var Wz = Object.defineProperty;
var zz = (e, t, r) => t in e ? Wz(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Fe = (e, t, r) => zz(e, typeof t != "symbol" ? t + "" : t, r);
import * as be from "react";
import M, { createContext as Vl, useContext as vh, useMemo as Tn, useState as Me, useCallback as Ft, useEffect as wt, forwardRef as va, lazy as Kz, Suspense as yw, useRef as tr, useLayoutEffect as kT, cloneElement as j4, createRef as Cc, Component as Cn, createElement as _a, isValidElement as qz, PureComponent as wg, memo as F4 } from "react";
import * as Gz from "react-dom";
import OT, { createPortal as bw } from "react-dom";
import { useNavigate as ta, Link as Lo, useSearchParams as AT, useParams as B4, useLocation as ww, Navigate as hc, Routes as Yz, Route as rp, NavLink as PT } from "react-router-dom";
function U4(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Xz } = Object.prototype, { getPrototypeOf: RT } = Object, xw = /* @__PURE__ */ ((e) => (t) => {
  const r = Xz.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Hi = (e) => (e = e.toLowerCase(), (t) => xw(t) === e), _w = (e) => (t) => typeof t === e, { isArray: yh } = Array, Dm = _w("undefined");
function Qz(e) {
  return e !== null && !Dm(e) && e.constructor !== null && !Dm(e.constructor) && $s(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const V4 = Hi("ArrayBuffer");
function Jz(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && V4(e.buffer), t;
}
const Zz = _w("string"), $s = _w("function"), $4 = _w("number"), Sw = (e) => e !== null && typeof e == "object", eK = (e) => e === !0 || e === !1, py = (e) => {
  if (xw(e) !== "object")
    return !1;
  const t = RT(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, tK = Hi("Date"), rK = Hi("File"), nK = Hi("Blob"), aK = Hi("FileList"), sK = (e) => Sw(e) && $s(e.pipe), iK = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || $s(e.append) && ((t = xw(e)) === "formdata" || // detect form-data instance
  t === "object" && $s(e.toString) && e.toString() === "[object FormData]"));
}, oK = Hi("URLSearchParams"), [lK, cK, uK, dK] = ["ReadableStream", "Request", "Response", "Headers"].map(Hi), fK = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function xg(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, a;
  if (typeof e != "object" && (e = [e]), yh(e))
    for (n = 0, a = e.length; n < a; n++)
      t.call(null, e[n], n, e);
  else {
    const s = r ? Object.getOwnPropertyNames(e) : Object.keys(e), i = s.length;
    let o;
    for (n = 0; n < i; n++)
      o = s[n], t.call(null, e[o], o, e);
  }
}
function H4(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, a;
  for (; n-- > 0; )
    if (a = r[n], t === a.toLowerCase())
      return a;
  return null;
}
const _u = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : window, W4 = (e) => !Dm(e) && e !== _u;
function qS() {
  const { caseless: e } = W4(this) && this || {}, t = {}, r = (n, a) => {
    const s = e && H4(t, a) || a;
    py(t[s]) && py(n) ? t[s] = qS(t[s], n) : py(n) ? t[s] = qS({}, n) : yh(n) ? t[s] = n.slice() : t[s] = n;
  };
  for (let n = 0, a = arguments.length; n < a; n++)
    arguments[n] && xg(arguments[n], r);
  return t;
}
const hK = (e, t, r, { allOwnKeys: n } = {}) => (xg(t, (a, s) => {
  r && $s(a) ? e[s] = U4(a, r) : e[s] = a;
}, { allOwnKeys: n }), e), pK = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), mK = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, gK = (e, t, r, n) => {
  let a, s, i;
  const o = {};
  if (t = t || {}, e == null) return t;
  do {
    for (a = Object.getOwnPropertyNames(e), s = a.length; s-- > 0; )
      i = a[s], (!n || n(i, e, t)) && !o[i] && (t[i] = e[i], o[i] = !0);
    e = r !== !1 && RT(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, vK = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, yK = (e) => {
  if (!e) return null;
  if (yh(e)) return e;
  let t = e.length;
  if (!$4(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, bK = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && RT(Uint8Array)), wK = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let a;
  for (; (a = n.next()) && !a.done; ) {
    const s = a.value;
    t.call(e, s[0], s[1]);
  }
}, xK = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, _K = Hi("HTMLFormElement"), SK = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, a) {
    return n.toUpperCase() + a;
  }
), YO = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), EK = Hi("RegExp"), z4 = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  xg(r, (a, s) => {
    let i;
    (i = t(a, s, e)) !== !1 && (n[s] = i || a);
  }), Object.defineProperties(e, n);
}, TK = (e) => {
  z4(e, (t, r) => {
    if ($s(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if ($s(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, CK = (e, t) => {
  const r = {}, n = (a) => {
    a.forEach((s) => {
      r[s] = !0;
    });
  };
  return yh(e) ? n(e) : n(String(e).split(t)), r;
}, kK = () => {
}, OK = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function AK(e) {
  return !!(e && $s(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const PK = (e) => {
  const t = new Array(10), r = (n, a) => {
    if (Sw(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[a] = n;
        const s = yh(n) ? [] : {};
        return xg(n, (i, o) => {
          const l = r(i, a + 1);
          !Dm(l) && (s[o] = l);
        }), t[a] = void 0, s;
      }
    }
    return n;
  };
  return r(e, 0);
}, RK = Hi("AsyncFunction"), IK = (e) => e && (Sw(e) || $s(e)) && $s(e.then) && $s(e.catch), K4 = ((e, t) => e ? setImmediate : t ? ((r, n) => (_u.addEventListener("message", ({ source: a, data: s }) => {
  a === _u && s === r && n.length && n.shift()();
}, !1), (a) => {
  n.push(a), _u.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  $s(_u.postMessage)
), DK = typeof queueMicrotask < "u" ? queueMicrotask.bind(_u) : typeof process < "u" && process.nextTick || K4, He = {
  isArray: yh,
  isArrayBuffer: V4,
  isBuffer: Qz,
  isFormData: iK,
  isArrayBufferView: Jz,
  isString: Zz,
  isNumber: $4,
  isBoolean: eK,
  isObject: Sw,
  isPlainObject: py,
  isReadableStream: lK,
  isRequest: cK,
  isResponse: uK,
  isHeaders: dK,
  isUndefined: Dm,
  isDate: tK,
  isFile: rK,
  isBlob: nK,
  isRegExp: EK,
  isFunction: $s,
  isStream: sK,
  isURLSearchParams: oK,
  isTypedArray: bK,
  isFileList: aK,
  forEach: xg,
  merge: qS,
  extend: hK,
  trim: fK,
  stripBOM: pK,
  inherits: mK,
  toFlatObject: gK,
  kindOf: xw,
  kindOfTest: Hi,
  endsWith: vK,
  toArray: yK,
  forEachEntry: wK,
  matchAll: xK,
  isHTMLForm: _K,
  hasOwnProperty: YO,
  hasOwnProp: YO,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: z4,
  freezeMethods: TK,
  toObjectSet: CK,
  toCamelCase: SK,
  noop: kK,
  toFiniteNumber: OK,
  findKey: H4,
  global: _u,
  isContextDefined: W4,
  isSpecCompliantForm: AK,
  toJSONObject: PK,
  isAsyncFn: RK,
  isThenable: IK,
  setImmediate: K4,
  asap: DK
};
function sr(e, t, r, n, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), a && (this.response = a, this.status = a.status ? a.status : null);
}
He.inherits(sr, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: He.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const q4 = sr.prototype, G4 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  G4[e] = { value: e };
});
Object.defineProperties(sr, G4);
Object.defineProperty(q4, "isAxiosError", { value: !0 });
sr.from = (e, t, r, n, a, s) => {
  const i = Object.create(q4);
  return He.toFlatObject(e, i, function(l) {
    return l !== Error.prototype;
  }, (o) => o !== "isAxiosError"), sr.call(i, e.message, t, r, n, a), i.cause = e, i.name = e.name, s && Object.assign(i, s), i;
};
const NK = null;
function GS(e) {
  return He.isPlainObject(e) || He.isArray(e);
}
function Y4(e) {
  return He.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function XO(e, t, r) {
  return e ? e.concat(t).map(function(a, s) {
    return a = Y4(a), !r && s ? "[" + a + "]" : a;
  }).join(r ? "." : "") : t;
}
function MK(e) {
  return He.isArray(e) && !e.some(GS);
}
const LK = He.toFlatObject(He, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Ew(e, t, r) {
  if (!He.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = He.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, g) {
    return !He.isUndefined(g[m]);
  });
  const n = r.metaTokens, a = r.visitor || u, s = r.dots, i = r.indexes, l = (r.Blob || typeof Blob < "u" && Blob) && He.isSpecCompliantForm(t);
  if (!He.isFunction(a))
    throw new TypeError("visitor must be a function");
  function c(p) {
    if (p === null) return "";
    if (He.isDate(p))
      return p.toISOString();
    if (!l && He.isBlob(p))
      throw new sr("Blob is not supported. Use a Buffer instead.");
    return He.isArrayBuffer(p) || He.isTypedArray(p) ? l && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function u(p, m, g) {
    let y = p;
    if (p && !g && typeof p == "object") {
      if (He.endsWith(m, "{}"))
        m = n ? m : m.slice(0, -2), p = JSON.stringify(p);
      else if (He.isArray(p) && MK(p) || (He.isFileList(p) || He.endsWith(m, "[]")) && (y = He.toArray(p)))
        return m = Y4(m), y.forEach(function(w, _) {
          !(He.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? XO([m], _, s) : i === null ? m : m + "[]",
            c(w)
          );
        }), !1;
    }
    return GS(p) ? !0 : (t.append(XO(g, m, s), c(p)), !1);
  }
  const d = [], f = Object.assign(LK, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: GS
  });
  function h(p, m) {
    if (!He.isUndefined(p)) {
      if (d.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      d.push(p), He.forEach(p, function(y, x) {
        (!(He.isUndefined(y) || y === null) && a.call(
          t,
          y,
          He.isString(x) ? x.trim() : x,
          m,
          f
        )) === !0 && h(y, m ? m.concat(x) : [x]);
      }), d.pop();
    }
  }
  if (!He.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function QO(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function IT(e, t) {
  this._pairs = [], e && Ew(e, this, t);
}
const X4 = IT.prototype;
X4.append = function(t, r) {
  this._pairs.push([t, r]);
};
X4.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, QO);
  } : QO;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function jK(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Q4(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || jK;
  He.isFunction(r) && (r = {
    serialize: r
  });
  const a = r && r.serialize;
  let s;
  if (a ? s = a(t, r) : s = He.isURLSearchParams(t) ? t.toString() : new IT(t, r).toString(n), s) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class JO {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    He.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const J4 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, FK = typeof URLSearchParams < "u" ? URLSearchParams : IT, BK = typeof FormData < "u" ? FormData : null, UK = typeof Blob < "u" ? Blob : null, VK = {
  isBrowser: !0,
  classes: {
    URLSearchParams: FK,
    FormData: BK,
    Blob: UK
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, DT = typeof window < "u" && typeof document < "u", YS = typeof navigator == "object" && navigator || void 0, $K = DT && (!YS || ["ReactNative", "NativeScript", "NS"].indexOf(YS.product) < 0), HK = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", WK = DT && window.location.href || "http://localhost", zK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: DT,
  hasStandardBrowserEnv: $K,
  hasStandardBrowserWebWorkerEnv: HK,
  navigator: YS,
  origin: WK
}, Symbol.toStringTag, { value: "Module" })), Ha = {
  ...zK,
  ...VK
};
function KK(e, t) {
  return Ew(e, new Ha.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, a, s) {
      return Ha.isNode && He.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function qK(e) {
  return He.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function GK(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const a = r.length;
  let s;
  for (n = 0; n < a; n++)
    s = r[n], t[s] = e[s];
  return t;
}
function Z4(e) {
  function t(r, n, a, s) {
    let i = r[s++];
    if (i === "__proto__") return !0;
    const o = Number.isFinite(+i), l = s >= r.length;
    return i = !i && He.isArray(a) ? a.length : i, l ? (He.hasOwnProp(a, i) ? a[i] = [a[i], n] : a[i] = n, !o) : ((!a[i] || !He.isObject(a[i])) && (a[i] = []), t(r, n, a[i], s) && He.isArray(a[i]) && (a[i] = GK(a[i])), !o);
  }
  if (He.isFormData(e) && He.isFunction(e.entries)) {
    const r = {};
    return He.forEachEntry(e, (n, a) => {
      t(qK(n), a, r, 0);
    }), r;
  }
  return null;
}
function YK(e, t, r) {
  if (He.isString(e))
    try {
      return (t || JSON.parse)(e), He.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const _g = {
  transitional: J4,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", a = n.indexOf("application/json") > -1, s = He.isObject(t);
    if (s && He.isHTMLForm(t) && (t = new FormData(t)), He.isFormData(t))
      return a ? JSON.stringify(Z4(t)) : t;
    if (He.isArrayBuffer(t) || He.isBuffer(t) || He.isStream(t) || He.isFile(t) || He.isBlob(t) || He.isReadableStream(t))
      return t;
    if (He.isArrayBufferView(t))
      return t.buffer;
    if (He.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let o;
    if (s) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return KK(t, this.formSerializer).toString();
      if ((o = He.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Ew(
          o ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return s || a ? (r.setContentType("application/json", !1), YK(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || _g.transitional, n = r && r.forcedJSONParsing, a = this.responseType === "json";
    if (He.isResponse(t) || He.isReadableStream(t))
      return t;
    if (t && He.isString(t) && (n && !this.responseType || a)) {
      const i = !(r && r.silentJSONParsing) && a;
      try {
        return JSON.parse(t);
      } catch (o) {
        if (i)
          throw o.name === "SyntaxError" ? sr.from(o, sr.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ha.classes.FormData,
    Blob: Ha.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
He.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  _g.headers[e] = {};
});
const XK = He.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), QK = (e) => {
  const t = {};
  let r, n, a;
  return e && e.split(`
`).forEach(function(i) {
    a = i.indexOf(":"), r = i.substring(0, a).trim().toLowerCase(), n = i.substring(a + 1).trim(), !(!r || t[r] && XK[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, ZO = Symbol("internals");
function np(e) {
  return e && String(e).trim().toLowerCase();
}
function my(e) {
  return e === !1 || e == null ? e : He.isArray(e) ? e.map(my) : String(e);
}
function JK(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const ZK = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function b1(e, t, r, n, a) {
  if (He.isFunction(n))
    return n.call(this, t, r);
  if (a && (t = r), !!He.isString(t)) {
    if (He.isString(n))
      return t.indexOf(n) !== -1;
    if (He.isRegExp(n))
      return n.test(t);
  }
}
function eq(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function tq(e, t) {
  const r = He.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(a, s, i) {
        return this[n].call(this, t, a, s, i);
      },
      configurable: !0
    });
  });
}
let ws = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const a = this;
    function s(o, l, c) {
      const u = np(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = He.findKey(a, u);
      (!d || a[d] === void 0 || c === !0 || c === void 0 && a[d] !== !1) && (a[d || l] = my(o));
    }
    const i = (o, l) => He.forEach(o, (c, u) => s(c, u, l));
    if (He.isPlainObject(t) || t instanceof this.constructor)
      i(t, r);
    else if (He.isString(t) && (t = t.trim()) && !ZK(t))
      i(QK(t), r);
    else if (He.isHeaders(t))
      for (const [o, l] of t.entries())
        s(l, o, n);
    else
      t != null && s(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = np(t), t) {
      const n = He.findKey(this, t);
      if (n) {
        const a = this[n];
        if (!r)
          return a;
        if (r === !0)
          return JK(a);
        if (He.isFunction(r))
          return r.call(this, a, n);
        if (He.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = np(t), t) {
      const n = He.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || b1(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let a = !1;
    function s(i) {
      if (i = np(i), i) {
        const o = He.findKey(n, i);
        o && (!r || b1(n, n[o], o, r)) && (delete n[o], a = !0);
      }
    }
    return He.isArray(t) ? t.forEach(s) : s(t), a;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, a = !1;
    for (; n--; ) {
      const s = r[n];
      (!t || b1(this, this[s], s, t, !0)) && (delete this[s], a = !0);
    }
    return a;
  }
  normalize(t) {
    const r = this, n = {};
    return He.forEach(this, (a, s) => {
      const i = He.findKey(n, s);
      if (i) {
        r[i] = my(a), delete r[s];
        return;
      }
      const o = t ? eq(s) : String(s).trim();
      o !== s && delete r[s], r[o] = my(a), n[o] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return He.forEach(this, (n, a) => {
      n != null && n !== !1 && (r[a] = t && He.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((a) => n.set(a)), n;
  }
  static accessor(t) {
    const n = (this[ZO] = this[ZO] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function s(i) {
      const o = np(i);
      n[o] || (tq(a, i), n[o] = !0);
    }
    return He.isArray(t) ? t.forEach(s) : s(t), this;
  }
};
ws.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
He.reduceDescriptors(ws.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
He.freezeMethods(ws);
function w1(e, t) {
  const r = this || _g, n = t || r, a = ws.from(n.headers);
  let s = n.data;
  return He.forEach(e, function(o) {
    s = o.call(r, s, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), s;
}
function e3(e) {
  return !!(e && e.__CANCEL__);
}
function bh(e, t, r) {
  sr.call(this, e ?? "canceled", sr.ERR_CANCELED, t, r), this.name = "CanceledError";
}
He.inherits(bh, sr, {
  __CANCEL__: !0
});
function t3(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new sr(
    "Request failed with status code " + r.status,
    [sr.ERR_BAD_REQUEST, sr.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function rq(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function nq(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let a = 0, s = 0, i;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), u = n[s];
    i || (i = c), r[a] = l, n[a] = c;
    let d = s, f = 0;
    for (; d !== a; )
      f += r[d++], d = d % e;
    if (a = (a + 1) % e, a === s && (s = (s + 1) % e), c - i < t)
      return;
    const h = u && c - u;
    return h ? Math.round(f * 1e3 / h) : void 0;
  };
}
function aq(e, t) {
  let r = 0, n = 1e3 / t, a, s;
  const i = (c, u = Date.now()) => {
    r = u, a = null, s && (clearTimeout(s), s = null), e.apply(null, c);
  };
  return [(...c) => {
    const u = Date.now(), d = u - r;
    d >= n ? i(c, u) : (a = c, s || (s = setTimeout(() => {
      s = null, i(a);
    }, n - d)));
  }, () => a && i(a)];
}
const Ly = (e, t, r = 3) => {
  let n = 0;
  const a = nq(50, 250);
  return aq((s) => {
    const i = s.loaded, o = s.lengthComputable ? s.total : void 0, l = i - n, c = a(l), u = i <= o;
    n = i;
    const d = {
      loaded: i,
      total: o,
      progress: o ? i / o : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && o && u ? (o - i) / c : void 0,
      event: s,
      lengthComputable: o != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, r);
}, eA = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, tA = (e) => (...t) => He.asap(() => e(...t)), sq = Ha.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, Ha.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(Ha.origin),
  Ha.navigator && /(msie|trident)/i.test(Ha.navigator.userAgent)
) : () => !0, iq = Ha.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, a, s) {
      const i = [e + "=" + encodeURIComponent(t)];
      He.isNumber(r) && i.push("expires=" + new Date(r).toGMTString()), He.isString(n) && i.push("path=" + n), He.isString(a) && i.push("domain=" + a), s === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function oq(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function lq(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function r3(e, t, r) {
  let n = !oq(t);
  return e && (n || r == !1) ? lq(e, t) : t;
}
const rA = (e) => e instanceof ws ? { ...e } : e;
function Fu(e, t) {
  t = t || {};
  const r = {};
  function n(c, u, d, f) {
    return He.isPlainObject(c) && He.isPlainObject(u) ? He.merge.call({ caseless: f }, c, u) : He.isPlainObject(u) ? He.merge({}, u) : He.isArray(u) ? u.slice() : u;
  }
  function a(c, u, d, f) {
    if (He.isUndefined(u)) {
      if (!He.isUndefined(c))
        return n(void 0, c, d, f);
    } else return n(c, u, d, f);
  }
  function s(c, u) {
    if (!He.isUndefined(u))
      return n(void 0, u);
  }
  function i(c, u) {
    if (He.isUndefined(u)) {
      if (!He.isUndefined(c))
        return n(void 0, c);
    } else return n(void 0, u);
  }
  function o(c, u, d) {
    if (d in t)
      return n(c, u);
    if (d in e)
      return n(void 0, c);
  }
  const l = {
    url: s,
    method: s,
    data: s,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: o,
    headers: (c, u, d) => a(rA(c), rA(u), d, !0)
  };
  return He.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const d = l[u] || a, f = d(e[u], t[u], u);
    He.isUndefined(f) && d !== o || (r[u] = f);
  }), r;
}
const n3 = (e) => {
  const t = Fu({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: a, xsrfCookieName: s, headers: i, auth: o } = t;
  t.headers = i = ws.from(i), t.url = Q4(r3(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), o && i.set(
    "Authorization",
    "Basic " + btoa((o.username || "") + ":" + (o.password ? unescape(encodeURIComponent(o.password)) : ""))
  );
  let l;
  if (He.isFormData(r)) {
    if (Ha.hasStandardBrowserEnv || Ha.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((l = i.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      i.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (Ha.hasStandardBrowserEnv && (n && He.isFunction(n) && (n = n(t)), n || n !== !1 && sq(t.url))) {
    const c = a && s && iq.read(s);
    c && i.set(a, c);
  }
  return t;
}, cq = typeof XMLHttpRequest < "u", uq = cq && function(e) {
  return new Promise(function(r, n) {
    const a = n3(e);
    let s = a.data;
    const i = ws.from(a.headers).normalize();
    let { responseType: o, onUploadProgress: l, onDownloadProgress: c } = a, u, d, f, h, p;
    function m() {
      h && h(), p && p(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let g = new XMLHttpRequest();
    g.open(a.method.toUpperCase(), a.url, !0), g.timeout = a.timeout;
    function y() {
      if (!g)
        return;
      const w = ws.from(
        "getAllResponseHeaders" in g && g.getAllResponseHeaders()
      ), S = {
        data: !o || o === "text" || o === "json" ? g.responseText : g.response,
        status: g.status,
        statusText: g.statusText,
        headers: w,
        config: e,
        request: g
      };
      t3(function(E) {
        r(E), m();
      }, function(E) {
        n(E), m();
      }, S), g = null;
    }
    "onloadend" in g ? g.onloadend = y : g.onreadystatechange = function() {
      !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(y);
    }, g.onabort = function() {
      g && (n(new sr("Request aborted", sr.ECONNABORTED, e, g)), g = null);
    }, g.onerror = function() {
      n(new sr("Network Error", sr.ERR_NETWORK, e, g)), g = null;
    }, g.ontimeout = function() {
      let _ = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const S = a.transitional || J4;
      a.timeoutErrorMessage && (_ = a.timeoutErrorMessage), n(new sr(
        _,
        S.clarifyTimeoutError ? sr.ETIMEDOUT : sr.ECONNABORTED,
        e,
        g
      )), g = null;
    }, s === void 0 && i.setContentType(null), "setRequestHeader" in g && He.forEach(i.toJSON(), function(_, S) {
      g.setRequestHeader(S, _);
    }), He.isUndefined(a.withCredentials) || (g.withCredentials = !!a.withCredentials), o && o !== "json" && (g.responseType = a.responseType), c && ([f, p] = Ly(c, !0), g.addEventListener("progress", f)), l && g.upload && ([d, h] = Ly(l), g.upload.addEventListener("progress", d), g.upload.addEventListener("loadend", h)), (a.cancelToken || a.signal) && (u = (w) => {
      g && (n(!w || w.type ? new bh(null, e, g) : w), g.abort(), g = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const x = rq(a.url);
    if (x && Ha.protocols.indexOf(x) === -1) {
      n(new sr("Unsupported protocol " + x + ":", sr.ERR_BAD_REQUEST, e));
      return;
    }
    g.send(s || null);
  });
}, dq = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), a;
    const s = function(c) {
      if (!a) {
        a = !0, o();
        const u = c instanceof Error ? c : this.reason;
        n.abort(u instanceof sr ? u : new bh(u instanceof Error ? u.message : u));
      }
    };
    let i = t && setTimeout(() => {
      i = null, s(new sr(`timeout ${t} of ms exceeded`, sr.ETIMEDOUT));
    }, t);
    const o = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(s) : c.removeEventListener("abort", s);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", s));
    const { signal: l } = n;
    return l.unsubscribe = () => He.asap(o), l;
  }
}, fq = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, a;
  for (; n < r; )
    a = n + t, yield e.slice(n, a), n = a;
}, hq = async function* (e, t) {
  for await (const r of pq(e))
    yield* fq(r, t);
}, pq = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, nA = (e, t, r, n) => {
  const a = hq(e, t);
  let s = 0, i, o = (l) => {
    i || (i = !0, n && n(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await a.next();
        if (c) {
          o(), l.close();
          return;
        }
        let d = u.byteLength;
        if (r) {
          let f = s += d;
          r(f);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw o(c), c;
      }
    },
    cancel(l) {
      return o(l), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Tw = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", a3 = Tw && typeof ReadableStream == "function", mq = Tw && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), s3 = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, gq = a3 && s3(() => {
  let e = !1;
  const t = new Request(Ha.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), aA = 64 * 1024, XS = a3 && s3(() => He.isReadableStream(new Response("").body)), jy = {
  stream: XS && ((e) => e.body)
};
Tw && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !jy[t] && (jy[t] = He.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new sr(`Response type '${t}' is not supported`, sr.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const vq = async (e) => {
  if (e == null)
    return 0;
  if (He.isBlob(e))
    return e.size;
  if (He.isSpecCompliantForm(e))
    return (await new Request(Ha.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (He.isArrayBufferView(e) || He.isArrayBuffer(e))
    return e.byteLength;
  if (He.isURLSearchParams(e) && (e = e + ""), He.isString(e))
    return (await mq(e)).byteLength;
}, yq = async (e, t) => {
  const r = He.toFiniteNumber(e.getContentLength());
  return r ?? vq(t);
}, bq = Tw && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: a,
    cancelToken: s,
    timeout: i,
    onDownloadProgress: o,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: f
  } = n3(e);
  c = c ? (c + "").toLowerCase() : "text";
  let h = dq([a, s && s.toAbortSignal()], i), p;
  const m = h && h.unsubscribe && (() => {
    h.unsubscribe();
  });
  let g;
  try {
    if (l && gq && r !== "get" && r !== "head" && (g = await yq(u, n)) !== 0) {
      let S = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), C;
      if (He.isFormData(n) && (C = S.headers.get("content-type")) && u.setContentType(C), S.body) {
        const [E, O] = eA(
          g,
          Ly(tA(l))
        );
        n = nA(S.body, aA, E, O);
      }
    }
    He.isString(d) || (d = d ? "include" : "omit");
    const y = "credentials" in Request.prototype;
    p = new Request(t, {
      ...f,
      signal: h,
      method: r.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: y ? d : void 0
    });
    let x = await fetch(p);
    const w = XS && (c === "stream" || c === "response");
    if (XS && (o || w && m)) {
      const S = {};
      ["status", "statusText", "headers"].forEach((k) => {
        S[k] = x[k];
      });
      const C = He.toFiniteNumber(x.headers.get("content-length")), [E, O] = o && eA(
        C,
        Ly(tA(o), !0)
      ) || [];
      x = new Response(
        nA(x.body, aA, E, () => {
          O && O(), m && m();
        }),
        S
      );
    }
    c = c || "text";
    let _ = await jy[He.findKey(jy, c) || "text"](x, e);
    return !w && m && m(), await new Promise((S, C) => {
      t3(S, C, {
        data: _,
        headers: ws.from(x.headers),
        status: x.status,
        statusText: x.statusText,
        config: e,
        request: p
      });
    });
  } catch (y) {
    throw m && m(), y && y.name === "TypeError" && /fetch/i.test(y.message) ? Object.assign(
      new sr("Network Error", sr.ERR_NETWORK, e, p),
      {
        cause: y.cause || y
      }
    ) : sr.from(y, y && y.code, e, p);
  }
}), QS = {
  http: NK,
  xhr: uq,
  fetch: bq
};
He.forEach(QS, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const sA = (e) => `- ${e}`, wq = (e) => He.isFunction(e) || e === null || e === !1, i3 = {
  getAdapter: (e) => {
    e = He.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const a = {};
    for (let s = 0; s < t; s++) {
      r = e[s];
      let i;
      if (n = r, !wq(r) && (n = QS[(i = String(r)).toLowerCase()], n === void 0))
        throw new sr(`Unknown adapter '${i}'`);
      if (n)
        break;
      a[i || "#" + s] = n;
    }
    if (!n) {
      const s = Object.entries(a).map(
        ([o, l]) => `adapter ${o} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? s.length > 1 ? `since :
` + s.map(sA).join(`
`) : " " + sA(s[0]) : "as no adapter specified";
      throw new sr(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: QS
};
function x1(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new bh(null, e);
}
function iA(e) {
  return x1(e), e.headers = ws.from(e.headers), e.data = w1.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), i3.getAdapter(e.adapter || _g.adapter)(e).then(function(n) {
    return x1(e), n.data = w1.call(
      e,
      e.transformResponse,
      n
    ), n.headers = ws.from(n.headers), n;
  }, function(n) {
    return e3(n) || (x1(e), n && n.response && (n.response.data = w1.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = ws.from(n.response.headers))), Promise.reject(n);
  });
}
const o3 = "1.8.4", Cw = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Cw[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const oA = {};
Cw.transitional = function(t, r, n) {
  function a(s, i) {
    return "[Axios v" + o3 + "] Transitional option '" + s + "'" + i + (n ? ". " + n : "");
  }
  return (s, i, o) => {
    if (t === !1)
      throw new sr(
        a(i, " has been removed" + (r ? " in " + r : "")),
        sr.ERR_DEPRECATED
      );
    return r && !oA[i] && (oA[i] = !0, console.warn(
      a(
        i,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(s, i, o) : !0;
  };
};
Cw.spelling = function(t) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function xq(e, t, r) {
  if (typeof e != "object")
    throw new sr("options must be an object", sr.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let a = n.length;
  for (; a-- > 0; ) {
    const s = n[a], i = t[s];
    if (i) {
      const o = e[s], l = o === void 0 || i(o, s, e);
      if (l !== !0)
        throw new sr("option " + s + " must be " + l, sr.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new sr("Unknown option " + s, sr.ERR_BAD_OPTION);
  }
}
const gy = {
  assertOptions: xq,
  validators: Cw
}, Zi = gy.validators;
let ku = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new JO(),
      response: new JO()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const s = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? s && !String(n.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + s) : n.stack = s;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = Fu(this.defaults, r);
    const { transitional: n, paramsSerializer: a, headers: s } = r;
    n !== void 0 && gy.assertOptions(n, {
      silentJSONParsing: Zi.transitional(Zi.boolean),
      forcedJSONParsing: Zi.transitional(Zi.boolean),
      clarifyTimeoutError: Zi.transitional(Zi.boolean)
    }, !1), a != null && (He.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : gy.assertOptions(a, {
      encode: Zi.function,
      serialize: Zi.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), gy.assertOptions(r, {
      baseUrl: Zi.spelling("baseURL"),
      withXsrfToken: Zi.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let i = s && He.merge(
      s.common,
      s[r.method]
    );
    s && He.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete s[p];
      }
    ), r.headers = ws.concat(i, s);
    const o = [];
    let l = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(r) === !1 || (l = l && m.synchronous, o.unshift(m.fulfilled, m.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(m) {
      c.push(m.fulfilled, m.rejected);
    });
    let u, d = 0, f;
    if (!l) {
      const p = [iA.bind(this), void 0];
      for (p.unshift.apply(p, o), p.push.apply(p, c), f = p.length, u = Promise.resolve(r); d < f; )
        u = u.then(p[d++], p[d++]);
      return u;
    }
    f = o.length;
    let h = r;
    for (d = 0; d < f; ) {
      const p = o[d++], m = o[d++];
      try {
        h = p(h);
      } catch (g) {
        m.call(this, g);
        break;
      }
    }
    try {
      u = iA.call(this, h);
    } catch (p) {
      return Promise.reject(p);
    }
    for (d = 0, f = c.length; d < f; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = Fu(this.defaults, t);
    const r = r3(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Q4(r, t.params, t.paramsSerializer);
  }
};
He.forEach(["delete", "get", "head", "options"], function(t) {
  ku.prototype[t] = function(r, n) {
    return this.request(Fu(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
He.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(s, i, o) {
      return this.request(Fu(o || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: i
      }));
    };
  }
  ku.prototype[t] = r(), ku.prototype[t + "Form"] = r(!0);
});
let _q = class l3 {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(s) {
      r = s;
    });
    const n = this;
    this.promise.then((a) => {
      if (!n._listeners) return;
      let s = n._listeners.length;
      for (; s-- > 0; )
        n._listeners[s](a);
      n._listeners = null;
    }), this.promise.then = (a) => {
      let s;
      const i = new Promise((o) => {
        n.subscribe(o), s = o;
      }).then(a);
      return i.cancel = function() {
        n.unsubscribe(s);
      }, i;
    }, t(function(s, i, o) {
      n.reason || (n.reason = new bh(s, i, o), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new l3(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
};
function Sq(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function Eq(e) {
  return He.isObject(e) && e.isAxiosError === !0;
}
const JS = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(JS).forEach(([e, t]) => {
  JS[t] = e;
});
function c3(e) {
  const t = new ku(e), r = U4(ku.prototype.request, t);
  return He.extend(r, ku.prototype, t, { allOwnKeys: !0 }), He.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(a) {
    return c3(Fu(e, a));
  }, r;
}
const Be = c3(_g);
Be.Axios = ku;
Be.CanceledError = bh;
Be.CancelToken = _q;
Be.isCancel = e3;
Be.VERSION = o3;
Be.toFormData = Ew;
Be.AxiosError = sr;
Be.Cancel = Be.CanceledError;
Be.all = function(t) {
  return Promise.all(t);
};
Be.spread = Sq;
Be.isAxiosError = Eq;
Be.mergeConfig = Fu;
Be.AxiosHeaders = ws;
Be.formToJSON = (e) => Z4(He.isHTMLForm(e) ? new FormData(e) : e);
Be.getAdapter = i3.getAdapter;
Be.HttpStatusCode = JS;
Be.default = Be;
const {
  Axios: AJe,
  AxiosError: PJe,
  CanceledError: RJe,
  isCancel: IJe,
  CancelToken: DJe,
  VERSION: NJe,
  all: MJe,
  Cancel: LJe,
  isAxiosError: Bv,
  spread: jJe,
  toFormData: FJe,
  AxiosHeaders: BJe,
  HttpStatusCode: UJe,
  formToJSON: VJe,
  getAdapter: $Je,
  mergeConfig: HJe
} = Be, _1 = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
}, dn = {
  HTTP: "HTTP",
  VALIDATION: "VALIDATION",
  API: "API",
  UNKNOWN: "UNKNOWN",
  AUTH: "AUTH",
  NETWORK: "NETWORK"
}, Xn = {
  // HTTP Errors
  HTTP_400: "BAD_REQUEST",
  HTTP_401: "UNAUTHORIZED",
  HTTP_403: "FORBIDDEN",
  HTTP_404: "NOT_FOUND",
  HTTP_500: "INTERNAL_SERVER_ERROR",
  // Validation Errors
  VALIDATION_ERROR: "VALIDATION_ERROR",
  REQUIRED_FIELD: "REQUIRED_FIELD",
  // API Errors
  API_ERROR: "API_ERROR",
  // Unknown Errors
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  // Auth Errors
  AUTH_UNKNOWN: "UNKNOWN_AUTH_ERROR",
  AUTH_INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
  AUTH_EMAIL_EXISTS: "EMAIL_EXISTS",
  AUTH_WEAK_PASSWORD: "WEAK_PASSWORD",
  AUTH_INVALID_TOKEN: "INVALID_TOKEN",
  AUTH_EXPIRED_TOKEN: "EXPIRED_TOKEN",
  AUTH_EMAIL_NOT_VERIFIED: "EMAIL_NOT_VERIFIED",
  AUTH_TOO_MANY_ATTEMPTS: "TOO_MANY_ATTEMPTS",
  AUTH_WRONG_TENANT: "WRONG_TENANT",
  AUTH_TENANT_ACCESS_DENIED: "TENANT_ACCESS_DENIED",
  AUTH_ADMIN_ACCESS_REQUIRED: "ADMIN_ACCESS_REQUIRED",
  AUTH_EMAIL_ALREADY_VERIFIED_ERROR: "EMAIL_ALREADY_VERIFIED_ERROR",
  // Network Errors
  NETWORK_OFFLINE: "NETWORK_OFFLINE",
  NETWORK_TIMEOUT: "NETWORK_TIMEOUT",
  NETWORK_DNS_FAILURE: "NETWORK_DNS_FAILURE",
  NETWORK_CORS_ERROR: "NETWORK_CORS_ERROR",
  NETWORK_ABORTED: "NETWORK_ABORTED",
  NETWORK_UNKNOWN: "NETWORK_UNKNOWN"
}, On = {
  HTTP: {
    400: "errors.http.bad_request",
    401: "errors.http.unauthorized",
    403: "errors.http.forbidden",
    404: "errors.http.not_found",
    500: "errors.http.internal_server_error"
  },
  AUTH: {
    UNKNOWN_AUTH_ERROR: "errors.auth.unknown",
    INVALID_CREDENTIALS: "errors.auth.invalid_credentials",
    EMAIL_EXISTS: "errors.auth.email_exists",
    WEAK_PASSWORD: "errors.auth.weak_password",
    INVALID_TOKEN: "errors.auth.invalid_token",
    EXPIRED_TOKEN: "errors.auth.expired_token",
    EMAIL_NOT_VERIFIED: "errors.auth.email_not_verified",
    TOO_MANY_ATTEMPTS: "errors.auth.too_many_attempts",
    TENANT_ACCESS_DENIED: "errors.auth.tenant_access_denied",
    UNAUTHORIZED: "errors.auth.unauthorized",
    WRONG_TENANT: "errors.auth.wrong_tenant",
    DEFAULT: "errors.auth.default",
    ADMIN_ACCESS_REQUIRED: "errors.auth.admin_access_required",
    EMAIL_ALREADY_VERIFIED_ERROR: "errors.auth.email_already_verified",
    NETWORK: {
      FAILED_CONNECTION: "errors.network.failed_connection",
      TIMEOUT: "errors.network.timeout",
      SERVER_UNREACHABLE: "errors.network.server_unreachable",
      failed_connection: "errors.network.failed_connection",
      connection_guide: "errors.network.connection_guide"
    }
  },
  VALIDATION: {
    DEFAULT: "errors.validation.default",
    REQUIRED: "errors.validation.required",
    BAD_REQUEST: "errors.validation.bad_request"
  },
  NETWORK: {
    NETWORK_OFFLINE: "errors.network.offline",
    NETWORK_TIMEOUT: "errors.network.timeout",
    NETWORK_DNS_FAILURE: "errors.network.dns_failure",
    NETWORK_CORS_ERROR: "errors.network.cors_error",
    NETWORK_ABORTED: "errors.network.aborted",
    NETWORK_UNKNOWN: "errors.network.unknown"
  }
}, Ye = "http://localhost".replace(/\/+$/, "");
class $c {
  constructor(t, r = Ye, n = Be) {
    Fe(this, "configuration");
    this.basePath = r, this.axios = n, t && (this.configuration = t, this.basePath = t.basePath ?? r);
  }
}
class u3 extends Error {
  constructor(t, r) {
    super(r), this.field = t, this.name = "RequiredError";
  }
}
const Xe = {};
class ed {
  isNetworkError(t) {
    return !!(t instanceof TypeError && t.message === "Failed to fetch" || !navigator.onLine || Bv(t) && !t.response);
  }
  adaptError(t) {
    return this.isNetworkError(t) ? this.getNetworkErrorDetails(t) : this.isAuthError(t) ? this.adaptAuthError(t) : this.isValidationError(t) ? this.adaptValidationError(t) : t instanceof u3 ? this.adaptRequiredFieldError(t) : Bv(t) ? this.adaptAxiosError(t) : this.adaptUnknownError(t);
  }
  isAuthError(t) {
    var n, a, s, i;
    if (!Bv(t)) {
      const o = t;
      return (o == null ? void 0 : o.name) === "AuthError" || (o == null ? void 0 : o.category) === "AUTH";
    }
    const r = (a = (n = t.response) == null ? void 0 : n.data) == null ? void 0 : a.code;
    return (r == null ? void 0 : r.startsWith("AUTH_")) || ((s = t.response) == null ? void 0 : s.status) === 401 || ((i = t.response) == null ? void 0 : i.status) === 403;
  }
  adaptAuthError(t) {
    var s, i, o, l, c, u;
    if ((t == null ? void 0 : t.name) === "AuthError" || (t == null ? void 0 : t.category) === "AUTH")
      return {
        message: t.message,
        code: t.code || (((i = (s = t.details) == null ? void 0 : s.raw) == null ? void 0 : i.unauthorized) === "token expired" ? "AUTH_EXPIRED_TOKEN" : "AUTH_ERROR"),
        category: dn.AUTH,
        translationKey: t.translationKey || On.AUTH[t.code],
        details: {
          ...t.details,
          raw: ((o = t.details) == null ? void 0 : o.raw) || { unauthorized: t.message }
        },
        metadata: {
          timestamp: (/* @__PURE__ */ new Date()).toISOString(),
          originalError: t
        }
      };
    const r = (l = t.response) == null ? void 0 : l.data, n = (c = t.response) == null ? void 0 : c.status, a = typeof r == "object" ? Object.entries(r).map(([d, f]) => ({
      field: d,
      message: f,
      type: "auth",
      translationKey: `errors.auth.${d.toLowerCase()}`
    })) : [
      {
        field: "auth",
        message: r || t.message,
        type: "auth",
        translationKey: "errors.auth.default"
      }
    ];
    return {
      message: a[0].message,
      code: `AUTH_${n}`,
      category: dn.AUTH,
      statusCode: n,
      translationKey: a[0].translationKey,
      details: {
        errors: a,
        raw: r,
        status: n,
        statusText: (u = t.response) == null ? void 0 : u.statusText
      },
      metadata: {
        timestamp: (/* @__PURE__ */ new Date()).toISOString(),
        originalError: t
      }
    };
  }
  isValidationError(t) {
    if (typeof t != "object" || t === null) return !1;
    const r = t;
    return Bv(t) ? !1 : "detail" in r && Array.isArray(r.detail) || "errors" in r && Array.isArray(r.errors) || "message" in r && typeof r.message == "string" && !r.response;
  }
  adaptValidationError(t) {
    const r = (t.detail || t.errors || []).map((n) => {
      var a;
      return {
        field: n.field || "unknown",
        message: n.message,
        type: n.type,
        translationKey: On.VALIDATION[(a = n.type) == null ? void 0 : a.toUpperCase()] || On.VALIDATION.DEFAULT
      };
    });
    return {
      message: t.message || "Validation Error",
      code: Xn.VALIDATION_ERROR,
      category: dn.VALIDATION,
      translationKey: "errors.validation.title",
      details: { errors: r },
      metadata: {
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      }
    };
  }
  getNetworkErrorDetails(t) {
    var r;
    if (!navigator.onLine)
      return {
        message: "You are offline. Please check your internet connection.",
        code: Xn.NETWORK_OFFLINE,
        category: dn.NETWORK,
        translationKey: On.NETWORK.NETWORK_OFFLINE,
        details: {
          browserOnline: !1
        }
      };
    if (t instanceof TypeError && t.message === "Failed to fetch") {
      const n = t.cause;
      if ((n == null ? void 0 : n.name) === "AbortError")
        return {
          message: "Request was cancelled",
          code: Xn.NETWORK_ABORTED,
          category: dn.NETWORK,
          translationKey: On.NETWORK.NETWORK_ABORTED
        };
      if (t.message.includes("CORS"))
        return {
          message: "Cross-origin request blocked",
          code: Xn.NETWORK_CORS_ERROR,
          category: dn.NETWORK,
          translationKey: On.NETWORK.NETWORK_CORS_ERROR
        };
      if (t.message.includes("dns"))
        return {
          message: "Unable to reach the server",
          code: Xn.NETWORK_DNS_FAILURE,
          category: dn.NETWORK,
          translationKey: On.NETWORK.NETWORK_DNS_FAILURE
        };
    }
    return (r = t.message) != null && r.includes("timeout") || t.code === "ECONNABORTED" ? {
      message: "Request timed out. Please try again.",
      code: Xn.NETWORK_TIMEOUT,
      category: dn.NETWORK,
      translationKey: On.NETWORK.NETWORK_TIMEOUT
    } : {
      message: "Network connection failed. Please check your connection and try again.",
      code: Xn.NETWORK_UNKNOWN,
      category: dn.NETWORK,
      translationKey: On.NETWORK.NETWORK_UNKNOWN,
      details: {
        browserOnline: navigator.onLine,
        errorMessage: t instanceof Error ? t.message : String(t),
        type: "network_error"
      }
    };
  }
  adaptAxiosError(t) {
    var s, i, o, l, c, u, d, f, h, p;
    if (!t.response)
      return this.getNetworkErrorDetails(t);
    const r = ((s = t.response) == null ? void 0 : s.status) || _1.INTERNAL_SERVER_ERROR, n = (i = t.response) == null ? void 0 : i.data;
    if (n != null && n.bad_request)
      return {
        message: n.bad_request,
        code: Xn.HTTP_400,
        category: dn.HTTP,
        statusCode: _1.BAD_REQUEST,
        translationKey: On.HTTP[400],
        details: {
          errors: [
            {
              field: "request",
              message: n.bad_request,
              type: "bad_request"
            }
          ],
          raw: n
        }
      };
    if (!t.response)
      return {
        message: t.message || "Network Error",
        code: "NETWORK_ERROR",
        category: dn.NETWORK,
        statusCode: 0,
        translationKey: "errors.network.failed_connection",
        details: {
          raw: {
            url: (o = t.config) == null ? void 0 : o.url,
            method: (l = t.config) == null ? void 0 : l.method
          },
          errors: [
            {
              field: "network",
              message: t.message,
              type: "network_error"
            }
          ]
        },
        metadata: {
          timestamp: (/* @__PURE__ */ new Date()).toISOString(),
          isNetworkError: !0
        }
      };
    if (typeof n == "string")
      return {
        message: n,
        code: `HTTP_${r}`,
        category: dn.HTTP,
        statusCode: r,
        translationKey: On.HTTP[r],
        details: {
          raw: n,
          status: r,
          statusText: (c = t.response) == null ? void 0 : c.statusText,
          url: (u = t.config) == null ? void 0 : u.url,
          method: (d = t.config) == null ? void 0 : d.method
        }
      };
    n != null && n.request_error;
    const a = typeof n == "string" ? n : (n == null ? void 0 : n.message) || (n == null ? void 0 : n.error) || (n == null ? void 0 : n.bad_request) || JSON.stringify(n);
    return {
      message: a,
      code: `HTTP_${r}`,
      category: dn.HTTP,
      statusCode: r,
      translationKey: On.HTTP[r],
      details: {
        errors: [
          {
            field: "request",
            message: a,
            type: r.toString()
          }
        ],
        raw: n,
        status: r,
        statusText: (f = t.response) == null ? void 0 : f.statusText,
        url: (h = t.config) == null ? void 0 : h.url,
        method: (p = t.config) == null ? void 0 : p.method
      }
    };
  }
  adaptUnknownError(t) {
    return {
      message: t instanceof Error ? t.message : "Unknown error occurred",
      code: Xn.UNKNOWN_ERROR,
      category: dn.UNKNOWN,
      statusCode: _1.INTERNAL_SERVER_ERROR,
      translationKey: "errors.unknown",
      metadata: {
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      },
      originalError: t
    };
  }
  adaptRequiredFieldError(t) {
    return {
      message: t.message,
      code: "REQUIRED_FIELD",
      category: dn.VALIDATION,
      translationKey: "common:common.validation.required_field",
      details: {
        field: t.field,
        errors: [
          {
            field: t.field,
            message: t.message,
            type: "required",
            translationKey: "common:common.validation.required"
          }
        ]
      }
    };
  }
}
const Qe = "https://example.com", Bt = function(e, t, r) {
  if (r == null)
    throw new u3(t, `Required parameter ${t} was null or undefined when calling ${e}.`);
}, ot = async function(e, t) {
  if (t && t.accessToken) {
    const r = typeof t.accessToken == "function" ? await t.accessToken() : await t.accessToken;
    e.Authorization = "Bearer " + r;
  }
};
function ZS(e, t, r = "") {
  t != null && (typeof t == "object" ? Array.isArray(t) ? t.forEach((n) => ZS(e, n, r)) : Object.keys(t).forEach(
    (n) => ZS(e, t[n], `${r}${r !== "" ? "." : ""}${n}`)
  ) : e.has(r) ? e.append(r, t) : e.set(r, t));
}
const Je = function(e, ...t) {
  const r = new URLSearchParams(e.search);
  ZS(r, t), e.search = r.toString();
}, mn = function(e, t, r) {
  const n = typeof e != "string";
  return (n && r && r.isJsonMime ? r.isJsonMime(t.headers["Content-Type"]) : n) ? JSON.stringify(e !== void 0 ? e : {}) : e || "";
}, Ze = function(e) {
  return e.pathname + e.search + e.hash;
}, et = function(e, t, r, n) {
  return (a = t, s = r) => {
    const i = { ...e.options, url: (a.defaults.baseURL ? "" : (n == null ? void 0 : n.basePath) ?? s) + e.url };
    return a.request(i);
  };
}, d3 = function(e) {
  return {
    /**
     * Add a tenant
     * @summary [admin] Add tenant
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addTenant: async (t, r = {}) => {
      Bt("addTenant", "id", t);
      const n = "/tenant/{id}".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "PUT", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * See the configuration for a deployment (admin only)
     * @summary [admin] Config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    config: async (t = {}) => {
      const r = "/config", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Client info
     * @summary Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    info: async (t = {}) => {
      const r = "/info", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {};
      Je(n, {});
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Initialize a deployment for a client
     * @summary [admin] Initialize
     * @param {Config} [config] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initialize: async (t, r = {}) => {
      const n = "/config", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Get openapi json
     * @summary Openapi
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    openapi: async (t = {}) => {
      const r = "/openapi", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {};
      Je(n, {});
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Swagger page
     * @summary Swagger
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    swagger: async (t = {}) => {
      const r = "/swagger", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {};
      Je(n, {});
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Set some configuration (admin only)
     * @summary [admin] Update config
     * @param {Array<UpdateConfig>} [updateConfig] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateConfig: async (t, r = {}) => {
      const n = "/config/update", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      await ot(o, e), o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Commit hash 
     * @summary Version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    version: async (t = {}) => {
      const r = "/version", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {};
      Je(n, {});
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    }
  };
}, ho = function(e) {
  const t = d3(e);
  return {
    /**
     * Add a tenant
     * @summary [admin] Add tenant
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addTenant(r, n) {
      var o, l;
      const a = await t.addTenant(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["AdminApi.addTenant"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * See the configuration for a deployment (admin only)
     * @summary [admin] Config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async config(r) {
      var i, o;
      const n = await t.config(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["AdminApi.config"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Client info
     * @summary Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async info(r) {
      var i, o;
      const n = await t.info(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["AdminApi.info"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Initialize a deployment for a client
     * @summary [admin] Initialize
     * @param {Config} [config] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initialize(r, n) {
      var o, l;
      const a = await t.initialize(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["AdminApi.initialize"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Get openapi json
     * @summary Openapi
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async openapi(r) {
      var i, o;
      const n = await t.openapi(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["AdminApi.openapi"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Swagger page
     * @summary Swagger
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async swagger(r) {
      var i, o;
      const n = await t.swagger(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["AdminApi.swagger"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Set some configuration (admin only)
     * @summary [admin] Update config
     * @param {Array<UpdateConfig>} [updateConfig] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateConfig(r, n) {
      var o, l;
      const a = await t.updateConfig(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["AdminApi.updateConfig"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Commit hash 
     * @summary Version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async version(r) {
      var i, o;
      const n = await t.version(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["AdminApi.version"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    }
  };
}, Tq = function(e, t, r) {
  const n = ho(e);
  return {
    /**
     * Add a tenant
     * @summary [admin] Add tenant
     * @param {AdminApiAddTenantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addTenant(a, s) {
      return n.addTenant(a.id, s).then((i) => i(r, t));
    },
    /**
     * See the configuration for a deployment (admin only)
     * @summary [admin] Config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    config(a) {
      return n.config(a).then((s) => s(r, t));
    },
    /**
     * Client info
     * @summary Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    info(a) {
      return n.info(a).then((s) => s(r, t));
    },
    /**
     * Initialize a deployment for a client
     * @summary [admin] Initialize
     * @param {AdminApiInitializeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initialize(a = {}, s) {
      return n.initialize(a.config, s).then((i) => i(r, t));
    },
    /**
     * Get openapi json
     * @summary Openapi
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    openapi(a) {
      return n.openapi(a).then((s) => s(r, t));
    },
    /**
     * Swagger page
     * @summary Swagger
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    swagger(a) {
      return n.swagger(a).then((s) => s(r, t));
    },
    /**
     * Set some configuration (admin only)
     * @summary [admin] Update config
     * @param {AdminApiUpdateConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateConfig(a = {}, s) {
      return n.updateConfig(a.updateConfig, s).then((i) => i(r, t));
    },
    /**
     * Commit hash 
     * @summary Version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    version(a) {
      return n.version(a).then((s) => s(r, t));
    }
  };
};
class Cq extends $c {
  /**
   * Add a tenant
   * @summary [admin] Add tenant
   * @param {AdminApiAddTenantRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  addTenant(t, r) {
    return ho(this.configuration).addTenant(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * See the configuration for a deployment (admin only)
   * @summary [admin] Config
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  config(t) {
    return ho(this.configuration).config(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Client info
   * @summary Info
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  info(t) {
    return ho(this.configuration).info(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Initialize a deployment for a client
   * @summary [admin] Initialize
   * @param {AdminApiInitializeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  initialize(t = {}, r) {
    return ho(this.configuration).initialize(t.config, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get openapi json
   * @summary Openapi
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  openapi(t) {
    return ho(this.configuration).openapi(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Swagger page
   * @summary Swagger
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  swagger(t) {
    return ho(this.configuration).swagger(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Set some configuration (admin only)
   * @summary [admin] Update config
   * @param {AdminApiUpdateConfigRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  updateConfig(t = {}, r) {
    return ho(this.configuration).updateConfig(t.updateConfig, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Commit hash 
   * @summary Version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  version(t) {
    return ho(this.configuration).version(t).then((r) => r(this.axios, this.basePath));
  }
}
const f3 = function(e) {
  return {
    /**
     * Get a specific campaign
     * @summary Campaign
     * @param {number} id 
     * @param {boolean} [stats] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaign: async (t, r, n = {}) => {
      Bt("campaign", "id", t);
      const a = "/campaigns/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), r !== void 0 && (c.stats = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * List orders for a campaign
     * @summary [admin] Campaign orders
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<CampaignOrdersStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignOrders: async (t, r, n, a, s = {}) => {
      Bt("campaignOrders", "id", t);
      const i = "/campaigns/{id}/orders".replace("{id}", encodeURIComponent(String(t))), o = new URL(i, Qe);
      let l;
      e && (l = e.baseOptions);
      const c = { method: "GET", ...l, ...s }, u = {}, d = {};
      await ot(u, e), r !== void 0 && (d.offset = r), n !== void 0 && (d.limit = n), a && (d.status = a), Je(o, d);
      let f = l && l.headers ? l.headers : {};
      return c.headers = { ...u, ...f, ...s.headers }, {
        url: Ze(o),
        options: c
      };
    },
    /**
     * Number of orders for a campaign
     * @summary [admin] Campaign orders count
     * @param {number} id 
     * @param {Array<CampaignOrdersCountStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignOrdersCount: async (t, r, n = {}) => {
      Bt("campaignOrdersCount", "id", t);
      const a = "/campaigns/{id}/orders/count".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), r && (c.status = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Pagination info for campaign orders
     * @summary [admin] Campaign orders pagination info
     * @param {number} id 
     * @param {Array<CampaignOrdersMetaStatusEnum>} [status] order status concatenated with a comma
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignOrdersMeta: async (t, r, n, a, s = {}) => {
      Bt("campaignOrdersMeta", "id", t);
      const i = "/campaigns/{id}/orders/meta".replace("{id}", encodeURIComponent(String(t))), o = new URL(i, Qe);
      let l;
      e && (l = e.baseOptions);
      const c = { method: "GET", ...l, ...s }, u = {}, d = {};
      await ot(u, e), r && (d.status = r), n !== void 0 && (d.offset = n), a !== void 0 && (d.limit = a), Je(o, d);
      let f = l && l.headers ? l.headers : {};
      return c.headers = { ...u, ...f, ...s.headers }, {
        url: Ze(o),
        options: c
      };
    },
    /**
     * List orders for a campaign with pagination info
     * @summary [admin] Campaign orders with pagination info
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<CampaignOrdersPageStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignOrdersPage: async (t, r, n, a, s = {}) => {
      Bt("campaignOrdersPage", "id", t);
      const i = "/campaigns/{id}/orders/page".replace("{id}", encodeURIComponent(String(t))), o = new URL(i, Qe);
      let l;
      e && (l = e.baseOptions);
      const c = { method: "GET", ...l, ...s }, u = {}, d = {};
      await ot(u, e), r !== void 0 && (d.offset = r), n !== void 0 && (d.limit = n), a && (d.status = a), Je(o, d);
      let f = l && l.headers ? l.headers : {};
      return c.headers = { ...u, ...f, ...s.headers }, {
        url: Ze(o),
        options: c
      };
    },
    /**
     * Number orders of each status and number of distinct buyers for a campaign
     * @summary Campaign statistics
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignStats: async (t, r = {}) => {
      Bt("campaignStats", "id", t);
      const n = "/campaigns/{id}/stats".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {};
      Je(a, {});
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Number of distinct buyers for a campaign
     * @summary Campaign users count
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignUsersCount: async (t, r = {}) => {
      Bt("campaignUsersCount", "id", t);
      const n = "/campaigns/{id}/users/count".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {};
      Je(a, {});
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * List campaigns (all if admin, only available ones for the rest)
     * @summary Campaigns
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<CampaignsStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [stats] 
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaigns: async (t, r, n, a, s, i = {}) => {
      const o = "/campaigns", l = new URL(o, Qe);
      let c;
      e && (c = e.baseOptions);
      const u = { method: "GET", ...c, ...i }, d = {}, f = {};
      await ot(d, e), t !== void 0 && (f.offset = t), r !== void 0 && (f.limit = r), n && (f.status = n), a !== void 0 && (f.stats = a), s !== void 0 && (f.private = s), Je(l, f);
      let h = c && c.headers ? c.headers : {};
      return u.headers = { ...d, ...h, ...i.headers }, {
        url: Ze(l),
        options: u
      };
    },
    /**
     * Get collected amount by campaign
     * @summary Campaigns collected amount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignsCollected: async (t = {}) => {
      const r = "/campaigns/collected", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Number of campaigns (all if admin, only available ones for the rest)
     * @summary Campaigns count
     * @param {Array<CampaignsCountStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignsCount: async (t, r, n = {}) => {
      const a = "/campaigns/count", s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), t && (c.status = t), r !== void 0 && (c.private = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Pagination info for campaigns
     * @summary Campaigns pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<CampaignsMetaStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignsMeta: async (t, r, n, a, s = {}) => {
      const i = "/campaigns/meta", o = new URL(i, Qe);
      let l;
      e && (l = e.baseOptions);
      const c = { method: "GET", ...l, ...s }, u = {}, d = {};
      await ot(u, e), t !== void 0 && (d.offset = t), r !== void 0 && (d.limit = r), n && (d.status = n), a !== void 0 && (d.private = a), Je(o, d);
      let f = l && l.headers ? l.headers : {};
      return c.headers = { ...u, ...f, ...s.headers }, {
        url: Ze(o),
        options: c
      };
    },
    /**
     * List campaigns with pagination info
     * @summary Campaigns with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<CampaignsPageStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [stats] 
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignsPage: async (t, r, n, a, s, i = {}) => {
      const o = "/campaigns/page", l = new URL(o, Qe);
      let c;
      e && (c = e.baseOptions);
      const u = { method: "GET", ...c, ...i }, d = {}, f = {};
      await ot(d, e), t !== void 0 && (f.offset = t), r !== void 0 && (f.limit = r), n && (f.status = n), a !== void 0 && (f.stats = a), s !== void 0 && (f.private = s), Je(l, f);
      let h = c && c.headers ? c.headers : {};
      return u.headers = { ...d, ...h, ...i.headers }, {
        url: Ze(l),
        options: u
      };
    },
    /**
     * Get number of campaigns in each status as well as the total currency collected
     * @summary Campaigns statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignsStats: async (t = {}) => {
      const r = "/campaigns/stats", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Create a campaign
     * @summary [admin] Campaign creation
     * @param {CampaignInput} [campaignInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCampaign: async (t, r = {}) => {
      const n = "/campaigns", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      await ot(o, e), o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Create an order
     * @summary Order creation
     * @param {number} id 
     * @param {number} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOrder: async (t, r, n = {}) => {
      Bt("createOrder", "id", t);
      const a = "/campaigns/{id}/order".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...n }, l = {}, c = {};
      await ot(l, e), l["Content-Type"] = "application/json", Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, o.data = mn(r, o, e), {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Delete a campaign
     * @summary [admin] Campaign deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCampaign: async (t, r = {}) => {
      Bt("deleteCampaign", "id", t);
      const n = "/campaigns/{id}".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "DELETE", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Mint a campaign
     * @summary [admin] Campaign mint
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mintCampaign: async (t, r = {}) => {
      Bt("mintCampaign", "id", t);
      const n = "/campaigns/{id}/mint".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "PUT", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Get the status of a mint
     * @summary [admin] Campaign mint status
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mintStatus: async (t, r = {}) => {
      Bt("mintStatus", "id", t);
      const n = "/campaigns/{id}/mint/status".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Update a campaign
     * @summary [admin] Campaign update
     * @param {number} id 
     * @param {CampaignInput} [campaignInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCampaign: async (t, r, n = {}) => {
      Bt("updateCampaign", "id", t);
      const a = "/campaigns/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...n }, l = {}, c = {};
      await ot(l, e), l["Content-Type"] = "application/json", Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, o.data = mn(r, o, e), {
        url: Ze(s),
        options: o
      };
    }
  };
}, Ln = function(e) {
  const t = f3(e);
  return {
    /**
     * Get a specific campaign
     * @summary Campaign
     * @param {number} id 
     * @param {boolean} [stats] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async campaign(r, n, a) {
      var l, c;
      const s = await t.campaign(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["CampaignsApi.campaign"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * List orders for a campaign
     * @summary [admin] Campaign orders
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<CampaignOrdersStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async campaignOrders(r, n, a, s, i) {
      var u, d;
      const o = await t.campaignOrders(r, n, a, s, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, c = (d = (u = Xe["CampaignsApi.campaignOrders"]) == null ? void 0 : u[l]) == null ? void 0 : d.url;
      return (f, h) => et(o, Be, Ye, e)(f, c || h);
    },
    /**
     * Number of orders for a campaign
     * @summary [admin] Campaign orders count
     * @param {number} id 
     * @param {Array<CampaignOrdersCountStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async campaignOrdersCount(r, n, a) {
      var l, c;
      const s = await t.campaignOrdersCount(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["CampaignsApi.campaignOrdersCount"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Pagination info for campaign orders
     * @summary [admin] Campaign orders pagination info
     * @param {number} id 
     * @param {Array<CampaignOrdersMetaStatusEnum>} [status] order status concatenated with a comma
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async campaignOrdersMeta(r, n, a, s, i) {
      var u, d;
      const o = await t.campaignOrdersMeta(r, n, a, s, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, c = (d = (u = Xe["CampaignsApi.campaignOrdersMeta"]) == null ? void 0 : u[l]) == null ? void 0 : d.url;
      return (f, h) => et(o, Be, Ye, e)(f, c || h);
    },
    /**
     * List orders for a campaign with pagination info
     * @summary [admin] Campaign orders with pagination info
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<CampaignOrdersPageStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async campaignOrdersPage(r, n, a, s, i) {
      var u, d;
      const o = await t.campaignOrdersPage(r, n, a, s, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, c = (d = (u = Xe["CampaignsApi.campaignOrdersPage"]) == null ? void 0 : u[l]) == null ? void 0 : d.url;
      return (f, h) => et(o, Be, Ye, e)(f, c || h);
    },
    /**
     * Number orders of each status and number of distinct buyers for a campaign
     * @summary Campaign statistics
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async campaignStats(r, n) {
      var o, l;
      const a = await t.campaignStats(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["CampaignsApi.campaignStats"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Number of distinct buyers for a campaign
     * @summary Campaign users count
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async campaignUsersCount(r, n) {
      var o, l;
      const a = await t.campaignUsersCount(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["CampaignsApi.campaignUsersCount"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * List campaigns (all if admin, only available ones for the rest)
     * @summary Campaigns
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<CampaignsStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [stats] 
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async campaigns(r, n, a, s, i, o) {
      var d, f;
      const l = await t.campaigns(r, n, a, s, i, o), c = (e == null ? void 0 : e.serverIndex) ?? 0, u = (f = (d = Xe["CampaignsApi.campaigns"]) == null ? void 0 : d[c]) == null ? void 0 : f.url;
      return (h, p) => et(l, Be, Ye, e)(h, u || p);
    },
    /**
     * Get collected amount by campaign
     * @summary Campaigns collected amount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async campaignsCollected(r) {
      var i, o;
      const n = await t.campaignsCollected(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["CampaignsApi.campaignsCollected"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Number of campaigns (all if admin, only available ones for the rest)
     * @summary Campaigns count
     * @param {Array<CampaignsCountStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async campaignsCount(r, n, a) {
      var l, c;
      const s = await t.campaignsCount(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["CampaignsApi.campaignsCount"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Pagination info for campaigns
     * @summary Campaigns pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<CampaignsMetaStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async campaignsMeta(r, n, a, s, i) {
      var u, d;
      const o = await t.campaignsMeta(r, n, a, s, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, c = (d = (u = Xe["CampaignsApi.campaignsMeta"]) == null ? void 0 : u[l]) == null ? void 0 : d.url;
      return (f, h) => et(o, Be, Ye, e)(f, c || h);
    },
    /**
     * List campaigns with pagination info
     * @summary Campaigns with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<CampaignsPageStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [stats] 
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async campaignsPage(r, n, a, s, i, o) {
      var d, f;
      const l = await t.campaignsPage(r, n, a, s, i, o), c = (e == null ? void 0 : e.serverIndex) ?? 0, u = (f = (d = Xe["CampaignsApi.campaignsPage"]) == null ? void 0 : d[c]) == null ? void 0 : f.url;
      return (h, p) => et(l, Be, Ye, e)(h, u || p);
    },
    /**
     * Get number of campaigns in each status as well as the total currency collected
     * @summary Campaigns statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async campaignsStats(r) {
      var i, o;
      const n = await t.campaignsStats(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["CampaignsApi.campaignsStats"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Create a campaign
     * @summary [admin] Campaign creation
     * @param {CampaignInput} [campaignInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCampaign(r, n) {
      var o, l;
      const a = await t.createCampaign(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["CampaignsApi.createCampaign"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Create an order
     * @summary Order creation
     * @param {number} id 
     * @param {number} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createOrder(r, n, a) {
      var l, c;
      const s = await t.createOrder(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["CampaignsApi.createOrder"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Delete a campaign
     * @summary [admin] Campaign deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteCampaign(r, n) {
      var o, l;
      const a = await t.deleteCampaign(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["CampaignsApi.deleteCampaign"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Mint a campaign
     * @summary [admin] Campaign mint
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mintCampaign(r, n) {
      var o, l;
      const a = await t.mintCampaign(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["CampaignsApi.mintCampaign"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Get the status of a mint
     * @summary [admin] Campaign mint status
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mintStatus(r, n) {
      var o, l;
      const a = await t.mintStatus(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["CampaignsApi.mintStatus"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Update a campaign
     * @summary [admin] Campaign update
     * @param {number} id 
     * @param {CampaignInput} [campaignInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCampaign(r, n, a) {
      var l, c;
      const s = await t.updateCampaign(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["CampaignsApi.updateCampaign"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    }
  };
}, kq = function(e, t, r) {
  const n = Ln(e);
  return {
    /**
     * Get a specific campaign
     * @summary Campaign
     * @param {CampaignsApiCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaign(a, s) {
      return n.campaign(a.id, a.stats, s).then((i) => i(r, t));
    },
    /**
     * List orders for a campaign
     * @summary [admin] Campaign orders
     * @param {CampaignsApiCampaignOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignOrders(a, s) {
      return n.campaignOrders(a.id, a.offset, a.limit, a.status, s).then((i) => i(r, t));
    },
    /**
     * Number of orders for a campaign
     * @summary [admin] Campaign orders count
     * @param {CampaignsApiCampaignOrdersCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignOrdersCount(a, s) {
      return n.campaignOrdersCount(a.id, a.status, s).then((i) => i(r, t));
    },
    /**
     * Pagination info for campaign orders
     * @summary [admin] Campaign orders pagination info
     * @param {CampaignsApiCampaignOrdersMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignOrdersMeta(a, s) {
      return n.campaignOrdersMeta(a.id, a.status, a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * List orders for a campaign with pagination info
     * @summary [admin] Campaign orders with pagination info
     * @param {CampaignsApiCampaignOrdersPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignOrdersPage(a, s) {
      return n.campaignOrdersPage(a.id, a.offset, a.limit, a.status, s).then((i) => i(r, t));
    },
    /**
     * Number orders of each status and number of distinct buyers for a campaign
     * @summary Campaign statistics
     * @param {CampaignsApiCampaignStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignStats(a, s) {
      return n.campaignStats(a.id, s).then((i) => i(r, t));
    },
    /**
     * Number of distinct buyers for a campaign
     * @summary Campaign users count
     * @param {CampaignsApiCampaignUsersCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignUsersCount(a, s) {
      return n.campaignUsersCount(a.id, s).then((i) => i(r, t));
    },
    /**
     * List campaigns (all if admin, only available ones for the rest)
     * @summary Campaigns
     * @param {CampaignsApiCampaignsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaigns(a = {}, s) {
      return n.campaigns(a.offset, a.limit, a.status, a.stats, a._private, s).then((i) => i(r, t));
    },
    /**
     * Get collected amount by campaign
     * @summary Campaigns collected amount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignsCollected(a) {
      return n.campaignsCollected(a).then((s) => s(r, t));
    },
    /**
     * Number of campaigns (all if admin, only available ones for the rest)
     * @summary Campaigns count
     * @param {CampaignsApiCampaignsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignsCount(a = {}, s) {
      return n.campaignsCount(a.status, a._private, s).then((i) => i(r, t));
    },
    /**
     * Pagination info for campaigns
     * @summary Campaigns pagination info
     * @param {CampaignsApiCampaignsMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignsMeta(a = {}, s) {
      return n.campaignsMeta(a.offset, a.limit, a.status, a._private, s).then((i) => i(r, t));
    },
    /**
     * List campaigns with pagination info
     * @summary Campaigns with pagination info
     * @param {CampaignsApiCampaignsPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignsPage(a = {}, s) {
      return n.campaignsPage(a.offset, a.limit, a.status, a.stats, a._private, s).then((i) => i(r, t));
    },
    /**
     * Get number of campaigns in each status as well as the total currency collected
     * @summary Campaigns statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    campaignsStats(a) {
      return n.campaignsStats(a).then((s) => s(r, t));
    },
    /**
     * Create a campaign
     * @summary [admin] Campaign creation
     * @param {CampaignsApiCreateCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCampaign(a = {}, s) {
      return n.createCampaign(a.campaignInput, s).then((i) => i(r, t));
    },
    /**
     * Create an order
     * @summary Order creation
     * @param {CampaignsApiCreateOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOrder(a, s) {
      return n.createOrder(a.id, a.body, s).then((i) => i(r, t));
    },
    /**
     * Delete a campaign
     * @summary [admin] Campaign deletion
     * @param {CampaignsApiDeleteCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCampaign(a, s) {
      return n.deleteCampaign(a.id, s).then((i) => i(r, t));
    },
    /**
     * Mint a campaign
     * @summary [admin] Campaign mint
     * @param {CampaignsApiMintCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mintCampaign(a, s) {
      return n.mintCampaign(a.id, s).then((i) => i(r, t));
    },
    /**
     * Get the status of a mint
     * @summary [admin] Campaign mint status
     * @param {CampaignsApiMintStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mintStatus(a, s) {
      return n.mintStatus(a.id, s).then((i) => i(r, t));
    },
    /**
     * Update a campaign
     * @summary [admin] Campaign update
     * @param {CampaignsApiUpdateCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCampaign(a, s) {
      return n.updateCampaign(a.id, a.campaignInput, s).then((i) => i(r, t));
    }
  };
};
class Oq extends $c {
  /**
   * Get a specific campaign
   * @summary Campaign
   * @param {CampaignsApiCampaignRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  campaign(t, r) {
    return Ln(this.configuration).campaign(t.id, t.stats, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List orders for a campaign
   * @summary [admin] Campaign orders
   * @param {CampaignsApiCampaignOrdersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  campaignOrders(t, r) {
    return Ln(this.configuration).campaignOrders(t.id, t.offset, t.limit, t.status, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number of orders for a campaign
   * @summary [admin] Campaign orders count
   * @param {CampaignsApiCampaignOrdersCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  campaignOrdersCount(t, r) {
    return Ln(this.configuration).campaignOrdersCount(t.id, t.status, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Pagination info for campaign orders
   * @summary [admin] Campaign orders pagination info
   * @param {CampaignsApiCampaignOrdersMetaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  campaignOrdersMeta(t, r) {
    return Ln(this.configuration).campaignOrdersMeta(t.id, t.status, t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List orders for a campaign with pagination info
   * @summary [admin] Campaign orders with pagination info
   * @param {CampaignsApiCampaignOrdersPageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  campaignOrdersPage(t, r) {
    return Ln(this.configuration).campaignOrdersPage(t.id, t.offset, t.limit, t.status, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number orders of each status and number of distinct buyers for a campaign
   * @summary Campaign statistics
   * @param {CampaignsApiCampaignStatsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  campaignStats(t, r) {
    return Ln(this.configuration).campaignStats(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number of distinct buyers for a campaign
   * @summary Campaign users count
   * @param {CampaignsApiCampaignUsersCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  campaignUsersCount(t, r) {
    return Ln(this.configuration).campaignUsersCount(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List campaigns (all if admin, only available ones for the rest)
   * @summary Campaigns
   * @param {CampaignsApiCampaignsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  campaigns(t = {}, r) {
    return Ln(this.configuration).campaigns(t.offset, t.limit, t.status, t.stats, t._private, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get collected amount by campaign
   * @summary Campaigns collected amount
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  campaignsCollected(t) {
    return Ln(this.configuration).campaignsCollected(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Number of campaigns (all if admin, only available ones for the rest)
   * @summary Campaigns count
   * @param {CampaignsApiCampaignsCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  campaignsCount(t = {}, r) {
    return Ln(this.configuration).campaignsCount(t.status, t._private, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Pagination info for campaigns
   * @summary Campaigns pagination info
   * @param {CampaignsApiCampaignsMetaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  campaignsMeta(t = {}, r) {
    return Ln(this.configuration).campaignsMeta(t.offset, t.limit, t.status, t._private, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List campaigns with pagination info
   * @summary Campaigns with pagination info
   * @param {CampaignsApiCampaignsPageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  campaignsPage(t = {}, r) {
    return Ln(this.configuration).campaignsPage(t.offset, t.limit, t.status, t.stats, t._private, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get number of campaigns in each status as well as the total currency collected
   * @summary Campaigns statistics
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  campaignsStats(t) {
    return Ln(this.configuration).campaignsStats(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Create a campaign
   * @summary [admin] Campaign creation
   * @param {CampaignsApiCreateCampaignRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  createCampaign(t = {}, r) {
    return Ln(this.configuration).createCampaign(t.campaignInput, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Create an order
   * @summary Order creation
   * @param {CampaignsApiCreateOrderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  createOrder(t, r) {
    return Ln(this.configuration).createOrder(t.id, t.body, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete a campaign
   * @summary [admin] Campaign deletion
   * @param {CampaignsApiDeleteCampaignRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  deleteCampaign(t, r) {
    return Ln(this.configuration).deleteCampaign(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Mint a campaign
   * @summary [admin] Campaign mint
   * @param {CampaignsApiMintCampaignRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  mintCampaign(t, r) {
    return Ln(this.configuration).mintCampaign(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get the status of a mint
   * @summary [admin] Campaign mint status
   * @param {CampaignsApiMintStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  mintStatus(t, r) {
    return Ln(this.configuration).mintStatus(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Update a campaign
   * @summary [admin] Campaign update
   * @param {CampaignsApiUpdateCampaignRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CampaignsApi
   */
  updateCampaign(t, r) {
    return Ln(this.configuration).updateCampaign(t.id, t.campaignInput, r).then((n) => n(this.axios, this.basePath));
  }
}
const Aq = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, Pq = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, Rq = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, Iq = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, Nr = {
  Created: "created",
  Available: "available",
  Canceled: "canceled",
  Closed: "closed",
  Minted: "minted"
}, Dq = {
  Created: "created",
  Available: "available",
  Canceled: "canceled",
  Closed: "closed",
  Minted: "minted"
}, Nq = {
  Created: "created",
  Available: "available",
  Canceled: "canceled",
  Closed: "closed",
  Minted: "minted"
}, ns = {
  Created: "created",
  Available: "available",
  Canceled: "canceled",
  Closed: "closed",
  Minted: "minted"
}, h3 = function(e) {
  return {
    /**
     * Add some generic data
     * @summary [admin] Data addition
     * @param {AddDataRequest} [addDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addData: async (t, r = {}) => {
      const n = "/data", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      await ot(o, e), o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * List data for a specific kind
     * @summary Data
     * @param {string} kind 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    data: async (t, r, n, a = {}) => {
      Bt("data", "kind", t);
      const s = "/data/{kind}".replace("{kind}", encodeURIComponent(String(t))), i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      r !== void 0 && (u.offset = r), n !== void 0 && (u.limit = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * Number of data for a specific kind
     * @summary Data count
     * @param {string} kind 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataCount: async (t, r = {}) => {
      Bt("dataCount", "kind", t);
      const n = "/data/{kind}/count".replace("{kind}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {};
      Je(a, {});
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * List different kinds of data
     * @summary Data kinds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataKinds: async (t = {}) => {
      const r = "/data/kinds", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {};
      Je(n, {});
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Pagination info for data of a specific kind
     * @summary Data pagination info
     * @param {string} kind 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataMeta: async (t, r, n, a = {}) => {
      Bt("dataMeta", "kind", t);
      const s = "/data/{kind}/meta".replace("{kind}", encodeURIComponent(String(t))), i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      r !== void 0 && (u.offset = r), n !== void 0 && (u.limit = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * List data for a specific kind with pagination info
     * @summary Data with pagination info
     * @param {string} kind 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataPage: async (t, r, n, a = {}) => {
      Bt("dataPage", "kind", t);
      const s = "/data/{kind}/page".replace("{kind}", encodeURIComponent(String(t))), i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      r !== void 0 && (u.offset = r), n !== void 0 && (u.limit = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * Delete some generic data
     * @summary [admin] Data deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteData: async (t, r = {}) => {
      Bt("deleteData", "id", t);
      const n = "/data/manage/{id}".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "DELETE", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Update some generic data
     * @summary [admin] Data update
     * @param {number} id 
     * @param {AddDataRequest} [addDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateData: async (t, r, n = {}) => {
      Bt("updateData", "id", t);
      const a = "/data/manage/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...n }, l = {}, c = {};
      await ot(l, e), l["Content-Type"] = "application/json", Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, o.data = mn(r, o, e), {
        url: Ze(s),
        options: o
      };
    }
  };
}, po = function(e) {
  const t = h3(e);
  return {
    /**
     * Add some generic data
     * @summary [admin] Data addition
     * @param {AddDataRequest} [addDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addData(r, n) {
      var o, l;
      const a = await t.addData(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["DataApi.addData"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * List data for a specific kind
     * @summary Data
     * @param {string} kind 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async data(r, n, a, s) {
      var c, u;
      const i = await t.data(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["DataApi.data"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * Number of data for a specific kind
     * @summary Data count
     * @param {string} kind 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataCount(r, n) {
      var o, l;
      const a = await t.dataCount(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["DataApi.dataCount"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * List different kinds of data
     * @summary Data kinds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataKinds(r) {
      var i, o;
      const n = await t.dataKinds(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["DataApi.dataKinds"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Pagination info for data of a specific kind
     * @summary Data pagination info
     * @param {string} kind 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataMeta(r, n, a, s) {
      var c, u;
      const i = await t.dataMeta(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["DataApi.dataMeta"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * List data for a specific kind with pagination info
     * @summary Data with pagination info
     * @param {string} kind 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataPage(r, n, a, s) {
      var c, u;
      const i = await t.dataPage(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["DataApi.dataPage"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * Delete some generic data
     * @summary [admin] Data deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteData(r, n) {
      var o, l;
      const a = await t.deleteData(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["DataApi.deleteData"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Update some generic data
     * @summary [admin] Data update
     * @param {number} id 
     * @param {AddDataRequest} [addDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateData(r, n, a) {
      var l, c;
      const s = await t.updateData(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["DataApi.updateData"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    }
  };
}, Mq = function(e, t, r) {
  const n = po(e);
  return {
    /**
     * Add some generic data
     * @summary [admin] Data addition
     * @param {DataApiAddDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addData(a = {}, s) {
      return n.addData(a.addDataRequest, s).then((i) => i(r, t));
    },
    /**
     * List data for a specific kind
     * @summary Data
     * @param {DataApiDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    data(a, s) {
      return n.data(a.kind, a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * Number of data for a specific kind
     * @summary Data count
     * @param {DataApiDataCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataCount(a, s) {
      return n.dataCount(a.kind, s).then((i) => i(r, t));
    },
    /**
     * List different kinds of data
     * @summary Data kinds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataKinds(a) {
      return n.dataKinds(a).then((s) => s(r, t));
    },
    /**
     * Pagination info for data of a specific kind
     * @summary Data pagination info
     * @param {DataApiDataMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataMeta(a, s) {
      return n.dataMeta(a.kind, a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * List data for a specific kind with pagination info
     * @summary Data with pagination info
     * @param {DataApiDataPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataPage(a, s) {
      return n.dataPage(a.kind, a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * Delete some generic data
     * @summary [admin] Data deletion
     * @param {DataApiDeleteDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteData(a, s) {
      return n.deleteData(a.id, s).then((i) => i(r, t));
    },
    /**
     * Update some generic data
     * @summary [admin] Data update
     * @param {DataApiUpdateDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateData(a, s) {
      return n.updateData(a.id, a.addDataRequest, s).then((i) => i(r, t));
    }
  };
};
class Lq extends $c {
  /**
   * Add some generic data
   * @summary [admin] Data addition
   * @param {DataApiAddDataRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataApi
   */
  addData(t = {}, r) {
    return po(this.configuration).addData(t.addDataRequest, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List data for a specific kind
   * @summary Data
   * @param {DataApiDataRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataApi
   */
  data(t, r) {
    return po(this.configuration).data(t.kind, t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number of data for a specific kind
   * @summary Data count
   * @param {DataApiDataCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataApi
   */
  dataCount(t, r) {
    return po(this.configuration).dataCount(t.kind, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List different kinds of data
   * @summary Data kinds
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataApi
   */
  dataKinds(t) {
    return po(this.configuration).dataKinds(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Pagination info for data of a specific kind
   * @summary Data pagination info
   * @param {DataApiDataMetaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataApi
   */
  dataMeta(t, r) {
    return po(this.configuration).dataMeta(t.kind, t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List data for a specific kind with pagination info
   * @summary Data with pagination info
   * @param {DataApiDataPageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataApi
   */
  dataPage(t, r) {
    return po(this.configuration).dataPage(t.kind, t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete some generic data
   * @summary [admin] Data deletion
   * @param {DataApiDeleteDataRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataApi
   */
  deleteData(t, r) {
    return po(this.configuration).deleteData(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Update some generic data
   * @summary [admin] Data update
   * @param {DataApiUpdateDataRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataApi
   */
  updateData(t, r) {
    return po(this.configuration).updateData(t.id, t.addDataRequest, r).then((n) => n(this.axios, this.basePath));
  }
}
const p3 = function(e) {
  return {
    /**
     * Hook endpoint for KYC events
     * @summary KYC Hook
     * @param {KycHook} [kycHook] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kycHook: async (t, r = {}) => {
      const n = "/hooks/kyc", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Hook endpoint for payment events
     * @summary Payment Hook
     * @param {File} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentHook: async (t, r = {}) => {
      const n = "/hooks/payment", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Hook endpoint for signature events
     * @summary Signature Hook
     * @param {SignatureHook | null} [signatureHook] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signatureHook: async (t, r = {}) => {
      const n = "/hooks/signature.json", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    }
  };
}, om = function(e) {
  const t = p3(e);
  return {
    /**
     * Hook endpoint for KYC events
     * @summary KYC Hook
     * @param {KycHook} [kycHook] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async kycHook(r, n) {
      var o, l;
      const a = await t.kycHook(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["HooksApi.kycHook"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Hook endpoint for payment events
     * @summary Payment Hook
     * @param {File} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentHook(r, n) {
      var o, l;
      const a = await t.paymentHook(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["HooksApi.paymentHook"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Hook endpoint for signature events
     * @summary Signature Hook
     * @param {SignatureHook | null} [signatureHook] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async signatureHook(r, n) {
      var o, l;
      const a = await t.signatureHook(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["HooksApi.signatureHook"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    }
  };
}, jq = function(e, t, r) {
  const n = om(e);
  return {
    /**
     * Hook endpoint for KYC events
     * @summary KYC Hook
     * @param {HooksApiKycHookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kycHook(a = {}, s) {
      return n.kycHook(a.kycHook, s).then((i) => i(r, t));
    },
    /**
     * Hook endpoint for payment events
     * @summary Payment Hook
     * @param {HooksApiPaymentHookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentHook(a = {}, s) {
      return n.paymentHook(a.body, s).then((i) => i(r, t));
    },
    /**
     * Hook endpoint for signature events
     * @summary Signature Hook
     * @param {HooksApiSignatureHookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signatureHook(a = {}, s) {
      return n.signatureHook(a.signatureHook, s).then((i) => i(r, t));
    }
  };
};
class Fq extends $c {
  /**
   * Hook endpoint for KYC events
   * @summary KYC Hook
   * @param {HooksApiKycHookRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HooksApi
   */
  kycHook(t = {}, r) {
    return om(this.configuration).kycHook(t.kycHook, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Hook endpoint for payment events
   * @summary Payment Hook
   * @param {HooksApiPaymentHookRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HooksApi
   */
  paymentHook(t = {}, r) {
    return om(this.configuration).paymentHook(t.body, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Hook endpoint for signature events
   * @summary Signature Hook
   * @param {HooksApiSignatureHookRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HooksApi
   */
  signatureHook(t = {}, r) {
    return om(this.configuration).signatureHook(t.signatureHook, r).then((n) => n(this.axios, this.basePath));
  }
}
const m3 = function(e) {
  return {
    /**
     * 
     * @summary cancel_order
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelOrder: async (t, r = {}) => {
      Bt("cancelOrder", "id", t);
      const n = "/orders/{id}/cancel".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "PUT", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Delete an order
     * @summary [admin] Order deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOrder: async (t, r = {}) => {
      Bt("deleteOrder", "id", t);
      const n = "/orders/{id}".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "DELETE", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Execute an order
     * @summary Order execution
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    executeOrder: async (t, r = {}) => {
      Bt("executeOrder", "id", t);
      const n = "/orders/{id}/execute".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "PUT", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Get a specific order
     * @summary Order
     * @param {number} id 
     * @param {boolean} [refresh] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    order: async (t, r, n = {}) => {
      Bt("order", "id", t);
      const a = "/orders/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "PUT", ...i, ...n }, l = {}, c = {};
      await ot(l, e), r !== void 0 && (c.refresh = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * List order documents
     * @summary Order documents
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderDocuments: async (t, r = {}) => {
      Bt("orderDocuments", "id", t);
      const n = "/orders/{id}/documents".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * List orders (if admin all orders, else only the user orders)
     * @summary Orders
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<OrdersStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orders: async (t, r, n, a = {}) => {
      const s = "/orders", i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      await ot(c, e), t !== void 0 && (u.offset = t), r !== void 0 && (u.limit = r), n && (u.status = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * Number of orders (if admin all orders, else only the user orders)
     * @summary Orders count
     * @param {Array<OrdersCountStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersCount: async (t, r = {}) => {
      const n = "/orders/count", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {}, l = {};
      await ot(o, e), t && (l.status = t), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Pagination info for orders
     * @summary Orders pagination info
     * @param {Array<OrdersMetaStatusEnum>} [status] order status concatenated with a comma
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersMeta: async (t, r, n, a = {}) => {
      const s = "/orders/meta", i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      await ot(c, e), t && (u.status = t), r !== void 0 && (u.offset = r), n !== void 0 && (u.limit = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * List orders with pagination info
     * @summary Orders with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<OrdersPageStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersPage: async (t, r, n, a = {}) => {
      const s = "/orders/page", i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      await ot(c, e), t !== void 0 && (u.offset = t), r !== void 0 && (u.limit = r), n && (u.status = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * Refund an order
     * @summary Order refund
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refundOrder: async (t, r = {}) => {
      Bt("refundOrder", "id", t);
      const n = "/orders/{id}/refund".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "PUT", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Update manually an order
     * @summary [admin] Order update
     * @param {number} id 
     * @param {OrderWithIds} [orderWithIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrder: async (t, r, n = {}) => {
      Bt("updateOrder", "id", t);
      const a = "/orders/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...n }, l = {}, c = {};
      await ot(l, e), l["Content-Type"] = "application/json", Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, o.data = mn(r, o, e), {
        url: Ze(s),
        options: o
      };
    }
  };
}, Ds = function(e) {
  const t = m3(e);
  return {
    /**
     * 
     * @summary cancel_order
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelOrder(r, n) {
      var o, l;
      const a = await t.cancelOrder(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["OrdersApi.cancelOrder"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Delete an order
     * @summary [admin] Order deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteOrder(r, n) {
      var o, l;
      const a = await t.deleteOrder(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["OrdersApi.deleteOrder"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Execute an order
     * @summary Order execution
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async executeOrder(r, n) {
      var o, l;
      const a = await t.executeOrder(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["OrdersApi.executeOrder"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Get a specific order
     * @summary Order
     * @param {number} id 
     * @param {boolean} [refresh] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async order(r, n, a) {
      var l, c;
      const s = await t.order(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["OrdersApi.order"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * List order documents
     * @summary Order documents
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orderDocuments(r, n) {
      var o, l;
      const a = await t.orderDocuments(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["OrdersApi.orderDocuments"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * List orders (if admin all orders, else only the user orders)
     * @summary Orders
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<OrdersStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orders(r, n, a, s) {
      var c, u;
      const i = await t.orders(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["OrdersApi.orders"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * Number of orders (if admin all orders, else only the user orders)
     * @summary Orders count
     * @param {Array<OrdersCountStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ordersCount(r, n) {
      var o, l;
      const a = await t.ordersCount(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["OrdersApi.ordersCount"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Pagination info for orders
     * @summary Orders pagination info
     * @param {Array<OrdersMetaStatusEnum>} [status] order status concatenated with a comma
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ordersMeta(r, n, a, s) {
      var c, u;
      const i = await t.ordersMeta(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["OrdersApi.ordersMeta"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * List orders with pagination info
     * @summary Orders with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<OrdersPageStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ordersPage(r, n, a, s) {
      var c, u;
      const i = await t.ordersPage(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["OrdersApi.ordersPage"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * Refund an order
     * @summary Order refund
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async refundOrder(r, n) {
      var o, l;
      const a = await t.refundOrder(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["OrdersApi.refundOrder"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Update manually an order
     * @summary [admin] Order update
     * @param {number} id 
     * @param {OrderWithIds} [orderWithIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateOrder(r, n, a) {
      var l, c;
      const s = await t.updateOrder(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["OrdersApi.updateOrder"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    }
  };
}, Bq = function(e, t, r) {
  const n = Ds(e);
  return {
    /**
     * 
     * @summary cancel_order
     * @param {OrdersApiCancelOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelOrder(a, s) {
      return n.cancelOrder(a.id, s).then((i) => i(r, t));
    },
    /**
     * Delete an order
     * @summary [admin] Order deletion
     * @param {OrdersApiDeleteOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOrder(a, s) {
      return n.deleteOrder(a.id, s).then((i) => i(r, t));
    },
    /**
     * Execute an order
     * @summary Order execution
     * @param {OrdersApiExecuteOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    executeOrder(a, s) {
      return n.executeOrder(a.id, s).then((i) => i(r, t));
    },
    /**
     * Get a specific order
     * @summary Order
     * @param {OrdersApiOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    order(a, s) {
      return n.order(a.id, a.refresh, s).then((i) => i(r, t));
    },
    /**
     * List order documents
     * @summary Order documents
     * @param {OrdersApiOrderDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderDocuments(a, s) {
      return n.orderDocuments(a.id, s).then((i) => i(r, t));
    },
    /**
     * List orders (if admin all orders, else only the user orders)
     * @summary Orders
     * @param {OrdersApiOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orders(a = {}, s) {
      return n.orders(a.offset, a.limit, a.status, s).then((i) => i(r, t));
    },
    /**
     * Number of orders (if admin all orders, else only the user orders)
     * @summary Orders count
     * @param {OrdersApiOrdersCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersCount(a = {}, s) {
      return n.ordersCount(a.status, s).then((i) => i(r, t));
    },
    /**
     * Pagination info for orders
     * @summary Orders pagination info
     * @param {OrdersApiOrdersMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersMeta(a = {}, s) {
      return n.ordersMeta(a.status, a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * List orders with pagination info
     * @summary Orders with pagination info
     * @param {OrdersApiOrdersPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersPage(a = {}, s) {
      return n.ordersPage(a.offset, a.limit, a.status, s).then((i) => i(r, t));
    },
    /**
     * Refund an order
     * @summary Order refund
     * @param {OrdersApiRefundOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refundOrder(a, s) {
      return n.refundOrder(a.id, s).then((i) => i(r, t));
    },
    /**
     * Update manually an order
     * @summary [admin] Order update
     * @param {OrdersApiUpdateOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrder(a, s) {
      return n.updateOrder(a.id, a.orderWithIds, s).then((i) => i(r, t));
    }
  };
};
class Uq extends $c {
  /**
   * 
   * @summary cancel_order
   * @param {OrdersApiCancelOrderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApi
   */
  cancelOrder(t, r) {
    return Ds(this.configuration).cancelOrder(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete an order
   * @summary [admin] Order deletion
   * @param {OrdersApiDeleteOrderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApi
   */
  deleteOrder(t, r) {
    return Ds(this.configuration).deleteOrder(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Execute an order
   * @summary Order execution
   * @param {OrdersApiExecuteOrderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApi
   */
  executeOrder(t, r) {
    return Ds(this.configuration).executeOrder(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get a specific order
   * @summary Order
   * @param {OrdersApiOrderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApi
   */
  order(t, r) {
    return Ds(this.configuration).order(t.id, t.refresh, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List order documents
   * @summary Order documents
   * @param {OrdersApiOrderDocumentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApi
   */
  orderDocuments(t, r) {
    return Ds(this.configuration).orderDocuments(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List orders (if admin all orders, else only the user orders)
   * @summary Orders
   * @param {OrdersApiOrdersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApi
   */
  orders(t = {}, r) {
    return Ds(this.configuration).orders(t.offset, t.limit, t.status, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number of orders (if admin all orders, else only the user orders)
   * @summary Orders count
   * @param {OrdersApiOrdersCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApi
   */
  ordersCount(t = {}, r) {
    return Ds(this.configuration).ordersCount(t.status, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Pagination info for orders
   * @summary Orders pagination info
   * @param {OrdersApiOrdersMetaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApi
   */
  ordersMeta(t = {}, r) {
    return Ds(this.configuration).ordersMeta(t.status, t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List orders with pagination info
   * @summary Orders with pagination info
   * @param {OrdersApiOrdersPageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApi
   */
  ordersPage(t = {}, r) {
    return Ds(this.configuration).ordersPage(t.offset, t.limit, t.status, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Refund an order
   * @summary Order refund
   * @param {OrdersApiRefundOrderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApi
   */
  refundOrder(t, r) {
    return Ds(this.configuration).refundOrder(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Update manually an order
   * @summary [admin] Order update
   * @param {OrdersApiUpdateOrderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrdersApi
   */
  updateOrder(t, r) {
    return Ds(this.configuration).updateOrder(t.id, t.orderWithIds, r).then((n) => n(this.axios, this.basePath));
  }
}
const Vq = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, $q = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, Hq = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, Wq = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, g3 = function(e) {
  return {
    /**
     * Create a poll
     * @summary [admin] Poll creation
     * @param {Poll} [poll] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPoll: async (t, r = {}) => {
      const n = "/polls", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      await ot(o, e), o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Delete a poll
     * @summary [admin] Poll deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePoll: async (t, r = {}) => {
      Bt("deletePoll", "id", t);
      const n = "/polls/{id}".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "DELETE", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Get a specific poll
     * @summary Poll
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    poll: async (t, r = {}) => {
      Bt("poll", "id", t);
      const n = "/polls/{id}".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * List votes for a poll
     * @summary [admin] Poll votes
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollVotes: async (t, r, n, a = {}) => {
      Bt("pollVotes", "id", t);
      const s = "/polls/{id}/votes".replace("{id}", encodeURIComponent(String(t))), i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      await ot(c, e), r !== void 0 && (u.offset = r), n !== void 0 && (u.limit = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * Number of votes for a poll
     * @summary [admin] Poll votes count
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollVotesCount: async (t, r = {}) => {
      Bt("pollVotesCount", "id", t);
      const n = "/polls/{id}/votes/count".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * List votes for a poll with pagination info
     * @summary [admin] Poll votes with pagination
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollVotesPage: async (t, r, n, a = {}) => {
      Bt("pollVotesPage", "id", t);
      const s = "/polls/{id}/votes/page".replace("{id}", encodeURIComponent(String(t))), i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      await ot(c, e), r !== void 0 && (u.offset = r), n !== void 0 && (u.limit = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * List polls
     * @summary Polls
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    polls: async (t, r, n = {}) => {
      const a = "/polls", s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), t !== void 0 && (c.offset = t), r !== void 0 && (c.limit = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Number of polls
     * @summary Polls count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollsCount: async (t = {}) => {
      const r = "/polls/count", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Pagination info for polls
     * @summary Polls pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollsMeta: async (t, r, n = {}) => {
      const a = "/polls/meta", s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), t !== void 0 && (c.offset = t), r !== void 0 && (c.limit = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * List polls with pagination info
     * @summary Polls with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollsPage: async (t, r, n = {}) => {
      const a = "/polls/page", s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), t !== void 0 && (c.offset = t), r !== void 0 && (c.limit = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Update a poll
     * @summary [admin] Poll update
     * @param {number} id 
     * @param {Poll} [poll] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePoll: async (t, r, n = {}) => {
      Bt("updatePoll", "id", t);
      const a = "/polls/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...n }, l = {}, c = {};
      await ot(l, e), l["Content-Type"] = "application/json", Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, o.data = mn(r, o, e), {
        url: Ze(s),
        options: o
      };
    }
  };
}, Ns = function(e) {
  const t = g3(e);
  return {
    /**
     * Create a poll
     * @summary [admin] Poll creation
     * @param {Poll} [poll] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPoll(r, n) {
      var o, l;
      const a = await t.createPoll(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["PollsApi.createPoll"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Delete a poll
     * @summary [admin] Poll deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePoll(r, n) {
      var o, l;
      const a = await t.deletePoll(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["PollsApi.deletePoll"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Get a specific poll
     * @summary Poll
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async poll(r, n) {
      var o, l;
      const a = await t.poll(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["PollsApi.poll"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * List votes for a poll
     * @summary [admin] Poll votes
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pollVotes(r, n, a, s) {
      var c, u;
      const i = await t.pollVotes(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["PollsApi.pollVotes"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * Number of votes for a poll
     * @summary [admin] Poll votes count
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pollVotesCount(r, n) {
      var o, l;
      const a = await t.pollVotesCount(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["PollsApi.pollVotesCount"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * List votes for a poll with pagination info
     * @summary [admin] Poll votes with pagination
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pollVotesPage(r, n, a, s) {
      var c, u;
      const i = await t.pollVotesPage(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["PollsApi.pollVotesPage"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * List polls
     * @summary Polls
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async polls(r, n, a) {
      var l, c;
      const s = await t.polls(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["PollsApi.polls"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Number of polls
     * @summary Polls count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pollsCount(r) {
      var i, o;
      const n = await t.pollsCount(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["PollsApi.pollsCount"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Pagination info for polls
     * @summary Polls pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pollsMeta(r, n, a) {
      var l, c;
      const s = await t.pollsMeta(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["PollsApi.pollsMeta"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * List polls with pagination info
     * @summary Polls with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pollsPage(r, n, a) {
      var l, c;
      const s = await t.pollsPage(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["PollsApi.pollsPage"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Update a poll
     * @summary [admin] Poll update
     * @param {number} id 
     * @param {Poll} [poll] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePoll(r, n, a) {
      var l, c;
      const s = await t.updatePoll(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["PollsApi.updatePoll"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    }
  };
}, zq = function(e, t, r) {
  const n = Ns(e);
  return {
    /**
     * Create a poll
     * @summary [admin] Poll creation
     * @param {PollsApiCreatePollRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPoll(a = {}, s) {
      return n.createPoll(a.poll, s).then((i) => i(r, t));
    },
    /**
     * Delete a poll
     * @summary [admin] Poll deletion
     * @param {PollsApiDeletePollRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePoll(a, s) {
      return n.deletePoll(a.id, s).then((i) => i(r, t));
    },
    /**
     * Get a specific poll
     * @summary Poll
     * @param {PollsApiPollRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    poll(a, s) {
      return n.poll(a.id, s).then((i) => i(r, t));
    },
    /**
     * List votes for a poll
     * @summary [admin] Poll votes
     * @param {PollsApiPollVotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollVotes(a, s) {
      return n.pollVotes(a.id, a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * Number of votes for a poll
     * @summary [admin] Poll votes count
     * @param {PollsApiPollVotesCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollVotesCount(a, s) {
      return n.pollVotesCount(a.id, s).then((i) => i(r, t));
    },
    /**
     * List votes for a poll with pagination info
     * @summary [admin] Poll votes with pagination
     * @param {PollsApiPollVotesPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollVotesPage(a, s) {
      return n.pollVotesPage(a.id, a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * List polls
     * @summary Polls
     * @param {PollsApiPollsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    polls(a = {}, s) {
      return n.polls(a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * Number of polls
     * @summary Polls count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollsCount(a) {
      return n.pollsCount(a).then((s) => s(r, t));
    },
    /**
     * Pagination info for polls
     * @summary Polls pagination info
     * @param {PollsApiPollsMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollsMeta(a = {}, s) {
      return n.pollsMeta(a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * List polls with pagination info
     * @summary Polls with pagination info
     * @param {PollsApiPollsPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pollsPage(a = {}, s) {
      return n.pollsPage(a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * Update a poll
     * @summary [admin] Poll update
     * @param {PollsApiUpdatePollRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePoll(a, s) {
      return n.updatePoll(a.id, a.poll, s).then((i) => i(r, t));
    }
  };
};
class Kq extends $c {
  /**
   * Create a poll
   * @summary [admin] Poll creation
   * @param {PollsApiCreatePollRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PollsApi
   */
  createPoll(t = {}, r) {
    return Ns(this.configuration).createPoll(t.poll, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete a poll
   * @summary [admin] Poll deletion
   * @param {PollsApiDeletePollRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PollsApi
   */
  deletePoll(t, r) {
    return Ns(this.configuration).deletePoll(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get a specific poll
   * @summary Poll
   * @param {PollsApiPollRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PollsApi
   */
  poll(t, r) {
    return Ns(this.configuration).poll(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List votes for a poll
   * @summary [admin] Poll votes
   * @param {PollsApiPollVotesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PollsApi
   */
  pollVotes(t, r) {
    return Ns(this.configuration).pollVotes(t.id, t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number of votes for a poll
   * @summary [admin] Poll votes count
   * @param {PollsApiPollVotesCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PollsApi
   */
  pollVotesCount(t, r) {
    return Ns(this.configuration).pollVotesCount(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List votes for a poll with pagination info
   * @summary [admin] Poll votes with pagination
   * @param {PollsApiPollVotesPageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PollsApi
   */
  pollVotesPage(t, r) {
    return Ns(this.configuration).pollVotesPage(t.id, t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List polls
   * @summary Polls
   * @param {PollsApiPollsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PollsApi
   */
  polls(t = {}, r) {
    return Ns(this.configuration).polls(t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number of polls
   * @summary Polls count
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PollsApi
   */
  pollsCount(t) {
    return Ns(this.configuration).pollsCount(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Pagination info for polls
   * @summary Polls pagination info
   * @param {PollsApiPollsMetaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PollsApi
   */
  pollsMeta(t = {}, r) {
    return Ns(this.configuration).pollsMeta(t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List polls with pagination info
   * @summary Polls with pagination info
   * @param {PollsApiPollsPageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PollsApi
   */
  pollsPage(t = {}, r) {
    return Ns(this.configuration).pollsPage(t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Update a poll
   * @summary [admin] Poll update
   * @param {PollsApiUpdatePollRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PollsApi
   */
  updatePoll(t, r) {
    return Ns(this.configuration).updatePoll(t.id, t.poll, r).then((n) => n(this.axios, this.basePath));
  }
}
const v3 = function(e) {
  return {
    /**
     * Cities with a project (in case of real estate)
     * @summary Cities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cities: async (t = {}) => {
      const r = "/projects/cities", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {};
      Je(n, {});
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Create a project
     * @summary [admin] Project creation
     * @param {Project} [project] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProject: async (t, r = {}) => {
      const n = "/projects", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      await ot(o, e), o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Delete a project
     * @summary [admin] Project deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProject: async (t, r = {}) => {
      Bt("deleteProject", "id", t);
      const n = "/projects/{id}".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "DELETE", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Execute the payout for a project (for a given period)
     * @summary [admin] Project payout
     * @param {number} id 
     * @param {PayoutRequest} [payoutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payout: async (t, r, n = {}) => {
      Bt("payout", "id", t);
      const a = "/projects/{id}/payout".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...n }, l = {}, c = {};
      await ot(l, e), l["Content-Type"] = "application/json", Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, o.data = mn(r, o, e), {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Periods available for a payout
     * @summary [admin] Payout periods
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payoutPeriods: async (t, r = {}) => {
      Bt("payoutPeriods", "id", t);
      const n = "/projects/{id}/periods".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Get a specific project
     * @summary Project
     * @param {number} id 
     * @param {boolean} [stats] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    project: async (t, r, n = {}) => {
      Bt("project", "id", t);
      const a = "/projects/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), r !== void 0 && (c.stats = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * List campaigns for a single project (all if admin, only available for the rest)
     * @summary Project campaigns
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<ProjectCampaignsStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectCampaigns: async (t, r, n, a, s, i = {}) => {
      Bt("projectCampaigns", "id", t);
      const o = "/projects/{id}/campaigns".replace("{id}", encodeURIComponent(String(t))), l = new URL(o, Qe);
      let c;
      e && (c = e.baseOptions);
      const u = { method: "GET", ...c, ...i }, d = {}, f = {};
      await ot(d, e), r !== void 0 && (f.offset = r), n !== void 0 && (f.limit = n), a && (f.status = a), s !== void 0 && (f.private = s), Je(l, f);
      let h = c && c.headers ? c.headers : {};
      return u.headers = { ...d, ...h, ...i.headers }, {
        url: Ze(l),
        options: u
      };
    },
    /**
     * Number of campaigns for a single project (all if admin, only available for the rest)
     * @summary Project campaigns count
     * @param {number} id 
     * @param {Array<ProjectCampaignsCountStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectCampaignsCount: async (t, r, n, a = {}) => {
      Bt("projectCampaignsCount", "id", t);
      const s = "/projects/{id}/campaigns/count".replace("{id}", encodeURIComponent(String(t))), i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      await ot(c, e), r && (u.status = r), n !== void 0 && (u.private = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * Pagination info for project campaigns
     * @summary Project campaigns pagination info
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<ProjectCampaignsMetaStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectCampaignsMeta: async (t, r, n, a, s, i = {}) => {
      Bt("projectCampaignsMeta", "id", t);
      const o = "/projects/{id}/campaigns/meta".replace("{id}", encodeURIComponent(String(t))), l = new URL(o, Qe);
      let c;
      e && (c = e.baseOptions);
      const u = { method: "GET", ...c, ...i }, d = {}, f = {};
      await ot(d, e), r !== void 0 && (f.offset = r), n !== void 0 && (f.limit = n), a && (f.status = a), s !== void 0 && (f.private = s), Je(l, f);
      let h = c && c.headers ? c.headers : {};
      return u.headers = { ...d, ...h, ...i.headers }, {
        url: Ze(l),
        options: u
      };
    },
    /**
     * List project campaigns with pagination info
     * @summary Project campaigns with pagination info
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<ProjectCampaignsPageStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectCampaignsPage: async (t, r, n, a, s, i = {}) => {
      Bt("projectCampaignsPage", "id", t);
      const o = "/projects/{id}/campaigns/page".replace("{id}", encodeURIComponent(String(t))), l = new URL(o, Qe);
      let c;
      e && (c = e.baseOptions);
      const u = { method: "GET", ...c, ...i }, d = {}, f = {};
      await ot(d, e), r !== void 0 && (f.offset = r), n !== void 0 && (f.limit = n), a && (f.status = a), s !== void 0 && (f.private = s), Je(l, f);
      let h = c && c.headers ? c.headers : {};
      return u.headers = { ...d, ...h, ...i.headers }, {
        url: Ze(l),
        options: u
      };
    },
    /**
     * Get the next project ID (for file upload and file naming purposes)
     * @summary [admin] Project next ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectNextId: async (t = {}) => {
      const r = "/projects/next", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Number of campaigns, batches available, distinct buyers, amount collected and orders of each kind for a project
     * @summary Project statistics
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectStats: async (t, r = {}) => {
      Bt("projectStats", "id", t);
      const n = "/projects/{id}/stats".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {};
      Je(a, {});
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * List projects (all if admin, only public ones for the rest)
     * @summary Projects list
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {boolean} [stats] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projects: async (t, r, n, a = {}) => {
      const s = "/projects", i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      await ot(c, e), t !== void 0 && (u.offset = t), r !== void 0 && (u.limit = r), n !== void 0 && (u.stats = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * Number of projects (all if admin, only public ones for the rest)
     * @summary Projects count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsCount: async (t = {}) => {
      const r = "/projects/count", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Pagination info for the projects endpoint
     * @summary Projects list pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsMeta: async (t, r, n = {}) => {
      const a = "/projects/meta", s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), t !== void 0 && (c.offset = t), r !== void 0 && (c.limit = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * List projects with pagination info 
     * @summary Projects list with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {boolean} [stats] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPage: async (t, r, n, a = {}) => {
      const s = "/projects/page", i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      await ot(c, e), t !== void 0 && (u.offset = t), r !== void 0 && (u.limit = r), n !== void 0 && (u.stats = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * Show the advancement of a given payout
     * @summary [admin] Project payout advancement
     * @param {number} id 
     * @param {string} period 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    showPayout: async (t, r, n = {}) => {
      Bt("showPayout", "id", t), Bt("showPayout", "period", r);
      const a = "/projects/{id}/payout/{period}".replace("{id}", encodeURIComponent(String(t))).replace("{period}", encodeURIComponent(String(r))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Update a project
     * @summary [admin] Project update
     * @param {number} id 
     * @param {Project} [project] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProject: async (t, r, n = {}) => {
      Bt("updateProject", "id", t);
      const a = "/projects/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...n }, l = {}, c = {};
      await ot(l, e), l["Content-Type"] = "application/json", Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, o.data = mn(r, o, e), {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Upload a file for a project
     * @summary [admin] Upload
     * @param {string} filename 
     * @param {File} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upload: async (t, r, n = {}) => {
      Bt("upload", "filename", t);
      const a = "/projects/upload", s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...n }, l = {}, c = {};
      await ot(l, e), t !== void 0 && (c.filename = t), l["Content-Type"] = "application/pdf", Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, o.data = mn(r, o, e), {
        url: Ze(s),
        options: o
      };
    }
  };
}, jn = function(e) {
  const t = v3(e);
  return {
    /**
     * Cities with a project (in case of real estate)
     * @summary Cities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cities(r) {
      var i, o;
      const n = await t.cities(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["ProjectsApi.cities"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Create a project
     * @summary [admin] Project creation
     * @param {Project} [project] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createProject(r, n) {
      var o, l;
      const a = await t.createProject(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["ProjectsApi.createProject"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Delete a project
     * @summary [admin] Project deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteProject(r, n) {
      var o, l;
      const a = await t.deleteProject(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["ProjectsApi.deleteProject"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Execute the payout for a project (for a given period)
     * @summary [admin] Project payout
     * @param {number} id 
     * @param {PayoutRequest} [payoutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async payout(r, n, a) {
      var l, c;
      const s = await t.payout(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["ProjectsApi.payout"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Periods available for a payout
     * @summary [admin] Payout periods
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async payoutPeriods(r, n) {
      var o, l;
      const a = await t.payoutPeriods(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["ProjectsApi.payoutPeriods"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Get a specific project
     * @summary Project
     * @param {number} id 
     * @param {boolean} [stats] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async project(r, n, a) {
      var l, c;
      const s = await t.project(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["ProjectsApi.project"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * List campaigns for a single project (all if admin, only available for the rest)
     * @summary Project campaigns
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<ProjectCampaignsStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectCampaigns(r, n, a, s, i, o) {
      var d, f;
      const l = await t.projectCampaigns(r, n, a, s, i, o), c = (e == null ? void 0 : e.serverIndex) ?? 0, u = (f = (d = Xe["ProjectsApi.projectCampaigns"]) == null ? void 0 : d[c]) == null ? void 0 : f.url;
      return (h, p) => et(l, Be, Ye, e)(h, u || p);
    },
    /**
     * Number of campaigns for a single project (all if admin, only available for the rest)
     * @summary Project campaigns count
     * @param {number} id 
     * @param {Array<ProjectCampaignsCountStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectCampaignsCount(r, n, a, s) {
      var c, u;
      const i = await t.projectCampaignsCount(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["ProjectsApi.projectCampaignsCount"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * Pagination info for project campaigns
     * @summary Project campaigns pagination info
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<ProjectCampaignsMetaStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectCampaignsMeta(r, n, a, s, i, o) {
      var d, f;
      const l = await t.projectCampaignsMeta(r, n, a, s, i, o), c = (e == null ? void 0 : e.serverIndex) ?? 0, u = (f = (d = Xe["ProjectsApi.projectCampaignsMeta"]) == null ? void 0 : d[c]) == null ? void 0 : f.url;
      return (h, p) => et(l, Be, Ye, e)(h, u || p);
    },
    /**
     * List project campaigns with pagination info
     * @summary Project campaigns with pagination info
     * @param {number} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<ProjectCampaignsPageStatusEnum>} [status] campaign status concatenated with a comma
     * @param {boolean} [_private] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectCampaignsPage(r, n, a, s, i, o) {
      var d, f;
      const l = await t.projectCampaignsPage(r, n, a, s, i, o), c = (e == null ? void 0 : e.serverIndex) ?? 0, u = (f = (d = Xe["ProjectsApi.projectCampaignsPage"]) == null ? void 0 : d[c]) == null ? void 0 : f.url;
      return (h, p) => et(l, Be, Ye, e)(h, u || p);
    },
    /**
     * Get the next project ID (for file upload and file naming purposes)
     * @summary [admin] Project next ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectNextId(r) {
      var i, o;
      const n = await t.projectNextId(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["ProjectsApi.projectNextId"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Number of campaigns, batches available, distinct buyers, amount collected and orders of each kind for a project
     * @summary Project statistics
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectStats(r, n) {
      var o, l;
      const a = await t.projectStats(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["ProjectsApi.projectStats"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * List projects (all if admin, only public ones for the rest)
     * @summary Projects list
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {boolean} [stats] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projects(r, n, a, s) {
      var c, u;
      const i = await t.projects(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["ProjectsApi.projects"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * Number of projects (all if admin, only public ones for the rest)
     * @summary Projects count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsCount(r) {
      var i, o;
      const n = await t.projectsCount(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["ProjectsApi.projectsCount"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Pagination info for the projects endpoint
     * @summary Projects list pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsMeta(r, n, a) {
      var l, c;
      const s = await t.projectsMeta(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["ProjectsApi.projectsMeta"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * List projects with pagination info 
     * @summary Projects list with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {boolean} [stats] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsPage(r, n, a, s) {
      var c, u;
      const i = await t.projectsPage(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["ProjectsApi.projectsPage"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * Show the advancement of a given payout
     * @summary [admin] Project payout advancement
     * @param {number} id 
     * @param {string} period 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async showPayout(r, n, a) {
      var l, c;
      const s = await t.showPayout(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["ProjectsApi.showPayout"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Update a project
     * @summary [admin] Project update
     * @param {number} id 
     * @param {Project} [project] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateProject(r, n, a) {
      var l, c;
      const s = await t.updateProject(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["ProjectsApi.updateProject"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Upload a file for a project
     * @summary [admin] Upload
     * @param {string} filename 
     * @param {File} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upload(r, n, a) {
      var l, c;
      const s = await t.upload(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["ProjectsApi.upload"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    }
  };
}, qq = function(e, t, r) {
  const n = jn(e);
  return {
    /**
     * Cities with a project (in case of real estate)
     * @summary Cities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cities(a) {
      return n.cities(a).then((s) => s(r, t));
    },
    /**
     * Create a project
     * @summary [admin] Project creation
     * @param {ProjectsApiCreateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProject(a = {}, s) {
      return n.createProject(a.project, s).then((i) => i(r, t));
    },
    /**
     * Delete a project
     * @summary [admin] Project deletion
     * @param {ProjectsApiDeleteProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProject(a, s) {
      return n.deleteProject(a.id, s).then((i) => i(r, t));
    },
    /**
     * Execute the payout for a project (for a given period)
     * @summary [admin] Project payout
     * @param {ProjectsApiPayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payout(a, s) {
      return n.payout(a.id, a.payoutRequest, s).then((i) => i(r, t));
    },
    /**
     * Periods available for a payout
     * @summary [admin] Payout periods
     * @param {ProjectsApiPayoutPeriodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payoutPeriods(a, s) {
      return n.payoutPeriods(a.id, s).then((i) => i(r, t));
    },
    /**
     * Get a specific project
     * @summary Project
     * @param {ProjectsApiProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    project(a, s) {
      return n.project(a.id, a.stats, s).then((i) => i(r, t));
    },
    /**
     * List campaigns for a single project (all if admin, only available for the rest)
     * @summary Project campaigns
     * @param {ProjectsApiProjectCampaignsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectCampaigns(a, s) {
      return n.projectCampaigns(a.id, a.offset, a.limit, a.status, a._private, s).then((i) => i(r, t));
    },
    /**
     * Number of campaigns for a single project (all if admin, only available for the rest)
     * @summary Project campaigns count
     * @param {ProjectsApiProjectCampaignsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectCampaignsCount(a, s) {
      return n.projectCampaignsCount(a.id, a.status, a._private, s).then((i) => i(r, t));
    },
    /**
     * Pagination info for project campaigns
     * @summary Project campaigns pagination info
     * @param {ProjectsApiProjectCampaignsMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectCampaignsMeta(a, s) {
      return n.projectCampaignsMeta(a.id, a.offset, a.limit, a.status, a._private, s).then((i) => i(r, t));
    },
    /**
     * List project campaigns with pagination info
     * @summary Project campaigns with pagination info
     * @param {ProjectsApiProjectCampaignsPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectCampaignsPage(a, s) {
      return n.projectCampaignsPage(a.id, a.offset, a.limit, a.status, a._private, s).then((i) => i(r, t));
    },
    /**
     * Get the next project ID (for file upload and file naming purposes)
     * @summary [admin] Project next ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectNextId(a) {
      return n.projectNextId(a).then((s) => s(r, t));
    },
    /**
     * Number of campaigns, batches available, distinct buyers, amount collected and orders of each kind for a project
     * @summary Project statistics
     * @param {ProjectsApiProjectStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectStats(a, s) {
      return n.projectStats(a.id, s).then((i) => i(r, t));
    },
    /**
     * List projects (all if admin, only public ones for the rest)
     * @summary Projects list
     * @param {ProjectsApiProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projects(a = {}, s) {
      return n.projects(a.offset, a.limit, a.stats, s).then((i) => i(r, t));
    },
    /**
     * Number of projects (all if admin, only public ones for the rest)
     * @summary Projects count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsCount(a) {
      return n.projectsCount(a).then((s) => s(r, t));
    },
    /**
     * Pagination info for the projects endpoint
     * @summary Projects list pagination info
     * @param {ProjectsApiProjectsMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsMeta(a = {}, s) {
      return n.projectsMeta(a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * List projects with pagination info 
     * @summary Projects list with pagination info
     * @param {ProjectsApiProjectsPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsPage(a = {}, s) {
      return n.projectsPage(a.offset, a.limit, a.stats, s).then((i) => i(r, t));
    },
    /**
     * Show the advancement of a given payout
     * @summary [admin] Project payout advancement
     * @param {ProjectsApiShowPayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    showPayout(a, s) {
      return n.showPayout(a.id, a.period, s).then((i) => i(r, t));
    },
    /**
     * Update a project
     * @summary [admin] Project update
     * @param {ProjectsApiUpdateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProject(a, s) {
      return n.updateProject(a.id, a.project, s).then((i) => i(r, t));
    },
    /**
     * Upload a file for a project
     * @summary [admin] Upload
     * @param {ProjectsApiUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upload(a, s) {
      return n.upload(a.filename, a.body, s).then((i) => i(r, t));
    }
  };
};
class Gq extends $c {
  /**
   * Cities with a project (in case of real estate)
   * @summary Cities
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  cities(t) {
    return jn(this.configuration).cities(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Create a project
   * @summary [admin] Project creation
   * @param {ProjectsApiCreateProjectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  createProject(t = {}, r) {
    return jn(this.configuration).createProject(t.project, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete a project
   * @summary [admin] Project deletion
   * @param {ProjectsApiDeleteProjectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  deleteProject(t, r) {
    return jn(this.configuration).deleteProject(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Execute the payout for a project (for a given period)
   * @summary [admin] Project payout
   * @param {ProjectsApiPayoutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  payout(t, r) {
    return jn(this.configuration).payout(t.id, t.payoutRequest, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Periods available for a payout
   * @summary [admin] Payout periods
   * @param {ProjectsApiPayoutPeriodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  payoutPeriods(t, r) {
    return jn(this.configuration).payoutPeriods(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get a specific project
   * @summary Project
   * @param {ProjectsApiProjectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  project(t, r) {
    return jn(this.configuration).project(t.id, t.stats, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List campaigns for a single project (all if admin, only available for the rest)
   * @summary Project campaigns
   * @param {ProjectsApiProjectCampaignsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  projectCampaigns(t, r) {
    return jn(this.configuration).projectCampaigns(t.id, t.offset, t.limit, t.status, t._private, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number of campaigns for a single project (all if admin, only available for the rest)
   * @summary Project campaigns count
   * @param {ProjectsApiProjectCampaignsCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  projectCampaignsCount(t, r) {
    return jn(this.configuration).projectCampaignsCount(t.id, t.status, t._private, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Pagination info for project campaigns
   * @summary Project campaigns pagination info
   * @param {ProjectsApiProjectCampaignsMetaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  projectCampaignsMeta(t, r) {
    return jn(this.configuration).projectCampaignsMeta(t.id, t.offset, t.limit, t.status, t._private, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List project campaigns with pagination info
   * @summary Project campaigns with pagination info
   * @param {ProjectsApiProjectCampaignsPageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  projectCampaignsPage(t, r) {
    return jn(this.configuration).projectCampaignsPage(t.id, t.offset, t.limit, t.status, t._private, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get the next project ID (for file upload and file naming purposes)
   * @summary [admin] Project next ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  projectNextId(t) {
    return jn(this.configuration).projectNextId(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Number of campaigns, batches available, distinct buyers, amount collected and orders of each kind for a project
   * @summary Project statistics
   * @param {ProjectsApiProjectStatsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  projectStats(t, r) {
    return jn(this.configuration).projectStats(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List projects (all if admin, only public ones for the rest)
   * @summary Projects list
   * @param {ProjectsApiProjectsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  projects(t = {}, r) {
    return jn(this.configuration).projects(t.offset, t.limit, t.stats, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number of projects (all if admin, only public ones for the rest)
   * @summary Projects count
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  projectsCount(t) {
    return jn(this.configuration).projectsCount(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Pagination info for the projects endpoint
   * @summary Projects list pagination info
   * @param {ProjectsApiProjectsMetaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  projectsMeta(t = {}, r) {
    return jn(this.configuration).projectsMeta(t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List projects with pagination info 
   * @summary Projects list with pagination info
   * @param {ProjectsApiProjectsPageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  projectsPage(t = {}, r) {
    return jn(this.configuration).projectsPage(t.offset, t.limit, t.stats, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Show the advancement of a given payout
   * @summary [admin] Project payout advancement
   * @param {ProjectsApiShowPayoutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  showPayout(t, r) {
    return jn(this.configuration).showPayout(t.id, t.period, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Update a project
   * @summary [admin] Project update
   * @param {ProjectsApiUpdateProjectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  updateProject(t, r) {
    return jn(this.configuration).updateProject(t.id, t.project, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Upload a file for a project
   * @summary [admin] Upload
   * @param {ProjectsApiUploadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  upload(t, r) {
    return jn(this.configuration).upload(t.filename, t.body, r).then((n) => n(this.axios, this.basePath));
  }
}
const Yq = {
  Created: "created",
  Available: "available",
  Canceled: "canceled",
  Closed: "closed",
  Minted: "minted"
}, Xq = {
  Created: "created",
  Available: "available",
  Canceled: "canceled",
  Closed: "closed",
  Minted: "minted"
}, Qq = {
  Created: "created",
  Available: "available",
  Canceled: "canceled",
  Closed: "closed",
  Minted: "minted"
}, Jq = {
  Created: "created",
  Available: "available",
  Canceled: "canceled",
  Closed: "closed",
  Minted: "minted"
}, y3 = function(e) {
  return {
    /**
     * Add a user to a specified list
     * @summary [admin] Add user to list
     * @param {number} id 
     * @param {string} list 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addUserList: async (t, r, n = {}) => {
      Bt("addUserList", "id", t), Bt("addUserList", "list", r);
      const a = "/users/{id}/list/{list}".replace("{id}", encodeURIComponent(String(t))).replace("{list}", encodeURIComponent(String(r))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Create a user from its info
     * @summary [admin] User creation
     * @param {CreateUserRequest} [createUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser: async (t, r = {}) => {
      const n = "/users/create", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      await ot(o, e), o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Create a user list
     * @summary [admin] User list creation
     * @param {UserLists200ResponseInner} [userLists200ResponseInner] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUserList: async (t, r = {}) => {
      const n = "/users/list", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      await ot(o, e), o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Delete a user
     * @summary [admin] User deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser: async (t, r = {}) => {
      Bt("deleteUser", "id", t);
      const n = "/users/{id}".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "DELETE", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Delete a user list
     * @summary [admin] User list deletion
     * @param {string} list 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUserList: async (t, r = {}) => {
      Bt("deleteUserList", "list", t);
      const n = "/users/list/{list}".replace("{list}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "DELETE", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Initialize a user
     * @summary User initialization
     * @param {InitializeUserRequest} [initializeUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initializeUser: async (t, r = {}) => {
      const n = "/users/init", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      await ot(o, e), o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Force reset KYC information for a user (only useful if failed)
     * @summary User KYC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kycUser: async (t = {}) => {
      const r = "/users/kyc", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "PUT", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * 
     * @summary link_email
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linkEmail: async (t, r = {}) => {
      Bt("linkEmail", "id", t);
      const n = "/users/{id}/link".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Create a payin request
     * @summary User payin
     * @param {PaymentPayinInfo} [paymentPayinInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payin: async (t, r = {}) => {
      const n = "/users/payin", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      await ot(o, e), o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Remove a user from a specified list
     * @summary [admin] Remove user from list
     * @param {number} id 
     * @param {string} list 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeUserList: async (t, r, n = {}) => {
      Bt("removeUserList", "id", t), Bt("removeUserList", "list", r);
      const a = "/users/{id}/list/{list}".replace("{id}", encodeURIComponent(String(t))).replace("{list}", encodeURIComponent(String(r))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...n }, l = {}, c = {};
      await ot(l, e), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * 
     * @summary send_email
     * @param {SendEmailRequest} [sendEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendEmail: async (t, r = {}) => {
      const n = "/users/email", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      await ot(o, e), o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Get user transactions
     * @summary User transfers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transfers: async (t = {}) => {
      const r = "/users/transfers", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Update user information
     * @summary [admin] User update
     * @param {number} id 
     * @param {UserWithId} [userWithId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser: async (t, r, n = {}) => {
      Bt("updateUser", "id", t);
      const a = "/users/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...n }, l = {}, c = {};
      await ot(l, e), l["Content-Type"] = "application/json", Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, o.data = mn(r, o, e), {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Get user information from its id
     * @summary [admin] User info
     * @param {number} id 
     * @param {boolean} [stats] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    user: async (t, r, n = {}) => {
      Bt("user", "id", t);
      const a = "/users/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), r !== void 0 && (c.stats = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Download the document of a user
     * @summary Document download
     * @param {string} kind 
     * @param {string} signatureId 
     * @param {string} signatureDocumentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userDocumentDownload: async (t, r, n, a = {}) => {
      Bt("userDocumentDownload", "kind", t), Bt("userDocumentDownload", "signatureId", r), Bt("userDocumentDownload", "signatureDocumentId", n);
      const s = "/users/documents/{kind}/{signature_id}/{signature_document_id}".replace("{kind}", encodeURIComponent(String(t))).replace("{signature_id}", encodeURIComponent(String(r))).replace("{signature_document_id}", encodeURIComponent(String(n))), i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {};
      Je(i, {});
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * List user documents
     * @summary User documents
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userDocuments: async (t, r, n = {}) => {
      const a = "/users/documents", s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), t !== void 0 && (c.offset = t), r !== void 0 && (c.limit = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Number of documents of a user
     * @summary User documents count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userDocumentsCount: async (t = {}) => {
      const r = "/users/documents/count", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Pagination info for user documents
     * @summary User documents pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userDocumentsMeta: async (t, r, n = {}) => {
      const a = "/users/documents/meta", s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), t !== void 0 && (c.offset = t), r !== void 0 && (c.limit = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * List user documents with pagination info
     * @summary User documents with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userDocumentsPage: async (t, r, n = {}) => {
      const a = "/users/documents/page", s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), t !== void 0 && (c.offset = t), r !== void 0 && (c.limit = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Get user information
     * @summary User info
     * @param {boolean} [stats] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userInfo: async (t, r = {}) => {
      const n = "/users/info", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "PUT", ...s, ...r }, o = {}, l = {};
      await ot(o, e), t !== void 0 && (l.stats = t), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * User statistics by projects (campaigns, orders, investement)
     * @summary User statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userInfoStats: async (t = {}) => {
      const r = "/users/info/stats", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * List user lists
     * @summary [admin] User lists
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLists: async (t = {}) => {
      const r = "/users/list", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * List orders for a user
     * @summary User orders
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<UserOrdersStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userOrders: async (t, r, n, a = {}) => {
      const s = "/users/orders", i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      await ot(c, e), t !== void 0 && (u.offset = t), r !== void 0 && (u.limit = r), n && (u.status = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * Number of orders for a user
     * @summary User orders count
     * @param {Array<UserOrdersCountStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userOrdersCount: async (t, r = {}) => {
      const n = "/users/orders/count", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {}, l = {};
      await ot(o, e), t && (l.status = t), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Pagination info for user orders
     * @summary User orders pagination info
     * @param {Array<UserOrdersMetaStatusEnum>} [status] order status concatenated with a comma
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userOrdersMeta: async (t, r, n, a = {}) => {
      const s = "/users/orders/meta", i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      await ot(c, e), t && (u.status = t), r !== void 0 && (u.offset = r), n !== void 0 && (u.limit = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * List orders for a user with pagination info
     * @summary User orders with pagination
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<UserOrdersPageStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userOrdersPage: async (t, r, n, a = {}) => {
      const s = "/users/orders/page", i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      await ot(c, e), t !== void 0 && (u.offset = t), r !== void 0 && (u.limit = r), n && (u.status = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * Add payout information for a user
     * @summary User payout
     * @param {PaymentUserPayout} [paymentUserPayout] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userPayout: async (t, r = {}) => {
      const n = "/users/payout", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "POST", ...s, ...r }, o = {}, l = {};
      await ot(o, e), o["Content-Type"] = "application/json", Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, i.data = mn(t, i, e), {
        url: Ze(a),
        options: i
      };
    },
    /**
     * List of projects a user invested in
     * @summary User projects
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<UserProjectsStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userProjects: async (t, r, n, a = {}) => {
      const s = "/users/projects", i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      await ot(c, e), t !== void 0 && (u.offset = t), r !== void 0 && (u.limit = r), n && (u.status = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * Number of projects a user invested in
     * @summary User projects count
     * @param {Array<UserProjectsCountStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userProjectsCount: async (t, r = {}) => {
      const n = "/users/projects/count", a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {}, l = {};
      await ot(o, e), t && (l.status = t), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Pagination info for projects of a user
     * @summary User projects pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userProjectsMeta: async (t, r, n = {}) => {
      const a = "/users/projects/meta", s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), t !== void 0 && (c.offset = t), r !== void 0 && (c.limit = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * List of projects a user invested in with pagination info
     * @summary User projects with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<UserProjectsPageStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userProjectsPage: async (t, r, n, a = {}) => {
      const s = "/users/projects/page", i = new URL(s, Qe);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...a }, c = {}, u = {};
      await ot(c, e), t !== void 0 && (u.offset = t), r !== void 0 && (u.limit = r), n && (u.status = n), Je(i, u);
      let d = o && o.headers ? o.headers : {};
      return l.headers = { ...c, ...d, ...a.headers }, {
        url: Ze(i),
        options: l
      };
    },
    /**
     * User statistics by projects (campaigns, orders, investement)
     * @summary [admin] User statistics
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userStats: async (t, r = {}) => {
      Bt("userStats", "id", t);
      const n = "/users/{id}/stats".replace("{id}", encodeURIComponent(String(t))), a = new URL(n, Qe);
      let s;
      e && (s = e.baseOptions);
      const i = { method: "GET", ...s, ...r }, o = {}, l = {};
      await ot(o, e), Je(a, l);
      let c = s && s.headers ? s.headers : {};
      return i.headers = { ...o, ...c, ...r.headers }, {
        url: Ze(a),
        options: i
      };
    },
    /**
     * Register a vote for a poll from a user
     * @summary User vote
     * @param {number} id 
     * @param {VoteInput} [voteInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userVote: async (t, r, n = {}) => {
      Bt("userVote", "id", t);
      const a = "/users/votes/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "PUT", ...i, ...n }, l = {}, c = {};
      await ot(l, e), l["Content-Type"] = "application/json", Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, o.data = mn(r, o, e), {
        url: Ze(s),
        options: o
      };
    },
    /**
     * List votes for a user
     * @summary User votes
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userVotes: async (t, r, n = {}) => {
      const a = "/users/votes", s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), t !== void 0 && (c.offset = t), r !== void 0 && (c.limit = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * Number of votes of a user
     * @summary User votes count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userVotesCount: async (t = {}) => {
      const r = "/users/votes/count", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * List votes for a user with pagination info
     * @summary User votes with pagination
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userVotesPage: async (t, r, n = {}) => {
      const a = "/users/votes/page", s = new URL(a, Qe);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...n }, l = {}, c = {};
      await ot(l, e), t !== void 0 && (c.offset = t), r !== void 0 && (c.limit = r), Je(s, c);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...n.headers }, {
        url: Ze(s),
        options: o
      };
    },
    /**
     * List users
     * @summary [admin] Users
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {string} [search] 
     * @param {UserStatus} [status] 
     * @param {number} [project] 
     * @param {UsersDirEnum} [dir] 
     * @param {UsersPageSortParameter} [sort] 
     * @param {boolean} [stats] 
     * @param {Array<string>} [lists] lists concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    users: async (t, r, n, a, s, i, o, l, c, u = {}) => {
      const d = "/users", f = new URL(d, Qe);
      let h;
      e && (h = e.baseOptions);
      const p = { method: "GET", ...h, ...u }, m = {}, g = {};
      if (await ot(m, e), t !== void 0 && (g.offset = t), r !== void 0 && (g.limit = r), n !== void 0 && (g.search = n), a !== void 0 && (g.status = a), s !== void 0 && (g.project = s), i !== void 0 && (g.dir = i), o !== void 0)
        for (const [x, w] of Object.entries(o))
          g[x] = w;
      l !== void 0 && (g.stats = l), c && (g.lists = c), Je(f, g);
      let y = h && h.headers ? h.headers : {};
      return p.headers = { ...m, ...y, ...u.headers }, {
        url: Ze(f),
        options: p
      };
    },
    /**
     * Number of users
     * @summary [admin] Users count
     * @param {UserStatus} [status] 
     * @param {string} [search] 
     * @param {number} [project] 
     * @param {Array<string>} [lists] lists concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersCount: async (t, r, n, a, s = {}) => {
      const i = "/users/count", o = new URL(i, Qe);
      let l;
      e && (l = e.baseOptions);
      const c = { method: "GET", ...l, ...s }, u = {}, d = {};
      await ot(u, e), t !== void 0 && (d.status = t), r !== void 0 && (d.search = r), n !== void 0 && (d.project = n), a && (d.lists = a), Je(o, d);
      let f = l && l.headers ? l.headers : {};
      return c.headers = { ...u, ...f, ...s.headers }, {
        url: Ze(o),
        options: c
      };
    },
    /**
     * Pagination info for users
     * @summary [admin] Users pagination info
     * @param {UserStatus} [status] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {number} [project] 
     * @param {string} [search] 
     * @param {Array<string>} [lists] lists concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMeta: async (t, r, n, a, s, i, o = {}) => {
      const l = "/users/meta", c = new URL(l, Qe);
      let u;
      e && (u = e.baseOptions);
      const d = { method: "GET", ...u, ...o }, f = {}, h = {};
      await ot(f, e), t !== void 0 && (h.status = t), r !== void 0 && (h.offset = r), n !== void 0 && (h.limit = n), a !== void 0 && (h.project = a), s !== void 0 && (h.search = s), i && (h.lists = i), Je(c, h);
      let p = u && u.headers ? u.headers : {};
      return d.headers = { ...f, ...p, ...o.headers }, {
        url: Ze(c),
        options: d
      };
    },
    /**
     * List users with pagination info
     * @summary [admin] Users with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {string} [search] 
     * @param {UserStatus} [status] 
     * @param {number} [project] 
     * @param {UsersPageDirEnum} [dir] 
     * @param {UsersPageSortParameter} [sort] 
     * @param {boolean} [stats] 
     * @param {Array<string>} [lists] lists concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersPage: async (t, r, n, a, s, i, o, l, c, u = {}) => {
      const d = "/users/page", f = new URL(d, Qe);
      let h;
      e && (h = e.baseOptions);
      const p = { method: "GET", ...h, ...u }, m = {}, g = {};
      if (await ot(m, e), t !== void 0 && (g.offset = t), r !== void 0 && (g.limit = r), n !== void 0 && (g.search = n), a !== void 0 && (g.status = a), s !== void 0 && (g.project = s), i !== void 0 && (g.dir = i), o !== void 0)
        for (const [x, w] of Object.entries(o))
          g[x] = w;
      l !== void 0 && (g.stats = l), c && (g.lists = c), Je(f, g);
      let y = h && h.headers ? h.headers : {};
      return p.headers = { ...m, ...y, ...u.headers }, {
        url: Ze(f),
        options: p
      };
    },
    /**
     * Users statistics by status
     * @summary [admin] Users statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersStats: async (t = {}) => {
      const r = "/users/stats", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    },
    /**
     * Get user wallet
     * @summary User wallet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    wallet: async (t = {}) => {
      const r = "/users/wallet", n = new URL(r, Qe);
      let a;
      e && (a = e.baseOptions);
      const s = { method: "GET", ...a, ...t }, i = {}, o = {};
      await ot(i, e), Je(n, o);
      let l = a && a.headers ? a.headers : {};
      return s.headers = { ...i, ...l, ...t.headers }, {
        url: Ze(n),
        options: s
      };
    }
  };
}, Zt = function(e) {
  const t = y3(e);
  return {
    /**
     * Add a user to a specified list
     * @summary [admin] Add user to list
     * @param {number} id 
     * @param {string} list 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addUserList(r, n, a) {
      var l, c;
      const s = await t.addUserList(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["UsersApi.addUserList"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Create a user from its info
     * @summary [admin] User creation
     * @param {CreateUserRequest} [createUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createUser(r, n) {
      var o, l;
      const a = await t.createUser(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["UsersApi.createUser"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Create a user list
     * @summary [admin] User list creation
     * @param {UserLists200ResponseInner} [userLists200ResponseInner] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createUserList(r, n) {
      var o, l;
      const a = await t.createUserList(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["UsersApi.createUserList"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Delete a user
     * @summary [admin] User deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteUser(r, n) {
      var o, l;
      const a = await t.deleteUser(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["UsersApi.deleteUser"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Delete a user list
     * @summary [admin] User list deletion
     * @param {string} list 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteUserList(r, n) {
      var o, l;
      const a = await t.deleteUserList(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["UsersApi.deleteUserList"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Initialize a user
     * @summary User initialization
     * @param {InitializeUserRequest} [initializeUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initializeUser(r, n) {
      var o, l;
      const a = await t.initializeUser(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["UsersApi.initializeUser"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Force reset KYC information for a user (only useful if failed)
     * @summary User KYC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async kycUser(r) {
      var i, o;
      const n = await t.kycUser(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["UsersApi.kycUser"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * 
     * @summary link_email
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async linkEmail(r, n) {
      var o, l;
      const a = await t.linkEmail(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["UsersApi.linkEmail"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Create a payin request
     * @summary User payin
     * @param {PaymentPayinInfo} [paymentPayinInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async payin(r, n) {
      var o, l;
      const a = await t.payin(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["UsersApi.payin"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Remove a user from a specified list
     * @summary [admin] Remove user from list
     * @param {number} id 
     * @param {string} list 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeUserList(r, n, a) {
      var l, c;
      const s = await t.removeUserList(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["UsersApi.removeUserList"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * 
     * @summary send_email
     * @param {SendEmailRequest} [sendEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendEmail(r, n) {
      var o, l;
      const a = await t.sendEmail(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["UsersApi.sendEmail"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Get user transactions
     * @summary User transfers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transfers(r) {
      var i, o;
      const n = await t.transfers(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["UsersApi.transfers"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Update user information
     * @summary [admin] User update
     * @param {number} id 
     * @param {UserWithId} [userWithId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateUser(r, n, a) {
      var l, c;
      const s = await t.updateUser(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["UsersApi.updateUser"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Get user information from its id
     * @summary [admin] User info
     * @param {number} id 
     * @param {boolean} [stats] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async user(r, n, a) {
      var l, c;
      const s = await t.user(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["UsersApi.user"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Download the document of a user
     * @summary Document download
     * @param {string} kind 
     * @param {string} signatureId 
     * @param {string} signatureDocumentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userDocumentDownload(r, n, a, s) {
      var c, u;
      const i = await t.userDocumentDownload(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["UsersApi.userDocumentDownload"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * List user documents
     * @summary User documents
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userDocuments(r, n, a) {
      var l, c;
      const s = await t.userDocuments(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["UsersApi.userDocuments"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Number of documents of a user
     * @summary User documents count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userDocumentsCount(r) {
      var i, o;
      const n = await t.userDocumentsCount(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["UsersApi.userDocumentsCount"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Pagination info for user documents
     * @summary User documents pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userDocumentsMeta(r, n, a) {
      var l, c;
      const s = await t.userDocumentsMeta(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["UsersApi.userDocumentsMeta"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * List user documents with pagination info
     * @summary User documents with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userDocumentsPage(r, n, a) {
      var l, c;
      const s = await t.userDocumentsPage(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["UsersApi.userDocumentsPage"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Get user information
     * @summary User info
     * @param {boolean} [stats] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userInfo(r, n) {
      var o, l;
      const a = await t.userInfo(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["UsersApi.userInfo"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * User statistics by projects (campaigns, orders, investement)
     * @summary User statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userInfoStats(r) {
      var i, o;
      const n = await t.userInfoStats(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["UsersApi.userInfoStats"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * List user lists
     * @summary [admin] User lists
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userLists(r) {
      var i, o;
      const n = await t.userLists(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["UsersApi.userLists"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * List orders for a user
     * @summary User orders
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<UserOrdersStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userOrders(r, n, a, s) {
      var c, u;
      const i = await t.userOrders(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["UsersApi.userOrders"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * Number of orders for a user
     * @summary User orders count
     * @param {Array<UserOrdersCountStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userOrdersCount(r, n) {
      var o, l;
      const a = await t.userOrdersCount(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["UsersApi.userOrdersCount"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Pagination info for user orders
     * @summary User orders pagination info
     * @param {Array<UserOrdersMetaStatusEnum>} [status] order status concatenated with a comma
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userOrdersMeta(r, n, a, s) {
      var c, u;
      const i = await t.userOrdersMeta(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["UsersApi.userOrdersMeta"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * List orders for a user with pagination info
     * @summary User orders with pagination
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<UserOrdersPageStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userOrdersPage(r, n, a, s) {
      var c, u;
      const i = await t.userOrdersPage(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["UsersApi.userOrdersPage"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * Add payout information for a user
     * @summary User payout
     * @param {PaymentUserPayout} [paymentUserPayout] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userPayout(r, n) {
      var o, l;
      const a = await t.userPayout(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["UsersApi.userPayout"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * List of projects a user invested in
     * @summary User projects
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<UserProjectsStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userProjects(r, n, a, s) {
      var c, u;
      const i = await t.userProjects(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["UsersApi.userProjects"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * Number of projects a user invested in
     * @summary User projects count
     * @param {Array<UserProjectsCountStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userProjectsCount(r, n) {
      var o, l;
      const a = await t.userProjectsCount(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["UsersApi.userProjectsCount"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Pagination info for projects of a user
     * @summary User projects pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userProjectsMeta(r, n, a) {
      var l, c;
      const s = await t.userProjectsMeta(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["UsersApi.userProjectsMeta"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * List of projects a user invested in with pagination info
     * @summary User projects with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {Array<UserProjectsPageStatusEnum>} [status] order status concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userProjectsPage(r, n, a, s) {
      var c, u;
      const i = await t.userProjectsPage(r, n, a, s), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (u = (c = Xe["UsersApi.userProjectsPage"]) == null ? void 0 : c[o]) == null ? void 0 : u.url;
      return (d, f) => et(i, Be, Ye, e)(d, l || f);
    },
    /**
     * User statistics by projects (campaigns, orders, investement)
     * @summary [admin] User statistics
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userStats(r, n) {
      var o, l;
      const a = await t.userStats(r, n), s = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Xe["UsersApi.userStats"]) == null ? void 0 : o[s]) == null ? void 0 : l.url;
      return (c, u) => et(a, Be, Ye, e)(c, i || u);
    },
    /**
     * Register a vote for a poll from a user
     * @summary User vote
     * @param {number} id 
     * @param {VoteInput} [voteInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userVote(r, n, a) {
      var l, c;
      const s = await t.userVote(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["UsersApi.userVote"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * List votes for a user
     * @summary User votes
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userVotes(r, n, a) {
      var l, c;
      const s = await t.userVotes(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["UsersApi.userVotes"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * Number of votes of a user
     * @summary User votes count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userVotesCount(r) {
      var i, o;
      const n = await t.userVotesCount(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["UsersApi.userVotesCount"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * List votes for a user with pagination info
     * @summary User votes with pagination
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userVotesPage(r, n, a) {
      var l, c;
      const s = await t.userVotesPage(r, n, a), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (c = (l = Xe["UsersApi.userVotesPage"]) == null ? void 0 : l[i]) == null ? void 0 : c.url;
      return (u, d) => et(s, Be, Ye, e)(u, o || d);
    },
    /**
     * List users
     * @summary [admin] Users
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {string} [search] 
     * @param {UserStatus} [status] 
     * @param {number} [project] 
     * @param {UsersDirEnum} [dir] 
     * @param {UsersPageSortParameter} [sort] 
     * @param {boolean} [stats] 
     * @param {Array<string>} [lists] lists concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async users(r, n, a, s, i, o, l, c, u, d) {
      var m, g;
      const f = await t.users(r, n, a, s, i, o, l, c, u, d), h = (e == null ? void 0 : e.serverIndex) ?? 0, p = (g = (m = Xe["UsersApi.users"]) == null ? void 0 : m[h]) == null ? void 0 : g.url;
      return (y, x) => et(f, Be, Ye, e)(y, p || x);
    },
    /**
     * Number of users
     * @summary [admin] Users count
     * @param {UserStatus} [status] 
     * @param {string} [search] 
     * @param {number} [project] 
     * @param {Array<string>} [lists] lists concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersCount(r, n, a, s, i) {
      var u, d;
      const o = await t.usersCount(r, n, a, s, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, c = (d = (u = Xe["UsersApi.usersCount"]) == null ? void 0 : u[l]) == null ? void 0 : d.url;
      return (f, h) => et(o, Be, Ye, e)(f, c || h);
    },
    /**
     * Pagination info for users
     * @summary [admin] Users pagination info
     * @param {UserStatus} [status] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {number} [project] 
     * @param {string} [search] 
     * @param {Array<string>} [lists] lists concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersMeta(r, n, a, s, i, o, l) {
      var f, h;
      const c = await t.usersMeta(r, n, a, s, i, o, l), u = (e == null ? void 0 : e.serverIndex) ?? 0, d = (h = (f = Xe["UsersApi.usersMeta"]) == null ? void 0 : f[u]) == null ? void 0 : h.url;
      return (p, m) => et(c, Be, Ye, e)(p, d || m);
    },
    /**
     * List users with pagination info
     * @summary [admin] Users with pagination info
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {string} [search] 
     * @param {UserStatus} [status] 
     * @param {number} [project] 
     * @param {UsersPageDirEnum} [dir] 
     * @param {UsersPageSortParameter} [sort] 
     * @param {boolean} [stats] 
     * @param {Array<string>} [lists] lists concatenated with a comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersPage(r, n, a, s, i, o, l, c, u, d) {
      var m, g;
      const f = await t.usersPage(r, n, a, s, i, o, l, c, u, d), h = (e == null ? void 0 : e.serverIndex) ?? 0, p = (g = (m = Xe["UsersApi.usersPage"]) == null ? void 0 : m[h]) == null ? void 0 : g.url;
      return (y, x) => et(f, Be, Ye, e)(y, p || x);
    },
    /**
     * Users statistics by status
     * @summary [admin] Users statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersStats(r) {
      var i, o;
      const n = await t.usersStats(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["UsersApi.usersStats"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    },
    /**
     * Get user wallet
     * @summary User wallet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async wallet(r) {
      var i, o;
      const n = await t.wallet(r), a = (e == null ? void 0 : e.serverIndex) ?? 0, s = (o = (i = Xe["UsersApi.wallet"]) == null ? void 0 : i[a]) == null ? void 0 : o.url;
      return (l, c) => et(n, Be, Ye, e)(l, s || c);
    }
  };
}, Zq = function(e, t, r) {
  const n = Zt(e);
  return {
    /**
     * Add a user to a specified list
     * @summary [admin] Add user to list
     * @param {UsersApiAddUserListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addUserList(a, s) {
      return n.addUserList(a.id, a.list, s).then((i) => i(r, t));
    },
    /**
     * Create a user from its info
     * @summary [admin] User creation
     * @param {UsersApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser(a = {}, s) {
      return n.createUser(a.createUserRequest, s).then((i) => i(r, t));
    },
    /**
     * Create a user list
     * @summary [admin] User list creation
     * @param {UsersApiCreateUserListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUserList(a = {}, s) {
      return n.createUserList(a.userLists200ResponseInner, s).then((i) => i(r, t));
    },
    /**
     * Delete a user
     * @summary [admin] User deletion
     * @param {UsersApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(a, s) {
      return n.deleteUser(a.id, s).then((i) => i(r, t));
    },
    /**
     * Delete a user list
     * @summary [admin] User list deletion
     * @param {UsersApiDeleteUserListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUserList(a, s) {
      return n.deleteUserList(a.list, s).then((i) => i(r, t));
    },
    /**
     * Initialize a user
     * @summary User initialization
     * @param {UsersApiInitializeUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initializeUser(a = {}, s) {
      return n.initializeUser(a.initializeUserRequest, s).then((i) => i(r, t));
    },
    /**
     * Force reset KYC information for a user (only useful if failed)
     * @summary User KYC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kycUser(a) {
      return n.kycUser(a).then((s) => s(r, t));
    },
    /**
     * 
     * @summary link_email
     * @param {UsersApiLinkEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linkEmail(a, s) {
      return n.linkEmail(a.id, s).then((i) => i(r, t));
    },
    /**
     * Create a payin request
     * @summary User payin
     * @param {UsersApiPayinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payin(a = {}, s) {
      return n.payin(a.paymentPayinInfo, s).then((i) => i(r, t));
    },
    /**
     * Remove a user from a specified list
     * @summary [admin] Remove user from list
     * @param {UsersApiRemoveUserListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeUserList(a, s) {
      return n.removeUserList(a.id, a.list, s).then((i) => i(r, t));
    },
    /**
     * 
     * @summary send_email
     * @param {UsersApiSendEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendEmail(a = {}, s) {
      return n.sendEmail(a.sendEmailRequest, s).then((i) => i(r, t));
    },
    /**
     * Get user transactions
     * @summary User transfers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transfers(a) {
      return n.transfers(a).then((s) => s(r, t));
    },
    /**
     * Update user information
     * @summary [admin] User update
     * @param {UsersApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(a, s) {
      return n.updateUser(a.id, a.userWithId, s).then((i) => i(r, t));
    },
    /**
     * Get user information from its id
     * @summary [admin] User info
     * @param {UsersApiUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    user(a, s) {
      return n.user(a.id, a.stats, s).then((i) => i(r, t));
    },
    /**
     * Download the document of a user
     * @summary Document download
     * @param {UsersApiUserDocumentDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userDocumentDownload(a, s) {
      return n.userDocumentDownload(a.kind, a.signatureId, a.signatureDocumentId, s).then((i) => i(r, t));
    },
    /**
     * List user documents
     * @summary User documents
     * @param {UsersApiUserDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userDocuments(a = {}, s) {
      return n.userDocuments(a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * Number of documents of a user
     * @summary User documents count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userDocumentsCount(a) {
      return n.userDocumentsCount(a).then((s) => s(r, t));
    },
    /**
     * Pagination info for user documents
     * @summary User documents pagination info
     * @param {UsersApiUserDocumentsMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userDocumentsMeta(a = {}, s) {
      return n.userDocumentsMeta(a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * List user documents with pagination info
     * @summary User documents with pagination info
     * @param {UsersApiUserDocumentsPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userDocumentsPage(a = {}, s) {
      return n.userDocumentsPage(a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * Get user information
     * @summary User info
     * @param {UsersApiUserInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userInfo(a = {}, s) {
      return n.userInfo(a.stats, s).then((i) => i(r, t));
    },
    /**
     * User statistics by projects (campaigns, orders, investement)
     * @summary User statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userInfoStats(a) {
      return n.userInfoStats(a).then((s) => s(r, t));
    },
    /**
     * List user lists
     * @summary [admin] User lists
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userLists(a) {
      return n.userLists(a).then((s) => s(r, t));
    },
    /**
     * List orders for a user
     * @summary User orders
     * @param {UsersApiUserOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userOrders(a = {}, s) {
      return n.userOrders(a.offset, a.limit, a.status, s).then((i) => i(r, t));
    },
    /**
     * Number of orders for a user
     * @summary User orders count
     * @param {UsersApiUserOrdersCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userOrdersCount(a = {}, s) {
      return n.userOrdersCount(a.status, s).then((i) => i(r, t));
    },
    /**
     * Pagination info for user orders
     * @summary User orders pagination info
     * @param {UsersApiUserOrdersMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userOrdersMeta(a = {}, s) {
      return n.userOrdersMeta(a.status, a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * List orders for a user with pagination info
     * @summary User orders with pagination
     * @param {UsersApiUserOrdersPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userOrdersPage(a = {}, s) {
      return n.userOrdersPage(a.offset, a.limit, a.status, s).then((i) => i(r, t));
    },
    /**
     * Add payout information for a user
     * @summary User payout
     * @param {UsersApiUserPayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userPayout(a = {}, s) {
      return n.userPayout(a.paymentUserPayout, s).then((i) => i(r, t));
    },
    /**
     * List of projects a user invested in
     * @summary User projects
     * @param {UsersApiUserProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userProjects(a = {}, s) {
      return n.userProjects(a.offset, a.limit, a.status, s).then((i) => i(r, t));
    },
    /**
     * Number of projects a user invested in
     * @summary User projects count
     * @param {UsersApiUserProjectsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userProjectsCount(a = {}, s) {
      return n.userProjectsCount(a.status, s).then((i) => i(r, t));
    },
    /**
     * Pagination info for projects of a user
     * @summary User projects pagination info
     * @param {UsersApiUserProjectsMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userProjectsMeta(a = {}, s) {
      return n.userProjectsMeta(a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * List of projects a user invested in with pagination info
     * @summary User projects with pagination info
     * @param {UsersApiUserProjectsPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userProjectsPage(a = {}, s) {
      return n.userProjectsPage(a.offset, a.limit, a.status, s).then((i) => i(r, t));
    },
    /**
     * User statistics by projects (campaigns, orders, investement)
     * @summary [admin] User statistics
     * @param {UsersApiUserStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userStats(a, s) {
      return n.userStats(a.id, s).then((i) => i(r, t));
    },
    /**
     * Register a vote for a poll from a user
     * @summary User vote
     * @param {UsersApiUserVoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userVote(a, s) {
      return n.userVote(a.id, a.voteInput, s).then((i) => i(r, t));
    },
    /**
     * List votes for a user
     * @summary User votes
     * @param {UsersApiUserVotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userVotes(a = {}, s) {
      return n.userVotes(a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * Number of votes of a user
     * @summary User votes count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userVotesCount(a) {
      return n.userVotesCount(a).then((s) => s(r, t));
    },
    /**
     * List votes for a user with pagination info
     * @summary User votes with pagination
     * @param {UsersApiUserVotesPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userVotesPage(a = {}, s) {
      return n.userVotesPage(a.offset, a.limit, s).then((i) => i(r, t));
    },
    /**
     * List users
     * @summary [admin] Users
     * @param {UsersApiUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    users(a = {}, s) {
      return n.users(a.offset, a.limit, a.search, a.status, a.project, a.dir, a.sort, a.stats, a.lists, s).then((i) => i(r, t));
    },
    /**
     * Number of users
     * @summary [admin] Users count
     * @param {UsersApiUsersCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersCount(a = {}, s) {
      return n.usersCount(a.status, a.search, a.project, a.lists, s).then((i) => i(r, t));
    },
    /**
     * Pagination info for users
     * @summary [admin] Users pagination info
     * @param {UsersApiUsersMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMeta(a = {}, s) {
      return n.usersMeta(a.status, a.offset, a.limit, a.project, a.search, a.lists, s).then((i) => i(r, t));
    },
    /**
     * List users with pagination info
     * @summary [admin] Users with pagination info
     * @param {UsersApiUsersPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersPage(a = {}, s) {
      return n.usersPage(a.offset, a.limit, a.search, a.status, a.project, a.dir, a.sort, a.stats, a.lists, s).then((i) => i(r, t));
    },
    /**
     * Users statistics by status
     * @summary [admin] Users statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersStats(a) {
      return n.usersStats(a).then((s) => s(r, t));
    },
    /**
     * Get user wallet
     * @summary User wallet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    wallet(a) {
      return n.wallet(a).then((s) => s(r, t));
    }
  };
};
class eG extends $c {
  /**
   * Add a user to a specified list
   * @summary [admin] Add user to list
   * @param {UsersApiAddUserListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  addUserList(t, r) {
    return Zt(this.configuration).addUserList(t.id, t.list, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Create a user from its info
   * @summary [admin] User creation
   * @param {UsersApiCreateUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  createUser(t = {}, r) {
    return Zt(this.configuration).createUser(t.createUserRequest, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Create a user list
   * @summary [admin] User list creation
   * @param {UsersApiCreateUserListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  createUserList(t = {}, r) {
    return Zt(this.configuration).createUserList(t.userLists200ResponseInner, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete a user
   * @summary [admin] User deletion
   * @param {UsersApiDeleteUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  deleteUser(t, r) {
    return Zt(this.configuration).deleteUser(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete a user list
   * @summary [admin] User list deletion
   * @param {UsersApiDeleteUserListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  deleteUserList(t, r) {
    return Zt(this.configuration).deleteUserList(t.list, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Initialize a user
   * @summary User initialization
   * @param {UsersApiInitializeUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  initializeUser(t = {}, r) {
    return Zt(this.configuration).initializeUser(t.initializeUserRequest, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Force reset KYC information for a user (only useful if failed)
   * @summary User KYC
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  kycUser(t) {
    return Zt(this.configuration).kycUser(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary link_email
   * @param {UsersApiLinkEmailRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  linkEmail(t, r) {
    return Zt(this.configuration).linkEmail(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Create a payin request
   * @summary User payin
   * @param {UsersApiPayinRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  payin(t = {}, r) {
    return Zt(this.configuration).payin(t.paymentPayinInfo, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Remove a user from a specified list
   * @summary [admin] Remove user from list
   * @param {UsersApiRemoveUserListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  removeUserList(t, r) {
    return Zt(this.configuration).removeUserList(t.id, t.list, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @summary send_email
   * @param {UsersApiSendEmailRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  sendEmail(t = {}, r) {
    return Zt(this.configuration).sendEmail(t.sendEmailRequest, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get user transactions
   * @summary User transfers
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  transfers(t) {
    return Zt(this.configuration).transfers(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Update user information
   * @summary [admin] User update
   * @param {UsersApiUpdateUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  updateUser(t, r) {
    return Zt(this.configuration).updateUser(t.id, t.userWithId, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get user information from its id
   * @summary [admin] User info
   * @param {UsersApiUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  user(t, r) {
    return Zt(this.configuration).user(t.id, t.stats, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Download the document of a user
   * @summary Document download
   * @param {UsersApiUserDocumentDownloadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userDocumentDownload(t, r) {
    return Zt(this.configuration).userDocumentDownload(t.kind, t.signatureId, t.signatureDocumentId, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List user documents
   * @summary User documents
   * @param {UsersApiUserDocumentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userDocuments(t = {}, r) {
    return Zt(this.configuration).userDocuments(t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number of documents of a user
   * @summary User documents count
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userDocumentsCount(t) {
    return Zt(this.configuration).userDocumentsCount(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Pagination info for user documents
   * @summary User documents pagination info
   * @param {UsersApiUserDocumentsMetaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userDocumentsMeta(t = {}, r) {
    return Zt(this.configuration).userDocumentsMeta(t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List user documents with pagination info
   * @summary User documents with pagination info
   * @param {UsersApiUserDocumentsPageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userDocumentsPage(t = {}, r) {
    return Zt(this.configuration).userDocumentsPage(t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get user information
   * @summary User info
   * @param {UsersApiUserInfoRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userInfo(t = {}, r) {
    return Zt(this.configuration).userInfo(t.stats, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * User statistics by projects (campaigns, orders, investement)
   * @summary User statistics
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userInfoStats(t) {
    return Zt(this.configuration).userInfoStats(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * List user lists
   * @summary [admin] User lists
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userLists(t) {
    return Zt(this.configuration).userLists(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * List orders for a user
   * @summary User orders
   * @param {UsersApiUserOrdersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userOrders(t = {}, r) {
    return Zt(this.configuration).userOrders(t.offset, t.limit, t.status, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number of orders for a user
   * @summary User orders count
   * @param {UsersApiUserOrdersCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userOrdersCount(t = {}, r) {
    return Zt(this.configuration).userOrdersCount(t.status, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Pagination info for user orders
   * @summary User orders pagination info
   * @param {UsersApiUserOrdersMetaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userOrdersMeta(t = {}, r) {
    return Zt(this.configuration).userOrdersMeta(t.status, t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List orders for a user with pagination info
   * @summary User orders with pagination
   * @param {UsersApiUserOrdersPageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userOrdersPage(t = {}, r) {
    return Zt(this.configuration).userOrdersPage(t.offset, t.limit, t.status, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Add payout information for a user
   * @summary User payout
   * @param {UsersApiUserPayoutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userPayout(t = {}, r) {
    return Zt(this.configuration).userPayout(t.paymentUserPayout, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List of projects a user invested in
   * @summary User projects
   * @param {UsersApiUserProjectsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userProjects(t = {}, r) {
    return Zt(this.configuration).userProjects(t.offset, t.limit, t.status, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number of projects a user invested in
   * @summary User projects count
   * @param {UsersApiUserProjectsCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userProjectsCount(t = {}, r) {
    return Zt(this.configuration).userProjectsCount(t.status, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Pagination info for projects of a user
   * @summary User projects pagination info
   * @param {UsersApiUserProjectsMetaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userProjectsMeta(t = {}, r) {
    return Zt(this.configuration).userProjectsMeta(t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List of projects a user invested in with pagination info
   * @summary User projects with pagination info
   * @param {UsersApiUserProjectsPageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userProjectsPage(t = {}, r) {
    return Zt(this.configuration).userProjectsPage(t.offset, t.limit, t.status, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * User statistics by projects (campaigns, orders, investement)
   * @summary [admin] User statistics
   * @param {UsersApiUserStatsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userStats(t, r) {
    return Zt(this.configuration).userStats(t.id, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Register a vote for a poll from a user
   * @summary User vote
   * @param {UsersApiUserVoteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userVote(t, r) {
    return Zt(this.configuration).userVote(t.id, t.voteInput, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List votes for a user
   * @summary User votes
   * @param {UsersApiUserVotesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userVotes(t = {}, r) {
    return Zt(this.configuration).userVotes(t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number of votes of a user
   * @summary User votes count
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userVotesCount(t) {
    return Zt(this.configuration).userVotesCount(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * List votes for a user with pagination info
   * @summary User votes with pagination
   * @param {UsersApiUserVotesPageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  userVotesPage(t = {}, r) {
    return Zt(this.configuration).userVotesPage(t.offset, t.limit, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List users
   * @summary [admin] Users
   * @param {UsersApiUsersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  users(t = {}, r) {
    return Zt(this.configuration).users(t.offset, t.limit, t.search, t.status, t.project, t.dir, t.sort, t.stats, t.lists, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Number of users
   * @summary [admin] Users count
   * @param {UsersApiUsersCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  usersCount(t = {}, r) {
    return Zt(this.configuration).usersCount(t.status, t.search, t.project, t.lists, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Pagination info for users
   * @summary [admin] Users pagination info
   * @param {UsersApiUsersMetaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  usersMeta(t = {}, r) {
    return Zt(this.configuration).usersMeta(t.status, t.offset, t.limit, t.project, t.search, t.lists, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * List users with pagination info
   * @summary [admin] Users with pagination info
   * @param {UsersApiUsersPageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  usersPage(t = {}, r) {
    return Zt(this.configuration).usersPage(t.offset, t.limit, t.search, t.status, t.project, t.dir, t.sort, t.stats, t.lists, r).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Users statistics by status
   * @summary [admin] Users statistics
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  usersStats(t) {
    return Zt(this.configuration).usersStats(t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Get user wallet
   * @summary User wallet
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  wallet(t) {
    return Zt(this.configuration).wallet(t).then((r) => r(this.axios, this.basePath));
  }
}
const tG = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, rG = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, nG = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, aG = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, sG = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, iG = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, oG = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, lG = {
  Asc: "asc",
  Desc: "desc"
}, eE = {
  Asc: "asc",
  Desc: "desc"
}, cG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AdminApi: Cq,
  AdminApiAxiosParamCreator: d3,
  AdminApiFactory: Tq,
  AdminApiFp: ho,
  CampaignOrdersCountStatusEnum: Pq,
  CampaignOrdersMetaStatusEnum: Rq,
  CampaignOrdersPageStatusEnum: Iq,
  CampaignOrdersStatusEnum: Aq,
  CampaignsApi: Oq,
  CampaignsApiAxiosParamCreator: f3,
  CampaignsApiFactory: kq,
  CampaignsApiFp: Ln,
  CampaignsCountStatusEnum: Dq,
  CampaignsMetaStatusEnum: Nq,
  CampaignsPageStatusEnum: ns,
  CampaignsStatusEnum: Nr,
  DataApi: Lq,
  DataApiAxiosParamCreator: h3,
  DataApiFactory: Mq,
  DataApiFp: po,
  HooksApi: Fq,
  HooksApiAxiosParamCreator: p3,
  HooksApiFactory: jq,
  HooksApiFp: om,
  OrdersApi: Uq,
  OrdersApiAxiosParamCreator: m3,
  OrdersApiFactory: Bq,
  OrdersApiFp: Ds,
  OrdersCountStatusEnum: $q,
  OrdersMetaStatusEnum: Hq,
  OrdersPageStatusEnum: Wq,
  OrdersStatusEnum: Vq,
  PollsApi: Kq,
  PollsApiAxiosParamCreator: g3,
  PollsApiFactory: zq,
  PollsApiFp: Ns,
  ProjectCampaignsCountStatusEnum: Xq,
  ProjectCampaignsMetaStatusEnum: Qq,
  ProjectCampaignsPageStatusEnum: Jq,
  ProjectCampaignsStatusEnum: Yq,
  ProjectsApi: Gq,
  ProjectsApiAxiosParamCreator: v3,
  ProjectsApiFactory: qq,
  ProjectsApiFp: jn,
  UserOrdersCountStatusEnum: rG,
  UserOrdersMetaStatusEnum: nG,
  UserOrdersPageStatusEnum: aG,
  UserOrdersStatusEnum: tG,
  UserProjectsCountStatusEnum: iG,
  UserProjectsPageStatusEnum: oG,
  UserProjectsStatusEnum: sG,
  UsersApi: eG,
  UsersApiAxiosParamCreator: y3,
  UsersApiFactory: Zq,
  UsersApiFp: Zt,
  UsersDirEnum: lG,
  UsersPageDirEnum: eE
}, Symbol.toStringTag, { value: "Module" })), S1 = new ed();
class uG {
  constructor(t) {
    Fe(this, "apiInstances");
    Fe(this, "adminApi", {
      addTenant: (t, r) => this.executeRequest("AdminApi", "addTenant", t, r),
      config: (t, r) => this.executeRequest("AdminApi", "config", t, r),
      info: (t, r) => this.executeRequest("AdminApi", "info", t, r),
      initialize: (t, r) => this.executeRequest("AdminApi", "initialize", t, r),
      openapi: (t, r) => this.executeRequest("AdminApi", "openapi", t, r),
      swagger: (t, r) => this.executeRequest("AdminApi", "swagger", t, r),
      updateConfig: (t, r) => this.executeRequest("AdminApi", "updateConfig", t, r),
      version: (t, r) => this.executeRequest("AdminApi", "version", t, r)
    });
    Fe(this, "campaignsApi", {
      campaign: (t, r) => this.executeRequest("CampaignsApi", "campaign", t, r),
      campaignOrders: (t, r) => this.executeRequest("CampaignsApi", "campaignOrders", t, r),
      campaignOrdersCount: (t, r) => this.executeRequest("CampaignsApi", "campaignOrdersCount", t, r),
      campaignOrdersMeta: (t, r) => this.executeRequest("CampaignsApi", "campaignOrdersMeta", t, r),
      campaignOrdersPage: (t, r) => this.executeRequest("CampaignsApi", "campaignOrdersPage", t, r),
      campaignStats: (t, r) => this.executeRequest("CampaignsApi", "campaignStats", t, r),
      campaignUsersCount: (t, r) => this.executeRequest("CampaignsApi", "campaignUsersCount", t, r),
      campaigns: (t, r) => this.executeRequest("CampaignsApi", "campaigns", t, r),
      campaignsCollected: (t, r) => this.executeRequest("CampaignsApi", "campaignsCollected", t, r),
      campaignsCount: (t, r) => this.executeRequest("CampaignsApi", "campaignsCount", t, r),
      campaignsMeta: (t, r) => this.executeRequest("CampaignsApi", "campaignsMeta", t, r),
      campaignsPage: (t, r) => this.executeRequest("CampaignsApi", "campaignsPage", t, r),
      campaignsStats: (t, r) => this.executeRequest("CampaignsApi", "campaignsStats", t, r),
      createCampaign: (t, r) => this.executeRequest("CampaignsApi", "createCampaign", t, r),
      createOrder: (t, r) => this.executeRequest("CampaignsApi", "createOrder", t, r),
      deleteCampaign: (t, r) => this.executeRequest("CampaignsApi", "deleteCampaign", t, r),
      mintCampaign: (t, r) => this.executeRequest("CampaignsApi", "mintCampaign", t, r),
      mintStatus: (t, r) => this.executeRequest("CampaignsApi", "mintStatus", t, r),
      updateCampaign: (t, r) => this.executeRequest("CampaignsApi", "updateCampaign", t, r)
    });
    Fe(this, "dataApi", {
      addData: (t, r) => this.executeRequest("DataApi", "addData", t, r),
      data: (t, r) => this.executeRequest("DataApi", "data", t, r),
      dataCount: (t, r) => this.executeRequest("DataApi", "dataCount", t, r),
      dataKinds: (t, r) => this.executeRequest("DataApi", "dataKinds", t, r),
      dataMeta: (t, r) => this.executeRequest("DataApi", "dataMeta", t, r),
      dataPage: (t, r) => this.executeRequest("DataApi", "dataPage", t, r),
      deleteData: (t, r) => this.executeRequest("DataApi", "deleteData", t, r),
      updateData: (t, r) => this.executeRequest("DataApi", "updateData", t, r)
    });
    Fe(this, "hooksApi", {
      kycHook: (t, r) => this.executeRequest("HooksApi", "kycHook", t, r),
      paymentHook: (t, r) => this.executeRequest("HooksApi", "paymentHook", t, r),
      signatureHook: (t, r) => this.executeRequest("HooksApi", "signatureHook", t, r)
    });
    Fe(this, "ordersApi", {
      cancelOrder: (t, r) => this.executeRequest("OrdersApi", "cancelOrder", t, r),
      deleteOrder: (t, r) => this.executeRequest("OrdersApi", "deleteOrder", t, r),
      executeOrder: (t, r) => this.executeRequest("OrdersApi", "executeOrder", t, r),
      order: (t, r) => this.executeRequest("OrdersApi", "order", t, r),
      orderDocuments: (t, r) => this.executeRequest("OrdersApi", "orderDocuments", t, r),
      orders: (t, r) => this.executeRequest("OrdersApi", "orders", t, r),
      ordersCount: (t, r) => this.executeRequest("OrdersApi", "ordersCount", t, r),
      ordersMeta: (t, r) => this.executeRequest("OrdersApi", "ordersMeta", t, r),
      ordersPage: (t, r) => this.executeRequest("OrdersApi", "ordersPage", t, r),
      refundOrder: (t, r) => this.executeRequest("OrdersApi", "refundOrder", t, r),
      updateOrder: (t, r) => this.executeRequest("OrdersApi", "updateOrder", t, r)
    });
    Fe(this, "pollsApi", {
      createPoll: (t, r) => this.executeRequest("PollsApi", "createPoll", t, r),
      deletePoll: (t, r) => this.executeRequest("PollsApi", "deletePoll", t, r),
      poll: (t, r) => this.executeRequest("PollsApi", "poll", t, r),
      pollVotes: (t, r) => this.executeRequest("PollsApi", "pollVotes", t, r),
      pollVotesCount: (t, r) => this.executeRequest("PollsApi", "pollVotesCount", t, r),
      pollVotesPage: (t, r) => this.executeRequest("PollsApi", "pollVotesPage", t, r),
      polls: (t, r) => this.executeRequest("PollsApi", "polls", t, r),
      pollsCount: (t, r) => this.executeRequest("PollsApi", "pollsCount", t, r),
      pollsMeta: (t, r) => this.executeRequest("PollsApi", "pollsMeta", t, r),
      pollsPage: (t, r) => this.executeRequest("PollsApi", "pollsPage", t, r),
      updatePoll: (t, r) => this.executeRequest("PollsApi", "updatePoll", t, r)
    });
    Fe(this, "projectsApi", {
      cities: (t, r) => this.executeRequest("ProjectsApi", "cities", t, r),
      createProject: (t, r) => this.executeRequest("ProjectsApi", "createProject", t, r),
      deleteProject: (t, r) => this.executeRequest("ProjectsApi", "deleteProject", t, r),
      payout: (t, r) => this.executeRequest("ProjectsApi", "payout", t, r),
      payoutPeriods: (t, r) => this.executeRequest("ProjectsApi", "payoutPeriods", t, r),
      project: (t, r) => this.executeRequest("ProjectsApi", "project", t, r),
      projectCampaigns: (t, r) => this.executeRequest("ProjectsApi", "projectCampaigns", t, r),
      projectCampaignsCount: (t, r) => this.executeRequest("ProjectsApi", "projectCampaignsCount", t, r),
      projectCampaignsMeta: (t, r) => this.executeRequest("ProjectsApi", "projectCampaignsMeta", t, r),
      projectCampaignsPage: (t, r) => this.executeRequest("ProjectsApi", "projectCampaignsPage", t, r),
      projectNextId: (t, r) => this.executeRequest("ProjectsApi", "projectNextId", t, r),
      projectStats: (t, r) => this.executeRequest("ProjectsApi", "projectStats", t, r),
      projects: (t, r) => this.executeRequest("ProjectsApi", "projects", t, r),
      projectsCount: (t, r) => this.executeRequest("ProjectsApi", "projectsCount", t, r),
      projectsMeta: (t, r) => this.executeRequest("ProjectsApi", "projectsMeta", t, r),
      projectsPage: (t, r) => this.executeRequest("ProjectsApi", "projectsPage", t, r),
      showPayout: (t, r) => this.executeRequest("ProjectsApi", "showPayout", t, r),
      updateProject: (t, r) => this.executeRequest("ProjectsApi", "updateProject", t, r),
      upload: (t, r) => this.executeRequest("ProjectsApi", "upload", t, r)
    });
    Fe(this, "usersApi", {
      addUserList: (t, r) => this.executeRequest("UsersApi", "addUserList", t, r),
      createUser: (t, r) => this.executeRequest("UsersApi", "createUser", t, r),
      createUserList: (t, r) => this.executeRequest("UsersApi", "createUserList", t, r),
      deleteUser: (t, r) => this.executeRequest("UsersApi", "deleteUser", t, r),
      deleteUserList: (t, r) => this.executeRequest("UsersApi", "deleteUserList", t, r),
      initializeUser: (t, r) => this.executeRequest("UsersApi", "initializeUser", t, r),
      kycUser: (t, r) => this.executeRequest("UsersApi", "kycUser", t, r),
      linkEmail: (t, r) => this.executeRequest("UsersApi", "linkEmail", t, r),
      payin: (t, r) => this.executeRequest("UsersApi", "payin", t, r),
      removeUserList: (t, r) => this.executeRequest("UsersApi", "removeUserList", t, r),
      sendEmail: (t, r) => this.executeRequest("UsersApi", "sendEmail", t, r),
      transfers: (t, r) => this.executeRequest("UsersApi", "transfers", t, r),
      updateUser: (t, r) => this.executeRequest("UsersApi", "updateUser", t, r),
      user: (t, r) => this.executeRequest("UsersApi", "user", t, r),
      userDocumentDownload: (t, r) => this.executeRequest("UsersApi", "userDocumentDownload", t, r),
      userDocuments: (t, r) => this.executeRequest("UsersApi", "userDocuments", t, r),
      userDocumentsCount: (t, r) => this.executeRequest("UsersApi", "userDocumentsCount", t, r),
      userDocumentsMeta: (t, r) => this.executeRequest("UsersApi", "userDocumentsMeta", t, r),
      userDocumentsPage: (t, r) => this.executeRequest("UsersApi", "userDocumentsPage", t, r),
      userInfo: (t, r) => this.executeRequest("UsersApi", "userInfo", t, r),
      userInfoStats: (t, r) => this.executeRequest("UsersApi", "userInfoStats", t, r),
      userLists: (t, r) => this.executeRequest("UsersApi", "userLists", t, r),
      userOrders: (t, r) => this.executeRequest("UsersApi", "userOrders", t, r),
      userOrdersCount: (t, r) => this.executeRequest("UsersApi", "userOrdersCount", t, r),
      userOrdersMeta: (t, r) => this.executeRequest("UsersApi", "userOrdersMeta", t, r),
      userOrdersPage: (t, r) => this.executeRequest("UsersApi", "userOrdersPage", t, r),
      userPayout: (t, r) => this.executeRequest("UsersApi", "userPayout", t, r),
      userProjects: (t, r) => this.executeRequest("UsersApi", "userProjects", t, r),
      userProjectsCount: (t, r) => this.executeRequest("UsersApi", "userProjectsCount", t, r),
      userProjectsMeta: (t, r) => this.executeRequest("UsersApi", "userProjectsMeta", t, r),
      userProjectsPage: (t, r) => this.executeRequest("UsersApi", "userProjectsPage", t, r),
      userStats: (t, r) => this.executeRequest("UsersApi", "userStats", t, r),
      userVote: (t, r) => this.executeRequest("UsersApi", "userVote", t, r),
      userVotes: (t, r) => this.executeRequest("UsersApi", "userVotes", t, r),
      userVotesCount: (t, r) => this.executeRequest("UsersApi", "userVotesCount", t, r),
      userVotesPage: (t, r) => this.executeRequest("UsersApi", "userVotesPage", t, r),
      users: (t, r) => this.executeRequest("UsersApi", "users", t, r),
      usersCount: (t, r) => this.executeRequest("UsersApi", "usersCount", t, r),
      usersMeta: (t, r) => this.executeRequest("UsersApi", "usersMeta", t, r),
      usersPage: (t, r) => this.executeRequest("UsersApi", "usersPage", t, r),
      usersStats: (t, r) => this.executeRequest("UsersApi", "usersStats", t, r),
      wallet: (t, r) => this.executeRequest("UsersApi", "wallet", t, r)
    });
    this.apiInstances = Object.fromEntries(
      Object.entries(cG).filter(([r]) => r.endsWith("Api")).map(([r, n]) => {
        let a;
        if (typeof n == "function")
          "prototype" in n && n.prototype.constructor === n ? a = new n(t) : a = n(t);
        else
          throw new Error(`Unexpected module type for ${r}`);
        return [r, a];
      })
    );
  }
  async executeRequest(t, r, n, a) {
    try {
      const s = this.apiInstances[t];
      if (!s) {
        const u = new Error(`API instance ${t} not found`);
        throw S1.adaptError(u);
      }
      const i = s[r];
      if (!i) {
        const u = new Error(
          `Method ${String(r)} not found on ${t}`
        );
        throw S1.adaptError(u);
      }
      const l = { ...{
        withCredentials: !1,
        headers: {
          "Content-Type": "application/json"
        }
      }, ...a };
      return (await i.call(s, n, l)).data;
    } catch (s) {
      const i = S1.adaptError(s);
      throw this.isTokenExpiredError(i) && window.dispatchEvent(
        new CustomEvent("auth:tokenExpired", {
          detail: { error: i }
        })
      ), i;
    }
  }
  isTokenExpiredError(t) {
    var r, n, a, s;
    return t.code === "AUTH_EXPIRED_TOKEN" || ((n = (r = t.details) == null ? void 0 : r.raw) == null ? void 0 : n.unauthorized) === "token expired" || t.statusCode === 401 && (t.category === "AUTH" || ((s = (a = t.details) == null ? void 0 : a.raw) == null ? void 0 : s.unauthorized) === "token expired");
  }
}
var ke = typeof globalThis < "u" ? globalThis : typeof window < "u" || typeof window < "u" ? window : typeof self < "u" ? self : {};
function wh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var tE = { exports: {} }, ap = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lA;
function dG() {
  if (lA) return ap;
  lA = 1;
  var e = M, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(o, l, c) {
    var u, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l) n.call(l, u) && !s.hasOwnProperty(u) && (d[u] = l[u]);
    if (o && o.defaultProps) for (u in l = o.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: o, key: f, ref: h, props: d, _owner: a.current };
  }
  return ap.Fragment = r, ap.jsx = i, ap.jsxs = i, ap;
}
var sp = {}, cA;
function fG() {
  if (cA) return sp;
  cA = 1;
  var e = {};
  /**
   * @license React
   * react-jsx-runtime.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && function() {
    var t = M, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), m = Symbol.iterator, g = "@@iterator";
    function y(I) {
      if (I === null || typeof I != "object")
        return null;
      var H = m && I[m] || I[g];
      return typeof H == "function" ? H : null;
    }
    var x = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(I) {
      {
        for (var H = arguments.length, X = new Array(H > 1 ? H - 1 : 0), Z = 1; Z < H; Z++)
          X[Z - 1] = arguments[Z];
        _("error", I, X);
      }
    }
    function _(I, H, X) {
      {
        var Z = x.ReactDebugCurrentFrame, Se = Z.getStackAddendum();
        Se !== "" && (H += "%s", X = X.concat([Se]));
        var Ie = X.map(function(ge) {
          return String(ge);
        });
        Ie.unshift("Warning: " + H), Function.prototype.apply.call(console[I], console, Ie);
      }
    }
    var S = !1, C = !1, E = !1, O = !1, k = !1, A;
    A = Symbol.for("react.module.reference");
    function P(I) {
      return !!(typeof I == "string" || typeof I == "function" || I === a || I === i || k || I === s || I === u || I === d || O || I === p || S || C || E || typeof I == "object" && I !== null && (I.$$typeof === h || I.$$typeof === f || I.$$typeof === o || I.$$typeof === l || I.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      I.$$typeof === A || I.getModuleId !== void 0));
    }
    function D(I, H, X) {
      var Z = I.displayName;
      if (Z)
        return Z;
      var Se = H.displayName || H.name || "";
      return Se !== "" ? X + "(" + Se + ")" : X;
    }
    function N(I) {
      return I.displayName || "Context";
    }
    function z(I) {
      if (I == null)
        return null;
      if (typeof I.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof I == "function")
        return I.displayName || I.name || null;
      if (typeof I == "string")
        return I;
      switch (I) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof I == "object")
        switch (I.$$typeof) {
          case l:
            var H = I;
            return N(H) + ".Consumer";
          case o:
            var X = I;
            return N(X._context) + ".Provider";
          case c:
            return D(I, I.render, "ForwardRef");
          case f:
            var Z = I.displayName || null;
            return Z !== null ? Z : z(I.type) || "Memo";
          case h: {
            var Se = I, Ie = Se._payload, ge = Se._init;
            try {
              return z(ge(Ie));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, Y = 0, te, ae, ne, ue, q, U, Q;
    function L() {
    }
    L.__reactDisabledLog = !0;
    function j() {
      {
        if (Y === 0) {
          te = console.log, ae = console.info, ne = console.warn, ue = console.error, q = console.group, U = console.groupCollapsed, Q = console.groupEnd;
          var I = {
            configurable: !0,
            enumerable: !0,
            value: L,
            writable: !0
          };
          Object.defineProperties(console, {
            info: I,
            log: I,
            warn: I,
            error: I,
            group: I,
            groupCollapsed: I,
            groupEnd: I
          });
        }
        Y++;
      }
    }
    function K() {
      {
        if (Y--, Y === 0) {
          var I = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, I, {
              value: te
            }),
            info: G({}, I, {
              value: ae
            }),
            warn: G({}, I, {
              value: ne
            }),
            error: G({}, I, {
              value: ue
            }),
            group: G({}, I, {
              value: q
            }),
            groupCollapsed: G({}, I, {
              value: U
            }),
            groupEnd: G({}, I, {
              value: Q
            })
          });
        }
        Y < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var J = x.ReactCurrentDispatcher, re;
    function le(I, H, X) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch (Se) {
            var Z = Se.stack.trim().match(/\n( *(at )?)/);
            re = Z && Z[1] || "";
          }
        return `
` + re + I;
      }
    }
    var pe = !1, me;
    {
      var Oe = typeof WeakMap == "function" ? WeakMap : Map;
      me = new Oe();
    }
    function ee(I, H) {
      if (!I || pe)
        return "";
      {
        var X = me.get(I);
        if (X !== void 0)
          return X;
      }
      var Z;
      pe = !0;
      var Se = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ie;
      Ie = J.current, J.current = null, j();
      try {
        if (H) {
          var ge = function() {
            throw Error();
          };
          if (Object.defineProperty(ge.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ge, []);
            } catch (Pt) {
              Z = Pt;
            }
            Reflect.construct(I, [], ge);
          } else {
            try {
              ge.call();
            } catch (Pt) {
              Z = Pt;
            }
            I.call(ge.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Pt) {
            Z = Pt;
          }
          I();
        }
      } catch (Pt) {
        if (Pt && Z && typeof Pt.stack == "string") {
          for (var xe = Pt.stack.split(`
`), De = Z.stack.split(`
`), je = xe.length - 1, at = De.length - 1; je >= 1 && at >= 0 && xe[je] !== De[at]; )
            at--;
          for (; je >= 1 && at >= 0; je--, at--)
            if (xe[je] !== De[at]) {
              if (je !== 1 || at !== 1)
                do
                  if (je--, at--, at < 0 || xe[je] !== De[at]) {
                    var pt = `
` + xe[je].replace(" at new ", " at ");
                    return I.displayName && pt.includes("<anonymous>") && (pt = pt.replace("<anonymous>", I.displayName)), typeof I == "function" && me.set(I, pt), pt;
                  }
                while (je >= 1 && at >= 0);
              break;
            }
        }
      } finally {
        pe = !1, J.current = Ie, K(), Error.prepareStackTrace = Se;
      }
      var ct = I ? I.displayName || I.name : "", gt = ct ? le(ct) : "";
      return typeof I == "function" && me.set(I, gt), gt;
    }
    function he(I, H, X) {
      return ee(I, !1);
    }
    function Ee(I) {
      var H = I.prototype;
      return !!(H && H.isReactComponent);
    }
    function we(I, H, X) {
      if (I == null)
        return "";
      if (typeof I == "function")
        return ee(I, Ee(I));
      if (typeof I == "string")
        return le(I);
      switch (I) {
        case u:
          return le("Suspense");
        case d:
          return le("SuspenseList");
      }
      if (typeof I == "object")
        switch (I.$$typeof) {
          case c:
            return he(I.render);
          case f:
            return we(I.type, H, X);
          case h: {
            var Z = I, Se = Z._payload, Ie = Z._init;
            try {
              return we(Ie(Se), H, X);
            } catch {
            }
          }
        }
      return "";
    }
    var Pe = Object.prototype.hasOwnProperty, rt = {}, ht = x.ReactDebugCurrentFrame;
    function bt(I) {
      if (I) {
        var H = I._owner, X = we(I.type, I._source, H ? H.type : null);
        ht.setExtraStackFrame(X);
      } else
        ht.setExtraStackFrame(null);
    }
    function Ge(I, H, X, Z, Se) {
      {
        var Ie = Function.call.bind(Pe);
        for (var ge in I)
          if (Ie(I, ge)) {
            var xe = void 0;
            try {
              if (typeof I[ge] != "function") {
                var De = Error((Z || "React class") + ": " + X + " type `" + ge + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof I[ge] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw De.name = "Invariant Violation", De;
              }
              xe = I[ge](H, ge, Z, X, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (je) {
              xe = je;
            }
            xe && !(xe instanceof Error) && (bt(Se), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Z || "React class", X, ge, typeof xe), bt(null)), xe instanceof Error && !(xe.message in rt) && (rt[xe.message] = !0, bt(Se), w("Failed %s type: %s", X, xe.message), bt(null));
          }
      }
    }
    var oe = Array.isArray;
    function ve(I) {
      return oe(I);
    }
    function ye(I) {
      {
        var H = typeof Symbol == "function" && Symbol.toStringTag, X = H && I[Symbol.toStringTag] || I.constructor.name || "Object";
        return X;
      }
    }
    function Te(I) {
      try {
        return _e(I), !1;
      } catch {
        return !0;
      }
    }
    function _e(I) {
      return "" + I;
    }
    function Ae(I) {
      if (Te(I))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ye(I)), _e(I);
    }
    var Ve = x.ReactCurrentOwner, mt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Dt, Gt;
    function $t(I) {
      if (Pe.call(I, "ref")) {
        var H = Object.getOwnPropertyDescriptor(I, "ref").get;
        if (H && H.isReactWarning)
          return !1;
      }
      return I.ref !== void 0;
    }
    function Rt(I) {
      if (Pe.call(I, "key")) {
        var H = Object.getOwnPropertyDescriptor(I, "key").get;
        if (H && H.isReactWarning)
          return !1;
      }
      return I.key !== void 0;
    }
    function Pr(I, H) {
      typeof I.ref == "string" && Ve.current;
    }
    function fr(I, H) {
      {
        var X = function() {
          Dt || (Dt = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", H));
        };
        X.isReactWarning = !0, Object.defineProperty(I, "key", {
          get: X,
          configurable: !0
        });
      }
    }
    function ca(I, H) {
      {
        var X = function() {
          Gt || (Gt = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", H));
        };
        X.isReactWarning = !0, Object.defineProperty(I, "ref", {
          get: X,
          configurable: !0
        });
      }
    }
    var en = function(I, H, X, Z, Se, Ie, ge) {
      var xe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: I,
        key: H,
        ref: X,
        props: ge,
        // Record the component responsible for creating this element.
        _owner: Ie
      };
      return xe._store = {}, Object.defineProperty(xe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(xe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Z
      }), Object.defineProperty(xe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Se
      }), Object.freeze && (Object.freeze(xe.props), Object.freeze(xe)), xe;
    };
    function Na(I, H, X, Z, Se) {
      {
        var Ie, ge = {}, xe = null, De = null;
        X !== void 0 && (Ae(X), xe = "" + X), Rt(H) && (Ae(H.key), xe = "" + H.key), $t(H) && (De = H.ref, Pr(H, Se));
        for (Ie in H)
          Pe.call(H, Ie) && !mt.hasOwnProperty(Ie) && (ge[Ie] = H[Ie]);
        if (I && I.defaultProps) {
          var je = I.defaultProps;
          for (Ie in je)
            ge[Ie] === void 0 && (ge[Ie] = je[Ie]);
        }
        if (xe || De) {
          var at = typeof I == "function" ? I.displayName || I.name || "Unknown" : I;
          xe && fr(ge, at), De && ca(ge, at);
        }
        return en(I, xe, De, Se, Z, Ve.current, ge);
      }
    }
    var Ma = x.ReactCurrentOwner, Hr = x.ReactDebugCurrentFrame;
    function wa(I) {
      if (I) {
        var H = I._owner, X = we(I.type, I._source, H ? H.type : null);
        Hr.setExtraStackFrame(X);
      } else
        Hr.setExtraStackFrame(null);
    }
    var na;
    na = !1;
    function ce(I) {
      return typeof I == "object" && I !== null && I.$$typeof === r;
    }
    function de() {
      {
        if (Ma.current) {
          var I = z(Ma.current.type);
          if (I)
            return `

Check the render method of \`` + I + "`.";
        }
        return "";
      }
    }
    function Ne(I) {
      return "";
    }
    var Le = {};
    function $e(I) {
      {
        var H = de();
        if (!H) {
          var X = typeof I == "string" ? I : I.displayName || I.name;
          X && (H = `

Check the top-level render call using <` + X + ">.");
        }
        return H;
      }
    }
    function ze(I, H) {
      {
        if (!I._store || I._store.validated || I.key != null)
          return;
        I._store.validated = !0;
        var X = $e(H);
        if (Le[X])
          return;
        Le[X] = !0;
        var Z = "";
        I && I._owner && I._owner !== Ma.current && (Z = " It was passed a child from " + z(I._owner.type) + "."), wa(I), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', X, Z), wa(null);
      }
    }
    function Lt(I, H) {
      {
        if (typeof I != "object")
          return;
        if (ve(I))
          for (var X = 0; X < I.length; X++) {
            var Z = I[X];
            ce(Z) && ze(Z, H);
          }
        else if (ce(I))
          I._store && (I._store.validated = !0);
        else if (I) {
          var Se = y(I);
          if (typeof Se == "function" && Se !== I.entries)
            for (var Ie = Se.call(I), ge; !(ge = Ie.next()).done; )
              ce(ge.value) && ze(ge.value, H);
        }
      }
    }
    function Ht(I) {
      {
        var H = I.type;
        if (H == null || typeof H == "string")
          return;
        var X;
        if (typeof H == "function")
          X = H.propTypes;
        else if (typeof H == "object" && (H.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        H.$$typeof === f))
          X = H.propTypes;
        else
          return;
        if (X) {
          var Z = z(H);
          Ge(X, I.props, "prop", Z, I);
        } else if (H.PropTypes !== void 0 && !na) {
          na = !0;
          var Se = z(H);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Se || "Unknown");
        }
        typeof H.getDefaultProps == "function" && !H.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Rr(I) {
      {
        for (var H = Object.keys(I.props), X = 0; X < H.length; X++) {
          var Z = H[X];
          if (Z !== "children" && Z !== "key") {
            wa(I), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Z), wa(null);
            break;
          }
        }
        I.ref !== null && (wa(I), w("Invalid attribute `ref` supplied to `React.Fragment`."), wa(null));
      }
    }
    var kt = {};
    function lr(I, H, X, Z, Se, Ie) {
      {
        var ge = P(I);
        if (!ge) {
          var xe = "";
          (I === void 0 || typeof I == "object" && I !== null && Object.keys(I).length === 0) && (xe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var De = Ne();
          De ? xe += De : xe += de();
          var je;
          I === null ? je = "null" : ve(I) ? je = "array" : I !== void 0 && I.$$typeof === r ? (je = "<" + (z(I.type) || "Unknown") + " />", xe = " Did you accidentally export a JSX literal instead of a component?") : je = typeof I, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", je, xe);
        }
        var at = Na(I, H, X, Se, Ie);
        if (at == null)
          return at;
        if (ge) {
          var pt = H.children;
          if (pt !== void 0)
            if (Z)
              if (ve(pt)) {
                for (var ct = 0; ct < pt.length; ct++)
                  Lt(pt[ct], I);
                Object.freeze && Object.freeze(pt);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Lt(pt, I);
        }
        if (Pe.call(H, "key")) {
          var gt = z(I), Pt = Object.keys(H).filter(function(Nn) {
            return Nn !== "key";
          }), Ir = Pt.length > 0 ? "{key: someKey, " + Pt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!kt[gt + Ir]) {
            var Wr = Pt.length > 0 ? "{" + Pt.join(": ..., ") + ": ...}" : "{}";
            w(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ir, gt, Wr, gt), kt[gt + Ir] = !0;
          }
        }
        return I === a ? Rr(at) : Ht(at), at;
      }
    }
    function cn(I, H, X) {
      return lr(I, H, X, !0);
    }
    function ua(I, H, X) {
      return lr(I, H, X, !1);
    }
    var W = ua, ie = cn;
    sp.Fragment = a, sp.jsx = W, sp.jsxs = ie;
  }(), sp;
}
var hG = {};
hG.NODE_ENV === "production" ? tE.exports = dG() : tE.exports = fG();
var v = tE.exports;
class b3 {
  constructor(t = {}) {
    /**
     * parameter for apiKey security
     * @param name security name
     * @memberof Configuration
     */
    Fe(this, "apiKey");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    Fe(this, "username");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    Fe(this, "password");
    /**
     * parameter for oauth2 security
     * @param name security name
     * @param scopes oauth2 scope
     * @memberof Configuration
     */
    Fe(this, "accessToken");
    /**
     * override base path
     *
     * @type {string}
     * @memberof Configuration
     */
    Fe(this, "basePath");
    /**
     * override server index
     *
     * @type {number}
     * @memberof Configuration
     */
    Fe(this, "serverIndex");
    /**
     * base options for axios calls
     *
     * @type {any}
     * @memberof Configuration
     */
    Fe(this, "baseOptions");
    /**
     * The FormData constructor that will be used to create multipart form data
     * requests. You can inject this here so that execution environments that
     * do not support the FormData class can still run the generated client.
     *
     * @type {new () => FormData}
     */
    Fe(this, "formDataCtor");
    this.apiKey = t.apiKey, this.username = t.username, this.password = t.password, this.accessToken = t.accessToken, this.basePath = t.basePath, this.serverIndex = t.serverIndex, this.baseOptions = t.baseOptions, this.formDataCtor = t.formDataCtor;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(t) {
    const r = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return t !== null && (r.test(t) || t.toLowerCase() === "application/json-patch+json");
  }
}
const xu = class xu {
  constructor(t = "local") {
    Fe(this, "TOKEN_KEY", "auth_tokens");
    Fe(this, "cachedTokens", null);
    this.storageType = t;
  }
  static getInstance(t) {
    return xu.instance || (xu.instance = new xu(t)), xu.instance;
  }
  async getTokens() {
    if (this.cachedTokens) return this.cachedTokens;
    const t = this.getStorage().getItem(this.TOKEN_KEY);
    if (!t) return null;
    try {
      return this.cachedTokens = JSON.parse(t), this.cachedTokens;
    } catch {
      return null;
    }
  }
  async setTokens(t) {
    this.cachedTokens = t, this.getStorage().setItem(this.TOKEN_KEY, JSON.stringify(t));
  }
  async clearTokens() {
    this.cachedTokens = null, this.getStorage().removeItem(this.TOKEN_KEY);
  }
  getStorage() {
    return this.storageType === "local" ? localStorage : sessionStorage;
  }
};
Fe(xu, "instance");
let si = xu, Wp = null;
function WJe(e) {
  Wp = e;
}
function ui() {
  return Wp || (Wp = {
    MODE: "production",
    AUTH_TOKEN: void 0,
    API_BASE_URL: "https://frak2-api.functori.com",
    AUTH_BASE_URL: "https://frak2-auth.functori.com",
    AUTH_TYPE: "supertokens",
    AUTH_STORAGE: "local",
    WEBSITE_URL: "https://example.com",
    STRIPE_PUBLIC_KEY: "pk_test_your_test_key_here",
    DEFAULT_THEME: "light",
    APP_NAME: "Your App Name",
    TENANT_ID: "fraktion",
    REQUIRED_ROLE: "admin",
    KYC_PROVIDER: "dataleon",
    SIGNATURE_PROVIDER: "signaturit",
    PAYMENT_PROVIDER: "bridgeapi",
    PAYMENT_PROVIDERS: "bridgeapi,mangopay".split(",").filter(Boolean),
    MEDIA_BASE_URL: "https://frak2-api.functori.com",
    ONBOARDING: {
      ENABLED: !0,
      STEPS: "personal,kyc".split(",") || []
    },
    JWT: {
      REFRESH_TOKEN_KEY: "refresh_token",
      ACCESS_TOKEN_KEY: "access_token"
    }
  }, Wp);
}
const w3 = Vl(null), zJe = ({
  children: e
}) => {
  const t = ui(), r = Tn(() => si.getInstance("local"), []), n = Tn(
    () => new b3({
      basePath: t.API_BASE_URL,
      baseOptions: {
        headers: {
          "Content-Type": "application/json"
        }
      },
      accessToken: async () => {
        const s = await r.getTokens();
        return s ? s.accessToken : (window.location.href = "/auth/login", "");
      }
    }),
    [r]
  ), a = Tn(
    () => new uG(n),
    [n]
  );
  return /* @__PURE__ */ v.jsx(w3.Provider, { value: a, children: e });
}, sn = () => {
  const e = vh(w3);
  if (!e)
    throw new Error("useApi must be used within ApiProvider");
  return e;
}, KJe = {
  DestructException: "Destruct exception"
}, eo = {
  Created: "created",
  Available: "available",
  Canceled: "canceled",
  Closed: "closed",
  Minted: "minted"
}, qJe = {
  Created: "created",
  Available: "available",
  Canceled: "canceled",
  Closed: "closed",
  Minted: "minted"
}, GJe = {
  Created: "created",
  Available: "available",
  Canceled: "canceled",
  Closed: "closed",
  Minted: "minted"
}, YJe = {
  Created: "created",
  Available: "available",
  Canceled: "canceled",
  Closed: "closed",
  Minted: "minted"
}, XJe = {
  Company: "company"
}, QJe = {
  Company: "company"
}, JJe = {
  Ondemand: "ondemand",
  Auto: "auto"
}, ZJe = {
  Company: "company"
}, eZe = {
  Eth: "eth",
  Tz: "tz"
}, tZe = {
  Ae: "AE",
  Af: "AF",
  Ag: "AG",
  Ai: "AI",
  Al: "AL",
  Am: "AM",
  Ao: "AO",
  Aq: "AQ",
  Ar: "AR",
  As: "AS",
  At: "AT",
  Au: "AU",
  Aw: "AW",
  Ax: "AX",
  Az: "AZ",
  Ba: "BA",
  Bb: "BB",
  Bd: "BD",
  Be: "BE",
  Bf: "BF",
  Bg: "BG",
  Bh: "BH",
  Bi: "BI",
  Bj: "BJ",
  Bl: "BL",
  Bm: "BM",
  Bn: "BN",
  Bo: "BO",
  Bq: "BQ",
  Br: "BR",
  Bs: "BS",
  Bt: "BT",
  Bv: "BV",
  Bw: "BW",
  By: "BY",
  Bz: "BZ",
  Ca: "CA",
  Cc: "CC",
  Cd: "CD",
  Cf: "CF",
  Cg: "CG",
  Ch: "CH",
  Ci: "CI",
  Ck: "CK",
  Cl: "CL",
  Cm: "CM",
  Cn: "CN",
  Co: "CO",
  Cr: "CR",
  Cu: "CU",
  Cv: "CV",
  Cw: "CW",
  Cx: "CX",
  Cy: "CY",
  Cz: "CZ",
  De: "DE",
  Dj: "DJ",
  Dk: "DK",
  Dm: "DM",
  Do: "DO",
  Dz: "DZ",
  Ec: "EC",
  Ee: "EE",
  Eg: "EG",
  Eh: "EH",
  Er: "ER",
  Es: "ES",
  Et: "ET",
  Fi: "FI",
  Fj: "FJ",
  Fk: "FK",
  Fm: "FM",
  Fo: "FO",
  Fr: "FR",
  Ga: "GA",
  Gb: "GB",
  Gd: "GD",
  Ge: "GE",
  Gf: "GF",
  Gg: "GG",
  Gh: "GH",
  Gi: "GI",
  Gl: "GL",
  Gm: "GM",
  Gn: "GN",
  Gp: "GP",
  Gq: "GQ",
  Gr: "GR",
  Gs: "GS",
  Gt: "GT",
  Gu: "GU",
  Gw: "GW",
  Gy: "GY",
  Hk: "HK",
  Hm: "HM",
  Hn: "HN",
  Hr: "HR",
  Ht: "HT",
  Hu: "HU",
  Id: "ID",
  Ie: "IE",
  Il: "IL",
  Im: "IM",
  In: "IN",
  Io: "IO",
  Iq: "IQ",
  Ir: "IR",
  Is: "IS",
  It: "IT",
  Je: "JE",
  Jm: "JM",
  Jo: "JO",
  Jp: "JP",
  Ke: "KE",
  Kg: "KG",
  Kh: "KH",
  Ki: "KI",
  Km: "KM",
  Kn: "KN",
  Kp: "KP",
  Kr: "KR",
  Kw: "KW",
  Ky: "KY",
  Kz: "KZ",
  La: "LA",
  Lb: "LB",
  Lc: "LC",
  Li: "LI",
  Lk: "LK",
  Lr: "LR",
  Ls: "LS",
  Lt: "LT",
  Lu: "LU",
  Lv: "LV",
  Ly: "LY",
  Ma: "MA",
  Mc: "MC",
  Md: "MD",
  Me: "ME",
  Mf: "MF",
  Mg: "MG",
  Mh: "MH",
  Mk: "MK",
  Ml: "ML",
  Mm: "MM",
  Mn: "MN",
  Mo: "MO",
  Mp: "MP",
  Mq: "MQ",
  Mr: "MR",
  Ms: "MS",
  Mt: "MT",
  Mu: "MU",
  Mv: "MV",
  Mw: "MW",
  Mx: "MX",
  My: "MY",
  Mz: "MZ",
  Na: "NA",
  Nc: "NC",
  Ne: "NE",
  Nf: "NF",
  Ng: "NG",
  Ni: "NI",
  Nl: "NL",
  No: "NO",
  Np: "NP",
  Nr: "NR",
  Nu: "NU",
  Nz: "NZ",
  Om: "OM",
  Pa: "PA",
  Pe: "PE",
  Pf: "PF",
  Pg: "PG",
  Ph: "PH",
  Pk: "PK",
  Pl: "PL",
  Pm: "PM",
  Pn: "PN",
  Pr: "PR",
  Ps: "PS",
  Pt: "PT",
  Pw: "PW",
  Py: "PY",
  Qa: "QA",
  Re: "RE",
  Ro: "RO",
  Rs: "RS",
  Ru: "RU",
  Rw: "RW",
  Sa: "SA",
  Sb: "SB",
  Sc: "SC",
  Sd: "SD",
  Se: "SE",
  Sg: "SG",
  Sh: "SH",
  Si: "SI",
  Sj: "SJ",
  Sk: "SK",
  Sl: "SL",
  Sm: "SM",
  Sn: "SN",
  So: "SO",
  Sr: "SR",
  Ss: "SS",
  St: "ST",
  Sv: "SV",
  Sx: "SX",
  Sy: "SY",
  Sz: "SZ",
  Tc: "TC",
  Td: "TD",
  Tf: "TF",
  Tg: "TG",
  Th: "TH",
  Tj: "TJ",
  Tk: "TK",
  Tl: "TL",
  Tm: "TM",
  Tn: "TN",
  To: "TO",
  Tr: "TR",
  Tt: "TT",
  Tv: "TV",
  Tw: "TW",
  Tz: "TZ",
  Ua: "UA",
  Ug: "UG",
  Um: "UM",
  Us: "US",
  Uy: "UY",
  Uz: "UZ",
  Va: "VA",
  Vc: "VC",
  Ve: "VE",
  Vg: "VG",
  Vi: "VI",
  Vn: "VN",
  Vu: "VU",
  Wf: "WF",
  Ws: "WS",
  Ye: "YE",
  Yt: "YT",
  Za: "ZA",
  Zm: "ZM",
  Zw: "ZW"
}, rZe = {
  Eur: "EUR",
  Gbp: "GBP",
  Pln: "PLN",
  Chf: "CHF",
  Nok: "NOK",
  Sek: "SEK",
  Dkk: "DKK",
  Usd: "USD",
  Cad: "CAD",
  Aud: "AUD",
  Jpy: "JPY",
  Hkd: "HKD",
  Aed: "AED",
  Zar: "ZAR",
  Czk: "CZK"
}, nZe = {
  DestructExn: "destruct_exn"
}, aZe = {
  EmptyBytes: "empty_bytes"
}, sZe = {
  EmptyOperationList: "empty_operation_list"
}, iZe = {
  EndOfBytes: "end_of_bytes"
}, oZe = {
  ForgeError: "forge_error"
}, lZe = {
  HttpError: "http_error"
}, cZe = {
  Individual: "individual"
}, uZe = {
  Individual: "individual"
}, dZe = {
  Individual: "individual"
}, fZe = {
  IntTooLong: "int_too_long"
}, hZe = {
  InvalidB58: "invalid_b58"
}, pZe = {
  Dataleon: "dataleon",
  Dev: "dev"
}, $a = {
  Canceled: "canceled",
  Succeeded: "succeeded",
  Failed: "failed",
  Unknown: "unknown"
}, mZe = {
  Web: "WEB",
  Direct: "DIRECT",
  ExternalInstruction: "EXTERNAL_INSTRUCTION"
}, gZe = {
  Created: "CREATED",
  Succeeded: "SUCCEEDED",
  Failed: "FAILED"
}, vZe = {
  Payin: "PAYIN",
  Transfer: "TRANSFER",
  Payout: "PAYOUT"
}, yZe = {
  Regular: "REGULAR",
  Repudiation: "REPUDIATION",
  Refund: "REFUND",
  Settlement: "SETTLEMENT"
}, bZe = {
  Card: "CARD",
  DirectDebit: "DIRECT_DEBIT",
  Preauthorized: "PREAUTHORIZED",
  BankWire: "BANK_WIRE"
}, wZe = {
  Regular: "REGULAR",
  Repudiation: "REPUDIATION",
  Refund: "REFUND",
  Settlement: "SETTLEMENT"
}, xZe = {
  Created: "CREATED",
  Succeeded: "SUCCEEDED",
  Failed: "FAILED"
}, _Ze = {
  Payin: "PAYIN",
  Transfer: "TRANSFER",
  Payout: "PAYOUT"
}, SZe = {
  Deploying: "deploying",
  Whitelisting: "whitelisting",
  Minting: "minting",
  Minted: "minted"
}, EZe = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, TZe = {
  NoCaseMatched: "no_case_matched"
}, CZe = {
  NoMetadata: "no_metadata"
}, kZe = {
  NodeError: "node_error"
}, OZe = {
  NotABool: "not_a_bool"
}, AZe = {
  OperationNotHandled: "operation_not_handled"
}, PZe = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, RZe = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, Uv = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, IZe = {
  Pending: "pending",
  Valid: "valid",
  Executed: "executed",
  Refunded: "refunded",
  Rejected: "rejected"
}, DZe = {
  Bridgeapi: "bridgeapi",
  Mangopay: "mangopay",
  Dev: "dev"
}, NZe = {
  PrepareOperationError: "prepare_operation_error"
}, MZe = {
  Ondemand: "ondemand",
  Auto: "auto"
}, LZe = {
  RecursiveError: "recursive_error"
}, jZe = {
  ServerError: "Server Error"
}, FZe = {
  ServerError: "Server Error"
}, BZe = {
  SignExn: "sign_exn"
}, UZe = {
  InQueue: "in_queue",
  Ready: "ready",
  Signing: "signing",
  Completed: "completed",
  Expired: "expired",
  Declined: "declined",
  Error: "error",
  Canceled: "canceled"
}, VZe = {
  StringTooShort: "string_too_short"
}, $Ze = {
  Random: "random",
  Preserved: "preserved"
}, HZe = {
  UnexpectedMichelson: "unexpected_michelson"
}, WZe = {
  UnexpectedOperationBytes: "unexpected_operation_bytes"
}, zZe = {
  UnexpectedOperationHash: "unexpected_operation_hash"
}, KZe = {
  UnexpectedTag: "unexpected_tag"
}, qZe = {
  UnknownCurve: "unknown_curve"
}, GZe = {
  UnknownLanguage: "unknown_language"
}, YZe = {
  UnknownMichelineTag: "unknown_micheline_tag"
}, XZe = {
  UnknownPrefix: "unknown_prefix"
}, QZe = {
  UnknownPrimitive: "unknown_primitive"
}, JZe = {
  UnmacroError: "unmacro_error"
}, zt = {
  Uninitiated: "uninitiated",
  Initiated: "initiated",
  Kyced: "kyced",
  Active: "active",
  Blockchained: "blockchained"
}, ZZe = {
  VerifyExn: "verify_exn"
}, eet = {
  Default: "DEFAULT",
  Fees: "FEES",
  Credit: "CREDIT"
}, tet = {
  WrongMichelsonType: "wrong_michelson_type"
}, { min: pG, max: mG } = Math, Ou = (e, t = 0, r = 1) => pG(mG(t, e), r), NT = (e) => {
  e._clipped = !1, e._unclipped = e.slice(0);
  for (let t = 0; t <= 3; t++)
    t < 3 ? ((e[t] < 0 || e[t] > 255) && (e._clipped = !0), e[t] = Ou(e[t], 0, 255)) : t === 3 && (e[t] = Ou(e[t], 0, 1));
  return e;
}, x3 = {};
for (let e of [
  "Boolean",
  "Number",
  "String",
  "Function",
  "Array",
  "Date",
  "RegExp",
  "Undefined",
  "Null"
])
  x3[`[object ${e}]`] = e.toLowerCase();
function vr(e) {
  return x3[Object.prototype.toString.call(e)] || "object";
}
const or = (e, t = null) => e.length >= 3 ? Array.prototype.slice.call(e) : vr(e[0]) == "object" && t ? t.split("").filter((r) => e[0][r] !== void 0).map((r) => e[0][r]) : e[0].slice(0), xh = (e) => {
  if (e.length < 2) return null;
  const t = e.length - 1;
  return vr(e[t]) == "string" ? e[t].toLowerCase() : null;
}, { PI: kw, min: _3, max: S3 } = Math, ci = (e) => Math.round(e * 100) / 100, rE = (e) => Math.round(e * 100) / 100, yl = kw * 2, E1 = kw / 3, gG = kw / 180, vG = 180 / kw;
function E3(e) {
  return [...e.slice(0, 3).reverse(), ...e.slice(3)];
}
const rr = {
  format: {},
  autodetect: []
};
let ft = class {
  constructor(...t) {
    const r = this;
    if (vr(t[0]) === "object" && t[0].constructor && t[0].constructor === this.constructor)
      return t[0];
    let n = xh(t), a = !1;
    if (!n) {
      a = !0, rr.sorted || (rr.autodetect = rr.autodetect.sort((s, i) => i.p - s.p), rr.sorted = !0);
      for (let s of rr.autodetect)
        if (n = s.test(...t), n) break;
    }
    if (rr.format[n]) {
      const s = rr.format[n].apply(
        null,
        a ? t : t.slice(0, -1)
      );
      r._rgb = NT(s);
    } else
      throw new Error("unknown format: " + t);
    r._rgb.length === 3 && r._rgb.push(1);
  }
  toString() {
    return vr(this.hex) == "function" ? this.hex() : `[${this._rgb.join(",")}]`;
  }
};
const yG = "3.1.2", Qt = (...e) => new ft(...e);
Qt.version = yG;
const Yf = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  gold: "#ffd700",
  goldenrod: "#daa520",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  laserlemon: "#ffff54",
  lavender: "#e6e6fa",
  lavenderblush: "#fff0f5",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrod: "#fafad2",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  maroon2: "#7f0000",
  maroon3: "#b03060",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  purple2: "#7f007f",
  purple3: "#a020f0",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
}, bG = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, wG = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/, T3 = (e) => {
  if (e.match(bG)) {
    (e.length === 4 || e.length === 7) && (e = e.substr(1)), e.length === 3 && (e = e.split(""), e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]);
    const t = parseInt(e, 16), r = t >> 16, n = t >> 8 & 255, a = t & 255;
    return [r, n, a, 1];
  }
  if (e.match(wG)) {
    (e.length === 5 || e.length === 9) && (e = e.substr(1)), e.length === 4 && (e = e.split(""), e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2] + e[3] + e[3]);
    const t = parseInt(e, 16), r = t >> 24 & 255, n = t >> 16 & 255, a = t >> 8 & 255, s = Math.round((t & 255) / 255 * 100) / 100;
    return [r, n, a, s];
  }
  throw new Error(`unknown hex color: ${e}`);
}, { round: Vv } = Math, C3 = (...e) => {
  let [t, r, n, a] = or(e, "rgba"), s = xh(e) || "auto";
  a === void 0 && (a = 1), s === "auto" && (s = a < 1 ? "rgba" : "rgb"), t = Vv(t), r = Vv(r), n = Vv(n);
  let o = "000000" + (t << 16 | r << 8 | n).toString(16);
  o = o.substr(o.length - 6);
  let l = "0" + Vv(a * 255).toString(16);
  switch (l = l.substr(l.length - 2), s.toLowerCase()) {
    case "rgba":
      return `#${o}${l}`;
    case "argb":
      return `#${l}${o}`;
    default:
      return `#${o}`;
  }
};
ft.prototype.name = function() {
  const e = C3(this._rgb, "rgb");
  for (let t of Object.keys(Yf))
    if (Yf[t] === e) return t.toLowerCase();
  return e;
};
rr.format.named = (e) => {
  if (e = e.toLowerCase(), Yf[e]) return T3(Yf[e]);
  throw new Error("unknown color name: " + e);
};
rr.autodetect.push({
  p: 5,
  test: (e, ...t) => {
    if (!t.length && vr(e) === "string" && Yf[e.toLowerCase()])
      return "named";
  }
});
ft.prototype.alpha = function(e, t = !1) {
  return e !== void 0 && vr(e) === "number" ? t ? (this._rgb[3] = e, this) : new ft([this._rgb[0], this._rgb[1], this._rgb[2], e], "rgb") : this._rgb[3];
};
ft.prototype.clipped = function() {
  return this._rgb._clipped || !1;
};
const ko = {
  // Corresponds roughly to RGB brighter/darker
  Kn: 18,
  // D65 standard referent
  labWhitePoint: "d65",
  Xn: 0.95047,
  Yn: 1,
  Zn: 1.08883,
  kE: 216 / 24389,
  kKE: 8,
  kK: 24389 / 27,
  RefWhiteRGB: {
    // sRGB
    X: 0.95047,
    Y: 1,
    Z: 1.08883
  },
  MtxRGB2XYZ: {
    m00: 0.4124564390896922,
    m01: 0.21267285140562253,
    m02: 0.0193338955823293,
    m10: 0.357576077643909,
    m11: 0.715152155287818,
    m12: 0.11919202588130297,
    m20: 0.18043748326639894,
    m21: 0.07217499330655958,
    m22: 0.9503040785363679
  },
  MtxXYZ2RGB: {
    m00: 3.2404541621141045,
    m01: -0.9692660305051868,
    m02: 0.055643430959114726,
    m10: -1.5371385127977166,
    m11: 1.8760108454466942,
    m12: -0.2040259135167538,
    m20: -0.498531409556016,
    m21: 0.041556017530349834,
    m22: 1.0572251882231791
  },
  // used in rgb2xyz
  As: 0.9414285350000001,
  Bs: 1.040417467,
  Cs: 1.089532651,
  MtxAdaptMa: {
    m00: 0.8951,
    m01: -0.7502,
    m02: 0.0389,
    m10: 0.2664,
    m11: 1.7135,
    m12: -0.0685,
    m20: -0.1614,
    m21: 0.0367,
    m22: 1.0296
  },
  MtxAdaptMaI: {
    m00: 0.9869929054667123,
    m01: 0.43230526972339456,
    m02: -0.008528664575177328,
    m10: -0.14705425642099013,
    m11: 0.5183602715367776,
    m12: 0.04004282165408487,
    m20: 0.15996265166373125,
    m21: 0.0492912282128556,
    m22: 0.9684866957875502
  }
}, xG = /* @__PURE__ */ new Map([
  // ASTM E308-01
  ["a", [1.0985, 0.35585]],
  // Wyszecki & Stiles, p. 769
  ["b", [1.0985, 0.35585]],
  // C ASTM E308-01
  ["c", [0.98074, 1.18232]],
  // D50 (ASTM E308-01)
  ["d50", [0.96422, 0.82521]],
  // D55 (ASTM E308-01)
  ["d55", [0.95682, 0.92149]],
  // D65 (ASTM E308-01)
  ["d65", [0.95047, 1.08883]],
  // E (ASTM E308-01)
  ["e", [1, 1, 1]],
  // F2 (ASTM E308-01)
  ["f2", [0.99186, 0.67393]],
  // F7 (ASTM E308-01)
  ["f7", [0.95041, 1.08747]],
  // F11 (ASTM E308-01)
  ["f11", [1.00962, 0.6435]],
  ["icc", [0.96422, 0.82521]]
]);
function Sl(e) {
  const t = xG.get(String(e).toLowerCase());
  if (!t)
    throw new Error("unknown Lab illuminant " + e);
  ko.labWhitePoint = e, ko.Xn = t[0], ko.Zn = t[1];
}
function Nm() {
  return ko.labWhitePoint;
}
const MT = (...e) => {
  e = or(e, "lab");
  const [t, r, n] = e, [a, s, i] = _G(t, r, n), [o, l, c] = k3(a, s, i);
  return [o, l, c, e.length > 3 ? e[3] : 1];
}, _G = (e, t, r) => {
  const { kE: n, kK: a, kKE: s, Xn: i, Yn: o, Zn: l } = ko, c = (e + 16) / 116, u = 2e-3 * t + c, d = c - 5e-3 * r, f = u * u * u, h = d * d * d, p = f > n ? f : (116 * u - 16) / a, m = e > s ? Math.pow((e + 16) / 116, 3) : e / a, g = h > n ? h : (116 * d - 16) / a, y = p * i, x = m * o, w = g * l;
  return [y, x, w];
}, T1 = (e) => {
  const t = Math.sign(e);
  return e = Math.abs(e), (e <= 31308e-7 ? e * 12.92 : 1.055 * Math.pow(e, 1 / 2.4) - 0.055) * t;
}, k3 = (e, t, r) => {
  const { MtxAdaptMa: n, MtxAdaptMaI: a, MtxXYZ2RGB: s, RefWhiteRGB: i, Xn: o, Yn: l, Zn: c } = ko, u = o * n.m00 + l * n.m10 + c * n.m20, d = o * n.m01 + l * n.m11 + c * n.m21, f = o * n.m02 + l * n.m12 + c * n.m22, h = i.X * n.m00 + i.Y * n.m10 + i.Z * n.m20, p = i.X * n.m01 + i.Y * n.m11 + i.Z * n.m21, m = i.X * n.m02 + i.Y * n.m12 + i.Z * n.m22, g = (e * n.m00 + t * n.m10 + r * n.m20) * (h / u), y = (e * n.m01 + t * n.m11 + r * n.m21) * (p / d), x = (e * n.m02 + t * n.m12 + r * n.m22) * (m / f), w = g * a.m00 + y * a.m10 + x * a.m20, _ = g * a.m01 + y * a.m11 + x * a.m21, S = g * a.m02 + y * a.m12 + x * a.m22, C = T1(
    w * s.m00 + _ * s.m10 + S * s.m20
  ), E = T1(
    w * s.m01 + _ * s.m11 + S * s.m21
  ), O = T1(
    w * s.m02 + _ * s.m12 + S * s.m22
  );
  return [C * 255, E * 255, O * 255];
}, LT = (...e) => {
  const [t, r, n, ...a] = or(e, "rgb"), [s, i, o] = O3(t, r, n), [l, c, u] = SG(s, i, o);
  return [l, c, u, ...a.length > 0 && a[0] < 1 ? [a[0]] : []];
};
function SG(e, t, r) {
  const { Xn: n, Yn: a, Zn: s, kE: i, kK: o } = ko, l = e / n, c = t / a, u = r / s, d = l > i ? Math.pow(l, 1 / 3) : (o * l + 16) / 116, f = c > i ? Math.pow(c, 1 / 3) : (o * c + 16) / 116, h = u > i ? Math.pow(u, 1 / 3) : (o * u + 16) / 116;
  return [116 * f - 16, 500 * (d - f), 200 * (f - h)];
}
function C1(e) {
  const t = Math.sign(e);
  return e = Math.abs(e), (e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4)) * t;
}
const O3 = (e, t, r) => {
  e = C1(e / 255), t = C1(t / 255), r = C1(r / 255);
  const { MtxRGB2XYZ: n, MtxAdaptMa: a, MtxAdaptMaI: s, Xn: i, Yn: o, Zn: l, As: c, Bs: u, Cs: d } = ko;
  let f = e * n.m00 + t * n.m10 + r * n.m20, h = e * n.m01 + t * n.m11 + r * n.m21, p = e * n.m02 + t * n.m12 + r * n.m22;
  const m = i * a.m00 + o * a.m10 + l * a.m20, g = i * a.m01 + o * a.m11 + l * a.m21, y = i * a.m02 + o * a.m12 + l * a.m22;
  let x = f * a.m00 + h * a.m10 + p * a.m20, w = f * a.m01 + h * a.m11 + p * a.m21, _ = f * a.m02 + h * a.m12 + p * a.m22;
  return x *= m / c, w *= g / u, _ *= y / d, f = x * s.m00 + w * s.m10 + _ * s.m20, h = x * s.m01 + w * s.m11 + _ * s.m21, p = x * s.m02 + w * s.m12 + _ * s.m22, [f, h, p];
};
ft.prototype.lab = function() {
  return LT(this._rgb);
};
const EG = (...e) => new ft(...e, "lab");
Object.assign(Qt, { lab: EG, getLabWhitePoint: Nm, setLabWhitePoint: Sl });
rr.format.lab = MT;
rr.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = or(e, "lab"), vr(e) === "array" && e.length === 3)
      return "lab";
  }
});
ft.prototype.darken = function(e = 1) {
  const t = this, r = t.lab();
  return r[0] -= ko.Kn * e, new ft(r, "lab").alpha(t.alpha(), !0);
};
ft.prototype.brighten = function(e = 1) {
  return this.darken(-e);
};
ft.prototype.darker = ft.prototype.darken;
ft.prototype.brighter = ft.prototype.brighten;
ft.prototype.get = function(e) {
  const [t, r] = e.split("."), n = this[t]();
  if (r) {
    const a = t.indexOf(r) - (t.substr(0, 2) === "ok" ? 2 : 0);
    if (a > -1) return n[a];
    throw new Error(`unknown channel ${r} in mode ${t}`);
  } else
    return n;
};
const { pow: TG } = Math, CG = 1e-7, kG = 20;
ft.prototype.luminance = function(e, t = "rgb") {
  if (e !== void 0 && vr(e) === "number") {
    if (e === 0)
      return new ft([0, 0, 0, this._rgb[3]], "rgb");
    if (e === 1)
      return new ft([255, 255, 255, this._rgb[3]], "rgb");
    let r = this.luminance(), n = kG;
    const a = (i, o) => {
      const l = i.interpolate(o, 0.5, t), c = l.luminance();
      return Math.abs(e - c) < CG || !n-- ? l : c > e ? a(i, l) : a(l, o);
    }, s = (r > e ? a(new ft([0, 0, 0]), this) : a(this, new ft([255, 255, 255]))).rgb();
    return new ft([...s, this._rgb[3]]);
  }
  return OG(...this._rgb.slice(0, 3));
};
const OG = (e, t, r) => (e = k1(e), t = k1(t), r = k1(r), 0.2126 * e + 0.7152 * t + 0.0722 * r), k1 = (e) => (e /= 255, e <= 0.03928 ? e / 12.92 : TG((e + 0.055) / 1.055, 2.4)), za = {}, Xf = (e, t, r = 0.5, ...n) => {
  let a = n[0] || "lrgb";
  if (!za[a] && !n.length && (a = Object.keys(za)[0]), !za[a])
    throw new Error(`interpolation mode ${a} is not defined`);
  return vr(e) !== "object" && (e = new ft(e)), vr(t) !== "object" && (t = new ft(t)), za[a](e, t, r).alpha(
    e.alpha() + r * (t.alpha() - e.alpha())
  );
};
ft.prototype.mix = ft.prototype.interpolate = function(e, t = 0.5, ...r) {
  return Xf(this, e, t, ...r);
};
ft.prototype.premultiply = function(e = !1) {
  const t = this._rgb, r = t[3];
  return e ? (this._rgb = [t[0] * r, t[1] * r, t[2] * r, r], this) : new ft([t[0] * r, t[1] * r, t[2] * r, r], "rgb");
};
const { sin: AG, cos: PG } = Math, A3 = (...e) => {
  let [t, r, n] = or(e, "lch");
  return isNaN(n) && (n = 0), n = n * gG, [t, PG(n) * r, AG(n) * r];
}, jT = (...e) => {
  e = or(e, "lch");
  const [t, r, n] = e, [a, s, i] = A3(t, r, n), [o, l, c] = MT(a, s, i);
  return [o, l, c, e.length > 3 ? e[3] : 1];
}, RG = (...e) => {
  const t = E3(or(e, "hcl"));
  return jT(...t);
}, { sqrt: IG, atan2: DG, round: NG } = Math, P3 = (...e) => {
  const [t, r, n] = or(e, "lab"), a = IG(r * r + n * n);
  let s = (DG(n, r) * vG + 360) % 360;
  return NG(a * 1e4) === 0 && (s = Number.NaN), [t, a, s];
}, FT = (...e) => {
  const [t, r, n, ...a] = or(e, "rgb"), [s, i, o] = LT(t, r, n), [l, c, u] = P3(s, i, o);
  return [l, c, u, ...a.length > 0 && a[0] < 1 ? [a[0]] : []];
};
ft.prototype.lch = function() {
  return FT(this._rgb);
};
ft.prototype.hcl = function() {
  return E3(FT(this._rgb));
};
const MG = (...e) => new ft(...e, "lch"), LG = (...e) => new ft(...e, "hcl");
Object.assign(Qt, { lch: MG, hcl: LG });
rr.format.lch = jT;
rr.format.hcl = RG;
["lch", "hcl"].forEach(
  (e) => rr.autodetect.push({
    p: 2,
    test: (...t) => {
      if (t = or(t, e), vr(t) === "array" && t.length === 3)
        return e;
    }
  })
);
ft.prototype.saturate = function(e = 1) {
  const t = this, r = t.lch();
  return r[1] += ko.Kn * e, r[1] < 0 && (r[1] = 0), new ft(r, "lch").alpha(t.alpha(), !0);
};
ft.prototype.desaturate = function(e = 1) {
  return this.saturate(-e);
};
ft.prototype.set = function(e, t, r = !1) {
  const [n, a] = e.split("."), s = this[n]();
  if (a) {
    const i = n.indexOf(a) - (n.substr(0, 2) === "ok" ? 2 : 0);
    if (i > -1) {
      if (vr(t) == "string")
        switch (t.charAt(0)) {
          case "+":
            s[i] += +t;
            break;
          case "-":
            s[i] += +t;
            break;
          case "*":
            s[i] *= +t.substr(1);
            break;
          case "/":
            s[i] /= +t.substr(1);
            break;
          default:
            s[i] = +t;
        }
      else if (vr(t) === "number")
        s[i] = t;
      else
        throw new Error("unsupported value for Color.set");
      const o = new ft(s, n);
      return r ? (this._rgb = o._rgb, this) : o;
    }
    throw new Error(`unknown channel ${a} in mode ${n}`);
  } else
    return s;
};
ft.prototype.tint = function(e = 0.5, ...t) {
  return Xf(this, "white", e, ...t);
};
ft.prototype.shade = function(e = 0.5, ...t) {
  return Xf(this, "black", e, ...t);
};
const jG = (e, t, r) => {
  const n = e._rgb, a = t._rgb;
  return new ft(
    n[0] + r * (a[0] - n[0]),
    n[1] + r * (a[1] - n[1]),
    n[2] + r * (a[2] - n[2]),
    "rgb"
  );
};
za.rgb = jG;
const { sqrt: O1, pow: Ld } = Math, FG = (e, t, r) => {
  const [n, a, s] = e._rgb, [i, o, l] = t._rgb;
  return new ft(
    O1(Ld(n, 2) * (1 - r) + Ld(i, 2) * r),
    O1(Ld(a, 2) * (1 - r) + Ld(o, 2) * r),
    O1(Ld(s, 2) * (1 - r) + Ld(l, 2) * r),
    "rgb"
  );
};
za.lrgb = FG;
const BG = (e, t, r) => {
  const n = e.lab(), a = t.lab();
  return new ft(
    n[0] + r * (a[0] - n[0]),
    n[1] + r * (a[1] - n[1]),
    n[2] + r * (a[2] - n[2]),
    "lab"
  );
};
za.lab = BG;
const _h = (e, t, r, n) => {
  let a, s;
  n === "hsl" ? (a = e.hsl(), s = t.hsl()) : n === "hsv" ? (a = e.hsv(), s = t.hsv()) : n === "hcg" ? (a = e.hcg(), s = t.hcg()) : n === "hsi" ? (a = e.hsi(), s = t.hsi()) : n === "lch" || n === "hcl" ? (n = "hcl", a = e.hcl(), s = t.hcl()) : n === "oklch" && (a = e.oklch().reverse(), s = t.oklch().reverse());
  let i, o, l, c, u, d;
  (n.substr(0, 1) === "h" || n === "oklch") && ([i, l, u] = a, [o, c, d] = s);
  let f, h, p, m;
  return !isNaN(i) && !isNaN(o) ? (o > i && o - i > 180 ? m = o - (i + 360) : o < i && i - o > 180 ? m = o + 360 - i : m = o - i, h = i + r * m) : isNaN(i) ? isNaN(o) ? h = Number.NaN : (h = o, (u == 1 || u == 0) && n != "hsv" && (f = c)) : (h = i, (d == 1 || d == 0) && n != "hsv" && (f = l)), f === void 0 && (f = l + r * (c - l)), p = u + r * (d - u), n === "oklch" ? new ft([p, f, h], n) : new ft([h, f, p], n);
}, R3 = (e, t, r) => _h(e, t, r, "lch");
za.lch = R3;
za.hcl = R3;
const UG = (e) => {
  if (vr(e) == "number" && e >= 0 && e <= 16777215) {
    const t = e >> 16, r = e >> 8 & 255, n = e & 255;
    return [t, r, n, 1];
  }
  throw new Error("unknown num color: " + e);
}, VG = (...e) => {
  const [t, r, n] = or(e, "rgb");
  return (t << 16) + (r << 8) + n;
};
ft.prototype.num = function() {
  return VG(this._rgb);
};
const $G = (...e) => new ft(...e, "num");
Object.assign(Qt, { num: $G });
rr.format.num = UG;
rr.autodetect.push({
  p: 5,
  test: (...e) => {
    if (e.length === 1 && vr(e[0]) === "number" && e[0] >= 0 && e[0] <= 16777215)
      return "num";
  }
});
const HG = (e, t, r) => {
  const n = e.num(), a = t.num();
  return new ft(n + r * (a - n), "num");
};
za.num = HG;
const { floor: WG } = Math, zG = (...e) => {
  e = or(e, "hcg");
  let [t, r, n] = e, a, s, i;
  n = n * 255;
  const o = r * 255;
  if (r === 0)
    a = s = i = n;
  else {
    t === 360 && (t = 0), t > 360 && (t -= 360), t < 0 && (t += 360), t /= 60;
    const l = WG(t), c = t - l, u = n * (1 - r), d = u + o * (1 - c), f = u + o * c, h = u + o;
    switch (l) {
      case 0:
        [a, s, i] = [h, f, u];
        break;
      case 1:
        [a, s, i] = [d, h, u];
        break;
      case 2:
        [a, s, i] = [u, h, f];
        break;
      case 3:
        [a, s, i] = [u, d, h];
        break;
      case 4:
        [a, s, i] = [f, u, h];
        break;
      case 5:
        [a, s, i] = [h, u, d];
        break;
    }
  }
  return [a, s, i, e.length > 3 ? e[3] : 1];
}, KG = (...e) => {
  const [t, r, n] = or(e, "rgb"), a = _3(t, r, n), s = S3(t, r, n), i = s - a, o = i * 100 / 255, l = a / (255 - i) * 100;
  let c;
  return i === 0 ? c = Number.NaN : (t === s && (c = (r - n) / i), r === s && (c = 2 + (n - t) / i), n === s && (c = 4 + (t - r) / i), c *= 60, c < 0 && (c += 360)), [c, o, l];
};
ft.prototype.hcg = function() {
  return KG(this._rgb);
};
const qG = (...e) => new ft(...e, "hcg");
Qt.hcg = qG;
rr.format.hcg = zG;
rr.autodetect.push({
  p: 1,
  test: (...e) => {
    if (e = or(e, "hcg"), vr(e) === "array" && e.length === 3)
      return "hcg";
  }
});
const GG = (e, t, r) => _h(e, t, r, "hcg");
za.hcg = GG;
const { cos: jd } = Math, YG = (...e) => {
  e = or(e, "hsi");
  let [t, r, n] = e, a, s, i;
  return isNaN(t) && (t = 0), isNaN(r) && (r = 0), t > 360 && (t -= 360), t < 0 && (t += 360), t /= 360, t < 1 / 3 ? (i = (1 - r) / 3, a = (1 + r * jd(yl * t) / jd(E1 - yl * t)) / 3, s = 1 - (i + a)) : t < 2 / 3 ? (t -= 1 / 3, a = (1 - r) / 3, s = (1 + r * jd(yl * t) / jd(E1 - yl * t)) / 3, i = 1 - (a + s)) : (t -= 2 / 3, s = (1 - r) / 3, i = (1 + r * jd(yl * t) / jd(E1 - yl * t)) / 3, a = 1 - (s + i)), a = Ou(n * a * 3), s = Ou(n * s * 3), i = Ou(n * i * 3), [a * 255, s * 255, i * 255, e.length > 3 ? e[3] : 1];
}, { min: XG, sqrt: QG, acos: JG } = Math, ZG = (...e) => {
  let [t, r, n] = or(e, "rgb");
  t /= 255, r /= 255, n /= 255;
  let a;
  const s = XG(t, r, n), i = (t + r + n) / 3, o = i > 0 ? 1 - s / i : 0;
  return o === 0 ? a = NaN : (a = (t - r + (t - n)) / 2, a /= QG((t - r) * (t - r) + (t - n) * (r - n)), a = JG(a), n > r && (a = yl - a), a /= yl), [a * 360, o, i];
};
ft.prototype.hsi = function() {
  return ZG(this._rgb);
};
const eY = (...e) => new ft(...e, "hsi");
Qt.hsi = eY;
rr.format.hsi = YG;
rr.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = or(e, "hsi"), vr(e) === "array" && e.length === 3)
      return "hsi";
  }
});
const tY = (e, t, r) => _h(e, t, r, "hsi");
za.hsi = tY;
const nE = (...e) => {
  e = or(e, "hsl");
  const [t, r, n] = e;
  let a, s, i;
  if (r === 0)
    a = s = i = n * 255;
  else {
    const o = [0, 0, 0], l = [0, 0, 0], c = n < 0.5 ? n * (1 + r) : n + r - n * r, u = 2 * n - c, d = t / 360;
    o[0] = d + 1 / 3, o[1] = d, o[2] = d - 1 / 3;
    for (let f = 0; f < 3; f++)
      o[f] < 0 && (o[f] += 1), o[f] > 1 && (o[f] -= 1), 6 * o[f] < 1 ? l[f] = u + (c - u) * 6 * o[f] : 2 * o[f] < 1 ? l[f] = c : 3 * o[f] < 2 ? l[f] = u + (c - u) * (2 / 3 - o[f]) * 6 : l[f] = u;
    [a, s, i] = [l[0] * 255, l[1] * 255, l[2] * 255];
  }
  return e.length > 3 ? [a, s, i, e[3]] : [a, s, i, 1];
}, I3 = (...e) => {
  e = or(e, "rgba");
  let [t, r, n] = e;
  t /= 255, r /= 255, n /= 255;
  const a = _3(t, r, n), s = S3(t, r, n), i = (s + a) / 2;
  let o, l;
  return s === a ? (o = 0, l = Number.NaN) : o = i < 0.5 ? (s - a) / (s + a) : (s - a) / (2 - s - a), t == s ? l = (r - n) / (s - a) : r == s ? l = 2 + (n - t) / (s - a) : n == s && (l = 4 + (t - r) / (s - a)), l *= 60, l < 0 && (l += 360), e.length > 3 && e[3] !== void 0 ? [l, o, i, e[3]] : [l, o, i];
};
ft.prototype.hsl = function() {
  return I3(this._rgb);
};
const rY = (...e) => new ft(...e, "hsl");
Qt.hsl = rY;
rr.format.hsl = nE;
rr.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = or(e, "hsl"), vr(e) === "array" && e.length === 3)
      return "hsl";
  }
});
const nY = (e, t, r) => _h(e, t, r, "hsl");
za.hsl = nY;
const { floor: aY } = Math, sY = (...e) => {
  e = or(e, "hsv");
  let [t, r, n] = e, a, s, i;
  if (n *= 255, r === 0)
    a = s = i = n;
  else {
    t === 360 && (t = 0), t > 360 && (t -= 360), t < 0 && (t += 360), t /= 60;
    const o = aY(t), l = t - o, c = n * (1 - r), u = n * (1 - r * l), d = n * (1 - r * (1 - l));
    switch (o) {
      case 0:
        [a, s, i] = [n, d, c];
        break;
      case 1:
        [a, s, i] = [u, n, c];
        break;
      case 2:
        [a, s, i] = [c, n, d];
        break;
      case 3:
        [a, s, i] = [c, u, n];
        break;
      case 4:
        [a, s, i] = [d, c, n];
        break;
      case 5:
        [a, s, i] = [n, c, u];
        break;
    }
  }
  return [a, s, i, e.length > 3 ? e[3] : 1];
}, { min: iY, max: oY } = Math, lY = (...e) => {
  e = or(e, "rgb");
  let [t, r, n] = e;
  const a = iY(t, r, n), s = oY(t, r, n), i = s - a;
  let o, l, c;
  return c = s / 255, s === 0 ? (o = Number.NaN, l = 0) : (l = i / s, t === s && (o = (r - n) / i), r === s && (o = 2 + (n - t) / i), n === s && (o = 4 + (t - r) / i), o *= 60, o < 0 && (o += 360)), [o, l, c];
};
ft.prototype.hsv = function() {
  return lY(this._rgb);
};
const cY = (...e) => new ft(...e, "hsv");
Qt.hsv = cY;
rr.format.hsv = sY;
rr.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = or(e, "hsv"), vr(e) === "array" && e.length === 3)
      return "hsv";
  }
});
const uY = (e, t, r) => _h(e, t, r, "hsv");
za.hsv = uY;
function Fy(e, t) {
  let r = e.length;
  Array.isArray(e[0]) || (e = [e]), Array.isArray(t[0]) || (t = t.map((i) => [i]));
  let n = t[0].length, a = t[0].map((i, o) => t.map((l) => l[o])), s = e.map(
    (i) => a.map((o) => Array.isArray(i) ? i.reduce((l, c, u) => l + c * (o[u] || 0), 0) : o.reduce((l, c) => l + c * i, 0))
  );
  return r === 1 && (s = s[0]), n === 1 ? s.map((i) => i[0]) : s;
}
const BT = (...e) => {
  e = or(e, "lab");
  const [t, r, n, ...a] = e, [s, i, o] = dY([t, r, n]), [l, c, u] = k3(s, i, o);
  return [l, c, u, ...a.length > 0 && a[0] < 1 ? [a[0]] : []];
};
function dY(e) {
  var t = [
    [1.2268798758459243, -0.5578149944602171, 0.2813910456659647],
    [-0.0405757452148008, 1.112286803280317, -0.0717110580655164],
    [-0.0763729366746601, -0.4214933324022432, 1.5869240198367816]
  ], r = [
    [1, 0.3963377773761749, 0.2158037573099136],
    [1, -0.1055613458156586, -0.0638541728258133],
    [1, -0.0894841775298119, -1.2914855480194092]
  ], n = Fy(r, e);
  return Fy(
    t,
    n.map((a) => a ** 3)
  );
}
const UT = (...e) => {
  const [t, r, n, ...a] = or(e, "rgb"), s = O3(t, r, n);
  return [...fY(s), ...a.length > 0 && a[0] < 1 ? [a[0]] : []];
};
function fY(e) {
  const t = [
    [0.819022437996703, 0.3619062600528904, -0.1288737815209879],
    [0.0329836539323885, 0.9292868615863434, 0.0361446663506424],
    [0.0481771893596242, 0.2642395317527308, 0.6335478284694309]
  ], r = [
    [0.210454268309314, 0.7936177747023054, -0.0040720430116193],
    [1.9779985324311684, -2.42859224204858, 0.450593709617411],
    [0.0259040424655478, 0.7827717124575296, -0.8086757549230774]
  ], n = Fy(t, e);
  return Fy(
    r,
    n.map((a) => Math.cbrt(a))
  );
}
ft.prototype.oklab = function() {
  return UT(this._rgb);
};
const hY = (...e) => new ft(...e, "oklab");
Object.assign(Qt, { oklab: hY });
rr.format.oklab = BT;
rr.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = or(e, "oklab"), vr(e) === "array" && e.length === 3)
      return "oklab";
  }
});
const pY = (e, t, r) => {
  const n = e.oklab(), a = t.oklab();
  return new ft(
    n[0] + r * (a[0] - n[0]),
    n[1] + r * (a[1] - n[1]),
    n[2] + r * (a[2] - n[2]),
    "oklab"
  );
};
za.oklab = pY;
const mY = (e, t, r) => _h(e, t, r, "oklch");
za.oklch = mY;
const { pow: A1, sqrt: P1, PI: R1, cos: uA, sin: dA, atan2: gY } = Math, vY = (e, t = "lrgb", r = null) => {
  const n = e.length;
  r || (r = Array.from(new Array(n)).map(() => 1));
  const a = n / r.reduce(function(d, f) {
    return d + f;
  });
  if (r.forEach((d, f) => {
    r[f] *= a;
  }), e = e.map((d) => new ft(d)), t === "lrgb")
    return yY(e, r);
  const s = e.shift(), i = s.get(t), o = [];
  let l = 0, c = 0;
  for (let d = 0; d < i.length; d++)
    if (i[d] = (i[d] || 0) * r[0], o.push(isNaN(i[d]) ? 0 : r[0]), t.charAt(d) === "h" && !isNaN(i[d])) {
      const f = i[d] / 180 * R1;
      l += uA(f) * r[0], c += dA(f) * r[0];
    }
  let u = s.alpha() * r[0];
  e.forEach((d, f) => {
    const h = d.get(t);
    u += d.alpha() * r[f + 1];
    for (let p = 0; p < i.length; p++)
      if (!isNaN(h[p]))
        if (o[p] += r[f + 1], t.charAt(p) === "h") {
          const m = h[p] / 180 * R1;
          l += uA(m) * r[f + 1], c += dA(m) * r[f + 1];
        } else
          i[p] += h[p] * r[f + 1];
  });
  for (let d = 0; d < i.length; d++)
    if (t.charAt(d) === "h") {
      let f = gY(c / o[d], l / o[d]) / R1 * 180;
      for (; f < 0; ) f += 360;
      for (; f >= 360; ) f -= 360;
      i[d] = f;
    } else
      i[d] = i[d] / o[d];
  return u /= n, new ft(i, t).alpha(u > 0.99999 ? 1 : u, !0);
}, yY = (e, t) => {
  const r = e.length, n = [0, 0, 0, 0];
  for (let a = 0; a < e.length; a++) {
    const s = e[a], i = t[a] / r, o = s._rgb;
    n[0] += A1(o[0], 2) * i, n[1] += A1(o[1], 2) * i, n[2] += A1(o[2], 2) * i, n[3] += o[3] * i;
  }
  return n[0] = P1(n[0]), n[1] = P1(n[1]), n[2] = P1(n[2]), n[3] > 0.9999999 && (n[3] = 1), new ft(NT(n));
}, { pow: bY } = Math;
function By(e) {
  let t = "rgb", r = Qt("#ccc"), n = 0, a = [0, 1], s = [], i = [0, 0], o = !1, l = [], c = !1, u = 0, d = 1, f = !1, h = {}, p = !0, m = 1;
  const g = function(E) {
    if (E = E || ["#fff", "#000"], E && vr(E) === "string" && Qt.brewer && Qt.brewer[E.toLowerCase()] && (E = Qt.brewer[E.toLowerCase()]), vr(E) === "array") {
      E.length === 1 && (E = [E[0], E[0]]), E = E.slice(0);
      for (let O = 0; O < E.length; O++)
        E[O] = Qt(E[O]);
      s.length = 0;
      for (let O = 0; O < E.length; O++)
        s.push(O / (E.length - 1));
    }
    return S(), l = E;
  }, y = function(E) {
    if (o != null) {
      const O = o.length - 1;
      let k = 0;
      for (; k < O && E >= o[k]; )
        k++;
      return k - 1;
    }
    return 0;
  };
  let x = (E) => E, w = (E) => E;
  const _ = function(E, O) {
    let k, A;
    if (O == null && (O = !1), isNaN(E) || E === null)
      return r;
    O ? A = E : o && o.length > 2 ? A = y(E) / (o.length - 2) : d !== u ? A = (E - u) / (d - u) : A = 1, A = w(A), O || (A = x(A)), m !== 1 && (A = bY(A, m)), A = i[0] + A * (1 - i[0] - i[1]), A = Ou(A, 0, 1);
    const P = Math.floor(A * 1e4);
    if (p && h[P])
      k = h[P];
    else {
      if (vr(l) === "array")
        for (let D = 0; D < s.length; D++) {
          const N = s[D];
          if (A <= N) {
            k = l[D];
            break;
          }
          if (A >= N && D === s.length - 1) {
            k = l[D];
            break;
          }
          if (A > N && A < s[D + 1]) {
            A = (A - N) / (s[D + 1] - N), k = Qt.interpolate(
              l[D],
              l[D + 1],
              A,
              t
            );
            break;
          }
        }
      else vr(l) === "function" && (k = l(A));
      p && (h[P] = k);
    }
    return k;
  };
  var S = () => h = {};
  g(e);
  const C = function(E) {
    const O = Qt(_(E));
    return c && O[c] ? O[c]() : O;
  };
  return C.classes = function(E) {
    if (E != null) {
      if (vr(E) === "array")
        o = E, a = [E[0], E[E.length - 1]];
      else {
        const O = Qt.analyze(a);
        E === 0 ? o = [O.min, O.max] : o = Qt.limits(O, "e", E);
      }
      return C;
    }
    return o;
  }, C.domain = function(E) {
    if (!arguments.length)
      return a;
    u = E[0], d = E[E.length - 1], s = [];
    const O = l.length;
    if (E.length === O && u !== d)
      for (let k of Array.from(E))
        s.push((k - u) / (d - u));
    else {
      for (let k = 0; k < O; k++)
        s.push(k / (O - 1));
      if (E.length > 2) {
        const k = E.map((P, D) => D / (E.length - 1)), A = E.map((P) => (P - u) / (d - u));
        A.every((P, D) => k[D] === P) || (w = (P) => {
          if (P <= 0 || P >= 1) return P;
          let D = 0;
          for (; P >= A[D + 1]; ) D++;
          const N = (P - A[D]) / (A[D + 1] - A[D]);
          return k[D] + N * (k[D + 1] - k[D]);
        });
      }
    }
    return a = [u, d], C;
  }, C.mode = function(E) {
    return arguments.length ? (t = E, S(), C) : t;
  }, C.range = function(E, O) {
    return g(E), C;
  }, C.out = function(E) {
    return c = E, C;
  }, C.spread = function(E) {
    return arguments.length ? (n = E, C) : n;
  }, C.correctLightness = function(E) {
    return E == null && (E = !0), f = E, S(), f ? x = function(O) {
      const k = _(0, !0).lab()[0], A = _(1, !0).lab()[0], P = k > A;
      let D = _(O, !0).lab()[0];
      const N = k + (A - k) * O;
      let z = D - N, G = 0, Y = 1, te = 20;
      for (; Math.abs(z) > 0.01 && te-- > 0; )
        (function() {
          return P && (z *= -1), z < 0 ? (G = O, O += (Y - O) * 0.5) : (Y = O, O += (G - O) * 0.5), D = _(O, !0).lab()[0], z = D - N;
        })();
      return O;
    } : x = (O) => O, C;
  }, C.padding = function(E) {
    return E != null ? (vr(E) === "number" && (E = [E, E]), i = E, C) : i;
  }, C.colors = function(E, O) {
    arguments.length < 2 && (O = "hex");
    let k = [];
    if (arguments.length === 0)
      k = l.slice(0);
    else if (E === 1)
      k = [C(0.5)];
    else if (E > 1) {
      const A = a[0], P = a[1] - A;
      k = wY(0, E).map(
        (D) => C(A + D / (E - 1) * P)
      );
    } else {
      e = [];
      let A = [];
      if (o && o.length > 2)
        for (let P = 1, D = o.length, N = 1 <= D; N ? P < D : P > D; N ? P++ : P--)
          A.push((o[P - 1] + o[P]) * 0.5);
      else
        A = a;
      k = A.map((P) => C(P));
    }
    return Qt[O] && (k = k.map((A) => A[O]())), k;
  }, C.cache = function(E) {
    return E != null ? (p = E, C) : p;
  }, C.gamma = function(E) {
    return E != null ? (m = E, C) : m;
  }, C.nodata = function(E) {
    return E != null ? (r = Qt(E), C) : r;
  }, C;
}
function wY(e, t, r) {
  let n = [], a = e < t, s = t;
  for (let i = e; a ? i < s : i > s; a ? i++ : i--)
    n.push(i);
  return n;
}
const xY = function(e) {
  let t = [1, 1];
  for (let r = 1; r < e; r++) {
    let n = [1];
    for (let a = 1; a <= t.length; a++)
      n[a] = (t[a] || 0) + t[a - 1];
    t = n;
  }
  return t;
}, _Y = function(e) {
  let t, r, n, a;
  if (e = e.map((s) => new ft(s)), e.length === 2)
    [r, n] = e.map((s) => s.lab()), t = function(s) {
      const i = [0, 1, 2].map((o) => r[o] + s * (n[o] - r[o]));
      return new ft(i, "lab");
    };
  else if (e.length === 3)
    [r, n, a] = e.map((s) => s.lab()), t = function(s) {
      const i = [0, 1, 2].map(
        (o) => (1 - s) * (1 - s) * r[o] + 2 * (1 - s) * s * n[o] + s * s * a[o]
      );
      return new ft(i, "lab");
    };
  else if (e.length === 4) {
    let s;
    [r, n, a, s] = e.map((i) => i.lab()), t = function(i) {
      const o = [0, 1, 2].map(
        (l) => (1 - i) * (1 - i) * (1 - i) * r[l] + 3 * (1 - i) * (1 - i) * i * n[l] + 3 * (1 - i) * i * i * a[l] + i * i * i * s[l]
      );
      return new ft(o, "lab");
    };
  } else if (e.length >= 5) {
    let s, i, o;
    s = e.map((l) => l.lab()), o = e.length - 1, i = xY(o), t = function(l) {
      const c = 1 - l, u = [0, 1, 2].map(
        (d) => s.reduce(
          (f, h, p) => f + i[p] * c ** (o - p) * l ** p * h[d],
          0
        )
      );
      return new ft(u, "lab");
    };
  } else
    throw new RangeError("No point in running bezier with only one color.");
  return t;
}, SY = (e) => {
  const t = _Y(e);
  return t.scale = () => By(t), t;
}, { round: D3 } = Math;
ft.prototype.rgb = function(e = !0) {
  return e === !1 ? this._rgb.slice(0, 3) : this._rgb.slice(0, 3).map(D3);
};
ft.prototype.rgba = function(e = !0) {
  return this._rgb.slice(0, 4).map((t, r) => r < 3 ? e === !1 ? t : D3(t) : t);
};
const EY = (...e) => new ft(...e, "rgb");
Object.assign(Qt, { rgb: EY });
rr.format.rgb = (...e) => {
  const t = or(e, "rgba");
  return t[3] === void 0 && (t[3] = 1), t;
};
rr.autodetect.push({
  p: 3,
  test: (...e) => {
    if (e = or(e, "rgba"), vr(e) === "array" && (e.length === 3 || e.length === 4 && vr(e[3]) == "number" && e[3] >= 0 && e[3] <= 1))
      return "rgb";
  }
});
const Ui = (e, t, r) => {
  if (!Ui[r])
    throw new Error("unknown blend mode " + r);
  return Ui[r](e, t);
}, Hc = (e) => (t, r) => {
  const n = Qt(r).rgb(), a = Qt(t).rgb();
  return Qt.rgb(e(n, a));
}, Wc = (e) => (t, r) => {
  const n = [];
  return n[0] = e(t[0], r[0]), n[1] = e(t[1], r[1]), n[2] = e(t[2], r[2]), n;
}, TY = (e) => e, CY = (e, t) => e * t / 255, kY = (e, t) => e > t ? t : e, OY = (e, t) => e > t ? e : t, AY = (e, t) => 255 * (1 - (1 - e / 255) * (1 - t / 255)), PY = (e, t) => t < 128 ? 2 * e * t / 255 : 255 * (1 - 2 * (1 - e / 255) * (1 - t / 255)), RY = (e, t) => 255 * (1 - (1 - t / 255) / (e / 255)), IY = (e, t) => e === 255 ? 255 : (e = 255 * (t / 255) / (1 - e / 255), e > 255 ? 255 : e);
Ui.normal = Hc(Wc(TY));
Ui.multiply = Hc(Wc(CY));
Ui.screen = Hc(Wc(AY));
Ui.overlay = Hc(Wc(PY));
Ui.darken = Hc(Wc(kY));
Ui.lighten = Hc(Wc(OY));
Ui.dodge = Hc(Wc(IY));
Ui.burn = Hc(Wc(RY));
const { pow: DY, sin: NY, cos: MY } = Math;
function LY(e = 300, t = -1.5, r = 1, n = 1, a = [0, 1]) {
  let s = 0, i;
  vr(a) === "array" ? i = a[1] - a[0] : (i = 0, a = [a, a]);
  const o = function(l) {
    const c = yl * ((e + 120) / 360 + t * l), u = DY(a[0] + i * l, n), f = (s !== 0 ? r[0] + l * s : r) * u * (1 - u) / 2, h = MY(c), p = NY(c), m = u + f * (-0.14861 * h + 1.78277 * p), g = u + f * (-0.29227 * h - 0.90649 * p), y = u + f * (1.97294 * h);
    return Qt(NT([m * 255, g * 255, y * 255, 1]));
  };
  return o.start = function(l) {
    return l == null ? e : (e = l, o);
  }, o.rotations = function(l) {
    return l == null ? t : (t = l, o);
  }, o.gamma = function(l) {
    return l == null ? n : (n = l, o);
  }, o.hue = function(l) {
    return l == null ? r : (r = l, vr(r) === "array" ? (s = r[1] - r[0], s === 0 && (r = r[1])) : s = 0, o);
  }, o.lightness = function(l) {
    return l == null ? a : (vr(l) === "array" ? (a = l, i = l[1] - l[0]) : (a = [l, l], i = 0), o);
  }, o.scale = () => Qt.scale(o), o.hue(r), o;
}
const jY = "0123456789abcdef", { floor: FY, random: BY } = Math, UY = () => {
  let e = "#";
  for (let t = 0; t < 6; t++)
    e += jY.charAt(FY(BY() * 16));
  return new ft(e, "hex");
}, { log: fA, pow: VY, floor: $Y, abs: HY } = Math;
function N3(e, t = null) {
  const r = {
    min: Number.MAX_VALUE,
    max: Number.MAX_VALUE * -1,
    sum: 0,
    values: [],
    count: 0
  };
  return vr(e) === "object" && (e = Object.values(e)), e.forEach((n) => {
    t && vr(n) === "object" && (n = n[t]), n != null && !isNaN(n) && (r.values.push(n), r.sum += n, n < r.min && (r.min = n), n > r.max && (r.max = n), r.count += 1);
  }), r.domain = [r.min, r.max], r.limits = (n, a) => M3(r, n, a), r;
}
function M3(e, t = "equal", r = 7) {
  vr(e) == "array" && (e = N3(e));
  const { min: n, max: a } = e, s = e.values.sort((o, l) => o - l);
  if (r === 1)
    return [n, a];
  const i = [];
  if (t.substr(0, 1) === "c" && (i.push(n), i.push(a)), t.substr(0, 1) === "e") {
    i.push(n);
    for (let o = 1; o < r; o++)
      i.push(n + o / r * (a - n));
    i.push(a);
  } else if (t.substr(0, 1) === "l") {
    if (n <= 0)
      throw new Error(
        "Logarithmic scales are only possible for values > 0"
      );
    const o = Math.LOG10E * fA(n), l = Math.LOG10E * fA(a);
    i.push(n);
    for (let c = 1; c < r; c++)
      i.push(VY(10, o + c / r * (l - o)));
    i.push(a);
  } else if (t.substr(0, 1) === "q") {
    i.push(n);
    for (let o = 1; o < r; o++) {
      const l = (s.length - 1) * o / r, c = $Y(l);
      if (c === l)
        i.push(s[c]);
      else {
        const u = l - c;
        i.push(s[c] * (1 - u) + s[c + 1] * u);
      }
    }
    i.push(a);
  } else if (t.substr(0, 1) === "k") {
    let o;
    const l = s.length, c = new Array(l), u = new Array(r);
    let d = !0, f = 0, h = null;
    h = [], h.push(n);
    for (let g = 1; g < r; g++)
      h.push(n + g / r * (a - n));
    for (h.push(a); d; ) {
      for (let y = 0; y < r; y++)
        u[y] = 0;
      for (let y = 0; y < l; y++) {
        const x = s[y];
        let w = Number.MAX_VALUE, _;
        for (let S = 0; S < r; S++) {
          const C = HY(h[S] - x);
          C < w && (w = C, _ = S), u[_]++, c[y] = _;
        }
      }
      const g = new Array(r);
      for (let y = 0; y < r; y++)
        g[y] = null;
      for (let y = 0; y < l; y++)
        o = c[y], g[o] === null ? g[o] = s[y] : g[o] += s[y];
      for (let y = 0; y < r; y++)
        g[y] *= 1 / u[y];
      d = !1;
      for (let y = 0; y < r; y++)
        if (g[y] !== h[y]) {
          d = !0;
          break;
        }
      h = g, f++, f > 200 && (d = !1);
    }
    const p = {};
    for (let g = 0; g < r; g++)
      p[g] = [];
    for (let g = 0; g < l; g++)
      o = c[g], p[o].push(s[g]);
    let m = [];
    for (let g = 0; g < r; g++)
      m.push(p[g][0]), m.push(p[g][p[g].length - 1]);
    m = m.sort((g, y) => g - y), i.push(m[0]);
    for (let g = 1; g < m.length; g += 2) {
      const y = m[g];
      !isNaN(y) && i.indexOf(y) === -1 && i.push(y);
    }
  }
  return i;
}
const WY = (e, t) => {
  e = new ft(e), t = new ft(t);
  const r = e.luminance(), n = t.luminance();
  return r > n ? (r + 0.05) / (n + 0.05) : (n + 0.05) / (r + 0.05);
};
/**
 * @license
 *
 * The APCA contrast prediction algorithm is based of the formulas published
 * in the APCA-1.0.98G specification by Myndex. The specification is available at:
 * https://raw.githubusercontent.com/Myndex/apca-w3/master/images/APCAw3_0.1.17_APCA0.0.98G.svg
 *
 * Note that the APCA implementation is still beta, so please update to
 * future versions of chroma.js when they become available.
 *
 * You can read more about the APCA Readability Criterion at
 * https://readtech.org/ARC/
 */
const hA = 0.027, zY = 5e-4, KY = 0.1, pA = 1.14, $v = 0.022, mA = 1.414, qY = (e, t) => {
  e = new ft(e), t = new ft(t), e.alpha() < 1 && (e = Xf(t, e, e.alpha(), "rgb"));
  const r = gA(...e.rgb()), n = gA(...t.rgb()), a = r >= $v ? r : r + Math.pow($v - r, mA), s = n >= $v ? n : n + Math.pow($v - n, mA), i = Math.pow(s, 0.56) - Math.pow(a, 0.57), o = Math.pow(s, 0.65) - Math.pow(a, 0.62), l = Math.abs(s - a) < zY ? 0 : a < s ? i * pA : o * pA;
  return (Math.abs(l) < KY ? 0 : l > 0 ? l - hA : l + hA) * 100;
};
function gA(e, t, r) {
  return 0.2126729 * Math.pow(e / 255, 2.4) + 0.7151522 * Math.pow(t / 255, 2.4) + 0.072175 * Math.pow(r / 255, 2.4);
}
const { sqrt: Jo, pow: qn, min: GY, max: YY, atan2: vA, abs: yA, cos: Hv, sin: bA, exp: XY, PI: wA } = Math;
function QY(e, t, r = 1, n = 1, a = 1) {
  var s = function(Q) {
    return 360 * Q / (2 * wA);
  }, i = function(Q) {
    return 2 * wA * Q / 360;
  };
  e = new ft(e), t = new ft(t);
  const [o, l, c] = Array.from(e.lab()), [u, d, f] = Array.from(t.lab()), h = (o + u) / 2, p = Jo(qn(l, 2) + qn(c, 2)), m = Jo(qn(d, 2) + qn(f, 2)), g = (p + m) / 2, y = 0.5 * (1 - Jo(qn(g, 7) / (qn(g, 7) + qn(25, 7)))), x = l * (1 + y), w = d * (1 + y), _ = Jo(qn(x, 2) + qn(c, 2)), S = Jo(qn(w, 2) + qn(f, 2)), C = (_ + S) / 2, E = s(vA(c, x)), O = s(vA(f, w)), k = E >= 0 ? E : E + 360, A = O >= 0 ? O : O + 360, P = yA(k - A) > 180 ? (k + A + 360) / 2 : (k + A) / 2, D = 1 - 0.17 * Hv(i(P - 30)) + 0.24 * Hv(i(2 * P)) + 0.32 * Hv(i(3 * P + 6)) - 0.2 * Hv(i(4 * P - 63));
  let N = A - k;
  N = yA(N) <= 180 ? N : A <= k ? N + 360 : N - 360, N = 2 * Jo(_ * S) * bA(i(N) / 2);
  const z = u - o, G = S - _, Y = 1 + 0.015 * qn(h - 50, 2) / Jo(20 + qn(h - 50, 2)), te = 1 + 0.045 * C, ae = 1 + 0.015 * C * D, ne = 30 * XY(-qn((P - 275) / 25, 2)), q = -(2 * Jo(qn(C, 7) / (qn(C, 7) + qn(25, 7)))) * bA(2 * i(ne)), U = Jo(
    qn(z / (r * Y), 2) + qn(G / (n * te), 2) + qn(N / (a * ae), 2) + q * (G / (n * te)) * (N / (a * ae))
  );
  return YY(0, GY(100, U));
}
function JY(e, t, r = "lab") {
  e = new ft(e), t = new ft(t);
  const n = e.get(r), a = t.get(r);
  let s = 0;
  for (let i in n) {
    const o = (n[i] || 0) - (a[i] || 0);
    s += o * o;
  }
  return Math.sqrt(s);
}
const ZY = (...e) => {
  try {
    return new ft(...e), !0;
  } catch {
    return !1;
  }
}, eX = {
  cool() {
    return By([Qt.hsl(180, 1, 0.9), Qt.hsl(250, 0.7, 0.4)]);
  },
  hot() {
    return By(["#000", "#f00", "#ff0", "#fff"]).mode(
      "rgb"
    );
  }
}, aE = {
  // sequential
  OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"],
  PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"],
  BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"],
  Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"],
  BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"],
  YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"],
  YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"],
  Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"],
  RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"],
  Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"],
  YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"],
  Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"],
  GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"],
  Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
  YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"],
  PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"],
  Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"],
  PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"],
  Viridis: ["#440154", "#482777", "#3f4a8a", "#31678e", "#26838f", "#1f9d8a", "#6cce5a", "#b6de2b", "#fee825"],
  // diverging
  Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"],
  RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"],
  RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],
  PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"],
  PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],
  RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
  BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"],
  RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"],
  PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"],
  // qualitative
  Set2: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
  Accent: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"],
  Set1: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"],
  Set3: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"],
  Dark2: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"],
  Paired: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"],
  Pastel2: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"],
  Pastel1: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"]
}, L3 = Object.keys(aE), xA = new Map(L3.map((e) => [e.toLowerCase(), e])), tX = typeof Proxy == "function" ? new Proxy(aE, {
  get(e, t) {
    const r = t.toLowerCase();
    if (xA.has(r))
      return e[xA.get(r)];
  },
  getOwnPropertyNames() {
    return Object.getOwnPropertyNames(L3);
  }
}) : aE, rX = (...e) => {
  e = or(e, "cmyk");
  const [t, r, n, a] = e, s = e.length > 4 ? e[4] : 1;
  return a === 1 ? [0, 0, 0, s] : [
    t >= 1 ? 0 : 255 * (1 - t) * (1 - a),
    // r
    r >= 1 ? 0 : 255 * (1 - r) * (1 - a),
    // g
    n >= 1 ? 0 : 255 * (1 - n) * (1 - a),
    // b
    s
  ];
}, { max: _A } = Math, nX = (...e) => {
  let [t, r, n] = or(e, "rgb");
  t = t / 255, r = r / 255, n = n / 255;
  const a = 1 - _A(t, _A(r, n)), s = a < 1 ? 1 / (1 - a) : 0, i = (1 - t - a) * s, o = (1 - r - a) * s, l = (1 - n - a) * s;
  return [i, o, l, a];
};
ft.prototype.cmyk = function() {
  return nX(this._rgb);
};
const aX = (...e) => new ft(...e, "cmyk");
Object.assign(Qt, { cmyk: aX });
rr.format.cmyk = rX;
rr.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = or(e, "cmyk"), vr(e) === "array" && e.length === 4)
      return "cmyk";
  }
});
const sX = (...e) => {
  const t = or(e, "hsla");
  let r = xh(e) || "lsa";
  return t[0] = ci(t[0] || 0) + "deg", t[1] = ci(t[1] * 100) + "%", t[2] = ci(t[2] * 100) + "%", r === "hsla" || t.length > 3 && t[3] < 1 ? (t[3] = "/ " + (t.length > 3 ? t[3] : 1), r = "hsla") : t.length = 3, `${r.substr(0, 3)}(${t.join(" ")})`;
}, iX = (...e) => {
  const t = or(e, "lab");
  let r = xh(e) || "lab";
  return t[0] = ci(t[0]) + "%", t[1] = ci(t[1]), t[2] = ci(t[2]), r === "laba" || t.length > 3 && t[3] < 1 ? t[3] = "/ " + (t.length > 3 ? t[3] : 1) : t.length = 3, `lab(${t.join(" ")})`;
}, oX = (...e) => {
  const t = or(e, "lch");
  let r = xh(e) || "lab";
  return t[0] = ci(t[0]) + "%", t[1] = ci(t[1]), t[2] = isNaN(t[2]) ? "none" : ci(t[2]) + "deg", r === "lcha" || t.length > 3 && t[3] < 1 ? t[3] = "/ " + (t.length > 3 ? t[3] : 1) : t.length = 3, `lch(${t.join(" ")})`;
}, lX = (...e) => {
  const t = or(e, "lab");
  return t[0] = ci(t[0] * 100) + "%", t[1] = rE(t[1]), t[2] = rE(t[2]), t.length > 3 && t[3] < 1 ? t[3] = "/ " + (t.length > 3 ? t[3] : 1) : t.length = 3, `oklab(${t.join(" ")})`;
}, j3 = (...e) => {
  const [t, r, n, ...a] = or(e, "rgb"), [s, i, o] = UT(t, r, n), [l, c, u] = P3(s, i, o);
  return [l, c, u, ...a.length > 0 && a[0] < 1 ? [a[0]] : []];
}, cX = (...e) => {
  const t = or(e, "lch");
  return t[0] = ci(t[0] * 100) + "%", t[1] = rE(t[1]), t[2] = isNaN(t[2]) ? "none" : ci(t[2]) + "deg", t.length > 3 && t[3] < 1 ? t[3] = "/ " + (t.length > 3 ? t[3] : 1) : t.length = 3, `oklch(${t.join(" ")})`;
}, { round: I1 } = Math, uX = (...e) => {
  const t = or(e, "rgba");
  let r = xh(e) || "rgb";
  if (r.substr(0, 3) === "hsl")
    return sX(I3(t), r);
  if (r.substr(0, 3) === "lab") {
    const n = Nm();
    Sl("d50");
    const a = iX(LT(t), r);
    return Sl(n), a;
  }
  if (r.substr(0, 3) === "lch") {
    const n = Nm();
    Sl("d50");
    const a = oX(FT(t), r);
    return Sl(n), a;
  }
  return r.substr(0, 5) === "oklab" ? lX(UT(t)) : r.substr(0, 5) === "oklch" ? cX(j3(t)) : (t[0] = I1(t[0]), t[1] = I1(t[1]), t[2] = I1(t[2]), (r === "rgba" || t.length > 3 && t[3] < 1) && (t[3] = "/ " + (t.length > 3 ? t[3] : 1), r = "rgba"), `${r.substr(0, 3)}(${t.slice(0, r === "rgb" ? 3 : 4).join(" ")})`);
}, F3 = (...e) => {
  e = or(e, "lch");
  const [t, r, n, ...a] = e, [s, i, o] = A3(t, r, n), [l, c, u] = BT(s, i, o);
  return [l, c, u, ...a.length > 0 && a[0] < 1 ? [a[0]] : []];
}, kl = /((?:-?\d+)|(?:-?\d+(?:\.\d+)?)%|none)/.source, Li = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%?)|none)/.source, Uy = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%)|none)/.source, di = /\s*/.source, Sh = /\s+/.source, VT = /\s*,\s*/.source, Ow = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)(?:deg)?)|none)/.source, Eh = /\s*(?:\/\s*((?:[01]|[01]?\.\d+)|\d+(?:\.\d+)?%))?/.source, B3 = new RegExp(
  "^rgba?\\(" + di + [kl, kl, kl].join(Sh) + Eh + "\\)$"
), U3 = new RegExp(
  "^rgb\\(" + di + [kl, kl, kl].join(VT) + di + "\\)$"
), V3 = new RegExp(
  "^rgba\\(" + di + [kl, kl, kl, Li].join(VT) + di + "\\)$"
), $3 = new RegExp(
  "^hsla?\\(" + di + [Ow, Uy, Uy].join(Sh) + Eh + "\\)$"
), H3 = new RegExp(
  "^hsl?\\(" + di + [Ow, Uy, Uy].join(VT) + di + "\\)$"
), W3 = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/, z3 = new RegExp(
  "^lab\\(" + di + [Li, Li, Li].join(Sh) + Eh + "\\)$"
), K3 = new RegExp(
  "^lch\\(" + di + [Li, Li, Ow].join(Sh) + Eh + "\\)$"
), q3 = new RegExp(
  "^oklab\\(" + di + [Li, Li, Li].join(Sh) + Eh + "\\)$"
), G3 = new RegExp(
  "^oklch\\(" + di + [Li, Li, Ow].join(Sh) + Eh + "\\)$"
), { round: Y3 } = Math, Fd = (e) => e.map((t, r) => r <= 2 ? Ou(Y3(t), 0, 255) : t), Gn = (e, t = 0, r = 100, n = !1) => (typeof e == "string" && e.endsWith("%") && (e = parseFloat(e.substring(0, e.length - 1)) / 100, n ? e = t + (e + 1) * 0.5 * (r - t) : e = t + e * (r - t)), +e), ts = (e, t) => e === "none" ? t : e, $T = (e) => {
  if (e = e.toLowerCase().trim(), e === "transparent")
    return [0, 0, 0, 0];
  let t;
  if (rr.format.named)
    try {
      return rr.format.named(e);
    } catch {
    }
  if ((t = e.match(B3)) || (t = e.match(U3))) {
    let r = t.slice(1, 4);
    for (let a = 0; a < 3; a++)
      r[a] = +Gn(ts(r[a], 0), 0, 255);
    r = Fd(r);
    const n = t[4] !== void 0 ? +Gn(t[4], 0, 1) : 1;
    return r[3] = n, r;
  }
  if (t = e.match(V3)) {
    const r = t.slice(1, 5);
    for (let n = 0; n < 4; n++)
      r[n] = +Gn(r[n], 0, 255);
    return r;
  }
  if ((t = e.match($3)) || (t = e.match(H3))) {
    const r = t.slice(1, 4);
    r[0] = +ts(r[0].replace("deg", ""), 0), r[1] = +Gn(ts(r[1], 0), 0, 100) * 0.01, r[2] = +Gn(ts(r[2], 0), 0, 100) * 0.01;
    const n = Fd(nE(r)), a = t[4] !== void 0 ? +Gn(t[4], 0, 1) : 1;
    return n[3] = a, n;
  }
  if (t = e.match(W3)) {
    const r = t.slice(1, 4);
    r[1] *= 0.01, r[2] *= 0.01;
    const n = nE(r);
    for (let a = 0; a < 3; a++)
      n[a] = Y3(n[a]);
    return n[3] = +t[4], n;
  }
  if (t = e.match(z3)) {
    const r = t.slice(1, 4);
    r[0] = Gn(ts(r[0], 0), 0, 100), r[1] = Gn(ts(r[1], 0), -125, 125, !0), r[2] = Gn(ts(r[2], 0), -125, 125, !0);
    const n = Nm();
    Sl("d50");
    const a = Fd(MT(r));
    Sl(n);
    const s = t[4] !== void 0 ? +Gn(t[4], 0, 1) : 1;
    return a[3] = s, a;
  }
  if (t = e.match(K3)) {
    const r = t.slice(1, 4);
    r[0] = Gn(r[0], 0, 100), r[1] = Gn(ts(r[1], 0), 0, 150, !1), r[2] = +ts(r[2].replace("deg", ""), 0);
    const n = Nm();
    Sl("d50");
    const a = Fd(jT(r));
    Sl(n);
    const s = t[4] !== void 0 ? +Gn(t[4], 0, 1) : 1;
    return a[3] = s, a;
  }
  if (t = e.match(q3)) {
    const r = t.slice(1, 4);
    r[0] = Gn(ts(r[0], 0), 0, 1), r[1] = Gn(ts(r[1], 0), -0.4, 0.4, !0), r[2] = Gn(ts(r[2], 0), -0.4, 0.4, !0);
    const n = Fd(BT(r)), a = t[4] !== void 0 ? +Gn(t[4], 0, 1) : 1;
    return n[3] = a, n;
  }
  if (t = e.match(G3)) {
    const r = t.slice(1, 4);
    r[0] = Gn(ts(r[0], 0), 0, 1), r[1] = Gn(ts(r[1], 0), 0, 0.4, !1), r[2] = +ts(r[2].replace("deg", ""), 0);
    const n = Fd(F3(r)), a = t[4] !== void 0 ? +Gn(t[4], 0, 1) : 1;
    return n[3] = a, n;
  }
};
$T.test = (e) => (
  // modern
  B3.test(e) || $3.test(e) || z3.test(e) || K3.test(e) || q3.test(e) || G3.test(e) || // legacy
  U3.test(e) || V3.test(e) || H3.test(e) || W3.test(e) || e === "transparent"
);
ft.prototype.css = function(e) {
  return uX(this._rgb, e);
};
const dX = (...e) => new ft(...e, "css");
Qt.css = dX;
rr.format.css = $T;
rr.autodetect.push({
  p: 5,
  test: (e, ...t) => {
    if (!t.length && vr(e) === "string" && $T.test(e))
      return "css";
  }
});
rr.format.gl = (...e) => {
  const t = or(e, "rgba");
  return t[0] *= 255, t[1] *= 255, t[2] *= 255, t;
};
const fX = (...e) => new ft(...e, "gl");
Qt.gl = fX;
ft.prototype.gl = function() {
  const e = this._rgb;
  return [e[0] / 255, e[1] / 255, e[2] / 255, e[3]];
};
ft.prototype.hex = function(e) {
  return C3(this._rgb, e);
};
const hX = (...e) => new ft(...e, "hex");
Qt.hex = hX;
rr.format.hex = T3;
rr.autodetect.push({
  p: 4,
  test: (e, ...t) => {
    if (!t.length && vr(e) === "string" && [3, 4, 5, 6, 7, 8, 9].indexOf(e.length) >= 0)
      return "hex";
  }
});
const { log: Wv } = Math, X3 = (e) => {
  const t = e / 100;
  let r, n, a;
  return t < 66 ? (r = 255, n = t < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (n = t - 2) + 104.49216199393888 * Wv(n), a = t < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (a = t - 10) + 115.67994401066147 * Wv(a)) : (r = 351.97690566805693 + 0.114206453784165 * (r = t - 55) - 40.25366309332127 * Wv(r), n = 325.4494125711974 + 0.07943456536662342 * (n = t - 50) - 28.0852963507957 * Wv(n), a = 255), [r, n, a, 1];
}, { round: pX } = Math, mX = (...e) => {
  const t = or(e, "rgb"), r = t[0], n = t[2];
  let a = 1e3, s = 4e4;
  const i = 0.4;
  let o;
  for (; s - a > i; ) {
    o = (s + a) * 0.5;
    const l = X3(o);
    l[2] / l[0] >= n / r ? s = o : a = o;
  }
  return pX(o);
};
ft.prototype.temp = ft.prototype.kelvin = ft.prototype.temperature = function() {
  return mX(this._rgb);
};
const D1 = (...e) => new ft(...e, "temp");
Object.assign(Qt, { temp: D1, kelvin: D1, temperature: D1 });
rr.format.temp = rr.format.kelvin = rr.format.temperature = X3;
ft.prototype.oklch = function() {
  return j3(this._rgb);
};
const gX = (...e) => new ft(...e, "oklch");
Object.assign(Qt, { oklch: gX });
rr.format.oklch = F3;
rr.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = or(e, "oklch"), vr(e) === "array" && e.length === 3)
      return "oklch";
  }
});
Object.assign(Qt, {
  analyze: N3,
  average: vY,
  bezier: SY,
  blend: Ui,
  brewer: tX,
  Color: ft,
  colors: Yf,
  contrast: WY,
  contrastAPCA: qY,
  cubehelix: LY,
  deltaE: QY,
  distance: JY,
  input: rr,
  interpolate: Xf,
  limits: M3,
  mix: Xf,
  random: UY,
  scale: By,
  scales: eX,
  valid: ZY
});
const HT = [
  50,
  100,
  200,
  300,
  400,
  500,
  600,
  700,
  800,
  900
];
function SA(e) {
  return { value: e };
}
function vX(e) {
  const t = e.hsl(), r = t[0], n = t[1], a = t[2], s = {
    red: r >= 345 || r <= 15,
    orange: r > 15 && r <= 45,
    yellow: r > 45 && r <= 70,
    yellowGreen: r > 70 && r <= 90,
    green: r > 90 && r <= 150,
    cyan: r > 150 && r <= 195,
    blue: r > 195 && r <= 240,
    purple: r > 240 && r <= 290,
    magenta: r > 290 && r <= 345
  }, i = r >= 345 || r <= 90, o = a > 0.7, l = a > 0.8, c = n > 0.7, u = n > 0.8 && a > 0.5, d = s.yellow || s.orange && o || (s.yellowGreen || s.cyan) && o || l && !c;
  return {
    h: r,
    s: n,
    l: a,
    ...s,
    isWarm: i,
    isLight: o,
    isVeryLight: l,
    isSaturated: c,
    isIntense: u,
    needsWarmDarkShift: i && c,
    needsSaturationBoost: o && !c,
    needsLightnessPreservation: d
  };
}
function fl(e) {
  const t = {
    value: e,
    DEFAULT: SA(e)
  }, r = Qt(e), n = vX(r), {
    h: a,
    s,
    l: i,
    red: o,
    orange: l,
    yellow: c,
    yellowGreen: u,
    magenta: d,
    isWarm: f,
    isSaturated: h,
    isIntense: p,
    needsLightnessPreservation: m
  } = n, g = (() => {
    if (c)
      return Qt.hsl(35, 0.95, i * 0.95);
    if (l)
      return Qt.hsl(25, 0.9, i * 0.92);
    if (o)
      return Qt.hsl(12, 0.88, i * 0.9);
    if (u)
      return Qt.hsl(75, 0.85, i * 0.95);
    if (d)
      return Qt.hsl(350, 0.9, i * 0.9);
    if (f) {
      const w = h ? 15 : 10;
      return Qt.hsl(
        (a - w + 360) % 360,
        Math.min(0.9, s * 1.1),
        i * 0.95
      );
    }
    return Qt.hsl(a, Math.min(0.8, s * 1.05), i * 0.98);
  })(), y = m ? {
    50: 0.99,
    // Almost white for preserved colors
    100: 0.96,
    200: 0.92,
    300: 0.87,
    400: 0.82,
    500: i,
    // Base color
    600: i * 0.95,
    700: i * 0.9,
    800: i * 0.85,
    900: i * 0.8
    // Preserve character
  } : f ? {
    50: 0.97,
    100: 0.93,
    200: 0.88,
    300: 0.83,
    400: 0.77,
    500: i,
    600: i * 0.92,
    700: i * 0.85,
    800: i * 0.78,
    900: i * 0.72
    // Keep warmer
  } : {
    50: 0.98,
    100: 0.92,
    200: 0.84,
    300: 0.76,
    400: 0.68,
    500: i,
    600: i * 0.82,
    700: i * 0.68,
    800: i * 0.54,
    900: i * 0.4
    // Cool colors can go darker
  }, x = m ? {
    50: s * 0.4,
    // Much less saturated for lighter preserved colors
    100: s * 0.5,
    200: s * 0.6,
    300: s * 0.7,
    400: s * 0.85,
    500: s,
    600: Math.min(1, s * 1.05),
    700: Math.min(1, s * 1.1),
    800: Math.min(1, s * 1.15),
    900: Math.min(1, s * 1.2)
  } : f ? {
    50: s * 0.7,
    100: s * 0.75,
    200: s * 0.8,
    300: s * 0.9,
    400: s * 0.95,
    500: s,
    600: Math.min(1, s * 1.05),
    700: Math.min(1, s * 1.1),
    800: Math.min(1, s * 1.15),
    900: Math.min(1, s * 1.2)
  } : {
    50: s * 0.8,
    100: s * 0.85,
    200: s * 0.9,
    300: s * 0.95,
    400: s,
    500: s,
    600: Math.min(1, s * 1.02),
    700: Math.min(1, s * 1.04),
    800: Math.min(1, s * 1.06),
    900: Math.min(1, s * 1.08)
  };
  return HT.forEach((w) => {
    const _ = y[w], S = x[w], C = (() => {
      if (!f || w <= 500) return 0;
      const O = (w - 500) / 400;
      return c ? -O * 8 : l ? -O * 6 : o ? -O * 4 : p ? -O * 5 : -O * 3;
    })();
    let E = Qt.hsl((a + C + 360) % 360, S, _);
    if (f && w > 500) {
      const O = Math.pow((w - 500) / 400, 1.5) * 0.8;
      E = Qt.mix(E, g, O, "hsl");
    }
    t[w] = SA(E.hex());
  }), t;
}
const yX = {
  baseStyle: {
    base: "w-full",
    container: "divide-y divide-gray-200 dark:divide-gray-700",
    item: "border-b border-border",
    header: "w-full",
    trigger: "flex w-full items-center justify-between py-4 px-4 text-left hover:bg-gray-50 dark:hover:bg-gray-800",
    content: "overflow-hidden transition-all duration-200",
    contentInner: "px-4 pb-4 pt-0",
    icon: "h-5 w-5 text-gray-500 transition-transform duration-200",
    states: {
      open: {
        item: "bg-gray-50 dark:bg-gray-800",
        trigger: "text-primary-600 dark:text-primary-400",
        icon: "transform rotate-180 text-primary-600 dark:text-primary-400"
      },
      disabled: {
        item: "opacity-50 cursor-not-allowed",
        trigger: "cursor-not-allowed"
      }
    }
  },
  variants: {
    default: {
      container: "",
      item: "border-b border-border"
    },
    bordered: {
      container: "border border-border rounded-lg",
      item: "border-b border-border last:border-b-0"
    }
  },
  sizes: {
    sm: {
      trigger: "py-2 px-3 text-sm",
      contentInner: "px-3 pb-2 pt-0"
    },
    md: {
      trigger: "py-3 px-4 text-base",
      contentInner: "px-4 pb-3 pt-0"
    },
    lg: {
      trigger: "py-4 px-5 text-lg",
      contentInner: "px-5 pb-4 pt-0"
    }
  },
  defaultProps: {
    variant: "default",
    size: "md"
  }
}, bX = {
  baseStyle: {
    container: "space-y-4",
    item: "flex items-start gap-4 p-4 bg-white dark:bg-gray-800 rounded-lg shadow transition-colors duration-200",
    dragHandle: "cursor-move text-gray-400",
    fieldsContainer: "grid grid-cols-12 gap-6 flex-1",
    button: "",
    helperText: "mt-1.5 text-sm text-gray-500 dark:text-gray-400",
    helperTextError: "text-sm text-red-500 dark:text-red-400"
  },
  variants: {
    default: {
      item: "hover:border-primary-500",
      dragHandle: "hover:text-gray-600"
    },
    dragging: {
      item: "border-2 border-primary-500 opacity-50"
    }
  },
  defaultProps: {
    variant: "default"
  }
}, wX = {
  baseStyle: {
    base: "inline-flex items-center rounded-full font-medium transition-colors duration-200",
    container: "relative flex items-center",
    content: "flex-grow",
    icon: "mr-1.5 flex-shrink-0",
    dot: "mr-1.5 h-1.5 w-1.5 rounded-full",
    remove: "ml-1 -mr-1 p-0.5 hover:bg-black/5 dark:hover:bg-white/5 rounded-full focus:outline-none focus:ring-offset-2 transition-colors duration-150",
    loadingSpinner: "animate-spin -ml-1 mr-2 h-3 w-3",
    states: {
      disabled: "opacity-50 cursor-not-allowed pointer-events-none",
      loading: "cursor-wait",
      withIcon: "pl-2",
      withDot: "pl-2",
      withRemove: "pr-2"
    }
  },
  variants: {
    solid: {
      base: "bg-opacity-15",
      primary: "bg-primary-100 text-primary-800 dark:bg-primary-700 dark:text-primary-200",
      secondary: "bg-secondary-100 text-secondary-800 dark:bg-secondary-700 dark:text-secondary-200",
      success: "bg-success-100 text-success-800 dark:bg-success-700 dark:text-success-200",
      danger: "bg-danger-100 text-danger-800 dark:bg-danger-700 dark:text-danger-200",
      warning: "bg-warning-100 text-warning-800 dark:bg-warning-700 dark:text-warning-200",
      info: "bg-info-100 text-info-800 dark:bg-info-700 dark:text-info-200"
    },
    outline: {
      base: "bg-transparent border",
      primary: "border-primary-500 text-primary-700 dark:text-primary-300",
      secondary: "border-secondary-500 text-secondary-700 dark:text-secondary-300",
      success: "border-success-500 text-success-700 dark:text-success-300",
      danger: "border-danger-500 text-danger-700 dark:text-danger-300",
      warning: "border-warning-500 text-warning-700 dark:text-warning-300",
      info: "border-info-500 text-info-700 dark:text-info-300"
    },
    ghost: {
      base: "bg-transparent",
      primary: "text-primary-700 dark:text-primary-300",
      secondary: "text-secondary-700 dark:text-secondary-300",
      success: "text-success-700 dark:text-success-300",
      danger: "text-danger-700 dark:text-danger-300",
      warning: "text-warning-700 dark:text-warning-300",
      info: "text-info-700 dark:text-info-300"
    },
    soft: {
      base: "bg-opacity-10",
      primary: "bg-primary-50 text-primary-700 dark:bg-primary-900 dark:text-primary-300",
      secondary: "bg-secondary-50 text-secondary-700 dark:bg-secondary-900 dark:text-secondary-300",
      success: "bg-success-50 text-success-700 dark:bg-success-900 dark:text-success-300",
      danger: "bg-danger-50 text-danger-700 dark:bg-danger-900 dark:text-danger-300",
      warning: "bg-warning-50 text-warning-700 dark:bg-warning-900 dark:text-warning-300",
      info: "bg-info-50 text-info-700 dark:bg-info-900 dark:text-info-300"
    }
  },
  sizes: {
    sm: {
      base: "px-2 py-0.5 text-xs"
    },
    md: {
      base: "px-2.5 py-0.5 text-sm"
    },
    lg: {
      base: "px-3 py-1 text-base"
    }
  },
  defaultProps: {
    variant: "solid",
    color: "primary",
    size: "md"
  }
}, xX = {
  baseStyle: {
    base: "inline-flex items-center justify-center border font-medium rounded-md focus:outline-none focus:ring-offset-2 transition-all duration-200 ease-in-out dark:focus:ring-offset-gray-800",
    container: "relative inline-flex",
    states: {
      loading: "opacity-70 cursor-not-allowed shadow-none pointer-events-none",
      active: "ring-2 ring-offset-2",
      disabled: "cursor-not-allowed shadow-none pointer-events-none bg-gray-200 dark:bg-gray-700 text-gray-400 dark:text-gray-500 border-gray-200 dark:border-gray-700",
      fullWidth: "w-full"
    },
    elements: {
      loadingSpinner: "animate-spin",
      content: "flex items-center",
      leftIcon: "flex-shrink-0",
      rightIcon: "flex-shrink-0",
      iconOnly: "m-0"
    },
    colors: {
      primary: {
        solid: `
        bg-primary-500 hover:bg-primary-600 border-primary-500 hover:border-primary-600
        focus:ring-primary-400 dark:bg-primary-600 dark:hover:bg-primary-700
        dark:border-white disabled:bg-gray-200 disabled:border-gray-200
        disabled:dark:bg-gray-700 disabled:dark:border-gray-700
        disabled:text-gray-400 disabled:dark:text-gray-500
      `,
        outline: `
        text-primary-500 border-primary-500 hover:bg-primary-50
        dark:text-primary-400 dark:border-primary-400 dark:hover:bg-primary-900/10
        disabled:text-gray-400 disabled:border-gray-200
        disabled:dark:text-gray-500 disabled:dark:border-gray-700
        disabled:hover:bg-transparent
      `,
        ghost: "text-primary-600 border-transparent hover:bg-primary-50 dark:text-primary-400 dark:hover:bg-primary-900/10",
        link: "text-primary-600 border-transparent hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300",
        soft: "text-primary-600 border-primary-100 bg-primary-50 hover:bg-primary-100 dark:text-primary-400 dark:border-primary-800 dark:bg-primary-900 dark:hover:bg-primary-800"
      },
      secondary: {
        solid: "bg-secondary-600 hover:bg-secondary-700 border-secondary-600 hover:border-secondary-700 focus:ring-secondary-500 dark:bg-secondary-500 dark:hover:bg-secondary-600 dark:border-secondary-500 dark:hover:border-secondary-600",
        outline: "text-secondary-600 border-secondary-600 hover:bg-secondary-50 dark:text-secondary-400 dark:border-secondary-400 dark:hover:bg-secondary-900/10",
        ghost: "text-secondary-600 border-transparent hover:bg-secondary-50 dark:text-secondary-400 dark:hover:bg-secondary-900/10",
        link: "text-secondary-600 border-transparent hover:text-secondary-700 dark:text-secondary-400 dark:hover:text-secondary-300",
        soft: "text-secondary-600 border-secondary-100 bg-secondary-50 hover:bg-secondary-100 dark:text-secondary-400 dark:border-secondary-800 dark:bg-secondary-900 dark:hover:bg-secondary-800"
      },
      success: {
        solid: "bg-success-600 hover:bg-success-700 border-success-600 hover:border-success-700 focus:ring-success-500 dark:bg-success-500 dark:hover:bg-success-600 dark:border-success-500 dark:hover:border-success-600",
        outline: "text-success-600 border-success-600 hover:bg-success-50 dark:text-success-400 dark:border-success-400 dark:hover:bg-success-900/10",
        ghost: "text-success-600 border-transparent hover:bg-success-50 dark:text-success-400 dark:hover:bg-success-900/10",
        link: "text-success-600 border-transparent hover:text-success-700 dark:text-success-400 dark:hover:text-success-300",
        soft: "text-success-600 border-success-100 bg-success-50 hover:bg-success-100 dark:text-success-400 dark:border-success-800 dark:bg-success-900 dark:hover:bg-success-800"
      },
      danger: {
        solid: "bg-danger-600 hover:bg-danger-700 border-danger-600 hover:border-danger-700 focus:ring-danger-500 dark:bg-danger-500 dark:hover:bg-danger-600 dark:border-danger-500 dark:hover:border-danger-600",
        outline: "text-danger-600 border-danger-600 hover:bg-danger-50 dark:text-danger-400 dark:border-danger-400 dark:hover:bg-danger-900/10",
        ghost: "text-danger-600 border-transparent hover:bg-danger-50 dark:text-danger-400 dark:hover:bg-danger-900/10",
        link: "text-danger-600 border-transparent hover:text-danger-700 dark:text-danger-400 dark:hover:text-danger-300",
        soft: "text-danger-600 border-danger-100 bg-danger-50 hover:bg-danger-100 dark:text-danger-400 dark:border-danger-800 dark:bg-danger-900 dark:hover:bg-danger-800"
      },
      warning: {
        solid: "bg-warning-600 hover:bg-warning-700 border-warning-600 hover:border-warning-700 focus:ring-warning-500 dark:bg-warning-500 dark:hover:bg-warning-600 dark:border-warning-500 dark:hover:border-warning-600",
        outline: "text-warning-600 border-warning-600 hover:bg-warning-50 dark:text-warning-400 dark:border-warning-400 dark:hover:bg-warning-900/10",
        ghost: "text-warning-600 border-transparent hover:bg-warning-50 dark:text-warning-400 dark:hover:bg-warning-900/10",
        link: "text-warning-600 border-transparent hover:text-warning-700 dark:text-warning-400 dark:hover:text-warning-300",
        soft: "text-warning-600 border-warning-100 bg-warning-50 hover:bg-warning-100 dark:text-warning-400 dark:border-warning-800 dark:bg-warning-900 dark:hover:bg-warning-800"
      },
      info: {
        solid: "bg-info-600 hover:bg-info-700 border-info-600 hover:border-info-700 focus:ring-info-500 dark:bg-info-500 dark:hover:bg-info-600 dark:border-info-500 dark:hover:border-info-600",
        outline: "text-info-600 border-info-600 hover:bg-info-50 dark:text-info-400 dark:border-info-400 dark:hover:bg-info-900/10",
        ghost: "text-info-600 border-transparent hover:bg-info-50 dark:text-info-400 dark:hover:bg-info-900/10",
        link: "text-info-600 border-transparent hover:text-info-700 dark:text-info-400 dark:hover:text-info-300",
        soft: "text-info-600 border-info-100 bg-info-50 hover:bg-info-100 dark:text-info-400 dark:border-info-800 dark:bg-info-900 dark:hover:bg-info-800"
      },
      gray: {
        solid: "bg-gray-600 hover:bg-gray-700 border-gray-600 hover:border-gray-700 focus:ring-gray-500 dark:bg-gray-500 dark:hover:bg-gray-600 dark:border-gray-500 dark:hover:border-gray-600",
        outline: "text-gray-600 border-gray-600 hover:bg-gray-50 dark:text-gray-400 dark:border-gray-400 dark:hover:bg-gray-900/10",
        ghost: "text-gray-600 border-transparent hover:bg-gray-50 dark:text-gray-400 dark:hover:bg-gray-900/10",
        link: "text-gray-600 border-transparent hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300",
        soft: "text-gray-600 border-gray-100 bg-gray-50 hover:bg-gray-100 dark:text-gray-400 dark:border-gray-800 dark:bg-gray-900 dark:hover:bg-gray-800"
      },
      white: {
        solid: "bg-white hover:bg-gray-50 border-white hover:border-gray-50 focus:ring-gray-50 dark:bg-gray-900 dark:hover:bg-gray-800 dark:border-gray-800 dark:hover:border-gray-800",
        outline: "text-white border-white hover:bg-gray-50 dark:text-gray-400 dark:border-gray-400 dark:hover:bg-gray-900/10",
        ghost: "text-white border-transparent hover:bg-gray-50 dark:text-gray-400 dark:hover:bg-gray-900/10",
        link: "text-white border-transparent hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300",
        soft: "text-white border-white bg-gray-50 hover:bg-gray-100 dark:text-gray-400 dark:border-gray-800 dark:bg-gray-900 dark:hover:bg-gray-800"
      }
    }
  },
  sizes: {
    xs: {
      base: "text-xs py-1 px-2"
    },
    sm: {
      base: "text-sm py-1.5 px-2.5"
    },
    md: {
      base: "text-base py-2 px-3"
    },
    lg: {
      base: "text-lg py-2.5 px-3.5"
    },
    xl: {
      base: "text-xl py-3 px-4"
    }
  },
  variants: {
    solid: {
      base: "text-white"
    },
    outline: {
      base: "bg-transparent border hover:bg-opacity-10 active:bg-opacity-20"
    },
    ghost: {
      base: "bg-transparent border-transparent hover:bg-opacity-10 focus:ring-0 focus:ring-offset-0"
    },
    link: {
      base: "bg-transparent border-none hover:underline underline-offset-4 focus:ring-0 focus:ring-offset-0"
    },
    soft: {
      base: "border-transparent bg-opacity-10 hover:bg-opacity-20"
    }
  },
  defaultProps: {
    size: "sm",
    variant: "solid",
    color: "primary",
    shape: "rounded"
  }
}, _X = {
  baseStyle: {
    base: "relative transition-colors duration-200",
    container: "flex flex-col",
    header: "text-text",
    body: "flex-grow text-text/70",
    footer: "text-text",
    rounded: {
      none: "rounded-none",
      sm: "rounded-sm",
      md: "rounded",
      lg: "rounded-lg",
      full: "rounded-full"
    },
    shadows: {
      none: "",
      sm: "shadow-sm",
      md: "shadow",
      lg: "shadow-lg",
      xl: "shadow-xl"
    },
    states: {
      hover: "transition duration-300 ease-in-out transform hover:scale-105",
      scrollable: "overflow-y-auto",
      clickable: "cursor-pointer"
    },
    spacing: {
      header: "px-4 py-3",
      body: "px-4 py-4",
      footer: "px-4 py-3",
      divider: "border-border"
    },
    borders: {
      default: "border border-border"
    },
    colors: {
      primary: {
        base: "bg-primary-50 dark:bg-primary-900/20",
        header: "text-primary-700 dark:text-primary-300",
        body: "text-primary-600/70 dark:text-primary-300/70",
        footer: "text-primary-700 dark:text-primary-300",
        border: "border-primary-400 dark:border-primary-700"
      },
      secondary: {
        base: "bg-secondary-400 dark:bg-secondary-900/20",
        header: "text-secondary-700 dark:text-secondary-300",
        body: "text-secondary-600/70 dark:text-secondary-300/70",
        footer: "text-secondary-700 dark:text-secondary-300",
        border: "border-secondary-400 dark:border-secondary-700"
      },
      success: {
        base: "bg-success-50 dark:bg-success-900/20",
        header: "text-success-700 dark:text-success-300",
        body: "text-success-600/70 dark:text-success-300/70",
        footer: "text-success-700 dark:text-success-300",
        border: "border-success-400 dark:border-success-700"
      },
      danger: {
        base: "bg-danger-50 dark:bg-danger-900/20",
        header: "text-danger-700 dark:text-danger-300",
        body: "text-danger-600/70 dark:text-danger-300/70",
        footer: "text-danger-700 dark:text-danger-300",
        border: "border-danger-400 dark:border-danger-700"
      },
      warning: {
        base: "bg-warning-50 dark:bg-warning-900/20",
        header: "text-warning-700 dark:text-warning-300",
        body: "text-warning-600/70 dark:text-warning-300/70",
        footer: "text-warning-700 dark:text-warning-300",
        border: "border-warning-400 dark:border-warning-700"
      },
      info: {
        base: "bg-info-50 dark:bg-info-900/20",
        header: "text-info-700 dark:text-info-300",
        body: "text-info-600/70 dark:text-info-300/70",
        footer: "text-info-700 dark:text-info-300",
        border: "border-info-400 dark:border-info-700"
      },
      gray: {
        base: "bg-gray-50 dark:bg-gray-900/20",
        header: "text-gray-700 dark:text-gray-300",
        body: "text-gray-600/70 dark:text-gray-300/70",
        footer: "text-gray-700 dark:text-gray-300",
        border: "border-gray-300 dark:border-gray-700"
      },
      white: {
        base: "bg-white dark:bg-gray-900/20",
        header: "text-gray-700 dark:text-gray-300",
        body: "text-gray-600/70 dark:text-gray-300/70",
        footer: "text-gray-700 dark:text-gray-300",
        border: "border-gray-200 dark:border-gray-800"
      }
    }
  },
  variants: {
    elevated: {
      base: "shadow-md border border-border"
    },
    outlined: {
      base: "border border-border"
    },
    filled: {
      base: "border border-border"
    },
    error: {
      base: "border border-red-500 dark:border-red-400"
    }
  },
  sizes: {
    sm: {
      spacing: {
        header: "px-3 py-2",
        body: "px-3 py-2",
        footer: "px-3 py-2",
        divider: "border-border"
      }
    },
    md: {
      spacing: {
        header: "px-4 py-3",
        body: "px-4 py-4",
        footer: "px-4 py-3",
        divider: "border-border"
      }
    },
    lg: {
      spacing: {
        header: "px-6 py-4",
        body: "px-6 py-5",
        footer: "px-6 py-4",
        divider: "border-border"
      }
    }
  },
  defaultProps: {
    variant: "outlined",
    size: "md",
    rounded: "lg",
    shadow: "none",
    hover: !1,
    scrollable: !1,
    fitContent: !1,
    color: "gray"
  }
}, SX = {
  baseStyle: {
    base: "form-checkbox transition-all duration-200 ease-in-out focus:outline-none focus:ring-offset-2",
    wrapper: "flex items-center",
    input: "border rounded",
    label: "flex items-center",
    labelText: "ml-2 block",
    helperText: "mt-1 text-sm",
    states: {
      error: "border-red-500 dark:border-red-400 focus:ring-red-500",
      disabled: "opacity-50 cursor-not-allowed",
      checked: "bg-current border-transparent",
      indeterminate: "bg-current border-transparent"
    }
  },
  variants: {
    solid: {
      base: "border-gray-300 dark:border-gray-600 dark:bg-gray-700",
      checked: "text-primary-600 dark:text-primary-400",
      hover: "hover:border-primary-500 dark:hover:border-primary-400"
    },
    outline: {
      base: "bg-transparent border-2",
      checked: "border-primary-600 text-primary-600 dark:border-primary-400 dark:text-primary-400",
      hover: "hover:border-primary-500 dark:hover:border-primary-400"
    }
  },
  sizes: {
    sm: {
      input: "h-3 w-3",
      labelText: "text-xs"
    },
    md: {
      input: "h-4 w-4",
      labelText: "text-sm"
    },
    lg: {
      input: "h-5 w-5",
      labelText: "text-base"
    }
  },
  defaultProps: {
    size: "md",
    variant: "solid",
    color: "primary"
  }
}, EX = {
  baseStyle: {
    container: "relative flex items-center gap-2",
    preview: "aspect-square rounded border border-gray-200 shadow-sm transition-colors cursor-pointer flex-shrink-0",
    input: "flex-1 min-w-full max-w-xs",
    popover: "absolute z-50 p-2 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700",
    formatToggle: "ml-2",
    shadesContainer: "mt-2 grid grid-cols-10 gap-1",
    shade: "relative group",
    shadeLabel: "absolute -bottom-6 left-1/2 -translate-x-1/2 text-xs opacity-0 group-hover:opacity-100 transition-opacity",
    helperText: "mt-1 text-sm text-gray-500 dark:text-gray-400",
    error: "mt-1 text-sm text-red-500 dark:text-red-400",
    label: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1",
    required: "text-red-500 dark:text-red-400 ml-1"
  },
  sizes: {
    xs: { preview: "w-6 h-6" },
    sm: { preview: "w-8 h-8" },
    md: { preview: "w-10 h-10" },
    lg: { preview: "w-12 h-12" },
    xl: { preview: "w-14 h-14" }
  },
  variants: {
    default: {},
    outline: {
      preview: "border-2"
    },
    filled: {
      preview: "border-0 shadow"
    }
  },
  defaultProps: {
    size: "md",
    variant: "default",
    showInput: !0,
    showFormatToggle: !1,
    showShades: !1,
    placement: "bottom"
  }
}, TX = {
  baseStyle: {
    container: "relative w-full",
    input: `
      appearance-none
      border
      border-border
      focus:border-primary-500
      dark:focus:border-primary-400
      focus:ring-primary-500/20
      dark:focus:ring-primary-400/20
      disabled:bg-gray-50
      disabled:dark:bg-gray-800/50
      disabled:border-gray-200
      disabled:dark:border-gray-700
      disabled:text-gray-500
      disabled:dark:text-gray-400
      disabled:cursor-not-allowed
      rounded-md
      w-full
      focus:outline-none
      transition
      duration-200
      ease-in-out
      bg-white
      dark:bg-gray-800
      text-gray-900
      dark:text-white
      placeholder-gray-400
      dark:placeholder-gray-500
    `,
    calendar: "bg-white dark:bg-gray-800 shadow-lg rounded-md mt-1 border border-border",
    header: "px-3 py-2 border-b border-border dark:border-gray-700",
    monthSelect: `
      appearance-none
      bg-white
      dark:bg-gray-800
      border
      border-border
      dark:border-gray-700
      rounded
      py-1
      px-2
      text-sm
      font-medium
      text-gray-900
      dark:text-white
      cursor-pointer
      hover:border-primary-500
      dark:hover:border-primary-400
    `,
    navigation: "flex items-center justify-between",
    navigationButton: `
      p-1
      rounded-full
      hover:bg-gray-100
      dark:hover:bg-gray-700
      text-gray-600
      dark:text-gray-300
      transition-colors
    `,
    weekdays: "px-3 py-2 text-center text-gray-600 dark:text-gray-400 text-xs",
    day: `
      w-8
      h-8
      flex
      items-center
      justify-center
      text-sm
      rounded-full
      hover:bg-primary-50
      dark:hover:bg-primary-900/50
      transition-colors
      text-gray-700
      dark:text-gray-300
    `,
    daySelected: "bg-primary-500 text-white hover:bg-primary-600 dark:hover:bg-primary-400",
    dayDisabled: "text-gray-300 dark:text-gray-600 cursor-not-allowed hover:bg-transparent",
    dayToday: "font-semibold text-primary-500 dark:text-primary-400",
    timeContainer: "p-3 border-t border-border dark:border-gray-700",
    error: "border-red-500 dark:border-red-400 focus:border-red-500 dark:focus:border-red-400 focus:ring-red-500/20",
    helperText: "mt-1.5 text-sm text-red-500 dark:text-red-400",
    yearSelect: `
      appearance-none
      bg-white
      dark:bg-gray-800
      border
      border-border
      dark:border-gray-700
      rounded
      py-1
      px-2
      text-sm
      font-medium
      text-gray-900
      dark:text-white
      cursor-pointer
      hover:border-primary-500
      dark:hover:border-primary-400
    `
  },
  variants: {
    outline: {},
    filled: {
      input: "bg-gray-100 dark:bg-gray-700 border-transparent"
    }
  },
  sizes: {
    sm: {
      input: "text-sm py-1.5 px-2.5",
      day: "w-6 h-6 text-xs"
    },
    md: {
      input: "text-base py-2 px-3",
      day: "w-8 h-8 text-sm"
    },
    lg: {
      input: "text-lg py-2.5 px-3.5",
      day: "w-10 h-10 text-base"
    }
  },
  defaultProps: {
    variant: "outline",
    size: "md"
  }
}, CX = {
  baseStyle: {
    base: "relative inline-block text-left",
    container: "relative",
    trigger: "inline-flex items-center justify-center transition-colors duration-200 w-full",
    menu: "absolute z-50 rounded-md bg-white dark:bg-surface border border-border focus:outline-none",
    menuList: "",
    item: "block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white focus:outline-none focus:bg-gray-100 dark:focus:bg-gray-700 focus:text-gray-900 dark:focus:text-white",
    icon: "mr-3 h-5 w-5 text-gray-400 dark:text-gray-500 group-hover:text-gray-500 dark:group-hover:text-gray-400",
    elements: {
      loadingSpinner: "animate-spin h-4 w-4",
      separator: "h-px my-1 bg-gray-200 dark:bg-gray-700"
    },
    states: {
      open: {
        menu: "transition ease-out duration-200 transform opacity-100 scale-100",
        menuClosed: "transition ease-in duration-150 transform opacity-0 scale-95"
      },
      disabled: {
        trigger: "opacity-50 cursor-not-allowed",
        item: "opacity-50 cursor-not-allowed"
      },
      active: {
        item: "bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white"
      }
    }
  },
  variants: {
    default: {
      menu: "mt-2 w-56"
    },
    contextual: {
      menu: "w-48"
    }
  },
  sizes: {
    xs: {
      menu: "mt-1",
      item: "py-1 px-2 text-xs"
    },
    sm: {
      menu: "mt-1",
      item: "py-1.5 px-3 text-sm"
    },
    md: {
      menu: "mt-1",
      item: "py-2 px-4 text-base"
    },
    lg: {
      menu: "text-lg",
      item: "py-2.5 px-5 text-base"
    },
    xl: {
      menu: "text-xl",
      item: "py-3 px-6 text-lg"
    }
  },
  defaultProps: {
    size: "md",
    variant: "default",
    placement: "bottom-start",
    closeOnSelect: !0
  }
}, kX = {
  baseStyle: {
    container: "space-y-4",
    item: "flex items-center gap-4",
    input: "flex-1",
    removeButton: "flex-shrink-0",
    addButton: "mt-4",
    error: "text-red-500 dark:text-red-400 text-sm mt-1",
    helperText: "text-gray-500 dark:text-gray-400 text-sm mt-1"
  },
  defaultProps: {
    variant: "default"
  }
}, OX = {
  baseStyle: {
    base: "w-full",
    wrapper: "relative w-full",
    dropzone: "border-2 border-dashed rounded-md p-8 text-center cursor-pointer transition-colors bg-white dark:bg-gray-800",
    input: "hidden",
    // preview: "relative group",
    // fileList:
    //   "mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4",
    fileItem: "relative",
    removeButton: "absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity rounded-full p-1",
    progressBar: "absolute bottom-0 left-0 right-0 h-1 bg-gray-200 dark:bg-gray-700",
    progressBarFill: "h-full transition-all duration-300",
    previewImage: "w-full h-24 object-cover rounded-lg shadow-md",
    previewDocument: "w-full h-24 bg-gray-100 dark:bg-gray-700 rounded-md shadow-md flex flex-col items-center justify-center",
    previewVideo: "w-full h-24 bg-gray-100 dark:bg-gray-700 rounded-md shadow-md flex items-center justify-center",
    previewAudio: "w-full h-24 bg-gray-100 dark:bg-gray-700 rounded-md shadow-md flex items-center justify-center",
    previewPdf: "w-full h-24 bg-gray-100 dark:bg-gray-700 rounded-md shadow-md flex flex-col items-center justify-center",
    uploadIcon: "text-primary-500 dark:text-primary-400 mb-4",
    dropzoneText: "text-gray-600 dark:text-gray-300 text-sm",
    fileName: "mt-2 text-xs text-gray-600 dark:text-gray-300 truncate w-full text-center",
    loadingSpinner: "animate-spin mr-2",
    fileIcon: "text-gray-400 dark:text-gray-500",
    error: "text-red-500 dark:text-red-400 mt-2 text-sm",
    dragHandle: "absolute top-1 left-1 cursor-move opacity-0 group-hover:opacity-100 transition-opacity text-gray-500 dark:text-gray-400",
    dragging: "opacity-50 border-2 border-dashed border-primary-500",
    dragOver: "border-2 border-primary-500 bg-primary-50 dark:bg-primary-900/10",
    preview: "relative group transition-all duration-200 rounded-lg overflow-hidden",
    fileList: "mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 relative"
  },
  variants: {
    default: {
      dropzone: "border-border hover:border-primary-500 dark:hover:border-primary-400",
      progressBarFill: "bg-primary-500 dark:bg-primary-400"
      // dropzone:
      //   "border-border hover:border-primary-500 dark:hover:border-primary-400",
      // progressBarFill: "bg-primary-500 dark:bg-primary-400",
    },
    error: {
      dropzone: "border-red-500 dark:border-red-400 text-red-500 dark:text-red-400",
      progressBarFill: "bg-red-500 dark:bg-red-400"
      // dropzone:
      //   "border-red-500 dark:border-red-400 text-red-500 dark:text-red-400",
      // progressBarFill: "bg-red-500 dark:bg-red-400",
    }
  },
  sizes: {
    sm: {
      dropzone: "p-4",
      fileList: "gap-2",
      uploadIcon: "h-8 w-8",
      dropzoneText: "text-xs"
    },
    md: {
      dropzone: "p-8",
      fileList: "gap-4",
      uploadIcon: "h-10 w-10",
      dropzoneText: "text-sm"
    },
    lg: {
      dropzone: "p-12",
      fileList: "gap-6",
      uploadIcon: "h-12 w-12",
      dropzoneText: "text-base"
    }
  },
  defaultProps: {
    variant: "default",
    size: "md",
    multiple: !1,
    color: "primary",
    allowReorder: !0
    // variant: "default",
    // size: "md",
    // multiple: false,
    // color: "primary",
  }
}, AX = {
  baseStyle: {
    base: "inline-flex items-center justify-center transition-colors duration-200",
    container: "relative",
    icon: "w-full h-full",
    sizes: {
      xxs: "w-3 h-3",
      xs: "w-3.5 h-3.5",
      sm: "w-4 h-4",
      md: "w-5 h-5",
      lg: "w-6 h-6",
      xl: "w-8 h-8",
      "2xl": "w-10 h-10",
      "3xl": "w-12 h-12",
      "4xl": "w-14 h-14",
      "5xl": "w-16 h-16"
    },
    colors: {
      current: "text-current",
      primary: "text-primary-600 dark:text-primary-400",
      secondary: "text-secondary-600 dark:text-secondary-400",
      success: "text-green-600 dark:text-green-400",
      danger: "text-red-600 dark:text-red-400",
      warning: "text-yellow-600 dark:text-yellow-400",
      info: "text-blue-600 dark:text-blue-400",
      white: "text-white dark:text-gray-100",
      black: "text-black dark:text-white"
    },
    states: {
      spinning: "animate-spin",
      pulsing: "animate-pulse"
    }
  },
  defaultProps: {
    size: "md"
  }
}, PX = {
  baseStyle: {
    base: "w-full transition duration-150 ease-in-out",
    inputWrapper: "relative flex items-center w-full",
    wrapper: "w-full",
    label: "block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1.5",
    labelDisabled: "text-gray-500 dark:text-gray-400",
    labelError: "text-red-500 dark:text-red-400",
    disabled: "cursor-not-allowed opacity-60",
    helperText: "mt-1.5 text-sm text-gray-500 dark:text-gray-400",
    helperTextError: "mt-1.5 text-sm text-red-500 dark:text-red-400",
    requiredIndicator: "text-red-500 dark:text-red-400 ml-1",
    icon: "text-gray-400 dark:text-gray-500",
    placeholder: "text-gray-400 dark:text-gray-500 truncate",
    startAdornment: "absolute left-0 w-10 flex items-center justify-center pointer-events-none z-10",
    endAdornment: "absolute right-0 w-10 flex items-center justify-center pointer-events-none z-10",
    actionButton: "absolute right-0 w-10 flex items-center justify-center z-10",
    fullWidth: "w-full"
  },
  sizes: {
    xs: {
      default: "text-xs py-1 px-2",
      ghost: "text-xs"
    },
    sm: {
      default: "text-sm py-1.5 px-2.5",
      ghost: "text-sm"
    },
    md: {
      default: "text-base py-2 px-3",
      ghost: "text-base"
    },
    lg: {
      default: "text-lg py-2.5 px-3.5",
      ghost: "text-lg"
    },
    xl: {
      default: "text-xl py-3 px-4",
      ghost: "text-xl"
    }
  },
  variants: {
    default: {
      base: `
       appearance-none
        border
        border-border
        focus:border-primary-500
        dark:focus:border-primary-400
        focus:ring-primary-500/20
        dark:focus:ring-primary-400/20
        disabled:bg-gray-50
        disabled:dark:bg-gray-800/50
        disabled:border-gray-200
        disabled:dark:border-gray-700
        disabled:text-gray-500
        disabled:dark:text-gray-400
        disabled:cursor-not-allowed
        rounded-md
        w-full
        focus:outline-none
        transition
        duration-200
        ease-in-out
        bg-white
        dark:bg-gray-800
        text-gray-900
        dark:text-white
        placeholder-gray-400
        dark:placeholder-gray-500
      `
    },
    ghost: {
      base: `
        border-0
        bg-transparent
        p-0
        m-0
        min-w-[2px]
        focus:ring-0
        focus:outline-none
        text-inherit
        appearance-none
        text-ellipsis
        whitespace-nowrap
      `
    },
    error: {
      base: `
        appearance-none
        border
        rounded-md
        bg-white
        dark:bg-gray-800
        text-gray-800
        dark:text-white
        border-red-500
        dark:border-red-400
        focus:border-red-500
        dark:focus:border-red-400
        focus:ring-red-500
        dark:focus:ring-red-400
      `
    }
  },
  defaultProps: {
    size: "md",
    variant: "default"
  }
}, RX = {
  baseStyle: {
    container: "flex items-center justify-center",
    spinner: "animate-spin",
    overlay: "bg-white/80 dark:bg-gray-900/80"
  },
  variants: {
    default: {},
    overlay: {
      container: "bg-white/80 dark:bg-gray-900/80"
    }
  },
  defaultProps: {
    size: "md",
    color: "primary",
    container: "inline",
    variant: "default",
    delay: 300
  }
}, IX = {
  baseStyle: {
    base: "fixed inset-0 z-[100] flex items-center justify-center",
    overlay: "fixed inset-0 bg-black/50 backdrop-blur-sm z-[100]",
    content: "relative z-[101] bg-surface rounded-lg shadow-xl max-h-[calc(100vh-2rem)] overflow-auto mx-4 w-full overflow-visible",
    body: "p-4 text-text-muted bg-surface flex-grow overflow-visible",
    header: "sticky z-[102] top-0 flex items-center justify-between p-4 border-b border-border bg-surface/95 backdrop-blur supports-[backdrop-filter]:bg-surface/80 rounded-t-lg",
    footer: "sticky bottom-0 flex justify-end gap-2 p-4 border-t border-border bg-surface/95 backdrop-blur supports-[backdrop-filter]:bg-surface/80 rounded-b-lg",
    title: "text-lg font-semibold text-text flex-1 truncate",
    closeButton: "rounded-full p-2 hover:bg-surface-hover transition-colors duration-200",
    animation: {
      enter: "transition-all ease-out duration-300",
      enterFrom: "opacity-0 scale-95 translate-y-4",
      enterTo: "opacity-100 scale-100 translate-y-0",
      leave: "transition-all ease-in duration-200",
      leaveFrom: "opacity-100 scale-100 translate-y-0",
      leaveTo: "opacity-0 scale-95 translate-y-4"
    }
  },
  variants: {},
  sizes: {
    sm: { content: "w-full max-w-sm" },
    md: { content: "w-full max-w-md" },
    lg: { content: "w-full max-w-lg" },
    xl: { content: "w-full max-w-xl" },
    full: {
      content: "w-full h-[calc(100vh-2rem)] w-[calc(100vw-2rem)] flex flex-col overflow-scroll"
    }
  },
  defaultProps: {
    size: "md",
    closeOnEsc: !0,
    closeOnOutsideClick: !0,
    preventClose: !1
  }
}, DX = {
  baseStyle: {
    base: "flex items-center justify-between gap-4",
    wrapper: "flex-shrink-0",
    infoWrapper: "text-sm whitespace-nowrap",
    navigation: "relative z-0 inline-flex rounded-md space-x-1",
    button: "relative inline-flex items-center px-3 py-2 border border-border text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-primary-500 focus:border-primary-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 dark:text-gray-300 dark:bg-surface dark:hover:bg-gray-700 dark:focus:ring-primary-400 dark:focus:border-primary-500",
    pageButton: "text-gray-700 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border border-border text-sm font-medium focus:z-10 focus:outline-none focus:ring-primary-500 focus:border-primary-300 transition-colors duration-200 dark:text-gray-300 dark:bg-surface dark:hover:bg-gray-700 dark:focus:ring-primary-400 dark:focus:border-primary-500",
    pageButtonActive: "z-10 !border-primary-500 !bg-primary-500 !text-white hover:!bg-primary-600 dark:!border-primary-400 dark:!bg-primary-500 dark:!text-white dark:hover:!bg-primary-600",
    ellipsis: "relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300",
    text: "text-sm text-gray-700 dark:text-gray-300",
    select: "mt-1 block w-full pl-3 pr-10 py-2 text-base border-border focus:outline-none focus:ring-primary-500 focus:border-primary-300 sm:text-sm rounded-md bg-white text-gray-900 transition-colors duration-200 dark:bg-surface dark:text-gray-100 dark:focus:ring-primary-400 dark:focus:border-primary-500",
    infoText: "text-gray-700 dark:text-gray-300",
    infoTextHighlight: "font-medium text-gray-900 dark:text-gray-100"
  },
  defaultProps: {
    pageSize: 10
  }
}, NX = {
  baseStyle: {
    base: "w-full",
    container: "flex items-center gap-3",
    wrapper: "flex-1 relative bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden min-h-[0.25rem]",
    bar: "transition-all duration-300 ease-in-out rounded-full h-full w-full",
    label: "text-sm font-medium",
    sizes: {
      xs: "h-1 min-h-[0.25rem]",
      sm: "h-2 min-h-[0.5rem]",
      md: "h-3 min-h-[0.75rem]",
      lg: "h-4 min-h-[1rem]",
      xl: "h-5 min-h-[1.25rem]"
    },
    variants: {
      solid: "",
      gradient: "bg-gradient-to-r",
      striped: "bg-stripes animate-progress-stripes"
    },
    colors: {
      primary: {
        solid: "bg-primary-500 dark:bg-primary-400",
        gradient: "from-primary-400 to-primary-600",
        striped: "bg-primary-500 dark:bg-primary-400"
      },
      secondary: {
        solid: "bg-secondary-500 dark:bg-secondary-400",
        gradient: "from-secondary-400 to-secondary-600",
        striped: "bg-secondary-500 dark:bg-secondary-400"
      },
      success: {
        solid: "bg-green-500 dark:bg-green-400",
        gradient: "from-green-400 to-green-600",
        striped: "bg-green-500 dark:bg-green-400"
      },
      danger: {
        solid: "bg-red-500 dark:bg-red-400",
        gradient: "from-red-400 to-red-600",
        striped: "bg-red-500 dark:bg-red-400"
      },
      warning: {
        solid: "bg-yellow-500 dark:bg-yellow-400",
        gradient: "from-yellow-400 to-yellow-600",
        striped: "bg-yellow-500 dark:bg-yellow-400"
      },
      info: {
        solid: "bg-blue-500 dark:bg-blue-400",
        gradient: "from-blue-400 to-blue-600",
        striped: "bg-blue-500 dark:bg-blue-400"
      }
    },
    states: {
      animated: "transition-all duration-300",
      indeterminate: "animate-progress-indeterminate"
    },
    labelPositions: {
      inside: "absolute inset-0 flex items-center justify-center text-white",
      outside: "ml-2 text-gray-700 dark:text-gray-300",
      end: "text-right text-text text-sm font-medium"
    }
  },
  defaultProps: {
    size: "md",
    variant: "solid",
    color: "primary",
    showLabel: !1,
    labelPosition: "outside",
    animated: !0,
    indeterminate: !1
  }
}, MX = {
  baseStyle: {
    base: "form-radio transition duration-150 ease-in-out",
    wrapper: "flex items-center",
    input: "border h-4 w-4 text-primary-600 border-border focus:ring-primary-500 dark:bg-surface dark:focus:ring-primary-400",
    label: "flex items-center",
    labelText: "ml-2 text-sm text-gray-700 dark:text-gray-300",
    helperText: "mt-1 text-sm text-gray-500 dark:text-gray-400",
    error: "border-red-500 dark:border-red-400 focus:ring-red-500 dark:focus:ring-red-400",
    disabled: "opacity-50 cursor-not-allowed"
  },
  sizes: {
    small: {
      input: "h-3 w-3",
      labelText: "text-xs"
    },
    medium: {
      input: "h-4 w-4",
      labelText: "text-sm"
    },
    large: {
      input: "h-5 w-5",
      labelText: "text-base"
    }
  },
  defaultProps: {
    size: "medium"
  }
}, LX = {
  baseStyle: {
    base: "space-y-2",
    wrapper: "flex flex-col",
    radioWrapper: "flex items-center",
    input: "form-radio h-4 w-4 text-primary-600 transition duration-150 ease-in-out",
    label: "ml-2 block text-sm leading-5 text-gray-700 dark:text-gray-300",
    helperText: "mt-1 text-sm text-gray-500 dark:text-gray-400",
    error: "text-red-500 dark:text-red-400",
    disabled: "opacity-50 cursor-not-allowed"
  },
  sizes: {
    small: {
      input: "h-3 w-3",
      label: "text-sm"
    },
    medium: {
      input: "h-4 w-4",
      label: "text-base"
    },
    large: {
      input: "h-5 w-5",
      label: "text-lg"
    }
  },
  defaultProps: {
    size: "medium"
  }
}, jX = {
  baseStyle: {
    container: "relative",
    control: "flex items-center justify-between w-full px-3 space-x-3 py-2 bg-white dark:dark:bg-gray-800 border border-border rounded-md focus-within:border-primary-500 dark:focus-within:border-primary-400 focus-within:ring-primary-500 dark:focus-within:ring-primary-400 transition-colors duration-200",
    controlFocused: "border-primary-500 dark:border-primary-400 ring-primary-500 dark:ring-primary-400",
    valueContainer: "flex flex-wrap flex-1 items-center space-x-1",
    placeholder: "text-primary-500 dark:text-primary-400",
    singleValue: "text-primary-500 dark:text-primary-400",
    multiValue: "bg-primary-100 dark:bg-primary-800 text-primary-800 dark:text-primary-200 rounded-md flex items-center text-xxs px-1.5 space-x-1.5",
    multiValueLabel: "",
    multiValueRemove: "flex items-center justify-center hover:bg-primary-200 dark:hover:bg-primary-700 hover:text-primary-900 dark:hover:text-primary-100 rounded-sm cursor-pointer transition-colors duration-150",
    input: "p-0 m-0 outline-none border-none bg-transparent flex-1 min-w-0",
    indicators: "flex items-center",
    indicatorSeparator: "bg-gray-300 dark:bg-gray-600 mx-2 w-px h-4",
    dropdownIndicator: "text-primary-400 dark:text-primary-400 hover:text-gray-600 dark:hover:text-gray-300 cursor-pointer flex items-center justify-center transition-colors duration-150",
    clearIndicator: "text-primary-400 dark:text-primary-400 hover:text-gray-600 dark:hover:text-primary-300 cursor-pointer flex items-center justify-center transition-colors duration-150",
    loadingIndicator: "text-primary-400 dark:text-primary-500",
    menu: "bg-white dark:bg-gray-800 dark:bg-surface rounded-md text-sm w-full",
    menuList: "max-h-60 overflow-auto",
    option: "px-3 py-2 hover:bg-primary-100 dark:hover:bg-primary-700 cursor-pointer transition-colors duration-150",
    optionSelected: "bg-primary-50 dark:bg-primary-900 text-primary-900 dark:text-primary-100",
    optionDisabled: "text-gray-300 dark:text-gray-600 cursor-not-allowed",
    createOption: "px-3 py-2 text-primary-600 dark:text-primary-400 bg-primary-50 dark:bg-primary-900/50 cursor-pointer hover:bg-primary-100 dark:hover:bg-primary-800/50 transition-colors duration-150 flex items-center gap-2 border-t border-border",
    createOptionIcon: "text-primary-500 dark:text-primary-400 flex-shrink-0",
    createOptionText: "text-sm font-medium flex-1",
    group: "pt-2 pb-1",
    groupHeading: "px-3 py-1 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider",
    noOptionsMessage: "px-3 py-2 text-gray-500 dark:text-gray-400",
    loadingMessage: "px-3 py-2 text-primary-500 dark:text-primary-400",
    label: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1",
    required: "text-red-500 dark:text-red-400 ml-1",
    error: "border-red-500 dark:border-red-400 focus-within:border-red-500 dark:focus-within:border-red-400 focus-within:ring-red-500 dark:focus-within:ring-red-400",
    helperText: "mt-1 text-sm text-gray-500 dark:text-gray-400",
    disabled: "opacity-50 cursor-not-allowed",
    customMultiValueContainer: "mt-2 space-y-2"
  },
  variants: {
    default: {
      select: `
        bg-white
        dark:bg-gray-800
        text-gray-900
        dark:text-gray-100
        border-border
        focus:border-primary-500
        dark:focus:border-primary-400
        focus:ring-primary-500
        dark:focus:ring-primary-400
        disabled:bg-gray-100
        disabled:dark:bg-gray-800/50
        disabled:border-gray-200
        disabled:dark:border-gray-700
        disabled:text-gray-500
        disabled:dark:text-gray-500
        disabled:cursor-not-allowed
      `
    },
    outline: {},
    filled: {
      control: "bg-gray-100 dark:bg-gray-800 border-transparent"
    }
  },
  sizes: {
    xs: {
      control: "min-h-[26px] px-2 py-1 text-xs",
      valueContainer: "gap-1",
      placeholder: "text-xs",
      input: "text-xs",
      indicators: "gap-1",
      dropdownIndicator: "w-4 h-4",
      clearIndicator: "w-4 h-4"
    },
    sm: {
      control: "min-h-[32px] px-2.5 py-1.5 text-sm",
      valueContainer: "gap-1.5",
      placeholder: "text-sm",
      input: "text-sm",
      indicators: "gap-1.5",
      dropdownIndicator: "w-4 h-4",
      clearIndicator: "w-4 h-4"
    },
    md: {
      control: "min-h-[42px] px-3 py-2 text-base",
      menu: "text-base mt-1",
      valueContainer: "gap-2",
      multiValue: "text-sm",
      dropdownIndicator: "w-5 h-5",
      clearIndicator: "w-5 h-5"
    },
    lg: {
      control: "min-h-[44px] px-3.5 py-2.5 text-lg",
      menu: "text-lg mt-1",
      valueContainer: "gap-2",
      multiValue: "text-sm",
      dropdownIndicator: "w-5 h-5",
      clearIndicator: "w-5 h-5"
    },
    xl: {
      control: "min-h-[52px] px-4 py-3 text-xl",
      menu: "text-xl mt-1",
      valueContainer: "gap-2.5",
      multiValue: "text-base",
      dropdownIndicator: "w-6 h-6",
      clearIndicator: "w-6 h-6"
    }
  },
  defaultProps: {
    variant: "outline",
    size: "md",
    isSearchable: !1,
    isClearable: !1,
    isMulti: !1,
    closeMenuOnSelect: !0,
    hideSelectedOptions: !1,
    createOnBlur: !1
  }
}, FX = {
  baseStyle: {
    base: "bg-gray-200 dark:bg-gray-700",
    animation: {
      pulse: "animate-pulse",
      wave: "animate-wave"
    },
    borderRadius: {
      rectangular: "rounded",
      circular: "rounded-full"
    }
  },
  variants: {
    text: {
      base: "h-4 w-full max-w-[200px]"
    },
    button: {
      base: "h-9 w-20"
    }
  },
  defaultProps: {
    variant: "rectangular",
    animation: "pulse",
    gap: 2,
    layout: "flex"
  }
}, BX = {
  baseStyle: {
    base: "relative w-full",
    wrapper: "flex flex-col space-y-2",
    container: "relative h-2 flex items-center",
    trackFilled: "absolute top-1/2 -translate-y-1/2 h-2 rounded-full bg-primary-500 dark:bg-primary-400 transition-[width] duration-75",
    track: "absolute top-1/2 -translate-y-1/2 h-2 w-full rounded-full bg-gray-200 dark:bg-gray-700 transition-colors duration-150 cursor-pointer",
    thumb: "absolute top-1/2 -translate-y-1/2 w-4 h-4 bg-white dark:bg-gray-200 rounded-full border-2 cursor-grab active:cursor-grabbing border-primary-500 dark:border-primary-400 hover:shadow-md focus:outline-none focus:ring-offset-2 focus:ring-primary-500 dark:focus:ring-primary-400 transition-[left,transform] duration-75",
    label: "text-sm font-medium text-gray-700 dark:text-gray-300",
    valueLabel: "ml-2 text-sm text-gray-600 dark:text-gray-400",
    markContainer: "absolute w-full",
    markDot: "absolute w-1 h-1 -translate-x-1/2 top-1/2 -translate-y-1/2 bg-gray-400 dark:bg-gray-500 rounded-full",
    markLabel: "absolute text-xs -translate-x-1/2 mt-3 text-gray-600 dark:text-gray-400",
    tooltip: "absolute -top-8 left-1/2 -translate-x-1/2 px-2 py-1 text-xs font-medium text-white bg-gray-900 dark:bg-gray-100 dark:text-gray-900 rounded shadow-sm whitespace-nowrap opacity-0 pointer-events-none transition-opacity duration-200",
    tooltipArrow: "absolute -bottom-1 left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900 dark:border-t-gray-100",
    states: {
      dragging: "shadow-lg scale-110",
      disabled: "opacity-50 cursor-not-allowed",
      error: "text-red-500 dark:text-red-400"
    },
    helperText: "text-gray-500 dark:text-gray-400 text-sm",
    errorText: "text-red-500 dark:text-red-400 text-sm"
  },
  variants: {
    default: {},
    gradient: {
      trackFilled: "bg-gradient-to-r from-primary-400 to-primary-600"
    }
  },
  sizes: {
    sm: {
      track: "h-1",
      thumb: "w-3 h-3"
    },
    md: {
      track: "h-2",
      thumb: "w-4 h-4"
    },
    lg: {
      track: "h-3",
      thumb: "w-5 h-5"
    }
  },
  defaultProps: {
    size: "md",
    variant: "default",
    color: "primary"
  }
}, UX = {
  baseStyle: {
    base: "inline-flex items-center",
    root: "relative inline-block",
    input: "sr-only",
    track: {
      small: "w-8 h-4",
      medium: "w-11 h-6",
      large: "w-14 h-7"
    },
    trackChecked: "bg-primary-600 dark:bg-primary-500",
    trackUnchecked: "bg-gray-300 dark:bg-gray-700",
    thumb: {
      small: "w-3 h-3",
      medium: "w-5 h-5",
      large: "w-6 h-6"
    },
    thumbChecked: "translate-x-full",
    thumbUnchecked: "translate-x-0",
    label: "flex items-center",
    labelDisabled: "opacity-50 cursor-not-allowed",
    labelText: {
      left: "mr-3 text-sm font-medium text-gray-700 dark:text-gray-300",
      right: "ml-3 text-sm font-medium text-gray-700 dark:text-gray-300",
      top: "mb-1 text-sm font-medium text-gray-700 dark:text-gray-300",
      bottom: "mt-1 text-sm font-medium text-gray-700 dark:text-gray-300"
    },
    wrapper: {
      left: "flex flex-row-reverse items-center",
      right: "flex items-center",
      top: "flex flex-col-reverse items-start",
      bottom: "flex flex-col items-start"
    },
    icon: "flex items-center justify-center w-full h-full text-gray-400 dark:text-gray-600"
  },
  defaultProps: {
    size: "medium",
    labelPosition: "right"
  }
}, VX = {
  baseStyle: {
    base: "w-full",
    tabList: "flex border-b border-border",
    tab: "relative px-4 py-3 text-sm font-medium transition-colors duration-200 focus:outline-none",
    tabContent: "mt-4",
    icon: "flex-shrink-0",
    activeIndicator: "absolute bottom-0 left-0 right-0 h-0.5 bg-primary-500",
    panelContainer: "focus:outline-none",
    states: {
      active: "text-primary-600 dark:text-primary-400",
      disabled: "opacity-50 cursor-not-allowed"
    }
  },
  variants: {
    default: {
      tab: "hover:text-primary-600 dark:hover:text-primary-400",
      activeIndicator: "-mb-px"
    },
    pills: {
      tabList: "flex space-x-2 border-0",
      tab: "rounded-md hover:bg-gray-100 dark:hover:bg-gray-800",
      states: {
        active: "bg-primary-50 dark:bg-primary-900 text-primary-600 dark:text-primary-400",
        disabled: "opacity-50 cursor-not-allowed"
      }
    },
    underline: {
      tab: "border-b-2 border-transparent hover:border-gray-300 dark:hover:border-gray-600",
      states: {
        active: "border-primary-500 dark:border-primary-400",
        disabled: "opacity-50 cursor-not-allowed"
      }
    }
  },
  sizes: {
    sm: {
      tab: "px-3 py-2 text-sm"
    },
    md: {
      tab: "px-4 py-3 text-base"
    },
    lg: {
      tab: "px-6 py-4 text-lg"
    }
  },
  defaultProps: {
    variant: "default",
    size: "md"
  }
}, $X = {
  baseStyle: {
    base: "min-w-full divide-y divide-border bg-surface dark:bg-surface table-auto w-full",
    wrapper: "flex flex-col min-h-0 border border-border rounded-lg overflow-hidden",
    container: "overflow-x-auto min-h-0",
    footer: "bg-surface dark:bg-surface border-t border-border sticky bottom-0 z-50",
    footerContent: "flex items-center justify-between px-6 py-4",
    footerCell: "flex-1",
    headerCell: "px-5 py-4 text-left font-normal text-text dark:text-text tracking-normal border-b border-border whitespace-nowrap",
    cell: "px-5 py-4 whitespace-nowrap text-sm text-text dark:text-text relative",
    header: "bg-surface dark:bg-surface sticky top-0 z-10 table-auto",
    coloredHeader: "bg-primary-50 dark:bg-primary-900 sticky top-0 z-10",
    sortableHeaderCell: "cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors",
    headerContent: "flex items-center space-x-1",
    sortIcon: "flex text-text dark:text-text transition-colors",
    sortIconActive: "text-primary-600 dark:text-primary-400",
    body: "bg-surface dark:bg-surface divide-y divide-border",
    row: "transition-colors hover:bg-gray-50 dark:hover:bg-gray-700",
    selectedRow: "bg-primary-50 dark:bg-primary-800",
    clickableRow: "cursor-pointer",
    loadingCell: "px-5 py-4 text-center",
    loadingSpinner: "flex items-center justify-center gap-2",
    emptyStateCell: "px-5 py-4 text-center text-sm text-gray-500 dark:text-gray-400",
    pagination: "px-4 py-3 flex items-center justify-between border-t border-border sm:px-6",
    paginationButton: "relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md transition-colors",
    paginationButtonActive: "z-10 bg-primary-50 dark:bg-primary-900 border-primary-500",
    loadingState: "opacity-50",
    headerSection: "px-5 py-4 bg-surface dark:bg-surface border-b border-border",
    headerSectionContent: "flex items-center justify-between gap-4",
    footerSection: "px-5 py-4 bg-surface dark:bg-surface border-t border-border",
    footerSectionContent: "flex items-center justify-between gap-4",
    errorCell: "p-4 text-center",
    errorMessage: "flex items-center justify-center space-x-2 text-red-500",
    errorAction: "ml-2 text-sm font-medium text-red-600 hover:text-red-500",
    pinnedLeft: `
    sticky left-0 z-30
    before:absolute before:top-0 before:right-0 before:bottom-0 before:w-[1px]
    before:bg-gradient-to-r before:from-transparent before:to-gray-200
    after:absolute after:top-0 after:right-[1px] after:bottom-0 after:w-[1px]
    after:bg-border/80 dark:after:bg-border/40
    bg-white dark:bg-surface text-left justify-items-start
  `,
    pinnedRight: `
    sticky right-0 z-30
    before:absolute before:top-0 before:left-0 before:bottom-0 before:w-[1px]
    before:bg-gradient-to-l before:from-transparent before:to-gray-200
    after:absolute after:top-0 after:left-[1px] after:bottom-0 after:w-[1px]
    after:bg-border/80 dark:after:bg-border/40
    bg-white dark:bg-surface text-left justify-items-end
  `,
    pinnedWrapper: "relative transition-all duration-200",
    pinnedCell: `
    backdrop-blur-[2px]
    bg-white/95 dark:bg-surface/95
    transition-colors
    group-hover:bg-gray-50/95 dark:group-hover:bg-gray-700/95
  `,
    pinnedHeaderCell: `
    backdrop-blur-[4px]
    bg-white/98 dark:bg-surface/98
    group-hover:bg-gray-50/98 dark:group-hover:bg-gray-700/98
  `,
    pinnedShadowLeft: "after:shadow-[2px_0_4px_-2px_rgba(0,0,0,0.1)]",
    pinnedShadowRight: "after:shadow-[-2px_0_4px_-2px_rgba(0,0,0,0.1)]"
  },
  variants: {
    default: {
      base: "",
      wrapper: ""
    },
    bordered: {
      base: "border border-border",
      wrapper: "overflow-hidden rounded-lg border border-border"
    },
    striped: {
      row: "even:bg-gray-50 dark:even:bg-gray-700"
    }
  },
  sizes: {
    sm: {
      headerCell: "px-4 py-2 text-xs",
      cell: "px-4 py-2 text-xs",
      footerCell: "px-4 py-2 text-xs"
    },
    md: {
      headerCell: "px-6 py-3.5 text-sm",
      cell: "px-6 py-3.5 text-sm",
      footerCell: "px-6 py-3.5 text-sm"
    },
    lg: {
      headerCell: "px-8 py-4 text-base",
      cell: "px-8 py-4 text-base",
      footerCell: "px-8 py-4 text-base"
    }
  },
  defaultProps: {
    variant: "default",
    size: "md",
    color: "primary"
  }
}, HX = {
  baseStyle: {
    base: "inline-flex items-center rounded-full font-medium transition-colors duration-200",
    container: "relative flex items-center gap-1.5",
    text: "truncate",
    icon: "flex-shrink-0",
    removeButton: "ml-1 -mr-1 hover:bg-black/5 dark:hover:bg-white/5 rounded-full p-0.5 transition-colors",
    sizes: {
      xs: "px-1.5 py-0 text-xxs",
      sm: "px-2 py-0.5 text-xs",
      md: "px-2.5 py-0.5 text-sm",
      lg: "px-3 py-1 text-base"
    },
    states: {
      withIcon: "pl-2",
      withRemove: "pr-2"
    }
  },
  variants: {
    solid: {
      base: "text-gray-700 dark:text-gray-200",
      primary: "bg-primary-100 text-primary-700 dark:bg-primary-900/20 dark:text-primary-300",
      secondary: "bg-secondary-100 text-secondary-700 dark:bg-secondary-900/20 dark:text-secondary-300",
      success: "bg-green-100 text-green-700 dark:bg-green-900/20 dark:text-green-300",
      warning: "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/20 dark:text-yellow-300",
      danger: "bg-red-100 text-red-700 dark:bg-red-900/20 dark:text-red-300",
      info: "bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-blue-300",
      gray: "bg-gray-100 text-gray-700 dark:bg-gray-900/20 dark:text-gray-300"
    },
    outline: {
      base: "bg-transparent border",
      primary: "border-primary-200 text-primary-700 dark:border-primary-700 dark:text-primary-300",
      secondary: "border-secondary-200 text-secondary-700 dark:border-secondary-700 dark:text-secondary-300",
      success: "border-green-200 text-green-700 dark:border-green-700 dark:text-green-300",
      warning: "border-yellow-200 text-yellow-700 dark:border-yellow-700 dark:text-yellow-300",
      danger: "border-red-200 text-red-700 dark:border-red-700 dark:text-red-300",
      info: "border-blue-200 text-blue-700 dark:border-blue-700 dark:text-blue-300",
      gray: "border-gray-200 text-gray-700 dark:border-gray-700 dark:text-gray-300"
    },
    soft: {
      base: "bg-opacity-15 border-transparent",
      primary: "bg-primary-50 text-primary-700 dark:bg-primary-900/10 dark:text-primary-300",
      secondary: "bg-gray-50 text-gray-700 dark:bg-gray-900/10 dark:text-gray-300",
      success: "bg-green-50 text-green-700 dark:bg-green-900/10 dark:text-green-300",
      warning: "bg-yellow-50 text-yellow-700 dark:bg-yellow-900/10 dark:text-yellow-300",
      danger: "bg-red-50 text-red-700 dark:bg-red-900/10 dark:text-red-300",
      info: "bg-blue-50 text-blue-700 dark:bg-blue-900/10 dark:text-blue-300",
      gray: "bg-gray-50 text-gray-700 dark:bg-gray-900/10 dark:text-gray-300"
    }
  },
  defaultProps: {
    size: "md",
    variant: "solid",
    color: "primary"
  }
}, WX = {
  baseStyle: {
    base: "",
    wrapper: "flex flex-col w-full",
    textarea: "appearance-none border rounded-md w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline transition duration-150 ease-in-out",
    label: "block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1.5",
    labelWrapper: "flex items-center justify-between",
    labelDisabled: "text-gray-500 dark:text-gray-400",
    labelError: "text-red-500 dark:text-red-400",
    helperWrapper: "mt-1.5 space-y-1",
    helperText: "text-sm text-gray-500 dark:text-gray-400",
    helperTextError: "text-sm text-red-500 dark:text-red-400",
    requiredIndicator: "text-red-500 dark:text-red-400 ml-1",
    characterCount: "text-sm text-gray-500 dark:text-gray-400",
    characterCountError: "text-red-500 dark:text-red-400",
    disabled: "bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400 cursor-not-allowed",
    fullWidth: "w-full"
  },
  sizes: {
    small: {
      textarea: "text-sm py-1 px-2",
      label: "text-sm"
    },
    medium: {
      textarea: "text-base py-2 px-3",
      label: "text-sm"
    },
    large: {
      textarea: "text-lg py-3 px-4",
      label: "text-base"
    }
  },
  variants: {
    default: {
      textarea: `
        bg-white
        dark:bg-gray-800
        text-gray-900
        dark:text-gray-100
        border-border
        focus:border-primary-500
        dark:focus:border-primary-400
        focus:ring-primary-500
        dark:focus:ring-primary-400
        disabled:bg-gray-100
        disabled:dark:bg-gray-800/50
        disabled:border-gray-200
        disabled:dark:border-gray-700
        disabled:text-gray-500
        disabled:dark:text-gray-500
        disabled:cursor-not-allowed
      `
    },
    error: {
      textarea: "bg-white dark:bg-gray-800 text-red-500 dark:text-red-400 border-red-500 dark:border-red-400 focus:border-red-500 dark:focus:border-red-400 focus:ring-red-500 dark:focus:ring-red-400"
    }
  },
  defaultProps: {
    size: "medium",
    variant: "default"
  }
}, zX = {
  baseStyle: {
    base: "pointer-events-auto flex w-full items-center justify-between space-x-4 overflow-hidden rounded-lg border p-4 shadow-lg transition-all",
    container: "fixed z-[100] flex flex-col gap-2 p-4 md:gap-3 w-full md:max-w-[420px]",
    toast: "bg-white dark:bg-gray-800 border-border",
    title: "text-sm font-semibold text-gray-900 dark:text-gray-100",
    message: "text-sm text-gray-600 dark:text-gray-300",
    actions: "flex items-center space-x-2 mt-2",
    dismissButton: "rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-primary-500",
    loading: {
      spinner: "animate-spin",
      wrapper: "flex items-center justify-center"
    },
    typeStyles: {
      success: "border-l-4 border-success-500 bg-success-50 dark:bg-success-900/10",
      error: "border-l-4 border-danger-500 bg-danger-50 dark:bg-danger-900/10",
      warning: "border-l-4 border-warning-500 bg-warning-50 dark:bg-warning-900/10",
      info: "border-l-4 border-info-500 bg-info-50 dark:bg-info-900/10",
      loading: "border-l-4 border-info-500 bg-info-50 dark:bg-info-900/10"
    },
    positionStyles: {
      "top-right": "top-0 right-0 sm:top-4 sm:right-4",
      "top-left": "top-0 left-0 sm:top-4 sm:left-4",
      "bottom-right": "bottom-0 right-0 sm:bottom-4 sm:right-4",
      "bottom-left": "bottom-0 left-0 sm:bottom-4 sm:left-4"
    },
    animationStyles: {
      enter: "animate-toast-enter",
      exit: "animate-toast-exit",
      swipe: "animate-toast-swipe"
    }
  },
  variants: {
    solid: {
      toast: "bg-white dark:bg-gray-800",
      title: "text-gray-900 dark:text-white",
      message: "text-gray-600 dark:text-gray-300"
    },
    soft: {
      toast: "bg-opacity-90 backdrop-blur-sm",
      title: "text-gray-800 dark:text-gray-100",
      message: "text-gray-600 dark:text-gray-300"
    }
  },
  sizes: {
    sm: {
      toast: "p-3",
      title: "text-sm",
      message: "text-xs"
    },
    md: {
      toast: "p-4",
      title: "text-sm",
      message: "text-sm"
    },
    lg: {
      toast: "p-5",
      title: "text-base",
      message: "text-base"
    }
  },
  defaultProps: {
    size: "md",
    variant: "solid",
    position: "top-right",
    duration: 5e3,
    dismissible: !0,
    pauseOnHover: !0
  }
}, KX = {
  baseStyle: {
    base: "fixed z-50 pointer-events-none max-w-xs transition-all duration-200",
    container: "flex",
    content: "px-2 py-1 text-sm font-medium rounded-md shadow-sm",
    arrow: "absolute w-2 h-2 transform rotate-45",
    states: {
      visible: "opacity-100",
      disabled: "opacity-0 pointer-events-none"
    },
    placements: {
      top: {
        container: "mb-2",
        arrow: "-bottom-1 left-1/2 -translate-x-1/2"
      },
      bottom: {
        container: "mt-2",
        arrow: "-top-1 left-1/2 -translate-x-1/2"
      },
      left: {
        container: "mr-2",
        arrow: "-right-1 top-1/2 -translate-y-1/2"
      },
      right: {
        container: "ml-2",
        arrow: "-left-1 top-1/2 -translate-y-1/2"
      }
    }
  },
  variants: {
    dark: {
      content: "bg-gray-900 text-white dark:bg-gray-100 dark:text-gray-900",
      arrow: "bg-gray-900 dark:bg-gray-100"
    },
    light: {
      content: "bg-white text-gray-900 border border-border dark:bg-gray-800 dark:text-white",
      arrow: "bg-white border border-border dark:bg-gray-800"
    }
  },
  defaultProps: {
    variant: "dark",
    placement: "top",
    delay: 0
  }
}, Q3 = {
  Accordion: yX,
  AdvancedDynamicList: bX,
  Badge: wX,
  Button: xX,
  Card: _X,
  Checkbox: SX,
  ColorPicker: EX,
  DatePicker: TX,
  Dropdown: CX,
  DynamicTextList: kX,
  FileUpload: OX,
  Icon: AX,
  Input: PX,
  LoadingSpinner: RX,
  Modal: IX,
  Pagination: DX,
  ProgressBar: NX,
  Radio: MX,
  RadioGroup: LX,
  Select: jX,
  Skeleton: FX,
  Slider: BX,
  Switch: UX,
  Tabs: VX,
  Table: $X,
  Tag: HX,
  Toast: zX,
  Tooltip: KX,
  Textarea: WX
}, WT = {
  name: "default",
  mode: "light",
  tokens: {
    colors: {
      base: {
        primary: fl("#000000"),
        secondary: fl("#FFD700"),
        success: fl("#2ABB72"),
        danger: fl("#EF4444"),
        warning: fl("#F97316"),
        info: fl("#3B82F6"),
        gray: fl("#6B7280"),
        white: fl("#FFFFFF")
      },
      semantic: {
        light: {
          background: { value: "#F9FAFB" },
          // Very light gray-blue
          surface: { value: "#FFFFFF" },
          // Pure white
          border: { value: "#E2E4E8" },
          // Light gray
          text: { value: "#000000" }
          // Dark gray-blue
        },
        dark: {
          background: { value: "#0F172A" },
          // Very dark blue
          surface: { value: "#1E293B" },
          // Dark blue-gray
          border: { value: "#CBD5E1" },
          // Medium gray-blue
          text: { value: "#F8FAFC" }
          // Very light gray-blue
        }
      }
    },
    typography: {
      fontFamily: {
        sans: { value: "Inter, system-ui, sans-serif" }
        // serif: { value: "Georgia, serif" },
        // mono: { value: "Menlo, monospace" },
      },
      fontSize: {
        xxs: { value: "0.625rem" }
        // xs: { value: "0.75rem" },
        // sm: { value: "0.875rem" },
        // base: { value: "1rem" },
        // lg: { value: "1.125rem" },
        // xl: { value: "1.25rem" },
        // "2xl": { value: "1.5rem" },
      }
      // fontWeight: {
      //   light: { value: "300" },
      //   normal: { value: "400" },
      //   medium: { value: "500" },
      //   semibold: { value: "600" },
      //   bold: { value: "700" },
      // },
      // lineHeight: {
      //   none: { value: "1" },
      //   tight: { value: "1.25" },
      //   normal: { value: "1.5" },
      //   relaxed: { value: "1.75" },
      // },
    },
    logos: {
      clientLogo: {
        src: "/branding/default-client-logo.png",
        alt: "Client Logo",
        width: 160,
        height: 40,
        darkModeSrc: "/branding/default-client-logo-dark.png"
      },
      poweredByLogo: {
        src: "/branding/powered-by-logo.png",
        alt: "Powered by Fraktion",
        width: 120,
        height: 30,
        darkModeSrc: "/branding/powered-by-logo-dark.png"
      }
    }
    // animation: {
    //   "slide-in-right": { value: "slideInRight 0.3s ease-out" },
    //   "slide-out-right": { value: "slideOutRight 0.3s ease-in" },
    //   "spin-slow": { value: "spin 3s linear infinite" },
    //   "pulse-slow": { value: "pulse 3s cubic-bezier(0.4, 0, 0.6, 1) infinite" },
    // },
    // keyframes: {
    //   slideInRight: {
    //     "0%": { value: "translateX(100%)" },
    //     "100%": { value: "translateX(0)" },
    //   },
    //   slideOutRight: {
    //     "0%": { value: "translateX(0)" },
    //     "100%": { value: "translateX(100%)" },
    //   },
    // },
    // spacing: {
    //   0: { value: "0" },
    //   1: { value: "0.25rem" },
    //   2: { value: "0.5rem" },
    //   4: { value: "1rem" },
    //   8: { value: "2rem" },
    //   16: { value: "4rem" },
    // },
    // radii: {
    //   none: { value: "0" },
    //   sm: { value: "0.125rem" },
    //   md: { value: "0.25rem" },
    //   lg: { value: "0.5rem" },
    //   xl: { value: "0.75rem" },
    //   full: { value: "9999px" },
    // },
    // shadows: {
    //   none: { value: "none" },
    //   sm: { value: "0 1px 2px 0 rgb(0 0 0 / 0.05)" },
    //   md: { value: "0 4px 6px -1px rgb(0 0 0 / 0.1)" },
    //   lg: { value: "0 10px 15px -3px rgb(0 0 0 / 0.1)" },
    //   xl: { value: "0 20px 25px -5px rgb(0 0 0 / 0.1)" },
    //   inner: { value: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)" },
    // },
  },
  components: Q3
}, net = {
  ...WT,
  name: "dark",
  mode: "dark"
};
function Mm(e, t) {
  const r = { ...e };
  return N1(e) && N1(t) && Object.keys(t).forEach((n) => {
    N1(t[n]) ? n in e ? r[n] = Mm(e[n], t[n]) : Object.assign(r, { [n]: t[n] }) : t[n] !== void 0 && Object.assign(r, { [n]: t[n] });
  }), r;
}
function N1(e) {
  return !!(e && typeof e == "object" && !Array.isArray(e));
}
function aet(e, t) {
  const r = { ...e };
  return t.forEach((n) => delete r[n]), r;
}
function set(e, t) {
  const r = {};
  return t.forEach((n) => {
    n in e && (r[n] = e[n]);
  }), r;
}
function J3(e) {
  return (t) => {
    e.forEach((r) => {
      typeof r == "function" ? r(t) : r != null && (r.current = t);
    });
  };
}
const EA = "app-theme";
function qX(e) {
  ui().MODE;
  const [r, n] = Me(() => {
    const s = localStorage.getItem(EA);
    if (s) {
      const i = JSON.parse(s);
      return Mm(e, i);
    }
    return e;
  });
  return [r, (s) => {
    const i = Mm(r, s);
    i.components = Q3, n(i), localStorage.setItem(EA, JSON.stringify(i));
  }];
}
function GX(e, t) {
  const r = Ft(
    (a) => {
      const s = Mm(e.tokens, a);
      t({
        tokens: s
      });
    },
    [e, t]
  ), n = Ft(() => {
    t({
      mode: e.mode === "light" ? "dark" : "light"
    });
  }, [e.mode, t]);
  return { updateTokens: r, toggleMode: n };
}
function Z3(e) {
  return [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "gray"
  ].includes(e);
}
function iet(e) {
  return ["background", "border", "surface", "text"].includes(e);
}
function eF(e, t, r = ":root") {
  const n = [];
  if (!e.colors.semantic[t]) return;
  const { fontFamily: s, fontSize: i } = e.typography;
  Object.entries(s).forEach(([c, u]) => {
    vy(u) && (n.push(`--font-family-${c}: ${u.value};`), r !== ":root" && n.push(`font-family: ${u.value};`));
  });
  const o = e.colors.semantic[t];
  Object.entries(o).forEach(([c, u]) => {
    vy(u) && n.push(`--color-${c}: ${u.value};`);
  }), Object.entries(e.colors.base).forEach(([c, u]) => {
    XX(u) && (n.push(`--color-${c}: ${u.DEFAULT.value};`), HT.forEach((d) => {
      n.push(`--color-${c}-${d}: ${u[d].value};`);
    }));
  }), Object.entries(i).forEach(([c, u]) => {
    vy(u) && n.push(`--typography-fontSize-${c}: ${u.value};`);
  });
  const l = document.createElement("style");
  return l.setAttribute("data-preview", "true"), l.textContent = `
    ${r} {
      ${n.join(`
`)}
    }
  `, document.head.appendChild(l), l;
}
function oet(e = {}) {
  return Mm(WT, e);
}
function cet(e) {
  return YX(e);
}
function YX(e) {
  return { value: e };
}
function vy(e) {
  return e && typeof e == "object" && "value" in e;
}
function XX(e) {
  return e && typeof e == "object" && "DEFAULT" in e && vy(e.DEFAULT);
}
function uet(e) {
  try {
    return !0;
  } catch (t) {
    return console.error("Theme validation failed:", t), !1;
  }
}
function QX(e) {
  const t = e.replace("#", ""), r = parseInt(t.slice(0, 2), 16), n = parseInt(t.slice(2, 4), 16), a = parseInt(t.slice(4, 6), 16);
  return (0.299 * r + 0.587 * n + 0.114 * a) / 255 > 0.5 ? "#000000" : "#FFFFFF";
}
function zp(e, t) {
  const r = document.documentElement, n = t ? `--color-${e}-${t}` : `--color-${e}`;
  return getComputedStyle(r).getPropertyValue(n).trim();
}
function TA(e, t) {
  return t.map((r) => zp(e, r));
}
const tF = Vl(
  void 0
), det = ({
  children: e,
  initialTheme: t = WT
}) => {
  const [r, n] = qX(t), { updateTokens: a, toggleMode: s } = GX(r, n);
  wt(() => {
    document.documentElement.classList.toggle("dark", r.mode === "dark"), eF(r.tokens, r.mode);
  }, [r]);
  const i = Tn(
    () => ({ theme: r, setTheme: n, updateTokens: a, toggleMode: s }),
    [r, n, a, s]
  );
  return /* @__PURE__ */ v.jsx(tF.Provider, { value: i, children: e });
};
function Wi() {
  const e = vh(tF);
  if (!e)
    throw new Error("useTheme must be used within a ThemeContext.Provider");
  const t = e.theme.mode === "dark", r = () => {
    const n = t ? "light" : "dark";
    document.documentElement.classList.toggle("dark", n === "dark"), e.setTheme({ mode: n });
  };
  return wt(() => {
    document.documentElement.classList.toggle("dark", t);
  }, [t]), { ...e, isDarkMode: t, toggleDarkMode: r };
}
function $r(e, t) {
  const r = va((n, a) => {
    const { theme: s } = Wi(), i = s.components[e];
    return i ? /* @__PURE__ */ v.jsx(
      t,
      {
        ...n,
        theme: i,
        ref: a
      }
    ) : (console.error(`Theme for component ${e} not found`), null);
  });
  return r.displayName = `Themed${e}`, r;
}
function Wa(...e) {
  return e.filter(Boolean).join(" ");
}
const JX = (e, t, r) => {
  const n = e[t];
  return n ? typeof n == "function" ? n() : Promise.resolve(n) : new Promise((a, s) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      s.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + t + (t.split("/").length !== r ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, it = (e) => Kz(() => JX(/* @__PURE__ */ Object.assign({ "./alert-triangle.svg": () => import("./alert-triangle-88wYr3ec.mjs"), "./arrow-right-circle.svg": () => import("./arrow-right-circle-BZAGg7_x.mjs"), "./arrow-right.svg": () => import("./arrow-right-PatAAppm.mjs"), "./arrow-rotate-left.svg": () => import("./arrow-rotate-left-DtkhAZ1Y.mjs"), "./arrow-top-right-on-square.svg": () => import("./arrow-top-right-on-square-Ccf7TE0T.mjs"), "./bank.svg": () => import("./bank-0OfB-Kg1.mjs"), "./bell.svg": () => import("./bell-BBVYs-W5.mjs"), "./calendar.svg": () => import("./calendar-BWK_X9T-.mjs"), "./campaigns.svg": () => import("./campaigns-BEi7Ic5d.mjs"), "./card.svg": () => import("./card-ZLrOhwSH.mjs"), "./check-circle.svg": () => import("./check-circle-QWPORpAK.mjs"), "./check.svg": () => import("./check-WtDBO0hz.mjs"), "./chevron-both.svg": () => import("./chevron-both-B0tqVvm3.mjs"), "./chevron-down.svg": () => import("./chevron-down-BXxf_R6C.mjs"), "./chevron-left.svg": () => import("./chevron-left-BWko98-9.mjs"), "./chevron-right.svg": () => import("./chevron-right-BpGoqZQL.mjs"), "./chevron-up.svg": () => import("./chevron-up-DknmVJ6d.mjs"), "./chip.svg": () => import("./chip-7vRrzcPa.mjs"), "./clock.svg": () => import("./clock-BNmnCtw1.mjs"), "./close.svg": () => import("./close-ur4T20nc.mjs"), "./code-bracket.svg": () => import("./code-bracket-2lcU17Ku.mjs"), "./coins.svg": () => import("./coins-B6ml-g0c.mjs"), "./comment.svg": () => import("./comment-D9avWHWy.mjs"), "./copy.svg": () => import("./copy-BaDABjkX.mjs"), "./credit-card.svg": () => import("./credit-card-D8I7qWyy.mjs"), "./cube.svg": () => import("./cube-DFGUl5LW.mjs"), "./donut-chart.svg": () => import("./donut-chart-NTIY4DPC.mjs"), "./download.svg": () => import("./download-Cek-TuXR.mjs"), "./edit.svg": () => import("./edit-BqYUwlkw.mjs"), "./ellipsis.svg": () => import("./ellipsis-Dy_xlGor.mjs"), "./empty-circle.svg": () => import("./empty-circle-CSXJ_n7b.mjs"), "./envelope.svg": () => import("./envelope-hRS4dV-O.mjs"), "./exclamation-circle.svg": () => import("./exclamation-circle-W79JDoix.mjs"), "./exclamation-triangle.svg": () => import("./exclamation-triangle-B5E6KCJV.mjs"), "./eye-off.svg": () => import("./eye-off-CwLUwuCB.mjs"), "./eye.svg": () => import("./eye-BOzuinj-.mjs"), "./facebook.svg": () => import("./facebook-laa2rmj-.mjs"), "./file-audio.svg": () => import("./file-audio-DGivAM1S.mjs"), "./file-pdf.svg": () => import("./file-pdf-OQAMlNSc.mjs"), "./file-video.svg": () => import("./file-video-BpcbsDpI.mjs"), "./file.svg": () => import("./file-D-m2Zrkh.mjs"), "./filter.svg": () => import("./filter-C3BMYXqc.mjs"), "./flag-cn.svg": () => import("./flag-cn-DhW82jO6.mjs"), "./flag-es.svg": () => import("./flag-es-CyurAUc7.mjs"), "./flag-fr.svg": () => import("./flag-fr-R45aK8dp.mjs"), "./flag-gb.svg": () => import("./flag-gb-CYBQBoAo.mjs"), "./gear.svg": () => import("./gear-BqfXfJsx.mjs"), "./gift.svg": () => import("./gift-BfowWCbt.mjs"), "./google.svg": () => import("./google-DYQm5Ov6.mjs"), "./grid.svg": () => import("./grid-BZvhYdG6.mjs"), "./grip-vertical.svg": () => import("./grip-vertical-DRvAR9Gy.mjs"), "./headset.svg": () => import("./headset-DLLznzot.mjs"), "./home.svg": () => import("./home-BwZR7V-U.mjs"), "./image-placeholder.svg": () => import("./image-placeholder-BNsmx7bz.mjs"), "./image.svg": () => import("./image-DgqoFRy9.mjs"), "./info-circle.svg": () => import("./info-circle-CzfT5qv5.mjs"), "./information-circle.svg": () => import("./information-circle-CzfT5qv5.mjs"), "./instagram.svg": () => import("./instagram-Cg8J4ez3.mjs"), "./invest.svg": () => import("./invest-5N_DbJ4G.mjs"), "./investment-illustration.svg": () => import("./investment-illustration-bGZbj38D.mjs"), "./link.svg": () => import("./link-5mQNDVAW.mjs"), "./linkedin.svg": () => import("./linkedin-BLp4O-88.mjs"), "./list.svg": () => import("./list-BEi7Ic5d.mjs"), "./logo.svg": () => import("./logo-8zqqso9f.mjs"), "./logout.svg": () => import("./logout-DPkXJjev.mjs"), "./mailchimp.svg": () => import("./mailchimp-CEo8ubZH.mjs"), "./maintenance-service-illustration.svg": () => import("./maintenance-service-illustration-CW_Jq7AP.mjs"), "./menu.svg": () => import("./menu-BL44q5mH.mjs"), "./minus.svg": () => import("./minus-Ch-LUViD.mjs"), "./moon.svg": () => import("./moon-DzkCDJK_.mjs"), "./play.svg": () => import("./play-CzROYOHP.mjs"), "./plus-circle.svg": () => import("./plus-circle-xceDzm5Q.mjs"), "./plus.svg": () => import("./plus-D1SFWDqN.mjs"), "./presentation.svg": () => import("./presentation-DPaZdmM6.mjs"), "./projects.svg": () => import("./projects-HvmcGVN1.mjs"), "./prompt.svg": () => import("./prompt-DPEN31rs.mjs"), "./question-mark.svg": () => import("./question-mark-Ch0y3WZa.mjs"), "./radar.svg": () => import("./radar-X4i1Uwqi.mjs"), "./refresh-ccw.svg": () => import("./refresh-ccw-CUBBP-Wf.mjs"), "./refresh.svg": () => import("./refresh-Cf8sc_i2.mjs"), "./rocket.svg": () => import("./rocket-Kw1BAj9d.mjs"), "./save-off.svg": () => import("./save-off-2571qe5K.mjs"), "./save.svg": () => import("./save-DiJwUh6w.mjs"), "./search.svg": () => import("./search-CYEhgIRb.mjs"), "./showcase.svg": () => import("./showcase-CZ174jQ6.mjs"), "./spinner.svg": () => import("./spinner-ByWGpyR5.mjs"), "./stack.svg": () => import("./stack-HvmcGVN1.mjs"), "./stripe.svg": () => import("./stripe-w7lOlU5G.mjs"), "./sun.svg": () => import("./sun-DQwk7cFX.mjs"), "./table.svg": () => import("./table-8lATVkw1.mjs"), "./target.svg": () => import("./target-D7TWFl6Y.mjs"), "./time-management-illustration.svg": () => import("./time-management-illustration-D9_wuvMF.mjs"), "./trash.svg": () => import("./trash-BZJG58gO.mjs"), "./twitter.svg": () => import("./twitter-D6Fx0CJh.mjs"), "./upload.svg": () => import("./upload-B0MdW2wW.mjs"), "./user-check.svg": () => import("./user-check-BQf5GzxW.mjs"), "./user-group.svg": () => import("./user-group-CBaPpWEN.mjs"), "./user.svg": () => import("./user-CbZTWUN-.mjs"), "./users.svg": () => import("./users-CBaPpWEN.mjs"), "./wallet.svg": () => import("./wallet-D3jxd0AV.mjs"), "./warning.svg": () => import("./warning-B5E6KCJV.mjs"), "./x-circle.svg": () => import("./x-circle-D_CWq5EK.mjs"), "./youtube.svg": () => import("./youtube-BOYwvnG0.mjs") }), `./${e}.svg`, 2)), sE = {
  "arrow-right": it("arrow-right"),
  "arrow-right-circle": it("arrow-right-circle"),
  check: it("check"),
  close: it("close"),
  spinner: it("spinner"),
  "chevron-up": it("chevron-up"),
  "chevron-down": it("chevron-down"),
  edit: it("edit"),
  trash: it("trash"),
  bell: it("bell"),
  home: it("home"),
  user: it("user"),
  users: it("users"),
  logo: it("logo"),
  plus: it("plus"),
  search: it("search"),
  eye: it("eye"),
  "eye-off": it("eye-off"),
  calendar: it("calendar"),
  filter: it("filter"),
  download: it("download"),
  upload: it("upload"),
  "chevron-left": it("chevron-left"),
  "chevron-right": it("chevron-right"),
  "question-mark": it("question-mark"),
  projects: it("projects"),
  "user-group": it("user-group"),
  target: it("target"),
  "refresh-ccw": it("refresh-ccw"),
  "info-circle": it("info-circle"),
  "arrow-rotate-left": it("arrow-rotate-left"),
  "check-circle": it("check-circle"),
  copy: it("copy"),
  file: it("file"),
  "file-pdf": it("file-pdf"),
  "file-video": it("file-video"),
  "file-audio": it("file-audio"),
  list: it("list"),
  image: it("image"),
  campaigns: it("campaigns"),
  table: it("table"),
  grid: it("grid"),
  wallet: it("wallet"),
  "image-placeholder": it("image-placeholder"),
  minus: it("minus"),
  "flag-gb": it("flag-gb"),
  "flag-fr": it("flag-fr"),
  "flag-es": it("flag-es"),
  "flag-cn": it("flag-cn"),
  sun: it("sun"),
  moon: it("moon"),
  chip: it("chip"),
  comment: it("comment"),
  prompt: it("prompt"),
  google: it("google"),
  youtube: it("youtube"),
  facebook: it("facebook"),
  instagram: it("instagram"),
  twitter: it("twitter"),
  linkedin: it("linkedin"),
  stripe: it("stripe"),
  mailchimp: it("mailchimp"),
  "exclamation-triangle": it("exclamation-triangle"),
  "information-circle": it("information-circle"),
  "x-circle": it("x-circle"),
  menu: it("menu"),
  ellipsis: it("ellipsis"),
  showcase: it("showcase"),
  "credit-card": it("credit-card"),
  bank: it("bank"),
  "plus-circle": it("plus-circle"),
  "time-management-illustration": it("time-management-illustration"),
  "investment-illustration": it("investment-illustration"),
  "maintenance-service-illustration": it(
    "maintenance-service-illustration"
  ),
  coins: it("coins"),
  link: it("link"),
  "grip-vertical": it("grip-vertical"),
  radar: it("radar"),
  refresh: it("refresh"),
  "donut-chart": it("donut-chart"),
  logout: it("logout"),
  warning: it("warning"),
  play: it("play"),
  "alert-triangle": it("alert-triangle"),
  gift: it("gift"),
  envelope: it("envelope"),
  "chevron-both": it("chevron-both"),
  presentation: it("presentation"),
  "code-bracket": it("code-bracket"),
  cube: it("cube"),
  "user-check": it("user-check"),
  headset: it("headset"),
  "exclamation-circle": it("exclamation-circle"),
  stack: it("stack"),
  gear: it("gear"),
  rocket: it("rocket"),
  card: it("card"),
  invest: it("invest"),
  clock: it("clock"),
  "empty-circle": it("empty-circle"),
  save: it("save"),
  "save-off": it("save-off"),
  "arrow-top-right-on-square": it("arrow-top-right-on-square")
}, rF = M.forwardRef(
  ({
    name: e,
    size: t = "md",
    color: r = "current",
    backgroundColor: n,
    rotate: a,
    flip: s,
    spin: i = !1,
    pulse: o = !1,
    className: l,
    theme: c,
    ...u
  }, d) => {
    const f = sE[e], h = sE["question-mark"], p = c.baseStyle, m = Wa(
      p.base,
      p.sizes[t],
      p.colors[r] || r,
      n && (p.colors[n] || n),
      i && p.states.spinning,
      o && p.states.pulsing,
      l
    ), g = [
      a && `rotate(${a}deg)`,
      s === "horizontal" && "scaleX(-1)",
      s === "vertical" && "scaleY(-1)",
      s === "both" && "scale(-1)"
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ v.jsx(
      "span",
      {
        ref: d,
        className: m,
        style: { transform: g || void 0 },
        role: "img",
        "aria-hidden": "true",
        ...u,
        children: /* @__PURE__ */ v.jsx(
          yw,
          {
            fallback: /* @__PURE__ */ v.jsx(
              "span",
              {
                className: Wa(
                  p.sizes[t],
                  "animate-pulse bg-current opacity-20 rounded"
                )
              }
            ),
            children: /* @__PURE__ */ v.jsx(
              "span",
              {
                className: Wa(
                  p.icon,
                  "flex items-center justify-center"
                ),
                children: f ? /* @__PURE__ */ v.jsx(
                  f,
                  {
                    className: "w-full h-full animated",
                    style: { maxWidth: "100%", maxHeight: "100%" }
                  }
                ) : /* @__PURE__ */ v.jsx(h, {})
              }
            )
          }
        )
      }
    );
  }
);
rF.displayName = "IconBase";
const dt = $r("Icon", rF);
function lt(...e) {
  const t = [];
  for (const r of e)
    if (r) {
      if (typeof r == "string")
        t.push(r);
      else if (typeof r == "object")
        if (Array.isArray(r))
          t.push(lt(...r));
        else
          for (const [n, a] of Object.entries(r))
            a && t.push(n);
    }
  return t.filter(Boolean).join(" ");
}
const nF = va(
  ({
    children: e,
    variant: t = "solid",
    color: r = "primary",
    size: n = "md",
    shape: a = "rounded",
    fullWidth: s,
    isLoading: i,
    loadingText: o,
    icon: l,
    iconPosition: c,
    isActive: u,
    isDisabled: d,
    className: f,
    as: h = "button",
    theme: p,
    href: m,
    type: g = "button",
    ...y
  }, x) => {
    var P, D, N, z, G, Y;
    const w = d || i, _ = l && !e, S = t === "ghost", E = S || t === "link", O = n === "xs" ? "xxs" : n === "sm" ? "xs" : n === "md" ? "sm" : n === "lg" ? "md" : n === "xl" ? "lg" : n === "2xl" ? "xl" : n === "3xl" ? "2xl" : n === "4xl" ? "3xl" : n === "5xl" ? "4xl" : "md", k = lt(
      p.baseStyle.base,
      a === "pill" && "rounded-full",
      a === "square" && "rounded-none",
      (D = (P = p.sizes) == null ? void 0 : P[n]) == null ? void 0 : D.base,
      (z = (N = p.variants) == null ? void 0 : N[t]) == null ? void 0 : z.base,
      (Y = (G = p.baseStyle.colors) == null ? void 0 : G[r]) == null ? void 0 : Y[t],
      {
        [p.baseStyle.states.loading]: i,
        [p.baseStyle.states.active]: u,
        [p.baseStyle.states.disabled]: w,
        [p.baseStyle.states.fullWidth]: s,
        "opacity-50": w && t !== "solid",
        "active:scale-95 active:transform transition-transform": _ && S,
        "!focus:ring-0 !focus:ring-offset-0": _ && E,
        "!p-0": E && l && e
      },
      _ ? "!p-0" : "",
      f
    ), A = /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      i && /* @__PURE__ */ v.jsx(
        dt,
        {
          name: "spinner",
          className: lt(
            p.baseStyle.elements.loadingSpinner,
            !_ && !c ? "" : "mr-2"
          ),
          size: O,
          "aria-hidden": "true",
          spin: !0
        }
      ),
      !i && l && (!c || c === "left") && /* @__PURE__ */ v.jsx(
        dt,
        {
          name: l,
          size: O,
          className: lt(
            p.baseStyle.elements.leftIcon,
            !_ && c && (E ? "mr-1 " : "mr-2")
          )
        }
      ),
      e && /* @__PURE__ */ v.jsx(
        "span",
        {
          className: lt(
            p.baseStyle.elements.content,
            E && l && "px-1"
          ),
          children: i && o ? o : e
        }
      ),
      !i && l && c === "right" && /* @__PURE__ */ v.jsx(
        dt,
        {
          name: l,
          size: O,
          className: lt(
            p.baseStyle.elements.rightIcon,
            !_ && c && (E ? "ml-1" : "ml-2")
          )
        }
      )
    ] });
    return h === "button" ? /* @__PURE__ */ v.jsx(
      "button",
      {
        ref: x,
        className: k,
        disabled: w,
        type: g,
        ...y,
        children: A
      }
    ) : /* @__PURE__ */ v.jsx(
      h,
      {
        ref: x,
        className: k,
        href: w ? void 0 : m,
        ...y,
        children: A
      }
    );
  }
);
nF.displayName = "ButtonBase";
const qe = $r("Button", nF), aF = ({
  type: e,
  title: t,
  message: r,
  actions: n,
  icon: a,
  position: s = "top-right",
  status: i = "entering",
  variant: o = "solid",
  size: l = "md",
  dismissible: c = !0,
  pauseOnHover: u = !0,
  closeOnClick: d = !1,
  onDismiss: f,
  className: h,
  theme: p,
  onClose: m,
  onPause: g,
  onResume: y
}) => {
  var N, z;
  const [x, w] = Me(0), _ = tr(0), S = Ft(() => {
    u && g && g();
  }, [u, g]), C = Ft(() => {
    u && y && y();
  }, [u, y]), E = Ft(() => {
    d && m();
  }, [d, m]), O = (G) => {
    _.current = G.touches[0].clientX;
  }, k = (G) => {
    if (_.current) {
      const te = G.touches[0].clientX - _.current;
      w(te);
    }
  }, A = () => {
    Math.abs(x) > 100 && m(), w(0), _.current = 0;
  };
  wt(() => {
    if (i === "entering") {
      const G = setTimeout(() => {
      }, 300);
      return () => clearTimeout(G);
    }
  }, [i]);
  const P = ((N = p.variants) == null ? void 0 : N[o]) || {}, D = ((z = p.sizes) == null ? void 0 : z[l]) || {};
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      role: "alert",
      "aria-live": "assertive",
      "aria-atomic": "true",
      className: lt(
        p.baseStyle.base,
        p.baseStyle.toast,
        p.baseStyle.typeStyles[e],
        P.toast,
        D.toast,
        i === "entering" && p.baseStyle.animationStyles.enter,
        i === "exiting" && p.baseStyle.animationStyles.exit,
        h
      ),
      style: {
        transform: `translateX(${x}px)`,
        transition: x ? "none" : "transform 0.2s ease-out"
      },
      onMouseEnter: S,
      onMouseLeave: C,
      onTouchStart: O,
      onTouchMove: k,
      onTouchEnd: A,
      onClick: E,
      children: [
        a && /* @__PURE__ */ v.jsx(
          dt,
          {
            name: a,
            className: lt("shrink-0", p.baseStyle.typeStyles[e]),
            size: l === "lg" ? "md" : "sm"
          }
        ),
        /* @__PURE__ */ v.jsxs("div", { className: "flex-1 min-w-0", children: [
          t && /* @__PURE__ */ v.jsx(
            "div",
            {
              className: lt(
                p.baseStyle.title,
                P.title,
                D.title
              ),
              children: t
            }
          ),
          /* @__PURE__ */ v.jsx(
            "div",
            {
              className: lt(
                p.baseStyle.message,
                P.message,
                D.message
              ),
              children: r
            }
          ),
          n && /* @__PURE__ */ v.jsx("div", { className: p.baseStyle.actions, children: n.map((G, Y) => /* @__PURE__ */ v.jsx(
            qe,
            {
              variant: G.variant,
              size: l === "lg" ? "md" : "sm",
              onClick: (te) => {
                te.stopPropagation(), G.onClick();
              },
              disabled: G.disabled,
              children: G.label
            },
            Y
          )) })
        ] }),
        c && /* @__PURE__ */ v.jsx(
          qe,
          {
            variant: "ghost",
            size: "sm",
            icon: "close",
            onClick: (G) => {
              G.stopPropagation(), m();
            },
            className: p.baseStyle.dismissButton,
            "aria-label": "Close"
          }
        )
      ]
    }
  );
}, ZX = ({
  toasts: e,
  removeToast: t
}) => {
  var s;
  const { theme: r } = Wi(), n = (s = r == null ? void 0 : r.components) == null ? void 0 : s.Toast;
  if (!n)
    return console.error("Toast theme is not properly configured"), null;
  const a = e.reduce(
    (i, o) => {
      const l = o.position || "top-right";
      return i[l] || (i[l] = []), i[l].push(o), i;
    },
    {}
  );
  return bw(
    /* @__PURE__ */ v.jsx(v.Fragment, { children: Object.entries(a).map(([i, o]) => {
      const l = n.baseStyle.positionStyles[i];
      return l ? /* @__PURE__ */ v.jsx(
        "div",
        {
          className: lt(n.baseStyle.container, l),
          children: o.map((c) => /* @__PURE__ */ v.jsx(
            aF,
            {
              ...c,
              theme: n,
              onClose: () => t(c.id)
            },
            c.id
          ))
        },
        i
      ) : null;
    }) }),
    document.body
  );
}, fet = $r("Toast", aF), CA = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", iE = 36;
let M1 = 0;
function lm(e = "") {
  const t = Date.now().toString(iE), r = (M1++).toString(iE);
  M1 > 1e3 && (M1 = 0);
  let n = "";
  for (let a = 0; a < 4; a++)
    n += CA[Math.floor(Math.random() * CA.length)];
  return `${e}${t}_${r}_${n}`;
}
function het(e) {
  const t = e.split("_")[0];
  return parseInt(t, iE);
}
function eQ() {
  const [e, t] = Me([]), r = tr(/* @__PURE__ */ new Map()), n = Ft((c) => {
    const u = r.current.get(c);
    u != null && u.timeoutId && (window.clearTimeout(u.timeoutId), r.current.delete(c));
  }, []), a = Ft(
    (c, u, d) => {
      n(c);
      const f = window.setTimeout(d, u);
      r.current.set(c, {
        timeoutId: f,
        startTime: Date.now(),
        remainingTime: u
      });
    },
    [n]
  ), s = Ft(
    (c) => {
      const u = lm(), d = c.duration ?? 5e3, f = {
        ...c,
        id: u,
        status: "entering"
      };
      return t((h) => [...h, f]), d > 0 && a(u, d, () => {
        var h;
        i(u), (h = f.onDismiss) == null || h.call(f);
      }), u;
    },
    [a]
  ), i = Ft(
    (c) => {
      t(
        (u) => u.map(
          (d) => d.id === c ? { ...d, status: "exiting" } : d
        )
      ), n(c), setTimeout(() => {
        t((u) => u.filter((d) => d.id !== c));
      }, 300);
    },
    [n]
  ), o = Ft(
    (c) => {
      const u = r.current.get(c);
      if (u) {
        n(c);
        const d = Date.now() - u.startTime;
        u.remainingTime = Math.max(0, u.remainingTime - d), r.current.set(c, u);
      }
    },
    [n]
  ), l = Ft(
    (c) => {
      const u = r.current.get(c);
      u != null && u.remainingTime && a(c, u.remainingTime, () => i(c));
    },
    [a, i]
  );
  return {
    toasts: e,
    addToast: s,
    removeToast: i,
    removeAllToasts: Ft(() => {
      e.forEach((c) => n(c.id)), t([]);
    }, [e, n]),
    updateToast: Ft((c, u) => {
      t(
        (d) => d.map((f) => f.id === c ? { ...f, ...u } : f)
      );
    }, []),
    pauseToast: o,
    resumeToast: l
  };
}
const sF = Vl(void 0);
function pet({ children: e }) {
  const t = eQ();
  return /* @__PURE__ */ v.jsxs(sF.Provider, { value: t, children: [
    e,
    /* @__PURE__ */ v.jsx(
      ZX,
      {
        toasts: t.toasts,
        removeToast: t.removeToast
      }
    )
  ] });
}
function tQ() {
  const e = vh(sF);
  if (!e)
    throw new Error("useToastContext must be used within ToastProvider");
  return e;
}
function Da() {
  const { addToast: e, removeToast: t, updateToast: r } = tQ(), n = Ft(
    (s, i, o) => e({ type: s, message: i, ...o }),
    [e]
  ), a = Ft(
    async (s, i) => {
      const o = n("info", i.loading, {
        duration: 0,
        ...i
      });
      try {
        const l = await s, c = typeof i.success == "function" ? i.success(l) : i.success;
        return t(o), n("success", c, i), l;
      } catch (l) {
        const c = l, u = typeof i.error == "function" ? i.error(c) : i.error;
        throw t(o), n("error", u, i), c;
      }
    },
    [n, t]
  );
  return {
    success: (s, i) => n("success", s, i),
    error: (s, i) => n("error", s, i),
    warning: (s, i) => n("warning", s, i),
    info: (s, i) => n("info", s, i),
    promise: a,
    custom: (s) => e(s),
    update: r,
    remove: t
  };
}
const rQ = (e, t, r, n) => {
  var s, i, o, l;
  const a = [r, {
    code: t,
    ...n || {}
  }];
  if ((i = (s = e == null ? void 0 : e.services) == null ? void 0 : s.logger) != null && i.forward)
    return e.services.logger.forward(a, "warn", "react-i18next::", !0);
  Au(a[0]) && (a[0] = `react-i18next:: ${a[0]}`), (l = (o = e == null ? void 0 : e.services) == null ? void 0 : o.logger) != null && l.warn ? e.services.logger.warn(...a) : console != null && console.warn && console.warn(...a);
}, kA = {}, oE = (e, t, r, n) => {
  Au(r) && kA[r] || (Au(r) && (kA[r] = /* @__PURE__ */ new Date()), rQ(e, t, r, n));
}, iF = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const r = () => {
      setTimeout(() => {
        e.off("initialized", r);
      }, 0), t();
    };
    e.on("initialized", r);
  }
}, lE = (e, t, r) => {
  e.loadNamespaces(t, iF(e, r));
}, OA = (e, t, r, n) => {
  if (Au(r) && (r = [r]), e.options.preload && e.options.preload.indexOf(t) > -1) return lE(e, r, n);
  r.forEach((a) => {
    e.options.ns.indexOf(a) < 0 && e.options.ns.push(a);
  }), e.loadLanguages(t, iF(e, n));
}, nQ = (e, t, r = {}) => !t.languages || !t.languages.length ? (oE(t, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: t.languages
}), !0) : t.hasLoadedNamespace(e, {
  lng: r.lng,
  precheck: (n, a) => {
    var s;
    if (((s = r.bindI18n) == null ? void 0 : s.indexOf("languageChanging")) > -1 && n.services.backendConnector.backend && n.isLanguageChangingTo && !a(n.isLanguageChangingTo, e)) return !1;
  }
}), Au = (e) => typeof e == "string", aQ = (e) => typeof e == "object" && e !== null, sQ = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, iQ = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, oQ = (e) => iQ[e], lQ = (e) => e.replace(sQ, oQ);
let cE = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: lQ
};
const cQ = (e = {}) => {
  cE = {
    ...cE,
    ...e
  };
}, uQ = () => cE;
let oF;
const dQ = (e) => {
  oF = e;
}, fQ = () => oF, hQ = {
  type: "3rdParty",
  init(e) {
    cQ(e.options.react), dQ(e);
  }
}, pQ = Vl();
class mQ {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((r) => {
      this.usedNamespaces[r] || (this.usedNamespaces[r] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const gQ = (e, t) => {
  const r = tr();
  return wt(() => {
    r.current = e;
  }, [e, t]), r.current;
}, lF = (e, t, r, n) => e.getFixedT(t, r, n), vQ = (e, t, r, n) => Ft(lF(e, t, r, n), [e, t, r, n]), _t = (e, t = {}) => {
  var _, S, C, E;
  const {
    i18n: r
  } = t, {
    i18n: n,
    defaultNS: a
  } = vh(pQ) || {}, s = r || n || fQ();
  if (s && !s.reportNamespaces && (s.reportNamespaces = new mQ()), !s) {
    oE(s, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const O = (A, P) => Au(P) ? P : aQ(P) && Au(P.defaultValue) ? P.defaultValue : Array.isArray(A) ? A[A.length - 1] : A, k = [O, {}, !1];
    return k.t = O, k.i18n = {}, k.ready = !1, k;
  }
  (_ = s.options.react) != null && _.wait && oE(s, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const i = {
    ...uQ(),
    ...s.options.react,
    ...t
  }, {
    useSuspense: o,
    keyPrefix: l
  } = i;
  let c = e || a || ((S = s.options) == null ? void 0 : S.defaultNS);
  c = Au(c) ? [c] : c || ["translation"], (E = (C = s.reportNamespaces).addUsedNamespaces) == null || E.call(C, c);
  const u = (s.isInitialized || s.initializedStoreOnce) && c.every((O) => nQ(O, s, i)), d = vQ(s, t.lng || null, i.nsMode === "fallback" ? c : c[0], l), f = () => d, h = () => lF(s, t.lng || null, i.nsMode === "fallback" ? c : c[0], l), [p, m] = Me(f);
  let g = c.join();
  t.lng && (g = `${t.lng}${g}`);
  const y = gQ(g), x = tr(!0);
  wt(() => {
    const {
      bindI18n: O,
      bindI18nStore: k
    } = i;
    x.current = !0, !u && !o && (t.lng ? OA(s, t.lng, c, () => {
      x.current && m(h);
    }) : lE(s, c, () => {
      x.current && m(h);
    })), u && y && y !== g && x.current && m(h);
    const A = () => {
      x.current && m(h);
    };
    return O && (s == null || s.on(O, A)), k && (s == null || s.store.on(k, A)), () => {
      x.current = !1, s && (O == null || O.split(" ").forEach((P) => s.off(P, A))), k && s && k.split(" ").forEach((P) => s.store.off(P, A));
    };
  }, [s, g]), wt(() => {
    x.current && u && m(f);
  }, [s, l, u]);
  const w = [p, s, u];
  if (w.t = p, w.i18n = s, w.ready = u, u || !u && !o) return w;
  throw new Promise((O) => {
    t.lng ? OA(s, t.lng, c, () => O()) : lE(s, c, () => O());
  });
}, yQ = new ed();
function zc() {
  const { error: e } = Da(), { t } = _t(["common"]);
  return { handleError: Ft(
    (n) => {
      const a = yQ.adaptError(n);
      return console.error("[ErrorHandler]", {
        category: a.category,
        code: a.code,
        message: a.message,
        details: a.details,
        metadata: a.metadata
      }), e(
        t(`errors.${a.category}.${a.code}`, {
          defaultValue: a.message,
          ...a.details
        })
      ), a;
    },
    [t, e]
  ) };
}
class met extends b3 {
  constructor(r = {}) {
    super(r);
    Fe(this, "headers");
    this.headers = r.headers;
  }
}
class get {
  constructor(t, r, n) {
    this.message = t, this.code = r, this.details = n;
  }
  toString() {
    return this.message;
  }
}
const vet = () => {
  const { error: e } = Da();
  return (t) => {
    var n, a, s;
    let r = "An unexpected error occurred";
    return Be.isAxiosError(t) ? ((n = t.response) == null ? void 0 : n.status) === 0 ? r = "Unable to access the API. Please check your network connection and try again." : r = ((s = (a = t.response) == null ? void 0 : a.data) == null ? void 0 : s.message) || t.message : t instanceof Error && (r = t.message), console.error("API Error:", t), e(r), r;
  };
}, cF = {};
function Th(e, t) {
  cF[e] = t;
}
const bQ = () => cF;
function yet(e) {
  return e;
}
var Er;
(function(e) {
  e.assertEqual = (a) => a;
  function t(a) {
  }
  e.assertIs = t;
  function r(a) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (a) => {
    const s = {};
    for (const i of a)
      s[i] = i;
    return s;
  }, e.getValidEnumValues = (a) => {
    const s = e.objectKeys(a).filter((o) => typeof a[a[o]] != "number"), i = {};
    for (const o of s)
      i[o] = a[o];
    return e.objectValues(i);
  }, e.objectValues = (a) => e.objectKeys(a).map(function(s) {
    return a[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const s = [];
    for (const i in a)
      Object.prototype.hasOwnProperty.call(a, i) && s.push(i);
    return s;
  }, e.find = (a, s) => {
    for (const i of a)
      if (s(i))
        return i;
  }, e.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, s = " | ") {
    return a.map((i) => typeof i == "string" ? `'${i}'` : i).join(s);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (a, s) => typeof s == "bigint" ? s.toString() : s;
})(Er || (Er = {}));
var uE;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(uE || (uE = {}));
const Ot = Er.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), bl = (e) => {
  switch (typeof e) {
    case "undefined":
      return Ot.undefined;
    case "string":
      return Ot.string;
    case "number":
      return isNaN(e) ? Ot.nan : Ot.number;
    case "boolean":
      return Ot.boolean;
    case "function":
      return Ot.function;
    case "bigint":
      return Ot.bigint;
    case "symbol":
      return Ot.symbol;
    case "object":
      return Array.isArray(e) ? Ot.array : e === null ? Ot.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Ot.promise : typeof Map < "u" && e instanceof Map ? Ot.map : typeof Set < "u" && e instanceof Set ? Ot.set : typeof Date < "u" && e instanceof Date ? Ot.date : Ot.object;
    default:
      return Ot.unknown;
  }
}, ut = Er.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), wQ = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class Hs extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const r = t || function(s) {
      return s.message;
    }, n = { _errors: [] }, a = (s) => {
      for (const i of s.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(a);
        else if (i.code === "invalid_return_type")
          a(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          a(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, l = 0;
          for (; l < i.path.length; ) {
            const c = i.path[l];
            l === i.path.length - 1 ? (o[c] = o[c] || { _errors: [] }, o[c]._errors.push(r(i))) : o[c] = o[c] || { _errors: [] }, o = o[c], l++;
          }
        }
    };
    return a(this), n;
  }
  static assert(t) {
    if (!(t instanceof Hs))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Er.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(t(a))) : n.push(t(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
Hs.create = (e) => new Hs(e);
const Qf = (e, t) => {
  let r;
  switch (e.code) {
    case ut.invalid_type:
      e.received === Ot.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case ut.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, Er.jsonStringifyReplacer)}`;
      break;
    case ut.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${Er.joinValues(e.keys, ", ")}`;
      break;
    case ut.invalid_union:
      r = "Invalid input";
      break;
    case ut.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${Er.joinValues(e.options)}`;
      break;
    case ut.invalid_enum_value:
      r = `Invalid enum value. Expected ${Er.joinValues(e.options)}, received '${e.received}'`;
      break;
    case ut.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case ut.invalid_return_type:
      r = "Invalid function return type";
      break;
    case ut.invalid_date:
      r = "Invalid date";
      break;
    case ut.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : Er.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case ut.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case ut.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case ut.custom:
      r = "Invalid input";
      break;
    case ut.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case ut.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case ut.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, Er.assertNever(e);
  }
  return { message: r };
};
let uF = Qf;
function xQ(e) {
  uF = e;
}
function Vy() {
  return uF;
}
const $y = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: a } = e, s = [...r, ...a.path || []], i = {
    ...a,
    path: s
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: s,
      message: a.message
    };
  let o = "";
  const l = n.filter((c) => !!c).slice().reverse();
  for (const c of l)
    o = c(i, { data: t, defaultError: o }).message;
  return {
    ...a,
    path: s,
    message: o
  };
}, _Q = [];
function Et(e, t) {
  const r = Vy(), n = $y({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === Qf ? void 0 : Qf
      // then global default map
    ].filter((a) => !!a)
  });
  e.common.issues.push(n);
}
class Qa {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return qt;
      a.status === "dirty" && t.dirty(), n.push(a.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const a of r) {
      const s = await a.key, i = await a.value;
      n.push({
        key: s,
        value: i
      });
    }
    return Qa.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const a of r) {
      const { key: s, value: i } = a;
      if (s.status === "aborted" || i.status === "aborted")
        return qt;
      s.status === "dirty" && t.dirty(), i.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof i.value < "u" || a.alwaysSet) && (n[s.value] = i.value);
    }
    return { status: t.value, value: n };
  }
}
const qt = Object.freeze({
  status: "aborted"
}), Af = (e) => ({ status: "dirty", value: e }), fs = (e) => ({ status: "valid", value: e }), dE = (e) => e.status === "aborted", fE = (e) => e.status === "dirty", Bu = (e) => e.status === "valid", Lm = (e) => typeof Promise < "u" && e instanceof Promise;
function Hy(e, t, r, n) {
  if (typeof t == "function" ? e !== t || !0 : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t.get(e);
}
function dF(e, t, r, n, a) {
  if (typeof t == "function" ? e !== t || !0 : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, r), r;
}
var jt;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(jt || (jt = {}));
var Kp, qp;
class jo {
  constructor(t, r, n, a) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const AA = (e, t) => {
  if (Bu(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new Hs(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function ir(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: a } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: a } : { errorMap: (i, o) => {
    var l, c;
    const { message: u } = e;
    return i.code === "invalid_enum_value" ? { message: u ?? o.defaultError } : typeof o.data > "u" ? { message: (l = u ?? n) !== null && l !== void 0 ? l : o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: (c = u ?? r) !== null && c !== void 0 ? c : o.defaultError };
  }, description: a };
}
class dr {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return bl(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: bl(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new Qa(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: bl(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (Lm(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: bl(t)
    }, s = this._parseSync({ data: t, path: a.path, parent: a });
    return AA(a, s);
  }
  "~validate"(t) {
    var r, n;
    const a = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: bl(t)
    };
    if (!this["~standard"].async)
      try {
        const s = this._parseSync({ data: t, path: [], parent: a });
        return Bu(s) ? {
          value: s.value
        } : {
          issues: a.common.issues
        };
      } catch (s) {
        !((n = (r = s == null ? void 0 : s.message) === null || r === void 0 ? void 0 : r.toLowerCase()) === null || n === void 0) && n.includes("encountered") && (this["~standard"].async = !0), a.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: a }).then((s) => Bu(s) ? {
      value: s.value
    } : {
      issues: a.common.issues
    });
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: bl(t)
    }, a = this._parse({ data: t, path: n.path, parent: n }), s = await (Lm(a) ? a : Promise.resolve(a));
    return AA(n, s);
  }
  refine(t, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, s) => {
      const i = t(a), o = () => s.addIssue({
        code: ut.custom,
        ...n(a)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((l) => l ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, a) => t(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(t) {
    return new Vi({
      schema: this,
      typeName: Kt.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return Oo.create(this, this._def);
  }
  nullable() {
    return Pc.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ji.create(this);
  }
  promise() {
    return Zf.create(this, this._def);
  }
  or(t) {
    return Um.create([this, t], this._def);
  }
  and(t) {
    return Vm.create(this, t, this._def);
  }
  transform(t) {
    return new Vi({
      ...ir(this._def),
      schema: this,
      typeName: Kt.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Km({
      ...ir(this._def),
      innerType: this,
      defaultValue: r,
      typeName: Kt.ZodDefault
    });
  }
  brand() {
    return new zT({
      typeName: Kt.ZodBranded,
      type: this,
      ...ir(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new qm({
      ...ir(this._def),
      innerType: this,
      catchValue: r,
      typeName: Kt.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return Sg.create(this, t);
  }
  readonly() {
    return Gm.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const SQ = /^c[^\s-]{8,}$/i, EQ = /^[0-9a-z]+$/, TQ = /^[0-9A-HJKMNP-TV-Z]{26}$/i, CQ = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, kQ = /^[a-z0-9_-]{21}$/i, OQ = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, AQ = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, PQ = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, RQ = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let L1;
const IQ = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, DQ = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, NQ = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, MQ = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, LQ = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, jQ = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, fF = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", FQ = new RegExp(`^${fF}$`);
function hF(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function BQ(e) {
  return new RegExp(`^${hF(e)}$`);
}
function pF(e) {
  let t = `${fF}T${hF(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function UQ(e, t) {
  return !!((t === "v4" || !t) && IQ.test(e) || (t === "v6" || !t) && NQ.test(e));
}
function VQ(e, t) {
  if (!OQ.test(e))
    return !1;
  try {
    const [r] = e.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || !a.typ || !a.alg || t && a.alg !== t);
  } catch {
    return !1;
  }
}
function $Q(e, t) {
  return !!((t === "v4" || !t) && DQ.test(e) || (t === "v6" || !t) && MQ.test(e));
}
class Ii extends dr {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== Ot.string) {
      const s = this._getOrReturnCtx(t);
      return Et(s, {
        code: ut.invalid_type,
        expected: Ot.string,
        received: s.parsedType
      }), qt;
    }
    const n = new Qa();
    let a;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (a = this._getOrReturnCtx(t, a), Et(a, {
          code: ut.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (a = this._getOrReturnCtx(t, a), Et(a, {
          code: ut.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "length") {
        const i = t.data.length > s.value, o = t.data.length < s.value;
        (i || o) && (a = this._getOrReturnCtx(t, a), i ? Et(a, {
          code: ut.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && Et(a, {
          code: ut.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), n.dirty());
      } else if (s.kind === "email")
        PQ.test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
          validation: "email",
          code: ut.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "emoji")
        L1 || (L1 = new RegExp(RQ, "u")), L1.test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
          validation: "emoji",
          code: ut.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "uuid")
        CQ.test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
          validation: "uuid",
          code: ut.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "nanoid")
        kQ.test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
          validation: "nanoid",
          code: ut.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid")
        SQ.test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
          validation: "cuid",
          code: ut.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid2")
        EQ.test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
          validation: "cuid2",
          code: ut.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "ulid")
        TQ.test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
          validation: "ulid",
          code: ut.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          a = this._getOrReturnCtx(t, a), Et(a, {
            validation: "url",
            code: ut.invalid_string,
            message: s.message
          }), n.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
        validation: "regex",
        code: ut.invalid_string,
        message: s.message
      }), n.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (a = this._getOrReturnCtx(t, a), Et(a, {
        code: ut.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), n.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (a = this._getOrReturnCtx(t, a), Et(a, {
        code: ut.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (a = this._getOrReturnCtx(t, a), Et(a, {
        code: ut.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "datetime" ? pF(s).test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
        code: ut.invalid_string,
        validation: "datetime",
        message: s.message
      }), n.dirty()) : s.kind === "date" ? FQ.test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
        code: ut.invalid_string,
        validation: "date",
        message: s.message
      }), n.dirty()) : s.kind === "time" ? BQ(s).test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
        code: ut.invalid_string,
        validation: "time",
        message: s.message
      }), n.dirty()) : s.kind === "duration" ? AQ.test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
        validation: "duration",
        code: ut.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "ip" ? UQ(t.data, s.version) || (a = this._getOrReturnCtx(t, a), Et(a, {
        validation: "ip",
        code: ut.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "jwt" ? VQ(t.data, s.alg) || (a = this._getOrReturnCtx(t, a), Et(a, {
        validation: "jwt",
        code: ut.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "cidr" ? $Q(t.data, s.version) || (a = this._getOrReturnCtx(t, a), Et(a, {
        validation: "cidr",
        code: ut.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64" ? LQ.test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
        validation: "base64",
        code: ut.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64url" ? jQ.test(t.data) || (a = this._getOrReturnCtx(t, a), Et(a, {
        validation: "base64url",
        code: ut.invalid_string,
        message: s.message
      }), n.dirty()) : Er.assertNever(s);
    return { status: n.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((a) => t.test(a), {
      validation: r,
      code: ut.invalid_string,
      ...jt.errToObj(n)
    });
  }
  _addCheck(t) {
    return new Ii({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...jt.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...jt.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...jt.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...jt.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...jt.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...jt.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...jt.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...jt.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...jt.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...jt.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...jt.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...jt.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...jt.errToObj(t) });
  }
  datetime(t) {
    var r, n;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (r = t == null ? void 0 : t.offset) !== null && r !== void 0 ? r : !1,
      local: (n = t == null ? void 0 : t.local) !== null && n !== void 0 ? n : !1,
      ...jt.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...jt.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...jt.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...jt.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...jt.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...jt.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...jt.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...jt.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...jt.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...jt.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, jt.errToObj(t));
  }
  trim() {
    return new Ii({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Ii({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Ii({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Ii.create = (e) => {
  var t;
  return new Ii({
    checks: [],
    typeName: Kt.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...ir(e)
  });
};
function HQ(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, a = r > n ? r : n, s = parseInt(e.toFixed(a).replace(".", "")), i = parseInt(t.toFixed(a).replace(".", ""));
  return s % i / Math.pow(10, a);
}
class kc extends dr {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== Ot.number) {
      const s = this._getOrReturnCtx(t);
      return Et(s, {
        code: ut.invalid_type,
        expected: Ot.number,
        received: s.parsedType
      }), qt;
    }
    let n;
    const a = new Qa();
    for (const s of this._def.checks)
      s.kind === "int" ? Er.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), Et(n, {
        code: ut.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), a.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), Et(n, {
        code: ut.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), Et(n, {
        code: ut.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? HQ(t.data, s.value) !== 0 && (n = this._getOrReturnCtx(t, n), Et(n, {
        code: ut.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), Et(n, {
        code: ut.not_finite,
        message: s.message
      }), a.dirty()) : Er.assertNever(s);
    return { status: a.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, jt.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, jt.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, jt.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, jt.toString(r));
  }
  setLimit(t, r, n, a) {
    return new kc({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: jt.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new kc({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: jt.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: jt.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: jt.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: jt.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: jt.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: jt.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: jt.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: jt.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: jt.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && Er.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
kc.create = (e) => new kc({
  checks: [],
  typeName: Kt.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...ir(e)
});
class Oc extends dr {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== Ot.bigint)
      return this._getInvalidInput(t);
    let n;
    const a = new Qa();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), Et(n, {
        code: ut.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), Et(n, {
        code: ut.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), Et(n, {
        code: ut.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : Er.assertNever(s);
    return { status: a.value, value: t.data };
  }
  _getInvalidInput(t) {
    const r = this._getOrReturnCtx(t);
    return Et(r, {
      code: ut.invalid_type,
      expected: Ot.bigint,
      received: r.parsedType
    }), qt;
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, jt.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, jt.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, jt.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, jt.toString(r));
  }
  setLimit(t, r, n, a) {
    return new Oc({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: jt.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Oc({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: jt.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: jt.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: jt.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: jt.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: jt.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Oc.create = (e) => {
  var t;
  return new Oc({
    checks: [],
    typeName: Kt.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...ir(e)
  });
};
class jm extends dr {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== Ot.boolean) {
      const n = this._getOrReturnCtx(t);
      return Et(n, {
        code: ut.invalid_type,
        expected: Ot.boolean,
        received: n.parsedType
      }), qt;
    }
    return fs(t.data);
  }
}
jm.create = (e) => new jm({
  typeName: Kt.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...ir(e)
});
class Uu extends dr {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== Ot.date) {
      const s = this._getOrReturnCtx(t);
      return Et(s, {
        code: ut.invalid_type,
        expected: Ot.date,
        received: s.parsedType
      }), qt;
    }
    if (isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return Et(s, {
        code: ut.invalid_date
      }), qt;
    }
    const n = new Qa();
    let a;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (a = this._getOrReturnCtx(t, a), Et(a, {
        code: ut.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), n.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (a = this._getOrReturnCtx(t, a), Et(a, {
        code: ut.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), n.dirty()) : Er.assertNever(s);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Uu({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: jt.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: jt.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
Uu.create = (e) => new Uu({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: Kt.ZodDate,
  ...ir(e)
});
class Wy extends dr {
  _parse(t) {
    if (this._getType(t) !== Ot.symbol) {
      const n = this._getOrReturnCtx(t);
      return Et(n, {
        code: ut.invalid_type,
        expected: Ot.symbol,
        received: n.parsedType
      }), qt;
    }
    return fs(t.data);
  }
}
Wy.create = (e) => new Wy({
  typeName: Kt.ZodSymbol,
  ...ir(e)
});
class Fm extends dr {
  _parse(t) {
    if (this._getType(t) !== Ot.undefined) {
      const n = this._getOrReturnCtx(t);
      return Et(n, {
        code: ut.invalid_type,
        expected: Ot.undefined,
        received: n.parsedType
      }), qt;
    }
    return fs(t.data);
  }
}
Fm.create = (e) => new Fm({
  typeName: Kt.ZodUndefined,
  ...ir(e)
});
class Bm extends dr {
  _parse(t) {
    if (this._getType(t) !== Ot.null) {
      const n = this._getOrReturnCtx(t);
      return Et(n, {
        code: ut.invalid_type,
        expected: Ot.null,
        received: n.parsedType
      }), qt;
    }
    return fs(t.data);
  }
}
Bm.create = (e) => new Bm({
  typeName: Kt.ZodNull,
  ...ir(e)
});
class Jf extends dr {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return fs(t.data);
  }
}
Jf.create = (e) => new Jf({
  typeName: Kt.ZodAny,
  ...ir(e)
});
class Pu extends dr {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return fs(t.data);
  }
}
Pu.create = (e) => new Pu({
  typeName: Kt.ZodUnknown,
  ...ir(e)
});
class jl extends dr {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return Et(r, {
      code: ut.invalid_type,
      expected: Ot.never,
      received: r.parsedType
    }), qt;
  }
}
jl.create = (e) => new jl({
  typeName: Kt.ZodNever,
  ...ir(e)
});
class zy extends dr {
  _parse(t) {
    if (this._getType(t) !== Ot.undefined) {
      const n = this._getOrReturnCtx(t);
      return Et(n, {
        code: ut.invalid_type,
        expected: Ot.void,
        received: n.parsedType
      }), qt;
    }
    return fs(t.data);
  }
}
zy.create = (e) => new zy({
  typeName: Kt.ZodVoid,
  ...ir(e)
});
class ji extends dr {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), a = this._def;
    if (r.parsedType !== Ot.array)
      return Et(r, {
        code: ut.invalid_type,
        expected: Ot.array,
        received: r.parsedType
      }), qt;
    if (a.exactLength !== null) {
      const i = r.data.length > a.exactLength.value, o = r.data.length < a.exactLength.value;
      (i || o) && (Et(r, {
        code: i ? ut.too_big : ut.too_small,
        minimum: o ? a.exactLength.value : void 0,
        maximum: i ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (Et(r, {
      code: ut.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (Et(r, {
      code: ut.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => a.type._parseAsync(new jo(r, i, r.path, o)))).then((i) => Qa.mergeArray(n, i));
    const s = [...r.data].map((i, o) => a.type._parseSync(new jo(r, i, r.path, o)));
    return Qa.mergeArray(n, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new ji({
      ...this._def,
      minLength: { value: t, message: jt.toString(r) }
    });
  }
  max(t, r) {
    return new ji({
      ...this._def,
      maxLength: { value: t, message: jt.toString(r) }
    });
  }
  length(t, r) {
    return new ji({
      ...this._def,
      exactLength: { value: t, message: jt.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
ji.create = (e, t) => new ji({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Kt.ZodArray,
  ...ir(t)
});
function lf(e) {
  if (e instanceof xn) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = Oo.create(lf(n));
    }
    return new xn({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof ji ? new ji({
    ...e._def,
    type: lf(e.element)
  }) : e instanceof Oo ? Oo.create(lf(e.unwrap())) : e instanceof Pc ? Pc.create(lf(e.unwrap())) : e instanceof Fo ? Fo.create(e.items.map((t) => lf(t))) : e;
}
class xn extends dr {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = Er.objectKeys(t);
    return this._cached = { shape: t, keys: r };
  }
  _parse(t) {
    if (this._getType(t) !== Ot.object) {
      const c = this._getOrReturnCtx(t);
      return Et(c, {
        code: ut.invalid_type,
        expected: Ot.object,
        received: c.parsedType
      }), qt;
    }
    const { status: n, ctx: a } = this._processInputParams(t), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof jl && this._def.unknownKeys === "strip"))
      for (const c in a.data)
        i.includes(c) || o.push(c);
    const l = [];
    for (const c of i) {
      const u = s[c], d = a.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: u._parse(new jo(a, d, a.path, c)),
        alwaysSet: c in a.data
      });
    }
    if (this._def.catchall instanceof jl) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const u of o)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (c === "strict")
        o.length > 0 && (Et(a, {
          code: ut.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const u of o) {
        const d = a.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: c._parse(
            new jo(a, d, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const u of l) {
        const d = await u.key, f = await u.value;
        c.push({
          key: d,
          value: f,
          alwaysSet: u.alwaysSet
        });
      }
      return c;
    }).then((c) => Qa.mergeObjectSync(n, c)) : Qa.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return jt.errToObj, new xn({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var a, s, i, o;
          const l = (i = (s = (a = this._def).errorMap) === null || s === void 0 ? void 0 : s.call(a, r, n).message) !== null && i !== void 0 ? i : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (o = jt.errToObj(t).message) !== null && o !== void 0 ? o : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new xn({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new xn({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new xn({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new xn({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: Kt.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new xn({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    return Er.objectKeys(t).forEach((n) => {
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new xn({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    return Er.objectKeys(this.shape).forEach((n) => {
      t[n] || (r[n] = this.shape[n]);
    }), new xn({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return lf(this);
  }
  partial(t) {
    const r = {};
    return Er.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      t && !t[n] ? r[n] = a : r[n] = a.optional();
    }), new xn({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    return Er.objectKeys(this.shape).forEach((n) => {
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let s = this.shape[n];
        for (; s instanceof Oo; )
          s = s._def.innerType;
        r[n] = s;
      }
    }), new xn({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return mF(Er.objectKeys(this.shape));
  }
}
xn.create = (e, t) => new xn({
  shape: () => e,
  unknownKeys: "strip",
  catchall: jl.create(),
  typeName: Kt.ZodObject,
  ...ir(t)
});
xn.strictCreate = (e, t) => new xn({
  shape: () => e,
  unknownKeys: "strict",
  catchall: jl.create(),
  typeName: Kt.ZodObject,
  ...ir(t)
});
xn.lazycreate = (e, t) => new xn({
  shape: e,
  unknownKeys: "strip",
  catchall: jl.create(),
  typeName: Kt.ZodObject,
  ...ir(t)
});
class Um extends dr {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function a(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new Hs(o.ctx.common.issues));
      return Et(r, {
        code: ut.invalid_union,
        unionErrors: i
      }), qt;
    }
    if (r.common.async)
      return Promise.all(n.map(async (s) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(a);
    {
      let s;
      const i = [];
      for (const l of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !s && (s = { result: u, ctx: c }), c.common.issues.length && i.push(c.common.issues);
      }
      if (s)
        return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((l) => new Hs(l));
      return Et(r, {
        code: ut.invalid_union,
        unionErrors: o
      }), qt;
    }
  }
  get options() {
    return this._def.options;
  }
}
Um.create = (e, t) => new Um({
  options: e,
  typeName: Kt.ZodUnion,
  ...ir(t)
});
const hl = (e) => e instanceof Hm ? hl(e.schema) : e instanceof Vi ? hl(e.innerType()) : e instanceof Wm ? [e.value] : e instanceof Ac ? e.options : e instanceof zm ? Er.objectValues(e.enum) : e instanceof Km ? hl(e._def.innerType) : e instanceof Fm ? [void 0] : e instanceof Bm ? [null] : e instanceof Oo ? [void 0, ...hl(e.unwrap())] : e instanceof Pc ? [null, ...hl(e.unwrap())] : e instanceof zT || e instanceof Gm ? hl(e.unwrap()) : e instanceof qm ? hl(e._def.innerType) : [];
class Aw extends dr {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Ot.object)
      return Et(r, {
        code: ut.invalid_type,
        expected: Ot.object,
        received: r.parsedType
      }), qt;
    const n = this.discriminator, a = r.data[n], s = this.optionsMap.get(a);
    return s ? r.common.async ? s._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : s._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (Et(r, {
      code: ut.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), qt);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const s of r) {
      const i = hl(s.shape[t]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (a.has(o))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(o)}`);
        a.set(o, s);
      }
    }
    return new Aw({
      typeName: Kt.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: a,
      ...ir(n)
    });
  }
}
function hE(e, t) {
  const r = bl(e), n = bl(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === Ot.object && n === Ot.object) {
    const a = Er.objectKeys(t), s = Er.objectKeys(e).filter((o) => a.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of s) {
      const l = hE(e[o], t[o]);
      if (!l.valid)
        return { valid: !1 };
      i[o] = l.data;
    }
    return { valid: !0, data: i };
  } else if (r === Ot.array && n === Ot.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const a = [];
    for (let s = 0; s < e.length; s++) {
      const i = e[s], o = t[s], l = hE(i, o);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return r === Ot.date && n === Ot.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Vm extends dr {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = (s, i) => {
      if (dE(s) || dE(i))
        return qt;
      const o = hE(s.value, i.value);
      return o.valid ? ((fE(s) || fE(i)) && r.dirty(), { status: r.value, value: o.data }) : (Et(n, {
        code: ut.invalid_intersection_types
      }), qt);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([s, i]) => a(s, i)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Vm.create = (e, t, r) => new Vm({
  left: e,
  right: t,
  typeName: Kt.ZodIntersection,
  ...ir(r)
});
class Fo extends dr {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Ot.array)
      return Et(n, {
        code: ut.invalid_type,
        expected: Ot.array,
        received: n.parsedType
      }), qt;
    if (n.data.length < this._def.items.length)
      return Et(n, {
        code: ut.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), qt;
    !this._def.rest && n.data.length > this._def.items.length && (Et(n, {
      code: ut.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const s = [...n.data].map((i, o) => {
      const l = this._def.items[o] || this._def.rest;
      return l ? l._parse(new jo(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(s).then((i) => Qa.mergeArray(r, i)) : Qa.mergeArray(r, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Fo({
      ...this._def,
      rest: t
    });
  }
}
Fo.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Fo({
    items: e,
    typeName: Kt.ZodTuple,
    rest: null,
    ...ir(t)
  });
};
class $m extends dr {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Ot.object)
      return Et(n, {
        code: ut.invalid_type,
        expected: Ot.object,
        received: n.parsedType
      }), qt;
    const a = [], s = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      a.push({
        key: s._parse(new jo(n, o, n.path, o)),
        value: i._parse(new jo(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? Qa.mergeObjectAsync(r, a) : Qa.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof dr ? new $m({
      keyType: t,
      valueType: r,
      typeName: Kt.ZodRecord,
      ...ir(n)
    }) : new $m({
      keyType: Ii.create(),
      valueType: t,
      typeName: Kt.ZodRecord,
      ...ir(r)
    });
  }
}
class Ky extends dr {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Ot.map)
      return Et(n, {
        code: ut.invalid_type,
        expected: Ot.map,
        received: n.parsedType
      }), qt;
    const a = this._def.keyType, s = this._def.valueType, i = [...n.data.entries()].map(([o, l], c) => ({
      key: a._parse(new jo(n, o, n.path, [c, "key"])),
      value: s._parse(new jo(n, l, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of i) {
          const c = await l.key, u = await l.value;
          if (c.status === "aborted" || u.status === "aborted")
            return qt;
          (c.status === "dirty" || u.status === "dirty") && r.dirty(), o.set(c.value, u.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const l of i) {
        const c = l.key, u = l.value;
        if (c.status === "aborted" || u.status === "aborted")
          return qt;
        (c.status === "dirty" || u.status === "dirty") && r.dirty(), o.set(c.value, u.value);
      }
      return { status: r.value, value: o };
    }
  }
}
Ky.create = (e, t, r) => new Ky({
  valueType: t,
  keyType: e,
  typeName: Kt.ZodMap,
  ...ir(r)
});
class Vu extends dr {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Ot.set)
      return Et(n, {
        code: ut.invalid_type,
        expected: Ot.set,
        received: n.parsedType
      }), qt;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (Et(n, {
      code: ut.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (Et(n, {
      code: ut.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const s = this._def.valueType;
    function i(l) {
      const c = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return qt;
        u.status === "dirty" && r.dirty(), c.add(u.value);
      }
      return { status: r.value, value: c };
    }
    const o = [...n.data.values()].map((l, c) => s._parse(new jo(n, l, n.path, c)));
    return n.common.async ? Promise.all(o).then((l) => i(l)) : i(o);
  }
  min(t, r) {
    return new Vu({
      ...this._def,
      minSize: { value: t, message: jt.toString(r) }
    });
  }
  max(t, r) {
    return new Vu({
      ...this._def,
      maxSize: { value: t, message: jt.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Vu.create = (e, t) => new Vu({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: Kt.ZodSet,
  ...ir(t)
});
class Nf extends dr {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Ot.function)
      return Et(r, {
        code: ut.invalid_type,
        expected: Ot.function,
        received: r.parsedType
      }), qt;
    function n(o, l) {
      return $y({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          Vy(),
          Qf
        ].filter((c) => !!c),
        issueData: {
          code: ut.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function a(o, l) {
      return $y({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          Vy(),
          Qf
        ].filter((c) => !!c),
        issueData: {
          code: ut.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const s = { errorMap: r.common.contextualErrorMap }, i = r.data;
    if (this._def.returns instanceof Zf) {
      const o = this;
      return fs(async function(...l) {
        const c = new Hs([]), u = await o._def.args.parseAsync(l, s).catch((h) => {
          throw c.addIssue(n(l, h)), c;
        }), d = await Reflect.apply(i, this, u);
        return await o._def.returns._def.type.parseAsync(d, s).catch((h) => {
          throw c.addIssue(a(d, h)), c;
        });
      });
    } else {
      const o = this;
      return fs(function(...l) {
        const c = o._def.args.safeParse(l, s);
        if (!c.success)
          throw new Hs([n(l, c.error)]);
        const u = Reflect.apply(i, this, c.data), d = o._def.returns.safeParse(u, s);
        if (!d.success)
          throw new Hs([a(u, d.error)]);
        return d.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new Nf({
      ...this._def,
      args: Fo.create(t).rest(Pu.create())
    });
  }
  returns(t) {
    return new Nf({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, r, n) {
    return new Nf({
      args: t || Fo.create([]).rest(Pu.create()),
      returns: r || Pu.create(),
      typeName: Kt.ZodFunction,
      ...ir(n)
    });
  }
}
class Hm extends dr {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Hm.create = (e, t) => new Hm({
  getter: e,
  typeName: Kt.ZodLazy,
  ...ir(t)
});
class Wm extends dr {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return Et(r, {
        received: r.data,
        code: ut.invalid_literal,
        expected: this._def.value
      }), qt;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Wm.create = (e, t) => new Wm({
  value: e,
  typeName: Kt.ZodLiteral,
  ...ir(t)
});
function mF(e, t) {
  return new Ac({
    values: e,
    typeName: Kt.ZodEnum,
    ...ir(t)
  });
}
class Ac extends dr {
  constructor() {
    super(...arguments), Kp.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return Et(r, {
        expected: Er.joinValues(n),
        received: r.parsedType,
        code: ut.invalid_type
      }), qt;
    }
    if (Hy(this, Kp) || dF(this, Kp, new Set(this._def.values)), !Hy(this, Kp).has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return Et(r, {
        received: r.data,
        code: ut.invalid_enum_value,
        options: n
      }), qt;
    }
    return fs(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return Ac.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return Ac.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
Kp = /* @__PURE__ */ new WeakMap();
Ac.create = mF;
class zm extends dr {
  constructor() {
    super(...arguments), qp.set(this, void 0);
  }
  _parse(t) {
    const r = Er.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== Ot.string && n.parsedType !== Ot.number) {
      const a = Er.objectValues(r);
      return Et(n, {
        expected: Er.joinValues(a),
        received: n.parsedType,
        code: ut.invalid_type
      }), qt;
    }
    if (Hy(this, qp) || dF(this, qp, new Set(Er.getValidEnumValues(this._def.values))), !Hy(this, qp).has(t.data)) {
      const a = Er.objectValues(r);
      return Et(n, {
        received: n.data,
        code: ut.invalid_enum_value,
        options: a
      }), qt;
    }
    return fs(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
qp = /* @__PURE__ */ new WeakMap();
zm.create = (e, t) => new zm({
  values: e,
  typeName: Kt.ZodNativeEnum,
  ...ir(t)
});
class Zf extends dr {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Ot.promise && r.common.async === !1)
      return Et(r, {
        code: ut.invalid_type,
        expected: Ot.promise,
        received: r.parsedType
      }), qt;
    const n = r.parsedType === Ot.promise ? r.data : Promise.resolve(r.data);
    return fs(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
Zf.create = (e, t) => new Zf({
  type: e,
  typeName: Kt.ZodPromise,
  ...ir(t)
});
class Vi extends dr {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Kt.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = this._def.effect || null, s = {
      addIssue: (i) => {
        Et(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), a.type === "preprocess") {
      const i = a.transform(n.data, s);
      if (n.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (r.value === "aborted")
            return qt;
          const l = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? qt : l.status === "dirty" || r.value === "dirty" ? Af(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return qt;
        const o = this._def.schema._parseSync({
          data: i,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? qt : o.status === "dirty" || r.value === "dirty" ? Af(o.value) : o;
      }
    }
    if (a.type === "refinement") {
      const i = (o) => {
        const l = a.refinement(o, s);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? qt : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? qt : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!Bu(i))
          return i;
        const o = a.transform(i.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => Bu(i) ? Promise.resolve(a.transform(i.value, s)).then((o) => ({ status: r.value, value: o })) : i);
    Er.assertNever(a);
  }
}
Vi.create = (e, t, r) => new Vi({
  schema: e,
  typeName: Kt.ZodEffects,
  effect: t,
  ...ir(r)
});
Vi.createWithPreprocess = (e, t, r) => new Vi({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: Kt.ZodEffects,
  ...ir(r)
});
class Oo extends dr {
  _parse(t) {
    return this._getType(t) === Ot.undefined ? fs(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Oo.create = (e, t) => new Oo({
  innerType: e,
  typeName: Kt.ZodOptional,
  ...ir(t)
});
class Pc extends dr {
  _parse(t) {
    return this._getType(t) === Ot.null ? fs(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Pc.create = (e, t) => new Pc({
  innerType: e,
  typeName: Kt.ZodNullable,
  ...ir(t)
});
class Km extends dr {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === Ot.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Km.create = (e, t) => new Km({
  innerType: e,
  typeName: Kt.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...ir(t)
});
class qm extends dr {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Lm(a) ? a.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new Hs(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Hs(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
qm.create = (e, t) => new qm({
  innerType: e,
  typeName: Kt.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...ir(t)
});
class qy extends dr {
  _parse(t) {
    if (this._getType(t) !== Ot.nan) {
      const n = this._getOrReturnCtx(t);
      return Et(n, {
        code: ut.invalid_type,
        expected: Ot.nan,
        received: n.parsedType
      }), qt;
    }
    return { status: "valid", value: t.data };
  }
}
qy.create = (e) => new qy({
  typeName: Kt.ZodNaN,
  ...ir(e)
});
const WQ = Symbol("zod_brand");
class zT extends dr {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Sg extends dr {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? qt : s.status === "dirty" ? (r.dirty(), Af(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? qt : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new Sg({
      in: t,
      out: r,
      typeName: Kt.ZodPipeline
    });
  }
}
class Gm extends dr {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (a) => (Bu(a) && (a.value = Object.freeze(a.value)), a);
    return Lm(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Gm.create = (e, t) => new Gm({
  innerType: e,
  typeName: Kt.ZodReadonly,
  ...ir(t)
});
function PA(e, t) {
  const r = typeof e == "function" ? e(t) : typeof e == "string" ? { message: e } : e;
  return typeof r == "string" ? { message: r } : r;
}
function gF(e, t = {}, r) {
  return e ? Jf.create().superRefine((n, a) => {
    var s, i;
    const o = e(n);
    if (o instanceof Promise)
      return o.then((l) => {
        var c, u;
        if (!l) {
          const d = PA(t, n), f = (u = (c = d.fatal) !== null && c !== void 0 ? c : r) !== null && u !== void 0 ? u : !0;
          a.addIssue({ code: "custom", ...d, fatal: f });
        }
      });
    if (!o) {
      const l = PA(t, n), c = (i = (s = l.fatal) !== null && s !== void 0 ? s : r) !== null && i !== void 0 ? i : !0;
      a.addIssue({ code: "custom", ...l, fatal: c });
    }
  }) : Jf.create();
}
const zQ = {
  object: xn.lazycreate
};
var Kt;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(Kt || (Kt = {}));
const KQ = (e, t = {
  message: `Input not instance of ${e.name}`
}) => gF((r) => r instanceof e, t), vF = Ii.create, yF = kc.create, qQ = qy.create, GQ = Oc.create, bF = jm.create, YQ = Uu.create, XQ = Wy.create, QQ = Fm.create, JQ = Bm.create, ZQ = Jf.create, eJ = Pu.create, tJ = jl.create, rJ = zy.create, nJ = ji.create, aJ = xn.create, sJ = xn.strictCreate, iJ = Um.create, oJ = Aw.create, lJ = Vm.create, cJ = Fo.create, uJ = $m.create, dJ = Ky.create, fJ = Vu.create, hJ = Nf.create, pJ = Hm.create, mJ = Wm.create, gJ = Ac.create, vJ = zm.create, yJ = Zf.create, RA = Vi.create, bJ = Oo.create, wJ = Pc.create, xJ = Vi.createWithPreprocess, _J = Sg.create, SJ = () => vF().optional(), EJ = () => yF().optional(), TJ = () => bF().optional(), CJ = {
  string: (e) => Ii.create({ ...e, coerce: !0 }),
  number: (e) => kc.create({ ...e, coerce: !0 }),
  boolean: (e) => jm.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => Oc.create({ ...e, coerce: !0 }),
  date: (e) => Uu.create({ ...e, coerce: !0 })
}, kJ = qt;
var B = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Qf,
  setErrorMap: xQ,
  getErrorMap: Vy,
  makeIssue: $y,
  EMPTY_PATH: _Q,
  addIssueToContext: Et,
  ParseStatus: Qa,
  INVALID: qt,
  DIRTY: Af,
  OK: fs,
  isAborted: dE,
  isDirty: fE,
  isValid: Bu,
  isAsync: Lm,
  get util() {
    return Er;
  },
  get objectUtil() {
    return uE;
  },
  ZodParsedType: Ot,
  getParsedType: bl,
  ZodType: dr,
  datetimeRegex: pF,
  ZodString: Ii,
  ZodNumber: kc,
  ZodBigInt: Oc,
  ZodBoolean: jm,
  ZodDate: Uu,
  ZodSymbol: Wy,
  ZodUndefined: Fm,
  ZodNull: Bm,
  ZodAny: Jf,
  ZodUnknown: Pu,
  ZodNever: jl,
  ZodVoid: zy,
  ZodArray: ji,
  ZodObject: xn,
  ZodUnion: Um,
  ZodDiscriminatedUnion: Aw,
  ZodIntersection: Vm,
  ZodTuple: Fo,
  ZodRecord: $m,
  ZodMap: Ky,
  ZodSet: Vu,
  ZodFunction: Nf,
  ZodLazy: Hm,
  ZodLiteral: Wm,
  ZodEnum: Ac,
  ZodNativeEnum: zm,
  ZodPromise: Zf,
  ZodEffects: Vi,
  ZodTransformer: Vi,
  ZodOptional: Oo,
  ZodNullable: Pc,
  ZodDefault: Km,
  ZodCatch: qm,
  ZodNaN: qy,
  BRAND: WQ,
  ZodBranded: zT,
  ZodPipeline: Sg,
  ZodReadonly: Gm,
  custom: gF,
  Schema: dr,
  ZodSchema: dr,
  late: zQ,
  get ZodFirstPartyTypeKind() {
    return Kt;
  },
  coerce: CJ,
  any: ZQ,
  array: nJ,
  bigint: GQ,
  boolean: bF,
  date: YQ,
  discriminatedUnion: oJ,
  effect: RA,
  enum: gJ,
  function: hJ,
  instanceof: KQ,
  intersection: lJ,
  lazy: pJ,
  literal: mJ,
  map: dJ,
  nan: qQ,
  nativeEnum: vJ,
  never: tJ,
  null: JQ,
  nullable: wJ,
  number: yF,
  object: aJ,
  oboolean: TJ,
  onumber: EJ,
  optional: bJ,
  ostring: SJ,
  pipeline: _J,
  preprocess: xJ,
  promise: yJ,
  record: uJ,
  set: fJ,
  strictObject: sJ,
  string: vF,
  symbol: XQ,
  transformer: RA,
  tuple: cJ,
  undefined: QQ,
  union: iJ,
  unknown: eJ,
  void: rJ,
  NEVER: kJ,
  ZodIssueCode: ut,
  quotelessJson: wQ,
  ZodError: Hs
});
const OJ = {
  TABLE: "table"
};
var _n = /* @__PURE__ */ ((e) => (e.ASC = "asc", e.DESC = "desc", e))(_n || {});
function eh(e) {
  const t = e.getFullYear(), r = String(e.getMonth() + 1).padStart(2, "0"), n = String(e.getDate()).padStart(2, "0");
  return `${t}-${r}-${n}`;
}
function pE(e) {
  const t = String(e.getDate()).padStart(2, "0"), r = String(e.getMonth() + 1).padStart(2, "0"), n = e.getFullYear();
  return `${t}/${r}/${n}`;
}
function AJ(e) {
  if (!e) return null;
  if (e.includes("-"))
    return new Date(e);
  const [t, r, n] = e.split("/").map(Number);
  return isNaN(t) || isNaN(r) || isNaN(n) ? null : new Date(n, r - 1, t);
}
function bet(e) {
  return [...Array(7)].map(
    (t, r) => new Date(2024, 0, r + 1).toLocaleDateString(e, { weekday: "short" })
  );
}
function wet(e) {
  return [...Array(12)].map(
    (t, r) => new Date(2024, r, 1).toLocaleDateString(e, { month: "long" })
  );
}
const PJ = {
  locale: "en-US",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  notation: "standard",
  compactDisplay: "short",
  signDisplay: "auto",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  roundingMode: "round",
  useGrouping: !0,
  preserveDecimals: !1
};
function Ao(e, t = {}) {
  const r = { ...PJ, ...t }, n = r.preserveDecimals ? e : r.roundingMode === "ceil" ? Math.ceil(e) : r.roundingMode === "floor" ? Math.floor(e) : r.roundingMode === "trunc" ? Math.trunc(e) : Math.round(e), a = new Intl.NumberFormat(r.locale, {
    minimumFractionDigits: r.minimumFractionDigits,
    maximumFractionDigits: r.maximumFractionDigits,
    notation: r.notation,
    compactDisplay: r.compactDisplay,
    signDisplay: r.signDisplay,
    useGrouping: r.useGrouping
  });
  let s = a.format(n);
  return (r.thousandsSeparator !== "," || r.decimalSeparator !== ".") && (s = a.formatToParts(n).map((o) => o.type === "group" ? r.thousandsSeparator : o.type === "decimal" ? r.decimalSeparator : o.value).join("")), s;
}
const RJ = ({
  children: e,
  color: t = "primary",
  size: r,
  variant: n,
  className: a,
  icon: s,
  onRemove: i,
  theme: o,
  ...l
}) => {
  var y, x;
  const c = o.baseStyle, u = o.defaultProps ?? {
    size: "md",
    variant: "solid",
    color: "primary"
  }, d = o.variants ?? {}, f = r ?? u.size, h = n ?? u.variant, p = t ?? u.color, m = d[h] ?? d.solid, g = lt(
    c.base,
    c.container,
    c.sizes[f],
    m == null ? void 0 : m.base,
    m == null ? void 0 : m[p],
    s && ((y = c.states) == null ? void 0 : y.withIcon),
    i && ((x = c.states) == null ? void 0 : x.withRemove),
    a
  );
  return /* @__PURE__ */ v.jsxs("span", { className: g, ...l, children: [
    s && /* @__PURE__ */ v.jsx("span", { className: c.icon, children: s }),
    /* @__PURE__ */ v.jsx("span", { className: c.text, children: e }),
    i && /* @__PURE__ */ v.jsx(
      "button",
      {
        type: "button",
        onClick: i,
        className: c.removeButton,
        "aria-label": "Remove",
        children: /* @__PURE__ */ v.jsx(
          "svg",
          {
            className: "h-3 w-3",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            children: /* @__PURE__ */ v.jsx(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M6 18L18 6M6 6l12 12"
              }
            )
          }
        )
      }
    )
  ] });
}, an = $r("Tag", RJ), Rc = (e) => "funded" in e ? "funded" : "pending" in e ? "pending" : "valid" in e ? "valid" : "refunded" in e ? "refunded" : "rejected" in e ? `${e.rejected}` : "unknown", xet = (e) => e ? "bridgeapi" in e ? "bridgeapi" : "mangopay" in e ? "mangopay" : "dev" in e ? "dev" : null : null, IA = (e) => {
  if (!e) return null;
  if ("pending" in e) {
    const t = e.pending;
    if (typeof t == "string")
      return t;
    if (t && typeof t == "object" && t !== null) {
      if ("mangopay" in t && t.mangopay && typeof t.mangopay == "object" && t.mangopay !== null && "return_url" in t.mangopay)
        return t.mangopay.return_url;
      if ("bridgeapi" in t && t.bridgeapi)
        return typeof t.bridgeapi == "string" ? t.bridgeapi : null;
    }
  }
  return null;
}, Pw = (e) => {
  switch (e) {
    case "pending":
      return "warning";
    case "valid":
      return "info";
    case "refunded":
      return "info";
    case "rejected":
      return "danger";
    case "NOAS":
      return "danger";
    case "expired":
      return "danger";
    case "funded":
      return "success";
    case "executed":
      return "success";
    default:
      return "primary";
  }
}, KT = (e) => {
  if (!e || !e.status || !e.info) {
    const i = (e == null ? void 0 : e.status) || "unknown";
    return {
      textKey: `campaigns.status.${i.toLowerCase()}`,
      styleKey: i
    };
  }
  const t = /* @__PURE__ */ new Date(), r = e.info.start_date ? new Date(e.info.start_date) : null, n = r && e.info.duration ? new Date(
    r.getTime() + e.info.duration * 24 * 60 * 60 * 1e3
  ) : null, a = e.status, s = {
    textKey: `campaigns.status.${a.toLowerCase()}`,
    styleKey: a
  };
  return a === Nr.Canceled || a === Nr.Minted ? s : (a === Nr.Available || a === Nr.Closed) && n && n < t ? {
    textKey: "campaigns.status.expired",
    styleKey: "expired"
  } : a === Nr.Available && // Only check if Available
  r && r > t ? {
    textKey: "campaigns.status.startsOn",
    styleKey: "startsOn",
    // Use consistent styleKey
    date: r
    // Pass date for interpolation
  } : (a === Nr.Available || a === Nr.Closed) && typeof e.available == "number" && e.available === 0 ? {
    textKey: "campaigns.status.goalReached",
    styleKey: "goalReached"
  } : s;
}, DA = (e) => {
  if (!e) return "secondary";
  switch (e) {
    case Nr.Available:
    case "goalReached":
    case "startsOn":
      return "success";
    case Nr.Created:
      return "info";
    case Nr.Canceled:
      return "danger";
    case Nr.Closed:
      return "warning";
    case Nr.Minted:
      return "success";
    case "expired":
      return "gray";
    default:
      return "gray";
  }
}, IJ = (e) => {
  if (!e) return "bg-secondary-500";
  switch (e) {
    case Nr.Available:
      return "bg-success-500 border-success-700 border text-white shadow-sm";
    case "startsOn":
      return "bg-success-300 border-success-700 border text-success-900 shadow-sm";
    case "goalReached":
      return "bg-success-600 border-success-800 border text-white shadow-sm";
    case Nr.Created:
      return "bg-info-500 border-info-700 border text-white shadow-sm";
    case Nr.Canceled:
      return "bg-danger-500 border-danger-700 border text-white shadow-sm";
    case Nr.Closed:
      return "bg-warning-500 border-warning-700 border text-white shadow-sm";
    case Nr.Minted:
      return "bg-success-700 border-success-900 border text-white shadow-sm";
    case "expired":
      return "bg-gray-600 border-gray-800 border text-white shadow-sm";
    default:
      return "bg-gray-600 border-gray-800 border text-white shadow-sm";
  }
}, mE = (e) => (e == null ? void 0 : e.private) === !0, NA = (e, t) => (e == null ? void 0 : e.private) === !0 ? !0 : (e == null ? void 0 : e.private) === !1 ? !1 : t === !0, j1 = () => ui().SIGNATURE_PROVIDER, qT = () => {
  const { t: e } = _t(["campaigns"]), t = sn(), [r, n] = Me([]);
  wt(() => {
    (async () => {
      try {
        const u = (await t.projectsApi.projects({})).filter((d) => d.id !== void 0).map((d) => ({
          value: d.id,
          label: d.name
        }));
        n(u);
      } catch (c) {
        console.error("Error fetching projects:", c);
      }
    })();
  }, [t]);
  const a = Tn(
    () => ({
      getAll: async (l) => {
        const { offset: c, limit: u } = l, d = await t.campaignsApi.campaignsPage({
          offset: c,
          limit: u
        });
        return {
          data: d.results,
          pagination: {
            total: d.meta.total,
            offset: d.meta.offset,
            limit: d.meta.limit,
            currentPage: d.meta.current_page,
            totalPages: d.meta.total_pages
          },
          links: d.links
        };
      },
      getOne: async (l) => await t.campaignsApi.campaign({ id: l }),
      create: async (l) => {
        var c, u;
        try {
          const d = j1();
          let f;
          d === "signaturit" ? f = { signaturit: String(
            ((c = l.info.signature) == null ? void 0 : c.signaturit) || ""
          ) } : f = { docuseal: Number(
            ((u = l.info.signature) == null ? void 0 : u.docuseal) || 0
          ) };
          const h = {
            ...l,
            project: Number(l.project),
            info: {
              ...l.info,
              name: l.info.name,
              start_date: eh(new Date(l.info.start_date)),
              duration: Number(l.info.duration),
              batches: Number(l.info.batches),
              // Use the signature object
              signature: f,
              // Include the private field
              private: NA(l.info),
              // Optional fields
              minimal_batches: l.info.minimal_batches !== void 0 ? Number(l.info.minimal_batches) : void 0
            },
            status: l.status || "created"
          }, p = await t.campaignsApi.createCampaign({
            campaignInput: h
          });
          return await t.campaignsApi.campaign({
            id: p
          });
        } catch (d) {
          throw console.error("Error creating campaign:", d), d;
        }
      },
      update: async (l, c) => {
        var u, d, f, h, p, m, g, y, x, w, _;
        try {
          const S = await t.campaignsApi.campaign({ id: l }), C = typeof c.project == "object" && c.project !== null ? Number(
            c.project.id || c.project.value
          ) || S.project.id : c.project !== void 0 ? Number(c.project) : S.project.id, E = (u = c.info) != null && u.start_date ? new Date(c.info.start_date) : new Date(S.info.start_date);
          if (isNaN(E.getTime()))
            throw new Error("Invalid date format");
          const O = j1();
          let k;
          O === "signaturit" ? k = { signaturit: String(
            ((f = (d = c.info) == null ? void 0 : d.signature) == null ? void 0 : f.signaturit) || ((h = S.info.signature) == null ? void 0 : h.signaturit) || ""
          ) } : k = { docuseal: Number(
            ((m = (p = c.info) == null ? void 0 : p.signature) == null ? void 0 : m.docuseal) || ((g = S.info.signature) == null ? void 0 : g.docuseal) || 0
          ) };
          const A = {
            name: ((y = c.info) == null ? void 0 : y.name) || S.info.name,
            start_date: eh(E),
            duration: ((x = c.info) == null ? void 0 : x.duration) !== void 0 ? Number(c.info.duration) : S.info.duration,
            batches: ((w = c.info) == null ? void 0 : w.batches) !== void 0 ? Number(c.info.batches) : S.info.batches,
            // Use the signature object
            signature: k,
            // Include the private field
            private: NA(c.info, S.info.private)
          };
          ((_ = c.info) == null ? void 0 : _.minimal_batches) !== void 0 ? A.minimal_batches = Number(c.info.minimal_batches) : S.info.minimal_batches !== void 0 && (A.minimal_batches = S.info.minimal_batches);
          const P = {
            project: C,
            info: A,
            status: c.status || S.status
          };
          return await t.campaignsApi.updateCampaign({
            id: l,
            campaignInput: P
          }), await t.campaignsApi.campaign({ id: l });
        } catch (S) {
          throw console.error("Error updating campaign:", S), S;
        }
      },
      delete: (l) => t.campaignsApi.deleteCampaign({ id: l })
    }),
    [t]
  ), s = j1(), i = {
    extractItems: (l) => l,
    extractTotal: (l) => l.length
  };
  return {
    entityConfig: {
      name: "campaigns",
      formLayout: "single-page",
      columns: [
        {
          id: "info.name",
          label: e("campaigns.name"),
          sortable: !0,
          render: (l) => l.info.name
        },
        {
          id: "project.name",
          label: e("campaigns.project"),
          sortable: !0,
          render: (l) => {
            var c;
            return (c = l.project) == null ? void 0 : c.name;
          }
        },
        {
          id: "status",
          label: e("campaigns.status.title"),
          sortable: !0,
          render: (l) => {
            const c = KT(l), u = c.textKey === "campaigns.status.startsOn" && c.date ? e(c.textKey, {
              date: pE(c.date)
              // Format date explicitly
            }) : e(c.textKey);
            return /* @__PURE__ */ v.jsx(
              an,
              {
                variant: "solid",
                color: DA(c.styleKey),
                size: "sm",
                children: u
              }
            );
          }
        },
        {
          id: "info.private",
          label: e("campaigns.privateCol"),
          sortable: !0,
          render: (l) => /* @__PURE__ */ v.jsx(
            an,
            {
              variant: "solid",
              color: mE(l.info) ? "info" : "gray",
              size: "sm",
              children: mE(l.info) ? e("campaigns.privateTag") : e("campaigns.publicTag")
            }
          ),
          width: "120px"
        },
        {
          id: "info.start_date",
          label: e("campaigns.startDate"),
          sortable: !0,
          render: (l) => pE(new Date(l.info.start_date))
        },
        {
          id: "info.duration",
          label: e("campaigns.duration"),
          sortable: !0,
          render: (l) => `${Ao(l.info.duration, {
            notation: "standard",
            thousandsSeparator: " "
          })} ${e("campaigns.day", {
            count: l.info.duration
          })}`
        },
        {
          id: "info.batches",
          label: e("campaigns.batches"),
          sortable: !0,
          render: (l) => /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-1 whitespace-nowrap", children: [
            /* @__PURE__ */ v.jsx("span", { children: Ao(l.available, {
              notation: "standard",
              thousandsSeparator: " "
            }) }),
            /* @__PURE__ */ v.jsx("span", { className: "text-xs text-muted-foreground italic", children: e("campaigns.remaining", { count: l.available }) }),
            /* @__PURE__ */ v.jsx("span", { children: "/" }),
            /* @__PURE__ */ v.jsx("span", { children: Ao(l.info.batches, {
              notation: "standard",
              thousandsSeparator: " "
            }) }),
            /* @__PURE__ */ v.jsx("span", { className: "text-xs text-muted-foreground italic", children: e("campaigns.total", { count: l.info.batches }) })
          ] })
        }
      ],
      formSections: [
        {
          title: e("campaigns.formTitle"),
          fields: [
            {
              name: "info.name",
              label: e("campaigns.name"),
              type: "text",
              required: !0,
              // Required by OpenAPI
              labelProps: { position: "top" },
              layout: { className: "col-span-12" },
              description: e("campaigns.nameDescription")
            },
            {
              name: "project",
              label: e("campaigns.project"),
              type: "select",
              required: !0,
              // Required by OpenAPI
              labelProps: { position: "top" },
              layout: { className: "col-span-4" },
              placeholder: e("common:select.placeholder"),
              options: r,
              description: e("campaigns.projectDescription"),
              transform: {
                input: (l) => typeof l == "object" && l !== null ? l.id || l.value || null : l !== void 0 ? Number(l) : null,
                output: (l) => l && typeof l == "object" && "id" in l && "name" in l ? {
                  label: l.name,
                  value: l.id
                } : typeof l == "number" && !isNaN(l) && r.length > 0 && r.find(
                  (u) => u.value === l
                ) || null
              }
            },
            {
              name: "info.start_date",
              label: e("campaigns.startDate"),
              type: "date",
              required: !0,
              // Required by OpenAPI
              labelProps: { position: "top" },
              layout: { className: "col-start-1 col-end-7" },
              description: e("campaigns.startDateDescription")
            },
            {
              name: "info.duration",
              label: e("campaigns.duration"),
              type: "number",
              required: !0,
              // Required by OpenAPI
              labelProps: { position: "top" },
              layout: { className: "col-span-6" },
              description: e("campaigns.durationDescription")
            },
            {
              name: "info.batches",
              label: e("campaigns.batches"),
              type: "number",
              required: !0,
              // Required by OpenAPI
              labelProps: { position: "top" },
              layout: { className: "col-span-6" },
              description: e("campaigns.batchesDescription")
            },
            {
              name: "info.minimal_batches",
              label: e("campaigns.minimalBatches"),
              type: "number",
              required: !1,
              // Optional in OpenAPI
              labelProps: { position: "top" },
              layout: { className: "col-span-6" },
              description: e("campaigns.minimalBatchesDescription")
            },
            {
              name: "info.private",
              label: e("campaigns.private"),
              type: "switch",
              labelProps: { position: "right" },
              layout: { className: "col-span-12" },
              description: e("campaigns.privateDescription")
            },
            {
              name: s === "signaturit" ? "info.signature.signaturit" : "info.signature.docuseal",
              label: e(`campaigns.signature.${s}`),
              type: s === "signaturit" ? "text" : "number",
              required: !0,
              // Required by OpenAPI
              labelProps: { position: "top" },
              layout: { className: "col-span-12" },
              description: e(
                `campaigns.signature.${s}Description`
              )
            }
          ]
        }
      ],
      validationSchema: {
        create: B.object({
          info: B.object({
            name: B.string().min(1, e("common:validation.required")),
            start_date: B.string().min(1, e("common:validation.required")),
            duration: B.coerce.number({
              required_error: e("common:validation.required")
            }).positive(),
            batches: B.coerce.number({
              required_error: e("common:validation.required")
            }).positive().int(),
            minimal_batches: B.coerce.number().optional(),
            private: B.boolean().optional().transform((l) => l === !0),
            signature: s === "signaturit" ? B.object({
              signaturit: B.string().default("")
            }) : B.object({
              docuseal: B.coerce.number().default(0)
            })
          }).transform((l) => ({
            ...l,
            // Only set default if signature is missing
            signature: l.signature || (s === "signaturit" ? { signaturit: "" } : { docuseal: 0 })
          })),
          project: B.coerce.number({
            required_error: e("common:validation.required")
          }),
          status: B.nativeEnum(eo).optional().default("created")
        }).transform((l) => ({
          ...l,
          info: l.info ? {
            ...l.info,
            // Only set default if signature is missing
            signature: l.info.signature || (s === "signaturit" ? { signaturit: "" } : { docuseal: 0 })
          } : void 0,
          status: l.status || "created"
        })),
        update: B.object({
          id: B.coerce.number().optional(),
          project: B.union([
            B.coerce.number(),
            B.object({
              id: B.coerce.number(),
              value: B.coerce.number()
            }),
            B.object({
              id: B.coerce.number(),
              name: B.string()
            })
          ]).transform((l) => {
            if (typeof l == "object" && l !== null && "id" in l)
              return Number(l.id);
            const c = Number(l);
            return isNaN(c) ? 0 : c;
          }).optional(),
          info: B.object({
            name: B.string().min(1, e("common:validation.required")).optional(),
            start_date: B.string().min(1, e("common:validation.required")).optional(),
            duration: B.coerce.number({
              required_error: e("common:validation.required")
            }).positive().optional(),
            batches: B.coerce.number({
              required_error: e("common:validation.required")
            }).positive().int().optional(),
            minimal_batches: B.coerce.number().optional(),
            private: B.boolean().optional().transform((l) => l === !0),
            signature: s === "signaturit" ? B.object({
              signaturit: B.string().default("")
            }) : B.object({
              docuseal: B.coerce.number().default(0)
            })
          }).optional().transform((l) => l ? {
            ...l,
            // Only set default if signature is missing
            signature: l.signature || (s === "signaturit" ? { signaturit: "" } : { docuseal: 0 })
          } : void 0),
          status: B.nativeEnum(eo).optional(),
          _isDraft: B.boolean().optional()
        }).transform((l) => ({
          ...l,
          info: l.info ? {
            ...l.info,
            // Only set default if signature is missing
            signature: l.info.signature || (s === "signaturit" ? { signaturit: "" } : { docuseal: 0 })
          } : void 0
        }))
      },
      tableConfig: {
        defaultSortColumn: "id",
        defaultSortDirection: _n.ASC,
        searchFields: ["info.name", "project.name"]
      },
      statusConfig: {
        title: e("campaigns.status.title"),
        steps: [
          {
            label: e("campaigns.generalInfo"),
            status: "completed",
            description: e("campaigns.generalInfoDescription")
          },
          {
            label: e("campaigns.projectSelection"),
            status: "completed",
            description: e("campaigns.projectSelectionDescription")
          }
        ]
      },
      viewModalConfig: {
        title: (l) => e("campaigns.viewModal.title", { name: l.info.name }),
        size: "full",
        statusTags: [
          {
            id: "status",
            valueKey: "status",
            getLabel: (l) => e(`campaigns.status.${l}`),
            getColor: DA
          }
        ],
        actions: [
          {
            id: "mint",
            label: e("campaigns.actions.mint"),
            icon: "cube",
            color: "primary",
            handler: async (l) => {
              await t.campaignsApi.mintCampaign({ id: l.id });
            },
            isVisible: (l) => l.status === "available",
            isDisabled: (l) => !1
            // Add your conditions
          }
        ],
        cards: [
          {
            id: "nft",
            title: e("campaigns.nft.title"),
            icon: "cube",
            color: "primary",
            isVisible: (l) => !!(l.status === "minted" && l.project.blockchain),
            content: (l) => {
              if (!l.project.blockchain) return null;
              const u = `https://ghostnet.tzkt.io/${l.project.blockchain.contract}/${l.project.blockchain.token_id}`;
              return /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col gap-2", children: [
                /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ v.jsxs("span", { className: "text-sm text-muted-foreground", children: [
                    e("campaigns.nft.contract"),
                    ":"
                  ] }),
                  /* @__PURE__ */ v.jsx("span", { className: "font-mono text-sm", children: l.project.blockchain.contract })
                ] }),
                /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ v.jsxs("span", { className: "text-sm text-muted-foreground", children: [
                    e("campaigns.nft.tokenId"),
                    ":"
                  ] }),
                  /* @__PURE__ */ v.jsx("span", { className: "font-mono text-sm", children: l.project.blockchain.token_id })
                ] }),
                /* @__PURE__ */ v.jsxs(
                  "a",
                  {
                    href: u,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "text-primary hover:text-primary-600 text-sm flex items-center gap-1 mt-2",
                    children: [
                      /* @__PURE__ */ v.jsx(dt, { name: "arrow-top-right-on-square", size: "sm" }),
                      e("campaigns.nft.viewOnExplorer")
                    ]
                  }
                )
              ] });
            }
          }
        ],
        kpis: {
          items: [
            {
              id: "contract-deployment",
              label: e("campaigns.kpis.contractDeployment"),
              icon: "code-bracket",
              color: "primary",
              valueKey: "deployment",
              statusKey: "status"
            },
            {
              id: "whitelisting",
              label: e("campaigns.kpis.whitelisting"),
              icon: "user-check",
              color: "success",
              valueKey: "whitelisting",
              statusKey: "status"
            },
            {
              id: "minting",
              label: e("campaigns.kpis.minting"),
              icon: "cube",
              color: "warning",
              valueKey: "minting",
              statusKey: "status"
            }
          ],
          batchFetch: async (l) => {
            const c = await t.campaignsApi.mintStatus({
              id: l.id
            }), u = c.processing.length + c.processed.length, d = () => {
              switch (c.status) {
                case "deploying":
                  return {
                    "contract-deployment": `0 / ${u}`,
                    whitelisting: `0 / ${u}`,
                    minting: `0 / ${u}`
                  };
                case "whitelisting":
                  return {
                    "contract-deployment": `${u} / ${u}`,
                    whitelisting: `${c.processed.length} / ${u}`,
                    minting: `0 / ${u}`
                  };
                case "minting":
                  return {
                    "contract-deployment": `${u} / ${u}`,
                    whitelisting: `${u} / ${u}`,
                    minting: `${c.processed.length} / ${u}`
                  };
                case "minted":
                  return {
                    "contract-deployment": `${u} / ${u}`,
                    whitelisting: `${u} / ${u}`,
                    minting: `${u} / ${u}`
                  };
                default:
                  return {
                    "contract-deployment": `0 / ${u}`,
                    whitelisting: `0 / ${u}`,
                    minting: `0 / ${u}`
                  };
              }
            }, f = () => ({
              "contract-deployment": c.status === "deploying" ? "pending" : "success",
              whitelisting: c.status === "whitelisting" ? "pending" : c.status === "deploying" ? "waiting" : "success",
              minting: c.status === "minting" ? "pending" : c.status === "minted" ? "success" : "waiting"
            });
            return {
              values: d(),
              statuses: f()
            };
          }
        },
        tabs: [
          {
            id: "orders",
            label: e("campaigns.orders.title"),
            listConfig: {
              entityName: "campaign-orders",
              getConfig: (l) => {
                const { t: c } = _t(["orders"]), u = sn();
                return {
                  entityConfig: {
                    name: "orders",
                    columns: [
                      {
                        id: "id",
                        label: c("common:common.id"),
                        sortable: !0,
                        render: (d) => d.id
                      },
                      {
                        id: "user",
                        label: c("orders.user"),
                        sortable: !0,
                        render: (d) => {
                          var f, h, p, m, g, y, x, w;
                          return ((h = (f = d.user) == null ? void 0 : f.info) == null ? void 0 : h.kind) === "individual" ? `${(m = (p = d.user) == null ? void 0 : p.info) == null ? void 0 : m.first_name} ${(y = (g = d.user) == null ? void 0 : g.info) == null ? void 0 : y.last_name}` : ((w = (x = d.user) == null ? void 0 : x.info) == null ? void 0 : w.company_name) || "-";
                        }
                      },
                      {
                        id: "quantity",
                        label: c("orders.quantity"),
                        sortable: !0,
                        render: (d) => /* @__PURE__ */ v.jsx("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ v.jsx("div", { className: "font-medium", children: d.quantity }) })
                      },
                      {
                        id: "status",
                        label: c("orders.status"),
                        sortable: !0,
                        render: (d) => /* @__PURE__ */ v.jsx(
                          an,
                          {
                            variant: "solid",
                            color: Pw(
                              Rc(d.payment)
                            ),
                            size: "sm",
                            children: c(
                              `orders.statuses.${d.status === "executed" ? "executed" : Rc(d.payment)}`
                            )
                          }
                        )
                      },
                      {
                        id: "signature",
                        label: c("orders.signature"),
                        sortable: !0,
                        render: (d) => /* @__PURE__ */ v.jsx(
                          an,
                          {
                            variant: "solid",
                            color: d.signature && "valid" in d.signature ? "success" : "danger",
                            size: "sm",
                            children: c(
                              `orders.${d.signature && "valid" in d.signature ? "yes" : "no"}`
                            )
                          }
                        )
                      },
                      {
                        id: "payment",
                        label: c("orders.payment"),
                        sortable: !0,
                        render: (d) => /* @__PURE__ */ v.jsx(
                          an,
                          {
                            variant: "solid",
                            color: d.payment && ("valid" in d.payment || "funded" in d.payment) ? "success" : "danger",
                            size: "sm",
                            children: c(
                              `orders.${d.payment && ("valid" in d.payment || "funded" in d.payment) ? "yes" : "no"}`
                            )
                          }
                        )
                      },
                      {
                        id: "tsp",
                        label: c("orders.createdAt"),
                        sortable: !0,
                        render: (d) => new Date(d.tsp).toLocaleDateString("fr-FR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric"
                        })
                      },
                      {
                        id: "documents",
                        label: c("orders.documents"),
                        sortable: !1,
                        render: (d) => !d.signature || !("valid" in d.signature) || !d.signature.valid.length ? null : /* @__PURE__ */ v.jsx("div", { className: "flex flex-wrap gap-2 max-w-[300px]", children: d.signature.valid.map((f, h) => /* @__PURE__ */ v.jsx(
                          qe,
                          {
                            variant: "outline",
                            color: "gray",
                            size: "xs",
                            onClick: (p) => {
                              p.stopPropagation(), window.open(f, "_blank");
                            },
                            children: /* @__PURE__ */ v.jsx("div", { className: "flex flex-col items-center justify-center space-y-1", children: /* @__PURE__ */ v.jsx(dt, { name: "file", size: "sm" }) })
                          },
                          f
                        )) })
                      }
                    ],
                    tableConfig: {
                      defaultSortColumn: "id",
                      defaultSortDirection: _n.DESC,
                      searchFields: ["id", "status"]
                    },
                    formSections: [],
                    validationSchema: {
                      create: B.object({}),
                      update: B.object({})
                    },
                    formLayout: "single-page"
                  },
                  crudMethods: {
                    getAll: async (d) => {
                      const f = await u.campaignsApi.campaignOrdersPage({
                        id: Number(l.id),
                        offset: d.offset,
                        limit: d.limit
                      });
                      return {
                        data: f.results,
                        pagination: {
                          total: f.meta.total,
                          offset: f.meta.offset,
                          limit: f.meta.limit,
                          currentPage: f.meta.current_page,
                          totalPages: f.meta.total_pages
                        },
                        links: f.links
                      };
                    }
                  },
                  responseExtractor: {
                    extractItems: (d) => d,
                    extractTotal: (d) => d.length
                  }
                };
              },
              parentItemAccessor: (l) => ({
                id: l.id
              })
            }
          }
        ]
      },
      draftConfig: {
        enabled: !0,
        isDraftField: "status",
        isDraftValue: eo.Created,
        publishedValue: eo.Available,
        isDraftPredicate: (l) => l.status === eo.Created,
        transformToDraft: (l) => ({
          ...l,
          status: eo.Created
        }),
        transformToPublished: (l) => {
          const c = l.status, u = !c || c === eo.Created || c === eo.Available;
          return {
            ...l,
            status: u ? eo.Available : c || eo.Available
          };
        },
        buttonConfig: {
          label: e("campaigns.saveDraft"),
          icon: "save",
          color: "secondary",
          showOnCreate: !0,
          showOnUpdate: !0
        }
      },
      formConfig: {
        showCancel: !0
      }
    },
    crudMethods: a,
    responseExtractor: i
  };
};
Th("campaigns", qT);
const DJ = () => {
  const e = sn(), t = (a) => {
    var i;
    switch ((i = a.split(".").pop()) == null ? void 0 : i.toLowerCase()) {
      case "pdf":
        return "application/pdf";
      case "png":
        return "image/png";
      case "jpg":
      case "jpeg":
        return "image/jpeg";
      default:
        return "application/octet-stream";
    }
  }, r = async (a, s) => {
    const i = `/${a}/${s.name}`, o = t(i);
    try {
      return await e.projectsApi.upload(
        {
          filename: i,
          body: s
        },
        {
          headers: {
            "Content-Type": o
          }
        }
      ), {
        filename: i,
        url: `${i}`
      };
    } catch (l) {
      throw console.error("Error uploading file:", l), l;
    }
  };
  return { uploadFile: r, uploadMultipleFiles: async (a, s) => {
    const i = s.map((o) => r(a, o));
    return Promise.all(i);
  } };
}, NJ = Vl({
  openIndexes: [],
  toggleItem: () => {
  },
  allowMultiple: !1
}), MJ = ({
  children: e,
  allowMultiple: t = !1,
  defaultOpenIndexes: r = [],
  className: n,
  variant: a = "default",
  theme: s
}) => {
  var u;
  const [i, o] = Me(r), l = (d) => {
    o(
      t ? (f) => f.includes(d) ? f.filter((h) => h !== d) : [...f, d] : (f) => f.includes(d) ? [] : [d]
    );
  }, c = {
    ...s.baseStyle,
    ...((u = s.variants) == null ? void 0 : u[a]) || {}
  };
  return /* @__PURE__ */ v.jsx(
    NJ.Provider,
    {
      value: { openIndexes: i, toggleItem: l, allowMultiple: t },
      children: /* @__PURE__ */ v.jsx("div", { className: lt(c.base, n), children: M.Children.map(e, (d, f) => M.isValidElement(d) ? M.cloneElement(d, {
        isOpen: i.includes(f),
        onChange: (h) => {
          h !== i.includes(f) && l(f);
        }
      }) : null) })
    }
  );
}, LJ = ({
  title: e,
  children: t,
  isOpen: r = !1,
  onChange: n,
  disabled: a = !1,
  className: s,
  theme: i
}) => {
  const o = () => {
    !a && n && n(!r);
  }, l = i.baseStyle, c = lt(
    l.item,
    r && l.states.open.item,
    a && l.states.disabled.item,
    s
  ), u = lt(
    l.trigger,
    r && l.states.open.trigger,
    a && l.states.disabled.trigger
  ), d = lt(l.icon, r && l.states.open.icon);
  return /* @__PURE__ */ v.jsxs("div", { className: c, children: [
    /* @__PURE__ */ v.jsx("h3", { className: l.header, children: /* @__PURE__ */ v.jsxs(
      "button",
      {
        type: "button",
        disabled: a,
        "aria-expanded": r,
        className: u,
        onClick: o,
        children: [
          e,
          /* @__PURE__ */ v.jsx(dt, { name: "chevron-down", className: d })
        ]
      }
    ) }),
    r && /* @__PURE__ */ v.jsx("div", { className: l.content, children: /* @__PURE__ */ v.jsx("div", { className: l.contentInner, children: t }) })
  ] });
}, jJ = $r(
  "Accordion",
  MJ
), FJ = $r(
  "Accordion",
  LJ
), MA = Object.assign(jJ, {
  Item: FJ
}), BJ = ({
  children: e,
  className: t,
  color: r = "bg-surface",
  border: n,
  header: a,
  footer: s,
  headerClassName: i,
  footerClassName: o,
  bodyClassName: l,
  rounded: c = "lg",
  shadow: u = "none",
  hover: d = !1,
  onClick: f,
  size: h = "md",
  variant: p = "outlined",
  scrollable: m = !1,
  fitContent: g = !1,
  theme: y,
  ...x
}) => {
  var z, G, Y, te, ae, ne, ue, q, U, Q, L, j, K, J;
  const w = y.baseStyle, _ = ((z = y.variants) == null ? void 0 : z[p]) || {}, S = ((G = y.sizes) == null ? void 0 : G[h]) || {}, C = n || (r && !r.startsWith("#") && !r.startsWith("bg-") ? (Y = w.colors[r]) == null ? void 0 : Y.border : w.borders.default), E = lt(
    w.base,
    w.container,
    w.rounded[c],
    u !== "none" && w.shadows[u],
    d && w.states.hover,
    f && w.states.clickable,
    !g && "w-full",
    _.base,
    // Handle both legacy classes and hex colors
    r != null && r.startsWith("#") ? "" : r != null && r.startsWith("bg-") ? r : (te = w.colors[r]) == null ? void 0 : te.base,
    // Apply border style
    p !== "elevated" && p !== "filled" && p !== "outlined" ? null : C,
    t
  ), O = r != null && r.startsWith("#") ? { backgroundColor: r } : void 0, k = a && (n || (r && !r.startsWith("#") && !r.startsWith("bg-") ? r === "border-border" ? "border-border" : ((ne = (ae = w.colors[r]) == null ? void 0 : ae.border) == null ? void 0 : ne.replace(
    "border-",
    ""
  )) || "border-border" : "border-border")), A = lt(
    w.header,
    r != null && r.startsWith("#") ? "text-gray-900 dark:text-gray-100" : ((ue = w.colors[r]) == null ? void 0 : ue.header) || w.colors.gray.header,
    w.spacing.header,
    (q = S.spacing) == null ? void 0 : q.header,
    a && "border-b",
    k,
    i
  ), P = s && (n || (r && !r.startsWith("#") && !r.startsWith("bg-") ? r === "border-border" ? "border-border" : ((Q = (U = w.colors[r]) == null ? void 0 : U.border) == null ? void 0 : Q.replace(
    "border-",
    ""
  )) || "border-border" : "border-border")), D = lt(
    w.body,
    r != null && r.startsWith("#") ? "text-black dark:text-white" : ((L = w.colors[r]) == null ? void 0 : L.body) || w.colors.gray.body,
    w.spacing.body,
    (j = S.spacing) == null ? void 0 : j.body,
    m && w.states.scrollable,
    l
  ), N = lt(
    w.footer,
    r != null && r.startsWith("#") ? "text-gray-900 dark:text-gray-100" : ((K = w.colors[r]) == null ? void 0 : K.footer) || w.colors.gray.footer,
    w.spacing.footer,
    (J = S.spacing) == null ? void 0 : J.footer,
    s && "border-t",
    P,
    o
  );
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: E,
      onClick: (re) => f == null ? void 0 : f(re),
      style: O,
      ...x,
      children: [
        a && /* @__PURE__ */ v.jsx("div", { className: A, children: a }),
        /* @__PURE__ */ v.jsx("div", { className: D, children: e }),
        s && /* @__PURE__ */ v.jsx("div", { className: N, children: s })
      ]
    }
  );
}, hr = $r("Card", BJ);
var Eg = (e) => e.type === "checkbox", Su = (e) => e instanceof Date, is = (e) => e == null;
const wF = (e) => typeof e == "object";
var zn = (e) => !is(e) && !Array.isArray(e) && wF(e) && !Su(e), xF = (e) => zn(e) && e.target ? Eg(e.target) ? e.target.checked : e.target.value : e, UJ = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, _F = (e, t) => e.has(UJ(t)), VJ = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return zn(t) && t.hasOwnProperty("isPrototypeOf");
}, GT = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Sa(e) {
  let t;
  const r = Array.isArray(e), n = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(GT && (e instanceof Blob || n)) && (r || zn(e)))
    if (t = r ? [] : {}, !r && !VJ(e))
      t = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (t[a] = Sa(e[a]));
  else
    return e;
  return t;
}
var Rw = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Vn = (e) => e === void 0, St = (e, t, r) => {
  if (!t || !zn(e))
    return r;
  const n = Rw(t.split(/[,[\].]+?/)).reduce((a, s) => is(a) ? a : a[s], e);
  return Vn(n) || n === e ? Vn(e[t]) ? r : e[t] : n;
}, Ls = (e) => typeof e == "boolean", YT = (e) => /^\w*$/.test(e), SF = (e) => Rw(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Ur = (e, t, r) => {
  let n = -1;
  const a = YT(t) ? [t] : SF(t), s = a.length, i = s - 1;
  for (; ++n < s; ) {
    const o = a[n];
    let l = r;
    if (n !== i) {
      const c = e[o];
      l = zn(c) || Array.isArray(c) ? c : isNaN(+a[n + 1]) ? {} : [];
    }
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    e[o] = l, e = e[o];
  }
};
const Gy = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Ai = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Zo = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, EF = M.createContext(null), Ch = () => M.useContext(EF), TF = (e) => {
  const { children: t, ...r } = e;
  return M.createElement(EF.Provider, { value: r }, t);
};
var CF = (e, t, r, n = !0) => {
  const a = {
    defaultValues: t._defaultValues
  };
  for (const s in e)
    Object.defineProperty(a, s, {
      get: () => {
        const i = s;
        return t._proxyFormState[i] !== Ai.all && (t._proxyFormState[i] = !n || Ai.all), r && (r[i] = !0), e[i];
      }
    });
  return a;
};
function $J(e) {
  const t = Ch(), { control: r = t.control, disabled: n, name: a, exact: s } = e || {}, [i, o] = M.useState(r._formState), l = M.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), c = M.useRef(a);
  return c.current = a, M.useEffect(() => r._subscribe({
    name: c.current,
    formState: l.current,
    exact: s,
    callback: (u) => {
      !n && o({
        ...r._formState,
        ...u
      });
    }
  }), [r, n, s]), M.useEffect(() => {
    l.current.isValid && r._setValid(!0);
  }, [r]), M.useMemo(() => CF(i, r, l.current, !1), [i, r]);
}
var So = (e) => typeof e == "string", kF = (e, t, r, n, a) => So(e) ? (n && t.watch.add(e), St(r, e, a)) : Array.isArray(e) ? e.map((s) => (n && t.watch.add(s), St(r, s))) : (n && (t.watchAll = !0), r);
function HJ(e) {
  const t = Ch(), { control: r = t.control, name: n, defaultValue: a, disabled: s, exact: i } = e || {}, o = M.useRef(n), l = M.useRef(a);
  o.current = n, M.useEffect(() => r._subscribe({
    name: o.current,
    formState: {
      values: !0
    },
    exact: i,
    callback: (d) => !s && u(kF(o.current, r._names, d.values || r._formValues, !1, l.current))
  }), [r, s, i]);
  const [c, u] = M.useState(r._getWatch(n, a));
  return M.useEffect(() => r._removeUnmounted()), c;
}
function WJ(e) {
  const t = Ch(), { name: r, disabled: n, control: a = t.control, shouldUnregister: s } = e, i = _F(a._names.array, r), o = HJ({
    control: a,
    name: r,
    defaultValue: St(a._formValues, r, St(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), l = $J({
    control: a,
    name: r,
    exact: !0
  }), c = M.useRef(e), u = M.useRef(a.register(r, {
    ...e.rules,
    value: o,
    ...Ls(e.disabled) ? { disabled: e.disabled } : {}
  })), d = M.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!St(l.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!St(l.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!St(l.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!St(l.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => St(l.errors, r)
    }
  }), [l, r]), f = M.useCallback((g) => u.current.onChange({
    target: {
      value: xF(g),
      name: r
    },
    type: Gy.CHANGE
  }), [r]), h = M.useCallback(() => u.current.onBlur({
    target: {
      value: St(a._formValues, r),
      name: r
    },
    type: Gy.BLUR
  }), [r, a._formValues]), p = M.useCallback((g) => {
    const y = St(a._fields, r);
    y && g && (y._f.ref = {
      focus: () => g.focus(),
      select: () => g.select(),
      setCustomValidity: (x) => g.setCustomValidity(x),
      reportValidity: () => g.reportValidity()
    });
  }, [a._fields, r]), m = M.useMemo(() => ({
    name: r,
    value: o,
    ...Ls(n) || l.disabled ? { disabled: l.disabled || n } : {},
    onChange: f,
    onBlur: h,
    ref: p
  }), [r, n, l.disabled, f, h, p, o]);
  return M.useEffect(() => {
    const g = a._options.shouldUnregister || s;
    a.register(r, {
      ...c.current.rules,
      ...Ls(c.current.disabled) ? { disabled: c.current.disabled } : {}
    });
    const y = (x, w) => {
      const _ = St(a._fields, x);
      _ && _._f && (_._f.mount = w);
    };
    if (y(r, !0), g) {
      const x = Sa(St(a._options.defaultValues, r));
      Ur(a._defaultValues, r, x), Vn(St(a._formValues, r)) && Ur(a._formValues, r, x);
    }
    return !i && a.register(r), () => {
      (i ? g && !a._state.action : g) ? a.unregister(r) : y(r, !1);
    };
  }, [r, a, i, s]), M.useEffect(() => {
    a._setDisabledField({
      disabled: n,
      name: r
    });
  }, [n, r, a]), M.useMemo(() => ({
    field: m,
    formState: l,
    fieldState: d
  }), [m, l, d]);
}
const zJ = (e) => e.render(WJ(e));
var OF = (e, t, r, n, a) => t ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [n]: a || !0
  }
} : {}, cm = (e) => Array.isArray(e) ? e : [e], LA = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const s of e)
        s.next && s.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((s) => s !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, gE = (e) => is(e) || !wF(e);
function fc(e, t) {
  if (gE(e) || gE(t))
    return e === t;
  if (Su(e) && Su(t))
    return e.getTime() === t.getTime();
  const r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length)
    return !1;
  for (const a of r) {
    const s = e[a];
    if (!n.includes(a))
      return !1;
    if (a !== "ref") {
      const i = t[a];
      if (Su(s) && Su(i) || zn(s) && zn(i) || Array.isArray(s) && Array.isArray(i) ? !fc(s, i) : s !== i)
        return !1;
    }
  }
  return !0;
}
var as = (e) => zn(e) && !Object.keys(e).length, XT = (e) => e.type === "file", Pi = (e) => typeof e == "function", Yy = (e) => {
  if (!GT)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, AF = (e) => e.type === "select-multiple", QT = (e) => e.type === "radio", KJ = (e) => QT(e) || Eg(e), F1 = (e) => Yy(e) && e.isConnected;
function qJ(e, t) {
  const r = t.slice(0, -1).length;
  let n = 0;
  for (; n < r; )
    e = Vn(e) ? n++ : e[t[n++]];
  return e;
}
function GJ(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !Vn(e[t]))
      return !1;
  return !0;
}
function sa(e, t) {
  const r = Array.isArray(t) ? t : YT(t) ? [t] : SF(t), n = r.length === 1 ? e : qJ(e, r), a = r.length - 1, s = r[a];
  return n && delete n[s], a !== 0 && (zn(n) && as(n) || Array.isArray(n) && GJ(n)) && sa(e, r.slice(0, -1)), e;
}
var PF = (e) => {
  for (const t in e)
    if (Pi(e[t]))
      return !0;
  return !1;
};
function Xy(e, t = {}) {
  const r = Array.isArray(e);
  if (zn(e) || r)
    for (const n in e)
      Array.isArray(e[n]) || zn(e[n]) && !PF(e[n]) ? (t[n] = Array.isArray(e[n]) ? [] : {}, Xy(e[n], t[n])) : is(e[n]) || (t[n] = !0);
  return t;
}
function RF(e, t, r) {
  const n = Array.isArray(e);
  if (zn(e) || n)
    for (const a in e)
      Array.isArray(e[a]) || zn(e[a]) && !PF(e[a]) ? Vn(t) || gE(r[a]) ? r[a] = Array.isArray(e[a]) ? Xy(e[a], []) : { ...Xy(e[a]) } : RF(e[a], is(t) ? {} : t[a], r[a]) : r[a] = !fc(e[a], t[a]);
  return r;
}
var ip = (e, t) => RF(e, t, Xy(t));
const jA = {
  value: !1,
  isValid: !1
}, FA = { value: !0, isValid: !0 };
var IF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !Vn(e[0].attributes.value) ? Vn(e[0].value) || e[0].value === "" ? FA : { value: e[0].value, isValid: !0 } : FA
    ) : jA;
  }
  return jA;
}, DF = (e, { valueAsNumber: t, valueAsDate: r, setValueAs: n }) => Vn(e) ? e : t ? e === "" ? NaN : e && +e : r && So(e) ? new Date(e) : n ? n(e) : e;
const BA = {
  isValid: !1,
  value: null
};
var NF = (e) => Array.isArray(e) ? e.reduce((t, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : t, BA) : BA;
function UA(e) {
  const t = e.ref;
  return XT(t) ? t.files : QT(t) ? NF(e.refs).value : AF(t) ? [...t.selectedOptions].map(({ value: r }) => r) : Eg(t) ? IF(e.refs).value : DF(Vn(t.value) ? e.ref.value : t.value, e);
}
var YJ = (e, t, r, n) => {
  const a = {};
  for (const s of e) {
    const i = St(t, s);
    i && Ur(a, s, i._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: n
  };
}, Qy = (e) => e instanceof RegExp, op = (e) => Vn(e) ? e : Qy(e) ? e.source : zn(e) ? Qy(e.value) ? e.value.source : e.value : e, VA = (e) => ({
  isOnSubmit: !e || e === Ai.onSubmit,
  isOnBlur: e === Ai.onBlur,
  isOnChange: e === Ai.onChange,
  isOnAll: e === Ai.all,
  isOnTouch: e === Ai.onTouched
});
const $A = "AsyncFunction";
var XJ = (e) => !!e && !!e.validate && !!(Pi(e.validate) && e.validate.constructor.name === $A || zn(e.validate) && Object.values(e.validate).find((t) => t.constructor.name === $A)), QJ = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), HA = (e, t, r) => !r && (t.watchAll || t.watch.has(e) || [...t.watch].some((n) => e.startsWith(n) && /^\.\w+/.test(e.slice(n.length))));
const um = (e, t, r, n) => {
  for (const a of r || Object.keys(e)) {
    const s = St(e, a);
    if (s) {
      const { _f: i, ...o } = s;
      if (i) {
        if (i.refs && i.refs[0] && t(i.refs[0], a) && !n)
          return !0;
        if (i.ref && t(i.ref, i.name) && !n)
          return !0;
        if (um(o, t))
          break;
      } else if (zn(o) && um(o, t))
        break;
    }
  }
};
function WA(e, t, r) {
  const n = St(e, r);
  if (n || YT(r))
    return {
      error: n,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const s = a.join("."), i = St(t, s), o = St(e, s);
    if (i && !Array.isArray(i) && r !== s)
      return { name: r };
    if (o && o.type)
      return {
        name: s,
        error: o
      };
    a.pop();
  }
  return {
    name: r
  };
}
var JJ = (e, t, r, n) => {
  r(e);
  const { name: a, ...s } = e;
  return as(s) || Object.keys(s).length >= Object.keys(t).length || Object.keys(s).find((i) => t[i] === (!n || Ai.all));
}, ZJ = (e, t, r) => !e || !t || e === t || cm(e).some((n) => n && (r ? n === t : n.startsWith(t) || t.startsWith(n))), eZ = (e, t, r, n, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(t || e) : (r ? n.isOnBlur : a.isOnBlur) ? !e : (r ? n.isOnChange : a.isOnChange) ? e : !0, tZ = (e, t) => !Rw(St(e, t)).length && sa(e, t), rZ = (e, t, r) => {
  const n = cm(St(e, r));
  return Ur(n, "root", t[r]), Ur(e, r, n), e;
}, yy = (e) => So(e);
function zA(e, t, r = "validate") {
  if (yy(e) || Array.isArray(e) && e.every(yy) || Ls(e) && !e)
    return {
      type: r,
      message: yy(e) ? e : "",
      ref: t
    };
}
var Bd = (e) => zn(e) && !Qy(e) ? e : {
  value: e,
  message: ""
}, KA = async (e, t, r, n, a, s) => {
  const { ref: i, refs: o, required: l, maxLength: c, minLength: u, min: d, max: f, pattern: h, validate: p, name: m, valueAsNumber: g, mount: y } = e._f, x = St(r, m);
  if (!y || t.has(m))
    return {};
  const w = o ? o[0] : i, _ = (D) => {
    a && w.reportValidity && (w.setCustomValidity(Ls(D) ? "" : D || ""), w.reportValidity());
  }, S = {}, C = QT(i), E = Eg(i), O = C || E, k = (g || XT(i)) && Vn(i.value) && Vn(x) || Yy(i) && i.value === "" || x === "" || Array.isArray(x) && !x.length, A = OF.bind(null, m, n, S), P = (D, N, z, G = Zo.maxLength, Y = Zo.minLength) => {
    const te = D ? N : z;
    S[m] = {
      type: D ? G : Y,
      message: te,
      ref: i,
      ...A(D ? G : Y, te)
    };
  };
  if (s ? !Array.isArray(x) || !x.length : l && (!O && (k || is(x)) || Ls(x) && !x || E && !IF(o).isValid || C && !NF(o).isValid)) {
    const { value: D, message: N } = yy(l) ? { value: !!l, message: l } : Bd(l);
    if (D && (S[m] = {
      type: Zo.required,
      message: N,
      ref: w,
      ...A(Zo.required, N)
    }, !n))
      return _(N), S;
  }
  if (!k && (!is(d) || !is(f))) {
    let D, N;
    const z = Bd(f), G = Bd(d);
    if (!is(x) && !isNaN(x)) {
      const Y = i.valueAsNumber || x && +x;
      is(z.value) || (D = Y > z.value), is(G.value) || (N = Y < G.value);
    } else {
      const Y = i.valueAsDate || new Date(x), te = (ue) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + ue), ae = i.type == "time", ne = i.type == "week";
      So(z.value) && x && (D = ae ? te(x) > te(z.value) : ne ? x > z.value : Y > new Date(z.value)), So(G.value) && x && (N = ae ? te(x) < te(G.value) : ne ? x < G.value : Y < new Date(G.value));
    }
    if ((D || N) && (P(!!D, z.message, G.message, Zo.max, Zo.min), !n))
      return _(S[m].message), S;
  }
  if ((c || u) && !k && (So(x) || s && Array.isArray(x))) {
    const D = Bd(c), N = Bd(u), z = !is(D.value) && x.length > +D.value, G = !is(N.value) && x.length < +N.value;
    if ((z || G) && (P(z, D.message, N.message), !n))
      return _(S[m].message), S;
  }
  if (h && !k && So(x)) {
    const { value: D, message: N } = Bd(h);
    if (Qy(D) && !x.match(D) && (S[m] = {
      type: Zo.pattern,
      message: N,
      ref: i,
      ...A(Zo.pattern, N)
    }, !n))
      return _(N), S;
  }
  if (p) {
    if (Pi(p)) {
      const D = await p(x, r), N = zA(D, w);
      if (N && (S[m] = {
        ...N,
        ...A(Zo.validate, N.message)
      }, !n))
        return _(N.message), S;
    } else if (zn(p)) {
      let D = {};
      for (const N in p) {
        if (!as(D) && !n)
          break;
        const z = zA(await p[N](x, r), w, N);
        z && (D = {
          ...z,
          ...A(N, z.message)
        }, _(z.message), n && (S[m] = D));
      }
      if (!as(D) && (S[m] = {
        ref: w,
        ...D
      }, !n))
        return S;
    }
  }
  return _(!0), S;
};
const nZ = {
  mode: Ai.onSubmit,
  reValidateMode: Ai.onChange,
  shouldFocusError: !0
};
function aZ(e = {}) {
  let t = {
    ...nZ,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Pi(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  };
  const n = {};
  let a = zn(t.defaultValues) || zn(t.values) ? Sa(t.values || t.defaultValues) || {} : {}, s = t.shouldUnregister ? {} : Sa(a), i = {
    action: !1,
    mount: !1,
    watch: !1
  }, o = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, c = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let d = {
    ...u
  };
  const f = {
    array: LA(),
    state: LA()
  }, h = VA(t.mode), p = VA(t.reValidateMode), m = t.criteriaMode === Ai.all, g = (oe) => (ve) => {
    clearTimeout(c), c = setTimeout(oe, ve);
  }, y = async (oe) => {
    if (!t.disabled && (u.isValid || d.isValid || oe)) {
      const ve = t.resolver ? as((await k()).errors) : await P(n, !0);
      ve !== r.isValid && f.state.next({
        isValid: ve
      });
    }
  }, x = (oe, ve) => {
    !t.disabled && (u.isValidating || u.validatingFields || d.isValidating || d.validatingFields) && ((oe || Array.from(o.mount)).forEach((ye) => {
      ye && (ve ? Ur(r.validatingFields, ye, ve) : sa(r.validatingFields, ye));
    }), f.state.next({
      validatingFields: r.validatingFields,
      isValidating: !as(r.validatingFields)
    }));
  }, w = (oe, ve = [], ye, Te, _e = !0, Ae = !0) => {
    if (Te && ye && !t.disabled) {
      if (i.action = !0, Ae && Array.isArray(St(n, oe))) {
        const Ve = ye(St(n, oe), Te.argA, Te.argB);
        _e && Ur(n, oe, Ve);
      }
      if (Ae && Array.isArray(St(r.errors, oe))) {
        const Ve = ye(St(r.errors, oe), Te.argA, Te.argB);
        _e && Ur(r.errors, oe, Ve), tZ(r.errors, oe);
      }
      if ((u.touchedFields || d.touchedFields) && Ae && Array.isArray(St(r.touchedFields, oe))) {
        const Ve = ye(St(r.touchedFields, oe), Te.argA, Te.argB);
        _e && Ur(r.touchedFields, oe, Ve);
      }
      (u.dirtyFields || d.dirtyFields) && (r.dirtyFields = ip(a, s)), f.state.next({
        name: oe,
        isDirty: N(oe, ve),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Ur(s, oe, ve);
  }, _ = (oe, ve) => {
    Ur(r.errors, oe, ve), f.state.next({
      errors: r.errors
    });
  }, S = (oe) => {
    r.errors = oe, f.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, C = (oe, ve, ye, Te) => {
    const _e = St(n, oe);
    if (_e) {
      const Ae = St(s, oe, Vn(ye) ? St(a, oe) : ye);
      Vn(Ae) || Te && Te.defaultChecked || ve ? Ur(s, oe, ve ? Ae : UA(_e._f)) : Y(oe, Ae), i.mount && y();
    }
  }, E = (oe, ve, ye, Te, _e) => {
    let Ae = !1, Ve = !1;
    const mt = {
      name: oe
    };
    if (!t.disabled) {
      if (!ye || Te) {
        (u.isDirty || d.isDirty) && (Ve = r.isDirty, r.isDirty = mt.isDirty = N(), Ae = Ve !== mt.isDirty);
        const Dt = fc(St(a, oe), ve);
        Ve = !!St(r.dirtyFields, oe), Dt ? sa(r.dirtyFields, oe) : Ur(r.dirtyFields, oe, !0), mt.dirtyFields = r.dirtyFields, Ae = Ae || (u.dirtyFields || d.dirtyFields) && Ve !== !Dt;
      }
      if (ye) {
        const Dt = St(r.touchedFields, oe);
        Dt || (Ur(r.touchedFields, oe, ye), mt.touchedFields = r.touchedFields, Ae = Ae || (u.touchedFields || d.touchedFields) && Dt !== ye);
      }
      Ae && _e && f.state.next(mt);
    }
    return Ae ? mt : {};
  }, O = (oe, ve, ye, Te) => {
    const _e = St(r.errors, oe), Ae = (u.isValid || d.isValid) && Ls(ve) && r.isValid !== ve;
    if (t.delayError && ye ? (l = g(() => _(oe, ye)), l(t.delayError)) : (clearTimeout(c), l = null, ye ? Ur(r.errors, oe, ye) : sa(r.errors, oe)), (ye ? !fc(_e, ye) : _e) || !as(Te) || Ae) {
      const Ve = {
        ...Te,
        ...Ae && Ls(ve) ? { isValid: ve } : {},
        errors: r.errors,
        name: oe
      };
      r = {
        ...r,
        ...Ve
      }, f.state.next(Ve);
    }
  }, k = async (oe) => {
    x(oe, !0);
    const ve = await t.resolver(s, t.context, YJ(oe || o.mount, n, t.criteriaMode, t.shouldUseNativeValidation));
    return x(oe), ve;
  }, A = async (oe) => {
    const { errors: ve } = await k(oe);
    if (oe)
      for (const ye of oe) {
        const Te = St(ve, ye);
        Te ? Ur(r.errors, ye, Te) : sa(r.errors, ye);
      }
    else
      r.errors = ve;
    return ve;
  }, P = async (oe, ve, ye = {
    valid: !0
  }) => {
    for (const Te in oe) {
      const _e = oe[Te];
      if (_e) {
        const { _f: Ae, ...Ve } = _e;
        if (Ae) {
          const mt = o.array.has(Ae.name), Dt = _e._f && XJ(_e._f);
          Dt && u.validatingFields && x([Te], !0);
          const Gt = await KA(_e, o.disabled, s, m, t.shouldUseNativeValidation && !ve, mt);
          if (Dt && u.validatingFields && x([Te]), Gt[Ae.name] && (ye.valid = !1, ve))
            break;
          !ve && (St(Gt, Ae.name) ? mt ? rZ(r.errors, Gt, Ae.name) : Ur(r.errors, Ae.name, Gt[Ae.name]) : sa(r.errors, Ae.name));
        }
        !as(Ve) && await P(Ve, ve, ye);
      }
    }
    return ye.valid;
  }, D = () => {
    for (const oe of o.unMount) {
      const ve = St(n, oe);
      ve && (ve._f.refs ? ve._f.refs.every((ye) => !F1(ye)) : !F1(ve._f.ref)) && le(oe);
    }
    o.unMount = /* @__PURE__ */ new Set();
  }, N = (oe, ve) => !t.disabled && (oe && ve && Ur(s, oe, ve), !fc(U(), a)), z = (oe, ve, ye) => kF(oe, o, {
    ...i.mount ? s : Vn(ve) ? a : So(oe) ? { [oe]: ve } : ve
  }, ye, ve), G = (oe) => Rw(St(i.mount ? s : a, oe, t.shouldUnregister ? St(a, oe, []) : [])), Y = (oe, ve, ye = {}) => {
    const Te = St(n, oe);
    let _e = ve;
    if (Te) {
      const Ae = Te._f;
      Ae && (!Ae.disabled && Ur(s, oe, DF(ve, Ae)), _e = Yy(Ae.ref) && is(ve) ? "" : ve, AF(Ae.ref) ? [...Ae.ref.options].forEach((Ve) => Ve.selected = _e.includes(Ve.value)) : Ae.refs ? Eg(Ae.ref) ? Ae.refs.length > 1 ? Ae.refs.forEach((Ve) => (!Ve.defaultChecked || !Ve.disabled) && (Ve.checked = Array.isArray(_e) ? !!_e.find((mt) => mt === Ve.value) : _e === Ve.value)) : Ae.refs[0] && (Ae.refs[0].checked = !!_e) : Ae.refs.forEach((Ve) => Ve.checked = Ve.value === _e) : XT(Ae.ref) ? Ae.ref.value = "" : (Ae.ref.value = _e, Ae.ref.type || f.state.next({
        name: oe,
        values: Sa(s)
      })));
    }
    (ye.shouldDirty || ye.shouldTouch) && E(oe, _e, ye.shouldTouch, ye.shouldDirty, !0), ye.shouldValidate && q(oe);
  }, te = (oe, ve, ye) => {
    for (const Te in ve) {
      const _e = ve[Te], Ae = `${oe}.${Te}`, Ve = St(n, Ae);
      (o.array.has(oe) || zn(_e) || Ve && !Ve._f) && !Su(_e) ? te(Ae, _e, ye) : Y(Ae, _e, ye);
    }
  }, ae = (oe, ve, ye = {}) => {
    const Te = St(n, oe), _e = o.array.has(oe), Ae = Sa(ve);
    Ur(s, oe, Ae), _e ? (f.array.next({
      name: oe,
      values: Sa(s)
    }), (u.isDirty || u.dirtyFields || d.isDirty || d.dirtyFields) && ye.shouldDirty && f.state.next({
      name: oe,
      dirtyFields: ip(a, s),
      isDirty: N(oe, Ae)
    })) : Te && !Te._f && !is(Ae) ? te(oe, Ae, ye) : Y(oe, Ae, ye), HA(oe, o) && f.state.next({ ...r }), f.state.next({
      name: i.mount ? oe : void 0,
      values: Sa(s)
    });
  }, ne = async (oe) => {
    i.mount = !0;
    const ve = oe.target;
    let ye = ve.name, Te = !0;
    const _e = St(n, ye), Ae = (Ve) => {
      Te = Number.isNaN(Ve) || Su(Ve) && isNaN(Ve.getTime()) || fc(Ve, St(s, ye, Ve));
    };
    if (_e) {
      let Ve, mt;
      const Dt = ve.type ? UA(_e._f) : xF(oe), Gt = oe.type === Gy.BLUR || oe.type === Gy.FOCUS_OUT, $t = !QJ(_e._f) && !t.resolver && !St(r.errors, ye) && !_e._f.deps || eZ(Gt, St(r.touchedFields, ye), r.isSubmitted, p, h), Rt = HA(ye, o, Gt);
      Ur(s, ye, Dt), Gt ? (_e._f.onBlur && _e._f.onBlur(oe), l && l(0)) : _e._f.onChange && _e._f.onChange(oe);
      const Pr = E(ye, Dt, Gt), fr = !as(Pr) || Rt;
      if (!Gt && f.state.next({
        name: ye,
        type: oe.type,
        values: Sa(s)
      }), $t)
        return (u.isValid || d.isValid) && (t.mode === "onBlur" ? Gt && y() : Gt || y()), fr && f.state.next({ name: ye, ...Rt ? {} : Pr });
      if (!Gt && Rt && f.state.next({ ...r }), t.resolver) {
        const { errors: ca } = await k([ye]);
        if (Ae(Dt), Te) {
          const en = WA(r.errors, n, ye), Na = WA(ca, n, en.name || ye);
          Ve = Na.error, ye = Na.name, mt = as(ca);
        }
      } else
        x([ye], !0), Ve = (await KA(_e, o.disabled, s, m, t.shouldUseNativeValidation))[ye], x([ye]), Ae(Dt), Te && (Ve ? mt = !1 : (u.isValid || d.isValid) && (mt = await P(n, !0)));
      Te && (_e._f.deps && q(_e._f.deps), O(ye, mt, Ve, Pr));
    }
  }, ue = (oe, ve) => {
    if (St(r.errors, ve) && oe.focus)
      return oe.focus(), 1;
  }, q = async (oe, ve = {}) => {
    let ye, Te;
    const _e = cm(oe);
    if (t.resolver) {
      const Ae = await A(Vn(oe) ? oe : _e);
      ye = as(Ae), Te = oe ? !_e.some((Ve) => St(Ae, Ve)) : ye;
    } else oe ? (Te = (await Promise.all(_e.map(async (Ae) => {
      const Ve = St(n, Ae);
      return await P(Ve && Ve._f ? { [Ae]: Ve } : Ve);
    }))).every(Boolean), !(!Te && !r.isValid) && y()) : Te = ye = await P(n);
    return f.state.next({
      ...!So(oe) || (u.isValid || d.isValid) && ye !== r.isValid ? {} : { name: oe },
      ...t.resolver || !oe ? { isValid: ye } : {},
      errors: r.errors
    }), ve.shouldFocus && !Te && um(n, ue, oe ? _e : o.mount), Te;
  }, U = (oe) => {
    const ve = {
      ...i.mount ? s : a
    };
    return Vn(oe) ? ve : So(oe) ? St(ve, oe) : oe.map((ye) => St(ve, ye));
  }, Q = (oe, ve) => ({
    invalid: !!St((ve || r).errors, oe),
    isDirty: !!St((ve || r).dirtyFields, oe),
    error: St((ve || r).errors, oe),
    isValidating: !!St(r.validatingFields, oe),
    isTouched: !!St((ve || r).touchedFields, oe)
  }), L = (oe) => {
    oe && cm(oe).forEach((ve) => sa(r.errors, ve)), f.state.next({
      errors: oe ? r.errors : {}
    });
  }, j = (oe, ve, ye) => {
    const Te = (St(n, oe, { _f: {} })._f || {}).ref, _e = St(r.errors, oe) || {}, { ref: Ae, message: Ve, type: mt, ...Dt } = _e;
    Ur(r.errors, oe, {
      ...Dt,
      ...ve,
      ref: Te
    }), f.state.next({
      name: oe,
      errors: r.errors,
      isValid: !1
    }), ye && ye.shouldFocus && Te && Te.focus && Te.focus();
  }, K = (oe, ve) => Pi(oe) ? f.state.subscribe({
    next: (ye) => oe(z(void 0, ve), ye)
  }) : z(oe, ve, !0), J = (oe) => f.state.subscribe({
    next: (ve) => {
      ZJ(oe.name, ve.name, oe.exact) && JJ(ve, oe.formState || u, ht, oe.reRenderRoot) && oe.callback({
        values: { ...s },
        ...r,
        ...ve
      });
    }
  }).unsubscribe, re = (oe) => (i.mount = !0, d = {
    ...d,
    ...oe.formState
  }, J({
    ...oe,
    formState: d
  })), le = (oe, ve = {}) => {
    for (const ye of oe ? cm(oe) : o.mount)
      o.mount.delete(ye), o.array.delete(ye), ve.keepValue || (sa(n, ye), sa(s, ye)), !ve.keepError && sa(r.errors, ye), !ve.keepDirty && sa(r.dirtyFields, ye), !ve.keepTouched && sa(r.touchedFields, ye), !ve.keepIsValidating && sa(r.validatingFields, ye), !t.shouldUnregister && !ve.keepDefaultValue && sa(a, ye);
    f.state.next({
      values: Sa(s)
    }), f.state.next({
      ...r,
      ...ve.keepDirty ? { isDirty: N() } : {}
    }), !ve.keepIsValid && y();
  }, pe = ({ disabled: oe, name: ve }) => {
    (Ls(oe) && i.mount || oe || o.disabled.has(ve)) && (oe ? o.disabled.add(ve) : o.disabled.delete(ve));
  }, me = (oe, ve = {}) => {
    let ye = St(n, oe);
    const Te = Ls(ve.disabled) || Ls(t.disabled);
    return Ur(n, oe, {
      ...ye || {},
      _f: {
        ...ye && ye._f ? ye._f : { ref: { name: oe } },
        name: oe,
        mount: !0,
        ...ve
      }
    }), o.mount.add(oe), ye ? pe({
      disabled: Ls(ve.disabled) ? ve.disabled : t.disabled,
      name: oe
    }) : C(oe, !0, ve.value), {
      ...Te ? { disabled: ve.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!ve.required,
        min: op(ve.min),
        max: op(ve.max),
        minLength: op(ve.minLength),
        maxLength: op(ve.maxLength),
        pattern: op(ve.pattern)
      } : {},
      name: oe,
      onChange: ne,
      onBlur: ne,
      ref: (_e) => {
        if (_e) {
          me(oe, ve), ye = St(n, oe);
          const Ae = Vn(_e.value) && _e.querySelectorAll && _e.querySelectorAll("input,select,textarea")[0] || _e, Ve = KJ(Ae), mt = ye._f.refs || [];
          if (Ve ? mt.find((Dt) => Dt === Ae) : Ae === ye._f.ref)
            return;
          Ur(n, oe, {
            _f: {
              ...ye._f,
              ...Ve ? {
                refs: [
                  ...mt.filter(F1),
                  Ae,
                  ...Array.isArray(St(a, oe)) ? [{}] : []
                ],
                ref: { type: Ae.type, name: oe }
              } : { ref: Ae }
            }
          }), C(oe, !1, void 0, Ae);
        } else
          ye = St(n, oe, {}), ye._f && (ye._f.mount = !1), (t.shouldUnregister || ve.shouldUnregister) && !(_F(o.array, oe) && i.action) && o.unMount.add(oe);
      }
    };
  }, Oe = () => t.shouldFocusError && um(n, ue, o.mount), ee = (oe) => {
    Ls(oe) && (f.state.next({ disabled: oe }), um(n, (ve, ye) => {
      const Te = St(n, ye);
      Te && (ve.disabled = Te._f.disabled || oe, Array.isArray(Te._f.refs) && Te._f.refs.forEach((_e) => {
        _e.disabled = Te._f.disabled || oe;
      }));
    }, 0, !1));
  }, he = (oe, ve) => async (ye) => {
    let Te;
    ye && (ye.preventDefault && ye.preventDefault(), ye.persist && ye.persist());
    let _e = Sa(s);
    if (f.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: Ae, values: Ve } = await k();
      r.errors = Ae, _e = Ve;
    } else
      await P(n);
    if (o.disabled.size)
      for (const Ae of o.disabled)
        Ur(_e, Ae, void 0);
    if (sa(r.errors, "root"), as(r.errors)) {
      f.state.next({
        errors: {}
      });
      try {
        await oe(_e, ye);
      } catch (Ae) {
        Te = Ae;
      }
    } else
      ve && await ve({ ...r.errors }, ye), Oe(), setTimeout(Oe);
    if (f.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: as(r.errors) && !Te,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), Te)
      throw Te;
  }, Ee = (oe, ve = {}) => {
    St(n, oe) && (Vn(ve.defaultValue) ? ae(oe, Sa(St(a, oe))) : (ae(oe, ve.defaultValue), Ur(a, oe, Sa(ve.defaultValue))), ve.keepTouched || sa(r.touchedFields, oe), ve.keepDirty || (sa(r.dirtyFields, oe), r.isDirty = ve.defaultValue ? N(oe, Sa(St(a, oe))) : N()), ve.keepError || (sa(r.errors, oe), u.isValid && y()), f.state.next({ ...r }));
  }, we = (oe, ve = {}) => {
    const ye = oe ? Sa(oe) : a, Te = Sa(ye), _e = as(oe), Ae = _e ? a : Te;
    if (ve.keepDefaultValues || (a = ye), !ve.keepValues) {
      if (ve.keepDirtyValues) {
        const Ve = /* @__PURE__ */ new Set([
          ...o.mount,
          ...Object.keys(ip(a, s))
        ]);
        for (const mt of Array.from(Ve))
          St(r.dirtyFields, mt) ? Ur(Ae, mt, St(s, mt)) : ae(mt, St(Ae, mt));
      } else {
        if (GT && Vn(oe))
          for (const Ve of o.mount) {
            const mt = St(n, Ve);
            if (mt && mt._f) {
              const Dt = Array.isArray(mt._f.refs) ? mt._f.refs[0] : mt._f.ref;
              if (Yy(Dt)) {
                const Gt = Dt.closest("form");
                if (Gt) {
                  Gt.reset();
                  break;
                }
              }
            }
          }
        for (const Ve of o.mount)
          ae(Ve, St(Ae, Ve));
      }
      s = Sa(Ae), f.array.next({
        values: { ...Ae }
      }), f.state.next({
        values: { ...Ae }
      });
    }
    o = {
      mount: ve.keepDirtyValues ? o.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, i.mount = !u.isValid || !!ve.keepIsValid || !!ve.keepDirtyValues, i.watch = !!t.shouldUnregister, f.state.next({
      submitCount: ve.keepSubmitCount ? r.submitCount : 0,
      isDirty: _e ? !1 : ve.keepDirty ? r.isDirty : !!(ve.keepDefaultValues && !fc(oe, a)),
      isSubmitted: ve.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: _e ? {} : ve.keepDirtyValues ? ve.keepDefaultValues && s ? ip(a, s) : r.dirtyFields : ve.keepDefaultValues && oe ? ip(a, oe) : ve.keepDirty ? r.dirtyFields : {},
      touchedFields: ve.keepTouched ? r.touchedFields : {},
      errors: ve.keepErrors ? r.errors : {},
      isSubmitSuccessful: ve.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Pe = (oe, ve) => we(Pi(oe) ? oe(s) : oe, ve), rt = (oe, ve = {}) => {
    const ye = St(n, oe), Te = ye && ye._f;
    if (Te) {
      const _e = Te.refs ? Te.refs[0] : Te.ref;
      _e.focus && (_e.focus(), ve.shouldSelect && Pi(_e.select) && _e.select());
    }
  }, ht = (oe) => {
    r = {
      ...r,
      ...oe
    };
  }, Ge = {
    control: {
      register: me,
      unregister: le,
      getFieldState: Q,
      handleSubmit: he,
      setError: j,
      _subscribe: J,
      _runSchema: k,
      _getWatch: z,
      _getDirty: N,
      _setValid: y,
      _setFieldArray: w,
      _setDisabledField: pe,
      _setErrors: S,
      _getFieldArray: G,
      _reset: we,
      _resetDefaultValues: () => Pi(t.defaultValues) && t.defaultValues().then((oe) => {
        Pe(oe, t.resetOptions), f.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: D,
      _disableForm: ee,
      _subjects: f,
      _proxyFormState: u,
      get _fields() {
        return n;
      },
      get _formValues() {
        return s;
      },
      get _state() {
        return i;
      },
      set _state(oe) {
        i = oe;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return o;
      },
      set _names(oe) {
        o = oe;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return t;
      },
      set _options(oe) {
        t = {
          ...t,
          ...oe
        };
      }
    },
    subscribe: re,
    trigger: q,
    register: me,
    handleSubmit: he,
    watch: K,
    setValue: ae,
    getValues: U,
    reset: Pe,
    resetField: Ee,
    clearErrors: L,
    unregister: le,
    setError: j,
    setFocus: rt,
    getFieldState: Q
  };
  return {
    ...Ge,
    formControl: Ge
  };
}
function MF(e = {}) {
  const t = M.useRef(void 0), r = M.useRef(void 0), [n, a] = M.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Pi(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Pi(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...e.formControl ? e.formControl : aZ(e),
    formState: n
  }, e.formControl && e.defaultValues && !Pi(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const s = t.current.control;
  return s._options = e, M.useLayoutEffect(() => s._subscribe({
    formState: s._proxyFormState,
    callback: () => a({ ...s._formState }),
    reRenderRoot: !0
  }), [s]), M.useEffect(() => s._disableForm(e.disabled), [s, e.disabled]), M.useEffect(() => {
    if (s._proxyFormState.isDirty) {
      const i = s._getDirty();
      i !== n.isDirty && s._subjects.state.next({
        isDirty: i
      });
    }
  }, [s, n.isDirty]), M.useEffect(() => {
    e.values && !fc(e.values, r.current) ? (s._reset(e.values, s._options.resetOptions), r.current = e.values, a((i) => ({ ...i }))) : s._resetDefaultValues();
  }, [e.values, s]), M.useEffect(() => {
    e.errors && !as(e.errors) && s._setErrors(e.errors);
  }, [e.errors, s]), M.useEffect(() => {
    s._state.mount || (s._setValid(), s._state.mount = !0), s._state.watch && (s._state.watch = !1, s._subjects.state.next({ ...s._formState })), s._removeUnmounted();
  }), M.useEffect(() => {
    e.shouldUnregister && s._subjects.state.next({
      values: s._getWatch()
    });
  }, [e.shouldUnregister, s]), t.current.formState = CF(n, s), t.current;
}
const LF = M.forwardRef(
  ({
    id: e,
    name: t,
    type: r = "text",
    label: n,
    labelProps: a,
    placeholder: s,
    value: i,
    onChange: o,
    onBlur: l,
    onFocus: c,
    disabled: u = !1,
    readOnly: d = !1,
    required: f = !1,
    variant: h = "default",
    error: p,
    helperText: m,
    className: g,
    fullWidth: y = !1,
    icon: x,
    iconPosition: w = "left",
    action: _,
    theme: S,
    size: C = ((P) => (P = S.defaultProps) == null ? void 0 : P.size)() || "md",
    onDateChange: E,
    inputProps: O = {},
    ...k
  }, A) => {
    var ne, ue;
    const D = p ? "error" : h, N = S.baseStyle, z = ((ne = S.sizes) == null ? void 0 : ne[C]) || {}, G = ((ue = S.variants) == null ? void 0 : ue[D]) || {}, Y = lt(
      N.wrapper,
      y ? N.fullWidth : ""
    ), te = lt(
      N.base,
      h === "ghost" ? z[h] || z.ghost : z[h] || z.default,
      G.base,
      u ? N.disabled : "",
      h !== "ghost" && x && w === "left" ? "pl-10" : "",
      h !== "ghost" && x && w === "right" ? "pr-10" : "",
      h !== "ghost" && _ ? "pr-10" : "",
      g
    ), ae = (q) => {
      r === "date" && E ? E(new Date(q.target.value)) : o && o(q);
    };
    return /* @__PURE__ */ v.jsxs("div", { className: Y, children: [
      n && /* @__PURE__ */ v.jsxs(
        "label",
        {
          htmlFor: e || t,
          className: lt(
            N.label,
            u ? N.labelDisabled : "",
            p ? N.labelError : ""
          ),
          ...a,
          children: [
            n,
            f && /* @__PURE__ */ v.jsx("span", { className: N.requiredIndicator, children: "*" })
          ]
        }
      ),
      /* @__PURE__ */ v.jsxs("div", { className: N.inputWrapper, children: [
        x && w === "left" && /* @__PURE__ */ v.jsx("div", { className: N.startAdornment, children: /* @__PURE__ */ v.jsx(
          dt,
          {
            name: x,
            className: N.icon,
            size: C === "xs" ? "xs" : C === "sm" ? "sm" : C === "xl" ? "xl" : "md"
          }
        ) }),
        /* @__PURE__ */ v.jsx(
          "input",
          {
            ref: A,
            id: e || t,
            name: t,
            type: r,
            value: i ?? "",
            onChange: ae,
            onBlur: l,
            onFocus: c,
            disabled: u,
            readOnly: d,
            required: f,
            placeholder: s,
            className: te,
            "aria-invalid": p ? "true" : "false",
            "aria-describedby": `${e || t}-helper-text`,
            ...O,
            ...k
          }
        ),
        x && w === "right" && /* @__PURE__ */ v.jsx("div", { className: N.endAdornment, children: /* @__PURE__ */ v.jsx(
          dt,
          {
            name: x,
            className: N.icon,
            size: C === "xs" ? "xs" : C === "sm" ? "sm" : C === "xl" ? "xl" : "md"
          }
        ) }),
        _ && /* @__PURE__ */ v.jsx(
          "button",
          {
            type: "button",
            onClick: _.onClick,
            className: N.actionButton,
            children: /* @__PURE__ */ v.jsx(
              dt,
              {
                name: _.icon,
                size: C === "xs" ? "xs" : C === "sm" ? "sm" : C === "xl" ? "xl" : "md"
              }
            )
          }
        )
      ] }),
      (m || p) && /* @__PURE__ */ v.jsx(
        "p",
        {
          id: `${e || t}-helper-text`,
          className: p ? N.helperTextError : N.helperText,
          children: p || m
        }
      )
    ] });
  }
);
LF.displayName = "InputBase";
const ar = $r(
  "Input",
  LF
);
function sZ(e) {
  return "options" in e;
}
function JT(e, t) {
  wt(() => {
    function r(n) {
      e.current && !e.current.contains(n.target) && t();
    }
    return document.addEventListener("mousedown", r, !0), () => {
      document.removeEventListener("mousedown", r, !0);
    };
  }, [e, t]);
}
const iZ = (e, t, r, n) => {
  const [a, s] = Me({});
  return wt(() => {
    if (n && e.current && t.current) {
      const i = e.current.getBoundingClientRect(), o = t.current.getBoundingClientRect(), l = window.innerHeight, c = window.innerWidth;
      let u, d;
      switch (r) {
        case "bottom-start":
          u = i.height, d = 0;
          break;
        case "bottom-end":
          u = i.height, d = i.width - o.width;
          break;
        case "top-start":
          u = -o.height, d = 0;
          break;
        case "top-end":
          u = -o.height, d = i.width - o.width;
          break;
      }
      i.top + u + o.height > l && (u = -o.height), i.top + u < 0 && (u = i.height), i.left + d + o.width > c && (d = i.width - o.width), i.left + d < 0 && (d = 0), s({
        position: "absolute",
        top: `${u}px`,
        left: `${d}px`,
        minWidth: `${i.width}px`
      });
    }
  }, [n, r, e, t]), a;
}, jF = va(
  ({
    trigger: e,
    children: t,
    items: r,
    disabled: n = !1,
    placement: a = "bottom-start",
    className: s,
    triggerClassName: i,
    itemClassName: o,
    theme: l,
    isOpen: c,
    onOpenChange: u,
    maxHeight: d,
    onKeyDown: f,
    closeOnSelect: h = !0,
    size: p = "md",
    variant: m = "default",
    ...g
  }, y) => {
    var te, ae, ne, ue, q, U, Q, L;
    const [x, w] = Me(!1), [_, S] = Me(-1), C = tr(null), E = tr(null), O = tr(null), k = c !== void 0, A = k ? c : x, P = (j) => {
      var K, J, re, le;
      return lt(
        l.baseStyle[j],
        p && ((J = (K = l.sizes) == null ? void 0 : K[p]) == null ? void 0 : J[j]),
        m && ((le = (re = l.variants) == null ? void 0 : re[m]) == null ? void 0 : le[j])
      );
    }, D = lt(
      P("trigger"),
      (ae = (te = l.sizes) == null ? void 0 : te[p]) == null ? void 0 : ae.trigger,
      n && ((ue = (ne = l.baseStyle.states) == null ? void 0 : ne.disabled) == null ? void 0 : ue.trigger),
      i
    );
    JT(C, () => {
      k ? u == null || u(!1) : w(!1);
    });
    const N = (j) => {
      j && (j.preventDefault(), j.stopPropagation()), n || requestAnimationFrame(() => {
        const K = !A;
        k ? u == null || u(K) : w(K);
      });
    }, z = (j) => {
      f == null || f(j), j.key === "Escape" ? N() : j.key === "ArrowDown" ? (j.preventDefault(), S((K) => (K + 1) % ((r == null ? void 0 : r.length) || 0))) : j.key === "ArrowUp" ? (j.preventDefault(), S(
        (K) => K <= 0 ? ((r == null ? void 0 : r.length) || 0) - 1 : K - 1
      )) : j.key === "Enter" && _ !== -1 && (j.preventDefault(), r == null || r[_].onClick(), h && N());
    }, G = iZ(
      E,
      O,
      a,
      A
    ), Y = () => r ? r.map((j, K) => {
      var J, re, le, pe;
      return /* @__PURE__ */ v.jsxs(
        "div",
        {
          className: lt(
            P("item"),
            o,
            K === _ && (((re = (J = l.baseStyle.states) == null ? void 0 : J.active) == null ? void 0 : re.item) || ""),
            n && (((pe = (le = l.baseStyle.states) == null ? void 0 : le.disabled) == null ? void 0 : pe.item) || "")
          ),
          onClick: () => {
            n || (j.onClick(), h && N());
          },
          role: "menuitem",
          tabIndex: 0,
          children: [
            j.icon && /* @__PURE__ */ v.jsx(dt, { name: j.icon, className: P("icon") }),
            j.label
          ]
        },
        K
      );
    }) : t;
    return /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: lt(P("base"), s),
        ref: J3([y, C]),
        onKeyDown: z,
        ...g,
        children: [
          /* @__PURE__ */ v.jsx(
            "div",
            {
              ref: E,
              onClick: (j) => {
                j.stopPropagation(), N(j);
              },
              className: D,
              "aria-haspopup": "true",
              "aria-expanded": A,
              role: "button",
              tabIndex: 0,
              children: e
            }
          ),
          A && /* @__PURE__ */ v.jsx(
            "div",
            {
              ref: O,
              className: lt(
                P("menu"),
                (U = (q = l.sizes) == null ? void 0 : q[p]) == null ? void 0 : U.menu,
                (L = (Q = l.baseStyle.states) == null ? void 0 : Q.open) == null ? void 0 : L.menu
              ),
              role: "menu",
              "aria-orientation": "vertical",
              style: {
                ...G,
                maxHeight: d ? `${d}px` : void 0,
                overflowY: "auto"
              },
              children: /* @__PURE__ */ v.jsx("div", { className: lt(P("menuList")), children: Y() })
            }
          )
        ]
      }
    );
  }
);
jF.displayName = "DropdownBase";
const FF = $r("Dropdown", jF);
function BF(e, t) {
  const [r, n] = Me(e);
  return wt(() => {
    const a = setTimeout(() => {
      n(e);
    }, t);
    return () => {
      clearTimeout(a);
    };
  }, [e, t]), r;
}
const UF = va(
  (e, t) => {
    var bt, Ge, oe, ve, ye, Te, _e, Ae, Ve, mt, Dt, Gt, $t, Rt, Pr, fr, ca, en, Na, Ma, Hr, wa, na;
    const {
      options: r,
      value: n,
      onChange: a,
      placeholder: s,
      isDisabled: i = !1,
      isLoading: o = !1,
      isClearable: l = !1,
      isSearchable: c = !1,
      isMulti: u = !1,
      closeMenuOnSelect: d = !0,
      hideSelectedOptions: f = !1,
      controlShouldRenderValue: h = !0,
      menuPlacement: p = "bottom-start",
      maxMenuHeight: m = 300,
      noOptionsMessage: g = ({ inputValue: ce }) => `No options for "${ce}"`,
      loadingMessage: y = ({ inputValue: ce }) => `Loading options for "${ce}"...`,
      formatOptionLabel: x,
      formatGroupLabel: w,
      components: _ = {},
      styles: S = {},
      error: C,
      helperText: E,
      label: O,
      required: k = !1,
      size: A = "md",
      className: P,
      id: D,
      name: N,
      theme: z,
      multiSelectVariant: G = "tag",
      renderCustomMultiValue: Y,
      isCreatable: te = !1,
      createOnBlur: ae = !0,
      onCreateOption: ne,
      formatCreateLabel: ue = (ce) => `Create "${ce}"`
    } = e, [q, U] = Me(""), [Q, L] = Me([]), [j, K] = Me(!1), J = BF(q, 300), re = (ce, de) => {
      const Ne = typeof de == "object" ? de.value : de;
      for (const Le of ce)
        if (sZ(Le)) {
          const $e = Le.options.find((ze) => ze.value === Ne);
          if ($e) return $e;
        } else if (Le.value === Ne)
          return Le;
    }, le = Ft(async () => {
      try {
        if (typeof r == "function") {
          const ce = await r(J);
          L(ce);
        } else
          L(r);
      } catch (ce) {
        console.error("Error loading options:", ce), L([]);
      }
    }, [r, J]);
    wt(() => {
      le();
    }, [le]);
    const pe = (ce) => {
      const de = ce.target.value;
      U(de), de === "" && !u && (a == null || a(null));
    }, me = (ce) => {
      if (u) {
        const Ne = (Array.isArray(n) ? n.includes(ce.value) : !1) ? n.filter((Le) => Le !== ce.value) : [...n, ce.value];
        a == null || a(Ne);
      } else
        a == null || a(ce.value), d && K(!1);
      U("");
    }, Oe = () => {
      if (q) {
        const ce = {
          label: q,
          value: q
        };
        if (ne && ne(q), L((de) => [...de, ce]), !u)
          a == null || a(ce.value), K(!1);
        else {
          const de = [...n || [], ce.value];
          a == null || a(de);
        }
        U("");
      }
    }, ee = (ce) => {
      ce == null || ce.preventDefault(), ce == null || ce.stopPropagation(), U(""), a == null || a(null), u || K(!1);
    }, he = (ce) => {
      te && ae && q && (re(
        Q,
        q
      ) || Oe());
    }, Ee = (ce) => {
      var Le, $e, ze;
      const de = u ? Array.isArray(n) && n.includes(ce.value) : n === ce.value, Ne = _.Option || "div";
      return /* @__PURE__ */ v.jsx(
        Ne,
        {
          className: lt(
            (Le = z.baseStyle) == null ? void 0 : Le.option,
            de ? ($e = z.baseStyle) == null ? void 0 : $e.optionSelected : "",
            ce.isDisabled ? (ze = z.baseStyle) == null ? void 0 : ze.optionDisabled : ""
          ),
          style: S.option ? S.option({}, { isSelected: de, isDisabled: ce.isDisabled }) : {},
          onClick: () => !ce.isDisabled && me(ce),
          children: x ? x(ce, { context: "menu" }) : ce.label
        },
        ce.value
      );
    }, we = Tn(() => !c || q.length === 0 ? Q : Q.reduce((ce, de) => {
      if ("options" in de) {
        const Ne = de.options.filter(
          (Le) => Le.label.toLowerCase().includes(q.toLowerCase())
        );
        Ne.length > 0 && ce.push({ ...de, options: Ne });
      } else de.label.toLowerCase().includes(q.toLowerCase()) && ce.push(de);
      return ce;
    }, []), [Q, q, c]), rt = (f ? we.filter(
      (ce) => "options" in ce ? ce.options.some(
        (de) => !(u && Array.isArray(n) && n.includes(de.value))
      ) : !(u && Array.isArray(n) && n.includes(ce.value))
    ) : we).map(
      (ce) => {
        var de, Ne;
        return "options" in ce ? /* @__PURE__ */ v.jsxs(
          "div",
          {
            className: (de = z.baseStyle) == null ? void 0 : de.group,
            style: S.group ? S.group({}, {}) : {},
            children: [
              /* @__PURE__ */ v.jsx("div", { className: (Ne = z.baseStyle) == null ? void 0 : Ne.groupHeading, children: w ? w(ce) : ce.label }),
              ce.options.map(Ee)
            ]
          },
          ce.label
        ) : Ee(ce);
      }
    ), ht = (ce) => {
      if (typeof ce == "object" && "label" in ce)
        return ce.label;
      const de = re(Q, ce);
      return (de == null ? void 0 : de.label) || String(ce);
    };
    return wt(() => {
      n && typeof n == "object" && "label" in n && U(ht(n));
    }, [n]), /* @__PURE__ */ v.jsxs("div", { ref: t, className: lt((bt = z.baseStyle) == null ? void 0 : bt.container, P), children: [
      O && /* @__PURE__ */ v.jsxs("label", { htmlFor: D || N, className: (Ge = z.baseStyle) == null ? void 0 : Ge.label, children: [
        O,
        k && /* @__PURE__ */ v.jsx("span", { className: (oe = z.baseStyle) == null ? void 0 : oe.required, children: "*" })
      ] }),
      /* @__PURE__ */ v.jsx(
        FF,
        {
          isOpen: j,
          onOpenChange: (ce) => {
            i || K(ce);
          },
          placement: p,
          disabled: i,
          className: (ve = z.baseStyle) == null ? void 0 : ve.menu,
          maxHeight: m,
          size: A,
          trigger: /* @__PURE__ */ v.jsxs(
            "div",
            {
              className: lt(
                z.baseStyle.control,
                (Te = (ye = z.sizes) == null ? void 0 : ye[A]) == null ? void 0 : Te.control,
                j && z.baseStyle.controlFocused,
                C && z.baseStyle.error,
                i && z.baseStyle.disabled
              ),
              children: [
                /* @__PURE__ */ v.jsxs("div", { className: (_e = z.baseStyle) == null ? void 0 : _e.valueContainer, children: [
                  u && G === "tag" && Array.isArray(n) && n.length > 0 && /* @__PURE__ */ v.jsx(v.Fragment, { children: n.map((ce) => {
                    var Ne, Le, $e;
                    const de = re(Q, ce);
                    return de ? /* @__PURE__ */ v.jsxs(
                      "div",
                      {
                        className: (Ne = z.baseStyle) == null ? void 0 : Ne.multiValue,
                        children: [
                          /* @__PURE__ */ v.jsx("span", { className: (Le = z.baseStyle) == null ? void 0 : Le.multiValueLabel, children: x ? x(de, {
                            context: "value"
                          }) : de.label }),
                          /* @__PURE__ */ v.jsx(
                            "span",
                            {
                              className: ($e = z.baseStyle) == null ? void 0 : $e.multiValueRemove,
                              onClick: (ze) => {
                                ze.stopPropagation(), me(de);
                              },
                              children: /* @__PURE__ */ v.jsx(dt, { name: "close", size: "xs" })
                            }
                          )
                        ]
                      },
                      ce
                    ) : null;
                  }) }),
                  (!u || !n || Array.isArray(n) && n.length === 0) && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
                    !c && !te && !u && n && /* @__PURE__ */ v.jsx("div", { className: (Ae = z.baseStyle) == null ? void 0 : Ae.singleValue, children: ht(n) }),
                    (c || te) && /* @__PURE__ */ v.jsx(
                      ar,
                      {
                        variant: "ghost",
                        size: "md",
                        value: q || (n && typeof n == "object" && "label" in n ? n.label : n ? ht(n) : ""),
                        onChange: pe,
                        onBlur: he,
                        className: (Ve = z.baseStyle) == null ? void 0 : Ve.input,
                        onFocus: (ce) => {
                          ce.stopPropagation(), i || K(!0);
                        },
                        onClick: (ce) => {
                          ce.stopPropagation(), i || K(!0);
                        },
                        placeholder: n ? "" : s,
                        disabled: i
                      }
                    ),
                    !c && !te && !n && /* @__PURE__ */ v.jsx("div", { className: (mt = z.baseStyle) == null ? void 0 : mt.placeholder, children: s })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsxs("div", { className: (Dt = z.baseStyle) == null ? void 0 : Dt.indicators, children: [
                  l && (u ? n.length > 0 : n) && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
                    /* @__PURE__ */ v.jsx(
                      "div",
                      {
                        className: (Gt = z.baseStyle) == null ? void 0 : Gt.clearIndicator,
                        onClick: ee,
                        children: /* @__PURE__ */ v.jsx(dt, { name: "close", size: "xs" })
                      }
                    ),
                    /* @__PURE__ */ v.jsx("div", { className: ($t = z.baseStyle) == null ? void 0 : $t.indicatorSeparator })
                  ] }),
                  /* @__PURE__ */ v.jsx("div", { className: (Rt = z.baseStyle) == null ? void 0 : Rt.dropdownIndicator, children: /* @__PURE__ */ v.jsx(
                    dt,
                    {
                      name: j ? "chevron-up" : "chevron-down",
                      size: "sm"
                    }
                  ) })
                ] })
              ]
            }
          ),
          children: /* @__PURE__ */ v.jsxs("div", { className: (Pr = z.baseStyle) == null ? void 0 : Pr.menuList, children: [
            o ? /* @__PURE__ */ v.jsx("div", { className: (fr = z.baseStyle) == null ? void 0 : fr.loadingMessage, children: y({ inputValue: q }) }) : rt.length === 0 ? /* @__PURE__ */ v.jsx("div", { className: (ca = z.baseStyle) == null ? void 0 : ca.noOptionsMessage, children: g({ inputValue: q }) }) : rt,
            te && q && /* @__PURE__ */ v.jsxs(
              "div",
              {
                className: (en = z.baseStyle) == null ? void 0 : en.createOption,
                onClick: Oe,
                children: [
                  /* @__PURE__ */ v.jsx(
                    dt,
                    {
                      name: "plus",
                      size: "sm",
                      className: (Na = z.baseStyle) == null ? void 0 : Na.createOptionIcon
                    }
                  ),
                  /* @__PURE__ */ v.jsx("span", { className: (Ma = z.baseStyle) == null ? void 0 : Ma.createOptionText, children: ue(q) })
                ]
              }
            )
          ] })
        }
      ),
      u && G === "custom" && Y && /* @__PURE__ */ v.jsx("div", { className: (Hr = z.baseStyle) == null ? void 0 : Hr.customMultiValueContainer, children: Y(
        Q.filter(
          (ce) => n.includes(ce.value)
        )
      ) }),
      (E || C) && /* @__PURE__ */ v.jsx(
        "p",
        {
          className: lt(
            (wa = z.baseStyle) == null ? void 0 : wa.helperText,
            C ? (na = z.baseStyle) == null ? void 0 : na.error : ""
          ),
          children: C || E
        }
      )
    ] });
  }
);
UF.displayName = "SelectBase";
const ss = $r(
  "Select",
  UF
), VF = M.forwardRef(
  ({
    id: e,
    name: t,
    checked: r,
    disabled: n = !1,
    onChange: a,
    label: s,
    size: i = "medium",
    className: o,
    ariaLabel: l,
    labelPosition: c = "right",
    checkedIcon: u,
    uncheckedIcon: d,
    theme: f,
    labelProps: h,
    ...p
  }, m) => {
    const [g, y] = M.useState(r ?? !1);
    M.useEffect(() => {
      r !== void 0 && y(r);
    }, [r]);
    const x = (_) => {
      const S = _.target.checked;
      y(S), a == null || a(S, _);
    }, w = (_) => {
      if (_.key === " " || _.key === "Enter") {
        _.preventDefault();
        const S = !g;
        y(S), a == null || a(S, {});
      }
    };
    return /* @__PURE__ */ v.jsxs(
      "label",
      {
        className: lt(
          f.baseStyle.base,
          f.baseStyle.root,
          f.baseStyle.wrapper[c],
          f.baseStyle.label,
          n && f.baseStyle.labelDisabled,
          o
        ),
        htmlFor: e,
        onKeyDown: w,
        tabIndex: n ? -1 : 0,
        children: [
          /* @__PURE__ */ v.jsx(
            "input",
            {
              type: "checkbox",
              id: e,
              name: t,
              checked: g,
              disabled: n,
              onChange: x,
              className: f.baseStyle.input,
              "aria-label": l || (typeof s == "string" ? s : void 0),
              ref: m,
              ...p
            }
          ),
          (c === "left" || c === "top") && s && /* @__PURE__ */ v.jsx(
            "span",
            {
              className: lt(
                f.baseStyle.labelText[c],
                h == null ? void 0 : h.className
              ),
              ...h,
              children: s
            }
          ),
          /* @__PURE__ */ v.jsx(
            "span",
            {
              className: lt(
                "relative inline-block transition-colors duration-200 ease-in-out rounded-full cursor-pointer",
                f.baseStyle.track[i],
                g ? f.baseStyle.trackChecked : f.baseStyle.trackUnchecked,
                n && "opacity-50 cursor-not-allowed"
              ),
              children: /* @__PURE__ */ v.jsx(
                "span",
                {
                  className: lt(
                    "absolute top-0.5 left-0.5 inline-block rounded-full bg-white shadow transform ring-0 transition-transform duration-200 ease-in-out",
                    f.baseStyle.thumb[i],
                    g ? f.baseStyle.thumbChecked : f.baseStyle.thumbUnchecked
                  ),
                  children: /* @__PURE__ */ v.jsx("span", { className: f.baseStyle.icon, children: g ? u : d })
                }
              )
            }
          ),
          (c === "right" || c === "bottom") && s && /* @__PURE__ */ v.jsx(
            "span",
            {
              className: lt(
                f.baseStyle.labelText[c],
                h == null ? void 0 : h.className
              ),
              ...h,
              children: s
            }
          )
        ]
      }
    );
  }
);
VF.displayName = "SwitchBase";
const $F = $r(
  "Switch",
  VF
), oZ = va(
  ({
    id: e,
    name: t,
    label: r,
    labelProps: n,
    placeholder: a,
    value: s,
    onChange: i,
    onBlur: o,
    onFocus: l,
    disabled: c = !1,
    readOnly: u = !1,
    required: d = !1,
    error: f,
    helperText: h,
    className: p,
    rows: m = 3,
    size: g = "medium",
    variant: y = "default",
    fullWidth: x = !1,
    autoResize: w = !1,
    maxLength: _,
    showCharacterCount: S = !1,
    theme: C,
    ...E
  }, O) => {
    var ue, q;
    const k = tr(null), [A, P] = Me(0);
    wt(() => {
      k.current && P(k.current.value.length);
    }, [s]);
    const D = (U) => {
      i == null || i(U), P(U.target.value.length), w && N();
    }, N = () => {
      k.current && (k.current.style.height = "auto", k.current.style.height = `${k.current.scrollHeight}px`);
    };
    wt(() => {
      w && N();
    }, [s, w]);
    const z = C.baseStyle, G = (ue = C.sizes) == null ? void 0 : ue[g], Y = (q = C.variants) == null ? void 0 : q[f ? "error" : y], te = lt(
      z.wrapper,
      x && z.fullWidth,
      p
    ), ae = lt(
      z.textarea,
      G == null ? void 0 : G.textarea,
      Y == null ? void 0 : Y.textarea,
      c && z.disabled,
      x && z.fullWidth
    ), ne = lt(
      z.label,
      G == null ? void 0 : G.label,
      c && z.labelDisabled,
      f && z.labelError
    );
    return /* @__PURE__ */ v.jsxs("div", { className: te, children: [
      r && /* @__PURE__ */ v.jsx("div", { className: z.labelWrapper, children: /* @__PURE__ */ v.jsxs(
        "label",
        {
          htmlFor: e || t,
          className: ne,
          ...n,
          children: [
            r,
            d && /* @__PURE__ */ v.jsx("span", { className: z.requiredIndicator, children: "*" })
          ]
        }
      ) }),
      /* @__PURE__ */ v.jsx(
        "textarea",
        {
          ref: (U) => {
            k.current = U, typeof O == "function" ? O(U) : O && (O.current = U);
          },
          id: e || t,
          name: t,
          value: s,
          onChange: D,
          onBlur: o,
          onFocus: l,
          disabled: c,
          readOnly: u,
          required: d,
          placeholder: a,
          rows: m,
          maxLength: _,
          "aria-invalid": f ? "true" : "false",
          "aria-describedby": f || h ? `${e || t}-helper-text` : void 0,
          className: ae,
          ...E
        }
      ),
      (f || h || S) && /* @__PURE__ */ v.jsxs("div", { className: z.helperWrapper, children: [
        (f || h) && /* @__PURE__ */ v.jsx(
          "p",
          {
            id: `${e || t}-helper-text`,
            className: lt(
              z.helperText,
              f ? z.helperTextError : ""
            ),
            children: f || h
          }
        ),
        S && /* @__PURE__ */ v.jsxs("p", { className: z.characterCount, children: [
          A,
          _ ? `/${_}` : "",
          " characters"
        ] })
      ] })
    ] });
  }
), lZ = $r(
  "Textarea",
  oZ
), fi = ({
  src: e,
  alt: t,
  fallbackSrc: r,
  lowResSrc: n,
  sizes: a,
  srcSet: s,
  fullHeight: i,
  ...o
}) => {
  const [l, c] = Me(n || e), [u, d] = Me(!1), [f, h] = Me(!1);
  wt(() => {
    const m = new window.Image();
    m.src = e, m.onload = () => {
      c(e), h(!0);
    }, m.onerror = () => {
      console.error("Error loading image:", e), p();
    };
  }, [e]);
  const p = () => {
    r && l !== r ? c(r) : d(!0);
  };
  return u ? /* @__PURE__ */ v.jsx(
    "div",
    {
      className: `flex items-center justify-center w-full bg-gray-100 ${i ? "h-full" : o.ratio || ""} ${o.className || ""}`,
      children: /* @__PURE__ */ v.jsx(
        dt,
        {
          name: "image-placeholder",
          className: "w-full h-full text-gray-300"
        }
      )
    }
  ) : /* @__PURE__ */ v.jsx(
    "div",
    {
      className: `relative ${i ? "h-full" : o.ratio || ""} overflow-hidden`,
      children: /* @__PURE__ */ v.jsx(
        "img",
        {
          src: l,
          alt: t,
          onError: p,
          loading: "lazy",
          sizes: a,
          srcSet: s,
          className: `absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${f ? "opacity-100" : "opacity-0"} ${o.className || ""}`,
          ...o
        }
      )
    }
  );
}, qA = (e) => e ? e.startsWith("image/") ? "image" : e === "application/pdf" ? "file-pdf" : e.startsWith("video/") ? "file-video" : e.startsWith("audio/") ? "file-audio" : "file" : "file", to = (e) => typeof e == "string" ? e : `${e.name}-${e.size}-${e.lastModified}`, HF = va(
  ({
    onChange: e,
    value: t = [],
    // Default to array for consistency
    multiple: r = !1,
    error: n,
    accept: a,
    maxSize: s,
    maxFiles: i,
    // Rename prop to avoid conflict
    onUploadProgress: o,
    onFileUpload: l,
    variant: c = "default",
    size: u = "md",
    color: d = "primary",
    disabled: f = !1,
    allowReorder: h = !0,
    theme: p
  }, m) => {
    var me, Oe;
    const { theme: g } = Wi(), y = p.baseStyle, x = ((me = p.variants) == null ? void 0 : me[c]) || {}, w = ((Oe = p.sizes) == null ? void 0 : Oe[u]) || {}, _ = r ? i : 1, S = tr(null), [C, E] = Me(!1), [O, k] = Me([]), [A, P] = Me(null), [D, N] = Me(null), z = tr(/* @__PURE__ */ new Set()), G = (ee) => ee ? Array.isArray(ee) ? ee : [ee] : [], [Y, te] = Me(
      G(t)
    ), ae = tr(
      new Set(Y.map(to))
    );
    wt(() => {
      const ee = G(t);
      new Set(ee.map(to));
      const he = new Set(Y.map(to)), Ee = ee.filter(
        (rt) => !z.current.has(to(rt))
      ), we = new Set(Ee.map(to));
      (we.size !== he.size || !Array.from(we).every((rt) => he.has(rt))) && (te(Ee), ae.current = we, Ee.length !== O.length && k(Array(Ee.length).fill(100)));
    }, [t]);
    const ne = Ft(
      (ee) => {
        var Ee;
        const he = to(ee);
        if (z.current.has(he) && z.current.delete(he), a) {
          const we = a.split(",").map((bt) => bt.trim()), Pe = ee.type, rt = `.${(Ee = ee.name.split(".").pop()) == null ? void 0 : Ee.toLowerCase()}`;
          if (!we.some((bt) => {
            if (bt.startsWith("."))
              return rt === bt.toLowerCase();
            if (bt.endsWith("/*")) {
              const Ge = bt.slice(0, -2);
              return Pe.startsWith(Ge);
            } else
              return Pe === bt;
          }))
            return console.error(
              `File ${ee.name} is not of accepted type: ${Pe}`
            ), !1;
        }
        return s && ee.size > s ? (console.error(
          `File ${ee.name} exceeds maximum size of ${s} bytes`
        ), !1) : !0;
      },
      [a, s]
      // Multiple dependency removed as logic applies to both
    ), ue = Ft(
      (ee) => {
        if (f) return;
        const he = Array.from(ee).filter(ne);
        if (he.length === 0)
          return;
        let Ee = [], we = [];
        if (r) {
          const Pe = [], rt = [];
          if (he.forEach((ht) => {
            const bt = to(ht);
            _ && Y.length + Pe.length >= _ || ae.current.has(bt) || (Pe.push(ht), rt.push(100), ae.current.add(bt));
          }), Pe.length > 0)
            Ee = [...Y, ...Pe], we = [...O, ...rt];
          else
            return;
        } else {
          const Pe = he[0];
          Ee = [Pe], we = [100];
          const rt = to(Pe);
          ae.current = /* @__PURE__ */ new Set([rt]), z.current.clear();
        }
        te(Ee), k(we), e(Ee);
      },
      [
        f,
        ne,
        r,
        _,
        Y,
        // Need current internalValue for appending in multi-mode
        O,
        // Need current progress for appending in multi-mode
        e
      ]
    ), q = Ft(
      (ee) => {
        f || (ee.preventDefault(), ee.stopPropagation(), E(ee.type === "dragenter" || ee.type === "dragover"));
      },
      [f]
    ), U = Ft(
      (ee) => {
        if (ee.preventDefault(), ee.stopPropagation(), E(!1), f) return;
        const he = ee.dataTransfer.files;
        he && he.length > 0 && ue(he);
      },
      [f, ue]
      // handleFiles is now defined
    ), Q = Ft(
      // Renamed from handleChange
      (ee) => {
        ee.target.files && (ue(ee.target.files), S.current && (S.current.value = ""));
      },
      [ue]
      // handleFiles is now defined
    ), L = (ee) => {
      !h || f || !r || P(ee);
    }, j = (ee, he) => {
      !h || f || !r || (ee.preventDefault(), N(he));
    }, K = (ee) => {
      if (!h || f || !r || A === null)
        return;
      let he = [];
      te((we) => {
        he = [...we];
        const [Pe] = he.splice(A, 1);
        return he.splice(ee, 0, Pe), he;
      });
      let Ee = [];
      k((we) => {
        Ee = [...we];
        const [Pe] = Ee.splice(A, 1);
        return Ee.splice(ee, 0, Pe), Ee;
      }), e(he), P(null), N(null);
    }, J = Ft(() => {
      !f && S.current && S.current.click();
    }, [f]), re = Ft(
      (ee) => {
        if (f) return;
        const he = Y[ee];
        if (!he) return;
        const Ee = to(he);
        z.current.add(Ee), ae.current.delete(Ee);
        let we, Pe;
        r ? (we = Y.filter((rt, ht) => ht !== ee), Pe = O.filter((rt, ht) => ht !== ee)) : (we = [], Pe = []), te(we), k(Pe), e(we);
      },
      [Y, O, f, e, r]
      // Add multiple dependency
    ), le = Ft(
      (ee, he) => {
        var rt;
        const Ee = O[he] || 100;
        let we;
        const Pe = `file-${he}-${to(ee)}`;
        try {
          if (typeof ee == "string") {
            const ht = (rt = ee.split(".").pop()) == null ? void 0 : rt.toLowerCase();
            we = ["jpg", "jpeg", "png", "gif", "webp"].includes(
              ht || ""
            ) ? /* @__PURE__ */ v.jsx(
              fi,
              {
                src: ee,
                alt: `File ${he + 1}`,
                ratio: "aspect-[2/3]"
              }
            ) : /* @__PURE__ */ v.jsxs("div", { className: y.previewDocument, children: [
              /* @__PURE__ */ v.jsx(dt, { name: qA(ht), size: "lg" }),
              /* @__PURE__ */ v.jsx("span", { className: y.fileName, children: ee.split("/").pop() })
            ] });
          } else
            we = ee.type.startsWith("image/") ? /* @__PURE__ */ v.jsx(
              fi,
              {
                src: URL.createObjectURL(ee),
                alt: ee.name,
                ratio: "aspect-[2/3]",
                onLoad: (ht) => URL.revokeObjectURL(ht.currentTarget.src)
              }
            ) : /* @__PURE__ */ v.jsxs("div", { className: y.previewDocument, children: [
              /* @__PURE__ */ v.jsx(dt, { name: qA(ee.type), size: "lg" }),
              /* @__PURE__ */ v.jsx("span", { className: y.fileName, children: ee.name })
            ] });
        } catch {
          we = /* @__PURE__ */ v.jsxs("div", { className: y.previewDocument, children: [
            /* @__PURE__ */ v.jsx(dt, { name: "file", size: "lg" }),
            /* @__PURE__ */ v.jsx("span", { className: y.fileName, children: typeof ee == "string" ? ee.split("/").pop() : ee.name || "Unknown file" })
          ] });
        }
        return /* @__PURE__ */ v.jsxs(
          "div",
          {
            className: lt(
              y.preview,
              A === he && y.dragging,
              D === he && y.dragOver
            ),
            draggable: h && !f && r && Y.length > 1,
            onDragStart: () => L(he),
            onDragOver: (ht) => j(ht, he),
            onDragEnd: () => {
              P(null), N(null);
            },
            onDrop: () => K(he),
            children: [
              we,
              /* @__PURE__ */ v.jsx("div", { className: y.progressBar, children: /* @__PURE__ */ v.jsx(
                "div",
                {
                  className: y.progressBarFill,
                  style: { width: `${Ee}%` }
                }
              ) }),
              !f && /* @__PURE__ */ v.jsx(
                qe,
                {
                  icon: "trash",
                  variant: "solid",
                  color: "danger",
                  size: "xs",
                  onClick: (ht) => {
                    ht.stopPropagation(), re(he);
                  },
                  className: y.removeButton
                }
              ),
              h && !f && r && Y.length > 1 && /* @__PURE__ */ v.jsx("div", { className: y.dragHandle, children: /* @__PURE__ */ v.jsx(dt, { name: "grip-vertical", size: "sm" }) })
            ]
          },
          Pe
        );
      },
      [
        y,
        f,
        O,
        h,
        A,
        D,
        r,
        Y.length,
        // Re-render previews if length changes
        re,
        L,
        // Add reorder handlers as dependencies
        j,
        K
      ]
    ), pe = !_ || Y.length < _ || !r && Y.length === 0;
    return /* @__PURE__ */ v.jsxs("div", { className: lt(y.base, x.base, w.base), children: [
      pe && /* @__PURE__ */ v.jsxs(
        "div",
        {
          className: lt(
            y.dropzone,
            x.dropzone,
            w.dropzone,
            C ? y.dragging : "",
            // Use specific dragging style if defined
            n ? y.error : "",
            // Use specific error style if defined
            f ? y.disabled : ""
            // Use specific disabled style if defined
          ),
          onDragEnter: q,
          onDragLeave: q,
          onDragOver: q,
          onDrop: U,
          onClick: J,
          role: "button",
          tabIndex: f ? -1 : 0,
          "aria-disabled": f,
          children: [
            /* @__PURE__ */ v.jsx(
              "input",
              {
                ref: J3([m, S]),
                type: "file",
                multiple: r,
                onChange: Q,
                accept: a,
                disabled: f,
                className: y.input,
                "aria-hidden": "true"
              }
            ),
            /* @__PURE__ */ v.jsx(dt, { name: "upload", size: "xl", className: y.uploadIcon }),
            /* @__PURE__ */ v.jsx("p", { className: y.dropzoneText, children: C ? "Drop the files here..." : "Drag & drop files here, or click to select files" })
          ]
        }
      ),
      Y.length > 0 && /* @__PURE__ */ v.jsx("div", { className: y.fileList, children: Y.map((ee, he) => le(ee, he)) }),
      n && /* @__PURE__ */ v.jsx("p", { className: y.error, children: n })
    ] });
  }
);
HF.displayName = "FileUploadBase";
const cZ = $r(
  "FileUpload",
  HF
), uZ = va(
  ({
    label: e,
    size: t = "medium",
    error: r,
    helperText: n,
    disabled: a,
    className: s,
    theme: i,
    ...o
  }, l) => {
    var m;
    const c = i.baseStyle, u = ((m = i.sizes) == null ? void 0 : m[t]) || {}, d = Wa(c.wrapper, s), f = Wa(
      c.base,
      c.input,
      u.input,
      r ? c.error : "",
      a ? c.disabled : ""
    ), h = Wa(
      c.label,
      a ? c.disabled : ""
    ), p = Wa(
      c.labelText,
      u.labelText
    );
    return /* @__PURE__ */ v.jsxs("div", { className: d, children: [
      /* @__PURE__ */ v.jsxs("label", { className: h, children: [
        /* @__PURE__ */ v.jsx(
          "input",
          {
            type: "radio",
            className: f,
            disabled: a,
            ref: l,
            ...o
          }
        ),
        e && /* @__PURE__ */ v.jsx("span", { className: p, children: e })
      ] }),
      (n || r) && /* @__PURE__ */ v.jsx(
        "p",
        {
          className: Wa(
            c.helperText,
            r ? c.error : ""
          ),
          children: r || n
        }
      )
    ] });
  }
), dZ = $r(
  "Radio",
  uZ
), WF = va(
  ({
    id: e,
    name: t,
    label: r,
    checked: n,
    indeterminate: a,
    disabled: s = !1,
    size: i = "md",
    variant: o = "solid",
    color: l = "primary",
    error: c,
    helperText: u,
    className: d,
    theme: f,
    onChange: h,
    ...p
  }, m) => {
    var O, k;
    const g = tr(null), y = m || g;
    wt(() => {
      y.current && (y.current.indeterminate = !!a);
    }, [a, y]);
    const x = f.baseStyle, w = (O = f.variants) == null ? void 0 : O[o], _ = (k = f.sizes) == null ? void 0 : k[i], S = lt(
      x.base,
      x.input,
      w == null ? void 0 : w.base,
      _ == null ? void 0 : _.input,
      n && [x.states.checked, w == null ? void 0 : w.checked],
      a && x.states.indeterminate,
      s && x.states.disabled,
      c && x.states.error,
      !s && (w == null ? void 0 : w.hover),
      d
    ), C = lt(x.label, s && x.states.disabled), E = lt(x.labelText, _ == null ? void 0 : _.labelText);
    return /* @__PURE__ */ v.jsxs("div", { className: x.wrapper, children: [
      /* @__PURE__ */ v.jsxs("label", { className: C, children: [
        /* @__PURE__ */ v.jsx(
          "input",
          {
            type: "checkbox",
            id: e || t,
            name: t,
            checked: n,
            disabled: s,
            className: S,
            onChange: h,
            ref: y,
            ...p
          }
        ),
        r && /* @__PURE__ */ v.jsx("span", { className: E, children: r })
      ] }),
      (u || c) && /* @__PURE__ */ v.jsx("p", { className: c ? x.states.error : x.helperText, children: c || u })
    ] });
  }
);
WF.displayName = "CheckboxBase";
const ZT = $r(
  "Checkbox",
  WF
);
function zF(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (r = zF(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function Pa() {
  for (var e, t, r = 0, n = "", a = arguments.length; r < a; r++) (e = arguments[r]) && (t = zF(e)) && (n && (n += " "), n += t);
  return n;
}
function At(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Xr(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Fi(e, t) {
  const r = At(e);
  return isNaN(t) ? Xr(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function $i(e, t) {
  const r = At(e);
  if (isNaN(t)) return Xr(e, NaN);
  if (!t)
    return r;
  const n = r.getDate(), a = Xr(e, r.getTime());
  a.setMonth(r.getMonth() + t + 1, 0);
  const s = a.getDate();
  return n >= s ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    n
  ), r);
}
function eC(e, t) {
  const r = +At(e);
  return Xr(e, r + t);
}
const KF = 6048e5, fZ = 864e5, Iw = 6e4, Dw = 36e5, hZ = 1e3;
function pZ(e, t) {
  return eC(e, t * Dw);
}
let mZ = {};
function td() {
  return mZ;
}
function Fl(e, t) {
  var o, l, c, u;
  const r = td(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (o = t == null ? void 0 : t.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? r.weekStartsOn ?? ((u = (c = r.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, a = At(e), s = a.getDay(), i = (s < n ? 7 : 0) + s - n;
  return a.setDate(a.getDate() - i), a.setHours(0, 0, 0, 0), a;
}
function th(e) {
  return Fl(e, { weekStartsOn: 1 });
}
function qF(e) {
  const t = At(e), r = t.getFullYear(), n = Xr(e, 0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const a = th(n), s = Xr(e, 0);
  s.setFullYear(r, 0, 4), s.setHours(0, 0, 0, 0);
  const i = th(s);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= i.getTime() ? r : r - 1;
}
function $u(e) {
  const t = At(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Jy(e) {
  const t = At(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function rh(e, t) {
  const r = $u(e), n = $u(t), a = +r - Jy(r), s = +n - Jy(n);
  return Math.round((a - s) / fZ);
}
function gZ(e) {
  const t = qF(e), r = Xr(e, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), th(r);
}
function vE(e, t) {
  return eC(e, t * Iw);
}
function tC(e, t) {
  const r = t * 3;
  return $i(e, r);
}
function vZ(e, t) {
  return eC(e, t * 1e3);
}
function Zy(e, t) {
  const r = t * 7;
  return Fi(e, r);
}
function Ol(e, t) {
  return $i(e, t * 12);
}
function GA(e) {
  let t;
  return e.forEach(function(r) {
    const n = At(r);
    (t === void 0 || t < n || isNaN(Number(n))) && (t = n);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function YA(e) {
  let t;
  return e.forEach((r) => {
    const n = At(r);
    (!t || t > n || isNaN(+n)) && (t = n);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function yZ(e, t) {
  const r = $u(e), n = $u(t);
  return +r == +n;
}
function Al(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function eb(e) {
  if (!Al(e) && typeof e != "number")
    return !1;
  const t = At(e);
  return !isNaN(Number(t));
}
function tb(e, t) {
  const r = At(e), n = At(t), a = r.getFullYear() - n.getFullYear(), s = r.getMonth() - n.getMonth();
  return a * 12 + s;
}
function Ru(e) {
  const t = At(e);
  return Math.trunc(t.getMonth() / 3) + 1;
}
function rb(e, t) {
  const r = At(e), n = At(t), a = r.getFullYear() - n.getFullYear(), s = Ru(r) - Ru(n);
  return a * 4 + s;
}
function nb(e, t) {
  const r = At(e), n = At(t);
  return r.getFullYear() - n.getFullYear();
}
function bZ(e, t) {
  const r = At(e), n = At(t), a = XA(r, n), s = Math.abs(rh(r, n));
  r.setDate(r.getDate() - a * s);
  const i = +(XA(r, n) === -a), o = a * (s - i);
  return o === 0 ? 0 : o;
}
function XA(e, t) {
  const r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function GF(e) {
  const t = At(e);
  return t.setHours(23, 59, 59, 999), t;
}
function YF(e) {
  const t = At(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function yE(e) {
  const t = At(e), r = t.getMonth(), n = r - r % 3;
  return t.setMonth(n, 1), t.setHours(0, 0, 0, 0), t;
}
function XF(e) {
  const t = At(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function QF(e) {
  const t = At(e), r = t.getFullYear();
  return t.setFullYear(r + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Nw(e) {
  const t = At(e), r = Xr(e, 0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function wZ(e, t) {
  var o, l;
  const r = td(), n = r.weekStartsOn ?? ((l = (o = r.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? 0, a = At(e), s = a.getDay(), i = (s < n ? -7 : 0) + 6 - (s - n);
  return a.setDate(a.getDate() + i), a.setHours(23, 59, 59, 999), a;
}
const xZ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, _Z = (e, t, r) => {
  let n;
  const a = xZ[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function B1(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const SZ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, EZ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, TZ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, CZ = {
  date: B1({
    formats: SZ,
    defaultWidth: "full"
  }),
  time: B1({
    formats: EZ,
    defaultWidth: "full"
  }),
  dateTime: B1({
    formats: TZ,
    defaultWidth: "full"
  })
}, kZ = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, OZ = (e, t, r, n) => kZ[e];
function lp(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : i;
      a = e.formattingValues[o] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, o = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[o] || e.values[i];
    }
    const s = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[s];
  };
}
const AZ = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, PZ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, RZ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, IZ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, DZ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, NZ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, MZ = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, LZ = {
  ordinalNumber: MZ,
  era: lp({
    values: AZ,
    defaultWidth: "wide"
  }),
  quarter: lp({
    values: PZ,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: lp({
    values: RZ,
    defaultWidth: "wide"
  }),
  day: lp({
    values: IZ,
    defaultWidth: "wide"
  }),
  dayPeriod: lp({
    values: DZ,
    defaultWidth: "wide",
    formattingValues: NZ,
    defaultFormattingWidth: "wide"
  })
};
function cp(e) {
  return (t, r = {}) => {
    const n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], s = t.match(a);
    if (!s)
      return null;
    const i = s[0], o = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(o) ? FZ(o, (d) => d.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      jZ(o, (d) => d.test(i))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = r.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      r.valueCallback(c)
    ) : c;
    const u = t.slice(i.length);
    return { value: c, rest: u };
  };
}
function jZ(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function FZ(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function BZ(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const a = n[0], s = t.match(e.parsePattern);
    if (!s) return null;
    let i = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    i = r.valueCallback ? r.valueCallback(i) : i;
    const o = t.slice(a.length);
    return { value: i, rest: o };
  };
}
const UZ = /^(\d+)(th|st|nd|rd)?/i, VZ = /\d+/i, $Z = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, HZ = {
  any: [/^b/i, /^(a|c)/i]
}, WZ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, zZ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, KZ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, qZ = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, GZ = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, YZ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, XZ = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, QZ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, JZ = {
  ordinalNumber: BZ({
    matchPattern: UZ,
    parsePattern: VZ,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: cp({
    matchPatterns: $Z,
    defaultMatchWidth: "wide",
    parsePatterns: HZ,
    defaultParseWidth: "any"
  }),
  quarter: cp({
    matchPatterns: WZ,
    defaultMatchWidth: "wide",
    parsePatterns: zZ,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: cp({
    matchPatterns: KZ,
    defaultMatchWidth: "wide",
    parsePatterns: qZ,
    defaultParseWidth: "any"
  }),
  day: cp({
    matchPatterns: GZ,
    defaultMatchWidth: "wide",
    parsePatterns: YZ,
    defaultParseWidth: "any"
  }),
  dayPeriod: cp({
    matchPatterns: XZ,
    defaultMatchWidth: "any",
    parsePatterns: QZ,
    defaultParseWidth: "any"
  })
}, JF = {
  code: "en-US",
  formatDistance: _Z,
  formatLong: CZ,
  formatRelative: OZ,
  localize: LZ,
  match: JZ,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function ZZ(e) {
  const t = At(e);
  return rh(t, Nw(t)) + 1;
}
function rC(e) {
  const t = At(e), r = +th(t) - +gZ(t);
  return Math.round(r / KF) + 1;
}
function nC(e, t) {
  var u, d, f, h;
  const r = At(e), n = r.getFullYear(), a = td(), s = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((h = (f = a.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = Xr(e, 0);
  i.setFullYear(n + 1, 0, s), i.setHours(0, 0, 0, 0);
  const o = Fl(i, t), l = Xr(e, 0);
  l.setFullYear(n, 0, s), l.setHours(0, 0, 0, 0);
  const c = Fl(l, t);
  return r.getTime() >= o.getTime() ? n + 1 : r.getTime() >= c.getTime() ? n : n - 1;
}
function eee(e, t) {
  var o, l, c, u;
  const r = td(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (o = t == null ? void 0 : t.locale) == null ? void 0 : o.options) == null ? void 0 : l.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((u = (c = r.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, a = nC(e, t), s = Xr(e, 0);
  return s.setFullYear(a, 0, n), s.setHours(0, 0, 0, 0), Fl(s, t);
}
function ZF(e, t) {
  const r = At(e), n = +Fl(r, t) - +eee(r, t);
  return Math.round(n / KF) + 1;
}
function Kr(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const Jl = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return Kr(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : Kr(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Kr(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Kr(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Kr(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Kr(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Kr(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return Kr(a, t.length);
  }
}, Ud = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, QA = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, { unit: "year" });
    }
    return Jl.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const a = nC(e, n), s = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const i = s % 100;
      return Kr(i, 2);
    }
    return t === "Yo" ? r.ordinalNumber(s, { unit: "year" }) : Kr(s, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = qF(e);
    return Kr(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return Kr(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return Kr(n, 2);
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return Kr(n, 2);
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Jl.M(e, t);
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return Kr(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const a = ZF(e, n);
    return t === "wo" ? r.ordinalNumber(a, { unit: "week" }) : Kr(a, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = rC(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : Kr(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : Jl.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = ZZ(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : Kr(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const a = e.getDay(), s = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(s);
      case "ee":
        return Kr(s, 2);
      case "eo":
        return r.ordinalNumber(s, { unit: "day" });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const a = e.getDay(), s = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(s);
      case "cc":
        return Kr(s, t.length);
      case "co":
        return r.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), a = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return Kr(a, t.length);
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n === 12 ? a = Ud.noon : n === 0 ? a = Ud.midnight : a = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n >= 17 ? a = Ud.evening : n >= 12 ? a = Ud.afternoon : n >= 4 ? a = Ud.morning : a = Ud.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return Jl.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : Jl.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : Kr(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : Kr(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Jl.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : Jl.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Jl.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return ZA(n);
      case "XXXX":
      case "XX":
        return fu(n);
      case "XXXXX":
      case "XXX":
      default:
        return fu(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return ZA(n);
      case "xxxx":
      case "xx":
        return fu(n);
      case "xxxxx":
      case "xxx":
      default:
        return fu(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + JA(n, ":");
      case "OOOO":
      default:
        return "GMT" + fu(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + JA(n, ":");
      case "zzzz":
      default:
        return "GMT" + fu(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(e.getTime() / 1e3);
    return Kr(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    const n = e.getTime();
    return Kr(n, t.length);
  }
};
function JA(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.trunc(n / 60), s = n % 60;
  return s === 0 ? r + String(a) : r + String(a) + t + Kr(s, 2);
}
function ZA(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Kr(Math.abs(e) / 60, 2) : fu(e, t);
}
function fu(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Kr(Math.trunc(n / 60), 2), s = Kr(n % 60, 2);
  return r + a + t + s;
}
const eP = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, e5 = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, tee = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return eP(e, t);
  let s;
  switch (n) {
    case "P":
      s = t.dateTime({ width: "short" });
      break;
    case "PP":
      s = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = t.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", eP(n, t)).replace("{{time}}", e5(a, t));
}, ab = {
  p: e5,
  P: tee
}, ree = /^D+$/, nee = /^Y+$/, aee = ["D", "DD", "YY", "YYYY"];
function t5(e) {
  return ree.test(e);
}
function r5(e) {
  return nee.test(e);
}
function bE(e, t, r) {
  const n = see(e, t, r);
  if (console.warn(n), aee.includes(e)) throw new RangeError(n);
}
function see(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const iee = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, oee = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, lee = /^'([^]*?)'?$/, cee = /''/g, uee = /[a-zA-Z]/;
function tP(e, t, r) {
  var u, d, f, h, p, m, g, y;
  const n = td(), a = (r == null ? void 0 : r.locale) ?? n.locale ?? JF, s = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((d = (u = r == null ? void 0 : r.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((h = (f = n.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = (r == null ? void 0 : r.weekStartsOn) ?? ((m = (p = r == null ? void 0 : r.locale) == null ? void 0 : p.options) == null ? void 0 : m.weekStartsOn) ?? n.weekStartsOn ?? ((y = (g = n.locale) == null ? void 0 : g.options) == null ? void 0 : y.weekStartsOn) ?? 0, o = At(e);
  if (!eb(o))
    throw new RangeError("Invalid time value");
  let l = t.match(oee).map((x) => {
    const w = x[0];
    if (w === "p" || w === "P") {
      const _ = ab[w];
      return _(x, a.formatLong);
    }
    return x;
  }).join("").match(iee).map((x) => {
    if (x === "''")
      return { isToken: !1, value: "'" };
    const w = x[0];
    if (w === "'")
      return { isToken: !1, value: dee(x) };
    if (QA[w])
      return { isToken: !0, value: x };
    if (w.match(uee))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: x };
  });
  a.localize.preprocessor && (l = a.localize.preprocessor(o, l));
  const c = {
    firstWeekContainsDate: s,
    weekStartsOn: i,
    locale: a
  };
  return l.map((x) => {
    if (!x.isToken) return x.value;
    const w = x.value;
    (!(r != null && r.useAdditionalWeekYearTokens) && r5(w) || !(r != null && r.useAdditionalDayOfYearTokens) && t5(w)) && bE(w, t, String(e));
    const _ = QA[w[0]];
    return _(o, w, a.localize, c);
  }).join("");
}
function dee(e) {
  const t = e.match(lee);
  return t ? t[1].replace(cee, "'") : e;
}
function rP(e) {
  return At(e).getDate();
}
function fee(e) {
  return At(e).getDay();
}
function hee(e) {
  const t = At(e), r = t.getFullYear(), n = t.getMonth(), a = Xr(e, 0);
  return a.setFullYear(r, n + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function pee() {
  return Object.assign({}, td());
}
function Po(e) {
  return At(e).getHours();
}
function mee(e) {
  let r = At(e).getDay();
  return r === 0 && (r = 7), r;
}
function Ro(e) {
  return At(e).getMinutes();
}
function us(e) {
  return At(e).getMonth();
}
function Pl(e) {
  return At(e).getSeconds();
}
function wE(e) {
  return At(e).getTime();
}
function mr(e) {
  return At(e).getFullYear();
}
function Ic(e, t) {
  const r = At(e), n = At(t);
  return r.getTime() > n.getTime();
}
function Hu(e, t) {
  const r = At(e), n = At(t);
  return +r < +n;
}
function gee(e, t) {
  const r = At(e), n = At(t);
  return +r == +n;
}
function vee(e, t) {
  const r = t instanceof Date ? Xr(t, 0) : new t(0);
  return r.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), r.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), r;
}
const yee = 10;
class n5 {
  constructor() {
    Fe(this, "subPriority", 0);
  }
  validate(t, r) {
    return !0;
  }
}
class bee extends n5 {
  constructor(t, r, n, a, s) {
    super(), this.value = t, this.validateValue = r, this.setValue = n, this.priority = a, s && (this.subPriority = s);
  }
  validate(t, r) {
    return this.validateValue(t, this.value, r);
  }
  set(t, r, n) {
    return this.setValue(t, r, this.value, n);
  }
}
class wee extends n5 {
  constructor() {
    super(...arguments);
    Fe(this, "priority", yee);
    Fe(this, "subPriority", -1);
  }
  set(r, n) {
    return n.timestampIsSet ? r : Xr(r, vee(r, Date));
  }
}
class Lr {
  run(t, r, n, a) {
    const s = this.parse(t, r, n, a);
    return s ? {
      setter: new bee(
        s.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: s.rest
    } : null;
  }
  validate(t, r, n) {
    return !0;
  }
}
class xee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 140);
    Fe(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(r, { width: "abbreviated" }) || a.era(r, { width: "narrow" });
      case "GGGGG":
        return a.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return a.era(r, { width: "wide" }) || a.era(r, { width: "abbreviated" }) || a.era(r, { width: "narrow" });
    }
  }
  set(r, n, a) {
    return n.era = a, r.setFullYear(a, 0, 1), r.setHours(0, 0, 0, 0), r;
  }
}
const $n = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, bo = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Hn(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Sn(e, t) {
  const r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function wo(e, t) {
  const r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const n = r[1] === "+" ? 1 : -1, a = r[2] ? parseInt(r[2], 10) : 0, s = r[3] ? parseInt(r[3], 10) : 0, i = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: n * (a * Dw + s * Iw + i * hZ),
    rest: t.slice(r[0].length)
  };
}
function a5(e) {
  return Sn($n.anyDigitsSigned, e);
}
function In(e, t) {
  switch (e) {
    case 1:
      return Sn($n.singleDigit, t);
    case 2:
      return Sn($n.twoDigits, t);
    case 3:
      return Sn($n.threeDigits, t);
    case 4:
      return Sn($n.fourDigits, t);
    default:
      return Sn(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function sb(e, t) {
  switch (e) {
    case 1:
      return Sn($n.singleDigitSigned, t);
    case 2:
      return Sn($n.twoDigitsSigned, t);
    case 3:
      return Sn($n.threeDigitsSigned, t);
    case 4:
      return Sn($n.fourDigitsSigned, t);
    default:
      return Sn(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function aC(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function s5(e, t) {
  const r = t > 0, n = r ? t : 1 - t;
  let a;
  if (n <= 50)
    a = e || 100;
  else {
    const s = n + 50, i = Math.trunc(s / 100) * 100, o = e >= s % 100;
    a = e + i - (o ? 100 : 0);
  }
  return r ? a : 1 - a;
}
function i5(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class _ee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 130);
    Fe(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(r, n, a) {
    const s = (i) => ({
      year: i,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return Hn(In(4, r), s);
      case "yo":
        return Hn(
          a.ordinalNumber(r, {
            unit: "year"
          }),
          s
        );
      default:
        return Hn(In(n.length, r), s);
    }
  }
  validate(r, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(r, n, a) {
    const s = r.getFullYear();
    if (a.isTwoDigitYear) {
      const o = s5(
        a.year,
        s
      );
      return r.setFullYear(o, 0, 1), r.setHours(0, 0, 0, 0), r;
    }
    const i = !("era" in n) || n.era === 1 ? a.year : 1 - a.year;
    return r.setFullYear(i, 0, 1), r.setHours(0, 0, 0, 0), r;
  }
}
class See extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 130);
    Fe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    const s = (i) => ({
      year: i,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return Hn(In(4, r), s);
      case "Yo":
        return Hn(
          a.ordinalNumber(r, {
            unit: "year"
          }),
          s
        );
      default:
        return Hn(In(n.length, r), s);
    }
  }
  validate(r, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(r, n, a, s) {
    const i = nC(r, s);
    if (a.isTwoDigitYear) {
      const l = s5(
        a.year,
        i
      );
      return r.setFullYear(
        l,
        0,
        s.firstWeekContainsDate
      ), r.setHours(0, 0, 0, 0), Fl(r, s);
    }
    const o = !("era" in n) || n.era === 1 ? a.year : 1 - a.year;
    return r.setFullYear(o, 0, s.firstWeekContainsDate), r.setHours(0, 0, 0, 0), Fl(r, s);
  }
}
class Eee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 130);
    Fe(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n) {
    return sb(n === "R" ? 4 : n.length, r);
  }
  set(r, n, a) {
    const s = Xr(r, 0);
    return s.setFullYear(a, 0, 4), s.setHours(0, 0, 0, 0), th(s);
  }
}
class Tee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 130);
    Fe(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(r, n) {
    return sb(n === "u" ? 4 : n.length, r);
  }
  set(r, n, a) {
    return r.setFullYear(a, 0, 1), r.setHours(0, 0, 0, 0), r;
  }
}
class Cee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 120);
    Fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "Q":
      case "QQ":
        return In(n.length, r);
      case "Qo":
        return a.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return a.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(r, {
          width: "wide",
          context: "formatting"
        }) || a.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 4;
  }
  set(r, n, a) {
    return r.setMonth((a - 1) * 3, 1), r.setHours(0, 0, 0, 0), r;
  }
}
class kee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 120);
    Fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "q":
      case "qq":
        return In(n.length, r);
      case "qo":
        return a.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return a.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(r, {
          width: "wide",
          context: "standalone"
        }) || a.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 4;
  }
  set(r, n, a) {
    return r.setMonth((a - 1) * 3, 1), r.setHours(0, 0, 0, 0), r;
  }
}
class Oee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    Fe(this, "priority", 110);
  }
  parse(r, n, a) {
    const s = (i) => i - 1;
    switch (n) {
      case "M":
        return Hn(
          Sn($n.month, r),
          s
        );
      case "MM":
        return Hn(In(2, r), s);
      case "Mo":
        return Hn(
          a.ordinalNumber(r, {
            unit: "month"
          }),
          s
        );
      case "MMM":
        return a.month(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(r, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return a.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(r, { width: "wide", context: "formatting" }) || a.month(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(r, { width: "narrow", context: "formatting" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 11;
  }
  set(r, n, a) {
    return r.setMonth(a, 1), r.setHours(0, 0, 0, 0), r;
  }
}
class Aee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 110);
    Fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    const s = (i) => i - 1;
    switch (n) {
      case "L":
        return Hn(
          Sn($n.month, r),
          s
        );
      case "LL":
        return Hn(In(2, r), s);
      case "Lo":
        return Hn(
          a.ordinalNumber(r, {
            unit: "month"
          }),
          s
        );
      case "LLL":
        return a.month(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(r, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return a.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(r, { width: "wide", context: "standalone" }) || a.month(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(r, { width: "narrow", context: "standalone" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 11;
  }
  set(r, n, a) {
    return r.setMonth(a, 1), r.setHours(0, 0, 0, 0), r;
  }
}
function Pee(e, t, r) {
  const n = At(e), a = ZF(n, r) - t;
  return n.setDate(n.getDate() - a * 7), n;
}
class Ree extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 100);
    Fe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "w":
        return Sn($n.week, r);
      case "wo":
        return a.ordinalNumber(r, { unit: "week" });
      default:
        return In(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 53;
  }
  set(r, n, a, s) {
    return Fl(Pee(r, a, s), s);
  }
}
function Iee(e, t) {
  const r = At(e), n = rC(r) - t;
  return r.setDate(r.getDate() - n * 7), r;
}
class Dee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 100);
    Fe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "I":
        return Sn($n.week, r);
      case "Io":
        return a.ordinalNumber(r, { unit: "week" });
      default:
        return In(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 53;
  }
  set(r, n, a) {
    return th(Iee(r, a));
  }
}
const Nee = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Mee = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Lee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 90);
    Fe(this, "subPriority", 1);
    Fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "d":
        return Sn($n.date, r);
      case "do":
        return a.ordinalNumber(r, { unit: "date" });
      default:
        return In(n.length, r);
    }
  }
  validate(r, n) {
    const a = r.getFullYear(), s = i5(a), i = r.getMonth();
    return s ? n >= 1 && n <= Mee[i] : n >= 1 && n <= Nee[i];
  }
  set(r, n, a) {
    return r.setDate(a), r.setHours(0, 0, 0, 0), r;
  }
}
class jee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 90);
    Fe(this, "subpriority", 1);
    Fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "D":
      case "DD":
        return Sn($n.dayOfYear, r);
      case "Do":
        return a.ordinalNumber(r, { unit: "date" });
      default:
        return In(n.length, r);
    }
  }
  validate(r, n) {
    const a = r.getFullYear();
    return i5(a) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(r, n, a) {
    return r.setMonth(0, a), r.setHours(0, 0, 0, 0), r;
  }
}
function sC(e, t, r) {
  var d, f, h, p;
  const n = td(), a = (r == null ? void 0 : r.weekStartsOn) ?? ((f = (d = r == null ? void 0 : r.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? n.weekStartsOn ?? ((p = (h = n.locale) == null ? void 0 : h.options) == null ? void 0 : p.weekStartsOn) ?? 0, s = At(e), i = s.getDay(), l = (t % 7 + 7) % 7, c = 7 - a, u = t < 0 || t > 6 ? t - (i + c) % 7 : (l + c) % 7 - (i + c) % 7;
  return Fi(s, u);
}
class Fee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 90);
    Fe(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return a.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return a.day(r, { width: "wide", context: "formatting" }) || a.day(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 6;
  }
  set(r, n, a, s) {
    return r = sC(r, a, s), r.setHours(0, 0, 0, 0), r;
  }
}
class Bee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 90);
    Fe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a, s) {
    const i = (o) => {
      const l = Math.floor((o - 1) / 7) * 7;
      return (o + s.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      case "e":
      case "ee":
        return Hn(In(n.length, r), i);
      case "eo":
        return Hn(
          a.ordinalNumber(r, {
            unit: "day"
          }),
          i
        );
      case "eee":
        return a.day(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
      case "eeeee":
        return a.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return a.day(r, { width: "wide", context: "formatting" }) || a.day(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 6;
  }
  set(r, n, a, s) {
    return r = sC(r, a, s), r.setHours(0, 0, 0, 0), r;
  }
}
class Uee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 90);
    Fe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(r, n, a, s) {
    const i = (o) => {
      const l = Math.floor((o - 1) / 7) * 7;
      return (o + s.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      case "c":
      case "cc":
        return Hn(In(n.length, r), i);
      case "co":
        return Hn(
          a.ordinalNumber(r, {
            unit: "day"
          }),
          i
        );
      case "ccc":
        return a.day(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(r, { width: "short", context: "standalone" }) || a.day(r, { width: "narrow", context: "standalone" });
      case "ccccc":
        return a.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(r, { width: "short", context: "standalone" }) || a.day(r, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return a.day(r, { width: "wide", context: "standalone" }) || a.day(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(r, { width: "short", context: "standalone" }) || a.day(r, { width: "narrow", context: "standalone" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 6;
  }
  set(r, n, a, s) {
    return r = sC(r, a, s), r.setHours(0, 0, 0, 0), r;
  }
}
function Vee(e, t) {
  const r = At(e), n = mee(r), a = t - n;
  return Fi(r, a);
}
class $ee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 90);
    Fe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    const s = (i) => i === 0 ? 7 : i;
    switch (n) {
      case "i":
      case "ii":
        return In(n.length, r);
      case "io":
        return a.ordinalNumber(r, { unit: "day" });
      case "iii":
        return Hn(
          a.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(r, {
            width: "short",
            context: "formatting"
          }) || a.day(r, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiiii":
        return Hn(
          a.day(r, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiiiii":
        return Hn(
          a.day(r, {
            width: "short",
            context: "formatting"
          }) || a.day(r, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiii":
      default:
        return Hn(
          a.day(r, {
            width: "wide",
            context: "formatting"
          }) || a.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(r, {
            width: "short",
            context: "formatting"
          }) || a.day(r, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 7;
  }
  set(r, n, a) {
    return r = Vee(r, a), r.setHours(0, 0, 0, 0), r;
  }
}
class Hee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 80);
    Fe(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(r, n, a) {
    return r.setHours(aC(a), 0, 0, 0), r;
  }
}
class Wee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 80);
    Fe(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(r, n, a) {
    return r.setHours(aC(a), 0, 0, 0), r;
  }
}
class zee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 80);
    Fe(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(r, n, a) {
    return r.setHours(aC(a), 0, 0, 0), r;
  }
}
class Kee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 70);
    Fe(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "h":
        return Sn($n.hour12h, r);
      case "ho":
        return a.ordinalNumber(r, { unit: "hour" });
      default:
        return In(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 12;
  }
  set(r, n, a) {
    const s = r.getHours() >= 12;
    return s && a < 12 ? r.setHours(a + 12, 0, 0, 0) : !s && a === 12 ? r.setHours(0, 0, 0, 0) : r.setHours(a, 0, 0, 0), r;
  }
}
class qee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 70);
    Fe(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "H":
        return Sn($n.hour23h, r);
      case "Ho":
        return a.ordinalNumber(r, { unit: "hour" });
      default:
        return In(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 23;
  }
  set(r, n, a) {
    return r.setHours(a, 0, 0, 0), r;
  }
}
class Gee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 70);
    Fe(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "K":
        return Sn($n.hour11h, r);
      case "Ko":
        return a.ordinalNumber(r, { unit: "hour" });
      default:
        return In(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 11;
  }
  set(r, n, a) {
    return r.getHours() >= 12 && a < 12 ? r.setHours(a + 12, 0, 0, 0) : r.setHours(a, 0, 0, 0), r;
  }
}
class Yee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 70);
    Fe(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "k":
        return Sn($n.hour24h, r);
      case "ko":
        return a.ordinalNumber(r, { unit: "hour" });
      default:
        return In(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 24;
  }
  set(r, n, a) {
    const s = a <= 24 ? a % 24 : a;
    return r.setHours(s, 0, 0, 0), r;
  }
}
class Xee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 60);
    Fe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "m":
        return Sn($n.minute, r);
      case "mo":
        return a.ordinalNumber(r, { unit: "minute" });
      default:
        return In(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 59;
  }
  set(r, n, a) {
    return r.setMinutes(a, 0, 0), r;
  }
}
class Qee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 50);
    Fe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "s":
        return Sn($n.second, r);
      case "so":
        return a.ordinalNumber(r, { unit: "second" });
      default:
        return In(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 59;
  }
  set(r, n, a) {
    return r.setSeconds(a, 0), r;
  }
}
class Jee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 30);
    Fe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(r, n) {
    const a = (s) => Math.trunc(s * Math.pow(10, -n.length + 3));
    return Hn(In(n.length, r), a);
  }
  set(r, n, a) {
    return r.setMilliseconds(a), r;
  }
}
class Zee extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 10);
    Fe(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(r, n) {
    switch (n) {
      case "X":
        return wo(
          bo.basicOptionalMinutes,
          r
        );
      case "XX":
        return wo(bo.basic, r);
      case "XXXX":
        return wo(
          bo.basicOptionalSeconds,
          r
        );
      case "XXXXX":
        return wo(
          bo.extendedOptionalSeconds,
          r
        );
      case "XXX":
      default:
        return wo(bo.extended, r);
    }
  }
  set(r, n, a) {
    return n.timestampIsSet ? r : Xr(
      r,
      r.getTime() - Jy(r) - a
    );
  }
}
class ete extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 10);
    Fe(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(r, n) {
    switch (n) {
      case "x":
        return wo(
          bo.basicOptionalMinutes,
          r
        );
      case "xx":
        return wo(bo.basic, r);
      case "xxxx":
        return wo(
          bo.basicOptionalSeconds,
          r
        );
      case "xxxxx":
        return wo(
          bo.extendedOptionalSeconds,
          r
        );
      case "xxx":
      default:
        return wo(bo.extended, r);
    }
  }
  set(r, n, a) {
    return n.timestampIsSet ? r : Xr(
      r,
      r.getTime() - Jy(r) - a
    );
  }
}
class tte extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 40);
    Fe(this, "incompatibleTokens", "*");
  }
  parse(r) {
    return a5(r);
  }
  set(r, n, a) {
    return [Xr(r, a * 1e3), { timestampIsSet: !0 }];
  }
}
class rte extends Lr {
  constructor() {
    super(...arguments);
    Fe(this, "priority", 20);
    Fe(this, "incompatibleTokens", "*");
  }
  parse(r) {
    return a5(r);
  }
  set(r, n, a) {
    return [Xr(r, a), { timestampIsSet: !0 }];
  }
}
const nte = {
  G: new xee(),
  y: new _ee(),
  Y: new See(),
  R: new Eee(),
  u: new Tee(),
  Q: new Cee(),
  q: new kee(),
  M: new Oee(),
  L: new Aee(),
  w: new Ree(),
  I: new Dee(),
  d: new Lee(),
  D: new jee(),
  E: new Fee(),
  e: new Bee(),
  c: new Uee(),
  i: new $ee(),
  a: new Hee(),
  b: new Wee(),
  B: new zee(),
  h: new Kee(),
  H: new qee(),
  K: new Gee(),
  k: new Yee(),
  m: new Xee(),
  s: new Qee(),
  S: new Jee(),
  X: new Zee(),
  x: new ete(),
  t: new tte(),
  T: new rte()
}, ate = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ste = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ite = /^'([^]*?)'?$/, ote = /''/g, lte = /\S/, cte = /[a-zA-Z]/;
function U1(e, t, r, n) {
  var m, g, y, x, w, _, S, C;
  const a = pee(), s = (n == null ? void 0 : n.locale) ?? a.locale ?? JF, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((g = (m = n == null ? void 0 : n.locale) == null ? void 0 : m.options) == null ? void 0 : g.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((x = (y = a.locale) == null ? void 0 : y.options) == null ? void 0 : x.firstWeekContainsDate) ?? 1, o = (n == null ? void 0 : n.weekStartsOn) ?? ((_ = (w = n == null ? void 0 : n.locale) == null ? void 0 : w.options) == null ? void 0 : _.weekStartsOn) ?? a.weekStartsOn ?? ((C = (S = a.locale) == null ? void 0 : S.options) == null ? void 0 : C.weekStartsOn) ?? 0;
  if (t === "")
    return e === "" ? At(r) : Xr(r, NaN);
  const l = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: s
  }, c = [new wee()], u = t.match(ste).map((E) => {
    const O = E[0];
    if (O in ab) {
      const k = ab[O];
      return k(E, s.formatLong);
    }
    return E;
  }).join("").match(ate), d = [];
  for (let E of u) {
    !(n != null && n.useAdditionalWeekYearTokens) && r5(E) && bE(E, t, e), !(n != null && n.useAdditionalDayOfYearTokens) && t5(E) && bE(E, t, e);
    const O = E[0], k = nte[O];
    if (k) {
      const { incompatibleTokens: A } = k;
      if (Array.isArray(A)) {
        const D = d.find(
          (N) => A.includes(N.token) || N.token === O
        );
        if (D)
          throw new RangeError(
            `The format string mustn't contain \`${D.fullToken}\` and \`${E}\` at the same time`
          );
      } else if (k.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${E}\` and any other token at the same time`
        );
      d.push({ token: O, fullToken: E });
      const P = k.run(
        e,
        E,
        s.match,
        l
      );
      if (!P)
        return Xr(r, NaN);
      c.push(P.setter), e = P.rest;
    } else {
      if (O.match(cte))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + O + "`"
        );
      if (E === "''" ? E = "'" : O === "'" && (E = ute(E)), e.indexOf(E) === 0)
        e = e.slice(E.length);
      else
        return Xr(r, NaN);
    }
  }
  if (e.length > 0 && lte.test(e))
    return Xr(r, NaN);
  const f = c.map((E) => E.priority).sort((E, O) => O - E).filter((E, O, k) => k.indexOf(E) === O).map(
    (E) => c.filter((O) => O.priority === E).sort((O, k) => k.subPriority - O.subPriority)
  ).map((E) => E[0]);
  let h = At(r);
  if (isNaN(h.getTime()))
    return Xr(r, NaN);
  const p = {};
  for (const E of f) {
    if (!E.validate(h, l))
      return Xr(r, NaN);
    const O = E.set(h, p, l);
    Array.isArray(O) ? (h = O[0], Object.assign(p, O[1])) : h = O;
  }
  return Xr(r, h);
}
function ute(e) {
  return e.match(ite)[1].replace(ote, "'");
}
function dte(e, t) {
  const r = At(e), n = At(t);
  return r.getFullYear() === n.getFullYear() && r.getMonth() === n.getMonth();
}
function fte(e, t) {
  const r = yE(e), n = yE(t);
  return +r == +n;
}
function hte(e, t) {
  const r = At(e), n = At(t);
  return r.getFullYear() === n.getFullYear();
}
function Ym(e, t) {
  const r = +At(e), [n, a] = [
    +At(t.start),
    +At(t.end)
  ].sort((s, i) => s - i);
  return r >= n && r <= a;
}
function pte(e, t) {
  return Fi(e, -1);
}
function mte(e, t) {
  const n = bte(e);
  let a;
  if (n.date) {
    const l = wte(n.date, 2);
    a = xte(l.restDateString, l.year);
  }
  if (!a || isNaN(a.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const s = a.getTime();
  let i = 0, o;
  if (n.time && (i = _te(n.time), isNaN(i)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (o = Ste(n.timezone), isNaN(o))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const l = new Date(s + i), c = /* @__PURE__ */ new Date(0);
    return c.setFullYear(
      l.getUTCFullYear(),
      l.getUTCMonth(),
      l.getUTCDate()
    ), c.setHours(
      l.getUTCHours(),
      l.getUTCMinutes(),
      l.getUTCSeconds(),
      l.getUTCMilliseconds()
    ), c;
  }
  return new Date(s + i + o);
}
const zv = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, gte = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, vte = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, yte = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function bte(e) {
  const t = {}, r = e.split(zv.dateTimeDelimiter);
  let n;
  if (r.length > 2)
    return t;
  if (/:/.test(r[0]) ? n = r[0] : (t.date = r[0], n = r[1], zv.timeZoneDelimiter.test(t.date) && (t.date = e.split(zv.timeZoneDelimiter)[0], n = e.substr(
    t.date.length,
    e.length
  ))), n) {
    const a = zv.timezone.exec(n);
    a ? (t.time = n.replace(a[1], ""), t.timezone = a[1]) : t.time = n;
  }
  return t;
}
function wte(e, t) {
  const r = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), n = e.match(r);
  if (!n) return { year: NaN, restDateString: "" };
  const a = n[1] ? parseInt(n[1]) : null, s = n[2] ? parseInt(n[2]) : null;
  return {
    year: s === null ? a : s * 100,
    restDateString: e.slice((n[1] || n[2]).length)
  };
}
function xte(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const r = e.match(gte);
  if (!r) return /* @__PURE__ */ new Date(NaN);
  const n = !!r[4], a = up(r[1]), s = up(r[2]) - 1, i = up(r[3]), o = up(r[4]), l = up(r[5]) - 1;
  if (n)
    return Ote(t, o, l) ? Ete(t, o, l) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !Cte(t, s, i) || !kte(t, a) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, s, Math.max(a, i)), c);
  }
}
function up(e) {
  return e ? parseInt(e) : 1;
}
function _te(e) {
  const t = e.match(vte);
  if (!t) return NaN;
  const r = V1(t[1]), n = V1(t[2]), a = V1(t[3]);
  return Ate(r, n, a) ? r * Dw + n * Iw + a * 1e3 : NaN;
}
function V1(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function Ste(e) {
  if (e === "Z") return 0;
  const t = e.match(yte);
  if (!t) return 0;
  const r = t[1] === "+" ? -1 : 1, n = parseInt(t[2]), a = t[3] && parseInt(t[3]) || 0;
  return Pte(n, a) ? r * (n * Dw + a * Iw) : NaN;
}
function Ete(e, t, r) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const a = n.getUTCDay() || 7, s = (t - 1) * 7 + r + 1 - a;
  return n.setUTCDate(n.getUTCDate() + s), n;
}
const Tte = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function o5(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Cte(e, t, r) {
  return t >= 0 && t <= 11 && r >= 1 && r <= (Tte[t] || (o5(e) ? 29 : 28));
}
function kte(e, t) {
  return t >= 1 && t <= (o5(e) ? 366 : 365);
}
function Ote(e, t, r) {
  return t >= 1 && t <= 53 && r >= 0 && r <= 6;
}
function Ate(e, t, r) {
  return e === 24 ? t === 0 && r === 0 : r >= 0 && r < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function Pte(e, t) {
  return t >= 0 && t <= 59;
}
function js(e, t) {
  const r = At(e), n = r.getFullYear(), a = r.getDate(), s = Xr(e, 0);
  s.setFullYear(n, t, 15), s.setHours(0, 0, 0, 0);
  const i = hee(s);
  return r.setMonth(t, Math.min(a, i)), r;
}
function Rte(e, t) {
  let r = At(e);
  return isNaN(+r) ? Xr(e, NaN) : (t.year != null && r.setFullYear(t.year), t.month != null && (r = js(r, t.month)), t.date != null && r.setDate(t.date), t.hours != null && r.setHours(t.hours), t.minutes != null && r.setMinutes(t.minutes), t.seconds != null && r.setSeconds(t.seconds), t.milliseconds != null && r.setMilliseconds(t.milliseconds), r);
}
function by(e, t) {
  const r = At(e);
  return r.setHours(t), r;
}
function wy(e, t) {
  const r = At(e);
  return r.setMinutes(t), r;
}
function cf(e, t) {
  const r = At(e), n = Math.trunc(r.getMonth() / 3) + 1, a = t - n;
  return js(r, r.getMonth() + a * 3);
}
function xy(e, t) {
  const r = At(e);
  return r.setSeconds(t), r;
}
function go(e, t) {
  const r = At(e);
  return isNaN(+r) ? Xr(e, NaN) : (r.setFullYear(t), r);
}
function Iu(e, t) {
  return $i(e, -t);
}
function l5(e, t) {
  return tC(e, -1);
}
function nP(e, t) {
  return Zy(e, -1);
}
function nh(e, t) {
  return Ol(e, -t);
}
function Mw() {
  return typeof window < "u";
}
function kh(e) {
  return c5(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ws(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function $o(e) {
  var t;
  return (t = (c5(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function c5(e) {
  return Mw() ? e instanceof Node || e instanceof Ws(e).Node : !1;
}
function Ka(e) {
  return Mw() ? e instanceof Element || e instanceof Ws(e).Element : !1;
}
function Bo(e) {
  return Mw() ? e instanceof HTMLElement || e instanceof Ws(e).HTMLElement : !1;
}
function aP(e) {
  return !Mw() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ws(e).ShadowRoot;
}
function Tg(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: a
  } = hi(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(a);
}
function Ite(e) {
  return ["table", "td", "th"].includes(kh(e));
}
function Lw(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function iC(e) {
  const t = oC(), r = Ka(e) ? hi(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function Dte(e) {
  let t = Dc(e);
  for (; Bo(t) && !ah(t); ) {
    if (iC(t))
      return t;
    if (Lw(t))
      return null;
    t = Dc(t);
  }
  return null;
}
function oC() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ah(e) {
  return ["html", "body", "#document"].includes(kh(e));
}
function hi(e) {
  return Ws(e).getComputedStyle(e);
}
function jw(e) {
  return Ka(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Dc(e) {
  if (kh(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    aP(e) && e.host || // Fallback.
    $o(e)
  );
  return aP(t) ? t.host : t;
}
function u5(e) {
  const t = Dc(e);
  return ah(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Bo(t) && Tg(t) ? t : u5(t);
}
function Xm(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const a = u5(e), s = a === ((n = e.ownerDocument) == null ? void 0 : n.body), i = Ws(a);
  if (s) {
    const o = xE(i);
    return t.concat(i, i.visualViewport || [], Tg(a) ? a : [], o && r ? Xm(o) : []);
  }
  return t.concat(a, Xm(a, [], r));
}
function xE(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
const sh = Math.min, Du = Math.max, ib = Math.round, Kv = Math.floor, Io = (e) => ({
  x: e,
  y: e
}), Nte = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Mte = {
  start: "end",
  end: "start"
};
function Lte(e, t, r) {
  return Du(e, sh(t, r));
}
function Fw(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ih(e) {
  return e.split("-")[0];
}
function Cg(e) {
  return e.split("-")[1];
}
function jte(e) {
  return e === "x" ? "y" : "x";
}
function lC(e) {
  return e === "y" ? "height" : "width";
}
function Qm(e) {
  return ["top", "bottom"].includes(ih(e)) ? "y" : "x";
}
function cC(e) {
  return jte(Qm(e));
}
function Fte(e, t, r) {
  r === void 0 && (r = !1);
  const n = Cg(e), a = cC(e), s = lC(a);
  let i = a === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (i = ob(i)), [i, ob(i)];
}
function Bte(e) {
  const t = ob(e);
  return [_E(e), t, _E(t)];
}
function _E(e) {
  return e.replace(/start|end/g, (t) => Mte[t]);
}
function Ute(e, t, r) {
  const n = ["left", "right"], a = ["right", "left"], s = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? a : n : t ? n : a;
    case "left":
    case "right":
      return t ? s : i;
    default:
      return [];
  }
}
function Vte(e, t, r, n) {
  const a = Cg(e);
  let s = Ute(ih(e), r === "start", n);
  return a && (s = s.map((i) => i + "-" + a), t && (s = s.concat(s.map(_E)))), s;
}
function ob(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Nte[t]);
}
function $te(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function d5(e) {
  return typeof e != "number" ? $te(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function lb(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: a
  } = e;
  return {
    width: n,
    height: a,
    top: r,
    left: t,
    right: t + n,
    bottom: r + a,
    x: t,
    y: r
  };
}
function sP(e, t, r) {
  let {
    reference: n,
    floating: a
  } = e;
  const s = Qm(t), i = cC(t), o = lC(i), l = ih(t), c = s === "y", u = n.x + n.width / 2 - a.width / 2, d = n.y + n.height / 2 - a.height / 2, f = n[o] / 2 - a[o] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: n.y - a.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      h = {
        x: n.x + n.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: n.x - a.width,
        y: d
      };
      break;
    default:
      h = {
        x: n.x,
        y: n.y
      };
  }
  switch (Cg(t)) {
    case "start":
      h[i] -= f * (r && c ? -1 : 1);
      break;
    case "end":
      h[i] += f * (r && c ? -1 : 1);
      break;
  }
  return h;
}
const Hte = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: a = "absolute",
    middleware: s = [],
    platform: i
  } = r, o = s.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: u,
    y: d
  } = sP(c, n, l), f = n, h = {}, p = 0;
  for (let m = 0; m < o.length; m++) {
    const {
      name: g,
      fn: y
    } = o[m], {
      x,
      y: w,
      data: _,
      reset: S
    } = await y({
      x: u,
      y: d,
      initialPlacement: n,
      placement: f,
      strategy: a,
      middlewareData: h,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = x ?? u, d = w ?? d, h = {
      ...h,
      [g]: {
        ...h[g],
        ..._
      }
    }, S && p <= 50 && (p++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (c = S.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : S.rects), {
      x: u,
      y: d
    } = sP(c, f, l)), m = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: a,
    middlewareData: h
  };
};
async function Wte(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: a,
    platform: s,
    rects: i,
    elements: o,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Fw(t, e), p = d5(h), g = o[f ? d === "floating" ? "reference" : "floating" : d], y = lb(await s.getClippingRect({
    element: (r = await (s.isElement == null ? void 0 : s.isElement(g))) == null || r ? g : g.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(o.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), x = d === "floating" ? {
    x: n,
    y: a,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, w = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(o.floating)), _ = await (s.isElement == null ? void 0 : s.isElement(w)) ? await (s.getScale == null ? void 0 : s.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = lb(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: x,
    offsetParent: w,
    strategy: l
  }) : x);
  return {
    top: (y.top - S.top + p.top) / _.y,
    bottom: (S.bottom - y.bottom + p.bottom) / _.y,
    left: (y.left - S.left + p.left) / _.x,
    right: (S.right - y.right + p.right) / _.x
  };
}
const zte = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: a,
      rects: s,
      platform: i,
      elements: o,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = Fw(e, t) || {};
    if (c == null)
      return {};
    const d = d5(u), f = {
      x: r,
      y: n
    }, h = cC(a), p = lC(h), m = await i.getDimensions(c), g = h === "y", y = g ? "top" : "left", x = g ? "bottom" : "right", w = g ? "clientHeight" : "clientWidth", _ = s.reference[p] + s.reference[h] - f[h] - s.floating[p], S = f[h] - s.reference[h], C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let E = C ? C[w] : 0;
    (!E || !await (i.isElement == null ? void 0 : i.isElement(C))) && (E = o.floating[w] || s.floating[p]);
    const O = _ / 2 - S / 2, k = E / 2 - m[p] / 2 - 1, A = sh(d[y], k), P = sh(d[x], k), D = A, N = E - m[p] - P, z = E / 2 - m[p] / 2 + O, G = Lte(D, z, N), Y = !l.arrow && Cg(a) != null && z !== G && s.reference[p] / 2 - (z < D ? A : P) - m[p] / 2 < 0, te = Y ? z < D ? z - D : z - N : 0;
    return {
      [h]: f[h] + te,
      data: {
        [h]: G,
        centerOffset: z - G - te,
        ...Y && {
          alignmentOffset: te
        }
      },
      reset: Y
    };
  }
}), Kte = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: a,
        middlewareData: s,
        rects: i,
        initialPlacement: o,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: m = !0,
        ...g
      } = Fw(e, t);
      if ((r = s.arrow) != null && r.alignmentOffset)
        return {};
      const y = ih(a), x = Qm(o), w = ih(o) === o, _ = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = f || (w || !m ? [ob(o)] : Bte(o)), C = p !== "none";
      !f && C && S.push(...Vte(o, m, p, _));
      const E = [o, ...S], O = await Wte(t, g), k = [];
      let A = ((n = s.flip) == null ? void 0 : n.overflows) || [];
      if (u && k.push(O[y]), d) {
        const z = Fte(a, i, _);
        k.push(O[z[0]], O[z[1]]);
      }
      if (A = [...A, {
        placement: a,
        overflows: k
      }], !k.every((z) => z <= 0)) {
        var P, D;
        const z = (((P = s.flip) == null ? void 0 : P.index) || 0) + 1, G = E[z];
        if (G)
          return {
            data: {
              index: z,
              overflows: A
            },
            reset: {
              placement: G
            }
          };
        let Y = (D = A.filter((te) => te.overflows[0] <= 0).sort((te, ae) => te.overflows[1] - ae.overflows[1])[0]) == null ? void 0 : D.placement;
        if (!Y)
          switch (h) {
            case "bestFit": {
              var N;
              const te = (N = A.filter((ae) => {
                if (C) {
                  const ne = Qm(ae.placement);
                  return ne === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ne === "y";
                }
                return !0;
              }).map((ae) => [ae.placement, ae.overflows.filter((ne) => ne > 0).reduce((ne, ue) => ne + ue, 0)]).sort((ae, ne) => ae[1] - ne[1])[0]) == null ? void 0 : N[0];
              te && (Y = te);
              break;
            }
            case "initialPlacement":
              Y = o;
              break;
          }
        if (a !== Y)
          return {
            reset: {
              placement: Y
            }
          };
      }
      return {};
    }
  };
};
async function qte(e, t) {
  const {
    placement: r,
    platform: n,
    elements: a
  } = e, s = await (n.isRTL == null ? void 0 : n.isRTL(a.floating)), i = ih(r), o = Cg(r), l = Qm(r) === "y", c = ["left", "top"].includes(i) ? -1 : 1, u = s && l ? -1 : 1, d = Fw(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return o && typeof p == "number" && (h = o === "end" ? p * -1 : p), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const Gte = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: a,
        y: s,
        placement: i,
        middlewareData: o
      } = t, l = await qte(t, e);
      return i === ((r = o.offset) == null ? void 0 : r.placement) && (n = o.arrow) != null && n.alignmentOffset ? {} : {
        x: a + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
};
function f5(e) {
  const t = hi(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const a = Bo(e), s = a ? e.offsetWidth : r, i = a ? e.offsetHeight : n, o = ib(r) !== s || ib(n) !== i;
  return o && (r = s, n = i), {
    width: r,
    height: n,
    $: o
  };
}
function uC(e) {
  return Ka(e) ? e : e.contextElement;
}
function Mf(e) {
  const t = uC(e);
  if (!Bo(t))
    return Io(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: a,
    $: s
  } = f5(t);
  let i = (s ? ib(r.width) : r.width) / n, o = (s ? ib(r.height) : r.height) / a;
  return (!i || !Number.isFinite(i)) && (i = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: i,
    y: o
  };
}
const Yte = /* @__PURE__ */ Io(0);
function h5(e) {
  const t = Ws(e);
  return !oC() || !t.visualViewport ? Yte : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Xte(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== Ws(e) ? !1 : t;
}
function Wu(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const a = e.getBoundingClientRect(), s = uC(e);
  let i = Io(1);
  t && (n ? Ka(n) && (i = Mf(n)) : i = Mf(e));
  const o = Xte(s, r, n) ? h5(s) : Io(0);
  let l = (a.left + o.x) / i.x, c = (a.top + o.y) / i.y, u = a.width / i.x, d = a.height / i.y;
  if (s) {
    const f = Ws(s), h = n && Ka(n) ? Ws(n) : n;
    let p = f, m = xE(p);
    for (; m && n && h !== p; ) {
      const g = Mf(m), y = m.getBoundingClientRect(), x = hi(m), w = y.left + (m.clientLeft + parseFloat(x.paddingLeft)) * g.x, _ = y.top + (m.clientTop + parseFloat(x.paddingTop)) * g.y;
      l *= g.x, c *= g.y, u *= g.x, d *= g.y, l += w, c += _, p = Ws(m), m = xE(p);
    }
  }
  return lb({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function dC(e, t) {
  const r = jw(e).scrollLeft;
  return t ? t.left + r : Wu($o(e)).left + r;
}
function p5(e, t, r) {
  r === void 0 && (r = !1);
  const n = e.getBoundingClientRect(), a = n.left + t.scrollLeft - (r ? 0 : (
    // RTL <body> scrollbar.
    dC(e, n)
  )), s = n.top + t.scrollTop;
  return {
    x: a,
    y: s
  };
}
function Qte(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: a
  } = e;
  const s = a === "fixed", i = $o(n), o = t ? Lw(t.floating) : !1;
  if (n === i || o && s)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Io(1);
  const u = Io(0), d = Bo(n);
  if ((d || !d && !s) && ((kh(n) !== "body" || Tg(i)) && (l = jw(n)), Bo(n))) {
    const h = Wu(n);
    c = Mf(n), u.x = h.x + n.clientLeft, u.y = h.y + n.clientTop;
  }
  const f = i && !d && !s ? p5(i, l, !0) : Io(0);
  return {
    width: r.width * c.x,
    height: r.height * c.y,
    x: r.x * c.x - l.scrollLeft * c.x + u.x + f.x,
    y: r.y * c.y - l.scrollTop * c.y + u.y + f.y
  };
}
function Jte(e) {
  return Array.from(e.getClientRects());
}
function Zte(e) {
  const t = $o(e), r = jw(e), n = e.ownerDocument.body, a = Du(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), s = Du(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -r.scrollLeft + dC(e);
  const o = -r.scrollTop;
  return hi(n).direction === "rtl" && (i += Du(t.clientWidth, n.clientWidth) - a), {
    width: a,
    height: s,
    x: i,
    y: o
  };
}
function ere(e, t) {
  const r = Ws(e), n = $o(e), a = r.visualViewport;
  let s = n.clientWidth, i = n.clientHeight, o = 0, l = 0;
  if (a) {
    s = a.width, i = a.height;
    const c = oC();
    (!c || c && t === "fixed") && (o = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: s,
    height: i,
    x: o,
    y: l
  };
}
function tre(e, t) {
  const r = Wu(e, !0, t === "fixed"), n = r.top + e.clientTop, a = r.left + e.clientLeft, s = Bo(e) ? Mf(e) : Io(1), i = e.clientWidth * s.x, o = e.clientHeight * s.y, l = a * s.x, c = n * s.y;
  return {
    width: i,
    height: o,
    x: l,
    y: c
  };
}
function iP(e, t, r) {
  let n;
  if (t === "viewport")
    n = ere(e, r);
  else if (t === "document")
    n = Zte($o(e));
  else if (Ka(t))
    n = tre(t, r);
  else {
    const a = h5(e);
    n = {
      x: t.x - a.x,
      y: t.y - a.y,
      width: t.width,
      height: t.height
    };
  }
  return lb(n);
}
function m5(e, t) {
  const r = Dc(e);
  return r === t || !Ka(r) || ah(r) ? !1 : hi(r).position === "fixed" || m5(r, t);
}
function rre(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = Xm(e, [], !1).filter((o) => Ka(o) && kh(o) !== "body"), a = null;
  const s = hi(e).position === "fixed";
  let i = s ? Dc(e) : e;
  for (; Ka(i) && !ah(i); ) {
    const o = hi(i), l = iC(i);
    !l && o.position === "fixed" && (a = null), (s ? !l && !a : !l && o.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || Tg(i) && !l && m5(e, i)) ? n = n.filter((u) => u !== i) : a = o, i = Dc(i);
  }
  return t.set(e, n), n;
}
function nre(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: a
  } = e;
  const i = [...r === "clippingAncestors" ? Lw(t) ? [] : rre(t, this._c) : [].concat(r), n], o = i[0], l = i.reduce((c, u) => {
    const d = iP(t, u, a);
    return c.top = Du(d.top, c.top), c.right = sh(d.right, c.right), c.bottom = sh(d.bottom, c.bottom), c.left = Du(d.left, c.left), c;
  }, iP(t, o, a));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function are(e) {
  const {
    width: t,
    height: r
  } = f5(e);
  return {
    width: t,
    height: r
  };
}
function sre(e, t, r) {
  const n = Bo(t), a = $o(t), s = r === "fixed", i = Wu(e, !0, s, t);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Io(0);
  if (n || !n && !s)
    if ((kh(t) !== "body" || Tg(a)) && (o = jw(t)), n) {
      const f = Wu(t, !0, s, t);
      l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
    } else a && (l.x = dC(a));
  const c = a && !n && !s ? p5(a, o) : Io(0), u = i.left + o.scrollLeft - l.x - c.x, d = i.top + o.scrollTop - l.y - c.y;
  return {
    x: u,
    y: d,
    width: i.width,
    height: i.height
  };
}
function $1(e) {
  return hi(e).position === "static";
}
function oP(e, t) {
  if (!Bo(e) || hi(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return $o(e) === r && (r = r.ownerDocument.body), r;
}
function g5(e, t) {
  const r = Ws(e);
  if (Lw(e))
    return r;
  if (!Bo(e)) {
    let a = Dc(e);
    for (; a && !ah(a); ) {
      if (Ka(a) && !$1(a))
        return a;
      a = Dc(a);
    }
    return r;
  }
  let n = oP(e, t);
  for (; n && Ite(n) && $1(n); )
    n = oP(n, t);
  return n && ah(n) && $1(n) && !iC(n) ? r : n || Dte(e) || r;
}
const ire = async function(e) {
  const t = this.getOffsetParent || g5, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: sre(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function ore(e) {
  return hi(e).direction === "rtl";
}
const lre = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Qte,
  getDocumentElement: $o,
  getClippingRect: nre,
  getOffsetParent: g5,
  getElementRects: ire,
  getClientRects: Jte,
  getDimensions: are,
  getScale: Mf,
  isElement: Ka,
  isRTL: ore
};
function v5(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function cre(e, t) {
  let r = null, n;
  const a = $o(e);
  function s() {
    var o;
    clearTimeout(n), (o = r) == null || o.disconnect(), r = null;
  }
  function i(o, l) {
    o === void 0 && (o = !1), l === void 0 && (l = 1), s();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: d,
      width: f,
      height: h
    } = c;
    if (o || t(), !f || !h)
      return;
    const p = Kv(d), m = Kv(a.clientWidth - (u + f)), g = Kv(a.clientHeight - (d + h)), y = Kv(u), w = {
      rootMargin: -p + "px " + -m + "px " + -g + "px " + -y + "px",
      threshold: Du(0, sh(1, l)) || 1
    };
    let _ = !0;
    function S(C) {
      const E = C[0].intersectionRatio;
      if (E !== l) {
        if (!_)
          return i();
        E ? i(!1, E) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !v5(c, e.getBoundingClientRect()) && i(), _ = !1;
    }
    try {
      r = new IntersectionObserver(S, {
        ...w,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(S, w);
    }
    r.observe(e);
  }
  return i(!0), s;
}
function ure(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, c = uC(e), u = a || s ? [...c ? Xm(c) : [], ...Xm(t)] : [];
  u.forEach((y) => {
    a && y.addEventListener("scroll", r, {
      passive: !0
    }), s && y.addEventListener("resize", r);
  });
  const d = c && o ? cre(c, r) : null;
  let f = -1, h = null;
  i && (h = new ResizeObserver((y) => {
    let [x] = y;
    x && x.target === c && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var w;
      (w = h) == null || w.observe(t);
    })), r();
  }), c && !l && h.observe(c), h.observe(t));
  let p, m = l ? Wu(e) : null;
  l && g();
  function g() {
    const y = Wu(e);
    m && !v5(m, y) && r(), m = y, p = requestAnimationFrame(g);
  }
  return r(), () => {
    var y;
    u.forEach((x) => {
      a && x.removeEventListener("scroll", r), s && x.removeEventListener("resize", r);
    }), d == null || d(), (y = h) == null || y.disconnect(), h = null, l && cancelAnimationFrame(p);
  };
}
const dre = Gte, fre = Kte, lP = zte, hre = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), a = {
    platform: lre,
    ...r
  }, s = {
    ...a.platform,
    _c: n
  };
  return Hte(e, t, {
    ...a,
    platform: s
  });
};
var _y = typeof document < "u" ? kT : wt;
function cb(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!cb(e[n], t[n]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), r = a.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const s = a[n];
      if (!(s === "_owner" && e.$$typeof) && !cb(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function y5(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function cP(e, t) {
  const r = y5(e);
  return Math.round(t * r) / r;
}
function H1(e) {
  const t = be.useRef(e);
  return _y(() => {
    t.current = e;
  }), t;
}
function pre(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: a,
    elements: {
      reference: s,
      floating: i
    } = {},
    transform: o = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = be.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = be.useState(n);
  cb(f, n) || h(n);
  const [p, m] = be.useState(null), [g, y] = be.useState(null), x = be.useCallback((ae) => {
    ae !== C.current && (C.current = ae, m(ae));
  }, []), w = be.useCallback((ae) => {
    ae !== E.current && (E.current = ae, y(ae));
  }, []), _ = s || p, S = i || g, C = be.useRef(null), E = be.useRef(null), O = be.useRef(u), k = l != null, A = H1(l), P = H1(a), D = H1(c), N = be.useCallback(() => {
    if (!C.current || !E.current)
      return;
    const ae = {
      placement: t,
      strategy: r,
      middleware: f
    };
    P.current && (ae.platform = P.current), hre(C.current, E.current, ae).then((ne) => {
      const ue = {
        ...ne,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: D.current !== !1
      };
      z.current && !cb(O.current, ue) && (O.current = ue, Gz.flushSync(() => {
        d(ue);
      }));
    });
  }, [f, t, r, P, D]);
  _y(() => {
    c === !1 && O.current.isPositioned && (O.current.isPositioned = !1, d((ae) => ({
      ...ae,
      isPositioned: !1
    })));
  }, [c]);
  const z = be.useRef(!1);
  _y(() => (z.current = !0, () => {
    z.current = !1;
  }), []), _y(() => {
    if (_ && (C.current = _), S && (E.current = S), _ && S) {
      if (A.current)
        return A.current(_, S, N);
      N();
    }
  }, [_, S, N, A, k]);
  const G = be.useMemo(() => ({
    reference: C,
    floating: E,
    setReference: x,
    setFloating: w
  }), [x, w]), Y = be.useMemo(() => ({
    reference: _,
    floating: S
  }), [_, S]), te = be.useMemo(() => {
    const ae = {
      position: r,
      left: 0,
      top: 0
    };
    if (!Y.floating)
      return ae;
    const ne = cP(Y.floating, u.x), ue = cP(Y.floating, u.y);
    return o ? {
      ...ae,
      transform: "translate(" + ne + "px, " + ue + "px)",
      ...y5(Y.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: ne,
      top: ue
    };
  }, [r, o, Y.floating, u.x, u.y]);
  return be.useMemo(() => ({
    ...u,
    update: N,
    refs: G,
    elements: Y,
    floatingStyles: te
  }), [u, N, G, Y, te]);
}
const mre = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: a
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? lP({
        element: n.current,
        padding: a
      }).fn(r) : {} : n ? lP({
        element: n,
        padding: a
      }).fn(r) : {};
    }
  };
}, gre = (e, t) => ({
  ...dre(e),
  options: [e, t]
}), vre = (e, t) => ({
  ...fre(e),
  options: [e, t]
}), yre = (e, t) => ({
  ...mre(e),
  options: [e, t]
});
var Bw = {};
const b5 = {
  ...be
}, bre = b5.useInsertionEffect, wre = bre || ((e) => e());
function xre(e) {
  const t = be.useRef(() => {
    if (Bw.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return wre(() => {
    t.current = e;
  }), be.useCallback(function() {
    for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
      n[a] = arguments[a];
    return t.current == null ? void 0 : t.current(...n);
  }, []);
}
var ub = typeof document < "u" ? kT : wt;
let uP = !1, _re = 0;
const dP = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + _re++
);
function Sre() {
  const [e, t] = be.useState(() => uP ? dP() : void 0);
  return ub(() => {
    e == null && t(dP());
  }, []), be.useEffect(() => {
    uP = !0;
  }, []), e;
}
const Ere = b5.useId, w5 = Ere || Sre;
let Jm;
Bw.NODE_ENV !== "production" && (Jm = /* @__PURE__ */ new Set());
function Tre() {
  for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  const a = "Floating UI: " + r.join(" ");
  if (!((e = Jm) != null && e.has(a))) {
    var s;
    (s = Jm) == null || s.add(a), console.warn(a);
  }
}
function Cre() {
  for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  const a = "Floating UI: " + r.join(" ");
  if (!((e = Jm) != null && e.has(a))) {
    var s;
    (s = Jm) == null || s.add(a), console.error(a);
  }
}
const kre = /* @__PURE__ */ be.forwardRef(function(t, r) {
  const {
    context: {
      placement: n,
      elements: {
        floating: a
      },
      middlewareData: {
        arrow: s,
        shift: i
      }
    },
    width: o = 14,
    height: l = 7,
    tipRadius: c = 0,
    strokeWidth: u = 0,
    staticOffset: d,
    stroke: f,
    d: h,
    style: {
      transform: p,
      ...m
    } = {},
    ...g
  } = t;
  Bw.NODE_ENV !== "production" && (r || Tre("The `ref` prop is required for `FloatingArrow`."));
  const y = w5(), [x, w] = be.useState(!1);
  if (ub(() => {
    if (!a) return;
    hi(a).direction === "rtl" && w(!0);
  }, [a]), !a)
    return null;
  const [_, S] = n.split("-"), C = _ === "top" || _ === "bottom";
  let E = d;
  (C && i != null && i.x || !C && i != null && i.y) && (E = null);
  const O = u * 2, k = O / 2, A = o / 2 * (c / -8 + 1), P = l / 2 * c / 4, D = !!h, N = E && S === "end" ? "bottom" : "top";
  let z = E && S === "end" ? "right" : "left";
  E && x && (z = S === "end" ? "left" : "right");
  const G = (s == null ? void 0 : s.x) != null ? E || s.x : "", Y = (s == null ? void 0 : s.y) != null ? E || s.y : "", te = h || "M0,0" + (" H" + o) + (" L" + (o - A) + "," + (l - P)) + (" Q" + o / 2 + "," + l + " " + A + "," + (l - P)) + " Z", ae = {
    top: D ? "rotate(180deg)" : "",
    left: D ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: D ? "" : "rotate(180deg)",
    right: D ? "rotate(-90deg)" : "rotate(90deg)"
  }[_];
  return /* @__PURE__ */ v.jsxs("svg", {
    ...g,
    "aria-hidden": !0,
    ref: r,
    width: D ? o : o + O,
    height: o,
    viewBox: "0 0 " + o + " " + (l > o ? l : o),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [z]: G,
      [N]: Y,
      [_]: C || D ? "100%" : "calc(100% - " + O / 2 + "px)",
      transform: [ae, p].filter((ne) => !!ne).join(" "),
      ...m
    },
    children: [O > 0 && /* @__PURE__ */ v.jsx("path", {
      clipPath: "url(#" + y + ")",
      fill: "none",
      stroke: f,
      strokeWidth: O + (h ? 0 : 1),
      d: te
    }), /* @__PURE__ */ v.jsx("path", {
      stroke: O && !h ? g.fill : "none",
      d: te
    }), /* @__PURE__ */ v.jsx("clipPath", {
      id: y,
      children: /* @__PURE__ */ v.jsx("rect", {
        x: -k,
        y: k * (D ? -1 : 1),
        width: o + O,
        height: o
      })
    })]
  });
});
function Ore() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, r) {
      var n;
      (n = e.get(t)) == null || n.forEach((a) => a(r));
    },
    on(t, r) {
      e.set(t, [...e.get(t) || [], r]);
    },
    off(t, r) {
      var n;
      e.set(t, ((n = e.get(t)) == null ? void 0 : n.filter((a) => a !== r)) || []);
    }
  };
}
const Are = /* @__PURE__ */ be.createContext(null), Pre = /* @__PURE__ */ be.createContext(null), Rre = () => {
  var e;
  return ((e = be.useContext(Are)) == null ? void 0 : e.id) || null;
}, Ire = () => be.useContext(Pre);
function Dre(e) {
  const {
    open: t = !1,
    onOpenChange: r,
    elements: n
  } = e, a = w5(), s = be.useRef({}), [i] = be.useState(() => Ore()), o = Rre() != null;
  if (Bw.NODE_ENV !== "production") {
    const h = n.reference;
    h && !Ka(h) && Cre("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = be.useState(n.reference), u = xre((h, p, m) => {
    s.current.openEvent = h ? p : void 0, i.emit("openchange", {
      open: h,
      event: p,
      reason: m,
      nested: o
    }), r == null || r(h, p, m);
  }), d = be.useMemo(() => ({
    setPositionReference: c
  }), []), f = be.useMemo(() => ({
    reference: l || n.reference || null,
    floating: n.floating || null,
    domReference: n.reference
  }), [l, n.reference, n.floating]);
  return be.useMemo(() => ({
    dataRef: s,
    open: t,
    onOpenChange: u,
    elements: f,
    events: i,
    floatingId: a,
    refs: d
  }), [t, u, f, i, a, d]);
}
function Nre(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, r = Dre({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), n = e.rootContext || r, a = n.elements, [s, i] = be.useState(null), [o, l] = be.useState(null), u = (a == null ? void 0 : a.domReference) || s, d = be.useRef(null), f = Ire();
  ub(() => {
    u && (d.current = u);
  }, [u]);
  const h = pre({
    ...e,
    elements: {
      ...a,
      ...o && {
        reference: o
      }
    }
  }), p = be.useCallback((w) => {
    const _ = Ka(w) ? {
      getBoundingClientRect: () => w.getBoundingClientRect(),
      getClientRects: () => w.getClientRects(),
      contextElement: w
    } : w;
    l(_), h.refs.setReference(_);
  }, [h.refs]), m = be.useCallback((w) => {
    (Ka(w) || w === null) && (d.current = w, i(w)), (Ka(h.refs.reference.current) || h.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    w !== null && !Ka(w)) && h.refs.setReference(w);
  }, [h.refs]), g = be.useMemo(() => ({
    ...h.refs,
    setReference: m,
    setPositionReference: p,
    domReference: d
  }), [h.refs, m, p]), y = be.useMemo(() => ({
    ...h.elements,
    domReference: u
  }), [h.elements, u]), x = be.useMemo(() => ({
    ...h,
    ...n,
    refs: g,
    elements: y,
    nodeId: t
  }), [h, g, y, t, n]);
  return ub(() => {
    n.dataRef.current.floatingContext = x;
    const w = f == null ? void 0 : f.nodesRef.current.find((_) => _.id === t);
    w && (w.context = x);
  }), be.useMemo(() => ({
    ...h,
    context: x,
    refs: g,
    elements: y
  }), [h, g, y, x]);
}
/*!
  react-datepicker v7.6.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
var SE = function(t, r) {
  return SE = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(n, a) {
    n.__proto__ = a;
  } || function(n, a) {
    for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
  }, SE(t, r);
};
function ya(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  SE(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var kr = function() {
  return kr = Object.assign || function(r) {
    for (var n, a = 1, s = arguments.length; a < s; a++) {
      n = arguments[a];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }
    return r;
  }, kr.apply(this, arguments);
};
function Eo(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var Mre = function(e) {
  var t = e.showTimeSelectOnly, r = t === void 0 ? !1 : t, n = e.showTime, a = n === void 0 ? !1 : n, s = e.className, i = e.children, o = r ? "Choose Time" : "Choose Date".concat(a ? " and Time" : "");
  return M.createElement("div", { className: s, role: "dialog", "aria-label": o, "aria-modal": "true" }, i);
}, Lre = function(e, t) {
  var r = tr(null), n = tr(e);
  n.current = e;
  var a = Ft(function(s) {
    var i;
    r.current && !r.current.contains(s.target) && (t && s.target instanceof HTMLElement && s.target.classList.contains(t) || (i = n.current) === null || i === void 0 || i.call(n, s));
  }, [t]);
  return wt(function() {
    return document.addEventListener("mousedown", a), function() {
      document.removeEventListener("mousedown", a);
    };
  }, [a]), r;
}, Uw = function(e) {
  var t = e.children, r = e.onClickOutside, n = e.className, a = e.containerRef, s = e.style, i = e.ignoreClass, o = Lre(r, i);
  return M.createElement("div", { className: n, style: s, ref: function(l) {
    o.current = l, a && (a.current = l);
  } }, t);
}, Tt;
(function(e) {
  e.ArrowUp = "ArrowUp", e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Home = "Home", e.End = "End", e.Enter = "Enter", e.Space = " ", e.Tab = "Tab", e.Escape = "Escape", e.Backspace = "Backspace", e.X = "x";
})(Tt || (Tt = {}));
function x5() {
  var e = typeof window < "u" ? window : globalThis;
  return e;
}
var kg = 12, jre = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function Qr(e) {
  if (e == null)
    return /* @__PURE__ */ new Date();
  var t = typeof e == "string" ? mte(e) : At(e);
  return wl(t) ? t : /* @__PURE__ */ new Date();
}
function W1(e, t, r, n, a) {
  var s, i = null, o = Nu(r) || Nu(dm()), l = !0;
  if (Array.isArray(t))
    return t.forEach(function(u) {
      var d = U1(e, u, /* @__PURE__ */ new Date(), {
        locale: o,
        useAdditionalWeekYearTokens: !0,
        useAdditionalDayOfYearTokens: !0
      });
      n && (l = wl(d, a) && e === gn(d, u, r)), wl(d, a) && l && (i = d);
    }), i;
  if (i = U1(e, t, /* @__PURE__ */ new Date(), {
    locale: o,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  }), n)
    l = wl(i) && e === gn(i, t, r);
  else if (!wl(i)) {
    var c = ((s = t.match(jre)) !== null && s !== void 0 ? s : []).map(function(u) {
      var d = u[0];
      if (d === "p" || d === "P") {
        var f = ab[d];
        return o ? f(u, o.formatLong) : d;
      }
      return u;
    }).join("");
    e.length > 0 && (i = U1(e, c.slice(0, e.length), /* @__PURE__ */ new Date(), {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    })), wl(i) || (i = new Date(e));
  }
  return wl(i) && l ? i : null;
}
function wl(e, t) {
  return eb(e) && !Hu(e, t ?? /* @__PURE__ */ new Date("1/1/1800"));
}
function gn(e, t, r) {
  if (r === "en")
    return tP(e, t, {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
  var n = r ? Nu(r) : void 0;
  return r && !n && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !n && dm() && Nu(dm()) && (n = Nu(dm())), tP(e, t, {
    locale: n,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  });
}
function ri(e, t) {
  var r = t.dateFormat, n = t.locale, a = Array.isArray(r) && r.length > 0 ? r[0] : r;
  return e && gn(e, a, n) || "";
}
function Fre(e, t, r) {
  if (!e)
    return "";
  var n = ri(e, r), a = t ? ri(t, r) : "";
  return "".concat(n, " - ").concat(a);
}
function Bre(e, t) {
  if (!(e != null && e.length))
    return "";
  var r = e[0] ? ri(e[0], t) : "";
  if (e.length === 1)
    return r;
  if (e.length === 2 && e[1]) {
    var n = ri(e[1], t);
    return "".concat(r, ", ").concat(n);
  }
  var a = e.length - 1;
  return "".concat(r, " (+").concat(a, ")");
}
function z1(e, t) {
  var r = t.hour, n = r === void 0 ? 0 : r, a = t.minute, s = a === void 0 ? 0 : a, i = t.second, o = i === void 0 ? 0 : i;
  return by(wy(xy(e, o), s), n);
}
function Ure(e) {
  return rC(e);
}
function Vre(e, t) {
  return gn(e, "ddd", t);
}
function Sy(e) {
  return $u(e);
}
function Ec(e, t, r) {
  var n = Nu(t || dm());
  return Fl(e, {
    locale: n,
    weekStartsOn: r
  });
}
function Rl(e) {
  return XF(e);
}
function Gp(e) {
  return Nw(e);
}
function fP(e) {
  return yE(e);
}
function hP() {
  return $u(Qr());
}
function pP(e) {
  return GF(e);
}
function $re(e) {
  return wZ(e);
}
function Hre(e) {
  return YF(e);
}
function yo(e, t) {
  return e && t ? hte(e, t) : !e && !t;
}
function os(e, t) {
  return e && t ? dte(e, t) : !e && !t;
}
function db(e, t) {
  return e && t ? fte(e, t) : !e && !t;
}
function Sr(e, t) {
  return e && t ? yZ(e, t) : !e && !t;
}
function Eu(e, t) {
  return e && t ? gee(e, t) : !e && !t;
}
function Yp(e, t, r) {
  var n, a = $u(t), s = GF(r);
  try {
    n = Ym(e, { start: a, end: s });
  } catch {
    n = !1;
  }
  return n;
}
function dm() {
  var e = x5();
  return e.__localeId__;
}
function Nu(e) {
  if (typeof e == "string") {
    var t = x5();
    return t.__localeData__ ? t.__localeData__[e] : void 0;
  } else
    return e;
}
function Wre(e, t, r) {
  return t(gn(e, "EEEE", r));
}
function zre(e, t) {
  return gn(e, "EEEEEE", t);
}
function Kre(e, t) {
  return gn(e, "EEE", t);
}
function fC(e, t) {
  return gn(js(Qr(), e), "LLLL", t);
}
function _5(e, t) {
  return gn(js(Qr(), e), "LLL", t);
}
function qre(e, t) {
  return gn(cf(Qr(), e), "QQQ", t);
}
function ii(e, t) {
  var r = t === void 0 ? {} : t, n = r.minDate, a = r.maxDate, s = r.excludeDates, i = r.excludeDateIntervals, o = r.includeDates, l = r.includeDateIntervals, c = r.filterDate;
  return Og(e, { minDate: n, maxDate: a }) || s && s.some(function(u) {
    return u instanceof Date ? Sr(e, u) : Sr(e, u.date);
  }) || i && i.some(function(u) {
    var d = u.start, f = u.end;
    return Ym(e, { start: d, end: f });
  }) || o && !o.some(function(u) {
    return Sr(e, u);
  }) || l && !l.some(function(u) {
    var d = u.start, f = u.end;
    return Ym(e, { start: d, end: f });
  }) || c && !c(Qr(e)) || !1;
}
function hC(e, t) {
  var r = t === void 0 ? {} : t, n = r.excludeDates, a = r.excludeDateIntervals;
  return a && a.length > 0 ? a.some(function(s) {
    var i = s.start, o = s.end;
    return Ym(e, { start: i, end: o });
  }) : n && n.some(function(s) {
    var i;
    return s instanceof Date ? Sr(e, s) : Sr(e, (i = s.date) !== null && i !== void 0 ? i : /* @__PURE__ */ new Date());
  }) || !1;
}
function S5(e, t) {
  var r = t === void 0 ? {} : t, n = r.minDate, a = r.maxDate, s = r.excludeDates, i = r.includeDates, o = r.filterDate;
  return Og(e, {
    minDate: n ? XF(n) : void 0,
    maxDate: a ? YF(a) : void 0
  }) || (s == null ? void 0 : s.some(function(l) {
    return os(e, l instanceof Date ? l : l.date);
  })) || i && !i.some(function(l) {
    return os(e, l);
  }) || o && !o(Qr(e)) || !1;
}
function qv(e, t, r, n) {
  var a = mr(e), s = us(e), i = mr(t), o = us(t), l = mr(n);
  return a === i && a === l ? s <= r && r <= o : a < i ? l === a && s <= r || l === i && o >= r || l < i && l > a : !1;
}
function Gre(e, t) {
  var r = t === void 0 ? {} : t, n = r.minDate, a = r.maxDate, s = r.excludeDates, i = r.includeDates;
  return Og(e, { minDate: n, maxDate: a }) || s && s.some(function(o) {
    return os(o instanceof Date ? o : o.date, e);
  }) || i && !i.some(function(o) {
    return os(o, e);
  }) || !1;
}
function Gv(e, t) {
  var r = t === void 0 ? {} : t, n = r.minDate, a = r.maxDate, s = r.excludeDates, i = r.includeDates, o = r.filterDate;
  return Og(e, { minDate: n, maxDate: a }) || (s == null ? void 0 : s.some(function(l) {
    return db(e, l instanceof Date ? l : l.date);
  })) || i && !i.some(function(l) {
    return db(e, l);
  }) || o && !o(Qr(e)) || !1;
}
function Yv(e, t, r) {
  if (!t || !r || !eb(t) || !eb(r))
    return !1;
  var n = mr(t), a = mr(r);
  return n <= e && a >= e;
}
function Ey(e, t) {
  var r = t === void 0 ? {} : t, n = r.minDate, a = r.maxDate, s = r.excludeDates, i = r.includeDates, o = r.filterDate, l = new Date(e, 0, 1);
  return Og(l, {
    minDate: n ? Nw(n) : void 0,
    maxDate: a ? QF(a) : void 0
  }) || (s == null ? void 0 : s.some(function(c) {
    return yo(l, c instanceof Date ? c : c.date);
  })) || i && !i.some(function(c) {
    return yo(l, c);
  }) || o && !o(Qr(l)) || !1;
}
function Xv(e, t, r, n) {
  var a = mr(e), s = Ru(e), i = mr(t), o = Ru(t), l = mr(n);
  return a === i && a === l ? s <= r && r <= o : a < i ? l === a && s <= r || l === i && o >= r || l < i && l > a : !1;
}
function Og(e, t) {
  var r, n = t === void 0 ? {} : t, a = n.minDate, s = n.maxDate;
  return (r = a && rh(e, a) < 0 || s && rh(e, s) > 0) !== null && r !== void 0 ? r : !1;
}
function mP(e, t) {
  return t.some(function(r) {
    return Po(r) === Po(e) && Ro(r) === Ro(e) && Pl(r) === Pl(e);
  });
}
function gP(e, t) {
  var r = t === void 0 ? {} : t, n = r.excludeTimes, a = r.includeTimes, s = r.filterTime;
  return n && mP(e, n) || a && !mP(e, a) || s && !s(e) || !1;
}
function vP(e, t) {
  var r = t.minTime, n = t.maxTime;
  if (!r || !n)
    throw new Error("Both minTime and maxTime props required");
  var a = Qr();
  a = by(a, Po(e)), a = wy(a, Ro(e)), a = xy(a, Pl(e));
  var s = Qr();
  s = by(s, Po(r)), s = wy(s, Ro(r)), s = xy(s, Pl(r));
  var i = Qr();
  i = by(i, Po(n)), i = wy(i, Ro(n)), i = xy(i, Pl(n));
  var o;
  try {
    o = !Ym(a, { start: s, end: i });
  } catch {
    o = !1;
  }
  return o;
}
function yP(e, t) {
  var r = t === void 0 ? {} : t, n = r.minDate, a = r.includeDates, s = Iu(e, 1);
  return n && tb(n, s) > 0 || a && a.every(function(i) {
    return tb(i, s) > 0;
  }) || !1;
}
function bP(e, t) {
  var r = t === void 0 ? {} : t, n = r.maxDate, a = r.includeDates, s = $i(e, 1);
  return n && tb(s, n) > 0 || a && a.every(function(i) {
    return tb(s, i) > 0;
  }) || !1;
}
function Yre(e, t) {
  var r = t === void 0 ? {} : t, n = r.minDate, a = r.includeDates, s = Nw(e), i = l5(s);
  return n && rb(n, i) > 0 || a && a.every(function(o) {
    return rb(o, i) > 0;
  }) || !1;
}
function Xre(e, t) {
  var r = t === void 0 ? {} : t, n = r.maxDate, a = r.includeDates, s = QF(e), i = tC(s, 1);
  return n && rb(i, n) > 0 || a && a.every(function(o) {
    return rb(i, o) > 0;
  }) || !1;
}
function wP(e, t) {
  var r = t === void 0 ? {} : t, n = r.minDate, a = r.includeDates, s = nh(e, 1);
  return n && nb(n, s) > 0 || a && a.every(function(i) {
    return nb(i, s) > 0;
  }) || !1;
}
function Qre(e, t) {
  var r = t === void 0 ? {} : t, n = r.minDate, a = r.yearItemNumber, s = a === void 0 ? kg : a, i = Gp(nh(e, s)), o = pc(i, s).endPeriod, l = n && mr(n);
  return l && l > o || !1;
}
function xP(e, t) {
  var r = t === void 0 ? {} : t, n = r.maxDate, a = r.includeDates, s = Ol(e, 1);
  return n && nb(s, n) > 0 || a && a.every(function(i) {
    return nb(s, i) > 0;
  }) || !1;
}
function Jre(e, t) {
  var r = t === void 0 ? {} : t, n = r.maxDate, a = r.yearItemNumber, s = a === void 0 ? kg : a, i = Ol(e, s), o = pc(i, s).startPeriod, l = n && mr(n);
  return l && l < o || !1;
}
function E5(e) {
  var t = e.minDate, r = e.includeDates;
  if (r && t) {
    var n = r.filter(function(a) {
      return rh(a, t) >= 0;
    });
    return YA(n);
  } else return r ? YA(r) : t;
}
function T5(e) {
  var t = e.maxDate, r = e.includeDates;
  if (r && t) {
    var n = r.filter(function(a) {
      return rh(a, t) <= 0;
    });
    return GA(n);
  } else return r ? GA(r) : t;
}
function _P(e, t) {
  var r;
  e === void 0 && (e = []), t === void 0 && (t = "react-datepicker__day--highlighted");
  for (var n = /* @__PURE__ */ new Map(), a = 0, s = e.length; a < s; a++) {
    var i = e[a];
    if (Al(i)) {
      var o = gn(i, "MM.dd.yyyy"), l = n.get(o) || [];
      l.includes(t) || (l.push(t), n.set(o, l));
    } else if (typeof i == "object") {
      var c = Object.keys(i), u = (r = c[0]) !== null && r !== void 0 ? r : "", d = i[u];
      if (typeof u == "string" && Array.isArray(d))
        for (var f = 0, h = d.length; f < h; f++) {
          var p = d[f];
          if (p) {
            var o = gn(p, "MM.dd.yyyy"), l = n.get(o) || [];
            l.includes(u) || (l.push(u), n.set(o, l));
          }
        }
    }
  }
  return n;
}
function Zre(e, t) {
  return e.length !== t.length ? !1 : e.every(function(r, n) {
    return r === t[n];
  });
}
function ene(e, t) {
  e === void 0 && (e = []), t === void 0 && (t = "react-datepicker__day--holidays");
  var r = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    var a = n.date, s = n.holidayName;
    if (Al(a)) {
      var i = gn(a, "MM.dd.yyyy"), o = r.get(i) || {
        className: "",
        holidayNames: []
      };
      if (!("className" in o && o.className === t && Zre(o.holidayNames, [s]))) {
        o.className = t;
        var l = o.holidayNames;
        o.holidayNames = l ? Eo(Eo([], l, !0), [s], !1) : [s], r.set(i, o);
      }
    }
  }), r;
}
function tne(e, t, r, n, a) {
  for (var s = a.length, i = [], o = 0; o < s; o++) {
    var l = e, c = a[o];
    c && (l = pZ(l, Po(c)), l = vE(l, Ro(c)), l = vZ(l, Pl(c)));
    var u = vE(e, (r + 1) * n);
    Ic(l, t) && Hu(l, u) && c != null && i.push(c);
  }
  return i;
}
function SP(e) {
  return e < 10 ? "0".concat(e) : "".concat(e);
}
function pc(e, t) {
  t === void 0 && (t = kg);
  var r = Math.ceil(mr(e) / t) * t, n = r - (t - 1);
  return { startPeriod: n, endPeriod: r };
}
function rne(e) {
  var t = new Date(e.getFullYear(), e.getMonth(), e.getDate()), r = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
  return Math.round((+r - +t) / 36e5);
}
function EP(e) {
  var t = e.getSeconds(), r = e.getMilliseconds();
  return At(e.getTime() - t * 1e3 - r);
}
function nne(e, t) {
  return EP(e).getTime() === EP(t).getTime();
}
function TP(e) {
  if (!Al(e))
    throw new Error("Invalid date");
  var t = new Date(e);
  return t.setHours(0, 0, 0, 0), t;
}
function CP(e, t) {
  if (!Al(e) || !Al(t))
    throw new Error("Invalid date received");
  var r = TP(e), n = TP(t);
  return Hu(r, n);
}
function C5(e) {
  return e.key === Tt.Space;
}
var ane = (
  /** @class */
  function(e) {
    ya(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.inputRef = M.createRef(), n.onTimeChange = function(a) {
        var s, i;
        n.setState({ time: a });
        var o = n.props.date, l = o instanceof Date && !isNaN(+o), c = l ? o : /* @__PURE__ */ new Date();
        if (a != null && a.includes(":")) {
          var u = a.split(":"), d = u[0], f = u[1];
          c.setHours(Number(d)), c.setMinutes(Number(f));
        }
        (i = (s = n.props).onChange) === null || i === void 0 || i.call(s, c);
      }, n.renderTimeInput = function() {
        var a = n.state.time, s = n.props, i = s.date, o = s.timeString, l = s.customTimeInput;
        return l ? j4(l, {
          date: i,
          value: a,
          onChange: n.onTimeChange
        }) : M.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", ref: n.inputRef, onClick: function() {
          var c;
          (c = n.inputRef.current) === null || c === void 0 || c.focus();
        }, required: !0, value: a, onChange: function(c) {
          n.onTimeChange(c.target.value || o);
        } });
      }, n.state = {
        time: n.props.timeString
      }, n;
    }
    return t.getDerivedStateFromProps = function(r, n) {
      return r.timeString !== n.time ? {
        time: r.timeString
      } : null;
    }, t.prototype.render = function() {
      return M.createElement(
        "div",
        { className: "react-datepicker__input-time-container" },
        M.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel),
        M.createElement(
          "div",
          { className: "react-datepicker-time__input-container" },
          M.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())
        )
      );
    }, t;
  }(Cn)
), sne = (
  /** @class */
  function(e) {
    ya(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.dayEl = Cc(), r.handleClick = function(n) {
        !r.isDisabled() && r.props.onClick && r.props.onClick(n);
      }, r.handleMouseEnter = function(n) {
        !r.isDisabled() && r.props.onMouseEnter && r.props.onMouseEnter(n);
      }, r.handleOnKeyDown = function(n) {
        var a, s, i = n.key;
        i === Tt.Space && (n.preventDefault(), n.key = Tt.Enter), (s = (a = r.props).handleOnKeyDown) === null || s === void 0 || s.call(a, n);
      }, r.isSameDay = function(n) {
        return Sr(r.props.day, n);
      }, r.isKeyboardSelected = function() {
        var n;
        if (r.props.disabledKeyboardNavigation)
          return !1;
        var a = r.props.selectsMultiple ? (n = r.props.selectedDates) === null || n === void 0 ? void 0 : n.some(function(i) {
          return r.isSameDayOrWeek(i);
        }) : r.isSameDayOrWeek(r.props.selected), s = r.props.preSelection && r.isDisabled(r.props.preSelection);
        return !a && r.isSameDayOrWeek(r.props.preSelection) && !s;
      }, r.isDisabled = function(n) {
        return n === void 0 && (n = r.props.day), ii(n, {
          minDate: r.props.minDate,
          maxDate: r.props.maxDate,
          excludeDates: r.props.excludeDates,
          excludeDateIntervals: r.props.excludeDateIntervals,
          includeDateIntervals: r.props.includeDateIntervals,
          includeDates: r.props.includeDates,
          filterDate: r.props.filterDate
        });
      }, r.isExcluded = function() {
        return hC(r.props.day, {
          excludeDates: r.props.excludeDates,
          excludeDateIntervals: r.props.excludeDateIntervals
        });
      }, r.isStartOfWeek = function() {
        return Sr(r.props.day, Ec(r.props.day, r.props.locale, r.props.calendarStartDay));
      }, r.isSameWeek = function(n) {
        return r.props.showWeekPicker && Sr(n, Ec(r.props.day, r.props.locale, r.props.calendarStartDay));
      }, r.isSameDayOrWeek = function(n) {
        return r.isSameDay(n) || r.isSameWeek(n);
      }, r.getHighLightedClass = function() {
        var n = r.props, a = n.day, s = n.highlightDates;
        if (!s)
          return !1;
        var i = gn(a, "MM.dd.yyyy");
        return s.get(i);
      }, r.getHolidaysClass = function() {
        var n, a = r.props, s = a.day, i = a.holidays;
        if (!i)
          return [void 0];
        var o = gn(s, "MM.dd.yyyy");
        return i.has(o) ? [(n = i.get(o)) === null || n === void 0 ? void 0 : n.className] : [void 0];
      }, r.isInRange = function() {
        var n = r.props, a = n.day, s = n.startDate, i = n.endDate;
        return !s || !i ? !1 : Yp(a, s, i);
      }, r.isInSelectingRange = function() {
        var n, a = r.props, s = a.day, i = a.selectsStart, o = a.selectsEnd, l = a.selectsRange, c = a.selectsDisabledDaysInRange, u = a.startDate, d = a.endDate, f = (n = r.props.selectingDate) !== null && n !== void 0 ? n : r.props.preSelection;
        return !(i || o || l) || !f || !c && r.isDisabled() ? !1 : i && d && (Hu(f, d) || Eu(f, d)) ? Yp(s, f, d) : o && u && (Ic(f, u) || Eu(f, u)) || l && u && !d && (Ic(f, u) || Eu(f, u)) ? Yp(s, u, f) : !1;
      }, r.isSelectingRangeStart = function() {
        var n;
        if (!r.isInSelectingRange())
          return !1;
        var a = r.props, s = a.day, i = a.startDate, o = a.selectsStart, l = (n = r.props.selectingDate) !== null && n !== void 0 ? n : r.props.preSelection;
        return o ? Sr(s, l) : Sr(s, i);
      }, r.isSelectingRangeEnd = function() {
        var n;
        if (!r.isInSelectingRange())
          return !1;
        var a = r.props, s = a.day, i = a.endDate, o = a.selectsEnd, l = a.selectsRange, c = (n = r.props.selectingDate) !== null && n !== void 0 ? n : r.props.preSelection;
        return o || l ? Sr(s, c) : Sr(s, i);
      }, r.isRangeStart = function() {
        var n = r.props, a = n.day, s = n.startDate, i = n.endDate;
        return !s || !i ? !1 : Sr(s, a);
      }, r.isRangeEnd = function() {
        var n = r.props, a = n.day, s = n.startDate, i = n.endDate;
        return !s || !i ? !1 : Sr(i, a);
      }, r.isWeekend = function() {
        var n = fee(r.props.day);
        return n === 0 || n === 6;
      }, r.isAfterMonth = function() {
        return r.props.month !== void 0 && (r.props.month + 1) % 12 === us(r.props.day);
      }, r.isBeforeMonth = function() {
        return r.props.month !== void 0 && (us(r.props.day) + 1) % 12 === r.props.month;
      }, r.isCurrentDay = function() {
        return r.isSameDay(Qr());
      }, r.isSelected = function() {
        var n;
        return r.props.selectsMultiple ? (n = r.props.selectedDates) === null || n === void 0 ? void 0 : n.some(function(a) {
          return r.isSameDayOrWeek(a);
        }) : r.isSameDayOrWeek(r.props.selected);
      }, r.getClassNames = function(n) {
        var a = r.props.dayClassName ? r.props.dayClassName(n) : void 0;
        return Pa("react-datepicker__day", a, "react-datepicker__day--" + Vre(r.props.day), {
          "react-datepicker__day--disabled": r.isDisabled(),
          "react-datepicker__day--excluded": r.isExcluded(),
          "react-datepicker__day--selected": r.isSelected(),
          "react-datepicker__day--keyboard-selected": r.isKeyboardSelected(),
          "react-datepicker__day--range-start": r.isRangeStart(),
          "react-datepicker__day--range-end": r.isRangeEnd(),
          "react-datepicker__day--in-range": r.isInRange(),
          "react-datepicker__day--in-selecting-range": r.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": r.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": r.isSelectingRangeEnd(),
          "react-datepicker__day--today": r.isCurrentDay(),
          "react-datepicker__day--weekend": r.isWeekend(),
          "react-datepicker__day--outside-month": r.isAfterMonth() || r.isBeforeMonth()
        }, r.getHighLightedClass(), r.getHolidaysClass());
      }, r.getAriaLabel = function() {
        var n = r.props, a = n.day, s = n.ariaLabelPrefixWhenEnabled, i = s === void 0 ? "Choose" : s, o = n.ariaLabelPrefixWhenDisabled, l = o === void 0 ? "Not available" : o, c = r.isDisabled() || r.isExcluded() ? l : i;
        return "".concat(c, " ").concat(gn(a, "PPPP", r.props.locale));
      }, r.getTitle = function() {
        var n = r.props, a = n.day, s = n.holidays, i = s === void 0 ? /* @__PURE__ */ new Map() : s, o = n.excludeDates, l = gn(a, "MM.dd.yyyy"), c = [];
        return i.has(l) && c.push.apply(c, i.get(l).holidayNames), r.isExcluded() && c.push(o == null ? void 0 : o.filter(function(u) {
          return u instanceof Date ? Sr(u, a) : Sr(u == null ? void 0 : u.date, a);
        }).map(function(u) {
          if (!(u instanceof Date))
            return u == null ? void 0 : u.message;
        })), c.join(", ");
      }, r.getTabIndex = function() {
        var n = r.props.selected, a = r.props.preSelection, s = !(r.props.showWeekPicker && (r.props.showWeekNumber || !r.isStartOfWeek())) && (r.isKeyboardSelected() || r.isSameDay(n) && Sr(a, n)) ? 0 : -1;
        return s;
      }, r.handleFocusDay = function() {
        var n;
        r.shouldFocusDay() && ((n = r.dayEl.current) === null || n === void 0 || n.focus({ preventScroll: !0 }));
      }, r.renderDayContents = function() {
        return r.props.monthShowsDuplicateDaysEnd && r.isAfterMonth() || r.props.monthShowsDuplicateDaysStart && r.isBeforeMonth() ? null : r.props.renderDayContents ? r.props.renderDayContents(rP(r.props.day), r.props.day) : rP(r.props.day);
      }, r.render = function() {
        return (
          // TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
          M.createElement(
            "div",
            { ref: r.dayEl, className: r.getClassNames(r.props.day), onKeyDown: r.handleOnKeyDown, onClick: r.handleClick, onMouseEnter: r.props.usePointerEvent ? void 0 : r.handleMouseEnter, onPointerEnter: r.props.usePointerEvent ? r.handleMouseEnter : void 0, tabIndex: r.getTabIndex(), "aria-label": r.getAriaLabel(), role: "option", title: r.getTitle(), "aria-disabled": r.isDisabled(), "aria-current": r.isCurrentDay() ? "date" : void 0, "aria-selected": r.isSelected() || r.isInRange() },
            r.renderDayContents(),
            r.getTitle() !== "" && M.createElement("span", { className: "overlay" }, r.getTitle())
          )
        );
      }, r;
    }
    return t.prototype.componentDidMount = function() {
      this.handleFocusDay();
    }, t.prototype.componentDidUpdate = function() {
      this.handleFocusDay();
    }, t.prototype.shouldFocusDay = function() {
      var r = !1;
      return this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (r = !0), this.props.inline && !this.props.shouldFocusDayInline && (r = !1), this.isDayActiveElement() && (r = !0), this.isDuplicateDay() && (r = !1)), r;
    }, t.prototype.isDayActiveElement = function() {
      var r, n, a;
      return ((n = (r = this.props.containerRef) === null || r === void 0 ? void 0 : r.current) === null || n === void 0 ? void 0 : n.contains(document.activeElement)) && ((a = document.activeElement) === null || a === void 0 ? void 0 : a.classList.contains("react-datepicker__day"));
    }, t.prototype.isDuplicateDay = function() {
      return (
        //day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth()
      );
    }, t;
  }(Cn)
), ine = (
  /** @class */
  function(e) {
    ya(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.weekNumberEl = Cc(), r.handleClick = function(n) {
        r.props.onClick && r.props.onClick(n);
      }, r.handleOnKeyDown = function(n) {
        var a, s, i = n.key;
        i === Tt.Space && (n.preventDefault(), n.key = Tt.Enter), (s = (a = r.props).handleOnKeyDown) === null || s === void 0 || s.call(a, n);
      }, r.isKeyboardSelected = function() {
        return !r.props.disabledKeyboardNavigation && !Sr(r.props.date, r.props.selected) && Sr(r.props.date, r.props.preSelection);
      }, r.getTabIndex = function() {
        return r.props.showWeekPicker && r.props.showWeekNumber && (r.isKeyboardSelected() || Sr(r.props.date, r.props.selected) && Sr(r.props.preSelection, r.props.selected)) ? 0 : -1;
      }, r.handleFocusWeekNumber = function(n) {
        var a = !1;
        r.getTabIndex() === 0 && !(n != null && n.isInputFocused) && Sr(r.props.date, r.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (a = !0), r.props.inline && !r.props.shouldFocusDayInline && (a = !1), r.props.containerRef && r.props.containerRef.current && r.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (a = !0)), a && r.weekNumberEl.current && r.weekNumberEl.current.focus({ preventScroll: !0 });
      }, r;
    }
    return Object.defineProperty(t, "defaultProps", {
      get: function() {
        return {
          ariaLabelPrefix: "week "
        };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidMount = function() {
      this.handleFocusWeekNumber();
    }, t.prototype.componentDidUpdate = function(r) {
      this.handleFocusWeekNumber(r);
    }, t.prototype.render = function() {
      var r = this.props, n = r.weekNumber, a = r.isWeekDisabled, s = r.ariaLabelPrefix, i = s === void 0 ? t.defaultProps.ariaLabelPrefix : s, o = r.onClick, l = {
        "react-datepicker__week-number": !0,
        "react-datepicker__week-number--clickable": !!o && !a,
        "react-datepicker__week-number--selected": !!o && Sr(this.props.date, this.props.selected)
      };
      return M.createElement("div", { ref: this.weekNumberEl, className: Pa(l), "aria-label": "".concat(i, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, n);
    }, t;
  }(Cn)
), one = (
  /** @class */
  function(e) {
    ya(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.isDisabled = function(n) {
        return ii(n, {
          minDate: r.props.minDate,
          maxDate: r.props.maxDate,
          excludeDates: r.props.excludeDates,
          excludeDateIntervals: r.props.excludeDateIntervals,
          includeDateIntervals: r.props.includeDateIntervals,
          includeDates: r.props.includeDates,
          filterDate: r.props.filterDate
        });
      }, r.handleDayClick = function(n, a) {
        r.props.onDayClick && r.props.onDayClick(n, a);
      }, r.handleDayMouseEnter = function(n) {
        r.props.onDayMouseEnter && r.props.onDayMouseEnter(n);
      }, r.handleWeekClick = function(n, a, s) {
        for (var i, o, l, c = new Date(n), u = 0; u < 7; u++) {
          var d = new Date(n);
          d.setDate(d.getDate() + u);
          var f = !r.isDisabled(d);
          if (f) {
            c = d;
            break;
          }
        }
        typeof r.props.onWeekSelect == "function" && r.props.onWeekSelect(c, a, s), r.props.showWeekPicker && r.handleDayClick(c, s), ((i = r.props.shouldCloseOnSelect) !== null && i !== void 0 ? i : t.defaultProps.shouldCloseOnSelect) && ((l = (o = r.props).setOpen) === null || l === void 0 || l.call(o, !1));
      }, r.formatWeekNumber = function(n) {
        return r.props.formatWeekNumber ? r.props.formatWeekNumber(n) : Ure(n);
      }, r.isWeekDisabled = function() {
        for (var n = r.startOfWeek(), a = Fi(n, 6), s = new Date(n); s <= a; ) {
          if (!r.isDisabled(s))
            return !1;
          s = Fi(s, 1);
        }
        return !0;
      }, r.renderDays = function() {
        var n = r.startOfWeek(), a = [], s = r.formatWeekNumber(n);
        if (r.props.showWeekNumber) {
          var i = r.props.onWeekSelect || r.props.showWeekPicker ? r.handleWeekClick.bind(r, n, s) : void 0;
          a.push(M.createElement(ine, kr({ key: "W" }, t.defaultProps, r.props, { weekNumber: s, isWeekDisabled: r.isWeekDisabled(), date: n, onClick: i })));
        }
        return a.concat([0, 1, 2, 3, 4, 5, 6].map(function(o) {
          var l = Fi(n, o);
          return M.createElement(sne, kr({}, t.defaultProps, r.props, { ariaLabelPrefixWhenEnabled: r.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: r.props.disabledDayAriaLabelPrefix, key: l.valueOf(), day: l, onClick: r.handleDayClick.bind(r, l), onMouseEnter: r.handleDayMouseEnter.bind(r, l) }));
        }));
      }, r.startOfWeek = function() {
        return Ec(r.props.day, r.props.locale, r.props.calendarStartDay);
      }, r.isKeyboardSelected = function() {
        return !r.props.disabledKeyboardNavigation && !Sr(r.startOfWeek(), r.props.selected) && Sr(r.startOfWeek(), r.props.preSelection);
      }, r;
    }
    return Object.defineProperty(t, "defaultProps", {
      get: function() {
        return {
          shouldCloseOnSelect: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.render = function() {
      var r = {
        "react-datepicker__week": !0,
        "react-datepicker__week--selected": Sr(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return M.createElement("div", { className: Pa(r) }, this.renderDays());
    }, t;
  }(Cn)
), dp, lne = 6, Lf = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
}, K1 = (dp = {}, dp[Lf.TWO_COLUMNS] = {
  grid: [
    [0, 1],
    [2, 3],
    [4, 5],
    [6, 7],
    [8, 9],
    [10, 11]
  ],
  verticalNavigationOffset: 2
}, dp[Lf.THREE_COLUMNS] = {
  grid: [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [9, 10, 11]
  ],
  verticalNavigationOffset: 3
}, dp[Lf.FOUR_COLUMNS] = {
  grid: [
    [0, 1, 2, 3],
    [4, 5, 6, 7],
    [8, 9, 10, 11]
  ],
  verticalNavigationOffset: 4
}, dp), Qv = 1;
function kP(e, t) {
  return e ? Lf.FOUR_COLUMNS : t ? Lf.TWO_COLUMNS : Lf.THREE_COLUMNS;
}
var cne = (
  /** @class */
  function(e) {
    ya(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.MONTH_REFS = Eo([], Array(12), !0).map(function() {
        return Cc();
      }), r.QUARTER_REFS = Eo([], Array(4), !0).map(function() {
        return Cc();
      }), r.isDisabled = function(n) {
        return ii(n, {
          minDate: r.props.minDate,
          maxDate: r.props.maxDate,
          excludeDates: r.props.excludeDates,
          excludeDateIntervals: r.props.excludeDateIntervals,
          includeDateIntervals: r.props.includeDateIntervals,
          includeDates: r.props.includeDates,
          filterDate: r.props.filterDate
        });
      }, r.isExcluded = function(n) {
        return hC(n, {
          excludeDates: r.props.excludeDates,
          excludeDateIntervals: r.props.excludeDateIntervals
        });
      }, r.handleDayClick = function(n, a) {
        var s, i;
        (i = (s = r.props).onDayClick) === null || i === void 0 || i.call(s, n, a, r.props.orderInDisplay);
      }, r.handleDayMouseEnter = function(n) {
        var a, s;
        (s = (a = r.props).onDayMouseEnter) === null || s === void 0 || s.call(a, n);
      }, r.handleMouseLeave = function() {
        var n, a;
        (a = (n = r.props).onMouseLeave) === null || a === void 0 || a.call(n);
      }, r.isRangeStartMonth = function(n) {
        var a = r.props, s = a.day, i = a.startDate, o = a.endDate;
        return !i || !o ? !1 : os(js(s, n), i);
      }, r.isRangeStartQuarter = function(n) {
        var a = r.props, s = a.day, i = a.startDate, o = a.endDate;
        return !i || !o ? !1 : db(cf(s, n), i);
      }, r.isRangeEndMonth = function(n) {
        var a = r.props, s = a.day, i = a.startDate, o = a.endDate;
        return !i || !o ? !1 : os(js(s, n), o);
      }, r.isRangeEndQuarter = function(n) {
        var a = r.props, s = a.day, i = a.startDate, o = a.endDate;
        return !i || !o ? !1 : db(cf(s, n), o);
      }, r.isInSelectingRangeMonth = function(n) {
        var a, s = r.props, i = s.day, o = s.selectsStart, l = s.selectsEnd, c = s.selectsRange, u = s.startDate, d = s.endDate, f = (a = r.props.selectingDate) !== null && a !== void 0 ? a : r.props.preSelection;
        return !(o || l || c) || !f ? !1 : o && d ? qv(f, d, n, i) : l && u || c && u && !d ? qv(u, f, n, i) : !1;
      }, r.isSelectingMonthRangeStart = function(n) {
        var a;
        if (!r.isInSelectingRangeMonth(n))
          return !1;
        var s = r.props, i = s.day, o = s.startDate, l = s.selectsStart, c = js(i, n), u = (a = r.props.selectingDate) !== null && a !== void 0 ? a : r.props.preSelection;
        return l ? os(c, u) : os(c, o);
      }, r.isSelectingMonthRangeEnd = function(n) {
        var a;
        if (!r.isInSelectingRangeMonth(n))
          return !1;
        var s = r.props, i = s.day, o = s.endDate, l = s.selectsEnd, c = s.selectsRange, u = js(i, n), d = (a = r.props.selectingDate) !== null && a !== void 0 ? a : r.props.preSelection;
        return l || c ? os(u, d) : os(u, o);
      }, r.isInSelectingRangeQuarter = function(n) {
        var a, s = r.props, i = s.day, o = s.selectsStart, l = s.selectsEnd, c = s.selectsRange, u = s.startDate, d = s.endDate, f = (a = r.props.selectingDate) !== null && a !== void 0 ? a : r.props.preSelection;
        return !(o || l || c) || !f ? !1 : o && d ? Xv(f, d, n, i) : l && u || c && u && !d ? Xv(u, f, n, i) : !1;
      }, r.isWeekInMonth = function(n) {
        var a = r.props.day, s = Fi(n, 6);
        return os(n, a) || os(s, a);
      }, r.isCurrentMonth = function(n, a) {
        return mr(n) === mr(Qr()) && a === us(Qr());
      }, r.isCurrentQuarter = function(n, a) {
        return mr(n) === mr(Qr()) && a === Ru(Qr());
      }, r.isSelectedMonth = function(n, a, s) {
        return us(s) === a && mr(n) === mr(s);
      }, r.isSelectMonthInList = function(n, a, s) {
        return s.some(function(i) {
          return r.isSelectedMonth(n, a, i);
        });
      }, r.isSelectedQuarter = function(n, a, s) {
        return Ru(n) === a && mr(n) === mr(s);
      }, r.renderWeeks = function() {
        for (var n = [], a = r.props.fixedHeight, s = 0, i = !1, o = Ec(Rl(r.props.day), r.props.locale, r.props.calendarStartDay), l = function(p) {
          return r.props.showWeekPicker ? Ec(p, r.props.locale, r.props.calendarStartDay) : r.props.preSelection;
        }, c = function(p) {
          return r.props.showWeekPicker ? Ec(p, r.props.locale, r.props.calendarStartDay) : r.props.selected;
        }, u = r.props.selected ? c(r.props.selected) : void 0, d = r.props.preSelection ? l(r.props.preSelection) : void 0; n.push(M.createElement(one, kr({}, r.props, { ariaLabelPrefix: r.props.weekAriaLabelPrefix, key: s, day: o, month: us(r.props.day), onDayClick: r.handleDayClick, onDayMouseEnter: r.handleDayMouseEnter, selected: u, preSelection: d, showWeekNumber: r.props.showWeekNumbers }))), !i; ) {
          s++, o = Zy(o, 1);
          var f = a && s >= lne, h = !a && !r.isWeekInMonth(o);
          if (f || h)
            if (r.props.peekNextMonth)
              i = !0;
            else
              break;
        }
        return n;
      }, r.onMonthClick = function(n, a) {
        var s = r.isMonthDisabledForLabelDate(a), i = s.isDisabled, o = s.labelDate;
        i || r.handleDayClick(Rl(o), n);
      }, r.onMonthMouseEnter = function(n) {
        var a = r.isMonthDisabledForLabelDate(n), s = a.isDisabled, i = a.labelDate;
        s || r.handleDayMouseEnter(Rl(i));
      }, r.handleMonthNavigation = function(n, a) {
        var s, i, o, l;
        (i = (s = r.props).setPreSelection) === null || i === void 0 || i.call(s, a), (l = (o = r.MONTH_REFS[n]) === null || o === void 0 ? void 0 : o.current) === null || l === void 0 || l.focus();
      }, r.handleKeyboardNavigation = function(n, a, s) {
        var i, o = r.props, l = o.selected, c = o.preSelection, u = o.setPreSelection, d = o.minDate, f = o.maxDate, h = o.showFourColumnMonthYearPicker, p = o.showTwoColumnMonthYearPicker;
        if (c) {
          var m = kP(h, p), g = r.getVerticalOffset(m), y = (i = K1[m]) === null || i === void 0 ? void 0 : i.grid, x = function(E, O, k) {
            var A, P, D = O, N = k;
            switch (E) {
              case Tt.ArrowRight:
                D = $i(O, Qv), N = k === 11 ? 0 : k + Qv;
                break;
              case Tt.ArrowLeft:
                D = Iu(O, Qv), N = k === 0 ? 11 : k - Qv;
                break;
              case Tt.ArrowUp:
                D = Iu(O, g), N = !((A = y == null ? void 0 : y[0]) === null || A === void 0) && A.includes(k) ? k + 12 - g : k - g;
                break;
              case Tt.ArrowDown:
                D = $i(O, g), N = !((P = y == null ? void 0 : y[y.length - 1]) === null || P === void 0) && P.includes(k) ? k - 12 + g : k + g;
                break;
            }
            return { newCalculatedDate: D, newCalculatedMonth: N };
          }, w = function(E, O, k) {
            for (var A = 40, P = E, D = !1, N = 0, z = x(P, O, k), G = z.newCalculatedDate, Y = z.newCalculatedMonth; !D; ) {
              if (N >= A) {
                G = O, Y = k;
                break;
              }
              if (d && G < d) {
                P = Tt.ArrowRight;
                var te = x(P, G, Y);
                G = te.newCalculatedDate, Y = te.newCalculatedMonth;
              }
              if (f && G > f) {
                P = Tt.ArrowLeft;
                var te = x(P, G, Y);
                G = te.newCalculatedDate, Y = te.newCalculatedMonth;
              }
              if (Gre(G, r.props)) {
                var te = x(P, G, Y);
                G = te.newCalculatedDate, Y = te.newCalculatedMonth;
              } else
                D = !0;
              N++;
            }
            return { newCalculatedDate: G, newCalculatedMonth: Y };
          };
          if (a === Tt.Enter) {
            r.isMonthDisabled(s) || (r.onMonthClick(n, s), u == null || u(l));
            return;
          }
          var _ = w(a, c, s), S = _.newCalculatedDate, C = _.newCalculatedMonth;
          switch (a) {
            case Tt.ArrowRight:
            case Tt.ArrowLeft:
            case Tt.ArrowUp:
            case Tt.ArrowDown:
              r.handleMonthNavigation(C, S);
              break;
          }
        }
      }, r.getVerticalOffset = function(n) {
        var a, s;
        return (s = (a = K1[n]) === null || a === void 0 ? void 0 : a.verticalNavigationOffset) !== null && s !== void 0 ? s : 0;
      }, r.onMonthKeyDown = function(n, a) {
        var s = r.props, i = s.disabledKeyboardNavigation, o = s.handleOnMonthKeyDown, l = n.key;
        l !== Tt.Tab && n.preventDefault(), i || r.handleKeyboardNavigation(n, l, a), o && o(n);
      }, r.onQuarterClick = function(n, a) {
        var s = cf(r.props.day, a);
        Gv(s, r.props) || r.handleDayClick(fP(s), n);
      }, r.onQuarterMouseEnter = function(n) {
        var a = cf(r.props.day, n);
        Gv(a, r.props) || r.handleDayMouseEnter(fP(a));
      }, r.handleQuarterNavigation = function(n, a) {
        var s, i, o, l;
        r.isDisabled(a) || r.isExcluded(a) || ((i = (s = r.props).setPreSelection) === null || i === void 0 || i.call(s, a), (l = (o = r.QUARTER_REFS[n - 1]) === null || o === void 0 ? void 0 : o.current) === null || l === void 0 || l.focus());
      }, r.onQuarterKeyDown = function(n, a) {
        var s, i, o = n.key;
        if (!r.props.disabledKeyboardNavigation)
          switch (o) {
            case Tt.Enter:
              r.onQuarterClick(n, a), (i = (s = r.props).setPreSelection) === null || i === void 0 || i.call(s, r.props.selected);
              break;
            case Tt.ArrowRight:
              if (!r.props.preSelection)
                break;
              r.handleQuarterNavigation(a === 4 ? 1 : a + 1, tC(r.props.preSelection, 1));
              break;
            case Tt.ArrowLeft:
              if (!r.props.preSelection)
                break;
              r.handleQuarterNavigation(a === 1 ? 4 : a - 1, l5(r.props.preSelection));
              break;
          }
      }, r.isMonthDisabledForLabelDate = function(n) {
        var a, s = r.props, i = s.day, o = s.minDate, l = s.maxDate, c = s.excludeDates, u = s.includeDates, d = js(i, n);
        return {
          isDisabled: (a = (o || l || c || u) && S5(d, r.props)) !== null && a !== void 0 ? a : !1,
          labelDate: d
        };
      }, r.isMonthDisabled = function(n) {
        var a = r.isMonthDisabledForLabelDate(n).isDisabled;
        return a;
      }, r.getMonthClassNames = function(n) {
        var a = r.props, s = a.day, i = a.startDate, o = a.endDate, l = a.preSelection, c = a.monthClassName, u = c ? c(js(s, n)) : void 0, d = r.getSelection();
        return Pa("react-datepicker__month-text", "react-datepicker__month-".concat(n), u, {
          "react-datepicker__month-text--disabled": r.isMonthDisabled(n),
          "react-datepicker__month-text--selected": d ? r.isSelectMonthInList(s, n, d) : void 0,
          "react-datepicker__month-text--keyboard-selected": !r.props.disabledKeyboardNavigation && l && r.isSelectedMonth(s, n, l) && !r.isMonthDisabled(n),
          "react-datepicker__month-text--in-selecting-range": r.isInSelectingRangeMonth(n),
          "react-datepicker__month-text--in-range": i && o ? qv(i, o, n, s) : void 0,
          "react-datepicker__month-text--range-start": r.isRangeStartMonth(n),
          "react-datepicker__month-text--range-end": r.isRangeEndMonth(n),
          "react-datepicker__month-text--selecting-range-start": r.isSelectingMonthRangeStart(n),
          "react-datepicker__month-text--selecting-range-end": r.isSelectingMonthRangeEnd(n),
          "react-datepicker__month-text--today": r.isCurrentMonth(s, n)
        });
      }, r.getTabIndex = function(n) {
        if (r.props.preSelection == null)
          return "-1";
        var a = us(r.props.preSelection), s = r.isMonthDisabledForLabelDate(a).isDisabled, i = n === a && !(s || r.props.disabledKeyboardNavigation) ? "0" : "-1";
        return i;
      }, r.getQuarterTabIndex = function(n) {
        if (r.props.preSelection == null)
          return "-1";
        var a = Ru(r.props.preSelection), s = Gv(r.props.day, r.props), i = n === a && !(s || r.props.disabledKeyboardNavigation) ? "0" : "-1";
        return i;
      }, r.getAriaLabel = function(n) {
        var a = r.props, s = a.chooseDayAriaLabelPrefix, i = s === void 0 ? "Choose" : s, o = a.disabledDayAriaLabelPrefix, l = o === void 0 ? "Not available" : o, c = a.day, u = a.locale, d = js(c, n), f = r.isDisabled(d) || r.isExcluded(d) ? l : i;
        return "".concat(f, " ").concat(gn(d, "MMMM yyyy", u));
      }, r.getQuarterClassNames = function(n) {
        var a = r.props, s = a.day, i = a.startDate, o = a.endDate, l = a.selected, c = a.minDate, u = a.maxDate, d = a.excludeDates, f = a.includeDates, h = a.filterDate, p = a.preSelection, m = a.disabledKeyboardNavigation, g = (c || u || d || f || h) && Gv(cf(s, n), r.props);
        return Pa("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(n), {
          "react-datepicker__quarter-text--disabled": g,
          "react-datepicker__quarter-text--selected": l ? r.isSelectedQuarter(s, n, l) : void 0,
          "react-datepicker__quarter-text--keyboard-selected": !m && p && r.isSelectedQuarter(s, n, p) && !g,
          "react-datepicker__quarter-text--in-selecting-range": r.isInSelectingRangeQuarter(n),
          "react-datepicker__quarter-text--in-range": i && o ? Xv(i, o, n, s) : void 0,
          "react-datepicker__quarter-text--range-start": r.isRangeStartQuarter(n),
          "react-datepicker__quarter-text--range-end": r.isRangeEndQuarter(n)
        });
      }, r.getMonthContent = function(n) {
        var a = r.props, s = a.showFullMonthYearPicker, i = a.renderMonthContent, o = a.locale, l = a.day, c = _5(n, o), u = fC(n, o);
        return i ? i(n, c, u, l) : s ? u : c;
      }, r.getQuarterContent = function(n) {
        var a, s = r.props, i = s.renderQuarterContent, o = s.locale, l = qre(n, o);
        return (a = i == null ? void 0 : i(n, l)) !== null && a !== void 0 ? a : l;
      }, r.renderMonths = function() {
        var n, a = r.props, s = a.showTwoColumnMonthYearPicker, i = a.showFourColumnMonthYearPicker, o = a.day, l = a.selected, c = (n = K1[kP(i, s)]) === null || n === void 0 ? void 0 : n.grid;
        return c == null ? void 0 : c.map(function(u, d) {
          return M.createElement("div", { className: "react-datepicker__month-wrapper", key: d }, u.map(function(f, h) {
            return M.createElement("div", { ref: r.MONTH_REFS[f], key: h, onClick: function(p) {
              r.onMonthClick(p, f);
            }, onKeyDown: function(p) {
              C5(p) && (p.preventDefault(), p.key = Tt.Enter), r.onMonthKeyDown(p, f);
            }, onMouseEnter: r.props.usePointerEvent ? void 0 : function() {
              return r.onMonthMouseEnter(f);
            }, onPointerEnter: r.props.usePointerEvent ? function() {
              return r.onMonthMouseEnter(f);
            } : void 0, tabIndex: Number(r.getTabIndex(f)), className: r.getMonthClassNames(f), "aria-disabled": r.isMonthDisabled(f), role: "option", "aria-label": r.getAriaLabel(f), "aria-current": r.isCurrentMonth(o, f) ? "date" : void 0, "aria-selected": l ? r.isSelectedMonth(o, f, l) : void 0 }, r.getMonthContent(f));
          }));
        });
      }, r.renderQuarters = function() {
        var n = r.props, a = n.day, s = n.selected, i = [1, 2, 3, 4];
        return M.createElement("div", { className: "react-datepicker__quarter-wrapper" }, i.map(function(o, l) {
          return M.createElement("div", { key: l, ref: r.QUARTER_REFS[l], role: "option", onClick: function(c) {
            r.onQuarterClick(c, o);
          }, onKeyDown: function(c) {
            r.onQuarterKeyDown(c, o);
          }, onMouseEnter: r.props.usePointerEvent ? void 0 : function() {
            return r.onQuarterMouseEnter(o);
          }, onPointerEnter: r.props.usePointerEvent ? function() {
            return r.onQuarterMouseEnter(o);
          } : void 0, className: r.getQuarterClassNames(o), "aria-selected": s ? r.isSelectedQuarter(a, o, s) : void 0, tabIndex: Number(r.getQuarterTabIndex(o)), "aria-current": r.isCurrentQuarter(a, o) ? "date" : void 0 }, r.getQuarterContent(o));
        }));
      }, r.getClassNames = function() {
        var n = r.props, a = n.selectingDate, s = n.selectsStart, i = n.selectsEnd, o = n.showMonthYearPicker, l = n.showQuarterYearPicker, c = n.showWeekPicker;
        return Pa("react-datepicker__month", {
          "react-datepicker__month--selecting-range": a && (s || i)
        }, { "react-datepicker__monthPicker": o }, { "react-datepicker__quarterPicker": l }, { "react-datepicker__weekPicker": c });
      }, r;
    }
    return t.prototype.getSelection = function() {
      var r = this.props, n = r.selected, a = r.selectedDates, s = r.selectsMultiple;
      if (s)
        return a;
      if (n)
        return [n];
    }, t.prototype.render = function() {
      var r = this.props, n = r.showMonthYearPicker, a = r.showQuarterYearPicker, s = r.day, i = r.ariaLabelPrefix, o = i === void 0 ? "Month " : i, l = o ? o.trim() + " " : "";
      return M.createElement("div", { className: this.getClassNames(), onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave, onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0, "aria-label": "".concat(l).concat(gn(s, "MMMM, yyyy", this.props.locale)), role: "listbox" }, n ? this.renderMonths() : a ? this.renderQuarters() : this.renderWeeks());
    }, t;
  }(Cn)
), une = (
  /** @class */
  function(e) {
    ya(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.isSelectedMonth = function(n) {
        return r.props.month === n;
      }, r.renderOptions = function() {
        return r.props.monthNames.map(function(n, a) {
          return M.createElement(
            "div",
            { className: r.isSelectedMonth(a) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: n, onClick: r.onChange.bind(r, a), "aria-selected": r.isSelectedMonth(a) ? "true" : void 0 },
            r.isSelectedMonth(a) ? M.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "",
            n
          );
        });
      }, r.onChange = function(n) {
        return r.props.onChange(n);
      }, r.handleClickOutside = function() {
        return r.props.onCancel();
      }, r;
    }
    return t.prototype.render = function() {
      return M.createElement(Uw, { className: "react-datepicker__month-dropdown", onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, t;
  }(Cn)
), dne = (
  /** @class */
  function(e) {
    ya(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.state = {
        dropdownVisible: !1
      }, r.renderSelectOptions = function(n) {
        return n.map(function(a, s) {
          return M.createElement("option", { key: a, value: s }, a);
        });
      }, r.renderSelectMode = function(n) {
        return M.createElement("select", { value: r.props.month, className: "react-datepicker__month-select", onChange: function(a) {
          return r.onChange(parseInt(a.target.value));
        } }, r.renderSelectOptions(n));
      }, r.renderReadView = function(n, a) {
        return M.createElement(
          "div",
          { key: "read", style: { visibility: n ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: r.toggleDropdown },
          M.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
          M.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, a[r.props.month])
        );
      }, r.renderDropdown = function(n) {
        return M.createElement(une, kr({ key: "dropdown" }, r.props, { monthNames: n, onChange: r.onChange, onCancel: r.toggleDropdown }));
      }, r.renderScrollMode = function(n) {
        var a = r.state.dropdownVisible, s = [r.renderReadView(!a, n)];
        return a && s.unshift(r.renderDropdown(n)), s;
      }, r.onChange = function(n) {
        r.toggleDropdown(), n !== r.props.month && r.props.onChange(n);
      }, r.toggleDropdown = function() {
        return r.setState({
          dropdownVisible: !r.state.dropdownVisible
        });
      }, r;
    }
    return t.prototype.render = function() {
      var r = this, n = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(s) {
        return _5(s, r.props.locale);
      } : function(s) {
        return fC(s, r.props.locale);
      }), a;
      switch (this.props.dropdownMode) {
        case "scroll":
          a = this.renderScrollMode(n);
          break;
        case "select":
          a = this.renderSelectMode(n);
          break;
      }
      return M.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, a);
    }, t;
  }(Cn)
);
function fne(e, t) {
  for (var r = [], n = Rl(e), a = Rl(t); !Ic(n, a); )
    r.push(Qr(n)), n = $i(n, 1);
  return r;
}
var hne = (
  /** @class */
  function(e) {
    ya(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.renderOptions = function() {
        return n.state.monthYearsList.map(function(a) {
          var s = wE(a), i = yo(n.props.date, a) && os(n.props.date, a);
          return M.createElement(
            "div",
            { className: i ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: s, onClick: n.onChange.bind(n, s), "aria-selected": i ? "true" : void 0 },
            i ? M.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "",
            gn(a, n.props.dateFormat, n.props.locale)
          );
        });
      }, n.onChange = function(a) {
        return n.props.onChange(a);
      }, n.handleClickOutside = function() {
        n.props.onCancel();
      }, n.state = {
        monthYearsList: fne(n.props.minDate, n.props.maxDate)
      }, n;
    }
    return t.prototype.render = function() {
      var r = Pa({
        "react-datepicker__month-year-dropdown": !0,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return M.createElement(Uw, { className: r, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, t;
  }(Cn)
), pne = (
  /** @class */
  function(e) {
    ya(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.state = {
        dropdownVisible: !1
      }, r.renderSelectOptions = function() {
        for (var n = Rl(r.props.minDate), a = Rl(r.props.maxDate), s = []; !Ic(n, a); ) {
          var i = wE(n);
          s.push(M.createElement("option", { key: i, value: i }, gn(n, r.props.dateFormat, r.props.locale))), n = $i(n, 1);
        }
        return s;
      }, r.onSelectChange = function(n) {
        r.onChange(parseInt(n.target.value));
      }, r.renderSelectMode = function() {
        return M.createElement("select", { value: wE(Rl(r.props.date)), className: "react-datepicker__month-year-select", onChange: r.onSelectChange }, r.renderSelectOptions());
      }, r.renderReadView = function(n) {
        var a = gn(r.props.date, r.props.dateFormat, r.props.locale);
        return M.createElement(
          "div",
          { key: "read", style: { visibility: n ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: r.toggleDropdown },
          M.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
          M.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, a)
        );
      }, r.renderDropdown = function() {
        return M.createElement(hne, kr({ key: "dropdown" }, r.props, { onChange: r.onChange, onCancel: r.toggleDropdown }));
      }, r.renderScrollMode = function() {
        var n = r.state.dropdownVisible, a = [r.renderReadView(!n)];
        return n && a.unshift(r.renderDropdown()), a;
      }, r.onChange = function(n) {
        r.toggleDropdown();
        var a = Qr(n);
        yo(r.props.date, a) && os(r.props.date, a) || r.props.onChange(a);
      }, r.toggleDropdown = function() {
        return r.setState({
          dropdownVisible: !r.state.dropdownVisible
        });
      }, r;
    }
    return t.prototype.render = function() {
      var r;
      switch (this.props.dropdownMode) {
        case "scroll":
          r = this.renderScrollMode();
          break;
        case "select":
          r = this.renderSelectMode();
          break;
      }
      return M.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, r);
    }, t;
  }(Cn)
), mne = (
  /** @class */
  function(e) {
    ya(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.state = {
        height: null
      }, r.scrollToTheSelectedTime = function() {
        requestAnimationFrame(function() {
          var n, a, s;
          r.list && (r.list.scrollTop = (s = r.centerLi && t.calcCenterPosition(r.props.monthRef ? r.props.monthRef.clientHeight - ((a = (n = r.header) === null || n === void 0 ? void 0 : n.clientHeight) !== null && a !== void 0 ? a : 0) : r.list.clientHeight, r.centerLi)) !== null && s !== void 0 ? s : 0);
        });
      }, r.handleClick = function(n) {
        var a, s;
        (r.props.minTime || r.props.maxTime) && vP(n, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && gP(n, r.props) || (s = (a = r.props).onChange) === null || s === void 0 || s.call(a, n);
      }, r.isSelectedTime = function(n) {
        return r.props.selected && nne(r.props.selected, n);
      }, r.isDisabledTime = function(n) {
        return (r.props.minTime || r.props.maxTime) && vP(n, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && gP(n, r.props);
      }, r.liClasses = function(n) {
        var a, s = [
          "react-datepicker__time-list-item",
          r.props.timeClassName ? r.props.timeClassName(n) : void 0
        ];
        return r.isSelectedTime(n) && s.push("react-datepicker__time-list-item--selected"), r.isDisabledTime(n) && s.push("react-datepicker__time-list-item--disabled"), r.props.injectTimes && (Po(n) * 3600 + Ro(n) * 60 + Pl(n)) % (((a = r.props.intervals) !== null && a !== void 0 ? a : t.defaultProps.intervals) * 60) !== 0 && s.push("react-datepicker__time-list-item--injected"), s.join(" ");
      }, r.handleOnKeyDown = function(n, a) {
        var s, i;
        n.key === Tt.Space && (n.preventDefault(), n.key = Tt.Enter), (n.key === Tt.ArrowUp || n.key === Tt.ArrowLeft) && n.target instanceof HTMLElement && n.target.previousSibling && (n.preventDefault(), n.target.previousSibling instanceof HTMLElement && n.target.previousSibling.focus()), (n.key === Tt.ArrowDown || n.key === Tt.ArrowRight) && n.target instanceof HTMLElement && n.target.nextSibling && (n.preventDefault(), n.target.nextSibling instanceof HTMLElement && n.target.nextSibling.focus()), n.key === Tt.Enter && r.handleClick(a), (i = (s = r.props).handleOnKeyDown) === null || i === void 0 || i.call(s, n);
      }, r.renderTimes = function() {
        for (var n, a = [], s = typeof r.props.format == "string" ? r.props.format : "p", i = (n = r.props.intervals) !== null && n !== void 0 ? n : t.defaultProps.intervals, o = r.props.selected || r.props.openToDate || Qr(), l = Sy(o), c = r.props.injectTimes && r.props.injectTimes.sort(function(g, y) {
          return g.getTime() - y.getTime();
        }), u = 60 * rne(o), d = u / i, f = 0; f < d; f++) {
          var h = vE(l, f * i);
          if (a.push(h), c) {
            var p = tne(l, h, f, i, c);
            a = a.concat(p);
          }
        }
        var m = a.reduce(function(g, y) {
          return y.getTime() <= o.getTime() ? y : g;
        }, a[0]);
        return a.map(function(g) {
          return M.createElement("li", { key: g.valueOf(), onClick: r.handleClick.bind(r, g), className: r.liClasses(g), ref: function(y) {
            g === m && (r.centerLi = y);
          }, onKeyDown: function(y) {
            r.handleOnKeyDown(y, g);
          }, tabIndex: g === m ? 0 : -1, role: "option", "aria-selected": r.isSelectedTime(g) ? "true" : void 0, "aria-disabled": r.isDisabledTime(g) ? "true" : void 0 }, gn(g, s, r.props.locale));
        });
      }, r.renderTimeCaption = function() {
        return r.props.showTimeCaption === !1 ? M.createElement(M.Fragment, null) : M.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--time ".concat(r.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(n) {
            r.header = n;
          } },
          M.createElement("div", { className: "react-datepicker-time__header" }, r.props.timeCaption)
        );
      }, r;
    }
    return Object.defineProperty(t, "defaultProps", {
      get: function() {
        return {
          intervals: 30,
          todayButton: null,
          timeCaption: "Time",
          showTimeCaption: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidMount = function() {
      this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
        height: this.props.monthRef.clientHeight - this.header.clientHeight
      });
    }, t.prototype.render = function() {
      var r = this, n, a = this.state.height;
      return M.createElement(
        "div",
        { className: "react-datepicker__time-container ".concat(((n = this.props.todayButton) !== null && n !== void 0 ? n : t.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "") },
        this.renderTimeCaption(),
        M.createElement(
          "div",
          { className: "react-datepicker__time" },
          M.createElement(
            "div",
            { className: "react-datepicker__time-box" },
            M.createElement("ul", { className: "react-datepicker__time-list", ref: function(s) {
              r.list = s;
            }, style: a ? { height: a } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes())
          )
        )
      );
    }, t.calcCenterPosition = function(r, n) {
      return n.offsetTop - (r / 2 - n.clientHeight / 2);
    }, t;
  }(Cn)
), OP = 3, gne = (
  /** @class */
  function(e) {
    ya(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.YEAR_REFS = Eo([], Array(n.props.yearItemNumber), !0).map(function() {
        return Cc();
      }), n.isDisabled = function(a) {
        return ii(a, {
          minDate: n.props.minDate,
          maxDate: n.props.maxDate,
          excludeDates: n.props.excludeDates,
          includeDates: n.props.includeDates,
          filterDate: n.props.filterDate
        });
      }, n.isExcluded = function(a) {
        return hC(a, {
          excludeDates: n.props.excludeDates
        });
      }, n.selectingDate = function() {
        var a;
        return (a = n.props.selectingDate) !== null && a !== void 0 ? a : n.props.preSelection;
      }, n.updateFocusOnPaginate = function(a) {
        var s = function() {
          var i, o;
          (o = (i = n.YEAR_REFS[a]) === null || i === void 0 ? void 0 : i.current) === null || o === void 0 || o.focus();
        };
        window.requestAnimationFrame(s);
      }, n.handleYearClick = function(a, s) {
        n.props.onDayClick && n.props.onDayClick(a, s);
      }, n.handleYearNavigation = function(a, s) {
        var i, o, l, c, u = n.props, d = u.date, f = u.yearItemNumber;
        if (!(d === void 0 || f === void 0)) {
          var h = pc(d, f).startPeriod;
          n.isDisabled(s) || n.isExcluded(s) || ((o = (i = n.props).setPreSelection) === null || o === void 0 || o.call(i, s), a - h < 0 ? n.updateFocusOnPaginate(f - (h - a)) : a - h >= f ? n.updateFocusOnPaginate(Math.abs(f - (a - h))) : (c = (l = n.YEAR_REFS[a - h]) === null || l === void 0 ? void 0 : l.current) === null || c === void 0 || c.focus());
        }
      }, n.isSameDay = function(a, s) {
        return Sr(a, s);
      }, n.isCurrentYear = function(a) {
        return a === mr(Qr());
      }, n.isRangeStart = function(a) {
        return n.props.startDate && n.props.endDate && yo(go(Qr(), a), n.props.startDate);
      }, n.isRangeEnd = function(a) {
        return n.props.startDate && n.props.endDate && yo(go(Qr(), a), n.props.endDate);
      }, n.isInRange = function(a) {
        return Yv(a, n.props.startDate, n.props.endDate);
      }, n.isInSelectingRange = function(a) {
        var s = n.props, i = s.selectsStart, o = s.selectsEnd, l = s.selectsRange, c = s.startDate, u = s.endDate;
        return !(i || o || l) || !n.selectingDate() ? !1 : i && u ? Yv(a, n.selectingDate(), u) : o && c || l && c && !u ? Yv(a, c, n.selectingDate()) : !1;
      }, n.isSelectingRangeStart = function(a) {
        var s;
        if (!n.isInSelectingRange(a))
          return !1;
        var i = n.props, o = i.startDate, l = i.selectsStart, c = go(Qr(), a);
        return l ? yo(c, (s = n.selectingDate()) !== null && s !== void 0 ? s : null) : yo(c, o ?? null);
      }, n.isSelectingRangeEnd = function(a) {
        var s;
        if (!n.isInSelectingRange(a))
          return !1;
        var i = n.props, o = i.endDate, l = i.selectsEnd, c = i.selectsRange, u = go(Qr(), a);
        return l || c ? yo(u, (s = n.selectingDate()) !== null && s !== void 0 ? s : null) : yo(u, o ?? null);
      }, n.isKeyboardSelected = function(a) {
        if (!(n.props.date === void 0 || n.props.selected == null || n.props.preSelection == null)) {
          var s = n.props, i = s.minDate, o = s.maxDate, l = s.excludeDates, c = s.includeDates, u = s.filterDate, d = Gp(go(n.props.date, a)), f = (i || o || l || c || u) && Ey(a, n.props);
          return !n.props.disabledKeyboardNavigation && !n.props.inline && !Sr(d, Gp(n.props.selected)) && Sr(d, Gp(n.props.preSelection)) && !f;
        }
      }, n.onYearClick = function(a, s) {
        var i = n.props.date;
        i !== void 0 && n.handleYearClick(Gp(go(i, s)), a);
      }, n.onYearKeyDown = function(a, s) {
        var i, o, l = a.key, c = n.props, u = c.date, d = c.yearItemNumber, f = c.handleOnKeyDown;
        if (l !== Tt.Tab && a.preventDefault(), !n.props.disabledKeyboardNavigation)
          switch (l) {
            case Tt.Enter:
              if (n.props.selected == null)
                break;
              n.onYearClick(a, s), (o = (i = n.props).setPreSelection) === null || o === void 0 || o.call(i, n.props.selected);
              break;
            case Tt.ArrowRight:
              if (n.props.preSelection == null)
                break;
              n.handleYearNavigation(s + 1, Ol(n.props.preSelection, 1));
              break;
            case Tt.ArrowLeft:
              if (n.props.preSelection == null)
                break;
              n.handleYearNavigation(s - 1, nh(n.props.preSelection, 1));
              break;
            case Tt.ArrowUp: {
              if (u === void 0 || d === void 0 || n.props.preSelection == null)
                break;
              var h = pc(u, d).startPeriod, p = OP, m = s - p;
              if (m < h) {
                var g = d % p;
                s >= h && s < h + g ? p = g : p += g, m = s - p;
              }
              n.handleYearNavigation(m, nh(n.props.preSelection, p));
              break;
            }
            case Tt.ArrowDown: {
              if (u === void 0 || d === void 0 || n.props.preSelection == null)
                break;
              var y = pc(u, d).endPeriod, p = OP, m = s + p;
              if (m > y) {
                var g = d % p;
                s <= y && s > y - g ? p = g : p += g, m = s + p;
              }
              n.handleYearNavigation(m, Ol(n.props.preSelection, p));
              break;
            }
          }
        f && f(a);
      }, n.getYearClassNames = function(a) {
        var s = n.props, i = s.date, o = s.minDate, l = s.maxDate, c = s.selected, u = s.excludeDates, d = s.includeDates, f = s.filterDate, h = s.yearClassName;
        return Pa("react-datepicker__year-text", "react-datepicker__year-".concat(a), i ? h == null ? void 0 : h(go(i, a)) : void 0, {
          "react-datepicker__year-text--selected": c ? a === mr(c) : void 0,
          "react-datepicker__year-text--disabled": (o || l || u || d || f) && Ey(a, n.props),
          "react-datepicker__year-text--keyboard-selected": n.isKeyboardSelected(a),
          "react-datepicker__year-text--range-start": n.isRangeStart(a),
          "react-datepicker__year-text--range-end": n.isRangeEnd(a),
          "react-datepicker__year-text--in-range": n.isInRange(a),
          "react-datepicker__year-text--in-selecting-range": n.isInSelectingRange(a),
          "react-datepicker__year-text--selecting-range-start": n.isSelectingRangeStart(a),
          "react-datepicker__year-text--selecting-range-end": n.isSelectingRangeEnd(a),
          "react-datepicker__year-text--today": n.isCurrentYear(a)
        });
      }, n.getYearTabIndex = function(a) {
        if (n.props.disabledKeyboardNavigation || n.props.preSelection == null)
          return "-1";
        var s = mr(n.props.preSelection), i = Ey(a, n.props);
        return a === s && !i ? "0" : "-1";
      }, n.getYearContent = function(a) {
        return n.props.renderYearContent ? n.props.renderYearContent(a) : a;
      }, n;
    }
    return t.prototype.render = function() {
      var r = this, n = [], a = this.props, s = a.date, i = a.yearItemNumber, o = a.onYearMouseEnter, l = a.onYearMouseLeave;
      if (s === void 0)
        return null;
      for (var c = pc(s, i), u = c.startPeriod, d = c.endPeriod, f = function(m) {
        n.push(M.createElement("div", { ref: h.YEAR_REFS[m - u], onClick: function(g) {
          r.onYearClick(g, m);
        }, onKeyDown: function(g) {
          C5(g) && (g.preventDefault(), g.key = Tt.Enter), r.onYearKeyDown(g, m);
        }, tabIndex: Number(h.getYearTabIndex(m)), className: h.getYearClassNames(m), onMouseEnter: h.props.usePointerEvent ? void 0 : function(g) {
          return o(g, m);
        }, onPointerEnter: h.props.usePointerEvent ? function(g) {
          return o(g, m);
        } : void 0, onMouseLeave: h.props.usePointerEvent ? void 0 : function(g) {
          return l(g, m);
        }, onPointerLeave: h.props.usePointerEvent ? function(g) {
          return l(g, m);
        } : void 0, key: m, "aria-current": h.isCurrentYear(m) ? "date" : void 0 }, h.getYearContent(m)));
      }, h = this, p = u; p <= d; p++)
        f(p);
      return M.createElement(
        "div",
        { className: "react-datepicker__year" },
        M.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate, onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0 }, n)
      );
    }, t;
  }(Cn)
);
function vne(e, t, r, n) {
  for (var a = [], s = 0; s < 2 * t + 1; s++) {
    var i = e + t - s, o = !0;
    r && (o = mr(r) <= i), n && o && (o = mr(n) >= i), o && a.push(i);
  }
  return a;
}
var yne = (
  /** @class */
  function(e) {
    ya(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      n.renderOptions = function() {
        var o = n.props.year, l = n.state.yearsList.map(function(d) {
          return M.createElement(
            "div",
            { className: o === d ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: d, onClick: n.onChange.bind(n, d), "aria-selected": o === d ? "true" : void 0 },
            o === d ? M.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "",
            d
          );
        }), c = n.props.minDate ? mr(n.props.minDate) : null, u = n.props.maxDate ? mr(n.props.maxDate) : null;
        return (!u || !n.state.yearsList.find(function(d) {
          return d === u;
        })) && l.unshift(M.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "upcoming", onClick: n.incrementYears },
          M.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        )), (!c || !n.state.yearsList.find(function(d) {
          return d === c;
        })) && l.push(M.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "previous", onClick: n.decrementYears },
          M.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        )), l;
      }, n.onChange = function(o) {
        n.props.onChange(o);
      }, n.handleClickOutside = function() {
        n.props.onCancel();
      }, n.shiftYears = function(o) {
        var l = n.state.yearsList.map(function(c) {
          return c + o;
        });
        n.setState({
          yearsList: l
        });
      }, n.incrementYears = function() {
        return n.shiftYears(1);
      }, n.decrementYears = function() {
        return n.shiftYears(-1);
      };
      var a = r.yearDropdownItemNumber, s = r.scrollableYearDropdown, i = a || (s ? 10 : 5);
      return n.state = {
        yearsList: vne(n.props.year, i, n.props.minDate, n.props.maxDate)
      }, n.dropdownRef = Cc(), n;
    }
    return t.prototype.componentDidMount = function() {
      var r = this.dropdownRef.current;
      if (r) {
        var n = r.children ? Array.from(r.children) : null, a = n ? n.find(function(s) {
          return s.ariaSelected;
        }) : null;
        r.scrollTop = a && a instanceof HTMLElement ? a.offsetTop + (a.clientHeight - r.clientHeight) / 2 : (r.scrollHeight - r.clientHeight) / 2;
      }
    }, t.prototype.render = function() {
      var r = Pa({
        "react-datepicker__year-dropdown": !0,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return M.createElement(Uw, { className: r, containerRef: this.dropdownRef, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, t;
  }(Cn)
), bne = (
  /** @class */
  function(e) {
    ya(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.state = {
        dropdownVisible: !1
      }, r.renderSelectOptions = function() {
        for (var n = r.props.minDate ? mr(r.props.minDate) : 1900, a = r.props.maxDate ? mr(r.props.maxDate) : 2100, s = [], i = n; i <= a; i++)
          s.push(M.createElement("option", { key: i, value: i }, i));
        return s;
      }, r.onSelectChange = function(n) {
        r.onChange(parseInt(n.target.value));
      }, r.renderSelectMode = function() {
        return M.createElement("select", { value: r.props.year, className: "react-datepicker__year-select", onChange: r.onSelectChange }, r.renderSelectOptions());
      }, r.renderReadView = function(n) {
        return M.createElement(
          "div",
          { key: "read", style: { visibility: n ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(a) {
            return r.toggleDropdown(a);
          } },
          M.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
          M.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, r.props.year)
        );
      }, r.renderDropdown = function() {
        return M.createElement(yne, kr({ key: "dropdown" }, r.props, { onChange: r.onChange, onCancel: r.toggleDropdown }));
      }, r.renderScrollMode = function() {
        var n = r.state.dropdownVisible, a = [r.renderReadView(!n)];
        return n && a.unshift(r.renderDropdown()), a;
      }, r.onChange = function(n) {
        r.toggleDropdown(), n !== r.props.year && r.props.onChange(n);
      }, r.toggleDropdown = function(n) {
        r.setState({
          dropdownVisible: !r.state.dropdownVisible
        }, function() {
          r.props.adjustDateOnChange && r.handleYearChange(r.props.date, n);
        });
      }, r.handleYearChange = function(n, a) {
        var s;
        (s = r.onSelect) === null || s === void 0 || s.call(r, n, a), r.setOpen();
      }, r.onSelect = function(n, a) {
        var s, i;
        (i = (s = r.props).onSelect) === null || i === void 0 || i.call(s, n, a);
      }, r.setOpen = function() {
        var n, a;
        (a = (n = r.props).setOpen) === null || a === void 0 || a.call(n, !0);
      }, r;
    }
    return t.prototype.render = function() {
      var r;
      switch (this.props.dropdownMode) {
        case "scroll":
          r = this.renderScrollMode();
          break;
        case "select":
          r = this.renderSelectMode();
          break;
      }
      return M.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, r);
    }, t;
  }(Cn)
), wne = [
  "react-datepicker__year-select",
  "react-datepicker__month-select",
  "react-datepicker__month-year-select"
], xne = function(e) {
  var t = (e.className || "").split(/\s+/);
  return wne.some(function(r) {
    return t.indexOf(r) >= 0;
  });
}, _ne = (
  /** @class */
  function(e) {
    ya(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.monthContainer = void 0, n.handleClickOutside = function(a) {
        n.props.onClickOutside(a);
      }, n.setClickOutsideRef = function() {
        return n.containerRef.current;
      }, n.handleDropdownFocus = function(a) {
        var s, i;
        xne(a.target) && ((i = (s = n.props).onDropdownFocus) === null || i === void 0 || i.call(s, a));
      }, n.getDateInView = function() {
        var a = n.props, s = a.preSelection, i = a.selected, o = a.openToDate, l = E5(n.props), c = T5(n.props), u = Qr(), d = o || i || s;
        return d || (l && Hu(u, l) ? l : c && Ic(u, c) ? c : u);
      }, n.increaseMonth = function() {
        n.setState(function(a) {
          var s = a.date;
          return {
            date: $i(s, 1)
          };
        }, function() {
          return n.handleMonthChange(n.state.date);
        });
      }, n.decreaseMonth = function() {
        n.setState(function(a) {
          var s = a.date;
          return {
            date: Iu(s, 1)
          };
        }, function() {
          return n.handleMonthChange(n.state.date);
        });
      }, n.handleDayClick = function(a, s, i) {
        n.props.onSelect(a, s, i), n.props.setPreSelection && n.props.setPreSelection(a);
      }, n.handleDayMouseEnter = function(a) {
        n.setState({ selectingDate: a }), n.props.onDayMouseEnter && n.props.onDayMouseEnter(a);
      }, n.handleMonthMouseLeave = function() {
        n.setState({ selectingDate: void 0 }), n.props.onMonthMouseLeave && n.props.onMonthMouseLeave();
      }, n.handleYearMouseEnter = function(a, s) {
        n.setState({ selectingDate: go(Qr(), s) }), n.props.onYearMouseEnter && n.props.onYearMouseEnter(a, s);
      }, n.handleYearMouseLeave = function(a, s) {
        n.props.onYearMouseLeave && n.props.onYearMouseLeave(a, s);
      }, n.handleYearChange = function(a) {
        var s, i, o, l;
        (i = (s = n.props).onYearChange) === null || i === void 0 || i.call(s, a), n.setState({ isRenderAriaLiveMessage: !0 }), n.props.adjustDateOnChange && (n.props.onSelect(a), (l = (o = n.props).setOpen) === null || l === void 0 || l.call(o, !0)), n.props.setPreSelection && n.props.setPreSelection(a);
      }, n.getEnabledPreSelectionDateForMonth = function(a) {
        if (!ii(a, n.props))
          return a;
        for (var s = Rl(a), i = Hre(a), o = bZ(i, s), l = null, c = 0; c <= o; c++) {
          var u = Fi(s, c);
          if (!ii(u, n.props)) {
            l = u;
            break;
          }
        }
        return l;
      }, n.handleMonthChange = function(a) {
        var s, i, o, l = (s = n.getEnabledPreSelectionDateForMonth(a)) !== null && s !== void 0 ? s : a;
        n.handleCustomMonthChange(l), n.props.adjustDateOnChange && (n.props.onSelect(l), (o = (i = n.props).setOpen) === null || o === void 0 || o.call(i, !0)), n.props.setPreSelection && n.props.setPreSelection(l);
      }, n.handleCustomMonthChange = function(a) {
        var s, i;
        (i = (s = n.props).onMonthChange) === null || i === void 0 || i.call(s, a), n.setState({ isRenderAriaLiveMessage: !0 });
      }, n.handleMonthYearChange = function(a) {
        n.handleYearChange(a), n.handleMonthChange(a);
      }, n.changeYear = function(a) {
        n.setState(function(s) {
          var i = s.date;
          return {
            date: go(i, Number(a))
          };
        }, function() {
          return n.handleYearChange(n.state.date);
        });
      }, n.changeMonth = function(a) {
        n.setState(function(s) {
          var i = s.date;
          return {
            date: js(i, Number(a))
          };
        }, function() {
          return n.handleMonthChange(n.state.date);
        });
      }, n.changeMonthYear = function(a) {
        n.setState(function(s) {
          var i = s.date;
          return {
            date: go(js(i, us(a)), mr(a))
          };
        }, function() {
          return n.handleMonthYearChange(n.state.date);
        });
      }, n.header = function(a) {
        a === void 0 && (a = n.state.date);
        var s = Ec(a, n.props.locale, n.props.calendarStartDay), i = [];
        return n.props.showWeekNumbers && i.push(M.createElement("div", { key: "W", className: "react-datepicker__day-name" }, n.props.weekLabel || "#")), i.concat([0, 1, 2, 3, 4, 5, 6].map(function(o) {
          var l = Fi(s, o), c = n.formatWeekday(l, n.props.locale), u = n.props.weekDayClassName ? n.props.weekDayClassName(l) : void 0;
          return M.createElement("div", { key: o, "aria-label": gn(l, "EEEE", n.props.locale), className: Pa("react-datepicker__day-name", u) }, c);
        }));
      }, n.formatWeekday = function(a, s) {
        return n.props.formatWeekDay ? Wre(a, n.props.formatWeekDay, s) : n.props.useWeekdaysShort ? Kre(a, s) : zre(a, s);
      }, n.decreaseYear = function() {
        n.setState(function(a) {
          var s, i = a.date;
          return {
            date: nh(i, n.props.showYearPicker ? (s = n.props.yearItemNumber) !== null && s !== void 0 ? s : t.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return n.handleYearChange(n.state.date);
        });
      }, n.clearSelectingDate = function() {
        n.setState({ selectingDate: void 0 });
      }, n.renderPreviousButton = function() {
        var a, s, i;
        if (!n.props.renderCustomHeader) {
          var o = (a = n.props.monthsShown) !== null && a !== void 0 ? a : t.defaultProps.monthsShown, l = n.props.showPreviousMonths ? o - 1 : 0, c = (s = n.props.monthSelectedIn) !== null && s !== void 0 ? s : l, u = Iu(n.state.date, c), d;
          switch (!0) {
            case n.props.showMonthYearPicker:
              d = wP(n.state.date, n.props);
              break;
            case n.props.showYearPicker:
              d = Qre(n.state.date, n.props);
              break;
            case n.props.showQuarterYearPicker:
              d = Yre(n.state.date, n.props);
              break;
            default:
              d = yP(u, n.props);
              break;
          }
          if (!(!((i = n.props.forceShowMonthNavigation) !== null && i !== void 0 ? i : t.defaultProps.forceShowMonthNavigation) && !n.props.showDisabledMonthNavigation && d || n.props.showTimeSelectOnly)) {
            var f = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--previous"
            ], h = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--previous"
            ], p = n.decreaseMonth;
            (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker) && (p = n.decreaseYear), d && n.props.showDisabledMonthNavigation && (h.push("react-datepicker__navigation--previous--disabled"), p = void 0);
            var m = n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker, g = n.props, y = g.previousMonthButtonLabel, x = y === void 0 ? t.defaultProps.previousMonthButtonLabel : y, w = g.previousYearButtonLabel, _ = w === void 0 ? t.defaultProps.previousYearButtonLabel : w, S = n.props, C = S.previousMonthAriaLabel, E = C === void 0 ? typeof x == "string" ? x : "Previous Month" : C, O = S.previousYearAriaLabel, k = O === void 0 ? typeof _ == "string" ? _ : "Previous Year" : O;
            return M.createElement(
              "button",
              { type: "button", className: h.join(" "), onClick: p, onKeyDown: n.props.handleOnKeyDown, "aria-label": m ? k : E },
              M.createElement("span", { className: f.join(" ") }, m ? _ : x)
            );
          }
        }
      }, n.increaseYear = function() {
        n.setState(function(a) {
          var s, i = a.date;
          return {
            date: Ol(i, n.props.showYearPicker ? (s = n.props.yearItemNumber) !== null && s !== void 0 ? s : t.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return n.handleYearChange(n.state.date);
        });
      }, n.renderNextButton = function() {
        var a;
        if (!n.props.renderCustomHeader) {
          var s;
          switch (!0) {
            case n.props.showMonthYearPicker:
              s = xP(n.state.date, n.props);
              break;
            case n.props.showYearPicker:
              s = Jre(n.state.date, n.props);
              break;
            case n.props.showQuarterYearPicker:
              s = Xre(n.state.date, n.props);
              break;
            default:
              s = bP(n.state.date, n.props);
              break;
          }
          if (!(!((a = n.props.forceShowMonthNavigation) !== null && a !== void 0 ? a : t.defaultProps.forceShowMonthNavigation) && !n.props.showDisabledMonthNavigation && s || n.props.showTimeSelectOnly)) {
            var i = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--next"
            ], o = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--next"
            ];
            n.props.showTimeSelect && i.push("react-datepicker__navigation--next--with-time"), n.props.todayButton && i.push("react-datepicker__navigation--next--with-today-button");
            var l = n.increaseMonth;
            (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker) && (l = n.increaseYear), s && n.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--next--disabled"), l = void 0);
            var c = n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker, u = n.props, d = u.nextMonthButtonLabel, f = d === void 0 ? t.defaultProps.nextMonthButtonLabel : d, h = u.nextYearButtonLabel, p = h === void 0 ? t.defaultProps.nextYearButtonLabel : h, m = n.props, g = m.nextMonthAriaLabel, y = g === void 0 ? typeof f == "string" ? f : "Next Month" : g, x = m.nextYearAriaLabel, w = x === void 0 ? typeof p == "string" ? p : "Next Year" : x;
            return M.createElement(
              "button",
              { type: "button", className: i.join(" "), onClick: l, onKeyDown: n.props.handleOnKeyDown, "aria-label": c ? w : y },
              M.createElement("span", { className: o.join(" ") }, c ? p : f)
            );
          }
        }
      }, n.renderCurrentMonth = function(a) {
        a === void 0 && (a = n.state.date);
        var s = ["react-datepicker__current-month"];
        return n.props.showYearDropdown && s.push("react-datepicker__current-month--hasYearDropdown"), n.props.showMonthDropdown && s.push("react-datepicker__current-month--hasMonthDropdown"), n.props.showMonthYearDropdown && s.push("react-datepicker__current-month--hasMonthYearDropdown"), M.createElement("h2", { className: s.join(" ") }, gn(a, n.props.dateFormat, n.props.locale));
      }, n.renderYearDropdown = function(a) {
        if (a === void 0 && (a = !1), !(!n.props.showYearDropdown || a))
          return M.createElement(bne, kr({}, t.defaultProps, n.props, { date: n.state.date, onChange: n.changeYear, year: mr(n.state.date) }));
      }, n.renderMonthDropdown = function(a) {
        if (a === void 0 && (a = !1), !(!n.props.showMonthDropdown || a))
          return M.createElement(dne, kr({}, t.defaultProps, n.props, { month: us(n.state.date), onChange: n.changeMonth }));
      }, n.renderMonthYearDropdown = function(a) {
        if (a === void 0 && (a = !1), !(!n.props.showMonthYearDropdown || a))
          return M.createElement(pne, kr({}, t.defaultProps, n.props, { date: n.state.date, onChange: n.changeMonthYear }));
      }, n.handleTodayButtonClick = function(a) {
        n.props.onSelect(hP(), a), n.props.setPreSelection && n.props.setPreSelection(hP());
      }, n.renderTodayButton = function() {
        if (!(!n.props.todayButton || n.props.showTimeSelectOnly))
          return M.createElement("div", { className: "react-datepicker__today-button", onClick: n.handleTodayButtonClick }, n.props.todayButton);
      }, n.renderDefaultHeader = function(a) {
        var s = a.monthDate, i = a.i;
        return M.createElement(
          "div",
          { className: "react-datepicker__header ".concat(n.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") },
          n.renderCurrentMonth(s),
          M.createElement(
            "div",
            { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(n.props.dropdownMode), onFocus: n.handleDropdownFocus },
            n.renderMonthDropdown(i !== 0),
            n.renderMonthYearDropdown(i !== 0),
            n.renderYearDropdown(i !== 0)
          ),
          M.createElement("div", { className: "react-datepicker__day-names" }, n.header(s))
        );
      }, n.renderCustomHeader = function(a) {
        var s, i, o = a.monthDate, l = a.i;
        if (n.props.showTimeSelect && !n.state.monthContainer || n.props.showTimeSelectOnly)
          return null;
        var c = yP(n.state.date, n.props), u = bP(n.state.date, n.props), d = wP(n.state.date, n.props), f = xP(n.state.date, n.props), h = !n.props.showMonthYearPicker && !n.props.showQuarterYearPicker && !n.props.showYearPicker;
        return M.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--custom", onFocus: n.props.onDropdownFocus },
          (i = (s = n.props).renderCustomHeader) === null || i === void 0 ? void 0 : i.call(s, kr(kr({}, n.state), { customHeaderCount: l, monthDate: o, changeMonth: n.changeMonth, changeYear: n.changeYear, decreaseMonth: n.decreaseMonth, increaseMonth: n.increaseMonth, decreaseYear: n.decreaseYear, increaseYear: n.increaseYear, prevMonthButtonDisabled: c, nextMonthButtonDisabled: u, prevYearButtonDisabled: d, nextYearButtonDisabled: f })),
          h && M.createElement("div", { className: "react-datepicker__day-names" }, n.header(o))
        );
      }, n.renderYearHeader = function(a) {
        var s = a.monthDate, i = n.props, o = i.showYearPicker, l = i.yearItemNumber, c = l === void 0 ? t.defaultProps.yearItemNumber : l, u = pc(s, c), d = u.startPeriod, f = u.endPeriod;
        return M.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, o ? "".concat(d, " - ").concat(f) : mr(s));
      }, n.renderHeader = function(a) {
        var s = a.monthDate, i = a.i, o = i === void 0 ? 0 : i, l = { monthDate: s, i: o };
        switch (!0) {
          case n.props.renderCustomHeader !== void 0:
            return n.renderCustomHeader(l);
          case (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker):
            return n.renderYearHeader(l);
          default:
            return n.renderDefaultHeader(l);
        }
      }, n.renderMonths = function() {
        var a, s;
        if (!(n.props.showTimeSelectOnly || n.props.showYearPicker)) {
          for (var i = [], o = (a = n.props.monthsShown) !== null && a !== void 0 ? a : t.defaultProps.monthsShown, l = n.props.showPreviousMonths ? o - 1 : 0, c = n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? Ol(n.state.date, l) : Iu(n.state.date, l), u = (s = n.props.monthSelectedIn) !== null && s !== void 0 ? s : l, d = 0; d < o; ++d) {
            var f = d - u + l, h = n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? Ol(c, f) : $i(c, f), p = "month-".concat(d), m = d < o - 1, g = d > 0;
            i.push(M.createElement(
              "div",
              { key: p, ref: function(y) {
                n.monthContainer = y ?? void 0;
              }, className: "react-datepicker__month-container" },
              n.renderHeader({ monthDate: h, i: d }),
              M.createElement(cne, kr({}, t.defaultProps, n.props, { ariaLabelPrefix: n.props.monthAriaLabelPrefix, day: h, onDayClick: n.handleDayClick, handleOnKeyDown: n.props.handleOnDayKeyDown, handleOnMonthKeyDown: n.props.handleOnKeyDown, onDayMouseEnter: n.handleDayMouseEnter, onMouseLeave: n.handleMonthMouseLeave, orderInDisplay: d, selectingDate: n.state.selectingDate, monthShowsDuplicateDaysEnd: m, monthShowsDuplicateDaysStart: g }))
            ));
          }
          return i;
        }
      }, n.renderYears = function() {
        if (!n.props.showTimeSelectOnly && n.props.showYearPicker)
          return M.createElement(
            "div",
            { className: "react-datepicker__year--container" },
            n.renderHeader({ monthDate: n.state.date }),
            M.createElement(gne, kr({}, t.defaultProps, n.props, { selectingDate: n.state.selectingDate, date: n.state.date, onDayClick: n.handleDayClick, clearSelectingDate: n.clearSelectingDate, onYearMouseEnter: n.handleYearMouseEnter, onYearMouseLeave: n.handleYearMouseLeave }))
          );
      }, n.renderTimeSection = function() {
        if (n.props.showTimeSelect && (n.state.monthContainer || n.props.showTimeSelectOnly))
          return M.createElement(mne, kr({}, t.defaultProps, n.props, { onChange: n.props.onTimeChange, format: n.props.timeFormat, intervals: n.props.timeIntervals, monthRef: n.state.monthContainer }));
      }, n.renderInputTimeSection = function() {
        var a = n.props.selected ? new Date(n.props.selected) : void 0, s = a && wl(a) && !!n.props.selected, i = s ? "".concat(SP(a.getHours()), ":").concat(SP(a.getMinutes())) : "";
        if (n.props.showTimeInput)
          return M.createElement(ane, kr({}, t.defaultProps, n.props, { date: a, timeString: i, onChange: n.props.onTimeChange }));
      }, n.renderAriaLiveRegion = function() {
        var a, s = pc(n.state.date, (a = n.props.yearItemNumber) !== null && a !== void 0 ? a : t.defaultProps.yearItemNumber), i = s.startPeriod, o = s.endPeriod, l;
        return n.props.showYearPicker ? l = "".concat(i, " - ").concat(o) : n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? l = mr(n.state.date) : l = "".concat(fC(us(n.state.date), n.props.locale), " ").concat(mr(n.state.date)), M.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, n.state.isRenderAriaLiveMessage && l);
      }, n.renderChildren = function() {
        if (n.props.children)
          return M.createElement("div", { className: "react-datepicker__children-container" }, n.props.children);
      }, n.containerRef = Cc(), n.state = {
        date: n.getDateInView(),
        selectingDate: void 0,
        monthContainer: void 0,
        isRenderAriaLiveMessage: !1
      }, n;
    }
    return Object.defineProperty(t, "defaultProps", {
      get: function() {
        return {
          monthsShown: 1,
          forceShowMonthNavigation: !1,
          timeCaption: "Time",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          yearItemNumber: kg
        };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidMount = function() {
      var r = this;
      this.props.showTimeSelect && (this.assignMonthContainer = function() {
        r.setState({ monthContainer: r.monthContainer });
      }());
    }, t.prototype.componentDidUpdate = function(r) {
      var n = this;
      if (this.props.preSelection && (!Sr(this.props.preSelection, r.preSelection) || this.props.monthSelectedIn !== r.monthSelectedIn)) {
        var a = !os(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return a && n.handleCustomMonthChange(n.state.date);
        });
      } else this.props.openToDate && !Sr(this.props.openToDate, r.openToDate) && this.setState({
        date: this.props.openToDate
      });
    }, t.prototype.render = function() {
      var r = this.props.container || Mre;
      return M.createElement(
        Uw,
        { onClickOutside: this.handleClickOutside, style: { display: "contents" }, containerRef: this.containerRef, ignoreClass: this.props.outsideClickIgnoreClass },
        M.createElement(
          r,
          { className: Pa("react-datepicker", this.props.className, {
            "react-datepicker--time-only": this.props.showTimeSelectOnly
          }), showTime: this.props.showTimeSelect || this.props.showTimeInput, showTimeSelectOnly: this.props.showTimeSelectOnly },
          this.renderAriaLiveRegion(),
          this.renderPreviousButton(),
          this.renderNextButton(),
          this.renderMonths(),
          this.renderYears(),
          this.renderTodayButton(),
          this.renderTimeSection(),
          this.renderInputTimeSection(),
          this.renderChildren()
        )
      );
    }, t;
  }(Cn)
), Sne = function(e) {
  var t = e.icon, r = e.className, n = r === void 0 ? "" : r, a = e.onClick, s = "react-datepicker__calendar-icon";
  return typeof t == "string" ? M.createElement("i", { className: "".concat(s, " ").concat(t, " ").concat(n), "aria-hidden": "true", onClick: a }) : M.isValidElement(t) ? M.cloneElement(t, {
    className: "".concat(t.props.className || "", " ").concat(s, " ").concat(n),
    onClick: function(i) {
      typeof t.props.onClick == "function" && t.props.onClick(i), typeof a == "function" && a(i);
    }
  }) : M.createElement(
    "svg",
    { className: "".concat(s, " ").concat(n), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: a },
    M.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" })
  );
}, k5 = (
  /** @class */
  function(e) {
    ya(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.portalRoot = null, n.el = document.createElement("div"), n;
    }
    return t.prototype.componentDidMount = function() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
    }, t.prototype.componentWillUnmount = function() {
      this.portalRoot && this.portalRoot.removeChild(this.el);
    }, t.prototype.render = function() {
      return OT.createPortal(this.props.children, this.el);
    }, t;
  }(Cn)
), Ene = "[tabindex], a, button, input, select, textarea", Tne = function(e) {
  return (e instanceof HTMLAnchorElement || !e.disabled) && e.tabIndex !== -1;
}, O5 = (
  /** @class */
  function(e) {
    ya(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.getTabChildren = function() {
        var a;
        return Array.prototype.slice.call((a = n.tabLoopRef.current) === null || a === void 0 ? void 0 : a.querySelectorAll(Ene), 1, -1).filter(Tne);
      }, n.handleFocusStart = function() {
        var a = n.getTabChildren();
        a && a.length > 1 && a[a.length - 1].focus();
      }, n.handleFocusEnd = function() {
        var a = n.getTabChildren();
        a && a.length > 1 && a[0].focus();
      }, n.tabLoopRef = Cc(), n;
    }
    return t.prototype.render = function() {
      var r;
      return ((r = this.props.enableTabLoop) !== null && r !== void 0 ? r : t.defaultProps.enableTabLoop) ? M.createElement(
        "div",
        { className: "react-datepicker__tab-loop", ref: this.tabLoopRef },
        M.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: 0, onFocus: this.handleFocusStart }),
        this.props.children,
        M.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: 0, onFocus: this.handleFocusEnd })
      ) : this.props.children;
    }, t.defaultProps = {
      enableTabLoop: !0
    }, t;
  }(Cn)
);
function Cne(e) {
  var t = function(r) {
    var n, a = typeof r.hidePopper == "boolean" ? r.hidePopper : !0, s = tr(null), i = Nre(kr({ open: !a, whileElementsMounted: ure, placement: r.popperPlacement, middleware: Eo([
      vre({ padding: 15 }),
      gre(10),
      yre({ element: s })
    ], (n = r.popperModifiers) !== null && n !== void 0 ? n : [], !0) }, r.popperProps)), o = kr(kr({}, r), { hidePopper: a, popperProps: kr(kr({}, i), { arrowRef: s }) });
    return M.createElement(e, kr({}, o));
  };
  return t;
}
var kne = (
  /** @class */
  function(e) {
    ya(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return Object.defineProperty(t, "defaultProps", {
      get: function() {
        return {
          hidePopper: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.render = function() {
      var r = this.props, n = r.className, a = r.wrapperClassName, s = r.hidePopper, i = s === void 0 ? t.defaultProps.hidePopper : s, o = r.popperComponent, l = r.targetComponent, c = r.enableTabLoop, u = r.popperOnKeyDown, d = r.portalId, f = r.portalHost, h = r.popperProps, p = r.showArrow, m = void 0;
      if (!i) {
        var g = Pa("react-datepicker-popper", n);
        m = M.createElement(
          O5,
          { enableTabLoop: c },
          M.createElement(
            "div",
            { ref: h.refs.setFloating, style: h.floatingStyles, className: g, "data-placement": h.placement, onKeyDown: u },
            o,
            p && M.createElement(kre, { ref: h.arrowRef, context: h.context, fill: "currentColor", strokeWidth: 1, height: 8, width: 16, style: { transform: "translateY(-1px)" }, className: "react-datepicker__triangle" })
          )
        );
      }
      this.props.popperContainer && (m = _a(this.props.popperContainer, {}, m)), d && !i && (m = M.createElement(k5, { portalId: d, portalHost: f }, m));
      var y = Pa("react-datepicker-wrapper", a);
      return M.createElement(
        M.Fragment,
        null,
        M.createElement("div", { ref: h.refs.setReference, className: y }, l),
        m
      );
    }, t;
  }(Cn)
), One = Cne(kne), AP = "react-datepicker-ignore-onclickoutside";
function Ane(e, t) {
  return e && t ? us(e) !== us(t) || mr(e) !== mr(t) : e !== t;
}
var q1 = "Date input not valid.", Pne = (
  /** @class */
  function(e) {
    ya(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.calendar = null, n.input = null, n.getPreSelection = function() {
        return n.props.openToDate ? n.props.openToDate : n.props.selectsEnd && n.props.startDate ? n.props.startDate : n.props.selectsStart && n.props.endDate ? n.props.endDate : Qr();
      }, n.modifyHolidays = function() {
        var a;
        return (a = n.props.holidays) === null || a === void 0 ? void 0 : a.reduce(function(s, i) {
          var o = new Date(i.date);
          return wl(o) ? Eo(Eo([], s, !0), [kr(kr({}, i), { date: o })], !1) : s;
        }, []);
      }, n.calcInitialState = function() {
        var a, s = n.getPreSelection(), i = E5(n.props), o = T5(n.props), l = i && Hu(s, Sy(i)) ? i : o && Ic(s, pP(o)) ? o : s;
        return {
          open: n.props.startOpen || !1,
          preventFocus: !1,
          inputValue: null,
          preSelection: (a = n.props.selectsRange ? n.props.startDate : n.props.selected) !== null && a !== void 0 ? a : l,
          // transforming highlighted days (perhaps nested array)
          // to flat Map for faster access in day.jsx
          highlightDates: _P(n.props.highlightDates),
          focused: !1,
          // used to focus day in inline version after month has changed, but not on
          // initial render
          shouldFocusDayInline: !1,
          isRenderAriaLiveMessage: !1,
          wasHidden: !1
        };
      }, n.resetHiddenStatus = function() {
        n.setState(kr(kr({}, n.state), { wasHidden: !1 }));
      }, n.setHiddenStatus = function() {
        n.setState(kr(kr({}, n.state), { wasHidden: !0 }));
      }, n.setHiddenStateOnVisibilityHidden = function() {
        document.visibilityState === "hidden" && n.setHiddenStatus();
      }, n.clearPreventFocusTimeout = function() {
        n.preventFocusTimeout && clearTimeout(n.preventFocusTimeout);
      }, n.safeFocus = function() {
        setTimeout(function() {
          var a, s;
          (s = (a = n.input) === null || a === void 0 ? void 0 : a.focus) === null || s === void 0 || s.call(a, { preventScroll: !0 });
        }, 0);
      }, n.safeBlur = function() {
        setTimeout(function() {
          var a, s;
          (s = (a = n.input) === null || a === void 0 ? void 0 : a.blur) === null || s === void 0 || s.call(a);
        }, 0);
      }, n.setFocus = function() {
        n.safeFocus();
      }, n.setBlur = function() {
        n.safeBlur(), n.cancelFocusInput();
      }, n.setOpen = function(a, s) {
        s === void 0 && (s = !1), n.setState({
          open: a,
          preSelection: a && n.state.open ? n.state.preSelection : n.calcInitialState().preSelection,
          lastPreSelectChange: G1
        }, function() {
          a || n.setState(function(i) {
            return {
              focused: s ? i.focused : !1
            };
          }, function() {
            !s && n.setBlur(), n.setState({ inputValue: null });
          });
        });
      }, n.inputOk = function() {
        return Al(n.state.preSelection);
      }, n.isCalendarOpen = function() {
        return n.props.open === void 0 ? n.state.open && !n.props.disabled && !n.props.readOnly : n.props.open;
      }, n.handleFocus = function(a) {
        var s, i, o = n.state.wasHidden, l = o ? n.state.open : !0;
        o && n.resetHiddenStatus(), !n.state.preventFocus && l && ((i = (s = n.props).onFocus) === null || i === void 0 || i.call(s, a), !n.props.preventOpenOnFocus && !n.props.readOnly && n.setOpen(!0)), n.setState({ focused: !0 });
      }, n.sendFocusBackToInput = function() {
        n.preventFocusTimeout && n.clearPreventFocusTimeout(), n.setState({ preventFocus: !0 }, function() {
          n.preventFocusTimeout = setTimeout(function() {
            n.setFocus(), n.setState({ preventFocus: !1 });
          });
        });
      }, n.cancelFocusInput = function() {
        clearTimeout(n.inputFocusTimeout), n.inputFocusTimeout = void 0;
      }, n.deferFocusInput = function() {
        n.cancelFocusInput(), n.inputFocusTimeout = setTimeout(function() {
          return n.setFocus();
        }, 1);
      }, n.handleDropdownFocus = function() {
        n.cancelFocusInput();
      }, n.handleBlur = function(a) {
        var s, i;
        (!n.state.open || n.props.withPortal || n.props.showTimeInput) && ((i = (s = n.props).onBlur) === null || i === void 0 || i.call(s, a)), n.setState({ focused: !1 });
      }, n.handleCalendarClickOutside = function(a) {
        var s, i;
        n.props.inline || n.setOpen(!1), (i = (s = n.props).onClickOutside) === null || i === void 0 || i.call(s, a), n.props.withPortal && a.preventDefault();
      }, n.handleChange = function() {
        for (var a, s, i = [], o = 0; o < arguments.length; o++)
          i[o] = arguments[o];
        var l = i[0];
        if (!(n.props.onChangeRaw && (n.props.onChangeRaw.apply(n, i), !l || typeof l.isDefaultPrevented != "function" || l.isDefaultPrevented()))) {
          n.setState({
            inputValue: (l == null ? void 0 : l.target) instanceof HTMLInputElement ? l.target.value : null,
            lastPreSelectChange: Rne
          });
          var c = n.props, u = c.dateFormat, d = u === void 0 ? t.defaultProps.dateFormat : u, f = c.strictParsing, h = f === void 0 ? t.defaultProps.strictParsing : f, p = c.selectsRange, m = c.startDate, g = c.endDate, y = (l == null ? void 0 : l.target) instanceof HTMLInputElement ? l.target.value : "";
          if (p) {
            var x = y.split("-", 2).map(function(A) {
              return A.trim();
            }), w = x[0], _ = x[1], S = W1(w ?? "", d, n.props.locale, h), C = W1(_ ?? "", d, n.props.locale, h), E = (m == null ? void 0 : m.getTime()) !== (S == null ? void 0 : S.getTime()), O = (g == null ? void 0 : g.getTime()) !== (C == null ? void 0 : C.getTime());
            if (!E && !O || S && ii(S, n.props) || C && ii(C, n.props))
              return;
            (s = (a = n.props).onChange) === null || s === void 0 || s.call(a, [S, C], l);
          } else {
            var k = W1(y, d, n.props.locale, h, n.props.minDate);
            n.props.showTimeSelectOnly && n.props.selected && k && !Sr(k, n.props.selected) && (k = Rte(n.props.selected, {
              hours: Po(k),
              minutes: Ro(k),
              seconds: Pl(k)
            })), (k || !y) && n.setSelected(k, l, !0);
          }
        }
      }, n.handleSelect = function(a, s, i) {
        if (n.props.shouldCloseOnSelect && !n.props.showTimeSelect && n.sendFocusBackToInput(), n.props.onChangeRaw && n.props.onChangeRaw(s), n.setSelected(a, s, !1, i), n.props.showDateSelect && n.setState({ isRenderAriaLiveMessage: !0 }), !n.props.shouldCloseOnSelect || n.props.showTimeSelect)
          n.setPreSelection(a);
        else if (!n.props.inline) {
          n.props.selectsRange || n.setOpen(!1);
          var o = n.props, l = o.startDate, c = o.endDate;
          l && !c && (n.props.swapRange || !CP(a, l)) && n.setOpen(!1);
        }
      }, n.setSelected = function(a, s, i, o) {
        var l, c, u = a;
        if (n.props.showYearPicker) {
          if (u !== null && Ey(mr(u), n.props))
            return;
        } else if (n.props.showMonthYearPicker) {
          if (u !== null && S5(u, n.props))
            return;
        } else if (u !== null && ii(u, n.props))
          return;
        var d = n.props, f = d.onChange, h = d.selectsRange, p = d.startDate, m = d.endDate, g = d.selectsMultiple, y = d.selectedDates, x = d.minTime, w = d.swapRange;
        if (!Eu(n.props.selected, u) || n.props.allowSameDay || h || g)
          if (u !== null && (n.props.selected && (!i || !n.props.showTimeSelect && !n.props.showTimeSelectOnly && !n.props.showTimeInput) && (u = z1(u, {
            hour: Po(n.props.selected),
            minute: Ro(n.props.selected),
            second: Pl(n.props.selected)
          })), !i && (n.props.showTimeSelect || n.props.showTimeSelectOnly) && x && (u = z1(u, {
            hour: x.getHours(),
            minute: x.getMinutes(),
            second: x.getSeconds()
          })), n.props.inline || n.setState({
            preSelection: u
          }), n.props.focusSelectedMonth || n.setState({ monthSelectedIn: o })), h) {
            var _ = !p && !m, S = p && !m, C = p && m;
            _ ? f == null || f([u, null], s) : S && (u === null ? f == null || f([null, null], s) : CP(u, p) ? w ? f == null || f([u, p], s) : f == null || f([u, null], s) : f == null || f([p, u], s)), C && (f == null || f([u, null], s));
          } else if (g) {
            if (u !== null)
              if (!(y != null && y.length))
                f == null || f([u], s);
              else {
                var E = y.some(function(k) {
                  return Sr(k, u);
                });
                if (E) {
                  var O = y.filter(function(k) {
                    return !Sr(k, u);
                  });
                  f == null || f(O, s);
                } else
                  f == null || f(Eo(Eo([], y, !0), [u], !1), s);
              }
          } else
            f == null || f(u, s);
        i || ((c = (l = n.props).onSelect) === null || c === void 0 || c.call(l, u, s), n.setState({ inputValue: null }));
      }, n.setPreSelection = function(a) {
        var s = Al(n.props.minDate), i = Al(n.props.maxDate), o = !0;
        if (a) {
          var l = Sy(a);
          if (s && i)
            o = Yp(a, n.props.minDate, n.props.maxDate);
          else if (s) {
            var c = Sy(n.props.minDate);
            o = Ic(a, c) || Eu(l, c);
          } else if (i) {
            var u = pP(n.props.maxDate);
            o = Hu(a, u) || Eu(l, u);
          }
        }
        o && n.setState({
          preSelection: a
        });
      }, n.toggleCalendar = function() {
        n.setOpen(!n.state.open);
      }, n.handleTimeChange = function(a) {
        var s, i;
        if (!(n.props.selectsRange || n.props.selectsMultiple)) {
          var o = n.props.selected ? n.props.selected : n.getPreSelection(), l = n.props.selected ? a : z1(o, {
            hour: Po(a),
            minute: Ro(a)
          });
          n.setState({
            preSelection: l
          }), (i = (s = n.props).onChange) === null || i === void 0 || i.call(s, l), n.props.shouldCloseOnSelect && !n.props.showTimeInput && (n.sendFocusBackToInput(), n.setOpen(!1)), n.props.showTimeInput && n.setOpen(!0), (n.props.showTimeSelectOnly || n.props.showTimeSelect) && n.setState({ isRenderAriaLiveMessage: !0 }), n.setState({ inputValue: null });
        }
      }, n.onInputClick = function() {
        var a, s;
        !n.props.disabled && !n.props.readOnly && n.setOpen(!0), (s = (a = n.props).onInputClick) === null || s === void 0 || s.call(a);
      }, n.onInputKeyDown = function(a) {
        var s, i, o, l, c, u;
        (i = (s = n.props).onKeyDown) === null || i === void 0 || i.call(s, a);
        var d = a.key;
        if (!n.state.open && !n.props.inline && !n.props.preventOpenOnFocus) {
          (d === Tt.ArrowDown || d === Tt.ArrowUp || d === Tt.Enter) && ((o = n.onInputClick) === null || o === void 0 || o.call(n));
          return;
        }
        if (n.state.open) {
          if (d === Tt.ArrowDown || d === Tt.ArrowUp) {
            a.preventDefault();
            var f = n.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : n.props.showWeekPicker && n.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : n.props.showFullMonthYearPicker || n.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', h = ((l = n.calendar) === null || l === void 0 ? void 0 : l.containerRef.current) instanceof Element && n.calendar.containerRef.current.querySelector(f);
            h instanceof HTMLElement && h.focus({ preventScroll: !0 });
            return;
          }
          var p = Qr(n.state.preSelection);
          d === Tt.Enter ? (a.preventDefault(), a.target.blur(), n.inputOk() && n.state.lastPreSelectChange === G1 ? (n.handleSelect(p, a), !n.props.shouldCloseOnSelect && n.setPreSelection(p)) : n.setOpen(!1)) : d === Tt.Escape ? (a.preventDefault(), a.target.blur(), n.sendFocusBackToInput(), n.setOpen(!1)) : d === Tt.Tab && n.setOpen(!1), n.inputOk() || (u = (c = n.props).onInputError) === null || u === void 0 || u.call(c, { code: 1, msg: q1 });
        }
      }, n.onPortalKeyDown = function(a) {
        var s = a.key;
        s === Tt.Escape && (a.preventDefault(), n.setState({
          preventFocus: !0
        }, function() {
          n.setOpen(!1), setTimeout(function() {
            n.setFocus(), n.setState({ preventFocus: !1 });
          });
        }));
      }, n.onDayKeyDown = function(a) {
        var s, i, o, l, c, u, d = n.props, f = d.minDate, h = d.maxDate, p = d.disabledKeyboardNavigation, m = d.showWeekPicker, g = d.shouldCloseOnSelect, y = d.locale, x = d.calendarStartDay, w = d.adjustDateOnChange, _ = d.inline;
        if ((i = (s = n.props).onKeyDown) === null || i === void 0 || i.call(s, a), !p) {
          var S = a.key, C = a.shiftKey, E = Qr(n.state.preSelection), O = function(G, Y) {
            var te = Y;
            switch (G) {
              case Tt.ArrowRight:
                te = m ? Zy(Y, 1) : Fi(Y, 1);
                break;
              case Tt.ArrowLeft:
                te = m ? nP(Y) : pte(Y);
                break;
              case Tt.ArrowUp:
                te = nP(Y);
                break;
              case Tt.ArrowDown:
                te = Zy(Y, 1);
                break;
              case Tt.PageUp:
                te = C ? nh(Y, 1) : Iu(Y, 1);
                break;
              case Tt.PageDown:
                te = C ? Ol(Y, 1) : $i(Y, 1);
                break;
              case Tt.Home:
                te = Ec(Y, y, x);
                break;
              case Tt.End:
                te = $re(Y);
                break;
            }
            return te;
          }, k = function(G, Y) {
            for (var te = 40, ae = G, ne = !1, ue = 0, q = O(G, Y); !ne; ) {
              if (ue >= te) {
                q = Y;
                break;
              }
              f && q < f && (ae = Tt.ArrowRight, q = ii(f, n.props) ? O(ae, q) : f), h && q > h && (ae = Tt.ArrowLeft, q = ii(h, n.props) ? O(ae, q) : h), ii(q, n.props) ? ((ae === Tt.PageUp || ae === Tt.Home) && (ae = Tt.ArrowRight), (ae === Tt.PageDown || ae === Tt.End) && (ae = Tt.ArrowLeft), q = O(ae, q)) : ne = !0, ue++;
            }
            return q;
          };
          if (S === Tt.Enter) {
            a.preventDefault(), n.handleSelect(E, a), !g && n.setPreSelection(E);
            return;
          } else if (S === Tt.Escape) {
            a.preventDefault(), n.setOpen(!1), n.inputOk() || (l = (o = n.props).onInputError) === null || l === void 0 || l.call(o, { code: 1, msg: q1 });
            return;
          }
          var A = null;
          switch (S) {
            case Tt.ArrowLeft:
            case Tt.ArrowRight:
            case Tt.ArrowUp:
            case Tt.ArrowDown:
            case Tt.PageUp:
            case Tt.PageDown:
            case Tt.Home:
            case Tt.End:
              A = k(S, E);
              break;
          }
          if (!A) {
            (u = (c = n.props).onInputError) === null || u === void 0 || u.call(c, { code: 1, msg: q1 });
            return;
          }
          if (a.preventDefault(), n.setState({ lastPreSelectChange: G1 }), w && n.setSelected(A), n.setPreSelection(A), _) {
            var P = us(E), D = us(A), N = mr(E), z = mr(A);
            P !== D || N !== z ? n.setState({ shouldFocusDayInline: !0 }) : n.setState({ shouldFocusDayInline: !1 });
          }
        }
      }, n.onPopperKeyDown = function(a) {
        var s = a.key;
        s === Tt.Escape && (a.preventDefault(), n.sendFocusBackToInput());
      }, n.onClearClick = function(a) {
        a && a.preventDefault && a.preventDefault(), n.sendFocusBackToInput();
        var s = n.props, i = s.selectsRange, o = s.onChange;
        i ? o == null || o([null, null], a) : o == null || o(null, a), n.setState({ inputValue: null });
      }, n.clear = function() {
        n.onClearClick();
      }, n.onScroll = function(a) {
        typeof n.props.closeOnScroll == "boolean" && n.props.closeOnScroll ? (a.target === document || a.target === document.documentElement || a.target === document.body) && n.setOpen(!1) : typeof n.props.closeOnScroll == "function" && n.props.closeOnScroll(a) && n.setOpen(!1);
      }, n.renderCalendar = function() {
        var a, s;
        return !n.props.inline && !n.isCalendarOpen() ? null : M.createElement(_ne, kr({ showMonthYearDropdown: void 0, ref: function(i) {
          n.calendar = i;
        } }, n.props, n.state, { setOpen: n.setOpen, dateFormat: (a = n.props.dateFormatCalendar) !== null && a !== void 0 ? a : t.defaultProps.dateFormatCalendar, onSelect: n.handleSelect, onClickOutside: n.handleCalendarClickOutside, holidays: ene(n.modifyHolidays()), outsideClickIgnoreClass: AP, onDropdownFocus: n.handleDropdownFocus, onTimeChange: n.handleTimeChange, className: n.props.calendarClassName, container: n.props.calendarContainer, handleOnKeyDown: n.props.onKeyDown, handleOnDayKeyDown: n.onDayKeyDown, setPreSelection: n.setPreSelection, dropdownMode: (s = n.props.dropdownMode) !== null && s !== void 0 ? s : t.defaultProps.dropdownMode }), n.props.children);
      }, n.renderAriaLiveRegion = function() {
        var a = n.props, s = a.dateFormat, i = s === void 0 ? t.defaultProps.dateFormat : s, o = a.locale, l = n.props.showTimeInput || n.props.showTimeSelect, c = l ? "PPPPp" : "PPPP", u;
        return n.props.selectsRange ? u = "Selected start date: ".concat(ri(n.props.startDate, {
          dateFormat: c,
          locale: o
        }), ". ").concat(n.props.endDate ? "End date: " + ri(n.props.endDate, {
          dateFormat: c,
          locale: o
        }) : "") : n.props.showTimeSelectOnly ? u = "Selected time: ".concat(ri(n.props.selected, { dateFormat: i, locale: o })) : n.props.showYearPicker ? u = "Selected year: ".concat(ri(n.props.selected, { dateFormat: "yyyy", locale: o })) : n.props.showMonthYearPicker ? u = "Selected month: ".concat(ri(n.props.selected, { dateFormat: "MMMM yyyy", locale: o })) : n.props.showQuarterYearPicker ? u = "Selected quarter: ".concat(ri(n.props.selected, {
          dateFormat: "yyyy, QQQ",
          locale: o
        })) : u = "Selected date: ".concat(ri(n.props.selected, {
          dateFormat: c,
          locale: o
        })), M.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, u);
      }, n.renderDateInput = function() {
        var a, s, i, o = Pa(n.props.className, (a = {}, a[AP] = n.state.open, a)), l = n.props.customInput || M.createElement("input", { type: "text" }), c = n.props.customInputRef || "ref", u = n.props, d = u.dateFormat, f = d === void 0 ? t.defaultProps.dateFormat : d, h = u.locale, p = typeof n.props.value == "string" ? n.props.value : typeof n.state.inputValue == "string" ? n.state.inputValue : n.props.selectsRange ? Fre(n.props.startDate, n.props.endDate, {
          dateFormat: f,
          locale: h
        }) : n.props.selectsMultiple ? Bre((i = n.props.selectedDates) !== null && i !== void 0 ? i : [], {
          dateFormat: f,
          locale: h
        }) : ri(n.props.selected, {
          dateFormat: f,
          locale: h
        });
        return j4(l, (s = {}, s[c] = function(m) {
          n.input = m;
        }, s.value = p, s.onBlur = n.handleBlur, s.onChange = n.handleChange, s.onClick = n.onInputClick, s.onFocus = n.handleFocus, s.onKeyDown = n.onInputKeyDown, s.id = n.props.id, s.name = n.props.name, s.form = n.props.form, s.autoFocus = n.props.autoFocus, s.placeholder = n.props.placeholderText, s.disabled = n.props.disabled, s.autoComplete = n.props.autoComplete, s.className = Pa(l.props.className, o), s.title = n.props.title, s.readOnly = n.props.readOnly, s.required = n.props.required, s.tabIndex = n.props.tabIndex, s["aria-describedby"] = n.props.ariaDescribedBy, s["aria-invalid"] = n.props.ariaInvalid, s["aria-labelledby"] = n.props.ariaLabelledBy, s["aria-required"] = n.props.ariaRequired, s));
      }, n.renderClearButton = function() {
        var a = n.props, s = a.isClearable, i = a.disabled, o = a.selected, l = a.startDate, c = a.endDate, u = a.clearButtonTitle, d = a.clearButtonClassName, f = d === void 0 ? "" : d, h = a.ariaLabelClose, p = h === void 0 ? "Close" : h, m = a.selectedDates;
        return s && (o != null || l != null || c != null || m != null && m.length) ? M.createElement("button", { type: "button", className: Pa("react-datepicker__close-icon", f, { "react-datepicker__close-icon--disabled": i }), disabled: i, "aria-label": p, onClick: n.onClearClick, title: u, tabIndex: -1 }) : null;
      }, n.state = n.calcInitialState(), n.preventFocusTimeout = void 0, n;
    }
    return Object.defineProperty(t, "defaultProps", {
      get: function() {
        return {
          allowSameDay: !1,
          dateFormat: "MM/dd/yyyy",
          dateFormatCalendar: "LLLL yyyy",
          disabled: !1,
          disabledKeyboardNavigation: !1,
          dropdownMode: "scroll",
          preventOpenOnFocus: !1,
          monthsShown: 1,
          readOnly: !1,
          withPortal: !1,
          selectsDisabledDaysInRange: !1,
          shouldCloseOnSelect: !0,
          showTimeSelect: !1,
          showTimeInput: !1,
          showPreviousMonths: !1,
          showMonthYearPicker: !1,
          showFullMonthYearPicker: !1,
          showTwoColumnMonthYearPicker: !1,
          showFourColumnMonthYearPicker: !1,
          showYearPicker: !1,
          showQuarterYearPicker: !1,
          showWeekPicker: !1,
          strictParsing: !1,
          swapRange: !1,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthAriaLabel: "Previous Month",
          previousMonthButtonLabel: "Previous Month",
          nextMonthAriaLabel: "Next Month",
          nextMonthButtonLabel: "Next Month",
          previousYearAriaLabel: "Previous Year",
          previousYearButtonLabel: "Previous Year",
          nextYearAriaLabel: "Next Year",
          nextYearButtonLabel: "Next Year",
          timeInputLabel: "Time",
          enableTabLoop: !0,
          yearItemNumber: kg,
          focusSelectedMonth: !1,
          showPopperArrow: !0,
          excludeScrollbar: !0,
          customTimeInput: null,
          calendarStartDay: void 0,
          toggleCalendarOnIconClick: !1,
          usePointerEvent: !1
        };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.componentDidMount = function() {
      window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, t.prototype.componentDidUpdate = function(r, n) {
      var a, s, i, o;
      r.inline && Ane(r.selected, this.props.selected) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && r.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), r.highlightDates !== this.props.highlightDates && this.setState({
        highlightDates: _P(this.props.highlightDates)
      }), !n.focused && !Eu(r.selected, this.props.selected) && this.setState({ inputValue: null }), n.open !== this.state.open && (n.open === !1 && this.state.open === !0 && ((s = (a = this.props).onCalendarOpen) === null || s === void 0 || s.call(a)), n.open === !0 && this.state.open === !1 && ((o = (i = this.props).onCalendarClose) === null || o === void 0 || o.call(i)));
    }, t.prototype.componentWillUnmount = function() {
      this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, t.prototype.renderInputContainer = function() {
      var r = this.props, n = r.showIcon, a = r.icon, s = r.calendarIconClassname, i = r.calendarIconClassName, o = r.toggleCalendarOnIconClick, l = this.state.open;
      return s && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), M.createElement(
        "div",
        { className: "react-datepicker__input-container".concat(n ? " react-datepicker__view-calendar-icon" : "") },
        n && M.createElement(Sne, kr({ icon: a, className: Pa(i, !i && s, l && "react-datepicker-ignore-onclickoutside") }, o ? {
          onClick: this.toggleCalendar
        } : null)),
        this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(),
        this.renderDateInput(),
        this.renderClearButton()
      );
    }, t.prototype.render = function() {
      var r = this.renderCalendar();
      if (this.props.inline)
        return r;
      if (this.props.withPortal) {
        var n = this.state.open ? M.createElement(
          O5,
          { enableTabLoop: this.props.enableTabLoop },
          M.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, r)
        ) : null;
        return this.state.open && this.props.portalId && (n = M.createElement(k5, kr({ portalId: this.props.portalId }, this.props), n)), M.createElement(
          "div",
          null,
          this.renderInputContainer(),
          n
        );
      }
      return M.createElement(One, kr({}, this.props, { className: this.props.popperClassName, hidePopper: !this.isCalendarOpen(), targetComponent: this.renderInputContainer(), popperComponent: r, popperOnKeyDown: this.onPopperKeyDown, showArrow: this.props.showPopperArrow }));
    }, t;
  }(Cn)
), Rne = "input", G1 = "navigate";
const A5 = va(
  ({
    value: e,
    onChange: t,
    error: r,
    size: n = "md",
    variant: a = "outline",
    theme: s,
    className: i,
    ...o
  }, l) => {
    var y, x;
    const c = s.baseStyle, u = ((y = s.sizes) == null ? void 0 : y[n]) || {}, d = ((x = s.variants) == null ? void 0 : x[a]) || {}, { i18n: f } = _t(), h = e ? AJ(e) : null, p = (w) => {
      t(w ? eh(w) : null);
    };
    M.useEffect(() => {
      const w = document.createElement("style");
      return w.innerHTML = `
        .react-datepicker-wrapper {
          display: block;
          width: 100%;
        }
        .react-datepicker__input-container {
          display: block;
          width: 100%;
        }
      `, document.head.appendChild(w), () => {
        document.head.removeChild(w);
      };
    }, []);
    const m = Wa(c.container, i), g = Wa(
      c.input,
      u.input,
      d.input,
      r && c.error
    );
    return /* @__PURE__ */ v.jsxs("div", { ref: l, className: m, children: [
      /* @__PURE__ */ v.jsx(
        Pne,
        {
          selected: h,
          onChange: p,
          className: g,
          dateFormat: "dd/MM/yyyy",
          showMonthDropdown: !0,
          showYearDropdown: !0,
          dropdownMode: "select",
          yearDropdownItemNumber: 10,
          scrollableYearDropdown: !0,
          formatWeekDay: (w) => w.substring(0, 3),
          locale: f.language,
          ...o
        }
      ),
      r && /* @__PURE__ */ v.jsx("p", { className: c.helperText, children: r })
    ] });
  }
);
A5.displayName = "DatePickerBase";
const Ine = $r(
  "DatePicker",
  A5
);
var oi = {}, Ag = {}, Dne = typeof window == "object" && window && window.Object === Object && window, P5 = Dne, Nne = P5, Mne = typeof self == "object" && self && self.Object === Object && self, Lne = Nne || Mne || Function("return this")(), Ho = Lne, jne = Ho, Fne = jne.Symbol, Pg = Fne, PP = Pg, R5 = Object.prototype, Bne = R5.hasOwnProperty, Une = R5.toString, fp = PP ? PP.toStringTag : void 0;
function Vne(e) {
  var t = Bne.call(e, fp), r = e[fp];
  try {
    e[fp] = void 0;
    var n = !0;
  } catch {
  }
  var a = Une.call(e);
  return n && (t ? e[fp] = r : delete e[fp]), a;
}
var $ne = Vne, Hne = Object.prototype, Wne = Hne.toString;
function zne(e) {
  return Wne.call(e);
}
var Kne = zne, RP = Pg, qne = $ne, Gne = Kne, Yne = "[object Null]", Xne = "[object Undefined]", IP = RP ? RP.toStringTag : void 0;
function Qne(e) {
  return e == null ? e === void 0 ? Xne : Yne : IP && IP in Object(e) ? qne(e) : Gne(e);
}
var rd = Qne, Jne = Array.isArray, zi = Jne;
function Zne(e) {
  return e != null && typeof e == "object";
}
var $l = Zne, eae = rd, tae = zi, rae = $l, nae = "[object String]";
function aae(e) {
  return typeof e == "string" || !tae(e) && rae(e) && eae(e) == nae;
}
var sae = aae;
function iae(e) {
  return function(t, r, n) {
    for (var a = -1, s = Object(t), i = n(t), o = i.length; o--; ) {
      var l = i[e ? o : ++a];
      if (r(s[l], l, s) === !1)
        break;
    }
    return t;
  };
}
var oae = iae, lae = oae, cae = lae(), uae = cae;
function dae(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var fae = dae, hae = rd, pae = $l, mae = "[object Arguments]";
function gae(e) {
  return pae(e) && hae(e) == mae;
}
var vae = gae, DP = vae, yae = $l, I5 = Object.prototype, bae = I5.hasOwnProperty, wae = I5.propertyIsEnumerable, xae = DP(/* @__PURE__ */ function() {
  return arguments;
}()) ? DP : function(e) {
  return yae(e) && bae.call(e, "callee") && !wae.call(e, "callee");
}, D5 = xae, fb = { exports: {} };
function _ae() {
  return !1;
}
var Sae = _ae;
fb.exports;
(function(e, t) {
  var r = Ho, n = Sae, a = t && !t.nodeType && t, s = a && !0 && e && !e.nodeType && e, i = s && s.exports === a, o = i ? r.Buffer : void 0, l = o ? o.isBuffer : void 0, c = l || n;
  e.exports = c;
})(fb, fb.exports);
var pC = fb.exports, Eae = 9007199254740991, Tae = /^(?:0|[1-9]\d*)$/;
function Cae(e, t) {
  var r = typeof e;
  return t = t ?? Eae, !!t && (r == "number" || r != "symbol" && Tae.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var N5 = Cae, kae = 9007199254740991;
function Oae(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= kae;
}
var mC = Oae, Aae = rd, Pae = mC, Rae = $l, Iae = "[object Arguments]", Dae = "[object Array]", Nae = "[object Boolean]", Mae = "[object Date]", Lae = "[object Error]", jae = "[object Function]", Fae = "[object Map]", Bae = "[object Number]", Uae = "[object Object]", Vae = "[object RegExp]", $ae = "[object Set]", Hae = "[object String]", Wae = "[object WeakMap]", zae = "[object ArrayBuffer]", Kae = "[object DataView]", qae = "[object Float32Array]", Gae = "[object Float64Array]", Yae = "[object Int8Array]", Xae = "[object Int16Array]", Qae = "[object Int32Array]", Jae = "[object Uint8Array]", Zae = "[object Uint8ClampedArray]", ese = "[object Uint16Array]", tse = "[object Uint32Array]", fn = {};
fn[qae] = fn[Gae] = fn[Yae] = fn[Xae] = fn[Qae] = fn[Jae] = fn[Zae] = fn[ese] = fn[tse] = !0;
fn[Iae] = fn[Dae] = fn[zae] = fn[Nae] = fn[Kae] = fn[Mae] = fn[Lae] = fn[jae] = fn[Fae] = fn[Bae] = fn[Uae] = fn[Vae] = fn[$ae] = fn[Hae] = fn[Wae] = !1;
function rse(e) {
  return Rae(e) && Pae(e.length) && !!fn[Aae(e)];
}
var nse = rse;
function ase(e) {
  return function(t) {
    return e(t);
  };
}
var gC = ase, hb = { exports: {} };
hb.exports;
(function(e, t) {
  var r = P5, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s && r.process, o = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  e.exports = o;
})(hb, hb.exports);
var vC = hb.exports, sse = nse, ise = gC, NP = vC, MP = NP && NP.isTypedArray, ose = MP ? ise(MP) : sse, M5 = ose, lse = fae, cse = D5, use = zi, dse = pC, fse = N5, hse = M5, pse = Object.prototype, mse = pse.hasOwnProperty;
function gse(e, t) {
  var r = use(e), n = !r && cse(e), a = !r && !n && dse(e), s = !r && !n && !a && hse(e), i = r || n || a || s, o = i ? lse(e.length, String) : [], l = o.length;
  for (var c in e)
    (t || mse.call(e, c)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    fse(c, l))) && o.push(c);
  return o;
}
var L5 = gse, vse = Object.prototype;
function yse(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || vse;
  return e === r;
}
var yC = yse;
function bse(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var j5 = bse, wse = j5, xse = wse(Object.keys, Object), _se = xse, Sse = yC, Ese = _se, Tse = Object.prototype, Cse = Tse.hasOwnProperty;
function kse(e) {
  if (!Sse(e))
    return Ese(e);
  var t = [];
  for (var r in Object(e))
    Cse.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var Ose = kse;
function Ase(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Oh = Ase, Pse = rd, Rse = Oh, Ise = "[object AsyncFunction]", Dse = "[object Function]", Nse = "[object GeneratorFunction]", Mse = "[object Proxy]";
function Lse(e) {
  if (!Rse(e))
    return !1;
  var t = Pse(e);
  return t == Dse || t == Nse || t == Ise || t == Mse;
}
var F5 = Lse, jse = F5, Fse = mC;
function Bse(e) {
  return e != null && Fse(e.length) && !jse(e);
}
var Vw = Bse, Use = L5, Vse = Ose, $se = Vw;
function Hse(e) {
  return $se(e) ? Use(e) : Vse(e);
}
var Rg = Hse, Wse = uae, zse = Rg;
function Kse(e, t) {
  return e && Wse(e, t, zse);
}
var B5 = Kse;
function qse(e) {
  return e;
}
var U5 = qse, Gse = U5;
function Yse(e) {
  return typeof e == "function" ? e : Gse;
}
var Xse = Yse, Qse = B5, Jse = Xse;
function Zse(e, t) {
  return e && Qse(e, Jse(t));
}
var bC = Zse, eie = j5, tie = eie(Object.getPrototypeOf, Object), wC = tie, rie = rd, nie = wC, aie = $l, sie = "[object Object]", iie = Function.prototype, oie = Object.prototype, V5 = iie.toString, lie = oie.hasOwnProperty, cie = V5.call(Object);
function uie(e) {
  if (!aie(e) || rie(e) != sie)
    return !1;
  var t = nie(e);
  if (t === null)
    return !0;
  var r = lie.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && V5.call(r) == cie;
}
var die = uie;
function fie(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var $5 = fie;
function hie() {
  this.__data__ = [], this.size = 0;
}
var pie = hie;
function mie(e, t) {
  return e === t || e !== e && t !== t;
}
var xC = mie, gie = xC;
function vie(e, t) {
  for (var r = e.length; r--; )
    if (gie(e[r][0], t))
      return r;
  return -1;
}
var $w = vie, yie = $w, bie = Array.prototype, wie = bie.splice;
function xie(e) {
  var t = this.__data__, r = yie(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : wie.call(t, r, 1), --this.size, !0;
}
var _ie = xie, Sie = $w;
function Eie(e) {
  var t = this.__data__, r = Sie(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var Tie = Eie, Cie = $w;
function kie(e) {
  return Cie(this.__data__, e) > -1;
}
var Oie = kie, Aie = $w;
function Pie(e, t) {
  var r = this.__data__, n = Aie(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var Rie = Pie, Iie = pie, Die = _ie, Nie = Tie, Mie = Oie, Lie = Rie;
function Ah(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Ah.prototype.clear = Iie;
Ah.prototype.delete = Die;
Ah.prototype.get = Nie;
Ah.prototype.has = Mie;
Ah.prototype.set = Lie;
var Hw = Ah, jie = Hw;
function Fie() {
  this.__data__ = new jie(), this.size = 0;
}
var Bie = Fie;
function Uie(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var Vie = Uie;
function $ie(e) {
  return this.__data__.get(e);
}
var Hie = $ie;
function Wie(e) {
  return this.__data__.has(e);
}
var zie = Wie, Kie = Ho, qie = Kie["__core-js_shared__"], Gie = qie, Y1 = Gie, LP = function() {
  var e = /[^.]+$/.exec(Y1 && Y1.keys && Y1.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Yie(e) {
  return !!LP && LP in e;
}
var Xie = Yie, Qie = Function.prototype, Jie = Qie.toString;
function Zie(e) {
  if (e != null) {
    try {
      return Jie.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var H5 = Zie, eoe = F5, toe = Xie, roe = Oh, noe = H5, aoe = /[\\^$.*+?()[\]{}|]/g, soe = /^\[object .+?Constructor\]$/, ioe = Function.prototype, ooe = Object.prototype, loe = ioe.toString, coe = ooe.hasOwnProperty, uoe = RegExp(
  "^" + loe.call(coe).replace(aoe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function doe(e) {
  if (!roe(e) || toe(e))
    return !1;
  var t = eoe(e) ? uoe : soe;
  return t.test(noe(e));
}
var foe = doe;
function hoe(e, t) {
  return e == null ? void 0 : e[t];
}
var poe = hoe, moe = foe, goe = poe;
function voe(e, t) {
  var r = goe(e, t);
  return moe(r) ? r : void 0;
}
var nd = voe, yoe = nd, boe = Ho, woe = yoe(boe, "Map"), _C = woe, xoe = nd, _oe = xoe(Object, "create"), Ww = _oe, jP = Ww;
function Soe() {
  this.__data__ = jP ? jP(null) : {}, this.size = 0;
}
var Eoe = Soe;
function Toe(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Coe = Toe, koe = Ww, Ooe = "__lodash_hash_undefined__", Aoe = Object.prototype, Poe = Aoe.hasOwnProperty;
function Roe(e) {
  var t = this.__data__;
  if (koe) {
    var r = t[e];
    return r === Ooe ? void 0 : r;
  }
  return Poe.call(t, e) ? t[e] : void 0;
}
var Ioe = Roe, Doe = Ww, Noe = Object.prototype, Moe = Noe.hasOwnProperty;
function Loe(e) {
  var t = this.__data__;
  return Doe ? t[e] !== void 0 : Moe.call(t, e);
}
var joe = Loe, Foe = Ww, Boe = "__lodash_hash_undefined__";
function Uoe(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Foe && t === void 0 ? Boe : t, this;
}
var Voe = Uoe, $oe = Eoe, Hoe = Coe, Woe = Ioe, zoe = joe, Koe = Voe;
function Ph(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Ph.prototype.clear = $oe;
Ph.prototype.delete = Hoe;
Ph.prototype.get = Woe;
Ph.prototype.has = zoe;
Ph.prototype.set = Koe;
var qoe = Ph, FP = qoe, Goe = Hw, Yoe = _C;
function Xoe() {
  this.size = 0, this.__data__ = {
    hash: new FP(),
    map: new (Yoe || Goe)(),
    string: new FP()
  };
}
var Qoe = Xoe;
function Joe(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Zoe = Joe, ele = Zoe;
function tle(e, t) {
  var r = e.__data__;
  return ele(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var zw = tle, rle = zw;
function nle(e) {
  var t = rle(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var ale = nle, sle = zw;
function ile(e) {
  return sle(this, e).get(e);
}
var ole = ile, lle = zw;
function cle(e) {
  return lle(this, e).has(e);
}
var ule = cle, dle = zw;
function fle(e, t) {
  var r = dle(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var hle = fle, ple = Qoe, mle = ale, gle = ole, vle = ule, yle = hle;
function Rh(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Rh.prototype.clear = ple;
Rh.prototype.delete = mle;
Rh.prototype.get = gle;
Rh.prototype.has = vle;
Rh.prototype.set = yle;
var SC = Rh, ble = Hw, wle = _C, xle = SC, _le = 200;
function Sle(e, t) {
  var r = this.__data__;
  if (r instanceof ble) {
    var n = r.__data__;
    if (!wle || n.length < _le - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new xle(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var Ele = Sle, Tle = Hw, Cle = Bie, kle = Vie, Ole = Hie, Ale = zie, Ple = Ele;
function Ih(e) {
  var t = this.__data__ = new Tle(e);
  this.size = t.size;
}
Ih.prototype.clear = Cle;
Ih.prototype.delete = kle;
Ih.prototype.get = Ole;
Ih.prototype.has = Ale;
Ih.prototype.set = Ple;
var EC = Ih, Rle = "__lodash_hash_undefined__";
function Ile(e) {
  return this.__data__.set(e, Rle), this;
}
var Dle = Ile;
function Nle(e) {
  return this.__data__.has(e);
}
var Mle = Nle, Lle = SC, jle = Dle, Fle = Mle;
function pb(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Lle(); ++t < r; )
    this.add(e[t]);
}
pb.prototype.add = pb.prototype.push = jle;
pb.prototype.has = Fle;
var Ble = pb;
function Ule(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var Vle = Ule;
function $le(e, t) {
  return e.has(t);
}
var Hle = $le, Wle = Ble, zle = Vle, Kle = Hle, qle = 1, Gle = 2;
function Yle(e, t, r, n, a, s) {
  var i = r & qle, o = e.length, l = t.length;
  if (o != l && !(i && l > o))
    return !1;
  var c = s.get(e), u = s.get(t);
  if (c && u)
    return c == t && u == e;
  var d = -1, f = !0, h = r & Gle ? new Wle() : void 0;
  for (s.set(e, t), s.set(t, e); ++d < o; ) {
    var p = e[d], m = t[d];
    if (n)
      var g = i ? n(m, p, d, t, e, s) : n(p, m, d, e, t, s);
    if (g !== void 0) {
      if (g)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!zle(t, function(y, x) {
        if (!Kle(h, x) && (p === y || a(p, y, r, n, s)))
          return h.push(x);
      })) {
        f = !1;
        break;
      }
    } else if (!(p === m || a(p, m, r, n, s))) {
      f = !1;
      break;
    }
  }
  return s.delete(e), s.delete(t), f;
}
var W5 = Yle, Xle = Ho, Qle = Xle.Uint8Array, z5 = Qle;
function Jle(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var Zle = Jle;
function ece(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var tce = ece, BP = Pg, UP = z5, rce = xC, nce = W5, ace = Zle, sce = tce, ice = 1, oce = 2, lce = "[object Boolean]", cce = "[object Date]", uce = "[object Error]", dce = "[object Map]", fce = "[object Number]", hce = "[object RegExp]", pce = "[object Set]", mce = "[object String]", gce = "[object Symbol]", vce = "[object ArrayBuffer]", yce = "[object DataView]", VP = BP ? BP.prototype : void 0, X1 = VP ? VP.valueOf : void 0;
function bce(e, t, r, n, a, s, i) {
  switch (r) {
    case yce:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case vce:
      return !(e.byteLength != t.byteLength || !s(new UP(e), new UP(t)));
    case lce:
    case cce:
    case fce:
      return rce(+e, +t);
    case uce:
      return e.name == t.name && e.message == t.message;
    case hce:
    case mce:
      return e == t + "";
    case dce:
      var o = ace;
    case pce:
      var l = n & ice;
      if (o || (o = sce), e.size != t.size && !l)
        return !1;
      var c = i.get(e);
      if (c)
        return c == t;
      n |= oce, i.set(e, t);
      var u = nce(o(e), o(t), n, a, s, i);
      return i.delete(e), u;
    case gce:
      if (X1)
        return X1.call(e) == X1.call(t);
  }
  return !1;
}
var wce = bce;
function xce(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var K5 = xce, _ce = K5, Sce = zi;
function Ece(e, t, r) {
  var n = t(e);
  return Sce(e) ? n : _ce(n, r(e));
}
var q5 = Ece;
function Tce(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, s = []; ++r < n; ) {
    var i = e[r];
    t(i, r, e) && (s[a++] = i);
  }
  return s;
}
var Cce = Tce;
function kce() {
  return [];
}
var G5 = kce, Oce = Cce, Ace = G5, Pce = Object.prototype, Rce = Pce.propertyIsEnumerable, $P = Object.getOwnPropertySymbols, Ice = $P ? function(e) {
  return e == null ? [] : (e = Object(e), Oce($P(e), function(t) {
    return Rce.call(e, t);
  }));
} : Ace, TC = Ice, Dce = q5, Nce = TC, Mce = Rg;
function Lce(e) {
  return Dce(e, Mce, Nce);
}
var Y5 = Lce, HP = Y5, jce = 1, Fce = Object.prototype, Bce = Fce.hasOwnProperty;
function Uce(e, t, r, n, a, s) {
  var i = r & jce, o = HP(e), l = o.length, c = HP(t), u = c.length;
  if (l != u && !i)
    return !1;
  for (var d = l; d--; ) {
    var f = o[d];
    if (!(i ? f in t : Bce.call(t, f)))
      return !1;
  }
  var h = s.get(e), p = s.get(t);
  if (h && p)
    return h == t && p == e;
  var m = !0;
  s.set(e, t), s.set(t, e);
  for (var g = i; ++d < l; ) {
    f = o[d];
    var y = e[f], x = t[f];
    if (n)
      var w = i ? n(x, y, f, t, e, s) : n(y, x, f, e, t, s);
    if (!(w === void 0 ? y === x || a(y, x, r, n, s) : w)) {
      m = !1;
      break;
    }
    g || (g = f == "constructor");
  }
  if (m && !g) {
    var _ = e.constructor, S = t.constructor;
    _ != S && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof S == "function" && S instanceof S) && (m = !1);
  }
  return s.delete(e), s.delete(t), m;
}
var Vce = Uce, $ce = nd, Hce = Ho, Wce = $ce(Hce, "DataView"), zce = Wce, Kce = nd, qce = Ho, Gce = Kce(qce, "Promise"), Yce = Gce, Xce = nd, Qce = Ho, Jce = Xce(Qce, "Set"), Zce = Jce, eue = nd, tue = Ho, rue = eue(tue, "WeakMap"), nue = rue, EE = zce, TE = _C, CE = Yce, kE = Zce, OE = nue, X5 = rd, Dh = H5, WP = "[object Map]", aue = "[object Object]", zP = "[object Promise]", KP = "[object Set]", qP = "[object WeakMap]", GP = "[object DataView]", sue = Dh(EE), iue = Dh(TE), oue = Dh(CE), lue = Dh(kE), cue = Dh(OE), hu = X5;
(EE && hu(new EE(new ArrayBuffer(1))) != GP || TE && hu(new TE()) != WP || CE && hu(CE.resolve()) != zP || kE && hu(new kE()) != KP || OE && hu(new OE()) != qP) && (hu = function(e) {
  var t = X5(e), r = t == aue ? e.constructor : void 0, n = r ? Dh(r) : "";
  if (n)
    switch (n) {
      case sue:
        return GP;
      case iue:
        return WP;
      case oue:
        return zP;
      case lue:
        return KP;
      case cue:
        return qP;
    }
  return t;
});
var Kw = hu, Q1 = EC, uue = W5, due = wce, fue = Vce, YP = Kw, XP = zi, QP = pC, hue = M5, pue = 1, JP = "[object Arguments]", ZP = "[object Array]", Jv = "[object Object]", mue = Object.prototype, eR = mue.hasOwnProperty;
function gue(e, t, r, n, a, s) {
  var i = XP(e), o = XP(t), l = i ? ZP : YP(e), c = o ? ZP : YP(t);
  l = l == JP ? Jv : l, c = c == JP ? Jv : c;
  var u = l == Jv, d = c == Jv, f = l == c;
  if (f && QP(e)) {
    if (!QP(t))
      return !1;
    i = !0, u = !1;
  }
  if (f && !u)
    return s || (s = new Q1()), i || hue(e) ? uue(e, t, r, n, a, s) : due(e, t, l, r, n, a, s);
  if (!(r & pue)) {
    var h = u && eR.call(e, "__wrapped__"), p = d && eR.call(t, "__wrapped__");
    if (h || p) {
      var m = h ? e.value() : e, g = p ? t.value() : t;
      return s || (s = new Q1()), a(m, g, r, n, s);
    }
  }
  return f ? (s || (s = new Q1()), fue(e, t, r, n, a, s)) : !1;
}
var vue = gue, yue = vue, tR = $l;
function Q5(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !tR(e) && !tR(t) ? e !== e && t !== t : yue(e, t, r, n, Q5, a);
}
var J5 = Q5, bue = EC, wue = J5, xue = 1, _ue = 2;
function Sue(e, t, r, n) {
  var a = r.length, s = a, i = !n;
  if (e == null)
    return !s;
  for (e = Object(e); a--; ) {
    var o = r[a];
    if (i && o[2] ? o[1] !== e[o[0]] : !(o[0] in e))
      return !1;
  }
  for (; ++a < s; ) {
    o = r[a];
    var l = o[0], c = e[l], u = o[1];
    if (i && o[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var d = new bue();
      if (n)
        var f = n(c, u, l, e, t, d);
      if (!(f === void 0 ? wue(u, c, xue | _ue, n, d) : f))
        return !1;
    }
  }
  return !0;
}
var Eue = Sue, Tue = Oh;
function Cue(e) {
  return e === e && !Tue(e);
}
var Z5 = Cue, kue = Z5, Oue = Rg;
function Aue(e) {
  for (var t = Oue(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, kue(a)];
  }
  return t;
}
var Pue = Aue;
function Rue(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var eB = Rue, Iue = Eue, Due = Pue, Nue = eB;
function Mue(e) {
  var t = Due(e);
  return t.length == 1 && t[0][2] ? Nue(t[0][0], t[0][1]) : function(r) {
    return r === e || Iue(r, e, t);
  };
}
var Lue = Mue, jue = rd, Fue = $l, Bue = "[object Symbol]";
function Uue(e) {
  return typeof e == "symbol" || Fue(e) && jue(e) == Bue;
}
var CC = Uue, Vue = zi, $ue = CC, Hue = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Wue = /^\w*$/;
function zue(e, t) {
  if (Vue(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || $ue(e) ? !0 : Wue.test(e) || !Hue.test(e) || t != null && e in Object(t);
}
var kC = zue, tB = SC, Kue = "Expected a function";
function OC(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Kue);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], s = r.cache;
    if (s.has(a))
      return s.get(a);
    var i = e.apply(this, n);
    return r.cache = s.set(a, i) || s, i;
  };
  return r.cache = new (OC.Cache || tB)(), r;
}
OC.Cache = tB;
var que = OC, Gue = que, Yue = 500;
function Xue(e) {
  var t = Gue(e, function(n) {
    return r.size === Yue && r.clear(), n;
  }), r = t.cache;
  return t;
}
var Que = Xue, Jue = Que, Zue = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ede = /\\(\\)?/g, tde = Jue(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Zue, function(r, n, a, s) {
    t.push(a ? s.replace(ede, "$1") : n || r);
  }), t;
}), rde = tde, rR = Pg, nde = $5, ade = zi, sde = CC, nR = rR ? rR.prototype : void 0, aR = nR ? nR.toString : void 0;
function rB(e) {
  if (typeof e == "string")
    return e;
  if (ade(e))
    return nde(e, rB) + "";
  if (sde(e))
    return aR ? aR.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var ide = rB, ode = ide;
function lde(e) {
  return e == null ? "" : ode(e);
}
var cde = lde, ude = zi, dde = kC, fde = rde, hde = cde;
function pde(e, t) {
  return ude(e) ? e : dde(e, t) ? [e] : fde(hde(e));
}
var nB = pde, mde = CC;
function gde(e) {
  if (typeof e == "string" || mde(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var qw = gde, vde = nB, yde = qw;
function bde(e, t) {
  t = vde(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[yde(t[r++])];
  return r && r == n ? e : void 0;
}
var aB = bde, wde = aB;
function xde(e, t, r) {
  var n = e == null ? void 0 : wde(e, t);
  return n === void 0 ? r : n;
}
var _de = xde;
function Sde(e, t) {
  return e != null && t in Object(e);
}
var Ede = Sde, Tde = nB, Cde = D5, kde = zi, Ode = N5, Ade = mC, Pde = qw;
function Rde(e, t, r) {
  t = Tde(t, e);
  for (var n = -1, a = t.length, s = !1; ++n < a; ) {
    var i = Pde(t[n]);
    if (!(s = e != null && r(e, i)))
      break;
    e = e[i];
  }
  return s || ++n != a ? s : (a = e == null ? 0 : e.length, !!a && Ade(a) && Ode(i, a) && (kde(e) || Cde(e)));
}
var Ide = Rde, Dde = Ede, Nde = Ide;
function Mde(e, t) {
  return e != null && Nde(e, t, Dde);
}
var Lde = Mde, jde = J5, Fde = _de, Bde = Lde, Ude = kC, Vde = Z5, $de = eB, Hde = qw, Wde = 1, zde = 2;
function Kde(e, t) {
  return Ude(e) && Vde(t) ? $de(Hde(e), t) : function(r) {
    var n = Fde(r, e);
    return n === void 0 && n === t ? Bde(r, e) : jde(t, n, Wde | zde);
  };
}
var qde = Kde;
function Gde(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var Yde = Gde, Xde = aB;
function Qde(e) {
  return function(t) {
    return Xde(t, e);
  };
}
var Jde = Qde, Zde = Yde, efe = Jde, tfe = kC, rfe = qw;
function nfe(e) {
  return tfe(e) ? Zde(rfe(e)) : efe(e);
}
var afe = nfe, sfe = Lue, ife = qde, ofe = U5, lfe = zi, cfe = afe;
function ufe(e) {
  return typeof e == "function" ? e : e == null ? ofe : typeof e == "object" ? lfe(e) ? ife(e[0], e[1]) : sfe(e) : cfe(e);
}
var dfe = ufe, ffe = Vw;
function hfe(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!ffe(r))
      return e(r, n);
    for (var a = r.length, s = t ? a : -1, i = Object(r); (t ? s-- : ++s < a) && n(i[s], s, i) !== !1; )
      ;
    return r;
  };
}
var pfe = hfe, mfe = B5, gfe = pfe, vfe = gfe(mfe), yfe = vfe, bfe = yfe, wfe = Vw;
function xfe(e, t) {
  var r = -1, n = wfe(e) ? Array(e.length) : [];
  return bfe(e, function(a, s, i) {
    n[++r] = t(a, s, i);
  }), n;
}
var _fe = xfe, Sfe = $5, Efe = dfe, Tfe = _fe, Cfe = zi;
function kfe(e, t) {
  var r = Cfe(e) ? Sfe : Tfe;
  return r(e, Efe(t));
}
var Ofe = kfe;
Object.defineProperty(Ag, "__esModule", {
  value: !0
});
Ag.flattenNames = void 0;
var Afe = sae, Pfe = Gw(Afe), Rfe = bC, Ife = Gw(Rfe), Dfe = die, Nfe = Gw(Dfe), Mfe = Ofe, Lfe = Gw(Mfe);
function Gw(e) {
  return e && e.__esModule ? e : { default: e };
}
var jfe = Ag.flattenNames = function e() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [];
  return (0, Lfe.default)(t, function(n) {
    Array.isArray(n) ? e(n).map(function(a) {
      return r.push(a);
    }) : (0, Nfe.default)(n) ? (0, Ife.default)(n, function(a, s) {
      a === !0 && r.push(s), r.push(s + "-" + a);
    }) : (0, Pfe.default)(n) && r.push(n);
  }), r;
};
Ag.default = jfe;
var Ig = {};
function Ffe(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var Bfe = Ffe, Ufe = nd, Vfe = function() {
  try {
    var e = Ufe(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), $fe = Vfe, sR = $fe;
function Hfe(e, t, r) {
  t == "__proto__" && sR ? sR(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var sB = Hfe, Wfe = sB, zfe = xC, Kfe = Object.prototype, qfe = Kfe.hasOwnProperty;
function Gfe(e, t, r) {
  var n = e[t];
  (!(qfe.call(e, t) && zfe(n, r)) || r === void 0 && !(t in e)) && Wfe(e, t, r);
}
var iB = Gfe, Yfe = iB, Xfe = sB;
function Qfe(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var s = -1, i = t.length; ++s < i; ) {
    var o = t[s], l = n ? n(r[o], e[o], o, r, e) : void 0;
    l === void 0 && (l = e[o]), a ? Xfe(r, o, l) : Yfe(r, o, l);
  }
  return r;
}
var Yw = Qfe, Jfe = Yw, Zfe = Rg;
function ehe(e, t) {
  return e && Jfe(t, Zfe(t), e);
}
var the = ehe;
function rhe(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var nhe = rhe, ahe = Oh, she = yC, ihe = nhe, ohe = Object.prototype, lhe = ohe.hasOwnProperty;
function che(e) {
  if (!ahe(e))
    return ihe(e);
  var t = she(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !lhe.call(e, n)) || r.push(n);
  return r;
}
var uhe = che, dhe = L5, fhe = uhe, hhe = Vw;
function phe(e) {
  return hhe(e) ? dhe(e, !0) : fhe(e);
}
var AC = phe, mhe = Yw, ghe = AC;
function vhe(e, t) {
  return e && mhe(t, ghe(t), e);
}
var yhe = vhe, mb = { exports: {} };
mb.exports;
(function(e, t) {
  var r = Ho, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s ? r.Buffer : void 0, o = i ? i.allocUnsafe : void 0;
  function l(c, u) {
    if (u)
      return c.slice();
    var d = c.length, f = o ? o(d) : new c.constructor(d);
    return c.copy(f), f;
  }
  e.exports = l;
})(mb, mb.exports);
var bhe = mb.exports;
function whe(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var xhe = whe, _he = Yw, She = TC;
function Ehe(e, t) {
  return _he(e, She(e), t);
}
var The = Ehe, Che = K5, khe = wC, Ohe = TC, Ahe = G5, Phe = Object.getOwnPropertySymbols, Rhe = Phe ? function(e) {
  for (var t = []; e; )
    Che(t, Ohe(e)), e = khe(e);
  return t;
} : Ahe, oB = Rhe, Ihe = Yw, Dhe = oB;
function Nhe(e, t) {
  return Ihe(e, Dhe(e), t);
}
var Mhe = Nhe, Lhe = q5, jhe = oB, Fhe = AC;
function Bhe(e) {
  return Lhe(e, Fhe, jhe);
}
var Uhe = Bhe, Vhe = Object.prototype, $he = Vhe.hasOwnProperty;
function Hhe(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && $he.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var Whe = Hhe, iR = z5;
function zhe(e) {
  var t = new e.constructor(e.byteLength);
  return new iR(t).set(new iR(e)), t;
}
var PC = zhe, Khe = PC;
function qhe(e, t) {
  var r = t ? Khe(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var Ghe = qhe, Yhe = /\w*$/;
function Xhe(e) {
  var t = new e.constructor(e.source, Yhe.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Qhe = Xhe, oR = Pg, lR = oR ? oR.prototype : void 0, cR = lR ? lR.valueOf : void 0;
function Jhe(e) {
  return cR ? Object(cR.call(e)) : {};
}
var Zhe = Jhe, epe = PC;
function tpe(e, t) {
  var r = t ? epe(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var rpe = tpe, npe = PC, ape = Ghe, spe = Qhe, ipe = Zhe, ope = rpe, lpe = "[object Boolean]", cpe = "[object Date]", upe = "[object Map]", dpe = "[object Number]", fpe = "[object RegExp]", hpe = "[object Set]", ppe = "[object String]", mpe = "[object Symbol]", gpe = "[object ArrayBuffer]", vpe = "[object DataView]", ype = "[object Float32Array]", bpe = "[object Float64Array]", wpe = "[object Int8Array]", xpe = "[object Int16Array]", _pe = "[object Int32Array]", Spe = "[object Uint8Array]", Epe = "[object Uint8ClampedArray]", Tpe = "[object Uint16Array]", Cpe = "[object Uint32Array]";
function kpe(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case gpe:
      return npe(e);
    case lpe:
    case cpe:
      return new n(+e);
    case vpe:
      return ape(e, r);
    case ype:
    case bpe:
    case wpe:
    case xpe:
    case _pe:
    case Spe:
    case Epe:
    case Tpe:
    case Cpe:
      return ope(e, r);
    case upe:
      return new n();
    case dpe:
    case ppe:
      return new n(e);
    case fpe:
      return spe(e);
    case hpe:
      return new n();
    case mpe:
      return ipe(e);
  }
}
var Ope = kpe, Ape = Oh, uR = Object.create, Ppe = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Ape(t))
      return {};
    if (uR)
      return uR(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), Rpe = Ppe, Ipe = Rpe, Dpe = wC, Npe = yC;
function Mpe(e) {
  return typeof e.constructor == "function" && !Npe(e) ? Ipe(Dpe(e)) : {};
}
var Lpe = Mpe, jpe = Kw, Fpe = $l, Bpe = "[object Map]";
function Upe(e) {
  return Fpe(e) && jpe(e) == Bpe;
}
var Vpe = Upe, $pe = Vpe, Hpe = gC, dR = vC, fR = dR && dR.isMap, Wpe = fR ? Hpe(fR) : $pe, zpe = Wpe, Kpe = Kw, qpe = $l, Gpe = "[object Set]";
function Ype(e) {
  return qpe(e) && Kpe(e) == Gpe;
}
var Xpe = Ype, Qpe = Xpe, Jpe = gC, hR = vC, pR = hR && hR.isSet, Zpe = pR ? Jpe(pR) : Qpe, eme = Zpe, tme = EC, rme = Bfe, nme = iB, ame = the, sme = yhe, ime = bhe, ome = xhe, lme = The, cme = Mhe, ume = Y5, dme = Uhe, fme = Kw, hme = Whe, pme = Ope, mme = Lpe, gme = zi, vme = pC, yme = zpe, bme = Oh, wme = eme, xme = Rg, _me = AC, Sme = 1, Eme = 2, Tme = 4, lB = "[object Arguments]", Cme = "[object Array]", kme = "[object Boolean]", Ome = "[object Date]", Ame = "[object Error]", cB = "[object Function]", Pme = "[object GeneratorFunction]", Rme = "[object Map]", Ime = "[object Number]", uB = "[object Object]", Dme = "[object RegExp]", Nme = "[object Set]", Mme = "[object String]", Lme = "[object Symbol]", jme = "[object WeakMap]", Fme = "[object ArrayBuffer]", Bme = "[object DataView]", Ume = "[object Float32Array]", Vme = "[object Float64Array]", $me = "[object Int8Array]", Hme = "[object Int16Array]", Wme = "[object Int32Array]", zme = "[object Uint8Array]", Kme = "[object Uint8ClampedArray]", qme = "[object Uint16Array]", Gme = "[object Uint32Array]", on = {};
on[lB] = on[Cme] = on[Fme] = on[Bme] = on[kme] = on[Ome] = on[Ume] = on[Vme] = on[$me] = on[Hme] = on[Wme] = on[Rme] = on[Ime] = on[uB] = on[Dme] = on[Nme] = on[Mme] = on[Lme] = on[zme] = on[Kme] = on[qme] = on[Gme] = !0;
on[Ame] = on[cB] = on[jme] = !1;
function Ty(e, t, r, n, a, s) {
  var i, o = t & Sme, l = t & Eme, c = t & Tme;
  if (r && (i = a ? r(e, n, a, s) : r(e)), i !== void 0)
    return i;
  if (!bme(e))
    return e;
  var u = gme(e);
  if (u) {
    if (i = hme(e), !o)
      return ome(e, i);
  } else {
    var d = fme(e), f = d == cB || d == Pme;
    if (vme(e))
      return ime(e, o);
    if (d == uB || d == lB || f && !a) {
      if (i = l || f ? {} : mme(e), !o)
        return l ? cme(e, sme(i, e)) : lme(e, ame(i, e));
    } else {
      if (!on[d])
        return a ? e : {};
      i = pme(e, d, o);
    }
  }
  s || (s = new tme());
  var h = s.get(e);
  if (h)
    return h;
  s.set(e, i), wme(e) ? e.forEach(function(g) {
    i.add(Ty(g, t, r, g, e, s));
  }) : yme(e) && e.forEach(function(g, y) {
    i.set(y, Ty(g, t, r, y, e, s));
  });
  var p = c ? l ? dme : ume : l ? _me : xme, m = u ? void 0 : p(e);
  return rme(m || e, function(g, y) {
    m && (y = g, g = e[y]), nme(i, y, Ty(g, t, r, y, e, s));
  }), i;
}
var Yme = Ty, Xme = Yme, Qme = 1, Jme = 4;
function Zme(e) {
  return Xme(e, Qme | Jme);
}
var ege = Zme;
Object.defineProperty(Ig, "__esModule", {
  value: !0
});
Ig.mergeClasses = void 0;
var tge = bC, rge = dB(tge), nge = ege, age = dB(nge), sge = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
};
function dB(e) {
  return e && e.__esModule ? e : { default: e };
}
var ige = Ig.mergeClasses = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = t.default && (0, age.default)(t.default) || {};
  return r.map(function(a) {
    var s = t[a];
    return s && (0, rge.default)(s, function(i, o) {
      n[o] || (n[o] = {}), n[o] = sge({}, n[o], s[o]);
    }), a;
  }), n;
};
Ig.default = ige;
var Dg = {};
Object.defineProperty(Dg, "__esModule", {
  value: !0
});
Dg.autoprefix = void 0;
var oge = bC, mR = cge(oge), lge = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
};
function cge(e) {
  return e && e.__esModule ? e : { default: e };
}
var uge = {
  borderRadius: function(t) {
    return {
      msBorderRadius: t,
      MozBorderRadius: t,
      OBorderRadius: t,
      WebkitBorderRadius: t,
      borderRadius: t
    };
  },
  boxShadow: function(t) {
    return {
      msBoxShadow: t,
      MozBoxShadow: t,
      OBoxShadow: t,
      WebkitBoxShadow: t,
      boxShadow: t
    };
  },
  userSelect: function(t) {
    return {
      WebkitTouchCallout: t,
      KhtmlUserSelect: t,
      MozUserSelect: t,
      msUserSelect: t,
      WebkitUserSelect: t,
      userSelect: t
    };
  },
  flex: function(t) {
    return {
      WebkitBoxFlex: t,
      MozBoxFlex: t,
      WebkitFlex: t,
      msFlex: t,
      flex: t
    };
  },
  flexBasis: function(t) {
    return {
      WebkitFlexBasis: t,
      flexBasis: t
    };
  },
  justifyContent: function(t) {
    return {
      WebkitJustifyContent: t,
      justifyContent: t
    };
  },
  transition: function(t) {
    return {
      msTransition: t,
      MozTransition: t,
      OTransition: t,
      WebkitTransition: t,
      transition: t
    };
  },
  transform: function(t) {
    return {
      msTransform: t,
      MozTransform: t,
      OTransform: t,
      WebkitTransform: t,
      transform: t
    };
  },
  absolute: function(t) {
    var r = t && t.split(" ");
    return {
      position: "absolute",
      top: r && r[0],
      right: r && r[1],
      bottom: r && r[2],
      left: r && r[3]
    };
  },
  extend: function(t, r) {
    var n = r[t];
    return n || {
      extend: t
    };
  }
}, dge = Dg.autoprefix = function(t) {
  var r = {};
  return (0, mR.default)(t, function(n, a) {
    var s = {};
    (0, mR.default)(n, function(i, o) {
      var l = uge[o];
      l ? s = lge({}, s, l(i)) : s[o] = i;
    }), r[a] = s;
  }), r;
};
Dg.default = dge;
var Ng = {};
Object.defineProperty(Ng, "__esModule", {
  value: !0
});
Ng.hover = void 0;
var fge = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, hge = M, J1 = pge(hge);
function pge(e) {
  return e && e.__esModule ? e : { default: e };
}
function mge(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function gR(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function gge(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var vge = Ng.hover = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(n) {
    gge(a, n);
    function a() {
      var s, i, o, l;
      mge(this, a);
      for (var c = arguments.length, u = Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      return l = (i = (o = gR(this, (s = a.__proto__ || Object.getPrototypeOf(a)).call.apply(s, [this].concat(u))), o), o.state = { hover: !1 }, o.handleMouseOver = function() {
        return o.setState({ hover: !0 });
      }, o.handleMouseOut = function() {
        return o.setState({ hover: !1 });
      }, o.render = function() {
        return J1.default.createElement(
          r,
          { onMouseOver: o.handleMouseOver, onMouseOut: o.handleMouseOut },
          J1.default.createElement(t, fge({}, o.props, o.state))
        );
      }, i), gR(o, l);
    }
    return a;
  }(J1.default.Component);
};
Ng.default = vge;
var Mg = {};
Object.defineProperty(Mg, "__esModule", {
  value: !0
});
Mg.active = void 0;
var yge = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, bge = M, Z1 = wge(bge);
function wge(e) {
  return e && e.__esModule ? e : { default: e };
}
function xge(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function vR(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function _ge(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Sge = Mg.active = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(n) {
    _ge(a, n);
    function a() {
      var s, i, o, l;
      xge(this, a);
      for (var c = arguments.length, u = Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      return l = (i = (o = vR(this, (s = a.__proto__ || Object.getPrototypeOf(a)).call.apply(s, [this].concat(u))), o), o.state = { active: !1 }, o.handleMouseDown = function() {
        return o.setState({ active: !0 });
      }, o.handleMouseUp = function() {
        return o.setState({ active: !1 });
      }, o.render = function() {
        return Z1.default.createElement(
          r,
          { onMouseDown: o.handleMouseDown, onMouseUp: o.handleMouseUp },
          Z1.default.createElement(t, yge({}, o.props, o.state))
        );
      }, i), vR(o, l);
    }
    return a;
  }(Z1.default.Component);
};
Mg.default = Sge;
var RC = {};
Object.defineProperty(RC, "__esModule", {
  value: !0
});
var Ege = function(t, r) {
  var n = {}, a = function(i) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    n[i] = o;
  };
  return t === 0 && a("first-child"), t === r - 1 && a("last-child"), (t === 0 || t % 2 === 0) && a("even"), Math.abs(t % 2) === 1 && a("odd"), a("nth-child", t), n;
};
RC.default = Ege;
Object.defineProperty(oi, "__esModule", {
  value: !0
});
oi.ReactCSS = oi.loop = oi.handleActive = IC = oi.handleHover = oi.hover = void 0;
var Tge = Ag, Cge = Nh(Tge), kge = Ig, Oge = Nh(kge), Age = Dg, Pge = Nh(Age), Rge = Ng, fB = Nh(Rge), Ige = Mg, Dge = Nh(Ige), Nge = RC, Mge = Nh(Nge);
function Nh(e) {
  return e && e.__esModule ? e : { default: e };
}
oi.hover = fB.default;
var IC = oi.handleHover = fB.default;
oi.handleActive = Dge.default;
oi.loop = Mge.default;
var Lge = oi.ReactCSS = function(t) {
  for (var r = arguments.length, n = Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
    n[a - 1] = arguments[a];
  var s = (0, Cge.default)(n), i = (0, Oge.default)(t, s);
  return (0, Pge.default)(i);
}, Yt = oi.default = Lge, jge = function(t, r, n, a, s) {
  var i = s.clientWidth, o = s.clientHeight, l = typeof t.pageX == "number" ? t.pageX : t.touches[0].pageX, c = typeof t.pageY == "number" ? t.pageY : t.touches[0].pageY, u = l - (s.getBoundingClientRect().left + window.pageXOffset), d = c - (s.getBoundingClientRect().top + window.pageYOffset);
  if (n === "vertical") {
    var f = void 0;
    if (d < 0 ? f = 0 : d > o ? f = 1 : f = Math.round(d * 100 / o) / 100, r.a !== f)
      return {
        h: r.h,
        s: r.s,
        l: r.l,
        a: f,
        source: "rgb"
      };
  } else {
    var h = void 0;
    if (u < 0 ? h = 0 : u > i ? h = 1 : h = Math.round(u * 100 / i) / 100, a !== h)
      return {
        h: r.h,
        s: r.s,
        l: r.l,
        a: h,
        source: "rgb"
      };
  }
  return null;
}, e_ = {}, Fge = function(t, r, n, a) {
  if (typeof document > "u" && !a)
    return null;
  var s = a ? new a() : document.createElement("canvas");
  s.width = n * 2, s.height = n * 2;
  var i = s.getContext("2d");
  return i ? (i.fillStyle = t, i.fillRect(0, 0, s.width, s.height), i.fillStyle = r, i.fillRect(0, 0, n, n), i.translate(n, n), i.fillRect(0, 0, n, n), s.toDataURL()) : null;
}, Bge = function(t, r, n, a) {
  var s = t + "-" + r + "-" + n + (a ? "-server" : "");
  if (e_[s])
    return e_[s];
  var i = Fge(t, r, n, a);
  return e_[s] = i, i;
}, yR = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, Mh = function(t) {
  var r = t.white, n = t.grey, a = t.size, s = t.renderers, i = t.borderRadius, o = t.boxShadow, l = t.children, c = Yt({
    default: {
      grid: {
        borderRadius: i,
        boxShadow: o,
        absolute: "0px 0px 0px 0px",
        background: "url(" + Bge(r, n, a, s.canvas) + ") center left"
      }
    }
  });
  return qz(l) ? M.cloneElement(l, yR({}, l.props, { style: yR({}, l.props.style, c.grid) })) : M.createElement("div", { style: c.grid });
};
Mh.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
var Uge = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, Vge = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function $ge(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function bR(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function Hge(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var DC = function(e) {
  Hge(t, e);
  function t() {
    var r, n, a, s;
    $ge(this, t);
    for (var i = arguments.length, o = Array(i), l = 0; l < i; l++)
      o[l] = arguments[l];
    return s = (n = (a = bR(this, (r = t.__proto__ || Object.getPrototypeOf(t)).call.apply(r, [this].concat(o))), a), a.handleChange = function(c) {
      var u = jge(c, a.props.hsl, a.props.direction, a.props.a, a.container);
      u && typeof a.props.onChange == "function" && a.props.onChange(u, c);
    }, a.handleMouseDown = function(c) {
      a.handleChange(c), window.addEventListener("mousemove", a.handleChange), window.addEventListener("mouseup", a.handleMouseUp);
    }, a.handleMouseUp = function() {
      a.unbindEventListeners();
    }, a.unbindEventListeners = function() {
      window.removeEventListener("mousemove", a.handleChange), window.removeEventListener("mouseup", a.handleMouseUp);
    }, n), bR(a, s);
  }
  return Vge(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props.rgb, s = Yt({
        default: {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden",
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + a.r + "," + a.g + "," + a.b + `, 0) 0%,
           rgba(` + a.r + "," + a.g + "," + a.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: a.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + a.r + "," + a.g + "," + a.b + `, 0) 0%,
           rgba(` + a.r + "," + a.g + "," + a.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: a.a * 100 + "%"
          }
        },
        overwrite: Uge({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: !0
      });
      return M.createElement(
        "div",
        { style: s.alpha },
        M.createElement(
          "div",
          { style: s.checkboard },
          M.createElement(Mh, { renderers: this.props.renderers })
        ),
        M.createElement("div", { style: s.gradient }),
        M.createElement(
          "div",
          {
            style: s.container,
            ref: function(o) {
              return n.container = o;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          M.createElement(
            "div",
            { style: s.pointer },
            this.props.pointer ? M.createElement(this.props.pointer, this.props) : M.createElement("div", { style: s.slider })
          )
        )
      );
    }
  }]), t;
}(wg || Cn), Wge = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function zge(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Kge(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qge(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function Gge(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Yge = 1, hB = 38, Xge = 40, Qge = [hB, Xge], Jge = function(t) {
  return Qge.indexOf(t) > -1;
}, Zge = function(t) {
  return Number(String(t).replace(/%/g, ""));
}, eve = 1, xr = function(e) {
  Gge(t, e);
  function t(r) {
    Kge(this, t);
    var n = qge(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
    return n.handleBlur = function() {
      n.state.blurValue && n.setState({ value: n.state.blurValue, blurValue: null });
    }, n.handleChange = function(a) {
      n.setUpdatedValue(a.target.value, a);
    }, n.handleKeyDown = function(a) {
      var s = Zge(a.target.value);
      if (!isNaN(s) && Jge(a.keyCode)) {
        var i = n.getArrowOffset(), o = a.keyCode === hB ? s + i : s - i;
        n.setUpdatedValue(o, a);
      }
    }, n.handleDrag = function(a) {
      if (n.props.dragLabel) {
        var s = Math.round(n.props.value + a.movementX);
        s >= 0 && s <= n.props.dragMax && n.props.onChange && n.props.onChange(n.getValueObjectWithLabel(s), a);
      }
    }, n.handleMouseDown = function(a) {
      n.props.dragLabel && (a.preventDefault(), n.handleDrag(a), window.addEventListener("mousemove", n.handleDrag), window.addEventListener("mouseup", n.handleMouseUp));
    }, n.handleMouseUp = function() {
      n.unbindEventListeners();
    }, n.unbindEventListeners = function() {
      window.removeEventListener("mousemove", n.handleDrag), window.removeEventListener("mouseup", n.handleMouseUp);
    }, n.state = {
      value: String(r.value).toUpperCase(),
      blurValue: String(r.value).toUpperCase()
    }, n.inputId = "rc-editable-input-" + eve++, n;
  }
  return Wge(t, [{
    key: "componentDidUpdate",
    value: function(n, a) {
      this.props.value !== this.state.value && (n.value !== this.props.value || a.value !== this.state.value) && (this.input === document.activeElement ? this.setState({ blurValue: String(this.props.value).toUpperCase() }) : this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "getValueObjectWithLabel",
    value: function(n) {
      return zge({}, this.props.label, n);
    }
  }, {
    key: "getArrowOffset",
    value: function() {
      return this.props.arrowOffset || Yge;
    }
  }, {
    key: "setUpdatedValue",
    value: function(n, a) {
      var s = this.props.label ? this.getValueObjectWithLabel(n) : n;
      this.props.onChange && this.props.onChange(s, a), this.setState({ value: n });
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = Yt({
        default: {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": !0
      }, this.props);
      return M.createElement(
        "div",
        { style: a.wrap },
        M.createElement("input", {
          id: this.inputId,
          style: a.input,
          ref: function(i) {
            return n.input = i;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: "false"
        }),
        this.props.label && !this.props.hideLabel ? M.createElement(
          "label",
          {
            htmlFor: this.inputId,
            style: a.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]), t;
}(wg || Cn), tve = function(t, r, n, a) {
  var s = a.clientWidth, i = a.clientHeight, o = typeof t.pageX == "number" ? t.pageX : t.touches[0].pageX, l = typeof t.pageY == "number" ? t.pageY : t.touches[0].pageY, c = o - (a.getBoundingClientRect().left + window.pageXOffset), u = l - (a.getBoundingClientRect().top + window.pageYOffset);
  if (r === "vertical") {
    var d = void 0;
    if (u < 0)
      d = 359;
    else if (u > i)
      d = 0;
    else {
      var f = -(u * 100 / i) + 100;
      d = 360 * f / 100;
    }
    if (n.h !== d)
      return {
        h: d,
        s: n.s,
        l: n.l,
        a: n.a,
        source: "hsl"
      };
  } else {
    var h = void 0;
    if (c < 0)
      h = 0;
    else if (c > s)
      h = 359;
    else {
      var p = c * 100 / s;
      h = 360 * p / 100;
    }
    if (n.h !== h)
      return {
        h,
        s: n.s,
        l: n.l,
        a: n.a,
        source: "hsl"
      };
  }
  return null;
}, rve = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function nve(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function wR(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function ave(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Lh = function(e) {
  ave(t, e);
  function t() {
    var r, n, a, s;
    nve(this, t);
    for (var i = arguments.length, o = Array(i), l = 0; l < i; l++)
      o[l] = arguments[l];
    return s = (n = (a = wR(this, (r = t.__proto__ || Object.getPrototypeOf(t)).call.apply(r, [this].concat(o))), a), a.handleChange = function(c) {
      var u = tve(c, a.props.direction, a.props.hsl, a.container);
      u && typeof a.props.onChange == "function" && a.props.onChange(u, c);
    }, a.handleMouseDown = function(c) {
      a.handleChange(c), window.addEventListener("mousemove", a.handleChange), window.addEventListener("mouseup", a.handleMouseUp);
    }, a.handleMouseUp = function() {
      a.unbindEventListeners();
    }, n), wR(a, s);
  }
  return rve(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props.direction, s = a === void 0 ? "horizontal" : a, i = Yt({
        default: {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%",
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, { vertical: s === "vertical" });
      return M.createElement(
        "div",
        { style: i.hue },
        M.createElement(
          "div",
          {
            className: "hue-" + s,
            style: i.container,
            ref: function(l) {
              return n.container = l;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          M.createElement(
            "style",
            null,
            `
            .hue-horizontal {
              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0
                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to right, #f00 0%, #ff0
                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }

            .hue-vertical {
              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,
                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,
                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }
          `
          ),
          M.createElement(
            "div",
            { style: i.pointer },
            this.props.pointer ? M.createElement(this.props.pointer, this.props) : M.createElement("div", { style: i.slider })
          )
        )
      );
    }
  }]), t;
}(wg || Cn), AE = { exports: {} }, Zv = { exports: {} }, Fr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xR;
function sve() {
  if (xR) return Fr;
  xR = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, o = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function w(S) {
    if (typeof S == "object" && S !== null) {
      var C = S.$$typeof;
      switch (C) {
        case t:
          switch (S = S.type, S) {
            case l:
            case c:
            case n:
            case s:
            case a:
            case d:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case o:
                case u:
                case p:
                case h:
                case i:
                  return S;
                default:
                  return C;
              }
          }
        case r:
          return C;
      }
    }
  }
  function _(S) {
    return w(S) === c;
  }
  return Fr.AsyncMode = l, Fr.ConcurrentMode = c, Fr.ContextConsumer = o, Fr.ContextProvider = i, Fr.Element = t, Fr.ForwardRef = u, Fr.Fragment = n, Fr.Lazy = p, Fr.Memo = h, Fr.Portal = r, Fr.Profiler = s, Fr.StrictMode = a, Fr.Suspense = d, Fr.isAsyncMode = function(S) {
    return _(S) || w(S) === l;
  }, Fr.isConcurrentMode = _, Fr.isContextConsumer = function(S) {
    return w(S) === o;
  }, Fr.isContextProvider = function(S) {
    return w(S) === i;
  }, Fr.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === t;
  }, Fr.isForwardRef = function(S) {
    return w(S) === u;
  }, Fr.isFragment = function(S) {
    return w(S) === n;
  }, Fr.isLazy = function(S) {
    return w(S) === p;
  }, Fr.isMemo = function(S) {
    return w(S) === h;
  }, Fr.isPortal = function(S) {
    return w(S) === r;
  }, Fr.isProfiler = function(S) {
    return w(S) === s;
  }, Fr.isStrictMode = function(S) {
    return w(S) === a;
  }, Fr.isSuspense = function(S) {
    return w(S) === d;
  }, Fr.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === n || S === c || S === s || S === a || S === d || S === f || typeof S == "object" && S !== null && (S.$$typeof === p || S.$$typeof === h || S.$$typeof === i || S.$$typeof === o || S.$$typeof === u || S.$$typeof === g || S.$$typeof === y || S.$$typeof === x || S.$$typeof === m);
  }, Fr.typeOf = w, Fr;
}
var Br = {}, _R;
function ive() {
  if (_R) return Br;
  _R = 1;
  var e = {};
  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, r = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, a = t ? Symbol.for("react.fragment") : 60107, s = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, l = t ? Symbol.for("react.context") : 60110, c = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, h = t ? Symbol.for("react.suspense_list") : 60120, p = t ? Symbol.for("react.memo") : 60115, m = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, y = t ? Symbol.for("react.fundamental") : 60117, x = t ? Symbol.for("react.responder") : 60118, w = t ? Symbol.for("react.scope") : 60119;
    function _(ee) {
      return typeof ee == "string" || typeof ee == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ee === a || ee === u || ee === i || ee === s || ee === f || ee === h || typeof ee == "object" && ee !== null && (ee.$$typeof === m || ee.$$typeof === p || ee.$$typeof === o || ee.$$typeof === l || ee.$$typeof === d || ee.$$typeof === y || ee.$$typeof === x || ee.$$typeof === w || ee.$$typeof === g);
    }
    function S(ee) {
      if (typeof ee == "object" && ee !== null) {
        var he = ee.$$typeof;
        switch (he) {
          case r:
            var Ee = ee.type;
            switch (Ee) {
              case c:
              case u:
              case a:
              case i:
              case s:
              case f:
                return Ee;
              default:
                var we = Ee && Ee.$$typeof;
                switch (we) {
                  case l:
                  case d:
                  case m:
                  case p:
                  case o:
                    return we;
                  default:
                    return he;
                }
            }
          case n:
            return he;
        }
      }
    }
    var C = c, E = u, O = l, k = o, A = r, P = d, D = a, N = m, z = p, G = n, Y = i, te = s, ae = f, ne = !1;
    function ue(ee) {
      return ne || (ne = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), q(ee) || S(ee) === c;
    }
    function q(ee) {
      return S(ee) === u;
    }
    function U(ee) {
      return S(ee) === l;
    }
    function Q(ee) {
      return S(ee) === o;
    }
    function L(ee) {
      return typeof ee == "object" && ee !== null && ee.$$typeof === r;
    }
    function j(ee) {
      return S(ee) === d;
    }
    function K(ee) {
      return S(ee) === a;
    }
    function J(ee) {
      return S(ee) === m;
    }
    function re(ee) {
      return S(ee) === p;
    }
    function le(ee) {
      return S(ee) === n;
    }
    function pe(ee) {
      return S(ee) === i;
    }
    function me(ee) {
      return S(ee) === s;
    }
    function Oe(ee) {
      return S(ee) === f;
    }
    Br.AsyncMode = C, Br.ConcurrentMode = E, Br.ContextConsumer = O, Br.ContextProvider = k, Br.Element = A, Br.ForwardRef = P, Br.Fragment = D, Br.Lazy = N, Br.Memo = z, Br.Portal = G, Br.Profiler = Y, Br.StrictMode = te, Br.Suspense = ae, Br.isAsyncMode = ue, Br.isConcurrentMode = q, Br.isContextConsumer = U, Br.isContextProvider = Q, Br.isElement = L, Br.isForwardRef = j, Br.isFragment = K, Br.isLazy = J, Br.isMemo = re, Br.isPortal = le, Br.isProfiler = pe, Br.isStrictMode = me, Br.isSuspense = Oe, Br.isValidElementType = _, Br.typeOf = S;
  }(), Br;
}
var SR;
function pB() {
  if (SR) return Zv.exports;
  SR = 1;
  var e = {};
  return e.NODE_ENV === "production" ? Zv.exports = sve() : Zv.exports = ive(), Zv.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ER = Object.getOwnPropertySymbols, ove = Object.prototype.hasOwnProperty, lve = Object.prototype.propertyIsEnumerable;
function cve(e) {
  if (e == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
function uve() {
  try {
    if (!Object.assign)
      return !1;
    var e = new String("abc");
    if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5")
      return !1;
    for (var t = {}, r = 0; r < 10; r++)
      t["_" + String.fromCharCode(r)] = r;
    var n = Object.getOwnPropertyNames(t).map(function(s) {
      return t[s];
    });
    if (n.join("") !== "0123456789")
      return !1;
    var a = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(s) {
      a[s] = s;
    }), Object.keys(Object.assign({}, a)).join("") === "abcdefghijklmnopqrst";
  } catch {
    return !1;
  }
}
var Kc = uve() ? Object.assign : function(e, t) {
  for (var r, n = cve(e), a, s = 1; s < arguments.length; s++) {
    r = Object(arguments[s]);
    for (var i in r)
      ove.call(r, i) && (n[i] = r[i]);
    if (ER) {
      a = ER(r);
      for (var o = 0; o < a.length; o++)
        lve.call(r, a[o]) && (n[a[o]] = r[a[o]]);
    }
  }
  return n;
}, t_, TR;
function NC() {
  if (TR) return t_;
  TR = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return t_ = e, t_;
}
var r_, CR;
function mB() {
  return CR || (CR = 1, r_ = Function.call.bind(Object.prototype.hasOwnProperty)), r_;
}
var n_, kR;
function dve() {
  if (kR) return n_;
  kR = 1;
  var e = {}, t = function() {
  };
  if (e.NODE_ENV !== "production") {
    var r = NC(), n = {}, a = mB();
    t = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function s(i, o, l, c, u) {
    if (e.NODE_ENV !== "production") {
      for (var d in i)
        if (a(i, d)) {
          var f;
          try {
            if (typeof i[d] != "function") {
              var h = Error(
                (c || "React class") + ": " + l + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            f = i[d](o, d, c, l, null, r);
          } catch (m) {
            f = m;
          }
          if (f && !(f instanceof Error) && t(
            (c || "React class") + ": type specification of " + l + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var p = u ? u() : "";
            t(
              "Failed " + l + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    e.NODE_ENV !== "production" && (n = {});
  }, n_ = s, n_;
}
var a_, OR;
function fve() {
  if (OR) return a_;
  OR = 1;
  var e = {}, t = pB(), r = Kc, n = NC(), a = mB(), s = dve(), i = function() {
  };
  e.NODE_ENV !== "production" && (i = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return a_ = function(l, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(q) {
      var U = q && (u && q[u] || q[d]);
      if (typeof U == "function")
        return U;
    }
    var h = "<<anonymous>>", p = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: w(),
      arrayOf: _,
      element: S(),
      elementType: C(),
      instanceOf: E,
      node: P(),
      objectOf: k,
      oneOf: O,
      oneOfType: A,
      shape: N,
      exact: z
    };
    function m(q, U) {
      return q === U ? q !== 0 || 1 / q === 1 / U : q !== q && U !== U;
    }
    function g(q, U) {
      this.message = q, this.data = U && typeof U == "object" ? U : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function y(q) {
      if (e.NODE_ENV !== "production")
        var U = {}, Q = 0;
      function L(K, J, re, le, pe, me, Oe) {
        if (le = le || h, me = me || re, Oe !== n) {
          if (c) {
            var ee = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ee.name = "Invariant Violation", ee;
          } else if (e.NODE_ENV !== "production" && typeof console < "u") {
            var he = le + ":" + re;
            !U[he] && // Avoid spamming the console because they are often not actionable except for lib authors
            Q < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + me + "` prop on `" + le + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), U[he] = !0, Q++);
          }
        }
        return J[re] == null ? K ? J[re] === null ? new g("The " + pe + " `" + me + "` is marked as required " + ("in `" + le + "`, but its value is `null`.")) : new g("The " + pe + " `" + me + "` is marked as required in " + ("`" + le + "`, but its value is `undefined`.")) : null : q(J, re, le, pe, me);
      }
      var j = L.bind(null, !1);
      return j.isRequired = L.bind(null, !0), j;
    }
    function x(q) {
      function U(Q, L, j, K, J, re) {
        var le = Q[L], pe = te(le);
        if (pe !== q) {
          var me = ae(le);
          return new g(
            "Invalid " + K + " `" + J + "` of type " + ("`" + me + "` supplied to `" + j + "`, expected ") + ("`" + q + "`."),
            { expectedType: q }
          );
        }
        return null;
      }
      return y(U);
    }
    function w() {
      return y(o);
    }
    function _(q) {
      function U(Q, L, j, K, J) {
        if (typeof q != "function")
          return new g("Property `" + J + "` of component `" + j + "` has invalid PropType notation inside arrayOf.");
        var re = Q[L];
        if (!Array.isArray(re)) {
          var le = te(re);
          return new g("Invalid " + K + " `" + J + "` of type " + ("`" + le + "` supplied to `" + j + "`, expected an array."));
        }
        for (var pe = 0; pe < re.length; pe++) {
          var me = q(re, pe, j, K, J + "[" + pe + "]", n);
          if (me instanceof Error)
            return me;
        }
        return null;
      }
      return y(U);
    }
    function S() {
      function q(U, Q, L, j, K) {
        var J = U[Q];
        if (!l(J)) {
          var re = te(J);
          return new g("Invalid " + j + " `" + K + "` of type " + ("`" + re + "` supplied to `" + L + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(q);
    }
    function C() {
      function q(U, Q, L, j, K) {
        var J = U[Q];
        if (!t.isValidElementType(J)) {
          var re = te(J);
          return new g("Invalid " + j + " `" + K + "` of type " + ("`" + re + "` supplied to `" + L + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(q);
    }
    function E(q) {
      function U(Q, L, j, K, J) {
        if (!(Q[L] instanceof q)) {
          var re = q.name || h, le = ue(Q[L]);
          return new g("Invalid " + K + " `" + J + "` of type " + ("`" + le + "` supplied to `" + j + "`, expected ") + ("instance of `" + re + "`."));
        }
        return null;
      }
      return y(U);
    }
    function O(q) {
      if (!Array.isArray(q))
        return e.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function U(Q, L, j, K, J) {
        for (var re = Q[L], le = 0; le < q.length; le++)
          if (m(re, q[le]))
            return null;
        var pe = JSON.stringify(q, function(Oe, ee) {
          var he = ae(ee);
          return he === "symbol" ? String(ee) : ee;
        });
        return new g("Invalid " + K + " `" + J + "` of value `" + String(re) + "` " + ("supplied to `" + j + "`, expected one of " + pe + "."));
      }
      return y(U);
    }
    function k(q) {
      function U(Q, L, j, K, J) {
        if (typeof q != "function")
          return new g("Property `" + J + "` of component `" + j + "` has invalid PropType notation inside objectOf.");
        var re = Q[L], le = te(re);
        if (le !== "object")
          return new g("Invalid " + K + " `" + J + "` of type " + ("`" + le + "` supplied to `" + j + "`, expected an object."));
        for (var pe in re)
          if (a(re, pe)) {
            var me = q(re, pe, j, K, J + "." + pe, n);
            if (me instanceof Error)
              return me;
          }
        return null;
      }
      return y(U);
    }
    function A(q) {
      if (!Array.isArray(q))
        return e.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var U = 0; U < q.length; U++) {
        var Q = q[U];
        if (typeof Q != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ne(Q) + " at index " + U + "."
          ), o;
      }
      function L(j, K, J, re, le) {
        for (var pe = [], me = 0; me < q.length; me++) {
          var Oe = q[me], ee = Oe(j, K, J, re, le, n);
          if (ee == null)
            return null;
          ee.data && a(ee.data, "expectedType") && pe.push(ee.data.expectedType);
        }
        var he = pe.length > 0 ? ", expected one of type [" + pe.join(", ") + "]" : "";
        return new g("Invalid " + re + " `" + le + "` supplied to " + ("`" + J + "`" + he + "."));
      }
      return y(L);
    }
    function P() {
      function q(U, Q, L, j, K) {
        return G(U[Q]) ? null : new g("Invalid " + j + " `" + K + "` supplied to " + ("`" + L + "`, expected a ReactNode."));
      }
      return y(q);
    }
    function D(q, U, Q, L, j) {
      return new g(
        (q || "React class") + ": " + U + " type `" + Q + "." + L + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + j + "`."
      );
    }
    function N(q) {
      function U(Q, L, j, K, J) {
        var re = Q[L], le = te(re);
        if (le !== "object")
          return new g("Invalid " + K + " `" + J + "` of type `" + le + "` " + ("supplied to `" + j + "`, expected `object`."));
        for (var pe in q) {
          var me = q[pe];
          if (typeof me != "function")
            return D(j, K, J, pe, ae(me));
          var Oe = me(re, pe, j, K, J + "." + pe, n);
          if (Oe)
            return Oe;
        }
        return null;
      }
      return y(U);
    }
    function z(q) {
      function U(Q, L, j, K, J) {
        var re = Q[L], le = te(re);
        if (le !== "object")
          return new g("Invalid " + K + " `" + J + "` of type `" + le + "` " + ("supplied to `" + j + "`, expected `object`."));
        var pe = r({}, Q[L], q);
        for (var me in pe) {
          var Oe = q[me];
          if (a(q, me) && typeof Oe != "function")
            return D(j, K, J, me, ae(Oe));
          if (!Oe)
            return new g(
              "Invalid " + K + " `" + J + "` key `" + me + "` supplied to `" + j + "`.\nBad object: " + JSON.stringify(Q[L], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(q), null, "  ")
            );
          var ee = Oe(re, me, j, K, J + "." + me, n);
          if (ee)
            return ee;
        }
        return null;
      }
      return y(U);
    }
    function G(q) {
      switch (typeof q) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !q;
        case "object":
          if (Array.isArray(q))
            return q.every(G);
          if (q === null || l(q))
            return !0;
          var U = f(q);
          if (U) {
            var Q = U.call(q), L;
            if (U !== q.entries) {
              for (; !(L = Q.next()).done; )
                if (!G(L.value))
                  return !1;
            } else
              for (; !(L = Q.next()).done; ) {
                var j = L.value;
                if (j && !G(j[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Y(q, U) {
      return q === "symbol" ? !0 : U ? U["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && U instanceof Symbol : !1;
    }
    function te(q) {
      var U = typeof q;
      return Array.isArray(q) ? "array" : q instanceof RegExp ? "object" : Y(U, q) ? "symbol" : U;
    }
    function ae(q) {
      if (typeof q > "u" || q === null)
        return "" + q;
      var U = te(q);
      if (U === "object") {
        if (q instanceof Date)
          return "date";
        if (q instanceof RegExp)
          return "regexp";
      }
      return U;
    }
    function ne(q) {
      var U = ae(q);
      switch (U) {
        case "array":
        case "object":
          return "an " + U;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + U;
        default:
          return U;
      }
    }
    function ue(q) {
      return !q.constructor || !q.constructor.name ? h : q.constructor.name;
    }
    return p.checkPropTypes = s, p.resetWarningCache = s.resetWarningCache, p.PropTypes = p, p;
  }, a_;
}
var s_, AR;
function hve() {
  if (AR) return s_;
  AR = 1;
  var e = NC();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, s_ = function() {
    function n(i, o, l, c, u, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var s = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, s_;
}
var pve = {};
if (pve.NODE_ENV !== "production") {
  var mve = pB(), gve = !0;
  AE.exports = fve()(mve.isElement, gve);
} else
  AE.exports = hve()();
var vve = AE.exports;
const xt = /* @__PURE__ */ wh(vve);
function yve() {
  this.__data__ = [], this.size = 0;
}
function Lg(e, t) {
  return e === t || e !== e && t !== t;
}
function Xw(e, t) {
  for (var r = e.length; r--; )
    if (Lg(e[r][0], t))
      return r;
  return -1;
}
var bve = Array.prototype, wve = bve.splice;
function xve(e) {
  var t = this.__data__, r = Xw(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : wve.call(t, r, 1), --this.size, !0;
}
function _ve(e) {
  var t = this.__data__, r = Xw(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function Sve(e) {
  return Xw(this.__data__, e) > -1;
}
function Eve(e, t) {
  var r = this.__data__, n = Xw(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function Hl(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Hl.prototype.clear = yve;
Hl.prototype.delete = xve;
Hl.prototype.get = _ve;
Hl.prototype.has = Sve;
Hl.prototype.set = Eve;
function Tve() {
  this.__data__ = new Hl(), this.size = 0;
}
function Cve(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function kve(e) {
  return this.__data__.get(e);
}
function Ove(e) {
  return this.__data__.has(e);
}
var gB = typeof window == "object" && window && window.Object === Object && window, Ave = typeof self == "object" && self && self.Object === Object && self, Ki = gB || Ave || Function("return this")(), Nc = Ki.Symbol, vB = Object.prototype, Pve = vB.hasOwnProperty, Rve = vB.toString, hp = Nc ? Nc.toStringTag : void 0;
function Ive(e) {
  var t = Pve.call(e, hp), r = e[hp];
  try {
    e[hp] = void 0;
    var n = !0;
  } catch {
  }
  var a = Rve.call(e);
  return n && (t ? e[hp] = r : delete e[hp]), a;
}
var Dve = Object.prototype, Nve = Dve.toString;
function Mve(e) {
  return Nve.call(e);
}
var Lve = "[object Null]", jve = "[object Undefined]", PR = Nc ? Nc.toStringTag : void 0;
function ad(e) {
  return e == null ? e === void 0 ? jve : Lve : PR && PR in Object(e) ? Ive(e) : Mve(e);
}
function pi(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Fve = "[object AsyncFunction]", Bve = "[object Function]", Uve = "[object GeneratorFunction]", Vve = "[object Proxy]";
function MC(e) {
  if (!pi(e))
    return !1;
  var t = ad(e);
  return t == Bve || t == Uve || t == Fve || t == Vve;
}
var i_ = Ki["__core-js_shared__"], RR = function() {
  var e = /[^.]+$/.exec(i_ && i_.keys && i_.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function $ve(e) {
  return !!RR && RR in e;
}
var Hve = Function.prototype, Wve = Hve.toString;
function sd(e) {
  if (e != null) {
    try {
      return Wve.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var zve = /[\\^$.*+?()[\]{}|]/g, Kve = /^\[object .+?Constructor\]$/, qve = Function.prototype, Gve = Object.prototype, Yve = qve.toString, Xve = Gve.hasOwnProperty, Qve = RegExp(
  "^" + Yve.call(Xve).replace(zve, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Jve(e) {
  if (!pi(e) || $ve(e))
    return !1;
  var t = MC(e) ? Qve : Kve;
  return t.test(sd(e));
}
function Zve(e, t) {
  return e == null ? void 0 : e[t];
}
function id(e, t) {
  var r = Zve(e, t);
  return Jve(r) ? r : void 0;
}
var Zm = id(Ki, "Map"), eg = id(Object, "create");
function e0e() {
  this.__data__ = eg ? eg(null) : {}, this.size = 0;
}
function t0e(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var r0e = "__lodash_hash_undefined__", n0e = Object.prototype, a0e = n0e.hasOwnProperty;
function s0e(e) {
  var t = this.__data__;
  if (eg) {
    var r = t[e];
    return r === r0e ? void 0 : r;
  }
  return a0e.call(t, e) ? t[e] : void 0;
}
var i0e = Object.prototype, o0e = i0e.hasOwnProperty;
function l0e(e) {
  var t = this.__data__;
  return eg ? t[e] !== void 0 : o0e.call(t, e);
}
var c0e = "__lodash_hash_undefined__";
function u0e(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = eg && t === void 0 ? c0e : t, this;
}
function zu(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
zu.prototype.clear = e0e;
zu.prototype.delete = t0e;
zu.prototype.get = s0e;
zu.prototype.has = l0e;
zu.prototype.set = u0e;
function d0e() {
  this.size = 0, this.__data__ = {
    hash: new zu(),
    map: new (Zm || Hl)(),
    string: new zu()
  };
}
function f0e(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Qw(e, t) {
  var r = e.__data__;
  return f0e(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function h0e(e) {
  var t = Qw(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function p0e(e) {
  return Qw(this, e).get(e);
}
function m0e(e) {
  return Qw(this, e).has(e);
}
function g0e(e, t) {
  var r = Qw(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function Wl(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Wl.prototype.clear = d0e;
Wl.prototype.delete = h0e;
Wl.prototype.get = p0e;
Wl.prototype.has = m0e;
Wl.prototype.set = g0e;
var v0e = 200;
function y0e(e, t) {
  var r = this.__data__;
  if (r instanceof Hl) {
    var n = r.__data__;
    if (!Zm || n.length < v0e - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Wl(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function Do(e) {
  var t = this.__data__ = new Hl(e);
  this.size = t.size;
}
Do.prototype.clear = Tve;
Do.prototype.delete = Cve;
Do.prototype.get = kve;
Do.prototype.has = Ove;
Do.prototype.set = y0e;
var gb = function() {
  try {
    var e = id(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
function LC(e, t, r) {
  t == "__proto__" && gb ? gb(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function PE(e, t, r) {
  (r !== void 0 && !Lg(e[t], r) || r === void 0 && !(t in e)) && LC(e, t, r);
}
function b0e(e) {
  return function(t, r, n) {
    for (var a = -1, s = Object(t), i = n(t), o = i.length; o--; ) {
      var l = i[++a];
      if (r(s[l], l, s) === !1)
        break;
    }
    return t;
  };
}
var yB = b0e(), bB = typeof exports == "object" && exports && !exports.nodeType && exports, IR = bB && typeof module == "object" && module && !module.nodeType && module, w0e = IR && IR.exports === bB, DR = w0e ? Ki.Buffer : void 0;
DR && DR.allocUnsafe;
function x0e(e, t) {
  return e.slice();
}
var vb = Ki.Uint8Array;
function _0e(e) {
  var t = new e.constructor(e.byteLength);
  return new vb(t).set(new vb(e)), t;
}
function S0e(e, t) {
  var r = _0e(e.buffer);
  return new e.constructor(r, e.byteOffset, e.length);
}
function E0e(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var NR = Object.create, T0e = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!pi(t))
      return {};
    if (NR)
      return NR(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}();
function wB(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var xB = wB(Object.getPrototypeOf, Object), C0e = Object.prototype;
function jC(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || C0e;
  return e === r;
}
function k0e(e) {
  return typeof e.constructor == "function" && !jC(e) ? T0e(xB(e)) : {};
}
function Mc(e) {
  return e != null && typeof e == "object";
}
var O0e = "[object Arguments]";
function MR(e) {
  return Mc(e) && ad(e) == O0e;
}
var _B = Object.prototype, A0e = _B.hasOwnProperty, P0e = _B.propertyIsEnumerable, yb = MR(/* @__PURE__ */ function() {
  return arguments;
}()) ? MR : function(e) {
  return Mc(e) && A0e.call(e, "callee") && !P0e.call(e, "callee");
}, Ks = Array.isArray, R0e = 9007199254740991;
function FC(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= R0e;
}
function jh(e) {
  return e != null && FC(e.length) && !MC(e);
}
function I0e(e) {
  return Mc(e) && jh(e);
}
function D0e() {
  return !1;
}
var SB = typeof exports == "object" && exports && !exports.nodeType && exports, LR = SB && typeof module == "object" && module && !module.nodeType && module, N0e = LR && LR.exports === SB, jR = N0e ? Ki.Buffer : void 0, M0e = jR ? jR.isBuffer : void 0, bb = M0e || D0e, L0e = "[object Object]", j0e = Function.prototype, F0e = Object.prototype, EB = j0e.toString, B0e = F0e.hasOwnProperty, U0e = EB.call(Object);
function V0e(e) {
  if (!Mc(e) || ad(e) != L0e)
    return !1;
  var t = xB(e);
  if (t === null)
    return !0;
  var r = B0e.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && EB.call(r) == U0e;
}
var $0e = "[object Arguments]", H0e = "[object Array]", W0e = "[object Boolean]", z0e = "[object Date]", K0e = "[object Error]", q0e = "[object Function]", G0e = "[object Map]", Y0e = "[object Number]", X0e = "[object Object]", Q0e = "[object RegExp]", J0e = "[object Set]", Z0e = "[object String]", eye = "[object WeakMap]", tye = "[object ArrayBuffer]", rye = "[object DataView]", nye = "[object Float32Array]", aye = "[object Float64Array]", sye = "[object Int8Array]", iye = "[object Int16Array]", oye = "[object Int32Array]", lye = "[object Uint8Array]", cye = "[object Uint8ClampedArray]", uye = "[object Uint16Array]", dye = "[object Uint32Array]", hn = {};
hn[nye] = hn[aye] = hn[sye] = hn[iye] = hn[oye] = hn[lye] = hn[cye] = hn[uye] = hn[dye] = !0;
hn[$0e] = hn[H0e] = hn[tye] = hn[W0e] = hn[rye] = hn[z0e] = hn[K0e] = hn[q0e] = hn[G0e] = hn[Y0e] = hn[X0e] = hn[Q0e] = hn[J0e] = hn[Z0e] = hn[eye] = !1;
function fye(e) {
  return Mc(e) && FC(e.length) && !!hn[ad(e)];
}
function hye(e) {
  return function(t) {
    return e(t);
  };
}
var TB = typeof exports == "object" && exports && !exports.nodeType && exports, fm = TB && typeof module == "object" && module && !module.nodeType && module, pye = fm && fm.exports === TB, o_ = pye && gB.process, FR = function() {
  try {
    var e = fm && fm.require && fm.require("util").types;
    return e || o_ && o_.binding && o_.binding("util");
  } catch {
  }
}(), BR = FR && FR.isTypedArray, BC = BR ? hye(BR) : fye;
function RE(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var mye = Object.prototype, gye = mye.hasOwnProperty;
function vye(e, t, r) {
  var n = e[t];
  (!(gye.call(e, t) && Lg(n, r)) || r === void 0 && !(t in e)) && LC(e, t, r);
}
function yye(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var s = -1, i = t.length; ++s < i; ) {
    var o = t[s], l = void 0;
    l === void 0 && (l = e[o]), a ? LC(r, o, l) : vye(r, o, l);
  }
  return r;
}
function bye(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var wye = 9007199254740991, xye = /^(?:0|[1-9]\d*)$/;
function UC(e, t) {
  var r = typeof e;
  return t = t ?? wye, !!t && (r == "number" || r != "symbol" && xye.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var _ye = Object.prototype, Sye = _ye.hasOwnProperty;
function CB(e, t) {
  var r = Ks(e), n = !r && yb(e), a = !r && !n && bb(e), s = !r && !n && !a && BC(e), i = r || n || a || s, o = i ? bye(e.length, String) : [], l = o.length;
  for (var c in e)
    (t || Sye.call(e, c)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    UC(c, l))) && o.push(c);
  return o;
}
function Eye(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var Tye = Object.prototype, Cye = Tye.hasOwnProperty;
function kye(e) {
  if (!pi(e))
    return Eye(e);
  var t = jC(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !Cye.call(e, n)) || r.push(n);
  return r;
}
function kB(e) {
  return jh(e) ? CB(e, !0) : kye(e);
}
function Oye(e) {
  return yye(e, kB(e));
}
function Aye(e, t, r, n, a, s, i) {
  var o = RE(e, r), l = RE(t, r), c = i.get(l);
  if (c) {
    PE(e, r, c);
    return;
  }
  var u = s ? s(o, l, r + "", e, t, i) : void 0, d = u === void 0;
  if (d) {
    var f = Ks(l), h = !f && bb(l), p = !f && !h && BC(l);
    u = l, f || h || p ? Ks(o) ? u = o : I0e(o) ? u = E0e(o) : h ? (d = !1, u = x0e(l)) : p ? (d = !1, u = S0e(l)) : u = [] : V0e(l) || yb(l) ? (u = o, yb(o) ? u = Oye(o) : (!pi(o) || MC(o)) && (u = k0e(l))) : d = !1;
  }
  d && (i.set(l, u), a(u, l, n, s, i), i.delete(l)), PE(e, r, u);
}
function OB(e, t, r, n, a) {
  e !== t && yB(t, function(s, i) {
    if (a || (a = new Do()), pi(s))
      Aye(e, t, i, r, OB, n, a);
    else {
      var o = n ? n(RE(e, i), s, i + "", e, t, a) : void 0;
      o === void 0 && (o = s), PE(e, i, o);
    }
  }, kB);
}
function Jw(e) {
  return e;
}
function Pye(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var UR = Math.max;
function Rye(e, t, r) {
  return t = UR(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, s = UR(n.length - t, 0), i = Array(s); ++a < s; )
      i[a] = n[t + a];
    a = -1;
    for (var o = Array(t + 1); ++a < t; )
      o[a] = n[a];
    return o[t] = r(i), Pye(e, this, o);
  };
}
function Iye(e) {
  return function() {
    return e;
  };
}
var Dye = gb ? function(e, t) {
  return gb(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Iye(t),
    writable: !0
  });
} : Jw, Nye = 800, Mye = 16, Lye = Date.now;
function jye(e) {
  var t = 0, r = 0;
  return function() {
    var n = Lye(), a = Mye - (n - r);
    if (r = n, a > 0) {
      if (++t >= Nye)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var Fye = jye(Dye);
function Bye(e, t) {
  return Fye(Rye(e, t, Jw), e + "");
}
function Uye(e, t, r) {
  if (!pi(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? jh(r) && UC(t, r.length) : n == "string" && t in r) ? Lg(r[t], e) : !1;
}
function Vye(e) {
  return Bye(function(t, r) {
    var n = -1, a = r.length, s = a > 1 ? r[a - 1] : void 0, i = a > 2 ? r[2] : void 0;
    for (s = e.length > 3 && typeof s == "function" ? (a--, s) : void 0, i && Uye(r[0], r[1], i) && (s = a < 3 ? void 0 : s, a = 1), t = Object(t); ++n < a; ) {
      var o = r[n];
      o && e(t, o, n, s);
    }
    return t;
  });
}
var Es = Vye(function(e, t, r) {
  OB(e, t, r);
}), jg = function(t) {
  var r = t.zDepth, n = t.radius, a = t.background, s = t.children, i = t.styles, o = i === void 0 ? {} : i, l = Yt(Es({
    default: {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + r + "px " + r * 4 + "px rgba(0,0,0,.24)",
        borderRadius: n,
        background: a
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    square: {
      bg: {
        borderRadius: "0"
      }
    },
    circle: {
      bg: {
        borderRadius: "50%"
      }
    }
  }, o), { "zDepth-1": r === 1 });
  return M.createElement(
    "div",
    { style: l.wrap },
    M.createElement("div", { style: l.bg }),
    M.createElement(
      "div",
      { style: l.content },
      s
    )
  );
};
jg.propTypes = {
  background: xt.string,
  zDepth: xt.oneOf([0, 1, 2, 3, 4, 5]),
  radius: xt.number,
  styles: xt.object
};
jg.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2,
  styles: {}
};
var l_ = function() {
  return Ki.Date.now();
}, $ye = /\s/;
function Hye(e) {
  for (var t = e.length; t-- && $ye.test(e.charAt(t)); )
    ;
  return t;
}
var Wye = /^\s+/;
function zye(e) {
  return e && e.slice(0, Hye(e) + 1).replace(Wye, "");
}
var Kye = "[object Symbol]";
function Zw(e) {
  return typeof e == "symbol" || Mc(e) && ad(e) == Kye;
}
var VR = NaN, qye = /^[-+]0x[0-9a-f]+$/i, Gye = /^0b[01]+$/i, Yye = /^0o[0-7]+$/i, Xye = parseInt;
function $R(e) {
  if (typeof e == "number")
    return e;
  if (Zw(e))
    return VR;
  if (pi(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = pi(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = zye(e);
  var r = Gye.test(e);
  return r || Yye.test(e) ? Xye(e.slice(2), r ? 2 : 8) : qye.test(e) ? VR : +e;
}
var Qye = "Expected a function", Jye = Math.max, Zye = Math.min;
function AB(e, t, r) {
  var n, a, s, i, o, l, c = 0, u = !1, d = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(Qye);
  t = $R(t) || 0, pi(r) && (u = !!r.leading, d = "maxWait" in r, s = d ? Jye($R(r.maxWait) || 0, t) : s, f = "trailing" in r ? !!r.trailing : f);
  function h(C) {
    var E = n, O = a;
    return n = a = void 0, c = C, i = e.apply(O, E), i;
  }
  function p(C) {
    return c = C, o = setTimeout(y, t), u ? h(C) : i;
  }
  function m(C) {
    var E = C - l, O = C - c, k = t - E;
    return d ? Zye(k, s - O) : k;
  }
  function g(C) {
    var E = C - l, O = C - c;
    return l === void 0 || E >= t || E < 0 || d && O >= s;
  }
  function y() {
    var C = l_();
    if (g(C))
      return x(C);
    o = setTimeout(y, m(C));
  }
  function x(C) {
    return o = void 0, f && n ? h(C) : (n = a = void 0, i);
  }
  function w() {
    o !== void 0 && clearTimeout(o), c = 0, n = l = a = o = void 0;
  }
  function _() {
    return o === void 0 ? i : x(l_());
  }
  function S() {
    var C = l_(), E = g(C);
    if (n = arguments, a = this, l = C, E) {
      if (o === void 0)
        return p(l);
      if (d)
        return clearTimeout(o), o = setTimeout(y, t), h(l);
    }
    return o === void 0 && (o = setTimeout(y, t)), i;
  }
  return S.cancel = w, S.flush = _, S;
}
var ebe = "Expected a function";
function tbe(e, t, r) {
  var n = !0, a = !0;
  if (typeof e != "function")
    throw new TypeError(ebe);
  return pi(r) && (n = "leading" in r ? !!r.leading : n, a = "trailing" in r ? !!r.trailing : a), AB(e, t, {
    leading: n,
    maxWait: t,
    trailing: a
  });
}
var rbe = function(t, r, n) {
  var a = n.getBoundingClientRect(), s = a.width, i = a.height, o = typeof t.pageX == "number" ? t.pageX : t.touches[0].pageX, l = typeof t.pageY == "number" ? t.pageY : t.touches[0].pageY, c = o - (n.getBoundingClientRect().left + window.pageXOffset), u = l - (n.getBoundingClientRect().top + window.pageYOffset);
  c < 0 ? c = 0 : c > s && (c = s), u < 0 ? u = 0 : u > i && (u = i);
  var d = c / s, f = 1 - u / i;
  return {
    h: r.h,
    s: d,
    v: f,
    a: r.a,
    source: "hsv"
  };
}, nbe = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function abe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function sbe(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function ibe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var ex = function(e) {
  ibe(t, e);
  function t(r) {
    abe(this, t);
    var n = sbe(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, r));
    return n.handleChange = function(a) {
      typeof n.props.onChange == "function" && n.throttle(n.props.onChange, rbe(a, n.props.hsl, n.container), a);
    }, n.handleMouseDown = function(a) {
      n.handleChange(a);
      var s = n.getContainerRenderWindow();
      s.addEventListener("mousemove", n.handleChange), s.addEventListener("mouseup", n.handleMouseUp);
    }, n.handleMouseUp = function() {
      n.unbindEventListeners();
    }, n.throttle = tbe(function(a, s, i) {
      a(s, i);
    }, 50), n;
  }
  return nbe(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.throttle.cancel(), this.unbindEventListeners();
    }
  }, {
    key: "getContainerRenderWindow",
    value: function() {
      for (var n = this.container, a = window; !a.document.contains(n) && a.parent !== a; )
        a = a.parent;
      return a;
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      var n = this.getContainerRenderWindow();
      n.removeEventListener("mousemove", this.handleChange), n.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props.style || {}, s = a.color, i = a.white, o = a.black, l = a.pointer, c = a.circle, u = Yt({
        default: {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: `0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),
            0 0 1px 2px rgba(0,0,0,.4)`,
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        custom: {
          color: s,
          white: i,
          black: o,
          pointer: l,
          circle: c
        }
      }, { custom: !!this.props.style });
      return M.createElement(
        "div",
        {
          style: u.color,
          ref: function(f) {
            return n.container = f;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        M.createElement(
          "style",
          null,
          `
          .saturation-white {
            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));
            background: linear-gradient(to right, #fff, rgba(255,255,255,0));
          }
          .saturation-black {
            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));
            background: linear-gradient(to top, #000, rgba(0,0,0,0));
          }
        `
        ),
        M.createElement(
          "div",
          { style: u.white, className: "saturation-white" },
          M.createElement("div", { style: u.black, className: "saturation-black" }),
          M.createElement(
            "div",
            { style: u.pointer },
            this.props.pointer ? M.createElement(this.props.pointer, this.props) : M.createElement("div", { style: u.circle })
          )
        )
      );
    }
  }]), t;
}(wg || Cn);
function obe(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var lbe = wB(Object.keys, Object), cbe = Object.prototype, ube = cbe.hasOwnProperty;
function dbe(e) {
  if (!jC(e))
    return lbe(e);
  var t = [];
  for (var r in Object(e))
    ube.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function VC(e) {
  return jh(e) ? CB(e) : dbe(e);
}
function fbe(e, t) {
  return e && yB(e, t, VC);
}
function hbe(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!jh(r))
      return e(r, n);
    for (var a = r.length, s = -1, i = Object(r); ++s < a && n(i[s], s, i) !== !1; )
      ;
    return r;
  };
}
var PB = hbe(fbe);
function pbe(e) {
  return typeof e == "function" ? e : Jw;
}
function mbe(e, t) {
  var r = Ks(e) ? obe : PB;
  return r(e, pbe(t));
}
function wb(e) {
  "@babel/helpers - typeof";
  return wb = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wb(e);
}
var gbe = /^\s+/, vbe = /\s+$/;
function Mt(e, t) {
  if (e = e || "", t = t || {}, e instanceof Mt)
    return e;
  if (!(this instanceof Mt))
    return new Mt(e, t);
  var r = ybe(e);
  this._originalInput = e, this._r = r.r, this._g = r.g, this._b = r.b, this._a = r.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || r.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = r.ok;
}
Mt.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  },
  getLuminance: function() {
    var t = this.toRgb(), r, n, a, s, i, o;
    return r = t.r / 255, n = t.g / 255, a = t.b / 255, r <= 0.03928 ? s = r / 12.92 : s = Math.pow((r + 0.055) / 1.055, 2.4), n <= 0.03928 ? i = n / 12.92 : i = Math.pow((n + 0.055) / 1.055, 2.4), a <= 0.03928 ? o = a / 12.92 : o = Math.pow((a + 0.055) / 1.055, 2.4), 0.2126 * s + 0.7152 * i + 0.0722 * o;
  },
  setAlpha: function(t) {
    return this._a = RB(t), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var t = WR(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      v: t.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var t = WR(this._r, this._g, this._b), r = Math.round(t.h * 360), n = Math.round(t.s * 100), a = Math.round(t.v * 100);
    return this._a == 1 ? "hsv(" + r + ", " + n + "%, " + a + "%)" : "hsva(" + r + ", " + n + "%, " + a + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var t = HR(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      l: t.l,
      a: this._a
    };
  },
  toHslString: function() {
    var t = HR(this._r, this._g, this._b), r = Math.round(t.h * 360), n = Math.round(t.s * 100), a = Math.round(t.l * 100);
    return this._a == 1 ? "hsl(" + r + ", " + n + "%, " + a + "%)" : "hsla(" + r + ", " + n + "%, " + a + "%, " + this._roundA + ")";
  },
  toHex: function(t) {
    return zR(this._r, this._g, this._b, t);
  },
  toHexString: function(t) {
    return "#" + this.toHex(t);
  },
  toHex8: function(t) {
    return _be(this._r, this._g, this._b, this._a, t);
  },
  toHex8String: function(t) {
    return "#" + this.toHex8(t);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(wn(this._r, 255) * 100) + "%",
      g: Math.round(wn(this._g, 255) * 100) + "%",
      b: Math.round(wn(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(wn(this._r, 255) * 100) + "%, " + Math.round(wn(this._g, 255) * 100) + "%, " + Math.round(wn(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(wn(this._r, 255) * 100) + "%, " + Math.round(wn(this._g, 255) * 100) + "%, " + Math.round(wn(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : Nbe[zR(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(t) {
    var r = "#" + KR(this._r, this._g, this._b, this._a), n = r, a = this._gradientType ? "GradientType = 1, " : "";
    if (t) {
      var s = Mt(t);
      n = "#" + KR(s._r, s._g, s._b, s._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + a + "startColorstr=" + r + ",endColorstr=" + n + ")";
  },
  toString: function(t) {
    var r = !!t;
    t = t || this._format;
    var n = !1, a = this._a < 1 && this._a >= 0, s = !r && a && (t === "hex" || t === "hex6" || t === "hex3" || t === "hex4" || t === "hex8" || t === "name");
    return s ? t === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (n = this.toRgbString()), t === "prgb" && (n = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (n = this.toHexString()), t === "hex3" && (n = this.toHexString(!0)), t === "hex4" && (n = this.toHex8String(!0)), t === "hex8" && (n = this.toHex8String()), t === "name" && (n = this.toName()), t === "hsl" && (n = this.toHslString()), t === "hsv" && (n = this.toHsvString()), n || this.toHexString());
  },
  clone: function() {
    return Mt(this.toString());
  },
  _applyModification: function(t, r) {
    var n = t.apply(null, [this].concat([].slice.call(r)));
    return this._r = n._r, this._g = n._g, this._b = n._b, this.setAlpha(n._a), this;
  },
  lighten: function() {
    return this._applyModification(Cbe, arguments);
  },
  brighten: function() {
    return this._applyModification(kbe, arguments);
  },
  darken: function() {
    return this._applyModification(Obe, arguments);
  },
  desaturate: function() {
    return this._applyModification(Sbe, arguments);
  },
  saturate: function() {
    return this._applyModification(Ebe, arguments);
  },
  greyscale: function() {
    return this._applyModification(Tbe, arguments);
  },
  spin: function() {
    return this._applyModification(Abe, arguments);
  },
  _applyCombination: function(t, r) {
    return t.apply(null, [this].concat([].slice.call(r)));
  },
  analogous: function() {
    return this._applyCombination(Ibe, arguments);
  },
  complement: function() {
    return this._applyCombination(Pbe, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(Dbe, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(Rbe, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(qR, [3]);
  },
  tetrad: function() {
    return this._applyCombination(qR, [4]);
  }
};
Mt.fromRatio = function(e, t) {
  if (wb(e) == "object") {
    var r = {};
    for (var n in e)
      e.hasOwnProperty(n) && (n === "a" ? r[n] = e[n] : r[n] = Xp(e[n]));
    e = r;
  }
  return Mt(e, t);
};
function ybe(e) {
  var t = {
    r: 0,
    g: 0,
    b: 0
  }, r = 1, n = null, a = null, s = null, i = !1, o = !1;
  return typeof e == "string" && (e = Fbe(e)), wb(e) == "object" && (el(e.r) && el(e.g) && el(e.b) ? (t = bbe(e.r, e.g, e.b), i = !0, o = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : el(e.h) && el(e.s) && el(e.v) ? (n = Xp(e.s), a = Xp(e.v), t = xbe(e.h, n, a), i = !0, o = "hsv") : el(e.h) && el(e.s) && el(e.l) && (n = Xp(e.s), s = Xp(e.l), t = wbe(e.h, n, s), i = !0, o = "hsl"), e.hasOwnProperty("a") && (r = e.a)), r = RB(r), {
    ok: i,
    format: e.format || o,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: r
  };
}
function bbe(e, t, r) {
  return {
    r: wn(e, 255) * 255,
    g: wn(t, 255) * 255,
    b: wn(r, 255) * 255
  };
}
function HR(e, t, r) {
  e = wn(e, 255), t = wn(t, 255), r = wn(r, 255);
  var n = Math.max(e, t, r), a = Math.min(e, t, r), s, i, o = (n + a) / 2;
  if (n == a)
    s = i = 0;
  else {
    var l = n - a;
    switch (i = o > 0.5 ? l / (2 - n - a) : l / (n + a), n) {
      case e:
        s = (t - r) / l + (t < r ? 6 : 0);
        break;
      case t:
        s = (r - e) / l + 2;
        break;
      case r:
        s = (e - t) / l + 4;
        break;
    }
    s /= 6;
  }
  return {
    h: s,
    s: i,
    l: o
  };
}
function wbe(e, t, r) {
  var n, a, s;
  e = wn(e, 360), t = wn(t, 100), r = wn(r, 100);
  function i(c, u, d) {
    return d < 0 && (d += 1), d > 1 && (d -= 1), d < 1 / 6 ? c + (u - c) * 6 * d : d < 1 / 2 ? u : d < 2 / 3 ? c + (u - c) * (2 / 3 - d) * 6 : c;
  }
  if (t === 0)
    n = a = s = r;
  else {
    var o = r < 0.5 ? r * (1 + t) : r + t - r * t, l = 2 * r - o;
    n = i(l, o, e + 1 / 3), a = i(l, o, e), s = i(l, o, e - 1 / 3);
  }
  return {
    r: n * 255,
    g: a * 255,
    b: s * 255
  };
}
function WR(e, t, r) {
  e = wn(e, 255), t = wn(t, 255), r = wn(r, 255);
  var n = Math.max(e, t, r), a = Math.min(e, t, r), s, i, o = n, l = n - a;
  if (i = n === 0 ? 0 : l / n, n == a)
    s = 0;
  else {
    switch (n) {
      case e:
        s = (t - r) / l + (t < r ? 6 : 0);
        break;
      case t:
        s = (r - e) / l + 2;
        break;
      case r:
        s = (e - t) / l + 4;
        break;
    }
    s /= 6;
  }
  return {
    h: s,
    s: i,
    v: o
  };
}
function xbe(e, t, r) {
  e = wn(e, 360) * 6, t = wn(t, 100), r = wn(r, 100);
  var n = Math.floor(e), a = e - n, s = r * (1 - t), i = r * (1 - a * t), o = r * (1 - (1 - a) * t), l = n % 6, c = [r, i, s, s, o, r][l], u = [o, r, r, i, s, s][l], d = [s, s, o, r, r, i][l];
  return {
    r: c * 255,
    g: u * 255,
    b: d * 255
  };
}
function zR(e, t, r, n) {
  var a = [Di(Math.round(e).toString(16)), Di(Math.round(t).toString(16)), Di(Math.round(r).toString(16))];
  return n && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
}
function _be(e, t, r, n, a) {
  var s = [Di(Math.round(e).toString(16)), Di(Math.round(t).toString(16)), Di(Math.round(r).toString(16)), Di(IB(n))];
  return a && s[0].charAt(0) == s[0].charAt(1) && s[1].charAt(0) == s[1].charAt(1) && s[2].charAt(0) == s[2].charAt(1) && s[3].charAt(0) == s[3].charAt(1) ? s[0].charAt(0) + s[1].charAt(0) + s[2].charAt(0) + s[3].charAt(0) : s.join("");
}
function KR(e, t, r, n) {
  var a = [Di(IB(n)), Di(Math.round(e).toString(16)), Di(Math.round(t).toString(16)), Di(Math.round(r).toString(16))];
  return a.join("");
}
Mt.equals = function(e, t) {
  return !e || !t ? !1 : Mt(e).toRgbString() == Mt(t).toRgbString();
};
Mt.random = function() {
  return Mt.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function Sbe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var r = Mt(e).toHsl();
  return r.s -= t / 100, r.s = tx(r.s), Mt(r);
}
function Ebe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var r = Mt(e).toHsl();
  return r.s += t / 100, r.s = tx(r.s), Mt(r);
}
function Tbe(e) {
  return Mt(e).desaturate(100);
}
function Cbe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var r = Mt(e).toHsl();
  return r.l += t / 100, r.l = tx(r.l), Mt(r);
}
function kbe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var r = Mt(e).toRgb();
  return r.r = Math.max(0, Math.min(255, r.r - Math.round(255 * -(t / 100)))), r.g = Math.max(0, Math.min(255, r.g - Math.round(255 * -(t / 100)))), r.b = Math.max(0, Math.min(255, r.b - Math.round(255 * -(t / 100)))), Mt(r);
}
function Obe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var r = Mt(e).toHsl();
  return r.l -= t / 100, r.l = tx(r.l), Mt(r);
}
function Abe(e, t) {
  var r = Mt(e).toHsl(), n = (r.h + t) % 360;
  return r.h = n < 0 ? 360 + n : n, Mt(r);
}
function Pbe(e) {
  var t = Mt(e).toHsl();
  return t.h = (t.h + 180) % 360, Mt(t);
}
function qR(e, t) {
  if (isNaN(t) || t <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var r = Mt(e).toHsl(), n = [Mt(e)], a = 360 / t, s = 1; s < t; s++)
    n.push(Mt({
      h: (r.h + s * a) % 360,
      s: r.s,
      l: r.l
    }));
  return n;
}
function Rbe(e) {
  var t = Mt(e).toHsl(), r = t.h;
  return [Mt(e), Mt({
    h: (r + 72) % 360,
    s: t.s,
    l: t.l
  }), Mt({
    h: (r + 216) % 360,
    s: t.s,
    l: t.l
  })];
}
function Ibe(e, t, r) {
  t = t || 6, r = r || 30;
  var n = Mt(e).toHsl(), a = 360 / r, s = [Mt(e)];
  for (n.h = (n.h - (a * t >> 1) + 720) % 360; --t; )
    n.h = (n.h + a) % 360, s.push(Mt(n));
  return s;
}
function Dbe(e, t) {
  t = t || 6;
  for (var r = Mt(e).toHsv(), n = r.h, a = r.s, s = r.v, i = [], o = 1 / t; t--; )
    i.push(Mt({
      h: n,
      s: a,
      v: s
    })), s = (s + o) % 1;
  return i;
}
Mt.mix = function(e, t, r) {
  r = r === 0 ? 0 : r || 50;
  var n = Mt(e).toRgb(), a = Mt(t).toRgb(), s = r / 100, i = {
    r: (a.r - n.r) * s + n.r,
    g: (a.g - n.g) * s + n.g,
    b: (a.b - n.b) * s + n.b,
    a: (a.a - n.a) * s + n.a
  };
  return Mt(i);
};
Mt.readability = function(e, t) {
  var r = Mt(e), n = Mt(t);
  return (Math.max(r.getLuminance(), n.getLuminance()) + 0.05) / (Math.min(r.getLuminance(), n.getLuminance()) + 0.05);
};
Mt.isReadable = function(e, t, r) {
  var n = Mt.readability(e, t), a, s;
  switch (s = !1, a = Bbe(r), a.level + a.size) {
    case "AAsmall":
    case "AAAlarge":
      s = n >= 4.5;
      break;
    case "AAlarge":
      s = n >= 3;
      break;
    case "AAAsmall":
      s = n >= 7;
      break;
  }
  return s;
};
Mt.mostReadable = function(e, t, r) {
  var n = null, a = 0, s, i, o, l;
  r = r || {}, i = r.includeFallbackColors, o = r.level, l = r.size;
  for (var c = 0; c < t.length; c++)
    s = Mt.readability(e, t[c]), s > a && (a = s, n = Mt(t[c]));
  return Mt.isReadable(e, n, {
    level: o,
    size: l
  }) || !i ? n : (r.includeFallbackColors = !1, Mt.mostReadable(e, ["#fff", "#000"], r));
};
var IE = Mt.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, Nbe = Mt.hexNames = Mbe(IE);
function Mbe(e) {
  var t = {};
  for (var r in e)
    e.hasOwnProperty(r) && (t[e[r]] = r);
  return t;
}
function RB(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function wn(e, t) {
  Lbe(e) && (e = "100%");
  var r = jbe(e);
  return e = Math.min(t, Math.max(0, parseFloat(e))), r && (e = parseInt(e * t, 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function tx(e) {
  return Math.min(1, Math.max(0, e));
}
function Is(e) {
  return parseInt(e, 16);
}
function Lbe(e) {
  return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function jbe(e) {
  return typeof e == "string" && e.indexOf("%") != -1;
}
function Di(e) {
  return e.length == 1 ? "0" + e : "" + e;
}
function Xp(e) {
  return e <= 1 && (e = e * 100 + "%"), e;
}
function IB(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function GR(e) {
  return Is(e) / 255;
}
var ki = function() {
  var e = "[-\\+]?\\d+%?", t = "[-\\+]?\\d*\\.\\d+%?", r = "(?:" + t + ")|(?:" + e + ")", n = "[\\s|\\(]+(" + r + ")[,|\\s]+(" + r + ")[,|\\s]+(" + r + ")\\s*\\)?", a = "[\\s|\\(]+(" + r + ")[,|\\s]+(" + r + ")[,|\\s]+(" + r + ")[,|\\s]+(" + r + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(r),
    rgb: new RegExp("rgb" + n),
    rgba: new RegExp("rgba" + a),
    hsl: new RegExp("hsl" + n),
    hsla: new RegExp("hsla" + a),
    hsv: new RegExp("hsv" + n),
    hsva: new RegExp("hsva" + a),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function el(e) {
  return !!ki.CSS_UNIT.exec(e);
}
function Fbe(e) {
  e = e.replace(gbe, "").replace(vbe, "").toLowerCase();
  var t = !1;
  if (IE[e])
    e = IE[e], t = !0;
  else if (e == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var r;
  return (r = ki.rgb.exec(e)) ? {
    r: r[1],
    g: r[2],
    b: r[3]
  } : (r = ki.rgba.exec(e)) ? {
    r: r[1],
    g: r[2],
    b: r[3],
    a: r[4]
  } : (r = ki.hsl.exec(e)) ? {
    h: r[1],
    s: r[2],
    l: r[3]
  } : (r = ki.hsla.exec(e)) ? {
    h: r[1],
    s: r[2],
    l: r[3],
    a: r[4]
  } : (r = ki.hsv.exec(e)) ? {
    h: r[1],
    s: r[2],
    v: r[3]
  } : (r = ki.hsva.exec(e)) ? {
    h: r[1],
    s: r[2],
    v: r[3],
    a: r[4]
  } : (r = ki.hex8.exec(e)) ? {
    r: Is(r[1]),
    g: Is(r[2]),
    b: Is(r[3]),
    a: GR(r[4]),
    format: t ? "name" : "hex8"
  } : (r = ki.hex6.exec(e)) ? {
    r: Is(r[1]),
    g: Is(r[2]),
    b: Is(r[3]),
    format: t ? "name" : "hex"
  } : (r = ki.hex4.exec(e)) ? {
    r: Is(r[1] + "" + r[1]),
    g: Is(r[2] + "" + r[2]),
    b: Is(r[3] + "" + r[3]),
    a: GR(r[4] + "" + r[4]),
    format: t ? "name" : "hex8"
  } : (r = ki.hex3.exec(e)) ? {
    r: Is(r[1] + "" + r[1]),
    g: Is(r[2] + "" + r[2]),
    b: Is(r[3] + "" + r[3]),
    format: t ? "name" : "hex"
  } : !1;
}
function Bbe(e) {
  var t, r;
  return e = e || {
    level: "AA",
    size: "small"
  }, t = (e.level || "AA").toUpperCase(), r = (e.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), r !== "small" && r !== "large" && (r = "small"), {
    level: t,
    size: r
  };
}
var YR = function(t) {
  var r = ["r", "g", "b", "a", "h", "s", "l", "v"], n = 0, a = 0;
  return mbe(r, function(s) {
    if (t[s] && (n += 1, isNaN(t[s]) || (a += 1), s === "s" || s === "l")) {
      var i = /^\d+%$/;
      i.test(t[s]) && (a += 1);
    }
  }), n === a ? t : !1;
}, Qp = function(t, r) {
  var n = t.hex ? Mt(t.hex) : Mt(t), a = n.toHsl(), s = n.toHsv(), i = n.toRgb(), o = n.toHex();
  a.s === 0 && (a.h = r || 0, s.h = r || 0);
  var l = o === "000000" && i.a === 0;
  return {
    hsl: a,
    hex: l ? "transparent" : "#" + o,
    rgb: i,
    hsv: s,
    oldHue: t.h || r || a.h,
    source: t.source
  };
}, qc = function(t) {
  if (t === "transparent")
    return !0;
  var r = String(t).charAt(0) === "#" ? 1 : 0;
  return t.length !== 4 + r && t.length < 7 + r && Mt(t).isValid();
}, $C = function(t) {
  if (!t)
    return "#fff";
  var r = Qp(t);
  if (r.hex === "transparent")
    return "rgba(0,0,0,0.4)";
  var n = (r.rgb.r * 299 + r.rgb.g * 587 + r.rgb.b * 114) / 1e3;
  return n >= 128 ? "#000" : "#fff";
}, c_ = function(t, r) {
  var n = t.replace("°", "");
  return Mt(r + " (" + n + ")")._ok;
}, pp = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, Ube = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function Vbe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $be(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function Hbe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Ts = function(t) {
  var r = function(n) {
    Hbe(a, n);
    function a(s) {
      Vbe(this, a);
      var i = $be(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this));
      return i.handleChange = function(o, l) {
        var c = YR(o);
        if (c) {
          var u = Qp(o, o.h || i.state.oldHue);
          i.setState(u), i.props.onChangeComplete && i.debounce(i.props.onChangeComplete, u, l), i.props.onChange && i.props.onChange(u, l);
        }
      }, i.handleSwatchHover = function(o, l) {
        var c = YR(o);
        if (c) {
          var u = Qp(o, o.h || i.state.oldHue);
          i.props.onSwatchHover && i.props.onSwatchHover(u, l);
        }
      }, i.state = pp({}, Qp(s.color, 0)), i.debounce = AB(function(o, l, c) {
        o(l, c);
      }, 100), i;
    }
    return Ube(a, [{
      key: "render",
      value: function() {
        var i = {};
        return this.props.onSwatchHover && (i.onSwatchHover = this.handleSwatchHover), M.createElement(t, pp({}, this.props, this.state, {
          onChange: this.handleChange
        }, i));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(i, o) {
        return pp({}, Qp(i.color, o.oldHue));
      }
    }]), a;
  }(wg || Cn);
  return r.propTypes = pp({}, t.propTypes), r.defaultProps = pp({}, t.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  }), r;
}, Wbe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, zbe = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function Kbe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function XR(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function qbe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Gbe = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(n) {
    qbe(a, n);
    function a() {
      var s, i, o, l;
      Kbe(this, a);
      for (var c = arguments.length, u = Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      return l = (i = (o = XR(this, (s = a.__proto__ || Object.getPrototypeOf(a)).call.apply(s, [this].concat(u))), o), o.state = { focus: !1 }, o.handleFocus = function() {
        return o.setState({ focus: !0 });
      }, o.handleBlur = function() {
        return o.setState({ focus: !1 });
      }, i), XR(o, l);
    }
    return zbe(a, [{
      key: "render",
      value: function() {
        return M.createElement(
          r,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          M.createElement(t, Wbe({}, this.props, this.state))
        );
      }
    }]), a;
  }(M.Component);
}, QR = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, Ybe = 13, Xbe = function(t) {
  var r = t.color, n = t.style, a = t.onClick, s = a === void 0 ? function() {
  } : a, i = t.onHover, o = t.title, l = o === void 0 ? r : o, c = t.children, u = t.focus, d = t.focusStyle, f = d === void 0 ? {} : d, h = r === "transparent", p = Yt({
    default: {
      swatch: QR({
        background: r,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, n, u ? f : {})
    }
  }), m = function(_) {
    return s(r, _);
  }, g = function(_) {
    return _.keyCode === Ybe && s(r, _);
  }, y = function(_) {
    return i(r, _);
  }, x = {};
  return i && (x.onMouseOver = y), M.createElement(
    "div",
    QR({
      style: p.swatch,
      onClick: m,
      title: l,
      tabIndex: 0,
      onKeyDown: g
    }, x),
    c,
    h && M.createElement(Mh, {
      borderRadius: p.swatch.borderRadius,
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    })
  );
};
const od = Gbe(Xbe);
var Qbe = function(t) {
  var r = t.direction, n = Yt({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: r === "vertical" });
  return M.createElement("div", { style: n.picker });
}, Jbe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, DB = function(t) {
  var r = t.rgb, n = t.hsl, a = t.width, s = t.height, i = t.onChange, o = t.direction, l = t.style, c = t.renderers, u = t.pointer, d = t.className, f = d === void 0 ? "" : d, h = Yt({
    default: {
      picker: {
        position: "relative",
        width: a,
        height: s
      },
      alpha: {
        radius: "2px",
        style: l
      }
    }
  });
  return M.createElement(
    "div",
    { style: h.picker, className: "alpha-picker " + f },
    M.createElement(DC, Jbe({}, h.alpha, {
      rgb: r,
      hsl: n,
      pointer: u,
      renderers: c,
      onChange: i,
      direction: o
    }))
  );
};
DB.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: Qbe
};
Ts(DB);
function NB(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var Zbe = "__lodash_hash_undefined__";
function ewe(e) {
  return this.__data__.set(e, Zbe), this;
}
function twe(e) {
  return this.__data__.has(e);
}
function xb(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Wl(); ++t < r; )
    this.add(e[t]);
}
xb.prototype.add = xb.prototype.push = ewe;
xb.prototype.has = twe;
function rwe(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function nwe(e, t) {
  return e.has(t);
}
var awe = 1, swe = 2;
function MB(e, t, r, n, a, s) {
  var i = r & awe, o = e.length, l = t.length;
  if (o != l && !(i && l > o))
    return !1;
  var c = s.get(e), u = s.get(t);
  if (c && u)
    return c == t && u == e;
  var d = -1, f = !0, h = r & swe ? new xb() : void 0;
  for (s.set(e, t), s.set(t, e); ++d < o; ) {
    var p = e[d], m = t[d];
    if (n)
      var g = i ? n(m, p, d, t, e, s) : n(p, m, d, e, t, s);
    if (g !== void 0) {
      if (g)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!rwe(t, function(y, x) {
        if (!nwe(h, x) && (p === y || a(p, y, r, n, s)))
          return h.push(x);
      })) {
        f = !1;
        break;
      }
    } else if (!(p === m || a(p, m, r, n, s))) {
      f = !1;
      break;
    }
  }
  return s.delete(e), s.delete(t), f;
}
function iwe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
function owe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var lwe = 1, cwe = 2, uwe = "[object Boolean]", dwe = "[object Date]", fwe = "[object Error]", hwe = "[object Map]", pwe = "[object Number]", mwe = "[object RegExp]", gwe = "[object Set]", vwe = "[object String]", ywe = "[object Symbol]", bwe = "[object ArrayBuffer]", wwe = "[object DataView]", JR = Nc ? Nc.prototype : void 0, u_ = JR ? JR.valueOf : void 0;
function xwe(e, t, r, n, a, s, i) {
  switch (r) {
    case wwe:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case bwe:
      return !(e.byteLength != t.byteLength || !s(new vb(e), new vb(t)));
    case uwe:
    case dwe:
    case pwe:
      return Lg(+e, +t);
    case fwe:
      return e.name == t.name && e.message == t.message;
    case mwe:
    case vwe:
      return e == t + "";
    case hwe:
      var o = iwe;
    case gwe:
      var l = n & lwe;
      if (o || (o = owe), e.size != t.size && !l)
        return !1;
      var c = i.get(e);
      if (c)
        return c == t;
      n |= cwe, i.set(e, t);
      var u = MB(o(e), o(t), n, a, s, i);
      return i.delete(e), u;
    case ywe:
      if (u_)
        return u_.call(e) == u_.call(t);
  }
  return !1;
}
function _we(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
function Swe(e, t, r) {
  var n = t(e);
  return Ks(e) ? n : _we(n, r(e));
}
function Ewe(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, s = []; ++r < n; ) {
    var i = e[r];
    t(i, r, e) && (s[a++] = i);
  }
  return s;
}
function Twe() {
  return [];
}
var Cwe = Object.prototype, kwe = Cwe.propertyIsEnumerable, ZR = Object.getOwnPropertySymbols, Owe = ZR ? function(e) {
  return e == null ? [] : (e = Object(e), Ewe(ZR(e), function(t) {
    return kwe.call(e, t);
  }));
} : Twe;
function eI(e) {
  return Swe(e, VC, Owe);
}
var Awe = 1, Pwe = Object.prototype, Rwe = Pwe.hasOwnProperty;
function Iwe(e, t, r, n, a, s) {
  var i = r & Awe, o = eI(e), l = o.length, c = eI(t), u = c.length;
  if (l != u && !i)
    return !1;
  for (var d = l; d--; ) {
    var f = o[d];
    if (!(i ? f in t : Rwe.call(t, f)))
      return !1;
  }
  var h = s.get(e), p = s.get(t);
  if (h && p)
    return h == t && p == e;
  var m = !0;
  s.set(e, t), s.set(t, e);
  for (var g = i; ++d < l; ) {
    f = o[d];
    var y = e[f], x = t[f];
    if (n)
      var w = i ? n(x, y, f, t, e, s) : n(y, x, f, e, t, s);
    if (!(w === void 0 ? y === x || a(y, x, r, n, s) : w)) {
      m = !1;
      break;
    }
    g || (g = f == "constructor");
  }
  if (m && !g) {
    var _ = e.constructor, S = t.constructor;
    _ != S && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof S == "function" && S instanceof S) && (m = !1);
  }
  return s.delete(e), s.delete(t), m;
}
var DE = id(Ki, "DataView"), NE = id(Ki, "Promise"), ME = id(Ki, "Set"), LE = id(Ki, "WeakMap"), tI = "[object Map]", Dwe = "[object Object]", rI = "[object Promise]", nI = "[object Set]", aI = "[object WeakMap]", sI = "[object DataView]", Nwe = sd(DE), Mwe = sd(Zm), Lwe = sd(NE), jwe = sd(ME), Fwe = sd(LE), cc = ad;
(DE && cc(new DE(new ArrayBuffer(1))) != sI || Zm && cc(new Zm()) != tI || NE && cc(NE.resolve()) != rI || ME && cc(new ME()) != nI || LE && cc(new LE()) != aI) && (cc = function(e) {
  var t = ad(e), r = t == Dwe ? e.constructor : void 0, n = r ? sd(r) : "";
  if (n)
    switch (n) {
      case Nwe:
        return sI;
      case Mwe:
        return tI;
      case Lwe:
        return rI;
      case jwe:
        return nI;
      case Fwe:
        return aI;
    }
  return t;
});
var Bwe = 1, iI = "[object Arguments]", oI = "[object Array]", e0 = "[object Object]", Uwe = Object.prototype, lI = Uwe.hasOwnProperty;
function Vwe(e, t, r, n, a, s) {
  var i = Ks(e), o = Ks(t), l = i ? oI : cc(e), c = o ? oI : cc(t);
  l = l == iI ? e0 : l, c = c == iI ? e0 : c;
  var u = l == e0, d = c == e0, f = l == c;
  if (f && bb(e)) {
    if (!bb(t))
      return !1;
    i = !0, u = !1;
  }
  if (f && !u)
    return s || (s = new Do()), i || BC(e) ? MB(e, t, r, n, a, s) : xwe(e, t, l, r, n, a, s);
  if (!(r & Bwe)) {
    var h = u && lI.call(e, "__wrapped__"), p = d && lI.call(t, "__wrapped__");
    if (h || p) {
      var m = h ? e.value() : e, g = p ? t.value() : t;
      return s || (s = new Do()), a(m, g, r, n, s);
    }
  }
  return f ? (s || (s = new Do()), Iwe(e, t, r, n, a, s)) : !1;
}
function HC(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !Mc(e) && !Mc(t) ? e !== e && t !== t : Vwe(e, t, r, n, HC, a);
}
var $we = 1, Hwe = 2;
function Wwe(e, t, r, n) {
  var a = r.length, s = a;
  if (e == null)
    return !s;
  for (e = Object(e); a--; ) {
    var i = r[a];
    if (i[2] ? i[1] !== e[i[0]] : !(i[0] in e))
      return !1;
  }
  for (; ++a < s; ) {
    i = r[a];
    var o = i[0], l = e[o], c = i[1];
    if (i[2]) {
      if (l === void 0 && !(o in e))
        return !1;
    } else {
      var u = new Do(), d;
      if (!(d === void 0 ? HC(c, l, $we | Hwe, n, u) : d))
        return !1;
    }
  }
  return !0;
}
function LB(e) {
  return e === e && !pi(e);
}
function zwe(e) {
  for (var t = VC(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, LB(a)];
  }
  return t;
}
function jB(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
function Kwe(e) {
  var t = zwe(e);
  return t.length == 1 && t[0][2] ? jB(t[0][0], t[0][1]) : function(r) {
    return r === e || Wwe(r, e, t);
  };
}
var qwe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Gwe = /^\w*$/;
function WC(e, t) {
  if (Ks(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Zw(e) ? !0 : Gwe.test(e) || !qwe.test(e) || t != null && e in Object(t);
}
var Ywe = "Expected a function";
function zC(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Ywe);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], s = r.cache;
    if (s.has(a))
      return s.get(a);
    var i = e.apply(this, n);
    return r.cache = s.set(a, i) || s, i;
  };
  return r.cache = new (zC.Cache || Wl)(), r;
}
zC.Cache = Wl;
var Xwe = 500;
function Qwe(e) {
  var t = zC(e, function(n) {
    return r.size === Xwe && r.clear(), n;
  }), r = t.cache;
  return t;
}
var Jwe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Zwe = /\\(\\)?/g, exe = Qwe(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Jwe, function(r, n, a, s) {
    t.push(a ? s.replace(Zwe, "$1") : n || r);
  }), t;
}), cI = Nc ? Nc.prototype : void 0, uI = cI ? cI.toString : void 0;
function FB(e) {
  if (typeof e == "string")
    return e;
  if (Ks(e))
    return NB(e, FB) + "";
  if (Zw(e))
    return uI ? uI.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function txe(e) {
  return e == null ? "" : FB(e);
}
function BB(e, t) {
  return Ks(e) ? e : WC(e, t) ? [e] : exe(txe(e));
}
function rx(e) {
  if (typeof e == "string" || Zw(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function UB(e, t) {
  t = BB(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[rx(t[r++])];
  return r && r == n ? e : void 0;
}
function rxe(e, t, r) {
  var n = e == null ? void 0 : UB(e, t);
  return n === void 0 ? r : n;
}
function nxe(e, t) {
  return e != null && t in Object(e);
}
function axe(e, t, r) {
  t = BB(t, e);
  for (var n = -1, a = t.length, s = !1; ++n < a; ) {
    var i = rx(t[n]);
    if (!(s = e != null && r(e, i)))
      break;
    e = e[i];
  }
  return s || ++n != a ? s : (a = e == null ? 0 : e.length, !!a && FC(a) && UC(i, a) && (Ks(e) || yb(e)));
}
function sxe(e, t) {
  return e != null && axe(e, t, nxe);
}
var ixe = 1, oxe = 2;
function lxe(e, t) {
  return WC(e) && LB(t) ? jB(rx(e), t) : function(r) {
    var n = rxe(r, e);
    return n === void 0 && n === t ? sxe(r, e) : HC(t, n, ixe | oxe);
  };
}
function cxe(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function uxe(e) {
  return function(t) {
    return UB(t, e);
  };
}
function dxe(e) {
  return WC(e) ? cxe(rx(e)) : uxe(e);
}
function fxe(e) {
  return typeof e == "function" ? e : e == null ? Jw : typeof e == "object" ? Ks(e) ? lxe(e[0], e[1]) : Kwe(e) : dxe(e);
}
function hxe(e, t) {
  var r = -1, n = jh(e) ? Array(e.length) : [];
  return PB(e, function(a, s, i) {
    n[++r] = t(a, s, i);
  }), n;
}
function ld(e, t) {
  var r = Ks(e) ? NB : hxe;
  return r(e, fxe(t));
}
var pxe = function(t) {
  var r = t.colors, n = t.onClick, a = t.onSwatchHover, s = Yt({
    default: {
      swatches: {
        marginRight: "-10px"
      },
      swatch: {
        width: "22px",
        height: "22px",
        float: "left",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "4px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return M.createElement(
    "div",
    { style: s.swatches },
    ld(r, function(i) {
      return M.createElement(od, {
        key: i,
        color: i,
        style: s.swatch,
        onClick: n,
        onHover: a,
        focusStyle: {
          boxShadow: "0 0 4px " + i
        }
      });
    }),
    M.createElement("div", { style: s.clear })
  );
}, KC = function(t) {
  var r = t.onChange, n = t.onSwatchHover, a = t.hex, s = t.colors, i = t.width, o = t.triangle, l = t.styles, c = l === void 0 ? {} : l, u = t.className, d = u === void 0 ? "" : u, f = a === "transparent", h = function(g, y) {
    qc(g) && r({
      hex: g,
      source: "hex"
    }, y);
  }, p = Yt(Es({
    default: {
      card: {
        width: i,
        background: "#fff",
        boxShadow: "0 1px rgba(0,0,0,.1)",
        borderRadius: "6px",
        position: "relative"
      },
      head: {
        height: "110px",
        background: a,
        borderRadius: "6px 6px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      },
      body: {
        padding: "10px"
      },
      label: {
        fontSize: "18px",
        color: $C(a),
        position: "relative"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent " + a + " transparent",
        position: "absolute",
        top: "-10px",
        left: "50%",
        marginLeft: "-10px"
      },
      input: {
        width: "100%",
        fontSize: "12px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "22px",
        boxShadow: "inset 0 0 0 1px #ddd",
        borderRadius: "4px",
        padding: "0 7px",
        boxSizing: "border-box"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      }
    }
  }, c), { "hide-triangle": o === "hide" });
  return M.createElement(
    "div",
    { style: p.card, className: "block-picker " + d },
    M.createElement("div", { style: p.triangle }),
    M.createElement(
      "div",
      { style: p.head },
      f && M.createElement(Mh, { borderRadius: "6px 6px 0 0" }),
      M.createElement(
        "div",
        { style: p.label },
        a
      )
    ),
    M.createElement(
      "div",
      { style: p.body },
      M.createElement(pxe, { colors: s, onClick: h, onSwatchHover: n }),
      M.createElement(xr, {
        style: { input: p.input },
        value: a,
        onChange: h
      })
    )
  );
};
KC.propTypes = {
  width: xt.oneOfType([xt.string, xt.number]),
  colors: xt.arrayOf(xt.string),
  triangle: xt.oneOf(["top", "hide"]),
  styles: xt.object
};
KC.defaultProps = {
  width: 170,
  colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
  triangle: "top",
  styles: {}
};
Ts(KC);
var uf = { 100: "#ffcdd2", 300: "#e57373", 500: "#f44336", 700: "#d32f2f", 900: "#b71c1c" }, df = { 100: "#f8bbd0", 300: "#f06292", 500: "#e91e63", 700: "#c2185b", 900: "#880e4f" }, ff = { 100: "#e1bee7", 300: "#ba68c8", 500: "#9c27b0", 700: "#7b1fa2", 900: "#4a148c" }, hf = { 100: "#d1c4e9", 300: "#9575cd", 500: "#673ab7", 700: "#512da8", 900: "#311b92" }, pf = { 100: "#c5cae9", 300: "#7986cb", 500: "#3f51b5", 700: "#303f9f", 900: "#1a237e" }, mf = { 100: "#bbdefb", 300: "#64b5f6", 500: "#2196f3", 700: "#1976d2", 900: "#0d47a1" }, gf = { 100: "#b3e5fc", 300: "#4fc3f7", 500: "#03a9f4", 700: "#0288d1", 900: "#01579b" }, vf = { 100: "#b2ebf2", 300: "#4dd0e1", 500: "#00bcd4", 700: "#0097a7", 900: "#006064" }, yf = { 100: "#b2dfdb", 300: "#4db6ac", 500: "#009688", 700: "#00796b", 900: "#004d40" }, Jp = { 100: "#c8e6c9", 300: "#81c784", 500: "#4caf50", 700: "#388e3c" }, bf = { 100: "#dcedc8", 300: "#aed581", 500: "#8bc34a", 700: "#689f38", 900: "#33691e" }, wf = { 100: "#f0f4c3", 300: "#dce775", 500: "#cddc39", 700: "#afb42b", 900: "#827717" }, xf = { 100: "#fff9c4", 300: "#fff176", 500: "#ffeb3b", 700: "#fbc02d", 900: "#f57f17" }, _f = { 100: "#ffecb3", 300: "#ffd54f", 500: "#ffc107", 700: "#ffa000", 900: "#ff6f00" }, Sf = { 100: "#ffe0b2", 300: "#ffb74d", 500: "#ff9800", 700: "#f57c00", 900: "#e65100" }, Ef = { 100: "#ffccbc", 300: "#ff8a65", 500: "#ff5722", 700: "#e64a19", 900: "#bf360c" }, Tf = { 100: "#d7ccc8", 300: "#a1887f", 500: "#795548", 700: "#5d4037", 900: "#3e2723" }, Cf = { 100: "#cfd8dc", 300: "#90a4ae", 500: "#607d8b", 700: "#455a64", 900: "#263238" }, VB = function(t) {
  var r = t.color, n = t.onClick, a = t.onSwatchHover, s = t.hover, i = t.active, o = t.circleSize, l = t.circleSpacing, c = Yt({
    default: {
      swatch: {
        width: o,
        height: o,
        marginRight: l,
        marginBottom: l,
        transform: "scale(1)",
        transition: "100ms transform ease"
      },
      Swatch: {
        borderRadius: "50%",
        background: "transparent",
        boxShadow: "inset 0 0 0 " + (o / 2 + 1) + "px " + r,
        transition: "100ms box-shadow ease"
      }
    },
    hover: {
      swatch: {
        transform: "scale(1.2)"
      }
    },
    active: {
      Swatch: {
        boxShadow: "inset 0 0 0 3px " + r
      }
    }
  }, { hover: s, active: i });
  return M.createElement(
    "div",
    { style: c.swatch },
    M.createElement(od, {
      style: c.Swatch,
      color: r,
      onClick: n,
      onHover: a,
      focusStyle: { boxShadow: c.Swatch.boxShadow + ", 0 0 5px " + r }
    })
  );
};
VB.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
const mxe = IC(VB);
var qC = function(t) {
  var r = t.width, n = t.onChange, a = t.onSwatchHover, s = t.colors, i = t.hex, o = t.circleSize, l = t.styles, c = l === void 0 ? {} : l, u = t.circleSpacing, d = t.className, f = d === void 0 ? "" : d, h = Yt(Es({
    default: {
      card: {
        width: r,
        display: "flex",
        flexWrap: "wrap",
        marginRight: -u,
        marginBottom: -u
      }
    }
  }, c)), p = function(g, y) {
    return n({ hex: g, source: "hex" }, y);
  };
  return M.createElement(
    "div",
    { style: h.card, className: "circle-picker " + f },
    ld(s, function(m) {
      return M.createElement(mxe, {
        key: m,
        color: m,
        onClick: p,
        onSwatchHover: a,
        active: i === m.toLowerCase(),
        circleSize: o,
        circleSpacing: u
      });
    })
  );
};
qC.propTypes = {
  width: xt.oneOfType([xt.string, xt.number]),
  circleSize: xt.number,
  circleSpacing: xt.number,
  styles: xt.object
};
qC.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [uf[500], df[500], ff[500], hf[500], pf[500], mf[500], gf[500], vf[500], yf[500], Jp[500], bf[500], wf[500], xf[500], _f[500], Sf[500], Ef[500], Tf[500], Cf[500]],
  styles: {}
};
Ts(qC);
function dI(e) {
  return e === void 0;
}
var $B = {};
Object.defineProperty($B, "__esModule", {
  value: !0
});
var fI = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, gxe = M, hI = vxe(gxe);
function vxe(e) {
  return e && e.__esModule ? e : { default: e };
}
function yxe(e, t) {
  var r = {};
  for (var n in e)
    t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  return r;
}
var t0 = 24, bxe = $B.default = function(e) {
  var t = e.fill, r = t === void 0 ? "currentColor" : t, n = e.width, a = n === void 0 ? t0 : n, s = e.height, i = s === void 0 ? t0 : s, o = e.style, l = o === void 0 ? {} : o, c = yxe(e, ["fill", "width", "height", "style"]);
  return hI.default.createElement(
    "svg",
    fI({
      viewBox: "0 0 " + t0 + " " + t0,
      style: fI({ fill: r, width: a, height: i }, l)
    }, c),
    hI.default.createElement("path", { d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" })
  );
}, wxe = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function xxe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _xe(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function Sxe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var HB = function(e) {
  Sxe(t, e);
  function t(r) {
    xxe(this, t);
    var n = _xe(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
    return n.toggleViews = function() {
      n.state.view === "hex" ? n.setState({ view: "rgb" }) : n.state.view === "rgb" ? n.setState({ view: "hsl" }) : n.state.view === "hsl" && (n.props.hsl.a === 1 ? n.setState({ view: "hex" }) : n.setState({ view: "rgb" }));
    }, n.handleChange = function(a, s) {
      a.hex ? qc(a.hex) && n.props.onChange({
        hex: a.hex,
        source: "hex"
      }, s) : a.r || a.g || a.b ? n.props.onChange({
        r: a.r || n.props.rgb.r,
        g: a.g || n.props.rgb.g,
        b: a.b || n.props.rgb.b,
        source: "rgb"
      }, s) : a.a ? (a.a < 0 ? a.a = 0 : a.a > 1 && (a.a = 1), n.props.onChange({
        h: n.props.hsl.h,
        s: n.props.hsl.s,
        l: n.props.hsl.l,
        a: Math.round(a.a * 100) / 100,
        source: "rgb"
      }, s)) : (a.h || a.s || a.l) && (typeof a.s == "string" && a.s.includes("%") && (a.s = a.s.replace("%", "")), typeof a.l == "string" && a.l.includes("%") && (a.l = a.l.replace("%", "")), a.s == 1 ? a.s = 0.01 : a.l == 1 && (a.l = 0.01), n.props.onChange({
        h: a.h || n.props.hsl.h,
        s: Number(dI(a.s) ? n.props.hsl.s : a.s),
        l: Number(dI(a.l) ? n.props.hsl.l : a.l),
        source: "hsl"
      }, s));
    }, n.showHighlight = function(a) {
      a.currentTarget.style.background = "#eee";
    }, n.hideHighlight = function(a) {
      a.currentTarget.style.background = "transparent";
    }, r.hsl.a !== 1 && r.view === "hex" ? n.state = {
      view: "rgb"
    } : n.state = {
      view: r.view
    }, n;
  }
  return wxe(t, [{
    key: "render",
    value: function() {
      var n = this, a = Yt({
        default: {
          wrap: {
            paddingTop: "16px",
            display: "flex"
          },
          fields: {
            flex: "1",
            display: "flex",
            marginLeft: "-6px"
          },
          field: {
            paddingLeft: "6px",
            width: "100%"
          },
          alpha: {
            paddingLeft: "6px",
            width: "100%"
          },
          toggle: {
            width: "32px",
            textAlign: "right",
            position: "relative"
          },
          icon: {
            marginRight: "-4px",
            marginTop: "12px",
            cursor: "pointer",
            position: "relative"
          },
          iconHighlight: {
            position: "absolute",
            width: "24px",
            height: "28px",
            background: "#eee",
            borderRadius: "4px",
            top: "10px",
            left: "12px",
            display: "none"
          },
          input: {
            fontSize: "11px",
            color: "#333",
            width: "100%",
            borderRadius: "2px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #dadada",
            height: "21px",
            textAlign: "center"
          },
          label: {
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: "11px",
            color: "#969696",
            textAlign: "center",
            display: "block",
            marginTop: "12px"
          },
          svg: {
            fill: "#333",
            width: "24px",
            height: "24px",
            border: "1px transparent solid",
            borderRadius: "5px"
          }
        },
        disableAlpha: {
          alpha: {
            display: "none"
          }
        }
      }, this.props, this.state), s = void 0;
      return this.state.view === "hex" ? s = M.createElement(
        "div",
        { style: a.fields, className: "flexbox-fix" },
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(xr, {
            style: { input: a.input, label: a.label },
            label: "hex",
            value: this.props.hex,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "rgb" ? s = M.createElement(
        "div",
        { style: a.fields, className: "flexbox-fix" },
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(xr, {
            style: { input: a.input, label: a.label },
            label: "r",
            value: this.props.rgb.r,
            onChange: this.handleChange
          })
        ),
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(xr, {
            style: { input: a.input, label: a.label },
            label: "g",
            value: this.props.rgb.g,
            onChange: this.handleChange
          })
        ),
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(xr, {
            style: { input: a.input, label: a.label },
            label: "b",
            value: this.props.rgb.b,
            onChange: this.handleChange
          })
        ),
        M.createElement(
          "div",
          { style: a.alpha },
          M.createElement(xr, {
            style: { input: a.input, label: a.label },
            label: "a",
            value: this.props.rgb.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "hsl" && (s = M.createElement(
        "div",
        { style: a.fields, className: "flexbox-fix" },
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(xr, {
            style: { input: a.input, label: a.label },
            label: "h",
            value: Math.round(this.props.hsl.h),
            onChange: this.handleChange
          })
        ),
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(xr, {
            style: { input: a.input, label: a.label },
            label: "s",
            value: Math.round(this.props.hsl.s * 100) + "%",
            onChange: this.handleChange
          })
        ),
        M.createElement(
          "div",
          { style: a.field },
          M.createElement(xr, {
            style: { input: a.input, label: a.label },
            label: "l",
            value: Math.round(this.props.hsl.l * 100) + "%",
            onChange: this.handleChange
          })
        ),
        M.createElement(
          "div",
          { style: a.alpha },
          M.createElement(xr, {
            style: { input: a.input, label: a.label },
            label: "a",
            value: this.props.hsl.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      )), M.createElement(
        "div",
        { style: a.wrap, className: "flexbox-fix" },
        s,
        M.createElement(
          "div",
          { style: a.toggle },
          M.createElement(
            "div",
            { style: a.icon, onClick: this.toggleViews, ref: function(o) {
              return n.icon = o;
            } },
            M.createElement(bxe, {
              style: a.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.hsl.a !== 1 && a.view === "hex" ? { view: "rgb" } : null;
    }
  }]), t;
}(M.Component);
HB.defaultProps = {
  view: "hex"
};
var pI = function() {
  var t = Yt({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        transform: "translate(-6px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return M.createElement("div", { style: t.picker });
}, Exe = function() {
  var t = Yt({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return M.createElement("div", { style: t.picker });
}, GC = function(t) {
  var r = t.width, n = t.onChange, a = t.disableAlpha, s = t.rgb, i = t.hsl, o = t.hsv, l = t.hex, c = t.renderers, u = t.styles, d = u === void 0 ? {} : u, f = t.className, h = f === void 0 ? "" : f, p = t.defaultView, m = Yt(Es({
    default: {
      picker: {
        width: r,
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
        boxSizing: "initial",
        fontFamily: "Menlo"
      },
      saturation: {
        width: "100%",
        paddingBottom: "55%",
        position: "relative",
        borderRadius: "2px 2px 0 0",
        overflow: "hidden"
      },
      Saturation: {
        radius: "2px 2px 0 0"
      },
      body: {
        padding: "16px 16px 12px"
      },
      controls: {
        display: "flex"
      },
      color: {
        width: "32px"
      },
      swatch: {
        marginTop: "6px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden"
      },
      active: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "8px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
        background: "rgba(" + s.r + ", " + s.g + ", " + s.b + ", " + s.a + ")",
        zIndex: "2"
      },
      toggles: {
        flex: "1"
      },
      hue: {
        height: "10px",
        position: "relative",
        marginBottom: "8px"
      },
      Hue: {
        radius: "2px"
      },
      alpha: {
        height: "10px",
        position: "relative"
      },
      Alpha: {
        radius: "2px"
      }
    },
    disableAlpha: {
      color: {
        width: "22px"
      },
      alpha: {
        display: "none"
      },
      hue: {
        marginBottom: "0px"
      },
      swatch: {
        width: "10px",
        height: "10px",
        marginTop: "0px"
      }
    }
  }, d), { disableAlpha: a });
  return M.createElement(
    "div",
    { style: m.picker, className: "chrome-picker " + h },
    M.createElement(
      "div",
      { style: m.saturation },
      M.createElement(ex, {
        style: m.Saturation,
        hsl: i,
        hsv: o,
        pointer: Exe,
        onChange: n
      })
    ),
    M.createElement(
      "div",
      { style: m.body },
      M.createElement(
        "div",
        { style: m.controls, className: "flexbox-fix" },
        M.createElement(
          "div",
          { style: m.color },
          M.createElement(
            "div",
            { style: m.swatch },
            M.createElement("div", { style: m.active }),
            M.createElement(Mh, { renderers: c })
          )
        ),
        M.createElement(
          "div",
          { style: m.toggles },
          M.createElement(
            "div",
            { style: m.hue },
            M.createElement(Lh, {
              style: m.Hue,
              hsl: i,
              pointer: pI,
              onChange: n
            })
          ),
          M.createElement(
            "div",
            { style: m.alpha },
            M.createElement(DC, {
              style: m.Alpha,
              rgb: s,
              hsl: i,
              pointer: pI,
              renderers: c,
              onChange: n
            })
          )
        )
      ),
      M.createElement(HB, {
        rgb: s,
        hsl: i,
        hex: l,
        view: p,
        onChange: n,
        disableAlpha: a
      })
    )
  );
};
GC.propTypes = {
  width: xt.oneOfType([xt.string, xt.number]),
  disableAlpha: xt.bool,
  styles: xt.object,
  defaultView: xt.oneOf(["hex", "rgb", "hsl"])
};
GC.defaultProps = {
  width: 225,
  disableAlpha: !1,
  styles: {}
};
const Txe = Ts(GC);
var Cxe = function(t) {
  var r = t.color, n = t.onClick, a = n === void 0 ? function() {
  } : n, s = t.onSwatchHover, i = t.active, o = Yt({
    default: {
      color: {
        background: r,
        width: "15px",
        height: "15px",
        float: "left",
        marginRight: "5px",
        marginBottom: "5px",
        position: "relative",
        cursor: "pointer"
      },
      dot: {
        absolute: "5px 5px 5px 5px",
        background: $C(r),
        borderRadius: "50%",
        opacity: "0"
      }
    },
    active: {
      dot: {
        opacity: "1"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      dot: {
        background: "#000"
      }
    },
    transparent: {
      dot: {
        background: "#000"
      }
    }
  }, { active: i, "color-#FFFFFF": r === "#FFFFFF", transparent: r === "transparent" });
  return M.createElement(
    od,
    {
      style: o.color,
      color: r,
      onClick: a,
      onHover: s,
      focusStyle: { boxShadow: "0 0 4px " + r }
    },
    M.createElement("div", { style: o.dot })
  );
}, kxe = function(t) {
  var r = t.hex, n = t.rgb, a = t.onChange, s = Yt({
    default: {
      fields: {
        display: "flex",
        paddingBottom: "6px",
        paddingRight: "5px",
        position: "relative"
      },
      active: {
        position: "absolute",
        top: "6px",
        left: "5px",
        height: "9px",
        width: "9px",
        background: r
      },
      HEXwrap: {
        flex: "6",
        position: "relative"
      },
      HEXinput: {
        width: "80%",
        padding: "0px",
        paddingLeft: "20%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      HEXlabel: {
        display: "none"
      },
      RGBwrap: {
        flex: "3",
        position: "relative"
      },
      RGBinput: {
        width: "70%",
        padding: "0px",
        paddingLeft: "30%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      RGBlabel: {
        position: "absolute",
        top: "3px",
        left: "0px",
        lineHeight: "16px",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#999"
      }
    }
  }), i = function(l, c) {
    l.r || l.g || l.b ? a({
      r: l.r || n.r,
      g: l.g || n.g,
      b: l.b || n.b,
      source: "rgb"
    }, c) : a({
      hex: l.hex,
      source: "hex"
    }, c);
  };
  return M.createElement(
    "div",
    { style: s.fields, className: "flexbox-fix" },
    M.createElement("div", { style: s.active }),
    M.createElement(xr, {
      style: { wrap: s.HEXwrap, input: s.HEXinput, label: s.HEXlabel },
      label: "hex",
      value: r,
      onChange: i
    }),
    M.createElement(xr, {
      style: { wrap: s.RGBwrap, input: s.RGBinput, label: s.RGBlabel },
      label: "r",
      value: n.r,
      onChange: i
    }),
    M.createElement(xr, {
      style: { wrap: s.RGBwrap, input: s.RGBinput, label: s.RGBlabel },
      label: "g",
      value: n.g,
      onChange: i
    }),
    M.createElement(xr, {
      style: { wrap: s.RGBwrap, input: s.RGBinput, label: s.RGBlabel },
      label: "b",
      value: n.b,
      onChange: i
    })
  );
}, YC = function(t) {
  var r = t.onChange, n = t.onSwatchHover, a = t.colors, s = t.hex, i = t.rgb, o = t.styles, l = o === void 0 ? {} : o, c = t.className, u = c === void 0 ? "" : c, d = Yt(Es({
    default: {
      Compact: {
        background: "#f6f6f6",
        radius: "4px"
      },
      compact: {
        paddingTop: "5px",
        paddingLeft: "5px",
        boxSizing: "initial",
        width: "240px"
      },
      clear: {
        clear: "both"
      }
    }
  }, l)), f = function(p, m) {
    p.hex ? qc(p.hex) && r({
      hex: p.hex,
      source: "hex"
    }, m) : r(p, m);
  };
  return M.createElement(
    jg,
    { style: d.Compact, styles: l },
    M.createElement(
      "div",
      { style: d.compact, className: "compact-picker " + u },
      M.createElement(
        "div",
        null,
        ld(a, function(h) {
          return M.createElement(Cxe, {
            key: h,
            color: h,
            active: h.toLowerCase() === s,
            onClick: f,
            onSwatchHover: n
          });
        }),
        M.createElement("div", { style: d.clear })
      ),
      M.createElement(kxe, { hex: s, rgb: i, onChange: f })
    )
  );
};
YC.propTypes = {
  colors: xt.arrayOf(xt.string),
  styles: xt.object
};
YC.defaultProps = {
  colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"],
  styles: {}
};
Ts(YC);
var Oxe = function(t) {
  var r = t.hover, n = t.color, a = t.onClick, s = t.onSwatchHover, i = {
    position: "relative",
    zIndex: "2",
    outline: "2px solid #fff",
    boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
  }, o = Yt({
    default: {
      swatch: {
        width: "25px",
        height: "25px",
        fontSize: "0"
      }
    },
    hover: {
      swatch: i
    }
  }, { hover: r });
  return M.createElement(
    "div",
    { style: o.swatch },
    M.createElement(od, {
      color: n,
      onClick: a,
      onHover: s,
      focusStyle: i
    })
  );
};
const Axe = IC(Oxe);
var XC = function(t) {
  var r = t.width, n = t.colors, a = t.onChange, s = t.onSwatchHover, i = t.triangle, o = t.styles, l = o === void 0 ? {} : o, c = t.className, u = c === void 0 ? "" : c, d = Yt(Es({
    default: {
      card: {
        width: r,
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.2)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        position: "relative",
        padding: "5px",
        display: "flex",
        flexWrap: "wrap"
      },
      triangle: {
        position: "absolute",
        border: "7px solid transparent",
        borderBottomColor: "#fff"
      },
      triangleShadow: {
        position: "absolute",
        border: "8px solid transparent",
        borderBottomColor: "rgba(0,0,0,0.15)"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-14px",
        left: "10px"
      },
      triangleShadow: {
        top: "-16px",
        left: "9px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-14px",
        right: "10px"
      },
      triangleShadow: {
        top: "-16px",
        right: "9px"
      }
    },
    "bottom-left-triangle": {
      triangle: {
        top: "35px",
        left: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        left: "9px",
        transform: "rotate(180deg)"
      }
    },
    "bottom-right-triangle": {
      triangle: {
        top: "35px",
        right: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        right: "9px",
        transform: "rotate(180deg)"
      }
    }
  }, l), {
    "hide-triangle": i === "hide",
    "top-left-triangle": i === "top-left",
    "top-right-triangle": i === "top-right",
    "bottom-left-triangle": i === "bottom-left",
    "bottom-right-triangle": i === "bottom-right"
  }), f = function(p, m) {
    return a({ hex: p, source: "hex" }, m);
  };
  return M.createElement(
    "div",
    { style: d.card, className: "github-picker " + u },
    M.createElement("div", { style: d.triangleShadow }),
    M.createElement("div", { style: d.triangle }),
    ld(n, function(h) {
      return M.createElement(Axe, {
        color: h,
        key: h,
        onClick: f,
        onSwatchHover: s
      });
    })
  );
};
XC.propTypes = {
  width: xt.oneOfType([xt.string, xt.number]),
  colors: xt.arrayOf(xt.string),
  triangle: xt.oneOf(["hide", "top-left", "top-right", "bottom-left", "bottom-right"]),
  styles: xt.object
};
XC.defaultProps = {
  width: 200,
  colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
  triangle: "top-left",
  styles: {}
};
Ts(XC);
var Pxe = function(t) {
  var r = t.direction, n = Yt({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: r === "vertical" });
  return M.createElement("div", { style: n.picker });
}, Rxe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, QC = function(t) {
  var r = t.width, n = t.height, a = t.onChange, s = t.hsl, i = t.direction, o = t.pointer, l = t.styles, c = l === void 0 ? {} : l, u = t.className, d = u === void 0 ? "" : u, f = Yt(Es({
    default: {
      picker: {
        position: "relative",
        width: r,
        height: n
      },
      hue: {
        radius: "2px"
      }
    }
  }, c)), h = function(m) {
    return a({ a: 1, h: m.h, l: 0.5, s: 1 });
  };
  return M.createElement(
    "div",
    { style: f.picker, className: "hue-picker " + d },
    M.createElement(Lh, Rxe({}, f.hue, {
      hsl: s,
      pointer: o,
      onChange: h,
      direction: i
    }))
  );
};
QC.propTypes = {
  styles: xt.object
};
QC.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: Pxe,
  styles: {}
};
Ts(QC);
var Ixe = function(t) {
  var r = t.onChange, n = t.hex, a = t.rgb, s = t.styles, i = s === void 0 ? {} : s, o = t.className, l = o === void 0 ? "" : o, c = Yt(Es({
    default: {
      material: {
        width: "98px",
        height: "98px",
        padding: "16px",
        fontFamily: "Roboto"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "2px solid " + n,
        outline: "none",
        height: "30px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "1px solid #eee",
        outline: "none",
        height: "30px"
      },
      RGBlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      split: {
        display: "flex",
        marginRight: "-10px",
        paddingTop: "11px"
      },
      third: {
        flex: "1",
        paddingRight: "10px"
      }
    }
  }, i)), u = function(f, h) {
    f.hex ? qc(f.hex) && r({
      hex: f.hex,
      source: "hex"
    }, h) : (f.r || f.g || f.b) && r({
      r: f.r || a.r,
      g: f.g || a.g,
      b: f.b || a.b,
      source: "rgb"
    }, h);
  };
  return M.createElement(
    jg,
    { styles: i },
    M.createElement(
      "div",
      { style: c.material, className: "material-picker " + l },
      M.createElement(xr, {
        style: { wrap: c.HEXwrap, input: c.HEXinput, label: c.HEXlabel },
        label: "hex",
        value: n,
        onChange: u
      }),
      M.createElement(
        "div",
        { style: c.split, className: "flexbox-fix" },
        M.createElement(
          "div",
          { style: c.third },
          M.createElement(xr, {
            style: { wrap: c.RGBwrap, input: c.RGBinput, label: c.RGBlabel },
            label: "r",
            value: a.r,
            onChange: u
          })
        ),
        M.createElement(
          "div",
          { style: c.third },
          M.createElement(xr, {
            style: { wrap: c.RGBwrap, input: c.RGBinput, label: c.RGBlabel },
            label: "g",
            value: a.g,
            onChange: u
          })
        ),
        M.createElement(
          "div",
          { style: c.third },
          M.createElement(xr, {
            style: { wrap: c.RGBwrap, input: c.RGBinput, label: c.RGBlabel },
            label: "b",
            value: a.b,
            onChange: u
          })
        )
      )
    )
  );
};
Ts(Ixe);
var Dxe = function(t) {
  var r = t.onChange, n = t.rgb, a = t.hsv, s = t.hex, i = Yt({
    default: {
      fields: {
        paddingTop: "5px",
        paddingBottom: "9px",
        width: "80px",
        position: "relative"
      },
      divider: {
        height: "5px"
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        marginLeft: "40%",
        width: "40%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "5px",
        fontSize: "13px",
        paddingLeft: "3px",
        marginRight: "10px"
      },
      RGBlabel: {
        left: "0px",
        top: "0px",
        width: "34px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px",
        position: "absolute"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        marginLeft: "20%",
        width: "80%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "6px",
        fontSize: "13px",
        paddingLeft: "3px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "14px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px"
      },
      fieldSymbols: {
        position: "absolute",
        top: "5px",
        right: "-7px",
        fontSize: "13px"
      },
      symbol: {
        height: "20px",
        lineHeight: "22px",
        paddingBottom: "7px"
      }
    }
  }), o = function(c, u) {
    c["#"] ? qc(c["#"]) && r({
      hex: c["#"],
      source: "hex"
    }, u) : c.r || c.g || c.b ? r({
      r: c.r || n.r,
      g: c.g || n.g,
      b: c.b || n.b,
      source: "rgb"
    }, u) : (c.h || c.s || c.v) && r({
      h: c.h || a.h,
      s: c.s || a.s,
      v: c.v || a.v,
      source: "hsv"
    }, u);
  };
  return M.createElement(
    "div",
    { style: i.fields },
    M.createElement(xr, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "h",
      value: Math.round(a.h),
      onChange: o
    }),
    M.createElement(xr, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "s",
      value: Math.round(a.s * 100),
      onChange: o
    }),
    M.createElement(xr, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "v",
      value: Math.round(a.v * 100),
      onChange: o
    }),
    M.createElement("div", { style: i.divider }),
    M.createElement(xr, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "r",
      value: n.r,
      onChange: o
    }),
    M.createElement(xr, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "g",
      value: n.g,
      onChange: o
    }),
    M.createElement(xr, {
      style: { wrap: i.RGBwrap, input: i.RGBinput, label: i.RGBlabel },
      label: "b",
      value: n.b,
      onChange: o
    }),
    M.createElement("div", { style: i.divider }),
    M.createElement(xr, {
      style: { wrap: i.HEXwrap, input: i.HEXinput, label: i.HEXlabel },
      label: "#",
      value: s.replace("#", ""),
      onChange: o
    }),
    M.createElement(
      "div",
      { style: i.fieldSymbols },
      M.createElement(
        "div",
        { style: i.symbol },
        "°"
      ),
      M.createElement(
        "div",
        { style: i.symbol },
        "%"
      ),
      M.createElement(
        "div",
        { style: i.symbol },
        "%"
      )
    )
  );
}, Nxe = function(t) {
  var r = t.hsl, n = Yt({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    },
    "black-outline": {
      picker: {
        boxShadow: "inset 0 0 0 1px #000"
      }
    }
  }, { "black-outline": r.l > 0.5 });
  return M.createElement("div", { style: n.picker });
}, Mxe = function() {
  var t = Yt({
    default: {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "4px 0 4px 6px",
        borderColor: "transparent transparent transparent #fff",
        position: "absolute",
        top: "1px",
        left: "1px"
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "5px 0 5px 8px",
        borderColor: "transparent transparent transparent #555"
      },
      left: {
        Extend: "triangleBorder",
        transform: "translate(-13px, -4px)"
      },
      leftInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      },
      right: {
        Extend: "triangleBorder",
        transform: "translate(20px, -14px) rotate(180deg)"
      },
      rightInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      }
    }
  });
  return M.createElement(
    "div",
    { style: t.pointer },
    M.createElement(
      "div",
      { style: t.left },
      M.createElement("div", { style: t.leftInside })
    ),
    M.createElement(
      "div",
      { style: t.right },
      M.createElement("div", { style: t.rightInside })
    )
  );
}, mI = function(t) {
  var r = t.onClick, n = t.label, a = t.children, s = t.active, i = Yt({
    default: {
      button: {
        backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
        border: "1px solid #878787",
        borderRadius: "2px",
        height: "20px",
        boxShadow: "0 1px 0 0 #EAEAEA",
        fontSize: "14px",
        color: "#000",
        lineHeight: "20px",
        textAlign: "center",
        marginBottom: "10px",
        cursor: "pointer"
      }
    },
    active: {
      button: {
        boxShadow: "0 0 0 1px #878787"
      }
    }
  }, { active: s });
  return M.createElement(
    "div",
    { style: i.button, onClick: r },
    n || a
  );
}, Lxe = function(t) {
  var r = t.rgb, n = t.currentColor, a = Yt({
    default: {
      swatches: {
        border: "1px solid #B3B3B3",
        borderBottom: "1px solid #F0F0F0",
        marginBottom: "2px",
        marginTop: "1px"
      },
      new: {
        height: "34px",
        background: "rgb(" + r.r + "," + r.g + ", " + r.b + ")",
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
      },
      current: {
        height: "34px",
        background: n,
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
      },
      label: {
        fontSize: "14px",
        color: "#000",
        textAlign: "center"
      }
    }
  });
  return M.createElement(
    "div",
    null,
    M.createElement(
      "div",
      { style: a.label },
      "new"
    ),
    M.createElement(
      "div",
      { style: a.swatches },
      M.createElement("div", { style: a.new }),
      M.createElement("div", { style: a.current })
    ),
    M.createElement(
      "div",
      { style: a.label },
      "current"
    )
  );
}, jxe = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function Fxe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Bxe(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function Uxe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var JC = function(e) {
  Uxe(t, e);
  function t(r) {
    Fxe(this, t);
    var n = Bxe(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
    return n.state = {
      currentColor: r.hex
    }, n;
  }
  return jxe(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.styles, s = a === void 0 ? {} : a, i = n.className, o = i === void 0 ? "" : i, l = Yt(Es({
        default: {
          picker: {
            background: "#DCDCDC",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
            boxSizing: "initial",
            width: "513px"
          },
          head: {
            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
            borderBottom: "1px solid #B1B1B1",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
            height: "23px",
            lineHeight: "24px",
            borderRadius: "4px 4px 0 0",
            fontSize: "13px",
            color: "#4D4D4D",
            textAlign: "center"
          },
          body: {
            padding: "15px 15px 0",
            display: "flex"
          },
          saturation: {
            width: "256px",
            height: "256px",
            position: "relative",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0",
            overflow: "hidden"
          },
          hue: {
            position: "relative",
            height: "256px",
            width: "19px",
            marginLeft: "10px",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0"
          },
          controls: {
            width: "180px",
            marginLeft: "10px"
          },
          top: {
            display: "flex"
          },
          previews: {
            width: "60px"
          },
          actions: {
            flex: "1",
            marginLeft: "20px"
          }
        }
      }, s));
      return M.createElement(
        "div",
        { style: l.picker, className: "photoshop-picker " + o },
        M.createElement(
          "div",
          { style: l.head },
          this.props.header
        ),
        M.createElement(
          "div",
          { style: l.body, className: "flexbox-fix" },
          M.createElement(
            "div",
            { style: l.saturation },
            M.createElement(ex, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: Nxe,
              onChange: this.props.onChange
            })
          ),
          M.createElement(
            "div",
            { style: l.hue },
            M.createElement(Lh, {
              direction: "vertical",
              hsl: this.props.hsl,
              pointer: Mxe,
              onChange: this.props.onChange
            })
          ),
          M.createElement(
            "div",
            { style: l.controls },
            M.createElement(
              "div",
              { style: l.top, className: "flexbox-fix" },
              M.createElement(
                "div",
                { style: l.previews },
                M.createElement(Lxe, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              M.createElement(
                "div",
                { style: l.actions },
                M.createElement(mI, { label: "OK", onClick: this.props.onAccept, active: !0 }),
                M.createElement(mI, { label: "Cancel", onClick: this.props.onCancel }),
                M.createElement(Dxe, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]), t;
}(M.Component);
JC.propTypes = {
  header: xt.string,
  styles: xt.object
};
JC.defaultProps = {
  header: "Color Picker",
  styles: {}
};
Ts(JC);
var Vxe = function(t) {
  var r = t.onChange, n = t.rgb, a = t.hsl, s = t.hex, i = t.disableAlpha, o = Yt({
    default: {
      fields: {
        display: "flex",
        paddingTop: "4px"
      },
      single: {
        flex: "1",
        paddingLeft: "6px"
      },
      alpha: {
        flex: "1",
        paddingLeft: "6px"
      },
      double: {
        flex: "2"
      },
      input: {
        width: "80%",
        padding: "4px 10% 3px",
        border: "none",
        boxShadow: "inset 0 0 0 1px #ccc",
        fontSize: "11px"
      },
      label: {
        display: "block",
        textAlign: "center",
        fontSize: "11px",
        color: "#222",
        paddingTop: "3px",
        paddingBottom: "4px",
        textTransform: "capitalize"
      }
    },
    disableAlpha: {
      alpha: {
        display: "none"
      }
    }
  }, { disableAlpha: i }), l = function(u, d) {
    u.hex ? qc(u.hex) && r({
      hex: u.hex,
      source: "hex"
    }, d) : u.r || u.g || u.b ? r({
      r: u.r || n.r,
      g: u.g || n.g,
      b: u.b || n.b,
      a: n.a,
      source: "rgb"
    }, d) : u.a && (u.a < 0 ? u.a = 0 : u.a > 100 && (u.a = 100), u.a /= 100, r({
      h: a.h,
      s: a.s,
      l: a.l,
      a: u.a,
      source: "rgb"
    }, d));
  };
  return M.createElement(
    "div",
    { style: o.fields, className: "flexbox-fix" },
    M.createElement(
      "div",
      { style: o.double },
      M.createElement(xr, {
        style: { input: o.input, label: o.label },
        label: "hex",
        value: s.replace("#", ""),
        onChange: l
      })
    ),
    M.createElement(
      "div",
      { style: o.single },
      M.createElement(xr, {
        style: { input: o.input, label: o.label },
        label: "r",
        value: n.r,
        onChange: l,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    M.createElement(
      "div",
      { style: o.single },
      M.createElement(xr, {
        style: { input: o.input, label: o.label },
        label: "g",
        value: n.g,
        onChange: l,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    M.createElement(
      "div",
      { style: o.single },
      M.createElement(xr, {
        style: { input: o.input, label: o.label },
        label: "b",
        value: n.b,
        onChange: l,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    M.createElement(
      "div",
      { style: o.alpha },
      M.createElement(xr, {
        style: { input: o.input, label: o.label },
        label: "a",
        value: Math.round(n.a * 100),
        onChange: l,
        dragLabel: "true",
        dragMax: "100"
      })
    )
  );
}, $xe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, WB = function(t) {
  var r = t.colors, n = t.onClick, a = n === void 0 ? function() {
  } : n, s = t.onSwatchHover, i = Yt({
    default: {
      colors: {
        margin: "0 -10px",
        padding: "10px 0 0 10px",
        borderTop: "1px solid #eee",
        display: "flex",
        flexWrap: "wrap",
        position: "relative"
      },
      swatchWrap: {
        width: "16px",
        height: "16px",
        margin: "0 10px 10px 0"
      },
      swatch: {
        borderRadius: "3px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
      }
    },
    "no-presets": {
      colors: {
        display: "none"
      }
    }
  }, {
    "no-presets": !r || !r.length
  }), o = function(c, u) {
    a({
      hex: c,
      source: "hex"
    }, u);
  };
  return M.createElement(
    "div",
    { style: i.colors, className: "flexbox-fix" },
    r.map(function(l) {
      var c = typeof l == "string" ? { color: l } : l, u = "" + c.color + (c.title || "");
      return M.createElement(
        "div",
        { key: u, style: i.swatchWrap },
        M.createElement(od, $xe({}, c, {
          style: i.swatch,
          onClick: o,
          onHover: s,
          focusStyle: {
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c.color
          }
        }))
      );
    })
  );
};
WB.propTypes = {
  colors: xt.arrayOf(xt.oneOfType([xt.string, xt.shape({
    color: xt.string,
    title: xt.string
  })])).isRequired
};
var Hxe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, ZC = function(t) {
  var r = t.width, n = t.rgb, a = t.hex, s = t.hsv, i = t.hsl, o = t.onChange, l = t.onSwatchHover, c = t.disableAlpha, u = t.presetColors, d = t.renderers, f = t.styles, h = f === void 0 ? {} : f, p = t.className, m = p === void 0 ? "" : p, g = Yt(Es({
    default: Hxe({
      picker: {
        width: r,
        padding: "10px 10px 0",
        boxSizing: "initial",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
      },
      saturation: {
        width: "100%",
        paddingBottom: "75%",
        position: "relative",
        overflow: "hidden"
      },
      Saturation: {
        radius: "3px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      controls: {
        display: "flex"
      },
      sliders: {
        padding: "4px 0",
        flex: "1"
      },
      color: {
        width: "24px",
        height: "24px",
        position: "relative",
        marginTop: "4px",
        marginLeft: "4px",
        borderRadius: "3px"
      },
      activeColor: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "2px",
        background: "rgba(" + n.r + "," + n.g + "," + n.b + "," + n.a + ")",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      hue: {
        position: "relative",
        height: "10px",
        overflow: "hidden"
      },
      Hue: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      alpha: {
        position: "relative",
        height: "10px",
        marginTop: "4px",
        overflow: "hidden"
      },
      Alpha: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      }
    }, h),
    disableAlpha: {
      color: {
        height: "10px"
      },
      hue: {
        height: "10px"
      },
      alpha: {
        display: "none"
      }
    }
  }, h), { disableAlpha: c });
  return M.createElement(
    "div",
    { style: g.picker, className: "sketch-picker " + m },
    M.createElement(
      "div",
      { style: g.saturation },
      M.createElement(ex, {
        style: g.Saturation,
        hsl: i,
        hsv: s,
        onChange: o
      })
    ),
    M.createElement(
      "div",
      { style: g.controls, className: "flexbox-fix" },
      M.createElement(
        "div",
        { style: g.sliders },
        M.createElement(
          "div",
          { style: g.hue },
          M.createElement(Lh, {
            style: g.Hue,
            hsl: i,
            onChange: o
          })
        ),
        M.createElement(
          "div",
          { style: g.alpha },
          M.createElement(DC, {
            style: g.Alpha,
            rgb: n,
            hsl: i,
            renderers: d,
            onChange: o
          })
        )
      ),
      M.createElement(
        "div",
        { style: g.color },
        M.createElement(Mh, null),
        M.createElement("div", { style: g.activeColor })
      )
    ),
    M.createElement(Vxe, {
      rgb: n,
      hsl: i,
      hex: a,
      onChange: o,
      disableAlpha: c
    }),
    M.createElement(WB, {
      colors: u,
      onClick: o,
      onSwatchHover: l
    })
  );
};
ZC.propTypes = {
  disableAlpha: xt.bool,
  width: xt.oneOfType([xt.string, xt.number]),
  styles: xt.object
};
ZC.defaultProps = {
  disableAlpha: !1,
  width: 200,
  styles: {},
  presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
};
Ts(ZC);
var mp = function(t) {
  var r = t.hsl, n = t.offset, a = t.onClick, s = a === void 0 ? function() {
  } : a, i = t.active, o = t.first, l = t.last, c = Yt({
    default: {
      swatch: {
        height: "12px",
        background: "hsl(" + r.h + ", 50%, " + n * 100 + "%)",
        cursor: "pointer"
      }
    },
    first: {
      swatch: {
        borderRadius: "2px 0 0 2px"
      }
    },
    last: {
      swatch: {
        borderRadius: "0 2px 2px 0"
      }
    },
    active: {
      swatch: {
        transform: "scaleY(1.8)",
        borderRadius: "3.6px/2px"
      }
    }
  }, { active: i, first: o, last: l }), u = function(f) {
    return s({
      h: r.h,
      s: 0.5,
      l: n,
      source: "hsl"
    }, f);
  };
  return M.createElement("div", { style: c.swatch, onClick: u });
}, Wxe = function(t) {
  var r = t.onClick, n = t.hsl, a = Yt({
    default: {
      swatches: {
        marginTop: "20px"
      },
      swatch: {
        boxSizing: "border-box",
        width: "20%",
        paddingRight: "1px",
        float: "left"
      },
      clear: {
        clear: "both"
      }
    }
  }), s = 0.1;
  return M.createElement(
    "div",
    { style: a.swatches },
    M.createElement(
      "div",
      { style: a.swatch },
      M.createElement(mp, {
        hsl: n,
        offset: ".80",
        active: Math.abs(n.l - 0.8) < s && Math.abs(n.s - 0.5) < s,
        onClick: r,
        first: !0
      })
    ),
    M.createElement(
      "div",
      { style: a.swatch },
      M.createElement(mp, {
        hsl: n,
        offset: ".65",
        active: Math.abs(n.l - 0.65) < s && Math.abs(n.s - 0.5) < s,
        onClick: r
      })
    ),
    M.createElement(
      "div",
      { style: a.swatch },
      M.createElement(mp, {
        hsl: n,
        offset: ".50",
        active: Math.abs(n.l - 0.5) < s && Math.abs(n.s - 0.5) < s,
        onClick: r
      })
    ),
    M.createElement(
      "div",
      { style: a.swatch },
      M.createElement(mp, {
        hsl: n,
        offset: ".35",
        active: Math.abs(n.l - 0.35) < s && Math.abs(n.s - 0.5) < s,
        onClick: r
      })
    ),
    M.createElement(
      "div",
      { style: a.swatch },
      M.createElement(mp, {
        hsl: n,
        offset: ".20",
        active: Math.abs(n.l - 0.2) < s && Math.abs(n.s - 0.5) < s,
        onClick: r,
        last: !0
      })
    ),
    M.createElement("div", { style: a.clear })
  );
}, zxe = function() {
  var t = Yt({
    default: {
      picker: {
        width: "14px",
        height: "14px",
        borderRadius: "6px",
        transform: "translate(-7px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return M.createElement("div", { style: t.picker });
}, ek = function(t) {
  var r = t.hsl, n = t.onChange, a = t.pointer, s = t.styles, i = s === void 0 ? {} : s, o = t.className, l = o === void 0 ? "" : o, c = Yt(Es({
    default: {
      hue: {
        height: "12px",
        position: "relative"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, i));
  return M.createElement(
    "div",
    { style: c.wrap || {}, className: "slider-picker " + l },
    M.createElement(
      "div",
      { style: c.hue },
      M.createElement(Lh, {
        style: c.Hue,
        hsl: r,
        pointer: a,
        onChange: n
      })
    ),
    M.createElement(
      "div",
      { style: c.swatches },
      M.createElement(Wxe, { hsl: r, onClick: n })
    )
  );
};
ek.propTypes = {
  styles: xt.object
};
ek.defaultProps = {
  pointer: zxe,
  styles: {}
};
Ts(ek);
var zB = {};
Object.defineProperty(zB, "__esModule", {
  value: !0
});
var gI = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, Kxe = M, vI = qxe(Kxe);
function qxe(e) {
  return e && e.__esModule ? e : { default: e };
}
function Gxe(e, t) {
  var r = {};
  for (var n in e)
    t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  return r;
}
var r0 = 24, Yxe = zB.default = function(e) {
  var t = e.fill, r = t === void 0 ? "currentColor" : t, n = e.width, a = n === void 0 ? r0 : n, s = e.height, i = s === void 0 ? r0 : s, o = e.style, l = o === void 0 ? {} : o, c = Gxe(e, ["fill", "width", "height", "style"]);
  return vI.default.createElement(
    "svg",
    gI({
      viewBox: "0 0 " + r0 + " " + r0,
      style: gI({ fill: r, width: a, height: i }, l)
    }, c),
    vI.default.createElement("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
  );
}, Xxe = function(t) {
  var r = t.color, n = t.onClick, a = n === void 0 ? function() {
  } : n, s = t.onSwatchHover, i = t.first, o = t.last, l = t.active, c = Yt({
    default: {
      color: {
        width: "40px",
        height: "24px",
        cursor: "pointer",
        background: r,
        marginBottom: "1px"
      },
      check: {
        color: $C(r),
        marginLeft: "8px",
        display: "none"
      }
    },
    first: {
      color: {
        overflow: "hidden",
        borderRadius: "2px 2px 0 0"
      }
    },
    last: {
      color: {
        overflow: "hidden",
        borderRadius: "0 0 2px 2px"
      }
    },
    active: {
      check: {
        display: "block"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      check: {
        color: "#333"
      }
    },
    transparent: {
      check: {
        color: "#333"
      }
    }
  }, {
    first: i,
    last: o,
    active: l,
    "color-#FFFFFF": r === "#FFFFFF",
    transparent: r === "transparent"
  });
  return M.createElement(
    od,
    {
      color: r,
      style: c.color,
      onClick: a,
      onHover: s,
      focusStyle: { boxShadow: "0 0 4px " + r }
    },
    M.createElement(
      "div",
      { style: c.check },
      M.createElement(Yxe, null)
    )
  );
}, Qxe = function(t) {
  var r = t.onClick, n = t.onSwatchHover, a = t.group, s = t.active, i = Yt({
    default: {
      group: {
        paddingBottom: "10px",
        width: "40px",
        float: "left",
        marginRight: "10px"
      }
    }
  });
  return M.createElement(
    "div",
    { style: i.group },
    ld(a, function(o, l) {
      return M.createElement(Xxe, {
        key: o,
        color: o,
        active: o.toLowerCase() === s,
        first: l === 0,
        last: l === a.length - 1,
        onClick: r,
        onSwatchHover: n
      });
    })
  );
}, tk = function(t) {
  var r = t.width, n = t.height, a = t.onChange, s = t.onSwatchHover, i = t.colors, o = t.hex, l = t.styles, c = l === void 0 ? {} : l, u = t.className, d = u === void 0 ? "" : u, f = Yt(Es({
    default: {
      picker: {
        width: r,
        height: n
      },
      overflow: {
        height: n,
        overflowY: "scroll"
      },
      body: {
        padding: "16px 0 6px 16px"
      },
      clear: {
        clear: "both"
      }
    }
  }, c)), h = function(m, g) {
    return a({ hex: m, source: "hex" }, g);
  };
  return M.createElement(
    "div",
    { style: f.picker, className: "swatches-picker " + d },
    M.createElement(
      jg,
      null,
      M.createElement(
        "div",
        { style: f.overflow },
        M.createElement(
          "div",
          { style: f.body },
          ld(i, function(p) {
            return M.createElement(Qxe, {
              key: p.toString(),
              group: p,
              active: o,
              onClick: h,
              onSwatchHover: s
            });
          }),
          M.createElement("div", { style: f.clear })
        )
      )
    )
  );
};
tk.propTypes = {
  width: xt.oneOfType([xt.string, xt.number]),
  height: xt.oneOfType([xt.string, xt.number]),
  colors: xt.arrayOf(xt.arrayOf(xt.string)),
  styles: xt.object
  /* eslint-disable max-len */
};
tk.defaultProps = {
  width: 320,
  height: 240,
  colors: [[uf[900], uf[700], uf[500], uf[300], uf[100]], [df[900], df[700], df[500], df[300], df[100]], [ff[900], ff[700], ff[500], ff[300], ff[100]], [hf[900], hf[700], hf[500], hf[300], hf[100]], [pf[900], pf[700], pf[500], pf[300], pf[100]], [mf[900], mf[700], mf[500], mf[300], mf[100]], [gf[900], gf[700], gf[500], gf[300], gf[100]], [vf[900], vf[700], vf[500], vf[300], vf[100]], [yf[900], yf[700], yf[500], yf[300], yf[100]], ["#194D33", Jp[700], Jp[500], Jp[300], Jp[100]], [bf[900], bf[700], bf[500], bf[300], bf[100]], [wf[900], wf[700], wf[500], wf[300], wf[100]], [xf[900], xf[700], xf[500], xf[300], xf[100]], [_f[900], _f[700], _f[500], _f[300], _f[100]], [Sf[900], Sf[700], Sf[500], Sf[300], Sf[100]], [Ef[900], Ef[700], Ef[500], Ef[300], Ef[100]], [Tf[900], Tf[700], Tf[500], Tf[300], Tf[100]], [Cf[900], Cf[700], Cf[500], Cf[300], Cf[100]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]],
  styles: {}
};
Ts(tk);
var rk = function(t) {
  var r = t.onChange, n = t.onSwatchHover, a = t.hex, s = t.colors, i = t.width, o = t.triangle, l = t.styles, c = l === void 0 ? {} : l, u = t.className, d = u === void 0 ? "" : u, f = Yt(Es({
    default: {
      card: {
        width: i,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, c), {
    "hide-triangle": o === "hide",
    "top-left-triangle": o === "top-left",
    "top-right-triangle": o === "top-right"
  }), h = function(m, g) {
    qc(m) && r({
      hex: m,
      source: "hex"
    }, g);
  };
  return M.createElement(
    "div",
    { style: f.card, className: "twitter-picker " + d },
    M.createElement("div", { style: f.triangleShadow }),
    M.createElement("div", { style: f.triangle }),
    M.createElement(
      "div",
      { style: f.body },
      ld(s, function(p, m) {
        return M.createElement(od, {
          key: m,
          color: p,
          hex: p,
          style: f.swatch,
          onClick: h,
          onHover: n,
          focusStyle: {
            boxShadow: "0 0 4px " + p
          }
        });
      }),
      M.createElement(
        "div",
        { style: f.hash },
        "#"
      ),
      M.createElement(xr, {
        label: null,
        style: { input: f.input },
        value: a.replace("#", ""),
        onChange: h
      }),
      M.createElement("div", { style: f.clear })
    )
  );
};
rk.propTypes = {
  width: xt.oneOfType([xt.string, xt.number]),
  triangle: xt.oneOf(["hide", "top-left", "top-right"]),
  colors: xt.arrayOf(xt.string),
  styles: xt.object
};
rk.defaultProps = {
  width: 276,
  colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
  triangle: "top-left",
  styles: {}
};
Ts(rk);
var nk = function(t) {
  var r = Yt({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        border: "2px #fff solid",
        transform: "translate(-12px, -13px)",
        background: "hsl(" + Math.round(t.hsl.h) + ", " + Math.round(t.hsl.s * 100) + "%, " + Math.round(t.hsl.l * 100) + "%)"
      }
    }
  });
  return M.createElement("div", { style: r.picker });
};
nk.propTypes = {
  hsl: xt.shape({
    h: xt.number,
    s: xt.number,
    l: xt.number,
    a: xt.number
  })
};
nk.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var ak = function(t) {
  var r = Yt({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        transform: "translate(-10px, -7px)",
        background: "hsl(" + Math.round(t.hsl.h) + ", 100%, 50%)",
        border: "2px white solid"
      }
    }
  });
  return M.createElement("div", { style: r.picker });
};
ak.propTypes = {
  hsl: xt.shape({
    h: xt.number,
    s: xt.number,
    l: xt.number,
    a: xt.number
  })
};
ak.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var Jxe = function(t) {
  var r = t.onChange, n = t.rgb, a = t.hsl, s = t.hex, i = t.hsv, o = function(h, p) {
    if (h.hex)
      qc(h.hex) && r({
        hex: h.hex,
        source: "hex"
      }, p);
    else if (h.rgb) {
      var m = h.rgb.split(",");
      c_(h.rgb, "rgb") && r({
        r: m[0],
        g: m[1],
        b: m[2],
        a: 1,
        source: "rgb"
      }, p);
    } else if (h.hsv) {
      var g = h.hsv.split(",");
      c_(h.hsv, "hsv") && (g[2] = g[2].replace("%", ""), g[1] = g[1].replace("%", ""), g[0] = g[0].replace("°", ""), g[1] == 1 ? g[1] = 0.01 : g[2] == 1 && (g[2] = 0.01), r({
        h: Number(g[0]),
        s: Number(g[1]),
        v: Number(g[2]),
        source: "hsv"
      }, p));
    } else if (h.hsl) {
      var y = h.hsl.split(",");
      c_(h.hsl, "hsl") && (y[2] = y[2].replace("%", ""), y[1] = y[1].replace("%", ""), y[0] = y[0].replace("°", ""), d[1] == 1 ? d[1] = 0.01 : d[2] == 1 && (d[2] = 0.01), r({
        h: Number(y[0]),
        s: Number(y[1]),
        v: Number(y[2]),
        source: "hsl"
      }, p));
    }
  }, l = Yt({
    default: {
      wrap: {
        display: "flex",
        height: "100px",
        marginTop: "4px"
      },
      fields: {
        width: "100%"
      },
      column: {
        paddingTop: "10px",
        display: "flex",
        justifyContent: "space-between"
      },
      double: {
        padding: "0px 4.4px",
        boxSizing: "border-box"
      },
      input: {
        width: "100%",
        height: "38px",
        boxSizing: "border-box",
        padding: "4px 10% 3px",
        textAlign: "center",
        border: "1px solid #dadce0",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      input2: {
        height: "38px",
        width: "100%",
        border: "1px solid #dadce0",
        boxSizing: "border-box",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        paddingLeft: "10px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label: {
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "35px",
        top: "-6px",
        left: "0",
        right: "0",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label2: {
        left: "10px",
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "32px",
        top: "-6px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      single: {
        flexGrow: "1",
        margin: "0px 4.4px"
      }
    }
  }), c = n.r + ", " + n.g + ", " + n.b, u = Math.round(a.h) + "°, " + Math.round(a.s * 100) + "%, " + Math.round(a.l * 100) + "%", d = Math.round(i.h) + "°, " + Math.round(i.s * 100) + "%, " + Math.round(i.v * 100) + "%";
  return M.createElement(
    "div",
    { style: l.wrap, className: "flexbox-fix" },
    M.createElement(
      "div",
      { style: l.fields },
      M.createElement(
        "div",
        { style: l.double },
        M.createElement(xr, {
          style: { input: l.input, label: l.label },
          label: "hex",
          value: s,
          onChange: o
        })
      ),
      M.createElement(
        "div",
        { style: l.column },
        M.createElement(
          "div",
          { style: l.single },
          M.createElement(xr, {
            style: { input: l.input2, label: l.label2 },
            label: "rgb",
            value: c,
            onChange: o
          })
        ),
        M.createElement(
          "div",
          { style: l.single },
          M.createElement(xr, {
            style: { input: l.input2, label: l.label2 },
            label: "hsv",
            value: d,
            onChange: o
          })
        ),
        M.createElement(
          "div",
          { style: l.single },
          M.createElement(xr, {
            style: { input: l.input2, label: l.label2 },
            label: "hsl",
            value: u,
            onChange: o
          })
        )
      )
    )
  );
}, sk = function(t) {
  var r = t.width, n = t.onChange, a = t.rgb, s = t.hsl, i = t.hsv, o = t.hex, l = t.header, c = t.styles, u = c === void 0 ? {} : c, d = t.className, f = d === void 0 ? "" : d, h = Yt(Es({
    default: {
      picker: {
        width: r,
        background: "#fff",
        border: "1px solid #dfe1e5",
        boxSizing: "initial",
        display: "flex",
        flexWrap: "wrap",
        borderRadius: "8px 8px 0px 0px"
      },
      head: {
        height: "57px",
        width: "100%",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        fontSize: "20px",
        boxSizing: "border-box",
        fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
      },
      saturation: {
        width: "70%",
        padding: "0px",
        position: "relative",
        overflow: "hidden"
      },
      swatch: {
        width: "30%",
        height: "228px",
        padding: "0px",
        background: "rgba(" + a.r + ", " + a.g + ", " + a.b + ", 1)",
        position: "relative",
        overflow: "hidden"
      },
      body: {
        margin: "auto",
        width: "95%"
      },
      controls: {
        display: "flex",
        boxSizing: "border-box",
        height: "52px",
        paddingTop: "22px"
      },
      color: {
        width: "32px"
      },
      hue: {
        height: "8px",
        position: "relative",
        margin: "0px 16px 0px 16px",
        width: "100%"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, u));
  return M.createElement(
    "div",
    { style: h.picker, className: "google-picker " + f },
    M.createElement(
      "div",
      { style: h.head },
      l
    ),
    M.createElement("div", { style: h.swatch }),
    M.createElement(
      "div",
      { style: h.saturation },
      M.createElement(ex, {
        hsl: s,
        hsv: i,
        pointer: nk,
        onChange: n
      })
    ),
    M.createElement(
      "div",
      { style: h.body },
      M.createElement(
        "div",
        { style: h.controls, className: "flexbox-fix" },
        M.createElement(
          "div",
          { style: h.hue },
          M.createElement(Lh, {
            style: h.Hue,
            hsl: s,
            radius: "4px",
            pointer: ak,
            onChange: n
          })
        )
      ),
      M.createElement(Jxe, {
        rgb: a,
        hsl: s,
        hex: o,
        hsv: i,
        onChange: n
      })
    )
  );
};
sk.propTypes = {
  width: xt.oneOfType([xt.string, xt.number]),
  styles: xt.object,
  header: xt.string
};
sk.defaultProps = {
  width: 652,
  styles: {},
  header: "Color picker"
};
Ts(sk);
const KB = va(
  ({
    value: e = "",
    onChange: t = () => {
    },
    size: r = "md",
    variant: n = "default",
    disabled: a = !1,
    error: s,
    helperText: i,
    label: o,
    required: l,
    showInput: c = !0,
    showFormatToggle: u = !1,
    showShades: d = !1,
    placement: f = "bottom",
    className: h,
    theme: p
  }, m) => {
    var P, D, N, z, G, Y, te, ae;
    const [g, y] = Me(!1), [x, w] = Me(e), [_, S] = Me("hex"), C = tr(null);
    JT(C, () => y(!1));
    const E = ((D = (P = p.sizes) == null ? void 0 : P[r]) == null ? void 0 : D.preview) || ((z = (N = p.sizes) == null ? void 0 : N.md) == null ? void 0 : z.preview), O = (ne) => {
      const ue = Mt(ne.target.value);
      if (w(ne.target.value), ue.isValid()) {
        const q = _ === "hex" ? ue.toHexString() : ue.toRgbString();
        t(q);
      }
    }, k = d ? fl(e) : null, A = k ? HT.map((ne) => ({
      shade: ne,
      color: k[ne].value
    })) : [];
    return /* @__PURE__ */ v.jsxs("div", { ref: C, className: (G = p.baseStyle) == null ? void 0 : G.container, children: [
      /* @__PURE__ */ v.jsx(
        "button",
        {
          type: "button",
          onClick: () => !a && y(!g),
          className: lt(
            (Y = p.baseStyle) == null ? void 0 : Y.preview,
            E,
            a ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:shadow-md",
            h
          ),
          style: { backgroundColor: e },
          disabled: a
        }
      ),
      c && /* @__PURE__ */ v.jsx(
        ar,
        {
          value: x,
          onChange: O,
          disabled: a,
          className: (te = p.baseStyle) == null ? void 0 : te.input,
          placeholder: "#000000"
        }
      ),
      u && /* @__PURE__ */ v.jsx(
        qe,
        {
          size: "sm",
          variant: "outline",
          onClick: () => S(_ === "hex" ? "rgba" : "hex"),
          disabled: a,
          children: _.toUpperCase()
        }
      ),
      d && /* @__PURE__ */ v.jsx("div", { className: (ae = p.baseStyle) == null ? void 0 : ae.shadesContainer, children: A.map(({ shade: ne, color: ue }) => {
        var q, U, Q;
        return /* @__PURE__ */ v.jsxs("div", { className: (q = p.baseStyle) == null ? void 0 : q.shade, children: [
          /* @__PURE__ */ v.jsx(
            "div",
            {
              className: (U = p.baseStyle) == null ? void 0 : U.preview,
              style: { backgroundColor: ue },
              onClick: () => t == null ? void 0 : t(ue)
            }
          ),
          /* @__PURE__ */ v.jsx("span", { className: (Q = p.baseStyle) == null ? void 0 : Q.shadeLabel, children: ne })
        ] }, `${ne}-${ue}`);
      }) }),
      g && !a && /* @__PURE__ */ v.jsx(
        "div",
        {
          className: `absolute z-50 ${f === "top" ? "bottom-full mb-2" : "top-full mt-2"}`,
          children: /* @__PURE__ */ v.jsx("div", { className: "p-2 bg-white rounded-lg shadow-lg border border-gray-200", children: /* @__PURE__ */ v.jsx(
            Txe,
            {
              color: e,
              onChange: (ne) => {
                const ue = _ === "hex" ? ne.hex : `rgba(${ne.rgb.r},${ne.rgb.g},${ne.rgb.b},${ne.rgb.a})`;
                t(ue), w(ue);
              },
              disableAlpha: _ === "hex"
            }
          ) })
        }
      ),
      s && /* @__PURE__ */ v.jsx("p", { className: "text-red-500 text-sm mt-1", children: s })
    ] });
  }
);
KB.displayName = "ColorPickerBase";
const Zxe = $r(
  "ColorPicker",
  KB
), e1e = ({
  min: e,
  max: t,
  step: r = 1,
  value: n,
  onChange: a,
  onChangeEnd: s,
  size: i = "md",
  variant: o = "default",
  color: l = "primary",
  label: c,
  showValue: u = !1,
  valuePosition: d = "right",
  marks: f,
  showTooltip: h = !1,
  tooltipLabel: p = (S) => S.toString(),
  disabled: m = !1,
  error: g,
  helperText: y,
  className: x,
  theme: w,
  ..._
}) => {
  var z, G;
  const [S, C] = Me(!1), E = (n - e) / (t - e) * 100, O = w.baseStyle, k = ((z = w.variants) == null ? void 0 : z[o]) || {}, A = ((G = w.sizes) == null ? void 0 : G[i]) || {}, P = Ft(
    (Y) => {
      m || a(Number(Y.target.value));
    },
    [a, m]
  ), D = Ft(() => {
    m || C(!0);
  }, [m]), N = Ft(() => {
    S && (C(!1), s == null || s(n));
  }, [S, s, n]);
  return wt(() => {
    if (S)
      return document.addEventListener("mouseup", N), document.addEventListener("touchend", N), () => {
        document.removeEventListener("mouseup", N), document.removeEventListener("touchend", N);
      };
  }, [S, N]), /* @__PURE__ */ v.jsx("div", { className: lt(O.base, x), children: /* @__PURE__ */ v.jsxs("div", { className: O.wrapper, children: [
    c && /* @__PURE__ */ v.jsxs(
      "label",
      {
        className: lt(O.label, m && O.states.disabled),
        children: [
          c,
          u && d === "right" && /* @__PURE__ */ v.jsx("span", { className: O.valueLabel, children: n })
        ]
      }
    ),
    /* @__PURE__ */ v.jsxs("div", { className: O.container, children: [
      /* @__PURE__ */ v.jsx("div", { className: lt(O.track, A.track) }),
      /* @__PURE__ */ v.jsx(
        "div",
        {
          className: lt(
            O.trackFilled,
            k.trackFilled,
            `bg-${l}-500 dark:bg-${l}-400`
          ),
          style: { width: `${E}%` }
        }
      ),
      /* @__PURE__ */ v.jsx(
        "div",
        {
          className: lt(
            O.thumb,
            A.thumb,
            S && O.states.dragging,
            m && O.states.disabled,
            `border-${l}-500 dark:border-${l}-400`
          ),
          style: { left: `${E}%` }
        }
      ),
      /* @__PURE__ */ v.jsx(
        "input",
        {
          type: "range",
          min: e,
          max: t,
          step: r,
          value: n,
          onChange: P,
          onMouseDown: D,
          onTouchStart: D,
          disabled: m,
          className: "absolute inset-0 w-full h-full opacity-0 cursor-pointer",
          ..._
        }
      ),
      f && /* @__PURE__ */ v.jsx("div", { className: O.markContainer, children: f.map((Y) => {
        const te = (Y.value - e) / (t - e) * 100;
        return /* @__PURE__ */ v.jsx(
          "div",
          {
            className: O.markDot,
            style: { left: `${te}%` },
            children: /* @__PURE__ */ v.jsx("div", { className: O.markLabel, children: Y.label })
          },
          Y.value
        );
      }) }),
      h && S && /* @__PURE__ */ v.jsxs("div", { className: O.tooltip, children: [
        p(n),
        /* @__PURE__ */ v.jsx("div", { className: O.tooltipArrow })
      ] })
    ] }),
    (g || y) && /* @__PURE__ */ v.jsx("p", { className: g ? O.errorText : O.helperText, children: g || y })
  ] }) });
}, qB = $r(
  "Slider",
  e1e
), t1e = ({
  value: e,
  onChange: t,
  max: r = 5,
  precision: n = 1,
  error: a
}) => {
  const s = (o) => {
    t(o);
  }, i = (o, l) => {
    const c = o.currentTarget.getBoundingClientRect(), u = (o.clientX - c.left) / c.width, d = l + 1 - (1 - u) * n;
    t(Math.min(Math.max(d, 0), r));
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "rating", children: [
    /* @__PURE__ */ v.jsx("div", { className: "flex", children: [...Array(r)].map((o, l) => /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: "relative w-8 h-8 cursor-pointer",
        onClick: () => s(l + 1),
        onMouseMove: (c) => i(c, l),
        onMouseLeave: () => t(Math.round(e / n) * n),
        children: [
          /* @__PURE__ */ v.jsx(
            "svg",
            {
              className: "w-full h-full text-gray-300",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg",
              children: /* @__PURE__ */ v.jsx(
                "path",
                {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: 2,
                  d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                }
              )
            }
          ),
          /* @__PURE__ */ v.jsx(
            "div",
            {
              style: {
                position: "absolute",
                top: 0,
                left: 0,
                width: `${Math.min(100, (e - l) * 100)}%`,
                height: "100%",
                overflow: "hidden"
              },
              children: /* @__PURE__ */ v.jsx(
                "svg",
                {
                  className: "w-full h-full text-yellow-400",
                  fill: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: /* @__PURE__ */ v.jsx(
                    "path",
                    {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                    }
                  )
                }
              )
            }
          )
        ]
      },
      l
    )) }),
    a && /* @__PURE__ */ v.jsx("p", { className: "text-red-500 text-sm mt-1", children: a })
  ] });
};
var GB = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(ke, function() {
    var r = Array.prototype.slice;
    function n(b, T) {
      T && (b.prototype = Object.create(T.prototype)), b.prototype.constructor = b;
    }
    function a(b) {
      return l(b) ? b : ee(b);
    }
    n(s, a);
    function s(b) {
      return c(b) ? b : he(b);
    }
    n(i, a);
    function i(b) {
      return u(b) ? b : Ee(b);
    }
    n(o, a);
    function o(b) {
      return l(b) && !d(b) ? b : we(b);
    }
    function l(b) {
      return !!(b && b[h]);
    }
    function c(b) {
      return !!(b && b[p]);
    }
    function u(b) {
      return !!(b && b[m]);
    }
    function d(b) {
      return c(b) || u(b);
    }
    function f(b) {
      return !!(b && b[g]);
    }
    a.isIterable = l, a.isKeyed = c, a.isIndexed = u, a.isAssociative = d, a.isOrdered = f, a.Keyed = s, a.Indexed = i, a.Set = o;
    var h = "@@__IMMUTABLE_ITERABLE__@@", p = "@@__IMMUTABLE_KEYED__@@", m = "@@__IMMUTABLE_INDEXED__@@", g = "@@__IMMUTABLE_ORDERED__@@", y = "delete", x = 5, w = 1 << x, _ = w - 1, S = {}, C = { value: !1 }, E = { value: !1 };
    function O(b) {
      return b.value = !1, b;
    }
    function k(b) {
      b && (b.value = !0);
    }
    function A() {
    }
    function P(b, T) {
      T = T || 0;
      for (var R = Math.max(0, b.length - T), F = new Array(R), V = 0; V < R; V++)
        F[V] = b[V + T];
      return F;
    }
    function D(b) {
      return b.size === void 0 && (b.size = b.__iterate(z)), b.size;
    }
    function N(b, T) {
      if (typeof T != "number") {
        var R = T >>> 0;
        if ("" + R !== T || R === 4294967295)
          return NaN;
        T = R;
      }
      return T < 0 ? D(b) + T : T;
    }
    function z() {
      return !0;
    }
    function G(b, T, R) {
      return (b === 0 || R !== void 0 && b <= -R) && (T === void 0 || R !== void 0 && T >= R);
    }
    function Y(b, T) {
      return ae(b, T, 0);
    }
    function te(b, T) {
      return ae(b, T, T);
    }
    function ae(b, T, R) {
      return b === void 0 ? R : b < 0 ? Math.max(0, T + b) : T === void 0 ? b : Math.min(T, b);
    }
    var ne = 0, ue = 1, q = 2, U = typeof Symbol == "function" && Symbol.iterator, Q = "@@iterator", L = U || Q;
    function j(b) {
      this.next = b;
    }
    j.prototype.toString = function() {
      return "[Iterator]";
    }, j.KEYS = ne, j.VALUES = ue, j.ENTRIES = q, j.prototype.inspect = j.prototype.toSource = function() {
      return this.toString();
    }, j.prototype[L] = function() {
      return this;
    };
    function K(b, T, R, F) {
      var V = b === 0 ? T : b === 1 ? R : [T, R];
      return F ? F.value = V : F = {
        value: V,
        done: !1
      }, F;
    }
    function J() {
      return { value: void 0, done: !0 };
    }
    function re(b) {
      return !!me(b);
    }
    function le(b) {
      return b && typeof b.next == "function";
    }
    function pe(b) {
      var T = me(b);
      return T && T.call(b);
    }
    function me(b) {
      var T = b && (U && b[U] || b[Q]);
      if (typeof T == "function")
        return T;
    }
    function Oe(b) {
      return b && typeof b.length == "number";
    }
    n(ee, a);
    function ee(b) {
      return b == null ? ye() : l(b) ? b.toSeq() : Ae(b);
    }
    ee.of = function() {
      return ee(arguments);
    }, ee.prototype.toSeq = function() {
      return this;
    }, ee.prototype.toString = function() {
      return this.__toString("Seq {", "}");
    }, ee.prototype.cacheResult = function() {
      return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
    }, ee.prototype.__iterate = function(b, T) {
      return mt(this, b, T, !0);
    }, ee.prototype.__iterator = function(b, T) {
      return Dt(this, b, T, !0);
    }, n(he, ee);
    function he(b) {
      return b == null ? ye().toKeyedSeq() : l(b) ? c(b) ? b.toSeq() : b.fromEntrySeq() : Te(b);
    }
    he.prototype.toKeyedSeq = function() {
      return this;
    }, n(Ee, ee);
    function Ee(b) {
      return b == null ? ye() : l(b) ? c(b) ? b.entrySeq() : b.toIndexedSeq() : _e(b);
    }
    Ee.of = function() {
      return Ee(arguments);
    }, Ee.prototype.toIndexedSeq = function() {
      return this;
    }, Ee.prototype.toString = function() {
      return this.__toString("Seq [", "]");
    }, Ee.prototype.__iterate = function(b, T) {
      return mt(this, b, T, !1);
    }, Ee.prototype.__iterator = function(b, T) {
      return Dt(this, b, T, !1);
    }, n(we, ee);
    function we(b) {
      return (b == null ? ye() : l(b) ? c(b) ? b.entrySeq() : b : _e(b)).toSetSeq();
    }
    we.of = function() {
      return we(arguments);
    }, we.prototype.toSetSeq = function() {
      return this;
    }, ee.isSeq = oe, ee.Keyed = he, ee.Set = we, ee.Indexed = Ee;
    var Pe = "@@__IMMUTABLE_SEQ__@@";
    ee.prototype[Pe] = !0, n(rt, Ee);
    function rt(b) {
      this._array = b, this.size = b.length;
    }
    rt.prototype.get = function(b, T) {
      return this.has(b) ? this._array[N(this, b)] : T;
    }, rt.prototype.__iterate = function(b, T) {
      for (var R = this._array, F = R.length - 1, V = 0; V <= F; V++)
        if (b(R[T ? F - V : V], V, this) === !1)
          return V + 1;
      return V;
    }, rt.prototype.__iterator = function(b, T) {
      var R = this._array, F = R.length - 1, V = 0;
      return new j(
        function() {
          return V > F ? J() : K(b, V, R[T ? F - V++ : V++]);
        }
      );
    }, n(ht, he);
    function ht(b) {
      var T = Object.keys(b);
      this._object = b, this._keys = T, this.size = T.length;
    }
    ht.prototype.get = function(b, T) {
      return T !== void 0 && !this.has(b) ? T : this._object[b];
    }, ht.prototype.has = function(b) {
      return this._object.hasOwnProperty(b);
    }, ht.prototype.__iterate = function(b, T) {
      for (var R = this._object, F = this._keys, V = F.length - 1, se = 0; se <= V; se++) {
        var fe = F[T ? V - se : se];
        if (b(R[fe], fe, this) === !1)
          return se + 1;
      }
      return se;
    }, ht.prototype.__iterator = function(b, T) {
      var R = this._object, F = this._keys, V = F.length - 1, se = 0;
      return new j(function() {
        var fe = F[T ? V - se : se];
        return se++ > V ? J() : K(b, fe, R[fe]);
      });
    }, ht.prototype[g] = !0, n(bt, Ee);
    function bt(b) {
      this._iterable = b, this.size = b.length || b.size;
    }
    bt.prototype.__iterateUncached = function(b, T) {
      if (T)
        return this.cacheResult().__iterate(b, T);
      var R = this._iterable, F = pe(R), V = 0;
      if (le(F))
        for (var se; !(se = F.next()).done && b(se.value, V++, this) !== !1; )
          ;
      return V;
    }, bt.prototype.__iteratorUncached = function(b, T) {
      if (T)
        return this.cacheResult().__iterator(b, T);
      var R = this._iterable, F = pe(R);
      if (!le(F))
        return new j(J);
      var V = 0;
      return new j(function() {
        var se = F.next();
        return se.done ? se : K(b, V++, se.value);
      });
    }, n(Ge, Ee);
    function Ge(b) {
      this._iterator = b, this._iteratorCache = [];
    }
    Ge.prototype.__iterateUncached = function(b, T) {
      if (T)
        return this.cacheResult().__iterate(b, T);
      for (var R = this._iterator, F = this._iteratorCache, V = 0; V < F.length; )
        if (b(F[V], V++, this) === !1)
          return V;
      for (var se; !(se = R.next()).done; ) {
        var fe = se.value;
        if (F[V] = fe, b(fe, V++, this) === !1)
          break;
      }
      return V;
    }, Ge.prototype.__iteratorUncached = function(b, T) {
      if (T)
        return this.cacheResult().__iterator(b, T);
      var R = this._iterator, F = this._iteratorCache, V = 0;
      return new j(function() {
        if (V >= F.length) {
          var se = R.next();
          if (se.done)
            return se;
          F[V] = se.value;
        }
        return K(b, V, F[V++]);
      });
    };
    function oe(b) {
      return !!(b && b[Pe]);
    }
    var ve;
    function ye() {
      return ve || (ve = new rt([]));
    }
    function Te(b) {
      var T = Array.isArray(b) ? new rt(b).fromEntrySeq() : le(b) ? new Ge(b).fromEntrySeq() : re(b) ? new bt(b).fromEntrySeq() : typeof b == "object" ? new ht(b) : void 0;
      if (!T)
        throw new TypeError(
          "Expected Array or iterable object of [k, v] entries, or keyed object: " + b
        );
      return T;
    }
    function _e(b) {
      var T = Ve(b);
      if (!T)
        throw new TypeError(
          "Expected Array or iterable object of values: " + b
        );
      return T;
    }
    function Ae(b) {
      var T = Ve(b) || typeof b == "object" && new ht(b);
      if (!T)
        throw new TypeError(
          "Expected Array or iterable object of values, or keyed object: " + b
        );
      return T;
    }
    function Ve(b) {
      return Oe(b) ? new rt(b) : le(b) ? new Ge(b) : re(b) ? new bt(b) : void 0;
    }
    function mt(b, T, R, F) {
      var V = b._cache;
      if (V) {
        for (var se = V.length - 1, fe = 0; fe <= se; fe++) {
          var Ce = V[R ? se - fe : fe];
          if (T(Ce[1], F ? Ce[0] : fe, b) === !1)
            return fe + 1;
        }
        return fe;
      }
      return b.__iterateUncached(T, R);
    }
    function Dt(b, T, R, F) {
      var V = b._cache;
      if (V) {
        var se = V.length - 1, fe = 0;
        return new j(function() {
          var Ce = V[R ? se - fe : fe];
          return fe++ > se ? J() : K(T, F ? Ce[0] : fe - 1, Ce[1]);
        });
      }
      return b.__iteratorUncached(T, R);
    }
    function Gt(b, T) {
      return T ? $t(T, b, "", { "": b }) : Rt(b);
    }
    function $t(b, T, R, F) {
      return Array.isArray(T) ? b.call(F, R, Ee(T).map(function(V, se) {
        return $t(b, V, se, T);
      })) : Pr(T) ? b.call(F, R, he(T).map(function(V, se) {
        return $t(b, V, se, T);
      })) : T;
    }
    function Rt(b) {
      return Array.isArray(b) ? Ee(b).map(Rt).toList() : Pr(b) ? he(b).map(Rt).toMap() : b;
    }
    function Pr(b) {
      return b && (b.constructor === Object || b.constructor === void 0);
    }
    function fr(b, T) {
      if (b === T || b !== b && T !== T)
        return !0;
      if (!b || !T)
        return !1;
      if (typeof b.valueOf == "function" && typeof T.valueOf == "function") {
        if (b = b.valueOf(), T = T.valueOf(), b === T || b !== b && T !== T)
          return !0;
        if (!b || !T)
          return !1;
      }
      return !!(typeof b.equals == "function" && typeof T.equals == "function" && b.equals(T));
    }
    function ca(b, T) {
      if (b === T)
        return !0;
      if (!l(T) || b.size !== void 0 && T.size !== void 0 && b.size !== T.size || b.__hash !== void 0 && T.__hash !== void 0 && b.__hash !== T.__hash || c(b) !== c(T) || u(b) !== u(T) || f(b) !== f(T))
        return !1;
      if (b.size === 0 && T.size === 0)
        return !0;
      var R = !d(b);
      if (f(b)) {
        var F = b.entries();
        return T.every(function(Ue, We) {
          var tt = F.next().value;
          return tt && fr(tt[1], Ue) && (R || fr(tt[0], We));
        }) && F.next().done;
      }
      var V = !1;
      if (b.size === void 0)
        if (T.size === void 0)
          typeof b.cacheResult == "function" && b.cacheResult();
        else {
          V = !0;
          var se = b;
          b = T, T = se;
        }
      var fe = !0, Ce = T.__iterate(function(Ue, We) {
        if (R ? !b.has(Ue) : V ? !fr(Ue, b.get(We, S)) : !fr(b.get(We, S), Ue))
          return fe = !1, !1;
      });
      return fe && b.size === Ce;
    }
    n(en, Ee);
    function en(b, T) {
      if (!(this instanceof en))
        return new en(b, T);
      if (this._value = b, this.size = T === void 0 ? 1 / 0 : Math.max(0, T), this.size === 0) {
        if (Na)
          return Na;
        Na = this;
      }
    }
    en.prototype.toString = function() {
      return this.size === 0 ? "Repeat []" : "Repeat [ " + this._value + " " + this.size + " times ]";
    }, en.prototype.get = function(b, T) {
      return this.has(b) ? this._value : T;
    }, en.prototype.includes = function(b) {
      return fr(this._value, b);
    }, en.prototype.slice = function(b, T) {
      var R = this.size;
      return G(b, T, R) ? this : new en(this._value, te(T, R) - Y(b, R));
    }, en.prototype.reverse = function() {
      return this;
    }, en.prototype.indexOf = function(b) {
      return fr(this._value, b) ? 0 : -1;
    }, en.prototype.lastIndexOf = function(b) {
      return fr(this._value, b) ? this.size : -1;
    }, en.prototype.__iterate = function(b, T) {
      for (var R = 0; R < this.size; R++)
        if (b(this._value, R, this) === !1)
          return R + 1;
      return R;
    }, en.prototype.__iterator = function(b, T) {
      var R = this, F = 0;
      return new j(
        function() {
          return F < R.size ? K(b, F++, R._value) : J();
        }
      );
    }, en.prototype.equals = function(b) {
      return b instanceof en ? fr(this._value, b._value) : ca(b);
    };
    var Na;
    function Ma(b, T) {
      if (!b) throw new Error(T);
    }
    n(Hr, Ee);
    function Hr(b, T, R) {
      if (!(this instanceof Hr))
        return new Hr(b, T, R);
      if (Ma(R !== 0, "Cannot step a Range by 0"), b = b || 0, T === void 0 && (T = 1 / 0), R = R === void 0 ? 1 : Math.abs(R), T < b && (R = -R), this._start = b, this._end = T, this._step = R, this.size = Math.max(0, Math.ceil((T - b) / R - 1) + 1), this.size === 0) {
        if (wa)
          return wa;
        wa = this;
      }
    }
    Hr.prototype.toString = function() {
      return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step > 1 ? " by " + this._step : "") + " ]";
    }, Hr.prototype.get = function(b, T) {
      return this.has(b) ? this._start + N(this, b) * this._step : T;
    }, Hr.prototype.includes = function(b) {
      var T = (b - this._start) / this._step;
      return T >= 0 && T < this.size && T === Math.floor(T);
    }, Hr.prototype.slice = function(b, T) {
      return G(b, T, this.size) ? this : (b = Y(b, this.size), T = te(T, this.size), T <= b ? new Hr(0, 0) : new Hr(this.get(b, this._end), this.get(T, this._end), this._step));
    }, Hr.prototype.indexOf = function(b) {
      var T = b - this._start;
      if (T % this._step === 0) {
        var R = T / this._step;
        if (R >= 0 && R < this.size)
          return R;
      }
      return -1;
    }, Hr.prototype.lastIndexOf = function(b) {
      return this.indexOf(b);
    }, Hr.prototype.__iterate = function(b, T) {
      for (var R = this.size - 1, F = this._step, V = T ? this._start + R * F : this._start, se = 0; se <= R; se++) {
        if (b(V, se, this) === !1)
          return se + 1;
        V += T ? -F : F;
      }
      return se;
    }, Hr.prototype.__iterator = function(b, T) {
      var R = this.size - 1, F = this._step, V = T ? this._start + R * F : this._start, se = 0;
      return new j(function() {
        var fe = V;
        return V += T ? -F : F, se > R ? J() : K(b, se++, fe);
      });
    }, Hr.prototype.equals = function(b) {
      return b instanceof Hr ? this._start === b._start && this._end === b._end && this._step === b._step : ca(this, b);
    };
    var wa;
    n(na, a);
    function na() {
      throw TypeError("Abstract");
    }
    n(ce, na);
    function ce() {
    }
    n(de, na);
    function de() {
    }
    n(Ne, na);
    function Ne() {
    }
    na.Keyed = ce, na.Indexed = de, na.Set = Ne;
    var Le = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(T, R) {
      T = T | 0, R = R | 0;
      var F = T & 65535, V = R & 65535;
      return F * V + ((T >>> 16) * V + F * (R >>> 16) << 16 >>> 0) | 0;
    };
    function $e(b) {
      return b >>> 1 & 1073741824 | b & 3221225471;
    }
    function ze(b) {
      if (b === !1 || b === null || b === void 0 || typeof b.valueOf == "function" && (b = b.valueOf(), b === !1 || b === null || b === void 0))
        return 0;
      if (b === !0)
        return 1;
      var T = typeof b;
      if (T === "number") {
        var R = b | 0;
        for (R !== b && (R ^= b * 4294967295); b > 4294967295; )
          b /= 4294967295, R ^= b;
        return $e(R);
      }
      if (T === "string")
        return b.length > H ? Lt(b) : Ht(b);
      if (typeof b.hashCode == "function")
        return b.hashCode();
      if (T === "object")
        return Rr(b);
      if (typeof b.toString == "function")
        return Ht(b.toString());
      throw new Error("Value type " + T + " cannot be hashed.");
    }
    function Lt(b) {
      var T = Se[b];
      return T === void 0 && (T = Ht(b), Z === X && (Z = 0, Se = {}), Z++, Se[b] = T), T;
    }
    function Ht(b) {
      for (var T = 0, R = 0; R < b.length; R++)
        T = 31 * T + b.charCodeAt(R) | 0;
      return $e(T);
    }
    function Rr(b) {
      var T;
      if (ua && (T = W.get(b), T !== void 0) || (T = b[I], T !== void 0) || !lr && (T = b.propertyIsEnumerable && b.propertyIsEnumerable[I], T !== void 0 || (T = cn(b), T !== void 0)))
        return T;
      if (T = ++ie, ie & 1073741824 && (ie = 0), ua)
        W.set(b, T);
      else {
        if (kt !== void 0 && kt(b) === !1)
          throw new Error("Non-extensible objects are not allowed as keys.");
        if (lr)
          Object.defineProperty(b, I, {
            enumerable: !1,
            configurable: !1,
            writable: !1,
            value: T
          });
        else if (b.propertyIsEnumerable !== void 0 && b.propertyIsEnumerable === b.constructor.prototype.propertyIsEnumerable)
          b.propertyIsEnumerable = function() {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
          }, b.propertyIsEnumerable[I] = T;
        else if (b.nodeType !== void 0)
          b[I] = T;
        else
          throw new Error("Unable to set a non-enumerable property on object.");
      }
      return T;
    }
    var kt = Object.isExtensible, lr = function() {
      try {
        return Object.defineProperty({}, "@", {}), !0;
      } catch {
        return !1;
      }
    }();
    function cn(b) {
      if (b && b.nodeType > 0)
        switch (b.nodeType) {
          case 1:
            return b.uniqueID;
          case 9:
            return b.documentElement && b.documentElement.uniqueID;
        }
    }
    var ua = typeof WeakMap == "function", W;
    ua && (W = /* @__PURE__ */ new WeakMap());
    var ie = 0, I = "__immutablehash__";
    typeof Symbol == "function" && (I = Symbol(I));
    var H = 16, X = 255, Z = 0, Se = {};
    function Ie(b) {
      Ma(
        b !== 1 / 0,
        "Cannot perform this action with an infinite size."
      );
    }
    n(ge, ce);
    function ge(b) {
      return b == null ? La() : xe(b) && !f(b) ? b : La().withMutations(function(T) {
        var R = s(b);
        Ie(R.size), R.forEach(function(F, V) {
          return T.set(V, F);
        });
      });
    }
    ge.prototype.toString = function() {
      return this.__toString("Map {", "}");
    }, ge.prototype.get = function(b, T) {
      return this._root ? this._root.get(0, void 0, b, T) : T;
    }, ge.prototype.set = function(b, T) {
      return Gi(this, b, T);
    }, ge.prototype.setIn = function(b, T) {
      return this.updateIn(b, S, function() {
        return T;
      });
    }, ge.prototype.remove = function(b) {
      return Gi(this, b, S);
    }, ge.prototype.deleteIn = function(b) {
      return this.updateIn(b, function() {
        return S;
      });
    }, ge.prototype.update = function(b, T, R) {
      return arguments.length === 1 ? b(this) : this.updateIn([b], T, R);
    }, ge.prototype.updateIn = function(b, T, R) {
      R || (R = T, T = void 0);
      var F = hO(
        this,
        NO(b),
        T,
        R
      );
      return F === S ? void 0 : F;
    }, ge.prototype.clear = function() {
      return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : La();
    }, ge.prototype.merge = function() {
      return Pv(this, void 0, arguments);
    }, ge.prototype.mergeWith = function(b) {
      var T = r.call(arguments, 1);
      return Pv(this, b, T);
    }, ge.prototype.mergeIn = function(b) {
      var T = r.call(arguments, 1);
      return this.updateIn(
        b,
        La(),
        function(R) {
          return typeof R.merge == "function" ? R.merge.apply(R, T) : T[T.length - 1];
        }
      );
    }, ge.prototype.mergeDeep = function() {
      return Pv(this, uO, arguments);
    }, ge.prototype.mergeDeepWith = function(b) {
      var T = r.call(arguments, 1);
      return Pv(this, dO(b), T);
    }, ge.prototype.mergeDeepIn = function(b) {
      var T = r.call(arguments, 1);
      return this.updateIn(
        b,
        La(),
        function(R) {
          return typeof R.mergeDeep == "function" ? R.mergeDeep.apply(R, T) : T[T.length - 1];
        }
      );
    }, ge.prototype.sort = function(b) {
      return Mn(Nd(this, b));
    }, ge.prototype.sortBy = function(b, T) {
      return Mn(Nd(this, T, b));
    }, ge.prototype.withMutations = function(b) {
      var T = this.asMutable();
      return b(T), T.wasAltered() ? T.__ensureOwner(this.__ownerID) : this;
    }, ge.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new A());
    }, ge.prototype.asImmutable = function() {
      return this.__ensureOwner();
    }, ge.prototype.wasAltered = function() {
      return this.__altered;
    }, ge.prototype.__iterator = function(b, T) {
      return new Ir(this, b, T);
    }, ge.prototype.__iterate = function(b, T) {
      var R = this, F = 0;
      return this._root && this._root.iterate(function(V) {
        return F++, b(V[1], V[0], R);
      }, T), F;
    }, ge.prototype.__ensureOwner = function(b) {
      return b === this.__ownerID ? this : b ? Qo(this.size, this._root, b, this.__hash) : (this.__ownerID = b, this.__altered = !1, this);
    };
    function xe(b) {
      return !!(b && b[De]);
    }
    ge.isMap = xe;
    var De = "@@__IMMUTABLE_MAP__@@", je = ge.prototype;
    je[De] = !0, je[y] = je.remove, je.removeIn = je.deleteIn;
    function at(b, T) {
      this.ownerID = b, this.entries = T;
    }
    at.prototype.get = function(b, T, R, F) {
      for (var V = this.entries, se = 0, fe = V.length; se < fe; se++)
        if (fr(R, V[se][0]))
          return V[se][1];
      return F;
    }, at.prototype.update = function(b, T, R, F, V, se, fe) {
      for (var Ce = V === S, Ue = this.entries, We = 0, tt = Ue.length; We < tt && !fr(F, Ue[We][0]); We++)
        ;
      var Ct = We < tt;
      if (Ct ? Ue[We][1] === V : Ce)
        return this;
      if (k(fe), (Ce || !Ct) && k(se), !(Ce && Ue.length === 1)) {
        if (!Ct && !Ce && Ue.length >= Cz)
          return xz(b, Ue, F, V);
        var It = b && b === this.ownerID, Jt = It ? Ue : P(Ue);
        return Ct ? Ce ? We === tt - 1 ? Jt.pop() : Jt[We] = Jt.pop() : Jt[We] = [F, V] : Jt.push([F, V]), It ? (this.entries = Jt, this) : new at(b, Jt);
      }
    };
    function pt(b, T, R) {
      this.ownerID = b, this.bitmap = T, this.nodes = R;
    }
    pt.prototype.get = function(b, T, R, F) {
      T === void 0 && (T = ze(R));
      var V = 1 << ((b === 0 ? T : T >>> b) & _), se = this.bitmap;
      return se & V ? this.nodes[pO(se & V - 1)].get(b + x, T, R, F) : F;
    }, pt.prototype.update = function(b, T, R, F, V, se, fe) {
      R === void 0 && (R = ze(F));
      var Ce = (T === 0 ? R : R >>> T) & _, Ue = 1 << Ce, We = this.bitmap, tt = (We & Ue) !== 0;
      if (!tt && V === S)
        return this;
      var Ct = pO(We & Ue - 1), It = this.nodes, Jt = tt ? It[Ct] : void 0, pr = eu(Jt, b, T + x, R, F, V, se, fe);
      if (pr === Jt)
        return this;
      if (!tt && pr && It.length >= kz)
        return Sz(b, It, We, Ce, pr);
      if (tt && !pr && It.length === 2 && Gs(It[Ct ^ 1]))
        return It[Ct ^ 1];
      if (tt && pr && It.length === 1 && Gs(pr))
        return pr;
      var bn = b && b === this.ownerID, xi = tt ? pr ? We : We ^ Ue : We | Ue, Ji = tt ? pr ? mO(It, Ct, pr, bn) : Tz(It, Ct, bn) : Ez(It, Ct, pr, bn);
      return bn ? (this.bitmap = xi, this.nodes = Ji, this) : new pt(b, xi, Ji);
    };
    function ct(b, T, R) {
      this.ownerID = b, this.count = T, this.nodes = R;
    }
    ct.prototype.get = function(b, T, R, F) {
      T === void 0 && (T = ze(R));
      var V = (b === 0 ? T : T >>> b) & _, se = this.nodes[V];
      return se ? se.get(b + x, T, R, F) : F;
    }, ct.prototype.update = function(b, T, R, F, V, se, fe) {
      R === void 0 && (R = ze(F));
      var Ce = (T === 0 ? R : R >>> T) & _, Ue = V === S, We = this.nodes, tt = We[Ce];
      if (Ue && !tt)
        return this;
      var Ct = eu(tt, b, T + x, R, F, V, se, fe);
      if (Ct === tt)
        return this;
      var It = this.count;
      if (!tt)
        It++;
      else if (!Ct && (It--, It < Oz))
        return _z(b, We, It, Ce);
      var Jt = b && b === this.ownerID, pr = mO(We, Ce, Ct, Jt);
      return Jt ? (this.count = It, this.nodes = pr, this) : new ct(b, It, pr);
    };
    function gt(b, T, R) {
      this.ownerID = b, this.keyHash = T, this.entries = R;
    }
    gt.prototype.get = function(b, T, R, F) {
      for (var V = this.entries, se = 0, fe = V.length; se < fe; se++)
        if (fr(R, V[se][0]))
          return V[se][1];
      return F;
    }, gt.prototype.update = function(b, T, R, F, V, se, fe) {
      R === void 0 && (R = ze(F));
      var Ce = V === S;
      if (R !== this.keyHash)
        return Ce ? this : (k(fe), k(se), i1(this, b, T, R, [F, V]));
      for (var Ue = this.entries, We = 0, tt = Ue.length; We < tt && !fr(F, Ue[We][0]); We++)
        ;
      var Ct = We < tt;
      if (Ct ? Ue[We][1] === V : Ce)
        return this;
      if (k(fe), (Ce || !Ct) && k(se), Ce && tt === 2)
        return new Pt(b, this.keyHash, Ue[We ^ 1]);
      var It = b && b === this.ownerID, Jt = It ? Ue : P(Ue);
      return Ct ? Ce ? We === tt - 1 ? Jt.pop() : Jt[We] = Jt.pop() : Jt[We] = [F, V] : Jt.push([F, V]), It ? (this.entries = Jt, this) : new gt(b, this.keyHash, Jt);
    };
    function Pt(b, T, R) {
      this.ownerID = b, this.keyHash = T, this.entry = R;
    }
    Pt.prototype.get = function(b, T, R, F) {
      return fr(R, this.entry[0]) ? this.entry[1] : F;
    }, Pt.prototype.update = function(b, T, R, F, V, se, fe) {
      var Ce = V === S, Ue = fr(F, this.entry[0]);
      if (Ue ? V === this.entry[1] : Ce)
        return this;
      if (k(fe), Ce) {
        k(se);
        return;
      }
      return Ue ? b && b === this.ownerID ? (this.entry[1] = V, this) : new Pt(b, this.keyHash, [F, V]) : (k(se), i1(this, b, T, ze(F), [F, V]));
    }, at.prototype.iterate = gt.prototype.iterate = function(b, T) {
      for (var R = this.entries, F = 0, V = R.length - 1; F <= V; F++)
        if (b(R[T ? V - F : F]) === !1)
          return !1;
    }, pt.prototype.iterate = ct.prototype.iterate = function(b, T) {
      for (var R = this.nodes, F = 0, V = R.length - 1; F <= V; F++) {
        var se = R[T ? V - F : F];
        if (se && se.iterate(b, T) === !1)
          return !1;
      }
    }, Pt.prototype.iterate = function(b, T) {
      return b(this.entry);
    }, n(Ir, j);
    function Ir(b, T, R) {
      this._type = T, this._reverse = R, this._stack = b._root && Nn(b._root);
    }
    Ir.prototype.next = function() {
      for (var b = this._type, T = this._stack; T; ) {
        var R = T.node, F = T.index++, V;
        if (R.entry) {
          if (F === 0)
            return Wr(b, R.entry);
        } else if (R.entries) {
          if (V = R.entries.length - 1, F <= V)
            return Wr(b, R.entries[this._reverse ? V - F : F]);
        } else if (V = R.nodes.length - 1, F <= V) {
          var se = R.nodes[this._reverse ? V - F : F];
          if (se) {
            if (se.entry)
              return Wr(b, se.entry);
            T = this._stack = Nn(se, T);
          }
          continue;
        }
        T = this._stack = this._stack.__prev;
      }
      return J();
    };
    function Wr(b, T) {
      return K(b, T[0], T[1]);
    }
    function Nn(b, T) {
      return {
        node: b,
        index: 0,
        __prev: T
      };
    }
    function Qo(b, T, R, F) {
      var V = Object.create(je);
      return V.size = b, V._root = T, V.__ownerID = R, V.__hash = F, V.__altered = !1, V;
    }
    var Yl;
    function La() {
      return Yl || (Yl = Qo(0));
    }
    function Gi(b, T, R) {
      var F, V;
      if (b._root) {
        var se = O(C), fe = O(E);
        if (F = eu(b._root, b.__ownerID, 0, void 0, T, R, se, fe), !fe.value)
          return b;
        V = b.size + (se.value ? R === S ? -1 : 1 : 0);
      } else {
        if (R === S)
          return b;
        V = 1, F = new at(b.__ownerID, [[T, R]]);
      }
      return b.__ownerID ? (b.size = V, b._root = F, b.__hash = void 0, b.__altered = !0, b) : F ? Qo(V, F) : La();
    }
    function eu(b, T, R, F, V, se, fe, Ce) {
      return b ? b.update(T, R, F, V, se, fe, Ce) : se === S ? b : (k(Ce), k(fe), new Pt(T, F, [V, se]));
    }
    function Gs(b) {
      return b.constructor === Pt || b.constructor === gt;
    }
    function i1(b, T, R, F, V) {
      if (b.keyHash === F)
        return new gt(T, F, [b.entry, V]);
      var se = (R === 0 ? b.keyHash : b.keyHash >>> R) & _, fe = (R === 0 ? F : F >>> R) & _, Ce, Ue = se === fe ? [i1(b, T, R + x, F, V)] : (Ce = new Pt(T, F, V), se < fe ? [b, Ce] : [Ce, b]);
      return new pt(T, 1 << se | 1 << fe, Ue);
    }
    function xz(b, T, R, F) {
      b || (b = new A());
      for (var V = new Pt(b, ze(R), [R, F]), se = 0; se < T.length; se++) {
        var fe = T[se];
        V = V.update(b, 0, void 0, fe[0], fe[1]);
      }
      return V;
    }
    function _z(b, T, R, F) {
      for (var V = 0, se = 0, fe = new Array(R), Ce = 0, Ue = 1, We = T.length; Ce < We; Ce++, Ue <<= 1) {
        var tt = T[Ce];
        tt !== void 0 && Ce !== F && (V |= Ue, fe[se++] = tt);
      }
      return new pt(b, V, fe);
    }
    function Sz(b, T, R, F, V) {
      for (var se = 0, fe = new Array(w), Ce = 0; R !== 0; Ce++, R >>>= 1)
        fe[Ce] = R & 1 ? T[se++] : void 0;
      return fe[F] = V, new ct(b, se + 1, fe);
    }
    function Pv(b, T, R) {
      for (var F = [], V = 0; V < R.length; V++) {
        var se = R[V], fe = s(se);
        l(se) || (fe = fe.map(function(Ce) {
          return Gt(Ce);
        })), F.push(fe);
      }
      return fO(b, T, F);
    }
    function uO(b, T, R) {
      return b && b.mergeDeep && l(T) ? b.mergeDeep(T) : fr(b, T) ? b : T;
    }
    function dO(b) {
      return function(T, R, F) {
        if (T && T.mergeDeepWith && l(R))
          return T.mergeDeepWith(b, R);
        var V = b(T, R, F);
        return fr(T, V) ? T : V;
      };
    }
    function fO(b, T, R) {
      return R = R.filter(function(F) {
        return F.size !== 0;
      }), R.length === 0 ? b : b.size === 0 && !b.__ownerID && R.length === 1 ? b.constructor(R[0]) : b.withMutations(function(F) {
        for (var V = T ? function(fe, Ce) {
          F.update(
            Ce,
            S,
            function(Ue) {
              return Ue === S ? fe : T(Ue, fe, Ce);
            }
          );
        } : function(fe, Ce) {
          F.set(Ce, fe);
        }, se = 0; se < R.length; se++)
          R[se].forEach(V);
      });
    }
    function hO(b, T, R, F) {
      var V = b === S, se = T.next();
      if (se.done) {
        var fe = V ? R : b, Ce = F(fe);
        return Ce === fe ? b : Ce;
      }
      Ma(
        V || b && b.set,
        "invalid keyPath"
      );
      var Ue = se.value, We = V ? S : b.get(Ue, S), tt = hO(
        We,
        T,
        R,
        F
      );
      return tt === We ? b : tt === S ? b.remove(Ue) : (V ? La() : b).set(Ue, tt);
    }
    function pO(b) {
      return b = b - (b >> 1 & 1431655765), b = (b & 858993459) + (b >> 2 & 858993459), b = b + (b >> 4) & 252645135, b = b + (b >> 8), b = b + (b >> 16), b & 127;
    }
    function mO(b, T, R, F) {
      var V = F ? b : P(b);
      return V[T] = R, V;
    }
    function Ez(b, T, R, F) {
      var V = b.length + 1;
      if (F && T + 1 === V)
        return b[T] = R, b;
      for (var se = new Array(V), fe = 0, Ce = 0; Ce < V; Ce++)
        Ce === T ? (se[Ce] = R, fe = -1) : se[Ce] = b[Ce + fe];
      return se;
    }
    function Tz(b, T, R) {
      var F = b.length - 1;
      if (R && T === F)
        return b.pop(), b;
      for (var V = new Array(F), se = 0, fe = 0; fe < F; fe++)
        fe === T && (se = 1), V[fe] = b[fe + se];
      return V;
    }
    var Cz = w / 4, kz = w / 2, Oz = w / 4;
    n(un, de);
    function un(b) {
      var T = o1();
      if (b == null)
        return T;
      if (gO(b))
        return b;
      var R = i(b), F = R.size;
      return F === 0 ? T : (Ie(F), F > 0 && F < w ? Zh(0, F, x, null, new Xl(R.toArray())) : T.withMutations(function(V) {
        V.setSize(F), R.forEach(function(se, fe) {
          return V.set(fe, se);
        });
      }));
    }
    un.of = function() {
      return this(arguments);
    }, un.prototype.toString = function() {
      return this.__toString("List [", "]");
    }, un.prototype.get = function(b, T) {
      if (b = N(this, b), b >= 0 && b < this.size) {
        b += this._origin;
        var R = wO(this, b);
        return R && R.array[b & _];
      }
      return T;
    }, un.prototype.set = function(b, T) {
      return Az(this, b, T);
    }, un.prototype.remove = function(b) {
      return this.has(b) ? b === 0 ? this.shift() : b === this.size - 1 ? this.pop() : this.splice(b, 1) : this;
    }, un.prototype.insert = function(b, T) {
      return this.splice(b, 0, T);
    }, un.prototype.clear = function() {
      return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = x, this._root = this._tail = null, this.__hash = void 0, this.__altered = !0, this) : o1();
    }, un.prototype.push = function() {
      var b = arguments, T = this.size;
      return this.withMutations(function(R) {
        Ql(R, 0, T + b.length);
        for (var F = 0; F < b.length; F++)
          R.set(T + F, b[F]);
      });
    }, un.prototype.pop = function() {
      return Ql(this, 0, -1);
    }, un.prototype.unshift = function() {
      var b = arguments;
      return this.withMutations(function(T) {
        Ql(T, -b.length);
        for (var R = 0; R < b.length; R++)
          T.set(R, b[R]);
      });
    }, un.prototype.shift = function() {
      return Ql(this, 1);
    }, un.prototype.merge = function() {
      return Rv(this, void 0, arguments);
    }, un.prototype.mergeWith = function(b) {
      var T = r.call(arguments, 1);
      return Rv(this, b, T);
    }, un.prototype.mergeDeep = function() {
      return Rv(this, uO, arguments);
    }, un.prototype.mergeDeepWith = function(b) {
      var T = r.call(arguments, 1);
      return Rv(this, dO(b), T);
    }, un.prototype.setSize = function(b) {
      return Ql(this, 0, b);
    }, un.prototype.slice = function(b, T) {
      var R = this.size;
      return G(b, T, R) ? this : Ql(
        this,
        Y(b, R),
        te(T, R)
      );
    }, un.prototype.__iterator = function(b, T) {
      var R = 0, F = yO(this, T);
      return new j(function() {
        var V = F();
        return V === Jh ? J() : K(b, R++, V);
      });
    }, un.prototype.__iterate = function(b, T) {
      for (var R = 0, F = yO(this, T), V; (V = F()) !== Jh && b(V, R++, this) !== !1; )
        ;
      return R;
    }, un.prototype.__ensureOwner = function(b) {
      return b === this.__ownerID ? this : b ? Zh(this._origin, this._capacity, this._level, this._root, this._tail, b, this.__hash) : (this.__ownerID = b, this);
    };
    function gO(b) {
      return !!(b && b[vO]);
    }
    un.isList = gO;
    var vO = "@@__IMMUTABLE_LIST__@@", es = un.prototype;
    es[vO] = !0, es[y] = es.remove, es.setIn = je.setIn, es.deleteIn = es.removeIn = je.removeIn, es.update = je.update, es.updateIn = je.updateIn, es.mergeIn = je.mergeIn, es.mergeDeepIn = je.mergeDeepIn, es.withMutations = je.withMutations, es.asMutable = je.asMutable, es.asImmutable = je.asImmutable, es.wasAltered = je.wasAltered;
    function Xl(b, T) {
      this.array = b, this.ownerID = T;
    }
    Xl.prototype.removeBefore = function(b, T, R) {
      if (R === T ? 1 << T : this.array.length === 0)
        return this;
      var F = R >>> T & _;
      if (F >= this.array.length)
        return new Xl([], b);
      var V = F === 0, se;
      if (T > 0) {
        var fe = this.array[F];
        if (se = fe && fe.removeBefore(b, T - x, R), se === fe && V)
          return this;
      }
      if (V && !se)
        return this;
      var Ce = Pd(this, b);
      if (!V)
        for (var Ue = 0; Ue < F; Ue++)
          Ce.array[Ue] = void 0;
      return se && (Ce.array[F] = se), Ce;
    }, Xl.prototype.removeAfter = function(b, T, R) {
      if (R === (T ? 1 << T : 0) || this.array.length === 0)
        return this;
      var F = R - 1 >>> T & _;
      if (F >= this.array.length)
        return this;
      var V;
      if (T > 0) {
        var se = this.array[F];
        if (V = se && se.removeAfter(b, T - x, R), V === se && F === this.array.length - 1)
          return this;
      }
      var fe = Pd(this, b);
      return fe.array.splice(F + 1), V && (fe.array[F] = V), fe;
    };
    var Jh = {};
    function yO(b, T) {
      var R = b._origin, F = b._capacity, V = ep(F), se = b._tail;
      return fe(b._root, b._level, 0);
      function fe(We, tt, Ct) {
        return tt === 0 ? Ce(We, Ct) : Ue(We, tt, Ct);
      }
      function Ce(We, tt) {
        var Ct = tt === V ? se && se.array : We && We.array, It = tt > R ? 0 : R - tt, Jt = F - tt;
        return Jt > w && (Jt = w), function() {
          if (It === Jt)
            return Jh;
          var pr = T ? --Jt : It++;
          return Ct && Ct[pr];
        };
      }
      function Ue(We, tt, Ct) {
        var It, Jt = We && We.array, pr = Ct > R ? 0 : R - Ct >> tt, bn = (F - Ct >> tt) + 1;
        return bn > w && (bn = w), function() {
          do {
            if (It) {
              var xi = It();
              if (xi !== Jh)
                return xi;
              It = null;
            }
            if (pr === bn)
              return Jh;
            var Ji = T ? --bn : pr++;
            It = fe(
              Jt && Jt[Ji],
              tt - x,
              Ct + (Ji << tt)
            );
          } while (!0);
        };
      }
    }
    function Zh(b, T, R, F, V, se, fe) {
      var Ce = Object.create(es);
      return Ce.size = T - b, Ce._origin = b, Ce._capacity = T, Ce._level = R, Ce._root = F, Ce._tail = V, Ce.__ownerID = se, Ce.__hash = fe, Ce.__altered = !1, Ce;
    }
    var bO;
    function o1() {
      return bO || (bO = Zh(0, 0, x));
    }
    function Az(b, T, R) {
      if (T = N(b, T), T !== T)
        return b;
      if (T >= b.size || T < 0)
        return b.withMutations(function(fe) {
          T < 0 ? Ql(fe, T).set(0, R) : Ql(fe, 0, T + 1).set(T, R);
        });
      T += b._origin;
      var F = b._tail, V = b._root, se = O(E);
      return T >= ep(b._capacity) ? F = l1(F, b.__ownerID, 0, T, R, se) : V = l1(V, b.__ownerID, b._level, T, R, se), se.value ? b.__ownerID ? (b._root = V, b._tail = F, b.__hash = void 0, b.__altered = !0, b) : Zh(b._origin, b._capacity, b._level, V, F) : b;
    }
    function l1(b, T, R, F, V, se) {
      var fe = F >>> R & _, Ce = b && fe < b.array.length;
      if (!Ce && V === void 0)
        return b;
      var Ue;
      if (R > 0) {
        var We = b && b.array[fe], tt = l1(We, T, R - x, F, V, se);
        return tt === We ? b : (Ue = Pd(b, T), Ue.array[fe] = tt, Ue);
      }
      return Ce && b.array[fe] === V ? b : (k(se), Ue = Pd(b, T), V === void 0 && fe === Ue.array.length - 1 ? Ue.array.pop() : Ue.array[fe] = V, Ue);
    }
    function Pd(b, T) {
      return T && b && T === b.ownerID ? b : new Xl(b ? b.array.slice() : [], T);
    }
    function wO(b, T) {
      if (T >= ep(b._capacity))
        return b._tail;
      if (T < 1 << b._level + x) {
        for (var R = b._root, F = b._level; R && F > 0; )
          R = R.array[T >>> F & _], F -= x;
        return R;
      }
    }
    function Ql(b, T, R) {
      T !== void 0 && (T = T | 0), R !== void 0 && (R = R | 0);
      var F = b.__ownerID || new A(), V = b._origin, se = b._capacity, fe = V + T, Ce = R === void 0 ? se : R < 0 ? se + R : V + R;
      if (fe === V && Ce === se)
        return b;
      if (fe >= Ce)
        return b.clear();
      for (var Ue = b._level, We = b._root, tt = 0; fe + tt < 0; )
        We = new Xl(We && We.array.length ? [void 0, We] : [], F), Ue += x, tt += 1 << Ue;
      tt && (fe += tt, V += tt, Ce += tt, se += tt);
      for (var Ct = ep(se), It = ep(Ce); It >= 1 << Ue + x; )
        We = new Xl(We && We.array.length ? [We] : [], F), Ue += x;
      var Jt = b._tail, pr = It < Ct ? wO(b, Ce - 1) : It > Ct ? new Xl([], F) : Jt;
      if (Jt && It > Ct && fe < se && Jt.array.length) {
        We = Pd(We, F);
        for (var bn = We, xi = Ue; xi > x; xi -= x) {
          var Ji = Ct >>> xi & _;
          bn = bn.array[Ji] = Pd(bn.array[Ji], F);
        }
        bn.array[Ct >>> x & _] = Jt;
      }
      if (Ce < se && (pr = pr && pr.removeAfter(F, 0, Ce)), fe >= It)
        fe -= It, Ce -= It, Ue = x, We = null, pr = pr && pr.removeBefore(F, 0, fe);
      else if (fe > V || It < Ct) {
        for (tt = 0; We; ) {
          var Fv = fe >>> Ue & _;
          if (Fv !== It >>> Ue & _)
            break;
          Fv && (tt += (1 << Ue) * Fv), Ue -= x, We = We.array[Fv];
        }
        We && fe > V && (We = We.removeBefore(F, Ue, fe - tt)), We && It < Ct && (We = We.removeAfter(F, Ue, It - tt)), tt && (fe -= tt, Ce -= tt);
      }
      return b.__ownerID ? (b.size = Ce - fe, b._origin = fe, b._capacity = Ce, b._level = Ue, b._root = We, b._tail = pr, b.__hash = void 0, b.__altered = !0, b) : Zh(fe, Ce, Ue, We, pr);
    }
    function Rv(b, T, R) {
      for (var F = [], V = 0, se = 0; se < R.length; se++) {
        var fe = R[se], Ce = i(fe);
        Ce.size > V && (V = Ce.size), l(fe) || (Ce = Ce.map(function(Ue) {
          return Gt(Ue);
        })), F.push(Ce);
      }
      return V > b.size && (b = b.setSize(V)), fO(b, T, F);
    }
    function ep(b) {
      return b < w ? 0 : b - 1 >>> x << x;
    }
    n(Mn, ge);
    function Mn(b) {
      return b == null ? Iv() : xO(b) ? b : Iv().withMutations(function(T) {
        var R = s(b);
        Ie(R.size), R.forEach(function(F, V) {
          return T.set(V, F);
        });
      });
    }
    Mn.of = function() {
      return this(arguments);
    }, Mn.prototype.toString = function() {
      return this.__toString("OrderedMap {", "}");
    }, Mn.prototype.get = function(b, T) {
      var R = this._map.get(b);
      return R !== void 0 ? this._list.get(R)[1] : T;
    }, Mn.prototype.clear = function() {
      return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this) : Iv();
    }, Mn.prototype.set = function(b, T) {
      return SO(this, b, T);
    }, Mn.prototype.remove = function(b) {
      return SO(this, b, S);
    }, Mn.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    }, Mn.prototype.__iterate = function(b, T) {
      var R = this;
      return this._list.__iterate(
        function(F) {
          return F && b(F[1], F[0], R);
        },
        T
      );
    }, Mn.prototype.__iterator = function(b, T) {
      return this._list.fromEntrySeq().__iterator(b, T);
    }, Mn.prototype.__ensureOwner = function(b) {
      if (b === this.__ownerID)
        return this;
      var T = this._map.__ensureOwner(b), R = this._list.__ensureOwner(b);
      return b ? c1(T, R, b, this.__hash) : (this.__ownerID = b, this._map = T, this._list = R, this);
    };
    function xO(b) {
      return xe(b) && f(b);
    }
    Mn.isOrderedMap = xO, Mn.prototype[g] = !0, Mn.prototype[y] = Mn.prototype.remove;
    function c1(b, T, R, F) {
      var V = Object.create(Mn.prototype);
      return V.size = b ? b.size : 0, V._map = b, V._list = T, V.__ownerID = R, V.__hash = F, V;
    }
    var _O;
    function Iv() {
      return _O || (_O = c1(La(), o1()));
    }
    function SO(b, T, R) {
      var F = b._map, V = b._list, se = F.get(T), fe = se !== void 0, Ce, Ue;
      if (R === S) {
        if (!fe)
          return b;
        V.size >= w && V.size >= F.size * 2 ? (Ue = V.filter(function(We, tt) {
          return We !== void 0 && se !== tt;
        }), Ce = Ue.toKeyedSeq().map(function(We) {
          return We[0];
        }).flip().toMap(), b.__ownerID && (Ce.__ownerID = Ue.__ownerID = b.__ownerID)) : (Ce = F.remove(T), Ue = se === V.size - 1 ? V.pop() : V.set(se, void 0));
      } else if (fe) {
        if (R === V.get(se)[1])
          return b;
        Ce = F, Ue = V.set(se, [T, R]);
      } else
        Ce = F.set(T, V.size), Ue = V.set(V.size, [T, R]);
      return b.__ownerID ? (b.size = Ce.size, b._map = Ce, b._list = Ue, b.__hash = void 0, b) : c1(Ce, Ue);
    }
    n(Ys, he);
    function Ys(b, T) {
      this._iter = b, this._useKeys = T, this.size = b.size;
    }
    Ys.prototype.get = function(b, T) {
      return this._iter.get(b, T);
    }, Ys.prototype.has = function(b) {
      return this._iter.has(b);
    }, Ys.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    }, Ys.prototype.reverse = function() {
      var b = this, T = u1(this, !0);
      return this._useKeys || (T.valueSeq = function() {
        return b._iter.toSeq().reverse();
      }), T;
    }, Ys.prototype.map = function(b, T) {
      var R = this, F = TO(this, b, T);
      return this._useKeys || (F.valueSeq = function() {
        return R._iter.toSeq().map(b, T);
      }), F;
    }, Ys.prototype.__iterate = function(b, T) {
      var R = this, F;
      return this._iter.__iterate(
        this._useKeys ? function(V, se) {
          return b(V, se, R);
        } : (F = T ? RO(this) : 0, function(V) {
          return b(V, T ? --F : F++, R);
        }),
        T
      );
    }, Ys.prototype.__iterator = function(b, T) {
      if (this._useKeys)
        return this._iter.__iterator(b, T);
      var R = this._iter.__iterator(ue, T), F = T ? RO(this) : 0;
      return new j(function() {
        var V = R.next();
        return V.done ? V : K(b, T ? --F : F++, V.value, V);
      });
    }, Ys.prototype[g] = !0, n(Rd, Ee);
    function Rd(b) {
      this._iter = b, this.size = b.size;
    }
    Rd.prototype.includes = function(b) {
      return this._iter.includes(b);
    }, Rd.prototype.__iterate = function(b, T) {
      var R = this, F = 0;
      return this._iter.__iterate(function(V) {
        return b(V, F++, R);
      }, T);
    }, Rd.prototype.__iterator = function(b, T) {
      var R = this._iter.__iterator(ue, T), F = 0;
      return new j(function() {
        var V = R.next();
        return V.done ? V : K(b, F++, V.value, V);
      });
    }, n(Id, we);
    function Id(b) {
      this._iter = b, this.size = b.size;
    }
    Id.prototype.has = function(b) {
      return this._iter.includes(b);
    }, Id.prototype.__iterate = function(b, T) {
      var R = this;
      return this._iter.__iterate(function(F) {
        return b(F, F, R);
      }, T);
    }, Id.prototype.__iterator = function(b, T) {
      var R = this._iter.__iterator(ue, T);
      return new j(function() {
        var F = R.next();
        return F.done ? F : K(b, F.value, F.value, F);
      });
    }, n(Dd, he);
    function Dd(b) {
      this._iter = b, this.size = b.size;
    }
    Dd.prototype.entrySeq = function() {
      return this._iter.toSeq();
    }, Dd.prototype.__iterate = function(b, T) {
      var R = this;
      return this._iter.__iterate(function(F) {
        if (F) {
          PO(F);
          var V = l(F);
          return b(
            V ? F.get(1) : F[1],
            V ? F.get(0) : F[0],
            R
          );
        }
      }, T);
    }, Dd.prototype.__iterator = function(b, T) {
      var R = this._iter.__iterator(ue, T);
      return new j(function() {
        for (; ; ) {
          var F = R.next();
          if (F.done)
            return F;
          var V = F.value;
          if (V) {
            PO(V);
            var se = l(V);
            return K(
              b,
              se ? V.get(0) : V[0],
              se ? V.get(1) : V[1],
              F
            );
          }
        }
      });
    }, Rd.prototype.cacheResult = Ys.prototype.cacheResult = Id.prototype.cacheResult = Dd.prototype.cacheResult = h1;
    function EO(b) {
      var T = Yi(b);
      return T._iter = b, T.size = b.size, T.flip = function() {
        return b;
      }, T.reverse = function() {
        var R = b.reverse.apply(this);
        return R.flip = function() {
          return b.reverse();
        }, R;
      }, T.has = function(R) {
        return b.includes(R);
      }, T.includes = function(R) {
        return b.has(R);
      }, T.cacheResult = h1, T.__iterateUncached = function(R, F) {
        var V = this;
        return b.__iterate(function(se, fe) {
          return R(fe, se, V) !== !1;
        }, F);
      }, T.__iteratorUncached = function(R, F) {
        if (R === q) {
          var V = b.__iterator(R, F);
          return new j(function() {
            var se = V.next();
            if (!se.done) {
              var fe = se.value[0];
              se.value[0] = se.value[1], se.value[1] = fe;
            }
            return se;
          });
        }
        return b.__iterator(
          R === ue ? ne : ue,
          F
        );
      }, T;
    }
    function TO(b, T, R) {
      var F = Yi(b);
      return F.size = b.size, F.has = function(V) {
        return b.has(V);
      }, F.get = function(V, se) {
        var fe = b.get(V, S);
        return fe === S ? se : T.call(R, fe, V, b);
      }, F.__iterateUncached = function(V, se) {
        var fe = this;
        return b.__iterate(
          function(Ce, Ue, We) {
            return V(T.call(R, Ce, Ue, We), Ue, fe) !== !1;
          },
          se
        );
      }, F.__iteratorUncached = function(V, se) {
        var fe = b.__iterator(q, se);
        return new j(function() {
          var Ce = fe.next();
          if (Ce.done)
            return Ce;
          var Ue = Ce.value, We = Ue[0];
          return K(
            V,
            We,
            T.call(R, Ue[1], We, b),
            Ce
          );
        });
      }, F;
    }
    function u1(b, T) {
      var R = Yi(b);
      return R._iter = b, R.size = b.size, R.reverse = function() {
        return b;
      }, b.flip && (R.flip = function() {
        var F = EO(b);
        return F.reverse = function() {
          return b.flip();
        }, F;
      }), R.get = function(F, V) {
        return b.get(T ? F : -1 - F, V);
      }, R.has = function(F) {
        return b.has(T ? F : -1 - F);
      }, R.includes = function(F) {
        return b.includes(F);
      }, R.cacheResult = h1, R.__iterate = function(F, V) {
        var se = this;
        return b.__iterate(function(fe, Ce) {
          return F(fe, Ce, se);
        }, !V);
      }, R.__iterator = function(F, V) {
        return b.__iterator(F, !V);
      }, R;
    }
    function CO(b, T, R, F) {
      var V = Yi(b);
      return F && (V.has = function(se) {
        var fe = b.get(se, S);
        return fe !== S && !!T.call(R, fe, se, b);
      }, V.get = function(se, fe) {
        var Ce = b.get(se, S);
        return Ce !== S && T.call(R, Ce, se, b) ? Ce : fe;
      }), V.__iterateUncached = function(se, fe) {
        var Ce = this, Ue = 0;
        return b.__iterate(function(We, tt, Ct) {
          if (T.call(R, We, tt, Ct))
            return Ue++, se(We, F ? tt : Ue - 1, Ce);
        }, fe), Ue;
      }, V.__iteratorUncached = function(se, fe) {
        var Ce = b.__iterator(q, fe), Ue = 0;
        return new j(function() {
          for (; ; ) {
            var We = Ce.next();
            if (We.done)
              return We;
            var tt = We.value, Ct = tt[0], It = tt[1];
            if (T.call(R, It, Ct, b))
              return K(se, F ? Ct : Ue++, It, We);
          }
        });
      }, V;
    }
    function Pz(b, T, R) {
      var F = ge().asMutable();
      return b.__iterate(function(V, se) {
        F.update(
          T.call(R, V, se, b),
          0,
          function(fe) {
            return fe + 1;
          }
        );
      }), F.asImmutable();
    }
    function Rz(b, T, R) {
      var F = c(b), V = (f(b) ? Mn() : ge()).asMutable();
      b.__iterate(function(fe, Ce) {
        V.update(
          T.call(R, fe, Ce, b),
          function(Ue) {
            return Ue = Ue || [], Ue.push(F ? [Ce, fe] : fe), Ue;
          }
        );
      });
      var se = IO(b);
      return V.map(function(fe) {
        return nn(b, se(fe));
      });
    }
    function d1(b, T, R, F) {
      var V = b.size;
      if (T !== void 0 && (T = T | 0), R !== void 0 && (R = R | 0), G(T, R, V))
        return b;
      var se = Y(T, V), fe = te(R, V);
      if (se !== se || fe !== fe)
        return d1(b.toSeq().cacheResult(), T, R, F);
      var Ce = fe - se, Ue;
      Ce === Ce && (Ue = Ce < 0 ? 0 : Ce);
      var We = Yi(b);
      return We.size = Ue === 0 ? Ue : b.size && Ue || void 0, !F && oe(b) && Ue >= 0 && (We.get = function(tt, Ct) {
        return tt = N(this, tt), tt >= 0 && tt < Ue ? b.get(tt + se, Ct) : Ct;
      }), We.__iterateUncached = function(tt, Ct) {
        var It = this;
        if (Ue === 0)
          return 0;
        if (Ct)
          return this.cacheResult().__iterate(tt, Ct);
        var Jt = 0, pr = !0, bn = 0;
        return b.__iterate(function(xi, Ji) {
          if (!(pr && (pr = Jt++ < se)))
            return bn++, tt(xi, F ? Ji : bn - 1, It) !== !1 && bn !== Ue;
        }), bn;
      }, We.__iteratorUncached = function(tt, Ct) {
        if (Ue !== 0 && Ct)
          return this.cacheResult().__iterator(tt, Ct);
        var It = Ue !== 0 && b.__iterator(tt, Ct), Jt = 0, pr = 0;
        return new j(function() {
          for (; Jt++ < se; )
            It.next();
          if (++pr > Ue)
            return J();
          var bn = It.next();
          return F || tt === ue ? bn : tt === ne ? K(tt, pr - 1, void 0, bn) : K(tt, pr - 1, bn.value[1], bn);
        });
      }, We;
    }
    function Iz(b, T, R) {
      var F = Yi(b);
      return F.__iterateUncached = function(V, se) {
        var fe = this;
        if (se)
          return this.cacheResult().__iterate(V, se);
        var Ce = 0;
        return b.__iterate(
          function(Ue, We, tt) {
            return T.call(R, Ue, We, tt) && ++Ce && V(Ue, We, fe);
          }
        ), Ce;
      }, F.__iteratorUncached = function(V, se) {
        var fe = this;
        if (se)
          return this.cacheResult().__iterator(V, se);
        var Ce = b.__iterator(q, se), Ue = !0;
        return new j(function() {
          if (!Ue)
            return J();
          var We = Ce.next();
          if (We.done)
            return We;
          var tt = We.value, Ct = tt[0], It = tt[1];
          return T.call(R, It, Ct, fe) ? V === q ? We : K(V, Ct, It, We) : (Ue = !1, J());
        });
      }, F;
    }
    function kO(b, T, R, F) {
      var V = Yi(b);
      return V.__iterateUncached = function(se, fe) {
        var Ce = this;
        if (fe)
          return this.cacheResult().__iterate(se, fe);
        var Ue = !0, We = 0;
        return b.__iterate(function(tt, Ct, It) {
          if (!(Ue && (Ue = T.call(R, tt, Ct, It))))
            return We++, se(tt, F ? Ct : We - 1, Ce);
        }), We;
      }, V.__iteratorUncached = function(se, fe) {
        var Ce = this;
        if (fe)
          return this.cacheResult().__iterator(se, fe);
        var Ue = b.__iterator(q, fe), We = !0, tt = 0;
        return new j(function() {
          var Ct, It, Jt;
          do {
            if (Ct = Ue.next(), Ct.done)
              return F || se === ue ? Ct : se === ne ? K(se, tt++, void 0, Ct) : K(se, tt++, Ct.value[1], Ct);
            var pr = Ct.value;
            It = pr[0], Jt = pr[1], We && (We = T.call(R, Jt, It, Ce));
          } while (We);
          return se === q ? Ct : K(se, It, Jt, Ct);
        });
      }, V;
    }
    function Dz(b, T) {
      var R = c(b), F = [b].concat(T).map(function(fe) {
        return l(fe) ? R && (fe = s(fe)) : fe = R ? Te(fe) : _e(Array.isArray(fe) ? fe : [fe]), fe;
      }).filter(function(fe) {
        return fe.size !== 0;
      });
      if (F.length === 0)
        return b;
      if (F.length === 1) {
        var V = F[0];
        if (V === b || R && c(V) || u(b) && u(V))
          return V;
      }
      var se = new rt(F);
      return R ? se = se.toKeyedSeq() : u(b) || (se = se.toSetSeq()), se = se.flatten(!0), se.size = F.reduce(
        function(fe, Ce) {
          if (fe !== void 0) {
            var Ue = Ce.size;
            if (Ue !== void 0)
              return fe + Ue;
          }
        },
        0
      ), se;
    }
    function OO(b, T, R) {
      var F = Yi(b);
      return F.__iterateUncached = function(V, se) {
        var fe = 0, Ce = !1;
        function Ue(We, tt) {
          var Ct = this;
          We.__iterate(function(It, Jt) {
            return (!T || tt < T) && l(It) ? Ue(It, tt + 1) : V(It, R ? Jt : fe++, Ct) === !1 && (Ce = !0), !Ce;
          }, se);
        }
        return Ue(b, 0), fe;
      }, F.__iteratorUncached = function(V, se) {
        var fe = b.__iterator(V, se), Ce = [], Ue = 0;
        return new j(function() {
          for (; fe; ) {
            var We = fe.next();
            if (We.done !== !1) {
              fe = Ce.pop();
              continue;
            }
            var tt = We.value;
            if (V === q && (tt = tt[1]), (!T || Ce.length < T) && l(tt))
              Ce.push(fe), fe = tt.__iterator(V, se);
            else
              return R ? We : K(V, Ue++, tt, We);
          }
          return J();
        });
      }, F;
    }
    function Nz(b, T, R) {
      var F = IO(b);
      return b.toSeq().map(
        function(V, se) {
          return F(T.call(R, V, se, b));
        }
      ).flatten(!0);
    }
    function Mz(b, T) {
      var R = Yi(b);
      return R.size = b.size && b.size * 2 - 1, R.__iterateUncached = function(F, V) {
        var se = this, fe = 0;
        return b.__iterate(
          function(Ce, Ue) {
            return (!fe || F(T, fe++, se) !== !1) && F(Ce, fe++, se) !== !1;
          },
          V
        ), fe;
      }, R.__iteratorUncached = function(F, V) {
        var se = b.__iterator(ue, V), fe = 0, Ce;
        return new j(function() {
          return (!Ce || fe % 2) && (Ce = se.next(), Ce.done) ? Ce : fe % 2 ? K(F, fe++, T) : K(F, fe++, Ce.value, Ce);
        });
      }, R;
    }
    function Nd(b, T, R) {
      T || (T = DO);
      var F = c(b), V = 0, se = b.toSeq().map(
        function(fe, Ce) {
          return [Ce, fe, V++, R ? R(fe, Ce, b) : fe];
        }
      ).toArray();
      return se.sort(function(fe, Ce) {
        return T(fe[3], Ce[3]) || fe[2] - Ce[2];
      }).forEach(
        F ? function(fe, Ce) {
          se[Ce].length = 2;
        } : function(fe, Ce) {
          se[Ce] = fe[1];
        }
      ), F ? he(se) : u(b) ? Ee(se) : we(se);
    }
    function Dv(b, T, R) {
      if (T || (T = DO), R) {
        var F = b.toSeq().map(function(V, se) {
          return [V, R(V, se, b)];
        }).reduce(function(V, se) {
          return AO(T, V[1], se[1]) ? se : V;
        });
        return F && F[0];
      } else
        return b.reduce(function(V, se) {
          return AO(T, V, se) ? se : V;
        });
    }
    function AO(b, T, R) {
      var F = b(R, T);
      return F === 0 && R !== T && (R == null || R !== R) || F > 0;
    }
    function f1(b, T, R) {
      var F = Yi(b);
      return F.size = new rt(R).map(function(V) {
        return V.size;
      }).min(), F.__iterate = function(V, se) {
        for (var fe = this.__iterator(ue, se), Ce, Ue = 0; !(Ce = fe.next()).done && V(Ce.value, Ue++, this) !== !1; )
          ;
        return Ue;
      }, F.__iteratorUncached = function(V, se) {
        var fe = R.map(
          function(We) {
            return We = a(We), pe(se ? We.reverse() : We);
          }
        ), Ce = 0, Ue = !1;
        return new j(function() {
          var We;
          return Ue || (We = fe.map(function(tt) {
            return tt.next();
          }), Ue = We.some(function(tt) {
            return tt.done;
          })), Ue ? J() : K(
            V,
            Ce++,
            T.apply(null, We.map(function(tt) {
              return tt.value;
            }))
          );
        });
      }, F;
    }
    function nn(b, T) {
      return oe(b) ? T : b.constructor(T);
    }
    function PO(b) {
      if (b !== Object(b))
        throw new TypeError("Expected [K, V] tuple: " + b);
    }
    function RO(b) {
      return Ie(b.size), D(b);
    }
    function IO(b) {
      return c(b) ? s : u(b) ? i : o;
    }
    function Yi(b) {
      return Object.create(
        (c(b) ? he : u(b) ? Ee : we).prototype
      );
    }
    function h1() {
      return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : ee.prototype.cacheResult.call(this);
    }
    function DO(b, T) {
      return b > T ? 1 : b < T ? -1 : 0;
    }
    function NO(b) {
      var T = pe(b);
      if (!T) {
        if (!Oe(b))
          throw new TypeError("Expected iterable or array-like: " + b);
        T = pe(a(b));
      }
      return T;
    }
    n(Ps, ce);
    function Ps(b, T) {
      var R, F = function(fe) {
        if (fe instanceof F)
          return fe;
        if (!(this instanceof F))
          return new F(fe);
        if (!R) {
          R = !0;
          var Ce = Object.keys(b);
          Lz(V, Ce), V.size = Ce.length, V._name = T, V._keys = Ce, V._defaultValues = b;
        }
        this._map = ge(fe);
      }, V = F.prototype = Object.create(xa);
      return V.constructor = F, F;
    }
    Ps.prototype.toString = function() {
      return this.__toString(MO(this) + " {", "}");
    }, Ps.prototype.has = function(b) {
      return this._defaultValues.hasOwnProperty(b);
    }, Ps.prototype.get = function(b, T) {
      if (!this.has(b))
        return T;
      var R = this._defaultValues[b];
      return this._map ? this._map.get(b, R) : R;
    }, Ps.prototype.clear = function() {
      if (this.__ownerID)
        return this._map && this._map.clear(), this;
      var b = this.constructor;
      return b._empty || (b._empty = Nv(this, La()));
    }, Ps.prototype.set = function(b, T) {
      if (!this.has(b))
        throw new Error('Cannot set unknown key "' + b + '" on ' + MO(this));
      var R = this._map && this._map.set(b, T);
      return this.__ownerID || R === this._map ? this : Nv(this, R);
    }, Ps.prototype.remove = function(b) {
      if (!this.has(b))
        return this;
      var T = this._map && this._map.remove(b);
      return this.__ownerID || T === this._map ? this : Nv(this, T);
    }, Ps.prototype.wasAltered = function() {
      return this._map.wasAltered();
    }, Ps.prototype.__iterator = function(b, T) {
      var R = this;
      return s(this._defaultValues).map(function(F, V) {
        return R.get(V);
      }).__iterator(b, T);
    }, Ps.prototype.__iterate = function(b, T) {
      var R = this;
      return s(this._defaultValues).map(function(F, V) {
        return R.get(V);
      }).__iterate(b, T);
    }, Ps.prototype.__ensureOwner = function(b) {
      if (b === this.__ownerID)
        return this;
      var T = this._map && this._map.__ensureOwner(b);
      return b ? Nv(this, T, b) : (this.__ownerID = b, this._map = T, this);
    };
    var xa = Ps.prototype;
    xa[y] = xa.remove, xa.deleteIn = xa.removeIn = je.removeIn, xa.merge = je.merge, xa.mergeWith = je.mergeWith, xa.mergeIn = je.mergeIn, xa.mergeDeep = je.mergeDeep, xa.mergeDeepWith = je.mergeDeepWith, xa.mergeDeepIn = je.mergeDeepIn, xa.setIn = je.setIn, xa.update = je.update, xa.updateIn = je.updateIn, xa.withMutations = je.withMutations, xa.asMutable = je.asMutable, xa.asImmutable = je.asImmutable;
    function Nv(b, T, R) {
      var F = Object.create(Object.getPrototypeOf(b));
      return F._map = T, F.__ownerID = R, F;
    }
    function MO(b) {
      return b._name || b.constructor.name || "Record";
    }
    function Lz(b, T) {
      try {
        T.forEach(jz.bind(void 0, b));
      } catch {
      }
    }
    function jz(b, T) {
      Object.defineProperty(b, T, {
        get: function() {
          return this.get(T);
        },
        set: function(R) {
          Ma(this.__ownerID, "Cannot set on an immutable record."), this.set(T, R);
        }
      });
    }
    n(yn, Ne);
    function yn(b) {
      return b == null ? g1() : p1(b) && !f(b) ? b : g1().withMutations(function(T) {
        var R = o(b);
        Ie(R.size), R.forEach(function(F) {
          return T.add(F);
        });
      });
    }
    yn.of = function() {
      return this(arguments);
    }, yn.fromKeys = function(b) {
      return this(s(b).keySeq());
    }, yn.prototype.toString = function() {
      return this.__toString("Set {", "}");
    }, yn.prototype.has = function(b) {
      return this._map.has(b);
    }, yn.prototype.add = function(b) {
      return m1(this, this._map.set(b, !0));
    }, yn.prototype.remove = function(b) {
      return m1(this, this._map.remove(b));
    }, yn.prototype.clear = function() {
      return m1(this, this._map.clear());
    }, yn.prototype.union = function() {
      var b = r.call(arguments, 0);
      return b = b.filter(function(T) {
        return T.size !== 0;
      }), b.length === 0 ? this : this.size === 0 && !this.__ownerID && b.length === 1 ? this.constructor(b[0]) : this.withMutations(function(T) {
        for (var R = 0; R < b.length; R++)
          o(b[R]).forEach(function(F) {
            return T.add(F);
          });
      });
    }, yn.prototype.intersect = function() {
      var b = r.call(arguments, 0);
      if (b.length === 0)
        return this;
      b = b.map(function(R) {
        return o(R);
      });
      var T = this;
      return this.withMutations(function(R) {
        T.forEach(function(F) {
          b.every(function(V) {
            return V.includes(F);
          }) || R.remove(F);
        });
      });
    }, yn.prototype.subtract = function() {
      var b = r.call(arguments, 0);
      if (b.length === 0)
        return this;
      b = b.map(function(R) {
        return o(R);
      });
      var T = this;
      return this.withMutations(function(R) {
        T.forEach(function(F) {
          b.some(function(V) {
            return V.includes(F);
          }) && R.remove(F);
        });
      });
    }, yn.prototype.merge = function() {
      return this.union.apply(this, arguments);
    }, yn.prototype.mergeWith = function(b) {
      var T = r.call(arguments, 1);
      return this.union.apply(this, T);
    }, yn.prototype.sort = function(b) {
      return Xi(Nd(this, b));
    }, yn.prototype.sortBy = function(b, T) {
      return Xi(Nd(this, T, b));
    }, yn.prototype.wasAltered = function() {
      return this._map.wasAltered();
    }, yn.prototype.__iterate = function(b, T) {
      var R = this;
      return this._map.__iterate(function(F, V) {
        return b(V, V, R);
      }, T);
    }, yn.prototype.__iterator = function(b, T) {
      return this._map.map(function(R, F) {
        return F;
      }).__iterator(b, T);
    }, yn.prototype.__ensureOwner = function(b) {
      if (b === this.__ownerID)
        return this;
      var T = this._map.__ensureOwner(b);
      return b ? this.__make(T, b) : (this.__ownerID = b, this._map = T, this);
    };
    function p1(b) {
      return !!(b && b[LO]);
    }
    yn.isSet = p1;
    var LO = "@@__IMMUTABLE_SET__@@", Rs = yn.prototype;
    Rs[LO] = !0, Rs[y] = Rs.remove, Rs.mergeDeep = Rs.merge, Rs.mergeDeepWith = Rs.mergeWith, Rs.withMutations = je.withMutations, Rs.asMutable = je.asMutable, Rs.asImmutable = je.asImmutable, Rs.__empty = g1, Rs.__make = jO;
    function m1(b, T) {
      return b.__ownerID ? (b.size = T.size, b._map = T, b) : T === b._map ? b : T.size === 0 ? b.__empty() : b.__make(T);
    }
    function jO(b, T) {
      var R = Object.create(Rs);
      return R.size = b ? b.size : 0, R._map = b, R.__ownerID = T, R;
    }
    var FO;
    function g1() {
      return FO || (FO = jO(La()));
    }
    n(Xi, yn);
    function Xi(b) {
      return b == null ? v1() : BO(b) ? b : v1().withMutations(function(T) {
        var R = o(b);
        Ie(R.size), R.forEach(function(F) {
          return T.add(F);
        });
      });
    }
    Xi.of = function() {
      return this(arguments);
    }, Xi.fromKeys = function(b) {
      return this(s(b).keySeq());
    }, Xi.prototype.toString = function() {
      return this.__toString("OrderedSet {", "}");
    };
    function BO(b) {
      return p1(b) && f(b);
    }
    Xi.isOrderedSet = BO;
    var Mv = Xi.prototype;
    Mv[g] = !0, Mv.__empty = v1, Mv.__make = UO;
    function UO(b, T) {
      var R = Object.create(Mv);
      return R.size = b ? b.size : 0, R._map = b, R.__ownerID = T, R;
    }
    var VO;
    function v1() {
      return VO || (VO = UO(Iv()));
    }
    n(Kn, de);
    function Kn(b) {
      return b == null ? y1() : $O(b) ? b : y1().unshiftAll(b);
    }
    Kn.of = function() {
      return this(arguments);
    }, Kn.prototype.toString = function() {
      return this.__toString("Stack [", "]");
    }, Kn.prototype.get = function(b, T) {
      var R = this._head;
      for (b = N(this, b); R && b--; )
        R = R.next;
      return R ? R.value : T;
    }, Kn.prototype.peek = function() {
      return this._head && this._head.value;
    }, Kn.prototype.push = function() {
      if (arguments.length === 0)
        return this;
      for (var b = this.size + arguments.length, T = this._head, R = arguments.length - 1; R >= 0; R--)
        T = {
          value: arguments[R],
          next: T
        };
      return this.__ownerID ? (this.size = b, this._head = T, this.__hash = void 0, this.__altered = !0, this) : tp(b, T);
    }, Kn.prototype.pushAll = function(b) {
      if (b = i(b), b.size === 0)
        return this;
      Ie(b.size);
      var T = this.size, R = this._head;
      return b.reverse().forEach(function(F) {
        T++, R = {
          value: F,
          next: R
        };
      }), this.__ownerID ? (this.size = T, this._head = R, this.__hash = void 0, this.__altered = !0, this) : tp(T, R);
    }, Kn.prototype.pop = function() {
      return this.slice(1);
    }, Kn.prototype.unshift = function() {
      return this.push.apply(this, arguments);
    }, Kn.prototype.unshiftAll = function(b) {
      return this.pushAll(b);
    }, Kn.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    }, Kn.prototype.clear = function() {
      return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : y1();
    }, Kn.prototype.slice = function(b, T) {
      if (G(b, T, this.size))
        return this;
      var R = Y(b, this.size), F = te(T, this.size);
      if (F !== this.size)
        return de.prototype.slice.call(this, b, T);
      for (var V = this.size - R, se = this._head; R--; )
        se = se.next;
      return this.__ownerID ? (this.size = V, this._head = se, this.__hash = void 0, this.__altered = !0, this) : tp(V, se);
    }, Kn.prototype.__ensureOwner = function(b) {
      return b === this.__ownerID ? this : b ? tp(this.size, this._head, b, this.__hash) : (this.__ownerID = b, this.__altered = !1, this);
    }, Kn.prototype.__iterate = function(b, T) {
      if (T)
        return this.reverse().__iterate(b);
      for (var R = 0, F = this._head; F && b(F.value, R++, this) !== !1; )
        F = F.next;
      return R;
    }, Kn.prototype.__iterator = function(b, T) {
      if (T)
        return this.reverse().__iterator(b);
      var R = 0, F = this._head;
      return new j(function() {
        if (F) {
          var V = F.value;
          return F = F.next, K(b, R++, V);
        }
        return J();
      });
    };
    function $O(b) {
      return !!(b && b[HO]);
    }
    Kn.isStack = $O;
    var HO = "@@__IMMUTABLE_STACK__@@", Md = Kn.prototype;
    Md[HO] = !0, Md.withMutations = je.withMutations, Md.asMutable = je.asMutable, Md.asImmutable = je.asImmutable, Md.wasAltered = je.wasAltered;
    function tp(b, T, R, F) {
      var V = Object.create(Md);
      return V.size = b, V._head = T, V.__ownerID = R, V.__hash = F, V.__altered = !1, V;
    }
    var WO;
    function y1() {
      return WO || (WO = tp(0));
    }
    function Qi(b, T) {
      var R = function(F) {
        b.prototype[F] = T[F];
      };
      return Object.keys(T).forEach(R), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(T).forEach(R), b;
    }
    a.Iterator = j, Qi(a, {
      // ### Conversion to other types
      toArray: function() {
        Ie(this.size);
        var b = new Array(this.size || 0);
        return this.valueSeq().__iterate(function(T, R) {
          b[R] = T;
        }), b;
      },
      toIndexedSeq: function() {
        return new Rd(this);
      },
      toJS: function() {
        return this.toSeq().map(
          function(b) {
            return b && typeof b.toJS == "function" ? b.toJS() : b;
          }
        ).__toJS();
      },
      toJSON: function() {
        return this.toSeq().map(
          function(b) {
            return b && typeof b.toJSON == "function" ? b.toJSON() : b;
          }
        ).__toJS();
      },
      toKeyedSeq: function() {
        return new Ys(this, !0);
      },
      toMap: function() {
        return ge(this.toKeyedSeq());
      },
      toObject: function() {
        Ie(this.size);
        var b = {};
        return this.__iterate(function(T, R) {
          b[R] = T;
        }), b;
      },
      toOrderedMap: function() {
        return Mn(this.toKeyedSeq());
      },
      toOrderedSet: function() {
        return Xi(c(this) ? this.valueSeq() : this);
      },
      toSet: function() {
        return yn(c(this) ? this.valueSeq() : this);
      },
      toSetSeq: function() {
        return new Id(this);
      },
      toSeq: function() {
        return u(this) ? this.toIndexedSeq() : c(this) ? this.toKeyedSeq() : this.toSetSeq();
      },
      toStack: function() {
        return Kn(c(this) ? this.valueSeq() : this);
      },
      toList: function() {
        return un(c(this) ? this.valueSeq() : this);
      },
      // ### Common JavaScript methods and properties
      toString: function() {
        return "[Iterable]";
      },
      __toString: function(b, T) {
        return this.size === 0 ? b + T : b + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + T;
      },
      // ### ES6 Collection methods (ES6 Array and Map)
      concat: function() {
        var b = r.call(arguments, 0);
        return nn(this, Dz(this, b));
      },
      includes: function(b) {
        return this.some(function(T) {
          return fr(T, b);
        });
      },
      entries: function() {
        return this.__iterator(q);
      },
      every: function(b, T) {
        Ie(this.size);
        var R = !0;
        return this.__iterate(function(F, V, se) {
          if (!b.call(T, F, V, se))
            return R = !1, !1;
        }), R;
      },
      filter: function(b, T) {
        return nn(this, CO(this, b, T, !0));
      },
      find: function(b, T, R) {
        var F = this.findEntry(b, T);
        return F ? F[1] : R;
      },
      findEntry: function(b, T) {
        var R;
        return this.__iterate(function(F, V, se) {
          if (b.call(T, F, V, se))
            return R = [V, F], !1;
        }), R;
      },
      findLastEntry: function(b, T) {
        return this.toSeq().reverse().findEntry(b, T);
      },
      forEach: function(b, T) {
        return Ie(this.size), this.__iterate(T ? b.bind(T) : b);
      },
      join: function(b) {
        Ie(this.size), b = b !== void 0 ? "" + b : ",";
        var T = "", R = !0;
        return this.__iterate(function(F) {
          R ? R = !1 : T += b, T += F != null ? F.toString() : "";
        }), T;
      },
      keys: function() {
        return this.__iterator(ne);
      },
      map: function(b, T) {
        return nn(this, TO(this, b, T));
      },
      reduce: function(b, T, R) {
        Ie(this.size);
        var F, V;
        return arguments.length < 2 ? V = !0 : F = T, this.__iterate(function(se, fe, Ce) {
          V ? (V = !1, F = se) : F = b.call(R, F, se, fe, Ce);
        }), F;
      },
      reduceRight: function(b, T, R) {
        var F = this.toKeyedSeq().reverse();
        return F.reduce.apply(F, arguments);
      },
      reverse: function() {
        return nn(this, u1(this, !0));
      },
      slice: function(b, T) {
        return nn(this, d1(this, b, T, !0));
      },
      some: function(b, T) {
        return !this.every(jv(b), T);
      },
      sort: function(b) {
        return nn(this, Nd(this, b));
      },
      values: function() {
        return this.__iterator(ue);
      },
      // ### More sequential methods
      butLast: function() {
        return this.slice(0, -1);
      },
      isEmpty: function() {
        return this.size !== void 0 ? this.size === 0 : !this.some(function() {
          return !0;
        });
      },
      count: function(b, T) {
        return D(
          b ? this.toSeq().filter(b, T) : this
        );
      },
      countBy: function(b, T) {
        return Pz(this, b, T);
      },
      equals: function(b) {
        return ca(this, b);
      },
      entrySeq: function() {
        var b = this;
        if (b._cache)
          return new rt(b._cache);
        var T = b.toSeq().map(Bz).toIndexedSeq();
        return T.fromEntrySeq = function() {
          return b.toSeq();
        }, T;
      },
      filterNot: function(b, T) {
        return this.filter(jv(b), T);
      },
      findLast: function(b, T, R) {
        return this.toKeyedSeq().reverse().find(b, T, R);
      },
      first: function() {
        return this.find(z);
      },
      flatMap: function(b, T) {
        return nn(this, Nz(this, b, T));
      },
      flatten: function(b) {
        return nn(this, OO(this, b, !0));
      },
      fromEntrySeq: function() {
        return new Dd(this);
      },
      get: function(b, T) {
        return this.find(function(R, F) {
          return fr(F, b);
        }, void 0, T);
      },
      getIn: function(b, T) {
        for (var R = this, F = NO(b), V; !(V = F.next()).done; ) {
          var se = V.value;
          if (R = R && R.get ? R.get(se, S) : S, R === S)
            return T;
        }
        return R;
      },
      groupBy: function(b, T) {
        return Rz(this, b, T);
      },
      has: function(b) {
        return this.get(b, S) !== S;
      },
      hasIn: function(b) {
        return this.getIn(b, S) !== S;
      },
      isSubset: function(b) {
        return b = typeof b.includes == "function" ? b : a(b), this.every(function(T) {
          return b.includes(T);
        });
      },
      isSuperset: function(b) {
        return b = typeof b.isSubset == "function" ? b : a(b), b.isSubset(this);
      },
      keySeq: function() {
        return this.toSeq().map(Fz).toIndexedSeq();
      },
      last: function() {
        return this.toSeq().reverse().first();
      },
      max: function(b) {
        return Dv(this, b);
      },
      maxBy: function(b, T) {
        return Dv(this, T, b);
      },
      min: function(b) {
        return Dv(this, b ? zO(b) : qO);
      },
      minBy: function(b, T) {
        return Dv(this, T ? zO(T) : qO, b);
      },
      rest: function() {
        return this.slice(1);
      },
      skip: function(b) {
        return this.slice(Math.max(0, b));
      },
      skipLast: function(b) {
        return nn(this, this.toSeq().reverse().skip(b).reverse());
      },
      skipWhile: function(b, T) {
        return nn(this, kO(this, b, T, !0));
      },
      skipUntil: function(b, T) {
        return this.skipWhile(jv(b), T);
      },
      sortBy: function(b, T) {
        return nn(this, Nd(this, T, b));
      },
      take: function(b) {
        return this.slice(0, Math.max(0, b));
      },
      takeLast: function(b) {
        return nn(this, this.toSeq().reverse().take(b).reverse());
      },
      takeWhile: function(b, T) {
        return nn(this, Iz(this, b, T));
      },
      takeUntil: function(b, T) {
        return this.takeWhile(jv(b), T);
      },
      valueSeq: function() {
        return this.toIndexedSeq();
      },
      // ### Hashable Object
      hashCode: function() {
        return this.__hash || (this.__hash = Vz(this));
      }
      // ### Internal
      // abstract __iterate(fn, reverse)
      // abstract __iterator(type, reverse)
    });
    var ja = a.prototype;
    ja[h] = !0, ja[L] = ja.values, ja.__toJS = ja.toArray, ja.__toStringMapper = KO, ja.inspect = ja.toSource = function() {
      return this.toString();
    }, ja.chain = ja.flatMap, ja.contains = ja.includes, function() {
      try {
        Object.defineProperty(ja, "length", {
          get: function() {
            if (!a.noLengthWarning) {
              var b;
              try {
                throw new Error();
              } catch (T) {
                b = T.stack;
              }
              if (b.indexOf("_wrapObject") === -1)
                return console && console.warn && console.warn(
                  "iterable.length has been deprecated, use iterable.size or iterable.count(). This warning will become a silent error in a future version. " + b
                ), this.size;
            }
          }
        });
      } catch {
      }
    }(), Qi(s, {
      // ### More sequential methods
      flip: function() {
        return nn(this, EO(this));
      },
      findKey: function(b, T) {
        var R = this.findEntry(b, T);
        return R && R[0];
      },
      findLastKey: function(b, T) {
        return this.toSeq().reverse().findKey(b, T);
      },
      keyOf: function(b) {
        return this.findKey(function(T) {
          return fr(T, b);
        });
      },
      lastKeyOf: function(b) {
        return this.findLastKey(function(T) {
          return fr(T, b);
        });
      },
      mapEntries: function(b, T) {
        var R = this, F = 0;
        return nn(
          this,
          this.toSeq().map(
            function(V, se) {
              return b.call(T, [se, V], F++, R);
            }
          ).fromEntrySeq()
        );
      },
      mapKeys: function(b, T) {
        var R = this;
        return nn(
          this,
          this.toSeq().flip().map(
            function(F, V) {
              return b.call(T, F, V, R);
            }
          ).flip()
        );
      }
    });
    var Lv = s.prototype;
    Lv[p] = !0, Lv[L] = ja.entries, Lv.__toJS = ja.toObject, Lv.__toStringMapper = function(b, T) {
      return JSON.stringify(T) + ": " + KO(b);
    }, Qi(i, {
      // ### Conversion to other types
      toKeyedSeq: function() {
        return new Ys(this, !1);
      },
      // ### ES6 Collection methods (ES6 Array and Map)
      filter: function(b, T) {
        return nn(this, CO(this, b, T, !1));
      },
      findIndex: function(b, T) {
        var R = this.findEntry(b, T);
        return R ? R[0] : -1;
      },
      indexOf: function(b) {
        var T = this.toKeyedSeq().keyOf(b);
        return T === void 0 ? -1 : T;
      },
      lastIndexOf: function(b) {
        var T = this.toKeyedSeq().reverse().keyOf(b);
        return T === void 0 ? -1 : T;
      },
      reverse: function() {
        return nn(this, u1(this, !1));
      },
      slice: function(b, T) {
        return nn(this, d1(this, b, T, !1));
      },
      splice: function(b, T) {
        var R = arguments.length;
        if (T = Math.max(T | 0, 0), R === 0 || R === 2 && !T)
          return this;
        b = Y(b, b < 0 ? this.count() : this.size);
        var F = this.slice(0, b);
        return nn(
          this,
          R === 1 ? F : F.concat(P(arguments, 2), this.slice(b + T))
        );
      },
      // ### More collection methods
      findLastIndex: function(b, T) {
        var R = this.toKeyedSeq().findLastKey(b, T);
        return R === void 0 ? -1 : R;
      },
      first: function() {
        return this.get(0);
      },
      flatten: function(b) {
        return nn(this, OO(this, b, !1));
      },
      get: function(b, T) {
        return b = N(this, b), b < 0 || this.size === 1 / 0 || this.size !== void 0 && b > this.size ? T : this.find(function(R, F) {
          return F === b;
        }, void 0, T);
      },
      has: function(b) {
        return b = N(this, b), b >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || b < this.size : this.indexOf(b) !== -1);
      },
      interpose: function(b) {
        return nn(this, Mz(this, b));
      },
      interleave: function() {
        var b = [this].concat(P(arguments)), T = f1(this.toSeq(), Ee.of, b), R = T.flatten(!0);
        return T.size && (R.size = T.size * b.length), nn(this, R);
      },
      last: function() {
        return this.get(-1);
      },
      skipWhile: function(b, T) {
        return nn(this, kO(this, b, T, !1));
      },
      zip: function() {
        var b = [this].concat(P(arguments));
        return nn(this, f1(this, Uz, b));
      },
      zipWith: function(b) {
        var T = P(arguments);
        return T[0] = this, nn(this, f1(this, b, T));
      }
    }), i.prototype[m] = !0, i.prototype[g] = !0, Qi(o, {
      // ### ES6 Collection methods (ES6 Array and Map)
      get: function(b, T) {
        return this.has(b) ? b : T;
      },
      includes: function(b) {
        return this.has(b);
      },
      // ### More sequential methods
      keySeq: function() {
        return this.valueSeq();
      }
    }), o.prototype.has = ja.includes, Qi(he, s.prototype), Qi(Ee, i.prototype), Qi(we, o.prototype), Qi(ce, s.prototype), Qi(de, i.prototype), Qi(Ne, o.prototype);
    function Fz(b, T) {
      return T;
    }
    function Bz(b, T) {
      return [T, b];
    }
    function jv(b) {
      return function() {
        return !b.apply(this, arguments);
      };
    }
    function zO(b) {
      return function() {
        return -b.apply(this, arguments);
      };
    }
    function KO(b) {
      return typeof b == "string" ? JSON.stringify(b) : b;
    }
    function Uz() {
      return P(arguments);
    }
    function qO(b, T) {
      return b < T ? 1 : b > T ? -1 : 0;
    }
    function Vz(b) {
      if (b.size === 1 / 0)
        return 0;
      var T = f(b), R = c(b), F = T ? 1 : 0, V = b.__iterate(
        R ? T ? function(se, fe) {
          F = 31 * F + GO(ze(se), ze(fe)) | 0;
        } : function(se, fe) {
          F = F + GO(ze(se), ze(fe)) | 0;
        } : T ? function(se) {
          F = 31 * F + ze(se) | 0;
        } : function(se) {
          F = F + ze(se) | 0;
        }
      );
      return $z(V, F);
    }
    function $z(b, T) {
      return T = Le(T, 3432918353), T = Le(T << 15 | T >>> -15, 461845907), T = Le(T << 13 | T >>> -13, 5), T = (T + 3864292196 | 0) ^ b, T = Le(T ^ T >>> 16, 2246822507), T = Le(T ^ T >>> 13, 3266489909), T = $e(T ^ T >>> 16), T;
    }
    function GO(b, T) {
      return b ^ T + 2654435769 + (b << 6) + (b >> 2) | 0;
    }
    var Hz = {
      Iterable: a,
      Seq: ee,
      Collection: na,
      Map: ge,
      OrderedMap: Mn,
      List: un,
      Stack: Kn,
      Set: yn,
      OrderedSet: Xi,
      Record: Ps,
      Range: Hr,
      Repeat: en,
      is: fr,
      fromJS: Gt
    };
    return Hz;
  });
})(GB);
var Tr = GB.exports, r1e = Tr, n1e = r1e.OrderedMap, a1e = {
  createFromArray: function(t) {
    return n1e(t.map(function(r) {
      return [r.getKey(), r];
    }));
  }
}, Fg = a1e;
function s1e(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
var ik = Tr, jE = ik.Map, FE = ik.OrderedSet, i1e = ik.Record, YB = FE(), XB = {
  style: YB,
  entity: null
}, o1e = i1e(XB), ok = /* @__PURE__ */ function(e) {
  s1e(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var r = t.prototype;
  return r.getStyle = function() {
    return this.get("style");
  }, r.getEntity = function() {
    return this.get("entity");
  }, r.hasStyle = function(a) {
    return this.getStyle().includes(a);
  }, t.applyStyle = function(a, s) {
    var i = a.set("style", a.getStyle().add(s));
    return t.create(i);
  }, t.removeStyle = function(a, s) {
    var i = a.set("style", a.getStyle().remove(s));
    return t.create(i);
  }, t.applyEntity = function(a, s) {
    var i = a.getEntity() === s ? a : a.set("entity", s);
    return t.create(i);
  }, t.create = function(a) {
    if (!a)
      return lk;
    var s = {
      style: YB,
      entity: null
    }, i = jE(s).merge(a), o = d_.get(i);
    if (o)
      return o;
    var l = new t(i);
    return d_ = d_.set(i, l), l;
  }, t.fromJS = function(a) {
    var s = a.style, i = a.entity;
    return new t({
      style: Array.isArray(s) ? FE(s) : s,
      entity: Array.isArray(i) ? FE(i) : i
    });
  }, t;
}(o1e), lk = new ok(), d_ = jE([[jE(XB), lk]]);
ok.EMPTY = lk;
var gi = ok;
function l1e(e, t, r, n) {
  if (e.size) {
    var a = 0;
    e.reduce(function(s, i, o) {
      return t(s, i) || (r(s) && n(a, o), a = o), i;
    }), r(e.last()) && n(a, e.count());
  }
}
var Bg = l1e;
function c1e(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
var u1e = gi, yI = Bg, Ug = Tr, QB = Ug.List, d1e = Ug.Map, f1e = Ug.OrderedSet, h1e = Ug.Record, p1e = Ug.Repeat, m1e = f1e(), g1e = {
  key: "",
  type: "unstyled",
  text: "",
  characterList: QB(),
  depth: 0,
  data: d1e()
}, v1e = h1e(g1e), y1e = function(t) {
  if (!t)
    return t;
  var r = t.characterList, n = t.text;
  return n && !r && (t.characterList = QB(p1e(u1e.EMPTY, n.length))), t;
}, b1e = /* @__PURE__ */ function(e) {
  c1e(t, e);
  function t(n) {
    return e.call(this, y1e(n)) || this;
  }
  var r = t.prototype;
  return r.getKey = function() {
    return this.get("key");
  }, r.getType = function() {
    return this.get("type");
  }, r.getText = function() {
    return this.get("text");
  }, r.getCharacterList = function() {
    return this.get("characterList");
  }, r.getLength = function() {
    return this.getText().length;
  }, r.getDepth = function() {
    return this.get("depth");
  }, r.getData = function() {
    return this.get("data");
  }, r.getInlineStyleAt = function(a) {
    var s = this.getCharacterList().get(a);
    return s ? s.getStyle() : m1e;
  }, r.getEntityAt = function(a) {
    var s = this.getCharacterList().get(a);
    return s ? s.getEntity() : null;
  }, r.findStyleRanges = function(a, s) {
    yI(this.getCharacterList(), w1e, a, s);
  }, r.findEntityRanges = function(a, s) {
    yI(this.getCharacterList(), x1e, a, s);
  }, t;
}(v1e);
function w1e(e, t) {
  return e.getStyle() === t.getStyle();
}
function x1e(e, t) {
  return e.getEntity() === t.getEntity();
}
var cd = b1e;
function _1e(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
var S1e = gi, bI = Bg, Vg = Tr, BE = Vg.List, E1e = Vg.Map, T1e = Vg.OrderedSet, C1e = Vg.Record, k1e = Vg.Repeat, O1e = T1e(), wI = {
  parent: null,
  characterList: BE(),
  data: E1e(),
  depth: 0,
  key: "",
  text: "",
  type: "unstyled",
  children: BE(),
  prevSibling: null,
  nextSibling: null
}, A1e = function(t, r) {
  return t.getStyle() === r.getStyle();
}, P1e = function(t, r) {
  return t.getEntity() === r.getEntity();
}, R1e = function(t) {
  if (!t)
    return t;
  var r = t.characterList, n = t.text;
  return n && !r && (t.characterList = BE(k1e(S1e.EMPTY, n.length))), t;
}, I1e = /* @__PURE__ */ function(e) {
  _1e(t, e);
  function t() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : wI;
    return e.call(this, R1e(n)) || this;
  }
  var r = t.prototype;
  return r.getKey = function() {
    return this.get("key");
  }, r.getType = function() {
    return this.get("type");
  }, r.getText = function() {
    return this.get("text");
  }, r.getCharacterList = function() {
    return this.get("characterList");
  }, r.getLength = function() {
    return this.getText().length;
  }, r.getDepth = function() {
    return this.get("depth");
  }, r.getData = function() {
    return this.get("data");
  }, r.getInlineStyleAt = function(a) {
    var s = this.getCharacterList().get(a);
    return s ? s.getStyle() : O1e;
  }, r.getEntityAt = function(a) {
    var s = this.getCharacterList().get(a);
    return s ? s.getEntity() : null;
  }, r.getChildKeys = function() {
    return this.get("children");
  }, r.getParentKey = function() {
    return this.get("parent");
  }, r.getPrevSiblingKey = function() {
    return this.get("prevSibling");
  }, r.getNextSiblingKey = function() {
    return this.get("nextSibling");
  }, r.findStyleRanges = function(a, s) {
    bI(this.getCharacterList(), A1e, a, s);
  }, r.findEntityRanges = function(a, s) {
    bI(this.getCharacterList(), P1e, a, s);
  }, t;
}(C1e(wI)), vi = I1e, xI = gi, D1e = Tr, N1e = D1e.Map, M1e = {
  add: function(t, r, n) {
    return _I(t, r, n, !0);
  },
  remove: function(t, r, n) {
    return _I(t, r, n, !1);
  }
};
function _I(e, t, r, n) {
  var a = e.getBlockMap(), s = t.getStartKey(), i = t.getStartOffset(), o = t.getEndKey(), l = t.getEndOffset(), c = a.skipUntil(function(u, d) {
    return d === s;
  }).takeUntil(function(u, d) {
    return d === o;
  }).concat(N1e([[o, a.get(o)]])).map(function(u, d) {
    var f, h;
    s === o ? (f = i, h = l) : (f = d === s ? i : 0, h = d === o ? l : u.getLength());
    for (var p = u.getCharacterList(), m; f < h; )
      m = p.get(f), p = p.set(f, n ? xI.applyStyle(m, r) : xI.removeStyle(m, r)), f++;
    return u.set("characterList", p);
  });
  return e.merge({
    blockMap: a.merge(c),
    selectionBefore: t,
    selectionAfter: t
  });
}
var L1e = M1e, j1e = gi;
function F1e(e, t, r, n) {
  for (var a = t, s = e.getCharacterList(); a < r; )
    s = s.set(a, j1e.applyEntity(s.get(a), n)), a++;
  return e.set("characterList", s);
}
var B1e = F1e, U1e = B1e, V1e = Tr;
function $1e(e, t, r) {
  var n = e.getBlockMap(), a = t.getStartKey(), s = t.getStartOffset(), i = t.getEndKey(), o = t.getEndOffset(), l = n.skipUntil(function(c, u) {
    return u === a;
  }).takeUntil(function(c, u) {
    return u === i;
  }).toOrderedMap().merge(V1e.OrderedMap([[i, n.get(i)]])).map(function(c, u) {
    var d = u === a ? s : 0, f = u === i ? o : c.getLength();
    return U1e(c, d, f, r);
  });
  return e.merge({
    blockMap: n.merge(l),
    selectionBefore: t,
    selectionAfter: t
  });
}
var H1e = $1e, W1e = {
  getRemovalRange: function(t, r, n, a, s) {
    var i = n.split(" ");
    i = i.map(function(g, y) {
      if (s === "forward") {
        if (y > 0)
          return " " + g;
      } else if (y < i.length - 1)
        return g + " ";
      return g;
    });
    for (var o = a, l, c, u = null, d = null, f = 0; f < i.length; f++) {
      if (c = i[f], l = o + c.length, t < l && o < r)
        u !== null || (u = o), d = l;
      else if (u !== null)
        break;
      o = l;
    }
    var h = a + n.length, p = u === a, m = d === h;
    return (!p && m || p && !m) && (s === "forward" ? d !== h && d++ : u !== a && u--), {
      start: u,
      end: d
    };
  }
}, z1e = W1e, K1e = {}, q1e = K1e.NODE_ENV !== "production" ? function(e) {
  if (e === void 0)
    throw new Error("invariant(...): Second argument must be a string.");
} : function(e) {
};
function G1e(e, t) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    n[a - 2] = arguments[a];
  if (q1e(t), !e) {
    var s;
    if (t === void 0)
      s = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var i = 0;
      s = new Error(t.replace(/%s/g, function() {
        return String(n[i++]);
      })), s.name = "Invariant Violation";
    }
    throw s.framesToPop = 1, s;
  }
}
var jr = G1e, Y1e = {}, SI = jr;
function X1e(e, t) {
  var r = [];
  return e.findEntityRanges(function(n) {
    return n.getEntity() === t;
  }, function(n, a) {
    r.push({
      start: n,
      end: a
    });
  }), r.length || (Y1e.NODE_ENV !== "production" ? SI(!1, "Entity key not found in this range.") : SI(!1)), r;
}
var Q1e = X1e, J1e = {}, Z1e = z1e, e_e = Q1e, EI = jr;
function t_e(e, t, r, n, a) {
  var s = n.getStartOffset(), i = n.getEndOffset(), o = t.getEntityAt(s), l = r.getEntityAt(i - 1);
  if (!o && !l)
    return n;
  var c = n;
  if (o && o === l)
    c = gp(e, t, c, a, o, !0, !0);
  else if (o && l) {
    var u = gp(e, t, c, a, o, !1, !0), d = gp(e, r, c, a, l, !1, !1);
    c = c.merge({
      anchorOffset: u.getAnchorOffset(),
      focusOffset: d.getFocusOffset(),
      isBackward: !1
    });
  } else if (o) {
    var f = gp(e, t, c, a, o, !1, !0);
    c = c.merge({
      anchorOffset: f.getStartOffset(),
      isBackward: !1
    });
  } else if (l) {
    var h = gp(e, r, c, a, l, !1, !1);
    c = c.merge({
      focusOffset: h.getEndOffset(),
      isBackward: !1
    });
  }
  return c;
}
function gp(e, t, r, n, a, s, i) {
  var o = r.getStartOffset(), l = r.getEndOffset(), c = e.__get(a), u = c.getMutability(), d = i ? o : l;
  if (u === "MUTABLE")
    return r;
  var f = e_e(t, a).filter(function(m) {
    return d <= m.end && d >= m.start;
  });
  f.length != 1 && (J1e.NODE_ENV !== "production" ? EI(!1, "There should only be one entity range within this removal range.") : EI(!1));
  var h = f[0];
  if (u === "IMMUTABLE")
    return r.merge({
      anchorOffset: h.start,
      focusOffset: h.end,
      isBackward: !1
    });
  s || (i ? l = h.end : o = h.start);
  var p = Z1e.getRemovalRange(o, l, t.getText().slice(h.start, h.end), h.start, n);
  return r.merge({
    anchorOffset: p.start,
    focusOffset: p.end,
    isBackward: !1
  });
}
var r_e = t_e, TI = {}, n_e = Math.pow(2, 24);
function a_e() {
  for (var e; e === void 0 || TI.hasOwnProperty(e) || !isNaN(+e); )
    e = Math.floor(Math.random() * n_e).toString(32);
  return TI[e] = !0, e;
}
var Wo = a_e, s_e = vi, JB = Wo, i_e = Tr, ZB = i_e.OrderedMap, o_e = function(t) {
  var r = {}, n;
  return ZB(t.withMutations(function(a) {
    a.forEach(function(s, i) {
      var o = s.getKey(), l = s.getNextSiblingKey(), c = s.getPrevSiblingKey(), u = s.getChildKeys(), d = s.getParentKey(), f = JB();
      if (r[o] = f, l) {
        var h = a.get(l);
        h ? a.setIn([l, "prevSibling"], f) : a.setIn([o, "nextSibling"], null);
      }
      if (c) {
        var p = a.get(c);
        p ? a.setIn([c, "nextSibling"], f) : a.setIn([o, "prevSibling"], null);
      }
      if (d && a.get(d)) {
        var m = a.get(d), g = m.getChildKeys();
        a.setIn([d, "children"], g.set(g.indexOf(s.getKey()), f));
      } else
        a.setIn([o, "parent"], null), n && (a.setIn([n.getKey(), "nextSibling"], f), a.setIn([o, "prevSibling"], r[n.getKey()])), n = a.get(o);
      u.forEach(function(y) {
        var x = a.get(y);
        x ? a.setIn([y, "parent"], f) : a.setIn([o, "children"], s.getChildKeys().filter(function(w) {
          return w !== y;
        }));
      });
    });
  }).toArray().map(function(a) {
    return [r[a.getKey()], a.set("key", r[a.getKey()])];
  }));
}, l_e = function(t) {
  return ZB(t.toArray().map(function(r) {
    var n = JB();
    return [n, r.set("key", n)];
  }));
}, c_e = function(t) {
  var r = t.first() instanceof s_e;
  return r ? o_e(t) : l_e(t);
}, e6 = c_e, u_e = {}, d_e = gi, f_e = Bg, CI = jr;
function h_e(e, t) {
  var r = e.getBlockMap(), n = e.getEntityMap(), a = {}, s = t.getStartKey(), i = t.getStartOffset(), o = r.get(s), l = kI(n, o, i);
  l !== o && (a[s] = l);
  var c = t.getEndKey(), u = t.getEndOffset(), d = r.get(c);
  s === c && (d = l);
  var f = kI(n, d, u);
  return f !== d && (a[c] = f), Object.keys(a).length ? e.merge({
    blockMap: r.merge(a),
    selectionAfter: t
  }) : e.set("selectionAfter", t);
}
function p_e(e, t, r) {
  var n;
  return f_e(
    e,
    // the list to iterate through
    function(a, s) {
      return a.getEntity() === s.getEntity();
    },
    // 'isEqual' callback
    function(a) {
      return a.getEntity() === t;
    },
    // 'filter' callback
    function(a, s) {
      a <= r && s >= r && (n = {
        start: a,
        end: s
      });
    }
  ), typeof n != "object" && (u_e.NODE_ENV !== "production" ? CI(!1, "Removal range must exist within character list.") : CI(!1)), n;
}
function kI(e, t, r) {
  var n = t.getCharacterList(), a = r > 0 ? n.get(r - 1) : void 0, s = r < n.count() ? n.get(r) : void 0, i = a ? a.getEntity() : void 0, o = s ? s.getEntity() : void 0;
  if (o && o === i) {
    var l = e.__get(o);
    if (l.getMutability() !== "MUTABLE") {
      for (var c = p_e(n, o, r), u = c.start, d = c.end, f; u < d; )
        f = n.get(u), n = n.set(u, d_e.applyEntity(f, null)), u++;
      return t.set("characterList", n);
    }
  }
  return t;
}
var t6 = h_e, m_e = e6, g_e = t6, v_e = function(t, r) {
  var n = r.getStartKey(), a = r.getStartOffset(), s = r.getEndKey(), i = r.getEndOffset(), o = g_e(t, r), l = o.getBlockMap(), c = l.keySeq(), u = c.indexOf(n), d = c.indexOf(s) + 1;
  return m_e(l.slice(u, d).map(function(f, h) {
    var p = f.getText(), m = f.getCharacterList();
    return n === s ? f.merge({
      text: p.slice(a, i),
      characterList: m.slice(a, i)
    }) : h === n ? f.merge({
      text: p.slice(a),
      characterList: m.slice(a)
    }) : h === s ? f.merge({
      text: p.slice(0, i),
      characterList: m.slice(0, i)
    }) : f;
  }));
}, nx = v_e;
function y_e(e, t, r) {
  var n = e;
  if (r === n.count())
    t.forEach(function(i) {
      n = n.push(i);
    });
  else if (r === 0)
    t.reverse().forEach(function(i) {
      n = n.unshift(i);
    });
  else {
    var a = n.slice(0, r), s = n.slice(r);
    n = a.concat(t, s).toList();
  }
  return n;
}
var r6 = y_e, OI = {}, b_e = Fg, n6 = vi, w_e = Tr, x_e = r6, n0 = jr, __e = e6, S_e = w_e.List, E_e = function(t, r, n, a, s, i) {
  var o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "REPLACE_WITH_NEW_DATA", l = n.get(s), c = l.getText(), u = l.getCharacterList(), d = s, f = i + a.getText().length, h = null;
  switch (o) {
    case "MERGE_OLD_DATA_TO_NEW_DATA":
      h = a.getData().merge(l.getData());
      break;
    case "REPLACE_WITH_NEW_DATA":
      h = a.getData();
      break;
  }
  var p = l.getType();
  c && p === "unstyled" && (p = a.getType());
  var m = l.merge({
    text: c.slice(0, i) + a.getText() + c.slice(i),
    characterList: x_e(u, a.getCharacterList(), i),
    type: p,
    data: h
  });
  return t.merge({
    blockMap: n.set(s, m),
    selectionBefore: r,
    selectionAfter: r.merge({
      anchorKey: d,
      anchorOffset: f,
      focusKey: d,
      focusOffset: f,
      isBackward: !1
    })
  });
}, T_e = function(t, r, n) {
  var a = t.getText(), s = t.getCharacterList(), i = a.slice(0, r), o = s.slice(0, r), l = n.first();
  return t.merge({
    text: i + l.getText(),
    characterList: o.concat(l.getCharacterList()),
    type: i ? t.getType() : l.getType(),
    data: l.getData()
  });
}, C_e = function(t, r, n) {
  var a = t.getText(), s = t.getCharacterList(), i = a.length, o = a.slice(r, i), l = s.slice(r, i), c = n.last();
  return c.merge({
    text: c.getText() + o,
    characterList: c.getCharacterList().concat(l),
    data: c.getData()
  });
}, k_e = function(t, r) {
  var n = t.getKey(), a = t, s = [];
  for (r.get(n) && s.push(n); a && a.getNextSiblingKey(); ) {
    var i = a.getNextSiblingKey();
    if (!i)
      break;
    s.push(i), a = r.get(i);
  }
  return s;
}, O_e = function(t, r, n, a) {
  return t.withMutations(function(s) {
    var i = n.getKey(), o = a.getKey(), l = n.getNextSiblingKey(), c = n.getParentKey(), u = k_e(a, t), d = u[u.length - 1];
    if (s.get(o) ? (s.setIn([i, "nextSibling"], o), s.setIn([o, "prevSibling"], i)) : (s.setIn([i, "nextSibling"], a.getNextSiblingKey()), s.setIn([a.getNextSiblingKey(), "prevSibling"], i)), s.setIn([d, "nextSibling"], l), l && s.setIn([l, "prevSibling"], d), u.forEach(function(y) {
      return s.setIn([y, "parent"], c);
    }), c) {
      var f = t.get(c), h = f.getChildKeys(), p = h.indexOf(i), m = p + 1, g = h.toArray();
      g.splice.apply(g, [m, 0].concat(u)), s.setIn([c, "children"], S_e(g));
    }
  });
}, A_e = function(t, r, n, a, s, i) {
  var o = n.first() instanceof n6, l = [], c = a.size, u = n.get(s), d = a.first(), f = a.last(), h = f.getLength(), p = f.getKey(), m = o && (!u.getChildKeys().isEmpty() || !d.getChildKeys().isEmpty());
  n.forEach(function(y, x) {
    if (x !== s) {
      l.push(y);
      return;
    }
    m ? l.push(y) : l.push(T_e(y, i, a)), a.slice(m ? 0 : 1, c - 1).forEach(function(w) {
      return l.push(w);
    }), l.push(C_e(y, i, a));
  });
  var g = b_e.createFromArray(l);
  return o && (g = O_e(g, n, u, d)), t.merge({
    blockMap: g,
    selectionBefore: r,
    selectionAfter: r.merge({
      anchorKey: p,
      anchorOffset: h,
      focusKey: p,
      focusOffset: h,
      isBackward: !1
    })
  });
}, P_e = function(t, r, n) {
  var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "REPLACE_WITH_NEW_DATA";
  r.isCollapsed() || (OI.NODE_ENV !== "production" ? n0(!1, "`insertFragment` should only be called with a collapsed selection state.") : n0(!1));
  var s = t.getBlockMap(), i = __e(n), o = r.getStartKey(), l = r.getStartOffset(), c = s.get(o);
  return c instanceof n6 && (c.getChildKeys().isEmpty() || (OI.NODE_ENV !== "production" ? n0(!1, "`insertFragment` should not be called when a container node is selected.") : n0(!1))), i.size === 1 ? E_e(t, r, s, i.first(), o, l, a) : A_e(t, r, s, i, o, l);
}, R_e = P_e, I_e = {}, D_e = Tr, N_e = r6, AI = jr, M_e = D_e.Repeat;
function L_e(e, t, r, n) {
  t.isCollapsed() || (I_e.NODE_ENV !== "production" ? AI(!1, "`insertText` should only be called with a collapsed range.") : AI(!1));
  var a = null;
  if (r != null && (a = r.length), a == null || a === 0)
    return e;
  var s = e.getBlockMap(), i = t.getStartKey(), o = t.getStartOffset(), l = s.get(i), c = l.getText(), u = l.merge({
    text: c.slice(0, o) + r + c.slice(o, l.getLength()),
    characterList: N_e(l.getCharacterList(), M_e(n, a).toList(), o)
  }), d = o + a;
  return e.merge({
    blockMap: s.set(i, u),
    selectionAfter: t.merge({
      anchorOffset: d,
      focusOffset: d
    })
  });
}
var j_e = L_e, F_e = Tr, B_e = F_e.Map;
function U_e(e, t, r) {
  var n = t.getStartKey(), a = t.getEndKey(), s = e.getBlockMap(), i = s.toSeq().skipUntil(function(o, l) {
    return l === n;
  }).takeUntil(function(o, l) {
    return l === a;
  }).concat(B_e([[a, s.get(a)]])).map(r);
  return e.merge({
    blockMap: s.merge(i),
    selectionBefore: t,
    selectionAfter: t
  });
}
var a6 = U_e, V_e = vi, $_e = function(t, r) {
  var n = t instanceof V_e;
  if (!n)
    return null;
  var a = t.getNextSiblingKey();
  if (a)
    return a;
  var s = t.getParentKey();
  if (!s)
    return null;
  for (var i = r.get(s); i && !i.getNextSiblingKey(); ) {
    var o = i.getParentKey();
    i = o ? r.get(o) : null;
  }
  return i ? i.getNextSiblingKey() : null;
}, s6 = $_e, H_e = vi, UE = s6, i6 = Tr;
i6.List;
var PI = i6.Map, ms = function(t, r, n) {
  if (t) {
    var a = r.get(t);
    a && r.set(t, n(a));
  }
}, _b = function(t, r) {
  var n = [];
  if (!t)
    return n;
  for (var a = r.get(t); a && a.getParentKey(); ) {
    var s = a.getParentKey();
    s && n.push(s), a = s ? r.get(s) : null;
  }
  return n;
}, W_e = function(t, r) {
  var n = [];
  if (!t)
    return n;
  for (var a = UE(t, r); a && r.get(a); ) {
    var s = r.get(a);
    n.push(a), a = s.getParentKey() ? UE(s, r) : null;
  }
  return n;
}, Vd = function(t, r, n) {
  if (!t)
    return null;
  for (var a = n.get(t.getKey()).getNextSiblingKey(); a && !r.get(a); )
    a = n.get(a).getNextSiblingKey() || null;
  return a;
}, $d = function(t, r, n) {
  if (!t)
    return null;
  for (var a = n.get(t.getKey()).getPrevSiblingKey(); a && !r.get(a); )
    a = n.get(a).getPrevSiblingKey() || null;
  return a;
}, z_e = function(t, r, n, a) {
  return t.withMutations(function(s) {
    if (ms(r.getKey(), s, function(u) {
      return u.merge({
        nextSibling: Vd(u, s, a),
        prevSibling: $d(u, s, a)
      });
    }), ms(n.getKey(), s, function(u) {
      return u.merge({
        nextSibling: Vd(u, s, a),
        prevSibling: $d(u, s, a)
      });
    }), _b(r.getKey(), a).forEach(function(u) {
      return ms(u, s, function(d) {
        return d.merge({
          children: d.getChildKeys().filter(function(f) {
            return s.get(f);
          }),
          nextSibling: Vd(d, s, a),
          prevSibling: $d(d, s, a)
        });
      });
    }), ms(r.getNextSiblingKey(), s, function(u) {
      return u.merge({
        prevSibling: r.getPrevSiblingKey()
      });
    }), ms(r.getPrevSiblingKey(), s, function(u) {
      return u.merge({
        nextSibling: Vd(u, s, a)
      });
    }), ms(n.getNextSiblingKey(), s, function(u) {
      return u.merge({
        prevSibling: $d(u, s, a)
      });
    }), ms(n.getPrevSiblingKey(), s, function(u) {
      return u.merge({
        nextSibling: n.getNextSiblingKey()
      });
    }), _b(n.getKey(), a).forEach(function(u) {
      ms(u, s, function(d) {
        return d.merge({
          children: d.getChildKeys().filter(function(f) {
            return s.get(f);
          }),
          nextSibling: Vd(d, s, a),
          prevSibling: $d(d, s, a)
        });
      });
    }), W_e(n, a).forEach(function(u) {
      return ms(u, s, function(d) {
        return d.merge({
          nextSibling: Vd(d, s, a),
          prevSibling: $d(d, s, a)
        });
      });
    }), t.get(r.getKey()) == null && t.get(n.getKey()) != null && n.getParentKey() === r.getKey() && n.getPrevSiblingKey() == null) {
      var i = r.getPrevSiblingKey();
      ms(n.getKey(), s, function(u) {
        return u.merge({
          prevSibling: i
        });
      }), ms(i, s, function(u) {
        return u.merge({
          nextSibling: n.getKey()
        });
      });
      var o = i ? t.get(i) : null, l = o ? o.getParentKey() : null;
      if (r.getChildKeys().forEach(function(u) {
        ms(u, s, function(d) {
          return d.merge({
            parent: l
            // set to null if there is no parent
          });
        });
      }), l != null) {
        var c = t.get(l);
        ms(l, s, function(u) {
          return u.merge({
            children: c.getChildKeys().concat(r.getChildKeys())
          });
        });
      }
      ms(r.getChildKeys().find(function(u) {
        var d = t.get(u);
        return d.getNextSiblingKey() === null;
      }), s, function(u) {
        return u.merge({
          nextSibling: r.getNextSiblingKey()
        });
      });
    }
  });
}, K_e = function(t, r) {
  if (r.isCollapsed())
    return t;
  var n = t.getBlockMap(), a = r.getStartKey(), s = r.getStartOffset(), i = r.getEndKey(), o = r.getEndOffset(), l = n.get(a), c = n.get(i), u = l instanceof H_e, d = [];
  if (u) {
    var f = c.getChildKeys(), h = _b(i, n);
    c.getNextSiblingKey() && (d = d.concat(h)), f.isEmpty() || (d = d.concat(h.concat([i]))), d = d.concat(_b(UE(c, n), n));
  }
  var p;
  l === c ? p = q_e(l.getCharacterList(), s, o) : p = l.getCharacterList().slice(0, s).concat(c.getCharacterList().slice(o));
  var m = l.merge({
    text: l.getText().slice(0, s) + c.getText().slice(o),
    characterList: p
  }), g = u && s === 0 && o === 0 && c.getParentKey() === a && c.getPrevSiblingKey() == null, y = g ? PI([[a, null]]) : n.toSeq().skipUntil(function(w, _) {
    return _ === a;
  }).takeUntil(function(w, _) {
    return _ === i;
  }).filter(function(w, _) {
    return d.indexOf(_) === -1;
  }).concat(PI([[i, null]])).map(function(w, _) {
    return _ === a ? m : null;
  }), x = n.merge(y).filter(function(w) {
    return !!w;
  });
  return u && l !== c && (x = z_e(x, l, c, n)), t.merge({
    blockMap: x,
    selectionBefore: r,
    selectionAfter: r.merge({
      anchorKey: a,
      anchorOffset: s,
      focusKey: a,
      focusOffset: s,
      isBackward: !1
    })
  });
}, q_e = function(t, r, n) {
  if (r === 0)
    for (; r < n; )
      t = t.shift(), r++;
  else if (n === t.count())
    for (; n > r; )
      t = t.pop(), n--;
  else {
    var a = t.slice(0, r), s = t.slice(n);
    t = a.concat(s).toList();
  }
  return t;
}, G_e = K_e, RI = {}, Y_e = vi, X_e = Wo, o6 = Tr, a0 = jr, Q_e = a6, J_e = o6.List, Z_e = o6.Map, s0 = function(t, r, n) {
  if (t) {
    var a = r.get(t);
    a && r.set(t, n(a));
  }
}, eSe = function(t, r, n) {
  return t.withMutations(function(a) {
    var s = r.getKey(), i = n.getKey();
    s0(r.getParentKey(), a, function(o) {
      var l = o.getChildKeys(), c = l.indexOf(s) + 1, u = l.toArray();
      return u.splice(c, 0, i), o.merge({
        children: J_e(u)
      });
    }), s0(r.getNextSiblingKey(), a, function(o) {
      return o.merge({
        prevSibling: i
      });
    }), s0(s, a, function(o) {
      return o.merge({
        nextSibling: i
      });
    }), s0(i, a, function(o) {
      return o.merge({
        prevSibling: s
      });
    });
  });
}, tSe = function(t, r) {
  r.isCollapsed() || (RI.NODE_ENV !== "production" ? a0(!1, "Selection range must be collapsed.") : a0(!1));
  var n = r.getAnchorKey(), a = t.getBlockMap(), s = a.get(n), i = s.getText();
  if (!i) {
    var o = s.getType();
    if (o === "unordered-list-item" || o === "ordered-list-item")
      return Q_e(t, r, function(y) {
        return y.merge({
          type: "unstyled",
          depth: 0
        });
      });
  }
  var l = r.getAnchorOffset(), c = s.getCharacterList(), u = X_e(), d = s instanceof Y_e, f = s.merge({
    text: i.slice(0, l),
    characterList: c.slice(0, l)
  }), h = f.merge({
    key: u,
    text: i.slice(l),
    characterList: c.slice(l),
    data: Z_e()
  }), p = a.toSeq().takeUntil(function(y) {
    return y === s;
  }), m = a.toSeq().skipUntil(function(y) {
    return y === s;
  }).rest(), g = p.concat([[n, f], [u, h]], m).toOrderedMap();
  return d && (s.getChildKeys().isEmpty() || (RI.NODE_ENV !== "production" ? a0(!1, "ContentBlockNode must not have children") : a0(!1)), g = eSe(g, f, h)), t.merge({
    blockMap: g,
    selectionBefore: r,
    selectionAfter: r.merge({
      anchorKey: u,
      anchorOffset: 0,
      focusKey: u,
      focusOffset: 0,
      isBackward: !1
    })
  });
}, rSe = tSe, nSe = {}, aSe = gi, II = L1e, sSe = H1e, iSe = r_e, oSe = nx, lSe = Tr, cSe = R_e, uSe = j_e, DI = jr, f_ = a6, vp = t6, yp = G_e, dSe = rSe, fSe = lSe.OrderedSet, Cy = {
  replaceText: function(t, r, n, a, s) {
    var i = vp(t, r), o = yp(i, r), l = aSe.create({
      style: a || fSe(),
      entity: s || null
    });
    return uSe(o, o.getSelectionAfter(), n, l);
  },
  insertText: function(t, r, n, a, s) {
    return r.isCollapsed() || (nSe.NODE_ENV !== "production" ? DI(!1, "Target range must be collapsed for `insertText`.") : DI(!1)), Cy.replaceText(t, r, n, a, s);
  },
  moveText: function(t, r, n) {
    var a = oSe(t, r), s = Cy.removeRange(t, r, "backward");
    return Cy.replaceWithFragment(s, n, a);
  },
  replaceWithFragment: function(t, r, n) {
    var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "REPLACE_WITH_NEW_DATA", s = vp(t, r), i = yp(s, r);
    return cSe(i, i.getSelectionAfter(), n, a);
  },
  removeRange: function(t, r, n) {
    var a, s, i, o;
    r.getIsBackward() && (r = r.merge({
      anchorKey: r.getFocusKey(),
      anchorOffset: r.getFocusOffset(),
      focusKey: r.getAnchorKey(),
      focusOffset: r.getAnchorOffset(),
      isBackward: !1
    })), a = r.getAnchorKey(), s = r.getFocusKey(), i = t.getBlockForKey(a), o = t.getBlockForKey(s);
    var l = r.getStartOffset(), c = r.getEndOffset(), u = i.getEntityAt(l), d = o.getEntityAt(c - 1);
    if (a === s && u && u === d) {
      var f = iSe(t.getEntityMap(), i, o, r, n);
      return yp(t, f);
    }
    var h = vp(t, r);
    return yp(h, r);
  },
  splitBlock: function(t, r) {
    var n = vp(t, r), a = yp(n, r);
    return dSe(a, a.getSelectionAfter());
  },
  applyInlineStyle: function(t, r, n) {
    return II.add(t, r, n);
  },
  removeInlineStyle: function(t, r, n) {
    return II.remove(t, r, n);
  },
  setBlockType: function(t, r, n) {
    return f_(t, r, function(a) {
      return a.merge({
        type: n,
        depth: 0
      });
    });
  },
  setBlockData: function(t, r, n) {
    return f_(t, r, function(a) {
      return a.merge({
        data: n
      });
    });
  },
  mergeBlockData: function(t, r, n) {
    return f_(t, r, function(a) {
      return a.merge({
        data: a.getData().merge(n)
      });
    });
  },
  applyEntity: function(t, r, n) {
    var a = vp(t, r);
    return sSe(a, r, n);
  }
}, Cs = Cy;
function hSe(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
var l6 = hSe;
function pSe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    }))), n.forEach(function(a) {
      mSe(e, a, r[a]);
    });
  }
  return e;
}
function mSe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function gSe(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, s;
  for (s = 0; s < n.length; s++)
    a = n[s], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var c6 = Bg, vSe = l6, ck = Tr, kf = ck.List, ySe = ck.Repeat, u6 = ck.Record, d6 = function() {
  return !0;
}, bSe = {
  start: null,
  end: null
}, VE = u6(bSe), wSe = {
  start: null,
  end: null,
  decoratorKey: null,
  leaves: null
}, h_ = u6(wSe), xSe = {
  /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
  generate: function(t, r, n) {
    var a = r.getLength();
    if (!a)
      return kf.of(new h_({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: kf.of(new VE({
          start: 0,
          end: 0
        }))
      }));
    var s = [], i = n ? n.getDecorations(r, t) : kf(ySe(null, a)), o = r.getCharacterList();
    return c6(i, f6, d6, function(l, c) {
      s.push(new h_({
        start: l,
        end: c,
        decoratorKey: i.get(l),
        leaves: _Se(o.slice(l, c).toList(), l)
      }));
    }), kf(s);
  },
  fromJS: function(t) {
    var r = t.leaves, n = gSe(t, ["leaves"]);
    return new h_(pSe({}, n, {
      leaves: r != null ? kf(Array.isArray(r) ? r : vSe(r)).map(function(a) {
        return VE(a);
      }) : null
    }));
  }
};
function _Se(e, t) {
  var r = [], n = e.map(function(a) {
    return a.getStyle();
  }).toList();
  return c6(n, f6, d6, function(a, s) {
    r.push(new VE({
      start: a + t,
      end: s + t
    }));
  }), kf(r);
}
function f6(e, t) {
  return e === t;
}
var SSe = xSe;
function ESe(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
var TSe = Tr, CSe = TSe.Record, kSe = CSe({
  type: "TOKEN",
  mutability: "IMMUTABLE",
  data: Object
}), OSe = /* @__PURE__ */ function(e) {
  ESe(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var r = t.prototype;
  return r.getType = function() {
    return this.get("type");
  }, r.getMutability = function() {
    return this.get("mutability");
  }, r.getData = function() {
    return this.get("data");
  }, t;
}(kSe), h6 = OSe;
function ASe() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    var t = Math.random() * 16 | 0, r = e == "x" ? t : t & 3 | 8;
    return r.toString(16);
  });
}
var PSe = ASe, RSe = {};
function ISe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    }))), n.forEach(function(a) {
      DSe(e, a, r[a]);
    });
  }
  return e;
}
function DSe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var NSe = h6, MSe = Tr, NI = jr, $E = PSe, LSe = MSe.Map, tl = LSe(), bp = $E();
function Hd(e, t) {
  console.warn("WARNING: " + e + ` will be deprecated soon!
Please use "` + t + '" instead.');
}
var io = {
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  getLastCreatedEntityKey: function() {
    return Hd("DraftEntity.getLastCreatedEntityKey", "contentState.getLastCreatedEntityKey"), io.__getLastCreatedEntityKey();
  },
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  create: function(t, r, n) {
    return Hd("DraftEntity.create", "contentState.createEntity"), io.__create(t, r, n);
  },
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  add: function(t) {
    return Hd("DraftEntity.add", "contentState.addEntity"), io.__add(t);
  },
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
  get: function(t) {
    return Hd("DraftEntity.get", "contentState.getEntity"), io.__get(t);
  },
  /**
   * Get all the entities in the content state.
   */
  __getAll: function() {
    return tl;
  },
  /**
   * Load the entity map with the given set of entities.
   */
  __loadWithEntities: function(t) {
    tl = t, bp = $E();
  },
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  mergeData: function(t, r) {
    return Hd("DraftEntity.mergeData", "contentState.mergeEntityData"), io.__mergeData(t, r);
  },
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
  replaceData: function(t, r) {
    return Hd("DraftEntity.replaceData", "contentState.replaceEntityData"), io.__replaceData(t, r);
  },
  // ***********************************WARNING******************************
  // --- the above public API will be deprecated in the next version of Draft!
  // The methods below this line are private - don't call them directly.
  /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  __getLastCreatedEntityKey: function() {
    return bp;
  },
  /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  __create: function(t, r, n) {
    return io.__add(new NSe({
      type: t,
      mutability: r,
      data: n || {}
    }));
  },
  /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  __add: function(t) {
    return bp = $E(), tl = tl.set(bp, t), bp;
  },
  /**
   * Retrieve the entity corresponding to the supplied key string.
   */
  __get: function(t) {
    var r = tl.get(t);
    return r || (RSe.NODE_ENV !== "production" ? NI(!1, "Unknown DraftEntity key: %s.", t) : NI(!1)), r;
  },
  /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  __mergeData: function(t, r) {
    var n = io.__get(t), a = ISe({}, n.getData(), r), s = n.set("data", a);
    return tl = tl.set(t, s), s;
  },
  /**
   * Completely replace the data for a given instance.
   */
  __replaceData: function(t, r) {
    var n = io.__get(t), a = n.set("data", r);
    return tl = tl.set(t, a), a;
  }
}, ax = io;
function jSe(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
var FSe = Tr, BSe = FSe.Record, USe = {
  anchorKey: "",
  anchorOffset: 0,
  focusKey: "",
  focusOffset: 0,
  isBackward: !1,
  hasFocus: !1
}, VSe = BSe(USe), $Se = /* @__PURE__ */ function(e) {
  jSe(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var r = t.prototype;
  return r.serialize = function() {
    return "Anchor: " + this.getAnchorKey() + ":" + this.getAnchorOffset() + ", Focus: " + this.getFocusKey() + ":" + this.getFocusOffset() + ", Is Backward: " + String(this.getIsBackward()) + ", Has Focus: " + String(this.getHasFocus());
  }, r.getAnchorKey = function() {
    return this.get("anchorKey");
  }, r.getAnchorOffset = function() {
    return this.get("anchorOffset");
  }, r.getFocusKey = function() {
    return this.get("focusKey");
  }, r.getFocusOffset = function() {
    return this.get("focusOffset");
  }, r.getIsBackward = function() {
    return this.get("isBackward");
  }, r.getHasFocus = function() {
    return this.get("hasFocus");
  }, r.hasEdgeWithin = function(a, s, i) {
    var o = this.getAnchorKey(), l = this.getFocusKey();
    if (o === l && o === a) {
      var c = this.getStartOffset(), u = this.getEndOffset();
      return s <= c && c <= i || // selectionStart is between start and end, or
      s <= u && u <= i;
    }
    if (a !== o && a !== l)
      return !1;
    var d = a === o ? this.getAnchorOffset() : this.getFocusOffset();
    return s <= d && i >= d;
  }, r.isCollapsed = function() {
    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
  }, r.getStartKey = function() {
    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
  }, r.getStartOffset = function() {
    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
  }, r.getEndKey = function() {
    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
  }, r.getEndOffset = function() {
    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
  }, t.createEmpty = function(a) {
    return new t({
      anchorKey: a,
      anchorOffset: 0,
      focusKey: a,
      focusOffset: 0,
      isBackward: !1,
      hasFocus: !1
    });
  }, t;
}(VSe), sx = $Se, Gc = function(e) {
  return typeof window < "u" && window.__DRAFT_GKX ? !!window.__DRAFT_GKX[e] : !1;
}, HSe = new RegExp("\r", "g");
function WSe(e) {
  return e.replace(HSe, "");
}
var p6 = WSe;
function MI(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    }))), n.forEach(function(a) {
      zSe(e, a, r[a]);
    });
  }
  return e;
}
function zSe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function KSe(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
var qSe = Fg, LI = gi, GSe = cd, YSe = vi, ro = ax, i0 = sx, XSe = Wo, QSe = l6, JSe = Gc, $g = Tr, ZSe = p6, jI = $g.List, eEe = $g.Record, tEe = $g.Repeat, rEe = $g.Map, nEe = $g.OrderedMap, aEe = {
  entityMap: null,
  blockMap: null,
  selectionBefore: null,
  selectionAfter: null
}, sEe = eEe(aEe), FI = JSe("draft_tree_data_support") ? YSe : GSe, iEe = /* @__PURE__ */ function(e) {
  KSe(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var r = t.prototype;
  return r.getEntityMap = function() {
    return ro;
  }, r.getBlockMap = function() {
    return this.get("blockMap");
  }, r.getSelectionBefore = function() {
    return this.get("selectionBefore");
  }, r.getSelectionAfter = function() {
    return this.get("selectionAfter");
  }, r.getBlockForKey = function(a) {
    var s = this.getBlockMap().get(a);
    return s;
  }, r.getKeyBefore = function(a) {
    return this.getBlockMap().reverse().keySeq().skipUntil(function(s) {
      return s === a;
    }).skip(1).first();
  }, r.getKeyAfter = function(a) {
    return this.getBlockMap().keySeq().skipUntil(function(s) {
      return s === a;
    }).skip(1).first();
  }, r.getBlockAfter = function(a) {
    return this.getBlockMap().skipUntil(function(s, i) {
      return i === a;
    }).skip(1).first();
  }, r.getBlockBefore = function(a) {
    return this.getBlockMap().reverse().skipUntil(function(s, i) {
      return i === a;
    }).skip(1).first();
  }, r.getBlocksAsArray = function() {
    return this.getBlockMap().toArray();
  }, r.getFirstBlock = function() {
    return this.getBlockMap().first();
  }, r.getLastBlock = function() {
    return this.getBlockMap().last();
  }, r.getPlainText = function(a) {
    return this.getBlockMap().map(function(s) {
      return s ? s.getText() : "";
    }).join(a || `
`);
  }, r.getLastCreatedEntityKey = function() {
    return ro.__getLastCreatedEntityKey();
  }, r.hasText = function() {
    var a = this.getBlockMap();
    return a.size > 1 || // make sure that there are no zero width space chars
    escape(a.first().getText()).replace(/%u200B/g, "").length > 0;
  }, r.createEntity = function(a, s, i) {
    return ro.__create(a, s, i), this;
  }, r.mergeEntityData = function(a, s) {
    return ro.__mergeData(a, s), this;
  }, r.replaceEntityData = function(a, s) {
    return ro.__replaceData(a, s), this;
  }, r.addEntity = function(a) {
    return ro.__add(a), this;
  }, r.getEntity = function(a) {
    return ro.__get(a);
  }, r.getAllEntities = function() {
    return ro.__getAll();
  }, r.loadWithEntities = function(a) {
    return ro.__loadWithEntities(a);
  }, t.createFromBlockArray = function(a, s) {
    var i = Array.isArray(a) ? a : a.contentBlocks, o = qSe.createFromArray(i), l = o.isEmpty() ? new i0() : i0.createEmpty(o.first().getKey());
    return new t({
      blockMap: o,
      entityMap: s || ro,
      selectionBefore: l,
      selectionAfter: l
    });
  }, t.createFromText = function(a) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /\r\n?|\n/g, i = a.split(s), o = i.map(function(l) {
      return l = ZSe(l), new FI({
        key: XSe(),
        text: l,
        type: "unstyled",
        characterList: jI(tEe(LI.EMPTY, l.length))
      });
    });
    return t.createFromBlockArray(o);
  }, t.fromJS = function(a) {
    return new t(MI({}, a, {
      blockMap: nEe(a.blockMap).map(t.createContentBlockFromJS),
      selectionBefore: new i0(a.selectionBefore),
      selectionAfter: new i0(a.selectionAfter)
    }));
  }, t.createContentBlockFromJS = function(a) {
    var s = a.characterList;
    return new FI(MI({}, a, {
      data: rEe(a.data),
      characterList: s != null ? jI((Array.isArray(s) ? s : QSe(s)).map(function(i) {
        return LI.fromJS(i);
      })) : void 0
    }));
  }, t;
}(sEe), uk = iEe, Sb = {}, mc = jr, oEe = "NEUTRAL", ix = "LTR", m6 = "RTL", ky = null;
function Eb(e) {
  return e === ix || e === m6;
}
function g6(e) {
  return Eb(e) || (Sb.NODE_ENV !== "production" ? mc(!1, "`dir` must be a strong direction to be converted to HTML Direction") : mc(!1)), e === ix ? "ltr" : "rtl";
}
function lEe(e, t) {
  return Eb(e) || (Sb.NODE_ENV !== "production" ? mc(!1, "`dir` must be a strong direction to be converted to HTML Direction") : mc(!1)), Eb(t) || (Sb.NODE_ENV !== "production" ? mc(!1, "`otherDir` must be a strong direction to be converted to HTML Direction") : mc(!1)), e === t ? null : g6(e);
}
function v6(e) {
  ky = e;
}
function cEe() {
  v6(ix);
}
function uEe() {
  return ky || this.initGlobalDir(), ky || (Sb.NODE_ENV !== "production" ? mc(!1, "Global direction not set.") : mc(!1)), ky;
}
var dEe = {
  // Values
  NEUTRAL: oEe,
  LTR: ix,
  RTL: m6,
  // Helpers
  isStrong: Eb,
  getHTMLDir: g6,
  getHTMLDirIfDifferent: lEe,
  // Global Direction
  setGlobalDir: v6,
  initGlobalDir: cEe,
  getGlobalDir: uEe
}, ox = dEe, fEe = {}, Il = ox, BI = jr, hm = {
  L: "A-Za-zªµºÀ-ÖØ-öø-ƺƻƼ-ƿǀ-ǃǄ-ʓʔʕ-ʯʰ-ʸʻ-ˁː-ˑˠ-ˤˮͰ-ͳͶ-ͷͺͻ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁ҂Ҋ-ԯԱ-Ֆՙ՚-՟ա-և։ःऄ-हऻऽा-ीॉ-ौॎ-ॏॐक़-ॡ।-॥०-९॰ॱॲ-ঀং-ঃঅ-ঌএ-ঐও-নপ-রলশ-হঽা-ীে-ৈো-ৌৎৗড়-ঢ়য়-ৡ০-৯ৰ-ৱ৴-৹৺ਃਅ-ਊਏ-ਐਓ-ਨਪ-ਰਲ-ਲ਼ਵ-ਸ਼ਸ-ਹਾ-ੀਖ਼-ੜਫ਼੦-੯ੲ-ੴઃઅ-ઍએ-ઑઓ-નપ-રલ-ળવ-હઽા-ીૉો-ૌૐૠ-ૡ૦-૯૰ଂ-ଃଅ-ଌଏ-ଐଓ-ନପ-ରଲ-ଳଵ-ହଽାୀେ-ୈୋ-ୌୗଡ଼-ଢ଼ୟ-ୡ୦-୯୰ୱ୲-୷ஃஅ-ஊஎ-ஐஒ-கங-சஜஞ-டண-தந-பம-ஹா-ிு-ூெ-ைொ-ௌௐௗ௦-௯௰-௲ఁ-ఃఅ-ఌఎ-ఐఒ-నప-హఽు-ౄౘ-ౙౠ-ౡ౦-౯౿ಂ-ಃಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽಾಿೀ-ೄೆೇ-ೈೊ-ೋೕ-ೖೞೠ-ೡ೦-೯ೱ-ೲം-ഃഅ-ഌഎ-ഐഒ-ഺഽാ-ീെ-ൈൊ-ൌൎൗൠ-ൡ൦-൯൰-൵൹ൺ-ൿං-ඃඅ-ඖක-නඳ-රලව-ෆා-ෑෘ-ෟ෦-෯ෲ-ෳ෴ก-ะา-ำเ-ๅๆ๏๐-๙๚-๛ກ-ຂຄງ-ຈຊຍດ-ທນ-ຟມ-ຣລວສ-ຫອ-ະາ-ຳຽເ-ໄໆ໐-໙ໜ-ໟༀ༁-༃༄-༒༓༔༕-༗༚-༟༠-༩༪-༳༴༶༸༾-༿ཀ-ཇཉ-ཬཿ྅ྈ-ྌ྾-࿅࿇-࿌࿎-࿏࿐-࿔࿕-࿘࿙-࿚က-ဪါ-ာေးျ-ြဿ၀-၉၊-၏ၐ-ၕၖ-ၗၚ-ၝၡၢ-ၤၥ-ၦၧ-ၭၮ-ၰၵ-ႁႃ-ႄႇ-ႌႎႏ႐-႙ႚ-ႜ႞-႟Ⴀ-ჅჇჍა-ჺ჻ჼჽ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚ፠-፨፩-፼ᎀ-ᎏᎠ-Ᏼᐁ-ᙬ᙭-᙮ᙯ-ᙿᚁ-ᚚᚠ-ᛪ᛫-᛭ᛮ-ᛰᛱ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱ᜵-᜶ᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳាើ-ៅះ-ៈ។-៖ៗ៘-៚ៜ០-៩᠐-᠙ᠠ-ᡂᡃᡄ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᤣ-ᤦᤩ-ᤫᤰ-ᤱᤳ-ᤸ᥆-᥏ᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧀᧁ-ᧇᧈ-ᧉ᧐-᧙᧚ᨀ-ᨖᨙ-ᨚ᨞-᨟ᨠ-ᩔᩕᩗᩡᩣ-ᩤᩭ-ᩲ᪀-᪉᪐-᪙᪠-᪦ᪧ᪨-᪭ᬄᬅ-ᬳᬵᬻᬽ-ᭁᭃ-᭄ᭅ-ᭋ᭐-᭙᭚-᭠᭡-᭪᭴-᭼ᮂᮃ-ᮠᮡᮦ-ᮧ᮪ᮮ-ᮯ᮰-᮹ᮺ-ᯥᯧᯪ-ᯬᯮ᯲-᯳᯼-᯿ᰀ-ᰣᰤ-ᰫᰴ-ᰵ᰻-᰿᱀-᱉ᱍ-ᱏ᱐-᱙ᱚ-ᱷᱸ-ᱽ᱾-᱿᳀-᳇᳓᳡ᳩ-ᳬᳮ-ᳱᳲ-ᳳᳵ-ᳶᴀ-ᴫᴬ-ᵪᵫ-ᵷᵸᵹ-ᶚᶛ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼ‎ⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℴℵ-ℸℹℼ-ℿⅅ-ⅉⅎ⅏Ⅰ-ↂↃ-ↄↅ-ↈ⌶-⍺⎕⒜-ⓩ⚬⠀-⣿Ⰰ-Ⱞⰰ-ⱞⱠ-ⱻⱼ-ⱽⱾ-ⳤⳫ-ⳮⳲ-ⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯ⵰ⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々〆〇〡-〩〮-〯〱-〵〸-〺〻〼ぁ-ゖゝ-ゞゟァ-ヺー-ヾヿㄅ-ㄭㄱ-ㆎ㆐-㆑㆒-㆕㆖-㆟ㆠ-ㆺㇰ-ㇿ㈀-㈜㈠-㈩㈪-㉇㉈-㉏㉠-㉻㉿㊀-㊉㊊-㊰㋀-㋋㋐-㋾㌀-㍶㍻-㏝㏠-㏾㐀-䶵一-鿌ꀀ-ꀔꀕꀖ-ꒌꓐ-ꓷꓸ-ꓽ꓾-꓿ꔀ-ꘋꘌꘐ-ꘟ꘠-꘩ꘪ-ꘫꙀ-ꙭꙮꚀ-ꚛꚜ-ꚝꚠ-ꛥꛦ-ꛯ꛲-꛷Ꜣ-ꝯꝰꝱ-ꞇ꞉-꞊Ꞌ-ꞎꞐ-ꞭꞰ-Ʇꟷꟸ-ꟹꟺꟻ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꠣ-ꠤꠧ꠰-꠵꠶-꠷ꡀ-ꡳꢀ-ꢁꢂ-ꢳꢴ-ꣃ꣎-꣏꣐-꣙ꣲ-ꣷ꣸-꣺ꣻ꤀-꤉ꤊ-ꤥ꤮-꤯ꤰ-ꥆꥒ-꥓꥟ꥠ-ꥼꦃꦄ-ꦲꦴ-ꦵꦺ-ꦻꦽ-꧀꧁-꧍ꧏ꧐-꧙꧞-꧟ꧠ-ꧤꧦꧧ-ꧯ꧰-꧹ꧺ-ꧾꨀ-ꨨꨯ-ꨰꨳ-ꨴꩀ-ꩂꩄ-ꩋꩍ꩐-꩙꩜-꩟ꩠ-ꩯꩰꩱ-ꩶ꩷-꩹ꩺꩻꩽꩾ-ꪯꪱꪵ-ꪶꪹ-ꪽꫀꫂꫛ-ꫜꫝ꫞-꫟ꫠ-ꫪꫫꫮ-ꫯ꫰-꫱ꫲꫳ-ꫴꫵꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚ꭛ꭜ-ꭟꭤ-ꭥꯀ-ꯢꯣ-ꯤꯦ-ꯧꯩ-ꯪ꯫꯬꯰-꯹가-힣ힰ-ퟆퟋ-ퟻ-豈-舘並-龎ﬀ-ﬆﬓ-ﬗＡ-Ｚａ-ｚｦ-ｯｰｱ-ﾝﾞ-ﾟﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
  R: "֐־׀׃׆׈-׏א-ת׫-ׯװ-ײ׳-״׵-׿߀-߉ߊ-ߪߴ-ߵߺ߻-߿ࠀ-ࠕࠚࠤࠨ࠮-࠯࠰-࠾࠿ࡀ-ࡘ࡜-࡝࡞࡟-࢟‏יִײַ-ﬨשׁ-זּ﬷טּ-לּ﬽מּ﬿נּ-סּ﭂ףּ-פּ﭅צּ-ﭏ",
  AL: "؈؋؍؛؜؝؞-؟ؠ-ؿـف-ي٭ٮ-ٯٱ-ۓ۔ەۥ-ۦۮ-ۯۺ-ۼ۽-۾ۿ܀-܍܎܏ܐܒ-ܯ݋-݌ݍ-ޥޱ޲-޿ࢠ-ࢲࢳ-ࣣﭐ-ﮱ﮲-﯁﯂-﯒ﯓ-ﴽ﵀-﵏ﵐ-ﶏ﶐-﶑ﶒ-ﷇ﷈-﷏ﷰ-ﷻ﷼﷾-﷿ﹰ-ﹴ﹵ﹶ-ﻼ﻽-﻾"
}, hEe = new RegExp("[" + hm.L + hm.R + hm.AL + "]"), pEe = new RegExp("[" + hm.R + hm.AL + "]");
function y6(e) {
  var t = hEe.exec(e);
  return t == null ? null : t[0];
}
function b6(e) {
  var t = y6(e);
  return t == null ? Il.NEUTRAL : pEe.exec(t) ? Il.RTL : Il.LTR;
}
function w6(e, t) {
  if (t = t || Il.NEUTRAL, !e.length)
    return t;
  var r = b6(e);
  return r === Il.NEUTRAL ? t : r;
}
function dk(e, t) {
  return t || (t = Il.getGlobalDir()), Il.isStrong(t) || (fEe.NODE_ENV !== "production" ? BI(!1, "Fallback direction must be a strong direction") : BI(!1)), w6(e, t);
}
function mEe(e, t) {
  return dk(e, t) === Il.LTR;
}
function gEe(e, t) {
  return dk(e, t) === Il.RTL;
}
var vEe = {
  firstStrongChar: y6,
  firstStrongCharDir: b6,
  resolveBlockDir: w6,
  getDirection: dk,
  isDirectionLTR: mEe,
  isDirectionRTL: gEe
}, fk = vEe, yEe = {};
function UI(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var bEe = fk, VI = ox, $I = jr, wEe = /* @__PURE__ */ function() {
  function e(r) {
    UI(this, "_defaultDir", void 0), UI(this, "_lastDir", void 0), r ? VI.isStrong(r) || (yEe.NODE_ENV !== "production" ? $I(!1, "Default direction must be a strong direction (LTR or RTL)") : $I(!1)) : r = VI.getGlobalDir(), this._defaultDir = r, this.reset();
  }
  var t = e.prototype;
  return t.reset = function() {
    this._lastDir = this._defaultDir;
  }, t.getDirection = function(n) {
    return this._lastDir = bEe.getDirection(n, this._lastDir), this._lastDir;
  }, e;
}(), xEe = wEe, _Ee = function(t) {
  if (t != null)
    return t;
  throw new Error("Got unexpected null or undefined");
}, ks = _Ee, SEe = xEe, x6 = Tr, EEe = ks, TEe = x6.OrderedMap, o0, CEe = {
  getDirectionMap: function(t, r) {
    o0 ? o0.reset() : o0 = new SEe();
    var n = t.getBlockMap(), a = n.valueSeq().map(function(i) {
      return EEe(o0).getDirection(i.getText());
    }), s = TEe(n.keySeq().zip(a));
    return r != null && x6.is(r, s) ? r : s;
  }
}, kEe = CEe;
function HI(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    }))), n.forEach(function(a) {
      _6(e, a, r[a]);
    });
  }
  return e;
}
function _6(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var lx = SSe, wp = uk, l0 = kEe, p_ = sx, Hg = Tr, S6 = Hg.OrderedSet, OEe = Hg.Record, gu = Hg.Stack, WI = Hg.OrderedMap, AEe = Hg.List, PEe = {
  allowUndo: !0,
  currentContent: null,
  decorator: null,
  directionMap: null,
  forceSelection: !1,
  inCompositionMode: !1,
  inlineStyleOverride: null,
  lastChangeType: null,
  nativelyRenderedContent: null,
  redoStack: gu(),
  selection: null,
  treeMap: null,
  undoStack: gu()
}, zI = OEe(PEe), E6 = /* @__PURE__ */ function() {
  t.createEmpty = function(n) {
    return this.createWithText("", n);
  }, t.createWithText = function(n, a) {
    return t.createWithContent(wp.createFromText(n), a);
  }, t.createWithContent = function(n, a) {
    if (n.getBlockMap().count() === 0)
      return t.createEmpty(a);
    var s = n.getBlockMap().first().getKey();
    return t.create({
      currentContent: n,
      undoStack: gu(),
      redoStack: gu(),
      decorator: a || null,
      selection: p_.createEmpty(s)
    });
  }, t.create = function(n) {
    var a = n.currentContent, s = n.decorator, i = HI({}, n, {
      treeMap: qI(a, s),
      directionMap: l0.getDirectionMap(a)
    });
    return new t(new zI(i));
  }, t.fromJS = function(n) {
    return new t(new zI(HI({}, n, {
      directionMap: n.directionMap != null ? WI(n.directionMap) : n.directionMap,
      inlineStyleOverride: n.inlineStyleOverride != null ? S6(n.inlineStyleOverride) : n.inlineStyleOverride,
      nativelyRenderedContent: n.nativelyRenderedContent != null ? wp.fromJS(n.nativelyRenderedContent) : n.nativelyRenderedContent,
      redoStack: n.redoStack != null ? gu(n.redoStack.map(function(a) {
        return wp.fromJS(a);
      })) : n.redoStack,
      selection: n.selection != null ? new p_(n.selection) : n.selection,
      treeMap: n.treeMap != null ? WI(n.treeMap).map(function(a) {
        return AEe(a).map(function(s) {
          return lx.fromJS(s);
        });
      }) : n.treeMap,
      undoStack: n.undoStack != null ? gu(n.undoStack.map(function(a) {
        return wp.fromJS(a);
      })) : n.undoStack,
      currentContent: wp.fromJS(n.currentContent)
    })));
  }, t.set = function(n, a) {
    var s = n.getImmutable().withMutations(function(i) {
      var o = i.get("decorator"), l = o;
      a.decorator === null ? l = null : a.decorator && (l = a.decorator);
      var c = a.currentContent || n.getCurrentContent();
      if (l !== o) {
        var u = i.get("treeMap"), d;
        l && o ? d = IEe(c, c.getBlockMap(), u, l, o) : d = qI(c, l), i.merge({
          decorator: l,
          treeMap: d,
          nativelyRenderedContent: null
        });
        return;
      }
      var f = n.getCurrentContent();
      c !== f && i.set("treeMap", REe(n, c.getBlockMap(), c.getEntityMap(), l)), i.merge(a);
    });
    return new t(s);
  };
  var e = t.prototype;
  e.toJS = function() {
    return this.getImmutable().toJS();
  }, e.getAllowUndo = function() {
    return this.getImmutable().get("allowUndo");
  }, e.getCurrentContent = function() {
    return this.getImmutable().get("currentContent");
  }, e.getUndoStack = function() {
    return this.getImmutable().get("undoStack");
  }, e.getRedoStack = function() {
    return this.getImmutable().get("redoStack");
  }, e.getSelection = function() {
    return this.getImmutable().get("selection");
  }, e.getDecorator = function() {
    return this.getImmutable().get("decorator");
  }, e.isInCompositionMode = function() {
    return this.getImmutable().get("inCompositionMode");
  }, e.mustForceSelection = function() {
    return this.getImmutable().get("forceSelection");
  }, e.getNativelyRenderedContent = function() {
    return this.getImmutable().get("nativelyRenderedContent");
  }, e.getLastChangeType = function() {
    return this.getImmutable().get("lastChangeType");
  }, e.getInlineStyleOverride = function() {
    return this.getImmutable().get("inlineStyleOverride");
  }, t.setInlineStyleOverride = function(n, a) {
    return t.set(n, {
      inlineStyleOverride: a
    });
  }, e.getCurrentInlineStyle = function() {
    var n = this.getInlineStyleOverride();
    if (n != null)
      return n;
    var a = this.getCurrentContent(), s = this.getSelection();
    return s.isCollapsed() ? NEe(a, s) : MEe(a, s);
  }, e.getBlockTree = function(n) {
    return this.getImmutable().getIn(["treeMap", n]);
  }, e.isSelectionAtStartOfContent = function() {
    var n = this.getCurrentContent().getBlockMap().first().getKey();
    return this.getSelection().hasEdgeWithin(n, 0, 0);
  }, e.isSelectionAtEndOfContent = function() {
    var n = this.getCurrentContent(), a = n.getBlockMap(), s = a.last(), i = s.getLength();
    return this.getSelection().hasEdgeWithin(s.getKey(), i, i);
  }, e.getDirectionMap = function() {
    return this.getImmutable().get("directionMap");
  }, t.acceptSelection = function(n, a) {
    return KI(n, a, !1);
  }, t.forceSelection = function(n, a) {
    return a.getHasFocus() || (a = a.set("hasFocus", !0)), KI(n, a, !0);
  }, t.moveSelectionToEnd = function(n) {
    var a = n.getCurrentContent(), s = a.getLastBlock(), i = s.getKey(), o = s.getLength();
    return t.acceptSelection(n, new p_({
      anchorKey: i,
      anchorOffset: o,
      focusKey: i,
      focusOffset: o,
      isBackward: !1
    }));
  }, t.moveFocusToEnd = function(n) {
    var a = t.moveSelectionToEnd(n);
    return t.forceSelection(a, a.getSelection());
  }, t.push = function(n, a, s) {
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
    if (n.getCurrentContent() === a)
      return n;
    var o = l0.getDirectionMap(a, n.getDirectionMap());
    if (!n.getAllowUndo())
      return t.set(n, {
        currentContent: a,
        directionMap: o,
        lastChangeType: s,
        selection: a.getSelectionAfter(),
        forceSelection: i,
        inlineStyleOverride: null
      });
    var l = n.getSelection(), c = n.getCurrentContent(), u = n.getUndoStack(), d = a;
    l !== c.getSelectionAfter() || DEe(n, s) ? (u = u.push(c), d = d.set("selectionBefore", l)) : (s === "insert-characters" || s === "backspace-character" || s === "delete-character") && (d = d.set("selectionBefore", c.getSelectionBefore()));
    var f = n.getInlineStyleOverride(), h = ["adjust-depth", "change-block-type", "split-block"];
    h.indexOf(s) === -1 && (f = null);
    var p = {
      currentContent: d,
      directionMap: o,
      undoStack: u,
      redoStack: gu(),
      lastChangeType: s,
      selection: a.getSelectionAfter(),
      forceSelection: i,
      inlineStyleOverride: f
    };
    return t.set(n, p);
  }, t.undo = function(n) {
    if (!n.getAllowUndo())
      return n;
    var a = n.getUndoStack(), s = a.peek();
    if (!s)
      return n;
    var i = n.getCurrentContent(), o = l0.getDirectionMap(s, n.getDirectionMap());
    return t.set(n, {
      currentContent: s,
      directionMap: o,
      undoStack: a.shift(),
      redoStack: n.getRedoStack().push(i),
      forceSelection: !0,
      inlineStyleOverride: null,
      lastChangeType: "undo",
      nativelyRenderedContent: null,
      selection: i.getSelectionBefore()
    });
  }, t.redo = function(n) {
    if (!n.getAllowUndo())
      return n;
    var a = n.getRedoStack(), s = a.peek();
    if (!s)
      return n;
    var i = n.getCurrentContent(), o = l0.getDirectionMap(s, n.getDirectionMap());
    return t.set(n, {
      currentContent: s,
      directionMap: o,
      undoStack: n.getUndoStack().push(i),
      redoStack: a.shift(),
      forceSelection: !0,
      inlineStyleOverride: null,
      lastChangeType: "redo",
      nativelyRenderedContent: null,
      selection: s.getSelectionAfter()
    });
  };
  function t(r) {
    _6(this, "_immutable", void 0), this._immutable = r;
  }
  return e.getImmutable = function() {
    return this._immutable;
  }, t;
}();
function KI(e, t, r) {
  return E6.set(e, {
    selection: t,
    forceSelection: r,
    nativelyRenderedContent: null,
    inlineStyleOverride: null
  });
}
function qI(e, t) {
  return e.getBlockMap().map(function(r) {
    return lx.generate(e, r, t);
  }).toOrderedMap();
}
function REe(e, t, r, n) {
  var a = e.getCurrentContent().set("entityMap", r), s = a.getBlockMap(), i = e.getImmutable().get("treeMap");
  return i.merge(t.toSeq().filter(function(o, l) {
    return o !== s.get(l);
  }).map(function(o) {
    return lx.generate(a, o, n);
  }));
}
function IEe(e, t, r, n, a) {
  return r.merge(t.toSeq().filter(function(s) {
    return n.getDecorations(s, e) !== a.getDecorations(s, e);
  }).map(function(s) {
    return lx.generate(e, s, n);
  }));
}
function DEe(e, t) {
  var r = e.getLastChangeType();
  return t !== r || t !== "insert-characters" && t !== "backspace-character" && t !== "delete-character";
}
function NEe(e, t) {
  var r = t.getStartKey(), n = t.getStartOffset(), a = e.getBlockForKey(r);
  return n > 0 ? a.getInlineStyleAt(n - 1) : a.getLength() ? a.getInlineStyleAt(0) : T6(e, r);
}
function MEe(e, t) {
  var r = t.getStartKey(), n = t.getStartOffset(), a = e.getBlockForKey(r);
  return n < a.getLength() ? a.getInlineStyleAt(n) : n > 0 ? a.getInlineStyleAt(n - 1) : T6(e, r);
}
function T6(e, t) {
  var r = e.getBlockMap().reverse().skipUntil(function(n, a) {
    return a === t;
  }).skip(1).skipUntil(function(n, a) {
    return n.getLength();
  }).first();
  return r ? r.getInlineStyleAt(r.getLength() - 1) : S6();
}
var ln = E6, c0 = {}, LEe = vi, jEe = s6, C6 = Tr, Zl = jr, FEe = C6.OrderedMap, BEe = C6.List, tu = function(t, r, n) {
  if (t) {
    var a = r.get(t);
    a && r.set(t, n(a));
  }
}, UEe = function(t, r, n, a, s) {
  if (!s)
    return t;
  var i = a === "after", o = r.getKey(), l = n.getKey(), c = r.getParentKey(), u = r.getNextSiblingKey(), d = r.getPrevSiblingKey(), f = n.getParentKey(), h = i ? n.getNextSiblingKey() : l, p = i ? l : n.getPrevSiblingKey();
  return t.withMutations(function(m) {
    tu(c, m, function(g) {
      var y = g.getChildKeys();
      return g.merge({
        children: y.delete(y.indexOf(o))
      });
    }), tu(d, m, function(g) {
      return g.merge({
        nextSibling: u
      });
    }), tu(u, m, function(g) {
      return g.merge({
        prevSibling: d
      });
    }), tu(h, m, function(g) {
      return g.merge({
        prevSibling: o
      });
    }), tu(p, m, function(g) {
      return g.merge({
        nextSibling: o
      });
    }), tu(f, m, function(g) {
      var y = g.getChildKeys(), x = y.indexOf(l), w = i ? x + 1 : x !== 0 ? x - 1 : 0, _ = y.toArray();
      return _.splice(w, 0, o), g.merge({
        children: BEe(_)
      });
    }), tu(o, m, function(g) {
      return g.merge({
        nextSibling: h,
        prevSibling: p,
        parent: f
      });
    });
  });
}, VEe = function(t, r, n, a) {
  a === "replace" && (c0.NODE_ENV !== "production" ? Zl(!1, "Replacing blocks is not supported.") : Zl(!1));
  var s = n.getKey(), i = r.getKey();
  i === s && (c0.NODE_ENV !== "production" ? Zl(!1, "Block cannot be moved next to itself.") : Zl(!1));
  var o = t.getBlockMap(), l = r instanceof LEe, c = [r], u = o.delete(i);
  l && (c = [], u = o.withMutations(function(y) {
    var x = r.getNextSiblingKey(), w = jEe(r, y);
    y.toSeq().skipUntil(function(_) {
      return _.getKey() === i;
    }).takeWhile(function(_) {
      var S = _.getKey(), C = S === i, E = x && S !== x, O = !x && _.getParentKey() && (!w || S !== w);
      return !!(C || E || O);
    }).forEach(function(_) {
      c.push(_), y.delete(_.getKey());
    });
  }));
  var d = u.toSeq().takeUntil(function(y) {
    return y === n;
  }), f = u.toSeq().skipUntil(function(y) {
    return y === n;
  }).skip(1), h = c.map(function(y) {
    return [y.getKey(), y];
  }), p = FEe();
  if (a === "before") {
    var m = t.getBlockBefore(s);
    !m || m.getKey() !== r.getKey() || (c0.NODE_ENV !== "production" ? Zl(!1, "Block cannot be moved next to itself.") : Zl(!1)), p = d.concat([].concat(h, [[s, n]]), f).toOrderedMap();
  } else if (a === "after") {
    var g = t.getBlockAfter(s);
    !g || g.getKey() !== i || (c0.NODE_ENV !== "production" ? Zl(!1, "Block cannot be moved next to itself.") : Zl(!1)), p = d.concat([[s, n]].concat(h), f).toOrderedMap();
  }
  return t.merge({
    blockMap: UEe(p, r, n, a, l),
    selectionBefore: t.getSelectionAfter(),
    selectionAfter: t.getSelectionAfter().merge({
      anchorKey: i,
      focusKey: i
    })
  });
}, $Ee = VEe;
function GI(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    }))), n.forEach(function(a) {
      HEe(e, a, r[a]);
    });
  }
  return e;
}
function HEe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var WEe = Fg, zEe = gi, KEe = cd, qEe = vi, Wd = Cs, YI = ln, XI = Wo, GEe = Gc, k6 = Tr, u0 = $Ee, O6 = GEe("draft_tree_data_support"), QI = O6 ? qEe : KEe, YEe = k6.List, XEe = k6.Repeat, QEe = {
  insertAtomicBlock: function(t, r, n) {
    var a = t.getCurrentContent(), s = t.getSelection(), i = Wd.removeRange(a, s, "backward"), o = i.getSelectionAfter(), l = Wd.splitBlock(i, o), c = l.getSelectionAfter(), u = Wd.setBlockType(l, c, "atomic"), d = zEe.create({
      entity: r
    }), f = {
      key: XI(),
      type: "atomic",
      text: n,
      characterList: YEe(XEe(d, n.length))
    }, h = {
      key: XI(),
      type: "unstyled"
    };
    O6 && (f = GI({}, f, {
      nextSibling: h.key
    }), h = GI({}, h, {
      prevSibling: f.key
    }));
    var p = [new QI(f), new QI(h)], m = WEe.createFromArray(p), g = Wd.replaceWithFragment(u, c, m), y = g.merge({
      selectionBefore: s,
      selectionAfter: g.getSelectionAfter().set("hasFocus", !0)
    });
    return YI.push(t, y, "insert-fragment");
  },
  moveAtomicBlock: function(t, r, n, a) {
    var s = t.getCurrentContent(), i = t.getSelection(), o;
    if (a === "before" || a === "after") {
      var l = s.getBlockForKey(a === "before" ? n.getStartKey() : n.getEndKey());
      o = u0(s, r, l, a);
    } else {
      var c = Wd.removeRange(s, n, "backward"), u = c.getSelectionAfter(), d = c.getBlockForKey(u.getFocusKey());
      if (u.getStartOffset() === 0)
        o = u0(c, r, d, "before");
      else if (u.getEndOffset() === d.getLength())
        o = u0(c, r, d, "after");
      else {
        var f = Wd.splitBlock(c, u), h = f.getSelectionAfter(), p = f.getBlockForKey(h.getFocusKey());
        o = u0(f, r, p, "before");
      }
    }
    var m = o.merge({
      selectionBefore: i,
      selectionAfter: o.getSelectionAfter().set("hasFocus", !0)
    });
    return YI.push(t, m, "move-block");
  }
}, JEe = QEe;
function ZEe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var eTe = Tr, tTe = eTe.List, m_ = ".", rTe = /* @__PURE__ */ function() {
  function e(r) {
    ZEe(this, "_decorators", void 0), this._decorators = r.slice();
  }
  var t = e.prototype;
  return t.getDecorations = function(n, a) {
    var s = Array(n.getText().length).fill(null);
    return this._decorators.forEach(function(i, o) {
      var l = 0, c = i.strategy, u = function(f, h) {
        nTe(s, f, h) && (aTe(s, f, h, o + m_ + l), l++);
      };
      c(n, u, a);
    }), tTe(s);
  }, t.getComponentForKey = function(n) {
    var a = parseInt(n.split(m_)[0], 10);
    return this._decorators[a].component;
  }, t.getPropsForKey = function(n) {
    var a = parseInt(n.split(m_)[0], 10);
    return this._decorators[a].props;
  }, e;
}();
function nTe(e, t, r) {
  for (var n = t; n < r; n++)
    if (e[n] != null)
      return !1;
  return !0;
}
function aTe(e, t, r, n) {
  for (var a = t; a < r; a++)
    e[a] = n;
}
var sTe = rTe;
function iTe(e) {
  return typeof e == "object" ? Object.keys(e).filter(function(t) {
    return e[t];
  }).map(JI).join(" ") : Array.prototype.map.call(arguments, JI).join(" ");
}
function JI(e) {
  return e.replace(/\//g, "-");
}
var ud = iTe, hk = M, pk = ud, oTe = Tr, lTe = oTe.Map, cTe = hk.createElement("ul", {
  className: pk("public/DraftStyleDefault/ul")
}), uTe = hk.createElement("ol", {
  className: pk("public/DraftStyleDefault/ol")
}), dTe = hk.createElement("pre", {
  className: pk("public/DraftStyleDefault/pre")
}), fTe = lTe({
  "header-one": {
    element: "h1"
  },
  "header-two": {
    element: "h2"
  },
  "header-three": {
    element: "h3"
  },
  "header-four": {
    element: "h4"
  },
  "header-five": {
    element: "h5"
  },
  "header-six": {
    element: "h6"
  },
  section: {
    element: "section"
  },
  article: {
    element: "article"
  },
  "unordered-list-item": {
    element: "li",
    wrapper: cTe
  },
  "ordered-list-item": {
    element: "li",
    wrapper: uTe
  },
  blockquote: {
    element: "blockquote"
  },
  atomic: {
    element: "figure"
  },
  "code-block": {
    element: "pre",
    wrapper: dTe
  },
  unstyled: {
    element: "div",
    aliasedElements: ["p"]
  }
}), mk = fTe, A6 = {
  BOLD: {
    fontWeight: "bold"
  },
  CODE: {
    fontFamily: "monospace",
    wordWrap: "break-word"
  },
  ITALIC: {
    fontStyle: "italic"
  },
  STRIKETHROUGH: {
    textDecoration: "line-through"
  },
  UNDERLINE: {
    textDecoration: "underline"
  }
}, HE = { exports: {} };
(function(e, t) {
  (function(r, n) {
    var a = "0.7.40", s = "", i = "?", o = "function", l = "undefined", c = "object", u = "string", d = "major", f = "model", h = "name", p = "type", m = "vendor", g = "version", y = "architecture", x = "console", w = "mobile", _ = "tablet", S = "smarttv", C = "wearable", E = "embedded", O = 500, k = "Amazon", A = "Apple", P = "ASUS", D = "BlackBerry", N = "Browser", z = "Chrome", G = "Edge", Y = "Firefox", te = "Google", ae = "Huawei", ne = "LG", ue = "Microsoft", q = "Motorola", U = "Opera", Q = "Samsung", L = "Sharp", j = "Sony", K = "Xiaomi", J = "Zebra", re = "Facebook", le = "Chromium OS", pe = "Mac OS", me = " Browser", Oe = function(_e, Ae) {
      var Ve = {};
      for (var mt in _e)
        Ae[mt] && Ae[mt].length % 2 === 0 ? Ve[mt] = Ae[mt].concat(_e[mt]) : Ve[mt] = _e[mt];
      return Ve;
    }, ee = function(_e) {
      for (var Ae = {}, Ve = 0; Ve < _e.length; Ve++)
        Ae[_e[Ve].toUpperCase()] = _e[Ve];
      return Ae;
    }, he = function(_e, Ae) {
      return typeof _e === u ? Ee(Ae).indexOf(Ee(_e)) !== -1 : !1;
    }, Ee = function(_e) {
      return _e.toLowerCase();
    }, we = function(_e) {
      return typeof _e === u ? _e.replace(/[^\d\.]/g, s).split(".")[0] : n;
    }, Pe = function(_e, Ae) {
      if (typeof _e === u)
        return _e = _e.replace(/^\s\s*/, s), typeof Ae === l ? _e : _e.substring(0, O);
    }, rt = function(_e, Ae) {
      for (var Ve = 0, mt, Dt, Gt, $t, Rt, Pr; Ve < Ae.length && !Rt; ) {
        var fr = Ae[Ve], ca = Ae[Ve + 1];
        for (mt = Dt = 0; mt < fr.length && !Rt && fr[mt]; )
          if (Rt = fr[mt++].exec(_e), Rt)
            for (Gt = 0; Gt < ca.length; Gt++)
              Pr = Rt[++Dt], $t = ca[Gt], typeof $t === c && $t.length > 0 ? $t.length === 2 ? typeof $t[1] == o ? this[$t[0]] = $t[1].call(this, Pr) : this[$t[0]] = $t[1] : $t.length === 3 ? typeof $t[1] === o && !($t[1].exec && $t[1].test) ? this[$t[0]] = Pr ? $t[1].call(this, Pr, $t[2]) : n : this[$t[0]] = Pr ? Pr.replace($t[1], $t[2]) : n : $t.length === 4 && (this[$t[0]] = Pr ? $t[3].call(this, Pr.replace($t[1], $t[2])) : n) : this[$t] = Pr || n;
        Ve += 2;
      }
    }, ht = function(_e, Ae) {
      for (var Ve in Ae)
        if (typeof Ae[Ve] === c && Ae[Ve].length > 0) {
          for (var mt = 0; mt < Ae[Ve].length; mt++)
            if (he(Ae[Ve][mt], _e))
              return Ve === i ? n : Ve;
        } else if (he(Ae[Ve], _e))
          return Ve === i ? n : Ve;
      return Ae.hasOwnProperty("*") ? Ae["*"] : _e;
    }, bt = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, Ge = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, oe = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [g, [h, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [g, [h, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [h, g],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [g, [h, U + " Mini"]],
        [
          /\bop(?:rg)?x\/([\w\.]+)/i
          // Opera GX
        ],
        [g, [h, U + " GX"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [g, [h, U]],
        [
          // Mixed
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
          // Baidu
        ],
        [g, [h, "Baidu"]],
        [
          /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
          // Maxthon
        ],
        [g, [h, "Maxthon"]],
        [
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
          // Trident based
          /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
          // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
          /(heytap|ovi|115)browser\/([\d\.]+)/i,
          // HeyTap/Ovi/115
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [h, g],
        [
          /quark(?:pc)?\/([-\w\.]+)/i
          // Quark
        ],
        [g, [h, "Quark"]],
        [
          /\bddg\/([\w\.]+)/i
          // DuckDuckGo
        ],
        [g, [h, "DuckDuckGo"]],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [g, [h, "UC" + N]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [g, [h, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [g, [h, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [g, [h, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [g, [h, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
          // Smart Lenovo Browser
        ],
        [g, [h, "Smart Lenovo " + N]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[h, /(.+)/, "$1 Secure " + N], g],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [g, [h, Y + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [g, [h, U + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [g, [h, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [g, [h, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [g, [h, U + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [g, [h, "MIUI" + me]],
        [
          /fxios\/([\w\.-]+)/i
          // Firefox for iOS
        ],
        [g, [h, Y]],
        [
          /\bqihoobrowser\/?([\w\.]*)/i
          // 360
        ],
        [g, [h, "360"]],
        [
          /\b(qq)\/([\w\.]+)/i
          // QQ
        ],
        [[h, /(.+)/, "$1Browser"], g],
        [
          /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
        ],
        [[h, /(.+)/, "$1" + me], g],
        [
          // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
          /samsungbrowser\/([\w\.]+)/i
          // Samsung Internet
        ],
        [g, [h, Q + " Internet"]],
        [
          /metasr[\/ ]?([\d\.]+)/i
          // Sogou Explorer
        ],
        [g, [h, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
          // Sogou Mobile
        ],
        [[h, "Sogou Mobile"], g],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
          // QQ/2345
        ],
        [h, g],
        [
          /(lbbrowser|rekonq)/i,
          // LieBao Browser/Rekonq
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [h],
        [
          /ome\/([\w\.]+) \w* ?(iron) saf/i,
          // Iron
          /ome\/([\w\.]+).+qihu (360)[es]e/i
          // 360
        ],
        [g, h],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[h, re], g],
        [
          /(Klarna)\/([\w\.]+)/i,
          // Klarna Shopping Browser for iOS & Android
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(alipay)client\/([\w\.]+)/i,
          // Alipay
          /(twitter)(?:and| f.+e\/([\w\.]+))/i,
          // Twitter
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram/Snapchat
        ],
        [h, g],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [g, [h, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [g, [h, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [g, [h, z + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[h, z + " WebView"], g],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [g, [h, "Android " + N]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [h, g],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [g, [h, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [g, h],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [h, [g, ht, bt]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [h, g],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[h, "Netscape"], g],
        [
          /(wolvic|librewolf)\/([\w\.]+)/i
          // Wolvic/LibreWolf
        ],
        [h, g],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [g, [h, Y + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i
          // Links
        ],
        [h, [g, /_/g, "."]],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [h, [g, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[y, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[y, Ee]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[y, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[y, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[y, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[y, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[y, /ower/, s, Ee]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[y, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[y, Ee]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [f, [m, Q], [p, _]],
        [
          /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]((?!sm-[lr])[-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [f, [m, Q], [p, w]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [f, [m, A], [p, w]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [f, [m, A], [p, _]],
        [
          /(macintosh);/i
        ],
        [f, [m, A]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [f, [m, L], [p, w]],
        [
          // Honor
          /(?:honor)([-\w ]+)[;\)]/i
        ],
        [f, [m, "Honor"], [p, w]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [f, [m, ae], [p, _]],
        [
          /(?:huawei)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [f, [m, ae], [p, w]],
        [
          // Xiaomi
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          // Xiaomi Redmi 'numeric' models
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[f, /_/g, " "], [m, K], [p, w]],
        [
          /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
          // Redmi Pad
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[f, /_/g, " "], [m, K], [p, _]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [f, [m, "OPPO"], [p, w]],
        [
          /\b(opd2\d{3}a?) bui/i
        ],
        [f, [m, "OPPO"], [p, _]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [f, [m, "Vivo"], [p, w]],
        [
          // Realme
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [f, [m, "Realme"], [p, w]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [f, [m, q], [p, w]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [f, [m, q], [p, _]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [f, [m, ne], [p, _]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [f, [m, ne], [p, w]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [f, [m, "Lenovo"], [p, _]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[f, /_/g, " "], [m, "Nokia"], [p, w]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [f, [m, te], [p, _]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [f, [m, te], [p, w]],
        [
          // Sony
          /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [f, [m, j], [p, w]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[f, "Xperia Tablet"], [m, j], [p, _]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [f, [m, "OnePlus"], [p, w]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [f, [m, k], [p, _]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[f, /(.+)/g, "Fire Phone $1"], [m, k], [p, w]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [f, m, [p, _]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [f, [m, D], [p, w]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [f, [m, P], [p, _]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [f, [m, P], [p, w]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [f, [m, "HTC"], [p, _]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [m, [f, /_/g, " "], [p, w]],
        [
          // TCL
          /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
        ],
        [f, [m, "TCL"], [p, _]],
        [
          // itel
          /(itel) ((\w+))/i
        ],
        [[m, Ee], f, [p, ht, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [f, [m, "Acer"], [p, _]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [f, [m, "Meizu"], [p, w]],
        [
          // Ulefone
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [f, [m, "Ulefone"], [p, w]],
        [
          // Energizer
          /; (energy ?\w+)(?: bui|\))/i,
          /; energizer ([\w ]+)(?: bui|\))/i
        ],
        [f, [m, "Energizer"], [p, w]],
        [
          // Cat
          /; cat (b35);/i,
          /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
        ],
        [f, [m, "Cat"], [p, w]],
        [
          // Smartfren
          /((?:new )?andromax[\w- ]+)(?: bui|\))/i
        ],
        [f, [m, "Smartfren"], [p, w]],
        [
          // Nothing
          /droid.+; (a(?:015|06[35]|142p?))/i
        ],
        [f, [m, "Nothing"], [p, w]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
          /; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i,
          // IMO
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [m, f, [p, w]],
        [
          /(imo) (tab \w+)/i,
          // IMO
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [m, f, [p, _]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [f, [m, ue], [p, _]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [f, [m, "Fairphone"], [p, w]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [f, [m, "AT&T"], [p, w]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [f, [m, "Siemens"], [p, w]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [f, [m, "RCA"], [p, _]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [f, [m, "Dell"], [p, _]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [f, [m, "Verizon"], [p, _]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [f, [m, "Barnes & Noble"], [p, _]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [f, [m, "NuVision"], [p, _]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [f, [m, "ZTE"], [p, _]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [f, [m, "ZTE"], [p, w]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [f, [m, "Swiss"], [p, w]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [f, [m, "Swiss"], [p, _]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [f, [m, "Zeki"], [p, _]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[m, "Dragon Touch"], f, [p, _]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [f, [m, "Insignia"], [p, _]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [f, [m, "NextBook"], [p, _]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[m, "Voice"], f, [p, w]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[m, "LvTel"], f, [p, w]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [f, [m, "Essential"], [p, w]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [f, [m, "Envizen"], [p, _]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [f, [m, "MachSpeed"], [p, _]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [f, [m, "Rotor"], [p, _]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [f, [m, "Nvidia"], [p, _]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [m, f, [p, w]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[f, /\./g, " "], [m, ue], [p, w]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [f, [m, J], [p, _]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [f, [m, J], [p, w]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [m, [p, S]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[f, /^/, "SmartTV"], [m, Q], [p, S]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[m, ne], [p, S]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [m, [f, A + " TV"], [p, S]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[f, z + "cast"], [m, te], [p, S]],
        [
          /droid.+aft(\w+)( bui|\))/i
          // Fire TV
        ],
        [f, [m, k], [p, S]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [f, [m, L], [p, S]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [f, [m, j], [p, S]],
        [
          /(mitv-\w{5}) bui/i
          // Xiaomi
        ],
        [f, [m, K], [p, S]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [m, f, [p, S]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[m, Pe], [f, Pe], [p, S]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[p, S]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [m, f, [p, x]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [f, [m, "Nvidia"], [p, x]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [f, [m, j], [p, x]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [f, [m, ue], [p, x]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i
          // Samsung Galaxy Watch
        ],
        [f, [m, Q], [p, C]],
        [
          /((pebble))app/i
          // Pebble
        ],
        [m, f, [p, C]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [f, [m, A], [p, C]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [f, [m, te], [p, C]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [f, [m, J], [p, C]],
        [
          ///////////////////
          // XR
          ///////////////////
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [f, [m, te], [p, C]],
        [
          /(pico) (4|neo3(?: link|pro)?)/i
          // Pico
        ],
        [m, f, [p, C]],
        [
          /; (quest( \d| pro)?)/i
          // Oculus Quest
        ],
        [f, [m, re], [p, C]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [m, [p, E]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [f, [m, k], [p, E]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [f, [p, w]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [f, [p, _]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[p, _]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[p, w]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [f, [m, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [g, [h, G + "HTML"]],
        [
          /(arkweb)\/([\w\.]+)/i
          // ArkWeb
        ],
        [h, g],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [g, [h, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
        ],
        [h, g],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [g, h]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [h, g],
        [
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
          // Windows Phone
        ],
        [h, [g, ht, Ge]],
        [
          /windows nt 6\.2; (arm)/i,
          // Windows RT
          /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[g, ht, Ge], [h, "Windows"]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[g, /_/g, "."], [h, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[h, pe], [g, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [g, h],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS/OpenHarmony
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [h, g],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [g, [h, D]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [g, [h, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [g, [h, Y + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [g, [h, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [g, [h, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [g, [h, z + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[h, le], g],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [h, g],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[h, "Solaris"], g],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [h, g]
      ]
    }, ve = function(_e, Ae) {
      if (typeof _e === c && (Ae = _e, _e = n), !(this instanceof ve))
        return new ve(_e, Ae).getResult();
      var Ve = typeof r !== l && r.navigator ? r.navigator : n, mt = _e || (Ve && Ve.userAgent ? Ve.userAgent : s), Dt = Ve && Ve.userAgentData ? Ve.userAgentData : n, Gt = Ae ? Oe(oe, Ae) : oe, $t = Ve && Ve.userAgent == mt;
      return this.getBrowser = function() {
        var Rt = {};
        return Rt[h] = n, Rt[g] = n, rt.call(Rt, mt, Gt.browser), Rt[d] = we(Rt[g]), $t && Ve && Ve.brave && typeof Ve.brave.isBrave == o && (Rt[h] = "Brave"), Rt;
      }, this.getCPU = function() {
        var Rt = {};
        return Rt[y] = n, rt.call(Rt, mt, Gt.cpu), Rt;
      }, this.getDevice = function() {
        var Rt = {};
        return Rt[m] = n, Rt[f] = n, Rt[p] = n, rt.call(Rt, mt, Gt.device), $t && !Rt[p] && Dt && Dt.mobile && (Rt[p] = w), $t && Rt[f] == "Macintosh" && Ve && typeof Ve.standalone !== l && Ve.maxTouchPoints && Ve.maxTouchPoints > 2 && (Rt[f] = "iPad", Rt[p] = _), Rt;
      }, this.getEngine = function() {
        var Rt = {};
        return Rt[h] = n, Rt[g] = n, rt.call(Rt, mt, Gt.engine), Rt;
      }, this.getOS = function() {
        var Rt = {};
        return Rt[h] = n, Rt[g] = n, rt.call(Rt, mt, Gt.os), $t && !Rt[h] && Dt && Dt.platform && Dt.platform != "Unknown" && (Rt[h] = Dt.platform.replace(/chrome os/i, le).replace(/macos/i, pe)), Rt;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return mt;
      }, this.setUA = function(Rt) {
        return mt = typeof Rt === u && Rt.length > O ? Pe(Rt, O) : Rt, this;
      }, this.setUA(mt), this;
    };
    ve.VERSION = a, ve.BROWSER = ee([h, g, d]), ve.CPU = ee([y]), ve.DEVICE = ee([f, m, p, x, w, S, _, C, E]), ve.ENGINE = ve.OS = ee([h, g]), e.exports && (t = e.exports = ve), t.UAParser = ve;
    var ye = typeof r !== l && (r.jQuery || r.Zepto);
    if (ye && !ye.ua) {
      var Te = new ve();
      ye.ua = Te.getResult(), ye.ua.get = function() {
        return Te.getUA();
      }, ye.ua.set = function(_e) {
        Te.setUA(_e);
        var Ae = Te.getResult();
        for (var Ve in Ae)
          ye.ua[Ve] = Ae[Ve];
      };
    }
  })(typeof window == "object" ? window : ke);
})(HE, HE.exports);
var hTe = HE.exports, pTe = hTe, Xs = "Unknown", mTe = {
  "Mac OS": "Mac OS X"
};
function gTe(e) {
  return mTe[e] || e;
}
function vTe(e) {
  if (!e)
    return {
      major: "",
      minor: ""
    };
  var t = e.split(".");
  return {
    major: t[0],
    minor: t[1]
  };
}
var yTe = new pTe(), Zs = yTe.getResult(), bTe = vTe(Zs.browser.version), wTe = {
  browserArchitecture: Zs.cpu.architecture || Xs,
  browserFullVersion: Zs.browser.version || Xs,
  browserMinorVersion: bTe.minor || Xs,
  browserName: Zs.browser.name || Xs,
  browserVersion: Zs.browser.major || Xs,
  deviceName: Zs.device.model || Xs,
  engineName: Zs.engine.name || Xs,
  engineVersion: Zs.engine.version || Xs,
  platformArchitecture: Zs.cpu.architecture || Xs,
  platformName: gTe(Zs.os.name) || Xs,
  platformVersion: Zs.os.version || Xs,
  platformFullVersion: Zs.os.version || Xs
}, xTe = wTe, Tb = {}, gc = jr, P6 = /\./, _Te = /\|\|/, STe = /\s+\-\s+/, ETe = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/, ZI = /^(\d*)(.*)/;
function TTe(e, t) {
  var r = e.split(_Te);
  return r.length > 1 ? r.some(function(n) {
    return N6.contains(n, t);
  }) : (e = r[0].trim(), CTe(e, t));
}
function CTe(e, t) {
  var r = e.split(STe);
  if (r.length > 0 && r.length <= 2 || (Tb.NODE_ENV !== "production" ? gc(!1, 'the "-" operator expects exactly 2 operands') : gc(!1)), r.length === 1)
    return g_(r[0], t);
  var n = r[0], a = r[1];
  return eD(n) && eD(a) || (Tb.NODE_ENV !== "production" ? gc(!1, 'operands to the "-" operator must be simple (no modifiers)') : gc(!1)), g_(">=" + n, t) && g_("<=" + a, t);
}
function g_(e, t) {
  if (e = e.trim(), e === "")
    return !0;
  var r = t.split(P6), n = D6(e), a = n.modifier, s = n.rangeComponents;
  switch (a) {
    case "<":
      return R6(r, s);
    case "<=":
      return kTe(r, s);
    case ">=":
      return I6(r, s);
    case ">":
      return ATe(r, s);
    case "~":
    case "~>":
      return PTe(r, s);
    default:
      return OTe(r, s);
  }
}
function R6(e, t) {
  return Wg(e, t) === -1;
}
function kTe(e, t) {
  var r = Wg(e, t);
  return r === -1 || r === 0;
}
function OTe(e, t) {
  return Wg(e, t) === 0;
}
function I6(e, t) {
  var r = Wg(e, t);
  return r === 1 || r === 0;
}
function ATe(e, t) {
  return Wg(e, t) === 1;
}
function PTe(e, t) {
  var r = t.slice(), n = t.slice();
  n.length > 1 && n.pop();
  var a = n.length - 1, s = parseInt(n[a], 10);
  return WE(s) && (n[a] = s + 1 + ""), I6(e, r) && R6(e, n);
}
function D6(e) {
  var t = e.split(P6), r = t[0].match(ETe);
  return r || (Tb.NODE_ENV !== "production" ? gc(!1, "expected regex to match but it did not") : gc(!1)), {
    modifier: r[1],
    rangeComponents: [r[2]].concat(t.slice(1))
  };
}
function WE(e) {
  return !isNaN(e) && isFinite(e);
}
function eD(e) {
  return !D6(e).modifier;
}
function tD(e, t) {
  for (var r = e.length; r < t; r++)
    e[r] = "0";
}
function RTe(e, t) {
  e = e.slice(), t = t.slice(), tD(e, t.length);
  for (var r = 0; r < t.length; r++) {
    var n = t[r].match(/^[x*]$/i);
    if (n && (t[r] = e[r] = "0", n[0] === "*" && r === t.length - 1))
      for (var a = r; a < e.length; a++)
        e[a] = "0";
  }
  return tD(t, e.length), [e, t];
}
function ITe(e, t) {
  var r = e.match(ZI)[1], n = t.match(ZI)[1], a = parseInt(r, 10), s = parseInt(n, 10);
  return WE(a) && WE(s) && a !== s ? rD(a, s) : rD(e, t);
}
function rD(e, t) {
  return typeof e != typeof t && (Tb.NODE_ENV !== "production" ? gc(!1, '"a" and "b" must be of the same type') : gc(!1)), e > t ? 1 : e < t ? -1 : 0;
}
function Wg(e, t) {
  for (var r = RTe(e, t), n = r[0], a = r[1], s = 0; s < a.length; s++) {
    var i = ITe(n[s], a[s]);
    if (i)
      return i;
  }
  return 0;
}
var N6 = {
  /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
  contains: function(t, r) {
    return TTe(t.trim(), r.trim());
  }
}, DTe = N6, NTe = Object.prototype.hasOwnProperty;
function MTe(e, t, r) {
  if (!e)
    return null;
  var n = {};
  for (var a in e)
    NTe.call(e, a) && (n[a] = t.call(r, e[a], a, e));
  return n;
}
var LTe = MTe;
function jTe(e) {
  var t = {};
  return function(r) {
    return t.hasOwnProperty(r) || (t[r] = e.call(this, r)), t[r];
  };
}
var FTe = jTe, oo = xTe, BTe = DTe, UTe = LTe, VTe = FTe;
function zd(e, t, r, n) {
  if (e === r)
    return !0;
  if (!r.startsWith(e))
    return !1;
  var a = r.slice(e.length);
  return t ? (a = n ? n(a) : a, BTe.contains(a, t)) : !1;
}
function $Te(e) {
  return oo.platformName === "Windows" ? e.replace(/^\s*NT/, "") : e;
}
var HTe = {
  /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isBrowser: function(t) {
    return zd(oo.browserName, oo.browserFullVersion, t);
  },
  /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isBrowserArchitecture: function(t) {
    return zd(oo.browserArchitecture, null, t);
  },
  /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
  isDevice: function(t) {
    return zd(oo.deviceName, null, t);
  },
  /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isEngine: function(t) {
    return zd(oo.engineName, oo.engineVersion, t);
  },
  /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isPlatform: function(t) {
    return zd(oo.platformName, oo.platformFullVersion, t, $Te);
  },
  /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isPlatformArchitecture: function(t) {
    return zd(oo.platformArchitecture, null, t);
  }
}, Os = UTe(HTe, VTe);
function WTe(e) {
  return !e || !e.ownerDocument ? document : e.ownerDocument;
}
var cx = WTe;
function zTe(e) {
  return !e || !e.ownerDocument ? !1 : e.nodeType === Node.ELEMENT_NODE;
}
var dd = zTe, KTe = dd;
function M6(e) {
  if (KTe(e)) {
    var t = e, r = t.getAttribute("data-offset-key");
    if (r)
      return r;
    for (var n = 0; n < t.childNodes.length; n++) {
      var a = M6(t.childNodes[n]);
      if (a)
        return a;
    }
  }
  return null;
}
var L6 = M6, qTe = cx, GTe = L6;
function YTe(e) {
  for (var t = e; t && t !== qTe(e).documentElement; ) {
    var r = GTe(t);
    if (r != null)
      return r;
    t = t.parentNode;
  }
  return null;
}
var ux = YTe;
function XTe(e) {
  return !e || !e.ownerDocument || !e.ownerDocument.defaultView ? window : e.ownerDocument.defaultView;
}
var j6 = XTe, QTe = {};
function d0(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var JTe = Os, ZTe = ux, eCe = j6, tCe = Tr, nD = jr, rCe = ks, aD = tCe.Map, nCe = {
  subtree: !0,
  characterData: !0,
  childList: !0,
  characterDataOldValue: !1,
  attributes: !1
}, sD = JTe.isBrowser("IE <= 11"), aCe = /* @__PURE__ */ function() {
  function e(r) {
    var n = this;
    d0(this, "observer", void 0), d0(this, "container", void 0), d0(this, "mutations", void 0), d0(this, "onCharData", void 0), this.container = r, this.mutations = aD();
    var a = eCe(r);
    a.MutationObserver && !sD ? this.observer = new a.MutationObserver(function(s) {
      return n.registerMutations(s);
    }) : this.onCharData = function(s) {
      s.target instanceof Node || (QTe.NODE_ENV !== "production" ? nD(!1, "Expected target to be an instance of Node") : nD(!1)), n.registerMutation({
        type: "characterData",
        target: s.target
      });
    };
  }
  var t = e.prototype;
  return t.start = function() {
    this.observer ? this.observer.observe(this.container, nCe) : this.container.addEventListener("DOMCharacterDataModified", this.onCharData);
  }, t.stopAndFlushMutations = function() {
    var n = this.observer;
    n ? (this.registerMutations(n.takeRecords()), n.disconnect()) : this.container.removeEventListener("DOMCharacterDataModified", this.onCharData);
    var a = this.mutations;
    return this.mutations = aD(), a;
  }, t.registerMutations = function(n) {
    for (var a = 0; a < n.length; a++)
      this.registerMutation(n[a]);
  }, t.getMutationTextContent = function(n) {
    var a = n.type, s = n.target, i = n.removedNodes;
    if (a === "characterData") {
      if (s.textContent !== "")
        return sD ? s.textContent.replace(`
`, "") : s.textContent;
    } else if (a === "childList") {
      if (i && i.length)
        return "";
      if (s.textContent !== "")
        return s.textContent;
    }
    return null;
  }, t.registerMutation = function(n) {
    var a = this.getMutationTextContent(n);
    if (a != null) {
      var s = rCe(ZTe(n.target));
      this.mutations = this.mutations.set(s, a);
    }
  }, e;
}(), sCe = aCe, f0 = "-", iCe = {
  encode: function(t, r, n) {
    return t + f0 + r + f0 + n;
  },
  decode: function(t) {
    var r = t.split(f0).reverse(), n = r[0], a = r[1], s = r.slice(2);
    return {
      // Recomposes the parts of blockKey after reversing them
      blockKey: s.reverse().join(f0),
      decoratorKey: parseInt(a, 10),
      leafKey: parseInt(n, 10)
    };
  }
}, zl = iCe, dx = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46
}, F6 = {
  logBlockedSelectionEvent: function() {
    return null;
  },
  logSelectionStateFailure: function() {
    return null;
  }
};
function oCe(e) {
  return !e || !e.ownerDocument ? !1 : e.ownerDocument.defaultView ? e instanceof e.ownerDocument.defaultView.HTMLElement : e instanceof HTMLElement;
}
var zg = oCe, iD = {}, h0 = jr, lCe = zg;
function cCe(e) {
  var t = e.editorContainer;
  t || (iD.NODE_ENV !== "production" ? h0(!1, "Missing editorNode") : h0(!1)), lCe(t.firstChild) || (iD.NODE_ENV !== "production" ? h0(!1, "editorNode.firstChild is not an HTMLElement") : h0(!1));
  var r = t.firstChild;
  return r;
}
var B6 = cCe, oD = {}, lD = zl, uCe = ks;
function dCe(e, t, r, n, a) {
  var s = uCe(e.getSelection());
  if (!t || !n)
    return oD.NODE_ENV !== "production" && console.warn("Invalid selection state.", arguments, e.toJS()), s;
  var i = lD.decode(t), o = i.blockKey, l = e.getBlockTree(o), c = l && l.getIn([i.decoratorKey, "leaves", i.leafKey]), u = lD.decode(n), d = u.blockKey, f = e.getBlockTree(d), h = f && f.getIn([u.decoratorKey, "leaves", u.leafKey]);
  if (!c || !h)
    return oD.NODE_ENV !== "production" && console.warn("Invalid selection state.", arguments, e.toJS()), s;
  var p = c.get("start"), m = h.get("start"), g = c ? p + r : null, y = h ? m + a : null, x = s.getAnchorKey() === o && s.getAnchorOffset() === g && s.getFocusKey() === d && s.getFocusOffset() === y;
  if (x)
    return s;
  var w = !1;
  if (o === d) {
    var _ = c.get("end"), S = h.get("end");
    m === p && S === _ ? w = a < r : w = m < p;
  } else {
    var C = e.getCurrentContent().getBlockMap().keySeq().skipUntil(function(E) {
      return E === o || E === d;
    }).first();
    w = C === d;
  }
  return s.merge({
    anchorKey: o,
    anchorOffset: g,
    focusKey: d,
    focusOffset: y,
    isBackward: w
  });
}
var U6 = dCe, v_ = {}, Zp = ux, pm = L6, cD = U6, Kd = jr, gk = dd, Tu = ks;
function fCe(e, t, r, n, a, s) {
  var i = r.nodeType === Node.TEXT_NODE, o = a.nodeType === Node.TEXT_NODE;
  if (i && o)
    return {
      selectionState: cD(e, Tu(Zp(r)), n, Tu(Zp(a)), s),
      needsRecovery: !1
    };
  var l = null, c = null, u = !0;
  return i ? (l = {
    key: Tu(Zp(r)),
    offset: n
  }, c = p0(t, a, s)) : o ? (c = {
    key: Tu(Zp(a)),
    offset: s
  }, l = p0(t, r, n)) : (l = p0(t, r, n), c = p0(t, a, s), r === a && n === s && (u = !!r.firstChild && r.firstChild.nodeName !== "BR")), {
    selectionState: cD(e, l.key, l.offset, c.key, c.offset),
    needsRecovery: u
  };
}
function hCe(e) {
  for (; e.firstChild && // data-blocks has no offset
  (gk(e.firstChild) && e.firstChild.getAttribute("data-blocks") === "true" || pm(e.firstChild)); )
    e = e.firstChild;
  return e;
}
function pCe(e) {
  for (; e.lastChild && // data-blocks has no offset
  (gk(e.lastChild) && e.lastChild.getAttribute("data-blocks") === "true" || pm(e.lastChild)); )
    e = e.lastChild;
  return e;
}
function p0(e, t, r) {
  var n = t, a = Zp(n);
  if (a != null || e && (e === n || e.firstChild === n) || (v_.NODE_ENV !== "production" ? Kd(!1, "Unknown node in selection range.") : Kd(!1)), e === n) {
    n = n.firstChild, gk(n) || (v_.NODE_ENV !== "production" ? Kd(!1, "Invalid DraftEditorContents node.") : Kd(!1));
    var s = n;
    n = s, n.getAttribute("data-contents") !== "true" && (v_.NODE_ENV !== "production" ? Kd(!1, "Invalid DraftEditorContents structure.") : Kd(!1)), r > 0 && (r = n.childNodes.length);
  }
  if (r === 0) {
    var i = null;
    if (a != null)
      i = a;
    else {
      var o = hCe(n);
      i = Tu(pm(o));
    }
    return {
      key: i,
      offset: 0
    };
  }
  var l = n.childNodes[r - 1], c = null, u = null;
  if (!pm(l))
    c = Tu(a), u = uD(l);
  else {
    var d = pCe(l);
    c = Tu(pm(d)), u = uD(d);
  }
  return {
    key: c,
    offset: u
  };
}
function uD(e) {
  var t = e.textContent;
  return t === `
` ? 0 : t.length;
}
var V6 = fCe, mCe = V6;
function gCe(e, t) {
  var r = t.ownerDocument.defaultView.getSelection(), n = r.anchorNode, a = r.anchorOffset, s = r.focusNode, i = r.focusOffset, o = r.rangeCount;
  return (
    // No active selection.
    o === 0 || // No selection, ever. As in, the user hasn't selected anything since
    // opening the document.
    n == null || s == null ? {
      selectionState: e.getSelection().set("hasFocus", !1),
      needsRecovery: !1
    } : mCe(e, t, n, a, s, i)
  );
}
var $6 = gCe, vCe = F6, dD = ln, yCe = B6, bCe = $6;
function wCe(e) {
  if (e._blockSelectEvents || e._latestEditorState !== e.props.editorState) {
    if (e._blockSelectEvents) {
      var t = e.props.editorState, r = t.getSelection();
      vCe.logBlockedSelectionEvent({
        // For now I don't think we need any other info
        anonymizedDom: "N/A",
        extraParams: JSON.stringify({
          stacktrace: new Error().stack
        }),
        selectionState: JSON.stringify(r.toJS())
      });
    }
    return;
  }
  var n = e.props.editorState, a = bCe(n, yCe(e)), s = a.selectionState;
  s !== n.getSelection() && (a.needsRecovery ? n = dD.forceSelection(n, s) : n = dD.acceptSelection(n, s), e.update(n));
}
var H6 = wCe;
function xCe(e) {
  return e != null && e != "";
}
var W6 = {
  notEmptyKey: xCe
}, _Ce = W6, SCe = _Ce.notEmptyKey;
function ECe(e, t) {
  var r;
  if (t.isCollapsed()) {
    var n = t.getAnchorKey(), a = t.getAnchorOffset();
    return a > 0 ? (r = e.getBlockForKey(n).getEntityAt(a - 1), r !== e.getBlockForKey(n).getEntityAt(a) ? null : fD(e.getEntityMap(), r)) : null;
  }
  var s = t.getStartKey(), i = t.getStartOffset(), o = e.getBlockForKey(s);
  return r = i === o.getLength() ? null : o.getEntityAt(i), fD(e.getEntityMap(), r);
}
function fD(e, t) {
  if (SCe(t)) {
    var r = e.__get(t);
    return r.getMutability() === "MUTABLE" ? t : null;
  }
  return null;
}
var vk = ECe, TCe = sCe, CCe = Cs, kCe = zl, xp = ln, y_ = dx, OCe = Os, ACe = H6, z6 = B6, PCe = $6, RCe = vk, ICe = ks, DCe = OCe.isBrowser("IE"), NCe = 20, b_ = !1, m0 = !1, mm = null;
function MCe(e) {
  mm || (mm = new TCe(z6(e)), mm.start());
}
var zE = {
  /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
  onCompositionStart: function(t) {
    m0 = !0, MCe(t);
  },
  /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
  onCompositionEnd: function(t) {
    b_ = !1, m0 = !1, setTimeout(function() {
      b_ || zE.resolveComposition(t);
    }, NCe);
  },
  onSelect: ACe,
  /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
  onKeyDown: function(t, r) {
    if (!m0) {
      zE.resolveComposition(t), t._onKeyDown(r);
      return;
    }
    (r.which === y_.RIGHT || r.which === y_.LEFT) && r.preventDefault();
  },
  /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
  onKeyPress: function(t, r) {
    r.which === y_.RETURN && r.preventDefault();
  },
  /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
  resolveComposition: function(t) {
    if (!m0) {
      var r = ICe(mm).stopAndFlushMutations();
      mm = null, b_ = !0;
      var n = xp.set(t._latestEditorState, {
        inCompositionMode: !1
      });
      if (t.exitCurrentMode(), !r.size) {
        t.update(n);
        return;
      }
      var a = n.getCurrentContent();
      r.forEach(function(l, c) {
        var u = kCe.decode(c), d = u.blockKey, f = u.decoratorKey, h = u.leafKey, p = n.getBlockTree(d).getIn([f, "leaves", h]), m = p.start, g = p.end, y = n.getSelection().merge({
          anchorKey: d,
          focusKey: d,
          anchorOffset: m,
          focusOffset: g,
          isBackward: !1
        }), x = RCe(a, y), w = a.getBlockForKey(d).getInlineStyleAt(m);
        a = CCe.replaceText(a, y, l, w, x), n = xp.set(n, {
          currentContent: a
        });
      });
      var s = PCe(n, z6(t)), i = s.selectionState;
      t.restoreEditorDOM();
      var o = DCe ? xp.forceSelection(n, i) : xp.acceptSelection(n, i);
      t.update(xp.push(o, a, "insert-characters"));
    }
  }
}, LCe = zE, w_, hD;
function jCe() {
  if (hD) return w_;
  hD = 1;
  var e = Kc;
  function t() {
    return t = e || function(l) {
      for (var c = 1; c < arguments.length; c++) {
        var u = arguments[c];
        for (var d in u)
          Object.prototype.hasOwnProperty.call(u, d) && (l[d] = u[d]);
      }
      return l;
    }, t.apply(this, arguments);
  }
  function r(l, c) {
    l.prototype = Object.create(c.prototype), l.prototype.constructor = l, l.__proto__ = c;
  }
  var n = zl, a = M, s = fk, i = ox, o = /* @__PURE__ */ function(l) {
    r(c, l);
    function c() {
      return l.apply(this, arguments) || this;
    }
    var u = c.prototype;
    return u.render = function() {
      var f = this.props, h = f.block, p = f.children, m = f.contentState, g = f.decorator, y = f.decoratorKey, x = f.direction, w = f.leafSet, _ = f.text, S = h.getKey(), C = w.get("leaves"), E = g.getComponentForKey(y), O = g.getPropsForKey(y), k = n.encode(S, parseInt(y, 10), 0), A = _.slice(C.first().get("start"), C.last().get("end")), P = i.getHTMLDirIfDifferent(s.getDirection(A), x);
      return a.createElement(E, t({}, O, {
        contentState: m,
        decoratedText: A,
        dir: P,
        key: k,
        entityKey: h.getEntityAt(w.get("start")),
        offsetKey: k
      }), p);
    }, c;
  }(a.Component);
  return w_ = o, w_;
}
var FCe = {};
function pD(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function BCe(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function mD(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var oh = M, UCe = Os, gD = jr, VCe = dd, yk = UCe.isBrowser("IE <= 11");
function $Ce(e) {
  return yk ? e.textContent === `
` : e.tagName === "BR";
}
var HCe = function(t) {
  return yk ? oh.createElement("span", {
    key: "A",
    "data-text": "true",
    ref: t
  }, `
`) : oh.createElement("br", {
    key: "A",
    "data-text": "true",
    ref: t
  });
}, WCe = function(t) {
  return yk ? oh.createElement("span", {
    key: "B",
    "data-text": "true",
    ref: t
  }, `
`) : oh.createElement("br", {
    key: "B",
    "data-text": "true",
    ref: t
  });
}, zCe = /* @__PURE__ */ function(e) {
  BCe(t, e);
  function t(n) {
    var a;
    return a = e.call(this, n) || this, mD(pD(a), "_forceFlag", void 0), mD(pD(a), "_node", void 0), a._forceFlag = !1, a;
  }
  var r = t.prototype;
  return r.shouldComponentUpdate = function(a) {
    var s = this._node, i = a.children === "";
    VCe(s) || (FCe.NODE_ENV !== "production" ? gD(!1, "node is not an Element") : gD(!1));
    var o = s;
    return i ? !$Ce(o) : o.textContent !== a.children;
  }, r.componentDidMount = function() {
    this._forceFlag = !this._forceFlag;
  }, r.componentDidUpdate = function() {
    this._forceFlag = !this._forceFlag;
  }, r.render = function() {
    var a = this;
    return this.props.children === "" ? this._forceFlag ? HCe(function(s) {
      return a._node = s;
    }) : WCe(function(s) {
      return a._node = s;
    }) : oh.createElement("span", {
      key: this._forceFlag ? "A" : "B",
      "data-text": "true",
      ref: function(i) {
        return a._node = i;
      }
    }, this.props.children);
  }, t;
}(oh.Component), KCe = zCe, qCe = dd;
function GCe(e) {
  return !e || !e.ownerDocument ? !1 : qCe(e) && e.nodeName === "BR";
}
var K6 = GCe, q6 = {
  initODS: function() {
  },
  handleExtensionCausedError: function() {
  }
};
function YCe(e) {
  var t = e ? e.ownerDocument || e : document, r = t.defaultView || window;
  return !!(e && (typeof r.Node == "function" ? e instanceof r.Node : typeof e == "object" && typeof e.nodeType == "number" && typeof e.nodeName == "string"));
}
var XCe = YCe, QCe = XCe;
function JCe(e) {
  return QCe(e) && e.nodeType == 3;
}
var ZCe = JCe, vD = ZCe;
function G6(e, t) {
  return !e || !t ? !1 : e === t ? !0 : vD(e) ? !1 : vD(t) ? G6(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1;
}
var bk = G6;
function eke(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
    return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
var Y6 = eke, X6 = {}, tke = q6, KE = F6, rke = Os, Q6 = bk, nke = Y6, wk = cx, yD = jr, J6 = dd, ake = rke.isBrowser("IE");
function ske(e, t) {
  if (!e)
    return "[empty]";
  var r = Z6(e, t);
  if (r.nodeType === Node.TEXT_NODE)
    return r.textContent;
  J6(r) || (X6.NODE_ENV !== "production" ? yD(!1, "Node must be an Element if it is not a text node.") : yD(!1));
  var n = r;
  return n.outerHTML;
}
function Z6(e, t) {
  var r = t !== void 0 ? t(e) : [];
  if (e.nodeType === Node.TEXT_NODE) {
    var n = e.textContent.length;
    return wk(e).createTextNode("[text " + n + (r.length ? " | " + r.join(", ") : "") + "]");
  }
  var a = e.cloneNode();
  a.nodeType === 1 && r.length && a.setAttribute("data-labels", r.join(", "));
  for (var s = e.childNodes, i = 0; i < s.length; i++)
    a.appendChild(Z6(s[i], t));
  return a;
}
function qE(e, t) {
  for (var r = e, n = r; r; ) {
    if (J6(r) && n.hasAttribute("contenteditable"))
      return ske(r, t);
    r = r.parentNode, n = r;
  }
  return "Could not find contentEditable parent of node";
}
function eU(e) {
  return e.nodeValue === null ? e.childNodes.length : e.nodeValue.length;
}
function ike(e, t, r, n, a) {
  var s = wk(t);
  if (Q6(s.documentElement, t)) {
    var i = s.defaultView.getSelection(), o = e.getAnchorKey(), l = e.getAnchorOffset(), c = e.getFocusKey(), u = e.getFocusOffset(), d = e.getIsBackward();
    if (!i.extend && d) {
      var f = o, h = l;
      o = c, l = u, c = f, u = h, d = !1;
    }
    var p = o === r && n <= l && a >= l, m = c === r && n <= u && a >= u;
    if (p && m) {
      i.removeAllRanges(), g0(i, t, l - n, e), x_(i, t, u - n, e);
      return;
    }
    if (!d)
      p && (i.removeAllRanges(), g0(i, t, l - n, e)), m && x_(i, t, u - n, e);
    else if (m && (i.removeAllRanges(), g0(i, t, u - n, e)), p) {
      var g = i.focusNode, y = i.focusOffset;
      i.removeAllRanges(), g0(i, t, l - n, e), x_(i, g, y, e);
    }
  }
}
function x_(e, t, r, n) {
  var a = nke(), s = e.extend;
  if (s && t != null && Q6(a, t)) {
    r > eU(t) && KE.logSelectionStateFailure({
      anonymizedDom: qE(t),
      extraParams: JSON.stringify({
        offset: r
      }),
      selectionState: JSON.stringify(n.toJS())
    });
    var i = t === e.focusNode;
    try {
      e.rangeCount > 0 && e.extend && e.extend(t, r);
    } catch (l) {
      throw KE.logSelectionStateFailure({
        anonymizedDom: qE(t, function(c) {
          var u = [];
          return c === a && u.push("active element"), c === e.anchorNode && u.push("selection anchor node"), c === e.focusNode && u.push("selection focus node"), u;
        }),
        extraParams: JSON.stringify({
          activeElementName: a ? a.nodeName : null,
          nodeIsFocus: t === e.focusNode,
          nodeWasFocus: i,
          selectionRangeCount: e.rangeCount,
          selectionAnchorNodeName: e.anchorNode ? e.anchorNode.nodeName : null,
          selectionAnchorOffset: e.anchorOffset,
          selectionFocusNodeName: e.focusNode ? e.focusNode.nodeName : null,
          selectionFocusOffset: e.focusOffset,
          message: l ? "" + l : null,
          offset: r
        }, null, 2),
        selectionState: JSON.stringify(n.toJS(), null, 2)
      }), l;
    }
  } else if (t && e.rangeCount > 0) {
    var o = e.getRangeAt(0);
    o.setEnd(t, r), e.addRange(o.cloneRange());
  }
}
function g0(e, t, r, n) {
  var a = wk(t).createRange();
  if (r > eU(t) && (KE.logSelectionStateFailure({
    anonymizedDom: qE(t),
    extraParams: JSON.stringify({
      offset: r
    }),
    selectionState: JSON.stringify(n.toJS())
  }), tke.handleExtensionCausedError()), a.setStart(t, r), ake)
    try {
      e.addRange(a);
    } catch (s) {
      X6.NODE_ENV !== "production" && console.warn("Call to selection.addRange() threw exception: ", s);
    }
  else
    e.addRange(a);
}
var oke = {
  setDraftEditorSelection: ike
}, v0 = {}, bD = Kc;
function lke(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function cke(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function uke(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var dke = KCe, __ = M, ec = jr, fke = K6, hke = oke.setDraftEditorSelection, pke = /* @__PURE__ */ function(e) {
  cke(t, e);
  function t() {
    for (var n, a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return n = e.call.apply(e, [this].concat(s)) || this, uke(lke(n), "leaf", void 0), n;
  }
  var r = t.prototype;
  return r._setSelection = function() {
    var a = this.props.selection;
    if (!(a == null || !a.getHasFocus())) {
      var s = this.props, i = s.block, o = s.start, l = s.text, c = i.getKey(), u = o + l.length;
      if (a.hasEdgeWithin(c, o, u)) {
        var d = this.leaf;
        d || (v0.NODE_ENV !== "production" ? ec(!1, "Missing node") : ec(!1));
        var f = d.firstChild;
        f || (v0.NODE_ENV !== "production" ? ec(!1, "Missing child") : ec(!1));
        var h;
        f.nodeType === Node.TEXT_NODE ? h = f : fke(f) ? h = d : (h = f.firstChild, h || (v0.NODE_ENV !== "production" ? ec(!1, "Missing targetNode") : ec(!1))), hke(a, h, c, o, u);
      }
    }
  }, r.shouldComponentUpdate = function(a) {
    var s = this.leaf;
    s || (v0.NODE_ENV !== "production" ? ec(!1, "Missing leafNode") : ec(!1));
    var i = s.textContent !== a.text || a.styleSet !== this.props.styleSet || a.forceSelection;
    return i;
  }, r.componentDidUpdate = function() {
    this._setSelection();
  }, r.componentDidMount = function() {
    this._setSelection();
  }, r.render = function() {
    var a = this, s = this.props.block, i = this.props.text;
    i.endsWith(`
`) && this.props.isLast && (i += `
`);
    var o = this.props, l = o.customStyleMap, c = o.customStyleFn, u = o.offsetKey, d = o.styleSet, f = d.reduce(function(p, m) {
      var g = {}, y = l[m];
      return y !== void 0 && p.textDecoration !== y.textDecoration && (g.textDecoration = [p.textDecoration, y.textDecoration].join(" ").trim()), bD(p, y, g);
    }, {});
    if (c) {
      var h = c(d, s);
      f = bD(f, h);
    }
    return __.createElement("span", {
      "data-offset-key": u,
      ref: function(m) {
        return a.leaf = m;
      },
      style: f
    }, __.createElement(dke, null, i));
  }, t;
}(__.Component), tU = pke, S_, wD;
function mke() {
  if (wD) return S_;
  wD = 1;
  function e(l, c) {
    l.prototype = Object.create(c.prototype), l.prototype.constructor = l, l.__proto__ = c;
  }
  var t = jCe(), r = tU, n = zl, a = Tr, s = M, i = ud;
  a.List;
  var o = /* @__PURE__ */ function(l) {
    e(c, l);
    function c() {
      return l.apply(this, arguments) || this;
    }
    var u = c.prototype;
    return u.render = function() {
      var f = this.props, h = f.block, p = f.contentState, m = f.customStyleFn, g = f.customStyleMap, y = f.decorator, x = f.direction, w = f.forceSelection, _ = f.hasSelection, S = f.selection, C = f.tree, E = h.getKey(), O = h.getText(), k = C.size - 1, A = this.props.children || C.map(function(P, D) {
        var N = P.get("decoratorKey"), z = P.get("leaves"), G = z.size - 1, Y = z.map(function(te, ae) {
          var ne = n.encode(E, D, ae), ue = te.get("start"), q = te.get("end");
          return s.createElement(r, {
            key: ne,
            offsetKey: ne,
            block: h,
            start: ue,
            selection: _ ? S : null,
            forceSelection: w,
            text: O.slice(ue, q),
            styleSet: h.getInlineStyleAt(ue),
            customStyleMap: g,
            customStyleFn: m,
            isLast: N === k && ae === G
          });
        }).toArray();
        return !N || !y ? Y : s.createElement(t, {
          block: h,
          children: Y,
          contentState: p,
          decorator: y,
          decoratorKey: N,
          direction: x,
          leafSet: P,
          text: O,
          key: D
        });
      }).toArray();
      return s.createElement("div", {
        "data-offset-key": n.encode(E, 0, 0),
        className: i({
          "public/DraftStyleDefault/block": !0,
          "public/DraftStyleDefault/ltr": x === "LTR",
          "public/DraftStyleDefault/rtl": x === "RTL"
        })
      }, A);
    }, c;
  }(s.Component);
  return S_ = o, S_;
}
function y0(e, t) {
  return !!t && (e === t.documentElement || e === t.body);
}
var gke = {
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getTop: function(t) {
    var r = t.ownerDocument;
    return y0(t, r) ? (
      // In practice, they will either both have the same value,
      // or one will be zero and the other will be the scroll position
      // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
      r.body.scrollTop || r.documentElement.scrollTop
    ) : t.scrollTop;
  },
  /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
  setTop: function(t, r) {
    var n = t.ownerDocument;
    y0(t, n) ? n.body.scrollTop = n.documentElement.scrollTop = r : t.scrollTop = r;
  },
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getLeft: function(t) {
    var r = t.ownerDocument;
    return y0(t, r) ? r.body.scrollLeft || r.documentElement.scrollLeft : t.scrollLeft;
  },
  /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
  setLeft: function(t, r) {
    var n = t.ownerDocument;
    y0(t, n) ? n.body.scrollLeft = n.documentElement.scrollLeft = r : t.scrollLeft = r;
  }
}, xk = gke, vke = /-(.)/g;
function yke(e) {
  return e.replace(vke, function(t, r) {
    return r.toUpperCase();
  });
}
var bke = yke, wke = /([A-Z])/g;
function xke(e) {
  return e.replace(wke, "-$1").toLowerCase();
}
var _ke = xke, xD = bke, _D = _ke;
function _p(e) {
  return e == null ? e : String(e);
}
function Ske(e, t) {
  var r;
  if (window.getComputedStyle && (r = window.getComputedStyle(e, null), r))
    return _p(r.getPropertyValue(_D(t)));
  if (document.defaultView && document.defaultView.getComputedStyle) {
    if (r = document.defaultView.getComputedStyle(e, null), r)
      return _p(r.getPropertyValue(_D(t)));
    if (t === "display")
      return "none";
  }
  return e.currentStyle ? _p(t === "float" ? e.currentStyle.cssFloat || e.currentStyle.styleFloat : e.currentStyle[xD(t)]) : _p(e.style && e.style[xD(t)]);
}
var Eke = Ske, Tke = Eke;
function E_(e, t) {
  var r = rU.get(e, t);
  return r === "auto" || r === "scroll";
}
var rU = {
  /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
  get: Tke,
  /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
  getScrollParent: function(t) {
    if (!t)
      return null;
    for (var r = t.ownerDocument; t && t !== r.body; ) {
      if (E_(t, "overflow") || E_(t, "overflowY") || E_(t, "overflowX"))
        return t;
      t = t.parentNode;
    }
    return r.defaultView || r.parentWindow;
  }
}, fx = rU, Cke = bk;
function kke(e) {
  var t = e.ownerDocument.documentElement;
  if (!("getBoundingClientRect" in e) || !Cke(t, e))
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  var r = e.getBoundingClientRect();
  return {
    left: Math.round(r.left) - t.clientLeft,
    right: Math.round(r.right) - t.clientLeft,
    top: Math.round(r.top) - t.clientTop,
    bottom: Math.round(r.bottom) - t.clientTop
  };
}
var Oke = kke, Ake = Oke;
function Pke(e) {
  var t = Ake(e);
  return {
    x: t.left,
    y: t.top,
    width: t.right - t.left,
    height: t.bottom - t.top
  };
}
var nU = Pke, Rke = typeof navigator < "u" && navigator.userAgent.indexOf("AppleWebKit") > -1;
function Ike(e) {
  return e = e || document, e.scrollingElement ? e.scrollingElement : !Rke && e.compatMode === "CSS1Compat" ? e.documentElement : e.body;
}
var Dke = Ike;
function Nke(e) {
  return e.Window && e instanceof e.Window ? {
    x: e.pageXOffset || e.document.documentElement.scrollLeft,
    y: e.pageYOffset || e.document.documentElement.scrollTop
  } : {
    x: e.scrollLeft,
    y: e.scrollTop
  };
}
var Mke = Nke, Lke = Dke, jke = Mke;
function Fke(e) {
  var t = Lke(e.ownerDocument || e.document);
  e.Window && e instanceof e.Window && (e = t);
  var r = jke(e), n = e === t ? e.ownerDocument.documentElement : e, a = e.scrollWidth - n.clientWidth, s = e.scrollHeight - n.clientHeight;
  return r.x = Math.max(0, Math.min(r.x, a)), r.y = Math.max(0, Math.min(r.y, s)), r;
}
var hx = Fke;
function aU() {
  var e;
  return document.documentElement && (e = document.documentElement.clientWidth), !e && document.body && (e = document.body.clientWidth), e || 0;
}
function sU() {
  var e;
  return document.documentElement && (e = document.documentElement.clientHeight), !e && document.body && (e = document.body.clientHeight), e || 0;
}
function iU() {
  return {
    width: window.innerWidth || aU(),
    height: window.innerHeight || sU()
  };
}
iU.withoutScrollbars = function() {
  return {
    width: aU(),
    height: sU()
  };
};
var oU = iU, T_, SD;
function Bke() {
  if (SD) return T_;
  SD = 1;
  var e = {}, t = Kc;
  function r() {
    return r = t || function(A) {
      for (var P = 1; P < arguments.length; P++) {
        var D = arguments[P];
        for (var N in D)
          Object.prototype.hasOwnProperty.call(D, N) && (A[N] = D[N]);
      }
      return A;
    }, r.apply(this, arguments);
  }
  function n(A) {
    if (A === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return A;
  }
  function a(A, P) {
    A.prototype = Object.create(P.prototype), A.prototype.constructor = A, A.__proto__ = P;
  }
  function s(A) {
    for (var P = 1; P < arguments.length; P++) {
      var D = arguments[P] != null ? arguments[P] : {}, N = Object.keys(D);
      typeof Object.getOwnPropertySymbols == "function" && (N = N.concat(Object.getOwnPropertySymbols(D).filter(function(z) {
        return Object.getOwnPropertyDescriptor(D, z).enumerable;
      }))), N.forEach(function(z) {
        i(A, z, D[z]);
      });
    }
    return A;
  }
  function i(A, P, D) {
    return P in A ? Object.defineProperty(A, P, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : A[P] = D, A;
  }
  var o = mke(), l = zl, c = M, u = xk, d = fx, f = nU, h = hx, p = oU, m = Tr, g = jr, y = zg, x = 10;
  m.List;
  var w = function(P, D) {
    return P.getAnchorKey() === D || P.getFocusKey() === D;
  }, _ = function(P, D) {
    var N = P.getNextSiblingKey();
    return N ? D.getBlockForKey(N).getType() === P.getType() : !1;
  }, S = function(P, D, N) {
    var z = [], G = !0, Y = !1, te = void 0;
    try {
      for (var ae = N.reverse()[Symbol.iterator](), ne; !(G = (ne = ae.next()).done); G = !0) {
        var ue = ne.value;
        if (ue.type !== D)
          break;
        z.push(ue);
      }
    } catch (Q) {
      Y = !0, te = Q;
    } finally {
      try {
        !G && ae.return != null && ae.return();
      } finally {
        if (Y)
          throw te;
      }
    }
    N.splice(N.indexOf(z[0]), z.length + 1);
    var q = z.reverse(), U = q[0].key;
    return N.push(c.cloneElement(P, {
      key: "".concat(U, "-wrap"),
      "data-offset-key": l.encode(U, 0, 0)
    }, q)), N;
  }, C = function(P, D) {
    var N = D.get(P.getType()) || D.get("unstyled"), z = N.wrapper, G = N.element || D.get("unstyled").element;
    return {
      Element: G,
      wrapperTemplate: z
    };
  }, E = function(P, D) {
    var N = D(P);
    if (!N)
      return {};
    var z = N.component, G = N.props, Y = N.editable;
    return {
      CustomComponent: z,
      customProps: G,
      customEditable: Y
    };
  }, O = function(P, D, N, z, G, Y) {
    var te = {
      "data-block": !0,
      "data-editor": D,
      "data-offset-key": N,
      key: P.getKey(),
      ref: Y
    }, ae = z(P);
    return ae && (te.className = ae), G.customEditable !== void 0 && (te = s({}, te, {
      contentEditable: G.customEditable,
      suppressContentEditableWarning: !0
    })), te;
  }, k = /* @__PURE__ */ function(A) {
    a(P, A);
    function P() {
      for (var N, z = arguments.length, G = new Array(z), Y = 0; Y < z; Y++)
        G[Y] = arguments[Y];
      return N = A.call.apply(A, [this].concat(G)) || this, i(n(N), "wrapperRef", c.createRef()), N;
    }
    var D = P.prototype;
    return D.shouldComponentUpdate = function(z) {
      var G = this.props, Y = G.block, te = G.direction, ae = G.tree, ne = !Y.getChildKeys().isEmpty(), ue = Y !== z.block || ae !== z.tree || te !== z.direction || w(z.selection, z.block.getKey()) && z.forceSelection;
      return ne || ue;
    }, D.componentDidMount = function() {
      var z = this.props.selection, G = z.getEndKey();
      if (!(!z.getHasFocus() || G !== this.props.block.getKey())) {
        var Y = this.wrapperRef.current;
        if (Y) {
          var te = d.getScrollParent(Y), ae = h(te), ne;
          if (te === window) {
            var ue = f(Y), q = ue.y + ue.height, U = p().height;
            ne = q - U, ne > 0 && window.scrollTo(ae.x, ae.y + ne + x);
          } else {
            y(Y) || (e.NODE_ENV !== "production" ? g(!1, "blockNode is not an HTMLElement") : g(!1));
            var Q = Y, L = Q.offsetHeight + Q.offsetTop, j = te.offsetHeight + ae.y;
            ne = L - j, ne > 0 && u.setTop(te, u.getTop(te) + ne + x);
          }
        }
      }
    }, D.render = function() {
      var z = this, G = this.props, Y = G.block, te = G.blockRenderMap, ae = G.blockRendererFn, ne = G.blockStyleFn, ue = G.contentState, q = G.decorator, U = G.editorKey, Q = G.editorState, L = G.customStyleFn, j = G.customStyleMap, K = G.direction, J = G.forceSelection, re = G.selection, le = G.tree, pe = null;
      Y.children.size && (pe = Y.children.reduce(function(ht, bt) {
        var Ge = l.encode(bt, 0, 0), oe = ue.getBlockForKey(bt), ve = E(oe, ae), ye = ve.CustomComponent || P, Te = C(oe, te), _e = Te.Element, Ae = Te.wrapperTemplate, Ve = O(oe, U, Ge, ne, ve, null), mt = s({}, z.props, {
          tree: Q.getBlockTree(bt),
          blockProps: ve.customProps,
          offsetKey: Ge,
          block: oe
        });
        return ht.push(c.createElement(_e, Ve, c.createElement(ye, mt))), !Ae || _(oe, ue) || S(Ae, _e, ht), ht;
      }, []));
      var me = Y.getKey(), Oe = l.encode(me, 0, 0), ee = E(Y, ae), he = ee.CustomComponent, Ee = he != null ? c.createElement(he, r({}, this.props, {
        tree: Q.getBlockTree(me),
        blockProps: ee.customProps,
        offsetKey: Oe,
        block: Y
      })) : c.createElement(o, {
        block: Y,
        children: pe,
        contentState: ue,
        customStyleFn: L,
        customStyleMap: j,
        decorator: q,
        direction: K,
        forceSelection: J,
        hasSelection: w(re, me),
        selection: re,
        tree: le
      });
      if (Y.getParentKey())
        return Ee;
      var we = C(Y, te), Pe = we.Element, rt = O(Y, U, Oe, ne, ee, this.wrapperRef);
      return c.createElement(Pe, rt, Ee);
    }, P;
  }(c.Component);
  return T_ = k, T_;
}
var C_, ED;
function Uke() {
  if (ED) return C_;
  ED = 1;
  var e = Kc;
  function t() {
    return t = e || function(l) {
      for (var c = 1; c < arguments.length; c++) {
        var u = arguments[c];
        for (var d in u)
          Object.prototype.hasOwnProperty.call(u, d) && (l[d] = u[d]);
      }
      return l;
    }, t.apply(this, arguments);
  }
  function r(l, c) {
    l.prototype = Object.create(c.prototype), l.prototype.constructor = l, l.__proto__ = c;
  }
  var n = Bke(), a = zl, s = M, i = ks, o = /* @__PURE__ */ function(l) {
    r(c, l);
    function c() {
      return l.apply(this, arguments) || this;
    }
    var u = c.prototype;
    return u.shouldComponentUpdate = function(f) {
      var h = this.props.editorState, p = f.editorState, m = h.getDirectionMap(), g = p.getDirectionMap();
      if (m !== g)
        return !0;
      var y = h.getSelection().getHasFocus(), x = p.getSelection().getHasFocus();
      if (y !== x)
        return !0;
      var w = p.getNativelyRenderedContent(), _ = h.isInCompositionMode(), S = p.isInCompositionMode();
      if (h === p || w !== null && p.getCurrentContent() === w || _ && S)
        return !1;
      var C = h.getCurrentContent(), E = p.getCurrentContent(), O = h.getDecorator(), k = p.getDecorator();
      return _ !== S || C !== E || O !== k || p.mustForceSelection();
    }, u.render = function() {
      for (var f = this.props, h = f.blockRenderMap, p = f.blockRendererFn, m = f.blockStyleFn, g = f.customStyleMap, y = f.customStyleFn, x = f.editorState, w = f.editorKey, _ = f.textDirectionality, S = x.getCurrentContent(), C = x.getSelection(), E = x.mustForceSelection(), O = x.getDecorator(), k = i(x.getDirectionMap()), A = S.getBlocksAsArray(), P = A[0], D = [], N = P; N; ) {
        var z = N.getKey(), G = {
          blockRenderMap: h,
          blockRendererFn: p,
          blockStyleFn: m,
          contentState: S,
          customStyleFn: y,
          customStyleMap: g,
          decorator: O,
          editorKey: w,
          editorState: x,
          forceSelection: E,
          selection: C,
          block: N,
          direction: _ || k.get(z),
          tree: x.getBlockTree(z)
        }, Y = h.get(N.getType()) || h.get("unstyled"), te = Y.wrapper;
        D.push({
          /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
           * comment suppresses an error found when Flow v0.112 was deployed. To
           * see the error delete this comment and run Flow. */
          block: s.createElement(n, t({
            key: z
          }, G)),
          wrapperTemplate: te,
          key: z,
          offsetKey: a.encode(z, 0, 0)
        });
        var ae = N.getNextSiblingKey();
        N = ae ? S.getBlockForKey(ae) : null;
      }
      for (var ne = [], ue = 0; ue < D.length; ) {
        var q = D[ue];
        if (q.wrapperTemplate) {
          var U = [];
          do
            U.push(D[ue].block), ue++;
          while (ue < D.length && D[ue].wrapperTemplate === q.wrapperTemplate);
          var Q = s.cloneElement(q.wrapperTemplate, {
            key: q.key + "-wrap",
            "data-offset-key": q.offsetKey
          }, U);
          ne.push(Q);
        } else
          ne.push(q.block), ue++;
      }
      return s.createElement("div", {
        "data-contents": "true"
      }, ne);
    }, c;
  }(s.Component);
  return C_ = o, C_;
}
var Vke = {}, $ke = Kc;
function GE() {
  return GE = $ke || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, GE.apply(this, arguments);
}
function Hke(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Wke(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function zke(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var Kke = tU, TD = zl, b0 = M, CD = xk, qke = fx, Gke = fk, Yke = ox, Xke = ud, Qke = nU, Jke = hx, Zke = oU, kD = jr, e2e = zg, t2e = ks, OD = 10, AD = function(t, r) {
  return t.getAnchorKey() === r || t.getFocusKey() === r;
}, r2e = /* @__PURE__ */ function(e) {
  Wke(t, e);
  function t() {
    for (var n, a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return n = e.call.apply(e, [this].concat(s)) || this, zke(Hke(n), "_node", void 0), n;
  }
  var r = t.prototype;
  return r.shouldComponentUpdate = function(a) {
    return this.props.block !== a.block || this.props.tree !== a.tree || this.props.direction !== a.direction || AD(a.selection, a.block.getKey()) && a.forceSelection;
  }, r.componentDidMount = function() {
    if (!this.props.preventScroll) {
      var a = this.props.selection, s = a.getEndKey();
      if (!(!a.getHasFocus() || s !== this.props.block.getKey())) {
        var i = this._node;
        if (i != null) {
          var o = qke.getScrollParent(i), l = Jke(o), c;
          if (o === window) {
            var u = Qke(i), d = u.y + u.height, f = Zke().height;
            c = d - f, c > 0 && window.scrollTo(l.x, l.y + c + OD);
          } else {
            e2e(i) || (Vke.NODE_ENV !== "production" ? kD(!1, "blockNode is not an HTMLElement") : kD(!1));
            var h = i.offsetHeight + i.offsetTop, p = o.offsetTop + o.offsetHeight, m = p + l.y;
            c = h - m, c > 0 && CD.setTop(o, CD.getTop(o) + c + OD);
          }
        }
      }
    }
  }, r._renderChildren = function() {
    var a = this, s = this.props.block, i = s.getKey(), o = s.getText(), l = this.props.tree.size - 1, c = AD(this.props.selection, i);
    return this.props.tree.map(function(u, d) {
      var f = u.get("leaves");
      if (f.size === 0)
        return null;
      var h = f.size - 1, p = f.map(function(A, P) {
        var D = TD.encode(i, d, P), N = A.get("start"), z = A.get("end");
        return b0.createElement(Kke, {
          key: D,
          offsetKey: D,
          block: s,
          start: N,
          selection: c ? a.props.selection : null,
          forceSelection: a.props.forceSelection,
          text: o.slice(N, z),
          styleSet: s.getInlineStyleAt(N),
          customStyleMap: a.props.customStyleMap,
          customStyleFn: a.props.customStyleFn,
          isLast: d === l && P === h
        });
      }).toArray(), m = u.get("decoratorKey");
      if (m == null || !a.props.decorator)
        return p;
      var g = t2e(a.props.decorator), y = g.getComponentForKey(m);
      if (!y)
        return p;
      var x = g.getPropsForKey(m), w = TD.encode(i, d, 0), _ = f.first().get("start"), S = f.last().get("end"), C = o.slice(_, S), E = s.getEntityAt(u.get("start")), O = Yke.getHTMLDirIfDifferent(Gke.getDirection(C), a.props.direction), k = {
        contentState: a.props.contentState,
        decoratedText: C,
        dir: O,
        start: _,
        end: S,
        blockKey: i,
        entityKey: E,
        offsetKey: w
      };
      return b0.createElement(y, GE({}, x, k, {
        key: w
      }), p);
    }).toArray();
  }, r.render = function() {
    var a = this, s = this.props, i = s.direction, o = s.offsetKey, l = Xke({
      "public/DraftStyleDefault/block": !0,
      "public/DraftStyleDefault/ltr": i === "LTR",
      "public/DraftStyleDefault/rtl": i === "RTL"
    });
    return b0.createElement("div", {
      "data-offset-key": o,
      className: l,
      ref: function(u) {
        return a._node = u;
      }
    }, this._renderChildren());
  }, t;
}(b0.Component), lU = r2e, k_, PD;
function n2e() {
  if (PD) return k_;
  PD = 1;
  function e(t) {
    var r = t || "", n = arguments.length;
    if (n > 1)
      for (var a = 1; a < n; a++) {
        var s = arguments[a];
        s && (r = (r ? r + " " : "") + s);
      }
    return r;
  }
  return k_ = e, k_;
}
var O_, RD;
function a2e() {
  if (RD) return O_;
  RD = 1;
  var e = Kc;
  function t() {
    return t = e || function(h) {
      for (var p = 1; p < arguments.length; p++) {
        var m = arguments[p];
        for (var g in m)
          Object.prototype.hasOwnProperty.call(m, g) && (h[g] = m[g]);
      }
      return h;
    }, t.apply(this, arguments);
  }
  function r(h) {
    for (var p = 1; p < arguments.length; p++) {
      var m = arguments[p] != null ? arguments[p] : {}, g = Object.keys(m);
      typeof Object.getOwnPropertySymbols == "function" && (g = g.concat(Object.getOwnPropertySymbols(m).filter(function(y) {
        return Object.getOwnPropertyDescriptor(m, y).enumerable;
      }))), g.forEach(function(y) {
        n(h, y, m[y]);
      });
    }
    return h;
  }
  function n(h, p, m) {
    return p in h ? Object.defineProperty(h, p, { value: m, enumerable: !0, configurable: !0, writable: !0 }) : h[p] = m, h;
  }
  function a(h, p) {
    h.prototype = Object.create(p.prototype), h.prototype.constructor = h, h.__proto__ = p;
  }
  var s = lU, i = zl, o = M, l = ud, c = n2e(), u = ks, d = function(p, m, g, y) {
    return l({
      "public/DraftStyleDefault/unorderedListItem": p === "unordered-list-item",
      "public/DraftStyleDefault/orderedListItem": p === "ordered-list-item",
      "public/DraftStyleDefault/reset": g,
      "public/DraftStyleDefault/depth0": m === 0,
      "public/DraftStyleDefault/depth1": m === 1,
      "public/DraftStyleDefault/depth2": m === 2,
      "public/DraftStyleDefault/depth3": m === 3,
      "public/DraftStyleDefault/depth4": m >= 4,
      "public/DraftStyleDefault/listLTR": y === "LTR",
      "public/DraftStyleDefault/listRTL": y === "RTL"
    });
  }, f = /* @__PURE__ */ function(h) {
    a(p, h);
    function p() {
      return h.apply(this, arguments) || this;
    }
    var m = p.prototype;
    return m.shouldComponentUpdate = function(y) {
      var x = this.props.editorState, w = y.editorState, _ = x.getDirectionMap(), S = w.getDirectionMap();
      if (_ !== S)
        return !0;
      var C = x.getSelection().getHasFocus(), E = w.getSelection().getHasFocus();
      if (C !== E)
        return !0;
      var O = w.getNativelyRenderedContent(), k = x.isInCompositionMode(), A = w.isInCompositionMode();
      if (x === w || O !== null && w.getCurrentContent() === O || k && A)
        return !1;
      var P = x.getCurrentContent(), D = w.getCurrentContent(), N = x.getDecorator(), z = w.getDecorator();
      return k !== A || P !== D || N !== z || w.mustForceSelection();
    }, m.render = function() {
      for (var y = this.props, x = y.blockRenderMap, w = y.blockRendererFn, _ = y.blockStyleFn, S = y.customStyleMap, C = y.customStyleFn, E = y.editorState, O = y.editorKey, k = y.preventScroll, A = y.textDirectionality, P = E.getCurrentContent(), D = E.getSelection(), N = E.mustForceSelection(), z = E.getDecorator(), G = u(E.getDirectionMap()), Y = P.getBlocksAsArray(), te = [], ae = null, ne = null, ue = 0; ue < Y.length; ue++) {
        var q = Y[ue], U = q.getKey(), Q = q.getType(), L = w(q), j = void 0, K = void 0, J = void 0;
        L && (j = L.component, K = L.props, J = L.editable);
        var re = A || G.get(U), le = i.encode(U, 0, 0), pe = {
          contentState: P,
          block: q,
          blockProps: K,
          blockStyleFn: _,
          customStyleMap: S,
          customStyleFn: C,
          decorator: z,
          direction: re,
          forceSelection: N,
          offsetKey: le,
          preventScroll: k,
          selection: D,
          tree: E.getBlockTree(U)
        }, me = x.get(Q) || x.get("unstyled"), Oe = me.wrapper, ee = me.element || x.get("unstyled").element, he = q.getDepth(), Ee = "";
        if (_ && (Ee = _(q)), ee === "li") {
          var we = ne !== Oe || ae === null || he > ae;
          Ee = c(Ee, d(Q, he, we, re));
        }
        var Pe = j || s, rt = {
          className: Ee,
          "data-block": !0,
          "data-editor": O,
          "data-offset-key": le,
          key: U
        };
        J !== void 0 && (rt = r({}, rt, {
          contentEditable: J,
          suppressContentEditableWarning: !0
        }));
        var ht = o.createElement(
          ee,
          rt,
          /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
           * comment suppresses an error found when Flow v0.112 was deployed. To
           * see the error delete this comment and run Flow. */
          o.createElement(Pe, t({}, pe, {
            key: U
          }))
        );
        te.push({
          block: ht,
          wrapperTemplate: Oe,
          key: U,
          offsetKey: le
        }), Oe ? ae = q.getDepth() : ae = null, ne = Oe;
      }
      for (var bt = [], Ge = 0; Ge < te.length; ) {
        var oe = te[Ge];
        if (oe.wrapperTemplate) {
          var ve = [];
          do
            ve.push(te[Ge].block), Ge++;
          while (Ge < te.length && te[Ge].wrapperTemplate === oe.wrapperTemplate);
          var ye = o.cloneElement(oe.wrapperTemplate, {
            key: oe.key + "-wrap",
            "data-offset-key": oe.offsetKey
          }, ve);
          bt.push(ye);
        } else
          bt.push(oe.block), Ge++;
      }
      return o.createElement("div", {
        "data-contents": "true"
      }, bt);
    }, p;
  }(o.Component);
  return O_ = f, O_;
}
var s2e = Gc, i2e = s2e("draft_tree_data_support"), o2e = i2e ? Uke() : a2e(), cU = {
  isImage: function(t) {
    return ID(t)[0] === "image";
  },
  isJpeg: function(t) {
    var r = ID(t);
    return cU.isImage(t) && // see http://fburl.com/10972194
    (r[1] === "jpeg" || r[1] === "pjpeg");
  }
};
function ID(e) {
  return e.split("/");
}
var l2e = cU, w0 = {}, tc = jr;
function c2e(e) {
  var t = e.length;
  if (!Array.isArray(e) && (typeof e == "object" || typeof e == "function") || (w0.NODE_ENV !== "production" ? tc(!1, "toArray: Array-like object expected") : tc(!1)), typeof t != "number" && (w0.NODE_ENV !== "production" ? tc(!1, "toArray: Object needs a length property") : tc(!1)), t === 0 || t - 1 in e || (w0.NODE_ENV !== "production" ? tc(!1, "toArray: Object should have keys for indices") : tc(!1)), typeof e.callee == "function" && (w0.NODE_ENV !== "production" ? tc(!1, "toArray: Object can't be `arguments`. Use rest params (function(...args) {}) or Array.from() instead.") : tc(!1)), e.hasOwnProperty)
    try {
      return Array.prototype.slice.call(e);
    } catch {
    }
  for (var r = Array(t), n = 0; n < t; n++)
    r[n] = e[n];
  return r;
}
function u2e(e) {
  return (
    // not null/false
    !!e && // arrays are objects, NodeLists are functions in Safari
    (typeof e == "object" || typeof e == "function") && // quacks like an array
    "length" in e && // not window
    !("setInterval" in e) && // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof e.nodeType != "number" && // a real array
    (Array.isArray(e) || // arguments
    "callee" in e || // HTMLCollection/NodeList
    "item" in e)
  );
}
function d2e(e) {
  return u2e(e) ? Array.isArray(e) ? e.slice() : c2e(e) : [e];
}
var f2e = d2e;
function px(e) {
  return function() {
    return e;
  };
}
var fd = function() {
};
fd.thatReturns = px;
fd.thatReturnsFalse = px(!1);
fd.thatReturnsTrue = px(!0);
fd.thatReturnsNull = px(null);
fd.thatReturnsThis = function() {
  return this;
};
fd.thatReturnsArgument = function(e) {
  return e;
};
var uU = fd, h2e = l2e, p2e = f2e, m2e = uU, g2e = new RegExp(`\r
`, "g"), v2e = `
`, y2e = {
  "text/rtf": 1,
  "text/html": 1
};
function b2e(e) {
  if (e.kind == "file")
    return e.getAsFile();
}
var w2e = /* @__PURE__ */ function() {
  function e(r) {
    this.data = r, this.types = r.types ? p2e(r.types) : [];
  }
  var t = e.prototype;
  return t.isRichText = function() {
    return this.getHTML() && this.getText() ? !0 : this.isImage() ? !1 : this.types.some(function(n) {
      return y2e[n];
    });
  }, t.getText = function() {
    var n;
    return this.data.getData && (this.types.length ? this.types.indexOf("text/plain") != -1 && (n = this.data.getData("text/plain")) : n = this.data.getData("Text")), n ? n.replace(g2e, v2e) : null;
  }, t.getHTML = function() {
    if (this.data.getData)
      if (this.types.length) {
        if (this.types.indexOf("text/html") != -1)
          return this.data.getData("text/html");
      } else return this.data.getData("Text");
  }, t.isLink = function() {
    return this.types.some(function(n) {
      return n.indexOf("Url") != -1 || n.indexOf("text/uri-list") != -1 || n.indexOf("text/x-moz-url");
    });
  }, t.getLink = function() {
    if (this.data.getData) {
      if (this.types.indexOf("text/x-moz-url") != -1) {
        var n = this.data.getData("text/x-moz-url").split(`
`);
        return n[0];
      }
      return this.types.indexOf("text/uri-list") != -1 ? this.data.getData("text/uri-list") : this.data.getData("url");
    }
    return null;
  }, t.isImage = function() {
    var n = this.types.some(function(o) {
      return o.indexOf("application/x-moz-file") != -1;
    });
    if (n)
      return !0;
    for (var a = this.getFiles(), s = 0; s < a.length; s++) {
      var i = a[s].type;
      if (!h2e.isImage(i))
        return !1;
    }
    return !0;
  }, t.getCount = function() {
    return this.data.hasOwnProperty("items") ? this.data.items.length : this.data.hasOwnProperty("mozItemCount") ? this.data.mozItemCount : this.data.files ? this.data.files.length : null;
  }, t.getFiles = function() {
    return this.data.items ? Array.prototype.slice.call(this.data.items).map(b2e).filter(m2e.thatReturnsArgument) : this.data.files ? Array.prototype.slice.call(this.data.files) : [];
  }, t.hasFiles = function() {
    return this.getFiles().length > 0;
  }, e;
}(), dU = w2e, x2e = {}, DD = jr, ND = /\.textClipping$/, _2e = {
  "text/plain": !0,
  "text/html": !0,
  "text/rtf": !0
}, S2e = 5e3;
function E2e(e, t) {
  var r = 0, n = [];
  e.forEach(function(a) {
    T2e(a, function(s) {
      r++, s && n.push(s.slice(0, S2e)), r == e.length && t(n.join("\r"));
    });
  });
}
function T2e(e, t) {
  if (!window.FileReader || e.type && !(e.type in _2e)) {
    t("");
    return;
  }
  if (e.type === "") {
    var r = "";
    ND.test(e.name) && (r = e.name.replace(ND, "")), t(r);
    return;
  }
  var n = new FileReader();
  n.onload = function() {
    var a = n.result;
    typeof a != "string" && (x2e.NODE_ENV !== "production" ? DD(!1, 'We should be calling "FileReader.readAsText" which returns a string') : DD(!1)), t(a);
  }, n.onerror = function() {
    t("");
  }, n.readAsText(e);
}
var fU = E2e;
function C2e(e) {
  return e === "handled" || e === !0;
}
var mx = C2e, k2e = dU, hU = Cs, pU = ln, O2e = ux, A2e = cx, P2e = fU, R2e = U6, I2e = j6, MD = mx, A_ = ks;
function D2e(e, t) {
  var r = null, n = null, a = A2e(e.currentTarget);
  if (typeof a.caretRangeFromPoint == "function") {
    var s = a.caretRangeFromPoint(e.x, e.y);
    r = s.startContainer, n = s.startOffset;
  } else if (e.rangeParent)
    r = e.rangeParent, n = e.rangeOffset;
  else
    return null;
  r = A_(r), n = A_(n);
  var i = A_(O2e(r));
  return R2e(t, i, n, i, n);
}
var N2e = {
  /**
   * Drag originating from input terminated.
   */
  onDragEnd: function(t) {
    t.exitCurrentMode(), LD(t);
  },
  /**
   * Handle data being dropped.
   */
  onDrop: function(t, r) {
    var n = new k2e(r.nativeEvent.dataTransfer), a = t._latestEditorState, s = D2e(r.nativeEvent, a);
    if (r.preventDefault(), t._dragCount = 0, t.exitCurrentMode(), s != null) {
      var i = n.getFiles();
      if (i.length > 0) {
        if (t.props.handleDroppedFiles && MD(t.props.handleDroppedFiles(s, i)))
          return;
        P2e(i, function(l) {
          l && t.update(jD(a, s, l));
        });
        return;
      }
      var o = t._internalDrag ? "internal" : "external";
      t.props.handleDrop && MD(t.props.handleDrop(s, n, o)) || (t._internalDrag ? t.update(M2e(a, s)) : t.update(jD(a, s, n.getText()))), LD(t);
    }
  }
};
function LD(e) {
  e._internalDrag = !1;
  var t = e.editorContainer;
  if (t) {
    var r = new MouseEvent("mouseup", {
      view: I2e(t),
      bubbles: !0,
      cancelable: !0
    });
    t.dispatchEvent(r);
  }
}
function M2e(e, t) {
  var r = hU.moveText(e.getCurrentContent(), e.getSelection(), t);
  return pU.push(e, r, "insert-fragment");
}
function jD(e, t, r) {
  var n = hU.insertText(e.getCurrentContent(), t, r, e.getCurrentInlineStyle());
  return pU.push(e, n, "insert-fragment");
}
var L2e = N2e;
function j2e(e) {
  var t = e.getSelection(), r = t.getAnchorKey(), n = e.getBlockTree(r), a = t.getStartOffset(), s = !1;
  return n.some(function(i) {
    return a === i.get("start") ? (s = !0, !0) : a < i.get("end") ? i.get("leaves").some(function(o) {
      var l = o.get("start");
      return a === l ? (s = !0, !0) : !1;
    }) : !1;
  }), s;
}
var F2e = j2e;
(function(e, t) {
  if (e.setImmediate)
    return;
  var r = 1, n = {}, a = !1, s = e.document, i;
  function o(x) {
    typeof x != "function" && (x = new Function("" + x));
    for (var w = new Array(arguments.length - 1), _ = 0; _ < w.length; _++)
      w[_] = arguments[_ + 1];
    var S = { callback: x, args: w };
    return n[r] = S, i(r), r++;
  }
  function l(x) {
    delete n[x];
  }
  function c(x) {
    var w = x.callback, _ = x.args;
    switch (_.length) {
      case 0:
        w();
        break;
      case 1:
        w(_[0]);
        break;
      case 2:
        w(_[0], _[1]);
        break;
      case 3:
        w(_[0], _[1], _[2]);
        break;
      default:
        w.apply(t, _);
        break;
    }
  }
  function u(x) {
    if (a)
      setTimeout(u, 0, x);
    else {
      var w = n[x];
      if (w) {
        a = !0;
        try {
          c(w);
        } finally {
          l(x), a = !1;
        }
      }
    }
  }
  function d() {
    i = function(x) {
      process.nextTick(function() {
        u(x);
      });
    };
  }
  function f() {
    if (e.postMessage && !e.importScripts) {
      var x = !0, w = e.onmessage;
      return e.onmessage = function() {
        x = !1;
      }, e.postMessage("", "*"), e.onmessage = w, x;
    }
  }
  function h() {
    var x = "setImmediate$" + Math.random() + "$", w = function(_) {
      _.source === e && typeof _.data == "string" && _.data.indexOf(x) === 0 && u(+_.data.slice(x.length));
    };
    e.addEventListener ? e.addEventListener("message", w, !1) : e.attachEvent("onmessage", w), i = function(_) {
      e.postMessage(x + _, "*");
    };
  }
  function p() {
    var x = new MessageChannel();
    x.port1.onmessage = function(w) {
      var _ = w.data;
      u(_);
    }, i = function(w) {
      x.port2.postMessage(w);
    };
  }
  function m() {
    var x = s.documentElement;
    i = function(w) {
      var _ = s.createElement("script");
      _.onreadystatechange = function() {
        u(w), _.onreadystatechange = null, x.removeChild(_), _ = null;
      }, x.appendChild(_);
    };
  }
  function g() {
    i = function(x) {
      setTimeout(u, 0, x);
    };
  }
  var y = Object.getPrototypeOf && Object.getPrototypeOf(e);
  y = y && y.setTimeout ? y : e, {}.toString.call(e.process) === "[object process]" ? d() : f() ? h() : e.MessageChannel ? p() : s && "onreadystatechange" in s.createElement("script") ? m() : g(), y.setImmediate = o, y.clearImmediate = l;
})(typeof self > "u" ? typeof window > "u" ? ke : window : self);
var B2e = window.setImmediate, U2e = Cs, YE = ln, V2e = Os, FD = vk, $2e = mx, H2e = F2e, BD = ks, W2e = B2e, z2e = "'", K2e = "/", q2e = V2e.isBrowser("Firefox");
function G2e(e) {
  return q2e && (e == z2e || e == K2e);
}
function UD(e, t, r, n, a) {
  var s = U2e.replaceText(e.getCurrentContent(), e.getSelection(), t, r, n);
  return YE.push(e, s, "insert-characters", a);
}
function Y2e(e, t) {
  e._pendingStateFromBeforeInput !== void 0 && (e.update(e._pendingStateFromBeforeInput), e._pendingStateFromBeforeInput = void 0);
  var r = e._latestEditorState, n = t.data;
  if (n) {
    if (e.props.handleBeforeInput && $2e(e.props.handleBeforeInput(n, r, t.timeStamp))) {
      t.preventDefault();
      return;
    }
    var a = r.getSelection(), s = a.getStartOffset(), i = a.getAnchorKey();
    if (!a.isCollapsed()) {
      t.preventDefault(), e.update(UD(r, n, r.getCurrentInlineStyle(), FD(r.getCurrentContent(), r.getSelection()), !0));
      return;
    }
    var o = UD(r, n, r.getCurrentInlineStyle(), FD(r.getCurrentContent(), r.getSelection()), !1), l = !1;
    if (l || (l = H2e(e._latestCommittedEditorState)), !l) {
      var c = r.getBlockTree(i), u = o.getBlockTree(i);
      l = c.size !== u.size || c.zip(u).some(function(d) {
        var f = d[0], h = d[1], p = f.get("start"), m = p + (p >= s ? n.length : 0), g = f.get("end"), y = g + (g >= s ? n.length : 0), x = h.get("start"), w = h.get("end"), _ = h.get("decoratorKey");
        return (
          // Different decorators
          f.get("decoratorKey") !== _ || // Different number of inline styles
          f.get("leaves").size !== h.get("leaves").size || // Different effective decorator position
          m !== x || y !== w || // Decorator already existed and its length changed
          _ != null && w - x !== g - p
        );
      });
    }
    if (l || (l = G2e(n)), l || (l = BD(o.getDirectionMap()).get(i) !== BD(r.getDirectionMap()).get(i)), l) {
      t.preventDefault(), o = YE.set(o, {
        forceSelection: !0
      }), e.update(o);
      return;
    }
    o = YE.set(o, {
      nativelyRenderedContent: o.getCurrentContent()
    }), e._pendingStateFromBeforeInput = o, W2e(function() {
      e._pendingStateFromBeforeInput !== void 0 && (e.update(e._pendingStateFromBeforeInput), e._pendingStateFromBeforeInput = void 0);
    });
  }
}
var X2e = Y2e, Q2e = ln, VD = bk, J2e = Y6;
function Z2e(e, t) {
  var r = t.currentTarget.ownerDocument;
  if (
    // This ESLint rule conflicts with `sketchy-null-bool` flow check
    // eslint-disable-next-line no-extra-boolean-cast
    !e.props.preserveSelectionOnBlur && J2e(r) === r.body
  ) {
    var n = r.defaultView.getSelection(), a = e.editor;
    n.rangeCount === 1 && VD(a, n.anchorNode) && VD(a, n.focusNode) && n.removeAllRanges();
  }
  var s = e._latestEditorState, i = s.getSelection();
  if (i.getHasFocus()) {
    var o = i.set("hasFocus", !1);
    e.props.onBlur && e.props.onBlur(t), e.update(Q2e.acceptSelection(s, o));
  }
}
var eOe = Z2e, tOe = ln;
function rOe(e, t) {
  e.setMode("composite"), e.update(tOe.set(e._latestEditorState, {
    inCompositionMode: !0
  })), e._onCompositionStart(t);
}
var nOe = rOe, aOe = nx;
function sOe(e) {
  var t = e.getSelection();
  return t.isCollapsed() ? null : aOe(e.getCurrentContent(), t);
}
var mU = sOe, iOe = mU;
function oOe(e, t) {
  var r = e._latestEditorState, n = r.getSelection();
  if (n.isCollapsed()) {
    t.preventDefault();
    return;
  }
  e.setClipboard(iOe(e._latestEditorState));
}
var lOe = oOe;
function cOe(e) {
  if (!e || !("ownerDocument" in e))
    return !1;
  if ("ownerDocument" in e) {
    var t = e;
    if (!t.ownerDocument.defaultView)
      return t instanceof Node;
    if (t instanceof t.ownerDocument.defaultView.Node)
      return !0;
  }
  return !1;
}
var uOe = cOe, dOe = Cs, fOe = ln, hOe = fx, pOe = mU, mOe = hx, gOe = uOe;
function vOe(e, t) {
  var r = e._latestEditorState, n = r.getSelection(), a = t.target, s;
  if (n.isCollapsed()) {
    t.preventDefault();
    return;
  }
  if (gOe(a)) {
    var i = a;
    s = mOe(hOe.getScrollParent(i));
  }
  var o = pOe(r);
  e.setClipboard(o), e.setMode("cut"), setTimeout(function() {
    e.restoreEditorDOM(s), e.exitCurrentMode(), e.update(yOe(r));
  }, 0);
}
function yOe(e) {
  var t = dOe.removeRange(e.getCurrentContent(), e.getSelection(), "forward");
  return fOe.push(e, t, "remove-range");
}
var bOe = vOe;
function wOe(e, t) {
  e.setMode("drag"), t.preventDefault();
}
var xOe = wOe;
function _Oe(e) {
  e._internalDrag = !0, e.setMode("drag");
}
var SOe = _Oe, $D = ln, EOe = Os;
function TOe(e, t) {
  var r = e._latestEditorState, n = r.getSelection();
  if (!n.getHasFocus()) {
    var a = n.set("hasFocus", !0);
    e.props.onFocus && e.props.onFocus(t), EOe.isBrowser("Chrome < 60.0.3081.0") ? e.update($D.forceSelection(r, a)) : e.update($D.acceptSelection(r, a));
  }
}
var COe = TOe, kOe = {}, HD = jr, gU = 55296, OOe = 56319, AOe = 56320, vU = 57343, POe = /[\uD800-\uDFFF]/;
function yU(e) {
  return gU <= e && e <= vU;
}
function ROe(e, t) {
  if (0 <= t && t < e.length || (kOe.NODE_ENV !== "production" ? HD(!1, "isSurrogatePair: Invalid index %s for string length %s.", t, e.length) : HD(!1)), t + 1 === e.length)
    return !1;
  var r = e.charCodeAt(t), n = e.charCodeAt(t + 1);
  return gU <= r && r <= OOe && AOe <= n && n <= vU;
}
function _k(e) {
  return POe.test(e);
}
function jf(e, t) {
  return 1 + yU(e.charCodeAt(t));
}
function IOe(e) {
  if (!_k(e))
    return e.length;
  for (var t = 0, r = 0; r < e.length; r += jf(e, r))
    t++;
  return t;
}
function bU(e, t, r) {
  if (t = t || 0, r = r === void 0 ? 1 / 0 : r || 0, !_k(e))
    return e.substr(t, r);
  var n = e.length;
  if (n <= 0 || t > n || r <= 0)
    return "";
  var a = 0;
  if (t > 0) {
    for (; t > 0 && a < n; t--)
      a += jf(e, a);
    if (a >= n)
      return "";
  } else if (t < 0) {
    for (a = n; t < 0 && 0 < a; t++)
      a -= jf(e, a - 1);
    a < 0 && (a = 0);
  }
  var s = n;
  if (r < n)
    for (s = a; r > 0 && s < n; r--)
      s += jf(e, s);
  return e.substring(a, s);
}
function DOe(e, t, r) {
  t = t || 0, r = r === void 0 ? 1 / 0 : r || 0, t < 0 && (t = 0), r < 0 && (r = 0);
  var n = Math.abs(r - t);
  return t = t < r ? t : r, bU(e, t, n);
}
function NOe(e) {
  for (var t = [], r = 0; r < e.length; r += jf(e, r))
    t.push(e.codePointAt(r));
  return t;
}
var MOe = {
  getCodePoints: NOe,
  getUTF16Length: jf,
  hasSurrogateUnit: _k,
  isCodeUnitInSurrogateRange: yU,
  isSurrogatePair: ROe,
  strlen: IOe,
  substring: DOe,
  substr: bU
}, hd = MOe, LOe = {}, jOe = uU;
function FOe(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  var a = 0, s = "Warning: " + e.replace(/%s/g, function() {
    return r[a++];
  });
  typeof console < "u" && console.error(s);
  try {
    throw new Error(s);
  } catch {
  }
}
var BOe = LOe.NODE_ENV !== "production" ? function(e, t) {
  if (t === void 0)
    throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
  if (!e) {
    for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
      n[a - 2] = arguments[a];
    FOe.apply(void 0, [t].concat(n));
  }
} : jOe, Sk = BOe, UOe = {}, VOe = Sk;
function $Oe(e, t) {
  var r = e.getSelection();
  UOe.NODE_ENV !== "production" && VOe(r.isCollapsed(), "moveSelectionBackward should only be called with a collapsed SelectionState");
  var n = e.getCurrentContent(), a = r.getStartKey(), s = r.getStartOffset(), i = a, o = 0;
  if (t > s) {
    var l = n.getKeyBefore(a);
    if (l == null)
      i = a;
    else {
      i = l;
      var c = n.getBlockForKey(l);
      o = c.getText().length;
    }
  } else
    o = s - t;
  return r.merge({
    focusKey: i,
    focusOffset: o,
    isBackward: !0
  });
}
var Ek = $Oe, HOe = Cs, WOe = Gc, WD = WOe("draft_tree_data_support");
function zOe(e, t, r) {
  var n = e.getSelection(), a = e.getCurrentContent(), s = n, i = n.getAnchorKey(), o = n.getFocusKey(), l = a.getBlockForKey(i);
  if (WD && r === "forward" && i !== o)
    return a;
  if (n.isCollapsed()) {
    if (r === "forward") {
      if (e.isSelectionAtEndOfContent())
        return a;
      if (WD) {
        var c = n.getAnchorOffset() === a.getBlockForKey(i).getLength();
        if (c) {
          var u = a.getBlockForKey(l.nextSibling);
          if (!u || u.getLength() === 0)
            return a;
        }
      }
    } else if (e.isSelectionAtStartOfContent())
      return a;
    if (s = t(e), s === n)
      return a;
  }
  return HOe.removeRange(a, s, r);
}
var Kg = zOe, KOe = ln, qOe = hd, GOe = Ek, YOe = Kg;
function XOe(e) {
  var t = YOe(e, function(n) {
    var a = n.getSelection(), s = n.getCurrentContent(), i = a.getAnchorKey(), o = a.getAnchorOffset(), l = s.getBlockForKey(i).getText()[o - 1];
    return GOe(n, l ? qOe.getUTF16Length(l, 0) : 1);
  }, "backward");
  if (t === e.getCurrentContent())
    return e;
  var r = e.getSelection();
  return KOe.push(e, t.set("selectionBefore", r), r.isCollapsed() ? "backspace-character" : "remove-range");
}
var wU = XOe, QOe = Cs, JOe = zl, ZOe = ln, eAe = Os, tAe = W6, rAe = tAe.notEmptyKey, nAe = ux, aAe = wU, sAe = ks, iAe = eAe.isEngine("Gecko"), oAe = `

`;
function lAe(e, t) {
  switch (e) {
    case "deleteContentBackward":
      return aAe(t);
  }
  return t;
}
function cAe(e, t) {
  e._pendingStateFromBeforeInput !== void 0 && (e.update(e._pendingStateFromBeforeInput), e._pendingStateFromBeforeInput = void 0);
  var r = e.editor, n = r.ownerDocument.defaultView.getSelection(), a = n.anchorNode, s = n.isCollapsed, i = (a == null ? void 0 : a.nodeType) !== Node.TEXT_NODE && (a == null ? void 0 : a.nodeType) !== Node.ELEMENT_NODE;
  if (!(a == null || i)) {
    if (a.nodeType === Node.TEXT_NODE && (a.previousSibling !== null || a.nextSibling !== null)) {
      var o = a.parentNode;
      if (o == null)
        return;
      a.nodeValue = o.textContent;
      for (var l = o.firstChild; l != null; l = l.nextSibling)
        l !== a && o.removeChild(l);
    }
    var c = a.textContent, u = e._latestEditorState, d = sAe(nAe(a)), f = JOe.decode(d), h = f.blockKey, p = f.decoratorKey, m = f.leafKey, g = u.getBlockTree(h).getIn([p, "leaves", m]), y = g.start, x = g.end, w = u.getCurrentContent(), _ = w.getBlockForKey(h), S = _.getText().slice(y, x);
    if (c.endsWith(oAe) && (c = c.slice(0, -1)), c === S) {
      var C = t.nativeEvent.inputType;
      if (C) {
        var E = lAe(C, u);
        if (E !== u) {
          e.restoreEditorDOM(), e.update(E);
          return;
        }
      }
      return;
    }
    var O = u.getSelection(), k = O.merge({
      anchorOffset: y,
      focusOffset: x,
      isBackward: !1
    }), A = _.getEntityAt(y), P = rAe(A) ? w.getEntity(A) : null, D = P != null ? P.getMutability() : null, N = D === "MUTABLE", z = N ? "spellcheck-change" : "apply-entity", G = QOe.replaceText(w, k, c, _.getInlineStyleAt(y), N ? _.getEntityAt(y) : null), Y, te, ae, ne;
    if (iAe)
      Y = n.anchorOffset, te = n.focusOffset, ae = y + Math.min(Y, te), ne = ae + Math.abs(Y - te), Y = ae, te = ne;
    else {
      var ue = c.length - S.length;
      ae = O.getStartOffset(), ne = O.getEndOffset(), Y = s ? ne + ue : ae, te = ne + ue;
    }
    var q = G.merge({
      selectionBefore: w.getSelectionAfter(),
      selectionAfter: O.merge({
        anchorOffset: Y,
        focusOffset: te
      })
    });
    e.update(ZOe.push(u, q, z));
  }
}
var uAe = cAe, dAe = dx;
function fAe(e) {
  return e.which === dAe.RETURN && (e.getModifierState("Shift") || e.getModifierState("Alt") || e.getModifierState("Control"));
}
var hAe = fAe, pAe = Os, mAe = hAe, P_ = pAe.isPlatform("Mac OS X"), xU = {
  /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
  isCtrlKeyCommand: function(t) {
    return !!t.ctrlKey && !t.altKey;
  },
  isOptionKeyCommand: function(t) {
    return P_ && t.altKey;
  },
  usesMacOSHeuristics: function() {
    return P_;
  },
  hasCommandModifier: function(t) {
    return P_ ? !!t.metaKey && !t.altKey : xU.isCtrlKeyCommand(t);
  },
  isSoftNewlineEvent: mAe
}, Tk = xU, zD = Cs, KD = ln, gAe = nx, vAe = ks, R_ = null, yAe = {
  cut: function(t) {
    var r = t.getCurrentContent(), n = t.getSelection(), a = null;
    if (n.isCollapsed()) {
      var s = n.getAnchorKey(), i = r.getBlockForKey(s).getLength();
      if (i === n.getAnchorOffset()) {
        var o = r.getKeyAfter(s);
        if (o == null)
          return t;
        a = n.set("focusKey", o).set("focusOffset", 0);
      } else
        a = n.set("focusOffset", i);
    } else
      a = n;
    a = vAe(a), R_ = gAe(r, a);
    var l = zD.removeRange(r, a, "forward");
    return l === r ? t : KD.push(t, l, "remove-range");
  },
  paste: function(t) {
    if (!R_)
      return t;
    var r = zD.replaceWithFragment(t.getCurrentContent(), t.getSelection(), R_);
    return KD.push(t, r, "insert-fragment");
  }
}, bAe = yAe, wAe = {}, xAe = Os, qD = jr, _Ae = xAe.isBrowser("Chrome");
function SAe(e) {
  for (var t = e.cloneRange(), r = [], n = e.endContainer; n != null; n = n.parentNode) {
    var a = n === e.commonAncestorContainer;
    a ? t.setStart(e.startContainer, e.startOffset) : t.setStart(t.endContainer, 0);
    var s = Array.from(t.getClientRects());
    if (r.push(s), a) {
      var i;
      return r.reverse(), (i = []).concat.apply(i, r);
    }
    t.setEndBefore(n);
  }
  wAe.NODE_ENV !== "production" ? qD(!1, "Found an unexpected detached subtree when getting range client rects.") : qD(!1);
}
var EAe = _Ae ? SAe : function(e) {
  return Array.from(e.getClientRects());
}, _U = EAe, XE = {}, TAe = hd, CAe = cx, GD = _U, Pf = jr;
function kAe(e) {
  var t = getComputedStyle(e), r = CAe(e), n = r.createElement("div");
  n.style.fontFamily = t.fontFamily, n.style.fontSize = t.fontSize, n.style.fontStyle = t.fontStyle, n.style.fontWeight = t.fontWeight, n.style.lineHeight = t.lineHeight, n.style.position = "absolute", n.textContent = "M";
  var a = r.body;
  a || (XE.NODE_ENV !== "production" ? Pf(!1, "Missing document.body") : Pf(!1)), a.appendChild(n);
  var s = n.getBoundingClientRect();
  return a.removeChild(n), s.height;
}
function YD(e, t) {
  for (var r = 1 / 0, n = 1 / 0, a = -1 / 0, s = -1 / 0, i = 0; i < e.length; i++) {
    var o = e[i];
    o.width === 0 || o.width === 1 || (r = Math.min(r, o.top), n = Math.min(n, o.bottom), a = Math.max(a, o.top), s = Math.max(s, o.bottom));
  }
  return a <= n && a - r < t && s - n < t;
}
function OAe(e) {
  switch (e.nodeType) {
    case Node.DOCUMENT_TYPE_NODE:
      return 0;
    case Node.TEXT_NODE:
    case Node.PROCESSING_INSTRUCTION_NODE:
    case Node.COMMENT_NODE:
      return e.length;
    default:
      return e.childNodes.length;
  }
}
function AAe(e) {
  e.collapsed || (XE.NODE_ENV !== "production" ? Pf(!1, "expandRangeToStartOfLine: Provided range is not collapsed.") : Pf(!1)), e = e.cloneRange();
  var t = e.startContainer;
  t.nodeType !== 1 && (t = t.parentNode);
  var r = kAe(t), n = e.endContainer, a = e.endOffset;
  for (e.setStart(e.startContainer, 0); YD(GD(e), r) && (n = e.startContainer, a = e.startOffset, n.parentNode || (XE.NODE_ENV !== "production" ? Pf(!1, "Found unexpected detached subtree when traversing.") : Pf(!1)), e.setStartBefore(n), !(n.nodeType === 1 && getComputedStyle(n).display !== "inline")); )
    ;
  var s = n, i = a - 1;
  do {
    for (var o = s.nodeValue, l = i; l >= 0; l--)
      if (!(o != null && l > 0 && TAe.isSurrogatePair(o, l - 1)))
        if (e.setStart(s, l), YD(GD(e), r))
          n = s, a = l;
        else
          break;
    if (l === -1 || s.childNodes.length === 0)
      break;
    s = s.childNodes[l], i = OAe(s);
  } while (!0);
  return e.setStart(n, a), e;
}
var PAe = AAe, RAe = ln, IAe = PAe, DAe = V6, NAe = Ek, MAe = Kg;
function LAe(e, t) {
  var r = MAe(e, function(n) {
    var a = n.getSelection();
    if (a.isCollapsed() && a.getAnchorOffset() === 0)
      return NAe(n, 1);
    var s = t.currentTarget.ownerDocument, i = s.defaultView.getSelection(), o = i.getRangeAt(0);
    return o = IAe(o), DAe(n, null, o.endContainer, o.endOffset, o.startContainer, o.startOffset).selectionState;
  }, "backward");
  return r === e.getCurrentContent() ? e : RAe.push(e, r, "remove-range");
}
var jAe = LAe, FAe = `[.,+*?$|#{}()'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;・、。〈-】〔-〟：-？！-／［-｀｛-･⸮؟٪-٬؛،؍﴾﴿᠁।၊။‐-‧‰-⁞¡-±´-¸º»¿]`, BAe = {
  getPunctuation: function() {
    return FAe;
  }
}, UAe = BAe, VAe = UAe.getPunctuation(), SU = "['‘’]", Ff = "\\s|(?![_])" + VAe, $Ae = "^(?:" + Ff + ")*(?:" + SU + "|(?!" + Ff + ").)*(?:(?!" + Ff + ").)", HAe = new RegExp($Ae), WAe = "(?:(?!" + Ff + ").)(?:" + SU + "|(?!" + Ff + ").)*(?:" + Ff + ")*$", zAe = new RegExp(WAe);
function XD(e, t) {
  var r = t ? zAe.exec(e) : HAe.exec(e);
  return r ? r[0] : e;
}
var KAe = {
  getBackward: function(t) {
    return XD(t, !0);
  },
  getForward: function(t) {
    return XD(t, !1);
  }
}, EU = KAe, qAe = EU, GAe = ln, QD = Ek, YAe = Kg;
function XAe(e) {
  var t = YAe(e, function(r) {
    var n = r.getSelection(), a = n.getStartOffset();
    if (a === 0)
      return QD(r, 1);
    var s = n.getStartKey(), i = r.getCurrentContent(), o = i.getBlockForKey(s).getText().slice(0, a), l = qAe.getBackward(o);
    return QD(r, l.length || 1);
  }, "backward");
  return t === e.getCurrentContent() ? e : GAe.push(e, t, "remove-range");
}
var QAe = XAe, JAe = {}, ZAe = Sk;
function ePe(e, t) {
  var r = e.getSelection();
  JAe.NODE_ENV !== "production" && ZAe(r.isCollapsed(), "moveSelectionForward should only be called with a collapsed SelectionState");
  var n = r.getStartKey(), a = r.getStartOffset(), s = e.getCurrentContent(), i = n, o, l = s.getBlockForKey(n);
  return t > l.getText().length - a ? (i = s.getKeyAfter(n), o = 0) : o = a + t, r.merge({
    focusKey: i,
    focusOffset: o
  });
}
var TU = ePe, tPe = EU, rPe = ln, nPe = TU, aPe = Kg;
function sPe(e) {
  var t = aPe(e, function(r) {
    var n = r.getSelection(), a = n.getStartOffset(), s = n.getStartKey(), i = r.getCurrentContent(), o = i.getBlockForKey(s).getText().slice(a), l = tPe.getForward(o);
    return nPe(r, l.length || 1);
  }, "forward");
  return t === e.getCurrentContent() ? e : rPe.push(e, t, "remove-range");
}
var iPe = sPe, oPe = Cs, lPe = ln;
function cPe(e) {
  var t = oPe.splitBlock(e.getCurrentContent(), e.getSelection());
  return lPe.push(e, t, "split-block");
}
var uPe = cPe, dPe = ln;
function fPe(e) {
  var t = e.getSelection(), r = t.getEndKey(), n = e.getCurrentContent(), a = n.getBlockForKey(r).getLength();
  return dPe.set(e, {
    selection: t.merge({
      anchorKey: r,
      anchorOffset: a,
      focusKey: r,
      focusOffset: a,
      isBackward: !1
    }),
    forceSelection: !0
  });
}
var hPe = fPe, pPe = ln;
function mPe(e) {
  var t = e.getSelection(), r = t.getStartKey();
  return pPe.set(e, {
    selection: t.merge({
      anchorKey: r,
      anchorOffset: 0,
      focusKey: r,
      focusOffset: 0,
      isBackward: !1
    }),
    forceSelection: !0
  });
}
var gPe = mPe, vPe = ln, yPe = hd, bPe = TU, wPe = Kg;
function xPe(e) {
  var t = wPe(e, function(n) {
    var a = n.getSelection(), s = n.getCurrentContent(), i = a.getAnchorKey(), o = a.getAnchorOffset(), l = s.getBlockForKey(i).getText()[o];
    return bPe(n, l ? yPe.getUTF16Length(l, 0) : 1);
  }, "forward");
  if (t === e.getCurrentContent())
    return e;
  var r = e.getSelection();
  return vPe.push(e, t.set("selectionBefore", r), r.isCollapsed() ? "delete-character" : "remove-range");
}
var _Pe = xPe, JD = Cs, ZD = ln, SPe = nx;
function EPe(e) {
  var t = e.getSelection();
  if (!t.isCollapsed())
    return e;
  var r = t.getAnchorOffset();
  if (r === 0)
    return e;
  var n = t.getAnchorKey(), a = e.getCurrentContent(), s = a.getBlockForKey(n), i = s.getLength();
  if (i <= 1)
    return e;
  var o, l;
  r === i ? (o = t.set("anchorOffset", r - 1), l = t) : (o = t.set("focusOffset", r + 1), l = o.set("anchorOffset", r + 1));
  var c = SPe(a, o), u = JD.removeRange(a, o, "backward"), d = u.getSelectionAfter(), f = d.getAnchorOffset() - 1, h = d.merge({
    anchorOffset: f,
    focusOffset: f
  }), p = JD.replaceWithFragment(u, h, c), m = ZD.push(e, p, "insert-fragment");
  return ZD.acceptSelection(m, l);
}
var TPe = EPe, I_ = ln;
function CPe(e, t, r) {
  var n = I_.undo(t);
  if (t.getLastChangeType() === "spellcheck-change") {
    var a = n.getCurrentContent();
    r(I_.set(n, {
      nativelyRenderedContent: a
    }));
    return;
  }
  if (e.preventDefault(), !t.getNativelyRenderedContent()) {
    r(n);
    return;
  }
  r(I_.set(t, {
    nativelyRenderedContent: null
  })), setTimeout(function() {
    r(n);
  }, 0);
}
var kPe = CPe, OPe = Cs, CU = ln, APe = Tk, rl = dx, eN = bAe, PPe = Os, tN = mx, RPe = jAe, IPe = QAe, DPe = iPe, NPe = uPe, MPe = hPe, LPe = gPe, jPe = wU, FPe = _Pe, BPe = TPe, UPe = kPe, rN = APe.isOptionKeyCommand, nN = PPe.isBrowser("Chrome");
function VPe(e, t, r) {
  switch (e) {
    case "redo":
      return CU.redo(t);
    case "delete":
      return FPe(t);
    case "delete-word":
      return DPe(t);
    case "backspace":
      return jPe(t);
    case "backspace-word":
      return IPe(t);
    case "backspace-to-start-of-line":
      return RPe(t, r);
    case "split-block":
      return NPe(t);
    case "transpose-characters":
      return BPe(t);
    case "move-selection-to-start-of-block":
      return LPe(t);
    case "move-selection-to-end-of-block":
      return MPe(t);
    case "secondary-cut":
      return eN.cut(t);
    case "secondary-paste":
      return eN.paste(t);
    default:
      return t;
  }
}
function $Pe(e, t) {
  var r = t.which, n = e._latestEditorState;
  function a(l) {
    var c = e.props[l];
    return c ? (c(t), !0) : !1;
  }
  switch (r) {
    case rl.RETURN:
      if (t.preventDefault(), e.props.handleReturn && tN(e.props.handleReturn(t, n)))
        return;
      break;
    case rl.ESC:
      if (t.preventDefault(), a("onEscape"))
        return;
      break;
    case rl.TAB:
      if (a("onTab"))
        return;
      break;
    case rl.UP:
      if (a("onUpArrow"))
        return;
      break;
    case rl.RIGHT:
      if (a("onRightArrow"))
        return;
      break;
    case rl.DOWN:
      if (a("onDownArrow"))
        return;
      break;
    case rl.LEFT:
      if (a("onLeftArrow"))
        return;
      break;
    case rl.SPACE:
      nN && rN(t) && t.preventDefault();
  }
  var s = e.props.keyBindingFn(t);
  if (s == null || s === "") {
    if (r === rl.SPACE && nN && rN(t)) {
      var i = OPe.replaceText(n.getCurrentContent(), n.getSelection(), " ");
      e.update(CU.push(n, i, "insert-characters"));
    }
    return;
  }
  if (s === "undo") {
    UPe(t, n, e.update);
    return;
  }
  if (t.preventDefault(), !(e.props.handleKeyCommand && tN(e.props.handleKeyCommand(s, n, t.timeStamp)))) {
    var o = VPe(s, n, t);
    o !== n && e.update(o);
  }
}
var HPe = $Pe;
function WPe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var zPe = /* @__PURE__ */ function() {
  function e(r) {
    WPe(this, "_uri", void 0), this._uri = r;
  }
  var t = e.prototype;
  return t.toString = function() {
    return this._uri;
  }, e;
}(), KPe = zPe, qPe = {}, GPe = Os, aN = jr, YPe = GPe.isBrowser("IE <= 9");
function XPe(e) {
  var t, r = null;
  return !YPe && document.implementation && document.implementation.createHTMLDocument && (t = document.implementation.createHTMLDocument("foo"), t.documentElement || (qPe.NODE_ENV !== "production" ? aN(!1, "Missing doc.documentElement") : aN(!1)), t.documentElement.innerHTML = e, r = t.getElementsByTagName("body")[0]), r;
}
var kU = XPe, QPe = dd;
function JPe(e) {
  return !e || !e.ownerDocument ? !1 : QPe(e) && e.nodeName === "A";
}
var ZPe = JPe, eRe = dd;
function tRe(e) {
  return !e || !e.ownerDocument ? !1 : eRe(e) && e.nodeName === "IMG";
}
var rRe = tRe, ru;
function D_(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    }))), n.forEach(function(a) {
      Ca(e, a, r[a]);
    });
  }
  return e;
}
function Ca(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var nRe = gi, aRe = cd, sRe = vi, iRe = mk, sN = ax, OU = KPe, Sp = ud, iN = Wo, oRe = kU, AU = Gc, Ck = Tr, rc = Ck.List, PU = Ck.Map, lRe = Ck.OrderedSet, RU = ZPe, cRe = K6, kk = zg, IU = rRe, oN = AU("draft_tree_data_support"), uRe = "&nbsp;", DU = " ", dRe = new RegExp("\r", "g"), fRe = new RegExp(`
`, "g"), hRe = new RegExp(`^
`, "g"), pRe = new RegExp(uRe, "g"), mRe = new RegExp("&#13;?", "g"), gRe = new RegExp("&#8203;?", "g"), vRe = ["bold", "bolder", "500", "600", "700", "800", "900"], yRe = ["light", "lighter", "normal", "100", "200", "300", "400"], bRe = ["className", "href", "rel", "target", "title"], wRe = ["alt", "className", "height", "src", "width"], lN = (ru = {}, Ca(ru, Sp("public/DraftStyleDefault/depth0"), 0), Ca(ru, Sp("public/DraftStyleDefault/depth1"), 1), Ca(ru, Sp("public/DraftStyleDefault/depth2"), 2), Ca(ru, Sp("public/DraftStyleDefault/depth3"), 3), Ca(ru, Sp("public/DraftStyleDefault/depth4"), 4), ru), cN = PU({
  b: "BOLD",
  code: "CODE",
  del: "STRIKETHROUGH",
  em: "ITALIC",
  i: "ITALIC",
  s: "STRIKETHROUGH",
  strike: "STRIKETHROUGH",
  strong: "BOLD",
  u: "UNDERLINE",
  mark: "HIGHLIGHT"
}), xRe = function(t) {
  var r = {};
  return t.mapKeys(function(n, a) {
    var s = [a.element];
    a.aliasedElements !== void 0 && s.push.apply(s, a.aliasedElements), s.forEach(function(i) {
      r[i] === void 0 ? r[i] = n : typeof r[i] == "string" ? r[i] = [r[i], n] : r[i].push(n);
    });
  }), PU(r);
}, _Re = function(t) {
  if (kk(t)) {
    var r = t;
    if (r.style.fontFamily.includes("monospace"))
      return "CODE";
  }
  return null;
}, SRe = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return Object.keys(lN).some(function(n) {
    t.classList.contains(n) && (r = lN[n]);
  }), r;
}, ERe = function(t) {
  if (!RU(t))
    return !1;
  var r = t;
  if (!r.href || r.protocol !== "http:" && r.protocol !== "https:" && r.protocol !== "mailto:" && r.protocol !== "tel:")
    return !1;
  try {
    var n = new OU(r.href);
    return !0;
  } catch {
    return !1;
  }
}, TRe = function(t) {
  if (!IU(t))
    return !1;
  var r = t;
  return !!(r.attributes.getNamedItem("src") && r.attributes.getNamedItem("src").value);
}, CRe = function(t, r) {
  if (!kk(t))
    return r;
  var n = t, a = n.style.fontWeight, s = n.style.fontStyle, i = n.style.textDecoration;
  return r.withMutations(function(o) {
    vRe.indexOf(a) >= 0 ? o.add("BOLD") : yRe.indexOf(a) >= 0 && o.remove("BOLD"), s === "italic" ? o.add("ITALIC") : s === "normal" && o.remove("ITALIC"), i === "underline" && o.add("UNDERLINE"), i === "line-through" && o.add("STRIKETHROUGH"), i === "none" && (o.remove("UNDERLINE"), o.remove("STRIKETHROUGH"));
  });
}, N_ = function(t) {
  return t === "ul" || t === "ol";
}, kRe = /* @__PURE__ */ function() {
  function e(r, n) {
    Ca(this, "characterList", rc()), Ca(this, "currentBlockType", "unstyled"), Ca(this, "currentDepth", 0), Ca(this, "currentEntity", null), Ca(this, "currentText", ""), Ca(this, "wrapper", null), Ca(this, "blockConfigs", []), Ca(this, "contentBlocks", []), Ca(this, "entityMap", sN), Ca(this, "blockTypeMap", void 0), Ca(this, "disambiguate", void 0), this.clear(), this.blockTypeMap = r, this.disambiguate = n;
  }
  var t = e.prototype;
  return t.clear = function() {
    this.characterList = rc(), this.blockConfigs = [], this.currentBlockType = "unstyled", this.currentDepth = 0, this.currentEntity = null, this.currentText = "", this.entityMap = sN, this.wrapper = null, this.contentBlocks = [];
  }, t.addDOMNode = function(n) {
    var a;
    return this.contentBlocks = [], this.currentDepth = 0, (a = this.blockConfigs).push.apply(a, this._toBlockConfigs([n], lRe())), this._trimCurrentText(), this.currentText !== "" && this.blockConfigs.push(this._makeBlockConfig()), this;
  }, t.getContentBlocks = function() {
    return this.contentBlocks.length === 0 && (oN ? this._toContentBlocks(this.blockConfigs) : this._toFlatContentBlocks(this.blockConfigs)), {
      contentBlocks: this.contentBlocks,
      entityMap: this.entityMap
    };
  }, t._makeBlockConfig = function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = n.key || iN(), s = D_({
      key: a,
      type: this.currentBlockType,
      text: this.currentText,
      characterList: this.characterList,
      depth: this.currentDepth,
      parent: null,
      children: rc(),
      prevSibling: null,
      nextSibling: null,
      childConfigs: []
    }, n);
    return this.characterList = rc(), this.currentBlockType = "unstyled", this.currentText = "", s;
  }, t._toBlockConfigs = function(n, a) {
    for (var s = [], i = 0; i < n.length; i++) {
      var o = n[i], l = o.nodeName.toLowerCase();
      if (l === "body" || N_(l)) {
        this._trimCurrentText(), this.currentText !== "" && s.push(this._makeBlockConfig());
        var c = this.currentDepth, u = this.wrapper;
        N_(l) && (this.wrapper = l, N_(u) && this.currentDepth++), s.push.apply(s, this._toBlockConfigs(Array.from(o.childNodes), a)), this.currentDepth = c, this.wrapper = u;
        continue;
      }
      var d = this.blockTypeMap.get(l);
      if (d !== void 0) {
        this._trimCurrentText(), this.currentText !== "" && s.push(this._makeBlockConfig());
        var f = this.currentDepth, h = this.wrapper;
        if (this.wrapper = l === "pre" ? "pre" : this.wrapper, typeof d != "string" && (d = this.disambiguate(l, this.wrapper) || d[0] || "unstyled"), !oN && kk(o) && (d === "unordered-list-item" || d === "ordered-list-item")) {
          var p = o;
          this.currentDepth = SRe(p, this.currentDepth);
        }
        var m = iN(), g = this._toBlockConfigs(Array.from(o.childNodes), a);
        this._trimCurrentText(), s.push(this._makeBlockConfig({
          key: m,
          childConfigs: g,
          type: d
        })), this.currentDepth = f, this.wrapper = h;
        continue;
      }
      if (l === "#text") {
        this._addTextNode(o, a);
        continue;
      }
      if (l === "br") {
        this._addBreakNode(o, a);
        continue;
      }
      if (TRe(o)) {
        this._addImgNode(o, a);
        continue;
      }
      if (ERe(o)) {
        this._addAnchorNode(o, s, a);
        continue;
      }
      var y = a;
      cN.has(l) && (y = y.add(cN.get(l))), y = CRe(o, y);
      var x = _Re(o);
      x != null && (y = y.add(x)), s.push.apply(s, this._toBlockConfigs(Array.from(o.childNodes), y));
    }
    return s;
  }, t._appendText = function(n, a) {
    var s;
    this.currentText += n;
    var i = nRe.create({
      style: a,
      entity: this.currentEntity
    });
    this.characterList = (s = this.characterList).push.apply(s, Array(n.length).fill(i));
  }, t._trimCurrentText = function() {
    var n = this.currentText.length, a = n - this.currentText.trimLeft().length, s = this.currentText.trimRight().length, i = this.characterList.findEntry(function(o) {
      return o.getEntity() !== null;
    });
    a = i !== void 0 ? Math.min(a, i[0]) : a, i = this.characterList.reverse().findEntry(function(o) {
      return o.getEntity() !== null;
    }), s = i !== void 0 ? Math.max(s, n - i[0]) : s, a > s ? (this.currentText = "", this.characterList = rc()) : (this.currentText = this.currentText.slice(a, s), this.characterList = this.characterList.slice(a, s));
  }, t._addTextNode = function(n, a) {
    var s = n.textContent, i = s.trim();
    i === "" && this.wrapper !== "pre" && (s = " "), this.wrapper !== "pre" && (s = s.replace(hRe, ""), s = s.replace(fRe, DU)), this._appendText(s, a);
  }, t._addBreakNode = function(n, a) {
    cRe(n) && this._appendText(`
`, a);
  }, t._addImgNode = function(n, a) {
    if (IU(n)) {
      var s = n, i = {};
      wRe.forEach(function(o) {
        var l = s.getAttribute(o);
        l && (i[o] = l);
      }), this.currentEntity = this.entityMap.__create("IMAGE", "IMMUTABLE", i), AU("draftjs_fix_paste_for_img") ? s.getAttribute("role") !== "presentation" && this._appendText("📷", a) : this._appendText("📷", a), this.currentEntity = null;
    }
  }, t._addAnchorNode = function(n, a, s) {
    if (RU(n)) {
      var i = n, o = {};
      bRe.forEach(function(l) {
        var c = i.getAttribute(l);
        c && (o[l] = c);
      }), o.url = new OU(i.href).toString(), this.currentEntity = this.entityMap.__create("LINK", "MUTABLE", o || {}), a.push.apply(a, this._toBlockConfigs(Array.from(n.childNodes), s)), this.currentEntity = null;
    }
  }, t._toContentBlocks = function(n) {
    for (var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, s = n.length - 1, i = 0; i <= s; i++) {
      var o = n[i];
      o.parent = a, o.prevSibling = i > 0 ? n[i - 1].key : null, o.nextSibling = i < s ? n[i + 1].key : null, o.children = rc(o.childConfigs.map(function(l) {
        return l.key;
      })), this.contentBlocks.push(new sRe(D_({}, o))), this._toContentBlocks(o.childConfigs, o.key);
    }
  }, t._hoistContainersInBlockConfigs = function(n) {
    var a = this, s = rc(n).flatMap(function(i) {
      return i.type !== "unstyled" || i.text !== "" ? [i] : a._hoistContainersInBlockConfigs(i.childConfigs);
    });
    return s;
  }, t._toFlatContentBlocks = function(n) {
    var a = this, s = this._hoistContainersInBlockConfigs(n);
    s.forEach(function(i) {
      var o = a._extractTextFromBlockConfigs(i.childConfigs), l = o.text, c = o.characterList;
      a.contentBlocks.push(new aRe(D_({}, i, {
        text: i.text + l,
        characterList: i.characterList.concat(c)
      })));
    });
  }, t._extractTextFromBlockConfigs = function(n) {
    for (var a = n.length - 1, s = "", i = rc(), o = 0; o <= a; o++) {
      var l = n[o];
      s += l.text, i = i.concat(l.characterList), s !== "" && l.type !== "unstyled" && (s += `
`, i = i.push(i.last()));
      var c = this._extractTextFromBlockConfigs(l.childConfigs);
      s += c.text, i = i.concat(c.characterList);
    }
    return {
      text: s,
      characterList: i
    };
  }, e;
}(), ORe = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : oRe, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : iRe;
  t = t.trim().replace(dRe, "").replace(pRe, DU).replace(mRe, "").replace(gRe, "");
  var a = r(t);
  if (!a)
    return null;
  var s = xRe(n), i = function(l, c) {
    return l === "li" ? c === "ol" ? "ordered-list-item" : "unordered-list-item" : null;
  };
  return new kRe(s, i).addDOMNode(a).getContentBlocks();
}, NU = ORe;
function ARe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    }))), n.forEach(function(a) {
      PRe(e, a, r[a]);
    });
  }
  return e;
}
function PRe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var RRe = cd, IRe = vi, DRe = NU, NRe = Wo, MRe = kU, LRe = Gc, MU = Tr, jRe = p6, FRe = MU.List, BRe = MU.Repeat, LU = LRe("draft_tree_data_support"), URe = LU ? IRe : RRe, VRe = {
  processHTML: function(t, r) {
    return DRe(t, MRe, r);
  },
  processText: function(t, r, n) {
    return t.reduce(function(a, s, i) {
      s = jRe(s);
      var o = NRe(), l = {
        key: o,
        type: n,
        text: s,
        characterList: FRe(BRe(r, s.length))
      };
      if (LU && i !== 0) {
        var c = i - 1, u = a[c] = a[c].merge({
          nextSibling: o
        });
        l = ARe({}, l, {
          prevSibling: u.getKey()
        });
      }
      return a.push(new URe(l)), a;
    }, []);
  }
}, $Re = VRe;
function HRe(e, t, r, n) {
  var a = t.getStartKey(), s = t.getEndKey(), i = e.getBlockMap(), o = i.toSeq().skipUntil(function(l, c) {
    return c === a;
  }).takeUntil(function(l, c) {
    return c === s;
  }).concat([[s, i.get(s)]]).map(function(l) {
    var c = l.getDepth() + r;
    return c = Math.max(0, Math.min(c, n)), l.set("depth", c);
  });
  return i = i.merge(o), e.merge({
    blockMap: i,
    selectionBefore: t,
    selectionAfter: t
  });
}
var WRe = HRe, nu = Cs, no = ln, zRe = WRe, KRe = ks, lo = {
  currentBlockContainsLink: function(t) {
    var r = t.getSelection(), n = t.getCurrentContent(), a = n.getEntityMap();
    return n.getBlockForKey(r.getAnchorKey()).getCharacterList().slice(r.getStartOffset(), r.getEndOffset()).some(function(s) {
      var i = s.getEntity();
      return !!i && a.__get(i).getType() === "LINK";
    });
  },
  getCurrentBlockType: function(t) {
    var r = t.getSelection();
    return t.getCurrentContent().getBlockForKey(r.getStartKey()).getType();
  },
  getDataObjectForLinkURL: function(t) {
    return {
      url: t.toString()
    };
  },
  handleKeyCommand: function(t, r, n) {
    switch (r) {
      case "bold":
        return lo.toggleInlineStyle(t, "BOLD");
      case "italic":
        return lo.toggleInlineStyle(t, "ITALIC");
      case "underline":
        return lo.toggleInlineStyle(t, "UNDERLINE");
      case "code":
        return lo.toggleCode(t);
      case "backspace":
      case "backspace-word":
      case "backspace-to-start-of-line":
        return lo.onBackspace(t);
      case "delete":
      case "delete-word":
      case "delete-to-end-of-block":
        return lo.onDelete(t);
      default:
        return null;
    }
  },
  insertSoftNewline: function(t) {
    var r = nu.insertText(t.getCurrentContent(), t.getSelection(), `
`, t.getCurrentInlineStyle(), null), n = no.push(t, r, "insert-characters");
    return no.forceSelection(n, r.getSelectionAfter());
  },
  /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
  onBackspace: function(t) {
    var r = t.getSelection();
    if (!r.isCollapsed() || r.getAnchorOffset() || r.getFocusOffset())
      return null;
    var n = t.getCurrentContent(), a = r.getStartKey(), s = n.getBlockBefore(a);
    if (s && s.getType() === "atomic") {
      var i = n.getBlockMap().delete(s.getKey()), o = n.merge({
        blockMap: i,
        selectionAfter: r
      });
      if (o !== n)
        return no.push(t, o, "remove-range");
    }
    var l = lo.tryToRemoveBlockStyle(t);
    return l ? no.push(t, l, "change-block-type") : null;
  },
  onDelete: function(t) {
    var r = t.getSelection();
    if (!r.isCollapsed())
      return null;
    var n = t.getCurrentContent(), a = r.getStartKey(), s = n.getBlockForKey(a), i = s.getLength();
    if (r.getStartOffset() < i)
      return null;
    var o = n.getBlockAfter(a);
    if (!o || o.getType() !== "atomic")
      return null;
    var l = r.merge({
      focusKey: o.getKey(),
      focusOffset: o.getLength()
    }), c = nu.removeRange(n, l, "forward");
    return c !== n ? no.push(t, c, "remove-range") : null;
  },
  onTab: function(t, r, n) {
    var a = r.getSelection(), s = a.getAnchorKey();
    if (s !== a.getFocusKey())
      return r;
    var i = r.getCurrentContent(), o = i.getBlockForKey(s), l = o.getType();
    if (l !== "unordered-list-item" && l !== "ordered-list-item")
      return r;
    t.preventDefault();
    var c = o.getDepth();
    if (!t.shiftKey && c === n)
      return r;
    var u = zRe(i, a, t.shiftKey ? -1 : 1, n);
    return no.push(r, u, "adjust-depth");
  },
  toggleBlockType: function(t, r) {
    var n = t.getSelection(), a = n.getStartKey(), s = n.getEndKey(), i = t.getCurrentContent(), o = n;
    if (a !== s && n.getEndOffset() === 0) {
      var l = KRe(i.getBlockBefore(s));
      s = l.getKey(), o = o.merge({
        anchorKey: a,
        anchorOffset: n.getStartOffset(),
        focusKey: s,
        focusOffset: l.getLength(),
        isBackward: !1
      });
    }
    var c = i.getBlockMap().skipWhile(function(d, f) {
      return f !== a;
    }).reverse().skipWhile(function(d, f) {
      return f !== s;
    }).some(function(d) {
      return d.getType() === "atomic";
    });
    if (c)
      return t;
    var u = i.getBlockForKey(a).getType() === r ? "unstyled" : r;
    return no.push(t, nu.setBlockType(i, o, u), "change-block-type");
  },
  toggleCode: function(t) {
    var r = t.getSelection(), n = r.getAnchorKey(), a = r.getFocusKey();
    return r.isCollapsed() || n !== a ? lo.toggleBlockType(t, "code-block") : lo.toggleInlineStyle(t, "CODE");
  },
  /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
  toggleInlineStyle: function(t, r) {
    var n = t.getSelection(), a = t.getCurrentInlineStyle();
    if (n.isCollapsed())
      return no.setInlineStyleOverride(t, a.has(r) ? a.remove(r) : a.add(r));
    var s = t.getCurrentContent(), i;
    return a.has(r) ? i = nu.removeInlineStyle(s, n, r) : i = nu.applyInlineStyle(s, n, r), no.push(t, i, "change-inline-style");
  },
  toggleLink: function(t, r, n) {
    var a = nu.applyEntity(t.getCurrentContent(), r, n);
    return no.push(t, a, "apply-entity");
  },
  /**
   * When a collapsed cursor is at the start of a styled block, changes block
   * type to 'unstyled'. Returns null if selection does not meet that criteria.
   */
  tryToRemoveBlockStyle: function(t) {
    var r = t.getSelection(), n = r.getAnchorOffset();
    if (r.isCollapsed() && n === 0) {
      var a = r.getAnchorKey(), s = t.getCurrentContent(), i = s.getBlockForKey(a), o = i.getType(), l = s.getBlockBefore(a);
      if (o === "code-block" && l && l.getType() === "code-block" && l.getLength() !== 0)
        return null;
      if (o !== "unstyled")
        return nu.setBlockType(s, r, "unstyled");
    }
    return null;
  }
}, jU = lo, qRe = /\r\n?|\n/g;
function GRe(e) {
  return e.split(qRe);
}
var YRe = GRe, M_ = Fg, uN = gi, XRe = dU, FU = Cs, L_ = $Re, BU = ln, dN = jU, fN = vk, QRe = fU, hN = mx, pN = YRe;
function JRe(e, t) {
  t.preventDefault();
  var r = new XRe(t.clipboardData);
  if (!r.isRichText()) {
    var n = r.getFiles(), a = r.getText();
    if (n.length > 0) {
      if (e.props.handlePastedFiles && hN(e.props.handlePastedFiles(n)))
        return;
      QRe(n, function(C) {
        if (C = C || a, !!C) {
          var E = e._latestEditorState, O = pN(C), k = uN.create({
            style: E.getCurrentInlineStyle(),
            entity: fN(E.getCurrentContent(), E.getSelection())
          }), A = dN.getCurrentBlockType(E), P = L_.processText(O, k, A), D = M_.createFromArray(P), N = FU.replaceWithFragment(E.getCurrentContent(), E.getSelection(), D);
          e.update(BU.push(E, N, "insert-fragment"));
        }
      });
      return;
    }
  }
  var s = [], i = r.getText(), o = r.getHTML(), l = e._latestEditorState;
  if (e.props.formatPastedText) {
    var c = e.props.formatPastedText(i, o), u = c.text, d = c.html;
    i = u, o = d;
  }
  if (!(e.props.handlePastedText && hN(e.props.handlePastedText(i, o, l)))) {
    if (i && (s = pN(i)), !e.props.stripPastedStyles) {
      var f = e.getClipboard();
      if (!e.props.formatPastedText && r.isRichText() && f) {
        var h;
        if (
          // If the editorKey is present in the pasted HTML, it should be safe to
          // assume this is an internal paste.
          ((h = o) === null || h === void 0 ? void 0 : h.indexOf(e.getEditorKey())) !== -1 || // The copy may have been made within a single block, in which case the
          // editor key won't be part of the paste. In this case, just check
          // whether the pasted text matches the internal clipboard.
          s.length === 1 && f.size === 1 && f.first().getText() === i
        ) {
          e.update(x0(e._latestEditorState, f));
          return;
        }
      } else if (f && r.types.includes("com.apple.webarchive") && !r.types.includes("text/html") && ZRe(s, f)) {
        e.update(x0(e._latestEditorState, f));
        return;
      }
      if (o) {
        var p = L_.processHTML(o, e.props.blockRenderMap);
        if (p) {
          var m = p.contentBlocks, g = p.entityMap;
          if (m) {
            var y = M_.createFromArray(m);
            e.update(x0(e._latestEditorState, y, g));
            return;
          }
        }
      }
      e.setClipboard(null);
    }
    if (s.length) {
      var x = uN.create({
        style: l.getCurrentInlineStyle(),
        entity: fN(l.getCurrentContent(), l.getSelection())
      }), w = dN.getCurrentBlockType(l), _ = L_.processText(s, x, w), S = M_.createFromArray(_);
      e.update(x0(e._latestEditorState, S));
    }
  }
}
function x0(e, t, r) {
  var n = FU.replaceWithFragment(e.getCurrentContent(), e.getSelection(), t);
  return BU.push(e, n.set("entityMap", r), "insert-fragment");
}
function ZRe(e, t) {
  return e.length === t.size && t.valueSeq().every(function(r, n) {
    return r.getText() === e[n];
  });
}
var eIe = JRe, UU = Os, tIe = X2e, rIe = eOe, nIe = nOe, aIe = lOe, sIe = bOe, iIe = xOe, oIe = SOe, lIe = COe, cIe = uAe, uIe = HPe, dIe = eIe, VU = H6, fIe = UU.isBrowser("Chrome"), hIe = UU.isBrowser("Firefox"), mN = fIe || hIe ? VU : function(e) {
}, pIe = {
  onBeforeInput: tIe,
  onBlur: rIe,
  onCompositionStart: nIe,
  onCopy: aIe,
  onCut: sIe,
  onDragOver: iIe,
  onDragStart: oIe,
  onFocus: lIe,
  onInput: cIe,
  onKeyDown: uIe,
  onPaste: dIe,
  onSelect: VU,
  // In certain cases, contenteditable on chrome does not fire the onSelect
  // event, causing problems with cursor positioning. Therefore, the selection
  // state update handler is added to more events to ensure that the selection
  // state is always synced with the actual cursor positions.
  onMouseUp: mN,
  onKeyUp: mN
}, mIe = pIe, gIe = OT, vIe = gIe.unstable_flushControlled, yIe = vIe;
function bIe(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
var j_ = M, gN = ud, wIe = /* @__PURE__ */ function(e) {
  bIe(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var r = t.prototype;
  return r.shouldComponentUpdate = function(a) {
    return this.props.text !== a.text || this.props.editorState.getSelection().getHasFocus() !== a.editorState.getSelection().getHasFocus();
  }, r.render = function() {
    var a = this.props.editorState.getSelection().getHasFocus(), s = gN({
      "public/DraftEditorPlaceholder/root": !0,
      "public/DraftEditorPlaceholder/hasFocus": a
    }), i = {
      whiteSpace: "pre-wrap"
    };
    return j_.createElement("div", {
      className: s
    }, j_.createElement("div", {
      className: gN("public/DraftEditorPlaceholder/inner"),
      id: this.props.accessibilityID,
      style: i
    }, this.props.text));
  }, t;
}(j_.Component), xIe = wIe, $U = Tk, Ep = dx, HU = Os, vc = HU.isPlatform("Mac OS X"), vN = vc && HU.isBrowser("Firefox < 29"), uc = $U.hasCommandModifier, pl = $U.isCtrlKeyCommand;
function WU(e) {
  return vc && e.altKey || pl(e);
}
function _Ie(e) {
  return uc(e) ? e.shiftKey ? "redo" : "undo" : null;
}
function SIe(e) {
  return !vc && e.shiftKey ? null : WU(e) ? "delete-word" : "delete";
}
function EIe(e) {
  return uc(e) && vc ? "backspace-to-start-of-line" : WU(e) ? "backspace-word" : "backspace";
}
function TIe(e) {
  switch (e.keyCode) {
    case 66:
      return uc(e) ? "bold" : null;
    case 68:
      return pl(e) ? "delete" : null;
    case 72:
      return pl(e) ? "backspace" : null;
    case 73:
      return uc(e) ? "italic" : null;
    case 74:
      return uc(e) ? "code" : null;
    case 75:
      return vc && pl(e) ? "secondary-cut" : null;
    case 77:
      return pl(e) ? "split-block" : null;
    case 79:
      return pl(e) ? "split-block" : null;
    case 84:
      return vc && pl(e) ? "transpose-characters" : null;
    case 85:
      return uc(e) ? "underline" : null;
    case 87:
      return vc && pl(e) ? "backspace-word" : null;
    case 89:
      return pl(e) ? vc ? "secondary-paste" : "redo" : null;
    case 90:
      return _Ie(e) || null;
    case Ep.RETURN:
      return "split-block";
    case Ep.DELETE:
      return SIe(e);
    case Ep.BACKSPACE:
      return EIe(e);
    case Ep.LEFT:
      return vN && uc(e) ? "move-selection-to-start-of-block" : null;
    case Ep.RIGHT:
      return vN && uc(e) ? "move-selection-to-end-of-block" : null;
    default:
      return null;
  }
}
var zU = TIe, F_ = {}, CIe = Kc;
function QE() {
  return QE = CIe || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, QE.apply(this, arguments);
}
function B_(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    }))), n.forEach(function(a) {
      Ut(e, a, r[a]);
    });
  }
  return e;
}
function Vt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ut(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function KU(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
var kIe = mk, OIe = A6, AIe = LCe, PIe = o2e, RIe = L2e, IIe = mIe, yN = yIe, DIe = xIe, NIe = q6, MIe = ln, oc = M, LIe = xk, jIe = fx, FIe = Os, U_ = ud, BIe = Wo, UIe = zU, VIe = hx, $Ie = Gc, _0 = jr, bN = zg, HIe = ks, qU = FIe.isBrowser("IE"), WIe = !qU, wN = {
  edit: IIe,
  composite: AIe,
  drag: RIe,
  cut: null,
  render: null
}, xN = !1, zIe = /* @__PURE__ */ function(e) {
  KU(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var r = t.prototype;
  return r.render = function() {
    return null;
  }, r.componentDidMount = function() {
    this._update();
  }, r.componentDidUpdate = function() {
    this._update();
  }, r._update = function() {
    var a = this.props.editor;
    a._latestEditorState = this.props.editorState, a._blockSelectEvents = !0;
  }, t;
}(oc.Component), GU = /* @__PURE__ */ function(e) {
  KU(t, e);
  function t(n) {
    var a;
    return a = e.call(this, n) || this, Ut(Vt(a), "_blockSelectEvents", void 0), Ut(Vt(a), "_clipboard", void 0), Ut(Vt(a), "_handler", void 0), Ut(Vt(a), "_dragCount", void 0), Ut(Vt(a), "_internalDrag", void 0), Ut(Vt(a), "_editorKey", void 0), Ut(Vt(a), "_placeholderAccessibilityID", void 0), Ut(Vt(a), "_latestEditorState", void 0), Ut(Vt(a), "_latestCommittedEditorState", void 0), Ut(Vt(a), "_pendingStateFromBeforeInput", void 0), Ut(Vt(a), "_onBeforeInput", void 0), Ut(Vt(a), "_onBlur", void 0), Ut(Vt(a), "_onCharacterData", void 0), Ut(Vt(a), "_onCompositionEnd", void 0), Ut(Vt(a), "_onCompositionStart", void 0), Ut(Vt(a), "_onCopy", void 0), Ut(Vt(a), "_onCut", void 0), Ut(Vt(a), "_onDragEnd", void 0), Ut(Vt(a), "_onDragOver", void 0), Ut(Vt(a), "_onDragStart", void 0), Ut(Vt(a), "_onDrop", void 0), Ut(Vt(a), "_onInput", void 0), Ut(Vt(a), "_onFocus", void 0), Ut(Vt(a), "_onKeyDown", void 0), Ut(Vt(a), "_onKeyPress", void 0), Ut(Vt(a), "_onKeyUp", void 0), Ut(Vt(a), "_onMouseDown", void 0), Ut(Vt(a), "_onMouseUp", void 0), Ut(Vt(a), "_onPaste", void 0), Ut(Vt(a), "_onSelect", void 0), Ut(Vt(a), "editor", void 0), Ut(Vt(a), "editorContainer", void 0), Ut(Vt(a), "focus", void 0), Ut(Vt(a), "blur", void 0), Ut(Vt(a), "setMode", void 0), Ut(Vt(a), "exitCurrentMode", void 0), Ut(Vt(a), "restoreEditorDOM", void 0), Ut(Vt(a), "setClipboard", void 0), Ut(Vt(a), "getClipboard", void 0), Ut(Vt(a), "getEditorKey", void 0), Ut(Vt(a), "update", void 0), Ut(Vt(a), "onDragEnter", void 0), Ut(Vt(a), "onDragLeave", void 0), Ut(Vt(a), "_handleEditorContainerRef", function(s) {
      a.editorContainer = s, a.editor = s !== null ? s.firstChild : null;
    }), Ut(Vt(a), "focus", function(s) {
      var i = a.props.editorState, o = i.getSelection().getHasFocus(), l = a.editor;
      if (l) {
        var c = jIe.getScrollParent(l), u = s || VIe(c), d = u.x, f = u.y;
        bN(l) || (F_.NODE_ENV !== "production" ? _0(!1, "editorNode is not an HTMLElement") : _0(!1)), l.focus(), c === window ? window.scrollTo(d, f) : LIe.setTop(c, f), o || a.update(MIe.forceSelection(i, i.getSelection()));
      }
    }), Ut(Vt(a), "blur", function() {
      var s = a.editor;
      s && (bN(s) || (F_.NODE_ENV !== "production" ? _0(!1, "editorNode is not an HTMLElement") : _0(!1)), s.blur());
    }), Ut(Vt(a), "setMode", function(s) {
      var i = a.props, o = i.onPaste, l = i.onCut, c = i.onCopy, u = B_({}, wN.edit);
      o && (u.onPaste = o), l && (u.onCut = l), c && (u.onCopy = c);
      var d = B_({}, wN, {
        edit: u
      });
      a._handler = d[s];
    }), Ut(Vt(a), "exitCurrentMode", function() {
      a.setMode("edit");
    }), Ut(Vt(a), "restoreEditorDOM", function(s) {
      a.setState({
        contentsKey: a.state.contentsKey + 1
      }, function() {
        a.focus(s);
      });
    }), Ut(Vt(a), "setClipboard", function(s) {
      a._clipboard = s;
    }), Ut(Vt(a), "getClipboard", function() {
      return a._clipboard;
    }), Ut(Vt(a), "update", function(s) {
      a._latestEditorState = s, a.props.onChange(s);
    }), Ut(Vt(a), "onDragEnter", function() {
      a._dragCount++;
    }), Ut(Vt(a), "onDragLeave", function() {
      a._dragCount--, a._dragCount === 0 && a.exitCurrentMode();
    }), a._blockSelectEvents = !1, a._clipboard = null, a._handler = null, a._dragCount = 0, a._editorKey = n.editorKey || BIe(), a._placeholderAccessibilityID = "placeholder-" + a._editorKey, a._latestEditorState = n.editorState, a._latestCommittedEditorState = n.editorState, a._onBeforeInput = a._buildHandler("onBeforeInput"), a._onBlur = a._buildHandler("onBlur"), a._onCharacterData = a._buildHandler("onCharacterData"), a._onCompositionEnd = a._buildHandler("onCompositionEnd"), a._onCompositionStart = a._buildHandler("onCompositionStart"), a._onCopy = a._buildHandler("onCopy"), a._onCut = a._buildHandler("onCut"), a._onDragEnd = a._buildHandler("onDragEnd"), a._onDragOver = a._buildHandler("onDragOver"), a._onDragStart = a._buildHandler("onDragStart"), a._onDrop = a._buildHandler("onDrop"), a._onInput = a._buildHandler("onInput"), a._onFocus = a._buildHandler("onFocus"), a._onKeyDown = a._buildHandler("onKeyDown"), a._onKeyPress = a._buildHandler("onKeyPress"), a._onKeyUp = a._buildHandler("onKeyUp"), a._onMouseDown = a._buildHandler("onMouseDown"), a._onMouseUp = a._buildHandler("onMouseUp"), a._onPaste = a._buildHandler("onPaste"), a._onSelect = a._buildHandler("onSelect"), a.getEditorKey = function() {
      return a._editorKey;
    }, F_.NODE_ENV !== "production" && ["onDownArrow", "onEscape", "onLeftArrow", "onRightArrow", "onTab", "onUpArrow"].forEach(function(s) {
      n.hasOwnProperty(s) && console.warn("Supplying an `".concat(s, "` prop to `DraftEditor` has ") + "been deprecated. If your handler needs access to the keyboard event, supply a custom `keyBindingFn` prop that falls back to the default one (eg. https://is.gd/wHKQ3W).");
    }), a.state = {
      contentsKey: 0
    }, a;
  }
  var r = t.prototype;
  return r._buildHandler = function(a) {
    var s = this;
    return function(i) {
      if (!s.props.readOnly) {
        var o = s._handler && s._handler[a];
        o && (yN ? yN(function() {
          return o(s, i);
        }) : o(s, i));
      }
    };
  }, r._showPlaceholder = function() {
    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
  }, r._renderPlaceholder = function() {
    if (this._showPlaceholder()) {
      var a = {
        text: HIe(this.props.placeholder),
        editorState: this.props.editorState,
        textAlignment: this.props.textAlignment,
        accessibilityID: this._placeholderAccessibilityID
      };
      return oc.createElement(DIe, a);
    }
    return null;
  }, r._renderARIADescribedBy = function() {
    var a = this.props.ariaDescribedBy || "", s = this._showPlaceholder() ? this._placeholderAccessibilityID : "";
    return a.replace("{{editor_id_placeholder}}", s) || void 0;
  }, r.render = function() {
    var a = this.props, s = a.blockRenderMap, i = a.blockRendererFn, o = a.blockStyleFn, l = a.customStyleFn, c = a.customStyleMap, u = a.editorState, d = a.preventScroll, f = a.readOnly, h = a.textAlignment, p = a.textDirectionality, m = U_({
      "DraftEditor/root": !0,
      "DraftEditor/alignLeft": h === "left",
      "DraftEditor/alignRight": h === "right",
      "DraftEditor/alignCenter": h === "center"
    }), g = {
      outline: "none",
      // fix parent-draggable Safari bug. #1326
      userSelect: "text",
      WebkitUserSelect: "text",
      whiteSpace: "pre-wrap",
      wordWrap: "break-word"
    }, y = this.props.role || "textbox", x = y === "combobox" ? !!this.props.ariaExpanded : null, w = {
      blockRenderMap: s,
      blockRendererFn: i,
      blockStyleFn: o,
      customStyleMap: B_({}, OIe, c),
      customStyleFn: l,
      editorKey: this._editorKey,
      editorState: u,
      preventScroll: d,
      textDirectionality: p
    };
    return oc.createElement("div", {
      className: m
    }, this._renderPlaceholder(), oc.createElement("div", {
      className: U_("DraftEditor/editorContainer"),
      ref: this._handleEditorContainerRef
    }, oc.createElement("div", {
      "aria-activedescendant": f ? null : this.props.ariaActiveDescendantID,
      "aria-autocomplete": f ? null : this.props.ariaAutoComplete,
      "aria-controls": f ? null : this.props.ariaControls,
      "aria-describedby": this._renderARIADescribedBy(),
      "aria-expanded": f ? null : x,
      "aria-label": this.props.ariaLabel,
      "aria-labelledby": this.props.ariaLabelledBy,
      "aria-multiline": this.props.ariaMultiline,
      "aria-owns": f ? null : this.props.ariaOwneeID,
      autoCapitalize: this.props.autoCapitalize,
      autoComplete: this.props.autoComplete,
      autoCorrect: this.props.autoCorrect,
      className: U_({
        // Chrome's built-in translation feature mutates the DOM in ways
        // that Draft doesn't expect (ex: adding <font> tags inside
        // DraftEditorLeaf spans) and causes problems. We add notranslate
        // here which makes its autotranslation skip over this subtree.
        notranslate: !f,
        "public/DraftEditor/content": !0
      }),
      contentEditable: !f,
      "data-testid": this.props.webDriverTestID,
      onBeforeInput: this._onBeforeInput,
      onBlur: this._onBlur,
      onCompositionEnd: this._onCompositionEnd,
      onCompositionStart: this._onCompositionStart,
      onCopy: this._onCopy,
      onCut: this._onCut,
      onDragEnd: this._onDragEnd,
      onDragEnter: this.onDragEnter,
      onDragLeave: this.onDragLeave,
      onDragOver: this._onDragOver,
      onDragStart: this._onDragStart,
      onDrop: this._onDrop,
      onFocus: this._onFocus,
      onInput: this._onInput,
      onKeyDown: this._onKeyDown,
      onKeyPress: this._onKeyPress,
      onKeyUp: this._onKeyUp,
      onMouseUp: this._onMouseUp,
      onPaste: this._onPaste,
      onSelect: this._onSelect,
      ref: this.props.editorRef,
      role: f ? null : y,
      spellCheck: WIe && this.props.spellCheck,
      style: g,
      suppressContentEditableWarning: !0,
      tabIndex: this.props.tabIndex
    }, oc.createElement(zIe, {
      editor: this,
      editorState: u
    }), oc.createElement(PIe, QE({}, w, {
      key: "contents" + this.state.contentsKey
    })))));
  }, r.componentDidMount = function() {
    this._blockSelectEvents = !1, !xN && $Ie("draft_ods_enabled") && (xN = !0, NIe.initODS()), this.setMode("edit"), qU && (this.editor ? this.editor.ownerDocument.execCommand("AutoUrlDetect", !1, !1) : window.execCommand("AutoUrlDetect", !1, !1));
  }, r.componentDidUpdate = function() {
    this._blockSelectEvents = !1, this._latestEditorState = this.props.editorState, this._latestCommittedEditorState = this.props.editorState;
  }, t;
}(oc.Component);
Ut(GU, "defaultProps", {
  ariaDescribedBy: "{{editor_id_placeholder}}",
  blockRenderMap: kIe,
  blockRendererFn: function() {
    return null;
  },
  blockStyleFn: function() {
    return "";
  },
  keyBindingFn: UIe,
  readOnly: !1,
  spellCheck: !1,
  stripPastedStyles: !1
});
var KIe = GU, qIe = {}, GIe = {
  stringify: function(t) {
    return "_" + String(t);
  },
  unstringify: function(t) {
    return t.slice(1);
  }
}, YU = GIe, YIe = YU, XIe = hd, _N = XIe.strlen;
function QIe(e, t) {
  var r = [];
  return e.findEntityRanges(function(n) {
    return !!n.getEntity();
  }, function(n, a) {
    var s = e.getText(), i = e.getEntityAt(n);
    r.push({
      offset: _N(s.slice(0, n)),
      length: _N(s.slice(n, a)),
      // Encode the key as a number for range storage.
      key: Number(t[YIe.stringify(i)])
    });
  }), r;
}
var JIe = QIe, SN = hd, ZIe = Bg, eDe = function(t, r) {
  return t === r;
}, tDe = function(t) {
  return !!t;
}, rDe = [];
function nDe(e, t, r) {
  var n = [], a = t.map(function(s) {
    return s.has(r);
  }).toList();
  return ZIe(
    a,
    eDe,
    // We only want to keep ranges with nonzero style values.
    tDe,
    function(s, i) {
      var o = e.getText();
      n.push({
        offset: SN.strlen(o.slice(0, s)),
        length: SN.strlen(o.slice(s, i)),
        style: r
      });
    }
  ), n;
}
function aDe(e) {
  var t = e.getCharacterList().map(function(n) {
    return n.getStyle();
  }).toList(), r = t.flatten().toSet().map(function(n) {
    return nDe(e, t, n);
  });
  return Array.prototype.concat.apply(rDe, r.toJS());
}
var sDe = aDe, iDe = {};
function oDe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    }))), n.forEach(function(a) {
      lDe(e, a, r[a]);
    });
  }
  return e;
}
function lDe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var cDe = cd, uDe = vi, XU = YU, dDe = JIe, fDe = sDe, EN = jr, TN = function(t, r) {
  return {
    key: t.getKey(),
    text: t.getText(),
    type: t.getType(),
    depth: t.getDepth(),
    inlineStyleRanges: fDe(t),
    entityRanges: dDe(t, r),
    data: t.getData().toObject()
  };
}, hDe = function(t, r, n, a) {
  if (t instanceof cDe) {
    n.push(TN(t, r));
    return;
  }
  t instanceof uDe || (iDe.NODE_ENV !== "production" ? EN(!1, "block is not a BlockNode") : EN(!1));
  var s = t.getParentKey(), i = a[t.getKey()] = oDe({}, TN(t, r), {
    children: []
  });
  if (s) {
    a[s].children.push(i);
    return;
  }
  n.push(i);
}, pDe = function(t, r) {
  var n = r.entityMap, a = [], s = {}, i = {}, o = 0;
  return t.getBlockMap().forEach(function(l) {
    l.findEntityRanges(function(c) {
      return c.getEntity() !== null;
    }, function(c) {
      var u = l.getEntityAt(c), d = XU.stringify(u);
      i[d] || (i[d] = u, n[d] = "".concat(o), o++);
    }), hDe(l, n, a, s);
  }), {
    blocks: a,
    entityMap: n
  };
}, mDe = function(t, r) {
  var n = r.blocks, a = r.entityMap, s = {};
  return Object.keys(a).forEach(function(i, o) {
    var l = t.getEntity(XU.unstringify(i));
    s[o] = {
      type: l.getType(),
      mutability: l.getMutability(),
      data: l.getData()
    };
  }), {
    blocks: n,
    entityMap: s
  };
}, gDe = function(t) {
  var r = {
    entityMap: {},
    blocks: []
  };
  return r = pDe(t, r), r = mDe(t, r), r;
}, vDe = gDe, QU = {};
function em(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    }))), n.forEach(function(a) {
      yDe(e, a, r[a]);
    });
  }
  return e;
}
function yDe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var bDe = Wo, Cb = jr, wDe = function(t, r) {
  for (var n = [].concat(t).reverse(); n.length; ) {
    var a = n.pop();
    r(a);
    var s = a.children;
    Array.isArray(s) || (QU.NODE_ENV !== "production" ? Cb(!1, "Invalid tree raw block") : Cb(!1)), n = n.concat([].concat(s.reverse()));
  }
}, CN = function(t) {
  if (!(t && t.type))
    return !1;
  var r = t.type;
  return r === "unordered-list-item" || r === "ordered-list-item";
}, xDe = function(t) {
  Array.isArray(t.children) && (t.children = t.children.map(function(r) {
    return r.type === t.type ? em({}, r, {
      depth: (t.depth || 0) + 1
    }) : r;
  }));
}, _De = {
  /**
   * Converts from a tree raw state back to draft raw state
   */
  fromRawTreeStateToRawState: function(t) {
    var r = t.blocks, n = [];
    return Array.isArray(r) || (QU.NODE_ENV !== "production" ? Cb(!1, "Invalid raw state") : Cb(!1)), !Array.isArray(r) || !r.length ? t : (wDe(r, function(a) {
      var s = em({}, a);
      CN(a) && (s.depth = s.depth || 0, xDe(a), a.children != null && a.children.length > 0) || (delete s.children, n.push(s));
    }), t.blocks = n, em({}, t, {
      blocks: n
    }));
  },
  /**
   * Converts from draft raw state to tree draft state
   */
  fromRawStateToRawTreeState: function(t) {
    var r = [], n = [];
    return t.blocks.forEach(function(a) {
      var s = CN(a), i = a.depth || 0, o = em({}, a, {
        children: []
      });
      if (!s) {
        r.push(o);
        return;
      }
      var l = n[0];
      if (l == null && i === 0)
        r.push(o);
      else if (l == null || l.depth < i - 1) {
        var c = {
          key: bDe(),
          text: "",
          depth: i - 1,
          type: a.type,
          children: [],
          entityRanges: [],
          inlineStyleRanges: []
        };
        n.unshift(c), i === 1 ? r.push(c) : l != null && l.children.push(c), c.children.push(o);
      } else if (l.depth === i - 1)
        l.children.push(o);
      else {
        for (; l != null && l.depth >= i; )
          n.shift(), l = n[0];
        i > 0 ? l.children.push(o) : r.push(o);
      }
    }), em({}, t, {
      blocks: r
    });
  }
}, SDe = _De, nl = {}, al = Sk, EDe = {
  /**
   * Check if the block is valid
   */
  isValidBlock: function(t, r) {
    var n = t.getKey(), a = t.getParentKey();
    if (a != null) {
      var s = r.get(a);
      if (!s.getChildKeys().includes(n))
        return nl.NODE_ENV !== "production" && al(!0, "Tree is missing parent -> child pointer on %s", n), !1;
    }
    var i = t.getChildKeys().map(function(d) {
      return r.get(d);
    });
    if (!i.every(function(d) {
      return d.getParentKey() === n;
    }))
      return nl.NODE_ENV !== "production" && al(!0, "Tree is missing child -> parent pointer on %s", n), !1;
    var o = t.getPrevSiblingKey();
    if (o != null) {
      var l = r.get(o);
      if (l.getNextSiblingKey() !== n)
        return nl.NODE_ENV !== "production" && al(!0, "Tree is missing nextSibling pointer on %s's prevSibling", n), !1;
    }
    var c = t.getNextSiblingKey();
    if (c != null) {
      var u = r.get(c);
      if (u.getPrevSiblingKey() !== n)
        return nl.NODE_ENV !== "production" && al(!0, "Tree is missing prevSibling pointer on %s's nextSibling", n), !1;
    }
    return c !== null && o !== null && o === c ? (nl.NODE_ENV !== "production" && al(!0, "Tree has a two-node cycle at %s", n), !1) : t.text != "" && t.getChildKeys().size > 0 ? (nl.NODE_ENV !== "production" && al(!0, "Leaf node %s has children", n), !1) : !0;
  },
  /**
   * Checks that this is a connected tree on all the blocks
   * starting from the first block, traversing nextSibling and child pointers
   * should be a tree (preorder traversal - parent, then children)
   * num of connected node === number of blocks
   */
  isConnectedTree: function(t) {
    var r = t.toArray().filter(function(f) {
      return f.getParentKey() == null && f.getPrevSiblingKey() == null;
    });
    if (r.length !== 1)
      return nl.NODE_ENV !== "production" && al(!0, "Tree is not connected. More or less than one first node"), !1;
    for (var n = r.shift(), a = 0, s = n.getKey(), i = []; s != null; ) {
      var o = t.get(s), l = o.getChildKeys(), c = o.getNextSiblingKey();
      if (l.size > 0) {
        c != null && i.unshift(c);
        var u = l.map(function(f) {
          return t.get(f);
        }), d = u.find(function(f) {
          return f.getPrevSiblingKey() == null;
        });
        if (d == null)
          return nl.NODE_ENV !== "production" && al(!0, "%s has no first child", s), !1;
        s = d.getKey();
      } else
        o.getNextSiblingKey() != null ? s = o.getNextSiblingKey() : s = i.shift();
      a++;
    }
    return a !== t.size ? (nl.NODE_ENV !== "production" && al(!0, "Tree is not connected. %s nodes were seen instead of %s", a, t.size), !1) : !0;
  },
  /**
   * Checks that the block map is a connected tree with valid blocks
   */
  isValidTree: function(t) {
    var r = this, n = t.toArray();
    return n.every(function(a) {
      return r.isValidBlock(a, t);
    }) ? this.isConnectedTree(t) : !1;
  }
}, TDe = EDe, CDe = gi, kDe = Tr, ODe = kDe.List;
function ADe(e, t) {
  var r = e.map(function(n, a) {
    var s = t[a];
    return CDe.create({
      style: n,
      entity: s
    });
  });
  return ODe(r);
}
var PDe = ADe, RDe = hd, kN = RDe.substr;
function IDe(e, t) {
  var r = Array(e.length).fill(null);
  return t && t.forEach(function(n) {
    for (var a = kN(e, 0, n.offset).length, s = a + kN(e, n.offset, n.length).length, i = a; i < s; i++)
      r[i] = n.key;
  }), r;
}
var DDe = IDe, NDe = hd, MDe = Tr, LDe = MDe.OrderedSet, ON = NDe.substr, jDe = LDe();
function FDe(e, t) {
  var r = Array(e.length).fill(jDe);
  return t && t.forEach(function(n) {
    for (var a = ON(e, 0, n.offset).length, s = a + ON(e, n.offset, n.length).length; a < s; )
      r[a] = r[a].add(n.style), a++;
  }), r;
}
var BDe = FDe, tg = {};
function rg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    }))), n.forEach(function(a) {
      UDe(e, a, r[a]);
    });
  }
  return e;
}
function UDe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var VDe = cd, AN = vi, $De = uk, HDe = ax, PN = SDe, WDe = TDe, RN = sx, zDe = PDe, KDe = DDe, qDe = BDe, JU = Wo, GDe = Gc, Ok = Tr, yc = jr, IN = GDe("draft_tree_data_support"), DN = Ok.List, YDe = Ok.Map, ZU = Ok.OrderedMap, JE = function(t, r) {
  var n = t.key, a = t.type, s = t.data, i = t.text, o = t.depth, l = {
    text: i,
    depth: o || 0,
    type: a || "unstyled",
    key: n || JU(),
    data: YDe(s),
    characterList: XDe(t, r)
  };
  return l;
}, XDe = function(t, r) {
  var n = t.text, a = t.entityRanges, s = t.inlineStyleRanges, i = a || [], o = s || [];
  return zDe(qDe(n, o), KDe(n, i.filter(function(l) {
    return r.hasOwnProperty(l.key);
  }).map(function(l) {
    return rg({}, l, {
      key: r[l.key]
    });
  })));
}, V_ = function(t) {
  return rg({}, t, {
    key: t.key || JU()
  });
}, NN = function(t, r, n) {
  var a = r.map(function(s) {
    return rg({}, s, {
      parentRef: n
    });
  });
  return t.concat(a.reverse());
}, QDe = function(t, r) {
  return t.map(V_).reduce(function(n, a, s) {
    Array.isArray(a.children) || (tg.NODE_ENV !== "production" ? yc(!1, "invalid RawDraftContentBlock can not be converted to ContentBlockNode") : yc(!1));
    var i = a.children.map(V_), o = new AN(rg({}, JE(a, r), {
      prevSibling: s === 0 ? null : t[s - 1].key,
      nextSibling: s === t.length - 1 ? null : t[s + 1].key,
      children: DN(i.map(function(g) {
        return g.key;
      }))
    }));
    n = n.set(o.getKey(), o);
    for (var l = NN([], i, o); l.length > 0; ) {
      var c = l.pop(), u = c.parentRef, d = u.getChildKeys(), f = d.indexOf(c.key), h = Array.isArray(c.children);
      if (!h) {
        h || (tg.NODE_ENV !== "production" ? yc(!1, "invalid RawDraftContentBlock can not be converted to ContentBlockNode") : yc(!1));
        break;
      }
      var p = c.children.map(V_), m = new AN(rg({}, JE(c, r), {
        parent: u.getKey(),
        children: DN(p.map(function(g) {
          return g.key;
        })),
        prevSibling: f === 0 ? null : d.get(f - 1),
        nextSibling: f === d.size - 1 ? null : d.get(f + 1)
      }));
      n = n.set(m.getKey(), m), l = NN(l, p, m);
    }
    return n;
  }, ZU());
}, JDe = function(t, r) {
  return ZU(t.map(function(n) {
    var a = new VDe(JE(n, r));
    return [a.getKey(), a];
  }));
}, ZDe = function(t, r) {
  var n = t.blocks.find(function(i) {
    return Array.isArray(i.children) && i.children.length > 0;
  }), a = IN && !n ? PN.fromRawStateToRawTreeState(t).blocks : t.blocks;
  if (!IN)
    return JDe(n ? PN.fromRawTreeStateToRawState(t).blocks : a, r);
  var s = QDe(a, r);
  return tg.NODE_ENV !== "production" && (WDe.isValidTree(s) || (tg.NODE_ENV !== "production" ? yc(!1, "Should be a valid tree") : yc(!1))), s;
}, eNe = function(t) {
  var r = t.entityMap, n = {};
  return Object.keys(r).forEach(function(a) {
    var s = r[a], i = s.type, o = s.mutability, l = s.data;
    n[a] = HDe.__create(i, o, l || {});
  }), n;
}, tNe = function(t) {
  Array.isArray(t.blocks) || (tg.NODE_ENV !== "production" ? yc(!1, "invalid RawDraftContentState") : yc(!1));
  var r = eNe(t), n = ZDe(t, r), a = n.isEmpty() ? new RN() : RN.createEmpty(n.first().getKey());
  return new $De({
    blockMap: n,
    entityMap: r,
    selectionBefore: a,
    selectionAfter: a
  });
}, rNe = tNe, nNe = _U;
function aNe(e) {
  var t = nNe(e), r = 0, n = 0, a = 0, s = 0;
  if (t.length) {
    if (t.length > 1 && t[0].width === 0) {
      var i = t[1];
      r = i.top, n = i.right, a = i.bottom, s = i.left;
    } else {
      var o = t[0];
      r = o.top, n = o.right, a = o.bottom, s = o.left;
    }
    for (var l = 1; l < t.length; l++) {
      var c = t[l];
      c.height !== 0 && c.width !== 0 && (r = Math.min(r, c.top), n = Math.max(n, c.right), a = Math.max(a, c.bottom), s = Math.min(s, c.left));
    }
  }
  return {
    top: r,
    right: n,
    bottom: a,
    left: s,
    width: n - s,
    height: a - r
  };
}
var sNe = aNe, iNe = sNe;
function oNe(e) {
  var t = e.getSelection();
  if (!t.rangeCount)
    return null;
  var r = t.getRangeAt(0), n = iNe(r), a = n.top, s = n.right, i = n.bottom, o = n.left;
  return a === 0 && s === 0 && i === 0 && o === 0 ? null : n;
}
var lNe = oNe, cNe = JEe, uNe = Fg, dNe = gi, fNe = sTe, hNe = cd, pNe = uk, mNe = mk, gNe = A6, vNe = KIe, yNe = lU, bNe = ax, wNe = Cs, xNe = h6, _Ne = ln, SNe = Tk, ENe = qIe, TNe = jU, CNe = sx, kNe = vDe, ONe = rNe, ANe = Wo, PNe = zU, RNe = lNe, INe = NU, DNe = {
  Editor: vNe,
  EditorBlock: yNe,
  EditorState: _Ne,
  CompositeDecorator: fNe,
  Entity: bNe,
  EntityInstance: xNe,
  BlockMapBuilder: uNe,
  CharacterMetadata: dNe,
  ContentBlock: hNe,
  ContentState: pNe,
  RawDraftContentState: ENe,
  SelectionState: CNe,
  AtomicBlockUtils: cNe,
  KeyBindingUtil: SNe,
  Modifier: wNe,
  RichUtils: TNe,
  DefaultDraftBlockRenderMap: mNe,
  DefaultDraftInlineStyle: gNe,
  convertFromHTML: INe,
  convertFromRaw: ONe,
  convertToRaw: kNe,
  genKey: ANe,
  getDefaultKeyBinding: PNe,
  getVisibleSelectionRect: RNe
}, da = DNe;
function NNe(e) {
  return jNe(e) || LNe(e) || MNe();
}
function MNe() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function LNe(e) {
  if (Symbol.iterator in Object(e) || Object.prototype.toString.call(e) === "[object Arguments]") return Array.from(e);
}
function jNe(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = new Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  }
}
function MN(e, t) {
  var r = Object.keys(e);
  return Object.getOwnPropertySymbols && r.push.apply(r, Object.getOwnPropertySymbols(e)), t && (r = r.filter(function(n) {
    return Object.getOwnPropertyDescriptor(e, n).enumerable;
  })), r;
}
function LN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? MN(r, !0).forEach(function(n) {
      FNe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : MN(r).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function FNe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function BNe(e, t) {
  return $Ne(e) || VNe(e, t) || UNe();
}
function UNe() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function VNe(e, t) {
  var r = [], n = !0, a = !1, s = void 0;
  try {
    for (var i = e[Symbol.iterator](), o; !(n = (o = i.next()).done) && (r.push(o.value), !(t && r.length === t)); n = !0)
      ;
  } catch (l) {
    a = !0, s = l;
  } finally {
    try {
      !n && i.return != null && i.return();
    } finally {
      if (a) throw s;
    }
  }
  return r;
}
function $Ne(e) {
  if (Array.isArray(e)) return e;
}
function HNe(e, t) {
  if (e == null)
    return t;
  for (var r = BNe(t, 2), n = r[0], a = r[1], s = LN({}, n), i = NNe(a), o = 0, l = Object.keys(e); o < l.length; o++) {
    var c = l[o];
    if (n.hasOwnProperty(c)) {
      var u = n[c];
      s[c] = LN({}, u, {}, e[c]);
    } else
      s[c] = e[c], i.push(c);
  }
  return [s, i];
}
var jN = {
  acceptCharset: "accept-charset",
  className: "class",
  htmlFor: "for",
  httpEquiv: "http-equiv"
};
function $_(e) {
  if (e == null)
    return e;
  for (var t = {}, r = !1, n = 0, a = Object.keys(e); n < a.length; n++) {
    var s = a[n], i = s;
    jN.hasOwnProperty(s) && (i = jN[s], r = !0), t[i] = e[s];
  }
  return r ? t : e;
}
var WNe = /^(moz|ms|o|webkit)-/, zNe = /^\d+$/, KNe = /([A-Z])/g, qNe = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  // SVG-related properties
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
};
function GNe(e) {
  return e.replace(KNe, "-$1").toLowerCase().replace(WNe, "-$1-");
}
function YNe(e, t) {
  var r;
  return typeof t == "string" ? r = zNe.test(t) : (r = !0, t = String(t)), !r || t === "0" || qNe[e] === !0 ? t : t + "px";
}
function S0(e) {
  return Object.keys(e).map(function(t) {
    var r = YNe(t, e[t]), n = GNe(t);
    return "".concat(n, ": ").concat(r);
  }).join("; ");
}
var Ba = {
  // This is used to represent a normal text block (paragraph).
  UNSTYLED: "unstyled",
  HEADER_ONE: "header-one",
  HEADER_TWO: "header-two",
  HEADER_THREE: "header-three",
  HEADER_FOUR: "header-four",
  HEADER_FIVE: "header-five",
  HEADER_SIX: "header-six",
  UNORDERED_LIST_ITEM: "unordered-list-item",
  ORDERED_LIST_ITEM: "ordered-list-item",
  BLOCKQUOTE: "blockquote",
  PULLQUOTE: "pullquote",
  CODE: "code-block",
  ATOMIC: "atomic"
}, lh = {
  LINK: "LINK",
  IMAGE: "IMAGE"
}, qg = {
  BOLD: "BOLD",
  CODE: "CODE",
  ITALIC: "ITALIC",
  STRIKETHROUGH: "STRIKETHROUGH",
  UNDERLINE: "UNDERLINE"
}, H_ = new Tr.OrderedSet();
function XNe(e, t) {
  for (var r = null, n = null, a = [], s = 0, i = 0, o = e.length; i < o; i++) {
    n = r;
    var l = t.get(i);
    r = l ? l.getEntity() : null, i > 0 && r !== n && (a.push([n, FN(e.slice(s, i), t.slice(s, i))]), s = i);
  }
  return a.push([r, FN(e.slice(s), t.slice(s))]), a;
}
function FN(e, t) {
  for (var r = H_, n = H_, a = [], s = 0, i = 0, o = e.length; i < o; i++) {
    n = r;
    var l = t.get(i);
    r = l ? l.getStyle() : H_, i > 0 && !Tr.is(r, n) && (a.push([e.slice(s, i), n]), s = i);
  }
  return a.push([e.slice(s), r]), a;
}
var au, E0, T0;
function BN(e, t) {
  var r = Object.keys(e);
  return Object.getOwnPropertySymbols && r.push.apply(r, Object.getOwnPropertySymbols(e)), t && (r = r.filter(function(n) {
    return Object.getOwnPropertyDescriptor(e, n).enumerable;
  })), r;
}
function C0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? BN(r, !0).forEach(function(n) {
      Fn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : BN(r).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function W_(e, t) {
  return ZNe(e) || JNe(e, t) || QNe();
}
function QNe() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function JNe(e, t) {
  var r = [], n = !0, a = !1, s = void 0;
  try {
    for (var i = e[Symbol.iterator](), o; !(n = (o = i.next()).done) && (r.push(o.value), !(t && r.length === t)); n = !0)
      ;
  } catch (l) {
    a = !0, s = l;
  } finally {
    try {
      !n && i.return != null && i.return();
    } finally {
      if (a) throw s;
    }
  }
  return r;
}
function ZNe(e) {
  if (Array.isArray(e)) return e;
}
function eMe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function tMe(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function rMe(e, t, r) {
  return t && tMe(e.prototype, t), e;
}
function Fn(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var eV = qg.BOLD, Ak = qg.CODE, tV = qg.ITALIC, rV = qg.STRIKETHROUGH, nV = qg.UNDERLINE, nMe = "  ", aV = "<br>", UN = /^data-([a-z0-9-]+)$/, aMe = (au = {}, Fn(au, eV, {
  element: "strong"
}), Fn(au, Ak, {
  element: "code"
}), Fn(au, tV, {
  element: "em"
}), Fn(au, rV, {
  element: "del"
}), Fn(au, nV, {
  element: "u"
}), au), sMe = [eV, tV, nV, rV, Ak], k0 = (E0 = {}, Fn(E0, lh.LINK, {
  url: "href",
  href: "href",
  rel: "rel",
  target: "target",
  title: "title",
  className: "class"
}), Fn(E0, lh.IMAGE, {
  src: "src",
  height: "height",
  width: "width",
  alt: "alt",
  className: "class"
}), E0), O0 = (T0 = {}, Fn(T0, lh.LINK, function(e, t) {
  for (var r = k0.hasOwnProperty(e) ? k0[e] : {}, n = t.getData(), a = {}, s = 0, i = Object.keys(n); s < i.length; s++) {
    var o = i[s], l = n[o];
    if (r.hasOwnProperty(o)) {
      var c = r[o];
      a[c] = l;
    } else UN.test(o) && (a[o] = l);
  }
  return a;
}), Fn(T0, lh.IMAGE, function(e, t) {
  for (var r = k0.hasOwnProperty(e) ? k0[e] : {}, n = t.getData(), a = {}, s = 0, i = Object.keys(n); s < i.length; s++) {
    var o = i[s], l = n[o];
    if (r.hasOwnProperty(o)) {
      var c = r[o];
      a[c] = l;
    } else UN.test(o) && (a[o] = l);
  }
  return a;
}), T0);
function VN(e, t) {
  switch (e) {
    case Ba.HEADER_ONE:
      return ["h1"];
    case Ba.HEADER_TWO:
      return ["h2"];
    case Ba.HEADER_THREE:
      return ["h3"];
    case Ba.HEADER_FOUR:
      return ["h4"];
    case Ba.HEADER_FIVE:
      return ["h5"];
    case Ba.HEADER_SIX:
      return ["h6"];
    case Ba.UNORDERED_LIST_ITEM:
    case Ba.ORDERED_LIST_ITEM:
      return ["li"];
    case Ba.BLOCKQUOTE:
      return ["blockquote"];
    case Ba.CODE:
      return ["pre", "code"];
    case Ba.ATOMIC:
      return ["figure"];
    default:
      return t === null ? [] : [t || "p"];
  }
}
function iMe(e) {
  switch (e) {
    case Ba.UNORDERED_LIST_ITEM:
      return "ul";
    case Ba.ORDERED_LIST_ITEM:
      return "ol";
    default:
      return null;
  }
}
var oMe = /* @__PURE__ */ function() {
  function e(t, r) {
    eMe(this, e), Fn(this, "blocks", void 0), Fn(this, "contentState", void 0), Fn(this, "currentBlock", void 0), Fn(this, "indentLevel", void 0), Fn(this, "output", void 0), Fn(this, "totalBlocks", void 0), Fn(this, "wrapperTag", void 0), Fn(this, "options", void 0), Fn(this, "inlineStyles", void 0), Fn(this, "inlineStyleFn", void 0), Fn(this, "styleOrder", void 0), r == null && (r = {}), this.contentState = t, this.options = r;
    var n = HNe(r.inlineStyles, [aMe, sMe]), a = W_(n, 2), s = a[0], i = a[1];
    this.inlineStyles = s, this.inlineStyleFn = r.inlineStyleFn, this.styleOrder = i;
  }
  return rMe(e, [{
    key: "generate",
    value: function() {
      for (this.output = [], this.blocks = this.contentState.getBlocksAsArray(), this.totalBlocks = this.blocks.length, this.currentBlock = 0, this.indentLevel = 0, this.wrapperTag = null; this.currentBlock < this.totalBlocks; )
        this.processBlock();
      return this.closeWrapperTag(), this.output.join("").trim();
    }
  }, {
    key: "processBlock",
    value: function() {
      var r = this.options, n = r.blockRenderers, a = r.defaultBlockTag, s = this.blocks[this.currentBlock], i = s.getType(), o = iMe(i);
      this.wrapperTag !== o && (this.wrapperTag && this.closeWrapperTag(), o && this.openWrapperTag(o)), this.indent();
      var l = n != null && n.hasOwnProperty(i) ? n[i] : null, c = l ? l(s) : null;
      if (c != null) {
        this.output.push(c), this.output.push(`
`), this.currentBlock += 1;
        return;
      }
      this.writeStartTag(s, a), this.output.push(this.renderBlockContent(s));
      var u = this.getNextBlock();
      if (lMe(i) && u && u.getDepth() === s.getDepth() + 1) {
        this.output.push(`
`);
        var d = this.wrapperTag;
        this.wrapperTag = null, this.indentLevel += 1, this.currentBlock += 1, this.processBlocksAtDepth(u.getDepth()), this.wrapperTag = d, this.indentLevel -= 1, this.indent();
      } else
        this.currentBlock += 1;
      this.writeEndTag(s, a);
    }
  }, {
    key: "processBlocksAtDepth",
    value: function(r) {
      for (var n = this.blocks[this.currentBlock]; n && n.getDepth() === r; )
        this.processBlock(), n = this.blocks[this.currentBlock];
      this.closeWrapperTag();
    }
  }, {
    key: "getNextBlock",
    value: function() {
      return this.blocks[this.currentBlock + 1];
    }
  }, {
    key: "writeStartTag",
    value: function(r, n) {
      var a = VN(r.getType(), n), s;
      if (this.options.blockStyleFn) {
        var i = this.options.blockStyleFn(r) || {}, o = i.attributes, l = i.style;
        if (o = $_(o), l != null) {
          var c = S0(l);
          o = o == null ? {
            style: c
          } : C0({}, o, {
            style: c
          });
        }
        s = qd(o);
      } else
        s = "";
      var u = !0, d = !1, f = void 0;
      try {
        for (var h = a[Symbol.iterator](), p; !(u = (p = h.next()).done); u = !0) {
          var m = p.value;
          this.output.push("<".concat(m).concat(s, ">"));
        }
      } catch (g) {
        d = !0, f = g;
      } finally {
        try {
          !u && h.return != null && h.return();
        } finally {
          if (d)
            throw f;
        }
      }
    }
  }, {
    key: "writeEndTag",
    value: function(r, n) {
      var a = VN(r.getType(), n);
      if (a.length === 1)
        this.output.push("</".concat(a[0], `>
`));
      else {
        var s = [], i = !0, o = !1, l = void 0;
        try {
          for (var c = a[Symbol.iterator](), u; !(i = (u = c.next()).done); i = !0) {
            var d = u.value;
            s.unshift("</".concat(d, ">"));
          }
        } catch (f) {
          o = !0, l = f;
        } finally {
          try {
            !i && c.return != null && c.return();
          } finally {
            if (o)
              throw l;
          }
        }
        this.output.push(s.join("") + `
`);
      }
    }
  }, {
    key: "openWrapperTag",
    value: function(r) {
      this.wrapperTag = r, this.indent(), this.output.push("<".concat(r, `>
`)), this.indentLevel += 1;
    }
  }, {
    key: "closeWrapperTag",
    value: function() {
      var r = this.wrapperTag;
      r && (this.indentLevel -= 1, this.indent(), this.output.push("</".concat(r, `>
`)), this.wrapperTag = null);
    }
  }, {
    key: "indent",
    value: function() {
      this.output.push(nMe.repeat(this.indentLevel));
    }
  }, {
    key: "withCustomInlineStyles",
    value: function(r, n) {
      if (!this.inlineStyleFn)
        return r;
      var a = this.inlineStyleFn(n);
      if (!a)
        return r;
      var s = a.element, i = s === void 0 ? "span" : s, o = a.attributes, l = a.style, c = qd(C0({}, o, {
        style: l && S0(l)
      }));
      return "<".concat(i).concat(c, ">").concat(r, "</").concat(i, ">");
    }
  }, {
    key: "renderBlockContent",
    value: function(r) {
      var n = this, a = r.getType(), s = r.getText();
      if (s === "")
        return aV;
      s = this.preserveWhitespace(s);
      var i = r.getCharacterList(), o = XNe(s, i);
      return o.map(function(l) {
        var c = W_(l, 2), u = c[0], d = c[1], f = d.map(function(A) {
          var P = W_(A, 2), D = P[0], N = P[1], z = cMe(D), G = !0, Y = !1, te = void 0;
          try {
            for (var ae = n.styleOrder[Symbol.iterator](), ne; !(G = (ne = ae.next()).done); G = !0) {
              var ue = ne.value;
              if (!(ue === Ak && a === Ba.CODE) && N.has(ue)) {
                var q = n.inlineStyles[ue], U = q.element, Q = q.attributes, L = q.style;
                if (U == null && (U = "span"), Q = $_(Q), L != null) {
                  var j = S0(L);
                  Q = Q == null ? {
                    style: j
                  } : C0({}, Q, {
                    style: j
                  });
                }
                var K = qd(Q);
                z = "<".concat(U).concat(K, ">").concat(z, "</").concat(U, ">");
              }
            }
          } catch (J) {
            Y = !0, te = J;
          } finally {
            try {
              !G && ae.return != null && ae.return();
            } finally {
              if (Y)
                throw te;
            }
          }
          return n.withCustomInlineStyles(z, N);
        }).join(""), h = u ? n.contentState.getEntity(u) : null, p = h == null ? null : h.getType().toUpperCase(), m;
        if (h != null && n.options.entityStyleFn && (m = n.options.entityStyleFn(h))) {
          var g = m, y = g.element, x = g.attributes, w = g.style;
          if (y == null && (y = "span"), x = $_(x), w != null) {
            var _ = S0(w);
            x = x == null ? {
              style: _
            } : C0({}, x, {
              style: _
            });
          }
          var S = qd(x);
          return "<".concat(y).concat(S, ">").concat(f, "</").concat(y, ">");
        } else if (p != null && p === lh.LINK) {
          var C = O0.hasOwnProperty(p) ? O0[p](p, h) : null, E = qd(C);
          return "<a".concat(E, ">").concat(f, "</a>");
        } else if (p != null && p === lh.IMAGE) {
          var O = O0.hasOwnProperty(p) ? O0[p](p, h) : null, k = qd(O);
          return "<img".concat(k, "/>");
        } else
          return f;
      }).join("");
    }
  }, {
    key: "preserveWhitespace",
    value: function(r) {
      for (var n = r.length, a = new Array(n), s = 0; s < n; s++)
        r[s] === " " && (s === 0 || s === n - 1 || r[s - 1] === " ") ? a[s] = " " : a[s] = r[s];
      return a.join("");
    }
  }]), e;
}();
function qd(e) {
  if (e == null)
    return "";
  for (var t = [], r = 0, n = Object.keys(e); r < n.length; r++) {
    var a = n[r], s = e[a];
    s != null && t.push(" ".concat(a, '="').concat(uMe(s + ""), '"'));
  }
  return t.join("");
}
function lMe(e) {
  switch (e) {
    case Ba.UNORDERED_LIST_ITEM:
    case Ba.ORDERED_LIST_ITEM:
      return !0;
    default:
      return !1;
  }
}
function cMe(e) {
  return e.split("&").join("&amp;").split("<").join("&lt;").split(">").join("&gt;").split(" ").join("&nbsp;").split(`
`).join(aV + `
`);
}
function uMe(e) {
  return e.split("&").join("&amp;").split("<").join("&lt;").split(">").join("&gt;").split('"').join("&quot;");
}
function $N(e, t) {
  return new oMe(e, t).generate();
}
const dMe = ({
  isOpen: e,
  onClose: t,
  children: r,
  title: n,
  closeOnEsc: a = !0,
  closeOnOutsideClick: s = !0,
  size: i = "md",
  className: o,
  overlayClassName: l,
  ariaLabelledBy: c,
  ariaDescribedBy: u,
  theme: d,
  footer: f,
  closeIcon: h = "close",
  preventClose: p = !1,
  onAnimationComplete: m,
  isLoading: g = !1,
  loadingText: y,
  ...x
}) => {
  var P, D;
  const { t: w } = _t(["common"]), _ = tr(null), [S, C] = Me(!1);
  wt(() => {
    const N = (z) => {
      a && !p && z.key === "Escape" && t();
    };
    return e ? (document.addEventListener("keydown", N), document.body.style.overflow = "hidden", C(!0)) : C(!1), () => {
      document.removeEventListener("keydown", N), document.body.style.overflow = "visible";
    };
  }, [e, a, t, p]), wt(() => {
    !S && m && m(e);
  }, [S, e, m]);
  const E = (N) => {
    s && !p && N.target === N.currentTarget && t();
  };
  if (!e && !S) return null;
  const O = d.baseStyle, k = ((D = (P = d.sizes) == null ? void 0 : P[i]) == null ? void 0 : D.content) || "", A = /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: Wa(O.base),
      onClick: E,
      "aria-modal": "true",
      role: "dialog",
      "aria-labelledby": c || "modal-title",
      "aria-describedby": u,
      ...x,
      children: [
        /* @__PURE__ */ v.jsx("div", { className: Wa(O.overlay, l) }),
        /* @__PURE__ */ v.jsxs(
          "div",
          {
            ref: _,
            className: Wa(
              O.content,
              k,
              o,
              S && O.animation.enter,
              S && O.animation.enterTo
            ),
            children: [
              n && /* @__PURE__ */ v.jsxs("div", { className: O.header, children: [
                /* @__PURE__ */ v.jsx("h2", { id: "modal-title", className: O.title, children: n }),
                !p && /* @__PURE__ */ v.jsx(
                  qe,
                  {
                    onClick: t,
                    variant: "ghost",
                    color: "secondary",
                    size: "xl",
                    className: O.closeButton,
                    "aria-label": w("common.close"),
                    disabled: g,
                    icon: h
                  }
                )
              ] }),
              /* @__PURE__ */ v.jsx("div", { className: O.body, children: g ? /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center justify-center p-8", children: [
                /* @__PURE__ */ v.jsx("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2 border-primary" }),
                y && /* @__PURE__ */ v.jsx("p", { className: "mt-2 text-sm text-text-muted", children: y })
              ] }) : r }),
              f && /* @__PURE__ */ v.jsx("div", { className: O.footer, children: typeof f == "function" ? f({ isLoading: g }) : f })
            ]
          }
        )
      ]
    }
  );
  return bw(A, document.body);
}, Fh = $r(
  "Modal",
  dMe
), fMe = ({
  isOpen: e,
  onClose: t,
  onSubmit: r,
  initialValue: n = ""
}) => {
  const { t: a } = _t(["common"]), [s, i] = Me(n);
  return /* @__PURE__ */ v.jsx(
    Fh,
    {
      isOpen: e,
      onClose: t,
      title: a("common:addLink"),
      size: "sm",
      footer: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx(qe, { variant: "ghost", onClick: t, children: a("common:cancel") }),
        /* @__PURE__ */ v.jsx(
          qe,
          {
            onClick: () => {
              r(s), t();
            },
            children: a("common:add")
          }
        )
      ] }),
      children: /* @__PURE__ */ v.jsx(
        ar,
        {
          value: s,
          onChange: (o) => i(o.target.value),
          placeholder: "https:// or mailto:",
          autoFocus: !0
        }
      )
    }
  );
}, hMe = [
  { label: "B", style: "BOLD", element: "strong" },
  { label: "I", style: "ITALIC", element: "em" },
  { label: "U", style: "UNDERLINE", element: "u" }
], pMe = (e, t, r) => {
  e.findEntityRanges((n) => {
    const a = n.getEntity();
    return a !== null && r.getEntity(a).getType() === "LINK";
  }, t);
}, mMe = (e) => {
  const { url: t } = e.contentState.getEntity(e.entityKey).getData();
  return /* @__PURE__ */ v.jsx(
    "a",
    {
      href: t,
      className: "underline text-primary-500 hover:text-primary-600",
      target: t.startsWith("mailto:") ? "_self" : "_blank",
      rel: "noopener noreferrer",
      children: e.children
    }
  );
}, sV = va(
  ({ value: e, onChange: t, placeholder: r, readOnly: n, error: a, minHeight: s = "150px" }, i) => {
    const [o, l] = Me(!1), [c, u] = Me(!1), [d, f] = Me(""), h = new da.CompositeDecorator([
      {
        strategy: pMe,
        component: mMe
      }
    ]), [p, m] = Me(() => {
      if (e)
        try {
          const S = da.convertFromHTML(e), C = da.ContentState.createFromBlockArray(
            S.contentBlocks,
            S.entityMap
          );
          return da.EditorState.createWithContent(C, h);
        } catch (S) {
          return console.error("Failed to parse HTML:", S), da.EditorState.createEmpty(h);
        }
      return da.EditorState.createEmpty(h);
    }), g = (S) => {
      if (m(S), S.getCurrentContent() !== p.getCurrentContent()) {
        const C = $N(S.getCurrentContent(), {
          inlineStyles: {
            BOLD: { element: "strong" },
            ITALIC: { element: "em" },
            UNDERLINE: { element: "u" }
          },
          entityStyleFn: (E) => {
            if (E.getType() === "LINK") {
              const O = E.getData();
              return {
                element: "a",
                attributes: {
                  href: O.url,
                  class: "underline text-primary-500 hover:text-primary-600",
                  target: O.url.startsWith("mailto:") ? "_self" : "_blank",
                  rel: "noopener noreferrer"
                }
              };
            }
          }
        });
        t(C);
      }
    }, y = (S, C) => {
      if (S === "undo")
        return g(da.EditorState.undo(C)), "handled";
      if (S === "redo")
        return g(da.EditorState.redo(C)), "handled";
      const E = da.RichUtils.handleKeyCommand(C, S);
      return E ? (g(E), "handled") : "not-handled";
    }, x = (S) => {
      if (da.KeyBindingUtil.hasCommandModifier(S)) {
        if (S.keyCode === 90 && !S.shiftKey) return "undo";
        if (S.keyCode === 90 && S.shiftKey) return "redo";
      }
      return da.getDefaultKeyBinding(S);
    }, w = () => {
      const S = p.getSelection();
      if (S.isCollapsed()) return;
      const E = p.getCurrentContent().getPlainText().slice(S.getStartOffset(), S.getEndOffset());
      f(E), u(!0);
    }, _ = (S) => {
      const C = p.getSelection(), O = p.getCurrentContent().createEntity("LINK", "MUTABLE", {
        url: S
      }), k = O.getLastCreatedEntityKey(), A = da.EditorState.set(p, {
        currentContent: O
      });
      g(da.RichUtils.toggleLink(A, C, k));
    };
    return /* @__PURE__ */ v.jsxs("div", { ref: i, className: "border rounded-md", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flex gap-2 p-2 border-b bg-gray-50 rounded-t-md", children: [
        hMe.map(({ label: S, style: C }) => /* @__PURE__ */ v.jsx(
          "button",
          {
            type: "button",
            onClick: () => g(da.RichUtils.toggleInlineStyle(p, C)),
            className: lt(
              "px-2 py-1 rounded",
              p.getCurrentInlineStyle().has(C) ? "bg-gray-200" : "hover:bg-gray-100"
            ),
            children: S
          },
          C
        )),
        /* @__PURE__ */ v.jsx(
          "button",
          {
            type: "button",
            onClick: w,
            className: lt(
              "px-2 py-1 rounded hover:bg-gray-100",
              p.getSelection().isCollapsed() && "opacity-50 cursor-not-allowed"
            ),
            children: "🔗"
          }
        ),
        /* @__PURE__ */ v.jsx("div", { className: "flex-1" }),
        /* @__PURE__ */ v.jsx(
          "button",
          {
            type: "button",
            onClick: () => l(!o),
            className: lt(
              "px-2 py-1 rounded hover:bg-gray-100",
              o && "bg-gray-200"
            ),
            children: o ? "Editor" : "HTML"
          }
        )
      ] }),
      /* @__PURE__ */ v.jsx("div", { style: { minHeight: s }, className: "p-4", children: o ? /* @__PURE__ */ v.jsx(
        "textarea",
        {
          value: $N(p.getCurrentContent(), {
            inlineStyles: {
              BOLD: { element: "strong" },
              ITALIC: { element: "em" },
              UNDERLINE: { element: "u" }
            },
            entityStyleFn: (S) => {
              if (S.getType() === "LINK") {
                const C = S.getData();
                return {
                  element: "a",
                  attributes: {
                    href: C.url,
                    class: "underline text-primary-500 hover:text-primary-600",
                    target: C.url.startsWith("mailto:") ? "_self" : "_blank",
                    rel: "noopener noreferrer"
                  }
                };
              }
            }
          }),
          onChange: (S) => {
            try {
              const C = da.convertFromHTML(S.target.value), E = da.ContentState.createFromBlockArray(
                C.contentBlocks,
                C.entityMap
              );
              g(da.EditorState.createWithContent(E, h));
            } catch (C) {
              console.error("Failed to parse HTML:", C);
            }
          },
          className: "w-full h-full min-h-[inherit] font-mono text-sm",
          style: { minHeight: "inherit" }
        }
      ) : /* @__PURE__ */ v.jsx(
        da.Editor,
        {
          editorState: p,
          onChange: g,
          handleKeyCommand: y,
          keyBindingFn: x,
          placeholder: r,
          readOnly: n
        }
      ) }),
      a && /* @__PURE__ */ v.jsx("p", { className: "text-red-500 text-sm mt-1 px-4 pb-2", children: a }),
      /* @__PURE__ */ v.jsx(
        fMe,
        {
          isOpen: c,
          onClose: () => u(!1),
          onSubmit: _,
          initialValue: d.includes("@") ? `mailto:${d}` : ""
        }
      )
    ] });
  }
);
sV.displayName = "RichTextEditor";
const iV = va(
  ({
    values: e,
    onChange: t,
    addButtonLabel: r,
    className: n,
    disabled: a,
    error: s,
    helperText: i,
    maxItems: o,
    placeholder: l,
    theme: c
  }, u) => {
    const { t: d } = _t(), f = () => {
      o && e.length >= o || t([...e, ""]);
    }, h = (m) => {
      const g = [...e];
      g.splice(m, 1), t(g);
    }, p = (m, g) => {
      const y = [...e];
      y[m] = g, t(y);
    };
    return /* @__PURE__ */ v.jsxs("div", { ref: u, className: lt(c.baseStyle.container, n), children: [
      e.map((m, g) => /* @__PURE__ */ v.jsxs("div", { className: c.baseStyle.item, children: [
        /* @__PURE__ */ v.jsx(
          ar,
          {
            value: m,
            onChange: (y) => p(g, y.target.value),
            disabled: a,
            placeholder: l,
            className: c.baseStyle.input
          }
        ),
        /* @__PURE__ */ v.jsx(
          qe,
          {
            variant: "ghost",
            color: "danger",
            size: "sm",
            onClick: () => h(g),
            disabled: a,
            icon: "trash",
            className: c.baseStyle.removeButton
          }
        )
      ] }, g)),
      (!o || e.length < o) && /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: f,
          variant: "outline",
          disabled: a,
          icon: "plus",
          iconPosition: "left",
          className: c.baseStyle.addButton,
          children: r || d("common.addItem")
        }
      ),
      s && /* @__PURE__ */ v.jsx("p", { className: c.baseStyle.error, children: s }),
      i && /* @__PURE__ */ v.jsx("p", { className: c.baseStyle.helperText, children: i })
    ] });
  }
);
iV.displayName = "DynamicTextListBase";
const gMe = $r("DynamicTextList", iV);
function Ea({ ...e }) {
  var l;
  const t = Ch(), { control: r, watch: n } = t, a = e.name, s = n(), i = (c, u) => {
    if (!c) return !0;
    if (typeof c == "function")
      return c(u);
    const { field: d, value: f, operator: h = "eq" } = c, p = u[d];
    switch (h) {
      case "eq":
        return p === f;
      case "neq":
        return p !== f;
      case "gt":
        return p > f;
      case "lt":
        return p < f;
      case "gte":
        return p >= f;
      case "lte":
        return p <= f;
      case "contains":
        return String(p).includes(f);
      default:
        return !0;
    }
  }, o = (c, u) => {
    var f, h, p, m, g;
    const d = {
      ...c,
      ...e,
      error: u == null ? void 0 : u.message,
      label: void 0,
      onChange: (y) => {
        c.onChange(y), e.onChange && e.onChange(y);
      }
    };
    switch (e.type) {
      case "text":
      case "email":
      case "password":
      case "number":
      case "tel":
      case "url":
        return /* @__PURE__ */ v.jsx(ar, { ...d, type: e.type });
      case "textarea":
        return /* @__PURE__ */ v.jsx(lZ, { ...d });
      case "select":
      case "multiSelect":
        return /* @__PURE__ */ v.jsx(
          ss,
          {
            ...d,
            ...e.selectProps,
            options: e.options,
            value: (f = e.transform) != null && f.output ? e.transform.output(c.value) : c.value,
            onChange: (y) => {
              var w;
              const x = (w = e.transform) != null && w.input ? e.transform.input(y) : y;
              c.onChange(x), "onChange" in e && e.onChange && e.onChange(x);
            }
          }
        );
      case "radio":
        return /* @__PURE__ */ v.jsx(dZ, { ...d });
      case "checkbox":
        return /* @__PURE__ */ v.jsx(ZT, { ...d, checked: c.value });
      case "switch":
        return /* @__PURE__ */ v.jsx(
          $F,
          {
            id: e.name,
            name: e.name,
            checked: c.value,
            onChange: (y) => {
              var x;
              c.onChange(y), (x = e.onChange) == null || x.call(e, y);
            },
            disabled: e.disabled,
            ...e.switchProps
          }
        );
      case "date":
      case "time":
      case "dateTime":
        return /* @__PURE__ */ v.jsx(
          Ine,
          {
            ...d,
            value: c.value,
            onChange: (y) => c.onChange(y)
          }
        );
      case "file":
      case "multiFile":
        return /* @__PURE__ */ v.jsx(
          cZ,
          {
            ...d,
            multiple: e.type === "multiFile",
            value: (h = e.transform) != null && h.output ? e.transform.output(c.value) : Array.isArray(c.value) ? c.value : c.value ? [c.value] : [],
            onChange: (y) => {
              var w;
              if (y.length === 0) {
                const _ = e.type === "file" ? null : [];
                c.onChange(_), e.onChange && e.onChange(_);
                return;
              }
              const x = (w = e.transform) != null && w.input ? e.transform.input(y) : e.type === "file" ? y[0] || null : y;
              c.onChange(x), e.onChange && e.onChange(x);
            },
            ...e.fileUploadProps
          }
        );
      case "color":
        return /* @__PURE__ */ v.jsx(
          Zxe,
          {
            ...d,
            ...e.colorProps,
            name: e.name,
            error: u == null ? void 0 : u.message
          }
        );
      case "range":
        return /* @__PURE__ */ v.jsx(qB, { ...d });
      case "rating":
        return /* @__PURE__ */ v.jsx(t1e, { ...d });
      case "richText":
        return /* @__PURE__ */ v.jsx(
          sV,
          {
            ...d,
            minHeight: (p = e.richTextProps) == null ? void 0 : p.minHeight,
            maxHeight: (m = e.richTextProps) == null ? void 0 : m.maxHeight,
            placeholder: (g = e.richTextProps) == null ? void 0 : g.placeholder
          }
        );
      case "dynamicTextList":
        return /* @__PURE__ */ v.jsx(
          gMe,
          {
            ...d,
            values: c.value || [],
            onChange: c.onChange,
            maxItems: e.maxItems
          }
        );
      case "advancedDynamicList":
        return /* @__PURE__ */ v.jsx(
          vMe,
          {
            ...d,
            items: c.value ? Array.isArray(c.value) ? c.value : [{ id: lm("item_"), ...c.value }] : null,
            onChange: (y) => {
              const x = e.maxItems === 1 && Array.isArray(y) && y.length > 0 ? y[0] : y;
              c.onChange(x), e.onChange && e.onChange(x);
            },
            fields: e.fields,
            maxItems: e.maxItems,
            error: e.error
          }
        );
      case "custom":
        return e.name.startsWith("__display"), e.component;
      default:
        return null;
    }
  };
  return /* @__PURE__ */ v.jsx(
    zJ,
    {
      name: a,
      control: r,
      rules: {
        required: e.required ? `${e.label} is required` : !1,
        validate: (l = e.validation) == null ? void 0 : l.validate
      },
      render: ({ field: c, fieldState: { error: u } }) => {
        var d, f;
        return e.showWhen && !i(e.showWhen, s) ? /* @__PURE__ */ v.jsx(v.Fragment, {}) : /* @__PURE__ */ v.jsxs("div", { className: (d = e.layout) == null ? void 0 : d.className, children: [
          e.label && /* @__PURE__ */ v.jsxs(
            "label",
            {
              htmlFor: e.name,
              className: Wa(
                "block text-sm text-gray-700 dark:text-gray-300 mb-1",
                (f = e.labelProps) == null ? void 0 : f.className
              ),
              children: [
                e.label,
                e.required && /* @__PURE__ */ v.jsx("span", { className: "text-red-500 dark:text-red-400 ml-1", children: "*" })
              ]
            }
          ),
          o(c, u),
          e.helperText && /* @__PURE__ */ v.jsx("p", { className: "mt-1 text-sm text-gray-500", children: e.helperText })
        ] });
      }
    }
  );
}
const oV = va(
  ({
    items: e,
    onChange: t,
    fields: r,
    maxItems: n = 1 / 0,
    addButtonLabel: a,
    className: s,
    disabled: i,
    error: o,
    helperText: l,
    draggable: c = !0,
    theme: u
  }, d) => {
    var U, Q, L, j, K;
    const { t: f } = _t(), { theme: h } = Wi(), p = ((U = h.components.AdvancedDynamicList) == null ? void 0 : U.baseStyle) || {}, [m, g] = Me(null), [y, x] = Me(null), w = tr(), _ = tr(), [S, C] = Me([]), E = MF({
      defaultValues: {}
    }), { control: O, reset: k, setValue: A, getValues: P, watch: D } = E, N = tr(!1), z = Ft(
      () => r.reduce((J, re) => {
        var pe, me, Oe;
        let le;
        switch (re.type) {
          case "select":
            le = ((pe = re.selectProps) == null ? void 0 : pe.isClearable) !== !1 && ((Oe = (me = re.selectProps) == null ? void 0 : me.options) != null && Oe[0]) ? re.selectProps.options[0] : null;
            break;
          case "multiSelect":
          case "advancedDynamicList":
          case "dynamicTextList":
          case "multiFile":
            le = [];
            break;
          case "switch":
          case "checkbox":
            le = !1;
            break;
          case "number":
          case "range":
          case "rating":
            le = 0;
            break;
          case "file":
            le = null;
            break;
          case "text":
          case "textarea":
          case "richText":
          case "email":
          case "password":
          case "tel":
          case "url":
          case "date":
          case "time":
          case "dateTime":
          case "color":
            le = "";
            break;
          default:
            le = void 0;
        }
        return { ...J, [re.name]: le };
      }, {}),
      [r]
    ), G = Ft(
      (J) => S.map((re) => ({
        id: re.id,
        ...J[re.id] || z()
      })),
      [S, z]
    );
    wt(() => {
      const J = JSON.stringify(_.current), re = JSON.stringify(e);
      if (J === re)
        return;
      _.current = e;
      const le = (e ? Array.isArray(e) ? e : [e] : n === 1 && S.length === 0 ? [{ id: lm("item_"), ...z() }] : []).map((ee) => !ee || typeof ee != "object" ? null : ee.id ? ee : (console.warn(
        "AdvancedDynamicList: Found item without ID, generating one.",
        ee
      ), { ...ee, id: lm("item_") })).filter(Boolean), pe = le.map((ee) => ({
        id: ee.id
      })), me = le.reduce(
        (ee, he) => (ee[he.id] = { ...he }, delete ee[he.id].id, ee),
        {}
      );
      JSON.stringify(S) !== JSON.stringify(pe) && C(pe);
      const Oe = P();
      JSON.stringify(Oe) !== JSON.stringify(me) && (N.current = !0, k(me));
    }, [
      e,
      n,
      k,
      r,
      z,
      P,
      S
    ]), wt(() => {
      const J = D((re, { name: le, type: pe }) => {
        if (N.current) {
          N.current = !1;
          return;
        }
        const me = G(re), Oe = n === 1 ? e : e || [];
        JSON.stringify(me) !== JSON.stringify(Oe) && t(
          n === 1 ? me[0] || null : me
        );
      });
      return () => J.unsubscribe();
    }, [D, t, n, G, e]);
    const Y = () => {
      if (n && S.length >= n) return;
      const J = lm("item_"), re = { id: J }, le = z(), pe = [...S, re], Oe = {
        ...P(),
        [J]: le
      };
      N.current = !0, k(Oe, { keepDefaultValues: !0 }), C(pe);
      const ee = pe.map((he) => ({
        id: he.id,
        ...Oe[he.id] || le
      }));
      t(n === 1 ? ee[0] || null : ee);
    }, te = (J) => {
      if (!S.find(
        (ee) => ee.id === J
      )) return;
      const le = S.filter(
        (ee) => ee.id !== J
      ), me = { ...P() };
      delete me[J], N.current = !0, k(me, { keepDefaultValues: !1 }), C(le);
      const Oe = le.map((ee) => ({
        id: ee.id,
        ...me[ee.id] || z()
      }));
      t(n === 1 ? Oe[0] || null : Oe);
    }, ae = (J) => g(J), ne = (J, re) => {
      J.preventDefault(), w.current && window.clearTimeout(w.current), w.current = window.setTimeout(
        () => x(re),
        50
      );
    }, ue = (J) => {
      if (!m || !c || n === 1) return;
      const re = S, le = P(), pe = re.findIndex(
        (we) => we.id === m.id
      ), me = re.findIndex(
        (we) => we.id === J
      );
      if (pe === -1 || me === -1 || pe === me) {
        g(null), x(null);
        return;
      }
      const Oe = [...re], [ee] = Oe.splice(pe, 1);
      Oe.splice(me, 0, ee);
      const he = {};
      Oe.forEach((we) => {
        he[we.id] = le[we.id] || z();
      }), N.current = !0, k(he, { keepDefaultValues: !1 }), C(Oe);
      const Ee = Oe.map((we) => ({
        id: we.id,
        ...he[we.id] || z()
      }));
      t(n === 1 ? Ee[0] || null : Ee), g(null), x(null);
    }, q = (J, re, le) => {
      const pe = `${le}.${J.name}`, me = `${le}-${J.name}`, Oe = {
        name: pe,
        label: J.label,
        placeholder: J.placeholder,
        required: J.required,
        readOnly: J.readOnly,
        helperText: J.helperText,
        layout: J.layout,
        disabled: i || J.disabled
      };
      switch (J.type) {
        case "select":
        case "multiSelect":
          const ee = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: ee.type,
              options: ee.options ?? [],
              selectProps: ee.selectProps
            }
          );
        case "switch":
          const he = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: he.type,
              switchProps: he.switchProps
            }
          );
        case "textarea":
          const Ee = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: Ee.type,
              textareaProps: Ee.textareaProps
            }
          );
        case "file":
        case "multiFile":
          const we = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: we.type,
              transform: we.transform,
              fileUploadProps: we.fileUploadProps
            }
          );
        case "radio":
          const Pe = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: Pe.type,
              options: Pe.options ?? [],
              radioProps: Pe.radioProps
            }
          );
        case "checkbox":
          const rt = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: rt.type,
              checkboxProps: rt.checkboxProps
            }
          );
        case "date":
        case "time":
        case "dateTime":
          const ht = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: ht.type,
              dateTimeProps: ht.dateTimeProps
            }
          );
        case "color":
          const bt = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: bt.type,
              colorProps: bt.colorProps
            }
          );
        case "range":
          const Ge = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: Ge.type,
              rangeProps: Ge.rangeProps
            }
          );
        case "rating":
          const oe = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: oe.type,
              ratingProps: oe.ratingProps
            }
          );
        case "richText":
          const ve = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: ve.type,
              richTextProps: ve.richTextProps
            }
          );
        case "advancedDynamicList":
          const ye = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: ye.type,
              fields: ye.fields,
              transform: ye.transform,
              maxItems: ye.maxItems
            }
          );
        case "dynamicTextList":
          const Te = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: Te.type,
              maxItems: Te.maxItems
            }
          );
        case "custom":
          const _e = J;
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Oe,
              key: me,
              type: _e.type,
              component: _e.component,
              componentProps: _e.componentProps
            }
          );
        default:
          const Ae = {
            ...Oe,
            transform: J.transform
          };
          return /* @__PURE__ */ _a(
            Ea,
            {
              ...Ae,
              key: me,
              type: J.type
            }
          );
      }
    };
    return /* @__PURE__ */ v.jsx(TF, { ...E, children: /* @__PURE__ */ v.jsxs("div", { ref: d, className: lt((Q = u.baseStyle) == null ? void 0 : Q.container, s), children: [
      S.length > 0 && /* @__PURE__ */ v.jsx("div", { className: "space-y-4", children: S.map((J, re) => {
        var le, pe;
        return /* @__PURE__ */ v.jsx(
          hr,
          {
            variant: o ? "error" : "outlined",
            children: /* @__PURE__ */ v.jsxs(
              "div",
              {
                draggable: c && (!n || n > 1),
                onDragStart: c ? () => ae(J) : void 0,
                onDragOver: c ? (me) => ne(me, J.id) : void 0,
                onDrop: c ? () => ue(J.id) : void 0,
                onClick: (me) => me.stopPropagation(),
                className: lt(
                  "flex gap-5",
                  c && (!n || n > 1) ? "cursor-grab" : "",
                  (m == null ? void 0 : m.id) === J.id && p.dragging,
                  y === J.id && p.dragOver
                ),
                children: [
                  c && (!n || n > 1) && /* @__PURE__ */ v.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ v.jsx(
                    dt,
                    {
                      name: "grip-vertical",
                      className: (le = u.baseStyle) == null ? void 0 : le.dragHandle
                    }
                  ) }),
                  /* @__PURE__ */ v.jsx("div", { className: "flex-1", children: /* @__PURE__ */ v.jsx("div", { className: (pe = u.baseStyle) == null ? void 0 : pe.fieldsContainer, children: r.map(
                    (me) => q(me, re, J.id)
                  ) }) }),
                  (!n || n > 1) && /* @__PURE__ */ v.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ v.jsx(
                    qe,
                    {
                      variant: "ghost",
                      color: "danger",
                      size: "sm",
                      onClick: () => te(J.id),
                      disabled: i,
                      icon: "trash"
                    }
                  ) })
                ]
              },
              `item-${J.id}`
            )
          },
          `card-${J.id}`
        );
      }) }),
      (!n || n > S.length) && (!n || n > 1) && /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: Y,
          variant: "outline",
          disabled: i,
          icon: "plus",
          iconPosition: "left",
          className: (L = u.baseStyle) == null ? void 0 : L.button,
          children: a || f("common.addItem")
        }
      ),
      (o || l) && /* @__PURE__ */ v.jsx(
        "p",
        {
          className: lt(
            (j = u.baseStyle) == null ? void 0 : j.helperText,
            o ? (K = u.baseStyle) == null ? void 0 : K.helperTextError : ""
          ),
          children: o || l
        }
      )
    ] }) });
  }
);
oV.displayName = "AdvancedDynamicListBase";
const vMe = $r("AdvancedDynamicList", oV), yMe = {
  info: {
    bg: "bg-blue-50",
    border: "border-blue-200",
    text: "text-blue-800",
    icon: "information-circle"
  },
  success: {
    bg: "bg-green-50",
    border: "border-green-200",
    text: "text-green-800",
    icon: "check-circle"
  },
  warning: {
    bg: "bg-yellow-50",
    border: "border-yellow-200",
    text: "text-yellow-800",
    icon: "exclamation-triangle"
  },
  error: {
    bg: "bg-red-50",
    border: "border-red-200",
    text: "text-red-800",
    icon: "x-circle"
  }
}, _et = ({
  type: e,
  title: t,
  error: r,
  message: n,
  onClose: a,
  action: s
}) => {
  var c;
  const i = yMe[e], o = r ? r.message : n, l = t || ((r == null ? void 0 : r.category) === dn.VALIDATION ? "Validation Error" : r == null ? void 0 : r.code);
  return /* @__PURE__ */ v.jsx("div", { className: `rounded-lg p-4 ${i.bg} border ${i.border}`, children: /* @__PURE__ */ v.jsxs("div", { className: "flex", children: [
    /* @__PURE__ */ v.jsx("div", { className: "flex-shrink-0", children: /* @__PURE__ */ v.jsx(dt, { name: i.icon, className: i.text }) }),
    /* @__PURE__ */ v.jsxs("div", { className: "ml-3 flex-1", children: [
      l && /* @__PURE__ */ v.jsx("h3", { className: `text-sm font-medium ${i.text}`, children: l }),
      /* @__PURE__ */ v.jsxs("div", { className: "mt-2 text-sm", children: [
        /* @__PURE__ */ v.jsx("p", { children: o }),
        ((c = r == null ? void 0 : r.details) == null ? void 0 : c.errors) && /* @__PURE__ */ v.jsx("ul", { className: "list-disc pl-5 mt-2", children: r.details.errors.map((u, d) => /* @__PURE__ */ v.jsxs("li", { children: [
          u.field && /* @__PURE__ */ v.jsxs("span", { className: "font-medium", children: [
            u.field,
            ": "
          ] }),
          u.message
        ] }, d)) })
      ] }),
      s && /* @__PURE__ */ v.jsx("div", { className: "mt-4", children: /* @__PURE__ */ v.jsx(
        qe,
        {
          variant: "link",
          color: e === "error" ? "danger" : void 0,
          onClick: s.onClick,
          href: s.href,
          className: "text-sm",
          children: s.label
        }
      ) })
    ] }),
    a && /* @__PURE__ */ v.jsx("div", { className: "ml-auto pl-3", children: /* @__PURE__ */ v.jsxs(
      "button",
      {
        type: "button",
        className: `inline-flex rounded-md p-1.5 ${i.text} hover:${i.bg}`,
        onClick: a,
        children: [
          /* @__PURE__ */ v.jsx("span", { className: "sr-only", children: "Dismiss" }),
          /* @__PURE__ */ v.jsx(dt, { name: "x", className: "h-5 w-5" })
        ]
      }
    ) })
  ] }) });
}, lV = va(
  ({
    variant: e = "solid",
    color: t = "primary",
    size: r = "md",
    icon: n,
    onRemove: a,
    loading: s,
    disabled: i,
    dot: o,
    className: l,
    children: c,
    theme: u,
    ...d
  }, f) => {
    var y, x, w;
    const h = u.baseStyle, p = ((x = (y = u.variants) == null ? void 0 : y[e]) == null ? void 0 : x[t]) || "", m = ((w = u.sizes) == null ? void 0 : w[r]) || "", g = lt(
      h.base,
      p,
      m,
      i && h.states.disabled,
      s && h.states.loading,
      n && h.states.withIcon,
      o && h.states.withDot,
      a && h.states.withRemove,
      l
    );
    return /* @__PURE__ */ v.jsx("span", { ref: f, className: g, ...d, children: /* @__PURE__ */ v.jsxs("span", { className: h.container, children: [
      s && /* @__PURE__ */ v.jsxs(
        "svg",
        {
          className: h.loadingSpinner,
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          children: [
            /* @__PURE__ */ v.jsx(
              "circle",
              {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
              }
            ),
            /* @__PURE__ */ v.jsx(
              "path",
              {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }
            )
          ]
        }
      ),
      o && /* @__PURE__ */ v.jsx("span", { className: h.dot }),
      n && /* @__PURE__ */ v.jsx("span", { className: h.icon, children: n }),
      /* @__PURE__ */ v.jsx("span", { className: h.content, children: c }),
      a && /* @__PURE__ */ v.jsx(
        "button",
        {
          type: "button",
          onClick: a,
          className: h.remove,
          disabled: i,
          children: /* @__PURE__ */ v.jsx(
            "svg",
            {
              className: "h-3 w-3",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              children: /* @__PURE__ */ v.jsx(
                "path",
                {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: 2,
                  d: "M6 18L18 6M6 6l12 12"
                }
              )
            }
          )
        }
      )
    ] }) });
  }
);
lV.displayName = "Badge";
const Eet = $r(
  "Badge",
  lV
);
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function Gg(e) {
  return e + 0.5 | 0;
}
const bc = (e, t, r) => Math.max(Math.min(e, r), t);
function tm(e) {
  return bc(Gg(e * 2.55), 0, 255);
}
function Tc(e) {
  return bc(Gg(e * 255), 0, 255);
}
function xl(e) {
  return bc(Gg(e / 2.55) / 100, 0, 1);
}
function HN(e) {
  return bc(Gg(e * 100), 0, 100);
}
const Qs = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, ZE = [..."0123456789ABCDEF"], bMe = (e) => ZE[e & 15], wMe = (e) => ZE[(e & 240) >> 4] + ZE[e & 15], A0 = (e) => (e & 240) >> 4 === (e & 15), xMe = (e) => A0(e.r) && A0(e.g) && A0(e.b) && A0(e.a);
function _Me(e) {
  var t = e.length, r;
  return e[0] === "#" && (t === 4 || t === 5 ? r = {
    r: 255 & Qs[e[1]] * 17,
    g: 255 & Qs[e[2]] * 17,
    b: 255 & Qs[e[3]] * 17,
    a: t === 5 ? Qs[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (r = {
    r: Qs[e[1]] << 4 | Qs[e[2]],
    g: Qs[e[3]] << 4 | Qs[e[4]],
    b: Qs[e[5]] << 4 | Qs[e[6]],
    a: t === 9 ? Qs[e[7]] << 4 | Qs[e[8]] : 255
  })), r;
}
const SMe = (e, t) => e < 255 ? t(e) : "";
function EMe(e) {
  var t = xMe(e) ? bMe : wMe;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + SMe(e.a, t) : void 0;
}
const TMe = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function cV(e, t, r) {
  const n = t * Math.min(r, 1 - r), a = (s, i = (s + e / 30) % 12) => r - n * Math.max(Math.min(i - 3, 9 - i, 1), -1);
  return [a(0), a(8), a(4)];
}
function CMe(e, t, r) {
  const n = (a, s = (a + e / 60) % 6) => r - r * t * Math.max(Math.min(s, 4 - s, 1), 0);
  return [n(5), n(3), n(1)];
}
function kMe(e, t, r) {
  const n = cV(e, 1, 0.5);
  let a;
  for (t + r > 1 && (a = 1 / (t + r), t *= a, r *= a), a = 0; a < 3; a++)
    n[a] *= 1 - t - r, n[a] += t;
  return n;
}
function OMe(e, t, r, n, a) {
  return e === a ? (t - r) / n + (t < r ? 6 : 0) : t === a ? (r - e) / n + 2 : (e - t) / n + 4;
}
function Pk(e) {
  const r = e.r / 255, n = e.g / 255, a = e.b / 255, s = Math.max(r, n, a), i = Math.min(r, n, a), o = (s + i) / 2;
  let l, c, u;
  return s !== i && (u = s - i, c = o > 0.5 ? u / (2 - s - i) : u / (s + i), l = OMe(r, n, a, u, s), l = l * 60 + 0.5), [l | 0, c || 0, o];
}
function Rk(e, t, r, n) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, r, n)).map(Tc);
}
function Ik(e, t, r) {
  return Rk(cV, e, t, r);
}
function AMe(e, t, r) {
  return Rk(kMe, e, t, r);
}
function PMe(e, t, r) {
  return Rk(CMe, e, t, r);
}
function uV(e) {
  return (e % 360 + 360) % 360;
}
function RMe(e) {
  const t = TMe.exec(e);
  let r = 255, n;
  if (!t)
    return;
  t[5] !== n && (r = t[6] ? tm(+t[5]) : Tc(+t[5]));
  const a = uV(+t[2]), s = +t[3] / 100, i = +t[4] / 100;
  return t[1] === "hwb" ? n = AMe(a, s, i) : t[1] === "hsv" ? n = PMe(a, s, i) : n = Ik(a, s, i), {
    r: n[0],
    g: n[1],
    b: n[2],
    a: r
  };
}
function IMe(e, t) {
  var r = Pk(e);
  r[0] = uV(r[0] + t), r = Ik(r), e.r = r[0], e.g = r[1], e.b = r[2];
}
function DMe(e) {
  if (!e)
    return;
  const t = Pk(e), r = t[0], n = HN(t[1]), a = HN(t[2]);
  return e.a < 255 ? `hsla(${r}, ${n}%, ${a}%, ${xl(e.a)})` : `hsl(${r}, ${n}%, ${a}%)`;
}
const WN = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, zN = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function NMe() {
  const e = {}, t = Object.keys(zN), r = Object.keys(WN);
  let n, a, s, i, o;
  for (n = 0; n < t.length; n++) {
    for (i = o = t[n], a = 0; a < r.length; a++)
      s = r[a], o = o.replace(s, WN[s]);
    s = parseInt(zN[i], 16), e[o] = [s >> 16 & 255, s >> 8 & 255, s & 255];
  }
  return e;
}
let P0;
function MMe(e) {
  P0 || (P0 = NMe(), P0.transparent = [0, 0, 0, 0]);
  const t = P0[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const LMe = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function jMe(e) {
  const t = LMe.exec(e);
  let r = 255, n, a, s;
  if (t) {
    if (t[7] !== n) {
      const i = +t[7];
      r = t[8] ? tm(i) : bc(i * 255, 0, 255);
    }
    return n = +t[1], a = +t[3], s = +t[5], n = 255 & (t[2] ? tm(n) : bc(n, 0, 255)), a = 255 & (t[4] ? tm(a) : bc(a, 0, 255)), s = 255 & (t[6] ? tm(s) : bc(s, 0, 255)), {
      r: n,
      g: a,
      b: s,
      a: r
    };
  }
}
function FMe(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${xl(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const z_ = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, Gd = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function BMe(e, t, r) {
  const n = Gd(xl(e.r)), a = Gd(xl(e.g)), s = Gd(xl(e.b));
  return {
    r: Tc(z_(n + r * (Gd(xl(t.r)) - n))),
    g: Tc(z_(a + r * (Gd(xl(t.g)) - a))),
    b: Tc(z_(s + r * (Gd(xl(t.b)) - s))),
    a: e.a + r * (t.a - e.a)
  };
}
function R0(e, t, r) {
  if (e) {
    let n = Pk(e);
    n[t] = Math.max(0, Math.min(n[t] + n[t] * r, t === 0 ? 360 : 1)), n = Ik(n), e.r = n[0], e.g = n[1], e.b = n[2];
  }
}
function dV(e, t) {
  return e && Object.assign(t || {}, e);
}
function KN(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = Tc(e[3]))) : (t = dV(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = Tc(t.a)), t;
}
function UMe(e) {
  return e.charAt(0) === "r" ? jMe(e) : RMe(e);
}
class ng {
  constructor(t) {
    if (t instanceof ng)
      return t;
    const r = typeof t;
    let n;
    r === "object" ? n = KN(t) : r === "string" && (n = _Me(t) || MMe(t) || UMe(t)), this._rgb = n, this._valid = !!n;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = dV(this._rgb);
    return t && (t.a = xl(t.a)), t;
  }
  set rgb(t) {
    this._rgb = KN(t);
  }
  rgbString() {
    return this._valid ? FMe(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? EMe(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? DMe(this._rgb) : void 0;
  }
  mix(t, r) {
    if (t) {
      const n = this.rgb, a = t.rgb;
      let s;
      const i = r === s ? 0.5 : r, o = 2 * i - 1, l = n.a - a.a, c = ((o * l === -1 ? o : (o + l) / (1 + o * l)) + 1) / 2;
      s = 1 - c, n.r = 255 & c * n.r + s * a.r + 0.5, n.g = 255 & c * n.g + s * a.g + 0.5, n.b = 255 & c * n.b + s * a.b + 0.5, n.a = i * n.a + (1 - i) * a.a, this.rgb = n;
    }
    return this;
  }
  interpolate(t, r) {
    return t && (this._rgb = BMe(this._rgb, t._rgb, r)), this;
  }
  clone() {
    return new ng(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = Tc(t), this;
  }
  clearer(t) {
    const r = this._rgb;
    return r.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, r = Gg(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = r, this;
  }
  opaquer(t) {
    const r = this._rgb;
    return r.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return R0(this._rgb, 2, t), this;
  }
  darken(t) {
    return R0(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return R0(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return R0(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return IMe(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.4.8
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
function sl() {
}
const VMe = /* @__PURE__ */ (() => {
  let e = 0;
  return () => e++;
})();
function Vr(e) {
  return e == null;
}
function Jn(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function wr(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function Ja(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function ao(e, t) {
  return Ja(e) ? e : t;
}
function gr(e, t) {
  return typeof e > "u" ? t : e;
}
const $Me = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, fV = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function pn(e, t, r) {
  if (e && typeof e.call == "function")
    return e.apply(r, t);
}
function Gr(e, t, r, n) {
  let a, s, i;
  if (Jn(e))
    for (s = e.length, a = 0; a < s; a++)
      t.call(r, e[a], a);
  else if (wr(e))
    for (i = Object.keys(e), s = i.length, a = 0; a < s; a++)
      t.call(r, e[i[a]], i[a]);
}
function kb(e, t) {
  let r, n, a, s;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (r = 0, n = e.length; r < n; ++r)
    if (a = e[r], s = t[r], a.datasetIndex !== s.datasetIndex || a.index !== s.index)
      return !1;
  return !0;
}
function Ob(e) {
  if (Jn(e))
    return e.map(Ob);
  if (wr(e)) {
    const t = /* @__PURE__ */ Object.create(null), r = Object.keys(e), n = r.length;
    let a = 0;
    for (; a < n; ++a)
      t[r[a]] = Ob(e[r[a]]);
    return t;
  }
  return e;
}
function hV(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function HMe(e, t, r, n) {
  if (!hV(e))
    return;
  const a = t[e], s = r[e];
  wr(a) && wr(s) ? ag(a, s, n) : t[e] = Ob(s);
}
function ag(e, t, r) {
  const n = Jn(t) ? t : [
    t
  ], a = n.length;
  if (!wr(e))
    return e;
  r = r || {};
  const s = r.merger || HMe;
  let i;
  for (let o = 0; o < a; ++o) {
    if (i = n[o], !wr(i))
      continue;
    const l = Object.keys(i);
    for (let c = 0, u = l.length; c < u; ++c)
      s(l[c], e, i, r);
  }
  return e;
}
function gm(e, t) {
  return ag(e, t, {
    merger: WMe
  });
}
function WMe(e, t, r) {
  if (!hV(e))
    return;
  const n = t[e], a = r[e];
  wr(n) && wr(a) ? gm(n, a) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = Ob(a));
}
const qN = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function zMe(e) {
  const t = e.split("."), r = [];
  let n = "";
  for (const a of t)
    n += a, n.endsWith("\\") ? n = n.slice(0, -1) + "." : (r.push(n), n = "");
  return r;
}
function KMe(e) {
  const t = zMe(e);
  return (r) => {
    for (const n of t) {
      if (n === "")
        break;
      r = r && r[n];
    }
    return r;
  };
}
function Ku(e, t) {
  return (qN[t] || (qN[t] = KMe(t)))(e);
}
function Dk(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const sg = (e) => typeof e < "u", Lc = (e) => typeof e == "function", GN = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const r of e)
    if (!t.has(r))
      return !1;
  return !0;
};
function qMe(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const Pn = Math.PI, En = 2 * Pn, GMe = En + Pn, Ab = Number.POSITIVE_INFINITY, YMe = Pn / 180, oa = Pn / 2, su = Pn / 4, YN = Pn * 2 / 3, pV = Math.log10, No = Math.sign;
function vm(e, t, r) {
  return Math.abs(e - t) < r;
}
function XN(e) {
  const t = Math.round(e);
  e = vm(e, t, e / 1e3) ? t : e;
  const r = Math.pow(10, Math.floor(pV(e))), n = e / r;
  return (n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10) * r;
}
function XMe(e) {
  const t = [], r = Math.sqrt(e);
  let n;
  for (n = 1; n < r; n++)
    e % n === 0 && (t.push(n), t.push(e / n));
  return r === (r | 0) && t.push(r), t.sort((a, s) => a - s).pop(), t;
}
function QMe(e) {
  return typeof e == "symbol" || typeof e == "object" && e !== null && !(Symbol.toPrimitive in e || "toString" in e || "valueOf" in e);
}
function ig(e) {
  return !QMe(e) && !isNaN(parseFloat(e)) && isFinite(e);
}
function JMe(e, t) {
  const r = Math.round(e);
  return r - t <= e && r + t >= e;
}
function ZMe(e, t, r) {
  let n, a, s;
  for (n = 0, a = e.length; n < a; n++)
    s = e[n][r], isNaN(s) || (t.min = Math.min(t.min, s), t.max = Math.max(t.max, s));
}
function El(e) {
  return e * (Pn / 180);
}
function eLe(e) {
  return e * (180 / Pn);
}
function QN(e) {
  if (!Ja(e))
    return;
  let t = 1, r = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, r++;
  return r;
}
function mV(e, t) {
  const r = t.x - e.x, n = t.y - e.y, a = Math.sqrt(r * r + n * n);
  let s = Math.atan2(n, r);
  return s < -0.5 * Pn && (s += En), {
    angle: s,
    distance: a
  };
}
function eT(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function tLe(e, t) {
  return (e - t + GMe) % En - Pn;
}
function vo(e) {
  return (e % En + En) % En;
}
function og(e, t, r, n) {
  const a = vo(e), s = vo(t), i = vo(r), o = vo(s - a), l = vo(i - a), c = vo(a - s), u = vo(a - i);
  return a === s || a === i || n && s === i || o > l && c < u;
}
function qa(e, t, r) {
  return Math.max(t, Math.min(r, e));
}
function rLe(e) {
  return qa(e, -32768, 32767);
}
function Tl(e, t, r, n = 1e-6) {
  return e >= Math.min(t, r) - n && e <= Math.max(t, r) + n;
}
function Nk(e, t, r) {
  r = r || ((i) => e[i] < t);
  let n = e.length - 1, a = 0, s;
  for (; n - a > 1; )
    s = a + n >> 1, r(s) ? a = s : n = s;
  return {
    lo: a,
    hi: n
  };
}
const Cu = (e, t, r, n) => Nk(e, r, n ? (a) => {
  const s = e[a][t];
  return s < r || s === r && e[a + 1][t] === r;
} : (a) => e[a][t] < r), nLe = (e, t, r) => Nk(e, r, (n) => e[n][t] >= r);
function aLe(e, t, r) {
  let n = 0, a = e.length;
  for (; n < a && e[n] < t; )
    n++;
  for (; a > n && e[a - 1] > r; )
    a--;
  return n > 0 || a < e.length ? e.slice(n, a) : e;
}
const gV = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function sLe(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), gV.forEach((r) => {
    const n = "_onData" + Dk(r), a = e[r];
    Object.defineProperty(e, r, {
      configurable: !0,
      enumerable: !1,
      value(...s) {
        const i = a.apply(this, s);
        return e._chartjs.listeners.forEach((o) => {
          typeof o[n] == "function" && o[n](...s);
        }), i;
      }
    });
  });
}
function JN(e, t) {
  const r = e._chartjs;
  if (!r)
    return;
  const n = r.listeners, a = n.indexOf(t);
  a !== -1 && n.splice(a, 1), !(n.length > 0) && (gV.forEach((s) => {
    delete e[s];
  }), delete e._chartjs);
}
function vV(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const yV = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function bV(e, t) {
  let r = [], n = !1;
  return function(...a) {
    r = a, n || (n = !0, yV.call(window, () => {
      n = !1, e.apply(t, r);
    }));
  };
}
function iLe(e, t) {
  let r;
  return function(...n) {
    return t ? (clearTimeout(r), r = setTimeout(e, t, n)) : e.apply(this, n), t;
  };
}
const Mk = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", Ua = (e, t, r) => e === "start" ? t : e === "end" ? r : (t + r) / 2, oLe = (e, t, r, n) => e === (n ? "left" : "right") ? r : e === "center" ? (t + r) / 2 : t;
function lLe(e, t, r) {
  const n = t.length;
  let a = 0, s = n;
  if (e._sorted) {
    const { iScale: i, vScale: o, _parsed: l } = e, c = e.dataset && e.dataset.options ? e.dataset.options.spanGaps : null, u = i.axis, { min: d, max: f, minDefined: h, maxDefined: p } = i.getUserBounds();
    if (h) {
      if (a = Math.min(
        // @ts-expect-error Need to type _parsed
        Cu(l, u, d).lo,
        // @ts-expect-error Need to fix types on _lookupByKey
        r ? n : Cu(t, u, i.getPixelForValue(d)).lo
      ), c) {
        const m = l.slice(0, a + 1).reverse().findIndex((g) => !Vr(g[o.axis]));
        a -= Math.max(0, m);
      }
      a = qa(a, 0, n - 1);
    }
    if (p) {
      let m = Math.max(
        // @ts-expect-error Need to type _parsed
        Cu(l, i.axis, f, !0).hi + 1,
        // @ts-expect-error Need to fix types on _lookupByKey
        r ? 0 : Cu(t, u, i.getPixelForValue(f), !0).hi + 1
      );
      if (c) {
        const g = l.slice(m - 1).findIndex((y) => !Vr(y[o.axis]));
        m += Math.max(0, g);
      }
      s = qa(m, a, n) - a;
    } else
      s = n - a;
  }
  return {
    start: a,
    count: s
  };
}
function cLe(e) {
  const { xScale: t, yScale: r, _scaleRanges: n } = e, a = {
    xmin: t.min,
    xmax: t.max,
    ymin: r.min,
    ymax: r.max
  };
  if (!n)
    return e._scaleRanges = a, !0;
  const s = n.xmin !== t.min || n.xmax !== t.max || n.ymin !== r.min || n.ymax !== r.max;
  return Object.assign(n, a), s;
}
const I0 = (e) => e === 0 || e === 1, ZN = (e, t, r) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * En / r)), eM = (e, t, r) => Math.pow(2, -10 * e) * Math.sin((e - t) * En / r) + 1, ym = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * oa) + 1,
  easeOutSine: (e) => Math.sin(e * oa),
  easeInOutSine: (e) => -0.5 * (Math.cos(Pn * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => I0(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => I0(e) ? e : ZN(e, 0.075, 0.3),
  easeOutElastic: (e) => I0(e) ? e : eM(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return I0(e) ? e : e < 0.5 ? 0.5 * ZN(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * eM(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - ym.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? ym.easeInBounce(e * 2) * 0.5 : ym.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function Lk(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function tM(e) {
  return Lk(e) ? e : new ng(e);
}
function K_(e) {
  return Lk(e) ? e : new ng(e).saturate(0.5).darken(0.1).hexString();
}
const uLe = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], dLe = [
  "color",
  "borderColor",
  "backgroundColor"
];
function fLe(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: dLe
    },
    numbers: {
      type: "number",
      properties: uLe
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function hLe(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const rM = /* @__PURE__ */ new Map();
function pLe(e, t) {
  t = t || {};
  const r = e + JSON.stringify(t);
  let n = rM.get(r);
  return n || (n = new Intl.NumberFormat(e, t), rM.set(r, n)), n;
}
function jk(e, t, r) {
  return pLe(t, r).format(e);
}
const mLe = {
  values(e) {
    return Jn(e) ? e : "" + e;
  },
  numeric(e, t, r) {
    if (e === 0)
      return "0";
    const n = this.chart.options.locale;
    let a, s = e;
    if (r.length > 1) {
      const c = Math.max(Math.abs(r[0].value), Math.abs(r[r.length - 1].value));
      (c < 1e-4 || c > 1e15) && (a = "scientific"), s = gLe(e, r);
    }
    const i = pV(Math.abs(s)), o = isNaN(i) ? 1 : Math.max(Math.min(-1 * Math.floor(i), 20), 0), l = {
      notation: a,
      minimumFractionDigits: o,
      maximumFractionDigits: o
    };
    return Object.assign(l, this.options.ticks.format), jk(e, n, l);
  }
};
function gLe(e, t) {
  let r = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(r) >= 1 && e !== Math.floor(e) && (r = e - Math.floor(e)), r;
}
var wV = {
  formatters: mLe
};
function vLe(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, r) => r.lineWidth,
      tickColor: (t, r) => r.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: wV.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const qu = /* @__PURE__ */ Object.create(null), tT = /* @__PURE__ */ Object.create(null);
function bm(e, t) {
  if (!t)
    return e;
  const r = t.split(".");
  for (let n = 0, a = r.length; n < a; ++n) {
    const s = r[n];
    e = e[s] || (e[s] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function q_(e, t, r) {
  return typeof t == "string" ? ag(bm(e, t), r) : ag(bm(e, ""), t);
}
class yLe {
  constructor(t, r) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (n) => n.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (n, a) => K_(a.backgroundColor), this.hoverBorderColor = (n, a) => K_(a.borderColor), this.hoverColor = (n, a) => K_(a.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(r);
  }
  set(t, r) {
    return q_(this, t, r);
  }
  get(t) {
    return bm(this, t);
  }
  describe(t, r) {
    return q_(tT, t, r);
  }
  override(t, r) {
    return q_(qu, t, r);
  }
  route(t, r, n, a) {
    const s = bm(this, t), i = bm(this, n), o = "_" + r;
    Object.defineProperties(s, {
      [o]: {
        value: s[r],
        writable: !0
      },
      [r]: {
        enumerable: !0,
        get() {
          const l = this[o], c = i[a];
          return wr(l) ? Object.assign({}, c, l) : gr(l, c);
        },
        set(l) {
          this[o] = l;
        }
      }
    });
  }
  apply(t) {
    t.forEach((r) => r(this));
  }
}
var Wn = /* @__PURE__ */ new yLe({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  fLe,
  hLe,
  vLe
]);
function bLe(e) {
  return !e || Vr(e.size) || Vr(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function nM(e, t, r, n, a) {
  let s = t[a];
  return s || (s = t[a] = e.measureText(a).width, r.push(a)), s > n && (n = s), n;
}
function iu(e, t, r) {
  const n = e.currentDevicePixelRatio, a = r !== 0 ? Math.max(r / 2, 0.5) : 0;
  return Math.round((t - a) * n) / n + a;
}
function aM(e, t) {
  !t && !e || (t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore());
}
function rT(e, t, r, n) {
  xV(e, t, r, n, null);
}
function xV(e, t, r, n, a) {
  let s, i, o, l, c, u, d, f;
  const h = t.pointStyle, p = t.rotation, m = t.radius;
  let g = (p || 0) * YMe;
  if (h && typeof h == "object" && (s = h.toString(), s === "[object HTMLImageElement]" || s === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(r, n), e.rotate(g), e.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), e.restore();
    return;
  }
  if (!(isNaN(m) || m <= 0)) {
    switch (e.beginPath(), h) {
      default:
        a ? e.ellipse(r, n, a / 2, m, 0, 0, En) : e.arc(r, n, m, 0, En), e.closePath();
        break;
      case "triangle":
        u = a ? a / 2 : m, e.moveTo(r + Math.sin(g) * u, n - Math.cos(g) * m), g += YN, e.lineTo(r + Math.sin(g) * u, n - Math.cos(g) * m), g += YN, e.lineTo(r + Math.sin(g) * u, n - Math.cos(g) * m), e.closePath();
        break;
      case "rectRounded":
        c = m * 0.516, l = m - c, i = Math.cos(g + su) * l, d = Math.cos(g + su) * (a ? a / 2 - c : l), o = Math.sin(g + su) * l, f = Math.sin(g + su) * (a ? a / 2 - c : l), e.arc(r - d, n - o, c, g - Pn, g - oa), e.arc(r + f, n - i, c, g - oa, g), e.arc(r + d, n + o, c, g, g + oa), e.arc(r - f, n + i, c, g + oa, g + Pn), e.closePath();
        break;
      case "rect":
        if (!p) {
          l = Math.SQRT1_2 * m, u = a ? a / 2 : l, e.rect(r - u, n - l, 2 * u, 2 * l);
          break;
        }
        g += su;
      case "rectRot":
        d = Math.cos(g) * (a ? a / 2 : m), i = Math.cos(g) * m, o = Math.sin(g) * m, f = Math.sin(g) * (a ? a / 2 : m), e.moveTo(r - d, n - o), e.lineTo(r + f, n - i), e.lineTo(r + d, n + o), e.lineTo(r - f, n + i), e.closePath();
        break;
      case "crossRot":
        g += su;
      case "cross":
        d = Math.cos(g) * (a ? a / 2 : m), i = Math.cos(g) * m, o = Math.sin(g) * m, f = Math.sin(g) * (a ? a / 2 : m), e.moveTo(r - d, n - o), e.lineTo(r + d, n + o), e.moveTo(r + f, n - i), e.lineTo(r - f, n + i);
        break;
      case "star":
        d = Math.cos(g) * (a ? a / 2 : m), i = Math.cos(g) * m, o = Math.sin(g) * m, f = Math.sin(g) * (a ? a / 2 : m), e.moveTo(r - d, n - o), e.lineTo(r + d, n + o), e.moveTo(r + f, n - i), e.lineTo(r - f, n + i), g += su, d = Math.cos(g) * (a ? a / 2 : m), i = Math.cos(g) * m, o = Math.sin(g) * m, f = Math.sin(g) * (a ? a / 2 : m), e.moveTo(r - d, n - o), e.lineTo(r + d, n + o), e.moveTo(r + f, n - i), e.lineTo(r - f, n + i);
        break;
      case "line":
        i = a ? a / 2 : Math.cos(g) * m, o = Math.sin(g) * m, e.moveTo(r - i, n - o), e.lineTo(r + i, n + o);
        break;
      case "dash":
        e.moveTo(r, n), e.lineTo(r + Math.cos(g) * (a ? a / 2 : m), n + Math.sin(g) * m);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function lg(e, t, r) {
  return r = r || 0.5, !t || e && e.x > t.left - r && e.x < t.right + r && e.y > t.top - r && e.y < t.bottom + r;
}
function gx(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function vx(e) {
  e.restore();
}
function wLe(e, t, r, n, a) {
  if (!t)
    return e.lineTo(r.x, r.y);
  if (a === "middle") {
    const s = (t.x + r.x) / 2;
    e.lineTo(s, t.y), e.lineTo(s, r.y);
  } else a === "after" != !!n ? e.lineTo(t.x, r.y) : e.lineTo(r.x, t.y);
  e.lineTo(r.x, r.y);
}
function xLe(e, t, r, n) {
  if (!t)
    return e.lineTo(r.x, r.y);
  e.bezierCurveTo(n ? t.cp1x : t.cp2x, n ? t.cp1y : t.cp2y, n ? r.cp2x : r.cp1x, n ? r.cp2y : r.cp1y, r.x, r.y);
}
function _Le(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), Vr(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function SLe(e, t, r, n, a) {
  if (a.strikethrough || a.underline) {
    const s = e.measureText(n), i = t - s.actualBoundingBoxLeft, o = t + s.actualBoundingBoxRight, l = r - s.actualBoundingBoxAscent, c = r + s.actualBoundingBoxDescent, u = a.strikethrough ? (l + c) / 2 : c;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = a.decorationWidth || 2, e.moveTo(i, u), e.lineTo(o, u), e.stroke();
  }
}
function ELe(e, t) {
  const r = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = r;
}
function cg(e, t, r, n, a, s = {}) {
  const i = Jn(t) ? t : [
    t
  ], o = s.strokeWidth > 0 && s.strokeColor !== "";
  let l, c;
  for (e.save(), e.font = a.string, _Le(e, s), l = 0; l < i.length; ++l)
    c = i[l], s.backdrop && ELe(e, s.backdrop), o && (s.strokeColor && (e.strokeStyle = s.strokeColor), Vr(s.strokeWidth) || (e.lineWidth = s.strokeWidth), e.strokeText(c, r, n, s.maxWidth)), e.fillText(c, r, n, s.maxWidth), SLe(e, r, n, c, s), n += Number(a.lineHeight);
  e.restore();
}
function Pb(e, t) {
  const { x: r, y: n, w: a, h: s, radius: i } = t;
  e.arc(r + i.topLeft, n + i.topLeft, i.topLeft, 1.5 * Pn, Pn, !0), e.lineTo(r, n + s - i.bottomLeft), e.arc(r + i.bottomLeft, n + s - i.bottomLeft, i.bottomLeft, Pn, oa, !0), e.lineTo(r + a - i.bottomRight, n + s), e.arc(r + a - i.bottomRight, n + s - i.bottomRight, i.bottomRight, oa, 0, !0), e.lineTo(r + a, n + i.topRight), e.arc(r + a - i.topRight, n + i.topRight, i.topRight, 0, -oa, !0), e.lineTo(r + i.topLeft, n);
}
const TLe = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, CLe = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function kLe(e, t) {
  const r = ("" + e).match(TLe);
  if (!r || r[1] === "normal")
    return t * 1.2;
  switch (e = +r[2], r[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const OLe = (e) => +e || 0;
function Fk(e, t) {
  const r = {}, n = wr(t), a = n ? Object.keys(t) : t, s = wr(e) ? n ? (i) => gr(e[i], e[t[i]]) : (i) => e[i] : () => e;
  for (const i of a)
    r[i] = OLe(s(i));
  return r;
}
function _V(e) {
  return Fk(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Bf(e) {
  return Fk(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function mi(e) {
  const t = _V(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function Ga(e, t) {
  e = e || {}, t = t || Wn.font;
  let r = gr(e.size, t.size);
  typeof r == "string" && (r = parseInt(r, 10));
  let n = gr(e.style, t.style);
  n && !("" + n).match(CLe) && (console.warn('Invalid font style specified: "' + n + '"'), n = void 0);
  const a = {
    family: gr(e.family, t.family),
    lineHeight: kLe(gr(e.lineHeight, t.lineHeight), r),
    size: r,
    style: n,
    weight: gr(e.weight, t.weight),
    string: ""
  };
  return a.string = bLe(a), a;
}
function D0(e, t, r, n) {
  let a, s, i;
  for (a = 0, s = e.length; a < s; ++a)
    if (i = e[a], i !== void 0 && i !== void 0)
      return i;
}
function ALe(e, t, r) {
  const { min: n, max: a } = e, s = fV(t, (a - n) / 2), i = (o, l) => r && o === 0 ? 0 : o + l;
  return {
    min: i(n, -Math.abs(s)),
    max: i(a, s)
  };
}
function pd(e, t) {
  return Object.assign(Object.create(e), t);
}
function Bk(e, t = [
  ""
], r, n, a = () => e[0]) {
  const s = r || e;
  typeof n > "u" && (n = CV("_fallback", e));
  const i = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: s,
    _fallback: n,
    _getTarget: a,
    override: (o) => Bk([
      o,
      ...e
    ], t, s, n)
  };
  return new Proxy(i, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(o, l) {
      return delete o[l], delete o._keys, delete e[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(o, l) {
      return EV(o, l, () => jLe(l, t, e, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(o, l) {
      return Reflect.getOwnPropertyDescriptor(o._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(o, l) {
      return iM(o).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(o) {
      return iM(o);
    },
    /**
    * A trap for setting property values.
    */
    set(o, l, c) {
      const u = o._storage || (o._storage = a());
      return o[l] = u[l] = c, delete o._keys, !0;
    }
  });
}
function ch(e, t, r, n) {
  const a = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: r,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: SV(e, n),
    setContext: (s) => ch(e, s, r, n),
    override: (s) => ch(e.override(s), t, r, n)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(s, i) {
      return delete s[i], delete e[i], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(s, i, o) {
      return EV(s, i, () => RLe(s, i, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(s, i) {
      return s._descriptors.allKeys ? Reflect.has(e, i) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, i);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(s, i) {
      return Reflect.has(e, i);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(s, i, o) {
      return e[i] = o, delete s[i], !0;
    }
  });
}
function SV(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: r = t.scriptable, _indexable: n = t.indexable, _allKeys: a = t.allKeys } = e;
  return {
    allKeys: a,
    scriptable: r,
    indexable: n,
    isScriptable: Lc(r) ? r : () => r,
    isIndexable: Lc(n) ? n : () => n
  };
}
const PLe = (e, t) => e ? e + Dk(t) : t, Uk = (e, t) => wr(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function EV(e, t, r) {
  if (Object.prototype.hasOwnProperty.call(e, t) || t === "constructor")
    return e[t];
  const n = r();
  return e[t] = n, n;
}
function RLe(e, t, r) {
  const { _proxy: n, _context: a, _subProxy: s, _descriptors: i } = e;
  let o = n[t];
  return Lc(o) && i.isScriptable(t) && (o = ILe(t, o, e, r)), Jn(o) && o.length && (o = DLe(t, o, e, i.isIndexable)), Uk(t, o) && (o = ch(o, a, s && s[t], i)), o;
}
function ILe(e, t, r, n) {
  const { _proxy: a, _context: s, _subProxy: i, _stack: o } = r;
  if (o.has(e))
    throw new Error("Recursion detected: " + Array.from(o).join("->") + "->" + e);
  o.add(e);
  let l = t(s, i || n);
  return o.delete(e), Uk(e, l) && (l = Vk(a._scopes, a, e, l)), l;
}
function DLe(e, t, r, n) {
  const { _proxy: a, _context: s, _subProxy: i, _descriptors: o } = r;
  if (typeof s.index < "u" && n(e))
    return t[s.index % t.length];
  if (wr(t[0])) {
    const l = t, c = a._scopes.filter((u) => u !== l);
    t = [];
    for (const u of l) {
      const d = Vk(c, a, e, u);
      t.push(ch(d, s, i && i[e], o));
    }
  }
  return t;
}
function TV(e, t, r) {
  return Lc(e) ? e(t, r) : e;
}
const NLe = (e, t) => e === !0 ? t : typeof e == "string" ? Ku(t, e) : void 0;
function MLe(e, t, r, n, a) {
  for (const s of t) {
    const i = NLe(r, s);
    if (i) {
      e.add(i);
      const o = TV(i._fallback, r, a);
      if (typeof o < "u" && o !== r && o !== n)
        return o;
    } else if (i === !1 && typeof n < "u" && r !== n)
      return null;
  }
  return !1;
}
function Vk(e, t, r, n) {
  const a = t._rootScopes, s = TV(t._fallback, r, n), i = [
    ...e,
    ...a
  ], o = /* @__PURE__ */ new Set();
  o.add(n);
  let l = sM(o, i, r, s || r, n);
  return l === null || typeof s < "u" && s !== r && (l = sM(o, i, s, l, n), l === null) ? !1 : Bk(Array.from(o), [
    ""
  ], a, s, () => LLe(t, r, n));
}
function sM(e, t, r, n, a) {
  for (; r; )
    r = MLe(e, t, r, n, a);
  return r;
}
function LLe(e, t, r) {
  const n = e._getTarget();
  t in n || (n[t] = {});
  const a = n[t];
  return Jn(a) && wr(r) ? r : a || {};
}
function jLe(e, t, r, n) {
  let a;
  for (const s of t)
    if (a = CV(PLe(s, e), r), typeof a < "u")
      return Uk(e, a) ? Vk(r, n, e, a) : a;
}
function CV(e, t) {
  for (const r of t) {
    if (!r)
      continue;
    const n = r[e];
    if (typeof n < "u")
      return n;
  }
}
function iM(e) {
  let t = e._keys;
  return t || (t = e._keys = FLe(e._scopes)), t;
}
function FLe(e) {
  const t = /* @__PURE__ */ new Set();
  for (const r of e)
    for (const n of Object.keys(r).filter((a) => !a.startsWith("_")))
      t.add(n);
  return Array.from(t);
}
const BLe = Number.EPSILON || 1e-14, uh = (e, t) => t < e.length && !e[t].skip && e[t], kV = (e) => e === "x" ? "y" : "x";
function ULe(e, t, r, n) {
  const a = e.skip ? t : e, s = t, i = r.skip ? t : r, o = eT(s, a), l = eT(i, s);
  let c = o / (o + l), u = l / (o + l);
  c = isNaN(c) ? 0 : c, u = isNaN(u) ? 0 : u;
  const d = n * c, f = n * u;
  return {
    previous: {
      x: s.x - d * (i.x - a.x),
      y: s.y - d * (i.y - a.y)
    },
    next: {
      x: s.x + f * (i.x - a.x),
      y: s.y + f * (i.y - a.y)
    }
  };
}
function VLe(e, t, r) {
  const n = e.length;
  let a, s, i, o, l, c = uh(e, 0);
  for (let u = 0; u < n - 1; ++u)
    if (l = c, c = uh(e, u + 1), !(!l || !c)) {
      if (vm(t[u], 0, BLe)) {
        r[u] = r[u + 1] = 0;
        continue;
      }
      a = r[u] / t[u], s = r[u + 1] / t[u], o = Math.pow(a, 2) + Math.pow(s, 2), !(o <= 9) && (i = 3 / Math.sqrt(o), r[u] = a * i * t[u], r[u + 1] = s * i * t[u]);
    }
}
function $Le(e, t, r = "x") {
  const n = kV(r), a = e.length;
  let s, i, o, l = uh(e, 0);
  for (let c = 0; c < a; ++c) {
    if (i = o, o = l, l = uh(e, c + 1), !o)
      continue;
    const u = o[r], d = o[n];
    i && (s = (u - i[r]) / 3, o[`cp1${r}`] = u - s, o[`cp1${n}`] = d - s * t[c]), l && (s = (l[r] - u) / 3, o[`cp2${r}`] = u + s, o[`cp2${n}`] = d + s * t[c]);
  }
}
function HLe(e, t = "x") {
  const r = kV(t), n = e.length, a = Array(n).fill(0), s = Array(n);
  let i, o, l, c = uh(e, 0);
  for (i = 0; i < n; ++i)
    if (o = l, l = c, c = uh(e, i + 1), !!l) {
      if (c) {
        const u = c[t] - l[t];
        a[i] = u !== 0 ? (c[r] - l[r]) / u : 0;
      }
      s[i] = o ? c ? No(a[i - 1]) !== No(a[i]) ? 0 : (a[i - 1] + a[i]) / 2 : a[i - 1] : a[i];
    }
  VLe(e, a, s), $Le(e, s, t);
}
function N0(e, t, r) {
  return Math.max(Math.min(e, r), t);
}
function WLe(e, t) {
  let r, n, a, s, i, o = lg(e[0], t);
  for (r = 0, n = e.length; r < n; ++r)
    i = s, s = o, o = r < n - 1 && lg(e[r + 1], t), s && (a = e[r], i && (a.cp1x = N0(a.cp1x, t.left, t.right), a.cp1y = N0(a.cp1y, t.top, t.bottom)), o && (a.cp2x = N0(a.cp2x, t.left, t.right), a.cp2y = N0(a.cp2y, t.top, t.bottom)));
}
function zLe(e, t, r, n, a) {
  let s, i, o, l;
  if (t.spanGaps && (e = e.filter((c) => !c.skip)), t.cubicInterpolationMode === "monotone")
    HLe(e, a);
  else {
    let c = n ? e[e.length - 1] : e[0];
    for (s = 0, i = e.length; s < i; ++s)
      o = e[s], l = ULe(c, o, e[Math.min(s + 1, i - (n ? 0 : 1)) % i], t.tension), o.cp1x = l.previous.x, o.cp1y = l.previous.y, o.cp2x = l.next.x, o.cp2y = l.next.y, c = o;
  }
  t.capBezierPoints && WLe(e, r);
}
function $k() {
  return typeof window < "u" && typeof document < "u";
}
function Hk(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function Rb(e, t, r) {
  let n;
  return typeof e == "string" ? (n = parseInt(e, 10), e.indexOf("%") !== -1 && (n = n / 100 * t.parentNode[r])) : n = e, n;
}
const yx = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function KLe(e, t) {
  return yx(e).getPropertyValue(t);
}
const qLe = [
  "top",
  "right",
  "bottom",
  "left"
];
function Mu(e, t, r) {
  const n = {};
  r = r ? "-" + r : "";
  for (let a = 0; a < 4; a++) {
    const s = qLe[a];
    n[s] = parseFloat(e[t + "-" + s + r]) || 0;
  }
  return n.width = n.left + n.right, n.height = n.top + n.bottom, n;
}
const GLe = (e, t, r) => (e > 0 || t > 0) && (!r || !r.shadowRoot);
function YLe(e, t) {
  const r = e.touches, n = r && r.length ? r[0] : e, { offsetX: a, offsetY: s } = n;
  let i = !1, o, l;
  if (GLe(a, s, e.target))
    o = a, l = s;
  else {
    const c = t.getBoundingClientRect();
    o = n.clientX - c.left, l = n.clientY - c.top, i = !0;
  }
  return {
    x: o,
    y: l,
    box: i
  };
}
function pu(e, t) {
  if ("native" in e)
    return e;
  const { canvas: r, currentDevicePixelRatio: n } = t, a = yx(r), s = a.boxSizing === "border-box", i = Mu(a, "padding"), o = Mu(a, "border", "width"), { x: l, y: c, box: u } = YLe(e, r), d = i.left + (u && o.left), f = i.top + (u && o.top);
  let { width: h, height: p } = t;
  return s && (h -= i.width + o.width, p -= i.height + o.height), {
    x: Math.round((l - d) / h * r.width / n),
    y: Math.round((c - f) / p * r.height / n)
  };
}
function XLe(e, t, r) {
  let n, a;
  if (t === void 0 || r === void 0) {
    const s = e && Hk(e);
    if (!s)
      t = e.clientWidth, r = e.clientHeight;
    else {
      const i = s.getBoundingClientRect(), o = yx(s), l = Mu(o, "border", "width"), c = Mu(o, "padding");
      t = i.width - c.width - l.width, r = i.height - c.height - l.height, n = Rb(o.maxWidth, s, "clientWidth"), a = Rb(o.maxHeight, s, "clientHeight");
    }
  }
  return {
    width: t,
    height: r,
    maxWidth: n || Ab,
    maxHeight: a || Ab
  };
}
const M0 = (e) => Math.round(e * 10) / 10;
function QLe(e, t, r, n) {
  const a = yx(e), s = Mu(a, "margin"), i = Rb(a.maxWidth, e, "clientWidth") || Ab, o = Rb(a.maxHeight, e, "clientHeight") || Ab, l = XLe(e, t, r);
  let { width: c, height: u } = l;
  if (a.boxSizing === "content-box") {
    const f = Mu(a, "border", "width"), h = Mu(a, "padding");
    c -= h.width + f.width, u -= h.height + f.height;
  }
  return c = Math.max(0, c - s.width), u = Math.max(0, n ? c / n : u - s.height), c = M0(Math.min(c, i, l.maxWidth)), u = M0(Math.min(u, o, l.maxHeight)), c && !u && (u = M0(c / 2)), (t !== void 0 || r !== void 0) && n && l.height && u > l.height && (u = l.height, c = M0(Math.floor(u * n))), {
    width: c,
    height: u
  };
}
function oM(e, t, r) {
  const n = t || 1, a = Math.floor(e.height * n), s = Math.floor(e.width * n);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const i = e.canvas;
  return i.style && (r || !i.style.height && !i.style.width) && (i.style.height = `${e.height}px`, i.style.width = `${e.width}px`), e.currentDevicePixelRatio !== n || i.height !== a || i.width !== s ? (e.currentDevicePixelRatio = n, i.height = a, i.width = s, e.ctx.setTransform(n, 0, 0, n, 0, 0), !0) : !1;
}
const JLe = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    $k() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch {
  }
  return e;
}();
function lM(e, t) {
  const r = KLe(e, t), n = r && r.match(/^(\d+)(\.\d+)?px$/);
  return n ? +n[1] : void 0;
}
function mu(e, t, r, n) {
  return {
    x: e.x + r * (t.x - e.x),
    y: e.y + r * (t.y - e.y)
  };
}
function ZLe(e, t, r, n) {
  return {
    x: e.x + r * (t.x - e.x),
    y: n === "middle" ? r < 0.5 ? e.y : t.y : n === "after" ? r < 1 ? e.y : t.y : r > 0 ? t.y : e.y
  };
}
function eje(e, t, r, n) {
  const a = {
    x: e.cp2x,
    y: e.cp2y
  }, s = {
    x: t.cp1x,
    y: t.cp1y
  }, i = mu(e, a, r), o = mu(a, s, r), l = mu(s, t, r), c = mu(i, o, r), u = mu(o, l, r);
  return mu(c, u, r);
}
const tje = function(e, t) {
  return {
    x(r) {
      return e + e + t - r;
    },
    setWidth(r) {
      t = r;
    },
    textAlign(r) {
      return r === "center" ? r : r === "right" ? "left" : "right";
    },
    xPlus(r, n) {
      return r - n;
    },
    leftForLtr(r, n) {
      return r - n;
    }
  };
}, rje = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function Uf(e, t, r) {
  return e ? tje(t, r) : rje();
}
function OV(e, t) {
  let r, n;
  (t === "ltr" || t === "rtl") && (r = e.canvas.style, n = [
    r.getPropertyValue("direction"),
    r.getPropertyPriority("direction")
  ], r.setProperty("direction", t, "important"), e.prevTextDirection = n);
}
function AV(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function PV(e) {
  return e === "angle" ? {
    between: og,
    compare: tLe,
    normalize: vo
  } : {
    between: Tl,
    compare: (t, r) => t - r,
    normalize: (t) => t
  };
}
function cM({ start: e, end: t, count: r, loop: n, style: a }) {
  return {
    start: e % r,
    end: t % r,
    loop: n && (t - e + 1) % r === 0,
    style: a
  };
}
function nje(e, t, r) {
  const { property: n, start: a, end: s } = r, { between: i, normalize: o } = PV(n), l = t.length;
  let { start: c, end: u, loop: d } = e, f, h;
  if (d) {
    for (c += l, u += l, f = 0, h = l; f < h && i(o(t[c % l][n]), a, s); ++f)
      c--, u--;
    c %= l, u %= l;
  }
  return u < c && (u += l), {
    start: c,
    end: u,
    loop: d,
    style: e.style
  };
}
function RV(e, t, r) {
  if (!r)
    return [
      e
    ];
  const { property: n, start: a, end: s } = r, i = t.length, { compare: o, between: l, normalize: c } = PV(n), { start: u, end: d, loop: f, style: h } = nje(e, t, r), p = [];
  let m = !1, g = null, y, x, w;
  const _ = () => l(a, w, y) && o(a, w) !== 0, S = () => o(s, y) === 0 || l(s, w, y), C = () => m || _(), E = () => !m || S();
  for (let O = u, k = u; O <= d; ++O)
    x = t[O % i], !x.skip && (y = c(x[n]), y !== w && (m = l(y, a, s), g === null && C() && (g = o(y, a) === 0 ? O : k), g !== null && E() && (p.push(cM({
      start: g,
      end: O,
      loop: f,
      count: i,
      style: h
    })), g = null), k = O, w = y));
  return g !== null && p.push(cM({
    start: g,
    end: d,
    loop: f,
    count: i,
    style: h
  })), p;
}
function IV(e, t) {
  const r = [], n = e.segments;
  for (let a = 0; a < n.length; a++) {
    const s = RV(n[a], e.points, t);
    s.length && r.push(...s);
  }
  return r;
}
function aje(e, t, r, n) {
  let a = 0, s = t - 1;
  if (r && !n)
    for (; a < t && !e[a].skip; )
      a++;
  for (; a < t && e[a].skip; )
    a++;
  for (a %= t, r && (s += a); s > a && e[s % t].skip; )
    s--;
  return s %= t, {
    start: a,
    end: s
  };
}
function sje(e, t, r, n) {
  const a = e.length, s = [];
  let i = t, o = e[t], l;
  for (l = t + 1; l <= r; ++l) {
    const c = e[l % a];
    c.skip || c.stop ? o.skip || (n = !1, s.push({
      start: t % a,
      end: (l - 1) % a,
      loop: n
    }), t = i = c.stop ? l : null) : (i = l, o.skip && (t = l)), o = c;
  }
  return i !== null && s.push({
    start: t % a,
    end: i % a,
    loop: n
  }), s;
}
function ije(e, t) {
  const r = e.points, n = e.options.spanGaps, a = r.length;
  if (!a)
    return [];
  const s = !!e._loop, { start: i, end: o } = aje(r, a, s, n);
  if (n === !0)
    return uM(e, [
      {
        start: i,
        end: o,
        loop: s
      }
    ], r, t);
  const l = o < i ? o + a : o, c = !!e._fullLoop && i === 0 && o === a - 1;
  return uM(e, sje(r, i, l, c), r, t);
}
function uM(e, t, r, n) {
  return !n || !n.setContext || !r ? t : oje(e, t, r, n);
}
function oje(e, t, r, n) {
  const a = e._chart.getContext(), s = dM(e.options), { _datasetIndex: i, options: { spanGaps: o } } = e, l = r.length, c = [];
  let u = s, d = t[0].start, f = d;
  function h(p, m, g, y) {
    const x = o ? -1 : 1;
    if (p !== m) {
      for (p += l; r[p % l].skip; )
        p -= x;
      for (; r[m % l].skip; )
        m += x;
      p % l !== m % l && (c.push({
        start: p % l,
        end: m % l,
        loop: g,
        style: y
      }), u = y, d = m % l);
    }
  }
  for (const p of t) {
    d = o ? d : p.start;
    let m = r[d % l], g;
    for (f = d + 1; f <= p.end; f++) {
      const y = r[f % l];
      g = dM(n.setContext(pd(a, {
        type: "segment",
        p0: m,
        p1: y,
        p0DataIndex: (f - 1) % l,
        p1DataIndex: f % l,
        datasetIndex: i
      }))), lje(g, u) && h(d, f - 1, p.loop, u), m = y, u = g;
    }
    d < f - 1 && h(d, f - 1, p.loop, u);
  }
  return c;
}
function dM(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function lje(e, t) {
  if (!t)
    return !1;
  const r = [], n = function(a, s) {
    return Lk(s) ? (r.includes(s) || r.push(s), r.indexOf(s)) : s;
  };
  return JSON.stringify(e, n) !== JSON.stringify(t, n);
}
/*!
 * Chart.js v4.4.8
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
class cje {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, r, n, a) {
    const s = r.listeners[a], i = r.duration;
    s.forEach((o) => o({
      chart: t,
      initial: r.initial,
      numSteps: i,
      currentStep: Math.min(n - r.start, i)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = yV.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let r = 0;
    this._charts.forEach((n, a) => {
      if (!n.running || !n.items.length)
        return;
      const s = n.items;
      let i = s.length - 1, o = !1, l;
      for (; i >= 0; --i)
        l = s[i], l._active ? (l._total > n.duration && (n.duration = l._total), l.tick(t), o = !0) : (s[i] = s[s.length - 1], s.pop());
      o && (a.draw(), this._notify(a, n, t, "progress")), s.length || (n.running = !1, this._notify(a, n, t, "complete"), n.initial = !1), r += s.length;
    }), this._lastDate = t, r === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const r = this._charts;
    let n = r.get(t);
    return n || (n = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, r.set(t, n)), n;
  }
  listen(t, r, n) {
    this._getAnims(t).listeners[r].push(n);
  }
  add(t, r) {
    !r || !r.length || this._getAnims(t).items.push(...r);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const r = this._charts.get(t);
    r && (r.running = !0, r.start = Date.now(), r.duration = r.items.reduce((n, a) => Math.max(n, a._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const r = this._charts.get(t);
    return !(!r || !r.running || !r.items.length);
  }
  stop(t) {
    const r = this._charts.get(t);
    if (!r || !r.items.length)
      return;
    const n = r.items;
    let a = n.length - 1;
    for (; a >= 0; --a)
      n[a].cancel();
    r.items = [], this._notify(t, r, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var ml = /* @__PURE__ */ new cje();
const fM = "transparent", uje = {
  boolean(e, t, r) {
    return r > 0.5 ? t : e;
  },
  color(e, t, r) {
    const n = tM(e || fM), a = n.valid && tM(t || fM);
    return a && a.valid ? a.mix(n, r).hexString() : t;
  },
  number(e, t, r) {
    return e + (t - e) * r;
  }
};
class dje {
  constructor(t, r, n, a) {
    const s = r[n];
    a = D0([
      t.to,
      a,
      s,
      t.from
    ]);
    const i = D0([
      t.from,
      s,
      a
    ]);
    this._active = !0, this._fn = t.fn || uje[t.type || typeof i], this._easing = ym[t.easing] || ym.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = r, this._prop = n, this._from = i, this._to = a, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, r, n) {
    if (this._active) {
      this._notify(!1);
      const a = this._target[this._prop], s = n - this._start, i = this._duration - s;
      this._start = n, this._duration = Math.floor(Math.max(i, t.duration)), this._total += s, this._loop = !!t.loop, this._to = D0([
        t.to,
        r,
        a,
        t.from
      ]), this._from = D0([
        t.from,
        a,
        r
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const r = t - this._start, n = this._duration, a = this._prop, s = this._from, i = this._loop, o = this._to;
    let l;
    if (this._active = s !== o && (i || r < n), !this._active) {
      this._target[a] = o, this._notify(!0);
      return;
    }
    if (r < 0) {
      this._target[a] = s;
      return;
    }
    l = r / n % 2, l = i && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[a] = this._fn(s, o, l);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((r, n) => {
      t.push({
        res: r,
        rej: n
      });
    });
  }
  _notify(t) {
    const r = t ? "res" : "rej", n = this._promises || [];
    for (let a = 0; a < n.length; a++)
      n[a][r]();
  }
}
class DV {
  constructor(t, r) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(r);
  }
  configure(t) {
    if (!wr(t))
      return;
    const r = Object.keys(Wn.animation), n = this._properties;
    Object.getOwnPropertyNames(t).forEach((a) => {
      const s = t[a];
      if (!wr(s))
        return;
      const i = {};
      for (const o of r)
        i[o] = s[o];
      (Jn(s.properties) && s.properties || [
        a
      ]).forEach((o) => {
        (o === a || !n.has(o)) && n.set(o, i);
      });
    });
  }
  _animateOptions(t, r) {
    const n = r.options, a = hje(t, n);
    if (!a)
      return [];
    const s = this._createAnimations(a, n);
    return n.$shared && fje(t.options.$animations, n).then(() => {
      t.options = n;
    }, () => {
    }), s;
  }
  _createAnimations(t, r) {
    const n = this._properties, a = [], s = t.$animations || (t.$animations = {}), i = Object.keys(r), o = Date.now();
    let l;
    for (l = i.length - 1; l >= 0; --l) {
      const c = i[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        a.push(...this._animateOptions(t, r));
        continue;
      }
      const u = r[c];
      let d = s[c];
      const f = n.get(c);
      if (d)
        if (f && d.active()) {
          d.update(f, u, o);
          continue;
        } else
          d.cancel();
      if (!f || !f.duration) {
        t[c] = u;
        continue;
      }
      s[c] = d = new dje(f, t, c, u), a.push(d);
    }
    return a;
  }
  update(t, r) {
    if (this._properties.size === 0) {
      Object.assign(t, r);
      return;
    }
    const n = this._createAnimations(t, r);
    if (n.length)
      return ml.add(this._chart, n), !0;
  }
}
function fje(e, t) {
  const r = [], n = Object.keys(t);
  for (let a = 0; a < n.length; a++) {
    const s = e[n[a]];
    s && s.active() && r.push(s.wait());
  }
  return Promise.all(r);
}
function hje(e, t) {
  if (!t)
    return;
  let r = e.options;
  if (!r) {
    e.options = t;
    return;
  }
  return r.$shared && (e.options = r = Object.assign({}, r, {
    $shared: !1,
    $animations: {}
  })), r;
}
function hM(e, t) {
  const r = e && e.options || {}, n = r.reverse, a = r.min === void 0 ? t : 0, s = r.max === void 0 ? t : 0;
  return {
    start: n ? s : a,
    end: n ? a : s
  };
}
function pje(e, t, r) {
  if (r === !1)
    return !1;
  const n = hM(e, r), a = hM(t, r);
  return {
    top: a.end,
    right: n.end,
    bottom: a.start,
    left: n.start
  };
}
function mje(e) {
  let t, r, n, a;
  return wr(e) ? (t = e.top, r = e.right, n = e.bottom, a = e.left) : t = r = n = a = e, {
    top: t,
    right: r,
    bottom: n,
    left: a,
    disabled: e === !1
  };
}
function NV(e, t) {
  const r = [], n = e._getSortedDatasetMetas(t);
  let a, s;
  for (a = 0, s = n.length; a < s; ++a)
    r.push(n[a].index);
  return r;
}
function pM(e, t, r, n = {}) {
  const a = e.keys, s = n.mode === "single";
  let i, o, l, c;
  if (t === null)
    return;
  let u = !1;
  for (i = 0, o = a.length; i < o; ++i) {
    if (l = +a[i], l === r) {
      if (u = !0, n.all)
        continue;
      break;
    }
    c = e.values[l], Ja(c) && (s || t === 0 || No(t) === No(c)) && (t += c);
  }
  return !u && !n.all ? 0 : t;
}
function gje(e, t) {
  const { iScale: r, vScale: n } = t, a = r.axis === "x" ? "x" : "y", s = n.axis === "x" ? "x" : "y", i = Object.keys(e), o = new Array(i.length);
  let l, c, u;
  for (l = 0, c = i.length; l < c; ++l)
    u = i[l], o[l] = {
      [a]: u,
      [s]: e[u]
    };
  return o;
}
function G_(e, t) {
  const r = e && e.options.stacked;
  return r || r === void 0 && t.stack !== void 0;
}
function vje(e, t, r) {
  return `${e.id}.${t.id}.${r.stack || r.type}`;
}
function yje(e) {
  const { min: t, max: r, minDefined: n, maxDefined: a } = e.getUserBounds();
  return {
    min: n ? t : Number.NEGATIVE_INFINITY,
    max: a ? r : Number.POSITIVE_INFINITY
  };
}
function bje(e, t, r) {
  const n = e[t] || (e[t] = {});
  return n[r] || (n[r] = {});
}
function mM(e, t, r, n) {
  for (const a of t.getMatchingVisibleMetas(n).reverse()) {
    const s = e[a.index];
    if (r && s > 0 || !r && s < 0)
      return a.index;
  }
  return null;
}
function gM(e, t) {
  const { chart: r, _cachedMeta: n } = e, a = r._stacks || (r._stacks = {}), { iScale: s, vScale: i, index: o } = n, l = s.axis, c = i.axis, u = vje(s, i, n), d = t.length;
  let f;
  for (let h = 0; h < d; ++h) {
    const p = t[h], { [l]: m, [c]: g } = p, y = p._stacks || (p._stacks = {});
    f = y[c] = bje(a, u, m), f[o] = g, f._top = mM(f, i, !0, n.type), f._bottom = mM(f, i, !1, n.type);
    const x = f._visualValues || (f._visualValues = {});
    x[o] = g;
  }
}
function Y_(e, t) {
  const r = e.scales;
  return Object.keys(r).filter((n) => r[n].axis === t).shift();
}
function wje(e, t) {
  return pd(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function xje(e, t, r) {
  return pd(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: r,
    index: t,
    mode: "default",
    type: "data"
  });
}
function Tp(e, t) {
  const r = e.controller.index, n = e.vScale && e.vScale.axis;
  if (n) {
    t = t || e._parsed;
    for (const a of t) {
      const s = a._stacks;
      if (!s || s[n] === void 0 || s[n][r] === void 0)
        return;
      delete s[n][r], s[n]._visualValues !== void 0 && s[n]._visualValues[r] !== void 0 && delete s[n]._visualValues[r];
    }
  }
}
const X_ = (e) => e === "reset" || e === "none", vM = (e, t) => t ? e : Object.assign({}, e), _je = (e, t, r) => e && !t.hidden && t._stacked && {
  keys: NV(r, !0),
  values: null
};
class Lu {
  constructor(t, r) {
    this.chart = t, this._ctx = t.ctx, this.index = r, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = G_(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && Tp(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, r = this._cachedMeta, n = this.getDataset(), a = (d, f, h, p) => d === "x" ? f : d === "r" ? p : h, s = r.xAxisID = gr(n.xAxisID, Y_(t, "x")), i = r.yAxisID = gr(n.yAxisID, Y_(t, "y")), o = r.rAxisID = gr(n.rAxisID, Y_(t, "r")), l = r.indexAxis, c = r.iAxisID = a(l, s, i, o), u = r.vAxisID = a(l, i, s, o);
    r.xScale = this.getScaleForId(s), r.yScale = this.getScaleForId(i), r.rScale = this.getScaleForId(o), r.iScale = this.getScaleForId(c), r.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const r = this._cachedMeta;
    return t === r.iScale ? r.vScale : r.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && JN(this._data, this), t._stacked && Tp(t);
  }
  _dataCheck() {
    const t = this.getDataset(), r = t.data || (t.data = []), n = this._data;
    if (wr(r)) {
      const a = this._cachedMeta;
      this._data = gje(r, a);
    } else if (n !== r) {
      if (n) {
        JN(n, this);
        const a = this._cachedMeta;
        Tp(a), a._parsed = [];
      }
      r && Object.isExtensible(r) && sLe(r, this), this._syncList = [], this._data = r;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const r = this._cachedMeta, n = this.getDataset();
    let a = !1;
    this._dataCheck();
    const s = r._stacked;
    r._stacked = G_(r.vScale, r), r.stack !== n.stack && (a = !0, Tp(r), r.stack = n.stack), this._resyncElements(t), (a || s !== r._stacked) && (gM(this, r._parsed), r._stacked = G_(r.vScale, r));
  }
  configure() {
    const t = this.chart.config, r = t.datasetScopeKeys(this._type), n = t.getOptionScopes(this.getDataset(), r, !0);
    this.options = t.createResolver(n, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, r) {
    const { _cachedMeta: n, _data: a } = this, { iScale: s, _stacked: i } = n, o = s.axis;
    let l = t === 0 && r === a.length ? !0 : n._sorted, c = t > 0 && n._parsed[t - 1], u, d, f;
    if (this._parsing === !1)
      n._parsed = a, n._sorted = !0, f = a;
    else {
      Jn(a[t]) ? f = this.parseArrayData(n, a, t, r) : wr(a[t]) ? f = this.parseObjectData(n, a, t, r) : f = this.parsePrimitiveData(n, a, t, r);
      const h = () => d[o] === null || c && d[o] < c[o];
      for (u = 0; u < r; ++u)
        n._parsed[u + t] = d = f[u], l && (h() && (l = !1), c = d);
      n._sorted = l;
    }
    i && gM(this, f);
  }
  parsePrimitiveData(t, r, n, a) {
    const { iScale: s, vScale: i } = t, o = s.axis, l = i.axis, c = s.getLabels(), u = s === i, d = new Array(a);
    let f, h, p;
    for (f = 0, h = a; f < h; ++f)
      p = f + n, d[f] = {
        [o]: u || s.parse(c[p], p),
        [l]: i.parse(r[p], p)
      };
    return d;
  }
  parseArrayData(t, r, n, a) {
    const { xScale: s, yScale: i } = t, o = new Array(a);
    let l, c, u, d;
    for (l = 0, c = a; l < c; ++l)
      u = l + n, d = r[u], o[l] = {
        x: s.parse(d[0], u),
        y: i.parse(d[1], u)
      };
    return o;
  }
  parseObjectData(t, r, n, a) {
    const { xScale: s, yScale: i } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(a);
    let u, d, f, h;
    for (u = 0, d = a; u < d; ++u)
      f = u + n, h = r[f], c[u] = {
        x: s.parse(Ku(h, o), f),
        y: i.parse(Ku(h, l), f)
      };
    return c;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, r, n) {
    const a = this.chart, s = this._cachedMeta, i = r[t.axis], o = {
      keys: NV(a, !0),
      values: r._stacks[t.axis]._visualValues
    };
    return pM(o, i, s.index, {
      mode: n
    });
  }
  updateRangeFromParsed(t, r, n, a) {
    const s = n[r.axis];
    let i = s === null ? NaN : s;
    const o = a && n._stacks[r.axis];
    a && o && (a.values = o, i = pM(a, s, this._cachedMeta.index)), t.min = Math.min(t.min, i), t.max = Math.max(t.max, i);
  }
  getMinMax(t, r) {
    const n = this._cachedMeta, a = n._parsed, s = n._sorted && t === n.iScale, i = a.length, o = this._getOtherScale(t), l = _je(r, n, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: d } = yje(o);
    let f, h;
    function p() {
      h = a[f];
      const m = h[o.axis];
      return !Ja(h[t.axis]) || u > m || d < m;
    }
    for (f = 0; f < i && !(!p() && (this.updateRangeFromParsed(c, t, h, l), s)); ++f)
      ;
    if (s) {
      for (f = i - 1; f >= 0; --f)
        if (!p()) {
          this.updateRangeFromParsed(c, t, h, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(t) {
    const r = this._cachedMeta._parsed, n = [];
    let a, s, i;
    for (a = 0, s = r.length; a < s; ++a)
      i = r[a][t.axis], Ja(i) && n.push(i);
    return n;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const r = this._cachedMeta, n = r.iScale, a = r.vScale, s = this.getParsed(t);
    return {
      label: n ? "" + n.getLabelForValue(s[n.axis]) : "",
      value: a ? "" + a.getLabelForValue(s[a.axis]) : ""
    };
  }
  _update(t) {
    const r = this._cachedMeta;
    this.update(t || "default"), r._clip = mje(gr(this.options.clip, pje(r.xScale, r.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, r = this.chart, n = this._cachedMeta, a = n.data || [], s = r.chartArea, i = [], o = this._drawStart || 0, l = this._drawCount || a.length - o, c = this.options.drawActiveElementsOnTop;
    let u;
    for (n.dataset && n.dataset.draw(t, s, o, l), u = o; u < o + l; ++u) {
      const d = a[u];
      d.hidden || (d.active && c ? i.push(d) : d.draw(t, s));
    }
    for (u = 0; u < i.length; ++u)
      i[u].draw(t, s);
  }
  getStyle(t, r) {
    const n = r ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(n) : this.resolveDataElementOptions(t || 0, n);
  }
  getContext(t, r, n) {
    const a = this.getDataset();
    let s;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const i = this._cachedMeta.data[t];
      s = i.$context || (i.$context = xje(this.getContext(), t, i)), s.parsed = this.getParsed(t), s.raw = a.data[t], s.index = s.dataIndex = t;
    } else
      s = this.$context || (this.$context = wje(this.chart.getContext(), this.index)), s.dataset = a, s.index = s.datasetIndex = this.index;
    return s.active = !!r, s.mode = n, s;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, r) {
    return this._resolveElementOptions(this.dataElementType.id, r, t);
  }
  _resolveElementOptions(t, r = "default", n) {
    const a = r === "active", s = this._cachedDataOpts, i = t + "-" + r, o = s[i], l = this.enableOptionSharing && sg(n);
    if (o)
      return vM(o, l);
    const c = this.chart.config, u = c.datasetElementScopeKeys(this._type, t), d = a ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], f = c.getOptionScopes(this.getDataset(), u), h = Object.keys(Wn.elements[t]), p = () => this.getContext(n, a, r), m = c.resolveNamedOptions(f, h, p, d);
    return m.$shared && (m.$shared = l, s[i] = Object.freeze(vM(m, l))), m;
  }
  _resolveAnimations(t, r, n) {
    const a = this.chart, s = this._cachedDataOpts, i = `animation-${r}`, o = s[i];
    if (o)
      return o;
    let l;
    if (a.options.animation !== !1) {
      const u = this.chart.config, d = u.datasetAnimationScopeKeys(this._type, r), f = u.getOptionScopes(this.getDataset(), d);
      l = u.createResolver(f, this.getContext(t, n, r));
    }
    const c = new DV(a, l && l.animations);
    return l && l._cacheable && (s[i] = Object.freeze(c)), c;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, r) {
    return !r || X_(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, r) {
    const n = this.resolveDataElementOptions(t, r), a = this._sharedOptions, s = this.getSharedOptions(n), i = this.includeOptions(r, s) || s !== a;
    return this.updateSharedOptions(s, r, n), {
      sharedOptions: s,
      includeOptions: i
    };
  }
  updateElement(t, r, n, a) {
    X_(a) ? Object.assign(t, n) : this._resolveAnimations(r, a).update(t, n);
  }
  updateSharedOptions(t, r, n) {
    t && !X_(r) && this._resolveAnimations(void 0, r).update(t, n);
  }
  _setStyle(t, r, n, a) {
    t.active = a;
    const s = this.getStyle(r, a);
    this._resolveAnimations(r, n, a).update(t, {
      options: !a && this.getSharedOptions(s) || s
    });
  }
  removeHoverStyle(t, r, n) {
    this._setStyle(t, n, "active", !1);
  }
  setHoverStyle(t, r, n) {
    this._setStyle(t, n, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const r = this._data, n = this._cachedMeta.data;
    for (const [o, l, c] of this._syncList)
      this[o](l, c);
    this._syncList = [];
    const a = n.length, s = r.length, i = Math.min(s, a);
    i && this.parse(0, i), s > a ? this._insertElements(a, s - a, t) : s < a && this._removeElements(s, a - s);
  }
  _insertElements(t, r, n = !0) {
    const a = this._cachedMeta, s = a.data, i = t + r;
    let o;
    const l = (c) => {
      for (c.length += r, o = c.length - 1; o >= i; o--)
        c[o] = c[o - r];
    };
    for (l(s), o = t; o < i; ++o)
      s[o] = new this.dataElementType();
    this._parsing && l(a._parsed), this.parse(t, r), n && this.updateElements(s, t, r, "reset");
  }
  updateElements(t, r, n, a) {
  }
  _removeElements(t, r) {
    const n = this._cachedMeta;
    if (this._parsing) {
      const a = n._parsed.splice(t, r);
      n._stacked && Tp(n, a);
    }
    n.data.splice(t, r);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [r, n, a] = t;
      this[r](n, a);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, r) {
    r && this._sync([
      "_removeElements",
      t,
      r
    ]);
    const n = arguments.length - 2;
    n && this._sync([
      "_insertElements",
      t,
      n
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
Fe(Lu, "defaults", {}), Fe(Lu, "datasetElementType", null), Fe(Lu, "dataElementType", null);
function Sje(e, t) {
  if (!e._cache.$bar) {
    const r = e.getMatchingVisibleMetas(t);
    let n = [];
    for (let a = 0, s = r.length; a < s; a++)
      n = n.concat(r[a].controller.getAllParsedValues(e));
    e._cache.$bar = vV(n.sort((a, s) => a - s));
  }
  return e._cache.$bar;
}
function Eje(e) {
  const t = e.iScale, r = Sje(t, e.type);
  let n = t._length, a, s, i, o;
  const l = () => {
    i === 32767 || i === -32768 || (sg(o) && (n = Math.min(n, Math.abs(i - o) || n)), o = i);
  };
  for (a = 0, s = r.length; a < s; ++a)
    i = t.getPixelForValue(r[a]), l();
  for (o = void 0, a = 0, s = t.ticks.length; a < s; ++a)
    i = t.getPixelForTick(a), l();
  return n;
}
function Tje(e, t, r, n) {
  const a = r.barThickness;
  let s, i;
  return Vr(a) ? (s = t.min * r.categoryPercentage, i = r.barPercentage) : (s = a * n, i = 1), {
    chunk: s / n,
    ratio: i,
    start: t.pixels[e] - s / 2
  };
}
function Cje(e, t, r, n) {
  const a = t.pixels, s = a[e];
  let i = e > 0 ? a[e - 1] : null, o = e < a.length - 1 ? a[e + 1] : null;
  const l = r.categoryPercentage;
  i === null && (i = s - (o === null ? t.end - t.start : o - s)), o === null && (o = s + s - i);
  const c = s - (s - Math.min(i, o)) / 2 * l;
  return {
    chunk: Math.abs(o - i) / 2 * l / n,
    ratio: r.barPercentage,
    start: c
  };
}
function kje(e, t, r, n) {
  const a = r.parse(e[0], n), s = r.parse(e[1], n), i = Math.min(a, s), o = Math.max(a, s);
  let l = i, c = o;
  Math.abs(i) > Math.abs(o) && (l = o, c = i), t[r.axis] = c, t._custom = {
    barStart: l,
    barEnd: c,
    start: a,
    end: s,
    min: i,
    max: o
  };
}
function MV(e, t, r, n) {
  return Jn(e) ? kje(e, t, r, n) : t[r.axis] = r.parse(e, n), t;
}
function yM(e, t, r, n) {
  const a = e.iScale, s = e.vScale, i = a.getLabels(), o = a === s, l = [];
  let c, u, d, f;
  for (c = r, u = r + n; c < u; ++c)
    f = t[c], d = {}, d[a.axis] = o || a.parse(i[c], c), l.push(MV(f, d, s, c));
  return l;
}
function Q_(e) {
  return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
function Oje(e, t, r) {
  return e !== 0 ? No(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= r ? 1 : -1);
}
function Aje(e) {
  let t, r, n, a, s;
  return e.horizontal ? (t = e.base > e.x, r = "left", n = "right") : (t = e.base < e.y, r = "bottom", n = "top"), t ? (a = "end", s = "start") : (a = "start", s = "end"), {
    start: r,
    end: n,
    reverse: t,
    top: a,
    bottom: s
  };
}
function Pje(e, t, r, n) {
  let a = t.borderSkipped;
  const s = {};
  if (!a) {
    e.borderSkipped = s;
    return;
  }
  if (a === !0) {
    e.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: i, end: o, reverse: l, top: c, bottom: u } = Aje(e);
  a === "middle" && r && (e.enableBorderRadius = !0, (r._top || 0) === n ? a = c : (r._bottom || 0) === n ? a = u : (s[bM(u, i, o, l)] = !0, a = c)), s[bM(a, i, o, l)] = !0, e.borderSkipped = s;
}
function bM(e, t, r, n) {
  return n ? (e = Rje(e, t, r), e = wM(e, r, t)) : e = wM(e, t, r), e;
}
function Rje(e, t, r) {
  return e === t ? r : e === r ? t : e;
}
function wM(e, t, r) {
  return e === "start" ? t : e === "end" ? r : e;
}
function Ije(e, { inflateAmount: t }, r) {
  e.inflateAmount = t === "auto" ? r === 1 ? 0.33 : 0 : t;
}
class Oy extends Lu {
  parsePrimitiveData(t, r, n, a) {
    return yM(t, r, n, a);
  }
  parseArrayData(t, r, n, a) {
    return yM(t, r, n, a);
  }
  parseObjectData(t, r, n, a) {
    const { iScale: s, vScale: i } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = s.axis === "x" ? o : l, u = i.axis === "x" ? o : l, d = [];
    let f, h, p, m;
    for (f = n, h = n + a; f < h; ++f)
      m = r[f], p = {}, p[s.axis] = s.parse(Ku(m, c), f), d.push(MV(Ku(m, u), p, i, f));
    return d;
  }
  updateRangeFromParsed(t, r, n, a) {
    super.updateRangeFromParsed(t, r, n, a);
    const s = n._custom;
    s && r === this._cachedMeta.vScale && (t.min = Math.min(t.min, s.min), t.max = Math.max(t.max, s.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const r = this._cachedMeta, { iScale: n, vScale: a } = r, s = this.getParsed(t), i = s._custom, o = Q_(i) ? "[" + i.start + ", " + i.end + "]" : "" + a.getLabelForValue(s[a.axis]);
    return {
      label: "" + n.getLabelForValue(s[n.axis]),
      value: o
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const r = this._cachedMeta;
    this.updateElements(r.data, 0, r.data.length, t);
  }
  updateElements(t, r, n, a) {
    const s = a === "reset", { index: i, _cachedMeta: { vScale: o } } = this, l = o.getBasePixel(), c = o.isHorizontal(), u = this._getRuler(), { sharedOptions: d, includeOptions: f } = this._getSharedOptions(r, a);
    for (let h = r; h < r + n; h++) {
      const p = this.getParsed(h), m = s || Vr(p[o.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(h), g = this._calculateBarIndexPixels(h, u), y = (p._stacks || {})[o.axis], x = {
        horizontal: c,
        base: m.base,
        enableBorderRadius: !y || Q_(p._custom) || i === y._top || i === y._bottom,
        x: c ? m.head : g.center,
        y: c ? g.center : m.head,
        height: c ? g.size : Math.abs(m.size),
        width: c ? Math.abs(m.size) : g.size
      };
      f && (x.options = d || this.resolveDataElementOptions(h, t[h].active ? "active" : a));
      const w = x.options || t[h].options;
      Pje(x, w, y, i), Ije(x, w, u.ratio), this.updateElement(t[h], h, x, a);
    }
  }
  _getStacks(t, r) {
    const { iScale: n } = this._cachedMeta, a = n.getMatchingVisibleMetas(this._type).filter((u) => u.controller.options.grouped), s = n.options.stacked, i = [], o = this._cachedMeta.controller.getParsed(r), l = o && o[n.axis], c = (u) => {
      const d = u._parsed.find((h) => h[n.axis] === l), f = d && d[u.vScale.axis];
      if (Vr(f) || isNaN(f))
        return !0;
    };
    for (const u of a)
      if (!(r !== void 0 && c(u)) && ((s === !1 || i.indexOf(u.stack) === -1 || s === void 0 && u.stack === void 0) && i.push(u.stack), u.index === t))
        break;
    return i.length || i.push(void 0), i;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, r, n) {
    const a = this._getStacks(t, n), s = r !== void 0 ? a.indexOf(r) : -1;
    return s === -1 ? a.length - 1 : s;
  }
  _getRuler() {
    const t = this.options, r = this._cachedMeta, n = r.iScale, a = [];
    let s, i;
    for (s = 0, i = r.data.length; s < i; ++s)
      a.push(n.getPixelForValue(this.getParsed(s)[n.axis], s));
    const o = t.barThickness;
    return {
      min: o || Eje(r),
      pixels: a,
      start: n._startPixel,
      end: n._endPixel,
      stackCount: this._getStackCount(),
      scale: n,
      grouped: t.grouped,
      ratio: o ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: r, _stacked: n, index: a }, options: { base: s, minBarLength: i } } = this, o = s || 0, l = this.getParsed(t), c = l._custom, u = Q_(c);
    let d = l[r.axis], f = 0, h = n ? this.applyStack(r, l, n) : d, p, m;
    h !== d && (f = h - d, h = d), u && (d = c.barStart, h = c.barEnd - c.barStart, d !== 0 && No(d) !== No(c.barEnd) && (f = 0), f += d);
    const g = !Vr(s) && !u ? s : f;
    let y = r.getPixelForValue(g);
    if (this.chart.getDataVisibility(t) ? p = r.getPixelForValue(f + h) : p = y, m = p - y, Math.abs(m) < i) {
      m = Oje(m, r, o) * i, d === o && (y -= m / 2);
      const x = r.getPixelForDecimal(0), w = r.getPixelForDecimal(1), _ = Math.min(x, w), S = Math.max(x, w);
      y = Math.max(Math.min(y, S), _), p = y + m, n && !u && (l._stacks[r.axis]._visualValues[a] = r.getValueForPixel(p) - r.getValueForPixel(y));
    }
    if (y === r.getPixelForValue(o)) {
      const x = No(m) * r.getLineWidthForValue(o) / 2;
      y += x, m -= x;
    }
    return {
      size: m,
      base: y,
      head: p,
      center: p + m / 2
    };
  }
  _calculateBarIndexPixels(t, r) {
    const n = r.scale, a = this.options, s = a.skipNull, i = gr(a.maxBarThickness, 1 / 0);
    let o, l;
    if (r.grouped) {
      const c = s ? this._getStackCount(t) : r.stackCount, u = a.barThickness === "flex" ? Cje(t, r, a, c) : Tje(t, r, a, c), d = this._getStackIndex(this.index, this._cachedMeta.stack, s ? t : void 0);
      o = u.start + u.chunk * d + u.chunk / 2, l = Math.min(i, u.chunk * u.ratio);
    } else
      o = n.getPixelForValue(this.getParsed(t)[n.axis], t), l = Math.min(i, r.min * r.ratio);
    return {
      base: o - l / 2,
      head: o + l / 2,
      center: o,
      size: l
    };
  }
  draw() {
    const t = this._cachedMeta, r = t.vScale, n = t.data, a = n.length;
    let s = 0;
    for (; s < a; ++s)
      this.getParsed(s)[r.axis] !== null && !n[s].hidden && n[s].draw(this._ctx);
  }
}
Fe(Oy, "id", "bar"), Fe(Oy, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), Fe(Oy, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
function Dje(e, t, r) {
  let n = 1, a = 1, s = 0, i = 0;
  if (t < En) {
    const o = e, l = o + t, c = Math.cos(o), u = Math.sin(o), d = Math.cos(l), f = Math.sin(l), h = (w, _, S) => og(w, o, l, !0) ? 1 : Math.max(_, _ * r, S, S * r), p = (w, _, S) => og(w, o, l, !0) ? -1 : Math.min(_, _ * r, S, S * r), m = h(0, c, d), g = h(oa, u, f), y = p(Pn, c, d), x = p(Pn + oa, u, f);
    n = (m - y) / 2, a = (g - x) / 2, s = -(m + y) / 2, i = -(g + x) / 2;
  }
  return {
    ratioX: n,
    ratioY: a,
    offsetX: s,
    offsetY: i
  };
}
class rm extends Lu {
  constructor(t, r) {
    super(t, r), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, r) {
    const n = this.getDataset().data, a = this._cachedMeta;
    if (this._parsing === !1)
      a._parsed = n;
    else {
      let s = (l) => +n[l];
      if (wr(n[t])) {
        const { key: l = "value" } = this._parsing;
        s = (c) => +Ku(n[c], l);
      }
      let i, o;
      for (i = t, o = t + r; i < o; ++i)
        a._parsed[i] = s(i);
    }
  }
  _getRotation() {
    return El(this.options.rotation - 90);
  }
  _getCircumference() {
    return El(this.options.circumference);
  }
  _getRotationExtents() {
    let t = En, r = -En;
    for (let n = 0; n < this.chart.data.datasets.length; ++n)
      if (this.chart.isDatasetVisible(n) && this.chart.getDatasetMeta(n).type === this._type) {
        const a = this.chart.getDatasetMeta(n).controller, s = a._getRotation(), i = a._getCircumference();
        t = Math.min(t, s), r = Math.max(r, s + i);
      }
    return {
      rotation: t,
      circumference: r - t
    };
  }
  update(t) {
    const r = this.chart, { chartArea: n } = r, a = this._cachedMeta, s = a.data, i = this.getMaxBorderWidth() + this.getMaxOffset(s) + this.options.spacing, o = Math.max((Math.min(n.width, n.height) - i) / 2, 0), l = Math.min($Me(this.options.cutout, o), 1), c = this._getRingWeight(this.index), { circumference: u, rotation: d } = this._getRotationExtents(), { ratioX: f, ratioY: h, offsetX: p, offsetY: m } = Dje(d, u, l), g = (n.width - i) / f, y = (n.height - i) / h, x = Math.max(Math.min(g, y) / 2, 0), w = fV(this.options.radius, x), _ = Math.max(w * l, 0), S = (w - _) / this._getVisibleDatasetWeightTotal();
    this.offsetX = p * w, this.offsetY = m * w, a.total = this.calculateTotal(), this.outerRadius = w - S * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - S * c, 0), this.updateElements(s, 0, s.length, t);
  }
  _circumference(t, r) {
    const n = this.options, a = this._cachedMeta, s = this._getCircumference();
    return r && n.animation.animateRotate || !this.chart.getDataVisibility(t) || a._parsed[t] === null || a.data[t].hidden ? 0 : this.calculateCircumference(a._parsed[t] * s / En);
  }
  updateElements(t, r, n, a) {
    const s = a === "reset", i = this.chart, o = i.chartArea, c = i.options.animation, u = (o.left + o.right) / 2, d = (o.top + o.bottom) / 2, f = s && c.animateScale, h = f ? 0 : this.innerRadius, p = f ? 0 : this.outerRadius, { sharedOptions: m, includeOptions: g } = this._getSharedOptions(r, a);
    let y = this._getRotation(), x;
    for (x = 0; x < r; ++x)
      y += this._circumference(x, s);
    for (x = r; x < r + n; ++x) {
      const w = this._circumference(x, s), _ = t[x], S = {
        x: u + this.offsetX,
        y: d + this.offsetY,
        startAngle: y,
        endAngle: y + w,
        circumference: w,
        outerRadius: p,
        innerRadius: h
      };
      g && (S.options = m || this.resolveDataElementOptions(x, _.active ? "active" : a)), y += w, this.updateElement(_, x, S, a);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, r = t.data;
    let n = 0, a;
    for (a = 0; a < r.length; a++) {
      const s = t._parsed[a];
      s !== null && !isNaN(s) && this.chart.getDataVisibility(a) && !r[a].hidden && (n += Math.abs(s));
    }
    return n;
  }
  calculateCircumference(t) {
    const r = this._cachedMeta.total;
    return r > 0 && !isNaN(t) ? En * (Math.abs(t) / r) : 0;
  }
  getLabelAndValue(t) {
    const r = this._cachedMeta, n = this.chart, a = n.data.labels || [], s = jk(r._parsed[t], n.options.locale);
    return {
      label: a[t] || "",
      value: s
    };
  }
  getMaxBorderWidth(t) {
    let r = 0;
    const n = this.chart;
    let a, s, i, o, l;
    if (!t) {
      for (a = 0, s = n.data.datasets.length; a < s; ++a)
        if (n.isDatasetVisible(a)) {
          i = n.getDatasetMeta(a), t = i.data, o = i.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (a = 0, s = t.length; a < s; ++a)
      l = o.resolveDataElementOptions(a), l.borderAlign !== "inner" && (r = Math.max(r, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return r;
  }
  getMaxOffset(t) {
    let r = 0;
    for (let n = 0, a = t.length; n < a; ++n) {
      const s = this.resolveDataElementOptions(n);
      r = Math.max(r, s.offset || 0, s.hoverOffset || 0);
    }
    return r;
  }
  _getRingWeightOffset(t) {
    let r = 0;
    for (let n = 0; n < t; ++n)
      this.chart.isDatasetVisible(n) && (r += this._getRingWeight(n));
    return r;
  }
  _getRingWeight(t) {
    return Math.max(gr(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
Fe(rm, "id", "doughnut"), Fe(rm, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), Fe(rm, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), Fe(rm, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const r = t.data;
          if (r.labels.length && r.datasets.length) {
            const { labels: { pointStyle: n, color: a } } = t.legend.options;
            return r.labels.map((s, i) => {
              const l = t.getDatasetMeta(0).controller.getStyle(i);
              return {
                text: s,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: a,
                lineWidth: l.borderWidth,
                pointStyle: n,
                hidden: !t.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(t, r, n) {
        n.chart.toggleDataVisibility(r.index), n.chart.update();
      }
    }
  }
});
class Ay extends Lu {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const r = this._cachedMeta, { dataset: n, data: a = [], _dataset: s } = r, i = this.chart._animationsDisabled;
    let { start: o, count: l } = lLe(r, a, i);
    this._drawStart = o, this._drawCount = l, cLe(r) && (o = 0, l = a.length), n._chart = this.chart, n._datasetIndex = this.index, n._decimated = !!s._decimated, n.points = a;
    const c = this.resolveDatasetElementOptions(t);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(n, void 0, {
      animated: !i,
      options: c
    }, t), this.updateElements(a, o, l, t);
  }
  updateElements(t, r, n, a) {
    const s = a === "reset", { iScale: i, vScale: o, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: u, includeOptions: d } = this._getSharedOptions(r, a), f = i.axis, h = o.axis, { spanGaps: p, segment: m } = this.options, g = ig(p) ? p : Number.POSITIVE_INFINITY, y = this.chart._animationsDisabled || s || a === "none", x = r + n, w = t.length;
    let _ = r > 0 && this.getParsed(r - 1);
    for (let S = 0; S < w; ++S) {
      const C = t[S], E = y ? C : {};
      if (S < r || S >= x) {
        E.skip = !0;
        continue;
      }
      const O = this.getParsed(S), k = Vr(O[h]), A = E[f] = i.getPixelForValue(O[f], S), P = E[h] = s || k ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, O, l) : O[h], S);
      E.skip = isNaN(A) || isNaN(P) || k, E.stop = S > 0 && Math.abs(O[f] - _[f]) > g, m && (E.parsed = O, E.raw = c.data[S]), d && (E.options = u || this.resolveDataElementOptions(S, C.active ? "active" : a)), y || this.updateElement(C, S, E, a), _ = O;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, r = t.dataset, n = r.options && r.options.borderWidth || 0, a = t.data || [];
    if (!a.length)
      return n;
    const s = a[0].size(this.resolveDataElementOptions(0)), i = a[a.length - 1].size(this.resolveDataElementOptions(a.length - 1));
    return Math.max(n, s, i) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
Fe(Ay, "id", "line"), Fe(Ay, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), Fe(Ay, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
function ou() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Wk {
  constructor(t) {
    Fe(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(Wk.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return ou();
  }
  parse() {
    return ou();
  }
  format() {
    return ou();
  }
  add() {
    return ou();
  }
  diff() {
    return ou();
  }
  startOf() {
    return ou();
  }
  endOf() {
    return ou();
  }
}
var Nje = {
  _date: Wk
};
function Mje(e, t, r, n) {
  const { controller: a, data: s, _sorted: i } = e, o = a._cachedMeta.iScale, l = e.dataset && e.dataset.options ? e.dataset.options.spanGaps : null;
  if (o && t === o.axis && t !== "r" && i && s.length) {
    const c = o._reversePixels ? nLe : Cu;
    if (n) {
      if (a._sharedOptions) {
        const u = s[0], d = typeof u.getRange == "function" && u.getRange(t);
        if (d) {
          const f = c(s, t, r - d), h = c(s, t, r + d);
          return {
            lo: f.lo,
            hi: h.hi
          };
        }
      }
    } else {
      const u = c(s, t, r);
      if (l) {
        const { vScale: d } = a._cachedMeta, { _parsed: f } = e, h = f.slice(0, u.lo + 1).reverse().findIndex((m) => !Vr(m[d.axis]));
        u.lo -= Math.max(0, h);
        const p = f.slice(u.hi).findIndex((m) => !Vr(m[d.axis]));
        u.hi += Math.max(0, p);
      }
      return u;
    }
  }
  return {
    lo: 0,
    hi: s.length - 1
  };
}
function bx(e, t, r, n, a) {
  const s = e.getSortedVisibleDatasetMetas(), i = r[t];
  for (let o = 0, l = s.length; o < l; ++o) {
    const { index: c, data: u } = s[o], { lo: d, hi: f } = Mje(s[o], t, i, a);
    for (let h = d; h <= f; ++h) {
      const p = u[h];
      p.skip || n(p, c, h);
    }
  }
}
function Lje(e) {
  const t = e.indexOf("x") !== -1, r = e.indexOf("y") !== -1;
  return function(n, a) {
    const s = t ? Math.abs(n.x - a.x) : 0, i = r ? Math.abs(n.y - a.y) : 0;
    return Math.sqrt(Math.pow(s, 2) + Math.pow(i, 2));
  };
}
function J_(e, t, r, n, a) {
  const s = [];
  return !a && !e.isPointInArea(t) || bx(e, r, t, function(o, l, c) {
    !a && !lg(o, e.chartArea, 0) || o.inRange(t.x, t.y, n) && s.push({
      element: o,
      datasetIndex: l,
      index: c
    });
  }, !0), s;
}
function jje(e, t, r, n) {
  let a = [];
  function s(i, o, l) {
    const { startAngle: c, endAngle: u } = i.getProps([
      "startAngle",
      "endAngle"
    ], n), { angle: d } = mV(i, {
      x: t.x,
      y: t.y
    });
    og(d, c, u) && a.push({
      element: i,
      datasetIndex: o,
      index: l
    });
  }
  return bx(e, r, t, s), a;
}
function Fje(e, t, r, n, a, s) {
  let i = [];
  const o = Lje(r);
  let l = Number.POSITIVE_INFINITY;
  function c(u, d, f) {
    const h = u.inRange(t.x, t.y, a);
    if (n && !h)
      return;
    const p = u.getCenterPoint(a);
    if (!(!!s || e.isPointInArea(p)) && !h)
      return;
    const g = o(t, p);
    g < l ? (i = [
      {
        element: u,
        datasetIndex: d,
        index: f
      }
    ], l = g) : g === l && i.push({
      element: u,
      datasetIndex: d,
      index: f
    });
  }
  return bx(e, r, t, c), i;
}
function Z_(e, t, r, n, a, s) {
  return !s && !e.isPointInArea(t) ? [] : r === "r" && !n ? jje(e, t, r, a) : Fje(e, t, r, n, a, s);
}
function xM(e, t, r, n, a) {
  const s = [], i = r === "x" ? "inXRange" : "inYRange";
  let o = !1;
  return bx(e, r, t, (l, c, u) => {
    l[i] && l[i](t[r], a) && (s.push({
      element: l,
      datasetIndex: c,
      index: u
    }), o = o || l.inRange(t.x, t.y, a));
  }), n && !o ? [] : s;
}
var Bje = {
  modes: {
    index(e, t, r, n) {
      const a = pu(t, e), s = r.axis || "x", i = r.includeInvisible || !1, o = r.intersect ? J_(e, a, s, n, i) : Z_(e, a, s, !1, n, i), l = [];
      return o.length ? (e.getSortedVisibleDatasetMetas().forEach((c) => {
        const u = o[0].index, d = c.data[u];
        d && !d.skip && l.push({
          element: d,
          datasetIndex: c.index,
          index: u
        });
      }), l) : [];
    },
    dataset(e, t, r, n) {
      const a = pu(t, e), s = r.axis || "xy", i = r.includeInvisible || !1;
      let o = r.intersect ? J_(e, a, s, n, i) : Z_(e, a, s, !1, n, i);
      if (o.length > 0) {
        const l = o[0].datasetIndex, c = e.getDatasetMeta(l).data;
        o = [];
        for (let u = 0; u < c.length; ++u)
          o.push({
            element: c[u],
            datasetIndex: l,
            index: u
          });
      }
      return o;
    },
    point(e, t, r, n) {
      const a = pu(t, e), s = r.axis || "xy", i = r.includeInvisible || !1;
      return J_(e, a, s, n, i);
    },
    nearest(e, t, r, n) {
      const a = pu(t, e), s = r.axis || "xy", i = r.includeInvisible || !1;
      return Z_(e, a, s, r.intersect, n, i);
    },
    x(e, t, r, n) {
      const a = pu(t, e);
      return xM(e, a, "x", r.intersect, n);
    },
    y(e, t, r, n) {
      const a = pu(t, e);
      return xM(e, a, "y", r.intersect, n);
    }
  }
};
const LV = [
  "left",
  "top",
  "right",
  "bottom"
];
function Cp(e, t) {
  return e.filter((r) => r.pos === t);
}
function _M(e, t) {
  return e.filter((r) => LV.indexOf(r.pos) === -1 && r.box.axis === t);
}
function kp(e, t) {
  return e.sort((r, n) => {
    const a = t ? n : r, s = t ? r : n;
    return a.weight === s.weight ? a.index - s.index : a.weight - s.weight;
  });
}
function Uje(e) {
  const t = [];
  let r, n, a, s, i, o;
  for (r = 0, n = (e || []).length; r < n; ++r)
    a = e[r], { position: s, options: { stack: i, stackWeight: o = 1 } } = a, t.push({
      index: r,
      box: a,
      pos: s,
      horizontal: a.isHorizontal(),
      weight: a.weight,
      stack: i && s + i,
      stackWeight: o
    });
  return t;
}
function Vje(e) {
  const t = {};
  for (const r of e) {
    const { stack: n, pos: a, stackWeight: s } = r;
    if (!n || !LV.includes(a))
      continue;
    const i = t[n] || (t[n] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    i.count++, i.weight += s;
  }
  return t;
}
function $je(e, t) {
  const r = Vje(e), { vBoxMaxWidth: n, hBoxMaxHeight: a } = t;
  let s, i, o;
  for (s = 0, i = e.length; s < i; ++s) {
    o = e[s];
    const { fullSize: l } = o.box, c = r[o.stack], u = c && o.stackWeight / c.weight;
    o.horizontal ? (o.width = u ? u * n : l && t.availableWidth, o.height = a) : (o.width = n, o.height = u ? u * a : l && t.availableHeight);
  }
  return r;
}
function Hje(e) {
  const t = Uje(e), r = kp(t.filter((c) => c.box.fullSize), !0), n = kp(Cp(t, "left"), !0), a = kp(Cp(t, "right")), s = kp(Cp(t, "top"), !0), i = kp(Cp(t, "bottom")), o = _M(t, "x"), l = _M(t, "y");
  return {
    fullSize: r,
    leftAndTop: n.concat(s),
    rightAndBottom: a.concat(l).concat(i).concat(o),
    chartArea: Cp(t, "chartArea"),
    vertical: n.concat(a).concat(l),
    horizontal: s.concat(i).concat(o)
  };
}
function SM(e, t, r, n) {
  return Math.max(e[r], t[r]) + Math.max(e[n], t[n]);
}
function jV(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function Wje(e, t, r, n) {
  const { pos: a, box: s } = r, i = e.maxPadding;
  if (!wr(a)) {
    r.size && (e[a] -= r.size);
    const d = n[r.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, r.horizontal ? s.height : s.width), r.size = d.size / d.count, e[a] += r.size;
  }
  s.getPadding && jV(i, s.getPadding());
  const o = Math.max(0, t.outerWidth - SM(i, e, "left", "right")), l = Math.max(0, t.outerHeight - SM(i, e, "top", "bottom")), c = o !== e.w, u = l !== e.h;
  return e.w = o, e.h = l, r.horizontal ? {
    same: c,
    other: u
  } : {
    same: u,
    other: c
  };
}
function zje(e) {
  const t = e.maxPadding;
  function r(n) {
    const a = Math.max(t[n] - e[n], 0);
    return e[n] += a, a;
  }
  e.y += r("top"), e.x += r("left"), r("right"), r("bottom");
}
function Kje(e, t) {
  const r = t.maxPadding;
  function n(a) {
    const s = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return a.forEach((i) => {
      s[i] = Math.max(t[i], r[i]);
    }), s;
  }
  return n(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function nm(e, t, r, n) {
  const a = [];
  let s, i, o, l, c, u;
  for (s = 0, i = e.length, c = 0; s < i; ++s) {
    o = e[s], l = o.box, l.update(o.width || t.w, o.height || t.h, Kje(o.horizontal, t));
    const { same: d, other: f } = Wje(t, r, o, n);
    c |= d && a.length, u = u || f, l.fullSize || a.push(o);
  }
  return c && nm(a, t, r, n) || u;
}
function L0(e, t, r, n, a) {
  e.top = r, e.left = t, e.right = t + n, e.bottom = r + a, e.width = n, e.height = a;
}
function EM(e, t, r, n) {
  const a = r.padding;
  let { x: s, y: i } = t;
  for (const o of e) {
    const l = o.box, c = n[o.stack] || {
      placed: 0,
      weight: 1
    }, u = o.stackWeight / c.weight || 1;
    if (o.horizontal) {
      const d = t.w * u, f = c.size || l.height;
      sg(c.start) && (i = c.start), l.fullSize ? L0(l, a.left, i, r.outerWidth - a.right - a.left, f) : L0(l, t.left + c.placed, i, d, f), c.start = i, c.placed += d, i = l.bottom;
    } else {
      const d = t.h * u, f = c.size || l.width;
      sg(c.start) && (s = c.start), l.fullSize ? L0(l, s, a.top, f, r.outerHeight - a.bottom - a.top) : L0(l, s, t.top + c.placed, f, d), c.start = s, c.placed += d, s = l.right;
    }
  }
  t.x = s, t.y = i;
}
var li = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(r) {
            t.draw(r);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const r = e.boxes ? e.boxes.indexOf(t) : -1;
    r !== -1 && e.boxes.splice(r, 1);
  },
  configure(e, t, r) {
    t.fullSize = r.fullSize, t.position = r.position, t.weight = r.weight;
  },
  update(e, t, r, n) {
    if (!e)
      return;
    const a = mi(e.options.layout.padding), s = Math.max(t - a.width, 0), i = Math.max(r - a.height, 0), o = Hje(e.boxes), l = o.vertical, c = o.horizontal;
    Gr(e.boxes, (m) => {
      typeof m.beforeLayout == "function" && m.beforeLayout();
    });
    const u = l.reduce((m, g) => g.box.options && g.box.options.display === !1 ? m : m + 1, 0) || 1, d = Object.freeze({
      outerWidth: t,
      outerHeight: r,
      padding: a,
      availableWidth: s,
      availableHeight: i,
      vBoxMaxWidth: s / 2 / u,
      hBoxMaxHeight: i / 2
    }), f = Object.assign({}, a);
    jV(f, mi(n));
    const h = Object.assign({
      maxPadding: f,
      w: s,
      h: i,
      x: a.left,
      y: a.top
    }, a), p = $je(l.concat(c), d);
    nm(o.fullSize, h, d, p), nm(l, h, d, p), nm(c, h, d, p) && nm(l, h, d, p), zje(h), EM(o.leftAndTop, h, d, p), h.x += h.w, h.y += h.h, EM(o.rightAndBottom, h, d, p), e.chartArea = {
      left: h.left,
      top: h.top,
      right: h.left + h.w,
      bottom: h.top + h.h,
      height: h.h,
      width: h.w
    }, Gr(o.chartArea, (m) => {
      const g = m.box;
      Object.assign(g, e.chartArea), g.update(h.w, h.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class FV {
  acquireContext(t, r) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, r, n) {
  }
  removeEventListener(t, r, n) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, r, n, a) {
    return r = Math.max(0, r || t.width), n = n || t.height, {
      width: r,
      height: Math.max(0, a ? Math.floor(r / a) : n)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class qje extends FV {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const Py = "$chartjs", Gje = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, TM = (e) => e === null || e === "";
function Yje(e, t) {
  const r = e.style, n = e.getAttribute("height"), a = e.getAttribute("width");
  if (e[Py] = {
    initial: {
      height: n,
      width: a,
      style: {
        display: r.display,
        height: r.height,
        width: r.width
      }
    }
  }, r.display = r.display || "block", r.boxSizing = r.boxSizing || "border-box", TM(a)) {
    const s = lM(e, "width");
    s !== void 0 && (e.width = s);
  }
  if (TM(n))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const s = lM(e, "height");
      s !== void 0 && (e.height = s);
    }
  return e;
}
const BV = JLe ? {
  passive: !0
} : !1;
function Xje(e, t, r) {
  e && e.addEventListener(t, r, BV);
}
function Qje(e, t, r) {
  e && e.canvas && e.canvas.removeEventListener(t, r, BV);
}
function Jje(e, t) {
  const r = Gje[e.type] || e.type, { x: n, y: a } = pu(e, t);
  return {
    type: r,
    chart: t,
    native: e,
    x: n !== void 0 ? n : null,
    y: a !== void 0 ? a : null
  };
}
function Ib(e, t) {
  for (const r of e)
    if (r === t || r.contains(t))
      return !0;
}
function Zje(e, t, r) {
  const n = e.canvas, a = new MutationObserver((s) => {
    let i = !1;
    for (const o of s)
      i = i || Ib(o.addedNodes, n), i = i && !Ib(o.removedNodes, n);
    i && r();
  });
  return a.observe(document, {
    childList: !0,
    subtree: !0
  }), a;
}
function e4e(e, t, r) {
  const n = e.canvas, a = new MutationObserver((s) => {
    let i = !1;
    for (const o of s)
      i = i || Ib(o.removedNodes, n), i = i && !Ib(o.addedNodes, n);
    i && r();
  });
  return a.observe(document, {
    childList: !0,
    subtree: !0
  }), a;
}
const ug = /* @__PURE__ */ new Map();
let CM = 0;
function UV() {
  const e = window.devicePixelRatio;
  e !== CM && (CM = e, ug.forEach((t, r) => {
    r.currentDevicePixelRatio !== e && t();
  }));
}
function t4e(e, t) {
  ug.size || window.addEventListener("resize", UV), ug.set(e, t);
}
function r4e(e) {
  ug.delete(e), ug.size || window.removeEventListener("resize", UV);
}
function n4e(e, t, r) {
  const n = e.canvas, a = n && Hk(n);
  if (!a)
    return;
  const s = bV((o, l) => {
    const c = a.clientWidth;
    r(o, l), c < a.clientWidth && r();
  }, window), i = new ResizeObserver((o) => {
    const l = o[0], c = l.contentRect.width, u = l.contentRect.height;
    c === 0 && u === 0 || s(c, u);
  });
  return i.observe(a), t4e(e, s), i;
}
function eS(e, t, r) {
  r && r.disconnect(), t === "resize" && r4e(e);
}
function a4e(e, t, r) {
  const n = e.canvas, a = bV((s) => {
    e.ctx !== null && r(Jje(s, e));
  }, e);
  return Xje(n, t, a), a;
}
class s4e extends FV {
  acquireContext(t, r) {
    const n = t && t.getContext && t.getContext("2d");
    return n && n.canvas === t ? (Yje(t, r), n) : null;
  }
  releaseContext(t) {
    const r = t.canvas;
    if (!r[Py])
      return !1;
    const n = r[Py].initial;
    [
      "height",
      "width"
    ].forEach((s) => {
      const i = n[s];
      Vr(i) ? r.removeAttribute(s) : r.setAttribute(s, i);
    });
    const a = n.style || {};
    return Object.keys(a).forEach((s) => {
      r.style[s] = a[s];
    }), r.width = r.width, delete r[Py], !0;
  }
  addEventListener(t, r, n) {
    this.removeEventListener(t, r);
    const a = t.$proxies || (t.$proxies = {}), i = {
      attach: Zje,
      detach: e4e,
      resize: n4e
    }[r] || a4e;
    a[r] = i(t, r, n);
  }
  removeEventListener(t, r) {
    const n = t.$proxies || (t.$proxies = {}), a = n[r];
    if (!a)
      return;
    ({
      attach: eS,
      detach: eS,
      resize: eS
    }[r] || Qje)(t, r, a), n[r] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, r, n, a) {
    return QLe(t, r, n, a);
  }
  isAttached(t) {
    const r = t && Hk(t);
    return !!(r && r.isConnected);
  }
}
function i4e(e) {
  return !$k() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? qje : s4e;
}
var hy;
let Kl = (hy = class {
  constructor() {
    Fe(this, "x");
    Fe(this, "y");
    Fe(this, "active", !1);
    Fe(this, "options");
    Fe(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: r, y: n } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: r,
      y: n
    };
  }
  hasValue() {
    return ig(this.x) && ig(this.y);
  }
  getProps(t, r) {
    const n = this.$animations;
    if (!r || !n)
      return this;
    const a = {};
    return t.forEach((s) => {
      a[s] = n[s] && n[s].active() ? n[s]._to : this[s];
    }), a;
  }
}, Fe(hy, "defaults", {}), Fe(hy, "defaultRoutes"), hy);
function o4e(e, t) {
  const r = e.options.ticks, n = l4e(e), a = Math.min(r.maxTicksLimit || n, n), s = r.major.enabled ? u4e(t) : [], i = s.length, o = s[0], l = s[i - 1], c = [];
  if (i > a)
    return d4e(t, c, s, i / a), c;
  const u = c4e(s, t, a);
  if (i > 0) {
    let d, f;
    const h = i > 1 ? Math.round((l - o) / (i - 1)) : null;
    for (j0(t, c, u, Vr(h) ? 0 : o - h, o), d = 0, f = i - 1; d < f; d++)
      j0(t, c, u, s[d], s[d + 1]);
    return j0(t, c, u, l, Vr(h) ? t.length : l + h), c;
  }
  return j0(t, c, u), c;
}
function l4e(e) {
  const t = e.options.offset, r = e._tickSize(), n = e._length / r + (t ? 0 : 1), a = e._maxLength / r;
  return Math.floor(Math.min(n, a));
}
function c4e(e, t, r) {
  const n = f4e(e), a = t.length / r;
  if (!n)
    return Math.max(a, 1);
  const s = XMe(n);
  for (let i = 0, o = s.length - 1; i < o; i++) {
    const l = s[i];
    if (l > a)
      return l;
  }
  return Math.max(a, 1);
}
function u4e(e) {
  const t = [];
  let r, n;
  for (r = 0, n = e.length; r < n; r++)
    e[r].major && t.push(r);
  return t;
}
function d4e(e, t, r, n) {
  let a = 0, s = r[0], i;
  for (n = Math.ceil(n), i = 0; i < e.length; i++)
    i === s && (t.push(e[i]), a++, s = r[a * n]);
}
function j0(e, t, r, n, a) {
  const s = gr(n, 0), i = Math.min(gr(a, e.length), e.length);
  let o = 0, l, c, u;
  for (r = Math.ceil(r), a && (l = a - n, r = l / Math.floor(l / r)), u = s; u < 0; )
    o++, u = Math.round(s + o * r);
  for (c = Math.max(s, 0); c < i; c++)
    c === u && (t.push(e[c]), o++, u = Math.round(s + o * r));
}
function f4e(e) {
  const t = e.length;
  let r, n;
  if (t < 2)
    return !1;
  for (n = e[0], r = 1; r < t; ++r)
    if (e[r] - e[r - 1] !== n)
      return !1;
  return n;
}
const h4e = (e) => e === "left" ? "right" : e === "right" ? "left" : e, kM = (e, t, r) => t === "top" || t === "left" ? e[t] + r : e[t] - r, OM = (e, t) => Math.min(t || e, e);
function AM(e, t) {
  const r = [], n = e.length / t, a = e.length;
  let s = 0;
  for (; s < a; s += n)
    r.push(e[Math.floor(s)]);
  return r;
}
function p4e(e, t, r) {
  const n = e.ticks.length, a = Math.min(t, n - 1), s = e._startPixel, i = e._endPixel, o = 1e-6;
  let l = e.getPixelForTick(a), c;
  if (!(r && (n === 1 ? c = Math.max(l - s, i - l) : t === 0 ? c = (e.getPixelForTick(1) - l) / 2 : c = (l - e.getPixelForTick(a - 1)) / 2, l += a < t ? c : -c, l < s - o || l > i + o)))
    return l;
}
function m4e(e, t) {
  Gr(e, (r) => {
    const n = r.gc, a = n.length / 2;
    let s;
    if (a > t) {
      for (s = 0; s < a; ++s)
        delete r.data[n[s]];
      n.splice(0, a);
    }
  });
}
function Op(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function PM(e, t) {
  if (!e.display)
    return 0;
  const r = Ga(e.font, t), n = mi(e.padding);
  return (Jn(e.text) ? e.text.length : 1) * r.lineHeight + n.height;
}
function g4e(e, t) {
  return pd(e, {
    scale: t,
    type: "scale"
  });
}
function v4e(e, t, r) {
  return pd(e, {
    tick: r,
    index: t,
    type: "tick"
  });
}
function y4e(e, t, r) {
  let n = Mk(e);
  return (r && t !== "right" || !r && t === "right") && (n = h4e(n)), n;
}
function b4e(e, t, r, n) {
  const { top: a, left: s, bottom: i, right: o, chart: l } = e, { chartArea: c, scales: u } = l;
  let d = 0, f, h, p;
  const m = i - a, g = o - s;
  if (e.isHorizontal()) {
    if (h = Ua(n, s, o), wr(r)) {
      const y = Object.keys(r)[0], x = r[y];
      p = u[y].getPixelForValue(x) + m - t;
    } else r === "center" ? p = (c.bottom + c.top) / 2 + m - t : p = kM(e, r, t);
    f = o - s;
  } else {
    if (wr(r)) {
      const y = Object.keys(r)[0], x = r[y];
      h = u[y].getPixelForValue(x) - g + t;
    } else r === "center" ? h = (c.left + c.right) / 2 - g + t : h = kM(e, r, t);
    p = Ua(n, i, a), d = r === "left" ? -oa : oa;
  }
  return {
    titleX: h,
    titleY: p,
    maxWidth: f,
    rotation: d
  };
}
class Bh extends Kl {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, r) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: r, _suggestedMin: n, _suggestedMax: a } = this;
    return t = ao(t, Number.POSITIVE_INFINITY), r = ao(r, Number.NEGATIVE_INFINITY), n = ao(n, Number.POSITIVE_INFINITY), a = ao(a, Number.NEGATIVE_INFINITY), {
      min: ao(t, n),
      max: ao(r, a),
      minDefined: Ja(t),
      maxDefined: Ja(r)
    };
  }
  getMinMax(t) {
    let { min: r, max: n, minDefined: a, maxDefined: s } = this.getUserBounds(), i;
    if (a && s)
      return {
        min: r,
        max: n
      };
    const o = this.getMatchingVisibleMetas();
    for (let l = 0, c = o.length; l < c; ++l)
      i = o[l].controller.getMinMax(this, t), a || (r = Math.min(r, i.min)), s || (n = Math.max(n, i.max));
    return r = s && r > n ? n : r, n = a && r > n ? r : n, {
      min: ao(r, ao(n, r)),
      max: ao(n, ao(r, n))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    pn(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, r, n) {
    const { beginAtZero: a, grace: s, ticks: i } = this.options, o = i.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = r, this._margins = n = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, n), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + n.left + n.right : this.height + n.top + n.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = ALe(this, s, a), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = o < this.ticks.length;
    this._convertTicksToLabels(l ? AM(this.ticks, o) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), i.display && (i.autoSkip || i.source === "auto") && (this.ticks = o4e(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, r, n;
    this.isHorizontal() ? (r = this.left, n = this.right) : (r = this.top, n = this.bottom, t = !t), this._startPixel = r, this._endPixel = n, this._reversePixels = t, this._length = n - r, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    pn(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    pn(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    pn(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), pn(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    pn(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const r = this.options.ticks;
    let n, a, s;
    for (n = 0, a = t.length; n < a; n++)
      s = t[n], s.label = pn(r.callback, [
        s.value,
        n,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    pn(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    pn(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, r = t.ticks, n = OM(this.ticks.length, t.ticks.maxTicksLimit), a = r.minRotation || 0, s = r.maxRotation;
    let i = a, o, l, c;
    if (!this._isVisible() || !r.display || a >= s || n <= 1 || !this.isHorizontal()) {
      this.labelRotation = a;
      return;
    }
    const u = this._getLabelSizes(), d = u.widest.width, f = u.highest.height, h = qa(this.chart.width - d, 0, this.maxWidth);
    o = t.offset ? this.maxWidth / n : h / (n - 1), d + 6 > o && (o = h / (n - (t.offset ? 0.5 : 1)), l = this.maxHeight - Op(t.grid) - r.padding - PM(t.title, this.chart.options.font), c = Math.sqrt(d * d + f * f), i = eLe(Math.min(Math.asin(qa((u.highest.height + 6) / o, -1, 1)), Math.asin(qa(l / c, -1, 1)) - Math.asin(qa(f / c, -1, 1)))), i = Math.max(a, Math.min(s, i))), this.labelRotation = i;
  }
  afterCalculateLabelRotation() {
    pn(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    pn(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: r, options: { ticks: n, title: a, grid: s } } = this, i = this._isVisible(), o = this.isHorizontal();
    if (i) {
      const l = PM(a, r.options.font);
      if (o ? (t.width = this.maxWidth, t.height = Op(s) + l) : (t.height = this.maxHeight, t.width = Op(s) + l), n.display && this.ticks.length) {
        const { first: c, last: u, widest: d, highest: f } = this._getLabelSizes(), h = n.padding * 2, p = El(this.labelRotation), m = Math.cos(p), g = Math.sin(p);
        if (o) {
          const y = n.mirror ? 0 : g * d.width + m * f.height;
          t.height = Math.min(this.maxHeight, t.height + y + h);
        } else {
          const y = n.mirror ? 0 : m * d.width + g * f.height;
          t.width = Math.min(this.maxWidth, t.width + y + h);
        }
        this._calculatePadding(c, u, g, m);
      }
    }
    this._handleMargins(), o ? (this.width = this._length = r.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = r.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, r, n, a) {
    const { ticks: { align: s, padding: i }, position: o } = this.options, l = this.labelRotation !== 0, c = o !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let f = 0, h = 0;
      l ? c ? (f = a * t.width, h = n * r.height) : (f = n * t.height, h = a * r.width) : s === "start" ? h = r.width : s === "end" ? f = t.width : s !== "inner" && (f = t.width / 2, h = r.width / 2), this.paddingLeft = Math.max((f - u + i) * this.width / (this.width - u), 0), this.paddingRight = Math.max((h - d + i) * this.width / (this.width - d), 0);
    } else {
      let u = r.height / 2, d = t.height / 2;
      s === "start" ? (u = 0, d = t.height) : s === "end" && (u = r.height, d = 0), this.paddingTop = u + i, this.paddingBottom = d + i;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    pn(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: r } = this.options;
    return r === "top" || r === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let r, n;
    for (r = 0, n = t.length; r < n; r++)
      Vr(t[r].label) && (t.splice(r, 1), n--, r--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const r = this.options.ticks.sampleSize;
      let n = this.ticks;
      r < n.length && (n = AM(n, r)), this._labelSizes = t = this._computeLabelSizes(n, n.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, r, n) {
    const { ctx: a, _longestTextCache: s } = this, i = [], o = [], l = Math.floor(r / OM(r, n));
    let c = 0, u = 0, d, f, h, p, m, g, y, x, w, _, S;
    for (d = 0; d < r; d += l) {
      if (p = t[d].label, m = this._resolveTickFontOptions(d), a.font = g = m.string, y = s[g] = s[g] || {
        data: {},
        gc: []
      }, x = m.lineHeight, w = _ = 0, !Vr(p) && !Jn(p))
        w = nM(a, y.data, y.gc, w, p), _ = x;
      else if (Jn(p))
        for (f = 0, h = p.length; f < h; ++f)
          S = p[f], !Vr(S) && !Jn(S) && (w = nM(a, y.data, y.gc, w, S), _ += x);
      i.push(w), o.push(_), c = Math.max(w, c), u = Math.max(_, u);
    }
    m4e(s, r);
    const C = i.indexOf(c), E = o.indexOf(u), O = (k) => ({
      width: i[k] || 0,
      height: o[k] || 0
    });
    return {
      first: O(0),
      last: O(r - 1),
      widest: O(C),
      highest: O(E),
      widths: i,
      heights: o
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, r) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const r = this.ticks;
    return t < 0 || t > r.length - 1 ? null : this.getPixelForValue(r[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const r = this._startPixel + t * this._length;
    return rLe(this._alignToPixels ? iu(this.chart, r, 0) : r);
  }
  getDecimalForPixel(t) {
    const r = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - r : r;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: r } = this;
    return t < 0 && r < 0 ? r : t > 0 && r > 0 ? t : 0;
  }
  getContext(t) {
    const r = this.ticks || [];
    if (t >= 0 && t < r.length) {
      const n = r[t];
      return n.$context || (n.$context = v4e(this.getContext(), t, n));
    }
    return this.$context || (this.$context = g4e(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, r = El(this.labelRotation), n = Math.abs(Math.cos(r)), a = Math.abs(Math.sin(r)), s = this._getLabelSizes(), i = t.autoSkipPadding || 0, o = s ? s.widest.width + i : 0, l = s ? s.highest.height + i : 0;
    return this.isHorizontal() ? l * n > o * a ? o / n : l / a : l * a < o * n ? l / n : o / a;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const r = this.axis, n = this.chart, a = this.options, { grid: s, position: i, border: o } = a, l = s.offset, c = this.isHorizontal(), d = this.ticks.length + (l ? 1 : 0), f = Op(s), h = [], p = o.setContext(this.getContext()), m = p.display ? p.width : 0, g = m / 2, y = function(Y) {
      return iu(n, Y, m);
    };
    let x, w, _, S, C, E, O, k, A, P, D, N;
    if (i === "top")
      x = y(this.bottom), E = this.bottom - f, k = x - g, P = y(t.top) + g, N = t.bottom;
    else if (i === "bottom")
      x = y(this.top), P = t.top, N = y(t.bottom) - g, E = x + g, k = this.top + f;
    else if (i === "left")
      x = y(this.right), C = this.right - f, O = x - g, A = y(t.left) + g, D = t.right;
    else if (i === "right")
      x = y(this.left), A = t.left, D = y(t.right) - g, C = x + g, O = this.left + f;
    else if (r === "x") {
      if (i === "center")
        x = y((t.top + t.bottom) / 2 + 0.5);
      else if (wr(i)) {
        const Y = Object.keys(i)[0], te = i[Y];
        x = y(this.chart.scales[Y].getPixelForValue(te));
      }
      P = t.top, N = t.bottom, E = x + g, k = E + f;
    } else if (r === "y") {
      if (i === "center")
        x = y((t.left + t.right) / 2);
      else if (wr(i)) {
        const Y = Object.keys(i)[0], te = i[Y];
        x = y(this.chart.scales[Y].getPixelForValue(te));
      }
      C = x - g, O = C - f, A = t.left, D = t.right;
    }
    const z = gr(a.ticks.maxTicksLimit, d), G = Math.max(1, Math.ceil(d / z));
    for (w = 0; w < d; w += G) {
      const Y = this.getContext(w), te = s.setContext(Y), ae = o.setContext(Y), ne = te.lineWidth, ue = te.color, q = ae.dash || [], U = ae.dashOffset, Q = te.tickWidth, L = te.tickColor, j = te.tickBorderDash || [], K = te.tickBorderDashOffset;
      _ = p4e(this, w, l), _ !== void 0 && (S = iu(n, _, ne), c ? C = O = A = D = S : E = k = P = N = S, h.push({
        tx1: C,
        ty1: E,
        tx2: O,
        ty2: k,
        x1: A,
        y1: P,
        x2: D,
        y2: N,
        width: ne,
        color: ue,
        borderDash: q,
        borderDashOffset: U,
        tickWidth: Q,
        tickColor: L,
        tickBorderDash: j,
        tickBorderDashOffset: K
      }));
    }
    return this._ticksLength = d, this._borderValue = x, h;
  }
  _computeLabelItems(t) {
    const r = this.axis, n = this.options, { position: a, ticks: s } = n, i = this.isHorizontal(), o = this.ticks, { align: l, crossAlign: c, padding: u, mirror: d } = s, f = Op(n.grid), h = f + u, p = d ? -u : h, m = -El(this.labelRotation), g = [];
    let y, x, w, _, S, C, E, O, k, A, P, D, N = "middle";
    if (a === "top")
      C = this.bottom - p, E = this._getXAxisLabelAlignment();
    else if (a === "bottom")
      C = this.top + p, E = this._getXAxisLabelAlignment();
    else if (a === "left") {
      const G = this._getYAxisLabelAlignment(f);
      E = G.textAlign, S = G.x;
    } else if (a === "right") {
      const G = this._getYAxisLabelAlignment(f);
      E = G.textAlign, S = G.x;
    } else if (r === "x") {
      if (a === "center")
        C = (t.top + t.bottom) / 2 + h;
      else if (wr(a)) {
        const G = Object.keys(a)[0], Y = a[G];
        C = this.chart.scales[G].getPixelForValue(Y) + h;
      }
      E = this._getXAxisLabelAlignment();
    } else if (r === "y") {
      if (a === "center")
        S = (t.left + t.right) / 2 - h;
      else if (wr(a)) {
        const G = Object.keys(a)[0], Y = a[G];
        S = this.chart.scales[G].getPixelForValue(Y);
      }
      E = this._getYAxisLabelAlignment(f).textAlign;
    }
    r === "y" && (l === "start" ? N = "top" : l === "end" && (N = "bottom"));
    const z = this._getLabelSizes();
    for (y = 0, x = o.length; y < x; ++y) {
      w = o[y], _ = w.label;
      const G = s.setContext(this.getContext(y));
      O = this.getPixelForTick(y) + s.labelOffset, k = this._resolveTickFontOptions(y), A = k.lineHeight, P = Jn(_) ? _.length : 1;
      const Y = P / 2, te = G.color, ae = G.textStrokeColor, ne = G.textStrokeWidth;
      let ue = E;
      i ? (S = O, E === "inner" && (y === x - 1 ? ue = this.options.reverse ? "left" : "right" : y === 0 ? ue = this.options.reverse ? "right" : "left" : ue = "center"), a === "top" ? c === "near" || m !== 0 ? D = -P * A + A / 2 : c === "center" ? D = -z.highest.height / 2 - Y * A + A : D = -z.highest.height + A / 2 : c === "near" || m !== 0 ? D = A / 2 : c === "center" ? D = z.highest.height / 2 - Y * A : D = z.highest.height - P * A, d && (D *= -1), m !== 0 && !G.showLabelBackdrop && (S += A / 2 * Math.sin(m))) : (C = O, D = (1 - P) * A / 2);
      let q;
      if (G.showLabelBackdrop) {
        const U = mi(G.backdropPadding), Q = z.heights[y], L = z.widths[y];
        let j = D - U.top, K = 0 - U.left;
        switch (N) {
          case "middle":
            j -= Q / 2;
            break;
          case "bottom":
            j -= Q;
            break;
        }
        switch (E) {
          case "center":
            K -= L / 2;
            break;
          case "right":
            K -= L;
            break;
          case "inner":
            y === x - 1 ? K -= L : y > 0 && (K -= L / 2);
            break;
        }
        q = {
          left: K,
          top: j,
          width: L + U.width,
          height: Q + U.height,
          color: G.backdropColor
        };
      }
      g.push({
        label: _,
        font: k,
        textOffset: D,
        options: {
          rotation: m,
          color: te,
          strokeColor: ae,
          strokeWidth: ne,
          textAlign: ue,
          textBaseline: N,
          translation: [
            S,
            C
          ],
          backdrop: q
        }
      });
    }
    return g;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: r } = this.options;
    if (-El(this.labelRotation))
      return t === "top" ? "left" : "right";
    let a = "center";
    return r.align === "start" ? a = "left" : r.align === "end" ? a = "right" : r.align === "inner" && (a = "inner"), a;
  }
  _getYAxisLabelAlignment(t) {
    const { position: r, ticks: { crossAlign: n, mirror: a, padding: s } } = this.options, i = this._getLabelSizes(), o = t + s, l = i.widest.width;
    let c, u;
    return r === "left" ? a ? (u = this.right + s, n === "near" ? c = "left" : n === "center" ? (c = "center", u += l / 2) : (c = "right", u += l)) : (u = this.right - o, n === "near" ? c = "right" : n === "center" ? (c = "center", u -= l / 2) : (c = "left", u = this.left)) : r === "right" ? a ? (u = this.left + s, n === "near" ? c = "right" : n === "center" ? (c = "center", u -= l / 2) : (c = "left", u -= l)) : (u = this.left + o, n === "near" ? c = "left" : n === "center" ? (c = "center", u += l / 2) : (c = "right", u = this.right)) : c = "right", {
      textAlign: c,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, r = this.options.position;
    if (r === "left" || r === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (r === "top" || r === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: r }, left: n, top: a, width: s, height: i } = this;
    r && (t.save(), t.fillStyle = r, t.fillRect(n, a, s, i), t.restore());
  }
  getLineWidthForValue(t) {
    const r = this.options.grid;
    if (!this._isVisible() || !r.display)
      return 0;
    const a = this.ticks.findIndex((s) => s.value === t);
    return a >= 0 ? r.setContext(this.getContext(a)).lineWidth : 0;
  }
  drawGrid(t) {
    const r = this.options.grid, n = this.ctx, a = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let s, i;
    const o = (l, c, u) => {
      !u.width || !u.color || (n.save(), n.lineWidth = u.width, n.strokeStyle = u.color, n.setLineDash(u.borderDash || []), n.lineDashOffset = u.borderDashOffset, n.beginPath(), n.moveTo(l.x, l.y), n.lineTo(c.x, c.y), n.stroke(), n.restore());
    };
    if (r.display)
      for (s = 0, i = a.length; s < i; ++s) {
        const l = a[s];
        r.drawOnChartArea && o({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), r.drawTicks && o({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: r, options: { border: n, grid: a } } = this, s = n.setContext(this.getContext()), i = n.display ? s.width : 0;
    if (!i)
      return;
    const o = a.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, u, d, f;
    this.isHorizontal() ? (c = iu(t, this.left, i) - i / 2, u = iu(t, this.right, o) + o / 2, d = f = l) : (d = iu(t, this.top, i) - i / 2, f = iu(t, this.bottom, o) + o / 2, c = u = l), r.save(), r.lineWidth = s.width, r.strokeStyle = s.color, r.beginPath(), r.moveTo(c, d), r.lineTo(u, f), r.stroke(), r.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const n = this.ctx, a = this._computeLabelArea();
    a && gx(n, a);
    const s = this.getLabelItems(t);
    for (const i of s) {
      const o = i.options, l = i.font, c = i.label, u = i.textOffset;
      cg(n, c, 0, u, l, o);
    }
    a && vx(n);
  }
  drawTitle() {
    const { ctx: t, options: { position: r, title: n, reverse: a } } = this;
    if (!n.display)
      return;
    const s = Ga(n.font), i = mi(n.padding), o = n.align;
    let l = s.lineHeight / 2;
    r === "bottom" || r === "center" || wr(r) ? (l += i.bottom, Jn(n.text) && (l += s.lineHeight * (n.text.length - 1))) : l += i.top;
    const { titleX: c, titleY: u, maxWidth: d, rotation: f } = b4e(this, l, r, o);
    cg(t, n.text, 0, 0, s, {
      color: n.color,
      maxWidth: d,
      rotation: f,
      textAlign: y4e(o, r, a),
      textBaseline: "middle",
      translation: [
        c,
        u
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, r = t.ticks && t.ticks.z || 0, n = gr(t.grid && t.grid.z, -1), a = gr(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Bh.prototype.draw ? [
      {
        z: r,
        draw: (s) => {
          this.draw(s);
        }
      }
    ] : [
      {
        z: n,
        draw: (s) => {
          this.drawBackground(), this.drawGrid(s), this.drawTitle();
        }
      },
      {
        z: a,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: r,
        draw: (s) => {
          this.drawLabels(s);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const r = this.chart.getSortedVisibleDatasetMetas(), n = this.axis + "AxisID", a = [];
    let s, i;
    for (s = 0, i = r.length; s < i; ++s) {
      const o = r[s];
      o[n] === this.id && (!t || o.type === t) && a.push(o);
    }
    return a;
  }
  _resolveTickFontOptions(t) {
    const r = this.options.ticks.setContext(this.getContext(t));
    return Ga(r.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class F0 {
  constructor(t, r, n) {
    this.type = t, this.scope = r, this.override = n, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const r = Object.getPrototypeOf(t);
    let n;
    _4e(r) && (n = this.register(r));
    const a = this.items, s = t.id, i = this.scope + "." + s;
    if (!s)
      throw new Error("class does not have id: " + t);
    return s in a || (a[s] = t, w4e(t, i, n), this.override && Wn.override(t.id, t.overrides)), i;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const r = this.items, n = t.id, a = this.scope;
    n in r && delete r[n], a && n in Wn[a] && (delete Wn[a][n], this.override && delete qu[n]);
  }
}
function w4e(e, t, r) {
  const n = ag(/* @__PURE__ */ Object.create(null), [
    r ? Wn.get(r) : {},
    Wn.get(t),
    e.defaults
  ]);
  Wn.set(t, n), e.defaultRoutes && x4e(t, e.defaultRoutes), e.descriptors && Wn.describe(t, e.descriptors);
}
function x4e(e, t) {
  Object.keys(t).forEach((r) => {
    const n = r.split("."), a = n.pop(), s = [
      e
    ].concat(n).join("."), i = t[r].split("."), o = i.pop(), l = i.join(".");
    Wn.route(s, a, l, o);
  });
}
function _4e(e) {
  return "id" in e && "defaults" in e;
}
class S4e {
  constructor() {
    this.controllers = new F0(Lu, "datasets", !0), this.elements = new F0(Kl, "elements"), this.plugins = new F0(Object, "plugins"), this.scales = new F0(Bh, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, r, n) {
    [
      ...r
    ].forEach((a) => {
      const s = n || this._getRegistryForType(a);
      n || s.isForType(a) || s === this.plugins && a.id ? this._exec(t, s, a) : Gr(a, (i) => {
        const o = n || this._getRegistryForType(i);
        this._exec(t, o, i);
      });
    });
  }
  _exec(t, r, n) {
    const a = Dk(t);
    pn(n["before" + a], [], n), r[t](n), pn(n["after" + a], [], n);
  }
  _getRegistryForType(t) {
    for (let r = 0; r < this._typedRegistries.length; r++) {
      const n = this._typedRegistries[r];
      if (n.isForType(t))
        return n;
    }
    return this.plugins;
  }
  _get(t, r, n) {
    const a = r.get(t);
    if (a === void 0)
      throw new Error('"' + t + '" is not a registered ' + n + ".");
    return a;
  }
}
var mo = /* @__PURE__ */ new S4e();
class E4e {
  constructor() {
    this._init = [];
  }
  notify(t, r, n, a) {
    r === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const s = a ? this._descriptors(t).filter(a) : this._descriptors(t), i = this._notify(s, t, r, n);
    return r === "afterDestroy" && (this._notify(s, t, "stop"), this._notify(this._init, t, "uninstall")), i;
  }
  _notify(t, r, n, a) {
    a = a || {};
    for (const s of t) {
      const i = s.plugin, o = i[n], l = [
        r,
        a,
        s.options
      ];
      if (pn(o, l, i) === !1 && a.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    Vr(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const r = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), r;
  }
  _createDescriptors(t, r) {
    const n = t && t.config, a = gr(n.options && n.options.plugins, {}), s = T4e(n);
    return a === !1 && !r ? [] : k4e(t, s, a, r);
  }
  _notifyStateChanges(t) {
    const r = this._oldCache || [], n = this._cache, a = (s, i) => s.filter((o) => !i.some((l) => o.plugin.id === l.plugin.id));
    this._notify(a(r, n), t, "stop"), this._notify(a(n, r), t, "start");
  }
}
function T4e(e) {
  const t = {}, r = [], n = Object.keys(mo.plugins.items);
  for (let s = 0; s < n.length; s++)
    r.push(mo.getPlugin(n[s]));
  const a = e.plugins || [];
  for (let s = 0; s < a.length; s++) {
    const i = a[s];
    r.indexOf(i) === -1 && (r.push(i), t[i.id] = !0);
  }
  return {
    plugins: r,
    localIds: t
  };
}
function C4e(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function k4e(e, { plugins: t, localIds: r }, n, a) {
  const s = [], i = e.getContext();
  for (const o of t) {
    const l = o.id, c = C4e(n[l], a);
    c !== null && s.push({
      plugin: o,
      options: O4e(e.config, {
        plugin: o,
        local: r[l]
      }, c, i)
    });
  }
  return s;
}
function O4e(e, { plugin: t, local: r }, n, a) {
  const s = e.pluginScopeKeys(t), i = e.getOptionScopes(n, s);
  return r && t.defaults && i.push(t.defaults), e.createResolver(i, a, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function nT(e, t) {
  const r = Wn.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || r.indexAxis || "x";
}
function A4e(e, t) {
  let r = e;
  return e === "_index_" ? r = t : e === "_value_" && (r = t === "x" ? "y" : "x"), r;
}
function P4e(e, t) {
  return e === t ? "_index_" : "_value_";
}
function RM(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
function R4e(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function aT(e, ...t) {
  if (RM(e))
    return e;
  for (const r of t) {
    const n = r.axis || R4e(r.position) || e.length > 1 && RM(e[0].toLowerCase());
    if (n)
      return n;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function IM(e, t, r) {
  if (r[t + "AxisID"] === e)
    return {
      axis: t
    };
}
function I4e(e, t) {
  if (t.data && t.data.datasets) {
    const r = t.data.datasets.filter((n) => n.xAxisID === e || n.yAxisID === e);
    if (r.length)
      return IM(e, "x", r[0]) || IM(e, "y", r[0]);
  }
  return {};
}
function D4e(e, t) {
  const r = qu[e.type] || {
    scales: {}
  }, n = t.scales || {}, a = nT(e.type, t), s = /* @__PURE__ */ Object.create(null);
  return Object.keys(n).forEach((i) => {
    const o = n[i];
    if (!wr(o))
      return console.error(`Invalid scale configuration for scale: ${i}`);
    if (o._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${i}`);
    const l = aT(i, o, I4e(i, e), Wn.scales[o.type]), c = P4e(l, a), u = r.scales || {};
    s[i] = gm(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      o,
      u[l],
      u[c]
    ]);
  }), e.data.datasets.forEach((i) => {
    const o = i.type || e.type, l = i.indexAxis || nT(o, t), u = (qu[o] || {}).scales || {};
    Object.keys(u).forEach((d) => {
      const f = A4e(d, l), h = i[f + "AxisID"] || f;
      s[h] = s[h] || /* @__PURE__ */ Object.create(null), gm(s[h], [
        {
          axis: f
        },
        n[h],
        u[d]
      ]);
    });
  }), Object.keys(s).forEach((i) => {
    const o = s[i];
    gm(o, [
      Wn.scales[o.type],
      Wn.scale
    ]);
  }), s;
}
function VV(e) {
  const t = e.options || (e.options = {});
  t.plugins = gr(t.plugins, {}), t.scales = D4e(e, t);
}
function $V(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function N4e(e) {
  return e = e || {}, e.data = $V(e.data), VV(e), e;
}
const DM = /* @__PURE__ */ new Map(), HV = /* @__PURE__ */ new Set();
function B0(e, t) {
  let r = DM.get(e);
  return r || (r = t(), DM.set(e, r), HV.add(r)), r;
}
const Ap = (e, t, r) => {
  const n = Ku(t, r);
  n !== void 0 && e.add(n);
};
class M4e {
  constructor(t) {
    this._config = N4e(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = $V(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), VV(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return B0(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, r) {
    return B0(`${t}.transition.${r}`, () => [
      [
        `datasets.${t}.transitions.${r}`,
        `transitions.${r}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, r) {
    return B0(`${t}-${r}`, () => [
      [
        `datasets.${t}.elements.${r}`,
        `datasets.${t}`,
        `elements.${r}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const r = t.id, n = this.type;
    return B0(`${n}-plugin-${r}`, () => [
      [
        `plugins.${r}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, r) {
    const n = this._scopeCache;
    let a = n.get(t);
    return (!a || r) && (a = /* @__PURE__ */ new Map(), n.set(t, a)), a;
  }
  getOptionScopes(t, r, n) {
    const { options: a, type: s } = this, i = this._cachedScopes(t, n), o = i.get(r);
    if (o)
      return o;
    const l = /* @__PURE__ */ new Set();
    r.forEach((u) => {
      t && (l.add(t), u.forEach((d) => Ap(l, t, d))), u.forEach((d) => Ap(l, a, d)), u.forEach((d) => Ap(l, qu[s] || {}, d)), u.forEach((d) => Ap(l, Wn, d)), u.forEach((d) => Ap(l, tT, d));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), HV.has(r) && i.set(r, c), c;
  }
  chartOptionScopes() {
    const { options: t, type: r } = this;
    return [
      t,
      qu[r] || {},
      Wn.datasets[r] || {},
      {
        type: r
      },
      Wn,
      tT
    ];
  }
  resolveNamedOptions(t, r, n, a = [
    ""
  ]) {
    const s = {
      $shared: !0
    }, { resolver: i, subPrefixes: o } = NM(this._resolverCache, t, a);
    let l = i;
    if (j4e(i, r)) {
      s.$shared = !1, n = Lc(n) ? n() : n;
      const c = this.createResolver(t, n, o);
      l = ch(i, n, c);
    }
    for (const c of r)
      s[c] = l[c];
    return s;
  }
  createResolver(t, r, n = [
    ""
  ], a) {
    const { resolver: s } = NM(this._resolverCache, t, n);
    return wr(r) ? ch(s, r, void 0, a) : s;
  }
}
function NM(e, t, r) {
  let n = e.get(t);
  n || (n = /* @__PURE__ */ new Map(), e.set(t, n));
  const a = r.join();
  let s = n.get(a);
  return s || (s = {
    resolver: Bk(t, r),
    subPrefixes: r.filter((o) => !o.toLowerCase().includes("hover"))
  }, n.set(a, s)), s;
}
const L4e = (e) => wr(e) && Object.getOwnPropertyNames(e).some((t) => Lc(e[t]));
function j4e(e, t) {
  const { isScriptable: r, isIndexable: n } = SV(e);
  for (const a of t) {
    const s = r(a), i = n(a), o = (i || s) && e[a];
    if (s && (Lc(o) || L4e(o)) || i && Jn(o))
      return !0;
  }
  return !1;
}
var F4e = "4.4.8";
const B4e = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function MM(e, t) {
  return e === "top" || e === "bottom" || B4e.indexOf(e) === -1 && t === "x";
}
function LM(e, t) {
  return function(r, n) {
    return r[e] === n[e] ? r[t] - n[t] : r[e] - n[e];
  };
}
function jM(e) {
  const t = e.chart, r = t.options.animation;
  t.notifyPlugins("afterRender"), pn(r && r.onComplete, [
    e
  ], t);
}
function U4e(e) {
  const t = e.chart, r = t.options.animation;
  pn(r && r.onProgress, [
    e
  ], t);
}
function WV(e) {
  return $k() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const Ry = {}, FM = (e) => {
  const t = WV(e);
  return Object.values(Ry).filter((r) => r.canvas === t).pop();
};
function V4e(e, t, r) {
  const n = Object.keys(e);
  for (const a of n) {
    const s = +a;
    if (s >= t) {
      const i = e[a];
      delete e[a], (r > 0 || s > t) && (e[s + r] = i);
    }
  }
}
function $4e(e, t, r, n) {
  return !r || e.type === "mouseout" ? null : n ? t : e;
}
function U0(e, t, r) {
  return e.options.clip ? e[r] : t[r];
}
function H4e(e, t) {
  const { xScale: r, yScale: n } = e;
  return r && n ? {
    left: U0(r, t, "left"),
    right: U0(r, t, "right"),
    top: U0(n, t, "top"),
    bottom: U0(n, t, "bottom")
  } : t;
}
var ic;
let qi = (ic = class {
  static register(...t) {
    mo.add(...t), BM();
  }
  static unregister(...t) {
    mo.remove(...t), BM();
  }
  constructor(t, r) {
    const n = this.config = new M4e(r), a = WV(t), s = FM(a);
    if (s)
      throw new Error("Canvas is already in use. Chart with ID '" + s.id + "' must be destroyed before the canvas with ID '" + s.canvas.id + "' can be reused.");
    const i = n.createResolver(n.chartOptionScopes(), this.getContext());
    this.platform = new (n.platform || i4e(a))(), this.platform.updateConfig(n);
    const o = this.platform.acquireContext(a, i.aspectRatio), l = o && o.canvas, c = l && l.height, u = l && l.width;
    if (this.id = VMe(), this.ctx = o, this.canvas = l, this.width = u, this.height = c, this._options = i, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new E4e(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = iLe((d) => this.update(d), i.resizeDelay || 0), this._dataChanges = [], Ry[this.id] = this, !o || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    ml.listen(this, "complete", jM), ml.listen(this, "progress", U4e), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: r }, width: n, height: a, _aspectRatio: s } = this;
    return Vr(t) ? r && s ? s : a ? n / a : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return mo;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : oM(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return aM(this.canvas, this.ctx), this;
  }
  stop() {
    return ml.stop(this), this;
  }
  resize(t, r) {
    ml.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: r
    } : this._resize(t, r);
  }
  _resize(t, r) {
    const n = this.options, a = this.canvas, s = n.maintainAspectRatio && this.aspectRatio, i = this.platform.getMaximumSize(a, t, r, s), o = n.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = i.width, this.height = i.height, this._aspectRatio = this.aspectRatio, oM(this, o, !0) && (this.notifyPlugins("resize", {
      size: i
    }), pn(n.onResize, [
      this,
      i
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const r = this.options.scales || {};
    Gr(r, (n, a) => {
      n.id = a;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, r = t.scales, n = this.scales, a = Object.keys(n).reduce((i, o) => (i[o] = !1, i), {});
    let s = [];
    r && (s = s.concat(Object.keys(r).map((i) => {
      const o = r[i], l = aT(i, o), c = l === "r", u = l === "x";
      return {
        options: o,
        dposition: c ? "chartArea" : u ? "bottom" : "left",
        dtype: c ? "radialLinear" : u ? "category" : "linear"
      };
    }))), Gr(s, (i) => {
      const o = i.options, l = o.id, c = aT(l, o), u = gr(o.type, i.dtype);
      (o.position === void 0 || MM(o.position, c) !== MM(i.dposition)) && (o.position = i.dposition), a[l] = !0;
      let d = null;
      if (l in n && n[l].type === u)
        d = n[l];
      else {
        const f = mo.getScale(u);
        d = new f({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), n[d.id] = d;
      }
      d.init(o, t);
    }), Gr(a, (i, o) => {
      i || delete n[o];
    }), Gr(n, (i) => {
      li.configure(this, i, i.options), li.addBox(this, i);
    });
  }
  _updateMetasets() {
    const t = this._metasets, r = this.data.datasets.length, n = t.length;
    if (t.sort((a, s) => a.index - s.index), n > r) {
      for (let a = r; a < n; ++a)
        this._destroyDatasetMeta(a);
      t.splice(r, n - r);
    }
    this._sortedMetasets = t.slice(0).sort(LM("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: r } } = this;
    t.length > r.length && delete this._stacks, t.forEach((n, a) => {
      r.filter((s) => s === n._dataset).length === 0 && this._destroyDatasetMeta(a);
    });
  }
  buildOrUpdateControllers() {
    const t = [], r = this.data.datasets;
    let n, a;
    for (this._removeUnreferencedMetasets(), n = 0, a = r.length; n < a; n++) {
      const s = r[n];
      let i = this.getDatasetMeta(n);
      const o = s.type || this.config.type;
      if (i.type && i.type !== o && (this._destroyDatasetMeta(n), i = this.getDatasetMeta(n)), i.type = o, i.indexAxis = s.indexAxis || nT(o, this.options), i.order = s.order || 0, i.index = n, i.label = "" + s.label, i.visible = this.isDatasetVisible(n), i.controller)
        i.controller.updateIndex(n), i.controller.linkScales();
      else {
        const l = mo.getController(o), { datasetElementType: c, dataElementType: u } = Wn.datasets[o];
        Object.assign(l, {
          dataElementType: mo.getElement(u),
          datasetElementType: c && mo.getElement(c)
        }), i.controller = new l(this, n), t.push(i.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    Gr(this.data.datasets, (t, r) => {
      this.getDatasetMeta(r).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const r = this.config;
    r.update();
    const n = this._options = r.createResolver(r.chartOptionScopes(), this.getContext()), a = this._animationsDisabled = !n.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const s = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let i = 0;
    for (let c = 0, u = this.data.datasets.length; c < u; c++) {
      const { controller: d } = this.getDatasetMeta(c), f = !a && s.indexOf(d) === -1;
      d.buildOrUpdateElements(f), i = Math.max(+d.getMaxOverflow(), i);
    }
    i = this._minPadding = n.layout.autoPadding ? i : 0, this._updateLayout(i), a || Gr(s, (c) => {
      c.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(LM("z", "_idx"));
    const { _active: o, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : o.length && this._updateHoverStyles(o, o, !0), this.render();
  }
  _updateScales() {
    Gr(this.scales, (t) => {
      li.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, r = new Set(Object.keys(this._listeners)), n = new Set(t.events);
    (!GN(r, n) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, r = this._getUniformDataChanges() || [];
    for (const { method: n, start: a, count: s } of r) {
      const i = n === "_removeElements" ? -s : s;
      V4e(t, a, i);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const r = this.data.datasets.length, n = (s) => new Set(t.filter((i) => i[0] === s).map((i, o) => o + "," + i.splice(1).join(","))), a = n(0);
    for (let s = 1; s < r; s++)
      if (!GN(a, n(s)))
        return;
    return Array.from(a).map((s) => s.split(",")).map((s) => ({
      method: s[1],
      start: +s[2],
      count: +s[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    li.update(this, this.width, this.height, t);
    const r = this.chartArea, n = r.width <= 0 || r.height <= 0;
    this._layers = [], Gr(this.boxes, (a) => {
      n && a.position === "chartArea" || (a.configure && a.configure(), this._layers.push(...a._layers()));
    }, this), this._layers.forEach((a, s) => {
      a._idx = s;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let r = 0, n = this.data.datasets.length; r < n; ++r)
        this.getDatasetMeta(r).controller.configure();
      for (let r = 0, n = this.data.datasets.length; r < n; ++r)
        this._updateDataset(r, Lc(t) ? t({
          datasetIndex: r
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, r) {
    const n = this.getDatasetMeta(t), a = {
      meta: n,
      index: t,
      mode: r,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", a) !== !1 && (n.controller._update(r), a.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", a));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (ml.has(this) ? this.attached && !ml.running(this) && ml.start(this) : (this.draw(), jM({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: n, height: a } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(n, a);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const r = this._layers;
    for (t = 0; t < r.length && r[t].z <= 0; ++t)
      r[t].draw(this.chartArea);
    for (this._drawDatasets(); t < r.length; ++t)
      r[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const r = this._sortedMetasets, n = [];
    let a, s;
    for (a = 0, s = r.length; a < s; ++a) {
      const i = r[a];
      (!t || i.visible) && n.push(i);
    }
    return n;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let r = t.length - 1; r >= 0; --r)
      this._drawDataset(t[r]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const r = this.ctx, n = t._clip, a = !n.disabled, s = H4e(t, this.chartArea), i = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", i) !== !1 && (a && gx(r, {
      left: n.left === !1 ? 0 : s.left - n.left,
      right: n.right === !1 ? this.width : s.right + n.right,
      top: n.top === !1 ? 0 : s.top - n.top,
      bottom: n.bottom === !1 ? this.height : s.bottom + n.bottom
    }), t.controller.draw(), a && vx(r), i.cancelable = !1, this.notifyPlugins("afterDatasetDraw", i));
  }
  isPointInArea(t) {
    return lg(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, r, n, a) {
    const s = Bje.modes[r];
    return typeof s == "function" ? s(this, t, n, a) : [];
  }
  getDatasetMeta(t) {
    const r = this.data.datasets[t], n = this._metasets;
    let a = n.filter((s) => s && s._dataset === r).pop();
    return a || (a = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: r && r.order || 0,
      index: t,
      _dataset: r,
      _parsed: [],
      _sorted: !1
    }, n.push(a)), a;
  }
  getContext() {
    return this.$context || (this.$context = pd(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const r = this.data.datasets[t];
    if (!r)
      return !1;
    const n = this.getDatasetMeta(t);
    return typeof n.hidden == "boolean" ? !n.hidden : !r.hidden;
  }
  setDatasetVisibility(t, r) {
    const n = this.getDatasetMeta(t);
    n.hidden = !r;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, r, n) {
    const a = n ? "show" : "hide", s = this.getDatasetMeta(t), i = s.controller._resolveAnimations(void 0, a);
    sg(r) ? (s.data[r].hidden = !n, this.update()) : (this.setDatasetVisibility(t, n), i.update(s, {
      visible: n
    }), this.update((o) => o.datasetIndex === t ? a : void 0));
  }
  hide(t, r) {
    this._updateVisibility(t, r, !1);
  }
  show(t, r) {
    this._updateVisibility(t, r, !0);
  }
  _destroyDatasetMeta(t) {
    const r = this._metasets[t];
    r && r.controller && r.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, r;
    for (this.stop(), ml.remove(this), t = 0, r = this.data.datasets.length; t < r; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: r } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), aM(t, r), this.platform.releaseContext(r), this.canvas = null, this.ctx = null), delete Ry[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, r = this.platform, n = (s, i) => {
      r.addEventListener(this, s, i), t[s] = i;
    }, a = (s, i, o) => {
      s.offsetX = i, s.offsetY = o, this._eventHandler(s);
    };
    Gr(this.options.events, (s) => n(s, a));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, r = this.platform, n = (l, c) => {
      r.addEventListener(this, l, c), t[l] = c;
    }, a = (l, c) => {
      t[l] && (r.removeEventListener(this, l, c), delete t[l]);
    }, s = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let i;
    const o = () => {
      a("attach", o), this.attached = !0, this.resize(), n("resize", s), n("detach", i);
    };
    i = () => {
      this.attached = !1, a("resize", s), this._stop(), this._resize(0, 0), n("attach", o);
    }, r.isAttached(this.canvas) ? o() : i();
  }
  unbindEvents() {
    Gr(this._listeners, (t, r) => {
      this.platform.removeEventListener(this, r, t);
    }), this._listeners = {}, Gr(this._responsiveListeners, (t, r) => {
      this.platform.removeEventListener(this, r, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, r, n) {
    const a = n ? "set" : "remove";
    let s, i, o, l;
    for (r === "dataset" && (s = this.getDatasetMeta(t[0].datasetIndex), s.controller["_" + a + "DatasetHoverStyle"]()), o = 0, l = t.length; o < l; ++o) {
      i = t[o];
      const c = i && this.getDatasetMeta(i.datasetIndex).controller;
      c && c[a + "HoverStyle"](i.element, i.datasetIndex, i.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const r = this._active || [], n = t.map(({ datasetIndex: s, index: i }) => {
      const o = this.getDatasetMeta(s);
      if (!o)
        throw new Error("No dataset found at index " + s);
      return {
        datasetIndex: s,
        element: o.data[i],
        index: i
      };
    });
    !kb(n, r) && (this._active = n, this._lastEvent = null, this._updateHoverStyles(n, r));
  }
  notifyPlugins(t, r, n) {
    return this._plugins.notify(this, t, r, n);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((r) => r.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, r, n) {
    const a = this.options.hover, s = (l, c) => l.filter((u) => !c.some((d) => u.datasetIndex === d.datasetIndex && u.index === d.index)), i = s(r, t), o = n ? t : s(t, r);
    i.length && this.updateHoverStyle(i, a.mode, !1), o.length && a.mode && this.updateHoverStyle(o, a.mode, !0);
  }
  _eventHandler(t, r) {
    const n = {
      event: t,
      replay: r,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, a = (i) => (i.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", n, a) === !1)
      return;
    const s = this._handleEvent(t, r, n.inChartArea);
    return n.cancelable = !1, this.notifyPlugins("afterEvent", n, a), (s || n.changed) && this.render(), this;
  }
  _handleEvent(t, r, n) {
    const { _active: a = [], options: s } = this, i = r, o = this._getActiveElements(t, a, n, i), l = qMe(t), c = $4e(t, this._lastEvent, n, l);
    n && (this._lastEvent = null, pn(s.onHover, [
      t,
      o,
      this
    ], this), l && pn(s.onClick, [
      t,
      o,
      this
    ], this));
    const u = !kb(o, a);
    return (u || r) && (this._active = o, this._updateHoverStyles(o, a, r)), this._lastEvent = c, u;
  }
  _getActiveElements(t, r, n, a) {
    if (t.type === "mouseout")
      return [];
    if (!n)
      return r;
    const s = this.options.hover;
    return this.getElementsAtEventForMode(t, s.mode, s, a);
  }
}, Fe(ic, "defaults", Wn), Fe(ic, "instances", Ry), Fe(ic, "overrides", qu), Fe(ic, "registry", mo), Fe(ic, "version", F4e), Fe(ic, "getChart", FM), ic);
function BM() {
  return Gr(qi.instances, (e) => e._plugins.invalidate());
}
function W4e(e, t, r) {
  const { startAngle: n, pixelMargin: a, x: s, y: i, outerRadius: o, innerRadius: l } = t;
  let c = a / o;
  e.beginPath(), e.arc(s, i, o, n - c, r + c), l > a ? (c = a / l, e.arc(s, i, l, r + c, n - c, !0)) : e.arc(s, i, a, r + oa, n - oa), e.closePath(), e.clip();
}
function z4e(e) {
  return Fk(e, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function K4e(e, t, r, n) {
  const a = z4e(e.options.borderRadius), s = (r - t) / 2, i = Math.min(s, n * t / 2), o = (l) => {
    const c = (r - Math.min(s, l)) * n / 2;
    return qa(l, 0, Math.min(s, c));
  };
  return {
    outerStart: o(a.outerStart),
    outerEnd: o(a.outerEnd),
    innerStart: qa(a.innerStart, 0, i),
    innerEnd: qa(a.innerEnd, 0, i)
  };
}
function Yd(e, t, r, n) {
  return {
    x: r + e * Math.cos(t),
    y: n + e * Math.sin(t)
  };
}
function Db(e, t, r, n, a, s) {
  const { x: i, y: o, startAngle: l, pixelMargin: c, innerRadius: u } = t, d = Math.max(t.outerRadius + n + r - c, 0), f = u > 0 ? u + n + r + c : 0;
  let h = 0;
  const p = a - l;
  if (n) {
    const G = u > 0 ? u - n : 0, Y = d > 0 ? d - n : 0, te = (G + Y) / 2, ae = te !== 0 ? p * te / (te + n) : p;
    h = (p - ae) / 2;
  }
  const m = Math.max(1e-3, p * d - r / Pn) / d, g = (p - m) / 2, y = l + g + h, x = a - g - h, { outerStart: w, outerEnd: _, innerStart: S, innerEnd: C } = K4e(t, f, d, x - y), E = d - w, O = d - _, k = y + w / E, A = x - _ / O, P = f + S, D = f + C, N = y + S / P, z = x - C / D;
  if (e.beginPath(), s) {
    const G = (k + A) / 2;
    if (e.arc(i, o, d, k, G), e.arc(i, o, d, G, A), _ > 0) {
      const ne = Yd(O, A, i, o);
      e.arc(ne.x, ne.y, _, A, x + oa);
    }
    const Y = Yd(D, x, i, o);
    if (e.lineTo(Y.x, Y.y), C > 0) {
      const ne = Yd(D, z, i, o);
      e.arc(ne.x, ne.y, C, x + oa, z + Math.PI);
    }
    const te = (x - C / f + (y + S / f)) / 2;
    if (e.arc(i, o, f, x - C / f, te, !0), e.arc(i, o, f, te, y + S / f, !0), S > 0) {
      const ne = Yd(P, N, i, o);
      e.arc(ne.x, ne.y, S, N + Math.PI, y - oa);
    }
    const ae = Yd(E, y, i, o);
    if (e.lineTo(ae.x, ae.y), w > 0) {
      const ne = Yd(E, k, i, o);
      e.arc(ne.x, ne.y, w, y - oa, k);
    }
  } else {
    e.moveTo(i, o);
    const G = Math.cos(k) * d + i, Y = Math.sin(k) * d + o;
    e.lineTo(G, Y);
    const te = Math.cos(A) * d + i, ae = Math.sin(A) * d + o;
    e.lineTo(te, ae);
  }
  e.closePath();
}
function q4e(e, t, r, n, a) {
  const { fullCircles: s, startAngle: i, circumference: o } = t;
  let l = t.endAngle;
  if (s) {
    Db(e, t, r, n, l, a);
    for (let c = 0; c < s; ++c)
      e.fill();
    isNaN(o) || (l = i + (o % En || En));
  }
  return Db(e, t, r, n, l, a), e.fill(), l;
}
function G4e(e, t, r, n, a) {
  const { fullCircles: s, startAngle: i, circumference: o, options: l } = t, { borderWidth: c, borderJoinStyle: u, borderDash: d, borderDashOffset: f } = l, h = l.borderAlign === "inner";
  if (!c)
    return;
  e.setLineDash(d || []), e.lineDashOffset = f, h ? (e.lineWidth = c * 2, e.lineJoin = u || "round") : (e.lineWidth = c, e.lineJoin = u || "bevel");
  let p = t.endAngle;
  if (s) {
    Db(e, t, r, n, p, a);
    for (let m = 0; m < s; ++m)
      e.stroke();
    isNaN(o) || (p = i + (o % En || En));
  }
  h && W4e(e, t, p), s || (Db(e, t, r, n, p, a), e.stroke());
}
class Rf extends Kl {
  constructor(r) {
    super();
    Fe(this, "circumference");
    Fe(this, "endAngle");
    Fe(this, "fullCircles");
    Fe(this, "innerRadius");
    Fe(this, "outerRadius");
    Fe(this, "pixelMargin");
    Fe(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, r && Object.assign(this, r);
  }
  inRange(r, n, a) {
    const s = this.getProps([
      "x",
      "y"
    ], a), { angle: i, distance: o } = mV(s, {
      x: r,
      y: n
    }), { startAngle: l, endAngle: c, innerRadius: u, outerRadius: d, circumference: f } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], a), h = (this.options.spacing + this.options.borderWidth) / 2, p = gr(f, c - l), m = og(i, l, c) && l !== c, g = p >= En || m, y = Tl(o, u + h, d + h);
    return g && y;
  }
  getCenterPoint(r) {
    const { x: n, y: a, startAngle: s, endAngle: i, innerRadius: o, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], r), { offset: c, spacing: u } = this.options, d = (s + i) / 2, f = (o + l + u + c) / 2;
    return {
      x: n + Math.cos(d) * f,
      y: a + Math.sin(d) * f
    };
  }
  tooltipPosition(r) {
    return this.getCenterPoint(r);
  }
  draw(r) {
    const { options: n, circumference: a } = this, s = (n.offset || 0) / 4, i = (n.spacing || 0) / 2, o = n.circular;
    if (this.pixelMargin = n.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = a > En ? Math.floor(a / En) : 0, a === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    r.save();
    const l = (this.startAngle + this.endAngle) / 2;
    r.translate(Math.cos(l) * s, Math.sin(l) * s);
    const c = 1 - Math.sin(Math.min(Pn, a || 0)), u = s * c;
    r.fillStyle = n.backgroundColor, r.strokeStyle = n.borderColor, q4e(r, this, u, i, o), G4e(r, this, u, i, o), r.restore();
  }
}
Fe(Rf, "id", "arc"), Fe(Rf, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), Fe(Rf, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), Fe(Rf, "descriptors", {
  _scriptable: !0,
  _indexable: (r) => r !== "borderDash"
});
function zV(e, t, r = t) {
  e.lineCap = gr(r.borderCapStyle, t.borderCapStyle), e.setLineDash(gr(r.borderDash, t.borderDash)), e.lineDashOffset = gr(r.borderDashOffset, t.borderDashOffset), e.lineJoin = gr(r.borderJoinStyle, t.borderJoinStyle), e.lineWidth = gr(r.borderWidth, t.borderWidth), e.strokeStyle = gr(r.borderColor, t.borderColor);
}
function Y4e(e, t, r) {
  e.lineTo(r.x, r.y);
}
function X4e(e) {
  return e.stepped ? wLe : e.tension || e.cubicInterpolationMode === "monotone" ? xLe : Y4e;
}
function KV(e, t, r = {}) {
  const n = e.length, { start: a = 0, end: s = n - 1 } = r, { start: i, end: o } = t, l = Math.max(a, i), c = Math.min(s, o), u = a < i && s < i || a > o && s > o;
  return {
    count: n,
    start: l,
    loop: t.loop,
    ilen: c < l && !u ? n + c - l : c - l
  };
}
function Q4e(e, t, r, n) {
  const { points: a, options: s } = t, { count: i, start: o, loop: l, ilen: c } = KV(a, r, n), u = X4e(s);
  let { move: d = !0, reverse: f } = n || {}, h, p, m;
  for (h = 0; h <= c; ++h)
    p = a[(o + (f ? c - h : h)) % i], !p.skip && (d ? (e.moveTo(p.x, p.y), d = !1) : u(e, m, p, f, s.stepped), m = p);
  return l && (p = a[(o + (f ? c : 0)) % i], u(e, m, p, f, s.stepped)), !!l;
}
function J4e(e, t, r, n) {
  const a = t.points, { count: s, start: i, ilen: o } = KV(a, r, n), { move: l = !0, reverse: c } = n || {};
  let u = 0, d = 0, f, h, p, m, g, y;
  const x = (_) => (i + (c ? o - _ : _)) % s, w = () => {
    m !== g && (e.lineTo(u, g), e.lineTo(u, m), e.lineTo(u, y));
  };
  for (l && (h = a[x(0)], e.moveTo(h.x, h.y)), f = 0; f <= o; ++f) {
    if (h = a[x(f)], h.skip)
      continue;
    const _ = h.x, S = h.y, C = _ | 0;
    C === p ? (S < m ? m = S : S > g && (g = S), u = (d * u + _) / ++d) : (w(), e.lineTo(_, S), p = C, d = 0, m = g = S), y = S;
  }
  w();
}
function sT(e) {
  const t = e.options, r = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !r ? J4e : Q4e;
}
function Z4e(e) {
  return e.stepped ? ZLe : e.tension || e.cubicInterpolationMode === "monotone" ? eje : mu;
}
function e3e(e, t, r, n) {
  let a = t._path;
  a || (a = t._path = new Path2D(), t.path(a, r, n) && a.closePath()), zV(e, t.options), e.stroke(a);
}
function t3e(e, t, r, n) {
  const { segments: a, options: s } = t, i = sT(t);
  for (const o of a)
    zV(e, s, o.style), e.beginPath(), i(e, t, o, {
      start: r,
      end: r + n - 1
    }) && e.closePath(), e.stroke();
}
const r3e = typeof Path2D == "function";
function n3e(e, t, r, n) {
  r3e && !t.options.segment ? e3e(e, t, r, n) : t3e(e, t, r, n);
}
class To extends Kl {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, r) {
    const n = this.options;
    if ((n.tension || n.cubicInterpolationMode === "monotone") && !n.stepped && !this._pointsUpdated) {
      const a = n.spanGaps ? this._loop : this._fullLoop;
      zLe(this._points, n, t, a, r), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = ije(this, this.options.segment));
  }
  first() {
    const t = this.segments, r = this.points;
    return t.length && r[t[0].start];
  }
  last() {
    const t = this.segments, r = this.points, n = t.length;
    return n && r[t[n - 1].end];
  }
  interpolate(t, r) {
    const n = this.options, a = t[r], s = this.points, i = IV(this, {
      property: r,
      start: a,
      end: a
    });
    if (!i.length)
      return;
    const o = [], l = Z4e(n);
    let c, u;
    for (c = 0, u = i.length; c < u; ++c) {
      const { start: d, end: f } = i[c], h = s[d], p = s[f];
      if (h === p) {
        o.push(h);
        continue;
      }
      const m = Math.abs((a - h[r]) / (p[r] - h[r])), g = l(h, p, m, n.stepped);
      g[r] = t[r], o.push(g);
    }
    return o.length === 1 ? o[0] : o;
  }
  pathSegment(t, r, n) {
    return sT(this)(t, this, r, n);
  }
  path(t, r, n) {
    const a = this.segments, s = sT(this);
    let i = this._loop;
    r = r || 0, n = n || this.points.length - r;
    for (const o of a)
      i &= s(t, this, o, {
        start: r,
        end: r + n - 1
      });
    return !!i;
  }
  draw(t, r, n, a) {
    const s = this.options || {};
    (this.points || []).length && s.borderWidth && (t.save(), n3e(t, this, n, a), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
Fe(To, "id", "line"), Fe(To, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), Fe(To, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), Fe(To, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function UM(e, t, r, n) {
  const a = e.options, { [r]: s } = e.getProps([
    r
  ], n);
  return Math.abs(t - s) < a.radius + a.hitRadius;
}
class Vf extends Kl {
  constructor(r) {
    super();
    Fe(this, "parsed");
    Fe(this, "skip");
    Fe(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, r && Object.assign(this, r);
  }
  inRange(r, n, a) {
    const s = this.options, { x: i, y: o } = this.getProps([
      "x",
      "y"
    ], a);
    return Math.pow(r - i, 2) + Math.pow(n - o, 2) < Math.pow(s.hitRadius + s.radius, 2);
  }
  inXRange(r, n) {
    return UM(this, r, "x", n);
  }
  inYRange(r, n) {
    return UM(this, r, "y", n);
  }
  getCenterPoint(r) {
    const { x: n, y: a } = this.getProps([
      "x",
      "y"
    ], r);
    return {
      x: n,
      y: a
    };
  }
  size(r) {
    r = r || this.options || {};
    let n = r.radius || 0;
    n = Math.max(n, n && r.hoverRadius || 0);
    const a = n && r.borderWidth || 0;
    return (n + a) * 2;
  }
  draw(r, n) {
    const a = this.options;
    this.skip || a.radius < 0.1 || !lg(this, n, this.size(a) / 2) || (r.strokeStyle = a.borderColor, r.lineWidth = a.borderWidth, r.fillStyle = a.backgroundColor, rT(r, a, this.x, this.y));
  }
  getRange() {
    const r = this.options || {};
    return r.radius + r.hitRadius;
  }
}
Fe(Vf, "id", "point"), /**
* @type {any}
*/
Fe(Vf, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
Fe(Vf, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function qV(e, t) {
  const { x: r, y: n, base: a, width: s, height: i } = e.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let o, l, c, u, d;
  return e.horizontal ? (d = i / 2, o = Math.min(r, a), l = Math.max(r, a), c = n - d, u = n + d) : (d = s / 2, o = r - d, l = r + d, c = Math.min(n, a), u = Math.max(n, a)), {
    left: o,
    top: c,
    right: l,
    bottom: u
  };
}
function wc(e, t, r, n) {
  return e ? 0 : qa(t, r, n);
}
function a3e(e, t, r) {
  const n = e.options.borderWidth, a = e.borderSkipped, s = _V(n);
  return {
    t: wc(a.top, s.top, 0, r),
    r: wc(a.right, s.right, 0, t),
    b: wc(a.bottom, s.bottom, 0, r),
    l: wc(a.left, s.left, 0, t)
  };
}
function s3e(e, t, r) {
  const { enableBorderRadius: n } = e.getProps([
    "enableBorderRadius"
  ]), a = e.options.borderRadius, s = Bf(a), i = Math.min(t, r), o = e.borderSkipped, l = n || wr(a);
  return {
    topLeft: wc(!l || o.top || o.left, s.topLeft, 0, i),
    topRight: wc(!l || o.top || o.right, s.topRight, 0, i),
    bottomLeft: wc(!l || o.bottom || o.left, s.bottomLeft, 0, i),
    bottomRight: wc(!l || o.bottom || o.right, s.bottomRight, 0, i)
  };
}
function i3e(e) {
  const t = qV(e), r = t.right - t.left, n = t.bottom - t.top, a = a3e(e, r / 2, n / 2), s = s3e(e, r / 2, n / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: r,
      h: n,
      radius: s
    },
    inner: {
      x: t.left + a.l,
      y: t.top + a.t,
      w: r - a.l - a.r,
      h: n - a.t - a.b,
      radius: {
        topLeft: Math.max(0, s.topLeft - Math.max(a.t, a.l)),
        topRight: Math.max(0, s.topRight - Math.max(a.t, a.r)),
        bottomLeft: Math.max(0, s.bottomLeft - Math.max(a.b, a.l)),
        bottomRight: Math.max(0, s.bottomRight - Math.max(a.b, a.r))
      }
    }
  };
}
function tS(e, t, r, n) {
  const a = t === null, s = r === null, o = e && !(a && s) && qV(e, n);
  return o && (a || Tl(t, o.left, o.right)) && (s || Tl(r, o.top, o.bottom));
}
function o3e(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function l3e(e, t) {
  e.rect(t.x, t.y, t.w, t.h);
}
function rS(e, t, r = {}) {
  const n = e.x !== r.x ? -t : 0, a = e.y !== r.y ? -t : 0, s = (e.x + e.w !== r.x + r.w ? t : 0) - n, i = (e.y + e.h !== r.y + r.h ? t : 0) - a;
  return {
    x: e.x + n,
    y: e.y + a,
    w: e.w + s,
    h: e.h + i,
    radius: e.radius
  };
}
class $f extends Kl {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: r, options: { borderColor: n, backgroundColor: a } } = this, { inner: s, outer: i } = i3e(this), o = o3e(i.radius) ? Pb : l3e;
    t.save(), (i.w !== s.w || i.h !== s.h) && (t.beginPath(), o(t, rS(i, r, s)), t.clip(), o(t, rS(s, -r, i)), t.fillStyle = n, t.fill("evenodd")), t.beginPath(), o(t, rS(s, r)), t.fillStyle = a, t.fill(), t.restore();
  }
  inRange(t, r, n) {
    return tS(this, t, r, n);
  }
  inXRange(t, r) {
    return tS(this, t, null, r);
  }
  inYRange(t, r) {
    return tS(this, null, t, r);
  }
  getCenterPoint(t) {
    const { x: r, y: n, base: a, horizontal: s } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: s ? (r + a) / 2 : r,
      y: s ? n : (n + a) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
Fe($f, "id", "bar"), Fe($f, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), Fe($f, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function c3e(e, t, r) {
  const n = e.segments, a = e.points, s = t.points, i = [];
  for (const o of n) {
    let { start: l, end: c } = o;
    c = zk(l, c, a);
    const u = iT(r, a[l], a[c], o.loop);
    if (!t.segments) {
      i.push({
        source: o,
        target: u,
        start: a[l],
        end: a[c]
      });
      continue;
    }
    const d = IV(t, u);
    for (const f of d) {
      const h = iT(r, s[f.start], s[f.end], f.loop), p = RV(o, a, h);
      for (const m of p)
        i.push({
          source: m,
          target: f,
          start: {
            [r]: VM(u, h, "start", Math.max)
          },
          end: {
            [r]: VM(u, h, "end", Math.min)
          }
        });
    }
  }
  return i;
}
function iT(e, t, r, n) {
  if (n)
    return;
  let a = t[e], s = r[e];
  return e === "angle" && (a = vo(a), s = vo(s)), {
    property: e,
    start: a,
    end: s
  };
}
function u3e(e, t) {
  const { x: r = null, y: n = null } = e || {}, a = t.points, s = [];
  return t.segments.forEach(({ start: i, end: o }) => {
    o = zk(i, o, a);
    const l = a[i], c = a[o];
    n !== null ? (s.push({
      x: l.x,
      y: n
    }), s.push({
      x: c.x,
      y: n
    })) : r !== null && (s.push({
      x: r,
      y: l.y
    }), s.push({
      x: r,
      y: c.y
    }));
  }), s;
}
function zk(e, t, r) {
  for (; t > e; t--) {
    const n = r[t];
    if (!isNaN(n.x) && !isNaN(n.y))
      break;
  }
  return t;
}
function VM(e, t, r, n) {
  return e && t ? n(e[r], t[r]) : e ? e[r] : t ? t[r] : 0;
}
function GV(e, t) {
  let r = [], n = !1;
  return Jn(e) ? (n = !0, r = e) : r = u3e(e, t), r.length ? new To({
    points: r,
    options: {
      tension: 0
    },
    _loop: n,
    _fullLoop: n
  }) : null;
}
function $M(e) {
  return e && e.fill !== !1;
}
function d3e(e, t, r) {
  let a = e[t].fill;
  const s = [
    t
  ];
  let i;
  if (!r)
    return a;
  for (; a !== !1 && s.indexOf(a) === -1; ) {
    if (!Ja(a))
      return a;
    if (i = e[a], !i)
      return !1;
    if (i.visible)
      return a;
    s.push(a), a = i.fill;
  }
  return !1;
}
function f3e(e, t, r) {
  const n = g3e(e);
  if (wr(n))
    return isNaN(n.value) ? !1 : n;
  let a = parseFloat(n);
  return Ja(a) && Math.floor(a) === a ? h3e(n[0], t, a, r) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(n) >= 0 && n;
}
function h3e(e, t, r, n) {
  return (e === "-" || e === "+") && (r = t + r), r === t || r < 0 || r >= n ? !1 : r;
}
function p3e(e, t) {
  let r = null;
  return e === "start" ? r = t.bottom : e === "end" ? r = t.top : wr(e) ? r = t.getPixelForValue(e.value) : t.getBasePixel && (r = t.getBasePixel()), r;
}
function m3e(e, t, r) {
  let n;
  return e === "start" ? n = r : e === "end" ? n = t.options.reverse ? t.min : t.max : wr(e) ? n = e.value : n = t.getBaseValue(), n;
}
function g3e(e) {
  const t = e.options, r = t.fill;
  let n = gr(r && r.target, r);
  return n === void 0 && (n = !!t.backgroundColor), n === !1 || n === null ? !1 : n === !0 ? "origin" : n;
}
function v3e(e) {
  const { scale: t, index: r, line: n } = e, a = [], s = n.segments, i = n.points, o = y3e(t, r);
  o.push(GV({
    x: null,
    y: t.bottom
  }, n));
  for (let l = 0; l < s.length; l++) {
    const c = s[l];
    for (let u = c.start; u <= c.end; u++)
      b3e(a, i[u], o);
  }
  return new To({
    points: a,
    options: {}
  });
}
function y3e(e, t) {
  const r = [], n = e.getMatchingVisibleMetas("line");
  for (let a = 0; a < n.length; a++) {
    const s = n[a];
    if (s.index === t)
      break;
    s.hidden || r.unshift(s.dataset);
  }
  return r;
}
function b3e(e, t, r) {
  const n = [];
  for (let a = 0; a < r.length; a++) {
    const s = r[a], { first: i, last: o, point: l } = w3e(s, t, "x");
    if (!(!l || i && o)) {
      if (i)
        n.unshift(l);
      else if (e.push(l), !o)
        break;
    }
  }
  e.push(...n);
}
function w3e(e, t, r) {
  const n = e.interpolate(t, r);
  if (!n)
    return {};
  const a = n[r], s = e.segments, i = e.points;
  let o = !1, l = !1;
  for (let c = 0; c < s.length; c++) {
    const u = s[c], d = i[u.start][r], f = i[u.end][r];
    if (Tl(a, d, f)) {
      o = a === d, l = a === f;
      break;
    }
  }
  return {
    first: o,
    last: l,
    point: n
  };
}
class YV {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, r, n) {
    const { x: a, y: s, radius: i } = this;
    return r = r || {
      start: 0,
      end: En
    }, t.arc(a, s, i, r.end, r.start, !0), !n.bounds;
  }
  interpolate(t) {
    const { x: r, y: n, radius: a } = this, s = t.angle;
    return {
      x: r + Math.cos(s) * a,
      y: n + Math.sin(s) * a,
      angle: s
    };
  }
}
function x3e(e) {
  const { chart: t, fill: r, line: n } = e;
  if (Ja(r))
    return _3e(t, r);
  if (r === "stack")
    return v3e(e);
  if (r === "shape")
    return !0;
  const a = S3e(e);
  return a instanceof YV ? a : GV(a, n);
}
function _3e(e, t) {
  const r = e.getDatasetMeta(t);
  return r && e.isDatasetVisible(t) ? r.dataset : null;
}
function S3e(e) {
  return (e.scale || {}).getPointPositionForValue ? T3e(e) : E3e(e);
}
function E3e(e) {
  const { scale: t = {}, fill: r } = e, n = p3e(r, t);
  if (Ja(n)) {
    const a = t.isHorizontal();
    return {
      x: a ? n : null,
      y: a ? null : n
    };
  }
  return null;
}
function T3e(e) {
  const { scale: t, fill: r } = e, n = t.options, a = t.getLabels().length, s = n.reverse ? t.max : t.min, i = m3e(r, t, s), o = [];
  if (n.grid.circular) {
    const l = t.getPointPositionForValue(0, s);
    return new YV({
      x: l.x,
      y: l.y,
      radius: t.getDistanceFromCenterForValue(i)
    });
  }
  for (let l = 0; l < a; ++l)
    o.push(t.getPointPositionForValue(l, i));
  return o;
}
function nS(e, t, r) {
  const n = x3e(t), { line: a, scale: s, axis: i } = t, o = a.options, l = o.fill, c = o.backgroundColor, { above: u = c, below: d = c } = l || {};
  n && a.points.length && (gx(e, r), C3e(e, {
    line: a,
    target: n,
    above: u,
    below: d,
    area: r,
    scale: s,
    axis: i
  }), vx(e));
}
function C3e(e, t) {
  const { line: r, target: n, above: a, below: s, area: i, scale: o } = t, l = r._loop ? "angle" : t.axis;
  e.save(), l === "x" && s !== a && (HM(e, n, i.top), WM(e, {
    line: r,
    target: n,
    color: a,
    scale: o,
    property: l
  }), e.restore(), e.save(), HM(e, n, i.bottom)), WM(e, {
    line: r,
    target: n,
    color: s,
    scale: o,
    property: l
  }), e.restore();
}
function HM(e, t, r) {
  const { segments: n, points: a } = t;
  let s = !0, i = !1;
  e.beginPath();
  for (const o of n) {
    const { start: l, end: c } = o, u = a[l], d = a[zk(l, c, a)];
    s ? (e.moveTo(u.x, u.y), s = !1) : (e.lineTo(u.x, r), e.lineTo(u.x, u.y)), i = !!t.pathSegment(e, o, {
      move: i
    }), i ? e.closePath() : e.lineTo(d.x, r);
  }
  e.lineTo(t.first().x, r), e.closePath(), e.clip();
}
function WM(e, t) {
  const { line: r, target: n, property: a, color: s, scale: i } = t, o = c3e(r, n, a);
  for (const { source: l, target: c, start: u, end: d } of o) {
    const { style: { backgroundColor: f = s } = {} } = l, h = n !== !0;
    e.save(), e.fillStyle = f, k3e(e, i, h && iT(a, u, d)), e.beginPath();
    const p = !!r.pathSegment(e, l);
    let m;
    if (h) {
      p ? e.closePath() : zM(e, n, d, a);
      const g = !!n.pathSegment(e, c, {
        move: p,
        reverse: !0
      });
      m = p && g, m || zM(e, n, u, a);
    }
    e.closePath(), e.fill(m ? "evenodd" : "nonzero"), e.restore();
  }
}
function k3e(e, t, r) {
  const { top: n, bottom: a } = t.chart.chartArea, { property: s, start: i, end: o } = r || {};
  s === "x" && (e.beginPath(), e.rect(i, n, o - i, a - n), e.clip());
}
function zM(e, t, r, n) {
  const a = t.interpolate(r, n);
  a && e.lineTo(a.x, a.y);
}
var Kk = {
  id: "filler",
  afterDatasetsUpdate(e, t, r) {
    const n = (e.data.datasets || []).length, a = [];
    let s, i, o, l;
    for (i = 0; i < n; ++i)
      s = e.getDatasetMeta(i), o = s.dataset, l = null, o && o.options && o instanceof To && (l = {
        visible: e.isDatasetVisible(i),
        index: i,
        fill: f3e(o, i, n),
        chart: e,
        axis: s.controller.options.indexAxis,
        scale: s.vScale,
        line: o
      }), s.$filler = l, a.push(l);
    for (i = 0; i < n; ++i)
      l = a[i], !(!l || l.fill === !1) && (l.fill = d3e(a, i, r.propagate));
  },
  beforeDraw(e, t, r) {
    const n = r.drawTime === "beforeDraw", a = e.getSortedVisibleDatasetMetas(), s = e.chartArea;
    for (let i = a.length - 1; i >= 0; --i) {
      const o = a[i].$filler;
      o && (o.line.updateControlPoints(s, o.axis), n && o.fill && nS(e.ctx, o, s));
    }
  },
  beforeDatasetsDraw(e, t, r) {
    if (r.drawTime !== "beforeDatasetsDraw")
      return;
    const n = e.getSortedVisibleDatasetMetas();
    for (let a = n.length - 1; a >= 0; --a) {
      const s = n[a].$filler;
      $M(s) && nS(e.ctx, s, e.chartArea);
    }
  },
  beforeDatasetDraw(e, t, r) {
    const n = t.meta.$filler;
    !$M(n) || r.drawTime !== "beforeDatasetDraw" || nS(e.ctx, n, e.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const KM = (e, t) => {
  let { boxHeight: r = t, boxWidth: n = t } = e;
  return e.usePointStyle && (r = Math.min(r, t), n = e.pointStyleWidth || Math.min(n, t)), {
    boxWidth: n,
    boxHeight: r,
    itemHeight: Math.max(t, r)
  };
}, O3e = (e, t) => e !== null && t !== null && e.datasetIndex === t.datasetIndex && e.index === t.index;
class qM extends Kl {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, r, n) {
    this.maxWidth = t, this.maxHeight = r, this._margins = n, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let r = pn(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (r = r.filter((n) => t.filter(n, this.chart.data))), t.sort && (r = r.sort((n, a) => t.sort(n, a, this.chart.data))), this.options.reverse && r.reverse(), this.legendItems = r;
  }
  fit() {
    const { options: t, ctx: r } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const n = t.labels, a = Ga(n.font), s = a.size, i = this._computeTitleHeight(), { boxWidth: o, itemHeight: l } = KM(n, s);
    let c, u;
    r.font = a.string, this.isHorizontal() ? (c = this.maxWidth, u = this._fitRows(i, s, o, l) + 10) : (u = this.maxHeight, c = this._fitCols(i, a, o, l) + 10), this.width = Math.min(c, t.maxWidth || this.maxWidth), this.height = Math.min(u, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, r, n, a) {
    const { ctx: s, maxWidth: i, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], u = a + o;
    let d = t;
    s.textAlign = "left", s.textBaseline = "middle";
    let f = -1, h = -u;
    return this.legendItems.forEach((p, m) => {
      const g = n + r / 2 + s.measureText(p.text).width;
      (m === 0 || c[c.length - 1] + g + 2 * o > i) && (d += u, c[c.length - (m > 0 ? 0 : 1)] = 0, h += u, f++), l[m] = {
        left: 0,
        top: h,
        row: f,
        width: g,
        height: a
      }, c[c.length - 1] += g + o;
    }), d;
  }
  _fitCols(t, r, n, a) {
    const { ctx: s, maxHeight: i, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], u = i - t;
    let d = o, f = 0, h = 0, p = 0, m = 0;
    return this.legendItems.forEach((g, y) => {
      const { itemWidth: x, itemHeight: w } = A3e(n, r, s, g, a);
      y > 0 && h + w + 2 * o > u && (d += f + o, c.push({
        width: f,
        height: h
      }), p += f + o, m++, f = h = 0), l[y] = {
        left: p,
        top: h,
        col: m,
        width: x,
        height: w
      }, f = Math.max(f, x), h += w + o;
    }), d += f, c.push({
      width: f,
      height: h
    }), d;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: r, options: { align: n, labels: { padding: a }, rtl: s } } = this, i = Uf(s, this.left, this.width);
    if (this.isHorizontal()) {
      let o = 0, l = Ua(n, this.left + a, this.right - this.lineWidths[o]);
      for (const c of r)
        o !== c.row && (o = c.row, l = Ua(n, this.left + a, this.right - this.lineWidths[o])), c.top += this.top + t + a, c.left = i.leftForLtr(i.x(l), c.width), l += c.width + a;
    } else {
      let o = 0, l = Ua(n, this.top + t + a, this.bottom - this.columnSizes[o].height);
      for (const c of r)
        c.col !== o && (o = c.col, l = Ua(n, this.top + t + a, this.bottom - this.columnSizes[o].height)), c.top = l, c.left += this.left + a, c.left = i.leftForLtr(i.x(c.left), c.width), l += c.height + a;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      gx(t, this), this._draw(), vx(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: r, lineWidths: n, ctx: a } = this, { align: s, labels: i } = t, o = Wn.color, l = Uf(t.rtl, this.left, this.width), c = Ga(i.font), { padding: u } = i, d = c.size, f = d / 2;
    let h;
    this.drawTitle(), a.textAlign = l.textAlign("left"), a.textBaseline = "middle", a.lineWidth = 0.5, a.font = c.string;
    const { boxWidth: p, boxHeight: m, itemHeight: g } = KM(i, d), y = function(C, E, O) {
      if (isNaN(p) || p <= 0 || isNaN(m) || m < 0)
        return;
      a.save();
      const k = gr(O.lineWidth, 1);
      if (a.fillStyle = gr(O.fillStyle, o), a.lineCap = gr(O.lineCap, "butt"), a.lineDashOffset = gr(O.lineDashOffset, 0), a.lineJoin = gr(O.lineJoin, "miter"), a.lineWidth = k, a.strokeStyle = gr(O.strokeStyle, o), a.setLineDash(gr(O.lineDash, [])), i.usePointStyle) {
        const A = {
          radius: m * Math.SQRT2 / 2,
          pointStyle: O.pointStyle,
          rotation: O.rotation,
          borderWidth: k
        }, P = l.xPlus(C, p / 2), D = E + f;
        xV(a, A, P, D, i.pointStyleWidth && p);
      } else {
        const A = E + Math.max((d - m) / 2, 0), P = l.leftForLtr(C, p), D = Bf(O.borderRadius);
        a.beginPath(), Object.values(D).some((N) => N !== 0) ? Pb(a, {
          x: P,
          y: A,
          w: p,
          h: m,
          radius: D
        }) : a.rect(P, A, p, m), a.fill(), k !== 0 && a.stroke();
      }
      a.restore();
    }, x = function(C, E, O) {
      cg(a, O.text, C, E + g / 2, c, {
        strikethrough: O.hidden,
        textAlign: l.textAlign(O.textAlign)
      });
    }, w = this.isHorizontal(), _ = this._computeTitleHeight();
    w ? h = {
      x: Ua(s, this.left + u, this.right - n[0]),
      y: this.top + u + _,
      line: 0
    } : h = {
      x: this.left + u,
      y: Ua(s, this.top + _ + u, this.bottom - r[0].height),
      line: 0
    }, OV(this.ctx, t.textDirection);
    const S = g + u;
    this.legendItems.forEach((C, E) => {
      a.strokeStyle = C.fontColor, a.fillStyle = C.fontColor;
      const O = a.measureText(C.text).width, k = l.textAlign(C.textAlign || (C.textAlign = i.textAlign)), A = p + f + O;
      let P = h.x, D = h.y;
      l.setWidth(this.width), w ? E > 0 && P + A + u > this.right && (D = h.y += S, h.line++, P = h.x = Ua(s, this.left + u, this.right - n[h.line])) : E > 0 && D + S > this.bottom && (P = h.x = P + r[h.line].width + u, h.line++, D = h.y = Ua(s, this.top + _ + u, this.bottom - r[h.line].height));
      const N = l.x(P);
      if (y(N, D, C), P = oLe(k, P + p + f, w ? P + A : this.right, t.rtl), x(l.x(P), D, C), w)
        h.x += A + u;
      else if (typeof C.text != "string") {
        const z = c.lineHeight;
        h.y += XV(C, z) + u;
      } else
        h.y += S;
    }), AV(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, r = t.title, n = Ga(r.font), a = mi(r.padding);
    if (!r.display)
      return;
    const s = Uf(t.rtl, this.left, this.width), i = this.ctx, o = r.position, l = n.size / 2, c = a.top + l;
    let u, d = this.left, f = this.width;
    if (this.isHorizontal())
      f = Math.max(...this.lineWidths), u = this.top + c, d = Ua(t.align, d, this.right - f);
    else {
      const p = this.columnSizes.reduce((m, g) => Math.max(m, g.height), 0);
      u = c + Ua(t.align, this.top, this.bottom - p - t.labels.padding - this._computeTitleHeight());
    }
    const h = Ua(o, d, d + f);
    i.textAlign = s.textAlign(Mk(o)), i.textBaseline = "middle", i.strokeStyle = r.color, i.fillStyle = r.color, i.font = n.string, cg(i, r.text, h, u, n);
  }
  _computeTitleHeight() {
    const t = this.options.title, r = Ga(t.font), n = mi(t.padding);
    return t.display ? r.lineHeight + n.height : 0;
  }
  _getLegendItemAt(t, r) {
    let n, a, s;
    if (Tl(t, this.left, this.right) && Tl(r, this.top, this.bottom)) {
      for (s = this.legendHitBoxes, n = 0; n < s.length; ++n)
        if (a = s[n], Tl(t, a.left, a.left + a.width) && Tl(r, a.top, a.top + a.height))
          return this.legendItems[n];
    }
    return null;
  }
  handleEvent(t) {
    const r = this.options;
    if (!I3e(t.type, r))
      return;
    const n = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const a = this._hoveredItem, s = O3e(a, n);
      a && !s && pn(r.onLeave, [
        t,
        a,
        this
      ], this), this._hoveredItem = n, n && !s && pn(r.onHover, [
        t,
        n,
        this
      ], this);
    } else n && pn(r.onClick, [
      t,
      n,
      this
    ], this);
  }
}
function A3e(e, t, r, n, a) {
  const s = P3e(n, e, t, r), i = R3e(a, n, t.lineHeight);
  return {
    itemWidth: s,
    itemHeight: i
  };
}
function P3e(e, t, r, n) {
  let a = e.text;
  return a && typeof a != "string" && (a = a.reduce((s, i) => s.length > i.length ? s : i)), t + r.size / 2 + n.measureText(a).width;
}
function R3e(e, t, r) {
  let n = e;
  return typeof t.text != "string" && (n = XV(t, r)), n;
}
function XV(e, t) {
  const r = e.text ? e.text.length : 0;
  return t * r;
}
function I3e(e, t) {
  return !!((e === "mousemove" || e === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (e === "click" || e === "mouseup"));
}
var Yc = {
  id: "legend",
  _element: qM,
  start(e, t, r) {
    const n = e.legend = new qM({
      ctx: e.ctx,
      options: r,
      chart: e
    });
    li.configure(e, n, r), li.addBox(e, n);
  },
  stop(e) {
    li.removeBox(e, e.legend), delete e.legend;
  },
  beforeUpdate(e, t, r) {
    const n = e.legend;
    li.configure(e, n, r), n.options = r;
  },
  afterUpdate(e) {
    const t = e.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(e, t) {
    t.replay || e.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(e, t, r) {
      const n = t.datasetIndex, a = r.chart;
      a.isDatasetVisible(n) ? (a.hide(n), t.hidden = !0) : (a.show(n), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (e) => e.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(e) {
        const t = e.data.datasets, { labels: { usePointStyle: r, pointStyle: n, textAlign: a, color: s, useBorderRadius: i, borderRadius: o } } = e.legend.options;
        return e._getSortedDatasetMetas().map((l) => {
          const c = l.controller.getStyle(r ? 0 : void 0), u = mi(c.borderWidth);
          return {
            text: t[l.index].label,
            fillStyle: c.backgroundColor,
            fontColor: s,
            hidden: !l.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (u.width + u.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: n || c.pointStyle,
            rotation: c.rotation,
            textAlign: a || c.textAlign,
            borderRadius: i && (o || c.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (e) => e.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (e) => !e.startsWith("on"),
    labels: {
      _scriptable: (e) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(e)
    }
  }
};
class QV extends Kl {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, r) {
    const n = this.options;
    if (this.left = 0, this.top = 0, !n.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = r;
    const a = Jn(n.text) ? n.text.length : 1;
    this._padding = mi(n.padding);
    const s = a * Ga(n.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = s : this.width = s;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: r, left: n, bottom: a, right: s, options: i } = this, o = i.align;
    let l = 0, c, u, d;
    return this.isHorizontal() ? (u = Ua(o, n, s), d = r + t, c = s - n) : (i.position === "left" ? (u = n + t, d = Ua(o, a, r), l = Pn * -0.5) : (u = s - t, d = Ua(o, r, a), l = Pn * 0.5), c = a - r), {
      titleX: u,
      titleY: d,
      maxWidth: c,
      rotation: l
    };
  }
  draw() {
    const t = this.ctx, r = this.options;
    if (!r.display)
      return;
    const n = Ga(r.font), s = n.lineHeight / 2 + this._padding.top, { titleX: i, titleY: o, maxWidth: l, rotation: c } = this._drawArgs(s);
    cg(t, r.text, 0, 0, n, {
      color: r.color,
      maxWidth: l,
      rotation: c,
      textAlign: Mk(r.align),
      textBaseline: "middle",
      translation: [
        i,
        o
      ]
    });
  }
}
function D3e(e, t) {
  const r = new QV({
    ctx: e.ctx,
    options: t,
    chart: e
  });
  li.configure(e, r, t), li.addBox(e, r), e.titleBlock = r;
}
var Uh = {
  id: "title",
  _element: QV,
  start(e, t, r) {
    D3e(e, r);
  },
  stop(e) {
    const t = e.titleBlock;
    li.removeBox(e, t), delete e.titleBlock;
  },
  beforeUpdate(e, t, r) {
    const n = e.titleBlock;
    li.configure(e, n, r), n.options = r;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const am = {
  average(e) {
    if (!e.length)
      return !1;
    let t, r, n = /* @__PURE__ */ new Set(), a = 0, s = 0;
    for (t = 0, r = e.length; t < r; ++t) {
      const o = e[t].element;
      if (o && o.hasValue()) {
        const l = o.tooltipPosition();
        n.add(l.x), a += l.y, ++s;
      }
    }
    return s === 0 || n.size === 0 ? !1 : {
      x: [
        ...n
      ].reduce((o, l) => o + l) / n.size,
      y: a / s
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let r = t.x, n = t.y, a = Number.POSITIVE_INFINITY, s, i, o;
    for (s = 0, i = e.length; s < i; ++s) {
      const l = e[s].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), u = eT(t, c);
        u < a && (a = u, o = l);
      }
    }
    if (o) {
      const l = o.tooltipPosition();
      r = l.x, n = l.y;
    }
    return {
      x: r,
      y: n
    };
  }
};
function co(e, t) {
  return t && (Jn(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function gl(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function N3e(e, t) {
  const { element: r, datasetIndex: n, index: a } = t, s = e.getDatasetMeta(n).controller, { label: i, value: o } = s.getLabelAndValue(a);
  return {
    chart: e,
    label: i,
    parsed: s.getParsed(a),
    raw: e.data.datasets[n].data[a],
    formattedValue: o,
    dataset: s.getDataset(),
    dataIndex: a,
    datasetIndex: n,
    element: r
  };
}
function GM(e, t) {
  const r = e.chart.ctx, { body: n, footer: a, title: s } = e, { boxWidth: i, boxHeight: o } = t, l = Ga(t.bodyFont), c = Ga(t.titleFont), u = Ga(t.footerFont), d = s.length, f = a.length, h = n.length, p = mi(t.padding);
  let m = p.height, g = 0, y = n.reduce((_, S) => _ + S.before.length + S.lines.length + S.after.length, 0);
  if (y += e.beforeBody.length + e.afterBody.length, d && (m += d * c.lineHeight + (d - 1) * t.titleSpacing + t.titleMarginBottom), y) {
    const _ = t.displayColors ? Math.max(o, l.lineHeight) : l.lineHeight;
    m += h * _ + (y - h) * l.lineHeight + (y - 1) * t.bodySpacing;
  }
  f && (m += t.footerMarginTop + f * u.lineHeight + (f - 1) * t.footerSpacing);
  let x = 0;
  const w = function(_) {
    g = Math.max(g, r.measureText(_).width + x);
  };
  return r.save(), r.font = c.string, Gr(e.title, w), r.font = l.string, Gr(e.beforeBody.concat(e.afterBody), w), x = t.displayColors ? i + 2 + t.boxPadding : 0, Gr(n, (_) => {
    Gr(_.before, w), Gr(_.lines, w), Gr(_.after, w);
  }), x = 0, r.font = u.string, Gr(e.footer, w), r.restore(), g += p.width, {
    width: g,
    height: m
  };
}
function M3e(e, t) {
  const { y: r, height: n } = t;
  return r < n / 2 ? "top" : r > e.height - n / 2 ? "bottom" : "center";
}
function L3e(e, t, r, n) {
  const { x: a, width: s } = n, i = r.caretSize + r.caretPadding;
  if (e === "left" && a + s + i > t.width || e === "right" && a - s - i < 0)
    return !0;
}
function j3e(e, t, r, n) {
  const { x: a, width: s } = r, { width: i, chartArea: { left: o, right: l } } = e;
  let c = "center";
  return n === "center" ? c = a <= (o + l) / 2 ? "left" : "right" : a <= s / 2 ? c = "left" : a >= i - s / 2 && (c = "right"), L3e(c, e, t, r) && (c = "center"), c;
}
function YM(e, t, r) {
  const n = r.yAlign || t.yAlign || M3e(e, r);
  return {
    xAlign: r.xAlign || t.xAlign || j3e(e, t, r, n),
    yAlign: n
  };
}
function F3e(e, t) {
  let { x: r, width: n } = e;
  return t === "right" ? r -= n : t === "center" && (r -= n / 2), r;
}
function B3e(e, t, r) {
  let { y: n, height: a } = e;
  return t === "top" ? n += r : t === "bottom" ? n -= a + r : n -= a / 2, n;
}
function XM(e, t, r, n) {
  const { caretSize: a, caretPadding: s, cornerRadius: i } = e, { xAlign: o, yAlign: l } = r, c = a + s, { topLeft: u, topRight: d, bottomLeft: f, bottomRight: h } = Bf(i);
  let p = F3e(t, o);
  const m = B3e(t, l, c);
  return l === "center" ? o === "left" ? p += c : o === "right" && (p -= c) : o === "left" ? p -= Math.max(u, f) + a : o === "right" && (p += Math.max(d, h) + a), {
    x: qa(p, 0, n.width - t.width),
    y: qa(m, 0, n.height - t.height)
  };
}
function V0(e, t, r) {
  const n = mi(r.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - n.right : e.x + n.left;
}
function QM(e) {
  return co([], gl(e));
}
function U3e(e, t, r) {
  return pd(e, {
    tooltip: t,
    tooltipItems: r,
    type: "tooltip"
  });
}
function JM(e, t) {
  const r = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return r ? e.override(r) : e;
}
const JV = {
  beforeTitle: sl,
  title(e) {
    if (e.length > 0) {
      const t = e[0], r = t.chart.data.labels, n = r ? r.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (n > 0 && t.dataIndex < n)
        return r[t.dataIndex];
    }
    return "";
  },
  afterTitle: sl,
  beforeBody: sl,
  beforeLabel: sl,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const r = e.formattedValue;
    return Vr(r) || (t += r), t;
  },
  labelColor(e) {
    const r = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: r.borderColor,
      backgroundColor: r.backgroundColor,
      borderWidth: r.borderWidth,
      borderDash: r.borderDash,
      borderDashOffset: r.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const r = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: r.pointStyle,
      rotation: r.rotation
    };
  },
  afterLabel: sl,
  afterBody: sl,
  beforeFooter: sl,
  footer: sl,
  afterFooter: sl
};
function gs(e, t, r, n) {
  const a = e[t].call(r, n);
  return typeof a > "u" ? JV[t].call(r, n) : a;
}
var KS;
let ZM = (KS = class extends Kl {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const r = this.chart, n = this.options.setContext(this.getContext()), a = n.enabled && r.options.animation && n.animations, s = new DV(this.chart, a);
    return a._cacheable && (this._cachedAnimations = Object.freeze(s)), s;
  }
  getContext() {
    return this.$context || (this.$context = U3e(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, r) {
    const { callbacks: n } = r, a = gs(n, "beforeTitle", this, t), s = gs(n, "title", this, t), i = gs(n, "afterTitle", this, t);
    let o = [];
    return o = co(o, gl(a)), o = co(o, gl(s)), o = co(o, gl(i)), o;
  }
  getBeforeBody(t, r) {
    return QM(gs(r.callbacks, "beforeBody", this, t));
  }
  getBody(t, r) {
    const { callbacks: n } = r, a = [];
    return Gr(t, (s) => {
      const i = {
        before: [],
        lines: [],
        after: []
      }, o = JM(n, s);
      co(i.before, gl(gs(o, "beforeLabel", this, s))), co(i.lines, gs(o, "label", this, s)), co(i.after, gl(gs(o, "afterLabel", this, s))), a.push(i);
    }), a;
  }
  getAfterBody(t, r) {
    return QM(gs(r.callbacks, "afterBody", this, t));
  }
  getFooter(t, r) {
    const { callbacks: n } = r, a = gs(n, "beforeFooter", this, t), s = gs(n, "footer", this, t), i = gs(n, "afterFooter", this, t);
    let o = [];
    return o = co(o, gl(a)), o = co(o, gl(s)), o = co(o, gl(i)), o;
  }
  _createItems(t) {
    const r = this._active, n = this.chart.data, a = [], s = [], i = [];
    let o = [], l, c;
    for (l = 0, c = r.length; l < c; ++l)
      o.push(N3e(this.chart, r[l]));
    return t.filter && (o = o.filter((u, d, f) => t.filter(u, d, f, n))), t.itemSort && (o = o.sort((u, d) => t.itemSort(u, d, n))), Gr(o, (u) => {
      const d = JM(t.callbacks, u);
      a.push(gs(d, "labelColor", this, u)), s.push(gs(d, "labelPointStyle", this, u)), i.push(gs(d, "labelTextColor", this, u));
    }), this.labelColors = a, this.labelPointStyles = s, this.labelTextColors = i, this.dataPoints = o, o;
  }
  update(t, r) {
    const n = this.options.setContext(this.getContext()), a = this._active;
    let s, i = [];
    if (!a.length)
      this.opacity !== 0 && (s = {
        opacity: 0
      });
    else {
      const o = am[n.position].call(this, a, this._eventPosition);
      i = this._createItems(n), this.title = this.getTitle(i, n), this.beforeBody = this.getBeforeBody(i, n), this.body = this.getBody(i, n), this.afterBody = this.getAfterBody(i, n), this.footer = this.getFooter(i, n);
      const l = this._size = GM(this, n), c = Object.assign({}, o, l), u = YM(this.chart, n, c), d = XM(n, c, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, s = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: l.width,
        height: l.height,
        caretX: o.x,
        caretY: o.y
      };
    }
    this._tooltipItems = i, this.$context = void 0, s && this._resolveAnimations().update(this, s), t && n.external && n.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: r
    });
  }
  drawCaret(t, r, n, a) {
    const s = this.getCaretPosition(t, n, a);
    r.lineTo(s.x1, s.y1), r.lineTo(s.x2, s.y2), r.lineTo(s.x3, s.y3);
  }
  getCaretPosition(t, r, n) {
    const { xAlign: a, yAlign: s } = this, { caretSize: i, cornerRadius: o } = n, { topLeft: l, topRight: c, bottomLeft: u, bottomRight: d } = Bf(o), { x: f, y: h } = t, { width: p, height: m } = r;
    let g, y, x, w, _, S;
    return s === "center" ? (_ = h + m / 2, a === "left" ? (g = f, y = g - i, w = _ + i, S = _ - i) : (g = f + p, y = g + i, w = _ - i, S = _ + i), x = g) : (a === "left" ? y = f + Math.max(l, u) + i : a === "right" ? y = f + p - Math.max(c, d) - i : y = this.caretX, s === "top" ? (w = h, _ = w - i, g = y - i, x = y + i) : (w = h + m, _ = w + i, g = y + i, x = y - i), S = w), {
      x1: g,
      x2: y,
      x3: x,
      y1: w,
      y2: _,
      y3: S
    };
  }
  drawTitle(t, r, n) {
    const a = this.title, s = a.length;
    let i, o, l;
    if (s) {
      const c = Uf(n.rtl, this.x, this.width);
      for (t.x = V0(this, n.titleAlign, n), r.textAlign = c.textAlign(n.titleAlign), r.textBaseline = "middle", i = Ga(n.titleFont), o = n.titleSpacing, r.fillStyle = n.titleColor, r.font = i.string, l = 0; l < s; ++l)
        r.fillText(a[l], c.x(t.x), t.y + i.lineHeight / 2), t.y += i.lineHeight + o, l + 1 === s && (t.y += n.titleMarginBottom - o);
    }
  }
  _drawColorBox(t, r, n, a, s) {
    const i = this.labelColors[n], o = this.labelPointStyles[n], { boxHeight: l, boxWidth: c } = s, u = Ga(s.bodyFont), d = V0(this, "left", s), f = a.x(d), h = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, p = r.y + h;
    if (s.usePointStyle) {
      const m = {
        radius: Math.min(c, l) / 2,
        pointStyle: o.pointStyle,
        rotation: o.rotation,
        borderWidth: 1
      }, g = a.leftForLtr(f, c) + c / 2, y = p + l / 2;
      t.strokeStyle = s.multiKeyBackground, t.fillStyle = s.multiKeyBackground, rT(t, m, g, y), t.strokeStyle = i.borderColor, t.fillStyle = i.backgroundColor, rT(t, m, g, y);
    } else {
      t.lineWidth = wr(i.borderWidth) ? Math.max(...Object.values(i.borderWidth)) : i.borderWidth || 1, t.strokeStyle = i.borderColor, t.setLineDash(i.borderDash || []), t.lineDashOffset = i.borderDashOffset || 0;
      const m = a.leftForLtr(f, c), g = a.leftForLtr(a.xPlus(f, 1), c - 2), y = Bf(i.borderRadius);
      Object.values(y).some((x) => x !== 0) ? (t.beginPath(), t.fillStyle = s.multiKeyBackground, Pb(t, {
        x: m,
        y: p,
        w: c,
        h: l,
        radius: y
      }), t.fill(), t.stroke(), t.fillStyle = i.backgroundColor, t.beginPath(), Pb(t, {
        x: g,
        y: p + 1,
        w: c - 2,
        h: l - 2,
        radius: y
      }), t.fill()) : (t.fillStyle = s.multiKeyBackground, t.fillRect(m, p, c, l), t.strokeRect(m, p, c, l), t.fillStyle = i.backgroundColor, t.fillRect(g, p + 1, c - 2, l - 2));
    }
    t.fillStyle = this.labelTextColors[n];
  }
  drawBody(t, r, n) {
    const { body: a } = this, { bodySpacing: s, bodyAlign: i, displayColors: o, boxHeight: l, boxWidth: c, boxPadding: u } = n, d = Ga(n.bodyFont);
    let f = d.lineHeight, h = 0;
    const p = Uf(n.rtl, this.x, this.width), m = function(O) {
      r.fillText(O, p.x(t.x + h), t.y + f / 2), t.y += f + s;
    }, g = p.textAlign(i);
    let y, x, w, _, S, C, E;
    for (r.textAlign = i, r.textBaseline = "middle", r.font = d.string, t.x = V0(this, g, n), r.fillStyle = n.bodyColor, Gr(this.beforeBody, m), h = o && g !== "right" ? i === "center" ? c / 2 + u : c + 2 + u : 0, _ = 0, C = a.length; _ < C; ++_) {
      for (y = a[_], x = this.labelTextColors[_], r.fillStyle = x, Gr(y.before, m), w = y.lines, o && w.length && (this._drawColorBox(r, t, _, p, n), f = Math.max(d.lineHeight, l)), S = 0, E = w.length; S < E; ++S)
        m(w[S]), f = d.lineHeight;
      Gr(y.after, m);
    }
    h = 0, f = d.lineHeight, Gr(this.afterBody, m), t.y -= s;
  }
  drawFooter(t, r, n) {
    const a = this.footer, s = a.length;
    let i, o;
    if (s) {
      const l = Uf(n.rtl, this.x, this.width);
      for (t.x = V0(this, n.footerAlign, n), t.y += n.footerMarginTop, r.textAlign = l.textAlign(n.footerAlign), r.textBaseline = "middle", i = Ga(n.footerFont), r.fillStyle = n.footerColor, r.font = i.string, o = 0; o < s; ++o)
        r.fillText(a[o], l.x(t.x), t.y + i.lineHeight / 2), t.y += i.lineHeight + n.footerSpacing;
    }
  }
  drawBackground(t, r, n, a) {
    const { xAlign: s, yAlign: i } = this, { x: o, y: l } = t, { width: c, height: u } = n, { topLeft: d, topRight: f, bottomLeft: h, bottomRight: p } = Bf(a.cornerRadius);
    r.fillStyle = a.backgroundColor, r.strokeStyle = a.borderColor, r.lineWidth = a.borderWidth, r.beginPath(), r.moveTo(o + d, l), i === "top" && this.drawCaret(t, r, n, a), r.lineTo(o + c - f, l), r.quadraticCurveTo(o + c, l, o + c, l + f), i === "center" && s === "right" && this.drawCaret(t, r, n, a), r.lineTo(o + c, l + u - p), r.quadraticCurveTo(o + c, l + u, o + c - p, l + u), i === "bottom" && this.drawCaret(t, r, n, a), r.lineTo(o + h, l + u), r.quadraticCurveTo(o, l + u, o, l + u - h), i === "center" && s === "left" && this.drawCaret(t, r, n, a), r.lineTo(o, l + d), r.quadraticCurveTo(o, l, o + d, l), r.closePath(), r.fill(), a.borderWidth > 0 && r.stroke();
  }
  _updateAnimationTarget(t) {
    const r = this.chart, n = this.$animations, a = n && n.x, s = n && n.y;
    if (a || s) {
      const i = am[t.position].call(this, this._active, this._eventPosition);
      if (!i)
        return;
      const o = this._size = GM(this, t), l = Object.assign({}, i, this._size), c = YM(r, t, l), u = XM(t, l, c, r);
      (a._to !== u.x || s._to !== u.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = o.width, this.height = o.height, this.caretX = i.x, this.caretY = i.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const r = this.options.setContext(this.getContext());
    let n = this.opacity;
    if (!n)
      return;
    this._updateAnimationTarget(r);
    const a = {
      width: this.width,
      height: this.height
    }, s = {
      x: this.x,
      y: this.y
    };
    n = Math.abs(n) < 1e-3 ? 0 : n;
    const i = mi(r.padding), o = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    r.enabled && o && (t.save(), t.globalAlpha = n, this.drawBackground(s, t, a, r), OV(t, r.textDirection), s.y += i.top, this.drawTitle(s, t, r), this.drawBody(s, t, r), this.drawFooter(s, t, r), AV(t, r.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, r) {
    const n = this._active, a = t.map(({ datasetIndex: o, index: l }) => {
      const c = this.chart.getDatasetMeta(o);
      if (!c)
        throw new Error("Cannot find a dataset at index " + o);
      return {
        datasetIndex: o,
        element: c.data[l],
        index: l
      };
    }), s = !kb(n, a), i = this._positionChanged(a, r);
    (s || i) && (this._active = a, this._eventPosition = r, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, r, n = !0) {
    if (r && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const a = this.options, s = this._active || [], i = this._getActiveElements(t, s, r, n), o = this._positionChanged(i, t), l = r || !kb(i, s) || o;
    return l && (this._active = i, (a.enabled || a.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, r))), l;
  }
  _getActiveElements(t, r, n, a) {
    const s = this.options;
    if (t.type === "mouseout")
      return [];
    if (!a)
      return r.filter((o) => this.chart.data.datasets[o.datasetIndex] && this.chart.getDatasetMeta(o.datasetIndex).controller.getParsed(o.index) !== void 0);
    const i = this.chart.getElementsAtEventForMode(t, s.mode, s, n);
    return s.reverse && i.reverse(), i;
  }
  _positionChanged(t, r) {
    const { caretX: n, caretY: a, options: s } = this, i = am[s.position].call(this, t, r);
    return i !== !1 && (n !== i.x || a !== i.y);
  }
}, Fe(KS, "positioners", am), KS);
var Xc = {
  id: "tooltip",
  _element: ZM,
  positioners: am,
  afterInit(e, t, r) {
    r && (e.tooltip = new ZM({
      chart: e,
      options: r
    }));
  },
  beforeUpdate(e, t, r) {
    e.tooltip && e.tooltip.initialize(r);
  },
  reset(e, t, r) {
    e.tooltip && e.tooltip.initialize(r);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const r = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...r,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", r);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const r = t.replay;
      e.tooltip.handleEvent(t.event, r, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: JV
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const V3e = (e, t, r, n) => (typeof t == "string" ? (r = e.push(t) - 1, n.unshift({
  index: r,
  label: t
})) : isNaN(t) && (r = null), r);
function $3e(e, t, r, n) {
  const a = e.indexOf(t);
  if (a === -1)
    return V3e(e, t, r, n);
  const s = e.lastIndexOf(t);
  return a !== s ? r : a;
}
const H3e = (e, t) => e === null ? null : qa(Math.round(e), 0, t);
function eL(e) {
  const t = this.getLabels();
  return e >= 0 && e < t.length ? t[e] : e;
}
class jc extends Bh {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const r = this._addedLabels;
    if (r.length) {
      const n = this.getLabels();
      for (const { index: a, label: s } of r)
        n[a] === s && n.splice(a, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, r) {
    if (Vr(t))
      return null;
    const n = this.getLabels();
    return r = isFinite(r) && n[r] === t ? r : $3e(n, t, gr(r, t), this._addedLabels), H3e(r, n.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: r } = this.getUserBounds();
    let { min: n, max: a } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (n = 0), r || (a = this.getLabels().length - 1)), this.min = n, this.max = a;
  }
  buildTicks() {
    const t = this.min, r = this.max, n = this.options.offset, a = [];
    let s = this.getLabels();
    s = t === 0 && r === s.length - 1 ? s : s.slice(t, r + 1), this._valueRange = Math.max(s.length - (n ? 0 : 1), 1), this._startValue = this.min - (n ? 0.5 : 0);
    for (let i = t; i <= r; i++)
      a.push({
        value: i
      });
    return a;
  }
  getLabelForValue(t) {
    return eL.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const r = this.ticks;
    return t < 0 || t > r.length - 1 ? null : this.getPixelForValue(r[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
Fe(jc, "id", "category"), Fe(jc, "defaults", {
  ticks: {
    callback: eL
  }
});
function W3e(e, t) {
  const r = [], { bounds: a, step: s, min: i, max: o, precision: l, count: c, maxTicks: u, maxDigits: d, includeBounds: f } = e, h = s || 1, p = u - 1, { min: m, max: g } = t, y = !Vr(i), x = !Vr(o), w = !Vr(c), _ = (g - m) / (d + 1);
  let S = XN((g - m) / p / h) * h, C, E, O, k;
  if (S < 1e-14 && !y && !x)
    return [
      {
        value: m
      },
      {
        value: g
      }
    ];
  k = Math.ceil(g / S) - Math.floor(m / S), k > p && (S = XN(k * S / p / h) * h), Vr(l) || (C = Math.pow(10, l), S = Math.ceil(S * C) / C), a === "ticks" ? (E = Math.floor(m / S) * S, O = Math.ceil(g / S) * S) : (E = m, O = g), y && x && s && JMe((o - i) / s, S / 1e3) ? (k = Math.round(Math.min((o - i) / S, u)), S = (o - i) / k, E = i, O = o) : w ? (E = y ? i : E, O = x ? o : O, k = c - 1, S = (O - E) / k) : (k = (O - E) / S, vm(k, Math.round(k), S / 1e3) ? k = Math.round(k) : k = Math.ceil(k));
  const A = Math.max(QN(S), QN(E));
  C = Math.pow(10, Vr(l) ? A : l), E = Math.round(E * C) / C, O = Math.round(O * C) / C;
  let P = 0;
  for (y && (f && E !== i ? (r.push({
    value: i
  }), E < i && P++, vm(Math.round((E + P * S) * C) / C, i, tL(i, _, e)) && P++) : E < i && P++); P < k; ++P) {
    const D = Math.round((E + P * S) * C) / C;
    if (x && D > o)
      break;
    r.push({
      value: D
    });
  }
  return x && f && O !== o ? r.length && vm(r[r.length - 1].value, o, tL(o, _, e)) ? r[r.length - 1].value = o : r.push({
    value: o
  }) : (!x || O === o) && r.push({
    value: O
  }), r;
}
function tL(e, t, { horizontal: r, minRotation: n }) {
  const a = El(n), s = (r ? Math.sin(a) : Math.cos(a)) || 1e-3, i = 0.75 * t * ("" + e).length;
  return Math.min(t / s, i);
}
class z3e extends Bh {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, r) {
    return Vr(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: r, maxDefined: n } = this.getUserBounds();
    let { min: a, max: s } = this;
    const i = (l) => a = r ? a : l, o = (l) => s = n ? s : l;
    if (t) {
      const l = No(a), c = No(s);
      l < 0 && c < 0 ? o(0) : l > 0 && c > 0 && i(0);
    }
    if (a === s) {
      let l = s === 0 ? 1 : Math.abs(s * 0.05);
      o(s + l), t || i(a - l);
    }
    this.min = a, this.max = s;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: r, stepSize: n } = t, a;
    return n ? (a = Math.ceil(this.max / n) - Math.floor(this.min / n) + 1, a > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${n} would result generating up to ${a} ticks. Limiting to 1000.`), a = 1e3)) : (a = this.computeTickLimit(), r = r || 11), r && (a = Math.min(r, a)), a;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, r = t.ticks;
    let n = this.getTickLimit();
    n = Math.max(2, n);
    const a = {
      maxTicks: n,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: r.precision,
      step: r.stepSize,
      count: r.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: r.minRotation || 0,
      includeBounds: r.includeBounds !== !1
    }, s = this._range || this, i = W3e(a, s);
    return t.bounds === "ticks" && ZMe(i, this, "value"), t.reverse ? (i.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), i;
  }
  configure() {
    const t = this.ticks;
    let r = this.min, n = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const a = (n - r) / Math.max(t.length - 1, 1) / 2;
      r -= a, n += a;
    }
    this._startValue = r, this._endValue = n, this._valueRange = n - r;
  }
  getLabelForValue(t) {
    return jk(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class Fc extends z3e {
  determineDataLimits() {
    const { min: t, max: r } = this.getMinMax(!0);
    this.min = Ja(t) ? t : 0, this.max = Ja(r) ? r : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), r = t ? this.width : this.height, n = El(this.options.ticks.minRotation), a = (t ? Math.sin(n) : Math.cos(n)) || 1e-3, s = this._resolveTickFontOptions(0);
    return Math.ceil(r / Math.min(40, s.lineHeight / a));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
Fe(Fc, "id", "linear"), Fe(Fc, "defaults", {
  ticks: {
    callback: wV.formatters.numeric
  }
});
const wx = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, bs = /* @__PURE__ */ Object.keys(wx);
function rL(e, t) {
  return e - t;
}
function nL(e, t) {
  if (Vr(t))
    return null;
  const r = e._adapter, { parser: n, round: a, isoWeekday: s } = e._parseOpts;
  let i = t;
  return typeof n == "function" && (i = n(i)), Ja(i) || (i = typeof n == "string" ? r.parse(i, n) : r.parse(i)), i === null ? null : (a && (i = a === "week" && (ig(s) || s === !0) ? r.startOf(i, "isoWeek", s) : r.startOf(i, a)), +i);
}
function aL(e, t, r, n) {
  const a = bs.length;
  for (let s = bs.indexOf(e); s < a - 1; ++s) {
    const i = wx[bs[s]], o = i.steps ? i.steps : Number.MAX_SAFE_INTEGER;
    if (i.common && Math.ceil((r - t) / (o * i.size)) <= n)
      return bs[s];
  }
  return bs[a - 1];
}
function K3e(e, t, r, n, a) {
  for (let s = bs.length - 1; s >= bs.indexOf(r); s--) {
    const i = bs[s];
    if (wx[i].common && e._adapter.diff(a, n, i) >= t - 1)
      return i;
  }
  return bs[r ? bs.indexOf(r) : 0];
}
function q3e(e) {
  for (let t = bs.indexOf(e) + 1, r = bs.length; t < r; ++t)
    if (wx[bs[t]].common)
      return bs[t];
}
function sL(e, t, r) {
  if (!r)
    e[t] = !0;
  else if (r.length) {
    const { lo: n, hi: a } = Nk(r, t), s = r[n] >= t ? r[n] : r[a];
    e[s] = !0;
  }
}
function G3e(e, t, r, n) {
  const a = e._adapter, s = +a.startOf(t[0].value, n), i = t[t.length - 1].value;
  let o, l;
  for (o = s; o <= i; o = +a.add(o, 1, n))
    l = r[o], l >= 0 && (t[l].major = !0);
  return t;
}
function iL(e, t, r) {
  const n = [], a = {}, s = t.length;
  let i, o;
  for (i = 0; i < s; ++i)
    o = t[i], a[o] = i, n.push({
      value: o,
      major: !1
    });
  return s === 0 || !r ? n : G3e(e, n, a, r);
}
class Nb extends Bh {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, r = {}) {
    const n = t.time || (t.time = {}), a = this._adapter = new Nje._date(t.adapters.date);
    a.init(r), gm(n.displayFormats, a.formats()), this._parseOpts = {
      parser: n.parser,
      round: n.round,
      isoWeekday: n.isoWeekday
    }, super.init(t), this._normalized = r.normalized;
  }
  parse(t, r) {
    return t === void 0 ? null : nL(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, r = this._adapter, n = t.time.unit || "day";
    let { min: a, max: s, minDefined: i, maxDefined: o } = this.getUserBounds();
    function l(c) {
      !i && !isNaN(c.min) && (a = Math.min(a, c.min)), !o && !isNaN(c.max) && (s = Math.max(s, c.max));
    }
    (!i || !o) && (l(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && l(this.getMinMax(!1))), a = Ja(a) && !isNaN(a) ? a : +r.startOf(Date.now(), n), s = Ja(s) && !isNaN(s) ? s : +r.endOf(Date.now(), n) + 1, this.min = Math.min(a, s - 1), this.max = Math.max(a + 1, s);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let r = Number.POSITIVE_INFINITY, n = Number.NEGATIVE_INFINITY;
    return t.length && (r = t[0], n = t[t.length - 1]), {
      min: r,
      max: n
    };
  }
  buildTicks() {
    const t = this.options, r = t.time, n = t.ticks, a = n.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && a.length && (this.min = this._userMin || a[0], this.max = this._userMax || a[a.length - 1]);
    const s = this.min, i = this.max, o = aLe(a, s, i);
    return this._unit = r.unit || (n.autoSkip ? aL(r.minUnit, this.min, this.max, this._getLabelCapacity(s)) : K3e(this, o.length, r.minUnit, this.min, this.max)), this._majorUnit = !n.major.enabled || this._unit === "year" ? void 0 : q3e(this._unit), this.initOffsets(a), t.reverse && o.reverse(), iL(this, o, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let r = 0, n = 0, a, s;
    this.options.offset && t.length && (a = this.getDecimalForValue(t[0]), t.length === 1 ? r = 1 - a : r = (this.getDecimalForValue(t[1]) - a) / 2, s = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? n = s : n = (s - this.getDecimalForValue(t[t.length - 2])) / 2);
    const i = t.length < 3 ? 0.5 : 0.25;
    r = qa(r, 0, i), n = qa(n, 0, i), this._offsets = {
      start: r,
      end: n,
      factor: 1 / (r + 1 + n)
    };
  }
  _generate() {
    const t = this._adapter, r = this.min, n = this.max, a = this.options, s = a.time, i = s.unit || aL(s.minUnit, r, n, this._getLabelCapacity(r)), o = gr(a.ticks.stepSize, 1), l = i === "week" ? s.isoWeekday : !1, c = ig(l) || l === !0, u = {};
    let d = r, f, h;
    if (c && (d = +t.startOf(d, "isoWeek", l)), d = +t.startOf(d, c ? "day" : i), t.diff(n, r, i) > 1e5 * o)
      throw new Error(r + " and " + n + " are too far apart with stepSize of " + o + " " + i);
    const p = a.ticks.source === "data" && this.getDataTimestamps();
    for (f = d, h = 0; f < n; f = +t.add(f, o, i), h++)
      sL(u, f, p);
    return (f === n || a.bounds === "ticks" || h === 1) && sL(u, f, p), Object.keys(u).sort(rL).map((m) => +m);
  }
  getLabelForValue(t) {
    const r = this._adapter, n = this.options.time;
    return n.tooltipFormat ? r.format(t, n.tooltipFormat) : r.format(t, n.displayFormats.datetime);
  }
  format(t, r) {
    const a = this.options.time.displayFormats, s = this._unit, i = r || a[s];
    return this._adapter.format(t, i);
  }
  _tickFormatFunction(t, r, n, a) {
    const s = this.options, i = s.ticks.callback;
    if (i)
      return pn(i, [
        t,
        r,
        n
      ], this);
    const o = s.time.displayFormats, l = this._unit, c = this._majorUnit, u = l && o[l], d = c && o[c], f = n[r], h = c && d && f && f.major;
    return this._adapter.format(t, a || (h ? d : u));
  }
  generateTickLabels(t) {
    let r, n, a;
    for (r = 0, n = t.length; r < n; ++r)
      a = t[r], a.label = this._tickFormatFunction(a.value, r, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const r = this._offsets, n = this.getDecimalForValue(t);
    return this.getPixelForDecimal((r.start + n) * r.factor);
  }
  getValueForPixel(t) {
    const r = this._offsets, n = this.getDecimalForPixel(t) / r.factor - r.end;
    return this.min + n * (this.max - this.min);
  }
  _getLabelSize(t) {
    const r = this.options.ticks, n = this.ctx.measureText(t).width, a = El(this.isHorizontal() ? r.maxRotation : r.minRotation), s = Math.cos(a), i = Math.sin(a), o = this._resolveTickFontOptions(0).size;
    return {
      w: n * s + o * i,
      h: n * i + o * s
    };
  }
  _getLabelCapacity(t) {
    const r = this.options.time, n = r.displayFormats, a = n[r.unit] || n.millisecond, s = this._tickFormatFunction(t, 0, iL(this, [
      t
    ], this._majorUnit), a), i = this._getLabelSize(s), o = Math.floor(this.isHorizontal() ? this.width / i.w : this.height / i.h) - 1;
    return o > 0 ? o : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], r, n;
    if (t.length)
      return t;
    const a = this.getMatchingVisibleMetas();
    if (this._normalized && a.length)
      return this._cache.data = a[0].controller.getAllParsedValues(this);
    for (r = 0, n = a.length; r < n; ++r)
      t = t.concat(a[r].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let r, n;
    if (t.length)
      return t;
    const a = this.getLabels();
    for (r = 0, n = a.length; r < n; ++r)
      t.push(nL(this, a[r]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return vV(t.sort(rL));
  }
}
Fe(Nb, "id", "time"), Fe(Nb, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function $0(e, t, r) {
  let n = 0, a = e.length - 1, s, i, o, l;
  r ? (t >= e[n].pos && t <= e[a].pos && ({ lo: n, hi: a } = Cu(e, "pos", t)), { pos: s, time: o } = e[n], { pos: i, time: l } = e[a]) : (t >= e[n].time && t <= e[a].time && ({ lo: n, hi: a } = Cu(e, "time", t)), { time: s, pos: o } = e[n], { time: i, pos: l } = e[a]);
  const c = i - s;
  return c ? o + (l - o) * (t - s) / c : o;
}
class oL extends Nb {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), r = this._table = this.buildLookupTable(t);
    this._minPos = $0(r, this.min), this._tableRange = $0(r, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: r, max: n } = this, a = [], s = [];
    let i, o, l, c, u;
    for (i = 0, o = t.length; i < o; ++i)
      c = t[i], c >= r && c <= n && a.push(c);
    if (a.length < 2)
      return [
        {
          time: r,
          pos: 0
        },
        {
          time: n,
          pos: 1
        }
      ];
    for (i = 0, o = a.length; i < o; ++i)
      u = a[i + 1], l = a[i - 1], c = a[i], Math.round((u + l) / 2) !== c && s.push({
        time: c,
        pos: i / (o - 1)
      });
    return s;
  }
  _generate() {
    const t = this.min, r = this.max;
    let n = super.getDataTimestamps();
    return (!n.includes(t) || !n.length) && n.splice(0, 0, t), (!n.includes(r) || n.length === 1) && n.push(r), n.sort((a, s) => a - s);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const r = this.getDataTimestamps(), n = this.getLabelTimestamps();
    return r.length && n.length ? t = this.normalize(r.concat(n)) : t = r.length ? r : n, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return ($0(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const r = this._offsets, n = this.getDecimalForPixel(t) / r.factor - r.end;
    return $0(this._table, n * this._tableRange + this._minPos, !0);
  }
}
Fe(oL, "id", "timeseries"), Fe(oL, "defaults", Nb.defaults);
const ZV = "label";
function lL(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function Y3e(e, t) {
  const r = e.options;
  r && t && Object.assign(r, t);
}
function e$(e, t) {
  e.labels = t;
}
function t$(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ZV;
  const n = [];
  e.datasets = t.map((a) => {
    const s = e.datasets.find((i) => i[r] === a[r]);
    return !s || !a.data || n.includes(s) ? {
      ...a
    } : (n.push(s), Object.assign(s, a), s);
  });
}
function X3e(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ZV;
  const r = {
    labels: [],
    datasets: []
  };
  return e$(r, e.labels), t$(r, e.datasets, t), r;
}
function Q3e(e, t) {
  const { height: r = 150, width: n = 300, redraw: a = !1, datasetIdKey: s, type: i, data: o, options: l, plugins: c = [], fallbackContent: u, updateMode: d, ...f } = e, h = tr(null), p = tr(null), m = () => {
    h.current && (p.current = new qi(h.current, {
      type: i,
      data: X3e(o, s),
      options: l && {
        ...l
      },
      plugins: c
    }), lL(t, p.current));
  }, g = () => {
    lL(t, null), p.current && (p.current.destroy(), p.current = null);
  };
  return wt(() => {
    !a && p.current && l && Y3e(p.current, l);
  }, [
    a,
    l
  ]), wt(() => {
    !a && p.current && e$(p.current.config.data, o.labels);
  }, [
    a,
    o.labels
  ]), wt(() => {
    !a && p.current && o.datasets && t$(p.current.config.data, o.datasets, s);
  }, [
    a,
    o.datasets
  ]), wt(() => {
    p.current && (a ? (g(), setTimeout(m)) : p.current.update(d));
  }, [
    a,
    l,
    o.labels,
    o.datasets,
    d
  ]), wt(() => {
    p.current && (g(), setTimeout(m));
  }, [
    i
  ]), wt(() => (m(), () => g()), []), /* @__PURE__ */ M.createElement("canvas", {
    ref: h,
    role: "img",
    height: r,
    width: n,
    ...f
  }, u);
}
const J3e = /* @__PURE__ */ va(Q3e);
function qk(e, t) {
  return qi.register(t), /* @__PURE__ */ va((r, n) => /* @__PURE__ */ M.createElement(J3e, {
    ...r,
    ref: n,
    type: e
  }));
}
const Gk = /* @__PURE__ */ qk("line", Ay), Yk = /* @__PURE__ */ qk("bar", Oy), r$ = /* @__PURE__ */ qk("doughnut", rm);
qi.register(
  jc,
  Fc,
  $f,
  Uh,
  Xc,
  Yc
);
const Z3e = ({ data: e, options: t = {} }) => {
  const r = document.documentElement.classList.contains("dark"), n = {
    responsive: !0,
    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        labels: {
          usePointStyle: !0,
          pointStyle: "rectRounded",
          padding: 20,
          font: { size: 12 },
          boxWidth: 16,
          boxHeight: 16,
          color: r ? "#F8FAFC" : "#0F172A"
        }
      },
      title: { display: !1 },
      tooltip: {
        backgroundColor: r ? "#1E293B" : "#FFFFFF",
        titleColor: r ? "#F8FAFC" : "#0F172A",
        bodyColor: r ? "#F8FAFC" : "#0F172A",
        borderColor: r ? "#334155" : "#E2E8F0",
        borderWidth: 1,
        padding: 12,
        displayColors: !0,
        cornerRadius: 8
      }
    },
    scales: {
      x: {
        stacked: !0,
        grid: { display: !1 },
        ticks: {
          color: r ? "#F8FAFC" : "#0F172A"
        },
        border: {
          color: r ? "#334155" : "#E2E8F0"
        }
      },
      y: {
        stacked: !1,
        beginAtZero: !0,
        grid: {
          color: r ? "rgba(248, 250, 252, 0.1)" : "rgba(15, 23, 42, 0.1)"
        },
        ticks: {
          color: r ? "#F8FAFC" : "#0F172A"
        },
        border: {
          color: r ? "#334155" : "#E2E8F0"
        }
      }
    },
    barPercentage: 0.8,
    categoryPercentage: 0.7
  };
  return /* @__PURE__ */ v.jsx(Yk, { data: e, options: { ...n, ...t } });
};
qi.register(
  jc,
  Fc,
  $f,
  Uh,
  Xc,
  Yc
);
const Oet = ({
  data: e,
  options: t = {},
  minYScale: r = 100
}) => {
  const [n, a] = Me(null), s = document.documentElement.classList.contains("dark"), i = (u, d, f) => {
    if (d.length > 0) {
      const h = d[0].index, p = e[h];
      p.monthlyData && p.monthlyData.length > 0 && a(p.season);
    }
  }, o = () => {
    a(null);
  }, l = () => {
    var u, d;
    if (n) {
      const f = e.find((h) => h.season === n);
      return {
        labels: ((u = f == null ? void 0 : f.monthlyData) == null ? void 0 : u.map((h) => h.month)) || [],
        datasets: [
          {
            label: n,
            data: ((d = f == null ? void 0 : f.monthlyData) == null ? void 0 : d.map((h) => h.value)) || [],
            backgroundColor: "#0060AA",
            hoverBackgroundColor: "#4B9FE1",
            borderRadius: 4
          }
        ]
      };
    }
    return {
      labels: e.map((f) => f.season),
      datasets: [
        {
          label: "Amount per Season",
          data: e.map((f) => f.value),
          backgroundColor: "#0060AA",
          hoverBackgroundColor: "#4B9FE1",
          borderRadius: 4
        }
      ]
    };
  }, c = {
    responsive: !0,
    onClick: n ? void 0 : i,
    animation: {
      duration: 500
    },
    plugins: {
      legend: {
        display: !1
      },
      tooltip: {
        callbacks: {
          label: (u) => {
            const d = u.raw;
            return new Intl.NumberFormat("fr-FR", {
              style: "currency",
              currency: "EUR",
              minimumFractionDigits: 0
            }).format(d);
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: !0,
        min: 0,
        max: Math.max(r, ...e.map((u) => u.value)),
        ticks: {
          callback: (u) => new Intl.NumberFormat("fr-FR", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 0
          }).format(u),
          color: s ? "#F8FAFC" : "#0F172A"
        },
        grid: {
          color: s ? "rgba(248, 250, 252, 0.1)" : "rgba(15, 23, 42, 0.1)"
        },
        border: {
          color: s ? "#334155" : "#E2E8F0"
        }
      },
      x: {
        grid: { display: !1 },
        ticks: {
          color: s ? "#F8FAFC" : "#0F172A"
        },
        border: {
          color: s ? "#334155" : "#E2E8F0"
        }
      }
    },
    barPercentage: 0.7,
    categoryPercentage: 0.7
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "space-y-4", children: [
    n && /* @__PURE__ */ v.jsx(
      qe,
      {
        variant: "outline",
        size: "sm",
        onClick: o,
        icon: "chevron-left",
        iconPosition: "left",
        children: "Back to Seasons"
      }
    ),
    /* @__PURE__ */ v.jsx(Yk, { data: l(), options: { ...c, ...t } })
  ] });
}, dh = ({
  icon: e = "inbox",
  title: t,
  description: r,
  primaryAction: n,
  secondaryAction: a,
  className: s
}) => /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col flex-1 items-center justify-center text-center space-y-4 py-8", children: [
  /* @__PURE__ */ v.jsx(dt, { name: e, size: "xl", className: "text-gray-400" }),
  /* @__PURE__ */ v.jsx("h3", { className: "text-xl font-medium text-gray-900 dark:text-gray-100", children: t }),
  /* @__PURE__ */ v.jsx("p", { className: "text-sm text-gray-500 dark:text-gray-400 max-w-sm", children: r }),
  (n || a) && /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col sm:flex-row gap-3 mt-2", children: [
    n && /* @__PURE__ */ v.jsx(
      qe,
      {
        onClick: n.onClick,
        icon: n.icon,
        iconPosition: n.icon ? "left" : void 0,
        variant: "solid",
        children: n.label
      }
    ),
    a && /* @__PURE__ */ v.jsx(
      qe,
      {
        onClick: a.onClick,
        icon: a.icon,
        iconPosition: a.icon ? "left" : void 0,
        variant: "outline",
        color: "gray",
        children: a.label
      }
    )
  ] })
] }), cL = (e, t, r) => {
  if (e && "reportValidity" in e) {
    const n = St(r, t);
    e.setCustomValidity(n && n.message || ""), e.reportValidity();
  }
}, n$ = (e, t) => {
  for (const r in t.fields) {
    const n = t.fields[r];
    n && n.ref && "reportValidity" in n.ref ? cL(n.ref, r, e) : n.refs && n.refs.forEach((a) => cL(a, r, e));
  }
}, eFe = (e, t) => {
  t.shouldUseNativeValidation && n$(e, t);
  const r = {};
  for (const n in e) {
    const a = St(t.fields, n), s = Object.assign(e[n] || {}, { ref: a && a.ref });
    if (tFe(t.names || Object.keys(e), n)) {
      const i = Object.assign({}, St(r, n));
      Ur(i, "root", s), Ur(r, n, i);
    } else Ur(r, n, s);
  }
  return r;
}, tFe = (e, t) => e.some((r) => r.startsWith(t + "."));
var rFe = function(e, t) {
  for (var r = {}; e.length; ) {
    var n = e[0], a = n.code, s = n.message, i = n.path.join(".");
    if (!r[i]) if ("unionErrors" in n) {
      var o = n.unionErrors[0].errors[0];
      r[i] = { message: o.message, type: o.code };
    } else r[i] = { message: s, type: a };
    if ("unionErrors" in n && n.unionErrors.forEach(function(u) {
      return u.errors.forEach(function(d) {
        return e.push(d);
      });
    }), t) {
      var l = r[i].types, c = l && l[n.code];
      r[i] = OF(i, t, r, a, c ? [].concat(c, n.message) : n.message);
    }
    e.shift();
  }
  return r;
}, nFe = function(e, t, r) {
  return r === void 0 && (r = {}), function(n, a, s) {
    try {
      return Promise.resolve(function(i, o) {
        try {
          var l = Promise.resolve(e[r.mode === "sync" ? "parse" : "parseAsync"](n, t)).then(function(c) {
            return s.shouldUseNativeValidation && n$({}, s), { errors: {}, values: r.raw ? n : c };
          });
        } catch (c) {
          return o(c);
        }
        return l && l.then ? l.then(void 0, o) : l;
      }(0, function(i) {
        if (function(o) {
          return Array.isArray(o == null ? void 0 : o.errors);
        }(i)) return { values: {}, errors: eFe(rFe(i.errors, !s.shouldUseNativeValidation && s.criteriaMode === "all"), s) };
        throw i;
      }));
    } catch (i) {
      return Promise.reject(i);
    }
  };
};
function uL({
  section: e,
  layout: t
}) {
  const {
    formState: { errors: r }
  } = Ch(), n = (t == null ? void 0 : t.type) === "grid" ? "grid grid-cols-12 gap-4" : "space-y-4", a = (i) => {
    const o = i.replace(/\[(\d+)\]/g, ".$1").split("."), l = (u) => {
      if (u) {
        if (typeof u == "string") return u;
        if (u.message) return u.message;
        if (typeof u == "object")
          return Object.values(u).reduce(
            (d, f) => d || l(f),
            void 0
          );
      }
    };
    return l(((u, d) => d.reduce((f, h) => f ? f[h] : void 0, u))(r, o));
  }, s = () => e.fields.map((i, o) => {
    var u, d;
    const l = /* @__PURE__ */ v.jsx(
      Ea,
      {
        ...i,
        name: `${i.name}`,
        className: (t == null ? void 0 : t.type) === "grid" ? "col-span-6" : "",
        error: a(`${i.name}`)
      },
      `${i.name}`
    ), c = (d = (u = e.displayComponents) == null ? void 0 : u.afterField) == null ? void 0 : d.filter(
      (f) => f.fieldName === i.name
    );
    return c && c.length > 0 ? /* @__PURE__ */ v.jsxs(M.Fragment, { children: [
      l,
      c.map((f, h) => /* @__PURE__ */ v.jsx(
        "div",
        {
          className: f.className || "col-span-12",
          children: f.component
        },
        `after-${i.name}-${h}`
      ))
    ] }, `${i.name}-group`) : l;
  });
  return /* @__PURE__ */ v.jsx("div", { className: n, children: e.displayComponents ? s() : e.fields.map((i) => /* @__PURE__ */ v.jsx(
    Ea,
    {
      ...i,
      name: `${i.name}`,
      className: (t == null ? void 0 : t.type) === "grid" ? "col-span-6" : "",
      error: a(`${i.name}`)
    },
    `${i.name}`
  )) });
}
function Uo({
  sections: e,
  validationSchema: t,
  defaultValues: r,
  onSubmit: n,
  onChange: a,
  onCancel: s,
  layout: i,
  formLayout: o = "single-page",
  sidebarContent: l,
  error: c,
  fieldErrors: u,
  actions: d,
  onDraft: f
}) {
  var G, Y, te, ae, ne, ue, q, U, Q, L, j, K, J;
  const { t: h } = _t(["common"]), [p, m] = M.useState(0), g = Da(), [y, x] = M.useState(!1), w = {
    submit: {
      show: ((G = d == null ? void 0 : d.submit) == null ? void 0 : G.show) ?? !0,
      label: ((Y = d == null ? void 0 : d.submit) == null ? void 0 : Y.label) ?? h("common.submit"),
      color: ((te = d == null ? void 0 : d.submit) == null ? void 0 : te.color) ?? "primary",
      position: ((ae = d == null ? void 0 : d.submit) == null ? void 0 : ae.position) ?? "right",
      ...d == null ? void 0 : d.submit
    },
    draft: {
      show: ((ne = d == null ? void 0 : d.draft) == null ? void 0 : ne.show) ?? !1,
      label: ((ue = d == null ? void 0 : d.draft) == null ? void 0 : ue.label) ?? h("common.saveDraft"),
      color: ((q = d == null ? void 0 : d.draft) == null ? void 0 : q.color) ?? "secondary",
      position: ((U = d == null ? void 0 : d.draft) == null ? void 0 : U.position) ?? "right",
      ...d == null ? void 0 : d.draft
    },
    cancel: {
      show: ((Q = d == null ? void 0 : d.cancel) == null ? void 0 : Q.show) ?? !1,
      label: ((L = d == null ? void 0 : d.cancel) == null ? void 0 : L.label) ?? h("common.cancel"),
      color: ((j = d == null ? void 0 : d.cancel) == null ? void 0 : j.color) ?? "gray",
      position: ((K = d == null ? void 0 : d.cancel) == null ? void 0 : K.position) ?? "left",
      ...d == null ? void 0 : d.cancel
    }
  }, _ = MF({
    resolver: t ? nFe(t) : void 0,
    defaultValues: r,
    mode: "onBlur"
  });
  wt(() => {
    if (a) {
      const re = _.watch((le) => {
        a(le);
      });
      return () => re.unsubscribe();
    }
  }, [_, a]), wt(() => {
    u != null && u.length && u.forEach((re) => {
      re.field && _.setError(re.field, {
        type: re.type || "error",
        message: re.message
      });
    });
  }, [u, _]);
  const {
    handleSubmit: S,
    formState: { isSubmitting: C, errors: E }
  } = _, [O, k] = Me(null), A = async (re) => {
    try {
      k("submit"), await n(re, _);
    } catch (le) {
      return console.error("Form submission error:", le), g.error(h("common.formSubmissionError")), !1;
    } finally {
      k(null);
    }
  }, P = async (re) => {
    try {
      k("draft"), await (f == null ? void 0 : f(re, _));
    } catch (le) {
      return console.error("Draft submission error:", le), g.error(h("common.draftSubmissionError")), !1;
    } finally {
      k(null);
    }
  }, D = async (re) => {
    if (re.preventDefault(), !await _.trigger()) {
      const pe = Object.entries(_.formState.errors).map(([me, Oe]) => {
        if (!Oe) return "";
        const ee = h(`form.fields.${me}`, { defaultValue: me }), he = Oe.message || h("common.invalidValue");
        return `${ee}: ${he}`;
      }).filter(Boolean).join(", ");
      g.error(pe || h("common.formErrors")), x(!0);
      return;
    }
    await S(A)(re);
  }, z = (() => {
    var le, pe, me;
    const re = e[p];
    return o === "multi-step" ? /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center justify-normal xl:justify-self-end xl:flex-row gap-4", children: [
      p > 0 && /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: () => m(p - 1),
          variant: "outline",
          children: h("common.previous")
        }
      ),
      re.allowSkip && /* @__PURE__ */ v.jsx(qe, { variant: "ghost", onClick: re.onSkip, children: re.skipButtonText || h("common.skip") }),
      p < e.length - 1 ? /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: () => m(p + 1),
          variant: "outline",
          children: h("common.next")
        }
      ) : /* @__PURE__ */ v.jsx(qe, { onClick: D, disabled: C, children: h(C ? "common.submitting" : "common.submit") })
    ] }) : /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center justify-normal xl:justify-self-end xl:flex-row gap-4", children: [
      ((le = w.cancel) == null ? void 0 : le.show) && /* @__PURE__ */ v.jsx(
        qe,
        {
          variant: "outline",
          onClick: s,
          icon: w.cancel.icon,
          color: w.cancel.color,
          fullWidth: !0,
          children: w.cancel.label
        }
      ),
      e[0].allowSkip && /* @__PURE__ */ v.jsx(
        qe,
        {
          variant: "outline",
          color: "gray",
          onClick: e[0].onSkip,
          fullWidth: !0,
          children: e[0].skipButtonText || h("common.skip")
        }
      ),
      ((pe = w.draft) == null ? void 0 : pe.show) && /* @__PURE__ */ v.jsx(
        qe,
        {
          variant: "outline",
          onClick: S(P),
          icon: w.draft.icon,
          iconPosition: "left",
          color: w.draft.color,
          fullWidth: !0,
          children: O === "draft" ? h("common.submitting") : w.draft.label
        }
      ),
      ((me = w.submit) == null ? void 0 : me.show) && /* @__PURE__ */ v.jsx(
        qe,
        {
          type: "submit",
          onClick: D,
          icon: w.submit.icon,
          color: w.submit.color,
          fullWidth: !0,
          children: O === "submit" ? h("common.submitting") : w.submit.label
        }
      )
    ] });
  })();
  return /* @__PURE__ */ v.jsx(TF, { ..._, children: /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col md:flex-row gap-6", children: [
    /* @__PURE__ */ v.jsx("div", { className: l ? "w-full md:w-2/3" : "w-full", children: /* @__PURE__ */ v.jsxs("form", { onSubmit: D, className: "space-y-6", noValidate: !0, children: [
      (c || y && Object.keys(E).length > 0) && /* @__PURE__ */ v.jsx("div", { className: "mb-4 p-4 border border-red-200 bg-red-50 rounded-md text-red-700", children: /* @__PURE__ */ v.jsxs("div", { className: "flex items-start", children: [
        /* @__PURE__ */ v.jsx("div", { className: "flex-shrink-0", children: /* @__PURE__ */ v.jsx(
          dt,
          {
            name: "exclamation-circle",
            className: "h-5 w-5 text-red-400"
          }
        ) }),
        /* @__PURE__ */ v.jsxs("div", { className: "ml-3", children: [
          /* @__PURE__ */ v.jsx("h3", { className: "text-sm font-medium", children: c ? typeof c == "string" ? c : c.message : h("common.formErrors") }),
          !c && y && Object.keys(E).length > 0 && /* @__PURE__ */ v.jsx("div", { className: "mt-2 text-sm", children: Object.entries(E).map(([re, le], pe) => {
            if (!le) return null;
            const me = h(`form.fields.${re}`, {
              defaultValue: re
            });
            return /* @__PURE__ */ v.jsxs("div", { className: "mt-1", children: [
              /* @__PURE__ */ v.jsxs("span", { className: "font-medium", children: [
                me,
                ": "
              ] }),
              le.message || h("common.invalidValue")
            ] }, pe);
          }) }),
          c && typeof c != "string" && ((J = c.details) == null ? void 0 : J.errors) && /* @__PURE__ */ v.jsx("div", { className: "mt-2 text-sm", children: c.details.errors.map((re, le) => /* @__PURE__ */ v.jsxs("div", { className: "mt-1", children: [
            re.field && re.field !== "request" && /* @__PURE__ */ v.jsxs("span", { className: "font-medium", children: [
              h(`form.fields.${re.field}`, {
                defaultValue: re.field
              }),
              ":",
              " "
            ] }),
            re.message
          ] }, le)) })
        ] })
      ] }) }),
      o === "multi-step" ? /* @__PURE__ */ v.jsx(hr, { header: e[p].title, children: /* @__PURE__ */ v.jsx(uL, { section: e[p], layout: i }) }) : e.map((re, le) => /* @__PURE__ */ v.jsx(
        hr,
        {
          header: re.title,
          footer: le === e.length - 1 && !l ? z : void 0,
          children: /* @__PURE__ */ v.jsx(uL, { section: re, layout: i })
        },
        le
      ))
    ] }) }),
    l && /* @__PURE__ */ v.jsx("div", { className: "w-full md:w-1/3", children: /* @__PURE__ */ v.jsx(hr, { footer: z, className: "sticky top-0", children: l }) })
  ] }) });
}
function Xk({
  sections: e,
  validationSchema: t,
  defaultValues: r,
  onSubmit: n,
  onCancel: a,
  layout: s,
  formLayout: i,
  sidebarContent: o,
  error: l,
  draftConfig: c,
  formConfig: u
}) {
  const d = {
    submit: { show: !0 },
    cancel: {
      show: (u == null ? void 0 : u.showCancel) ?? !1
    },
    draft: c != null && c.enabled ? {
      show: !0,
      label: c.buttonConfig.label,
      icon: c.buttonConfig.icon,
      color: c.buttonConfig.color,
      position: "right"
    } : void 0
  }, f = typeof r == "function" ? void 0 : r, h = async (m, g) => {
    var x;
    const y = ((x = c == null ? void 0 : c.transformToPublished) == null ? void 0 : x.call(c, m)) ?? m;
    return n(y, g);
  }, p = async (m, g) => {
    if (!c) return !1;
    const y = c.transformToDraft(m);
    return n(y, g);
  };
  return /* @__PURE__ */ v.jsx(
    Uo,
    {
      sections: e,
      validationSchema: t,
      defaultValues: f,
      onSubmit: h,
      onDraft: p,
      onCancel: a,
      layout: s,
      formLayout: i,
      sidebarContent: o,
      error: l,
      actions: d
    }
  );
}
const aFe = ({
  columns: e,
  onSort: t,
  sortColumn: r,
  sortDirection: n,
  onSelectAll: a,
  theme: s,
  actions: i,
  showCheckboxes: o,
  coloredHeader: l
}) => /* @__PURE__ */ v.jsx("thead", { children: /* @__PURE__ */ v.jsxs("tr", { children: [
  o && /* @__PURE__ */ v.jsx(
    "th",
    {
      className: lt(
        s.baseStyle.headerCell,
        s.baseStyle.pinnedLeft,
        "w-[50px]"
      ),
      children: /* @__PURE__ */ v.jsx(ZT, { onChange: a, "aria-label": "Select all rows" })
    }
  ),
  e.map((c) => /* @__PURE__ */ v.jsx(
    "th",
    {
      className: lt(
        s.baseStyle.headerCell,
        c.sortable ? s.baseStyle.sortableHeaderCell : "",
        c.pinned && [
          s.baseStyle.pinnedWrapper,
          c.pinned === "left" ? "text-left" : "text-right"
        ],
        c.pinned === "left" && [
          s.baseStyle.pinnedLeft,
          s.baseStyle.pinnedHeaderCell,
          "group-hover:after:shadow-[2px_0_4px_-2px_rgba(0,0,0,0.1)]"
        ],
        c.pinned === "right" && [
          s.baseStyle.pinnedRight,
          s.baseStyle.pinnedHeaderCell,
          "group-hover:after:shadow-[-2px_0_4px_-2px_rgba(0,0,0,0.1)]"
        ],
        c.width && `w-[${c.width}]`
      ),
      onClick: () => c.sortable && t(c.id),
      children: /* @__PURE__ */ v.jsxs("div", { className: lt(s.baseStyle.headerContent, "inline-flex"), children: [
        /* @__PURE__ */ v.jsx("span", { className: "whitespace-nowrap", children: c.label }),
        c.sortable && /* @__PURE__ */ v.jsx("span", { className: s.baseStyle.sortIcon, children: /* @__PURE__ */ v.jsx(
          dt,
          {
            name: r === c.id ? n === _n.DESC ? "chevron-up" : "chevron-down" : "chevron-both",
            size: "sm",
            className: lt(
              r === c.id ? s.baseStyle.sortIconActive : s.baseStyle.sortIconInactive
            )
          }
        ) })
      ] })
    },
    c.id.toString()
  )),
  i && /* @__PURE__ */ v.jsx(
    "th",
    {
      className: lt(
        s.baseStyle.headerCell,
        s.baseStyle.pinnedRight,
        "w-[100px]"
      ),
      children: "Actions"
    }
  )
] }) }), sFe = ({
  data: e,
  columns: t,
  onRowClick: r,
  onRowSelection: n,
  selectedRows: a,
  isLoading: s,
  emptyStateMessage: i,
  theme: o,
  actions: l,
  showCheckboxes: c,
  error: u,
  errorRenderer: d
}) => {
  var h, p, m;
  const f = t.length + (l ? 1 : 0) + (c ? 1 : 0);
  return u ? /* @__PURE__ */ v.jsx("tbody", { children: /* @__PURE__ */ v.jsx("tr", { children: /* @__PURE__ */ v.jsx("td", { colSpan: f, className: o.baseStyle.errorCell, children: /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center justify-center space-y-4 p-6", children: [
    /* @__PURE__ */ v.jsx(dt, { name: "x-circle", className: "text-red-500 w-8 h-8" }),
    /* @__PURE__ */ v.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ v.jsx("p", { className: "font-medium text-red-600", children: u.code ? `${u.code}: ${u.message}` : u.message }),
      (p = (h = u.details) == null ? void 0 : h.errors) == null ? void 0 : p.map((g, y) => /* @__PURE__ */ v.jsxs("p", { className: "mt-2 text-sm text-gray-600", children: [
        g.field && /* @__PURE__ */ v.jsxs("span", { className: "font-medium", children: [
          g.field,
          ": "
        ] }),
        g.message
      ] }, y)),
      ((m = u.details) == null ? void 0 : m.raw) && /* @__PURE__ */ v.jsx("pre", { className: "mt-2 text-xs text-gray-500 bg-gray-50 p-2 rounded", children: JSON.stringify(u.details.raw, null, 2) })
    ] }),
    u.action && /* @__PURE__ */ v.jsx(
      qe,
      {
        variant: "solid",
        color: "primary",
        size: "sm",
        onClick: u.action.onClick,
        children: u.action.label
      }
    )
  ] }) }) }) }) : s ? /* @__PURE__ */ v.jsx("tbody", { children: /* @__PURE__ */ v.jsx("tr", { children: /* @__PURE__ */ v.jsx("td", { colSpan: f, className: o.baseStyle.loadingCell, children: /* @__PURE__ */ v.jsxs("div", { className: o.baseStyle.loadingSpinner, children: [
    /* @__PURE__ */ v.jsx(dt, { name: "spinner", className: "animate-spin" }),
    "Loading..."
  ] }) }) }) }) : !e || e.length === 0 ? /* @__PURE__ */ v.jsx("tbody", { children: /* @__PURE__ */ v.jsx("tr", { children: /* @__PURE__ */ v.jsx("td", { colSpan: f, className: o.baseStyle.emptyStateCell, children: i }) }) }) : /* @__PURE__ */ v.jsx("tbody", { children: Array.isArray(e) && e.map((g, y) => /* @__PURE__ */ v.jsxs(
    "tr",
    {
      className: lt(
        o.baseStyle.row,
        a.has(g.id) ? o.baseStyle.selectedRow : "",
        r ? o.baseStyle.clickableRow : ""
      ),
      onClick: () => r && r(g),
      children: [
        c && /* @__PURE__ */ v.jsx(
          "td",
          {
            className: lt(
              o.baseStyle.cell,
              o.baseStyle.pinnedLeft,
              o.baseStyle.pinnedCell
            ),
            onClick: (x) => x.stopPropagation(),
            children: /* @__PURE__ */ v.jsx(
              ZT,
              {
                checked: a.has(g.id),
                onChange: () => n(g.id),
                "aria-label": `Select row ${g.id}`
              }
            )
          }
        ),
        t.map((x) => /* @__PURE__ */ v.jsx(
          "td",
          {
            className: lt(
              o.baseStyle.cell,
              x.pinned && [
                o.baseStyle.pinnedWrapper,
                x.pinned === "left" ? "text-left" : "text-right"
              ],
              x.pinned === "left" && [
                o.baseStyle.pinnedLeft,
                o.baseStyle.pinnedCell,
                "group-hover:after:shadow-[2px_0_4px_-2px_rgba(0,0,0,0.1)]"
              ],
              x.pinned === "right" && [
                o.baseStyle.pinnedRight,
                o.baseStyle.pinnedCell,
                "group-hover:after:shadow-[-2px_0_4px_-2px_rgba(0,0,0,0.1)]"
              ],
              x.width && `w-[${x.width}]`
            ),
            children: x.render ? x.render(g) : x.accessor ? x.accessor(g) : g[x.id]
          },
          String(x.id)
        )),
        l && l.length > 0 && /* @__PURE__ */ v.jsx(
          "td",
          {
            className: lt(
              o.baseStyle.cell,
              o.baseStyle.pinnedRight
            ),
            onClick: (x) => x.stopPropagation(),
            children: l(g)
          }
        )
      ]
    },
    g.id || y
  )) });
}, iFe = ({
  currentPage: e,
  totalPages: t,
  onPageChange: r,
  pageSize: n,
  totalItems: a,
  onPageSizeChange: s,
  className: i,
  theme: o
}) => {
  const { t: l } = _t(["common"]), c = o.baseStyle, u = () => {
    const h = [];
    let p = Math.max(1, e - 2), m = Math.min(t, p + 4);
    m - p < 4 && (p = Math.max(1, m - 4)), p > 1 && (h.push(
      /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: () => r(1),
          variant: "outline",
          color: "gray",
          size: "sm",
          className: c.pageButton,
          children: "1"
        },
        1
      )
    ), p > 2 && h.push(
      /* @__PURE__ */ v.jsx("span", { className: c.ellipsis, children: "…" }, "dots-start")
    ));
    for (let g = p; g <= m; g++)
      h.push(
        /* @__PURE__ */ v.jsx(
          qe,
          {
            onClick: () => r(g),
            variant: e === g ? "solid" : "outline",
            color: "gray",
            size: "sm",
            className: Wa(
              c.pageButton,
              e === g && c.pageButtonActive
            ),
            children: g
          },
          g
        )
      );
    return m < t && (m < t - 1 && h.push(
      /* @__PURE__ */ v.jsx("span", { className: c.ellipsis, children: "…" }, "dots-end")
    ), h.push(
      /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: () => r(t),
          variant: "outline",
          color: "gray",
          size: "sm",
          className: c.pageButton,
          children: t
        },
        t
      )
    )), h;
  }, d = (e - 1) * n + 1, f = Math.min(e * n, a);
  return /* @__PURE__ */ v.jsxs("div", { className: Wa(c.base, c.wrapper, i), children: [
    /* @__PURE__ */ v.jsx("div", { className: c.infoWrapper, children: /* @__PURE__ */ v.jsxs("p", { className: c.text, children: [
      l("pagination.showing"),
      " ",
      /* @__PURE__ */ v.jsx("span", { className: c.infoTextHighlight, children: d }),
      " ",
      l("pagination.to"),
      " ",
      /* @__PURE__ */ v.jsx("span", { className: c.infoTextHighlight, children: f }),
      " ",
      l("pagination.of"),
      " ",
      /* @__PURE__ */ v.jsx("span", { className: c.infoTextHighlight, children: a }),
      " ",
      l("pagination.results")
    ] }) }),
    /* @__PURE__ */ v.jsxs("nav", { className: c.navigation, "aria-label": "Pagination", children: [
      /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: () => r(e - 1),
          disabled: e === 1,
          variant: "outline",
          color: "gray",
          size: "sm",
          className: c.button,
          "aria-label": l("common.previous"),
          icon: "chevron-left",
          children: /* @__PURE__ */ v.jsx("span", { className: "sr-only", children: l("common.previous") })
        }
      ),
      u(),
      /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: () => r(e + 1),
          disabled: e === t,
          variant: "outline",
          color: "gray",
          size: "sm",
          className: c.button,
          "aria-label": l("common.next"),
          icon: "chevron-right",
          children: /* @__PURE__ */ v.jsx("span", { className: "sr-only", children: l("common.next") })
        }
      )
    ] })
  ] });
}, oFe = $r(
  "Pagination",
  iFe
), lFe = ({ theme: e, pagination: t, footerSection: r, showPagination: n = !0 }) => /* @__PURE__ */ v.jsx("div", { className: e.baseStyle.footer, children: /* @__PURE__ */ v.jsxs("div", { className: lt(e.baseStyle.footerContent), children: [
  n && t && /* @__PURE__ */ v.jsx("div", { className: lt(e.baseStyle.footerCell), children: /* @__PURE__ */ v.jsx(oFe, { ...t }) }),
  r && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    r.before && /* @__PURE__ */ v.jsx("div", { className: lt(e.baseStyle.footerCell), children: r.before }),
    r.after && /* @__PURE__ */ v.jsx("div", { className: lt(e.baseStyle.footerCell), children: r.after })
  ] })
] }) }), cFe = ({
  data: e,
  columns: t,
  onSort: r,
  onRowClick: n,
  onSelectionChange: a,
  isLoading: s,
  emptyStateMessage: i = "No data available",
  className: o,
  theme: l,
  showCheckboxes: c = !1,
  sortColumn: u,
  sortDirection: d,
  pagination: f,
  actions: h,
  headerSection: p,
  footerSection: m,
  showPagination: g = !0,
  coloredHeader: y = !1,
  error: x,
  errorRenderer: w,
  ..._
}) => {
  const [S, C] = Me(
    /* @__PURE__ */ new Set()
  ), E = Ft(
    (k) => {
      k === u ? r == null || r(
        k,
        d === _n.ASC ? _n.DESC : _n.ASC
      ) : r == null || r(k, _n.ASC);
    },
    [u, d, r]
  ), O = Ft((k) => {
    C((A) => {
      const P = new Set(A);
      return P.has(k) ? P.delete(k) : P.add(k), P;
    });
  }, []);
  return M.useEffect(() => {
    a == null || a(Array.from(S));
  }, [S, a]), /* @__PURE__ */ v.jsxs("div", { className: lt(l.baseStyle.wrapper, o), children: [
    p && /* @__PURE__ */ v.jsxs("div", { className: l.baseStyle.headerSection, children: [
      p.before,
      /* @__PURE__ */ v.jsx("div", { className: l.baseStyle.headerSectionContent, children: p.after })
    ] }),
    /* @__PURE__ */ v.jsx("div", { className: l.baseStyle.container, children: /* @__PURE__ */ v.jsxs("table", { className: l.baseStyle.base, ..._, children: [
      /* @__PURE__ */ v.jsx(
        aFe,
        {
          columns: t,
          onSort: E,
          sortColumn: u,
          sortDirection: d || _n.ASC,
          theme: l,
          onSelectAll: () => {
            if (!c) return;
            const k = /* @__PURE__ */ new Set();
            S.size !== e.length && e.forEach((A) => k.add(A.id)), C(k), a == null || a(Array.from(k));
          },
          actions: h,
          showCheckboxes: c,
          coloredHeader: y
        }
      ),
      /* @__PURE__ */ v.jsx(
        sFe,
        {
          data: Array.isArray(e) ? e : [],
          columns: t,
          onRowClick: n,
          onRowSelection: O,
          selectedRows: S,
          isLoading: s,
          emptyStateMessage: i,
          theme: l,
          actions: h,
          showCheckboxes: c,
          error: x,
          errorRenderer: w
        }
      )
    ] }) }),
    /* @__PURE__ */ v.jsx(
      lFe,
      {
        columns: t,
        theme: l,
        pagination: g ? f : void 0,
        footerSection: m
      }
    )
  ] });
}, xx = $r(
  "Table",
  cFe
), uFe = ({
  value: e,
  onChange: t,
  placeholder: r,
  isLoading: n,
  debounceDelay: a = 300,
  minCharacters: s = 2
}) => {
  const { t: i } = _t(["common"]), [o, l] = Me(e), c = BF(o, a), [u, d] = Me(!1);
  wt(() => {
    c.length >= s || c.length === 0 ? (t(c), d(!1)) : d(!0);
  }, [c, t, s]);
  const f = (h) => {
    const p = h.target.value;
    l(p);
  };
  return /* @__PURE__ */ v.jsx("div", { className: "relative", children: /* @__PURE__ */ v.jsx(
    ar,
    {
      type: "text",
      value: o,
      onChange: f,
      placeholder: r || i("common.search"),
      disabled: n,
      icon: n ? "spinner" : "search",
      iconPosition: "right",
      className: "w-full min-w-[280px]",
      size: "md"
    }
  ) });
}, dFe = ({
  size: e = "md",
  color: t = "primary",
  container: r = "inline",
  variant: n = "default",
  label: a,
  delay: s = 300,
  className: i
}) => {
  const { t: o } = _t(), [l, c] = Me(s === 0);
  if (wt(() => {
    if (s === 0) return;
    const f = setTimeout(() => {
      c(!0);
    }, s);
    return () => clearTimeout(f);
  }, [s]), !l) return null;
  const u = lt(
    "flex items-center justify-center",
    r === "screen" && "fixed inset-0 bg-white/80 dark:bg-gray-900/80 z-50",
    r === "full" && "h-full w-full inset-0",
    i
  ), d = /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      dt,
      {
        name: "spinner",
        size: e,
        color: t,
        className: "animate-spin",
        "aria-hidden": "true"
      }
    ),
    /* @__PURE__ */ v.jsx("span", { className: "sr-only", children: a || o("common.loading") })
  ] });
  return r === "inline" ? /* @__PURE__ */ v.jsx("span", { className: "inline-flex", children: d }) : /* @__PURE__ */ v.jsx("div", { role: "status", "aria-live": "polite", className: u, children: d });
}, la = $r("LoadingSpinner", dFe);
function fFe({
  entityConfig: e,
  items: t,
  isLoading: r,
  error: n,
  currentPage: a,
  totalItems: s,
  itemsPerPage: i,
  sortColumn: o,
  sortDirection: l,
  onSort: c,
  onPageChange: u,
  onItemsPerPageChange: d,
  onRowClick: f,
  onEditClick: h,
  onDeleteClick: p,
  onViewClick: m,
  onSearch: g,
  searchTerm: y = "",
  customActions: x = [],
  renderEmptyState: w,
  customFooter: _,
  showCheckboxes: S = !0,
  viewMode: C,
  onViewModeChange: E,
  renderCard: O,
  showViewModeSwitch: k,
  onRetry: A,
  customErrorRenderer: P,
  onRefresh: D,
  crudMethods: N
}) {
  var U;
  const { t: z } = _t([e.name]), G = Da(), [Y, te] = Me(y), { handleError: ae } = zc();
  wt(() => {
    const Q = () => {
      D == null || D();
    };
    return window.addEventListener(
      "refresh-entity-table",
      Q
    ), () => {
      window.removeEventListener(
        "refresh-entity-table",
        Q
      );
    };
  }, [D]);
  const ne = n ? {
    message: n.message,
    type: "error",
    action: A ? {
      label: z("common:common.retry"),
      onClick: A
    } : void 0
  } : void 0;
  function ue({
    viewMode: Q,
    onViewModeChange: L,
    showViewModeSwitch: j
  }) {
    return j ? /* @__PURE__ */ v.jsxs("div", { className: "flex space-x-2", children: [
      /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: () => L("table"),
          color: Q === "table" ? "primary" : "secondary",
          size: "sm",
          children: /* @__PURE__ */ v.jsx(dt, { name: "table", size: "lg" })
        }
      ),
      /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: () => L("card"),
          color: Q === "card" ? "primary" : "secondary",
          size: "sm",
          children: /* @__PURE__ */ v.jsx(dt, { name: "grid", size: "lg" })
        }
      )
    ] }) : null;
  }
  const q = (Q) => {
    var j, K, J;
    return /* @__PURE__ */ v.jsxs("div", { className: "flex items-center place-self-center gap-3", children: [
      (K = (j = e.tableConfig) == null ? void 0 : j.actions) == null ? void 0 : K.call(j, Q),
      ((J = e.draftConfig) == null ? void 0 : J.enabled) && e.draftConfig && /* @__PURE__ */ v.jsx(
        qe,
        {
          variant: "ghost",
          size: "sm",
          color: e.draftConfig.isDraftPredicate(Q) ? "secondary" : "success",
          onClick: async (re) => {
            var le;
            re.stopPropagation();
            try {
              const pe = e.draftConfig, me = pe.isDraftPredicate(Q) ? pe.transformToPublished(Q) : pe.transformToDraft(Q);
              await ((le = N == null ? void 0 : N.update) == null ? void 0 : le.call(N, Q.id, me)), G.success(
                z(
                  `${e.name}.crud.list.${pe.isDraftPredicate(Q) ? "publishedSuccess" : "draftSuccess"}`
                )
              ), window.dispatchEvent(
                new CustomEvent("refresh-entity-table", {
                  detail: {
                    entityName: e.name
                  }
                })
              );
            } catch (pe) {
              ae(pe);
            }
          },
          icon: e.draftConfig.isDraftPredicate(Q) ? "save-off" : "save",
          iconPosition: "left"
        }
      ),
      e.viewModalConfig && m && /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: (re) => {
            re.stopPropagation(), m(Q);
          },
          variant: "ghost",
          size: "sm",
          icon: "eye",
          iconPosition: "left"
        }
      ),
      h && /* @__PURE__ */ v.jsx(
        qe,
        {
          variant: "ghost",
          size: "sm",
          color: "primary",
          onClick: (re) => {
            re.stopPropagation(), h(Q);
          },
          icon: "edit",
          iconPosition: "left"
        }
      ),
      p && /* @__PURE__ */ v.jsx(
        qe,
        {
          variant: "ghost",
          size: "sm",
          color: "danger",
          onClick: async (re) => {
            re.stopPropagation(), await p(Q.id), D == null || D();
          },
          icon: "trash",
          iconPosition: "left"
        }
      ),
      x == null ? void 0 : x.map((re, le) => /* @__PURE__ */ v.jsxs(
        qe,
        {
          variant: re.variant || "ghost",
          color: re.color || "primary",
          size: "xs",
          onClick: (pe) => {
            pe.stopPropagation(), re.onClick(Q);
          },
          children: [
            re.icon && /* @__PURE__ */ v.jsx(dt, { name: re.icon, size: "sm" }),
            re.label
          ]
        },
        le
      ))
    ] });
  };
  return /* @__PURE__ */ v.jsx("div", { className: "flex-1 min-h-0 h-full flex flex-col", children: C === "table" ? /* @__PURE__ */ v.jsx(
    xx,
    {
      columns: e.columns,
      data: t,
      onSort: (Q, L) => c(Q, L),
      onRowClick: f,
      isLoading: r,
      coloredHeader: !0,
      emptyStateMessage: w ? ((U = w()) == null ? void 0 : U.toString()) ?? z(`${e.name}.crud.list.noItemsFound`) : z(`${e.name}.crud.list.noItemsFound`),
      sortColumn: o,
      sortDirection: l,
      pagination: {
        currentPage: a,
        totalPages: i > 0 ? Math.ceil(s / i) : 1,
        onPageChange: u,
        pageSize: i,
        totalItems: s || 0,
        onPageSizeChange: d
      },
      showCheckboxes: S,
      actions: q,
      headerSection: {
        after: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
          /* @__PURE__ */ v.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ v.jsx(
            ue,
            {
              viewMode: C,
              onViewModeChange: E,
              showViewModeSwitch: k
            }
          ) }),
          /* @__PURE__ */ v.jsx(
            uFe,
            {
              value: Y,
              onChange: g,
              placeholder: z(
                `${e.name}.crud.list.searchPlaceholder`
              ),
              isLoading: r,
              debounceDelay: 300
            }
          )
        ] })
      },
      footerSection: _ ? { before: _ } : void 0,
      error: ne,
      errorRenderer: P ? (Q) => P(Q) : void 0
    }
  ) : /* @__PURE__ */ v.jsx("div", { className: "space-y-6", children: r ? /* @__PURE__ */ v.jsx(la, {}) : /* @__PURE__ */ v.jsx(hr, { children: /* @__PURE__ */ v.jsx("div", { className: "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8 2xl:gap-10", children: t.map((Q) => /* @__PURE__ */ v.jsx(
    "div",
    {
      onClick: (L) => {
        L.defaultPrevented || f == null || f(Q);
      },
      children: O(Q)
    },
    Q.id
  )) }) }) }) });
}
function Qk({
  statusSection: e,
  currentStep: t,
  item: r
}) {
  const n = (l) => {
    switch (l) {
      case "completed":
        return /* @__PURE__ */ v.jsx(dt, { name: "check-circle", color: "success" });
      case "in_progress":
        return /* @__PURE__ */ v.jsx(dt, { name: "clock", color: "info" });
      case "pending":
        return /* @__PURE__ */ v.jsx(dt, { name: "empty-circle", color: "text-gray-300" });
      default:
        return /* @__PURE__ */ v.jsx(dt, { name: "empty-circle", color: "text-gray-300" });
    }
  }, a = (l) => typeof l.status == "function" && r ? l.status(r) : l.status, s = (l) => l.action ? typeof l.action == "function" && r ? l.action(r) || null : l.action : null, i = Tn(() => e.steps.map((l) => {
    const c = a(l), u = s(l);
    return {
      ...l,
      resolvedStatus: c,
      resolvedAction: u
    };
  }), [e.steps, r]), o = (l) => {
    if (M.isValidElement(l))
      return l;
    const c = l;
    return /* @__PURE__ */ v.jsxs(
      qe,
      {
        onClick: c.onClick,
        color: c.color || "primary",
        size: "sm",
        className: `mt-2 ${c.className || ""}`,
        children: [
          c.icon && /* @__PURE__ */ v.jsx(dt, { name: c.icon, className: "mr-2" }),
          c.label
        ]
      }
    );
  };
  return /* @__PURE__ */ v.jsx("div", { className: "space-y-8", children: i.map((l, c) => {
    const u = l.resolvedStatus === "in_progress" && l.resolvedAction;
    return /* @__PURE__ */ v.jsxs("div", { className: "flex items-start", children: [
      /* @__PURE__ */ v.jsx("div", { className: "flex-shrink-0 mr-3", children: n(l.resolvedStatus) }),
      /* @__PURE__ */ v.jsxs("div", { className: "flex-inline flex-col flex-grow space-y-1", children: [
        /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center", children: [
          /* @__PURE__ */ v.jsx(
            "span",
            {
              className: `text-sm font-medium ${l.resolvedStatus === "in_progress" ? "text-primary-600 dark:text-primary-400" : "text-gray-900 dark:text-gray-100"}`,
              children: l.label
            }
          ),
          l.date && /* @__PURE__ */ v.jsx("span", { className: "text-sm text-gray-500 dark:text-gray-400", children: l.date })
        ] }),
        typeof l.description == "string" ? /* @__PURE__ */ v.jsx("p", { className: "text-sm text-gray-500 dark:text-gray-400 mt-1 min-h-[1.5rem]", children: l.description }) : /* @__PURE__ */ v.jsx("p", { className: "text-sm text-gray-500 dark:text-gray-400 mt-1 min-h-[1.5rem]", children: l.description(r) }),
        u && o(l.resolvedAction)
      ] })
    ] }, c);
  }) });
}
function hFe({
  item: e,
  onClose: t,
  fields: r,
  title: n,
  onEdit: a,
  statusSection: s,
  additionalActions: i
}) {
  const { t: o } = _t(["common"]), { theme: l } = Wi(), c = tr(null), [u, d] = Me(!1);
  wt(() => {
    const p = setTimeout(() => d(!0), 50);
    return () => clearTimeout(p);
  }, []), wt(() => {
    const p = (m) => {
      c.current && !c.current.contains(m.target) && f();
    };
    return document.addEventListener("mousedown", p), () => {
      document.removeEventListener("mousedown", p);
    };
  }, []);
  const f = () => {
    d(!1), setTimeout(t, 300);
  }, h = (p) => {
    const g = ((y, x) => x.split(".").reduce((w, _) => w && w[_], y))(e, p.name);
    switch (p.type) {
      case "switch":
        return /* @__PURE__ */ v.jsx($F, { checked: !!g, readOnly: !0 });
      case "date":
        return g ? new Date(g).toLocaleDateString() : "";
      case "text":
      case "select":
      default:
        return /* @__PURE__ */ v.jsxs("div", { className: "flex items-center", children: [
          /* @__PURE__ */ v.jsx("span", { className: "text-sm text-gray-900", children: String(g || "") }),
          p.icon && /* @__PURE__ */ v.jsx(
            dt,
            {
              name: p.icon,
              className: "ml-2 text-gray-400",
              size: "xs"
            }
          )
        ] });
    }
  };
  return /* @__PURE__ */ v.jsx("div", { className: "fixed inset-0 overflow-hidden z-50", children: /* @__PURE__ */ v.jsxs("div", { className: "absolute inset-0 overflow-hidden", children: [
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: "absolute inset-0 bg-gray-500 opacity-75 transition-opacity",
        "aria-hidden": "true"
      }
    ),
    /* @__PURE__ */ v.jsx(
      "section",
      {
        className: "absolute inset-y-0 right-0 pl-10 max-w-full flex",
        "aria-labelledby": "slide-over-heading",
        children: /* @__PURE__ */ v.jsx(
          "div",
          {
            className: `relative w-screen max-w-md transform transition-transform ease-in-out duration-300 ${u ? "translate-x-0" : "translate-x-full"}`,
            children: /* @__PURE__ */ v.jsxs(
              "div",
              {
                ref: c,
                className: "h-full flex flex-col py-6 bg-background shadow-xl overflow-y-scroll",
                children: [
                  /* @__PURE__ */ v.jsx("div", { className: "px-4 sm:px-6", children: /* @__PURE__ */ v.jsxs("div", { className: "flex items-start justify-between", children: [
                    /* @__PURE__ */ v.jsx(
                      "h2",
                      {
                        className: "text-lg font-medium text-gray-900",
                        id: "slide-over-heading",
                        children: typeof n == "function" ? n(e) : n
                      }
                    ),
                    /* @__PURE__ */ v.jsx("div", { className: "ml-3", children: /* @__PURE__ */ v.jsx(
                      qe,
                      {
                        onClick: f,
                        variant: "ghost",
                        color: "secondary",
                        size: "xl",
                        icon: "close",
                        children: /* @__PURE__ */ v.jsx("span", { className: "sr-only", children: o("common.close") })
                      }
                    ) })
                  ] }) }),
                  /* @__PURE__ */ v.jsxs("div", { className: "mt-6 relative flex-1 px-4 sm:px-6", children: [
                    /* @__PURE__ */ v.jsx("div", { className: "space-y-6 mb-6", children: r.map((p) => /* @__PURE__ */ v.jsxs(
                      "div",
                      {
                        className: "sm:flex sm:items-center sm:gap-4 w-full",
                        children: [
                          /* @__PURE__ */ v.jsx("label", { className: "sm:w-1/3 block text-sm text-gray-700 font-semibold", children: p.label }),
                          /* @__PURE__ */ v.jsx("div", { className: "mt-1 sm:mt-0 sm:w-2/3", children: h(p) })
                        ]
                      },
                      p.name
                    )) }),
                    s && /* @__PURE__ */ v.jsx(
                      Qk,
                      {
                        statusSection: s,
                        currentStep: 0,
                        item: e
                      }
                    ),
                    i && /* @__PURE__ */ v.jsx("div", { className: "mt-6 space-y-4", children: i.map((p, m) => /* @__PURE__ */ v.jsxs("div", { children: [
                      /* @__PURE__ */ v.jsx("h4", { className: "font-medium mb-2", children: p.label }),
                      p.render && p.render(e)
                    ] }, m)) })
                  ] }),
                  a && /* @__PURE__ */ v.jsx("div", { className: "mt-6 px-4 sm:px-6", children: /* @__PURE__ */ v.jsx(qe, { onClick: a, variant: "outline", fullWidth: !0, children: o("common.edit") }) })
                ]
              }
            )
          }
        )
      }
    )
  ] }) });
}
class Aet extends M.Component {
  constructor(t) {
    super(t), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError(t) {
    return { hasError: !0 };
  }
  componentDidCatch(t, r) {
    console.error("Uncaught error:", t, r);
  }
  render() {
    return this.state.hasError ? this.props.fallback || /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center justify-center h-screen", children: [
      /* @__PURE__ */ v.jsx("h1", { className: "text-2xl font-bold mb-4 text-text", children: "Oops! Something went wrong." }),
      /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: () => window.location.reload(),
          variant: "solid",
          color: "primary",
          size: "md",
          children: "Reload Page"
        }
      )
    ] }) : this.props.children;
  }
}
const aS = [
  { code: "en", name: "English", flag: "flag-gb" },
  { code: "fr", name: "Français", flag: "flag-fr" },
  { code: "es", name: "Español", flag: "flag-es" },
  { code: "zh", name: "中文", flag: "flag-cn" }
], Pet = () => {
  const { i18n: e, t } = _t(["common"]), r = async (a) => {
    a !== e.language && await e.changeLanguage(a);
  }, n = aS.find((a) => {
    var s;
    return a.code === ((s = e.language) == null ? void 0 : s.split("-")[0]);
  }) || aS[0];
  return /* @__PURE__ */ v.jsx(
    FF,
    {
      trigger: /* @__PURE__ */ v.jsxs("div", { className: "flex items-center space-x-2 cursor-pointer", children: [
        /* @__PURE__ */ v.jsx(dt, { name: n.flag, size: "sm" }),
        /* @__PURE__ */ v.jsx("span", { className: "text-sm font-medium", children: t(`common:language.${n.code}`) }),
        /* @__PURE__ */ v.jsx(dt, { name: "chevron-down", size: "sm" })
      ] }),
      items: aS.map((a) => ({
        label: t(`common:language.${a.code}`),
        icon: a.flag,
        onClick: () => r(a.code)
      }))
    }
  );
};
function Jk({ type: e, className: t, inverted: r = !1 }) {
  const { theme: n, isDarkMode: a } = Wi(), s = n.tokens.logos[e === "client" ? "clientLogo" : "poweredByLogo"], i = r ? s.invertedSrc : a && s.darkModeSrc ? s.darkModeSrc : s.src;
  return /* @__PURE__ */ v.jsx(
    yw,
    {
      fallback: /* @__PURE__ */ v.jsx("div", { className: lt("flex items-center justify-center", t), children: /* @__PURE__ */ v.jsx(
        dt,
        {
          name: e === "client" ? "logo" : "image",
          className: lt("text-muted-foreground", r && "text-white"),
          size: "lg"
        }
      ) }),
      children: /* @__PURE__ */ v.jsx(
        fi,
        {
          src: i,
          alt: s.alt,
          width: s.width,
          height: s.height,
          className: lt("h-auto object-contain", t),
          fallbackSrc: `/branding/${e === "client" ? "default-client-logo" : "powered-by-logo"}${r ? "-dark" : ""}.png`
        }
      )
    }
  );
}
const pFe = ({ url: e, className: t }) => {
  const [r, n] = Me(!1), [a, s] = Me(!1);
  wt(() => {
    const g = () => {
      s(window.innerWidth < 768);
    };
    return g(), window.addEventListener("resize", g), () => window.removeEventListener("resize", g);
  }, []);
  const i = (g) => g.includes("youtube.com") || g.includes("youtu.be") ? "youtube" : g.includes("vimeo.com") ? "vimeo" : g.includes("dailymotion.com") ? "dailymotion" : g.includes("pitch.com") ? "pitch" : "unknown", o = (g, y) => {
    var x;
    switch (y) {
      case "youtube":
        if (g.includes("youtu.be"))
          return ((x = g.split("youtu.be/")[1]) == null ? void 0 : x.split("?")[0]) || null;
        const w = /(?:youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([^#&?]*)/, _ = g.match(w);
        return (_ == null ? void 0 : _[1]) || null;
      case "vimeo":
        const S = /vimeo\.com\/(?:.*#|.*\/videos\/)?([0-9]+)/, C = g.match(S);
        return C ? C[1] : null;
      case "dailymotion":
        const E = /^.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/, O = g.match(E);
        return O ? O[2] : null;
      default:
        return null;
    }
  }, l = (g, y) => {
    switch (y) {
      case "youtube":
        return `https://www.youtube.com/watch?v=${g}`;
      case "vimeo":
        return `https://vimeo.com/${g}`;
      case "dailymotion":
        return `https://www.dailymotion.com/video/${g}`;
      default:
        return e;
    }
  }, c = (g, y) => {
    switch (y) {
      case "pitch":
        return `${e.split("/").slice(0, -1).join("/")}/embed`;
      case "youtube":
        return `https://www.youtube-nocookie.com/embed/${g}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
      case "vimeo":
        return `https://player.vimeo.com/video/${g}?autoplay=1`;
      case "dailymotion":
        return `https://www.dailymotion.com/embed/video/${g}?autoplay=1`;
      default:
        return e;
    }
  }, u = (g, y) => {
    switch (y) {
      case "youtube":
        return `https://img.youtube.com/vi/${g}/maxresdefault.jpg`;
      case "vimeo":
        return "/images/video-placeholder.jpg";
      case "dailymotion":
        return `https://www.dailymotion.com/thumbnail/video/${g}`;
      default:
        return "/images/video-placeholder.jpg";
    }
  }, d = i(e), f = o(e, d), h = f ? l(f, d) : e, p = f ? u(f, d) : "/images/video-placeholder.jpg", m = () => {
    a ? window.open(h, "_blank") : n(!0);
  };
  return r ? /* @__PURE__ */ v.jsx("div", { className: `relative aspect-video ${t}`, children: /* @__PURE__ */ v.jsx(
    "iframe",
    {
      className: "w-full h-full rounded-lg",
      src: c(f || "", d),
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: !0
    }
  ) }) : /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `relative aspect-video border border-border rounded-lg ${t}`,
      onClick: m,
      children: [
        /* @__PURE__ */ v.jsx(
          "img",
          {
            src: p,
            alt: "Video thumbnail",
            className: "w-full h-full object-cover rounded-lg"
          }
        ),
        /* @__PURE__ */ v.jsxs("div", { className: "absolute inset-0 flex items-center justify-center", children: [
          /* @__PURE__ */ v.jsx("div", { className: "absolute bg-black bg-opacity-70 rounded-full p-6 -ml-1" }),
          /* @__PURE__ */ v.jsx(dt, { name: "play", size: "xl", className: "z-10", color: "white" })
        ] })
      ]
    }
  );
}, mFe = ({ url: e, className: t }) => {
  const r = (s) => s.includes("pitch.com") ? "presentation" : s.includes("youtube.com") || s.includes("youtu.be") || s.includes("vimeo.com") || s.includes("dailymotion.com") ? "video" : "unknown", n = ({
    url: s,
    className: i
  }) => {
    var c;
    const l = `https://backend.services.pitch.com/preview-image-by-managed-link/${(c = s.split("/")[4]) == null ? void 0 : c.split("-").pop()}`;
    return /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: `relative aspect-[16/9] rounded-lg flex flex-col items-center justify-center cursor-pointer overflow-hidden ${i}`,
        onClick: () => window.open(s, "_blank"),
        children: [
          /* @__PURE__ */ v.jsx(
            "div",
            {
              className: "absolute inset-0 bg-cover bg-center",
              style: { backgroundImage: `url(${l})` }
            }
          ),
          /* @__PURE__ */ v.jsxs("div", { className: "absolute z-10 top-0 left-0 bottom-0 right-0 flex items-center justify-center bg-black/10", children: [
            /* @__PURE__ */ v.jsx("div", { className: "absolute bg-white bg-opacity-90 rounded-full p-6" }),
            /* @__PURE__ */ v.jsx(dt, { name: "presentation", size: "xl", className: "z-10", color: "black" })
          ] })
        ]
      }
    );
  };
  switch (r(e)) {
    case "presentation":
      return /* @__PURE__ */ v.jsx(n, { url: e, className: t });
    case "video":
      return /* @__PURE__ */ v.jsx(pFe, { url: e, className: t });
    default:
      return /* @__PURE__ */ v.jsx("div", { className: "bg-gray-100 text-gray-500 text-center p-4 rounded-lg", children: "Unsupported media type" });
  }
}, Ret = ({
  steps: e,
  currentStep: t,
  className: r,
  labels: n,
  orientation: a = "horizontal",
  size: s = "md"
}) => /* @__PURE__ */ v.jsx(
  "div",
  {
    className: lt(
      "flex items-center gap-2",
      a === "vertical" && "flex-col",
      r
    ),
    children: Array.from({ length: e }).map((i, o) => /* @__PURE__ */ v.jsxs("div", { className: "flex items-center space-x-2", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: lt(
              "rounded-full transition-all",
              s === "sm" && "h-2 w-2",
              s === "md" && "h-3 w-3",
              s === "lg" && "h-4 w-4",
              o === t ? "bg-primary-600 ring-4 ring-secondary-300" : o < t ? "bg-success-600" : "bg-gray-200"
            )
          }
        ),
        n && /* @__PURE__ */ v.jsx(
          "span",
          {
            className: lt(
              "text-sm",
              o === t ? "text-primary-600 font-medium" : o < t ? "text-success-600" : "text-gray-200"
            ),
            children: n[o]
          }
        )
      ] }),
      o < e - 1 && /* @__PURE__ */ v.jsx(
        "div",
        {
          className: lt(
            a === "horizontal" ? "h-[2px] w-12" : "w-[2px] h-12",
            o < t ? "bg-success-600" : "bg-gray-200"
          )
        }
      )
    ] }, o))
  }
), gFe = ({
  progress: e,
  size: t = "md",
  variant: r = "solid",
  color: n = "primary",
  showLabel: a = !1,
  labelPosition: s = "outside",
  animated: i = !0,
  indeterminate: o = !1,
  className: l,
  labelFormatter: c = (d) => `${Math.round(d)}%`,
  theme: u
}) => {
  const d = Math.min(Math.max(e || 0, 0), 100), f = c(d), h = u.baseStyle, p = lt(
    h.bar,
    h.sizes[t],
    h.variants[r],
    h.colors[n][r],
    i && h.states.animated,
    o && h.states.indeterminate
  ), m = /* @__PURE__ */ v.jsx("div", { className: h.wrapper, children: /* @__PURE__ */ v.jsx(
    "div",
    {
      className: p,
      style: { width: o ? "100%" : `${d}%` },
      role: "progressbar",
      "aria-valuenow": d,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      children: a && s === "inside" && /* @__PURE__ */ v.jsx("span", { className: h.labelPositions.inside, children: f })
    }
  ) });
  return a && s === "end" ? /* @__PURE__ */ v.jsxs("div", { className: lt(h.base, h.container, l), children: [
    m,
    /* @__PURE__ */ v.jsx("span", { className: h.labelPositions.end, children: f })
  ] }) : /* @__PURE__ */ v.jsxs("div", { className: lt(h.base, l), children: [
    m,
    a && s === "outside" && /* @__PURE__ */ v.jsx("span", { className: h.labelPositions.outside, children: f })
  ] });
}, vFe = $r(
  "ProgressBar",
  gFe
), yFe = ({
  options: e,
  value: t,
  onChange: r,
  name: n,
  disabled: a = !1,
  size: s = "medium",
  error: i,
  helperText: o,
  className: l,
  theme: c,
  ...u
}) => {
  var p;
  const d = (m) => {
    r(m.target.value);
  }, f = c.baseStyle, h = ((p = c.sizes) == null ? void 0 : p[s]) || {};
  return /* @__PURE__ */ v.jsxs("div", { className: lt(f.base, f.wrapper, l), children: [
    e.map((m) => /* @__PURE__ */ v.jsx("div", { className: f.radioWrapper, children: /* @__PURE__ */ v.jsxs("label", { className: f.label, children: [
      /* @__PURE__ */ v.jsx(
        "input",
        {
          type: "radio",
          name: n,
          value: m.value,
          checked: t === m.value,
          disabled: a,
          onChange: d,
          className: lt(
            f.input,
            h.input,
            a ? f.disabled : "",
            i ? f.error : ""
          ),
          ...u
        }
      ),
      /* @__PURE__ */ v.jsx("span", { className: h.label, children: m.label })
    ] }) }, m.value)),
    (o || i) && /* @__PURE__ */ v.jsx("p", { className: i ? f.error : f.helperText, children: i || o })
  ] });
}, Iet = $r(
  "RadioGroup",
  yFe
), bFe = ({
  variant: e = "rectangular",
  animation: t = "pulse",
  width: r,
  height: n,
  className: a,
  repeat: s = 1,
  gap: i = 2,
  layout: o = "flex",
  gridCols: l = 1,
  theme: c
}) => {
  const u = Array.from({ length: s }, (f, h) => {
    var m, g;
    const p = lt(
      c.baseStyle.base,
      {
        [c.baseStyle.animation.pulse]: t === "pulse",
        [c.baseStyle.animation.wave]: t === "wave",
        [c.baseStyle.borderRadius.circular]: e === "circular",
        [c.baseStyle.borderRadius.rectangular]: e === "rectangular" || e === "button"
      },
      (g = (m = c.variants) == null ? void 0 : m[e]) == null ? void 0 : g.base,
      a
    );
    return /* @__PURE__ */ v.jsx(
      "div",
      {
        className: p,
        style: {
          width: typeof r == "number" ? `${r}px` : r,
          height: typeof n == "number" ? `${n}px` : n
        },
        "aria-hidden": "true"
      },
      h
    );
  }), d = lt({
    "flex flex-col": o === "flex",
    [`grid grid-cols-${l}`]: o === "grid",
    [`gap-${i}`]: i > 0
  });
  return /* @__PURE__ */ v.jsx("div", { className: d, children: u });
}, _l = $r(
  "Skeleton",
  bFe
), Det = ({
  steps: e,
  currentStep: t
}) => /* @__PURE__ */ v.jsx("div", { className: "flex items-center justify-center mb-6", children: e.map((r, n) => /* @__PURE__ */ v.jsxs(M.Fragment, { children: [
  /* @__PURE__ */ v.jsxs("div", { className: "flex items-center", children: [
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: `w-8 h-8 rounded-full flex items-center justify-center ${n <= t ? "bg-primary-600 text-white" : "bg-gray-200 text-gray-600"}`,
        children: n + 1
      }
    ),
    /* @__PURE__ */ v.jsx(
      "span",
      {
        className: `ml-2 ${n <= t ? "text-primary-600" : "text-gray-600"}`,
        children: r
      }
    )
  ] }),
  n < e.length - 1 && /* @__PURE__ */ v.jsx(
    "div",
    {
      className: `w-16 h-1 mx-2 ${n < t ? "bg-primary-600" : "bg-gray-200"}`
    }
  )
] }, n)) }), wFe = ({
  activeTab: e,
  onTabChange: t,
  children: r,
  variant: n = "default",
  size: a = "md",
  icon: s,
  iconPosition: i = "left",
  disabled: o = !1,
  className: l,
  theme: c
}) => {
  var h, p;
  const u = c.baseStyle, d = ((h = c.variants) == null ? void 0 : h[n]) || {}, f = ((p = c.sizes) == null ? void 0 : p[a]) || {};
  return /* @__PURE__ */ v.jsxs("div", { className: lt(u.base, l), children: [
    /* @__PURE__ */ v.jsx("div", { className: lt(u.tabList, d.tabList, f.tabList), children: M.Children.map(r, (m) => {
      if (!M.isValidElement(m)) return null;
      const g = e === m.props.value;
      return /* @__PURE__ */ v.jsxs(
        "button",
        {
          className: lt(
            u.tab,
            d.tab,
            f.tab,
            g && u.states.active,
            o && u.states.disabled
          ),
          onClick: () => !o && t(m.props.value),
          disabled: o,
          role: "tab",
          "aria-selected": g,
          children: [
            s && i === "left" && /* @__PURE__ */ v.jsx(dt, { name: s, className: u.icon }),
            /* @__PURE__ */ v.jsx("span", { className: u.tabContent, children: m.props.title }),
            s && i === "right" && /* @__PURE__ */ v.jsx(dt, { name: s, className: u.icon }),
            g && /* @__PURE__ */ v.jsx("div", { className: u.activeIndicator })
          ]
        },
        m.props.value
      );
    }) }),
    /* @__PURE__ */ v.jsx("div", { className: u.panelContainer, children: M.Children.toArray(r).find(
      (m) => m.props.value === e
    ) })
  ] });
}, oT = ({ children: e, className: t }) => /* @__PURE__ */ v.jsx("div", { role: "tabpanel", className: lt("pt-4", t), children: e }), a$ = $r("Tabs", wFe);
function xFe(e, t, r, n, a) {
  wt(() => {
    const s = () => {
      if (!r.current || !n.current) return;
      const i = r.current.getBoundingClientRect(), o = n.current.getBoundingClientRect(), l = {
        top: {
          top: i.top - o.height,
          left: i.left + i.width / 2 - o.width / 2
        },
        bottom: {
          top: i.bottom,
          left: i.left + i.width / 2 - o.width / 2
        },
        left: {
          top: i.top + i.height / 2 - o.height / 2,
          left: i.left - o.width
        },
        right: {
          top: i.top + i.height / 2 - o.height / 2,
          left: i.right
        }
      };
      a(l[t]);
    };
    return e && (s(), window.addEventListener("resize", s), window.addEventListener("scroll", s)), () => {
      window.removeEventListener("resize", s), window.removeEventListener("scroll", s);
    };
  }, [e, t, r, n, a]);
}
const _Fe = ({
  children: e,
  content: t,
  placement: r = "top",
  variant: n = "dark",
  delay: a = 0,
  disabled: s = !1,
  className: i,
  theme: o,
  ...l
}) => {
  var w, _, S, C;
  const [c, u] = Me(!1), [d, f] = Me({ top: 0, left: 0 }), h = tr(null), p = tr(null);
  xFe(c, r, h, p, f);
  const m = () => {
    s || setTimeout(() => u(!0), a);
  }, g = () => u(!1), y = lt(
    o.baseStyle.base,
    o.baseStyle.content,
    (_ = (w = o.variants) == null ? void 0 : w[n]) == null ? void 0 : _.content,
    o.baseStyle.placements[r].container,
    c ? o.baseStyle.states.visible : o.baseStyle.states.disabled,
    i
  ), x = lt(
    o.baseStyle.arrow,
    (C = (S = o.variants) == null ? void 0 : S[n]) == null ? void 0 : C.arrow,
    o.baseStyle.placements[r].arrow
  );
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      ref: h,
      className: o.baseStyle.container,
      onMouseEnter: m,
      onMouseLeave: g,
      onFocus: m,
      onBlur: g,
      ...l,
      children: [
        e,
        bw(
          /* @__PURE__ */ v.jsxs(
            "div",
            {
              ref: p,
              role: "tooltip",
              className: y,
              style: {
                top: `${d.top}px`,
                left: `${d.left}px`
              },
              children: [
                t,
                /* @__PURE__ */ v.jsx("div", { className: x, "aria-hidden": "true" })
              ]
            }
          ),
          document.body
        )
      ]
    }
  );
}, ni = $r(
  "Tooltip",
  _Fe
), Yg = ({
  show: e = !0,
  text: t,
  color: r = "#f3f4f6",
  icon: n = "radar",
  route: a,
  primaryAction: s,
  secondaryAction: i,
  iconSize: o = "lg",
  className: l = ""
}) => {
  const c = ta(), u = !!a, d = (f) => {
    f && (f.target instanceof Element && (f.target.closest("a") || f.target.closest("button") || f.target.closest('[role="button"]') || f.target.closest("input") || f.target.closest("select") || f.target.closest("textarea")) || u && c(a));
  };
  return e ? /* @__PURE__ */ v.jsx(
    "div",
    {
      className: lt(
        "overflow-hidden will-change-transform animate-expand-banner"
      ),
      children: /* @__PURE__ */ v.jsx(
        hr,
        {
          className: lt("transition-transform duration-300", l),
          onClick: u ? d : void 0,
          color: r,
          children: /* @__PURE__ */ v.jsxs(
            "div",
            {
              className: lt(
                "container mx-auto flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0",
                u && "cursor-pointer"
              ),
              children: [
                /* @__PURE__ */ v.jsxs("div", { className: "flex items-center space-x-4", children: [
                  /* @__PURE__ */ v.jsx(
                    dt,
                    {
                      name: n,
                      size: o,
                      className: "text-primary-500 flex-shrink-0"
                    }
                  ),
                  /* @__PURE__ */ v.jsx("div", { className: "text-base sm:text-lg font-medium", children: t })
                ] }),
                (s || i) && /* @__PURE__ */ v.jsxs("div", { className: "flex w-full sm:w-auto space-x-2 sm:space-x-4", children: [
                  i && /* @__PURE__ */ v.jsx(
                    qe,
                    {
                      variant: "outline",
                      onClick: i.onClick,
                      className: "flex-1 sm:flex-none bg-white",
                      children: i.label
                    }
                  ),
                  s && /* @__PURE__ */ v.jsx(
                    qe,
                    {
                      variant: "solid",
                      onClick: s.onClick,
                      disabled: s.disabled,
                      className: "flex-1 sm:flex-none",
                      children: s.label
                    }
                  )
                ] })
              ]
            }
          )
        }
      )
    }
  ) : null;
}, Zk = ({
  batches: e,
  frozen: t,
  availableBatches: r,
  showInfo: n = !1,
  progressBarProps: a,
  extraAmount: s = 0,
  batchPrice: i = 0
}) => {
  const { t: o } = _t(["projects"]), l = () => {
    if (r !== void 0) {
      const d = (e - (r + t)) / e * 100;
      let f = 0;
      if (s > 0 && i > 0 && e > 0) {
        const p = e * i;
        f = s / p * 100;
      }
      return Math.min(d + f, 100);
    }
    return 0;
  }, c = (u) => Ao(u, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    preserveDecimals: !0
  });
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      vFe,
      {
        ...a,
        progress: l(),
        labelFormatter: (u) => `${c(u)}%`
      }
    ),
    n && /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between text-sm text-text mt-1 font-medium", children: [
      /* @__PURE__ */ v.jsx("span", { children: o("projects.fundingProgress") }),
      /* @__PURE__ */ v.jsxs("span", { children: [
        c(l()),
        "%"
      ] })
    ] })
  ] });
}, Mb = (e) => {
  switch (KT(e).styleKey) {
    case "created":
      return 0;
    case "available":
      return 1;
    case "startsOn":
      return 2;
    case "goalReached":
      return 3;
    case "minted":
      return 4;
    case "expired":
      return 5;
    case "closed":
      return 6;
    case "canceled":
      return 7;
    default:
      return 8;
  }
}, SFe = ({
  watchFields: e,
  calculate: t,
  renderResult: r,
  shouldShow: n = () => !0,
  className: a
}) => {
  const { watch: s } = Ch(), i = tr({}), [o, l] = Me(null), [c, u] = Me({}), d = tr(t), f = tr(n);
  wt(() => {
    d.current = t, f.current = n;
  }, [t, n]);
  const h = Tn(() => e.join(","), [e]);
  return wt(() => {
    const m = (x) => {
      const w = {};
      for (const _ of e)
        w[_] = x[_];
      return w;
    }, g = (x, w) => {
      for (const _ of e)
        if (x[_] !== w[_])
          return !0;
      return !1;
    }, y = s((x) => {
      if (!x) return;
      const w = m(x);
      if (g(w, i.current)) {
        i.current = { ...w }, u(w);
        try {
          const _ = d.current(w);
          l(_);
        } catch (_) {
          console.error("Error in calculation:", _);
        }
      }
    });
    return () => y.unsubscribe();
  }, [s, e, h]), wt(() => {
    const m = s(), g = {};
    for (const y of e)
      g[y] = m[y];
    i.current = g, u(g);
    try {
      const y = d.current(g);
      l(y);
    } catch (y) {
      console.error("Error in initial calculation:", y);
    }
  }, [s, e, h]), f.current(c) ? /* @__PURE__ */ v.jsx("div", { className: a, children: r(o, c) }) : null;
}, EFe = ({ className: e }) => {
  const { t } = _t(["projects"]);
  return /* @__PURE__ */ v.jsx(
    SFe,
    {
      watchFields: ["price", "batches"],
      calculate: (r) => {
        const n = Number(r.price) || 0, a = Number(r.batches) || 0;
        return n * a;
      },
      shouldShow: (r) => {
        const n = Number(r.price) || 0, a = Number(r.batches) || 0;
        return n > 0 && a > 0;
      },
      renderResult: (r, n) => {
        const a = Number(n.price) || 0, s = Number(n.batches) || 0;
        return /* @__PURE__ */ v.jsx("div", { className: "col-span-12 p-3 bg-primary-50 rounded-md border border-primary-200", children: /* @__PURE__ */ v.jsxs("p", { className: "text-sm text-primary-700", children: [
          /* @__PURE__ */ v.jsxs("span", { className: "font-medium", children: [
            t("projects.targetAmount"),
            " = ",
            t("projects.price"),
            " * ",
            t("projects.batches")
          ] }),
          /* @__PURE__ */ v.jsx("br", {}),
          /* @__PURE__ */ v.jsxs("span", { className: "text-primary-600", children: [
            Number(a).toLocaleString("fr-FR"),
            " € ×",
            " ",
            Number(s).toLocaleString("fr-FR"),
            " = ",
            Number(r).toLocaleString("fr-FR"),
            " ",
            "€"
          ] })
        ] }) });
      },
      className: e
    }
  );
}, e2 = (e) => {
  var r, n;
  if (!((n = (r = e == null ? void 0 : e.attributes) == null ? void 0 : r.info) != null && n.showProgressBar))
    return { show: !1 };
  const t = e.attributes.info.showProgressBar;
  if (Array.isArray(t) && t.length > 0) {
    const a = t[0];
    return {
      show: a.show === !0,
      extraAmount: a.extraAmount ? typeof a.extraAmount == "string" ? parseFloat(a.extraAmount) || 0 : a.extraAmount : 0
    };
  }
  return typeof t == "object" && !Array.isArray(t) ? {
    show: t.show === !0,
    extraAmount: t.extraAmount ? typeof t.extraAmount == "string" ? parseFloat(t.extraAmount) || 0 : t.extraAmount : 0
  } : typeof t == "boolean" ? {
    show: t,
    extraAmount: 0
  } : { show: !1 };
}, H0 = ui().PAYMENT_PROVIDER, W0 = () => ui().MEDIA_BASE_URL || ui().API_BASE_URL, TFe = () => {
  const { t: e } = _t(["projects", "common"]), t = sn(), { uploadMultipleFiles: r } = DJ();
  ui();
  const n = [
    {
      title: e("projects.generalInfo"),
      fields: [
        {
          name: "name",
          label: e("projects.name"),
          type: "text",
          required: !0,
          labelProps: { position: "top" },
          layout: { className: "col-span-12" }
        },
        {
          name: "price",
          label: e("projects.price"),
          type: "number",
          required: !0,
          labelProps: { position: "top" },
          layout: { className: "col-span-6" },
          inputProps: { step: 0.01 }
        },
        {
          name: "batches",
          label: e("projects.batches"),
          type: "number",
          required: !0,
          labelProps: { position: "top" },
          layout: { className: "col-span-6" },
          inputProps: { step: 0.01 }
        },
        {
          name: "info.description",
          label: e("projects.description"),
          type: "richText",
          required: !0,
          labelProps: { position: "top" },
          layout: { className: "col-span-12" }
        },
        {
          name: "info.attributes.info.type",
          label: e("projects.type"),
          type: "text",
          labelProps: { position: "top" },
          layout: { className: "col-span-6" }
        },
        {
          name: "info.attributes.info.showProgressBar",
          label: e("projects.showProgressBar"),
          type: "advancedDynamicList",
          maxItems: 1,
          fields: [
            {
              name: "show",
              type: "switch",
              label: e("projects.showProgressBar"),
              labelProps: { position: "right" },
              layout: { className: "col-span-6" }
            },
            {
              name: "extraAmount",
              type: "number",
              label: e("projects.extraAmount"),
              layout: { className: "col-span-6" },
              inputProps: { step: 0.01 }
            }
          ],
          layout: { className: "col-span-12" }
        },
        {
          name: "info.attributes.info.reasons",
          label: e("projects.reasons.label"),
          type: "advancedDynamicList",
          fields: [
            {
              name: "title",
              type: "select",
              label: e("common:common.title"),
              layout: { className: "col-span-12 md:col-span-6" },
              selectProps: {
                options: [],
                isClearable: !0,
                isCreatable: !0,
                formatCreateLabel: (d) => `Create "${d}"`
              }
            },
            {
              name: "description",
              type: "text",
              label: e("common:common.description"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.descriptionPlaceholder")
            }
          ],
          layout: { className: "col-span-12" }
        },
        {
          name: "info.attributes.info.kpis.kpi_1",
          label: e("projects.finance.yields.kpi_1"),
          type: "advancedDynamicList",
          required: !0,
          maxItems: 1,
          fields: [
            {
              name: "title",
              type: "select",
              label: e("common:common.title"),
              layout: { className: "col-span-12 md:col-span-6" },
              required: !0,
              selectProps: {
                options: [],
                isClearable: !0,
                isCreatable: !0,
                formatCreateLabel: (d) => `Create "${d}"`
              }
            },
            {
              name: "description",
              type: "text",
              label: e("common:common.description"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.descriptionPlaceholder")
            },
            {
              name: "value",
              type: "number",
              label: e("common:common.value"),
              required: !0,
              layout: { className: "col-span-12 md:col-span-4" },
              placeholder: e("common:common.valuePlaceholder")
            },
            {
              name: "operator",
              type: "text",
              label: e("common:common.operator"),
              layout: { className: "col-span-12 md:col-span-4" },
              placeholder: e("common:common.operatorPlaceholder")
            },
            {
              name: "tooltip",
              type: "text",
              label: e("common:common.tooltip"),
              layout: { className: "col-span-12 md:col-span-4" },
              placeholder: e("common:common.tooltipPlaceholder")
            }
          ],
          layout: { className: "col-span-12" }
        },
        {
          name: "info.attributes.info.kpis.kpi_2",
          label: e("projects.finance.yields.kpi_2"),
          type: "advancedDynamicList",
          required: !0,
          maxItems: 1,
          fields: [
            {
              name: "title",
              type: "select",
              label: e("common:common.title"),
              layout: { className: "col-span-12 md:col-span-6" },
              required: !0,
              selectProps: {
                options: [],
                isClearable: !0,
                isCreatable: !0,
                formatCreateLabel: (d) => `Create "${d}"`
              }
            },
            {
              name: "description",
              type: "text",
              label: e("common:common.description"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.descriptionPlaceholder")
            },
            {
              name: "value",
              type: "number",
              label: e("common:common.value"),
              required: !0,
              layout: { className: "col-span-12 md:col-span-4" },
              placeholder: e("common:common.valuePlaceholder")
            },
            {
              name: "operator",
              type: "text",
              label: e("common:common.operator"),
              layout: { className: "col-span-12 md:col-span-4" },
              placeholder: e("common:common.operatorPlaceholder")
            },
            {
              name: "tooltip",
              type: "text",
              label: e("common:common.tooltip"),
              layout: { className: "col-span-12 md:col-span-4" },
              placeholder: e("common:common.tooltipPlaceholder")
            }
          ],
          layout: { className: "col-span-12" }
        },
        {
          name: "info.attributes.info.simulation",
          label: e("projects.simulation.title"),
          type: "advancedDynamicList",
          maxItems: 1,
          fields: [
            {
              name: "rate",
              type: "number",
              label: e("projects.simulation.rate"),
              required: !0,
              layout: { className: "col-span-12 md:col-span-6" },
              inputProps: {
                step: 0.01,
                min: 0,
                max: 100
              }
            },
            {
              name: "duration",
              type: "number",
              label: e("projects.simulation.duration"),
              required: !0,
              layout: { className: "col-span-12 md:col-span-6" },
              inputProps: {
                step: 1,
                min: 1,
                max: 120
              }
            },
            {
              name: "durationType",
              type: "select",
              label: e("projects.simulation.durationType"),
              required: !0,
              layout: { className: "col-span-12 md:col-span-6" },
              selectProps: {
                options: [
                  { label: e("projects.simulation.years"), value: "year" },
                  { label: e("projects.simulation.months"), value: "month" }
                ],
                isClearable: !1
              }
            },
            {
              name: "min",
              type: "number",
              label: e("projects.simulation.min"),
              required: !0,
              layout: { className: "col-span-12 md:col-span-6" },
              inputProps: {
                step: 1,
                min: 1,
                max: 120
              }
            },
            {
              name: "max",
              type: "number",
              label: e("projects.simulation.max"),
              required: !0,
              layout: { className: "col-span-12 md:col-span-6" },
              inputProps: {
                step: 1,
                min: 1,
                max: 120
              }
            }
          ],
          layout: { className: "col-span-12" }
        }
      ],
      displayComponents: {
        afterField: [
          {
            fieldName: "batches",
            component: /* @__PURE__ */ v.jsx(EFe, {}),
            className: "col-span-12"
          }
        ]
      }
    },
    {
      title: e("projects.finance.title"),
      fields: [
        {
          name: "info.attributes.finance.image",
          label: e("projects.finance.image"),
          type: "file",
          labelProps: { position: "top" },
          layout: { className: "col-span-12" },
          fileUploadProps: {
            accept: "image/*",
            maxFiles: 1
          },
          transform: {
            input: (d) => d.length === 0 ? "" : d[0],
            output: (d) => d ? [d] : []
          }
        },
        {
          name: "info.attributes.finance.charges",
          label: e("projects.finance.charges.title"),
          type: "advancedDynamicList",
          fields: [
            {
              name: "title",
              type: "select",
              label: e("common:common.title"),
              layout: { className: "col-span-12 md:col-span-6" },
              selectProps: {
                options: [
                  {
                    label: e("projects.finance.charges.maintenance"),
                    value: "maintenance"
                  },
                  {
                    label: e("projects.finance.charges.energy"),
                    value: "energy"
                  },
                  {
                    label: e("projects.finance.charges.worksFund"),
                    value: "works_fund"
                  },
                  {
                    label: e("projects.finance.charges.taxes"),
                    value: "taxes"
                  },
                  {
                    label: e("projects.finance.charges.managementFees"),
                    value: "management_fees"
                  }
                ],
                isClearable: !0,
                isCreatable: !0,
                formatCreateLabel: (d) => `Create "${d}"`
              }
            },
            {
              name: "value",
              type: "number",
              label: e("common:common.value"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.valuePlaceholder")
            },
            {
              name: "operator",
              type: "text",
              label: e("common:common.operator"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.operatorPlaceholder")
            },
            {
              name: "tooltip",
              type: "text",
              label: e("common:common.tooltip"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.tooltipPlaceholder")
            }
          ],
          layout: { className: "col-span-12" }
        },
        {
          name: "info.attributes.finance.revenues",
          label: e("projects.finance.revenues.title"),
          type: "advancedDynamicList",
          fields: [
            {
              name: "title",
              type: "select",
              label: e("common:common.title"),
              layout: { className: "col-span-12 md:col-span-6" },
              selectProps: {
                options: [
                  {
                    label: e("projects.finance.revenues.dailyAverage"),
                    value: "daily_average"
                  },
                  {
                    label: e("projects.finance.revenues.energy"),
                    value: "energy"
                  }
                ],
                isClearable: !0,
                isCreatable: !0,
                formatCreateLabel: (d) => `Create "${d}"`
              }
            },
            {
              name: "value",
              type: "number",
              label: e("common:common.value"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.valuePlaceholder")
            },
            {
              name: "operator",
              type: "text",
              label: e("common:common.operator"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.operatorPlaceholder")
            },
            {
              name: "tooltip",
              type: "text",
              label: e("common:common.tooltip"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.tooltipPlaceholder")
            }
          ],
          layout: { className: "col-span-12" }
        },
        {
          name: "info.attributes.finance.results",
          label: e("projects.finance.results.title"),
          type: "advancedDynamicList",
          fields: [
            {
              name: "title",
              type: "select",
              label: e("common:common.title"),
              layout: { className: "col-span-12 md:col-span-6" },
              selectProps: {
                options: [],
                isClearable: !0,
                isCreatable: !0,
                formatCreateLabel: (d) => `Create "${d}"`
              }
            },
            {
              name: "value",
              type: "number",
              label: e("common:common.value"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.valuePlaceholder")
            },
            {
              name: "operator",
              type: "text",
              label: e("common:common.operator"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.operatorPlaceholder")
            },
            {
              name: "tooltip",
              type: "text",
              label: e("common:common.tooltip"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.tooltipPlaceholder")
            }
          ],
          layout: { className: "col-span-12" }
        },
        {
          name: "info.attributes.finance.investment",
          label: e("projects.finance.investment.title"),
          type: "advancedDynamicList",
          fields: [
            {
              name: "title",
              type: "select",
              label: e("common:common.title"),
              layout: { className: "col-span-12 md:col-span-6" },
              selectProps: {
                options: [],
                isClearable: !0,
                isCreatable: !0,
                formatCreateLabel: (d) => `Create "${d}"`
              }
            },
            {
              name: "value",
              type: "number",
              label: e("common:common.value"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.valuePlaceholder")
            },
            {
              name: "operator",
              type: "text",
              label: e("common:common.operator"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.operatorPlaceholder")
            },
            {
              name: "tooltip",
              type: "text",
              label: e("common:common.tooltip"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.tooltipPlaceholder")
            }
          ],
          layout: { className: "col-span-12" }
        },
        {
          name: "info.attributes.finance.resale",
          label: e("projects.finance.resale.title"),
          type: "advancedDynamicList",
          fields: [
            {
              name: "title",
              type: "select",
              label: e("common:common.title"),
              layout: { className: "col-span-12 md:col-span-6" },
              selectProps: {
                options: [],
                isClearable: !0,
                isCreatable: !0,
                formatCreateLabel: (d) => `Create "${d}"`
              }
            },
            {
              name: "value",
              type: "number",
              label: e("common:common.value"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.valuePlaceholder")
            },
            {
              name: "operator",
              type: "text",
              label: e("common:common.operator"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.operatorPlaceholder")
            },
            {
              name: "tooltip",
              type: "text",
              label: e("common:common.tooltip"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.tooltipPlaceholder")
            }
          ],
          layout: { className: "col-span-12" }
        }
      ]
    },
    {
      title: e("projects.presentation.title"),
      fields: [
        {
          name: "info.features",
          label: e("projects.features.title"),
          type: "richText",
          required: !0,
          labelProps: { position: "top" },
          layout: { className: "col-span-12" }
        },
        {
          name: "info.strategy",
          label: e("projects.strategy.title"),
          type: "richText",
          required: !0,
          labelProps: { position: "top" },
          layout: { className: "col-span-12" }
        },
        {
          name: "info.attributes.news",
          label: e("projects.news.title"),
          type: "advancedDynamicList",
          fields: [
            {
              name: "title",
              type: "text",
              label: e("common:common.title"),
              required: !0,
              layout: { className: "col-span-12 md:col-span-6" }
            },
            {
              name: "sourceUrl",
              type: "text",
              label: e("projects.news.sourceUrl"),
              layout: { className: "col-span-12 md:col-span-6" }
            },
            {
              name: "imageUrl",
              type: "file",
              label: e("common:common.image"),
              layout: { className: "col-span-12 md:col-span-6" },
              fileUploadProps: {
                accept: "image/*",
                maxFiles: 1
              },
              transform: {
                input: (d) => d.length === 0 ? "" : d[0],
                output: (d) => d ? [d] : []
              }
            },
            {
              name: "content",
              type: "richText",
              label: e("common:common.description"),
              required: !0,
              layout: { className: "col-span-12" }
            }
          ],
          layout: { className: "col-span-12" }
        },
        {
          name: "info.attributes.timeline",
          label: e("projects.timeline.title"),
          type: "advancedDynamicList",
          fields: [
            {
              name: "title",
              type: "select",
              label: e("common:common.title"),
              layout: { className: "col-span-12 md:col-span-6" },
              selectProps: {
                options: [],
                isClearable: !0,
                isCreatable: !0,
                formatCreateLabel: (d) => `Create "${d}"`
              }
            },
            {
              name: "description",
              type: "text",
              label: e("common:common.description"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.descriptionPlaceholder")
            }
          ],
          layout: { className: "col-span-12" }
        },
        {
          name: "files.images",
          label: e("projects.files.images"),
          type: "multiFile",
          required: !0,
          labelProps: { position: "top" },
          layout: { className: "col-span-12" }
        },
        {
          name: "files.links",
          label: e("projects.files.links"),
          type: "multiFile",
          required: !0,
          labelProps: { position: "top" },
          layout: { className: "col-span-12" },
          transform: {
            input: (d) => {
              if (d.length === 0) return {};
              const f = {};
              return d.forEach((h) => {
                if (h instanceof File) {
                  const p = h.name.substring(0, h.name.lastIndexOf(".")) || h.name;
                  f[p] = h;
                } else if (typeof h == "string") {
                  const p = h.split("/").pop() || "", m = p.substring(0, p.lastIndexOf(".")) || p;
                  f[m] = h;
                }
              }), f;
            },
            output: (d) => d ? Object.values(d) : []
          },
          fileUploadProps: {
            accept: "image/*,.pdf",
            maxSize: 5 * 1024 * 1024
            // 5MB
          }
        },
        {
          name: "info.urls",
          label: e("projects.urls.title"),
          type: "advancedDynamicList",
          fields: [
            {
              name: "link",
              type: "text",
              label: e("projects.urls.link"),
              required: !0,
              layout: { className: "col-span-12" }
            },
            {
              name: "thumbnail",
              type: "file",
              label: e("projects.urls.thumbnail"),
              layout: { className: "col-span-12" },
              fileUploadProps: {
                accept: "image/*",
                maxFiles: 1
              },
              transform: {
                input: (d) => d.length === 0 ? "" : d[0],
                output: (d) => d ? [d] : []
              }
            }
          ],
          layout: { className: "col-span-12" }
        }
      ]
    },
    {
      title: e("projects.location.title"),
      fields: [
        {
          name: "location.street_number",
          label: e("projects.location.streetNumber"),
          type: "text",
          labelProps: { position: "top" },
          layout: { className: "col-span-4" }
        },
        {
          name: "location.street_name",
          label: e("projects.location.streetName"),
          type: "text",
          labelProps: { position: "top" },
          layout: { className: "col-span-8" }
        },
        {
          name: "location.city",
          label: e("projects.location.city"),
          type: "text",
          labelProps: { position: "top" },
          layout: { className: "col-span-6" }
        },
        {
          name: "location.postal_code",
          label: e("projects.location.postalCode"),
          type: "text",
          labelProps: { position: "top" },
          layout: { className: "col-span-6" }
        },
        {
          name: "location.country",
          label: e("projects.location.country"),
          type: "text",
          labelProps: { position: "top" },
          layout: { className: "col-span-12" }
        },
        {
          name: "info.attributes.location.details",
          label: e("projects.location.details"),
          type: "richText",
          labelProps: { position: "top" },
          layout: { className: "col-span-12" }
        }
      ]
    }
  ], a = B.array(
    B.object({
      id: B.string(),
      title: B.object({
        label: B.string(),
        value: B.string()
      }),
      value: B.string(),
      operator: B.string().optional(),
      description: B.string().optional(),
      tooltip: B.string().optional()
    })
  ).optional(), s = {
    create: B.object({
      name: B.string().min(1),
      price: B.coerce.number().min(0),
      batches: B.coerce.number().min(1),
      info: B.object({
        description: B.string().min(1, e("common:common.validation.required")),
        features: B.string().min(1, e("common:common.validation.required")),
        strategy: B.string().min(1, e("common:common.validation.required")),
        news: B.array(
          B.object({
            title: B.string().min(1, e("common:common.validation.required")),
            description: B.string().min(1, e("common:common.validation.required")),
            date: B.string().min(1, e("common:common.validation.required")),
            image: B.union([B.string(), B.any()]).optional()
          })
        ).optional(),
        urls: B.array(
          B.object({
            link: B.string().min(1, e("common:common.validation.required")),
            thumbnail: B.union([B.string(), B.any()]).optional()
          })
        ).optional(),
        tags: B.array(B.string()).optional(),
        creators: B.array(B.string()).optional(),
        attributes: B.object({
          info: B.object({
            type: B.string().optional(),
            showProgressBar: B.boolean().optional().default(!1),
            reasons: B.array(
              B.object({
                title: B.object({
                  label: B.string(),
                  value: B.string()
                }),
                description: B.string().optional()
              })
            ).optional(),
            kpis: B.object({
              kpi_1: B.object({
                title: B.object({
                  label: B.string(),
                  value: B.string()
                }),
                description: B.string().optional(),
                value: B.coerce.number().min(0),
                operator: B.string().optional(),
                tooltip: B.string().optional()
              }).optional(),
              kpi_2: B.object({
                title: B.object({
                  label: B.string(),
                  value: B.string()
                }),
                description: B.string().optional(),
                value: B.coerce.number().min(0),
                operator: B.string().optional(),
                tooltip: B.string().optional()
              }).optional()
            }).optional()
          }).optional(),
          timeline: B.array(
            B.object({
              title: B.object({
                label: B.string(),
                value: B.string()
              }),
              description: B.string().optional()
            })
          ).optional(),
          news: B.array(
            B.object({
              title: B.string().min(1, e("common:common.validation.required")),
              content: B.string().min(1, e("common:common.validation.required")),
              date: B.string().min(1, e("common:common.validation.required")),
              imageUrl: B.union([B.string(), B.any()]).optional(),
              sourceUrl: B.string().optional()
            })
          ).optional(),
          finance: B.object({
            charges: a,
            revenues: a,
            results: a,
            investment: a,
            resale: a,
            yields: B.object({
              target_annual_yield: B.coerce.number().optional(),
              distributed_yield_per_year: B.coerce.number().optional()
            }).optional()
          }).optional(),
          location: B.object({
            details: B.string().optional()
          }).optional()
        }).optional()
      }),
      location: B.object({
        street_number: B.string().optional(),
        street_name: B.string().optional(),
        postal_code: B.string().optional(),
        city: B.string().optional(),
        country: B.string().optional()
      }).optional(),
      files: B.object({
        links: B.record(B.union([B.string(), B.any()])).refine(
          (d) => Object.keys(d || {}).length > 0,
          e("common:common.validation.required")
        ).transform((d) => d || {}),
        images: B.array(B.union([B.string(), B.any()])).min(1, e("common:common.validation.min", { min: 1 })).transform((d) => d || [])
      }).refine(
        (d) => !0,
        { message: "Files validation failed" }
      ),
      payment: B.enum(["bridgeapi", "mangopay", "dev"]).default(H0)
    }).transform((d) => ({
      ...d,
      info: {
        ...d.info,
        tags: d.info.tags || [],
        creators: d.info.creators || [],
        attributes: d.info.attributes || {}
      },
      files: {
        links: d.files.links || {},
        images: d.files.images || []
      },
      payment: d.payment || H0
    })),
    update: B.object({
      name: B.string().min(1, e("test")),
      price: B.coerce.number().min(0, e("common:common.validation.min", { min: 0 })).transform((d) => Number(d)),
      batches: B.coerce.number().min(1, e("common:common.validation.min", { min: 1 })).transform((d) => Number(d)),
      info: B.object({
        description: B.string().min(1, e("common:common.validation.required")),
        attributes: B.object({}).passthrough(),
        features: B.string().min(1, e("common:common.validation.required")),
        strategy: B.string().min(1, e("common:common.validation.required")),
        news: B.array(
          B.object({
            title: B.string().min(1, e("common:common.validation.required")),
            description: B.string().min(1, e("common:common.validation.required")),
            date: B.string().min(1, e("common:common.validation.required")),
            image: B.union([B.string(), B.any()]).optional()
          })
        ).optional(),
        urls: B.array(
          B.object({
            link: B.string().min(1, e("common:common.validation.required")),
            thumbnail: B.union([B.string(), B.any()]).optional()
          })
        ).optional(),
        tags: B.array(B.string()),
        creators: B.array(B.string())
      }),
      location: B.object({
        street_number: B.string().optional(),
        street_name: B.string().optional(),
        postal_code: B.string().optional(),
        city: B.string().optional(),
        country: B.string().optional(),
        details: B.string().optional(),
        latitude: B.coerce.number().optional(),
        longitude: B.coerce.number().optional()
      }).optional(),
      files: B.object({
        links: B.record(B.union([B.string(), B.any()])).transform((d) => d || {}),
        images: B.array(B.union([B.string(), B.any()])).transform((d) => d || [])
      }).transform((d) => ({
        links: d.links,
        images: d.images
      })),
      blockchain: B.object({
        contract: B.string(),
        token_id: B.coerce.number()
      }).optional(),
      payment: B.enum(["bridgeapi", "mangopay", "dev"]).optional().default(H0)
    }).partial().transform((d) => ({
      ...d,
      price: d.price ? Number(d.price) : void 0,
      batches: d.batches ? Number(d.batches) : void 0,
      payment: d.payment || H0
    }))
  }, i = Tn(
    () => ({
      getAll: async (d) => {
        const { offset: f, limit: h } = d, p = await t.projectsApi.projectsPage({
          offset: f,
          limit: h,
          stats: !0
        });
        return {
          data: p.results,
          pagination: {
            total: p.meta.total,
            offset: p.meta.offset,
            limit: p.meta.limit,
            currentPage: p.meta.current_page,
            totalPages: p.meta.total_pages
          },
          links: p.links
        };
      },
      getOne: async (d) => await t.projectsApi.project({ id: d }),
      create: async (d) => {
        try {
          const f = await o(0, d), h = {
            ...f,
            info: {
              ...f.info,
              tags: [],
              creators: []
            }
          }, p = await t.projectsApi.createProject({
            project: h
          });
          return await t.projectsApi.project({
            id: p
          });
        } catch (f) {
          throw console.error("Error creating project:", f), f;
        }
      },
      update: async (d, f) => {
        try {
          const h = await t.projectsApi.project({ id: d }), p = await o(d, f);
          console.log("--- Payload for updateProject ---");
          const m = {
            ...p,
            info: {
              ...h.info,
              ...p.info
            }
          };
          return console.log(JSON.stringify(m, null, 2)), console.log("--- End of Payload ---"), await t.projectsApi.updateProject({
            id: d,
            project: m
          }), await t.projectsApi.project({ id: d });
        } catch (h) {
          throw console.error("Error updating project:", h), h;
        }
      },
      delete: (d) => t.projectsApi.deleteProject({ id: d })
    }),
    [t, r]
  ), o = async (d, f) => {
    var m, g, y, x, w, _, S, C, E, O, k, A, P, D, N, z, G, Y, te, ae, ne, ue, q, U, Q, L, j, K, J, re, le, pe, me, Oe;
    const h = { ...f };
    if (f.files) {
      const ee = await l(d, f.files);
      h.files = ee;
    }
    const p = (y = (g = (m = f.info) == null ? void 0 : m.attributes) == null ? void 0 : g.finance) == null ? void 0 : y.image;
    if (p && typeof p == "object" && "name" in p)
      try {
        const [ee] = await r(d, [
          p
        ]), Ee = `${W0()}${ee.url}`;
        h.info = {
          ...h.info,
          description: ((x = h.info) == null ? void 0 : x.description) || "",
          features: ((w = h.info) == null ? void 0 : w.features) || "",
          strategy: ((_ = h.info) == null ? void 0 : _.strategy) || "",
          tags: ((S = h.info) == null ? void 0 : S.tags) || [],
          creators: ((C = h.info) == null ? void 0 : C.creators) || [],
          attributes: {
            ...(E = h.info) == null ? void 0 : E.attributes,
            finance: {
              ...(k = (O = h.info) == null ? void 0 : O.attributes) == null ? void 0 : k.finance,
              image: Ee
            }
          }
        };
      } catch (ee) {
        console.error("Error uploading finance image:", ee);
      }
    else p === "" && (h.info = {
      ...h.info,
      description: ((A = h.info) == null ? void 0 : A.description) || "",
      features: ((P = h.info) == null ? void 0 : P.features) || "",
      strategy: ((D = h.info) == null ? void 0 : D.strategy) || "",
      tags: ((N = h.info) == null ? void 0 : N.tags) || [],
      creators: ((z = h.info) == null ? void 0 : z.creators) || [],
      attributes: {
        ...(G = h.info) == null ? void 0 : G.attributes,
        finance: {
          ...(te = (Y = h.info) == null ? void 0 : Y.attributes) == null ? void 0 : te.finance,
          image: ""
        }
      }
    });
    if ((ne = (ae = f.info) == null ? void 0 : ae.attributes) != null && ne.news) {
      const ee = await Promise.all(
        f.info.attributes.news.map(async (he) => {
          if (!he.imageUrl || typeof he.imageUrl == "string")
            return he;
          try {
            const [Ee] = await r(d, [
              he.imageUrl
            ]), Pe = `${W0()}${Ee.url}`;
            return {
              ...he,
              imageUrl: Pe
            };
          } catch (Ee) {
            return console.error("Error uploading news image:", Ee), {
              ...he,
              imageUrl: ""
            };
          }
        })
      );
      h.info = {
        ...h.info,
        description: ((ue = h.info) == null ? void 0 : ue.description) || "",
        features: ((q = h.info) == null ? void 0 : q.features) || "",
        strategy: ((U = h.info) == null ? void 0 : U.strategy) || "",
        tags: ((Q = h.info) == null ? void 0 : Q.tags) || [],
        creators: ((L = h.info) == null ? void 0 : L.creators) || [],
        attributes: {
          ...(j = h.info) == null ? void 0 : j.attributes,
          news: ee
        }
      };
    }
    if ((K = f.info) != null && K.urls) {
      const ee = await Promise.all(
        f.info.urls.map(async (he) => {
          let Ee = he.thumbnail;
          if (Ee && typeof Ee == "object")
            try {
              const Pe = Ee, [rt] = await r(d, [
                Pe
              ]);
              Ee = rt.url;
            } catch (Pe) {
              console.error("Error uploading thumbnail:", Pe), Ee = "";
            }
          else Ee == null && (Ee = "");
          const we = { ...he };
          return Ee === "" ? delete we.thumbnail : we.thumbnail = Ee, we;
        })
      );
      h.info = {
        ...h.info,
        description: ((J = h.info) == null ? void 0 : J.description) || "",
        features: ((re = h.info) == null ? void 0 : re.features) || "",
        strategy: ((le = h.info) == null ? void 0 : le.strategy) || "",
        tags: ((pe = h.info) == null ? void 0 : pe.tags) || [],
        creators: ((me = h.info) == null ? void 0 : me.creators) || [],
        urls: ee,
        attributes: ((Oe = h.info) == null ? void 0 : Oe.attributes) || {}
      };
    }
    return h;
  }, l = async (d, f) => {
    const h = { links: {}, images: [] };
    if (f.links) {
      const p = Object.entries(f.links).map(
        async ([g, y]) => {
          if (typeof y == "string")
            return [g, y];
          if (y && typeof y == "object") {
            const x = y, [w] = await r(d, [
              x
            ]);
            W0();
            const _ = `${w.url}`;
            return [x.name.substring(0, x.name.lastIndexOf(".")) || x.name, _];
          }
          return [g, ""];
        }
      ), m = await Promise.all(p);
      h.links = Object.fromEntries(m);
    }
    if (f.images && Array.isArray(f.images)) {
      const p = f.images.map(async (m) => {
        if (typeof m == "string")
          return m;
        if (m && typeof m == "object") {
          const g = m, [y] = await r(d, [
            g
          ]);
          return W0(), `${y.url}`;
        }
        return "";
      });
      h.images = await Promise.all(p);
    }
    return h;
  }, c = {
    extractItems: (d) => Array.isArray(d) ? [...d].sort((h, p) => {
      var y, x, w, _;
      const m = Mb({
        ...h.campaign,
        info: ((y = h.campaign) == null ? void 0 : y.info) || { start_date: null, duration: null },
        status: ((x = h.campaign) == null ? void 0 : x.status) || null
      }), g = Mb({
        ...p.campaign,
        info: ((w = p.campaign) == null ? void 0 : w.info) || { start_date: null, duration: null },
        status: ((_ = p.campaign) == null ? void 0 : _.status) || null
      });
      return m - g;
    }) : [],
    extractTotal: (d) => Array.isArray(d) ? d.length : 0
  };
  return {
    entityConfig: {
      name: "projects",
      formLayout: "single-page",
      columns: [
        {
          id: "id",
          label: e("projects.id"),
          sortable: !0,
          render: (d) => d.id
        },
        {
          id: "public",
          label: e("projects.status.title"),
          sortable: !0,
          render: (d) => /* @__PURE__ */ v.jsx(
            an,
            {
              variant: "solid",
              color: d.public ? "success" : "info",
              size: "sm",
              children: d.public ? e("projects.status.published") : e("projects.status.draft")
            }
          ),
          width: "120px"
        },
        {
          id: "name",
          label: e("projects.name"),
          sortable: !0,
          render: (d) => d.name
        },
        {
          id: "investment",
          label: e("projects.investmentProgress.title"),
          sortable: !0,
          render: (d) => {
            var h, p, m;
            const { extraAmount: f } = e2(d.info);
            return /* @__PURE__ */ v.jsx("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ v.jsx(
              Zk,
              {
                batches: d.batches,
                frozen: ((h = d.project_stats) == null ? void 0 : h.frozen) || 0,
                availableBatches: ((p = d.project_stats) == null ? void 0 : p.campaigns) === 0 ? d.batches : ((m = d.project_stats) == null ? void 0 : m.available) || 0,
                extraAmount: f,
                batchPrice: d.price || 0,
                progressBarProps: {
                  size: "md",
                  color: "secondary",
                  variant: "gradient",
                  showLabel: !0,
                  labelPosition: "end"
                }
              }
            ) });
          }
        }
      ],
      formSections: n,
      validationSchema: {
        create: s.create,
        update: s.update
      },
      tableConfig: {
        defaultSortColumn: "id",
        defaultSortDirection: _n.ASC,
        searchFields: ["name", "id"]
      },
      statusConfig: {
        title: e("projects.createStatus"),
        steps: [
          {
            label: e("projects.status.info.title"),
            status: "completed",
            description: e("projects.status.info.description")
          },
          {
            label: e("projects.status.finance.title"),
            status: "completed",
            description: e("projects.status.finance.description")
          },
          {
            label: e("projects.status.presentation.title"),
            status: "completed",
            description: e("projects.status.presentation.description")
          },
          {
            label: e("projects.status.location.title"),
            status: "completed",
            description: e("projects.status.location.description")
          }
        ]
      },
      viewConfig: {
        useCustomView: !0,
        getViewPath: (d) => `/projects/${d.id}/view`,
        getEditPath: (d) => `/projects/${d.id}/edit`
      },
      draftConfig: {
        enabled: !0,
        isDraftField: "public",
        isDraftValue: !1,
        publishedValue: !0,
        isDraftPredicate: (d) => !d.public,
        transformToDraft: (d) => ({
          ...d,
          public: !1
        }),
        transformToPublished: (d) => ({
          ...d,
          public: !0
        }),
        buttonConfig: {
          label: e("projects.saveDraft"),
          icon: "save",
          color: "secondary",
          showOnCreate: !0,
          showOnUpdate: !0
        }
      },
      formConfig: {
        showCancel: !0
      }
    },
    crudMethods: i,
    responseExtractor: c
  };
};
Th("projects", TFe);
const CFe = {
  EUR: {
    locale: "fr-FR",
    symbolPosition: "after",
    thousandsSeparator: " ",
    decimalSeparator: ","
  },
  CHF: {
    thousandsSeparator: "'"
  }
};
function hs(e, t) {
  var o;
  const n = { ...CFe[t.currency] || {}, ...t }, s = ((o = new Intl.NumberFormat(n.locale, {
    style: "currency",
    currency: n.currency
  }).formatToParts(0).find((l) => l.type === "currency")) == null ? void 0 : o.value) || "", i = Ao(e, n);
  return n.symbolPosition === "after" ? `${i}${s}` : `${s}${i}`;
}
const dL = (e) => {
  let t;
  const r = /* @__PURE__ */ new Set(), n = (c, u) => {
    const d = typeof c == "function" ? c(t) : c;
    if (!Object.is(d, t)) {
      const f = t;
      t = u ?? (typeof d != "object" || d === null) ? d : Object.assign({}, t, d), r.forEach((h) => h(t, f));
    }
  }, a = () => t, o = { setState: n, getState: a, getInitialState: () => l, subscribe: (c) => (r.add(c), () => r.delete(c)) }, l = t = e(n, a, o);
  return o;
}, kFe = (e) => e ? dL(e) : dL, OFe = (e) => e;
function AFe(e, t = OFe) {
  const r = M.useSyncExternalStore(
    e.subscribe,
    () => t(e.getState()),
    () => t(e.getInitialState())
  );
  return M.useDebugValue(r), r;
}
const fL = (e) => {
  const t = kFe(e), r = (n) => AFe(t, n);
  return Object.assign(r, t), r;
}, s$ = (e) => e ? fL(e) : fL, Lb = s$((e) => ({
  isOpen: !1,
  step: "form",
  order: null,
  projectName: "",
  isContinuation: !1,
  minBatches: void 0,
  maxBatches: void 0,
  onConfirm: void 0,
  pricePerBatch: void 0,
  campaignId: void 0,
  setOrderModalData: (t) => e({
    isOpen: !0,
    step: "form",
    order: t.order,
    campaignId: t.campaignId,
    projectName: t.projectName,
    minBatches: t.minBatches,
    maxBatches: t.maxBatches,
    pricePerBatch: t.pricePerBatch,
    onConfirm: t.onConfirm
  }),
  openModal: (t) => e({
    isOpen: !0,
    step: t.step,
    order: t.order,
    projectName: t.projectName,
    isContinuation: t.isContinuation,
    minBatches: t.minBatches,
    maxBatches: t.maxBatches,
    pricePerBatch: t.pricePerBatch,
    onConfirm: t.onConfirm
  }),
  closeModal: () => e({
    isOpen: !1,
    step: "form",
    order: null,
    projectName: "",
    isContinuation: !1,
    minBatches: void 0,
    maxBatches: void 0,
    onConfirm: void 0,
    pricePerBatch: void 0,
    campaignId: void 0
  }),
  setStep: (t) => e({ step: t })
})), PFe = {
  payout: () => Promise.resolve().then(() => aJe).then(
    (e) => ({ component: e.PayoutModal })
  ),
  orderConfirmation: () => Promise.resolve().then(() => TXe).then((e) => ({ component: e.OrderConfirmationModal })),
  userListAddUsers: () => import("./user-list-add-users-modal.component-JmBxxOXY.mjs").then((e) => ({ component: e.UserListAddUsersModal }))
}, i$ = Vl({
  showModal: () => {
  },
  hideModal: () => {
  },
  modalProps: {},
  activeModal: null
}), Xg = () => {
  const e = vh(i$);
  if (!e)
    throw new Error("useModal must be used within a ModalProvider");
  return e;
}, Net = ({
  children: e
}) => {
  const [t, r] = Me({}), [n, a] = Me(null), s = (h, p) => {
    a(h), r(p || {});
  }, i = () => {
    a(null), r({});
  }, o = async () => {
    if (!n) return null;
    const h = PFe[n];
    if (!h) return null;
    try {
      const { component: p } = await h();
      return /* @__PURE__ */ v.jsx(p, { isOpen: !0, onClose: i, ...t });
    } catch (p) {
      return console.error("Failed to load modal:", p), null;
    }
  }, l = {
    showModal: s,
    hideModal: i,
    modalProps: t,
    activeModal: n
  }, [c, u] = Me(!1), [d, f] = Me(null);
  return wt(() => {
    if (!n) {
      f(null);
      return;
    }
    u(!0), o().then(f).finally(() => u(!1));
  }, [n, t]), /* @__PURE__ */ v.jsxs(i$.Provider, { value: l, children: [
    e,
    c ? /* @__PURE__ */ v.jsx(la, {}) : d
  ] });
}, RFe = () => {
  const { t: e } = _t(["orders"]), t = sn(), r = async (m) => {
    try {
      return await t.ordersApi.order({
        id: m,
        refresh: !0
      });
    } catch (g) {
      return console.error("Failed to check order status:", g), null;
    }
  }, n = (m) => m.status === "rejected" || m.payment && "rejected" in m.payment ? null : m.signature && "pending" in m.signature ? { step: "signature", url: m.signature.pending } : m.payment && "pending" in m.payment ? { step: "payment", url: m.payment.pending } : null, a = (m) => m.signature && "valid" in m.signature && m.payment && "valid" in m.payment, s = (m) => m.signature && "valid" in m.signature && m.payment && "funded" in m.payment && m.status !== "executed", i = Tn(
    () => ({
      getAll: async (m) => {
        const g = await t.usersApi.userOrdersPage({
          offset: m.offset,
          limit: m.limit
        });
        return {
          data: g.results || [],
          pagination: {
            total: g.meta.total
          }
        };
      }
    }),
    [t]
  ), o = {
    extractItems: (m) => m,
    extractTotal: (m) => m.length
  }, { openModal: l } = Lb(), { showModal: c } = Xg(), [u, d] = Me(!1), f = async (m, g) => {
    try {
      d(!0), await g();
      const y = await i.getAll({
        offset: 0,
        limit: 10
      });
      if (o)
        return {
          data: o.extractItems(y.data),
          pagination: {
            total: y.pagination.total
          }
        };
    } catch (y) {
      console.error("Failed to perform order action:", y);
    } finally {
      d(!1);
    }
  }, h = async (m) => {
    const g = await r(m.id);
    if (!g) return;
    const y = n(g);
    ((y == null ? void 0 : y.step) === "signature" || (y == null ? void 0 : y.step) === "payment") && (l({
      step: y.step,
      order: g,
      projectName: m.campaign.project.name,
      isContinuation: !0
      // Don't set min/max batches since this is a continuation
    }), c("orderConfirmation"));
  };
  return {
    entityConfig: {
      name: "orders-user",
      formLayout: "single-page",
      columns: [
        {
          id: "id",
          label: e("common:common.id"),
          sortable: !0,
          render: (m) => m.id
        },
        {
          id: "project",
          label: e("orders.projectName"),
          sortable: !0,
          render: (m) => {
            var g;
            return /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-3", children: [
              /* @__PURE__ */ v.jsx(
                fi,
                {
                  src: m.campaign.project.files.images[0] || "/placeholder-project.jpg",
                  alt: m.campaign.project.name,
                  className: "min-w-10 min-h-10 w-10 h-10 max-w-10 max-h-10 object-cover rounded-md"
                }
              ),
              /* @__PURE__ */ v.jsxs("div", { children: [
                /* @__PURE__ */ v.jsx("div", { className: "font-medium", children: m.campaign.project.name }),
                /* @__PURE__ */ v.jsx("div", { className: "text-sm text-gray-500", children: (g = m.campaign.project.location) == null ? void 0 : g.city })
              ] })
            ] });
          }
        },
        {
          id: "campaign.info.batches",
          label: e("orders.campaign.batches"),
          sortable: !0,
          render: (m) => m.campaign.info.batches
        },
        {
          id: "quantity",
          label: e("orders.quantity"),
          sortable: !0,
          render: (m) => {
            var g, y, x, w;
            return /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ v.jsx("div", { className: "font-medium", children: m.quantity }),
              /* @__PURE__ */ v.jsx(an, { color: "secondary", size: "xs", children: /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-1 italic", children: [
                /* @__PURE__ */ v.jsxs("div", { className: "text-xxs", children: [
                  (w = (x = (y = (g = m.campaign.project.info.attributes) == null ? void 0 : g.info) == null ? void 0 : y.kpis) == null ? void 0 : x.kpi_1) == null ? void 0 : w.value,
                  "%"
                ] }),
                /* @__PURE__ */ v.jsx("span", { className: "lowercase", children: e("orders.yield") })
              ] }) })
            ] });
          }
        },
        {
          id: "batchValue",
          label: e("orders.batchValue"),
          sortable: !0,
          render: (m) => hs(m.campaign.project.price, {
            currency: "EUR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            preserveDecimals: !0
          })
        },
        {
          id: "status",
          label: e("orders.status"),
          sortable: !0,
          render: (m) => /* @__PURE__ */ v.jsx(
            an,
            {
              variant: "solid",
              color: Pw(Rc(m.payment)),
              size: "sm",
              children: e(
                `orders.statuses.${m.status === "executed" ? "executed" : Rc(m.payment)}`
              )
            }
          )
        },
        {
          id: "signature",
          label: e("orders.signature"),
          sortable: !0,
          render: (m) => /* @__PURE__ */ v.jsx(
            an,
            {
              variant: "solid",
              color: m.signature && "valid" in m.signature ? "success" : "danger",
              size: "sm",
              children: e(
                `orders.${m.signature && "valid" in m.signature ? "yes" : "no"}`
              )
            }
          )
        },
        {
          id: "payment",
          label: e("orders.payment"),
          sortable: !0,
          render: (m) => /* @__PURE__ */ v.jsx(
            an,
            {
              variant: "solid",
              color: m.payment && ("valid" in m.payment || "funded" in m.payment) ? "success" : "danger",
              size: "sm",
              children: e(
                `orders.${m.payment && ("valid" in m.payment || "funded" in m.payment) ? "yes" : "no"}`
              )
            }
          )
        },
        {
          id: "tsp",
          label: e("orders.createdAt"),
          sortable: !0,
          render: (m) => new Date(m.tsp).toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          })
        },
        {
          id: "documents",
          label: e("orders.documents"),
          sortable: !1,
          render: (m) => !m.signature || !("valid" in m.signature) || !m.signature.valid.length ? null : /* @__PURE__ */ v.jsx("div", { className: "flex flex-wrap gap-2 max-w-[300px]", children: m.signature.valid.map((g, y) => /* @__PURE__ */ v.jsx(
            qe,
            {
              variant: "outline",
              color: "gray",
              size: "xs",
              onClick: (x) => {
                x.stopPropagation(), window.open(g, "_blank");
              },
              children: /* @__PURE__ */ v.jsx("div", { className: "flex flex-col items-center justify-center space-y-1", children: /* @__PURE__ */ v.jsx(dt, { name: "file", size: "sm" }) })
            },
            g
          )) })
        }
      ],
      formSections: [],
      tableConfig: {
        defaultSortColumn: "tsp",
        defaultSortDirection: _n.DESC,
        searchFields: ["campaign.project.name", "payment"],
        actions: (m) => /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2", children: [
          n(m) && /* @__PURE__ */ v.jsxs(
            qe,
            {
              variant: "solid",
              color: "primary",
              size: "xs",
              onClick: async (g) => {
                g.stopPropagation(), await f(
                  m.id,
                  () => h(m)
                );
              },
              children: [
                /* @__PURE__ */ v.jsx(
                  dt,
                  {
                    name: u ? "spinner" : "arrow-right",
                    size: "sm",
                    className: u ? "animate-spin mr-1" : "mr-1"
                  }
                ),
                e("orders.actions.continue")
              ]
            }
          ),
          a(m) && /* @__PURE__ */ v.jsxs(
            qe,
            {
              variant: "solid",
              color: "gray",
              size: "xs",
              onClick: async (g) => {
                g.stopPropagation(), await f(m.id, async () => {
                  await r(m.id);
                });
              },
              children: [
                /* @__PURE__ */ v.jsx(
                  dt,
                  {
                    name: u ? "spinner" : "refresh",
                    size: "sm",
                    className: u ? "animate-spin mr-1" : "mr-1"
                  }
                ),
                e("orders.actions.refresh")
              ]
            }
          ),
          s(m) && /* @__PURE__ */ v.jsxs(
            qe,
            {
              variant: "solid",
              color: "info",
              size: "xs",
              onClick: async (g) => {
                g.stopPropagation(), await f(m.id, async () => {
                  const y = await r(m.id);
                  y && s(y) && await t.ordersApi.executeOrder({ id: m.id });
                });
              },
              children: [
                /* @__PURE__ */ v.jsx(
                  dt,
                  {
                    name: u ? "spinner" : "arrow-right",
                    size: "sm",
                    className: u ? "animate-spin mr-1" : "mr-1"
                  }
                ),
                e("orders.actions.execute")
              ]
            }
          )
        ] })
      },
      validationSchema: {
        create: B.never(),
        update: B.never()
      }
    },
    crudMethods: i,
    responseExtractor: o
  };
};
Th("orders-user", RFe);
const IFe = () => {
  const { t: e } = _t(["orders"]), t = sn(), r = async (d) => {
    try {
      return await t.ordersApi.order({
        id: d,
        refresh: !0
      });
    } catch (f) {
      return console.error("Failed to check order status:", f), null;
    }
  }, n = (d) => d.signature && "valid" in d.signature && d.payment && "valid" in d.payment, a = (d) => d.signature && "valid" in d.signature && d.payment && "funded" in d.payment && d.status !== "executed", s = Tn(
    () => ({
      getAll: async (d) => {
        const f = await t.ordersApi.ordersPage({
          offset: d.offset,
          limit: d.limit,
          status: [
            Uv.Pending,
            Uv.Valid,
            Uv.Executed,
            Uv.Refunded
          ]
        });
        return {
          data: f.results || [],
          pagination: {
            total: f.meta.total
          }
        };
      }
    }),
    [t]
  ), i = {
    extractItems: (d) => d,
    extractTotal: (d) => d.length
  }, [o, l] = Me(!1), c = async (d, f) => {
    try {
      l(!0), await f();
      const h = await s.getAll({
        offset: 0,
        limit: 10
      });
      if (i)
        return {
          data: i.extractItems(h.data),
          pagination: {
            total: h.pagination.total
          }
        };
    } catch (h) {
      console.error("Failed to perform order action:", h);
    } finally {
      l(!1);
    }
  };
  return {
    entityConfig: {
      name: "orders",
      formLayout: "single-page",
      columns: [
        {
          id: "id",
          label: e("common:common.id"),
          sortable: !0,
          render: (d) => d.id
        },
        {
          id: "user",
          label: e("orders.user"),
          sortable: !0,
          render: (d) => {
            var f;
            return ((f = d.user) == null ? void 0 : f.email) || "";
          }
        },
        {
          id: "project",
          label: e("orders.projectName"),
          sortable: !0,
          render: (d) => {
            var f;
            return /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-3", children: [
              /* @__PURE__ */ v.jsx(
                fi,
                {
                  src: d.campaign.project.files.images[0] || "/placeholder-project.jpg",
                  alt: d.campaign.project.name,
                  className: "min-w-10 min-h-10 w-10 h-10 max-w-10 max-h-10 object-cover rounded-md"
                }
              ),
              /* @__PURE__ */ v.jsxs("div", { children: [
                /* @__PURE__ */ v.jsx("div", { className: "font-medium", children: d.campaign.project.name }),
                /* @__PURE__ */ v.jsx("div", { className: "text-sm text-gray-500", children: (f = d.campaign.project.location) == null ? void 0 : f.city })
              ] })
            ] });
          }
        },
        {
          id: "campaign.info.batches",
          label: e("orders.campaign.batches"),
          sortable: !0,
          render: (d) => d.campaign.info.batches
        },
        {
          id: "quantity",
          label: e("orders.quantity"),
          sortable: !0,
          render: (d) => {
            var f, h, p, m;
            return /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ v.jsx("div", { className: "font-medium", children: d.quantity }),
              /* @__PURE__ */ v.jsx(an, { color: "secondary", size: "xs", children: /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-1 italic", children: [
                /* @__PURE__ */ v.jsxs("div", { className: "text-xxs", children: [
                  (m = (p = (h = (f = d.campaign.project.info.attributes) == null ? void 0 : f.info) == null ? void 0 : h.kpis) == null ? void 0 : p.kpi_1) == null ? void 0 : m.value,
                  "%"
                ] }),
                /* @__PURE__ */ v.jsx("span", { className: "lowercase", children: e("orders.yield") })
              ] }) })
            ] });
          }
        },
        {
          id: "batchValue",
          label: e("orders.batchValue"),
          sortable: !0,
          render: (d) => hs(d.campaign.project.price, {
            currency: "EUR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            preserveDecimals: !0
          })
        },
        {
          id: "status",
          label: e("orders.status"),
          sortable: !0,
          render: (d) => /* @__PURE__ */ v.jsx(
            an,
            {
              variant: "solid",
              color: Pw(Rc(d.payment)),
              size: "sm",
              children: e(
                `orders.statuses.${d.status === "executed" ? "executed" : Rc(d.payment)}`
              )
            }
          )
        },
        {
          id: "signature",
          label: e("orders.signature"),
          sortable: !0,
          render: (d) => /* @__PURE__ */ v.jsx(
            an,
            {
              variant: "solid",
              color: d.signature && "valid" in d.signature ? "success" : "danger",
              size: "sm",
              children: e(
                `orders.${d.signature && "valid" in d.signature ? "yes" : "no"}`
              )
            }
          )
        },
        {
          id: "payment",
          label: e("orders.payment"),
          sortable: !0,
          render: (d) => /* @__PURE__ */ v.jsx(
            an,
            {
              variant: "solid",
              color: d.payment && ("valid" in d.payment || "funded" in d.payment) ? "success" : "danger",
              size: "sm",
              children: e(
                `orders.${d.payment && ("valid" in d.payment || "funded" in d.payment) ? "yes" : "no"}`
              )
            }
          )
        },
        {
          id: "tsp",
          label: e("orders.createdAt"),
          sortable: !0,
          render: (d) => new Date(d.tsp).toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          })
        },
        {
          id: "documents",
          label: e("orders.documents"),
          sortable: !1,
          render: (d) => !d.signature || !("valid" in d.signature) || !d.signature.valid.length ? null : /* @__PURE__ */ v.jsx("div", { className: "flex flex-wrap gap-2 max-w-[300px]", children: d.signature.valid.map((f, h) => /* @__PURE__ */ v.jsx(
            qe,
            {
              variant: "outline",
              color: "gray",
              size: "xs",
              onClick: (p) => {
                p.stopPropagation(), window.open(f, "_blank");
              },
              children: /* @__PURE__ */ v.jsx("div", { className: "flex flex-col items-center justify-center space-y-1", children: /* @__PURE__ */ v.jsx(dt, { name: "file", size: "sm" }) })
            },
            f
          )) })
        }
      ],
      formSections: [],
      tableConfig: {
        defaultSortColumn: "tsp",
        defaultSortDirection: _n.DESC,
        searchFields: ["campaign.project.name", "payment"],
        actions: (d) => /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2", children: [
          n(d) && /* @__PURE__ */ v.jsxs(
            qe,
            {
              variant: "solid",
              color: "gray",
              size: "xs",
              onClick: async (f) => {
                f.stopPropagation(), await c(d.id, async () => {
                  await r(d.id);
                });
              },
              children: [
                /* @__PURE__ */ v.jsx(
                  dt,
                  {
                    name: o ? "spinner" : "refresh",
                    size: "sm",
                    className: o ? "animate-spin mr-1" : "mr-1"
                  }
                ),
                e("orders.actions.refresh")
              ]
            }
          ),
          a(d) && /* @__PURE__ */ v.jsxs(
            qe,
            {
              variant: "solid",
              color: "info",
              size: "xs",
              onClick: async (f) => {
                f.stopPropagation(), await c(d.id, async () => {
                  const h = await r(d.id);
                  h && a(h) && await t.ordersApi.executeOrder({ id: d.id });
                });
              },
              children: [
                /* @__PURE__ */ v.jsx(
                  dt,
                  {
                    name: o ? "spinner" : "arrow-right",
                    size: "sm",
                    className: o ? "animate-spin mr-1" : "mr-1"
                  }
                ),
                e("orders.actions.execute")
              ]
            }
          )
        ] })
      },
      validationSchema: {
        create: B.never().transform(() => {
          throw new Error("Create operation not supported for orders");
        }),
        update: B.never().transform(() => {
          throw new Error("Update operation not supported for orders");
        })
      }
    },
    crudMethods: s,
    responseExtractor: i
  };
};
Th("orders", IFe);
const lT = (e) => {
  var t;
  return e ? "info" in e ? ((t = e.info) == null ? void 0 : t.qualified) === !0 : e.qualified === !0 : !1;
}, Pp = (e, t) => {
  var r, n;
  if (!e) return t === !0;
  if ("info" in e) {
    if (((r = e.info) == null ? void 0 : r.qualified) === !0) return !0;
    if (((n = e.info) == null ? void 0 : n.qualified) === !1) return !1;
  } else {
    if (e.qualified === !0) return !0;
    if (e.qualified === !1) return !1;
  }
  return t === !0;
};
function hL(e) {
  if (!e) return { status: "not_started", color: "gray" };
  if (typeof e == "object" && "status" in e) {
    if (typeof e.status == "object" && "pending" in e.status)
      return { status: "pending", color: "warning" };
    if (typeof e.status == "string")
      switch (e.status) {
        case $a.Succeeded:
          return { status: "succeeded", color: "success" };
        case $a.Failed:
          return { status: "failed", color: "danger" };
        case $a.Canceled:
          return { status: "canceled", color: "danger" };
        default:
          return { status: "unknown", color: "gray" };
      }
  }
  if (typeof e == "string")
    switch (e) {
      case $a.Succeeded:
        return { status: "succeeded", color: "success" };
      case $a.Failed:
        return { status: "failed", color: "danger" };
      case $a.Canceled:
        return { status: "canceled", color: "danger" };
      default:
        return { status: "unknown", color: "gray" };
    }
  return typeof e == "object" && "pending" in e ? { status: "pending", color: "warning" } : { status: "unknown", color: "gray" };
}
function pL(e) {
  switch (e) {
    case zt.Uninitiated:
      return { status: zt.Uninitiated, color: "gray" };
    case zt.Initiated:
      return { status: zt.Initiated, color: "warning" };
    case zt.Kyced:
      return { status: zt.Kyced, color: "info" };
    case zt.Active:
      return { status: zt.Active, color: "success" };
    case zt.Blockchained:
      return { status: zt.Active, color: "success" };
    default:
      return { status: zt.Uninitiated, color: "gray" };
  }
}
function sS(e) {
  return e.kind === "individual";
}
function mL(e) {
  return e.kind === "company";
}
const o$ = () => {
  const { t: e } = _t(["users", "common"]), t = sn(), r = Da(), n = Tn(
    () => ({
      getAll: async (i) => {
        var c;
        const o = {
          offset: i.offset,
          limit: i.limit,
          sort: i.sort,
          dir: i.dir === _n.ASC ? eE.Asc : eE.Desc,
          search: i.search,
          stats: !0,
          ...i.filters && {
            status: (c = i.filters.match(/status=([^&]*)/)) == null ? void 0 : c[1]
          }
        }, l = await t.usersApi.usersPage(o);
        return {
          data: l.results,
          pagination: {
            total: l.meta.total,
            offset: l.meta.offset,
            limit: l.meta.limit,
            currentPage: l.meta.current_page,
            totalPages: l.meta.total_pages
          },
          links: l.links
        };
      },
      getOne: async (i) => {
        const o = await t.usersApi.user({ id: i });
        if (!o) throw new Error("User not found");
        const l = {
          id: o.id,
          kind: o.info.kind,
          email: o.auth.email,
          phone_number: o.info.phone_number,
          qualified: Pp(o),
          ...o.info.address && {
            "address.street_number": o.info.address.street_number,
            "address.street_name": o.info.address.street_name,
            "address.postal_code": o.info.address.postal_code,
            "address.city": o.info.address.city,
            "address.country": o.info.address.country
          },
          // Preserve the original structure for status section
          status: o.status,
          kyc: o.kyc,
          lists: o.lists,
          stats: o.stats,
          creation: o.creation,
          auth: o.auth,
          // Store the original data object for other components that need it
          _originalData: o
        };
        return sS(o.info) ? {
          ...l,
          first_name: o.info.first_name,
          last_name: o.info.last_name,
          birth_country: o.info.birth_country,
          birth_city: o.info.birth_city,
          birthday: o.info.birthday,
          nationality: o.info.nationality,
          residence_country: o.info.residence_country
        } : {
          ...l,
          company_name: o.info.company_name,
          siren: o.info.siren,
          country: o.info.country
        };
      },
      create: async (i) => {
        try {
          const o = { ...i }, l = ui();
          o.qualified === void 0 && (o.qualified = !1), o.qualified = Pp(o), o.kyc || (o.kyc = l.KYC_PROVIDER);
          const c = await t.usersApi.createUser({
            createUserRequest: o
          });
          return {
            ...c,
            auth: {
              id: c.auth,
              email: o.email
            }
          };
        } catch (o) {
          throw console.error("Error creating user:", o), o;
        }
      },
      update: async (i, o) => {
        try {
          const l = await t.usersApi.user({ id: i });
          if (!l)
            throw new Error("User not found");
          if (o.kyc && typeof o.kyc == "object") {
            const u = {
              info: {
                ...l.info,
                qualified: Pp(o, l.info.qualified)
              },
              creation: l.creation,
              auth: l.auth.id,
              kyc: o.kyc,
              payment: l.payment,
              status: o.status || l.status
            };
            return await t.usersApi.updateUser({
              id: i,
              userWithId: u
            }), t.usersApi.user({ id: i });
          }
          if (o.info) {
            const u = {
              info: {
                ...o.info,
                qualified: Pp(o, l.info.qualified)
              },
              creation: l.creation,
              auth: l.auth.id,
              kyc: l.kyc,
              payment: l.payment,
              status: l.status
            };
            return await t.usersApi.updateUser({
              id: i,
              userWithId: u
            }), t.usersApi.user({ id: i });
          }
          const c = {
            ...l,
            ...o,
            info: {
              ...l.info,
              qualified: Pp(o, l.info.qualified)
            },
            auth: l.auth.id
            // Ensure auth is the ID string
          };
          return await t.usersApi.updateUser({
            id: i,
            userWithId: c
          }), t.usersApi.user({ id: i });
        } catch (l) {
          throw console.error("Error updating user:", l), l;
        }
      },
      delete: async (i) => {
        await t.usersApi.deleteUser({ id: i });
      }
    }),
    [t]
  ), a = {
    extractItems: (i) => i,
    extractTotal: (i) => i.length
  };
  return {
    entityConfig: {
      name: "users",
      formLayout: "single-page",
      exportConfig: {
        filename: `users-export-${(/* @__PURE__ */ new Date()).toISOString().slice(0, 10)}.csv`,
        columns: [
          { key: "info.first_name", label: e("users.firstName") },
          { key: "info.last_name", label: e("users.lastName") },
          { key: "auth.email", label: e("users.email") },
          { key: "info.phone_number", label: e("users.phoneNumber") },
          {
            key: "stats.totalInvested",
            label: e("users.investedAmount"),
            accessor: (i) => i.stats ? Object.values(i.stats).reduce(
              (o, l) => o + l.invested,
              0
            ) : 0
          },
          {
            key: "creation",
            label: e("users.registrationDate"),
            accessor: (i) => eh(new Date(i.creation))
          },
          { key: "status", label: e("users.status.title") },
          { key: "kyc.status", label: e("users.kycStatus.title") },
          { key: "info.qualified", label: e("users.qualified") },
          {
            key: "lists",
            label: e("users.lists.userLists"),
            accessor: (i) => !Array.isArray(i.lists) || i.lists.length === 0 ? "" : i.lists.join(", ")
          }
        ]
      },
      columns: [
        { id: "id", label: e("users.id"), sortable: !0, sortField: "id" },
        {
          id: "name",
          label: e("users.name"),
          sortable: !0,
          accessor: (i) => sS(i.info) ? `${i.info.first_name} ${i.info.last_name}` : mL(i.info) ? i.info.company_name : "",
          sortAccessor: (i) => {
            var o;
            return sS(i.info) ? `${i.info.first_name} ${i.info.last_name}`.toLowerCase() : mL(i.info) ? (o = i.info.company_name) == null ? void 0 : o.toLowerCase() : "";
          },
          sortField: "name"
        },
        {
          id: "email",
          label: e("users.email"),
          accessor: (i) => typeof i.auth == "object" && "email" in i.auth ? i.auth.email : i.auth
        },
        {
          id: "creation",
          label: e("users.registrationDate"),
          sortable: !0,
          accessor: (i) => i.creation,
          render: (i) => eh(new Date(i.creation)),
          sortAccessor: (i) => new Date(i.creation).getTime(),
          sortField: "creation"
        },
        {
          id: "status",
          label: e("users.status.title"),
          sortable: !0,
          accessor: (i) => {
            var c;
            const o = pL(i.status), l = hL((c = i.kyc) == null ? void 0 : c.status);
            return `${o.status}_${l.status}`;
          },
          render: (i) => {
            var c;
            const o = pL(i.status), l = hL((c = i.kyc) == null ? void 0 : c.status);
            return /* @__PURE__ */ v.jsxs("div", { className: "space-x-2", children: [
              /* @__PURE__ */ v.jsx(an, { color: o.color, size: "sm", children: e(`users.status.${o.status}`) }),
              i.status === zt.Initiated && /* @__PURE__ */ v.jsx(an, { color: l.color, size: "sm", children: e(`users.kycStatus.${l.status}`) })
            ] });
          },
          sortField: "status"
        },
        {
          id: "totalInvested",
          label: e("users.investedAmount"),
          accessor: (i) => i.stats ? Object.values(i.stats).reduce(
            (o, l) => o + l.invested,
            0
          ) : 0,
          render: (i) => {
            if (!i.stats) return hs(0, { currency: "EUR" });
            const o = Object.values(i.stats).reduce(
              (l, c) => l + c.invested,
              0
            );
            return hs(o, {
              currency: "EUR",
              minimumFractionDigits: 0,
              maximumFractionDigits: 2
            });
          }
        },
        {
          id: "qualified",
          label: e("users.qualified"),
          sortable: !0,
          accessor: (i) => lT(i) ? "qualified" : "not-qualified",
          render: (i) => {
            const o = lT(i);
            return /* @__PURE__ */ v.jsx(
              an,
              {
                variant: "solid",
                color: o ? "info" : "gray",
                size: "sm",
                children: e(o ? "common:common.yes" : "common:common.no")
              }
            );
          }
        },
        {
          id: "lists",
          label: e("users.lists.userLists"),
          sortable: !1,
          render: (i) => !Array.isArray(i.lists) || i.lists.length === 0 ? /* @__PURE__ */ v.jsx("span", { className: "text-muted-foreground text-sm italic", children: e("users.lists.noLists") }) : /* @__PURE__ */ v.jsx("div", { className: "flex items-center gap-1 overflow-hidden", children: i.lists.map((o) => /* @__PURE__ */ v.jsx(an, { color: "info", size: "sm", children: o }, o)) })
        }
      ],
      formSections: [
        {
          title: e("common:common.generalInformation"),
          fields: [
            {
              name: "kind",
              label: e("users.kind"),
              type: "select",
              required: !0,
              layout: { className: "col-span-4" },
              placeholder: e("users.kind"),
              options: [
                { value: "individual", label: e("users.individual") },
                { value: "company", label: e("users.company") }
              ]
            },
            // Individual fields
            {
              name: "first_name",
              label: e("users.firstName"),
              type: "text",
              required: !0,
              layout: { className: "col-span-4" },
              showWhen: {
                field: "kind",
                value: "individual",
                operator: "eq"
              }
            },
            {
              name: "last_name",
              label: e("users.lastName"),
              type: "text",
              required: !0,
              layout: { className: "col-span-4" },
              showWhen: {
                field: "kind",
                value: "individual",
                operator: "eq"
              }
            },
            {
              name: "birth_country",
              label: e("users.birthCountry"),
              type: "text",
              required: !0,
              layout: { className: "col-span-4" },
              showWhen: {
                field: "kind",
                value: "individual",
                operator: "eq"
              }
            },
            {
              name: "birth_city",
              label: e("users.birthCity"),
              type: "text",
              required: !0,
              layout: { className: "col-span-4" },
              showWhen: {
                field: "kind",
                value: "individual",
                operator: "eq"
              }
            },
            {
              name: "birthday",
              label: e("users.birthday"),
              type: "date",
              required: !0,
              layout: { className: "col-span-4" },
              showWhen: {
                field: "kind",
                value: "individual",
                operator: "eq"
              }
            },
            {
              name: "nationality",
              label: e("users.nationality"),
              type: "text",
              required: !0,
              layout: { className: "col-span-4" },
              showWhen: {
                field: "kind",
                value: "individual",
                operator: "eq"
              }
            },
            {
              name: "residence_country",
              label: e("users.residenceCountry"),
              type: "text",
              required: !0,
              layout: { className: "col-span-4" },
              showWhen: {
                field: "kind",
                value: "individual",
                operator: "eq"
              }
            },
            // Company fields
            {
              name: "company_name",
              label: e("users.companyName"),
              type: "text",
              required: !0,
              layout: { className: "col-span-4" },
              showWhen: {
                field: "kind",
                value: "company",
                operator: "eq"
              }
            },
            {
              name: "siren",
              label: e("users.siren"),
              type: "text",
              required: !0,
              layout: { className: "col-span-4" },
              showWhen: {
                field: "kind",
                value: "company",
                operator: "eq"
              }
            },
            {
              name: "country",
              label: e("users.country"),
              type: "text",
              required: !0,
              layout: { className: "col-span-4" },
              showWhen: {
                field: "kind",
                value: "company",
                operator: "eq"
              }
            },
            // Common fields
            {
              name: "email",
              label: e("users.email"),
              type: "email",
              required: !0,
              layout: { className: "col-span-4" }
            },
            {
              name: "qualified",
              label: e("users.qualified"),
              description: e("users.qualifiedDescription"),
              type: "switch",
              layout: { className: "col-span-4" }
            },
            {
              name: "phone_number",
              label: e("users.phoneNumber"),
              type: "text",
              layout: { className: "col-span-4" }
            }
          ]
        },
        {
          title: e("users.address"),
          fields: [
            {
              name: "address.street_number",
              label: e("users.streetNumber"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: { className: "col-span-2" }
            },
            {
              name: "address.street_name",
              label: e("users.streetName"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: { className: "col-span-10" }
            },
            {
              name: "address.postal_code",
              label: e("users.postalCode"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: { className: "col-span-4" }
            },
            {
              name: "address.city",
              label: e("users.city"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: { className: "col-span-4" }
            },
            {
              name: "address.country",
              label: e("users.country"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: { className: "col-span-4" }
            }
          ]
        }
      ],
      validationSchema: {
        create: B.discriminatedUnion("kind", [
          B.object({
            kind: B.literal("individual"),
            first_name: B.string(),
            last_name: B.string(),
            birth_country: B.string(),
            birth_city: B.string(),
            birthday: B.string(),
            nationality: B.string(),
            residence_country: B.string(),
            email: B.string().email(),
            qualified: B.boolean().optional(),
            phone_number: B.string().optional(),
            address: B.object({
              street_number: B.string(),
              street_name: B.string(),
              postal_code: B.string(),
              city: B.string(),
              country: B.string()
            }).optional(),
            attributes: B.record(B.string(), B.any()).optional(),
            kyc: B.enum(["dataleon", "dev"]).optional()
          }),
          B.object({
            kind: B.literal("company"),
            company_name: B.string(),
            siren: B.string(),
            country: B.string(),
            email: B.string().email(),
            qualified: B.boolean().optional(),
            phone_number: B.string().optional(),
            address: B.object({
              street_number: B.string(),
              street_name: B.string(),
              postal_code: B.string(),
              city: B.string(),
              country: B.string()
            }).optional(),
            attributes: B.record(B.string(), B.any()).optional(),
            kyc: B.enum(["dataleon", "dev"]).optional()
          })
        ]),
        update: B.object({
          id: B.coerce.number().optional(),
          qualified: B.boolean().optional(),
          info: B.discriminatedUnion("kind", [
            B.object({
              kind: B.literal("individual"),
              first_name: B.string(),
              last_name: B.string(),
              birth_country: B.string(),
              birth_city: B.string(),
              birthday: B.string(),
              nationality: B.string(),
              residence_country: B.string(),
              qualified: B.boolean().optional(),
              phone_number: B.string().optional(),
              address: B.object({
                street_number: B.string(),
                street_name: B.string(),
                postal_code: B.string(),
                city: B.string(),
                country: B.string(),
                details: B.string().optional(),
                latitude: B.coerce.number().optional(),
                longitude: B.coerce.number().optional()
              }).optional(),
              attributes: B.record(B.string(), B.any()).optional()
            }),
            B.object({
              kind: B.literal("company"),
              company_name: B.string(),
              siren: B.string(),
              country: B.string(),
              qualified: B.boolean().optional(),
              phone_number: B.string().optional(),
              address: B.object({
                street_number: B.string(),
                street_name: B.string(),
                postal_code: B.string(),
                city: B.string(),
                country: B.string()
              }).optional(),
              attributes: B.record(B.string(), B.any()).optional()
            })
          ]).optional(),
          creation: B.string().optional(),
          auth: B.union([
            B.string(),
            B.object({
              id: B.string(),
              email: B.string()
            })
          ]).optional(),
          payment: B.object({
            info: B.discriminatedUnion("kind", [
              B.object({
                kind: B.literal("company"),
                company_name: B.string(),
                siren: B.string(),
                country: B.string(),
                phone_number: B.string().optional(),
                address: B.object({
                  street_number: B.string(),
                  street_name: B.string(),
                  postal_code: B.string(),
                  city: B.string(),
                  country: B.string()
                }).optional()
              }),
              B.object({
                kind: B.literal("private"),
                first_name: B.string(),
                last_name: B.string(),
                birth_country: B.string(),
                birth_city: B.string(),
                birthday: B.string(),
                nationality: B.string(),
                residence_country: B.string(),
                phone_number: B.string().optional(),
                address: B.object({
                  street_number: B.string(),
                  street_name: B.string(),
                  postal_code: B.string(),
                  city: B.string(),
                  country: B.string()
                }).optional()
              })
            ]),
            bank_id: B.coerce.number().optional(),
            payout: B.discriminatedUnion("kind", [
              B.object({
                kind: B.literal("company"),
                company_name: B.string(),
                siren: B.string(),
                country: B.string(),
                iban: B.string().optional(),
                name: B.string().optional(),
                bic: B.string().optional(),
                bank_name: B.string().optional(),
                email: B.string().optional(),
                virtual_iban_mode: B.enum(["ondemand", "auto"]).optional(),
                virtual_iban_id: B.string().optional()
              }),
              B.object({
                kind: B.literal("private"),
                first_name: B.string(),
                last_name: B.string(),
                iban: B.string().optional(),
                name: B.string().optional(),
                bic: B.string().optional(),
                bank_name: B.string().optional(),
                email: B.string().optional(),
                virtual_iban_mode: B.enum(["ondemand", "auto"]).optional(),
                virtual_iban_id: B.string().optional()
              })
            ]).optional()
          }).optional(),
          kyc: B.object({
            id: B.union([
              B.string(),
              B.object({
                dataleon: B.string()
              }),
              B.object({
                dev: B.string()
              })
            ]),
            status: B.union([
              B.enum(["succeeded", "canceled", "failed", "unknown"]),
              B.object({ pending: B.string() })
            ])
          }).optional(),
          blockchain: B.object({
            address: B.string(),
            whitelisted: B.boolean(),
            update: B.coerce.number()
          }).optional(),
          status: B.nativeEnum(zt).optional(),
          stats: B.record(
            B.string(),
            B.object({
              name: B.string(),
              campaigns: B.coerce.number(),
              orders: B.coerce.number(),
              invested: B.coerce.number()
            })
          ).optional(),
          pending_orders: B.boolean().optional()
        })
      },
      tableConfig: {
        defaultSortColumn: "id",
        defaultSortDirection: _n.DESC,
        searchFields: []
      },
      statusConfig: {
        title: e("users.status.title"),
        steps: [
          {
            label: e("users.status.initiated"),
            status: (i) => !i || i.status === zt.Uninitiated ? "in_progress" : "completed",
            description: e("users.status.initiatedDesc"),
            action: (i) => !i || i.status !== zt.Uninitiated ? null : /* @__PURE__ */ v.jsx(
              qe,
              {
                onClick: async () => {
                  try {
                    i.id && (await t.usersApi.linkEmail({ id: i.id }), r.success(e("users.actions.sendLinkSuccess")));
                  } catch {
                    r.error(e("users.actions.sendLinkError"));
                  }
                },
                variant: "outline",
                color: "warning",
                size: "xs",
                icon: "envelope",
                iconPosition: "left",
                children: e("users.actions.sendLink")
              }
            )
          },
          {
            label: e("users.status.kyc.title"),
            status: (i) => i ? i.status === zt.Kyced || i.status === zt.Active || i.status === zt.Blockchained ? "completed" : i.status === zt.Initiated ? "in_progress" : "pending" : "pending",
            description: (i) => i ? i.status === zt.Kyced || i.status === zt.Active || i.status === zt.Blockchained ? e("users.status.kyc.completed") : i.status === zt.Initiated ? e("users.status.kyc.pending") : e("users.status.kyc.not_started") : e("users.status.kyc.not_started"),
            action: (i) => {
              if (!i || i.status === zt.Kyced || i.status === zt.Active || i.status === zt.Blockchained)
                return null;
              const o = (l) => "dataleon" in l.id;
              return /* @__PURE__ */ v.jsx(
                qe,
                {
                  onClick: async () => {
                    try {
                      const l = {
                        info: i.info,
                        creation: i.creation,
                        auth: i.auth,
                        payment: i.payment,
                        kyc: o(i.kyc) ? {
                          id: {
                            dataleon: i.kyc.id.dataleon
                          },
                          status: $a.Succeeded
                        } : {
                          id: { dev: i.kyc.id.dev || "dev" },
                          status: $a.Succeeded
                        },
                        status: zt.Kyced
                      };
                      i.id && (await n.update(i.id, l), r.success(e("users.actions.forceKycSuccess")), window.location.reload());
                    } catch {
                      r.error(e("users.actions.forceKycError"));
                    }
                  },
                  variant: "outline",
                  color: "warning",
                  size: "xs",
                  icon: "warning",
                  iconPosition: "left",
                  children: e("users.status.kyc.force_kyc")
                }
              );
            }
          },
          {
            label: e("users.status.active"),
            status: (i) => i ? i.status === zt.Active || i.status === zt.Blockchained ? "completed" : i.status === zt.Kyced ? "in_progress" : "pending" : "pending",
            description: (i) => i ? i.status === zt.Active || i.status === zt.Blockchained ? e("users.status.activeDesc") : i.status === zt.Kyced ? e("users.status.kyc.completed") : e("users.status.kyc.not_started") : e("users.status.kyc.not_started")
          }
        ]
      },
      filters: {
        config: [
          {
            field: "status",
            label: e("users.status.title"),
            type: "select",
            options: Object.values(zt).map((i) => ({
              label: e(`users.status.${i}`),
              value: i
            }))
          }
        ],
        defaultFilters: {}
      }
    },
    crudMethods: n,
    responseExtractor: a
  };
};
Th("users", o$);
const DFe = () => {
  const { t: e } = _t(["users", "common"]), t = sn(), r = Da(), { showModal: n } = Xg(), a = o$(), s = Tn(
    () => ({
      getAll: async (l) => {
        const u = (await t.usersApi.userLists()).map((m) => ({
          ...m,
          id: m.name
          // Use name as the id
        }));
        let d = u;
        if (l.search) {
          const m = l.search.toLowerCase();
          d = u.filter(
            (g) => g.name.toLowerCase().includes(m) || g.description && g.description.toLowerCase().includes(m)
          );
        }
        l.sort && (d = [...d].sort((m, g) => {
          const y = l.sort, x = m[y], w = g[y], _ = l.dir === _n.ASC ? 1 : -1;
          return x.localeCompare(w) * _;
        }));
        const f = l.offset || 0, h = l.limit || 10;
        return {
          data: d.slice(f, f + h),
          pagination: {
            total: d.length,
            offset: f,
            limit: h,
            currentPage: Math.floor(f / h) + 1,
            totalPages: Math.ceil(d.length / h)
          },
          links: {}
        };
      },
      getOne: async (l) => {
        const u = (await t.usersApi.userLists()).find((h) => h.name === l);
        if (!u)
          throw new Error(`User list with ID ${l} not found`);
        const d = await t.usersApi.usersPage({
          lists: [l],
          limit: 1e3
          // Fetch a large number to get all users
        }), f = d.results ? d.results.map((h) => h.id) : [];
        return {
          ...u,
          id: u.name,
          userIds: f
        };
      },
      create: async (l) => {
        if (await t.usersApi.createUserList({
          userLists200ResponseInner: {
            name: l.name,
            description: l.description || ""
          }
        }), l.userIds && l.userIds.length > 0) {
          const c = l.userIds.map(
            (u) => t.usersApi.addUserList({
              id: u,
              list: l.name
            })
          );
          await Promise.all(c);
        }
        return { id: l.name, ...l };
      },
      update: async (l, c) => {
        const u = await s.getOne(l);
        if (await t.usersApi.deleteUserList({
          list: l
        }), await t.usersApi.createUserList({
          userLists200ResponseInner: {
            name: c.name,
            description: c.description || ""
          }
        }), c.userIds) {
          const d = u.userIds || [], f = c.userIds;
          for (const h of f)
            d.includes(h) || await t.usersApi.addUserList({
              id: h,
              list: c.name
            });
        }
        return { id: c.name, ...c };
      },
      delete: async (l) => {
        await t.usersApi.deleteUserList({
          list: l
        });
      }
    }),
    [t, r, e]
  ), i = {
    extractItems: (l) => Array.isArray(l) ? l.map((c) => ({
      ...c,
      id: c.name,
      onRefresh: void 0
    })) : [],
    extractTotal: (l) => Array.isArray(l) ? l.length : 0
  };
  return {
    entityConfig: {
      name: "user-lists",
      columns: [
        {
          id: "name",
          label: e("users.lists.name"),
          sortable: !0
        },
        {
          id: "description",
          label: e("users.lists.description"),
          sortable: !0
        }
      ],
      formSections: [
        {
          title: e("users.lists.basicInfo"),
          fields: [
            {
              name: "name",
              label: e("users.lists.name"),
              type: "text",
              required: !0,
              layout: { className: "col-span-6" }
            },
            {
              name: "description",
              label: e("users.lists.description"),
              type: "textarea",
              layout: { className: "col-span-6" }
            }
          ]
        }
      ],
      validationSchema: {
        create: B.object({
          name: B.string().min(1, e("common.validation.required")),
          description: B.string().optional().or(B.literal("")),
          userIds: B.array(B.number()).optional().default([])
        }),
        update: B.object({
          name: B.string().min(1, e("common.validation.required")),
          description: B.string().optional().or(B.literal("")),
          userIds: B.array(B.number()).optional().default([])
        })
      },
      tableConfig: {
        defaultSortColumn: "name",
        defaultSortDirection: _n.ASC,
        searchFields: ["name", "description"],
        actions: (l) => /* @__PURE__ */ v.jsx(
          qe,
          {
            variant: "outline",
            color: "info",
            size: "xs",
            icon: "download",
            iconPosition: "left",
            onClick: async (c) => {
              c.stopPropagation();
              try {
                r.success(`${e("users.lists.exportPreparing")} ${l.name}`);
                const u = await t.usersApi.usersPage({
                  lists: [l.name],
                  limit: 1e3
                  // Get a large number of users
                });
                let d = `First Name,Last Name,Email
`;
                u.results && u.results.length > 0 && u.results.forEach((m) => {
                  var w;
                  const g = ((w = m.auth) == null ? void 0 : w.email) || "";
                  let y = "", x = "";
                  m.info && m.info.kind === "individual" ? (y = m.info.first_name || "", x = m.info.last_name || "") : m.info && m.info.kind === "company" && (x = m.info.company_name || ""), d += `"${y}","${x}","${g}"
`;
                });
                const f = new Blob([d], { type: "text/csv" }), h = window.URL.createObjectURL(f), p = document.createElement("a");
                p.href = h, p.download = `user-list-${l.name}.csv`, document.body.appendChild(p), p.click(), window.URL.revokeObjectURL(h), r.success(`${e("users.lists.exportComplete")} ${l.name}`);
              } catch {
                r.error(e("users.lists.exportError"));
              }
            },
            children: e("common:common.export")
          }
        )
      },
      permissions: {
        canCreate: !0,
        canEdit: !0,
        canDelete: !0,
        canExport: !1
        // Disable global export
      },
      formLayout: "single-page",
      viewModalConfig: {
        title: (l) => e("user-lists:user-lists.viewList", { name: l.name }),
        size: "full",
        actions: [
          {
            id: "add-users",
            label: e("user-lists:user-lists.addUsersToList"),
            icon: "plus",
            color: "primary",
            handler: async (l) => {
              try {
                const c = await t.usersApi.usersPage({
                  limit: 1e3
                }), u = await t.usersApi.usersPage({
                  lists: [l.name],
                  limit: 1e3
                });
                if (c.results && u.results) {
                  const d = u.results.map(
                    (h) => h.id
                  );
                  if (c.results.filter(
                    (h) => !d.includes(h.id)
                  ).length === 0)
                    return r.info(e("user-lists:user-lists.allUsersAlreadyInList")), Promise.resolve();
                }
                n("userListAddUsers", { listName: l.name });
              } catch {
                r.error(e("user-lists:user-lists.errorLoadingUsers"));
              }
              return Promise.resolve();
            }
          }
        ],
        kpis: {
          items: [
            {
              id: "name",
              label: e("users.lists.name"),
              valueKey: "name",
              icon: "list",
              color: "primary"
            },
            {
              id: "description",
              label: e("users.lists.description"),
              valueKey: "description",
              icon: "info-circle",
              color: "info"
            }
          ]
        },
        tabs: [
          {
            id: "users",
            label: e("users.lists.members"),
            listConfig: {
              entityName: "users",
              getConfig: (l) => ({
                entityConfig: {
                  ...a.entityConfig,
                  name: "user-lists",
                  permissions: {
                    canCreate: !1,
                    canEdit: !1,
                    canDelete: !1,
                    canExport: !1
                  },
                  tableConfig: {
                    ...a.entityConfig.tableConfig,
                    searchConfig: {
                      customSearch: (u) => ({
                        search: u,
                        lists: [l.name]
                      })
                    },
                    actions: (u) => /* @__PURE__ */ v.jsx(
                      qe,
                      {
                        color: "danger",
                        size: "xs",
                        icon: "trash",
                        iconPosition: "left",
                        onClick: async (d) => {
                          d.stopPropagation(), d.preventDefault();
                          try {
                            await t.usersApi.removeUserList({
                              id: u.id,
                              list: l.name
                            }), r.success(
                              e("user-lists:user-lists.userRemovedSuccess")
                            ), l != null && l.onRefresh && l.onRefresh(), window.dispatchEvent(
                              new CustomEvent("refresh-entity-table", {
                                detail: {
                                  entityName: "users",
                                  listName: l.name
                                }
                              })
                            );
                          } catch {
                            r.error(
                              e("user-lists:user-lists.errorRemovingUser")
                            );
                          }
                        },
                        children: e("user-lists:user-lists.removeFromList")
                      }
                    )
                  },
                  filters: void 0,
                  exportConfig: void 0
                },
                crudMethods: {
                  getAll: async (u) => {
                    var d;
                    try {
                      const {
                        offset: f,
                        limit: h,
                        sort: p,
                        dir: m,
                        search: g,
                        ...y
                      } = u, x = await t.usersApi.usersPage({
                        offset: f,
                        limit: h,
                        sort: p,
                        ...m && { dir: m },
                        ...g && { search: g },
                        ...y,
                        lists: [l.name]
                      });
                      return {
                        data: x.results || [],
                        pagination: {
                          total: ((d = x.meta) == null ? void 0 : d.total) || 0,
                          offset: f || 0,
                          limit: h || 10
                        }
                      };
                    } catch {
                      return r.error(e("users.lists.loadError")), {
                        data: [],
                        pagination: { total: 0 }
                      };
                    }
                  },
                  getOne: void 0,
                  create: void 0,
                  update: void 0,
                  delete: void 0
                },
                responseExtractor: a.responseExtractor
              })
            }
          }
        ]
      }
    },
    crudMethods: s,
    responseExtractor: i
  };
};
Th("user-lists", DFe);
class Met {
  constructor(t) {
    Fe(this, "config");
    this.config = t;
  }
  getConfig() {
    return this.config;
  }
  getEnvironmentVariables() {
    return {
      VITE_API_BASE_URL: this.config.apiEndpoints.main,
      VITE_AUTH_BASE_URL: this.config.apiEndpoints.auth,
      VITE_ENVIRONMENT: this.config.environment,
      VITE_STAGE: this.config.stage || "development",
      VITE_REGION: this.config.region || "",
      VITE_MEDIA_BASE_URL: this.config.apiEndpoints.media || ""
    };
  }
}
function Mo({
  children: e,
  title: t,
  subtitle: r,
  footer: n
}) {
  return /* @__PURE__ */ v.jsx("div", { className: "w-full max-w-md", children: /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col space-y-6", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ v.jsx("h2", { className: "text-3xl font-bold text-gray-900 dark:text-white", children: t }),
      r && /* @__PURE__ */ v.jsx("p", { className: "mt-2 text-md text-gray-600 dark:text-gray-400", children: r })
    ] }),
    /* @__PURE__ */ v.jsx("div", { className: "flex-1", children: e }),
    n && /* @__PURE__ */ v.jsx("div", { className: "mt-6", children: n })
  ] }) });
}
function Let({
  onGoogleLogin: e,
  onGithubLogin: t,
  className: r = ""
}) {
  const { t: n } = _t(["auth"]);
  return /* @__PURE__ */ v.jsxs("div", { className: `flex flex-col space-y-4 ${r}`, children: [
    /* @__PURE__ */ v.jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ v.jsx("div", { className: "absolute inset-0 flex items-center", children: /* @__PURE__ */ v.jsx("span", { className: "w-full border-t border-gray-200 dark:border-gray-700" }) }),
      /* @__PURE__ */ v.jsx("div", { className: "relative flex justify-center text-xs uppercase", children: /* @__PURE__ */ v.jsx("span", { className: "bg-white dark:bg-gray-900 px-4 text-gray-500 dark:text-gray-400 font-medium", children: n("auth.orContinueWith") }) })
    ] }),
    /* @__PURE__ */ v.jsx(
      qe,
      {
        variant: "outline",
        color: "gray",
        fullWidth: !0,
        onClick: e,
        disabled: !e,
        className: "h-11 bg-white dark:bg-border hover:bg-gray-50 dark:hover:bg-gray-700 border-gray-200 dark:border-gray-700",
        icon: "google",
        iconPosition: "left",
        children: /* @__PURE__ */ v.jsx("span", { className: "font-medium text-gray-700 dark:text-gray-200", children: n("auth.continueWithGoogle") })
      }
    )
  ] });
}
var NFe = Object.defineProperty, jb = Object.getOwnPropertySymbols, l$ = Object.prototype.hasOwnProperty, c$ = Object.prototype.propertyIsEnumerable, gL = (e, t, r) => t in e ? NFe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, cT = (e, t) => {
  for (var r in t || (t = {}))
    l$.call(t, r) && gL(e, r, t[r]);
  if (jb)
    for (var r of jb(t))
      c$.call(t, r) && gL(e, r, t[r]);
  return e;
}, uT = (e, t) => {
  var r = {};
  for (var n in e)
    l$.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && jb)
    for (var n of jb(e))
      t.indexOf(n) < 0 && c$.call(e, n) && (r[n] = e[n]);
  return r;
};
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */
var Gu;
((e) => {
  const t = class yr {
    /*-- Constructor (low level) and fields --*/
    // Creates a new QR Code with the given version number,
    // error correction level, data codeword bytes, and mask number.
    // This is a low-level API that most users should not use directly.
    // A mid-level API is the encodeSegments() function.
    constructor(l, c, u, d) {
      if (this.version = l, this.errorCorrectionLevel = c, this.modules = [], this.isFunction = [], l < yr.MIN_VERSION || l > yr.MAX_VERSION)
        throw new RangeError("Version value out of range");
      if (d < -1 || d > 7)
        throw new RangeError("Mask value out of range");
      this.size = l * 4 + 17;
      let f = [];
      for (let p = 0; p < this.size; p++)
        f.push(!1);
      for (let p = 0; p < this.size; p++)
        this.modules.push(f.slice()), this.isFunction.push(f.slice());
      this.drawFunctionPatterns();
      const h = this.addEccAndInterleave(u);
      if (this.drawCodewords(h), d == -1) {
        let p = 1e9;
        for (let m = 0; m < 8; m++) {
          this.applyMask(m), this.drawFormatBits(m);
          const g = this.getPenaltyScore();
          g < p && (d = m, p = g), this.applyMask(m);
        }
      }
      a(0 <= d && d <= 7), this.mask = d, this.applyMask(d), this.drawFormatBits(d), this.isFunction = [];
    }
    /*-- Static factory functions (high level) --*/
    // Returns a QR Code representing the given Unicode text string at the given error correction level.
    // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
    // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
    // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
    // ecl argument if it can be done without increasing the version.
    static encodeText(l, c) {
      const u = e.QrSegment.makeSegments(l);
      return yr.encodeSegments(u, c);
    }
    // Returns a QR Code representing the given binary data at the given error correction level.
    // This function always encodes using the binary segment mode, not any text mode. The maximum number of
    // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
    // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
    static encodeBinary(l, c) {
      const u = e.QrSegment.makeBytes(l);
      return yr.encodeSegments([u], c);
    }
    /*-- Static factory functions (mid level) --*/
    // Returns a QR Code representing the given segments with the given encoding parameters.
    // The smallest possible QR Code version within the given range is automatically
    // chosen for the output. Iff boostEcl is true, then the ECC level of the result
    // may be higher than the ecl argument if it can be done without increasing the
    // version. The mask number is either between 0 to 7 (inclusive) to force that
    // mask, or -1 to automatically choose an appropriate mask (which may be slow).
    // This function allows the user to create a custom sequence of segments that switches
    // between modes (such as alphanumeric and byte) to encode text in less space.
    // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
    static encodeSegments(l, c, u = 1, d = 40, f = -1, h = !0) {
      if (!(yr.MIN_VERSION <= u && u <= d && d <= yr.MAX_VERSION) || f < -1 || f > 7)
        throw new RangeError("Invalid value");
      let p, m;
      for (p = u; ; p++) {
        const w = yr.getNumDataCodewords(p, c) * 8, _ = i.getTotalBits(l, p);
        if (_ <= w) {
          m = _;
          break;
        }
        if (p >= d)
          throw new RangeError("Data too long");
      }
      for (const w of [yr.Ecc.MEDIUM, yr.Ecc.QUARTILE, yr.Ecc.HIGH])
        h && m <= yr.getNumDataCodewords(p, w) * 8 && (c = w);
      let g = [];
      for (const w of l) {
        r(w.mode.modeBits, 4, g), r(w.numChars, w.mode.numCharCountBits(p), g);
        for (const _ of w.getData())
          g.push(_);
      }
      a(g.length == m);
      const y = yr.getNumDataCodewords(p, c) * 8;
      a(g.length <= y), r(0, Math.min(4, y - g.length), g), r(0, (8 - g.length % 8) % 8, g), a(g.length % 8 == 0);
      for (let w = 236; g.length < y; w ^= 253)
        r(w, 8, g);
      let x = [];
      for (; x.length * 8 < g.length; )
        x.push(0);
      return g.forEach((w, _) => x[_ >>> 3] |= w << 7 - (_ & 7)), new yr(p, c, x, f);
    }
    /*-- Accessor methods --*/
    // Returns the color of the module (pixel) at the given coordinates, which is false
    // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
    // If the given coordinates are out of bounds, then false (light) is returned.
    getModule(l, c) {
      return 0 <= l && l < this.size && 0 <= c && c < this.size && this.modules[c][l];
    }
    // Modified to expose modules for easy access
    getModules() {
      return this.modules;
    }
    /*-- Private helper methods for constructor: Drawing function modules --*/
    // Reads this object's version field, and draws and marks all function modules.
    drawFunctionPatterns() {
      for (let u = 0; u < this.size; u++)
        this.setFunctionModule(6, u, u % 2 == 0), this.setFunctionModule(u, 6, u % 2 == 0);
      this.drawFinderPattern(3, 3), this.drawFinderPattern(this.size - 4, 3), this.drawFinderPattern(3, this.size - 4);
      const l = this.getAlignmentPatternPositions(), c = l.length;
      for (let u = 0; u < c; u++)
        for (let d = 0; d < c; d++)
          u == 0 && d == 0 || u == 0 && d == c - 1 || u == c - 1 && d == 0 || this.drawAlignmentPattern(l[u], l[d]);
      this.drawFormatBits(0), this.drawVersion();
    }
    // Draws two copies of the format bits (with its own error correction code)
    // based on the given mask and this object's error correction level field.
    drawFormatBits(l) {
      const c = this.errorCorrectionLevel.formatBits << 3 | l;
      let u = c;
      for (let f = 0; f < 10; f++)
        u = u << 1 ^ (u >>> 9) * 1335;
      const d = (c << 10 | u) ^ 21522;
      a(d >>> 15 == 0);
      for (let f = 0; f <= 5; f++)
        this.setFunctionModule(8, f, n(d, f));
      this.setFunctionModule(8, 7, n(d, 6)), this.setFunctionModule(8, 8, n(d, 7)), this.setFunctionModule(7, 8, n(d, 8));
      for (let f = 9; f < 15; f++)
        this.setFunctionModule(14 - f, 8, n(d, f));
      for (let f = 0; f < 8; f++)
        this.setFunctionModule(this.size - 1 - f, 8, n(d, f));
      for (let f = 8; f < 15; f++)
        this.setFunctionModule(8, this.size - 15 + f, n(d, f));
      this.setFunctionModule(8, this.size - 8, !0);
    }
    // Draws two copies of the version bits (with its own error correction code),
    // based on this object's version field, iff 7 <= version <= 40.
    drawVersion() {
      if (this.version < 7)
        return;
      let l = this.version;
      for (let u = 0; u < 12; u++)
        l = l << 1 ^ (l >>> 11) * 7973;
      const c = this.version << 12 | l;
      a(c >>> 18 == 0);
      for (let u = 0; u < 18; u++) {
        const d = n(c, u), f = this.size - 11 + u % 3, h = Math.floor(u / 3);
        this.setFunctionModule(f, h, d), this.setFunctionModule(h, f, d);
      }
    }
    // Draws a 9*9 finder pattern including the border separator,
    // with the center module at (x, y). Modules can be out of bounds.
    drawFinderPattern(l, c) {
      for (let u = -4; u <= 4; u++)
        for (let d = -4; d <= 4; d++) {
          const f = Math.max(Math.abs(d), Math.abs(u)), h = l + d, p = c + u;
          0 <= h && h < this.size && 0 <= p && p < this.size && this.setFunctionModule(h, p, f != 2 && f != 4);
        }
    }
    // Draws a 5*5 alignment pattern, with the center module
    // at (x, y). All modules must be in bounds.
    drawAlignmentPattern(l, c) {
      for (let u = -2; u <= 2; u++)
        for (let d = -2; d <= 2; d++)
          this.setFunctionModule(l + d, c + u, Math.max(Math.abs(d), Math.abs(u)) != 1);
    }
    // Sets the color of a module and marks it as a function module.
    // Only used by the constructor. Coordinates must be in bounds.
    setFunctionModule(l, c, u) {
      this.modules[c][l] = u, this.isFunction[c][l] = !0;
    }
    /*-- Private helper methods for constructor: Codewords and masking --*/
    // Returns a new byte string representing the given data with the appropriate error correction
    // codewords appended to it, based on this object's version and error correction level.
    addEccAndInterleave(l) {
      const c = this.version, u = this.errorCorrectionLevel;
      if (l.length != yr.getNumDataCodewords(c, u))
        throw new RangeError("Invalid argument");
      const d = yr.NUM_ERROR_CORRECTION_BLOCKS[u.ordinal][c], f = yr.ECC_CODEWORDS_PER_BLOCK[u.ordinal][c], h = Math.floor(yr.getNumRawDataModules(c) / 8), p = d - h % d, m = Math.floor(h / d);
      let g = [];
      const y = yr.reedSolomonComputeDivisor(f);
      for (let w = 0, _ = 0; w < d; w++) {
        let S = l.slice(_, _ + m - f + (w < p ? 0 : 1));
        _ += S.length;
        const C = yr.reedSolomonComputeRemainder(S, y);
        w < p && S.push(0), g.push(S.concat(C));
      }
      let x = [];
      for (let w = 0; w < g[0].length; w++)
        g.forEach((_, S) => {
          (w != m - f || S >= p) && x.push(_[w]);
        });
      return a(x.length == h), x;
    }
    // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
    // data area of this QR Code. Function modules need to be marked off before this is called.
    drawCodewords(l) {
      if (l.length != Math.floor(yr.getNumRawDataModules(this.version) / 8))
        throw new RangeError("Invalid argument");
      let c = 0;
      for (let u = this.size - 1; u >= 1; u -= 2) {
        u == 6 && (u = 5);
        for (let d = 0; d < this.size; d++)
          for (let f = 0; f < 2; f++) {
            const h = u - f, m = (u + 1 & 2) == 0 ? this.size - 1 - d : d;
            !this.isFunction[m][h] && c < l.length * 8 && (this.modules[m][h] = n(l[c >>> 3], 7 - (c & 7)), c++);
          }
      }
      a(c == l.length * 8);
    }
    // XORs the codeword modules in this QR Code with the given mask pattern.
    // The function modules must be marked and the codeword bits must be drawn
    // before masking. Due to the arithmetic of XOR, calling applyMask() with
    // the same mask value a second time will undo the mask. A final well-formed
    // QR Code needs exactly one (not zero, two, etc.) mask applied.
    applyMask(l) {
      if (l < 0 || l > 7)
        throw new RangeError("Mask value out of range");
      for (let c = 0; c < this.size; c++)
        for (let u = 0; u < this.size; u++) {
          let d;
          switch (l) {
            case 0:
              d = (u + c) % 2 == 0;
              break;
            case 1:
              d = c % 2 == 0;
              break;
            case 2:
              d = u % 3 == 0;
              break;
            case 3:
              d = (u + c) % 3 == 0;
              break;
            case 4:
              d = (Math.floor(u / 3) + Math.floor(c / 2)) % 2 == 0;
              break;
            case 5:
              d = u * c % 2 + u * c % 3 == 0;
              break;
            case 6:
              d = (u * c % 2 + u * c % 3) % 2 == 0;
              break;
            case 7:
              d = ((u + c) % 2 + u * c % 3) % 2 == 0;
              break;
            default:
              throw new Error("Unreachable");
          }
          !this.isFunction[c][u] && d && (this.modules[c][u] = !this.modules[c][u]);
        }
    }
    // Calculates and returns the penalty score based on state of this QR Code's current modules.
    // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
    getPenaltyScore() {
      let l = 0;
      for (let f = 0; f < this.size; f++) {
        let h = !1, p = 0, m = [0, 0, 0, 0, 0, 0, 0];
        for (let g = 0; g < this.size; g++)
          this.modules[f][g] == h ? (p++, p == 5 ? l += yr.PENALTY_N1 : p > 5 && l++) : (this.finderPenaltyAddHistory(p, m), h || (l += this.finderPenaltyCountPatterns(m) * yr.PENALTY_N3), h = this.modules[f][g], p = 1);
        l += this.finderPenaltyTerminateAndCount(h, p, m) * yr.PENALTY_N3;
      }
      for (let f = 0; f < this.size; f++) {
        let h = !1, p = 0, m = [0, 0, 0, 0, 0, 0, 0];
        for (let g = 0; g < this.size; g++)
          this.modules[g][f] == h ? (p++, p == 5 ? l += yr.PENALTY_N1 : p > 5 && l++) : (this.finderPenaltyAddHistory(p, m), h || (l += this.finderPenaltyCountPatterns(m) * yr.PENALTY_N3), h = this.modules[g][f], p = 1);
        l += this.finderPenaltyTerminateAndCount(h, p, m) * yr.PENALTY_N3;
      }
      for (let f = 0; f < this.size - 1; f++)
        for (let h = 0; h < this.size - 1; h++) {
          const p = this.modules[f][h];
          p == this.modules[f][h + 1] && p == this.modules[f + 1][h] && p == this.modules[f + 1][h + 1] && (l += yr.PENALTY_N2);
        }
      let c = 0;
      for (const f of this.modules)
        c = f.reduce((h, p) => h + (p ? 1 : 0), c);
      const u = this.size * this.size, d = Math.ceil(Math.abs(c * 20 - u * 10) / u) - 1;
      return a(0 <= d && d <= 9), l += d * yr.PENALTY_N4, a(0 <= l && l <= 2568888), l;
    }
    /*-- Private helper functions --*/
    // Returns an ascending list of positions of alignment patterns for this version number.
    // Each position is in the range [0,177), and are used on both the x and y axes.
    // This could be implemented as lookup table of 40 variable-length lists of integers.
    getAlignmentPatternPositions() {
      if (this.version == 1)
        return [];
      {
        const l = Math.floor(this.version / 7) + 2, c = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (l * 2 - 2)) * 2;
        let u = [6];
        for (let d = this.size - 7; u.length < l; d -= c)
          u.splice(1, 0, d);
        return u;
      }
    }
    // Returns the number of data bits that can be stored in a QR Code of the given version number, after
    // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
    // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
    static getNumRawDataModules(l) {
      if (l < yr.MIN_VERSION || l > yr.MAX_VERSION)
        throw new RangeError("Version number out of range");
      let c = (16 * l + 128) * l + 64;
      if (l >= 2) {
        const u = Math.floor(l / 7) + 2;
        c -= (25 * u - 10) * u - 55, l >= 7 && (c -= 36);
      }
      return a(208 <= c && c <= 29648), c;
    }
    // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
    // QR Code of the given version number and error correction level, with remainder bits discarded.
    // This stateless pure function could be implemented as a (40*4)-cell lookup table.
    static getNumDataCodewords(l, c) {
      return Math.floor(yr.getNumRawDataModules(l) / 8) - yr.ECC_CODEWORDS_PER_BLOCK[c.ordinal][l] * yr.NUM_ERROR_CORRECTION_BLOCKS[c.ordinal][l];
    }
    // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
    // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
    static reedSolomonComputeDivisor(l) {
      if (l < 1 || l > 255)
        throw new RangeError("Degree out of range");
      let c = [];
      for (let d = 0; d < l - 1; d++)
        c.push(0);
      c.push(1);
      let u = 1;
      for (let d = 0; d < l; d++) {
        for (let f = 0; f < c.length; f++)
          c[f] = yr.reedSolomonMultiply(c[f], u), f + 1 < c.length && (c[f] ^= c[f + 1]);
        u = yr.reedSolomonMultiply(u, 2);
      }
      return c;
    }
    // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
    static reedSolomonComputeRemainder(l, c) {
      let u = c.map((d) => 0);
      for (const d of l) {
        const f = d ^ u.shift();
        u.push(0), c.forEach((h, p) => u[p] ^= yr.reedSolomonMultiply(h, f));
      }
      return u;
    }
    // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
    // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
    static reedSolomonMultiply(l, c) {
      if (l >>> 8 || c >>> 8)
        throw new RangeError("Byte out of range");
      let u = 0;
      for (let d = 7; d >= 0; d--)
        u = u << 1 ^ (u >>> 7) * 285, u ^= (c >>> d & 1) * l;
      return a(u >>> 8 == 0), u;
    }
    // Can only be called immediately after a light run is added, and
    // returns either 0, 1, or 2. A helper function for getPenaltyScore().
    finderPenaltyCountPatterns(l) {
      const c = l[1];
      a(c <= this.size * 3);
      const u = c > 0 && l[2] == c && l[3] == c * 3 && l[4] == c && l[5] == c;
      return (u && l[0] >= c * 4 && l[6] >= c ? 1 : 0) + (u && l[6] >= c * 4 && l[0] >= c ? 1 : 0);
    }
    // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
    finderPenaltyTerminateAndCount(l, c, u) {
      return l && (this.finderPenaltyAddHistory(c, u), c = 0), c += this.size, this.finderPenaltyAddHistory(c, u), this.finderPenaltyCountPatterns(u);
    }
    // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
    finderPenaltyAddHistory(l, c) {
      c[0] == 0 && (l += this.size), c.pop(), c.unshift(l);
    }
  };
  t.MIN_VERSION = 1, t.MAX_VERSION = 40, t.PENALTY_N1 = 3, t.PENALTY_N2 = 3, t.PENALTY_N3 = 40, t.PENALTY_N4 = 10, t.ECC_CODEWORDS_PER_BLOCK = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    // Low
    [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
    // Medium
    [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    // Quartile
    [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]
    // High
  ], t.NUM_ERROR_CORRECTION_BLOCKS = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25],
    // Low
    [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49],
    // Medium
    [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68],
    // Quartile
    [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]
    // High
  ], e.QrCode = t;
  function r(o, l, c) {
    if (l < 0 || l > 31 || o >>> l)
      throw new RangeError("Value out of range");
    for (let u = l - 1; u >= 0; u--)
      c.push(o >>> u & 1);
  }
  function n(o, l) {
    return (o >>> l & 1) != 0;
  }
  function a(o) {
    if (!o)
      throw new Error("Assertion error");
  }
  const s = class kn {
    /*-- Constructor (low level) and fields --*/
    // Creates a new QR Code segment with the given attributes and data.
    // The character count (numChars) must agree with the mode and the bit buffer length,
    // but the constraint isn't checked. The given bit buffer is cloned and stored.
    constructor(l, c, u) {
      if (this.mode = l, this.numChars = c, this.bitData = u, c < 0)
        throw new RangeError("Invalid argument");
      this.bitData = u.slice();
    }
    /*-- Static factory functions (mid level) --*/
    // Returns a segment representing the given binary data encoded in
    // byte mode. All input byte arrays are acceptable. Any text string
    // can be converted to UTF-8 bytes and encoded as a byte mode segment.
    static makeBytes(l) {
      let c = [];
      for (const u of l)
        r(u, 8, c);
      return new kn(kn.Mode.BYTE, l.length, c);
    }
    // Returns a segment representing the given string of decimal digits encoded in numeric mode.
    static makeNumeric(l) {
      if (!kn.isNumeric(l))
        throw new RangeError("String contains non-numeric characters");
      let c = [];
      for (let u = 0; u < l.length; ) {
        const d = Math.min(l.length - u, 3);
        r(parseInt(l.substring(u, u + d), 10), d * 3 + 1, c), u += d;
      }
      return new kn(kn.Mode.NUMERIC, l.length, c);
    }
    // Returns a segment representing the given text string encoded in alphanumeric mode.
    // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
    // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
    static makeAlphanumeric(l) {
      if (!kn.isAlphanumeric(l))
        throw new RangeError("String contains unencodable characters in alphanumeric mode");
      let c = [], u;
      for (u = 0; u + 2 <= l.length; u += 2) {
        let d = kn.ALPHANUMERIC_CHARSET.indexOf(l.charAt(u)) * 45;
        d += kn.ALPHANUMERIC_CHARSET.indexOf(l.charAt(u + 1)), r(d, 11, c);
      }
      return u < l.length && r(kn.ALPHANUMERIC_CHARSET.indexOf(l.charAt(u)), 6, c), new kn(kn.Mode.ALPHANUMERIC, l.length, c);
    }
    // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
    // The result may use various segment modes and switch modes to optimize the length of the bit stream.
    static makeSegments(l) {
      return l == "" ? [] : kn.isNumeric(l) ? [kn.makeNumeric(l)] : kn.isAlphanumeric(l) ? [kn.makeAlphanumeric(l)] : [kn.makeBytes(kn.toUtf8ByteArray(l))];
    }
    // Returns a segment representing an Extended Channel Interpretation
    // (ECI) designator with the given assignment value.
    static makeEci(l) {
      let c = [];
      if (l < 0)
        throw new RangeError("ECI assignment value out of range");
      if (l < 128)
        r(l, 8, c);
      else if (l < 16384)
        r(2, 2, c), r(l, 14, c);
      else if (l < 1e6)
        r(6, 3, c), r(l, 21, c);
      else
        throw new RangeError("ECI assignment value out of range");
      return new kn(kn.Mode.ECI, 0, c);
    }
    // Tests whether the given string can be encoded as a segment in numeric mode.
    // A string is encodable iff each character is in the range 0 to 9.
    static isNumeric(l) {
      return kn.NUMERIC_REGEX.test(l);
    }
    // Tests whether the given string can be encoded as a segment in alphanumeric mode.
    // A string is encodable iff each character is in the following set: 0 to 9, A to Z
    // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
    static isAlphanumeric(l) {
      return kn.ALPHANUMERIC_REGEX.test(l);
    }
    /*-- Methods --*/
    // Returns a new copy of the data bits of this segment.
    getData() {
      return this.bitData.slice();
    }
    // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
    // the given version. The result is infinity if a segment has too many characters to fit its length field.
    static getTotalBits(l, c) {
      let u = 0;
      for (const d of l) {
        const f = d.mode.numCharCountBits(c);
        if (d.numChars >= 1 << f)
          return 1 / 0;
        u += 4 + f + d.bitData.length;
      }
      return u;
    }
    // Returns a new array of bytes representing the given string encoded in UTF-8.
    static toUtf8ByteArray(l) {
      l = encodeURI(l);
      let c = [];
      for (let u = 0; u < l.length; u++)
        l.charAt(u) != "%" ? c.push(l.charCodeAt(u)) : (c.push(parseInt(l.substring(u + 1, u + 3), 16)), u += 2);
      return c;
    }
  };
  s.NUMERIC_REGEX = /^[0-9]*$/, s.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/, s.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
  let i = s;
  e.QrSegment = s;
})(Gu || (Gu = {}));
((e) => {
  ((t) => {
    const r = class {
      // The QR Code can tolerate about 30% erroneous codewords
      /*-- Constructor and fields --*/
      constructor(a, s) {
        this.ordinal = a, this.formatBits = s;
      }
    };
    r.LOW = new r(0, 1), r.MEDIUM = new r(1, 0), r.QUARTILE = new r(2, 3), r.HIGH = new r(3, 2), t.Ecc = r;
  })(e.QrCode || (e.QrCode = {}));
})(Gu || (Gu = {}));
((e) => {
  ((t) => {
    const r = class {
      /*-- Constructor and fields --*/
      constructor(a, s) {
        this.modeBits = a, this.numBitsCharCount = s;
      }
      /*-- Method --*/
      // (Package-private) Returns the bit width of the character count field for a segment in
      // this mode in a QR Code at the given version number. The result is in the range [0, 16].
      numCharCountBits(a) {
        return this.numBitsCharCount[Math.floor((a + 7) / 17)];
      }
    };
    r.NUMERIC = new r(1, [10, 12, 14]), r.ALPHANUMERIC = new r(2, [9, 11, 13]), r.BYTE = new r(4, [8, 16, 16]), r.KANJI = new r(8, [8, 10, 12]), r.ECI = new r(7, [0, 0, 0]), t.Mode = r;
  })(e.QrSegment || (e.QrSegment = {}));
})(Gu || (Gu = {}));
var If = Gu;
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */
var MFe = {
  L: If.QrCode.Ecc.LOW,
  M: If.QrCode.Ecc.MEDIUM,
  Q: If.QrCode.Ecc.QUARTILE,
  H: If.QrCode.Ecc.HIGH
}, u$ = 128, d$ = "L", f$ = "#FFFFFF", h$ = "#000000", p$ = !1, m$ = 1, LFe = 4, jFe = 0, FFe = 0.1;
function g$(e, t = 0) {
  const r = [];
  return e.forEach(function(n, a) {
    let s = null;
    n.forEach(function(i, o) {
      if (!i && s !== null) {
        r.push(
          `M${s + t} ${a + t}h${o - s}v1H${s + t}z`
        ), s = null;
        return;
      }
      if (o === n.length - 1) {
        if (!i)
          return;
        s === null ? r.push(`M${o + t},${a + t} h1v1H${o + t}z`) : r.push(
          `M${s + t},${a + t} h${o + 1 - s}v1H${s + t}z`
        );
        return;
      }
      i && s === null && (s = o);
    });
  }), r.join("");
}
function v$(e, t) {
  return e.slice().map((r, n) => n < t.y || n >= t.y + t.h ? r : r.map((a, s) => s < t.x || s >= t.x + t.w ? a : !1));
}
function BFe(e, t, r, n) {
  if (n == null)
    return null;
  const a = e.length + r * 2, s = Math.floor(t * FFe), i = a / t, o = (n.width || s) * i, l = (n.height || s) * i, c = n.x == null ? e.length / 2 - o / 2 : n.x * i, u = n.y == null ? e.length / 2 - l / 2 : n.y * i, d = n.opacity == null ? 1 : n.opacity;
  let f = null;
  if (n.excavate) {
    let p = Math.floor(c), m = Math.floor(u), g = Math.ceil(o + c - p), y = Math.ceil(l + u - m);
    f = { x: p, y: m, w: g, h: y };
  }
  const h = n.crossOrigin;
  return { x: c, y: u, h: l, w: o, excavation: f, opacity: d, crossOrigin: h };
}
function UFe(e, t) {
  return t != null ? Math.max(Math.floor(t), 0) : e ? LFe : jFe;
}
function y$({
  value: e,
  level: t,
  minVersion: r,
  includeMargin: n,
  marginSize: a,
  imageSettings: s,
  size: i,
  boostLevel: o
}) {
  let l = M.useMemo(() => {
    const p = (Array.isArray(e) ? e : [e]).reduce((m, g) => (m.push(...If.QrSegment.makeSegments(g)), m), []);
    return If.QrCode.encodeSegments(
      p,
      MFe[t],
      r,
      void 0,
      void 0,
      o
    );
  }, [e, t, r, o]);
  const { cells: c, margin: u, numCells: d, calculatedImageSettings: f } = M.useMemo(() => {
    let h = l.getModules();
    const p = UFe(n, a), m = h.length + p * 2, g = BFe(
      h,
      i,
      p,
      s
    );
    return {
      cells: h,
      margin: p,
      numCells: m,
      calculatedImageSettings: g
    };
  }, [l, i, s, n, a]);
  return {
    qrcode: l,
    margin: u,
    cells: c,
    numCells: d,
    calculatedImageSettings: f
  };
}
var VFe = function() {
  try {
    new Path2D().addPath(new Path2D());
  } catch {
    return !1;
  }
  return !0;
}(), $Fe = M.forwardRef(
  function(t, r) {
    const n = t, {
      value: a,
      size: s = u$,
      level: i = d$,
      bgColor: o = f$,
      fgColor: l = h$,
      includeMargin: c = p$,
      minVersion: u = m$,
      boostLevel: d,
      marginSize: f,
      imageSettings: h
    } = n, m = uT(n, [
      "value",
      "size",
      "level",
      "bgColor",
      "fgColor",
      "includeMargin",
      "minVersion",
      "boostLevel",
      "marginSize",
      "imageSettings"
    ]), { style: g } = m, y = uT(m, ["style"]), x = h == null ? void 0 : h.src, w = M.useRef(null), _ = M.useRef(null), S = M.useCallback(
      (z) => {
        w.current = z, typeof r == "function" ? r(z) : r && (r.current = z);
      },
      [r]
    ), [C, E] = M.useState(!1), { margin: O, cells: k, numCells: A, calculatedImageSettings: P } = y$({
      value: a,
      level: i,
      minVersion: u,
      boostLevel: d,
      includeMargin: c,
      marginSize: f,
      imageSettings: h,
      size: s
    });
    M.useEffect(() => {
      if (w.current != null) {
        const z = w.current, G = z.getContext("2d");
        if (!G)
          return;
        let Y = k;
        const te = _.current, ae = P != null && te !== null && te.complete && te.naturalHeight !== 0 && te.naturalWidth !== 0;
        ae && P.excavation != null && (Y = v$(
          k,
          P.excavation
        ));
        const ne = window.devicePixelRatio || 1;
        z.height = z.width = s * ne;
        const ue = s / A * ne;
        G.scale(ue, ue), G.fillStyle = o, G.fillRect(0, 0, A, A), G.fillStyle = l, VFe ? G.fill(new Path2D(g$(Y, O))) : k.forEach(function(q, U) {
          q.forEach(function(Q, L) {
            Q && G.fillRect(L + O, U + O, 1, 1);
          });
        }), P && (G.globalAlpha = P.opacity), ae && G.drawImage(
          te,
          P.x + O,
          P.y + O,
          P.w,
          P.h
        );
      }
    }), M.useEffect(() => {
      E(!1);
    }, [x]);
    const D = cT({ height: s, width: s }, g);
    let N = null;
    return x != null && (N = /* @__PURE__ */ M.createElement(
      "img",
      {
        src: x,
        key: x,
        style: { display: "none" },
        onLoad: () => {
          E(!0);
        },
        ref: _,
        crossOrigin: P == null ? void 0 : P.crossOrigin
      }
    )), /* @__PURE__ */ M.createElement(M.Fragment, null, /* @__PURE__ */ M.createElement(
      "canvas",
      cT({
        style: D,
        height: s,
        width: s,
        ref: S,
        role: "img"
      }, y)
    ), N);
  }
);
$Fe.displayName = "QRCodeCanvas";
var b$ = M.forwardRef(
  function(t, r) {
    const n = t, {
      value: a,
      size: s = u$,
      level: i = d$,
      bgColor: o = f$,
      fgColor: l = h$,
      includeMargin: c = p$,
      minVersion: u = m$,
      boostLevel: d,
      title: f,
      marginSize: h,
      imageSettings: p
    } = n, m = uT(n, [
      "value",
      "size",
      "level",
      "bgColor",
      "fgColor",
      "includeMargin",
      "minVersion",
      "boostLevel",
      "title",
      "marginSize",
      "imageSettings"
    ]), { margin: g, cells: y, numCells: x, calculatedImageSettings: w } = y$({
      value: a,
      level: i,
      minVersion: u,
      boostLevel: d,
      includeMargin: c,
      marginSize: h,
      imageSettings: p,
      size: s
    });
    let _ = y, S = null;
    p != null && w != null && (w.excavation != null && (_ = v$(
      y,
      w.excavation
    )), S = /* @__PURE__ */ M.createElement(
      "image",
      {
        href: p.src,
        height: w.h,
        width: w.w,
        x: w.x + g,
        y: w.y + g,
        preserveAspectRatio: "none",
        opacity: w.opacity,
        crossOrigin: w.crossOrigin
      }
    ));
    const C = g$(_, g);
    return /* @__PURE__ */ M.createElement(
      "svg",
      cT({
        height: s,
        width: s,
        viewBox: `0 0 ${x} ${x}`,
        ref: r,
        role: "img"
      }, m),
      !!f && /* @__PURE__ */ M.createElement("title", null, f),
      /* @__PURE__ */ M.createElement(
        "path",
        {
          fill: o,
          d: `M0,0 h${x}v${x}H0z`,
          shapeRendering: "crispEdges"
        }
      ),
      /* @__PURE__ */ M.createElement("path", { fill: l, d: C, shapeRendering: "crispEdges" }),
      S
    );
  }
);
b$.displayName = "QRCodeSVG";
function HFe(e, t) {
  const { t: r } = _t(), [n, a] = Me({}), s = tr(), i = Ft(() => {
    s.current && (clearInterval(s.current), s.current = void 0);
  }, []);
  wt(() => i, []);
  const o = Ft(async () => {
    try {
      const c = await e.checkKycStatus(), u = dT(c);
      u.status === "succeeded" ? (i(), a((d) => ({ ...d, status: "succeeded" })), t(u)) : u.status === "failed" && (i(), a((d) => ({
        ...d,
        status: "failed",
        error: r("auth.kyc.verificationFailed")
      })));
    } catch (c) {
      c instanceof Error && c.message !== "Failed to fetch" && (i(), a((u) => ({
        ...u,
        status: "failed",
        error: r("auth.kyc.verificationFailed")
      })));
    }
  }, [e, t, i, r]), l = Ft(async () => {
    try {
      a((d) => ({
        ...d,
        error: void 0,
        status: void 0,
        url: void 0
      }));
      const c = await e.verifyKyc(), u = dT(c);
      if (u.status === "succeeded") {
        t(u);
        return;
      }
      u.url && (a((d) => ({
        ...d,
        url: u.url,
        status: "pending"
      })), s.current = setInterval(o, 8e3));
    } catch (c) {
      if (c instanceof Error && c.message === "KYC already completed") {
        t({ status: "succeeded" });
        return;
      }
      a((u) => ({
        ...u,
        status: "failed",
        error: r("auth.kyc.verificationFailed")
      }));
    }
  }, [e, t, o, r]);
  return {
    kycUrl: n.url,
    status: n.status,
    error: n.error,
    startVerification: l
  };
}
const w$ = (e) => B.discriminatedUnion("kind", [
  B.object({
    kind: B.literal("individual"),
    first_name: B.string({ required_error: e("auth.firstNameRequired") }),
    last_name: B.string({ required_error: e("auth.lastNameRequired") }),
    birth_country: B.string({
      required_error: e("auth.birthCountryRequired")
    }),
    birth_city: B.string({ required_error: e("auth.birthCityRequired") }),
    birthday: B.string({ required_error: e("auth.birthdayRequired") }),
    nationality: B.string({ required_error: e("auth.nationalityRequired") }),
    residence_country: B.string({
      required_error: e("auth.residenceCountryRequired")
    }),
    phone_number: B.string().optional()
  }),
  B.object({
    kind: B.literal("company"),
    company_name: B.string({ required_error: e("auth.companyNameRequired") }),
    siren: B.string({ required_error: e("auth.sirenRequired") }),
    country: B.string({ required_error: e("auth.countryRequired") }),
    phone_number: B.string().optional()
  })
]), Bet = 8e3, dT = (e) => {
  if (!e)
    return { status: "failed" };
  if (typeof e == "object" && "id" in e && typeof e.id == "object" && "status" in e) {
    const t = e.id.dataleon ? "dataleon" : e.id.dev ? "dev" : void 0, r = t ? e.id[t] : void 0;
    if (typeof e.status == "object" && "pending" in e.status && typeof e.status.pending == "string")
      return {
        status: "pending",
        pendingId: r || e.status.pending,
        url: e.status.pending,
        id: r,
        provider: t
      };
    if (typeof e.status == "string")
      return {
        status: e.status,
        id: r,
        provider: t
      };
  }
  return typeof e == "string" ? {
    status: e,
    provider: "dev",
    id: "dev"
  } : typeof e == "object" && "pending" in e ? {
    status: "pending",
    pendingId: e.pending,
    url: e.pending,
    provider: "dev",
    id: "dev"
  } : { status: "failed" };
}, x$ = (e) => {
  if (!e) return !1;
  if (typeof e == "object" && "status" in e) {
    const t = e.status;
    return typeof t == "string" && t === $a.Succeeded;
  }
  return typeof e == "string" ? e === $a.Succeeded : (typeof e == "object" && "pending" in e, !1);
}, WFe = (e) => {
  if (!e) return !1;
  if (typeof e == "object" && "status" in e) {
    const t = e.status;
    return typeof t == "string" && t === $a.Succeeded;
  }
  return typeof e == "string" ? e === $a.Succeeded : !1;
}, zFe = (e) => {
  let t;
  switch (e.status) {
    case "succeeded":
      t = $a.Succeeded;
      break;
    case "failed":
      t = $a.Failed;
      break;
    case "canceled":
      t = $a.Canceled;
      break;
    case "pending":
      t = { pending: e.url || e.pendingId || "" };
      break;
    default:
      t = $a.Unknown;
  }
  const r = {};
  return e.provider === "dataleon" && e.id ? r.dataleon = e.id : (e.provider === "dev" || !e.provider) && (r.dev = e.id || "dev"), {
    id: r,
    status: t
  };
}, KFe = ({ onSubmit: e, defaultValues: t }) => {
  const { t: r } = _t(["auth", "users", "common"]), n = w$(r), [a, s] = Me((t == null ? void 0 : t.kind) || void 0), i = Tn(
    () => [
      {
        title: r("auth.onboarding.personalInfo"),
        fields: [
          {
            name: "kind",
            label: r("users:users.kind"),
            type: "select",
            required: !0,
            options: [
              { value: "individual", label: r("users:users.individual") },
              { value: "company", label: r("users:users.company") }
            ],
            layout: { className: "col-span-12 sm:col-span-6" },
            placeholder: r("common:select.placeholder"),
            onChange: (o) => s(o),
            selectProps: {
              isClearable: !1
            }
          },
          ...a === "individual" ? [
            {
              name: "first_name",
              label: r("users:users.firstName"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: {
                className: "col-start-1 col-span-12 sm:col-span-6"
              }
            },
            {
              name: "last_name",
              label: r("users:users.lastName"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: { className: "col-span-12 sm:col-span-6" }
            },
            {
              name: "birth_country",
              label: r("users:users.birthCountry"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: { className: "col-span-12 sm:col-span-6" }
            },
            {
              name: "birth_city",
              label: r("users:users.birthCity"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: { className: "col-span-12 sm:col-span-6" }
            },
            {
              name: "birthday",
              label: r("users:users.birthday"),
              type: "date",
              required: !0,
              labelProps: { position: "top" },
              layout: { className: "col-span-12 sm:col-span-6" }
            },
            {
              name: "nationality",
              label: r("users:users.nationality"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: { className: "col-span-12 sm:col-span-6" }
            },
            {
              name: "residence_country",
              label: r("users:users.residenceCountry"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: { className: "col-span-12 sm:col-span-6" }
            }
          ] : a === "company" ? [
            {
              name: "company_name",
              label: r("users:users.companyName"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: {
                className: "col-start-1 col-span-12 sm:col-span-6"
              }
            },
            {
              name: "siren",
              label: r("users:users.siren"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: { className: "col-span-12 sm:col-span-6" }
            },
            {
              name: "country",
              label: r("users:users.country"),
              type: "text",
              required: !0,
              labelProps: { position: "top" },
              layout: { className: "col-span-12 sm:col-span-6" }
            }
          ] : [],
          {
            name: "phone_number",
            label: r("users:users.phoneNumber"),
            type: "tel",
            labelProps: { position: "top" },
            layout: { className: "col-span-12 sm:col-span-6" }
          }
        ]
      }
    ],
    [a, r]
  );
  return /* @__PURE__ */ v.jsx(
    Uo,
    {
      onSubmit: e,
      defaultValues: t,
      sections: i,
      validationSchema: n,
      formLayout: "single-page",
      layout: { type: "grid", className: "grid-cols-12 gap-4" }
    }
  );
}, qFe = F4(
  ({
    onSubmit: e,
    onSkip: t,
    apiOperations: r
  }) => {
    const { t: n } = _t(["auth"]), [a, s] = Me(null), [i, o] = Me(
      null
    ), [l, c] = Me(!0);
    wt(() => {
      (async () => {
        try {
          c(!0);
          const x = await r.checkKycStatus(), w = dT(x);
          w.status === "pending" && w.url ? s(w.url) : typeof x == "object" && "status" in x && typeof x.status == "object" && "pending" in x.status && typeof x.status.pending == "string" && s(x.status.pending), o(null);
        } catch (x) {
          console.error("Error getting KYC status:", x), o("Failed to get KYC status. Please try again.");
        } finally {
          c(!1);
        }
      })();
    }, [r]);
    const { kycUrl: u, status: d, error: f, startVerification: h } = HFe(
      r,
      Ft(
        (y) => {
          e({ kyc: zFe(y) });
        },
        [e]
      )
    );
    if (wt(() => {
      !a && !l && !i && !u && !d && !f && h().catch(console.error);
    }, [
      a,
      l,
      i,
      u,
      d,
      f,
      h
    ]), i || f)
      return /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-start", children: [
        /* @__PURE__ */ v.jsxs("div", { className: "w-full mb-6 text-left", children: [
          /* @__PURE__ */ v.jsx("h2", { className: "text-2xl font-semibold text-gray-900", children: n("auth.kyc.title") }),
          /* @__PURE__ */ v.jsx("p", { className: "mt-2 text-gray-600", children: n("auth.kyc.reloadDescription") })
        ] }),
        /* @__PURE__ */ v.jsx("div", { className: "text-red-500 text-center p-4 bg-red-50 rounded-lg w-full mb-6", children: i || n(f || "") }),
        /* @__PURE__ */ v.jsxs("div", { className: "flex justify-start w-full space-x-4", children: [
          /* @__PURE__ */ v.jsx(
            qe,
            {
              variant: "solid",
              onClick: () => {
                i ? (c(!0), o(null), window.location.reload()) : h();
              },
              className: "px-6",
              children: n("auth.kyc.reload")
            }
          ),
          t && /* @__PURE__ */ v.jsx(qe, { variant: "outline", onClick: t, className: "px-6", children: n("auth.kyc.finishLater") })
        ] })
      ] });
    const m = a || u, g = () => m ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs("div", { className: "w-full mb-6 text-left", children: [
        /* @__PURE__ */ v.jsx("h2", { className: "text-xl sm:text-2xl font-semibold text-gray-900 dark:text-white", children: n("auth.kyc.title") }),
        /* @__PURE__ */ v.jsx("p", { className: "mt-2 text-sm sm:text-base text-gray-600 dark:text-gray-400", children: n("auth.kyc.description") })
      ] }),
      /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center sm:items-start space-y-4 sm:space-y-6 w-full", children: [
        /* @__PURE__ */ v.jsx("div", { className: "w-full max-w-[280px] sm:max-w-[320px]", children: /* @__PURE__ */ v.jsx(
          b$,
          {
            value: m,
            size: 280,
            className: "w-full h-auto"
          }
        ) }),
        /* @__PURE__ */ v.jsxs("p", { className: "text-sm sm:text-base text-gray-600 dark:text-gray-400 text-center sm:text-left", children: [
          n("auth.kyc.mobileInstructions"),
          " ",
          /* @__PURE__ */ v.jsx(
            "a",
            {
              href: m,
              className: "text-primary-600 dark:text-primary-400 underline",
              children: n("auth.kyc.clickHere")
            }
          )
        ] })
      ] })
    ] }) : /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-start w-full", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "w-full mb-6", children: [
        /* @__PURE__ */ v.jsx(
          _l,
          {
            variant: "text",
            width: "50%",
            height: 32,
            className: "mb-2"
          }
        ),
        /* @__PURE__ */ v.jsx(_l, { variant: "text", width: "70%", height: 20 })
      ] }),
      /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-start w-full space-y-4 sm:space-y-6", children: [
        /* @__PURE__ */ v.jsx(
          _l,
          {
            variant: "rectangular",
            width: 320,
            height: 320,
            className: "rounded-lg"
          }
        ),
        /* @__PURE__ */ v.jsx("div", { className: "w-full space-y-2", children: /* @__PURE__ */ v.jsx(_l, { variant: "text", width: "80%", height: 20 }) })
      ] })
    ] });
    return /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-start", children: [
      g(),
      /* @__PURE__ */ v.jsx("div", { className: "flex justify-start w-full mt-8", children: t && /* @__PURE__ */ v.jsx(qe, { variant: "outline", onClick: t, className: "px-6", children: n("auth.kyc.finishLater") }) })
    ] });
  }
), GFe = (e, t) => {
  const r = {
    steps: [
      {
        id: "userInfo",
        title: "auth:auth.onboarding.userInfo.title",
        isRequired: !0,
        component: KFe,
        validation: w$(t),
        shouldSkip: (n) => !!(n != null && n.isActive)
      },
      {
        id: "kyc",
        title: "auth:auth.onboarding.kyc.title",
        isRequired: !1,
        component: (n) => /* @__PURE__ */ v.jsx(qFe, { ...n, apiOperations: r.apiOperations }),
        shouldSkip: ({ kyc: n }) => WFe(n)
      }
    ],
    allowSkip: !0,
    onComplete: () => {
      window.location.href = "/";
    },
    apiOperations: {
      initializeUser: async (n) => {
        await e.usersApi.initializeUser({
          initializeUserRequest: n
        });
      },
      verifyKyc: async () => {
        const { kyc: n } = await e.usersApi.userInfo({});
        if (x$(n))
          throw new Error("KYC already completed");
        if (typeof n == "object" && "status" in n && typeof n.status == "object" && "pending" in n.status || typeof n == "object" && "pending" in n)
          throw new Error("KYC verification already in progress");
        await e.usersApi.kycUser();
        const { kyc: a } = await e.usersApi.userInfo({});
        if (!a) throw new Error("Invalid KYC response");
        return a;
      },
      checkKycStatus: async () => {
        const { kyc: n } = await e.usersApi.userInfo({});
        if (!n) throw new Error("Invalid KYC response");
        return n;
      }
    }
  };
  return r;
};
class Uet {
  constructor(t) {
    Fe(this, "config");
    this.config = t;
  }
  parseRole(t) {
    var s;
    const { separator: r } = ((s = this.config.features.auth) == null ? void 0 : s.roles.tenants) || {
      separator: ":"
    }, [n, a] = t.split(r);
    return { role: n, tenant: a };
  }
  getRoleConfig(t) {
    var r;
    return ((r = this.config.features.auth) == null ? void 0 : r.roles.definitions[t]) || null;
  }
  hasPermission(t, r, n) {
    return (t.roles || []).some((s) => {
      const { role: i, tenant: o } = this.parseRole(s), l = this.getRoleConfig(i);
      return !l || l.tenantScoped && n && o !== n ? !1 : l.permissions.includes("*") ? !0 : l.permissions.includes(r);
    });
  }
  getHighestRole(t) {
    const r = t.roles || [];
    let n = null;
    return r.forEach((a) => {
      const { role: s } = this.parseRole(a), i = this.getRoleConfig(s);
      i && (!n || i.level > n.level) && (n = i);
    }), n;
  }
  isTenantScoped(t) {
    const r = this.getRoleConfig(t);
    return (r == null ? void 0 : r.tenantScoped) || !1;
  }
}
var _$ = {}, zo = {}, ba = {}, S$ = {}, Qg = {}, t2 = {}, ur = {}, _x = {}, r2 = {}, yi = {}, Sx = {}, xo = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, _o = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(Sx, "__esModule", { value: !0 });
Sx.defaultWindowHandlerImplementation = void 0;
function Cr() {
  if (typeof window > "u")
    throw Error(
      "If you are using this package with server-side rendering, please make sure that you are checking if the window object is defined."
    );
  return window;
}
var YFe = {
  key: function(e) {
    return xo(this, void 0, void 0, function() {
      return _o(this, function(t) {
        return [2, Cr().localStorage.key(e)];
      });
    });
  },
  clear: function() {
    return xo(this, void 0, void 0, function() {
      return _o(this, function(e) {
        return [2, Cr().localStorage.clear()];
      });
    });
  },
  getItem: function(e) {
    return xo(this, void 0, void 0, function() {
      return _o(this, function(t) {
        return [2, Cr().localStorage.getItem(e)];
      });
    });
  },
  removeItem: function(e) {
    return xo(this, void 0, void 0, function() {
      return _o(this, function(t) {
        return [2, Cr().localStorage.removeItem(e)];
      });
    });
  },
  setItem: function(e, t) {
    return xo(this, void 0, void 0, function() {
      return _o(this, function(r) {
        return [2, Cr().localStorage.setItem(e, t)];
      });
    });
  },
  keySync: function(e) {
    return Cr().localStorage.key(e);
  },
  clearSync: function() {
    return Cr().localStorage.clear();
  },
  getItemSync: function(e) {
    return Cr().localStorage.getItem(e);
  },
  removeItemSync: function(e) {
    return Cr().localStorage.removeItem(e);
  },
  setItemSync: function(e, t) {
    return Cr().localStorage.setItem(e, t);
  }
}, XFe = {
  key: function(e) {
    return xo(this, void 0, void 0, function() {
      return _o(this, function(t) {
        return [2, Cr().sessionStorage.key(e)];
      });
    });
  },
  clear: function() {
    return xo(this, void 0, void 0, function() {
      return _o(this, function(e) {
        return [2, Cr().sessionStorage.clear()];
      });
    });
  },
  getItem: function(e) {
    return xo(this, void 0, void 0, function() {
      return _o(this, function(t) {
        return [2, Cr().sessionStorage.getItem(e)];
      });
    });
  },
  removeItem: function(e) {
    return xo(this, void 0, void 0, function() {
      return _o(this, function(t) {
        return [2, Cr().sessionStorage.removeItem(e)];
      });
    });
  },
  setItem: function(e, t) {
    return xo(this, void 0, void 0, function() {
      return _o(this, function(r) {
        return [2, Cr().sessionStorage.setItem(e, t)];
      });
    });
  },
  keySync: function(e) {
    return Cr().sessionStorage.key(e);
  },
  clearSync: function() {
    return Cr().sessionStorage.clear();
  },
  getItemSync: function(e) {
    return Cr().sessionStorage.getItem(e);
  },
  removeItemSync: function(e) {
    return Cr().sessionStorage.removeItem(e);
  },
  setItemSync: function(e, t) {
    return Cr().sessionStorage.setItem(e, t);
  }
};
Sx.defaultWindowHandlerImplementation = {
  history: {
    replaceState: function(e, t, r) {
      return Cr().history.replaceState(e, t, r);
    },
    getState: function() {
      return Cr().history.state;
    }
  },
  location: {
    getHref: function() {
      return Cr().location.href;
    },
    setHref: function(e) {
      Cr().location.href = e;
    },
    getSearch: function() {
      return Cr().location.search;
    },
    getHash: function() {
      return Cr().location.hash;
    },
    getPathName: function() {
      return Cr().location.pathname;
    },
    assign: function(e) {
      Cr().location.assign(e);
    },
    getHostName: function() {
      return Cr().location.hostname;
    },
    getHost: function() {
      return Cr().location.host;
    },
    getOrigin: function() {
      return Cr().location.origin;
    }
  },
  getDocument: function() {
    return Cr().document;
  },
  getWindowUnsafe: function() {
    return Cr().window;
  },
  localStorage: YFe,
  sessionStorage: XFe
};
Object.defineProperty(yi, "__esModule", { value: !0 });
yi.WindowHandlerReference = void 0;
var QFe = Sx, E$ = (
  /** @class */
  function() {
    function e(t) {
      var r = function(n) {
        return n;
      };
      t !== void 0 && (r = t), this.windowHandler = r(QFe.defaultWindowHandlerImplementation);
    }
    return e.init = function(t) {
      e.instance === void 0 && (e.instance = new e(t));
    }, e.getReferenceOrThrow = function() {
      if (e.instance === void 0)
        throw new Error("SuperTokensWindowHandler must be initialized before calling this method.");
      return e.instance;
    }, e;
  }()
);
yi.WindowHandlerReference = E$;
yi.default = E$;
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(yi);
})(r2);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.WindowHandlerReference = void 0;
  var t = r2;
  Object.defineProperty(e, "WindowHandlerReference", {
    enumerable: !0,
    get: function() {
      return t.WindowHandlerReference;
    }
  });
})(_x);
var fh = {};
Object.defineProperty(fh, "__esModule", { value: !0 });
fh.SSR_ERROR = fh.DEFAULT_API_BASE_PATH = void 0;
fh.DEFAULT_API_BASE_PATH = "/auth";
fh.SSR_ERROR = `
If you are trying to use this method doing server-side-rendering, please make sure you move this method inside a componentDidMount method or useEffect hook.`;
var Ex = {};
Object.defineProperty(Ex, "__esModule", { value: !0 });
var JFe = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this;
      this.getAsStringDangerous = function() {
        return r.value;
      }, this.value = T$(t);
    }
    return e;
  }()
);
Ex.default = JFe;
function T$(e, t) {
  t === void 0 && (t = !1);
  function r(a) {
    return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
      a
    );
  }
  e = e.trim();
  try {
    if (!e.startsWith("http://") && !e.startsWith("https://"))
      throw new Error("Error converting to proper URL");
    var n = new URL(e);
    return t ? n.hostname.startsWith("localhost") || r(n.hostname) ? e = "http://" + n.host : e = "https://" + n.host : e = n.protocol + "//" + n.host, e;
  } catch {
  }
  if (e.startsWith("/"))
    throw new Error("Please provide a valid domain name");
  if (e.indexOf(".") === 0 && (e = e.substr(1)), (e.indexOf(".") !== -1 || e.startsWith("localhost")) && !e.startsWith("http://") && !e.startsWith("https://")) {
    e = "https://" + e;
    try {
      return new URL(e), T$(e, !0);
    } catch {
    }
  }
  throw new Error("Please provide a valid domain name");
}
var Vh = {};
Object.defineProperty(Vh, "__esModule", { value: !0 });
var ZFe = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this;
      this.startsWith = function(n) {
        return r.value.startsWith(n.value);
      }, this.appendPath = function(n) {
        return new e(r.value + n.value);
      }, this.getAsStringDangerous = function() {
        return r.value;
      }, this.value = fT(t);
    }
    return e;
  }()
);
Vh.default = ZFe;
function fT(e) {
  e = e.trim();
  try {
    if (!e.startsWith("http://") && !e.startsWith("https://"))
      throw new Error("Error converting to proper URL");
    var t = new URL(e);
    return e = t.pathname, e.charAt(e.length - 1) === "/" ? e.substr(0, e.length - 1) : e;
  } catch {
  }
  if ((e5e(e) || e.startsWith("localhost")) && !e.startsWith("http://") && !e.startsWith("https://"))
    return e = "http://" + e, fT(e);
  e.charAt(0) !== "/" && (e = "/" + e);
  try {
    return new URL("http://example.com" + e), fT("http://example.com" + e);
  } catch {
    throw new Error("Please provide a valid URL path");
  }
}
function e5e(e) {
  if (e.indexOf(".") === -1 || e.startsWith("/"))
    return !1;
  try {
    var t = new URL(e);
    return t.hostname.indexOf(".") !== -1;
  } catch {
  }
  try {
    var t = new URL("http://" + e);
    return t.hostname.indexOf(".") !== -1;
  } catch {
  }
  return !1;
}
var C$ = {}, Tx = {}, rs = {}, Xd = {}, vL;
function t5e() {
  if (vL) return Xd;
  vL = 1, Object.defineProperty(Xd, "__esModule", { value: !0 }), Xd.isAnIpAddress = void 0;
  function e(n) {
    return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
      n
    );
  }
  Xd.isAnIpAddress = e;
  var t = (
    /** @class */
    /* @__PURE__ */ function() {
      function n(a) {
        var s = this;
        this.getAsStringDangerous = function() {
          return s.value;
        }, this.value = r(a);
      }
      return n;
    }()
  );
  Xd.default = t;
  function r(n, a) {
    a === void 0 && (a = !1), n = n.trim();
    try {
      if (!n.startsWith("http://") && !n.startsWith("https://"))
        throw new Error("converting to proper URL");
      var s = new URL(n);
      return a ? s.hostname.startsWith("localhost") || e(s.hostname) ? n = "http://" + s.host : n = "https://" + s.host : n = s.protocol + "//" + s.host, n;
    } catch {
    }
    if (n.startsWith("/"))
      throw new Error("Please provide a valid domain name");
    if (n.indexOf(".") === 0 && (n = n.substr(1)), (n.indexOf(".") !== -1 || n.startsWith("localhost")) && !n.startsWith("http://") && !n.startsWith("https://")) {
      n = "https://" + n;
      try {
        return new URL(n), r(n, !0);
      } catch {
      }
    }
    throw new Error("Please provide a valid domain name");
  }
  return Xd;
}
var z0 = {}, yL;
function r5e() {
  if (yL) return z0;
  yL = 1, Object.defineProperty(z0, "__esModule", { value: !0 });
  var e = (
    /** @class */
    /* @__PURE__ */ function() {
      function n(a) {
        var s = this;
        this.startsWith = function(i) {
          return s.value.startsWith(i.value);
        }, this.appendPath = function(i) {
          return new n(s.value + i.value);
        }, this.getAsStringDangerous = function() {
          return s.value;
        }, this.value = t(a);
      }
      return n;
    }()
  );
  z0.default = e;
  function t(n) {
    n = n.trim();
    try {
      if (!n.startsWith("http://") && !n.startsWith("https://"))
        throw new Error("converting to proper URL");
      var a = new URL(n);
      return n = a.pathname, n.charAt(n.length - 1) === "/" ? n.substr(0, n.length - 1) : n;
    } catch {
    }
    if ((r(n) || n.startsWith("localhost")) && !n.startsWith("http://") && !n.startsWith("https://"))
      return n = "http://" + n, t(n);
    n.charAt(0) !== "/" && (n = "/" + n);
    try {
      return new URL("http://example.com" + n), t("http://example.com" + n);
    } catch {
      throw new Error("Please provide a valid URL path");
    }
  }
  function r(n) {
    if (n.indexOf(".") === -1 || n.startsWith("/"))
      return !1;
    try {
      var a = new URL(n);
      return a.hostname.indexOf(".") !== -1;
    } catch {
    }
    try {
      var a = new URL("http://" + n);
      return a.hostname.indexOf(".") !== -1;
    } catch {
    }
    return !1;
  }
  return z0;
}
var bL;
function n2() {
  if (bL) return rs;
  bL = 1;
  var e = ke && ke.__assign || function() {
    return e = Object.assign || function(f) {
      for (var h, p = 1, m = arguments.length; p < m; p++) {
        h = arguments[p];
        for (var g in h) Object.prototype.hasOwnProperty.call(h, g) && (f[g] = h[g]);
      }
      return f;
    }, e.apply(this, arguments);
  }, t = ke && ke.__awaiter || function(f, h, p, m) {
    function g(y) {
      return y instanceof p ? y : new p(function(x) {
        x(y);
      });
    }
    return new (p || (p = Promise))(function(y, x) {
      function w(C) {
        try {
          S(m.next(C));
        } catch (E) {
          x(E);
        }
      }
      function _(C) {
        try {
          S(m.throw(C));
        } catch (E) {
          x(E);
        }
      }
      function S(C) {
        C.done ? y(C.value) : g(C.value).then(w, _);
      }
      S((m = m.apply(f, h || [])).next());
    });
  }, r = ke && ke.__generator || function(f, h) {
    var p = {
      label: 0,
      sent: function() {
        if (y[0] & 1) throw y[1];
        return y[1];
      },
      trys: [],
      ops: []
    }, m, g, y, x;
    return x = { next: w(0), throw: w(1), return: w(2) }, typeof Symbol == "function" && (x[Symbol.iterator] = function() {
      return this;
    }), x;
    function w(S) {
      return function(C) {
        return _([S, C]);
      };
    }
    function _(S) {
      if (m) throw new TypeError("Generator is already executing.");
      for (; p; )
        try {
          if (m = 1, g && (y = S[0] & 2 ? g.return : S[0] ? g.throw || ((y = g.return) && y.call(g), 0) : g.next) && !(y = y.call(g, S[1])).done)
            return y;
          switch (g = 0, y && (S = [S[0] & 2, y.value]), S[0]) {
            case 0:
            case 1:
              y = S;
              break;
            case 4:
              return p.label++, { value: S[1], done: !1 };
            case 5:
              p.label++, g = S[1], S = [0];
              continue;
            case 7:
              S = p.ops.pop(), p.trys.pop();
              continue;
            default:
              if (y = p.trys, !(y = y.length > 0 && y[y.length - 1]) && (S[0] === 6 || S[0] === 2)) {
                p = 0;
                continue;
              }
              if (S[0] === 3 && (!y || S[1] > y[0] && S[1] < y[3])) {
                p.label = S[1];
                break;
              }
              if (S[0] === 6 && p.label < y[1]) {
                p.label = y[1], y = S;
                break;
              }
              if (y && p.label < y[2]) {
                p.label = y[2], p.ops.push(S);
                break;
              }
              y[2] && p.ops.pop(), p.trys.pop();
              continue;
          }
          S = h.call(f, p);
        } catch (C) {
          S = [6, C], g = 0;
        } finally {
          m = y = 0;
        }
      if (S[0] & 5) throw S[1];
      return { value: S[0] ? S[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(rs, "__esModule", { value: !0 }), rs.matchesDomainOrSubdomain = rs.getNormalisedUserContext = rs.validateAndNormaliseInputOrThrowError = rs.normaliseSessionScopeOrThrowError = rs.normaliseURLPathOrThrowError = rs.normaliseURLDomainOrThrowError = void 0;
  var n = t5e(), a = r5e(), s = yi;
  function i(f) {
    var h = new n.default(f).getAsStringDangerous();
    return h;
  }
  rs.normaliseURLDomainOrThrowError = i;
  function o(f) {
    return new a.default(f).getAsStringDangerous();
  }
  rs.normaliseURLPathOrThrowError = o;
  function l(f) {
    function h(m) {
      m = m.trim().toLowerCase(), m.startsWith(".") && (m = m.substr(1)), !m.startsWith("http://") && !m.startsWith("https://") && (m = "http://" + m);
      try {
        var g = new URL(m);
        return m = g.hostname, m;
      } catch {
        throw new Error("Please provide a valid sessionScope");
      }
    }
    var p = h(f);
    return p === "localhost" || (0, n.isAnIpAddress)(p) ? p : f.startsWith(".") ? "." + p : p;
  }
  rs.normaliseSessionScopeOrThrowError = l;
  function c(f) {
    var h = this, p = i(f.apiDomain), m = o("/auth");
    f.apiBasePath !== void 0 && (m = o(f.apiBasePath));
    var g = s.default.getReferenceOrThrow().windowHandler.location.getHostName(), y = l(
      f !== void 0 && f.sessionTokenFrontendDomain !== void 0 ? f.sessionTokenFrontendDomain : g
    ), x = 401;
    f.sessionExpiredStatusCode !== void 0 && (x = f.sessionExpiredStatusCode);
    var w = 403;
    if (f.invalidClaimStatusCode !== void 0 && (w = f.invalidClaimStatusCode), x === w)
      throw new Error("sessionExpiredStatusCode and invalidClaimStatusCode cannot be the same.");
    var _ = !0;
    f.autoAddCredentials !== void 0 && (_ = f.autoAddCredentials);
    var S = !1;
    f.isInIframe !== void 0 && (S = f.isInIframe);
    var C = void 0;
    f.sessionTokenBackendDomain !== void 0 && (C = l(f.sessionTokenBackendDomain));
    var E = 10;
    if (f.maxRetryAttemptsForSessionRefresh !== void 0) {
      if (f.maxRetryAttemptsForSessionRefresh < 0)
        throw new Error("maxRetryAttemptsForSessionRefresh must be greater than or equal to 0.");
      E = f.maxRetryAttemptsForSessionRefresh;
    }
    var O = function(D) {
      return t(h, void 0, void 0, function() {
        return r(this, function(N) {
          return [2, { url: D.url, requestInit: D.requestInit }];
        });
      });
    };
    f.preAPIHook !== void 0 && (O = f.preAPIHook);
    var k = function() {
      return t(h, void 0, void 0, function() {
        return r(this, function(D) {
          return [
            2
            /*return*/
          ];
        });
      });
    };
    f.postAPIHook !== void 0 && (k = f.postAPIHook);
    var A = function() {
    };
    f.onHandleEvent !== void 0 && (A = f.onHandleEvent);
    var P = e(
      {
        functions: function(D) {
          return D;
        }
      },
      f.override
    );
    return {
      apiDomain: p,
      apiBasePath: m,
      sessionTokenFrontendDomain: y,
      sessionExpiredStatusCode: x,
      invalidClaimStatusCode: w,
      autoAddCredentials: _,
      isInIframe: S,
      tokenTransferMethod: f.tokenTransferMethod !== void 0 ? f.tokenTransferMethod : "cookie",
      sessionTokenBackendDomain: C,
      maxRetryAttemptsForSessionRefresh: E,
      preAPIHook: O,
      postAPIHook: k,
      onHandleEvent: A,
      override: P
    };
  }
  rs.validateAndNormaliseInputOrThrowError = c;
  function u(f) {
    return f === void 0 ? {} : f;
  }
  rs.getNormalisedUserContext = u;
  function d(f, h) {
    for (var p = f.split("."), m = 0; m < p.length; m++) {
      var g = p.slice(m).join(".");
      if (g === h || ".".concat(g) === h)
        return !0;
    }
    return !1;
  }
  return rs.matchesDomainOrSubdomain = d, rs;
}
var $h = {}, iS = {}, wL;
function a2() {
  return wL || (wL = 1, function(e) {
    var t = { VITE_APP_NAME: "Your App Name", VITE_API_BASE_URL: "https://frak2-api.functori.com", VITE_AUTH_BASE_URL: "https://frak2-auth.functori.com", VITE_MEDIA_BASE_URL: "https://frak2-api.functori.com", VITE_AUTH_TYPE: "supertokens", VITE_AUTH_STORAGE: "local", VITE_WEBSITE_URL: "https://example.com", VITE_STRIPE_PUBLIC_KEY: "pk_test_your_test_key_here", VITE_DEFAULT_THEME: "light", VITE_ONBOARDING_ENABLED: "true", VITE_ONBOARDING_STEPS: "personal,kyc", VITE_JWT_REFRESH_TOKEN_KEY: "refresh_token", VITE_JWT_ACCESS_TOKEN_KEY: "access_token", VITE_BUILD_MODE: "library", VITE_TENANT_ID: "fraktion", VITE_REQUIRED_ROLE: "admin", VITE_SIGNATURE_PROVIDER: "signaturit", VITE_PAYMENT_PROVIDER: "bridgeapi", VITE_PAYMENT_PROVIDERS: "bridgeapi,mangopay", VITE_KYC_PROVIDER: "dataleon" }, r = ke && ke.__awaiter || function(s, i, o, l) {
      function c(u) {
        return u instanceof o ? u : new o(function(d) {
          d(u);
        });
      }
      return new (o || (o = Promise))(function(u, d) {
        function f(m) {
          try {
            p(l.next(m));
          } catch (g) {
            d(g);
          }
        }
        function h(m) {
          try {
            p(l.throw(m));
          } catch (g) {
            d(g);
          }
        }
        function p(m) {
          m.done ? u(m.value) : c(m.value).then(f, h);
        }
        p((l = l.apply(s, i || [])).next());
      });
    }, n = ke && ke.__generator || function(s, i) {
      var o = {
        label: 0,
        sent: function() {
          if (u[0] & 1) throw u[1];
          return u[1];
        },
        trys: [],
        ops: []
      }, l, c, u, d;
      return d = { next: f(0), throw: f(1), return: f(2) }, typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function f(p) {
        return function(m) {
          return h([p, m]);
        };
      }
      function h(p) {
        if (l) throw new TypeError("Generator is already executing.");
        for (; o; )
          try {
            if (l = 1, c && (u = p[0] & 2 ? c.return : p[0] ? c.throw || ((u = c.return) && u.call(c), 0) : c.next) && !(u = u.call(c, p[1])).done)
              return u;
            switch (c = 0, u && (p = [p[0] & 2, u.value]), p[0]) {
              case 0:
              case 1:
                u = p;
                break;
              case 4:
                return o.label++, { value: p[1], done: !1 };
              case 5:
                o.label++, c = p[1], p = [0];
                continue;
              case 7:
                p = o.ops.pop(), o.trys.pop();
                continue;
              default:
                if (u = o.trys, !(u = u.length > 0 && u[u.length - 1]) && (p[0] === 6 || p[0] === 2)) {
                  o = 0;
                  continue;
                }
                if (p[0] === 3 && (!u || p[1] > u[0] && p[1] < u[3])) {
                  o.label = p[1];
                  break;
                }
                if (p[0] === 6 && o.label < u[1]) {
                  o.label = u[1], u = p;
                  break;
                }
                if (u && o.label < u[2]) {
                  o.label = u[2], o.ops.push(p);
                  break;
                }
                u[2] && o.ops.pop(), o.trys.pop();
                continue;
            }
            p = i.call(s, o);
          } catch (m) {
            p = [6, m], c = 0;
          } finally {
            l = u = 0;
          }
        if (p[0] & 5) throw p[1];
        return { value: p[0] ? p[1] : void 0, done: !0 };
      }
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ProcessState = e.PROCESS_STATE = void 0, function(s) {
      s[s.CALLING_INTERCEPTION_REQUEST = 0] = "CALLING_INTERCEPTION_REQUEST", s[s.CALLING_INTERCEPTION_RESPONSE = 1] = "CALLING_INTERCEPTION_RESPONSE";
    }(e.PROCESS_STATE || (e.PROCESS_STATE = {}));
    var a = (
      /** @class */
      function() {
        function s() {
          var i = this;
          this.history = [], this.addState = function(o) {
            try {
              process !== void 0 && t !== void 0 && t.TEST_MODE === "testing" && i.history.push(o);
            } catch {
            }
          }, this.getEventByLastEventByName = function(o) {
            for (var l = i.history.length - 1; l >= 0; l--)
              if (i.history[l] == o)
                return i.history[l];
          }, this.reset = function() {
            i.history = [];
          }, this.waitForEvent = function(o, l) {
            return l === void 0 && (l = 7e3), r(i, void 0, void 0, function() {
              var c, u = this;
              return n(this, function(d) {
                return c = Date.now(), [
                  2,
                  new Promise(function(f) {
                    var h = u;
                    function p() {
                      var m = h.getEventByLastEventByName(o);
                      m === void 0 ? Date.now() - c > l ? f(void 0) : setTimeout(p, 1e3) : f(m);
                    }
                    p();
                  })
                ];
              });
            });
          };
        }
        return s.getInstance = function() {
          return s.instance == null && (s.instance = new s()), s.instance;
        }, s;
      }()
    );
    e.ProcessState = a;
  }(iS)), iS;
}
var lu = {}, xL;
function s2() {
  return xL || (xL = 1, Object.defineProperty(lu, "__esModule", { value: !0 }), lu.supported_fdi = lu.package_version = void 0, lu.package_version = "20.1.6", lu.supported_fdi = ["1.16", "1.17", "1.18", "1.19", "2.0", "3.0", "3.1", "4.0", "4.1"]), lu;
}
var md = {}, Cx = {}, _L = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, SL = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(Cx, "__esModule", { value: !0 });
Cx.defaultCookieHandlerImplementation = void 0;
var EL = yi;
Cx.defaultCookieHandlerImplementation = {
  getCookie: function() {
    return _L(this, void 0, void 0, function() {
      return SL(this, function(e) {
        return [
          2,
          EL.default.getReferenceOrThrow().windowHandler.getWindowUnsafe().document.cookie
        ];
      });
    });
  },
  setCookie: function(e) {
    return _L(this, void 0, void 0, function() {
      return SL(this, function(t) {
        return EL.default.getReferenceOrThrow().windowHandler.getWindowUnsafe().document.cookie = e, [
          2
          /*return*/
        ];
      });
    });
  }
};
Object.defineProperty(md, "__esModule", { value: !0 });
md.CookieHandlerReference = void 0;
var n5e = Cx, k$ = (
  /** @class */
  function() {
    function e(t) {
      var r = function(n) {
        return n;
      };
      t !== void 0 && (r = t), this.cookieHandler = r(n5e.defaultCookieHandlerImplementation);
    }
    return e.init = function(t) {
      e.instance === void 0 && (e.instance = new e(t));
    }, e.getReferenceOrThrow = function() {
      if (e.instance === void 0)
        throw new Error("SuperTokensCookieHandler must be initialized before calling this method.");
      return e.instance;
    }, e;
  }()
);
md.CookieHandlerReference = k$;
md.default = k$;
var Qd = {}, K0 = {}, q0 = {}, TL;
function a5e() {
  if (TL) return q0;
  TL = 1, Object.defineProperty(q0, "__esModule", { value: !0 });
  var e = (
    /** @class */
    function() {
      function r() {
        var n = this;
        this.locked = /* @__PURE__ */ new Map(), this.addToLocked = function(a, s) {
          var i = n.locked.get(a);
          i === void 0 ? s === void 0 ? n.locked.set(a, []) : n.locked.set(a, [s]) : s !== void 0 && (i.unshift(s), n.locked.set(a, i));
        }, this.isLocked = function(a) {
          return n.locked.has(a);
        }, this.lock = function(a) {
          return new Promise(function(s, i) {
            n.isLocked(a) ? n.addToLocked(a, s) : (n.addToLocked(a), s());
          });
        }, this.unlock = function(a) {
          var s = n.locked.get(a);
          if (s === void 0 || s.length === 0) {
            n.locked.delete(a);
            return;
          }
          var i = s.pop();
          n.locked.set(a, s), i !== void 0 && setTimeout(i, 0);
        };
      }
      return r.getInstance = function() {
        return r.instance === void 0 && (r.instance = new r()), r.instance;
      }, r;
    }()
  );
  function t() {
    return e.getInstance();
  }
  return q0.default = t, q0;
}
var CL;
function s5e() {
  if (CL) return K0;
  CL = 1;
  var e = ke && ke.__awaiter || function(u, d, f, h) {
    return new (f || (f = Promise))(function(p, m) {
      function g(w) {
        try {
          x(h.next(w));
        } catch (_) {
          m(_);
        }
      }
      function y(w) {
        try {
          x(h.throw(w));
        } catch (_) {
          m(_);
        }
      }
      function x(w) {
        w.done ? p(w.value) : new f(function(_) {
          _(w.value);
        }).then(g, y);
      }
      x((h = h.apply(u, d || [])).next());
    });
  }, t = ke && ke.__generator || function(u, d) {
    var f = { label: 0, sent: function() {
      if (m[0] & 1) throw m[1];
      return m[1];
    }, trys: [], ops: [] }, h, p, m, g;
    return g = { next: y(0), throw: y(1), return: y(2) }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
      return this;
    }), g;
    function y(w) {
      return function(_) {
        return x([w, _]);
      };
    }
    function x(w) {
      if (h) throw new TypeError("Generator is already executing.");
      for (; f; ) try {
        if (h = 1, p && (m = w[0] & 2 ? p.return : w[0] ? p.throw || ((m = p.return) && m.call(p), 0) : p.next) && !(m = m.call(p, w[1])).done) return m;
        switch (p = 0, m && (w = [w[0] & 2, m.value]), w[0]) {
          case 0:
          case 1:
            m = w;
            break;
          case 4:
            return f.label++, { value: w[1], done: !1 };
          case 5:
            f.label++, p = w[1], w = [0];
            continue;
          case 7:
            w = f.ops.pop(), f.trys.pop();
            continue;
          default:
            if (m = f.trys, !(m = m.length > 0 && m[m.length - 1]) && (w[0] === 6 || w[0] === 2)) {
              f = 0;
              continue;
            }
            if (w[0] === 3 && (!m || w[1] > m[0] && w[1] < m[3])) {
              f.label = w[1];
              break;
            }
            if (w[0] === 6 && f.label < m[1]) {
              f.label = m[1], m = w;
              break;
            }
            if (m && f.label < m[2]) {
              f.label = m[2], f.ops.push(w);
              break;
            }
            m[2] && f.ops.pop(), f.trys.pop();
            continue;
        }
        w = d.call(u, f);
      } catch (_) {
        w = [6, _], p = 0;
      } finally {
        h = m = 0;
      }
      if (w[0] & 5) throw w[1];
      return { value: w[0] ? w[1] : void 0, done: !0 };
    }
  }, r = ke;
  Object.defineProperty(K0, "__esModule", { value: !0 });
  var n = a5e(), a = "browser-tabs-lock-key", s = {
    key: function(u) {
      return e(r, void 0, void 0, function() {
        return t(this, function(d) {
          throw new Error("Unsupported");
        });
      });
    },
    getItem: function(u) {
      return e(r, void 0, void 0, function() {
        return t(this, function(d) {
          throw new Error("Unsupported");
        });
      });
    },
    clear: function() {
      return e(r, void 0, void 0, function() {
        return t(this, function(u) {
          return [2, window.localStorage.clear()];
        });
      });
    },
    removeItem: function(u) {
      return e(r, void 0, void 0, function() {
        return t(this, function(d) {
          throw new Error("Unsupported");
        });
      });
    },
    setItem: function(u, d) {
      return e(r, void 0, void 0, function() {
        return t(this, function(f) {
          throw new Error("Unsupported");
        });
      });
    },
    keySync: function(u) {
      return window.localStorage.key(u);
    },
    getItemSync: function(u) {
      return window.localStorage.getItem(u);
    },
    clearSync: function() {
      return window.localStorage.clear();
    },
    removeItemSync: function(u) {
      return window.localStorage.removeItem(u);
    },
    setItemSync: function(u, d) {
      return window.localStorage.setItem(u, d);
    }
  };
  function i(u) {
    return new Promise(function(d) {
      return setTimeout(d, u);
    });
  }
  function o(u) {
    for (var d = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", f = "", h = 0; h < u; h++) {
      var p = Math.floor(Math.random() * d.length);
      f += d[p];
    }
    return f;
  }
  function l() {
    return Date.now().toString() + o(15);
  }
  var c = (
    /** @class */
    function() {
      function u(d) {
        this.acquiredIatSet = /* @__PURE__ */ new Set(), this.storageHandler = void 0, this.id = l(), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = d, u.waiters === void 0 && (u.waiters = []);
      }
      return u.prototype.acquireLock = function(d, f) {
        return f === void 0 && (f = 5e3), e(this, void 0, void 0, function() {
          var h, p, m, g, y, x, w, _;
          return t(this, function(S) {
            switch (S.label) {
              case 0:
                h = Date.now() + o(4), p = Date.now() + f, m = a + "-" + d, g = this.storageHandler === void 0 ? s : this.storageHandler, S.label = 1;
              case 1:
                return Date.now() < p ? [4, i(30)] : [3, 8];
              case 2:
                return S.sent(), y = g.getItemSync(m), y !== null ? [3, 5] : (x = this.id + "-" + d + "-" + h, [4, i(Math.floor(Math.random() * 25))]);
              case 3:
                return S.sent(), g.setItemSync(m, JSON.stringify({
                  id: this.id,
                  iat: h,
                  timeoutKey: x,
                  timeAcquired: Date.now(),
                  timeRefreshed: Date.now()
                })), [4, i(30)];
              case 4:
                return S.sent(), w = g.getItemSync(m), w !== null && (_ = JSON.parse(w), _.id === this.id && _.iat === h) ? (this.acquiredIatSet.add(h), this.refreshLockWhileAcquired(m, h), [2, !0]) : [3, 7];
              case 5:
                return u.lockCorrector(this.storageHandler === void 0 ? s : this.storageHandler), [4, this.waitForSomethingToChange(p)];
              case 6:
                S.sent(), S.label = 7;
              case 7:
                return h = Date.now() + o(4), [3, 1];
              case 8:
                return [2, !1];
            }
          });
        });
      }, u.prototype.refreshLockWhileAcquired = function(d, f) {
        return e(this, void 0, void 0, function() {
          var h = this;
          return t(this, function(p) {
            return setTimeout(function() {
              return e(h, void 0, void 0, function() {
                var m, g, y;
                return t(this, function(x) {
                  switch (x.label) {
                    case 0:
                      return [4, n.default().lock(f)];
                    case 1:
                      if (x.sent(), !this.acquiredIatSet.has(f))
                        return n.default().unlock(f), [
                          2
                          /*return*/
                        ];
                      if (m = this.storageHandler === void 0 ? s : this.storageHandler, g = m.getItemSync(d), g !== null)
                        y = JSON.parse(g), y.timeRefreshed = Date.now(), m.setItemSync(d, JSON.stringify(y)), n.default().unlock(f);
                      else
                        return n.default().unlock(f), [
                          2
                          /*return*/
                        ];
                      return this.refreshLockWhileAcquired(d, f), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, 1e3), [
              2
              /*return*/
            ];
          });
        });
      }, u.prototype.waitForSomethingToChange = function(d) {
        return e(this, void 0, void 0, function() {
          return t(this, function(f) {
            switch (f.label) {
              case 0:
                return [4, new Promise(function(h) {
                  var p = !1, m = Date.now(), g = 50, y = !1;
                  function x() {
                    if (y || (window.removeEventListener("storage", x), u.removeFromWaiting(x), clearTimeout(w), y = !0), !p) {
                      p = !0;
                      var _ = g - (Date.now() - m);
                      _ > 0 ? setTimeout(h, _) : h(null);
                    }
                  }
                  window.addEventListener("storage", x), u.addToWaiting(x);
                  var w = setTimeout(x, Math.max(0, d - Date.now()));
                })];
              case 1:
                return f.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u.addToWaiting = function(d) {
        this.removeFromWaiting(d), u.waiters !== void 0 && u.waiters.push(d);
      }, u.removeFromWaiting = function(d) {
        u.waiters !== void 0 && (u.waiters = u.waiters.filter(function(f) {
          return f !== d;
        }));
      }, u.notifyWaiters = function() {
        if (u.waiters !== void 0) {
          var d = u.waiters.slice();
          d.forEach(function(f) {
            return f();
          });
        }
      }, u.prototype.releaseLock = function(d) {
        return e(this, void 0, void 0, function() {
          return t(this, function(f) {
            switch (f.label) {
              case 0:
                return [4, this.releaseLock__private__(d)];
              case 1:
                return [2, f.sent()];
            }
          });
        });
      }, u.prototype.releaseLock__private__ = function(d) {
        return e(this, void 0, void 0, function() {
          var f, h, p, m;
          return t(this, function(g) {
            switch (g.label) {
              case 0:
                return f = this.storageHandler === void 0 ? s : this.storageHandler, h = a + "-" + d, p = f.getItemSync(h), p === null ? [
                  2
                  /*return*/
                ] : (m = JSON.parse(p), m.id !== this.id ? [3, 2] : [4, n.default().lock(m.iat)]);
              case 1:
                g.sent(), this.acquiredIatSet.delete(m.iat), f.removeItemSync(h), n.default().unlock(m.iat), u.notifyWaiters(), g.label = 2;
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u.lockCorrector = function(d) {
        for (var f = Date.now() - 5e3, h = d, p = [], m = 0; ; ) {
          var g = h.keySync(m);
          if (g === null)
            break;
          p.push(g), m++;
        }
        for (var y = !1, x = 0; x < p.length; x++) {
          var w = p[x];
          if (w.includes(a)) {
            var _ = h.getItemSync(w);
            if (_ !== null) {
              var S = JSON.parse(_);
              (S.timeRefreshed === void 0 && S.timeAcquired < f || S.timeRefreshed !== void 0 && S.timeRefreshed < f) && (h.removeItemSync(w), y = !0);
            }
          }
        }
        y && u.notifyWaiters();
      }, u.waiters = void 0, u;
    }()
  );
  return K0.default = c, K0;
}
var kL;
function i2() {
  if (kL) return Qd;
  kL = 1, Object.defineProperty(Qd, "__esModule", { value: !0 }), Qd.LockFactoryReference = void 0;
  var e = s5e(), t = function(n) {
    return function() {
      return Promise.resolve(new e.default(n));
    };
  }, r = (
    /** @class */
    function() {
      function n(a) {
        this.lockFactory = a;
      }
      return n.init = function(a, s) {
        this.instance === void 0 && (this.instance = new n(
          a ?? t(s)
        ));
      }, n.getReferenceOrThrow = function() {
        if (n.instance === void 0)
          throw new Error("SuperTokensLockReference must be initialized before calling this method.");
        return n.instance;
      }, n;
    }()
  );
  return Qd.LockFactoryReference = r, Qd.default = r, Qd;
}
var il = {}, OL;
function Jg() {
  if (OL) return il;
  OL = 1, Object.defineProperty(il, "__esModule", { value: !0 }), il.logDebugMessage = il.disableLogging = il.enableLogging = void 0;
  var e = s2(), t = "com.supertokens", r = !1;
  function n() {
    r = !0;
  }
  il.enableLogging = n;
  function a() {
    r = !1;
  }
  il.disableLogging = a;
  function s(i) {
    r && console.log(
      "".concat(t, ' {t: "').concat((/* @__PURE__ */ new Date()).toISOString(), '", message: "').concat(i, '", supertokens-website-ver: "').concat(e.package_version, '"}')
    );
  }
  return il.logDebugMessage = s, il;
}
var Ko = {}, kx = {};
Object.defineProperty(kx, "__esModule", { value: !0 });
kx.DateProvider = void 0;
var AL = yi, i5e = (
  /** @class */
  function() {
    function e() {
      this.clockSkewInMillis = 0, this.thresholdInSeconds = 7;
    }
    return e.init = function() {
      if (e.instance === void 0) {
        e.instance = new e();
        var t = AL.default.getReferenceOrThrow().windowHandler.localStorage, r = t.getItemSync(e.CLOCK_SKEW_KEY), n = r !== null ? parseInt(r, 10) : 0;
        e.instance.setClientClockSkewInMillis(n);
      }
    }, e.getReferenceOrThrow = function() {
      if (e.instance === void 0)
        throw new Error("DateProvider must be initialized before calling this method.");
      return e.instance;
    }, e.prototype.getThresholdInSeconds = function() {
      return this.thresholdInSeconds;
    }, e.prototype.setThresholdInSeconds = function(t) {
      this.thresholdInSeconds = t;
    }, e.prototype.setClientClockSkewInMillis = function(t) {
      this.clockSkewInMillis = Math.abs(t) >= this.thresholdInSeconds * 1e3 ? t : 0;
      var r = AL.default.getReferenceOrThrow().windowHandler.localStorage;
      r.setItemSync(e.CLOCK_SKEW_KEY, String(t));
    }, e.prototype.getClientClockSkewInMillis = function() {
      return this.clockSkewInMillis;
    }, e.prototype.now = function() {
      return Date.now() + this.getClientClockSkewInMillis();
    }, e.CLOCK_SKEW_KEY = "__st_clockSkewInMillis", e;
  }()
);
kx.DateProvider = i5e;
Object.defineProperty(Ko, "__esModule", { value: !0 });
Ko.DateProviderReference = void 0;
var PL = kx, O$ = (
  /** @class */
  function() {
    function e(t) {
      t !== void 0 ? this.dateProvider = t() : (PL.DateProvider.init(), this.dateProvider = PL.DateProvider.getReferenceOrThrow());
    }
    return e.init = function(t) {
      e.instance === void 0 && (e.instance = new e(t));
    }, e.getReferenceOrThrow = function() {
      if (e.instance === void 0)
        throw new Error("SuperTokensDateProvider must be initialized before calling this method.");
      return e.instance;
    }, e;
  }()
);
Ko.DateProviderReference = O$;
Ko.default = O$;
(function(e) {
  var t = ke && ke.__assign || function() {
    return t = Object.assign || function(L) {
      for (var j, K = 1, J = arguments.length; K < J; K++) {
        j = arguments[K];
        for (var re in j) Object.prototype.hasOwnProperty.call(j, re) && (L[re] = j[re]);
      }
      return L;
    }, t.apply(this, arguments);
  }, r = ke && ke.__awaiter || function(L, j, K, J) {
    function re(le) {
      return le instanceof K ? le : new K(function(pe) {
        pe(le);
      });
    }
    return new (K || (K = Promise))(function(le, pe) {
      function me(he) {
        try {
          ee(J.next(he));
        } catch (Ee) {
          pe(Ee);
        }
      }
      function Oe(he) {
        try {
          ee(J.throw(he));
        } catch (Ee) {
          pe(Ee);
        }
      }
      function ee(he) {
        he.done ? le(he.value) : re(he.value).then(me, Oe);
      }
      ee((J = J.apply(L, j || [])).next());
    });
  }, n = ke && ke.__generator || function(L, j) {
    var K = {
      label: 0,
      sent: function() {
        if (le[0] & 1) throw le[1];
        return le[1];
      },
      trys: [],
      ops: []
    }, J, re, le, pe;
    return pe = { next: me(0), throw: me(1), return: me(2) }, typeof Symbol == "function" && (pe[Symbol.iterator] = function() {
      return this;
    }), pe;
    function me(ee) {
      return function(he) {
        return Oe([ee, he]);
      };
    }
    function Oe(ee) {
      if (J) throw new TypeError("Generator is already executing.");
      for (; K; )
        try {
          if (J = 1, re && (le = ee[0] & 2 ? re.return : ee[0] ? re.throw || ((le = re.return) && le.call(re), 0) : re.next) && !(le = le.call(re, ee[1])).done)
            return le;
          switch (re = 0, le && (ee = [ee[0] & 2, le.value]), ee[0]) {
            case 0:
            case 1:
              le = ee;
              break;
            case 4:
              return K.label++, { value: ee[1], done: !1 };
            case 5:
              K.label++, re = ee[1], ee = [0];
              continue;
            case 7:
              ee = K.ops.pop(), K.trys.pop();
              continue;
            default:
              if (le = K.trys, !(le = le.length > 0 && le[le.length - 1]) && (ee[0] === 6 || ee[0] === 2)) {
                K = 0;
                continue;
              }
              if (ee[0] === 3 && (!le || ee[1] > le[0] && ee[1] < le[3])) {
                K.label = ee[1];
                break;
              }
              if (ee[0] === 6 && K.label < le[1]) {
                K.label = le[1], le = ee;
                break;
              }
              if (le && K.label < le[2]) {
                K.label = le[2], K.ops.push(ee);
                break;
              }
              le[2] && K.ops.pop(), K.trys.pop();
              continue;
          }
          ee = j.call(L, K);
        } catch (he) {
          ee = [6, he], re = 0;
        } finally {
          J = le = 0;
        }
      if (ee[0] & 5) throw ee[1];
      return { value: ee[0] ? ee[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.updateClockSkewUsingFrontToken = e.fireSessionUpdateEventsIfNecessary = e.setFrontToken = e.getFrontToken = e.setAntiCSRF = e.saveLastAccessTokenUpdate = e.getTokenForHeaderAuth = e.setToken = e.getStorageNameForToken = e.getLocalSessionState = e.onInvalidClaimResponse = e.onTokenUpdate = e.onUnauthorisedResponse = e.FrontToken = e.AntiCsrfToken = void 0;
  var a = a2(), s = s2(), i = md, o = yi, l = i2(), c = Jg(), u = Ko, d = (
    /** @class */
    function() {
      function L() {
      }
      return L.getToken = function(j) {
        return r(this, void 0, void 0, function() {
          var K;
          return n(this, function(J) {
            switch (J.label) {
              case 0:
                return (0, c.logDebugMessage)("AntiCsrfToken.getToken: called"), j === void 0 ? (L.tokenInfo = void 0, (0, c.logDebugMessage)("AntiCsrfToken.getToken: returning undefined"), [2, void 0]) : L.tokenInfo !== void 0 ? [3, 2] : [4, Y()];
              case 1:
                return K = J.sent(), K === null ? ((0, c.logDebugMessage)("AntiCsrfToken.getToken: returning undefined"), [2, void 0]) : (L.tokenInfo = {
                  antiCsrf: K,
                  associatedAccessTokenUpdate: j
                }, [3, 4]);
              case 2:
                return L.tokenInfo.associatedAccessTokenUpdate === j ? [3, 4] : (L.tokenInfo = void 0, [4, L.getToken(j)]);
              case 3:
                return [2, J.sent()];
              case 4:
                return (0, c.logDebugMessage)("AntiCsrfToken.getToken: returning: " + L.tokenInfo.antiCsrf), [2, L.tokenInfo.antiCsrf];
            }
          });
        });
      }, L.removeToken = function() {
        return r(this, void 0, void 0, function() {
          return n(this, function(j) {
            switch (j.label) {
              case 0:
                return (0, c.logDebugMessage)("AntiCsrfToken.removeToken: called"), L.tokenInfo = void 0, [4, te(void 0)];
              case 1:
                return j.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, L.setItem = function(j, K) {
        return r(this, void 0, void 0, function() {
          return n(this, function(J) {
            switch (J.label) {
              case 0:
                return j === void 0 ? (L.tokenInfo = void 0, [
                  2
                  /*return*/
                ]) : ((0, c.logDebugMessage)("AntiCsrfToken.setItem: called"), [4, te(K)]);
              case 1:
                return J.sent(), L.tokenInfo = {
                  antiCsrf: K,
                  associatedAccessTokenUpdate: j
                }, [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, L;
    }()
  );
  e.AntiCsrfToken = d;
  var f = (
    /** @class */
    function() {
      function L() {
      }
      return L.getTokenInfo = function() {
        return r(this, void 0, void 0, function() {
          var j, K;
          return n(this, function(J) {
            switch (J.label) {
              case 0:
                return (0, c.logDebugMessage)("FrontToken.getTokenInfo: called"), [4, ue()];
              case 1:
                return j = J.sent(), j !== null ? [3, 5] : [4, C(!1)];
              case 2:
                return J.sent().status !== "EXISTS" ? [3, 4] : [
                  4,
                  new Promise(function(re) {
                    L.waiters.push(re);
                  })
                ];
              case 3:
                return J.sent(), [2, L.getTokenInfo()];
              case 4:
                return [2, void 0];
              case 5:
                return K = ne(j), (0, c.logDebugMessage)("FrontToken.getTokenInfo: returning ate: " + K.ate), (0, c.logDebugMessage)("FrontToken.getTokenInfo: returning uid: " + K.uid), (0, c.logDebugMessage)("FrontToken.getTokenInfo: returning up: " + K.up), [2, K];
            }
          });
        });
      }, L.removeToken = function() {
        return r(this, void 0, void 0, function() {
          return n(this, function(j) {
            switch (j.label) {
              case 0:
                return (0, c.logDebugMessage)("FrontToken.removeToken: called"), [4, q(void 0)];
              case 1:
                return j.sent(), [4, O("access", "")];
              case 2:
                return j.sent(), [4, O("refresh", "")];
              case 3:
                return j.sent(), [4, d.removeToken()];
              case 4:
                return j.sent(), L.waiters.forEach(function(K) {
                  return K(void 0);
                }), L.waiters = [], [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, L.setItem = function(j) {
        return r(this, void 0, void 0, function() {
          return n(this, function(K) {
            switch (K.label) {
              case 0:
                return [4, G()];
              case 1:
                return K.sent(), j === "remove" ? [2, L.removeToken()] : ((0, c.logDebugMessage)("FrontToken.setItem: called"), [4, q(j)]);
              case 2:
                return K.sent(), L.waiters.forEach(function(J) {
                  return J(void 0);
                }), L.waiters = [], [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, L.doesTokenExists = function() {
        return r(this, void 0, void 0, function() {
          var j;
          return n(this, function(K) {
            switch (K.label) {
              case 0:
                return [4, ae()];
              case 1:
                return j = K.sent(), [2, j !== null];
            }
          });
        });
      }, L.waiters = [], L;
    }()
  );
  e.FrontToken = f;
  var h = (
    /** @class */
    function() {
      function L() {
      }
      L.init = function(K, J) {
        (0, c.logDebugMessage)("init: called"), (0, c.logDebugMessage)("init: Input apiBasePath: " + K.apiBasePath), (0, c.logDebugMessage)("init: Input apiDomain: " + K.apiDomain), (0, c.logDebugMessage)("init: Input autoAddCredentials: " + K.autoAddCredentials), (0, c.logDebugMessage)("init: Input sessionTokenBackendDomain: " + K.sessionTokenBackendDomain), (0, c.logDebugMessage)("init: Input isInIframe: " + K.isInIframe), (0, c.logDebugMessage)("init: Input sessionExpiredStatusCode: " + K.sessionExpiredStatusCode), (0, c.logDebugMessage)("init: Input sessionTokenFrontendDomain: " + K.sessionTokenFrontendDomain), (0, c.logDebugMessage)("init: Input tokenTransferMethod: " + K.tokenTransferMethod);
        var re = o.default.getReferenceOrThrow().windowHandler.getWindowUnsafe();
        L.env = re === void 0 || re.fetch === void 0 ? window : re, L.refreshTokenUrl = K.apiDomain + K.apiBasePath + "/session/refresh", L.signOutUrl = K.apiDomain + K.apiBasePath + "/signout", L.rid = "session", L.config = K, L.env.__supertokensOriginalFetch === void 0 && ((0, c.logDebugMessage)("init: __supertokensOriginalFetch is undefined"), L.env.__supertokensOriginalFetch = L.env.fetch.bind(L.env), L.env.__supertokensSessionRecipe = J, L.env.fetch = L.env.__supertokensSessionRecipe.addFetchInterceptorsAndReturnModifiedFetch({
          originalFetch: L.env.__supertokensOriginalFetch,
          userContext: {}
        }), L.env.__supertokensSessionRecipe.addXMLHttpRequestInterceptor({
          userContext: {}
        })), L.recipeImpl = L.env.__supertokensSessionRecipe, L.initCalled = !0;
      };
      var j;
      return j = L, L.initCalled = !1, L.doRequest = function(K, J, re) {
        return r(void 0, void 0, void 0, function() {
          var le, pe, me, Oe, ee, he, Ee, we, Pe, rt, ht, bt, Ge, oe, ve;
          return n(j, function(ye) {
            switch (ye.label) {
              case 0:
                if (!L.initCalled)
                  throw Error("init function not called");
                (0, c.logDebugMessage)("doRequest: start of fetch interception"), le = !1;
                try {
                  pe = void 0, typeof re == "string" ? pe = re : typeof re == "object" && (typeof re.url == "string" ? pe = re.url : typeof re.href == "string" && (pe = re.href)), le = !L.recipeImpl.shouldDoInterceptionBasedOnUrl(
                    pe,
                    L.config.apiDomain,
                    L.config.sessionTokenBackendDomain
                  );
                } catch (Te) {
                  if (Te.message === "Please provide a valid domain name")
                    (0, c.logDebugMessage)(
                      "doRequest: Trying shouldDoInterceptionBasedOnUrl with location.origin"
                    ), le = !L.recipeImpl.shouldDoInterceptionBasedOnUrl(
                      o.default.getReferenceOrThrow().windowHandler.location.getOrigin(),
                      L.config.apiDomain,
                      L.config.sessionTokenBackendDomain
                    );
                  else
                    throw Te;
                }
                return (0, c.logDebugMessage)("doRequest: Value of doNotDoInterception: " + le), le ? ((0, c.logDebugMessage)("doRequest: Returning without interception"), [4, K(J)]) : [3, 2];
              case 1:
                return [2, ye.sent()];
              case 2:
                return me = new Headers(
                  J !== void 0 && J.headers !== void 0 ? J.headers : re.headers
                ), me.has("Authorization") ? [4, A("access")] : [3, 5];
              case 3:
                return Oe = ye.sent(), [4, A("refresh")];
              case 4:
                ee = ye.sent(), Oe !== void 0 && ee !== void 0 && me.get("Authorization") === "Bearer ".concat(Oe) && ((0, c.logDebugMessage)(
                  "doRequest: Removing Authorization from user provided headers because it contains our access token"
                ), me.delete("Authorization")), ye.label = 5;
              case 5:
                (0, c.logDebugMessage)("doRequest: Interception started"), a.ProcessState.getInstance().addState(
                  a.PROCESS_STATE.CALLING_INTERCEPTION_REQUEST
                ), he = 0, Ee = void 0, ye.label = 6;
              case 6:
                return [4, C(!0)];
              case 7:
                return we = ye.sent(), Pe = new Headers(me), rt = t(t({}, J), { headers: Pe }), we.status !== "EXISTS" ? [3, 9] : [4, d.getToken(we.lastAccessTokenUpdate)];
              case 8:
                ht = ye.sent(), ht !== void 0 && ((0, c.logDebugMessage)("doRequest: Adding anti-csrf token to request"), Pe.set("anti-csrf", ht)), ye.label = 9;
              case 9:
                return L.config.autoAddCredentials && ((0, c.logDebugMessage)("doRequest: Adding credentials include"), rt === void 0 ? rt = {
                  credentials: "include"
                } : rt.credentials === void 0 && (rt = t(t({}, rt), {
                  credentials: "include"
                }))), Pe.has("rid") ? (0, c.logDebugMessage)("doRequest: rid header was already there in request") : ((0, c.logDebugMessage)("doRequest: Adding rid header: anti-csrf"), Pe.set("rid", "anti-csrf")), bt = L.config.tokenTransferMethod, (0, c.logDebugMessage)("doRequest: Adding st-auth-mode header: " + bt), Pe.set("st-auth-mode", bt), [4, D(Pe)];
              case 10:
                return ye.sent(), (0, c.logDebugMessage)("doRequest: Making user's http call"), [4, K(rt)];
              case 11:
                return Ge = ye.sent(), (0, c.logDebugMessage)("doRequest: User's http call ended"), [4, N(Ge)];
              case 12:
                if (ye.sent(), U(
                  we.status === "EXISTS",
                  Ge.status,
                  Ge.headers.get("front-token")
                ), Ge.status !== L.config.sessionExpiredStatusCode)
                  return [3, 14];
                if ((0, c.logDebugMessage)("doRequest: Status code is: " + Ge.status), he >= L.config.maxRetryAttemptsForSessionRefresh)
                  throw (0, c.logDebugMessage)(
                    "doRequest: Maximum session refresh attempts reached. sessionRefreshAttempts: ".concat(he, ", maxRetryAttemptsForSessionRefresh: ").concat(L.config.maxRetryAttemptsForSessionRefresh)
                  ), oe = "Received a 401 response from ".concat(
                    re,
                    ". Attempted to refresh the session and retry the request with the updated session tokens "
                  ).concat(
                    L.config.maxRetryAttemptsForSessionRefresh,
                    " times, but each attempt resulted in a 401 error. The maximum session refresh limit has been reached. Please investigate your API. To increase the session refresh attempts, update maxRetryAttemptsForSessionRefresh in the config."
                  ), console.error(oe), new Error(oe);
                return [4, w(we)];
              case 13:
                if (ve = ye.sent(), he++, (0, c.logDebugMessage)("doRequest: sessionRefreshAttempts: " + he), ve.result !== "RETRY") {
                  if ((0, c.logDebugMessage)("doRequest: Not retrying original request"), ve.error !== void 0)
                    if (ve.error instanceof Response)
                      Ee = ve.error;
                    else
                      throw ve.error;
                  else
                    Ee = Ge;
                  return [3, 18];
                }
                return (0, c.logDebugMessage)("doRequest: Retrying original request"), [3, 17];
              case 14:
                return Ge.status !== L.config.invalidClaimStatusCode ? [3, 16] : [4, S(Ge)];
              case 15:
                ye.sent(), ye.label = 16;
              case 16:
                return [2, Ge];
              case 17:
                return [3, 6];
              case 18:
                return [2, Ee];
            }
          });
        });
      }, L.attemptRefreshingSession = function() {
        return r(void 0, void 0, void 0, function() {
          var K, J;
          return n(j, function(re) {
            switch (re.label) {
              case 0:
                if (!L.initCalled)
                  throw Error("init function not called");
                return [4, C(!1)];
              case 1:
                return K = re.sent(), [4, w(K)];
              case 2:
                if (J = re.sent(), J.result === "API_ERROR")
                  throw J.error;
                return [2, J.result === "RETRY"];
            }
          });
        });
      }, L;
    }()
  );
  e.default = h;
  var p = "st-last-access-token-update", m = "st-refresh-token", g = "st-access-token", y = "sAntiCsrf", x = "sFrontToken";
  function w(L) {
    return r(this, void 0, void 0, function() {
      var j, K, J, re, le, pe, me, Oe, ee, he, Ee, we, Pe, rt, ht;
      return n(this, function(bt) {
        switch (bt.label) {
          case 0:
            return [4, l.default.getReferenceOrThrow().lockFactory()];
          case 1:
            j = bt.sent(), bt.label = 2;
          case 2:
            return (0, c.logDebugMessage)("onUnauthorisedResponse: trying to acquire lock"), [4, j.acquireLock("REFRESH_TOKEN_USE", 1e3)];
          case 3:
            if (!bt.sent()) return [3, 21];
            (0, c.logDebugMessage)("onUnauthorisedResponse: lock acquired"), bt.label = 4;
          case 4:
            return bt.trys.push([4, 17, 19, 21]), [4, C(!1)];
          case 5:
            return K = bt.sent(), K.status === "NOT_EXISTS" ? ((0, c.logDebugMessage)(
              "onUnauthorisedResponse: Not refreshing because local session state is NOT_EXISTS"
            ), h.config.onHandleEvent({
              action: "UNAUTHORISED",
              sessionExpiredOrRevoked: !1,
              userContext: {}
            }), [2, { result: "SESSION_EXPIRED" }]) : (J = K.status === "EXISTS", re = L.status === "EXISTS", le = K.status !== L.status, pe = "lastAccessTokenUpdate" in K && "lastAccessTokenUpdate" in L && K.lastAccessTokenUpdate !== L.lastAccessTokenUpdate, le && J ? ((0, c.logDebugMessage)(
              "onUnauthorisedResponse: Retrying early because session status has changed and postLockLSS.status is EXISTS"
            ), [2, { result: "RETRY" }]) : J && re && pe ? ((0, c.logDebugMessage)(
              "onUnauthorisedResponse: Retrying early because pre and post lastAccessTokenUpdate don't match"
            ), [2, { result: "RETRY" }]) : (me = new Headers(), L.status !== "EXISTS" ? [3, 7] : [4, d.getToken(L.lastAccessTokenUpdate)]));
          case 6:
            Oe = bt.sent(), Oe !== void 0 && ((0, c.logDebugMessage)(
              "onUnauthorisedResponse: Adding anti-csrf token to refresh API call"
            ), me.set("anti-csrf", Oe)), bt.label = 7;
          case 7:
            return (0, c.logDebugMessage)("onUnauthorisedResponse: Adding rid and fdi-versions to refresh call header"), me.set("rid", h.rid), me.set("fdi-version", s.supported_fdi.join(",")), ee = h.config.tokenTransferMethod, (0, c.logDebugMessage)("onUnauthorisedResponse: Adding st-auth-mode header: " + ee), me.set("st-auth-mode", ee), [4, D(me, !0)];
          case 8:
            return bt.sent(), (0, c.logDebugMessage)("onUnauthorisedResponse: Calling refresh pre API hook"), [
              4,
              h.config.preAPIHook({
                action: "REFRESH_SESSION",
                requestInit: {
                  method: "post",
                  credentials: "include",
                  headers: me
                },
                url: h.refreshTokenUrl,
                userContext: {}
              })
            ];
          case 9:
            return he = bt.sent(), (0, c.logDebugMessage)("onUnauthorisedResponse: Making refresh call"), [
              4,
              h.env.__supertokensOriginalFetch(he.url, he.requestInit)
            ];
          case 10:
            return Ee = bt.sent(), (0, c.logDebugMessage)("onUnauthorisedResponse: Refresh call ended"), [4, N(Ee)];
          case 11:
            return bt.sent(), (0, c.logDebugMessage)("onUnauthorisedResponse: Refresh status code is: " + Ee.status), we = Ee.status === h.config.sessionExpiredStatusCode, Ee.headers.get("front-token") !== null ? [3, 14] : we ? [4, f.setItem("remove")] : [3, 13];
          case 12:
            return bt.sent(), [3, 14];
          case 13:
            if (Ee.status === 200)
              throw Pe = "The 'front-token' header is missing from a successful refresh-session response. The most likely causes are proxy settings (e.g.: 'front-token' missing from 'access-control-expose-headers' or a proxy stripping this header). Please investigate your API.", console.error(Pe), new Error(Pe);
            bt.label = 14;
          case 14:
            if (U(
              L.status === "EXISTS",
              Ee.status,
              we && Ee.headers.get("front-token") === null ? "remove" : Ee.headers.get("front-token")
            ), Ee.status >= 300)
              throw Ee;
            return [
              4,
              h.config.postAPIHook({
                action: "REFRESH_SESSION",
                fetchResponse: Ee.clone(),
                requestInit: he.requestInit,
                url: he.url,
                userContext: {}
              })
            ];
          case 15:
            return bt.sent(), [4, C(!1)];
          case 16:
            return bt.sent().status === "NOT_EXISTS" ? ((0, c.logDebugMessage)(
              "onUnauthorisedResponse: local session doesn't exist, so returning session expired"
            ), [2, { result: "SESSION_EXPIRED" }]) : (h.config.onHandleEvent({
              action: "REFRESH_SESSION",
              userContext: {}
            }), (0, c.logDebugMessage)("onUnauthorisedResponse: Sending RETRY signal"), [2, { result: "RETRY" }]);
          case 17:
            return rt = bt.sent(), [4, C(!1)];
          case 18:
            return bt.sent().status === "NOT_EXISTS" ? ((0, c.logDebugMessage)(
              "onUnauthorisedResponse: local session doesn't exist, so returning session expired"
            ), [2, { result: "SESSION_EXPIRED", error: rt }]) : ((0, c.logDebugMessage)("onUnauthorisedResponse: sending API_ERROR"), [2, { result: "API_ERROR", error: rt }]);
          case 19:
            return [4, j.releaseLock("REFRESH_TOKEN_USE")];
          case 20:
            return bt.sent(), (0, c.logDebugMessage)("onUnauthorisedResponse: Released lock"), [
              7
              /*endfinally*/
            ];
          case 21:
            return [4, C(!1)];
          case 22:
            return ht = bt.sent(), ht.status === "NOT_EXISTS" ? ((0, c.logDebugMessage)(
              "onUnauthorisedResponse: lock acquired failed and local session doesn't exist, so sending SESSION_EXPIRED"
            ), [2, { result: "SESSION_EXPIRED" }]) : ht.status !== L.status || ht.status === "EXISTS" && L.status === "EXISTS" && ht.lastAccessTokenUpdate !== L.lastAccessTokenUpdate ? ((0, c.logDebugMessage)(
              "onUnauthorisedResponse: lock acquired failed and retrying early because pre and post lastAccessTokenUpdate don't match"
            ), [2, { result: "RETRY" }]) : [3, 2];
          case 23:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  e.onUnauthorisedResponse = w;
  function _() {
    (0, c.logDebugMessage)("onTokenUpdate: firing ACCESS_TOKEN_PAYLOAD_UPDATED event"), h.config.onHandleEvent({
      action: "ACCESS_TOKEN_PAYLOAD_UPDATED",
      userContext: {}
    });
  }
  e.onTokenUpdate = _;
  function S(L) {
    return r(this, void 0, void 0, function() {
      var j;
      return n(this, function(K) {
        switch (K.label) {
          case 0:
            return K.trys.push([0, 2, , 3]), [
              4,
              h.recipeImpl.getInvalidClaimsFromResponse({
                response: L,
                userContext: {}
              })
            ];
          case 1:
            return j = K.sent(), j && h.config.onHandleEvent({
              action: "API_INVALID_CLAIM",
              claimValidationErrors: j,
              userContext: {}
            }), [3, 3];
          case 2:
            return K.sent(), [3, 3];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  e.onInvalidClaimResponse = S;
  function C(L) {
    return r(this, void 0, void 0, function() {
      var j, K, J, re, le, pe, me;
      return n(this, function(Oe) {
        switch (Oe.label) {
          case 0:
            return (0, c.logDebugMessage)("getLocalSessionState: called"), [4, P(p)];
          case 1:
            return j = Oe.sent(), [4, f.doesTokenExists()];
          case 2:
            return K = Oe.sent(), K && j !== void 0 ? ((0, c.logDebugMessage)("getLocalSessionState: returning EXISTS since both frontToken and lastAccessTokenUpdate exists"), [2, { status: "EXISTS", lastAccessTokenUpdate: j }]) : [3, 3];
          case 3:
            return j ? ((0, c.logDebugMessage)("getLocalSessionState: returning NOT_EXISTS since frontToken was cleared but lastAccessTokenUpdate exists"), [2, { status: "NOT_EXISTS" }]) : [3, 4];
          case 4:
            return J = {
              status: "MAY_EXIST"
            }, L ? ((0, c.logDebugMessage)("getLocalSessionState: trying to refresh"), [4, w(J)]) : [3, 8];
          case 5:
            return re = Oe.sent(), re.result !== "RETRY" ? ((0, c.logDebugMessage)(
              "getLocalSessionState: return NOT_EXISTS in case error from backend" + re.result
            ), [
              2,
              {
                status: "NOT_EXISTS"
              }
            ]) : [4, P(p)];
          case 6:
            return le = Oe.sent(), [4, f.doesTokenExists()];
          case 7:
            if (pe = Oe.sent(), !pe || le === void 0)
              throw me = "Failed to retrieve local session state from cookies after a successful session refresh. This indicates a configuration error or that the browser is preventing cookie writes.", console.error(me), new Error(me);
            return (0, c.logDebugMessage)("getLocalSessionState: returning EXISTS since both frontToken and lastAccessTokenUpdate exists post refresh"), [2, { status: "EXISTS", lastAccessTokenUpdate: le }];
          case 8:
            return (0, c.logDebugMessage)("getLocalSessionState: returning: " + J.status), [2, J];
        }
      });
    });
  }
  e.getLocalSessionState = C;
  function E(L) {
    switch (L) {
      case "access":
        return g;
      case "refresh":
        return m;
    }
  }
  e.getStorageNameForToken = E;
  function O(L, j) {
    var K = E(L);
    return j !== "" ? ((0, c.logDebugMessage)("setToken: saved ".concat(L, " token into cookies")), k(K, j, Date.now() + 31536e5)) : ((0, c.logDebugMessage)("setToken: cleared ".concat(L, " token from cookies")), k(K, j, 0));
  }
  e.setToken = O;
  function k(L, j, K) {
    var J = "Fri, 31 Dec 9999 23:59:59 GMT";
    K !== Number.MAX_SAFE_INTEGER && (J = new Date(K).toUTCString());
    var re = h.config.sessionTokenFrontendDomain;
    return re === "localhost" || re === o.default.getReferenceOrThrow().windowHandler.location.getHostName() ? i.default.getReferenceOrThrow().cookieHandler.setCookie(
      "".concat(L, "=").concat(j, ";expires=").concat(J, ";path=/;samesite=").concat(h.config.isInIframe ? "none;secure" : "lax")
    ) : i.default.getReferenceOrThrow().cookieHandler.setCookie(
      "".concat(L, "=").concat(j, ";expires=").concat(J, ";domain=").concat(re, ";path=/;samesite=").concat(h.config.isInIframe ? "none;secure" : "lax")
    );
  }
  function A(L) {
    return r(this, void 0, void 0, function() {
      var j;
      return n(this, function(K) {
        return j = E(L), [2, P(j)];
      });
    });
  }
  e.getTokenForHeaderAuth = A;
  function P(L) {
    return r(this, void 0, void 0, function() {
      var j, K, J, re;
      return n(this, function(le) {
        switch (le.label) {
          case 0:
            return K = "; ", [4, i.default.getReferenceOrThrow().cookieHandler.getCookie()];
          case 1:
            return j = K + le.sent(), J = j.split("; " + L + "="), J.length >= 2 && (re = J.pop(), re !== void 0) ? [2, re.split(";").shift()] : [2, void 0];
        }
      });
    });
  }
  function D(L, j) {
    return j === void 0 && (j = !1), r(this, void 0, void 0, function() {
      var K, J;
      return n(this, function(re) {
        switch (re.label) {
          case 0:
            return (0, c.logDebugMessage)("setTokenHeaders: adding existing tokens as header"), [4, A("access")];
          case 1:
            return K = re.sent(), [4, A("refresh")];
          case 2:
            return J = re.sent(), (j || K !== void 0) && J !== void 0 ? L.has("Authorization") ? (0, c.logDebugMessage)(
              "setAuthorizationHeaderIfRequired: Authorization header defined by the user, not adding"
            ) : ((0, c.logDebugMessage)(
              "setAuthorizationHeaderIfRequired: added authorization header"
            ), L.set(
              "Authorization",
              "Bearer ".concat(j ? J : K)
            )) : (0, c.logDebugMessage)(
              "setAuthorizationHeaderIfRequired: token for header based auth not found"
            ), [
              2
              /*return*/
            ];
        }
      });
    });
  }
  function N(L) {
    return r(this, void 0, void 0, function() {
      var j, K, J, re, le;
      return n(this, function(pe) {
        switch (pe.label) {
          case 0:
            return (0, c.logDebugMessage)("saveTokensFromHeaders: Saving updated tokens from the response headers"), j = L.headers.get("st-refresh-token"), j === null ? [3, 2] : ((0, c.logDebugMessage)("saveTokensFromHeaders: saving new refresh token"), [4, O("refresh", j)]);
          case 1:
            pe.sent(), pe.label = 2;
          case 2:
            return K = L.headers.get("st-access-token"), K === null ? [3, 4] : ((0, c.logDebugMessage)("saveTokensFromHeaders: saving new access token"), [4, O("access", K)]);
          case 3:
            pe.sent(), pe.label = 4;
          case 4:
            return J = L.headers.get("front-token"), J === null ? [3, 6] : ((0, c.logDebugMessage)("saveTokensFromHeaders: Setting sFrontToken: " + J), [4, f.setItem(J)]);
          case 5:
            pe.sent(), (0, e.updateClockSkewUsingFrontToken)({ frontToken: J, responseHeaders: L.headers }), pe.label = 6;
          case 6:
            return re = L.headers.get("anti-csrf"), re === null ? [3, 9] : [4, C(!1)];
          case 7:
            return le = pe.sent(), le.status !== "EXISTS" ? [3, 9] : ((0, c.logDebugMessage)("saveTokensFromHeaders: Setting anti-csrf token"), [4, d.setItem(le.lastAccessTokenUpdate, re)]);
          case 8:
            pe.sent(), pe.label = 9;
          case 9:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  var z = void 0;
  function G() {
    return r(this, void 0, void 0, function() {
      var L;
      return n(this, function(j) {
        switch (j.label) {
          case 0:
            return (0, c.logDebugMessage)("saveLastAccessTokenUpdate: called"), L = Date.now().toString(), (0, c.logDebugMessage)("saveLastAccessTokenUpdate: setting " + L), [4, k(p, L, Number.MAX_SAFE_INTEGER)];
          case 1:
            return j.sent(), z !== void 0 ? [3, 3] : [4, P(p)];
          case 2:
            z = j.sent() === L, j.label = 3;
          case 3:
            return z === !1 && console.warn(
              "Saving to cookies was not successful, this indicates a configuration error or the browser preventing us from writing the cookies."
            ), [4, k("sIRTFrontend", "", 0)];
          case 4:
            return j.sent(), [
              2
              /*return*/
            ];
        }
      });
    });
  }
  e.saveLastAccessTokenUpdate = G;
  function Y() {
    return r(this, void 0, void 0, function() {
      function L() {
        return r(this, void 0, void 0, function() {
          var K, J, re, le, pe;
          return n(this, function(me) {
            switch (me.label) {
              case 0:
                return J = "; ", [
                  4,
                  i.default.getReferenceOrThrow().cookieHandler.getCookie()
                ];
              case 1:
                return K = J + me.sent(), re = K.split("; " + y + "="), re.length >= 2 && (le = re.pop(), le !== void 0) ? (pe = le.split(";").shift(), pe === void 0 ? [2, null] : [2, pe]) : [2, null];
            }
          });
        });
      }
      var j;
      return n(this, function(K) {
        switch (K.label) {
          case 0:
            return (0, c.logDebugMessage)("getAntiCSRFToken: called"), [4, C(!0)];
          case 1:
            return K.sent().status !== "EXISTS" ? ((0, c.logDebugMessage)(
              "getAntiCSRFToken: Returning because local session state != EXISTS"
            ), [2, null]) : [4, L()];
          case 2:
            return j = K.sent(), (0, c.logDebugMessage)("getAntiCSRFToken: returning: " + j), [2, j];
        }
      });
    });
  }
  function te(L) {
    return r(this, void 0, void 0, function() {
      return n(this, function(j) {
        switch (j.label) {
          case 0:
            return (0, c.logDebugMessage)("setAntiCSRF: called: " + L), L === void 0 ? [3, 2] : [4, k(y, L, Number.MAX_SAFE_INTEGER)];
          case 1:
            return j.sent(), [3, 4];
          case 2:
            return [4, k(y, "", 0)];
          case 3:
            j.sent(), j.label = 4;
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  e.setAntiCSRF = te;
  function ae() {
    return r(this, void 0, void 0, function() {
      var L;
      return n(this, function(j) {
        switch (j.label) {
          case 0:
            return (0, c.logDebugMessage)("getFrontTokenFromCookie: called"), [4, P(x)];
          case 1:
            return L = j.sent(), [2, L === void 0 ? null : L];
        }
      });
    });
  }
  function ne(L) {
    return JSON.parse(decodeURIComponent(escape(atob(L))));
  }
  function ue() {
    return r(this, void 0, void 0, function() {
      var L;
      return n(this, function(j) {
        switch (j.label) {
          case 0:
            return (0, c.logDebugMessage)("getFrontToken: called"), [4, C(!0)];
          case 1:
            return j.sent().status !== "EXISTS" ? ((0, c.logDebugMessage)("getFrontToken: Returning because sIRTFrontend != EXISTS"), [2, null]) : [4, ae()];
          case 2:
            return L = j.sent(), (0, c.logDebugMessage)("getFrontToken: returning: " + L), [2, L];
        }
      });
    });
  }
  e.getFrontToken = ue;
  function q(L) {
    return r(this, void 0, void 0, function() {
      var j, K, J;
      return n(this, function(re) {
        switch (re.label) {
          case 0:
            return (0, c.logDebugMessage)("setFrontToken: called"), [4, ae()];
          case 1:
            return j = re.sent(), j !== null && L !== void 0 && (K = ne(j).up, J = ne(L).up, JSON.stringify(K) !== JSON.stringify(J) && _()), L !== void 0 ? [3, 3] : [4, k(x, "", 0)];
          case 2:
            return re.sent(), [3, 5];
          case 3:
            return [4, k(x, L, Number.MAX_SAFE_INTEGER)];
          case 4:
            re.sent(), re.label = 5;
          case 5:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  e.setFrontToken = q;
  function U(L, j, K) {
    if (K == null) {
      (0, c.logDebugMessage)(
        "fireSessionUpdateEventsIfNecessary returning early because the front token was not updated"
      );
      return;
    }
    var J = K !== "remove";
    (0, c.logDebugMessage)(
      "fireSessionUpdateEventsIfNecessary wasLoggedIn: ".concat(L, " frontTokenExistsAfter: ").concat(J, " status: ").concat(j)
    ), L ? J || (j === h.config.sessionExpiredStatusCode ? ((0, c.logDebugMessage)("onUnauthorisedResponse: firing UNAUTHORISED event"), h.config.onHandleEvent({
      action: "UNAUTHORISED",
      sessionExpiredOrRevoked: !0,
      userContext: {}
    })) : ((0, c.logDebugMessage)("onUnauthorisedResponse: firing SIGN_OUT event"), h.config.onHandleEvent({
      action: "SIGN_OUT",
      userContext: {}
    }))) : J && ((0, c.logDebugMessage)("onUnauthorisedResponse: firing SESSION_CREATED event"), h.config.onHandleEvent({
      action: "SESSION_CREATED",
      userContext: {}
    }));
  }
  e.fireSessionUpdateEventsIfNecessary = U;
  var Q = function(L) {
    var j = L.frontToken, K = L.responseHeaders;
    if ((0, c.logDebugMessage)("updateClockSkewUsingFrontToken: frontToken: " + j), j == null || j === "remove") {
      (0, c.logDebugMessage)(
        "updateClockSkewUsingFrontToken: the access token payload wasn't updated or is being removed, skipping clock skew update"
      );
      return;
    }
    var J = ne(j), re = h.recipeImpl.calculateClockSkewInMillis({
      accessTokenPayload: J.up,
      responseHeaders: K
    });
    u.default.getReferenceOrThrow().dateProvider.setClientClockSkewInMillis(re), (0, c.logDebugMessage)("updateClockSkewUsingFrontToken: Client clock synchronized successfully");
  };
  e.updateClockSkewUsingFrontToken = Q;
})($h);
var gd = {};
Object.defineProperty(gd, "__esModule", { value: !0 });
gd.SessionClaimValidatorStore = void 0;
var A$ = (
  /** @class */
  function() {
    function e() {
    }
    return e.claimValidatorsAddedByOtherRecipes = [], e.addClaimValidatorFromOtherRecipe = function(t) {
      e.claimValidatorsAddedByOtherRecipes.push(t);
    }, e.getClaimValidatorsAddedByOtherRecipes = function() {
      return e.claimValidatorsAddedByOtherRecipes;
    }, e;
  }()
);
gd.SessionClaimValidatorStore = A$;
gd.default = A$;
Object.defineProperty(Tx, "__esModule", { value: !0 });
Tx.getGlobalClaimValidators = void 0;
var o5e = n2(), l5e = $h, c5e = gd;
function u5e(e, t) {
  var r = (0, o5e.getNormalisedUserContext)(t), n = c5e.default.getClaimValidatorsAddedByOtherRecipes(), a = l5e.default.recipeImpl.getGlobalClaimValidators({
    claimValidatorsAddedByOtherRecipes: n,
    userContext: r
  }), s = e !== void 0 ? e(a, r) : a;
  return s;
}
Tx.getGlobalClaimValidators = u5e;
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(Tx);
})(C$);
var d5e = { VITE_APP_NAME: "Your App Name", VITE_API_BASE_URL: "https://frak2-api.functori.com", VITE_AUTH_BASE_URL: "https://frak2-auth.functori.com", VITE_MEDIA_BASE_URL: "https://frak2-api.functori.com", VITE_AUTH_TYPE: "supertokens", VITE_AUTH_STORAGE: "local", VITE_WEBSITE_URL: "https://example.com", VITE_STRIPE_PUBLIC_KEY: "pk_test_your_test_key_here", VITE_DEFAULT_THEME: "light", VITE_ONBOARDING_ENABLED: "true", VITE_ONBOARDING_STEPS: "personal,kyc", VITE_JWT_REFRESH_TOKEN_KEY: "refresh_token", VITE_JWT_ACCESS_TOKEN_KEY: "access_token", VITE_BUILD_MODE: "library", VITE_TENANT_ID: "fraktion", VITE_REQUIRED_ROLE: "admin", VITE_SIGNATURE_PROVIDER: "signaturit", VITE_PAYMENT_PROVIDER: "bridgeapi", VITE_PAYMENT_PROVIDERS: "bridgeapi,mangopay", VITE_KYC_PROVIDER: "dataleon" };
Object.defineProperty(ur, "__esModule", { value: !0 });
ur.normaliseUser = ur.normaliseUserResponse = ur.getGlobalClaimValidators = ur.getHashFromLocation = ur.getNormalisedUserContext = ur.checkForSSRErrorAndAppendIfNeeded = ur.getAllQueryParams = ur.getQueryParams = ur.isTest = ur.normaliseInputAppInfoOrThrowError = ur.appendQueryParamsToURL = void 0;
var o2 = _x, P$ = fh, f5e = Ex, Fb = Vh, h5e = C$;
function p5e(e, t) {
  if (t === void 0)
    return e;
  try {
    var r = new URL(e);
    return Object.entries(t).forEach(function(s) {
      var i = s[0], o = s[1];
      r.searchParams.set(i, o);
    }), r.href;
  } catch {
    var n = e.startsWith("/") ? "http:localhost" : "http://localhost/", a = new URL("".concat(n).concat(e));
    return Object.entries(t).forEach(function(i) {
      var o = i[0], l = i[1];
      a.searchParams.set(o, l);
    }), "".concat(a.pathname).concat(a.search);
  }
}
ur.appendQueryParamsToURL = p5e;
function m5e(e, t) {
  return t !== void 0 ? new Fb.default(t) : new Fb.default(e);
}
function g5e(e) {
  if (e === void 0)
    throw new Error("Please provide the appInfo object when calling supertokens.init");
  if (e.apiDomain === void 0)
    throw new Error("Please provide your apiDomain inside the appInfo object when calling supertokens.init");
  if (e.appName === void 0)
    throw new Error("Please provide your appName inside the appInfo object when calling supertokens.init");
  var t = new Fb.default("");
  return e.apiGatewayPath !== void 0 && (t = new Fb.default(e.apiGatewayPath)), {
    appName: e.appName,
    apiDomain: new f5e.default(e.apiDomain),
    apiBasePath: t.appendPath(
      m5e(P$.DEFAULT_API_BASE_PATH, e.apiBasePath)
    )
  };
}
ur.normaliseInputAppInfoOrThrowError = g5e;
function v5e() {
  try {
    return d5e.TEST_MODE === "testing";
  } catch {
    return !1;
  }
}
ur.isTest = v5e;
function y5e(e) {
  var t = new URLSearchParams(
    o2.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getSearch()
  ), r = t.get(e);
  if (r !== null)
    return r;
}
ur.getQueryParams = y5e;
function b5e() {
  return new URLSearchParams(
    o2.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getSearch()
  );
}
ur.getAllQueryParams = b5e;
function w5e(e) {
  return typeof window > "u" && (e = e + P$.SSR_ERROR), e;
}
ur.checkForSSRErrorAndAppendIfNeeded = w5e;
function x5e(e) {
  return e === void 0 ? {} : e;
}
ur.getNormalisedUserContext = x5e;
function _5e() {
  return o2.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getHash().substring(1);
}
ur.getHashFromLocation = _5e;
function S5e(e) {
  var t = e.overrideGlobalClaimValidators, r = e.userContext;
  return (0, h5e.getGlobalClaimValidators)(t, r);
}
ur.getGlobalClaimValidators = S5e;
function E5e(e, t) {
  return "createdNewRecipeUser" in t ? t : {
    createdNewRecipeUser: t.createdNewUser,
    user: R$(e, t.user)
  };
}
ur.normaliseUserResponse = E5e;
function R$(e, t) {
  if ("loginMethods" in t)
    return t;
  var r = t.email !== void 0 ? [t.email] : [], n = t.phoneNumber !== void 0 ? [t.phoneNumber] : [], a = t.thirdParty !== void 0 ? [t.thirdParty] : [];
  return {
    id: t.id,
    emails: r,
    phoneNumbers: n,
    thirdParty: a,
    isPrimaryUser: !1,
    tenantIds: t.tenantIds,
    timeJoined: t.timeJoined,
    loginMethods: [
      {
        recipeId: e,
        recipeUserId: t.id,
        timeJoined: t.timeJoined,
        tenantIds: t.tenantIds,
        email: t.email,
        phoneNumber: t.email
      }
    ]
  };
}
ur.normaliseUser = R$;
var l2 = {}, I$ = {};
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(md);
})(I$);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CookieHandlerReference = void 0;
  var t = I$;
  Object.defineProperty(e, "CookieHandlerReference", {
    enumerable: !0,
    get: function() {
      return t.CookieHandlerReference;
    }
  });
})(l2);
var vd = {};
Object.defineProperty(vd, "__esModule", { value: !0 });
vd.PostSuperTokensInitCallbacks = void 0;
var T5e = (
  /** @class */
  function() {
    function e() {
    }
    return e.addPostInitCallback = function(t) {
      e.postInitCallbacks.push(t);
    }, e.runPostInitCallbacks = function() {
      for (var t = 0, r = e.postInitCallbacks; t < r.length; t++) {
        var n = r[t];
        n();
      }
    }, e.postInitCallbacks = [], e;
  }()
);
vd.PostSuperTokensInitCallbacks = T5e;
var Qc = {}, Ox = {}, yd = {}, Zg = {}, RL = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, IL = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(Zg, "__esModule", { value: !0 });
Zg.normaliseRecipeModuleConfig = void 0;
function C5e(e) {
  var t = this, r = e.preAPIHook;
  r === void 0 && (r = function(a) {
    return RL(t, void 0, void 0, function() {
      return IL(this, function(s) {
        return [2, a];
      });
    });
  });
  var n = e.postAPIHook;
  return n === void 0 && (n = function() {
    return RL(t, void 0, void 0, function() {
      return IL(this, function(a) {
        return [
          2
          /*return*/
        ];
      });
    });
  }), {
    recipeId: e.recipeId,
    appInfo: e.appInfo,
    clientType: e.clientType,
    preAPIHook: r,
    postAPIHook: n
  };
}
Zg.normaliseRecipeModuleConfig = C5e;
Object.defineProperty(yd, "__esModule", { value: !0 });
yd.normaliseAuthRecipe = void 0;
var k5e = Zg;
function O5e(e) {
  return (0, k5e.normaliseRecipeModuleConfig)(e);
}
yd.normaliseAuthRecipe = O5e;
var wm = ke && ke.__assign || function() {
  return wm = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, wm.apply(this, arguments);
};
Object.defineProperty(Ox, "__esModule", { value: !0 });
Ox.normaliseUserInput = void 0;
var A5e = yd;
function P5e(e) {
  var t = wm(
    {
      functions: function(r) {
        return r;
      }
    },
    e.override
  );
  return wm(wm({}, (0, A5e.normaliseAuthRecipe)(e)), { override: t });
}
Ox.normaliseUserInput = P5e;
var qo = {}, Ax = {}, Bb = ke && ke.__assign || function() {
  return Bb = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Bb.apply(this, arguments);
};
Object.defineProperty(Ax, "__esModule", { value: !0 });
Ax.getProxyObject = void 0;
function R5e(e) {
  for (var t = Bb(Bb({}, e), { _call: function(o, l) {
    throw new Error("This function should only be called through the recipe object");
  } }), r = Object.keys(t), n = function(o) {
    o !== "_call" && (t[o] = function() {
      for (var l = [], c = 0; c < arguments.length; c++)
        l[c] = arguments[c];
      return this._call(o, l);
    });
  }, a = 0, s = r; a < s.length; a++) {
    var i = s[a];
    n(i);
  }
  return t;
}
Ax.getProxyObject = R5e;
Object.defineProperty(qo, "__esModule", { value: !0 });
qo.OverrideableBuilder = void 0;
var I5e = Ax, D$ = (
  /** @class */
  function() {
    function e(t) {
      this.layers = [t], this.proxies = [];
    }
    return e.prototype.override = function(t) {
      for (var r = (0, I5e.getProxyObject)(this.layers[0]), n = t(r, this), a = 0, s = Object.keys(this.layers[0]); a < s.length; a++) {
        var i = s[a];
        n[i] === r[i] || i === "_call" ? delete n[i] : n[i] === void 0 && (n[i] = null);
      }
      return this.layers.push(n), this.proxies.push(r), this;
    }, e.prototype.build = function() {
      var t = this;
      if (this.result)
        return this.result;
      this.result = {};
      for (var r = 0, n = this.layers; r < n.length; r++)
        for (var a = n[r], s = 0, i = Object.keys(a); s < i.length; s++) {
          var o = i[s], l = a[o];
          l !== void 0 && (l === null ? this.result[o] = void 0 : typeof l == "function" ? this.result[o] = l.bind(this.result) : this.result[o] = l);
        }
      for (var c = function(f) {
        var h = u.proxies[f];
        h._call = function(p, m) {
          for (var g = f; g >= 0; --g) {
            var y = t.layers[g][p];
            if (y != null)
              return y.bind(t.result).apply(void 0, m);
          }
        };
      }, u = this, d = 0; d < this.proxies.length; ++d)
        c(d);
      return this.result;
    }, e;
  }()
);
qo.OverrideableBuilder = D$;
qo.default = D$;
var ev = {}, bd = {}, hh = {};
Object.defineProperty(hh, "__esModule", { value: !0 });
hh.supported_fdi = hh.package_version = void 0;
hh.package_version = "0.14.0";
hh.supported_fdi = ["3.1", "4.0"];
var c2 = {}, N$ = {}, tv = {}, D5e = ke && ke.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(tv, "__esModule", { value: !0 });
tv.STGeneralError = void 0;
var N5e = (
  /** @class */
  function(e) {
    D5e(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.isSuperTokensGeneralError = !0, n;
    }
    return t.isThisError = function(r) {
      return r.isSuperTokensGeneralError === !0;
    }, t;
  }(Error)
);
tv.STGeneralError = N5e;
(function(e) {
  function t(n) {
    for (var a in n) e.hasOwnProperty(a) || (e[a] = n[a]);
  }
  e.__esModule = !0;
  let r = tv;
  r.default !== void 0 ? t(r) : t({
    default: r,
    ...r
  });
})(N$);
Object.defineProperty(c2, "__esModule", { value: !0 });
var M5e = N$;
c2.default = M5e.STGeneralError;
var vs = ke && ke.__assign || function() {
  return vs = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, vs.apply(this, arguments);
}, ol = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, ll = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(bd, "__esModule", { value: !0 });
var L5e = Vh, j5e = hh, F5e = c2, B5e = (
  /** @class */
  function() {
    function e(r, n) {
      var a = this;
      this.recipeId = r, this.appInfo = n, this.get = function(s, i, o, l, c, u) {
        return ol(a, void 0, void 0, function() {
          var d, f;
          return ll(this, function(h) {
            switch (h.label) {
              case 0:
                return [
                  4,
                  this.fetch(
                    this.getFullUrl(s, i, l),
                    vs({ method: "GET" }, o),
                    c,
                    u
                  )
                ];
              case 1:
                return d = h.sent(), [4, this.getResponseJsonOrThrowGeneralError(d)];
              case 2:
                return f = h.sent(), [
                  2,
                  {
                    jsonBody: f,
                    fetchResponse: d
                  }
                ];
            }
          });
        });
      }, this.post = function(s, i, o, l, c) {
        return ol(a, void 0, void 0, function() {
          var u, d;
          return ll(this, function(f) {
            switch (f.label) {
              case 0:
                if (o.body === void 0)
                  throw new Error("Post request must have a body");
                return [
                  4,
                  this.fetch(
                    this.getFullUrl(s, i),
                    vs({ method: "POST" }, o),
                    l,
                    c
                  )
                ];
              case 1:
                return u = f.sent(), [4, this.getResponseJsonOrThrowGeneralError(u)];
              case 2:
                return d = f.sent(), [
                  2,
                  {
                    jsonBody: d,
                    fetchResponse: u
                  }
                ];
            }
          });
        });
      }, this.delete = function(s, i, o, l, c) {
        return ol(a, void 0, void 0, function() {
          var u, d;
          return ll(this, function(f) {
            switch (f.label) {
              case 0:
                return [
                  4,
                  this.fetch(
                    this.getFullUrl(s, i),
                    vs({ method: "DELETE" }, o),
                    l,
                    c
                  )
                ];
              case 1:
                return u = f.sent(), [4, this.getResponseJsonOrThrowGeneralError(u)];
              case 2:
                return d = f.sent(), [
                  2,
                  {
                    jsonBody: d,
                    fetchResponse: u
                  }
                ];
            }
          });
        });
      }, this.put = function(s, i, o, l, c) {
        return ol(a, void 0, void 0, function() {
          var u, d;
          return ll(this, function(f) {
            switch (f.label) {
              case 0:
                return [
                  4,
                  this.fetch(
                    this.getFullUrl(s, i),
                    vs({ method: "PUT" }, o),
                    l,
                    c
                  )
                ];
              case 1:
                return u = f.sent(), [4, this.getResponseJsonOrThrowGeneralError(u)];
              case 2:
                return d = f.sent(), [
                  2,
                  {
                    jsonBody: d,
                    fetchResponse: u
                  }
                ];
            }
          });
        });
      }, this.fetch = function(s, i, o, l) {
        return ol(a, void 0, void 0, function() {
          var c, u, d, f, h, p;
          return ll(this, function(m) {
            switch (m.label) {
              case 0:
                return i === void 0 ? c = {} : c = i.headers, [
                  4,
                  this.callPreAPIHook({
                    preAPIHook: o,
                    url: s,
                    requestInit: vs(vs({}, i), {
                      headers: vs(vs({}, c), {
                        "fdi-version": j5e.supported_fdi.join(","),
                        "Content-Type": "application/json",
                        rid: this.recipeId
                      })
                    })
                  })
                ];
              case 1:
                return u = m.sent(), d = u.requestInit, f = u.url, [4, fetch(f, d)];
              case 2:
                if (h = m.sent(), h.status >= 300)
                  throw h;
                return l === void 0 ? [3, 4] : (p = h.clone(), [
                  4,
                  l({
                    requestInit: d,
                    url: s,
                    fetchResponse: p
                  })
                ]);
              case 3:
                m.sent(), m.label = 4;
              case 4:
                return [2, h];
            }
          });
        });
      }, this.callPreAPIHook = function(s) {
        return ol(a, void 0, void 0, function() {
          var i;
          return ll(this, function(o) {
            switch (o.label) {
              case 0:
                return s.preAPIHook === void 0 ? [
                  2,
                  {
                    url: s.url,
                    requestInit: s.requestInit
                  }
                ] : [
                  4,
                  s.preAPIHook({
                    url: s.url,
                    requestInit: s.requestInit
                  })
                ];
              case 1:
                return i = o.sent(), [2, i];
            }
          });
        });
      }, this.getFullUrl = function(s, i, o) {
        var l = a.appInfo.apiBasePath.getAsStringDangerous();
        s !== void 0 && s !== "public" && (l = "".concat(l, "/").concat(s));
        var c = new L5e.default(i), u = "".concat(a.appInfo.apiDomain.getAsStringDangerous()).concat(l).concat(c.getAsStringDangerous());
        return o === void 0 ? u : u + "?" + new URLSearchParams(o);
      }, this.getResponseJsonOrThrowGeneralError = function(s) {
        return ol(a, void 0, void 0, function() {
          var i, o;
          return ll(this, function(l) {
            switch (l.label) {
              case 0:
                return [4, s.clone().json()];
              case 1:
                if (i = l.sent(), i.status === "GENERAL_ERROR")
                  throw o = i.message === void 0 ? "No Error Message Provided" : i.message, new F5e.default(o);
                return [2, i];
            }
          });
        });
      };
    }
    var t;
    return t = e, e.preparePreAPIHook = function(r) {
      var n = r.recipePreAPIHook, a = r.action, s = r.options, i = r.userContext;
      return function(o) {
        return ol(void 0, void 0, void 0, function() {
          var l;
          return ll(t, function(c) {
            switch (c.label) {
              case 0:
                return [
                  4,
                  n(
                    vs(vs({}, o), { action: a, userContext: i })
                  )
                ];
              case 1:
                return l = c.sent(), s === void 0 || s.preAPIHook === void 0 ? [2, l] : [
                  2,
                  s.preAPIHook({
                    url: l.url,
                    requestInit: l.requestInit,
                    userContext: i
                  })
                ];
            }
          });
        });
      };
    }, e.preparePostAPIHook = function(r) {
      var n = r.recipePostAPIHook, a = r.action, s = r.userContext;
      return function(i) {
        return ol(void 0, void 0, void 0, function() {
          return ll(t, function(o) {
            switch (o.label) {
              case 0:
                return [
                  4,
                  n(
                    vs(vs({}, i), { userContext: s, action: a })
                  )
                ];
              case 1:
                return o.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
    }, e;
  }()
);
bd.default = B5e;
var U5e = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, V5e = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(ev, "__esModule", { value: !0 });
ev.getRecipeImplementation = void 0;
var oS = bd, $5e = ur;
function M$(e) {
  var t = new oS.default(e.recipeId, e.appInfo);
  return {
    getTenantId: function() {
      var r = (0, $5e.getQueryParams)("tenantId");
      if ((r == null ? void 0 : r.trim()) !== "")
        return r;
    },
    getLoginMethods: function(r) {
      var n = r.tenantId, a = r.options, s = r.userContext;
      return U5e(this, void 0, void 0, function() {
        var i, o, l, c, u;
        return V5e(this, function(d) {
          switch (d.label) {
            case 0:
              return i = {}, e.clientType !== void 0 && (i.clientType = e.clientType), [
                4,
                t.get(
                  n,
                  "/loginmethods",
                  {},
                  i,
                  oS.default.preparePreAPIHook({
                    recipePreAPIHook: e.preAPIHook,
                    action: "GET_LOGIN_METHODS",
                    options: a,
                    userContext: s
                  }),
                  oS.default.preparePostAPIHook({
                    recipePostAPIHook: e.postAPIHook,
                    action: "GET_LOGIN_METHODS",
                    userContext: s
                  })
                )
              ];
            case 1:
              return o = d.sent(), l = o.jsonBody, c = o.fetchResponse, l.firstFactors === void 0 ? (u = [], l.emailPassword.enabled && u.push("emailpassword"), l.thirdParty.enabled && u.push("thirdparty"), l.passwordless.enabled && (u.push("otp-email"), u.push("otp-phone"), u.push("link-email"), u.push("link-phone"))) : u = l.firstFactors, [
                2,
                {
                  status: "OK",
                  thirdParty: {
                    providers: l.thirdParty.providers
                  },
                  firstFactors: u,
                  fetchResponse: c
                }
              ];
          }
        });
      });
    }
  };
}
ev.default = M$;
ev.getRecipeImplementation = M$;
var Hh = {}, Px = {};
Object.defineProperty(Px, "__esModule", { value: !0 });
var H5e = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.config = t;
    }
    return e;
  }()
);
Px.default = H5e;
var Wh = {}, lS = {}, cS = {}, G0 = {}, so = {}, Rp = {}, DL;
function W5e() {
  if (DL) return Rp;
  DL = 1;
  var e = ke && ke.__awaiter || function(a, s, i, o) {
    function l(c) {
      return c instanceof i ? c : new i(function(u) {
        u(c);
      });
    }
    return new (i || (i = Promise))(function(c, u) {
      function d(p) {
        try {
          h(o.next(p));
        } catch (m) {
          u(m);
        }
      }
      function f(p) {
        try {
          h(o.throw(p));
        } catch (m) {
          u(m);
        }
      }
      function h(p) {
        p.done ? c(p.value) : l(p.value).then(d, f);
      }
      h((o = o.apply(a, s || [])).next());
    });
  }, t = ke && ke.__generator || function(a, s) {
    var i = {
      label: 0,
      sent: function() {
        if (c[0] & 1) throw c[1];
        return c[1];
      },
      trys: [],
      ops: []
    }, o, l, c, u;
    return u = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
      return this;
    }), u;
    function d(h) {
      return function(p) {
        return f([h, p]);
      };
    }
    function f(h) {
      if (o) throw new TypeError("Generator is already executing.");
      for (; i; )
        try {
          if (o = 1, l && (c = h[0] & 2 ? l.return : h[0] ? l.throw || ((c = l.return) && c.call(l), 0) : l.next) && !(c = c.call(l, h[1])).done)
            return c;
          switch (l = 0, c && (h = [h[0] & 2, c.value]), h[0]) {
            case 0:
            case 1:
              c = h;
              break;
            case 4:
              return i.label++, { value: h[1], done: !1 };
            case 5:
              i.label++, l = h[1], h = [0];
              continue;
            case 7:
              h = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (c = i.trys, !(c = c.length > 0 && c[c.length - 1]) && (h[0] === 6 || h[0] === 2)) {
                i = 0;
                continue;
              }
              if (h[0] === 3 && (!c || h[1] > c[0] && h[1] < c[3])) {
                i.label = h[1];
                break;
              }
              if (h[0] === 6 && i.label < c[1]) {
                i.label = c[1], c = h;
                break;
              }
              if (c && i.label < c[2]) {
                i.label = c[2], i.ops.push(h);
                break;
              }
              c[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          h = s.call(a, i);
        } catch (p) {
          h = [6, p], l = 0;
        } finally {
          o = c = 0;
        }
      if (h[0] & 5) throw h[1];
      return { value: h[0] ? h[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Rp, "__esModule", { value: !0 }), Rp.createAxiosErrorFromFetchResp = void 0;
  function r(a, s, i, o, l) {
    return a.config = s, i && (a.code = i), a.request = o, a.response = l, a.isAxiosError = !0, a.toJSON = function() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code
      };
    }, a;
  }
  function n(a) {
    return e(this, void 0, void 0, function() {
      var s, i, o, l, c;
      return t(this, function(u) {
        switch (u.label) {
          case 0:
            if (s = {
              url: a.url,
              headers: a.headers
            }, i = "status" in a, !i) return [3, 12];
            if (l = a.headers.get("content-type"), c = void 0, l !== null) return [3, 5];
            u.label = 1;
          case 1:
            return u.trys.push([1, 3, , 4]), [4, a.text()];
          case 2:
            return c = u.sent(), [3, 4];
          case 3:
            return u.sent(), c = "", [3, 4];
          case 4:
            return [3, 11];
          case 5:
            return l.includes("application/json") ? [4, a.json()] : [3, 7];
          case 6:
            return c = u.sent(), [3, 11];
          case 7:
            return l.includes("text/") ? [4, a.text()] : [3, 9];
          case 8:
            return c = u.sent(), [3, 11];
          case 9:
            return [4, a.blob()];
          case 10:
            c = u.sent(), u.label = 11;
          case 11:
            o = {
              data: c,
              status: a.status,
              statusText: a.statusText,
              headers: a.headers,
              config: s,
              request: void 0
            }, u.label = 12;
          case 12:
            return [
              2,
              r(
                i ? new Error("Request failed with status code " + a.status) : a,
                s,
                a.code,
                void 0,
                o
              )
            ];
        }
      });
    });
  }
  return Rp.createAxiosErrorFromFetchResp = n, Rp;
}
var NL;
function z5e() {
  if (NL) return so;
  NL = 1;
  var e = ke && ke.__assign || function() {
    return e = Object.assign || function(x) {
      for (var w, _ = 1, S = arguments.length; _ < S; _++) {
        w = arguments[_];
        for (var C in w) Object.prototype.hasOwnProperty.call(w, C) && (x[C] = w[C]);
      }
      return x;
    }, e.apply(this, arguments);
  }, t = ke && ke.__awaiter || function(x, w, _, S) {
    function C(E) {
      return E instanceof _ ? E : new _(function(O) {
        O(E);
      });
    }
    return new (_ || (_ = Promise))(function(E, O) {
      function k(D) {
        try {
          P(S.next(D));
        } catch (N) {
          O(N);
        }
      }
      function A(D) {
        try {
          P(S.throw(D));
        } catch (N) {
          O(N);
        }
      }
      function P(D) {
        D.done ? E(D.value) : C(D.value).then(k, A);
      }
      P((S = S.apply(x, w || [])).next());
    });
  }, r = ke && ke.__generator || function(x, w) {
    var _ = {
      label: 0,
      sent: function() {
        if (E[0] & 1) throw E[1];
        return E[1];
      },
      trys: [],
      ops: []
    }, S, C, E, O;
    return O = { next: k(0), throw: k(1), return: k(2) }, typeof Symbol == "function" && (O[Symbol.iterator] = function() {
      return this;
    }), O;
    function k(P) {
      return function(D) {
        return A([P, D]);
      };
    }
    function A(P) {
      if (S) throw new TypeError("Generator is already executing.");
      for (; _; )
        try {
          if (S = 1, C && (E = P[0] & 2 ? C.return : P[0] ? C.throw || ((E = C.return) && E.call(C), 0) : C.next) && !(E = E.call(C, P[1])).done)
            return E;
          switch (C = 0, E && (P = [P[0] & 2, E.value]), P[0]) {
            case 0:
            case 1:
              E = P;
              break;
            case 4:
              return _.label++, { value: P[1], done: !1 };
            case 5:
              _.label++, C = P[1], P = [0];
              continue;
            case 7:
              P = _.ops.pop(), _.trys.pop();
              continue;
            default:
              if (E = _.trys, !(E = E.length > 0 && E[E.length - 1]) && (P[0] === 6 || P[0] === 2)) {
                _ = 0;
                continue;
              }
              if (P[0] === 3 && (!E || P[1] > E[0] && P[1] < E[3])) {
                _.label = P[1];
                break;
              }
              if (P[0] === 6 && _.label < E[1]) {
                _.label = E[1], E = P;
                break;
              }
              if (E && _.label < E[2]) {
                _.label = E[2], _.ops.push(P);
                break;
              }
              E[2] && _.ops.pop(), _.trys.pop();
              continue;
          }
          P = w.call(x, _);
        } catch (D) {
          P = [6, D], C = 0;
        } finally {
          S = E = 0;
        }
      if (P[0] & 5) throw P[1];
      return { value: P[0] ? P[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(so, "__esModule", { value: !0 }), so.responseErrorInterceptor = so.responseInterceptor = so.interceptorFunctionRequestFulfilled = void 0;
  var n = W5e(), a = $h, s = a2(), i = yi, o = Jg();
  function l(x) {
    x.__supertokensSessionRefreshAttempts === void 0 && (x.__supertokensSessionRefreshAttempts = 0), x.__supertokensSessionRefreshAttempts++;
  }
  function c(x) {
    return x.__supertokensSessionRefreshAttempts === void 0 && (x.__supertokensSessionRefreshAttempts = 0), x.__supertokensSessionRefreshAttempts >= a.default.config.maxRetryAttemptsForSessionRefresh;
  }
  function u(x) {
    var w = x.url === void 0 ? "" : x.url, _ = x.baseURL;
    return _ !== void 0 && (w.charAt(0) === "/" && _.charAt(_.length - 1) === "/" ? w = _ + w.substr(1) : w.charAt(0) !== "/" && _.charAt(_.length - 1) !== "/" ? w = _ + "/" + w : w = _ + w), w;
  }
  function d(x) {
    return t(this, void 0, void 0, function() {
      var w, _, S, C, E, O;
      return r(this, function(k) {
        switch (k.label) {
          case 0:
            (0, o.logDebugMessage)("interceptorFunctionRequestFulfilled: started axios interception"), w = u(x), _ = !1;
            try {
              _ = typeof w == "string" && !a.default.recipeImpl.shouldDoInterceptionBasedOnUrl(
                w,
                a.default.config.apiDomain,
                a.default.config.sessionTokenBackendDomain
              );
            } catch (A) {
              if (A.message === "Please provide a valid domain name")
                (0, o.logDebugMessage)(
                  "interceptorFunctionRequestFulfilled: Trying shouldDoInterceptionBasedOnUrl with location.origin"
                ), _ = !a.default.recipeImpl.shouldDoInterceptionBasedOnUrl(
                  i.default.getReferenceOrThrow().windowHandler.location.getOrigin(),
                  a.default.config.apiDomain,
                  a.default.config.sessionTokenBackendDomain
                );
              else
                throw A;
            }
            return (0, o.logDebugMessage)("interceptorFunctionRequestFulfilled: Value of doNotDoInterception: " + _), _ ? ((0, o.logDebugMessage)(
              "interceptorFunctionRequestFulfilled: Returning config unchanged"
            ), [2, x]) : ((0, o.logDebugMessage)("interceptorFunctionRequestFulfilled: Modifying config"), s.ProcessState.getInstance().addState(
              s.PROCESS_STATE.CALLING_INTERCEPTION_REQUEST
            ), [4, (0, a.getLocalSessionState)(!0)]);
          case 1:
            return S = k.sent(), C = x, S.status !== "EXISTS" ? [3, 3] : [4, a.AntiCsrfToken.getToken(S.lastAccessTokenUpdate)];
          case 2:
            E = k.sent(), E !== void 0 && ((0, o.logDebugMessage)(
              "interceptorFunctionRequestFulfilled: Adding anti-csrf token to request"
            ), C = e(e({}, C), {
              headers: C === void 0 ? {
                "anti-csrf": E
              } : e(e({}, C.headers), { "anti-csrf": E })
            })), k.label = 3;
          case 3:
            return a.default.config.autoAddCredentials && C.withCredentials === void 0 && ((0, o.logDebugMessage)(
              "interceptorFunctionRequestFulfilled: Adding credentials include"
            ), C = e(e({}, C), { withCredentials: !0 })), (0, o.logDebugMessage)("interceptorFunctionRequestFulfilled: Adding rid header: anti-csrf (it may be overriden by the user's provided rid)"), C = e(e({}, C), {
              headers: C === void 0 ? {
                rid: "anti-csrf"
              } : e({ rid: "anti-csrf" }, C.headers)
            }), O = a.default.config.tokenTransferMethod, (0, o.logDebugMessage)("interceptorFunctionRequestFulfilled: Adding st-auth-mode header: " + O), C.headers["st-auth-mode"] = O, [4, y(C)];
          case 4:
            return C = k.sent(), [4, m(C)];
          case 5:
            return k.sent(), (0, o.logDebugMessage)("interceptorFunctionRequestFulfilled: returning modified config"), [2, C];
        }
      });
    });
  }
  so.interceptorFunctionRequestFulfilled = d;
  function f(x) {
    var w = this;
    return function(_) {
      return t(w, void 0, void 0, function() {
        var S, C, E, O;
        return r(this, function(k) {
          switch (k.label) {
            case 0:
              if (S = !1, !a.default.initCalled)
                throw new Error("init function not called");
              (0, o.logDebugMessage)("responseInterceptor: started"), (0, o.logDebugMessage)("responseInterceptor: already intercepted: " + _.headers["x-supertokens-xhr-intercepted"]), C = u(_.config);
              try {
                S = typeof C == "string" && !a.default.recipeImpl.shouldDoInterceptionBasedOnUrl(
                  C,
                  a.default.config.apiDomain,
                  a.default.config.sessionTokenBackendDomain
                ) || !!_.headers["x-supertokens-xhr-intercepted"];
              } catch (A) {
                if (A.message === "Please provide a valid domain name")
                  (0, o.logDebugMessage)(
                    "responseInterceptor: Trying shouldDoInterceptionBasedOnUrl with location.origin"
                  ), S = !a.default.recipeImpl.shouldDoInterceptionBasedOnUrl(
                    i.default.getReferenceOrThrow().windowHandler.location.getOrigin(),
                    a.default.config.apiDomain,
                    a.default.config.sessionTokenBackendDomain
                  ) || !!_.headers["x-supertokens-xhr-intercepted"];
                else
                  throw A;
              }
              return (0, o.logDebugMessage)("responseInterceptor: Value of doNotDoInterception: " + S), S ? ((0, o.logDebugMessage)("responseInterceptor: Returning without interception"), [2, _]) : ((0, o.logDebugMessage)("responseInterceptor: Interception started"), s.ProcessState.getInstance().addState(
                s.PROCESS_STATE.CALLING_INTERCEPTION_RESPONSE
              ), [4, (0, a.getLocalSessionState)(!1)]);
            case 1:
              return E = k.sent(), [4, g(_)];
            case 2:
              return k.sent(), (0, a.fireSessionUpdateEventsIfNecessary)(E.status === "EXISTS", _.status, _.headers["front-token"]), _.status !== a.default.config.sessionExpiredStatusCode ? [3, 3] : ((0, o.logDebugMessage)("responseInterceptor: Status code is: " + _.status), O = _.config, [
                2,
                p.doRequest(
                  function(A) {
                    return x(A);
                  },
                  O,
                  C,
                  _,
                  void 0,
                  !0
                )
              ]);
            case 3:
              return _.status !== a.default.config.invalidClaimStatusCode ? [3, 5] : [4, (0, a.onInvalidClaimResponse)(_)];
            case 4:
              k.sent(), k.label = 5;
            case 5:
              return [2, _];
          }
        });
      });
    };
  }
  so.responseInterceptor = f;
  function h(x) {
    var w = this;
    return function(_) {
      return t(w, void 0, void 0, function() {
        var S;
        return r(this, function(C) {
          switch (C.label) {
            case 0:
              if ((0, o.logDebugMessage)("responseErrorInterceptor: called"), (0, o.logDebugMessage)("responseErrorInterceptor: already intercepted: " + (_.response && _.response.headers["x-supertokens-xhr-intercepted"])), _.response === void 0 || _.response.headers["x-supertokens-xhr-intercepted"])
                throw _;
              return _.response !== void 0 && _.response.status === a.default.config.sessionExpiredStatusCode ? ((0, o.logDebugMessage)("responseErrorInterceptor: Status code is: " + _.response.status), S = _.config, [
                2,
                p.doRequest(
                  function(E) {
                    return x(E);
                  },
                  S,
                  u(S),
                  void 0,
                  _,
                  !0
                )
              ]) : [3, 1];
            case 1:
              return _.response !== void 0 && _.response.status === a.default.config.invalidClaimStatusCode ? [4, (0, a.onInvalidClaimResponse)(_.response)] : [3, 3];
            case 2:
              C.sent(), C.label = 3;
            case 3:
              throw _;
          }
        });
      });
    };
  }
  so.responseErrorInterceptor = h;
  var p = (
    /** @class */
    function() {
      function x() {
      }
      var w;
      return w = x, x.doRequest = function(_, S, C, E, O, k) {
        return k === void 0 && (k = !1), t(void 0, void 0, void 0, function() {
          var A, P, D, N, z, G, Y, te, ue, ae, ne, ue, q, U, Q;
          return r(w, function(L) {
            switch (L.label) {
              case 0:
                if (!a.default.initCalled)
                  throw Error("init function not called");
                (0, o.logDebugMessage)("doRequest: called"), A = !1;
                try {
                  A = typeof C == "string" && !a.default.recipeImpl.shouldDoInterceptionBasedOnUrl(
                    C,
                    a.default.config.apiDomain,
                    a.default.config.sessionTokenBackendDomain
                  ) && k;
                } catch (j) {
                  if (j.message === "Please provide a valid domain name")
                    (0, o.logDebugMessage)(
                      "doRequest: Trying shouldDoInterceptionBasedOnUrl with location.origin"
                    ), A = !a.default.recipeImpl.shouldDoInterceptionBasedOnUrl(
                      i.default.getReferenceOrThrow().windowHandler.location.getOrigin(),
                      a.default.config.apiDomain,
                      a.default.config.sessionTokenBackendDomain
                    ) && k;
                  else
                    throw j;
                }
                if ((0, o.logDebugMessage)("doRequest: Value of doNotDoInterception: " + A), !A) return [3, 2];
                if ((0, o.logDebugMessage)("doRequest: Returning without interception"), O !== void 0)
                  throw O;
                return E !== void 0 ? [2, E] : [4, _(S)];
              case 1:
                return [2, L.sent()];
              case 2:
                return (0, o.logDebugMessage)("doRequest: Interception started"), [4, y(S)];
              case 3:
                S = L.sent(), P = void 0, L.label = 4;
              case 4:
                return [4, (0, a.getLocalSessionState)(!0)];
              case 5:
                return D = L.sent(), N = S, D.status !== "EXISTS" ? [3, 7] : [4, a.AntiCsrfToken.getToken(D.lastAccessTokenUpdate)];
              case 6:
                z = L.sent(), z !== void 0 && ((0, o.logDebugMessage)("doRequest: Adding anti-csrf token to request"), N = e(e({}, N), {
                  headers: N === void 0 ? {
                    "anti-csrf": z
                  } : e(e({}, N.headers), {
                    "anti-csrf": z
                  })
                })), L.label = 7;
              case 7:
                return a.default.config.autoAddCredentials && N.withCredentials === void 0 && ((0, o.logDebugMessage)("doRequest: Adding credentials include"), N = e(e({}, N), { withCredentials: !0 })), (0, o.logDebugMessage)("doRequest: Adding rid header: anti-csrf (May get overriden by user's rid)"), N = e(e({}, N), {
                  headers: N === void 0 ? {
                    rid: "anti-csrf"
                  } : e({ rid: "anti-csrf" }, N.headers)
                }), G = a.default.config.tokenTransferMethod, (0, o.logDebugMessage)("doRequest: Adding st-auth-mode header: " + G), N.headers["st-auth-mode"] = G, [4, m(N)];
              case 8:
                L.sent(), L.label = 9;
              case 9:
                if (L.trys.push([9, 14, , 27]), Y = O, te = E, O = void 0, E = void 0, Y !== void 0)
                  throw (0, o.logDebugMessage)(
                    "doRequest: Not making call because localPrevError is not undefined"
                  ), Y;
                return te !== void 0 ? (0, o.logDebugMessage)(
                  "doRequest: Not making call because localPrevResponse is not undefined"
                ) : (0, o.logDebugMessage)("doRequest: Making user's http call"), te !== void 0 ? [3, 11] : [4, _(N)];
              case 10:
                return ae = L.sent(), [3, 12];
              case 11:
                ae = te, L.label = 12;
              case 12:
                return ue = ae, (0, o.logDebugMessage)("doRequest: User's http call ended"), [4, g(ue)];
              case 13:
                return L.sent(), (0, a.fireSessionUpdateEventsIfNecessary)(D.status === "EXISTS", ue.status, ue.headers["front-token"]), [2, ue];
              case 14:
                return ne = L.sent(), ue = ne.response, ue === void 0 ? [3, 25] : [4, g(ue)];
              case 15:
                if (L.sent(), (0, a.fireSessionUpdateEventsIfNecessary)(D.status === "EXISTS", ue.status, ue.headers["front-token"]), ue.status !== a.default.config.sessionExpiredStatusCode)
                  return [3, 21];
                if ((0, o.logDebugMessage)("doRequest: Status code is: " + ue.status), c(S))
                  throw (0, o.logDebugMessage)(
                    "doRequest: Maximum session refresh attempts reached. sessionRefreshAttempts: ".concat(
                      S.__supertokensSessionRefreshAttempts,
                      ", maxRetryAttemptsForSessionRefresh: "
                    ).concat(a.default.config.maxRetryAttemptsForSessionRefresh)
                  ), q = "Received a 401 response from ".concat(
                    C,
                    ". Attempted to refresh the session and retry the request with the updated session tokens "
                  ).concat(
                    a.default.config.maxRetryAttemptsForSessionRefresh,
                    " times, but each attempt resulted in a 401 error. The maximum session refresh limit has been reached. Please investigate your API. To increase the session refresh attempts, update maxRetryAttemptsForSessionRefresh in the config."
                  ), console.error(q), new Error(q);
                return [4, (0, a.onUnauthorisedResponse)(D)];
              case 16:
                return U = L.sent(), l(S), (0, o.logDebugMessage)("doRequest: sessionRefreshAttempts: " + S.__supertokensSessionRefreshAttempts), U.result === "RETRY" ? [3, 20] : ((0, o.logDebugMessage)("doRequest: Not retrying original request"), U.error === void 0 ? [3, 18] : [4, (0, n.createAxiosErrorFromFetchResp)(U.error)]);
              case 17:
                return Q = L.sent(), [3, 19];
              case 18:
                Q = ne, L.label = 19;
              case 19:
                return P = Q, [3, 28];
              case 20:
                return (0, o.logDebugMessage)("doRequest: Retrying original request"), [3, 24];
              case 21:
                return ue.status !== a.default.config.invalidClaimStatusCode ? [3, 23] : [4, (0, a.onInvalidClaimResponse)(ue)];
              case 22:
                L.sent(), L.label = 23;
              case 23:
                throw ne;
              case 24:
                return [3, 26];
              case 25:
                throw ne;
              case 26:
                return [3, 27];
              case 27:
                return [3, 4];
              case 28:
                throw P;
            }
          });
        });
      }, x;
    }()
  );
  so.default = p;
  function m(x) {
    return t(this, void 0, void 0, function() {
      var w, _;
      return r(this, function(S) {
        switch (S.label) {
          case 0:
            return x.headers === void 0 && (x.headers = {}), (0, o.logDebugMessage)("setAuthorizationHeaderIfRequired: adding existing tokens as header"), [4, (0, a.getTokenForHeaderAuth)("access")];
          case 1:
            return w = S.sent(), [4, (0, a.getTokenForHeaderAuth)("refresh")];
          case 2:
            return _ = S.sent(), w !== void 0 && _ !== void 0 ? x.headers.Authorization !== void 0 || x.headers.authorization !== void 0 ? (0, o.logDebugMessage)(
              "setAuthorizationHeaderIfRequired: Authorization header defined by the user, not adding"
            ) : ((0, o.logDebugMessage)(
              "setAuthorizationHeaderIfRequired: added authorization header"
            ), x.headers = e(e({}, x.headers), {
              Authorization: "Bearer ".concat(w)
            }), x.__supertokensAddedAuthHeader = !0) : (0, o.logDebugMessage)(
              "setAuthorizationHeaderIfRequired: token for header based auth not found"
            ), [
              2
              /*return*/
            ];
        }
      });
    });
  }
  function g(x) {
    return t(this, void 0, void 0, function() {
      var w, _, S, C, E, O;
      return r(this, function(k) {
        switch (k.label) {
          case 0:
            return (0, o.logDebugMessage)("saveTokensFromHeaders: Saving updated tokens from the response"), w = x.headers["st-refresh-token"], w === void 0 ? [3, 2] : ((0, o.logDebugMessage)("saveTokensFromHeaders: saving new refresh token"), [4, (0, a.setToken)("refresh", w)]);
          case 1:
            k.sent(), k.label = 2;
          case 2:
            return _ = x.headers["st-access-token"], _ === void 0 ? [3, 4] : ((0, o.logDebugMessage)("saveTokensFromHeaders: saving new access token"), [4, (0, a.setToken)("access", _)]);
          case 3:
            k.sent(), k.label = 4;
          case 4:
            return S = x.headers["front-token"], S === void 0 ? [3, 6] : ((0, o.logDebugMessage)("doRequest: Setting sFrontToken: " + S), [4, a.FrontToken.setItem(S)]);
          case 5:
            k.sent(), C = new Headers(), Object.entries(x.headers).forEach(function(A) {
              var P = A[0], D = A[1];
              Array.isArray(D) ? D.forEach(function(N) {
                return C.append(P, N);
              }) : C.append(P, D);
            }), (0, a.updateClockSkewUsingFrontToken)({ frontToken: S, responseHeaders: C }), k.label = 6;
          case 6:
            return E = x.headers["anti-csrf"], E === void 0 ? [3, 9] : [4, (0, a.getLocalSessionState)(!1)];
          case 7:
            return O = k.sent(), O.status !== "EXISTS" ? [3, 9] : ((0, o.logDebugMessage)("doRequest: Setting anti-csrf token"), [4, a.AntiCsrfToken.setItem(O.lastAccessTokenUpdate, E)]);
          case 8:
            k.sent(), k.label = 9;
          case 9:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  function y(x) {
    return t(this, void 0, void 0, function() {
      var w, _, S, C;
      return r(this, function(E) {
        switch (E.label) {
          case 0:
            return [4, (0, a.getTokenForHeaderAuth)("access")];
          case 1:
            return w = E.sent(), [4, (0, a.getTokenForHeaderAuth)("refresh")];
          case 2:
            return _ = E.sent(), S = x.headers.Authorization || x.headers.authorization, w !== void 0 && _ !== void 0 && (S === "Bearer ".concat(w) || "__supertokensAddedAuthHeader" in x) ? ((0, o.logDebugMessage)(
              "removeAuthHeaderIfMatchesLocalToken: Removing Authorization from user provided headers because it contains our access token"
            ), C = e(e({}, x), { headers: e({}, x.headers) }), delete C.headers.authorization, delete C.headers.Authorization, [2, C]) : [2, x];
        }
      });
    });
  }
  return so;
}
var Ip = {}, ML;
function K5e() {
  if (ML) return Ip;
  ML = 1;
  var e = ke && ke.__awaiter || function(f, h, p, m) {
    function g(y) {
      return y instanceof p ? y : new p(function(x) {
        x(y);
      });
    }
    return new (p || (p = Promise))(function(y, x) {
      function w(C) {
        try {
          S(m.next(C));
        } catch (E) {
          x(E);
        }
      }
      function _(C) {
        try {
          S(m.throw(C));
        } catch (E) {
          x(E);
        }
      }
      function S(C) {
        C.done ? y(C.value) : g(C.value).then(w, _);
      }
      S((m = m.apply(f, h || [])).next());
    });
  }, t = ke && ke.__generator || function(f, h) {
    var p = {
      label: 0,
      sent: function() {
        if (y[0] & 1) throw y[1];
        return y[1];
      },
      trys: [],
      ops: []
    }, m, g, y, x;
    return x = { next: w(0), throw: w(1), return: w(2) }, typeof Symbol == "function" && (x[Symbol.iterator] = function() {
      return this;
    }), x;
    function w(S) {
      return function(C) {
        return _([S, C]);
      };
    }
    function _(S) {
      if (m) throw new TypeError("Generator is already executing.");
      for (; p; )
        try {
          if (m = 1, g && (y = S[0] & 2 ? g.return : S[0] ? g.throw || ((y = g.return) && y.call(g), 0) : g.next) && !(y = y.call(g, S[1])).done)
            return y;
          switch (g = 0, y && (S = [S[0] & 2, y.value]), S[0]) {
            case 0:
            case 1:
              y = S;
              break;
            case 4:
              return p.label++, { value: S[1], done: !1 };
            case 5:
              p.label++, g = S[1], S = [0];
              continue;
            case 7:
              S = p.ops.pop(), p.trys.pop();
              continue;
            default:
              if (y = p.trys, !(y = y.length > 0 && y[y.length - 1]) && (S[0] === 6 || S[0] === 2)) {
                p = 0;
                continue;
              }
              if (S[0] === 3 && (!y || S[1] > y[0] && S[1] < y[3])) {
                p.label = S[1];
                break;
              }
              if (S[0] === 6 && p.label < y[1]) {
                p.label = y[1], y = S;
                break;
              }
              if (y && p.label < y[2]) {
                p.label = y[2], p.ops.push(S);
                break;
              }
              y[2] && p.ops.pop(), p.trys.pop();
              continue;
          }
          S = h.call(f, p);
        } catch (C) {
          S = [6, C], g = 0;
        } finally {
          m = y = 0;
        }
      if (S[0] & 5) throw S[1];
      return { value: S[0] ? S[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Ip, "__esModule", { value: !0 }), Ip.addInterceptorsToXMLHttpRequest = void 0;
  var r = $h, n = Jg(), a = yi, s = a2(), i = ["readystatechange", "abort", "error", "load", "loadend", "loadstart", "progress", "timeout"];
  function o() {
    var f = new Promise(function(p) {
      return setTimeout(p, 0);
    }), h = XMLHttpRequest;
    (0, n.logDebugMessage)("addInterceptorsToXMLHttpRequest called"), XMLHttpRequest = function() {
      var p = new h(), m = this, g = [], y = [], x = {}, w, _ = /* @__PURE__ */ new Map(), S = f;
      function C(ae) {
        S = S.finally(function() {
          var ne;
          return (ne = ae()) === null || ne === void 0 ? void 0 : ne.catch(function(ue) {
            var q = new ProgressEvent("error");
            q.error = ue, m.onerror !== void 0 && m.onerror !== null && m.onerror(q), D("error", q);
          });
        });
      }
      var E = "", O = !1, k = void 0, A, P = 0;
      m.onload = null, m.onreadystatechange = null, m.onloadend = null, m.addEventListener = function(ae, ne, ue) {
        var q = _.get(ae);
        q === void 0 && (q = /* @__PURE__ */ new Set(), _.set(ae, q)), q.add(ne);
      }, m.removeEventListener = function(ae, ne) {
        var ue = _.get(ae);
        ue === void 0 && (ue = /* @__PURE__ */ new Set(), _.set(ae, ue)), ue.delete(ne);
      };
      function D(ae, ne) {
        var ue = _.get(ae);
        (0, n.logDebugMessage)(
          "XHRInterceptor dispatching ".concat(ne.type, " to ").concat(ue ? ue.size : 0, " listeners")
        ), ue && Array.from(ue).forEach(function(q) {
          return q.apply(m, [ne]);
        });
      }
      function N() {
        return e(this, void 0, void 0, function() {
          var ae, ne, ue;
          return t(this, function(q) {
            switch (q.label) {
              case 0:
                if (k === void 0)
                  throw new Error("Should never come here..");
                if ((0, n.logDebugMessage)("XHRInterceptor.handleRetryPostRefreshing: preRequestLSS " + k.status), P >= r.default.config.maxRetryAttemptsForSessionRefresh)
                  throw (0, n.logDebugMessage)(
                    "XHRInterceptor.handleRetryPostRefreshing: Maximum session refresh attempts reached. sessionRefreshAttempts: ".concat(P, ", maxRetryAttemptsForSessionRefresh: ").concat(r.default.config.maxRetryAttemptsForSessionRefresh)
                  ), x.status = 0, x.statusText = "", x.responseType = "", ae = "Received a 401 response from ".concat(
                    E,
                    ". Attempted to refresh the session and retry the request with the updated session tokens "
                  ).concat(
                    r.default.config.maxRetryAttemptsForSessionRefresh,
                    " times, but each attempt resulted in a 401 error. The maximum session refresh limit has been reached. Please investigate your API. To increase the session refresh attempts, update maxRetryAttemptsForSessionRefresh in the config."
                  ), console.error(ae), new Error(ae);
                return [4, (0, r.onUnauthorisedResponse)(k)];
              case 1:
                if (ne = q.sent(), P++, (0, n.logDebugMessage)("XHRInterceptor.handleRetryPostRefreshing: sessionRefreshAttempts: " + P), ne.result !== "RETRY") {
                  if ((0, n.logDebugMessage)(
                    "XHRInterceptor.handleRetryPostRefreshing: Not retrying original request " + !!ne.error
                  ), ne.error !== void 0)
                    throw ne.error;
                  return [2, !0];
                }
                return (0, n.logDebugMessage)("XHRInterceptor.handleRetryPostRefreshing: Retrying original request"), ue = new h(), Y(m, ue, !0), g.forEach(function(U) {
                  U(ue);
                }), te(ue, A), [2, !1];
            }
          });
        });
      }
      function z(ae) {
        return e(this, void 0, void 0, function() {
          var ne, ue, q, U, Q;
          return t(this, function(L) {
            switch (L.label) {
              case 0:
                if (O)
                  return (0, n.logDebugMessage)(
                    "XHRInterceptor.handleResponse: Returning without interception"
                  ), [2, !0];
                L.label = 1;
              case 1:
                return L.trys.push([1, 7, , 11]), (0, n.logDebugMessage)("XHRInterceptor.handleResponse: Interception started"), s.ProcessState.getInstance().addState(
                  s.PROCESS_STATE.CALLING_INTERCEPTION_RESPONSE
                ), ne = ae.status, ue = d(ae), [4, u(ue)];
              case 2:
                return L.sent(), (0, r.fireSessionUpdateEventsIfNecessary)(k.status === "EXISTS", ne, ue.get("front-token")), ne !== r.default.config.sessionExpiredStatusCode ? [3, 4] : ((0, n.logDebugMessage)("responseInterceptor: Status code is: " + ne), [4, N()]);
              case 3:
                return [2, L.sent()];
              case 4:
                return ne !== r.default.config.invalidClaimStatusCode ? [3, 6] : [4, (0, r.onInvalidClaimResponse)({ data: ae.responseText })];
              case 5:
                L.sent(), L.label = 6;
              case 6:
                return [2, !0];
              case 7:
                return q = L.sent(), (0, n.logDebugMessage)("XHRInterceptor.handleResponse: caught error"), q.status === void 0 ? [3, 9] : [4, l(q)];
              case 8:
                if (U = L.sent(), x.status = U.status, x.statusText = U.statusText, x.responseType = U.responseType, w = U.headers, U.responseType === "json")
                  try {
                    x.response = JSON.parse(U.responseText);
                  } catch {
                    x.response = U.responseText;
                  }
                else
                  x.response = U.responseText;
                return x.responseText = U.responseText, [3, 10];
              case 9:
                Q = new ProgressEvent("error"), Q.error = q, m.onerror !== void 0 && m.onerror !== null && m.onerror(Q), D("error", Q), L.label = 10;
              case 10:
                return [2, !0];
              case 11:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }
      m.open = function(ae, ne) {
        (0, n.logDebugMessage)("XHRInterceptor.open called");
        var ue = arguments;
        E = ne;
        try {
          O = typeof E == "string" && !r.default.recipeImpl.shouldDoInterceptionBasedOnUrl(
            E,
            r.default.config.apiDomain,
            r.default.config.sessionTokenBackendDomain
          ) || typeof E != "string" && !r.default.recipeImpl.shouldDoInterceptionBasedOnUrl(
            E.toString(),
            r.default.config.apiDomain,
            r.default.config.sessionTokenBackendDomain
          );
        } catch (q) {
          if (q.message === "Please provide a valid domain name")
            (0, n.logDebugMessage)(
              "XHRInterceptor.open: Trying shouldDoInterceptionBasedOnUrl with location.origin"
            ), O = !r.default.recipeImpl.shouldDoInterceptionBasedOnUrl(
              a.default.getReferenceOrThrow().windowHandler.location.getOrigin(),
              r.default.config.apiDomain,
              r.default.config.sessionTokenBackendDomain
            );
          else
            throw q;
        }
        C(function() {
          g.push(function(q) {
            q.open.apply(q, ue);
          }), p.open.apply(p, ue);
        });
      }, m.send = function(ae) {
        A = ae, te(p, A);
      }, m.setRequestHeader = function(ae, ne) {
        var ue = this;
        if ((0, n.logDebugMessage)("XHRInterceptor.setRequestHeader: Called with ".concat(ae)), O) {
          C(function() {
            return p.setRequestHeader(ae, ne);
          });
          return;
        }
        ae !== "anti-csrf" && C(function() {
          return e(ue, void 0, void 0, function() {
            var q, U;
            return t(this, function(Q) {
              switch (Q.label) {
                case 0:
                  return ae.toLowerCase() !== "authorization" ? [3, 3] : ((0, n.logDebugMessage)("XHRInterceptor.setRequestHeader: checking if user provided auth header matches local token"), [4, (0, r.getTokenForHeaderAuth)("access")]);
                case 1:
                  return q = Q.sent(), [4, (0, r.getTokenForHeaderAuth)("refresh")];
                case 2:
                  if (U = Q.sent(), q !== void 0 && U !== void 0 && ne === "Bearer ".concat(q))
                    return (0, n.logDebugMessage)(
                      "XHRInterceptor.setRequestHeader: skipping Authorization from user provided headers because it contains our access token"
                    ), [
                      2
                      /*return*/
                    ];
                  Q.label = 3;
                case 3:
                  return g.push(function(L) {
                    L.setRequestHeader(ae, ne);
                  }), y.push({ name: ae, value: ne }), p.setRequestHeader(ae, ne), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        });
      };
      var G = void 0;
      Y(m, p, !1);
      function Y(ae, ne, ue) {
        var q, U = ["load", "loadend", "readystatechange"];
        (0, n.logDebugMessage)("XHRInterceptor.setUpXHR called");
        for (var Q = function(me) {
          (0, n.logDebugMessage)("XHRInterceptor added listener for event ".concat(me)), ne.addEventListener(me, function(Oe) {
            (0, n.logDebugMessage)("XHRInterceptor got event ".concat(me)), U.includes(me) || D(me, Oe);
          });
        }, L = 0, j = i; L < j.length; L++) {
          var K = j[L];
          Q(K);
        }
        if (ne.onload = function(me) {
          q === void 0 && (q = z(ne)), q.then(function(Oe) {
            Oe && (ae.onload && ae.onload(me), D("load", me));
          });
        }, ne.onreadystatechange = function(me) {
          ne.readyState === h.DONE ? (q === void 0 && (q = z(ne)), q.then(function(Oe) {
            Oe && (ae.onreadystatechange && ae.onreadystatechange(me), D("readystatechange", me));
          })) : (ae.onreadystatechange && ae.onreadystatechange(me), D("readystatechange", me));
        }, ne.onloadend = function(me) {
          q === void 0 && (q = z(ne)), q.then(function(Oe) {
            Oe && (ae.onloadend && ae.onloadend(me), D("loadend", me));
          });
        }, ae.getAllResponseHeaders = function() {
          var me;
          return w ? (me = "", w.forEach(function(Oe, ee) {
            return me += "".concat(ee, ": ").concat(Oe, `\r
`);
          })) : me = ne.getAllResponseHeaders(), me + `x-supertokens-xhr-intercepted: true\r
`;
        }, ae.getResponseHeader = function(me) {
          return me === "x-supertokens-xhr-intercepted" ? "true" : w ? w.get(me) : ne.getResponseHeader(me);
        }, G === void 0) {
          G = [];
          for (var J in ne)
            J in ae || G.push(J);
        }
        for (var re = function(me) {
          typeof ne[me] == "function" ? Object.defineProperty(ae, me, {
            configurable: !0,
            value: function() {
              var Oe = arguments;
              return ue || g.push(function(ee) {
                ee[me].apply(ee, Oe);
              }), ne[me].apply(ne, Oe);
            }
          }) : Object.defineProperty(ae, me, {
            configurable: !0,
            get: function() {
              return x[me] !== void 0 ? x[me] : ne[me];
            },
            set: function(Oe) {
              ue || g.push(function(ee) {
                ee[me] = Oe;
              }), (0, n.logDebugMessage)("XHRInterceptor.set[".concat(me, "] = ").concat(Oe)), ne[me] = Oe;
            }
          });
        }, le = 0, pe = G; le < pe.length; le++) {
          var J = pe[le];
          re(J);
        }
      }
      function te(ae, ne) {
        var ue = this;
        if ((0, n.logDebugMessage)("XHRInterceptor.send: called"), (0, n.logDebugMessage)("XHRInterceptor.send: Value of doNotDoInterception: " + O), O) {
          (0, n.logDebugMessage)("XHRInterceptor.send: Returning without interception"), C(function() {
            return ae.send(ne);
          });
          return;
        }
        (0, n.logDebugMessage)("XHRInterceptor.send: Interception started"), s.ProcessState.getInstance().addState(
          s.PROCESS_STATE.CALLING_INTERCEPTION_REQUEST
        ), C(function() {
          return e(ue, void 0, void 0, function() {
            var q, U;
            return t(this, function(Q) {
              switch (Q.label) {
                case 0:
                  return [4, (0, r.getLocalSessionState)(!0)];
                case 1:
                  return k = Q.sent(), k.status !== "EXISTS" ? [3, 3] : [
                    4,
                    r.AntiCsrfToken.getToken(k.lastAccessTokenUpdate)
                  ];
                case 2:
                  q = Q.sent(), q !== void 0 && ((0, n.logDebugMessage)(
                    "XHRInterceptor.send: Adding anti-csrf token to request"
                  ), ae.setRequestHeader("anti-csrf", q)), Q.label = 3;
                case 3:
                  return r.default.config.autoAddCredentials && ((0, n.logDebugMessage)("XHRInterceptor.send: Adding credentials include"), m.withCredentials = !0), y.some(function(L) {
                    return L.name === "rid";
                  }) ? (0, n.logDebugMessage)(
                    "XHRInterceptor.send: rid header was already there in request"
                  ) : ((0, n.logDebugMessage)("XHRInterceptor.send: Adding rid header: anti-csrf"), ae.setRequestHeader("rid", "anti-csrf")), U = r.default.config.tokenTransferMethod, y.some(function(L) {
                    return L.name === "st-auth-mode";
                  }) ? (0, n.logDebugMessage)(
                    "XHRInterceptor.send: st-auth-mode header was already there in request"
                  ) : ((0, n.logDebugMessage)(
                    "XHRInterceptor.send: Adding st-auth-mode header: " + U
                  ), ae.setRequestHeader("st-auth-mode", U)), [4, c(ae, y)];
                case 4:
                  return Q.sent(), (0, n.logDebugMessage)("XHRInterceptor.send: Making user's http call"), [2, ae.send(ne)];
              }
            });
          });
        });
      }
    }, XMLHttpRequest.__interceptedBySuperTokens = !0, XMLHttpRequest.__original = h;
  }
  Ip.addInterceptorsToXMLHttpRequest = o;
  function l(f) {
    return e(this, void 0, void 0, function() {
      var h, p, m, g, y;
      return t(this, function(x) {
        switch (x.label) {
          case 0:
            if (h = f.headers.get("content-type"), p = "", m = "text", h !== null) return [3, 5];
            x.label = 1;
          case 1:
            return x.trys.push([1, 3, , 4]), [4, f.text()];
          case 2:
            return p = x.sent(), [3, 4];
          case 3:
            return x.sent(), p = "", [3, 4];
          case 4:
            return [3, 9];
          case 5:
            return h.includes("application/json") ? (m = "json", y = (g = JSON).stringify, [4, f.json()]) : [3, 7];
          case 6:
            return p = y.apply(g, [x.sent()]), [3, 9];
          case 7:
            return h.includes("text/") ? [4, f.text()] : [3, 9];
          case 8:
            p = x.sent(), x.label = 9;
          case 9:
            return [
              2,
              {
                status: f.status,
                responseText: p,
                statusText: f.statusText,
                responseType: m,
                headers: f.headers
              }
            ];
        }
      });
    });
  }
  function c(f, h) {
    return e(this, void 0, void 0, function() {
      var p, m;
      return t(this, function(g) {
        switch (g.label) {
          case 0:
            return (0, n.logDebugMessage)("setAuthorizationHeaderIfRequired: adding existing tokens as header"), [4, (0, r.getTokenForHeaderAuth)("access")];
          case 1:
            return p = g.sent(), [4, (0, r.getTokenForHeaderAuth)("refresh")];
          case 2:
            return m = g.sent(), p !== void 0 && m !== void 0 ? h.some(function(y) {
              var x = y.name;
              return x.toLowerCase() === "authorization";
            }) ? (0, n.logDebugMessage)(
              "setAuthorizationHeaderIfRequired: Authorization header defined by the user, not adding"
            ) : p !== void 0 && ((0, n.logDebugMessage)(
              "setAuthorizationHeaderIfRequired: added authorization header"
            ), f.setRequestHeader("Authorization", "Bearer ".concat(p))) : (0, n.logDebugMessage)(
              "setAuthorizationHeaderIfRequired: token for header based auth not found"
            ), [
              2
              /*return*/
            ];
        }
      });
    });
  }
  function u(f) {
    return e(this, void 0, void 0, function() {
      var h, p, m, g, y;
      return t(this, function(x) {
        switch (x.label) {
          case 0:
            return (0, n.logDebugMessage)("saveTokensFromHeaders: Saving updated tokens from the response"), h = f.get("st-refresh-token"), h === null ? [3, 2] : ((0, n.logDebugMessage)("saveTokensFromHeaders: saving new refresh token"), [4, (0, r.setToken)("refresh", h)]);
          case 1:
            x.sent(), x.label = 2;
          case 2:
            return p = f.get("st-access-token"), p === null ? [3, 4] : ((0, n.logDebugMessage)("saveTokensFromHeaders: saving new access token"), [4, (0, r.setToken)("access", p)]);
          case 3:
            x.sent(), x.label = 4;
          case 4:
            return m = f.get("front-token"), m === null ? [3, 6] : ((0, n.logDebugMessage)("saveTokensFromHeaders: Setting sFrontToken: " + m), [4, r.FrontToken.setItem(m)]);
          case 5:
            x.sent(), (0, r.updateClockSkewUsingFrontToken)({ frontToken: m, responseHeaders: f }), x.label = 6;
          case 6:
            return g = f.get("anti-csrf"), g === null ? [3, 9] : [4, (0, r.getLocalSessionState)(!1)];
          case 7:
            return y = x.sent(), y.status !== "EXISTS" ? [3, 9] : ((0, n.logDebugMessage)("saveTokensFromHeaders: Setting anti-csrf token"), [4, r.AntiCsrfToken.setItem(y.lastAccessTokenUpdate, g)]);
          case 8:
            x.sent(), x.label = 9;
          case 9:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  function d(f) {
    return new Headers(
      f.getAllResponseHeaders().split(`\r
`).map(function(h) {
        var p = h.indexOf(": ");
        return p === -1 ? ["", ""] : [h.slice(0, p), h.slice(p + 2)];
      }).filter(function(h) {
        return h[0].length !== 0;
      })
    );
  }
  return Ip;
}
var LL;
function q5e() {
  if (LL) return G0;
  LL = 1;
  var e = ke && ke.__assign || function() {
    return e = Object.assign || function(m) {
      for (var g, y = 1, x = arguments.length; y < x; y++) {
        g = arguments[y];
        for (var w in g) Object.prototype.hasOwnProperty.call(g, w) && (m[w] = g[w]);
      }
      return m;
    }, e.apply(this, arguments);
  }, t = ke && ke.__awaiter || function(m, g, y, x) {
    function w(_) {
      return _ instanceof y ? _ : new y(function(S) {
        S(_);
      });
    }
    return new (y || (y = Promise))(function(_, S) {
      function C(k) {
        try {
          O(x.next(k));
        } catch (A) {
          S(A);
        }
      }
      function E(k) {
        try {
          O(x.throw(k));
        } catch (A) {
          S(A);
        }
      }
      function O(k) {
        k.done ? _(k.value) : w(k.value).then(C, E);
      }
      O((x = x.apply(m, g || [])).next());
    });
  }, r = ke && ke.__generator || function(m, g) {
    var y = {
      label: 0,
      sent: function() {
        if (_[0] & 1) throw _[1];
        return _[1];
      },
      trys: [],
      ops: []
    }, x, w, _, S;
    return S = { next: C(0), throw: C(1), return: C(2) }, typeof Symbol == "function" && (S[Symbol.iterator] = function() {
      return this;
    }), S;
    function C(O) {
      return function(k) {
        return E([O, k]);
      };
    }
    function E(O) {
      if (x) throw new TypeError("Generator is already executing.");
      for (; y; )
        try {
          if (x = 1, w && (_ = O[0] & 2 ? w.return : O[0] ? w.throw || ((_ = w.return) && _.call(w), 0) : w.next) && !(_ = _.call(w, O[1])).done)
            return _;
          switch (w = 0, _ && (O = [O[0] & 2, _.value]), O[0]) {
            case 0:
            case 1:
              _ = O;
              break;
            case 4:
              return y.label++, { value: O[1], done: !1 };
            case 5:
              y.label++, w = O[1], O = [0];
              continue;
            case 7:
              O = y.ops.pop(), y.trys.pop();
              continue;
            default:
              if (_ = y.trys, !(_ = _.length > 0 && _[_.length - 1]) && (O[0] === 6 || O[0] === 2)) {
                y = 0;
                continue;
              }
              if (O[0] === 3 && (!_ || O[1] > _[0] && O[1] < _[3])) {
                y.label = O[1];
                break;
              }
              if (O[0] === 6 && y.label < _[1]) {
                y.label = _[1], _ = O;
                break;
              }
              if (_ && y.label < _[2]) {
                y.label = _[2], y.ops.push(O);
                break;
              }
              _[2] && y.ops.pop(), y.trys.pop();
              continue;
          }
          O = g.call(m, y);
        } catch (k) {
          O = [6, k], w = 0;
        } finally {
          x = _ = 0;
        }
      if (O[0] & 5) throw O[1];
      return { value: O[0] ? O[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(G0, "__esModule", { value: !0 });
  var n = $h, a = z5e(), s = s2(), i = Jg(), o = tv, l = K5e(), c = n2(), u = Ko, d = i2(), f = 100, h = "CLAIM_REFRESH_LOCK";
  function p(m) {
    return {
      addXMLHttpRequestInterceptor: function(g) {
        (0, i.logDebugMessage)("addXMLHttpRequestInterceptorAndReturnModified: called"), (0, l.addInterceptorsToXMLHttpRequest)();
      },
      addFetchInterceptorsAndReturnModifiedFetch: function(g) {
        return (0, i.logDebugMessage)("addFetchInterceptorsAndReturnModifiedFetch: called"), function(y, x) {
          return t(this, void 0, void 0, function() {
            return r(this, function(w) {
              switch (w.label) {
                case 0:
                  return [
                    4,
                    n.default.doRequest(
                      function(_) {
                        return g.originalFetch(
                          typeof y == "object" && "clone" in y ? y.clone() : y,
                          e({}, _)
                        );
                      },
                      x,
                      y
                    )
                  ];
                case 1:
                  return [2, w.sent()];
              }
            });
          });
        };
      },
      addAxiosInterceptors: function(g) {
        if ((0, i.logDebugMessage)("addAxiosInterceptors: called"), XMLHttpRequest.__interceptedBySuperTokens) {
          console.warn(
            "Not adding axios interceptor since XMLHttpRequest is already added. This is just a warning."
          ), console.warn("Our axios and XMLHttpRequest interceptors cannot be used at the same time."), console.warn(
            "Since XMLHttpRequest is added automatically and supports axios by default, you can just remove addAxiosInterceptors from your code."
          ), console.warn(
            "If you want to continue using our axios interceptor, you can override addXMLHttpRequestInterceptor with an empty function."
          ), (0, i.logDebugMessage)(
            "addAxiosInterceptors: not adding, because XHR interceptors are already in place"
          );
          return;
        }
        for (var y = g.axiosInstance.interceptors.request, x = 0; x < y.handlers.length; x++)
          if (y.handlers[x].fulfilled === a.interceptorFunctionRequestFulfilled) {
            (0, i.logDebugMessage)(
              "addAxiosInterceptors: not adding because already added on this instance"
            );
            return;
          }
        g.axiosInstance.interceptors.request.use(a.interceptorFunctionRequestFulfilled, function(w) {
          return t(this, void 0, void 0, function() {
            return r(this, function(_) {
              throw w;
            });
          });
        }), g.axiosInstance.interceptors.response.use(
          (0, a.responseInterceptor)(g.axiosInstance),
          (0, a.responseErrorInterceptor)(g.axiosInstance)
        );
      },
      getUserId: function(g) {
        return t(this, void 0, void 0, function() {
          var y;
          return r(this, function(x) {
            switch (x.label) {
              case 0:
                return (0, i.logDebugMessage)("getUserId: called"), [4, n.FrontToken.getTokenInfo()];
              case 1:
                if (y = x.sent(), y === void 0)
                  throw new Error("No session exists");
                return (0, i.logDebugMessage)("getUserId: returning: " + y.uid), [2, y.uid];
            }
          });
        });
      },
      getAccessTokenPayloadSecurely: function(g) {
        return t(this, void 0, void 0, function() {
          var y, x;
          return r(this, function(w) {
            switch (w.label) {
              case 0:
                return (0, i.logDebugMessage)("getAccessTokenPayloadSecurely: called"), [4, n.FrontToken.getTokenInfo()];
              case 1:
                if (y = w.sent(), y === void 0)
                  throw new Error("No session exists");
                return y.ate < u.default.getReferenceOrThrow().dateProvider.now() ? ((0, i.logDebugMessage)("getAccessTokenPayloadSecurely: access token expired. Refreshing session"), [4, n.default.attemptRefreshingSession()]) : [3, 5];
              case 2:
                return x = w.sent(), x ? [
                  4,
                  this.getAccessTokenPayloadSecurely({
                    userContext: g.userContext
                  })
                ] : [3, 4];
              case 3:
                return [2, w.sent()];
              case 4:
                throw new Error("Could not refresh session");
              case 5:
                return (0, i.logDebugMessage)("getAccessTokenPayloadSecurely: returning: " + JSON.stringify(y.up)), [2, y.up];
            }
          });
        });
      },
      doesSessionExist: function(g) {
        return t(this, void 0, void 0, function() {
          var y, x, w;
          return r(this, function(_) {
            switch (_.label) {
              case 0:
                return (0, i.logDebugMessage)("doesSessionExist: called"), [4, n.FrontToken.getTokenInfo()];
              case 1:
                return y = _.sent(), y === void 0 ? ((0, i.logDebugMessage)("doesSessionExist: access token does not exist locally"), [2, !1]) : y.ate < u.default.getReferenceOrThrow().dateProvider.now() ? ((0, i.logDebugMessage)("doesSessionExist: access token expired. Refreshing session"), [4, (0, n.getLocalSessionState)(!1)]) : [3, 4];
              case 2:
                return x = _.sent(), [4, (0, n.onUnauthorisedResponse)(x)];
              case 3:
                return w = _.sent(), [2, w.result === "RETRY"];
              case 4:
                return [2, !0];
            }
          });
        });
      },
      signOut: function(g) {
        return t(this, void 0, void 0, function() {
          var y, x, w, _;
          return r(this, function(S) {
            switch (S.label) {
              case 0:
                return (0, i.logDebugMessage)("signOut: called"), [4, this.doesSessionExist(g)];
              case 1:
                return S.sent() ? ((0, i.logDebugMessage)("signOut: Calling refresh pre API hook"), [
                  4,
                  m.preAPIHook({
                    action: "SIGN_OUT",
                    requestInit: {
                      method: "post",
                      headers: {
                        "fdi-version": s.supported_fdi.join(","),
                        rid: n.default.rid
                      }
                    },
                    url: n.default.signOutUrl,
                    userContext: g.userContext
                  })
                ]) : ((0, i.logDebugMessage)("signOut: exiting early because session does not exist"), (0, i.logDebugMessage)("signOut: firing SIGN_OUT event"), m.onHandleEvent({
                  action: "SIGN_OUT",
                  userContext: g.userContext
                }), [
                  2
                  /*return*/
                ]);
              case 2:
                return y = S.sent(), (0, i.logDebugMessage)("signOut: Calling API"), [4, fetch(y.url, y.requestInit)];
              case 3:
                if (x = S.sent(), (0, i.logDebugMessage)("signOut: API ended"), (0, i.logDebugMessage)("signOut: API responded with status code: " + x.status), x.status === m.sessionExpiredStatusCode)
                  return [
                    2
                    /*return*/
                  ];
                if (x.status >= 300)
                  throw x;
                return [
                  4,
                  m.postAPIHook({
                    action: "SIGN_OUT",
                    requestInit: y.requestInit,
                    url: y.url,
                    fetchResponse: x.clone(),
                    userContext: g.userContext
                  })
                ];
              case 4:
                return S.sent(), [4, x.clone().json()];
              case 5:
                if (w = S.sent(), w.status === "GENERAL_ERROR")
                  throw (0, i.logDebugMessage)("doRequest: Throwing general error"), _ = w.message === void 0 ? "No Error Message Provided" : w.message, new o.STGeneralError(_);
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      },
      getInvalidClaimsFromResponse: function(g) {
        return t(this, void 0, void 0, function() {
          var y;
          return r(this, function(x) {
            switch (x.label) {
              case 0:
                return "body" in g.response ? [4, g.response.clone().json()] : [3, 2];
              case 1:
                return y = x.sent(), [3, 3];
              case 2:
                typeof g.response.data == "string" ? y = JSON.parse(g.response.data) : y = g.response.data, x.label = 3;
              case 3:
                return [2, y.claimValidationErrors];
            }
          });
        });
      },
      getGlobalClaimValidators: function(g) {
        return g.claimValidatorsAddedByOtherRecipes;
      },
      validateClaims: function(g) {
        return t(this, void 0, void 0, function() {
          var y, x, w, _, S, C, P, E, O, k, A, P, D;
          return r(this, function(N) {
            switch (N.label) {
              case 0:
                x = 0, N.label = 1;
              case 1:
                return ++x < f ? [4, d.default.getReferenceOrThrow().lockFactory()] : [3, 20];
              case 2:
                return w = N.sent(), (0, i.logDebugMessage)("validateClaims: trying to acquire claim refresh lock"), [4, w.acquireLock(h)];
              case 3:
                if (_ = N.sent(), !_) return [3, 18];
                N.label = 4;
              case 4:
                return N.trys.push([4, , 15, 17]), [
                  4,
                  this.getAccessTokenPayloadSecurely({
                    userContext: g.userContext
                  })
                ];
              case 5:
                y = N.sent(), (0, i.logDebugMessage)("validateClaims: claim refresh lock acquired"), S = 0, C = g.claimValidators, N.label = 6;
              case 6:
                return S < C.length ? (P = C[S], [4, P.shouldRefresh(y, g.userContext)]) : [3, 14];
              case 7:
                if (!N.sent()) return [3, 13];
                N.label = 8;
              case 8:
                return N.trys.push([8, 10, , 11]), [4, P.refresh(g.userContext)];
              case 9:
                return N.sent(), [3, 11];
              case 10:
                return E = N.sent(), console.error(
                  "Encountered an error while refreshing validator ".concat(P.id),
                  E
                ), [3, 11];
              case 11:
                return [
                  4,
                  this.getAccessTokenPayloadSecurely({
                    userContext: g.userContext
                  })
                ];
              case 12:
                y = N.sent(), N.label = 13;
              case 13:
                return S++, [3, 6];
              case 14:
                return [3, 17];
              case 15:
                return (0, i.logDebugMessage)("validateClaims: releasing claim refresh lock"), [4, w.releaseLock(h)];
              case 16:
                return N.sent(), [
                  7
                  /*endfinally*/
                ];
              case 17:
                return [3, 20];
              case 18:
                (0, i.logDebugMessage)("validateClaims: Retrying refresh lock ".concat(x, "/").concat(f)), N.label = 19;
              case 19:
                return [3, 1];
              case 20:
                return x !== f ? [3, 22] : ((0, i.logDebugMessage)("validateClaims: ran out of retries while trying to acquire claim refresh lock"), [
                  4,
                  this.getAccessTokenPayloadSecurely({ userContext: g.userContext })
                ]);
              case 21:
                y = N.sent(), N.label = 22;
              case 22:
                O = [], k = 0, A = g.claimValidators, N.label = 23;
              case 23:
                return k < A.length ? (P = A[k], [4, P.validate(y, g.userContext)]) : [3, 26];
              case 24:
                D = N.sent(), D.isValid || O.push({
                  id: P.id,
                  reason: D.reason
                }), N.label = 25;
              case 25:
                return k++, [3, 23];
              case 26:
                return [2, O];
            }
          });
        });
      },
      shouldDoInterceptionBasedOnUrl: function(g, y, x) {
        if ((0, i.logDebugMessage)(
          "shouldDoInterceptionBasedOnUrl: toCheckUrl: " + g + " apiDomain: " + y + " sessionTokenBackendDomain: " + x
        ), g.includes("superTokensDoNotDoInterception"))
          return !1;
        g = (0, c.normaliseURLDomainOrThrowError)(g);
        var w = new URL(g), _ = w.hostname, S = !1;
        if (y !== "") {
          y = (0, c.normaliseURLDomainOrThrowError)(y);
          var C = new URL(y);
          S = _ === C.hostname;
        }
        if (x === void 0 || S)
          return S;
        var E = (0, c.normaliseSessionScopeOrThrowError)(x);
        return (0, c.matchesDomainOrSubdomain)(_, E);
      },
      calculateClockSkewInMillis: function(g) {
        var y = g.accessTokenPayload;
        (0, i.logDebugMessage)("calculateClockSkewInMillis: called");
        var x = y == null ? void 0 : y.iat;
        if (x === void 0 || typeof x != "number")
          return (0, i.logDebugMessage)(
            "calculateClockSkewInMillis: payload iat is undefined or not a number. This may happen due to an unsupported backend sdk. Returning 0"
          ), 0;
        var w = x * 1e3, _ = w - Date.now();
        return (0, i.logDebugMessage)("calculateClockSkewInMillis: returning " + _), _;
      }
    };
  }
  return G0.default = p, G0;
}
var Dp = {}, jL;
function L$() {
  if (jL) return Dp;
  jL = 1, Object.defineProperty(Dp, "__esModule", { value: !0 }), Dp.PrimitiveClaim = void 0;
  var e = Ko, t = (
    /** @class */
    function() {
      function r(n) {
        var a = this;
        this.validators = {
          hasValue: function(s, i, o) {
            i === void 0 && (i = a.defaultMaxAgeInSeconds);
            var l = e.default.getReferenceOrThrow().dateProvider;
            return {
              id: o !== void 0 ? o : a.id,
              refresh: function(c) {
                return a.refresh(c);
              },
              shouldRefresh: function(c, u) {
                if (i !== void 0 && i < l.getThresholdInSeconds())
                  throw new Error(
                    "maxAgeInSeconds must be greater than or equal to the DateProvider threshold value -> ".concat(
                      l.getThresholdInSeconds()
                    )
                  );
                return a.getValueFromPayload(c, u) === void 0 || // We know payload[this.id] is defined since the value is not undefined in this branch
                i !== void 0 && c[a.id].t < l.now() - i * 1e3;
              },
              validate: function(c, u) {
                var d = a.getValueFromPayload(c, u);
                if (d === void 0)
                  return {
                    isValid: !1,
                    reason: { message: "value does not exist", expectedValue: s, actualValue: d }
                  };
                var f = (l.now() - a.getLastFetchedTime(c, u)) / 1e3;
                return i !== void 0 && f > i ? {
                  isValid: !1,
                  reason: {
                    message: "expired",
                    ageInSeconds: f,
                    maxAgeInSeconds: i
                  }
                } : d !== s ? {
                  isValid: !1,
                  reason: { message: "wrong value", expectedValue: s, actualValue: d }
                } : { isValid: !0 };
              }
            };
          }
        }, this.id = n.id, this.refresh = n.refresh, this.defaultMaxAgeInSeconds = n.defaultMaxAgeInSeconds;
      }
      return r.prototype.getValueFromPayload = function(n, a) {
        return n[this.id] !== void 0 ? n[this.id].v : void 0;
      }, r.prototype.getLastFetchedTime = function(n, a) {
        return n[this.id] !== void 0 ? n[this.id].t : void 0;
      }, r;
    }()
  );
  return Dp.PrimitiveClaim = t, Dp;
}
var Np = {}, FL;
function G5e() {
  if (FL) return Np;
  FL = 1;
  var e = ke && ke.__awaiter || function(a, s, i, o) {
    function l(c) {
      return c instanceof i ? c : new i(function(u) {
        u(c);
      });
    }
    return new (i || (i = Promise))(function(c, u) {
      function d(p) {
        try {
          h(o.next(p));
        } catch (m) {
          u(m);
        }
      }
      function f(p) {
        try {
          h(o.throw(p));
        } catch (m) {
          u(m);
        }
      }
      function h(p) {
        p.done ? c(p.value) : l(p.value).then(d, f);
      }
      h((o = o.apply(a, s || [])).next());
    });
  }, t = ke && ke.__generator || function(a, s) {
    var i = {
      label: 0,
      sent: function() {
        if (c[0] & 1) throw c[1];
        return c[1];
      },
      trys: [],
      ops: []
    }, o, l, c, u;
    return u = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
      return this;
    }), u;
    function d(h) {
      return function(p) {
        return f([h, p]);
      };
    }
    function f(h) {
      if (o) throw new TypeError("Generator is already executing.");
      for (; i; )
        try {
          if (o = 1, l && (c = h[0] & 2 ? l.return : h[0] ? l.throw || ((c = l.return) && c.call(l), 0) : l.next) && !(c = c.call(l, h[1])).done)
            return c;
          switch (l = 0, c && (h = [h[0] & 2, c.value]), h[0]) {
            case 0:
            case 1:
              c = h;
              break;
            case 4:
              return i.label++, { value: h[1], done: !1 };
            case 5:
              i.label++, l = h[1], h = [0];
              continue;
            case 7:
              h = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (c = i.trys, !(c = c.length > 0 && c[c.length - 1]) && (h[0] === 6 || h[0] === 2)) {
                i = 0;
                continue;
              }
              if (h[0] === 3 && (!c || h[1] > c[0] && h[1] < c[3])) {
                i.label = h[1];
                break;
              }
              if (h[0] === 6 && i.label < c[1]) {
                i.label = c[1], c = h;
                break;
              }
              if (c && i.label < c[2]) {
                i.label = c[2], i.ops.push(h);
                break;
              }
              c[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          h = s.call(a, i);
        } catch (p) {
          h = [6, p], l = 0;
        } finally {
          o = c = 0;
        }
      if (h[0] & 5) throw h[1];
      return { value: h[0] ? h[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Np, "__esModule", { value: !0 }), Np.PrimitiveArrayClaim = void 0;
  var r = Ko, n = (
    /** @class */
    function() {
      function a(s) {
        var i = this;
        this.validators = {
          includes: function(o, l, c) {
            l === void 0 && (l = i.defaultMaxAgeInSeconds);
            var u = r.default.getReferenceOrThrow().dateProvider;
            return {
              id: c !== void 0 ? c : i.id,
              refresh: function(d) {
                return i.refresh(d);
              },
              shouldRefresh: function(d, f) {
                if (l !== void 0 && l < u.getThresholdInSeconds())
                  throw new Error(
                    "maxAgeInSeconds must be greater than or equal to the DateProvider threshold value -> ".concat(
                      u.getThresholdInSeconds()
                    )
                  );
                return i.getValueFromPayload(d, f) === void 0 || // We know payload[this.id] is defined since the value is not undefined in this branch
                l !== void 0 && d[i.id].t < u.now() - l * 1e3;
              },
              validate: function(d, f) {
                return e(i, void 0, void 0, function() {
                  var h, p;
                  return t(this, function(m) {
                    return h = this.getValueFromPayload(d, f), h === void 0 ? [
                      2,
                      {
                        isValid: !1,
                        reason: {
                          message: "value does not exist",
                          expectedToInclude: o,
                          actualValue: h
                        }
                      }
                    ] : (p = (u.now() - this.getLastFetchedTime(d, f)) / 1e3, l !== void 0 && p > l ? [
                      2,
                      {
                        isValid: !1,
                        reason: {
                          message: "expired",
                          ageInSeconds: p,
                          maxAgeInSeconds: l
                        }
                      }
                    ] : h.includes(o) ? [2, { isValid: !0 }] : [
                      2,
                      {
                        isValid: !1,
                        reason: {
                          message: "wrong value",
                          expectedToInclude: o,
                          actualValue: h
                        }
                      }
                    ]);
                  });
                });
              }
            };
          },
          excludes: function(o, l, c) {
            l === void 0 && (l = i.defaultMaxAgeInSeconds);
            var u = r.default.getReferenceOrThrow().dateProvider;
            return {
              id: c !== void 0 ? c : i.id,
              refresh: function(d) {
                return i.refresh(d);
              },
              shouldRefresh: function(d, f) {
                if (l !== void 0 && l < u.getThresholdInSeconds())
                  throw new Error(
                    "maxAgeInSeconds must be greater than or equal to the DateProvider threshold value -> ".concat(
                      u.getThresholdInSeconds()
                    )
                  );
                return i.getValueFromPayload(d, f) === void 0 || // We know payload[this.id] is defined since the value is not undefined in this branch
                l !== void 0 && d[i.id].t < u.now() - l * 1e3;
              },
              validate: function(d, f) {
                return e(i, void 0, void 0, function() {
                  var h, p;
                  return t(this, function(m) {
                    return h = this.getValueFromPayload(d, f), h === void 0 ? [
                      2,
                      {
                        isValid: !1,
                        reason: {
                          message: "value does not exist",
                          expectedToNotInclude: o,
                          actualValue: h
                        }
                      }
                    ] : (p = (u.now() - this.getLastFetchedTime(d, f)) / 1e3, l !== void 0 && p > l ? [
                      2,
                      {
                        isValid: !1,
                        reason: {
                          message: "expired",
                          ageInSeconds: p,
                          maxAgeInSeconds: l
                        }
                      }
                    ] : h.includes(o) ? [
                      2,
                      {
                        isValid: !1,
                        reason: {
                          message: "wrong value",
                          expectedToNotInclude: o,
                          actualValue: h
                        }
                      }
                    ] : [2, { isValid: !0 }]);
                  });
                });
              }
            };
          },
          includesAll: function(o, l, c) {
            l === void 0 && (l = i.defaultMaxAgeInSeconds);
            var u = r.default.getReferenceOrThrow().dateProvider;
            return {
              id: c !== void 0 ? c : i.id,
              refresh: function(d) {
                return i.refresh(d);
              },
              shouldRefresh: function(d, f) {
                if (l !== void 0 && l < u.getThresholdInSeconds())
                  throw new Error(
                    "maxAgeInSeconds must be greater than or equal to the DateProvider threshold value -> ".concat(
                      u.getThresholdInSeconds()
                    )
                  );
                return i.getValueFromPayload(d, f) === void 0 || // We know payload[this.id] is defined since the value is not undefined in this branch
                l !== void 0 && d[i.id].t < u.now() - l * 1e3;
              },
              validate: function(d, f) {
                return e(i, void 0, void 0, function() {
                  var h, p, m, g;
                  return t(this, function(y) {
                    return h = this.getValueFromPayload(d, f), h === void 0 ? [
                      2,
                      {
                        isValid: !1,
                        reason: {
                          message: "value does not exist",
                          expectedToInclude: o,
                          actualValue: h
                        }
                      }
                    ] : (p = (u.now() - this.getLastFetchedTime(d, f)) / 1e3, l !== void 0 && p > l ? [
                      2,
                      {
                        isValid: !1,
                        reason: {
                          message: "expired",
                          ageInSeconds: p,
                          maxAgeInSeconds: l
                        }
                      }
                    ] : (m = new Set(h), g = o.every(function(x) {
                      return m.has(x);
                    }), [
                      2,
                      g ? { isValid: g } : {
                        isValid: g,
                        reason: {
                          message: "wrong value",
                          expectedToInclude: o,
                          actualValue: h
                        }
                      }
                    ]));
                  });
                });
              }
            };
          },
          includesAny: function(o, l, c) {
            l === void 0 && (l = i.defaultMaxAgeInSeconds);
            var u = r.default.getReferenceOrThrow().dateProvider;
            return {
              id: c !== void 0 ? c : i.id,
              refresh: function(d) {
                return i.refresh(d);
              },
              shouldRefresh: function(d, f) {
                if (l !== void 0 && l < u.getThresholdInSeconds())
                  throw new Error(
                    "maxAgeInSeconds must be greater than or equal to the DateProvider threshold value -> ".concat(
                      u.getThresholdInSeconds()
                    )
                  );
                return i.getValueFromPayload(d, f) === void 0 || // We know payload[this.id] is defined since the value is not undefined in this branch
                l !== void 0 && d[i.id].t < u.now() - l * 1e3;
              },
              validate: function(d, f) {
                return e(i, void 0, void 0, function() {
                  var h, p, m, g;
                  return t(this, function(y) {
                    return h = this.getValueFromPayload(d, f), h === void 0 ? [
                      2,
                      {
                        isValid: !1,
                        reason: {
                          message: "value does not exist",
                          expectedToInclude: o,
                          actualValue: h
                        }
                      }
                    ] : (p = (u.now() - this.getLastFetchedTime(d, f)) / 1e3, l !== void 0 && p > l ? [
                      2,
                      {
                        isValid: !1,
                        reason: {
                          message: "expired",
                          ageInSeconds: p,
                          maxAgeInSeconds: l
                        }
                      }
                    ] : (m = new Set(h), g = o.some(function(x) {
                      return m.has(x);
                    }), [
                      2,
                      g ? { isValid: g } : {
                        isValid: g,
                        reason: {
                          message: "wrong value",
                          expectedToIncludeAtLeastOneOf: o,
                          actualValue: h
                        }
                      }
                    ]));
                  });
                });
              }
            };
          },
          excludesAll: function(o, l, c) {
            l === void 0 && (l = i.defaultMaxAgeInSeconds);
            var u = r.default.getReferenceOrThrow().dateProvider;
            return {
              id: c !== void 0 ? c : i.id,
              refresh: function(d) {
                return i.refresh(d);
              },
              shouldRefresh: function(d, f) {
                if (l !== void 0 && l < u.getThresholdInSeconds())
                  throw new Error(
                    "maxAgeInSeconds must be greater than or equal to the DateProvider threshold value -> ".concat(
                      u.getThresholdInSeconds()
                    )
                  );
                return i.getValueFromPayload(d, f) === void 0 || // We know payload[this.id] is defined since the value is not undefined in this branch
                l !== void 0 && d[i.id].t < u.now() - l * 1e3;
              },
              validate: function(d, f) {
                return e(i, void 0, void 0, function() {
                  var h, p, m, g;
                  return t(this, function(y) {
                    return h = this.getValueFromPayload(d, f), h === void 0 ? [
                      2,
                      {
                        isValid: !1,
                        reason: {
                          message: "value does not exist",
                          expectedToNotInclude: o,
                          actualValue: h
                        }
                      }
                    ] : (p = (u.now() - this.getLastFetchedTime(d, f)) / 1e3, l !== void 0 && p > l ? [
                      2,
                      {
                        isValid: !1,
                        reason: {
                          message: "expired",
                          ageInSeconds: p,
                          maxAgeInSeconds: l
                        }
                      }
                    ] : (m = new Set(h), g = o.every(function(x) {
                      return !m.has(x);
                    }), [
                      2,
                      g ? { isValid: g } : {
                        isValid: g,
                        reason: {
                          message: "wrong value",
                          expectedToNotInclude: o,
                          actualValue: h
                        }
                      }
                    ]));
                  });
                });
              }
            };
          }
        }, this.id = s.id, this.refresh = s.refresh, this.defaultMaxAgeInSeconds = s.defaultMaxAgeInSeconds;
      }
      return a.prototype.getValueFromPayload = function(s, i) {
        return s[this.id] !== void 0 ? s[this.id].v : void 0;
      }, a.prototype.getLastFetchedTime = function(s, i) {
        return s[this.id] !== void 0 ? s[this.id].t : void 0;
      }, a;
    }()
  );
  return Np.PrimitiveArrayClaim = n, Np;
}
var Mp = {}, BL;
function Y5e() {
  if (BL) return Mp;
  BL = 1;
  var e = ke && ke.__extends || /* @__PURE__ */ function() {
    var a = function(s, i) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, l) {
        o.__proto__ = l;
      } || function(o, l) {
        for (var c in l) Object.prototype.hasOwnProperty.call(l, c) && (o[c] = l[c]);
      }, a(s, i);
    };
    return function(s, i) {
      if (typeof i != "function" && i !== null)
        throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
      a(s, i);
      function o() {
        this.constructor = s;
      }
      s.prototype = i === null ? Object.create(i) : (o.prototype = i.prototype, new o());
    };
  }(), t = ke && ke.__assign || function() {
    return t = Object.assign || function(a) {
      for (var s, i = 1, o = arguments.length; i < o; i++) {
        s = arguments[i];
        for (var l in s) Object.prototype.hasOwnProperty.call(s, l) && (a[l] = s[l]);
      }
      return a;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(Mp, "__esModule", { value: !0 }), Mp.BooleanClaim = void 0;
  var r = L$(), n = (
    /** @class */
    function(a) {
      e(s, a);
      function s(i) {
        var o = a.call(this, i) || this;
        return o.validators = t(t({}, o.validators), {
          isTrue: function(l) {
            return o.validators.hasValue(!0, l);
          },
          isFalse: function(l) {
            return o.validators.hasValue(!1, l);
          }
        }), o;
      }
      return s;
    }(r.PrimitiveClaim)
  );
  return Mp.BooleanClaim = n, Mp;
}
var UL;
function X5e() {
  return UL || (UL = 1, function(e) {
    var t = ke && ke.__awaiter || function(y, x, w, _) {
      function S(C) {
        return C instanceof w ? C : new w(function(E) {
          E(C);
        });
      }
      return new (w || (w = Promise))(function(C, E) {
        function O(P) {
          try {
            A(_.next(P));
          } catch (D) {
            E(D);
          }
        }
        function k(P) {
          try {
            A(_.throw(P));
          } catch (D) {
            E(D);
          }
        }
        function A(P) {
          P.done ? C(P.value) : S(P.value).then(O, k);
        }
        A((_ = _.apply(y, x || [])).next());
      });
    }, r = ke && ke.__generator || function(y, x) {
      var w = {
        label: 0,
        sent: function() {
          if (C[0] & 1) throw C[1];
          return C[1];
        },
        trys: [],
        ops: []
      }, _, S, C, E;
      return E = { next: O(0), throw: O(1), return: O(2) }, typeof Symbol == "function" && (E[Symbol.iterator] = function() {
        return this;
      }), E;
      function O(A) {
        return function(P) {
          return k([A, P]);
        };
      }
      function k(A) {
        if (_) throw new TypeError("Generator is already executing.");
        for (; w; )
          try {
            if (_ = 1, S && (C = A[0] & 2 ? S.return : A[0] ? S.throw || ((C = S.return) && C.call(S), 0) : S.next) && !(C = C.call(S, A[1])).done)
              return C;
            switch (S = 0, C && (A = [A[0] & 2, C.value]), A[0]) {
              case 0:
              case 1:
                C = A;
                break;
              case 4:
                return w.label++, { value: A[1], done: !1 };
              case 5:
                w.label++, S = A[1], A = [0];
                continue;
              case 7:
                A = w.ops.pop(), w.trys.pop();
                continue;
              default:
                if (C = w.trys, !(C = C.length > 0 && C[C.length - 1]) && (A[0] === 6 || A[0] === 2)) {
                  w = 0;
                  continue;
                }
                if (A[0] === 3 && (!C || A[1] > C[0] && A[1] < C[3])) {
                  w.label = A[1];
                  break;
                }
                if (A[0] === 6 && w.label < C[1]) {
                  w.label = C[1], C = A;
                  break;
                }
                if (C && w.label < C[2]) {
                  w.label = C[2], w.ops.push(A);
                  break;
                }
                C[2] && w.ops.pop(), w.trys.pop();
                continue;
            }
            A = x.call(y, w);
          } catch (P) {
            A = [6, P], S = 0;
          } finally {
            _ = C = 0;
          }
        if (A[0] & 5) throw A[1];
        return { value: A[0] ? A[1] : void 0, done: !0 };
      }
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.BooleanClaim = e.PrimitiveArrayClaim = e.PrimitiveClaim = e.getInvalidClaimsFromResponse = e.getClaimValue = e.validateClaims = e.signOut = e.addAxiosInterceptors = e.doesSessionExist = e.attemptRefreshingSession = e.getAccessToken = e.getAccessTokenPayloadSecurely = e.getUserId = e.init = void 0;
    var n = $h, a = q5e(), s = qo, i = n2(), o = md, l = yi, c = i2(), u = gd, d = Jg(), f = Ko, h = (
      /** @class */
      function() {
        function y() {
        }
        y.init = function(w) {
          o.default.init(w.cookieHandler), l.default.init(w.windowHandler), f.default.init(w.dateProvider), c.default.init(
            w.lockFactory,
            l.default.getReferenceOrThrow().windowHandler.localStorage
          );
          var _ = (0, i.validateAndNormaliseInputOrThrowError)(w);
          w.enableDebugLogs !== void 0 && w.enableDebugLogs && (0, d.enableLogging)();
          var S = new s.default(
            (0, a.default)({
              onHandleEvent: _.onHandleEvent,
              preAPIHook: _.preAPIHook,
              postAPIHook: _.postAPIHook,
              sessionExpiredStatusCode: _.sessionExpiredStatusCode
            })
          ).override(_.override.functions).build();
          n.default.init(_, S), y.axiosInterceptorQueue.forEach(function(C) {
            C();
          }), y.axiosInterceptorQueue = [];
        }, y.getUserId = function(w) {
          return n.default.recipeImpl.getUserId({
            userContext: (0, i.getNormalisedUserContext)(w === void 0 ? void 0 : w.userContext)
          });
        }, y.getAccessTokenPayloadSecurely = function(w) {
          return t(this, void 0, void 0, function() {
            return r(this, function(_) {
              return [
                2,
                n.default.recipeImpl.getAccessTokenPayloadSecurely({
                  userContext: (0, i.getNormalisedUserContext)(
                    w === void 0 ? void 0 : w.userContext
                  )
                })
              ];
            });
          });
        };
        var x;
        return x = y, y.axiosInterceptorQueue = [], y.attemptRefreshingSession = function() {
          return t(void 0, void 0, void 0, function() {
            return r(x, function(w) {
              return [2, n.default.attemptRefreshingSession()];
            });
          });
        }, y.doesSessionExist = function(w) {
          return n.default.recipeImpl.doesSessionExist({
            userContext: (0, i.getNormalisedUserContext)(w === void 0 ? void 0 : w.userContext)
          });
        }, y.addAxiosInterceptors = function(w, _) {
          n.default.initCalled ? n.default.recipeImpl.addAxiosInterceptors({
            axiosInstance: w,
            userContext: (0, i.getNormalisedUserContext)(_)
          }) : y.axiosInterceptorQueue.push(function() {
            n.default.recipeImpl.addAxiosInterceptors({
              axiosInstance: w,
              userContext: (0, i.getNormalisedUserContext)(_)
            });
          });
        }, y.signOut = function(w) {
          return n.default.recipeImpl.signOut({
            userContext: (0, i.getNormalisedUserContext)(w === void 0 ? void 0 : w.userContext)
          });
        }, y.getInvalidClaimsFromResponse = function(w) {
          return t(this, void 0, void 0, function() {
            return r(this, function(_) {
              return [
                2,
                n.default.recipeImpl.getInvalidClaimsFromResponse({
                  response: w.response,
                  userContext: (0, i.getNormalisedUserContext)(w.userContext)
                })
              ];
            });
          });
        }, y.getClaimValue = function(w) {
          return t(this, void 0, void 0, function() {
            var _, S;
            return r(this, function(C) {
              switch (C.label) {
                case 0:
                  return _ = (0, i.getNormalisedUserContext)(
                    w === void 0 ? void 0 : w.userContext
                  ), [
                    4,
                    y.getAccessTokenPayloadSecurely({ userContext: _ })
                  ];
                case 1:
                  return S = C.sent(), [2, w.claim.getValueFromPayload(S, _)];
              }
            });
          });
        }, y.validateClaims = function(w, _) {
          var S = (0, i.getNormalisedUserContext)(_), C = u.SessionClaimValidatorStore.getClaimValidatorsAddedByOtherRecipes(), E = n.default.recipeImpl.getGlobalClaimValidators({
            claimValidatorsAddedByOtherRecipes: C,
            userContext: S
          }), O = w !== void 0 ? w(E, S) : E;
          return O.length === 0 ? [] : n.default.recipeImpl.validateClaims({
            claimValidators: O,
            userContext: (0, i.getNormalisedUserContext)(_)
          });
        }, y.getAccessToken = function(w) {
          return t(void 0, void 0, void 0, function() {
            return r(x, function(_) {
              switch (_.label) {
                case 0:
                  return [
                    4,
                    n.default.recipeImpl.doesSessionExist({
                      userContext: (0, i.getNormalisedUserContext)(
                        w === void 0 ? void 0 : w.userContext
                      )
                    })
                  ];
                case 1:
                  return _.sent() ? [2, (0, n.getTokenForHeaderAuth)("access")] : [2, void 0];
              }
            });
          });
        }, y;
      }()
    );
    e.default = h, e.init = h.init, e.getUserId = h.getUserId, e.getAccessTokenPayloadSecurely = h.getAccessTokenPayloadSecurely, e.getAccessToken = h.getAccessToken, e.attemptRefreshingSession = h.attemptRefreshingSession, e.doesSessionExist = h.doesSessionExist, e.addAxiosInterceptors = h.addAxiosInterceptors, e.signOut = h.signOut, e.validateClaims = h.validateClaims, e.getClaimValue = h.getClaimValue, e.getInvalidClaimsFromResponse = h.getInvalidClaimsFromResponse;
    var p = L$();
    Object.defineProperty(e, "PrimitiveClaim", {
      enumerable: !0,
      get: function() {
        return p.PrimitiveClaim;
      }
    });
    var m = G5e();
    Object.defineProperty(e, "PrimitiveArrayClaim", {
      enumerable: !0,
      get: function() {
        return m.PrimitiveArrayClaim;
      }
    });
    var g = Y5e();
    Object.defineProperty(e, "BooleanClaim", {
      enumerable: !0,
      get: function() {
        return g.BooleanClaim;
      }
    });
  }(cS)), cS;
}
var VL;
function j$() {
  return VL || (VL = 1, function(e) {
    function t(r) {
      for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
    }
    e.__esModule = !0, t(X5e());
  }(lS)), lS;
}
var rv = {};
Object.defineProperty(rv, "__esModule", { value: !0 });
rv.EMAILVERIFICATION_CLAIM_ID = void 0;
rv.EMAILVERIFICATION_CLAIM_ID = "st-ev";
var Q5e = ke && ke.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ti = ke && ke.__assign || function() {
  return ti = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, ti.apply(this, arguments);
}, Y0 = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, X0 = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, $L = ke && ke.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, a = t.length, s; n < a; n++)
      (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
};
Object.defineProperty(Wh, "__esModule", { value: !0 });
Wh.Recipe = void 0;
var J5e = Px, _i = j$(), HL = ur, Z5e = rv, WL = [Z5e.EMAILVERIFICATION_CLAIM_ID], F$ = (
  /** @class */
  function(e) {
    Q5e(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.getUserId = function(a) {
        return _i.default.getUserId({
          userContext: a.userContext
        });
      }, n.getAccessToken = function(a) {
        return Y0(n, void 0, void 0, function() {
          return X0(this, function(s) {
            return [
              2,
              _i.default.getAccessToken({
                userContext: a.userContext
              })
            ];
          });
        });
      }, n.getAccessTokenPayloadSecurely = function(a) {
        return Y0(n, void 0, void 0, function() {
          return X0(this, function(s) {
            return [
              2,
              _i.default.getAccessTokenPayloadSecurely({
                userContext: a.userContext
              })
            ];
          });
        });
      }, n.doesSessionExist = function(a) {
        return _i.default.doesSessionExist({
          userContext: a.userContext
        });
      }, n.signOut = function(a) {
        return _i.default.signOut({
          userContext: a.userContext
        });
      }, n.attemptRefreshingSession = function() {
        return Y0(n, void 0, void 0, function() {
          return X0(this, function(a) {
            return [2, _i.default.attemptRefreshingSession()];
          });
        });
      }, n.validateClaims = function(a) {
        return _i.default.validateClaims(a.overrideGlobalClaimValidators, a.userContext);
      }, _i.default.init(
        ti(ti({}, r), {
          override: {
            functions: function(a, s) {
              var i;
              return s.override(function(o) {
                return ti(ti({}, o), {
                  getGlobalClaimValidators: function(l) {
                    var c = o.getGlobalClaimValidators(l);
                    return $L(
                      $L(
                        [],
                        c.filter(function(u) {
                          return WL.includes(u.id);
                        }),
                        !0
                      ),
                      c.filter(function(u) {
                        return !WL.includes(u.id);
                      }),
                      !0
                    );
                  }
                });
              }), !((i = r.override) === null || i === void 0) && i.functions && s.override(r.override.functions), a;
            }
          },
          preAPIHook: function(a) {
            return Y0(n, void 0, void 0, function() {
              var s, i;
              return X0(this, function(o) {
                return s = new Headers(a.requestInit.headers), s.set("rid", r.recipeId), i = ti(ti({}, a), {
                  requestInit: ti(ti({}, a.requestInit), { headers: s })
                }), r.preAPIHook === void 0 ? [2, i] : [2, r.preAPIHook(a)];
              });
            });
          },
          apiDomain: r.appInfo.apiDomain.getAsStringDangerous(),
          apiBasePath: r.appInfo.apiBasePath.getAsStringDangerous()
        })
      ), n;
    }
    return t.init = function(r) {
      return function(n, a, s) {
        return t.instance = new t(
          ti(ti({}, r), {
            appInfo: n,
            recipeId: t.RECIPE_ID,
            enableDebugLogs: s
          })
        ), t.instance;
      };
    }, t.prototype.getClaimValue = function(r) {
      return _i.default.getClaimValue(r);
    }, t.prototype.getInvalidClaimsFromResponse = function(r) {
      return _i.default.getInvalidClaimsFromResponse(r);
    }, t.addAxiosInterceptors = function(r, n) {
      return _i.default.addAxiosInterceptors(r, n);
    }, t.getInstanceOrThrow = function() {
      if (t.instance === void 0) {
        var r = "No instance of Session found. Ensure that the 'Session.init' method is called within the 'SuperTokens.init' recipeList.";
        throw r = (0, HL.checkForSSRErrorAndAppendIfNeeded)(r), Error(r);
      }
      return t.instance;
    }, t.reset = function() {
      (0, HL.isTest)() && (t.instance = void 0);
    }, t.RECIPE_ID = "session", t;
  }(J5e.default)
);
Wh.Recipe = F$;
Wh.default = F$;
var eBe = ke && ke.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), tBe = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, rBe = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(Hh, "__esModule", { value: !0 });
var nBe = Px, aBe = Wh, sBe = (
  /** @class */
  function(e) {
    eBe(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.signOut = function(a) {
        return tBe(n, void 0, void 0, function() {
          return rBe(this, function(s) {
            switch (s.label) {
              case 0:
                return [
                  4,
                  aBe.default.getInstanceOrThrow().signOut({
                    userContext: a.userContext
                  })
                ];
              case 1:
                return [2, s.sent()];
            }
          });
        });
      }, n;
    }
    return t;
  }(nBe.default)
);
Hh.default = sBe;
var iBe = ke && ke.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ub = ke && ke.__assign || function() {
  return Ub = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Ub.apply(this, arguments);
};
Object.defineProperty(Qc, "__esModule", { value: !0 });
Qc.Recipe = void 0;
var oBe = Ox, lBe = qo, cBe = ev, zL = ur, uBe = Hh, B$ = (
  /** @class */
  function(e) {
    iBe(t, e);
    function t(r) {
      var n = e.call(this, (0, oBe.normaliseUserInput)(r)) || this, a = new lBe.default(
        (0, cBe.default)({
          recipeId: n.config.recipeId,
          appInfo: n.config.appInfo,
          clientType: n.config.clientType,
          preAPIHook: n.config.preAPIHook,
          postAPIHook: n.config.postAPIHook
        })
      );
      return n.recipeImplementation = a.override(n.config.override.functions).build(), n;
    }
    return t.init = function(r) {
      return function(n, a) {
        return t.instance = new t(
          Ub(Ub({}, r), { recipeId: t.RECIPE_ID, appInfo: n, clientType: a })
        ), t.instance;
      };
    }, t.getInstanceOrThrow = function() {
      if (t.instance === void 0) {
        var r = "No instance of Multitenancy found. Ensure that 'SuperTokens.init' method has been called.";
        throw r = (0, zL.checkForSSRErrorAndAppendIfNeeded)(r), Error(r);
      }
      return t.instance;
    }, t.reset = function() {
      (0, zL.isTest)() && (t.instance = void 0);
    }, t.RECIPE_ID = "multitenancy", t;
  }(uBe.default)
);
Qc.Recipe = B$;
Qc.default = B$;
var U$ = {}, u2 = {};
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(Ko);
})(u2);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DateProviderReference = void 0;
  var t = u2;
  Object.defineProperty(e, "DateProviderReference", {
    enumerable: !0,
    get: function() {
      return t.DateProviderReference;
    }
  });
})(U$);
Object.defineProperty(t2, "__esModule", { value: !0 });
var uS = ur, dBe = l2, fBe = _x, hBe = vd, dS = Qc, pBe = U$, mBe = (
  /** @class */
  function() {
    function e(t) {
      var r = this;
      if (this.recipeList = [], this.appInfo = (0, uS.normaliseInputAppInfoOrThrowError)(t.appInfo), t.recipeList === void 0 || t.recipeList.length === 0)
        throw new Error(
          "Please provide at least one recipe to the supertokens.init function call. See https://supertokens.io/docs/emailpassword/quick-setup/frontend"
        );
      var n = !1;
      t.enableDebugLogs !== void 0 && (n = t.enableDebugLogs);
      var a = !1;
      this.recipeList = t.recipeList.map(function(s) {
        var i = s(r.appInfo, t.clientType, n);
        return i.config.recipeId === dS.Recipe.RECIPE_ID && (a = !0), i;
      }), a || this.recipeList.push(dS.Recipe.init()(this.appInfo, t.clientType, n));
    }
    return e.init = function(t) {
      if (dBe.CookieHandlerReference.init(t.cookieHandler), fBe.WindowHandlerReference.init(t.windowHandler), pBe.DateProviderReference.init(t.dateProvider), e.instance !== void 0) {
        console.warn("SuperTokens was already initialized");
        return;
      }
      e.instance = new e(t), hBe.PostSuperTokensInitCallbacks.runPostInitCallbacks();
    }, e.getInstanceOrThrow = function() {
      if (e.instance === void 0) {
        var t = "SuperTokens must be initialized before calling this method.";
        throw t = (0, uS.checkForSSRErrorAndAppendIfNeeded)(t), new Error(t);
      }
      return e.instance;
    }, e.reset = function() {
      if (!(0, uS.isTest)()) {
        console.warn("Calling reset() is only supported during testing");
        return;
      }
      dS.Recipe.reset(), e.instance = void 0;
    }, e;
  }()
);
t2.default = mBe;
Object.defineProperty(Qg, "__esModule", { value: !0 });
Qg.init = void 0;
var gBe = t2, V$ = (
  /** @class */
  function() {
    function e() {
    }
    return e.init = function(t) {
      gBe.default.init(t);
    }, e;
  }()
);
Qg.default = V$;
Qg.init = V$.init;
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(Qg);
})(S$);
var $$ = {};
(function(e) {
  function t(n) {
    for (var a in n) e.hasOwnProperty(a) || (e[a] = n[a]);
  }
  e.__esModule = !0;
  let r = l2;
  r.default !== void 0 ? t(r) : t({
    default: r,
    ...r
  });
})($$);
var Rx = {};
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(vd);
})(Rx);
var nv = {};
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(_x);
})(nv);
var d2 = {}, H$ = {}, ph = {}, Ix = {};
(function(e) {
  var t = ke && ke.__awaiter || function(x, w, _, S) {
    function C(E) {
      return E instanceof _ ? E : new _(function(O) {
        O(E);
      });
    }
    return new (_ || (_ = Promise))(function(E, O) {
      function k(D) {
        try {
          P(S.next(D));
        } catch (N) {
          O(N);
        }
      }
      function A(D) {
        try {
          P(S.throw(D));
        } catch (N) {
          O(N);
        }
      }
      function P(D) {
        D.done ? E(D.value) : C(D.value).then(k, A);
      }
      P((S = S.apply(x, w || [])).next());
    });
  }, r = ke && ke.__generator || function(x, w) {
    var _ = {
      label: 0,
      sent: function() {
        if (E[0] & 1) throw E[1];
        return E[1];
      },
      trys: [],
      ops: []
    }, S, C, E, O;
    return O = { next: k(0), throw: k(1), return: k(2) }, typeof Symbol == "function" && (O[Symbol.iterator] = function() {
      return this;
    }), O;
    function k(P) {
      return function(D) {
        return A([P, D]);
      };
    }
    function A(P) {
      if (S) throw new TypeError("Generator is already executing.");
      for (; _; )
        try {
          if (S = 1, C && (E = P[0] & 2 ? C.return : P[0] ? C.throw || ((E = C.return) && E.call(C), 0) : C.next) && !(E = E.call(C, P[1])).done)
            return E;
          switch (C = 0, E && (P = [P[0] & 2, E.value]), P[0]) {
            case 0:
            case 1:
              E = P;
              break;
            case 4:
              return _.label++, { value: P[1], done: !1 };
            case 5:
              _.label++, C = P[1], P = [0];
              continue;
            case 7:
              P = _.ops.pop(), _.trys.pop();
              continue;
            default:
              if (E = _.trys, !(E = E.length > 0 && E[E.length - 1]) && (P[0] === 6 || P[0] === 2)) {
                _ = 0;
                continue;
              }
              if (P[0] === 3 && (!E || P[1] > E[0] && P[1] < E[3])) {
                _.label = P[1];
                break;
              }
              if (P[0] === 6 && _.label < E[1]) {
                _.label = E[1], E = P;
                break;
              }
              if (E && _.label < E[2]) {
                _.label = E[2], _.ops.push(P);
                break;
              }
              E[2] && _.ops.pop(), _.trys.pop();
              continue;
          }
          P = w.call(x, _);
        } catch (D) {
          P = [6, D], C = 0;
        } finally {
          S = E = 0;
        }
      if (P[0] & 5) throw P[1];
      return { value: P[0] ? P[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getInvalidClaimsFromResponse = e.getClaimValue = e.validateClaims = e.signOut = e.addAxiosInterceptors = e.doesSessionExist = e.attemptRefreshingSession = e.getAccessToken = e.getAccessTokenPayloadSecurely = e.getUserId = e.init = e.BooleanClaim = e.PrimitiveArrayClaim = e.PrimitiveClaim = void 0;
  var n = ur, a = Wh, s = (
    /** @class */
    function() {
      function x() {
      }
      return x.init = function(w) {
        return a.default.init(w);
      }, x.getUserId = function(w) {
        return a.default.getInstanceOrThrow().getUserId({
          userContext: (0, n.getNormalisedUserContext)(
            w == null ? void 0 : w.userContext
          )
        });
      }, x.getAccessToken = function(w) {
        return a.default.getInstanceOrThrow().getAccessToken({
          userContext: (0, n.getNormalisedUserContext)(
            w == null ? void 0 : w.userContext
          )
        });
      }, x.getAccessTokenPayloadSecurely = function(w) {
        return t(this, void 0, void 0, function() {
          return r(this, function(_) {
            return [
              2,
              a.default.getInstanceOrThrow().getAccessTokenPayloadSecurely({
                userContext: (0, n.getNormalisedUserContext)(
                  w == null ? void 0 : w.userContext
                )
              })
            ];
          });
        });
      }, x.attemptRefreshingSession = function() {
        return t(this, void 0, void 0, function() {
          return r(this, function(w) {
            return [2, a.default.getInstanceOrThrow().attemptRefreshingSession()];
          });
        });
      }, x.doesSessionExist = function(w) {
        return a.default.getInstanceOrThrow().doesSessionExist({
          userContext: (0, n.getNormalisedUserContext)(
            w == null ? void 0 : w.userContext
          )
        });
      }, x.addAxiosInterceptors = function(w, _) {
        return a.default.addAxiosInterceptors(w, (0, n.getNormalisedUserContext)(_));
      }, x.signOut = function(w) {
        return a.default.getInstanceOrThrow().signOut({
          userContext: (0, n.getNormalisedUserContext)(
            w == null ? void 0 : w.userContext
          )
        });
      }, x.getClaimValue = function(w) {
        return a.default.getInstanceOrThrow().getClaimValue({
          claim: w.claim,
          userContext: (0, n.getNormalisedUserContext)(
            w == null ? void 0 : w.userContext
          )
        });
      }, x.validateClaims = function(w) {
        return a.default.getInstanceOrThrow().validateClaims({
          overrideGlobalClaimValidators: w == null ? void 0 : w.overrideGlobalClaimValidators,
          userContext: (0, n.getNormalisedUserContext)(
            w == null ? void 0 : w.userContext
          )
        });
      }, x.getInvalidClaimsFromResponse = function(w) {
        return a.default.getInstanceOrThrow().getInvalidClaimsFromResponse({
          response: w.response,
          userContext: (0, n.getNormalisedUserContext)(
            w == null ? void 0 : w.userContext
          )
        });
      }, x;
    }()
  );
  e.default = s;
  var i = s.init;
  e.init = i;
  var o = s.getUserId;
  e.getUserId = o;
  var l = s.getAccessTokenPayloadSecurely;
  e.getAccessTokenPayloadSecurely = l;
  var c = s.getAccessToken;
  e.getAccessToken = c;
  var u = s.attemptRefreshingSession;
  e.attemptRefreshingSession = u;
  var d = s.doesSessionExist;
  e.doesSessionExist = d;
  var f = s.addAxiosInterceptors;
  e.addAxiosInterceptors = f;
  var h = s.signOut;
  e.signOut = h;
  var p = s.validateClaims;
  e.validateClaims = p;
  var m = s.getClaimValue;
  e.getClaimValue = m;
  var g = s.getInvalidClaimsFromResponse;
  e.getInvalidClaimsFromResponse = g;
  var y = j$();
  Object.defineProperty(e, "PrimitiveClaim", {
    enumerable: !0,
    get: function() {
      return y.PrimitiveClaim;
    }
  }), Object.defineProperty(e, "PrimitiveArrayClaim", {
    enumerable: !0,
    get: function() {
      return y.PrimitiveArrayClaim;
    }
  }), Object.defineProperty(e, "BooleanClaim", {
    enumerable: !0,
    get: function() {
      return y.BooleanClaim;
    }
  });
})(Ix);
var vBe = ke && ke.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Vb = ke && ke.__assign || function() {
  return Vb = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Vb.apply(this, arguments);
}, KL = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, qL = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(ph, "__esModule", { value: !0 });
ph.AllowedDomainsClaim = ph.AllowedDomainsClaimClass = void 0;
var yBe = r2, bBe = Ix, W$ = (
  /** @class */
  function(e) {
    vBe(t, e);
    function t() {
      var r = e.call(this, {
        id: "st-t-dmns",
        refresh: function() {
          return KL(r, void 0, void 0, function() {
            return qL(this, function(n) {
              return [
                2
                /*return*/
              ];
            });
          });
        },
        defaultMaxAgeInSeconds: Number.MAX_SAFE_INTEGER
      }) || this;
      return r.validators = Vb(Vb({}, r.validators), {
        hasAccessToCurrentDomain: function() {
          return {
            id: r.id,
            refresh: r.refresh,
            shouldRefresh: function() {
              return !1;
            },
            validate: function(n, a) {
              return KL(r, void 0, void 0, function() {
                var s, i;
                return qL(this, function(o) {
                  return s = yBe.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getHostName(), i = this.validators.includes(
                    s,
                    Number.MAX_SAFE_INTEGER,
                    this.id
                  ), [2, i.validate(n, a)];
                });
              });
            }
          };
        }
      }), r;
    }
    return t;
  }(bBe.PrimitiveArrayClaim)
);
ph.AllowedDomainsClaimClass = W$;
ph.AllowedDomainsClaim = new W$();
(function(e) {
  var t = ke && ke.__assign || function() {
    return t = Object.assign || function(c) {
      for (var u, d = 1, f = arguments.length; d < f; d++) {
        u = arguments[d];
        for (var h in u) Object.prototype.hasOwnProperty.call(u, h) && (c[h] = u[h]);
      }
      return c;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AllowedDomainsClaim = e.getTenantId = e.getLoginMethods = e.init = void 0;
  var r = ur, n = ph;
  Object.defineProperty(e, "AllowedDomainsClaim", {
    enumerable: !0,
    get: function() {
      return n.AllowedDomainsClaim;
    }
  });
  var a = Qc, s = (
    /** @class */
    function() {
      function c() {
      }
      return c.init = function(u) {
        return a.default.init(u);
      }, c.getLoginMethods = function(u) {
        return a.default.getInstanceOrThrow().recipeImplementation.getLoginMethods(
          t(t({}, u), {
            userContext: (0, r.getNormalisedUserContext)(
              u == null ? void 0 : u.userContext
            )
          })
        );
      }, c.getTenantId = function(u) {
        return a.default.getInstanceOrThrow().recipeImplementation.getTenantId(
          t(t({}, u), {
            userContext: (0, r.getNormalisedUserContext)(
              u == null ? void 0 : u.userContext
            )
          })
        );
      }, c.AllowedDomainsClaim = n.AllowedDomainsClaim, c;
    }()
  );
  e.default = s;
  var i = s.init;
  e.init = i;
  var o = s.getLoginMethods;
  e.getLoginMethods = o;
  var l = s.getTenantId;
  e.getTenantId = l;
})(H$);
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(H$);
})(d2);
var Dx = {};
(function(e) {
  function t(n) {
    for (var a in n) e.hasOwnProperty(a) || (e[a] = n[a]);
  }
  e.__esModule = !0;
  let r = ur;
  r.default !== void 0 ? t(r) : t({
    default: r,
    ...r
  });
})(Dx);
var z$ = {};
(function(e) {
  function t(n) {
    for (var a in n) e.hasOwnProperty(a) || (e[a] = n[a]);
  }
  e.__esModule = !0;
  let r = Ex;
  r.default !== void 0 ? t(r) : t({
    default: r,
    ...r
  });
})(z$);
var f2 = {};
(function(e) {
  function t(n) {
    for (var a in n) e.hasOwnProperty(a) || (e[a] = n[a]);
  }
  e.__esModule = !0;
  let r = Vh;
  r.default !== void 0 ? t(r) : t({
    default: r,
    ...r
  });
})(f2);
(function(e) {
  var t = { VITE_APP_NAME: "Your App Name", VITE_API_BASE_URL: "https://frak2-api.functori.com", VITE_AUTH_BASE_URL: "https://frak2-auth.functori.com", VITE_MEDIA_BASE_URL: "https://frak2-api.functori.com", VITE_AUTH_TYPE: "supertokens", VITE_AUTH_STORAGE: "local", VITE_WEBSITE_URL: "https://example.com", VITE_STRIPE_PUBLIC_KEY: "pk_test_your_test_key_here", VITE_DEFAULT_THEME: "light", VITE_ONBOARDING_ENABLED: "true", VITE_ONBOARDING_STEPS: "personal,kyc", VITE_JWT_REFRESH_TOKEN_KEY: "refresh_token", VITE_JWT_ACCESS_TOKEN_KEY: "access_token", VITE_BUILD_MODE: "library", VITE_TENANT_ID: "fraktion", VITE_REQUIRED_ROLE: "admin", VITE_SIGNATURE_PROVIDER: "signaturit", VITE_PAYMENT_PROVIDER: "bridgeapi", VITE_PAYMENT_PROVIDERS: "bridgeapi,mangopay", VITE_KYC_PROVIDER: "dataleon" }, r = S$, n = $$, a = Rx, s = nv, i = d2, o = Dx, l = M, c = z$, u = f2, d = v;
  function f(ce) {
    return ce && ce.__esModule ? ce : { default: ce };
  }
  var h = /* @__PURE__ */ f(r), p = /* @__PURE__ */ f(i), m = /* @__PURE__ */ f(l), g = /* @__PURE__ */ f(c), y = /* @__PURE__ */ f(u), x = function(ce, de) {
    return x = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ne, Le) {
      Ne.__proto__ = Le;
    } || function(Ne, Le) {
      for (var $e in Le) Object.prototype.hasOwnProperty.call(Le, $e) && (Ne[$e] = Le[$e]);
    }, x(ce, de);
  };
  function w(ce, de) {
    if (typeof de != "function" && de !== null)
      throw new TypeError("Class extends value " + String(de) + " is not a constructor or null");
    x(ce, de);
    function Ne() {
      this.constructor = ce;
    }
    ce.prototype = de === null ? Object.create(de) : (Ne.prototype = de.prototype, new Ne());
  }
  e.__assign = function() {
    return e.__assign = Object.assign || function(de) {
      for (var Ne, Le = 1, $e = arguments.length; Le < $e; Le++) {
        Ne = arguments[Le];
        for (var ze in Ne) Object.prototype.hasOwnProperty.call(Ne, ze) && (de[ze] = Ne[ze]);
      }
      return de;
    }, e.__assign.apply(this, arguments);
  };
  function _(ce, de) {
    var Ne = {};
    for (var Le in ce) Object.prototype.hasOwnProperty.call(ce, Le) && de.indexOf(Le) < 0 && (Ne[Le] = ce[Le]);
    if (ce != null && typeof Object.getOwnPropertySymbols == "function")
      for (var $e = 0, Le = Object.getOwnPropertySymbols(ce); $e < Le.length; $e++)
        de.indexOf(Le[$e]) < 0 && Object.prototype.propertyIsEnumerable.call(ce, Le[$e]) && (Ne[Le[$e]] = ce[Le[$e]]);
    return Ne;
  }
  function S(ce, de, Ne, Le) {
    function $e(ze) {
      return ze instanceof Ne ? ze : new Ne(function(Lt) {
        Lt(ze);
      });
    }
    return new (Ne || (Ne = Promise))(function(ze, Lt) {
      function Ht(lr) {
        try {
          kt(Le.next(lr));
        } catch (cn) {
          Lt(cn);
        }
      }
      function Rr(lr) {
        try {
          kt(Le.throw(lr));
        } catch (cn) {
          Lt(cn);
        }
      }
      function kt(lr) {
        lr.done ? ze(lr.value) : $e(lr.value).then(Ht, Rr);
      }
      kt((Le = Le.apply(ce, de || [])).next());
    });
  }
  function C(ce, de) {
    var Ne = {
      label: 0,
      sent: function() {
        if (ze[0] & 1) throw ze[1];
        return ze[1];
      },
      trys: [],
      ops: []
    }, Le, $e, ze, Lt;
    return Lt = { next: Ht(0), throw: Ht(1), return: Ht(2) }, typeof Symbol == "function" && (Lt[Symbol.iterator] = function() {
      return this;
    }), Lt;
    function Ht(kt) {
      return function(lr) {
        return Rr([kt, lr]);
      };
    }
    function Rr(kt) {
      if (Le) throw new TypeError("Generator is already executing.");
      for (; Lt && (Lt = 0, kt[0] && (Ne = 0)), Ne; )
        try {
          if (Le = 1, $e && (ze = kt[0] & 2 ? $e.return : kt[0] ? $e.throw || ((ze = $e.return) && ze.call($e), 0) : $e.next) && !(ze = ze.call($e, kt[1])).done)
            return ze;
          switch ($e = 0, ze && (kt = [kt[0] & 2, ze.value]), kt[0]) {
            case 0:
            case 1:
              ze = kt;
              break;
            case 4:
              return Ne.label++, { value: kt[1], done: !1 };
            case 5:
              Ne.label++, $e = kt[1], kt = [0];
              continue;
            case 7:
              kt = Ne.ops.pop(), Ne.trys.pop();
              continue;
            default:
              if (ze = Ne.trys, !(ze = ze.length > 0 && ze[ze.length - 1]) && (kt[0] === 6 || kt[0] === 2)) {
                Ne = 0;
                continue;
              }
              if (kt[0] === 3 && (!ze || kt[1] > ze[0] && kt[1] < ze[3])) {
                Ne.label = kt[1];
                break;
              }
              if (kt[0] === 6 && Ne.label < ze[1]) {
                Ne.label = ze[1], ze = kt;
                break;
              }
              if (ze && Ne.label < ze[2]) {
                Ne.label = ze[2], Ne.ops.push(kt);
                break;
              }
              ze[2] && Ne.ops.pop(), Ne.trys.pop();
              continue;
          }
          kt = de.call(ce, Ne);
        } catch (lr) {
          kt = [6, lr], $e = 0;
        } finally {
          Le = ze = 0;
        }
      if (kt[0] & 5) throw kt[1];
      return { value: kt[0] ? kt[1] : void 0, done: !0 };
    }
  }
  function E(ce, de, Ne) {
    if (Ne || arguments.length === 2)
      for (var Le = 0, $e = de.length, ze; Le < $e; Le++)
        (ze || !(Le in de)) && (ze || (ze = Array.prototype.slice.call(de, 0, Le)), ze[Le] = de[Le]);
    return ce.concat(ze || Array.prototype.slice.call(de));
  }
  typeof SuppressedError == "function" && SuppressedError;
  var O = "rid", k = "tenantId", A = "/auth", P = "/auth", D = "supertokens-root", N = `
If you are trying to use this method doing server-side-rendering, please make sure you move this method inside a componentDidMount method or useEffect hook.`, z = "0.48.0", G = "com.supertokens.auth-react", Y = !1;
  function te() {
    Y = !0;
  }
  function ae(ce) {
    Y && console.log(
      "".concat(G, ' {t: "').concat((/* @__PURE__ */ new Date()).toISOString(), '", message: "').concat(ce, '", supertokens-auth-react-ver: "').concat(z, '"}')
    );
  }
  function ne(ce) {
    var de = new URLSearchParams(ce);
    return de.get(O);
  }
  function ue(ce) {
    for (var de = new URL(s.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getHref()), Ne = 0, Le = ce; Ne < Le.length; Ne++) {
      var $e = Le[Ne];
      de.searchParams.delete($e);
    }
    s.WindowHandlerReference.getReferenceOrThrow().windowHandler.history.replaceState(
      s.WindowHandlerReference.getReferenceOrThrow().windowHandler.history.getState(),
      "",
      de.toString()
    );
  }
  function q(ce, de) {
    var Ne = new URL(s.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getHref());
    Ne.searchParams.set(ce, de), s.WindowHandlerReference.getReferenceOrThrow().windowHandler.history.replaceState(
      s.WindowHandlerReference.getReferenceOrThrow().windowHandler.history.getState(),
      "",
      Ne.toString()
    );
  }
  function U() {
    ue(["error", "message"]);
  }
  function Q(ce) {
    var de = new URLSearchParams(
      s.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getSearch()
    );
    return de.get(ce);
  }
  function L() {
    return s.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getHash().substr(1);
  }
  function j() {
    var ce = Q("redirectToPath");
    if (ce !== null)
      try {
        var de = void 0;
        try {
          de = new URL(ce);
        } catch {
          var Ne = ce.startsWith("/") ? "http://localhost" : "http://localhost/";
          de = new URL("".concat(Ne).concat(ce));
        }
        var Le = new y.default(ce).getAsStringDangerous(), $e = de.search || "", ze = de.hash || "", Lt = Le + $e + ze;
        return Le.length === 0 && Lt.length > 0 && !Lt.startsWith("/") ? "/" + Lt : Lt;
      } catch {
        return;
      }
  }
  function K() {
    var ce;
    return (ce = Q(k)) !== null && ce !== void 0 ? ce : void 0;
  }
  function J(ce, de, Ne, Le) {
    var $e = ce.appInfo.websiteBasePath.appendPath(new y.default(de)).getAsStringDangerous(), ze = new URLSearchParams();
    return Ne.tenantIdFromQueryParams !== void 0 && ze.set(k, Ne.tenantIdFromQueryParams), Le !== void 0 && Object.entries(Le).forEach(function(Lt) {
      var Ht = Lt[0], Rr = Lt[1];
      Rr !== void 0 && ze.set(Ht, Rr);
    }), ze.toString() !== "" ? "".concat($e, "?").concat(ze.toString()) : $e;
  }
  function re() {
    try {
      return t.TEST_MODE === "testing" || t.REACT_APP_TEST_MODE === "testing";
    } catch {
      return !1;
    }
  }
  function le(ce) {
    if (ce === void 0)
      throw new Error("Please provide the appInfo object when calling supertokens.init");
    if (ce.apiDomain === void 0)
      throw new Error("Please provide your apiDomain inside the appInfo object when calling supertokens.init");
    if (ce.appName === void 0)
      throw new Error("Please provide your appName inside the appInfo object when calling supertokens.init");
    if (ce.websiteDomain === void 0)
      throw new Error("Please provide your websiteDomain inside the appInfo object when calling supertokens.init");
    var de = new y.default("");
    return ce.apiGatewayPath !== void 0 && (de = new y.default(ce.apiGatewayPath)), {
      appName: ce.appName,
      apiDomain: new g.default(ce.apiDomain),
      websiteDomain: new g.default(ce.websiteDomain),
      apiBasePath: de.appendPath(
        pe(A, ce.apiBasePath)
      ),
      websiteBasePath: pe(P, ce.websiteBasePath)
    };
  }
  function pe(ce, de) {
    return de !== void 0 ? new y.default(de) : new y.default(ce);
  }
  function me(ce, de) {
    return S(this, void 0, void 0, function() {
      var Ne, Le, $e;
      return C(this, function(ze) {
        switch (ze.label) {
          case 0:
            if (Ne = [], de.length !== ce.length)
              throw Error("Are you sending too many / too few formFields?");
            Le = function(Lt) {
              var Ht, Rr, kt, lr;
              return C(this, function(cn) {
                switch (cn.label) {
                  case 0:
                    return Ht = de[Lt], Rr = ce.find(function(ua) {
                      return ua.id === Ht.id;
                    }), kt = Rr.value, Rr.id === "email" && (kt = kt.trim()), [4, Ht.validate(kt)];
                  case 1:
                    return lr = cn.sent(), lr !== void 0 && Ne.push({
                      error: lr,
                      id: Ht.id
                    }), [
                      2
                      /*return*/
                    ];
                }
              });
            }, $e = 0, ze.label = 1;
          case 1:
            return $e < de.length ? [5, Le($e)] : [3, 4];
          case 2:
            ze.sent(), ze.label = 3;
          case 3:
            return $e++, [3, 1];
          case 4:
            return [2, Ne];
        }
      });
    });
  }
  function Oe() {
    return new y.default(
      s.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getPathName()
    );
  }
  function ee() {
    var ce = Oe().getAsStringDangerous();
    return ce + s.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getSearch() + s.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getHash();
  }
  function he(ce, de) {
    if (de === void 0)
      return ce;
    try {
      var Ne = new URL(ce);
      return Object.entries(de).forEach(function(ze) {
        var Lt = ze[0], Ht = ze[1];
        Ne.searchParams.set(Lt, Ht);
      }), Ne.href;
    } catch {
      var Le = ce.startsWith("/") ? "http://localhost" : "http://localhost/", $e = new URL("".concat(Le).concat(ce));
      return Object.entries(de).forEach(function(Lt) {
        var Ht = Lt[0], Rr = Lt[1];
        $e.searchParams.set(Ht, Rr);
      }), "".concat($e.pathname).concat($e.search).concat($e.hash);
    }
  }
  function Ee(ce) {
    return ce.endsWith("/") ? ce : ce + "/";
  }
  function we(ce) {
    return function() {
      var de = ne(
        s.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getSearch()
      );
      return de === ce;
    };
  }
  function Pe(ce) {
    ce.trim() === "" && (ce = "/"), s.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.setHref(ce);
  }
  function rt(ce, de) {
    ce.trim() === "" && (ce = "/"), "push" in de ? de.push(ce) : de(ce);
  }
  function ht() {
    return new g.default(
      s.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getOrigin()
    );
  }
  function bt(ce) {
    return S(this, void 0, void 0, function() {
      var de;
      return C(this, function(Ne) {
        return de = s.WindowHandlerReference.getReferenceOrThrow().windowHandler.localStorage.getItem(ce), de == null ? [2, null] : [2, de];
      });
    });
  }
  function Ge(ce, de) {
    return S(this, void 0, void 0, function() {
      return C(this, function(Ne) {
        switch (Ne.label) {
          case 0:
            return [
              4,
              s.WindowHandlerReference.getReferenceOrThrow().windowHandler.localStorage.setItem(
                ce,
                de
              )
            ];
          case 1:
            return Ne.sent(), [
              2
              /*return*/
            ];
        }
      });
    });
  }
  function oe(ce) {
    return S(this, void 0, void 0, function() {
      return C(this, function(de) {
        switch (de.label) {
          case 0:
            return [
              4,
              s.WindowHandlerReference.getReferenceOrThrow().windowHandler.localStorage.removeItem(
                ce
              )
            ];
          case 1:
            return de.sent(), [
              2
              /*return*/
            ];
        }
      });
    });
  }
  function ve(ce, de) {
    var Ne = e.__assign({}, ce);
    for (var Le in de)
      typeof Ne[Le] == "object" && typeof de[Le] == "object" ? Ne[Le] = ve(Ne[Le], de[Le]) : Ne[Le] = de[Le];
    return Ne;
  }
  function ye(ce) {
    function de($e) {
      $e = $e.trim().toLowerCase(), $e.startsWith(".") && ($e = $e.substr(1)), !$e.startsWith("http://") && !$e.startsWith("https://") && ($e = "http://" + $e);
      try {
        var ze = new URL($e);
        return $e = ze.hostname, $e.startsWith(".") && ($e = $e.substr(1)), $e;
      } catch {
        throw new Error("Please provide a valid cookie scope");
      }
    }
    function Ne($e) {
      return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        $e
      );
    }
    var Le = de(ce);
    return Le === "localhost" || Ne(Le) ? Le : ce.startsWith(".") ? "." + Le : Le;
  }
  function Te() {
    try {
      return ye(
        s.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getHostName()
      );
    } catch {
      return;
    }
  }
  function _e(ce) {
    return S(this, void 0, void 0, function() {
      var de, Ne, Le, $e, ze;
      return C(this, function(Lt) {
        switch (Lt.label) {
          case 0:
            return Ne = "; ", [
              4,
              n.CookieHandlerReference.getReferenceOrThrow().cookieHandler.getCookie()
            ];
          case 1:
            return de = Ne + Lt.sent(), Le = de.split("; " + ce + "="), Le.length >= 2 && ($e = Le.pop(), $e !== void 0) ? (ze = $e.split(";").shift(), ze === void 0 ? [2, null] : [2, ze]) : [2, null];
        }
      });
    });
  }
  function Ae(ce, de, Ne) {
    return S(this, void 0, void 0, function() {
      var Le, $e;
      return C(this, function(ze) {
        switch (ze.label) {
          case 0:
            return Le = "Thu, 01 Jan 1970 00:00:01 GMT", $e = "", de !== void 0 && ($e = de, Le = void 0), Ne === "localhost" || Ne === s.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getHostName() || Ne === void 0 ? Le === void 0 ? [3, 2] : [
              4,
              n.CookieHandlerReference.getReferenceOrThrow().cookieHandler.setCookie(
                "".concat(ce, "=").concat($e, ";expires=").concat(Le, ";path=/;samesite=lax")
              )
            ] : [3, 5];
          case 1:
            return ze.sent(), [3, 4];
          case 2:
            return [
              4,
              n.CookieHandlerReference.getReferenceOrThrow().cookieHandler.setCookie(
                "".concat(ce, "=").concat($e, ";expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/;samesite=lax")
              )
            ];
          case 3:
            ze.sent(), ze.label = 4;
          case 4:
            return [3, 9];
          case 5:
            return Le === void 0 ? [3, 7] : [
              4,
              n.CookieHandlerReference.getReferenceOrThrow().cookieHandler.setCookie(
                "".concat(ce, "=").concat($e, ";expires=").concat(Le, ";domain=").concat(Ne, ";path=/;samesite=lax")
              )
            ];
          case 6:
            return ze.sent(), [3, 9];
          case 7:
            return [
              4,
              n.CookieHandlerReference.getReferenceOrThrow().cookieHandler.setCookie(
                "".concat(ce, "=").concat($e, ";domain=").concat(Ne, ";expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/;samesite=lax")
              )
            ];
          case 8:
            ze.sent(), ze.label = 9;
          case 9:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  function Ve(ce) {
    return ce === void 0 ? {} : ce;
  }
  var mt = function(ce, de, Ne, Le) {
    Le === void 0 && (Le = !0);
    var $e = l.useRef(), ze = l.useState(void 0), Lt = ze[0], Ht = ze[1];
    if (l.useEffect(
      function() {
        var Rr = function(lr) {
          return S(void 0, void 0, void 0, function() {
            var cn, ua, W;
            return C(this, function(ie) {
              switch (ie.label) {
                case 0:
                  return ie.trys.push([0, 2, , 9]), $e.current === void 0 && ($e.current = ce()), [4, $e.current];
                case 1:
                  return cn = ie.sent(), lr.aborted || de(cn), [3, 9];
                case 2:
                  if (ua = ie.sent(), lr.aborted) return [3, 8];
                  if (Ne === void 0) return [3, 7];
                  ie.label = 3;
                case 3:
                  return ie.trys.push([3, 5, , 6]), [4, Ne(ua, cn)];
                case 4:
                  return ie.sent(), [3, 6];
                case 5:
                  return W = ie.sent(), Ht(W), [3, 6];
                case 6:
                  return [3, 8];
                case 7:
                  Ht(ua), ie.label = 8;
                case 8:
                  return [3, 9];
                case 9:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        };
        if (Le) {
          var kt = new AbortController();
          return Rr(kt.signal), function() {
            kt.abort();
          };
        }
      },
      [Ht, $e, ce, de, Ne, Le]
    ), Lt)
      throw Lt;
  };
  function Dt() {
    var ce = l.useState(void 0), de = ce[0], Ne = ce[1];
    if (de)
      throw de;
    return Ne;
  }
  var Gt = (
    /** @class */
    /* @__PURE__ */ function() {
      function ce(de) {
        this.config = de;
      }
      return ce;
    }()
  );
  function $t(ce) {
    var de = this;
    ce === void 0 && (ce = {});
    var Ne = ce.onHandleEvent, Le = ce.getRedirectionURL, $e = ce.preAPIHook, ze = ce.postAPIHook;
    Ne === void 0 && (Ne = function(Ht) {
    }), Le === void 0 && (Le = function(Ht) {
      return S(de, void 0, void 0, function() {
        return C(this, function(Rr) {
          return [2, void 0];
        });
      });
    }), $e === void 0 && ($e = function(Ht) {
      return S(de, void 0, void 0, function() {
        return C(this, function(Rr) {
          return [2, Ht];
        });
      });
    }), ze === void 0 && (ze = function() {
      return S(de, void 0, void 0, function() {
        return C(this, function(Ht) {
          return [
            2
            /*return*/
          ];
        });
      });
    });
    var Lt = ce.style === void 0 ? "" : ce.style;
    return e.__assign(e.__assign({}, ce), {
      getRedirectionURL: Le,
      onHandleEvent: Ne,
      preAPIHook: $e,
      postAPIHook: ze,
      recipeRootStyle: Lt
    });
  }
  function Rt(ce) {
    return e.__assign(e.__assign({}, $t(ce)), {
      override: e.__assign(
        {
          functions: function(de) {
            return de;
          }
        },
        ce == null ? void 0 : ce.override
      )
    });
  }
  function Pr(ce, de) {
    return ce.firstFactors.some(function(Ne) {
      return de.some(function(Le) {
        return Le.firstFactorIds.includes(Ne);
      });
    });
  }
  var fr = (
    /** @class */
    function(ce) {
      w(de, ce);
      function de(Ne, Le) {
        Le === void 0 && (Le = p.default);
        var $e = ce.call(this, Ne) || this;
        return $e.webJSRecipe = Le, $e.recipeID = de.RECIPE_ID, $e.dynamicLoginMethodsCache = {}, $e;
      }
      return de.prototype.getCurrentDynamicLoginMethods = function(Ne) {
        var Le;
        return S(this, void 0, void 0, function() {
          var $e, ze, Lt;
          return C(this, function(Ht) {
            switch (Ht.label) {
              case 0:
                return Hr.usesDynamicLoginMethods === !1 ? [2, void 0] : ($e = o.getNormalisedUserContext(Ne.userContext), [4, de.getInstanceOrThrow().webJSRecipe.getTenantId()]);
              case 1:
                return ze = (Le = Ht.sent()) !== null && Le !== void 0 ? Le : "public", this.dynamicLoginMethodsCache[ze] === void 0 && (this.dynamicLoginMethodsCache[ze] = de.getDynamicLoginMethods({
                  tenantId: ze,
                  userContext: $e
                })), [4, this.dynamicLoginMethodsCache[ze]];
              case 2:
                if (Lt = Ht.sent(), !Pr(
                  Lt,
                  Hr.getInstanceOrThrow().recipeList.filter(function(Rr) {
                    return "firstFactorIds" in Rr;
                  })
                ))
                  throw new Error(
                    "Initialized recipes have no overlap with core recipes or could not load login methods"
                  );
                return [2, Lt];
            }
          });
        });
      }, de.getDynamicLoginMethods = function(Ne) {
        return S(this, void 0, void 0, function() {
          var Le, $e, ze;
          return C(this, function(Lt) {
            switch (Lt.label) {
              case 0:
                return [4, p.default.getLoginMethods(Ne)];
              case 1:
                return Le = Lt.sent(), $e = Le.thirdParty, ze = Le.firstFactors, [
                  2,
                  {
                    thirdparty: $e,
                    firstFactors: ze
                  }
                ];
            }
          });
        });
      }, de.init = function(Ne) {
        var Le = Rt(Ne);
        return {
          recipeID: de.RECIPE_ID,
          authReact: function($e) {
            return de.instance = new de(
              e.__assign(e.__assign({}, Le), {
                appInfo: $e,
                recipeId: de.RECIPE_ID
              })
            ), de.instance;
          },
          webJS: p.default.init(e.__assign({}, Le))
        };
      }, de.getInstanceOrThrow = function() {
        if (de.instance === void 0) {
          var Ne = "No instance of Multitenancy found. Make sure to call the Multitenancy.init method.See https://supertokens.io/docs/multitenancy/quick-setup/frontend";
          throw typeof window > "u" && (Ne = Ne + N), Error(Ne);
        }
        return de.instance;
      }, de.reset = function() {
        re() && (de.instance = void 0);
      }, de.RECIPE_ID = "multitenancy", de;
    }(Gt)
  ), ca = (
    /** @class */
    function() {
      function ce() {
        this.handlers = /* @__PURE__ */ new Map();
      }
      return ce.prototype.emit = function(de, Ne) {
        for (var Le = this.handlers.get(de) || [], $e = 0, ze = Le; $e < ze.length; $e++) {
          var Lt = ze[$e];
          Lt(de, Ne);
        }
      }, ce.prototype.on = function(de, Ne) {
        var Le = this.handlers.get(de) || [];
        this.handlers.set(de, Le.concat(Ne));
      }, ce.prototype.off = function(de, Ne) {
        var Le = this.handlers.get(de) || [];
        this.handlers.set(
          de,
          Le.filter(function($e) {
            return $e !== Ne;
          })
        );
      }, ce;
    }()
  ), en = "sCurrLanguage";
  function Na(ce, de) {
    return S(this, void 0, void 0, function() {
      return C(this, function(Ne) {
        switch (Ne.label) {
          case 0:
            return Ne.trys.push([0, 2, , 3]), [4, Ae(en, ce, de)];
          case 1:
            return Ne.sent(), [3, 3];
          case 2:
            return Ne.sent(), [3, 3];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  function Ma() {
    return S(this, void 0, void 0, function() {
      return C(this, function(ce) {
        switch (ce.label) {
          case 0:
            return ce.trys.push([0, 2, , 3]), [4, _e(en)];
          case 1:
            return [2, ce.sent()];
          case 2:
            return ce.sent(), [2, null];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  var Hr = (
    /** @class */
    function() {
      function ce(de) {
        var Ne = this, Le, $e, ze, Lt;
        if (this.recipeList = [], this.changeLanguage = function(kt) {
          return S(Ne, void 0, void 0, function() {
            return C(this, function(lr) {
              switch (lr.label) {
                case 0:
                  return [
                    4,
                    Na(kt, this.languageTranslations.currentLanguageCookieScope)
                  ];
                case 1:
                  return lr.sent(), this.languageTranslations.translationEventSource.emit("LanguageChange", kt), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, this.redirectToAuth = function(kt) {
          return S(Ne, void 0, void 0, function() {
            var lr, cn;
            return C(this, function(ua) {
              switch (ua.label) {
                case 0:
                  return lr = kt.queryParams === void 0 ? {} : kt.queryParams, kt.show !== void 0 && (lr.show = kt.show), kt.redirectBack === !0 && (lr.redirectToPath = ee()), [
                    4,
                    this.getRedirectUrl(
                      {
                        action: "TO_AUTH",
                        showSignIn: kt.show === "signin",
                        tenantIdFromQueryParams: K()
                      },
                      kt.userContext
                    )
                  ];
                case 1:
                  return cn = ua.sent(), cn === null ? (ae("Skipping redirection because the user override returned null"), [
                    2
                    /*return*/
                  ]) : (cn = he(cn, lr), [2, this.redirectToUrl(cn, kt.navigate)]);
              }
            });
          });
        }, this.redirectToUrl = function(kt, lr) {
          return S(Ne, void 0, void 0, function() {
            return C(this, function(cn) {
              return wa(this.appInfo, kt, lr), [
                2
                /*return*/
              ];
            });
          });
        }, this.redirect = function(kt, lr, cn, ua) {
          return S(Ne, void 0, void 0, function() {
            var W;
            return C(this, function(ie) {
              switch (ie.label) {
                case 0:
                  return [4, this.getRedirectUrl(kt, Ve(ua))];
                case 1:
                  return W = ie.sent(), W === null ? (ae(
                    "Skipping redirection because the user override returned null for context ".concat(
                      JSON.stringify(kt, null, 2)
                    )
                  ), [
                    2
                    /*return*/
                  ]) : (W = he(W, cn), [
                    2,
                    ce.getInstanceOrThrow().redirectToUrl(W, lr)
                  ]);
              }
            });
          });
        }, this.appInfo = le(de.appInfo), de.recipeList === void 0 || de.recipeList.length === 0)
          throw new Error(
            "Please provide at least one recipe to the supertokens.init function call. See https://supertokens.io/docs/emailpassword/quick-setup/frontend"
          );
        var Ht = de.languageTranslations === void 0 ? {} : de.languageTranslations;
        this.languageTranslations = {
          defaultLanguage: Ht.defaultLanguage === void 0 ? "en" : Ht.defaultLanguage,
          currentLanguageCookieScope: Ht.currentLanguageCookieScope !== void 0 ? ye(Ht.currentLanguageCookieScope) : Te(),
          userTranslationStore: Ht.translations !== void 0 ? Ht.translations : {},
          translationEventSource: new ca(),
          userTranslationFunc: Ht.translationFunc
        };
        var Rr = !!(de != null && de.enableDebugLogs);
        Rr && te(), this.userGetRedirectionURL = de.getRedirectionURL, this.recipeList = de.recipeList.map(function(kt) {
          var lr = kt.authReact;
          return lr(Ne.appInfo, Rr);
        }), this.rootStyle = (Le = de.style) !== null && Le !== void 0 ? Le : "", this.privacyPolicyLink = de.privacyPolicyLink, this.termsOfServiceLink = de.termsOfServiceLink, this.useShadowDom = ($e = de.useShadowDom) !== null && $e !== void 0 ? $e : !0, this.defaultToSignUp = (ze = de.defaultToSignUp) !== null && ze !== void 0 ? ze : !1, this.disableAuthRoute = (Lt = de.disableAuthRoute) !== null && Lt !== void 0 ? Lt : !1;
      }
      return ce.init = function(de) {
        var Ne;
        if (n.CookieHandlerReference.init(de.cookieHandler), s.WindowHandlerReference.init(de.windowHandler), ce.instance !== void 0) {
          console.warn("SuperTokens was already initialized");
          return;
        }
        ce.usesDynamicLoginMethods = (Ne = de.usesDynamicLoginMethods) !== null && Ne !== void 0 ? Ne : !1;
        var Le = de.recipeList.find(function($e) {
          return $e.recipeID === fr.RECIPE_ID;
        }) !== void 0 ? de.recipeList : de.recipeList.concat(fr.init({}));
        h.default.init(
          e.__assign(e.__assign({}, de), {
            recipeList: Le.map(function($e) {
              var ze = $e.webJS;
              return ze;
            })
          })
        ), ce.instance = new ce(e.__assign(e.__assign({}, de), { recipeList: Le })), a.PostSuperTokensInitCallbacks.runPostInitCallbacks();
      }, ce.getInstanceOrThrow = function() {
        if (ce.instance === void 0) {
          var de = "SuperTokens must be initialized before calling this method.";
          throw typeof window > "u" && (de = de + N), new Error(de);
        }
        return ce.instance;
      }, ce.prototype.getRecipeOrThrow = function(de) {
        var Ne = this.recipeList.find(function(Le) {
          return Le.config.recipeId === de;
        });
        if (Ne === void 0)
          throw new Error("Missing recipe: ".concat(de));
        return Ne;
      }, ce.prototype.loadTranslation = function(de) {
        this.languageTranslations.translationEventSource.emit("TranslationLoaded", de);
      }, ce.prototype.getRedirectUrl = function(de, Ne) {
        var Le;
        return S(this, void 0, void 0, function() {
          var $e, ze, Lt, Ht;
          return C(this, function(Rr) {
            switch (Rr.label) {
              case 0:
                return this.userGetRedirectionURL ? [4, this.userGetRedirectionURL(de, Ne)] : [3, 2];
              case 1:
                if ($e = Rr.sent(), $e !== void 0)
                  return [2, $e];
                Rr.label = 2;
              case 2:
                if (de.action === "TO_AUTH")
                  return ze = this.appInfo.websiteBasePath.getAsStringDangerous(), Lt = Ee(ze), de.tenantIdFromQueryParams ? [
                    2,
                    he(
                      Lt,
                      (Ht = {}, Ht[k] = de.tenantIdFromQueryParams, Ht)
                    )
                  ] : [2, Lt];
                if (de.action === "SUCCESS")
                  return [2, (Le = de.redirectToPath) !== null && Le !== void 0 ? Le : "/"];
                throw new Error("Should never come here: unexpected redirection context");
            }
          });
        });
      }, ce.reset = function() {
        re() && (ce.instance = void 0);
      }, ce.usesDynamicLoginMethods = !1, ce;
    }()
  );
  function wa(ce, de, Ne) {
    try {
      new URL(de);
    } catch {
      var Le = ht().getAsStringDangerous();
      if (Le !== ce.websiteDomain.getAsStringDangerous()) {
        de = "".concat(ce.websiteDomain.getAsStringDangerous()).concat(de), Pe(de);
        return;
      }
      if (Ne !== void 0) {
        rt(de, Ne);
        return;
      }
    }
    Pe(de);
  }
  var na = function(ce) {
    ce === void 0 && (ce = {});
    var de = m.default.createContext(ce), Ne = function() {
      return m.default.useContext(de);
    }, Le = function($e) {
      var ze = $e.children, Lt = $e.components;
      return d.jsx(de.Provider, e.__assign({ value: Lt }, { children: ze }));
    };
    return [Ne, Le, de.Consumer];
  };
  e.BaseRecipeModule = Gt, e.Multitenancy = fr, e.SSR_ERROR = N, e.ST_ROOT_ID = D, e.SuperTokens = Hr, e.__awaiter = S, e.__extends = w, e.__generator = C, e.__rest = _, e.__spreadArray = E, e.appendQueryParamsToURL = he, e.clearErrorQueryParam = U, e.clearQueryParams = ue, e.createGenericComponentsOverrideContext = na, e.getCurrentLanguageFromCookie = Ma, e.getCurrentNormalisedUrlPath = Oe, e.getCurrentNormalisedUrlPathWithQueryParamsAndFragments = ee, e.getDefaultRedirectionURLForPath = J, e.getLocalStorage = bt, e.getNormalisedUserContext = Ve, e.getQueryParams = Q, e.getRedirectToPathFromURL = j, e.getTenantIdFromQueryParams = K, e.getURLHash = L, e.isTest = re, e.logDebugMessage = ae, e.matchRecipeIdUsingQueryParams = we, e.mergeObjects = ve, e.normaliseRecipeModuleConfig = $t, e.redirectWithFullPageReload = Pe, e.removeFromLocalStorage = oe, e.setLocalStorage = Ge, e.updateQueryParam = q, e.useOnMountAPICall = mt, e.useRethrowInRender = Dt, e.validateForm = me;
})(ba);
var _r = {}, Nx = {}, Lp = ba, wBe = v, vu = M;
function xBe(e) {
  return e && e.__esModule ? e : { default: e };
}
var _Be = /* @__PURE__ */ xBe(vu), SBe = function() {
  throw new Error("Cannot use translation func outside TranslationContext provider.");
}, K$ = _Be.default.createContext({
  translate: SBe
}), EBe = function() {
  return vu.useContext(K$).translate;
}, TBe = function(e) {
  var t = e.children, r = e.defaultLanguage, n = e.userTranslationFunc, a = e.defaultStore, s = e.translationControlEventSource, i = vu.useState(a), o = i[0], l = i[1], c = vu.useState(void 0), u = c[0], d = c[1];
  vu.useEffect(
    function() {
      function h() {
        return Lp.__awaiter(this, void 0, void 0, function() {
          var p, m;
          return Lp.__generator(this, function(g) {
            switch (g.label) {
              case 0:
                return [4, Lp.getCurrentLanguageFromCookie()];
              case 1:
                return p = g.sent(), m = p === null ? r : p, d(function(y) {
                  return y !== void 0 ? y : m;
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }
      h();
    },
    [r, d]
  ), vu.useEffect(function() {
    var h = function(m, g) {
      d(g);
    }, p = function(m, g) {
      l(function(y) {
        return Lp.mergeObjects(y, g);
      });
    };
    return s.on("LanguageChange", h), s.on("TranslationLoaded", p), function() {
      s.off("LanguageChange", h), s.off("TranslationLoaded", p);
    };
  });
  var f = vu.useCallback(
    function(h) {
      if (n !== void 0)
        return n(h);
      if (u !== void 0) {
        var p = o[u] && o[u][h], m = o[r] && o[r][h];
        return p === void 0 ? m !== void 0 ? m : h : p;
      }
      throw new Error("Should never come here");
    },
    [o, u, r, n]
  );
  return u === void 0 ? null : wBe.jsx(
    K$.Provider,
    Lp.__assign({ value: { translate: f } }, { children: t })
  );
};
Nx.TranslationContextProvider = TBe;
Nx.useTranslation = EBe;
var Mx = {}, CBe = ba, q$ = CBe.createGenericComponentsOverrideContext(), kBe = q$[0], OBe = q$[1];
Mx.Provider = OBe;
Mx.useContext = kBe;
var Lx = {}, G$ = {}, Y$ = {}, av = {}, Yu = {}, xm = ke && ke.__assign || function() {
  return xm = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, xm.apply(this, arguments);
};
Object.defineProperty(Yu, "__esModule", { value: !0 });
Yu.checkFactorRequirement = Yu.normaliseUserInput = void 0;
var ABe = yd;
function PBe(e) {
  var t = xm(
    {
      functions: function(r) {
        return r;
      }
    },
    e.override
  );
  return xm(xm({}, (0, ABe.normaliseAuthRecipe)(e)), { override: t });
}
Yu.normaliseUserInput = PBe;
function RBe(e, t) {
  return {
    id: e,
    isValid: t[e] !== void 0,
    message: "Not completed"
  };
}
Yu.checkFactorRequirement = RBe;
var GL = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, YL = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(av, "__esModule", { value: !0 });
av.MultiFactorAuthClaimClass = void 0;
var fS = Yu, IBe = (
  /** @class */
  function() {
    function e(t) {
      var r = this;
      this.getRecipeImpl = t, this.id = "st-mfa", this.validators = {
        hasCompletedMFARequirementsForAuth: function() {
          return {
            id: r.id,
            refresh: function() {
              for (var n = [], a = 0; a < arguments.length; a++)
                n[a] = arguments[a];
              return r.refresh.apply(r, n);
            },
            shouldRefresh: function(n, a) {
              var s = r.getValueFromPayload(n, a);
              return s === void 0;
            },
            validate: function(n, a) {
              return GL(r, void 0, void 0, function() {
                var s;
                return YL(this, function(i) {
                  return s = this.getValueFromPayload(n, a), s === void 0 ? [
                    2,
                    {
                      isValid: !1,
                      reason: {
                        message: "MFA info not available in payload"
                      }
                    }
                  ] : s.v ? [
                    2,
                    {
                      isValid: !0
                    }
                  ] : [
                    2,
                    {
                      isValid: !1,
                      reason: {
                        message: "not all required factors have been completed"
                      }
                    }
                  ];
                });
              });
            }
          };
        },
        hasCompletedFactors: function(n) {
          return {
            id: r.id,
            shouldRefresh: function(a, s) {
              var i = r.getValueFromPayload(a, s);
              return i === void 0;
            },
            refresh: function() {
              for (var a = [], s = 0; s < arguments.length; s++)
                a[s] = arguments[s];
              return r.refresh.apply(r, a);
            },
            validate: function(a, s) {
              var i = r.getValueFromPayload(a, s);
              if (i === void 0)
                return {
                  isValid: !1,
                  reason: {
                    message: "MFA info not available in payload"
                  }
                };
              for (var o = i.c, l = 0, c = n; l < c.length; l++) {
                var u = c[l];
                if (typeof u == "object" && "oneOf" in u) {
                  var d = u.oneOf.map(function(f) {
                    return (0, fS.checkFactorRequirement)(f, o);
                  }).filter(function(f) {
                    return f.isValid === !1;
                  });
                  if (d.length === u.oneOf.length)
                    return {
                      isValid: !1,
                      reason: {
                        message: "All factor checkers failed in the list",
                        oneOf: u.oneOf,
                        failures: d
                      }
                    };
                } else if (typeof u == "object" && "allOfInAnyOrder" in u) {
                  var d = u.allOfInAnyOrder.map(function(h) {
                    return (0, fS.checkFactorRequirement)(h, o);
                  }).filter(function(h) {
                    return h.isValid === !1;
                  });
                  if (d.length !== 0)
                    return {
                      isValid: !1,
                      reason: {
                        message: "Some factor checkers failed in the list",
                        allOfInAnyOrder: u.allOfInAnyOrder,
                        failures: d
                      }
                    };
                } else {
                  var d = (0, fS.checkFactorRequirement)(u, o);
                  if (d.isValid !== !0)
                    return {
                      isValid: !1,
                      reason: {
                        message: "Factor validation failed: " + d.message,
                        factorId: d.id
                      }
                    };
                }
              }
              return {
                isValid: !0
              };
            }
          };
        }
      };
    }
    return e.prototype.refresh = function(t) {
      return GL(this, void 0, void 0, function() {
        return YL(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.getRecipeImpl().resyncSessionAndFetchMFAInfo(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.getValueFromPayload = function(t, r) {
      if (t[this.id] !== void 0)
        return {
          c: t[this.id].c,
          v: t[this.id].v
        };
    }, e.prototype.getLastFetchedTime = function(t, r) {
      var n;
      return (n = t[this.id]) === null || n === void 0 ? void 0 : n.t;
    }, e;
  }()
);
av.MultiFactorAuthClaimClass = IBe;
var sv = {}, iv = {}, $b = ke && ke.__assign || function() {
  return $b = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, $b.apply(this, arguments);
}, DBe = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, NBe = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(iv, "__esModule", { value: !0 });
iv.getRecipeImplementation = void 0;
var hS = bd;
function X$(e) {
  var t = new hS.default(e.recipeId, e.appInfo);
  return {
    resyncSessionAndFetchMFAInfo: function(r) {
      var n = r.options, a = r.userContext;
      return DBe(this, void 0, void 0, function() {
        var s, i, o;
        return NBe(this, function(l) {
          switch (l.label) {
            case 0:
              return [
                4,
                t.put(
                  void 0,
                  "/mfa/info",
                  {},
                  hS.default.preparePreAPIHook({
                    recipePreAPIHook: e.preAPIHook,
                    action: "GET_MFA_INFO",
                    options: n,
                    userContext: a
                  }),
                  hS.default.preparePostAPIHook({
                    recipePostAPIHook: e.postAPIHook,
                    action: "GET_MFA_INFO",
                    userContext: a
                  })
                )
              ];
            case 1:
              return s = l.sent(), i = s.jsonBody, o = s.fetchResponse, [2, $b($b({}, i), { fetchResponse: o })];
          }
        });
      });
    }
  };
}
iv.default = X$;
iv.getRecipeImplementation = X$;
var h2 = {};
(function(e) {
  function t(n) {
    for (var a in n) e.hasOwnProperty(a) || (e[a] = n[a]);
  }
  e.__esModule = !0;
  let r = gd;
  r.default !== void 0 ? t(r) : t({
    default: r,
    ...r
  });
})(h2);
var MBe = ke && ke.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Hb = ke && ke.__assign || function() {
  return Hb = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Hb.apply(this, arguments);
};
Object.defineProperty(sv, "__esModule", { value: !0 });
sv.Recipe = void 0;
var LBe = Yu, jBe = qo, FBe = iv, XL = ur, BBe = Hh, UBe = vd, VBe = h2, $Be = av, Q$ = (
  /** @class */
  function(e) {
    MBe(t, e);
    function t(r) {
      var n = e.call(this, (0, LBe.normaliseUserInput)(r)) || this, a = new jBe.default(
        (0, FBe.default)({
          recipeId: n.config.recipeId,
          appInfo: n.config.appInfo,
          clientType: n.config.clientType,
          preAPIHook: n.config.preAPIHook,
          postAPIHook: n.config.postAPIHook
        })
      );
      return n.recipeImplementation = a.override(n.config.override.functions).build(), UBe.PostSuperTokensInitCallbacks.addPostInitCallback(function() {
        VBe.SessionClaimValidatorStore.addClaimValidatorFromOtherRecipe(
          t.MultiFactorAuthClaim.validators.hasCompletedMFARequirementsForAuth()
        );
      }), n;
    }
    return t.init = function(r) {
      return function(n, a) {
        return t.instance = new t(
          Hb(Hb({}, r), { recipeId: t.RECIPE_ID, appInfo: n, clientType: a })
        ), t.instance;
      };
    }, t.getInstanceOrThrow = function() {
      if (t.instance === void 0) {
        var r = "No instance of MultiFactorAuth found. Make sure to call the MultiFactorAuth.init method.";
        throw r = (0, XL.checkForSSRErrorAndAppendIfNeeded)(r), Error(r);
      }
      return t.instance;
    }, t.reset = function() {
      (0, XL.isTest)() && (t.instance = void 0);
    }, t.RECIPE_ID = "multifactorauth", t.MultiFactorAuthClaim = new $Be.MultiFactorAuthClaimClass(function() {
      return t.getInstanceOrThrow().recipeImplementation;
    }), t;
  }(BBe.default)
);
sv.Recipe = Q$;
sv.default = Q$;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MultiFactorAuthClaimClass = e.MultiFactorAuthClaim = e.resyncSessionAndFetchMFAInfo = e.init = void 0;
  var t = av;
  Object.defineProperty(e, "MultiFactorAuthClaimClass", {
    enumerable: !0,
    get: function() {
      return t.MultiFactorAuthClaimClass;
    }
  });
  var r = sv, n = ur, a = (
    /** @class */
    function() {
      function l() {
      }
      return l.init = function(c) {
        return r.default.init(c);
      }, l.resyncSessionAndFetchMFAInfo = function(c) {
        var u;
        return r.default.getInstanceOrThrow().recipeImplementation.resyncSessionAndFetchMFAInfo({
          options: (u = c == null ? void 0 : c.options) !== null && u !== void 0 ? u : {},
          userContext: (0, n.getNormalisedUserContext)(
            c == null ? void 0 : c.userContext
          )
        });
      }, l.MultiFactorAuthClaim = r.default.MultiFactorAuthClaim, l;
    }()
  );
  e.default = a;
  var s = a.init;
  e.init = s;
  var i = a.resyncSessionAndFetchMFAInfo;
  e.resyncSessionAndFetchMFAInfo = i;
  var o = a.MultiFactorAuthClaim;
  e.MultiFactorAuthClaim = o;
})(Y$);
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(Y$);
})(G$);
var p2 = {}, m2 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SessionClaimValidatorStore = void 0;
  var t = h2;
  Object.defineProperty(e, "SessionClaimValidatorStore", {
    enumerable: !0,
    get: function() {
      return t.SessionClaimValidatorStore;
    }
  });
})(m2);
(function(e) {
  function t(n) {
    for (var a in n) e.hasOwnProperty(a) || (e[a] = n[a]);
  }
  e.__esModule = !0;
  let r = m2;
  r.default !== void 0 ? t(r) : t({
    default: r,
    ...r
  });
})(p2);
var zh = {}, Js = ba, HBe = (
  /** @class */
  function(e) {
    Js.__extends(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.redirect = function(n, a, s, i) {
        return Js.__awaiter(r, void 0, void 0, function() {
          var o;
          return Js.__generator(this, function(l) {
            switch (l.label) {
              case 0:
                return [
                  4,
                  this.getRedirectUrl(
                    n,
                    Js.getNormalisedUserContext(i)
                  )
                ];
              case 1:
                return o = l.sent(), o === null ? (Js.logDebugMessage(
                  "Skipping redirection because the user override returned null for context ".concat(
                    JSON.stringify(n, null, 2)
                  )
                ), [
                  2
                  /*return*/
                ]) : (o = Js.appendQueryParamsToURL(
                  o,
                  s
                ), [
                  2,
                  Js.SuperTokens.getInstanceOrThrow().redirectToUrl(
                    o,
                    a
                  )
                ]);
            }
          });
        });
      }, r.getRedirectUrl = function(n, a) {
        return Js.__awaiter(r, void 0, void 0, function() {
          var s;
          return Js.__generator(this, function(i) {
            switch (i.label) {
              case 0:
                return [4, this.config.getRedirectionURL(n, a)];
              case 1:
                return s = i.sent(), s !== void 0 ? [2, s] : [4, this.getDefaultRedirectionURL(n, a)];
              case 2:
                return [2, i.sent()];
            }
          });
        });
      }, r;
    }
    return t.prototype.getDefaultRedirectionURL = function(r, n) {
      return Js.__awaiter(this, void 0, void 0, function() {
        return Js.__generator(this, function(a) {
          throw new Error("getDefaultRedirectionURL is not implemented.");
        });
      });
    }, t;
  }(Js.BaseRecipeModule)
);
zh.RecipeModule = HBe;
var ql = {}, g2 = {};
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(Ix);
})(g2);
var v2 = {}, J$ = {}, Ni = {}, ov = {}, jx = {}, _m = ke && ke.__assign || function() {
  return _m = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, _m.apply(this, arguments);
};
Object.defineProperty(jx, "__esModule", { value: !0 });
jx.normaliseUserInput = void 0;
var WBe = yd;
function zBe(e) {
  var t = _m(
    {
      functions: function(r) {
        return r;
      }
    },
    e.override
  );
  return _m(_m({}, (0, WBe.normaliseAuthRecipe)(e)), { override: t });
}
jx.normaliseUserInput = zBe;
var lv = {}, pS = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, mS = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(lv, "__esModule", { value: !0 });
lv.getRecipeImplementation = void 0;
var cu = bd, gS = Qc;
function Z$(e) {
  var t = new cu.default(e.recipeId, e.appInfo);
  return {
    getLoginChallengeInfo: function(r) {
      var n = r.loginChallenge, a = r.options, s = r.userContext;
      return pS(this, void 0, void 0, function() {
        var i, o, l, c, u, d;
        return mS(this, function(f) {
          switch (f.label) {
            case 0:
              return i = {
                loginChallenge: n
              }, d = (u = t).get, [
                4,
                gS.default.getInstanceOrThrow().recipeImplementation.getTenantId({ userContext: s })
              ];
            case 1:
              return [
                4,
                d.apply(u, [
                  f.sent(),
                  "/oauth/login/info",
                  {},
                  i,
                  cu.default.preparePreAPIHook({
                    recipePreAPIHook: e.preAPIHook,
                    action: "GET_LOGIN_CHALLENGE_INFO",
                    options: a,
                    userContext: s
                  }),
                  cu.default.preparePostAPIHook({
                    recipePostAPIHook: e.postAPIHook,
                    action: "GET_LOGIN_CHALLENGE_INFO",
                    userContext: s
                  })
                ])
              ];
            case 2:
              return o = f.sent(), l = o.jsonBody, c = o.fetchResponse, [
                2,
                {
                  status: "OK",
                  info: l.info,
                  fetchResponse: c
                }
              ];
          }
        });
      });
    },
    getRedirectURLToContinueOAuthFlow: function(r) {
      var n = r.loginChallenge, a = r.options, s = r.userContext;
      return pS(this, void 0, void 0, function() {
        var i, o, l, c, u;
        return mS(this, function(d) {
          switch (d.label) {
            case 0:
              return u = (c = t).get, [
                4,
                gS.default.getInstanceOrThrow().recipeImplementation.getTenantId({ userContext: s })
              ];
            case 1:
              return [
                4,
                u.apply(c, [
                  d.sent(),
                  "/oauth/login",
                  {},
                  {
                    loginChallenge: n
                  },
                  cu.default.preparePreAPIHook({
                    recipePreAPIHook: e.preAPIHook,
                    action: "GET_REDIRECT_URL_TO_CONTINUE_OAUTH_FLOW",
                    options: a,
                    userContext: s
                  }),
                  cu.default.preparePostAPIHook({
                    recipePostAPIHook: e.postAPIHook,
                    action: "GET_REDIRECT_URL_TO_CONTINUE_OAUTH_FLOW",
                    userContext: s
                  })
                ])
              ];
            case 2:
              return i = d.sent(), o = i.jsonBody, l = i.fetchResponse, [
                2,
                {
                  status: "OK",
                  frontendRedirectTo: o.frontendRedirectTo,
                  fetchResponse: l
                }
              ];
          }
        });
      });
    },
    logOut: function(r) {
      var n = r.logoutChallenge, a = r.options, s = r.userContext;
      return pS(this, void 0, void 0, function() {
        var i, o, l, c, u;
        return mS(this, function(d) {
          switch (d.label) {
            case 0:
              return u = (c = t).post, [
                4,
                gS.default.getInstanceOrThrow().recipeImplementation.getTenantId({ userContext: s })
              ];
            case 1:
              return [
                4,
                u.apply(c, [
                  d.sent(),
                  "/oauth/logout",
                  {
                    body: JSON.stringify({ logoutChallenge: n })
                  },
                  cu.default.preparePreAPIHook({
                    recipePreAPIHook: e.preAPIHook,
                    action: "LOG_OUT",
                    options: a,
                    userContext: s
                  }),
                  cu.default.preparePostAPIHook({
                    recipePostAPIHook: e.postAPIHook,
                    action: "LOG_OUT",
                    userContext: s
                  })
                ])
              ];
            case 2:
              return i = d.sent(), o = i.jsonBody, l = i.fetchResponse, [
                2,
                {
                  status: "OK",
                  frontendRedirectTo: o.frontendRedirectTo,
                  fetchResponse: l
                }
              ];
          }
        });
      });
    }
  };
}
lv.default = Z$;
lv.getRecipeImplementation = Z$;
var KBe = ke && ke.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Wb = ke && ke.__assign || function() {
  return Wb = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Wb.apply(this, arguments);
};
Object.defineProperty(ov, "__esModule", { value: !0 });
ov.Recipe = void 0;
var qBe = jx, GBe = qo, YBe = lv, QL = ur, XBe = Hh, e8 = (
  /** @class */
  function(e) {
    KBe(t, e);
    function t(r) {
      var n = e.call(this, (0, qBe.normaliseUserInput)(r)) || this, a = new GBe.default(
        (0, YBe.default)({
          recipeId: n.config.recipeId,
          appInfo: n.config.appInfo,
          clientType: n.config.clientType,
          preAPIHook: n.config.preAPIHook,
          postAPIHook: n.config.postAPIHook
        })
      );
      return n.recipeImplementation = a.override(n.config.override.functions).build(), n;
    }
    return t.init = function(r) {
      return function(n, a) {
        return t.instance = new t(
          Wb(Wb({}, r), { recipeId: t.RECIPE_ID, appInfo: n, clientType: a })
        ), t.instance;
      };
    }, t.getInstanceOrThrow = function() {
      if (t.instance === void 0) {
        var r = "No instance of OAuth2Provider found. Ensure that the 'OAuth2Provider.init' method is called within the 'SuperTokens.init' recipeList.";
        throw r = (0, QL.checkForSSRErrorAndAppendIfNeeded)(r), Error(r);
      }
      return t.instance;
    }, t.reset = function() {
      (0, QL.isTest)() && (t.instance = void 0);
    }, t.RECIPE_ID = "oauth2provider", t;
  }(XBe.default)
);
ov.Recipe = e8;
ov.default = e8;
var dc = ke && ke.__assign || function() {
  return dc = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, dc.apply(this, arguments);
};
Object.defineProperty(Ni, "__esModule", { value: !0 });
Ni.logOut = Ni.getRedirectURLToContinueOAuthFlow = Ni.getLoginChallengeInfo = Ni.init = void 0;
var vS = ur, Q0 = ov, cv = (
  /** @class */
  function() {
    function e() {
    }
    return e.init = function(t) {
      return Q0.default.init(t);
    }, e.getLoginChallengeInfo = function(t) {
      return Q0.default.getInstanceOrThrow().recipeImplementation.getLoginChallengeInfo(
        dc(dc({}, t), { userContext: (0, vS.getNormalisedUserContext)(t.userContext) })
      );
    }, e.getRedirectURLToContinueOAuthFlow = function(t) {
      return Q0.default.getInstanceOrThrow().recipeImplementation.getRedirectURLToContinueOAuthFlow(
        dc(dc({}, t), { userContext: (0, vS.getNormalisedUserContext)(t.userContext) })
      );
    }, e.logOut = function(t) {
      return Q0.default.getInstanceOrThrow().recipeImplementation.logOut(
        dc(dc({}, t), { userContext: (0, vS.getNormalisedUserContext)(t.userContext) })
      );
    }, e;
  }()
);
Ni.default = cv;
var QBe = cv.init;
Ni.init = QBe;
var JBe = cv.getLoginChallengeInfo;
Ni.getLoginChallengeInfo = JBe;
var ZBe = cv.getRedirectURLToContinueOAuthFlow;
Ni.getRedirectURLToContinueOAuthFlow = ZBe;
var e6e = cv.logOut;
Ni.logOut = e6e;
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(Ni);
})(J$);
var Bn = ba, t6e = J$, r6e = zh;
function n6e(e) {
  return e && e.__esModule ? e : { default: e };
}
var JL = /* @__PURE__ */ n6e(t6e), a6e = function(e) {
  return function(t) {
    return Bn.__assign(Bn.__assign({}, t), {
      getLoginChallengeInfo: function(r) {
        return Bn.__awaiter(this, void 0, void 0, function() {
          var n;
          return Bn.__generator(this, function(a) {
            switch (a.label) {
              case 0:
                return [4, t.getLoginChallengeInfo(r)];
              case 1:
                return n = a.sent(), e({
                  action: "LOADED_LOGIN_CHALLENGE",
                  loginChallenge: r.loginChallenge,
                  loginInfo: n.info,
                  userContext: r.userContext
                }), [2, n];
            }
          });
        });
      },
      logOut: function(r) {
        return Bn.__awaiter(this, void 0, void 0, function() {
          var n;
          return Bn.__generator(this, function(a) {
            switch (a.label) {
              case 0:
                return [4, t.logOut(r)];
              case 1:
                return n = a.sent(), e({
                  action: "OAUTH2_LOGOUT_SUCCESS",
                  frontendRedirectTo: n.frontendRedirectTo,
                  userContext: r.userContext
                }), [2, n];
            }
          });
        });
      }
    });
  };
};
function s6e(e) {
  var t;
  return Bn.__assign(
    Bn.__assign(
      {},
      Bn.normaliseRecipeModuleConfig(e)
    ),
    {
      disableDefaultUI: (t = e == null ? void 0 : e.disableDefaultUI) !== null && t !== void 0 ? t : !1,
      tryRefreshPage: Bn.__assign(
        { disableDefaultUI: !1 },
        e == null ? void 0 : e.tryRefreshPage
      ),
      oauth2LogoutScreen: Bn.__assign(
        { disableDefaultUI: !1, style: "" },
        e == null ? void 0 : e.oauth2LogoutScreen
      ),
      override: Bn.__assign(
        {
          functions: function(r) {
            return r;
          }
        },
        e == null ? void 0 : e.override
      )
    }
  );
}
var i6e = (
  /** @class */
  function(e) {
    Bn.__extends(t, e);
    function t(r, n) {
      n === void 0 && (n = JL.default);
      var a = e.call(this, r) || this;
      return a.webJSRecipe = n, a.recipeID = t.RECIPE_ID, a;
    }
    return t.init = function(r) {
      var n = s6e(r);
      return {
        recipeID: t.RECIPE_ID,
        authReact: function(a) {
          return t.instance = new t(
            Bn.__assign(
              Bn.__assign({}, n),
              { appInfo: a, recipeId: t.RECIPE_ID }
            )
          ), t.instance;
        },
        webJS: JL.default.init(
          Bn.__assign(
            Bn.__assign({}, n),
            {
              override: {
                functions: function(a, s) {
                  var i = a6e(n.onHandleEvent);
                  return s.override(i), s.override(n.override.functions), a;
                }
              }
            }
          )
        )
      };
    }, t.getInstanceOrThrow = function() {
      if (t.instance === void 0) {
        var r = "No instance of OAuth2Provider found. Make sure to call the OAuth2Provider.init method.See https://supertokens.io/docs/oauth2/quick-setup/frontend";
        throw typeof window > "u" && (r = r + Bn.SSR_ERROR), Error(r);
      }
      return t.instance;
    }, t.getInstance = function() {
      return t.instance;
    }, t.prototype.getDefaultRedirectionURL = function(r) {
      return Bn.__awaiter(this, void 0, void 0, function() {
        return Bn.__generator(this, function(n) {
          if (r.action === "SUCCESS_OAUTH2" || r.action === "CONTINUE_OAUTH2_AFTER_REFRESH" || r.action === "POST_OAUTH2_LOGOUT_REDIRECT")
            return [2, r.frontendRedirectTo];
          throw new Error(
            "Should never come here: unknown action in OAuth2Provider.getDefaultRedirectionURL"
          );
        });
      });
    }, t.reset = function() {
      Bn.isTest() && (t.instance = void 0);
    }, t.RECIPE_ID = "oauth2provider", t;
  }(r6e.RecipeModule)
);
v2.OAuth2Provider = i6e;
var er = ba, o6e = g2, l6e = v2, c6e = zh, u6e = Dx, d6e = nv;
function f6e(e) {
  return e && e.__esModule ? e : { default: e };
}
var yS = /* @__PURE__ */ f6e(o6e);
function h6e(e) {
  var t, r, n;
  e === void 0 && (e = {});
  var a = (r = (t = e.accessDeniedScreen) === null || t === void 0 ? void 0 : t.style) !== null && r !== void 0 ? r : "", s = {
    style: a
  }, i = er.__assign(
    {
      functions: function(o) {
        return o;
      }
    },
    e.override
  );
  return er.__assign(
    er.__assign(
      {},
      er.normaliseRecipeModuleConfig(e)
    ),
    {
      // TODO: ideally we'd get the default (or normalized) value from supertokens-website
      invalidClaimStatusCode: (n = e.invalidClaimStatusCode) !== null && n !== void 0 ? n : 403,
      accessDeniedScreen: s,
      override: i
    }
  );
}
var t8 = function(e) {
  var t = e.invalidClaims, r = e.overrideGlobalClaimValidators, n = e.userContext;
  return er.__awaiter(void 0, void 0, void 0, function() {
    var a, s, i, o, l, c, u;
    return er.__generator(this, function(d) {
      switch (d.label) {
        case 0:
          a = u6e.getGlobalClaimValidators({
            overrideGlobalClaimValidators: r,
            userContext: n
          }), s = void 0, i = function(f) {
            var h, p, m;
            return er.__generator(this, function(g) {
              switch (g.label) {
                case 0:
                  return h = t.find(function(y) {
                    return y.id === f.id;
                  }), h === void 0 ? [3, 2] : (p = f.onFailureRedirection, p ? [
                    4,
                    p({ reason: h.reason, userContext: n })
                  ] : [3, 2]);
                case 1:
                  if (m = g.sent(), m !== void 0)
                    return [
                      2,
                      {
                        value: {
                          redirectPath: m,
                          failedClaim: h
                        }
                      }
                    ];
                  g.label = 2;
                case 2:
                  return f.showAccessDeniedOnFailure !== !1 && s === void 0 && (s = h), [
                    2
                    /*return*/
                  ];
              }
            });
          }, o = 0, l = a, d.label = 1;
        case 1:
          return o < l.length ? (c = l[o], [5, i(c)]) : [3, 4];
        case 2:
          if (u = d.sent(), typeof u == "object") return [2, u.value];
          d.label = 3;
        case 3:
          return o++, [3, 1];
        case 4:
          return [
            2,
            {
              redirectPath: void 0,
              failedClaim: s
            }
          ];
      }
    });
  });
};
function r8(e) {
  var t = d6e.WindowHandlerReference.getReferenceOrThrow().windowHandler.location.getHref(), r;
  try {
    new URL(e), r = e;
  } catch {
    if (!e.startsWith("/"))
      throw new Error("onFailureRedirectionURL returned a relative url: ".concat(e));
    var n = er.SuperTokens.getInstanceOrThrow().appInfo;
    r = "".concat(n.websiteDomain.getAsStringDangerous()).concat(e);
  }
  return t === r;
}
var p6e = (
  /** @class */
  function(e) {
    er.__extends(t, e);
    function t(r, n) {
      n === void 0 && (n = yS.default);
      var a = e.call(this, r) || this;
      return a.webJSRecipe = n, a.recipeID = t.RECIPE_ID, a.eventListeners = /* @__PURE__ */ new Set(), a.getUserId = function(s) {
        return a.webJSRecipe.getUserId(s);
      }, a.getAccessToken = function(s) {
        return a.webJSRecipe.getAccessToken(s);
      }, a.getClaimValue = function(s) {
        return a.webJSRecipe.getClaimValue(s);
      }, a.getAccessTokenPayloadSecurely = function(s) {
        return er.__awaiter(a, void 0, void 0, function() {
          return er.__generator(this, function(i) {
            return [2, this.webJSRecipe.getAccessTokenPayloadSecurely(s)];
          });
        });
      }, a.doesSessionExist = function(s) {
        return a.webJSRecipe.doesSessionExist(s);
      }, a.signOut = function(s) {
        return a.webJSRecipe.signOut(s);
      }, a.attemptRefreshingSession = function() {
        return er.__awaiter(a, void 0, void 0, function() {
          return er.__generator(this, function(s) {
            return [2, this.webJSRecipe.attemptRefreshingSession()];
          });
        });
      }, a.validateClaims = function(s) {
        return a.webJSRecipe.validateClaims(s);
      }, a.getInvalidClaimsFromResponse = function(s) {
        return a.webJSRecipe.getInvalidClaimsFromResponse(s);
      }, a.addEventListener = function(s) {
        return a.eventListeners.add(s), function() {
          return a.eventListeners.delete(s);
        };
      }, a.validateGlobalClaimsAndHandleSuccessRedirection = function(s, i, o, l, c) {
        return er.__awaiter(a, void 0, void 0, function() {
          var u, d, f, h, p;
          return er.__generator(this, function(m) {
            switch (m.label) {
              case 0:
                return l = er.getNormalisedUserContext(l), [4, this.doesSessionExist({ userContext: l })];
              case 1:
                return m.sent() ? [4, this.validateClaims({ userContext: l })] : [
                  2,
                  er.SuperTokens.getInstanceOrThrow().redirectToAuth({
                    navigate: c,
                    redirectBack: !1,
                    userContext: l
                  })
                ];
              case 2:
                return u = m.sent(), u.length > 0 ? s === void 0 ? [3, 4] : (d = JSON.stringify({
                  successRedirectContext: s,
                  redirectToPath: o
                }), [
                  4,
                  er.setLocalStorage(
                    "supertokens-success-redirection-context",
                    d
                  )
                ]) : [3, 6];
              case 3:
                m.sent(), m.label = 4;
              case 4:
                return [
                  4,
                  t8({
                    invalidClaims: u,
                    userContext: l
                  })
                ];
              case 5:
                if (f = m.sent(), f.redirectPath !== void 0) {
                  if (r8(f.redirectPath))
                    throw new Error(
                      "onFailureRedirectionURL returned the current URL (".concat(
                        f.redirectPath,
                        ") during success redirection. This indicates that the user is in a stuck state."
                      )
                    );
                  return [
                    2,
                    er.SuperTokens.getInstanceOrThrow().redirectToUrl(
                      f.redirectPath,
                      c
                    )
                  ];
                }
                m.label = 6;
              case 6:
                return s !== void 0 ? [3, 13] : [
                  4,
                  er.getLocalStorage(
                    "supertokens-success-redirection-context"
                  )
                ];
              case 7:
                if (h = m.sent(), h === null) return [3, 12];
                m.label = 8;
              case 8:
                return m.trys.push([8, , 9, 11]), p = JSON.parse(h), s = p.successRedirectContext, o === void 0 && (o = p.redirectToPath), [3, 11];
              case 9:
                return [
                  4,
                  er.removeFromLocalStorage(
                    "supertokens-success-redirection-context"
                  )
                ];
              case 10:
                return m.sent(), [
                  7
                  /*endfinally*/
                ];
              case 11:
                return [3, 13];
              case 12:
                s = {
                  recipeId: i,
                  action: "SUCCESS",
                  createdNewUser: !1,
                  isNewRecipeUser: !1,
                  newSessionCreated: !1,
                  tenantIdFromQueryParams: er.getTenantIdFromQueryParams()
                }, m.label = 13;
              case 13:
                if (s === void 0)
                  throw new Error("This should never happen: successRedirectContext undefined ");
                return s.action === "SUCCESS_OAUTH2" ? [
                  2,
                  l6e.OAuth2Provider.getInstanceOrThrow().redirect(
                    s,
                    c,
                    {},
                    l
                  )
                ] : (s.action === "SUCCESS" && o !== void 0 && (s.redirectToPath = o), [
                  2,
                  er.SuperTokens.getInstanceOrThrow().redirect(
                    s,
                    c,
                    {},
                    l
                  )
                ]);
            }
          });
        });
      }, a.getDefaultRedirectionURL = function() {
        return er.__awaiter(a, void 0, void 0, function() {
          return er.__generator(this, function(s) {
            return [2, "/"];
          });
        });
      }, a.notifyListeners = function(s) {
        return er.__awaiter(a, void 0, void 0, function() {
          var i;
          return er.__generator(this, function(o) {
            switch (o.label) {
              case 0:
                return [4, this.getSessionContext(s)];
              case 1:
                return i = o.sent(), Array.from(this.eventListeners).forEach(function(l) {
                  return l(
                    er.__assign({ sessionContext: i }, s)
                  );
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, a;
    }
    return t.prototype.getSessionContext = function(r) {
      var n = r.action, a = r.userContext;
      return er.__awaiter(this, void 0, void 0, function() {
        var s, i, o;
        return er.__generator(this, function(l) {
          switch (l.label) {
            case 0:
              return n === "SESSION_CREATED" || n === "REFRESH_SESSION" || n === "API_INVALID_CLAIM" || n === "ACCESS_TOKEN_PAYLOAD_UPDATED" ? [
                4,
                Promise.all([
                  this.getUserId({
                    userContext: a
                  }),
                  this.getAccessTokenPayloadSecurely({
                    userContext: a
                  })
                ])
              ] : [3, 2];
            case 1:
              return s = l.sent(), i = s[0], o = s[1], [
                2,
                {
                  doesSessionExist: !0,
                  accessTokenPayload: o,
                  userId: i
                }
              ];
            case 2:
              if (n === "SIGN_OUT" || n === "UNAUTHORISED")
                return [
                  2,
                  {
                    doesSessionExist: !1,
                    accessTokenPayload: {},
                    userId: ""
                  }
                ];
              throw new Error("Unhandled recipe event: ".concat(n));
          }
        });
      });
    }, t.addAxiosInterceptors = function(r, n) {
      return yS.default.addAxiosInterceptors(r, n);
    }, t.init = function(r) {
      var n = this, a = h6e(r);
      return {
        recipeID: t.RECIPE_ID,
        authReact: function(s) {
          return t.instance = new t(
            er.__assign(
              er.__assign({}, a),
              { appInfo: s, recipeId: t.RECIPE_ID }
            )
          ), t.instance;
        },
        webJS: yS.default.init(
          er.__assign(
            er.__assign({}, a),
            {
              onHandleEvent: function(s) {
                a.onHandleEvent !== void 0 && a.onHandleEvent(s), t.getInstanceOrThrow().notifyListeners(s);
              },
              preAPIHook: function(s) {
                return er.__awaiter(n, void 0, void 0, function() {
                  var i;
                  return er.__generator(this, function(o) {
                    return i = er.__assign(
                      er.__assign({}, s),
                      {
                        requestInit: er.__assign(
                          er.__assign({}, s.requestInit),
                          {
                            headers: er.__assign(
                              er.__assign(
                                {},
                                s.requestInit.headers
                              ),
                              { rid: t.RECIPE_ID }
                            )
                          }
                        )
                      }
                    ), a.preAPIHook === void 0 ? [2, i] : [2, a.preAPIHook(s)];
                  });
                });
              }
            }
          )
        )
      };
    }, t.getInstanceOrThrow = function() {
      if (t.instance === void 0)
        throw Error(
          "No instance of Session found. Make sure to call the Session.init method. See https://supertokens.io/docs/emailpassword/quick-setup/frontend"
        );
      return t.instance;
    }, t.getInstance = function() {
      return t.instance;
    }, t.reset = function() {
      er.isTest() && (t.instance = void 0);
    }, t.RECIPE_ID = "session", t;
  }(c6e.RecipeModule)
), m6e = {
  EMAILPASSWORD: "emailpassword",
  OTP_EMAIL: "otp-email",
  OTP_PHONE: "otp-phone",
  LINK_EMAIL: "link-email",
  LINK_PHONE: "link-phone",
  THIRDPARTY: "thirdparty",
  TOTP: "totp"
};
ql.FactorIds = m6e;
ql.Session = p6e;
ql.getFailureRedirectionInfo = t8;
ql.validateAndCompareOnFailureRedirectionURLToCurrent = r8;
var Nt = ba, n8 = G$, ZL = Dx, g6e = Rx, v6e = p2, a8 = nv, y6e = zh, b6e = ql;
function w6e(e) {
  return e && e.__esModule ? e : { default: e };
}
var ej = /* @__PURE__ */ w6e(n8), s8 = "/mfa", Iy = "st-mfa-info-cache", jp = void 0, x6e = function(e) {
  return function(t) {
    return Nt.__assign(Nt.__assign({}, t), {
      resyncSessionAndFetchMFAInfo: function(r) {
        return Nt.__awaiter(this, void 0, void 0, function() {
          var n, a, o, s, i, o, l;
          return Nt.__generator(this, function(c) {
            switch (c.label) {
              case 0:
                return n = a8.WindowHandlerReference.getReferenceOrThrow(), [4, jp];
              case 1:
                return c.sent(), [4, n.windowHandler.sessionStorage.getItem(Iy)];
              case 2:
                if (a = c.sent(), a !== null && (o = JSON.parse(a), o.t > Date.now() - 1e3))
                  return [
                    2,
                    Nt.__assign(
                      Nt.__assign({}, o.v),
                      {
                        // Adding a fake response is not great, but we do want to add something and this way it's detectable by the app
                        // so they could even add specific handling for it if they preferred.
                        fetchResponse: new Response(null, { status: 304 })
                      }
                    )
                  ];
                c.label = 3;
              case 3:
                return jp === void 0 ? [3, 5] : [4, jp];
              case 4:
                return c.sent(), [3, 3];
              case 5:
                jp = new Promise(function(u) {
                  return s = u;
                }), c.label = 6;
              case 6:
                return c.trys.push([6, , 11, 12]), [4, n.windowHandler.sessionStorage.getItem(Iy)];
              case 7:
                return i = c.sent(), i !== null && (o = JSON.parse(i), o.t > Date.now() - 1e3) ? [
                  2,
                  Nt.__assign(
                    Nt.__assign({}, o.v),
                    {
                      // Adding a fake response is not great, but we do want to add something and this way it's detectable by the app
                      // so they could even add specific handling for it if they preferred.
                      fetchResponse: new Response(null, { status: 304 })
                    }
                  )
                ] : [4, t.resyncSessionAndFetchMFAInfo(r)];
              case 8:
                return l = c.sent(), l.status !== "OK" ? [3, 10] : [
                  4,
                  n.windowHandler.sessionStorage.setItem(
                    Iy,
                    JSON.stringify({
                      t: Date.now(),
                      v: {
                        emails: l.emails,
                        phoneNumbers: l.phoneNumbers,
                        factors: l.factors,
                        status: l.status
                      }
                    })
                  )
                ];
              case 9:
                c.sent(), c.label = 10;
              case 10:
                return [2, l];
              case 11:
                return jp = void 0, s(), [
                  7
                  /*endfinally*/
                ];
              case 12:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }
    });
  };
}, _6e = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, r, n) {
      var a = this;
      this.webJSClaim = new n8.MultiFactorAuthClaimClass(function() {
        return t().webJSRecipe;
      }), this.refresh = this.webJSClaim.refresh, this.getLastFetchedTime = this.webJSClaim.getLastFetchedTime, this.getValueFromPayload = this.webJSClaim.getValueFromPayload, this.id = this.webJSClaim.id;
      var s = function(i) {
        var o = i.reason, l = i.userContext;
        return Nt.__awaiter(a, void 0, void 0, function() {
          var c, u, f, d, f;
          return Nt.__generator(this, function(h) {
            switch (h.label) {
              case 0:
                return c = t(), u = o.oneOf || o.allOfInAnyOrder || (o.factorId !== void 0 ? [o.factorId] : void 0), u === void 0 ? [3, 1] : (Nt.logDebugMessage(
                  "Redirecting to MFA on next array from validation failure: " + u.join(", ")
                ), f = c.getSecondaryFactors(l).filter(function(p) {
                  return u.factors.next.includes(p.id);
                }).map(function(p) {
                  return p.id;
                }), f.length === 1 ? [
                  2,
                  r(
                    { action: "GO_TO_FACTOR", factorId: f[0] },
                    l
                  )
                ] : [
                  2,
                  r(
                    { action: "FACTOR_CHOOSER", nextFactorOptions: u },
                    l
                  )
                ]);
              case 1:
                return [
                  4,
                  c.webJSRecipe.resyncSessionAndFetchMFAInfo({ userContext: l })
                ];
              case 2:
                return d = h.sent(), f = c.getSecondaryFactors(l).filter(function(p) {
                  return d.factors.next.includes(p.id);
                }).map(function(p) {
                  return p.id;
                }), Nt.logDebugMessage(
                  "Redirecting to MFA on next array from backend: " + f.join(", ")
                ), f.length === 1 ? [
                  2,
                  r(
                    { action: "GO_TO_FACTOR", factorId: f[0] },
                    l
                  )
                ] : [2, r({ action: "FACTOR_CHOOSER" }, l)];
              case 3:
                return [2, void 0];
            }
          });
        });
      };
      this.validators = Nt.__assign(
        Nt.__assign({}, this.webJSClaim.validators),
        {
          hasCompletedMFARequirementsForAuth: function(i, o) {
            i === void 0 && (i = !0), o === void 0 && (o = !0);
            var l = a.webJSClaim.validators.hasCompletedMFARequirementsForAuth();
            return Nt.__assign(
              Nt.__assign({}, l),
              {
                showAccessDeniedOnFailure: o,
                onFailureRedirection: n ?? function(c) {
                  var u = c.reason, d = c.userContext;
                  return i ? s({
                    reason: u,
                    userContext: d
                  }) : void 0;
                }
              }
            );
          },
          hasCompletedFactors: function(i, o, l) {
            o === void 0 && (o = !0), l === void 0 && (l = !0);
            var c = a.webJSClaim.validators.hasCompletedFactors(i);
            return Nt.__assign(
              Nt.__assign({}, c),
              {
                showAccessDeniedOnFailure: l,
                onFailureRedirection: n ?? function(u) {
                  var d = u.reason, f = u.userContext;
                  return o ? s({
                    reason: d,
                    userContext: f
                  }) : void 0;
                }
              }
            );
          }
        }
      );
    }
    return e;
  }()
);
function S6e(e) {
  var t;
  e === void 0 && (e = {});
  var r = e.disableDefaultUI === !0, n = Nt.__assign(
    {
      functions: function(a) {
        return a;
      }
    },
    e.override
  );
  return Nt.__assign(
    Nt.__assign(
      {},
      Nt.normaliseRecipeModuleConfig(e)
    ),
    {
      disableDefaultUI: r,
      firstFactors: e == null ? void 0 : e.firstFactors,
      getSecondaryFactorInfo: function(a) {
        return a;
      },
      factorChooserScreen: (t = e.factorChooserScreen) !== null && t !== void 0 ? t : {},
      override: n
    }
  );
}
function E6e(e, t, r, n) {
  Nt.logDebugMessage(
    "getAvailableFactors: allowed to setup: ".concat(e.allowedToSetup)
  ), Nt.logDebugMessage(
    "getAvailableFactors: already setup: ".concat(e.alreadySetup)
  ), Nt.logDebugMessage("getAvailableFactors: next from factorInfo: ".concat(e.next)), Nt.logDebugMessage(
    "getAvailableFactors: nextArrayQueryParam: ".concat(t)
  ), Nt.logDebugMessage(
    "getAvailableFactors: secondary factors: ".concat(
      r.getSecondaryFactors(n).map(function(i) {
        return i.id;
      })
    )
  );
  var a = t !== void 0 ? t.split(",") : e.next, s = r.getSecondaryFactors(n).filter(function(i) {
    var o = i.id;
    return a.length === 0 ? e.allowedToSetup.includes(o) || e.alreadySetup.includes(o) : a.includes(o);
  });
  return s;
}
var T6e = (
  /** @class */
  function(e) {
    Nt.__extends(t, e);
    function t(n, a) {
      a === void 0 && (a = ej.default);
      var s = e.call(this, n) || this;
      return s.webJSRecipe = a, s.recipeID = t.RECIPE_ID, s.secondaryFactors = [], s.getDefaultRedirectionURL = function(i, o) {
        return Nt.__awaiter(s, void 0, void 0, function() {
          var l, c;
          return Nt.__generator(this, function(u) {
            if (i.action === "FACTOR_CHOOSER")
              return l = i.nextFactorOptions && i.nextFactorOptions.length > 0 ? i.nextFactorOptions.join(",") : void 0, [
                2,
                Nt.getDefaultRedirectionURLForPath(
                  this.config,
                  s8,
                  i,
                  {
                    n: l,
                    stepUp: i.stepUp ? "true" : void 0
                  }
                )
              ];
            if (i.action === "GO_TO_FACTOR") {
              if (c = this.getSecondaryFactors(o).find(function(d) {
                return d.id === i.factorId;
              }), c !== void 0)
                return [
                  2,
                  Nt.getDefaultRedirectionURLForPath(
                    this.config,
                    c.path,
                    i,
                    {
                      setup: i.forceSetup ? "true" : void 0,
                      stepUp: i.stepUp ? "true" : void 0
                    }
                  )
                ];
              throw new Error("Requested redirect to unknown factor id: " + i.factorId);
            } else
              return [2, "/"];
          });
        });
      }, g6e.PostSuperTokensInitCallbacks.addPostInitCallback(function() {
        var i = t.MultiFactorAuthClaim.validators.hasCompletedMFARequirementsForAuth();
        v6e.SessionClaimValidatorStore.addClaimValidatorFromOtherRecipe(
          i
        ), b6e.Session.getInstanceOrThrow().addEventListener(function() {
          var o = a8.WindowHandlerReference.getReferenceOrThrow();
          o.windowHandler.sessionStorage.removeItemSync(Iy);
        });
      }), s;
    }
    t.init = function(n) {
      var a = S6e(n);
      return {
        recipeID: t.RECIPE_ID,
        authReact: function(s) {
          return t.instance = new t(
            Nt.__assign(
              Nt.__assign({}, a),
              { appInfo: s, recipeId: t.RECIPE_ID }
            )
          ), t.instance;
        },
        webJS: ej.default.init(
          Nt.__assign(
            Nt.__assign({}, a),
            {
              override: {
                functions: function(s, i) {
                  var o = x6e(a.onHandleEvent);
                  return i.override(o), i.override(a.override.functions), s;
                }
              }
            }
          )
        )
      };
    }, t.getInstance = function() {
      return t.instance;
    }, t.getInstanceOrThrow = function() {
      if (t.instance === void 0) {
        var n = "No instance of MultiFactorAuth found. Make sure to call the MultiFactorAuth.init method.";
        throw typeof window > "u" && (n = n + Nt.SSR_ERROR), Error(n);
      }
      return t.instance;
    }, t.prototype.addMFAFactors = function(n) {
      this.secondaryFactors = Nt.__spreadArray(
        Nt.__spreadArray(
          [],
          this.secondaryFactors.filter(function(a) {
            return n.every(function(s) {
              return a.id !== s.id;
            });
          }),
          !0
        ),
        n,
        !0
      );
    }, t.prototype.isFirstFactorEnabledOnClient = function(n) {
      return this.config.firstFactors === void 0 || this.config.firstFactors.includes(n);
    }, t.prototype.getSecondaryFactors = function(n) {
      return this.config.getSecondaryFactorInfo(this.secondaryFactors, n);
    }, t.prototype.redirectToFactor = function(n) {
      var a = n.factorId, s = n.forceSetup, i = n.stepUp, o = n.redirectBack, l = n.navigate, c = n.userContext;
      return Nt.__awaiter(this, void 0, void 0, function() {
        var u, d, d;
        return Nt.__generator(this, function(f) {
          switch (f.label) {
            case 0:
              return [
                4,
                this.getRedirectUrl(
                  {
                    action: "GO_TO_FACTOR",
                    forceSetup: s,
                    stepUp: i,
                    factorId: a,
                    tenantIdFromQueryParams: Nt.getTenantIdFromQueryParams()
                  },
                  ZL.getNormalisedUserContext(c)
                )
              ];
            case 1:
              return u = f.sent(), u === null ? [
                2
                /*return*/
              ] : (o ? (d = Nt.getCurrentNormalisedUrlPathWithQueryParamsAndFragments(), u = Nt.appendQueryParamsToURL(u, {
                redirectToPath: d
              })) : (d = Nt.getRedirectToPathFromURL(), d && (u = Nt.appendQueryParamsToURL(u, {
                redirectToPath: d
              }))), [
                2,
                Nt.SuperTokens.getInstanceOrThrow().redirectToUrl(
                  u,
                  l
                )
              ]);
          }
        });
      });
    }, t.prototype.redirectToFactorChooser = function(n) {
      var a = n.redirectBack, s = a === void 0 ? !1 : a, i = n.nextFactorOptions, o = i === void 0 ? [] : i, l = n.stepUp, c = n.navigate, u = n.userContext;
      return Nt.__awaiter(this, void 0, void 0, function() {
        var d, f, f;
        return Nt.__generator(this, function(h) {
          switch (h.label) {
            case 0:
              return [
                4,
                this.getRedirectUrl(
                  {
                    action: "FACTOR_CHOOSER",
                    nextFactorOptions: o,
                    stepUp: l,
                    tenantIdFromQueryParams: Nt.getTenantIdFromQueryParams()
                  },
                  ZL.getNormalisedUserContext(u)
                )
              ];
            case 1:
              return d = h.sent(), d === null ? [
                2
                /*return*/
              ] : (s ? (f = Nt.getCurrentNormalisedUrlPathWithQueryParamsAndFragments(), d = Nt.appendQueryParamsToURL(d, {
                redirectToPath: f
              })) : (f = Nt.getRedirectToPathFromURL(), f && (d = Nt.appendQueryParamsToURL(d, {
                redirectToPath: f
              }))), [
                2,
                Nt.SuperTokens.getInstanceOrThrow().redirectToUrl(
                  d,
                  c
                )
              ]);
          }
        });
      });
    }, t.reset = function() {
      Nt.isTest() && (t.instance = void 0);
    };
    var r;
    return r = t, t.RECIPE_ID = "multifactorauth", t.MultiFactorAuthClaim = new _6e(
      function() {
        return t.getInstanceOrThrow();
      },
      function(n, a) {
        return Nt.__awaiter(void 0, void 0, void 0, function() {
          return Nt.__generator(r, function(s) {
            switch (s.label) {
              case 0:
                return [
                  4,
                  this.getInstanceOrThrow().getRedirectUrl(
                    Nt.__assign(
                      Nt.__assign({}, n),
                      {
                        tenantIdFromQueryParams: Nt.getTenantIdFromQueryParams()
                      }
                    ),
                    a
                  )
                ];
              case 1:
                return [2, s.sent() || void 0];
            }
          });
        });
      }
    ), t;
  }(y6e.RecipeModule)
);
Lx.DEFAULT_FACTOR_CHOOSER_PATH = s8;
Lx.MultiFactorAuth = T6e;
Lx.getAvailableFactors = E6e;
var Fx = {}, i8 = ba;
function C6e(e) {
  return i8.normaliseRecipeModuleConfig(e);
}
function o8(e, t) {
  if (t.length !== 0)
    for (var r = function(s) {
      var i = e[s], o = t.filter(function(u) {
        return !i.factorIds.includes(u);
      });
      if (o.length === 0)
        return { value: [i] };
      var l = e.filter(function(u) {
        return u.factorIds.every(function(d) {
          return o.includes(d);
        });
      });
      if (l.length !== 0) {
        var c = o8(l, o);
        if (c !== void 0)
          return { value: i8.__spreadArray([i], c, !0) };
      }
    }, n = 0; n < e.length; ++n) {
      var a = r(n);
      if (typeof a == "object") return a.value;
    }
}
Fx.normaliseAuthRecipe = C6e;
Fx.selectComponentsToCoverAllFirstFactors = o8;
var Re = ba, st = v, nr = M, k6e = f2, Jc = Nx, O6e = nv, A6e = OT, P6e = Mx, Dy = Lx, br = ql, J0 = v2, R6e = Fx, I6e = Vh;
function y2(e) {
  return e && e.__esModule ? e : { default: e };
}
var zs = /* @__PURE__ */ y2(nr), D6e = /* @__PURE__ */ y2(k6e), l8 = /* @__PURE__ */ y2(I6e), Bx = zs.default.createContext("IS_DEFAULT");
function c8() {
  return st.jsx(
    "svg",
    Re.__assign(
      { version: "1.1", viewBox: "25 25 50 50", "data-supertokens": "spinnerIcon" },
      {
        children: st.jsxs(
          "circle",
          Re.__assign(
            {
              cx: "50",
              cy: "50",
              r: "20",
              fill: "none",
              stroke: "rgb(var(--palette-primary))",
              strokeWidth: "5",
              strokeLinecap: "round",
              strokeDashoffset: "0",
              strokeDasharray: "100, 200"
            },
            {
              children: [
                st.jsx("animateTransform", {
                  attributeName: "transform",
                  attributeType: "XML",
                  type: "rotate",
                  from: "0 50 50",
                  to: "360 50 50",
                  dur: "4s",
                  repeatCount: "indefinite"
                }),
                st.jsx("animate", {
                  attributeName: "stroke-dashoffset",
                  values: "0;-30;-124",
                  dur: "2s",
                  repeatCount: "indefinite"
                }),
                st.jsx("animate", {
                  attributeName: "stroke-dasharray",
                  values: "0,200;110,200;110,200",
                  dur: "2s",
                  repeatCount: "indefinite"
                })
              ]
            }
          )
        )
      }
    )
  );
}
var N6e = function(e) {
  var t = nr.useContext(Bx);
  if (t === "IS_DEFAULT")
    throw new Error("Cannot use component override outside ComponentOverrideContext provider.");
  var r = t[e];
  return r === void 0 ? null : r;
}, uv = function(e, t) {
  var r = e + "_Override";
  return t.displayName = r, function(n) {
    var a = N6e(r);
    return a !== null ? st.jsx(
      a,
      Re.__assign({ DefaultComponent: t }, n)
    ) : st.jsx(t, Re.__assign({}, n));
  };
}, M6e = `[data-supertokens~="container"] {
    --palette-background: 255, 255, 255;
    --palette-inputBackground: 250, 250, 250;
    --palette-inputBorder: 224, 224, 224;
    --palette-primary: 28, 34, 42;
    --palette-primaryBorder: 45, 54, 68;
    --palette-success: 65, 167, 0;
    --palette-successBackground: 217, 255, 191;
    --palette-error: 255, 23, 23;
    --palette-errorBackground: 255, 241, 235;
    --palette-textTitle: 0, 0, 0;
    --palette-textLabel: 0, 0, 0;
    --palette-textInput: 0, 0, 0;
    --palette-textPrimary: 128, 128, 128;
    --palette-textLink: 0, 122, 255;
    --palette-buttonText: 255, 255, 255;
    --palette-textGray: 54, 54, 54;
    --palette-superTokensBrandingBackground: 242, 245, 246;
    --palette-superTokensBrandingText: 173, 189, 196;

    --font-size-0: 12px;
    --font-size-1: 14px;
    --font-size-2: 16px;
    --font-size-3: 19px;
    --font-size-4: 24px;
    --font-size-5: 28px;
}
/*
 * Default styles.
 */
@keyframes slideTop {
    0% {
        transform: translateY(-5px);
    }
    100% {
        transform: translateY(0px);
    }
}
@keyframes swing-in-top-fwd {
    0% {
        transform: rotateX(-100deg);
        transform-origin: top;
        opacity: 0;
    }
    100% {
        transform: rotateX(0deg);
        transform-origin: top;
        opacity: 1;
    }
}
[data-supertokens~="container"] {
    font-family: "Arial", sans-serif;
    margin: 12px auto;
    margin-top: 26px;
    margin-bottom: 26px;
    width: 420px;
    text-align: center;
    border-radius: 8px;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.16);
    background-color: rgb(var(--palette-background));
}
@media (max-width: 440px) {
    [data-supertokens~="container"] {
        width: 95vw;
    }
}
[data-supertokens~="row"] {
    margin: 0 auto;
    width: 76%;
    padding-top: 30px;
    padding-bottom: 10px;
}
[data-supertokens~="superTokensBranding"] {
    display: block;
    margin: 10px auto 0;
    background: rgb(var(--palette-superTokensBrandingBackground));
    color: rgb(var(--palette-superTokensBrandingText));
    text-decoration: none;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    border-radius: 6px 6px 0 0;
    padding: 4px 9px;
    font-weight: 400;
    font-size: var(--font-size-0);
    letter-spacing: 0.4px;
}
[data-supertokens~="generalError"] {
    background: rgb(var(--palette-errorBackground));
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    margin-top: 24px;
    padding-left: 18px;
    padding-right: 18px;
    letter-spacing: 0.2px;
    font-size: var(--font-size-1);
    border-radius: 8px;
    color: rgb(var(--palette-error));
    animation: swing-in-top-fwd 1s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
    word-wrap: break-word;
}
[data-supertokens~="headerTitle"] {
    font-size: var(--font-size-4);
    line-height: 27.6px;
    letter-spacing: 0.58px;
    font-weight: 700;
    margin-bottom: 20px;
    color: rgb(var(--palette-textTitle));
}
[data-supertokens~="headerSubtitle"] {
    font-weight: 400;
    color: rgb(var(--palette-textGray));
    margin-bottom: 21px;
}
[data-supertokens~="headerSubtitle"][data-supertokens~="secondaryText"] {
    color: rgb(var(--palette-textGray));
    font-weight: 400;
}
[data-supertokens~="privacyPolicyAndTermsAndConditions"] {
    max-width: 300px;
    margin-top: 10px;
}
[data-supertokens~="privacyPolicyAndTermsAndConditions"] a {
    line-height: 21px;
}
/* TODO: split the link style into separate things*/
/* We add this before primary and secondary text, because if they are applied to the same element the other ones take priority */
[data-supertokens~="link"] {
    padding-left: 3px;
    padding-right: 3px;
    color: rgb(var(--palette-textLink));
    font-size: var(--font-size-1);
    cursor: pointer;
    letter-spacing: 0.16px;
    line-height: 26px;
}
[data-supertokens~="primaryText"] {
    font-size: var(--font-size-2);
    font-weight: 400;
    letter-spacing: 0.4px;
    line-height: 21px;
    color: rgb(var(--palette-textLabel));
}
[data-supertokens~="secondaryText"] {
    font-size: var(--font-size-1);
    font-weight: 400;
    letter-spacing: 0.4px;
    color: rgb(var(--palette-textPrimary));
}
[data-supertokens~="secondaryText"] strong {
    font-weight: 600;
}
[data-supertokens~="divider"] {
    margin-top: 1.5em;
    margin-bottom: 1.5em;
    border-bottom: 0.3px solid #dddddd;
    align-items: center;
    padding-bottom: 5px;
    flex: 3 3;
}
[data-supertokens~="headerTinyTitle"] {
    margin-top: 24px;
    font-size: var(--font-size-5);
    letter-spacing: 1.1px;
    font-weight: 700;
    line-height: 28px;
}
[data-supertokens~="secondaryLinkWithArrow"] {
    margin-top: 10px;
    margin-bottom: 30px;
    cursor: pointer;
}
[data-supertokens~="secondaryLinkWithArrow"]:hover {
    position: relative;
    left: 2px;
    word-spacing: 4px;
}
[data-supertokens~="generalSuccess"] {
    color: rgb(var(--palette-success));
    font-size: var(--font-size-1);
    background: rgb(var(--palette-successBackground));
    animation: swing-in-top-fwd 1s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
    padding: 9px 15px 9px 15px;
    border-radius: 6px;
    display: inline-block;
}
[data-supertokens~="spinner"] {
    width: 80px;
    height: auto;
    padding-top: 20px;
    padding-bottom: 40px;
    margin: 0 auto;
}
[data-supertokens~="error"] {
    color: rgb(var(--palette-error));
}
[data-supertokens~="linkButton"] {
    font-family: "Arial", sans-serif;
    background-color: transparent;
    border: 0;
}
[data-supertokens~="secondaryLinkWithLeftArrow"] {
    color: rgb(var(--palette-textGray));
    font-weight: 400;
    margin-top: 10px;
    margin-bottom: 40px;
    cursor: pointer;
}
[data-supertokens~="secondaryLinkWithLeftArrow"] svg {
    margin-right: 0.3em;
}
[data-supertokens~="secondaryLinkWithLeftArrow"]:hover svg {
    position: relative;
    left: -4px;
}
[data-supertokens~="button"] {
    font-family: "Arial", sans-serif;
    background-color: rgb(var(--palette-primary));
    color: rgb(var(--palette-buttonText));
    width: 100%;
    height: 34px;
    font-weight: 600;
    border-width: 1px;
    border-style: solid;
    border-radius: 6px;
    border-color: rgb(var(--palette-primaryBorder));
    background-position: center;
    transition: all 0.4s;
    background-size: 12000%;
    cursor: pointer;
}
[data-supertokens~="button"]:disabled {
    border: none;
    cursor: no-drop;
}
[data-supertokens~="button"]:active {
    outline: none;
    transition: all 0s;
    background-size: 100%;
    filter: brightness(0.85);
}
[data-supertokens~="button"]:focus {
    outline: none;
}
[data-supertokens~="backButtonCommon"] {
    width: 16px;
    height: 13px;
}
[data-supertokens~="backButton"] {
    cursor: pointer;
    border: none;
    background-color: transparent;
    padding: 0px;
}
[data-supertokens~="backButtonPlaceholder"] {
    display: block;
}
[data-supertokens~="delayedRender"] {
    animation-duration: 0.1s;
    animation-name: animate-fade;
    animation-delay: 0.2s;
    animation-fill-mode: backwards;
}
@keyframes animate-fade {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
[data-supertokens~="footerLinkGroupVert"] {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    gap: 24px;
}
[data-supertokens~="footerLinkGroupVert"] > div {
    cursor: pointer;
    margin: 0;
}
[data-supertokens~="footerLinkGroupVert"] [data-supertokens~="secondaryText"] {
    font-weight: 400;
}
[data-supertokens~="footerLinkGroupVert"] [data-supertokens~="secondaryLinkWithLeftArrow"] {
    font-weight: 400;
    position: relative;
    left: -6px; /* half the width of the left arrow */
}
@media (max-width: 360px) {
    [data-supertokens~="footerLinkGroupVert"] {
        flex-direction: column;
    }
    [data-supertokens~="footerLinkGroupVert"] > div {
        margin: 0 auto;
    }
}
[data-supertokens~="footerLinkGroupVert"] div:only-child {
    margin-left: auto;
    margin-right: auto;
    margin-top: 14px;
}
[data-supertokens~="withBackButton"] {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
[data-supertokens~="dividerWithOr"] {
    padding-top: 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: rgb(var(--palette-textPrimary));
}
[data-supertokens~="dividerText"] {
    flex: 1 1;
    font-weight: 400;
    font-size: var(--font-size-1);
}
[data-supertokens~="formLabelWithLinkWrapper"] {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
[data-supertokens~="formLabelLinkBtn"] {
    width: auto;
    margin-top: 0;
    line-height: 24px;
    font-size: var(--font-size-0);
}
[data-supertokens~="formLabelLinkBtn"]:hover {
    text-decoration: underline;
}
[data-supertokens~="formLabelLinkBtn"]:disabled {
    color: rgb(var(--palette-textPrimary));
    cursor: default;
    text-decoration: none;
}
[data-supertokens~="authComponentList"] {
    padding-bottom: 20px;
}
[data-supertokens~="authPageTitleOAuthClient"] {
    color: rgb(var(--palette-textGray));
    font-size: var(--font-size-1);
    font-weight: 400;
    margin: 10px 0 25px;
}
[data-supertokens~="authPageTitleOAuthClientUrl"] {
    text-decoration: none;
}
[data-supertokens~="authPageTitleOAuthClientLogo"] {
    width: 44px;
    height: 44px;
    margin-bottom: 10px;
}
[data-supertokens~="authPageTitleOAuthClient"] [data-supertokens~="authPageTitleOAuthClientName"] {
    color: rgb(var(--palette-textTitle));
}
[data-supertokens~="buttonWithArrow"] {
    border-radius: 6px;
    border: 1px solid #d0d5dd;
    width: 100%;
    color: rgb(var(--palette-textGray));
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    margin: 24px 0;
    min-height: 48px;
    cursor: pointer;
}
[data-supertokens~="buttonWithArrow"]:hover {
    background-color: rgb(var(--palette-inputBackground));
}
[data-supertokens~="buttonWithArrow"] [data-supertokens~="secondaryText"] {
    font-weight: 700;
    font-size: var(--font-size-2);
    color: rgb(var(--palette-textGray));
    margin: 0;
}
[data-supertokens~="buttonWithArrow"]:hover [data-supertokens~="secondaryLinkWithRightArrow"] ~ svg {
    position: relative;
    left: 2px;
}
[data-supertokens~="buttonWithArrow"]:hover [data-supertokens~="secondaryLinkWithLeftArrow"] svg {
    position: relative;
    left: -2px;
}
[data-supertokens~="buttonWithArrow"] [data-supertokens~="secondaryLinkWithLeftArrow"] {
    display: flex;
    align-items: center;
}
`, L6e = function(e) {
  var t = e.children, r = e.userStyles;
  return st.jsxs(nr.Fragment, {
    children: [t, st.jsxs("style", { children: [M6e, r.join(`
`)] })]
  });
}, j6e = function() {
  return st.jsx(
    "div",
    Re.__assign(
      { "data-supertokens": "container delayedRender" },
      {
        children: st.jsx(
          "div",
          Re.__assign(
            { "data-supertokens": "row" },
            {
              children: st.jsx(
                "div",
                Re.__assign(
                  { "data-supertokens": "spinner delayedRender" },
                  { children: st.jsx(c8, {}) }
                )
              )
            }
          )
        )
      }
    )
  );
}, F6e = uv(
  "MultitenancyDynamicLoginMethodsSpinnerTheme",
  j6e
), B6e = function(e) {
  var t = Re.SuperTokens.getInstanceOrThrow().rootStyle;
  return st.jsx(
    L6e,
    Re.__assign(
      { userStyles: [t, e.config.recipeRootStyle] },
      { children: st.jsx(F6e, {}) }
    )
  );
}, Ux = function() {
  var e = Re.Multitenancy.getInstanceOrThrow(), t = P6e.useContext();
  return st.jsx(
    Bx.Provider,
    Re.__assign(
      { value: t },
      {
        children: st.jsx(
          b2,
          Re.__assign(
            { useShadowDom: Re.SuperTokens.getInstanceOrThrow().useShadowDom },
            { children: st.jsx(B6e, { config: e.config }) }
          )
        )
      }
    )
  );
}, u8 = zs.default.createContext(void 0), U6e = function() {
  var e = zs.default.useContext(u8);
  if (e === void 0)
    throw new Error("useDynamicLoginMethods used outside of a valid provider (FeatureWrapper)");
  return e;
}, d8 = function(e) {
  var t = e.value, r = e.children, n = t === void 0 ? { loaded: !1 } : { loaded: !0, loginMethods: t };
  return st.jsx(
    u8.Provider,
    Re.__assign({ value: n }, { children: r })
  );
}, Vx = zs.default.createContext(void 0), Kh = function() {
  return zs.default.useContext(Vx);
}, hT = function(e) {
  var t = e.children, r = e.userContext, n = nr.useState(Re.getNormalisedUserContext(r))[0];
  return st.jsx(
    Vx.Provider,
    Re.__assign({ value: n }, { children: t })
  );
};
function V6e(e) {
  var t = e.children, r = e.useShadowDom, n = e.defaultStore, a = Kh(), s = Re.useRethrowInRender(), i = nr.useState(void 0), o = i[0], l = i[1], c = Re.SuperTokens.getInstanceOrThrow();
  return nr.useEffect(
    function() {
      o || Re.Multitenancy.getInstanceOrThrow().getCurrentDynamicLoginMethods({ userContext: a }).then(
        function(u) {
          return l(u);
        },
        function(u) {
          return s(u);
        }
      );
    },
    [o, l]
  ), Re.SuperTokens.usesDynamicLoginMethods && !o ? st.jsx(Ux, {}) : st.jsx(
    d8,
    Re.__assign(
      { value: o },
      {
        children: st.jsx(
          Jc.TranslationContextProvider,
          Re.__assign(
            {
              defaultLanguage: c.languageTranslations.defaultLanguage,
              defaultStore: Re.mergeObjects(
                n,
                c.languageTranslations.userTranslationStore
              ),
              translationControlEventSource: c.languageTranslations.translationEventSource,
              userTranslationFunc: c.languageTranslations.userTranslationFunc
            },
            {
              children: st.jsx(
                b2,
                Re.__assign(
                  { useShadowDom: r },
                  { children: t }
                )
              )
            }
          )
        )
      }
    )
  );
}
function $6e(e) {
  var t = e.children, r = nr.useRef(null), n = nr.useState(), a = n[0], s = n[1];
  return nr.useEffect(
    function() {
      r.current && s(function(i) {
        return i || r.current.shadowRoot || r.current.attachShadow({ mode: "open", delegatesFocus: !1 });
      });
    },
    [r]
  ), st.jsx(
    "div",
    Re.__assign(
      { id: Re.ST_ROOT_ID, ref: r },
      { children: a && A6e.createPortal(t, a) }
    )
  );
}
function b2(e) {
  var t = e.children, r = e.useShadowDom;
  return r === !1 ? st.jsxs(
    "div",
    Re.__assign(
      { id: Re.ST_ROOT_ID },
      { children: [t, st.jsx(tj, {})] }
    )
  ) : st.jsxs($6e, { children: [t, st.jsx(tj, {})] });
}
function tj() {
  return st.jsx(
    "style",
    Re.__assign(
      { type: "text/css" },
      {
        children: "input.supertokens-input:-webkit-autofill,input.supertokens-input:-webkit-autofill:focus,input.supertokens-input:-webkit-autofill:hover,select:-webkit-autofill,select:-webkit-autofill:focus,select:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{transition:background-color 5000s ease-in-out 0s}"
      }
    )
  );
}
var f8 = {
  en: {
    AUTH_PAGE_HEADER_TITLE_SIGN_IN_AND_UP: "Sign Up / Sign In",
    AUTH_PAGE_HEADER_TITLE_SIGN_IN: "Sign In",
    AUTH_PAGE_HEADER_TITLE_SIGN_UP: "Sign Up",
    AUTH_PAGE_HEADER_TITLE_SIGN_IN_UP_TO_APP: " to continue to ",
    AUTH_PAGE_HEADER_SUBTITLE_SIGN_IN_START: "Not registered yet?",
    AUTH_PAGE_HEADER_SUBTITLE_SIGN_IN_SIGN_UP_LINK: "Sign Up",
    AUTH_PAGE_HEADER_SUBTITLE_SIGN_IN_END: "",
    AUTH_PAGE_HEADER_SUBTITLE_SIGN_UP_START: "Already have an account?",
    AUTH_PAGE_HEADER_SUBTITLE_SIGN_UP_SIGN_IN_LINK: "Sign In",
    AUTH_PAGE_HEADER_SUBTITLE_SIGN_UP_END: "",
    AUTH_PAGE_FOOTER_START: "By continuing, you agree to our ",
    AUTH_PAGE_FOOTER_TOS: "Terms of Service",
    AUTH_PAGE_FOOTER_AND: " and ",
    AUTH_PAGE_FOOTER_PP: "Privacy Policy",
    AUTH_PAGE_FOOTER_END: "",
    DIVIDER_OR: "or",
    BRANDING_POWERED_BY_START: "Powered by ",
    BRANDING_POWERED_BY_END: "",
    SOMETHING_WENT_WRONG_ERROR: "Something went wrong. Please try again.",
    SOMETHING_WENT_WRONG_ERROR_RELOAD: "Something went wrong. Please try again later or reload the page."
  }
}, w2 = zs.default.createContext({
  loading: !0,
  isDefault: !0
}), h8 = function() {
  var e = zs.default.useContext(w2);
  if (e.isDefault === !0)
    throw new Error("Cannot use useSessionContext outside auth wrapper components.");
  return e;
}, p8 = Re.createGenericComponentsOverrideContext(), H6e = p8[0], m8 = p8[1];
function g8() {
  var e = Jc.useTranslation();
  return st.jsxs(
    "a",
    Re.__assign(
      {
        "data-supertokens": "superTokensBranding",
        href: "https://supertokens.com?utm_campaign=poweredby",
        target: "_blank"
      },
      {
        children: [
          e("BRANDING_POWERED_BY_START"),
          st.jsx("strong", { children: "SuperTokens" }),
          e("BRANDING_POWERED_BY_END")
        ]
      }
    )
  );
}
function x2(e) {
  return e.userContext !== void 0 ? st.jsx(
    hT,
    Re.__assign({ userContext: e.userContext }, { children: e.children })
  ) : st.jsx(Vx.Consumer, {
    children: function(t) {
      return t === void 0 ? st.jsx(hT, { children: e.children }) : e.children;
    }
  });
}
function v8(e) {
  var t = e.error, r = Jc.useTranslation();
  return st.jsx(
    "div",
    Re.__assign({ "data-supertokens": "generalError" }, { children: r(t) })
  );
}
var W6e = `[data-supertokens~="container"] {
    --palette-background: 255, 255, 255;
    --palette-inputBackground: 250, 250, 250;
    --palette-inputBorder: 224, 224, 224;
    --palette-primary: 28, 34, 42;
    --palette-primaryBorder: 45, 54, 68;
    --palette-success: 65, 167, 0;
    --palette-successBackground: 217, 255, 191;
    --palette-error: 255, 23, 23;
    --palette-errorBackground: 255, 241, 235;
    --palette-textTitle: 0, 0, 0;
    --palette-textLabel: 0, 0, 0;
    --palette-textInput: 0, 0, 0;
    --palette-textPrimary: 128, 128, 128;
    --palette-textLink: 0, 122, 255;
    --palette-buttonText: 255, 255, 255;
    --palette-textGray: 54, 54, 54;
    --palette-superTokensBrandingBackground: 242, 245, 246;
    --palette-superTokensBrandingText: 173, 189, 196;

    --font-size-0: 12px;
    --font-size-1: 14px;
    --font-size-2: 16px;
    --font-size-3: 19px;
    --font-size-4: 24px;
    --font-size-5: 28px;
}
/*
 * Default styles.
 */
@keyframes slideTop {
    0% {
        transform: translateY(-5px);
    }
    100% {
        transform: translateY(0px);
    }
}
@keyframes swing-in-top-fwd {
    0% {
        transform: rotateX(-100deg);
        transform-origin: top;
        opacity: 0;
    }
    100% {
        transform: rotateX(0deg);
        transform-origin: top;
        opacity: 1;
    }
}
[data-supertokens~="container"] {
    font-family: "Arial", sans-serif;
    margin: 12px auto;
    margin-top: 26px;
    margin-bottom: 26px;
    width: 420px;
    text-align: center;
    border-radius: 8px;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.16);
    background-color: rgb(var(--palette-background));
}
@media (max-width: 440px) {
    [data-supertokens~="container"] {
        width: 95vw;
    }
}
[data-supertokens~="row"] {
    margin: 0 auto;
    width: 76%;
    padding-top: 30px;
    padding-bottom: 10px;
}
[data-supertokens~="superTokensBranding"] {
    display: block;
    margin: 10px auto 0;
    background: rgb(var(--palette-superTokensBrandingBackground));
    color: rgb(var(--palette-superTokensBrandingText));
    text-decoration: none;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    border-radius: 6px 6px 0 0;
    padding: 4px 9px;
    font-weight: 400;
    font-size: var(--font-size-0);
    letter-spacing: 0.4px;
}
[data-supertokens~="generalError"] {
    background: rgb(var(--palette-errorBackground));
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    margin-top: 24px;
    padding-left: 18px;
    padding-right: 18px;
    letter-spacing: 0.2px;
    font-size: var(--font-size-1);
    border-radius: 8px;
    color: rgb(var(--palette-error));
    animation: swing-in-top-fwd 1s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
    word-wrap: break-word;
}
[data-supertokens~="headerTitle"] {
    font-size: var(--font-size-4);
    line-height: 27.6px;
    letter-spacing: 0.58px;
    font-weight: 700;
    margin-bottom: 20px;
    color: rgb(var(--palette-textTitle));
}
[data-supertokens~="headerSubtitle"] {
    font-weight: 400;
    color: rgb(var(--palette-textGray));
    margin-bottom: 21px;
}
[data-supertokens~="headerSubtitle"][data-supertokens~="secondaryText"] {
    color: rgb(var(--palette-textGray));
    font-weight: 400;
}
[data-supertokens~="privacyPolicyAndTermsAndConditions"] {
    max-width: 300px;
    margin-top: 10px;
}
[data-supertokens~="privacyPolicyAndTermsAndConditions"] a {
    line-height: 21px;
}
/* TODO: split the link style into separate things*/
/* We add this before primary and secondary text, because if they are applied to the same element the other ones take priority */
[data-supertokens~="link"] {
    padding-left: 3px;
    padding-right: 3px;
    color: rgb(var(--palette-textLink));
    font-size: var(--font-size-1);
    cursor: pointer;
    letter-spacing: 0.16px;
    line-height: 26px;
}
[data-supertokens~="primaryText"] {
    font-size: var(--font-size-2);
    font-weight: 400;
    letter-spacing: 0.4px;
    line-height: 21px;
    color: rgb(var(--palette-textLabel));
}
[data-supertokens~="secondaryText"] {
    font-size: var(--font-size-1);
    font-weight: 400;
    letter-spacing: 0.4px;
    color: rgb(var(--palette-textPrimary));
}
[data-supertokens~="secondaryText"] strong {
    font-weight: 600;
}
[data-supertokens~="divider"] {
    margin-top: 1.5em;
    margin-bottom: 1.5em;
    border-bottom: 0.3px solid #dddddd;
    align-items: center;
    padding-bottom: 5px;
    flex: 3 3;
}
[data-supertokens~="headerTinyTitle"] {
    margin-top: 24px;
    font-size: var(--font-size-5);
    letter-spacing: 1.1px;
    font-weight: 700;
    line-height: 28px;
}
[data-supertokens~="secondaryLinkWithArrow"] {
    margin-top: 10px;
    margin-bottom: 30px;
    cursor: pointer;
}
[data-supertokens~="secondaryLinkWithArrow"]:hover {
    position: relative;
    left: 2px;
    word-spacing: 4px;
}
[data-supertokens~="generalSuccess"] {
    color: rgb(var(--palette-success));
    font-size: var(--font-size-1);
    background: rgb(var(--palette-successBackground));
    animation: swing-in-top-fwd 1s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
    padding: 9px 15px 9px 15px;
    border-radius: 6px;
    display: inline-block;
}
[data-supertokens~="spinner"] {
    width: 80px;
    height: auto;
    padding-top: 20px;
    padding-bottom: 40px;
    margin: 0 auto;
}
[data-supertokens~="error"] {
    color: rgb(var(--palette-error));
}
[data-supertokens~="linkButton"] {
    font-family: "Arial", sans-serif;
    background-color: transparent;
    border: 0;
}
[data-supertokens~="secondaryLinkWithLeftArrow"] {
    color: rgb(var(--palette-textGray));
    font-weight: 400;
    margin-top: 10px;
    margin-bottom: 40px;
    cursor: pointer;
}
[data-supertokens~="secondaryLinkWithLeftArrow"] svg {
    margin-right: 0.3em;
}
[data-supertokens~="secondaryLinkWithLeftArrow"]:hover svg {
    position: relative;
    left: -4px;
}
[data-supertokens~="button"] {
    font-family: "Arial", sans-serif;
    background-color: rgb(var(--palette-primary));
    color: rgb(var(--palette-buttonText));
    width: 100%;
    height: 34px;
    font-weight: 600;
    border-width: 1px;
    border-style: solid;
    border-radius: 6px;
    border-color: rgb(var(--palette-primaryBorder));
    background-position: center;
    transition: all 0.4s;
    background-size: 12000%;
    cursor: pointer;
}
[data-supertokens~="button"]:disabled {
    border: none;
    cursor: no-drop;
}
[data-supertokens~="button"]:active {
    outline: none;
    transition: all 0s;
    background-size: 100%;
    filter: brightness(0.85);
}
[data-supertokens~="button"]:focus {
    outline: none;
}
[data-supertokens~="backButtonCommon"] {
    width: 16px;
    height: 13px;
}
[data-supertokens~="backButton"] {
    cursor: pointer;
    border: none;
    background-color: transparent;
    padding: 0px;
}
[data-supertokens~="backButtonPlaceholder"] {
    display: block;
}
[data-supertokens~="delayedRender"] {
    animation-duration: 0.1s;
    animation-name: animate-fade;
    animation-delay: 0.2s;
    animation-fill-mode: backwards;
}
@keyframes animate-fade {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
[data-supertokens~="footerLinkGroupVert"] {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    gap: 24px;
}
[data-supertokens~="footerLinkGroupVert"] > div {
    cursor: pointer;
    margin: 0;
}
[data-supertokens~="footerLinkGroupVert"] [data-supertokens~="secondaryText"] {
    font-weight: 400;
}
[data-supertokens~="footerLinkGroupVert"] [data-supertokens~="secondaryLinkWithLeftArrow"] {
    font-weight: 400;
    position: relative;
    left: -6px; /* half the width of the left arrow */
}
@media (max-width: 360px) {
    [data-supertokens~="footerLinkGroupVert"] {
        flex-direction: column;
    }
    [data-supertokens~="footerLinkGroupVert"] > div {
        margin: 0 auto;
    }
}
[data-supertokens~="footerLinkGroupVert"] div:only-child {
    margin-left: auto;
    margin-right: auto;
    margin-top: 14px;
}
[data-supertokens~="withBackButton"] {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
[data-supertokens~="dividerWithOr"] {
    padding-top: 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: rgb(var(--palette-textPrimary));
}
[data-supertokens~="dividerText"] {
    flex: 1 1;
    font-weight: 400;
    font-size: var(--font-size-1);
}
[data-supertokens~="formLabelWithLinkWrapper"] {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
[data-supertokens~="formLabelLinkBtn"] {
    width: auto;
    margin-top: 0;
    line-height: 24px;
    font-size: var(--font-size-0);
}
[data-supertokens~="formLabelLinkBtn"]:hover {
    text-decoration: underline;
}
[data-supertokens~="formLabelLinkBtn"]:disabled {
    color: rgb(var(--palette-textPrimary));
    cursor: default;
    text-decoration: none;
}
[data-supertokens~="authComponentList"] {
    padding-bottom: 20px;
}
[data-supertokens~="authPageTitleOAuthClient"] {
    color: rgb(var(--palette-textGray));
    font-size: var(--font-size-1);
    font-weight: 400;
    margin: 10px 0 25px;
}
[data-supertokens~="authPageTitleOAuthClientUrl"] {
    text-decoration: none;
}
[data-supertokens~="authPageTitleOAuthClientLogo"] {
    width: 44px;
    height: 44px;
    margin-bottom: 10px;
}
[data-supertokens~="authPageTitleOAuthClient"] [data-supertokens~="authPageTitleOAuthClientName"] {
    color: rgb(var(--palette-textTitle));
}
[data-supertokens~="buttonWithArrow"] {
    border-radius: 6px;
    border: 1px solid #d0d5dd;
    width: 100%;
    color: rgb(var(--palette-textGray));
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    margin: 24px 0;
    min-height: 48px;
    cursor: pointer;
}
[data-supertokens~="buttonWithArrow"]:hover {
    background-color: rgb(var(--palette-inputBackground));
}
[data-supertokens~="buttonWithArrow"] [data-supertokens~="secondaryText"] {
    font-weight: 700;
    font-size: var(--font-size-2);
    color: rgb(var(--palette-textGray));
    margin: 0;
}
[data-supertokens~="buttonWithArrow"]:hover [data-supertokens~="secondaryLinkWithRightArrow"] ~ svg {
    position: relative;
    left: 2px;
}
[data-supertokens~="buttonWithArrow"]:hover [data-supertokens~="secondaryLinkWithLeftArrow"] svg {
    position: relative;
    left: -2px;
}
[data-supertokens~="buttonWithArrow"] [data-supertokens~="secondaryLinkWithLeftArrow"] {
    display: flex;
    align-items: center;
}
`, z6e = function(e) {
  var t = e.children, r = e.userStyles;
  return st.jsxs(nr.Fragment, {
    children: [t, st.jsxs("style", { children: [W6e, r.join(`
`)] })]
  });
}, _2 = uv("AuthPageComponentList", function(t) {
  for (var r = Jc.useTranslation(), n = [t.authComponents[0]], a = function(i) {
    n.push(function() {
      return st.jsxs(
        "div",
        Re.__assign(
          { "data-supertokens": "dividerWithOr" },
          {
            children: [
              st.jsx("div", { "data-supertokens": "divider" }),
              st.jsx(
                "div",
                Re.__assign(
                  { "data-supertokens": "dividerText" },
                  { children: r("DIVIDER_OR") }
                )
              ),
              st.jsx("div", { "data-supertokens": "divider" })
            ]
          }
        ),
        "divider-".concat(i)
      );
    }), n.push(t.authComponents[i]);
  }, s = 1; s < t.authComponents.length; ++s)
    a(s);
  return st.jsx(
    "div",
    Re.__assign(
      { "data-supertokens": "authComponentList" },
      {
        children: n.map(function(i) {
          return i(Re.__assign({}, t));
        })
      }
    )
  );
}), S2 = uv("AuthPageFooter", function(t) {
  var r = t.hasSeparateSignUpView, n = t.isSignUp, a = t.termsOfServiceLink, s = t.privacyPolicyLink, i = Jc.useTranslation();
  return a === void 0 && s === void 0 || r && !n ? null : st.jsxs(
    "div",
    Re.__assign(
      { "data-supertokens": "secondaryText privacyPolicyAndTermsAndConditions" },
      {
        children: [
          i("AUTH_PAGE_FOOTER_START"),
          a !== void 0 && st.jsx(
            "a",
            Re.__assign(
              {
                "data-supertokens": "link",
                href: a,
                target: "_blank",
                rel: "noopener noreferer"
              },
              { children: i("AUTH_PAGE_FOOTER_TOS") }
            )
          ),
          a !== void 0 && s !== void 0 && i("AUTH_PAGE_FOOTER_AND"),
          s !== void 0 && st.jsx(
            "a",
            Re.__assign(
              {
                "data-supertokens": "link",
                href: s,
                target: "_blank",
                rel: "noopener noreferer"
              },
              { children: i("AUTH_PAGE_FOOTER_PP") }
            )
          ),
          i("AUTH_PAGE_FOOTER_END")
        ]
      }
    )
  );
});
function K6e(e) {
  var t = e.color;
  return st.jsx(
    "svg",
    Re.__assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "13",
        viewBox: "0 0 16 13",
        "data-supertokens": "heavyArrowLeftIcon"
      },
      {
        children: st.jsx("path", {
          fill: t,
          d: "M13 6.8h.022H3.8l2.9 2.9a.761.761 0 0 1 0 1.07l-.451.451a.754.754 0 0 1-1.064 0L.22 6.254a.759.759 0 0 1 0-1.068L5.186.22a.755.755 0 0 1 1.064 0l.45.451a.746.746 0 0 1 .22.532.724.724 0 0 1-.22.522l-2.93 2.92h9.24a.781.781 0 0 1 .764.773v.638A.766.766 0 0 1 13 6.8z",
          transform: "translate(1.182 .708)"
        })
      }
    )
  );
}
function y8(e) {
  var t = e.onClick;
  return st.jsx(
    "button",
    Re.__assign(
      { onClick: t, "data-supertokens": "backButton backButtonCommon" },
      { children: st.jsx(K6e, { color: "rgb(var(--palette-textTitle))" }) }
    )
  );
}
var E2 = uv("AuthPageHeader", function(t) {
  var r = t.onSignInUpSwitcherClick, n = t.hasSeparateSignUpView, a = t.isSignUp, s = t.showBackButton, i = t.resetFactorList, o = t.oauth2ClientInfo, l = Jc.useTranslation();
  return st.jsxs(nr.Fragment, {
    children: [
      (o == null ? void 0 : o.logoUri) && st.jsx("img", {
        src: o.logoUri,
        alt: o.clientName,
        "data-supertokens": "authPageTitleOAuthClientLogo"
      }),
      st.jsxs(
        "div",
        Re.__assign(
          { "data-supertokens": "headerTitle withBackButton" },
          {
            children: [
              s ? st.jsx(y8, { onClick: i }) : st.jsx("span", {
                "data-supertokens": "backButtonPlaceholder backButtonCommon"
              }),
              l(n ? a ? "AUTH_PAGE_HEADER_TITLE_SIGN_UP" : "AUTH_PAGE_HEADER_TITLE_SIGN_IN" : "AUTH_PAGE_HEADER_TITLE_SIGN_IN_AND_UP"),
              st.jsx("span", { "data-supertokens": "backButtonPlaceholder backButtonCommon" })
            ]
          }
        )
      ),
      o && o.clientName !== void 0 && o.clientName.length > 0 && st.jsxs(
        "div",
        Re.__assign(
          { "data-supertokens": "authPageTitleOAuthClient" },
          {
            children: [
              l("AUTH_PAGE_HEADER_TITLE_SIGN_IN_UP_TO_APP"),
              o.clientUri !== void 0 ? st.jsx(
                "a",
                Re.__assign(
                  {
                    "data-supertokens": "authPageTitleOAuthClientUrl link",
                    href: o.clientUri
                  },
                  { children: o.clientName }
                )
              ) : st.jsx(
                "span",
                Re.__assign(
                  { "data-supertokens": "authPageTitleOAuthClientName" },
                  { children: o.clientName }
                )
              )
            ]
          }
        )
      ),
      n && (a ? st.jsxs(
        "div",
        Re.__assign(
          { "data-supertokens": "headerSubtitle secondaryText" },
          {
            children: [
              l("AUTH_PAGE_HEADER_SUBTITLE_SIGN_UP_START"),
              st.jsx(
                "span",
                Re.__assign(
                  { "data-supertokens": "link", onClick: r },
                  { children: l("AUTH_PAGE_HEADER_SUBTITLE_SIGN_UP_SIGN_IN_LINK") }
                )
              ),
              l("AUTH_PAGE_HEADER_SUBTITLE_SIGN_UP_END")
            ]
          }
        )
      ) : st.jsxs(
        "div",
        Re.__assign(
          { "data-supertokens": "headerSubtitle secondaryText" },
          {
            children: [
              l("AUTH_PAGE_HEADER_SUBTITLE_SIGN_IN_START"),
              st.jsx(
                "span",
                Re.__assign(
                  { "data-supertokens": "link", onClick: r },
                  { children: l("AUTH_PAGE_HEADER_SUBTITLE_SIGN_IN_SIGN_UP_LINK") }
                )
              ),
              l("AUTH_PAGE_HEADER_SUBTITLE_SIGN_IN_END")
            ]
          }
        )
      )),
      st.jsx("div", { "data-supertokens": "divider" })
    ]
  });
});
function T2(e) {
  return e.fullPageCompWithPreloadedInfo ? st.jsx(st.Fragment, {
    children: e.fullPageCompWithPreloadedInfo.component(
      Re.__assign(Re.__assign({}, e), {
        preloadInfo: e.fullPageCompWithPreloadedInfo.preloadInfo
      })
    )
  }) : st.jsxs(
    "div",
    Re.__assign(
      {
        "data-supertokens": "container authPage ".concat(
          e.factorIds.length > 1 ? "multiFactor" : "singleFactor"
        )
      },
      {
        children: [
          st.jsxs(
            "div",
            Re.__assign(
              { "data-supertokens": "row" },
              {
                children: [
                  st.jsx(E2, {
                    factorIds: e.factorIds,
                    isSignUp: e.isSignUp,
                    onSignInUpSwitcherClick: e.onSignInUpSwitcherClick,
                    hasSeparateSignUpView: e.hasSeparateSignUpView,
                    resetFactorList: e.resetFactorList,
                    showBackButton: e.showBackButton,
                    oauth2ClientInfo: e.oauth2ClientInfo
                  }),
                  e.error !== void 0 && st.jsx(v8, { error: e.error }),
                  st.jsx(
                    _2,
                    Re.__assign({}, e)
                  ),
                  st.jsx(S2, {
                    factorIds: e.factorIds,
                    isSignUp: e.isSignUp,
                    hasSeparateSignUpView: e.hasSeparateSignUpView,
                    privacyPolicyLink: e.privacyPolicyLink,
                    termsOfServiceLink: e.termsOfServiceLink
                  })
                ]
              }
            )
          ),
          st.jsx(g8, {})
        ]
      }
    )
  );
}
function q6e(e) {
  var t = Re.SuperTokens.getInstanceOrThrow().rootStyle;
  return st.jsx(
    x2,
    Re.__assign(
      { userContext: e.userContext },
      {
        children: st.jsx(
          z6e,
          Re.__assign(
            { userStyles: [t] },
            { children: st.jsx(T2, Re.__assign({}, e)) }
          )
        )
      }
    )
  );
}
var G6e = {
  signin: "SOMETHING_WENT_WRONG_ERROR",
  no_email_present: "THIRD_PARTY_ERROR_NO_EMAIL",
  restart_link: "ERROR_SIGN_IN_UP_LINK"
}, b8 = function(e) {
  var t = H6e();
  return st.jsx(
    hT,
    Re.__assign(
      { userContext: e.userContext },
      {
        children: st.jsx(
          k2,
          Re.__assign(
            { requireAuth: !1, doRedirection: !1 },
            {
              children: st.jsx(
                Bx.Provider,
                Re.__assign(
                  { value: t },
                  {
                    children: st.jsx(
                      Y6e,
                      Re.__assign({}, e)
                    )
                  }
                )
              )
            }
          )
        )
      }
    )
  );
}, Y6e = function(e) {
  var t, r, n, a, s;
  if (e.factors !== void 0 && e.factors.length === 0)
    throw new Error("The factors array cannot be empty");
  var i = O6e.WindowHandlerReference.getReferenceOrThrow().windowHandler, o = new URLSearchParams(i.location.getSearch()), l = o.get("show"), c = e.useSignUpStateFromQueryString !== !0 || l === null ? void 0 : l === "signup", u = o.get("error") !== null && (r = (t = o.get("message")) !== null && t !== void 0 ? t : o.get("error")) !== null && r !== void 0 ? r : void 0;
  u = u !== void 0 ? (n = G6e[u]) !== null && n !== void 0 ? n : u : void 0;
  var d = nr.useRef(l), f = nr.useRef(u), h = o.get("loginChallenge"), p = o.get("forceFreshAuth") === "true", m = h8(), g = Kh(), y = Re.useRethrowInRender(), x = nr.useState(void 0), w = x[0], _ = x[1], S = nr.useState(void 0), C = S[0], E = S[1], O = nr.useState(u), k = O[0], A = O[1], P = nr.useState(!1), D = P[0], N = P[1], z = Re.SuperTokens.getInstanceOrThrow(), G = nr.useState(e.factors), Y = G[0], te = G[1], ae = nr.useState(
    (s = (a = e.isSignUp) !== null && a !== void 0 ? a : c) !== null && s !== void 0 ? s : z.defaultToSignUp
  ), ne = ae[0], ue = ae[1], q = nr.useState(0), U = q[0], Q = q[1], L = nr.useRef({ buildReq: void 0 });
  nr.useEffect(function() {
    if (e.useSignUpStateFromQueryString && d.current !== l) {
      var we = e.useSignUpStateFromQueryString !== !0 || l === null ? void 0 : l === "signup";
      d.current = l;
      var Pe = we ?? z.defaultToSignUp;
      ne !== Pe && (ue(Pe), Q(function(rt) {
        return rt + 1;
      }));
    }
  }), nr.useEffect(function() {
    f.current !== u && (f.current = u, A(u));
  });
  var j = nr.useCallback(
    function() {
      e.useSignUpStateFromQueryString === !0 && Re.updateQueryParam("show", ne ? "signin" : "signup"), A(void 0), ue(!ne), Q(function(we) {
        return we + 1;
      });
    },
    [ne, ue, Q, A, e.useSignUpStateFromQueryString]
  );
  nr.useEffect(
    function() {
      w || Re.Multitenancy.getInstanceOrThrow().getCurrentDynamicLoginMethods({ userContext: g }).then(
        function(we) {
          return _(we);
        },
        function(we) {
          return y(we);
        }
      );
    },
    [w, _]
  ), Re.useOnMountAPICall(
    function() {
      return Re.__awaiter(void 0, void 0, void 0, function() {
        var we;
        return Re.__generator(this, function(Pe) {
          return C ? [
            2
            /*return*/
          ] : (we = J0.OAuth2Provider.getInstance(), we !== void 0 && h !== null ? [
            2,
            we.webJSRecipe.getLoginChallengeInfo({
              loginChallenge: h,
              userContext: g
            })
          ] : [2, void 0]);
        });
      });
    },
    function(we) {
      return Re.__awaiter(void 0, void 0, void 0, function() {
        return Re.__generator(this, function(Pe) {
          return we !== void 0 && (we.status === "OK" ? E(we.info) : A("SOMETHING_WENT_WRONG_ERROR")), [
            2
            /*return*/
          ];
        });
      });
    },
    function() {
      Re.clearQueryParams(["loginChallenge"]), A("SOMETHING_WENT_WRONG_ERROR");
    }
  ), nr.useEffect(
    function() {
      if (!D && m.loading === !1)
        if (m.doesSessionExist)
          if (e.onSessionAlreadyExists !== void 0)
            e.onSessionAlreadyExists();
          else if (e.redirectOnSessionExists !== !1 && !p) {
            br.Session.getInstanceOrThrow().config.onHandleEvent({
              action: "SESSION_ALREADY_EXISTS"
            });
            var we = J0.OAuth2Provider.getInstance();
            h !== null && we !== void 0 ? function() {
              return Re.__awaiter(this, void 0, void 0, function() {
                var Pe;
                return Re.__generator(this, function(rt) {
                  switch (rt.label) {
                    case 0:
                      return [
                        4,
                        we.webJSRecipe.getRedirectURLToContinueOAuthFlow({
                          loginChallenge: h,
                          userContext: g
                        })
                      ];
                    case 1:
                      return Pe = rt.sent().frontendRedirectTo, [
                        2,
                        br.Session.getInstanceOrThrow().validateGlobalClaimsAndHandleSuccessRedirection(
                          {
                            // We get here if the user was redirected to the auth screen with an already existing session
                            // and a loginChallenge (we check the forceFreshAuth queryparam above)
                            action: "SUCCESS_OAUTH2",
                            frontendRedirectTo: Pe,
                            // We can use these defaults, since this is not the result of a sign in/up call
                            createdNewUser: !1,
                            isNewRecipeUser: !1,
                            newSessionCreated: !1,
                            tenantIdFromQueryParams: Re.getTenantIdFromQueryParams(),
                            recipeId: br.Session.RECIPE_ID
                          },
                          br.Session.RECIPE_ID,
                          Re.getRedirectToPathFromURL(),
                          g,
                          e.navigate
                        )
                      ];
                  }
                });
              });
            }().catch(y) : br.Session.getInstanceOrThrow().validateGlobalClaimsAndHandleSuccessRedirection(
              void 0,
              br.Session.RECIPE_ID,
              Re.getRedirectToPathFromURL(),
              g,
              e.navigate
            ).catch(y);
          } else
            N(!0);
        else
          N(!0);
    },
    [m.loading]
  );
  var K = nr.useState(), J = K[0], re = K[1], le = Y !== void 0 && (e.factors === void 0 || e.factors.some(function(we) {
    return !Y.includes(we);
  })), pe = Re.SuperTokens.getInstanceOrThrow(), me = pe.privacyPolicyLink, Oe = pe.termsOfServiceLink;
  nr.useEffect(
    function() {
      var we = new AbortController();
      if (L.current.buildReq !== U)
        return D && (w !== void 0 || !Re.SuperTokens.usesDynamicLoginMethods) && X6e(
          e.preBuiltUIList,
          w,
          g,
          Y,
          ne,
          re,
          we.signal
        ).then(function() {
          L.current.buildReq = U;
        }, y), function() {
          we.abort();
        };
    },
    [
      D,
      U,
      Q,
      e.preBuiltUIList,
      w,
      g,
      Y,
      ne,
      re,
      y
    ]
  );
  var ee = nr.useCallback(
    function(we) {
      return Re.__awaiter(void 0, void 0, void 0, function() {
        var Pe, rt;
        return Re.__generator(this, function(ht) {
          switch (ht.label) {
            case 0:
              return Pe = J0.OAuth2Provider.getInstance(), h === null || Pe === void 0 ? [
                2,
                br.Session.getInstanceOrThrow().validateGlobalClaimsAndHandleSuccessRedirection(
                  Re.__assign(
                    Re.__assign({}, we),
                    {
                      action: "SUCCESS",
                      tenantIdFromQueryParams: Re.getTenantIdFromQueryParams(),
                      redirectToPath: Re.getRedirectToPathFromURL()
                    }
                  ),
                  we.recipeId,
                  Re.getRedirectToPathFromURL(),
                  g,
                  e.navigate
                )
              ] : [
                4,
                Pe.webJSRecipe.getRedirectURLToContinueOAuthFlow({
                  loginChallenge: h,
                  userContext: g
                })
              ];
            case 1:
              return rt = ht.sent().frontendRedirectTo, [
                2,
                br.Session.getInstanceOrThrow().validateGlobalClaimsAndHandleSuccessRedirection(
                  Re.__assign(
                    Re.__assign({}, we),
                    {
                      action: "SUCCESS_OAUTH2",
                      tenantIdFromQueryParams: Re.getTenantIdFromQueryParams(),
                      frontendRedirectTo: rt
                    }
                  ),
                  we.recipeId,
                  Re.getRedirectToPathFromURL(),
                  g,
                  e.navigate
                )
              ];
          }
        });
      });
    },
    [h]
  ), he = J !== void 0 && (h === null || C !== void 0 || J0.OAuth2Provider.getInstance() === void 0) ? Re.__assign(
    Re.__assign({}, J),
    {
      oauth2ClientInfo: C,
      onAuthSuccess: ee,
      error: k,
      onError: function(we) {
        A(we);
      },
      clearError: function() {
        return A(void 0);
      },
      navigate: e.navigate,
      onSignInUpSwitcherClick: j,
      privacyPolicyLink: me,
      rebuildAuthPage: function() {
        return Q(function(we) {
          return we + 1;
        });
      },
      setFactorList: function(we) {
        te(we), Q(function(Pe) {
          return Pe + 1;
        });
      },
      resetFactorList: function() {
        te(e.factors), Q(function(we) {
          return we + 1;
        });
      },
      showBackButton: le,
      termsOfServiceLink: Oe,
      userContext: g
    }
  ) : void 0, Ee = nr.useMemo(
    function() {
      var we = f8;
      if (J !== void 0)
        for (var Pe = 0, rt = e.preBuiltUIList; Pe < rt.length; Pe++) {
          var ht = rt[Pe];
          we = Re.mergeObjects(we, ht.languageTranslations);
        }
      return we = Re.mergeObjects(we, z.languageTranslations.userTranslationStore), we;
    },
    [z.languageTranslations.userTranslationStore, J]
  );
  return he === void 0 ? st.jsx(Ux, {}) : st.jsx(
    d8,
    Re.__assign(
      { value: w },
      {
        children: st.jsx(
          Jc.TranslationContextProvider,
          Re.__assign(
            {
              defaultLanguage: z.languageTranslations.defaultLanguage,
              defaultStore: Ee,
              translationControlEventSource: z.languageTranslations.translationEventSource,
              userTranslationFunc: z.languageTranslations.userTranslationFunc
            },
            {
              children: st.jsx(
                b2,
                Re.__assign(
                  { useShadowDom: z.useShadowDom },
                  {
                    children: st.jsxs(nr.Fragment, {
                      children: [
                        e.children === void 0 && st.jsx(
                          q6e,
                          Re.__assign({}, he)
                        ),
                        e.children && zs.default.Children.map(
                          e.children,
                          function(we) {
                            return zs.default.isValidElement(we) ? zs.default.cloneElement(
                              we,
                              he
                            ) : we;
                          }
                        )
                      ]
                    })
                  }
                )
              )
            }
          )
        )
      }
    )
  );
};
function X6e(e, t, r, n, a, s, i) {
  var o, l, c, u, d;
  return Re.__awaiter(this, void 0, void 0, function() {
    var f, h, p, m, g, y, x, w, _, S, C, E, O, k, A, P, D, N, z, G, Y, te, ae, ne;
    return Re.__generator(this, function(ue) {
      switch (ue.label) {
        case 0:
          if (f = Re.SuperTokens.getInstanceOrThrow().recipeList.filter(function(q) {
            return "firstFactorIds" in q;
          }), h = (c = (o = n ?? (t == null ? void 0 : t.firstFactors)) !== null && o !== void 0 ? o : (l = Dy.MultiFactorAuth.getInstance()) === null || l === void 0 ? void 0 : l.config.firstFactors) !== null && c !== void 0 ? c : f.reduce(function(q, U) {
            return Re.__spreadArray(
              Re.__spreadArray([], q, !0),
              U.getFirstFactorsForAuthPage(),
              !0
            );
          }, []), n === void 0 && (t == null ? void 0 : t.firstFactors) === void 0 && ((u = Dy.MultiFactorAuth.getInstance()) === null || u === void 0 ? void 0 : u.config.firstFactors) === void 0 && (p = f.filter(function(q) {
            return !e.some(function(U) {
              return U.recipeInstance.recipeID === q.recipeID;
            });
          }), p.length > 0))
            throw new Error(
              "Factor list not set but PreBuiltUI not added for ".concat(
                p.map(function(q) {
                  return q.recipeID;
                })
              )
            );
          if (h.length === 0)
            throw new Error("There are no enabled factors to show");
          if (h.includes(br.FactorIds.THIRDPARTY) && (m = e.find(function(q) {
            return q.recipeInstance.recipeID === br.FactorIds.THIRDPARTY;
          }), m !== void 0 && m.recipeInstance.config.signInAndUpFeature.providers.length === 0 && (!Re.SuperTokens.usesDynamicLoginMethods || t.thirdparty.providers.length === 0) && (h = h.filter(function(q) {
            return q !== br.FactorIds.THIRDPARTY;
          }), h.length === 0)))
            throw new Error(
              "The only enabled first factor is thirdparty, but no providers were defined. Please define at least one provider."
            );
          for (g = e.some(function(q) {
            return q.requiresSignUpPage && q.recipeInstance.firstFactorIds.some(function(U) {
              return h.includes(U);
            });
          }), y = g && a, x = [], w = 0, _ = e; w < _.length; w++)
            S = _[w], x.push.apply(x, S.getAuthComponents());
          C = 0, E = x, ue.label = 1;
        case 1:
          return C < E.length ? (O = E[C], O.type !== "FULL_PAGE" ? [3, 3] : [4, O.preloadInfoAndRunChecks(h, r)]) : [3, 4];
        case 2:
          if (k = ue.sent(), i.aborted)
            return [
              2
              /*return*/
            ];
          if (k.shouldDisplay)
            return s({
              authComponents: [],
              fullPageCompWithPreloadedInfo: {
                component: O.component,
                preloadInfo: k.preloadInfo
              },
              isSignUp: y,
              hasSeparateSignUpView: g,
              factorIds: h
            }), [
              2
              /*return*/
            ];
          ue.label = 3;
        case 3:
          return C++, [3, 1];
        case 4:
          if (i.aborted)
            return [
              2
              /*return*/
            ];
          if (A = x.filter(function(q) {
            return q.type !== "FULL_PAGE" && q.factorIds.every(function(U) {
              return h.includes(U);
            });
          }), A = A.filter(
            function(q) {
              return q.type === "SIGN_IN_UP" || // sign in+up components show in all cases
              (y ? q.type === "SIGN_UP" : q.type === "SIGN_IN");
            }
            // otherwise we check if the sign up state is appropriate
          ), A.sort(function(q, U) {
            return U.factorIds.length - q.factorIds.length;
          }), P = R6e.selectComponentsToCoverAllFirstFactors(A, h), P === void 0) {
            for (D = /* @__PURE__ */ new Set(), N = 0, z = A; N < z.length; N++)
              for (G = z[N], Y = 0, te = G.factorIds; Y < te.length; Y++)
                ae = te[Y], D.add(ae);
            throw ne = n !== void 0 ? "local state or props" : (t == null ? void 0 : t.firstFactors) !== void 0 ? "dynamic tenant configuration" : ((d = Dy.MultiFactorAuth.getInstance()) === null || d === void 0 ? void 0 : d.config.firstFactors) !== void 0 ? "the config passed to the MFA recipe" : "all recipes initialized", new Error(
              "Couldn't cover all first factors: ".concat(h.join(", "), " (from ").concat(ne, "), available components: ").concat(Array.from(D).join(", "), `.
`) + `You may have missed adding a recipe into the list of prebuiltUIs passed to list of prebuiltUIs passed to getSuperTokensRoutesForReactRouterDom, canHandleRoute, handleRoute functions or the AuthPage component.
Another common error is adding a non-existent factor id into the list, e.g.: passwordless instead of otp-email/phone`
            );
          }
          return s({
            authComponents: P.sort(function(q, U) {
              return q.displayOrder - U.displayOrder;
            }).map(function(q) {
              return q.component;
            }),
            factorIds: h,
            hasSeparateSignUpView: g,
            isSignUp: y
          }), [
            2
            /*return*/
          ];
      }
    });
  });
}
var Hf = [
  {
    rid: "thirdpartyemailpassword",
    includes: ["thirdparty", "emailpassword"],
    factorsProvided: [br.FactorIds.THIRDPARTY, br.FactorIds.EMAILPASSWORD]
  },
  {
    rid: "thirdpartypasswordless",
    includes: ["thirdparty", "passwordless"],
    factorsProvided: [
      br.FactorIds.THIRDPARTY,
      br.FactorIds.OTP_PHONE,
      br.FactorIds.OTP_EMAIL,
      br.FactorIds.LINK_PHONE,
      br.FactorIds.LINK_EMAIL
    ]
  },
  { rid: "emailpassword", includes: ["emailpassword"], factorsProvided: [br.FactorIds.EMAILPASSWORD] },
  {
    rid: "passwordless",
    includes: ["passwordless"],
    factorsProvided: [
      br.FactorIds.OTP_PHONE,
      br.FactorIds.OTP_EMAIL,
      br.FactorIds.LINK_PHONE,
      br.FactorIds.LINK_EMAIL
    ]
  },
  { rid: "thirdparty", includes: ["thirdparty"], factorsProvided: [br.FactorIds.THIRDPARTY] }
];
function rj(e, t) {
  for (var r, n, a = function(O, k) {
    if (e.every(function(P) {
      return k.includes(P);
    })) {
      var A = t.find(function(P) {
        return P.recipeID === O;
      });
      if (A && (r = O, n = A, e.length === k.length))
        return Re.logDebugMessage(
          "Rendering ".concat(O, " because it matches factors: ").concat(e, " exactly")
        ), { value: A };
    }
  }, s = 0, i = Hf; s < i.length; s++) {
    var o = i[s], l = o.rid, c = o.factorsProvided, u = a(l, c);
    if (typeof u == "object") return u.value;
  }
  if (n !== void 0)
    return Re.logDebugMessage(
      "Rendering ".concat(r, " to cover ").concat(e, " as a fallback")
    ), n;
  var d = [];
  e.includes(br.FactorIds.EMAILPASSWORD) && d.push("emailpassword"), e.includes(br.FactorIds.THIRDPARTY) && d.push("thirdparty"), [
    br.FactorIds.OTP_PHONE,
    br.FactorIds.OTP_EMAIL,
    br.FactorIds.LINK_PHONE,
    br.FactorIds.LINK_EMAIL
  ].some(function(O) {
    return e.includes(O);
  }) && d.push("passwordless"), Re.logDebugMessage(
    "Choosing component using fallback logic w/ ".concat(d.join(", "), " enabled")
  );
  for (var f = d.length, h = function(O, k) {
    if (f === k.length && k.every(function(P) {
      return d.includes(P);
    })) {
      var A = t.find(function(P) {
        return P.recipeID === O;
      });
      if (A)
        return { value: A };
    }
  }, p = 0, m = Hf; p < m.length; p++) {
    var g = m[p], l = g.rid, y = g.includes, x = h(l, y);
    if (typeof x == "object") return x.value;
  }
  for (var w = function(O, k) {
    if (k.some(function(P) {
      return d.includes(P);
    })) {
      var A = t.find(function(P) {
        return P.recipeID === O;
      });
      if (A)
        return { value: A };
    }
  }, _ = 0, S = Hf; _ < S.length; _++) {
    var C = S[_], l = C.rid, y = C.includes, E = w(l, y);
    if (typeof E == "object") return E.value;
  }
  throw new Error("No enabled recipes overlap with the requested firstFactors: " + e);
}
var C2 = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this.getPathsToFeatureComponentWithRecipeIdMap = function() {
        if (t.pathsToFeatureComponentWithRecipeIdMap !== void 0)
          return t.pathsToFeatureComponentWithRecipeIdMap;
        for (var r = {}, n = t.getFeatures(), a = Object.keys(n), s = 0; s < a.length; s++) {
          var i = a[s];
          r[i] === void 0 && (r[i] = []), r[i].push(n[i]);
        }
        return t.pathsToFeatureComponentWithRecipeIdMap = r, t.pathsToFeatureComponentWithRecipeIdMap;
      }, this.requiresSignUpPage = !1;
    }
    return e.getMatchingComponentForRouteAndRecipeIdFromPreBuiltUIList = function(t, r, n, a) {
      var s = t.getAsStringDangerous(), i = s === Re.SuperTokens.getInstanceOrThrow().appInfo.websiteBasePath.getAsStringDangerous(), o = r.reduce(function(f, h) {
        for (var p = h.getPathsToFeatureComponentWithRecipeIdMap(), m = function(S, C) {
          (S === s || new RegExp("^" + S.replace(/:\w+/g, "[^/]+").replace(/\/\*/g, "/[^/]+") + "$").test(s)) && (f = f.concat(
            C.map(function(E) {
              return { comp: E, route: S };
            })
          ));
        }, g = 0, y = Object.entries(p); g < y.length; g++) {
          var x = y[g], w = x[0], _ = x[1];
          m(w, _);
        }
        return f;
      }, []), l = o.find(function(f) {
        return f.comp.matches();
      }), c;
      o.length === 0 ? c = void 0 : l !== void 0 ? c = l.comp : c = o[0].comp;
      var u = o.find(function(f) {
        var h = Hf.map(function(p) {
          return p.rid;
        });
        return !h.includes(f.comp.recipeID) || f.route !== Re.SuperTokens.getInstanceOrThrow().appInfo.websiteBasePath.getAsStringDangerous();
      });
      if (u)
        return u.comp;
      if (n)
        return c;
      var d = Dy.MultiFactorAuth.getInstance();
      if (Re.SuperTokens.usesDynamicLoginMethods === !1)
        return l ? l.comp : i && d && d.config.firstFactors !== void 0 ? rj(
          d.config.firstFactors,
          o.map(function(f) {
            return f.comp;
          })
        ) : c;
      if (a === void 0)
        throw new Error(
          "Should never come here: dynamic login methods info has not been loaded but recipeRouter rendered"
        );
      if (l && // if we find a component matching by rid
      (!Hf.map(function(f) {
        return f.rid;
      }).includes(l.comp.recipeID) || // from a non-auth recipe
      Hf.some(function(f) {
        return f.rid === l.comp.recipeID && f.factorsProvided.some(function(h) {
          return a.firstFactors.includes(h);
        });
      })))
        return l.comp;
      if (i)
        return rj(
          a.firstFactors,
          o.map(function(f) {
            return f.comp;
          })
        );
    }, e;
  }()
);
function dg(e) {
  var t, r, n = Kh(), a = Re.useRethrowInRender(), s = nr.useState(void 0), i = s[0], o = s[1], l = (t = e.getReactRouterDomWithCustomHistory()) === null || t === void 0 ? void 0 : t.useHistoryCustom(), c = e.path, u = c === Re.SuperTokens.getInstanceOrThrow().appInfo.websiteBasePath.getAsStringDangerous(), d = (r = e.getReactRouterDomWithCustomHistory()) === null || r === void 0 ? void 0 : r.useLocation(), f = zs.default.useMemo(
    function() {
      if (!u) {
        var h = new D6e.default(c);
        if (i !== void 0 || Re.SuperTokens.usesDynamicLoginMethods === !1) {
          var p = C2.getMatchingComponentForRouteAndRecipeIdFromPreBuiltUIList(
            h,
            e.preBuiltUIList,
            !1,
            i
          );
          return p === void 0 && Re.SuperTokens.usesDynamicLoginMethods === !0 && x8({ navigate: l, redirectBack: !1 }), p;
        }
      }
    },
    [c, d, i, e.preBuiltUIList]
  );
  return nr.useEffect(
    function() {
      i || Re.Multitenancy.getInstanceOrThrow().getCurrentDynamicLoginMethods({ userContext: n }).then(
        function(h) {
          return o(h);
        },
        function(h) {
          return a(h);
        }
      );
    },
    [i, o]
  ), u ? st.jsx(b8, {
    preBuiltUIList: e.preBuiltUIList,
    navigate: l,
    useSignUpStateFromQueryString: !0
  }) : Re.SuperTokens.usesDynamicLoginMethods && i === void 0 ? st.jsx(Ux, {}) : f === void 0 || i === void 0 && Re.SuperTokens.usesDynamicLoginMethods ? null : st.jsx(f.component, { navigate: l });
}
function Q6e(e) {
  var t = e.getReactRouterDomWithCustomHistory, r = e.recipeList, n = e.basePath, a = t();
  if (a === void 0)
    return [];
  var s = a.router.Route, i = Object.values(
    r.reduce(function(l, c) {
      var u = c.getPathsToFeatureComponentWithRecipeIdMap();
      return Object.keys(u).forEach(function(d) {
        d = d === "" ? "/" : d;
        var f = nj(n, d);
        d in l || (l[d] = st.jsx(
          s,
          Re.__assign(
            { exact: !0, path: f },
            {
              children: st.jsx(dg, {
                getReactRouterDomWithCustomHistory: t,
                preBuiltUIList: r,
                path: d
              })
            }
          ),
          "st-".concat(d)
        ));
      }), l;
    }, {})
  );
  if (!Re.SuperTokens.getInstanceOrThrow().disableAuthRoute && r.some(function(l) {
    return l.getAuthComponents().length !== 0;
  })) {
    var o = Re.SuperTokens.getInstanceOrThrow().appInfo.websiteBasePath.appendPath(new l8.default("/")).getAsStringDangerous();
    i.push(
      st.jsx(
        s,
        Re.__assign(
          { exact: !0, path: nj(n, o) },
          {
            children: st.jsx(dg, {
              getReactRouterDomWithCustomHistory: t,
              preBuiltUIList: r,
              path: o
            })
          }
        ),
        "st-/auth"
      )
    );
  }
  return i;
}
function nj(e, t) {
  var r = t;
  if (e !== void 0)
    if (r.startsWith(e))
      r = r.slice(e.length), r.startsWith("/") || (r = "/" + r);
    else
      throw new Error("basePath has to be a prefix of websiteBasePath passed to SuperTokens.init");
  return r;
}
function J6e(e) {
  var t = e.getReactRouterDomWithCustomHistory, r = e.recipeList, n = e.basePath, a = t();
  if (a === void 0)
    return [];
  var s = a.router.Route, i = Object.values(
    r.reduce(function(l, c) {
      var u = c.getPathsToFeatureComponentWithRecipeIdMap();
      return Object.keys(u).forEach(function(d) {
        d = d === "" ? "/" : d;
        var f = aj(n, d);
        d in l || (l[d] = st.jsx(
          s,
          {
            path: f,
            element: st.jsx(dg, {
              getReactRouterDomWithCustomHistory: t,
              preBuiltUIList: r,
              path: d
            })
          },
          "st-".concat(d)
        ));
      }), l;
    }, {})
  );
  if (!Re.SuperTokens.getInstanceOrThrow().disableAuthRoute && r.some(function(l) {
    return l.getAuthComponents().length !== 0;
  })) {
    var o = Re.SuperTokens.getInstanceOrThrow().appInfo.websiteBasePath.appendPath(new l8.default("/")).getAsStringDangerous();
    i.push(
      st.jsx(
        s,
        {
          path: aj(n, o),
          element: st.jsx(dg, {
            getReactRouterDomWithCustomHistory: t,
            preBuiltUIList: r,
            path: o
          })
        },
        "st-/auth"
      )
    );
  }
  return i;
}
function aj(e, t) {
  if (e !== void 0)
    if (t.startsWith(e))
      t = t.slice(e.length), t.startsWith("/") || (t = "/" + t);
    else
      throw new Error("basePath has to be a prefix of websiteBasePath passed to SuperTokens.init");
  return t;
}
var qh = (
  /** @class */
  function() {
    function e() {
    }
    return e.getSuperTokensRoutesForReactRouterDom = function(t, r, n) {
      if (r === void 0 && (r = []), t === void 0 || r.length === 0)
        throw new Error(
          // eslint-disable-next-line @typescript-eslint/quotes
          'Please use getSuperTokensRoutesForReactRouterDom like getSuperTokensRoutesForReactRouterDom(require("react-router-dom"), [EmailPasswordPreBuiltUI]) in your render function'
        );
      var a = r.map(function(i) {
        return i.getInstanceOrInitAndGetInstance();
      });
      if (e.reactRouterDomIsV6 === void 0 && (e.reactRouterDomIsV6 = t.withRouter === void 0), e.reactRouterDomIsV6) {
        if (e.reactRouterDom === void 0) {
          var s = function() {
            var i = t.useNavigate(), o = zs.default.useState(void 0), l = o[0], c = o[1];
            return zs.default.useEffect(
              function() {
                l !== void 0 && (c(void 0), i(l));
              },
              [l, i, c]
            ), c;
          };
          e.reactRouterDom = {
            router: t,
            useHistoryCustom: s,
            useLocation: t.useLocation
          };
        }
        return J6e({
          getReactRouterDomWithCustomHistory: e.getReactRouterDomWithCustomHistory,
          recipeList: a,
          basePath: n
        });
      }
      return e.reactRouterDom === void 0 && (e.reactRouterDom = {
        router: t,
        useHistoryCustom: t.useHistory,
        useLocation: t.useLocation
      }), Q6e({
        getReactRouterDomWithCustomHistory: e.getReactRouterDomWithCustomHistory,
        recipeList: a,
        basePath: n
      });
    }, e.canHandleRoute = function(t) {
      var r = t.map(function(s) {
        return s.getInstanceOrInitAndGetInstance();
      }), n = Re.getCurrentNormalisedUrlPath().getAsStringDangerous(), a = n === Re.SuperTokens.getInstanceOrThrow().appInfo.websiteBasePath.getAsStringDangerous();
      return a ? !Re.SuperTokens.getInstanceOrThrow().disableAuthRoute : C2.getMatchingComponentForRouteAndRecipeIdFromPreBuiltUIList(
        Re.getCurrentNormalisedUrlPath(),
        r,
        !0
      ) !== void 0;
    }, e.getRoutingComponent = function(t) {
      var r = t.map(function(n) {
        return n.getInstanceOrInitAndGetInstance();
      });
      return st.jsx(dg, {
        getReactRouterDomWithCustomHistory: e.getReactRouterDomWithCustomHistory,
        path: Re.getCurrentNormalisedUrlPath().getAsStringDangerous(),
        preBuiltUIList: r
      });
    }, e.getReactRouterDomWithCustomHistory = function() {
      return e.reactRouterDom;
    }, e.AuthPage = function(t) {
      return st.jsx(
        b8,
        Re.__assign({}, t, {
          preBuiltUIList: t.preBuiltUIList.map(function(r) {
            return r.getInstanceOrInitAndGetInstance();
          })
        })
      );
    }, e.AuthPageTheme = T2, e.AuthPageFooter = S2, e.AuthPageHeader = E2, e.AuthPageComponentList = _2, e.AuthRecipeComponentsOverrideContextProvider = m8, e;
  }()
), Z6e = qh.getSuperTokensRoutesForReactRouterDom, eUe = qh.canHandleRoute, tUe = qh.getRoutingComponent, rUe = qh.AuthPage, nUe = function(e) {
  var t, r = e.children, n = Re.__rest(e, ["children"]), a = nr.useRef(n.requireAuth);
  if (n.requireAuth !== a.current)
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/quotes
      'requireAuth prop should not change. If you are seeing this, it probably means that you are using SessionAuth in multiple routes with different values for requireAuth. To solve this, try adding the "key" prop to all uses of SessionAuth like <SessionAuth key="someUniqueKeyPerRoute" requireAuth={...}>'
    );
  var s = nr.useState({ loading: !0 }), i = s[0], o = s[1], l = nr.useCallback(
    function(y) {
      o(function(x) {
        return JSON.stringify(x) !== JSON.stringify(y) ? y : x;
      });
    },
    [o]
  ), c = nr.useRef(), u = nr.useRef(
    (t = qh.getReactRouterDomWithCustomHistory()) === null || t === void 0 ? void 0 : t.useHistoryCustom
  ), d;
  try {
    u.current && (d = u.current());
  } catch {
  }
  var f = Kh(), h = Re.useRethrowInRender(), p = nr.useCallback(function() {
    Re.SuperTokens.getInstanceOrThrow().redirectToAuth({
      navigate: d,
      userContext: f,
      redirectBack: !0
    });
  }, []), m = nr.useCallback(function() {
    return Re.__awaiter(void 0, void 0, void 0, function() {
      var y, x, w, _, S;
      return Re.__generator(this, function(C) {
        switch (C.label) {
          case 0:
            return c.current === void 0 && (c.current = br.Session.getInstanceOrThrow()), [
              4,
              c.current.doesSessionExist({
                userContext: f
              })
            ];
          case 1:
            if (y = C.sent(), y === !1)
              return [
                2,
                {
                  loading: !1,
                  doesSessionExist: !1,
                  accessTokenPayload: {},
                  invalidClaims: [],
                  userId: ""
                }
              ];
            C.label = 2;
          case 2:
            return C.trys.push([2, 4, , 6]), [
              4,
              c.current.validateClaims({
                overrideGlobalClaimValidators: n.overrideGlobalClaimValidators,
                userContext: f
              })
            ];
          case 3:
            return x = C.sent(), [3, 6];
          case 4:
            return w = C.sent(), [
              4,
              c.current.doesSessionExist({
                userContext: f
              })
            ];
          case 5:
            if (C.sent())
              throw w;
            return [
              2,
              {
                loading: !1,
                doesSessionExist: !1,
                accessTokenPayload: {},
                invalidClaims: [],
                userId: ""
              }
            ];
          case 6:
            return C.trys.push([6, 9, , 11]), S = {
              loading: !1,
              doesSessionExist: !0,
              invalidClaims: x
            }, [
              4,
              c.current.getAccessTokenPayloadSecurely({
                userContext: f
              })
            ];
          case 7:
            return S.accessTokenPayload = C.sent(), [
              4,
              c.current.getUserId({
                userContext: f
              })
            ];
          case 8:
            return [2, (S.userId = C.sent(), S)];
          case 9:
            return _ = C.sent(), [
              4,
              c.current.doesSessionExist({
                userContext: f
              })
            ];
          case 10:
            if (C.sent())
              throw _;
            return [
              2,
              {
                loading: !1,
                doesSessionExist: !1,
                accessTokenPayload: {},
                invalidClaims: [],
                userId: ""
              }
            ];
          case 11:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, []), g = nr.useCallback(
    function(y) {
      return Re.__awaiter(void 0, void 0, void 0, function() {
        var x, w;
        return Re.__generator(this, function(_) {
          switch (_.label) {
            case 0:
              if (i.loading === !1)
                return [
                  2
                  /*return*/
                ];
              if (n.doRedirection === !1) return [3, 8];
              if (!y.doesSessionExist && n.requireAuth !== !1)
                return p(), [
                  2
                  /*return*/
                ];
              if (y.invalidClaims.length === 0) return [3, 8];
              x = void 0, _.label = 1;
            case 1:
              return _.trys.push([1, 6, , 7]), [
                4,
                br.getFailureRedirectionInfo({
                  invalidClaims: y.invalidClaims,
                  overrideGlobalClaimValidators: n.overrideGlobalClaimValidators,
                  userContext: f
                })
              ];
            case 2:
              return x = _.sent(), x.redirectPath === void 0 ? [3, 5] : br.validateAndCompareOnFailureRedirectionURLToCurrent(
                x.redirectPath
              ) ? (l(y), [
                2
                /*return*/
              ]) : [3, 3];
            case 3:
              return [
                4,
                Re.SuperTokens.getInstanceOrThrow().redirectToUrl(
                  x.redirectPath,
                  d
                )
              ];
            case 4:
              return [2, _.sent()];
            case 5:
              return [3, 7];
            case 6:
              throw w = _.sent(), h(w), w;
            case 7:
              if (n.accessDeniedScreen !== void 0 && x.failedClaim !== void 0)
                return console.warn({
                  message: "Showing access denied screen because a claim validator failed",
                  claimValidationError: x.failedClaim
                }), [
                  2,
                  l(
                    Re.__assign(
                      Re.__assign({}, y),
                      { accessDeniedValidatorError: x.failedClaim }
                    )
                  )
                ];
              _.label = 8;
            case 8:
              return l(y), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    [
      i.loading,
      n.doRedirection,
      n.requireAuth,
      n.overrideGlobalClaimValidators,
      n.accessDeniedScreen,
      p,
      f,
      d
    ]
  );
  return Re.useOnMountAPICall(m, g), nr.useEffect(
    function() {
      function y(x) {
        return Re.__awaiter(this, void 0, void 0, function() {
          var w, _, S, C;
          return Re.__generator(this, function(E) {
            switch (E.label) {
              case 0:
                switch (w = x.action, w) {
                  case "SESSION_CREATED":
                    return [3, 1];
                  case "REFRESH_SESSION":
                    return [3, 1];
                  case "ACCESS_TOKEN_PAYLOAD_UPDATED":
                    return [3, 1];
                  case "API_INVALID_CLAIM":
                    return [3, 1];
                  case "SIGN_OUT":
                    return [3, 11];
                  case "UNAUTHORISED":
                    return [3, 12];
                }
                return [3, 13];
              case 1:
                return [
                  4,
                  c.current.validateClaims({
                    overrideGlobalClaimValidators: n.overrideGlobalClaimValidators,
                    userContext: f
                  })
                ];
              case 2:
                if (_ = E.sent(), n.doRedirection === !1) return [3, 10];
                S = void 0, E.label = 3;
              case 3:
                return E.trys.push([3, 8, , 9]), [
                  4,
                  br.getFailureRedirectionInfo({
                    invalidClaims: _,
                    overrideGlobalClaimValidators: n.overrideGlobalClaimValidators,
                    userContext: f
                  })
                ];
              case 4:
                return S = E.sent(), S.redirectPath ? br.validateAndCompareOnFailureRedirectionURLToCurrent(
                  S.redirectPath
                ) ? (l(
                  Re.__assign(
                    Re.__assign({}, x.sessionContext),
                    { loading: !1, invalidClaims: _ }
                  )
                ), [3, 7]) : [3, 5] : [3, 7];
              case 5:
                return [
                  4,
                  Re.SuperTokens.getInstanceOrThrow().redirectToUrl(
                    S.redirectPath,
                    d
                  )
                ];
              case 6:
                return [2, E.sent()];
              case 7:
                return [3, 9];
              case 8:
                throw C = E.sent(), h(C), C;
              case 9:
                if (n.accessDeniedScreen !== void 0 && S.failedClaim !== void 0)
                  return console.warn({
                    message: "Showing access denied screen because a claim validator failed",
                    claimValidationError: S.failedClaim
                  }), [
                    2,
                    l(
                      Re.__assign(
                        Re.__assign({}, x.sessionContext),
                        {
                          loading: !1,
                          invalidClaims: _,
                          accessDeniedValidatorError: S.failedClaim
                        }
                      )
                    )
                  ];
                E.label = 10;
              case 10:
                return l(
                  Re.__assign(
                    Re.__assign({}, x.sessionContext),
                    { loading: !1, invalidClaims: _ }
                  )
                ), [
                  2
                  /*return*/
                ];
              case 11:
                return l(
                  Re.__assign(
                    Re.__assign({}, x.sessionContext),
                    { loading: !1, invalidClaims: [] }
                  )
                ), [
                  2
                  /*return*/
                ];
              case 12:
                return l(
                  Re.__assign(
                    Re.__assign({}, x.sessionContext),
                    { loading: !1, invalidClaims: [] }
                  )
                ), n.onSessionExpired !== void 0 ? n.onSessionExpired() : n.requireAuth !== !1 && n.doRedirection !== !1 && p(), [
                  2
                  /*return*/
                ];
              case 13:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }
      if (c.current === void 0 && (c.current = br.Session.getInstanceOrThrow()), i.loading === !1)
        return c.current.addEventListener(y);
    },
    [n, l, i.loading, f, d, p]
  ), n.requireAuth !== !1 && (i.loading || !i.doesSessionExist) ? null : !i.loading && i.accessDeniedValidatorError && n.accessDeniedScreen ? st.jsx(n.accessDeniedScreen, {
    userContext: f,
    navigate: d,
    validationError: i.accessDeniedValidatorError
  }) : st.jsx(
    w2.Provider,
    Re.__assign({ value: i }, { children: r })
  );
}, k2 = function(e) {
  return st.jsx(
    x2,
    Re.__assign(
      { userContext: e.userContext },
      { children: st.jsx(nUe, Re.__assign({}, e)) }
    )
  );
}, w8 = function(e) {
  return st.jsx(
    k2,
    Re.__assign({}, e, { requireAuth: !1, doRedirection: !1 })
  );
}, dv = (
  /** @class */
  function() {
    function e() {
    }
    e.init = function(r) {
      Re.SuperTokens.init(r);
    }, e.changeLanguage = function(r) {
      return Re.SuperTokens.getInstanceOrThrow().changeLanguage(r);
    }, e.loadTranslation = function(r) {
      return Re.SuperTokens.getInstanceOrThrow().loadTranslation(r);
    };
    var t;
    return t = e, e.SuperTokensWrapper = w8, e.redirectToAuth = function(r) {
      return Re.__awaiter(void 0, void 0, void 0, function() {
        var n;
        return Re.__generator(t, function(a) {
          return [
            2,
            Re.SuperTokens.getInstanceOrThrow().redirectToAuth(
              Re.__assign(
                Re.__assign({}, r),
                {
                  redirectBack: (n = r == null ? void 0 : r.redirectBack) !== null && n !== void 0 ? n : !0,
                  userContext: Re.getNormalisedUserContext(
                    r == null ? void 0 : r.userContext
                  )
                }
              )
            )
          ];
        });
      });
    }, e.useTranslation = Jc.useTranslation, e.useUserContext = Kh, e;
  }()
), aUe = dv.init, sUe = dv.changeLanguage, iUe = dv.loadTranslation, x8 = dv.redirectToAuth;
_r.AuthPage = rUe;
_r.AuthPageComponentList = _2;
_r.AuthPageFooter = S2;
_r.AuthPageHeader = E2;
_r.AuthPageTheme = T2;
_r.BackButton = y8;
_r.ComponentOverrideContext = Bx;
_r.DynamicLoginMethodsSpinner = Ux;
_r.FeatureWrapper = V6e;
_r.GeneralError = v8;
_r.Provider = m8;
_r.RecipeRouter = C2;
_r.SessionAuthWrapper = k2;
_r.SessionContext = w2;
_r.SpinnerIcon = c8;
_r.SuperTokensAPIWrapper = dv;
_r.SuperTokensBranding = g8;
_r.SuperTokensWrapper = w8;
_r.UI = qh;
_r.UserContextContext = Vx;
_r.UserContextWrapper = x2;
_r.canHandleRoute = eUe;
_r.changeLanguage = sUe;
_r.defaultTranslationsCommon = f8;
_r.getRoutingComponent = tUe;
_r.getSuperTokensRoutesForReactRouterDom = Z6e;
_r.init = aUe;
_r.loadTranslation = iUe;
_r.redirectToAuth = x8;
_r.useDynamicLoginMethods = U6e;
_r.useSessionContext = h8;
_r.useUserContext = Kh;
_r.withOverride = uv;
Object.defineProperty(zo, "__esModule", { value: !0 });
var wd = _r, oUe = Nx;
zo.SuperTokensWrapper = wd.SuperTokensWrapper;
zo.changeLanguage = wd.changeLanguage;
zo.default = wd.SuperTokensAPIWrapper;
zo.init = wd.init;
zo.loadTranslation = wd.loadTranslation;
zo.redirectToAuth = wd.redirectToAuth;
zo.useUserContext = wd.useUserContext;
zo.useTranslation = oUe.useTranslation;
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(zo);
})(_$);
const lUe = /* @__PURE__ */ wh(_$);
var _8 = {}, bi = {}, O2 = {}, cUe = ba, S8 = cUe.createGenericComponentsOverrideContext(), uUe = S8[0], dUe = S8[1];
O2.Provider = dUe;
O2.useContext = uUe;
var A2 = {}, E8 = {}, Un = {}, fv = {}, $x = {}, Sm = ke && ke.__assign || function() {
  return Sm = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Sm.apply(this, arguments);
};
Object.defineProperty($x, "__esModule", { value: !0 });
$x.normaliseUserInput = void 0;
var fUe = yd;
function hUe(e) {
  var t = Sm(
    {
      functions: function(r) {
        return r;
      }
    },
    e.override
  );
  return Sm(Sm({}, (0, fUe.normaliseAuthRecipe)(e)), { override: t });
}
$x.normaliseUserInput = hUe;
var hv = {}, zb = ke && ke.__assign || function() {
  return zb = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, zb.apply(this, arguments);
}, Fp = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, Bp = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(hv, "__esModule", { value: !0 });
hv.getRecipeImplementation = void 0;
var Si = bd, Z0 = Qc, ey = ur;
function T8(e) {
  var t = new Si.default(e.recipeId, e.appInfo);
  return {
    submitNewPassword: function(r) {
      var n = r.formFields, a = r.options, s = r.userContext;
      return Fp(this, void 0, void 0, function() {
        var i, o, l, c, u;
        return Bp(this, function(d) {
          switch (d.label) {
            case 0:
              return i = this.getTenantIdFromURL({ userContext: s }), o = this.getResetPasswordTokenFromURL({
                userContext: s
              }), [
                4,
                t.post(
                  i,
                  "/user/password/reset",
                  { body: JSON.stringify({ formFields: n, token: o, method: "token" }) },
                  Si.default.preparePreAPIHook({
                    recipePreAPIHook: e.preAPIHook,
                    action: "SUBMIT_NEW_PASSWORD",
                    options: a,
                    userContext: s
                  }),
                  Si.default.preparePostAPIHook({
                    recipePostAPIHook: e.postAPIHook,
                    action: "SUBMIT_NEW_PASSWORD",
                    userContext: s
                  })
                )
              ];
            case 1:
              return l = d.sent(), c = l.jsonBody, u = l.fetchResponse, c.status === "FIELD_ERROR" ? [
                2,
                {
                  status: "FIELD_ERROR",
                  formFields: c.formFields,
                  fetchResponse: u
                }
              ] : c.status === "RESET_PASSWORD_INVALID_TOKEN_ERROR" ? [
                2,
                {
                  status: c.status,
                  fetchResponse: u
                }
              ] : [2, zb(zb({}, c), { fetchResponse: u })];
          }
        });
      });
    },
    sendPasswordResetEmail: function(r) {
      var n = r.formFields, a = r.options, s = r.userContext;
      return Fp(this, void 0, void 0, function() {
        var i, o, l, c, u;
        return Bp(this, function(d) {
          switch (d.label) {
            case 0:
              return u = (c = t).post, [
                4,
                Z0.default.getInstanceOrThrow().recipeImplementation.getTenantId({ userContext: s })
              ];
            case 1:
              return [
                4,
                u.apply(c, [
                  d.sent(),
                  "/user/password/reset/token",
                  { body: JSON.stringify({ formFields: n }) },
                  Si.default.preparePreAPIHook({
                    recipePreAPIHook: e.preAPIHook,
                    action: "SEND_RESET_PASSWORD_EMAIL",
                    options: a,
                    userContext: s
                  }),
                  Si.default.preparePostAPIHook({
                    recipePostAPIHook: e.postAPIHook,
                    action: "SEND_RESET_PASSWORD_EMAIL",
                    userContext: s
                  })
                ])
              ];
            case 2:
              return i = d.sent(), o = i.jsonBody, l = i.fetchResponse, o.status === "FIELD_ERROR" ? [
                2,
                {
                  status: "FIELD_ERROR",
                  formFields: o.formFields,
                  fetchResponse: l
                }
              ] : o.status === "PASSWORD_RESET_NOT_ALLOWED" ? [
                2,
                {
                  status: o.status,
                  reason: o.reason,
                  fetchResponse: l
                }
              ] : [
                2,
                {
                  status: o.status,
                  fetchResponse: l
                }
              ];
          }
        });
      });
    },
    signUp: function(r) {
      var n = r.formFields, a = r.shouldTryLinkingWithSessionUser, s = r.options, i = r.userContext;
      return Fp(this, void 0, void 0, function() {
        var o, l, c, u, d;
        return Bp(this, function(f) {
          switch (f.label) {
            case 0:
              return d = (u = t).post, [
                4,
                Z0.default.getInstanceOrThrow().recipeImplementation.getTenantId({ userContext: i })
              ];
            case 1:
              return [
                4,
                d.apply(u, [
                  f.sent(),
                  "/signup",
                  {
                    body: JSON.stringify({
                      formFields: n,
                      shouldTryLinkingWithSessionUser: a
                    })
                  },
                  Si.default.preparePreAPIHook({
                    recipePreAPIHook: e.preAPIHook,
                    action: "EMAIL_PASSWORD_SIGN_UP",
                    options: s,
                    userContext: i
                  }),
                  Si.default.preparePostAPIHook({
                    recipePostAPIHook: e.postAPIHook,
                    action: "EMAIL_PASSWORD_SIGN_UP",
                    userContext: i
                  })
                ])
              ];
            case 2:
              return o = f.sent(), l = o.jsonBody, c = o.fetchResponse, l.status === "FIELD_ERROR" ? [
                2,
                {
                  status: "FIELD_ERROR",
                  formFields: l.formFields,
                  fetchResponse: c
                }
              ] : l.status === "SIGN_UP_NOT_ALLOWED" ? [
                2,
                {
                  status: "SIGN_UP_NOT_ALLOWED",
                  reason: l.reason,
                  fetchResponse: c
                }
              ] : [
                2,
                {
                  status: l.status,
                  user: (0, ey.normaliseUser)("emailpassword", l.user),
                  fetchResponse: c
                }
              ];
          }
        });
      });
    },
    signIn: function(r) {
      var n = r.formFields, a = r.shouldTryLinkingWithSessionUser, s = r.options, i = r.userContext;
      return Fp(this, void 0, void 0, function() {
        var o, l, c, u, d;
        return Bp(this, function(f) {
          switch (f.label) {
            case 0:
              return d = (u = t).post, [
                4,
                Z0.default.getInstanceOrThrow().recipeImplementation.getTenantId({ userContext: i })
              ];
            case 1:
              return [
                4,
                d.apply(u, [
                  f.sent(),
                  "/signin",
                  {
                    body: JSON.stringify({
                      formFields: n,
                      shouldTryLinkingWithSessionUser: a
                    })
                  },
                  Si.default.preparePreAPIHook({
                    recipePreAPIHook: e.preAPIHook,
                    action: "EMAIL_PASSWORD_SIGN_IN",
                    options: s,
                    userContext: i
                  }),
                  Si.default.preparePostAPIHook({
                    recipePostAPIHook: e.postAPIHook,
                    action: "EMAIL_PASSWORD_SIGN_IN",
                    userContext: i
                  })
                ])
              ];
            case 2:
              return o = f.sent(), l = o.jsonBody, c = o.fetchResponse, l.status === "FIELD_ERROR" ? [
                2,
                {
                  status: "FIELD_ERROR",
                  formFields: l.formFields,
                  fetchResponse: c
                }
              ] : l.status === "WRONG_CREDENTIALS_ERROR" ? [
                2,
                {
                  status: "WRONG_CREDENTIALS_ERROR",
                  fetchResponse: c
                }
              ] : l.status === "SIGN_IN_NOT_ALLOWED" ? [
                2,
                {
                  status: "SIGN_IN_NOT_ALLOWED",
                  reason: l.reason,
                  fetchResponse: c
                }
              ] : [
                2,
                {
                  status: "OK",
                  user: (0, ey.normaliseUser)("emailpassword", l.user),
                  fetchResponse: c
                }
              ];
          }
        });
      });
    },
    doesEmailExist: function(r) {
      var n = r.email, a = r.options, s = r.userContext;
      return Fp(this, void 0, void 0, function() {
        var i, o, l, c, u;
        return Bp(this, function(d) {
          switch (d.label) {
            case 0:
              return u = (c = t).get, [
                4,
                Z0.default.getInstanceOrThrow().recipeImplementation.getTenantId({ userContext: s })
              ];
            case 1:
              return [
                4,
                u.apply(c, [
                  d.sent(),
                  "/emailpassword/email/exists",
                  {},
                  { email: n },
                  Si.default.preparePreAPIHook({
                    recipePreAPIHook: e.preAPIHook,
                    action: "EMAIL_EXISTS",
                    options: a,
                    userContext: s
                  }),
                  Si.default.preparePostAPIHook({
                    recipePostAPIHook: e.postAPIHook,
                    action: "EMAIL_EXISTS",
                    userContext: s
                  })
                ])
              ];
            case 2:
              return i = d.sent(), o = i.jsonBody, l = i.fetchResponse, [
                2,
                {
                  status: o.status,
                  doesExist: o.exists,
                  fetchResponse: l
                }
              ];
          }
        });
      });
    },
    getResetPasswordTokenFromURL: function() {
      var r = (0, ey.getQueryParams)("token");
      return r === void 0 ? "" : r;
    },
    getTenantIdFromURL: function() {
      return (0, ey.getQueryParams)("tenantId");
    }
  };
}
hv.default = T8;
hv.getRecipeImplementation = T8;
var pUe = ke && ke.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Kb = ke && ke.__assign || function() {
  return Kb = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Kb.apply(this, arguments);
};
Object.defineProperty(fv, "__esModule", { value: !0 });
fv.Recipe = void 0;
var mUe = $x, gUe = hv, vUe = qo, sj = ur, yUe = Hh, C8 = (
  /** @class */
  function(e) {
    pUe(t, e);
    function t(r) {
      var n = e.call(this, (0, mUe.normaliseUserInput)(r)) || this, a = new vUe.default(
        (0, gUe.default)({
          recipeId: n.config.recipeId,
          appInfo: n.config.appInfo,
          clientType: n.config.clientType,
          preAPIHook: n.config.preAPIHook,
          postAPIHook: n.config.postAPIHook
        })
      );
      return n.recipeImplementation = a.override(n.config.override.functions).build(), n;
    }
    return t.init = function(r) {
      return function(n, a) {
        return t.instance = new t(
          Kb(Kb({}, r), { recipeId: t.RECIPE_ID, clientType: a, appInfo: n })
        ), t.instance;
      };
    }, t.getInstanceOrThrow = function() {
      if (t.instance === void 0) {
        var r = "No instance of EmailPassword found. Ensure that the 'EmailPassword.init' method is called within the 'SuperTokens.init' recipeList.";
        throw r = (0, sj.checkForSSRErrorAndAppendIfNeeded)(r), Error(r);
      }
      return t.instance;
    }, t.reset = function() {
      (0, sj.isTest)() && (t.instance = void 0);
    }, t.RECIPE_ID = "emailpassword", t;
  }(yUe.default)
);
fv.Recipe = C8;
fv.default = C8;
var Fa = ke && ke.__assign || function() {
  return Fa = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Fa.apply(this, arguments);
};
Object.defineProperty(Un, "__esModule", { value: !0 });
Un.signOut = Un.getTenantIdFromURL = Un.getResetPasswordTokenFromURL = Un.doesEmailExist = Un.signIn = Un.signUp = Un.sendPasswordResetEmail = Un.submitNewPassword = Un.init = void 0;
var cl = fv, nc = ur, Go = (
  /** @class */
  function() {
    function e() {
    }
    return e.init = function(t) {
      return cl.default.init(t);
    }, e.signOut = function(t) {
      return cl.default.getInstanceOrThrow().signOut({
        userContext: (0, nc.getNormalisedUserContext)(
          t == null ? void 0 : t.userContext
        )
      });
    }, e.submitNewPassword = function(t) {
      return cl.default.getInstanceOrThrow().recipeImplementation.submitNewPassword(
        Fa(Fa({}, t), { userContext: (0, nc.getNormalisedUserContext)(t.userContext) })
      );
    }, e.sendPasswordResetEmail = function(t) {
      return cl.default.getInstanceOrThrow().recipeImplementation.sendPasswordResetEmail(
        Fa(Fa({}, t), { userContext: (0, nc.getNormalisedUserContext)(t.userContext) })
      );
    }, e.signUp = function(t) {
      return cl.default.getInstanceOrThrow().recipeImplementation.signUp(
        Fa(Fa({}, t), {
          shouldTryLinkingWithSessionUser: t == null ? void 0 : t.shouldTryLinkingWithSessionUser,
          userContext: (0, nc.getNormalisedUserContext)(t.userContext)
        })
      );
    }, e.signIn = function(t) {
      return cl.default.getInstanceOrThrow().recipeImplementation.signIn(
        Fa(Fa({}, t), {
          shouldTryLinkingWithSessionUser: t == null ? void 0 : t.shouldTryLinkingWithSessionUser,
          userContext: (0, nc.getNormalisedUserContext)(t.userContext)
        })
      );
    }, e.doesEmailExist = function(t) {
      return cl.default.getInstanceOrThrow().recipeImplementation.doesEmailExist(
        Fa(Fa({}, t), { userContext: (0, nc.getNormalisedUserContext)(t.userContext) })
      );
    }, e.getResetPasswordTokenFromURL = function(t) {
      return cl.default.getInstanceOrThrow().recipeImplementation.getResetPasswordTokenFromURL(
        Fa(Fa({}, t), {
          userContext: (0, nc.getNormalisedUserContext)(
            t == null ? void 0 : t.userContext
          )
        })
      );
    }, e.getTenantIdFromURL = function(t) {
      return cl.default.getInstanceOrThrow().recipeImplementation.getTenantIdFromURL(
        Fa(Fa({}, t), {
          userContext: (0, nc.getNormalisedUserContext)(
            t == null ? void 0 : t.userContext
          )
        })
      );
    }, e;
  }()
);
Un.default = Go;
var bUe = Go.init;
Un.init = bUe;
var wUe = Go.submitNewPassword;
Un.submitNewPassword = wUe;
var xUe = Go.sendPasswordResetEmail;
Un.sendPasswordResetEmail = xUe;
var _Ue = Go.signUp;
Un.signUp = _Ue;
var SUe = Go.signIn;
Un.signIn = SUe;
var EUe = Go.doesEmailExist;
Un.doesEmailExist = EUe;
var TUe = Go.signOut;
Un.signOut = TUe;
var CUe = Go.getResetPasswordTokenFromURL;
Un.getResetPasswordTokenFromURL = CUe;
var kUe = Go.getTenantIdFromURL;
Un.getTenantIdFromURL = kUe;
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(Un);
})(E8);
var k8 = {}, ul = ba, OUe = zh, ij = ql, AUe = (
  /** @class */
  function(e) {
    ul.__extends(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.getAuthRecipeDefaultRedirectionURL = function(n) {
        return ul.__awaiter(r, void 0, void 0, function() {
          return ul.__generator(this, function(a) {
            throw new Error("Should never come here");
          });
        });
      }, r.signOut = function(n) {
        return ul.__awaiter(r, void 0, void 0, function() {
          return ul.__generator(this, function(a) {
            switch (a.label) {
              case 0:
                return [
                  4,
                  ij.Session.getInstanceOrThrow().signOut({
                    userContext: ul.getNormalisedUserContext(
                      n == null ? void 0 : n.userContext
                    )
                  })
                ];
              case 1:
                return [2, a.sent()];
            }
          });
        });
      }, r.doesSessionExist = function(n) {
        return ul.__awaiter(r, void 0, void 0, function() {
          return ul.__generator(this, function(a) {
            switch (a.label) {
              case 0:
                return [
                  4,
                  ij.Session.getInstanceOrThrow().doesSessionExist({
                    userContext: ul.getNormalisedUserContext(
                      n == null ? void 0 : n.userContext
                    )
                  })
                ];
              case 1:
                return [2, a.sent()];
            }
          });
        });
      }, r;
    }
    return t;
  }(OUe.RecipeModule)
);
k8.AuthRecipe = AUe;
var P2 = {}, PUe = ["email", "password"], RUe = "/reset-password";
P2.DEFAULT_RESET_PASSWORD_PATH = RUe;
P2.MANDATORY_FORM_FIELDS_ID_ARRAY = PUe;
var Wt = ba, IUe = E8, DUe = k8, sm = ql, R2 = P2, NUe = Fx;
function MUe(e) {
  return e && e.__esModule ? e : { default: e };
}
var oj = /* @__PURE__ */ MUe(IUe), LUe = function(e) {
  return function(t) {
    return Wt.__assign(Wt.__assign({}, t), {
      submitNewPassword: function(r) {
        return Wt.__awaiter(this, void 0, void 0, function() {
          var n;
          return Wt.__generator(this, function(a) {
            switch (a.label) {
              case 0:
                return [
                  4,
                  t.submitNewPassword(
                    Wt.__assign(
                      Wt.__assign({}, r),
                      { formFields: [r.formFields[0]] }
                    )
                  )
                ];
              case 1:
                return n = a.sent(), n.status === "OK" && e({
                  action: "PASSWORD_RESET_SUCCESSFUL",
                  userContext: r.userContext
                }), [2, n];
            }
          });
        });
      },
      sendPasswordResetEmail: function(r) {
        return Wt.__awaiter(this, void 0, void 0, function() {
          var n;
          return Wt.__generator(this, function(a) {
            switch (a.label) {
              case 0:
                return [4, t.sendPasswordResetEmail(r)];
              case 1:
                return n = a.sent(), n.status === "OK" && e({
                  action: "RESET_PASSWORD_EMAIL_SENT",
                  email: r.formFields.find(function(s) {
                    var i = s.id;
                    return i === "email";
                  }).value,
                  userContext: r.userContext
                }), [2, n];
            }
          });
        });
      },
      signUp: function(r) {
        return Wt.__awaiter(this, void 0, void 0, function() {
          var n, a, s;
          return Wt.__generator(this, function(i) {
            switch (i.label) {
              case 0:
                return i.trys.push([0, 2, , 3]), [
                  4,
                  sm.Session.getInstanceOrThrow().getAccessTokenPayloadSecurely({
                    userContext: r.userContext
                  })
                ];
              case 1:
                return n = i.sent(), [3, 3];
              case 2:
                return i.sent(), n = void 0, [3, 3];
              case 3:
                return [4, t.signUp(r)];
              case 4:
                if (a = i.sent(), a.status !== "OK") return [3, 9];
                s = void 0, i.label = 5;
              case 5:
                return i.trys.push([5, 7, , 8]), [
                  4,
                  sm.Session.getInstanceOrThrow().getAccessTokenPayloadSecurely({
                    userContext: r.userContext
                  })
                ];
              case 6:
                return s = i.sent(), [3, 8];
              case 7:
                return i.sent(), s = void 0, [3, 8];
              case 8:
                e({
                  action: "SUCCESS",
                  isNewRecipeUser: !0,
                  createdNewSession: s !== void 0 && (n === void 0 || n.sessionHandle !== s.sessionHandle),
                  user: a.user,
                  userContext: r.userContext
                }), i.label = 9;
              case 9:
                return [2, a];
            }
          });
        });
      },
      signIn: function(r) {
        return Wt.__awaiter(this, void 0, void 0, function() {
          var n, a, s;
          return Wt.__generator(this, function(i) {
            switch (i.label) {
              case 0:
                return i.trys.push([0, 2, , 3]), [
                  4,
                  sm.Session.getInstanceOrThrow().getAccessTokenPayloadSecurely({
                    userContext: r.userContext
                  })
                ];
              case 1:
                return n = i.sent(), [3, 3];
              case 2:
                return i.sent(), n = void 0, [3, 3];
              case 3:
                return [4, t.signIn(r)];
              case 4:
                if (a = i.sent(), a.status !== "OK") return [3, 9];
                s = void 0, i.label = 5;
              case 5:
                return i.trys.push([5, 7, , 8]), [
                  4,
                  sm.Session.getInstanceOrThrow().getAccessTokenPayloadSecurely({
                    userContext: r.userContext
                  })
                ];
              case 6:
                return s = i.sent(), [3, 8];
              case 7:
                return i.sent(), s = void 0, [3, 8];
              case 8:
                e({
                  action: "SUCCESS",
                  isNewRecipeUser: !1,
                  createdNewSession: s !== void 0 && (n === void 0 || n.sessionHandle !== s.sessionHandle),
                  user: a.user,
                  userContext: r.userContext
                }), i.label = 9;
              case 9:
                return [2, a];
            }
          });
        });
      }
    });
  };
};
function jUe(e) {
  return Wt.__awaiter(this, void 0, void 0, function() {
    var t;
    return Wt.__generator(this, function(r) {
      return typeof e != "string" ? [2, "ERROR_EMAIL_NON_STRING"] : (e = e.trim(), t = // eslint-disable-next-line no-useless-escape
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, e.match(t) === null ? [2, "ERROR_EMAIL_INVALID"] : [2, void 0]);
    });
  });
}
function FUe(e) {
  return Wt.__awaiter(this, void 0, void 0, function() {
    return Wt.__generator(this, function(t) {
      return typeof e != "string" ? [2, "ERROR_PASSWORD_NON_STRING"] : e.length < 8 ? [2, "ERROR_PASSWORD_TOO_SHORT"] : e.length >= 100 ? [2, "ERROR_PASSWORD_TOO_LONG"] : e.match(/^.*[A-Za-z]+.*$/) === null ? [2, "ERROR_PASSWORD_NO_ALPHA"] : e.match(/^.*[0-9]+.*$/) === null ? [2, "ERROR_PASSWORD_NO_NUM"] : [2, void 0];
    });
  });
}
function BUe(e) {
  return Wt.__awaiter(this, void 0, void 0, function() {
    return Wt.__generator(this, function(t) {
      return typeof e != "string" ? [2, "ERROR_PASSWORD_NON_STRING"] : [2, void 0];
    });
  });
}
function O8(e) {
  return Wt.__awaiter(this, void 0, void 0, function() {
    return Wt.__generator(this, function(t) {
      return [2, void 0];
    });
  });
}
function UUe(e) {
  e === void 0 && (e = {});
  var t = VUe(e.signInAndUpFeature), r = t.signUpForm.formFields.find(function(i) {
    return i.id === "password";
  }), n = t.signUpForm.formFields.find(function(i) {
    return i.id === "email";
  }), a = KUe(
    r.validate,
    n,
    e.resetPasswordUsingTokenFeature
  ), s = Wt.__assign(
    {
      functions: function(i) {
        return i;
      }
    },
    e.override
  );
  return Wt.__assign(
    Wt.__assign({}, NUe.normaliseAuthRecipe(e)),
    {
      signInAndUpFeature: t,
      resetPasswordUsingTokenFeature: a,
      override: s
    }
  );
}
function VUe(e) {
  e === void 0 && (e = {});
  var t = $Ue(e.signUpForm), r = t.formFields.reduce(function(a, s) {
    return s.id === "email" ? Wt.__spreadArray(
      Wt.__spreadArray([], a, !0),
      [s],
      !1
    ) : s.id === "password" ? Wt.__spreadArray(
      Wt.__spreadArray([], a, !0),
      [
        Wt.__assign(Wt.__assign({}, s), {
          autoComplete: "current-password",
          validate: BUe
        })
      ],
      !1
    ) : a;
  }, []), n = HUe(r, e.signInForm);
  return {
    signUpForm: t,
    signInForm: n
  };
}
function $Ue(e) {
  e === void 0 && (e = {});
  var t = WUe(), r = [];
  e.formFields !== void 0 && (r = e.formFields);
  var n = P8(t, r), a = e.style !== void 0 ? e.style : "";
  return {
    style: a,
    formFields: n
  };
}
function HUe(e, t) {
  t === void 0 && (t = {});
  var r = [];
  t.formFields !== void 0 && (r = t.formFields.filter(function(s) {
    return R2.MANDATORY_FORM_FIELDS_ID_ARRAY.includes(s.id);
  }).map(function(s) {
    return Wt.__assign(Wt.__assign({}, s), {
      optional: !1
    });
  }));
  var n = P8(e, r), a = t.style !== void 0 ? t.style : "";
  return {
    style: a,
    formFields: n
  };
}
function WUe() {
  return [A8(), zUe()];
}
function A8() {
  return {
    id: "email",
    label: "EMAIL_PASSWORD_EMAIL_LABEL",
    placeholder: "EMAIL_PASSWORD_EMAIL_PLACEHOLDER",
    validate: jUe,
    optional: !1,
    autoComplete: "email"
  };
}
function zUe() {
  return {
    id: "password",
    label: "EMAIL_PASSWORD_PASSWORD_LABEL",
    placeholder: "EMAIL_PASSWORD_PASSWORD_PLACEHOLDER",
    validate: FUe,
    optional: !1,
    autoComplete: "new-password"
  };
}
function KUe(e, t, r) {
  r === void 0 && (r = {});
  var n = r.disableDefaultUI === !0, a = r.submitNewPasswordForm !== void 0 && r.submitNewPasswordForm.style !== void 0 ? r.submitNewPasswordForm.style : "", s = {
    style: a,
    formFields: [
      {
        id: "password",
        label: "EMAIL_PASSWORD_NEW_PASSWORD_LABEL",
        placeholder: "EMAIL_PASSWORD_NEW_PASSWORD_PLACEHOLDER",
        validate: e,
        optional: !1,
        autoComplete: "new-password"
      },
      {
        id: "confirm-password",
        label: "EMAIL_PASSWORD_CONFIRM_PASSWORD_LABEL",
        placeholder: "EMAIL_PASSWORD_CONFIRM_PASSWORD_PLACEHOLDER",
        validate: e,
        optional: !1,
        autoComplete: "new-password"
      }
    ]
  }, i = r.enterEmailForm !== void 0 && r.enterEmailForm.style !== void 0 ? r.enterEmailForm.style : "", o = {
    style: i,
    formFields: [
      Wt.__assign(
        Wt.__assign({}, A8()),
        { validate: t.validate, placeholder: "", autofocus: !0 }
      )
    ]
  };
  return {
    disableDefaultUI: n,
    submitNewPasswordForm: s,
    enterEmailForm: o
  };
}
function P8(e, t) {
  for (var r = e, n = 0; n < t.length; n++) {
    for (var a = t[n], s = !0, i = 0; i < r.length; i++) {
      var o = r[i];
      if (a.id === o.id) {
        var l = o.optional;
        a.optional !== void 0 && (l = a.optional), R2.MANDATORY_FORM_FIELDS_ID_ARRAY.includes(a.id) && (l = !1), r[i] = Wt.__assign(
          Wt.__assign(
            Wt.__assign({}, r[i]),
            a
          ),
          { optional: l }
        ), s = !1;
        break;
      }
    }
    s && r.push(
      Wt.__assign(
        { optional: !1, placeholder: a.label, validate: O8 },
        a
      )
    );
  }
  return r.map(function(c) {
    return qUe(c);
  });
}
function qUe(e) {
  var t = this;
  if (e.optional === !1 && e.nonOptionalErrorMsg === "")
    throw new Error("nonOptionalErrorMsg for field ".concat(e.id, " cannot be an empty string"));
  return Wt.__assign(Wt.__assign({}, e), {
    validate: function(r) {
      return Wt.__awaiter(t, void 0, void 0, function() {
        return Wt.__generator(this, function(n) {
          switch (n.label) {
            case 0:
              return r === "" && e.optional === !1 ? e.nonOptionalErrorMsg !== void 0 ? [2, e.nonOptionalErrorMsg] : [2, "ERROR_NON_OPTIONAL"] : [4, e.validate(r)];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }
  });
}
var GUe = (
  /** @class */
  function(e) {
    Wt.__extends(t, e);
    function t(r, n) {
      n === void 0 && (n = oj.default);
      var a = e.call(this, r) || this;
      return a.webJSRecipe = n, a.recipeID = t.RECIPE_ID, a.firstFactorIds = [sm.FactorIds.EMAILPASSWORD], a.getDefaultRedirectionURL = function(s) {
        return Wt.__awaiter(a, void 0, void 0, function() {
          return Wt.__generator(this, function(i) {
            return s.action === "RESET_PASSWORD" ? [
              2,
              Wt.getDefaultRedirectionURLForPath(
                this.config,
                R2.DEFAULT_RESET_PASSWORD_PATH,
                s
              )
            ] : [2, this.getAuthRecipeDefaultRedirectionURL(s)];
          });
        });
      }, a;
    }
    return t.prototype.getFirstFactorsForAuthPage = function() {
      return this.firstFactorIds;
    }, t.init = function(r) {
      var n = UUe(r);
      return {
        recipeID: t.RECIPE_ID,
        authReact: function(a) {
          return t.instance = new t(
            Wt.__assign(
              Wt.__assign({}, n),
              { appInfo: a, recipeId: t.RECIPE_ID }
            )
          ), t.instance;
        },
        webJS: oj.default.init(
          Wt.__assign(
            Wt.__assign({}, n),
            {
              override: {
                functions: function(a, s) {
                  var i = LUe(n.onHandleEvent);
                  return s.override(i), s.override(n.override.functions), a;
                }
              }
            }
          )
        )
      };
    }, t.getInstanceOrThrow = function() {
      if (t.instance === void 0) {
        var r = "No instance of EmailPassword found. Make sure to call the EmailPassword.init method.See https://supertokens.io/docs/emailpassword/quick-setup/frontend";
        throw typeof window > "u" && (r = r + Wt.SSR_ERROR), Error(r);
      }
      return t.instance;
    }, t.reset = function() {
      Wt.isTest() && (t.instance = void 0);
    }, t.RECIPE_ID = "emailpassword", t;
  }(DUe.AuthRecipe)
);
A2.EmailPassword = GUe;
A2.defaultValidate = O8;
Object.defineProperty(bi, "__esModule", { value: !0 });
var Dr = ba, YUe = O2, ac = A2, Yo = (
  /** @class */
  function() {
    function e() {
    }
    return e.init = function(t) {
      return ac.EmailPassword.init(t);
    }, e.signOut = function(t) {
      return Dr.__awaiter(this, void 0, void 0, function() {
        return Dr.__generator(this, function(r) {
          return [
            2,
            ac.EmailPassword.getInstanceOrThrow().signOut({
              userContext: Dr.getNormalisedUserContext(
                t == null ? void 0 : t.userContext
              )
            })
          ];
        });
      });
    }, e.submitNewPassword = function(t) {
      return Dr.__awaiter(this, void 0, void 0, function() {
        return Dr.__generator(this, function(r) {
          return [
            2,
            ac.EmailPassword.getInstanceOrThrow().webJSRecipe.submitNewPassword(
              Dr.__assign(Dr.__assign({}, t), {
                userContext: Dr.getNormalisedUserContext(t.userContext)
              })
            )
          ];
        });
      });
    }, e.sendPasswordResetEmail = function(t) {
      return Dr.__awaiter(this, void 0, void 0, function() {
        return Dr.__generator(this, function(r) {
          return [
            2,
            ac.EmailPassword.getInstanceOrThrow().webJSRecipe.sendPasswordResetEmail(
              Dr.__assign(Dr.__assign({}, t), {
                userContext: Dr.getNormalisedUserContext(t.userContext)
              })
            )
          ];
        });
      });
    }, e.signUp = function(t) {
      return Dr.__awaiter(this, void 0, void 0, function() {
        return Dr.__generator(this, function(r) {
          return [
            2,
            ac.EmailPassword.getInstanceOrThrow().webJSRecipe.signUp(
              Dr.__assign(Dr.__assign({}, t), {
                userContext: Dr.getNormalisedUserContext(t.userContext)
              })
            )
          ];
        });
      });
    }, e.signIn = function(t) {
      return Dr.__awaiter(this, void 0, void 0, function() {
        return Dr.__generator(this, function(r) {
          return [
            2,
            ac.EmailPassword.getInstanceOrThrow().webJSRecipe.signIn(
              Dr.__assign(Dr.__assign({}, t), {
                userContext: Dr.getNormalisedUserContext(t.userContext)
              })
            )
          ];
        });
      });
    }, e.doesEmailExist = function(t) {
      return Dr.__awaiter(this, void 0, void 0, function() {
        return Dr.__generator(this, function(r) {
          return [
            2,
            ac.EmailPassword.getInstanceOrThrow().webJSRecipe.doesEmailExist(
              Dr.__assign(Dr.__assign({}, t), {
                userContext: Dr.getNormalisedUserContext(t.userContext)
              })
            )
          ];
        });
      });
    }, e.getResetPasswordTokenFromURL = function(t) {
      return ac.EmailPassword.getInstanceOrThrow().webJSRecipe.getResetPasswordTokenFromURL(
        Dr.__assign(Dr.__assign({}, t), {
          userContext: Dr.getNormalisedUserContext(
            t == null ? void 0 : t.userContext
          )
        })
      );
    }, e.ComponentsOverrideProvider = YUe.Provider, e;
  }()
), XUe = Yo.init, QUe = Yo.signOut, JUe = Yo.submitNewPassword, ZUe = Yo.sendPasswordResetEmail, eVe = Yo.signUp, tVe = Yo.signIn, rVe = Yo.doesEmailExist, nVe = Yo.getResetPasswordTokenFromURL, aVe = Yo.ComponentsOverrideProvider;
bi.EmailPasswordComponentsOverrideProvider = aVe;
bi.default = Yo;
bi.doesEmailExist = rVe;
bi.getResetPasswordTokenFromURL = nVe;
bi.init = XUe;
bi.sendPasswordResetEmail = ZUe;
bi.signIn = tVe;
bi.signOut = QUe;
bi.signUp = eVe;
bi.submitNewPassword = JUe;
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(bi);
})(_8);
const Up = /* @__PURE__ */ wh(_8);
var R8 = {}, Xo = {}, pv = {}, I8 = {}, D8 = {}, mv = {}, Hx = {}, Em = ke && ke.__assign || function() {
  return Em = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Em.apply(this, arguments);
};
Object.defineProperty(Hx, "__esModule", { value: !0 });
Hx.normaliseUserInput = void 0;
var sVe = Zg;
function iVe(e) {
  var t = Em(
    {
      functions: function(r) {
        return r;
      }
    },
    e.override
  );
  return Em(Em({}, (0, sVe.normaliseRecipeModuleConfig)(e)), { override: t });
}
Hx.normaliseUserInput = iVe;
var gv = {}, bS = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, wS = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(gv, "__esModule", { value: !0 });
gv.getRecipeImplementation = void 0;
var uu = bd, lj = ur;
function N8(e) {
  var t = new uu.default(e.recipeId, e.appInfo);
  return {
    verifyEmail: function(r) {
      var n = r.options, a = r.userContext;
      return bS(this, void 0, void 0, function() {
        var s, i, o, l, c;
        return wS(this, function(u) {
          switch (u.label) {
            case 0:
              return s = this.getEmailVerificationTokenFromURL({
                userContext: a
              }), i = this.getTenantIdFromURL({
                userContext: a
              }), [
                4,
                t.post(
                  i,
                  "/user/email/verify",
                  {
                    body: JSON.stringify({
                      method: "token",
                      token: s
                    })
                  },
                  uu.default.preparePreAPIHook({
                    recipePreAPIHook: e.preAPIHook,
                    action: "VERIFY_EMAIL",
                    options: n,
                    userContext: a
                  }),
                  uu.default.preparePostAPIHook({
                    recipePostAPIHook: e.postAPIHook,
                    userContext: a,
                    action: "VERIFY_EMAIL"
                  })
                )
              ];
            case 1:
              return o = u.sent(), l = o.jsonBody, c = o.fetchResponse, [
                2,
                {
                  status: l.status,
                  fetchResponse: c
                }
              ];
          }
        });
      });
    },
    isEmailVerified: function(r) {
      var n = r.options, a = r.userContext;
      return bS(this, void 0, void 0, function() {
        var s, i, o;
        return wS(this, function(l) {
          switch (l.label) {
            case 0:
              return [
                4,
                t.get(
                  void 0,
                  "/user/email/verify",
                  {},
                  void 0,
                  uu.default.preparePreAPIHook({
                    recipePreAPIHook: e.preAPIHook,
                    action: "IS_EMAIL_VERIFIED",
                    options: n,
                    userContext: a
                  }),
                  uu.default.preparePostAPIHook({
                    recipePostAPIHook: e.postAPIHook,
                    userContext: a,
                    action: "IS_EMAIL_VERIFIED"
                  })
                )
              ];
            case 1:
              return s = l.sent(), i = s.jsonBody, o = s.fetchResponse, [
                2,
                {
                  status: "OK",
                  isVerified: i.isVerified,
                  fetchResponse: o
                }
              ];
          }
        });
      });
    },
    sendVerificationEmail: function(r) {
      var n = r.options, a = r.userContext;
      return bS(this, void 0, void 0, function() {
        var s, i, o;
        return wS(this, function(l) {
          switch (l.label) {
            case 0:
              return [
                4,
                t.post(
                  void 0,
                  "/user/email/verify/token",
                  { body: JSON.stringify({}) },
                  uu.default.preparePreAPIHook({
                    recipePreAPIHook: e.preAPIHook,
                    action: "SEND_VERIFY_EMAIL",
                    options: n,
                    userContext: a
                  }),
                  uu.default.preparePostAPIHook({
                    recipePostAPIHook: e.postAPIHook,
                    userContext: a,
                    action: "SEND_VERIFY_EMAIL"
                  })
                )
              ];
            case 1:
              return s = l.sent(), i = s.jsonBody, o = s.fetchResponse, [
                2,
                {
                  status: i.status,
                  fetchResponse: o
                }
              ];
          }
        });
      });
    },
    getEmailVerificationTokenFromURL: function() {
      var r = (0, lj.getQueryParams)("token");
      return r === void 0 ? "" : r;
    },
    getTenantIdFromURL: function() {
      return (0, lj.getQueryParams)("tenantId");
    }
  };
}
gv.default = N8;
gv.getRecipeImplementation = N8;
var vv = {}, oVe = ke && ke.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), qb = ke && ke.__assign || function() {
  return qb = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, qb.apply(this, arguments);
}, cj = ke && ke.__awaiter || function(e, t, r, n) {
  function a(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, l);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, uj = ke && ke.__generator || function(e, t) {
  var r = {
    label: 0,
    sent: function() {
      if (s[0] & 1) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  }, n, a, s, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done)
          return s;
        switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = c;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(c);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        n = s = 0;
      }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
};
Object.defineProperty(vv, "__esModule", { value: !0 });
vv.EmailVerificationClaimClass = void 0;
var M8 = u2, lVe = Ix, cVe = rv;
function uVe(e) {
  return Math.max(
    e,
    M8.DateProviderReference.getReferenceOrThrow().dateProvider.getThresholdInSeconds()
  );
}
var dVe = (
  /** @class */
  function(e) {
    oVe(t, e);
    function t(r) {
      var n = e.call(this, {
        id: cVe.EMAILVERIFICATION_CLAIM_ID,
        refresh: function(a) {
          return cj(n, void 0, void 0, function() {
            return uj(this, function(s) {
              switch (s.label) {
                case 0:
                  return [
                    4,
                    r().isEmailVerified({
                      userContext: a
                    })
                  ];
                case 1:
                  return s.sent(), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }
      }) || this;
      return n.validators = qb(qb({}, n.validators), {
        isVerified: function(a, s) {
          return {
            id: n.id,
            refresh: n.refresh,
            shouldRefresh: function(i, o) {
              var l = M8.DateProviderReference.getReferenceOrThrow().dateProvider;
              if (a = a ?? uVe(10), s !== void 0 && s < l.getThresholdInSeconds())
                throw new Error(
                  "maxAgeInSeconds must be greater than or equal to the DateProvider threshold value -> ".concat(
                    l.getThresholdInSeconds()
                  )
                );
              if (a < l.getThresholdInSeconds())
                throw new Error(
                  "refetchTimeOnFalseInSeconds must be greater than or equal to the DateProvider threshold value -> ".concat(
                    l.getThresholdInSeconds()
                  )
                );
              var c = n.getValueFromPayload(i, o);
              if (c === void 0)
                return !0;
              var u = l.now(), d = n.getLastFetchedTime(i, o);
              return s !== void 0 && d < u - s * 1e3 || c === !1 && d < u - a * 1e3;
            },
            validate: function(i, o) {
              return cj(n, void 0, void 0, function() {
                var l;
                return uj(this, function(c) {
                  return l = this.getValueFromPayload(i, o), [
                    2,
                    l === !0 ? { isValid: !0 } : {
                      isValid: !1,
                      reason: {
                        message: "wrong value",
                        expectedValue: !0,
                        actualValue: l
                      }
                    }
                  ];
                });
              });
            }
          };
        }
      }), n;
    }
    return t;
  }(lVe.BooleanClaim)
);
vv.EmailVerificationClaimClass = dVe;
var Gb = ke && ke.__assign || function() {
  return Gb = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Gb.apply(this, arguments);
};
Object.defineProperty(mv, "__esModule", { value: !0 });
mv.Recipe = void 0;
var fVe = m2, hVe = Hx, pVe = gv, mVe = qo, dj = ur, gVe = vv, vVe = vd, L8 = (
  /** @class */
  function() {
    function e(t) {
      this.config = (0, hVe.normaliseUserInput)(t);
      var r = new mVe.default(
        (0, pVe.default)({
          recipeId: this.config.recipeId,
          appInfo: this.config.appInfo,
          clientType: this.config.clientType,
          preAPIHook: this.config.preAPIHook,
          postAPIHook: this.config.postAPIHook
        })
      );
      this.recipeImplementation = r.override(this.config.override.functions).build(), vVe.PostSuperTokensInitCallbacks.addPostInitCallback(function() {
        fVe.SessionClaimValidatorStore.addClaimValidatorFromOtherRecipe(
          e.EmailVerificationClaim.validators.isVerified(10)
        );
      });
    }
    return e.init = function(t) {
      return function(r, n) {
        return e.instance = new e(
          Gb(Gb({}, t), { appInfo: r, clientType: n, recipeId: e.RECIPE_ID })
        ), e.instance;
      };
    }, e.getInstanceOrThrow = function() {
      if (e.instance === void 0) {
        var t = "No instance of EmailVerification found. Ensure that the 'EmailVerification.init' method is called within the 'SuperTokens.init' recipeList.";
        throw t = (0, dj.checkForSSRErrorAndAppendIfNeeded)(t), Error(t);
      }
      return e.instance;
    }, e.reset = function() {
      (0, dj.isTest)() && (e.instance = void 0);
    }, e.RECIPE_ID = "emailverification", e.EmailVerificationClaim = new gVe.EmailVerificationClaimClass(function() {
      return e.getInstanceOrThrow().recipeImplementation;
    }), e;
  }()
);
mv.Recipe = L8;
mv.default = L8;
(function(e) {
  var t = ke && ke.__assign || function() {
    return t = Object.assign || function(h) {
      for (var p, m = 1, g = arguments.length; m < g; m++) {
        p = arguments[m];
        for (var y in p) Object.prototype.hasOwnProperty.call(p, y) && (h[y] = p[y]);
      }
      return h;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.EmailVerificationClaimClass = e.EmailVerificationClaim = e.getTenantIdFromURL = e.getEmailVerificationTokenFromURL = e.isEmailVerified = e.sendVerificationEmail = e.verifyEmail = e.init = void 0;
  var r = mv, n = ur, a = vv;
  Object.defineProperty(e, "EmailVerificationClaimClass", {
    enumerable: !0,
    get: function() {
      return a.EmailVerificationClaimClass;
    }
  });
  var s = (
    /** @class */
    function() {
      function h() {
      }
      return h.init = function(p) {
        return r.default.init(p);
      }, h.verifyEmail = function(p) {
        return r.default.getInstanceOrThrow().recipeImplementation.verifyEmail(
          t(t({}, p), {
            userContext: (0, n.getNormalisedUserContext)(
              p == null ? void 0 : p.userContext
            )
          })
        );
      }, h.sendVerificationEmail = function(p) {
        return r.default.getInstanceOrThrow().recipeImplementation.sendVerificationEmail(
          t(t({}, p), {
            userContext: (0, n.getNormalisedUserContext)(
              p == null ? void 0 : p.userContext
            )
          })
        );
      }, h.isEmailVerified = function(p) {
        return r.default.getInstanceOrThrow().recipeImplementation.isEmailVerified(
          t(t({}, p), {
            userContext: (0, n.getNormalisedUserContext)(
              p == null ? void 0 : p.userContext
            )
          })
        );
      }, h.getEmailVerificationTokenFromURL = function(p) {
        return r.default.getInstanceOrThrow().recipeImplementation.getEmailVerificationTokenFromURL(
          t(t({}, p), {
            userContext: (0, n.getNormalisedUserContext)(
              p == null ? void 0 : p.userContext
            )
          })
        );
      }, h.getTenantIdFromURL = function(p) {
        return r.default.getInstanceOrThrow().recipeImplementation.getTenantIdFromURL(
          t(t({}, p), {
            userContext: (0, n.getNormalisedUserContext)(
              p == null ? void 0 : p.userContext
            )
          })
        );
      }, h.EmailVerificationClaim = r.default.EmailVerificationClaim, h;
    }()
  );
  e.default = s;
  var i = s.init;
  e.init = i;
  var o = s.verifyEmail;
  e.verifyEmail = o;
  var l = s.sendVerificationEmail;
  e.sendVerificationEmail = l;
  var c = s.isEmailVerified;
  e.isEmailVerified = c;
  var u = s.getEmailVerificationTokenFromURL;
  e.getEmailVerificationTokenFromURL = u;
  var d = s.getTenantIdFromURL;
  e.getTenantIdFromURL = d;
  var f = s.EmailVerificationClaim;
  e.EmailVerificationClaim = f;
})(D8);
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(D8);
})(I8);
var tn = ba, j8 = I8, yVe = Rx, bVe = p2, wVe = zh;
function xVe(e) {
  return e && e.__esModule ? e : { default: e };
}
var fj = /* @__PURE__ */ xVe(j8), F8 = tn.createGenericComponentsOverrideContext(), _Ve = F8[0], SVe = F8[1], B8 = "/verify-email", EVe = (
  /** @class */
  function(e) {
    tn.__extends(t, e);
    function t(r, n) {
      var a = e.call(this, r) || this, s = tn.__assign({}, a.validators), i = function(l) {
        var c = s[l];
        s[l] = function() {
          for (var u = [], d = 0; d < arguments.length; d++)
            u[d] = arguments[d];
          return tn.__assign(
            tn.__assign({}, c.apply(void 0, u)),
            {
              onFailureRedirection: function(f) {
                if (n !== void 0)
                  return n(f);
                var h = U8.getInstanceOrThrow();
                if (h.config.mode === "REQUIRED")
                  return h.getRedirectUrl(
                    {
                      action: "VERIFY_EMAIL",
                      tenantIdFromQueryParams: tn.getTenantIdFromQueryParams()
                    },
                    f.userContext
                  );
              },
              showAccessDeniedOnFailure: !1
            }
          );
        };
      };
      for (var o in s)
        i(o);
      return a.validators = s, a;
    }
    return t;
  }(j8.EmailVerificationClaimClass)
), TVe = function(e) {
  return function(t) {
    return tn.__assign(tn.__assign({}, t), {
      verifyEmail: function(r) {
        return tn.__awaiter(this, void 0, void 0, function() {
          var n;
          return tn.__generator(this, function(a) {
            switch (a.label) {
              case 0:
                return [4, t.verifyEmail(r)];
              case 1:
                return n = a.sent(), n.status === "OK" && e({
                  action: "EMAIL_VERIFIED_SUCCESSFUL",
                  userContext: r.userContext
                }), [2, n];
            }
          });
        });
      },
      sendVerificationEmail: function(r) {
        return tn.__awaiter(this, void 0, void 0, function() {
          var n;
          return tn.__generator(this, function(a) {
            switch (a.label) {
              case 0:
                return [4, t.sendVerificationEmail(r)];
              case 1:
                return n = a.sent(), n.status === "OK" && e({
                  action: "VERIFY_EMAIL_SENT",
                  userContext: r.userContext
                }), [2, n];
            }
          });
        });
      }
    });
  };
};
function CVe(e) {
  e === void 0 && (e = {});
  var t = e.disableDefaultUI === !0, r = e.mode === void 0 ? "REQUIRED" : e.mode, n = e.sendVerifyEmailScreen !== void 0 && e.sendVerifyEmailScreen.style !== void 0 ? e.sendVerifyEmailScreen.style : "", a = {
    style: n
  }, s = e.verifyEmailLinkClickedScreen !== void 0 && e.verifyEmailLinkClickedScreen.style !== void 0 ? e.verifyEmailLinkClickedScreen.style : "", i = {
    style: s
  }, o = tn.__assign(
    {
      functions: function(l) {
        return l;
      }
    },
    e.override
  );
  return tn.__assign(
    tn.__assign(
      {},
      tn.normaliseRecipeModuleConfig(e)
    ),
    {
      disableDefaultUI: t,
      mode: r,
      sendVerifyEmailScreen: a,
      verifyEmailLinkClickedScreen: i,
      override: o
    }
  );
}
var U8 = (
  /** @class */
  function(e) {
    tn.__extends(t, e);
    function t(r, n) {
      n === void 0 && (n = fj.default);
      var a = e.call(this, r) || this;
      return a.webJSRecipe = n, a.recipeID = t.RECIPE_ID, a.getDefaultRedirectionURL = function(s) {
        return tn.__awaiter(a, void 0, void 0, function() {
          return tn.__generator(this, function(i) {
            return s.action === "VERIFY_EMAIL" ? [
              2,
              tn.getDefaultRedirectionURLForPath(
                this.config,
                B8,
                s
              )
            ] : [2, "/"];
          });
        });
      }, yVe.PostSuperTokensInitCallbacks.addPostInitCallback(function() {
        var s = t.EmailVerificationClaim.validators.isVerified(10);
        bVe.SessionClaimValidatorStore.addClaimValidatorFromOtherRecipe(s);
      }), a;
    }
    return t.init = function(r) {
      var n = CVe(r);
      return {
        recipeID: t.RECIPE_ID,
        authReact: function(a) {
          return t.instance = new t(
            tn.__assign(
              tn.__assign({}, n),
              { appInfo: a, recipeId: t.RECIPE_ID }
            )
          ), t.instance;
        },
        webJS: fj.default.init(
          tn.__assign(
            tn.__assign({}, n),
            {
              override: {
                functions: function(a, s) {
                  var i = TVe(n.onHandleEvent);
                  return s.override(i), s.override(n.override.functions), a;
                }
              }
            }
          )
        )
      };
    }, t.getInstanceOrThrow = function() {
      if (t.instance === void 0) {
        var r = "No instance of EmailVerification found. Make sure to call the EmailVerification.init method.";
        throw typeof window > "u" && (r = r + tn.SSR_ERROR), Error(r);
      }
      return t.instance;
    }, t.prototype.isEmailVerified = function(r) {
      return tn.__awaiter(this, void 0, void 0, function() {
        return tn.__generator(this, function(n) {
          switch (n.label) {
            case 0:
              return [
                4,
                this.webJSRecipe.isEmailVerified({
                  userContext: r
                })
              ];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, t.reset = function() {
      tn.isTest() && (t.instance = void 0);
    }, t.RECIPE_ID = "emailverification", t.EmailVerificationClaim = new EVe(function() {
      return t.getInstanceOrThrow().webJSRecipe;
    }), t;
  }(wVe.RecipeModule)
);
pv.DEFAULT_VERIFY_EMAIL_PATH = B8;
pv.EmailVerification = U8;
pv.Provider = SVe;
pv.useContext = _Ve;
Object.defineProperty(Xo, "__esModule", { value: !0 });
var fa = ba, lc = pv, xd = (
  /** @class */
  function() {
    function e() {
    }
    return e.init = function(t) {
      return lc.EmailVerification.init(t);
    }, e.isEmailVerified = function(t) {
      return fa.__awaiter(this, void 0, void 0, function() {
        return fa.__generator(this, function(r) {
          return [
            2,
            lc.EmailVerification.getInstanceOrThrow().webJSRecipe.isEmailVerified(
              fa.__assign(fa.__assign({}, t), {
                userContext: fa.getNormalisedUserContext(
                  t == null ? void 0 : t.userContext
                )
              })
            )
          ];
        });
      });
    }, e.verifyEmail = function(t) {
      return fa.__awaiter(this, void 0, void 0, function() {
        return fa.__generator(this, function(r) {
          return [
            2,
            lc.EmailVerification.getInstanceOrThrow().webJSRecipe.verifyEmail(
              fa.__assign(fa.__assign({}, t), {
                userContext: fa.getNormalisedUserContext(
                  t == null ? void 0 : t.userContext
                )
              })
            )
          ];
        });
      });
    }, e.sendVerificationEmail = function(t) {
      return fa.__awaiter(this, void 0, void 0, function() {
        return fa.__generator(this, function(r) {
          return [
            2,
            lc.EmailVerification.getInstanceOrThrow().webJSRecipe.sendVerificationEmail(
              fa.__assign(fa.__assign({}, t), {
                userContext: fa.getNormalisedUserContext(
                  t == null ? void 0 : t.userContext
                )
              })
            )
          ];
        });
      });
    }, e.getEmailVerificationTokenFromURL = function(t) {
      return lc.EmailVerification.getInstanceOrThrow().webJSRecipe.getEmailVerificationTokenFromURL(
        fa.__assign(fa.__assign({}, t), {
          userContext: fa.getNormalisedUserContext(
            t == null ? void 0 : t.userContext
          )
        })
      );
    }, e.EmailVerificationClaim = lc.EmailVerification.EmailVerificationClaim, e.ComponentsOverrideProvider = lc.Provider, e;
  }()
), kVe = xd.init, OVe = xd.isEmailVerified, AVe = xd.verifyEmail, PVe = xd.sendVerificationEmail, RVe = xd.getEmailVerificationTokenFromURL, IVe = xd.ComponentsOverrideProvider, DVe = lc.EmailVerification.EmailVerificationClaim;
Xo.EmailVerificationClaim = DVe;
Xo.EmailVerificationComponentsOverrideProvider = IVe;
Xo.default = xd;
Xo.getEmailVerificationTokenFromURL = RVe;
Xo.init = kVe;
Xo.isEmailVerified = OVe;
Xo.sendVerificationEmail = PVe;
Xo.verifyEmail = AVe;
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(Xo);
})(R8);
const ty = /* @__PURE__ */ wh(R8);
var V8 = {}, Dn = {}, I2 = {}, NVe = ba, $8 = NVe.createGenericComponentsOverrideContext(), MVe = $8[0], LVe = $8[1];
I2.Provider = LVe;
I2.useContext = MVe;
Object.defineProperty(Dn, "__esModule", { value: !0 });
var Or = ba, D2 = g2, jVe = I2, Ei = ql, Yb = _r, FVe = (
  /** @class */
  function(e) {
    Or.__extends(t, e);
    function t(r) {
      var n = e.call(this, r) || this, a = Or.__assign({}, n.validators), s = function(o) {
        var l = a[o];
        a[o] = function() {
          for (var c = [], u = 0; u < arguments.length; u++)
            c[u] = arguments[u];
          return Or.__assign(
            Or.__assign({}, l.apply(void 0, c)),
            {
              onFailureRedirection: r.onFailureRedirection,
              showAccessDeniedOnFailure: r.showAccessDeniedOnFailure
            }
          );
        };
      };
      for (var i in a)
        s(i);
      return n.validators = a, n;
    }
    return t;
  }(D2.BooleanClaim)
), BVe = (
  /** @class */
  function(e) {
    Or.__extends(t, e);
    function t(r) {
      var n = e.call(this, r) || this, a = Or.__assign({}, n.validators), s = function(o) {
        var l = a[o];
        a[o] = function() {
          for (var c = [], u = 0; u < arguments.length; u++)
            c[u] = arguments[u];
          return Or.__assign(
            Or.__assign({}, l.apply(void 0, c)),
            {
              onFailureRedirection: r.onFailureRedirection,
              showAccessDeniedOnFailure: r.showAccessDeniedOnFailure
            }
          );
        };
      };
      for (var i in a)
        s(i);
      return n.validators = a, n;
    }
    return t;
  }(D2.PrimitiveArrayClaim)
), UVe = (
  /** @class */
  function(e) {
    Or.__extends(t, e);
    function t(r) {
      var n = e.call(this, r) || this, a = Or.__assign({}, n.validators), s = function(o) {
        var l = a[o];
        a[o] = function() {
          for (var c = [], u = 0; u < arguments.length; u++)
            c[u] = arguments[u];
          return Or.__assign(
            Or.__assign({}, l.apply(void 0, c)),
            {
              onFailureRedirection: r.onFailureRedirection,
              showAccessDeniedOnFailure: r.showAccessDeniedOnFailure
            }
          );
        };
      };
      for (var i in a)
        s(i);
      return n.validators = a, n;
    }
    return t;
  }(D2.PrimitiveClaim)
), VVe = function(e) {
  var t = Yb.useSessionContext();
  return t.loading ? {
    loading: !0
  } : t.doesSessionExist === !1 ? {
    loading: !1,
    doesSessionExist: !1,
    value: void 0
  } : {
    loading: !1,
    doesSessionExist: !0,
    value: e.getValueFromPayload(t.accessTokenPayload)
  };
}, Za = (
  /** @class */
  function() {
    function e() {
    }
    return e.init = function(t) {
      return Ei.Session.init(t);
    }, e.getUserId = function(t) {
      return Or.__awaiter(this, void 0, void 0, function() {
        return Or.__generator(this, function(r) {
          return [
            2,
            Ei.Session.getInstanceOrThrow().getUserId({
              userContext: Or.getNormalisedUserContext(
                t == null ? void 0 : t.userContext
              )
            })
          ];
        });
      });
    }, e.getAccessToken = function(t) {
      return Or.__awaiter(this, void 0, void 0, function() {
        return Or.__generator(this, function(r) {
          return [
            2,
            Ei.Session.getInstanceOrThrow().getAccessToken({
              userContext: Or.getNormalisedUserContext(
                t == null ? void 0 : t.userContext
              )
            })
          ];
        });
      });
    }, e.getAccessTokenPayloadSecurely = function(t) {
      return Or.__awaiter(this, void 0, void 0, function() {
        return Or.__generator(this, function(r) {
          return [
            2,
            Ei.Session.getInstanceOrThrow().getAccessTokenPayloadSecurely({
              userContext: Or.getNormalisedUserContext(
                t == null ? void 0 : t.userContext
              )
            })
          ];
        });
      });
    }, e.attemptRefreshingSession = function() {
      return Or.__awaiter(this, void 0, void 0, function() {
        return Or.__generator(this, function(t) {
          return [2, Ei.Session.getInstanceOrThrow().attemptRefreshingSession()];
        });
      });
    }, e.doesSessionExist = function(t) {
      return Or.__awaiter(this, void 0, void 0, function() {
        return Or.__generator(this, function(r) {
          return [
            2,
            Ei.Session.getInstanceOrThrow().doesSessionExist({
              userContext: Or.getNormalisedUserContext(
                t == null ? void 0 : t.userContext
              )
            })
          ];
        });
      });
    }, e.addAxiosInterceptors = function(t, r) {
      return Ei.Session.addAxiosInterceptors(
        t,
        Or.getNormalisedUserContext(r)
      );
    }, e.signOut = function(t) {
      return Or.__awaiter(this, void 0, void 0, function() {
        return Or.__generator(this, function(r) {
          return [
            2,
            Ei.Session.getInstanceOrThrow().signOut({
              userContext: Or.getNormalisedUserContext(
                t == null ? void 0 : t.userContext
              )
            })
          ];
        });
      });
    }, e.validateClaims = function(t) {
      return Ei.Session.getInstanceOrThrow().validateClaims({
        overrideGlobalClaimValidators: t == null ? void 0 : t.overrideGlobalClaimValidators,
        userContext: Or.getNormalisedUserContext(
          t == null ? void 0 : t.userContext
        )
      });
    }, e.getInvalidClaimsFromResponse = function(t) {
      return Ei.Session.getInstanceOrThrow().getInvalidClaimsFromResponse(t);
    }, e.getClaimValue = function(t) {
      return Ei.Session.getInstanceOrThrow().getClaimValue({
        claim: t.claim,
        userContext: Or.getNormalisedUserContext(
          t == null ? void 0 : t.userContext
        )
      });
    }, e.useSessionContext = Yb.useSessionContext, e.useClaimValue = VVe, e.SessionAuth = Yb.SessionAuthWrapper, e.ComponentsOverrideProvider = jVe.Provider, e;
  }()
), $Ve = Za.useSessionContext, HVe = Za.useClaimValue, WVe = Za.SessionAuth, zVe = Za.init, KVe = Za.getUserId, qVe = Za.getAccessToken, GVe = Za.getAccessTokenPayloadSecurely, YVe = Za.attemptRefreshingSession, XVe = Za.doesSessionExist, QVe = Za.addAxiosInterceptors, JVe = Za.signOut, ZVe = Za.validateClaims, e$e = Za.getInvalidClaimsFromResponse, t$e = Za.getClaimValue, r$e = Za.ComponentsOverrideProvider;
Dn.SessionContext = Yb.SessionContext;
Dn.BooleanClaim = FVe;
Dn.PrimitiveArrayClaim = BVe;
Dn.PrimitiveClaim = UVe;
Dn.SessionAuth = WVe;
Dn.SessionComponentsOverrideProvider = r$e;
Dn.addAxiosInterceptors = QVe;
Dn.attemptRefreshingSession = YVe;
Dn.default = Za;
Dn.doesSessionExist = XVe;
Dn.getAccessToken = qVe;
Dn.getAccessTokenPayloadSecurely = GVe;
Dn.getClaimValue = t$e;
Dn.getInvalidClaimsFromResponse = e$e;
Dn.getUserId = KVe;
Dn.init = zVe;
Dn.signOut = JVe;
Dn.useClaimValue = HVe;
Dn.useSessionContext = $Ve;
Dn.validateClaims = ZVe;
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(Dn);
})(V8);
const aa = /* @__PURE__ */ wh(V8);
var H8 = {}, W8 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = d2, r = Mx, n = ba, a = (
    /** @class */
    function() {
      function o() {
      }
      return o.init = function(l) {
        return n.Multitenancy.init(l);
      }, o.AllowedDomainsClaim = t.AllowedDomainsClaim, o.ComponentsOverrideProvider = r.Provider, o;
    }()
  ), s = a.init, i = a.ComponentsOverrideProvider;
  Object.defineProperty(e, "AllowedDomainsClaim", {
    enumerable: !0,
    get: function() {
      return t.AllowedDomainsClaim;
    }
  }), e.MultitenancyComponentsOverrideProvider = i, e.default = a, e.init = s;
})(W8);
(function(e) {
  function t(r) {
    for (var n in r) e.hasOwnProperty(n) || (e[n] = r[n]);
  }
  e.__esModule = !0, t(W8);
})(H8);
const n$e = /* @__PURE__ */ wh(H8), a$e = (e) => {
  const t = ui(), r = new ed();
  lUe.init({
    appInfo: {
      appName: t.APP_NAME,
      apiDomain: t.AUTH_BASE_URL,
      apiBasePath: "/auth",
      websiteDomain: window.location.origin,
      websiteBasePath: "/auth"
    },
    recipeList: [
      Up.init(),
      ty.init(),
      aa.init({
        tokenTransferMethod: "header"
      }),
      n$e.init({
        override: {
          functions: (a) => ({
            ...a,
            getTenantId: async () => t.TENANT_ID
          })
        }
      })
    ]
  });
  const n = (a, s) => {
    var c;
    const i = !s.REQUIRED_ROLE || (((c = a["st-role"]) == null ? void 0 : c.v) || []).includes(s.REQUIRED_ROLE), o = a.tId ? [a.tId] : [], l = o.includes(s.TENANT_ID);
    return { hasRequiredRole: i, hasTenantAccess: l, tenants: o };
  };
  return {
    tenant: t.TENANT_ID,
    providers: {
      storage: {
        type: "local",
        operations: {
          set: {
            execute: async (a) => Promise.resolve(void 0)
          },
          get: {
            execute: async (a) => Promise.resolve(void 0)
          }
        }
      },
      analytics: {
        type: "mixpanel",
        operations: {
          track: {
            execute: () => Promise.resolve(void 0)
          }
        }
      },
      auth: {
        type: "supertokens",
        operations: {
          login: {
            execute: async (a) => {
              try {
                const s = await Up.signIn({
                  formFields: [
                    { id: "email", value: a.email },
                    { id: "password", value: a.password }
                  ]
                });
                if (s.status === "OK") {
                  const i = await aa.getAccessTokenPayloadSecurely(), o = await aa.getAccessToken();
                  if (!o)
                    throw await aa.signOut(), await si.getInstance("local").clearTokens(), {
                      name: "AuthError",
                      message: "Failed to get access token",
                      code: Xn.AUTH_INVALID_TOKEN,
                      category: dn.AUTH,
                      translationKey: On.AUTH.INVALID_TOKEN
                    };
                  const { hasRequiredRole: l, hasTenantAccess: c, tenants: u } = n(
                    i,
                    t
                  );
                  if (!l || !c)
                    throw await aa.signOut(), await si.getInstance("local").clearTokens(), {
                      name: "AuthError",
                      message: l ? "No access to this tenant" : `${t.REQUIRED_ROLE} role required`,
                      code: l ? Xn.AUTH_TENANT_ACCESS_DENIED : Xn.AUTH_ADMIN_ACCESS_REQUIRED,
                      category: dn.AUTH,
                      translationKey: l ? On.AUTH.TENANT_ACCESS_DENIED : On.AUTH.ADMIN_ACCESS_REQUIRED
                    };
                  await si.getInstance("local").setTokens({
                    accessToken: o,
                    tokenType: "Bearer"
                  });
                  let d = null, f = !1;
                  try {
                    d = await e.usersApi.userInfo({}), f = !0;
                  } catch (h) {
                    if (h.statusCode !== 404)
                      throw await aa.signOut(), await si.getInstance("local").clearTokens(), r.adaptError(h);
                  }
                  return {
                    data: {
                      user: {
                        id: s.user.id,
                        email: a.email,
                        roles: i.roles || [],
                        userInfo: d,
                        isActive: f,
                        tenants: s.user.tenantIds || [],
                        currentTenant: t.TENANT_ID,
                        permissions: [
                          "*",
                          "read:comments",
                          "manage:agents",
                          "manage:prompts",
                          "manage:users"
                        ],
                        features: [
                          "dashboard",
                          "comments",
                          "settings",
                          "profile",
                          "theme-customization",
                          "subscription",
                          "documentation",
                          "agents",
                          "prompts",
                          "user-management",
                          "onboarding"
                        ]
                      },
                      tokens: {
                        accessToken: o,
                        tokenType: "Bearer"
                      }
                    }
                  };
                }
                throw await aa.signOut(), await si.getInstance("local").clearTokens(), {
                  name: "AuthError",
                  message: "Login failed",
                  code: Xn.AUTH_INVALID_CREDENTIALS,
                  category: dn.AUTH,
                  translationKey: On.AUTH.INVALID_CREDENTIALS
                };
              } catch (s) {
                throw await aa.signOut(), await si.getInstance("local").clearTokens(), r.adaptError(s);
              }
            }
          },
          register: {
            execute: async (a) => {
              await aa.signOut(), await si.getInstance().clearTokens();
              const s = await Up.signUp({
                formFields: [
                  { id: "email", value: a.email },
                  { id: "password", value: a.password }
                ]
              });
              if (s.status === "OK") {
                await ty.sendVerificationEmail();
                const i = await aa.getAccessTokenPayloadSecurely(), o = await aa.getAccessToken();
                if (!o)
                  throw {
                    name: "AuthError",
                    message: "No access token",
                    code: Xn.AUTH_INVALID_TOKEN,
                    category: dn.AUTH,
                    translationKey: On.AUTH.INVALID_TOKEN
                  };
                return {
                  user: {
                    id: s.user.id,
                    email: a.email,
                    roles: i.roles || [],
                    isActive: !1
                    // Set to false until email is verified
                  },
                  tokens: {
                    accessToken: o,
                    tokenType: "Bearer"
                  }
                };
              }
              throw new Error("Registration failed");
            }
          },
          me: {
            execute: async () => {
              try {
                if (!await aa.doesSessionExist()) throw new Error("No session exists");
                const a = await aa.getAccessTokenPayloadSecurely();
                if (!await aa.getAccessToken())
                  throw {
                    name: "AuthError",
                    message: "No access token",
                    code: Xn.AUTH_INVALID_TOKEN,
                    category: dn.AUTH,
                    translationKey: On.AUTH.INVALID_TOKEN
                  };
                const { hasRequiredRole: i, hasTenantAccess: o, tenants: l } = n(a, t);
                if (!i || !o)
                  throw await aa.signOut(), {
                    name: "AuthError",
                    message: i ? "No access to this tenant" : `${t.REQUIRED_ROLE} role required`,
                    code: i ? Xn.AUTH_TENANT_ACCESS_DENIED : Xn.AUTH_ADMIN_ACCESS_REQUIRED,
                    category: dn.AUTH,
                    translationKey: i ? On.AUTH.TENANT_ACCESS_DENIED : On.AUTH.ADMIN_ACCESS_REQUIRED
                  };
                let c = null, u = !1;
                try {
                  c = await e.usersApi.userInfo({}), u = !0;
                } catch (f) {
                  if (f.statusCode !== 404) throw r.adaptError(f);
                }
                return {
                  id: a.sub,
                  email: a.email,
                  roles: a.roles || [],
                  userInfo: c,
                  isActive: u,
                  tenants: l,
                  currentTenant: t.TENANT_ID,
                  permissions: [
                    "*",
                    "read:comments",
                    "manage:agents",
                    "manage:prompts",
                    "manage:users"
                  ],
                  features: [
                    "dashboard",
                    "comments",
                    "settings",
                    "profile",
                    "theme-customization",
                    "subscription",
                    "documentation",
                    "agents",
                    "prompts",
                    "user-management",
                    "onboarding"
                  ]
                };
              } catch (a) {
                throw a.code !== "TENANT_ACCESS_DENIED" && await aa.signOut(), a;
              }
            }
          },
          logout: {
            execute: async () => {
              await aa.signOut();
            }
          },
          refresh: {
            execute: async () => {
              const a = await aa.getAccessToken();
              if (!a)
                throw {
                  name: "AuthError",
                  message: "No access token",
                  code: Xn.AUTH_INVALID_TOKEN,
                  category: dn.AUTH,
                  translationKey: On.AUTH.INVALID_TOKEN
                };
              return {
                accessToken: a,
                tokenType: "Bearer"
              };
            }
          },
          getRoles: {
            execute: async () => (await aa.getAccessTokenPayloadSecurely()).roles || []
          },
          assignRole: {
            execute: async (a) => {
              throw new Error("Not implemented");
            }
          },
          verifyEmail: {
            execute: async (a) => {
              if (!a) throw new Error("Token is required");
              if ((await ty.verifyEmail({
                userContext: {},
                options: {}
              })).status !== "OK")
                throw new Error("Email verification failed");
            }
          },
          sendVerificationEmail: {
            execute: async () => {
              const a = await ty.sendVerificationEmail();
              if (a.status !== "OK")
                throw a.status === "EMAIL_ALREADY_VERIFIED_ERROR" ? {
                  status: "EMAIL_ALREADY_VERIFIED_ERROR",
                  name: "AuthError",
                  message: "Email already verified",
                  code: Xn.AUTH_EMAIL_ALREADY_VERIFIED_ERROR,
                  category: dn.AUTH,
                  translationKey: On.AUTH.EMAIL_ALREADY_VERIFIED_ERROR
                } : new Error("Failed to send verification email");
            }
          },
          resetPassword: {
            execute: async (a) => {
              if (!a) throw new Error("Email is required");
              if ((await Up.sendPasswordResetEmail({
                formFields: [{ id: "email", value: a }],
                options: {}
              })).status !== "OK")
                throw new Error("Failed to send reset password email");
            }
          },
          confirmResetPassword: {
            execute: async (a) => {
              if (!(a != null && a.password) || !(a != null && a.token))
                throw new Error("Password and token are required");
              if ((await Up.submitNewPassword({
                formFields: [{ id: "password", value: a.password }],
                options: {}
              })).status !== "OK")
                throw new Error("Failed to reset password");
            }
          }
        }
      },
      payment: {
        type: "multi",
        operations: {
          // initiateBankConnection: createOperation<
          //   "usersApi",
          //   "initiateBankConnection",
          //   BridgeApiOperations["initiateBankConnection"]["request"],
          //   BridgeApiOperations["initiateBankConnection"]["response"]
          // >({
          //   execute: async (data) => {
          //     const response = await apiClient.usersApi.initializeUser({
          //       userInfo: {
          //         first_name: data!.first_name,
          //         last_name: data!.last_name,
          //         birth_country: data!.birth_country,
          //         birth_city: data!.birth_city,
          //         birthday: data!.birthday,
          //         nationality: data!.nationality,
          //         residence_country: data!.residence_country,
          //         bank_account: data!.bank_account,
          //       },
          //     });
          //     return {
          //       id: response.id,
          //       status: response.status as "initiated" | "kyced" | "active",
          //     };
          //   },
          // }),
          // getBankAccounts: createOperation<
          //   "usersApi",
          //   "getBankAccounts",
          //   void,
          //   BridgeApiOperations["getBankAccounts"]["response"]
          // >({
          //   execute: async () => {
          //     const response = await apiClient.usersApi.wallet();
          //     return {
          //       accounts: response.accounts.map((acc) => ({
          //         id: acc.id,
          //         iban: acc.iban,
          //         bic: acc.bic,
          //         status: acc.status as "active" | "inactive",
          //       })),
          //     };
          //   },
          // }),
        }
      }
    },
    features: {
      auth: {
        storage: "local",
        roles: {
          enabled: !0,
          default: "user",
          definitions: {
            admin: {
              name: "Administrator",
              permissions: ["*"],
              level: 100,
              tenantScoped: !1
            },
            manager: {
              name: "Manager",
              permissions: ["read:*", "write:*", "delete:*"],
              level: 50,
              tenantScoped: !0
            },
            user: {
              name: "User",
              permissions: ["read:own", "write:own"],
              level: 10,
              tenantScoped: !0
            }
          },
          tenants: {
            enabled: !0,
            separator: ":"
          }
        },
        onboarding: {
          enabled: !0,
          steps: ["profile", "organization", "bank-connection"]
        }
      },
      payment: {
        providers: ["bridgeapi", "mangopay"],
        subscriptionRequired: !0,
        plans: ["free", "pro", "enterprise"]
        // bankConnection: {
        //   required: true,
        //   providers: ["bridgeapi"],
        // },
        // wallet: {
        //   enabled: true,
        //   provider: "mangopay",
        // },
      }
    }
  };
}, z8 = Vl(
  void 0
);
function Vet({ children: e }) {
  const t = sn(), r = Tn(() => a$e(t), [t]), n = Tn(() => si.getInstance(), []), [a, s] = Me(() => ({
    user: null,
    tokens: null,
    isLoading: !0,
    error: null
  })), i = Ft(
    (l) => !(l != null && l.tenants) || !r.tenant ? !1 : l.tenants.includes(r.tenant),
    [r]
  );
  wt(() => {
    const l = async () => {
      await n.clearTokens(), s({
        user: null,
        tokens: null,
        isLoading: !1,
        error: null
      });
    };
    return window.addEventListener("auth:tokenExpired", l), () => {
      window.removeEventListener("auth:tokenExpired", l);
    };
  }, [n]), wt(() => {
    let l = !0;
    return (async () => {
      try {
        const u = await n.getTokens();
        if (!u) {
          l && s((f) => ({ ...f, isLoading: !1 }));
          return;
        }
        const d = await r.providers.auth.operations.me.execute();
        if (l) {
          if (!i(d)) {
            s({
              user: null,
              tokens: null,
              isLoading: !1,
              error: {
                name: "TenantError",
                message: "No access to this tenant",
                code: "TENANT_ACCESS_DENIED"
              }
            });
            return;
          }
          s({
            user: d,
            tokens: u,
            isLoading: !1,
            error: null
          });
        }
      } catch (u) {
        l && (u.code !== "TENANT_ACCESS_DENIED" && await n.clearTokens(), s((d) => ({
          ...d,
          user: null,
          tokens: null,
          isLoading: !1
        })));
      }
    })(), () => {
      l = !1;
    };
  }, [r, n, i]);
  const o = Tn(
    () => {
      var l, c, u;
      return {
        ...a,
        isAuthenticated: !!a.user,
        isOnboardingEnabled: ((u = (c = (l = r.features) == null ? void 0 : l.auth) == null ? void 0 : c.onboarding) == null ? void 0 : u.enabled) ?? !1,
        login: async (d) => {
          try {
            const f = await r.providers.auth.operations.login.execute(
              d
            );
            if (f.data) {
              if (!i(f.data.user))
                return s({
                  user: null,
                  tokens: null,
                  isLoading: !1,
                  error: {
                    name: "TenantError",
                    message: "No access to this tenant",
                    code: "TENANT_ACCESS_DENIED"
                  }
                }), f;
              s({
                user: f.data.user,
                tokens: f.data.tokens,
                isLoading: !1,
                error: null
              });
            }
            return f;
          } catch (f) {
            throw s((h) => ({ ...h, error: f })), f;
          }
        },
        register: async (d) => {
          try {
            const f = await r.providers.auth.operations.register.execute(d);
            return f.data && s({
              user: f.data.user,
              tokens: f.data.tokens,
              isLoading: !1,
              error: null
            }), f;
          } catch (f) {
            throw s((h) => ({ ...h, error: f })), f;
          }
        },
        logout: async () => {
          try {
            await r.providers.auth.operations.logout.execute(), await n.clearTokens(), s({
              user: null,
              tokens: null,
              isLoading: !1,
              error: null
            });
          } catch (d) {
            throw s((f) => ({ ...f, error: d })), d;
          }
        },
        updateOnboardingStep: async (d) => {
          var f;
          try {
            const h = await r.providers.auth.operations.updateOnboarding.execute(
              d
            );
            return (f = h.data) != null && f.user && s((p) => ({
              ...p,
              user: h.data.user,
              error: null
            })), h;
          } catch (h) {
            throw s((p) => ({ ...p, error: h })), h;
          }
        },
        resetPassword: async (d) => {
          try {
            await r.providers.auth.operations.resetPassword.execute(d), s((f) => ({ ...f, error: null }));
          } catch (f) {
            throw s((h) => ({ ...h, error: f })), f;
          }
        },
        confirmResetPassword: async (d, f) => {
          try {
            await r.providers.auth.operations.confirmResetPassword.execute({
              token: d,
              password: f
            }), s((h) => ({ ...h, error: null }));
          } catch (h) {
            throw s((p) => ({ ...p, error: h })), h;
          }
        },
        refreshTokens: async () => {
          var d;
          try {
            const f = await r.providers.auth.operations.refresh.execute(
              { refreshToken: ((d = a.tokens) == null ? void 0 : d.refreshToken) || "" }
            );
            return s((h) => ({ ...h, tokens: f, error: null })), f;
          } catch (f) {
            throw s((h) => ({ ...h, error: f })), f;
          }
        },
        verifyEmail: async (d) => {
          try {
            await r.providers.auth.operations.verifyEmail.execute(d), s((f) => ({ ...f, error: null }));
          } catch (f) {
            throw s((h) => ({ ...h, error: f })), f;
          }
        },
        sendVerificationEmail: async () => {
          try {
            await r.providers.auth.operations.sendVerificationEmail.execute(), s((d) => ({ ...d, error: null }));
          } catch (d) {
            throw s((f) => ({ ...f, error: d })), d;
          }
        }
      };
    },
    [a, r, n]
  );
  return /* @__PURE__ */ v.jsx(z8.Provider, { value: o, children: e });
}
function As() {
  const e = vh(z8);
  if (!e)
    throw new Error("useAuth must be used within an AuthProvider");
  return e;
}
const N2 = () => {
  var s;
  const { user: e } = As(), t = ta(), r = x$((s = e == null ? void 0 : e.userInfo) == null ? void 0 : s.kyc), n = (e == null ? void 0 : e.isActive) ?? !1, a = () => !e || !n || !r ? (t("/onboarding"), !1) : !0;
  return {
    isKycVerified: r,
    isActive: n,
    userInfo: e == null ? void 0 : e.userInfo,
    checkAndRedirect: a
  };
};
function s$e(e) {
  const { t } = _t(), r = Da(), { user: n } = As(), [a, s] = Me(0), [i, o] = Me({}), [l, c] = Me(null), [u, d] = Me(!0), f = ui();
  wt(() => {
    var g;
    if (!n) return;
    const p = { kyc: n.kyc ?? null, isActive: n.isActive }, m = e.steps.findIndex(
      (y) => {
        var x;
        return !((x = y.shouldSkip) != null && x.call(y, p));
      }
    );
    if (m === -1) {
      (g = e.onComplete) == null || g.call(e);
      return;
    }
    s(m), d(!1);
  }, [n, e]);
  const h = Ft(
    async (p) => {
      var m;
      d(!0);
      try {
        if (e.steps[a].id === "userInfo" && p && "kind" in p) {
          const g = {
            ...p,
            kyc: f.KYC_PROVIDER
          };
          await e.apiOperations.initializeUser(g);
        }
        o((g) => ({ ...g, ...p })), a < e.steps.length - 1 ? s((g) => g + 1) : (m = e.onComplete) == null || m.call(e);
      } catch (g) {
        c(g), r.error(t("auth.error.generic"));
      } finally {
        d(!1);
      }
    },
    [a, e, r, t, f]
  );
  return {
    currentStep: a,
    handleSubmit: h,
    handleSkip: e.allowSkip ? () => {
      var m;
      const p = a + 1;
      p >= e.steps.length ? (m = e.onComplete) == null || m.call(e) : s(p);
    } : void 0,
    stepData: i,
    error: l,
    isLoading: u
  };
}
const Wx = (e = {}) => {
  const t = sn(), [r, n] = Me(null), [a, s] = Me(!0), i = Ft(async () => {
    var l, c, u, d, f, h, p;
    try {
      s(!0);
      const [m, g, y] = await Promise.all([
        t.dataApi.data({ kind: "faq", limit: 1e3 }),
        t.dataApi.data({ kind: "contact" }),
        t.dataApi.data({ kind: "dashboard_info" })
      ]);
      let x;
      e.includeAdminConfig && (x = await t.adminApi.config());
      const w = ((c = (l = y == null ? void 0 : y.find(
        (_) => _.data.key === "topbanner_content"
      )) == null ? void 0 : l.data) == null ? void 0 : c.value) || {
        color: "",
        icon: "",
        route: "",
        content: ""
      };
      n({
        faq: (m || []).map((_) => {
          var S;
          return {
            id: ((S = _.id) == null ? void 0 : S.toString()) ?? "",
            title: typeof _.data.value == "object" ? _.data.value.title : "",
            description: typeof _.data.value == "object" ? _.data.value.description : ""
          };
        }),
        contact: {
          email: e.includeAdminConfig ? ((d = (u = x == null ? void 0 : x.email) == null ? void 0 : u.sendgrid) == null ? void 0 : d.dst) || "" : ((f = g == null ? void 0 : g.find((_) => _.data.key === "email")) == null ? void 0 : f.data.value) || "",
          link: ((h = g == null ? void 0 : g.find((_) => _.data.key === "link")) == null ? void 0 : h.data.value) || "",
          registrationLink: ((p = g == null ? void 0 : g.find((_) => _.data.key === "registrationLink")) == null ? void 0 : p.data.value) || ""
        },
        dashboardInfo: {
          topbanner_content: w
        }
      });
    } catch (m) {
      console.error("Error fetching data:", m);
    } finally {
      s(!1);
    }
  }, [t, e.includeAdminConfig]), o = Ft(
    async (l, c) => {
      var u, d;
      try {
        s(!0);
        const f = [];
        if (l === "faq") {
          const h = await t.dataApi.data({
            kind: "faq",
            limit: 1e3
          }), p = new Map(
            h.map((S) => {
              var C;
              return [((C = S.id) == null ? void 0 : C.toString()) ?? "", S];
            })
          ), m = new Set(p.keys()), g = c.map((S) => {
            var C, E;
            return {
              id: (C = S.id) == null ? void 0 : C.toString(),
              title: ((E = S.title) == null ? void 0 : E.value) || S.title || "",
              description: S.description || ""
            };
          }), y = new Set(
            g.map((S) => S.id).filter(Boolean)
          ), w = [...m].filter(
            (S) => S && !y.has(S)
          ).map(
            (S) => t.dataApi.deleteData({ id: parseInt(S, 10) })
          );
          await Promise.all(w);
          const _ = [];
          for (const S of g) {
            const C = {
              key: "faq_item",
              value: {
                title: S.title,
                description: S.description
              }
            };
            if (S.id && m.has(S.id)) {
              const E = (d = (u = p.get(S.id)) == null ? void 0 : u.data) == null ? void 0 : d.value;
              ((E == null ? void 0 : E.title) !== S.title || (E == null ? void 0 : E.description) !== S.description) && _.push(
                t.dataApi.updateData({
                  id: parseInt(S.id, 10),
                  addDataRequest: { kind: "faq", data: C }
                })
              );
            } else
              (!S.id || !m.has(S.id)) && _.push(
                t.dataApi.addData({
                  addDataRequest: { kind: "faq", data: C }
                })
              );
          }
          await Promise.all(_);
        } else if (l === "contact") {
          const h = await t.dataApi.data({ kind: "contact" }) || [], p = [
            { key: "email", value: c.email },
            { key: "link", value: c.link },
            { key: "registrationLink", value: c.registrationLink }
          ];
          for (const { key: m, value: g } of p)
            if (g != null) {
              const y = h.find(
                (w) => {
                  var _;
                  return ((_ = w.data) == null ? void 0 : _.key) === m && w.kind === "contact";
                }
              ), x = { key: m, value: g };
              y != null && y.id ? f.push(
                t.dataApi.updateData({
                  id: y.id,
                  addDataRequest: { kind: "contact", data: x }
                })
              ) : g && f.push(
                t.dataApi.addData({
                  addDataRequest: { kind: "contact", data: x }
                })
              );
            }
          await Promise.all(f);
        } else if (l === "dashboard_info") {
          const p = (await t.dataApi.data({ kind: "dashboard_info" }) || []).find(
            (y) => {
              var x;
              return ((x = y.data) == null ? void 0 : x.key) === "topbanner_content";
            }
          ), m = {
            key: "topbanner_content",
            value: c.topbanner_content
          };
          await (p != null && p.id ? t.dataApi.updateData({
            id: p.id,
            addDataRequest: {
              kind: "dashboard_info",
              data: m
            }
          }) : t.dataApi.addData({
            addDataRequest: {
              kind: "dashboard_info",
              data: m
            }
          }));
        }
        await i();
      } catch (f) {
        throw console.error("Error in updateData:", f), f;
      } finally {
        s(!1);
      }
    },
    [t, i]
  );
  return wt(() => {
    i();
  }, [i]), { data: r, loading: a, updateData: o };
}, i$e = () => {
  var n;
  const { data: e, loading: t } = Wx(), r = (n = e == null ? void 0 : e.contact) == null ? void 0 : n.registrationLink;
  return {
    link: r || "/auth/register",
    isCustomLink: !!r,
    isLoading: t
  };
};
function zx({
  className: e = ""
}) {
  const { t } = _t(["auth"]), {
    link: r,
    isCustomLink: n,
    isLoading: a
  } = i$e();
  return a ? /* @__PURE__ */ v.jsx(v.Fragment, {}) : n ? /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: `relative rounded-md bg-gray-100 px-4 py-3 flex items-center justify-center gap-1 text-gray-700 ${e}`,
      children: [
        /* @__PURE__ */ v.jsx("div", { className: "absolute left-4 top-1/2 -translate-y-1/2", children: /* @__PURE__ */ v.jsx(dt, { name: "arrow-right-circle", size: "lg" }) }),
        /* @__PURE__ */ v.jsxs("span", { className: "flex flex-col", children: [
          t("auth.login.noAccount"),
          " ",
          /* @__PURE__ */ v.jsx(
            Lo,
            {
              to: r,
              className: "font-medium text-gray-800 underline",
              target: "_blank",
              rel: "noopener noreferrer",
              children: t("auth.login.createAccount")
            }
          )
        ] })
      ]
    }
  ) : /* @__PURE__ */ v.jsxs("div", { className: `text-center ${e}`, children: [
    /* @__PURE__ */ v.jsxs("span", { className: "text-muted-foreground", children: [
      t("auth.login.dontHaveAccount"),
      " "
    ] }),
    /* @__PURE__ */ v.jsx(Lo, { to: r, className: "text-primary underline", children: t("auth.register.title") })
  ] });
}
function o$e() {
  const { t: e } = _t(["auth", "common"]), { resetPassword: t, isLoading: r } = As(), [n, a] = Me(!1), { handleError: s } = zc(), i = B.object({
    email: B.string().email(e("auth.invalidEmail")).min(1, e("auth.emailRequired"))
  }), o = [
    {
      title: e("auth.resetPassword.title"),
      fields: [
        {
          name: "email",
          label: e("auth.email"),
          type: "email",
          placeholder: e("auth.emailPlaceholder"),
          required: !0,
          labelProps: { position: "top" }
        }
      ]
    }
  ], l = async (c) => {
    try {
      await t(c.email), a(!0);
    } catch (u) {
      s(u);
    }
  };
  return n ? /* @__PURE__ */ v.jsx(
    Mo,
    {
      title: e("auth.resetPassword.checkEmail"),
      subtitle: e("auth.resetPassword.checkEmailDesc"),
      footer: /* @__PURE__ */ v.jsx("div", { className: "text-center text-sm", children: /* @__PURE__ */ v.jsx(Lo, { to: "/auth/login", className: "text-primary hover:underline", children: e("auth.resetPassword.backToLogin") }) }),
      children: /* @__PURE__ */ v.jsx(hr, { children: /* @__PURE__ */ v.jsx("p", { className: "text-center text-muted-foreground", children: e("auth.resetPassword.checkSpam") }) })
    }
  ) : /* @__PURE__ */ v.jsx(
    Mo,
    {
      title: e("auth.resetPassword.title"),
      subtitle: e("auth.resetPassword.subtitle"),
      footer: /* @__PURE__ */ v.jsxs("div", { className: "text-center text-sm", children: [
        /* @__PURE__ */ v.jsx(Lo, { to: "/auth/login", className: "text-primary hover:underline", children: e("auth.resetPassword.backToLogin") }),
        /* @__PURE__ */ v.jsx(zx, { className: "mt-4" })
      ] }),
      children: /* @__PURE__ */ v.jsx(
        Uo,
        {
          sections: o,
          validationSchema: i,
          onSubmit: l,
          formLayout: "single-page",
          layout: { type: "flex", className: "space-y-6" },
          defaultValues: {
            email: ""
          }
        }
      )
    }
  );
}
function l$e() {
  const e = ta(), { login: t, isOnboardingEnabled: r } = As(), { t: n } = _t(["auth", "common"]), { handleError: a } = zc(), s = B.object({
    email: B.string().email(n("auth.invalidEmail")).min(1, n("auth.emailRequired")),
    password: B.string().min(1, n("auth.passwordRequired")).min(8, n("auth.passwordMinLength"))
  }), i = [
    {
      title: n("auth.login.title"),
      fields: [
        {
          name: "email",
          label: n("auth.email"),
          type: "email",
          placeholder: n("auth.emailPlaceholder"),
          required: !0,
          labelProps: { position: "top" },
          inputProps: { autoComplete: "username" }
        },
        {
          name: "password",
          label: n("auth.password"),
          type: "password",
          placeholder: n("auth.passwordPlaceholder"),
          required: !0,
          labelProps: { position: "top" },
          inputProps: { autoComplete: "current-password" }
        }
      ]
    }
  ], o = async (l) => {
    var c;
    try {
      const u = await t({
        email: l.email,
        password: l.password
      });
      (c = u.data) != null && c.user && (!u.data.user.isActive && r ? e("/onboarding") : u.data.user.isActive && e("/projects"));
    } catch (u) {
      a(u);
    }
  };
  return /* @__PURE__ */ v.jsx(
    Mo,
    {
      title: n("auth.login.title"),
      subtitle: n("auth.login.subtitle"),
      footer: /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col space-y-4 text-sm text-center", children: [
        /* @__PURE__ */ v.jsx(
          Lo,
          {
            to: "/auth/forgot-password",
            className: "text-primary hover:underline",
            children: n("auth.login.forgotPassword")
          }
        ),
        /* @__PURE__ */ v.jsx(zx, {})
      ] }),
      children: /* @__PURE__ */ v.jsx(
        Uo,
        {
          sections: i,
          validationSchema: s,
          onSubmit: o,
          formLayout: "single-page",
          layout: { type: "flex", className: "space-y-4" },
          defaultValues: {
            email: "",
            password: ""
          }
        }
      )
    }
  );
}
function c$e() {
  const { user: e, isLoading: t } = As(), r = sn(), { t: n } = _t(["auth"]), a = Tn(
    () => GFe(r, n),
    [r, n]
  );
  if (t || !e)
    return /* @__PURE__ */ v.jsx(la, { container: "screen" });
  const { currentStep: s, handleSubmit: i, handleSkip: o, stepData: l, error: c, isLoading: u } = s$e(a);
  if (u)
    return /* @__PURE__ */ v.jsx(la, { container: "screen" });
  const d = a.steps[s].component;
  return /* @__PURE__ */ v.jsx(
    d,
    {
      onSubmit: i,
      onSkip: o,
      defaultValues: l,
      error: c || void 0
    }
  );
}
function u$e() {
  const { register: e, sendVerificationEmail: t } = As(), { t: r } = _t(["auth", "common"]), [n, a] = Me(!1), [s, i] = Me(null), { handleError: o } = zc(), l = Da(), c = new ed(), [u] = AT(), d = u.get("email"), f = async (m) => {
    try {
      await si.getInstance().clearTokens(), await e({
        email: m.email,
        password: m.password
      }), i({ email: m.email }), a(!0);
    } catch (g) {
      const y = c.adaptError(g);
      y.category === dn.NETWORK ? l.error(
        r(
          y.translationKey ? `common:${y.translationKey}` : "common:errors.network.unknown"
        ),
        {
          action: y.code === Xn.NETWORK_OFFLINE ? {
            label: r("common.retry"),
            onClick: () => f(m)
          } : void 0
        }
      ) : o(y);
    }
  }, h = B.object({
    email: B.string().email(r("auth.invalidEmail")).min(1, r("auth.emailRequired")),
    password: B.string().min(1, r("auth.passwordRequired")).min(8, r("auth.passwordComplexity.minLength")).regex(/^(?=.*[a-z])/, r("auth.passwordComplexity.lowercase")).regex(/^(?=.*[A-Z])/, r("auth.passwordComplexity.uppercase")).regex(/^(?=.*\d)/, r("auth.passwordComplexity.number")),
    confirmPassword: B.string().min(1, r("auth.confirmPasswordRequired"))
  }).refine((m) => m.password === m.confirmPassword, {
    message: r("auth.passwordsMustMatch"),
    path: ["confirmPassword"]
  }), p = [
    {
      title: r("auth.register.title"),
      fields: [
        {
          name: "email",
          label: r("auth.email"),
          type: "email",
          placeholder: r("auth.emailPlaceholder"),
          required: !0,
          disabled: !!d
        },
        {
          name: "password",
          label: r("auth.password"),
          type: "password",
          placeholder: r("auth.passwordPlaceholder"),
          required: !0,
          labelProps: { position: "top" }
        },
        {
          name: "confirmPassword",
          label: r("auth.confirmPassword"),
          type: "password",
          placeholder: r("auth.confirmPasswordPlaceholder"),
          required: !0,
          labelProps: { position: "top" }
        }
      ]
    }
  ];
  return n ? /* @__PURE__ */ v.jsx(
    Mo,
    {
      title: r("auth.register.checkEmail"),
      subtitle: r("auth.register.checkEmailDesc"),
      footer: /* @__PURE__ */ v.jsxs("div", { className: "text-center text-sm space-y-4", children: [
        /* @__PURE__ */ v.jsx(
          qe,
          {
            variant: "outline",
            size: "sm",
            onClick: async () => {
              try {
                await t(), l.success(r("auth.verifyEmail.resendSuccess"));
              } catch (m) {
                o(m);
              }
            },
            children: r("auth.verifyEmail.resend")
          }
        ),
        /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsx(Lo, { to: "/auth/login", className: "text-primary hover:underline", children: r("auth.register.backToLogin") }) })
      ] }),
      children: /* @__PURE__ */ v.jsx(hr, { children: /* @__PURE__ */ v.jsxs("div", { className: "space-y-4", children: [
        /* @__PURE__ */ v.jsx("span", { className: "text-xl font-medium block text-center text-blue-600 dark:text-blue-400", children: s == null ? void 0 : s.email }),
        /* @__PURE__ */ v.jsx("p", { className: "text-center text-muted-foreground", children: r("auth.register.checkSpam") })
      ] }) })
    }
  ) : /* @__PURE__ */ v.jsx(
    Mo,
    {
      title: r("auth.register.title"),
      subtitle: r("auth.register.subtitle"),
      footer: /* @__PURE__ */ v.jsxs("div", { className: "text-center text-sm", children: [
        /* @__PURE__ */ v.jsxs("span", { className: "text-muted-foreground", children: [
          r("auth.register.alreadyHaveAccount"),
          " "
        ] }),
        /* @__PURE__ */ v.jsx(Lo, { to: "/auth/login", className: "text-primary hover:underline", children: r("auth.login.title") })
      ] }),
      children: /* @__PURE__ */ v.jsx(
        Uo,
        {
          sections: p,
          validationSchema: h,
          onSubmit: f,
          formLayout: "single-page",
          layout: { type: "flex", className: "space-y-6" },
          defaultValues: {
            email: d || "",
            password: "",
            confirmPassword: ""
          }
        }
      )
    }
  );
}
function d$e() {
  const [e] = AT();
  ta();
  const { t } = _t(["auth", "common"]), { confirmResetPassword: r } = As(), [n, a] = Me(!1), { handleError: s } = zc(), i = e.get("token");
  if (!i)
    return /* @__PURE__ */ v.jsx(
      Mo,
      {
        title: t("auth.resetPassword.error"),
        subtitle: t("auth.resetPassword.invalidToken"),
        children: /* @__PURE__ */ v.jsx(hr, { children: /* @__PURE__ */ v.jsx("div", { className: "text-center text-red-500", children: t("auth.resetPassword.invalidToken") }) })
      }
    );
  const o = B.object({
    password: B.string().min(1, t("auth.passwordRequired")).min(8, t("auth.passwordComplexity.minLength")).regex(/^(?=.*[a-z])/, t("auth.passwordComplexity.lowercase")).regex(/^(?=.*[A-Z])/, t("auth.passwordComplexity.uppercase")).regex(/^(?=.*\d)/, t("auth.passwordComplexity.number")),
    confirmPassword: B.string().min(1, t("auth.confirmPasswordRequired"))
  }).refine((u) => u.password === u.confirmPassword, {
    message: t("auth.passwordsMustMatch"),
    path: ["confirmPassword"]
  }), l = [
    {
      title: t("auth.resetPassword.title"),
      fields: [
        {
          name: "password",
          label: t("auth.password"),
          type: "password",
          placeholder: t("auth.passwordPlaceholder"),
          required: !0,
          labelProps: { position: "top" }
        },
        {
          name: "confirmPassword",
          label: t("auth.confirmPassword"),
          type: "password",
          placeholder: t("auth.confirmPasswordPlaceholder"),
          required: !0,
          labelProps: { position: "top" }
        }
      ]
    }
  ], c = async (u) => {
    try {
      await r(i, u.password), a(!0);
    } catch (d) {
      s(d);
    }
  };
  return n ? /* @__PURE__ */ v.jsx(
    Mo,
    {
      title: t("auth.resetPassword.success"),
      subtitle: t("auth.resetPassword.successDesc"),
      footer: /* @__PURE__ */ v.jsx("div", { className: "text-center text-sm", children: /* @__PURE__ */ v.jsx(Lo, { to: "/auth/login", className: "text-primary hover:underline", children: t("auth.resetPassword.backToLogin") }) }),
      children: /* @__PURE__ */ v.jsx(hr, { children: /* @__PURE__ */ v.jsx("p", { className: "text-center text-muted-foreground", children: t("auth.resetPassword.successMessage") }) })
    }
  ) : /* @__PURE__ */ v.jsx(
    Mo,
    {
      title: t("auth.resetPassword.title"),
      subtitle: t("auth.resetPassword.subtitle"),
      footer: /* @__PURE__ */ v.jsxs("div", { className: "text-center text-sm", children: [
        /* @__PURE__ */ v.jsx(Lo, { to: "/auth/login", className: "text-primary hover:underline", children: t("auth.resetPassword.backToLogin") }),
        /* @__PURE__ */ v.jsx(zx, { className: "mt-4" })
      ] }),
      children: /* @__PURE__ */ v.jsx(
        Uo,
        {
          sections: l,
          validationSchema: o,
          onSubmit: c,
          formLayout: "single-page",
          layout: { type: "flex", className: "space-y-6" },
          defaultValues: {
            password: "",
            confirmPassword: ""
          }
        }
      )
    }
  );
}
function f$e() {
  const [e] = AT(), t = ta(), { verifyEmail: r, sendVerificationEmail: n, isOnboardingEnabled: a } = As(), { t: s } = _t(["auth", "common"]), [i, o] = Me(!0), [l, c] = Me(null), [u, d] = Me(!1), [f, h] = Me(!1), p = Da(), { handleError: m } = zc(), g = async () => {
    try {
      h(!0), await n(), p.success(s("auth.verifyEmail.resendSuccess"));
    } catch (y) {
      if ((y == null ? void 0 : y.status) === "EMAIL_ALREADY_VERIFIED_ERROR") {
        p.success(s("auth.verifyEmail.alreadyVerified")), t(a ? "/onboarding" : "/projects");
        return;
      }
      m(y);
    } finally {
      h(!1);
    }
  };
  return wt(() => {
    const y = e.get("token");
    if (!y) {
      c(s("auth.verifyEmail.noToken")), o(!1), d(!0);
      return;
    }
    u || r(y).then(() => {
      t(a ? "/onboarding" : "/projects");
    }).catch((x) => {
      c(x.message), o(!1);
    }).finally(() => {
      d(!0);
    });
  }, [
    e,
    r,
    t,
    a,
    u,
    s
  ]), i ? /* @__PURE__ */ v.jsx(
    Mo,
    {
      title: s("auth.verifyEmail.verifying"),
      subtitle: s("auth.verifyEmail.pleaseWait"),
      children: /* @__PURE__ */ v.jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ v.jsx(la, {}) })
    }
  ) : l ? /* @__PURE__ */ v.jsx(Mo, { title: s("auth.verifyEmail.error"), children: /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center space-y-4", children: [
    /* @__PURE__ */ v.jsx(hr, { children: /* @__PURE__ */ v.jsx("div", { className: "text-center text-red-500", children: l }) }),
    /* @__PURE__ */ v.jsxs(
      qe,
      {
        variant: "outline",
        onClick: g,
        disabled: f,
        children: [
          f ? /* @__PURE__ */ v.jsx(la, { className: "w-4 h-4 mr-2" }) : null,
          s("auth.verifyEmail.resend")
        ]
      }
    ),
    /* @__PURE__ */ v.jsx(zx, {})
  ] }) }) : null;
}
const Xt = (e) => typeof e == "string", Vp = () => {
  let e, t;
  const r = new Promise((n, a) => {
    e = n, t = a;
  });
  return r.resolve = e, r.reject = t, r;
}, hj = (e) => e == null ? "" : "" + e, h$e = (e, t, r) => {
  e.forEach((n) => {
    t[n] && (r[n] = t[n]);
  });
}, p$e = /###/g, pj = (e) => e && e.indexOf("###") > -1 ? e.replace(p$e, ".") : e, mj = (e) => !e || Xt(e), Tm = (e, t, r) => {
  const n = Xt(t) ? t.split(".") : t;
  let a = 0;
  for (; a < n.length - 1; ) {
    if (mj(e)) return {};
    const s = pj(n[a]);
    !e[s] && r && (e[s] = new r()), Object.prototype.hasOwnProperty.call(e, s) ? e = e[s] : e = {}, ++a;
  }
  return mj(e) ? {} : {
    obj: e,
    k: pj(n[a])
  };
}, gj = (e, t, r) => {
  const {
    obj: n,
    k: a
  } = Tm(e, t, Object);
  if (n !== void 0 || t.length === 1) {
    n[a] = r;
    return;
  }
  let s = t[t.length - 1], i = t.slice(0, t.length - 1), o = Tm(e, i, Object);
  for (; o.obj === void 0 && i.length; )
    s = `${i[i.length - 1]}.${s}`, i = i.slice(0, i.length - 1), o = Tm(e, i, Object), o && o.obj && typeof o.obj[`${o.k}.${s}`] < "u" && (o.obj = void 0);
  o.obj[`${o.k}.${s}`] = r;
}, m$e = (e, t, r, n) => {
  const {
    obj: a,
    k: s
  } = Tm(e, t, Object);
  a[s] = a[s] || [], a[s].push(r);
}, Xb = (e, t) => {
  const {
    obj: r,
    k: n
  } = Tm(e, t);
  if (r)
    return r[n];
}, g$e = (e, t, r) => {
  const n = Xb(e, r);
  return n !== void 0 ? n : Xb(t, r);
}, K8 = (e, t, r) => {
  for (const n in t)
    n !== "__proto__" && n !== "constructor" && (n in e ? Xt(e[n]) || e[n] instanceof String || Xt(t[n]) || t[n] instanceof String ? r && (e[n] = t[n]) : K8(e[n], t[n], r) : e[n] = t[n]);
  return e;
}, Jd = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var v$e = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const y$e = (e) => Xt(e) ? e.replace(/[&<>"'\/]/g, (t) => v$e[t]) : e;
class b$e {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const r = this.regExpMap.get(t);
    if (r !== void 0)
      return r;
    const n = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, n), this.regExpQueue.push(t), n;
  }
}
const w$e = [" ", ",", "?", "!", ";"], x$e = new b$e(20), _$e = (e, t, r) => {
  t = t || "", r = r || "";
  const n = w$e.filter((i) => t.indexOf(i) < 0 && r.indexOf(i) < 0);
  if (n.length === 0) return !0;
  const a = x$e.getRegExp(`(${n.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let s = !a.test(e);
  if (!s) {
    const i = e.indexOf(r);
    i > 0 && !a.test(e.substring(0, i)) && (s = !0);
  }
  return s;
}, pT = function(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e) return;
  if (e[t]) return e[t];
  const n = t.split(r);
  let a = e;
  for (let s = 0; s < n.length; ) {
    if (!a || typeof a != "object")
      return;
    let i, o = "";
    for (let l = s; l < n.length; ++l)
      if (l !== s && (o += r), o += n[l], i = a[o], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < n.length - 1)
          continue;
        s += l - s + 1;
        break;
      }
    a = i;
  }
  return a;
}, Qb = (e) => e && e.replace("_", "-"), S$e = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class Jb {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, r);
  }
  init(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = r.prefix || "i18next:", this.logger = t || S$e, this.options = r, this.debug = r.debug;
  }
  log() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    return this.forward(r, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    return this.forward(r, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    return this.forward(r, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    return this.forward(r, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, r, n, a) {
    return a && !this.debug ? null : (Xt(t[0]) && (t[0] = `${n}${this.prefix} ${t[0]}`), this.logger[r](t));
  }
  create(t) {
    return new Jb(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Jb(this.logger, t);
  }
}
var Co = new Jb();
class Kx {
  constructor() {
    this.observers = {};
  }
  on(t, r) {
    return t.split(" ").forEach((n) => {
      this.observers[n] || (this.observers[n] = /* @__PURE__ */ new Map());
      const a = this.observers[n].get(r) || 0;
      this.observers[n].set(r, a + 1);
    }), this;
  }
  off(t, r) {
    if (this.observers[t]) {
      if (!r) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(r);
    }
  }
  emit(t) {
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      n[a - 1] = arguments[a];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((i) => {
      let [o, l] = i;
      for (let c = 0; c < l; c++)
        o(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((i) => {
      let [o, l] = i;
      for (let c = 0; c < l; c++)
        o.apply(o, [t, ...n]);
    });
  }
}
class vj extends Kx {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const r = this.options.ns.indexOf(t);
    r > -1 && this.options.ns.splice(r, 1);
  }
  getResource(t, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const s = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, i = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let o;
    t.indexOf(".") > -1 ? o = t.split(".") : (o = [t, r], n && (Array.isArray(n) ? o.push(...n) : Xt(n) && s ? o.push(...n.split(s)) : o.push(n)));
    const l = Xb(this.data, o);
    return !l && !r && !n && t.indexOf(".") > -1 && (t = o[0], r = o[1], n = o.slice(2).join(".")), l || !i || !Xt(n) ? l : pT(this.data && this.data[t] && this.data[t][r], n, s);
  }
  addResource(t, r, n, a) {
    let s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const i = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator;
    let o = [t, r];
    n && (o = o.concat(i ? n.split(i) : n)), t.indexOf(".") > -1 && (o = t.split("."), a = r, r = o[1]), this.addNamespaces(r), gj(this.data, o, a), s.silent || this.emit("added", t, r, n, a);
  }
  addResources(t, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const s in n)
      (Xt(n[s]) || Array.isArray(n[s])) && this.addResource(t, r, s, n[s], {
        silent: !0
      });
    a.silent || this.emit("added", t, r, n);
  }
  addResourceBundle(t, r, n, a, s) {
    let i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, o = [t, r];
    t.indexOf(".") > -1 && (o = t.split("."), a = n, n = r, r = o[1]), this.addNamespaces(r);
    let l = Xb(this.data, o) || {};
    i.skipCopy || (n = JSON.parse(JSON.stringify(n))), a ? K8(l, n, s) : l = {
      ...l,
      ...n
    }, gj(this.data, o, l), i.silent || this.emit("added", t, r, n);
  }
  removeResourceBundle(t, r) {
    this.hasResourceBundle(t, r) && delete this.data[t][r], this.removeNamespaces(r), this.emit("removed", t, r);
  }
  hasResourceBundle(t, r) {
    return this.getResource(t, r) !== void 0;
  }
  getResourceBundle(t, r) {
    return r || (r = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, r)
    } : this.getResource(t, r);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const r = this.getDataByLanguage(t);
    return !!(r && Object.keys(r) || []).find((a) => r[a] && Object.keys(r[a]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var q8 = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, r, n, a) {
    return e.forEach((s) => {
      this.processors[s] && (t = this.processors[s].process(t, r, n, a));
    }), t;
  }
};
const yj = {};
class Zb extends Kx {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), h$e(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Co.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const n = this.resolve(t, r);
    return n && n.res !== void 0;
  }
  extractFromKey(t, r) {
    let n = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
    n === void 0 && (n = ":");
    const a = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let s = r.ns || this.options.defaultNS || [];
    const i = n && t.indexOf(n) > -1, o = !this.options.userDefinedKeySeparator && !r.keySeparator && !this.options.userDefinedNsSeparator && !r.nsSeparator && !_$e(t, n, a);
    if (i && !o) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: Xt(s) ? [s] : s
        };
      const c = t.split(n);
      (n !== a || n === a && this.options.ns.indexOf(c[0]) > -1) && (s = c.shift()), t = c.join(a);
    }
    return {
      key: t,
      namespaces: Xt(s) ? [s] : s
    };
  }
  translate(t, r, n) {
    if (typeof r != "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), typeof r == "object" && (r = {
      ...r
    }), r || (r = {}), t == null) return "";
    Array.isArray(t) || (t = [String(t)]);
    const a = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails, s = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, {
      key: i,
      namespaces: o
    } = this.extractFromKey(t[t.length - 1], r), l = o[o.length - 1], c = r.lng || this.language, u = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const _ = r.nsSeparator || this.options.nsSeparator;
        return a ? {
          res: `${l}${_}${i}`,
          usedKey: i,
          exactUsedKey: i,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(r)
        } : `${l}${_}${i}`;
      }
      return a ? {
        res: i,
        usedKey: i,
        exactUsedKey: i,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(r)
      } : i;
    }
    const d = this.resolve(t, r);
    let f = d && d.res;
    const h = d && d.usedKey || i, p = d && d.exactUsedKey || i, m = Object.prototype.toString.apply(f), g = ["[object Number]", "[object Function]", "[object RegExp]"], y = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays, x = !this.i18nFormat || this.i18nFormat.handleAsObject, w = !Xt(f) && typeof f != "boolean" && typeof f != "number";
    if (x && f && w && g.indexOf(m) < 0 && !(Xt(y) && Array.isArray(f))) {
      if (!r.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const _ = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, f, {
          ...r,
          ns: o
        }) : `key '${i} (${this.language})' returned an object instead of string.`;
        return a ? (d.res = _, d.usedParams = this.getUsedParamsDetails(r), d) : _;
      }
      if (s) {
        const _ = Array.isArray(f), S = _ ? [] : {}, C = _ ? p : h;
        for (const E in f)
          if (Object.prototype.hasOwnProperty.call(f, E)) {
            const O = `${C}${s}${E}`;
            S[E] = this.translate(O, {
              ...r,
              joinArrays: !1,
              ns: o
            }), S[E] === O && (S[E] = f[E]);
          }
        f = S;
      }
    } else if (x && Xt(y) && Array.isArray(f))
      f = f.join(y), f && (f = this.extendTranslation(f, t, r, n));
    else {
      let _ = !1, S = !1;
      const C = r.count !== void 0 && !Xt(r.count), E = Zb.hasDefaultValue(r), O = C ? this.pluralResolver.getSuffix(c, r.count, r) : "", k = r.ordinal && C ? this.pluralResolver.getSuffix(c, r.count, {
        ordinal: !1
      }) : "", A = C && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), P = A && r[`defaultValue${this.options.pluralSeparator}zero`] || r[`defaultValue${O}`] || r[`defaultValue${k}`] || r.defaultValue;
      !this.isValidLookup(f) && E && (_ = !0, f = P), this.isValidLookup(f) || (S = !0, f = i);
      const N = (r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && S ? void 0 : f, z = E && P !== f && this.options.updateMissing;
      if (S || _ || z) {
        if (this.logger.log(z ? "updateKey" : "missingKey", c, l, i, z ? P : f), s) {
          const ae = this.resolve(i, {
            ...r,
            keySeparator: !1
          });
          ae && ae.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let G = [];
        const Y = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Y && Y[0])
          for (let ae = 0; ae < Y.length; ae++)
            G.push(Y[ae]);
        else this.options.saveMissingTo === "all" ? G = this.languageUtils.toResolveHierarchy(r.lng || this.language) : G.push(r.lng || this.language);
        const te = (ae, ne, ue) => {
          const q = E && ue !== f ? ue : N;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(ae, l, ne, q, z, r) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(ae, l, ne, q, z, r), this.emit("missingKey", ae, l, ne, f);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && C ? G.forEach((ae) => {
          const ne = this.pluralResolver.getSuffixes(ae, r);
          A && r[`defaultValue${this.options.pluralSeparator}zero`] && ne.indexOf(`${this.options.pluralSeparator}zero`) < 0 && ne.push(`${this.options.pluralSeparator}zero`), ne.forEach((ue) => {
            te([ae], i + ue, r[`defaultValue${ue}`] || P);
          });
        }) : te(G, i, P));
      }
      f = this.extendTranslation(f, t, r, d, n), S && f === i && this.options.appendNamespaceToMissingKey && (f = `${l}:${i}`), (S || _) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${i}` : i, _ ? f : void 0) : f = this.options.parseMissingKeyHandler(f));
    }
    return a ? (d.res = f, d.usedParams = this.getUsedParamsDetails(r), d) : f;
  }
  extendTranslation(t, r, n, a, s) {
    var i = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...n
      }, n.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!n.skipInterpolation) {
      n.interpolation && this.interpolator.init({
        ...n,
        interpolation: {
          ...this.options.interpolation,
          ...n.interpolation
        }
      });
      const c = Xt(t) && (n && n.interpolation && n.interpolation.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const f = t.match(this.interpolator.nestingRegexp);
        u = f && f.length;
      }
      let d = n.replace && !Xt(n.replace) ? n.replace : n;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), t = this.interpolator.interpolate(t, d, n.lng || this.language || a.usedLng, n), c) {
        const f = t.match(this.interpolator.nestingRegexp), h = f && f.length;
        u < h && (n.nest = !1);
      }
      !n.lng && this.options.compatibilityAPI !== "v1" && a && a.res && (n.lng = this.language || a.usedLng), n.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var f = arguments.length, h = new Array(f), p = 0; p < f; p++)
          h[p] = arguments[p];
        return s && s[0] === h[0] && !n.context ? (i.logger.warn(`It seems you are nesting recursively key: ${h[0]} in key: ${r[0]}`), null) : i.translate(...h, r);
      }, n)), n.interpolation && this.interpolator.reset();
    }
    const o = n.postProcess || this.options.postProcess, l = Xt(o) ? [o] : o;
    return t != null && l && l.length && n.applyPostProcessor !== !1 && (t = q8.handle(l, t, r, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(n)
      },
      ...n
    } : n, this)), t;
  }
  resolve(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n, a, s, i, o;
    return Xt(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(n)) return;
      const c = this.extractFromKey(l, r), u = c.key;
      a = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const f = r.count !== void 0 && !Xt(r.count), h = f && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), p = r.context !== void 0 && (Xt(r.context) || typeof r.context == "number") && r.context !== "", m = r.lngs ? r.lngs : this.languageUtils.toResolveHierarchy(r.lng || this.language, r.fallbackLng);
      d.forEach((g) => {
        this.isValidLookup(n) || (o = g, !yj[`${m[0]}-${g}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(o) && (yj[`${m[0]}-${g}`] = !0, this.logger.warn(`key "${a}" for languages "${m.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), m.forEach((y) => {
          if (this.isValidLookup(n)) return;
          i = y;
          const x = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(x, u, y, g, r);
          else {
            let _;
            f && (_ = this.pluralResolver.getSuffix(y, r.count, r));
            const S = `${this.options.pluralSeparator}zero`, C = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (f && (x.push(u + _), r.ordinal && _.indexOf(C) === 0 && x.push(u + _.replace(C, this.options.pluralSeparator)), h && x.push(u + S)), p) {
              const E = `${u}${this.options.contextSeparator}${r.context}`;
              x.push(E), f && (x.push(E + _), r.ordinal && _.indexOf(C) === 0 && x.push(E + _.replace(C, this.options.pluralSeparator)), h && x.push(E + S));
            }
          }
          let w;
          for (; w = x.pop(); )
            this.isValidLookup(n) || (s = w, n = this.getResource(y, g, w, r));
        }));
      });
    }), {
      res: n,
      usedKey: a,
      exactUsedKey: s,
      usedLng: i,
      usedNS: o
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, r, n, a) : this.resourceStore.getResource(t, r, n, a);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const r = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], n = t.replace && !Xt(t.replace);
    let a = n ? t.replace : t;
    if (n && typeof t.count < "u" && (a.count = t.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !n) {
      a = {
        ...a
      };
      for (const s of r)
        delete a[s];
    }
    return a;
  }
  static hasDefaultValue(t) {
    const r = "defaultValue";
    for (const n in t)
      if (Object.prototype.hasOwnProperty.call(t, n) && r === n.substring(0, r.length) && t[n] !== void 0)
        return !0;
    return !1;
  }
}
const xS = (e) => e.charAt(0).toUpperCase() + e.slice(1);
class bj {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Co.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = Qb(t), !t || t.indexOf("-") < 0) return null;
    const r = t.split("-");
    return r.length === 2 || (r.pop(), r[r.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(r.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = Qb(t), !t || t.indexOf("-") < 0) return t;
    const r = t.split("-");
    return this.formatLanguageCode(r[0]);
  }
  formatLanguageCode(t) {
    if (Xt(t) && t.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let a = Intl.getCanonicalLocales(t)[0];
          if (a && this.options.lowerCaseLng && (a = a.toLowerCase()), a) return a;
        } catch {
        }
      const r = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let n = t.split("-");
      return this.options.lowerCaseLng ? n = n.map((a) => a.toLowerCase()) : n.length === 2 ? (n[0] = n[0].toLowerCase(), n[1] = n[1].toUpperCase(), r.indexOf(n[1].toLowerCase()) > -1 && (n[1] = xS(n[1].toLowerCase()))) : n.length === 3 && (n[0] = n[0].toLowerCase(), n[1].length === 2 && (n[1] = n[1].toUpperCase()), n[0] !== "sgn" && n[2].length === 2 && (n[2] = n[2].toUpperCase()), r.indexOf(n[1].toLowerCase()) > -1 && (n[1] = xS(n[1].toLowerCase())), r.indexOf(n[2].toLowerCase()) > -1 && (n[2] = xS(n[2].toLowerCase()))), n.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let r;
    return t.forEach((n) => {
      if (r) return;
      const a = this.formatLanguageCode(n);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (r = a);
    }), !r && this.options.supportedLngs && t.forEach((n) => {
      if (r) return;
      const a = this.getLanguagePartFromCode(n);
      if (this.isSupportedCode(a)) return r = a;
      r = this.options.supportedLngs.find((s) => {
        if (s === a) return s;
        if (!(s.indexOf("-") < 0 && a.indexOf("-") < 0) && (s.indexOf("-") > 0 && a.indexOf("-") < 0 && s.substring(0, s.indexOf("-")) === a || s.indexOf(a) === 0 && a.length > 1))
          return s;
      });
    }), r || (r = this.getFallbackCodes(this.options.fallbackLng)[0]), r;
  }
  getFallbackCodes(t, r) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(r)), Xt(t) && (t = [t]), Array.isArray(t)) return t;
    if (!r) return t.default || [];
    let n = t[r];
    return n || (n = t[this.getScriptPartFromCode(r)]), n || (n = t[this.formatLanguageCode(r)]), n || (n = t[this.getLanguagePartFromCode(r)]), n || (n = t.default), n || [];
  }
  toResolveHierarchy(t, r) {
    const n = this.getFallbackCodes(r || this.options.fallbackLng || [], t), a = [], s = (i) => {
      i && (this.isSupportedCode(i) ? a.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return Xt(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && s(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && s(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && s(this.getLanguagePartFromCode(t))) : Xt(t) && s(this.formatLanguageCode(t)), n.forEach((i) => {
      a.indexOf(i) < 0 && s(this.formatLanguageCode(i));
    }), a;
  }
}
let E$e = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], T$e = {
  1: (e) => +(e > 1),
  2: (e) => +(e != 1),
  3: (e) => 0,
  4: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  5: (e) => e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
  6: (e) => e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
  7: (e) => e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  8: (e) => e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
  9: (e) => +(e >= 2),
  10: (e) => e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
  11: (e) => e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
  12: (e) => +(e % 10 != 1 || e % 100 == 11),
  13: (e) => +(e !== 0),
  14: (e) => e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
  15: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  16: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
  17: (e) => e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
  18: (e) => e == 0 ? 0 : e == 1 ? 1 : 2,
  19: (e) => e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
  20: (e) => e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
  21: (e) => e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
  22: (e) => e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const C$e = ["v1", "v2", "v3"], k$e = ["v4"], wj = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, O$e = () => {
  const e = {};
  return E$e.forEach((t) => {
    t.lngs.forEach((r) => {
      e[r] = {
        numbers: t.nr,
        plurals: T$e[t.fc]
      };
    });
  }), e;
};
class A$e {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = r, this.logger = Co.create("pluralResolver"), (!this.options.compatibilityJSON || k$e.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = O$e(), this.pluralRulesCache = {};
  }
  addRule(t, r) {
    this.rules[t] = r;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const n = Qb(t === "dev" ? "en" : t), a = r.ordinal ? "ordinal" : "cardinal", s = JSON.stringify({
        cleanedCode: n,
        type: a
      });
      if (s in this.pluralRulesCache)
        return this.pluralRulesCache[s];
      let i;
      try {
        i = new Intl.PluralRules(n, {
          type: a
        });
      } catch {
        if (!t.match(/-|_/)) return;
        const l = this.languageUtils.getLanguagePartFromCode(t);
        i = this.getRule(l, r);
      }
      return this.pluralRulesCache[s] = i, i;
    }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(t, r);
    return this.shouldUseIntlApi() ? n && n.resolvedOptions().pluralCategories.length > 1 : n && n.numbers.length > 1;
  }
  getPluralFormsOfKey(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, n).map((a) => `${r}${a}`);
  }
  getSuffixes(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(t, r);
    return n ? this.shouldUseIntlApi() ? n.resolvedOptions().pluralCategories.sort((a, s) => wj[a] - wj[s]).map((a) => `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : n.numbers.map((a) => this.getSuffix(t, a, r)) : [];
  }
  getSuffix(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const a = this.getRule(t, n);
    return a ? this.shouldUseIntlApi() ? `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(r)}` : this.getSuffixRetroCompatible(a, r) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, r) {
    const n = t.noAbs ? t.plurals(r) : t.plurals(Math.abs(r));
    let a = t.numbers[n];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (a === 2 ? a = "plural" : a === 1 && (a = ""));
    const s = () => this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
    return this.options.compatibilityJSON === "v1" ? a === 1 ? "" : typeof a == "number" ? `_plural_${a.toString()}` : s() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? s() : this.options.prepend && n.toString() ? this.options.prepend + n.toString() : n.toString();
  }
  shouldUseIntlApi() {
    return !C$e.includes(this.options.compatibilityJSON);
  }
}
const xj = function(e, t, r) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, s = g$e(e, t, r);
  return !s && a && Xt(r) && (s = pT(e, r, n), s === void 0 && (s = pT(t, r, n))), s;
}, _S = (e) => e.replace(/\$/g, "$$$$");
class P$e {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Co.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((r) => r), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: r,
      escapeValue: n,
      useRawValueToEscape: a,
      prefix: s,
      prefixEscaped: i,
      suffix: o,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: f,
      nestingPrefixEscaped: h,
      nestingSuffix: p,
      nestingSuffixEscaped: m,
      nestingOptionsSeparator: g,
      maxReplaces: y,
      alwaysFormat: x
    } = t.interpolation;
    this.escape = r !== void 0 ? r : y$e, this.escapeValue = n !== void 0 ? n : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = s ? Jd(s) : i || "{{", this.suffix = o ? Jd(o) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = f ? Jd(f) : h || Jd("$t("), this.nestingSuffix = p ? Jd(p) : m || Jd(")"), this.nestingOptionsSeparator = g || ",", this.maxReplaces = y || 1e3, this.alwaysFormat = x !== void 0 ? x : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (r, n) => r && r.source === n ? (r.lastIndex = 0, r) : new RegExp(n, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, r, n, a) {
    let s, i, o;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (h) => {
      if (h.indexOf(this.formatSeparator) < 0) {
        const y = xj(r, l, h, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(y, void 0, n, {
          ...a,
          ...r,
          interpolationkey: h
        }) : y;
      }
      const p = h.split(this.formatSeparator), m = p.shift().trim(), g = p.join(this.formatSeparator).trim();
      return this.format(xj(r, l, m, this.options.keySeparator, this.options.ignoreJSONStructure), g, n, {
        ...a,
        ...r,
        interpolationkey: m
      });
    };
    this.resetRegExp();
    const u = a && a.missingInterpolationHandler || this.options.missingInterpolationHandler, d = a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (h) => _S(h)
    }, {
      regex: this.regexp,
      safeValue: (h) => this.escapeValue ? _S(this.escape(h)) : _S(h)
    }].forEach((h) => {
      for (o = 0; s = h.regex.exec(t); ) {
        const p = s[1].trim();
        if (i = c(p), i === void 0)
          if (typeof u == "function") {
            const g = u(t, s, a);
            i = Xt(g) ? g : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, p))
            i = "";
          else if (d) {
            i = s[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${p} for interpolating ${t}`), i = "";
        else !Xt(i) && !this.useRawValueToEscape && (i = hj(i));
        const m = h.safeValue(i);
        if (t = t.replace(s[0], m), d ? (h.regex.lastIndex += i.length, h.regex.lastIndex -= s[0].length) : h.regex.lastIndex = 0, o++, o >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, s, i;
    const o = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let f = `{${d[1]}`;
      l = d[0], f = this.interpolate(f, i);
      const h = f.match(/'/g), p = f.match(/"/g);
      (h && h.length % 2 === 0 && !p || p.length % 2 !== 0) && (f = f.replace(/'/g, '"'));
      try {
        i = JSON.parse(f), c && (i = {
          ...c,
          ...i
        });
      } catch (m) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, m), `${l}${u}${f}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; a = this.nestingRegexp.exec(t); ) {
      let l = [];
      i = {
        ...n
      }, i = i.replace && !Xt(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      let c = !1;
      if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
        const u = a[1].split(this.formatSeparator).map((d) => d.trim());
        a[1] = u.shift(), l = u, c = !0;
      }
      if (s = r(o.call(this, a[1].trim(), i), i), s && a[0] === t && !Xt(s)) return s;
      Xt(s) || (s = hj(s)), s || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${t}`), s = ""), c && (s = l.reduce((u, d) => this.format(u, d, n.lng, {
        ...n,
        interpolationkey: a[1].trim()
      }), s.trim())), t = t.replace(a[0], s), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const R$e = (e) => {
  let t = e.toLowerCase().trim();
  const r = {};
  if (e.indexOf("(") > -1) {
    const n = e.split("(");
    t = n[0].toLowerCase().trim();
    const a = n[1].substring(0, n[1].length - 1);
    t === "currency" && a.indexOf(":") < 0 ? r.currency || (r.currency = a.trim()) : t === "relativetime" && a.indexOf(":") < 0 ? r.range || (r.range = a.trim()) : a.split(";").forEach((i) => {
      if (i) {
        const [o, ...l] = i.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = o.trim();
        r[u] || (r[u] = c), c === "false" && (r[u] = !1), c === "true" && (r[u] = !0), isNaN(c) || (r[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: r
  };
}, Zd = (e) => {
  const t = {};
  return (r, n, a) => {
    let s = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (s = {
      ...s,
      [a.interpolationkey]: void 0
    });
    const i = n + JSON.stringify(s);
    let o = t[i];
    return o || (o = e(Qb(n), a), t[i] = o), o(r);
  };
};
class I$e {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Co.create("formatter"), this.options = t, this.formats = {
      number: Zd((r, n) => {
        const a = new Intl.NumberFormat(r, {
          ...n
        });
        return (s) => a.format(s);
      }),
      currency: Zd((r, n) => {
        const a = new Intl.NumberFormat(r, {
          ...n,
          style: "currency"
        });
        return (s) => a.format(s);
      }),
      datetime: Zd((r, n) => {
        const a = new Intl.DateTimeFormat(r, {
          ...n
        });
        return (s) => a.format(s);
      }),
      relativetime: Zd((r, n) => {
        const a = new Intl.RelativeTimeFormat(r, {
          ...n
        });
        return (s) => a.format(s, n.range || "day");
      }),
      list: Zd((r, n) => {
        const a = new Intl.ListFormat(r, {
          ...n
        });
        return (s) => a.format(s);
      })
    }, this.init(t);
  }
  init(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = r.interpolation.formatSeparator || ",";
  }
  add(t, r) {
    this.formats[t.toLowerCase().trim()] = r;
  }
  addCached(t, r) {
    this.formats[t.toLowerCase().trim()] = Zd(r);
  }
  format(t, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const s = r.split(this.formatSeparator);
    if (s.length > 1 && s[0].indexOf("(") > 1 && s[0].indexOf(")") < 0 && s.find((o) => o.indexOf(")") > -1)) {
      const o = s.findIndex((l) => l.indexOf(")") > -1);
      s[0] = [s[0], ...s.splice(1, o)].join(this.formatSeparator);
    }
    return s.reduce((o, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = R$e(l);
      if (this.formats[c]) {
        let d = o;
        try {
          const f = a && a.formatParams && a.formatParams[a.interpolationkey] || {}, h = f.locale || f.lng || a.locale || a.lng || n;
          d = this.formats[c](o, h, {
            ...u,
            ...a,
            ...f
          });
        } catch (f) {
          this.logger.warn(f);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return o;
    }, t);
  }
}
const D$e = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class N$e extends Kx {
  constructor(t, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = r, this.services = n, this.languageUtils = n.languageUtils, this.options = a, this.logger = Co.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(n, a.backend, a);
  }
  queueLoad(t, r, n, a) {
    const s = {}, i = {}, o = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      r.forEach((d) => {
        const f = `${c}|${d}`;
        !n.reload && this.store.hasResourceBundle(c, d) ? this.state[f] = 2 : this.state[f] < 0 || (this.state[f] === 1 ? i[f] === void 0 && (i[f] = !0) : (this.state[f] = 1, u = !1, i[f] === void 0 && (i[f] = !0), s[f] === void 0 && (s[f] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (o[c] = !0);
    }), (Object.keys(s).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(s),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(o),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, r, n) {
    const a = t.split("|"), s = a[0], i = a[1];
    r && this.emit("failedLoading", s, i, r), !r && n && this.store.addResourceBundle(s, i, n, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = r ? -1 : 2, r && n && (this.state[t] = 0);
    const o = {};
    this.queue.forEach((l) => {
      m$e(l.loaded, [s], i), D$e(l, t), r && l.errors.push(r), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        o[c] || (o[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          o[c][d] === void 0 && (o[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", o), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, i = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: r,
        fcName: n,
        tried: a,
        wait: s,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const o = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, r, n, a + 1, s * 2, i);
        }, s);
        return;
      }
      i(c, u);
    }, l = this.backend[n].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, r);
        c && typeof c.then == "function" ? c.then((u) => o(null, u)).catch(o) : o(null, c);
      } catch (c) {
        o(c);
      }
      return;
    }
    return l(t, r, o);
  }
  prepareLoading(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    Xt(t) && (t = this.languageUtils.toResolveHierarchy(t)), Xt(r) && (r = [r]);
    const s = this.queueLoad(t, r, n, a);
    if (!s.toLoad.length)
      return s.pending.length || a(), null;
    s.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, r, n) {
    this.prepareLoading(t, r, {}, n);
  }
  reload(t, r, n) {
    this.prepareLoading(t, r, {
      reload: !0
    }, n);
  }
  loadOne(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const n = t.split("|"), a = n[0], s = n[1];
    this.read(a, s, "read", void 0, void 0, (i, o) => {
      i && this.logger.warn(`${r}loading namespace ${s} for language ${a} failed`, i), !i && o && this.logger.log(`${r}loaded namespace ${s} for language ${a}`, o), this.loaded(t, i, o);
    });
  }
  saveMissing(t, r, n, a, s) {
    let i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(r)) {
      this.logger.warn(`did not save key "${n}" as the namespace "${r}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(n == null || n === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...i,
          isUpdate: s
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, r, n, a, l) : u = c(t, r, n, a), u && typeof u.then == "function" ? u.then((d) => o(null, d)).catch(o) : o(null, u);
          } catch (u) {
            o(u);
          }
        else
          c(t, r, n, a, o, l);
      }
      !t || !t[0] || this.store.addResource(t[0], r, n, a);
    }
  }
}
const _j = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), Xt(e[1]) && (t.defaultValue = e[1]), Xt(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const r = e[3] || e[2];
      Object.keys(r).forEach((n) => {
        t[n] = r[n];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Sj = (e) => (Xt(e.ns) && (e.ns = [e.ns]), Xt(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), Xt(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e), ry = () => {
}, M$e = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((r) => {
    typeof e[r] == "function" && (e[r] = e[r].bind(e));
  });
};
class fg extends Kx {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Sj(t), this.services = {}, this.logger = Co, this.modules = {
      external: []
    }, M$e(this), r && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, r), this;
      setTimeout(() => {
        this.init(t, r);
      }, 0);
    }
  }
  init() {
    var t = this;
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof r == "function" && (n = r, r = {}), !r.defaultNS && r.defaultNS !== !1 && r.ns && (Xt(r.ns) ? r.defaultNS = r.ns : r.ns.indexOf("translation") < 0 && (r.defaultNS = r.ns[0]));
    const a = _j();
    this.options = {
      ...a,
      ...this.options,
      ...Sj(r)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }), r.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = r.keySeparator), r.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = r.nsSeparator);
    const s = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? Co.init(s(this.modules.logger), this.options) : Co.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = I$e);
      const d = new bj(this.options);
      this.store = new vj(this.options.resources, this.options);
      const f = this.services;
      f.logger = Co, f.resourceStore = this.store, f.languageUtils = d, f.pluralResolver = new A$e(d, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (f.formatter = s(u), f.formatter.init(f, this.options), this.options.interpolation.format = f.formatter.format.bind(f.formatter)), f.interpolator = new P$e(this.options), f.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, f.backendConnector = new N$e(s(this.modules.backend), f.resourceStore, f, this.options), f.backendConnector.on("*", function(h) {
        for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), g = 1; g < p; g++)
          m[g - 1] = arguments[g];
        t.emit(h, ...m);
      }), this.modules.languageDetector && (f.languageDetector = s(this.modules.languageDetector), f.languageDetector.init && f.languageDetector.init(f, this.options.detection, this.options)), this.modules.i18nFormat && (f.i18nFormat = s(this.modules.i18nFormat), f.i18nFormat.init && f.i18nFormat.init(this)), this.translator = new Zb(this.services, this.options), this.translator.on("*", function(h) {
        for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), g = 1; g < p; g++)
          m[g - 1] = arguments[g];
        t.emit(h, ...m);
      }), this.modules.external.forEach((h) => {
        h.init && h.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = ry), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return t.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return t.store[u](...arguments), t;
      };
    });
    const l = Vp(), c = () => {
      const u = (d, f) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(f), n(d, f);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ry;
    const a = Xt(t) ? t : this.language;
    if (typeof t == "function" && (n = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (a && a.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return n();
      const s = [], i = (o) => {
        if (!o || o === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(o).forEach((c) => {
          c !== "cimode" && s.indexOf(c) < 0 && s.push(c);
        });
      };
      a ? i(a) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => i(l)), this.options.preload && this.options.preload.forEach((o) => i(o)), this.services.backendConnector.load(s, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(o);
      });
    } else
      n(null);
  }
  reloadResources(t, r, n) {
    const a = Vp();
    return typeof t == "function" && (n = t, t = void 0), typeof r == "function" && (n = r, r = void 0), t || (t = this.languages), r || (r = this.options.ns), n || (n = ry), this.services.backendConnector.reload(t, r, (s) => {
      a.resolve(), n(s);
    }), a;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && q8.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let r = 0; r < this.languages.length; r++) {
        const n = this.languages[r];
        if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
          this.resolvedLanguage = n;
          break;
        }
      }
  }
  changeLanguage(t, r) {
    var n = this;
    this.isLanguageChangingTo = t;
    const a = Vp();
    this.emit("languageChanging", t);
    const s = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, i = (l, c) => {
      c ? (s(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, a.resolve(function() {
        return n.t(...arguments);
      }), r && r(l, function() {
        return n.t(...arguments);
      });
    }, o = (l) => {
      !t && !l && this.services.languageDetector && (l = []);
      const c = Xt(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || s(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        i(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(t), a;
  }
  getFixedT(t, r, n) {
    var a = this;
    const s = function(i, o) {
      let l;
      if (typeof o != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          u[d - 2] = arguments[d];
        l = a.options.overloadTranslationOptionHandler([i, o].concat(u));
      } else
        l = {
          ...o
        };
      l.lng = l.lng || s.lng, l.lngs = l.lngs || s.lngs, l.ns = l.ns || s.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || n || s.keyPrefix);
      const f = a.options.keySeparator || ".";
      let h;
      return l.keyPrefix && Array.isArray(i) ? h = i.map((p) => `${l.keyPrefix}${f}${p}`) : h = l.keyPrefix ? `${l.keyPrefix}${f}${i}` : i, a.t(h, l);
    };
    return Xt(t) ? s.lng = t : s.lngs = t, s.ns = r, s.keyPrefix = n, s;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const n = r.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, s = this.languages[this.languages.length - 1];
    if (n.toLowerCase() === "cimode") return !0;
    const i = (o, l) => {
      const c = this.services.backendConnector.state[`${o}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (r.precheck) {
      const o = r.precheck(this, i);
      if (o !== void 0) return o;
    }
    return !!(this.hasResourceBundle(n, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(n, t) && (!a || i(s, t)));
  }
  loadNamespaces(t, r) {
    const n = Vp();
    return this.options.ns ? (Xt(t) && (t = [t]), t.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      n.resolve(), r && r(a);
    }), n) : (r && r(), Promise.resolve());
  }
  loadLanguages(t, r) {
    const n = Vp();
    Xt(t) && (t = [t]);
    const a = this.options.preload || [], s = t.filter((i) => a.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return s.length ? (this.options.preload = a.concat(s), this.loadResources((i) => {
      n.resolve(), r && r(i);
    }), n) : (r && r(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    const r = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], n = this.services && this.services.languageUtils || new bj(_j());
    return r.indexOf(n.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    return new fg(t, r);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ry;
    const n = t.forkResourceStore;
    n && delete t.forkResourceStore;
    const a = {
      ...this.options,
      ...t,
      isClone: !0
    }, s = new fg(a);
    return (t.debug !== void 0 || t.prefix !== void 0) && (s.logger = s.logger.clone(t)), ["store", "services", "language"].forEach((o) => {
      s[o] = this[o];
    }), s.services = {
      ...this.services
    }, s.services.utils = {
      hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
    }, n && (s.store = new vj(this.store.data, a), s.services.resourceStore = s.store), s.translator = new Zb(s.services, a), s.translator.on("*", function(o) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      s.emit(o, ...c);
    }), s.init(a, r), s.translator.options = a, s.translator.backendConnector.services.utils = {
      hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
    }, s;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Zn = fg.createInstance();
Zn.createInstance = fg.createInstance;
Zn.createInstance;
Zn.dir;
Zn.init;
Zn.loadResources;
Zn.reloadResources;
Zn.use;
Zn.changeLanguage;
Zn.getFixedT;
Zn.t;
Zn.exists;
Zn.setDefaultNamespace;
Zn.hasLoadedNamespace;
Zn.loadNamespaces;
Zn.loadLanguages;
const {
  slice: L$e,
  forEach: j$e
} = [];
function F$e(e) {
  return j$e.call(L$e.call(arguments, 1), (t) => {
    if (t)
      for (const r in t)
        e[r] === void 0 && (e[r] = t[r]);
  }), e;
}
const Ej = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, B$e = function(e, t) {
  const n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    path: "/"
  }, a = encodeURIComponent(t);
  let s = `${e}=${a}`;
  if (n.maxAge > 0) {
    const i = n.maxAge - 0;
    if (Number.isNaN(i)) throw new Error("maxAge should be a Number");
    s += `; Max-Age=${Math.floor(i)}`;
  }
  if (n.domain) {
    if (!Ej.test(n.domain))
      throw new TypeError("option domain is invalid");
    s += `; Domain=${n.domain}`;
  }
  if (n.path) {
    if (!Ej.test(n.path))
      throw new TypeError("option path is invalid");
    s += `; Path=${n.path}`;
  }
  if (n.expires) {
    if (typeof n.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    s += `; Expires=${n.expires.toUTCString()}`;
  }
  if (n.httpOnly && (s += "; HttpOnly"), n.secure && (s += "; Secure"), n.sameSite)
    switch (typeof n.sameSite == "string" ? n.sameSite.toLowerCase() : n.sameSite) {
      case !0:
        s += "; SameSite=Strict";
        break;
      case "lax":
        s += "; SameSite=Lax";
        break;
      case "strict":
        s += "; SameSite=Strict";
        break;
      case "none":
        s += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  return s;
}, Tj = {
  create(e, t, r, n) {
    let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    r && (a.expires = /* @__PURE__ */ new Date(), a.expires.setTime(a.expires.getTime() + r * 60 * 1e3)), n && (a.domain = n), document.cookie = B$e(e, encodeURIComponent(t), a);
  },
  read(e) {
    const t = `${e}=`, r = document.cookie.split(";");
    for (let n = 0; n < r.length; n++) {
      let a = r[n];
      for (; a.charAt(0) === " "; ) a = a.substring(1, a.length);
      if (a.indexOf(t) === 0) return a.substring(t.length, a.length);
    }
    return null;
  },
  remove(e) {
    this.create(e, "", -1);
  }
};
var U$e = {
  name: "cookie",
  // Deconstruct the options object and extract the lookupCookie property
  lookup(e) {
    let {
      lookupCookie: t
    } = e;
    if (t && typeof document < "u")
      return Tj.read(t) || void 0;
  },
  // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
  cacheUserLanguage(e, t) {
    let {
      lookupCookie: r,
      cookieMinutes: n,
      cookieDomain: a,
      cookieOptions: s
    } = t;
    r && typeof document < "u" && Tj.create(r, e, n, a, s);
  }
}, V$e = {
  name: "querystring",
  // Deconstruct the options object and extract the lookupQuerystring property
  lookup(e) {
    var n;
    let {
      lookupQuerystring: t
    } = e, r;
    if (typeof window < "u") {
      let {
        search: a
      } = window.location;
      !window.location.search && ((n = window.location.hash) == null ? void 0 : n.indexOf("?")) > -1 && (a = window.location.hash.substring(window.location.hash.indexOf("?")));
      const i = a.substring(1).split("&");
      for (let o = 0; o < i.length; o++) {
        const l = i[o].indexOf("=");
        l > 0 && i[o].substring(0, l) === t && (r = i[o].substring(l + 1));
      }
    }
    return r;
  }
};
let ef = null;
const Cj = () => {
  if (ef !== null) return ef;
  try {
    if (ef = typeof window < "u" && window.localStorage !== null, !ef)
      return !1;
    const e = "i18next.translate.boo";
    window.localStorage.setItem(e, "foo"), window.localStorage.removeItem(e);
  } catch {
    ef = !1;
  }
  return ef;
};
var $$e = {
  name: "localStorage",
  // Deconstruct the options object and extract the lookupLocalStorage property
  lookup(e) {
    let {
      lookupLocalStorage: t
    } = e;
    if (t && Cj())
      return window.localStorage.getItem(t) || void 0;
  },
  // Deconstruct the options object and extract the lookupLocalStorage property
  cacheUserLanguage(e, t) {
    let {
      lookupLocalStorage: r
    } = t;
    r && Cj() && window.localStorage.setItem(r, e);
  }
};
let tf = null;
const kj = () => {
  if (tf !== null) return tf;
  try {
    if (tf = typeof window < "u" && window.sessionStorage !== null, !tf)
      return !1;
    const e = "i18next.translate.boo";
    window.sessionStorage.setItem(e, "foo"), window.sessionStorage.removeItem(e);
  } catch {
    tf = !1;
  }
  return tf;
};
var H$e = {
  name: "sessionStorage",
  lookup(e) {
    let {
      lookupSessionStorage: t
    } = e;
    if (t && kj())
      return window.sessionStorage.getItem(t) || void 0;
  },
  cacheUserLanguage(e, t) {
    let {
      lookupSessionStorage: r
    } = t;
    r && kj() && window.sessionStorage.setItem(r, e);
  }
}, W$e = {
  name: "navigator",
  lookup(e) {
    const t = [];
    if (typeof navigator < "u") {
      const {
        languages: r,
        userLanguage: n,
        language: a
      } = navigator;
      if (r)
        for (let s = 0; s < r.length; s++)
          t.push(r[s]);
      n && t.push(n), a && t.push(a);
    }
    return t.length > 0 ? t : void 0;
  }
}, z$e = {
  name: "htmlTag",
  // Deconstruct the options object and extract the htmlTag property
  lookup(e) {
    let {
      htmlTag: t
    } = e, r;
    const n = t || (typeof document < "u" ? document.documentElement : null);
    return n && typeof n.getAttribute == "function" && (r = n.getAttribute("lang")), r;
  }
}, K$e = {
  name: "path",
  // Deconstruct the options object and extract the lookupFromPathIndex property
  lookup(e) {
    var a;
    let {
      lookupFromPathIndex: t
    } = e;
    if (typeof window > "u") return;
    const r = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
    return Array.isArray(r) ? (a = r[typeof t == "number" ? t : 0]) == null ? void 0 : a.replace("/", "") : void 0;
  }
}, q$e = {
  name: "subdomain",
  lookup(e) {
    var a, s;
    let {
      lookupFromSubdomainIndex: t
    } = e;
    const r = typeof t == "number" ? t + 1 : 1, n = typeof window < "u" && ((s = (a = window.location) == null ? void 0 : a.hostname) == null ? void 0 : s.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i));
    if (n)
      return n[r];
  }
};
let G8 = !1;
try {
  document.cookie, G8 = !0;
} catch {
}
const Y8 = ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"];
G8 || Y8.splice(1, 1);
const G$e = () => ({
  order: Y8,
  lookupQuerystring: "lng",
  lookupCookie: "i18next",
  lookupLocalStorage: "i18nextLng",
  lookupSessionStorage: "i18nextLng",
  // cache user language
  caches: ["localStorage"],
  excludeCacheFor: ["cimode"],
  // cookieMinutes: 10,
  // cookieDomain: 'myDomain'
  convertDetectedLanguage: (e) => e
});
class X8 {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.type = "languageDetector", this.detectors = {}, this.init(t, r);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      languageUtils: {}
    }, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.services = t, this.options = F$e(r, this.options || {}, G$e()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = (a) => a.replace("-", "_")), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = n, this.addDetector(U$e), this.addDetector(V$e), this.addDetector($$e), this.addDetector(H$e), this.addDetector(W$e), this.addDetector(z$e), this.addDetector(K$e), this.addDetector(q$e);
  }
  addDetector(t) {
    return this.detectors[t.name] = t, this;
  }
  detect() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.order, r = [];
    return t.forEach((n) => {
      if (this.detectors[n]) {
        let a = this.detectors[n].lookup(this.options);
        a && typeof a == "string" && (a = [a]), a && (r = r.concat(a));
      }
    }), r = r.map((n) => this.options.convertDetectedLanguage(n)), this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes ? r : r.length > 0 ? r[0] : null;
  }
  cacheUserLanguage(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.options.caches;
    r && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(t) > -1 || r.forEach((n) => {
      this.detectors[n] && this.detectors[n].cacheUserLanguage(t, this.options);
    }));
  }
}
X8.type = "languageDetector";
const Q8 = {
  logout: "Logout",
  email: "Email",
  password: "Password",
  confirmPassword: "Confirm Password",
  forgotPassword: {
    title: "Forgot Password",
    subtitle: "Enter your email to reset your password",
    noAccount: "I want to join the Circle?",
    createAccount: "Learn More"
  },
  emailPlaceholder: "Enter your email",
  passwordPlaceholder: "Enter your password",
  confirmPasswordPlaceholder: "Confirm your password",
  loginError: "Login failed. Please check your credentials.",
  registrationError: "Registration failed. Please try again.",
  emailRequired: "Email is required",
  invalidEmail: "Please enter a valid email address",
  passwordRequired: "Password is required",
  passwordMinLength: "Password must be at least 8 characters long",
  confirmPasswordRequired: "Please confirm your password",
  passwordsMustMatch: "Passwords must match",
  switchToRegister: "Don't have an account? Register",
  switchToLogin: "Already have an account? Login",
  logoutSuccess: "You have been successfully logged out.",
  firstName: "First Name",
  lastName: "Last Name",
  firstNamePlaceholder: "Enter your first name",
  lastNamePlaceholder: "Enter your last name",
  firstNameRequired: "First name is required",
  lastNameRequired: "Last name is required",
  birthCountryRequired: "Birth country is required",
  birthCityRequired: "Birth city is required",
  birthdayRequired: "Birthday is required",
  nationalityRequired: "Nationality is required",
  residenceCountryRequired: "Residence country is required",
  phoneNumberRequired: "Phone number is required",
  signInToAccount: "Sign in to your account",
  createAccount: "Create new account",
  documentType: "Document Type",
  passport: "Passport",
  idCard: "ID Card",
  documentTypeRequired: "Document type is required",
  orContinueWith: "Or continue with",
  continueWithGoogle: "Continue with Google",
  continueWithGithub: "Continue with Github",
  companyNameRequired: "Company name is required",
  sirenRequired: "SIREN is required",
  countryRequired: "Country is required",
  kind: "Kind",
  individual: "Individual",
  company: "Company",
  baseline: "Your trusted partner for sustainable investments",
  passwordComplexity: {
    title: "Password must contain:",
    minLength: "At least 8 characters",
    uppercase: "At least one uppercase letter (A-Z)",
    lowercase: "At least one lowercase letter (a-z)",
    number: "At least one number (0-9)"
  },
  kyc: {
    title: "Identity Verification",
    description: "Please complete the identity verification process",
    mobileInstructions: "Scan the QR code with your mobile device or",
    clickHere: "click here",
    finishLater: "Finish Later",
    verificationFailed: "Verification failed. Please try again.",
    verificationInProgress: "Verification in progress",
    reload: "Try Again",
    reloadDescription: "There was an error with the verification. Click below to try again."
  },
  login: {
    title: "Login",
    subtitle: "Sign in to your account",
    forgotPassword: "Forgot password?",
    noAccount: "I want to join the Circle?",
    createAccount: "Learn More",
    dontHaveAccount: "Don't have an account?"
  },
  register: {
    title: "Create Account",
    subtitle: "Get started by creating your account",
    alreadyHaveAccount: "Already have an account? Sign in",
    checkEmail: "Check your email",
    checkEmailDesc: "We've sent you a verification link",
    checkSpam: "If you don't see the email, please check your spam folder",
    backToLogin: "Back to login",
    noAccount: "Don't have an account?",
    passwordComplexity: "Password must contain at least one uppercase letter, one lowercase letter, and one number",
    emailSentTo: "Email sent to:",
    verificationInstructions: "Please click on the verification link sent to your email"
  },
  resetPassword: {
    title: "Reset Password",
    subtitle: "Enter your new password",
    checkEmail: "Check your email",
    checkEmailDesc: "We've sent a link to reset your password",
    checkSpam: "If you can't find the email, check your spam folder",
    success: "Password reset successful",
    successDesc: "You can now login with your new password",
    successMessage: "Your password has been reset successfully",
    error: "Password reset error",
    invalidToken: "Invalid or expired reset token",
    backToLogin: "Back to login",
    noAccount: "I want to join the Circle?",
    createAccount: "Learn More"
  },
  verifyEmail: {
    title: "Verify Email",
    subtitle: "Please verify your email to activate your account",
    verifying: "Verifying your email",
    pleaseWait: "Please wait while we verify your email",
    error: "Email verification error",
    resend: "Resend verification email",
    resendSuccess: "Verification email sent successfully",
    alreadyVerified: "Your email is already verified",
    noToken: "No verification token found",
    goToLogin: "Go to login page",
    noAccount: "I want to join the Circle?",
    createAccount: "Learn More"
  },
  onboarding: {
    title: "Complete Your Profile",
    subtitle: "Let's get to know you better",
    personalInfo: "Personal Information",
    personalInfoDescription: "Please fill in your personal information to complete your profile",
    next: "Next",
    previous: "Previous",
    finish: "Finish",
    skip: "Skip for now",
    userInfo: {
      title: "Personal Information"
    },
    kyc: {
      title: "Identity Verification"
    }
  },
  steps: {
    personalInfo: "Personal Information",
    kyc: "Identity Verification"
  }
}, J8 = {
  auth: Q8
}, Y$e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  auth: Q8,
  default: J8
}, Symbol.toStringTag, { value: "Module" })), Z8 = {
  "campaign-orders": {
    crud: {
      list: {
        title: "Investments on campaign"
      }
    }
  }
}, X$e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Z8
}, Symbol.toStringTag, { value: "Module" })), eH = {
  campaigns: "Campaigns",
  endDate: "End Date",
  price: "Price",
  investor: "Investor",
  userDataTracking: "User Data Tracking",
  date: "Date",
  investedAmount: "Invested Amount",
  title: "Campaigns",
  createTitle: "Create Campaign",
  searchPlaceholder: "Search campaigns...",
  updateTitle: "Update Campaign",
  myCampaigns: "My Campaigns",
  id: "ID",
  location: "Location",
  remainingTokens: "Remaining Tokens",
  creationDate: "Creation Date",
  name: "Campaign Name",
  project: "Asset",
  startDate: "Start Date",
  duration: "Campaign Duration",
  batches: "Batches",
  batchesDescription: "Number of batches available for this campaign",
  formTitle: "Campaign Form",
  generalInfo: "General Information",
  generalInfoDescription: "Fill in the general information for the campaign",
  projectSelection: "Asset Selection",
  projectSelectionDescription: "Select the asset for this campaign",
  minimalBatches: "Minimal Batches",
  minimalBatchesDescription: "Minimum number of batches required for this campaign",
  private: "Private Campaign",
  privateCol: "Private",
  privateDescription: "If enabled, only qualified users will be able to see this campaign",
  privateTag: "Private",
  publicTag: "Public",
  yes: "Yes",
  no: "No",
  signature: {
    signaturit: "Signaturit Template ID",
    signaturitDescription: "Enter the Signaturit template ID for this campaign",
    docuseal: "Docuseal Template ID",
    docusealDescription: "Enter the Docuseal template ID for this campaign"
  },
  status: {
    title: "Campaign Status",
    available: "Available",
    created: "Created",
    canceled: "Canceled",
    closed: "Closed",
    minted: "Minted",
    goalReached: "Goal Reached",
    expired: "Expired"
  },
  crud: {
    list: {
      title: "Campaigns Management",
      createButton: "Create Campaign",
      searchPlaceholder: "Search campaigns...",
      noItemsFound: "No campaigns found"
    },
    create: {
      title: "Create Campaign",
      success: "Campaign created successfully"
    },
    update: {
      title: "Update Campaign",
      success: "Campaign updated successfully"
    },
    delete: {
      confirmation: "Are you sure you want to delete this campaign?",
      success: "Campaign deleted successfully"
    }
  },
  tabs: {
    orders: "Orders",
    details: "Details"
  },
  actions: {
    mint: "Start Minting"
  },
  toast: {
    mint: {
      loading: "Starting the minting process...",
      success: "Minting process started successfully",
      error: "Failed to start minting: {{error}}"
    }
  },
  kpis: {
    contractDeployment: "Contract Deployment",
    whitelisting: "Whitelisting",
    minting: "Minting Progress"
  },
  nft: {
    title: "NFT Details",
    contract: "Contract Address",
    tokenId: "Token ID",
    viewOnExplorer: "View on Explorer",
    externalLink: "Open in new tab"
  },
  startsOn: "Starts on {{date}}"
}, tH = {
  campaigns: eH
}, Q$e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  campaigns: eH,
  default: tH
}, Symbol.toStringTag, { value: "Module" })), rH = {
  loading: "Loading...",
  error: "An error occurred",
  success: "Success!",
  cancel: "Cancel",
  save: "Save",
  edit: "Edit",
  delete: "Delete",
  create: "Create",
  update: "Update",
  actions: "Actions",
  yes: "Yes",
  no: "No",
  search: "Search",
  welcome: "Welcome",
  learnMore: "Learn More",
  processing: "Processing...",
  ellipsis: "...",
  page: "Page",
  of: "of",
  itemsPerPage: "Items per page",
  pageButton: "Page button",
  pageButtonActive: "Page button active",
  previous: "Previous",
  next: "Next",
  showing: "Showing",
  to: "to",
  results: "results",
  view: "View",
  viewDetails: "View Details",
  back: "Back",
  copy: "Copy",
  saveProgress: "Save Progress",
  submit: "Submit",
  addItem: "Add Item",
  removeItem: "Remove Item",
  dateFrom: "From",
  dateTo: "To",
  seeAll: "See All",
  seeMore: "See More",
  readMore: "Read More",
  all: "All",
  generalInformation: "General Information",
  id: "ID",
  submitting: "Submitting...",
  retry: "Retry",
  title: "Title",
  description: "Description",
  value: "Value",
  operator: "Operator",
  tooltip: "Tooltip",
  titlePlaceholder: "Enter title",
  descriptionPlaceholder: "Enter description",
  valuePlaceholder: "Enter value",
  operatorPlaceholder: "e.g. €, %, etc.",
  tooltipPlaceholder: "Enter tooltip text",
  selectTitle: "Select a value",
  verifyIdentityToInvest: "Verify your identity to invest",
  completeKyc: "Complete KYC",
  callAdvisor: "Call an advisor",
  pendingOrderBanner: "You have a pending investment to complete",
  completeOrder: "Complete your investment",
  filter: "Filter",
  filters: "Filters",
  apply: "Apply",
  reset: "Reset",
  select: "Select...",
  close: "Close",
  export: "Export",
  add: "Add",
  noItemsSelected: "No items selected",
  formErrors: "Please correct the following errors:",
  formSubmissionSuccess: "Form submitted successfully",
  formSubmissionError: "Error submitting form",
  draftSubmissionSuccess: "Draft saved successfully",
  draftSubmissionError: "Error saving draft",
  invalidValue: "Invalid value",
  form: {
    fields: {
      email: "Email",
      password: "Password",
      firstName: "First Name",
      lastName: "Last Name",
      phoneNumber: "Phone Number",
      address: "Address",
      city: "City",
      postalCode: "Postal Code",
      country: "Country",
      birthDate: "Birth Date",
      birthCity: "Birth City",
      birthCountry: "Birth Country",
      nationality: "Nationality",
      residenceCountry: "Residence Country",
      companyName: "Company Name",
      siren: "SIREN",
      streetNumber: "Street Number",
      streetName: "Street Name"
    }
  }
}, nH = {
  en: "English",
  fr: "French",
  es: "Spanish",
  zh: "Chinese"
}, aH = {
  name: "Your App Name",
  allRightsReserved: "All rights reserved."
}, sH = {
  more: "More",
  menu: "Menu",
  home: "Home",
  about: "About",
  dashboard: "Dashboard",
  profile: "Profile",
  users: "Users",
  user: "Gestion utilisateurs",
  projects: "Projects",
  campaigns: "Campaigns",
  agents: "Agents",
  createAgent: "Create Agent",
  comments: "Comments",
  prompts: "Prompts",
  showcase: "Showcase",
  settings: "Settings",
  plans: "Plans",
  theme: "Theme",
  documentation: "Documentation",
  "user-lists": "User Lists",
  dashboardB2B: "Dashboard B2B",
  dashboardB2C: "Dashboard B2C",
  projectsOverview: "Projects Overview",
  management: "Management",
  wallet: "Wallet",
  configuration: "Configuration",
  support: "Support B2B",
  communication: "Communication",
  supportB2C: "Support B2C",
  investments: "My Investments",
  investmentsOverview: "Investments (All)",
  marketplace: "Marketplace"
}, iH = {
  allInvestments: "All Investments",
  investmentName: "Investment Name",
  investmentRevenue: "Investment Revenue",
  investmentA: "Investment A",
  investmentB: "Investment B",
  investmentC: "Investment C"
}, oH = {
  investmentOperationDescription: "Investment in {{project}}",
  depositOperationDescription: "Deposit to account",
  withdrawalOperationDescription: "Withdrawal from account",
  investment: "Investment",
  deposit: "Deposit",
  withdrawal: "Withdrawal"
}, lH = {
  title: "Your Profile",
  editProfile: "Edit Profile",
  saveChanges: "Save Changes",
  personalInfo: "Personal Information",
  accountSettings: "Account Settings"
}, cH = {
  http: {
    bad_request: "Invalid request",
    unauthorized: "Please log in to continue",
    forbidden: "You don't have permission to perform this action",
    not_found: "The requested resource was not found",
    internal_server_error: "An unexpected error occurred"
  },
  auth: {
    unauthorized: "{{message}}",
    wrong_tenant: "{{message}}",
    default: "Authentication failed: {{message}}",
    admin_access_required: "Admin role is required for this application",
    tenant_access_denied: "No access to this tenant",
    no_session: "No session exists",
    no_token: "Failed to get access token",
    login_failed: "Login failed",
    registration_failed: "Registration failed"
  },
  validation: {
    title: "Validation Error",
    default: "Invalid input",
    required: "This field is required",
    required_field: "The {{field}} field is required",
    min_length: "Must be at least {{min}} characters",
    max_length: "Must be at most {{max}} characters",
    pattern: "Invalid format",
    email: "Invalid email address"
  },
  unknown: "An unexpected error occurred",
  network: {
    offline: "You are currently offline",
    timeout: "The request timed out",
    dns_failure: "Unable to reach the server",
    cors_error: "Cross-origin request blocked",
    aborted: "Request was cancelled",
    unknown: "Network connection failed",
    failed_connection: "Unable to connect to the server",
    server_unreachable: "Server is unreachable",
    connection_guide: "Please check your internet connection and try again"
  }
}, uH = {
  user: "User",
  users: "Users"
}, dH = {
  required: "This field is required",
  invalidEmail: "Please enter a valid email address",
  passwordMinLength: "Password must be at least 8 characters long"
}, fH = {
  title: "Your Wallet",
  balance: "Current Balance",
  transactions: "Transaction History"
}, hH = {
  description: "This is the home page description."
}, pH = {
  title: "Pricing Plans",
  subscribe: "Subscribe"
}, mH = {
  previous: "Previous",
  next: "Next",
  itemsPerPage: "Items per page",
  page: "Page",
  of: "of",
  pageButton: "Page button",
  pageButtonActive: "Page button active",
  pageButtonInactive: "Page button inactive",
  showing: "Showing",
  to: "to",
  results: "results",
  perPage: "per page"
}, gH = {
  status: {
    completed: "Completed",
    in_progress: "In Progress",
    pending: "Pending"
  },
  deleteConfirmation: "Are you sure you want to delete this {{entity}}?",
  title: "{{entity}}",
  searchPlaceholder: "Search users..."
}, vH = {
  invalidPhoneNumber: "Please enter a valid phone number",
  invalidColor: "Please enter a valid color",
  required: "This field is required",
  email: "Please enter a valid email address",
  passwordMinLength: "Password must be at least 8 characters long",
  iban: {
    required: "IBAN is required",
    invalid: "Invalid IBAN format"
  },
  bic: {
    required: "BIC is required",
    invalid: "Invalid BIC format"
  },
  amount: {
    required: "Amount is required",
    min: "Minimum amount is {{min}}",
    max: "Maximum amount is {{max}}",
    insufficient: "Insufficient funds",
    invalid: "Invalid amount"
  },
  address: {
    required: "Address is required",
    streetNumber: "Street number is required",
    streetName: "Street name is required",
    postalCode: "Postal code is required",
    city: "City is required"
  }
}, yH = {
  list: {
    marketplace: "Marketplace"
  }
}, bH = {
  placeholder: "Select an option"
}, wH = "Admin", xH = {
  common: rH,
  language: nH,
  app: aH,
  nav: sH,
  investments: iH,
  operations: oH,
  profile: lH,
  errors: cH,
  entities: uH,
  forms: dH,
  wallet: fH,
  home: hH,
  pricing: pH,
  pagination: mH,
  user: gH,
  validation: vH,
  crud: yH,
  select: bH,
  admin: wH,
  delete: {
    title: "Confirm Delete",
    message: "Are you sure you want to delete this {{entity}}?",
    confirm: "Delete"
  }
}, J$e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  admin: wH,
  app: aH,
  common: rH,
  crud: yH,
  default: xH,
  entities: uH,
  errors: cH,
  forms: dH,
  home: hH,
  investments: iH,
  language: nH,
  nav: sH,
  operations: oH,
  pagination: mH,
  pricing: pH,
  profile: lH,
  select: bH,
  user: gH,
  validation: vH,
  wallet: fH
}, Symbol.toStringTag, { value: "Module" })), _H = {
  title: "{{entity}}",
  createTitle: "Create {{entity}}",
  updateTitle: "Update {{entity}}",
  formTitle: "{{entity}} Form",
  deleteConfirmation: "Are you sure you want to delete this {{entity}}?",
  createNew: "Create New {{entity}}",
  search: "Search {{entity}}",
  create: "Create {{entity}}",
  edit: "Edit {{entity}}",
  delete: "Delete {{entity}}",
  actions: "Actions",
  view: "View",
  noItemsFound: "No {{entity}} found",
  confirmDelete: "Are you sure you want to delete this {{entity}}?",
  createSuccess: "{{entity}} created successfully",
  updateSuccess: "{{entity}} updated successfully",
  deleteSuccess: "{{entity}} deleted successfully",
  createError: "Failed to create {{entity}}",
  updateError: "Failed to update {{entity}}",
  deleteError: "Failed to delete {{entity}}",
  loadError: "Failed to load {{entity}}",
  searchPlaceholder: "Search {{entity}} ..."
}, SH = {
  crud: _H
}, Z$e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  crud: _H,
  default: SH
}, Symbol.toStringTag, { value: "Module" })), EH = {
  title: "Dashboard",
  totalUsers: "Total Users",
  totalUsersDesc: "Total number of registered users",
  totalRevenue: "Total Revenue",
  totalRevenueDesc: "Total revenue generated",
  averageValue: "Average Value",
  averageValueDesc: "Average value per user",
  datasetOne: "Dataset One",
  datasetTwo: "Dataset Two",
  optionOne: "Option One",
  optionTwo: "Option Two",
  lineChartTitle: "Line Chart",
  barChartTitle: "Bar Chart",
  currentYear: "Current Year",
  previousYear: "Previous Year",
  twoYearsAgo: "Two Years Ago",
  filterByCategory: "Filter by Category",
  category1: "Category 1",
  category2: "Category 2",
  doughnutChartTitle: "Doughnut Chart",
  doughnutLabel1: "Label 1",
  doughnutLabel2: "Label 2",
  doughnutLabel3: "Label 3",
  all: "All",
  viewDetails: "View Details",
  inscrits: "Inscrits",
  kycChecked: "KYC vérifiés",
  investisseurs: "Investisseurs",
  montantCollecte: "Montant collecté général",
  campaign1: "Campagne 1",
  campaign2: "Campagne 2",
  mesProjets: "Mes Projets",
  seeAllProjects: "Voir tous les projets",
  performancesDistributeurs: "Performances distributeurs",
  dashboardTitle: "Dashboard",
  totalAmountCollected: "Total Amount Collected",
  byCampaigns: "By Campaigns",
  campaignOne: "Campaign 1",
  campaignTwo: "Campaign 2",
  registeredUsers: "Registered Users",
  registeredUsersDescription: "Total number of registered users",
  kycVerified: "KYC Verified",
  kycVerifiedDescription: "Users who have completed KYC verification",
  investors: "Investors",
  investorsDescription: "Active investors on the platform",
  myProjects: "My Projects",
  activeProjects: "Active Portfolio",
  distributorPerformance: "Distributor Performance",
  lastYear: "Last Year",
  filterByCampaigns: "Filter by Campaigns",
  repartitionInvestissements: "Investment Distribution",
  myOperations: "My Operations",
  averageYieldDescription: "Average yield description",
  averageYield: "Average Yield",
  receivedRevenues: "Received Revenues",
  receivedRevenuesDescription: "Received revenues description",
  investedAmountDescription: "Invested amount description",
  investedAmount: "Invested Amount",
  addProject: "Add Project",
  noAmountCollectedTitle: "No Data Available",
  noAmountCollectedDescription: "There is no amount collected data to display at the moment.",
  noDistributorData: "No Distributor Data",
  noDistributorDataDescription: "No distributor data description",
  seasonalPerformance: "Seasonal Performance",
  welcomeBanner: "<strong>Welcome to your Kapi Club member area.</strong><br />The Collection Goldstone club-deal is open for investment until 01/17/2025.<br />You can invest through this space or contact the Kapi team at <a href='mailto:hello@kapi.club' class='underline text-primary-500 hover:text-primary-600'>hello@kapi.club</a> for any questions.",
  backToSeasons: "Back to Seasons",
  backToYears: "Back to Years",
  amountPerYear: "Amount per Year",
  amountPerCampaign: "Amount per Campaign",
  errorLoadingData: "Error Loading Data"
}, TH = {
  dashboard: EH
}, e8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  dashboard: EH,
  default: TH
}, Symbol.toStringTag, { value: "Module" })), CH = {
  distribution: "Distribution",
  payoutDetails: "Payout Details",
  totalAmount: "Total Amount",
  fees: "Fees",
  period: "Period",
  status: "Status",
  investors: "Investors",
  payoutError: "Failed to load payout data",
  id: "ID",
  name: "Name",
  price: "Price",
  batches: "Batches",
  actions: "Actions",
  viewDetails: "View Details",
  year: "Year",
  month: "Month",
  amount: "Amount",
  parts: "Number of Parts",
  submit: "Process Payout",
  crud: {
    list: {
      title: "Management",
      searchPlaceholder: "Search projects...",
      noItemsFound: "No projects found"
    }
  }
}, kH = {
  management: CH
}, t8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kH,
  management: CH
}, Symbol.toStringTag, { value: "Module" })), OH = {
  "orders-user": {
    crud: {
      list: {
        title: "My Investments",
        searchPlaceholder: "Search investments...",
        noItemsFound: "No investments found"
      }
    }
  }
}, r8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: OH
}, Symbol.toStringTag, { value: "Module" })), AH = {
  title: "My Investments",
  user: "User",
  projectName: "Project",
  amount: "Amount",
  quantity: "Quantity",
  status: "Status",
  createdAt: "Investment Date",
  batchValue: "Batch Value",
  documents: "Documents",
  "documents.doc": "Doc {{number}}",
  campaign: {
    batches: "Total Batches"
  },
  yield: "Yield",
  execute: "Execute",
  refreshStatus: "Refresh Status",
  failedToExecute: "Failed to execute order",
  statuses: {
    pending: "Pending",
    completed: "Completed",
    failed: "Failed",
    cancelled: "Cancelled",
    expired: "Expired",
    funded: "Funded",
    valid: "Valid",
    refunded: "Refunded",
    rejected: "Rejected",
    executed: "Executed",
    unknown: "Unknown",
    NOAS: "Not Available"
  },
  errors: {
    noCampaign: "No available campaign found for this project",
    createOrder: "Error creating order",
    checkStatus: "Error checking order status"
  },
  actions: {
    checkStatus: "Check Status",
    executeOrder: "Execute Order",
    continue: "Continue",
    refresh: "Refresh",
    execute: "Execute",
    download: "Download"
  },
  crud: {
    list: {
      title: "My Investments",
      searchPlaceholder: "Search investments...",
      noItemsFound: "No investments found"
    }
  }
}, PH = {
  orders: AH
}, n8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: PH,
  orders: AH
}, Symbol.toStringTag, { value: "Module" })), RH = {
  kycProcess: "KYC Process",
  kycStatus: "KYC Status",
  title: "Profile",
  personalInfo: "Personal Info",
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  nationality: "Nationality",
  birthDate: "Birth Date",
  birthCity: "Birth City",
  address: "Address",
  phoneNumber: "Phone Number",
  streetNumber: "Street Number",
  streetName: "Street Name",
  postalCode: "Postal Code",
  city: "City",
  country: "Country",
  blockchainInfo: "Blockchain Info",
  walletAddress: "Wallet Address",
  whitelisted: "Whitelisted",
  notWhitelisted: "Not Whitelisted",
  birthCountry: "Birth Country",
  residenceCountry: "Residence Country",
  contactInfo: "Contact Information",
  companyName: "Company Name",
  siren: "SIREN",
  qualified: "Qualified Status",
  status: "Account Status",
  kycSteps: {
    registration: "Registration",
    verification: "Verification",
    active: "Active"
  }
}, IH = {
  profile: RH
}, a8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: IH,
  profile: RH
}, Symbol.toStringTag, { value: "Module" })), DH = {
  name: "Name",
  creationDate: "Creation Date",
  remainingTokens: "Remaining Tokens",
  id: "ID",
  searchPlaceholder: "Search projects...",
  editProject: "Edit Project",
  deleteProject: "Delete Project",
  createProject: "Create Project",
  myProjects: "My Projects",
  overview: "My Projects",
  activeProjects: "Active Projects",
  title: "Projects",
  activePortfolio: "Active Portfolio",
  formTitle: "Project Form",
  defaultName: "Untitled Project",
  defaultLocation: "Unknown Location",
  financed: "financed",
  investors: "Investors",
  targetYield: "Target Yield",
  netYield: "Net Yield",
  perYear: "per year",
  description: "Description",
  investmentReasons: "Investment Reasons",
  street: "Street",
  number: "Number",
  postalCode: "Postal Code",
  city: "City",
  country: "Country",
  latitude: "Latitude",
  longitude: "Longitude",
  type: "Type",
  documents: "Documents",
  activeCampaignBanner: "Active Campaign",
  startDate: "Start Date",
  campaignDuration: "Campaign Duration",
  shareValue: "Share Value",
  sharesForSale: "Shares For Sale",
  generalInfo: "General Info",
  createStatus: "Create Status",
  generalInfoDescription: "General info description",
  investmentReasonsDescription: "Investment reasons description",
  descriptionStepDescription: "Description step description",
  locationDescription: "Location description",
  filesDescription: "Files description",
  updateTitle: "Update Project",
  features: "Features",
  paymentWindowOpened: "A new window has been opened to complete your payment",
  reopenPayment: "Reopen Payment Window",
  waitingForPayment: "Please complete the payment in the opened window",
  retryPayment: "Retry Payment",
  completeAndSignDocument: "Complete and sign the document to access the next step",
  popupBlocked: "Popup window was blocked",
  popupBlockedMessage: "Please allow popups for this site to proceed with payment",
  openPayment: "Open Payment Window",
  processingPayment: "Processing Your Payment",
  paymentCheckError: "Error checking payment status. Please try again.",
  timeline: {
    title: "Project Timeline"
  },
  tooltips: {
    targetYield: "The expected annual return on investment before taxes",
    netYield: "The actual distributed yield per year after all fees and taxes",
    investors: "Number of current investors in this project",
    duration: "Expected investment holding period"
  },
  strategy: {
    name: "Strategy",
    title: "Investment Strategy"
  },
  targetSort: "Target Yield",
  netTaxes: "Net Taxes",
  targetDuration: "Target Duration",
  yearly: "Yearly",
  access: "Access",
  details: "Details",
  price: "Price",
  pricePerShare: "Price per share",
  minimumShares: "Minimum shares",
  minimumInvestment: "Minimum investment amount",
  totalInvestment: "Total investment amount: {{total}}",
  futureCapital: "Future Capital",
  gains: "Gains",
  investedAmount: "Invested Amount",
  averageRevenue: "Average Revenue",
  occupancyRate: "Occupancy Rate",
  urls: "Medias",
  batches: "Batches",
  paymentInstructions: "Click below to proceed with payment in a new tab",
  signatureInstructions: "Click below to sign the documents in a new tab",
  investmentComplete: "Your investment process is complete!",
  proceedToPayment: "Proceed to Payment",
  proceedToSignature: "Proceed to Signature",
  paymentInProgress: "Payment process started",
  paymentNewWindow: "Please complete the payment in the new window",
  signatureInProgress: "Signature process started",
  signatureNewWindow: "Please complete the signature in the new window",
  checkPaymentWindow: "Please check your browser's new window/tab to complete the payment",
  checkSignatureWindow: "Please check your browser's new window/tab to complete the signature",
  testCardDetails: "Test Card Details (Sandbox)",
  anyFutureDate: "Any future date (e.g., 12/25)",
  anyCvv: "Any 3 digits (e.g., 123)",
  orderSummary: "Order Summary",
  pendingPayment: "Payment Pending",
  awaitingPayment: "Awaiting Payment",
  loading: "Loading...",
  quantity: "Quantity",
  orderStatus: "Order Status",
  projectName: "Project Name",
  signatureRequired: "Signature Required",
  waitingForSignature: "Waiting for signature...",
  retrySignature: "Retry Signature",
  orderComplete: "Order Complete",
  orderCompleteMessage: "Your order has been successfully completed",
  investmentAmount: "Investment Amount",
  orderProcessing: "Processing Order",
  orderError: "Order Error",
  tryAgain: "Try Again",
  paymentWindowClosed: "Payment window has been closed",
  checkSignatureStatus: "Check Signature Status",
  continueToPayment: "Continue to Payment",
  confirmInvest: "Confirm Investment",
  investmentSuccessMessage: "Your investment has been successfully processed",
  availableBatches: "Available batches: {{count}}",
  validatingSignature: "Validating signature...",
  signatureValidationFailed: "Signature validation failed after multiple attempts",
  signatureCheckError: "Error checking signature status",
  retrySignatureCheck: "Retry Signature Check",
  paymentTimeoutError: "Payment deadline has expired. Please try again.",
  checkPaymentManually: "Payment is taking longer than expected. You can manually refresh to check its status.",
  refreshPaymentStatus: "Refresh Payment Status",
  reopenPaymentWindow: "Reopen Payment Window",
  noBatchesAvailable: "No batches available",
  investInProject: "Invest in {{projectName}}",
  fallbackPaymentMessage: "If you're having trouble with the payment window, please proceed in a new tab by clicking the button below:",
  openPaymentNewTab: "Open in new tab",
  error: "Error on the project",
  targetAmount: "Target amount:",
  steps: {
    form: "Investment Details",
    signature: "Document Signature",
    payment: "Payment",
    complete: "Confirmation",
    confirm: "Confirm Investment"
  },
  errors: {
    orderCreationFailed: "Failed to create order. Please try again.",
    paymentFailed: "Payment verification failed. Please try again or contact support.",
    orderCreation: "Error creating order",
    orderStatus: "Error checking order status",
    invalidQuantity: "Invalid quantity"
  },
  success: {
    orderCreated: "Order created successfully",
    paymentCompleted: "Payment completed successfully"
  },
  reasons: {
    label: "Reasons",
    title: "Title",
    description: "Description"
  },
  finance: {
    title: "Finance",
    resale: {
      title: "Resale",
      priceAfterRenovation: "Price after renovation",
      holdingPeriod: "Holding period",
      annualRevaluation: "Annual revaluation",
      estimatedResaleAmount: "Estimated resale amount"
    },
    yields: {
      title: "Yields",
      targetAnnualYield: "Target annual yield",
      distributedYieldPerYear: "Distributed yield per year"
    },
    charges: {
      title: "Charges",
      maintenance: "Maintenance",
      taxes: "Taxes",
      energy: "Energy",
      worksFund: "Works fund",
      managementFees: "Management fees"
    },
    revenues: {
      title: "Revenue",
      dailyAverage: "Daily average",
      energy: "Energy"
    },
    investment: {
      title: "Investment",
      purchasePrice: "Purchase price",
      notaryFees: "Notary fees",
      huntingFees: "Hunting fees",
      works: "Works",
      furnishing: "Furnishing",
      worksReserve: "Works reserve",
      subscriptionFee: "Subscription fee"
    },
    results: {
      title: "Results",
      annualOperational: "Annual operational",
      annualFinancial: "Annual financial",
      annualNetEstimated: "Annual net estimated",
      totalAnnualCharges: "Total annual charges"
    }
  },
  location: {
    title: "Location",
    streetName: "Street",
    streetNumber: "Number",
    postalCode: "Postal Code",
    city: "City",
    country: "Country",
    details: "Details"
  },
  files: {
    title: "Files",
    mainImage: "Main Image",
    additionalImages: "Additional Images",
    documents: "Documents",
    terms: "Terms",
    images: "Images"
  },
  news: {
    title: "News",
    imageUrl: "Image URL",
    sourceUrl: "Source URL"
  },
  presentation: {
    title: "Presentation"
  },
  investmentOpportunity: "Investment Opportunity",
  completeProfile: "Complete Profile",
  general: {
    title: "General"
  },
  advantages: {
    title: "Advantages"
  },
  projectLocation: "Project Location",
  mapPlaceholder: "Map will be displayed here",
  callAdvisor: "Call Advisor",
  whyInvest: "Why Invest",
  transactions: "Transactions",
  daysLeft: "days left",
  fundingProgress: "Funding Progress",
  charges: "Charges",
  revenues: "Revenues",
  results: "Results",
  investment: "Investment",
  resale: "Resale",
  terms: "Terms and Conditions",
  documentAvailable: "Document Available",
  estimatedGains: "Estimated Gains",
  invest: "Invest",
  noProjectsAdded: "No projects added",
  findProjectsInSection: "Find projects in the section below",
  addFirstProject: "Add your first project",
  moreImages: "More images",
  seeImages: "See images",
  crud: {
    list: {
      title: "Projects Management",
      marketplace: "Marketplace",
      createButton: "Create Project",
      searchPlaceholder: "Search projects...",
      noItemsFound: "No projects found",
      publishedSuccess: "Project published successfully",
      draftSuccess: "Project moved to draft successfully",
      draftToggleError: "Error toggling project status"
    },
    create: {
      title: "Create Project",
      success: "Project created successfully"
    },
    update: {
      title: "Update Project",
      success: "Project updated successfully"
    },
    delete: {
      confirmation: "Are you sure you want to delete this project?",
      success: "Project deleted successfully"
    }
  },
  startsOn: "Starts on {{date}}",
  comingSoon: "Coming Soon",
  privateCampaign: "Private",
  status: {
    available: "Available",
    created: "Created",
    canceled: "Canceled",
    closed: "Closed",
    minted: "Minted",
    valid: "Valid",
    info: {
      title: "General Information",
      description: "Basic project information including name, price, and description"
    },
    finance: {
      title: "Financial Details",
      description: "Project financial information including yields, charges and revenues"
    },
    presentation: {
      title: "Asset Presentation",
      description: "Project features, strategy and media files"
    },
    location: {
      title: "Location Details",
      description: "Project location information and specifications"
    }
  },
  downloadRib: "",
  downloadRibDescription: "",
  showProgressBar: "Show progress bar",
  extraAmount: "Extra amount",
  simulation: {
    title: "Investment Simulation",
    rate: "Annual Rate",
    duration: "Duration",
    durationType: "Duration Type",
    min: "Minimum Duration",
    max: "Maximum Duration",
    years: "year",
    months: "month"
  }
}, NH = {
  noProjects: "No projects available at the moment",
  noProjectsDescription: "There are currently no investment opportunities available. Please check back later for new projects.",
  checkBackLater: "Go to Dashboard"
}, MH = {
  projects: DH,
  marketplace: NH
}, s8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MH,
  marketplace: NH,
  projects: DH
}, Symbol.toStringTag, { value: "Module" })), LH = {
  title: "Support",
  noContentAvailable: "No support content is currently available. Please check back later.",
  faq: {
    title: "FAQ",
    items: "FAQ Items",
    addItem: "Add FAQ Item"
  },
  contact: {
    title: "Contact Information",
    email: "Support Email",
    link: "Contact Link",
    yourEmail: "Your Email",
    message: "Your Message",
    emailSubject: "Support Contact Form Submission"
  },
  dashboard: {
    title: "Dashboard Information",
    content: "Top Banner Content"
  }
}, jH = {
  support: LH
}, i8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jH,
  support: LH
}, Symbol.toStringTag, { value: "Module" })), FH = {
  "user-lists": {
    crud: {
      list: {
        title: "User Lists",
        searchPlaceholder: "Search lists...",
        noItemsFound: "No lists found"
      },
      update: {
        title: "Update List"
      },
      create: {
        title: "Create List"
      }
    },
    name: "List Name",
    description: "Description",
    basicInfo: "Basic Information",
    members: "List Members",
    selectUsers: "Select Users",
    membersHelperText: "Select users to add to this list",
    unnamed: "Unnamed List",
    exportPreparing: "Preparing export for list:",
    exportComplete: "Export completed for list:",
    exportError: "Error exporting list data",
    createError: "Error creating list",
    updateError: "Error updating list",
    createSuccess: "List created successfully",
    updateSuccess: "List updated successfully",
    viewList: "View List: {{name}}",
    details: "Details",
    addUsersToList: "Add Users to List",
    selectUsersToAdd: "Select Users to Add",
    loading: "Loading users...",
    addingUsers: "Adding users to list...",
    usersAddedSuccess: "Users successfully added to list",
    errorAddingUsers: "Error adding users to list",
    errorLoadingUsers: "Error loading users",
    loadError: "Error loading list members",
    noUsersFound: 'No users found matching "{{term}}"',
    noAvailableUsers: "No users available to add",
    allUsersAlreadyInList: "All users are already in this list",
    removeFromList: "Remove from list",
    removingUser: "Removing user from list...",
    userRemovedSuccess: "User successfully removed from list",
    errorRemovingUser: "Error removing user from list"
  }
}, o8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FH
}, Symbol.toStringTag, { value: "Module" })), BH = {
  id: "ID",
  email: "Email",
  isActive: "Is Active",
  isAdmin: "Is admin",
  password: "Password",
  addUser: "Add User",
  searchPlaceholder: "Search users...",
  createdAt: "Created At",
  updatedAt: "Updated At",
  active: "Active",
  inactive: "Inactive",
  viewUser: "View User",
  editUser: "Edit User",
  deleteUser: "Delete User",
  createUser: "Create User",
  firstName: "First Name",
  lastName: "Last Name",
  nationality: "Nationality",
  updateTitle: "Update User",
  updateUser: "Update User",
  createTitle: "Create User",
  deleteConfirmation: "Are you sure you want to delete this {{entity}}?",
  personalInfo: "Personal Info",
  registrationComplete: "Registration Complete",
  registrationDescription: "User successfully registered in the system.",
  verificationStatus: "Verification Status",
  verificationComplete: "User account has been verified.",
  verificationPending: "User account verification is pending.",
  adminStatus: "Admin Status",
  adminActive: "User has admin privileges.",
  adminInactive: "User does not have admin privileges.",
  verifyUser: "Verify User",
  invitationLink: "Invitation Link",
  addNote: "Add Note",
  addNotePlaceholder: "Add a note to the user",
  kycProcessValidated: "KYC process validated",
  kycProcessPending: "KYC process pending",
  kycProcessNotStarted: "KYC process not started",
  validateKYC: "Validate KYC",
  kind: "Account Type",
  individual: "Individual",
  company: "Company",
  investorRegistered: "User registered",
  identityVerificationInProgress: "Identity verification in progress",
  validRegistration: "Valid registration",
  verificationInProgress: "Verification in progress",
  name: "Name",
  registrationDate: "Registration Date",
  investedAmount: "Invested Amount",
  formTitle: "User Form",
  birthDate: "Birth Date",
  birthPlace: "Birth Place",
  phoneNumber: "Phone Number",
  address: "Address",
  postalCode: "Postal Code",
  city: "City",
  country: "Country",
  streetNumber: "Street Number",
  birthCountry: "Birth Country",
  streetName: "Street Name",
  birthCity: "Birth City",
  statusTitle: "Status",
  creationDate: "Creation Date",
  residenceCountry: "Residence Country",
  birthday: "Birthday",
  companyName: "Company Name",
  siren: "SIREN",
  crud: {
    list: {
      title: "Users Management",
      createButton: "Create User",
      searchPlaceholder: "Search users...",
      noItemsFound: "No investors found"
    },
    create: {
      title: "Create User",
      success: "User created successfully"
    },
    update: {
      title: "Update User",
      success: "User updated successfully"
    },
    delete: {
      confirmation: "Are you sure you want to delete this user?",
      success: "User deleted successfully"
    }
  },
  status: {
    title: "User Status",
    uninitiated: "Uninitiated",
    initiated: "Initiated",
    initiatedDesc: "User has started the registration process",
    kyc: {
      completed: "KYC process completed",
      pending: "KYC process pending",
      not_started: "KYC process not started",
      force_kyc: "Force KYC"
    },
    kyced: "KYC Validated",
    kycedDesc: "Identity verification process",
    active: "Active",
    activeDesc: "User fully verified and active",
    blockchained: "Blockchained",
    blockchainedDesc: "User integrated with blockchain"
  },
  kycStatus: {
    not_started: "KYC Not Started",
    pending: "KYC In Progress",
    succeeded: "KYC Succeeded",
    canceled: "KYC Canceled",
    failed: "KYC Failed",
    unknown: "KYC Unknown Status"
  },
  activeUser: "Active investor",
  actions: {
    forceKyc: "Force KYC Validation",
    forceKycSuccess: "KYC validation forced successfully",
    forceKycError: "Error forcing KYC validation",
    sendLink: "Send Activation Link",
    sendLinkSuccess: "Activation link sent successfully",
    sendLinkError: "Error sending activation link"
  },
  qualified: "Qualified",
  qualifiedDescription: "If enabled, this user will be able to see private campaigns",
  qualifiedTag: "Qualified",
  notQualifiedTag: "Not Qualified",
  select: "Select a user",
  lists: {
    name: "List Name",
    description: "Description",
    basicInfo: "Basic Information",
    create: "Create List",
    update: "Update List",
    delete: "Delete List",
    view: "View List",
    unnamed: "Unnamed List",
    userAdded: "User added to list successfully",
    userRemoved: "User removed from list successfully",
    addError: "Error adding user to list",
    removeError: "Error removing user from list",
    members: "List Members",
    details: "List Details",
    addUser: "Add User to List",
    noUsers: "No users in this list",
    manageLists: "Marketing Lists",
    createList: "Create Marketing List",
    updateList: "Update Marketing List",
    deleteConfirmation: "Are you sure you want to delete this list?",
    listDeleteSuccess: "List deleted successfully",
    userManagement: "User Management",
    selectUsers: "Select Users",
    membersHelperText: "Select users to add to this list",
    exportPreparing: "Preparing export for list",
    exportComplete: "Export completed for list",
    exportError: "Error exporting list data",
    status: {
      title: "List Setup Progress"
    },
    basicInfoStep: "Basic Information",
    basicInfoStepDesc: "Define the list name and description",
    membersStep: "List Members",
    membersStepDesc: "Add users to your list"
  }
}, UH = {
  users: BH
}, l8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: UH,
  users: BH
}, Symbol.toStringTag, { value: "Module" })), VH = {
  addressTitle: "Address Information",
  streetNumber: "Street Number",
  streetName: "Street Name",
  postalCode: "Postal Code",
  fetchError: "Failed to fetch bank account information",
  updateSuccess: "Bank account information updated successfully",
  updateError: "Failed to update bank account information",
  city: "City",
  country: "Country",
  details: "Additional Details",
  required: "This field is required",
  bankAccountTitle: "Bank Account Details",
  bankAccountDisclaimer: "Please enter your bank account information for receiving payments",
  iban: "IBAN",
  bic: "BIC/SWIFT",
  firstName: "First Name",
  lastName: "Last Name",
  birthday: "Date of Birth",
  birthCountry: "Country of Birth",
  birthCity: "City of Birth",
  nationality: "Nationality",
  residenceCountry: "Country of Residence",
  invalidIban: "Please enter a valid IBAN (minimum 15 characters)",
  invalidBic: "Please enter a valid BIC (minimum 8 characters)",
  invalidFirstName: "Please enter a valid first name",
  invalidLastName: "Please enter a valid last name",
  invalidBirthday: "Please enter a valid date in format YYYY-MM-DD",
  invalidBirthCountry: "Please enter a valid country code",
  invalidBirthCity: "Please enter a valid city",
  invalidNationality: "Please enter a valid nationality code",
  invalidResidenceCountry: "Please enter a valid residence country code",
  title: "Wallet",
  balance: "Balance",
  addFunds: "Add Funds",
  withdraw: "Withdraw",
  transactions: "Transactions",
  noTransactions: "No transactions found",
  lastUpdated: "Last updated: {{time}}",
  error: "Wallet Error",
  comingSoon: "Coming Soon",
  kycRequired: "KYC Verification Required",
  kycRequiredDescription: "To use wallet features, you need to complete KYC verification",
  completeKyc: "Complete KYC Verification",
  kycVerified: "KYC Verified",
  addBankAccount: "Add Bank Account",
  bankDetails: "Bank Account Details",
  quickActions: "Quick Actions",
  invalidAmount: "Invalid amount. Please enter between {{min}} and {{max}}",
  amountPlaceholder: "Enter amount",
  amountHelp: "Min: {{min}} - Max: {{max}}",
  paymentMethods: "Payment Methods",
  proceed: "Proceed",
  confirmWithdrawal: "Confirm Withdrawal",
  infoTitle: "Important Information",
  infoMessage: "Processing times may vary depending on your bank",
  type: "Type",
  amount: "Amount",
  bankAccounts: "Bank Accounts",
  addNew: "Add",
  bankAccountEnding: "Account ending with {{last4}}",
  noBankAccountsYet: "No bank accounts yet",
  withdrawalTitle: "Withdrawal",
  withdrawalDescription: "Withdraw funds to your bank account",
  addFundsTitle: "Add Funds",
  addFundsDescription: "Add funds to your wallet",
  availableBalance: "Available Balance",
  minimumAmount: "Minimum Amount",
  maximumAmount: "Maximum Amount",
  processingFees: "Processing Fees",
  totalAmount: "Total Amount",
  bankAccountRequired: "A bank account is required to perform a withdrawal",
  addBankAccountFirst: "Please add a bank account first",
  insufficientFunds: "Insufficient funds",
  transferDetails: "Transfer Details",
  transferId: "Transfer ID",
  transferDate: "Transfer Date",
  transferStatus: "Transfer Status",
  noTransactionsFound: "No transactions found",
  noBankAccountTitle: "No Bank Account",
  noBankAccountDescription: "Please add a bank account first",
  infoBanner: "Manage your bank information to receive your payments. Make sure the information is correct to avoid any payment delays.",
  status: {
    title: "Status",
    succeeded: "Succeeded",
    failed: "Failed",
    pending: "Pending",
    created: "Created"
  },
  transactionTypes: {
    payin: "Deposit",
    payout: "Withdrawal",
    transfer: "Transfer"
  },
  date: "Date",
  fees: "Fees",
  address: {
    streetNumber: "Street Number",
    streetName: "Street Name",
    postalCode: "Postal Code",
    city: "City",
    country: "Country"
  },
  crud: {
    list: {
      title: "Wallet Management",
      createButton: "Create Wallet",
      searchPlaceholder: "Search wallets...",
      noItemsFound: "No wallets found"
    },
    create: {
      title: "Create Wallet",
      success: "Wallet created successfully"
    },
    update: {
      title: "Update Wallet",
      success: "Wallet updated successfully"
    },
    delete: {
      confirmation: "Are you sure you want to delete this wallet?",
      success: "Wallet deleted successfully"
    }
  }
}, $H = {
  wallet: VH
}, c8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $H,
  wallet: VH
}, Symbol.toStringTag, { value: "Module" })), HH = {
  logout: "Déconnexion",
  email: "Email",
  password: "Mot de passe",
  confirmPassword: "Confirmer le mot de passe",
  forgotPassword: "Mot de passe oublié?",
  emailPlaceholder: "Entrer votre email",
  passwordPlaceholder: "Entrer votre mot de passe",
  confirmPasswordPlaceholder: "Confirmer votre mot de passe",
  loginError: "Connexion impossible. Veuillez vérifier vos identifiants.",
  registrationError: "Inscription impossible. Veuillez réessayer.",
  emailRequired: "Email est requis",
  invalidEmail: "Veuillez entrer un email valide",
  passwordRequired: "Mot de passe est requis",
  passwordMinLength: "Le mot de passe doit comporter au moins 8 caractères",
  confirmPasswordRequired: "Veuillez confirmer votre mot de passe",
  birthCountryRequired: "Le pays de naissance est requis",
  birthCityRequired: "La ville de naissance est requise",
  birthdayRequired: "La date de naissance est requise",
  nationalityRequired: "La nationalité est requise",
  residenceCountryRequired: "Le pays de résidence est requis",
  phoneNumberRequired: "Le numéro de téléphone est requis",
  passwordsMustMatch: "Les mots de passe doivent correspondre",
  switchToRegister: "Vous n'avez pas de compte? S'inscrire",
  switchToLogin: "Vous avez déjà un compte? Se connecter",
  logoutSuccess: "Vous avez été déconnecté avec succès.",
  orContinueWith: "Ou continuez avec",
  continueWithGoogle: "Continuer avec Google",
  continueWithGithub: "Continuer avec Github",
  companyNameRequired: "Le nom de l'entreprise est requis",
  sirenRequired: "Le SIREN est requis",
  countryRequired: "Le pays est requis",
  kind: "Type",
  individual: "Individuel",
  company: "Entreprise",
  baseline: "Lancez votre plateforme d'investissement facilement",
  passwordComplexity: {
    title: "Le mot de passe doit contenir:",
    minLength: "Au moins 8 caractères",
    uppercase: "Au moins une lettre majuscule (A-Z)",
    lowercase: "Au moins une lettre minuscule (a-z)",
    number: "Au moins un chiffre (0-9)"
  },
  kyc: {
    title: "Vérification d'identité",
    description: "Veuillez compléter le processus de vérification d'identité",
    mobileInstructions: "Scannez le code QR avec votre dispositif mobile ou",
    clickHere: "cliquez ici",
    finishLater: "Finaliser plus tard",
    verificationInProgress: "Vérification en cours",
    verificationFailed: "La vérification a échoué. Veuillez réessayer.",
    reload: "Réessayer",
    reloadDescription: "Une erreur s'est produite lors de la vérification. Cliquez ci-dessous pour réessayer."
  },
  login: {
    title: "Connexion",
    subtitle: "Connectez-vous à votre compte",
    forgotPassword: "Mot de passe oublié?",
    noAccount: "Je souhaite accéder aux opportunités ?",
    createAccount: "Demande d'inscription",
    dontHaveAccount: "Vous n'avez pas de compte?"
  },
  register: {
    title: "Créer un compte",
    subtitle: "Commencez par créer votre compte",
    alreadyHaveAccount: "Vous avez déjà un compte? Se connecter",
    checkEmail: "Vérifier votre email",
    checkEmailDesc: "Nous vous avons envoyé un lien de vérification",
    checkSpam: "Si vous ne voyez pas l'email, veuillez vérifier votre dossier de spam",
    backToLogin: "Retour à la connexion",
    noAccount: "Vous n'avez pas de compte?",
    passwordComplexity: "Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule et un nombre",
    emailSentTo: "Email envoyé à :",
    verificationInstructions: "Veuillez cliquer sur le lien de vérification envoyé à votre email"
  },
  resetPassword: {
    title: "Réinitialiser le mot de passe",
    subtitle: "Entrez votre nouveau mot de passe",
    checkEmail: "Vérifiez votre e-mail",
    checkEmailDesc: "Nous avons envoyé un lien pour réinitialiser votre mot de passe",
    checkSpam: "Si vous ne trouvez pas l'e-mail, vérifiez votre dossier spam",
    success: "Mot de passe réinitialisé avec succès",
    successDesc: "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe",
    successMessage: "Votre mot de passe a été réinitialisé avec succès",
    error: "Erreur de réinitialisation du mot de passe",
    invalidToken: "Jeton de réinitialisation invalide ou expiré",
    backToLogin: "Retour à la connexion",
    noAccount: "Je souhaite rejoindre le Cercle?",
    createAccount: "En Savoir Plus"
  },
  verifyEmail: {
    title: "Vérification de l'e-mail",
    subtitle: "Veuillez vérifier votre e-mail pour activer votre compte",
    verifying: "Vérification de votre e-mail",
    pleaseWait: "Veuillez patienter pendant que nous vérifions votre e-mail",
    error: "Erreur de vérification de l'e-mail",
    resend: "Renvoyer l'e-mail de vérification",
    resendSuccess: "E-mail de vérification envoyé avec succès",
    alreadyVerified: "Votre e-mail a déjà été vérifié",
    noToken: "Aucun jeton de vérification trouvé",
    goToLogin: "Aller à la page de connexion",
    noAccount: "Je souhaite rejoindre le Cercle?",
    createAccount: "En Savoir Plus"
  },
  onboarding: {
    title: "Complétez votre profil",
    subtitle: "Fais connaissance avec nous",
    personalInfo: "Informations personnelles",
    personalInfoDescription: "Veuillez entrer vos informations personnelles",
    next: "Suivant",
    previous: "Précédent",
    finish: "Finaliser",
    skip: "Omitir pour le moment",
    userInfo: {
      title: "Informations personnelles"
    },
    kyc: {
      title: "Vérification d'identité"
    }
  },
  signInToAccount: "Se connecter à votre compte",
  createAccount: "Créer un nouveau compte",
  steps: {
    personalInfo: "Informations personnelles",
    kyc: "Vérification d'identité"
  },
  documentType: "Type de document",
  passport: "Passport",
  idCard: "Carte d'identité",
  documentTypeRequired: "Le type de document est requis",
  firstNameRequired: "Le nom est requis",
  lastNameRequired: "Le prénom est requis"
}, WH = {
  auth: HH
}, u8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  auth: HH,
  default: WH
}, Symbol.toStringTag, { value: "Module" })), zH = {
  "campaign-orders": {
    crud: {
      list: {
        title: "Investissements sur la campagne"
      }
    }
  }
}, d8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zH
}, Symbol.toStringTag, { value: "Module" })), KH = {
  campaigns: "Campagnes",
  endDate: "Date de fin",
  price: "Prix",
  investor: "Investisseur",
  userDataTracking: "Suivi des données utilisateur",
  date: "Date",
  investedAmount: "Montant investi",
  title: "Campagnes",
  createTitle: "Créer une campagne",
  searchPlaceholder: "Rechercher des campagnes...",
  updateTitle: "Mettre à jour la campagne",
  myCampaigns: "Mes campagnes",
  id: "ID",
  location: "Localisation",
  remainingTokens: "Tokens restants",
  creationDate: "Date de création",
  name: "Nom",
  project: "Actif",
  startDate: "Date de début",
  duration: "Durée",
  batches: "Nombre de parts",
  batchesDescription: "Nombre de parts disponibles pour cette campagne",
  formTitle: "Formulaire de campagne",
  generalInfo: "Informations générales",
  generalInfoDescription: "Remplissez les informations générales de la campagne",
  projectSelection: "Sélection de l'actif",
  projectSelectionDescription: "Sélectionnez l'actif pour cette campagne",
  signature: {
    signaturit: "ID du modèle Signaturit",
    signaturitDescription: "Entrez l'ID du modèle Signaturit pour cette campagne",
    docuseal: "ID du modèle Docuseal",
    docusealDescription: "Entrez l'ID du modèle Docuseal pour cette campagne"
  },
  minimalBatches: "Nombre minimum de parts",
  minimalBatchesDescription: "Nombre minimum de parts requis pour cette campagne",
  private: "Campagne Privée",
  privateCol: "Privée",
  privateDescription: "Si activé, seuls les utilisateurs qualifiés pourront voir cette campagne",
  privateTag: "Privée",
  publicTag: "Publique",
  yes: "Oui",
  no: "Non",
  saveDraft: "Brouillon",
  day_one: "jour",
  day_other: "jours",
  remaining_one: "restante",
  remaining_other: "restantes",
  total_one: "totale",
  total_other: "totales",
  status: {
    title: "Statut",
    startsOn: "Démarre le {{date}}",
    available: "Disponible",
    created: "Créé",
    canceled: "Annulé",
    closed: "Clôturé",
    minted: "Financé",
    goalReached: "Objectif atteint",
    expired: "Date dépassée"
  },
  viewModal: {
    title: "Campagne: {{name}}"
  },
  crud: {
    list: {
      title: "Gestion des campagnes",
      createButton: "Créer une campagne",
      searchPlaceholder: "Rechercher des campagnes...",
      noItemsFound: "Aucune campagne trouvée",
      publishedSuccess: "Campagne publiée avec succès",
      draftSuccess: "Campagne mise en brouillon avec succès",
      draftToggleError: "Erreur lors de la modification du statut de la campagne"
    },
    create: {
      title: "Créer une campagne",
      success: "Campagne créée avec succès"
    },
    update: {
      title: "Mettre à jour la campagne",
      success: "Campagne mise à jour avec succès"
    },
    delete: {
      confirmation: "Êtes-vous sûr de vouloir supprimer cette campagne?",
      success: "Campagne supprimée avec succès"
    }
  },
  tabs: {
    orders: "Commandes",
    details: "Détails"
  },
  actions: {
    mint: "Démarrer le Minting"
  },
  toast: {
    mint: {
      loading: "Démarrage du processus de minting...",
      success: "Processus de minting démarré avec succès",
      error: "Échec du démarrage du minting : {{error}}"
    }
  },
  kpis: {
    contractDeployment: "Déploiement des contrats managés",
    whitelisting: "Whitelisting",
    minting: "Minting"
  },
  nft: {
    title: "Détails du NFT",
    contract: "Adresse du contrat",
    tokenId: "ID du token",
    viewOnExplorer: "Voir sur l'explorateur"
  },
  orders: {
    title: "Investissements",
    crud: {
      list: {
        title: "Investissements sur la campagne"
      }
    },
    startsOn: "Démarre le {{date}}"
  }
}, qH = {
  campaigns: KH
}, f8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  campaigns: KH,
  default: qH
}, Symbol.toStringTag, { value: "Module" })), GH = {
  loading: "Chargement...",
  error: "Une erreur est survenue",
  success: "Succès!",
  cancel: "Annuler",
  save: "Enregistrer",
  edit: "Modifier",
  delete: "Supprimer",
  create: "Créer",
  update: "Mettre à jour",
  actions: "Actions",
  yes: "Oui",
  no: "Non",
  search: "Rechercher",
  welcome: "Bienvenue",
  learnMore: "En savoir plus",
  processing: "Traitement...",
  ellipsis: "...",
  page: "Page",
  of: "de",
  itemsPerPage: "Items par page",
  pageButton: "Bouton de page",
  pageButtonActive: "Bouton de page actif",
  previous: "Précédent",
  next: "Suivant",
  showing: "Affichage",
  to: "à",
  results: "résultats",
  view: "Voir",
  viewDetails: "Voir les détails",
  back: "Retour",
  copy: "Copier",
  saveProgress: "Enregistrer le progrès",
  submit: "Soumettre",
  addItem: "Ajouter un élément",
  removeItem: "Supprimer un élément",
  dateFrom: "De",
  dateTo: "À",
  seeAll: "Voir tout",
  seeMore: "Voir plus",
  readMore: "Lire la suite",
  knowMore: "En savoir plus",
  content: "Contenu",
  image: "Image",
  date: "Date",
  all: "Tous",
  generalInformation: "Informations générales",
  id: "ID",
  submitting: "Envoi...",
  retry: "Réessayer",
  title: "Titre",
  description: "Description",
  value: "Valeur",
  operator: "Opérateur",
  tooltip: "Info-bulle",
  titlePlaceholder: "Saisir le titre",
  descriptionPlaceholder: "Saisir la description",
  valuePlaceholder: "Saisir la valeur",
  operatorPlaceholder: "ex: €, %, etc.",
  tooltipPlaceholder: "Saisir le texte de l'info-bulle",
  selectTitle: "Sélectionner une valeur",
  verifyIdentityToInvest: "Vérifiez votre identité pour investir",
  completeKyc: "Réaliser mon KYC",
  callAdvisor: "Appeler un conseiller",
  pendingOrderBanner: "Vous avez un investissement en attente à finaliser",
  completeOrder: "Finaliser votre investissement",
  filter: "Filtrer",
  filters: "Filtres",
  apply: "Appliquer",
  reset: "Réinitialiser",
  select: "Sélectionner...",
  close: "Fermer",
  export: "Exporter",
  add: "Ajouter",
  noItemsSelected: "Aucun élément sélectionné",
  validation: {
    invalidPhoneNumber: "Veuillez entrer un numéro de téléphone valide",
    invalidColor: "Veuillez entrer une couleur valide",
    required: "Ce champ est obligatoire",
    email: "Veuillez entrer une adresse e-mail valide",
    passwordMinLength: "Le mot de passe doit contenir au moins 8 caractères",
    iban: {
      required: "L'IBAN est requis",
      invalid: "Format d'IBAN invalide"
    },
    bic: {
      required: "Le BIC est requis",
      invalid: "Format de BIC invalide"
    },
    amount: {
      required: "Le montant est requis",
      min: "Le montant minimum est de {{min}}",
      max: "Le montant maximum est de {{max}}",
      insufficient: "Solde insuffisant",
      invalid: "Montant invalide"
    },
    address: {
      required: "L'adresse est requise",
      streetNumber: "Le numéro de rue est requis",
      streetName: "Le nom de rue est requis",
      postalCode: "Le code postal est requis",
      city: "La ville est requise"
    }
  },
  formErrors: "Veuillez corriger les erreurs suivantes :",
  formSubmissionSuccess: "Formulaire soumis avec succès",
  formSubmissionError: "Erreur lors de la soumission du formulaire",
  draftSubmissionSuccess: "Brouillon enregistré avec succès",
  draftSubmissionError: "Erreur lors de l'enregistrement du brouillon",
  invalidValue: "Valeur invalide",
  form: {
    fields: {
      email: "Email",
      password: "Mot de passe",
      firstName: "Prénom",
      lastName: "Nom",
      phoneNumber: "Numéro de téléphone",
      address: "Adresse",
      city: "Ville",
      postalCode: "Code postal",
      country: "Pays",
      birthDate: "Date de naissance",
      birthCity: "Ville de naissance",
      birthCountry: "Pays de naissance",
      nationality: "Nationalité",
      residenceCountry: "Pays de résidence",
      companyName: "Nom de l'entreprise",
      siren: "SIREN",
      streetNumber: "Numéro de rue",
      streetName: "Nom de rue"
    }
  }
}, YH = {
  en: "Anglais",
  fr: "Français",
  es: "Espagnol",
  zh: "Chinois"
}, XH = {
  name: "Votre nom d'application",
  allRightsReserved: "Tous droits réservés."
}, QH = {
  more: "Plus",
  menu: "Menu",
  home: "Accueil",
  about: "À propos",
  dashboard: "Tableau de bord",
  profile: "Mon Profil",
  users: "Gestion des utilisateurs",
  user: "Gestion utilisateurs",
  projects: "Projets",
  campaigns: "Campagnes",
  agents: "Agents",
  createAgent: "Créer un agent",
  comments: "Commentaires",
  prompts: "Prompts",
  showcase: "Showcase",
  settings: "Paramètres",
  plans: "Plans",
  theme: "Thème",
  documentation: "Documentation",
  "user-lists": "Listes d'utilisateurs",
  dashboardB2B: "Dashboard B2B",
  dashboardB2C: "Dashboard B2C",
  projectsOverview: "Aperçu des offres",
  management: "Management",
  wallet: "Portefeuille",
  configuration: "Configuration",
  support: "Support",
  supportB2B: "Support B2B",
  supportB2C: "Support B2C",
  communication: "Communication",
  investments: "Mes Investissements",
  investmentsOverview: "Investissements",
  marketplace: "Projets"
}, JH = {
  allInvestments: "Toutes les investissements",
  investmentName: "Nom de l'investissement",
  investmentRevenue: "Revenu de l'investissement",
  investmentA: "Investissement A",
  investmentB: "Investissement B",
  investmentC: "Investissement C"
}, ZH = {
  investmentOperationDescription: "Investissement dans {{project}}",
  depositOperationDescription: "Dépôt sur le compte",
  withdrawalOperationDescription: "Retrait du compte",
  investment: "Investissement",
  deposit: "Dépôt",
  withdrawal: "Retrait"
}, e7 = {
  title: "Votre profil",
  editProfile: "Modifier le profil",
  saveChanges: "Enregistrer les modifications",
  personalInfo: "Informations personnelles",
  accountSettings: "Paramètres du compte"
}, t7 = {
  http: {
    bad_request: "Requête invalide",
    unauthorized: "Veuillez vous connecter pour continuer",
    forbidden: "Vous n'avez pas la permission d'effectuer cette action",
    not_found: "La ressource demandée n'a pas été trouvée",
    internal_server_error: "Une erreur inattendue s'est produite"
  },
  auth: {
    unauthorized: "{{message}}",
    wrong_tenant: "tenant éroné",
    default: "Authentification échouée: {{message}}",
    admin_access_required: "Le rôle administrateur est requis pour cette application",
    tenant_access_denied: "Accès au tenant refusé",
    no_session: "Aucune session n'existe",
    no_token: "Impossible d'obtenir le jeton d'accès",
    login_failed: "Échec de la connexion",
    registration_failed: "Échec de l'inscription"
  },
  validation: {
    title: "Erreur de validation",
    default: "Entrée invalide",
    required: "Ce champ est obligatoire",
    required_field: "Le champ {{field}} est obligatoire",
    min_length: "Doit contenir au moins {{min}} caractères",
    max_length: "Doit contenir au maximum {{max}} caractères",
    pattern: "Format invalide",
    email: "Adresse e-mail invalide",
    min: "Le minimum est de {{min}}"
  },
  unknown: "Une erreur inattendue s'est produite",
  network: {
    offline: "Vous êtes actuellement hors ligne",
    timeout: "La requête a expiré",
    dns_failure: "Impossible d'atteindre le serveur",
    cors_error: "Requête cross-origin bloquée",
    aborted: "Requête annulée",
    unknown: "La connexion réseau a échoué",
    failed_connection: "Impossible de se connecter au serveur",
    server_unreachable: "Le serveur est inaccessible",
    connection_guide: "Veuillez vérifier votre connexion internet et réessayer"
  }
}, r7 = {
  user: "Utilisateur",
  users: "Utilisateurs"
}, n7 = {
  required: "Ce champ est requis",
  invalidEmail: "Veuillez entrer un email valide",
  passwordMinLength: "Le mot de passe doit comporter au moins 8 caractères"
}, a7 = {
  title: "Votre portefeuille",
  balance: "Solde actuel",
  transactions: "Historique des transactions"
}, s7 = {
  description: "Cette est la description de la page d'accueil."
}, i7 = {
  title: "Plans tarifaires",
  subscribe: "S'abonner"
}, o7 = {
  previous: "Précédent",
  next: "Suivant",
  itemsPerPage: "Items par page",
  page: "Page",
  of: "de",
  pageButton: "Bouton de page",
  pageButtonActive: "Bouton de page actif",
  pageButtonInactive: "Bouton de page inactif",
  showing: "Affichage",
  to: "à",
  results: "résultats",
  perPage: "par page"
}, l7 = {
  status: {
    completed: "Terminé",
    in_progress: "En cours",
    pending: "En attente"
  },
  deleteConfirmation: "Êtes-vous sûr de vouloir supprimer cet {{entity}}?",
  title: "{{entity}}",
  searchPlaceholder: "Rechercher des utilisateurs..."
}, c7 = {
  list: {
    marketplace: "Projets"
  }
}, u7 = {
  placeholder: "Sélectionner une option"
}, d7 = "Admin", f7 = {
  common: GH,
  language: YH,
  app: XH,
  nav: QH,
  investments: JH,
  operations: ZH,
  profile: e7,
  errors: t7,
  entities: r7,
  forms: n7,
  wallet: a7,
  home: s7,
  pricing: i7,
  pagination: o7,
  user: l7,
  crud: c7,
  select: u7,
  admin: d7,
  delete: {
    title: "Confirmation de suppression",
    message: "Êtes-vous sûr de vouloir supprimer cet élément ?",
    confirm: "Supprimer"
  }
}, h8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  admin: d7,
  app: XH,
  common: GH,
  crud: c7,
  default: f7,
  entities: r7,
  errors: t7,
  forms: n7,
  home: s7,
  investments: JH,
  language: YH,
  nav: QH,
  operations: ZH,
  pagination: o7,
  pricing: i7,
  profile: e7,
  select: u7,
  user: l7,
  wallet: a7
}, Symbol.toStringTag, { value: "Module" })), h7 = {
  title: "{{entity}}",
  createTitle: "Créer un {{entity}}",
  updateTitle: "Mettre à jour un {{entity}}",
  formTitle: "Formulaire {{entity}}",
  deleteConfirmation: "Êtes-vous sûr de vouloir supprimer ce {{entity}}?",
  createNew: "Créer un nouveau {{entity}}",
  search: "Rechercher {{entity}}",
  create: "Créer {{entity}}",
  edit: "Modifier un {{entity}}",
  delete: "Supprimer un {{entity}}",
  actions: "Actions",
  view: "Voir",
  noItemsFound: "Aucun {{entity}} trouvé",
  confirmDelete: "Êtes-vous sûr de vouloir supprimer ce {{entity}}?",
  createSuccess: "{{entity}} créé avec succès",
  updateSuccess: "{{entity}} mis à jour avec succès",
  deleteSuccess: "{{entity}} supprimé avec succès",
  createError: "Erreur lors de la création de {{entity}}",
  updateError: "Erreur lors de la mise à jour de {{entity}}",
  deleteError: "Erreur lors de la suppression de {{entity}}",
  loadError: "Erreur lors du chargement de {{entity}}",
  searchPlaceholder: "Rechercher un {{entity}} ..."
}, p7 = {
  crud: h7
}, p8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  crud: h7,
  default: p7
}, Symbol.toStringTag, { value: "Module" })), m7 = {
  title: "Tableau de bord",
  totalUsers: "Total Utilisateurs",
  totalUsersDesc: "Nombre total d'utilisateurs enregistrés",
  totalRevenue: "Total des revenus",
  totalRevenueDesc: "Revenu total généré",
  averageValue: "Valeur moyenne",
  averageValueDesc: "Valeur moyenne par utilisateur",
  datasetOne: "Dataset Un",
  datasetTwo: "Dataset Deux",
  optionOne: "Option Un",
  optionTwo: "Option Deux",
  lineChartTitle: "Graphique en ligne",
  barChartTitle: "Graphique en barre",
  currentYear: "Année en cours",
  previousYear: "Année précédente",
  twoYearsAgo: "Deux ans déjà",
  filterByCategory: "Filtrer par catégorie",
  category1: "Catégorie 1",
  category2: "Catégorie 2",
  doughnutChartTitle: "Graphique en anneau",
  doughnutLabel1: "Label 1",
  doughnutLabel2: "Label 2",
  doughnutLabel3: "Label 3",
  all: "Tous",
  viewDetails: "Voir les détails",
  welcome: "Bienvenue sur votre tableau de bord",
  stats: "Vos statistiques",
  recentActivity: "Activité récente",
  dashboardTitle: "Tableau de bord",
  totalAmountCollected: "Montant total collecté",
  byCampaigns: "Par campagnes",
  campaignOne: "Campagne 1",
  campaignTwo: "Campagne 2",
  registeredUsers: "Utilisateurs inscrits",
  registeredUsersDescription: "Nombre total d'utilisateurs inscrits",
  kycVerified: "KYC vérifiés",
  kycVerifiedDescription: "Utilisateurs ayant complété la vérification KYC",
  investors: "Investisseurs",
  investorsDescription: "Investisseurs actifs sur la plateforme",
  myProjects: "Mes projets",
  activeProjects: "Portefeuille actif",
  distributorPerformance: "Performance du distributeur",
  lastYear: "Dernière année",
  filterByCampaigns: "Filtrer par campagnes",
  repartitionInvestissements: "Répartition de mes investissements",
  myOperations: "Mes opérations",
  averageYieldDescription: "Rendement annuel moyen sur mes investissements",
  averageYield: "Rendement Moyen",
  receivedRevenues: "Revenus Perçus",
  receivedRevenuesDescription: "Revenus perçus depuis mon inscription",
  investedAmountDescription: "Montant investi depuis mon inscription",
  investedAmount: "Montant investi",
  addProject: "Ajouter un projet",
  noAmountCollectedTitle: "Aucune donnée disponible",
  noAmountCollectedDescription: "Il n'y a pas de données de montant collecté à afficher pour le moment.",
  noDistributorData: "Aucune partenaire ajouté",
  noDistributorDataDescription: "Invitez vos distributeurs",
  noRevenuesTitle: "Aucun revenu perçu",
  noRevenuesDescription: "vous n'avez pas encore perçu de revenu pour la période selectionnée",
  projectInvestment: "Investir sur un projet",
  noInvestmentsTitle: "Aucun Investissement",
  noInvestmentsDescription: "Une fois vos investissements réalisés, vous trouverez leur répartition par catégories ici.",
  makeFirstInvestment: "Réaliser mon premier investissement",
  seasonalPerformance: "Performance saisonnière",
  welcomeBanner: "<strong>Bienvenue dans votre espace membre Kapi Club.</strong><br />Le club-deal Collection Goldstone est ouvert à l'investissement jusqu'au 17/01/2025.<br />Vous pouvez investir via cet espace ou contacter l'équipe Kapi sur <a href='mailto:hello@kapi.club' class='underline text-primary-500 hover:text-primary-600'>hello@kapi.club</a> pour toute question.",
  backToSeasons: "Retour aux saisons",
  backToYears: "Retour aux années",
  amountPerYear: "Montant par année",
  amountPerCampaign: "Montant par campagne",
  errorLoadingData: "Erreur de chargement des données"
}, g7 = {
  dashboard: m7
}, m8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  dashboard: m7,
  default: g7
}, Symbol.toStringTag, { value: "Module" })), v7 = {
  distribution: "Distribution",
  payoutDetails: "Détails du pay-out",
  totalAmount: "Montant total",
  fees: "Frais",
  period: "Période",
  status: "Statut",
  investors: "Investisseurs",
  payoutError: "Erreur lors du chargement des données de pay-out",
  id: "ID",
  name: "Nom",
  price: "Prix",
  batches: "Parts",
  actions: "Actions",
  viewDetails: "Voir les détails",
  year: "Année",
  month: "Mois",
  amount: "Montant",
  parts: "Nombre de parts",
  submit: "Traiter le paiement",
  crud: {
    list: {
      title: "Gestion",
      searchPlaceholder: "Rechercher des projets...",
      noItemsFound: "Aucun projet trouvé"
    }
  }
}, y7 = {
  management: v7
}, g8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: y7,
  management: v7
}, Symbol.toStringTag, { value: "Module" })), b7 = {
  "orders-user": {
    crud: {
      list: {
        title: "Mes investissements",
        searchPlaceholder: "Rechercher des investissements...",
        noItemsFound: "Aucun investissement trouvé"
      },
      create: {
        title: "Créer un investissement"
      },
      update: {
        title: "Modifier l'investissement"
      }
    }
  }
}, v8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: b7
}, Symbol.toStringTag, { value: "Module" })), w7 = {
  title: "Mes investissements",
  user: "Utilisateur",
  projectName: "Projet",
  amount: "Montant",
  quantity: "Parts achetées",
  status: "Statut",
  createdAt: "Date d'investissement",
  batchValue: "Valeur de la part",
  signature: "Signature",
  payment: "Paiement",
  yes: "Oui",
  no: "Non",
  documents: "Documents",
  "documents.doc": "Doc {{number}}",
  campaign: {
    batches: "Parts Totales"
  },
  yield: "Rendement",
  execute: "Exécuter",
  refreshStatus: "Actualiser le statut",
  failedToExecute: "Échec de l'exécution de l'ordre",
  errors: {
    noCampaign: "Aucune campagne disponible trouvée pour ce projet",
    createOrder: "Erreur lors de la création de la commande",
    checkStatus: "Erreur lors de la vérification du statut"
  },
  statuses: {
    pending: "En attente",
    completed: "Terminé",
    failed: "Failed",
    cancelled: "Annulé",
    expired: "Expiré",
    funded: "Financé",
    valid: "Validé",
    refunded: "Remboursé",
    rejected: "Rejeté",
    executed: "Exécuté",
    unknown: "Inconnu",
    NOAS: "Non disponible"
  },
  actions: {
    checkStatus: "Vérifier le statut",
    executeOrder: "Exécuter l'ordre",
    continue: "Continuer",
    refresh: "Actualiser",
    execute: "Exécuter",
    download: "Télécharger"
  },
  crud: {
    list: {
      title: "Mes investissements",
      searchPlaceholder: "Rechercher des investissements...",
      noItemsFound: "Aucun investissement trouvé"
    },
    create: {
      title: "Créer un investissement"
    },
    update: {
      title: "Modifier l'investissement"
    }
  }
}, x7 = {
  orders: w7
}, y8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: x7,
  orders: w7
}, Symbol.toStringTag, { value: "Module" })), _7 = {
  kycProcess: "Processus KYC",
  kycStatus: "Statut KYC",
  title: "Mon Profil",
  personalInfo: "Informations personnelles",
  firstName: "Prénom",
  lastName: "Nom",
  email: "Email",
  nationality: "Nationalité",
  birthDate: "Date de naissance",
  birthCity: "Ville de naissance",
  address: "Adresse",
  phoneNumber: "Numéro de téléphone",
  streetNumber: "Numéro de rue",
  streetName: "Nom de rue",
  postalCode: "Code postal",
  city: "Ville",
  country: "Pays",
  blockchainInfo: "Informations blockchain",
  walletAddress: "Adresse du portefeuille",
  whitelisted: "Whitelisté",
  notWhitelisted: "Non whitelisté",
  birthCountry: "Pays de naissance",
  residenceCountry: "Pays de résidence",
  contactInfo: "Coordonnées",
  companyName: "Nom de l'entreprise",
  siren: "SIREN",
  qualified: "Statut Qualifié",
  status: "Statut du compte",
  kycSteps: {
    registration: "Enregistrement",
    verification: "Vérification",
    active: "Actif"
  }
}, S7 = {
  profile: _7
}, b8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: S7,
  profile: _7
}, Symbol.toStringTag, { value: "Module" })), E7 = {
  name: "Nom",
  creationDate: "Date de création",
  remainingTokens: "Tokens restants",
  id: "ID",
  searchPlaceholder: "Rechercher des projets...",
  editProject: "Modifier le projet",
  deleteProject: "Supprimer le projet",
  createProject: "Créer un projet",
  myProjects: "Mes projets",
  overview: "Mes projets",
  activeProjects: "Projets actifs",
  title: "Projets",
  activePortfolio: "Portefeuille actif",
  formTitle: "Formulaire de projet",
  defaultName: "Projet sans titre",
  defaultLocation: "Localisation inconnue",
  financed: "financés",
  investors: "Investisseurs",
  targetYield: "Rendement cible",
  netYield: "Rendement net",
  perYear: "par an",
  description: "Description du projet",
  investmentReasons: "Motifs d'investissement",
  street: "Rue",
  number: "Numéro",
  postalCode: "Code postal",
  city: "Ville",
  country: "Pays",
  latitude: "Latitude",
  longitude: "Longitude",
  type: "Type",
  documents: "Documents",
  activeCampaignBanner: "Campagne en cours",
  startDate: "Date de début",
  campaignDuration: "Durée de la campagne",
  shareValue: "Valeur des parts",
  sharesForSale: "Parts à vendre",
  generalInfo: "Informations générales",
  createStatus: "Statut de création",
  generalInfoDescription: "Description des informations générales",
  investmentReasonsDescription: "Description des motifs d'investissement",
  descriptionStepDescription: "Description de la description",
  locationDescription: "Description de la localisation",
  filesDescription: "Description des fichiers",
  updateTitle: "Mettre à jour le projet",
  paymentWindowOpened: "Une nouvelle fenêtre a été ouverte pour compléter votre paiement",
  reopenPayment: "Réouvrir la fenêtre de paiement",
  waitingForPayment: "Veuillez compléter le paiement dans la fenêtre ouverte",
  retryPayment: "Réessayer le paiement",
  completeAndSignDocument: "Compléter et signer le document pour accéder à l'étape suivante",
  totalInvestment: "Montant total de l'investissement :",
  validatingSignature: "Validation de la signature...",
  signatureValidationFailed: "Validation de la signature échouée après plusieurs tentatives",
  signatureCheckError: "Erreur lors de la vérification du statut de la signature",
  retrySignatureCheck: "Réessayer la vérification de la signature",
  paymentTimeoutError: "Le délai de paiement a expiré. Veuillez réessayer.",
  checkPaymentManually: "Le paiement prend plus de temps que prévu. Vous pouvez rafraîchir manuellement pour vérifier son statut.",
  refreshPaymentStatus: "Rafraîchir le statut",
  reopenPaymentWindow: "Rouvrir la fenêtre de paiement",
  error: "Erreur sur le projet",
  saveDraft: "Brouillon",
  steps: {
    form: "Détails de l'investissement",
    signature: "Signature des documents",
    payment: "Paiement",
    confirm: "Confirmation d'investissement",
    complete: "Terminé"
  },
  targetSort: "Rendement cible",
  netTaxes: "/an・net de frais",
  targetDuration: "Durée cible",
  yearly: "ans",
  access: "Accéder",
  paymentInstructions: "Cliquez ci-dessous pour procéder au paiement dans un nouvel onglet",
  signatureInstructions: "Cliquez ci-dessous pour signer les documents dans un nouvel onglet",
  investmentComplete: "Votre processus d'investissement est terminé !",
  proceedToPayment: "Procéder au paiement",
  proceedToSignature: "Procéder à la signature",
  paymentInProgress: "Paiement en cours",
  paymentWindowClosed: "La fenêtre de paiement a été fermée",
  checkSignatureStatus: "Vérifier le statut de la signature",
  continueToPayment: "Continuer vers le paiement",
  confirmInvest: "Confirmer l'investissement",
  investmentSuccessMessage: "Votre investissement a été traité avec succès",
  popupBlocked: "Fenêtre pop-up bloquée",
  popupBlockedMessage: "Veuillez autoriser les popups pour ce site pour procéder avec le paiement",
  openPayment: "Ouvrir la fenêtre de paiement",
  processingPayment: "Traitement de votre paiement",
  paymentCheckError: "Erreur lors de la vérification du statut du paiement. Veuillez réessayer.",
  noBatchesAvailable: "Aucune parts restantes pour le moment, veuillez réessayer ultérieurement ou contacter le support",
  investInProject: "Investir pour le projet : {{projectName}}",
  fallbackPaymentMessage: "Si vous avez des difficultés à ouvrir la fenêtre de paiement, veuillez procéder dans un nouvel onglet en cliquant sur le bouton suivant :",
  openPaymentNewTab: "Ouvrir dans un nouvel onglet",
  timeline: {
    title: "Dates-clés du projet"
  },
  tooltips: {
    targetYield: "Représente le rendement annuel moyen attendu d'un investissement, après déduction des frais, sur une période donnée.",
    netYield: "Rendement net après frais et impôts",
    investors: "Nombre d'investisseurs actuel dans ce projet",
    duration: "Période prévue d'investissement afin d'atteindre les objectifs."
  },
  errors: {
    orderCreationFailed: "Erreur lors de la création de la commande. Veuillez réessayer.",
    paymentFailed: "Vérification du paiement échouée. Veuillez réessayer ou contacter le support.",
    orderCreation: "Erreur lors de la création de la commande",
    orderStatus: "Erreur lors de la vérification du statut",
    invalidQuantity: "Quantité invalide"
  },
  orderSummary: "Résumé de la commande",
  targetAmount: "Montant recherché",
  pendingPayment: "Paiement en attente",
  awaitingPayment: "En attente de paiement",
  loading: "Chargement...",
  quantity: "Nombre de parts",
  orderStatus: "Statut de la commande",
  projectName: "Nom du projet",
  signatureRequired: "Signature requise",
  waitingForSignature: "En attente de signature...",
  retrySignature: "Réessayer la signature",
  orderComplete: "Commande terminée",
  orderCompleteMessage: "Votre commande a été complétée avec succès",
  investmentAmount: "Montant de l'investissement",
  orderProcessing: "Traitement de la commande",
  orderError: "Erreur de commande",
  tryAgain: "Réessayer",
  showProgressBar: "Afficher la barre de progression",
  extraAmount: "Montant supplémentaire",
  success: {
    orderCreated: "Commande créée avec succès",
    paymentCompleted: "Paiement effectué avec succès"
  },
  strategy: {
    name: "Stratégie",
    title: "Stratégie d'investissement"
  },
  features: {
    title: "Caractéristiques de l'actif"
  },
  price: "Prix",
  pricePerShare: "Prix de la part",
  minimumShares: "Nombre minimum de parts",
  minimumInvestment: "Montant minimum d'investissement",
  futureCapital: "Capital futur",
  gains: "Gains",
  investedAmount: "Montant investi",
  averageRevenue: "Revenu moyen",
  occupancyRate: "Taux d'occupation",
  batches: "Nombre de parts",
  reasons: {
    label: "Pourquoi investir ?",
    title: "Titre",
    description: "Description"
  },
  finance: {
    title: "Finance",
    image: "Document finance",
    resale: {
      title: "Revente",
      priceAfterRenovation: "Prix du bien après rénovation",
      holdingPeriod: "Durée de détention",
      annualRevaluation: "Revalorisation annuelle",
      estimatedResaleAmount: "Montant estimé de revente"
    },
    yields: {
      title: "Rendements",
      kpi_1: "Kpi 1",
      kpi_2: "Kpi 2"
    },
    charges: {
      title: "Charges",
      maintenance: "Maintenance générale",
      taxes: "Taxes",
      energy: "Énergie & consommables",
      worksFund: "Fonds de travaux",
      managementFees: "Frais de gestion sur les revenus"
    },
    revenues: {
      title: "Revenus",
      dailyAverage: "Revenu quotidion moyen",
      energy: "Energie & consommables"
    },
    investment: {
      title: "Investment",
      purchasePrice: "Prix d'achat",
      notaryFees: "Frais de notaire",
      huntingFees: "Frais de chasse",
      works: "Travaux",
      furnishing: "Ameublement et équipement",
      worksReserve: "Réserve travaux",
      subscriptionFee: "Commission de souscription"
    },
    results: {
      title: "Résultats",
      annualOperational: "Résultat opérationnel annuel",
      annualFinancial: "Résultat financier annuel",
      annualNetEstimated: "Résultat net annuel estimé par Fraktion",
      totalAnnualCharges: "Total charges annuelles estimées"
    }
  },
  location: {
    title: "Localisation",
    streetName: "Rue",
    streetNumber: "Numéro",
    postalCode: "Code postal",
    city: "Ville",
    country: "Pays",
    details: "Informations sur le lieu"
  },
  urls: {
    title: "Médias",
    link: "Lien",
    thumbnail: "Miniature"
  },
  files: {
    title: "Fichiers",
    mainImage: "Image principale",
    additionalImages: "Images additionnelles",
    documents: "Documents",
    links: "Documents",
    terms: "PDF réglementation",
    images: "Images"
  },
  news: {
    title: "Actualités",
    imageUrl: "URL de l'image",
    sourceUrl: "URL de la source"
  },
  presentation: {
    title: "Présentation de votre Actif"
  },
  investmentOpportunity: "Investissement",
  completeProfile: "Compléter votre profil",
  general: {
    title: "Général"
  },
  advantages: {
    title: "Avantages"
  },
  investmentProgress: {
    title: "Investissement"
  },
  projectLocation: "Localisation du projet",
  mapPlaceholder: "La carte sera affichée ici",
  callAdvisor: "Appel à un conseiller",
  whyInvest: "Pourquoi investir ?",
  transactions: "Transactions",
  daysLeft: "jours restants",
  fundingProgress: "Progression de la collecte",
  charges: "Charges",
  revenues: "Revenus",
  results: "Résultats",
  investment: "Simulateur d'investissement",
  resale: "Revente",
  terms: "Conditions générales",
  documentAvailable: "Document disponible",
  estimatedGains: "Gains estimés",
  invest: "Investir",
  noProjectsAdded: "Aucun projet ajouté",
  findProjectsInSection: "Retrouvez tous vos projets dans cette section",
  addFirstProject: "Ajouter mon premier projet",
  moreImages: "Plus d'images",
  seeImages: "Voir les images",
  crud: {
    list: {
      title: "Gestion des projets",
      createButton: "Créer un projet",
      searchPlaceholder: "Rechercher des projets...",
      noItemsFound: "Aucun projet trouvé",
      publishedSuccess: "Projet publié avec succès",
      draftSuccess: "Projet mis en brouillon avec succès",
      draftToggleError: "Erreur lors de la modification du statut du projet"
    },
    create: {
      title: "Créer un projet",
      success: "Projet créé avec succès"
    },
    update: {
      title: "Mettre à jour le projet",
      success: "Projet mis à jour avec succès"
    },
    delete: {
      confirmation: "Êtes-vous sûr de vouloir supprimer ce projet?",
      success: "Projet supprimé avec succès"
    }
  },
  startsOn: "Commence le {{date}}",
  comingSoon: "Bientôt disponible",
  status: {
    title: "Statut",
    published: "Publié",
    draft: "Brouillon",
    available: "En cours",
    created: "Créé",
    expired: "Date dépassée",
    canceled: "Annulé",
    closed: "Clôturé",
    minted: "Financé",
    valid: "Valide",
    info: {
      title: "Information Générale",
      description: "Description générale de votre projet"
    },
    finance: {
      title: "Détails Financiers",
      description: "Validation de vos chiffres clés"
    },
    presentation: {
      title: "Présentation de votre Actif",
      description: "Intégration de vos médias et documents"
    },
    location: {
      title: "Information sur la localisation",
      description: "Détailler la situation géographique de votre actif"
    }
  },
  downloadRib: "Télécharger le RIB",
  downloadRibDescription: "Télécharger le RIB si vous souhaitez effectuer un virement bancaire standard",
  url: "URL",
  privateCampaign: "Privé",
  simulation: {
    title: "Simulation d'investissement",
    rate: "Rentabilité Cible",
    duration: "Durée de l'investissement",
    durationType: "Type de durée",
    min: "Durée minimale",
    max: "Durée maximale",
    years: "an",
    months: "mois"
  }
}, T7 = {
  noProjects: "Aucun projet disponible pour le moment",
  noProjectsDescription: "Il n'y a actuellement aucune opportunité d'investissement disponible. Veuillez revenir plus tard pour découvrir de nouveaux projets.",
  checkBackLater: "Aller au Tableau de bord"
}, C7 = {
  projects: E7,
  marketplace: T7
}, w8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: C7,
  marketplace: T7,
  projects: E7
}, Symbol.toStringTag, { value: "Module" })), k7 = {
  title: "Support",
  noContentAvailable: "Pas de contenu de support disponible pour le moment. Veuillez vérifier plus tard.",
  faq: {
    title: "FAQ",
    items: "Éléments FAQ",
    addItem: "Ajouter un élément FAQ"
  },
  updateSuccess: "Paramètres de support mis à jour avec succès",
  updateError: "Erreur lors de la mise à jour des paramètres de support",
  contact: {
    title: "Informations de contact",
    email: "Email de support",
    link: "Lien de contact",
    registrationLink: "Lien d'inscription personnalisé",
    yourEmail: "Votre email",
    message: "Votre message",
    emailSubject: "Sujet du message",
    emailUpdateSuccess: "Configuration email mise à jour avec succès",
    emailUpdateError: "Erreur lors de la mise à jour de la configuration email",
    emailSentSuccess: "Message envoyé avec succès",
    emailSentError: "Erreur lors de l'envoi du message"
  },
  dashboard: {
    topbanner: "Bannière supérieure",
    title: "Informations du tableau de bord",
    content: "Contenu de la bannière supérieure",
    color: "Couleur",
    icon: "Icône",
    route: "Route de redirection"
  }
}, O7 = {
  support: k7
}, x8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: O7,
  support: k7
}, Symbol.toStringTag, { value: "Module" })), A7 = {
  "user-lists": {
    crud: {
      list: {
        title: "Listes d'utilisateurs",
        searchPlaceholder: "Rechercher une liste",
        noItemsFound: "Aucune liste trouvée"
      },
      update: {
        title: "Mettre à jour la liste"
      },
      create: {
        title: "Créer une liste"
      }
    },
    name: "Nom de la liste",
    description: "Description",
    basicInfo: "Informations de base",
    members: "Membres de la liste",
    selectUsers: "Sélectionner des utilisateurs",
    membersHelperText: "Sélectionnez les utilisateurs à ajouter à cette liste",
    unnamed: "Liste sans nom",
    exportPreparing: "Préparation de l'export pour la liste :",
    exportComplete: "Export terminé pour la liste :",
    exportError: "Erreur lors de l'export des données de la liste",
    createError: "Erreur lors de la création de la liste",
    updateError: "Erreur lors de la mise à jour de la liste",
    createSuccess: "Liste créée avec succès",
    updateSuccess: "Liste mise à jour avec succès",
    viewList: "Voir la liste : {{name}}",
    details: "Détails",
    addUsersToList: "Ajouter des utilisateurs à la liste",
    selectUsersToAdd: "Sélectionner des utilisateurs à ajouter",
    loading: "Chargement des utilisateurs...",
    addingUsers: "Ajout des utilisateurs à la liste...",
    usersAddedSuccess: "Utilisateurs ajoutés à la liste avec succès",
    errorAddingUsers: "Erreur lors de l'ajout des utilisateurs à la liste",
    errorLoadingUsers: "Erreur lors du chargement des utilisateurs",
    loadError: "Erreur lors du chargement des membres de la liste",
    noUsersFound: 'Aucun utilisateur trouvé correspondant à "{{term}}"',
    noAvailableUsers: "Aucun utilisateur disponible à ajouter",
    allUsersAlreadyInList: "Tous les utilisateurs sont déjà dans cette liste",
    removeFromList: "Retirer de la liste",
    removingUser: "Suppression de l'utilisateur de la liste...",
    userRemovedSuccess: "Utilisateur retiré de la liste avec succès",
    errorRemovingUser: "Erreur lors de la suppression de l'utilisateur de la liste"
  }
}, _8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: A7
}, Symbol.toStringTag, { value: "Module" })), P7 = {
  id: "ID",
  email: "Email",
  isActive: "Est actif",
  isAdmin: "Est admin",
  password: "Mot de passe",
  addUser: "Ajouter un utilisateur",
  searchPlaceholder: "Rechercher des utilisateurs...",
  createdAt: "Créé à",
  updatedAt: "Mis à jour à",
  active: "Actif",
  inactive: "Inactif",
  viewUser: "Voir l'utilisateur",
  editUser: "Modifier l'utilisateur",
  deleteUser: "Supprimer l'utilisateur",
  createUser: "Créer un utilisateur",
  firstName: "Prénom",
  lastName: "Nom",
  nationality: "Nationalité",
  updateTitle: "Mettre à jour l'utilisateur",
  updateUser: "Mettre à jour l'utilisateur",
  createTitle: "Créer un utilisateur",
  deleteConfirmation: "Êtes-vous sûr de vouloir supprimer cet utilisateur?",
  personalInfo: "Informations personnelles",
  registrationComplete: "Inscription complète",
  registrationDescription: "Utilisateur enregistré avec succès dans le système.",
  verificationStatus: "Statut de vérification",
  verificationComplete: "Le compte utilisateur a été vérifié.",
  verificationPending: "La vérification du compte utilisateur est en attente.",
  adminStatus: "Statut d'admin",
  adminActive: "L'utilisateur a des privilèges d'admin.",
  adminInactive: "L'utilisateur n'a pas de privilèges d'admin.",
  verifyUser: "Vérifier l'utilisateur",
  invitationLink: "Lien d'invitation",
  addNote: "Ajouter une note",
  addNotePlaceholder: "Ajouter une note à l'utilisateur",
  kycProcessValidated: "Processus KYC validé",
  kycProcessPending: "Processus KYC en attente",
  kycProcessNotStarted: "Processus KYC non démarré",
  validateKYC: "Valider KYC",
  kind: "Type de compte",
  individual: "Particulier",
  company: "Entreprise",
  investorRegistered: "Utilisateur enregistré",
  identityVerificationInProgress: "Vérification d'identité en cours",
  validRegistration: "Inscription valide",
  verificationInProgress: "Vérification en cours",
  name: "Nom",
  registrationDate: "Date d'inscription",
  investedAmount: "Montant investi",
  formTitle: "Formulaire utilisateur",
  birthDate: "Date de naissance",
  birthPlace: "Lieu de naissance",
  phoneNumber: "Numéro de téléphone",
  address: "Adresse",
  postalCode: "Code postal",
  city: "Ville",
  country: "Pays",
  streetNumber: "Numéro de rue",
  birthCountry: "Pays de naissance",
  streetName: "Nom de rue",
  birthCity: "Ville de naissance",
  statusTitle: "Statut",
  creationDate: "Date de création",
  residenceCountry: "Pays de résidence",
  birthday: "Date de naissance",
  companyName: "Nom de l'entreprise",
  siren: "SIREN",
  crud: {
    list: {
      title: "Gestion des utilisateurs",
      createButton: "Créer un utilisateur",
      searchPlaceholder: "Rechercher des utilisateurs...",
      noItemsFound: "Aucun investisseur trouvé"
    },
    create: {
      title: "Créer un utilisateur",
      success: "Utilisateur créé avec succès"
    },
    update: {
      title: "Mettre à jour un utilisateur",
      success: "Utilisateur mis à jour avec succès"
    }
  },
  status: {
    title: "Statut Utilisateur",
    uninitiated: "Non initié",
    initiated: "Initié",
    initiatedDesc: "L'utilisateur a commencé le processus d'inscription",
    kyced: "KYC validé",
    kycedDesc: "Processus de vérification d'identité",
    active: "Actif",
    activeDesc: "Utilisateur entièrement vérifié et actif",
    blockchained: "Blockchainé",
    blockchinedDesc: "Utilisateur intégré avec la blockchain",
    kyc: {
      title: "KYC",
      completed: "Processus KYC terminé",
      pending: "Processus KYC en cours",
      not_started: "Processus KYC non démarré",
      force_kyc: "Forcer KYC"
    }
  },
  kycStatus: {
    title: "Statut KYC",
    not_started: "KYC non démarré",
    pending: "KYC en cours",
    succeeded: "KYC réussi",
    canceled: "KYC annulé",
    failed: "KYC échoué",
    unknown: "KYC statut inconnu"
  },
  activeUser: "Investisseur actif",
  actions: {
    forceKyc: "Forcer la validation KYC",
    forceKycSuccess: "Validation KYC forcée avec succès",
    forceKycError: "Erreur lors du forçage de la validation KYC",
    sendLink: "Envoyer lien d'activation",
    sendLinkSuccess: "Lien d'activation envoyé avec succès",
    sendLinkError: "Erreur lors de l'envoi du lien d'activation"
  },
  qualified: "Privé",
  qualifiedDescription: "Si activé, cet utilisateur pourra voir les campagnes privées",
  qualifiedTag: "Privé",
  notQualifiedTag: "Public",
  select: "Sélectionner un utilisateur",
  lists: {
    name: "Nom de la liste",
    description: "Description",
    basicInfo: "Informations de base",
    create: "Créer une liste",
    update: "Mettre à jour la liste",
    delete: "Supprimer la liste",
    view: "Voir la liste",
    unnamed: "Liste sans nom",
    userAdded: "Utilisateur ajouté à la liste avec succès",
    userRemoved: "Utilisateur retiré de la liste avec succès",
    addError: "Erreur lors de l'ajout de l'utilisateur à la liste",
    removeError: "Erreur lors du retrait de l'utilisateur de la liste",
    members: "Membres de la liste",
    details: "Détails de la liste",
    addUser: "Ajouter un utilisateur à la liste",
    noUsers: "Aucun utilisateur dans cette liste",
    userLists: "Listes",
    noLists: "Aucune liste",
    manageLists: "Listes de marketing",
    createList: "Créer une liste de marketing",
    updateList: "Mettre à jour la liste de marketing",
    deleteConfirmation: "Êtes-vous sûr de vouloir supprimer cette liste?",
    listDeleteSuccess: "Liste supprimée avec succès",
    userManagement: "Gestion des utilisateurs",
    selectUsers: "Sélectionner des utilisateurs",
    membersHelperText: "Sélectionnez les utilisateurs à ajouter à cette liste",
    exportPreparing: "Préparation de l'export pour la liste",
    exportComplete: "Export terminé pour la liste",
    exportError: "Erreur lors de l'export des données de la liste",
    status: {
      title: "Progression de la configuration"
    },
    basicInfoStep: "Informations de base",
    basicInfoStepDesc: "Définir le nom et la description de la liste",
    membersStep: "Membres de la liste",
    membersStepDesc: "Ajouter des utilisateurs à votre liste"
  }
}, R7 = {
  users: P7
}, S8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: R7,
  users: P7
}, Symbol.toStringTag, { value: "Module" })), I7 = {
  addressTitle: "Informations de l'adresse",
  streetNumber: "Numéro de rue",
  streetName: "Nom de rue",
  postalCode: "Code postal",
  fetchError: "Erreur lors de la récupération des informations du compte bancaire",
  updateSuccess: "Informations du compte bancaire mises à jour avec succès",
  updateError: "Erreur lors de la mise à jour des informations du compte bancaire",
  city: "Ville",
  country: "Pays",
  details: "Informations supplémentaires",
  required: "Ce champ est requis",
  bankAccountTitle: "Informations du compte bancaire",
  bankAccountDisclaimer: "Veuillez entrer vos informations de compte bancaire pour recevoir des paiements",
  iban: "IBAN",
  bic: "BIC/SWIFT",
  invalidIban: "Veuillez entrer un IBAN valide (minimum 15 caractères)",
  invalidBic: "Veuillez entrer un BIC valide (minimum 8 caractères)",
  title: "Portefeuille",
  balance: "Solde",
  addFunds: "Ajouter des fonds",
  withdraw: "Retirer",
  transactions: "Transactions",
  noTransactions: "Aucune transaction trouvée",
  lastUpdated: "Dernière mise à jour : {{time}}",
  error: "Erreur de portefeuille",
  comingSoon: "Bientôt disponible",
  kycRequired: "Vérification KYC requise",
  kycRequiredDescription: "Pour utiliser les fonctionnalités du portefeuille, vous devez compléter la vérification KYC",
  completeKyc: "Compléter la vérification KYC",
  kycVerified: "KYC vérifié",
  addBankAccount: "Ajouter un compte bancaire",
  bankDetails: "Détails du compte bancaire",
  quickActions: "Actions rapides",
  invalidAmount: "Montant invalide. Veuillez entrer entre {{min}} et {{max}}",
  amountPlaceholder: "Entrer le montant",
  amountHelp: "Min : {{min}} - Max : {{max}}",
  paymentMethods: "Moyens de paiement",
  proceed: "Continuer",
  confirmWithdrawal: "Confirmer le retrait",
  infoTitle: "Informations importantes",
  infoMessage: "Les délais de traitement peuvent varier selon votre banque",
  type: "Type",
  amount: "Montant",
  bankAccounts: "Comptes bancaires",
  addNew: "Ajouter",
  bankAccountEnding: "Compte se terminant par {{last4}}",
  noBankAccountsYet: "Aucun compte bancaire ajouté",
  withdrawalTitle: "Retrait de fonds",
  withdrawalDescription: "Retirez des fonds vers votre compte bancaire",
  addFundsTitle: "Ajouter des fonds",
  addFundsDescription: "Ajoutez des fonds à votre portefeuille",
  availableBalance: "Solde disponible",
  minimumAmount: "Montant minimum",
  maximumAmount: "Montant maximum",
  processingFees: "Frais de traitement",
  totalAmount: "Montant total",
  bankAccountRequired: "Un compte bancaire est requis pour effectuer un retrait",
  addBankAccountFirst: "Veuillez d'abord ajouter un compte bancaire",
  insufficientFunds: "Solde insuffisant",
  transferDetails: "Détails du transfert",
  transferId: "ID de transfert",
  transferDate: "Date du transfert",
  transferStatus: "Statut du transfert",
  noTransactionsFound: "Aucune transaction trouvée",
  noBankAccountTitle: "Aucun compte bancaire",
  noBankAccountDescription: "Veuillez d'abord ajouter un compte bancaire",
  infoBanner: "Votre IBAN est nécessaire pour recevoir vos gains ou remboursements. Il sera utilisé uniquement pour des transactions sécurisées, dans le respect des normes de confidentialité.",
  status: {
    title: "Statut",
    succeeded: "Réussi",
    failed: "Échoué",
    pending: "En attente",
    created: "Créé"
  },
  transactionTypes: {
    payin: "Dépôt",
    payout: "Retrait",
    transfer: "Virement"
  },
  date: "Date",
  fees: "Frais",
  address: {
    streetNumber: "Numéro de rue",
    streetName: "Nom de rue",
    postalCode: "Code postal",
    city: "Ville",
    country: "Pays"
  },
  crud: {
    list: {
      title: "Gestion du portefeuille",
      createButton: "Créer un portefeuille",
      searchPlaceholder: "Rechercher des portefeuilles...",
      noItemsFound: "Aucun portefeuille trouvé"
    },
    create: {
      title: "Créer un portefeuille",
      success: "Portefeuille créé avec succès"
    },
    update: {
      title: "Mettre à jour le portefeuille",
      success: "Portefeuille mis à jour avec succès"
    },
    delete: {
      confirmation: "Êtes-vous sûr de vouloir supprimer ce portefeuille?",
      success: "Portefeuille supprimé avec succès"
    }
  }
}, D7 = {
  wallet: I7
}, E8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: D7,
  wallet: I7
}, Symbol.toStringTag, { value: "Module" }));
async function T8e(e) {
  try {
    const t = e.split("-")[0], r = /* @__PURE__ */ Object.assign({
      "./translations/en/auth.json": Y$e,
      "./translations/en/campaign-orders.json": X$e,
      "./translations/en/campaigns.json": Q$e,
      "./translations/en/common.json": J$e,
      "./translations/en/crud.json": Z$e,
      "./translations/en/dashboard.json": e8e,
      "./translations/en/management.json": t8e,
      "./translations/en/orders-user.json": r8e,
      "./translations/en/orders.json": n8e,
      "./translations/en/profile.json": a8e,
      "./translations/en/projects.json": s8e,
      "./translations/en/support.json": i8e,
      "./translations/en/user-lists.json": o8e,
      "./translations/en/users.json": l8e,
      "./translations/en/wallet.json": c8e,
      "./translations/fr/auth.json": u8e,
      "./translations/fr/campaign-orders.json": d8e,
      "./translations/fr/campaigns.json": f8e,
      "./translations/fr/common.json": h8e,
      "./translations/fr/crud.json": p8e,
      "./translations/fr/dashboard.json": m8e,
      "./translations/fr/management.json": g8e,
      "./translations/fr/orders-user.json": v8e,
      "./translations/fr/orders.json": y8e,
      "./translations/fr/profile.json": b8e,
      "./translations/fr/projects.json": w8e,
      "./translations/fr/support.json": x8e,
      "./translations/fr/user-lists.json": _8e,
      "./translations/fr/users.json": S8e,
      "./translations/fr/wallet.json": E8e
    });
    let n = !1;
    Object.entries(r).forEach(([a, s]) => {
      var i;
      if (a.includes(`/${t}/`)) {
        const o = (i = a.split("/").pop()) == null ? void 0 : i.replace(".json", ""), l = s.default;
        o && !Zn.hasResourceBundle(t, o) && (Zn.addResourceBundle(
          t,
          o,
          l,
          !0,
          !0
        ), n = !0);
      }
    }), n && await Zn.reloadResources(t);
  } catch (t) {
    console.error("Error loading translations:", t);
  }
}
function $et() {
  return Zn.use(X8).use(hQ).init({
    fallbackLng: "fr",
    supportedLngs: ["en", "fr"],
    load: "languageOnly",
    defaultNS: "common",
    // detection: {
    //   order: ["localStorage", "navigator"],
    //   lookupLocalStorage: "i18nextLng",
    //   caches: ["localStorage"],
    // },
    interpolation: {
      escapeValue: !1
    }
  }), T8e("fr"), Zn;
}
const C8e = {
  auth: J8,
  campaignOrders: Z8,
  campaigns: tH,
  common: xH,
  crud: SH,
  dashboard: TH,
  management: kH,
  ordersUser: OH,
  orders: PH,
  profile: IH,
  projects: MH,
  support: jH,
  userLists: FH,
  users: UH,
  wallet: $H
}, k8e = {
  auth: WH,
  campaignOrders: zH,
  campaigns: qH,
  common: f7,
  crud: p7,
  dashboard: g7,
  management: y7,
  ordersUser: b7,
  orders: x7,
  profile: S7,
  projects: C7,
  support: O7,
  userLists: A7,
  users: R7,
  wallet: D7
}, Het = {
  en: C8e,
  fr: k8e
}, N7 = (e) => [...e].sort((t, r) => {
  var s, i;
  const n = Mb(t), a = Mb(r);
  if (n === a) {
    const o = (s = t.info) != null && s.start_date ? new Date(t.info.start_date) : /* @__PURE__ */ new Date(0), l = (i = r.info) != null && i.start_date ? new Date(r.info.start_date) : /* @__PURE__ */ new Date(0);
    return o.getTime() - l.getTime();
  }
  return n - a;
}), O8e = s$((e, t) => ({
  campaigns: [],
  campaignsByStatus: {
    [Nr.Available]: [],
    [Nr.Created]: [],
    [Nr.Canceled]: [],
    [Nr.Closed]: [],
    [Nr.Minted]: []
  },
  isLoading: !1,
  error: null,
  fetchCampaigns: async (r, n) => {
    e({ isLoading: !0, error: null });
    try {
      let a;
      Array.isArray(n == null ? void 0 : n.status) ? a = n.status : typeof (n == null ? void 0 : n.status) == "string" && (a = [n.status]);
      const { status: s, isAdmin: i, _private: o, ...l } = n || {}, c = await r.campaignsApi.campaignsPage({
        ...l,
        status: a,
        _private: o
      }), u = N7(c.results || []), d = u.reduce(
        (f, h) => {
          const p = h.status;
          return f[p] = [...f[p] || [], h], f;
        },
        {}
      );
      e({ campaigns: u, campaignsByStatus: d });
    } catch {
      e({ error: "Failed to fetch campaigns" });
    } finally {
      e({ isLoading: !1 });
    }
  },
  getCampaignByProjectId: (r) => t().campaigns.find((n) => {
    var a;
    return ((a = n.project) == null ? void 0 : a.id) === r;
  }) || null
})), M7 = (e = {}) => {
  var a;
  const t = O8e(), r = sn(), n = Tn(() => {
    var i;
    const s = (i = e.filters) != null && i.status ? t.campaignsByStatus[e.filters.status] || [] : t.campaigns;
    return e.displayLimit ? s.slice(0, e.displayLimit) : s;
  }, [
    t.campaigns,
    t.campaignsByStatus,
    (a = e.filters) == null ? void 0 : a.status,
    e.displayLimit
  ]);
  return wt(() => {
    var o;
    const s = new AbortController(), i = e.isAdmin ? [
      ns.Created,
      ns.Available,
      ns.Minted,
      ns.Closed,
      ns.Canceled
    ] : (o = e.filters) != null && o.status ? [e.filters.status] : [
      Nr.Available,
      Nr.Minted,
      Nr.Closed,
      Nr.Canceled
    ];
    return t.fetchCampaigns(r, {
      ...e.filters,
      isAdmin: e.isAdmin,
      status: i
    }), () => s.abort();
  }, [JSON.stringify(e.filters), e.isAdmin]), {
    campaigns: n,
    getCampaignByProjectId: t.getCampaignByProjectId,
    isLoading: t.isLoading,
    error: t.error,
    refetch: () => {
      var i;
      const s = e.isAdmin ? [
        ns.Created,
        ns.Available,
        ns.Minted,
        ns.Closed,
        ns.Canceled
      ] : (i = e.filters) != null && i.status ? [e.filters.status] : [
        Nr.Available,
        Nr.Minted,
        Nr.Closed,
        Nr.Canceled
      ];
      return t.fetchCampaigns(r, {
        ...e.filters,
        isAdmin: e.isAdmin,
        status: s
      });
    }
  };
}, A8e = (e) => {
  var a, s;
  if (!e) return !1;
  const t = /* @__PURE__ */ new Date(), r = (a = e.info) != null && a.start_date ? new Date(e.info.start_date) : null, n = r && ((s = e.info) != null && s.duration) ? new Date(
    r.getTime() + e.info.duration * 24 * 60 * 60 * 1e3
  ) : null;
  return e.status === "available" && e.available > 0 && (!r || r <= t) && (!n || n > t);
}, P8e = () => /* @__PURE__ */ v.jsx("div", { children: "Configuration" });
qi.register(
  jc,
  Fc,
  Vf,
  To,
  Uh,
  Xc,
  Yc,
  Kk
);
const Wet = ({
  title: e,
  amount: t,
  percentageChange: r,
  isPositiveChange: n,
  startDate: a,
  endDate: s,
  onStartDateChange: i,
  onEndDateChange: o,
  selectedCampaign: l,
  campaignOptions: c,
  onCampaignChange: u,
  chartData: d,
  chartOptions: f
}) => {
  const { t: h } = _t(), p = (m, g) => {
    const y = m.createLinearGradient(0, 0, 0, m.canvas.height);
    return y.addColorStop(0, `${g}`), y.addColorStop(0.2, `${g}`), y.addColorStop(0.45, `${g}00`), y;
  };
  return /* @__PURE__ */ v.jsxs(hr, { header: e, size: "sm", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center mb-6", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ v.jsx("span", { className: "text-3xl font-semibold text-primary-800", children: t }),
        /* @__PURE__ */ v.jsxs(
          "span",
          {
            className: `text-sm ${n ? "text-green-500 bg-green-100" : "text-red-500 bg-red-100"} px-2 py-1 rounded-full`,
            children: [
              n ? "+" : "-",
              " ",
              r,
              " ",
              n ? "▲" : "▼"
            ]
          }
        )
      ] }),
      /* @__PURE__ */ v.jsxs("div", { className: "flex space-x-2", children: [
        /* @__PURE__ */ v.jsx("span", { className: "text-gray-500 self-center", children: h("common.dateFrom") }),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            type: "date",
            value: a.toISOString().split("T")[0],
            onChange: (m) => i(new Date(m.target.value)),
            className: "w-36"
          }
        ),
        /* @__PURE__ */ v.jsx("span", { className: "text-gray-500 self-center", children: h("common.dateTo") }),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            type: "date",
            value: s.toISOString().split("T")[0],
            onChange: (m) => o(new Date(m.target.value)),
            className: "w-36"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex space-x-2 mb-6", children: [
      /* @__PURE__ */ v.jsx("span", { className: "text-gray-500 self-center", children: h("dashboard.filterByCampaigns") }),
      /* @__PURE__ */ v.jsx(
        ss,
        {
          options: c,
          value: l,
          isMulti: !0,
          onChange: () => {
          },
          className: "w-full"
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx(
      Gk,
      {
        data: {
          ...d,
          datasets: d.datasets.map((m) => ({
            ...m,
            backgroundColor: (g) => {
              const y = g.chart.ctx;
              return p(y, m.backgroundColor);
            }
          }))
        },
        options: f
      }
    )
  ] });
};
qi.register(
  jc,
  Fc,
  Vf,
  To,
  Uh,
  Xc,
  Yc,
  Kk
);
const R8e = ({
  labels: e,
  datasets: t
}) => {
  const r = {
    labels: e,
    datasets: t.map((s) => ({
      ...s,
      backgroundColor: (i) => {
        const o = i.chart.ctx, l = o.createLinearGradient(0, 0, o.canvas.width, 0), c = s.color.replace("#", "");
        return l.addColorStop(
          0,
          `rgba(${parseInt(c.slice(0, 2), 16)}, ${parseInt(
            c.slice(2, 4),
            16
          )}, ${parseInt(c.slice(4, 6), 16)}, 0)`
        ), l.addColorStop(0.5, s.color), l;
      }
    }))
  }, n = {
    responsive: !0,
    maintainAspectRatio: !1,
    plugins: {
      legend: {
        display: !1
      },
      tooltip: {
        enabled: !1
      }
    },
    scales: {
      x: {
        grid: {
          display: !1
        }
      },
      y: {
        grid: {
          display: !1
        },
        ticks: {
          display: !1
        },
        border: {
          display: !1
        },
        beginAtZero: !0
      }
    },
    elements: {
      line: {
        tension: 0.4,
        borderWidth: 0
      },
      point: {
        radius: 0
      }
    },
    interaction: {
      mode: "index",
      intersect: !1
    }
  }, a = {
    id: "customLabels",
    afterDraw: (s) => {
      const i = s.ctx, o = s.scales.y, l = s.scales.x, c = s.data.datasets;
      i.save(), i.font = "12px Arial", i.textAlign = "right", i.textBaseline = "middle", c.forEach((u, d) => {
        const f = u.data, h = Math.min(...f), p = Math.max(...f), m = (o.getPixelForValue(h) + o.getPixelForValue(p)) / 1.8, g = l.right - 10, y = u.color;
        i.fillStyle = QX(y), i.fillText(u.label, g, m);
      }), i.restore();
    }
  };
  return /* @__PURE__ */ v.jsx("div", { className: "w-full h-64", children: /* @__PURE__ */ v.jsx(Gk, { data: r, options: n, plugins: [a] }) });
};
qi.register(Rf, Xc, Yc);
const zet = () => {
  const { t: e } = _t(["dashboard"]), t = {
    labels: [
      e("dashboard.doughnutLabel1"),
      e("dashboard.doughnutLabel2"),
      e("dashboard.doughnutLabel3")
    ],
    datasets: [
      {
        data: [50.3, 29.4, 20.3],
        backgroundColor: ["#4B78DF", "#91F2FF", "#2ABB72"],
        hoverBackgroundColor: ["#5B88EF", "#A1FFFF", "#3ACB82"]
      }
    ]
  }, r = {
    responsive: !0,
    maintainAspectRatio: !1,
    plugins: {
      legend: {
        display: !1
      },
      tooltip: {
        enabled: !0,
        callbacks: {
          label: (a) => `${a.label}: ${a.parsed}%`
        },
        bodyColor: "#fff",
        backgroundColor: "rgba(0, 0, 0, 0.8)"
      }
    },
    cutout: "70%"
  }, n = [-2.9, 5.9, 8.1];
  return /* @__PURE__ */ v.jsx(
    hr,
    {
      header: e("dashboard.doughnutChartTitle"),
      className: "h-full flex flex-col",
      children: /* @__PURE__ */ v.jsxs("div", { className: "flex-grow flex flex-col h-full space-y-6 p-4", children: [
        /* @__PURE__ */ v.jsx("div", { className: "flex-grow flex items-center justify-center mb-4", children: /* @__PURE__ */ v.jsx("div", { className: "w-full h-full max-w-64 max-h-64", children: /* @__PURE__ */ v.jsx(
          r$,
          {
            data: t,
            options: {
              ...r,
              plugins: {
                ...r.plugins,
                tooltip: {
                  ...r.plugins.tooltip,
                  bodyColor: "#fff",
                  backgroundColor: "rgba(0, 0, 0, 0.8)"
                }
              }
            }
          }
        ) }) }),
        /* @__PURE__ */ v.jsx("div", { className: "mt-auto space-y-4", children: t.labels.map((a, s) => /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center", children: [
          /* @__PURE__ */ v.jsxs("div", { className: "flex items-center", children: [
            /* @__PURE__ */ v.jsx(
              "div",
              {
                className: "w-4 h-4 rounded-full mr-2",
                style: {
                  backgroundColor: t.datasets[0].backgroundColor[s]
                }
              }
            ),
            /* @__PURE__ */ v.jsx("span", { className: "font-medium text-gray-900 dark:text-gray-100", children: a })
          ] }),
          /* @__PURE__ */ v.jsxs("div", { className: "flex items-center", children: [
            /* @__PURE__ */ v.jsxs("span", { className: "font-semibold mr-2 text-primary-600 dark:text-primary-400", children: [
              t.datasets[0].data[s],
              "%"
            ] }),
            /* @__PURE__ */ v.jsxs(
              "span",
              {
                className: `text-sm ${n[s] < 0 ? "text-red-500" : "text-green-500"}`,
                children: [
                  n[s] < 0 ? "▼" : "▲",
                  " ",
                  Math.abs(n[s]),
                  "%"
                ]
              }
            )
          ] })
        ] }, s)) })
      ] })
    }
  );
};
qi.register(Rf, Xc, Yc);
const I8e = ({
  data: e,
  percentageChanges: t
}) => {
  const { t: r } = _t(["dashboard"]), n = ta(), a = e.datasets[0].data.some((i) => i > 0), s = {
    responsive: !0,
    maintainAspectRatio: !1,
    plugins: {
      legend: {
        display: !1
      },
      tooltip: {
        enabled: !0,
        callbacks: {
          label: (i) => `${i.label}: ${i.parsed}%`
        }
      }
    },
    cutout: "70%"
  };
  return /* @__PURE__ */ v.jsx(
    hr,
    {
      header: r("dashboard.repartitionInvestissements"),
      className: "h-full flex flex-col flex-1",
      children: a ? /* @__PURE__ */ v.jsxs("div", { className: "flex-grow flex flex-col h-full space-y-4 sm:space-y-6", children: [
        /* @__PURE__ */ v.jsx("div", { className: "flex-grow flex items-center justify-center min-h-[200px] sm:min-h-[250px]", children: /* @__PURE__ */ v.jsx("div", { className: "w-full h-full max-w-48 sm:max-w-64", children: /* @__PURE__ */ v.jsx(r$, { data: e, options: s }) }) }),
        /* @__PURE__ */ v.jsx("div", { className: "mt-auto space-y-4", children: e.labels.map((i, o) => /* @__PURE__ */ v.jsxs(
          "div",
          {
            className: "flex justify-between items-center space-x-2",
            children: [
              /* @__PURE__ */ v.jsxs("div", { className: "flex items-center", children: [
                /* @__PURE__ */ v.jsx(
                  "div",
                  {
                    className: "w-4 h-4 rounded-full mr-2 shrink-0",
                    style: {
                      backgroundColor: e.datasets[0].backgroundColor[o]
                    }
                  }
                ),
                /* @__PURE__ */ v.jsx("span", { className: "font-medium", children: i })
              ] }),
              /* @__PURE__ */ v.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ v.jsxs("span", { className: "font-semibold mr-2 text-primary-800", children: [
                e.datasets[0].data[o],
                "%"
              ] }) })
            ]
          },
          o
        )) })
      ] }) : /* @__PURE__ */ v.jsx(
        dh,
        {
          icon: "donut-chart",
          title: r("dashboard.noInvestmentsTitle"),
          description: r("dashboard.noInvestmentsDescription"),
          primaryAction: {
            label: r("dashboard.makeFirstInvestment"),
            onClick: () => {
              n("/marketplace");
            },
            icon: "plus"
          }
        }
      )
    }
  );
}, Ket = ({
  title: e,
  value: t,
  icon: r,
  linkText: n,
  description: a,
  link: s,
  isLoading: i = !1
}) => i ? /* @__PURE__ */ v.jsx(hr, { fitContent: !0, children: /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col space-y-4", children: [
  /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col justify-between items-start", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex gap-2 items-center", children: [
      /* @__PURE__ */ v.jsx(_l, { className: "h-5 w-5 rounded" }),
      /* @__PURE__ */ v.jsx(_l, { className: "h-5 w-32 rounded" })
    ] }),
    /* @__PURE__ */ v.jsx(_l, { className: "h-4 w-44 mt-2 rounded" })
  ] }),
  /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center", children: [
    /* @__PURE__ */ v.jsx(_l, { className: "h-8 w-24 rounded" }),
    /* @__PURE__ */ v.jsx(_l, { className: "h-4 w-16 rounded" })
  ] })
] }) }) : /* @__PURE__ */ v.jsx(hr, { fitContent: !0, children: /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col space-y-4", children: [
  /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col justify-between items-start", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex gap-2 items-center", children: [
      /* @__PURE__ */ v.jsx(dt, { name: r, color: "text-primary-800", size: "sm" }),
      /* @__PURE__ */ v.jsx("h3", { className: "font-medium text-primary-800", children: e })
    ] }),
    a && /* @__PURE__ */ v.jsx("p", { className: "text-sm text-gray-500", children: a })
  ] }),
  /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center", children: [
    /* @__PURE__ */ v.jsx("p", { className: "text-3xl text-primary-800 font-semibold", children: t }),
    n && s && /* @__PURE__ */ v.jsx(
      qe,
      {
        variant: "link",
        color: "primary",
        size: "sm",
        className: "font-medium",
        onClick: () => window.location.href = s,
        children: n
      }
    )
  ] })
] }) });
qi.register(
  jc,
  Fc,
  Vf,
  To,
  Uh,
  Xc,
  Yc,
  Kk
);
const D8e = ({
  title: e,
  mainValue: t,
  changeValue: r,
  isPositiveChange: n,
  startDate: a,
  endDate: s,
  onStartDateChange: i,
  onEndDateChange: o,
  selectedFilter: l,
  filterOptions: c,
  onFilterChange: u,
  chartData: d,
  chartOptions: f,
  renderEmptyState: h
}) => {
  const { t: p } = _t(["dashboard", "common"]), m = d.datasets.some((x) => x.data.length > 0), g = (x, w, _) => {
    const S = x.createLinearGradient(0, 0, 0, x.canvas.height);
    return _ ? (S.addColorStop(0, _.start), S.addColorStop(0.2, _.middle), S.addColorStop(0.45, _.end)) : (S.addColorStop(0, `${w}`), S.addColorStop(0.2, `${w}`), S.addColorStop(0.45, `${w}00`)), S;
  }, y = {
    ...f,
    plugins: {
      ...f.plugins,
      legend: {
        ...f.plugins.legend,
        labels: {
          ...f.plugins.legend.labels,
          filter: (x) => d.datasets[x.datasetIndex].showInLegend !== !1,
          color: (x) => x.chart.options.theme === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(0, 0, 0, 0.8)"
        }
      }
    },
    scales: {
      ...f.scales,
      x: {
        ...f.scales.x,
        ticks: {
          color: (x) => x.chart.options.theme === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(0, 0, 0, 0.8)"
        },
        grid: { color: "rgba(107, 114, 128, 0.2)" }
      },
      y: {
        ...f.scales.y,
        ticks: {
          color: (x) => x.chart.options.theme === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(0, 0, 0, 0.8)"
        },
        grid: { color: "rgba(107, 114, 128, 0.2)" }
      }
    },
    theme: document.documentElement.classList.contains("dark") ? "dark" : "light"
  };
  return /* @__PURE__ */ v.jsx(hr, { header: e, size: "sm", className: "flex-1", children: m ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center mb-6", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flex items-center space-x-4", children: [
        /* @__PURE__ */ v.jsx("span", { className: "text-3xl font-semibold text-primary-600 dark:text-primary-400", children: hs(t, {
          currency: "EUR",
          symbolPosition: "after",
          thousandsSeparator: " ",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }) }),
        typeof r < "u" && typeof n < "u" && /* @__PURE__ */ v.jsxs(
          "span",
          {
            className: `text-sm ${n ? "text-green-500 bg-green-100 dark:bg-green-900 border border-green-500" : "text-red-500 bg-red-100 dark:bg-red-900 border border-red-500"} px-2 py-1 rounded-full`,
            children: [
              n ? "+" : "-",
              r,
              "% ",
              n ? "▲" : "▼"
            ]
          }
        )
      ] }),
      /* @__PURE__ */ v.jsxs("div", { className: "flex space-x-2", children: [
        /* @__PURE__ */ v.jsx("span", { className: "text-gray-600 dark:text-gray-400 self-center", children: p("common:common.dateFrom") }),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            type: "date",
            value: a.toISOString().split("T")[0],
            onChange: (x) => i(new Date(x.target.value)),
            className: "w-36 text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-700"
          }
        ),
        /* @__PURE__ */ v.jsx("span", { className: "text-gray-600 dark:text-gray-400 self-center", children: p("common:common.dateTo") }),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            type: "date",
            value: s.toISOString().split("T")[0],
            onChange: (x) => o(new Date(x.target.value)),
            className: "w-36 text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-700"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col sm:flex-row sm:items-center gap-2 mb-6", children: [
      /* @__PURE__ */ v.jsx("span", { className: "text-gray-600 dark:text-gray-400 whitespace-nowrap", children: p("dashboard.filterByCategory") }),
      /* @__PURE__ */ v.jsx(
        ss,
        {
          options: c,
          value: l,
          isMulti: !0,
          onChange: (x) => u(x),
          className: "max-w-full"
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx(
      Gk,
      {
        data: {
          ...d,
          datasets: d.datasets.map((x) => ({
            ...x,
            backgroundColor: (w) => {
              const _ = w.chart.ctx;
              return g(
                _,
                x.backgroundColor,
                x.gradientStops
              );
            }
          }))
        },
        options: y,
        className: "text-gray-900 dark:text-gray-100"
      }
    )
  ] }) : h() });
}, N8e = ({
  loading: e,
  data: t = [],
  onSeeAll: r
}) => {
  const { t: n } = _t(["orders"]);
  ta();
  const a = [
    {
      id: "project",
      key: "project",
      label: n("orders.projectName"),
      render: (s) => /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2 h-full", children: [
        /* @__PURE__ */ v.jsx(
          fi,
          {
            src: s.campaign.project.files.images[0],
            alt: s.campaign.project.name,
            className: "w-8 h-8 rounded object-cover"
          }
        ),
        /* @__PURE__ */ v.jsx("span", { className: "font-medium", children: s.campaign.project.name })
      ] })
    },
    {
      id: "quantity",
      key: "quantity",
      label: n("orders.quantity"),
      render: (s) => /* @__PURE__ */ v.jsx("div", { className: "flex items-center h-full", children: /* @__PURE__ */ v.jsx("span", { className: "font-medium", children: s.quantity }) })
    },
    {
      id: "batchValue",
      key: "batchValue",
      label: n("orders.batchValue"),
      render: (s) => /* @__PURE__ */ v.jsx("div", { className: "flex items-center h-full", children: /* @__PURE__ */ v.jsx("span", { className: "font-medium", children: hs(s.campaign.project.price, { currency: "EUR" }) }) })
    },
    {
      id: "status",
      key: "status",
      label: n("orders.status"),
      render: (s) => /* @__PURE__ */ v.jsx("div", { className: "flex items-center h-full", children: /* @__PURE__ */ v.jsx(an, { color: Pw(Rc(s.payment)), children: n(`orders.statuses.${Rc(s.payment)}`) }) })
    },
    {
      id: "creation",
      key: "creation",
      label: n("orders.createdAt"),
      render: (s) => /* @__PURE__ */ v.jsx("div", { className: "flex items-center h-full", children: /* @__PURE__ */ v.jsx("span", { className: "font-medium", children: new Date(s.tsp).toLocaleDateString() }) })
    }
  ];
  return /* @__PURE__ */ v.jsx(
    xx,
    {
      columns: a,
      data: t,
      isLoading: e,
      emptyStateMessage: n("orders.crud.list.noItemsFound"),
      footerSection: {
        before: /* @__PURE__ */ v.jsx("div", { className: "flex justify-end", children: /* @__PURE__ */ v.jsx(
          qe,
          {
            variant: "link",
            icon: "chevron-right",
            iconPosition: "right",
            onClick: r,
            children: n("common:common.seeAll")
          }
        ) })
      }
    }
  );
}, qet = ({
  operations: e = [],
  onSeeMore: t,
  isLoading: r = !1
}) => {
  const { t: n } = _t(["dashboard", "common"]), a = (s) => {
    switch (s) {
      case "investment":
        return "chart-line";
      case "deposit":
        return "arrow-down";
      case "withdrawal":
        return "arrow-up";
      default:
        return "question";
    }
  };
  return /* @__PURE__ */ v.jsx(
    hr,
    {
      header: n("dashboard.myOperations"),
      size: "sm",
      footer: /* @__PURE__ */ v.jsx("div", { className: "flex justify-end", children: /* @__PURE__ */ v.jsx(qe, { variant: "link", onClick: t, children: n("common:common.seeMore") }) }),
      children: /* @__PURE__ */ v.jsx("div", { className: "space-y-4", children: e.map((s) => /* @__PURE__ */ v.jsxs(
        "div",
        {
          className: "flex items-center bg-primary-100 p-4 rounded-lg",
          children: [
            /* @__PURE__ */ v.jsx("div", { className: "flex-shrink-0 mr-4", children: /* @__PURE__ */ v.jsx(
              dt,
              {
                name: a(s.type),
                size: "md",
                className: "text-primary-500"
              }
            ) }),
            /* @__PURE__ */ v.jsxs("div", { className: "flex-grow", children: [
              /* @__PURE__ */ v.jsxs("div", { className: "font-medium", children: [
                s.type === "withdrawal" ? "-" : "+",
                s.amount,
                "€ ",
                n(`common:operations.${s.type}`)
              ] }),
              /* @__PURE__ */ v.jsx("div", { className: "text-sm text-gray-500", children: s.description })
            ] }),
            /* @__PURE__ */ v.jsx("div", { className: "flex-shrink-0 text-sm text-gray-500", children: s.timestamp })
          ]
        },
        s.id
      )) })
    }
  );
}, L7 = ({
  title: e,
  value: t,
  icon: r,
  linkText: n,
  description: a,
  link: s,
  onLinkClick: i
}) => {
  const o = ta(), l = () => {
    i ? i() : s && o(s);
  };
  return /* @__PURE__ */ v.jsx(hr, { fitContent: !0, children: /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col space-y-4", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col justify-between items-start", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flex gap-2 items-center", children: [
        /* @__PURE__ */ v.jsx(dt, { name: r, color: "primary", size: "sm" }),
        /* @__PURE__ */ v.jsx("h3", { className: "font-medium text-gray-900 dark:text-gray-100", children: e })
      ] }),
      /* @__PURE__ */ v.jsx("p", { className: "text-sm text-gray-600 dark:text-gray-400", children: a })
    ] }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center", children: [
      /* @__PURE__ */ v.jsx("p", { className: "text-3xl text-primary-600 dark:text-primary-400 font-semibold", children: t }),
      /* @__PURE__ */ v.jsx(
        qe,
        {
          variant: "link",
          color: "primary",
          size: "sm",
          className: "font-medium text-text",
          onClick: l,
          children: n
        }
      )
    ] })
  ] }) });
};
async function M8e(e) {
  try {
    const t = new FontFace(e, `local(${e})`);
    await t.load(), document.fonts.add(t);
  } catch (t) {
    console.warn(`Failed to load font: ${e}`, t);
  }
}
function Get(e) {
  const t = e.split(",").map((r) => r.trim());
  return Promise.all(t.map((r) => M8e(r)));
}
const Yet = (e) => {
  if (!(e != null && e.value)) return 0;
  const t = parseFloat(e.value);
  return isNaN(t) ? 0 : t;
}, Xet = (e) => e ? `${e.value || "N/A"}${e.operator || ""}${e.description ? ` ${e.description}` : ""}` : "N/A", Qet = (e) => e == null ? void 0 : e.tooltip, Jet = (e) => ({
  required: (t) => e("common:common.validation.required", { field: t }),
  min: (t) => e("common:common.validation.min", { min: t }),
  max: (t) => e("common:common.validation.max", { max: t }),
  email: () => e("common:common.validation.email"),
  minLength: (t) => e("common:common.validation.minLength", { min: t }),
  maxLength: (t) => e("common:common.validation.maxLength", { max: t })
}), L8e = async () => {
  try {
    const e = window.open("about:blank", "_blank", "width=1,height=1");
    return !e || e.closed || typeof e.closed > "u" ? !0 : (e.close(), !1);
  } catch {
    return !0;
  }
}, Oj = (e) => {
  const t = window.open(
    e,
    "_blank",
    "width=600,height=800,top=50,right=50,popup=true"
  );
  return !t || t.closed || typeof t.closed > "u" ? null : t;
};
qi.register(
  jc,
  Fc,
  $f,
  Uh,
  Xc,
  Yc
);
const j8e = ({
  data: e,
  options: t = {},
  minYScale: r = 100,
  title: n = "Amount per Year",
  backButtonText: a = "Back to Years",
  yearLabel: s = "Amount per Year",
  campaignLabel: i = "Amount per Campaign"
}) => {
  var y, x;
  const [o, l] = Me(null), [c, u] = Me({
    primary: TA("primary", [400, 300]),
    text: zp("text"),
    border: zp("border")
  });
  wt(() => {
    const w = new MutationObserver((_) => {
      _.forEach((S) => {
        S.attributeName === "class" && u({
          primary: TA("primary", [400, 300]),
          text: zp("text"),
          border: zp("border")
        });
      });
    });
    return w.observe(document.documentElement, {
      attributes: !0,
      attributeFilter: ["class"]
    }), () => w.disconnect();
  }, []);
  const { t: d } = _t(["dashboard"]), f = (w, _, S) => {
    if (_.length > 0) {
      const C = _[0].index, E = e[C];
      E.campaignData && E.campaignData.length > 0 && l(E.year);
    }
  }, h = () => {
    l(null);
  }, p = (w) => {
    const _ = Math.max(r, ...w);
    return _ >= 1e6 ? Math.ceil(_ / 1e6) * 1e6 : _ >= 1e5 ? Math.ceil(_ / 1e5) * 1e5 : _ >= 1e4 ? Math.ceil(_ / 1e4) * 1e4 : _ >= 1e3 ? Math.ceil(_ / 1e3) * 1e3 : _ * 1.2;
  }, m = () => {
    var _, S;
    if (o) {
      const C = e.find((O) => O.year === o), E = ((_ = C == null ? void 0 : C.campaignData) == null ? void 0 : _.map((O) => O.value)) || [];
      return p(E), {
        labels: ((S = C == null ? void 0 : C.campaignData) == null ? void 0 : S.map((O) => O.name)) || [],
        datasets: [
          {
            label: i,
            data: E,
            backgroundColor: c.primary[0],
            hoverBackgroundColor: c.primary[1],
            borderRadius: 4
          }
        ]
      };
    }
    const w = e.map((C) => C.value);
    return p(w), {
      labels: e.map((C) => C.year),
      datasets: [
        {
          label: s,
          data: w,
          backgroundColor: c.primary[0],
          hoverBackgroundColor: c.primary[1],
          borderRadius: 4
        }
      ]
    };
  }, g = {
    responsive: !0,
    maintainAspectRatio: !1,
    onClick: o ? void 0 : f,
    animation: {
      duration: 500
    },
    plugins: {
      legend: {
        display: !0,
        position: "bottom",
        align: "start",
        labels: {
          usePointStyle: !0,
          pointStyle: "rectRounded",
          padding: 20,
          font: {
            size: 12
          },
          boxWidth: 16,
          boxHeight: 16,
          color: c.text
        }
      },
      title: {
        display: !1
      },
      tooltip: {
        callbacks: {
          label: (w) => {
            const _ = w.raw;
            return hs(_, { currency: "EUR" });
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: !0,
        min: 0,
        max: p(
          o ? ((x = (y = e.find((w) => w.year === o)) == null ? void 0 : y.campaignData) == null ? void 0 : x.map((w) => w.value)) || [] : e.map((w) => w.value)
        ),
        ticks: {
          callback: (w) => hs(w, { currency: "EUR" }),
          color: c.text
        },
        grid: {
          color: c.border
        }
      },
      x: {
        grid: { display: !1 },
        ticks: {
          color: c.text
        }
      }
    },
    barPercentage: 0.7,
    categoryPercentage: 0.7
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "space-y-4", children: [
    o && /* @__PURE__ */ v.jsx(
      qe,
      {
        variant: "outline",
        size: "sm",
        onClick: h,
        icon: "chevron-left",
        iconPosition: "left",
        children: a
      }
    ),
    /* @__PURE__ */ v.jsx("div", { style: { height: "400px" }, children: /* @__PURE__ */ v.jsx(
      Yk,
      {
        data: m(),
        options: { ...g, ...t }
      }
    ) })
  ] });
}, yv = ({
  title: e,
  onAddClick: t,
  actions: r
}) => {
  var a, s, i, o, l, c;
  const { t: n } = _t(["common"]);
  return /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center", children: [
    /* @__PURE__ */ v.jsx("h1", { className: "text-2xl font-semibold text-text", children: e }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex space-x-3", children: [
      ((a = r == null ? void 0 : r.filter) == null ? void 0 : a.enabled) && /* @__PURE__ */ v.jsxs(
        qe,
        {
          onClick: r.filter.handler,
          variant: "link",
          color: "primary",
          size: "sm",
          icon: "filter",
          iconPosition: "left",
          disabled: !((i = (s = r.filter).permissions) != null && i.call(s)),
          children: [
            n("common.filter"),
            r.filter.activeFilters ? /* @__PURE__ */ v.jsx("span", { className: "ml-1.5 px-1.5 py-0.5 text-xs bg-primary-100 text-primary-700 rounded-full", children: r.filter.activeFilters }) : null
          ]
        }
      ),
      ((o = r == null ? void 0 : r.export) == null ? void 0 : o.enabled) && /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: r.export.handler,
          variant: "link",
          color: "primary",
          size: "sm",
          icon: "download",
          iconPosition: "left",
          disabled: !((c = (l = r.export).permissions) != null && c.call(l)),
          children: n("common.export")
        }
      ),
      t && /* @__PURE__ */ v.jsx(
        qe,
        {
          onClick: t,
          variant: "solid",
          color: "primary",
          size: "md",
          icon: "plus",
          iconPosition: "left",
          children: n("common.add")
        }
      )
    ] })
  ] });
};
var j7 = { exports: {} };
(function(e, t) {
  (function(r, n) {
    n();
  })(ke, function() {
    function r(c, u) {
      return typeof u > "u" ? u = { autoBom: !1 } : typeof u != "object" && (console.warn("Deprecated: Expected third argument to be a object"), u = { autoBom: !u }), u.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(c.type) ? new Blob(["\uFEFF", c], { type: c.type }) : c;
    }
    function n(c, u, d) {
      var f = new XMLHttpRequest();
      f.open("GET", c), f.responseType = "blob", f.onload = function() {
        l(f.response, u, d);
      }, f.onerror = function() {
        console.error("could not download file");
      }, f.send();
    }
    function a(c) {
      var u = new XMLHttpRequest();
      u.open("HEAD", c, !1);
      try {
        u.send();
      } catch {
      }
      return 200 <= u.status && 299 >= u.status;
    }
    function s(c) {
      try {
        c.dispatchEvent(new MouseEvent("click"));
      } catch {
        var u = document.createEvent("MouseEvents");
        u.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), c.dispatchEvent(u);
      }
    }
    var i = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof window == "object" && window.global === window ? window : void 0, o = i.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), l = i.saveAs || (typeof window != "object" || window !== i ? function() {
    } : "download" in HTMLAnchorElement.prototype && !o ? function(c, u, d) {
      var f = i.URL || i.webkitURL, h = document.createElement("a");
      u = u || c.name || "download", h.download = u, h.rel = "noopener", typeof c == "string" ? (h.href = c, h.origin === location.origin ? s(h) : a(h.href) ? n(c, u, d) : s(h, h.target = "_blank")) : (h.href = f.createObjectURL(c), setTimeout(function() {
        f.revokeObjectURL(h.href);
      }, 4e4), setTimeout(function() {
        s(h);
      }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(c, u, d) {
      if (u = u || c.name || "download", typeof c != "string") navigator.msSaveOrOpenBlob(r(c, d), u);
      else if (a(c)) n(c, u, d);
      else {
        var f = document.createElement("a");
        f.href = c, f.target = "_blank", setTimeout(function() {
          s(f);
        });
      }
    } : function(c, u, d, f) {
      if (f = f || open("", "_blank"), f && (f.document.title = f.document.body.innerText = "downloading..."), typeof c == "string") return n(c, u, d);
      var h = c.type === "application/octet-stream", p = /constructor/i.test(i.HTMLElement) || i.safari, m = /CriOS\/[\d]+/.test(navigator.userAgent);
      if ((m || h && p || o) && typeof FileReader < "u") {
        var g = new FileReader();
        g.onloadend = function() {
          var w = g.result;
          w = m ? w : w.replace(/^data:[^;]*;/, "data:attachment/file;"), f ? f.location.href = w : location = w, f = null;
        }, g.readAsDataURL(c);
      } else {
        var y = i.URL || i.webkitURL, x = y.createObjectURL(c);
        f ? f.location = x : location.href = x, f = null, setTimeout(function() {
          y.revokeObjectURL(x);
        }, 4e4);
      }
    });
    i.saveAs = l.saveAs = l, e.exports = l;
  });
})(j7);
var F8e = j7.exports;
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
var ew = {};
ew.version = "0.18.5";
var F7 = 1252, B8e = [874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 1e4], B7 = function(e) {
  B8e.indexOf(e) != -1 && (F7 = e);
};
function U8e() {
  B7(1252);
}
var hg = function(e) {
  B7(e);
};
function V8e() {
  hg(1200), U8e();
}
var ny = function(t) {
  return String.fromCharCode(t);
}, Aj = function(t) {
  return String.fromCharCode(t);
}, Pj, xc = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function pg(e) {
  for (var t = "", r = 0, n = 0, a = 0, s = 0, i = 0, o = 0, l = 0, c = 0; c < e.length; )
    r = e.charCodeAt(c++), s = r >> 2, n = e.charCodeAt(c++), i = (r & 3) << 4 | n >> 4, a = e.charCodeAt(c++), o = (n & 15) << 2 | a >> 6, l = a & 63, isNaN(n) ? o = l = 64 : isNaN(a) && (l = 64), t += xc.charAt(s) + xc.charAt(i) + xc.charAt(o) + xc.charAt(l);
  return t;
}
function Bl(e) {
  var t = "", r = 0, n = 0, a = 0, s = 0, i = 0, o = 0, l = 0;
  e = e.replace(/[^\w\+\/\=]/g, "");
  for (var c = 0; c < e.length; )
    s = xc.indexOf(e.charAt(c++)), i = xc.indexOf(e.charAt(c++)), r = s << 2 | i >> 4, t += String.fromCharCode(r), o = xc.indexOf(e.charAt(c++)), n = (i & 15) << 4 | o >> 2, o !== 64 && (t += String.fromCharCode(n)), l = xc.indexOf(e.charAt(c++)), a = (o & 3) << 6 | l, l !== 64 && (t += String.fromCharCode(a));
  return t;
}
var Mr = /* @__PURE__ */ function() {
  return typeof Buffer < "u" && typeof process < "u" && typeof process.versions < "u" && !!process.versions.node;
}(), Gl = /* @__PURE__ */ function() {
  if (typeof Buffer < "u") {
    var e = !Buffer.from;
    if (!e) try {
      Buffer.from("foo", "utf8");
    } catch {
      e = !0;
    }
    return e ? function(t, r) {
      return r ? new Buffer(t, r) : new Buffer(t);
    } : Buffer.from.bind(Buffer);
  }
  return function() {
  };
}();
function Xu(e) {
  return Mr ? Buffer.alloc ? Buffer.alloc(e) : new Buffer(e) : typeof Uint8Array < "u" ? new Uint8Array(e) : new Array(e);
}
function Rj(e) {
  return Mr ? Buffer.allocUnsafe ? Buffer.allocUnsafe(e) : new Buffer(e) : typeof Uint8Array < "u" ? new Uint8Array(e) : new Array(e);
}
var Ri = function(t) {
  return Mr ? Gl(t, "binary") : t.split("").map(function(r) {
    return r.charCodeAt(0) & 255;
  });
};
function qx(e) {
  if (typeof ArrayBuffer > "u") return Ri(e);
  for (var t = new ArrayBuffer(e.length), r = new Uint8Array(t), n = 0; n != e.length; ++n) r[n] = e.charCodeAt(n) & 255;
  return t;
}
function bv(e) {
  if (Array.isArray(e)) return e.map(function(n) {
    return String.fromCharCode(n);
  }).join("");
  for (var t = [], r = 0; r < e.length; ++r) t[r] = String.fromCharCode(e[r]);
  return t.join("");
}
function $8e(e) {
  if (typeof Uint8Array > "u") throw new Error("Unsupported");
  return new Uint8Array(e);
}
var Oa = Mr ? function(e) {
  return Buffer.concat(e.map(function(t) {
    return Buffer.isBuffer(t) ? t : Gl(t);
  }));
} : function(e) {
  if (typeof Uint8Array < "u") {
    var t = 0, r = 0;
    for (t = 0; t < e.length; ++t) r += e[t].length;
    var n = new Uint8Array(r), a = 0;
    for (t = 0, r = 0; t < e.length; r += a, ++t)
      if (a = e[t].length, e[t] instanceof Uint8Array) n.set(e[t], r);
      else {
        if (typeof e[t] == "string")
          throw "wtf";
        n.set(new Uint8Array(e[t]), r);
      }
    return n;
  }
  return [].concat.apply([], e.map(function(s) {
    return Array.isArray(s) ? s : [].slice.call(s);
  }));
};
function H8e(e) {
  for (var t = [], r = 0, n = e.length + 250, a = Xu(e.length + 255), s = 0; s < e.length; ++s) {
    var i = e.charCodeAt(s);
    if (i < 128) a[r++] = i;
    else if (i < 2048)
      a[r++] = 192 | i >> 6 & 31, a[r++] = 128 | i & 63;
    else if (i >= 55296 && i < 57344) {
      i = (i & 1023) + 64;
      var o = e.charCodeAt(++s) & 1023;
      a[r++] = 240 | i >> 8 & 7, a[r++] = 128 | i >> 2 & 63, a[r++] = 128 | o >> 6 & 15 | (i & 3) << 4, a[r++] = 128 | o & 63;
    } else
      a[r++] = 224 | i >> 12 & 15, a[r++] = 128 | i >> 6 & 63, a[r++] = 128 | i & 63;
    r > n && (t.push(a.slice(0, r)), r = 0, a = Xu(65535), n = 65530);
  }
  return t.push(a.slice(0, r)), Oa(t);
}
var Cm = /\u0000/g, ay = /[\u0001-\u0006]/g;
function Wf(e) {
  for (var t = "", r = e.length - 1; r >= 0; ) t += e.charAt(r--);
  return t;
}
function Mi(e, t) {
  var r = "" + e;
  return r.length >= t ? r : An("0", t - r.length) + r;
}
function M2(e, t) {
  var r = "" + e;
  return r.length >= t ? r : An(" ", t - r.length) + r;
}
function tw(e, t) {
  var r = "" + e;
  return r.length >= t ? r : r + An(" ", t - r.length);
}
function W8e(e, t) {
  var r = "" + Math.round(e);
  return r.length >= t ? r : An("0", t - r.length) + r;
}
function z8e(e, t) {
  var r = "" + e;
  return r.length >= t ? r : An("0", t - r.length) + r;
}
var Ij = /* @__PURE__ */ Math.pow(2, 32);
function rf(e, t) {
  if (e > Ij || e < -Ij) return W8e(e, t);
  var r = Math.round(e);
  return z8e(r, t);
}
function rw(e, t) {
  return t = t || 0, e.length >= 7 + t && (e.charCodeAt(t) | 32) === 103 && (e.charCodeAt(t + 1) | 32) === 101 && (e.charCodeAt(t + 2) | 32) === 110 && (e.charCodeAt(t + 3) | 32) === 101 && (e.charCodeAt(t + 4) | 32) === 114 && (e.charCodeAt(t + 5) | 32) === 97 && (e.charCodeAt(t + 6) | 32) === 108;
}
var Dj = [
  ["Sun", "Sunday"],
  ["Mon", "Monday"],
  ["Tue", "Tuesday"],
  ["Wed", "Wednesday"],
  ["Thu", "Thursday"],
  ["Fri", "Friday"],
  ["Sat", "Saturday"]
], SS = [
  ["J", "Jan", "January"],
  ["F", "Feb", "February"],
  ["M", "Mar", "March"],
  ["A", "Apr", "April"],
  ["M", "May", "May"],
  ["J", "Jun", "June"],
  ["J", "Jul", "July"],
  ["A", "Aug", "August"],
  ["S", "Sep", "September"],
  ["O", "Oct", "October"],
  ["N", "Nov", "November"],
  ["D", "Dec", "December"]
];
function K8e(e) {
  return e || (e = {}), e[0] = "General", e[1] = "0", e[2] = "0.00", e[3] = "#,##0", e[4] = "#,##0.00", e[9] = "0%", e[10] = "0.00%", e[11] = "0.00E+00", e[12] = "# ?/?", e[13] = "# ??/??", e[14] = "m/d/yy", e[15] = "d-mmm-yy", e[16] = "d-mmm", e[17] = "mmm-yy", e[18] = "h:mm AM/PM", e[19] = "h:mm:ss AM/PM", e[20] = "h:mm", e[21] = "h:mm:ss", e[22] = "m/d/yy h:mm", e[37] = "#,##0 ;(#,##0)", e[38] = "#,##0 ;[Red](#,##0)", e[39] = "#,##0.00;(#,##0.00)", e[40] = "#,##0.00;[Red](#,##0.00)", e[45] = "mm:ss", e[46] = "[h]:mm:ss", e[47] = "mmss.0", e[48] = "##0.0E+0", e[49] = "@", e[56] = '"上午/下午 "hh"時"mm"分"ss"秒 "', e;
}
var Rn = {
  0: "General",
  1: "0",
  2: "0.00",
  3: "#,##0",
  4: "#,##0.00",
  9: "0%",
  10: "0.00%",
  11: "0.00E+00",
  12: "# ?/?",
  13: "# ??/??",
  14: "m/d/yy",
  15: "d-mmm-yy",
  16: "d-mmm",
  17: "mmm-yy",
  18: "h:mm AM/PM",
  19: "h:mm:ss AM/PM",
  20: "h:mm",
  21: "h:mm:ss",
  22: "m/d/yy h:mm",
  37: "#,##0 ;(#,##0)",
  38: "#,##0 ;[Red](#,##0)",
  39: "#,##0.00;(#,##0.00)",
  40: "#,##0.00;[Red](#,##0.00)",
  45: "mm:ss",
  46: "[h]:mm:ss",
  47: "mmss.0",
  48: "##0.0E+0",
  49: "@",
  56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
}, Nj = {
  5: 37,
  6: 38,
  7: 39,
  8: 40,
  //  5 -> 37 ...  8 -> 40
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  // 23 ->  0 ... 26 ->  0
  27: 14,
  28: 14,
  29: 14,
  30: 14,
  31: 14,
  // 27 -> 14 ... 31 -> 14
  50: 14,
  51: 14,
  52: 14,
  53: 14,
  54: 14,
  // 50 -> 14 ... 58 -> 14
  55: 14,
  56: 14,
  57: 14,
  58: 14,
  59: 1,
  60: 2,
  61: 3,
  62: 4,
  // 59 ->  1 ... 62 ->  4
  67: 9,
  68: 10,
  // 67 ->  9 ... 68 -> 10
  69: 12,
  70: 13,
  71: 14,
  // 69 -> 12 ... 71 -> 14
  72: 14,
  73: 15,
  74: 16,
  75: 17,
  // 72 -> 14 ... 75 -> 17
  76: 20,
  77: 21,
  78: 22,
  // 76 -> 20 ... 78 -> 22
  79: 45,
  80: 46,
  81: 47,
  // 79 -> 45 ... 81 -> 47
  82: 0
  // 82 ->  0 ... 65536 -> 0 (omitted)
}, q8e = {
  //  5 -- Currency,   0 decimal, black negative
  5: '"$"#,##0_);\\("$"#,##0\\)',
  63: '"$"#,##0_);\\("$"#,##0\\)',
  //  6 -- Currency,   0 decimal, red   negative
  6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  //  7 -- Currency,   2 decimal, black negative
  7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  //  8 -- Currency,   2 decimal, red   negative
  8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  // 41 -- Accounting, 0 decimal, No Symbol
  41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
  // 42 -- Accounting, 0 decimal, $  Symbol
  42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
  // 43 -- Accounting, 2 decimal, No Symbol
  43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
  // 44 -- Accounting, 2 decimal, $  Symbol
  44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function nw(e, t, r) {
  for (var n = e < 0 ? -1 : 1, a = e * n, s = 0, i = 1, o = 0, l = 1, c = 0, u = 0, d = Math.floor(a); c < t && (d = Math.floor(a), o = d * i + s, u = d * c + l, !(a - d < 5e-8)); )
    a = 1 / (a - d), s = i, i = o, l = c, c = u;
  if (u > t && (c > t ? (u = l, o = s) : (u = c, o = i)), !r) return [0, n * o, u];
  var f = Math.floor(n * o / u);
  return [f, n * o - f * u, u];
}
function sy(e, t, r) {
  if (e > 2958465 || e < 0) return null;
  var n = e | 0, a = Math.floor(86400 * (e - n)), s = 0, i = [], o = { D: n, T: a, u: 86400 * (e - n) - a, y: 0, m: 0, d: 0, H: 0, M: 0, S: 0, q: 0 };
  if (Math.abs(o.u) < 1e-6 && (o.u = 0), t && t.date1904 && (n += 1462), o.u > 0.9999 && (o.u = 0, ++a == 86400 && (o.T = a = 0, ++n, ++o.D)), n === 60)
    i = r ? [1317, 10, 29] : [1900, 2, 29], s = 3;
  else if (n === 0)
    i = r ? [1317, 8, 29] : [1900, 1, 0], s = 6;
  else {
    n > 60 && --n;
    var l = new Date(1900, 0, 1);
    l.setDate(l.getDate() + n - 1), i = [l.getFullYear(), l.getMonth() + 1, l.getDate()], s = l.getDay(), n < 60 && (s = (s + 6) % 7), r && (s = eHe(l, i));
  }
  return o.y = i[0], o.m = i[1], o.d = i[2], o.S = a % 60, a = Math.floor(a / 60), o.M = a % 60, a = Math.floor(a / 60), o.H = a, o.q = s, o;
}
var U7 = /* @__PURE__ */ new Date(1899, 11, 31, 0, 0, 0), G8e = /* @__PURE__ */ U7.getTime(), Y8e = /* @__PURE__ */ new Date(1900, 2, 1, 0, 0, 0);
function V7(e, t) {
  var r = /* @__PURE__ */ e.getTime();
  return t ? r -= 1461 * 24 * 60 * 60 * 1e3 : e >= Y8e && (r += 24 * 60 * 60 * 1e3), (r - (G8e + (/* @__PURE__ */ e.getTimezoneOffset() - /* @__PURE__ */ U7.getTimezoneOffset()) * 6e4)) / (24 * 60 * 60 * 1e3);
}
function L2(e) {
  return e.indexOf(".") == -1 ? e : e.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
function X8e(e) {
  return e.indexOf("E") == -1 ? e : e.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
function Q8e(e) {
  var t = e < 0 ? 12 : 11, r = L2(e.toFixed(12));
  return r.length <= t || (r = e.toPrecision(10), r.length <= t) ? r : e.toExponential(5);
}
function J8e(e) {
  var t = L2(e.toFixed(11));
  return t.length > (e < 0 ? 12 : 11) || t === "0" || t === "-0" ? e.toPrecision(6) : t;
}
function Z8e(e) {
  var t = Math.floor(Math.log(Math.abs(e)) * Math.LOG10E), r;
  return t >= -4 && t <= -1 ? r = e.toPrecision(10 + t) : Math.abs(t) <= 9 ? r = Q8e(e) : t === 10 ? r = e.toFixed(10).substr(0, 12) : r = J8e(e), L2(X8e(r.toUpperCase()));
}
function mT(e, t) {
  switch (typeof e) {
    case "string":
      return e;
    case "boolean":
      return e ? "TRUE" : "FALSE";
    case "number":
      return (e | 0) === e ? e.toString(10) : Z8e(e);
    case "undefined":
      return "";
    case "object":
      if (e == null) return "";
      if (e instanceof Date) return Bc(14, V7(e, t && t.date1904), t);
  }
  throw new Error("unsupported value in General format: " + e);
}
function eHe(e, t) {
  t[0] -= 581;
  var r = e.getDay();
  return e < 60 && (r = (r + 6) % 7), r;
}
function tHe(e, t, r, n) {
  var a = "", s = 0, i = 0, o = r.y, l, c = 0;
  switch (e) {
    case 98:
      o = r.y + 543;
    case 121:
      switch (t.length) {
        case 1:
        case 2:
          l = o % 100, c = 2;
          break;
        default:
          l = o % 1e4, c = 4;
          break;
      }
      break;
    case 109:
      switch (t.length) {
        case 1:
        case 2:
          l = r.m, c = t.length;
          break;
        case 3:
          return SS[r.m - 1][1];
        case 5:
          return SS[r.m - 1][0];
        default:
          return SS[r.m - 1][2];
      }
      break;
    case 100:
      switch (t.length) {
        case 1:
        case 2:
          l = r.d, c = t.length;
          break;
        case 3:
          return Dj[r.q][0];
        default:
          return Dj[r.q][1];
      }
      break;
    case 104:
      switch (t.length) {
        case 1:
        case 2:
          l = 1 + (r.H + 11) % 12, c = t.length;
          break;
        default:
          throw "bad hour format: " + t;
      }
      break;
    case 72:
      switch (t.length) {
        case 1:
        case 2:
          l = r.H, c = t.length;
          break;
        default:
          throw "bad hour format: " + t;
      }
      break;
    case 77:
      switch (t.length) {
        case 1:
        case 2:
          l = r.M, c = t.length;
          break;
        default:
          throw "bad minute format: " + t;
      }
      break;
    case 115:
      if (t != "s" && t != "ss" && t != ".0" && t != ".00" && t != ".000") throw "bad second format: " + t;
      return r.u === 0 && (t == "s" || t == "ss") ? Mi(r.S, t.length) : (n >= 2 ? i = n === 3 ? 1e3 : 100 : i = n === 1 ? 10 : 1, s = Math.round(i * (r.S + r.u)), s >= 60 * i && (s = 0), t === "s" ? s === 0 ? "0" : "" + s / i : (a = Mi(s, 2 + n), t === "ss" ? a.substr(0, 2) : "." + a.substr(2, t.length - 1)));
    case 90:
      switch (t) {
        case "[h]":
        case "[hh]":
          l = r.D * 24 + r.H;
          break;
        case "[m]":
        case "[mm]":
          l = (r.D * 24 + r.H) * 60 + r.M;
          break;
        case "[s]":
        case "[ss]":
          l = ((r.D * 24 + r.H) * 60 + r.M) * 60 + Math.round(r.S + r.u);
          break;
        default:
          throw "bad abstime format: " + t;
      }
      c = t.length === 3 ? 1 : 2;
      break;
    case 101:
      l = o, c = 1;
      break;
  }
  var u = c > 0 ? Mi(l, c) : "";
  return u;
}
function _c(e) {
  var t = 3;
  if (e.length <= t) return e;
  for (var r = e.length % t, n = e.substr(0, r); r != e.length; r += t) n += (n.length > 0 ? "," : "") + e.substr(r, t);
  return n;
}
var $7 = /%/g;
function rHe(e, t, r) {
  var n = t.replace($7, ""), a = t.length - n.length;
  return Dl(e, n, r * Math.pow(10, 2 * a)) + An("%", a);
}
function nHe(e, t, r) {
  for (var n = t.length - 1; t.charCodeAt(n - 1) === 44; ) --n;
  return Dl(e, t.substr(0, n), r / Math.pow(10, 3 * (t.length - n)));
}
function H7(e, t) {
  var r, n = e.indexOf("E") - e.indexOf(".") - 1;
  if (e.match(/^#+0.0E\+0$/)) {
    if (t == 0) return "0.0E+0";
    if (t < 0) return "-" + H7(e, -t);
    var a = e.indexOf(".");
    a === -1 && (a = e.indexOf("E"));
    var s = Math.floor(Math.log(t) * Math.LOG10E) % a;
    if (s < 0 && (s += a), r = (t / Math.pow(10, s)).toPrecision(n + 1 + (a + s) % a), r.indexOf("e") === -1) {
      var i = Math.floor(Math.log(t) * Math.LOG10E);
      for (r.indexOf(".") === -1 ? r = r.charAt(0) + "." + r.substr(1) + "E+" + (i - r.length + s) : r += "E+" + (i - s); r.substr(0, 2) === "0."; )
        r = r.charAt(0) + r.substr(2, a) + "." + r.substr(2 + a), r = r.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
      r = r.replace(/\+-/, "-");
    }
    r = r.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(o, l, c, u) {
      return l + c + u.substr(0, (a + s) % a) + "." + u.substr(s) + "E";
    });
  } else r = t.toExponential(n);
  return e.match(/E\+00$/) && r.match(/e[+-]\d$/) && (r = r.substr(0, r.length - 1) + "0" + r.charAt(r.length - 1)), e.match(/E\-/) && r.match(/e\+/) && (r = r.replace(/e\+/, "e")), r.replace("e", "E");
}
var W7 = /# (\?+)( ?)\/( ?)(\d+)/;
function aHe(e, t, r) {
  var n = parseInt(e[4], 10), a = Math.round(t * n), s = Math.floor(a / n), i = a - s * n, o = n;
  return r + (s === 0 ? "" : "" + s) + " " + (i === 0 ? An(" ", e[1].length + 1 + e[4].length) : M2(i, e[1].length) + e[2] + "/" + e[3] + Mi(o, e[4].length));
}
function sHe(e, t, r) {
  return r + (t === 0 ? "" : "" + t) + An(" ", e[1].length + 2 + e[4].length);
}
var z7 = /^#*0*\.([0#]+)/, K7 = /\).*[0#]/, q7 = /\(###\) ###\\?-####/;
function ls(e) {
  for (var t = "", r, n = 0; n != e.length; ++n) switch (r = e.charCodeAt(n)) {
    case 35:
      break;
    case 63:
      t += " ";
      break;
    case 48:
      t += "0";
      break;
    default:
      t += String.fromCharCode(r);
  }
  return t;
}
function Mj(e, t) {
  var r = Math.pow(10, t);
  return "" + Math.round(e * r) / r;
}
function Lj(e, t) {
  var r = e - Math.floor(e), n = Math.pow(10, t);
  return t < ("" + Math.round(r * n)).length ? 0 : Math.round(r * n);
}
function iHe(e, t) {
  return t < ("" + Math.round((e - Math.floor(e)) * Math.pow(10, t))).length ? 1 : 0;
}
function oHe(e) {
  return e < 2147483647 && e > -2147483648 ? "" + (e >= 0 ? e | 0 : e - 1 | 0) : "" + Math.floor(e);
}
function ei(e, t, r) {
  if (e.charCodeAt(0) === 40 && !t.match(K7)) {
    var n = t.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return r >= 0 ? ei("n", n, r) : "(" + ei("n", n, -r) + ")";
  }
  if (t.charCodeAt(t.length - 1) === 44) return nHe(e, t, r);
  if (t.indexOf("%") !== -1) return rHe(e, t, r);
  if (t.indexOf("E") !== -1) return H7(t, r);
  if (t.charCodeAt(0) === 36) return "$" + ei(e, t.substr(t.charAt(1) == " " ? 2 : 1), r);
  var a, s, i, o, l = Math.abs(r), c = r < 0 ? "-" : "";
  if (t.match(/^00+$/)) return c + rf(l, t.length);
  if (t.match(/^[#?]+$/))
    return a = rf(r, 0), a === "0" && (a = ""), a.length > t.length ? a : ls(t.substr(0, t.length - a.length)) + a;
  if (s = t.match(W7)) return aHe(s, l, c);
  if (t.match(/^#+0+$/)) return c + rf(l, t.length - t.indexOf("0"));
  if (s = t.match(z7))
    return a = Mj(r, s[1].length).replace(/^([^\.]+)$/, "$1." + ls(s[1])).replace(/\.$/, "." + ls(s[1])).replace(/\.(\d*)$/, function(p, m) {
      return "." + m + An("0", ls(
        /*::(*/
        s[1]
      ).length - m.length);
    }), t.indexOf("0.") !== -1 ? a : a.replace(/^0\./, ".");
  if (t = t.replace(/^#+([0.])/, "$1"), s = t.match(/^(0*)\.(#*)$/))
    return c + Mj(l, s[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, s[1].length ? "0." : ".");
  if (s = t.match(/^#{1,3},##0(\.?)$/)) return c + _c(rf(l, 0));
  if (s = t.match(/^#,##0\.([#0]*0)$/))
    return r < 0 ? "-" + ei(e, t, -r) : _c("" + (Math.floor(r) + iHe(r, s[1].length))) + "." + Mi(Lj(r, s[1].length), s[1].length);
  if (s = t.match(/^#,#*,#0/)) return ei(e, t.replace(/^#,#*,/, ""), r);
  if (s = t.match(/^([0#]+)(\\?-([0#]+))+$/))
    return a = Wf(ei(e, t.replace(/[\\-]/g, ""), r)), i = 0, Wf(Wf(t.replace(/\\/g, "")).replace(/[0#]/g, function(p) {
      return i < a.length ? a.charAt(i++) : p === "0" ? "0" : "";
    }));
  if (t.match(q7))
    return a = ei(e, "##########", r), "(" + a.substr(0, 3) + ") " + a.substr(3, 3) + "-" + a.substr(6);
  var u = "";
  if (s = t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return i = Math.min(
      /*::String(*/
      s[4].length,
      7
    ), o = nw(l, Math.pow(10, i) - 1, !1), a = "" + c, u = Dl(
      "n",
      /*::String(*/
      s[1],
      o[1]
    ), u.charAt(u.length - 1) == " " && (u = u.substr(0, u.length - 1) + "0"), a += u + /*::String(*/
    s[2] + "/" + /*::String(*/
    s[3], u = tw(o[2], i), u.length < s[4].length && (u = ls(s[4].substr(s[4].length - u.length)) + u), a += u, a;
  if (s = t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return i = Math.min(Math.max(s[1].length, s[4].length), 7), o = nw(l, Math.pow(10, i) - 1, !0), c + (o[0] || (o[1] ? "" : "0")) + " " + (o[1] ? M2(o[1], i) + s[2] + "/" + s[3] + tw(o[2], i) : An(" ", 2 * i + 1 + s[2].length + s[3].length));
  if (s = t.match(/^[#0?]+$/))
    return a = rf(r, 0), t.length <= a.length ? a : ls(t.substr(0, t.length - a.length)) + a;
  if (s = t.match(/^([#0?]+)\.([#0]+)$/)) {
    a = "" + r.toFixed(Math.min(s[2].length, 10)).replace(/([^0])0+$/, "$1"), i = a.indexOf(".");
    var d = t.indexOf(".") - i, f = t.length - a.length - d;
    return ls(t.substr(0, d) + a + t.substr(t.length - f));
  }
  if (s = t.match(/^00,000\.([#0]*0)$/))
    return i = Lj(r, s[1].length), r < 0 ? "-" + ei(e, t, -r) : _c(oHe(r)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(p) {
      return "00," + (p.length < 3 ? Mi(0, 3 - p.length) : "") + p;
    }) + "." + Mi(i, s[1].length);
  switch (t) {
    case "###,##0.00":
      return ei(e, "#,##0.00", r);
    case "###,###":
    case "##,###":
    case "#,###":
      var h = _c(rf(l, 0));
      return h !== "0" ? c + h : "";
    case "###,###.00":
      return ei(e, "###,##0.00", r).replace(/^0\./, ".");
    case "#,###.00":
      return ei(e, "#,##0.00", r).replace(/^0\./, ".");
  }
  throw new Error("unsupported format |" + t + "|");
}
function lHe(e, t, r) {
  for (var n = t.length - 1; t.charCodeAt(n - 1) === 44; ) --n;
  return Dl(e, t.substr(0, n), r / Math.pow(10, 3 * (t.length - n)));
}
function cHe(e, t, r) {
  var n = t.replace($7, ""), a = t.length - n.length;
  return Dl(e, n, r * Math.pow(10, 2 * a)) + An("%", a);
}
function G7(e, t) {
  var r, n = e.indexOf("E") - e.indexOf(".") - 1;
  if (e.match(/^#+0.0E\+0$/)) {
    if (t == 0) return "0.0E+0";
    if (t < 0) return "-" + G7(e, -t);
    var a = e.indexOf(".");
    a === -1 && (a = e.indexOf("E"));
    var s = Math.floor(Math.log(t) * Math.LOG10E) % a;
    if (s < 0 && (s += a), r = (t / Math.pow(10, s)).toPrecision(n + 1 + (a + s) % a), !r.match(/[Ee]/)) {
      var i = Math.floor(Math.log(t) * Math.LOG10E);
      r.indexOf(".") === -1 ? r = r.charAt(0) + "." + r.substr(1) + "E+" + (i - r.length + s) : r += "E+" + (i - s), r = r.replace(/\+-/, "-");
    }
    r = r.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(o, l, c, u) {
      return l + c + u.substr(0, (a + s) % a) + "." + u.substr(s) + "E";
    });
  } else r = t.toExponential(n);
  return e.match(/E\+00$/) && r.match(/e[+-]\d$/) && (r = r.substr(0, r.length - 1) + "0" + r.charAt(r.length - 1)), e.match(/E\-/) && r.match(/e\+/) && (r = r.replace(/e\+/, "e")), r.replace("e", "E");
}
function uo(e, t, r) {
  if (e.charCodeAt(0) === 40 && !t.match(K7)) {
    var n = t.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return r >= 0 ? uo("n", n, r) : "(" + uo("n", n, -r) + ")";
  }
  if (t.charCodeAt(t.length - 1) === 44) return lHe(e, t, r);
  if (t.indexOf("%") !== -1) return cHe(e, t, r);
  if (t.indexOf("E") !== -1) return G7(t, r);
  if (t.charCodeAt(0) === 36) return "$" + uo(e, t.substr(t.charAt(1) == " " ? 2 : 1), r);
  var a, s, i, o, l = Math.abs(r), c = r < 0 ? "-" : "";
  if (t.match(/^00+$/)) return c + Mi(l, t.length);
  if (t.match(/^[#?]+$/))
    return a = "" + r, r === 0 && (a = ""), a.length > t.length ? a : ls(t.substr(0, t.length - a.length)) + a;
  if (s = t.match(W7)) return sHe(s, l, c);
  if (t.match(/^#+0+$/)) return c + Mi(l, t.length - t.indexOf("0"));
  if (s = t.match(z7))
    return a = ("" + r).replace(/^([^\.]+)$/, "$1." + ls(s[1])).replace(/\.$/, "." + ls(s[1])), a = a.replace(/\.(\d*)$/, function(p, m) {
      return "." + m + An("0", ls(s[1]).length - m.length);
    }), t.indexOf("0.") !== -1 ? a : a.replace(/^0\./, ".");
  if (t = t.replace(/^#+([0.])/, "$1"), s = t.match(/^(0*)\.(#*)$/))
    return c + ("" + l).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, s[1].length ? "0." : ".");
  if (s = t.match(/^#{1,3},##0(\.?)$/)) return c + _c("" + l);
  if (s = t.match(/^#,##0\.([#0]*0)$/))
    return r < 0 ? "-" + uo(e, t, -r) : _c("" + r) + "." + An("0", s[1].length);
  if (s = t.match(/^#,#*,#0/)) return uo(e, t.replace(/^#,#*,/, ""), r);
  if (s = t.match(/^([0#]+)(\\?-([0#]+))+$/))
    return a = Wf(uo(e, t.replace(/[\\-]/g, ""), r)), i = 0, Wf(Wf(t.replace(/\\/g, "")).replace(/[0#]/g, function(p) {
      return i < a.length ? a.charAt(i++) : p === "0" ? "0" : "";
    }));
  if (t.match(q7))
    return a = uo(e, "##########", r), "(" + a.substr(0, 3) + ") " + a.substr(3, 3) + "-" + a.substr(6);
  var u = "";
  if (s = t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return i = Math.min(
      /*::String(*/
      s[4].length,
      7
    ), o = nw(l, Math.pow(10, i) - 1, !1), a = "" + c, u = Dl(
      "n",
      /*::String(*/
      s[1],
      o[1]
    ), u.charAt(u.length - 1) == " " && (u = u.substr(0, u.length - 1) + "0"), a += u + /*::String(*/
    s[2] + "/" + /*::String(*/
    s[3], u = tw(o[2], i), u.length < s[4].length && (u = ls(s[4].substr(s[4].length - u.length)) + u), a += u, a;
  if (s = t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return i = Math.min(Math.max(s[1].length, s[4].length), 7), o = nw(l, Math.pow(10, i) - 1, !0), c + (o[0] || (o[1] ? "" : "0")) + " " + (o[1] ? M2(o[1], i) + s[2] + "/" + s[3] + tw(o[2], i) : An(" ", 2 * i + 1 + s[2].length + s[3].length));
  if (s = t.match(/^[#0?]+$/))
    return a = "" + r, t.length <= a.length ? a : ls(t.substr(0, t.length - a.length)) + a;
  if (s = t.match(/^([#0]+)\.([#0]+)$/)) {
    a = "" + r.toFixed(Math.min(s[2].length, 10)).replace(/([^0])0+$/, "$1"), i = a.indexOf(".");
    var d = t.indexOf(".") - i, f = t.length - a.length - d;
    return ls(t.substr(0, d) + a + t.substr(t.length - f));
  }
  if (s = t.match(/^00,000\.([#0]*0)$/))
    return r < 0 ? "-" + uo(e, t, -r) : _c("" + r).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(p) {
      return "00," + (p.length < 3 ? Mi(0, 3 - p.length) : "") + p;
    }) + "." + Mi(0, s[1].length);
  switch (t) {
    case "###,###":
    case "##,###":
    case "#,###":
      var h = _c("" + l);
      return h !== "0" ? c + h : "";
    default:
      if (t.match(/\.[0#?]*$/)) return uo(e, t.slice(0, t.lastIndexOf(".")), r) + ls(t.slice(t.lastIndexOf(".")));
  }
  throw new Error("unsupported format |" + t + "|");
}
function Dl(e, t, r) {
  return (r | 0) === r ? uo(e, t, r) : ei(e, t, r);
}
function uHe(e) {
  for (var t = [], r = !1, n = 0, a = 0; n < e.length; ++n) switch (
    /*cc=*/
    e.charCodeAt(n)
  ) {
    case 34:
      r = !r;
      break;
    case 95:
    case 42:
    case 92:
      ++n;
      break;
    case 59:
      t[t.length] = e.substr(a, n - a), a = n + 1;
  }
  if (t[t.length] = e.substr(a), r === !0) throw new Error("Format |" + e + "| unterminated string ");
  return t;
}
var Y7 = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function X7(e) {
  for (var t = 0, r = "", n = ""; t < e.length; )
    switch (r = e.charAt(t)) {
      case "G":
        rw(e, t) && (t += 6), t++;
        break;
      case '"':
        for (
          ;
          /*cc=*/
          e.charCodeAt(++t) !== 34 && t < e.length;
        )
          ;
        ++t;
        break;
      case "\\":
        t += 2;
        break;
      case "_":
        t += 2;
        break;
      case "@":
        ++t;
        break;
      case "B":
      case "b":
        if (e.charAt(t + 1) === "1" || e.charAt(t + 1) === "2") return !0;
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        return !0;
      case "A":
      case "a":
      case "上":
        if (e.substr(t, 3).toUpperCase() === "A/P" || e.substr(t, 5).toUpperCase() === "AM/PM" || e.substr(t, 5).toUpperCase() === "上午/下午") return !0;
        ++t;
        break;
      case "[":
        for (n = r; e.charAt(t++) !== "]" && t < e.length; ) n += e.charAt(t);
        if (n.match(Y7)) return !0;
        break;
      case ".":
      case "0":
      case "#":
        for (; t < e.length && ("0#?.,E+-%".indexOf(r = e.charAt(++t)) > -1 || r == "\\" && e.charAt(t + 1) == "-" && "0#".indexOf(e.charAt(t + 2)) > -1); )
          ;
        break;
      case "?":
        for (; e.charAt(++t) === r; )
          ;
        break;
      case "*":
        ++t, (e.charAt(t) == " " || e.charAt(t) == "*") && ++t;
        break;
      case "(":
      case ")":
        ++t;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (; t < e.length && "0123456789".indexOf(e.charAt(++t)) > -1; )
          ;
        break;
      case " ":
        ++t;
        break;
      default:
        ++t;
        break;
    }
  return !1;
}
function dHe(e, t, r, n) {
  for (var a = [], s = "", i = 0, o = "", l = "t", c, u, d, f = "H"; i < e.length; )
    switch (o = e.charAt(i)) {
      case "G":
        if (!rw(e, i)) throw new Error("unrecognized character " + o + " in " + e);
        a[a.length] = { t: "G", v: "General" }, i += 7;
        break;
      case '"':
        for (s = ""; (d = e.charCodeAt(++i)) !== 34 && i < e.length; ) s += String.fromCharCode(d);
        a[a.length] = { t: "t", v: s }, ++i;
        break;
      case "\\":
        var h = e.charAt(++i), p = h === "(" || h === ")" ? h : "t";
        a[a.length] = { t: p, v: h }, ++i;
        break;
      case "_":
        a[a.length] = { t: "t", v: " " }, i += 2;
        break;
      case "@":
        a[a.length] = { t: "T", v: t }, ++i;
        break;
      case "B":
      case "b":
        if (e.charAt(i + 1) === "1" || e.charAt(i + 1) === "2") {
          if (c == null && (c = sy(t, r, e.charAt(i + 1) === "2"), c == null))
            return "";
          a[a.length] = { t: "X", v: e.substr(i, 2) }, l = o, i += 2;
          break;
        }
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
        o = o.toLowerCase();
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        if (t < 0 || c == null && (c = sy(t, r), c == null))
          return "";
        for (s = o; ++i < e.length && e.charAt(i).toLowerCase() === o; ) s += o;
        o === "m" && l.toLowerCase() === "h" && (o = "M"), o === "h" && (o = f), a[a.length] = { t: o, v: s }, l = o;
        break;
      case "A":
      case "a":
      case "上":
        var m = { t: o, v: o };
        if (c == null && (c = sy(t, r)), e.substr(i, 3).toUpperCase() === "A/P" ? (c != null && (m.v = c.H >= 12 ? "P" : "A"), m.t = "T", f = "h", i += 3) : e.substr(i, 5).toUpperCase() === "AM/PM" ? (c != null && (m.v = c.H >= 12 ? "PM" : "AM"), m.t = "T", i += 5, f = "h") : e.substr(i, 5).toUpperCase() === "上午/下午" ? (c != null && (m.v = c.H >= 12 ? "下午" : "上午"), m.t = "T", i += 5, f = "h") : (m.t = "t", ++i), c == null && m.t === "T") return "";
        a[a.length] = m, l = o;
        break;
      case "[":
        for (s = o; e.charAt(i++) !== "]" && i < e.length; ) s += e.charAt(i);
        if (s.slice(-1) !== "]") throw 'unterminated "[" block: |' + s + "|";
        if (s.match(Y7)) {
          if (c == null && (c = sy(t, r), c == null))
            return "";
          a[a.length] = { t: "Z", v: s.toLowerCase() }, l = s.charAt(1);
        } else s.indexOf("$") > -1 && (s = (s.match(/\$([^-\[\]]*)/) || [])[1] || "$", X7(e) || (a[a.length] = { t: "t", v: s }));
        break;
      case ".":
        if (c != null) {
          for (s = o; ++i < e.length && (o = e.charAt(i)) === "0"; ) s += o;
          a[a.length] = { t: "s", v: s };
          break;
        }
      case "0":
      case "#":
        for (s = o; ++i < e.length && "0#?.,E+-%".indexOf(o = e.charAt(i)) > -1; ) s += o;
        a[a.length] = { t: "n", v: s };
        break;
      case "?":
        for (s = o; e.charAt(++i) === o; ) s += o;
        a[a.length] = { t: o, v: s }, l = o;
        break;
      case "*":
        ++i, (e.charAt(i) == " " || e.charAt(i) == "*") && ++i;
        break;
      case "(":
      case ")":
        a[a.length] = { t: n === 1 ? "t" : o, v: o }, ++i;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (s = o; i < e.length && "0123456789".indexOf(e.charAt(++i)) > -1; ) s += e.charAt(i);
        a[a.length] = { t: "D", v: s };
        break;
      case " ":
        a[a.length] = { t: o, v: o }, ++i;
        break;
      case "$":
        a[a.length] = { t: "t", v: "$" }, ++i;
        break;
      default:
        if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(o) === -1) throw new Error("unrecognized character " + o + " in " + e);
        a[a.length] = { t: "t", v: o }, ++i;
        break;
    }
  var g = 0, y = 0, x;
  for (i = a.length - 1, l = "t"; i >= 0; --i)
    switch (a[i].t) {
      case "h":
      case "H":
        a[i].t = f, l = "h", g < 1 && (g = 1);
        break;
      case "s":
        (x = a[i].v.match(/\.0+$/)) && (y = Math.max(y, x[0].length - 1)), g < 3 && (g = 3);
      case "d":
      case "y":
      case "M":
      case "e":
        l = a[i].t;
        break;
      case "m":
        l === "s" && (a[i].t = "M", g < 2 && (g = 2));
        break;
      case "X":
        break;
      case "Z":
        g < 1 && a[i].v.match(/[Hh]/) && (g = 1), g < 2 && a[i].v.match(/[Mm]/) && (g = 2), g < 3 && a[i].v.match(/[Ss]/) && (g = 3);
    }
  switch (g) {
    case 0:
      break;
    case 1:
      c.u >= 0.5 && (c.u = 0, ++c.S), c.S >= 60 && (c.S = 0, ++c.M), c.M >= 60 && (c.M = 0, ++c.H);
      break;
    case 2:
      c.u >= 0.5 && (c.u = 0, ++c.S), c.S >= 60 && (c.S = 0, ++c.M);
      break;
  }
  var w = "", _;
  for (i = 0; i < a.length; ++i)
    switch (a[i].t) {
      case "t":
      case "T":
      case " ":
      case "D":
        break;
      case "X":
        a[i].v = "", a[i].t = ";";
        break;
      case "d":
      case "m":
      case "y":
      case "h":
      case "H":
      case "M":
      case "s":
      case "e":
      case "b":
      case "Z":
        a[i].v = tHe(a[i].t.charCodeAt(0), a[i].v, c, y), a[i].t = "t";
        break;
      case "n":
      case "?":
        for (_ = i + 1; a[_] != null && ((o = a[_].t) === "?" || o === "D" || (o === " " || o === "t") && a[_ + 1] != null && (a[_ + 1].t === "?" || a[_ + 1].t === "t" && a[_ + 1].v === "/") || a[i].t === "(" && (o === " " || o === "n" || o === ")") || o === "t" && (a[_].v === "/" || a[_].v === " " && a[_ + 1] != null && a[_ + 1].t == "?")); )
          a[i].v += a[_].v, a[_] = { v: "", t: ";" }, ++_;
        w += a[i].v, i = _ - 1;
        break;
      case "G":
        a[i].t = "t", a[i].v = mT(t, r);
        break;
    }
  var S = "", C, E;
  if (w.length > 0) {
    w.charCodeAt(0) == 40 ? (C = t < 0 && w.charCodeAt(0) === 45 ? -t : t, E = Dl("n", w, C)) : (C = t < 0 && n > 1 ? -t : t, E = Dl("n", w, C), C < 0 && a[0] && a[0].t == "t" && (E = E.substr(1), a[0].v = "-" + a[0].v)), _ = E.length - 1;
    var O = a.length;
    for (i = 0; i < a.length; ++i) if (a[i] != null && a[i].t != "t" && a[i].v.indexOf(".") > -1) {
      O = i;
      break;
    }
    var k = a.length;
    if (O === a.length && E.indexOf("E") === -1) {
      for (i = a.length - 1; i >= 0; --i)
        a[i] == null || "n?".indexOf(a[i].t) === -1 || (_ >= a[i].v.length - 1 ? (_ -= a[i].v.length, a[i].v = E.substr(_ + 1, a[i].v.length)) : _ < 0 ? a[i].v = "" : (a[i].v = E.substr(0, _ + 1), _ = -1), a[i].t = "t", k = i);
      _ >= 0 && k < a.length && (a[k].v = E.substr(0, _ + 1) + a[k].v);
    } else if (O !== a.length && E.indexOf("E") === -1) {
      for (_ = E.indexOf(".") - 1, i = O; i >= 0; --i)
        if (!(a[i] == null || "n?".indexOf(a[i].t) === -1)) {
          for (u = a[i].v.indexOf(".") > -1 && i === O ? a[i].v.indexOf(".") - 1 : a[i].v.length - 1, S = a[i].v.substr(u + 1); u >= 0; --u)
            _ >= 0 && (a[i].v.charAt(u) === "0" || a[i].v.charAt(u) === "#") && (S = E.charAt(_--) + S);
          a[i].v = S, a[i].t = "t", k = i;
        }
      for (_ >= 0 && k < a.length && (a[k].v = E.substr(0, _ + 1) + a[k].v), _ = E.indexOf(".") + 1, i = O; i < a.length; ++i)
        if (!(a[i] == null || "n?(".indexOf(a[i].t) === -1 && i !== O)) {
          for (u = a[i].v.indexOf(".") > -1 && i === O ? a[i].v.indexOf(".") + 1 : 0, S = a[i].v.substr(0, u); u < a[i].v.length; ++u)
            _ < E.length && (S += E.charAt(_++));
          a[i].v = S, a[i].t = "t", k = i;
        }
    }
  }
  for (i = 0; i < a.length; ++i) a[i] != null && "n?".indexOf(a[i].t) > -1 && (C = n > 1 && t < 0 && i > 0 && a[i - 1].v === "-" ? -t : t, a[i].v = Dl(a[i].t, a[i].v, C), a[i].t = "t");
  var A = "";
  for (i = 0; i !== a.length; ++i) a[i] != null && (A += a[i].v);
  return A;
}
var jj = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function Fj(e, t) {
  if (t == null) return !1;
  var r = parseFloat(t[2]);
  switch (t[1]) {
    case "=":
      if (e == r) return !0;
      break;
    case ">":
      if (e > r) return !0;
      break;
    case "<":
      if (e < r) return !0;
      break;
    case "<>":
      if (e != r) return !0;
      break;
    case ">=":
      if (e >= r) return !0;
      break;
    case "<=":
      if (e <= r) return !0;
      break;
  }
  return !1;
}
function fHe(e, t) {
  var r = uHe(e), n = r.length, a = r[n - 1].indexOf("@");
  if (n < 4 && a > -1 && --n, r.length > 4) throw new Error("cannot find right format for |" + r.join("|") + "|");
  if (typeof t != "number") return [4, r.length === 4 || a > -1 ? r[r.length - 1] : "@"];
  switch (r.length) {
    case 1:
      r = a > -1 ? ["General", "General", "General", r[0]] : [r[0], r[0], r[0], "@"];
      break;
    case 2:
      r = a > -1 ? [r[0], r[0], r[0], r[1]] : [r[0], r[1], r[0], "@"];
      break;
    case 3:
      r = a > -1 ? [r[0], r[1], r[0], r[2]] : [r[0], r[1], r[2], "@"];
      break;
  }
  var s = t > 0 ? r[0] : t < 0 ? r[1] : r[2];
  if (r[0].indexOf("[") === -1 && r[1].indexOf("[") === -1) return [n, s];
  if (r[0].match(/\[[=<>]/) != null || r[1].match(/\[[=<>]/) != null) {
    var i = r[0].match(jj), o = r[1].match(jj);
    return Fj(t, i) ? [n, r[0]] : Fj(t, o) ? [n, r[1]] : [n, r[i != null && o != null ? 2 : 1]];
  }
  return [n, s];
}
function Bc(e, t, r) {
  r == null && (r = {});
  var n = "";
  switch (typeof e) {
    case "string":
      e == "m/d/yy" && r.dateNF ? n = r.dateNF : n = e;
      break;
    case "number":
      e == 14 && r.dateNF ? n = r.dateNF : n = (r.table != null ? r.table : Rn)[e], n == null && (n = r.table && r.table[Nj[e]] || Rn[Nj[e]]), n == null && (n = q8e[e] || "General");
      break;
  }
  if (rw(n, 0)) return mT(t, r);
  t instanceof Date && (t = V7(t, r.date1904));
  var a = fHe(n, t);
  if (rw(a[1])) return mT(t, r);
  if (t === !0) t = "TRUE";
  else if (t === !1) t = "FALSE";
  else if (t === "" || t == null) return "";
  return dHe(a[1], t, r, a[0]);
}
function Q7(e, t) {
  if (typeof t != "number") {
    t = +t || -1;
    for (var r = 0; r < 392; ++r) {
      if (Rn[r] == null) {
        t < 0 && (t = r);
        continue;
      }
      if (Rn[r] == e) {
        t = r;
        break;
      }
    }
    t < 0 && (t = 391);
  }
  return Rn[t] = e, t;
}
function Gx(e) {
  for (var t = 0; t != 392; ++t)
    e[t] !== void 0 && Q7(e[t], t);
}
function Yx() {
  Rn = K8e();
}
var J7 = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function hHe(e) {
  var t = typeof e == "number" ? Rn[e] : e;
  return t = t.replace(J7, "(\\d+)"), new RegExp("^" + t + "$");
}
function pHe(e, t, r) {
  var n = -1, a = -1, s = -1, i = -1, o = -1, l = -1;
  (t.match(J7) || []).forEach(function(d, f) {
    var h = parseInt(r[f + 1], 10);
    switch (d.toLowerCase().charAt(0)) {
      case "y":
        n = h;
        break;
      case "d":
        s = h;
        break;
      case "h":
        i = h;
        break;
      case "s":
        l = h;
        break;
      case "m":
        i >= 0 ? o = h : a = h;
        break;
    }
  }), l >= 0 && o == -1 && a >= 0 && (o = a, a = -1);
  var c = ("" + (n >= 0 ? n : (/* @__PURE__ */ new Date()).getFullYear())).slice(-4) + "-" + ("00" + (a >= 1 ? a : 1)).slice(-2) + "-" + ("00" + (s >= 1 ? s : 1)).slice(-2);
  c.length == 7 && (c = "0" + c), c.length == 8 && (c = "20" + c);
  var u = ("00" + (i >= 0 ? i : 0)).slice(-2) + ":" + ("00" + (o >= 0 ? o : 0)).slice(-2) + ":" + ("00" + (l >= 0 ? l : 0)).slice(-2);
  return i == -1 && o == -1 && l == -1 ? c : n == -1 && a == -1 && s == -1 ? u : c + "T" + u;
}
var mHe = /* @__PURE__ */ function() {
  var e = {};
  e.version = "1.2.0";
  function t() {
    for (var E = 0, O = new Array(256), k = 0; k != 256; ++k)
      E = k, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, O[k] = E;
    return typeof Int32Array < "u" ? new Int32Array(O) : O;
  }
  var r = t();
  function n(E) {
    var O = 0, k = 0, A = 0, P = typeof Int32Array < "u" ? new Int32Array(4096) : new Array(4096);
    for (A = 0; A != 256; ++A) P[A] = E[A];
    for (A = 0; A != 256; ++A)
      for (k = E[A], O = 256 + A; O < 4096; O += 256) k = P[O] = k >>> 8 ^ E[k & 255];
    var D = [];
    for (A = 1; A != 16; ++A) D[A - 1] = typeof Int32Array < "u" ? P.subarray(A * 256, A * 256 + 256) : P.slice(A * 256, A * 256 + 256);
    return D;
  }
  var a = n(r), s = a[0], i = a[1], o = a[2], l = a[3], c = a[4], u = a[5], d = a[6], f = a[7], h = a[8], p = a[9], m = a[10], g = a[11], y = a[12], x = a[13], w = a[14];
  function _(E, O) {
    for (var k = O ^ -1, A = 0, P = E.length; A < P; ) k = k >>> 8 ^ r[(k ^ E.charCodeAt(A++)) & 255];
    return ~k;
  }
  function S(E, O) {
    for (var k = O ^ -1, A = E.length - 15, P = 0; P < A; ) k = w[E[P++] ^ k & 255] ^ x[E[P++] ^ k >> 8 & 255] ^ y[E[P++] ^ k >> 16 & 255] ^ g[E[P++] ^ k >>> 24] ^ m[E[P++]] ^ p[E[P++]] ^ h[E[P++]] ^ f[E[P++]] ^ d[E[P++]] ^ u[E[P++]] ^ c[E[P++]] ^ l[E[P++]] ^ o[E[P++]] ^ i[E[P++]] ^ s[E[P++]] ^ r[E[P++]];
    for (A += 15; P < A; ) k = k >>> 8 ^ r[(k ^ E[P++]) & 255];
    return ~k;
  }
  function C(E, O) {
    for (var k = O ^ -1, A = 0, P = E.length, D = 0, N = 0; A < P; )
      D = E.charCodeAt(A++), D < 128 ? k = k >>> 8 ^ r[(k ^ D) & 255] : D < 2048 ? (k = k >>> 8 ^ r[(k ^ (192 | D >> 6 & 31)) & 255], k = k >>> 8 ^ r[(k ^ (128 | D & 63)) & 255]) : D >= 55296 && D < 57344 ? (D = (D & 1023) + 64, N = E.charCodeAt(A++) & 1023, k = k >>> 8 ^ r[(k ^ (240 | D >> 8 & 7)) & 255], k = k >>> 8 ^ r[(k ^ (128 | D >> 2 & 63)) & 255], k = k >>> 8 ^ r[(k ^ (128 | N >> 6 & 15 | (D & 3) << 4)) & 255], k = k >>> 8 ^ r[(k ^ (128 | N & 63)) & 255]) : (k = k >>> 8 ^ r[(k ^ (224 | D >> 12 & 15)) & 255], k = k >>> 8 ^ r[(k ^ (128 | D >> 6 & 63)) & 255], k = k >>> 8 ^ r[(k ^ (128 | D & 63)) & 255]);
    return ~k;
  }
  return e.table = r, e.bstr = _, e.buf = S, e.str = C, e;
}(), rn = /* @__PURE__ */ function() {
  var t = {};
  t.version = "1.2.1";
  function r(W, ie) {
    for (var I = W.split("/"), H = ie.split("/"), X = 0, Z = 0, Se = Math.min(I.length, H.length); X < Se; ++X) {
      if (Z = I[X].length - H[X].length) return Z;
      if (I[X] != H[X]) return I[X] < H[X] ? -1 : 1;
    }
    return I.length - H.length;
  }
  function n(W) {
    if (W.charAt(W.length - 1) == "/") return W.slice(0, -1).indexOf("/") === -1 ? W : n(W.slice(0, -1));
    var ie = W.lastIndexOf("/");
    return ie === -1 ? W : W.slice(0, ie + 1);
  }
  function a(W) {
    if (W.charAt(W.length - 1) == "/") return a(W.slice(0, -1));
    var ie = W.lastIndexOf("/");
    return ie === -1 ? W : W.slice(ie + 1);
  }
  function s(W, ie) {
    typeof ie == "string" && (ie = new Date(ie));
    var I = ie.getHours();
    I = I << 6 | ie.getMinutes(), I = I << 5 | ie.getSeconds() >>> 1, W.write_shift(2, I);
    var H = ie.getFullYear() - 1980;
    H = H << 4 | ie.getMonth() + 1, H = H << 5 | ie.getDate(), W.write_shift(2, H);
  }
  function i(W) {
    var ie = W.read_shift(2) & 65535, I = W.read_shift(2) & 65535, H = /* @__PURE__ */ new Date(), X = I & 31;
    I >>>= 5;
    var Z = I & 15;
    I >>>= 4, H.setMilliseconds(0), H.setFullYear(I + 1980), H.setMonth(Z - 1), H.setDate(X);
    var Se = ie & 31;
    ie >>>= 5;
    var Ie = ie & 63;
    return ie >>>= 6, H.setHours(ie), H.setMinutes(Ie), H.setSeconds(Se << 1), H;
  }
  function o(W) {
    Fs(W, 0);
    for (var ie = (
      /*::(*/
      {}
    ), I = 0; W.l <= W.length - 4; ) {
      var H = W.read_shift(2), X = W.read_shift(2), Z = W.l + X, Se = {};
      switch (H) {
        case 21589:
          I = W.read_shift(1), I & 1 && (Se.mtime = W.read_shift(4)), X > 5 && (I & 2 && (Se.atime = W.read_shift(4)), I & 4 && (Se.ctime = W.read_shift(4))), Se.mtime && (Se.mt = new Date(Se.mtime * 1e3));
          break;
      }
      W.l = Z, ie[H] = Se;
    }
    return ie;
  }
  var l;
  function c() {
    return l || (l = {});
  }
  function u(W, ie) {
    if (W[0] == 80 && W[1] == 75) return Hr(W, ie);
    if ((W[0] | 32) == 109 && (W[1] | 32) == 105) return Lt(W, ie);
    if (W.length < 512) throw new Error("CFB file size " + W.length + " < 512");
    var I = 3, H = 512, X = 0, Z = 0, Se = 0, Ie = 0, ge = 0, xe = [], De = (
      /*::(*/
      W.slice(0, 512)
    );
    Fs(De, 0);
    var je = d(De);
    switch (I = je[0], I) {
      case 3:
        H = 512;
        break;
      case 4:
        H = 4096;
        break;
      case 0:
        if (je[1] == 0) return Hr(W, ie);
      default:
        throw new Error("Major Version: Expected 3 or 4 saw " + I);
    }
    H !== 512 && (De = /*::(*/
    W.slice(0, H), Fs(
      De,
      28
      /* blob.l */
    ));
    var at = W.slice(0, H);
    f(De, I);
    var pt = De.read_shift(4, "i");
    if (I === 3 && pt !== 0) throw new Error("# Directory Sectors: Expected 0 saw " + pt);
    De.l += 4, Se = De.read_shift(4, "i"), De.l += 4, De.chk("00100000", "Mini Stream Cutoff Size: "), Ie = De.read_shift(4, "i"), X = De.read_shift(4, "i"), ge = De.read_shift(4, "i"), Z = De.read_shift(4, "i");
    for (var ct = -1, gt = 0; gt < 109 && (ct = De.read_shift(4, "i"), !(ct < 0)); ++gt)
      xe[gt] = ct;
    var Pt = h(W, H);
    g(ge, Z, Pt, H, xe);
    var Ir = x(Pt, Se, xe, H);
    Ir[Se].name = "!Directory", X > 0 && Ie !== N && (Ir[Ie].name = "!MiniFAT"), Ir[xe[0]].name = "!FAT", Ir.fat_addrs = xe, Ir.ssz = H;
    var Wr = {}, Nn = [], Qo = [], Yl = [];
    w(Se, Ir, Pt, Nn, X, Wr, Qo, Ie), p(Qo, Yl, Nn), Nn.shift();
    var La = {
      FileIndex: Qo,
      FullPaths: Yl
    };
    return ie && ie.raw && (La.raw = { header: at, sectors: Pt }), La;
  }
  function d(W) {
    if (W[W.l] == 80 && W[W.l + 1] == 75) return [0, 0];
    W.chk(z, "Header Signature: "), W.l += 16;
    var ie = W.read_shift(2, "u");
    return [W.read_shift(2, "u"), ie];
  }
  function f(W, ie) {
    var I = 9;
    switch (W.l += 2, I = W.read_shift(2)) {
      case 9:
        if (ie != 3) throw new Error("Sector Shift: Expected 9 saw " + I);
        break;
      case 12:
        if (ie != 4) throw new Error("Sector Shift: Expected 12 saw " + I);
        break;
      default:
        throw new Error("Sector Shift: Expected 9 or 12 saw " + I);
    }
    W.chk("0600", "Mini Sector Shift: "), W.chk("000000000000", "Reserved: ");
  }
  function h(W, ie) {
    for (var I = Math.ceil(W.length / ie) - 1, H = [], X = 1; X < I; ++X) H[X - 1] = W.slice(X * ie, (X + 1) * ie);
    return H[I - 1] = W.slice(I * ie), H;
  }
  function p(W, ie, I) {
    for (var H = 0, X = 0, Z = 0, Se = 0, Ie = 0, ge = I.length, xe = [], De = []; H < ge; ++H)
      xe[H] = De[H] = H, ie[H] = I[H];
    for (; Ie < De.length; ++Ie)
      H = De[Ie], X = W[H].L, Z = W[H].R, Se = W[H].C, xe[H] === H && (X !== -1 && xe[X] !== X && (xe[H] = xe[X]), Z !== -1 && xe[Z] !== Z && (xe[H] = xe[Z])), Se !== -1 && (xe[Se] = H), X !== -1 && H != xe[H] && (xe[X] = xe[H], De.lastIndexOf(X) < Ie && De.push(X)), Z !== -1 && H != xe[H] && (xe[Z] = xe[H], De.lastIndexOf(Z) < Ie && De.push(Z));
    for (H = 1; H < ge; ++H) xe[H] === H && (Z !== -1 && xe[Z] !== Z ? xe[H] = xe[Z] : X !== -1 && xe[X] !== X && (xe[H] = xe[X]));
    for (H = 1; H < ge; ++H)
      if (W[H].type !== 0) {
        if (Ie = H, Ie != xe[Ie]) do
          Ie = xe[Ie], ie[H] = ie[Ie] + "/" + ie[H];
        while (Ie !== 0 && xe[Ie] !== -1 && Ie != xe[Ie]);
        xe[H] = -1;
      }
    for (ie[0] += "/", H = 1; H < ge; ++H)
      W[H].type !== 2 && (ie[H] += "/");
  }
  function m(W, ie, I) {
    for (var H = W.start, X = W.size, Z = [], Se = H; I && X > 0 && Se >= 0; )
      Z.push(ie.slice(Se * D, Se * D + D)), X -= D, Se = yu(I, Se * 4);
    return Z.length === 0 ? Ke(0) : Oa(Z).slice(0, W.size);
  }
  function g(W, ie, I, H, X) {
    var Z = N;
    if (W === N) {
      if (ie !== 0) throw new Error("DIFAT chain shorter than expected");
    } else if (W !== -1) {
      var Se = I[W], Ie = (H >>> 2) - 1;
      if (!Se) return;
      for (var ge = 0; ge < Ie && (Z = yu(Se, ge * 4)) !== N; ++ge)
        X.push(Z);
      g(yu(Se, H - 4), ie - 1, I, H, X);
    }
  }
  function y(W, ie, I, H, X) {
    var Z = [], Se = [];
    X || (X = []);
    var Ie = H - 1, ge = 0, xe = 0;
    for (ge = ie; ge >= 0; ) {
      X[ge] = !0, Z[Z.length] = ge, Se.push(W[ge]);
      var De = I[Math.floor(ge * 4 / H)];
      if (xe = ge * 4 & Ie, H < 4 + xe) throw new Error("FAT boundary crossed: " + ge + " 4 " + H);
      if (!W[De]) break;
      ge = yu(W[De], xe);
    }
    return { nodes: Z, data: Kj([Se]) };
  }
  function x(W, ie, I, H) {
    var X = W.length, Z = [], Se = [], Ie = [], ge = [], xe = H - 1, De = 0, je = 0, at = 0, pt = 0;
    for (De = 0; De < X; ++De)
      if (Ie = [], at = De + ie, at >= X && (at -= X), !Se[at]) {
        ge = [];
        var ct = [];
        for (je = at; je >= 0; ) {
          ct[je] = !0, Se[je] = !0, Ie[Ie.length] = je, ge.push(W[je]);
          var gt = I[Math.floor(je * 4 / H)];
          if (pt = je * 4 & xe, H < 4 + pt) throw new Error("FAT boundary crossed: " + je + " 4 " + H);
          if (!W[gt] || (je = yu(W[gt], pt), ct[je])) break;
        }
        Z[at] = { nodes: Ie, data: Kj([ge]) };
      }
    return Z;
  }
  function w(W, ie, I, H, X, Z, Se, Ie) {
    for (var ge = 0, xe = H.length ? 2 : 0, De = ie[W].data, je = 0, at = 0, pt; je < De.length; je += 128) {
      var ct = (
        /*::(*/
        De.slice(je, je + 128)
      );
      Fs(ct, 64), at = ct.read_shift(2), pt = V2(ct, 0, at - xe), H.push(pt);
      var gt = {
        name: pt,
        type: ct.read_shift(1),
        color: ct.read_shift(1),
        L: ct.read_shift(4, "i"),
        R: ct.read_shift(4, "i"),
        C: ct.read_shift(4, "i"),
        clsid: ct.read_shift(16),
        state: ct.read_shift(4, "i"),
        start: 0,
        size: 0
      }, Pt = ct.read_shift(2) + ct.read_shift(2) + ct.read_shift(2) + ct.read_shift(2);
      Pt !== 0 && (gt.ct = _(ct, ct.l - 8));
      var Ir = ct.read_shift(2) + ct.read_shift(2) + ct.read_shift(2) + ct.read_shift(2);
      Ir !== 0 && (gt.mt = _(ct, ct.l - 8)), gt.start = ct.read_shift(4, "i"), gt.size = ct.read_shift(4, "i"), gt.size < 0 && gt.start < 0 && (gt.size = gt.type = 0, gt.start = N, gt.name = ""), gt.type === 5 ? (ge = gt.start, X > 0 && ge !== N && (ie[ge].name = "!StreamData")) : gt.size >= 4096 ? (gt.storage = "fat", ie[gt.start] === void 0 && (ie[gt.start] = y(I, gt.start, ie.fat_addrs, ie.ssz)), ie[gt.start].name = gt.name, gt.content = ie[gt.start].data.slice(0, gt.size)) : (gt.storage = "minifat", gt.size < 0 ? gt.size = 0 : ge !== N && gt.start !== N && ie[ge] && (gt.content = m(gt, ie[ge].data, (ie[Ie] || {}).data))), gt.content && Fs(gt.content, 0), Z[pt] = gt, Se.push(gt);
    }
  }
  function _(W, ie) {
    return new Date((Vs(W, ie + 4) / 1e7 * Math.pow(2, 32) + Vs(W, ie) / 1e7 - 11644473600) * 1e3);
  }
  function S(W, ie) {
    return c(), u(l.readFileSync(W), ie);
  }
  function C(W, ie) {
    var I = ie && ie.type;
    switch (I || Mr && Buffer.isBuffer(W) && (I = "buffer"), I || "base64") {
      case "file":
        return S(W, ie);
      case "base64":
        return u(Ri(Bl(W)), ie);
      case "binary":
        return u(Ri(W), ie);
    }
    return u(
      /*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */
      W,
      ie
    );
  }
  function E(W, ie) {
    var I = ie || {}, H = I.root || "Root Entry";
    if (W.FullPaths || (W.FullPaths = []), W.FileIndex || (W.FileIndex = []), W.FullPaths.length !== W.FileIndex.length) throw new Error("inconsistent CFB structure");
    W.FullPaths.length === 0 && (W.FullPaths[0] = H + "/", W.FileIndex[0] = { name: H, type: 5 }), I.CLSID && (W.FileIndex[0].clsid = I.CLSID), O(W);
  }
  function O(W) {
    var ie = "Sh33tJ5";
    if (!rn.find(W, "/" + ie)) {
      var I = Ke(4);
      I[0] = 55, I[1] = I[3] = 50, I[2] = 54, W.FileIndex.push({ name: ie, type: 2, content: I, size: 4, L: 69, R: 69, C: 69 }), W.FullPaths.push(W.FullPaths[0] + ie), k(W);
    }
  }
  function k(W, ie) {
    E(W);
    for (var I = !1, H = !1, X = W.FullPaths.length - 1; X >= 0; --X) {
      var Z = W.FileIndex[X];
      switch (Z.type) {
        case 0:
          H ? I = !0 : (W.FileIndex.pop(), W.FullPaths.pop());
          break;
        case 1:
        case 2:
        case 5:
          H = !0, isNaN(Z.R * Z.L * Z.C) && (I = !0), Z.R > -1 && Z.L > -1 && Z.R == Z.L && (I = !0);
          break;
        default:
          I = !0;
          break;
      }
    }
    if (!(!I && !ie)) {
      var Se = new Date(1987, 1, 19), Ie = 0, ge = Object.create ? /* @__PURE__ */ Object.create(null) : {}, xe = [];
      for (X = 0; X < W.FullPaths.length; ++X)
        ge[W.FullPaths[X]] = !0, W.FileIndex[X].type !== 0 && xe.push([W.FullPaths[X], W.FileIndex[X]]);
      for (X = 0; X < xe.length; ++X) {
        var De = n(xe[X][0]);
        H = ge[De], H || (xe.push([De, {
          name: a(De).replace("/", ""),
          type: 1,
          clsid: Y,
          ct: Se,
          mt: Se,
          content: null
        }]), ge[De] = !0);
      }
      for (xe.sort(function(pt, ct) {
        return r(pt[0], ct[0]);
      }), W.FullPaths = [], W.FileIndex = [], X = 0; X < xe.length; ++X)
        W.FullPaths[X] = xe[X][0], W.FileIndex[X] = xe[X][1];
      for (X = 0; X < xe.length; ++X) {
        var je = W.FileIndex[X], at = W.FullPaths[X];
        if (je.name = a(at).replace("/", ""), je.L = je.R = je.C = -(je.color = 1), je.size = je.content ? je.content.length : 0, je.start = 0, je.clsid = je.clsid || Y, X === 0)
          je.C = xe.length > 1 ? 1 : -1, je.size = 0, je.type = 5;
        else if (at.slice(-1) == "/") {
          for (Ie = X + 1; Ie < xe.length && n(W.FullPaths[Ie]) != at; ++Ie) ;
          for (je.C = Ie >= xe.length ? -1 : Ie, Ie = X + 1; Ie < xe.length && n(W.FullPaths[Ie]) != n(at); ++Ie) ;
          je.R = Ie >= xe.length ? -1 : Ie, je.type = 1;
        } else
          n(W.FullPaths[X + 1] || "") == n(at) && (je.R = X + 1), je.type = 2;
      }
    }
  }
  function A(W, ie) {
    var I = ie || {};
    if (I.fileType == "mad") return Ht(W, I);
    switch (k(W), I.fileType) {
      case "zip":
        return na(W, I);
    }
    var H = function(pt) {
      for (var ct = 0, gt = 0, Pt = 0; Pt < pt.FileIndex.length; ++Pt) {
        var Ir = pt.FileIndex[Pt];
        if (Ir.content) {
          var Wr = Ir.content.length;
          Wr > 0 && (Wr < 4096 ? ct += Wr + 63 >> 6 : gt += Wr + 511 >> 9);
        }
      }
      for (var Nn = pt.FullPaths.length + 3 >> 2, Qo = ct + 7 >> 3, Yl = ct + 127 >> 7, La = Qo + gt + Nn + Yl, Gi = La + 127 >> 7, eu = Gi <= 109 ? 0 : Math.ceil((Gi - 109) / 127); La + Gi + eu + 127 >> 7 > Gi; ) eu = ++Gi <= 109 ? 0 : Math.ceil((Gi - 109) / 127);
      var Gs = [1, eu, Gi, Yl, Nn, gt, ct, 0];
      return pt.FileIndex[0].size = ct << 6, Gs[7] = (pt.FileIndex[0].start = Gs[0] + Gs[1] + Gs[2] + Gs[3] + Gs[4] + Gs[5]) + (Gs[6] + 7 >> 3), Gs;
    }(W), X = Ke(H[7] << 9), Z = 0, Se = 0;
    {
      for (Z = 0; Z < 8; ++Z) X.write_shift(1, G[Z]);
      for (Z = 0; Z < 8; ++Z) X.write_shift(2, 0);
      for (X.write_shift(2, 62), X.write_shift(2, 3), X.write_shift(2, 65534), X.write_shift(2, 9), X.write_shift(2, 6), Z = 0; Z < 3; ++Z) X.write_shift(2, 0);
      for (X.write_shift(4, 0), X.write_shift(4, H[2]), X.write_shift(4, H[0] + H[1] + H[2] + H[3] - 1), X.write_shift(4, 0), X.write_shift(4, 4096), X.write_shift(4, H[3] ? H[0] + H[1] + H[2] - 1 : N), X.write_shift(4, H[3]), X.write_shift(-4, H[1] ? H[0] - 1 : N), X.write_shift(4, H[1]), Z = 0; Z < 109; ++Z) X.write_shift(-4, Z < H[2] ? H[1] + Z : -1);
    }
    if (H[1])
      for (Se = 0; Se < H[1]; ++Se) {
        for (; Z < 236 + Se * 127; ++Z) X.write_shift(-4, Z < H[2] ? H[1] + Z : -1);
        X.write_shift(-4, Se === H[1] - 1 ? N : Se + 1);
      }
    var Ie = function(pt) {
      for (Se += pt; Z < Se - 1; ++Z) X.write_shift(-4, Z + 1);
      pt && (++Z, X.write_shift(-4, N));
    };
    for (Se = Z = 0, Se += H[1]; Z < Se; ++Z) X.write_shift(-4, te.DIFSECT);
    for (Se += H[2]; Z < Se; ++Z) X.write_shift(-4, te.FATSECT);
    Ie(H[3]), Ie(H[4]);
    for (var ge = 0, xe = 0, De = W.FileIndex[0]; ge < W.FileIndex.length; ++ge)
      De = W.FileIndex[ge], De.content && (xe = De.content.length, !(xe < 4096) && (De.start = Se, Ie(xe + 511 >> 9)));
    for (Ie(H[6] + 7 >> 3); X.l & 511; ) X.write_shift(-4, te.ENDOFCHAIN);
    for (Se = Z = 0, ge = 0; ge < W.FileIndex.length; ++ge)
      De = W.FileIndex[ge], De.content && (xe = De.content.length, !(!xe || xe >= 4096) && (De.start = Se, Ie(xe + 63 >> 6)));
    for (; X.l & 511; ) X.write_shift(-4, te.ENDOFCHAIN);
    for (Z = 0; Z < H[4] << 2; ++Z) {
      var je = W.FullPaths[Z];
      if (!je || je.length === 0) {
        for (ge = 0; ge < 17; ++ge) X.write_shift(4, 0);
        for (ge = 0; ge < 3; ++ge) X.write_shift(4, -1);
        for (ge = 0; ge < 12; ++ge) X.write_shift(4, 0);
        continue;
      }
      De = W.FileIndex[Z], Z === 0 && (De.start = De.size ? De.start - 1 : N);
      var at = Z === 0 && I.root || De.name;
      if (xe = 2 * (at.length + 1), X.write_shift(64, at, "utf16le"), X.write_shift(2, xe), X.write_shift(1, De.type), X.write_shift(1, De.color), X.write_shift(-4, De.L), X.write_shift(-4, De.R), X.write_shift(-4, De.C), De.clsid) X.write_shift(16, De.clsid, "hex");
      else for (ge = 0; ge < 4; ++ge) X.write_shift(4, 0);
      X.write_shift(4, De.state || 0), X.write_shift(4, 0), X.write_shift(4, 0), X.write_shift(4, 0), X.write_shift(4, 0), X.write_shift(4, De.start), X.write_shift(4, De.size), X.write_shift(4, 0);
    }
    for (Z = 1; Z < W.FileIndex.length; ++Z)
      if (De = W.FileIndex[Z], De.size >= 4096)
        if (X.l = De.start + 1 << 9, Mr && Buffer.isBuffer(De.content))
          De.content.copy(X, X.l, 0, De.size), X.l += De.size + 511 & -512;
        else {
          for (ge = 0; ge < De.size; ++ge) X.write_shift(1, De.content[ge]);
          for (; ge & 511; ++ge) X.write_shift(1, 0);
        }
    for (Z = 1; Z < W.FileIndex.length; ++Z)
      if (De = W.FileIndex[Z], De.size > 0 && De.size < 4096)
        if (Mr && Buffer.isBuffer(De.content))
          De.content.copy(X, X.l, 0, De.size), X.l += De.size + 63 & -64;
        else {
          for (ge = 0; ge < De.size; ++ge) X.write_shift(1, De.content[ge]);
          for (; ge & 63; ++ge) X.write_shift(1, 0);
        }
    if (Mr)
      X.l = X.length;
    else
      for (; X.l < X.length; ) X.write_shift(1, 0);
    return X;
  }
  function P(W, ie) {
    var I = W.FullPaths.map(function(ge) {
      return ge.toUpperCase();
    }), H = I.map(function(ge) {
      var xe = ge.split("/");
      return xe[xe.length - (ge.slice(-1) == "/" ? 2 : 1)];
    }), X = !1;
    ie.charCodeAt(0) === 47 ? (X = !0, ie = I[0].slice(0, -1) + ie) : X = ie.indexOf("/") !== -1;
    var Z = ie.toUpperCase(), Se = X === !0 ? I.indexOf(Z) : H.indexOf(Z);
    if (Se !== -1) return W.FileIndex[Se];
    var Ie = !Z.match(ay);
    for (Z = Z.replace(Cm, ""), Ie && (Z = Z.replace(ay, "!")), Se = 0; Se < I.length; ++Se)
      if ((Ie ? I[Se].replace(ay, "!") : I[Se]).replace(Cm, "") == Z || (Ie ? H[Se].replace(ay, "!") : H[Se]).replace(Cm, "") == Z) return W.FileIndex[Se];
    return null;
  }
  var D = 64, N = -2, z = "d0cf11e0a1b11ae1", G = [208, 207, 17, 224, 161, 177, 26, 225], Y = "00000000000000000000000000000000", te = {
    /* 2.1 Compund File Sector Numbers and Types */
    MAXREGSECT: -6,
    DIFSECT: -4,
    FATSECT: -3,
    ENDOFCHAIN: N,
    FREESECT: -1,
    /* 2.2 Compound File Header */
    HEADER_SIGNATURE: z,
    HEADER_MINOR_VERSION: "3e00",
    MAXREGSID: -6,
    NOSTREAM: -1,
    HEADER_CLSID: Y,
    /* 2.6.1 Compound File Directory Entry */
    EntryTypes: ["unknown", "storage", "stream", "lockbytes", "property", "root"]
  };
  function ae(W, ie, I) {
    c();
    var H = A(W, I);
    l.writeFileSync(ie, H);
  }
  function ne(W) {
    for (var ie = new Array(W.length), I = 0; I < W.length; ++I) ie[I] = String.fromCharCode(W[I]);
    return ie.join("");
  }
  function ue(W, ie) {
    var I = A(W, ie);
    switch (ie && ie.type || "buffer") {
      case "file":
        return c(), l.writeFileSync(ie.filename, I), I;
      case "binary":
        return typeof I == "string" ? I : ne(I);
      case "base64":
        return pg(typeof I == "string" ? I : ne(I));
      case "buffer":
        if (Mr) return Buffer.isBuffer(I) ? I : Gl(I);
      case "array":
        return typeof I == "string" ? Ri(I) : I;
    }
    return I;
  }
  var q;
  function U(W) {
    try {
      var ie = W.InflateRaw, I = new ie();
      if (I._processChunk(new Uint8Array([3, 0]), I._finishFlushFlag), I.bytesRead) q = W;
      else throw new Error("zlib does not expose bytesRead");
    } catch (H) {
      console.error("cannot use native zlib: " + (H.message || H));
    }
  }
  function Q(W, ie) {
    if (!q) return Na(W, ie);
    var I = q.InflateRaw, H = new I(), X = H._processChunk(W.slice(W.l), H._finishFlushFlag);
    return W.l += H.bytesRead, X;
  }
  function L(W) {
    return q ? q.deflateRawSync(W) : Dt(W);
  }
  var j = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], K = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258], J = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577];
  function re(W) {
    var ie = (W << 1 | W << 11) & 139536 | (W << 5 | W << 15) & 558144;
    return (ie >> 16 | ie >> 8 | ie) & 255;
  }
  for (var le = typeof Uint8Array < "u", pe = le ? new Uint8Array(256) : [], me = 0; me < 256; ++me) pe[me] = re(me);
  function Oe(W, ie) {
    var I = pe[W & 255];
    return ie <= 8 ? I >>> 8 - ie : (I = I << 8 | pe[W >> 8 & 255], ie <= 16 ? I >>> 16 - ie : (I = I << 8 | pe[W >> 16 & 255], I >>> 24 - ie));
  }
  function ee(W, ie) {
    var I = ie & 7, H = ie >>> 3;
    return (W[H] | (I <= 6 ? 0 : W[H + 1] << 8)) >>> I & 3;
  }
  function he(W, ie) {
    var I = ie & 7, H = ie >>> 3;
    return (W[H] | (I <= 5 ? 0 : W[H + 1] << 8)) >>> I & 7;
  }
  function Ee(W, ie) {
    var I = ie & 7, H = ie >>> 3;
    return (W[H] | (I <= 4 ? 0 : W[H + 1] << 8)) >>> I & 15;
  }
  function we(W, ie) {
    var I = ie & 7, H = ie >>> 3;
    return (W[H] | (I <= 3 ? 0 : W[H + 1] << 8)) >>> I & 31;
  }
  function Pe(W, ie) {
    var I = ie & 7, H = ie >>> 3;
    return (W[H] | (I <= 1 ? 0 : W[H + 1] << 8)) >>> I & 127;
  }
  function rt(W, ie, I) {
    var H = ie & 7, X = ie >>> 3, Z = (1 << I) - 1, Se = W[X] >>> H;
    return I < 8 - H || (Se |= W[X + 1] << 8 - H, I < 16 - H) || (Se |= W[X + 2] << 16 - H, I < 24 - H) || (Se |= W[X + 3] << 24 - H), Se & Z;
  }
  function ht(W, ie, I) {
    var H = ie & 7, X = ie >>> 3;
    return H <= 5 ? W[X] |= (I & 7) << H : (W[X] |= I << H & 255, W[X + 1] = (I & 7) >> 8 - H), ie + 3;
  }
  function bt(W, ie, I) {
    var H = ie & 7, X = ie >>> 3;
    return I = (I & 1) << H, W[X] |= I, ie + 1;
  }
  function Ge(W, ie, I) {
    var H = ie & 7, X = ie >>> 3;
    return I <<= H, W[X] |= I & 255, I >>>= 8, W[X + 1] = I, ie + 8;
  }
  function oe(W, ie, I) {
    var H = ie & 7, X = ie >>> 3;
    return I <<= H, W[X] |= I & 255, I >>>= 8, W[X + 1] = I & 255, W[X + 2] = I >>> 8, ie + 16;
  }
  function ve(W, ie) {
    var I = W.length, H = 2 * I > ie ? 2 * I : ie + 5, X = 0;
    if (I >= ie) return W;
    if (Mr) {
      var Z = Rj(H);
      if (W.copy) W.copy(Z);
      else for (; X < W.length; ++X) Z[X] = W[X];
      return Z;
    } else if (le) {
      var Se = new Uint8Array(H);
      if (Se.set) Se.set(W);
      else for (; X < I; ++X) Se[X] = W[X];
      return Se;
    }
    return W.length = H, W;
  }
  function ye(W) {
    for (var ie = new Array(W), I = 0; I < W; ++I) ie[I] = 0;
    return ie;
  }
  function Te(W, ie, I) {
    var H = 1, X = 0, Z = 0, Se = 0, Ie = 0, ge = W.length, xe = le ? new Uint16Array(32) : ye(32);
    for (Z = 0; Z < 32; ++Z) xe[Z] = 0;
    for (Z = ge; Z < I; ++Z) W[Z] = 0;
    ge = W.length;
    var De = le ? new Uint16Array(ge) : ye(ge);
    for (Z = 0; Z < ge; ++Z)
      xe[X = W[Z]]++, H < X && (H = X), De[Z] = 0;
    for (xe[0] = 0, Z = 1; Z <= H; ++Z) xe[Z + 16] = Ie = Ie + xe[Z - 1] << 1;
    for (Z = 0; Z < ge; ++Z)
      Ie = W[Z], Ie != 0 && (De[Z] = xe[Ie + 16]++);
    var je = 0;
    for (Z = 0; Z < ge; ++Z)
      if (je = W[Z], je != 0)
        for (Ie = Oe(De[Z], H) >> H - je, Se = (1 << H + 4 - je) - 1; Se >= 0; --Se)
          ie[Ie | Se << je] = je & 15 | Z << 4;
    return H;
  }
  var _e = le ? new Uint16Array(512) : ye(512), Ae = le ? new Uint16Array(32) : ye(32);
  if (!le) {
    for (var Ve = 0; Ve < 512; ++Ve) _e[Ve] = 0;
    for (Ve = 0; Ve < 32; ++Ve) Ae[Ve] = 0;
  }
  (function() {
    for (var W = [], ie = 0; ie < 32; ie++) W.push(5);
    Te(W, Ae, 32);
    var I = [];
    for (ie = 0; ie <= 143; ie++) I.push(8);
    for (; ie <= 255; ie++) I.push(9);
    for (; ie <= 279; ie++) I.push(7);
    for (; ie <= 287; ie++) I.push(8);
    Te(I, _e, 288);
  })();
  var mt = /* @__PURE__ */ function() {
    for (var ie = le ? new Uint8Array(32768) : [], I = 0, H = 0; I < J.length - 1; ++I)
      for (; H < J[I + 1]; ++H) ie[H] = I;
    for (; H < 32768; ++H) ie[H] = 29;
    var X = le ? new Uint8Array(259) : [];
    for (I = 0, H = 0; I < K.length - 1; ++I)
      for (; H < K[I + 1]; ++H) X[H] = I;
    function Z(Ie, ge) {
      for (var xe = 0; xe < Ie.length; ) {
        var De = Math.min(65535, Ie.length - xe), je = xe + De == Ie.length;
        for (ge.write_shift(1, +je), ge.write_shift(2, De), ge.write_shift(2, ~De & 65535); De-- > 0; ) ge[ge.l++] = Ie[xe++];
      }
      return ge.l;
    }
    function Se(Ie, ge) {
      for (var xe = 0, De = 0, je = le ? new Uint16Array(32768) : []; De < Ie.length; ) {
        var at = (
          /* data.length - boff; */
          Math.min(65535, Ie.length - De)
        );
        if (at < 10) {
          for (xe = ht(ge, xe, +(De + at == Ie.length)), xe & 7 && (xe += 8 - (xe & 7)), ge.l = xe / 8 | 0, ge.write_shift(2, at), ge.write_shift(2, ~at & 65535); at-- > 0; ) ge[ge.l++] = Ie[De++];
          xe = ge.l * 8;
          continue;
        }
        xe = ht(ge, xe, +(De + at == Ie.length) + 2);
        for (var pt = 0; at-- > 0; ) {
          var ct = Ie[De];
          pt = (pt << 5 ^ ct) & 32767;
          var gt = -1, Pt = 0;
          if ((gt = je[pt]) && (gt |= De & -32768, gt > De && (gt -= 32768), gt < De))
            for (; Ie[gt + Pt] == Ie[De + Pt] && Pt < 250; ) ++Pt;
          if (Pt > 2) {
            ct = X[Pt], ct <= 22 ? xe = Ge(ge, xe, pe[ct + 1] >> 1) - 1 : (Ge(ge, xe, 3), xe += 5, Ge(ge, xe, pe[ct - 23] >> 5), xe += 3);
            var Ir = ct < 8 ? 0 : ct - 4 >> 2;
            Ir > 0 && (oe(ge, xe, Pt - K[ct]), xe += Ir), ct = ie[De - gt], xe = Ge(ge, xe, pe[ct] >> 3), xe -= 3;
            var Wr = ct < 4 ? 0 : ct - 2 >> 1;
            Wr > 0 && (oe(ge, xe, De - gt - J[ct]), xe += Wr);
            for (var Nn = 0; Nn < Pt; ++Nn)
              je[pt] = De & 32767, pt = (pt << 5 ^ Ie[De]) & 32767, ++De;
            at -= Pt - 1;
          } else
            ct <= 143 ? ct = ct + 48 : xe = bt(ge, xe, 1), xe = Ge(ge, xe, pe[ct]), je[pt] = De & 32767, ++De;
        }
        xe = Ge(ge, xe, 0) - 1;
      }
      return ge.l = (xe + 7) / 8 | 0, ge.l;
    }
    return function(ge, xe) {
      return ge.length < 8 ? Z(ge, xe) : Se(ge, xe);
    };
  }();
  function Dt(W) {
    var ie = Ke(50 + Math.floor(W.length * 1.1)), I = mt(W, ie);
    return ie.slice(0, I);
  }
  var Gt = le ? new Uint16Array(32768) : ye(32768), $t = le ? new Uint16Array(32768) : ye(32768), Rt = le ? new Uint16Array(128) : ye(128), Pr = 1, fr = 1;
  function ca(W, ie) {
    var I = we(W, ie) + 257;
    ie += 5;
    var H = we(W, ie) + 1;
    ie += 5;
    var X = Ee(W, ie) + 4;
    ie += 4;
    for (var Z = 0, Se = le ? new Uint8Array(19) : ye(19), Ie = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ge = 1, xe = le ? new Uint8Array(8) : ye(8), De = le ? new Uint8Array(8) : ye(8), je = Se.length, at = 0; at < X; ++at)
      Se[j[at]] = Z = he(W, ie), ge < Z && (ge = Z), xe[Z]++, ie += 3;
    var pt = 0;
    for (xe[0] = 0, at = 1; at <= ge; ++at) De[at] = pt = pt + xe[at - 1] << 1;
    for (at = 0; at < je; ++at) (pt = Se[at]) != 0 && (Ie[at] = De[pt]++);
    var ct = 0;
    for (at = 0; at < je; ++at)
      if (ct = Se[at], ct != 0) {
        pt = pe[Ie[at]] >> 8 - ct;
        for (var gt = (1 << 7 - ct) - 1; gt >= 0; --gt) Rt[pt | gt << ct] = ct & 7 | at << 3;
      }
    var Pt = [];
    for (ge = 1; Pt.length < I + H; )
      switch (pt = Rt[Pe(W, ie)], ie += pt & 7, pt >>>= 3) {
        case 16:
          for (Z = 3 + ee(W, ie), ie += 2, pt = Pt[Pt.length - 1]; Z-- > 0; ) Pt.push(pt);
          break;
        case 17:
          for (Z = 3 + he(W, ie), ie += 3; Z-- > 0; ) Pt.push(0);
          break;
        case 18:
          for (Z = 11 + Pe(W, ie), ie += 7; Z-- > 0; ) Pt.push(0);
          break;
        default:
          Pt.push(pt), ge < pt && (ge = pt);
          break;
      }
    var Ir = Pt.slice(0, I), Wr = Pt.slice(I);
    for (at = I; at < 286; ++at) Ir[at] = 0;
    for (at = H; at < 30; ++at) Wr[at] = 0;
    return Pr = Te(Ir, Gt, 286), fr = Te(Wr, $t, 30), ie;
  }
  function en(W, ie) {
    if (W[0] == 3 && !(W[1] & 3))
      return [Xu(ie), 2];
    for (var I = 0, H = 0, X = Rj(ie || 1 << 18), Z = 0, Se = X.length >>> 0, Ie = 0, ge = 0; !(H & 1); ) {
      if (H = he(W, I), I += 3, H >>> 1)
        H >> 1 == 1 ? (Ie = 9, ge = 5) : (I = ca(W, I), Ie = Pr, ge = fr);
      else {
        I & 7 && (I += 8 - (I & 7));
        var xe = W[I >>> 3] | W[(I >>> 3) + 1] << 8;
        if (I += 32, xe > 0)
          for (!ie && Se < Z + xe && (X = ve(X, Z + xe), Se = X.length); xe-- > 0; )
            X[Z++] = W[I >>> 3], I += 8;
        continue;
      }
      for (; ; ) {
        !ie && Se < Z + 32767 && (X = ve(X, Z + 32767), Se = X.length);
        var De = rt(W, I, Ie), je = H >>> 1 == 1 ? _e[De] : Gt[De];
        if (I += je & 15, je >>>= 4, !(je >>> 8 & 255)) X[Z++] = je;
        else {
          if (je == 256) break;
          je -= 257;
          var at = je < 8 ? 0 : je - 4 >> 2;
          at > 5 && (at = 0);
          var pt = Z + K[je];
          at > 0 && (pt += rt(W, I, at), I += at), De = rt(W, I, ge), je = H >>> 1 == 1 ? Ae[De] : $t[De], I += je & 15, je >>>= 4;
          var ct = je < 4 ? 0 : je - 2 >> 1, gt = J[je];
          for (ct > 0 && (gt += rt(W, I, ct), I += ct), !ie && Se < pt && (X = ve(X, pt + 100), Se = X.length); Z < pt; )
            X[Z] = X[Z - gt], ++Z;
        }
      }
    }
    return ie ? [X, I + 7 >>> 3] : [X.slice(0, Z), I + 7 >>> 3];
  }
  function Na(W, ie) {
    var I = W.slice(W.l || 0), H = en(I, ie);
    return W.l += H[1], H[0];
  }
  function Ma(W, ie) {
    if (W)
      typeof console < "u" && console.error(ie);
    else throw new Error(ie);
  }
  function Hr(W, ie) {
    var I = (
      /*::(*/
      W
    );
    Fs(I, 0);
    var H = [], X = [], Z = {
      FileIndex: H,
      FullPaths: X
    };
    E(Z, { root: ie.root });
    for (var Se = I.length - 4; (I[Se] != 80 || I[Se + 1] != 75 || I[Se + 2] != 5 || I[Se + 3] != 6) && Se >= 0; ) --Se;
    I.l = Se + 4, I.l += 4;
    var Ie = I.read_shift(2);
    I.l += 6;
    var ge = I.read_shift(4);
    for (I.l = ge, Se = 0; Se < Ie; ++Se) {
      I.l += 20;
      var xe = I.read_shift(4), De = I.read_shift(4), je = I.read_shift(2), at = I.read_shift(2), pt = I.read_shift(2);
      I.l += 8;
      var ct = I.read_shift(4), gt = o(
        /*::(*/
        I.slice(I.l + je, I.l + je + at)
        /*:: :any)*/
      );
      I.l += je + at + pt;
      var Pt = I.l;
      I.l = ct + 4, wa(I, xe, De, Z, gt), I.l = Pt;
    }
    return Z;
  }
  function wa(W, ie, I, H, X) {
    W.l += 2;
    var Z = W.read_shift(2), Se = W.read_shift(2), Ie = i(W);
    if (Z & 8257) throw new Error("Unsupported ZIP encryption");
    for (var ge = W.read_shift(4), xe = W.read_shift(4), De = W.read_shift(4), je = W.read_shift(2), at = W.read_shift(2), pt = "", ct = 0; ct < je; ++ct) pt += String.fromCharCode(W[W.l++]);
    if (at) {
      var gt = o(
        /*::(*/
        W.slice(W.l, W.l + at)
        /*:: :any)*/
      );
      (gt[21589] || {}).mt && (Ie = gt[21589].mt), ((X || {})[21589] || {}).mt && (Ie = X[21589].mt);
    }
    W.l += at;
    var Pt = W.slice(W.l, W.l + xe);
    switch (Se) {
      case 8:
        Pt = Q(W, De);
        break;
      case 0:
        break;
      default:
        throw new Error("Unsupported ZIP Compression method " + Se);
    }
    var Ir = !1;
    Z & 8 && (ge = W.read_shift(4), ge == 134695760 && (ge = W.read_shift(4), Ir = !0), xe = W.read_shift(4), De = W.read_shift(4)), xe != ie && Ma(Ir, "Bad compressed size: " + ie + " != " + xe), De != I && Ma(Ir, "Bad uncompressed size: " + I + " != " + De), kt(H, pt, Pt, { unsafe: !0, mt: Ie });
  }
  function na(W, ie) {
    var I = ie || {}, H = [], X = [], Z = Ke(1), Se = I.compression ? 8 : 0, Ie = 0, ge = 0, xe = 0, De = 0, je = 0, at = W.FullPaths[0], pt = at, ct = W.FileIndex[0], gt = [], Pt = 0;
    for (ge = 1; ge < W.FullPaths.length; ++ge)
      if (pt = W.FullPaths[ge].slice(at.length), ct = W.FileIndex[ge], !(!ct.size || !ct.content || pt == "Sh33tJ5")) {
        var Ir = De, Wr = Ke(pt.length);
        for (xe = 0; xe < pt.length; ++xe) Wr.write_shift(1, pt.charCodeAt(xe) & 127);
        Wr = Wr.slice(0, Wr.l), gt[je] = mHe.buf(
          /*::((*/
          ct.content,
          0
        );
        var Nn = ct.content;
        Se == 8 && (Nn = L(Nn)), Z = Ke(30), Z.write_shift(4, 67324752), Z.write_shift(2, 20), Z.write_shift(2, Ie), Z.write_shift(2, Se), ct.mt ? s(Z, ct.mt) : Z.write_shift(4, 0), Z.write_shift(-4, gt[je]), Z.write_shift(4, Nn.length), Z.write_shift(
          4,
          /*::(*/
          ct.content.length
        ), Z.write_shift(2, Wr.length), Z.write_shift(2, 0), De += Z.length, H.push(Z), De += Wr.length, H.push(Wr), De += Nn.length, H.push(Nn), Z = Ke(46), Z.write_shift(4, 33639248), Z.write_shift(2, 0), Z.write_shift(2, 20), Z.write_shift(2, Ie), Z.write_shift(2, Se), Z.write_shift(4, 0), Z.write_shift(-4, gt[je]), Z.write_shift(4, Nn.length), Z.write_shift(
          4,
          /*::(*/
          ct.content.length
        ), Z.write_shift(2, Wr.length), Z.write_shift(2, 0), Z.write_shift(2, 0), Z.write_shift(2, 0), Z.write_shift(2, 0), Z.write_shift(4, 0), Z.write_shift(4, Ir), Pt += Z.l, X.push(Z), Pt += Wr.length, X.push(Wr), ++je;
      }
    return Z = Ke(22), Z.write_shift(4, 101010256), Z.write_shift(2, 0), Z.write_shift(2, 0), Z.write_shift(2, je), Z.write_shift(2, je), Z.write_shift(4, Pt), Z.write_shift(4, De), Z.write_shift(2, 0), Oa([Oa(H), Oa(X), Z]);
  }
  var ce = {
    htm: "text/html",
    xml: "text/xml",
    gif: "image/gif",
    jpg: "image/jpeg",
    png: "image/png",
    mso: "application/x-mso",
    thmx: "application/vnd.ms-officetheme",
    sh33tj5: "application/octet-stream"
  };
  function de(W, ie) {
    if (W.ctype) return W.ctype;
    var I = W.name || "", H = I.match(/\.([^\.]+)$/);
    return H && ce[H[1]] || ie && (H = (I = ie).match(/[\.\\]([^\.\\])+$/), H && ce[H[1]]) ? ce[H[1]] : "application/octet-stream";
  }
  function Ne(W) {
    for (var ie = pg(W), I = [], H = 0; H < ie.length; H += 76) I.push(ie.slice(H, H + 76));
    return I.join(`\r
`) + `\r
`;
  }
  function Le(W) {
    var ie = W.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(xe) {
      var De = xe.charCodeAt(0).toString(16).toUpperCase();
      return "=" + (De.length == 1 ? "0" + De : De);
    });
    ie = ie.replace(/ $/mg, "=20").replace(/\t$/mg, "=09"), ie.charAt(0) == `
` && (ie = "=0D" + ie.slice(1)), ie = ie.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, `
=0A`).replace(/([^\r\n])\n/mg, "$1=0A");
    for (var I = [], H = ie.split(`\r
`), X = 0; X < H.length; ++X) {
      var Z = H[X];
      if (Z.length == 0) {
        I.push("");
        continue;
      }
      for (var Se = 0; Se < Z.length; ) {
        var Ie = 76, ge = Z.slice(Se, Se + Ie);
        ge.charAt(Ie - 1) == "=" ? Ie-- : ge.charAt(Ie - 2) == "=" ? Ie -= 2 : ge.charAt(Ie - 3) == "=" && (Ie -= 3), ge = Z.slice(Se, Se + Ie), Se += Ie, Se < Z.length && (ge += "="), I.push(ge);
      }
    }
    return I.join(`\r
`);
  }
  function $e(W) {
    for (var ie = [], I = 0; I < W.length; ++I) {
      for (var H = W[I]; I <= W.length && H.charAt(H.length - 1) == "="; ) H = H.slice(0, H.length - 1) + W[++I];
      ie.push(H);
    }
    for (var X = 0; X < ie.length; ++X) ie[X] = ie[X].replace(/[=][0-9A-Fa-f]{2}/g, function(Z) {
      return String.fromCharCode(parseInt(Z.slice(1), 16));
    });
    return Ri(ie.join(`\r
`));
  }
  function ze(W, ie, I) {
    for (var H = "", X = "", Z = "", Se, Ie = 0; Ie < 10; ++Ie) {
      var ge = ie[Ie];
      if (!ge || ge.match(/^\s*$/)) break;
      var xe = ge.match(/^(.*?):\s*([^\s].*)$/);
      if (xe) switch (xe[1].toLowerCase()) {
        case "content-location":
          H = xe[2].trim();
          break;
        case "content-type":
          Z = xe[2].trim();
          break;
        case "content-transfer-encoding":
          X = xe[2].trim();
          break;
      }
    }
    switch (++Ie, X.toLowerCase()) {
      case "base64":
        Se = Ri(Bl(ie.slice(Ie).join("")));
        break;
      case "quoted-printable":
        Se = $e(ie.slice(Ie));
        break;
      default:
        throw new Error("Unsupported Content-Transfer-Encoding " + X);
    }
    var De = kt(W, H.slice(I.length), Se, { unsafe: !0 });
    Z && (De.ctype = Z);
  }
  function Lt(W, ie) {
    if (ne(W.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
    var I = ie && ie.root || "", H = (Mr && Buffer.isBuffer(W) ? W.toString("binary") : ne(W)).split(`\r
`), X = 0, Z = "";
    for (X = 0; X < H.length; ++X)
      if (Z = H[X], !!/^Content-Location:/i.test(Z) && (Z = Z.slice(Z.indexOf("file")), I || (I = Z.slice(0, Z.lastIndexOf("/") + 1)), Z.slice(0, I.length) != I))
        for (; I.length > 0 && (I = I.slice(0, I.length - 1), I = I.slice(0, I.lastIndexOf("/") + 1), Z.slice(0, I.length) != I); )
          ;
    var Se = (H[1] || "").match(/boundary="(.*?)"/);
    if (!Se) throw new Error("MAD cannot find boundary");
    var Ie = "--" + (Se[1] || ""), ge = [], xe = [], De = {
      FileIndex: ge,
      FullPaths: xe
    };
    E(De);
    var je, at = 0;
    for (X = 0; X < H.length; ++X) {
      var pt = H[X];
      pt !== Ie && pt !== Ie + "--" || (at++ && ze(De, H.slice(je, X), I), je = X);
    }
    return De;
  }
  function Ht(W, ie) {
    var I = ie || {}, H = I.boundary || "SheetJS";
    H = "------=" + H;
    for (var X = [
      "MIME-Version: 1.0",
      'Content-Type: multipart/related; boundary="' + H.slice(2) + '"',
      "",
      "",
      ""
    ], Z = W.FullPaths[0], Se = Z, Ie = W.FileIndex[0], ge = 1; ge < W.FullPaths.length; ++ge)
      if (Se = W.FullPaths[ge].slice(Z.length), Ie = W.FileIndex[ge], !(!Ie.size || !Ie.content || Se == "Sh33tJ5")) {
        Se = Se.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(Pt) {
          return "_x" + Pt.charCodeAt(0).toString(16) + "_";
        }).replace(/[\u0080-\uFFFF]/g, function(Pt) {
          return "_u" + Pt.charCodeAt(0).toString(16) + "_";
        });
        for (var xe = Ie.content, De = Mr && Buffer.isBuffer(xe) ? xe.toString("binary") : ne(xe), je = 0, at = Math.min(1024, De.length), pt = 0, ct = 0; ct <= at; ++ct) (pt = De.charCodeAt(ct)) >= 32 && pt < 128 && ++je;
        var gt = je >= at * 4 / 5;
        X.push(H), X.push("Content-Location: " + (I.root || "file:///C:/SheetJS/") + Se), X.push("Content-Transfer-Encoding: " + (gt ? "quoted-printable" : "base64")), X.push("Content-Type: " + de(Ie, Se)), X.push(""), X.push(gt ? Le(De) : Ne(De));
      }
    return X.push(H + `--\r
`), X.join(`\r
`);
  }
  function Rr(W) {
    var ie = {};
    return E(ie, W), ie;
  }
  function kt(W, ie, I, H) {
    var X = H && H.unsafe;
    X || E(W);
    var Z = !X && rn.find(W, ie);
    if (!Z) {
      var Se = W.FullPaths[0];
      ie.slice(0, Se.length) == Se ? Se = ie : (Se.slice(-1) != "/" && (Se += "/"), Se = (Se + ie).replace("//", "/")), Z = { name: a(ie), type: 2 }, W.FileIndex.push(Z), W.FullPaths.push(Se), X || rn.utils.cfb_gc(W);
    }
    return Z.content = I, Z.size = I ? I.length : 0, H && (H.CLSID && (Z.clsid = H.CLSID), H.mt && (Z.mt = H.mt), H.ct && (Z.ct = H.ct)), Z;
  }
  function lr(W, ie) {
    E(W);
    var I = rn.find(W, ie);
    if (I) {
      for (var H = 0; H < W.FileIndex.length; ++H) if (W.FileIndex[H] == I)
        return W.FileIndex.splice(H, 1), W.FullPaths.splice(H, 1), !0;
    }
    return !1;
  }
  function cn(W, ie, I) {
    E(W);
    var H = rn.find(W, ie);
    if (H) {
      for (var X = 0; X < W.FileIndex.length; ++X) if (W.FileIndex[X] == H)
        return W.FileIndex[X].name = a(I), W.FullPaths[X] = I, !0;
    }
    return !1;
  }
  function ua(W) {
    k(W, !0);
  }
  return t.find = P, t.read = C, t.parse = u, t.write = ue, t.writeFile = ae, t.utils = {
    cfb_new: Rr,
    cfb_add: kt,
    cfb_del: lr,
    cfb_mov: cn,
    cfb_gc: ua,
    ReadShift: Om,
    CheckField: g9,
    prep_blob: Fs,
    bconcat: Oa,
    use_zlib: U,
    _deflateRaw: Dt,
    _inflateRaw: Na,
    consts: te
  }, t;
}();
function gHe(e) {
  return typeof e == "string" ? qx(e) : Array.isArray(e) ? $8e(e) : e;
}
function wv(e, t, r) {
  if (typeof Deno < "u") {
    if (r && typeof t == "string") switch (r) {
      case "utf8":
        t = new TextEncoder(r).encode(t);
        break;
      case "binary":
        t = qx(t);
        break;
      default:
        throw new Error("Unsupported encoding " + r);
    }
    return Deno.writeFileSync(e, t);
  }
  var n = r == "utf8" ? gg(t) : t;
  if (typeof IE_SaveFile < "u") return IE_SaveFile(n, e);
  if (typeof Blob < "u") {
    var a = new Blob([gHe(n)], { type: "application/octet-stream" });
    if (typeof navigator < "u" && navigator.msSaveBlob) return navigator.msSaveBlob(a, e);
    if (typeof saveAs < "u") return saveAs(a, e);
    if (typeof URL < "u" && typeof document < "u" && document.createElement && URL.createObjectURL) {
      var s = URL.createObjectURL(a);
      if (typeof chrome == "object" && typeof (chrome.downloads || {}).download == "function")
        return URL.revokeObjectURL && typeof setTimeout < "u" && setTimeout(function() {
          URL.revokeObjectURL(s);
        }, 6e4), chrome.downloads.download({ url: s, filename: e, saveAs: !0 });
      var i = document.createElement("a");
      if (i.download != null)
        return i.download = e, i.href = s, document.body.appendChild(i), i.click(), document.body.removeChild(i), URL.revokeObjectURL && typeof setTimeout < "u" && setTimeout(function() {
          URL.revokeObjectURL(s);
        }, 6e4), s;
    }
  }
  if (typeof $ < "u" && typeof File < "u" && typeof Folder < "u") try {
    var o = File(e);
    return o.open("w"), o.encoding = "binary", Array.isArray(t) && (t = bv(t)), o.write(t), o.close(), t;
  } catch (l) {
    if (!l.message || !l.message.match(/onstruct/)) throw l;
  }
  throw new Error("cannot save file " + e);
}
function Ia(e) {
  for (var t = Object.keys(e), r = [], n = 0; n < t.length; ++n) Object.prototype.hasOwnProperty.call(e, t[n]) && r.push(t[n]);
  return r;
}
function Bj(e, t) {
  for (var r = [], n = Ia(e), a = 0; a !== n.length; ++a) r[e[n[a]][t]] == null && (r[e[n[a]][t]] = n[a]);
  return r;
}
function j2(e) {
  for (var t = [], r = Ia(e), n = 0; n !== r.length; ++n) t[e[r[n]]] = r[n];
  return t;
}
function Xx(e) {
  for (var t = [], r = Ia(e), n = 0; n !== r.length; ++n) t[e[r[n]]] = parseInt(r[n], 10);
  return t;
}
function vHe(e) {
  for (var t = [], r = Ia(e), n = 0; n !== r.length; ++n)
    t[e[r[n]]] == null && (t[e[r[n]]] = []), t[e[r[n]]].push(r[n]);
  return t;
}
var aw = /* @__PURE__ */ new Date(1899, 11, 30, 0, 0, 0);
function _s(e, t) {
  var r = /* @__PURE__ */ e.getTime(), n = /* @__PURE__ */ aw.getTime() + (/* @__PURE__ */ e.getTimezoneOffset() - /* @__PURE__ */ aw.getTimezoneOffset()) * 6e4;
  return (r - n) / (24 * 60 * 60 * 1e3);
}
var Z7 = /* @__PURE__ */ new Date(), yHe = /* @__PURE__ */ aw.getTime() + (/* @__PURE__ */ Z7.getTimezoneOffset() - /* @__PURE__ */ aw.getTimezoneOffset()) * 6e4, Uj = /* @__PURE__ */ Z7.getTimezoneOffset();
function e9(e) {
  var t = /* @__PURE__ */ new Date();
  return t.setTime(e * 24 * 60 * 60 * 1e3 + yHe), t.getTimezoneOffset() !== Uj && t.setTime(t.getTime() + (t.getTimezoneOffset() - Uj) * 6e4), t;
}
var Vj = /* @__PURE__ */ new Date("2017-02-19T19:06:09.000Z"), t9 = /* @__PURE__ */ isNaN(/* @__PURE__ */ Vj.getFullYear()) ? /* @__PURE__ */ new Date("2/19/17") : Vj, bHe = /* @__PURE__ */ t9.getFullYear() == 2017;
function ds(e, t) {
  var r = new Date(e);
  if (bHe)
    return t > 0 ? r.setTime(r.getTime() + r.getTimezoneOffset() * 60 * 1e3) : t < 0 && r.setTime(r.getTime() - r.getTimezoneOffset() * 60 * 1e3), r;
  if (e instanceof Date) return e;
  if (t9.getFullYear() == 1917 && !isNaN(r.getFullYear())) {
    var n = r.getFullYear();
    return e.indexOf("" + n) > -1 || r.setFullYear(r.getFullYear() + 100), r;
  }
  var a = e.match(/\d+/g) || ["2017", "2", "19", "0", "0", "0"], s = new Date(+a[0], +a[1] - 1, +a[2], +a[3] || 0, +a[4] || 0, +a[5] || 0);
  return e.indexOf("Z") > -1 && (s = new Date(s.getTime() - s.getTimezoneOffset() * 60 * 1e3)), s;
}
function Qx(e, t) {
  if (Mr && Buffer.isBuffer(e))
    return e.toString("binary");
  if (typeof TextDecoder < "u") try {
    var r = {
      "€": "",
      "‚": "",
      ƒ: "",
      "„": "",
      "…": "",
      "†": "",
      "‡": "",
      "ˆ": "",
      "‰": "",
      Š: "",
      "‹": "",
      Œ: "",
      Ž: "",
      "‘": "",
      "’": "",
      "“": "",
      "”": "",
      "•": "",
      "–": "",
      "—": "",
      "˜": "",
      "™": "",
      š: "",
      "›": "",
      œ: "",
      ž: "",
      Ÿ: ""
    };
    return Array.isArray(e) && (e = new Uint8Array(e)), new TextDecoder("latin1").decode(e).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(s) {
      return r[s] || s;
    });
  } catch {
  }
  for (var n = [], a = 0; a != e.length; ++a) n.push(String.fromCharCode(e[a]));
  return n.join("");
}
function Ss(e) {
  if (typeof JSON < "u" && !Array.isArray(e)) return JSON.parse(JSON.stringify(e));
  if (typeof e != "object" || e == null) return e;
  if (e instanceof Date) return new Date(e.getTime());
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = Ss(e[r]));
  return t;
}
function An(e, t) {
  for (var r = ""; r.length < t; ) r += e;
  return r;
}
function Nl(e) {
  var t = Number(e);
  if (!isNaN(t)) return isFinite(t) ? t : NaN;
  if (!/\d/.test(e)) return t;
  var r = 1, n = e.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
    return r *= 100, "";
  });
  return !isNaN(t = Number(n)) || (n = n.replace(/[(](.*)[)]/, function(a, s) {
    return r = -r, s;
  }), !isNaN(t = Number(n))) ? t / r : t;
}
var wHe = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
function mg(e) {
  var t = new Date(e), r = /* @__PURE__ */ new Date(NaN), n = t.getYear(), a = t.getMonth(), s = t.getDate();
  if (isNaN(s)) return r;
  var i = e.toLowerCase();
  if (i.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
    if (i = i.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, ""), i.length > 3 && wHe.indexOf(i) == -1) return r;
  } else if (i.match(/[a-z]/)) return r;
  return n < 0 || n > 8099 ? r : (a > 0 || s > 1) && n != 101 ? t : e.match(/[^-0-9:,\/\\]/) ? r : t;
}
function cr(e, t, r) {
  if (e.FullPaths) {
    if (typeof r == "string") {
      var n;
      return Mr ? n = Gl(r) : n = H8e(r), rn.utils.cfb_add(e, t, n);
    }
    rn.utils.cfb_add(e, t, r);
  } else e.file(t, r);
}
function F2() {
  return rn.utils.cfb_new();
}
var ra = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r
`, xHe = {
  "&quot;": '"',
  "&apos;": "'",
  "&gt;": ">",
  "&lt;": "<",
  "&amp;": "&"
}, B2 = /* @__PURE__ */ j2(xHe), U2 = /[&<>'"]/g, _He = /[\u0000-\u0008\u000b-\u001f]/g;
function Jr(e) {
  var t = e + "";
  return t.replace(U2, function(r) {
    return B2[r];
  }).replace(_He, function(r) {
    return "_x" + ("000" + r.charCodeAt(0).toString(16)).slice(-4) + "_";
  });
}
function $j(e) {
  return Jr(e).replace(/ /g, "_x0020_");
}
var r9 = /[\u0000-\u001f]/g;
function SHe(e) {
  var t = e + "";
  return t.replace(U2, function(r) {
    return B2[r];
  }).replace(/\n/g, "<br/>").replace(r9, function(r) {
    return "&#x" + ("000" + r.charCodeAt(0).toString(16)).slice(-4) + ";";
  });
}
function EHe(e) {
  var t = e + "";
  return t.replace(U2, function(r) {
    return B2[r];
  }).replace(r9, function(r) {
    return "&#x" + r.charCodeAt(0).toString(16).toUpperCase() + ";";
  });
}
function THe(e) {
  return e.replace(/(\r\n|[\r\n])/g, "&#10;");
}
function CHe(e) {
  switch (e) {
    case 1:
    case !0:
    case "1":
    case "true":
    case "TRUE":
      return !0;
    default:
      return !1;
  }
}
function ES(e) {
  for (var t = "", r = 0, n = 0, a = 0, s = 0, i = 0, o = 0; r < e.length; ) {
    if (n = e.charCodeAt(r++), n < 128) {
      t += String.fromCharCode(n);
      continue;
    }
    if (a = e.charCodeAt(r++), n > 191 && n < 224) {
      i = (n & 31) << 6, i |= a & 63, t += String.fromCharCode(i);
      continue;
    }
    if (s = e.charCodeAt(r++), n < 240) {
      t += String.fromCharCode((n & 15) << 12 | (a & 63) << 6 | s & 63);
      continue;
    }
    i = e.charCodeAt(r++), o = ((n & 7) << 18 | (a & 63) << 12 | (s & 63) << 6 | i & 63) - 65536, t += String.fromCharCode(55296 + (o >>> 10 & 1023)), t += String.fromCharCode(56320 + (o & 1023));
  }
  return t;
}
function Hj(e) {
  var t = Xu(2 * e.length), r, n, a = 1, s = 0, i = 0, o;
  for (n = 0; n < e.length; n += a)
    a = 1, (o = e.charCodeAt(n)) < 128 ? r = o : o < 224 ? (r = (o & 31) * 64 + (e.charCodeAt(n + 1) & 63), a = 2) : o < 240 ? (r = (o & 15) * 4096 + (e.charCodeAt(n + 1) & 63) * 64 + (e.charCodeAt(n + 2) & 63), a = 3) : (a = 4, r = (o & 7) * 262144 + (e.charCodeAt(n + 1) & 63) * 4096 + (e.charCodeAt(n + 2) & 63) * 64 + (e.charCodeAt(n + 3) & 63), r -= 65536, i = 55296 + (r >>> 10 & 1023), r = 56320 + (r & 1023)), i !== 0 && (t[s++] = i & 255, t[s++] = i >>> 8, i = 0), t[s++] = r % 256, t[s++] = r >>> 8;
  return t.slice(0, s).toString("ucs2");
}
function Wj(e) {
  return Gl(e, "binary").toString("utf8");
}
var iy = "foo bar bazâð£", km = Mr && (/* @__PURE__ */ Wj(iy) == /* @__PURE__ */ ES(iy) && Wj || /* @__PURE__ */ Hj(iy) == /* @__PURE__ */ ES(iy) && Hj) || ES, gg = Mr ? function(e) {
  return Gl(e, "utf8").toString("binary");
} : function(e) {
  for (var t = [], r = 0, n = 0, a = 0; r < e.length; )
    switch (n = e.charCodeAt(r++), !0) {
      case n < 128:
        t.push(String.fromCharCode(n));
        break;
      case n < 2048:
        t.push(String.fromCharCode(192 + (n >> 6))), t.push(String.fromCharCode(128 + (n & 63)));
        break;
      case (n >= 55296 && n < 57344):
        n -= 55296, a = e.charCodeAt(r++) - 56320 + (n << 10), t.push(String.fromCharCode(240 + (a >> 18 & 7))), t.push(String.fromCharCode(144 + (a >> 12 & 63))), t.push(String.fromCharCode(128 + (a >> 6 & 63))), t.push(String.fromCharCode(128 + (a & 63)));
        break;
      default:
        t.push(String.fromCharCode(224 + (n >> 12))), t.push(String.fromCharCode(128 + (n >> 6 & 63))), t.push(String.fromCharCode(128 + (n & 63)));
    }
  return t.join("");
}, kHe = /* @__PURE__ */ function() {
  var e = [
    ["nbsp", " "],
    ["middot", "·"],
    ["quot", '"'],
    ["apos", "'"],
    ["gt", ">"],
    ["lt", "<"],
    ["amp", "&"]
  ].map(function(t) {
    return [new RegExp("&" + t[0] + ";", "ig"), t[1]];
  });
  return function(r) {
    for (var n = r.replace(/^[\t\n\r ]+/, "").replace(/[\t\n\r ]+$/, "").replace(/>\s+/g, ">").replace(/\s+</g, "<").replace(/[\t\n\r ]+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g, `
`).replace(/<[^>]*>/g, ""), a = 0; a < e.length; ++a) n = n.replace(e[a][0], e[a][1]);
    return n;
  };
}(), n9 = /(^\s|\s$|\n)/;
function Aa(e, t) {
  return "<" + e + (t.match(n9) ? ' xml:space="preserve"' : "") + ">" + t + "</" + e + ">";
}
function vg(e) {
  return Ia(e).map(function(t) {
    return " " + t + '="' + e[t] + '"';
  }).join("");
}
function vt(e, t, r) {
  return "<" + e + (r != null ? vg(r) : "") + (t != null ? (t.match(n9) ? ' xml:space="preserve"' : "") + ">" + t + "</" + e : "/") + ">";
}
function gT(e, t) {
  try {
    return e.toISOString().replace(/\.\d*/, "");
  } catch (r) {
    if (t) throw r;
  }
  return "";
}
function OHe(e, t) {
  switch (typeof e) {
    case "string":
      var r = vt("vt:lpwstr", Jr(e));
      return r = r.replace(/&quot;/g, "_x0022_"), r;
    case "number":
      return vt((e | 0) == e ? "vt:i4" : "vt:r8", Jr(String(e)));
    case "boolean":
      return vt("vt:bool", e ? "true" : "false");
  }
  if (e instanceof Date) return vt("vt:filetime", gT(e));
  throw new Error("Unable to serialize " + e);
}
var pa = {
  CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
  CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
  EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
  CT: "http://schemas.openxmlformats.org/package/2006/content-types",
  RELS: "http://schemas.openxmlformats.org/package/2006/relationships",
  TCMNT: "http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments",
  dc: "http://purl.org/dc/elements/1.1/",
  dcterms: "http://purl.org/dc/terms/",
  dcmitype: "http://purl.org/dc/dcmitype/",
  r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
  vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",
  xsi: "http://www.w3.org/2001/XMLSchema-instance",
  xsd: "http://www.w3.org/2001/XMLSchema"
}, Gh = [
  "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
  "http://purl.oclc.org/ooxml/spreadsheetml/main",
  "http://schemas.microsoft.com/office/excel/2006/main",
  "http://schemas.microsoft.com/office/excel/2006/2"
], Us = {
  o: "urn:schemas-microsoft-com:office:office",
  x: "urn:schemas-microsoft-com:office:excel",
  ss: "urn:schemas-microsoft-com:office:spreadsheet",
  dt: "uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",
  mv: "http://macVmlSchemaUri",
  v: "urn:schemas-microsoft-com:vml",
  html: "http://www.w3.org/TR/REC-html40"
};
function AHe(e, t) {
  for (var r = 1 - 2 * (e[t + 7] >>> 7), n = ((e[t + 7] & 127) << 4) + (e[t + 6] >>> 4 & 15), a = e[t + 6] & 15, s = 5; s >= 0; --s) a = a * 256 + e[t + s];
  return n == 2047 ? a == 0 ? r * (1 / 0) : NaN : (n == 0 ? n = -1022 : (n -= 1023, a += Math.pow(2, 52)), r * Math.pow(2, n - 52) * a);
}
function PHe(e, t, r) {
  var n = (t < 0 || 1 / t == -1 / 0 ? 1 : 0) << 7, a = 0, s = 0, i = n ? -t : t;
  isFinite(i) ? i == 0 ? a = s = 0 : (a = Math.floor(Math.log(i) / Math.LN2), s = i * Math.pow(2, 52 - a), a <= -1023 && (!isFinite(s) || s < Math.pow(2, 52)) ? a = -1022 : (s -= Math.pow(2, 52), a += 1023)) : (a = 2047, s = isNaN(t) ? 26985 : 0);
  for (var o = 0; o <= 5; ++o, s /= 256) e[r + o] = s & 255;
  e[r + 6] = (a & 15) << 4 | s & 15, e[r + 7] = a >> 4 | n;
}
var zj = function(e) {
  for (var t = [], r = 10240, n = 0; n < e[0].length; ++n) if (e[0][n]) for (var a = 0, s = e[0][n].length; a < s; a += r) t.push.apply(t, e[0][n].slice(a, a + r));
  return t;
}, Kj = Mr ? function(e) {
  return e[0].length > 0 && Buffer.isBuffer(e[0][0]) ? Buffer.concat(e[0].map(function(t) {
    return Buffer.isBuffer(t) ? t : Gl(t);
  })) : zj(e);
} : zj, qj = function(e, t, r) {
  for (var n = [], a = t; a < r; a += 2) n.push(String.fromCharCode(im(e, a)));
  return n.join("").replace(Cm, "");
}, V2 = Mr ? function(e, t, r) {
  return Buffer.isBuffer(e) ? e.toString("utf16le", t, r).replace(Cm, "") : qj(e, t, r);
} : qj, Gj = function(e, t, r) {
  for (var n = [], a = t; a < t + r; ++a) n.push(("0" + e[a].toString(16)).slice(-2));
  return n.join("");
}, a9 = Mr ? function(e, t, r) {
  return Buffer.isBuffer(e) ? e.toString("hex", t, t + r) : Gj(e, t, r);
} : Gj, Yj = function(e, t, r) {
  for (var n = [], a = t; a < r; a++) n.push(String.fromCharCode(Of(e, a)));
  return n.join("");
}, xv = Mr ? function(t, r, n) {
  return Buffer.isBuffer(t) ? t.toString("utf8", r, n) : Yj(t, r, n);
} : Yj, s9 = function(e, t) {
  var r = Vs(e, t);
  return r > 0 ? xv(e, t + 4, t + 4 + r - 1) : "";
}, i9 = s9, o9 = function(e, t) {
  var r = Vs(e, t);
  return r > 0 ? xv(e, t + 4, t + 4 + r - 1) : "";
}, l9 = o9, c9 = function(e, t) {
  var r = 2 * Vs(e, t);
  return r > 0 ? xv(e, t + 4, t + 4 + r - 1) : "";
}, u9 = c9, d9 = function(t, r) {
  var n = Vs(t, r);
  return n > 0 ? V2(t, r + 4, r + 4 + n) : "";
}, f9 = d9, h9 = function(e, t) {
  var r = Vs(e, t);
  return r > 0 ? xv(e, t + 4, t + 4 + r) : "";
}, p9 = h9, m9 = function(e, t) {
  return AHe(e, t);
}, sw = m9, $2 = function(t) {
  return Array.isArray(t) || typeof Uint8Array < "u" && t instanceof Uint8Array;
};
Mr && (i9 = function(t, r) {
  if (!Buffer.isBuffer(t)) return s9(t, r);
  var n = t.readUInt32LE(r);
  return n > 0 ? t.toString("utf8", r + 4, r + 4 + n - 1) : "";
}, l9 = function(t, r) {
  if (!Buffer.isBuffer(t)) return o9(t, r);
  var n = t.readUInt32LE(r);
  return n > 0 ? t.toString("utf8", r + 4, r + 4 + n - 1) : "";
}, u9 = function(t, r) {
  if (!Buffer.isBuffer(t)) return c9(t, r);
  var n = 2 * t.readUInt32LE(r);
  return t.toString("utf16le", r + 4, r + 4 + n - 1);
}, f9 = function(t, r) {
  if (!Buffer.isBuffer(t)) return d9(t, r);
  var n = t.readUInt32LE(r);
  return t.toString("utf16le", r + 4, r + 4 + n);
}, p9 = function(t, r) {
  if (!Buffer.isBuffer(t)) return h9(t, r);
  var n = t.readUInt32LE(r);
  return t.toString("utf8", r + 4, r + 4 + n);
}, sw = function(t, r) {
  return Buffer.isBuffer(t) ? t.readDoubleLE(r) : m9(t, r);
}, $2 = function(t) {
  return Buffer.isBuffer(t) || Array.isArray(t) || typeof Uint8Array < "u" && t instanceof Uint8Array;
});
var Of = function(e, t) {
  return e[t];
}, im = function(e, t) {
  return e[t + 1] * 256 + e[t];
}, RHe = function(e, t) {
  var r = e[t + 1] * 256 + e[t];
  return r < 32768 ? r : (65535 - r + 1) * -1;
}, Vs = function(e, t) {
  return e[t + 3] * (1 << 24) + (e[t + 2] << 16) + (e[t + 1] << 8) + e[t];
}, yu = function(e, t) {
  return e[t + 3] << 24 | e[t + 2] << 16 | e[t + 1] << 8 | e[t];
}, IHe = function(e, t) {
  return e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3];
};
function Om(e, t) {
  var r = "", n, a, s = [], i, o, l, c;
  switch (t) {
    case "dbcs":
      if (c = this.l, Mr && Buffer.isBuffer(this)) r = this.slice(this.l, this.l + 2 * e).toString("utf16le");
      else for (l = 0; l < e; ++l)
        r += String.fromCharCode(im(this, c)), c += 2;
      e *= 2;
      break;
    case "utf8":
      r = xv(this, this.l, this.l + e);
      break;
    case "utf16le":
      e *= 2, r = V2(this, this.l, this.l + e);
      break;
    case "wstr":
      return Om.call(this, e, "dbcs");
    case "lpstr-ansi":
      r = i9(this, this.l), e = 4 + Vs(this, this.l);
      break;
    case "lpstr-cp":
      r = l9(this, this.l), e = 4 + Vs(this, this.l);
      break;
    case "lpwstr":
      r = u9(this, this.l), e = 4 + 2 * Vs(this, this.l);
      break;
    case "lpp4":
      e = 4 + Vs(this, this.l), r = f9(this, this.l), e & 2 && (e += 2);
      break;
    case "8lpp4":
      e = 4 + Vs(this, this.l), r = p9(this, this.l), e & 3 && (e += 4 - (e & 3));
      break;
    case "cstr":
      for (e = 0, r = ""; (i = Of(this, this.l + e++)) !== 0; ) s.push(ny(i));
      r = s.join("");
      break;
    case "_wstr":
      for (e = 0, r = ""; (i = im(this, this.l + e)) !== 0; )
        s.push(ny(i)), e += 2;
      e += 2, r = s.join("");
      break;
    case "dbcs-cont":
      for (r = "", c = this.l, l = 0; l < e; ++l) {
        if (this.lens && this.lens.indexOf(c) !== -1)
          return i = Of(this, c), this.l = c + 1, o = Om.call(this, e - l, i ? "dbcs-cont" : "sbcs-cont"), s.join("") + o;
        s.push(ny(im(this, c))), c += 2;
      }
      r = s.join(""), e *= 2;
      break;
    case "cpstr":
    case "sbcs-cont":
      for (r = "", c = this.l, l = 0; l != e; ++l) {
        if (this.lens && this.lens.indexOf(c) !== -1)
          return i = Of(this, c), this.l = c + 1, o = Om.call(this, e - l, i ? "dbcs-cont" : "sbcs-cont"), s.join("") + o;
        s.push(ny(Of(this, c))), c += 1;
      }
      r = s.join("");
      break;
    default:
      switch (e) {
        case 1:
          return n = Of(this, this.l), this.l++, n;
        case 2:
          return n = (t === "i" ? RHe : im)(this, this.l), this.l += 2, n;
        case 4:
        case -4:
          return t === "i" || !(this[this.l + 3] & 128) ? (n = (e > 0 ? yu : IHe)(this, this.l), this.l += 4, n) : (a = Vs(this, this.l), this.l += 4, a);
        case 8:
        case -8:
          if (t === "f")
            return e == 8 ? a = sw(this, this.l) : a = sw([this[this.l + 7], this[this.l + 6], this[this.l + 5], this[this.l + 4], this[this.l + 3], this[this.l + 2], this[this.l + 1], this[this.l + 0]], 0), this.l += 8, a;
          e = 8;
        case 16:
          r = a9(this, this.l, e);
          break;
      }
  }
  return this.l += e, r;
}
var DHe = function(e, t, r) {
  e[r] = t & 255, e[r + 1] = t >>> 8 & 255, e[r + 2] = t >>> 16 & 255, e[r + 3] = t >>> 24 & 255;
}, NHe = function(e, t, r) {
  e[r] = t & 255, e[r + 1] = t >> 8 & 255, e[r + 2] = t >> 16 & 255, e[r + 3] = t >> 24 & 255;
}, MHe = function(e, t, r) {
  e[r] = t & 255, e[r + 1] = t >>> 8 & 255;
};
function LHe(e, t, r) {
  var n = 0, a = 0;
  if (r === "dbcs") {
    for (a = 0; a != t.length; ++a) MHe(this, t.charCodeAt(a), this.l + 2 * a);
    n = 2 * t.length;
  } else if (r === "sbcs") {
    for (t = t.replace(/[^\x00-\x7F]/g, "_"), a = 0; a != t.length; ++a) this[this.l + a] = t.charCodeAt(a) & 255;
    n = t.length;
  } else if (r === "hex") {
    for (; a < e; ++a)
      this[this.l++] = parseInt(t.slice(2 * a, 2 * a + 2), 16) || 0;
    return this;
  } else if (r === "utf16le") {
    var s = Math.min(this.l + e, this.length);
    for (a = 0; a < Math.min(t.length, e); ++a) {
      var i = t.charCodeAt(a);
      this[this.l++] = i & 255, this[this.l++] = i >> 8;
    }
    for (; this.l < s; ) this[this.l++] = 0;
    return this;
  } else switch (e) {
    case 1:
      n = 1, this[this.l] = t & 255;
      break;
    case 2:
      n = 2, this[this.l] = t & 255, t >>>= 8, this[this.l + 1] = t & 255;
      break;
    case 3:
      n = 3, this[this.l] = t & 255, t >>>= 8, this[this.l + 1] = t & 255, t >>>= 8, this[this.l + 2] = t & 255;
      break;
    case 4:
      n = 4, DHe(this, t, this.l);
      break;
    case 8:
      if (n = 8, r === "f") {
        PHe(this, t, this.l);
        break;
      }
    case 16:
      break;
    case -4:
      n = 4, NHe(this, t, this.l);
      break;
  }
  return this.l += n, this;
}
function g9(e, t) {
  var r = a9(this, this.l, e.length >> 1);
  if (r !== e) throw new Error(t + "Expected " + e + " saw " + r);
  this.l += e.length >> 1;
}
function Fs(e, t) {
  e.l = t, e.read_shift = /*::(*/
  Om, e.chk = g9, e.write_shift = LHe;
}
function Vo(e, t) {
  e.l += t;
}
function Ke(e) {
  var t = Xu(e);
  return Fs(t, 0), t;
}
function xs() {
  var e = [], t = Mr ? 256 : 2048, r = function(c) {
    var u = Ke(c);
    return Fs(u, 0), u;
  }, n = r(t), a = function() {
    n && (n.length > n.l && (n = n.slice(0, n.l), n.l = n.length), n.length > 0 && e.push(n), n = null);
  }, s = function(c) {
    return n && c < n.length - n.l ? n : (a(), n = r(Math.max(c + 1, t)));
  }, i = function() {
    return a(), Oa(e);
  }, o = function(c) {
    a(), n = c, n.l == null && (n.l = n.length), s(t);
  };
  return { next: s, push: o, end: i, _bufs: e };
}
function nt(e, t, r, n) {
  var a = +t, s;
  if (!isNaN(a)) {
    n || (n = Aqe[a].p || (r || []).length || 0), s = 1 + (a >= 128 ? 1 : 0) + 1, n >= 128 && ++s, n >= 16384 && ++s, n >= 2097152 && ++s;
    var i = e.next(s);
    a <= 127 ? i.write_shift(1, a) : (i.write_shift(1, (a & 127) + 128), i.write_shift(1, a >> 7));
    for (var o = 0; o != 4; ++o)
      if (n >= 128)
        i.write_shift(1, (n & 127) + 128), n >>= 7;
      else {
        i.write_shift(1, n);
        break;
      }
    /*:: length != null &&*/
    n > 0 && $2(r) && e.push(r);
  }
}
function Am(e, t, r) {
  var n = Ss(e);
  if (t.s ? (n.cRel && (n.c += t.s.c), n.rRel && (n.r += t.s.r)) : (n.cRel && (n.c += t.c), n.rRel && (n.r += t.r)), !r || r.biff < 12) {
    for (; n.c >= 256; ) n.c -= 256;
    for (; n.r >= 65536; ) n.r -= 65536;
  }
  return n;
}
function Xj(e, t, r) {
  var n = Ss(e);
  return n.s = Am(n.s, t.s, r), n.e = Am(n.e, t.s, r), n;
}
function Pm(e, t) {
  if (e.cRel && e.c < 0)
    for (e = Ss(e); e.c < 0; ) e.c += t > 8 ? 16384 : 256;
  if (e.rRel && e.r < 0)
    for (e = Ss(e); e.r < 0; ) e.r += t > 8 ? 1048576 : t > 5 ? 65536 : 16384;
  var r = Zr(e);
  return !e.cRel && e.cRel != null && (r = BHe(r)), !e.rRel && e.rRel != null && (r = jHe(r)), r;
}
function TS(e, t) {
  return e.s.r == 0 && !e.s.rRel && e.e.r == (t.biff >= 12 ? 1048575 : t.biff >= 8 ? 65536 : 16384) && !e.e.rRel ? (e.s.cRel ? "" : "$") + Ya(e.s.c) + ":" + (e.e.cRel ? "" : "$") + Ya(e.e.c) : e.s.c == 0 && !e.s.cRel && e.e.c == (t.biff >= 12 ? 16383 : 255) && !e.e.cRel ? (e.s.rRel ? "" : "$") + Ra(e.s.r) + ":" + (e.e.rRel ? "" : "$") + Ra(e.e.r) : Pm(e.s, t.biff) + ":" + Pm(e.e, t.biff);
}
function H2(e) {
  return parseInt(FHe(e), 10) - 1;
}
function Ra(e) {
  return "" + (e + 1);
}
function jHe(e) {
  return e.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function FHe(e) {
  return e.replace(/\$(\d+)$/, "$1");
}
function W2(e) {
  for (var t = UHe(e), r = 0, n = 0; n !== t.length; ++n) r = 26 * r + t.charCodeAt(n) - 64;
  return r - 1;
}
function Ya(e) {
  if (e < 0) throw new Error("invalid column " + e);
  var t = "";
  for (++e; e; e = Math.floor((e - 1) / 26)) t = String.fromCharCode((e - 1) % 26 + 65) + t;
  return t;
}
function BHe(e) {
  return e.replace(/^([A-Z])/, "$$$1");
}
function UHe(e) {
  return e.replace(/^\$([A-Z])/, "$1");
}
function VHe(e) {
  return e.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function ma(e) {
  for (var t = 0, r = 0, n = 0; n < e.length; ++n) {
    var a = e.charCodeAt(n);
    a >= 48 && a <= 57 ? t = 10 * t + (a - 48) : a >= 65 && a <= 90 && (r = 26 * r + (a - 64));
  }
  return { c: r - 1, r: t - 1 };
}
function Zr(e) {
  for (var t = e.c + 1, r = ""; t; t = (t - 1) / 26 | 0) r = String.fromCharCode((t - 1) % 26 + 65) + r;
  return r + (e.r + 1);
}
function qs(e) {
  var t = e.indexOf(":");
  return t == -1 ? { s: ma(e), e: ma(e) } : { s: ma(e.slice(0, t)), e: ma(e.slice(t + 1)) };
}
function ea(e, t) {
  return typeof t > "u" || typeof t == "number" ? ea(e.s, e.e) : (typeof e != "string" && (e = Zr(e)), typeof t != "string" && (t = Zr(t)), e == t ? e : e + ":" + t);
}
function vn(e) {
  var t = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } }, r = 0, n = 0, a = 0, s = e.length;
  for (r = 0; n < s && !((a = e.charCodeAt(n) - 64) < 1 || a > 26); ++n)
    r = 26 * r + a;
  for (t.s.c = --r, r = 0; n < s && !((a = e.charCodeAt(n) - 48) < 0 || a > 9); ++n)
    r = 10 * r + a;
  if (t.s.r = --r, n === s || a != 10)
    return t.e.c = t.s.c, t.e.r = t.s.r, t;
  for (++n, r = 0; n != s && !((a = e.charCodeAt(n) - 64) < 1 || a > 26); ++n)
    r = 26 * r + a;
  for (t.e.c = --r, r = 0; n != s && !((a = e.charCodeAt(n) - 48) < 0 || a > 9); ++n)
    r = 10 * r + a;
  return t.e.r = --r, t;
}
function Qj(e, t) {
  var r = e.t == "d" && t instanceof Date;
  if (e.z != null) try {
    return e.w = Bc(e.z, r ? _s(t) : t);
  } catch {
  }
  try {
    return e.w = Bc((e.XF || {}).numFmtId || (r ? 14 : 0), r ? _s(t) : t);
  } catch {
    return "" + t;
  }
}
function Ul(e, t, r) {
  return e == null || e.t == null || e.t == "z" ? "" : e.w !== void 0 ? e.w : (e.t == "d" && !e.z && r && r.dateNF && (e.z = r.dateNF), e.t == "e" ? _v[e.v] || e.v : t == null ? Qj(e, e.v) : Qj(e, t));
}
function _d(e, t) {
  var r = t && t.sheet ? t.sheet : "Sheet1", n = {};
  return n[r] = e, { SheetNames: [r], Sheets: n };
}
function v9(e, t, r) {
  var n = r || {}, a = e ? Array.isArray(e) : n.dense, s = e || (a ? [] : {}), i = 0, o = 0;
  if (s && n.origin != null) {
    if (typeof n.origin == "number") i = n.origin;
    else {
      var l = typeof n.origin == "string" ? ma(n.origin) : n.origin;
      i = l.r, o = l.c;
    }
    s["!ref"] || (s["!ref"] = "A1:A1");
  }
  var c = { s: { c: 1e7, r: 1e7 }, e: { c: 0, r: 0 } };
  if (s["!ref"]) {
    var u = vn(s["!ref"]);
    c.s.c = u.s.c, c.s.r = u.s.r, c.e.c = Math.max(c.e.c, u.e.c), c.e.r = Math.max(c.e.r, u.e.r), i == -1 && (c.e.r = i = u.e.r + 1);
  }
  for (var d = 0; d != t.length; ++d)
    if (t[d]) {
      if (!Array.isArray(t[d])) throw new Error("aoa_to_sheet expects an array of arrays");
      for (var f = 0; f != t[d].length; ++f)
        if (!(typeof t[d][f] > "u")) {
          var h = { v: t[d][f] }, p = i + d, m = o + f;
          if (c.s.r > p && (c.s.r = p), c.s.c > m && (c.s.c = m), c.e.r < p && (c.e.r = p), c.e.c < m && (c.e.c = m), t[d][f] && typeof t[d][f] == "object" && !Array.isArray(t[d][f]) && !(t[d][f] instanceof Date)) h = t[d][f];
          else if (Array.isArray(h.v) && (h.f = t[d][f][1], h.v = h.v[0]), h.v === null)
            if (h.f) h.t = "n";
            else if (n.nullError)
              h.t = "e", h.v = 0;
            else if (n.sheetStubs) h.t = "z";
            else continue;
          else typeof h.v == "number" ? h.t = "n" : typeof h.v == "boolean" ? h.t = "b" : h.v instanceof Date ? (h.z = n.dateNF || Rn[14], n.cellDates ? (h.t = "d", h.w = Bc(h.z, _s(h.v))) : (h.t = "n", h.v = _s(h.v), h.w = Bc(h.z, h.v))) : h.t = "s";
          if (a)
            s[p] || (s[p] = []), s[p][m] && s[p][m].z && (h.z = s[p][m].z), s[p][m] = h;
          else {
            var g = Zr({ c: m, r: p });
            s[g] && s[g].z && (h.z = s[g].z), s[g] = h;
          }
        }
    }
  return c.s.c < 1e7 && (s["!ref"] = ea(c)), s;
}
function Yh(e, t) {
  return v9(null, e, t);
}
function $He(e) {
  return e.read_shift(4, "i");
}
function Bi(e, t) {
  return t || (t = Ke(4)), t.write_shift(4, e), t;
}
function Xa(e) {
  var t = e.read_shift(4);
  return t === 0 ? "" : e.read_shift(t, "dbcs");
}
function ga(e, t) {
  var r = !1;
  return t == null && (r = !0, t = Ke(4 + 2 * e.length)), t.write_shift(4, e.length), e.length > 0 && t.write_shift(0, e, "dbcs"), r ? t.slice(0, t.l) : t;
}
function HHe(e) {
  return { ich: e.read_shift(2), ifnt: e.read_shift(2) };
}
function WHe(e, t) {
  return t || (t = Ke(4)), t.write_shift(2, 0), t.write_shift(2, 0), t;
}
function z2(e, t) {
  var r = e.l, n = e.read_shift(1), a = Xa(e), s = [], i = { t: a, h: a };
  if (n & 1) {
    for (var o = e.read_shift(4), l = 0; l != o; ++l) s.push(HHe(e));
    i.r = s;
  } else i.r = [{ ich: 0, ifnt: 0 }];
  return e.l = r + t, i;
}
function zHe(e, t) {
  var r = !1;
  return t == null && (r = !0, t = Ke(15 + 4 * e.t.length)), t.write_shift(1, 0), ga(e.t, t), r ? t.slice(0, t.l) : t;
}
var KHe = z2;
function qHe(e, t) {
  var r = !1;
  return t == null && (r = !0, t = Ke(23 + 4 * e.t.length)), t.write_shift(1, 1), ga(e.t, t), t.write_shift(4, 1), WHe({}, t), r ? t.slice(0, t.l) : t;
}
function wi(e) {
  var t = e.read_shift(4), r = e.read_shift(2);
  return r += e.read_shift(1) << 16, e.l++, { c: t, iStyleRef: r };
}
function Sd(e, t) {
  return t == null && (t = Ke(8)), t.write_shift(-4, e.c), t.write_shift(3, e.iStyleRef || e.s), t.write_shift(1, 0), t;
}
function Ed(e) {
  var t = e.read_shift(2);
  return t += e.read_shift(1) << 16, e.l++, { c: -1, iStyleRef: t };
}
function Td(e, t) {
  return t == null && (t = Ke(4)), t.write_shift(3, e.iStyleRef || e.s), t.write_shift(1, 0), t;
}
var GHe = Xa, y9 = ga;
function K2(e) {
  var t = e.read_shift(4);
  return t === 0 || t === 4294967295 ? "" : e.read_shift(t, "dbcs");
}
function iw(e, t) {
  var r = !1;
  return t == null && (r = !0, t = Ke(127)), t.write_shift(4, e.length > 0 ? e.length : 4294967295), e.length > 0 && t.write_shift(0, e, "dbcs"), r ? t.slice(0, t.l) : t;
}
var YHe = Xa, vT = K2, q2 = iw;
function b9(e) {
  var t = e.slice(e.l, e.l + 4), r = t[0] & 1, n = t[0] & 2;
  e.l += 4;
  var a = n === 0 ? sw([0, 0, 0, 0, t[0] & 252, t[1], t[2], t[3]], 0) : yu(t, 0) >> 2;
  return r ? a / 100 : a;
}
function w9(e, t) {
  t == null && (t = Ke(4));
  var r = 0, n = 0, a = e * 100;
  if (e == (e | 0) && e >= -536870912 && e < 1 << 29 ? n = 1 : a == (a | 0) && a >= -536870912 && a < 1 << 29 && (n = 1, r = 1), n) t.write_shift(-4, ((r ? a : e) << 2) + (r + 2));
  else throw new Error("unsupported RkNumber " + e);
}
function x9(e) {
  var t = { s: {}, e: {} };
  return t.s.r = e.read_shift(4), t.e.r = e.read_shift(4), t.s.c = e.read_shift(4), t.e.c = e.read_shift(4), t;
}
function XHe(e, t) {
  return t || (t = Ke(16)), t.write_shift(4, e.s.r), t.write_shift(4, e.e.r), t.write_shift(4, e.s.c), t.write_shift(4, e.e.c), t;
}
var Cd = x9, Xh = XHe;
function Qh(e) {
  if (e.length - e.l < 8) throw "XLS Xnum Buffer underflow";
  return e.read_shift(8, "f");
}
function Qu(e, t) {
  return (t || Ke(8)).write_shift(8, e, "f");
}
function QHe(e) {
  var t = {}, r = e.read_shift(1), n = r >>> 1, a = e.read_shift(1), s = e.read_shift(2, "i"), i = e.read_shift(1), o = e.read_shift(1), l = e.read_shift(1);
  switch (e.l++, n) {
    case 0:
      t.auto = 1;
      break;
    case 1:
      t.index = a;
      var c = i7e[a];
      c && (t.rgb = l4(c));
      break;
    case 2:
      t.rgb = l4([i, o, l]);
      break;
    case 3:
      t.theme = a;
      break;
  }
  return s != 0 && (t.tint = s > 0 ? s / 32767 : s / 32768), t;
}
function ow(e, t) {
  if (t || (t = Ke(8)), !e || e.auto)
    return t.write_shift(4, 0), t.write_shift(4, 0), t;
  e.index != null ? (t.write_shift(1, 2), t.write_shift(1, e.index)) : e.theme != null ? (t.write_shift(1, 6), t.write_shift(1, e.theme)) : (t.write_shift(1, 5), t.write_shift(1, 0));
  var r = e.tint || 0;
  if (r > 0 ? r *= 32767 : r < 0 && (r *= 32768), t.write_shift(2, r), !e.rgb || e.theme != null)
    t.write_shift(2, 0), t.write_shift(1, 0), t.write_shift(1, 0);
  else {
    var n = e.rgb || "FFFFFF";
    typeof n == "number" && (n = ("000000" + n.toString(16)).slice(-6)), t.write_shift(1, parseInt(n.slice(0, 2), 16)), t.write_shift(1, parseInt(n.slice(2, 4), 16)), t.write_shift(1, parseInt(n.slice(4, 6), 16)), t.write_shift(1, 255);
  }
  return t;
}
function JHe(e) {
  var t = e.read_shift(1);
  e.l++;
  var r = {
    fBold: t & 1,
    fItalic: t & 2,
    fUnderline: t & 4,
    fStrikeout: t & 8,
    fOutline: t & 16,
    fShadow: t & 32,
    fCondense: t & 64,
    fExtend: t & 128
  };
  return r;
}
function ZHe(e, t) {
  t || (t = Ke(2));
  var r = (e.italic ? 2 : 0) | (e.strike ? 8 : 0) | (e.outline ? 16 : 0) | (e.shadow ? 32 : 0) | (e.condense ? 64 : 0) | (e.extend ? 128 : 0);
  return t.write_shift(1, r), t.write_shift(1, 0), t;
}
var _9 = 2, Ms = 3, oy = 11, lw = 19, ly = 64, e7e = 65, t7e = 71, r7e = 4108, n7e = 4126, ka = 80, Jj = {
  /*::[*/
  1: { n: "CodePage", t: _9 },
  /*::[*/
  2: { n: "Category", t: ka },
  /*::[*/
  3: { n: "PresentationFormat", t: ka },
  /*::[*/
  4: { n: "ByteCount", t: Ms },
  /*::[*/
  5: { n: "LineCount", t: Ms },
  /*::[*/
  6: { n: "ParagraphCount", t: Ms },
  /*::[*/
  7: { n: "SlideCount", t: Ms },
  /*::[*/
  8: { n: "NoteCount", t: Ms },
  /*::[*/
  9: { n: "HiddenCount", t: Ms },
  /*::[*/
  10: { n: "MultimediaClipCount", t: Ms },
  /*::[*/
  11: { n: "ScaleCrop", t: oy },
  /*::[*/
  12: {
    n: "HeadingPairs",
    t: r7e
    /* VT_VECTOR | VT_VARIANT */
  },
  /*::[*/
  13: {
    n: "TitlesOfParts",
    t: n7e
    /* VT_VECTOR | VT_LPSTR */
  },
  /*::[*/
  14: { n: "Manager", t: ka },
  /*::[*/
  15: { n: "Company", t: ka },
  /*::[*/
  16: { n: "LinksUpToDate", t: oy },
  /*::[*/
  17: { n: "CharacterCount", t: Ms },
  /*::[*/
  19: { n: "SharedDoc", t: oy },
  /*::[*/
  22: { n: "HyperlinksChanged", t: oy },
  /*::[*/
  23: { n: "AppVersion", t: Ms, p: "version" },
  /*::[*/
  24: { n: "DigSig", t: e7e },
  /*::[*/
  26: { n: "ContentType", t: ka },
  /*::[*/
  27: { n: "ContentStatus", t: ka },
  /*::[*/
  28: { n: "Language", t: ka },
  /*::[*/
  29: { n: "Version", t: ka },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: lw },
  /*::[*/
  2147483651: { n: "Behavior", t: lw },
  /*::[*/
  1919054434: {}
}, Zj = {
  /*::[*/
  1: { n: "CodePage", t: _9 },
  /*::[*/
  2: { n: "Title", t: ka },
  /*::[*/
  3: { n: "Subject", t: ka },
  /*::[*/
  4: { n: "Author", t: ka },
  /*::[*/
  5: { n: "Keywords", t: ka },
  /*::[*/
  6: { n: "Comments", t: ka },
  /*::[*/
  7: { n: "Template", t: ka },
  /*::[*/
  8: { n: "LastAuthor", t: ka },
  /*::[*/
  9: { n: "RevNumber", t: ka },
  /*::[*/
  10: { n: "EditTime", t: ly },
  /*::[*/
  11: { n: "LastPrinted", t: ly },
  /*::[*/
  12: { n: "CreatedDate", t: ly },
  /*::[*/
  13: { n: "ModifiedDate", t: ly },
  /*::[*/
  14: { n: "PageCount", t: Ms },
  /*::[*/
  15: { n: "WordCount", t: Ms },
  /*::[*/
  16: { n: "CharCount", t: Ms },
  /*::[*/
  17: { n: "Thumbnail", t: t7e },
  /*::[*/
  18: { n: "Application", t: ka },
  /*::[*/
  19: { n: "DocSecurity", t: Ms },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: lw },
  /*::[*/
  2147483651: { n: "Behavior", t: lw },
  /*::[*/
  1919054434: {}
};
function a7e(e) {
  return e.map(function(t) {
    return [t >> 16 & 255, t >> 8 & 255, t & 255];
  });
}
var s7e = /* @__PURE__ */ a7e([
  /* Color Constants */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  /* Overridable Defaults */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  8388608,
  32768,
  128,
  8421376,
  8388736,
  32896,
  12632256,
  8421504,
  10066431,
  10040166,
  16777164,
  13434879,
  6684774,
  16744576,
  26316,
  13421823,
  128,
  16711935,
  16776960,
  65535,
  8388736,
  8388608,
  32896,
  255,
  52479,
  13434879,
  13434828,
  16777113,
  10079487,
  16751052,
  13408767,
  16764057,
  3368703,
  3394764,
  10079232,
  16763904,
  16750848,
  16737792,
  6710937,
  9868950,
  13158,
  3381606,
  13056,
  3355392,
  10040064,
  10040166,
  3355545,
  3355443,
  /* Other entries to appease BIFF8/12 */
  16777215,
  /* 0x40 icvForeground ?? */
  0,
  /* 0x41 icvBackground ?? */
  0,
  /* 0x42 icvFrame ?? */
  0,
  /* 0x43 icv3D ?? */
  0,
  /* 0x44 icv3DText ?? */
  0,
  /* 0x45 icv3DHilite ?? */
  0,
  /* 0x46 icv3DShadow ?? */
  0,
  /* 0x47 icvHilite ?? */
  0,
  /* 0x48 icvCtlText ?? */
  0,
  /* 0x49 icvCtlScrl ?? */
  0,
  /* 0x4A icvCtlInv ?? */
  0,
  /* 0x4B icvCtlBody ?? */
  0,
  /* 0x4C icvCtlFrame ?? */
  0,
  /* 0x4D icvCtlFore ?? */
  0,
  /* 0x4E icvCtlBack ?? */
  0,
  /* 0x4F icvCtlNeutral */
  0,
  /* 0x50 icvInfoBk ?? */
  0
  /* 0x51 icvInfoText ?? */
]), i7e = /* @__PURE__ */ Ss(s7e), _v = {
  /*::[*/
  0: "#NULL!",
  /*::[*/
  7: "#DIV/0!",
  /*::[*/
  15: "#VALUE!",
  /*::[*/
  23: "#REF!",
  /*::[*/
  29: "#NAME?",
  /*::[*/
  36: "#NUM!",
  /*::[*/
  42: "#N/A",
  /*::[*/
  43: "#GETTING_DATA",
  /*::[*/
  255: "#WTF?"
}, o7e = {
  /* Workbook */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
  "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
  /* Worksheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
  "application/vnd.ms-excel.worksheet": "sheets",
  "application/vnd.ms-excel.binIndexWs": "TODO",
  /* Binary Index */
  /* Chartsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
  "application/vnd.ms-excel.chartsheet": "charts",
  /* Macrosheet */
  "application/vnd.ms-excel.macrosheet+xml": "macros",
  "application/vnd.ms-excel.macrosheet": "macros",
  "application/vnd.ms-excel.intlmacrosheet": "TODO",
  "application/vnd.ms-excel.binIndexMs": "TODO",
  /* Binary Index */
  /* Dialogsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
  "application/vnd.ms-excel.dialogsheet": "dialogs",
  /* Shared Strings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
  "application/vnd.ms-excel.sharedStrings": "strs",
  /* Styles */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
  "application/vnd.ms-excel.styles": "styles",
  /* File Properties */
  "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
  /* Custom Data Properties */
  "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
  /* Comments */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
  "application/vnd.ms-excel.comments": "comments",
  "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
  "application/vnd.ms-excel.person+xml": "people",
  /* Metadata (Stock/Geography and Dynamic Array) */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
  "application/vnd.ms-excel.sheetMetadata": "metadata",
  /* PivotTable */
  "application/vnd.ms-excel.pivotTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
  /* Chart Objects */
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
  /* Chart Colors */
  "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
  /* Chart Style */
  "application/vnd.ms-office.chartstyle+xml": "TODO",
  /* Chart Advanced */
  "application/vnd.ms-office.chartex+xml": "TODO",
  /* Calculation Chain */
  "application/vnd.ms-excel.calcChain": "calcchains",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
  /* Printer Settings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
  /* ActiveX */
  "application/vnd.ms-office.activeX": "TODO",
  "application/vnd.ms-office.activeX+xml": "TODO",
  /* Custom Toolbars */
  "application/vnd.ms-excel.attachedToolbars": "TODO",
  /* External Data Connections */
  "application/vnd.ms-excel.connections": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
  /* External Links */
  "application/vnd.ms-excel.externalLink": "links",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
  /* PivotCache */
  "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
  "application/vnd.ms-excel.pivotCacheRecords": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
  /* Query Table */
  "application/vnd.ms-excel.queryTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
  /* Shared Workbook */
  "application/vnd.ms-excel.userNames": "TODO",
  "application/vnd.ms-excel.revisionHeaders": "TODO",
  "application/vnd.ms-excel.revisionLog": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
  /* Single Cell Table */
  "application/vnd.ms-excel.tableSingleCells": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
  /* Slicer */
  "application/vnd.ms-excel.slicer": "TODO",
  "application/vnd.ms-excel.slicerCache": "TODO",
  "application/vnd.ms-excel.slicer+xml": "TODO",
  "application/vnd.ms-excel.slicerCache+xml": "TODO",
  /* Sort Map */
  "application/vnd.ms-excel.wsSortMap": "TODO",
  /* Table */
  "application/vnd.ms-excel.table": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
  /* Themes */
  "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
  /* Theme Override */
  "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
  /* Timeline */
  "application/vnd.ms-excel.Timeline+xml": "TODO",
  /* verify */
  "application/vnd.ms-excel.TimelineCache+xml": "TODO",
  /* verify */
  /* VBA */
  "application/vnd.ms-office.vbaProject": "vba",
  "application/vnd.ms-office.vbaProjectSignature": "TODO",
  /* Volatile Dependencies */
  "application/vnd.ms-office.volatileDependencies": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
  /* Control Properties */
  "application/vnd.ms-excel.controlproperties+xml": "TODO",
  /* Data Model */
  "application/vnd.openxmlformats-officedocument.model+data": "TODO",
  /* Survey */
  "application/vnd.ms-excel.Survey+xml": "TODO",
  /* Drawing */
  "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
  /* VML */
  "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
  "application/vnd.openxmlformats-package.relationships+xml": "rels",
  "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
  /* Image */
  "image/png": "TODO",
  sheet: "js"
}, cy = {
  workbooks: {
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
    xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
    xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
    xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
    xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
  },
  strs: {
    /* Shared Strings */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
    xlsb: "application/vnd.ms-excel.sharedStrings"
  },
  comments: {
    /* Comments */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
    xlsb: "application/vnd.ms-excel.comments"
  },
  sheets: {
    /* Worksheet */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
    xlsb: "application/vnd.ms-excel.worksheet"
  },
  charts: {
    /* Chartsheet */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
    xlsb: "application/vnd.ms-excel.chartsheet"
  },
  dialogs: {
    /* Dialogsheet */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
    xlsb: "application/vnd.ms-excel.dialogsheet"
  },
  macros: {
    /* Macrosheet (Excel 4.0 Macros) */
    xlsx: "application/vnd.ms-excel.macrosheet+xml",
    xlsb: "application/vnd.ms-excel.macrosheet"
  },
  metadata: {
    /* Metadata (Stock/Geography and Dynamic Array) */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
    xlsb: "application/vnd.ms-excel.sheetMetadata"
  },
  styles: {
    /* Styles */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
    xlsb: "application/vnd.ms-excel.styles"
  }
};
function S9() {
  return {
    workbooks: [],
    sheets: [],
    charts: [],
    dialogs: [],
    macros: [],
    rels: [],
    strs: [],
    comments: [],
    threadedcomments: [],
    links: [],
    coreprops: [],
    extprops: [],
    custprops: [],
    themes: [],
    styles: [],
    calcchains: [],
    vba: [],
    drawings: [],
    metadata: [],
    people: [],
    TODO: [],
    xmlns: ""
  };
}
function E9(e, t) {
  var r = vHe(o7e), n = [], a;
  n[n.length] = ra, n[n.length] = vt("Types", null, {
    xmlns: pa.CT,
    "xmlns:xsd": pa.xsd,
    "xmlns:xsi": pa.xsi
  }), n = n.concat([
    ["xml", "application/xml"],
    ["bin", "application/vnd.ms-excel.sheet.binary.macroEnabled.main"],
    ["vml", "application/vnd.openxmlformats-officedocument.vmlDrawing"],
    ["data", "application/vnd.openxmlformats-officedocument.model+data"],
    /* from test files */
    ["bmp", "image/bmp"],
    ["png", "image/png"],
    ["gif", "image/gif"],
    ["emf", "image/x-emf"],
    ["wmf", "image/x-wmf"],
    ["jpg", "image/jpeg"],
    ["jpeg", "image/jpeg"],
    ["tif", "image/tiff"],
    ["tiff", "image/tiff"],
    ["pdf", "application/pdf"],
    ["rels", "application/vnd.openxmlformats-package.relationships+xml"]
  ].map(function(l) {
    return vt("Default", null, { Extension: l[0], ContentType: l[1] });
  }));
  var s = function(l) {
    e[l] && e[l].length > 0 && (a = e[l][0], n[n.length] = vt("Override", null, {
      PartName: (a[0] == "/" ? "" : "/") + a,
      ContentType: cy[l][t.bookType] || cy[l].xlsx
    }));
  }, i = function(l) {
    (e[l] || []).forEach(function(c) {
      n[n.length] = vt("Override", null, {
        PartName: (c[0] == "/" ? "" : "/") + c,
        ContentType: cy[l][t.bookType] || cy[l].xlsx
      });
    });
  }, o = function(l) {
    (e[l] || []).forEach(function(c) {
      n[n.length] = vt("Override", null, {
        PartName: (c[0] == "/" ? "" : "/") + c,
        ContentType: r[l][0]
      });
    });
  };
  return s("workbooks"), i("sheets"), i("charts"), o("themes"), ["strs", "styles"].forEach(s), ["coreprops", "extprops", "custprops"].forEach(o), o("vba"), o("comments"), o("threadedcomments"), o("drawings"), i("metadata"), o("people"), n.length > 2 && (n[n.length] = "</Types>", n[1] = n[1].replace("/>", ">")), n.join("");
}
var Ar = {
  WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
  VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
  XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
  XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
  CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
  CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
  EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
  CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",
  SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
  STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
  THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
  WS: [
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
    "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
  ],
  DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
  XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
  TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
  PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
  VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
};
function T9(e) {
  var t = e.lastIndexOf("/");
  return e.slice(0, t + 1) + "_rels/" + e.slice(t + 1) + ".rels";
}
function zf(e) {
  var t = [ra, vt("Relationships", null, {
    //'xmlns:ns0': XMLNS.RELS,
    xmlns: pa.RELS
  })];
  return Ia(e["!id"]).forEach(function(r) {
    t[t.length] = vt("Relationship", null, e["!id"][r]);
  }), t.length > 2 && (t[t.length] = "</Relationships>", t[1] = t[1].replace("/>", ">")), t.join("");
}
function qr(e, t, r, n, a, s) {
  if (a || (a = {}), e["!id"] || (e["!id"] = {}), e["!idx"] || (e["!idx"] = 1), t < 0) for (t = e["!idx"]; e["!id"]["rId" + t]; ++t)
    ;
  if (e["!idx"] = t + 1, a.Id = "rId" + t, a.Type = n, a.Target = r, [Ar.HLINK, Ar.XPATH, Ar.XMISS].indexOf(a.Type) > -1 && (a.TargetMode = "External"), e["!id"][a.Id]) throw new Error("Cannot rewrite rId " + t);
  return e["!id"][a.Id] = a, e[("/" + a.Target).replace("//", "/")] = a, t;
}
function l7e(e) {
  var t = [ra];
  t.push(`<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">
`), t.push(`  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>
`);
  for (var r = 0; r < e.length; ++r) t.push('  <manifest:file-entry manifest:full-path="' + e[r][0] + '" manifest:media-type="' + e[r][1] + `"/>
`);
  return t.push("</manifest:manifest>"), t.join("");
}
function e4(e, t, r) {
  return [
    '  <rdf:Description rdf:about="' + e + `">
`,
    '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (r || "odf") + "#" + t + `"/>
`,
    `  </rdf:Description>
`
  ].join("");
}
function c7e(e, t) {
  return [
    '  <rdf:Description rdf:about="' + e + `">
`,
    '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + t + `"/>
`,
    `  </rdf:Description>
`
  ].join("");
}
function u7e(e) {
  var t = [ra];
  t.push(`<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
`);
  for (var r = 0; r != e.length; ++r)
    t.push(e4(e[r][0], e[r][1])), t.push(c7e("", e[r][0]));
  return t.push(e4("", "Document", "pkg")), t.push("</rdf:RDF>"), t.join("");
}
function C9() {
  return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + ew.version + "</meta:generator></office:meta></office:document-meta>";
}
var ju = [
  ["cp:category", "Category"],
  ["cp:contentStatus", "ContentStatus"],
  ["cp:keywords", "Keywords"],
  ["cp:lastModifiedBy", "LastAuthor"],
  ["cp:lastPrinted", "LastPrinted"],
  ["cp:revision", "RevNumber"],
  ["cp:version", "Version"],
  ["dc:creator", "Author"],
  ["dc:description", "Comments"],
  ["dc:identifier", "Identifier"],
  ["dc:language", "Language"],
  ["dc:subject", "Subject"],
  ["dc:title", "Title"],
  ["dcterms:created", "CreatedDate", "date"],
  ["dcterms:modified", "ModifiedDate", "date"]
];
function CS(e, t, r, n, a) {
  a[e] != null || t == null || t === "" || (a[e] = t, t = Jr(t), n[n.length] = r ? vt(e, t, r) : Aa(e, t));
}
function k9(e, t) {
  var r = t || {}, n = [ra, vt("cp:coreProperties", null, {
    //'xmlns': XMLNS.CORE_PROPS,
    "xmlns:cp": pa.CORE_PROPS,
    "xmlns:dc": pa.dc,
    "xmlns:dcterms": pa.dcterms,
    "xmlns:dcmitype": pa.dcmitype,
    "xmlns:xsi": pa.xsi
  })], a = {};
  if (!e && !r.Props) return n.join("");
  e && (e.CreatedDate != null && CS("dcterms:created", typeof e.CreatedDate == "string" ? e.CreatedDate : gT(e.CreatedDate, r.WTF), { "xsi:type": "dcterms:W3CDTF" }, n, a), e.ModifiedDate != null && CS("dcterms:modified", typeof e.ModifiedDate == "string" ? e.ModifiedDate : gT(e.ModifiedDate, r.WTF), { "xsi:type": "dcterms:W3CDTF" }, n, a));
  for (var s = 0; s != ju.length; ++s) {
    var i = ju[s], o = r.Props && r.Props[i[1]] != null ? r.Props[i[1]] : e ? e[i[1]] : null;
    o === !0 ? o = "1" : o === !1 ? o = "0" : typeof o == "number" && (o = String(o)), o != null && CS(i[0], o, null, n, a);
  }
  return n.length > 2 && (n[n.length] = "</cp:coreProperties>", n[1] = n[1].replace("/>", ">")), n.join("");
}
var Kf = [
  ["Application", "Application", "string"],
  ["AppVersion", "AppVersion", "string"],
  ["Company", "Company", "string"],
  ["DocSecurity", "DocSecurity", "string"],
  ["Manager", "Manager", "string"],
  ["HyperlinksChanged", "HyperlinksChanged", "bool"],
  ["SharedDoc", "SharedDoc", "bool"],
  ["LinksUpToDate", "LinksUpToDate", "bool"],
  ["ScaleCrop", "ScaleCrop", "bool"],
  ["HeadingPairs", "HeadingPairs", "raw"],
  ["TitlesOfParts", "TitlesOfParts", "raw"]
], O9 = [
  "Worksheets",
  "SheetNames",
  "NamedRanges",
  "DefinedNames",
  "Chartsheets",
  "ChartNames"
];
function A9(e) {
  var t = [], r = vt;
  return e || (e = {}), e.Application = "SheetJS", t[t.length] = ra, t[t.length] = vt("Properties", null, {
    xmlns: pa.EXT_PROPS,
    "xmlns:vt": pa.vt
  }), Kf.forEach(function(n) {
    if (e[n[1]] !== void 0) {
      var a;
      switch (n[2]) {
        case "string":
          a = Jr(String(e[n[1]]));
          break;
        case "bool":
          a = e[n[1]] ? "true" : "false";
          break;
      }
      a !== void 0 && (t[t.length] = r(n[0], a));
    }
  }), t[t.length] = r("HeadingPairs", r("vt:vector", r("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") + r("vt:variant", r("vt:i4", String(e.Worksheets))), { size: 2, baseType: "variant" })), t[t.length] = r("TitlesOfParts", r("vt:vector", e.SheetNames.map(function(n) {
    return "<vt:lpstr>" + Jr(n) + "</vt:lpstr>";
  }).join(""), { size: e.Worksheets, baseType: "lpstr" })), t.length > 2 && (t[t.length] = "</Properties>", t[1] = t[1].replace("/>", ">")), t.join("");
}
function P9(e) {
  var t = [ra, vt("Properties", null, {
    xmlns: pa.CUST_PROPS,
    "xmlns:vt": pa.vt
  })];
  if (!e) return t.join("");
  var r = 1;
  return Ia(e).forEach(function(a) {
    ++r, t[t.length] = vt("property", OHe(e[a]), {
      fmtid: "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
      pid: r,
      name: Jr(a)
    });
  }), t.length > 2 && (t[t.length] = "</Properties>", t[1] = t[1].replace("/>", ">")), t.join("");
}
var t4 = {
  Title: "Title",
  Subject: "Subject",
  Author: "Author",
  Keywords: "Keywords",
  Comments: "Description",
  LastAuthor: "LastAuthor",
  RevNumber: "Revision",
  Application: "AppName",
  /* TotalTime: 'TotalTime', */
  LastPrinted: "LastPrinted",
  CreatedDate: "Created",
  ModifiedDate: "LastSaved",
  /* Pages */
  /* Words */
  /* Characters */
  Category: "Category",
  /* PresentationFormat */
  Manager: "Manager",
  Company: "Company",
  /* Guid */
  /* HyperlinkBase */
  /* Bytes */
  /* Lines */
  /* Paragraphs */
  /* CharactersWithSpaces */
  AppVersion: "Version",
  ContentStatus: "ContentStatus",
  /* NOTE: missing from schema */
  Identifier: "Identifier",
  /* NOTE: missing from schema */
  Language: "Language"
  /* NOTE: missing from schema */
};
function d7e(e, t) {
  var r = [];
  return Ia(t4).map(function(n) {
    for (var a = 0; a < ju.length; ++a) if (ju[a][1] == n) return ju[a];
    for (a = 0; a < Kf.length; ++a) if (Kf[a][1] == n) return Kf[a];
    throw n;
  }).forEach(function(n) {
    if (e[n[1]] != null) {
      var a = t && t.Props && t.Props[n[1]] != null ? t.Props[n[1]] : e[n[1]];
      switch (n[2]) {
        case "date":
          a = new Date(a).toISOString().replace(/\.\d*Z/, "Z");
          break;
      }
      typeof a == "number" ? a = String(a) : a === !0 || a === !1 ? a = a ? "1" : "0" : a instanceof Date && (a = new Date(a).toISOString().replace(/\.\d*Z/, "")), r.push(Aa(t4[n[1]] || n[1], a));
    }
  }), vt("DocumentProperties", r.join(""), { xmlns: Us.o });
}
function f7e(e, t) {
  var r = ["Worksheets", "SheetNames"], n = "CustomDocumentProperties", a = [];
  return e && Ia(e).forEach(function(s) {
    if (Object.prototype.hasOwnProperty.call(e, s)) {
      for (var i = 0; i < ju.length; ++i) if (s == ju[i][1]) return;
      for (i = 0; i < Kf.length; ++i) if (s == Kf[i][1]) return;
      for (i = 0; i < r.length; ++i) if (s == r[i]) return;
      var o = e[s], l = "string";
      typeof o == "number" ? (l = "float", o = String(o)) : o === !0 || o === !1 ? (l = "boolean", o = o ? "1" : "0") : o = String(o), a.push(vt($j(s), o, { "dt:dt": l }));
    }
  }), t && Ia(t).forEach(function(s) {
    if (Object.prototype.hasOwnProperty.call(t, s) && !(e && Object.prototype.hasOwnProperty.call(e, s))) {
      var i = t[s], o = "string";
      typeof i == "number" ? (o = "float", i = String(i)) : i === !0 || i === !1 ? (o = "boolean", i = i ? "1" : "0") : i instanceof Date ? (o = "dateTime.tz", i = i.toISOString()) : i = String(i), a.push(vt($j(s), i, { "dt:dt": o }));
    }
  }), "<" + n + ' xmlns="' + Us.o + '">' + a.join("") + "</" + n + ">";
}
function h7e(e) {
  var t = typeof e == "string" ? new Date(Date.parse(e)) : e, r = t.getTime() / 1e3 + 11644473600, n = r % Math.pow(2, 32), a = (r - n) / Math.pow(2, 32);
  n *= 1e7, a *= 1e7;
  var s = n / Math.pow(2, 32) | 0;
  s > 0 && (n = n % Math.pow(2, 32), a += s);
  var i = Ke(8);
  return i.write_shift(4, n), i.write_shift(4, a), i;
}
function r4(e, t) {
  var r = Ke(4), n = Ke(4);
  switch (r.write_shift(4, e == 80 ? 31 : e), e) {
    case 3:
      n.write_shift(-4, t);
      break;
    case 5:
      n = Ke(8), n.write_shift(8, t, "f");
      break;
    case 11:
      n.write_shift(4, t ? 1 : 0);
      break;
    case 64:
      n = h7e(t);
      break;
    case 31:
    case 80:
      for (n = Ke(4 + 2 * (t.length + 1) + (t.length % 2 ? 0 : 2)), n.write_shift(4, t.length + 1), n.write_shift(0, t, "dbcs"); n.l != n.length; ) n.write_shift(1, 0);
      break;
    default:
      throw new Error("TypedPropertyValue unrecognized type " + e + " " + t);
  }
  return Oa([r, n]);
}
var R9 = ["CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID"];
function p7e(e) {
  switch (typeof e) {
    case "boolean":
      return 11;
    case "number":
      return (e | 0) == e ? 3 : 5;
    case "string":
      return 31;
    case "object":
      if (e instanceof Date) return 64;
      break;
  }
  return -1;
}
function n4(e, t, r) {
  var n = Ke(8), a = [], s = [], i = 8, o = 0, l = Ke(8), c = Ke(8);
  if (l.write_shift(4, 2), l.write_shift(4, 1200), c.write_shift(4, 1), s.push(l), a.push(c), i += 8 + l.length, !t) {
    c = Ke(8), c.write_shift(4, 0), a.unshift(c);
    var u = [Ke(4)];
    for (u[0].write_shift(4, e.length), o = 0; o < e.length; ++o) {
      var d = e[o][0];
      for (l = Ke(8 + 2 * (d.length + 1) + (d.length % 2 ? 0 : 2)), l.write_shift(4, o + 2), l.write_shift(4, d.length + 1), l.write_shift(0, d, "dbcs"); l.l != l.length; ) l.write_shift(1, 0);
      u.push(l);
    }
    l = Oa(u), s.unshift(l), i += 8 + l.length;
  }
  for (o = 0; o < e.length; ++o)
    if (!(t && !t[e[o][0]]) && !(R9.indexOf(e[o][0]) > -1 || O9.indexOf(e[o][0]) > -1) && e[o][1] != null) {
      var f = e[o][1], h = 0;
      if (t) {
        h = +t[e[o][0]];
        var p = r[h];
        if (p.p == "version" && typeof f == "string") {
          var m = f.split(".");
          f = (+m[0] << 16) + (+m[1] || 0);
        }
        l = r4(p.t, f);
      } else {
        var g = p7e(f);
        g == -1 && (g = 31, f = String(f)), l = r4(g, f);
      }
      s.push(l), c = Ke(8), c.write_shift(4, t ? h : 2 + o), a.push(c), i += 8 + l.length;
    }
  var y = 8 * (s.length + 1);
  for (o = 0; o < s.length; ++o)
    a[o].write_shift(4, y), y += s[o].length;
  return n.write_shift(4, i), n.write_shift(4, s.length), Oa([n].concat(a).concat(s));
}
function a4(e, t, r, n, a, s) {
  var i = Ke(a ? 68 : 48), o = [i];
  i.write_shift(2, 65534), i.write_shift(2, 0), i.write_shift(4, 842412599), i.write_shift(16, rn.utils.consts.HEADER_CLSID, "hex"), i.write_shift(4, a ? 2 : 1), i.write_shift(16, t, "hex"), i.write_shift(4, a ? 68 : 48);
  var l = n4(e, r, n);
  if (o.push(l), a) {
    var c = n4(a, null, null);
    i.write_shift(16, s, "hex"), i.write_shift(4, 68 + l.length), o.push(c);
  }
  return Oa(o);
}
function m7e(e, t) {
  t || (t = Ke(e));
  for (var r = 0; r < e; ++r) t.write_shift(1, 0);
  return t;
}
function g7e(e, t) {
  return e.read_shift(t) === 1;
}
function cs(e, t) {
  return t || (t = Ke(2)), t.write_shift(2, +!!e), t;
}
function I9(e) {
  return e.read_shift(2, "u");
}
function ai(e, t) {
  return t || (t = Ke(2)), t.write_shift(2, e), t;
}
function D9(e, t, r) {
  return r || (r = Ke(2)), r.write_shift(1, t == "e" ? +e : +!!e), r.write_shift(1, t == "e" ? 1 : 0), r;
}
function N9(e, t, r) {
  var n = e.read_shift(r && r.biff >= 12 ? 2 : 1), a = "sbcs-cont";
  if (r && r.biff >= 8, !r || r.biff == 8) {
    var s = e.read_shift(1);
    s && (a = "dbcs-cont");
  } else r.biff == 12 && (a = "wstr");
  r.biff >= 2 && r.biff <= 5 && (a = "cpstr");
  var i = n ? e.read_shift(n, a) : "";
  return i;
}
function v7e(e) {
  var t = e.t || "", r = Ke(3);
  r.write_shift(2, t.length), r.write_shift(1, 1);
  var n = Ke(2 * t.length);
  n.write_shift(2 * t.length, t, "utf16le");
  var a = [r, n];
  return Oa(a);
}
function y7e(e, t, r) {
  var n;
  if (r) {
    if (r.biff >= 2 && r.biff <= 5) return e.read_shift(t, "cpstr");
    if (r.biff >= 12) return e.read_shift(t, "dbcs-cont");
  }
  var a = e.read_shift(1);
  return a === 0 ? n = e.read_shift(t, "sbcs-cont") : n = e.read_shift(t, "dbcs-cont"), n;
}
function b7e(e, t, r) {
  var n = e.read_shift(r && r.biff == 2 ? 1 : 2);
  return n === 0 ? (e.l++, "") : y7e(e, n, r);
}
function w7e(e, t, r) {
  if (r.biff > 5) return b7e(e, t, r);
  var n = e.read_shift(1);
  return n === 0 ? (e.l++, "") : e.read_shift(n, r.biff <= 4 || !e.lens ? "cpstr" : "sbcs-cont");
}
function M9(e, t, r) {
  return r || (r = Ke(3 + 2 * e.length)), r.write_shift(2, e.length), r.write_shift(1, 1), r.write_shift(31, e, "utf16le"), r;
}
function s4(e, t) {
  t || (t = Ke(6 + e.length * 2)), t.write_shift(4, 1 + e.length);
  for (var r = 0; r < e.length; ++r) t.write_shift(2, e.charCodeAt(r));
  return t.write_shift(2, 0), t;
}
function x7e(e) {
  var t = Ke(512), r = 0, n = e.Target;
  n.slice(0, 7) == "file://" && (n = n.slice(7));
  var a = n.indexOf("#"), s = a > -1 ? 31 : 23;
  switch (n.charAt(0)) {
    case "#":
      s = 28;
      break;
    case ".":
      s &= -3;
      break;
  }
  t.write_shift(4, 2), t.write_shift(4, s);
  var i = [8, 6815827, 6619237, 4849780, 83];
  for (r = 0; r < i.length; ++r) t.write_shift(4, i[r]);
  if (s == 28)
    n = n.slice(1), s4(n, t);
  else if (s & 2) {
    for (i = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "), r = 0; r < i.length; ++r) t.write_shift(1, parseInt(i[r], 16));
    var o = a > -1 ? n.slice(0, a) : n;
    for (t.write_shift(4, 2 * (o.length + 1)), r = 0; r < o.length; ++r) t.write_shift(2, o.charCodeAt(r));
    t.write_shift(2, 0), s & 8 && s4(a > -1 ? n.slice(a + 1) : "", t);
  } else {
    for (i = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" "), r = 0; r < i.length; ++r) t.write_shift(1, parseInt(i[r], 16));
    for (var l = 0; n.slice(l * 3, l * 3 + 3) == "../" || n.slice(l * 3, l * 3 + 3) == "..\\"; ) ++l;
    for (t.write_shift(2, l), t.write_shift(4, n.length - 3 * l + 1), r = 0; r < n.length - 3 * l; ++r) t.write_shift(1, n.charCodeAt(r + 3 * l) & 255);
    for (t.write_shift(1, 0), t.write_shift(2, 65535), t.write_shift(2, 57005), r = 0; r < 6; ++r) t.write_shift(4, 0);
  }
  return t.slice(0, t.l);
}
function Ju(e, t, r, n) {
  return n || (n = Ke(6)), n.write_shift(2, e), n.write_shift(2, t), n.write_shift(2, r || 0), n;
}
function _7e(e, t, r) {
  var n = r.biff > 8 ? 4 : 2, a = e.read_shift(n), s = e.read_shift(n, "i"), i = e.read_shift(n, "i");
  return [a, s, i];
}
function S7e(e) {
  var t = e.read_shift(2), r = e.read_shift(2), n = e.read_shift(2), a = e.read_shift(2);
  return { s: { c: n, r: t }, e: { c: a, r } };
}
function L9(e, t) {
  return t || (t = Ke(8)), t.write_shift(2, e.s.r), t.write_shift(2, e.e.r), t.write_shift(2, e.s.c), t.write_shift(2, e.e.c), t;
}
function G2(e, t, r) {
  var n = 1536, a = 16;
  switch (r.bookType) {
    case "biff8":
      break;
    case "biff5":
      n = 1280, a = 8;
      break;
    case "biff4":
      n = 4, a = 6;
      break;
    case "biff3":
      n = 3, a = 6;
      break;
    case "biff2":
      n = 2, a = 4;
      break;
    case "xla":
      break;
    default:
      throw new Error("unsupported BIFF version");
  }
  var s = Ke(a);
  return s.write_shift(2, n), s.write_shift(2, t), a > 4 && s.write_shift(2, 29282), a > 6 && s.write_shift(2, 1997), a > 8 && (s.write_shift(2, 49161), s.write_shift(2, 1), s.write_shift(2, 1798), s.write_shift(2, 0)), s;
}
function E7e(e, t) {
  var r = !t || t.biff == 8, n = Ke(r ? 112 : 54);
  for (n.write_shift(t.biff == 8 ? 2 : 1, 7), r && n.write_shift(1, 0), n.write_shift(4, 859007059), n.write_shift(4, 5458548 | (r ? 0 : 536870912)); n.l < n.length; ) n.write_shift(1, r ? 0 : 32);
  return n;
}
function T7e(e, t) {
  var r = !t || t.biff >= 8 ? 2 : 1, n = Ke(8 + r * e.name.length);
  n.write_shift(4, e.pos), n.write_shift(1, e.hs || 0), n.write_shift(1, e.dt), n.write_shift(1, e.name.length), t.biff >= 8 && n.write_shift(1, 1), n.write_shift(r * e.name.length, e.name, t.biff < 8 ? "sbcs" : "utf16le");
  var a = n.slice(0, n.l);
  return a.l = n.l, a;
}
function C7e(e, t) {
  var r = Ke(8);
  r.write_shift(4, e.Count), r.write_shift(4, e.Unique);
  for (var n = [], a = 0; a < e.length; ++a) n[a] = v7e(e[a]);
  var s = Oa([r].concat(n));
  return s.parts = [r.length].concat(n.map(function(i) {
    return i.length;
  })), s;
}
function k7e() {
  var e = Ke(18);
  return e.write_shift(2, 0), e.write_shift(2, 0), e.write_shift(2, 29280), e.write_shift(2, 17600), e.write_shift(2, 56), e.write_shift(2, 0), e.write_shift(2, 0), e.write_shift(2, 1), e.write_shift(2, 500), e;
}
function O7e(e) {
  var t = Ke(18), r = 1718;
  return e && e.RTL && (r |= 64), t.write_shift(2, r), t.write_shift(4, 0), t.write_shift(4, 64), t.write_shift(4, 0), t.write_shift(4, 0), t;
}
function A7e(e, t) {
  var r = e.name || "Arial", n = t && t.biff == 5, a = n ? 15 + r.length : 16 + 2 * r.length, s = Ke(a);
  return s.write_shift(2, e.sz * 20), s.write_shift(4, 0), s.write_shift(2, 400), s.write_shift(4, 0), s.write_shift(2, 0), s.write_shift(1, r.length), n || s.write_shift(1, 1), s.write_shift((n ? 1 : 2) * r.length, r, n ? "sbcs" : "utf16le"), s;
}
function P7e(e, t, r, n) {
  var a = Ke(10);
  return Ju(e, t, n, a), a.write_shift(4, r), a;
}
function R7e(e, t, r, n, a) {
  var s = !a || a.biff == 8, i = Ke(8 + +s + (1 + s) * r.length);
  return Ju(e, t, n, i), i.write_shift(2, r.length), s && i.write_shift(1, 1), i.write_shift((1 + s) * r.length, r, s ? "utf16le" : "sbcs"), i;
}
function I7e(e, t, r, n) {
  var a = r && r.biff == 5;
  n || (n = Ke(a ? 3 + t.length : 5 + 2 * t.length)), n.write_shift(2, e), n.write_shift(a ? 1 : 2, t.length), a || n.write_shift(1, 1), n.write_shift((a ? 1 : 2) * t.length, t, a ? "sbcs" : "utf16le");
  var s = n.length > n.l ? n.slice(0, n.l) : n;
  return s.l == null && (s.l = s.length), s;
}
function D7e(e, t) {
  var r = t.biff == 8 || !t.biff ? 4 : 2, n = Ke(2 * r + 6);
  return n.write_shift(r, e.s.r), n.write_shift(r, e.e.r + 1), n.write_shift(2, e.s.c), n.write_shift(2, e.e.c + 1), n.write_shift(2, 0), n;
}
function i4(e, t, r, n) {
  var a = r && r.biff == 5;
  n || (n = Ke(a ? 16 : 20)), n.write_shift(2, 0), e.style ? (n.write_shift(2, e.numFmtId || 0), n.write_shift(2, 65524)) : (n.write_shift(2, e.numFmtId || 0), n.write_shift(2, t << 4));
  var s = 0;
  return e.numFmtId > 0 && a && (s |= 1024), n.write_shift(4, s), n.write_shift(4, 0), a || n.write_shift(4, 0), n.write_shift(2, 0), n;
}
function N7e(e) {
  var t = Ke(8);
  return t.write_shift(4, 0), t.write_shift(2, 0), t.write_shift(2, 0), t;
}
function M7e(e, t, r, n, a, s) {
  var i = Ke(8);
  return Ju(e, t, n, i), D9(r, s, i), i;
}
function L7e(e, t, r, n) {
  var a = Ke(14);
  return Ju(e, t, n, a), Qu(r, a), a;
}
function j7e(e, t, r) {
  if (r.biff < 8) return F7e(e, t, r);
  for (var n = [], a = e.l + t, s = e.read_shift(r.biff > 8 ? 4 : 2); s-- !== 0; ) n.push(_7e(e, r.biff > 8 ? 12 : 6, r));
  if (e.l != a) throw new Error("Bad ExternSheet: " + e.l + " != " + a);
  return n;
}
function F7e(e, t, r) {
  e[e.l + 1] == 3 && e[e.l]++;
  var n = N9(e, t, r);
  return n.charCodeAt(0) == 3 ? n.slice(1) : n;
}
function B7e(e) {
  var t = Ke(2 + e.length * 8);
  t.write_shift(2, e.length);
  for (var r = 0; r < e.length; ++r) L9(e[r], t);
  return t;
}
function U7e(e) {
  var t = Ke(24), r = ma(e[0]);
  t.write_shift(2, r.r), t.write_shift(2, r.r), t.write_shift(2, r.c), t.write_shift(2, r.c);
  for (var n = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "), a = 0; a < 16; ++a) t.write_shift(1, parseInt(n[a], 16));
  return Oa([t, x7e(e[1])]);
}
function V7e(e) {
  var t = e[1].Tooltip, r = Ke(10 + 2 * (t.length + 1));
  r.write_shift(2, 2048);
  var n = ma(e[0]);
  r.write_shift(2, n.r), r.write_shift(2, n.r), r.write_shift(2, n.c), r.write_shift(2, n.c);
  for (var a = 0; a < t.length; ++a) r.write_shift(2, t.charCodeAt(a));
  return r.write_shift(2, 0), r;
}
function $7e(e) {
  return e || (e = Ke(4)), e.write_shift(2, 1), e.write_shift(2, 1), e;
}
function H7e(e, t, r) {
  if (!r.cellStyles) return Vo(e, t);
  var n = r && r.biff >= 12 ? 4 : 2, a = e.read_shift(n), s = e.read_shift(n), i = e.read_shift(n), o = e.read_shift(n), l = e.read_shift(2);
  n == 2 && (e.l += 2);
  var c = { s: a, e: s, w: i, ixfe: o, flags: l };
  return (r.biff >= 5 || !r.biff) && (c.level = l >> 8 & 7), c;
}
function W7e(e, t) {
  var r = Ke(12);
  r.write_shift(2, t), r.write_shift(2, t), r.write_shift(2, e.width * 256), r.write_shift(2, 0);
  var n = 0;
  return e.hidden && (n |= 1), r.write_shift(1, n), n = e.level || 0, r.write_shift(1, n), r.write_shift(2, 0), r;
}
function z7e(e) {
  for (var t = Ke(2 * e), r = 0; r < e; ++r) t.write_shift(2, r + 1);
  return t;
}
function K7e(e, t, r) {
  var n = Ke(15);
  return Ev(n, e, t), n.write_shift(8, r, "f"), n;
}
function q7e(e, t, r) {
  var n = Ke(9);
  return Ev(n, e, t), n.write_shift(2, r), n;
}
var G7e = /* @__PURE__ */ function() {
  var e = {
    /* Code Pages Supported by Visual FoxPro */
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /* shapefile DBF extension */
    /*::[*/
    0: 20127,
    /*::[*/
    8: 865,
    /*::[*/
    9: 437,
    /*::[*/
    10: 850,
    /*::[*/
    11: 437,
    /*::[*/
    13: 437,
    /*::[*/
    14: 850,
    /*::[*/
    15: 437,
    /*::[*/
    16: 850,
    /*::[*/
    17: 437,
    /*::[*/
    18: 850,
    /*::[*/
    19: 932,
    /*::[*/
    20: 850,
    /*::[*/
    21: 437,
    /*::[*/
    22: 850,
    /*::[*/
    23: 865,
    /*::[*/
    24: 437,
    /*::[*/
    25: 437,
    /*::[*/
    26: 850,
    /*::[*/
    27: 437,
    /*::[*/
    28: 863,
    /*::[*/
    29: 850,
    /*::[*/
    31: 852,
    /*::[*/
    34: 852,
    /*::[*/
    35: 852,
    /*::[*/
    36: 860,
    /*::[*/
    37: 850,
    /*::[*/
    38: 866,
    /*::[*/
    55: 850,
    /*::[*/
    64: 852,
    /*::[*/
    77: 936,
    /*::[*/
    78: 949,
    /*::[*/
    79: 950,
    /*::[*/
    80: 874,
    /*::[*/
    87: 1252,
    /*::[*/
    88: 1252,
    /*::[*/
    89: 1252,
    /*::[*/
    108: 863,
    /*::[*/
    134: 737,
    /*::[*/
    135: 852,
    /*::[*/
    136: 857,
    /*::[*/
    204: 1257,
    /*::[*/
    255: 16969
  }, t = j2({
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /*::[*/
    0: 20127
  });
  function r(o, l) {
    var c = [], u = Xu(1);
    switch (l.type) {
      case "base64":
        u = Ri(Bl(o));
        break;
      case "binary":
        u = Ri(o);
        break;
      case "buffer":
      case "array":
        u = o;
        break;
    }
    Fs(u, 0);
    var d = u.read_shift(1), f = !!(d & 136), h = !1, p = !1;
    switch (d) {
      case 2:
        break;
      case 3:
        break;
      case 48:
        h = !0, f = !0;
        break;
      case 49:
        h = !0, f = !0;
        break;
      case 131:
        break;
      case 139:
        break;
      case 140:
        p = !0;
        break;
      case 245:
        break;
      default:
        throw new Error("DBF Unsupported Version: " + d.toString(16));
    }
    var m = 0, g = 521;
    d == 2 && (m = u.read_shift(2)), u.l += 3, d != 2 && (m = u.read_shift(4)), m > 1048576 && (m = 1e6), d != 2 && (g = u.read_shift(2));
    var y = u.read_shift(2), x = l.codepage || 1252;
    d != 2 && (u.l += 16, u.read_shift(1), u[u.l] !== 0 && (x = e[u[u.l]]), u.l += 1, u.l += 2), p && (u.l += 36);
    for (var w = [], _ = {}, S = Math.min(u.length, d == 2 ? 521 : g - 10 - (h ? 264 : 0)), C = p ? 32 : 11; u.l < S && u[u.l] != 13; )
      switch (_ = {}, _.name = Pj.utils.decode(x, u.slice(u.l, u.l + C)).replace(/[\u0000\r\n].*$/g, ""), u.l += C, _.type = String.fromCharCode(u.read_shift(1)), d != 2 && !p && (_.offset = u.read_shift(4)), _.len = u.read_shift(1), d == 2 && (_.offset = u.read_shift(2)), _.dec = u.read_shift(1), _.name.length && w.push(_), d != 2 && (u.l += p ? 13 : 14), _.type) {
        case "B":
          (!h || _.len != 8) && l.WTF && console.log("Skipping " + _.name + ":" + _.type);
          break;
        case "G":
        case "P":
          l.WTF && console.log("Skipping " + _.name + ":" + _.type);
          break;
        case "+":
        case "0":
        case "@":
        case "C":
        case "D":
        case "F":
        case "I":
        case "L":
        case "M":
        case "N":
        case "O":
        case "T":
        case "Y":
          break;
        default:
          throw new Error("Unknown Field Type: " + _.type);
      }
    if (u[u.l] !== 13 && (u.l = g - 1), u.read_shift(1) !== 13) throw new Error("DBF Terminator not found " + u.l + " " + u[u.l]);
    u.l = g;
    var E = 0, O = 0;
    for (c[0] = [], O = 0; O != w.length; ++O) c[0][O] = w[O].name;
    for (; m-- > 0; ) {
      if (u[u.l] === 42) {
        u.l += y;
        continue;
      }
      for (++u.l, c[++E] = [], O = 0, O = 0; O != w.length; ++O) {
        var k = u.slice(u.l, u.l + w[O].len);
        u.l += w[O].len, Fs(k, 0);
        var A = Pj.utils.decode(x, k);
        switch (w[O].type) {
          case "C":
            A.trim().length && (c[E][O] = A.replace(/\s+$/, ""));
            break;
          case "D":
            A.length === 8 ? c[E][O] = new Date(+A.slice(0, 4), +A.slice(4, 6) - 1, +A.slice(6, 8)) : c[E][O] = A;
            break;
          case "F":
            c[E][O] = parseFloat(A.trim());
            break;
          case "+":
          case "I":
            c[E][O] = p ? k.read_shift(-4, "i") ^ 2147483648 : k.read_shift(4, "i");
            break;
          case "L":
            switch (A.trim().toUpperCase()) {
              case "Y":
              case "T":
                c[E][O] = !0;
                break;
              case "N":
              case "F":
                c[E][O] = !1;
                break;
              case "":
              case "?":
                break;
              default:
                throw new Error("DBF Unrecognized L:|" + A + "|");
            }
            break;
          case "M":
            if (!f) throw new Error("DBF Unexpected MEMO for type " + d.toString(16));
            c[E][O] = "##MEMO##" + (p ? parseInt(A.trim(), 10) : k.read_shift(4));
            break;
          case "N":
            A = A.replace(/\u0000/g, "").trim(), A && A != "." && (c[E][O] = +A || 0);
            break;
          case "@":
            c[E][O] = new Date(k.read_shift(-8, "f") - 621356832e5);
            break;
          case "T":
            c[E][O] = new Date((k.read_shift(4) - 2440588) * 864e5 + k.read_shift(4));
            break;
          case "Y":
            c[E][O] = k.read_shift(4, "i") / 1e4 + k.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
            break;
          case "O":
            c[E][O] = -k.read_shift(-8, "f");
            break;
          case "B":
            if (h && w[O].len == 8) {
              c[E][O] = k.read_shift(8, "f");
              break;
            }
          case "G":
          case "P":
            k.l += w[O].len;
            break;
          case "0":
            if (w[O].name === "_NullFlags") break;
          default:
            throw new Error("DBF Unsupported data type " + w[O].type);
        }
      }
    }
    if (d != 2 && u.l < u.length && u[u.l++] != 26)
      throw new Error("DBF EOF Marker missing " + (u.l - 1) + " of " + u.length + " " + u[u.l - 1].toString(16));
    return l && l.sheetRows && (c = c.slice(0, l.sheetRows)), l.DBF = w, c;
  }
  function n(o, l) {
    var c = l || {};
    c.dateNF || (c.dateNF = "yyyymmdd");
    var u = Yh(r(o, c), c);
    return u["!cols"] = c.DBF.map(function(d) {
      return {
        wch: d.len,
        DBF: d
      };
    }), delete c.DBF, u;
  }
  function a(o, l) {
    try {
      return _d(n(o, l), l);
    } catch (c) {
      if (l && l.WTF) throw c;
    }
    return { SheetNames: [], Sheets: {} };
  }
  var s = { B: 8, C: 250, L: 1, D: 8, "?": 0, "": 0 };
  function i(o, l) {
    var c = l || {};
    if (+c.codepage >= 0 && hg(+c.codepage), c.type == "string") throw new Error("Cannot write DBF to JS string");
    var u = xs(), d = hw(o, { header: 1, raw: !0, cellDates: !0 }), f = d[0], h = d.slice(1), p = o["!cols"] || [], m = 0, g = 0, y = 0, x = 1;
    for (m = 0; m < f.length; ++m) {
      if (((p[m] || {}).DBF || {}).name) {
        f[m] = p[m].DBF.name, ++y;
        continue;
      }
      if (f[m] != null) {
        if (++y, typeof f[m] == "number" && (f[m] = f[m].toString(10)), typeof f[m] != "string") throw new Error("DBF Invalid column name " + f[m] + " |" + typeof f[m] + "|");
        if (f.indexOf(f[m]) !== m) {
          for (g = 0; g < 1024; ++g)
            if (f.indexOf(f[m] + "_" + g) == -1) {
              f[m] += "_" + g;
              break;
            }
        }
      }
    }
    var w = vn(o["!ref"]), _ = [], S = [], C = [];
    for (m = 0; m <= w.e.c - w.s.c; ++m) {
      var E = "", O = "", k = 0, A = [];
      for (g = 0; g < h.length; ++g)
        h[g][m] != null && A.push(h[g][m]);
      if (A.length == 0 || f[m] == null) {
        _[m] = "?";
        continue;
      }
      for (g = 0; g < A.length; ++g) {
        switch (typeof A[g]) {
          case "number":
            O = "B";
            break;
          case "string":
            O = "C";
            break;
          case "boolean":
            O = "L";
            break;
          case "object":
            O = A[g] instanceof Date ? "D" : "C";
            break;
          default:
            O = "C";
        }
        k = Math.max(k, String(A[g]).length), E = E && E != O ? "C" : O;
      }
      k > 250 && (k = 250), O = ((p[m] || {}).DBF || {}).type, O == "C" && p[m].DBF.len > k && (k = p[m].DBF.len), E == "B" && O == "N" && (E = "N", C[m] = p[m].DBF.dec, k = p[m].DBF.len), S[m] = E == "C" || O == "N" ? k : s[E] || 0, x += S[m], _[m] = E;
    }
    var P = u.next(32);
    for (P.write_shift(4, 318902576), P.write_shift(4, h.length), P.write_shift(2, 296 + 32 * y), P.write_shift(2, x), m = 0; m < 4; ++m) P.write_shift(4, 0);
    for (P.write_shift(4, 0 | (+t[
      /*::String(*/
      F7
      /*::)*/
    ] || 3) << 8), m = 0, g = 0; m < f.length; ++m)
      if (f[m] != null) {
        var D = u.next(32), N = (f[m].slice(-10) + "\0\0\0\0\0\0\0\0\0\0\0").slice(0, 11);
        D.write_shift(1, N, "sbcs"), D.write_shift(1, _[m] == "?" ? "C" : _[m], "sbcs"), D.write_shift(4, g), D.write_shift(1, S[m] || s[_[m]] || 0), D.write_shift(1, C[m] || 0), D.write_shift(1, 2), D.write_shift(4, 0), D.write_shift(1, 0), D.write_shift(4, 0), D.write_shift(4, 0), g += S[m] || s[_[m]] || 0;
      }
    var z = u.next(264);
    for (z.write_shift(4, 13), m = 0; m < 65; ++m) z.write_shift(4, 0);
    for (m = 0; m < h.length; ++m) {
      var G = u.next(x);
      for (G.write_shift(1, 0), g = 0; g < f.length; ++g)
        if (f[g] != null)
          switch (_[g]) {
            case "L":
              G.write_shift(1, h[m][g] == null ? 63 : h[m][g] ? 84 : 70);
              break;
            case "B":
              G.write_shift(8, h[m][g] || 0, "f");
              break;
            case "N":
              var Y = "0";
              for (typeof h[m][g] == "number" && (Y = h[m][g].toFixed(C[g] || 0)), y = 0; y < S[g] - Y.length; ++y) G.write_shift(1, 32);
              G.write_shift(1, Y, "sbcs");
              break;
            case "D":
              h[m][g] ? (G.write_shift(4, ("0000" + h[m][g].getFullYear()).slice(-4), "sbcs"), G.write_shift(2, ("00" + (h[m][g].getMonth() + 1)).slice(-2), "sbcs"), G.write_shift(2, ("00" + h[m][g].getDate()).slice(-2), "sbcs")) : G.write_shift(8, "00000000", "sbcs");
              break;
            case "C":
              var te = String(h[m][g] != null ? h[m][g] : "").slice(0, S[g]);
              for (G.write_shift(1, te, "sbcs"), y = 0; y < S[g] - te.length; ++y) G.write_shift(1, 32);
              break;
          }
    }
    return u.next(1).write_shift(1, 26), u.end();
  }
  return {
    to_workbook: a,
    to_sheet: n,
    from_sheet: i
  };
}(), Y7e = /* @__PURE__ */ function() {
  var e = {
    AA: "À",
    BA: "Á",
    CA: "Â",
    DA: 195,
    HA: "Ä",
    JA: 197,
    AE: "È",
    BE: "É",
    CE: "Ê",
    HE: "Ë",
    AI: "Ì",
    BI: "Í",
    CI: "Î",
    HI: "Ï",
    AO: "Ò",
    BO: "Ó",
    CO: "Ô",
    DO: 213,
    HO: "Ö",
    AU: "Ù",
    BU: "Ú",
    CU: "Û",
    HU: "Ü",
    Aa: "à",
    Ba: "á",
    Ca: "â",
    Da: 227,
    Ha: "ä",
    Ja: 229,
    Ae: "è",
    Be: "é",
    Ce: "ê",
    He: "ë",
    Ai: "ì",
    Bi: "í",
    Ci: "î",
    Hi: "ï",
    Ao: "ò",
    Bo: "ó",
    Co: "ô",
    Do: 245,
    Ho: "ö",
    Au: "ù",
    Bu: "ú",
    Cu: "û",
    Hu: "ü",
    KC: "Ç",
    Kc: "ç",
    q: "æ",
    z: "œ",
    a: "Æ",
    j: "Œ",
    DN: 209,
    Dn: 241,
    Hy: 255,
    S: 169,
    c: 170,
    R: 174,
    "B ": 180,
    /*::[*/
    0: 176,
    /*::[*/
    1: 177,
    /*::[*/
    2: 178,
    /*::[*/
    3: 179,
    /*::[*/
    5: 181,
    /*::[*/
    6: 182,
    /*::[*/
    7: 183,
    Q: 185,
    k: 186,
    b: 208,
    i: 216,
    l: 222,
    s: 240,
    y: 248,
    "!": 161,
    '"': 162,
    "#": 163,
    "(": 164,
    "%": 165,
    "'": 167,
    "H ": 168,
    "+": 171,
    ";": 187,
    "<": 188,
    "=": 189,
    ">": 190,
    "?": 191,
    "{": 223
  }, t = new RegExp("\x1BN(" + Ia(e).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm"), r = function(f, h) {
    var p = e[h];
    return typeof p == "number" ? Aj(p) : p;
  }, n = function(f, h, p) {
    var m = h.charCodeAt(0) - 32 << 4 | p.charCodeAt(0) - 48;
    return m == 59 ? f : Aj(m);
  };
  e["|"] = 254;
  function a(f, h) {
    switch (h.type) {
      case "base64":
        return s(Bl(f), h);
      case "binary":
        return s(f, h);
      case "buffer":
        return s(Mr && Buffer.isBuffer(f) ? f.toString("binary") : bv(f), h);
      case "array":
        return s(Qx(f), h);
    }
    throw new Error("Unrecognized type " + h.type);
  }
  function s(f, h) {
    var p = f.split(/[\n\r]+/), m = -1, g = -1, y = 0, x = 0, w = [], _ = [], S = null, C = {}, E = [], O = [], k = [], A = 0, P;
    for (+h.codepage >= 0 && hg(+h.codepage); y !== p.length; ++y) {
      A = 0;
      var D = p[y].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, n).replace(t, r), N = D.replace(/;;/g, "\0").split(";").map(function(j) {
        return j.replace(/\u0000/g, ";");
      }), z = N[0], G;
      if (D.length > 0) switch (z) {
        case "ID":
          break;
        case "E":
          break;
        case "B":
          break;
        case "O":
          break;
        case "W":
          break;
        case "P":
          N[1].charAt(0) == "P" && _.push(D.slice(3).replace(/;;/g, ";"));
          break;
        case "C":
          var Y = !1, te = !1, ae = !1, ne = !1, ue = -1, q = -1;
          for (x = 1; x < N.length; ++x) switch (N[x].charAt(0)) {
            case "A":
              break;
            case "X":
              g = parseInt(N[x].slice(1)) - 1, te = !0;
              break;
            case "Y":
              for (m = parseInt(N[x].slice(1)) - 1, te || (g = 0), P = w.length; P <= m; ++P) w[P] = [];
              break;
            case "K":
              G = N[x].slice(1), G.charAt(0) === '"' ? G = G.slice(1, G.length - 1) : G === "TRUE" ? G = !0 : G === "FALSE" ? G = !1 : isNaN(Nl(G)) ? isNaN(mg(G).getDate()) || (G = ds(G)) : (G = Nl(G), S !== null && X7(S) && (G = e9(G))), Y = !0;
              break;
            case "E":
              ne = !0;
              var U = q9e(N[x].slice(1), { r: m, c: g });
              w[m][g] = [w[m][g], U];
              break;
            case "S":
              ae = !0, w[m][g] = [w[m][g], "S5S"];
              break;
            case "G":
              break;
            case "R":
              ue = parseInt(N[x].slice(1)) - 1;
              break;
            case "C":
              q = parseInt(N[x].slice(1)) - 1;
              break;
            default:
              if (h && h.WTF) throw new Error("SYLK bad record " + D);
          }
          if (Y && (w[m][g] && w[m][g].length == 2 ? w[m][g][0] = G : w[m][g] = G, S = null), ae) {
            if (ne) throw new Error("SYLK shared formula cannot have own formula");
            var Q = ue > -1 && w[ue][q];
            if (!Q || !Q[1]) throw new Error("SYLK shared formula cannot find base");
            w[m][g][1] = G9e(Q[1], { r: m - ue, c: g - q });
          }
          break;
        case "F":
          var L = 0;
          for (x = 1; x < N.length; ++x) switch (N[x].charAt(0)) {
            case "X":
              g = parseInt(N[x].slice(1)) - 1, ++L;
              break;
            case "Y":
              for (m = parseInt(N[x].slice(1)) - 1, P = w.length; P <= m; ++P) w[P] = [];
              break;
            case "M":
              A = parseInt(N[x].slice(1)) / 20;
              break;
            case "F":
              break;
            case "G":
              break;
            case "P":
              S = _[parseInt(N[x].slice(1))];
              break;
            case "S":
              break;
            case "D":
              break;
            case "N":
              break;
            case "W":
              for (k = N[x].slice(1).split(" "), P = parseInt(k[0], 10); P <= parseInt(k[1], 10); ++P)
                A = parseInt(k[2], 10), O[P - 1] = A === 0 ? { hidden: !0 } : { wch: A }, Y2(O[P - 1]);
              break;
            case "C":
              g = parseInt(N[x].slice(1)) - 1, O[g] || (O[g] = {});
              break;
            case "R":
              m = parseInt(N[x].slice(1)) - 1, E[m] || (E[m] = {}), A > 0 ? (E[m].hpt = A, E[m].hpx = V9(A)) : A === 0 && (E[m].hidden = !0);
              break;
            default:
              if (h && h.WTF) throw new Error("SYLK bad record " + D);
          }
          L < 1 && (S = null);
          break;
        default:
          if (h && h.WTF) throw new Error("SYLK bad record " + D);
      }
    }
    return E.length > 0 && (C["!rows"] = E), O.length > 0 && (C["!cols"] = O), h && h.sheetRows && (w = w.slice(0, h.sheetRows)), [w, C];
  }
  function i(f, h) {
    var p = a(f, h), m = p[0], g = p[1], y = Yh(m, h);
    return Ia(g).forEach(function(x) {
      y[x] = g[x];
    }), y;
  }
  function o(f, h) {
    return _d(i(f, h), h);
  }
  function l(f, h, p, m) {
    var g = "C;Y" + (p + 1) + ";X" + (m + 1) + ";K";
    switch (f.t) {
      case "n":
        g += f.v || 0, f.f && !f.F && (g += ";E" + Q2(f.f, { r: p, c: m }));
        break;
      case "b":
        g += f.v ? "TRUE" : "FALSE";
        break;
      case "e":
        g += f.w || f.v;
        break;
      case "d":
        g += '"' + (f.w || f.v) + '"';
        break;
      case "s":
        g += '"' + f.v.replace(/"/g, "").replace(/;/g, ";;") + '"';
        break;
    }
    return g;
  }
  function c(f, h) {
    h.forEach(function(p, m) {
      var g = "F;W" + (m + 1) + " " + (m + 1) + " ";
      p.hidden ? g += "0" : (typeof p.width == "number" && !p.wpx && (p.wpx = cw(p.width)), typeof p.wpx == "number" && !p.wch && (p.wch = uw(p.wpx)), typeof p.wch == "number" && (g += Math.round(p.wch))), g.charAt(g.length - 1) != " " && f.push(g);
    });
  }
  function u(f, h) {
    h.forEach(function(p, m) {
      var g = "F;";
      p.hidden ? g += "M0;" : p.hpt ? g += "M" + 20 * p.hpt + ";" : p.hpx && (g += "M" + 20 * dw(p.hpx) + ";"), g.length > 2 && f.push(g + "R" + (m + 1));
    });
  }
  function d(f, h) {
    var p = ["ID;PWXL;N;E"], m = [], g = vn(f["!ref"]), y, x = Array.isArray(f), w = `\r
`;
    p.push("P;PGeneral"), p.push("F;P0;DG0G8;M255"), f["!cols"] && c(p, f["!cols"]), f["!rows"] && u(p, f["!rows"]), p.push("B;Y" + (g.e.r - g.s.r + 1) + ";X" + (g.e.c - g.s.c + 1) + ";D" + [g.s.c, g.s.r, g.e.c, g.e.r].join(" "));
    for (var _ = g.s.r; _ <= g.e.r; ++_)
      for (var S = g.s.c; S <= g.e.c; ++S) {
        var C = Zr({ r: _, c: S });
        y = x ? (f[_] || [])[S] : f[C], !(!y || y.v == null && (!y.f || y.F)) && m.push(l(y, f, _, S));
      }
    return p.join(w) + w + m.join(w) + w + "E" + w;
  }
  return {
    to_workbook: o,
    to_sheet: i,
    from_sheet: d
  };
}(), X7e = /* @__PURE__ */ function() {
  function e(s, i) {
    switch (i.type) {
      case "base64":
        return t(Bl(s), i);
      case "binary":
        return t(s, i);
      case "buffer":
        return t(Mr && Buffer.isBuffer(s) ? s.toString("binary") : bv(s), i);
      case "array":
        return t(Qx(s), i);
    }
    throw new Error("Unrecognized type " + i.type);
  }
  function t(s, i) {
    for (var o = s.split(`
`), l = -1, c = -1, u = 0, d = []; u !== o.length; ++u) {
      if (o[u].trim() === "BOT") {
        d[++l] = [], c = 0;
        continue;
      }
      if (!(l < 0)) {
        var f = o[u].trim().split(","), h = f[0], p = f[1];
        ++u;
        for (var m = o[u] || ""; (m.match(/["]/g) || []).length & 1 && u < o.length - 1; ) m += `
` + o[++u];
        switch (m = m.trim(), +h) {
          case -1:
            if (m === "BOT") {
              d[++l] = [], c = 0;
              continue;
            } else if (m !== "EOD") throw new Error("Unrecognized DIF special command " + m);
            break;
          case 0:
            m === "TRUE" ? d[l][c] = !0 : m === "FALSE" ? d[l][c] = !1 : isNaN(Nl(p)) ? isNaN(mg(p).getDate()) ? d[l][c] = p : d[l][c] = ds(p) : d[l][c] = Nl(p), ++c;
            break;
          case 1:
            m = m.slice(1, m.length - 1), m = m.replace(/""/g, '"'), m && m.match(/^=".*"$/) && (m = m.slice(2, -1)), d[l][c++] = m !== "" ? m : null;
            break;
        }
        if (m === "EOD") break;
      }
    }
    return i && i.sheetRows && (d = d.slice(0, i.sheetRows)), d;
  }
  function r(s, i) {
    return Yh(e(s, i), i);
  }
  function n(s, i) {
    return _d(r(s, i), i);
  }
  var a = /* @__PURE__ */ function() {
    var s = function(l, c, u, d, f) {
      l.push(c), l.push(u + "," + d), l.push('"' + f.replace(/"/g, '""') + '"');
    }, i = function(l, c, u, d) {
      l.push(c + "," + u), l.push(c == 1 ? '"' + d.replace(/"/g, '""') + '"' : d);
    };
    return function(l) {
      var c = [], u = vn(l["!ref"]), d, f = Array.isArray(l);
      s(c, "TABLE", 0, 1, "sheetjs"), s(c, "VECTORS", 0, u.e.r - u.s.r + 1, ""), s(c, "TUPLES", 0, u.e.c - u.s.c + 1, ""), s(c, "DATA", 0, 0, "");
      for (var h = u.s.r; h <= u.e.r; ++h) {
        i(c, -1, 0, "BOT");
        for (var p = u.s.c; p <= u.e.c; ++p) {
          var m = Zr({ r: h, c: p });
          if (d = f ? (l[h] || [])[p] : l[m], !d) {
            i(c, 1, 0, "");
            continue;
          }
          switch (d.t) {
            case "n":
              var g = d.w;
              !g && d.v != null && (g = d.v), g == null ? d.f && !d.F ? i(c, 1, 0, "=" + d.f) : i(c, 1, 0, "") : i(c, 0, g, "V");
              break;
            case "b":
              i(c, 0, d.v ? 1 : 0, d.v ? "TRUE" : "FALSE");
              break;
            case "s":
              i(c, 1, 0, isNaN(d.v) ? d.v : '="' + d.v + '"');
              break;
            case "d":
              d.w || (d.w = Bc(d.z || Rn[14], _s(ds(d.v)))), i(c, 0, d.w, "V");
              break;
            default:
              i(c, 1, 0, "");
          }
        }
      }
      i(c, -1, 0, "EOD");
      var y = `\r
`, x = c.join(y);
      return x;
    };
  }();
  return {
    to_workbook: n,
    to_sheet: r,
    from_sheet: a
  };
}(), j9 = /* @__PURE__ */ function() {
  function e(d) {
    return d.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, `
`);
  }
  function t(d) {
    return d.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
  }
  function r(d, f) {
    for (var h = d.split(`
`), p = -1, m = -1, g = 0, y = []; g !== h.length; ++g) {
      var x = h[g].trim().split(":");
      if (x[0] === "cell") {
        var w = ma(x[1]);
        if (y.length <= w.r)
          for (p = y.length; p <= w.r; ++p) y[p] || (y[p] = []);
        switch (p = w.r, m = w.c, x[2]) {
          case "t":
            y[p][m] = e(x[3]);
            break;
          case "v":
            y[p][m] = +x[3];
            break;
          case "vtf":
            var _ = x[x.length - 1];
          case "vtc":
            switch (x[3]) {
              case "nl":
                y[p][m] = !!+x[4];
                break;
              default:
                y[p][m] = +x[4];
                break;
            }
            x[2] == "vtf" && (y[p][m] = [y[p][m], _]);
        }
      }
    }
    return f && f.sheetRows && (y = y.slice(0, f.sheetRows)), y;
  }
  function n(d, f) {
    return Yh(r(d, f), f);
  }
  function a(d, f) {
    return _d(n(d, f), f);
  }
  var s = [
    "socialcalc:version:1.5",
    "MIME-Version: 1.0",
    "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
  ].join(`
`), i = [
    "--SocialCalcSpreadsheetControlSave",
    "Content-type: text/plain; charset=UTF-8"
  ].join(`
`) + `
`, o = [
    "# SocialCalc Spreadsheet Control Save",
    "part:sheet"
  ].join(`
`), l = "--SocialCalcSpreadsheetControlSave--";
  function c(d) {
    if (!d || !d["!ref"]) return "";
    for (var f = [], h = [], p, m = "", g = qs(d["!ref"]), y = Array.isArray(d), x = g.s.r; x <= g.e.r; ++x)
      for (var w = g.s.c; w <= g.e.c; ++w)
        if (m = Zr({ r: x, c: w }), p = y ? (d[x] || [])[w] : d[m], !(!p || p.v == null || p.t === "z")) {
          switch (h = ["cell", m, "t"], p.t) {
            case "s":
            case "str":
              h.push(t(p.v));
              break;
            case "n":
              p.f ? (h[2] = "vtf", h[3] = "n", h[4] = p.v, h[5] = t(p.f)) : (h[2] = "v", h[3] = p.v);
              break;
            case "b":
              h[2] = "vt" + (p.f ? "f" : "c"), h[3] = "nl", h[4] = p.v ? "1" : "0", h[5] = t(p.f || (p.v ? "TRUE" : "FALSE"));
              break;
            case "d":
              var _ = _s(ds(p.v));
              h[2] = "vtc", h[3] = "nd", h[4] = "" + _, h[5] = p.w || Bc(p.z || Rn[14], _);
              break;
            case "e":
              continue;
          }
          f.push(h.join(":"));
        }
    return f.push("sheet:c:" + (g.e.c - g.s.c + 1) + ":r:" + (g.e.r - g.s.r + 1) + ":tvf:1"), f.push("valueformat:1:text-wiki"), f.join(`
`);
  }
  function u(d) {
    return [s, i, o, i, c(d), l].join(`
`);
  }
  return {
    to_workbook: a,
    to_sheet: n,
    from_sheet: u
  };
}(), Q7e = /* @__PURE__ */ function() {
  function e(u, d, f, h, p) {
    p.raw ? d[f][h] = u : u === "" || (u === "TRUE" ? d[f][h] = !0 : u === "FALSE" ? d[f][h] = !1 : isNaN(Nl(u)) ? isNaN(mg(u).getDate()) ? d[f][h] = u : d[f][h] = ds(u) : d[f][h] = Nl(u));
  }
  function t(u, d) {
    var f = d || {}, h = [];
    if (!u || u.length === 0) return h;
    for (var p = u.split(/[\r\n]/), m = p.length - 1; m >= 0 && p[m].length === 0; ) --m;
    for (var g = 10, y = 0, x = 0; x <= m; ++x)
      y = p[x].indexOf(" "), y == -1 ? y = p[x].length : y++, g = Math.max(g, y);
    for (x = 0; x <= m; ++x) {
      h[x] = [];
      var w = 0;
      for (e(p[x].slice(0, g).trim(), h, x, w, f), w = 1; w <= (p[x].length - g) / 10 + 1; ++w)
        e(p[x].slice(g + (w - 1) * 10, g + w * 10).trim(), h, x, w, f);
    }
    return f.sheetRows && (h = h.slice(0, f.sheetRows)), h;
  }
  var r = {
    /*::[*/
    44: ",",
    /*::[*/
    9: "	",
    /*::[*/
    59: ";",
    /*::[*/
    124: "|"
  }, n = {
    /*::[*/
    44: 3,
    /*::[*/
    9: 2,
    /*::[*/
    59: 1,
    /*::[*/
    124: 0
  };
  function a(u) {
    for (var d = {}, f = !1, h = 0, p = 0; h < u.length; ++h)
      (p = u.charCodeAt(h)) == 34 ? f = !f : !f && p in r && (d[p] = (d[p] || 0) + 1);
    p = [];
    for (h in d) Object.prototype.hasOwnProperty.call(d, h) && p.push([d[h], h]);
    if (!p.length) {
      d = n;
      for (h in d) Object.prototype.hasOwnProperty.call(d, h) && p.push([d[h], h]);
    }
    return p.sort(function(m, g) {
      return m[0] - g[0] || n[m[1]] - n[g[1]];
    }), r[p.pop()[1]] || 44;
  }
  function s(u, d) {
    var f = d || {}, h = "", p = f.dense ? [] : {}, m = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    u.slice(0, 4) == "sep=" ? u.charCodeAt(5) == 13 && u.charCodeAt(6) == 10 ? (h = u.charAt(4), u = u.slice(7)) : u.charCodeAt(5) == 13 || u.charCodeAt(5) == 10 ? (h = u.charAt(4), u = u.slice(6)) : h = a(u.slice(0, 1024)) : f && f.FS ? h = f.FS : h = a(u.slice(0, 1024));
    var g = 0, y = 0, x = 0, w = 0, _ = 0, S = h.charCodeAt(0), C = !1, E = 0, O = u.charCodeAt(0);
    u = u.replace(/\r\n/mg, `
`);
    var k = f.dateNF != null ? hHe(f.dateNF) : null;
    function A() {
      var P = u.slice(w, _), D = {};
      if (P.charAt(0) == '"' && P.charAt(P.length - 1) == '"' && (P = P.slice(1, -1).replace(/""/g, '"')), P.length === 0) D.t = "z";
      else if (f.raw)
        D.t = "s", D.v = P;
      else if (P.trim().length === 0)
        D.t = "s", D.v = P;
      else if (P.charCodeAt(0) == 61)
        P.charCodeAt(1) == 34 && P.charCodeAt(P.length - 1) == 34 ? (D.t = "s", D.v = P.slice(2, -1).replace(/""/g, '"')) : Y9e(P) ? (D.t = "n", D.f = P.slice(1)) : (D.t = "s", D.v = P);
      else if (P == "TRUE")
        D.t = "b", D.v = !0;
      else if (P == "FALSE")
        D.t = "b", D.v = !1;
      else if (!isNaN(x = Nl(P)))
        D.t = "n", f.cellText !== !1 && (D.w = P), D.v = x;
      else if (!isNaN(mg(P).getDate()) || k && P.match(k)) {
        D.z = f.dateNF || Rn[14];
        var N = 0;
        k && P.match(k) && (P = pHe(P, f.dateNF, P.match(k) || []), N = 1), f.cellDates ? (D.t = "d", D.v = ds(P, N)) : (D.t = "n", D.v = _s(ds(P, N))), f.cellText !== !1 && (D.w = Bc(D.z, D.v instanceof Date ? _s(D.v) : D.v)), f.cellNF || delete D.z;
      } else
        D.t = "s", D.v = P;
      if (D.t == "z" || (f.dense ? (p[g] || (p[g] = []), p[g][y] = D) : p[Zr({ c: y, r: g })] = D), w = _ + 1, O = u.charCodeAt(w), m.e.c < y && (m.e.c = y), m.e.r < g && (m.e.r = g), E == S) ++y;
      else if (y = 0, ++g, f.sheetRows && f.sheetRows <= g) return !0;
    }
    e: for (; _ < u.length; ++_) switch (E = u.charCodeAt(_)) {
      case 34:
        O === 34 && (C = !C);
        break;
      case S:
      case 10:
      case 13:
        if (!C && A()) break e;
        break;
    }
    return _ - w > 0 && A(), p["!ref"] = ea(m), p;
  }
  function i(u, d) {
    return !(d && d.PRN) || d.FS || u.slice(0, 4) == "sep=" || u.indexOf("	") >= 0 || u.indexOf(",") >= 0 || u.indexOf(";") >= 0 ? s(u, d) : Yh(t(u, d), d);
  }
  function o(u, d) {
    var f = "", h = d.type == "string" ? [0, 0, 0, 0] : cGe(u, d);
    switch (d.type) {
      case "base64":
        f = Bl(u);
        break;
      case "binary":
        f = u;
        break;
      case "buffer":
        d.codepage == 65001 ? f = u.toString("utf8") : (d.codepage, f = Mr && Buffer.isBuffer(u) ? u.toString("binary") : bv(u));
        break;
      case "array":
        f = Qx(u);
        break;
      case "string":
        f = u;
        break;
      default:
        throw new Error("Unrecognized type " + d.type);
    }
    return h[0] == 239 && h[1] == 187 && h[2] == 191 ? f = km(f.slice(3)) : d.type != "string" && d.type != "buffer" && d.codepage == 65001 ? f = km(f) : d.type == "binary", f.slice(0, 19) == "socialcalc:version:" ? j9.to_sheet(d.type == "string" ? f : km(f), d) : i(f, d);
  }
  function l(u, d) {
    return _d(o(u, d), d);
  }
  function c(u) {
    for (var d = [], f = vn(u["!ref"]), h, p = Array.isArray(u), m = f.s.r; m <= f.e.r; ++m) {
      for (var g = [], y = f.s.c; y <= f.e.c; ++y) {
        var x = Zr({ r: m, c: y });
        if (h = p ? (u[m] || [])[y] : u[x], !h || h.v == null) {
          g.push("          ");
          continue;
        }
        for (var w = (h.w || (Ul(h), h.w) || "").slice(0, 10); w.length < 10; ) w += " ";
        g.push(w + (y === 0 ? " " : ""));
      }
      d.push(g.join(""));
    }
    return d.join(`
`);
  }
  return {
    to_workbook: l,
    to_sheet: o,
    from_sheet: c
  };
}(), o4 = /* @__PURE__ */ function() {
  function e(U, Q, L) {
    if (U) {
      Fs(U, U.l || 0);
      for (var j = L.Enum || ue; U.l < U.length; ) {
        var K = U.read_shift(2), J = j[K] || j[65535], re = U.read_shift(2), le = U.l + re, pe = J.f && J.f(U, re, L);
        if (U.l = le, Q(pe, J, K)) return;
      }
    }
  }
  function t(U, Q) {
    switch (Q.type) {
      case "base64":
        return r(Ri(Bl(U)), Q);
      case "binary":
        return r(Ri(U), Q);
      case "buffer":
      case "array":
        return r(U, Q);
    }
    throw "Unsupported type " + Q.type;
  }
  function r(U, Q) {
    if (!U) return U;
    var L = Q || {}, j = L.dense ? [] : {}, K = "Sheet1", J = "", re = 0, le = {}, pe = [], me = [], Oe = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, ee = L.sheetRows || 0;
    if (U[2] == 0 && (U[3] == 8 || U[3] == 9) && U.length >= 16 && U[14] == 5 && U[15] === 108)
      throw new Error("Unsupported Works 3 for Mac file");
    if (U[2] == 2)
      L.Enum = ue, e(U, function(Pe, rt, ht) {
        switch (ht) {
          case 0:
            L.vers = Pe, Pe >= 4096 && (L.qpro = !0);
            break;
          case 6:
            Oe = Pe;
            break;
          case 204:
            Pe && (J = Pe);
            break;
          case 222:
            J = Pe;
            break;
          case 15:
          case 51:
            L.qpro || (Pe[1].v = Pe[1].v.slice(1));
          case 13:
          case 14:
          case 16:
            ht == 14 && (Pe[2] & 112) == 112 && (Pe[2] & 15) > 1 && (Pe[2] & 15) < 15 && (Pe[1].z = L.dateNF || Rn[14], L.cellDates && (Pe[1].t = "d", Pe[1].v = e9(Pe[1].v))), L.qpro && Pe[3] > re && (j["!ref"] = ea(Oe), le[K] = j, pe.push(K), j = L.dense ? [] : {}, Oe = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, re = Pe[3], K = J || "Sheet" + (re + 1), J = "");
            var bt = L.dense ? (j[Pe[0].r] || [])[Pe[0].c] : j[Zr(Pe[0])];
            if (bt) {
              bt.t = Pe[1].t, bt.v = Pe[1].v, Pe[1].z != null && (bt.z = Pe[1].z), Pe[1].f != null && (bt.f = Pe[1].f);
              break;
            }
            L.dense ? (j[Pe[0].r] || (j[Pe[0].r] = []), j[Pe[0].r][Pe[0].c] = Pe[1]) : j[Zr(Pe[0])] = Pe[1];
            break;
        }
      }, L);
    else if (U[2] == 26 || U[2] == 14)
      L.Enum = q, U[2] == 14 && (L.qpro = !0, U.l = 0), e(U, function(Pe, rt, ht) {
        switch (ht) {
          case 204:
            K = Pe;
            break;
          case 22:
            Pe[1].v = Pe[1].v.slice(1);
          case 23:
          case 24:
          case 25:
          case 37:
          case 39:
          case 40:
            if (Pe[3] > re && (j["!ref"] = ea(Oe), le[K] = j, pe.push(K), j = L.dense ? [] : {}, Oe = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, re = Pe[3], K = "Sheet" + (re + 1)), ee > 0 && Pe[0].r >= ee) break;
            L.dense ? (j[Pe[0].r] || (j[Pe[0].r] = []), j[Pe[0].r][Pe[0].c] = Pe[1]) : j[Zr(Pe[0])] = Pe[1], Oe.e.c < Pe[0].c && (Oe.e.c = Pe[0].c), Oe.e.r < Pe[0].r && (Oe.e.r = Pe[0].r);
            break;
          case 27:
            Pe[14e3] && (me[Pe[14e3][0]] = Pe[14e3][1]);
            break;
          case 1537:
            me[Pe[0]] = Pe[1], Pe[0] == re && (K = Pe[1]);
            break;
        }
      }, L);
    else throw new Error("Unrecognized LOTUS BOF " + U[2]);
    if (j["!ref"] = ea(Oe), le[J || K] = j, pe.push(J || K), !me.length) return { SheetNames: pe, Sheets: le };
    for (var he = {}, Ee = [], we = 0; we < me.length; ++we) le[pe[we]] ? (Ee.push(me[we] || pe[we]), he[me[we]] = le[me[we]] || le[pe[we]]) : (Ee.push(me[we]), he[me[we]] = { "!ref": "A1" });
    return { SheetNames: Ee, Sheets: he };
  }
  function n(U, Q) {
    var L = Q || {};
    if (+L.codepage >= 0 && hg(+L.codepage), L.type == "string") throw new Error("Cannot write WK1 to JS string");
    var j = xs(), K = vn(U["!ref"]), J = Array.isArray(U), re = [];
    yt(j, 0, s(1030)), yt(j, 6, l(K));
    for (var le = Math.min(K.e.r, 8191), pe = K.s.r; pe <= le; ++pe)
      for (var me = Ra(pe), Oe = K.s.c; Oe <= K.e.c; ++Oe) {
        pe === K.s.r && (re[Oe] = Ya(Oe));
        var ee = re[Oe] + me, he = J ? (U[pe] || [])[Oe] : U[ee];
        if (!(!he || he.t == "z"))
          if (he.t == "n")
            (he.v | 0) == he.v && he.v >= -32768 && he.v <= 32767 ? yt(j, 13, h(pe, Oe, he.v)) : yt(j, 14, m(pe, Oe, he.v));
          else {
            var Ee = Ul(he);
            yt(j, 15, d(pe, Oe, Ee.slice(0, 239)));
          }
      }
    return yt(j, 1), j.end();
  }
  function a(U, Q) {
    var L = Q || {};
    if (+L.codepage >= 0 && hg(+L.codepage), L.type == "string") throw new Error("Cannot write WK3 to JS string");
    var j = xs();
    yt(j, 0, i(U));
    for (var K = 0, J = 0; K < U.SheetNames.length; ++K) (U.Sheets[U.SheetNames[K]] || {})["!ref"] && yt(j, 27, ne(U.SheetNames[K], J++));
    var re = 0;
    for (K = 0; K < U.SheetNames.length; ++K) {
      var le = U.Sheets[U.SheetNames[K]];
      if (!(!le || !le["!ref"])) {
        for (var pe = vn(le["!ref"]), me = Array.isArray(le), Oe = [], ee = Math.min(pe.e.r, 8191), he = pe.s.r; he <= ee; ++he)
          for (var Ee = Ra(he), we = pe.s.c; we <= pe.e.c; ++we) {
            he === pe.s.r && (Oe[we] = Ya(we));
            var Pe = Oe[we] + Ee, rt = me ? (le[he] || [])[we] : le[Pe];
            if (!(!rt || rt.t == "z"))
              if (rt.t == "n")
                yt(j, 23, A(he, we, re, rt.v));
              else {
                var ht = Ul(rt);
                yt(j, 22, E(he, we, re, ht.slice(0, 239)));
              }
          }
        ++re;
      }
    }
    return yt(j, 1), j.end();
  }
  function s(U) {
    var Q = Ke(2);
    return Q.write_shift(2, U), Q;
  }
  function i(U) {
    var Q = Ke(26);
    Q.write_shift(2, 4096), Q.write_shift(2, 4), Q.write_shift(4, 0);
    for (var L = 0, j = 0, K = 0, J = 0; J < U.SheetNames.length; ++J) {
      var re = U.SheetNames[J], le = U.Sheets[re];
      if (!(!le || !le["!ref"])) {
        ++K;
        var pe = qs(le["!ref"]);
        L < pe.e.r && (L = pe.e.r), j < pe.e.c && (j = pe.e.c);
      }
    }
    return L > 8191 && (L = 8191), Q.write_shift(2, L), Q.write_shift(1, K), Q.write_shift(1, j), Q.write_shift(2, 0), Q.write_shift(2, 0), Q.write_shift(1, 1), Q.write_shift(1, 2), Q.write_shift(4, 0), Q.write_shift(4, 0), Q;
  }
  function o(U, Q, L) {
    var j = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    return Q == 8 && L.qpro ? (j.s.c = U.read_shift(1), U.l++, j.s.r = U.read_shift(2), j.e.c = U.read_shift(1), U.l++, j.e.r = U.read_shift(2), j) : (j.s.c = U.read_shift(2), j.s.r = U.read_shift(2), Q == 12 && L.qpro && (U.l += 2), j.e.c = U.read_shift(2), j.e.r = U.read_shift(2), Q == 12 && L.qpro && (U.l += 2), j.s.c == 65535 && (j.s.c = j.e.c = j.s.r = j.e.r = 0), j);
  }
  function l(U) {
    var Q = Ke(8);
    return Q.write_shift(2, U.s.c), Q.write_shift(2, U.s.r), Q.write_shift(2, U.e.c), Q.write_shift(2, U.e.r), Q;
  }
  function c(U, Q, L) {
    var j = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0, 0];
    return L.qpro && L.vers != 20768 ? (j[0].c = U.read_shift(1), j[3] = U.read_shift(1), j[0].r = U.read_shift(2), U.l += 2) : (j[2] = U.read_shift(1), j[0].c = U.read_shift(2), j[0].r = U.read_shift(2)), j;
  }
  function u(U, Q, L) {
    var j = U.l + Q, K = c(U, Q, L);
    if (K[1].t = "s", L.vers == 20768) {
      U.l++;
      var J = U.read_shift(1);
      return K[1].v = U.read_shift(J, "utf8"), K;
    }
    return L.qpro && U.l++, K[1].v = U.read_shift(j - U.l, "cstr"), K;
  }
  function d(U, Q, L) {
    var j = Ke(7 + L.length);
    j.write_shift(1, 255), j.write_shift(2, Q), j.write_shift(2, U), j.write_shift(1, 39);
    for (var K = 0; K < j.length; ++K) {
      var J = L.charCodeAt(K);
      j.write_shift(1, J >= 128 ? 95 : J);
    }
    return j.write_shift(1, 0), j;
  }
  function f(U, Q, L) {
    var j = c(U, Q, L);
    return j[1].v = U.read_shift(2, "i"), j;
  }
  function h(U, Q, L) {
    var j = Ke(7);
    return j.write_shift(1, 255), j.write_shift(2, Q), j.write_shift(2, U), j.write_shift(2, L, "i"), j;
  }
  function p(U, Q, L) {
    var j = c(U, Q, L);
    return j[1].v = U.read_shift(8, "f"), j;
  }
  function m(U, Q, L) {
    var j = Ke(13);
    return j.write_shift(1, 255), j.write_shift(2, Q), j.write_shift(2, U), j.write_shift(8, L, "f"), j;
  }
  function g(U, Q, L) {
    var j = U.l + Q, K = c(U, Q, L);
    if (K[1].v = U.read_shift(8, "f"), L.qpro) U.l = j;
    else {
      var J = U.read_shift(2);
      _(U.slice(U.l, U.l + J), K), U.l += J;
    }
    return K;
  }
  function y(U, Q, L) {
    var j = Q & 32768;
    return Q &= -32769, Q = (j ? U : 0) + (Q >= 8192 ? Q - 16384 : Q), (j ? "" : "$") + (L ? Ya(Q) : Ra(Q));
  }
  var x = {
    51: ["FALSE", 0],
    52: ["TRUE", 0],
    70: ["LEN", 1],
    80: ["SUM", 69],
    81: ["AVERAGEA", 69],
    82: ["COUNTA", 69],
    83: ["MINA", 69],
    84: ["MAXA", 69],
    111: ["T", 1]
  }, w = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "",
    "+",
    "-",
    "*",
    "/",
    "^",
    "=",
    "<>",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "<=",
    ">=",
    "<",
    ">",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "&",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
    // eslint-disable-line no-mixed-spaces-and-tabs
  ];
  function _(U, Q) {
    Fs(U, 0);
    for (var L = [], j = 0, K = "", J = "", re = "", le = ""; U.l < U.length; ) {
      var pe = U[U.l++];
      switch (pe) {
        case 0:
          L.push(U.read_shift(8, "f"));
          break;
        case 1:
          J = y(Q[0].c, U.read_shift(2), !0), K = y(Q[0].r, U.read_shift(2), !1), L.push(J + K);
          break;
        case 2:
          {
            var me = y(Q[0].c, U.read_shift(2), !0), Oe = y(Q[0].r, U.read_shift(2), !1);
            J = y(Q[0].c, U.read_shift(2), !0), K = y(Q[0].r, U.read_shift(2), !1), L.push(me + Oe + ":" + J + K);
          }
          break;
        case 3:
          if (U.l < U.length) {
            console.error("WK1 premature formula end");
            return;
          }
          break;
        case 4:
          L.push("(" + L.pop() + ")");
          break;
        case 5:
          L.push(U.read_shift(2));
          break;
        case 6:
          {
            for (var ee = ""; pe = U[U.l++]; ) ee += String.fromCharCode(pe);
            L.push('"' + ee.replace(/"/g, '""') + '"');
          }
          break;
        case 8:
          L.push("-" + L.pop());
          break;
        case 23:
          L.push("+" + L.pop());
          break;
        case 22:
          L.push("NOT(" + L.pop() + ")");
          break;
        case 20:
        case 21:
          le = L.pop(), re = L.pop(), L.push(["AND", "OR"][pe - 20] + "(" + re + "," + le + ")");
          break;
        default:
          if (pe < 32 && w[pe])
            le = L.pop(), re = L.pop(), L.push(re + w[pe] + le);
          else if (x[pe]) {
            if (j = x[pe][1], j == 69 && (j = U[U.l++]), j > L.length) {
              console.error("WK1 bad formula parse 0x" + pe.toString(16) + ":|" + L.join("|") + "|");
              return;
            }
            var he = L.slice(-j);
            L.length -= j, L.push(x[pe][0] + "(" + he.join(",") + ")");
          } else return pe <= 7 ? console.error("WK1 invalid opcode " + pe.toString(16)) : pe <= 24 ? console.error("WK1 unsupported op " + pe.toString(16)) : pe <= 30 ? console.error("WK1 invalid opcode " + pe.toString(16)) : pe <= 115 ? console.error("WK1 unsupported function opcode " + pe.toString(16)) : console.error("WK1 unrecognized opcode " + pe.toString(16));
      }
    }
    L.length == 1 ? Q[1].f = "" + L[0] : console.error("WK1 bad formula parse |" + L.join("|") + "|");
  }
  function S(U) {
    var Q = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0];
    return Q[0].r = U.read_shift(2), Q[3] = U[U.l++], Q[0].c = U[U.l++], Q;
  }
  function C(U, Q) {
    var L = S(U);
    return L[1].t = "s", L[1].v = U.read_shift(Q - 4, "cstr"), L;
  }
  function E(U, Q, L, j) {
    var K = Ke(6 + j.length);
    K.write_shift(2, U), K.write_shift(1, L), K.write_shift(1, Q), K.write_shift(1, 39);
    for (var J = 0; J < j.length; ++J) {
      var re = j.charCodeAt(J);
      K.write_shift(1, re >= 128 ? 95 : re);
    }
    return K.write_shift(1, 0), K;
  }
  function O(U, Q) {
    var L = S(U);
    L[1].v = U.read_shift(2);
    var j = L[1].v >> 1;
    if (L[1].v & 1)
      switch (j & 7) {
        case 0:
          j = (j >> 3) * 5e3;
          break;
        case 1:
          j = (j >> 3) * 500;
          break;
        case 2:
          j = (j >> 3) / 20;
          break;
        case 3:
          j = (j >> 3) / 200;
          break;
        case 4:
          j = (j >> 3) / 2e3;
          break;
        case 5:
          j = (j >> 3) / 2e4;
          break;
        case 6:
          j = (j >> 3) / 16;
          break;
        case 7:
          j = (j >> 3) / 64;
          break;
      }
    return L[1].v = j, L;
  }
  function k(U, Q) {
    var L = S(U), j = U.read_shift(4), K = U.read_shift(4), J = U.read_shift(2);
    if (J == 65535)
      return j === 0 && K === 3221225472 ? (L[1].t = "e", L[1].v = 15) : j === 0 && K === 3489660928 ? (L[1].t = "e", L[1].v = 42) : L[1].v = 0, L;
    var re = J & 32768;
    return J = (J & 32767) - 16446, L[1].v = (1 - re * 2) * (K * Math.pow(2, J + 32) + j * Math.pow(2, J)), L;
  }
  function A(U, Q, L, j) {
    var K = Ke(14);
    if (K.write_shift(2, U), K.write_shift(1, L), K.write_shift(1, Q), j == 0)
      return K.write_shift(4, 0), K.write_shift(4, 0), K.write_shift(2, 65535), K;
    var J = 0, re = 0, le = 0, pe = 0;
    return j < 0 && (J = 1, j = -j), re = Math.log2(j) | 0, j /= Math.pow(2, re - 31), pe = j >>> 0, pe & 2147483648 || (j /= 2, ++re, pe = j >>> 0), j -= pe, pe |= 2147483648, pe >>>= 0, j *= Math.pow(2, 32), le = j >>> 0, K.write_shift(4, le), K.write_shift(4, pe), re += 16383 + (J ? 32768 : 0), K.write_shift(2, re), K;
  }
  function P(U, Q) {
    var L = k(U);
    return U.l += Q - 14, L;
  }
  function D(U, Q) {
    var L = S(U), j = U.read_shift(4);
    return L[1].v = j >> 6, L;
  }
  function N(U, Q) {
    var L = S(U), j = U.read_shift(8, "f");
    return L[1].v = j, L;
  }
  function z(U, Q) {
    var L = N(U);
    return U.l += Q - 10, L;
  }
  function G(U, Q) {
    return U[U.l + Q - 1] == 0 ? U.read_shift(Q, "cstr") : "";
  }
  function Y(U, Q) {
    var L = U[U.l++];
    L > Q - 1 && (L = Q - 1);
    for (var j = ""; j.length < L; ) j += String.fromCharCode(U[U.l++]);
    return j;
  }
  function te(U, Q, L) {
    if (!(!L.qpro || Q < 21)) {
      var j = U.read_shift(1);
      U.l += 17, U.l += 1, U.l += 2;
      var K = U.read_shift(Q - 21, "cstr");
      return [j, K];
    }
  }
  function ae(U, Q) {
    for (var L = {}, j = U.l + Q; U.l < j; ) {
      var K = U.read_shift(2);
      if (K == 14e3) {
        for (L[K] = [0, ""], L[K][0] = U.read_shift(2); U[U.l]; )
          L[K][1] += String.fromCharCode(U[U.l]), U.l++;
        U.l++;
      }
    }
    return L;
  }
  function ne(U, Q) {
    var L = Ke(5 + U.length);
    L.write_shift(2, 14e3), L.write_shift(2, Q);
    for (var j = 0; j < U.length; ++j) {
      var K = U.charCodeAt(j);
      L[L.l++] = K > 127 ? 95 : K;
    }
    return L[L.l++] = 0, L;
  }
  var ue = {
    /*::[*/
    0: { n: "BOF", f: I9 },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "CALCMODE" },
    /*::[*/
    3: { n: "CALCORDER" },
    /*::[*/
    4: { n: "SPLIT" },
    /*::[*/
    5: { n: "SYNC" },
    /*::[*/
    6: { n: "RANGE", f: o },
    /*::[*/
    7: { n: "WINDOW1" },
    /*::[*/
    8: { n: "COLW1" },
    /*::[*/
    9: { n: "WINTWO" },
    /*::[*/
    10: { n: "COLW2" },
    /*::[*/
    11: { n: "NAME" },
    /*::[*/
    12: { n: "BLANK" },
    /*::[*/
    13: { n: "INTEGER", f },
    /*::[*/
    14: { n: "NUMBER", f: p },
    /*::[*/
    15: { n: "LABEL", f: u },
    /*::[*/
    16: { n: "FORMULA", f: g },
    /*::[*/
    24: { n: "TABLE" },
    /*::[*/
    25: { n: "ORANGE" },
    /*::[*/
    26: { n: "PRANGE" },
    /*::[*/
    27: { n: "SRANGE" },
    /*::[*/
    28: { n: "FRANGE" },
    /*::[*/
    29: { n: "KRANGE1" },
    /*::[*/
    32: { n: "HRANGE" },
    /*::[*/
    35: { n: "KRANGE2" },
    /*::[*/
    36: { n: "PROTEC" },
    /*::[*/
    37: { n: "FOOTER" },
    /*::[*/
    38: { n: "HEADER" },
    /*::[*/
    39: { n: "SETUP" },
    /*::[*/
    40: { n: "MARGINS" },
    /*::[*/
    41: { n: "LABELFMT" },
    /*::[*/
    42: { n: "TITLES" },
    /*::[*/
    43: { n: "SHEETJS" },
    /*::[*/
    45: { n: "GRAPH" },
    /*::[*/
    46: { n: "NGRAPH" },
    /*::[*/
    47: { n: "CALCCOUNT" },
    /*::[*/
    48: { n: "UNFORMATTED" },
    /*::[*/
    49: { n: "CURSORW12" },
    /*::[*/
    50: { n: "WINDOW" },
    /*::[*/
    51: { n: "STRING", f: u },
    /*::[*/
    55: { n: "PASSWORD" },
    /*::[*/
    56: { n: "LOCKED" },
    /*::[*/
    60: { n: "QUERY" },
    /*::[*/
    61: { n: "QUERYNAME" },
    /*::[*/
    62: { n: "PRINT" },
    /*::[*/
    63: { n: "PRINTNAME" },
    /*::[*/
    64: { n: "GRAPH2" },
    /*::[*/
    65: { n: "GRAPHNAME" },
    /*::[*/
    66: { n: "ZOOM" },
    /*::[*/
    67: { n: "SYMSPLIT" },
    /*::[*/
    68: { n: "NSROWS" },
    /*::[*/
    69: { n: "NSCOLS" },
    /*::[*/
    70: { n: "RULER" },
    /*::[*/
    71: { n: "NNAME" },
    /*::[*/
    72: { n: "ACOMM" },
    /*::[*/
    73: { n: "AMACRO" },
    /*::[*/
    74: { n: "PARSE" },
    /*::[*/
    102: { n: "PRANGES??" },
    /*::[*/
    103: { n: "RRANGES??" },
    /*::[*/
    104: { n: "FNAME??" },
    /*::[*/
    105: { n: "MRANGES??" },
    /*::[*/
    204: { n: "SHEETNAMECS", f: G },
    /*::[*/
    222: { n: "SHEETNAMELP", f: Y },
    /*::[*/
    65535: { n: "" }
  }, q = {
    /*::[*/
    0: { n: "BOF" },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "PASSWORD" },
    /*::[*/
    3: { n: "CALCSET" },
    /*::[*/
    4: { n: "WINDOWSET" },
    /*::[*/
    5: { n: "SHEETCELLPTR" },
    /*::[*/
    6: { n: "SHEETLAYOUT" },
    /*::[*/
    7: { n: "COLUMNWIDTH" },
    /*::[*/
    8: { n: "HIDDENCOLUMN" },
    /*::[*/
    9: { n: "USERRANGE" },
    /*::[*/
    10: { n: "SYSTEMRANGE" },
    /*::[*/
    11: { n: "ZEROFORCE" },
    /*::[*/
    12: { n: "SORTKEYDIR" },
    /*::[*/
    13: { n: "FILESEAL" },
    /*::[*/
    14: { n: "DATAFILLNUMS" },
    /*::[*/
    15: { n: "PRINTMAIN" },
    /*::[*/
    16: { n: "PRINTSTRING" },
    /*::[*/
    17: { n: "GRAPHMAIN" },
    /*::[*/
    18: { n: "GRAPHSTRING" },
    /*::[*/
    19: { n: "??" },
    /*::[*/
    20: { n: "ERRCELL" },
    /*::[*/
    21: { n: "NACELL" },
    /*::[*/
    22: { n: "LABEL16", f: C },
    /*::[*/
    23: { n: "NUMBER17", f: k },
    /*::[*/
    24: { n: "NUMBER18", f: O },
    /*::[*/
    25: { n: "FORMULA19", f: P },
    /*::[*/
    26: { n: "FORMULA1A" },
    /*::[*/
    27: { n: "XFORMAT", f: ae },
    /*::[*/
    28: { n: "DTLABELMISC" },
    /*::[*/
    29: { n: "DTLABELCELL" },
    /*::[*/
    30: { n: "GRAPHWINDOW" },
    /*::[*/
    31: { n: "CPA" },
    /*::[*/
    32: { n: "LPLAUTO" },
    /*::[*/
    33: { n: "QUERY" },
    /*::[*/
    34: { n: "HIDDENSHEET" },
    /*::[*/
    35: { n: "??" },
    /*::[*/
    37: { n: "NUMBER25", f: D },
    /*::[*/
    38: { n: "??" },
    /*::[*/
    39: { n: "NUMBER27", f: N },
    /*::[*/
    40: { n: "FORMULA28", f: z },
    /*::[*/
    142: { n: "??" },
    /*::[*/
    147: { n: "??" },
    /*::[*/
    150: { n: "??" },
    /*::[*/
    151: { n: "??" },
    /*::[*/
    152: { n: "??" },
    /*::[*/
    153: { n: "??" },
    /*::[*/
    154: { n: "??" },
    /*::[*/
    155: { n: "??" },
    /*::[*/
    156: { n: "??" },
    /*::[*/
    163: { n: "??" },
    /*::[*/
    174: { n: "??" },
    /*::[*/
    175: { n: "??" },
    /*::[*/
    176: { n: "??" },
    /*::[*/
    177: { n: "??" },
    /*::[*/
    184: { n: "??" },
    /*::[*/
    185: { n: "??" },
    /*::[*/
    186: { n: "??" },
    /*::[*/
    187: { n: "??" },
    /*::[*/
    188: { n: "??" },
    /*::[*/
    195: { n: "??" },
    /*::[*/
    201: { n: "??" },
    /*::[*/
    204: { n: "SHEETNAMECS", f: G },
    /*::[*/
    205: { n: "??" },
    /*::[*/
    206: { n: "??" },
    /*::[*/
    207: { n: "??" },
    /*::[*/
    208: { n: "??" },
    /*::[*/
    256: { n: "??" },
    /*::[*/
    259: { n: "??" },
    /*::[*/
    260: { n: "??" },
    /*::[*/
    261: { n: "??" },
    /*::[*/
    262: { n: "??" },
    /*::[*/
    263: { n: "??" },
    /*::[*/
    265: { n: "??" },
    /*::[*/
    266: { n: "??" },
    /*::[*/
    267: { n: "??" },
    /*::[*/
    268: { n: "??" },
    /*::[*/
    270: { n: "??" },
    /*::[*/
    271: { n: "??" },
    /*::[*/
    384: { n: "??" },
    /*::[*/
    389: { n: "??" },
    /*::[*/
    390: { n: "??" },
    /*::[*/
    393: { n: "??" },
    /*::[*/
    396: { n: "??" },
    /*::[*/
    512: { n: "??" },
    /*::[*/
    514: { n: "??" },
    /*::[*/
    513: { n: "??" },
    /*::[*/
    516: { n: "??" },
    /*::[*/
    517: { n: "??" },
    /*::[*/
    640: { n: "??" },
    /*::[*/
    641: { n: "??" },
    /*::[*/
    642: { n: "??" },
    /*::[*/
    643: { n: "??" },
    /*::[*/
    644: { n: "??" },
    /*::[*/
    645: { n: "??" },
    /*::[*/
    646: { n: "??" },
    /*::[*/
    647: { n: "??" },
    /*::[*/
    648: { n: "??" },
    /*::[*/
    658: { n: "??" },
    /*::[*/
    659: { n: "??" },
    /*::[*/
    660: { n: "??" },
    /*::[*/
    661: { n: "??" },
    /*::[*/
    662: { n: "??" },
    /*::[*/
    665: { n: "??" },
    /*::[*/
    666: { n: "??" },
    /*::[*/
    768: { n: "??" },
    /*::[*/
    772: { n: "??" },
    /*::[*/
    1537: { n: "SHEETINFOQP", f: te },
    /*::[*/
    1600: { n: "??" },
    /*::[*/
    1602: { n: "??" },
    /*::[*/
    1793: { n: "??" },
    /*::[*/
    1794: { n: "??" },
    /*::[*/
    1795: { n: "??" },
    /*::[*/
    1796: { n: "??" },
    /*::[*/
    1920: { n: "??" },
    /*::[*/
    2048: { n: "??" },
    /*::[*/
    2049: { n: "??" },
    /*::[*/
    2052: { n: "??" },
    /*::[*/
    2688: { n: "??" },
    /*::[*/
    10998: { n: "??" },
    /*::[*/
    12849: { n: "??" },
    /*::[*/
    28233: { n: "??" },
    /*::[*/
    28484: { n: "??" },
    /*::[*/
    65535: { n: "" }
  };
  return {
    sheet_to_wk1: n,
    book_to_wk3: a,
    to_workbook: t
  };
}(), J7e = /^\s|\s$|[\t\n\r]/;
function F9(e, t) {
  if (!t.bookSST) return "";
  var r = [ra];
  r[r.length] = vt("sst", null, {
    xmlns: Gh[0],
    count: e.Count,
    uniqueCount: e.Unique
  });
  for (var n = 0; n != e.length; ++n)
    if (e[n] != null) {
      var a = e[n], s = "<si>";
      a.r ? s += a.r : (s += "<t", a.t || (a.t = ""), a.t.match(J7e) && (s += ' xml:space="preserve"'), s += ">" + Jr(a.t) + "</t>"), s += "</si>", r[r.length] = s;
    }
  return r.length > 2 && (r[r.length] = "</sst>", r[1] = r[1].replace("/>", ">")), r.join("");
}
function Z7e(e) {
  return [e.read_shift(4), e.read_shift(4)];
}
function e9e(e, t) {
  return t || (t = Ke(8)), t.write_shift(4, e.Count), t.write_shift(4, e.Unique), t;
}
var t9e = zHe;
function r9e(e) {
  var t = xs();
  nt(t, 159, e9e(e));
  for (var r = 0; r < e.length; ++r) nt(t, 19, t9e(e[r]));
  return nt(
    t,
    160
    /* BrtEndSst */
  ), t.end();
}
function n9e(e) {
  for (var t = [], r = e.split(""), n = 0; n < r.length; ++n) t[n] = r[n].charCodeAt(0);
  return t;
}
function B9(e) {
  var t = 0, r, n = n9e(e), a = n.length + 1, s, i, o, l, c;
  for (r = Xu(a), r[0] = n.length, s = 1; s != a; ++s) r[s] = n[s - 1];
  for (s = a - 1; s >= 0; --s)
    i = r[s], o = t & 16384 ? 1 : 0, l = t << 1 & 32767, c = o | l, t = c ^ i;
  return t ^ 52811;
}
var a9e = /* @__PURE__ */ function() {
  function e(a, s) {
    switch (s.type) {
      case "base64":
        return t(Bl(a), s);
      case "binary":
        return t(a, s);
      case "buffer":
        return t(Mr && Buffer.isBuffer(a) ? a.toString("binary") : bv(a), s);
      case "array":
        return t(Qx(a), s);
    }
    throw new Error("Unrecognized type " + s.type);
  }
  function t(a, s) {
    var i = s || {}, o = i.dense ? [] : {}, l = a.match(/\\trowd.*?\\row\b/g);
    if (!l.length) throw new Error("RTF missing table");
    var c = { s: { c: 0, r: 0 }, e: { c: 0, r: l.length - 1 } };
    return l.forEach(function(u, d) {
      Array.isArray(o) && (o[d] = []);
      for (var f = /\\\w+\b/g, h = 0, p, m = -1; p = f.exec(u); ) {
        switch (p[0]) {
          case "\\cell":
            var g = u.slice(h, f.lastIndex - p[0].length);
            if (g[0] == " " && (g = g.slice(1)), ++m, g.length) {
              var y = { v: g, t: "s" };
              Array.isArray(o) ? o[d][m] = y : o[Zr({ r: d, c: m })] = y;
            }
            break;
        }
        h = f.lastIndex;
      }
      m > c.e.c && (c.e.c = m);
    }), o["!ref"] = ea(c), o;
  }
  function r(a, s) {
    return _d(e(a, s), s);
  }
  function n(a) {
    for (var s = ["{\\rtf1\\ansi"], i = vn(a["!ref"]), o, l = Array.isArray(a), c = i.s.r; c <= i.e.r; ++c) {
      s.push("\\trowd\\trautofit1");
      for (var u = i.s.c; u <= i.e.c; ++u) s.push("\\cellx" + (u + 1));
      for (s.push("\\pard\\intbl"), u = i.s.c; u <= i.e.c; ++u) {
        var d = Zr({ r: c, c: u });
        o = l ? (a[c] || [])[u] : a[d], !(!o || o.v == null && (!o.f || o.F)) && (s.push(" " + (o.w || (Ul(o), o.w))), s.push("\\cell"));
      }
      s.push("\\pard\\intbl\\row");
    }
    return s.join("") + "}";
  }
  return {
    to_workbook: r,
    to_sheet: e,
    from_sheet: n
  };
}();
function l4(e) {
  for (var t = 0, r = 1; t != 3; ++t) r = r * 256 + (e[t] > 255 ? 255 : e[t] < 0 ? 0 : e[t]);
  return r.toString(16).toUpperCase().slice(1);
}
var s9e = 6, Ml = s9e;
function cw(e) {
  return Math.floor((e + Math.round(128 / Ml) / 256) * Ml);
}
function uw(e) {
  return Math.floor((e - 5) / Ml * 100 + 0.5) / 100;
}
function yT(e) {
  return Math.round((e * Ml + 5) / Ml * 256) / 256;
}
function Y2(e) {
  e.width ? (e.wpx = cw(e.width), e.wch = uw(e.wpx), e.MDW = Ml) : e.wpx ? (e.wch = uw(e.wpx), e.width = yT(e.wch), e.MDW = Ml) : typeof e.wch == "number" && (e.width = yT(e.wch), e.wpx = cw(e.width), e.MDW = Ml), e.customWidth && delete e.customWidth;
}
var i9e = 96, U9 = i9e;
function dw(e) {
  return e * 96 / U9;
}
function V9(e) {
  return e * U9 / 96;
}
function o9e(e) {
  var t = ["<numFmts>"];
  return [[5, 8], [23, 26], [41, 44], [
    /*63*/
    50,
    /*66],[164,*/
    392
  ]].forEach(function(r) {
    for (var n = r[0]; n <= r[1]; ++n) e[n] != null && (t[t.length] = vt("numFmt", null, { numFmtId: n, formatCode: Jr(e[n]) }));
  }), t.length === 1 ? "" : (t[t.length] = "</numFmts>", t[0] = vt("numFmts", null, { count: t.length - 2 }).replace("/>", ">"), t.join(""));
}
function l9e(e) {
  var t = [];
  return t[t.length] = vt("cellXfs", null), e.forEach(function(r) {
    t[t.length] = vt("xf", null, r);
  }), t[t.length] = "</cellXfs>", t.length === 2 ? "" : (t[0] = vt("cellXfs", null, { count: t.length - 2 }).replace("/>", ">"), t.join(""));
}
function $9(e, t) {
  var r = [ra, vt("styleSheet", null, {
    xmlns: Gh[0],
    "xmlns:vt": pa.vt
  })], n;
  return e.SSF && (n = o9e(e.SSF)) != null && (r[r.length] = n), r[r.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>', r[r.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>', r[r.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>', r[r.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>', (n = l9e(t.cellXfs)) && (r[r.length] = n), r[r.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>', r[r.length] = '<dxfs count="0"/>', r[r.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>', r.length > 2 && (r[r.length] = "</styleSheet>", r[1] = r[1].replace("/>", ">")), r.join("");
}
function c9e(e, t) {
  var r = e.read_shift(2), n = Xa(e);
  return [r, n];
}
function u9e(e, t, r) {
  r || (r = Ke(6 + 4 * t.length)), r.write_shift(2, e), ga(t, r);
  var n = r.length > r.l ? r.slice(0, r.l) : r;
  return r.l == null && (r.l = r.length), n;
}
function d9e(e, t, r) {
  var n = {};
  n.sz = e.read_shift(2) / 20;
  var a = JHe(e);
  a.fItalic && (n.italic = 1), a.fCondense && (n.condense = 1), a.fExtend && (n.extend = 1), a.fShadow && (n.shadow = 1), a.fOutline && (n.outline = 1), a.fStrikeout && (n.strike = 1);
  var s = e.read_shift(2);
  switch (s === 700 && (n.bold = 1), e.read_shift(2)) {
    case 1:
      n.vertAlign = "superscript";
      break;
    case 2:
      n.vertAlign = "subscript";
      break;
  }
  var i = e.read_shift(1);
  i != 0 && (n.underline = i);
  var o = e.read_shift(1);
  o > 0 && (n.family = o);
  var l = e.read_shift(1);
  switch (l > 0 && (n.charset = l), e.l++, n.color = QHe(e), e.read_shift(1)) {
    case 1:
      n.scheme = "major";
      break;
    case 2:
      n.scheme = "minor";
      break;
  }
  return n.name = Xa(e), n;
}
function f9e(e, t) {
  t || (t = Ke(25 + 4 * 32)), t.write_shift(2, e.sz * 20), ZHe(e, t), t.write_shift(2, e.bold ? 700 : 400);
  var r = 0;
  e.vertAlign == "superscript" ? r = 1 : e.vertAlign == "subscript" && (r = 2), t.write_shift(2, r), t.write_shift(1, e.underline || 0), t.write_shift(1, e.family || 0), t.write_shift(1, e.charset || 0), t.write_shift(1, 0), ow(e.color, t);
  var n = 0;
  return n = 2, t.write_shift(1, n), ga(e.name, t), t.length > t.l ? t.slice(0, t.l) : t;
}
var h9e = [
  "none",
  "solid",
  "mediumGray",
  "darkGray",
  "lightGray",
  "darkHorizontal",
  "darkVertical",
  "darkDown",
  "darkUp",
  "darkGrid",
  "darkTrellis",
  "lightHorizontal",
  "lightVertical",
  "lightDown",
  "lightUp",
  "lightGrid",
  "lightTrellis",
  "gray125",
  "gray0625"
], kS, p9e = Vo;
function c4(e, t) {
  t || (t = Ke(4 * 3 + 8 * 7 + 16 * 1)), kS || (kS = j2(h9e));
  var r = kS[e.patternType];
  r == null && (r = 40), t.write_shift(4, r);
  var n = 0;
  if (r != 40)
    for (ow({ auto: 1 }, t), ow({ auto: 1 }, t); n < 12; ++n) t.write_shift(4, 0);
  else {
    for (; n < 4; ++n) t.write_shift(4, 0);
    for (; n < 12; ++n) t.write_shift(4, 0);
  }
  return t.length > t.l ? t.slice(0, t.l) : t;
}
function m9e(e, t) {
  var r = e.l + t, n = e.read_shift(2), a = e.read_shift(2);
  return e.l = r, { ixfe: n, numFmtId: a };
}
function H9(e, t, r) {
  r || (r = Ke(16)), r.write_shift(2, t || 0), r.write_shift(2, e.numFmtId || 0), r.write_shift(2, 0), r.write_shift(2, 0), r.write_shift(2, 0), r.write_shift(1, 0), r.write_shift(1, 0);
  var n = 0;
  return r.write_shift(1, n), r.write_shift(1, 0), r.write_shift(1, 0), r.write_shift(1, 0), r;
}
function $p(e, t) {
  return t || (t = Ke(10)), t.write_shift(1, 0), t.write_shift(1, 0), t.write_shift(4, 0), t.write_shift(4, 0), t;
}
var g9e = Vo;
function v9e(e, t) {
  return t || (t = Ke(51)), t.write_shift(1, 0), $p(null, t), $p(null, t), $p(null, t), $p(null, t), $p(null, t), t.length > t.l ? t.slice(0, t.l) : t;
}
function y9e(e, t) {
  return t || (t = Ke(12 + 4 * 10)), t.write_shift(4, e.xfId), t.write_shift(2, 1), t.write_shift(1, 0), t.write_shift(1, 0), iw(e.name || "", t), t.length > t.l ? t.slice(0, t.l) : t;
}
function b9e(e, t, r) {
  var n = Ke(2052);
  return n.write_shift(4, e), iw(t, n), iw(r, n), n.length > n.l ? n.slice(0, n.l) : n;
}
function w9e(e, t) {
  if (t) {
    var r = 0;
    [[5, 8], [23, 26], [41, 44], [
      /*63*/
      50,
      /*66],[164,*/
      392
    ]].forEach(function(n) {
      for (var a = n[0]; a <= n[1]; ++a) t[a] != null && ++r;
    }), r != 0 && (nt(e, 615, Bi(r)), [[5, 8], [23, 26], [41, 44], [
      /*63*/
      50,
      /*66],[164,*/
      392
    ]].forEach(function(n) {
      for (var a = n[0]; a <= n[1]; ++a) t[a] != null && nt(e, 44, u9e(a, t[a]));
    }), nt(
      e,
      616
      /* BrtEndFmts */
    ));
  }
}
function x9e(e) {
  var t = 1;
  nt(e, 611, Bi(t)), nt(e, 43, f9e({
    sz: 12,
    color: { theme: 1 },
    name: "Calibri",
    family: 2
  })), nt(
    e,
    612
    /* BrtEndFonts */
  );
}
function _9e(e) {
  var t = 2;
  nt(e, 603, Bi(t)), nt(e, 45, c4({ patternType: "none" })), nt(e, 45, c4({ patternType: "gray125" })), nt(
    e,
    604
    /* BrtEndFills */
  );
}
function S9e(e) {
  var t = 1;
  nt(e, 613, Bi(t)), nt(e, 46, v9e()), nt(
    e,
    614
    /* BrtEndBorders */
  );
}
function E9e(e) {
  var t = 1;
  nt(e, 626, Bi(t)), nt(e, 47, H9({
    numFmtId: 0
  }, 65535)), nt(
    e,
    627
    /* BrtEndCellStyleXFs */
  );
}
function T9e(e, t) {
  nt(e, 617, Bi(t.length)), t.forEach(function(r) {
    nt(e, 47, H9(r, 0));
  }), nt(
    e,
    618
    /* BrtEndCellXFs */
  );
}
function C9e(e) {
  var t = 1;
  nt(e, 619, Bi(t)), nt(e, 48, y9e({
    xfId: 0,
    name: "Normal"
  })), nt(
    e,
    620
    /* BrtEndStyles */
  );
}
function k9e(e) {
  var t = 0;
  nt(e, 505, Bi(t)), nt(
    e,
    506
    /* BrtEndDXFs */
  );
}
function O9e(e) {
  var t = 0;
  nt(e, 508, b9e(t, "TableStyleMedium9", "PivotStyleMedium4")), nt(
    e,
    509
    /* BrtEndTableStyles */
  );
}
function A9e(e, t) {
  var r = xs();
  return nt(
    r,
    278
    /* BrtBeginStyleSheet */
  ), w9e(r, e.SSF), x9e(r), _9e(r), S9e(r), E9e(r), T9e(r, t.cellXfs), C9e(r), k9e(r), O9e(r), nt(
    r,
    279
    /* BrtEndStyleSheet */
  ), r.end();
}
function W9(e, t) {
  if (t && t.themeXLSX) return t.themeXLSX;
  if (e && typeof e.raw == "string") return e.raw;
  var r = [ra];
  return r[r.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">', r[r.length] = "<a:themeElements>", r[r.length] = '<a:clrScheme name="Office">', r[r.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>', r[r.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>', r[r.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>', r[r.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>', r[r.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>', r[r.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>', r[r.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>', r[r.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>', r[r.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>', r[r.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>', r[r.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>', r[r.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>', r[r.length] = "</a:clrScheme>", r[r.length] = '<a:fontScheme name="Office">', r[r.length] = "<a:majorFont>", r[r.length] = '<a:latin typeface="Cambria"/>', r[r.length] = '<a:ea typeface=""/>', r[r.length] = '<a:cs typeface=""/>', r[r.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', r[r.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', r[r.length] = '<a:font script="Hans" typeface="宋体"/>', r[r.length] = '<a:font script="Hant" typeface="新細明體"/>', r[r.length] = '<a:font script="Arab" typeface="Times New Roman"/>', r[r.length] = '<a:font script="Hebr" typeface="Times New Roman"/>', r[r.length] = '<a:font script="Thai" typeface="Tahoma"/>', r[r.length] = '<a:font script="Ethi" typeface="Nyala"/>', r[r.length] = '<a:font script="Beng" typeface="Vrinda"/>', r[r.length] = '<a:font script="Gujr" typeface="Shruti"/>', r[r.length] = '<a:font script="Khmr" typeface="MoolBoran"/>', r[r.length] = '<a:font script="Knda" typeface="Tunga"/>', r[r.length] = '<a:font script="Guru" typeface="Raavi"/>', r[r.length] = '<a:font script="Cans" typeface="Euphemia"/>', r[r.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', r[r.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', r[r.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', r[r.length] = '<a:font script="Thaa" typeface="MV Boli"/>', r[r.length] = '<a:font script="Deva" typeface="Mangal"/>', r[r.length] = '<a:font script="Telu" typeface="Gautami"/>', r[r.length] = '<a:font script="Taml" typeface="Latha"/>', r[r.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', r[r.length] = '<a:font script="Orya" typeface="Kalinga"/>', r[r.length] = '<a:font script="Mlym" typeface="Kartika"/>', r[r.length] = '<a:font script="Laoo" typeface="DokChampa"/>', r[r.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', r[r.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', r[r.length] = '<a:font script="Viet" typeface="Times New Roman"/>', r[r.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', r[r.length] = '<a:font script="Geor" typeface="Sylfaen"/>', r[r.length] = "</a:majorFont>", r[r.length] = "<a:minorFont>", r[r.length] = '<a:latin typeface="Calibri"/>', r[r.length] = '<a:ea typeface=""/>', r[r.length] = '<a:cs typeface=""/>', r[r.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', r[r.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', r[r.length] = '<a:font script="Hans" typeface="宋体"/>', r[r.length] = '<a:font script="Hant" typeface="新細明體"/>', r[r.length] = '<a:font script="Arab" typeface="Arial"/>', r[r.length] = '<a:font script="Hebr" typeface="Arial"/>', r[r.length] = '<a:font script="Thai" typeface="Tahoma"/>', r[r.length] = '<a:font script="Ethi" typeface="Nyala"/>', r[r.length] = '<a:font script="Beng" typeface="Vrinda"/>', r[r.length] = '<a:font script="Gujr" typeface="Shruti"/>', r[r.length] = '<a:font script="Khmr" typeface="DaunPenh"/>', r[r.length] = '<a:font script="Knda" typeface="Tunga"/>', r[r.length] = '<a:font script="Guru" typeface="Raavi"/>', r[r.length] = '<a:font script="Cans" typeface="Euphemia"/>', r[r.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', r[r.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', r[r.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', r[r.length] = '<a:font script="Thaa" typeface="MV Boli"/>', r[r.length] = '<a:font script="Deva" typeface="Mangal"/>', r[r.length] = '<a:font script="Telu" typeface="Gautami"/>', r[r.length] = '<a:font script="Taml" typeface="Latha"/>', r[r.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', r[r.length] = '<a:font script="Orya" typeface="Kalinga"/>', r[r.length] = '<a:font script="Mlym" typeface="Kartika"/>', r[r.length] = '<a:font script="Laoo" typeface="DokChampa"/>', r[r.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', r[r.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', r[r.length] = '<a:font script="Viet" typeface="Arial"/>', r[r.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', r[r.length] = '<a:font script="Geor" typeface="Sylfaen"/>', r[r.length] = "</a:minorFont>", r[r.length] = "</a:fontScheme>", r[r.length] = '<a:fmtScheme name="Office">', r[r.length] = "<a:fillStyleLst>", r[r.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:lin ang="16200000" scaled="1"/>', r[r.length] = "</a:gradFill>", r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:lin ang="16200000" scaled="0"/>', r[r.length] = "</a:gradFill>", r[r.length] = "</a:fillStyleLst>", r[r.length] = "<a:lnStyleLst>", r[r.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>', r[r.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', r[r.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', r[r.length] = "</a:lnStyleLst>", r[r.length] = "<a:effectStyleLst>", r[r.length] = "<a:effectStyle>", r[r.length] = "<a:effectLst>", r[r.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>', r[r.length] = "</a:effectLst>", r[r.length] = "</a:effectStyle>", r[r.length] = "<a:effectStyle>", r[r.length] = "<a:effectLst>", r[r.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', r[r.length] = "</a:effectLst>", r[r.length] = "</a:effectStyle>", r[r.length] = "<a:effectStyle>", r[r.length] = "<a:effectLst>", r[r.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', r[r.length] = "</a:effectLst>", r[r.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>', r[r.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>', r[r.length] = "</a:effectStyle>", r[r.length] = "</a:effectStyleLst>", r[r.length] = "<a:bgFillStyleLst>", r[r.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>', r[r.length] = "</a:gradFill>", r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>', r[r.length] = "</a:gradFill>", r[r.length] = "</a:bgFillStyleLst>", r[r.length] = "</a:fmtScheme>", r[r.length] = "</a:themeElements>", r[r.length] = "<a:objectDefaults>", r[r.length] = "<a:spDef>", r[r.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>', r[r.length] = "</a:spDef>", r[r.length] = "<a:lnDef>", r[r.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>', r[r.length] = "</a:lnDef>", r[r.length] = "</a:objectDefaults>", r[r.length] = "<a:extraClrSchemeLst/>", r[r.length] = "</a:theme>", r.join("");
}
function P9e(e, t) {
  return {
    flags: e.read_shift(4),
    version: e.read_shift(4),
    name: Xa(e)
  };
}
function R9e(e) {
  var t = Ke(12 + 2 * e.name.length);
  return t.write_shift(4, e.flags), t.write_shift(4, e.version), ga(e.name, t), t.slice(0, t.l);
}
function I9e(e) {
  for (var t = [], r = e.read_shift(4); r-- > 0; )
    t.push([e.read_shift(4), e.read_shift(4)]);
  return t;
}
function D9e(e) {
  var t = Ke(4 + 8 * e.length);
  t.write_shift(4, e.length);
  for (var r = 0; r < e.length; ++r)
    t.write_shift(4, e[r][0]), t.write_shift(4, e[r][1]);
  return t;
}
function N9e(e, t) {
  var r = Ke(8 + 2 * t.length);
  return r.write_shift(4, e), ga(t, r), r.slice(0, r.l);
}
function M9e(e) {
  return e.l += 4, e.read_shift(4) != 0;
}
function L9e(e, t) {
  var r = Ke(8);
  return r.write_shift(4, e), r.write_shift(4, 1), r;
}
function j9e() {
  var e = xs();
  return nt(e, 332), nt(e, 334, Bi(1)), nt(e, 335, R9e({
    name: "XLDAPR",
    version: 12e4,
    flags: 3496657072
  })), nt(e, 336), nt(e, 339, N9e(1, "XLDAPR")), nt(e, 52), nt(e, 35, Bi(514)), nt(e, 4096, Bi(0)), nt(e, 4097, ai(1)), nt(e, 36), nt(e, 53), nt(e, 340), nt(e, 337, L9e(1)), nt(e, 51, D9e([[1, 0]])), nt(e, 338), nt(e, 333), e.end();
}
function z9() {
  var e = [ra];
  return e.push(`<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">
  <metadataTypes count="1">
    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>
  </metadataTypes>
  <futureMetadata name="XLDAPR" count="1">
    <bk>
      <extLst>
        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">
          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>
        </ext>
      </extLst>
    </bk>
  </futureMetadata>
  <cellMetadata count="1">
    <bk>
      <rc t="1" v="0"/>
    </bk>
  </cellMetadata>
</metadata>`), e.join("");
}
function F9e(e) {
  var t = {};
  t.i = e.read_shift(4);
  var r = {};
  r.r = e.read_shift(4), r.c = e.read_shift(4), t.r = Zr(r);
  var n = e.read_shift(1);
  return n & 2 && (t.l = "1"), n & 8 && (t.a = "1"), t;
}
var Df = 1024;
function K9(e, t) {
  for (var r = [21600, 21600], n = ["m0,0l0", r[1], r[0], r[1], r[0], "0xe"].join(","), a = [
    vt("xml", null, { "xmlns:v": Us.v, "xmlns:o": Us.o, "xmlns:x": Us.x, "xmlns:mv": Us.mv }).replace(/\/>/, ">"),
    vt("o:shapelayout", vt("o:idmap", null, { "v:ext": "edit", data: e }), { "v:ext": "edit" }),
    vt("v:shapetype", [
      vt("v:stroke", null, { joinstyle: "miter" }),
      vt("v:path", null, { gradientshapeok: "t", "o:connecttype": "rect" })
    ].join(""), { id: "_x0000_t202", "o:spt": 202, coordsize: r.join(","), path: n })
  ]; Df < e * 1e3; ) Df += 1e3;
  return t.forEach(function(s) {
    var i = ma(s[0]), o = (
      /*::(*/
      { color2: "#BEFF82", type: "gradient" }
    );
    o.type == "gradient" && (o.angle = "-180");
    var l = o.type == "gradient" ? vt("o:fill", null, { type: "gradientUnscaled", "v:ext": "view" }) : null, c = vt("v:fill", l, o), u = { on: "t", obscured: "t" };
    ++Df, a = a.concat([
      "<v:shape" + vg({
        id: "_x0000_s" + Df,
        type: "#_x0000_t202",
        style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (s[1].hidden ? ";visibility:hidden" : ""),
        fillcolor: "#ECFAD4",
        strokecolor: "#edeaa1"
      }) + ">",
      c,
      vt("v:shadow", null, u),
      vt("v:path", null, { "o:connecttype": "none" }),
      '<v:textbox><div style="text-align:left"></div></v:textbox>',
      '<x:ClientData ObjectType="Note">',
      "<x:MoveWithCells/>",
      "<x:SizeWithCells/>",
      /* Part 4 19.4.2.3 Anchor (Anchor) */
      Aa("x:Anchor", [i.c + 1, 0, i.r + 1, 0, i.c + 3, 20, i.r + 5, 20].join(",")),
      Aa("x:AutoFill", "False"),
      Aa("x:Row", String(i.r)),
      Aa("x:Column", String(i.c)),
      s[1].hidden ? "" : "<x:Visible/>",
      "</x:ClientData>",
      "</v:shape>"
    ]);
  }), a.push("</xml>"), a.join("");
}
function q9(e) {
  var t = [ra, vt("comments", null, { xmlns: Gh[0] })], r = [];
  return t.push("<authors>"), e.forEach(function(n) {
    n[1].forEach(function(a) {
      var s = Jr(a.a);
      r.indexOf(s) == -1 && (r.push(s), t.push("<author>" + s + "</author>")), a.T && a.ID && r.indexOf("tc=" + a.ID) == -1 && (r.push("tc=" + a.ID), t.push("<author>tc=" + a.ID + "</author>"));
    });
  }), r.length == 0 && (r.push("SheetJ5"), t.push("<author>SheetJ5</author>")), t.push("</authors>"), t.push("<commentList>"), e.forEach(function(n) {
    var a = 0, s = [];
    if (n[1][0] && n[1][0].T && n[1][0].ID ? a = r.indexOf("tc=" + n[1][0].ID) : n[1].forEach(function(l) {
      l.a && (a = r.indexOf(Jr(l.a))), s.push(l.t || "");
    }), t.push('<comment ref="' + n[0] + '" authorId="' + a + '"><text>'), s.length <= 1) t.push(Aa("t", Jr(s[0] || "")));
    else {
      for (var i = `Comment:
    ` + s[0] + `
`, o = 1; o < s.length; ++o) i += `Reply:
    ` + s[o] + `
`;
      t.push(Aa("t", Jr(i)));
    }
    t.push("</text></comment>");
  }), t.push("</commentList>"), t.length > 2 && (t[t.length] = "</comments>", t[1] = t[1].replace("/>", ">")), t.join("");
}
function B9e(e, t, r) {
  var n = [ra, vt("ThreadedComments", null, { xmlns: pa.TCMNT }).replace(/[\/]>/, ">")];
  return e.forEach(function(a) {
    var s = "";
    (a[1] || []).forEach(function(i, o) {
      if (!i.T) {
        delete i.ID;
        return;
      }
      i.a && t.indexOf(i.a) == -1 && t.push(i.a);
      var l = {
        ref: a[0],
        id: "{54EE7951-7262-4200-6969-" + ("000000000000" + r.tcid++).slice(-12) + "}"
      };
      o == 0 ? s = l.id : l.parentId = s, i.ID = l.id, i.a && (l.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + t.indexOf(i.a)).slice(-12) + "}"), n.push(vt("threadedComment", Aa("text", i.t || ""), l));
    });
  }), n.push("</ThreadedComments>"), n.join("");
}
function U9e(e) {
  var t = [ra, vt("personList", null, {
    xmlns: pa.TCMNT,
    "xmlns:x": Gh[0]
  }).replace(/[\/]>/, ">")];
  return e.forEach(function(r, n) {
    t.push(vt("person", null, {
      displayName: r,
      id: "{54EE7950-7262-4200-6969-" + ("000000000000" + n).slice(-12) + "}",
      userId: r,
      providerId: "None"
    }));
  }), t.push("</personList>"), t.join("");
}
function V9e(e) {
  var t = {};
  t.iauthor = e.read_shift(4);
  var r = Cd(e);
  return t.rfx = r.s, t.ref = Zr(r.s), e.l += 16, t;
}
function $9e(e, t) {
  return t == null && (t = Ke(36)), t.write_shift(4, e[1].iauthor), Xh(e[0], t), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(4, 0), t;
}
var H9e = Xa;
function W9e(e) {
  return ga(e.slice(0, 54));
}
function z9e(e) {
  var t = xs(), r = [];
  return nt(
    t,
    628
    /* BrtBeginComments */
  ), nt(
    t,
    630
    /* BrtBeginCommentAuthors */
  ), e.forEach(function(n) {
    n[1].forEach(function(a) {
      r.indexOf(a.a) > -1 || (r.push(a.a.slice(0, 54)), nt(t, 632, W9e(a.a)));
    });
  }), nt(
    t,
    631
    /* BrtEndCommentAuthors */
  ), nt(
    t,
    633
    /* BrtBeginCommentList */
  ), e.forEach(function(n) {
    n[1].forEach(function(a) {
      a.iauthor = r.indexOf(a.a);
      var s = { s: ma(n[0]), e: ma(n[0]) };
      nt(t, 635, $9e([s, a])), a.t && a.t.length > 0 && nt(t, 637, qHe(a)), nt(
        t,
        636
        /* BrtEndComment */
      ), delete a.iauthor;
    });
  }), nt(
    t,
    634
    /* BrtEndCommentList */
  ), nt(
    t,
    629
    /* BrtEndComments */
  ), t.end();
}
function K9e(e, t) {
  t.FullPaths.forEach(function(r, n) {
    if (n != 0) {
      var a = r.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
      a.slice(-1) !== "/" && rn.utils.cfb_add(e, a, t.FileIndex[n].content);
    }
  });
}
var G9 = ["xlsb", "xlsm", "xlam", "biff8", "xla"], q9e = /* @__PURE__ */ function() {
  var e = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g, t = { r: 0, c: 0 };
  function r(n, a, s, i) {
    var o = !1, l = !1;
    s.length == 0 ? l = !0 : s.charAt(0) == "[" && (l = !0, s = s.slice(1, -1)), i.length == 0 ? o = !0 : i.charAt(0) == "[" && (o = !0, i = i.slice(1, -1));
    var c = s.length > 0 ? parseInt(s, 10) | 0 : 0, u = i.length > 0 ? parseInt(i, 10) | 0 : 0;
    return o ? u += t.c : --u, l ? c += t.r : --c, a + (o ? "" : "$") + Ya(u) + (l ? "" : "$") + Ra(c);
  }
  return function(a, s) {
    return t = s, a.replace(e, r);
  };
}(), X2 = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g, Q2 = /* @__PURE__ */ function() {
  return function(t, r) {
    return t.replace(X2, function(n, a, s, i, o, l) {
      var c = W2(i) - (s ? 0 : r.c), u = H2(l) - (o ? 0 : r.r), d = u == 0 ? "" : o ? u + 1 : "[" + u + "]", f = c == 0 ? "" : s ? c + 1 : "[" + c + "]";
      return a + "R" + d + "C" + f;
    });
  };
}();
function G9e(e, t) {
  return e.replace(X2, function(r, n, a, s, i, o) {
    return n + (a == "$" ? a + s : Ya(W2(s) + t.c)) + (i == "$" ? i + o : Ra(H2(o) + t.r));
  });
}
function Y9e(e) {
  return e.length != 1;
}
function Yn(e) {
  e.l += 1;
}
function Uc(e, t) {
  var r = e.read_shift(2);
  return [r & 16383, r >> 14 & 1, r >> 15 & 1];
}
function Y9(e, t, r) {
  var n = 2;
  if (r) {
    if (r.biff >= 2 && r.biff <= 5) return X9(e);
    r.biff == 12 && (n = 4);
  }
  var a = e.read_shift(n), s = e.read_shift(n), i = Uc(e), o = Uc(e);
  return { s: { r: a, c: i[0], cRel: i[1], rRel: i[2] }, e: { r: s, c: o[0], cRel: o[1], rRel: o[2] } };
}
function X9(e) {
  var t = Uc(e), r = Uc(e), n = e.read_shift(1), a = e.read_shift(1);
  return { s: { r: t[0], c: n, cRel: t[1], rRel: t[2] }, e: { r: r[0], c: a, cRel: r[1], rRel: r[2] } };
}
function X9e(e, t, r) {
  if (r.biff < 8) return X9(e);
  var n = e.read_shift(r.biff == 12 ? 4 : 2), a = e.read_shift(r.biff == 12 ? 4 : 2), s = Uc(e), i = Uc(e);
  return { s: { r: n, c: s[0], cRel: s[1], rRel: s[2] }, e: { r: a, c: i[0], cRel: i[1], rRel: i[2] } };
}
function Q9(e, t, r) {
  if (r && r.biff >= 2 && r.biff <= 5) return Q9e(e);
  var n = e.read_shift(r && r.biff == 12 ? 4 : 2), a = Uc(e);
  return { r: n, c: a[0], cRel: a[1], rRel: a[2] };
}
function Q9e(e) {
  var t = Uc(e), r = e.read_shift(1);
  return { r: t[0], c: r, cRel: t[1], rRel: t[2] };
}
function J9e(e) {
  var t = e.read_shift(2), r = e.read_shift(2);
  return { r: t, c: r & 255, fQuoted: !!(r & 16384), cRel: r >> 15, rRel: r >> 15 };
}
function Z9e(e, t, r) {
  var n = r && r.biff ? r.biff : 8;
  if (n >= 2 && n <= 5) return eWe(e);
  var a = e.read_shift(n >= 12 ? 4 : 2), s = e.read_shift(2), i = (s & 16384) >> 14, o = (s & 32768) >> 15;
  if (s &= 16383, o == 1) for (; a > 524287; ) a -= 1048576;
  if (i == 1) for (; s > 8191; ) s = s - 16384;
  return { r: a, c: s, cRel: i, rRel: o };
}
function eWe(e) {
  var t = e.read_shift(2), r = e.read_shift(1), n = (t & 32768) >> 15, a = (t & 16384) >> 14;
  return t &= 16383, n == 1 && t >= 8192 && (t = t - 16384), a == 1 && r >= 128 && (r = r - 256), { r: t, c: r, cRel: a, rRel: n };
}
function tWe(e, t, r) {
  var n = (e[e.l++] & 96) >> 5, a = Y9(e, r.biff >= 2 && r.biff <= 5 ? 6 : 8, r);
  return [n, a];
}
function rWe(e, t, r) {
  var n = (e[e.l++] & 96) >> 5, a = e.read_shift(2, "i"), s = 8;
  if (r) switch (r.biff) {
    case 5:
      e.l += 12, s = 6;
      break;
    case 12:
      s = 12;
      break;
  }
  var i = Y9(e, s, r);
  return [n, a, i];
}
function nWe(e, t, r) {
  var n = (e[e.l++] & 96) >> 5;
  return e.l += r && r.biff > 8 ? 12 : r.biff < 8 ? 6 : 8, [n];
}
function aWe(e, t, r) {
  var n = (e[e.l++] & 96) >> 5, a = e.read_shift(2), s = 8;
  if (r) switch (r.biff) {
    case 5:
      e.l += 12, s = 6;
      break;
    case 12:
      s = 12;
      break;
  }
  return e.l += s, [n, a];
}
function sWe(e, t, r) {
  var n = (e[e.l++] & 96) >> 5, a = X9e(e, t - 1, r);
  return [n, a];
}
function iWe(e, t, r) {
  var n = (e[e.l++] & 96) >> 5;
  return e.l += r.biff == 2 ? 6 : r.biff == 12 ? 14 : 7, [n];
}
function u4(e) {
  var t = e[e.l + 1] & 1, r = 1;
  return e.l += 4, [t, r];
}
function oWe(e, t, r) {
  e.l += 2;
  for (var n = e.read_shift(r && r.biff == 2 ? 1 : 2), a = [], s = 0; s <= n; ++s) a.push(e.read_shift(r && r.biff == 2 ? 1 : 2));
  return a;
}
function lWe(e, t, r) {
  var n = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [n, e.read_shift(r && r.biff == 2 ? 1 : 2)];
}
function cWe(e, t, r) {
  var n = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [n, e.read_shift(r && r.biff == 2 ? 1 : 2)];
}
function uWe(e) {
  var t = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [t, e.read_shift(2)];
}
function dWe(e, t, r) {
  var n = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += r && r.biff == 2 ? 3 : 4, [n];
}
function J9(e) {
  var t = e.read_shift(1), r = e.read_shift(1);
  return [t, r];
}
function fWe(e) {
  return e.read_shift(2), J9(e);
}
function hWe(e) {
  return e.read_shift(2), J9(e);
}
function pWe(e, t, r) {
  var n = (e[e.l] & 96) >> 5;
  e.l += 1;
  var a = Q9(e, 0, r);
  return [n, a];
}
function mWe(e, t, r) {
  var n = (e[e.l] & 96) >> 5;
  e.l += 1;
  var a = Z9e(e, 0, r);
  return [n, a];
}
function gWe(e, t, r) {
  var n = (e[e.l] & 96) >> 5;
  e.l += 1;
  var a = e.read_shift(2);
  r && r.biff == 5 && (e.l += 12);
  var s = Q9(e, 0, r);
  return [n, a, s];
}
function vWe(e, t, r) {
  var n = (e[e.l] & 96) >> 5;
  e.l += 1;
  var a = e.read_shift(r && r.biff <= 3 ? 1 : 2);
  return [vze[a], tW[a], n];
}
function yWe(e, t, r) {
  var n = e[e.l++], a = e.read_shift(1), s = r && r.biff <= 3 ? [n == 88 ? -1 : 0, e.read_shift(1)] : bWe(e);
  return [a, (s[0] === 0 ? tW : gze)[s[1]]];
}
function bWe(e) {
  return [e[e.l + 1] >> 7, e.read_shift(2) & 32767];
}
function wWe(e, t, r) {
  e.l += r && r.biff == 2 ? 3 : 4;
}
function xWe(e, t, r) {
  if (e.l++, r && r.biff == 12) return [e.read_shift(4, "i"), 0];
  var n = e.read_shift(2), a = e.read_shift(r && r.biff == 2 ? 1 : 2);
  return [n, a];
}
function _We(e) {
  return e.l++, _v[e.read_shift(1)];
}
function SWe(e) {
  return e.l++, e.read_shift(2);
}
function EWe(e) {
  return e.l++, e.read_shift(1) !== 0;
}
function TWe(e) {
  return e.l++, Qh(e);
}
function CWe(e, t, r) {
  return e.l++, N9(e, t - 1, r);
}
function kWe(e, t) {
  var r = [e.read_shift(1)];
  if (t == 12) switch (r[0]) {
    case 2:
      r[0] = 4;
      break;
    case 4:
      r[0] = 16;
      break;
    case 0:
      r[0] = 1;
      break;
    case 1:
      r[0] = 2;
      break;
  }
  switch (r[0]) {
    case 4:
      r[1] = g7e(e, 1) ? "TRUE" : "FALSE", t != 12 && (e.l += 7);
      break;
    case 37:
    case 16:
      r[1] = _v[e[e.l]], e.l += t == 12 ? 4 : 8;
      break;
    case 0:
      e.l += 8;
      break;
    case 1:
      r[1] = Qh(e);
      break;
    case 2:
      r[1] = w7e(e, 0, { biff: t > 0 && t < 8 ? 2 : t });
      break;
    default:
      throw new Error("Bad SerAr: " + r[0]);
  }
  return r;
}
function OWe(e, t, r) {
  for (var n = e.read_shift(r.biff == 12 ? 4 : 2), a = [], s = 0; s != n; ++s) a.push((r.biff == 12 ? Cd : S7e)(e));
  return a;
}
function AWe(e, t, r) {
  var n = 0, a = 0;
  r.biff == 12 ? (n = e.read_shift(4), a = e.read_shift(4)) : (a = 1 + e.read_shift(1), n = 1 + e.read_shift(2)), r.biff >= 2 && r.biff < 8 && (--n, --a == 0 && (a = 256));
  for (var s = 0, i = []; s != n && (i[s] = []); ++s)
    for (var o = 0; o != a; ++o) i[s][o] = kWe(e, r.biff);
  return i;
}
function PWe(e, t, r) {
  var n = e.read_shift(1) >>> 5 & 3, a = !r || r.biff >= 8 ? 4 : 2, s = e.read_shift(a);
  switch (r.biff) {
    case 2:
      e.l += 5;
      break;
    case 3:
    case 4:
      e.l += 8;
      break;
    case 5:
      e.l += 12;
      break;
  }
  return [n, 0, s];
}
function RWe(e, t, r) {
  if (r.biff == 5) return IWe(e);
  var n = e.read_shift(1) >>> 5 & 3, a = e.read_shift(2), s = e.read_shift(4);
  return [n, a, s];
}
function IWe(e) {
  var t = e.read_shift(1) >>> 5 & 3, r = e.read_shift(2, "i");
  e.l += 8;
  var n = e.read_shift(2);
  return e.l += 12, [t, r, n];
}
function DWe(e, t, r) {
  var n = e.read_shift(1) >>> 5 & 3;
  e.l += r && r.biff == 2 ? 3 : 4;
  var a = e.read_shift(r && r.biff == 2 ? 1 : 2);
  return [n, a];
}
function NWe(e, t, r) {
  var n = e.read_shift(1) >>> 5 & 3, a = e.read_shift(r && r.biff == 2 ? 1 : 2);
  return [n, a];
}
function MWe(e, t, r) {
  var n = e.read_shift(1) >>> 5 & 3;
  return e.l += 4, r.biff < 8 && e.l--, r.biff == 12 && (e.l += 2), [n];
}
function LWe(e, t, r) {
  var n = (e[e.l++] & 96) >> 5, a = e.read_shift(2), s = 4;
  if (r) switch (r.biff) {
    case 5:
      s = 15;
      break;
    case 12:
      s = 6;
      break;
  }
  return e.l += s, [n, a];
}
var jWe = Vo, FWe = Vo, BWe = Vo;
function Sv(e, t, r) {
  return e.l += 2, [J9e(e)];
}
function J2(e) {
  return e.l += 6, [];
}
var UWe = Sv, VWe = J2, $We = J2, HWe = Sv;
function Z9(e) {
  return e.l += 2, [I9(e), e.read_shift(2) & 1];
}
var WWe = Sv, zWe = Z9, KWe = J2, qWe = Sv, GWe = Sv, YWe = [
  "Data",
  "All",
  "Headers",
  "??",
  "?Data2",
  "??",
  "?DataHeaders",
  "??",
  "Totals",
  "??",
  "??",
  "??",
  "?DataTotals",
  "??",
  "??",
  "??",
  "?Current"
];
function XWe(e) {
  e.l += 2;
  var t = e.read_shift(2), r = e.read_shift(2), n = e.read_shift(4), a = e.read_shift(2), s = e.read_shift(2), i = YWe[r >> 2 & 31];
  return { ixti: t, coltype: r & 3, rt: i, idx: n, c: a, C: s };
}
function QWe(e) {
  return e.l += 2, [e.read_shift(4)];
}
function JWe(e, t, r) {
  return e.l += 5, e.l += 2, e.l += r.biff == 2 ? 1 : 4, ["PTGSHEET"];
}
function ZWe(e, t, r) {
  return e.l += r.biff == 2 ? 4 : 5, ["PTGENDSHEET"];
}
function eze(e) {
  var t = e.read_shift(1) >>> 5 & 3, r = e.read_shift(2);
  return [t, r];
}
function tze(e) {
  var t = e.read_shift(1) >>> 5 & 3, r = e.read_shift(2);
  return [t, r];
}
function rze(e) {
  return e.l += 4, [0, 0];
}
var d4 = {
  /*::[*/
  1: { n: "PtgExp", f: xWe },
  /*::[*/
  2: { n: "PtgTbl", f: BWe },
  /*::[*/
  3: { n: "PtgAdd", f: Yn },
  /*::[*/
  4: { n: "PtgSub", f: Yn },
  /*::[*/
  5: { n: "PtgMul", f: Yn },
  /*::[*/
  6: { n: "PtgDiv", f: Yn },
  /*::[*/
  7: { n: "PtgPower", f: Yn },
  /*::[*/
  8: { n: "PtgConcat", f: Yn },
  /*::[*/
  9: { n: "PtgLt", f: Yn },
  /*::[*/
  10: { n: "PtgLe", f: Yn },
  /*::[*/
  11: { n: "PtgEq", f: Yn },
  /*::[*/
  12: { n: "PtgGe", f: Yn },
  /*::[*/
  13: { n: "PtgGt", f: Yn },
  /*::[*/
  14: { n: "PtgNe", f: Yn },
  /*::[*/
  15: { n: "PtgIsect", f: Yn },
  /*::[*/
  16: { n: "PtgUnion", f: Yn },
  /*::[*/
  17: { n: "PtgRange", f: Yn },
  /*::[*/
  18: { n: "PtgUplus", f: Yn },
  /*::[*/
  19: { n: "PtgUminus", f: Yn },
  /*::[*/
  20: { n: "PtgPercent", f: Yn },
  /*::[*/
  21: { n: "PtgParen", f: Yn },
  /*::[*/
  22: { n: "PtgMissArg", f: Yn },
  /*::[*/
  23: { n: "PtgStr", f: CWe },
  /*::[*/
  26: { n: "PtgSheet", f: JWe },
  /*::[*/
  27: { n: "PtgEndSheet", f: ZWe },
  /*::[*/
  28: { n: "PtgErr", f: _We },
  /*::[*/
  29: { n: "PtgBool", f: EWe },
  /*::[*/
  30: { n: "PtgInt", f: SWe },
  /*::[*/
  31: { n: "PtgNum", f: TWe },
  /*::[*/
  32: { n: "PtgArray", f: iWe },
  /*::[*/
  33: { n: "PtgFunc", f: vWe },
  /*::[*/
  34: { n: "PtgFuncVar", f: yWe },
  /*::[*/
  35: { n: "PtgName", f: PWe },
  /*::[*/
  36: { n: "PtgRef", f: pWe },
  /*::[*/
  37: { n: "PtgArea", f: tWe },
  /*::[*/
  38: { n: "PtgMemArea", f: DWe },
  /*::[*/
  39: { n: "PtgMemErr", f: jWe },
  /*::[*/
  40: { n: "PtgMemNoMem", f: FWe },
  /*::[*/
  41: { n: "PtgMemFunc", f: NWe },
  /*::[*/
  42: { n: "PtgRefErr", f: MWe },
  /*::[*/
  43: { n: "PtgAreaErr", f: nWe },
  /*::[*/
  44: { n: "PtgRefN", f: mWe },
  /*::[*/
  45: { n: "PtgAreaN", f: sWe },
  /*::[*/
  46: { n: "PtgMemAreaN", f: eze },
  /*::[*/
  47: { n: "PtgMemNoMemN", f: tze },
  /*::[*/
  57: { n: "PtgNameX", f: RWe },
  /*::[*/
  58: { n: "PtgRef3d", f: gWe },
  /*::[*/
  59: { n: "PtgArea3d", f: rWe },
  /*::[*/
  60: { n: "PtgRefErr3d", f: LWe },
  /*::[*/
  61: { n: "PtgAreaErr3d", f: aWe },
  /*::[*/
  255: {}
}, nze = {
  /*::[*/
  64: 32,
  /*::[*/
  96: 32,
  /*::[*/
  65: 33,
  /*::[*/
  97: 33,
  /*::[*/
  66: 34,
  /*::[*/
  98: 34,
  /*::[*/
  67: 35,
  /*::[*/
  99: 35,
  /*::[*/
  68: 36,
  /*::[*/
  100: 36,
  /*::[*/
  69: 37,
  /*::[*/
  101: 37,
  /*::[*/
  70: 38,
  /*::[*/
  102: 38,
  /*::[*/
  71: 39,
  /*::[*/
  103: 39,
  /*::[*/
  72: 40,
  /*::[*/
  104: 40,
  /*::[*/
  73: 41,
  /*::[*/
  105: 41,
  /*::[*/
  74: 42,
  /*::[*/
  106: 42,
  /*::[*/
  75: 43,
  /*::[*/
  107: 43,
  /*::[*/
  76: 44,
  /*::[*/
  108: 44,
  /*::[*/
  77: 45,
  /*::[*/
  109: 45,
  /*::[*/
  78: 46,
  /*::[*/
  110: 46,
  /*::[*/
  79: 47,
  /*::[*/
  111: 47,
  /*::[*/
  88: 34,
  /*::[*/
  120: 34,
  /*::[*/
  89: 57,
  /*::[*/
  121: 57,
  /*::[*/
  90: 58,
  /*::[*/
  122: 58,
  /*::[*/
  91: 59,
  /*::[*/
  123: 59,
  /*::[*/
  92: 60,
  /*::[*/
  124: 60,
  /*::[*/
  93: 61,
  /*::[*/
  125: 61
}, aze = {
  /*::[*/
  1: { n: "PtgElfLel", f: Z9 },
  /*::[*/
  2: { n: "PtgElfRw", f: qWe },
  /*::[*/
  3: { n: "PtgElfCol", f: UWe },
  /*::[*/
  6: { n: "PtgElfRwV", f: GWe },
  /*::[*/
  7: { n: "PtgElfColV", f: HWe },
  /*::[*/
  10: { n: "PtgElfRadical", f: WWe },
  /*::[*/
  11: { n: "PtgElfRadicalS", f: KWe },
  /*::[*/
  13: { n: "PtgElfColS", f: VWe },
  /*::[*/
  15: { n: "PtgElfColSV", f: $We },
  /*::[*/
  16: { n: "PtgElfRadicalLel", f: zWe },
  /*::[*/
  25: { n: "PtgList", f: XWe },
  /*::[*/
  29: { n: "PtgSxName", f: QWe },
  /*::[*/
  255: {}
}, sze = {
  /*::[*/
  0: { n: "PtgAttrNoop", f: rze },
  /*::[*/
  1: { n: "PtgAttrSemi", f: dWe },
  /*::[*/
  2: { n: "PtgAttrIf", f: cWe },
  /*::[*/
  4: { n: "PtgAttrChoose", f: oWe },
  /*::[*/
  8: { n: "PtgAttrGoto", f: lWe },
  /*::[*/
  16: { n: "PtgAttrSum", f: wWe },
  /*::[*/
  32: { n: "PtgAttrBaxcel", f: u4 },
  /*::[*/
  33: { n: "PtgAttrBaxcel", f: u4 },
  /*::[*/
  64: { n: "PtgAttrSpace", f: fWe },
  /*::[*/
  65: { n: "PtgAttrSpaceSemi", f: hWe },
  /*::[*/
  128: { n: "PtgAttrIfError", f: uWe },
  /*::[*/
  255: {}
};
function ize(e, t, r, n) {
  if (n.biff < 8) return Vo(e, t);
  for (var a = e.l + t, s = [], i = 0; i !== r.length; ++i)
    switch (r[i][0]) {
      case "PtgArray":
        r[i][1] = AWe(e, 0, n), s.push(r[i][1]);
        break;
      case "PtgMemArea":
        r[i][2] = OWe(e, r[i][1], n), s.push(r[i][2]);
        break;
      case "PtgExp":
        n && n.biff == 12 && (r[i][1][1] = e.read_shift(4), s.push(r[i][1]));
        break;
      case "PtgList":
      case "PtgElfRadicalS":
      case "PtgElfColS":
      case "PtgElfColSV":
        throw "Unsupported " + r[i][0];
    }
  return t = a - e.l, t !== 0 && s.push(Vo(e, t)), s;
}
function oze(e, t, r) {
  for (var n = e.l + t, a, s, i = []; n != e.l; )
    t = n - e.l, s = e[e.l], a = d4[s] || d4[nze[s]], (s === 24 || s === 25) && (a = (s === 24 ? aze : sze)[e[e.l + 1]]), !a || !a.f ? Vo(e, t) : i.push([a.n, a.f(e, t, r)]);
  return i;
}
function lze(e) {
  for (var t = [], r = 0; r < e.length; ++r) {
    for (var n = e[r], a = [], s = 0; s < n.length; ++s) {
      var i = n[s];
      if (i) switch (i[0]) {
        case 2:
          a.push('"' + i[1].replace(/"/g, '""') + '"');
          break;
        default:
          a.push(i[1]);
      }
      else a.push("");
    }
    t.push(a.join(","));
  }
  return t.join(";");
}
var cze = {
  PtgAdd: "+",
  PtgConcat: "&",
  PtgDiv: "/",
  PtgEq: "=",
  PtgGe: ">=",
  PtgGt: ">",
  PtgLe: "<=",
  PtgLt: "<",
  PtgMul: "*",
  PtgNe: "<>",
  PtgPower: "^",
  PtgSub: "-"
};
function uze(e, t) {
  if (!e && !(t && t.biff <= 5 && t.biff >= 2)) throw new Error("empty sheet name");
  return /[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(e) ? "'" + e + "'" : e;
}
function eW(e, t, r) {
  if (!e) return "SH33TJSERR0";
  if (r.biff > 8 && (!e.XTI || !e.XTI[t])) return e.SheetNames[t];
  if (!e.XTI) return "SH33TJSERR6";
  var n = e.XTI[t];
  if (r.biff < 8)
    return t > 1e4 && (t -= 65536), t < 0 && (t = -t), t == 0 ? "" : e.XTI[t - 1];
  if (!n) return "SH33TJSERR1";
  var a = "";
  if (r.biff > 8) switch (e[n[0]][0]) {
    case 357:
      return a = n[1] == -1 ? "#REF" : e.SheetNames[n[1]], n[1] == n[2] ? a : a + ":" + e.SheetNames[n[2]];
    case 358:
      return r.SID != null ? e.SheetNames[r.SID] : "SH33TJSSAME" + e[n[0]][0];
    case 355:
    default:
      return "SH33TJSSRC" + e[n[0]][0];
  }
  switch (e[n[0]][0][0]) {
    case 1025:
      return a = n[1] == -1 ? "#REF" : e.SheetNames[n[1]] || "SH33TJSERR3", n[1] == n[2] ? a : a + ":" + e.SheetNames[n[2]];
    case 14849:
      return e[n[0]].slice(1).map(function(s) {
        return s.Name;
      }).join(";;");
    default:
      return e[n[0]][0][3] ? (a = n[1] == -1 ? "#REF" : e[n[0]][0][3][n[1]] || "SH33TJSERR4", n[1] == n[2] ? a : a + ":" + e[n[0]][0][3][n[2]]) : "SH33TJSERR2";
  }
}
function f4(e, t, r) {
  var n = eW(e, t, r);
  return n == "#REF" ? n : uze(n, r);
}
function mh(e, t, r, n, a) {
  var s = a && a.biff || 8, i = (
    /*range != null ? range :*/
    { s: { c: 0, r: 0 } }
  ), o = [], l, c, u, d = 0, f = 0, h, p = "";
  if (!e[0] || !e[0][0]) return "";
  for (var m = -1, g = "", y = 0, x = e[0].length; y < x; ++y) {
    var w = e[0][y];
    switch (w[0]) {
      case "PtgUminus":
        o.push("-" + o.pop());
        break;
      case "PtgUplus":
        o.push("+" + o.pop());
        break;
      case "PtgPercent":
        o.push(o.pop() + "%");
        break;
      case "PtgAdd":
      case "PtgConcat":
      case "PtgDiv":
      case "PtgEq":
      case "PtgGe":
      case "PtgGt":
      case "PtgLe":
      case "PtgLt":
      case "PtgMul":
      case "PtgNe":
      case "PtgPower":
      case "PtgSub":
        if (l = o.pop(), c = o.pop(), m >= 0) {
          switch (e[0][m][1][0]) {
            case 0:
              g = An(" ", e[0][m][1][1]);
              break;
            case 1:
              g = An("\r", e[0][m][1][1]);
              break;
            default:
              if (g = "", a.WTF) throw new Error("Unexpected PtgAttrSpaceType " + e[0][m][1][0]);
          }
          c = c + g, m = -1;
        }
        o.push(c + cze[w[0]] + l);
        break;
      case "PtgIsect":
        l = o.pop(), c = o.pop(), o.push(c + " " + l);
        break;
      case "PtgUnion":
        l = o.pop(), c = o.pop(), o.push(c + "," + l);
        break;
      case "PtgRange":
        l = o.pop(), c = o.pop(), o.push(c + ":" + l);
        break;
      case "PtgAttrChoose":
        break;
      case "PtgAttrGoto":
        break;
      case "PtgAttrIf":
        break;
      case "PtgAttrIfError":
        break;
      case "PtgRef":
        u = Am(w[1][1], i, a), o.push(Pm(u, s));
        break;
      case "PtgRefN":
        u = r ? Am(w[1][1], r, a) : w[1][1], o.push(Pm(u, s));
        break;
      case "PtgRef3d":
        d = /*::Number(*/
        w[1][1], u = Am(w[1][2], i, a), p = f4(n, d, a), o.push(p + "!" + Pm(u, s));
        break;
      case "PtgFunc":
      case "PtgFuncVar":
        var _ = w[1][0], S = w[1][1];
        _ || (_ = 0), _ &= 127;
        var C = _ == 0 ? [] : o.slice(-_);
        o.length -= _, S === "User" && (S = C.shift()), o.push(S + "(" + C.join(",") + ")");
        break;
      case "PtgBool":
        o.push(w[1] ? "TRUE" : "FALSE");
        break;
      case "PtgInt":
        o.push(
          /*::String(*/
          w[1]
          /*::)*/
        );
        break;
      case "PtgNum":
        o.push(String(w[1]));
        break;
      case "PtgStr":
        o.push('"' + w[1].replace(/"/g, '""') + '"');
        break;
      case "PtgErr":
        o.push(
          /*::String(*/
          w[1]
          /*::)*/
        );
        break;
      case "PtgAreaN":
        h = Xj(w[1][1], r ? { s: r } : i, a), o.push(TS(h, a));
        break;
      case "PtgArea":
        h = Xj(w[1][1], i, a), o.push(TS(h, a));
        break;
      case "PtgArea3d":
        d = /*::Number(*/
        w[1][1], h = w[1][2], p = f4(n, d, a), o.push(p + "!" + TS(h, a));
        break;
      case "PtgAttrSum":
        o.push("SUM(" + o.pop() + ")");
        break;
      case "PtgAttrBaxcel":
      case "PtgAttrSemi":
        break;
      case "PtgName":
        f = w[1][2];
        var E = (n.names || [])[f - 1] || (n[0] || [])[f], O = E ? E.Name : "SH33TJSNAME" + String(f);
        O && O.slice(0, 6) == "_xlfn." && !a.xlfn && (O = O.slice(6)), o.push(O);
        break;
      case "PtgNameX":
        var k = w[1][1];
        f = w[1][2];
        var A;
        if (a.biff <= 5)
          k < 0 && (k = -k), n[k] && (A = n[k][f]);
        else {
          var P = "";
          if (((n[k] || [])[0] || [])[0] == 14849 || (((n[k] || [])[0] || [])[0] == 1025 ? n[k][f] && n[k][f].itab > 0 && (P = n.SheetNames[n[k][f].itab - 1] + "!") : P = n.SheetNames[f - 1] + "!"), n[k] && n[k][f]) P += n[k][f].Name;
          else if (n[0] && n[0][f]) P += n[0][f].Name;
          else {
            var D = (eW(n, k, a) || "").split(";;");
            D[f - 1] ? P = D[f - 1] : P += "SH33TJSERRX";
          }
          o.push(P);
          break;
        }
        A || (A = { Name: "SH33TJSERRY" }), o.push(A.Name);
        break;
      case "PtgParen":
        var N = "(", z = ")";
        if (m >= 0) {
          switch (g = "", e[0][m][1][0]) {
            case 2:
              N = An(" ", e[0][m][1][1]) + N;
              break;
            case 3:
              N = An("\r", e[0][m][1][1]) + N;
              break;
            case 4:
              z = An(" ", e[0][m][1][1]) + z;
              break;
            case 5:
              z = An("\r", e[0][m][1][1]) + z;
              break;
            default:
              if (a.WTF) throw new Error("Unexpected PtgAttrSpaceType " + e[0][m][1][0]);
          }
          m = -1;
        }
        o.push(N + o.pop() + z);
        break;
      case "PtgRefErr":
        o.push("#REF!");
        break;
      case "PtgRefErr3d":
        o.push("#REF!");
        break;
      case "PtgExp":
        u = { c: w[1][1], r: w[1][0] };
        var G = { c: r.c, r: r.r };
        if (n.sharedf[Zr(u)]) {
          var Y = n.sharedf[Zr(u)];
          o.push(mh(Y, i, G, n, a));
        } else {
          var te = !1;
          for (l = 0; l != n.arrayf.length; ++l)
            if (c = n.arrayf[l], !(u.c < c[0].s.c || u.c > c[0].e.c) && !(u.r < c[0].s.r || u.r > c[0].e.r)) {
              o.push(mh(c[1], i, G, n, a)), te = !0;
              break;
            }
          te || o.push(
            /*::String(*/
            w[1]
            /*::)*/
          );
        }
        break;
      case "PtgArray":
        o.push("{" + lze(
          /*::(*/
          w[1]
          /*:: :any)*/
        ) + "}");
        break;
      case "PtgMemArea":
        break;
      case "PtgAttrSpace":
      case "PtgAttrSpaceSemi":
        m = y;
        break;
      case "PtgTbl":
        break;
      case "PtgMemErr":
        break;
      case "PtgMissArg":
        o.push("");
        break;
      case "PtgAreaErr":
        o.push("#REF!");
        break;
      case "PtgAreaErr3d":
        o.push("#REF!");
        break;
      case "PtgList":
        o.push("Table" + w[1].idx + "[#" + w[1].rt + "]");
        break;
      case "PtgMemAreaN":
      case "PtgMemNoMemN":
      case "PtgAttrNoop":
      case "PtgSheet":
      case "PtgEndSheet":
        break;
      case "PtgMemFunc":
        break;
      case "PtgMemNoMem":
        break;
      case "PtgElfCol":
      case "PtgElfColS":
      case "PtgElfColSV":
      case "PtgElfColV":
      case "PtgElfLel":
      case "PtgElfRadical":
      case "PtgElfRadicalLel":
      case "PtgElfRadicalS":
      case "PtgElfRw":
      case "PtgElfRwV":
        throw new Error("Unsupported ELFs");
      case "PtgSxName":
        throw new Error("Unrecognized Formula Token: " + String(w));
      default:
        throw new Error("Unrecognized Formula Token: " + String(w));
    }
    var ae = ["PtgAttrSpace", "PtgAttrSpaceSemi", "PtgAttrGoto"];
    if (a.biff != 3 && m >= 0 && ae.indexOf(e[0][y][0]) == -1) {
      w = e[0][m];
      var ne = !0;
      switch (w[1][0]) {
        case 4:
          ne = !1;
        case 0:
          g = An(" ", w[1][1]);
          break;
        case 5:
          ne = !1;
        case 1:
          g = An("\r", w[1][1]);
          break;
        default:
          if (g = "", a.WTF) throw new Error("Unexpected PtgAttrSpaceType " + w[1][0]);
      }
      o.push((ne ? g : "") + o.pop() + (ne ? "" : g)), m = -1;
    }
  }
  if (o.length > 1 && a.WTF) throw new Error("bad formula stack");
  return o[0];
}
function dze(e) {
  if (e == null) {
    var t = Ke(8);
    return t.write_shift(1, 3), t.write_shift(1, 0), t.write_shift(2, 0), t.write_shift(2, 0), t.write_shift(2, 65535), t;
  } else if (typeof e == "number") return Qu(e);
  return Qu(0);
}
function fze(e, t, r, n, a) {
  var s = Ju(t, r, a), i = dze(e.v), o = Ke(6), l = 33;
  o.write_shift(2, l), o.write_shift(4, 0);
  for (var c = Ke(e.bf.length), u = 0; u < e.bf.length; ++u) c[u] = e.bf[u];
  var d = Oa([s, i, o, c]);
  return d;
}
function Jx(e, t, r) {
  var n = e.read_shift(4), a = oze(e, n, r), s = e.read_shift(4), i = s > 0 ? ize(e, s, a, r) : null;
  return [a, i];
}
var hze = Jx, Zx = Jx, pze = Jx, mze = Jx, gze = {
  0: "BEEP",
  1: "OPEN",
  2: "OPEN.LINKS",
  3: "CLOSE.ALL",
  4: "SAVE",
  5: "SAVE.AS",
  6: "FILE.DELETE",
  7: "PAGE.SETUP",
  8: "PRINT",
  9: "PRINTER.SETUP",
  10: "QUIT",
  11: "NEW.WINDOW",
  12: "ARRANGE.ALL",
  13: "WINDOW.SIZE",
  14: "WINDOW.MOVE",
  15: "FULL",
  16: "CLOSE",
  17: "RUN",
  22: "SET.PRINT.AREA",
  23: "SET.PRINT.TITLES",
  24: "SET.PAGE.BREAK",
  25: "REMOVE.PAGE.BREAK",
  26: "FONT",
  27: "DISPLAY",
  28: "PROTECT.DOCUMENT",
  29: "PRECISION",
  30: "A1.R1C1",
  31: "CALCULATE.NOW",
  32: "CALCULATION",
  34: "DATA.FIND",
  35: "EXTRACT",
  36: "DATA.DELETE",
  37: "SET.DATABASE",
  38: "SET.CRITERIA",
  39: "SORT",
  40: "DATA.SERIES",
  41: "TABLE",
  42: "FORMAT.NUMBER",
  43: "ALIGNMENT",
  44: "STYLE",
  45: "BORDER",
  46: "CELL.PROTECTION",
  47: "COLUMN.WIDTH",
  48: "UNDO",
  49: "CUT",
  50: "COPY",
  51: "PASTE",
  52: "CLEAR",
  53: "PASTE.SPECIAL",
  54: "EDIT.DELETE",
  55: "INSERT",
  56: "FILL.RIGHT",
  57: "FILL.DOWN",
  61: "DEFINE.NAME",
  62: "CREATE.NAMES",
  63: "FORMULA.GOTO",
  64: "FORMULA.FIND",
  65: "SELECT.LAST.CELL",
  66: "SHOW.ACTIVE.CELL",
  67: "GALLERY.AREA",
  68: "GALLERY.BAR",
  69: "GALLERY.COLUMN",
  70: "GALLERY.LINE",
  71: "GALLERY.PIE",
  72: "GALLERY.SCATTER",
  73: "COMBINATION",
  74: "PREFERRED",
  75: "ADD.OVERLAY",
  76: "GRIDLINES",
  77: "SET.PREFERRED",
  78: "AXES",
  79: "LEGEND",
  80: "ATTACH.TEXT",
  81: "ADD.ARROW",
  82: "SELECT.CHART",
  83: "SELECT.PLOT.AREA",
  84: "PATTERNS",
  85: "MAIN.CHART",
  86: "OVERLAY",
  87: "SCALE",
  88: "FORMAT.LEGEND",
  89: "FORMAT.TEXT",
  90: "EDIT.REPEAT",
  91: "PARSE",
  92: "JUSTIFY",
  93: "HIDE",
  94: "UNHIDE",
  95: "WORKSPACE",
  96: "FORMULA",
  97: "FORMULA.FILL",
  98: "FORMULA.ARRAY",
  99: "DATA.FIND.NEXT",
  100: "DATA.FIND.PREV",
  101: "FORMULA.FIND.NEXT",
  102: "FORMULA.FIND.PREV",
  103: "ACTIVATE",
  104: "ACTIVATE.NEXT",
  105: "ACTIVATE.PREV",
  106: "UNLOCKED.NEXT",
  107: "UNLOCKED.PREV",
  108: "COPY.PICTURE",
  109: "SELECT",
  110: "DELETE.NAME",
  111: "DELETE.FORMAT",
  112: "VLINE",
  113: "HLINE",
  114: "VPAGE",
  115: "HPAGE",
  116: "VSCROLL",
  117: "HSCROLL",
  118: "ALERT",
  119: "NEW",
  120: "CANCEL.COPY",
  121: "SHOW.CLIPBOARD",
  122: "MESSAGE",
  124: "PASTE.LINK",
  125: "APP.ACTIVATE",
  126: "DELETE.ARROW",
  127: "ROW.HEIGHT",
  128: "FORMAT.MOVE",
  129: "FORMAT.SIZE",
  130: "FORMULA.REPLACE",
  131: "SEND.KEYS",
  132: "SELECT.SPECIAL",
  133: "APPLY.NAMES",
  134: "REPLACE.FONT",
  135: "FREEZE.PANES",
  136: "SHOW.INFO",
  137: "SPLIT",
  138: "ON.WINDOW",
  139: "ON.DATA",
  140: "DISABLE.INPUT",
  142: "OUTLINE",
  143: "LIST.NAMES",
  144: "FILE.CLOSE",
  145: "SAVE.WORKBOOK",
  146: "DATA.FORM",
  147: "COPY.CHART",
  148: "ON.TIME",
  149: "WAIT",
  150: "FORMAT.FONT",
  151: "FILL.UP",
  152: "FILL.LEFT",
  153: "DELETE.OVERLAY",
  155: "SHORT.MENUS",
  159: "SET.UPDATE.STATUS",
  161: "COLOR.PALETTE",
  162: "DELETE.STYLE",
  163: "WINDOW.RESTORE",
  164: "WINDOW.MAXIMIZE",
  166: "CHANGE.LINK",
  167: "CALCULATE.DOCUMENT",
  168: "ON.KEY",
  169: "APP.RESTORE",
  170: "APP.MOVE",
  171: "APP.SIZE",
  172: "APP.MINIMIZE",
  173: "APP.MAXIMIZE",
  174: "BRING.TO.FRONT",
  175: "SEND.TO.BACK",
  185: "MAIN.CHART.TYPE",
  186: "OVERLAY.CHART.TYPE",
  187: "SELECT.END",
  188: "OPEN.MAIL",
  189: "SEND.MAIL",
  190: "STANDARD.FONT",
  191: "CONSOLIDATE",
  192: "SORT.SPECIAL",
  193: "GALLERY.3D.AREA",
  194: "GALLERY.3D.COLUMN",
  195: "GALLERY.3D.LINE",
  196: "GALLERY.3D.PIE",
  197: "VIEW.3D",
  198: "GOAL.SEEK",
  199: "WORKGROUP",
  200: "FILL.GROUP",
  201: "UPDATE.LINK",
  202: "PROMOTE",
  203: "DEMOTE",
  204: "SHOW.DETAIL",
  206: "UNGROUP",
  207: "OBJECT.PROPERTIES",
  208: "SAVE.NEW.OBJECT",
  209: "SHARE",
  210: "SHARE.NAME",
  211: "DUPLICATE",
  212: "APPLY.STYLE",
  213: "ASSIGN.TO.OBJECT",
  214: "OBJECT.PROTECTION",
  215: "HIDE.OBJECT",
  216: "SET.EXTRACT",
  217: "CREATE.PUBLISHER",
  218: "SUBSCRIBE.TO",
  219: "ATTRIBUTES",
  220: "SHOW.TOOLBAR",
  222: "PRINT.PREVIEW",
  223: "EDIT.COLOR",
  224: "SHOW.LEVELS",
  225: "FORMAT.MAIN",
  226: "FORMAT.OVERLAY",
  227: "ON.RECALC",
  228: "EDIT.SERIES",
  229: "DEFINE.STYLE",
  240: "LINE.PRINT",
  243: "ENTER.DATA",
  249: "GALLERY.RADAR",
  250: "MERGE.STYLES",
  251: "EDITION.OPTIONS",
  252: "PASTE.PICTURE",
  253: "PASTE.PICTURE.LINK",
  254: "SPELLING",
  256: "ZOOM",
  259: "INSERT.OBJECT",
  260: "WINDOW.MINIMIZE",
  265: "SOUND.NOTE",
  266: "SOUND.PLAY",
  267: "FORMAT.SHAPE",
  268: "EXTEND.POLYGON",
  269: "FORMAT.AUTO",
  272: "GALLERY.3D.BAR",
  273: "GALLERY.3D.SURFACE",
  274: "FILL.AUTO",
  276: "CUSTOMIZE.TOOLBAR",
  277: "ADD.TOOL",
  278: "EDIT.OBJECT",
  279: "ON.DOUBLECLICK",
  280: "ON.ENTRY",
  281: "WORKBOOK.ADD",
  282: "WORKBOOK.MOVE",
  283: "WORKBOOK.COPY",
  284: "WORKBOOK.OPTIONS",
  285: "SAVE.WORKSPACE",
  288: "CHART.WIZARD",
  289: "DELETE.TOOL",
  290: "MOVE.TOOL",
  291: "WORKBOOK.SELECT",
  292: "WORKBOOK.ACTIVATE",
  293: "ASSIGN.TO.TOOL",
  295: "COPY.TOOL",
  296: "RESET.TOOL",
  297: "CONSTRAIN.NUMERIC",
  298: "PASTE.TOOL",
  302: "WORKBOOK.NEW",
  305: "SCENARIO.CELLS",
  306: "SCENARIO.DELETE",
  307: "SCENARIO.ADD",
  308: "SCENARIO.EDIT",
  309: "SCENARIO.SHOW",
  310: "SCENARIO.SHOW.NEXT",
  311: "SCENARIO.SUMMARY",
  312: "PIVOT.TABLE.WIZARD",
  313: "PIVOT.FIELD.PROPERTIES",
  314: "PIVOT.FIELD",
  315: "PIVOT.ITEM",
  316: "PIVOT.ADD.FIELDS",
  318: "OPTIONS.CALCULATION",
  319: "OPTIONS.EDIT",
  320: "OPTIONS.VIEW",
  321: "ADDIN.MANAGER",
  322: "MENU.EDITOR",
  323: "ATTACH.TOOLBARS",
  324: "VBAActivate",
  325: "OPTIONS.CHART",
  328: "VBA.INSERT.FILE",
  330: "VBA.PROCEDURE.DEFINITION",
  336: "ROUTING.SLIP",
  338: "ROUTE.DOCUMENT",
  339: "MAIL.LOGON",
  342: "INSERT.PICTURE",
  343: "EDIT.TOOL",
  344: "GALLERY.DOUGHNUT",
  350: "CHART.TREND",
  352: "PIVOT.ITEM.PROPERTIES",
  354: "WORKBOOK.INSERT",
  355: "OPTIONS.TRANSITION",
  356: "OPTIONS.GENERAL",
  370: "FILTER.ADVANCED",
  373: "MAIL.ADD.MAILER",
  374: "MAIL.DELETE.MAILER",
  375: "MAIL.REPLY",
  376: "MAIL.REPLY.ALL",
  377: "MAIL.FORWARD",
  378: "MAIL.NEXT.LETTER",
  379: "DATA.LABEL",
  380: "INSERT.TITLE",
  381: "FONT.PROPERTIES",
  382: "MACRO.OPTIONS",
  383: "WORKBOOK.HIDE",
  384: "WORKBOOK.UNHIDE",
  385: "WORKBOOK.DELETE",
  386: "WORKBOOK.NAME",
  388: "GALLERY.CUSTOM",
  390: "ADD.CHART.AUTOFORMAT",
  391: "DELETE.CHART.AUTOFORMAT",
  392: "CHART.ADD.DATA",
  393: "AUTO.OUTLINE",
  394: "TAB.ORDER",
  395: "SHOW.DIALOG",
  396: "SELECT.ALL",
  397: "UNGROUP.SHEETS",
  398: "SUBTOTAL.CREATE",
  399: "SUBTOTAL.REMOVE",
  400: "RENAME.OBJECT",
  412: "WORKBOOK.SCROLL",
  413: "WORKBOOK.NEXT",
  414: "WORKBOOK.PREV",
  415: "WORKBOOK.TAB.SPLIT",
  416: "FULL.SCREEN",
  417: "WORKBOOK.PROTECT",
  420: "SCROLLBAR.PROPERTIES",
  421: "PIVOT.SHOW.PAGES",
  422: "TEXT.TO.COLUMNS",
  423: "FORMAT.CHARTTYPE",
  424: "LINK.FORMAT",
  425: "TRACER.DISPLAY",
  430: "TRACER.NAVIGATE",
  431: "TRACER.CLEAR",
  432: "TRACER.ERROR",
  433: "PIVOT.FIELD.GROUP",
  434: "PIVOT.FIELD.UNGROUP",
  435: "CHECKBOX.PROPERTIES",
  436: "LABEL.PROPERTIES",
  437: "LISTBOX.PROPERTIES",
  438: "EDITBOX.PROPERTIES",
  439: "PIVOT.REFRESH",
  440: "LINK.COMBO",
  441: "OPEN.TEXT",
  442: "HIDE.DIALOG",
  443: "SET.DIALOG.FOCUS",
  444: "ENABLE.OBJECT",
  445: "PUSHBUTTON.PROPERTIES",
  446: "SET.DIALOG.DEFAULT",
  447: "FILTER",
  448: "FILTER.SHOW.ALL",
  449: "CLEAR.OUTLINE",
  450: "FUNCTION.WIZARD",
  451: "ADD.LIST.ITEM",
  452: "SET.LIST.ITEM",
  453: "REMOVE.LIST.ITEM",
  454: "SELECT.LIST.ITEM",
  455: "SET.CONTROL.VALUE",
  456: "SAVE.COPY.AS",
  458: "OPTIONS.LISTS.ADD",
  459: "OPTIONS.LISTS.DELETE",
  460: "SERIES.AXES",
  461: "SERIES.X",
  462: "SERIES.Y",
  463: "ERRORBAR.X",
  464: "ERRORBAR.Y",
  465: "FORMAT.CHART",
  466: "SERIES.ORDER",
  467: "MAIL.LOGOFF",
  468: "CLEAR.ROUTING.SLIP",
  469: "APP.ACTIVATE.MICROSOFT",
  470: "MAIL.EDIT.MAILER",
  471: "ON.SHEET",
  472: "STANDARD.WIDTH",
  473: "SCENARIO.MERGE",
  474: "SUMMARY.INFO",
  475: "FIND.FILE",
  476: "ACTIVE.CELL.FONT",
  477: "ENABLE.TIPWIZARD",
  478: "VBA.MAKE.ADDIN",
  480: "INSERTDATATABLE",
  481: "WORKGROUP.OPTIONS",
  482: "MAIL.SEND.MAILER",
  485: "AUTOCORRECT",
  489: "POST.DOCUMENT",
  491: "PICKLIST",
  493: "VIEW.SHOW",
  494: "VIEW.DEFINE",
  495: "VIEW.DELETE",
  509: "SHEET.BACKGROUND",
  510: "INSERT.MAP.OBJECT",
  511: "OPTIONS.MENONO",
  517: "MSOCHECKS",
  518: "NORMAL",
  519: "LAYOUT",
  520: "RM.PRINT.AREA",
  521: "CLEAR.PRINT.AREA",
  522: "ADD.PRINT.AREA",
  523: "MOVE.BRK",
  545: "HIDECURR.NOTE",
  546: "HIDEALL.NOTES",
  547: "DELETE.NOTE",
  548: "TRAVERSE.NOTES",
  549: "ACTIVATE.NOTES",
  620: "PROTECT.REVISIONS",
  621: "UNPROTECT.REVISIONS",
  647: "OPTIONS.ME",
  653: "WEB.PUBLISH",
  667: "NEWWEBQUERY",
  673: "PIVOT.TABLE.CHART",
  753: "OPTIONS.SAVE",
  755: "OPTIONS.SPELL",
  808: "HIDEALL.INKANNOTS"
}, tW = {
  0: "COUNT",
  1: "IF",
  2: "ISNA",
  3: "ISERROR",
  4: "SUM",
  5: "AVERAGE",
  6: "MIN",
  7: "MAX",
  8: "ROW",
  9: "COLUMN",
  10: "NA",
  11: "NPV",
  12: "STDEV",
  13: "DOLLAR",
  14: "FIXED",
  15: "SIN",
  16: "COS",
  17: "TAN",
  18: "ATAN",
  19: "PI",
  20: "SQRT",
  21: "EXP",
  22: "LN",
  23: "LOG10",
  24: "ABS",
  25: "INT",
  26: "SIGN",
  27: "ROUND",
  28: "LOOKUP",
  29: "INDEX",
  30: "REPT",
  31: "MID",
  32: "LEN",
  33: "VALUE",
  34: "TRUE",
  35: "FALSE",
  36: "AND",
  37: "OR",
  38: "NOT",
  39: "MOD",
  40: "DCOUNT",
  41: "DSUM",
  42: "DAVERAGE",
  43: "DMIN",
  44: "DMAX",
  45: "DSTDEV",
  46: "VAR",
  47: "DVAR",
  48: "TEXT",
  49: "LINEST",
  50: "TREND",
  51: "LOGEST",
  52: "GROWTH",
  53: "GOTO",
  54: "HALT",
  55: "RETURN",
  56: "PV",
  57: "FV",
  58: "NPER",
  59: "PMT",
  60: "RATE",
  61: "MIRR",
  62: "IRR",
  63: "RAND",
  64: "MATCH",
  65: "DATE",
  66: "TIME",
  67: "DAY",
  68: "MONTH",
  69: "YEAR",
  70: "WEEKDAY",
  71: "HOUR",
  72: "MINUTE",
  73: "SECOND",
  74: "NOW",
  75: "AREAS",
  76: "ROWS",
  77: "COLUMNS",
  78: "OFFSET",
  79: "ABSREF",
  80: "RELREF",
  81: "ARGUMENT",
  82: "SEARCH",
  83: "TRANSPOSE",
  84: "ERROR",
  85: "STEP",
  86: "TYPE",
  87: "ECHO",
  88: "SET.NAME",
  89: "CALLER",
  90: "DEREF",
  91: "WINDOWS",
  92: "SERIES",
  93: "DOCUMENTS",
  94: "ACTIVE.CELL",
  95: "SELECTION",
  96: "RESULT",
  97: "ATAN2",
  98: "ASIN",
  99: "ACOS",
  100: "CHOOSE",
  101: "HLOOKUP",
  102: "VLOOKUP",
  103: "LINKS",
  104: "INPUT",
  105: "ISREF",
  106: "GET.FORMULA",
  107: "GET.NAME",
  108: "SET.VALUE",
  109: "LOG",
  110: "EXEC",
  111: "CHAR",
  112: "LOWER",
  113: "UPPER",
  114: "PROPER",
  115: "LEFT",
  116: "RIGHT",
  117: "EXACT",
  118: "TRIM",
  119: "REPLACE",
  120: "SUBSTITUTE",
  121: "CODE",
  122: "NAMES",
  123: "DIRECTORY",
  124: "FIND",
  125: "CELL",
  126: "ISERR",
  127: "ISTEXT",
  128: "ISNUMBER",
  129: "ISBLANK",
  130: "T",
  131: "N",
  132: "FOPEN",
  133: "FCLOSE",
  134: "FSIZE",
  135: "FREADLN",
  136: "FREAD",
  137: "FWRITELN",
  138: "FWRITE",
  139: "FPOS",
  140: "DATEVALUE",
  141: "TIMEVALUE",
  142: "SLN",
  143: "SYD",
  144: "DDB",
  145: "GET.DEF",
  146: "REFTEXT",
  147: "TEXTREF",
  148: "INDIRECT",
  149: "REGISTER",
  150: "CALL",
  151: "ADD.BAR",
  152: "ADD.MENU",
  153: "ADD.COMMAND",
  154: "ENABLE.COMMAND",
  155: "CHECK.COMMAND",
  156: "RENAME.COMMAND",
  157: "SHOW.BAR",
  158: "DELETE.MENU",
  159: "DELETE.COMMAND",
  160: "GET.CHART.ITEM",
  161: "DIALOG.BOX",
  162: "CLEAN",
  163: "MDETERM",
  164: "MINVERSE",
  165: "MMULT",
  166: "FILES",
  167: "IPMT",
  168: "PPMT",
  169: "COUNTA",
  170: "CANCEL.KEY",
  171: "FOR",
  172: "WHILE",
  173: "BREAK",
  174: "NEXT",
  175: "INITIATE",
  176: "REQUEST",
  177: "POKE",
  178: "EXECUTE",
  179: "TERMINATE",
  180: "RESTART",
  181: "HELP",
  182: "GET.BAR",
  183: "PRODUCT",
  184: "FACT",
  185: "GET.CELL",
  186: "GET.WORKSPACE",
  187: "GET.WINDOW",
  188: "GET.DOCUMENT",
  189: "DPRODUCT",
  190: "ISNONTEXT",
  191: "GET.NOTE",
  192: "NOTE",
  193: "STDEVP",
  194: "VARP",
  195: "DSTDEVP",
  196: "DVARP",
  197: "TRUNC",
  198: "ISLOGICAL",
  199: "DCOUNTA",
  200: "DELETE.BAR",
  201: "UNREGISTER",
  204: "USDOLLAR",
  205: "FINDB",
  206: "SEARCHB",
  207: "REPLACEB",
  208: "LEFTB",
  209: "RIGHTB",
  210: "MIDB",
  211: "LENB",
  212: "ROUNDUP",
  213: "ROUNDDOWN",
  214: "ASC",
  215: "DBCS",
  216: "RANK",
  219: "ADDRESS",
  220: "DAYS360",
  221: "TODAY",
  222: "VDB",
  223: "ELSE",
  224: "ELSE.IF",
  225: "END.IF",
  226: "FOR.CELL",
  227: "MEDIAN",
  228: "SUMPRODUCT",
  229: "SINH",
  230: "COSH",
  231: "TANH",
  232: "ASINH",
  233: "ACOSH",
  234: "ATANH",
  235: "DGET",
  236: "CREATE.OBJECT",
  237: "VOLATILE",
  238: "LAST.ERROR",
  239: "CUSTOM.UNDO",
  240: "CUSTOM.REPEAT",
  241: "FORMULA.CONVERT",
  242: "GET.LINK.INFO",
  243: "TEXT.BOX",
  244: "INFO",
  245: "GROUP",
  246: "GET.OBJECT",
  247: "DB",
  248: "PAUSE",
  251: "RESUME",
  252: "FREQUENCY",
  253: "ADD.TOOLBAR",
  254: "DELETE.TOOLBAR",
  255: "User",
  256: "RESET.TOOLBAR",
  257: "EVALUATE",
  258: "GET.TOOLBAR",
  259: "GET.TOOL",
  260: "SPELLING.CHECK",
  261: "ERROR.TYPE",
  262: "APP.TITLE",
  263: "WINDOW.TITLE",
  264: "SAVE.TOOLBAR",
  265: "ENABLE.TOOL",
  266: "PRESS.TOOL",
  267: "REGISTER.ID",
  268: "GET.WORKBOOK",
  269: "AVEDEV",
  270: "BETADIST",
  271: "GAMMALN",
  272: "BETAINV",
  273: "BINOMDIST",
  274: "CHIDIST",
  275: "CHIINV",
  276: "COMBIN",
  277: "CONFIDENCE",
  278: "CRITBINOM",
  279: "EVEN",
  280: "EXPONDIST",
  281: "FDIST",
  282: "FINV",
  283: "FISHER",
  284: "FISHERINV",
  285: "FLOOR",
  286: "GAMMADIST",
  287: "GAMMAINV",
  288: "CEILING",
  289: "HYPGEOMDIST",
  290: "LOGNORMDIST",
  291: "LOGINV",
  292: "NEGBINOMDIST",
  293: "NORMDIST",
  294: "NORMSDIST",
  295: "NORMINV",
  296: "NORMSINV",
  297: "STANDARDIZE",
  298: "ODD",
  299: "PERMUT",
  300: "POISSON",
  301: "TDIST",
  302: "WEIBULL",
  303: "SUMXMY2",
  304: "SUMX2MY2",
  305: "SUMX2PY2",
  306: "CHITEST",
  307: "CORREL",
  308: "COVAR",
  309: "FORECAST",
  310: "FTEST",
  311: "INTERCEPT",
  312: "PEARSON",
  313: "RSQ",
  314: "STEYX",
  315: "SLOPE",
  316: "TTEST",
  317: "PROB",
  318: "DEVSQ",
  319: "GEOMEAN",
  320: "HARMEAN",
  321: "SUMSQ",
  322: "KURT",
  323: "SKEW",
  324: "ZTEST",
  325: "LARGE",
  326: "SMALL",
  327: "QUARTILE",
  328: "PERCENTILE",
  329: "PERCENTRANK",
  330: "MODE",
  331: "TRIMMEAN",
  332: "TINV",
  334: "MOVIE.COMMAND",
  335: "GET.MOVIE",
  336: "CONCATENATE",
  337: "POWER",
  338: "PIVOT.ADD.DATA",
  339: "GET.PIVOT.TABLE",
  340: "GET.PIVOT.FIELD",
  341: "GET.PIVOT.ITEM",
  342: "RADIANS",
  343: "DEGREES",
  344: "SUBTOTAL",
  345: "SUMIF",
  346: "COUNTIF",
  347: "COUNTBLANK",
  348: "SCENARIO.GET",
  349: "OPTIONS.LISTS.GET",
  350: "ISPMT",
  351: "DATEDIF",
  352: "DATESTRING",
  353: "NUMBERSTRING",
  354: "ROMAN",
  355: "OPEN.DIALOG",
  356: "SAVE.DIALOG",
  357: "VIEW.GET",
  358: "GETPIVOTDATA",
  359: "HYPERLINK",
  360: "PHONETIC",
  361: "AVERAGEA",
  362: "MAXA",
  363: "MINA",
  364: "STDEVPA",
  365: "VARPA",
  366: "STDEVA",
  367: "VARA",
  368: "BAHTTEXT",
  369: "THAIDAYOFWEEK",
  370: "THAIDIGIT",
  371: "THAIMONTHOFYEAR",
  372: "THAINUMSOUND",
  373: "THAINUMSTRING",
  374: "THAISTRINGLENGTH",
  375: "ISTHAIDIGIT",
  376: "ROUNDBAHTDOWN",
  377: "ROUNDBAHTUP",
  378: "THAIYEAR",
  379: "RTD",
  380: "CUBEVALUE",
  381: "CUBEMEMBER",
  382: "CUBEMEMBERPROPERTY",
  383: "CUBERANKEDMEMBER",
  384: "HEX2BIN",
  385: "HEX2DEC",
  386: "HEX2OCT",
  387: "DEC2BIN",
  388: "DEC2HEX",
  389: "DEC2OCT",
  390: "OCT2BIN",
  391: "OCT2HEX",
  392: "OCT2DEC",
  393: "BIN2DEC",
  394: "BIN2OCT",
  395: "BIN2HEX",
  396: "IMSUB",
  397: "IMDIV",
  398: "IMPOWER",
  399: "IMABS",
  400: "IMSQRT",
  401: "IMLN",
  402: "IMLOG2",
  403: "IMLOG10",
  404: "IMSIN",
  405: "IMCOS",
  406: "IMEXP",
  407: "IMARGUMENT",
  408: "IMCONJUGATE",
  409: "IMAGINARY",
  410: "IMREAL",
  411: "COMPLEX",
  412: "IMSUM",
  413: "IMPRODUCT",
  414: "SERIESSUM",
  415: "FACTDOUBLE",
  416: "SQRTPI",
  417: "QUOTIENT",
  418: "DELTA",
  419: "GESTEP",
  420: "ISEVEN",
  421: "ISODD",
  422: "MROUND",
  423: "ERF",
  424: "ERFC",
  425: "BESSELJ",
  426: "BESSELK",
  427: "BESSELY",
  428: "BESSELI",
  429: "XIRR",
  430: "XNPV",
  431: "PRICEMAT",
  432: "YIELDMAT",
  433: "INTRATE",
  434: "RECEIVED",
  435: "DISC",
  436: "PRICEDISC",
  437: "YIELDDISC",
  438: "TBILLEQ",
  439: "TBILLPRICE",
  440: "TBILLYIELD",
  441: "PRICE",
  442: "YIELD",
  443: "DOLLARDE",
  444: "DOLLARFR",
  445: "NOMINAL",
  446: "EFFECT",
  447: "CUMPRINC",
  448: "CUMIPMT",
  449: "EDATE",
  450: "EOMONTH",
  451: "YEARFRAC",
  452: "COUPDAYBS",
  453: "COUPDAYS",
  454: "COUPDAYSNC",
  455: "COUPNCD",
  456: "COUPNUM",
  457: "COUPPCD",
  458: "DURATION",
  459: "MDURATION",
  460: "ODDLPRICE",
  461: "ODDLYIELD",
  462: "ODDFPRICE",
  463: "ODDFYIELD",
  464: "RANDBETWEEN",
  465: "WEEKNUM",
  466: "AMORDEGRC",
  467: "AMORLINC",
  468: "CONVERT",
  724: "SHEETJS",
  469: "ACCRINT",
  470: "ACCRINTM",
  471: "WORKDAY",
  472: "NETWORKDAYS",
  473: "GCD",
  474: "MULTINOMIAL",
  475: "LCM",
  476: "FVSCHEDULE",
  477: "CUBEKPIMEMBER",
  478: "CUBESET",
  479: "CUBESETCOUNT",
  480: "IFERROR",
  481: "COUNTIFS",
  482: "SUMIFS",
  483: "AVERAGEIF",
  484: "AVERAGEIFS"
}, vze = {
  2: 1,
  3: 1,
  10: 0,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 0,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 2,
  30: 2,
  31: 3,
  32: 1,
  33: 1,
  34: 0,
  35: 0,
  38: 1,
  39: 2,
  40: 3,
  41: 3,
  42: 3,
  43: 3,
  44: 3,
  45: 3,
  47: 3,
  48: 2,
  53: 1,
  61: 3,
  63: 0,
  65: 3,
  66: 3,
  67: 1,
  68: 1,
  69: 1,
  70: 1,
  71: 1,
  72: 1,
  73: 1,
  74: 0,
  75: 1,
  76: 1,
  77: 1,
  79: 2,
  80: 2,
  83: 1,
  85: 0,
  86: 1,
  89: 0,
  90: 1,
  94: 0,
  95: 0,
  97: 2,
  98: 1,
  99: 1,
  101: 3,
  102: 3,
  105: 1,
  106: 1,
  108: 2,
  111: 1,
  112: 1,
  113: 1,
  114: 1,
  117: 2,
  118: 1,
  119: 4,
  121: 1,
  126: 1,
  127: 1,
  128: 1,
  129: 1,
  130: 1,
  131: 1,
  133: 1,
  134: 1,
  135: 1,
  136: 2,
  137: 2,
  138: 2,
  140: 1,
  141: 1,
  142: 3,
  143: 4,
  144: 4,
  161: 1,
  162: 1,
  163: 1,
  164: 1,
  165: 2,
  172: 1,
  175: 2,
  176: 2,
  177: 3,
  178: 2,
  179: 1,
  184: 1,
  186: 1,
  189: 3,
  190: 1,
  195: 3,
  196: 3,
  197: 1,
  198: 1,
  199: 3,
  201: 1,
  207: 4,
  210: 3,
  211: 1,
  212: 2,
  213: 2,
  214: 1,
  215: 1,
  225: 0,
  229: 1,
  230: 1,
  231: 1,
  232: 1,
  233: 1,
  234: 1,
  235: 3,
  244: 1,
  247: 4,
  252: 2,
  257: 1,
  261: 1,
  271: 1,
  273: 4,
  274: 2,
  275: 2,
  276: 2,
  277: 3,
  278: 3,
  279: 1,
  280: 3,
  281: 3,
  282: 3,
  283: 1,
  284: 1,
  285: 2,
  286: 4,
  287: 3,
  288: 2,
  289: 4,
  290: 3,
  291: 3,
  292: 3,
  293: 4,
  294: 1,
  295: 3,
  296: 1,
  297: 3,
  298: 1,
  299: 2,
  300: 3,
  301: 3,
  302: 4,
  303: 2,
  304: 2,
  305: 2,
  306: 2,
  307: 2,
  308: 2,
  309: 3,
  310: 2,
  311: 2,
  312: 2,
  313: 2,
  314: 2,
  315: 2,
  316: 4,
  325: 2,
  326: 2,
  327: 2,
  328: 2,
  331: 2,
  332: 2,
  337: 2,
  342: 1,
  343: 1,
  346: 2,
  347: 1,
  350: 4,
  351: 3,
  352: 1,
  353: 2,
  360: 1,
  368: 1,
  369: 1,
  370: 1,
  371: 1,
  372: 1,
  373: 1,
  374: 1,
  375: 1,
  376: 1,
  377: 1,
  378: 1,
  382: 3,
  385: 1,
  392: 1,
  393: 1,
  396: 2,
  397: 2,
  398: 2,
  399: 1,
  400: 1,
  401: 1,
  402: 1,
  403: 1,
  404: 1,
  405: 1,
  406: 1,
  407: 1,
  408: 1,
  409: 1,
  410: 1,
  414: 4,
  415: 1,
  416: 1,
  417: 2,
  420: 1,
  421: 1,
  422: 2,
  424: 1,
  425: 2,
  426: 2,
  427: 2,
  428: 2,
  430: 3,
  438: 3,
  439: 3,
  440: 3,
  443: 2,
  444: 2,
  445: 2,
  446: 2,
  447: 6,
  448: 6,
  449: 2,
  450: 2,
  464: 2,
  468: 3,
  476: 2,
  479: 1,
  480: 2,
  65535: 0
};
function yze(e) {
  var t = "of:=" + e.replace(X2, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
  return t.replace(/;/g, "|").replace(/,/g, ";");
}
function bze(e) {
  return e.replace(/\./, "!");
}
var Rm = typeof Map < "u";
function Z2(e, t, r) {
  var n = 0, a = e.length;
  if (r) {
    if (Rm ? r.has(t) : Object.prototype.hasOwnProperty.call(r, t)) {
      for (var s = Rm ? r.get(t) : r[t]; n < s.length; ++n)
        if (e[s[n]].t === t)
          return e.Count++, s[n];
    }
  } else for (; n < a; ++n)
    if (e[n].t === t)
      return e.Count++, n;
  return e[a] = { t }, e.Count++, e.Unique++, r && (Rm ? (r.has(t) || r.set(t, []), r.get(t).push(a)) : (Object.prototype.hasOwnProperty.call(r, t) || (r[t] = []), r[t].push(a))), a;
}
function e1(e, t) {
  var r = { min: e + 1, max: e + 1 }, n = -1;
  return t.MDW && (Ml = t.MDW), t.width != null ? r.customWidth = 1 : t.wpx != null ? n = uw(t.wpx) : t.wch != null && (n = t.wch), n > -1 ? (r.width = yT(n), r.customWidth = 1) : t.width != null && (r.width = t.width), t.hidden && (r.hidden = !0), t.level != null && (r.outlineLevel = r.level = t.level), r;
}
function rW(e, t) {
  if (e) {
    var r = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
    e.left == null && (e.left = r[0]), e.right == null && (e.right = r[1]), e.top == null && (e.top = r[2]), e.bottom == null && (e.bottom = r[3]), e.header == null && (e.header = r[4]), e.footer == null && (e.footer = r[5]);
  }
}
function Zc(e, t, r) {
  var n = r.revssf[t.z != null ? t.z : "General"], a = 60, s = e.length;
  if (n == null && r.ssf) {
    for (; a < 392; ++a) if (r.ssf[a] == null) {
      Q7(t.z, a), r.ssf[a] = t.z, r.revssf[t.z] = n = a;
      break;
    }
  }
  for (a = 0; a != s; ++a) if (e[a].numFmtId === n) return a;
  return e[s] = {
    numFmtId: n,
    fontId: 0,
    fillId: 0,
    borderId: 0,
    xfId: 0,
    applyNumberFormat: 1
  }, s;
}
function wze(e, t, r) {
  if (e && e["!ref"]) {
    var n = vn(e["!ref"]);
    if (n.e.c < n.s.c || n.e.r < n.s.r) throw new Error("Bad range (" + r + "): " + e["!ref"]);
  }
}
function xze(e) {
  if (e.length === 0) return "";
  for (var t = '<mergeCells count="' + e.length + '">', r = 0; r != e.length; ++r) t += '<mergeCell ref="' + ea(e[r]) + '"/>';
  return t + "</mergeCells>";
}
function _ze(e, t, r, n, a) {
  var s = !1, i = {}, o = null;
  if (n.bookType !== "xlsx" && t.vbaraw) {
    var l = t.SheetNames[r];
    try {
      t.Workbook && (l = t.Workbook.Sheets[r].CodeName || l);
    } catch {
    }
    s = !0, i.codeName = gg(Jr(l));
  }
  if (e && e["!outline"]) {
    var c = { summaryBelow: 1, summaryRight: 1 };
    e["!outline"].above && (c.summaryBelow = 0), e["!outline"].left && (c.summaryRight = 0), o = (o || "") + vt("outlinePr", null, c);
  }
  !s && !o || (a[a.length] = vt("sheetPr", o, i));
}
var Sze = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"], Eze = [
  "formatColumns",
  "formatRows",
  "formatCells",
  "insertColumns",
  "insertRows",
  "insertHyperlinks",
  "deleteColumns",
  "deleteRows",
  "sort",
  "autoFilter",
  "pivotTables"
];
function Tze(e) {
  var t = { sheet: 1 };
  return Sze.forEach(function(r) {
    e[r] != null && e[r] && (t[r] = "1");
  }), Eze.forEach(function(r) {
    e[r] != null && !e[r] && (t[r] = "0");
  }), e.password && (t.password = B9(e.password).toString(16).toUpperCase()), vt("sheetProtection", null, t);
}
function Cze(e) {
  return rW(e), vt("pageMargins", null, e);
}
function kze(e, t) {
  for (var r = ["<cols>"], n, a = 0; a != t.length; ++a)
    (n = t[a]) && (r[r.length] = vt("col", null, e1(a, n)));
  return r[r.length] = "</cols>", r.join("");
}
function Oze(e, t, r, n) {
  var a = typeof e.ref == "string" ? e.ref : ea(e.ref);
  r.Workbook || (r.Workbook = { Sheets: [] }), r.Workbook.Names || (r.Workbook.Names = []);
  var s = r.Workbook.Names, i = qs(a);
  i.s.r == i.e.r && (i.e.r = qs(t["!ref"]).e.r, a = ea(i));
  for (var o = 0; o < s.length; ++o) {
    var l = s[o];
    if (l.Name == "_xlnm._FilterDatabase" && l.Sheet == n) {
      l.Ref = "'" + r.SheetNames[n] + "'!" + a;
      break;
    }
  }
  return o == s.length && s.push({ Name: "_xlnm._FilterDatabase", Sheet: n, Ref: "'" + r.SheetNames[n] + "'!" + a }), vt("autoFilter", null, { ref: a });
}
function Aze(e, t, r, n) {
  var a = { workbookViewId: "0" };
  return (((n || {}).Workbook || {}).Views || [])[0] && (a.rightToLeft = n.Workbook.Views[0].RTL ? "1" : "0"), vt("sheetViews", vt("sheetView", null, a), {});
}
function Pze(e, t, r, n) {
  if (e.c && r["!comments"].push([t, e.c]), e.v === void 0 && typeof e.f != "string" || e.t === "z" && !e.f) return "";
  var a = "", s = e.t, i = e.v;
  if (e.t !== "z") switch (e.t) {
    case "b":
      a = e.v ? "1" : "0";
      break;
    case "n":
      a = "" + e.v;
      break;
    case "e":
      a = _v[e.v];
      break;
    case "d":
      n && n.cellDates ? a = ds(e.v, -1).toISOString() : (e = Ss(e), e.t = "n", a = "" + (e.v = _s(ds(e.v)))), typeof e.z > "u" && (e.z = Rn[14]);
      break;
    default:
      a = e.v;
      break;
  }
  var o = Aa("v", Jr(a)), l = { r: t }, c = Zc(n.cellXfs, e, n);
  switch (c !== 0 && (l.s = c), e.t) {
    case "n":
      break;
    case "d":
      l.t = "d";
      break;
    case "b":
      l.t = "b";
      break;
    case "e":
      l.t = "e";
      break;
    case "z":
      break;
    default:
      if (e.v == null) {
        delete e.t;
        break;
      }
      if (e.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
      if (n && n.bookSST) {
        o = Aa("v", "" + Z2(n.Strings, e.v, n.revStrings)), l.t = "s";
        break;
      }
      l.t = "str";
      break;
  }
  if (e.t != s && (e.t = s, e.v = i), typeof e.f == "string" && e.f) {
    var u = e.F && e.F.slice(0, t.length) == t ? { t: "array", ref: e.F } : null;
    o = vt("f", Jr(e.f), u) + (e.v != null ? o : "");
  }
  return e.l && r["!links"].push([t, e.l]), e.D && (l.cm = 1), vt("c", o, l);
}
function Rze(e, t, r, n) {
  var a = [], s = [], i = vn(e["!ref"]), o = "", l, c = "", u = [], d = 0, f = 0, h = e["!rows"], p = Array.isArray(e), m = { r: c }, g, y = -1;
  for (f = i.s.c; f <= i.e.c; ++f) u[f] = Ya(f);
  for (d = i.s.r; d <= i.e.r; ++d) {
    for (s = [], c = Ra(d), f = i.s.c; f <= i.e.c; ++f) {
      l = u[f] + c;
      var x = p ? (e[d] || [])[f] : e[l];
      x !== void 0 && (o = Pze(x, l, e, t)) != null && s.push(o);
    }
    (s.length > 0 || h && h[d]) && (m = { r: c }, h && h[d] && (g = h[d], g.hidden && (m.hidden = 1), y = -1, g.hpx ? y = dw(g.hpx) : g.hpt && (y = g.hpt), y > -1 && (m.ht = y, m.customHeight = 1), g.level && (m.outlineLevel = g.level)), a[a.length] = vt("row", s.join(""), m));
  }
  if (h) for (; d < h.length; ++d)
    h && h[d] && (m = { r: d + 1 }, g = h[d], g.hidden && (m.hidden = 1), y = -1, g.hpx ? y = dw(g.hpx) : g.hpt && (y = g.hpt), y > -1 && (m.ht = y, m.customHeight = 1), g.level && (m.outlineLevel = g.level), a[a.length] = vt("row", "", m));
  return a.join("");
}
function nW(e, t, r, n) {
  var a = [ra, vt("worksheet", null, {
    xmlns: Gh[0],
    "xmlns:r": pa.r
  })], s = r.SheetNames[e], i = 0, o = "", l = r.Sheets[s];
  l == null && (l = {});
  var c = l["!ref"] || "A1", u = vn(c);
  if (u.e.c > 16383 || u.e.r > 1048575) {
    if (t.WTF) throw new Error("Range " + c + " exceeds format limit A1:XFD1048576");
    u.e.c = Math.min(u.e.c, 16383), u.e.r = Math.min(u.e.c, 1048575), c = ea(u);
  }
  n || (n = {}), l["!comments"] = [];
  var d = [];
  _ze(l, r, e, t, a), a[a.length] = vt("dimension", null, { ref: c }), a[a.length] = Aze(l, t, e, r), t.sheetFormat && (a[a.length] = vt("sheetFormatPr", null, {
    defaultRowHeight: t.sheetFormat.defaultRowHeight || "16",
    baseColWidth: t.sheetFormat.baseColWidth || "10",
    outlineLevelRow: t.sheetFormat.outlineLevelRow || "7"
  })), l["!cols"] != null && l["!cols"].length > 0 && (a[a.length] = kze(l, l["!cols"])), a[i = a.length] = "<sheetData/>", l["!links"] = [], l["!ref"] != null && (o = Rze(l, t), o.length > 0 && (a[a.length] = o)), a.length > i + 1 && (a[a.length] = "</sheetData>", a[i] = a[i].replace("/>", ">")), l["!protect"] && (a[a.length] = Tze(l["!protect"])), l["!autofilter"] != null && (a[a.length] = Oze(l["!autofilter"], l, r, e)), l["!merges"] != null && l["!merges"].length > 0 && (a[a.length] = xze(l["!merges"]));
  var f = -1, h, p = -1;
  return (
    /*::(*/
    l["!links"].length > 0 && (a[a.length] = "<hyperlinks>", l["!links"].forEach(function(m) {
      m[1].Target && (h = { ref: m[0] }, m[1].Target.charAt(0) != "#" && (p = qr(n, -1, Jr(m[1].Target).replace(/#.*$/, ""), Ar.HLINK), h["r:id"] = "rId" + p), (f = m[1].Target.indexOf("#")) > -1 && (h.location = Jr(m[1].Target.slice(f + 1))), m[1].Tooltip && (h.tooltip = Jr(m[1].Tooltip)), a[a.length] = vt("hyperlink", null, h));
    }), a[a.length] = "</hyperlinks>"), delete l["!links"], l["!margins"] != null && (a[a.length] = Cze(l["!margins"])), (!t || t.ignoreEC || t.ignoreEC == null) && (a[a.length] = Aa("ignoredErrors", vt("ignoredError", null, { numberStoredAsText: 1, sqref: c }))), d.length > 0 && (p = qr(n, -1, "../drawings/drawing" + (e + 1) + ".xml", Ar.DRAW), a[a.length] = vt("drawing", null, { "r:id": "rId" + p }), l["!drawing"] = d), l["!comments"].length > 0 && (p = qr(n, -1, "../drawings/vmlDrawing" + (e + 1) + ".vml", Ar.VML), a[a.length] = vt("legacyDrawing", null, { "r:id": "rId" + p }), l["!legacy"] = p), a.length > 1 && (a[a.length] = "</worksheet>", a[1] = a[1].replace("/>", ">")), a.join("")
  );
}
function Ize(e, t) {
  var r = {}, n = e.l + t;
  r.r = e.read_shift(4), e.l += 4;
  var a = e.read_shift(2);
  e.l += 1;
  var s = e.read_shift(1);
  return e.l = n, s & 7 && (r.level = s & 7), s & 16 && (r.hidden = !0), s & 32 && (r.hpt = a / 20), r;
}
function Dze(e, t, r) {
  var n = Ke(145), a = (r["!rows"] || [])[e] || {};
  n.write_shift(4, e), n.write_shift(4, 0);
  var s = 320;
  a.hpx ? s = dw(a.hpx) * 20 : a.hpt && (s = a.hpt * 20), n.write_shift(2, s), n.write_shift(1, 0);
  var i = 0;
  a.level && (i |= a.level), a.hidden && (i |= 16), (a.hpx || a.hpt) && (i |= 32), n.write_shift(1, i), n.write_shift(1, 0);
  var o = 0, l = n.l;
  n.l += 4;
  for (var c = { r: e, c: 0 }, u = 0; u < 16; ++u)
    if (!(t.s.c > u + 1 << 10 || t.e.c < u << 10)) {
      for (var d = -1, f = -1, h = u << 10; h < u + 1 << 10; ++h) {
        c.c = h;
        var p = Array.isArray(r) ? (r[c.r] || [])[c.c] : r[Zr(c)];
        p && (d < 0 && (d = h), f = h);
      }
      d < 0 || (++o, n.write_shift(4, d), n.write_shift(4, f));
    }
  var m = n.l;
  return n.l = l, n.write_shift(4, o), n.l = m, n.length > n.l ? n.slice(0, n.l) : n;
}
function Nze(e, t, r, n) {
  var a = Dze(n, r, t);
  (a.length > 17 || (t["!rows"] || [])[n]) && nt(e, 0, a);
}
var Mze = Cd, Lze = Xh;
function jze() {
}
function Fze(e, t) {
  var r = {}, n = e[e.l];
  return ++e.l, r.above = !(n & 64), r.left = !(n & 128), e.l += 18, r.name = GHe(e), r;
}
function Bze(e, t, r) {
  r == null && (r = Ke(84 + 4 * e.length));
  var n = 192;
  t && (t.above && (n &= -65), t.left && (n &= -129)), r.write_shift(1, n);
  for (var a = 1; a < 3; ++a) r.write_shift(1, 0);
  return ow({ auto: 1 }, r), r.write_shift(-4, -1), r.write_shift(-4, -1), y9(e, r), r.slice(0, r.l);
}
function Uze(e) {
  var t = wi(e);
  return [t];
}
function Vze(e, t, r) {
  return r == null && (r = Ke(8)), Sd(t, r);
}
function $ze(e) {
  var t = Ed(e);
  return [t];
}
function Hze(e, t, r) {
  return r == null && (r = Ke(4)), Td(t, r);
}
function Wze(e) {
  var t = wi(e), r = e.read_shift(1);
  return [t, r, "b"];
}
function zze(e, t, r) {
  return r == null && (r = Ke(9)), Sd(t, r), r.write_shift(1, e.v ? 1 : 0), r;
}
function Kze(e) {
  var t = Ed(e), r = e.read_shift(1);
  return [t, r, "b"];
}
function qze(e, t, r) {
  return r == null && (r = Ke(5)), Td(t, r), r.write_shift(1, e.v ? 1 : 0), r;
}
function Gze(e) {
  var t = wi(e), r = e.read_shift(1);
  return [t, r, "e"];
}
function Yze(e, t, r) {
  return r == null && (r = Ke(9)), Sd(t, r), r.write_shift(1, e.v), r;
}
function Xze(e) {
  var t = Ed(e), r = e.read_shift(1);
  return [t, r, "e"];
}
function Qze(e, t, r) {
  return r == null && (r = Ke(8)), Td(t, r), r.write_shift(1, e.v), r.write_shift(2, 0), r.write_shift(1, 0), r;
}
function Jze(e) {
  var t = wi(e), r = e.read_shift(4);
  return [t, r, "s"];
}
function Zze(e, t, r) {
  return r == null && (r = Ke(12)), Sd(t, r), r.write_shift(4, t.v), r;
}
function eKe(e) {
  var t = Ed(e), r = e.read_shift(4);
  return [t, r, "s"];
}
function tKe(e, t, r) {
  return r == null && (r = Ke(8)), Td(t, r), r.write_shift(4, t.v), r;
}
function rKe(e) {
  var t = wi(e), r = Qh(e);
  return [t, r, "n"];
}
function nKe(e, t, r) {
  return r == null && (r = Ke(16)), Sd(t, r), Qu(e.v, r), r;
}
function aKe(e) {
  var t = Ed(e), r = Qh(e);
  return [t, r, "n"];
}
function sKe(e, t, r) {
  return r == null && (r = Ke(12)), Td(t, r), Qu(e.v, r), r;
}
function iKe(e) {
  var t = wi(e), r = b9(e);
  return [t, r, "n"];
}
function oKe(e, t, r) {
  return r == null && (r = Ke(12)), Sd(t, r), w9(e.v, r), r;
}
function lKe(e) {
  var t = Ed(e), r = b9(e);
  return [t, r, "n"];
}
function cKe(e, t, r) {
  return r == null && (r = Ke(8)), Td(t, r), w9(e.v, r), r;
}
function uKe(e) {
  var t = wi(e), r = z2(e);
  return [t, r, "is"];
}
function dKe(e) {
  var t = wi(e), r = Xa(e);
  return [t, r, "str"];
}
function fKe(e, t, r) {
  return r == null && (r = Ke(12 + 4 * e.v.length)), Sd(t, r), ga(e.v, r), r.length > r.l ? r.slice(0, r.l) : r;
}
function hKe(e) {
  var t = Ed(e), r = Xa(e);
  return [t, r, "str"];
}
function pKe(e, t, r) {
  return r == null && (r = Ke(8 + 4 * e.v.length)), Td(t, r), ga(e.v, r), r.length > r.l ? r.slice(0, r.l) : r;
}
function mKe(e, t, r) {
  var n = e.l + t, a = wi(e);
  a.r = r["!row"];
  var s = e.read_shift(1), i = [a, s, "b"];
  if (r.cellFormula) {
    e.l += 2;
    var o = Zx(e, n - e.l, r);
    i[3] = mh(o, null, a, r.supbooks, r);
  } else e.l = n;
  return i;
}
function gKe(e, t, r) {
  var n = e.l + t, a = wi(e);
  a.r = r["!row"];
  var s = e.read_shift(1), i = [a, s, "e"];
  if (r.cellFormula) {
    e.l += 2;
    var o = Zx(e, n - e.l, r);
    i[3] = mh(o, null, a, r.supbooks, r);
  } else e.l = n;
  return i;
}
function vKe(e, t, r) {
  var n = e.l + t, a = wi(e);
  a.r = r["!row"];
  var s = Qh(e), i = [a, s, "n"];
  if (r.cellFormula) {
    e.l += 2;
    var o = Zx(e, n - e.l, r);
    i[3] = mh(o, null, a, r.supbooks, r);
  } else e.l = n;
  return i;
}
function yKe(e, t, r) {
  var n = e.l + t, a = wi(e);
  a.r = r["!row"];
  var s = Xa(e), i = [a, s, "str"];
  if (r.cellFormula) {
    e.l += 2;
    var o = Zx(e, n - e.l, r);
    i[3] = mh(o, null, a, r.supbooks, r);
  } else e.l = n;
  return i;
}
var bKe = Cd, wKe = Xh;
function xKe(e, t) {
  return t == null && (t = Ke(4)), t.write_shift(4, e), t;
}
function _Ke(e, t) {
  var r = e.l + t, n = Cd(e), a = K2(e), s = Xa(e), i = Xa(e), o = Xa(e);
  e.l = r;
  var l = { rfx: n, relId: a, loc: s, display: o };
  return i && (l.Tooltip = i), l;
}
function SKe(e, t) {
  var r = Ke(50 + 4 * (e[1].Target.length + (e[1].Tooltip || "").length));
  Xh({ s: ma(e[0]), e: ma(e[0]) }, r), q2("rId" + t, r);
  var n = e[1].Target.indexOf("#"), a = n == -1 ? "" : e[1].Target.slice(n + 1);
  return ga(a || "", r), ga(e[1].Tooltip || "", r), ga("", r), r.slice(0, r.l);
}
function EKe() {
}
function TKe(e, t, r) {
  var n = e.l + t, a = x9(e), s = e.read_shift(1), i = [a];
  if (i[2] = s, r.cellFormula) {
    var o = hze(e, n - e.l, r);
    i[1] = o;
  } else e.l = n;
  return i;
}
function CKe(e, t, r) {
  var n = e.l + t, a = Cd(e), s = [a];
  if (r.cellFormula) {
    var i = mze(e, n - e.l, r);
    s[1] = i, e.l = n;
  } else e.l = n;
  return s;
}
function kKe(e, t, r) {
  r == null && (r = Ke(18));
  var n = e1(e, t);
  r.write_shift(-4, e), r.write_shift(-4, e), r.write_shift(4, (n.width || 10) * 256), r.write_shift(
    4,
    0
    /*ixfe*/
  );
  var a = 0;
  return t.hidden && (a |= 1), typeof n.width == "number" && (a |= 2), t.level && (a |= t.level << 8), r.write_shift(2, a), r;
}
var aW = ["left", "right", "top", "bottom", "header", "footer"];
function OKe(e) {
  var t = {};
  return aW.forEach(function(r) {
    t[r] = Qh(e);
  }), t;
}
function AKe(e, t) {
  return t == null && (t = Ke(6 * 8)), rW(e), aW.forEach(function(r) {
    Qu(e[r], t);
  }), t;
}
function PKe(e) {
  var t = e.read_shift(2);
  return e.l += 28, { RTL: t & 32 };
}
function RKe(e, t, r) {
  r == null && (r = Ke(30));
  var n = 924;
  return (((t || {}).Views || [])[0] || {}).RTL && (n |= 32), r.write_shift(2, n), r.write_shift(4, 0), r.write_shift(4, 0), r.write_shift(4, 0), r.write_shift(1, 0), r.write_shift(1, 0), r.write_shift(2, 0), r.write_shift(2, 100), r.write_shift(2, 0), r.write_shift(2, 0), r.write_shift(2, 0), r.write_shift(4, 0), r;
}
function IKe(e) {
  var t = Ke(24);
  return t.write_shift(4, 4), t.write_shift(4, 1), Xh(e, t), t;
}
function DKe(e, t) {
  return t == null && (t = Ke(16 * 4 + 2)), t.write_shift(2, e.password ? B9(e.password) : 0), t.write_shift(4, 1), [
    ["objects", !1],
    // fObjects
    ["scenarios", !1],
    // fScenarios
    ["formatCells", !0],
    // fFormatCells
    ["formatColumns", !0],
    // fFormatColumns
    ["formatRows", !0],
    // fFormatRows
    ["insertColumns", !0],
    // fInsertColumns
    ["insertRows", !0],
    // fInsertRows
    ["insertHyperlinks", !0],
    // fInsertHyperlinks
    ["deleteColumns", !0],
    // fDeleteColumns
    ["deleteRows", !0],
    // fDeleteRows
    ["selectLockedCells", !1],
    // fSelLockedCells
    ["sort", !0],
    // fSort
    ["autoFilter", !0],
    // fAutoFilter
    ["pivotTables", !0],
    // fPivotTables
    ["selectUnlockedCells", !1]
    // fSelUnlockedCells
  ].forEach(function(r) {
    r[1] ? t.write_shift(4, e[r[0]] != null && !e[r[0]] ? 1 : 0) : t.write_shift(4, e[r[0]] != null && e[r[0]] ? 0 : 1);
  }), t;
}
function NKe() {
}
function MKe() {
}
function LKe(e, t, r, n, a, s, i) {
  if (t.v === void 0) return !1;
  var o = "";
  switch (t.t) {
    case "b":
      o = t.v ? "1" : "0";
      break;
    case "d":
      t = Ss(t), t.z = t.z || Rn[14], t.v = _s(ds(t.v)), t.t = "n";
      break;
    case "n":
    case "e":
      o = "" + t.v;
      break;
    default:
      o = t.v;
      break;
  }
  var l = { r, c: n };
  switch (l.s = Zc(a.cellXfs, t, a), t.l && s["!links"].push([Zr(l), t.l]), t.c && s["!comments"].push([Zr(l), t.c]), t.t) {
    case "s":
    case "str":
      return a.bookSST ? (o = Z2(a.Strings, t.v, a.revStrings), l.t = "s", l.v = o, i ? nt(e, 18, tKe(t, l)) : nt(e, 7, Zze(t, l))) : (l.t = "str", i ? nt(e, 17, pKe(t, l)) : nt(e, 6, fKe(t, l))), !0;
    case "n":
      return t.v == (t.v | 0) && t.v > -1e3 && t.v < 1e3 ? i ? nt(e, 13, cKe(t, l)) : nt(e, 2, oKe(t, l)) : i ? nt(e, 16, sKe(t, l)) : nt(e, 5, nKe(t, l)), !0;
    case "b":
      return l.t = "b", i ? nt(e, 15, qze(t, l)) : nt(e, 4, zze(t, l)), !0;
    case "e":
      return l.t = "e", i ? nt(e, 14, Qze(t, l)) : nt(e, 3, Yze(t, l)), !0;
  }
  return i ? nt(e, 12, Hze(t, l)) : nt(e, 1, Vze(t, l)), !0;
}
function jKe(e, t, r, n) {
  var a = vn(t["!ref"] || "A1"), s, i = "", o = [];
  nt(
    e,
    145
    /* BrtBeginSheetData */
  );
  var l = Array.isArray(t), c = a.e.r;
  t["!rows"] && (c = Math.max(a.e.r, t["!rows"].length - 1));
  for (var u = a.s.r; u <= c; ++u) {
    i = Ra(u), Nze(e, t, a, u);
    var d = !1;
    if (u <= a.e.r) for (var f = a.s.c; f <= a.e.c; ++f) {
      u === a.s.r && (o[f] = Ya(f)), s = o[f] + i;
      var h = l ? (t[u] || [])[f] : t[s];
      if (!h) {
        d = !1;
        continue;
      }
      d = LKe(e, h, u, f, n, t, d);
    }
  }
  nt(
    e,
    146
    /* BrtEndSheetData */
  );
}
function FKe(e, t) {
  !t || !t["!merges"] || (nt(e, 177, xKe(t["!merges"].length)), t["!merges"].forEach(function(r) {
    nt(e, 176, wKe(r));
  }), nt(
    e,
    178
    /* BrtEndMergeCells */
  ));
}
function BKe(e, t) {
  !t || !t["!cols"] || (nt(
    e,
    390
    /* BrtBeginColInfos */
  ), t["!cols"].forEach(function(r, n) {
    r && nt(e, 60, kKe(n, r));
  }), nt(
    e,
    391
    /* BrtEndColInfos */
  ));
}
function UKe(e, t) {
  !t || !t["!ref"] || (nt(
    e,
    648
    /* BrtBeginCellIgnoreECs */
  ), nt(e, 649, IKe(vn(t["!ref"]))), nt(
    e,
    650
    /* BrtEndCellIgnoreECs */
  ));
}
function VKe(e, t, r) {
  t["!links"].forEach(function(n) {
    if (n[1].Target) {
      var a = qr(r, -1, n[1].Target.replace(/#.*$/, ""), Ar.HLINK);
      nt(e, 494, SKe(n, a));
    }
  }), delete t["!links"];
}
function $Ke(e, t, r, n) {
  if (t["!comments"].length > 0) {
    var a = qr(n, -1, "../drawings/vmlDrawing" + (r + 1) + ".vml", Ar.VML);
    nt(e, 551, q2("rId" + a)), t["!legacy"] = a;
  }
}
function HKe(e, t, r, n) {
  if (t["!autofilter"]) {
    var a = t["!autofilter"], s = typeof a.ref == "string" ? a.ref : ea(a.ref);
    r.Workbook || (r.Workbook = { Sheets: [] }), r.Workbook.Names || (r.Workbook.Names = []);
    var i = r.Workbook.Names, o = qs(s);
    o.s.r == o.e.r && (o.e.r = qs(t["!ref"]).e.r, s = ea(o));
    for (var l = 0; l < i.length; ++l) {
      var c = i[l];
      if (c.Name == "_xlnm._FilterDatabase" && c.Sheet == n) {
        c.Ref = "'" + r.SheetNames[n] + "'!" + s;
        break;
      }
    }
    l == i.length && i.push({ Name: "_xlnm._FilterDatabase", Sheet: n, Ref: "'" + r.SheetNames[n] + "'!" + s }), nt(e, 161, Xh(vn(s))), nt(
      e,
      162
      /* BrtEndAFilter */
    );
  }
}
function WKe(e, t, r) {
  nt(
    e,
    133
    /* BrtBeginWsViews */
  ), nt(e, 137, RKe(t, r)), nt(
    e,
    138
    /* BrtEndWsView */
  ), nt(
    e,
    134
    /* BrtEndWsViews */
  );
}
function zKe(e, t) {
  t["!protect"] && nt(e, 535, DKe(t["!protect"]));
}
function KKe(e, t, r, n) {
  var a = xs(), s = r.SheetNames[e], i = r.Sheets[s] || {}, o = s;
  try {
    r && r.Workbook && (o = r.Workbook.Sheets[e].CodeName || o);
  } catch {
  }
  var l = vn(i["!ref"] || "A1");
  if (l.e.c > 16383 || l.e.r > 1048575) {
    if (t.WTF) throw new Error("Range " + (i["!ref"] || "A1") + " exceeds format limit A1:XFD1048576");
    l.e.c = Math.min(l.e.c, 16383), l.e.r = Math.min(l.e.c, 1048575);
  }
  return i["!links"] = [], i["!comments"] = [], nt(
    a,
    129
    /* BrtBeginSheet */
  ), (r.vbaraw || i["!outline"]) && nt(a, 147, Bze(o, i["!outline"])), nt(a, 148, Lze(l)), WKe(a, i, r.Workbook), BKe(a, i), jKe(a, i, e, t), zKe(a, i), HKe(a, i, r, e), FKe(a, i), VKe(a, i, n), i["!margins"] && nt(a, 476, AKe(i["!margins"])), (!t || t.ignoreEC || t.ignoreEC == null) && UKe(a, i), $Ke(a, i, e, n), nt(
    a,
    130
    /* BrtEndSheet */
  ), a.end();
}
function qKe(e, t) {
  e.l += 10;
  var r = Xa(e);
  return { name: r };
}
var GKe = [
  ["allowRefreshQuery", !1, "bool"],
  ["autoCompressPictures", !0, "bool"],
  ["backupFile", !1, "bool"],
  ["checkCompatibility", !1, "bool"],
  ["CodeName", ""],
  ["date1904", !1, "bool"],
  ["defaultThemeVersion", 0, "int"],
  ["filterPrivacy", !1, "bool"],
  ["hidePivotFieldList", !1, "bool"],
  ["promptedSolutions", !1, "bool"],
  ["publishItems", !1, "bool"],
  ["refreshAllConnections", !1, "bool"],
  ["saveExternalLinkValues", !0, "bool"],
  ["showBorderUnselectedTables", !0, "bool"],
  ["showInkAnnotation", !0, "bool"],
  ["showObjects", "all"],
  ["showPivotChartFilter", !1, "bool"],
  ["updateLinks", "userSet"]
];
function YKe(e) {
  return !e.Workbook || !e.Workbook.WBProps ? "false" : CHe(e.Workbook.WBProps.date1904) ? "true" : "false";
}
var XKe = /* @__PURE__ */ "][*?/\\".split("");
function sW(e, t) {
  if (e.length > 31)
    throw new Error("Sheet names cannot exceed 31 chars");
  var r = !0;
  return XKe.forEach(function(n) {
    if (e.indexOf(n) != -1)
      throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
  }), r;
}
function QKe(e, t, r) {
  e.forEach(function(n, a) {
    sW(n);
    for (var s = 0; s < a; ++s) if (n == e[s]) throw new Error("Duplicate Sheet Name: " + n);
    if (r) {
      var i = t && t[a] && t[a].CodeName || n;
      if (i.charCodeAt(0) == 95 && i.length > 22) throw new Error("Bad Code Name: Worksheet" + i);
    }
  });
}
function JKe(e) {
  if (!e || !e.SheetNames || !e.Sheets) throw new Error("Invalid Workbook");
  if (!e.SheetNames.length) throw new Error("Workbook is empty");
  var t = e.Workbook && e.Workbook.Sheets || [];
  QKe(e.SheetNames, t, !!e.vbaraw);
  for (var r = 0; r < e.SheetNames.length; ++r) wze(e.Sheets[e.SheetNames[r]], e.SheetNames[r], r);
}
function iW(e) {
  var t = [ra];
  t[t.length] = vt("workbook", null, {
    xmlns: Gh[0],
    //'xmlns:mx': XMLNS.mx,
    //'xmlns:s': XMLNS_main[0],
    "xmlns:r": pa.r
  });
  var r = e.Workbook && (e.Workbook.Names || []).length > 0, n = { codeName: "ThisWorkbook" };
  e.Workbook && e.Workbook.WBProps && (GKe.forEach(function(o) {
    e.Workbook.WBProps[o[0]] != null && e.Workbook.WBProps[o[0]] != o[1] && (n[o[0]] = e.Workbook.WBProps[o[0]]);
  }), e.Workbook.WBProps.CodeName && (n.codeName = e.Workbook.WBProps.CodeName, delete n.CodeName)), t[t.length] = vt("workbookPr", null, n);
  var a = e.Workbook && e.Workbook.Sheets || [], s = 0;
  if (a && a[0] && a[0].Hidden) {
    for (t[t.length] = "<bookViews>", s = 0; s != e.SheetNames.length && !(!a[s] || !a[s].Hidden); ++s)
      ;
    s == e.SheetNames.length && (s = 0), t[t.length] = '<workbookView firstSheet="' + s + '" activeTab="' + s + '"/>', t[t.length] = "</bookViews>";
  }
  for (t[t.length] = "<sheets>", s = 0; s != e.SheetNames.length; ++s) {
    var i = { name: Jr(e.SheetNames[s].slice(0, 31)) };
    if (i.sheetId = "" + (s + 1), i["r:id"] = "rId" + (s + 1), a[s]) switch (a[s].Hidden) {
      case 1:
        i.state = "hidden";
        break;
      case 2:
        i.state = "veryHidden";
        break;
    }
    t[t.length] = vt("sheet", null, i);
  }
  return t[t.length] = "</sheets>", r && (t[t.length] = "<definedNames>", e.Workbook && e.Workbook.Names && e.Workbook.Names.forEach(function(o) {
    var l = { name: o.Name };
    o.Comment && (l.comment = o.Comment), o.Sheet != null && (l.localSheetId = "" + o.Sheet), o.Hidden && (l.hidden = "1"), o.Ref && (t[t.length] = vt("definedName", Jr(o.Ref), l));
  }), t[t.length] = "</definedNames>"), t.length > 2 && (t[t.length] = "</workbook>", t[1] = t[1].replace("/>", ">")), t.join("");
}
function ZKe(e, t) {
  var r = {};
  return r.Hidden = e.read_shift(4), r.iTabID = e.read_shift(4), r.strRelID = vT(e), r.name = Xa(e), r;
}
function eqe(e, t) {
  return t || (t = Ke(127)), t.write_shift(4, e.Hidden), t.write_shift(4, e.iTabID), q2(e.strRelID, t), ga(e.name.slice(0, 31), t), t.length > t.l ? t.slice(0, t.l) : t;
}
function tqe(e, t) {
  var r = {}, n = e.read_shift(4);
  r.defaultThemeVersion = e.read_shift(4);
  var a = t > 8 ? Xa(e) : "";
  return a.length > 0 && (r.CodeName = a), r.autoCompressPictures = !!(n & 65536), r.backupFile = !!(n & 64), r.checkCompatibility = !!(n & 4096), r.date1904 = !!(n & 1), r.filterPrivacy = !!(n & 8), r.hidePivotFieldList = !!(n & 1024), r.promptedSolutions = !!(n & 16), r.publishItems = !!(n & 2048), r.refreshAllConnections = !!(n & 262144), r.saveExternalLinkValues = !!(n & 128), r.showBorderUnselectedTables = !!(n & 4), r.showInkAnnotation = !!(n & 32), r.showObjects = ["all", "placeholders", "none"][n >> 13 & 3], r.showPivotChartFilter = !!(n & 32768), r.updateLinks = ["userSet", "never", "always"][n >> 8 & 3], r;
}
function rqe(e, t) {
  t || (t = Ke(72));
  var r = 0;
  return e && e.filterPrivacy && (r |= 8), t.write_shift(4, r), t.write_shift(4, 0), y9(e && e.CodeName || "ThisWorkbook", t), t.slice(0, t.l);
}
function nqe(e, t, r) {
  var n = e.l + t;
  e.l += 4, e.l += 1;
  var a = e.read_shift(4), s = YHe(e), i = pze(e, 0, r), o = K2(e);
  e.l = n;
  var l = { Name: s, Ptg: i };
  return a < 268435455 && (l.Sheet = a), o && (l.Comment = o), l;
}
function aqe(e, t) {
  nt(
    e,
    143
    /* BrtBeginBundleShs */
  );
  for (var r = 0; r != t.SheetNames.length; ++r) {
    var n = t.Workbook && t.Workbook.Sheets && t.Workbook.Sheets[r] && t.Workbook.Sheets[r].Hidden || 0, a = { Hidden: n, iTabID: r + 1, strRelID: "rId" + (r + 1), name: t.SheetNames[r] };
    nt(e, 156, eqe(a));
  }
  nt(
    e,
    144
    /* BrtEndBundleShs */
  );
}
function sqe(e, t) {
  t || (t = Ke(127));
  for (var r = 0; r != 4; ++r) t.write_shift(4, 0);
  return ga("SheetJS", t), ga(ew.version, t), ga(ew.version, t), ga("7262", t), t.length > t.l ? t.slice(0, t.l) : t;
}
function iqe(e, t) {
  t || (t = Ke(29)), t.write_shift(-4, 0), t.write_shift(-4, 460), t.write_shift(4, 28800), t.write_shift(4, 17600), t.write_shift(4, 500), t.write_shift(4, e), t.write_shift(4, e);
  var r = 120;
  return t.write_shift(1, r), t.length > t.l ? t.slice(0, t.l) : t;
}
function oqe(e, t) {
  if (!(!t.Workbook || !t.Workbook.Sheets)) {
    for (var r = t.Workbook.Sheets, n = 0, a = -1, s = -1; n < r.length; ++n)
      !r[n] || !r[n].Hidden && a == -1 ? a = n : r[n].Hidden == 1 && s == -1 && (s = n);
    s > a || (nt(
      e,
      135
      /* BrtBeginBookViews */
    ), nt(e, 158, iqe(a)), nt(
      e,
      136
      /* BrtEndBookViews */
    ));
  }
}
function lqe(e, t) {
  var r = xs();
  return nt(
    r,
    131
    /* BrtBeginBook */
  ), nt(r, 128, sqe()), nt(r, 153, rqe(e.Workbook && e.Workbook.WBProps || null)), oqe(r, e), aqe(r, e), nt(
    r,
    132
    /* BrtEndBook */
  ), r.end();
}
function cqe(e, t, r) {
  return (t.slice(-4) === ".bin" ? lqe : iW)(e);
}
function uqe(e, t, r, n, a) {
  return (t.slice(-4) === ".bin" ? KKe : nW)(e, r, n, a);
}
function dqe(e, t, r) {
  return (t.slice(-4) === ".bin" ? A9e : $9)(e, r);
}
function fqe(e, t, r) {
  return (t.slice(-4) === ".bin" ? r9e : F9)(e, r);
}
function hqe(e, t, r) {
  return (t.slice(-4) === ".bin" ? z9e : q9)(e);
}
function pqe(e) {
  return (e.slice(-4) === ".bin" ? j9e : z9)();
}
function mqe(e, t) {
  var r = [];
  return e.Props && r.push(d7e(e.Props, t)), e.Custprops && r.push(f7e(e.Props, e.Custprops)), r.join("");
}
function gqe() {
  return "";
}
function vqe(e, t) {
  var r = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
  return t.cellXfs.forEach(function(n, a) {
    var s = [];
    s.push(vt("NumberFormat", null, { "ss:Format": Jr(Rn[n.numFmtId]) }));
    var i = (
      /*::(*/
      { "ss:ID": "s" + (21 + a) }
    );
    r.push(vt("Style", s.join(""), i));
  }), vt("Styles", r.join(""));
}
function oW(e) {
  return vt("NamedRange", null, { "ss:Name": e.Name, "ss:RefersTo": "=" + Q2(e.Ref, { r: 0, c: 0 }) });
}
function yqe(e) {
  if (!((e || {}).Workbook || {}).Names) return "";
  for (var t = e.Workbook.Names, r = [], n = 0; n < t.length; ++n) {
    var a = t[n];
    a.Sheet == null && (a.Name.match(/^_xlfn\./) || r.push(oW(a)));
  }
  return vt("Names", r.join(""));
}
function bqe(e, t, r, n) {
  if (!e || !((n || {}).Workbook || {}).Names) return "";
  for (var a = n.Workbook.Names, s = [], i = 0; i < a.length; ++i) {
    var o = a[i];
    o.Sheet == r && (o.Name.match(/^_xlfn\./) || s.push(oW(o)));
  }
  return s.join("");
}
function wqe(e, t, r, n) {
  if (!e) return "";
  var a = [];
  if (e["!margins"] && (a.push("<PageSetup>"), e["!margins"].header && a.push(vt("Header", null, { "x:Margin": e["!margins"].header })), e["!margins"].footer && a.push(vt("Footer", null, { "x:Margin": e["!margins"].footer })), a.push(vt("PageMargins", null, {
    "x:Bottom": e["!margins"].bottom || "0.75",
    "x:Left": e["!margins"].left || "0.7",
    "x:Right": e["!margins"].right || "0.7",
    "x:Top": e["!margins"].top || "0.75"
  })), a.push("</PageSetup>")), n && n.Workbook && n.Workbook.Sheets && n.Workbook.Sheets[r])
    if (n.Workbook.Sheets[r].Hidden) a.push(vt("Visible", n.Workbook.Sheets[r].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
    else {
      for (var s = 0; s < r && !(n.Workbook.Sheets[s] && !n.Workbook.Sheets[s].Hidden); ++s) ;
      s == r && a.push("<Selected/>");
    }
  return ((((n || {}).Workbook || {}).Views || [])[0] || {}).RTL && a.push("<DisplayRightToLeft/>"), e["!protect"] && (a.push(Aa("ProtectContents", "True")), e["!protect"].objects && a.push(Aa("ProtectObjects", "True")), e["!protect"].scenarios && a.push(Aa("ProtectScenarios", "True")), e["!protect"].selectLockedCells != null && !e["!protect"].selectLockedCells ? a.push(Aa("EnableSelection", "NoSelection")) : e["!protect"].selectUnlockedCells != null && !e["!protect"].selectUnlockedCells && a.push(Aa("EnableSelection", "UnlockedCells")), [
    ["formatCells", "AllowFormatCells"],
    ["formatColumns", "AllowSizeCols"],
    ["formatRows", "AllowSizeRows"],
    ["insertColumns", "AllowInsertCols"],
    ["insertRows", "AllowInsertRows"],
    ["insertHyperlinks", "AllowInsertHyperlinks"],
    ["deleteColumns", "AllowDeleteCols"],
    ["deleteRows", "AllowDeleteRows"],
    ["sort", "AllowSort"],
    ["autoFilter", "AllowFilter"],
    ["pivotTables", "AllowUsePivotTables"]
  ].forEach(function(i) {
    e["!protect"][i[0]] && a.push("<" + i[1] + "/>");
  })), a.length == 0 ? "" : vt("WorksheetOptions", a.join(""), { xmlns: Us.x });
}
function xqe(e) {
  return e.map(function(t) {
    var r = THe(t.t || ""), n = vt("ss:Data", r, { xmlns: "http://www.w3.org/TR/REC-html40" });
    return vt("Comment", n, { "ss:Author": t.a });
  }).join("");
}
function _qe(e, t, r, n, a, s, i) {
  if (!e || e.v == null && e.f == null) return "";
  var o = {};
  if (e.f && (o["ss:Formula"] = "=" + Jr(Q2(e.f, i))), e.F && e.F.slice(0, t.length) == t) {
    var l = ma(e.F.slice(t.length + 1));
    o["ss:ArrayRange"] = "RC:R" + (l.r == i.r ? "" : "[" + (l.r - i.r) + "]") + "C" + (l.c == i.c ? "" : "[" + (l.c - i.c) + "]");
  }
  if (e.l && e.l.Target && (o["ss:HRef"] = Jr(e.l.Target), e.l.Tooltip && (o["x:HRefScreenTip"] = Jr(e.l.Tooltip))), r["!merges"])
    for (var c = r["!merges"], u = 0; u != c.length; ++u)
      c[u].s.c != i.c || c[u].s.r != i.r || (c[u].e.c > c[u].s.c && (o["ss:MergeAcross"] = c[u].e.c - c[u].s.c), c[u].e.r > c[u].s.r && (o["ss:MergeDown"] = c[u].e.r - c[u].s.r));
  var d = "", f = "";
  switch (e.t) {
    case "z":
      if (!n.sheetStubs) return "";
      break;
    case "n":
      d = "Number", f = String(e.v);
      break;
    case "b":
      d = "Boolean", f = e.v ? "1" : "0";
      break;
    case "e":
      d = "Error", f = _v[e.v];
      break;
    case "d":
      d = "DateTime", f = new Date(e.v).toISOString(), e.z == null && (e.z = e.z || Rn[14]);
      break;
    case "s":
      d = "String", f = EHe(e.v || "");
      break;
  }
  var h = Zc(n.cellXfs, e, n);
  o["ss:StyleID"] = "s" + (21 + h), o["ss:Index"] = i.c + 1;
  var p = e.v != null ? f : "", m = e.t == "z" ? "" : '<Data ss:Type="' + d + '">' + p + "</Data>";
  return (e.c || []).length > 0 && (m += xqe(e.c)), vt("Cell", m, o);
}
function Sqe(e, t) {
  var r = '<Row ss:Index="' + (e + 1) + '"';
  return t && (t.hpt && !t.hpx && (t.hpx = V9(t.hpt)), t.hpx && (r += ' ss:AutoFitHeight="0" ss:Height="' + t.hpx + '"'), t.hidden && (r += ' ss:Hidden="1"')), r + ">";
}
function Eqe(e, t, r, n) {
  if (!e["!ref"]) return "";
  var a = vn(e["!ref"]), s = e["!merges"] || [], i = 0, o = [];
  e["!cols"] && e["!cols"].forEach(function(g, y) {
    Y2(g);
    var x = !!g.width, w = e1(y, g), _ = { "ss:Index": y + 1 };
    x && (_["ss:Width"] = cw(w.width)), g.hidden && (_["ss:Hidden"] = "1"), o.push(vt("Column", null, _));
  });
  for (var l = Array.isArray(e), c = a.s.r; c <= a.e.r; ++c) {
    for (var u = [Sqe(c, (e["!rows"] || [])[c])], d = a.s.c; d <= a.e.c; ++d) {
      var f = !1;
      for (i = 0; i != s.length; ++i)
        if (!(s[i].s.c > d) && !(s[i].s.r > c) && !(s[i].e.c < d) && !(s[i].e.r < c)) {
          (s[i].s.c != d || s[i].s.r != c) && (f = !0);
          break;
        }
      if (!f) {
        var h = { r: c, c: d }, p = Zr(h), m = l ? (e[c] || [])[d] : e[p];
        u.push(_qe(m, p, e, t, r, n, h));
      }
    }
    u.push("</Row>"), u.length > 2 && o.push(u.join(""));
  }
  return o.join("");
}
function Tqe(e, t, r) {
  var n = [], a = r.SheetNames[e], s = r.Sheets[a], i = s ? bqe(s, t, e, r) : "";
  return i.length > 0 && n.push("<Names>" + i + "</Names>"), i = s ? Eqe(s, t, e, r) : "", i.length > 0 && n.push("<Table>" + i + "</Table>"), n.push(wqe(s, t, e, r)), n.join("");
}
function Cqe(e, t) {
  t || (t = {}), e.SSF || (e.SSF = Ss(Rn)), e.SSF && (Yx(), Gx(e.SSF), t.revssf = Xx(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF, t.cellXfs = [], Zc(t.cellXfs, {}, { revssf: { General: 0 } }));
  var r = [];
  r.push(mqe(e, t)), r.push(gqe()), r.push(""), r.push("");
  for (var n = 0; n < e.SheetNames.length; ++n)
    r.push(vt("Worksheet", Tqe(n, t, e), { "ss:Name": Jr(e.SheetNames[n]) }));
  return r[2] = vqe(e, t), r[3] = yqe(e), ra + vt("Workbook", r.join(""), {
    xmlns: Us.ss,
    "xmlns:o": Us.o,
    "xmlns:x": Us.x,
    "xmlns:ss": Us.ss,
    "xmlns:dt": Us.dt,
    "xmlns:html": Us.html
  });
}
var OS = {
  SI: "e0859ff2f94f6810ab9108002b27b3d9",
  DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
  UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function kqe(e, t) {
  var r = [], n = [], a = [], s = 0, i, o = Bj(Jj, "n"), l = Bj(Zj, "n");
  if (e.Props)
    for (i = Ia(e.Props), s = 0; s < i.length; ++s) (Object.prototype.hasOwnProperty.call(o, i[s]) ? r : Object.prototype.hasOwnProperty.call(l, i[s]) ? n : a).push([i[s], e.Props[i[s]]]);
  if (e.Custprops)
    for (i = Ia(e.Custprops), s = 0; s < i.length; ++s) Object.prototype.hasOwnProperty.call(e.Props || {}, i[s]) || (Object.prototype.hasOwnProperty.call(o, i[s]) ? r : Object.prototype.hasOwnProperty.call(l, i[s]) ? n : a).push([i[s], e.Custprops[i[s]]]);
  var c = [];
  for (s = 0; s < a.length; ++s)
    R9.indexOf(a[s][0]) > -1 || O9.indexOf(a[s][0]) > -1 || a[s][1] != null && c.push(a[s]);
  n.length && rn.utils.cfb_add(t, "/SummaryInformation", a4(n, OS.SI, l, Zj)), (r.length || c.length) && rn.utils.cfb_add(t, "/DocumentSummaryInformation", a4(r, OS.DSI, o, Jj, c.length ? c : null, OS.UDI));
}
function Oqe(e, t) {
  var r = t || {}, n = rn.utils.cfb_new({ root: "R" }), a = "/Workbook";
  switch (r.bookType || "xls") {
    case "xls":
      r.bookType = "biff8";
    case "xla":
      r.bookType || (r.bookType = "xla");
    case "biff8":
      a = "/Workbook", r.biff = 8;
      break;
    case "biff5":
      a = "/Book", r.biff = 5;
      break;
    default:
      throw new Error("invalid type " + r.bookType + " for XLS CFB");
  }
  return rn.utils.cfb_add(n, a, lW(e, r)), r.biff == 8 && (e.Props || e.Custprops) && kqe(e, n), r.biff == 8 && e.vbaraw && K9e(n, rn.read(e.vbaraw, { type: typeof e.vbaraw == "string" ? "binary" : "buffer" })), n;
}
var Aqe = {
  /*::[*/
  0: {
    /* n:"BrtRowHdr", */
    f: Ize
  },
  /*::[*/
  1: {
    /* n:"BrtCellBlank", */
    f: Uze
  },
  /*::[*/
  2: {
    /* n:"BrtCellRk", */
    f: iKe
  },
  /*::[*/
  3: {
    /* n:"BrtCellError", */
    f: Gze
  },
  /*::[*/
  4: {
    /* n:"BrtCellBool", */
    f: Wze
  },
  /*::[*/
  5: {
    /* n:"BrtCellReal", */
    f: rKe
  },
  /*::[*/
  6: {
    /* n:"BrtCellSt", */
    f: dKe
  },
  /*::[*/
  7: {
    /* n:"BrtCellIsst", */
    f: Jze
  },
  /*::[*/
  8: {
    /* n:"BrtFmlaString", */
    f: yKe
  },
  /*::[*/
  9: {
    /* n:"BrtFmlaNum", */
    f: vKe
  },
  /*::[*/
  10: {
    /* n:"BrtFmlaBool", */
    f: mKe
  },
  /*::[*/
  11: {
    /* n:"BrtFmlaError", */
    f: gKe
  },
  /*::[*/
  12: {
    /* n:"BrtShortBlank", */
    f: $ze
  },
  /*::[*/
  13: {
    /* n:"BrtShortRk", */
    f: lKe
  },
  /*::[*/
  14: {
    /* n:"BrtShortError", */
    f: Xze
  },
  /*::[*/
  15: {
    /* n:"BrtShortBool", */
    f: Kze
  },
  /*::[*/
  16: {
    /* n:"BrtShortReal", */
    f: aKe
  },
  /*::[*/
  17: {
    /* n:"BrtShortSt", */
    f: hKe
  },
  /*::[*/
  18: {
    /* n:"BrtShortIsst", */
    f: eKe
  },
  /*::[*/
  19: {
    /* n:"BrtSSTItem", */
    f: z2
  },
  /*::[*/
  20: {
    /* n:"BrtPCDIMissing" */
  },
  /*::[*/
  21: {
    /* n:"BrtPCDINumber" */
  },
  /*::[*/
  22: {
    /* n:"BrtPCDIBoolean" */
  },
  /*::[*/
  23: {
    /* n:"BrtPCDIError" */
  },
  /*::[*/
  24: {
    /* n:"BrtPCDIString" */
  },
  /*::[*/
  25: {
    /* n:"BrtPCDIDatetime" */
  },
  /*::[*/
  26: {
    /* n:"BrtPCDIIndex" */
  },
  /*::[*/
  27: {
    /* n:"BrtPCDIAMissing" */
  },
  /*::[*/
  28: {
    /* n:"BrtPCDIANumber" */
  },
  /*::[*/
  29: {
    /* n:"BrtPCDIABoolean" */
  },
  /*::[*/
  30: {
    /* n:"BrtPCDIAError" */
  },
  /*::[*/
  31: {
    /* n:"BrtPCDIAString" */
  },
  /*::[*/
  32: {
    /* n:"BrtPCDIADatetime" */
  },
  /*::[*/
  33: {
    /* n:"BrtPCRRecord" */
  },
  /*::[*/
  34: {
    /* n:"BrtPCRRecordDt" */
  },
  /*::[*/
  35: {
    /* n:"BrtFRTBegin", */
    T: 1
  },
  /*::[*/
  36: {
    /* n:"BrtFRTEnd", */
    T: -1
  },
  /*::[*/
  37: {
    /* n:"BrtACBegin", */
    T: 1
  },
  /*::[*/
  38: {
    /* n:"BrtACEnd", */
    T: -1
  },
  /*::[*/
  39: {
    /* n:"BrtName", */
    f: nqe
  },
  /*::[*/
  40: {
    /* n:"BrtIndexRowBlock" */
  },
  /*::[*/
  42: {
    /* n:"BrtIndexBlock" */
  },
  /*::[*/
  43: {
    /* n:"BrtFont", */
    f: d9e
  },
  /*::[*/
  44: {
    /* n:"BrtFmt", */
    f: c9e
  },
  /*::[*/
  45: {
    /* n:"BrtFill", */
    f: p9e
  },
  /*::[*/
  46: {
    /* n:"BrtBorder", */
    f: g9e
  },
  /*::[*/
  47: {
    /* n:"BrtXF", */
    f: m9e
  },
  /*::[*/
  48: {
    /* n:"BrtStyle" */
  },
  /*::[*/
  49: {
    /* n:"BrtCellMeta", */
    f: $He
  },
  /*::[*/
  50: {
    /* n:"BrtValueMeta" */
  },
  /*::[*/
  51: {
    /* n:"BrtMdb" */
    f: I9e
  },
  /*::[*/
  52: {
    /* n:"BrtBeginFmd", */
    T: 1
  },
  /*::[*/
  53: {
    /* n:"BrtEndFmd", */
    T: -1
  },
  /*::[*/
  54: {
    /* n:"BrtBeginMdx", */
    T: 1
  },
  /*::[*/
  55: {
    /* n:"BrtEndMdx", */
    T: -1
  },
  /*::[*/
  56: {
    /* n:"BrtBeginMdxTuple", */
    T: 1
  },
  /*::[*/
  57: {
    /* n:"BrtEndMdxTuple", */
    T: -1
  },
  /*::[*/
  58: {
    /* n:"BrtMdxMbrIstr" */
  },
  /*::[*/
  59: {
    /* n:"BrtStr" */
  },
  /*::[*/
  60: {
    /* n:"BrtColInfo", */
    f: H7e
  },
  /*::[*/
  62: {
    /* n:"BrtCellRString", */
    f: uKe
  },
  /*::[*/
  63: {
    /* n:"BrtCalcChainItem$", */
    f: F9e
  },
  /*::[*/
  64: {
    /* n:"BrtDVal", */
    f: NKe
  },
  /*::[*/
  65: {
    /* n:"BrtSxvcellNum" */
  },
  /*::[*/
  66: {
    /* n:"BrtSxvcellStr" */
  },
  /*::[*/
  67: {
    /* n:"BrtSxvcellBool" */
  },
  /*::[*/
  68: {
    /* n:"BrtSxvcellErr" */
  },
  /*::[*/
  69: {
    /* n:"BrtSxvcellDate" */
  },
  /*::[*/
  70: {
    /* n:"BrtSxvcellNil" */
  },
  /*::[*/
  128: {
    /* n:"BrtFileVersion" */
  },
  /*::[*/
  129: {
    /* n:"BrtBeginSheet", */
    T: 1
  },
  /*::[*/
  130: {
    /* n:"BrtEndSheet", */
    T: -1
  },
  /*::[*/
  131: {
    /* n:"BrtBeginBook", */
    T: 1,
    f: Vo,
    p: 0
  },
  /*::[*/
  132: {
    /* n:"BrtEndBook", */
    T: -1
  },
  /*::[*/
  133: {
    /* n:"BrtBeginWsViews", */
    T: 1
  },
  /*::[*/
  134: {
    /* n:"BrtEndWsViews", */
    T: -1
  },
  /*::[*/
  135: {
    /* n:"BrtBeginBookViews", */
    T: 1
  },
  /*::[*/
  136: {
    /* n:"BrtEndBookViews", */
    T: -1
  },
  /*::[*/
  137: {
    /* n:"BrtBeginWsView", */
    T: 1,
    f: PKe
  },
  /*::[*/
  138: {
    /* n:"BrtEndWsView", */
    T: -1
  },
  /*::[*/
  139: {
    /* n:"BrtBeginCsViews", */
    T: 1
  },
  /*::[*/
  140: {
    /* n:"BrtEndCsViews", */
    T: -1
  },
  /*::[*/
  141: {
    /* n:"BrtBeginCsView", */
    T: 1
  },
  /*::[*/
  142: {
    /* n:"BrtEndCsView", */
    T: -1
  },
  /*::[*/
  143: {
    /* n:"BrtBeginBundleShs", */
    T: 1
  },
  /*::[*/
  144: {
    /* n:"BrtEndBundleShs", */
    T: -1
  },
  /*::[*/
  145: {
    /* n:"BrtBeginSheetData", */
    T: 1
  },
  /*::[*/
  146: {
    /* n:"BrtEndSheetData", */
    T: -1
  },
  /*::[*/
  147: {
    /* n:"BrtWsProp", */
    f: Fze
  },
  /*::[*/
  148: {
    /* n:"BrtWsDim", */
    f: Mze,
    p: 16
  },
  /*::[*/
  151: {
    /* n:"BrtPane", */
    f: EKe
  },
  /*::[*/
  152: {
    /* n:"BrtSel" */
  },
  /*::[*/
  153: {
    /* n:"BrtWbProp", */
    f: tqe
  },
  /*::[*/
  154: {
    /* n:"BrtWbFactoid" */
  },
  /*::[*/
  155: {
    /* n:"BrtFileRecover" */
  },
  /*::[*/
  156: {
    /* n:"BrtBundleSh", */
    f: ZKe
  },
  /*::[*/
  157: {
    /* n:"BrtCalcProp" */
  },
  /*::[*/
  158: {
    /* n:"BrtBookView" */
  },
  /*::[*/
  159: {
    /* n:"BrtBeginSst", */
    T: 1,
    f: Z7e
  },
  /*::[*/
  160: {
    /* n:"BrtEndSst", */
    T: -1
  },
  /*::[*/
  161: {
    /* n:"BrtBeginAFilter", */
    T: 1,
    f: Cd
  },
  /*::[*/
  162: {
    /* n:"BrtEndAFilter", */
    T: -1
  },
  /*::[*/
  163: {
    /* n:"BrtBeginFilterColumn", */
    T: 1
  },
  /*::[*/
  164: {
    /* n:"BrtEndFilterColumn", */
    T: -1
  },
  /*::[*/
  165: {
    /* n:"BrtBeginFilters", */
    T: 1
  },
  /*::[*/
  166: {
    /* n:"BrtEndFilters", */
    T: -1
  },
  /*::[*/
  167: {
    /* n:"BrtFilter" */
  },
  /*::[*/
  168: {
    /* n:"BrtColorFilter" */
  },
  /*::[*/
  169: {
    /* n:"BrtIconFilter" */
  },
  /*::[*/
  170: {
    /* n:"BrtTop10Filter" */
  },
  /*::[*/
  171: {
    /* n:"BrtDynamicFilter" */
  },
  /*::[*/
  172: {
    /* n:"BrtBeginCustomFilters", */
    T: 1
  },
  /*::[*/
  173: {
    /* n:"BrtEndCustomFilters", */
    T: -1
  },
  /*::[*/
  174: {
    /* n:"BrtCustomFilter" */
  },
  /*::[*/
  175: {
    /* n:"BrtAFilterDateGroupItem" */
  },
  /*::[*/
  176: {
    /* n:"BrtMergeCell", */
    f: bKe
  },
  /*::[*/
  177: {
    /* n:"BrtBeginMergeCells", */
    T: 1
  },
  /*::[*/
  178: {
    /* n:"BrtEndMergeCells", */
    T: -1
  },
  /*::[*/
  179: {
    /* n:"BrtBeginPivotCacheDef", */
    T: 1
  },
  /*::[*/
  180: {
    /* n:"BrtEndPivotCacheDef", */
    T: -1
  },
  /*::[*/
  181: {
    /* n:"BrtBeginPCDFields", */
    T: 1
  },
  /*::[*/
  182: {
    /* n:"BrtEndPCDFields", */
    T: -1
  },
  /*::[*/
  183: {
    /* n:"BrtBeginPCDField", */
    T: 1
  },
  /*::[*/
  184: {
    /* n:"BrtEndPCDField", */
    T: -1
  },
  /*::[*/
  185: {
    /* n:"BrtBeginPCDSource", */
    T: 1
  },
  /*::[*/
  186: {
    /* n:"BrtEndPCDSource", */
    T: -1
  },
  /*::[*/
  187: {
    /* n:"BrtBeginPCDSRange", */
    T: 1
  },
  /*::[*/
  188: {
    /* n:"BrtEndPCDSRange", */
    T: -1
  },
  /*::[*/
  189: {
    /* n:"BrtBeginPCDFAtbl", */
    T: 1
  },
  /*::[*/
  190: {
    /* n:"BrtEndPCDFAtbl", */
    T: -1
  },
  /*::[*/
  191: {
    /* n:"BrtBeginPCDIRun", */
    T: 1
  },
  /*::[*/
  192: {
    /* n:"BrtEndPCDIRun", */
    T: -1
  },
  /*::[*/
  193: {
    /* n:"BrtBeginPivotCacheRecords", */
    T: 1
  },
  /*::[*/
  194: {
    /* n:"BrtEndPivotCacheRecords", */
    T: -1
  },
  /*::[*/
  195: {
    /* n:"BrtBeginPCDHierarchies", */
    T: 1
  },
  /*::[*/
  196: {
    /* n:"BrtEndPCDHierarchies", */
    T: -1
  },
  /*::[*/
  197: {
    /* n:"BrtBeginPCDHierarchy", */
    T: 1
  },
  /*::[*/
  198: {
    /* n:"BrtEndPCDHierarchy", */
    T: -1
  },
  /*::[*/
  199: {
    /* n:"BrtBeginPCDHFieldsUsage", */
    T: 1
  },
  /*::[*/
  200: {
    /* n:"BrtEndPCDHFieldsUsage", */
    T: -1
  },
  /*::[*/
  201: {
    /* n:"BrtBeginExtConnection", */
    T: 1
  },
  /*::[*/
  202: {
    /* n:"BrtEndExtConnection", */
    T: -1
  },
  /*::[*/
  203: {
    /* n:"BrtBeginECDbProps", */
    T: 1
  },
  /*::[*/
  204: {
    /* n:"BrtEndECDbProps", */
    T: -1
  },
  /*::[*/
  205: {
    /* n:"BrtBeginECOlapProps", */
    T: 1
  },
  /*::[*/
  206: {
    /* n:"BrtEndECOlapProps", */
    T: -1
  },
  /*::[*/
  207: {
    /* n:"BrtBeginPCDSConsol", */
    T: 1
  },
  /*::[*/
  208: {
    /* n:"BrtEndPCDSConsol", */
    T: -1
  },
  /*::[*/
  209: {
    /* n:"BrtBeginPCDSCPages", */
    T: 1
  },
  /*::[*/
  210: {
    /* n:"BrtEndPCDSCPages", */
    T: -1
  },
  /*::[*/
  211: {
    /* n:"BrtBeginPCDSCPage", */
    T: 1
  },
  /*::[*/
  212: {
    /* n:"BrtEndPCDSCPage", */
    T: -1
  },
  /*::[*/
  213: {
    /* n:"BrtBeginPCDSCPItem", */
    T: 1
  },
  /*::[*/
  214: {
    /* n:"BrtEndPCDSCPItem", */
    T: -1
  },
  /*::[*/
  215: {
    /* n:"BrtBeginPCDSCSets", */
    T: 1
  },
  /*::[*/
  216: {
    /* n:"BrtEndPCDSCSets", */
    T: -1
  },
  /*::[*/
  217: {
    /* n:"BrtBeginPCDSCSet", */
    T: 1
  },
  /*::[*/
  218: {
    /* n:"BrtEndPCDSCSet", */
    T: -1
  },
  /*::[*/
  219: {
    /* n:"BrtBeginPCDFGroup", */
    T: 1
  },
  /*::[*/
  220: {
    /* n:"BrtEndPCDFGroup", */
    T: -1
  },
  /*::[*/
  221: {
    /* n:"BrtBeginPCDFGItems", */
    T: 1
  },
  /*::[*/
  222: {
    /* n:"BrtEndPCDFGItems", */
    T: -1
  },
  /*::[*/
  223: {
    /* n:"BrtBeginPCDFGRange", */
    T: 1
  },
  /*::[*/
  224: {
    /* n:"BrtEndPCDFGRange", */
    T: -1
  },
  /*::[*/
  225: {
    /* n:"BrtBeginPCDFGDiscrete", */
    T: 1
  },
  /*::[*/
  226: {
    /* n:"BrtEndPCDFGDiscrete", */
    T: -1
  },
  /*::[*/
  227: {
    /* n:"BrtBeginPCDSDTupleCache", */
    T: 1
  },
  /*::[*/
  228: {
    /* n:"BrtEndPCDSDTupleCache", */
    T: -1
  },
  /*::[*/
  229: {
    /* n:"BrtBeginPCDSDTCEntries", */
    T: 1
  },
  /*::[*/
  230: {
    /* n:"BrtEndPCDSDTCEntries", */
    T: -1
  },
  /*::[*/
  231: {
    /* n:"BrtBeginPCDSDTCEMembers", */
    T: 1
  },
  /*::[*/
  232: {
    /* n:"BrtEndPCDSDTCEMembers", */
    T: -1
  },
  /*::[*/
  233: {
    /* n:"BrtBeginPCDSDTCEMember", */
    T: 1
  },
  /*::[*/
  234: {
    /* n:"BrtEndPCDSDTCEMember", */
    T: -1
  },
  /*::[*/
  235: {
    /* n:"BrtBeginPCDSDTCQueries", */
    T: 1
  },
  /*::[*/
  236: {
    /* n:"BrtEndPCDSDTCQueries", */
    T: -1
  },
  /*::[*/
  237: {
    /* n:"BrtBeginPCDSDTCQuery", */
    T: 1
  },
  /*::[*/
  238: {
    /* n:"BrtEndPCDSDTCQuery", */
    T: -1
  },
  /*::[*/
  239: {
    /* n:"BrtBeginPCDSDTCSets", */
    T: 1
  },
  /*::[*/
  240: {
    /* n:"BrtEndPCDSDTCSets", */
    T: -1
  },
  /*::[*/
  241: {
    /* n:"BrtBeginPCDSDTCSet", */
    T: 1
  },
  /*::[*/
  242: {
    /* n:"BrtEndPCDSDTCSet", */
    T: -1
  },
  /*::[*/
  243: {
    /* n:"BrtBeginPCDCalcItems", */
    T: 1
  },
  /*::[*/
  244: {
    /* n:"BrtEndPCDCalcItems", */
    T: -1
  },
  /*::[*/
  245: {
    /* n:"BrtBeginPCDCalcItem", */
    T: 1
  },
  /*::[*/
  246: {
    /* n:"BrtEndPCDCalcItem", */
    T: -1
  },
  /*::[*/
  247: {
    /* n:"BrtBeginPRule", */
    T: 1
  },
  /*::[*/
  248: {
    /* n:"BrtEndPRule", */
    T: -1
  },
  /*::[*/
  249: {
    /* n:"BrtBeginPRFilters", */
    T: 1
  },
  /*::[*/
  250: {
    /* n:"BrtEndPRFilters", */
    T: -1
  },
  /*::[*/
  251: {
    /* n:"BrtBeginPRFilter", */
    T: 1
  },
  /*::[*/
  252: {
    /* n:"BrtEndPRFilter", */
    T: -1
  },
  /*::[*/
  253: {
    /* n:"BrtBeginPNames", */
    T: 1
  },
  /*::[*/
  254: {
    /* n:"BrtEndPNames", */
    T: -1
  },
  /*::[*/
  255: {
    /* n:"BrtBeginPName", */
    T: 1
  },
  /*::[*/
  256: {
    /* n:"BrtEndPName", */
    T: -1
  },
  /*::[*/
  257: {
    /* n:"BrtBeginPNPairs", */
    T: 1
  },
  /*::[*/
  258: {
    /* n:"BrtEndPNPairs", */
    T: -1
  },
  /*::[*/
  259: {
    /* n:"BrtBeginPNPair", */
    T: 1
  },
  /*::[*/
  260: {
    /* n:"BrtEndPNPair", */
    T: -1
  },
  /*::[*/
  261: {
    /* n:"BrtBeginECWebProps", */
    T: 1
  },
  /*::[*/
  262: {
    /* n:"BrtEndECWebProps", */
    T: -1
  },
  /*::[*/
  263: {
    /* n:"BrtBeginEcWpTables", */
    T: 1
  },
  /*::[*/
  264: {
    /* n:"BrtEndECWPTables", */
    T: -1
  },
  /*::[*/
  265: {
    /* n:"BrtBeginECParams", */
    T: 1
  },
  /*::[*/
  266: {
    /* n:"BrtEndECParams", */
    T: -1
  },
  /*::[*/
  267: {
    /* n:"BrtBeginECParam", */
    T: 1
  },
  /*::[*/
  268: {
    /* n:"BrtEndECParam", */
    T: -1
  },
  /*::[*/
  269: {
    /* n:"BrtBeginPCDKPIs", */
    T: 1
  },
  /*::[*/
  270: {
    /* n:"BrtEndPCDKPIs", */
    T: -1
  },
  /*::[*/
  271: {
    /* n:"BrtBeginPCDKPI", */
    T: 1
  },
  /*::[*/
  272: {
    /* n:"BrtEndPCDKPI", */
    T: -1
  },
  /*::[*/
  273: {
    /* n:"BrtBeginDims", */
    T: 1
  },
  /*::[*/
  274: {
    /* n:"BrtEndDims", */
    T: -1
  },
  /*::[*/
  275: {
    /* n:"BrtBeginDim", */
    T: 1
  },
  /*::[*/
  276: {
    /* n:"BrtEndDim", */
    T: -1
  },
  /*::[*/
  277: {
    /* n:"BrtIndexPartEnd" */
  },
  /*::[*/
  278: {
    /* n:"BrtBeginStyleSheet", */
    T: 1
  },
  /*::[*/
  279: {
    /* n:"BrtEndStyleSheet", */
    T: -1
  },
  /*::[*/
  280: {
    /* n:"BrtBeginSXView", */
    T: 1
  },
  /*::[*/
  281: {
    /* n:"BrtEndSXVI", */
    T: -1
  },
  /*::[*/
  282: {
    /* n:"BrtBeginSXVI", */
    T: 1
  },
  /*::[*/
  283: {
    /* n:"BrtBeginSXVIs", */
    T: 1
  },
  /*::[*/
  284: {
    /* n:"BrtEndSXVIs", */
    T: -1
  },
  /*::[*/
  285: {
    /* n:"BrtBeginSXVD", */
    T: 1
  },
  /*::[*/
  286: {
    /* n:"BrtEndSXVD", */
    T: -1
  },
  /*::[*/
  287: {
    /* n:"BrtBeginSXVDs", */
    T: 1
  },
  /*::[*/
  288: {
    /* n:"BrtEndSXVDs", */
    T: -1
  },
  /*::[*/
  289: {
    /* n:"BrtBeginSXPI", */
    T: 1
  },
  /*::[*/
  290: {
    /* n:"BrtEndSXPI", */
    T: -1
  },
  /*::[*/
  291: {
    /* n:"BrtBeginSXPIs", */
    T: 1
  },
  /*::[*/
  292: {
    /* n:"BrtEndSXPIs", */
    T: -1
  },
  /*::[*/
  293: {
    /* n:"BrtBeginSXDI", */
    T: 1
  },
  /*::[*/
  294: {
    /* n:"BrtEndSXDI", */
    T: -1
  },
  /*::[*/
  295: {
    /* n:"BrtBeginSXDIs", */
    T: 1
  },
  /*::[*/
  296: {
    /* n:"BrtEndSXDIs", */
    T: -1
  },
  /*::[*/
  297: {
    /* n:"BrtBeginSXLI", */
    T: 1
  },
  /*::[*/
  298: {
    /* n:"BrtEndSXLI", */
    T: -1
  },
  /*::[*/
  299: {
    /* n:"BrtBeginSXLIRws", */
    T: 1
  },
  /*::[*/
  300: {
    /* n:"BrtEndSXLIRws", */
    T: -1
  },
  /*::[*/
  301: {
    /* n:"BrtBeginSXLICols", */
    T: 1
  },
  /*::[*/
  302: {
    /* n:"BrtEndSXLICols", */
    T: -1
  },
  /*::[*/
  303: {
    /* n:"BrtBeginSXFormat", */
    T: 1
  },
  /*::[*/
  304: {
    /* n:"BrtEndSXFormat", */
    T: -1
  },
  /*::[*/
  305: {
    /* n:"BrtBeginSXFormats", */
    T: 1
  },
  /*::[*/
  306: {
    /* n:"BrtEndSxFormats", */
    T: -1
  },
  /*::[*/
  307: {
    /* n:"BrtBeginSxSelect", */
    T: 1
  },
  /*::[*/
  308: {
    /* n:"BrtEndSxSelect", */
    T: -1
  },
  /*::[*/
  309: {
    /* n:"BrtBeginISXVDRws", */
    T: 1
  },
  /*::[*/
  310: {
    /* n:"BrtEndISXVDRws", */
    T: -1
  },
  /*::[*/
  311: {
    /* n:"BrtBeginISXVDCols", */
    T: 1
  },
  /*::[*/
  312: {
    /* n:"BrtEndISXVDCols", */
    T: -1
  },
  /*::[*/
  313: {
    /* n:"BrtEndSXLocation", */
    T: -1
  },
  /*::[*/
  314: {
    /* n:"BrtBeginSXLocation", */
    T: 1
  },
  /*::[*/
  315: {
    /* n:"BrtEndSXView", */
    T: -1
  },
  /*::[*/
  316: {
    /* n:"BrtBeginSXTHs", */
    T: 1
  },
  /*::[*/
  317: {
    /* n:"BrtEndSXTHs", */
    T: -1
  },
  /*::[*/
  318: {
    /* n:"BrtBeginSXTH", */
    T: 1
  },
  /*::[*/
  319: {
    /* n:"BrtEndSXTH", */
    T: -1
  },
  /*::[*/
  320: {
    /* n:"BrtBeginISXTHRws", */
    T: 1
  },
  /*::[*/
  321: {
    /* n:"BrtEndISXTHRws", */
    T: -1
  },
  /*::[*/
  322: {
    /* n:"BrtBeginISXTHCols", */
    T: 1
  },
  /*::[*/
  323: {
    /* n:"BrtEndISXTHCols", */
    T: -1
  },
  /*::[*/
  324: {
    /* n:"BrtBeginSXTDMPS", */
    T: 1
  },
  /*::[*/
  325: {
    /* n:"BrtEndSXTDMPs", */
    T: -1
  },
  /*::[*/
  326: {
    /* n:"BrtBeginSXTDMP", */
    T: 1
  },
  /*::[*/
  327: {
    /* n:"BrtEndSXTDMP", */
    T: -1
  },
  /*::[*/
  328: {
    /* n:"BrtBeginSXTHItems", */
    T: 1
  },
  /*::[*/
  329: {
    /* n:"BrtEndSXTHItems", */
    T: -1
  },
  /*::[*/
  330: {
    /* n:"BrtBeginSXTHItem", */
    T: 1
  },
  /*::[*/
  331: {
    /* n:"BrtEndSXTHItem", */
    T: -1
  },
  /*::[*/
  332: {
    /* n:"BrtBeginMetadata", */
    T: 1
  },
  /*::[*/
  333: {
    /* n:"BrtEndMetadata", */
    T: -1
  },
  /*::[*/
  334: {
    /* n:"BrtBeginEsmdtinfo", */
    T: 1
  },
  /*::[*/
  335: {
    /* n:"BrtMdtinfo", */
    f: P9e
  },
  /*::[*/
  336: {
    /* n:"BrtEndEsmdtinfo", */
    T: -1
  },
  /*::[*/
  337: {
    /* n:"BrtBeginEsmdb", */
    f: M9e,
    T: 1
  },
  /*::[*/
  338: {
    /* n:"BrtEndEsmdb", */
    T: -1
  },
  /*::[*/
  339: {
    /* n:"BrtBeginEsfmd", */
    T: 1
  },
  /*::[*/
  340: {
    /* n:"BrtEndEsfmd", */
    T: -1
  },
  /*::[*/
  341: {
    /* n:"BrtBeginSingleCells", */
    T: 1
  },
  /*::[*/
  342: {
    /* n:"BrtEndSingleCells", */
    T: -1
  },
  /*::[*/
  343: {
    /* n:"BrtBeginList", */
    T: 1
  },
  /*::[*/
  344: {
    /* n:"BrtEndList", */
    T: -1
  },
  /*::[*/
  345: {
    /* n:"BrtBeginListCols", */
    T: 1
  },
  /*::[*/
  346: {
    /* n:"BrtEndListCols", */
    T: -1
  },
  /*::[*/
  347: {
    /* n:"BrtBeginListCol", */
    T: 1
  },
  /*::[*/
  348: {
    /* n:"BrtEndListCol", */
    T: -1
  },
  /*::[*/
  349: {
    /* n:"BrtBeginListXmlCPr", */
    T: 1
  },
  /*::[*/
  350: {
    /* n:"BrtEndListXmlCPr", */
    T: -1
  },
  /*::[*/
  351: {
    /* n:"BrtListCCFmla" */
  },
  /*::[*/
  352: {
    /* n:"BrtListTrFmla" */
  },
  /*::[*/
  353: {
    /* n:"BrtBeginExternals", */
    T: 1
  },
  /*::[*/
  354: {
    /* n:"BrtEndExternals", */
    T: -1
  },
  /*::[*/
  355: {
    /* n:"BrtSupBookSrc", */
    f: vT
  },
  /*::[*/
  357: {
    /* n:"BrtSupSelf" */
  },
  /*::[*/
  358: {
    /* n:"BrtSupSame" */
  },
  /*::[*/
  359: {
    /* n:"BrtSupTabs" */
  },
  /*::[*/
  360: {
    /* n:"BrtBeginSupBook", */
    T: 1
  },
  /*::[*/
  361: {
    /* n:"BrtPlaceholderName" */
  },
  /*::[*/
  362: {
    /* n:"BrtExternSheet", */
    f: j7e
  },
  /*::[*/
  363: {
    /* n:"BrtExternTableStart" */
  },
  /*::[*/
  364: {
    /* n:"BrtExternTableEnd" */
  },
  /*::[*/
  366: {
    /* n:"BrtExternRowHdr" */
  },
  /*::[*/
  367: {
    /* n:"BrtExternCellBlank" */
  },
  /*::[*/
  368: {
    /* n:"BrtExternCellReal" */
  },
  /*::[*/
  369: {
    /* n:"BrtExternCellBool" */
  },
  /*::[*/
  370: {
    /* n:"BrtExternCellError" */
  },
  /*::[*/
  371: {
    /* n:"BrtExternCellString" */
  },
  /*::[*/
  372: {
    /* n:"BrtBeginEsmdx", */
    T: 1
  },
  /*::[*/
  373: {
    /* n:"BrtEndEsmdx", */
    T: -1
  },
  /*::[*/
  374: {
    /* n:"BrtBeginMdxSet", */
    T: 1
  },
  /*::[*/
  375: {
    /* n:"BrtEndMdxSet", */
    T: -1
  },
  /*::[*/
  376: {
    /* n:"BrtBeginMdxMbrProp", */
    T: 1
  },
  /*::[*/
  377: {
    /* n:"BrtEndMdxMbrProp", */
    T: -1
  },
  /*::[*/
  378: {
    /* n:"BrtBeginMdxKPI", */
    T: 1
  },
  /*::[*/
  379: {
    /* n:"BrtEndMdxKPI", */
    T: -1
  },
  /*::[*/
  380: {
    /* n:"BrtBeginEsstr", */
    T: 1
  },
  /*::[*/
  381: {
    /* n:"BrtEndEsstr", */
    T: -1
  },
  /*::[*/
  382: {
    /* n:"BrtBeginPRFItem", */
    T: 1
  },
  /*::[*/
  383: {
    /* n:"BrtEndPRFItem", */
    T: -1
  },
  /*::[*/
  384: {
    /* n:"BrtBeginPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  385: {
    /* n:"BrtEndPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  386: {
    /* n:"BrtBeginPivotCacheID", */
    T: 1
  },
  /*::[*/
  387: {
    /* n:"BrtEndPivotCacheID", */
    T: -1
  },
  /*::[*/
  388: {
    /* n:"BrtBeginISXVIs", */
    T: 1
  },
  /*::[*/
  389: {
    /* n:"BrtEndISXVIs", */
    T: -1
  },
  /*::[*/
  390: {
    /* n:"BrtBeginColInfos", */
    T: 1
  },
  /*::[*/
  391: {
    /* n:"BrtEndColInfos", */
    T: -1
  },
  /*::[*/
  392: {
    /* n:"BrtBeginRwBrk", */
    T: 1
  },
  /*::[*/
  393: {
    /* n:"BrtEndRwBrk", */
    T: -1
  },
  /*::[*/
  394: {
    /* n:"BrtBeginColBrk", */
    T: 1
  },
  /*::[*/
  395: {
    /* n:"BrtEndColBrk", */
    T: -1
  },
  /*::[*/
  396: {
    /* n:"BrtBrk" */
  },
  /*::[*/
  397: {
    /* n:"BrtUserBookView" */
  },
  /*::[*/
  398: {
    /* n:"BrtInfo" */
  },
  /*::[*/
  399: {
    /* n:"BrtCUsr" */
  },
  /*::[*/
  400: {
    /* n:"BrtUsr" */
  },
  /*::[*/
  401: {
    /* n:"BrtBeginUsers", */
    T: 1
  },
  /*::[*/
  403: {
    /* n:"BrtEOF" */
  },
  /*::[*/
  404: {
    /* n:"BrtUCR" */
  },
  /*::[*/
  405: {
    /* n:"BrtRRInsDel" */
  },
  /*::[*/
  406: {
    /* n:"BrtRREndInsDel" */
  },
  /*::[*/
  407: {
    /* n:"BrtRRMove" */
  },
  /*::[*/
  408: {
    /* n:"BrtRREndMove" */
  },
  /*::[*/
  409: {
    /* n:"BrtRRChgCell" */
  },
  /*::[*/
  410: {
    /* n:"BrtRREndChgCell" */
  },
  /*::[*/
  411: {
    /* n:"BrtRRHeader" */
  },
  /*::[*/
  412: {
    /* n:"BrtRRUserView" */
  },
  /*::[*/
  413: {
    /* n:"BrtRRRenSheet" */
  },
  /*::[*/
  414: {
    /* n:"BrtRRInsertSh" */
  },
  /*::[*/
  415: {
    /* n:"BrtRRDefName" */
  },
  /*::[*/
  416: {
    /* n:"BrtRRNote" */
  },
  /*::[*/
  417: {
    /* n:"BrtRRConflict" */
  },
  /*::[*/
  418: {
    /* n:"BrtRRTQSIF" */
  },
  /*::[*/
  419: {
    /* n:"BrtRRFormat" */
  },
  /*::[*/
  420: {
    /* n:"BrtRREndFormat" */
  },
  /*::[*/
  421: {
    /* n:"BrtRRAutoFmt" */
  },
  /*::[*/
  422: {
    /* n:"BrtBeginUserShViews", */
    T: 1
  },
  /*::[*/
  423: {
    /* n:"BrtBeginUserShView", */
    T: 1
  },
  /*::[*/
  424: {
    /* n:"BrtEndUserShView", */
    T: -1
  },
  /*::[*/
  425: {
    /* n:"BrtEndUserShViews", */
    T: -1
  },
  /*::[*/
  426: {
    /* n:"BrtArrFmla", */
    f: TKe
  },
  /*::[*/
  427: {
    /* n:"BrtShrFmla", */
    f: CKe
  },
  /*::[*/
  428: {
    /* n:"BrtTable" */
  },
  /*::[*/
  429: {
    /* n:"BrtBeginExtConnections", */
    T: 1
  },
  /*::[*/
  430: {
    /* n:"BrtEndExtConnections", */
    T: -1
  },
  /*::[*/
  431: {
    /* n:"BrtBeginPCDCalcMems", */
    T: 1
  },
  /*::[*/
  432: {
    /* n:"BrtEndPCDCalcMems", */
    T: -1
  },
  /*::[*/
  433: {
    /* n:"BrtBeginPCDCalcMem", */
    T: 1
  },
  /*::[*/
  434: {
    /* n:"BrtEndPCDCalcMem", */
    T: -1
  },
  /*::[*/
  435: {
    /* n:"BrtBeginPCDHGLevels", */
    T: 1
  },
  /*::[*/
  436: {
    /* n:"BrtEndPCDHGLevels", */
    T: -1
  },
  /*::[*/
  437: {
    /* n:"BrtBeginPCDHGLevel", */
    T: 1
  },
  /*::[*/
  438: {
    /* n:"BrtEndPCDHGLevel", */
    T: -1
  },
  /*::[*/
  439: {
    /* n:"BrtBeginPCDHGLGroups", */
    T: 1
  },
  /*::[*/
  440: {
    /* n:"BrtEndPCDHGLGroups", */
    T: -1
  },
  /*::[*/
  441: {
    /* n:"BrtBeginPCDHGLGroup", */
    T: 1
  },
  /*::[*/
  442: {
    /* n:"BrtEndPCDHGLGroup", */
    T: -1
  },
  /*::[*/
  443: {
    /* n:"BrtBeginPCDHGLGMembers", */
    T: 1
  },
  /*::[*/
  444: {
    /* n:"BrtEndPCDHGLGMembers", */
    T: -1
  },
  /*::[*/
  445: {
    /* n:"BrtBeginPCDHGLGMember", */
    T: 1
  },
  /*::[*/
  446: {
    /* n:"BrtEndPCDHGLGMember", */
    T: -1
  },
  /*::[*/
  447: {
    /* n:"BrtBeginQSI", */
    T: 1
  },
  /*::[*/
  448: {
    /* n:"BrtEndQSI", */
    T: -1
  },
  /*::[*/
  449: {
    /* n:"BrtBeginQSIR", */
    T: 1
  },
  /*::[*/
  450: {
    /* n:"BrtEndQSIR", */
    T: -1
  },
  /*::[*/
  451: {
    /* n:"BrtBeginDeletedNames", */
    T: 1
  },
  /*::[*/
  452: {
    /* n:"BrtEndDeletedNames", */
    T: -1
  },
  /*::[*/
  453: {
    /* n:"BrtBeginDeletedName", */
    T: 1
  },
  /*::[*/
  454: {
    /* n:"BrtEndDeletedName", */
    T: -1
  },
  /*::[*/
  455: {
    /* n:"BrtBeginQSIFs", */
    T: 1
  },
  /*::[*/
  456: {
    /* n:"BrtEndQSIFs", */
    T: -1
  },
  /*::[*/
  457: {
    /* n:"BrtBeginQSIF", */
    T: 1
  },
  /*::[*/
  458: {
    /* n:"BrtEndQSIF", */
    T: -1
  },
  /*::[*/
  459: {
    /* n:"BrtBeginAutoSortScope", */
    T: 1
  },
  /*::[*/
  460: {
    /* n:"BrtEndAutoSortScope", */
    T: -1
  },
  /*::[*/
  461: {
    /* n:"BrtBeginConditionalFormatting", */
    T: 1
  },
  /*::[*/
  462: {
    /* n:"BrtEndConditionalFormatting", */
    T: -1
  },
  /*::[*/
  463: {
    /* n:"BrtBeginCFRule", */
    T: 1
  },
  /*::[*/
  464: {
    /* n:"BrtEndCFRule", */
    T: -1
  },
  /*::[*/
  465: {
    /* n:"BrtBeginIconSet", */
    T: 1
  },
  /*::[*/
  466: {
    /* n:"BrtEndIconSet", */
    T: -1
  },
  /*::[*/
  467: {
    /* n:"BrtBeginDatabar", */
    T: 1
  },
  /*::[*/
  468: {
    /* n:"BrtEndDatabar", */
    T: -1
  },
  /*::[*/
  469: {
    /* n:"BrtBeginColorScale", */
    T: 1
  },
  /*::[*/
  470: {
    /* n:"BrtEndColorScale", */
    T: -1
  },
  /*::[*/
  471: {
    /* n:"BrtCFVO" */
  },
  /*::[*/
  472: {
    /* n:"BrtExternValueMeta" */
  },
  /*::[*/
  473: {
    /* n:"BrtBeginColorPalette", */
    T: 1
  },
  /*::[*/
  474: {
    /* n:"BrtEndColorPalette", */
    T: -1
  },
  /*::[*/
  475: {
    /* n:"BrtIndexedColor" */
  },
  /*::[*/
  476: {
    /* n:"BrtMargins", */
    f: OKe
  },
  /*::[*/
  477: {
    /* n:"BrtPrintOptions" */
  },
  /*::[*/
  478: {
    /* n:"BrtPageSetup" */
  },
  /*::[*/
  479: {
    /* n:"BrtBeginHeaderFooter", */
    T: 1
  },
  /*::[*/
  480: {
    /* n:"BrtEndHeaderFooter", */
    T: -1
  },
  /*::[*/
  481: {
    /* n:"BrtBeginSXCrtFormat", */
    T: 1
  },
  /*::[*/
  482: {
    /* n:"BrtEndSXCrtFormat", */
    T: -1
  },
  /*::[*/
  483: {
    /* n:"BrtBeginSXCrtFormats", */
    T: 1
  },
  /*::[*/
  484: {
    /* n:"BrtEndSXCrtFormats", */
    T: -1
  },
  /*::[*/
  485: {
    /* n:"BrtWsFmtInfo", */
    f: jze
  },
  /*::[*/
  486: {
    /* n:"BrtBeginMgs", */
    T: 1
  },
  /*::[*/
  487: {
    /* n:"BrtEndMGs", */
    T: -1
  },
  /*::[*/
  488: {
    /* n:"BrtBeginMGMaps", */
    T: 1
  },
  /*::[*/
  489: {
    /* n:"BrtEndMGMaps", */
    T: -1
  },
  /*::[*/
  490: {
    /* n:"BrtBeginMG", */
    T: 1
  },
  /*::[*/
  491: {
    /* n:"BrtEndMG", */
    T: -1
  },
  /*::[*/
  492: {
    /* n:"BrtBeginMap", */
    T: 1
  },
  /*::[*/
  493: {
    /* n:"BrtEndMap", */
    T: -1
  },
  /*::[*/
  494: {
    /* n:"BrtHLink", */
    f: _Ke
  },
  /*::[*/
  495: {
    /* n:"BrtBeginDCon", */
    T: 1
  },
  /*::[*/
  496: {
    /* n:"BrtEndDCon", */
    T: -1
  },
  /*::[*/
  497: {
    /* n:"BrtBeginDRefs", */
    T: 1
  },
  /*::[*/
  498: {
    /* n:"BrtEndDRefs", */
    T: -1
  },
  /*::[*/
  499: {
    /* n:"BrtDRef" */
  },
  /*::[*/
  500: {
    /* n:"BrtBeginScenMan", */
    T: 1
  },
  /*::[*/
  501: {
    /* n:"BrtEndScenMan", */
    T: -1
  },
  /*::[*/
  502: {
    /* n:"BrtBeginSct", */
    T: 1
  },
  /*::[*/
  503: {
    /* n:"BrtEndSct", */
    T: -1
  },
  /*::[*/
  504: {
    /* n:"BrtSlc" */
  },
  /*::[*/
  505: {
    /* n:"BrtBeginDXFs", */
    T: 1
  },
  /*::[*/
  506: {
    /* n:"BrtEndDXFs", */
    T: -1
  },
  /*::[*/
  507: {
    /* n:"BrtDXF" */
  },
  /*::[*/
  508: {
    /* n:"BrtBeginTableStyles", */
    T: 1
  },
  /*::[*/
  509: {
    /* n:"BrtEndTableStyles", */
    T: -1
  },
  /*::[*/
  510: {
    /* n:"BrtBeginTableStyle", */
    T: 1
  },
  /*::[*/
  511: {
    /* n:"BrtEndTableStyle", */
    T: -1
  },
  /*::[*/
  512: {
    /* n:"BrtTableStyleElement" */
  },
  /*::[*/
  513: {
    /* n:"BrtTableStyleClient" */
  },
  /*::[*/
  514: {
    /* n:"BrtBeginVolDeps", */
    T: 1
  },
  /*::[*/
  515: {
    /* n:"BrtEndVolDeps", */
    T: -1
  },
  /*::[*/
  516: {
    /* n:"BrtBeginVolType", */
    T: 1
  },
  /*::[*/
  517: {
    /* n:"BrtEndVolType", */
    T: -1
  },
  /*::[*/
  518: {
    /* n:"BrtBeginVolMain", */
    T: 1
  },
  /*::[*/
  519: {
    /* n:"BrtEndVolMain", */
    T: -1
  },
  /*::[*/
  520: {
    /* n:"BrtBeginVolTopic", */
    T: 1
  },
  /*::[*/
  521: {
    /* n:"BrtEndVolTopic", */
    T: -1
  },
  /*::[*/
  522: {
    /* n:"BrtVolSubtopic" */
  },
  /*::[*/
  523: {
    /* n:"BrtVolRef" */
  },
  /*::[*/
  524: {
    /* n:"BrtVolNum" */
  },
  /*::[*/
  525: {
    /* n:"BrtVolErr" */
  },
  /*::[*/
  526: {
    /* n:"BrtVolStr" */
  },
  /*::[*/
  527: {
    /* n:"BrtVolBool" */
  },
  /*::[*/
  528: {
    /* n:"BrtBeginCalcChain$", */
    T: 1
  },
  /*::[*/
  529: {
    /* n:"BrtEndCalcChain$", */
    T: -1
  },
  /*::[*/
  530: {
    /* n:"BrtBeginSortState", */
    T: 1
  },
  /*::[*/
  531: {
    /* n:"BrtEndSortState", */
    T: -1
  },
  /*::[*/
  532: {
    /* n:"BrtBeginSortCond", */
    T: 1
  },
  /*::[*/
  533: {
    /* n:"BrtEndSortCond", */
    T: -1
  },
  /*::[*/
  534: {
    /* n:"BrtBookProtection" */
  },
  /*::[*/
  535: {
    /* n:"BrtSheetProtection" */
  },
  /*::[*/
  536: {
    /* n:"BrtRangeProtection" */
  },
  /*::[*/
  537: {
    /* n:"BrtPhoneticInfo" */
  },
  /*::[*/
  538: {
    /* n:"BrtBeginECTxtWiz", */
    T: 1
  },
  /*::[*/
  539: {
    /* n:"BrtEndECTxtWiz", */
    T: -1
  },
  /*::[*/
  540: {
    /* n:"BrtBeginECTWFldInfoLst", */
    T: 1
  },
  /*::[*/
  541: {
    /* n:"BrtEndECTWFldInfoLst", */
    T: -1
  },
  /*::[*/
  542: {
    /* n:"BrtBeginECTwFldInfo", */
    T: 1
  },
  /*::[*/
  548: {
    /* n:"BrtFileSharing" */
  },
  /*::[*/
  549: {
    /* n:"BrtOleSize" */
  },
  /*::[*/
  550: {
    /* n:"BrtDrawing", */
    f: vT
  },
  /*::[*/
  551: {
    /* n:"BrtLegacyDrawing" */
  },
  /*::[*/
  552: {
    /* n:"BrtLegacyDrawingHF" */
  },
  /*::[*/
  553: {
    /* n:"BrtWebOpt" */
  },
  /*::[*/
  554: {
    /* n:"BrtBeginWebPubItems", */
    T: 1
  },
  /*::[*/
  555: {
    /* n:"BrtEndWebPubItems", */
    T: -1
  },
  /*::[*/
  556: {
    /* n:"BrtBeginWebPubItem", */
    T: 1
  },
  /*::[*/
  557: {
    /* n:"BrtEndWebPubItem", */
    T: -1
  },
  /*::[*/
  558: {
    /* n:"BrtBeginSXCondFmt", */
    T: 1
  },
  /*::[*/
  559: {
    /* n:"BrtEndSXCondFmt", */
    T: -1
  },
  /*::[*/
  560: {
    /* n:"BrtBeginSXCondFmts", */
    T: 1
  },
  /*::[*/
  561: {
    /* n:"BrtEndSXCondFmts", */
    T: -1
  },
  /*::[*/
  562: {
    /* n:"BrtBkHim" */
  },
  /*::[*/
  564: {
    /* n:"BrtColor" */
  },
  /*::[*/
  565: {
    /* n:"BrtBeginIndexedColors", */
    T: 1
  },
  /*::[*/
  566: {
    /* n:"BrtEndIndexedColors", */
    T: -1
  },
  /*::[*/
  569: {
    /* n:"BrtBeginMRUColors", */
    T: 1
  },
  /*::[*/
  570: {
    /* n:"BrtEndMRUColors", */
    T: -1
  },
  /*::[*/
  572: {
    /* n:"BrtMRUColor" */
  },
  /*::[*/
  573: {
    /* n:"BrtBeginDVals", */
    T: 1
  },
  /*::[*/
  574: {
    /* n:"BrtEndDVals", */
    T: -1
  },
  /*::[*/
  577: {
    /* n:"BrtSupNameStart" */
  },
  /*::[*/
  578: {
    /* n:"BrtSupNameValueStart" */
  },
  /*::[*/
  579: {
    /* n:"BrtSupNameValueEnd" */
  },
  /*::[*/
  580: {
    /* n:"BrtSupNameNum" */
  },
  /*::[*/
  581: {
    /* n:"BrtSupNameErr" */
  },
  /*::[*/
  582: {
    /* n:"BrtSupNameSt" */
  },
  /*::[*/
  583: {
    /* n:"BrtSupNameNil" */
  },
  /*::[*/
  584: {
    /* n:"BrtSupNameBool" */
  },
  /*::[*/
  585: {
    /* n:"BrtSupNameFmla" */
  },
  /*::[*/
  586: {
    /* n:"BrtSupNameBits" */
  },
  /*::[*/
  587: {
    /* n:"BrtSupNameEnd" */
  },
  /*::[*/
  588: {
    /* n:"BrtEndSupBook", */
    T: -1
  },
  /*::[*/
  589: {
    /* n:"BrtCellSmartTagProperty" */
  },
  /*::[*/
  590: {
    /* n:"BrtBeginCellSmartTag", */
    T: 1
  },
  /*::[*/
  591: {
    /* n:"BrtEndCellSmartTag", */
    T: -1
  },
  /*::[*/
  592: {
    /* n:"BrtBeginCellSmartTags", */
    T: 1
  },
  /*::[*/
  593: {
    /* n:"BrtEndCellSmartTags", */
    T: -1
  },
  /*::[*/
  594: {
    /* n:"BrtBeginSmartTags", */
    T: 1
  },
  /*::[*/
  595: {
    /* n:"BrtEndSmartTags", */
    T: -1
  },
  /*::[*/
  596: {
    /* n:"BrtSmartTagType" */
  },
  /*::[*/
  597: {
    /* n:"BrtBeginSmartTagTypes", */
    T: 1
  },
  /*::[*/
  598: {
    /* n:"BrtEndSmartTagTypes", */
    T: -1
  },
  /*::[*/
  599: {
    /* n:"BrtBeginSXFilters", */
    T: 1
  },
  /*::[*/
  600: {
    /* n:"BrtEndSXFilters", */
    T: -1
  },
  /*::[*/
  601: {
    /* n:"BrtBeginSXFILTER", */
    T: 1
  },
  /*::[*/
  602: {
    /* n:"BrtEndSXFilter", */
    T: -1
  },
  /*::[*/
  603: {
    /* n:"BrtBeginFills", */
    T: 1
  },
  /*::[*/
  604: {
    /* n:"BrtEndFills", */
    T: -1
  },
  /*::[*/
  605: {
    /* n:"BrtBeginCellWatches", */
    T: 1
  },
  /*::[*/
  606: {
    /* n:"BrtEndCellWatches", */
    T: -1
  },
  /*::[*/
  607: {
    /* n:"BrtCellWatch" */
  },
  /*::[*/
  608: {
    /* n:"BrtBeginCRErrs", */
    T: 1
  },
  /*::[*/
  609: {
    /* n:"BrtEndCRErrs", */
    T: -1
  },
  /*::[*/
  610: {
    /* n:"BrtCrashRecErr" */
  },
  /*::[*/
  611: {
    /* n:"BrtBeginFonts", */
    T: 1
  },
  /*::[*/
  612: {
    /* n:"BrtEndFonts", */
    T: -1
  },
  /*::[*/
  613: {
    /* n:"BrtBeginBorders", */
    T: 1
  },
  /*::[*/
  614: {
    /* n:"BrtEndBorders", */
    T: -1
  },
  /*::[*/
  615: {
    /* n:"BrtBeginFmts", */
    T: 1
  },
  /*::[*/
  616: {
    /* n:"BrtEndFmts", */
    T: -1
  },
  /*::[*/
  617: {
    /* n:"BrtBeginCellXFs", */
    T: 1
  },
  /*::[*/
  618: {
    /* n:"BrtEndCellXFs", */
    T: -1
  },
  /*::[*/
  619: {
    /* n:"BrtBeginStyles", */
    T: 1
  },
  /*::[*/
  620: {
    /* n:"BrtEndStyles", */
    T: -1
  },
  /*::[*/
  625: {
    /* n:"BrtBigName" */
  },
  /*::[*/
  626: {
    /* n:"BrtBeginCellStyleXFs", */
    T: 1
  },
  /*::[*/
  627: {
    /* n:"BrtEndCellStyleXFs", */
    T: -1
  },
  /*::[*/
  628: {
    /* n:"BrtBeginComments", */
    T: 1
  },
  /*::[*/
  629: {
    /* n:"BrtEndComments", */
    T: -1
  },
  /*::[*/
  630: {
    /* n:"BrtBeginCommentAuthors", */
    T: 1
  },
  /*::[*/
  631: {
    /* n:"BrtEndCommentAuthors", */
    T: -1
  },
  /*::[*/
  632: {
    /* n:"BrtCommentAuthor", */
    f: H9e
  },
  /*::[*/
  633: {
    /* n:"BrtBeginCommentList", */
    T: 1
  },
  /*::[*/
  634: {
    /* n:"BrtEndCommentList", */
    T: -1
  },
  /*::[*/
  635: {
    /* n:"BrtBeginComment", */
    T: 1,
    f: V9e
  },
  /*::[*/
  636: {
    /* n:"BrtEndComment", */
    T: -1
  },
  /*::[*/
  637: {
    /* n:"BrtCommentText", */
    f: KHe
  },
  /*::[*/
  638: {
    /* n:"BrtBeginOleObjects", */
    T: 1
  },
  /*::[*/
  639: {
    /* n:"BrtOleObject" */
  },
  /*::[*/
  640: {
    /* n:"BrtEndOleObjects", */
    T: -1
  },
  /*::[*/
  641: {
    /* n:"BrtBeginSxrules", */
    T: 1
  },
  /*::[*/
  642: {
    /* n:"BrtEndSxRules", */
    T: -1
  },
  /*::[*/
  643: {
    /* n:"BrtBeginActiveXControls", */
    T: 1
  },
  /*::[*/
  644: {
    /* n:"BrtActiveX" */
  },
  /*::[*/
  645: {
    /* n:"BrtEndActiveXControls", */
    T: -1
  },
  /*::[*/
  646: {
    /* n:"BrtBeginPCDSDTCEMembersSortBy", */
    T: 1
  },
  /*::[*/
  648: {
    /* n:"BrtBeginCellIgnoreECs", */
    T: 1
  },
  /*::[*/
  649: {
    /* n:"BrtCellIgnoreEC" */
  },
  /*::[*/
  650: {
    /* n:"BrtEndCellIgnoreECs", */
    T: -1
  },
  /*::[*/
  651: {
    /* n:"BrtCsProp", */
    f: qKe
  },
  /*::[*/
  652: {
    /* n:"BrtCsPageSetup" */
  },
  /*::[*/
  653: {
    /* n:"BrtBeginUserCsViews", */
    T: 1
  },
  /*::[*/
  654: {
    /* n:"BrtEndUserCsViews", */
    T: -1
  },
  /*::[*/
  655: {
    /* n:"BrtBeginUserCsView", */
    T: 1
  },
  /*::[*/
  656: {
    /* n:"BrtEndUserCsView", */
    T: -1
  },
  /*::[*/
  657: {
    /* n:"BrtBeginPcdSFCIEntries", */
    T: 1
  },
  /*::[*/
  658: {
    /* n:"BrtEndPCDSFCIEntries", */
    T: -1
  },
  /*::[*/
  659: {
    /* n:"BrtPCDSFCIEntry" */
  },
  /*::[*/
  660: {
    /* n:"BrtBeginListParts", */
    T: 1
  },
  /*::[*/
  661: {
    /* n:"BrtListPart" */
  },
  /*::[*/
  662: {
    /* n:"BrtEndListParts", */
    T: -1
  },
  /*::[*/
  663: {
    /* n:"BrtSheetCalcProp" */
  },
  /*::[*/
  664: {
    /* n:"BrtBeginFnGroup", */
    T: 1
  },
  /*::[*/
  665: {
    /* n:"BrtFnGroup" */
  },
  /*::[*/
  666: {
    /* n:"BrtEndFnGroup", */
    T: -1
  },
  /*::[*/
  667: {
    /* n:"BrtSupAddin" */
  },
  /*::[*/
  668: {
    /* n:"BrtSXTDMPOrder" */
  },
  /*::[*/
  669: {
    /* n:"BrtCsProtection" */
  },
  /*::[*/
  671: {
    /* n:"BrtBeginWsSortMap", */
    T: 1
  },
  /*::[*/
  672: {
    /* n:"BrtEndWsSortMap", */
    T: -1
  },
  /*::[*/
  673: {
    /* n:"BrtBeginRRSort", */
    T: 1
  },
  /*::[*/
  674: {
    /* n:"BrtEndRRSort", */
    T: -1
  },
  /*::[*/
  675: {
    /* n:"BrtRRSortItem" */
  },
  /*::[*/
  676: {
    /* n:"BrtFileSharingIso" */
  },
  /*::[*/
  677: {
    /* n:"BrtBookProtectionIso" */
  },
  /*::[*/
  678: {
    /* n:"BrtSheetProtectionIso" */
  },
  /*::[*/
  679: {
    /* n:"BrtCsProtectionIso" */
  },
  /*::[*/
  680: {
    /* n:"BrtRangeProtectionIso" */
  },
  /*::[*/
  681: {
    /* n:"BrtDValList" */
  },
  /*::[*/
  1024: {
    /* n:"BrtRwDescent" */
  },
  /*::[*/
  1025: {
    /* n:"BrtKnownFonts" */
  },
  /*::[*/
  1026: {
    /* n:"BrtBeginSXTupleSet", */
    T: 1
  },
  /*::[*/
  1027: {
    /* n:"BrtEndSXTupleSet", */
    T: -1
  },
  /*::[*/
  1028: {
    /* n:"BrtBeginSXTupleSetHeader", */
    T: 1
  },
  /*::[*/
  1029: {
    /* n:"BrtEndSXTupleSetHeader", */
    T: -1
  },
  /*::[*/
  1030: {
    /* n:"BrtSXTupleSetHeaderItem" */
  },
  /*::[*/
  1031: {
    /* n:"BrtBeginSXTupleSetData", */
    T: 1
  },
  /*::[*/
  1032: {
    /* n:"BrtEndSXTupleSetData", */
    T: -1
  },
  /*::[*/
  1033: {
    /* n:"BrtBeginSXTupleSetRow", */
    T: 1
  },
  /*::[*/
  1034: {
    /* n:"BrtEndSXTupleSetRow", */
    T: -1
  },
  /*::[*/
  1035: {
    /* n:"BrtSXTupleSetRowItem" */
  },
  /*::[*/
  1036: {
    /* n:"BrtNameExt" */
  },
  /*::[*/
  1037: {
    /* n:"BrtPCDH14" */
  },
  /*::[*/
  1038: {
    /* n:"BrtBeginPCDCalcMem14", */
    T: 1
  },
  /*::[*/
  1039: {
    /* n:"BrtEndPCDCalcMem14", */
    T: -1
  },
  /*::[*/
  1040: {
    /* n:"BrtSXTH14" */
  },
  /*::[*/
  1041: {
    /* n:"BrtBeginSparklineGroup", */
    T: 1
  },
  /*::[*/
  1042: {
    /* n:"BrtEndSparklineGroup", */
    T: -1
  },
  /*::[*/
  1043: {
    /* n:"BrtSparkline" */
  },
  /*::[*/
  1044: {
    /* n:"BrtSXDI14" */
  },
  /*::[*/
  1045: {
    /* n:"BrtWsFmtInfoEx14" */
  },
  /*::[*/
  1046: {
    /* n:"BrtBeginConditionalFormatting14", */
    T: 1
  },
  /*::[*/
  1047: {
    /* n:"BrtEndConditionalFormatting14", */
    T: -1
  },
  /*::[*/
  1048: {
    /* n:"BrtBeginCFRule14", */
    T: 1
  },
  /*::[*/
  1049: {
    /* n:"BrtEndCFRule14", */
    T: -1
  },
  /*::[*/
  1050: {
    /* n:"BrtCFVO14" */
  },
  /*::[*/
  1051: {
    /* n:"BrtBeginDatabar14", */
    T: 1
  },
  /*::[*/
  1052: {
    /* n:"BrtBeginIconSet14", */
    T: 1
  },
  /*::[*/
  1053: {
    /* n:"BrtDVal14", */
    f: MKe
  },
  /*::[*/
  1054: {
    /* n:"BrtBeginDVals14", */
    T: 1
  },
  /*::[*/
  1055: {
    /* n:"BrtColor14" */
  },
  /*::[*/
  1056: {
    /* n:"BrtBeginSparklines", */
    T: 1
  },
  /*::[*/
  1057: {
    /* n:"BrtEndSparklines", */
    T: -1
  },
  /*::[*/
  1058: {
    /* n:"BrtBeginSparklineGroups", */
    T: 1
  },
  /*::[*/
  1059: {
    /* n:"BrtEndSparklineGroups", */
    T: -1
  },
  /*::[*/
  1061: {
    /* n:"BrtSXVD14" */
  },
  /*::[*/
  1062: {
    /* n:"BrtBeginSXView14", */
    T: 1
  },
  /*::[*/
  1063: {
    /* n:"BrtEndSXView14", */
    T: -1
  },
  /*::[*/
  1064: {
    /* n:"BrtBeginSXView16", */
    T: 1
  },
  /*::[*/
  1065: {
    /* n:"BrtEndSXView16", */
    T: -1
  },
  /*::[*/
  1066: {
    /* n:"BrtBeginPCD14", */
    T: 1
  },
  /*::[*/
  1067: {
    /* n:"BrtEndPCD14", */
    T: -1
  },
  /*::[*/
  1068: {
    /* n:"BrtBeginExtConn14", */
    T: 1
  },
  /*::[*/
  1069: {
    /* n:"BrtEndExtConn14", */
    T: -1
  },
  /*::[*/
  1070: {
    /* n:"BrtBeginSlicerCacheIDs", */
    T: 1
  },
  /*::[*/
  1071: {
    /* n:"BrtEndSlicerCacheIDs", */
    T: -1
  },
  /*::[*/
  1072: {
    /* n:"BrtBeginSlicerCacheID", */
    T: 1
  },
  /*::[*/
  1073: {
    /* n:"BrtEndSlicerCacheID", */
    T: -1
  },
  /*::[*/
  1075: {
    /* n:"BrtBeginSlicerCache", */
    T: 1
  },
  /*::[*/
  1076: {
    /* n:"BrtEndSlicerCache", */
    T: -1
  },
  /*::[*/
  1077: {
    /* n:"BrtBeginSlicerCacheDef", */
    T: 1
  },
  /*::[*/
  1078: {
    /* n:"BrtEndSlicerCacheDef", */
    T: -1
  },
  /*::[*/
  1079: {
    /* n:"BrtBeginSlicersEx", */
    T: 1
  },
  /*::[*/
  1080: {
    /* n:"BrtEndSlicersEx", */
    T: -1
  },
  /*::[*/
  1081: {
    /* n:"BrtBeginSlicerEx", */
    T: 1
  },
  /*::[*/
  1082: {
    /* n:"BrtEndSlicerEx", */
    T: -1
  },
  /*::[*/
  1083: {
    /* n:"BrtBeginSlicer", */
    T: 1
  },
  /*::[*/
  1084: {
    /* n:"BrtEndSlicer", */
    T: -1
  },
  /*::[*/
  1085: {
    /* n:"BrtSlicerCachePivotTables" */
  },
  /*::[*/
  1086: {
    /* n:"BrtBeginSlicerCacheOlapImpl", */
    T: 1
  },
  /*::[*/
  1087: {
    /* n:"BrtEndSlicerCacheOlapImpl", */
    T: -1
  },
  /*::[*/
  1088: {
    /* n:"BrtBeginSlicerCacheLevelsData", */
    T: 1
  },
  /*::[*/
  1089: {
    /* n:"BrtEndSlicerCacheLevelsData", */
    T: -1
  },
  /*::[*/
  1090: {
    /* n:"BrtBeginSlicerCacheLevelData", */
    T: 1
  },
  /*::[*/
  1091: {
    /* n:"BrtEndSlicerCacheLevelData", */
    T: -1
  },
  /*::[*/
  1092: {
    /* n:"BrtBeginSlicerCacheSiRanges", */
    T: 1
  },
  /*::[*/
  1093: {
    /* n:"BrtEndSlicerCacheSiRanges", */
    T: -1
  },
  /*::[*/
  1094: {
    /* n:"BrtBeginSlicerCacheSiRange", */
    T: 1
  },
  /*::[*/
  1095: {
    /* n:"BrtEndSlicerCacheSiRange", */
    T: -1
  },
  /*::[*/
  1096: {
    /* n:"BrtSlicerCacheOlapItem" */
  },
  /*::[*/
  1097: {
    /* n:"BrtBeginSlicerCacheSelections", */
    T: 1
  },
  /*::[*/
  1098: {
    /* n:"BrtSlicerCacheSelection" */
  },
  /*::[*/
  1099: {
    /* n:"BrtEndSlicerCacheSelections", */
    T: -1
  },
  /*::[*/
  1100: {
    /* n:"BrtBeginSlicerCacheNative", */
    T: 1
  },
  /*::[*/
  1101: {
    /* n:"BrtEndSlicerCacheNative", */
    T: -1
  },
  /*::[*/
  1102: {
    /* n:"BrtSlicerCacheNativeItem" */
  },
  /*::[*/
  1103: {
    /* n:"BrtRangeProtection14" */
  },
  /*::[*/
  1104: {
    /* n:"BrtRangeProtectionIso14" */
  },
  /*::[*/
  1105: {
    /* n:"BrtCellIgnoreEC14" */
  },
  /*::[*/
  1111: {
    /* n:"BrtList14" */
  },
  /*::[*/
  1112: {
    /* n:"BrtCFIcon" */
  },
  /*::[*/
  1113: {
    /* n:"BrtBeginSlicerCachesPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  1114: {
    /* n:"BrtEndSlicerCachesPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  1115: {
    /* n:"BrtBeginSlicers", */
    T: 1
  },
  /*::[*/
  1116: {
    /* n:"BrtEndSlicers", */
    T: -1
  },
  /*::[*/
  1117: {
    /* n:"BrtWbProp14" */
  },
  /*::[*/
  1118: {
    /* n:"BrtBeginSXEdit", */
    T: 1
  },
  /*::[*/
  1119: {
    /* n:"BrtEndSXEdit", */
    T: -1
  },
  /*::[*/
  1120: {
    /* n:"BrtBeginSXEdits", */
    T: 1
  },
  /*::[*/
  1121: {
    /* n:"BrtEndSXEdits", */
    T: -1
  },
  /*::[*/
  1122: {
    /* n:"BrtBeginSXChange", */
    T: 1
  },
  /*::[*/
  1123: {
    /* n:"BrtEndSXChange", */
    T: -1
  },
  /*::[*/
  1124: {
    /* n:"BrtBeginSXChanges", */
    T: 1
  },
  /*::[*/
  1125: {
    /* n:"BrtEndSXChanges", */
    T: -1
  },
  /*::[*/
  1126: {
    /* n:"BrtSXTupleItems" */
  },
  /*::[*/
  1128: {
    /* n:"BrtBeginSlicerStyle", */
    T: 1
  },
  /*::[*/
  1129: {
    /* n:"BrtEndSlicerStyle", */
    T: -1
  },
  /*::[*/
  1130: {
    /* n:"BrtSlicerStyleElement" */
  },
  /*::[*/
  1131: {
    /* n:"BrtBeginStyleSheetExt14", */
    T: 1
  },
  /*::[*/
  1132: {
    /* n:"BrtEndStyleSheetExt14", */
    T: -1
  },
  /*::[*/
  1133: {
    /* n:"BrtBeginSlicerCachesPivotCacheID", */
    T: 1
  },
  /*::[*/
  1134: {
    /* n:"BrtEndSlicerCachesPivotCacheID", */
    T: -1
  },
  /*::[*/
  1135: {
    /* n:"BrtBeginConditionalFormattings", */
    T: 1
  },
  /*::[*/
  1136: {
    /* n:"BrtEndConditionalFormattings", */
    T: -1
  },
  /*::[*/
  1137: {
    /* n:"BrtBeginPCDCalcMemExt", */
    T: 1
  },
  /*::[*/
  1138: {
    /* n:"BrtEndPCDCalcMemExt", */
    T: -1
  },
  /*::[*/
  1139: {
    /* n:"BrtBeginPCDCalcMemsExt", */
    T: 1
  },
  /*::[*/
  1140: {
    /* n:"BrtEndPCDCalcMemsExt", */
    T: -1
  },
  /*::[*/
  1141: {
    /* n:"BrtPCDField14" */
  },
  /*::[*/
  1142: {
    /* n:"BrtBeginSlicerStyles", */
    T: 1
  },
  /*::[*/
  1143: {
    /* n:"BrtEndSlicerStyles", */
    T: -1
  },
  /*::[*/
  1144: {
    /* n:"BrtBeginSlicerStyleElements", */
    T: 1
  },
  /*::[*/
  1145: {
    /* n:"BrtEndSlicerStyleElements", */
    T: -1
  },
  /*::[*/
  1146: {
    /* n:"BrtCFRuleExt" */
  },
  /*::[*/
  1147: {
    /* n:"BrtBeginSXCondFmt14", */
    T: 1
  },
  /*::[*/
  1148: {
    /* n:"BrtEndSXCondFmt14", */
    T: -1
  },
  /*::[*/
  1149: {
    /* n:"BrtBeginSXCondFmts14", */
    T: 1
  },
  /*::[*/
  1150: {
    /* n:"BrtEndSXCondFmts14", */
    T: -1
  },
  /*::[*/
  1152: {
    /* n:"BrtBeginSortCond14", */
    T: 1
  },
  /*::[*/
  1153: {
    /* n:"BrtEndSortCond14", */
    T: -1
  },
  /*::[*/
  1154: {
    /* n:"BrtEndDVals14", */
    T: -1
  },
  /*::[*/
  1155: {
    /* n:"BrtEndIconSet14", */
    T: -1
  },
  /*::[*/
  1156: {
    /* n:"BrtEndDatabar14", */
    T: -1
  },
  /*::[*/
  1157: {
    /* n:"BrtBeginColorScale14", */
    T: 1
  },
  /*::[*/
  1158: {
    /* n:"BrtEndColorScale14", */
    T: -1
  },
  /*::[*/
  1159: {
    /* n:"BrtBeginSxrules14", */
    T: 1
  },
  /*::[*/
  1160: {
    /* n:"BrtEndSxrules14", */
    T: -1
  },
  /*::[*/
  1161: {
    /* n:"BrtBeginPRule14", */
    T: 1
  },
  /*::[*/
  1162: {
    /* n:"BrtEndPRule14", */
    T: -1
  },
  /*::[*/
  1163: {
    /* n:"BrtBeginPRFilters14", */
    T: 1
  },
  /*::[*/
  1164: {
    /* n:"BrtEndPRFilters14", */
    T: -1
  },
  /*::[*/
  1165: {
    /* n:"BrtBeginPRFilter14", */
    T: 1
  },
  /*::[*/
  1166: {
    /* n:"BrtEndPRFilter14", */
    T: -1
  },
  /*::[*/
  1167: {
    /* n:"BrtBeginPRFItem14", */
    T: 1
  },
  /*::[*/
  1168: {
    /* n:"BrtEndPRFItem14", */
    T: -1
  },
  /*::[*/
  1169: {
    /* n:"BrtBeginCellIgnoreECs14", */
    T: 1
  },
  /*::[*/
  1170: {
    /* n:"BrtEndCellIgnoreECs14", */
    T: -1
  },
  /*::[*/
  1171: {
    /* n:"BrtDxf14" */
  },
  /*::[*/
  1172: {
    /* n:"BrtBeginDxF14s", */
    T: 1
  },
  /*::[*/
  1173: {
    /* n:"BrtEndDxf14s", */
    T: -1
  },
  /*::[*/
  1177: {
    /* n:"BrtFilter14" */
  },
  /*::[*/
  1178: {
    /* n:"BrtBeginCustomFilters14", */
    T: 1
  },
  /*::[*/
  1180: {
    /* n:"BrtCustomFilter14" */
  },
  /*::[*/
  1181: {
    /* n:"BrtIconFilter14" */
  },
  /*::[*/
  1182: {
    /* n:"BrtPivotCacheConnectionName" */
  },
  /*::[*/
  2048: {
    /* n:"BrtBeginDecoupledPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2049: {
    /* n:"BrtEndDecoupledPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2050: {
    /* n:"BrtDecoupledPivotCacheID" */
  },
  /*::[*/
  2051: {
    /* n:"BrtBeginPivotTableRefs", */
    T: 1
  },
  /*::[*/
  2052: {
    /* n:"BrtEndPivotTableRefs", */
    T: -1
  },
  /*::[*/
  2053: {
    /* n:"BrtPivotTableRef" */
  },
  /*::[*/
  2054: {
    /* n:"BrtSlicerCacheBookPivotTables" */
  },
  /*::[*/
  2055: {
    /* n:"BrtBeginSxvcells", */
    T: 1
  },
  /*::[*/
  2056: {
    /* n:"BrtEndSxvcells", */
    T: -1
  },
  /*::[*/
  2057: {
    /* n:"BrtBeginSxRow", */
    T: 1
  },
  /*::[*/
  2058: {
    /* n:"BrtEndSxRow", */
    T: -1
  },
  /*::[*/
  2060: {
    /* n:"BrtPcdCalcMem15" */
  },
  /*::[*/
  2067: {
    /* n:"BrtQsi15" */
  },
  /*::[*/
  2068: {
    /* n:"BrtBeginWebExtensions", */
    T: 1
  },
  /*::[*/
  2069: {
    /* n:"BrtEndWebExtensions", */
    T: -1
  },
  /*::[*/
  2070: {
    /* n:"BrtWebExtension" */
  },
  /*::[*/
  2071: {
    /* n:"BrtAbsPath15" */
  },
  /*::[*/
  2072: {
    /* n:"BrtBeginPivotTableUISettings", */
    T: 1
  },
  /*::[*/
  2073: {
    /* n:"BrtEndPivotTableUISettings", */
    T: -1
  },
  /*::[*/
  2075: {
    /* n:"BrtTableSlicerCacheIDs" */
  },
  /*::[*/
  2076: {
    /* n:"BrtTableSlicerCacheID" */
  },
  /*::[*/
  2077: {
    /* n:"BrtBeginTableSlicerCache", */
    T: 1
  },
  /*::[*/
  2078: {
    /* n:"BrtEndTableSlicerCache", */
    T: -1
  },
  /*::[*/
  2079: {
    /* n:"BrtSxFilter15" */
  },
  /*::[*/
  2080: {
    /* n:"BrtBeginTimelineCachePivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2081: {
    /* n:"BrtEndTimelineCachePivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2082: {
    /* n:"BrtTimelineCachePivotCacheID" */
  },
  /*::[*/
  2083: {
    /* n:"BrtBeginTimelineCacheIDs", */
    T: 1
  },
  /*::[*/
  2084: {
    /* n:"BrtEndTimelineCacheIDs", */
    T: -1
  },
  /*::[*/
  2085: {
    /* n:"BrtBeginTimelineCacheID", */
    T: 1
  },
  /*::[*/
  2086: {
    /* n:"BrtEndTimelineCacheID", */
    T: -1
  },
  /*::[*/
  2087: {
    /* n:"BrtBeginTimelinesEx", */
    T: 1
  },
  /*::[*/
  2088: {
    /* n:"BrtEndTimelinesEx", */
    T: -1
  },
  /*::[*/
  2089: {
    /* n:"BrtBeginTimelineEx", */
    T: 1
  },
  /*::[*/
  2090: {
    /* n:"BrtEndTimelineEx", */
    T: -1
  },
  /*::[*/
  2091: {
    /* n:"BrtWorkBookPr15" */
  },
  /*::[*/
  2092: {
    /* n:"BrtPCDH15" */
  },
  /*::[*/
  2093: {
    /* n:"BrtBeginTimelineStyle", */
    T: 1
  },
  /*::[*/
  2094: {
    /* n:"BrtEndTimelineStyle", */
    T: -1
  },
  /*::[*/
  2095: {
    /* n:"BrtTimelineStyleElement" */
  },
  /*::[*/
  2096: {
    /* n:"BrtBeginTimelineStylesheetExt15", */
    T: 1
  },
  /*::[*/
  2097: {
    /* n:"BrtEndTimelineStylesheetExt15", */
    T: -1
  },
  /*::[*/
  2098: {
    /* n:"BrtBeginTimelineStyles", */
    T: 1
  },
  /*::[*/
  2099: {
    /* n:"BrtEndTimelineStyles", */
    T: -1
  },
  /*::[*/
  2100: {
    /* n:"BrtBeginTimelineStyleElements", */
    T: 1
  },
  /*::[*/
  2101: {
    /* n:"BrtEndTimelineStyleElements", */
    T: -1
  },
  /*::[*/
  2102: {
    /* n:"BrtDxf15" */
  },
  /*::[*/
  2103: {
    /* n:"BrtBeginDxfs15", */
    T: 1
  },
  /*::[*/
  2104: {
    /* n:"BrtEndDxfs15", */
    T: -1
  },
  /*::[*/
  2105: {
    /* n:"BrtSlicerCacheHideItemsWithNoData" */
  },
  /*::[*/
  2106: {
    /* n:"BrtBeginItemUniqueNames", */
    T: 1
  },
  /*::[*/
  2107: {
    /* n:"BrtEndItemUniqueNames", */
    T: -1
  },
  /*::[*/
  2108: {
    /* n:"BrtItemUniqueName" */
  },
  /*::[*/
  2109: {
    /* n:"BrtBeginExtConn15", */
    T: 1
  },
  /*::[*/
  2110: {
    /* n:"BrtEndExtConn15", */
    T: -1
  },
  /*::[*/
  2111: {
    /* n:"BrtBeginOledbPr15", */
    T: 1
  },
  /*::[*/
  2112: {
    /* n:"BrtEndOledbPr15", */
    T: -1
  },
  /*::[*/
  2113: {
    /* n:"BrtBeginDataFeedPr15", */
    T: 1
  },
  /*::[*/
  2114: {
    /* n:"BrtEndDataFeedPr15", */
    T: -1
  },
  /*::[*/
  2115: {
    /* n:"BrtTextPr15" */
  },
  /*::[*/
  2116: {
    /* n:"BrtRangePr15" */
  },
  /*::[*/
  2117: {
    /* n:"BrtDbCommand15" */
  },
  /*::[*/
  2118: {
    /* n:"BrtBeginDbTables15", */
    T: 1
  },
  /*::[*/
  2119: {
    /* n:"BrtEndDbTables15", */
    T: -1
  },
  /*::[*/
  2120: {
    /* n:"BrtDbTable15" */
  },
  /*::[*/
  2121: {
    /* n:"BrtBeginDataModel", */
    T: 1
  },
  /*::[*/
  2122: {
    /* n:"BrtEndDataModel", */
    T: -1
  },
  /*::[*/
  2123: {
    /* n:"BrtBeginModelTables", */
    T: 1
  },
  /*::[*/
  2124: {
    /* n:"BrtEndModelTables", */
    T: -1
  },
  /*::[*/
  2125: {
    /* n:"BrtModelTable" */
  },
  /*::[*/
  2126: {
    /* n:"BrtBeginModelRelationships", */
    T: 1
  },
  /*::[*/
  2127: {
    /* n:"BrtEndModelRelationships", */
    T: -1
  },
  /*::[*/
  2128: {
    /* n:"BrtModelRelationship" */
  },
  /*::[*/
  2129: {
    /* n:"BrtBeginECTxtWiz15", */
    T: 1
  },
  /*::[*/
  2130: {
    /* n:"BrtEndECTxtWiz15", */
    T: -1
  },
  /*::[*/
  2131: {
    /* n:"BrtBeginECTWFldInfoLst15", */
    T: 1
  },
  /*::[*/
  2132: {
    /* n:"BrtEndECTWFldInfoLst15", */
    T: -1
  },
  /*::[*/
  2133: {
    /* n:"BrtBeginECTWFldInfo15", */
    T: 1
  },
  /*::[*/
  2134: {
    /* n:"BrtFieldListActiveItem" */
  },
  /*::[*/
  2135: {
    /* n:"BrtPivotCacheIdVersion" */
  },
  /*::[*/
  2136: {
    /* n:"BrtSXDI15" */
  },
  /*::[*/
  2137: {
    /* n:"BrtBeginModelTimeGroupings", */
    T: 1
  },
  /*::[*/
  2138: {
    /* n:"BrtEndModelTimeGroupings", */
    T: -1
  },
  /*::[*/
  2139: {
    /* n:"BrtBeginModelTimeGrouping", */
    T: 1
  },
  /*::[*/
  2140: {
    /* n:"BrtEndModelTimeGrouping", */
    T: -1
  },
  /*::[*/
  2141: {
    /* n:"BrtModelTimeGroupingCalcCol" */
  },
  /*::[*/
  3072: {
    /* n:"BrtUid" */
  },
  /*::[*/
  3073: {
    /* n:"BrtRevisionPtr" */
  },
  /*::[*/
  4096: {
    /* n:"BrtBeginDynamicArrayPr", */
    T: 1
  },
  /*::[*/
  4097: {
    /* n:"BrtEndDynamicArrayPr", */
    T: -1
  },
  /*::[*/
  5002: {
    /* n:"BrtBeginRichValueBlock", */
    T: 1
  },
  /*::[*/
  5003: {
    /* n:"BrtEndRichValueBlock", */
    T: -1
  },
  /*::[*/
  5081: {
    /* n:"BrtBeginRichFilters", */
    T: 1
  },
  /*::[*/
  5082: {
    /* n:"BrtEndRichFilters", */
    T: -1
  },
  /*::[*/
  5083: {
    /* n:"BrtRichFilter" */
  },
  /*::[*/
  5084: {
    /* n:"BrtBeginRichFilterColumn", */
    T: 1
  },
  /*::[*/
  5085: {
    /* n:"BrtEndRichFilterColumn", */
    T: -1
  },
  /*::[*/
  5086: {
    /* n:"BrtBeginCustomRichFilters", */
    T: 1
  },
  /*::[*/
  5087: {
    /* n:"BrtEndCustomRichFilters", */
    T: -1
  },
  /*::[*/
  5088: {
    /* n:"BrtCustomRichFilter" */
  },
  /*::[*/
  5089: {
    /* n:"BrtTop10RichFilter" */
  },
  /*::[*/
  5090: {
    /* n:"BrtDynamicRichFilter" */
  },
  /*::[*/
  5092: {
    /* n:"BrtBeginRichSortCondition", */
    T: 1
  },
  /*::[*/
  5093: {
    /* n:"BrtEndRichSortCondition", */
    T: -1
  },
  /*::[*/
  5094: {
    /* n:"BrtRichFilterDateGroupItem" */
  },
  /*::[*/
  5095: {
    /* n:"BrtBeginCalcFeatures", */
    T: 1
  },
  /*::[*/
  5096: {
    /* n:"BrtEndCalcFeatures", */
    T: -1
  },
  /*::[*/
  5097: {
    /* n:"BrtCalcFeature" */
  },
  /*::[*/
  5099: {
    /* n:"BrtExternalLinksPr" */
  },
  /*::[*/
  65535: { n: "" }
};
function yt(e, t, r, n) {
  var a = t;
  if (!isNaN(a)) {
    var s = n || (r || []).length || 0, i = e.next(4);
    i.write_shift(2, a), i.write_shift(2, s), /*:: len != null &&*/
    s > 0 && $2(r) && e.push(r);
  }
}
function Pqe(e, t, r, n) {
  var a = (r || []).length || 0;
  if (a <= 8224) return yt(e, t, r, a);
  var s = t;
  if (!isNaN(s)) {
    for (var i = r.parts || [], o = 0, l = 0, c = 0; c + (i[o] || 8224) <= 8224; )
      c += i[o] || 8224, o++;
    var u = e.next(4);
    for (u.write_shift(2, s), u.write_shift(2, c), e.push(r.slice(l, l + c)), l += c; l < a; ) {
      for (u = e.next(4), u.write_shift(2, 60), c = 0; c + (i[o] || 8224) <= 8224; )
        c += i[o] || 8224, o++;
      u.write_shift(2, c), e.push(r.slice(l, l + c)), l += c;
    }
  }
}
function Ev(e, t, r) {
  return e || (e = Ke(7)), e.write_shift(2, t), e.write_shift(2, r), e.write_shift(2, 0), e.write_shift(1, 0), e;
}
function Rqe(e, t, r, n) {
  var a = Ke(9);
  return Ev(a, e, t), D9(r, n || "b", a), a;
}
function Iqe(e, t, r) {
  var n = Ke(8 + 2 * r.length);
  return Ev(n, e, t), n.write_shift(1, r.length), n.write_shift(r.length, r, "sbcs"), n.l < n.length ? n.slice(0, n.l) : n;
}
function Dqe(e, t, r, n) {
  if (t.v != null) switch (t.t) {
    case "d":
    case "n":
      var a = t.t == "d" ? _s(ds(t.v)) : t.v;
      a == (a | 0) && a >= 0 && a < 65536 ? yt(e, 2, q7e(r, n, a)) : yt(e, 3, K7e(r, n, a));
      return;
    case "b":
    case "e":
      yt(e, 5, Rqe(r, n, t.v, t.t));
      return;
    case "s":
    case "str":
      yt(e, 4, Iqe(r, n, (t.v || "").slice(0, 255)));
      return;
  }
  yt(e, 1, Ev(null, r, n));
}
function Nqe(e, t, r, n) {
  var a = Array.isArray(t), s = vn(t["!ref"] || "A1"), i, o = "", l = [];
  if (s.e.c > 255 || s.e.r > 16383) {
    if (n.WTF) throw new Error("Range " + (t["!ref"] || "A1") + " exceeds format limit A1:IV16384");
    s.e.c = Math.min(s.e.c, 255), s.e.r = Math.min(s.e.c, 16383), i = ea(s);
  }
  for (var c = s.s.r; c <= s.e.r; ++c) {
    o = Ra(c);
    for (var u = s.s.c; u <= s.e.c; ++u) {
      c === s.s.r && (l[u] = Ya(u)), i = l[u] + o;
      var d = a ? (t[c] || [])[u] : t[i];
      d && Dqe(e, d, c, u);
    }
  }
}
function Mqe(e, t) {
  for (var r = t || {}, n = xs(), a = 0, s = 0; s < e.SheetNames.length; ++s) e.SheetNames[s] == r.sheet && (a = s);
  if (a == 0 && r.sheet && e.SheetNames[0] != r.sheet) throw new Error("Sheet not found: " + r.sheet);
  return yt(n, r.biff == 4 ? 1033 : r.biff == 3 ? 521 : 9, G2(e, 16, r)), Nqe(n, e.Sheets[e.SheetNames[a]], a, r), yt(n, 10), n.end();
}
function Lqe(e, t, r) {
  yt(e, 49, A7e({
    sz: 12,
    name: "Arial"
  }, r));
}
function jqe(e, t, r) {
  t && [[5, 8], [23, 26], [41, 44], [
    /*63*/
    50,
    /*66],[164,*/
    392
  ]].forEach(function(n) {
    for (var a = n[0]; a <= n[1]; ++a) t[a] != null && yt(e, 1054, I7e(a, t[a], r));
  });
}
function Fqe(e, t) {
  var r = Ke(19);
  r.write_shift(4, 2151), r.write_shift(4, 0), r.write_shift(4, 0), r.write_shift(2, 3), r.write_shift(1, 1), r.write_shift(4, 0), yt(e, 2151, r), r = Ke(39), r.write_shift(4, 2152), r.write_shift(4, 0), r.write_shift(4, 0), r.write_shift(2, 3), r.write_shift(1, 0), r.write_shift(4, 0), r.write_shift(2, 1), r.write_shift(4, 4), r.write_shift(2, 0), L9(vn(t["!ref"] || "A1"), r), r.write_shift(4, 4), yt(e, 2152, r);
}
function Bqe(e, t) {
  for (var r = 0; r < 16; ++r) yt(e, 224, i4({ numFmtId: 0, style: !0 }, 0, t));
  t.cellXfs.forEach(function(n) {
    yt(e, 224, i4(n, 0, t));
  });
}
function Uqe(e, t) {
  for (var r = 0; r < t["!links"].length; ++r) {
    var n = t["!links"][r];
    yt(e, 440, U7e(n)), n[1].Tooltip && yt(e, 2048, V7e(n));
  }
  delete t["!links"];
}
function Vqe(e, t) {
  if (t) {
    var r = 0;
    t.forEach(function(n, a) {
      ++r <= 256 && n && yt(e, 125, W7e(e1(a, n), a));
    });
  }
}
function $qe(e, t, r, n, a) {
  var s = 16 + Zc(a.cellXfs, t, a);
  if (t.v == null && !t.bf) {
    yt(e, 513, Ju(r, n, s));
    return;
  }
  if (t.bf) yt(e, 6, fze(t, r, n, a, s));
  else switch (t.t) {
    case "d":
    case "n":
      var i = t.t == "d" ? _s(ds(t.v)) : t.v;
      yt(e, 515, L7e(r, n, i, s));
      break;
    case "b":
    case "e":
      yt(e, 517, M7e(r, n, t.v, s, a, t.t));
      break;
    case "s":
    case "str":
      if (a.bookSST) {
        var o = Z2(a.Strings, t.v, a.revStrings);
        yt(e, 253, P7e(r, n, o, s));
      } else yt(e, 516, R7e(r, n, (t.v || "").slice(0, 255), s, a));
      break;
    default:
      yt(e, 513, Ju(r, n, s));
  }
}
function Hqe(e, t, r) {
  var n = xs(), a = r.SheetNames[e], s = r.Sheets[a] || {}, i = (r || {}).Workbook || {}, o = (i.Sheets || [])[e] || {}, l = Array.isArray(s), c = t.biff == 8, u, d = "", f = [], h = vn(s["!ref"] || "A1"), p = c ? 65536 : 16384;
  if (h.e.c > 255 || h.e.r >= p) {
    if (t.WTF) throw new Error("Range " + (s["!ref"] || "A1") + " exceeds format limit A1:IV16384");
    h.e.c = Math.min(h.e.c, 255), h.e.r = Math.min(h.e.c, p - 1);
  }
  yt(n, 2057, G2(r, 16, t)), yt(n, 13, ai(1)), yt(n, 12, ai(100)), yt(n, 15, cs(!0)), yt(n, 17, cs(!1)), yt(n, 16, Qu(1e-3)), yt(n, 95, cs(!0)), yt(n, 42, cs(!1)), yt(n, 43, cs(!1)), yt(n, 130, ai(1)), yt(n, 128, N7e()), yt(n, 131, cs(!1)), yt(n, 132, cs(!1)), c && Vqe(n, s["!cols"]), yt(n, 512, D7e(h, t)), c && (s["!links"] = []);
  for (var m = h.s.r; m <= h.e.r; ++m) {
    d = Ra(m);
    for (var g = h.s.c; g <= h.e.c; ++g) {
      m === h.s.r && (f[g] = Ya(g)), u = f[g] + d;
      var y = l ? (s[m] || [])[g] : s[u];
      y && ($qe(n, y, m, g, t), c && y.l && s["!links"].push([u, y.l]));
    }
  }
  var x = o.CodeName || o.name || a;
  return c && yt(n, 574, O7e((i.Views || [])[0])), c && (s["!merges"] || []).length && yt(n, 229, B7e(s["!merges"])), c && Uqe(n, s), yt(n, 442, M9(x)), c && Fqe(n, s), yt(
    n,
    10
    /* EOF */
  ), n.end();
}
function Wqe(e, t, r) {
  var n = xs(), a = (e || {}).Workbook || {}, s = a.Sheets || [], i = (
    /*::((*/
    a.WBProps || {
      /*::CodeName:"ThisWorkbook"*/
    }
  ), o = r.biff == 8, l = r.biff == 5;
  if (yt(n, 2057, G2(e, 5, r)), r.bookType == "xla" && yt(
    n,
    135
    /* Addin */
  ), yt(n, 225, o ? ai(1200) : null), yt(n, 193, m7e(2)), l && yt(
    n,
    191
    /* ToolbarHdr */
  ), l && yt(
    n,
    192
    /* ToolbarEnd */
  ), yt(
    n,
    226
    /* InterfaceEnd */
  ), yt(n, 92, E7e("SheetJS", r)), yt(n, 66, ai(o ? 1200 : 1252)), o && yt(n, 353, ai(0)), o && yt(
    n,
    448
    /* Excel9File */
  ), yt(n, 317, z7e(e.SheetNames.length)), o && e.vbaraw && yt(
    n,
    211
    /* ObProj */
  ), o && e.vbaraw) {
    var c = i.CodeName || "ThisWorkbook";
    yt(n, 442, M9(c));
  }
  yt(n, 156, ai(17)), yt(n, 25, cs(!1)), yt(n, 18, cs(!1)), yt(n, 19, ai(0)), o && yt(n, 431, cs(!1)), o && yt(n, 444, ai(0)), yt(n, 61, k7e()), yt(n, 64, cs(!1)), yt(n, 141, ai(0)), yt(n, 34, cs(YKe(e) == "true")), yt(n, 14, cs(!0)), o && yt(n, 439, cs(!1)), yt(n, 218, ai(0)), Lqe(n, e, r), jqe(n, e.SSF, r), Bqe(n, r), o && yt(n, 352, cs(!1));
  var u = n.end(), d = xs();
  o && yt(d, 140, $7e()), o && r.Strings && Pqe(d, 252, C7e(r.Strings)), yt(
    d,
    10
    /* EOF */
  );
  var f = d.end(), h = xs(), p = 0, m = 0;
  for (m = 0; m < e.SheetNames.length; ++m) p += (o ? 12 : 11) + (o ? 2 : 1) * e.SheetNames[m].length;
  var g = u.length + p + f.length;
  for (m = 0; m < e.SheetNames.length; ++m) {
    var y = s[m] || {};
    yt(h, 133, T7e({ pos: g, hs: y.Hidden || 0, dt: 0, name: e.SheetNames[m] }, r)), g += t[m].length;
  }
  var x = h.end();
  if (p != x.length) throw new Error("BS8 " + p + " != " + x.length);
  var w = [];
  return u.length && w.push(u), x.length && w.push(x), f.length && w.push(f), Oa(w);
}
function zqe(e, t) {
  var r = t || {}, n = [];
  e && !e.SSF && (e.SSF = Ss(Rn)), e && e.SSF && (Yx(), Gx(e.SSF), r.revssf = Xx(e.SSF), r.revssf[e.SSF[65535]] = 0, r.ssf = e.SSF), r.Strings = /*::((*/
  [], r.Strings.Count = 0, r.Strings.Unique = 0, eO(r), r.cellXfs = [], Zc(r.cellXfs, {}, { revssf: { General: 0 } }), e.Props || (e.Props = {});
  for (var a = 0; a < e.SheetNames.length; ++a) n[n.length] = Hqe(a, r, e);
  return n.unshift(Wqe(e, n, r)), Oa(n);
}
function lW(e, t) {
  for (var r = 0; r <= e.SheetNames.length; ++r) {
    var n = e.Sheets[e.SheetNames[r]];
    if (!(!n || !n["!ref"])) {
      var a = qs(n["!ref"]);
      a.e.c > 255 && typeof console < "u" && console.error && console.error("Worksheet '" + e.SheetNames[r] + "' extends beyond column IV (255).  Data may be lost.");
    }
  }
  var s = t || {};
  switch (s.biff || 2) {
    case 8:
    case 5:
      return zqe(e, t);
    case 4:
    case 3:
    case 2:
      return Mqe(e, t);
  }
  throw new Error("invalid type " + s.bookType + " for BIFF");
}
function Kqe(e, t, r, n) {
  for (var a = e["!merges"] || [], s = [], i = t.s.c; i <= t.e.c; ++i) {
    for (var o = 0, l = 0, c = 0; c < a.length; ++c)
      if (!(a[c].s.r > r || a[c].s.c > i) && !(a[c].e.r < r || a[c].e.c < i)) {
        if (a[c].s.r < r || a[c].s.c < i) {
          o = -1;
          break;
        }
        o = a[c].e.r - a[c].s.r + 1, l = a[c].e.c - a[c].s.c + 1;
        break;
      }
    if (!(o < 0)) {
      var u = Zr({ r, c: i }), d = n.dense ? (e[r] || [])[i] : e[u], f = d && d.v != null && (d.h || SHe(d.w || (Ul(d), d.w) || "")) || "", h = {};
      o > 1 && (h.rowspan = o), l > 1 && (h.colspan = l), n.editable ? f = '<span contenteditable="true">' + f + "</span>" : d && (h["data-t"] = d && d.t || "z", d.v != null && (h["data-v"] = d.v), d.z != null && (h["data-z"] = d.z), d.l && (d.l.Target || "#").charAt(0) != "#" && (f = '<a href="' + d.l.Target + '">' + f + "</a>")), h.id = (n.id || "sjs") + "-" + u, s.push(vt("td", f, h));
    }
  }
  var p = "<tr>";
  return p + s.join("") + "</tr>";
}
var qqe = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>', Gqe = "</body></html>";
function Yqe(e, t, r) {
  var n = [];
  return n.join("") + "<table" + (r && r.id ? ' id="' + r.id + '"' : "") + ">";
}
function cW(e, t) {
  var r = t || {}, n = r.header != null ? r.header : qqe, a = r.footer != null ? r.footer : Gqe, s = [n], i = qs(e["!ref"]);
  r.dense = Array.isArray(e), s.push(Yqe(e, i, r));
  for (var o = i.s.r; o <= i.e.r; ++o) s.push(Kqe(e, i, o, r));
  return s.push("</table>" + a), s.join("");
}
function uW(e, t, r) {
  var n = r || {}, a = 0, s = 0;
  if (n.origin != null)
    if (typeof n.origin == "number") a = n.origin;
    else {
      var i = typeof n.origin == "string" ? ma(n.origin) : n.origin;
      a = i.r, s = i.c;
    }
  var o = t.getElementsByTagName("tr"), l = Math.min(n.sheetRows || 1e7, o.length), c = { s: { r: 0, c: 0 }, e: { r: a, c: s } };
  if (e["!ref"]) {
    var u = qs(e["!ref"]);
    c.s.r = Math.min(c.s.r, u.s.r), c.s.c = Math.min(c.s.c, u.s.c), c.e.r = Math.max(c.e.r, u.e.r), c.e.c = Math.max(c.e.c, u.e.c), a == -1 && (c.e.r = a = u.e.r + 1);
  }
  var d = [], f = 0, h = e["!rows"] || (e["!rows"] = []), p = 0, m = 0, g = 0, y = 0, x = 0, w = 0;
  for (e["!cols"] || (e["!cols"] = []); p < o.length && m < l; ++p) {
    var _ = o[p];
    if (h4(_)) {
      if (n.display) continue;
      h[m] = { hidden: !0 };
    }
    var S = _.children;
    for (g = y = 0; g < S.length; ++g) {
      var C = S[g];
      if (!(n.display && h4(C))) {
        var E = C.hasAttribute("data-v") ? C.getAttribute("data-v") : C.hasAttribute("v") ? C.getAttribute("v") : kHe(C.innerHTML), O = C.getAttribute("data-z") || C.getAttribute("z");
        for (f = 0; f < d.length; ++f) {
          var k = d[f];
          k.s.c == y + s && k.s.r < m + a && m + a <= k.e.r && (y = k.e.c + 1 - s, f = -1);
        }
        w = +C.getAttribute("colspan") || 1, ((x = +C.getAttribute("rowspan") || 1) > 1 || w > 1) && d.push({ s: { r: m + a, c: y + s }, e: { r: m + a + (x || 1) - 1, c: y + s + (w || 1) - 1 } });
        var A = { t: "s", v: E }, P = C.getAttribute("data-t") || C.getAttribute("t") || "";
        E != null && (E.length == 0 ? A.t = P || "z" : n.raw || E.trim().length == 0 || P == "s" || (E === "TRUE" ? A = { t: "b", v: !0 } : E === "FALSE" ? A = { t: "b", v: !1 } : isNaN(Nl(E)) ? isNaN(mg(E).getDate()) || (A = { t: "d", v: ds(E) }, n.cellDates || (A = { t: "n", v: _s(A.v) }), A.z = n.dateNF || Rn[14]) : A = { t: "n", v: Nl(E) })), A.z === void 0 && O != null && (A.z = O);
        var D = "", N = C.getElementsByTagName("A");
        if (N && N.length)
          for (var z = 0; z < N.length && !(N[z].hasAttribute("href") && (D = N[z].getAttribute("href"), D.charAt(0) != "#")); ++z) ;
        D && D.charAt(0) != "#" && (A.l = { Target: D }), n.dense ? (e[m + a] || (e[m + a] = []), e[m + a][y + s] = A) : e[Zr({ c: y + s, r: m + a })] = A, c.e.c < y + s && (c.e.c = y + s), y += w;
      }
    }
    ++m;
  }
  return d.length && (e["!merges"] = (e["!merges"] || []).concat(d)), c.e.r = Math.max(c.e.r, m - 1 + a), e["!ref"] = ea(c), m >= l && (e["!fullref"] = ea((c.e.r = o.length - p + m - 1 + a, c))), e;
}
function dW(e, t) {
  var r = t || {}, n = r.dense ? [] : {};
  return uW(n, e, t);
}
function Xqe(e, t) {
  return _d(dW(e, t), t);
}
function h4(e) {
  var t = "", r = Qqe(e);
  return r && (t = r(e).getPropertyValue("display")), t || (t = e.style && e.style.display), t === "none";
}
function Qqe(e) {
  return e.ownerDocument.defaultView && typeof e.ownerDocument.defaultView.getComputedStyle == "function" ? e.ownerDocument.defaultView.getComputedStyle : typeof getComputedStyle == "function" ? getComputedStyle : null;
}
var Jqe = /* @__PURE__ */ function() {
  var e = [
    "<office:master-styles>",
    '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
    "<style:header/>",
    '<style:header-left style:display="false"/>',
    "<style:footer/>",
    '<style:footer-left style:display="false"/>',
    "</style:master-page>",
    "</office:master-styles>"
  ].join(""), t = "<office:document-styles " + vg({
    "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
    "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
    "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
    "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
    "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
    "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
    "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
    "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
    "office:version": "1.2"
  }) + ">" + e + "</office:document-styles>";
  return function() {
    return ra + t;
  };
}(), p4 = /* @__PURE__ */ function() {
  var e = function(s) {
    return Jr(s).replace(/  +/g, function(i) {
      return '<text:s text:c="' + i.length + '"/>';
    }).replace(/\t/g, "<text:tab/>").replace(/\n/g, "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
  }, t = `          <table:table-cell />
`, r = `          <table:covered-table-cell/>
`, n = function(s, i, o) {
    var l = [];
    l.push('      <table:table table:name="' + Jr(i.SheetNames[o]) + `" table:style-name="ta1">
`);
    var c = 0, u = 0, d = qs(s["!ref"] || "A1"), f = s["!merges"] || [], h = 0, p = Array.isArray(s);
    if (s["!cols"])
      for (u = 0; u <= d.e.c; ++u) l.push("        <table:table-column" + (s["!cols"][u] ? ' table:style-name="co' + s["!cols"][u].ods + '"' : "") + `></table:table-column>
`);
    var m = "", g = s["!rows"] || [];
    for (c = 0; c < d.s.r; ++c)
      m = g[c] ? ' table:style-name="ro' + g[c].ods + '"' : "", l.push("        <table:table-row" + m + `></table:table-row>
`);
    for (; c <= d.e.r; ++c) {
      for (m = g[c] ? ' table:style-name="ro' + g[c].ods + '"' : "", l.push("        <table:table-row" + m + `>
`), u = 0; u < d.s.c; ++u) l.push(t);
      for (; u <= d.e.c; ++u) {
        var y = !1, x = {}, w = "";
        for (h = 0; h != f.length; ++h)
          if (!(f[h].s.c > u) && !(f[h].s.r > c) && !(f[h].e.c < u) && !(f[h].e.r < c)) {
            (f[h].s.c != u || f[h].s.r != c) && (y = !0), x["table:number-columns-spanned"] = f[h].e.c - f[h].s.c + 1, x["table:number-rows-spanned"] = f[h].e.r - f[h].s.r + 1;
            break;
          }
        if (y) {
          l.push(r);
          continue;
        }
        var _ = Zr({ r: c, c: u }), S = p ? (s[c] || [])[u] : s[_];
        if (S && S.f && (x["table:formula"] = Jr(yze(S.f)), S.F && S.F.slice(0, _.length) == _)) {
          var C = qs(S.F);
          x["table:number-matrix-columns-spanned"] = C.e.c - C.s.c + 1, x["table:number-matrix-rows-spanned"] = C.e.r - C.s.r + 1;
        }
        if (!S) {
          l.push(t);
          continue;
        }
        switch (S.t) {
          case "b":
            w = S.v ? "TRUE" : "FALSE", x["office:value-type"] = "boolean", x["office:boolean-value"] = S.v ? "true" : "false";
            break;
          case "n":
            w = S.w || String(S.v || 0), x["office:value-type"] = "float", x["office:value"] = S.v || 0;
            break;
          case "s":
          case "str":
            w = S.v == null ? "" : S.v, x["office:value-type"] = "string";
            break;
          case "d":
            w = S.w || ds(S.v).toISOString(), x["office:value-type"] = "date", x["office:date-value"] = ds(S.v).toISOString(), x["table:style-name"] = "ce1";
            break;
          default:
            l.push(t);
            continue;
        }
        var E = e(w);
        if (S.l && S.l.Target) {
          var O = S.l.Target;
          O = O.charAt(0) == "#" ? "#" + bze(O.slice(1)) : O, O.charAt(0) != "#" && !O.match(/^\w+:/) && (O = "../" + O), E = vt("text:a", E, { "xlink:href": O.replace(/&/g, "&amp;") });
        }
        l.push("          " + vt("table:table-cell", vt("text:p", E, {}), x) + `
`);
      }
      l.push(`        </table:table-row>
`);
    }
    return l.push(`      </table:table>
`), l.join("");
  }, a = function(s, i) {
    s.push(` <office:automatic-styles>
`), s.push(`  <number:date-style style:name="N37" number:automatic-order="true">
`), s.push(`   <number:month number:style="long"/>
`), s.push(`   <number:text>/</number:text>
`), s.push(`   <number:day number:style="long"/>
`), s.push(`   <number:text>/</number:text>
`), s.push(`   <number:year/>
`), s.push(`  </number:date-style>
`);
    var o = 0;
    i.SheetNames.map(function(c) {
      return i.Sheets[c];
    }).forEach(function(c) {
      if (c && c["!cols"]) {
        for (var u = 0; u < c["!cols"].length; ++u) if (c["!cols"][u]) {
          var d = c["!cols"][u];
          if (d.width == null && d.wpx == null && d.wch == null) continue;
          Y2(d), d.ods = o;
          var f = c["!cols"][u].wpx + "px";
          s.push('  <style:style style:name="co' + o + `" style:family="table-column">
`), s.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + f + `"/>
`), s.push(`  </style:style>
`), ++o;
        }
      }
    });
    var l = 0;
    i.SheetNames.map(function(c) {
      return i.Sheets[c];
    }).forEach(function(c) {
      if (c && c["!rows"]) {
        for (var u = 0; u < c["!rows"].length; ++u) if (c["!rows"][u]) {
          c["!rows"][u].ods = l;
          var d = c["!rows"][u].hpx + "px";
          s.push('  <style:style style:name="ro' + l + `" style:family="table-row">
`), s.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + d + `"/>
`), s.push(`  </style:style>
`), ++l;
        }
      }
    }), s.push(`  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">
`), s.push(`   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>
`), s.push(`  </style:style>
`), s.push(`  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>
`), s.push(` </office:automatic-styles>
`);
  };
  return function(i, o) {
    var l = [ra], c = vg({
      "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
      "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
      "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
      "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
      "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
      "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xmlns:dc": "http://purl.org/dc/elements/1.1/",
      "xmlns:meta": "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
      "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
      "xmlns:presentation": "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
      "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
      "xmlns:chart": "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
      "xmlns:dr3d": "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
      "xmlns:math": "http://www.w3.org/1998/Math/MathML",
      "xmlns:form": "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
      "xmlns:script": "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
      "xmlns:ooo": "http://openoffice.org/2004/office",
      "xmlns:ooow": "http://openoffice.org/2004/writer",
      "xmlns:oooc": "http://openoffice.org/2004/calc",
      "xmlns:dom": "http://www.w3.org/2001/xml-events",
      "xmlns:xforms": "http://www.w3.org/2002/xforms",
      "xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
      "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
      "xmlns:sheet": "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
      "xmlns:rpt": "http://openoffice.org/2005/report",
      "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
      "xmlns:xhtml": "http://www.w3.org/1999/xhtml",
      "xmlns:grddl": "http://www.w3.org/2003/g/data-view#",
      "xmlns:tableooo": "http://openoffice.org/2009/table",
      "xmlns:drawooo": "http://openoffice.org/2010/draw",
      "xmlns:calcext": "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
      "xmlns:loext": "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
      "xmlns:field": "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
      "xmlns:formx": "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
      "xmlns:css3t": "http://www.w3.org/TR/css3-text/",
      "office:version": "1.2"
    }), u = vg({
      "xmlns:config": "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
      "office:mimetype": "application/vnd.oasis.opendocument.spreadsheet"
    });
    o.bookType == "fods" ? (l.push("<office:document" + c + u + `>
`), l.push(C9().replace(/office:document-meta/g, "office:meta"))) : l.push("<office:document-content" + c + `>
`), a(l, i), l.push(`  <office:body>
`), l.push(`    <office:spreadsheet>
`);
    for (var d = 0; d != i.SheetNames.length; ++d) l.push(n(i.Sheets[i.SheetNames[d]], i, d));
    return l.push(`    </office:spreadsheet>
`), l.push(`  </office:body>
`), o.bookType == "fods" ? l.push("</office:document>") : l.push("</office:document-content>"), l.join("");
  };
}();
function fW(e, t) {
  if (t.bookType == "fods") return p4(e, t);
  var r = F2(), n = "", a = [], s = [];
  return n = "mimetype", cr(r, n, "application/vnd.oasis.opendocument.spreadsheet"), n = "content.xml", cr(r, n, p4(e, t)), a.push([n, "text/xml"]), s.push([n, "ContentFile"]), n = "styles.xml", cr(r, n, Jqe(e, t)), a.push([n, "text/xml"]), s.push([n, "StylesFile"]), n = "meta.xml", cr(r, n, ra + C9(
    /*::wb, opts*/
  )), a.push([n, "text/xml"]), s.push([n, "MetadataFile"]), n = "manifest.rdf", cr(r, n, u7e(
    s
    /*, opts*/
  )), a.push([n, "application/rdf+xml"]), n = "META-INF/manifest.xml", cr(r, n, l7e(
    a
    /*, opts*/
  )), r;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
function fw(e) {
  return new DataView(e.buffer, e.byteOffset, e.byteLength);
}
function Zqe(e) {
  return typeof TextEncoder < "u" ? new TextEncoder().encode(e) : Ri(gg(e));
}
function eGe(e, t) {
  e:
    for (var r = 0; r <= e.length - t.length; ++r) {
      for (var n = 0; n < t.length; ++n)
        if (e[r + n] != t[n])
          continue e;
      return !0;
    }
  return !1;
}
function Vc(e) {
  var t = e.reduce(function(a, s) {
    return a + s.length;
  }, 0), r = new Uint8Array(t), n = 0;
  return e.forEach(function(a) {
    r.set(a, n), n += a.length;
  }), r;
}
function tGe(e, t, r) {
  var n = Math.floor(r == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(r))) + 6176 - 20, a = r / Math.pow(10, n - 6176);
  e[t + 15] |= n >> 7, e[t + 14] |= (n & 127) << 1;
  for (var s = 0; a >= 1; ++s, a /= 256)
    e[t + s] = a & 255;
  e[t + 15] |= r >= 0 ? 0 : 128;
}
function yg(e, t) {
  var r = t ? t[0] : 0, n = e[r] & 127;
  e:
    if (e[r++] >= 128 && (n |= (e[r] & 127) << 7, e[r++] < 128 || (n |= (e[r] & 127) << 14, e[r++] < 128) || (n |= (e[r] & 127) << 21, e[r++] < 128) || (n += (e[r] & 127) * Math.pow(2, 28), ++r, e[r++] < 128) || (n += (e[r] & 127) * Math.pow(2, 35), ++r, e[r++] < 128) || (n += (e[r] & 127) * Math.pow(2, 42), ++r, e[r++] < 128)))
      break e;
  return t && (t[0] = r), n;
}
function zr(e) {
  var t = new Uint8Array(7);
  t[0] = e & 127;
  var r = 1;
  e:
    if (e > 127) {
      if (t[r - 1] |= 128, t[r] = e >> 7 & 127, ++r, e <= 16383 || (t[r - 1] |= 128, t[r] = e >> 14 & 127, ++r, e <= 2097151) || (t[r - 1] |= 128, t[r] = e >> 21 & 127, ++r, e <= 268435455) || (t[r - 1] |= 128, t[r] = e / 256 >>> 21 & 127, ++r, e <= 34359738367) || (t[r - 1] |= 128, t[r] = e / 65536 >>> 21 & 127, ++r, e <= 4398046511103))
        break e;
      t[r - 1] |= 128, t[r] = e / 16777216 >>> 21 & 127, ++r;
    }
  return t.slice(0, r);
}
function qf(e) {
  var t = 0, r = e[t] & 127;
  e:
    if (e[t++] >= 128) {
      if (r |= (e[t] & 127) << 7, e[t++] < 128 || (r |= (e[t] & 127) << 14, e[t++] < 128) || (r |= (e[t] & 127) << 21, e[t++] < 128))
        break e;
      r |= (e[t] & 127) << 28;
    }
  return r;
}
function ia(e) {
  for (var t = [], r = [0]; r[0] < e.length; ) {
    var n = r[0], a = yg(e, r), s = a & 7;
    a = Math.floor(a / 8);
    var i = 0, o;
    if (a == 0)
      break;
    switch (s) {
      case 0:
        {
          for (var l = r[0]; e[r[0]++] >= 128; )
            ;
          o = e.slice(l, r[0]);
        }
        break;
      case 5:
        i = 4, o = e.slice(r[0], r[0] + i), r[0] += i;
        break;
      case 1:
        i = 8, o = e.slice(r[0], r[0] + i), r[0] += i;
        break;
      case 2:
        i = yg(e, r), o = e.slice(r[0], r[0] + i), r[0] += i;
        break;
      case 3:
      case 4:
      default:
        throw new Error("PB Type ".concat(s, " for Field ").concat(a, " at offset ").concat(n));
    }
    var c = { data: o, type: s };
    t[a] == null ? t[a] = [c] : t[a].push(c);
  }
  return t;
}
function Ta(e) {
  var t = [];
  return e.forEach(function(r, n) {
    r.forEach(function(a) {
      a.data && (t.push(zr(n * 8 + a.type)), a.type == 2 && t.push(zr(a.data.length)), t.push(a.data));
    });
  }), Vc(t);
}
function Ti(e) {
  for (var t, r = [], n = [0]; n[0] < e.length; ) {
    var a = yg(e, n), s = ia(e.slice(n[0], n[0] + a));
    n[0] += a;
    var i = {
      id: qf(s[1][0].data),
      messages: []
    };
    s[2].forEach(function(o) {
      var l = ia(o.data), c = qf(l[3][0].data);
      i.messages.push({
        meta: l,
        data: e.slice(n[0], n[0] + c)
      }), n[0] += c;
    }), (t = s[3]) != null && t[0] && (i.merge = qf(s[3][0].data) >>> 0 > 0), r.push(i);
  }
  return r;
}
function nf(e) {
  var t = [];
  return e.forEach(function(r) {
    var n = [];
    n[1] = [{ data: zr(r.id), type: 0 }], n[2] = [], r.merge != null && (n[3] = [{ data: zr(+!!r.merge), type: 0 }]);
    var a = [];
    r.messages.forEach(function(i) {
      a.push(i.data), i.meta[3] = [{ type: 0, data: zr(i.data.length) }], n[2].push({ data: Ta(i.meta), type: 2 });
    });
    var s = Ta(n);
    t.push(zr(s.length)), t.push(s), a.forEach(function(i) {
      return t.push(i);
    });
  }), Vc(t);
}
function rGe(e, t) {
  if (e != 0)
    throw new Error("Unexpected Snappy chunk type ".concat(e));
  for (var r = [0], n = yg(t, r), a = []; r[0] < t.length; ) {
    var s = t[r[0]] & 3;
    if (s == 0) {
      var i = t[r[0]++] >> 2;
      if (i < 60)
        ++i;
      else {
        var o = i - 59;
        i = t[r[0]], o > 1 && (i |= t[r[0] + 1] << 8), o > 2 && (i |= t[r[0] + 2] << 16), o > 3 && (i |= t[r[0] + 3] << 24), i >>>= 0, i++, r[0] += o;
      }
      a.push(t.slice(r[0], r[0] + i)), r[0] += i;
      continue;
    } else {
      var l = 0, c = 0;
      if (s == 1 ? (c = (t[r[0]] >> 2 & 7) + 4, l = (t[r[0]++] & 224) << 3, l |= t[r[0]++]) : (c = (t[r[0]++] >> 2) + 1, s == 2 ? (l = t[r[0]] | t[r[0] + 1] << 8, r[0] += 2) : (l = (t[r[0]] | t[r[0] + 1] << 8 | t[r[0] + 2] << 16 | t[r[0] + 3] << 24) >>> 0, r[0] += 4)), a = [Vc(a)], l == 0)
        throw new Error("Invalid offset 0");
      if (l > a[0].length)
        throw new Error("Invalid offset beyond length");
      if (c >= l)
        for (a.push(a[0].slice(-l)), c -= l; c >= a[a.length - 1].length; )
          a.push(a[a.length - 1]), c -= a[a.length - 1].length;
      a.push(a[0].slice(-l, -l + c));
    }
  }
  var u = Vc(a);
  if (u.length != n)
    throw new Error("Unexpected length: ".concat(u.length, " != ").concat(n));
  return u;
}
function Ci(e) {
  for (var t = [], r = 0; r < e.length; ) {
    var n = e[r++], a = e[r] | e[r + 1] << 8 | e[r + 2] << 16;
    r += 3, t.push(rGe(n, e.slice(r, r + a))), r += a;
  }
  if (r !== e.length)
    throw new Error("data is not a valid framed stream!");
  return Vc(t);
}
function af(e) {
  for (var t = [], r = 0; r < e.length; ) {
    var n = Math.min(e.length - r, 268435455), a = new Uint8Array(4);
    t.push(a);
    var s = zr(n), i = s.length;
    t.push(s), n <= 60 ? (i++, t.push(new Uint8Array([n - 1 << 2]))) : n <= 256 ? (i += 2, t.push(new Uint8Array([240, n - 1 & 255]))) : n <= 65536 ? (i += 3, t.push(new Uint8Array([244, n - 1 & 255, n - 1 >> 8 & 255]))) : n <= 16777216 ? (i += 4, t.push(new Uint8Array([248, n - 1 & 255, n - 1 >> 8 & 255, n - 1 >> 16 & 255]))) : n <= 4294967296 && (i += 5, t.push(new Uint8Array([252, n - 1 & 255, n - 1 >> 8 & 255, n - 1 >> 16 & 255, n - 1 >>> 24 & 255]))), t.push(e.slice(r, r + n)), i += n, a[0] = 0, a[1] = i & 255, a[2] = i >> 8 & 255, a[3] = i >> 16 & 255, r += n;
  }
  return Vc(t);
}
function AS(e, t) {
  var r = new Uint8Array(32), n = fw(r), a = 12, s = 0;
  switch (r[0] = 5, e.t) {
    case "n":
      r[1] = 2, tGe(r, a, e.v), s |= 1, a += 16;
      break;
    case "b":
      r[1] = 6, n.setFloat64(a, e.v ? 1 : 0, !0), s |= 2, a += 8;
      break;
    case "s":
      if (t.indexOf(e.v) == -1)
        throw new Error("Value ".concat(e.v, " missing from SST!"));
      r[1] = 3, n.setUint32(a, t.indexOf(e.v), !0), s |= 8, a += 4;
      break;
    default:
      throw "unsupported cell type " + e.t;
  }
  return n.setUint32(8, s, !0), r.slice(0, a);
}
function PS(e, t) {
  var r = new Uint8Array(32), n = fw(r), a = 12, s = 0;
  switch (r[0] = 3, e.t) {
    case "n":
      r[2] = 2, n.setFloat64(a, e.v, !0), s |= 32, a += 8;
      break;
    case "b":
      r[2] = 6, n.setFloat64(a, e.v ? 1 : 0, !0), s |= 32, a += 8;
      break;
    case "s":
      if (t.indexOf(e.v) == -1)
        throw new Error("Value ".concat(e.v, " missing from SST!"));
      r[2] = 3, n.setUint32(a, t.indexOf(e.v), !0), s |= 16, a += 4;
      break;
    default:
      throw "unsupported cell type " + e.t;
  }
  return n.setUint32(4, s, !0), r.slice(0, a);
}
function sc(e) {
  var t = ia(e);
  return yg(t[1][0].data);
}
function nGe(e, t, r) {
  var n, a, s, i;
  if (!((n = e[6]) != null && n[0]) || !((a = e[7]) != null && a[0]))
    throw "Mutation only works on post-BNC storages!";
  var o = ((i = (s = e[8]) == null ? void 0 : s[0]) == null ? void 0 : i.data) && qf(e[8][0].data) > 0 || !1;
  if (o)
    throw "Math only works with normal offsets";
  for (var l = 0, c = fw(e[7][0].data), u = 0, d = [], f = fw(e[4][0].data), h = 0, p = [], m = 0; m < t.length; ++m) {
    if (t[m] == null) {
      c.setUint16(m * 2, 65535, !0), f.setUint16(m * 2, 65535);
      continue;
    }
    c.setUint16(m * 2, u, !0), f.setUint16(m * 2, h, !0);
    var g, y;
    switch (typeof t[m]) {
      case "string":
        g = AS({ t: "s", v: t[m] }, r), y = PS({ t: "s", v: t[m] }, r);
        break;
      case "number":
        g = AS({ t: "n", v: t[m] }, r), y = PS({ t: "n", v: t[m] }, r);
        break;
      case "boolean":
        g = AS({ t: "b", v: t[m] }, r), y = PS({ t: "b", v: t[m] }, r);
        break;
      default:
        throw new Error("Unsupported value " + t[m]);
    }
    d.push(g), u += g.length, p.push(y), h += y.length, ++l;
  }
  for (e[2][0].data = zr(l); m < e[7][0].data.length / 2; ++m)
    c.setUint16(m * 2, 65535, !0), f.setUint16(m * 2, 65535, !0);
  return e[6][0].data = Vc(d), e[3][0].data = Vc(p), l;
}
function aGe(e, t) {
  if (!t || !t.numbers)
    throw new Error("Must pass a `numbers` option -- check the README");
  var r = e.Sheets[e.SheetNames[0]];
  e.SheetNames.length > 1 && console.error("The Numbers writer currently writes only the first table");
  var n = qs(r["!ref"]);
  n.s.r = n.s.c = 0;
  var a = !1;
  n.e.c > 9 && (a = !0, n.e.c = 9), n.e.r > 49 && (a = !0, n.e.r = 49), a && console.error("The Numbers writer is currently limited to ".concat(ea(n)));
  var s = hw(r, { range: n, header: 1 }), i = ["~Sh33tJ5~"];
  s.forEach(function(Q) {
    return Q.forEach(function(L) {
      typeof L == "string" && i.push(L);
    });
  });
  var o = {}, l = [], c = rn.read(t.numbers, { type: "base64" });
  c.FileIndex.map(function(Q, L) {
    return [Q, c.FullPaths[L]];
  }).forEach(function(Q) {
    var L = Q[0], j = Q[1];
    if (L.type == 2 && L.name.match(/\.iwa/)) {
      var K = L.content, J = Ci(K), re = Ti(J);
      re.forEach(function(le) {
        l.push(le.id), o[le.id] = { deps: [], location: j, type: qf(le.messages[0].meta[1][0].data) };
      });
    }
  }), l.sort(function(Q, L) {
    return Q - L;
  });
  var u = l.filter(function(Q) {
    return Q > 1;
  }).map(function(Q) {
    return [Q, zr(Q)];
  });
  c.FileIndex.map(function(Q, L) {
    return [Q, c.FullPaths[L]];
  }).forEach(function(Q) {
    var L = Q[0];
    if (Q[1], !!L.name.match(/\.iwa/)) {
      var j = Ti(Ci(L.content));
      j.forEach(function(K) {
        K.messages.forEach(function(J) {
          u.forEach(function(re) {
            K.messages.some(function(le) {
              return qf(le.meta[1][0].data) != 11006 && eGe(le.data, re[1]);
            }) && o[re[0]].deps.push(K.id);
          });
        });
      });
    }
  });
  for (var d = rn.find(c, o[1].location), f = Ti(Ci(d.content)), h, p = 0; p < f.length; ++p) {
    var m = f[p];
    m.id == 1 && (h = m);
  }
  var g = sc(ia(h.messages[0].data)[1][0].data);
  for (d = rn.find(c, o[g].location), f = Ti(Ci(d.content)), p = 0; p < f.length; ++p)
    m = f[p], m.id == g && (h = m);
  for (g = sc(ia(h.messages[0].data)[2][0].data), d = rn.find(c, o[g].location), f = Ti(Ci(d.content)), p = 0; p < f.length; ++p)
    m = f[p], m.id == g && (h = m);
  for (g = sc(ia(h.messages[0].data)[2][0].data), d = rn.find(c, o[g].location), f = Ti(Ci(d.content)), p = 0; p < f.length; ++p)
    m = f[p], m.id == g && (h = m);
  var y = ia(h.messages[0].data);
  {
    y[6][0].data = zr(n.e.r + 1), y[7][0].data = zr(n.e.c + 1);
    var x = sc(y[46][0].data), w = rn.find(c, o[x].location), _ = Ti(Ci(w.content));
    {
      for (var S = 0; S < _.length && _[S].id != x; ++S)
        ;
      if (_[S].id != x)
        throw "Bad ColumnRowUIDMapArchive";
      var C = ia(_[S].messages[0].data);
      C[1] = [], C[2] = [], C[3] = [];
      for (var E = 0; E <= n.e.c; ++E) {
        var O = [];
        O[1] = O[2] = [{ type: 0, data: zr(E + 420690) }], C[1].push({ type: 2, data: Ta(O) }), C[2].push({ type: 0, data: zr(E) }), C[3].push({ type: 0, data: zr(E) });
      }
      C[4] = [], C[5] = [], C[6] = [];
      for (var k = 0; k <= n.e.r; ++k)
        O = [], O[1] = O[2] = [{ type: 0, data: zr(k + 726270) }], C[4].push({ type: 2, data: Ta(O) }), C[5].push({ type: 0, data: zr(k) }), C[6].push({ type: 0, data: zr(k) });
      _[S].messages[0].data = Ta(C);
    }
    w.content = af(nf(_)), w.size = w.content.length, delete y[46];
    var A = ia(y[4][0].data);
    {
      A[7][0].data = zr(n.e.r + 1);
      var P = ia(A[1][0].data), D = sc(P[2][0].data);
      w = rn.find(c, o[D].location), _ = Ti(Ci(w.content));
      {
        if (_[0].id != D)
          throw "Bad HeaderStorageBucket";
        var N = ia(_[0].messages[0].data);
        for (k = 0; k < s.length; ++k) {
          var z = ia(N[2][0].data);
          z[1][0].data = zr(k), z[4][0].data = zr(s[k].length), N[2][k] = { type: N[2][0].type, data: Ta(z) };
        }
        _[0].messages[0].data = Ta(N);
      }
      w.content = af(nf(_)), w.size = w.content.length;
      var G = sc(A[2][0].data);
      w = rn.find(c, o[G].location), _ = Ti(Ci(w.content));
      {
        if (_[0].id != G)
          throw "Bad HeaderStorageBucket";
        for (N = ia(_[0].messages[0].data), E = 0; E <= n.e.c; ++E)
          z = ia(N[2][0].data), z[1][0].data = zr(E), z[4][0].data = zr(n.e.r + 1), N[2][E] = { type: N[2][0].type, data: Ta(z) };
        _[0].messages[0].data = Ta(N);
      }
      w.content = af(nf(_)), w.size = w.content.length;
      var Y = sc(A[4][0].data);
      (function() {
        for (var Q = rn.find(c, o[Y].location), L = Ti(Ci(Q.content)), j, K = 0; K < L.length; ++K) {
          var J = L[K];
          J.id == Y && (j = J);
        }
        var re = ia(j.messages[0].data);
        {
          re[3] = [];
          var le = [];
          i.forEach(function(Oe, ee) {
            le[1] = [{ type: 0, data: zr(ee) }], le[2] = [{ type: 0, data: zr(1) }], le[3] = [{ type: 2, data: Zqe(Oe) }], re[3].push({ type: 2, data: Ta(le) });
          });
        }
        j.messages[0].data = Ta(re);
        var pe = nf(L), me = af(pe);
        Q.content = me, Q.size = Q.content.length;
      })();
      var te = ia(A[3][0].data);
      {
        var ae = te[1][0];
        delete te[2];
        var ne = ia(ae.data);
        {
          var ue = sc(ne[2][0].data);
          (function() {
            for (var Q = rn.find(c, o[ue].location), L = Ti(Ci(Q.content)), j, K = 0; K < L.length; ++K) {
              var J = L[K];
              J.id == ue && (j = J);
            }
            var re = ia(j.messages[0].data);
            {
              delete re[6], delete te[7];
              var le = new Uint8Array(re[5][0].data);
              re[5] = [];
              for (var pe = 0, me = 0; me <= n.e.r; ++me) {
                var Oe = ia(le);
                pe += nGe(Oe, s[me], i), Oe[1][0].data = zr(me), re[5].push({ data: Ta(Oe), type: 2 });
              }
              re[1] = [{ type: 0, data: zr(n.e.c + 1) }], re[2] = [{ type: 0, data: zr(n.e.r + 1) }], re[3] = [{ type: 0, data: zr(pe) }], re[4] = [{ type: 0, data: zr(n.e.r + 1) }];
            }
            j.messages[0].data = Ta(re);
            var ee = nf(L), he = af(ee);
            Q.content = he, Q.size = Q.content.length;
          })();
        }
        ae.data = Ta(ne);
      }
      A[3][0].data = Ta(te);
    }
    y[4][0].data = Ta(A);
  }
  h.messages[0].data = Ta(y);
  var q = nf(f), U = af(q);
  return d.content = U, d.size = d.content.length, c;
}
function sGe(e) {
  return function(r) {
    for (var n = 0; n != e.length; ++n) {
      var a = e[n];
      r[a[0]] === void 0 && (r[a[0]] = a[1]), a[2] === "n" && (r[a[0]] = Number(r[a[0]]));
    }
  };
}
function eO(e) {
  sGe([
    ["cellDates", !1],
    /* write date cells with type `d` */
    ["bookSST", !1],
    /* Generate Shared String Table */
    ["bookType", "xlsx"],
    /* Type of workbook (xlsx/m/b) */
    ["compression", !1],
    /* Use file compression */
    ["WTF", !1]
    /* WTF mode (throws errors) */
  ])(e);
}
function iGe(e, t) {
  return t.bookType == "ods" ? fW(e, t) : t.bookType == "numbers" ? aGe(e, t) : t.bookType == "xlsb" ? oGe(e, t) : lGe(e, t);
}
function oGe(e, t) {
  Df = 1024, e && !e.SSF && (e.SSF = Ss(Rn)), e && e.SSF && (Yx(), Gx(e.SSF), t.revssf = Xx(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF), t.rels = {}, t.wbrels = {}, t.Strings = /*::((*/
  [], t.Strings.Count = 0, t.Strings.Unique = 0, Rm ? t.revStrings = /* @__PURE__ */ new Map() : (t.revStrings = {}, t.revStrings.foo = [], delete t.revStrings.foo);
  var r = t.bookType == "xlsb" ? "bin" : "xml", n = G9.indexOf(t.bookType) > -1, a = S9();
  eO(t = t || {});
  var s = F2(), i = "", o = 0;
  if (t.cellXfs = [], Zc(t.cellXfs, {}, { revssf: { General: 0 } }), e.Props || (e.Props = {}), i = "docProps/core.xml", cr(s, i, k9(e.Props, t)), a.coreprops.push(i), qr(t.rels, 2, i, Ar.CORE_PROPS), i = "docProps/app.xml", !(e.Props && e.Props.SheetNames)) if (!e.Workbook || !e.Workbook.Sheets) e.Props.SheetNames = e.SheetNames;
  else {
    for (var l = [], c = 0; c < e.SheetNames.length; ++c)
      (e.Workbook.Sheets[c] || {}).Hidden != 2 && l.push(e.SheetNames[c]);
    e.Props.SheetNames = l;
  }
  for (e.Props.Worksheets = e.Props.SheetNames.length, cr(s, i, A9(e.Props)), a.extprops.push(i), qr(t.rels, 3, i, Ar.EXT_PROPS), e.Custprops !== e.Props && Ia(e.Custprops || {}).length > 0 && (i = "docProps/custom.xml", cr(s, i, P9(e.Custprops)), a.custprops.push(i), qr(t.rels, 4, i, Ar.CUST_PROPS)), o = 1; o <= e.SheetNames.length; ++o) {
    var u = { "!id": {} }, d = e.Sheets[e.SheetNames[o - 1]], f = (d || {})["!type"] || "sheet";
    switch (f) {
      case "chart":
      default:
        i = "xl/worksheets/sheet" + o + "." + r, cr(s, i, uqe(o - 1, i, t, e, u)), a.sheets.push(i), qr(t.wbrels, -1, "worksheets/sheet" + o + "." + r, Ar.WS[0]);
    }
    if (d) {
      var h = d["!comments"], p = !1, m = "";
      h && h.length > 0 && (m = "xl/comments" + o + "." + r, cr(s, m, hqe(h, m)), a.comments.push(m), qr(u, -1, "../comments" + o + "." + r, Ar.CMNT), p = !0), d["!legacy"] && p && cr(s, "xl/drawings/vmlDrawing" + o + ".vml", K9(o, d["!comments"])), delete d["!comments"], delete d["!legacy"];
    }
    u["!id"].rId1 && cr(s, T9(i), zf(u));
  }
  return t.Strings != null && t.Strings.length > 0 && (i = "xl/sharedStrings." + r, cr(s, i, fqe(t.Strings, i, t)), a.strs.push(i), qr(t.wbrels, -1, "sharedStrings." + r, Ar.SST)), i = "xl/workbook." + r, cr(s, i, cqe(e, i)), a.workbooks.push(i), qr(t.rels, 1, i, Ar.WB), i = "xl/theme/theme1.xml", cr(s, i, W9(e.Themes, t)), a.themes.push(i), qr(t.wbrels, -1, "theme/theme1.xml", Ar.THEME), i = "xl/styles." + r, cr(s, i, dqe(e, i, t)), a.styles.push(i), qr(t.wbrels, -1, "styles." + r, Ar.STY), e.vbaraw && n && (i = "xl/vbaProject.bin", cr(s, i, e.vbaraw), a.vba.push(i), qr(t.wbrels, -1, "vbaProject.bin", Ar.VBA)), i = "xl/metadata." + r, cr(s, i, pqe(i)), a.metadata.push(i), qr(t.wbrels, -1, "metadata." + r, Ar.XLMETA), cr(s, "[Content_Types].xml", E9(a, t)), cr(s, "_rels/.rels", zf(t.rels)), cr(s, "xl/_rels/workbook." + r + ".rels", zf(t.wbrels)), delete t.revssf, delete t.ssf, s;
}
function lGe(e, t) {
  Df = 1024, e && !e.SSF && (e.SSF = Ss(Rn)), e && e.SSF && (Yx(), Gx(e.SSF), t.revssf = Xx(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF), t.rels = {}, t.wbrels = {}, t.Strings = /*::((*/
  [], t.Strings.Count = 0, t.Strings.Unique = 0, Rm ? t.revStrings = /* @__PURE__ */ new Map() : (t.revStrings = {}, t.revStrings.foo = [], delete t.revStrings.foo);
  var r = "xml", n = G9.indexOf(t.bookType) > -1, a = S9();
  eO(t = t || {});
  var s = F2(), i = "", o = 0;
  if (t.cellXfs = [], Zc(t.cellXfs, {}, { revssf: { General: 0 } }), e.Props || (e.Props = {}), i = "docProps/core.xml", cr(s, i, k9(e.Props, t)), a.coreprops.push(i), qr(t.rels, 2, i, Ar.CORE_PROPS), i = "docProps/app.xml", !(e.Props && e.Props.SheetNames)) if (!e.Workbook || !e.Workbook.Sheets) e.Props.SheetNames = e.SheetNames;
  else {
    for (var l = [], c = 0; c < e.SheetNames.length; ++c)
      (e.Workbook.Sheets[c] || {}).Hidden != 2 && l.push(e.SheetNames[c]);
    e.Props.SheetNames = l;
  }
  e.Props.Worksheets = e.Props.SheetNames.length, cr(s, i, A9(e.Props)), a.extprops.push(i), qr(t.rels, 3, i, Ar.EXT_PROPS), e.Custprops !== e.Props && Ia(e.Custprops || {}).length > 0 && (i = "docProps/custom.xml", cr(s, i, P9(e.Custprops)), a.custprops.push(i), qr(t.rels, 4, i, Ar.CUST_PROPS));
  var u = ["SheetJ5"];
  for (t.tcid = 0, o = 1; o <= e.SheetNames.length; ++o) {
    var d = { "!id": {} }, f = e.Sheets[e.SheetNames[o - 1]], h = (f || {})["!type"] || "sheet";
    switch (h) {
      case "chart":
      default:
        i = "xl/worksheets/sheet" + o + "." + r, cr(s, i, nW(o - 1, t, e, d)), a.sheets.push(i), qr(t.wbrels, -1, "worksheets/sheet" + o + "." + r, Ar.WS[0]);
    }
    if (f) {
      var p = f["!comments"], m = !1, g = "";
      if (p && p.length > 0) {
        var y = !1;
        p.forEach(function(x) {
          x[1].forEach(function(w) {
            w.T == !0 && (y = !0);
          });
        }), y && (g = "xl/threadedComments/threadedComment" + o + "." + r, cr(s, g, B9e(p, u, t)), a.threadedcomments.push(g), qr(d, -1, "../threadedComments/threadedComment" + o + "." + r, Ar.TCMNT)), g = "xl/comments" + o + "." + r, cr(s, g, q9(p)), a.comments.push(g), qr(d, -1, "../comments" + o + "." + r, Ar.CMNT), m = !0;
      }
      f["!legacy"] && m && cr(s, "xl/drawings/vmlDrawing" + o + ".vml", K9(o, f["!comments"])), delete f["!comments"], delete f["!legacy"];
    }
    d["!id"].rId1 && cr(s, T9(i), zf(d));
  }
  return t.Strings != null && t.Strings.length > 0 && (i = "xl/sharedStrings." + r, cr(s, i, F9(t.Strings, t)), a.strs.push(i), qr(t.wbrels, -1, "sharedStrings." + r, Ar.SST)), i = "xl/workbook." + r, cr(s, i, iW(e)), a.workbooks.push(i), qr(t.rels, 1, i, Ar.WB), i = "xl/theme/theme1.xml", cr(s, i, W9(e.Themes, t)), a.themes.push(i), qr(t.wbrels, -1, "theme/theme1.xml", Ar.THEME), i = "xl/styles." + r, cr(s, i, $9(e, t)), a.styles.push(i), qr(t.wbrels, -1, "styles." + r, Ar.STY), e.vbaraw && n && (i = "xl/vbaProject.bin", cr(s, i, e.vbaraw), a.vba.push(i), qr(t.wbrels, -1, "vbaProject.bin", Ar.VBA)), i = "xl/metadata." + r, cr(s, i, z9()), a.metadata.push(i), qr(t.wbrels, -1, "metadata." + r, Ar.XLMETA), u.length > 1 && (i = "xl/persons/person.xml", cr(s, i, U9e(u)), a.people.push(i), qr(t.wbrels, -1, "persons/person.xml", Ar.PEOPLE)), cr(s, "[Content_Types].xml", E9(a, t)), cr(s, "_rels/.rels", zf(t.rels)), cr(s, "xl/_rels/workbook." + r + ".rels", zf(t.wbrels)), delete t.revssf, delete t.ssf, s;
}
function cGe(e, t) {
  var r = "";
  switch ((t || {}).type || "base64") {
    case "buffer":
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]];
    case "base64":
      r = Bl(e.slice(0, 12));
      break;
    case "binary":
      r = e;
      break;
    case "array":
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]];
    default:
      throw new Error("Unrecognized type " + (t && t.type || "undefined"));
  }
  return [r.charCodeAt(0), r.charCodeAt(1), r.charCodeAt(2), r.charCodeAt(3), r.charCodeAt(4), r.charCodeAt(5), r.charCodeAt(6), r.charCodeAt(7)];
}
function hW(e, t) {
  switch (t.type) {
    case "base64":
    case "binary":
      break;
    case "buffer":
    case "array":
      t.type = "";
      break;
    case "file":
      return wv(t.file, rn.write(e, { type: Mr ? "buffer" : "" }));
    case "string":
      throw new Error("'string' output type invalid for '" + t.bookType + "' files");
    default:
      throw new Error("Unrecognized type " + t.type);
  }
  return rn.write(e, t);
}
function uGe(e, t) {
  var r = Ss(t || {}), n = iGe(e, r);
  return dGe(n, r);
}
function dGe(e, t) {
  var r = {}, n = Mr ? "nodebuffer" : typeof Uint8Array < "u" ? "array" : "string";
  if (t.compression && (r.compression = "DEFLATE"), t.password) r.type = n;
  else switch (t.type) {
    case "base64":
      r.type = "base64";
      break;
    case "binary":
      r.type = "string";
      break;
    case "string":
      throw new Error("'string' output type invalid for '" + t.bookType + "' files");
    case "buffer":
    case "file":
      r.type = n;
      break;
    default:
      throw new Error("Unrecognized type " + t.type);
  }
  var a = e.FullPaths ? rn.write(e, { fileType: "zip", type: (
    /*::(*/
    { nodebuffer: "buffer", string: "binary" }[r.type] || r.type
  ), compression: !!t.compression }) : e.generate(r);
  if (typeof Deno < "u" && typeof a == "string") {
    if (t.type == "binary" || t.type == "base64") return a;
    a = new Uint8Array(qx(a));
  }
  return t.password && typeof encrypt_agile < "u" ? hW(encrypt_agile(a, t.password), t) : t.type === "file" ? wv(t.file, a) : t.type == "string" ? km(
    /*::(*/
    a
    /*:: :any)*/
  ) : a;
}
function fGe(e, t) {
  var r = t || {}, n = Oqe(e, r);
  return hW(n, r);
}
function fo(e, t, r) {
  r || (r = "");
  var n = r + e;
  switch (t.type) {
    case "base64":
      return pg(gg(n));
    case "binary":
      return gg(n);
    case "string":
      return e;
    case "file":
      return wv(t.file, n, "utf8");
    case "buffer":
      return Mr ? Gl(n, "utf8") : typeof TextEncoder < "u" ? new TextEncoder().encode(n) : fo(n, { type: "binary" }).split("").map(function(a) {
        return a.charCodeAt(0);
      });
  }
  throw new Error("Unrecognized type " + t.type);
}
function hGe(e, t) {
  switch (t.type) {
    case "base64":
      return pg(e);
    case "binary":
      return e;
    case "string":
      return e;
    case "file":
      return wv(t.file, e, "binary");
    case "buffer":
      return Mr ? Gl(e, "binary") : e.split("").map(function(r) {
        return r.charCodeAt(0);
      });
  }
  throw new Error("Unrecognized type " + t.type);
}
function uy(e, t) {
  switch (t.type) {
    case "string":
    case "base64":
    case "binary":
      for (var r = "", n = 0; n < e.length; ++n) r += String.fromCharCode(e[n]);
      return t.type == "base64" ? pg(r) : t.type == "string" ? km(r) : r;
    case "file":
      return wv(t.file, e);
    case "buffer":
      return e;
    default:
      throw new Error("Unrecognized type " + t.type);
  }
}
function pW(e, t) {
  V8e(), JKe(e);
  var r = Ss(t || {});
  if (r.cellStyles && (r.cellNF = !0, r.sheetStubs = !0), r.type == "array") {
    r.type = "binary";
    var n = pW(e, r);
    return r.type = "array", qx(n);
  }
  var a = 0;
  if (r.sheet && (typeof r.sheet == "number" ? a = r.sheet : a = e.SheetNames.indexOf(r.sheet), !e.SheetNames[a]))
    throw new Error("Sheet not found: " + r.sheet + " : " + typeof r.sheet);
  switch (r.bookType || "xlsb") {
    case "xml":
    case "xlml":
      return fo(Cqe(e, r), r);
    case "slk":
    case "sylk":
      return fo(Y7e.from_sheet(e.Sheets[e.SheetNames[a]], r), r);
    case "htm":
    case "html":
      return fo(cW(e.Sheets[e.SheetNames[a]], r), r);
    case "txt":
      return hGe(mW(e.Sheets[e.SheetNames[a]], r), r);
    case "csv":
      return fo(tO(e.Sheets[e.SheetNames[a]], r), r, "\uFEFF");
    case "dif":
      return fo(X7e.from_sheet(e.Sheets[e.SheetNames[a]], r), r);
    case "dbf":
      return uy(G7e.from_sheet(e.Sheets[e.SheetNames[a]], r), r);
    case "prn":
      return fo(Q7e.from_sheet(e.Sheets[e.SheetNames[a]], r), r);
    case "rtf":
      return fo(a9e.from_sheet(e.Sheets[e.SheetNames[a]], r), r);
    case "eth":
      return fo(j9.from_sheet(e.Sheets[e.SheetNames[a]], r), r);
    case "fods":
      return fo(fW(e, r), r);
    case "wk1":
      return uy(o4.sheet_to_wk1(e.Sheets[e.SheetNames[a]], r), r);
    case "wk3":
      return uy(o4.book_to_wk3(e, r), r);
    case "biff2":
      r.biff || (r.biff = 2);
    case "biff3":
      r.biff || (r.biff = 3);
    case "biff4":
      return r.biff || (r.biff = 4), uy(lW(e, r), r);
    case "biff5":
      r.biff || (r.biff = 5);
    case "biff8":
    case "xla":
    case "xls":
      return r.biff || (r.biff = 8), fGe(e, r);
    case "xlsx":
    case "xlsm":
    case "xlam":
    case "xlsb":
    case "numbers":
    case "ods":
      return uGe(e, r);
    default:
      throw new Error("Unrecognized bookType |" + r.bookType + "|");
  }
}
function pGe(e, t, r, n, a, s, i, o) {
  var l = Ra(r), c = o.defval, u = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw"), d = !0, f = a === 1 ? [] : {};
  if (a !== 1)
    if (Object.defineProperty) try {
      Object.defineProperty(f, "__rowNum__", { value: r, enumerable: !1 });
    } catch {
      f.__rowNum__ = r;
    }
    else f.__rowNum__ = r;
  if (!i || e[r]) for (var h = t.s.c; h <= t.e.c; ++h) {
    var p = i ? e[r][h] : e[n[h] + l];
    if (p === void 0 || p.t === void 0) {
      if (c === void 0) continue;
      s[h] != null && (f[s[h]] = c);
      continue;
    }
    var m = p.v;
    switch (p.t) {
      case "z":
        if (m == null) break;
        continue;
      case "e":
        m = m == 0 ? null : void 0;
        break;
      case "s":
      case "d":
      case "b":
      case "n":
        break;
      default:
        throw new Error("unrecognized type " + p.t);
    }
    if (s[h] != null) {
      if (m == null)
        if (p.t == "e" && m === null) f[s[h]] = null;
        else if (c !== void 0) f[s[h]] = c;
        else if (u && m === null) f[s[h]] = null;
        else continue;
      else
        f[s[h]] = u && (p.t !== "n" || p.t === "n" && o.rawNumbers !== !1) ? m : Ul(p, m, o);
      m != null && (d = !1);
    }
  }
  return { row: f, isempty: d };
}
function hw(e, t) {
  if (e == null || e["!ref"] == null) return [];
  var r = { t: "n", v: 0 }, n = 0, a = 1, s = [], i = 0, o = "", l = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, c = t || {}, u = c.range != null ? c.range : e["!ref"];
  switch (c.header === 1 ? n = 1 : c.header === "A" ? n = 2 : Array.isArray(c.header) ? n = 3 : c.header == null && (n = 0), typeof u) {
    case "string":
      l = vn(u);
      break;
    case "number":
      l = vn(e["!ref"]), l.s.r = u;
      break;
    default:
      l = u;
  }
  n > 0 && (a = 0);
  var d = Ra(l.s.r), f = [], h = [], p = 0, m = 0, g = Array.isArray(e), y = l.s.r, x = 0, w = {};
  g && !e[y] && (e[y] = []);
  var _ = c.skipHidden && e["!cols"] || [], S = c.skipHidden && e["!rows"] || [];
  for (x = l.s.c; x <= l.e.c; ++x)
    if (!(_[x] || {}).hidden)
      switch (f[x] = Ya(x), r = g ? e[y][x] : e[f[x] + d], n) {
        case 1:
          s[x] = x - l.s.c;
          break;
        case 2:
          s[x] = f[x];
          break;
        case 3:
          s[x] = c.header[x - l.s.c];
          break;
        default:
          if (r == null && (r = { w: "__EMPTY", t: "s" }), o = i = Ul(r, null, c), m = w[i] || 0, !m) w[i] = 1;
          else {
            do
              o = i + "_" + m++;
            while (w[o]);
            w[i] = m, w[o] = 1;
          }
          s[x] = o;
      }
  for (y = l.s.r + a; y <= l.e.r; ++y)
    if (!(S[y] || {}).hidden) {
      var C = pGe(e, l, y, f, n, s, g, c);
      (C.isempty === !1 || (n === 1 ? c.blankrows !== !1 : c.blankrows)) && (h[p++] = C.row);
    }
  return h.length = p, h;
}
var m4 = /"/g;
function mGe(e, t, r, n, a, s, i, o) {
  for (var l = !0, c = [], u = "", d = Ra(r), f = t.s.c; f <= t.e.c; ++f)
    if (n[f]) {
      var h = o.dense ? (e[r] || [])[f] : e[n[f] + d];
      if (h == null) u = "";
      else if (h.v != null) {
        l = !1, u = "" + (o.rawNumbers && h.t == "n" ? h.v : Ul(h, null, o));
        for (var p = 0, m = 0; p !== u.length; ++p) if ((m = u.charCodeAt(p)) === a || m === s || m === 34 || o.forceQuotes) {
          u = '"' + u.replace(m4, '""') + '"';
          break;
        }
        u == "ID" && (u = '"ID"');
      } else h.f != null && !h.F ? (l = !1, u = "=" + h.f, u.indexOf(",") >= 0 && (u = '"' + u.replace(m4, '""') + '"')) : u = "";
      c.push(u);
    }
  return o.blankrows === !1 && l ? null : c.join(i);
}
function tO(e, t) {
  var r = [], n = t ?? {};
  if (e == null || e["!ref"] == null) return "";
  var a = vn(e["!ref"]), s = n.FS !== void 0 ? n.FS : ",", i = s.charCodeAt(0), o = n.RS !== void 0 ? n.RS : `
`, l = o.charCodeAt(0), c = new RegExp((s == "|" ? "\\|" : s) + "+$"), u = "", d = [];
  n.dense = Array.isArray(e);
  for (var f = n.skipHidden && e["!cols"] || [], h = n.skipHidden && e["!rows"] || [], p = a.s.c; p <= a.e.c; ++p) (f[p] || {}).hidden || (d[p] = Ya(p));
  for (var m = 0, g = a.s.r; g <= a.e.r; ++g)
    (h[g] || {}).hidden || (u = mGe(e, a, g, d, i, l, s, n), u != null && (n.strip && (u = u.replace(c, "")), (u || n.blankrows !== !1) && r.push((m++ ? o : "") + u)));
  return delete n.dense, r.join("");
}
function mW(e, t) {
  t || (t = {}), t.FS = "	", t.RS = `
`;
  var r = tO(e, t);
  return r;
}
function gGe(e) {
  var t = "", r, n = "";
  if (e == null || e["!ref"] == null) return [];
  var a = vn(e["!ref"]), s = "", i = [], o, l = [], c = Array.isArray(e);
  for (o = a.s.c; o <= a.e.c; ++o) i[o] = Ya(o);
  for (var u = a.s.r; u <= a.e.r; ++u)
    for (s = Ra(u), o = a.s.c; o <= a.e.c; ++o)
      if (t = i[o] + s, r = c ? (e[u] || [])[o] : e[t], n = "", r !== void 0) {
        if (r.F != null) {
          if (t = r.F, !r.f) continue;
          n = r.f, t.indexOf(":") == -1 && (t = t + ":" + t);
        }
        if (r.f != null) n = r.f;
        else {
          if (r.t == "z") continue;
          if (r.t == "n" && r.v != null) n = "" + r.v;
          else if (r.t == "b") n = r.v ? "TRUE" : "FALSE";
          else if (r.w !== void 0) n = "'" + r.w;
          else {
            if (r.v === void 0) continue;
            r.t == "s" ? n = "'" + r.v : n = "" + r.v;
          }
        }
        l[l.length] = t + "=" + n;
      }
  return l;
}
function gW(e, t, r) {
  var n = r || {}, a = +!n.skipHeader, s = e || {}, i = 0, o = 0;
  if (s && n.origin != null)
    if (typeof n.origin == "number") i = n.origin;
    else {
      var l = typeof n.origin == "string" ? ma(n.origin) : n.origin;
      i = l.r, o = l.c;
    }
  var c, u = { s: { c: 0, r: 0 }, e: { c: o, r: i + t.length - 1 + a } };
  if (s["!ref"]) {
    var d = vn(s["!ref"]);
    u.e.c = Math.max(u.e.c, d.e.c), u.e.r = Math.max(u.e.r, d.e.r), i == -1 && (i = d.e.r + 1, u.e.r = i + t.length - 1 + a);
  } else
    i == -1 && (i = 0, u.e.r = t.length - 1 + a);
  var f = n.header || [], h = 0;
  t.forEach(function(m, g) {
    Ia(m).forEach(function(y) {
      (h = f.indexOf(y)) == -1 && (f[h = f.length] = y);
      var x = m[y], w = "z", _ = "", S = Zr({ c: o + h, r: i + g + a });
      c = bg(s, S), x && typeof x == "object" && !(x instanceof Date) ? s[S] = x : (typeof x == "number" ? w = "n" : typeof x == "boolean" ? w = "b" : typeof x == "string" ? w = "s" : x instanceof Date ? (w = "d", n.cellDates || (w = "n", x = _s(x)), _ = n.dateNF || Rn[14]) : x === null && n.nullError && (w = "e", x = 0), c ? (c.t = w, c.v = x, delete c.w, delete c.R, _ && (c.z = _)) : s[S] = c = { t: w, v: x }, _ && (c.z = _));
    });
  }), u.e.c = Math.max(u.e.c, o + f.length - 1);
  var p = Ra(i);
  if (a) for (h = 0; h < f.length; ++h) s[Ya(h + o) + p] = { t: "s", v: f[h] };
  return s["!ref"] = ea(u), s;
}
function vGe(e, t) {
  return gW(null, e, t);
}
function bg(e, t, r) {
  if (typeof t == "string") {
    if (Array.isArray(e)) {
      var n = ma(t);
      return e[n.r] || (e[n.r] = []), e[n.r][n.c] || (e[n.r][n.c] = { t: "z" });
    }
    return e[t] || (e[t] = { t: "z" });
  }
  return typeof t != "number" ? bg(e, Zr(t)) : bg(e, Zr({ r: t, c: r || 0 }));
}
function yGe(e, t) {
  if (typeof t == "number") {
    if (t >= 0 && e.SheetNames.length > t) return t;
    throw new Error("Cannot find sheet # " + t);
  } else if (typeof t == "string") {
    var r = e.SheetNames.indexOf(t);
    if (r > -1) return r;
    throw new Error("Cannot find sheet name |" + t + "|");
  } else throw new Error("Cannot find sheet |" + t + "|");
}
function bGe() {
  return { SheetNames: [], Sheets: {} };
}
function wGe(e, t, r, n) {
  var a = 1;
  if (!r)
    for (; a <= 65535 && e.SheetNames.indexOf(r = "Sheet" + a) != -1; ++a, r = void 0) ;
  if (!r || e.SheetNames.length >= 65535) throw new Error("Too many worksheets");
  if (n && e.SheetNames.indexOf(r) >= 0) {
    var s = r.match(/(^.*?)(\d+)$/);
    a = s && +s[2] || 0;
    var i = s && s[1] || r;
    for (++a; a <= 65535 && e.SheetNames.indexOf(r = i + a) != -1; ++a) ;
  }
  if (sW(r), e.SheetNames.indexOf(r) >= 0) throw new Error("Worksheet with name |" + r + "| already exists!");
  return e.SheetNames.push(r), e.Sheets[r] = t, r;
}
function xGe(e, t, r) {
  e.Workbook || (e.Workbook = {}), e.Workbook.Sheets || (e.Workbook.Sheets = []);
  var n = yGe(e, t);
  switch (e.Workbook.Sheets[n] || (e.Workbook.Sheets[n] = {}), r) {
    case 0:
    case 1:
    case 2:
      break;
    default:
      throw new Error("Bad sheet visibility setting " + r);
  }
  e.Workbook.Sheets[n].Hidden = r;
}
function _Ge(e, t) {
  return e.z = t, e;
}
function vW(e, t, r) {
  return t ? (e.l = { Target: t }, r && (e.l.Tooltip = r)) : delete e.l, e;
}
function SGe(e, t, r) {
  return vW(e, "#" + t, r);
}
function EGe(e, t, r) {
  e.c || (e.c = []), e.c.push({ t, a: r || "SheetJS" });
}
function TGe(e, t, r, n) {
  for (var a = typeof t != "string" ? t : vn(t), s = typeof t == "string" ? t : ea(t), i = a.s.r; i <= a.e.r; ++i) for (var o = a.s.c; o <= a.e.c; ++o) {
    var l = bg(e, i, o);
    l.t = "n", l.F = s, delete l.v, i == a.s.r && o == a.s.c && (l.f = r, n && (l.D = !0));
  }
  return e;
}
var RS = {
  encode_col: Ya,
  encode_row: Ra,
  encode_cell: Zr,
  encode_range: ea,
  decode_col: W2,
  decode_row: H2,
  split_cell: VHe,
  decode_cell: ma,
  decode_range: qs,
  format_cell: Ul,
  sheet_add_aoa: v9,
  sheet_add_json: gW,
  sheet_add_dom: uW,
  aoa_to_sheet: Yh,
  json_to_sheet: vGe,
  table_to_sheet: dW,
  table_to_book: Xqe,
  sheet_to_csv: tO,
  sheet_to_txt: mW,
  sheet_to_json: hw,
  sheet_to_html: cW,
  sheet_to_formulae: gGe,
  sheet_to_row_object_array: hw,
  sheet_get_cell: bg,
  book_new: bGe,
  book_append_sheet: wGe,
  book_set_sheet_visibility: xGe,
  cell_set_number_format: _Ge,
  cell_set_hyperlink: vW,
  cell_set_internal_link: SGe,
  cell_add_comment: EGe,
  sheet_set_array_formula: TGe,
  consts: {
    SHEET_VISIBLE: 0,
    SHEET_HIDDEN: 1,
    SHEET_VERY_HIDDEN: 2
  }
};
const g4 = new ed();
function rO(e, t, r, n = _n.ASC, a = !0, s) {
  const { success: i, error: o } = Da(), [l, c] = Me(null), { handleError: u } = zc(), [d, f] = Me([]), [h, p] = Me(!1), [m, g] = Me(1), [y, x] = Me(0), [w, _] = Me(10), [S, C] = Me(
    r
  ), [E, O] = Me(n), [k, A] = Me(null), [P, D] = Me(!1), [N, z] = Me(""), [G, Y] = Me(0), te = tr(null), ae = tr(!1), [ne, ue] = Me({}), q = Ft(
    async (he = !1) => {
      if (h || !e.getAll || !he && G > 3)
        return;
      const Ee = {
        offset: (m - 1) * w,
        limit: w,
        sort: S == null ? void 0 : S.toString(),
        dir: E,
        search: N || void 0,
        ...Object.keys(ne).length > 0 && {
          filters: Object.entries(ne).filter(([Pe, rt]) => rt != null).map(([Pe, rt]) => `${Pe}=${encodeURIComponent(rt)}`).join("&")
        }
      }, we = JSON.stringify(Ee);
      if (!(!he && te.current && JSON.stringify(te.current) === we)) {
        p(!0), te.current = Ee, c(null);
        try {
          const Pe = await e.getAll(Ee);
          ae.current && (t && (f(t.extractItems(Pe.data)), x(Pe.pagination.total)), te.current = Ee, Y(0));
        } catch (Pe) {
          ae.current && (c(g4.adaptError(Pe)), !he && Y((rt) => rt + 1));
        } finally {
          ae.current && p(!1);
        }
      }
    },
    [
      m,
      w,
      S,
      E,
      N,
      ne,
      e.getAll,
      t,
      h,
      G
    ]
  );
  wt(() => (ae.current = !0, a && q(), () => {
    ae.current = !1;
  }), [q, a]);
  const U = Ft((he) => {
    ue(he), g(1);
  }, []), Q = Ft((he) => {
    g(he);
  }, []), L = Ft((he) => {
    _(he), g(1);
  }, []), j = Ft(
    (he, Ee) => {
      C(he), O(Ee);
    },
    []
  ), K = Ft((he) => {
    z(he), g(1);
  }, []), J = Ft((he) => {
    const Ee = g4.adaptError(he);
    return c(Ee), Ee;
  }, []), re = Ft(
    async (he) => {
      if (!e.create)
        return { data: null, success: !1 };
      p(!0), c(null);
      try {
        return { data: await e.create(he), success: !0 };
      } catch (Ee) {
        throw J(Ee), o(
          JSON.stringify(typeof Ee == "string" ? Ee : Ee.message)
        ), Ee;
      } finally {
        p(!1);
      }
    },
    [e.create]
  ), le = Ft(
    async (he, Ee) => {
      if (!e.update) return null;
      try {
        const we = await e.update(he, Ee);
        return await q(), we;
      } catch (we) {
        throw J(we), o(
          JSON.stringify(typeof we == "string" ? we : we.message)
        ), we;
      }
    },
    [e, q, o]
  ), pe = Ft(
    async (he) => {
      if (!e.delete)
        return { data: null, success: !1 };
      p(!0), c(null);
      try {
        return f((Ee) => Ee.filter((we) => we.id !== he)), await e.delete(he), x((Ee) => Ee - 1), { data: null, success: !0 };
      } catch (Ee) {
        return await q(!0), { data: null, error: J(Ee), success: !1 };
      } finally {
        p(!1);
      }
    },
    [e.delete, q]
  ), me = Ft(() => {
    D(!1), A(null);
  }, []), Oe = Ft(
    async (he, Ee) => {
      p(!0), c(null);
      try {
        Ee !== void 0 && e.update ? await e.update(Ee, he) : e.create && await e.create(he), me(), q();
      } catch (we) {
        J("Failed to save item"), console.error(we);
      } finally {
        p(!1);
      }
    },
    [e, me, q]
  ), ee = Ft(async () => {
    if (!(!e.getAll || !(s != null && s.exportConfig))) {
      p(!0);
      try {
        const he = await e.getAll({ limit: 999999, offset: 0 }), Ee = t.extractItems(he.data);
        if (!Ee.length) return;
        const { exportConfig: we } = s, Pe = Ee.map((oe) => {
          const ve = {};
          return we.columns.forEach((ye) => {
            const Te = ye.accessor ? ye.accessor(oe) : typeof ye.key == "string" ? ye.key.split(".").reduce((_e, Ae) => _e == null ? void 0 : _e[Ae], oe) : oe[ye.key];
            ve[ye.label] = Te;
          }), ve;
        }), rt = RS.json_to_sheet(Pe), ht = RS.book_new();
        RS.book_append_sheet(ht, rt, "Sheet1");
        const bt = pW(ht, {
          bookType: "xlsx",
          type: "array"
        }), Ge = we.filename || `${s.name}-export.xlsx`;
        F8e.saveAs(
          new Blob([bt], { type: "application/octet-stream" }),
          Ge
        );
      } catch (he) {
        J(he);
      } finally {
        p(!1);
      }
    }
  }, [e.getAll, s, t]);
  return {
    items: d,
    isLoading: h,
    error: l,
    currentPage: m,
    totalItems: y,
    itemsPerPage: w,
    sortColumn: S,
    sortDirection: E,
    selectedItem: k,
    isModalOpen: P,
    searchTerm: N,
    activeFilters: ne,
    handleFilterChange: U,
    fetchItems: q,
    handleSort: j,
    handlePageChange: Q,
    handleItemsPerPageChange: L,
    handleCreate: re,
    handleEdit: le,
    handleDelete: pe,
    handleModalClose: me,
    handleSubmit: Oe,
    handleSearch: K,
    handleExport: ee
  };
}
const CGe = ({ isOpen: e, onClose: t, onConfirm: r, entityName: n, isLoading: a }) => {
  const { t: s } = _t(["common"]);
  return /* @__PURE__ */ v.jsx(
    Fh,
    {
      isOpen: e,
      onClose: t,
      title: s("delete.title"),
      isLoading: a,
      footer: ({ isLoading: i }) => /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx(qe, { variant: "ghost", onClick: t, disabled: i, children: s("cancel") }),
        /* @__PURE__ */ v.jsx(
          qe,
          {
            variant: "solid",
            color: "danger",
            onClick: r,
            isLoading: i,
            children: s("delete.confirm")
          }
        )
      ] }),
      children: /* @__PURE__ */ v.jsx("p", { children: s("delete.message") })
    }
  );
};
function kGe({
  isOpen: e,
  onClose: t,
  item: r,
  config: n
}) {
  var u, d;
  const [a, s] = Me({}), [i, o] = Me(((d = (u = n.tabs) == null ? void 0 : u[0]) == null ? void 0 : d.id) || ""), [l, c] = Me(
    {}
  );
  return wt(() => {
    const f = n.kpis;
    if (!f) return;
    (async () => {
      try {
        if ("batchFetch" in f && f.batchFetch) {
          const { values: p, statuses: m } = await f.batchFetch(r);
          c(p), m && s(m);
        } else if ("items" in f) {
          const p = {}, m = {};
          for (const g of f.items) {
            const y = g.valueKey.split(".").reduce((x, w) => x == null ? void 0 : x[w], r);
            if (p[g.id] = y ?? "-", g.statusKey) {
              const x = g.statusKey.split(".").reduce((w, _) => w == null ? void 0 : w[_], r);
              m[g.id] = x ?? "success";
            }
          }
          c(p), s(m);
        }
      } catch (p) {
        console.error("Error fetching KPI data:", p);
      }
    })();
  }, [n.kpis, r]), /* @__PURE__ */ v.jsxs(
    Fh,
    {
      isOpen: e,
      onClose: t,
      title: typeof n.title == "function" ? n.title(r) : n.title,
      size: n.size,
      children: [
        n.statusTags && /* @__PURE__ */ v.jsx("div", { className: "flex gap-2 items-center justify-end mb-4", children: n.statusTags.map((f) => {
          var p, m;
          const h = f.valueKey.split(".").reduce((g, y) => g == null ? void 0 : g[y], r);
          return /* @__PURE__ */ v.jsx(
            an,
            {
              color: ((p = f.getColor) == null ? void 0 : p.call(f, h)) || "primary",
              variant: "solid",
              size: "md",
              children: ((m = f.getLabel) == null ? void 0 : m.call(f, h)) || h
            },
            f.id
          );
        }) }),
        n.kpis && /* @__PURE__ */ v.jsx("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4", children: n.kpis.items.map((f) => /* @__PURE__ */ v.jsxs(
          "div",
          {
            className: "bg-surface p-4 rounded-lg shadow-sm border border-border",
            children: [
              /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2 text-sm text-text-muted", children: [
                f.icon && /* @__PURE__ */ v.jsx(dt, { name: f.icon, className: `text-${f.color}` }),
                f.label
              ] }),
              /* @__PURE__ */ v.jsx("div", { className: "text-2xl font-semibold mt-1", children: l[f.id] ?? "-" })
            ]
          },
          f.id
        )) }),
        n.cards && /* @__PURE__ */ v.jsx("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4", children: n.cards.map((f) => {
          var h;
          return (h = f.isVisible) != null && h.call(f, r) ? /* @__PURE__ */ v.jsxs(
            "div",
            {
              className: "bg-surface p-4 rounded-lg shadow-sm border border-border",
              children: [
                /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2 text-sm text-text-muted mb-2", children: [
                  f.icon && /* @__PURE__ */ v.jsx(dt, { name: f.icon, className: `text-${f.color}` }),
                  f.title
                ] }),
                f.content(r)
              ]
            },
            f.id
          ) : null;
        }) }),
        n.actions && /* @__PURE__ */ v.jsx("div", { className: "flex gap-2 my-4", children: n.actions.map((f) => {
          var m, g;
          const h = ((m = f.isVisible) == null ? void 0 : m.call(f, r)) ?? !0, p = ((g = f.isDisabled) == null ? void 0 : g.call(f, r)) ?? !1;
          return h ? /* @__PURE__ */ v.jsxs(
            qe,
            {
              color: f.color,
              onClick: () => f.handler(r),
              disabled: p,
              children: [
                f.icon && /* @__PURE__ */ v.jsx(dt, { name: f.icon, className: "mr-2" }),
                f.label
              ]
            },
            f.id
          ) : null;
        }) }),
        n.tabs && /* @__PURE__ */ v.jsx(a$, { activeTab: i, onTabChange: o, children: n.tabs.map((f) => {
          var h, p, m;
          return /* @__PURE__ */ v.jsx(oT, { value: i, title: f.label, children: f.listConfig ? /* @__PURE__ */ v.jsx(
            t1,
            {
              entityName: f.listConfig.entityName,
              useEntityConfig: () => {
                var y;
                const g = (y = f.listConfig) == null ? void 0 : y.getConfig(r);
                if (!g) throw new Error("Failed to get list config");
                return g;
              },
              parentItem: ((p = (h = f.listConfig).parentItemAccessor) == null ? void 0 : p.call(h, r)) || r,
              parentGetItems: f.listConfig.getConfig(r).crudMethods.getAll,
              onRefresh: () => {
                var y;
                const g = (y = f.listConfig) == null ? void 0 : y.getConfig(r);
                g != null && g.crudMethods.getAll && g.crudMethods.getAll({
                  offset: 0,
                  limit: 10
                });
              }
            }
          ) : (m = f.content) == null ? void 0 : m.call(f, r) }, f.id);
        }) })
      ]
    }
  );
}
const OGe = ({
  isOpen: e,
  onClose: t,
  filters: r,
  activeFilters: n,
  onApplyFilters: a
}) => {
  const { t: s } = _t(["common"]), [i, o] = M.useState(n);
  wt(() => {
    o(n);
  }, [n]);
  const l = (d, f) => {
    o((h) => ({
      ...h,
      [d]: f
    }));
  }, c = () => {
    a(i), t();
  }, u = () => {
    const d = r.defaultFilters || {};
    o(d), a(d), t();
  };
  return /* @__PURE__ */ v.jsx(
    Fh,
    {
      isOpen: e,
      onClose: t,
      title: s("common.filters"),
      size: "md",
      footer: /* @__PURE__ */ v.jsxs("div", { className: "flex justify-end space-x-2", children: [
        /* @__PURE__ */ v.jsx(qe, { variant: "outline", color: "gray", onClick: u, children: s("common.reset") }),
        /* @__PURE__ */ v.jsx(qe, { variant: "solid", color: "primary", onClick: c, children: s("common.apply") })
      ] }),
      children: /* @__PURE__ */ v.jsx("div", { className: "space-y-4", children: r.config.map((d) => /* @__PURE__ */ v.jsxs("div", { className: "space-y-2", children: [
        /* @__PURE__ */ v.jsx("label", { className: "block text-sm font-medium text-gray-700", children: d.label }),
        /* @__PURE__ */ v.jsx(
          ss,
          {
            options: d.options || [],
            value: i[String(d.field)],
            onChange: (f) => l(String(d.field), f),
            isClearable: !0,
            placeholder: s("common.select")
          }
        )
      ] }, String(d.field))) })
    }
  );
};
function t1({
  entityName: e,
  useEntityConfig: t,
  defaultViewMode: r,
  showViewModeSwitch: n,
  generateRoutes: a,
  listTitleKey: s,
  parentItem: i,
  parentGetItems: o,
  showTitle: l = !0,
  onRefresh: c
}) {
  var Ge, oe, ve, ye;
  const { t: u } = _t(["common", e]), d = ta(), f = t(), { entityConfig: h, crudMethods: p, responseExtractor: m } = f, [g, y] = Me(
    r || ((Ge = h.viewMode) == null ? void 0 : Ge.defaultMode) || OJ.TABLE
  ), [x, w] = Me(null), {
    items: _,
    isLoading: S,
    error: C,
    currentPage: E,
    totalItems: O,
    itemsPerPage: k,
    sortColumn: A,
    sortDirection: P,
    searchTerm: D,
    activeFilters: N,
    handleFilterChange: z,
    fetchItems: G,
    handleSort: Y,
    handlePageChange: te,
    handleItemsPerPageChange: ae,
    handleDelete: ne,
    handleSearch: ue,
    handleExport: q
  } = rO(
    o ? {
      getAll: async (Te) => {
        try {
          return await o(i, Te);
        } catch (_e) {
          throw console.error("Error fetching items:", _e), _e;
        }
      }
    } : p,
    m,
    h.tableConfig.defaultSortColumn,
    h.tableConfig.defaultSortDirection,
    !0,
    h
  );
  wt(() => {
    const Te = (_e) => {
      _e.detail.entityName === e && G(!0);
    };
    return window.addEventListener(
      "refresh-entity-table",
      Te
    ), () => {
      window.removeEventListener(
        "refresh-entity-table",
        Te
      );
    };
  }, [e, G]);
  const [U, Q] = Me(null), [L, j] = Me(!1), [K, J] = Me(null), [re, le] = Me(!1), [pe, me] = Me(!1), Oe = Ft((Te) => {
    w(Te);
  }, []), ee = () => {
    d(`/${e}/create`);
  }, he = (Te, _e) => {
    var Ae;
    _e == null || _e.preventDefault(), _e == null || _e.stopPropagation(), (Ae = h.viewConfig) != null && Ae.useCustomView ? d(h.viewConfig.getViewPath(Te)) : w(Te);
  }, Ee = (Te) => {
    d(`/${e}/${Te.id}/edit`);
  }, we = (Te) => {
    J(Te), j(!0);
  }, Pe = async () => {
    if (!(!K || !ne)) {
      le(!0);
      try {
        await ne(K), j(!1);
      } finally {
        le(!1), J(null);
      }
    }
  }, rt = () => {
    Q(null);
  }, ht = Ft(() => {
    G(!0);
  }, [G]), bt = Tn(
    () => ({
      filter: h.filters ? {
        enabled: !0,
        handler: () => me(!0),
        activeFilters: Object.keys(N).length,
        permissions: () => !0
      } : void 0,
      export: h.exportConfig ? {
        enabled: !0,
        handler: q,
        permissions: () => !0
      } : void 0
    }),
    [
      h.filters,
      h.exportConfig,
      N,
      q
    ]
  );
  return /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col min-h-0 h-full space-y-6", children: [
    l && /* @__PURE__ */ v.jsx(
      yv,
      {
        title: u(s || `${e}:${e}.crud.list.title`),
        onAddClick: a != null && a.create ? ee : void 0,
        actions: bt
      }
    ),
    /* @__PURE__ */ v.jsx(
      fFe,
      {
        entityConfig: h,
        items: Array.isArray(_) ? _ : [],
        isLoading: S,
        error: C,
        currentPage: E,
        totalItems: O,
        itemsPerPage: k,
        sortColumn: A,
        sortDirection: P,
        onSort: Y,
        onPageChange: te,
        onItemsPerPageChange: ae,
        onViewClick: Oe,
        onRowClick: he,
        onEditClick: a != null && a.update && p.update ? Ee : void 0,
        onDeleteClick: p.delete ? we : void 0,
        onSearch: ue,
        searchTerm: D,
        viewMode: g,
        onViewModeChange: y,
        showViewModeSwitch: n ?? ((oe = h.viewMode) == null ? void 0 : oe.showViewModeSwitch),
        renderCard: h.cardRenderer || (() => null),
        onRetry: ht,
        onRefresh: c,
        crudMethods: p
      }
    ),
    x && h.viewModalConfig && /* @__PURE__ */ v.jsx(
      kGe,
      {
        isOpen: !!x,
        onClose: () => w(null),
        item: x,
        config: h.viewModalConfig
      }
    ),
    U && h.viewPanelConfig && /* @__PURE__ */ v.jsx(
      hFe,
      {
        item: U,
        onClose: rt,
        title: ((ye = (ve = h.viewPanelConfig).getTitle) == null ? void 0 : ye.call(ve, U)) || "",
        onEdit: () => Ee(U),
        fields: h.viewPanelConfig.fields(!1),
        statusSection: h.statusConfig,
        additionalActions: h.viewPanelConfig.additionalActions
      }
    ),
    /* @__PURE__ */ v.jsx(
      OGe,
      {
        isOpen: pe,
        onClose: () => me(!1),
        filters: h.filters || { config: [], defaultFilters: {} },
        activeFilters: N,
        onApplyFilters: z
      }
    ),
    /* @__PURE__ */ v.jsx(
      CGe,
      {
        isOpen: L,
        onClose: () => j(!1),
        onConfirm: Pe,
        entityName: e,
        isLoading: re
      }
    )
  ] });
}
function yW({
  statusSection: e,
  formActions: t
}) {
  return /* @__PURE__ */ v.jsxs("div", { className: "space-y-6", children: [
    e && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx("h3", { className: "text-lg font-semibold text-gray-800 dark:text-gray-200", children: e.title }),
      /* @__PURE__ */ v.jsx(
        Qk,
        {
          statusSection: e,
          item: e.item
        }
      )
    ] }),
    t && /* @__PURE__ */ v.jsx("div", { className: "mt-6", children: t })
  ] });
}
function AGe({
  entityName: e,
  useEntityConfig: t
}) {
  const { t: r } = _t(["common", e]), n = ta(), { success: a, error: s } = Da(), { entityConfig: i, crudMethods: o, responseExtractor: l } = t(), [c, u] = Me(null), d = new ed(), { isLoading: f, error: h, handleCreate: p } = rO(
    o,
    l,
    i.tableConfig.defaultSortColumn,
    i.tableConfig.defaultSortDirection,
    !1
  ), m = async (y) => {
    try {
      if (await p(y))
        return a(r(`${e}:${e}.crud.create.success`)), n(`/${e}`), !0;
    } catch (x) {
      const w = d.adaptError(x);
      return u(w), !1;
    }
    return !1;
  }, g = () => {
    n(`/${e}`);
  };
  return f && !p ? /* @__PURE__ */ v.jsx(la, { container: "full" }) : /* @__PURE__ */ v.jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ v.jsx(
      qe,
      {
        onClick: () => n(-1),
        variant: "link",
        color: "primary",
        size: "sm",
        icon: "chevron-left",
        iconPosition: "left",
        children: r("common.back")
      }
    ),
    /* @__PURE__ */ v.jsx(yv, { title: r(`${e}:${e}.crud.create.title`) }),
    /* @__PURE__ */ v.jsx(
      Xk,
      {
        sections: i.formSections,
        validationSchema: i.validationSchema.create,
        onSubmit: m,
        onCancel: g,
        error: c || h,
        layout: { type: "grid", className: "grid-cols-12 gap-4" },
        formLayout: i.formLayout,
        draftConfig: i.draftConfig,
        formConfig: i.formConfig,
        sidebarContent: i.statusConfig ? /* @__PURE__ */ v.jsx(yW, { statusSection: i.statusConfig }) : null
      }
    )
  ] });
}
function PGe({
  entityName: e,
  useEntityConfig: t
}) {
  const { t: r } = _t(["common", e]), n = ta(), { success: a, error: s } = Da(), { id: i } = B4(), { entityConfig: o, crudMethods: l, responseExtractor: c } = t(), [u, d] = Me(null), [f, h] = Me(null), p = new ed(), { isLoading: m, error: g, handleEdit: y } = rO(
    l,
    c,
    o.tableConfig.defaultSortColumn,
    o.tableConfig.defaultSortDirection,
    !1
  );
  wt(() => {
    i && !u && (async () => {
      if (i && l.getOne)
        try {
          const S = await l.getOne(i);
          d(S);
        } catch (S) {
          console.error(`Failed to fetch ${e}:`, S);
        }
    })();
  }, [i, l.getOne, e, u]);
  const x = async (_) => {
    if (i)
      try {
        if (await y(i, _))
          return a(r(`${e}:${e}.crud.update.success`)), n(`/${e}`), !0;
      } catch (S) {
        return h(p.adaptError(S)), !1;
      }
    return !1;
  }, w = () => {
    n(`/${e}`);
  };
  return m && !y || !u && i ? /* @__PURE__ */ v.jsx(la, { container: "full" }) : /* @__PURE__ */ v.jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ v.jsx(
      qe,
      {
        onClick: () => n(-1),
        variant: "link",
        color: "primary",
        size: "sm",
        icon: "chevron-left",
        iconPosition: "left",
        children: r("common.back")
      }
    ),
    /* @__PURE__ */ v.jsx(yv, { title: r(`${e}:${e}.crud.update.title`) }),
    /* @__PURE__ */ v.jsx(
      Xk,
      {
        sections: o.formSections,
        validationSchema: o.validationSchema.update,
        onSubmit: x,
        onCancel: w,
        error: f || g,
        defaultValues: u,
        layout: { type: "grid" },
        formLayout: o.formLayout,
        draftConfig: o.draftConfig,
        formConfig: o.formConfig,
        sidebarContent: o.statusConfig ? /* @__PURE__ */ v.jsx(
          yW,
          {
            statusSection: {
              ...o.statusConfig,
              item: u
            }
          }
        ) : null
      }
    )
  ] });
}
function bW() {
  const { t: e } = _t(["auth"]);
  return /* @__PURE__ */ v.jsx("div", { className: "hidden xl:block w-1/3 bg-black-700 relative", children: /* @__PURE__ */ v.jsx("div", { className: "absolute inset-0", children: /* @__PURE__ */ v.jsx(
    fi,
    {
      src: "/images/background.jpeg",
      alt: "Background",
      className: "w-full h-full object-cover",
      fullHeight: !0
    }
  ) }) });
}
function RGe({ children: e }) {
  return /* @__PURE__ */ v.jsxs("div", { className: "min-h-screen flex", children: [
    /* @__PURE__ */ v.jsx("div", { className: "flex-grow flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-background", children: /* @__PURE__ */ v.jsxs("div", { className: "w-full max-w-md space-y-8", children: [
      /* @__PURE__ */ v.jsx("div", { className: "xl:hidden flex justify-center mb-6", children: /* @__PURE__ */ v.jsx(Jk, { type: "client", className: "w-40 h-16 max-h-32" }) }),
      e
    ] }) }),
    /* @__PURE__ */ v.jsx(bW, {})
  ] });
}
const Zet = ({ appName: e }) => /* @__PURE__ */ v.jsx("header", { className: "bg-white dark:bg-surface z-10", children: /* @__PURE__ */ v.jsxs("div", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16", children: [
  /* @__PURE__ */ v.jsx("h1", { className: "text-2xl font-semibold text-text", children: e }),
  /* @__PURE__ */ v.jsxs("div", { className: "flex items-center space-x-4", children: [
    /* @__PURE__ */ v.jsx(dt, { name: "bell", size: "lg", color: "gray-500" }),
    /* @__PURE__ */ v.jsx("div", { className: "w-8 h-8 rounded-full bg-gray-300" })
  ] })
] }) });
function IGe() {
  return { canAccess: (t, r) => {
    if (t.public) return !0;
    if (!r) return !1;
    if (!t.access) return !0;
    const { roles: n = [], permissions: a = [], features: s = [] } = t.access;
    return (!n.length || n.some((i) => {
      var o;
      return (o = r.roles) == null ? void 0 : o.includes(i);
    })) && (!a.length || a.some((i) => {
      var o;
      return (o = r.permissions) == null ? void 0 : o.includes(i);
    })) && (!s.length || s.every((i) => {
      var o;
      return (o = r.features) == null ? void 0 : o.includes(i);
    }));
  } };
}
const DGe = ({
  children: e,
  config: t
}) => {
  const { user: r, isOnboardingEnabled: n, logout: a } = As(), { canAccess: s } = IGe(), i = ww();
  if (!r)
    return /* @__PURE__ */ v.jsx(hc, { to: "/auth/login", state: { from: i }, replace: !0 });
  if (!r.isActive)
    if (n) {
      if (i.pathname !== "/onboarding")
        return /* @__PURE__ */ v.jsx(hc, { to: "/onboarding", state: { from: i }, replace: !0 });
    } else
      return a(), /* @__PURE__ */ v.jsx(hc, { to: "/auth/login", state: { from: i }, replace: !0 });
  return s(t, r) ? /* @__PURE__ */ v.jsx(v.Fragment, { children: e }) : /* @__PURE__ */ v.jsx(hc, { to: "/403", replace: !0 });
}, IS = /* @__PURE__ */ new Map();
function wW(e) {
  const t = JSON.stringify(e);
  if (IS.has(t))
    return IS.get(t);
  const r = e.reduce((n, a) => (n.push(a), a.children && n.push(
    ...wW(
      a.children.map((s) => ({
        ...s,
        path: `${a.path}/${s.path}`.replace(/\/+/g, "/")
      }))
    )
  ), n), []);
  return IS.set(t, r), r;
}
function NGe(e, t) {
  return e.filter((r) => {
    const n = t(r);
    return r.children && (r.children = NGe(r.children, t)), n;
  });
}
function MGe(e) {
  const t = e.filter((n) => n.public), r = e.filter((n) => !n.public);
  return { publicRoutes: t, protectedRoutes: r };
}
const LGe = [
  {
    path: "/auth/login",
    component: l$e,
    label: "Login",
    translationKey: "nav.login",
    icon: "login",
    showInNav: !1,
    public: !0
  },
  {
    path: "/auth/register",
    component: u$e,
    label: "Register",
    translationKey: "nav.register",
    icon: "register",
    showInNav: !1,
    public: !0
  },
  {
    path: "/auth/forgot-password",
    component: o$e,
    label: "Forgot Password",
    translationKey: "nav.forgotPassword",
    icon: "password",
    showInNav: !1,
    public: !0
  },
  {
    path: "/auth/reset-password",
    component: d$e,
    label: "Reset Password",
    translationKey: "nav.resetPassword",
    icon: "password",
    showInNav: !1,
    public: !0
  },
  {
    path: "/auth/verify-email",
    component: f$e,
    label: "Verify Email",
    translationKey: "nav.verifyEmail",
    icon: "email",
    showInNav: !1,
    public: !0
  }
], jGe = ["list", "create", "update"];
function sf(e, t = {}) {
  const r = t.listPath || `/${e}`, n = [];
  return jGe.forEach((a) => {
    var s;
    (s = t.generateRoutes) != null && s[a] && n.push({
      path: BGe(e, a, r),
      component: FGe(e, a, t),
      label: UGe(e, a),
      translationKey: a === "list" ? t.translationKey || `nav.${e}` : `nav.${a}${e.charAt(0).toUpperCase() + e.slice(1)}`,
      icon: a === "list" ? t.icon || "folder" : a === "create" ? "plus" : "edit",
      showInNav: a === "list" ? t.showInNav ?? !0 : !1,
      entityName: e,
      access: t.access,
      defaultViewMode: t.defaultViewMode,
      showViewModeSwitch: t.showViewModeSwitch
    });
  }), n;
}
function FGe(e, t, r = {}) {
  return () => {
    const n = bQ()[e];
    if (!n)
      throw new Error(`No config found for entity: ${e}`);
    return _a(t === "list" ? t1 : t === "create" ? AGe : PGe, {
      entityName: e,
      useEntityConfig: n,
      defaultViewMode: r.defaultViewMode,
      showViewModeSwitch: r.showViewModeSwitch,
      generateRoutes: r.generateRoutes,
      listTitleKey: r.listTitleKey
    });
  };
}
function BGe(e, t, r) {
  switch (t) {
    case "list":
      return r;
    case "create":
      return `${r}/create`;
    case "update":
      return `${r}/:id/edit`;
  }
}
function UGe(e, t) {
  switch (t) {
    case "list":
      return e;
    case "create":
      return `Create ${e}`;
    case "update":
      return `Edit ${e}`;
  }
}
const VGe = () => {
  var d, f, h, p;
  const { t: e } = _t(["common", "support"]), { data: t, loading: r, updateData: n } = Wx({
    includeAdminConfig: !0
  }), a = sn(), s = Da(), [i, o] = Me(!1);
  if (r) return /* @__PURE__ */ v.jsx(la, { container: "full" });
  const l = async (m) => {
    var g, y, x, w;
    try {
      o(!0);
      const _ = await a.adminApi.config();
      await a.adminApi.updateConfig({
        updateConfig: [
          {
            email: {
              sendgrid: {
                src: ((y = (g = _.email) == null ? void 0 : g.sendgrid) == null ? void 0 : y.src) || "",
                dst: m.email,
                subject_prefix: (w = (x = _.email) == null ? void 0 : x.sendgrid) == null ? void 0 : w.subject_prefix
              }
            }
          }
        ]
      }), s.success(e("support:support.contact.emailUpdateSuccess")), await n("contact", { email: m.email });
    } catch (_) {
      console.error("Email update error:", _), s.error(e("support:support.contact.emailUpdateError"));
    } finally {
      o(!1);
    }
  }, c = [
    {
      title: e("support:support.contact.title"),
      fields: [
        {
          name: "email",
          type: "text",
          label: e("support:support.contact.email"),
          layout: { className: "col-span-12" }
        }
      ]
    }
  ], u = [
    {
      title: e("support:support.faq.title"),
      fields: [
        {
          name: "faq",
          label: e("support:support.faq.items"),
          type: "advancedDynamicList",
          fields: [
            {
              name: "title",
              type: "select",
              label: e("common:common.title"),
              layout: { className: "col-span-12 md:col-span-6" },
              selectProps: {
                options: [],
                isClearable: !0,
                isCreatable: !0,
                formatCreateLabel: (m) => `Create "${m}"`
              }
            },
            {
              name: "description",
              type: "text",
              label: e("common:common.description"),
              layout: { className: "col-span-12 md:col-span-6" },
              placeholder: e("common:common.descriptionPlaceholder")
            }
          ],
          layout: { className: "col-span-12" }
        }
      ]
    },
    {
      title: e("support:support.contact.title"),
      fields: [
        {
          name: "link",
          type: "text",
          label: e("support:support.contact.link"),
          layout: { className: "col-span-6" }
        },
        {
          name: "registrationLink",
          type: "text",
          label: e("support:support.contact.registrationLink"),
          layout: { className: "col-span-6" }
        }
      ]
    },
    {
      title: e("support:support.dashboard.title"),
      fields: [
        {
          name: "topbanner_content",
          type: "advancedDynamicList",
          label: e("support:support.dashboard.topbanner"),
          maxItems: 1,
          fields: [
            {
              name: "color",
              type: "color",
              label: e("support:support.dashboard.color"),
              layout: { className: "col-span-12 md:col-span-4" }
            },
            {
              name: "icon",
              type: "select",
              label: e("support:support.dashboard.icon"),
              layout: { className: "col-span-12 md:col-span-4" },
              selectProps: {
                options: Object.keys(sE).map((m) => ({
                  value: m,
                  label: m
                }))
              }
            },
            {
              name: "route",
              type: "text",
              label: e("support:support.dashboard.route"),
              layout: { className: "col-span-12 md:col-span-4" }
            },
            {
              name: "content",
              type: "richText",
              label: e("support:support.dashboard.content"),
              layout: { className: "col-span-12" },
              richTextProps: {
                minHeight: "200px"
              }
            }
          ],
          layout: { className: "col-span-12" }
        }
      ]
    }
  ];
  return /* @__PURE__ */ v.jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ v.jsx("h1", { className: "text-3xl font-bold mb-6 text-text", children: e("support:support.title") }),
    /* @__PURE__ */ v.jsx(
      Uo,
      {
        formLayout: "single-page",
        sections: c,
        defaultValues: {
          email: ((d = t == null ? void 0 : t.contact) == null ? void 0 : d.email) || ""
        },
        onSubmit: l
      }
    ),
    /* @__PURE__ */ v.jsx(
      Uo,
      {
        formLayout: "single-page",
        layout: { type: "grid", className: "grid-cols-12" },
        sections: u,
        defaultValues: {
          faq: (t == null ? void 0 : t.faq) || [],
          link: ((f = t == null ? void 0 : t.contact) == null ? void 0 : f.link) || "",
          registrationLink: ((h = t == null ? void 0 : t.contact) == null ? void 0 : h.registrationLink) || "",
          topbanner_content: ((p = t == null ? void 0 : t.dashboardInfo) == null ? void 0 : p.topbanner_content) || {
            color: "",
            icon: {
              label: "",
              value: ""
            },
            route: "",
            content: ""
          }
        },
        onSubmit: async (m) => {
          try {
            await n("contact", {
              link: m.link,
              registrationLink: m.registrationLink
            }), await n("faq", m.faq), await n("dashboard_info", {
              topbanner_content: m.topbanner_content
            }), s.success(e("support:support.updateSuccess"));
          } catch (g) {
            console.error("Form submission error:", g), s.error(e("support:support.updateError"));
          }
        }
      }
    )
  ] });
}, $Ge = () => {
  const { t: e } = _t(["common", "support"]), { data: t, loading: r } = Wx(), n = sn(), a = Da();
  if (r) return /* @__PURE__ */ v.jsx(la, { container: "full" });
  const s = (t == null ? void 0 : t.faq) && t.faq.length > 0, i = B.object({
    subject: B.string().min(1),
    message: B.string().min(10)
  }), o = [
    {
      title: e("support:support.contact.title"),
      fields: [
        {
          name: "subject",
          type: "text",
          label: e("support:support.contact.emailSubject")
        },
        {
          name: "message",
          type: "textarea",
          label: e("support:support.contact.message")
        }
      ]
    }
  ];
  return /* @__PURE__ */ v.jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ v.jsx("h1", { className: "text-3xl font-bold mb-6 text-text", children: e("support:support.title") }),
    s && /* @__PURE__ */ v.jsx(hr, { header: e("support:support.faq.title"), children: /* @__PURE__ */ v.jsx(MA, { children: t.faq.map((l) => /* @__PURE__ */ v.jsx(MA.Item, { title: l.title, children: /* @__PURE__ */ v.jsx("p", { className: "text-gray-600", children: l.description }) }, l.id)) }) }),
    /* @__PURE__ */ v.jsx(
      Uo,
      {
        formLayout: "single-page",
        sections: o,
        validationSchema: i,
        defaultValues: {
          subject: "",
          message: ""
        },
        onSubmit: async (l, c) => {
          try {
            await n.usersApi.sendEmail({
              sendEmailRequest: {
                subject: l.subject,
                content: l.message
              }
            }), a.success(e("support:support.contact.emailSentSuccess")), c.reset();
          } catch (u) {
            console.error("Failed to send contact email:", u), a.error(e("support:support.contact.emailSentError"));
          }
        }
      }
    )
  ] });
}, xW = (e) => {
  const t = sn();
  return {
    createOrder: e ? async (a) => {
      if (!(e != null && e.id)) throw new Error("Campaign not found");
      return await t.campaignsApi.createOrder({
        id: e.id,
        body: a
      });
    } : void 0,
    checkOrderStatus: async (a) => await t.ordersApi.order({ id: a, refresh: !0 }),
    availableBatches: (e == null ? void 0 : e.available) ?? 0
  };
}, nO = (e) => {
  const t = sn(), [r, n] = Me(
    null
  ), [a, s] = Me(!1), { createOrder: i, availableBatches: o } = xW(r), { setOrderModalData: l } = Lb(), { isKycVerified: c } = N2(), { showModal: u } = Xg(), { t: d } = _t(["projects"]);
  wt(() => {
    e && (typeof e == "number" ? (async () => {
      var m;
      s(!0);
      try {
        const y = (m = (await t.projectsApi.projectCampaignsPage({
          id: e,
          status: ["available"]
        })).results) == null ? void 0 : m[0];
        if (y) {
          const x = await t.projectsApi.project({
            id: y.project
          });
          n({
            ...y,
            project: x
          });
        } else
          n(null);
      } catch (g) {
        console.error("Error fetching campaign:", g);
      } finally {
        s(!1);
      }
    })() : n(e));
  }, [e]);
  const f = Ft(
    async (p) => {
      if (p == null || p.preventDefault(), p == null || p.stopPropagation(), !!r && c)
        try {
          l({
            type: "investment",
            campaignId: r.id ?? 0,
            order: null,
            projectName: r.project.name || d("projects.defaultName"),
            minBatches: r.info.minimal_batches || 1,
            maxBatches: o,
            pricePerBatch: r.project.price,
            onConfirm: async (m) => await (i == null ? void 0 : i(m))
          }), u("orderConfirmation");
        } catch (m) {
          console.error("Error handling invest:", m);
        }
    },
    [r, i, l, u, d, c]
  ), h = A8e(r) && c;
  return { handleInvest: f, isInvestmentEnabled: h, isLoading: a, campaign: r };
}, _W = ({
  campaign: e,
  onClick: t
}) => {
  var m, g, y, x, w, _, S, C, E, O, k;
  const { t: r } = _t(["projects"]), n = e.project, a = ((g = (m = n.files) == null ? void 0 : m.images) == null ? void 0 : g[0]) || "", s = (_ = (w = (x = (y = n.info) == null ? void 0 : y.attributes) == null ? void 0 : x.info) == null ? void 0 : w.kpis) == null ? void 0 : _.kpi_1, i = (O = (E = (C = (S = n.info) == null ? void 0 : S.attributes) == null ? void 0 : C.info) == null ? void 0 : E.kpis) == null ? void 0 : O.kpi_2, o = mE(e.info), { handleInvest: l, isInvestmentEnabled: c } = nO(e), u = () => {
    const { show: A, extraAmount: P } = e2(n.info);
    return A ? /* @__PURE__ */ v.jsx(
      Zk,
      {
        batches: e.info.batches || n.batches,
        frozen: e.frozen || 0,
        availableBatches: e.available,
        extraAmount: P,
        batchPrice: n.price || 0,
        progressBarProps: {
          size: "md",
          showLabel: !0,
          labelPosition: "end",
          color: "secondary",
          variant: "gradient"
        }
      }
    ) : null;
  }, d = (A) => {
    t && !A.defaultPrevented && t();
  }, f = KT(e), h = f.textKey === "campaigns.status.startsOn" && f.date ? r(f.textKey, {
    date: pE(f.date),
    // Use formatting utility
    ns: "campaigns"
    // Specify namespace
  }) : r(f.textKey, { ns: "campaigns" }), p = IJ(f.styleKey);
  return /* @__PURE__ */ v.jsx("div", { className: "py-1 h-full", children: /* @__PURE__ */ v.jsxs("div", { className: "bg-secondary-100 border border-secondary-200 rounded-xl overflow-hidden w-full h-full cursor-pointer transition-all duration-200 ease-in-out hover:shadow-sm hover:-translate-y-1 flex flex-col", children: [
    /* @__PURE__ */ v.jsxs("div", { onClick: d, className: "flex flex-col flex-grow", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "relative", children: [
        e.status && /* @__PURE__ */ v.jsx(
          "div",
          {
            className: `absolute top-4 left-4 z-10 px-3 py-1 rounded-md text-sm font-medium ${p}`,
            children: h
          }
        ),
        o && /* @__PURE__ */ v.jsx("div", { className: "absolute top-4 right-4 z-10 px-3 py-1 bg-gray-900 border-gray-500 border text-white rounded-md text-sm font-medium shadow-sm", children: r("projects.privateCampaign") }),
        /* @__PURE__ */ v.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ v.jsx("div", { className: "absolute inset-0 bg-black/10 z-[2]" }),
          /* @__PURE__ */ v.jsx(
            fi,
            {
              src: a,
              alt: n.name || r("projects.defaultName"),
              className: "w-full h-full object-cover",
              ratio: "aspect-[5/4]"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ v.jsxs("div", { className: "border-t border-border px-5 py-6 flex-grow flex flex-col", children: [
        /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center", children: [
          /* @__PURE__ */ v.jsx("h3", { className: "text-lg font-semibold text-text truncate flex-1 mr-2", children: n.name || r("projects.defaultName") }),
          /* @__PURE__ */ v.jsxs("span", { className: "text-sm font-medium text-text0 whitespace-nowrap", children: [
            n.price && n.batches ? /* @__PURE__ */ v.jsx(v.Fragment, { children: hs(n.price, {
              currency: "EUR",
              minimumFractionDigits: 0,
              maximumFractionDigits: 6,
              preserveDecimals: !0
            }) }) : null,
            ((k = n.location) == null ? void 0 : k.city) && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
              " • ",
              n.location.city
            ] })
          ] })
        ] }),
        /* @__PURE__ */ v.jsxs("div", { className: "mb-6", children: [
          /* @__PURE__ */ v.jsxs("p", { className: "text-sm font-medium text-text mb-1", children: [
            /* @__PURE__ */ v.jsxs("span", { className: "text-text0 mr-1", children: [
              r("projects.targetAmount"),
              " :"
            ] }),
            /* @__PURE__ */ v.jsx("span", { className: "font-bold", children: hs(n.price * n.batches || 0, {
              currency: "EUR",
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }) })
          ] }),
          /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsx("div", { children: u() }) })
        ] }),
        /* @__PURE__ */ v.jsxs("div", { className: "grid grid-cols-2 gap-3 mt-auto", children: [
          s && /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col space-y-2 border border-border bg-surface rounded-lg p-2", children: [
            /* @__PURE__ */ v.jsxs("div", { className: "flex items-center space-x-1 justify-start", children: [
              /* @__PURE__ */ v.jsx(dt, { name: "target", size: "sm", color: "text-text" }),
              /* @__PURE__ */ v.jsx("span", { className: "text-text text-xs truncate", children: s.title.label || "N/A" })
            ] }),
            /* @__PURE__ */ v.jsxs("div", { className: "font-semibold flex items-center justify-between text-text space-x-1", children: [
              /* @__PURE__ */ v.jsxs("div", { className: "flex items-baseline min-w-0", children: [
                /* @__PURE__ */ v.jsxs("span", { className: "text-lg font-medium whitespace-nowrap mr-1", children: [
                  s.value || "N/A",
                  s.operator || ""
                ] }),
                /* @__PURE__ */ v.jsx("span", { className: "text-xs truncate", children: s.description || "" })
              ] }),
              (s == null ? void 0 : s.tooltip) && /* @__PURE__ */ v.jsx(ni, { content: s.tooltip, variant: "dark", children: /* @__PURE__ */ v.jsx(
                dt,
                {
                  name: "question-mark",
                  size: "sm",
                  color: "text-secondary-800",
                  className: "cursor-help flex-shrink-0"
                }
              ) })
            ] })
          ] }),
          i && /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col space-y-2 border border-border bg-surface rounded-lg p-2", children: [
            /* @__PURE__ */ v.jsxs("div", { className: "flex items-center space-x-1 justify-start", children: [
              /* @__PURE__ */ v.jsx(
                dt,
                {
                  name: "arrow-rotate-left",
                  size: "sm",
                  color: "text-primary-800"
                }
              ),
              /* @__PURE__ */ v.jsx("span", { className: "text-text text-xs truncate", children: i.title.label || "N/A" })
            ] }),
            /* @__PURE__ */ v.jsxs("div", { className: "font-semibold flex items-center justify-between text-text space-x-1", children: [
              /* @__PURE__ */ v.jsxs("div", { children: [
                /* @__PURE__ */ v.jsxs("span", { className: "text-lg font-medium mr-1", children: [
                  i.value || "N/A",
                  i.operator || ""
                ] }),
                /* @__PURE__ */ v.jsx("span", { className: "text-xs", children: i.description || "" })
              ] }),
              (i == null ? void 0 : i.tooltip) && /* @__PURE__ */ v.jsx(ni, { content: i.tooltip, variant: "dark", children: /* @__PURE__ */ v.jsx(
                dt,
                {
                  name: "question-mark",
                  size: "sm",
                  color: "text-secondary-800",
                  className: "cursor-help flex-shrink-0"
                }
              ) })
            ] })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex items-center justify-between space-x-3 px-5 pb-4", children: [
      c && /* @__PURE__ */ v.jsx(
        qe,
        {
          variant: "solid",
          color: "primary",
          fullWidth: !0,
          onClick: (A) => {
            A.preventDefault(), l();
          },
          children: r("projects.invest")
        }
      ),
      /* @__PURE__ */ v.jsx(
        qe,
        {
          variant: "solid",
          color: "primary",
          fullWidth: !0,
          onClick: d,
          children: r("projects.access")
        }
      )
    ] })
  ] }) });
}, HGe = () => {
  const e = ta(), t = sn(), { t: r } = _t(["projects"]), { entityConfig: n, crudMethods: a, responseExtractor: s } = qT(), i = Tn(() => () => ({
    entityConfig: {
      ...n,
      cardRenderer: (l) => {
        var c;
        return (c = l.project) != null && c.id ? /* @__PURE__ */ v.jsx(
          _W,
          {
            campaign: l,
            onClick: () => e(`/projects/${l.project.id}/view`),
            variant: "marketplace"
          },
          l.project.id
        ) : null;
      },
      emptyStateRenderer: () => /* @__PURE__ */ v.jsx(
        dh,
        {
          icon: "grid",
          title: r("projects.marketplace.noProjects"),
          description: r("projects.marketplace.noProjectsDescription"),
          primaryAction: {
            label: r("projects.marketplace.checkBackLater"),
            onClick: () => e("/dashboard"),
            icon: "arrow-right"
          }
        }
      )
    },
    crudMethods: {
      ...a,
      getAll: async (l) => {
        let c = !1;
        try {
          const f = await t.usersApi.userInfo({});
          f && (c = lT(f));
        } catch (f) {
          console.error("Error fetching user info:", f);
        }
        const u = await t.campaignsApi.campaignsPage({
          ...l,
          status: [
            ns.Available,
            ns.Minted,
            ns.Closed,
            ns.Canceled
          ],
          // Only add _private: false filter if user is not qualified
          ...!c && { _private: !1 }
        });
        return {
          data: N7(u.results || []),
          pagination: {
            total: u.meta.total,
            offset: u.meta.offset,
            limit: u.meta.limit,
            currentPage: u.meta.current_page,
            totalPages: u.meta.total_pages
          }
        };
      }
    },
    responseExtractor: s
  }), [n, a, s, t, e, r]);
  return /* @__PURE__ */ v.jsx(
    t1,
    {
      entityName: "projects",
      listTitleKey: "crud.list.marketplace",
      useEntityConfig: i,
      defaultViewMode: "card",
      showViewModeSwitch: !1
    }
  );
}, WGe = ({
  user: e
}) => {
  const { t } = _t(["users"]), r = {
    title: t("users.status.title"),
    steps: [
      {
        label: t("users.status.initiated"),
        status: (n) => !n || n.status === zt.Uninitiated ? "pending" : "completed",
        description: t("users.status.initiatedDesc")
      },
      {
        label: t("users.status.kyc.title"),
        status: (n) => n ? n.status === zt.Kyced || n.status === zt.Active || n.status === zt.Blockchained ? "completed" : n.status === zt.Initiated ? "in_progress" : "pending" : "pending",
        description: (n) => n ? n.status === zt.Kyced || n.status === zt.Active || n.status === zt.Blockchained ? t("users.status.kyc.completed") : n.status === zt.Initiated ? t("users.status.kyc.pending") : t("users.status.kyc.not_started") : t("users.status.kyc.not_started")
      },
      {
        label: t("users.status.active"),
        status: (n) => n ? n.status === zt.Active || n.status === zt.Blockchained ? "completed" : n.status === zt.Kyced ? "in_progress" : "pending" : "pending",
        description: (n) => n ? n.status === zt.Active || n.status === zt.Blockchained ? t("users.status.activeDesc") : n.status === zt.Kyced ? t("users.status.kyc.completed") : t("users.status.kyc.not_started") : t("users.status.kyc.not_started")
      }
    ]
  };
  return /* @__PURE__ */ v.jsx(Qk, { statusSection: r, item: e });
}, zGe = () => {
  const { t: e } = _t(["profile"]), t = sn(), [r, n] = Me(null);
  if (wt(() => {
    (async () => {
      try {
        const o = await t.usersApi.userInfo({});
        n(o);
      } catch (o) {
        console.error("Error fetching user info:", o);
      }
    })();
  }, [t]), !r)
    return /* @__PURE__ */ v.jsx(la, { container: "full" });
  const a = () => {
    if (r.info.kind === "individual") {
      const i = r.info;
      return /* @__PURE__ */ v.jsxs("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-4", children: [
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.firstName"),
            value: i.first_name,
            readOnly: !0,
            disabled: !0
          }
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.lastName"),
            value: i.last_name,
            readOnly: !0,
            disabled: !0
          }
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.email"),
            value: r.auth.email,
            readOnly: !0,
            disabled: !0
          }
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.nationality"),
            value: i.nationality,
            readOnly: !0,
            disabled: !0
          }
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.birthDate"),
            value: i.birthday ? eh(new Date(i.birthday)) : "",
            readOnly: !0,
            disabled: !0
          }
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.birthCity"),
            value: i.birth_city,
            readOnly: !0,
            disabled: !0
          }
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.birthCountry"),
            value: i.birth_country,
            readOnly: !0,
            disabled: !0
          }
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.residenceCountry"),
            value: i.residence_country,
            readOnly: !0,
            disabled: !0
          }
        )
      ] });
    } else if (r.info.kind === "company") {
      const i = r.info;
      return /* @__PURE__ */ v.jsxs("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-4", children: [
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.companyName"),
            value: i.company_name,
            readOnly: !0,
            disabled: !0
          }
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.email"),
            value: r.auth.email,
            readOnly: !0,
            disabled: !0
          }
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.siren"),
            value: i.siren,
            readOnly: !0,
            disabled: !0
          }
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.country"),
            value: i.country,
            readOnly: !0,
            disabled: !0
          }
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.qualified"),
            value: i.qualified ? e("common:common.yes") : e("common:common.no"),
            readOnly: !0,
            disabled: !0
          }
        )
      ] });
    } else {
      const i = r.info;
      return /* @__PURE__ */ v.jsxs("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-4", children: [
        /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.companyName"),
            value: i.company_name,
            readOnly: !0
          }
        ),
        /* @__PURE__ */ v.jsx(ar, { label: e("profile.siren"), value: i.siren, readOnly: !0 }),
        /* @__PURE__ */ v.jsx(ar, { label: e("profile.country"), value: i.country, readOnly: !0 }),
        i.phone_number && /* @__PURE__ */ v.jsx(
          ar,
          {
            label: e("profile.phoneNumber"),
            value: i.phone_number,
            readOnly: !0
          }
        )
      ] });
    }
  }, s = () => {
    const i = r.info;
    return /* @__PURE__ */ v.jsx("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-4", children: /* @__PURE__ */ v.jsx(
      ar,
      {
        label: e("profile.phoneNumber"),
        value: i.phone_number || "",
        readOnly: !0,
        disabled: !0
      }
    ) });
  };
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx("h1", { className: "text-3xl font-bold mb-6 text-text", children: e("profile.title") }),
    /* @__PURE__ */ v.jsxs("div", { className: "grid grid-cols-1 md:grid-cols-3 gap-8", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "md:col-span-2 space-y-8", children: [
        /* @__PURE__ */ v.jsx(hr, { header: e("profile.personalInfo"), children: a() }),
        /* @__PURE__ */ v.jsx(hr, { header: e("profile.contactInfo"), children: s() })
      ] }),
      /* @__PURE__ */ v.jsx("div", { className: "space-y-8", children: /* @__PURE__ */ v.jsx(hr, { header: e("profile.status"), children: /* @__PURE__ */ v.jsx(WGe, { user: r }) }) })
    ] })
  ] });
};
function v4(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
}
function aO(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = {});
  const r = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter((n) => r.indexOf(n) < 0).forEach((n) => {
    typeof e[n] > "u" ? e[n] = t[n] : v4(t[n]) && v4(e[n]) && Object.keys(t[n]).length > 0 && aO(e[n], t[n]);
  });
}
const SW = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function kd() {
  const e = typeof document < "u" ? document : {};
  return aO(e, SW), e;
}
const KGe = {
  document: SW,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  }
};
function ps() {
  const e = typeof window < "u" ? window : {};
  return aO(e, KGe), e;
}
function qGe(e) {
  return e === void 0 && (e = ""), e.trim().split(" ").filter((t) => !!t.trim());
}
function GGe(e) {
  const t = e;
  Object.keys(t).forEach((r) => {
    try {
      t[r] = null;
    } catch {
    }
    try {
      delete t[r];
    } catch {
    }
  });
}
function bT(e, t) {
  return t === void 0 && (t = 0), setTimeout(e, t);
}
function pw() {
  return Date.now();
}
function YGe(e) {
  const t = ps();
  let r;
  return t.getComputedStyle && (r = t.getComputedStyle(e, null)), !r && e.currentStyle && (r = e.currentStyle), r || (r = e.style), r;
}
function XGe(e, t) {
  t === void 0 && (t = "x");
  const r = ps();
  let n, a, s;
  const i = YGe(e);
  return r.WebKitCSSMatrix ? (a = i.transform || i.webkitTransform, a.split(",").length > 6 && (a = a.split(", ").map((o) => o.replace(",", ".")).join(", ")), s = new r.WebKitCSSMatrix(a === "none" ? "" : a)) : (s = i.MozTransform || i.OTransform || i.MsTransform || i.msTransform || i.transform || i.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = s.toString().split(",")), t === "x" && (r.WebKitCSSMatrix ? a = s.m41 : n.length === 16 ? a = parseFloat(n[12]) : a = parseFloat(n[4])), t === "y" && (r.WebKitCSSMatrix ? a = s.m42 : n.length === 16 ? a = parseFloat(n[13]) : a = parseFloat(n[5])), a || 0;
}
function dy(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function QGe(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function Bs() {
  const e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = ["__proto__", "constructor", "prototype"];
  for (let r = 1; r < arguments.length; r += 1) {
    const n = r < 0 || arguments.length <= r ? void 0 : arguments[r];
    if (n != null && !QGe(n)) {
      const a = Object.keys(Object(n)).filter((s) => t.indexOf(s) < 0);
      for (let s = 0, i = a.length; s < i; s += 1) {
        const o = a[s], l = Object.getOwnPropertyDescriptor(n, o);
        l !== void 0 && l.enumerable && (dy(e[o]) && dy(n[o]) ? n[o].__swiper__ ? e[o] = n[o] : Bs(e[o], n[o]) : !dy(e[o]) && dy(n[o]) ? (e[o] = {}, n[o].__swiper__ ? e[o] = n[o] : Bs(e[o], n[o])) : e[o] = n[o]);
      }
    }
  }
  return e;
}
function fy(e, t, r) {
  e.style.setProperty(t, r);
}
function EW(e) {
  let {
    swiper: t,
    targetPosition: r,
    side: n
  } = e;
  const a = ps(), s = -t.translate;
  let i = null, o;
  const l = t.params.speed;
  t.wrapperEl.style.scrollSnapType = "none", a.cancelAnimationFrame(t.cssModeFrameID);
  const c = r > s ? "next" : "prev", u = (f, h) => c === "next" && f >= h || c === "prev" && f <= h, d = () => {
    o = (/* @__PURE__ */ new Date()).getTime(), i === null && (i = o);
    const f = Math.max(Math.min((o - i) / l, 1), 0), h = 0.5 - Math.cos(f * Math.PI) / 2;
    let p = s + h * (r - s);
    if (u(p, r) && (p = r), t.wrapperEl.scrollTo({
      [n]: p
    }), u(p, r)) {
      t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
          [n]: p
        });
      }), a.cancelAnimationFrame(t.cssModeFrameID);
      return;
    }
    t.cssModeFrameID = a.requestAnimationFrame(d);
  };
  d();
}
function Cl(e, t) {
  t === void 0 && (t = "");
  const r = ps(), n = [...e.children];
  return r.HTMLSlotElement && e instanceof HTMLSlotElement && n.push(...e.assignedElements()), t ? n.filter((a) => a.matches(t)) : n;
}
function JGe(e, t) {
  const r = [t];
  for (; r.length > 0; ) {
    const n = r.shift();
    if (e === n)
      return !0;
    r.push(...n.children, ...n.shadowRoot ? n.shadowRoot.children : [], ...n.assignedElements ? n.assignedElements() : []);
  }
}
function ZGe(e, t) {
  const r = ps();
  let n = t.contains(e);
  return !n && r.HTMLSlotElement && t instanceof HTMLSlotElement && (n = [...t.assignedElements()].includes(e), n || (n = JGe(e, t))), n;
}
function mw(e) {
  try {
    console.warn(e);
    return;
  } catch {
  }
}
function wT(e, t) {
  t === void 0 && (t = []);
  const r = document.createElement(e);
  return r.classList.add(...Array.isArray(t) ? t : qGe(t)), r;
}
function eYe(e, t) {
  const r = [];
  for (; e.previousElementSibling; ) {
    const n = e.previousElementSibling;
    t ? n.matches(t) && r.push(n) : r.push(n), e = n;
  }
  return r;
}
function tYe(e, t) {
  const r = [];
  for (; e.nextElementSibling; ) {
    const n = e.nextElementSibling;
    t ? n.matches(t) && r.push(n) : r.push(n), e = n;
  }
  return r;
}
function Sc(e, t) {
  return ps().getComputedStyle(e, null).getPropertyValue(t);
}
function y4(e) {
  let t = e, r;
  if (t) {
    for (r = 0; (t = t.previousSibling) !== null; )
      t.nodeType === 1 && (r += 1);
    return r;
  }
}
function rYe(e, t) {
  const r = [];
  let n = e.parentElement;
  for (; n; )
    r.push(n), n = n.parentElement;
  return r;
}
function b4(e, t, r) {
  const n = ps();
  return e[t === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-left" : "margin-bottom"));
}
let DS;
function nYe() {
  const e = ps(), t = kd();
  return {
    smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
  };
}
function TW() {
  return DS || (DS = nYe()), DS;
}
let NS;
function aYe(e) {
  let {
    userAgent: t
  } = e === void 0 ? {} : e;
  const r = TW(), n = ps(), a = n.navigator.platform, s = t || n.navigator.userAgent, i = {
    ios: !1,
    android: !1
  }, o = n.screen.width, l = n.screen.height, c = s.match(/(Android);?[\s\/]+([\d.]+)?/);
  let u = s.match(/(iPad).*OS\s([\d_]+)/);
  const d = s.match(/(iPod)(.*OS\s([\d_]+))?/), f = !u && s.match(/(iPhone\sOS|iOS)\s([\d_]+)/), h = a === "Win32";
  let p = a === "MacIntel";
  const m = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !u && p && r.touch && m.indexOf(`${o}x${l}`) >= 0 && (u = s.match(/(Version)\/([\d.]+)/), u || (u = [0, 1, "13_0_0"]), p = !1), c && !h && (i.os = "android", i.android = !0), (u || f || d) && (i.os = "ios", i.ios = !0), i;
}
function CW(e) {
  return e === void 0 && (e = {}), NS || (NS = aYe(e)), NS;
}
let MS;
function sYe() {
  const e = ps(), t = CW();
  let r = !1;
  function n() {
    const o = e.navigator.userAgent.toLowerCase();
    return o.indexOf("safari") >= 0 && o.indexOf("chrome") < 0 && o.indexOf("android") < 0;
  }
  if (n()) {
    const o = String(e.navigator.userAgent);
    if (o.includes("Version/")) {
      const [l, c] = o.split("Version/")[1].split(" ")[0].split(".").map((u) => Number(u));
      r = l < 16 || l === 16 && c < 2;
    }
  }
  const a = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent), s = n(), i = s || a && t.ios;
  return {
    isSafari: r || s,
    needPerspectiveFix: r,
    need3dFix: i,
    isWebView: a
  };
}
function kW() {
  return MS || (MS = sYe()), MS;
}
function iYe(e) {
  let {
    swiper: t,
    on: r,
    emit: n
  } = e;
  const a = ps();
  let s = null, i = null;
  const o = () => {
    !t || t.destroyed || !t.initialized || (n("beforeResize"), n("resize"));
  }, l = () => {
    !t || t.destroyed || !t.initialized || (s = new ResizeObserver((d) => {
      i = a.requestAnimationFrame(() => {
        const {
          width: f,
          height: h
        } = t;
        let p = f, m = h;
        d.forEach((g) => {
          let {
            contentBoxSize: y,
            contentRect: x,
            target: w
          } = g;
          w && w !== t.el || (p = x ? x.width : (y[0] || y).inlineSize, m = x ? x.height : (y[0] || y).blockSize);
        }), (p !== f || m !== h) && o();
      });
    }), s.observe(t.el));
  }, c = () => {
    i && a.cancelAnimationFrame(i), s && s.unobserve && t.el && (s.unobserve(t.el), s = null);
  }, u = () => {
    !t || t.destroyed || !t.initialized || n("orientationchange");
  };
  r("init", () => {
    if (t.params.resizeObserver && typeof a.ResizeObserver < "u") {
      l();
      return;
    }
    a.addEventListener("resize", o), a.addEventListener("orientationchange", u);
  }), r("destroy", () => {
    c(), a.removeEventListener("resize", o), a.removeEventListener("orientationchange", u);
  });
}
function oYe(e) {
  let {
    swiper: t,
    extendParams: r,
    on: n,
    emit: a
  } = e;
  const s = [], i = ps(), o = function(u, d) {
    d === void 0 && (d = {});
    const f = i.MutationObserver || i.WebkitMutationObserver, h = new f((p) => {
      if (t.__preventObserver__) return;
      if (p.length === 1) {
        a("observerUpdate", p[0]);
        return;
      }
      const m = function() {
        a("observerUpdate", p[0]);
      };
      i.requestAnimationFrame ? i.requestAnimationFrame(m) : i.setTimeout(m, 0);
    });
    h.observe(u, {
      attributes: typeof d.attributes > "u" ? !0 : d.attributes,
      childList: t.isElement || (typeof d.childList > "u" ? !0 : d).childList,
      characterData: typeof d.characterData > "u" ? !0 : d.characterData
    }), s.push(h);
  }, l = () => {
    if (t.params.observer) {
      if (t.params.observeParents) {
        const u = rYe(t.hostEl);
        for (let d = 0; d < u.length; d += 1)
          o(u[d]);
      }
      o(t.hostEl, {
        childList: t.params.observeSlideChildren
      }), o(t.wrapperEl, {
        attributes: !1
      });
    }
  }, c = () => {
    s.forEach((u) => {
      u.disconnect();
    }), s.splice(0, s.length);
  };
  r({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), n("init", l), n("destroy", c);
}
var lYe = {
  on(e, t, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof t != "function") return n;
    const a = r ? "unshift" : "push";
    return e.split(" ").forEach((s) => {
      n.eventsListeners[s] || (n.eventsListeners[s] = []), n.eventsListeners[s][a](t);
    }), n;
  },
  once(e, t, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof t != "function") return n;
    function a() {
      n.off(e, a), a.__emitterProxy && delete a.__emitterProxy;
      for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++)
        i[o] = arguments[o];
      t.apply(n, i);
    }
    return a.__emitterProxy = t, n.on(e, a, r);
  },
  onAny(e, t) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof e != "function") return r;
    const n = t ? "unshift" : "push";
    return r.eventsAnyListeners.indexOf(e) < 0 && r.eventsAnyListeners[n](e), r;
  },
  offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners) return t;
    const r = t.eventsAnyListeners.indexOf(e);
    return r >= 0 && t.eventsAnyListeners.splice(r, 1), t;
  },
  off(e, t) {
    const r = this;
    return !r.eventsListeners || r.destroyed || !r.eventsListeners || e.split(" ").forEach((n) => {
      typeof t > "u" ? r.eventsListeners[n] = [] : r.eventsListeners[n] && r.eventsListeners[n].forEach((a, s) => {
        (a === t || a.__emitterProxy && a.__emitterProxy === t) && r.eventsListeners[n].splice(s, 1);
      });
    }), r;
  },
  emit() {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsListeners) return e;
    let t, r, n;
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    return typeof s[0] == "string" || Array.isArray(s[0]) ? (t = s[0], r = s.slice(1, s.length), n = e) : (t = s[0].events, r = s[0].data, n = s[0].context || e), r.unshift(n), (Array.isArray(t) ? t : t.split(" ")).forEach((l) => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((c) => {
        c.apply(n, [l, ...r]);
      }), e.eventsListeners && e.eventsListeners[l] && e.eventsListeners[l].forEach((c) => {
        c.apply(n, r);
      });
    }), e;
  }
};
function cYe() {
  const e = this;
  let t, r;
  const n = e.el;
  typeof e.params.width < "u" && e.params.width !== null ? t = e.params.width : t = n.clientWidth, typeof e.params.height < "u" && e.params.height !== null ? r = e.params.height : r = n.clientHeight, !(t === 0 && e.isHorizontal() || r === 0 && e.isVertical()) && (t = t - parseInt(Sc(n, "padding-left") || 0, 10) - parseInt(Sc(n, "padding-right") || 0, 10), r = r - parseInt(Sc(n, "padding-top") || 0, 10) - parseInt(Sc(n, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(r) && (r = 0), Object.assign(e, {
    width: t,
    height: r,
    size: e.isHorizontal() ? t : r
  }));
}
function uYe() {
  const e = this;
  function t(A, P) {
    return parseFloat(A.getPropertyValue(e.getDirectionLabel(P)) || 0);
  }
  const r = e.params, {
    wrapperEl: n,
    slidesEl: a,
    size: s,
    rtlTranslate: i,
    wrongRTL: o
  } = e, l = e.virtual && r.virtual.enabled, c = l ? e.virtual.slides.length : e.slides.length, u = Cl(a, `.${e.params.slideClass}, swiper-slide`), d = l ? e.virtual.slides.length : u.length;
  let f = [];
  const h = [], p = [];
  let m = r.slidesOffsetBefore;
  typeof m == "function" && (m = r.slidesOffsetBefore.call(e));
  let g = r.slidesOffsetAfter;
  typeof g == "function" && (g = r.slidesOffsetAfter.call(e));
  const y = e.snapGrid.length, x = e.slidesGrid.length;
  let w = r.spaceBetween, _ = -m, S = 0, C = 0;
  if (typeof s > "u")
    return;
  typeof w == "string" && w.indexOf("%") >= 0 ? w = parseFloat(w.replace("%", "")) / 100 * s : typeof w == "string" && (w = parseFloat(w)), e.virtualSize = -w, u.forEach((A) => {
    i ? A.style.marginLeft = "" : A.style.marginRight = "", A.style.marginBottom = "", A.style.marginTop = "";
  }), r.centeredSlides && r.cssMode && (fy(n, "--swiper-centered-offset-before", ""), fy(n, "--swiper-centered-offset-after", ""));
  const E = r.grid && r.grid.rows > 1 && e.grid;
  E ? e.grid.initSlides(u) : e.grid && e.grid.unsetSlides();
  let O;
  const k = r.slidesPerView === "auto" && r.breakpoints && Object.keys(r.breakpoints).filter((A) => typeof r.breakpoints[A].slidesPerView < "u").length > 0;
  for (let A = 0; A < d; A += 1) {
    O = 0;
    let P;
    if (u[A] && (P = u[A]), E && e.grid.updateSlide(A, P, u), !(u[A] && Sc(P, "display") === "none")) {
      if (r.slidesPerView === "auto") {
        k && (u[A].style[e.getDirectionLabel("width")] = "");
        const D = getComputedStyle(P), N = P.style.transform, z = P.style.webkitTransform;
        if (N && (P.style.transform = "none"), z && (P.style.webkitTransform = "none"), r.roundLengths)
          O = e.isHorizontal() ? b4(P, "width") : b4(P, "height");
        else {
          const G = t(D, "width"), Y = t(D, "padding-left"), te = t(D, "padding-right"), ae = t(D, "margin-left"), ne = t(D, "margin-right"), ue = D.getPropertyValue("box-sizing");
          if (ue && ue === "border-box")
            O = G + ae + ne;
          else {
            const {
              clientWidth: q,
              offsetWidth: U
            } = P;
            O = G + Y + te + ae + ne + (U - q);
          }
        }
        N && (P.style.transform = N), z && (P.style.webkitTransform = z), r.roundLengths && (O = Math.floor(O));
      } else
        O = (s - (r.slidesPerView - 1) * w) / r.slidesPerView, r.roundLengths && (O = Math.floor(O)), u[A] && (u[A].style[e.getDirectionLabel("width")] = `${O}px`);
      u[A] && (u[A].swiperSlideSize = O), p.push(O), r.centeredSlides ? (_ = _ + O / 2 + S / 2 + w, S === 0 && A !== 0 && (_ = _ - s / 2 - w), A === 0 && (_ = _ - s / 2 - w), Math.abs(_) < 1 / 1e3 && (_ = 0), r.roundLengths && (_ = Math.floor(_)), C % r.slidesPerGroup === 0 && f.push(_), h.push(_)) : (r.roundLengths && (_ = Math.floor(_)), (C - Math.min(e.params.slidesPerGroupSkip, C)) % e.params.slidesPerGroup === 0 && f.push(_), h.push(_), _ = _ + O + w), e.virtualSize += O + w, S = O, C += 1;
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, s) + g, i && o && (r.effect === "slide" || r.effect === "coverflow") && (n.style.width = `${e.virtualSize + w}px`), r.setWrapperSize && (n.style[e.getDirectionLabel("width")] = `${e.virtualSize + w}px`), E && e.grid.updateWrapperSize(O, f), !r.centeredSlides) {
    const A = [];
    for (let P = 0; P < f.length; P += 1) {
      let D = f[P];
      r.roundLengths && (D = Math.floor(D)), f[P] <= e.virtualSize - s && A.push(D);
    }
    f = A, Math.floor(e.virtualSize - s) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - s);
  }
  if (l && r.loop) {
    const A = p[0] + w;
    if (r.slidesPerGroup > 1) {
      const P = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / r.slidesPerGroup), D = A * r.slidesPerGroup;
      for (let N = 0; N < P; N += 1)
        f.push(f[f.length - 1] + D);
    }
    for (let P = 0; P < e.virtual.slidesBefore + e.virtual.slidesAfter; P += 1)
      r.slidesPerGroup === 1 && f.push(f[f.length - 1] + A), h.push(h[h.length - 1] + A), e.virtualSize += A;
  }
  if (f.length === 0 && (f = [0]), w !== 0) {
    const A = e.isHorizontal() && i ? "marginLeft" : e.getDirectionLabel("marginRight");
    u.filter((P, D) => !r.cssMode || r.loop ? !0 : D !== u.length - 1).forEach((P) => {
      P.style[A] = `${w}px`;
    });
  }
  if (r.centeredSlides && r.centeredSlidesBounds) {
    let A = 0;
    p.forEach((D) => {
      A += D + (w || 0);
    }), A -= w;
    const P = A > s ? A - s : 0;
    f = f.map((D) => D <= 0 ? -m : D > P ? P + g : D);
  }
  if (r.centerInsufficientSlides) {
    let A = 0;
    p.forEach((D) => {
      A += D + (w || 0);
    }), A -= w;
    const P = (r.slidesOffsetBefore || 0) + (r.slidesOffsetAfter || 0);
    if (A + P < s) {
      const D = (s - A - P) / 2;
      f.forEach((N, z) => {
        f[z] = N - D;
      }), h.forEach((N, z) => {
        h[z] = N + D;
      });
    }
  }
  if (Object.assign(e, {
    slides: u,
    snapGrid: f,
    slidesGrid: h,
    slidesSizesGrid: p
  }), r.centeredSlides && r.cssMode && !r.centeredSlidesBounds) {
    fy(n, "--swiper-centered-offset-before", `${-f[0]}px`), fy(n, "--swiper-centered-offset-after", `${e.size / 2 - p[p.length - 1] / 2}px`);
    const A = -e.snapGrid[0], P = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map((D) => D + A), e.slidesGrid = e.slidesGrid.map((D) => D + P);
  }
  if (d !== c && e.emit("slidesLengthChange"), f.length !== y && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), h.length !== x && e.emit("slidesGridLengthChange"), r.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !l && !r.cssMode && (r.effect === "slide" || r.effect === "fade")) {
    const A = `${r.containerModifierClass}backface-hidden`, P = e.el.classList.contains(A);
    d <= r.maxBackfaceHiddenSlides ? P || e.el.classList.add(A) : P && e.el.classList.remove(A);
  }
}
function dYe(e) {
  const t = this, r = [], n = t.virtual && t.params.virtual.enabled;
  let a = 0, s;
  typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
  const i = (o) => n ? t.slides[t.getSlideIndexByData(o)] : t.slides[o];
  if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1)
    if (t.params.centeredSlides)
      (t.visibleSlides || []).forEach((o) => {
        r.push(o);
      });
    else
      for (s = 0; s < Math.ceil(t.params.slidesPerView); s += 1) {
        const o = t.activeIndex + s;
        if (o > t.slides.length && !n) break;
        r.push(i(o));
      }
  else
    r.push(i(t.activeIndex));
  for (s = 0; s < r.length; s += 1)
    if (typeof r[s] < "u") {
      const o = r[s].offsetHeight;
      a = o > a ? o : a;
    }
  (a || a === 0) && (t.wrapperEl.style.height = `${a}px`);
}
function fYe() {
  const e = this, t = e.slides, r = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
  for (let n = 0; n < t.length; n += 1)
    t[n].swiperSlideOffset = (e.isHorizontal() ? t[n].offsetLeft : t[n].offsetTop) - r - e.cssOverflowAdjustment();
}
const w4 = (e, t, r) => {
  t && !e.classList.contains(r) ? e.classList.add(r) : !t && e.classList.contains(r) && e.classList.remove(r);
};
function hYe(e) {
  e === void 0 && (e = this && this.translate || 0);
  const t = this, r = t.params, {
    slides: n,
    rtlTranslate: a,
    snapGrid: s
  } = t;
  if (n.length === 0) return;
  typeof n[0].swiperSlideOffset > "u" && t.updateSlidesOffset();
  let i = -e;
  a && (i = e), t.visibleSlidesIndexes = [], t.visibleSlides = [];
  let o = r.spaceBetween;
  typeof o == "string" && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * t.size : typeof o == "string" && (o = parseFloat(o));
  for (let l = 0; l < n.length; l += 1) {
    const c = n[l];
    let u = c.swiperSlideOffset;
    r.cssMode && r.centeredSlides && (u -= n[0].swiperSlideOffset);
    const d = (i + (r.centeredSlides ? t.minTranslate() : 0) - u) / (c.swiperSlideSize + o), f = (i - s[0] + (r.centeredSlides ? t.minTranslate() : 0) - u) / (c.swiperSlideSize + o), h = -(i - u), p = h + t.slidesSizesGrid[l], m = h >= 0 && h <= t.size - t.slidesSizesGrid[l], g = h >= 0 && h < t.size - 1 || p > 1 && p <= t.size || h <= 0 && p >= t.size;
    g && (t.visibleSlides.push(c), t.visibleSlidesIndexes.push(l)), w4(c, g, r.slideVisibleClass), w4(c, m, r.slideFullyVisibleClass), c.progress = a ? -d : d, c.originalProgress = a ? -f : f;
  }
}
function pYe(e) {
  const t = this;
  if (typeof e > "u") {
    const u = t.rtlTranslate ? -1 : 1;
    e = t && t.translate && t.translate * u || 0;
  }
  const r = t.params, n = t.maxTranslate() - t.minTranslate();
  let {
    progress: a,
    isBeginning: s,
    isEnd: i,
    progressLoop: o
  } = t;
  const l = s, c = i;
  if (n === 0)
    a = 0, s = !0, i = !0;
  else {
    a = (e - t.minTranslate()) / n;
    const u = Math.abs(e - t.minTranslate()) < 1, d = Math.abs(e - t.maxTranslate()) < 1;
    s = u || a <= 0, i = d || a >= 1, u && (a = 0), d && (a = 1);
  }
  if (r.loop) {
    const u = t.getSlideIndexByData(0), d = t.getSlideIndexByData(t.slides.length - 1), f = t.slidesGrid[u], h = t.slidesGrid[d], p = t.slidesGrid[t.slidesGrid.length - 1], m = Math.abs(e);
    m >= f ? o = (m - f) / p : o = (m + p - h) / p, o > 1 && (o -= 1);
  }
  Object.assign(t, {
    progress: a,
    progressLoop: o,
    isBeginning: s,
    isEnd: i
  }), (r.watchSlidesProgress || r.centeredSlides && r.autoHeight) && t.updateSlidesProgress(e), s && !l && t.emit("reachBeginning toEdge"), i && !c && t.emit("reachEnd toEdge"), (l && !s || c && !i) && t.emit("fromEdge"), t.emit("progress", a);
}
const LS = (e, t, r) => {
  t && !e.classList.contains(r) ? e.classList.add(r) : !t && e.classList.contains(r) && e.classList.remove(r);
};
function mYe() {
  const e = this, {
    slides: t,
    params: r,
    slidesEl: n,
    activeIndex: a
  } = e, s = e.virtual && r.virtual.enabled, i = e.grid && r.grid && r.grid.rows > 1, o = (d) => Cl(n, `.${r.slideClass}${d}, swiper-slide${d}`)[0];
  let l, c, u;
  if (s)
    if (r.loop) {
      let d = a - e.virtual.slidesBefore;
      d < 0 && (d = e.virtual.slides.length + d), d >= e.virtual.slides.length && (d -= e.virtual.slides.length), l = o(`[data-swiper-slide-index="${d}"]`);
    } else
      l = o(`[data-swiper-slide-index="${a}"]`);
  else
    i ? (l = t.find((d) => d.column === a), u = t.find((d) => d.column === a + 1), c = t.find((d) => d.column === a - 1)) : l = t[a];
  l && (i || (u = tYe(l, `.${r.slideClass}, swiper-slide`)[0], r.loop && !u && (u = t[0]), c = eYe(l, `.${r.slideClass}, swiper-slide`)[0], r.loop && !c === 0 && (c = t[t.length - 1]))), t.forEach((d) => {
    LS(d, d === l, r.slideActiveClass), LS(d, d === u, r.slideNextClass), LS(d, d === c, r.slidePrevClass);
  }), e.emitSlidesClasses();
}
const Ny = (e, t) => {
  if (!e || e.destroyed || !e.params) return;
  const r = () => e.isElement ? "swiper-slide" : `.${e.params.slideClass}`, n = t.closest(r());
  if (n) {
    let a = n.querySelector(`.${e.params.lazyPreloaderClass}`);
    !a && e.isElement && (n.shadowRoot ? a = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      n.shadowRoot && (a = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), a && a.remove());
    })), a && a.remove();
  }
}, jS = (e, t) => {
  if (!e.slides[t]) return;
  const r = e.slides[t].querySelector('[loading="lazy"]');
  r && r.removeAttribute("loading");
}, xT = (e) => {
  if (!e || e.destroyed || !e.params) return;
  let t = e.params.lazyPreloadPrevNext;
  const r = e.slides.length;
  if (!r || !t || t < 0) return;
  t = Math.min(t, r);
  const n = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), a = e.activeIndex;
  if (e.params.grid && e.params.grid.rows > 1) {
    const i = a, o = [i - t];
    o.push(...Array.from({
      length: t
    }).map((l, c) => i + n + c)), e.slides.forEach((l, c) => {
      o.includes(l.column) && jS(e, c);
    });
    return;
  }
  const s = a + n - 1;
  if (e.params.rewind || e.params.loop)
    for (let i = a - t; i <= s + t; i += 1) {
      const o = (i % r + r) % r;
      (o < a || o > s) && jS(e, o);
    }
  else
    for (let i = Math.max(a - t, 0); i <= Math.min(s + t, r - 1); i += 1)
      i !== a && (i > s || i < a) && jS(e, i);
};
function gYe(e) {
  const {
    slidesGrid: t,
    params: r
  } = e, n = e.rtlTranslate ? e.translate : -e.translate;
  let a;
  for (let s = 0; s < t.length; s += 1)
    typeof t[s + 1] < "u" ? n >= t[s] && n < t[s + 1] - (t[s + 1] - t[s]) / 2 ? a = s : n >= t[s] && n < t[s + 1] && (a = s + 1) : n >= t[s] && (a = s);
  return r.normalizeSlideIndex && (a < 0 || typeof a > "u") && (a = 0), a;
}
function vYe(e) {
  const t = this, r = t.rtlTranslate ? t.translate : -t.translate, {
    snapGrid: n,
    params: a,
    activeIndex: s,
    realIndex: i,
    snapIndex: o
  } = t;
  let l = e, c;
  const u = (h) => {
    let p = h - t.virtual.slidesBefore;
    return p < 0 && (p = t.virtual.slides.length + p), p >= t.virtual.slides.length && (p -= t.virtual.slides.length), p;
  };
  if (typeof l > "u" && (l = gYe(t)), n.indexOf(r) >= 0)
    c = n.indexOf(r);
  else {
    const h = Math.min(a.slidesPerGroupSkip, l);
    c = h + Math.floor((l - h) / a.slidesPerGroup);
  }
  if (c >= n.length && (c = n.length - 1), l === s && !t.params.loop) {
    c !== o && (t.snapIndex = c, t.emit("snapIndexChange"));
    return;
  }
  if (l === s && t.params.loop && t.virtual && t.params.virtual.enabled) {
    t.realIndex = u(l);
    return;
  }
  const d = t.grid && a.grid && a.grid.rows > 1;
  let f;
  if (t.virtual && a.virtual.enabled && a.loop)
    f = u(l);
  else if (d) {
    const h = t.slides.find((m) => m.column === l);
    let p = parseInt(h.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(p) && (p = Math.max(t.slides.indexOf(h), 0)), f = Math.floor(p / a.grid.rows);
  } else if (t.slides[l]) {
    const h = t.slides[l].getAttribute("data-swiper-slide-index");
    h ? f = parseInt(h, 10) : f = l;
  } else
    f = l;
  Object.assign(t, {
    previousSnapIndex: o,
    snapIndex: c,
    previousRealIndex: i,
    realIndex: f,
    previousIndex: s,
    activeIndex: l
  }), t.initialized && xT(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (i !== f && t.emit("realIndexChange"), t.emit("slideChange"));
}
function yYe(e, t) {
  const r = this, n = r.params;
  let a = e.closest(`.${n.slideClass}, swiper-slide`);
  !a && r.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach((o) => {
    !a && o.matches && o.matches(`.${n.slideClass}, swiper-slide`) && (a = o);
  });
  let s = !1, i;
  if (a) {
    for (let o = 0; o < r.slides.length; o += 1)
      if (r.slides[o] === a) {
        s = !0, i = o;
        break;
      }
  }
  if (a && s)
    r.clickedSlide = a, r.virtual && r.params.virtual.enabled ? r.clickedIndex = parseInt(a.getAttribute("data-swiper-slide-index"), 10) : r.clickedIndex = i;
  else {
    r.clickedSlide = void 0, r.clickedIndex = void 0;
    return;
  }
  n.slideToClickedSlide && r.clickedIndex !== void 0 && r.clickedIndex !== r.activeIndex && r.slideToClickedSlide();
}
var bYe = {
  updateSize: cYe,
  updateSlides: uYe,
  updateAutoHeight: dYe,
  updateSlidesOffset: fYe,
  updateSlidesProgress: hYe,
  updateProgress: pYe,
  updateSlidesClasses: mYe,
  updateActiveIndex: vYe,
  updateClickedSlide: yYe
};
function wYe(e) {
  e === void 0 && (e = this.isHorizontal() ? "x" : "y");
  const t = this, {
    params: r,
    rtlTranslate: n,
    translate: a,
    wrapperEl: s
  } = t;
  if (r.virtualTranslate)
    return n ? -a : a;
  if (r.cssMode)
    return a;
  let i = XGe(s, e);
  return i += t.cssOverflowAdjustment(), n && (i = -i), i || 0;
}
function xYe(e, t) {
  const r = this, {
    rtlTranslate: n,
    params: a,
    wrapperEl: s,
    progress: i
  } = r;
  let o = 0, l = 0;
  const c = 0;
  r.isHorizontal() ? o = n ? -e : e : l = e, a.roundLengths && (o = Math.floor(o), l = Math.floor(l)), r.previousTranslate = r.translate, r.translate = r.isHorizontal() ? o : l, a.cssMode ? s[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -o : -l : a.virtualTranslate || (r.isHorizontal() ? o -= r.cssOverflowAdjustment() : l -= r.cssOverflowAdjustment(), s.style.transform = `translate3d(${o}px, ${l}px, ${c}px)`);
  let u;
  const d = r.maxTranslate() - r.minTranslate();
  d === 0 ? u = 0 : u = (e - r.minTranslate()) / d, u !== i && r.updateProgress(e), r.emit("setTranslate", r.translate, t);
}
function _Ye() {
  return -this.snapGrid[0];
}
function SYe() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function EYe(e, t, r, n, a) {
  e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), r === void 0 && (r = !0), n === void 0 && (n = !0);
  const s = this, {
    params: i,
    wrapperEl: o
  } = s;
  if (s.animating && i.preventInteractionOnTransition)
    return !1;
  const l = s.minTranslate(), c = s.maxTranslate();
  let u;
  if (n && e > l ? u = l : n && e < c ? u = c : u = e, s.updateProgress(u), i.cssMode) {
    const d = s.isHorizontal();
    if (t === 0)
      o[d ? "scrollLeft" : "scrollTop"] = -u;
    else {
      if (!s.support.smoothScroll)
        return EW({
          swiper: s,
          targetPosition: -u,
          side: d ? "left" : "top"
        }), !0;
      o.scrollTo({
        [d ? "left" : "top"]: -u,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return t === 0 ? (s.setTransition(0), s.setTranslate(u), r && (s.emit("beforeTransitionStart", t, a), s.emit("transitionEnd"))) : (s.setTransition(t), s.setTranslate(u), r && (s.emit("beforeTransitionStart", t, a), s.emit("transitionStart")), s.animating || (s.animating = !0, s.onTranslateToWrapperTransitionEnd || (s.onTranslateToWrapperTransitionEnd = function(f) {
    !s || s.destroyed || f.target === this && (s.wrapperEl.removeEventListener("transitionend", s.onTranslateToWrapperTransitionEnd), s.onTranslateToWrapperTransitionEnd = null, delete s.onTranslateToWrapperTransitionEnd, s.animating = !1, r && s.emit("transitionEnd"));
  }), s.wrapperEl.addEventListener("transitionend", s.onTranslateToWrapperTransitionEnd))), !0;
}
var TYe = {
  getTranslate: wYe,
  setTranslate: xYe,
  minTranslate: _Ye,
  maxTranslate: SYe,
  translateTo: EYe
};
function CYe(e, t) {
  const r = this;
  r.params.cssMode || (r.wrapperEl.style.transitionDuration = `${e}ms`, r.wrapperEl.style.transitionDelay = e === 0 ? "0ms" : ""), r.emit("setTransition", e, t);
}
function OW(e) {
  let {
    swiper: t,
    runCallbacks: r,
    direction: n,
    step: a
  } = e;
  const {
    activeIndex: s,
    previousIndex: i
  } = t;
  let o = n;
  if (o || (s > i ? o = "next" : s < i ? o = "prev" : o = "reset"), t.emit(`transition${a}`), r && s !== i) {
    if (o === "reset") {
      t.emit(`slideResetTransition${a}`);
      return;
    }
    t.emit(`slideChangeTransition${a}`), o === "next" ? t.emit(`slideNextTransition${a}`) : t.emit(`slidePrevTransition${a}`);
  }
}
function kYe(e, t) {
  e === void 0 && (e = !0);
  const r = this, {
    params: n
  } = r;
  n.cssMode || (n.autoHeight && r.updateAutoHeight(), OW({
    swiper: r,
    runCallbacks: e,
    direction: t,
    step: "Start"
  }));
}
function OYe(e, t) {
  e === void 0 && (e = !0);
  const r = this, {
    params: n
  } = r;
  r.animating = !1, !n.cssMode && (r.setTransition(0), OW({
    swiper: r,
    runCallbacks: e,
    direction: t,
    step: "End"
  }));
}
var AYe = {
  setTransition: CYe,
  transitionStart: kYe,
  transitionEnd: OYe
};
function PYe(e, t, r, n, a) {
  e === void 0 && (e = 0), r === void 0 && (r = !0), typeof e == "string" && (e = parseInt(e, 10));
  const s = this;
  let i = e;
  i < 0 && (i = 0);
  const {
    params: o,
    snapGrid: l,
    slidesGrid: c,
    previousIndex: u,
    activeIndex: d,
    rtlTranslate: f,
    wrapperEl: h,
    enabled: p
  } = s;
  if (!p && !n && !a || s.destroyed || s.animating && o.preventInteractionOnTransition)
    return !1;
  typeof t > "u" && (t = s.params.speed);
  const m = Math.min(s.params.slidesPerGroupSkip, i);
  let g = m + Math.floor((i - m) / s.params.slidesPerGroup);
  g >= l.length && (g = l.length - 1);
  const y = -l[g];
  if (o.normalizeSlideIndex)
    for (let E = 0; E < c.length; E += 1) {
      const O = -Math.floor(y * 100), k = Math.floor(c[E] * 100), A = Math.floor(c[E + 1] * 100);
      typeof c[E + 1] < "u" ? O >= k && O < A - (A - k) / 2 ? i = E : O >= k && O < A && (i = E + 1) : O >= k && (i = E);
    }
  if (s.initialized && i !== d && (!s.allowSlideNext && (f ? y > s.translate && y > s.minTranslate() : y < s.translate && y < s.minTranslate()) || !s.allowSlidePrev && y > s.translate && y > s.maxTranslate() && (d || 0) !== i))
    return !1;
  i !== (u || 0) && r && s.emit("beforeSlideChangeStart"), s.updateProgress(y);
  let x;
  i > d ? x = "next" : i < d ? x = "prev" : x = "reset";
  const w = s.virtual && s.params.virtual.enabled;
  if (!(w && a) && (f && -y === s.translate || !f && y === s.translate))
    return s.updateActiveIndex(i), o.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), o.effect !== "slide" && s.setTranslate(y), x !== "reset" && (s.transitionStart(r, x), s.transitionEnd(r, x)), !1;
  if (o.cssMode) {
    const E = s.isHorizontal(), O = f ? y : -y;
    if (t === 0)
      w && (s.wrapperEl.style.scrollSnapType = "none", s._immediateVirtual = !0), w && !s._cssModeVirtualInitialSet && s.params.initialSlide > 0 ? (s._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        h[E ? "scrollLeft" : "scrollTop"] = O;
      })) : h[E ? "scrollLeft" : "scrollTop"] = O, w && requestAnimationFrame(() => {
        s.wrapperEl.style.scrollSnapType = "", s._immediateVirtual = !1;
      });
    else {
      if (!s.support.smoothScroll)
        return EW({
          swiper: s,
          targetPosition: O,
          side: E ? "left" : "top"
        }), !0;
      h.scrollTo({
        [E ? "left" : "top"]: O,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const C = kW().isSafari;
  return w && !a && C && s.isElement && s.virtual.update(!1, !1, i), s.setTransition(t), s.setTranslate(y), s.updateActiveIndex(i), s.updateSlidesClasses(), s.emit("beforeTransitionStart", t, n), s.transitionStart(r, x), t === 0 ? s.transitionEnd(r, x) : s.animating || (s.animating = !0, s.onSlideToWrapperTransitionEnd || (s.onSlideToWrapperTransitionEnd = function(O) {
    !s || s.destroyed || O.target === this && (s.wrapperEl.removeEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.onSlideToWrapperTransitionEnd = null, delete s.onSlideToWrapperTransitionEnd, s.transitionEnd(r, x));
  }), s.wrapperEl.addEventListener("transitionend", s.onSlideToWrapperTransitionEnd)), !0;
}
function RYe(e, t, r, n) {
  e === void 0 && (e = 0), r === void 0 && (r = !0), typeof e == "string" && (e = parseInt(e, 10));
  const a = this;
  if (a.destroyed) return;
  typeof t > "u" && (t = a.params.speed);
  const s = a.grid && a.params.grid && a.params.grid.rows > 1;
  let i = e;
  if (a.params.loop)
    if (a.virtual && a.params.virtual.enabled)
      i = i + a.virtual.slidesBefore;
    else {
      let o;
      if (s) {
        const f = i * a.params.grid.rows;
        o = a.slides.find((h) => h.getAttribute("data-swiper-slide-index") * 1 === f).column;
      } else
        o = a.getSlideIndexByData(i);
      const l = s ? Math.ceil(a.slides.length / a.params.grid.rows) : a.slides.length, {
        centeredSlides: c
      } = a.params;
      let u = a.params.slidesPerView;
      u === "auto" ? u = a.slidesPerViewDynamic() : (u = Math.ceil(parseFloat(a.params.slidesPerView, 10)), c && u % 2 === 0 && (u = u + 1));
      let d = l - o < u;
      if (c && (d = d || o < Math.ceil(u / 2)), n && c && a.params.slidesPerView !== "auto" && !s && (d = !1), d) {
        const f = c ? o < a.activeIndex ? "prev" : "next" : o - a.activeIndex - 1 < a.params.slidesPerView ? "next" : "prev";
        a.loopFix({
          direction: f,
          slideTo: !0,
          activeSlideIndex: f === "next" ? o + 1 : o - l + 1,
          slideRealIndex: f === "next" ? a.realIndex : void 0
        });
      }
      if (s) {
        const f = i * a.params.grid.rows;
        i = a.slides.find((h) => h.getAttribute("data-swiper-slide-index") * 1 === f).column;
      } else
        i = a.getSlideIndexByData(i);
    }
  return requestAnimationFrame(() => {
    a.slideTo(i, t, r, n);
  }), a;
}
function IYe(e, t, r) {
  t === void 0 && (t = !0);
  const n = this, {
    enabled: a,
    params: s,
    animating: i
  } = n;
  if (!a || n.destroyed) return n;
  typeof e > "u" && (e = n.params.speed);
  let o = s.slidesPerGroup;
  s.slidesPerView === "auto" && s.slidesPerGroup === 1 && s.slidesPerGroupAuto && (o = Math.max(n.slidesPerViewDynamic("current", !0), 1));
  const l = n.activeIndex < s.slidesPerGroupSkip ? 1 : o, c = n.virtual && s.virtual.enabled;
  if (s.loop) {
    if (i && !c && s.loopPreventsSliding) return !1;
    if (n.loopFix({
      direction: "next"
    }), n._clientLeft = n.wrapperEl.clientLeft, n.activeIndex === n.slides.length - 1 && s.cssMode)
      return requestAnimationFrame(() => {
        n.slideTo(n.activeIndex + l, e, t, r);
      }), !0;
  }
  return s.rewind && n.isEnd ? n.slideTo(0, e, t, r) : n.slideTo(n.activeIndex + l, e, t, r);
}
function DYe(e, t, r) {
  t === void 0 && (t = !0);
  const n = this, {
    params: a,
    snapGrid: s,
    slidesGrid: i,
    rtlTranslate: o,
    enabled: l,
    animating: c
  } = n;
  if (!l || n.destroyed) return n;
  typeof e > "u" && (e = n.params.speed);
  const u = n.virtual && a.virtual.enabled;
  if (a.loop) {
    if (c && !u && a.loopPreventsSliding) return !1;
    n.loopFix({
      direction: "prev"
    }), n._clientLeft = n.wrapperEl.clientLeft;
  }
  const d = o ? n.translate : -n.translate;
  function f(x) {
    return x < 0 ? -Math.floor(Math.abs(x)) : Math.floor(x);
  }
  const h = f(d), p = s.map((x) => f(x)), m = a.freeMode && a.freeMode.enabled;
  let g = s[p.indexOf(h) - 1];
  if (typeof g > "u" && (a.cssMode || m)) {
    let x;
    s.forEach((w, _) => {
      h >= w && (x = _);
    }), typeof x < "u" && (g = m ? s[x] : s[x > 0 ? x - 1 : x]);
  }
  let y = 0;
  if (typeof g < "u" && (y = i.indexOf(g), y < 0 && (y = n.activeIndex - 1), a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (y = y - n.slidesPerViewDynamic("previous", !0) + 1, y = Math.max(y, 0))), a.rewind && n.isBeginning) {
    const x = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
    return n.slideTo(x, e, t, r);
  } else if (a.loop && n.activeIndex === 0 && a.cssMode)
    return requestAnimationFrame(() => {
      n.slideTo(y, e, t, r);
    }), !0;
  return n.slideTo(y, e, t, r);
}
function NYe(e, t, r) {
  t === void 0 && (t = !0);
  const n = this;
  if (!n.destroyed)
    return typeof e > "u" && (e = n.params.speed), n.slideTo(n.activeIndex, e, t, r);
}
function MYe(e, t, r, n) {
  t === void 0 && (t = !0), n === void 0 && (n = 0.5);
  const a = this;
  if (a.destroyed) return;
  typeof e > "u" && (e = a.params.speed);
  let s = a.activeIndex;
  const i = Math.min(a.params.slidesPerGroupSkip, s), o = i + Math.floor((s - i) / a.params.slidesPerGroup), l = a.rtlTranslate ? a.translate : -a.translate;
  if (l >= a.snapGrid[o]) {
    const c = a.snapGrid[o], u = a.snapGrid[o + 1];
    l - c > (u - c) * n && (s += a.params.slidesPerGroup);
  } else {
    const c = a.snapGrid[o - 1], u = a.snapGrid[o];
    l - c <= (u - c) * n && (s -= a.params.slidesPerGroup);
  }
  return s = Math.max(s, 0), s = Math.min(s, a.slidesGrid.length - 1), a.slideTo(s, e, t, r);
}
function LYe() {
  const e = this;
  if (e.destroyed) return;
  const {
    params: t,
    slidesEl: r
  } = e, n = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
  let a = e.clickedIndex, s;
  const i = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
  if (t.loop) {
    if (e.animating) return;
    s = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? a < e.loopedSlides - n / 2 || a > e.slides.length - e.loopedSlides + n / 2 ? (e.loopFix(), a = e.getSlideIndex(Cl(r, `${i}[data-swiper-slide-index="${s}"]`)[0]), bT(() => {
      e.slideTo(a);
    })) : e.slideTo(a) : a > e.slides.length - n ? (e.loopFix(), a = e.getSlideIndex(Cl(r, `${i}[data-swiper-slide-index="${s}"]`)[0]), bT(() => {
      e.slideTo(a);
    })) : e.slideTo(a);
  } else
    e.slideTo(a);
}
var jYe = {
  slideTo: PYe,
  slideToLoop: RYe,
  slideNext: IYe,
  slidePrev: DYe,
  slideReset: NYe,
  slideToClosest: MYe,
  slideToClickedSlide: LYe
};
function FYe(e, t) {
  const r = this, {
    params: n,
    slidesEl: a
  } = r;
  if (!n.loop || r.virtual && r.params.virtual.enabled) return;
  const s = () => {
    Cl(a, `.${n.slideClass}, swiper-slide`).forEach((f, h) => {
      f.setAttribute("data-swiper-slide-index", h);
    });
  }, i = r.grid && n.grid && n.grid.rows > 1, o = n.slidesPerGroup * (i ? n.grid.rows : 1), l = r.slides.length % o !== 0, c = i && r.slides.length % n.grid.rows !== 0, u = (d) => {
    for (let f = 0; f < d; f += 1) {
      const h = r.isElement ? wT("swiper-slide", [n.slideBlankClass]) : wT("div", [n.slideClass, n.slideBlankClass]);
      r.slidesEl.append(h);
    }
  };
  if (l) {
    if (n.loopAddBlankSlides) {
      const d = o - r.slides.length % o;
      u(d), r.recalcSlides(), r.updateSlides();
    } else
      mw("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    s();
  } else if (c) {
    if (n.loopAddBlankSlides) {
      const d = n.grid.rows - r.slides.length % n.grid.rows;
      u(d), r.recalcSlides(), r.updateSlides();
    } else
      mw("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    s();
  } else
    s();
  r.loopFix({
    slideRealIndex: e,
    direction: n.centeredSlides ? void 0 : "next",
    initial: t
  });
}
function BYe(e) {
  let {
    slideRealIndex: t,
    slideTo: r = !0,
    direction: n,
    setTranslate: a,
    activeSlideIndex: s,
    initial: i,
    byController: o,
    byMousewheel: l
  } = e === void 0 ? {} : e;
  const c = this;
  if (!c.params.loop) return;
  c.emit("beforeLoopFix");
  const {
    slides: u,
    allowSlidePrev: d,
    allowSlideNext: f,
    slidesEl: h,
    params: p
  } = c, {
    centeredSlides: m,
    initialSlide: g
  } = p;
  if (c.allowSlidePrev = !0, c.allowSlideNext = !0, c.virtual && p.virtual.enabled) {
    r && (!p.centeredSlides && c.snapIndex === 0 ? c.slideTo(c.virtual.slides.length, 0, !1, !0) : p.centeredSlides && c.snapIndex < p.slidesPerView ? c.slideTo(c.virtual.slides.length + c.snapIndex, 0, !1, !0) : c.snapIndex === c.snapGrid.length - 1 && c.slideTo(c.virtual.slidesBefore, 0, !1, !0)), c.allowSlidePrev = d, c.allowSlideNext = f, c.emit("loopFix");
    return;
  }
  let y = p.slidesPerView;
  y === "auto" ? y = c.slidesPerViewDynamic() : (y = Math.ceil(parseFloat(p.slidesPerView, 10)), m && y % 2 === 0 && (y = y + 1));
  const x = p.slidesPerGroupAuto ? y : p.slidesPerGroup;
  let w = x;
  w % x !== 0 && (w += x - w % x), w += p.loopAdditionalSlides, c.loopedSlides = w;
  const _ = c.grid && p.grid && p.grid.rows > 1;
  u.length < y + w || c.params.effect === "cards" && u.length < y + w * 2 ? mw("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : _ && p.grid.fill === "row" && mw("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const S = [], C = [], E = _ ? Math.ceil(u.length / p.grid.rows) : u.length, O = i && E - g < y && !m;
  let k = O ? g : c.activeIndex;
  typeof s > "u" ? s = c.getSlideIndex(u.find((Y) => Y.classList.contains(p.slideActiveClass))) : k = s;
  const A = n === "next" || !n, P = n === "prev" || !n;
  let D = 0, N = 0;
  const G = (_ ? u[s].column : s) + (m && typeof a > "u" ? -y / 2 + 0.5 : 0);
  if (G < w) {
    D = Math.max(w - G, x);
    for (let Y = 0; Y < w - G; Y += 1) {
      const te = Y - Math.floor(Y / E) * E;
      if (_) {
        const ae = E - te - 1;
        for (let ne = u.length - 1; ne >= 0; ne -= 1)
          u[ne].column === ae && S.push(ne);
      } else
        S.push(E - te - 1);
    }
  } else if (G + y > E - w) {
    N = Math.max(G - (E - w * 2), x), O && (N = Math.max(N, y - E + g + 1));
    for (let Y = 0; Y < N; Y += 1) {
      const te = Y - Math.floor(Y / E) * E;
      _ ? u.forEach((ae, ne) => {
        ae.column === te && C.push(ne);
      }) : C.push(te);
    }
  }
  if (c.__preventObserver__ = !0, requestAnimationFrame(() => {
    c.__preventObserver__ = !1;
  }), c.params.effect === "cards" && u.length < y + w * 2 && (C.includes(s) && C.splice(C.indexOf(s), 1), S.includes(s) && S.splice(S.indexOf(s), 1)), P && S.forEach((Y) => {
    u[Y].swiperLoopMoveDOM = !0, h.prepend(u[Y]), u[Y].swiperLoopMoveDOM = !1;
  }), A && C.forEach((Y) => {
    u[Y].swiperLoopMoveDOM = !0, h.append(u[Y]), u[Y].swiperLoopMoveDOM = !1;
  }), c.recalcSlides(), p.slidesPerView === "auto" ? c.updateSlides() : _ && (S.length > 0 && P || C.length > 0 && A) && c.slides.forEach((Y, te) => {
    c.grid.updateSlide(te, Y, c.slides);
  }), p.watchSlidesProgress && c.updateSlidesOffset(), r) {
    if (S.length > 0 && P) {
      if (typeof t > "u") {
        const Y = c.slidesGrid[k], ae = c.slidesGrid[k + D] - Y;
        l ? c.setTranslate(c.translate - ae) : (c.slideTo(k + Math.ceil(D), 0, !1, !0), a && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - ae, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - ae));
      } else if (a) {
        const Y = _ ? S.length / p.grid.rows : S.length;
        c.slideTo(c.activeIndex + Y, 0, !1, !0), c.touchEventsData.currentTranslate = c.translate;
      }
    } else if (C.length > 0 && A)
      if (typeof t > "u") {
        const Y = c.slidesGrid[k], ae = c.slidesGrid[k - N] - Y;
        l ? c.setTranslate(c.translate - ae) : (c.slideTo(k - N, 0, !1, !0), a && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - ae, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - ae));
      } else {
        const Y = _ ? C.length / p.grid.rows : C.length;
        c.slideTo(c.activeIndex - Y, 0, !1, !0);
      }
  }
  if (c.allowSlidePrev = d, c.allowSlideNext = f, c.controller && c.controller.control && !o) {
    const Y = {
      slideRealIndex: t,
      direction: n,
      setTranslate: a,
      activeSlideIndex: s,
      byController: !0
    };
    Array.isArray(c.controller.control) ? c.controller.control.forEach((te) => {
      !te.destroyed && te.params.loop && te.loopFix({
        ...Y,
        slideTo: te.params.slidesPerView === p.slidesPerView ? r : !1
      });
    }) : c.controller.control instanceof c.constructor && c.controller.control.params.loop && c.controller.control.loopFix({
      ...Y,
      slideTo: c.controller.control.params.slidesPerView === p.slidesPerView ? r : !1
    });
  }
  c.emit("loopFix");
}
function UYe() {
  const e = this, {
    params: t,
    slidesEl: r
  } = e;
  if (!t.loop || !r || e.virtual && e.params.virtual.enabled) return;
  e.recalcSlides();
  const n = [];
  e.slides.forEach((a) => {
    const s = typeof a.swiperSlideIndex > "u" ? a.getAttribute("data-swiper-slide-index") * 1 : a.swiperSlideIndex;
    n[s] = a;
  }), e.slides.forEach((a) => {
    a.removeAttribute("data-swiper-slide-index");
  }), n.forEach((a) => {
    r.append(a);
  }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
}
var VYe = {
  loopCreate: FYe,
  loopFix: BYe,
  loopDestroy: UYe
};
function $Ye(e) {
  const t = this;
  if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
  const r = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
  t.isElement && (t.__preventObserver__ = !0), r.style.cursor = "move", r.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  });
}
function HYe() {
  const e = this;
  e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  }));
}
var WYe = {
  setGrabCursor: $Ye,
  unsetGrabCursor: HYe
};
function zYe(e, t) {
  t === void 0 && (t = this);
  function r(n) {
    if (!n || n === kd() || n === ps()) return null;
    n.assignedSlot && (n = n.assignedSlot);
    const a = n.closest(e);
    return !a && !n.getRootNode ? null : a || r(n.getRootNode().host);
  }
  return r(t);
}
function x4(e, t, r) {
  const n = ps(), {
    params: a
  } = e, s = a.edgeSwipeDetection, i = a.edgeSwipeThreshold;
  return s && (r <= i || r >= n.innerWidth - i) ? s === "prevent" ? (t.preventDefault(), !0) : !1 : !0;
}
function KYe(e) {
  const t = this, r = kd();
  let n = e;
  n.originalEvent && (n = n.originalEvent);
  const a = t.touchEventsData;
  if (n.type === "pointerdown") {
    if (a.pointerId !== null && a.pointerId !== n.pointerId)
      return;
    a.pointerId = n.pointerId;
  } else n.type === "touchstart" && n.targetTouches.length === 1 && (a.touchId = n.targetTouches[0].identifier);
  if (n.type === "touchstart") {
    x4(t, n, n.targetTouches[0].pageX);
    return;
  }
  const {
    params: s,
    touches: i,
    enabled: o
  } = t;
  if (!o || !s.simulateTouch && n.pointerType === "mouse" || t.animating && s.preventInteractionOnTransition)
    return;
  !t.animating && s.cssMode && s.loop && t.loopFix();
  let l = n.target;
  if (s.touchEventsTarget === "wrapper" && !ZGe(l, t.wrapperEl) || "which" in n && n.which === 3 || "button" in n && n.button > 0 || a.isTouched && a.isMoved) return;
  const c = !!s.noSwipingClass && s.noSwipingClass !== "", u = n.composedPath ? n.composedPath() : n.path;
  c && n.target && n.target.shadowRoot && u && (l = u[0]);
  const d = s.noSwipingSelector ? s.noSwipingSelector : `.${s.noSwipingClass}`, f = !!(n.target && n.target.shadowRoot);
  if (s.noSwiping && (f ? zYe(d, l) : l.closest(d))) {
    t.allowClick = !0;
    return;
  }
  if (s.swipeHandler && !l.closest(s.swipeHandler))
    return;
  i.currentX = n.pageX, i.currentY = n.pageY;
  const h = i.currentX, p = i.currentY;
  if (!x4(t, n, h))
    return;
  Object.assign(a, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), i.startX = h, i.startY = p, a.touchStartTime = pw(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, s.threshold > 0 && (a.allowThresholdMove = !1);
  let m = !0;
  l.matches(a.focusableElements) && (m = !1, l.nodeName === "SELECT" && (a.isTouched = !1)), r.activeElement && r.activeElement.matches(a.focusableElements) && r.activeElement !== l && (n.pointerType === "mouse" || n.pointerType !== "mouse" && !l.matches(a.focusableElements)) && r.activeElement.blur();
  const g = m && t.allowTouchMove && s.touchStartPreventDefault;
  (s.touchStartForcePreventDefault || g) && !l.isContentEditable && n.preventDefault(), s.freeMode && s.freeMode.enabled && t.freeMode && t.animating && !s.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", n);
}
function qYe(e) {
  const t = kd(), r = this, n = r.touchEventsData, {
    params: a,
    touches: s,
    rtlTranslate: i,
    enabled: o
  } = r;
  if (!o || !a.simulateTouch && e.pointerType === "mouse") return;
  let l = e;
  if (l.originalEvent && (l = l.originalEvent), l.type === "pointermove" && (n.touchId !== null || l.pointerId !== n.pointerId))
    return;
  let c;
  if (l.type === "touchmove") {
    if (c = [...l.changedTouches].find((S) => S.identifier === n.touchId), !c || c.identifier !== n.touchId) return;
  } else
    c = l;
  if (!n.isTouched) {
    n.startMoving && n.isScrolling && r.emit("touchMoveOpposite", l);
    return;
  }
  const u = c.pageX, d = c.pageY;
  if (l.preventedByNestedSwiper) {
    s.startX = u, s.startY = d;
    return;
  }
  if (!r.allowTouchMove) {
    l.target.matches(n.focusableElements) || (r.allowClick = !1), n.isTouched && (Object.assign(s, {
      startX: u,
      startY: d,
      currentX: u,
      currentY: d
    }), n.touchStartTime = pw());
    return;
  }
  if (a.touchReleaseOnEdges && !a.loop)
    if (r.isVertical()) {
      if (d < s.startY && r.translate <= r.maxTranslate() || d > s.startY && r.translate >= r.minTranslate()) {
        n.isTouched = !1, n.isMoved = !1;
        return;
      }
    } else {
      if (i && (u > s.startX && -r.translate <= r.maxTranslate() || u < s.startX && -r.translate >= r.minTranslate()))
        return;
      if (!i && (u < s.startX && r.translate <= r.maxTranslate() || u > s.startX && r.translate >= r.minTranslate()))
        return;
    }
  if (t.activeElement && t.activeElement.matches(n.focusableElements) && t.activeElement !== l.target && l.pointerType !== "mouse" && t.activeElement.blur(), t.activeElement && l.target === t.activeElement && l.target.matches(n.focusableElements)) {
    n.isMoved = !0, r.allowClick = !1;
    return;
  }
  n.allowTouchCallbacks && r.emit("touchMove", l), s.previousX = s.currentX, s.previousY = s.currentY, s.currentX = u, s.currentY = d;
  const f = s.currentX - s.startX, h = s.currentY - s.startY;
  if (r.params.threshold && Math.sqrt(f ** 2 + h ** 2) < r.params.threshold) return;
  if (typeof n.isScrolling > "u") {
    let S;
    r.isHorizontal() && s.currentY === s.startY || r.isVertical() && s.currentX === s.startX ? n.isScrolling = !1 : f * f + h * h >= 25 && (S = Math.atan2(Math.abs(h), Math.abs(f)) * 180 / Math.PI, n.isScrolling = r.isHorizontal() ? S > a.touchAngle : 90 - S > a.touchAngle);
  }
  if (n.isScrolling && r.emit("touchMoveOpposite", l), typeof n.startMoving > "u" && (s.currentX !== s.startX || s.currentY !== s.startY) && (n.startMoving = !0), n.isScrolling || l.type === "touchmove" && n.preventTouchMoveFromPointerMove) {
    n.isTouched = !1;
    return;
  }
  if (!n.startMoving)
    return;
  r.allowClick = !1, !a.cssMode && l.cancelable && l.preventDefault(), a.touchMoveStopPropagation && !a.nested && l.stopPropagation();
  let p = r.isHorizontal() ? f : h, m = r.isHorizontal() ? s.currentX - s.previousX : s.currentY - s.previousY;
  a.oneWayMovement && (p = Math.abs(p) * (i ? 1 : -1), m = Math.abs(m) * (i ? 1 : -1)), s.diff = p, p *= a.touchRatio, i && (p = -p, m = -m);
  const g = r.touchesDirection;
  r.swipeDirection = p > 0 ? "prev" : "next", r.touchesDirection = m > 0 ? "prev" : "next";
  const y = r.params.loop && !a.cssMode, x = r.touchesDirection === "next" && r.allowSlideNext || r.touchesDirection === "prev" && r.allowSlidePrev;
  if (!n.isMoved) {
    if (y && x && r.loopFix({
      direction: r.swipeDirection
    }), n.startTranslate = r.getTranslate(), r.setTransition(0), r.animating) {
      const S = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      r.wrapperEl.dispatchEvent(S);
    }
    n.allowMomentumBounce = !1, a.grabCursor && (r.allowSlideNext === !0 || r.allowSlidePrev === !0) && r.setGrabCursor(!0), r.emit("sliderFirstMove", l);
  }
  if ((/* @__PURE__ */ new Date()).getTime(), a._loopSwapReset !== !1 && n.isMoved && n.allowThresholdMove && g !== r.touchesDirection && y && x && Math.abs(p) >= 1) {
    Object.assign(s, {
      startX: u,
      startY: d,
      currentX: u,
      currentY: d,
      startTranslate: n.currentTranslate
    }), n.loopSwapReset = !0, n.startTranslate = n.currentTranslate;
    return;
  }
  r.emit("sliderMove", l), n.isMoved = !0, n.currentTranslate = p + n.startTranslate;
  let w = !0, _ = a.resistanceRatio;
  if (a.touchReleaseOnEdges && (_ = 0), p > 0 ? (y && x && n.allowThresholdMove && n.currentTranslate > (a.centeredSlides ? r.minTranslate() - r.slidesSizesGrid[r.activeIndex + 1] - (a.slidesPerView !== "auto" && r.slides.length - a.slidesPerView >= 2 ? r.slidesSizesGrid[r.activeIndex + 1] + r.params.spaceBetween : 0) - r.params.spaceBetween : r.minTranslate()) && r.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), n.currentTranslate > r.minTranslate() && (w = !1, a.resistance && (n.currentTranslate = r.minTranslate() - 1 + (-r.minTranslate() + n.startTranslate + p) ** _))) : p < 0 && (y && x && n.allowThresholdMove && n.currentTranslate < (a.centeredSlides ? r.maxTranslate() + r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween + (a.slidesPerView !== "auto" && r.slides.length - a.slidesPerView >= 2 ? r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween : 0) : r.maxTranslate()) && r.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: r.slides.length - (a.slidesPerView === "auto" ? r.slidesPerViewDynamic() : Math.ceil(parseFloat(a.slidesPerView, 10)))
  }), n.currentTranslate < r.maxTranslate() && (w = !1, a.resistance && (n.currentTranslate = r.maxTranslate() + 1 - (r.maxTranslate() - n.startTranslate - p) ** _))), w && (l.preventedByNestedSwiper = !0), !r.allowSlideNext && r.swipeDirection === "next" && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !r.allowSlidePrev && r.swipeDirection === "prev" && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), !r.allowSlidePrev && !r.allowSlideNext && (n.currentTranslate = n.startTranslate), a.threshold > 0)
    if (Math.abs(p) > a.threshold || n.allowThresholdMove) {
      if (!n.allowThresholdMove) {
        n.allowThresholdMove = !0, s.startX = s.currentX, s.startY = s.currentY, n.currentTranslate = n.startTranslate, s.diff = r.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY;
        return;
      }
    } else {
      n.currentTranslate = n.startTranslate;
      return;
    }
  !a.followFinger || a.cssMode || ((a.freeMode && a.freeMode.enabled && r.freeMode || a.watchSlidesProgress) && (r.updateActiveIndex(), r.updateSlidesClasses()), a.freeMode && a.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(), r.updateProgress(n.currentTranslate), r.setTranslate(n.currentTranslate));
}
function GYe(e) {
  const t = this, r = t.touchEventsData;
  let n = e;
  n.originalEvent && (n = n.originalEvent);
  let a;
  if (n.type === "touchend" || n.type === "touchcancel") {
    if (a = [...n.changedTouches].find((S) => S.identifier === r.touchId), !a || a.identifier !== r.touchId) return;
  } else {
    if (r.touchId !== null || n.pointerId !== r.pointerId) return;
    a = n;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(n.type) && !(["pointercancel", "contextmenu"].includes(n.type) && (t.browser.isSafari || t.browser.isWebView)))
    return;
  r.pointerId = null, r.touchId = null;
  const {
    params: i,
    touches: o,
    rtlTranslate: l,
    slidesGrid: c,
    enabled: u
  } = t;
  if (!u || !i.simulateTouch && n.pointerType === "mouse") return;
  if (r.allowTouchCallbacks && t.emit("touchEnd", n), r.allowTouchCallbacks = !1, !r.isTouched) {
    r.isMoved && i.grabCursor && t.setGrabCursor(!1), r.isMoved = !1, r.startMoving = !1;
    return;
  }
  i.grabCursor && r.isMoved && r.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
  const d = pw(), f = d - r.touchStartTime;
  if (t.allowClick) {
    const S = n.path || n.composedPath && n.composedPath();
    t.updateClickedSlide(S && S[0] || n.target, S), t.emit("tap click", n), f < 300 && d - r.lastClickTime < 300 && t.emit("doubleTap doubleClick", n);
  }
  if (r.lastClickTime = pw(), bT(() => {
    t.destroyed || (t.allowClick = !0);
  }), !r.isTouched || !r.isMoved || !t.swipeDirection || o.diff === 0 && !r.loopSwapReset || r.currentTranslate === r.startTranslate && !r.loopSwapReset) {
    r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
    return;
  }
  r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
  let h;
  if (i.followFinger ? h = l ? t.translate : -t.translate : h = -r.currentTranslate, i.cssMode)
    return;
  if (i.freeMode && i.freeMode.enabled) {
    t.freeMode.onTouchEnd({
      currentPos: h
    });
    return;
  }
  const p = h >= -t.maxTranslate() && !t.params.loop;
  let m = 0, g = t.slidesSizesGrid[0];
  for (let S = 0; S < c.length; S += S < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
    const C = S < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
    typeof c[S + C] < "u" ? (p || h >= c[S] && h < c[S + C]) && (m = S, g = c[S + C] - c[S]) : (p || h >= c[S]) && (m = S, g = c[c.length - 1] - c[c.length - 2]);
  }
  let y = null, x = null;
  i.rewind && (t.isBeginning ? x = i.virtual && i.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (y = 0));
  const w = (h - c[m]) / g, _ = m < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
  if (f > i.longSwipesMs) {
    if (!i.longSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.swipeDirection === "next" && (w >= i.longSwipesRatio ? t.slideTo(i.rewind && t.isEnd ? y : m + _) : t.slideTo(m)), t.swipeDirection === "prev" && (w > 1 - i.longSwipesRatio ? t.slideTo(m + _) : x !== null && w < 0 && Math.abs(w) > i.longSwipesRatio ? t.slideTo(x) : t.slideTo(m));
  } else {
    if (!i.shortSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.navigation && (n.target === t.navigation.nextEl || n.target === t.navigation.prevEl) ? n.target === t.navigation.nextEl ? t.slideTo(m + _) : t.slideTo(m) : (t.swipeDirection === "next" && t.slideTo(y !== null ? y : m + _), t.swipeDirection === "prev" && t.slideTo(x !== null ? x : m));
  }
}
function _4() {
  const e = this, {
    params: t,
    el: r
  } = e;
  if (r && r.offsetWidth === 0) return;
  t.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: n,
    allowSlidePrev: a,
    snapGrid: s
  } = e, i = e.virtual && e.params.virtual.enabled;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
  const o = i && t.loop;
  (t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !o ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.params.loop && !i ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
    e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
  }, 500)), e.allowSlidePrev = a, e.allowSlideNext = n, e.params.watchOverflow && s !== e.snapGrid && e.checkOverflow();
}
function YYe(e) {
  const t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function XYe() {
  const e = this, {
    wrapperEl: t,
    rtlTranslate: r,
    enabled: n
  } = e;
  if (!n) return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let a;
  const s = e.maxTranslate() - e.minTranslate();
  s === 0 ? a = 0 : a = (e.translate - e.minTranslate()) / s, a !== e.progress && e.updateProgress(r ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function QYe(e) {
  const t = this;
  Ny(t, e.target), !(t.params.cssMode || t.params.slidesPerView !== "auto" && !t.params.autoHeight) && t.update();
}
function JYe() {
  const e = this;
  e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
}
const AW = (e, t) => {
  const r = kd(), {
    params: n,
    el: a,
    wrapperEl: s,
    device: i
  } = e, o = !!n.nested, l = t === "on" ? "addEventListener" : "removeEventListener", c = t;
  !a || typeof a == "string" || (r[l]("touchstart", e.onDocumentTouchStart, {
    passive: !1,
    capture: o
  }), a[l]("touchstart", e.onTouchStart, {
    passive: !1
  }), a[l]("pointerdown", e.onTouchStart, {
    passive: !1
  }), r[l]("touchmove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), r[l]("pointermove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), r[l]("touchend", e.onTouchEnd, {
    passive: !0
  }), r[l]("pointerup", e.onTouchEnd, {
    passive: !0
  }), r[l]("pointercancel", e.onTouchEnd, {
    passive: !0
  }), r[l]("touchcancel", e.onTouchEnd, {
    passive: !0
  }), r[l]("pointerout", e.onTouchEnd, {
    passive: !0
  }), r[l]("pointerleave", e.onTouchEnd, {
    passive: !0
  }), r[l]("contextmenu", e.onTouchEnd, {
    passive: !0
  }), (n.preventClicks || n.preventClicksPropagation) && a[l]("click", e.onClick, !0), n.cssMode && s[l]("scroll", e.onScroll), n.updateOnWindowResize ? e[c](i.ios || i.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", _4, !0) : e[c]("observerUpdate", _4, !0), a[l]("load", e.onLoad, {
    capture: !0
  }));
};
function ZYe() {
  const e = this, {
    params: t
  } = e;
  e.onTouchStart = KYe.bind(e), e.onTouchMove = qYe.bind(e), e.onTouchEnd = GYe.bind(e), e.onDocumentTouchStart = JYe.bind(e), t.cssMode && (e.onScroll = XYe.bind(e)), e.onClick = YYe.bind(e), e.onLoad = QYe.bind(e), AW(e, "on");
}
function eXe() {
  AW(this, "off");
}
var tXe = {
  attachEvents: ZYe,
  detachEvents: eXe
};
const S4 = (e, t) => e.grid && t.grid && t.grid.rows > 1;
function rXe() {
  const e = this, {
    realIndex: t,
    initialized: r,
    params: n,
    el: a
  } = e, s = n.breakpoints;
  if (!s || s && Object.keys(s).length === 0) return;
  const i = kd(), o = n.breakpointsBase === "window" || !n.breakpointsBase ? n.breakpointsBase : "container", l = ["window", "container"].includes(n.breakpointsBase) || !n.breakpointsBase ? e.el : i.querySelector(n.breakpointsBase), c = e.getBreakpoint(s, o, l);
  if (!c || e.currentBreakpoint === c) return;
  const d = (c in s ? s[c] : void 0) || e.originalParams, f = S4(e, n), h = S4(e, d), p = e.params.grabCursor, m = d.grabCursor, g = n.enabled;
  f && !h ? (a.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), e.emitContainerClasses()) : !f && h && (a.classList.add(`${n.containerModifierClass}grid`), (d.grid.fill && d.grid.fill === "column" || !d.grid.fill && n.grid.fill === "column") && a.classList.add(`${n.containerModifierClass}grid-column`), e.emitContainerClasses()), p && !m ? e.unsetGrabCursor() : !p && m && e.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((C) => {
    if (typeof d[C] > "u") return;
    const E = n[C] && n[C].enabled, O = d[C] && d[C].enabled;
    E && !O && e[C].disable(), !E && O && e[C].enable();
  });
  const y = d.direction && d.direction !== n.direction, x = n.loop && (d.slidesPerView !== n.slidesPerView || y), w = n.loop;
  y && r && e.changeDirection(), Bs(e.params, d);
  const _ = e.params.enabled, S = e.params.loop;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), g && !_ ? e.disable() : !g && _ && e.enable(), e.currentBreakpoint = c, e.emit("_beforeBreakpoint", d), r && (x ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !w && S ? (e.loopCreate(t), e.updateSlides()) : w && !S && e.loopDestroy()), e.emit("breakpoint", d);
}
function nXe(e, t, r) {
  if (t === void 0 && (t = "window"), !e || t === "container" && !r) return;
  let n = !1;
  const a = ps(), s = t === "window" ? a.innerHeight : r.clientHeight, i = Object.keys(e).map((o) => {
    if (typeof o == "string" && o.indexOf("@") === 0) {
      const l = parseFloat(o.substr(1));
      return {
        value: s * l,
        point: o
      };
    }
    return {
      value: o,
      point: o
    };
  });
  i.sort((o, l) => parseInt(o.value, 10) - parseInt(l.value, 10));
  for (let o = 0; o < i.length; o += 1) {
    const {
      point: l,
      value: c
    } = i[o];
    t === "window" ? a.matchMedia(`(min-width: ${c}px)`).matches && (n = l) : c <= r.clientWidth && (n = l);
  }
  return n || "max";
}
var aXe = {
  setBreakpoint: rXe,
  getBreakpoint: nXe
};
function sXe(e, t) {
  const r = [];
  return e.forEach((n) => {
    typeof n == "object" ? Object.keys(n).forEach((a) => {
      n[a] && r.push(t + a);
    }) : typeof n == "string" && r.push(t + n);
  }), r;
}
function iXe() {
  const e = this, {
    classNames: t,
    params: r,
    rtl: n,
    el: a,
    device: s
  } = e, i = sXe(["initialized", r.direction, {
    "free-mode": e.params.freeMode && r.freeMode.enabled
  }, {
    autoheight: r.autoHeight
  }, {
    rtl: n
  }, {
    grid: r.grid && r.grid.rows > 1
  }, {
    "grid-column": r.grid && r.grid.rows > 1 && r.grid.fill === "column"
  }, {
    android: s.android
  }, {
    ios: s.ios
  }, {
    "css-mode": r.cssMode
  }, {
    centered: r.cssMode && r.centeredSlides
  }, {
    "watch-progress": r.watchSlidesProgress
  }], r.containerModifierClass);
  t.push(...i), a.classList.add(...t), e.emitContainerClasses();
}
function oXe() {
  const e = this, {
    el: t,
    classNames: r
  } = e;
  !t || typeof t == "string" || (t.classList.remove(...r), e.emitContainerClasses());
}
var lXe = {
  addClasses: iXe,
  removeClasses: oXe
};
function cXe() {
  const e = this, {
    isLocked: t,
    params: r
  } = e, {
    slidesOffsetBefore: n
  } = r;
  if (n) {
    const a = e.slides.length - 1, s = e.slidesGrid[a] + e.slidesSizesGrid[a] + n * 2;
    e.isLocked = e.size > s;
  } else
    e.isLocked = e.snapGrid.length === 1;
  r.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), r.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
var uXe = {
  checkOverflow: cXe
}, _T = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function dXe(e, t) {
  return function(n) {
    n === void 0 && (n = {});
    const a = Object.keys(n)[0], s = n[a];
    if (typeof s != "object" || s === null) {
      Bs(t, n);
      return;
    }
    if (e[a] === !0 && (e[a] = {
      enabled: !0
    }), a === "navigation" && e[a] && e[a].enabled && !e[a].prevEl && !e[a].nextEl && (e[a].auto = !0), ["pagination", "scrollbar"].indexOf(a) >= 0 && e[a] && e[a].enabled && !e[a].el && (e[a].auto = !0), !(a in e && "enabled" in s)) {
      Bs(t, n);
      return;
    }
    typeof e[a] == "object" && !("enabled" in e[a]) && (e[a].enabled = !0), e[a] || (e[a] = {
      enabled: !1
    }), Bs(t, n);
  };
}
const FS = {
  eventsEmitter: lYe,
  update: bYe,
  translate: TYe,
  transition: AYe,
  slide: jYe,
  loop: VYe,
  grabCursor: WYe,
  events: tXe,
  breakpoints: aXe,
  checkOverflow: uXe,
  classes: lXe
}, BS = {};
let sO = class vl {
  constructor() {
    let t, r;
    for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
      a[s] = arguments[s];
    a.length === 1 && a[0].constructor && Object.prototype.toString.call(a[0]).slice(8, -1) === "Object" ? r = a[0] : [t, r] = a, r || (r = {}), r = Bs({}, r), t && !r.el && (r.el = t);
    const i = kd();
    if (r.el && typeof r.el == "string" && i.querySelectorAll(r.el).length > 1) {
      const u = [];
      return i.querySelectorAll(r.el).forEach((d) => {
        const f = Bs({}, r, {
          el: d
        });
        u.push(new vl(f));
      }), u;
    }
    const o = this;
    o.__swiper__ = !0, o.support = TW(), o.device = CW({
      userAgent: r.userAgent
    }), o.browser = kW(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = [...o.__modules__], r.modules && Array.isArray(r.modules) && o.modules.push(...r.modules);
    const l = {};
    o.modules.forEach((u) => {
      u({
        params: r,
        swiper: o,
        extendParams: dXe(r, l),
        on: o.on.bind(o),
        once: o.once.bind(o),
        off: o.off.bind(o),
        emit: o.emit.bind(o)
      });
    });
    const c = Bs({}, _T, l);
    return o.params = Bs({}, c, BS, r), o.originalParams = Bs({}, o.params), o.passedParams = Bs({}, r), o.params && o.params.on && Object.keys(o.params.on).forEach((u) => {
      o.on(u, o.params.on[u]);
    }), o.params && o.params.onAny && o.onAny(o.params.onAny), Object.assign(o, {
      enabled: o.params.enabled,
      el: t,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return o.params.direction === "horizontal";
      },
      isVertical() {
        return o.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: o.params.allowSlideNext,
      allowSlidePrev: o.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: o.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: o.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), o.emit("_swiper"), o.params.init && o.init(), o;
  }
  getDirectionLabel(t) {
    return this.isHorizontal() ? t : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[t];
  }
  getSlideIndex(t) {
    const {
      slidesEl: r,
      params: n
    } = this, a = Cl(r, `.${n.slideClass}, swiper-slide`), s = y4(a[0]);
    return y4(t) - s;
  }
  getSlideIndexByData(t) {
    return this.getSlideIndex(this.slides.find((r) => r.getAttribute("data-swiper-slide-index") * 1 === t));
  }
  recalcSlides() {
    const t = this, {
      slidesEl: r,
      params: n
    } = t;
    t.slides = Cl(r, `.${n.slideClass}, swiper-slide`);
  }
  enable() {
    const t = this;
    t.enabled || (t.enabled = !0, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
  }
  disable() {
    const t = this;
    t.enabled && (t.enabled = !1, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
  }
  setProgress(t, r) {
    const n = this;
    t = Math.min(Math.max(t, 0), 1);
    const a = n.minTranslate(), i = (n.maxTranslate() - a) * t + a;
    n.translateTo(i, typeof r > "u" ? 0 : r), n.updateActiveIndex(), n.updateSlidesClasses();
  }
  emitContainerClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const r = t.el.className.split(" ").filter((n) => n.indexOf("swiper") === 0 || n.indexOf(t.params.containerModifierClass) === 0);
    t.emit("_containerClasses", r.join(" "));
  }
  getSlideClasses(t) {
    const r = this;
    return r.destroyed ? "" : t.className.split(" ").filter((n) => n.indexOf("swiper-slide") === 0 || n.indexOf(r.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const r = [];
    t.slides.forEach((n) => {
      const a = t.getSlideClasses(n);
      r.push({
        slideEl: n,
        classNames: a
      }), t.emit("_slideClass", n, a);
    }), t.emit("_slideClasses", r);
  }
  slidesPerViewDynamic(t, r) {
    t === void 0 && (t = "current"), r === void 0 && (r = !1);
    const n = this, {
      params: a,
      slides: s,
      slidesGrid: i,
      slidesSizesGrid: o,
      size: l,
      activeIndex: c
    } = n;
    let u = 1;
    if (typeof a.slidesPerView == "number") return a.slidesPerView;
    if (a.centeredSlides) {
      let d = s[c] ? Math.ceil(s[c].swiperSlideSize) : 0, f;
      for (let h = c + 1; h < s.length; h += 1)
        s[h] && !f && (d += Math.ceil(s[h].swiperSlideSize), u += 1, d > l && (f = !0));
      for (let h = c - 1; h >= 0; h -= 1)
        s[h] && !f && (d += s[h].swiperSlideSize, u += 1, d > l && (f = !0));
    } else if (t === "current")
      for (let d = c + 1; d < s.length; d += 1)
        (r ? i[d] + o[d] - i[c] < l : i[d] - i[c] < l) && (u += 1);
    else
      for (let d = c - 1; d >= 0; d -= 1)
        i[c] - i[d] < l && (u += 1);
    return u;
  }
  update() {
    const t = this;
    if (!t || t.destroyed) return;
    const {
      snapGrid: r,
      params: n
    } = t;
    n.breakpoints && t.setBreakpoint(), [...t.el.querySelectorAll('[loading="lazy"]')].forEach((i) => {
      i.complete && Ny(t, i);
    }), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses();
    function a() {
      const i = t.rtlTranslate ? t.translate * -1 : t.translate, o = Math.min(Math.max(i, t.maxTranslate()), t.minTranslate());
      t.setTranslate(o), t.updateActiveIndex(), t.updateSlidesClasses();
    }
    let s;
    if (n.freeMode && n.freeMode.enabled && !n.cssMode)
      a(), n.autoHeight && t.updateAutoHeight();
    else {
      if ((n.slidesPerView === "auto" || n.slidesPerView > 1) && t.isEnd && !n.centeredSlides) {
        const i = t.virtual && n.virtual.enabled ? t.virtual.slides : t.slides;
        s = t.slideTo(i.length - 1, 0, !1, !0);
      } else
        s = t.slideTo(t.activeIndex, 0, !1, !0);
      s || a();
    }
    n.watchOverflow && r !== t.snapGrid && t.checkOverflow(), t.emit("update");
  }
  changeDirection(t, r) {
    r === void 0 && (r = !0);
    const n = this, a = n.params.direction;
    return t || (t = a === "horizontal" ? "vertical" : "horizontal"), t === a || t !== "horizontal" && t !== "vertical" || (n.el.classList.remove(`${n.params.containerModifierClass}${a}`), n.el.classList.add(`${n.params.containerModifierClass}${t}`), n.emitContainerClasses(), n.params.direction = t, n.slides.forEach((s) => {
      t === "vertical" ? s.style.width = "" : s.style.height = "";
    }), n.emit("changeDirection"), r && n.update()), n;
  }
  changeLanguageDirection(t) {
    const r = this;
    r.rtl && t === "rtl" || !r.rtl && t === "ltr" || (r.rtl = t === "rtl", r.rtlTranslate = r.params.direction === "horizontal" && r.rtl, r.rtl ? (r.el.classList.add(`${r.params.containerModifierClass}rtl`), r.el.dir = "rtl") : (r.el.classList.remove(`${r.params.containerModifierClass}rtl`), r.el.dir = "ltr"), r.update());
  }
  mount(t) {
    const r = this;
    if (r.mounted) return !0;
    let n = t || r.params.el;
    if (typeof n == "string" && (n = document.querySelector(n)), !n)
      return !1;
    n.swiper = r, n.parentNode && n.parentNode.host && n.parentNode.host.nodeName === r.params.swiperElementNodeName.toUpperCase() && (r.isElement = !0);
    const a = () => `.${(r.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let i = n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(a()) : Cl(n, a())[0];
    return !i && r.params.createElements && (i = wT("div", r.params.wrapperClass), n.append(i), Cl(n, `.${r.params.slideClass}`).forEach((o) => {
      i.append(o);
    })), Object.assign(r, {
      el: n,
      wrapperEl: i,
      slidesEl: r.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : i,
      hostEl: r.isElement ? n.parentNode.host : n,
      mounted: !0,
      // RTL
      rtl: n.dir.toLowerCase() === "rtl" || Sc(n, "direction") === "rtl",
      rtlTranslate: r.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || Sc(n, "direction") === "rtl"),
      wrongRTL: Sc(i, "display") === "-webkit-box"
    }), !0;
  }
  init(t) {
    const r = this;
    if (r.initialized || r.mount(t) === !1) return r;
    r.emit("beforeInit"), r.params.breakpoints && r.setBreakpoint(), r.addClasses(), r.updateSize(), r.updateSlides(), r.params.watchOverflow && r.checkOverflow(), r.params.grabCursor && r.enabled && r.setGrabCursor(), r.params.loop && r.virtual && r.params.virtual.enabled ? r.slideTo(r.params.initialSlide + r.virtual.slidesBefore, 0, r.params.runCallbacksOnInit, !1, !0) : r.slideTo(r.params.initialSlide, 0, r.params.runCallbacksOnInit, !1, !0), r.params.loop && r.loopCreate(void 0, !0), r.attachEvents();
    const a = [...r.el.querySelectorAll('[loading="lazy"]')];
    return r.isElement && a.push(...r.hostEl.querySelectorAll('[loading="lazy"]')), a.forEach((s) => {
      s.complete ? Ny(r, s) : s.addEventListener("load", (i) => {
        Ny(r, i.target);
      });
    }), xT(r), r.initialized = !0, xT(r), r.emit("init"), r.emit("afterInit"), r;
  }
  destroy(t, r) {
    t === void 0 && (t = !0), r === void 0 && (r = !0);
    const n = this, {
      params: a,
      el: s,
      wrapperEl: i,
      slides: o
    } = n;
    return typeof n.params > "u" || n.destroyed || (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), a.loop && n.loopDestroy(), r && (n.removeClasses(), s && typeof s != "string" && s.removeAttribute("style"), i && i.removeAttribute("style"), o && o.length && o.forEach((l) => {
      l.classList.remove(a.slideVisibleClass, a.slideFullyVisibleClass, a.slideActiveClass, a.slideNextClass, a.slidePrevClass), l.removeAttribute("style"), l.removeAttribute("data-swiper-slide-index");
    })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((l) => {
      n.off(l);
    }), t !== !1 && (n.el && typeof n.el != "string" && (n.el.swiper = null), GGe(n)), n.destroyed = !0), null;
  }
  static extendDefaults(t) {
    Bs(BS, t);
  }
  static get extendedDefaults() {
    return BS;
  }
  static get defaults() {
    return _T;
  }
  static installModule(t) {
    vl.prototype.__modules__ || (vl.prototype.__modules__ = []);
    const r = vl.prototype.__modules__;
    typeof t == "function" && r.indexOf(t) < 0 && r.push(t);
  }
  static use(t) {
    return Array.isArray(t) ? (t.forEach((r) => vl.installModule(r)), vl) : (vl.installModule(t), vl);
  }
};
Object.keys(FS).forEach((e) => {
  Object.keys(FS[e]).forEach((t) => {
    sO.prototype[t] = FS[e][t];
  });
});
sO.use([iYe, oYe]);
const PW = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function Zu(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object" && !e.__swiper__;
}
function Gf(e, t) {
  const r = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter((n) => r.indexOf(n) < 0).forEach((n) => {
    typeof e[n] > "u" ? e[n] = t[n] : Zu(t[n]) && Zu(e[n]) && Object.keys(t[n]).length > 0 ? t[n].__swiper__ ? e[n] = t[n] : Gf(e[n], t[n]) : e[n] = t[n];
  });
}
function RW(e) {
  return e === void 0 && (e = {}), e.navigation && typeof e.navigation.nextEl > "u" && typeof e.navigation.prevEl > "u";
}
function IW(e) {
  return e === void 0 && (e = {}), e.pagination && typeof e.pagination.el > "u";
}
function DW(e) {
  return e === void 0 && (e = {}), e.scrollbar && typeof e.scrollbar.el > "u";
}
function NW(e) {
  e === void 0 && (e = "");
  const t = e.split(" ").map((n) => n.trim()).filter((n) => !!n), r = [];
  return t.forEach((n) => {
    r.indexOf(n) < 0 && r.push(n);
  }), r.join(" ");
}
function fXe(e) {
  return e === void 0 && (e = ""), e ? e.includes("swiper-wrapper") ? e : `swiper-wrapper ${e}` : "swiper-wrapper";
}
function hXe(e) {
  let {
    swiper: t,
    slides: r,
    passedParams: n,
    changedParams: a,
    nextEl: s,
    prevEl: i,
    scrollbarEl: o,
    paginationEl: l
  } = e;
  const c = a.filter((k) => k !== "children" && k !== "direction" && k !== "wrapperClass"), {
    params: u,
    pagination: d,
    navigation: f,
    scrollbar: h,
    virtual: p,
    thumbs: m
  } = t;
  let g, y, x, w, _, S, C, E;
  a.includes("thumbs") && n.thumbs && n.thumbs.swiper && !n.thumbs.swiper.destroyed && u.thumbs && (!u.thumbs.swiper || u.thumbs.swiper.destroyed) && (g = !0), a.includes("controller") && n.controller && n.controller.control && u.controller && !u.controller.control && (y = !0), a.includes("pagination") && n.pagination && (n.pagination.el || l) && (u.pagination || u.pagination === !1) && d && !d.el && (x = !0), a.includes("scrollbar") && n.scrollbar && (n.scrollbar.el || o) && (u.scrollbar || u.scrollbar === !1) && h && !h.el && (w = !0), a.includes("navigation") && n.navigation && (n.navigation.prevEl || i) && (n.navigation.nextEl || s) && (u.navigation || u.navigation === !1) && f && !f.prevEl && !f.nextEl && (_ = !0);
  const O = (k) => {
    t[k] && (t[k].destroy(), k === "navigation" ? (t.isElement && (t[k].prevEl.remove(), t[k].nextEl.remove()), u[k].prevEl = void 0, u[k].nextEl = void 0, t[k].prevEl = void 0, t[k].nextEl = void 0) : (t.isElement && t[k].el.remove(), u[k].el = void 0, t[k].el = void 0));
  };
  a.includes("loop") && t.isElement && (u.loop && !n.loop ? S = !0 : !u.loop && n.loop ? C = !0 : E = !0), c.forEach((k) => {
    if (Zu(u[k]) && Zu(n[k]))
      Object.assign(u[k], n[k]), (k === "navigation" || k === "pagination" || k === "scrollbar") && "enabled" in n[k] && !n[k].enabled && O(k);
    else {
      const A = n[k];
      (A === !0 || A === !1) && (k === "navigation" || k === "pagination" || k === "scrollbar") ? A === !1 && O(k) : u[k] = n[k];
    }
  }), c.includes("controller") && !y && t.controller && t.controller.control && u.controller && u.controller.control && (t.controller.control = u.controller.control), a.includes("children") && r && p && u.virtual.enabled ? (p.slides = r, p.update(!0)) : a.includes("virtual") && p && u.virtual.enabled && (r && (p.slides = r), p.update(!0)), a.includes("children") && r && u.loop && (E = !0), g && m.init() && m.update(!0), y && (t.controller.control = u.controller.control), x && (t.isElement && (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-pagination"), l.part.add("pagination"), t.el.appendChild(l)), l && (u.pagination.el = l), d.init(), d.render(), d.update()), w && (t.isElement && (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-scrollbar"), o.part.add("scrollbar"), t.el.appendChild(o)), o && (u.scrollbar.el = o), h.init(), h.updateSize(), h.setTranslate()), _ && (t.isElement && ((!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-button-next"), s.innerHTML = t.hostEl.constructor.nextButtonSvg, s.part.add("button-next"), t.el.appendChild(s)), (!i || typeof i == "string") && (i = document.createElement("div"), i.classList.add("swiper-button-prev"), i.innerHTML = t.hostEl.constructor.prevButtonSvg, i.part.add("button-prev"), t.el.appendChild(i))), s && (u.navigation.nextEl = s), i && (u.navigation.prevEl = i), f.init(), f.update()), a.includes("allowSlideNext") && (t.allowSlideNext = n.allowSlideNext), a.includes("allowSlidePrev") && (t.allowSlidePrev = n.allowSlidePrev), a.includes("direction") && t.changeDirection(n.direction, !1), (S || E) && t.loopDestroy(), (C || E) && t.loopCreate(), t.update();
}
function pXe(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = !0);
  const r = {
    on: {}
  }, n = {}, a = {};
  Gf(r, _T), r._emitClasses = !0, r.init = !1;
  const s = {}, i = PW.map((l) => l.replace(/_/, "")), o = Object.assign({}, e);
  return Object.keys(o).forEach((l) => {
    typeof e[l] > "u" || (i.indexOf(l) >= 0 ? Zu(e[l]) ? (r[l] = {}, a[l] = {}, Gf(r[l], e[l]), Gf(a[l], e[l])) : (r[l] = e[l], a[l] = e[l]) : l.search(/on[A-Z]/) === 0 && typeof e[l] == "function" ? t ? n[`${l[2].toLowerCase()}${l.substr(3)}`] = e[l] : r.on[`${l[2].toLowerCase()}${l.substr(3)}`] = e[l] : s[l] = e[l]);
  }), ["navigation", "pagination", "scrollbar"].forEach((l) => {
    r[l] === !0 && (r[l] = {}), r[l] === !1 && delete r[l];
  }), {
    params: r,
    passedParams: a,
    rest: s,
    events: n
  };
}
function mXe(e, t) {
  let {
    el: r,
    nextEl: n,
    prevEl: a,
    paginationEl: s,
    scrollbarEl: i,
    swiper: o
  } = e;
  RW(t) && n && a && (o.params.navigation.nextEl = n, o.originalParams.navigation.nextEl = n, o.params.navigation.prevEl = a, o.originalParams.navigation.prevEl = a), IW(t) && s && (o.params.pagination.el = s, o.originalParams.pagination.el = s), DW(t) && i && (o.params.scrollbar.el = i, o.originalParams.scrollbar.el = i), o.init(r);
}
function gXe(e, t, r, n, a) {
  const s = [];
  if (!t) return s;
  const i = (l) => {
    s.indexOf(l) < 0 && s.push(l);
  };
  if (r && n) {
    const l = n.map(a), c = r.map(a);
    l.join("") !== c.join("") && i("children"), n.length !== r.length && i("children");
  }
  return PW.filter((l) => l[0] === "_").map((l) => l.replace(/_/, "")).forEach((l) => {
    if (l in e && l in t)
      if (Zu(e[l]) && Zu(t[l])) {
        const c = Object.keys(e[l]), u = Object.keys(t[l]);
        c.length !== u.length ? i(l) : (c.forEach((d) => {
          e[l][d] !== t[l][d] && i(l);
        }), u.forEach((d) => {
          e[l][d] !== t[l][d] && i(l);
        }));
      } else e[l] !== t[l] && i(l);
  }), s;
}
const vXe = (e) => {
  !e || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
};
function gw() {
  return gw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gw.apply(this, arguments);
}
function MW(e) {
  return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function LW(e) {
  const t = [];
  return M.Children.toArray(e).forEach((r) => {
    MW(r) ? t.push(r) : r.props && r.props.children && LW(r.props.children).forEach((n) => t.push(n));
  }), t;
}
function yXe(e) {
  const t = [], r = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return M.Children.toArray(e).forEach((n) => {
    if (MW(n))
      t.push(n);
    else if (n.props && n.props.slot && r[n.props.slot])
      r[n.props.slot].push(n);
    else if (n.props && n.props.children) {
      const a = LW(n.props.children);
      a.length > 0 ? a.forEach((s) => t.push(s)) : r["container-end"].push(n);
    } else
      r["container-end"].push(n);
  }), {
    slides: t,
    slots: r
  };
}
function bXe(e, t, r) {
  if (!r) return null;
  const n = (u) => {
    let d = u;
    return u < 0 ? d = t.length + u : d >= t.length && (d = d - t.length), d;
  }, a = e.isHorizontal() ? {
    [e.rtlTranslate ? "right" : "left"]: `${r.offset}px`
  } : {
    top: `${r.offset}px`
  }, {
    from: s,
    to: i
  } = r, o = e.params.loop ? -t.length : 0, l = e.params.loop ? t.length * 2 : t.length, c = [];
  for (let u = o; u < l; u += 1)
    u >= s && u <= i && c.push(t[n(u)]);
  return c.map((u, d) => /* @__PURE__ */ M.cloneElement(u, {
    swiper: e,
    style: a,
    key: u.props.virtualIndex || u.key || `slide-${d}`
  }));
}
function Im(e, t) {
  return typeof window > "u" ? wt(e, t) : kT(e, t);
}
const E4 = /* @__PURE__ */ Vl(null), wXe = /* @__PURE__ */ Vl(null), jW = /* @__PURE__ */ va(function(e, t) {
  let {
    className: r,
    tag: n = "div",
    wrapperTag: a = "div",
    children: s,
    onSwiper: i,
    ...o
  } = e === void 0 ? {} : e, l = !1;
  const [c, u] = Me("swiper"), [d, f] = Me(null), [h, p] = Me(!1), m = tr(!1), g = tr(null), y = tr(null), x = tr(null), w = tr(null), _ = tr(null), S = tr(null), C = tr(null), E = tr(null), {
    params: O,
    passedParams: k,
    rest: A,
    events: P
  } = pXe(o), {
    slides: D,
    slots: N
  } = yXe(s), z = () => {
    p(!h);
  };
  Object.assign(O.on, {
    _containerClasses(ne, ue) {
      u(ue);
    }
  });
  const G = () => {
    Object.assign(O.on, P), l = !0;
    const ne = {
      ...O
    };
    if (delete ne.wrapperClass, y.current = new sO(ne), y.current.virtual && y.current.params.virtual.enabled) {
      y.current.virtual.slides = D;
      const ue = {
        cache: !1,
        slides: D,
        renderExternal: f,
        renderExternalUpdate: !1
      };
      Gf(y.current.params.virtual, ue), Gf(y.current.originalParams.virtual, ue);
    }
  };
  g.current || G(), y.current && y.current.on("_beforeBreakpoint", z);
  const Y = () => {
    l || !P || !y.current || Object.keys(P).forEach((ne) => {
      y.current.on(ne, P[ne]);
    });
  }, te = () => {
    !P || !y.current || Object.keys(P).forEach((ne) => {
      y.current.off(ne, P[ne]);
    });
  };
  wt(() => () => {
    y.current && y.current.off("_beforeBreakpoint", z);
  }), wt(() => {
    !m.current && y.current && (y.current.emitSlidesClasses(), m.current = !0);
  }), Im(() => {
    if (t && (t.current = g.current), !!g.current)
      return y.current.destroyed && G(), mXe({
        el: g.current,
        nextEl: _.current,
        prevEl: S.current,
        paginationEl: C.current,
        scrollbarEl: E.current,
        swiper: y.current
      }, O), i && !y.current.destroyed && i(y.current), () => {
        y.current && !y.current.destroyed && y.current.destroy(!0, !1);
      };
  }, []), Im(() => {
    Y();
    const ne = gXe(k, x.current, D, w.current, (ue) => ue.key);
    return x.current = k, w.current = D, ne.length && y.current && !y.current.destroyed && hXe({
      swiper: y.current,
      slides: D,
      passedParams: k,
      changedParams: ne,
      nextEl: _.current,
      prevEl: S.current,
      scrollbarEl: E.current,
      paginationEl: C.current
    }), () => {
      te();
    };
  }), Im(() => {
    vXe(y.current);
  }, [d]);
  function ae() {
    return O.virtual ? bXe(y.current, D, d) : D.map((ne, ue) => /* @__PURE__ */ M.cloneElement(ne, {
      swiper: y.current,
      swiperSlideIndex: ue
    }));
  }
  return /* @__PURE__ */ M.createElement(n, gw({
    ref: g,
    className: NW(`${c}${r ? ` ${r}` : ""}`)
  }, A), /* @__PURE__ */ M.createElement(wXe.Provider, {
    value: y.current
  }, N["container-start"], /* @__PURE__ */ M.createElement(a, {
    className: fXe(O.wrapperClass)
  }, N["wrapper-start"], ae(), N["wrapper-end"]), RW(O) && /* @__PURE__ */ M.createElement(M.Fragment, null, /* @__PURE__ */ M.createElement("div", {
    ref: S,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ M.createElement("div", {
    ref: _,
    className: "swiper-button-next"
  })), DW(O) && /* @__PURE__ */ M.createElement("div", {
    ref: E,
    className: "swiper-scrollbar"
  }), IW(O) && /* @__PURE__ */ M.createElement("div", {
    ref: C,
    className: "swiper-pagination"
  }), N["container-end"]));
});
jW.displayName = "Swiper";
const FW = /* @__PURE__ */ va(function(e, t) {
  let {
    tag: r = "div",
    children: n,
    className: a = "",
    swiper: s,
    zoom: i,
    lazy: o,
    virtualIndex: l,
    swiperSlideIndex: c,
    ...u
  } = e === void 0 ? {} : e;
  const d = tr(null), [f, h] = Me("swiper-slide"), [p, m] = Me(!1);
  function g(_, S, C) {
    S === d.current && h(C);
  }
  Im(() => {
    if (typeof c < "u" && (d.current.swiperSlideIndex = c), t && (t.current = d.current), !(!d.current || !s)) {
      if (s.destroyed) {
        f !== "swiper-slide" && h("swiper-slide");
        return;
      }
      return s.on("_slideClass", g), () => {
        s && s.off("_slideClass", g);
      };
    }
  }), Im(() => {
    s && d.current && !s.destroyed && h(s.getSlideClasses(d.current));
  }, [s]);
  const y = {
    isActive: f.indexOf("swiper-slide-active") >= 0,
    isVisible: f.indexOf("swiper-slide-visible") >= 0,
    isPrev: f.indexOf("swiper-slide-prev") >= 0,
    isNext: f.indexOf("swiper-slide-next") >= 0
  }, x = () => typeof n == "function" ? n(y) : n, w = () => {
    m(!0);
  };
  return /* @__PURE__ */ M.createElement(r, gw({
    ref: d,
    className: NW(`${f}${a ? ` ${a}` : ""}`),
    "data-swiper-slide-index": l,
    onLoad: w
  }, u), i && /* @__PURE__ */ M.createElement(E4.Provider, {
    value: y
  }, /* @__PURE__ */ M.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof i == "number" ? i : void 0
  }, x(), o && !p && /* @__PURE__ */ M.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !i && /* @__PURE__ */ M.createElement(E4.Provider, {
    value: y
  }, x(), o && !p && /* @__PURE__ */ M.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
FW.displayName = "SwiperSlide";
const xXe = ({
  investmentAmount: e,
  years: t,
  gainsData: r,
  investedData: n
}) => {
  const { t: a } = _t(["projects"]), { theme: s } = Wi(), i = (/* @__PURE__ */ new Date()).getFullYear(), o = Array.from(
    { length: t + 1 },
    (c, u) => (i + u).toString()
  ), l = [
    {
      label: a("projects.gains"),
      data: r,
      color: s.tokens.colors.base.primary[500].value,
      fill: "+1",
      order: 2
    },
    {
      label: a("projects.investedAmount"),
      data: n,
      color: s.tokens.colors.base.gray[200].value,
      fill: !0,
      order: 1
    }
  ];
  return /* @__PURE__ */ v.jsx(R8e, { labels: o, datasets: l });
};
var _Xe = ({ src: e = "", host: t = "cdn.docuseal.com", role: r = "", submitter: n = "", preview: a = !1, expand: s = !0, minimize: i = !1, orderAsOnPage: o = !1, email: l = "", name: c = "", backgroundColor: u = "", sendCopyEmail: d, applicationKey: f = "", externalId: h = "", logo: p = "", language: m = "", completedRedirectUrl: g = "", completedButton: y = { title: "", url: "" }, goToLast: x = !0, skipFields: w = !1, autoscrollFields: _ = !0, withTitle: S = !0, withDecline: C = !1, withFieldNames: E = !0, withFieldPlaceholder: O = !1, withDownloadButton: k = !0, allowToResubmit: A = !0, allowTypedSignature: P = !0, signature: D = "", rememberSignature: N = !1, reuseSignature: z = !0, withSendCopyButton: G = !0, withCompleteButton: Y = !1, values: te = {}, metadata: ae = {}, i18n: ne = {}, fields: ue = [], readonlyFields: q = [], onComplete: U = () => {
}, onInit: Q = () => {
}, onDecline: L = () => {
}, onLoad: j = () => {
}, className: K = "", customCss: J = "", style: re = {} }) => {
  let le = "docuseal-form-script", pe = `https://${t}/js/form.js`, me = typeof window > "u", Oe = me ? null : M.useRef(null);
  me || (M.useEffect(() => {
    if (!document.getElementById(le)) {
      let he = document.createElement("script");
      he.id = le, he.async = !0, he.src = pe, document.head.appendChild(he);
    }
  }, []), M.useEffect(() => {
    let he = Oe == null ? void 0 : Oe.current, Ee = (we) => U && U(we.detail);
    return he && he.addEventListener("completed", Ee), () => {
      he && he.removeEventListener("completed", Ee);
    };
  }, [U]), M.useEffect(() => {
    let he = Oe == null ? void 0 : Oe.current, Ee = (we) => Q && Q(we.detail);
    return he && he.addEventListener("init", Ee), () => {
      he && he.removeEventListener("init", Ee);
    };
  }, [Q]), M.useEffect(() => {
    let he = Oe == null ? void 0 : Oe.current, Ee = (we) => L && L(we.detail);
    return he && he.addEventListener("declined", Ee), () => {
      he && he.removeEventListener("declined", Ee);
    };
  }, [L]), M.useEffect(() => {
    let he = Oe == null ? void 0 : Oe.current, Ee = (we) => j && j(we.detail);
    return he && he.addEventListener("load", Ee), () => {
      he && he.removeEventListener("load", Ee);
    };
  }, [j]));
  let ee = (he) => he === !0 ? "true" : he === !1 ? "false" : he;
  return M.createElement(M.Fragment, null, M.createElement("docuseal-form", { "data-src": e, "data-email": l, "data-name": c, "data-role": r || n, "data-external-id": h || f, "data-expand": ee(s), "data-minimize": ee(i), "data-order-as-on-page": o, "data-preview": ee(a), "data-go-to-last": ee(x), "data-skip-fields": ee(w), "data-autoscroll-fields": ee(_), "data-send-copy-email": ee(d), "data-with-title": ee(S), "data-with-decline": ee(C), "data-logo": p, "data-language": m, "data-with-field-names": ee(E), "data-with-field-placeholder": ee(O), "data-with-download-button": ee(k), "data-allow-to-resubmit": ee(A), "data-allow-typed-signature": ee(P), "data-signature": D, "data-remember-signature": ee(N), "data-reuse-signature": ee(z), "data-completed-redirect-url": g, "data-with-send-copy-button": ee(G), "data-with-complete-button": ee(Y), "data-values": JSON.stringify(te), "data-metadata": JSON.stringify(ae), "data-fields": JSON.stringify(ue), "data-i18n": JSON.stringify(ne), "data-readonly-fields": q.join(","), "data-completed-button-title": y.title, "data-completed-button-url": y.url, "data-background-color": u, "data-custom-css": J, ref: Oe, className: K, style: re }), me && M.createElement("script", { id: le, src: pe, async: !0 }));
}, SXe = _Xe;
const EXe = () => {
  const { t: e } = _t(["projects"]), {
    isOpen: t,
    step: r,
    order: n,
    projectName: a,
    minBatches: s,
    maxBatches: i,
    pricePerBatch: o,
    closeModal: l,
    setStep: c,
    onConfirm: u
  } = Lb(), { hideModal: d } = Xg(), { handleError: f } = zc(), h = Da(), [p, m] = Me(null), [g, y] = Me(!1), { checkOrderStatus: x } = xW(), [w, _] = Me(!1), [S, C] = Me(!1), [E, O] = Me(null), [k, A] = Me(!1), [P, D] = Me(s ?? 1), [N, z] = Me(n), [G, Y] = Me(0), [te, ae] = Me(!1), ne = 3, ue = 60, q = 5e3, [U, Q] = Me(0), [L, j] = Me(!1), [K, J] = Me(!1);
  wt(() => {
    n && z(n);
  }, [n]), wt(() => {
    t || (m(null), y(!1), _(!1), C(!1), O(null), A(!1), D(s ?? 1), z(n), Y(0), ae(!1), Q(0), j(!1));
  }, [t, s, n]), wt(() => {
    r === "signature" && w && !S && re();
  }, [r, w, S, N == null ? void 0 : N.id, G]), wt(() => {
    if (r === "signature")
      return window.addEventListener("message", le), () => {
        window.removeEventListener("message", le);
      };
  }, [r]), wt(() => {
    r === "payment" && (N != null && N.id) && pe();
  }, [r, N == null ? void 0 : N.id]);
  const re = async () => {
    if (!(!(N != null && N.id) || G >= ne)) {
      ae(!0);
      try {
        const Te = await x(N.id);
        Te.signature && "valid" in Te.signature ? (C(!0), c("payment")) : (Y((_e) => _e + 1), G < ne - 1 && setTimeout(re, 3e3));
      } catch {
        m(e("projects.signatureCheckError")), Y(ne);
      } finally {
        ae(!1);
      }
    }
  }, le = async (Te) => {
    var _e, Ae, Ve, mt;
    if (Te.origin.includes("signaturit.com") && (((_e = Te.data) == null ? void 0 : _e.event) === "signed" || ((Ae = Te.data) == null ? void 0 : Ae.event) === "completed") && (_(!0), N != null && N.id)) {
      const Dt = await me(N.id);
      Dt != null && Dt.signature && "valid" in Dt.signature && (C(!0), c("payment"));
    }
    Te.origin.includes("docuseal") && (((Ve = Te.data) == null ? void 0 : Ve.event) === "submit" ? _(!0) : ((mt = Te.data) == null ? void 0 : mt.event) === "close" && (_(!0), C(!1), m(e("projects.errors.signature_canceled"))));
  }, pe = async () => {
    if (N != null && N.payment && "pending" in N.payment) {
      const Te = await L8e();
      if (J(Te), !Te) {
        const _e = IA(N.payment);
        if (!_e) {
          m(e("projects.errors.payment_url_missing"));
          return;
        }
        const Ae = Oj(_e);
        if (!Ae) {
          J(!0);
          return;
        }
        O(Ae), Oe();
      }
    }
  }, me = async (Te, _e = 3, Ae = 2e3) => {
    for (let Ve = 0; Ve < _e; Ve++) {
      const mt = await x(Te);
      if (mt != null && mt.signature && "valid" in mt.signature)
        return mt;
      Ve < _e - 1 && await new Promise((Dt) => setTimeout(Dt, Ae));
    }
    return null;
  }, Oe = () => {
    if (!(N != null && N.id)) return;
    let Te = 0;
    j(!0);
    const _e = setInterval(async () => {
      try {
        Te++;
        const Ae = await x(N.id);
        ee(Ae, Te, _e);
      } catch (Ae) {
        console.error("Error checking payment status:", Ae);
      }
    }, q);
    return () => {
      clearInterval(_e), j(!1);
    };
  }, ee = (Te, _e, Ae) => {
    Te != null && Te.payment && "valid" in Te.payment ? (A(!0), c("complete"), clearInterval(Ae), j(!1)) : _e >= ue && (m(e("projects.paymentTimeoutError")), clearInterval(Ae), j(!1)), Q(_e);
  }, he = (Te) => {
    const _e = Te.target.value;
    if (_e === "") {
      D(0);
      return;
    }
    const Ae = parseInt(_e);
    !isNaN(Ae) && Ae >= 0 && (s && Ae < s ? D(s) : i && Ae > i ? D(i) : D(Ae));
  }, Ee = () => {
    s && P < s ? D(s) : i && P > i && D(i);
  }, we = async () => {
    try {
      if (y(!0), m(null), !u) return;
      const Te = await u(P).catch((_e) => {
        const Ae = f(_e);
        throw h.error(Ae.message), _e;
      });
      z(Te), c("signature");
    } finally {
      y(!1);
    }
  }, Pe = async () => {
    if (N != null && N.id) {
      y(!0);
      try {
        const Te = await x(N.id);
        Te != null && Te.payment && "valid" in Te.payment ? (A(!0), c("complete")) : Te != null && Te.payment && "pending" in Te.payment ? (Q(ue), m(null)) : m(e("projects.paymentTimeoutError"));
      } catch {
        m(e("projects.paymentCheckError"));
      } finally {
        y(!1);
      }
    }
  }, rt = (Te = !1) => {
    if (N != null && N.payment && "pending" in N.payment) {
      const _e = IA(N.payment);
      if (!_e) {
        m(e("projects.errors.payment_url_missing"));
        return;
      }
      if (Te)
        window.open(_e, "_blank");
      else {
        const Ae = Oj(_e);
        Ae ? (O(Ae), J(!1), Oe()) : J(!0);
      }
    }
  }, ht = (Te) => Te.signature && "pending" in Te.signature ? Te.signature.pending : null, bt = () => {
    if (p)
      return /* @__PURE__ */ v.jsxs("div", { className: "text-center text-error-500 p-4", children: [
        /* @__PURE__ */ v.jsx(dt, { name: "close", size: "xl", className: "mb-4" }),
        /* @__PURE__ */ v.jsx("h3", { className: "text-xl font-medium mb-2", children: e("projects.error") }),
        /* @__PURE__ */ v.jsx("p", { children: p })
      ] });
    if (g)
      return /* @__PURE__ */ v.jsxs("div", { className: "text-center p-4", children: [
        /* @__PURE__ */ v.jsx(dt, { name: "spinner", size: "lg", className: "animate-spin mb-4" }),
        /* @__PURE__ */ v.jsx("p", { children: e("projects.loading") })
      ] });
    switch (r) {
      case "form":
        return /* @__PURE__ */ v.jsx("div", { className: "space-y-4", children: i === 0 ? /* @__PURE__ */ v.jsx("div", { className: "text-error-500 text-center p-4", children: e("projects.noBatchesAvailable") }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
          /* @__PURE__ */ v.jsx("p", { children: e("projects.investInProject", { projectName: a }) }),
          /* @__PURE__ */ v.jsxs("div", { className: "space-y-2", children: [
            /* @__PURE__ */ v.jsx(
              ar,
              {
                type: "number",
                label: e("projects.quantity"),
                value: P || "",
                onChange: he,
                onBlur: Ee,
                min: s,
                max: i,
                required: !0
              }
            ),
            /* @__PURE__ */ v.jsxs("div", { className: "bg-gray-50 rounded-lg p-4 space-y-1 text-sm", children: [
              /* @__PURE__ */ v.jsxs("div", { className: "flex space-x-1 justify-start", children: [
                /* @__PURE__ */ v.jsx("span", { className: "font-medium", children: e("projects.totalInvestment") }),
                /* @__PURE__ */ v.jsx("span", { className: "font-semibold text-primary-500", children: hs(P * (o || 0), {
                  currency: "EUR",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                  preserveDecimals: !0
                }) })
              ] }),
              /* @__PURE__ */ v.jsxs("div", { className: "flex space-x-1 justify-start text-gray-500 text-xs", children: [
                /* @__PURE__ */ v.jsxs("span", { children: [
                  e("projects.pricePerShare"),
                  " :"
                ] }),
                /* @__PURE__ */ v.jsx("span", { className: "font-medium", children: hs(o || 0, {
                  currency: "EUR",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                  preserveDecimals: !0
                }) })
              ] }),
              /* @__PURE__ */ v.jsxs("div", { className: "flex space-x-1 justify-start text-gray-500 text-xs", children: [
                /* @__PURE__ */ v.jsxs("span", { children: [
                  e("projects.minimumShares"),
                  " :"
                ] }),
                /* @__PURE__ */ v.jsx("span", { className: "font-medium", children: s })
              ] })
            ] })
          ] })
        ] }) });
      case "signature":
        const Te = N ? ht(N) : null;
        if (!Te)
          return /* @__PURE__ */ v.jsx("div", { className: "text-error-500 text-center", children: e("projects.errors.signature_url_missing") });
        const _e = ui().SIGNATURE_PROVIDER;
        return typeof Te == "string" && Te.includes("docuseal") || _e === "docuseal" ? /* @__PURE__ */ v.jsx(
          SXe,
          {
            src: Te,
            onComplete: () => _(!0)
          }
        ) : /* @__PURE__ */ v.jsx("div", { className: "flex-1 flex w-[200vw] overflow-x-auto md:w-full h-full", children: /* @__PURE__ */ v.jsx(
          "iframe",
          {
            src: typeof Te == "string" ? Te : JSON.stringify(Te),
            className: "w-full h-full",
            allow: "camera *; microphone *; geolocation *",
            sandbox: "allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads"
          }
        ) });
      case "payment":
        return /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center md:p-8 space-y-6", children: [
          /* @__PURE__ */ v.jsxs("div", { className: "w-full max-w-md bg-gray-50 rounded-lg p-4 md:p-6", children: [
            /* @__PURE__ */ v.jsxs("div", { className: "flex items-center justify-between mb-4", children: [
              /* @__PURE__ */ v.jsx("h4", { className: "text-lg font-medium", children: e("projects.orderSummary") }),
              /* @__PURE__ */ v.jsxs("div", { className: "flex items-center", children: [
                /* @__PURE__ */ v.jsx(
                  dt,
                  {
                    name: "clock",
                    size: "sm",
                    className: "mr-2 text-warning-500"
                  }
                ),
                /* @__PURE__ */ v.jsx("span", { className: "text-sm text-warning-500", children: e("projects.pendingPayment") })
              ] })
            ] }),
            /* @__PURE__ */ v.jsxs("div", { className: "space-y-3", children: [
              /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between", children: [
                /* @__PURE__ */ v.jsx("span", { className: "text-text-muted", children: e("projects.projectName") }),
                /* @__PURE__ */ v.jsx("span", { className: "font-medium", children: a })
              ] }),
              /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between", children: [
                /* @__PURE__ */ v.jsx("span", { className: "text-text-muted", children: e("projects.quantity") }),
                /* @__PURE__ */ v.jsx("span", { className: "font-medium", children: P })
              ] }),
              /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between border-t pt-3", children: [
                /* @__PURE__ */ v.jsx("span", { className: "text-text-muted", children: e("projects.orderStatus") }),
                /* @__PURE__ */ v.jsx("span", { className: "font-medium text-warning-500", children: e("projects.awaitingPayment") })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ v.jsxs("div", { className: "text-center", children: [
            /* @__PURE__ */ v.jsx(
              dt,
              {
                name: "credit-card",
                size: "lg",
                className: "mb-4 text-primary-500"
              }
            ),
            /* @__PURE__ */ v.jsx("h3", { className: "text-xl font-medium mb-4", children: e("projects.paymentInProgress") }),
            K ? /* @__PURE__ */ v.jsxs("div", { className: "space-y-4", children: [
              /* @__PURE__ */ v.jsx("p", { className: "text-warning-500", children: e("projects.popupBlocked") }),
              /* @__PURE__ */ v.jsx(
                qe,
                {
                  variant: "solid",
                  color: "primary",
                  onClick: () => rt(!1),
                  children: e("projects.openPayment")
                }
              ),
              /* @__PURE__ */ v.jsxs("div", { className: "mt-4", children: [
                /* @__PURE__ */ v.jsx("p", { className: "text-sm text-gray-600 mb-2", children: e("projects.fallbackPaymentMessage") }),
                /* @__PURE__ */ v.jsx(
                  qe,
                  {
                    variant: "outline",
                    color: "secondary",
                    size: "sm",
                    onClick: () => rt(!0),
                    children: e("projects.openPaymentNewTab")
                  }
                )
              ] })
            ] }) : E != null && E.closed ? /* @__PURE__ */ v.jsxs("div", { className: "space-y-4", children: [
              /* @__PURE__ */ v.jsx("p", { className: "text-warning-500", children: e("projects.paymentWindowClosed") }),
              /* @__PURE__ */ v.jsx(
                qe,
                {
                  variant: "outline",
                  color: "secondary",
                  onClick: () => rt(!1),
                  children: e("projects.reopenPaymentWindow")
                }
              ),
              /* @__PURE__ */ v.jsxs("div", { className: "mt-4", children: [
                /* @__PURE__ */ v.jsx("p", { className: "text-sm text-gray-600 mb-2", children: e("projects.fallbackPaymentMessage") }),
                /* @__PURE__ */ v.jsx(
                  qe,
                  {
                    variant: "outline",
                    color: "secondary",
                    size: "sm",
                    onClick: () => rt(!0),
                    children: e("projects.openPaymentNewTab")
                  }
                )
              ] })
            ] }) : U >= ue ? /* @__PURE__ */ v.jsxs("div", { className: "space-y-4", children: [
              /* @__PURE__ */ v.jsx("p", { className: "text-warning-500", children: e("projects.checkPaymentManually") }),
              /* @__PURE__ */ v.jsx(
                qe,
                {
                  variant: "solid",
                  color: "primary",
                  onClick: Pe,
                  disabled: g,
                  children: e("projects.refreshPaymentStatus")
                }
              )
            ] }) : /* @__PURE__ */ v.jsxs("div", { className: "flex items-center justify-center space-x-2", children: [
              /* @__PURE__ */ v.jsx("div", { className: "animate-spin rounded-full h-4 w-4 border-2 border-primary border-t-transparent" }),
              /* @__PURE__ */ v.jsx("span", { children: e("projects.waitingForPayment") })
            ] })
          ] }),
          /* @__PURE__ */ v.jsxs("div", { className: "w-full max-w-md mt-8 pt-8 border-t border-gray-200", children: [
            /* @__PURE__ */ v.jsxs(
              qe,
              {
                variant: "link",
                color: "primary",
                size: "sm",
                onClick: () => window.open("/documents/rib.pdf", "_blank"),
                className: "inline-flex items-center mx-auto",
                children: [
                  /* @__PURE__ */ v.jsx(dt, { name: "file-pdf", size: "sm", className: "mr-2" }),
                  e("projects.downloadRib")
                ]
              }
            ),
            /* @__PURE__ */ v.jsx("p", { className: "text-sm text-gray-500 mt-1 text-center", children: e("projects.downloadRibDescription") })
          ] })
        ] });
      case "complete":
        return /* @__PURE__ */ v.jsxs("div", { className: "text-center", children: [
          /* @__PURE__ */ v.jsx(
            dt,
            {
              name: "check-circle",
              size: "lg",
              className: "text-success-500 mb-4"
            }
          ),
          /* @__PURE__ */ v.jsx("h3", { className: "text-xl font-medium mb-2", children: e("projects.investmentComplete") }),
          /* @__PURE__ */ v.jsx("p", { children: e("projects.investmentSuccessMessage") })
        ] });
    }
  }, Ge = () => {
    switch (r) {
      case "form":
        return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
          /* @__PURE__ */ v.jsx(qe, { variant: "outline", onClick: l, children: e("common:common.cancel") }),
          i !== 0 && /* @__PURE__ */ v.jsx(
            qe,
            {
              variant: "solid",
              color: "primary",
              onClick: we,
              isLoading: g,
              iconPosition: "left",
              children: e("projects.confirmInvest")
            }
          )
        ] });
      case "signature":
        return w ? S ? /* @__PURE__ */ v.jsx(
          qe,
          {
            variant: "solid",
            color: "primary",
            onClick: () => c("payment"),
            children: e("projects.continueToPayment")
          }
        ) : te || G < ne ? /* @__PURE__ */ v.jsxs("div", { className: "flex items-center justify-center space-x-2", children: [
          /* @__PURE__ */ v.jsx("div", { className: "animate-spin rounded-full h-5 w-5 border-b-2 border-primary" }),
          /* @__PURE__ */ v.jsxs("span", { className: "text-text-muted", children: [
            e("projects.validatingSignature"),
            " (",
            G + 1,
            "/",
            ne,
            ")"
          ] })
        ] }) : /* @__PURE__ */ v.jsx(
          qe,
          {
            variant: "solid",
            color: "primary",
            onClick: () => {
              Y(0), m(null);
            },
            children: e("projects.retrySignatureCheck")
          }
        ) : /* @__PURE__ */ v.jsxs("div", { className: "flex items-center justify-between space-x-2 w-full", children: [
          /* @__PURE__ */ v.jsx(qe, { variant: "outline", onClick: ye, children: e("common:common.cancel") }),
          /* @__PURE__ */ v.jsx("div", { className: "text-text-muted", children: e("projects.completeAndSignDocument") })
        ] });
      case "payment":
        return k ? p ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
          /* @__PURE__ */ v.jsx("div", { className: "text-error-500 text-center", children: p }),
          /* @__PURE__ */ v.jsx(
            qe,
            {
              variant: "solid",
              color: "primary",
              onClick: () => {
                if (N != null && N.payment && "pending" in N.payment) {
                  const Te = window.open(
                    typeof N.payment.pending == "string" ? N.payment.pending : JSON.stringify(N.payment.pending),
                    "_blank",
                    "width=600,height=800,top=50,right=50"
                  );
                  O(Te);
                }
              },
              children: e("projects.retryPayment")
            }
          )
        ] }) : null : /* @__PURE__ */ v.jsx("div", { className: "text-text-muted text-center", children: e("projects.waitingForPayment") });
      case "complete":
        return /* @__PURE__ */ v.jsx(qe, { variant: "solid", color: "primary", onClick: ye, children: e("common:common.close") });
    }
  }, oe = {
    form: {
      size: "md",
      closeOnOutsideClick: !0
    },
    signature: {
      size: "full",
      closeOnOutsideClick: !0
    },
    payment: {
      size: "xl",
      preventClose: !0
    },
    complete: {
      size: "xl",
      closeOnOutsideClick: !0
    }
  }, ve = /* @__PURE__ */ v.jsx("div", { className: "flex flex-col lg:flex-row items-center justify-start lg:space-x-12 w-full", children: /* @__PURE__ */ v.jsx("h2", { className: "shrink-0", children: e(`projects.steps.${r}`) }) }), ye = () => {
    const Te = r === "complete" && Lb.getState().isContinuation;
    m(null), y(!1), _(!1), C(!1), O(null), A(!1), D(s ?? 1), z(n), Y(0), ae(!1), Q(0), j(!1), l(), d(), Te && window.location.reload();
  };
  return /* @__PURE__ */ v.jsx(
    Fh,
    {
      ...oe[r],
      isOpen: t,
      onClose: ye,
      title: ve,
      footer: /* @__PURE__ */ v.jsx("div", { className: "flex justify-end space-x-2", children: Ge() }),
      children: /* @__PURE__ */ v.jsx("div", { className: "w-full h-full", children: bt() })
    }
  );
}, TXe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  OrderConfirmationModal: EXe
}, Symbol.toStringTag, { value: "Module" })), ett = ({
  project: e
}) => {
  var r;
  const { t } = _t(["projects"]);
  return /* @__PURE__ */ v.jsx(hr, { className: "bg-background-light dark:bg-background-dark", children: ((r = e.files) == null ? void 0 : r.links) && Object.entries(e.files.links).length > 0 && /* @__PURE__ */ v.jsx("div", { className: "space-y-4", children: Object.entries(e.files.links).map(([n, a]) => /* @__PURE__ */ v.jsxs("div", { className: "flex items-center space-x-4", children: [
    /* @__PURE__ */ v.jsx(dt, { name: "file-pdf", size: "2xl" }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ v.jsx(
        "a",
        {
          href: a,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "flex items-center text-primary-800 hover:underline",
          children: n
        }
      ),
      /* @__PURE__ */ v.jsx("span", { className: "text-primary-500", children: t("projects.documentAvailable") })
    ] })
  ] }, n)) }) });
}, CXe = ({
  project: e
}) => {
  var s, i, o;
  const { t } = _t(["projects"]), r = [
    {
      id: "revenues",
      gridSpan: 6
    },
    {
      id: "charges",
      gridSpan: 6
    },
    {
      id: "results",
      gridSpan: 12
    },
    {
      id: "investment",
      gridSpan: 6
    },
    {
      id: "resale",
      gridSpan: 6
    }
  ], n = (l, c) => {
    if (!l) return null;
    const u = String(l.value || ""), d = u.startsWith("-"), f = u.startsWith("+");
    return /* @__PURE__ */ v.jsxs("li", { className: "flex justify-between items-center", children: [
      /* @__PURE__ */ v.jsxs("span", { className: "text-gray-600 flex items-center gap-2", children: [
        l.title.label,
        l.tooltip && /* @__PURE__ */ v.jsx(ni, { content: l.tooltip, children: /* @__PURE__ */ v.jsx(dt, { name: "info-circle", size: "sm", className: "text-gray-400" }) })
      ] }),
      /* @__PURE__ */ v.jsx(
        "span",
        {
          className: `font-medium ${l.operator === "%" || u.includes("%") ? "text-gray-900 dark:text-gray-100" : d ? "text-red-500" : f ? "text-green-500" : "text-gray-900 dark:text-gray-100"}`,
          children: l.value !== void 0 ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            typeof l.value == "number" ? Math.abs(l.value).toLocaleString("fr-FR") : Ao(l.value, {
              thousandsSeparator: " ",
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
              preserveDecimals: !0
            }),
            l.value && l.operator && ` ${l.operator}`
          ] }) : "N/A"
        }
      )
    ] }, c);
  }, a = (l) => {
    var u, d, f;
    const c = ((f = (d = (u = e.info) == null ? void 0 : u.attributes) == null ? void 0 : d.finance) == null ? void 0 : f[l.id]) || [];
    return !Array.isArray(c) || c.length === 0 ? null : /* @__PURE__ */ v.jsxs(
      hr,
      {
        className: `col-span-12 md:col-span-${l.gridSpan}`,
        color: "bg-secondary-50",
        border: "border-secondary-200",
        children: [
          /* @__PURE__ */ v.jsx("h4", { className: "font-semibold mb-4 text-lg", children: t(`projects.${l.id}`) }),
          /* @__PURE__ */ v.jsx("ul", { className: "space-y-3", children: c.map((h, p) => n(h, p)) })
        ]
      },
      l.id
    );
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "space-y-6", children: [
    ((o = (i = (s = e.info) == null ? void 0 : s.attributes) == null ? void 0 : i.finance) == null ? void 0 : o.image) && /* @__PURE__ */ v.jsx(hr, { children: /* @__PURE__ */ v.jsx(
      fi,
      {
        src: e.info.attributes.finance.image,
        alt: "Bilan Financier",
        className: "max-w-full w-full h-auto"
      }
    ) }),
    /* @__PURE__ */ v.jsx("div", { className: "grid grid-cols-12 gap-6", children: r.map(a) })
  ] });
}, Hp = (e) => e ? { __html: e.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "").replace(/on\w+="[^"]*"/g, "").replace(/on\w+='[^']*'/g, "") } : { __html: "" }, kXe = ({
  project: e,
  activeCampaign: t
}) => {
  var i, o, l, c, u, d, f, h, p, m, g, y, x, w, _, S, C, E, O;
  const { t: r } = _t(["projects"]), n = (k) => {
    const A = new Date(k.info.start_date), P = new Date(
      A.getTime() + k.info.duration * 24 * 60 * 60 * 1e3
    ), D = /* @__PURE__ */ new Date(), N = Math.ceil(
      (P.getTime() - D.getTime()) / (1e3 * 60 * 60 * 24)
    );
    return N > 0 ? N : 0;
  }, a = (k) => k.includes("youtube.com") || k.includes("youtu.be") || k.includes("vimeo.com") || k.includes("dailymotion.com") || k.includes("pitch.com"), s = t ? n(t) : "N/A";
  return /* @__PURE__ */ v.jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ v.jsxs("div", { children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flex items-start justify-between mb-6", children: [
        /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col space-y-1", children: [
          /* @__PURE__ */ v.jsx("h2", { className: "text-md md:text-2xl font-bold text-primary-600 break-words", children: e.name }),
          /* @__PURE__ */ v.jsx("p", { children: (i = e.location) == null ? void 0 : i.city })
        ] }),
        /* @__PURE__ */ v.jsx("div", { className: "border border-primary-600 text-primary-600 px-2 py-1 md:px-3 md:py-2 rounded-sm text-sm md:text-base", children: ((c = (l = (o = e.info) == null ? void 0 : o.attributes) == null ? void 0 : l.info) == null ? void 0 : c.type) || r("projects.type") })
      ] }),
      /* @__PURE__ */ v.jsxs("div", { className: "flex items-center justify-between mb-2", children: [
        /* @__PURE__ */ v.jsx("div", { children: hs(e.price * e.batches || 0, {
          currency: "EUR",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }) }),
        /* @__PURE__ */ v.jsxs("div", { className: "text-right space-x-1", children: [
          /* @__PURE__ */ v.jsx("span", { className: "font-bold text-primary-600", children: s }),
          /* @__PURE__ */ v.jsx("span", { className: "text-sm text-gray-600", children: r("projects.daysLeft") })
        ] })
      ] }),
      t && (() => {
        const { show: k, extraAmount: A } = e2(e.info);
        return k ? /* @__PURE__ */ v.jsx(
          Zk,
          {
            batches: t.info.batches,
            frozen: t.frozen,
            availableBatches: t.available,
            extraAmount: A,
            batchPrice: e.price || 0,
            showInfo: !0,
            progressBarProps: {
              color: "secondary",
              variant: "gradient",
              size: "xs"
            }
          }
        ) : null;
      })()
    ] }),
    ((f = (d = (u = e.info) == null ? void 0 : u.attributes) == null ? void 0 : d.info) == null ? void 0 : f.reasons) && e.info.attributes.info.reasons.length > 0 && /* @__PURE__ */ v.jsx(
      hr,
      {
        color: "bg-secondary-50",
        border: "border-secondary-200",
        header: /* @__PURE__ */ v.jsx("h3", { children: r("projects.whyInvest") }),
        children: /* @__PURE__ */ v.jsx("ul", { className: "space-y-4", children: e.info.attributes.info.reasons.map((k, A) => /* @__PURE__ */ v.jsxs(
          "li",
          {
            className: "flex items-start first:border-none first:pt-0 border-t border-border pt-4",
            children: [
              /* @__PURE__ */ v.jsx(
                dt,
                {
                  name: "check-circle",
                  size: "lg",
                  className: "text-primary-600 mr-3 flex-shrink-0"
                }
              ),
              /* @__PURE__ */ v.jsxs("div", { className: "flex-1 min-w-0", children: [
                /* @__PURE__ */ v.jsx("h4", { className: "font-medium text-gray-900 dark:text-gray-100 break-words", children: typeof k.title == "string" ? k.title : k.title.label }),
                /* @__PURE__ */ v.jsx("p", { className: "text-gray-600 dark:text-gray-400 mt-1 break-words", children: k.description })
              ] })
            ]
          },
          A
        )) })
      }
    ),
    ((h = e.info) == null ? void 0 : h.description) && /* @__PURE__ */ v.jsx(
      hr,
      {
        color: "bg-secondary-50",
        border: "border-secondary-200",
        header: /* @__PURE__ */ v.jsx("h3", { children: r("projects.description") }),
        children: /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "text-gray-600 prose max-w-none",
            dangerouslySetInnerHTML: Hp(e.info.description)
          }
        )
      }
    ),
    ((p = e.info) == null ? void 0 : p.urls) && e.info.urls.length > 0 && /* @__PURE__ */ v.jsx(
      hr,
      {
        color: "bg-secondary-50",
        border: "border-secondary-200",
        header: /* @__PURE__ */ v.jsx("h3", { children: r("projects.urls.title") }),
        children: /* @__PURE__ */ v.jsx(
          "div",
          {
            className: `grid grid-cols-1 ${e.info.urls.length === 1 ? "md:grid-cols-1" : e.info.urls.length === 2 ? "md:grid-cols-2" : "md:grid-cols-2 lg:grid-cols-3"} gap-4`,
            children: e.info.urls.map((k, A) => /* @__PURE__ */ v.jsx(
              "div",
              {
                className: "group relative overflow-hidden rounded-lg",
                children: a(k.link) ? /* @__PURE__ */ v.jsx(mFe, { url: k.link, className: "w-full" }) : /* @__PURE__ */ v.jsxs(
                  "a",
                  {
                    href: k.link,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "block bg-gray-100 hover:ring-2 hover:ring-primary-500 transition-all duration-200",
                    children: [
                      /* @__PURE__ */ v.jsx("div", { className: "aspect-video", children: k.thumbnail ? /* @__PURE__ */ v.jsx(
                        fi,
                        {
                          src: k.thumbnail,
                          alt: `Thumbnail for ${k.link}`,
                          className: "w-full h-full object-cover",
                          ratio: "aspect-video"
                        }
                      ) : /* @__PURE__ */ v.jsx("div", { className: "w-full h-full flex items-center justify-center bg-gray-200", children: /* @__PURE__ */ v.jsx(
                        dt,
                        {
                          name: "link",
                          size: "2xl",
                          className: "text-gray-400"
                        }
                      ) }) }),
                      /* @__PURE__ */ v.jsx("div", { className: "absolute top-0 left-0 bottom-0 right-0 p-3 bg-black/50 flex flex-col justify-end", children: /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2", children: [
                        /* @__PURE__ */ v.jsx(
                          dt,
                          {
                            name: "link",
                            className: "text-white flex-shrink-0",
                            size: "sm"
                          }
                        ),
                        /* @__PURE__ */ v.jsx("span", { className: "text-sm text-white truncate", children: k.link })
                      ] }) })
                    ]
                  }
                )
              },
              A
            ))
          }
        )
      }
    ),
    ((m = e.info) == null ? void 0 : m.features) && /* @__PURE__ */ v.jsx(
      hr,
      {
        color: "bg-secondary-50",
        border: "border-secondary-200",
        header: /* @__PURE__ */ v.jsx("h3", { children: r("projects.features.title") }),
        children: /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "text-gray-600 prose max-w-none",
            dangerouslySetInnerHTML: Hp(e.info.features)
          }
        )
      }
    ),
    ((g = e.info) == null ? void 0 : g.strategy) && /* @__PURE__ */ v.jsx(
      hr,
      {
        color: "bg-secondary-50",
        border: "border-secondary-200",
        header: /* @__PURE__ */ v.jsx("h3", { children: r("projects.strategy.title") }),
        children: /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "text-gray-600 prose max-w-none",
            dangerouslySetInnerHTML: Hp(e.info.strategy)
          }
        )
      }
    ),
    ((x = (y = e.info) == null ? void 0 : y.attributes) == null ? void 0 : x.news) && e.info.attributes.news.length > 0 && /* @__PURE__ */ v.jsx(
      hr,
      {
        color: "bg-secondary-50",
        border: "border-secondary-200",
        header: /* @__PURE__ */ v.jsx("h3", { children: r("projects.news.title") }),
        children: /* @__PURE__ */ v.jsx("div", { className: "space-y-6", children: e.info.attributes.news.map(
          (k, A) => /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col space-y-2", children: [
            /* @__PURE__ */ v.jsx("h3", { className: "text-lg font-semibold", children: k.title }),
            k.imageUrl && /* @__PURE__ */ v.jsx(
              "img",
              {
                src: k.imageUrl,
                alt: k.title,
                className: "w-full h-48 object-cover rounded-lg"
              }
            ),
            /* @__PURE__ */ v.jsx("div", { className: "prose max-w-none", children: /* @__PURE__ */ v.jsx(
              "div",
              {
                className: "text-gray-600 prose max-w-none",
                dangerouslySetInnerHTML: Hp(k.content)
              }
            ) }),
            k.sourceUrl && /* @__PURE__ */ v.jsxs(
              "a",
              {
                href: k.sourceUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "text-sm text-gray-600 hover:text-gray-800 inline-flex items-center italic underline",
                children: [
                  r("common:common.knowMore"),
                  " ",
                  /* @__PURE__ */ v.jsx(dt, { name: "arrow-right", size: "sm", className: "ml-1" })
                ]
              }
            )
          ] }, A)
        ) })
      }
    ),
    ((S = (_ = (w = e.info) == null ? void 0 : w.attributes) == null ? void 0 : _.location) == null ? void 0 : S.details) && /* @__PURE__ */ v.jsx(
      hr,
      {
        color: "bg-secondary-50",
        border: "border-secondary-200",
        header: /* @__PURE__ */ v.jsx("h3", { children: r("projects.status.location.title") }),
        children: /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "text-gray-600 prose max-w-none",
            dangerouslySetInnerHTML: Hp(
              e.info.attributes.location.details
            )
          }
        )
      }
    ),
    ((E = (C = e.info) == null ? void 0 : C.attributes) == null ? void 0 : E.timeline) && /* @__PURE__ */ v.jsx(
      hr,
      {
        color: "bg-secondary-50",
        border: "border-secondary-200",
        header: /* @__PURE__ */ v.jsx("h3", { children: r("projects.timeline.title") }),
        children: /* @__PURE__ */ v.jsx(HQe, { items: e.info.attributes.timeline })
      }
    ),
    ((O = e.files) == null ? void 0 : O.links) && Object.entries(e.files.links).length > 0 && /* @__PURE__ */ v.jsx(
      hr,
      {
        color: "bg-secondary-50",
        border: "border-secondary-200",
        header: /* @__PURE__ */ v.jsx("h3", { children: r("projects.documents") }),
        children: /* @__PURE__ */ v.jsx("div", { className: "overflow-x-auto pr-2", children: Object.entries(e.files.links).map(([k, A]) => /* @__PURE__ */ v.jsxs(
          "div",
          {
            className: "flex items-center space-x-4 mb-4 last:mb-0",
            children: [
              /* @__PURE__ */ v.jsx(dt, { name: "file-pdf", size: "2xl", className: "flex-shrink-0" }),
              /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col min-w-0", children: [
                /* @__PURE__ */ v.jsx(
                  "a",
                  {
                    href: A,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "flex items-center text-primary-600 hover:underline",
                    children: k
                  }
                ),
                /* @__PURE__ */ v.jsx("span", { className: "text-text text-sm whitespace-nowrap", children: r("projects.documentAvailable") })
              ] })
            ]
          },
          k
        )) })
      }
    )
  ] });
}, BW = "carousel", UW = "controller", OXe = "navigation", AXe = "no-scroll", iO = "portal", PXe = "root", VW = "toolbar", US = "loading", VS = "error", $S = "complete", RXe = "placeholder", IXe = (e) => `active-slide-${e}`, $W = "flex_center", DXe = "no_scroll", HW = "no_scroll_padding", NXe = "slide_wrapper", bu = "prev", wu = "next", T4 = "swipe", gh = "close", WW = "onPointerDown", zW = "onPointerMove", KW = "onPointerUp", qW = "onPointerLeave", GW = "onPointerCancel", YW = "onKeyDown", MXe = "onKeyUp", XW = "onWheel", LXe = "Escape", jXe = "ArrowLeft", FXe = "ArrowRight", BXe = "button", ST = "icon", QW = "contain", C4 = "cover", UXe = "Unknown action type", JW = "yarl__";
function Ll(...e) {
  return [...e].filter(Boolean).join(" ");
}
function Yr(e) {
  return `${JW}${e}`;
}
function ys(e) {
  return `--${JW}${e}`;
}
function Tv(e, t) {
  return `${e}${t ? `_${t}` : ""}`;
}
function oO(e) {
  return (t) => Tv(e, t);
}
function VXe(e, t) {
  var r;
  return (r = e == null ? void 0 : e[t]) !== null && r !== void 0 ? r : t;
}
function ZW(...e) {
  return () => {
    e.forEach((t) => {
      t();
    });
  };
}
function Od(e, t, r) {
  return () => {
    const n = be.useContext(r);
    if (!n)
      throw new Error(`${e} must be used within a ${t}.Provider`);
    return n;
  };
}
function ez() {
  return typeof window < "u";
}
function $Xe(e, t = 0) {
  const r = 10 ** t;
  return Math.round((e + Number.EPSILON) * r) / r;
}
function tz(e) {
  return e.type === void 0 || e.type === "image";
}
function HXe(e, t) {
  return e.imageFit === C4 || e.imageFit !== QW && t === C4;
}
function r1(e) {
  return typeof e == "string" ? Number.parseInt(e, 10) : e;
}
function vw(e) {
  if (typeof e == "number")
    return { pixel: e };
  if (typeof e == "string") {
    const t = r1(e);
    return e.endsWith("%") ? { percent: t } : { pixel: t };
  }
  return { pixel: 0 };
}
function WXe(e, t) {
  const r = vw(t), n = r.percent !== void 0 ? e.width / 100 * r.percent : r.pixel;
  return {
    width: Math.max(e.width - 2 * n, 0),
    height: Math.max(e.height - 2 * n, 0)
  };
}
function rz(e, t) {
  return t > 0 ? (e % t + t) % t : 0;
}
function nz(e) {
  return e.length > 0;
}
function az(e, t) {
  return e[rz(t, e.length)];
}
function ET(e, t) {
  return nz(e) ? az(e, t) : void 0;
}
function zXe(e) {
  return tz(e) ? e.src : void 0;
}
function KXe(e, t, r = 0) {
  return Math.min(e.preload, Math.max(e.finite ? t.length - 1 : Math.floor(t.length / 2), r));
}
const qXe = Number(be.version.split(".")[0]) >= 19;
function GXe(e) {
  return { inert: qXe ? e : e ? "" : void 0 };
}
const TT = {
  open: !1,
  close: () => {
  },
  index: 0,
  slides: [],
  render: {},
  plugins: [],
  toolbar: { buttons: [gh] },
  labels: {},
  animation: {
    fade: 250,
    swipe: 500,
    easing: {
      fade: "ease",
      swipe: "ease-out",
      navigation: "ease-in-out"
    }
  },
  carousel: {
    finite: !1,
    preload: 2,
    padding: "16px",
    spacing: "30%",
    imageFit: QW,
    imageProps: {}
  },
  controller: {
    ref: null,
    focus: !0,
    aria: !1,
    touchAction: "none",
    closeOnPullUp: !1,
    closeOnPullDown: !1,
    closeOnBackdropClick: !1,
    preventDefaultWheelX: !0,
    preventDefaultWheelY: !1,
    disableSwipeNavigation: !1
  },
  portal: {},
  noScroll: {
    disabled: !1
  },
  on: {},
  styles: {},
  className: ""
};
function Ad(e, t) {
  return { name: e, component: t };
}
function ha(e, t) {
  return { module: e, children: t };
}
function sz(e, t, r) {
  return e.module.name === t ? r(e) : e.children ? [
    ha(e.module, e.children.flatMap((n) => {
      var a;
      return (a = sz(n, t, r)) !== null && a !== void 0 ? a : [];
    }))
  ] : [e];
}
function of(e, t, r) {
  return e.flatMap((n) => {
    var a;
    return (a = sz(n, t, r)) !== null && a !== void 0 ? a : [];
  });
}
function YXe(e, t = [], r = []) {
  let n = e;
  const a = (h) => {
    const p = [...n];
    for (; p.length > 0; ) {
      const m = p.pop();
      if ((m == null ? void 0 : m.module.name) === h)
        return !0;
      m != null && m.children && p.push(...m.children);
    }
    return !1;
  }, s = (h, p) => {
    if (h === "") {
      n = [ha(p, n)];
      return;
    }
    n = of(n, h, (m) => [ha(p, [m])]);
  }, i = (h, p) => {
    n = of(n, h, (m) => [ha(m.module, [ha(p, m.children)])]);
  }, o = (h, p, m) => {
    n = of(n, h, (g) => {
      var y;
      return [
        ha(g.module, [
          ...m ? [ha(p)] : [],
          ...(y = g.children) !== null && y !== void 0 ? y : [],
          ...m ? [] : [ha(p)]
        ])
      ];
    });
  }, l = (h, p, m) => {
    n = of(n, h, (g) => [
      ...m ? [ha(p)] : [],
      g,
      ...m ? [] : [ha(p)]
    ]);
  }, c = (h) => {
    i(UW, h);
  }, u = (h, p) => {
    n = of(n, h, (m) => [ha(p, m.children)]);
  }, d = (h) => {
    n = of(n, h, (p) => p.children);
  }, f = (h) => {
    r.push(h);
  };
  return t.forEach((h) => {
    h({
      contains: a,
      addParent: s,
      append: i,
      addChild: o,
      addSibling: l,
      addModule: c,
      replace: u,
      remove: d,
      augment: f
    });
  }), {
    config: n,
    augmentation: (h) => r.reduce((p, m) => m(p), h)
  };
}
const iz = be.createContext(null), lO = Od("useDocument", "DocumentContext", iz);
function XXe({ nodeRef: e, children: t }) {
  const r = be.useMemo(() => {
    const n = (s) => {
      var i;
      return ((i = s || e.current) === null || i === void 0 ? void 0 : i.ownerDocument) || document;
    };
    return { getOwnerDocument: n, getOwnerWindow: (s) => {
      var i;
      return ((i = n(s)) === null || i === void 0 ? void 0 : i.defaultView) || window;
    } };
  }, [e]);
  return be.createElement(iz.Provider, { value: r }, t);
}
const oz = be.createContext(null), n1 = Od("useEvents", "EventsContext", oz);
function QXe({ children: e }) {
  const [t] = be.useState({});
  be.useEffect(() => () => {
    Object.keys(t).forEach((n) => delete t[n]);
  }, [t]);
  const r = be.useMemo(() => {
    const n = (i, o) => {
      var l;
      (l = t[i]) === null || l === void 0 || l.splice(0, t[i].length, ...t[i].filter((c) => c !== o));
    };
    return { publish: (...[i, o]) => {
      var l;
      (l = t[i]) === null || l === void 0 || l.forEach((c) => c(o));
    }, subscribe: (i, o) => (t[i] || (t[i] = []), t[i].push(o), () => n(i, o)), unsubscribe: n };
  }, [t]);
  return be.createElement(oz.Provider, { value: r }, e);
}
const lz = be.createContext(null), Cv = Od("useLightboxProps", "LightboxPropsContext", lz);
function JXe({ children: e, ...t }) {
  return be.createElement(lz.Provider, { value: t }, e);
}
const cz = be.createContext(null), a1 = Od("useLightboxState", "LightboxStateContext", cz), uz = be.createContext(null), ZXe = Od("useLightboxDispatch", "LightboxDispatchContext", uz);
function eQe(e, t) {
  switch (t.type) {
    case "swipe": {
      const { slides: r } = e, n = (t == null ? void 0 : t.increment) || 0, a = e.globalIndex + n, s = rz(a, r.length), i = ET(r, s), o = n || t.duration ? {
        increment: n,
        duration: t.duration,
        easing: t.easing
      } : void 0;
      return { slides: r, currentIndex: s, globalIndex: a, currentSlide: i, animation: o };
    }
    case "update":
      return t.slides !== e.slides || t.index !== e.currentIndex ? {
        slides: t.slides,
        currentIndex: t.index,
        globalIndex: t.index,
        currentSlide: ET(t.slides, t.index)
      } : e;
    default:
      throw new Error(UXe);
  }
}
function tQe({ slides: e, index: t, children: r }) {
  const [n, a] = be.useReducer(eQe, {
    slides: e,
    currentIndex: t,
    globalIndex: t,
    currentSlide: ET(e, t)
  });
  be.useEffect(() => {
    a({ type: "update", slides: e, index: t });
  }, [e, t]);
  const s = be.useMemo(() => ({ ...n, state: n, dispatch: a }), [n, a]);
  return be.createElement(
    uz.Provider,
    { value: a },
    be.createElement(cz.Provider, { value: s }, r)
  );
}
const dz = be.createContext(null), s1 = Od("useTimeouts", "TimeoutsContext", dz);
function rQe({ children: e }) {
  const [t] = be.useState([]);
  be.useEffect(() => () => {
    t.forEach((n) => window.clearTimeout(n)), t.splice(0, t.length);
  }, [t]);
  const r = be.useMemo(() => {
    const n = (i) => {
      t.splice(0, t.length, ...t.filter((o) => o !== i));
    };
    return { setTimeout: (i, o) => {
      const l = window.setTimeout(() => {
        n(l), i();
      }, o);
      return t.push(l), l;
    }, clearTimeout: (i) => {
      i !== void 0 && (n(i), window.clearTimeout(i));
    } };
  }, [t]);
  return be.createElement(dz.Provider, { value: r }, e);
}
const fz = be.forwardRef(function({ label: t, className: r, icon: n, renderIcon: a, onClick: s, style: i, ...o }, l) {
  const { styles: c, labels: u } = Cv(), d = VXe(u, t);
  return be.createElement("button", { ref: l, type: "button", title: d, "aria-label": d, className: Ll(Yr(BXe), r), onClick: s, style: { ...i, ...c.button }, ...o }, a ? a() : be.createElement(n, { className: Yr(ST), style: c.icon }));
});
function nQe(e, t) {
  const r = (n) => be.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "24", height: "24", "aria-hidden": "true", focusable: "false", ...n }, t);
  return r.displayName = e, r;
}
function kv(e, t) {
  return nQe(e, be.createElement(
    "g",
    { fill: "currentColor" },
    be.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    t
  ));
}
const aQe = kv("Close", be.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })), sQe = kv("Previous", be.createElement("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" })), iQe = kv("Next", be.createElement("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" })), oQe = kv("Loading", be.createElement(be.Fragment, null, Array.from({ length: 8 }).map((e, t, r) => be.createElement("line", { key: t, x1: "12", y1: "6.5", x2: "12", y2: "1.8", strokeLinecap: "round", strokeWidth: "2.6", stroke: "currentColor", strokeOpacity: 1 / r.length * (t + 1), transform: `rotate(${360 / r.length * t}, 12, 12)` })))), lQe = kv("Error", be.createElement("path", { d: "M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z" })), Ov = ez() ? be.useLayoutEffect : be.useEffect;
function hz() {
  const [e, t] = be.useState(!1);
  return be.useEffect(() => {
    var r, n;
    const a = (r = window.matchMedia) === null || r === void 0 ? void 0 : r.call(window, "(prefers-reduced-motion: reduce)");
    t(a == null ? void 0 : a.matches);
    const s = (i) => t(i.matches);
    return (n = a == null ? void 0 : a.addEventListener) === null || n === void 0 || n.call(a, "change", s), () => {
      var i;
      return (i = a == null ? void 0 : a.removeEventListener) === null || i === void 0 ? void 0 : i.call(a, "change", s);
    };
  }, []), e;
}
function cQe(e) {
  let t = 0, r = 0, n = 0;
  const s = window.getComputedStyle(e).transform.match(/matrix.*\((.+)\)/);
  if (s) {
    const i = s[1].split(",").map(r1);
    i.length === 6 ? (t = i[4], r = i[5]) : i.length === 16 && (t = i[12], r = i[13], n = i[14]);
  }
  return { x: t, y: r, z: n };
}
function k4(e, t) {
  const r = be.useRef(void 0), n = be.useRef(void 0), a = hz();
  return Ov(() => {
    var s, i, o;
    if (e.current && r.current !== void 0 && !a) {
      const { keyframes: l, duration: c, easing: u, onfinish: d } = t(r.current, e.current.getBoundingClientRect(), cQe(e.current)) || {};
      if (l && c) {
        (s = n.current) === null || s === void 0 || s.cancel(), n.current = void 0;
        try {
          n.current = (o = (i = e.current).animate) === null || o === void 0 ? void 0 : o.call(i, l, { duration: c, easing: u });
        } catch (f) {
          console.error(f);
        }
        n.current && (n.current.onfinish = () => {
          n.current = void 0, d == null || d();
        });
      }
    }
    r.current = void 0;
  }), {
    prepareAnimation: (s) => {
      r.current = s;
    },
    isAnimationPlaying: () => {
      var s;
      return ((s = n.current) === null || s === void 0 ? void 0 : s.playState) === "running";
    }
  };
}
function pz() {
  const e = be.useRef(null), t = be.useRef(void 0), [r, n] = be.useState();
  return { setContainerRef: be.useCallback((s) => {
    e.current = s, t.current && (t.current.disconnect(), t.current = void 0);
    const i = () => {
      if (s) {
        const o = window.getComputedStyle(s), l = (c) => parseFloat(c) || 0;
        n({
          width: Math.round(s.clientWidth - l(o.paddingLeft) - l(o.paddingRight)),
          height: Math.round(s.clientHeight - l(o.paddingTop) - l(o.paddingBottom))
        });
      } else
        n(void 0);
    };
    i(), s && typeof ResizeObserver < "u" && (t.current = new ResizeObserver(i), t.current.observe(s));
  }, []), containerRef: e, containerRect: r };
}
function My() {
  const e = be.useRef(void 0), { setTimeout: t, clearTimeout: r } = s1();
  return be.useCallback((n, a) => {
    r(e.current), e.current = t(n, a > 0 ? a : 0);
  }, [t, r]);
}
function Qn(e) {
  const t = be.useRef(e);
  return Ov(() => {
    t.current = e;
  }), be.useCallback((...r) => {
    var n;
    return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
  }, []);
}
function O4(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function CT(e, t) {
  return be.useMemo(() => e == null && t == null ? null : (r) => {
    O4(e, r), O4(t, r);
  }, [e, t]);
}
function uQe(e, t = !1) {
  const r = be.useRef(!1);
  Ov(() => {
    t && r.current && (r.current = !1, e());
  }, [t, e]);
  const n = be.useCallback(() => {
    r.current = !0;
  }, []), a = be.useCallback(() => {
    r.current = !1;
  }, []);
  return { onFocus: n, onBlur: a };
}
function cO() {
  const [e, t] = be.useState(!1);
  return Ov(() => {
    t(window.getComputedStyle(window.document.documentElement).direction === "rtl");
  }, []), e;
}
function dQe() {
  const [e] = be.useState({}), t = be.useCallback((a, s) => {
    var i;
    (i = e[a]) === null || i === void 0 || i.forEach((o) => {
      s.isPropagationStopped() || o(s);
    });
  }, [e]), r = be.useMemo(() => ({
    onPointerDown: (a) => t(WW, a),
    onPointerMove: (a) => t(zW, a),
    onPointerUp: (a) => t(KW, a),
    onPointerLeave: (a) => t(qW, a),
    onPointerCancel: (a) => t(GW, a),
    onKeyDown: (a) => t(YW, a),
    onKeyUp: (a) => t(MXe, a),
    onWheel: (a) => t(XW, a)
  }), [t]), n = be.useCallback((a, s) => (e[a] || (e[a] = []), e[a].unshift(s), () => {
    const i = e[a];
    i && i.splice(0, i.length, ...i.filter((o) => o !== s));
  }), [e]);
  return { registerSensors: r, subscribeSensors: n };
}
function A4(e, t) {
  const r = be.useRef(0), n = My(), a = Qn((...s) => {
    r.current = Date.now(), e(s);
  });
  return be.useCallback((...s) => {
    n(() => {
      a(s);
    }, t - (Date.now() - r.current));
  }, [t, a, n]);
}
const HS = oO("slide"), WS = oO("slide_image");
function fQe({ slide: e, offset: t, render: r, rect: n, imageFit: a, imageProps: s, onClick: i, onLoad: o, onError: l, style: c }) {
  var u, d, f, h, p, m, g;
  const [y, x] = be.useState(US), { publish: w } = n1(), { setTimeout: _ } = s1(), S = be.useRef(null);
  be.useEffect(() => {
    t === 0 && w(IXe(y));
  }, [t, y, w]);
  const C = Qn((q) => {
    ("decode" in q ? q.decode() : Promise.resolve()).catch(() => {
    }).then(() => {
      q.parentNode && (x($S), _(() => {
        o == null || o(q);
      }, 0));
    });
  }), E = be.useCallback((q) => {
    S.current = q, q != null && q.complete && C(q);
  }, [C]), O = be.useCallback((q) => {
    C(q.currentTarget);
  }, [C]), k = Qn(() => {
    x(VS), l == null || l();
  }), A = HXe(e, a), P = (q, U) => Number.isFinite(q) ? q : U, D = P(Math.max(...((d = (u = e.srcSet) === null || u === void 0 ? void 0 : u.map((q) => q.width)) !== null && d !== void 0 ? d : []).concat(e.width ? [e.width] : []).filter(Boolean)), ((f = S.current) === null || f === void 0 ? void 0 : f.naturalWidth) || 0), N = P(Math.max(...((p = (h = e.srcSet) === null || h === void 0 ? void 0 : h.map((q) => q.height)) !== null && p !== void 0 ? p : []).concat(e.height ? [e.height] : []).filter(Boolean)), ((m = S.current) === null || m === void 0 ? void 0 : m.naturalHeight) || 0), z = D && N ? {
    maxWidth: `min(${D}px, 100%)`,
    maxHeight: `min(${N}px, 100%)`
  } : {
    maxWidth: "100%",
    maxHeight: "100%"
  }, G = (g = e.srcSet) === null || g === void 0 ? void 0 : g.sort((q, U) => q.width - U.width).map((q) => `${q.src} ${q.width}w`).join(", "), Y = () => n && !A && e.width && e.height ? n.height / e.height * e.width : Number.MAX_VALUE, te = G && n && ez() ? `${Math.round(Math.min(Y(), n.width))}px` : void 0, { style: ae, className: ne, ...ue } = s || {};
  return be.createElement(
    be.Fragment,
    null,
    be.createElement("img", { ref: E, onLoad: O, onError: k, onClick: i, draggable: !1, className: Ll(Yr(WS()), A && Yr(WS("cover")), y !== $S && Yr(WS("loading")), ne), style: { ...z, ...c, ...ae }, ...ue, alt: e.alt, sizes: te, srcSet: G, src: e.src }),
    y !== $S && be.createElement(
      "div",
      { className: Yr(HS(RXe)) },
      y === US && (r != null && r.iconLoading ? r.iconLoading() : be.createElement(oQe, { className: Ll(Yr(ST), Yr(HS(US))) })),
      y === VS && (r != null && r.iconError ? r.iconError() : be.createElement(lQe, { className: Ll(Yr(ST), Yr(HS(VS))) }))
    )
  );
}
const hQe = be.forwardRef(function({ className: t, children: r, ...n }, a) {
  const s = be.useRef(null);
  return be.createElement(
    XXe,
    { nodeRef: s },
    be.createElement("div", { ref: CT(a, s), className: Ll(Yr("root"), t), ...n }, r)
  );
});
var Va;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SWIPE = 1] = "SWIPE", e[e.PULL = 2] = "PULL", e[e.ANIMATION = 3] = "ANIMATION";
})(Va || (Va = {}));
function pQe(e, t, r, n, a) {
  be.useEffect(() => ZW(e(WW, t), e(zW, r), e(KW, n), e(qW, n), e(GW, n)), [e, t, r, n, a]);
}
var Oi;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SWIPE = 1] = "SWIPE", e[e.PULL = 2] = "PULL";
})(Oi || (Oi = {}));
const zS = 30;
function mQe({ disableSwipeNavigation: e }, t, r, n, a, s, i, o, l, c, u, d, f, h, p) {
  const m = be.useRef(0), g = be.useRef([]), y = be.useRef(void 0), x = be.useRef(0), w = be.useRef(Oi.NONE), _ = be.useCallback((A) => {
    y.current === A.pointerId && (y.current = void 0, w.current = Oi.NONE);
    const P = g.current;
    P.splice(0, P.length, ...P.filter((D) => D.pointerId !== A.pointerId));
  }, []), S = be.useCallback((A) => {
    _(A), A.persist(), g.current.push(A);
  }, [_]), C = Qn((A) => {
    S(A);
  }), E = (A, P) => u && A > P || c && A < -P, O = Qn((A) => {
    if (g.current.find((P) => P.pointerId === A.pointerId) && y.current === A.pointerId) {
      const P = Date.now() - x.current, D = m.current;
      w.current === Oi.SWIPE ? Math.abs(D) > 0.3 * n || Math.abs(D) > 5 && P < a ? o(D, P) : l(D) : w.current === Oi.PULL && (E(D, 2 * zS) ? h(D, P) : p(D)), m.current = 0, w.current = Oi.NONE;
    }
    _(A);
  }), k = Qn((A) => {
    const P = g.current.find((D) => D.pointerId === A.pointerId);
    if (P) {
      const D = y.current === A.pointerId;
      if (A.buttons === 0) {
        D && m.current !== 0 ? O(A) : _(P);
        return;
      }
      const N = A.clientX - P.clientX, z = A.clientY - P.clientY;
      if (y.current === void 0) {
        const G = (Y) => {
          S(A), y.current = A.pointerId, x.current = Date.now(), w.current = Y;
        };
        Math.abs(N) > Math.abs(z) && Math.abs(N) > zS && r(N) ? e || (G(Oi.SWIPE), s()) : Math.abs(z) > Math.abs(N) && E(z, zS) && (G(Oi.PULL), d());
      } else D && (w.current === Oi.SWIPE ? (m.current = N, i(N)) : w.current === Oi.PULL && (m.current = z, f(z)));
    }
  });
  pQe(t, C, k, O);
}
function gQe({ preventDefaultWheelX: e, preventDefaultWheelY: t }) {
  const r = be.useRef(null), n = Qn((a) => {
    const s = Math.abs(a.deltaX) > Math.abs(a.deltaY);
    (s && e || !s && t || a.ctrlKey) && a.preventDefault();
  });
  return be.useCallback((a) => {
    var s;
    a ? a.addEventListener("wheel", n, { passive: !1 }) : (s = r.current) === null || s === void 0 || s.removeEventListener("wheel", n), r.current = a;
  }, [n]);
}
function vQe(e, t, r, n, a, s, i, o, l) {
  const c = be.useRef(0), u = be.useRef(0), d = be.useRef(void 0), f = be.useRef(void 0), h = be.useRef(0), p = be.useRef(void 0), m = be.useRef(0), { setTimeout: g, clearTimeout: y } = s1(), x = be.useCallback(() => {
    d.current && (y(d.current), d.current = void 0);
  }, [y]), w = be.useCallback(() => {
    f.current && (y(f.current), f.current = void 0);
  }, [y]), _ = Qn(() => {
    e !== Va.SWIPE && (c.current = 0, m.current = 0, x(), w());
  });
  be.useEffect(_, [e, _]);
  const S = Qn((E) => {
    f.current = void 0, c.current === E && l(c.current);
  }), C = Qn((E) => {
    if (E.ctrlKey || Math.abs(E.deltaY) > Math.abs(E.deltaX))
      return;
    const O = (k) => {
      h.current = k, y(p.current), p.current = k > 0 ? g(() => {
        h.current = 0, p.current = void 0;
      }, 300) : void 0;
    };
    if (e === Va.NONE) {
      if (Math.abs(E.deltaX) <= 1.2 * Math.abs(h.current)) {
        O(E.deltaX);
        return;
      }
      if (!r(-E.deltaX))
        return;
      if (u.current += E.deltaX, x(), Math.abs(u.current) > 30)
        u.current = 0, O(0), m.current = Date.now(), s();
      else {
        const k = u.current;
        d.current = g(() => {
          d.current = void 0, k === u.current && (u.current = 0);
        }, a);
      }
    } else if (e === Va.SWIPE) {
      let k = c.current - E.deltaX;
      if (k = Math.min(Math.abs(k), n) * Math.sign(k), c.current = k, i(k), w(), Math.abs(k) > 0.2 * n) {
        O(E.deltaX), o(k, Date.now() - m.current);
        return;
      }
      f.current = g(() => S(k), 2 * a);
    } else
      O(E.deltaX);
  });
  be.useEffect(() => t(XW, C), [t, C]);
}
const P4 = oO("container"), mz = be.createContext(null), Av = Od("useController", "ControllerContext", mz);
function yQe({ children: e, ...t }) {
  var r;
  const { carousel: n, animation: a, controller: s, on: i, styles: o, render: l } = t, { closeOnPullUp: c, closeOnPullDown: u, preventDefaultWheelX: d, preventDefaultWheelY: f } = s, [h, p] = be.useState(), m = a1(), g = ZXe(), [y, x] = be.useState(Va.NONE), w = be.useRef(0), _ = be.useRef(0), S = be.useRef(1), { registerSensors: C, subscribeSensors: E } = dQe(), { subscribe: O, publish: k } = n1(), A = My(), P = My(), D = My(), { containerRef: N, setContainerRef: z, containerRect: G } = pz(), Y = CT(gQe({ preventDefaultWheelX: d, preventDefaultWheelY: f }), z), te = be.useRef(null), ae = CT(te, void 0), { getOwnerDocument: ne } = lO(), ue = cO(), q = (Ge) => (ue ? -1 : 1) * (typeof Ge == "number" ? Ge : 1), U = Qn(() => {
    var Ge;
    return (Ge = N.current) === null || Ge === void 0 ? void 0 : Ge.focus();
  }), Q = Qn(() => t), L = Qn(() => m), j = be.useCallback((Ge) => k(bu, Ge), [k]), K = be.useCallback((Ge) => k(wu, Ge), [k]), J = be.useCallback(() => k(gh), [k]), re = (Ge) => !(n.finite && (q(Ge) > 0 && m.currentIndex === 0 || q(Ge) < 0 && m.currentIndex === m.slides.length - 1)), le = (Ge) => {
    var oe;
    w.current = Ge, (oe = N.current) === null || oe === void 0 || oe.style.setProperty(ys("swipe_offset"), `${Math.round(Ge)}px`);
  }, pe = (Ge) => {
    var oe, ve;
    _.current = Ge, S.current = (() => {
      const _e = u && Ge > 0 ? Ge : c && Ge < 0 ? -Ge : 0;
      return Math.min(Math.max($Xe(1 - _e / 60 * (1 - 0.5), 2), 0.5), 1);
    })(), (oe = N.current) === null || oe === void 0 || oe.style.setProperty(ys("pull_offset"), `${Math.round(Ge)}px`), (ve = N.current) === null || ve === void 0 || ve.style.setProperty(ys("pull_opacity"), `${S.current}`);
  }, { prepareAnimation: me } = k4(te, (Ge, oe, ve) => {
    if (te.current && G)
      return {
        keyframes: [
          {
            transform: `translate(0, ${Ge.rect.y - oe.y + ve.y}px)`,
            opacity: Ge.opacity
          },
          { transform: "translate(0, 0)", opacity: 1 }
        ],
        duration: Ge.duration,
        easing: a.easing.fade
      };
  }), Oe = (Ge, oe) => {
    if (c || u) {
      pe(Ge);
      let ve = 0;
      te.current && (ve = a.fade * (oe ? 2 : 1), me({
        rect: te.current.getBoundingClientRect(),
        opacity: S.current,
        duration: ve
      })), D(() => {
        pe(0), x(Va.NONE);
      }, ve), x(Va.ANIMATION), oe || J();
    }
  }, { prepareAnimation: ee, isAnimationPlaying: he } = k4(te, (Ge, oe, ve) => {
    var ye;
    if (te.current && G && (!((ye = m.animation) === null || ye === void 0) && ye.duration)) {
      const Te = vw(n.spacing), _e = (Te.percent ? Te.percent * G.width / 100 : Te.pixel) || 0;
      return {
        keyframes: [
          {
            transform: `translate(${q(m.globalIndex - Ge.index) * (G.width + _e) + Ge.rect.x - oe.x + ve.x}px, 0)`
          },
          { transform: "translate(0, 0)" }
        ],
        duration: m.animation.duration,
        easing: m.animation.easing
      };
    }
  }), Ee = Qn((Ge) => {
    var oe, ve;
    const ye = Ge.offset || 0, Te = ye ? a.swipe : (oe = a.navigation) !== null && oe !== void 0 ? oe : a.swipe, _e = !ye && !he() ? a.easing.navigation : a.easing.swipe;
    let { direction: Ae } = Ge;
    const Ve = (ve = Ge.count) !== null && ve !== void 0 ? ve : 1;
    let mt = Va.ANIMATION, Dt = Te * Ve;
    if (!Ae) {
      const $t = G == null ? void 0 : G.width, Rt = Ge.duration || 0, Pr = $t ? Te / $t * Math.abs(ye) : Te;
      Ve !== 0 ? (Rt < Pr ? Dt = Dt / Pr * Math.max(Rt, Pr / 5) : $t && (Dt = Te / $t * ($t - Math.abs(ye))), Ae = q(ye) > 0 ? bu : wu) : Dt = Te / 2;
    }
    let Gt = 0;
    Ae === bu ? re(q(1)) ? Gt = -Ve : (mt = Va.NONE, Dt = Te) : Ae === wu && (re(q(-1)) ? Gt = Ve : (mt = Va.NONE, Dt = Te)), Dt = Math.round(Dt), P(() => {
      le(0), x(Va.NONE);
    }, Dt), te.current && ee({
      rect: te.current.getBoundingClientRect(),
      index: m.globalIndex
    }), x(mt), k(T4, {
      type: "swipe",
      increment: Gt,
      duration: Dt,
      easing: _e
    });
  });
  be.useEffect(() => {
    var Ge, oe;
    !((Ge = m.animation) === null || Ge === void 0) && Ge.increment && (!((oe = m.animation) === null || oe === void 0) && oe.duration) && A(() => g({ type: "swipe", increment: 0 }), m.animation.duration);
  }, [m.animation, g, A]);
  const we = [
    E,
    re,
    (G == null ? void 0 : G.width) || 0,
    a.swipe,
    () => x(Va.SWIPE),
    (Ge) => le(Ge),
    (Ge, oe) => Ee({ offset: Ge, duration: oe, count: 1 }),
    (Ge) => Ee({ offset: Ge, count: 0 })
  ], Pe = [
    () => {
      u && x(Va.PULL);
    },
    (Ge) => pe(Ge),
    (Ge) => Oe(Ge),
    (Ge) => Oe(Ge, !0)
  ];
  mQe(s, ...we, c, u, ...Pe), vQe(y, ...we);
  const rt = Qn(() => {
    s.focus && ne().querySelector(`.${Yr(iO)} .${Yr(P4())}`) && U();
  });
  be.useEffect(rt, [rt]);
  const ht = Qn(() => {
    var Ge;
    (Ge = i.view) === null || Ge === void 0 || Ge.call(i, { index: m.currentIndex });
  });
  be.useEffect(ht, [m.globalIndex, ht]), be.useEffect(() => ZW(O(bu, (Ge) => Ee({ direction: bu, ...Ge })), O(wu, (Ge) => Ee({ direction: wu, ...Ge })), O(T4, (Ge) => g(Ge))), [O, Ee, g]);
  const bt = be.useMemo(() => ({
    prev: j,
    next: K,
    close: J,
    focus: U,
    slideRect: G ? WXe(G, n.padding) : { width: 0, height: 0 },
    containerRect: G || { width: 0, height: 0 },
    subscribeSensors: E,
    containerRef: N,
    setCarouselRef: ae,
    toolbarWidth: h,
    setToolbarWidth: p
  }), [
    j,
    K,
    J,
    U,
    E,
    G,
    N,
    ae,
    h,
    p,
    n.padding
  ]);
  return be.useImperativeHandle(s.ref, () => ({
    prev: j,
    next: K,
    close: J,
    focus: U,
    getLightboxProps: Q,
    getLightboxState: L
  }), [j, K, J, U, Q, L]), be.createElement("div", { ref: Y, className: Ll(Yr(P4()), Yr($W)), style: {
    ...y === Va.SWIPE ? { [ys("swipe_offset")]: `${Math.round(w.current)}px` } : null,
    ...y === Va.PULL ? {
      [ys("pull_offset")]: `${Math.round(_.current)}px`,
      [ys("pull_opacity")]: `${S.current}`
    } : null,
    ...s.touchAction !== "none" ? { [ys("controller_touch_action")]: s.touchAction } : null,
    ...o.container
  }, ...s.aria ? { role: "presentation", "aria-live": "polite" } : null, tabIndex: -1, ...C }, G && be.createElement(
    mz.Provider,
    { value: bt },
    e,
    (r = l.controls) === null || r === void 0 ? void 0 : r.call(l)
  ));
}
const bQe = Ad(UW, yQe);
function du(e) {
  return Tv(BW, e);
}
function R4(e) {
  return Tv("slide", e);
}
function wQe({ slide: e, offset: t }) {
  const r = be.useRef(null), { currentIndex: n } = a1(), { slideRect: a, close: s, focus: i } = Av(), { render: o, carousel: { imageFit: l, imageProps: c }, on: { click: u }, controller: { closeOnBackdropClick: d }, styles: { slide: f } } = Cv(), { getOwnerDocument: h } = lO(), p = t !== 0;
  be.useEffect(() => {
    var y;
    p && (!((y = r.current) === null || y === void 0) && y.contains(h().activeElement)) && i();
  }, [p, i, h]);
  const m = () => {
    var y, x, w, _;
    let S = (y = o.slide) === null || y === void 0 ? void 0 : y.call(o, { slide: e, offset: t, rect: a });
    return !S && tz(e) && (S = be.createElement(fQe, { slide: e, offset: t, render: o, rect: a, imageFit: l, imageProps: c, onClick: p ? void 0 : () => u == null ? void 0 : u({ index: n }) })), S ? be.createElement(
      be.Fragment,
      null,
      (x = o.slideHeader) === null || x === void 0 ? void 0 : x.call(o, { slide: e }),
      ((w = o.slideContainer) !== null && w !== void 0 ? w : ({ children: C }) => C)({ slide: e, children: S }),
      (_ = o.slideFooter) === null || _ === void 0 ? void 0 : _.call(o, { slide: e })
    ) : null;
  }, g = (y) => {
    const x = r.current, w = y.target instanceof HTMLElement ? y.target : void 0;
    d && w && x && (w === x || Array.from(x.children).find((_) => _ === w) && w.classList.contains(Yr(NXe))) && s();
  };
  return be.createElement("div", { ref: r, className: Ll(Yr(R4()), !p && Yr(R4("current")), Yr($W)), ...GXe(p), onClick: g, style: f }, m());
}
function xQe() {
  const e = Cv().styles.slide;
  return be.createElement("div", { className: Yr("slide"), style: e });
}
function _Qe({ carousel: e }) {
  const { slides: t, currentIndex: r, globalIndex: n } = a1(), { setCarouselRef: a } = Av(), s = vw(e.spacing), i = vw(e.padding), o = KXe(e, t, 1), l = [];
  if (nz(t))
    for (let c = r - o; c <= r + o; c += 1) {
      const u = az(t, c), d = n - r + c, f = e.finite && (c < 0 || c > t.length - 1);
      l.push(f ? { key: d } : {
        key: [`${d}`, zXe(u)].filter(Boolean).join("|"),
        offset: c - r,
        slide: u
      });
    }
  return be.createElement("div", { ref: a, className: Ll(Yr(du()), l.length > 0 && Yr(du("with_slides"))), style: {
    [`${ys(du("slides_count"))}`]: l.length,
    [`${ys(du("spacing_px"))}`]: s.pixel || 0,
    [`${ys(du("spacing_percent"))}`]: s.percent || 0,
    [`${ys(du("padding_px"))}`]: i.pixel || 0,
    [`${ys(du("padding_percent"))}`]: i.percent || 0
  } }, l.map(({ key: c, slide: u, offset: d }) => u ? be.createElement(wQe, { key: c, slide: u, offset: d }) : be.createElement(xQe, { key: c })));
}
const SQe = Ad(BW, _Qe);
function gz() {
  const { carousel: e } = Cv(), { slides: t, currentIndex: r } = a1(), n = t.length === 0 || e.finite && r === 0, a = t.length === 0 || e.finite && r === t.length - 1;
  return { prevDisabled: n, nextDisabled: a };
}
function EQe(e) {
  var t;
  const r = cO(), { publish: n } = n1(), { animation: a } = Cv(), { prevDisabled: s, nextDisabled: i } = gz(), o = ((t = a.navigation) !== null && t !== void 0 ? t : a.swipe) / 2, l = A4(() => n(bu), o), c = A4(() => n(wu), o), u = Qn((d) => {
    switch (d.key) {
      case LXe:
        n(gh);
        break;
      case jXe:
        (r ? i : s) || (r ? c : l)();
        break;
      case FXe:
        (r ? s : i) || (r ? l : c)();
        break;
    }
  });
  be.useEffect(() => e(YW, u), [e, u]);
}
function I4({ label: e, icon: t, renderIcon: r, action: n, onClick: a, disabled: s, style: i }) {
  return be.createElement(fz, { label: e, icon: t, renderIcon: r, className: Yr(`navigation_${n}`), disabled: s, onClick: a, style: i, ...uQe(Av().focus, s) });
}
function TQe({ render: { buttonPrev: e, buttonNext: t, iconPrev: r, iconNext: n }, styles: a }) {
  const { prev: s, next: i, subscribeSensors: o } = Av(), { prevDisabled: l, nextDisabled: c } = gz();
  return EQe(o), be.createElement(
    be.Fragment,
    null,
    e ? e() : be.createElement(I4, { label: "Previous", action: bu, icon: sQe, renderIcon: r, style: a.navigationPrev, disabled: l, onClick: s }),
    t ? t() : be.createElement(I4, { label: "Next", action: wu, icon: iQe, renderIcon: n, style: a.navigationNext, disabled: c, onClick: i })
  );
}
const CQe = Ad(OXe, TQe), D4 = Yr(DXe), kQe = Yr(HW);
function OQe(e) {
  return "style" in e;
}
function N4(e, t, r) {
  const n = window.getComputedStyle(e), a = r ? "padding-left" : "padding-right", s = r ? n.paddingLeft : n.paddingRight, i = e.style.getPropertyValue(a);
  return e.style.setProperty(a, `${(r1(s) || 0) + t}px`), () => {
    i ? e.style.setProperty(a, i) : e.style.removeProperty(a);
  };
}
function AQe({ noScroll: { disabled: e }, children: t }) {
  const r = cO(), { getOwnerDocument: n, getOwnerWindow: a } = lO();
  return be.useEffect(() => {
    if (e)
      return () => {
      };
    const s = [], i = a(), { body: o, documentElement: l } = n(), c = Math.round(i.innerWidth - l.clientWidth);
    if (c > 0) {
      s.push(N4(o, c, r));
      const u = o.getElementsByTagName("*");
      for (let d = 0; d < u.length; d += 1) {
        const f = u[d];
        OQe(f) && i.getComputedStyle(f).getPropertyValue("position") === "fixed" && !f.classList.contains(kQe) && s.push(N4(f, c, r));
      }
    }
    return o.classList.add(D4), () => {
      o.classList.remove(D4), s.forEach((u) => u());
    };
  }, [r, e, n, a]), be.createElement(be.Fragment, null, t);
}
const PQe = Ad(AXe, AQe);
function M4(e) {
  return Tv(iO, e);
}
function L4(e, t, r) {
  const n = e.getAttribute(t);
  return e.setAttribute(t, r), () => {
    n ? e.setAttribute(t, n) : e.removeAttribute(t);
  };
}
function RQe({ children: e, animation: t, styles: r, className: n, on: a, portal: s, close: i }) {
  const [o, l] = be.useState(!1), [c, u] = be.useState(!1), d = be.useRef([]), f = be.useRef(null), { setTimeout: h } = s1(), { subscribe: p } = n1(), g = hz() ? 0 : t.fade;
  be.useEffect(() => (l(!0), () => {
    l(!1), u(!1);
  }), []);
  const y = Qn(() => {
    d.current.forEach((S) => S()), d.current = [];
  }), x = Qn(() => {
    var S;
    u(!1), y(), (S = a.exiting) === null || S === void 0 || S.call(a), h(() => {
      var C;
      (C = a.exited) === null || C === void 0 || C.call(a), i();
    }, g);
  });
  be.useEffect(() => p(gh, x), [p, x]);
  const w = Qn((S) => {
    var C, E, O;
    S.scrollTop, u(!0), (C = a.entering) === null || C === void 0 || C.call(a);
    const k = (O = (E = S.parentNode) === null || E === void 0 ? void 0 : E.children) !== null && O !== void 0 ? O : [];
    for (let A = 0; A < k.length; A += 1) {
      const P = k[A];
      ["TEMPLATE", "SCRIPT", "STYLE"].indexOf(P.tagName) === -1 && P !== S && (d.current.push(L4(P, "inert", "")), d.current.push(L4(P, "aria-hidden", "true")));
    }
    d.current.push(() => {
      var A, P;
      (P = (A = f.current) === null || A === void 0 ? void 0 : A.focus) === null || P === void 0 || P.call(A);
    }), h(() => {
      var A;
      (A = a.entered) === null || A === void 0 || A.call(a);
    }, g);
  }), _ = be.useCallback((S) => {
    S ? w(S) : y();
  }, [w, y]);
  return o ? bw(be.createElement(hQe, { ref: _, className: Ll(n, Yr(M4()), Yr(HW), c && Yr(M4("open"))), role: "presentation", "aria-live": "polite", style: {
    ...t.fade !== TT.animation.fade ? { [ys("fade_animation_duration")]: `${g}ms` } : null,
    ...t.easing.fade !== TT.animation.easing.fade ? { [ys("fade_animation_timing_function")]: t.easing.fade } : null,
    ...r.root
  }, onFocus: (S) => {
    f.current || (f.current = S.relatedTarget);
  } }, e), s.root || document.body) : null;
}
const IQe = Ad(iO, RQe);
function DQe({ children: e }) {
  return be.createElement(be.Fragment, null, e);
}
const NQe = Ad(PXe, DQe);
function MQe(e) {
  return Tv(VW, e);
}
function LQe({ toolbar: { buttons: e }, render: { buttonClose: t, iconClose: r }, styles: n }) {
  const { close: a, setToolbarWidth: s } = Av(), { setContainerRef: i, containerRect: o } = pz();
  Ov(() => {
    s(o == null ? void 0 : o.width);
  }, [s, o == null ? void 0 : o.width]);
  const l = () => t ? t() : be.createElement(fz, { key: gh, label: "Close", icon: aQe, renderIcon: r, onClick: a });
  return be.createElement("div", { ref: i, style: n.toolbar, className: Yr(MQe()) }, e == null ? void 0 : e.map((c) => c === gh ? l() : c));
}
const jQe = Ad(VW, LQe);
function vz(e, t) {
  var r;
  return be.createElement(e.module.component, { key: e.module.name, ...t }, (r = e.children) === null || r === void 0 ? void 0 : r.map((n) => vz(n, t)));
}
function FQe(e, t = {}) {
  const { easing: r, ...n } = e, { easing: a, ...s } = t;
  return {
    easing: { ...r, ...a },
    ...n,
    ...s
  };
}
function BQe({ carousel: e, animation: t, render: r, toolbar: n, controller: a, noScroll: s, on: i, plugins: o, slides: l, index: c, ...u }) {
  const { animation: d, carousel: f, render: h, toolbar: p, controller: m, noScroll: g, on: y, slides: x, index: w, plugins: _, ...S } = TT, { config: C, augmentation: E } = YXe([
    ha(IQe, [
      ha(PQe, [
        ha(bQe, [
          ha(SQe),
          ha(jQe),
          ha(CQe)
        ])
      ])
    ])
  ], o || _), O = E({
    animation: FQe(d, t),
    carousel: { ...f, ...e },
    render: { ...h, ...r },
    toolbar: { ...p, ...n },
    controller: { ...m, ...a },
    noScroll: { ...g, ...s },
    on: { ...y, ...i },
    ...S,
    ...u
  });
  return O.open ? be.createElement(
    JXe,
    { ...O },
    be.createElement(
      tQe,
      { slides: l || x, index: r1(c || w) },
      be.createElement(
        rQe,
        null,
        be.createElement(QXe, null, vz(ha(NQe, C), O))
      )
    )
  ) : null;
}
const UQe = ({
  project: e
}) => {
  var h, p, m, g, y, x, w, _, S, C, E, O, k;
  const { t } = _t(["projects"]), [r, n] = Me(!1), [a, s] = Me(0), i = ((h = e.files) == null ? void 0 : h.images) || [], o = i.map((A) => ({ src: A })), l = i.slice(0, 3), c = i.length > 3, u = (y = (g = (m = (p = e.info) == null ? void 0 : p.attributes) == null ? void 0 : m.info) == null ? void 0 : g.kpis) == null ? void 0 : y.kpi_1, d = (S = (_ = (w = (x = e.info) == null ? void 0 : x.attributes) == null ? void 0 : w.info) == null ? void 0 : _.kpis) == null ? void 0 : S.kpi_2, f = [
    {
      icon: "target",
      label: ((C = u == null ? void 0 : u.title) == null ? void 0 : C.label) || "N/A",
      value: `${(u == null ? void 0 : u.value) || "N/A"}${(u == null ? void 0 : u.operator) || ""}`,
      info: (u == null ? void 0 : u.description) || "",
      tooltip: u == null ? void 0 : u.tooltip
    },
    {
      icon: "chart-line",
      label: ((E = d == null ? void 0 : d.title) == null ? void 0 : E.label) || "N/A",
      value: `${(d == null ? void 0 : d.value) || "N/A"}${(d == null ? void 0 : d.operator) || ""}`,
      info: (d == null ? void 0 : d.description) || "",
      tooltip: d == null ? void 0 : d.tooltip
    }
  ];
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs("div", { className: "grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6 mb-4 lg:mb-6", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "md:col-span-2 relative rounded-lg overflow-hidden", children: [
        /* @__PURE__ */ v.jsx(
          fi,
          {
            src: ((k = (O = e.files) == null ? void 0 : O.images) == null ? void 0 : k[0]) || "",
            alt: e.name,
            ratio: "aspect-[3/2]",
            className: "w-full h-full object-cover",
            onClick: () => {
              s(0), n(!0);
            }
          }
        ),
        /* @__PURE__ */ v.jsx("div", { className: "absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60" }),
        /* @__PURE__ */ v.jsx("div", { className: "absolute bottom-4 left-4 right-4 overflow-x-auto", children: /* @__PURE__ */ v.jsx(VQe, { infos: f }) }),
        c && /* @__PURE__ */ v.jsx(
          qe,
          {
            variant: "solid",
            color: "primary",
            className: "absolute md:hidden top-4 right-4 bg-opacity-90 hover:bg-opacity-100",
            size: "sm",
            onClick: (A) => {
              A.stopPropagation(), s(0), n(!0);
            },
            children: t("projects.seeImages")
          }
        )
      ] }),
      /* @__PURE__ */ v.jsx("div", { className: "hidden md:grid md:col-span-1 grid-rows-2 gap-4 lg:gap-6", children: [1, 2].map((A) => /* @__PURE__ */ v.jsxs("div", { className: "relative rounded-lg overflow-hidden", children: [
        /* @__PURE__ */ v.jsx(
          fi,
          {
            src: l[A] || "",
            alt: `${e.name} - ${A + 1}`,
            ratio: "aspect-[3/2]",
            className: "w-full h-full object-cover",
            fallbackSrc: "/images/placeholder.jpg",
            onClick: () => {
              l[A] && (s(A), n(!0));
            }
          }
        ),
        /* @__PURE__ */ v.jsx("div", { className: "absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60" }),
        A === 1 && c && /* @__PURE__ */ v.jsx(
          qe,
          {
            variant: "solid",
            color: "primary",
            className: "absolute top-4 right-4 bg-opacity-90 hover:bg-opacity-100",
            onClick: (P) => {
              P.stopPropagation(), s(0), n(!0);
            },
            children: t("projects.seeImages")
          }
        )
      ] }, A)) })
    ] }),
    /* @__PURE__ */ v.jsx(
      BQe,
      {
        open: r,
        close: () => n(!1),
        index: a,
        slides: o,
        carousel: { finite: o.length <= 1 },
        animation: { fade: 300 },
        controller: { closeOnBackdropClick: !0 }
      }
    )
  ] });
}, VQe = ({ infos: e }) => /* @__PURE__ */ v.jsx("div", { className: "flex flex-col space-y-2 lg:flex-row lg:space-x-2 lg:space-y-0 overflow-x-auto", children: e.map((t, r) => /* @__PURE__ */ v.jsxs(
  "div",
  {
    className: "flex-shrink-0 flex lg:flex-col items-center justify-between border border-white px-2 py-1 lg:p-3 rounded-lg bg-black bg-opacity-20 backdrop-blur-sm lg:w-48 space-x-2 lg:space-x-0 lg:space-y-2",
    children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flex items-center lg:self-start gap-2", children: [
        /* @__PURE__ */ v.jsx(
          dt,
          {
            name: t.icon,
            color: "white",
            size: "xs",
            className: "lg:hidden"
          }
        ),
        /* @__PURE__ */ v.jsx(
          dt,
          {
            name: t.icon,
            color: "white",
            size: "sm",
            className: "hidden lg:block"
          }
        ),
        /* @__PURE__ */ v.jsx("p", { className: "text-white text-xs lg:text-sm whitespace-nowrap", children: t.label })
      ] }),
      /* @__PURE__ */ v.jsxs("div", { className: "flex items-center lg:justify-between lg:w-full space-x-2 lg:space-x-0", children: [
        /* @__PURE__ */ v.jsxs("p", { className: "flex items-baseline text-white text-sm lg:text-xl space-x-1", children: [
          /* @__PURE__ */ v.jsx("span", { children: t.value }),
          t.info && /* @__PURE__ */ v.jsx("span", { className: "text-xxs lg:text-xs text-gray-400 whitespace-nowrap", children: t.info })
        ] }),
        t.tooltip && /* @__PURE__ */ v.jsx(ni, { content: t.tooltip, variant: "dark", children: /* @__PURE__ */ v.jsx(
          dt,
          {
            name: "question",
            color: "white",
            size: "xs",
            className: "cursor-help flex-shrink-0"
          }
        ) })
      ] })
    ]
  },
  r
)) }), $Qe = ({ project: e }) => {
  var S, C, E, O;
  const { t } = _t(["projects"]), [r, n] = Me(2), [a, s] = Me(1e3);
  if (!(e != null && e.id))
    return null;
  const { handleInvest: i, isInvestmentEnabled: o, campaign: l, isLoading: c } = nO((e == null ? void 0 : e.id) ?? null), u = () => s((k) => k + 50), d = () => s((k) => Math.max(0, k - 50));
  if (c)
    return /* @__PURE__ */ v.jsx(la, {});
  const f = (E = (C = (S = e.info) == null ? void 0 : S.attributes) == null ? void 0 : C.info) == null ? void 0 : E.simulation, h = (f == null ? void 0 : f.rate) || 0, p = (f == null ? void 0 : f.duration) || 0, m = ((O = f == null ? void 0 : f.durationType) == null ? void 0 : O.value) || "year", g = (f == null ? void 0 : f.min) || 1, y = (f == null ? void 0 : f.max) || 120, x = m === "month" ? p / 12 : p, _ = (a * h * x / 100).toLocaleString("fr-FR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
  return /* @__PURE__ */ v.jsxs(
    hr,
    {
      className: "sticky top-4",
      size: "sm",
      color: "bg-secondary-50",
      border: "border-secondary-200",
      children: [
        /* @__PURE__ */ v.jsx("div", { className: "flex items-center justify-between border-b border-primary-400 pb-5", children: /* @__PURE__ */ v.jsx("div", { className: "flex justify-left items-center space-x-2", children: /* @__PURE__ */ v.jsx("span", { className: "font-medium", children: t("projects.investment") }) }) }),
        /* @__PURE__ */ v.jsxs("div", { className: "flex items-center justify-between space-x-4 py-5 border-b border-primary-400", children: [
          /* @__PURE__ */ v.jsx(
            qe,
            {
              icon: "minus",
              variant: "solid",
              color: "primary",
              onClick: d,
              className: "w-12 sm:w-auto"
            }
          ),
          /* @__PURE__ */ v.jsx(
            ar,
            {
              type: "number",
              value: a,
              onChange: (k) => s(Number(k.target.value)),
              className: "flex-1"
            }
          ),
          /* @__PURE__ */ v.jsx(
            qe,
            {
              icon: "plus",
              variant: "solid",
              color: "primary",
              onClick: u,
              className: "w-12 sm:w-auto"
            }
          )
        ] }),
        /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col space-y-3 py-3 border-b border-primary-400", children: [
          /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center", children: [
            /* @__PURE__ */ v.jsx("div", { className: "flex justify-left items-center space-x-2", children: /* @__PURE__ */ v.jsx("span", { children: t("projects.simulation.rate") }) }),
            /* @__PURE__ */ v.jsx("span", { className: "flex items-baseline text-2xl font-medium space-x-1", children: /* @__PURE__ */ v.jsxs("span", { children: [
              h,
              "%"
            ] }) })
          ] }),
          /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center", children: [
            /* @__PURE__ */ v.jsx("div", { className: "flex justify-left items-center space-x-2", children: /* @__PURE__ */ v.jsx("span", { children: t("projects.simulation.duration") }) }),
            /* @__PURE__ */ v.jsx("span", { className: "flex items-baseline space-x-1 text-2xl font-medium", children: /* @__PURE__ */ v.jsxs("span", { children: [
              p,
              " ",
              t(`projects.simulation.${m}s`)
            ] }) })
          ] })
        ] }),
        /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col space-y-3 py-3 border-b border-primary-400", children: [
          /* @__PURE__ */ v.jsx("div", { className: "flex justify-left items-center space-x-2", children: /* @__PURE__ */ v.jsx("span", { className: "font-medium", children: t("projects.estimatedGains") }) }),
          /* @__PURE__ */ v.jsxs("div", { className: "flex items-center justify-between space-x-4", children: [
            /* @__PURE__ */ v.jsx("div", { className: "w-1/3", children: /* @__PURE__ */ v.jsx(
              ar,
              {
                type: "text",
                readOnly: !0,
                value: `+${_}€`
              }
            ) }),
            /* @__PURE__ */ v.jsx("div", { className: "w-2/3", children: /* @__PURE__ */ v.jsx(
              qB,
              {
                min: g,
                max: y,
                value: p,
                onChange: (k) => {
                  n(k);
                },
                size: "md",
                variant: "gradient",
                showValue: !0,
                valuePosition: "right",
                showTooltip: !0,
                tooltipLabel: (k) => `${k} ${t(`projects.simulation.${m}s`)}`
              }
            ) })
          ] }),
          /* @__PURE__ */ v.jsxs("span", { className: "text-sm text-gray-500 text-right", children: [
            p,
            " ",
            t(`projects.simulation.${m}s`)
          ] })
        ] }),
        /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col space-y-1 py-3 border-b border-primary-400 mb-3", children: [
          /* @__PURE__ */ v.jsx("div", { className: "flex justify-left items-center space-x-2", children: /* @__PURE__ */ v.jsx("span", { className: "text-sm font-medium", children: t("projects.futureCapital") }) }),
          /* @__PURE__ */ v.jsx(
            xXe,
            {
              investmentAmount: 2e3,
              years: 3,
              gainsData: [2e3, 2500, 3500, 4500],
              investedData: [1500, 1500, 1500, 1500]
            }
          )
        ] }),
        /* @__PURE__ */ v.jsx(
          qe,
          {
            variant: "solid",
            color: "primary",
            fullWidth: !0,
            onClick: i,
            disabled: !o,
            children: t("projects.invest")
          }
        )
      ]
    }
  );
}, HQe = ({ items: e }) => /* @__PURE__ */ v.jsx("div", { className: "w-full overflow-x-auto", children: /* @__PURE__ */ v.jsx("div", { className: "min-w-[800px]", children: /* @__PURE__ */ v.jsx("div", { className: "flex", children: e.map((t, r) => {
  var n;
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: "relative flex-shrink-0 w-[250px] last:w-auto last:max-w-[250px]",
      children: [
        /* @__PURE__ */ v.jsx("div", { className: "text-lg font-bold text-gray-900 mb-4", children: (n = t.title) == null ? void 0 : n.label }),
        /* @__PURE__ */ v.jsxs("div", { className: "flex items-center h-3", children: [
          /* @__PURE__ */ v.jsx("div", { className: "w-3 h-3 rounded-full bg-primary-600 z-10" }),
          r < e.length - 1 && /* @__PURE__ */ v.jsx(
            "div",
            {
              className: "h-[1px] bg-primary-600 flex-grow",
              style: { marginLeft: "-1.5px" }
            }
          )
        ] }),
        /* @__PURE__ */ v.jsx("div", { className: "mt-6 space-y-4", children: /* @__PURE__ */ v.jsx("p", { className: "text-sm text-gray-600 mt-1", children: t.description }) })
      ]
    },
    r
  );
}) }) }) }), ttt = ({ totalAmount: e = 15042, onViewMore: t }) => {
  const { t: r } = _t(["projects"]), [n, a] = Me("last_year"), s = (o, l, c) => Array.from(
    { length: c },
    () => Math.floor(Math.random() * (l - o + 1) + o)
  ), i = {
    labels: [
      "Jan",
      "Fev",
      "Mar",
      "Avr",
      "Mai",
      "Jun",
      "Jul",
      "Aou",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    datasets: [
      {
        label: r("projects.averageRevenue"),
        data: s(1e3, 1500, 12),
        backgroundColor: "#2C7BE580",
        order: 1
      },
      {
        label: r("projects.occupancyRate"),
        data: s(500, 1e3, 12),
        backgroundColor: "#4B78DF",
        order: 2
      }
    ]
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ v.jsxs("span", { className: "text-3xl font-semibold text-primary-600", children: [
          "+",
          e.toLocaleString("fr-FR"),
          "€"
        ] }),
        /* @__PURE__ */ v.jsx(dt, { name: "info-circle", className: "text-gray-400" })
      ] }),
      /* @__PURE__ */ v.jsx(
        ss,
        {
          options: [
            { value: "last_year", label: r("common.lastYear") },
            { value: "this_year", label: r("common.thisYear") }
          ],
          value: n,
          onChange: (o) => a(o)
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx("div", { className: "", children: /* @__PURE__ */ v.jsx(Z3e, { data: i }) }),
    t && /* @__PURE__ */ v.jsx("div", { className: "flex justify-end", children: /* @__PURE__ */ v.jsx(
      qe,
      {
        variant: "link",
        color: "primary",
        onClick: t,
        icon: "chevron-right",
        iconPosition: "right",
        children: r("common.seeMore")
      }
    ) })
  ] });
}, yz = ({
  campaigns: e,
  isLoading: t,
  error: r,
  onCreateProject: n,
  onViewMore: a
}) => {
  const { t: s } = _t(["projects", "common"]), i = ta(), o = (l) => {
    i(`/projects/${l}/view`);
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "bg-surface rounded-lg overflow-hidden border border-border pl-4 py-4", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center mb-6 pr-4", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ v.jsx("h2", { className: "font-medium", children: s("projects.myProjects") }),
        /* @__PURE__ */ v.jsx("span", { className: "text-sm text-text", children: s("projects.activeProjects") })
      ] }),
      /* @__PURE__ */ v.jsx(qe, { onClick: n, children: s("common:common.add") })
    ] }),
    t ? /* @__PURE__ */ v.jsx(la, { container: "full" }) : r ? /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center justify-center space-y-2 p-4 text-red-500", children: [
      /* @__PURE__ */ v.jsx(dt, { name: "x-circle" }),
      /* @__PURE__ */ v.jsx("span", { children: r })
    ] }) : e.length ? /* @__PURE__ */ v.jsx(
      jW,
      {
        spaceBetween: 16,
        slidesPerView: 1,
        breakpoints: {
          640: { slidesPerView: 1.4, spaceBetween: 24 },
          1024: { slidesPerView: 2.4, spaceBetween: 32 },
          1280: { slidesPerView: 3.2, spaceBetween: 44 },
          1440: { slidesPerView: 3.3, spaceBetween: 44 }
        },
        loop: e.length > 3,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: { clickable: !0 },
        children: e.map((l, c) => {
          var u;
          return /* @__PURE__ */ v.jsx(FW, { children: /* @__PURE__ */ v.jsx(
            _W,
            {
              campaign: l,
              onClick: () => {
                var d;
                return ((d = l.project) == null ? void 0 : d.id) && o(l.project.id);
              },
              variant: "dashboard"
            }
          ) }, `${(u = l.project) == null ? void 0 : u.id}-${c}`);
        })
      }
    ) : /* @__PURE__ */ v.jsx(
      dh,
      {
        icon: "grid",
        title: s("projects.noProjectsAdded"),
        description: s("projects.findProjectsInSection"),
        primaryAction: {
          label: s("projects.addFirstProject"),
          onClick: n,
          icon: "plus"
        }
      }
    ),
    /* @__PURE__ */ v.jsx("div", { className: "flex justify-center mt-4", children: /* @__PURE__ */ v.jsx(
      qe,
      {
        variant: "link",
        color: "gray",
        icon: "chevron-right",
        iconPosition: "right",
        onClick: a,
        className: "text-text",
        children: s("common:common.seeMore")
      }
    ) })
  ] });
}, WQe = () => {
  const { t: e } = _t(["projects"]), { campaigns: t, isLoading: r, error: n } = M7({
    displayLimit: 5,
    isAdmin: !0
  }), { entityConfig: a } = qT(), s = ta(), i = () => s("/projects/create"), o = () => s("/campaigns/create"), l = () => s("/projects"), c = () => s("/campaigns"), u = a.columns;
  return r ? /* @__PURE__ */ v.jsx(la, { container: "full" }) : n ? /* @__PURE__ */ v.jsxs("div", { children: [
    "Error: ",
    n
  ] }) : /* @__PURE__ */ v.jsxs("div", { className: "container mx-auto space-y-6", children: [
    /* @__PURE__ */ v.jsx("h1", { className: "text-3xl font-bold mb-4 text-text", children: e("projects.overview") }),
    /* @__PURE__ */ v.jsx("section", { className: "mb-12", children: /* @__PURE__ */ v.jsx(
      yz,
      {
        campaigns: t,
        isLoading: r,
        error: n,
        onCreateProject: i,
        onViewMore: l
      }
    ) }),
    /* @__PURE__ */ v.jsx("section", { className: "mb-12", children: /* @__PURE__ */ v.jsx(
      xx,
      {
        columns: u,
        data: t,
        coloredHeader: !0,
        headerSection: {
          before: /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center", children: [
            /* @__PURE__ */ v.jsx("h2", { className: "font-medium text-text", children: e("campaigns:campaigns.myCampaigns") }),
            /* @__PURE__ */ v.jsx(qe, { onClick: o, children: e("common:common.add") })
          ] })
        },
        footerSection: {
          before: /* @__PURE__ */ v.jsx("div", { className: "flex w-full justify-center", children: /* @__PURE__ */ v.jsx(
            qe,
            {
              variant: "link",
              color: "primary",
              icon: "chevron-right",
              iconPosition: "right",
              onClick: c,
              children: e("common:common.seeMore")
            }
          ) })
        }
      }
    ) })
  ] });
}, bz = () => {
  const e = sn(), [t, r] = Me(""), [n, a] = Me(!1);
  wt(() => {
    (async () => {
      var o;
      try {
        a(!0);
        const l = await e.dataApi.data({ kind: "contact" }), c = ((o = l == null ? void 0 : l.find((u) => u.data.key === "link")) == null ? void 0 : o.data.value) || "";
        r(c);
      } catch (l) {
        console.error("Error fetching contact link:", l);
      } finally {
        a(!1);
      }
    })();
  }, [e]);
  const s = Ft(() => {
    t && window.open(t, "_blank");
  }, [t]);
  return {
    hasContactLink: !!t,
    handleContactClick: s,
    loading: n
  };
}, zQe = () => {
  var _, S;
  const { t: e } = _t(["projects"]), { hasContactLink: t, handleContactClick: r } = bz(), { id: n } = B4(), a = sn(), s = ta(), [i, o] = Me(null), [l, c] = Me(!0), [u, d] = Me(null), [f, h] = Me("general"), { isKycVerified: p, checkAndRedirect: m } = N2(), [g, y] = Me(null), { handleInvest: x, isInvestmentEnabled: w } = nO(
    (i == null ? void 0 : i.id) ?? null
  );
  return wt(() => {
    (async () => {
      c(!0), d(null);
      try {
        const E = await a.projectsApi.project({
          id: Number(n)
        });
        o(E);
      } catch (E) {
        console.error("Error fetching project:", E), d("Failed to fetch project. Please try again later.");
      } finally {
        c(!1);
      }
    })();
  }, [a, n]), wt(() => {
    (async () => {
      if (i != null && i.id)
        try {
          const E = await a.projectsApi.projectCampaigns({
            id: i.id
            // status: "available",
          });
          y(E[0] || null);
        } catch (E) {
          console.error("Error fetching campaigns:", E);
        }
    })();
  }, [a, i == null ? void 0 : i.id]), l ? /* @__PURE__ */ v.jsx(la, { container: "full" }) : u ? /* @__PURE__ */ v.jsxs("div", { children: [
    "Error: ",
    u
  ] }) : i ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx("div", { className: "flex items-center mb-6", children: /* @__PURE__ */ v.jsx(
      qe,
      {
        onClick: () => s(-1),
        variant: "link",
        color: "primary",
        size: "sm",
        icon: "chevron-left",
        iconPosition: "left",
        children: e("common:common.back")
      }
    ) }),
    g && !((_ = g.info) != null && _.start_date && ((S = g.info) != null && S.duration) && new Date(g.info.start_date).getTime() + g.info.duration * 24 * 60 * 60 * 1e3 < (/* @__PURE__ */ new Date()).getTime()) && /* @__PURE__ */ v.jsx(
      Yg,
      {
        className: "mb-6",
        text: e("projects.activeCampaignBanner"),
        icon: "radar",
        primaryAction: {
          label: e("projects.invest"),
          onClick: x,
          disabled: !w
        },
        ...t && {
          secondaryAction: {
            label: e("projects.callAdvisor"),
            onClick: r
          }
        }
      }
    ),
    /* @__PURE__ */ v.jsxs(hr, { children: [
      /* @__PURE__ */ v.jsx(UQe, { project: i }),
      /* @__PURE__ */ v.jsxs("div", { className: "grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6", children: [
        /* @__PURE__ */ v.jsx("div", { className: "lg:col-span-2", children: /* @__PURE__ */ v.jsxs(a$, { activeTab: f, onTabChange: h, children: [
          /* @__PURE__ */ v.jsx(oT, { title: e("projects.general.title"), value: "general", children: /* @__PURE__ */ v.jsx(
            kXe,
            {
              project: i,
              activeCampaign: g
            }
          ) }),
          /* @__PURE__ */ v.jsx(oT, { title: e("projects.finance.title"), value: "finance", children: /* @__PURE__ */ v.jsx(CXe, { project: i }) })
        ] }) }),
        /* @__PURE__ */ v.jsxs("div", { className: "lg:col-span-1 lg:sticky lg:top-0", children: [
          /* @__PURE__ */ v.jsxs("div", { className: "flex space-x-2 mb-5", children: [
            !p && /* @__PURE__ */ v.jsx(
              qe,
              {
                variant: "outline",
                color: "primary",
                className: "w-full",
                onClick: () => m(),
                children: e("projects.completeProfile")
              }
            ),
            t && /* @__PURE__ */ v.jsx(
              qe,
              {
                variant: "solid",
                color: "primary",
                className: "w-full",
                onClick: r,
                children: e("projects.callAdvisor")
              }
            )
          ] }),
          /* @__PURE__ */ v.jsx($Qe, { project: i })
        ] })
      ] })
    ] })
  ] }) : /* @__PURE__ */ v.jsx("div", { children: "Project not found" });
}, KQe = () => {
  var u, d, f, h, p, m;
  const { t: e } = _t(["wallet", "common"]), t = sn(), r = Da(), { user: n, isLoading: a } = As(), s = ui();
  if (a)
    return /* @__PURE__ */ v.jsx(la, { container: "full" });
  if (!n || !t)
    return null;
  const i = B.object({
    iban: B.string().min(15, e("wallet.invalidIban")),
    bic: B.string().min(8, e("wallet.invalidBic"))
  }), o = async (g) => {
    var y, x, w;
    try {
      await t.usersApi.userPayout({
        paymentUserPayout: {
          bridgeapi: {
            iban: g.iban,
            bic: g.bic
          }
        }
      }), r.success(e("wallet.updateSuccess"));
    } catch (_) {
      const S = ((x = (y = _ == null ? void 0 : _.response) == null ? void 0 : y.data) == null ? void 0 : x.error) || (_ == null ? void 0 : _.message) || "Unknown error";
      r.error(`${e("wallet.updateError")}: ${S}`), console.error(
        "Update error:",
        JSON.stringify(
          {
            error: _ == null ? void 0 : _.message,
            response: (w = _ == null ? void 0 : _.response) == null ? void 0 : w.data,
            stack: _ == null ? void 0 : _.stack
          },
          null,
          2
        )
      );
    }
  }, l = {
    iban: "",
    bic: ""
  };
  if (s.PAYMENT_PROVIDER === "bridgeapi" && ((f = (d = (u = n == null ? void 0 : n.userInfo) == null ? void 0 : u.payment) == null ? void 0 : d.bridgeapi) != null && f.payout)) {
    const g = n.userInfo.payment.bridgeapi.payout;
    l.iban = g.iban || "", l.bic = g.bic || "";
  } else if (s.PAYMENT_PROVIDER === "mangopay" && ((m = (p = (h = n == null ? void 0 : n.userInfo) == null ? void 0 : h.payment) == null ? void 0 : p.mangopay) != null && m.payout)) {
    const g = n.userInfo.payment.mangopay.payout;
    l.iban = g.iban || "", l.bic = g.bic || "";
  }
  const c = [
    {
      title: e("wallet.bankAccountTitle"),
      description: e("wallet.bankAccountDisclaimer"),
      fields: [
        {
          name: "iban",
          type: "text",
          required: !0,
          label: e("wallet.iban"),
          placeholder: "FR7630006000011234567890189",
          layout: { className: "col-span-6" }
        },
        {
          name: "bic",
          type: "text",
          required: !0,
          label: e("wallet.bic"),
          placeholder: "BNPAFRPP",
          layout: { className: "col-span-6" }
        }
      ]
    }
  ];
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx("h1", { className: "text-3xl font-bold mb-6 text-text", children: e("wallet.title") }),
    /* @__PURE__ */ v.jsxs("div", { className: "xl:w-2/3", children: [
      /* @__PURE__ */ v.jsx(
        Yg,
        {
          text: e("wallet.infoBanner"),
          icon: "bank",
          iconSize: "xl",
          className: "mb-4 md:mb-6 border border-primary-400 dark:border-primary-800",
          color: "bg-info-100 dark:bg-info-900/20"
        }
      ),
      /* @__PURE__ */ v.jsx(
        Uo,
        {
          sections: c,
          validationSchema: i,
          onSubmit: o,
          formLayout: "single-page",
          layout: { type: "grid", className: "grid-cols-12 gap-4" },
          defaultValues: l
        }
      )
    ] })
  ] });
}, qQe = () => {
  const { t: e } = _t(["management"]), { showModal: t } = Xg(), r = sn(), n = (o) => {
    t("payout", { projectId: o.id });
  }, a = Tn(
    () => ({
      getAll: async (o) => {
        const { offset: l, limit: c } = o, u = await r.projectsApi.projectsPage({
          offset: l,
          limit: c
        });
        return {
          data: u.results,
          pagination: {
            total: u.meta.total,
            offset: u.meta.offset,
            limit: u.meta.limit,
            currentPage: u.meta.current_page,
            totalPages: u.meta.total_pages
          },
          links: u.links
        };
      }
    }),
    [r]
  ), s = {
    extractItems: (o) => o,
    extractTotal: (o) => o.length
  }, i = {
    name: "management",
    formLayout: "single-page",
    formSections: [],
    validationSchema: {
      create: B.object({}),
      update: B.object({})
    },
    columns: [
      {
        id: "id",
        label: e("management.id"),
        sortable: !0
      },
      {
        id: "name",
        label: e("management.name"),
        sortable: !0
      },
      {
        id: "price",
        label: e("management.price"),
        sortable: !0
      },
      {
        id: "batches",
        label: e("management.batches"),
        sortable: !0
      }
    ],
    tableConfig: {
      defaultSortColumn: "id",
      defaultSortDirection: _n.ASC,
      searchFields: ["name", "id"],
      actions: (o) => /* @__PURE__ */ v.jsx(
        qe,
        {
          variant: "solid",
          color: "primary",
          size: "xs",
          icon: "coins",
          iconPosition: "left",
          onClick: (l) => {
            l.stopPropagation(), n(o);
          },
          children: e("management.distribution")
        }
      )
    },
    viewMode: {
      defaultMode: "table",
      showViewModeSwitch: !1
    }
  };
  return /* @__PURE__ */ v.jsx("div", { className: "space-y-8", children: /* @__PURE__ */ v.jsx(
    t1,
    {
      entityName: "management",
      useEntityConfig: () => ({
        entityConfig: i,
        crudMethods: a,
        responseExtractor: s
      }),
      defaultViewMode: "table",
      showViewModeSwitch: !1
    }
  ) });
}, GQe = [
  {
    path: "/onboarding",
    component: c$e,
    label: "Onboarding",
    translationKey: "nav.onboarding",
    icon: "onboarding",
    showInNav: !1
  },
  {
    path: "/profile",
    component: zGe,
    label: "Profile",
    translationKey: "nav.profile",
    icon: "user",
    showInNav: !0
  },
  // {
  //   path: '/dashboard',
  //   component: DashboardB2BPage,
  //   label: 'Dashboard B2B',
  //   translationKey: 'nav.dashboardB2B',
  //   icon: 'home',
  //   showInNav: true,
  // },
  // {
  //   path: '/dashboard-b2c',
  //   component: DashboardB2CPage,
  //   label: 'Dashboard B2C',
  //   translationKey: 'nav.dashboardB2C',
  //   icon: 'home',
  //   showInNav: true,
  // },
  ...sf("users", {
    translationKey: "nav.users",
    icon: "users",
    showInNav: !0,
    defaultViewMode: "table",
    showViewModeSwitch: !1,
    generateRoutes: {
      list: !0,
      create: !0,
      update: !0
    }
  }),
  ...sf("user-lists", {
    translationKey: "nav.user-lists",
    icon: "list",
    showInNav: !0,
    defaultViewMode: "table",
    showViewModeSwitch: !1,
    generateRoutes: {
      list: !0,
      create: !0,
      update: !0
    }
  }),
  {
    path: "/projects-overview",
    component: WQe,
    label: "Projects Overview",
    translationKey: "nav.projectsOverview",
    icon: "stack",
    showInNav: !0
  },
  {
    path: "/projects/:id/view",
    component: zQe,
    label: "Project View",
    translationKey: "nav.projectView",
    icon: "projects"
  },
  {
    path: "/marketplace",
    component: HGe,
    label: "Marketplace",
    translationKey: "nav.marketplace",
    icon: "card",
    showInNav: !0
  },
  ...sf("projects", {
    translationKey: "nav.projects",
    icon: "card",
    showInNav: !0,
    defaultViewMode: "table",
    showViewModeSwitch: !1,
    generateRoutes: {
      list: !0,
      create: !0,
      update: !0
    }
  }),
  ...sf("campaigns", {
    translationKey: "nav.campaigns",
    icon: "rocket",
    showInNav: !0,
    defaultViewMode: "table",
    showViewModeSwitch: !1,
    generateRoutes: {
      list: !0,
      create: !0,
      update: !0
    }
  }),
  ...sf("orders-user", {
    translationKey: "nav.investments",
    icon: "invest",
    showInNav: !0,
    defaultViewMode: "table",
    showViewModeSwitch: !1,
    listPath: "/investissements",
    generateRoutes: {
      list: !0
    }
  }),
  ...sf("orders", {
    translationKey: "nav.investmentsOverview",
    icon: "invest",
    showInNav: !0,
    defaultViewMode: "table",
    showViewModeSwitch: !1,
    listPath: "/investissements-overview",
    generateRoutes: {
      list: !0
    }
  }),
  {
    path: "/wallet",
    component: KQe,
    label: "Wallet",
    translationKey: "nav.wallet",
    icon: "wallet",
    showInNav: !0
  },
  {
    path: "/support-b2b",
    component: VGe,
    label: "Support B2B",
    translationKey: "nav.supportB2B",
    icon: "headset",
    showInNav: !0
  },
  {
    path: "/support-b2c",
    component: $Ge,
    label: "Support B2C",
    translationKey: "nav.supportB2C",
    icon: "headset",
    showInNav: !0
  },
  {
    path: "/management",
    component: qQe,
    label: "Management",
    translationKey: "nav.management",
    icon: "coins",
    showInNav: !0
  },
  {
    path: "/configuration",
    component: P8e,
    label: "Configuration",
    translationKey: "nav.configuration",
    icon: "gear",
    showInNav: !0
  }
], YQe = [...LGe, ...GQe], XQe = () => {
  const e = ww(), t = Da();
  return wt(() => {
    t.success("You don't have permission to access this page");
  }, []), /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center justify-center min-h-screen", children: [
    /* @__PURE__ */ v.jsx("h1", { className: "text-4xl font-bold mb-4 text-text", children: "403 - Access Denied" }),
    /* @__PURE__ */ v.jsxs("p", { className: "text-gray-600 mb-4", children: [
      "You don't have permission to access ",
      e.pathname
    ] }),
    /* @__PURE__ */ v.jsx("p", { className: "text-sm text-gray-500", children: "Contact your administrator if you believe this is a mistake." })
  ] });
};
function QQe({ routes: e = YQe }) {
  const { user: t, isLoading: r } = As(), n = ww();
  if (r)
    return /* @__PURE__ */ v.jsx(la, { container: "screen" });
  const a = wW(e), { publicRoutes: s, protectedRoutes: i } = MGe(a);
  return t && n.pathname.startsWith("/auth") ? /* @__PURE__ */ v.jsx(hc, { to: "/projects", replace: !0 }) : /* @__PURE__ */ v.jsx(yw, { fallback: /* @__PURE__ */ v.jsx(la, { container: "screen" }), children: /* @__PURE__ */ v.jsxs(Yz, { children: [
    /* @__PURE__ */ v.jsx(
      rp,
      {
        path: "/",
        element: /* @__PURE__ */ v.jsx(hc, { to: t ? "/projects" : "/auth/login", replace: !0 })
      }
    ),
    s.map(({ path: o, component: l }) => /* @__PURE__ */ v.jsx(rp, { path: o, element: /* @__PURE__ */ v.jsx(l, {}) }, o)),
    i.map((o) => /* @__PURE__ */ v.jsx(
      rp,
      {
        path: o.path,
        element: /* @__PURE__ */ v.jsx(DGe, { config: o, children: /* @__PURE__ */ v.jsx(o.component, {}) })
      },
      o.path
    )),
    /* @__PURE__ */ v.jsx(rp, { path: "/403", element: /* @__PURE__ */ v.jsx(XQe, {}) }),
    /* @__PURE__ */ v.jsx(rp, { path: "*", element: /* @__PURE__ */ v.jsx(hc, { to: "/", replace: !0 }) })
  ] }) });
}
function rtt({ routes: e }) {
  const { t } = _t(), r = ww(), { user: n, isLoading: a, isOnboardingEnabled: s } = As(), i = r.pathname.startsWith("/auth"), o = r.pathname.startsWith("/onboarding"), l = M.useMemo(
    () => e.filter((u) => u.showInNav).map((u) => ({
      to: u.path,
      label: t(u.translationKey, { defaultValue: u.label }),
      translationKey: u.translationKey,
      icon: u.icon
    })),
    [e, t]
  ), c = M.useMemo(
    () => /* @__PURE__ */ v.jsx(yw, { fallback: null, children: /* @__PURE__ */ v.jsx(QQe, { routes: e }) }),
    [e]
  );
  return a ? /* @__PURE__ */ v.jsx(la, { container: "screen" }) : n && !n.isActive && s && !o && !i ? /* @__PURE__ */ v.jsx(hc, { to: "/onboarding", replace: !0 }) : i || !n ? /* @__PURE__ */ v.jsx(RGe, { children: c }) : o ? /* @__PURE__ */ v.jsx(rJe, { children: c }) : /* @__PURE__ */ v.jsx(tJe, { navItems: l, children: c });
}
const JQe = ({
  navItems: e,
  userImageSrc: t,
  className: r
}) => {
  const { t: n } = _t(["auth", "common"]), { logout: a, user: s } = As(), i = ta(), o = async () => {
    try {
      await a(), i("/auth/login");
    } catch (l) {
      console.error("Logout failed:", l);
    }
  };
  return /* @__PURE__ */ v.jsxs(
    "aside",
    {
      className: lt(
        "bg-surface border-r border-border w-64 h-full flex flex-col",
        r
      ),
      children: [
        /* @__PURE__ */ v.jsx("div", { className: "px-5 pt-8 p-6 flex items-center justify-center", children: /* @__PURE__ */ v.jsx(Jk, { type: "client", className: "w-28 h-12 max-h-24" }) }),
        /* @__PURE__ */ v.jsx("nav", { className: "flex-1 overflow-y-auto", children: /* @__PURE__ */ v.jsx("ul", { className: "space-y-1 px-3", children: e.map((l) => /* @__PURE__ */ v.jsx("li", { children: /* @__PURE__ */ v.jsxs(
          PT,
          {
            to: l.to,
            className: ({ isActive: c }) => lt(
              "flex items-center px-3 py-2 text-sm font-medium rounded-md",
              c ? "text-primary-500" : "text-text dark:text-text hover:text-primary-400"
            ),
            children: [
              /* @__PURE__ */ v.jsx(
                dt,
                {
                  name: l.icon,
                  className: "mr-3",
                  size: "sm",
                  color: "primary"
                }
              ),
              n(`common:${l.translationKey}`)
            ]
          }
        ) }, l.to)) }) }),
        /* @__PURE__ */ v.jsx("div", { className: "mt-auto px-5 py-8", children: /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-4 border-t border-border pt-8", children: [
          /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center", children: [
            t ? /* @__PURE__ */ v.jsx(
              "img",
              {
                src: t,
                alt: "User avatar",
                className: "rounded-full w-9 h-9"
              }
            ) : /* @__PURE__ */ v.jsx("div", { className: "rounded-full w-9 h-9 bg-gray-300 flex items-center justify-center", children: /* @__PURE__ */ v.jsx(dt, { name: "user", className: "text-gray-700", size: "md" }) }),
            (s == null ? void 0 : s.role) === "admin" && /* @__PURE__ */ v.jsx("div", { className: "relative bg-secondary-300 z-10 text-black text-xs font-semibold rounded-full flex items-center justify-center py-1 px-2 -mt-1", children: n("common:admin") })
          ] }),
          /* @__PURE__ */ v.jsxs("div", { className: "flex-1 truncate", children: [
            /* @__PURE__ */ v.jsx("p", { className: "text-sm font-semibold text-gray-400 truncate", children: s == null ? void 0 : s.userInfo.auth.email }),
            /* @__PURE__ */ v.jsx(
              Lo,
              {
                to: "#",
                onClick: o,
                className: "text-sm text-slate-700 hover:text-primary-500 transition-colors cursor-pointer truncate block",
                children: n("auth.logout")
              }
            )
          ] })
        ] }) })
      ]
    }
  );
};
function ZQe({ isOpen: e, onClose: t, navItems: r }) {
  const { t: n } = _t(["common", "auth"]), { logout: a, user: s } = As(), i = ta(), o = tr(null);
  if (JT(o, () => {
    e && t();
  }), !e) return null;
  const l = async () => {
    try {
      await a(), i("/auth/login");
    } catch (c) {
      console.error("Logout failed:", c);
    }
  };
  return /* @__PURE__ */ v.jsx("div", { className: "fixed inset-0 bg-black bg-opacity-50 z-50 overflow-hidden", children: /* @__PURE__ */ v.jsxs(
    "div",
    {
      ref: o,
      className: "absolute right-0 top-0 bottom-0 w-64 bg-surface flex flex-col shadow-xl",
      children: [
        /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center p-4 border-b border-border", children: [
          /* @__PURE__ */ v.jsx("h2", { className: "font-semibold", children: n("common:nav.menu") }),
          /* @__PURE__ */ v.jsx(
            qe,
            {
              variant: "ghost",
              color: "gray",
              size: "xl",
              icon: "close",
              onClick: t,
              "aria-label": "Close menu"
            }
          )
        ] }),
        /* @__PURE__ */ v.jsx("nav", { className: "flex-1 overflow-y-auto", children: /* @__PURE__ */ v.jsx("ul", { className: "space-y-2 p-4", children: r.map((c) => /* @__PURE__ */ v.jsx("li", { children: /* @__PURE__ */ v.jsxs(
          PT,
          {
            to: c.to,
            onClick: t,
            className: ({ isActive: u }) => `flex items-center space-x-3 py-2 rounded-md ${u ? "text-primary-500 bg-primary-50" : "text-gray-600"}`,
            children: [
              /* @__PURE__ */ v.jsx(dt, { name: c.icon, size: "sm" }),
              /* @__PURE__ */ v.jsx("span", { children: n(`common:${c.translationKey}`) })
            ]
          }
        ) }, c.to)) }) }),
        /* @__PURE__ */ v.jsxs("div", { className: "border-t border-border p-4 space-y-2", children: [
          /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-3", children: [
            /* @__PURE__ */ v.jsx(dt, { name: "user", size: "sm" }),
            /* @__PURE__ */ v.jsx("div", { className: "flex-1", children: /* @__PURE__ */ v.jsx("p", { className: "text-sm font-medium text-gray-600 truncate", children: s == null ? void 0 : s.userInfo.auth.email }) })
          ] }),
          /* @__PURE__ */ v.jsxs(
            "button",
            {
              onClick: l,
              className: "w-full flex items-center py-2 text-sm text-gray-600 hover:text-primary-500",
              children: [
                /* @__PURE__ */ v.jsx(dt, { name: "logout", size: "sm", className: "mr-3" }),
                n("auth:logout")
              ]
            }
          )
        ] })
      ]
    }
  ) });
}
function eJe({ navItems: e, className: t }) {
  const { t: r } = _t(["common"]), [n, a] = Me(!1), s = e.filter(
    (i) => ["/dashboard", "/projects", "/investissements"].includes(i.to)
  );
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      "nav",
      {
        className: lt(
          "fixed bottom-0 left-0 right-0 bg-surface border-t border-border h-16 px-6 z-10",
          t
        ),
        children: /* @__PURE__ */ v.jsxs("div", { className: "h-full flex items-center justify-between max-w-md mx-auto", children: [
          s.map((i) => /* @__PURE__ */ v.jsxs(
            PT,
            {
              to: i.to,
              className: ({ isActive: o }) => `flex flex-col items-center justify-center space-y-1 ${o ? "text-primary-500" : "text-gray-500"}`,
              children: [
                /* @__PURE__ */ v.jsx(dt, { name: i.icon, size: "md" }),
                /* @__PURE__ */ v.jsx("span", { className: "text-xxs", children: r(`common:${i.translationKey}`) })
              ]
            },
            i.to
          )),
          /* @__PURE__ */ v.jsxs(
            "button",
            {
              onClick: () => a(!0),
              className: "flex flex-col items-center justify-center space-y-1 text-gray-500",
              children: [
                /* @__PURE__ */ v.jsx(dt, { name: "menu", size: "md" }),
                /* @__PURE__ */ v.jsx("span", { className: "text-xs", children: r("common:nav.more") })
              ]
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ v.jsx(
      ZQe,
      {
        isOpen: n,
        onClose: () => a(!1),
        navItems: e.filter(
          (i) => !["/dashboard", "/projects", "/investissements"].includes(i.to)
        )
      }
    )
  ] });
}
const wz = F4(() => {
  const { t: e } = _t(["common"]), { isKycVerified: t, checkAndRedirect: r } = N2();
  if (t) return null;
  const { hasContactLink: n, handleContactClick: a } = bz();
  return /* @__PURE__ */ v.jsx(
    Yg,
    {
      className: "mb-4 md:mb-6 border border-primary-400",
      color: "bg-info-100",
      text: e("common.verifyIdentityToInvest"),
      primaryAction: {
        label: e("common.completeKyc"),
        onClick: () => r()
      },
      ...n && {
        secondaryAction: {
          label: e("common.callAdvisor"),
          onClick: a
        }
      }
    }
  );
});
wz.displayName = "KycBanner";
function tJe({ children: e, navItems: t }) {
  const { t: r } = _t(["common"]), n = sn(), a = ta(), [s, i] = Me(
    null
  );
  return wt(() => {
    (async () => {
      try {
        const l = await n.usersApi.userOrdersPage({
          limit: 1,
          offset: 0,
          status: ["pending"]
        });
        l.results && l.results.length > 0 ? i(l.results[0]) : i(null);
      } catch (l) {
        console.error("Error checking pending orders:", l);
      }
    })();
  }, [n]), /* @__PURE__ */ v.jsxs("div", { className: "flex h-screen w-full overflow-hidden bg-background", children: [
    /* @__PURE__ */ v.jsx(JQe, { navItems: t, className: "hidden md:flex" }),
    /* @__PURE__ */ v.jsx("div", { className: "flex-1 flex flex-col overflow-hidden", children: /* @__PURE__ */ v.jsxs("main", { className: "flex-1 overflow-x-hidden overflow-y-auto bg-background/50 px-4 sm:px-6 py-6 pb-20 md:pb-6", children: [
      s && /* @__PURE__ */ v.jsx(
        Yg,
        {
          className: "mb-4 md:mb-6",
          color: "bg-warning-100",
          text: r("common.pendingOrderBanner"),
          icon: "alert-triangle",
          primaryAction: {
            label: r("common.completeOrder"),
            onClick: () => a("/investissements")
          }
        }
      ),
      /* @__PURE__ */ v.jsx(wz, {}),
      e
    ] }) }),
    /* @__PURE__ */ v.jsx(eJe, { navItems: t, className: "md:hidden" })
  ] });
}
function rJe({ children: e }) {
  return /* @__PURE__ */ v.jsxs("div", { className: "min-h-screen flex flex-col lg:flex-row", children: [
    /* @__PURE__ */ v.jsx("div", { className: "flex-grow flex flex-col items-center justify-center bg-background", children: /* @__PURE__ */ v.jsxs("div", { className: "w-full max-w-[340px] sm:max-w-md lg:max-w-2xl px-4 sm:px-6 py-6 sm:py-8 lg:py-12", children: [
      /* @__PURE__ */ v.jsx("div", { className: "lg:hidden flex justify-start mb-4 sm:mb-6", children: /* @__PURE__ */ v.jsx(
        Jk,
        {
          type: "client",
          className: "w-28 sm:w-32 lg:w-40 h-10 sm:h-12 lg:h-16 sm:max-h-24 lg:max-h-32"
        }
      ) }),
      /* @__PURE__ */ v.jsx("div", { className: "space-y-4 sm:space-y-6", children: e })
    ] }) }),
    /* @__PURE__ */ v.jsx(bW, {})
  ] });
}
const ntt = () => {
  const { t: e } = _t(["dashboard"]), t = sn(), { campaigns: r, isLoading: n, error: a } = M7({
    displayLimit: 5,
    isAdmin: !0
  }), s = ta(), [i, o] = Me(null), [l, c] = Me(!0), [u, d] = Me(null), [f, h] = Me(
    null
  ), [p, m] = Me(!0), [g, y] = Me(
    null
  ), [x, w] = Me([]), [_, S] = Me(!0), [C, E] = Me(null);
  wt(() => {
    (async () => {
      m(!0), y(null);
      try {
        const z = await t.campaignsApi.campaignsStats();
        h(z);
      } catch (z) {
        console.error("Error fetching campaign stats:", z), y("Failed to fetch campaign statistics");
      } finally {
        m(!1);
      }
    })();
  }, [t]), wt(() => {
    (async () => {
      S(!0), E(null);
      try {
        const z = await t.campaignsApi.campaignsCollected(), G = Object.entries(z).map(([Y, te]) => ({
          id: Y,
          ...te
        }));
        w(G);
      } catch (z) {
        console.error("Error fetching campaign collected:", z), E("Failed to fetch campaign collected data");
      } finally {
        S(!1);
      }
    })();
  }, [t]);
  const k = (() => {
    const N = /* @__PURE__ */ new Map();
    x.forEach((G) => {
      const Y = new Date(G.start).getFullYear().toString(), te = N.get(Y) || {
        total: 0,
        campaigns: /* @__PURE__ */ new Map()
      };
      te.total += G.collected, te.campaigns.set(`Campaign ${G.id}`, G.collected), N.set(Y, te);
    });
    let z = Number.MAX_SAFE_INTEGER;
    N.forEach((G, Y) => {
      const te = parseInt(Y);
      te < z && (z = te);
    }), z === Number.MAX_SAFE_INTEGER && (z = (/* @__PURE__ */ new Date()).getFullYear());
    for (let G = 0; G < 7; G++) {
      const Y = (z + G).toString();
      N.has(Y) || N.set(Y, { total: 0, campaigns: /* @__PURE__ */ new Map() });
    }
    return Array.from(N.entries()).map(([G, Y]) => ({
      year: G,
      value: Y.total,
      campaignData: Array.from(Y.campaigns.entries()).map(
        ([te, ae]) => ({
          name: te,
          value: ae
        })
      )
    })).sort((G, Y) => G.year.localeCompare(Y.year));
  })();
  wt(() => {
    (async () => {
      c(!0), d(null);
      try {
        const z = await t.usersApi.usersStats();
        o(z);
      } catch (z) {
        console.error("Error fetching users stats:", z), d("Failed to fetch users statistics");
      } finally {
        c(!1);
      }
    })();
  }, [t]);
  const A = [
    {
      title: e("dashboard.registeredUsers"),
      value: Ao((i == null ? void 0 : i.total) || 0, {
        notation: "compact",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        thousandsSeparator: " "
      }),
      icon: "user",
      linkText: e("common:common.seeMore"),
      description: e("dashboard.registeredUsersDescription"),
      link: "/users"
    },
    {
      title: e("dashboard.kycVerified"),
      value: Ao((i == null ? void 0 : i.kyced) || 0, {
        notation: "compact",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        thousandsSeparator: " "
      }),
      icon: "check",
      linkText: e("common:common.seeMore"),
      description: e("dashboard.kycVerifiedDescription"),
      link: "/users"
    },
    {
      title: e("dashboard.investors"),
      value: Ao((i == null ? void 0 : i.active) || 0, {
        notation: "compact",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        thousandsSeparator: " "
      }),
      icon: "wallet",
      linkText: e("common:common.seeMore"),
      description: e("dashboard.investorsDescription"),
      link: "/users"
    }
  ], P = () => s("/projects/create"), D = () => s("/projects");
  return /* @__PURE__ */ v.jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ v.jsx(yv, { title: e("dashboard.dashboardTitle") }),
    /* @__PURE__ */ v.jsx("div", { className: "grid grid-cols-1 md:grid-cols-3 gap-6", children: A.map((N, z) => /* @__PURE__ */ v.jsx(L7, { ...N }, z)) }),
    /* @__PURE__ */ v.jsx("div", { className: "grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6 h-full", children: /* @__PURE__ */ v.jsx("div", { className: "lg:col-span-3 flex flex-col order-2 md:order-1", children: /* @__PURE__ */ v.jsx(hr, { header: e("dashboard.totalAmountCollected"), size: "sm", children: _ ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs("div", { className: "h-[400px] flex items-end justify-between px-4 pb-4", children: [
        /* @__PURE__ */ v.jsx("div", { className: "mt-2 w-1 h-[320px] bg-gray-200 dark:bg-gray-700 rounded animate-pulse" }),
        Array.from({ length: 12 }).map((N, z) => /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center", children: [
          /* @__PURE__ */ v.jsx(
            "div",
            {
              className: "w-8 bg-gray-200 dark:bg-gray-700 rounded-t-md animate-pulse",
              style: {
                height: `${Math.floor(Math.random() * 60) + 200}px`
              }
            }
          ),
          /* @__PURE__ */ v.jsx("div", { className: "mt-2 w-6 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" })
        ] }, z))
      ] }),
      /* @__PURE__ */ v.jsx("div", { className: "mt-2 w-full h-1 bg-gray-200 dark:bg-gray-700 rounded animate-pulse px-4 mb-4" })
    ] }) : C ? /* @__PURE__ */ v.jsx(
      dh,
      {
        icon: "exclamation-triangle",
        title: e("dashboard.errorLoadingData"),
        description: C
      }
    ) : k.length === 0 ? /* @__PURE__ */ v.jsx(
      dh,
      {
        icon: "coins",
        title: e("dashboard.noAmountCollectedTitle"),
        description: e("dashboard.noAmountCollectedDescription")
      }
    ) : /* @__PURE__ */ v.jsx(
      j8e,
      {
        data: k,
        title: e("dashboard.totalAmountCollected"),
        backButtonText: e("dashboard.backToYears"),
        yearLabel: e("dashboard.amountPerYear"),
        campaignLabel: e("dashboard.amountPerCampaign")
      }
    ) }) }) }),
    /* @__PURE__ */ v.jsx(
      yz,
      {
        campaigns: r,
        isLoading: n,
        error: a,
        onCreateProject: P,
        onViewMore: D
      }
    )
  ] });
}, att = () => {
  var k, A;
  const { t: e } = _t(["dashboard", "common", "orders"]), [t, r] = Me(/* @__PURE__ */ new Date("2023-09-27")), [n, a] = Me(/* @__PURE__ */ new Date("2024-09-27")), [s, i] = Me("all"), o = ta(), l = sn(), [c, u] = Me(!0), [d, f] = Me(null), [h, p] = Me(null), { data: m } = Wx(), [g, y] = Me([]), [x, w] = Me(!0);
  wt(() => {
    (async () => {
      u(!0), f(null);
      try {
        const D = await l.usersApi.userInfoStats();
        p(D);
      } catch (D) {
        console.error("Error fetching user stats:", D), f("Failed to fetch user statistics");
      } finally {
        u(!1);
      }
    })();
  }, [l]), wt(() => {
    (async () => {
      try {
        w(!0);
        const D = await l.usersApi.userOrdersPage({
          offset: 0,
          limit: 5
        });
        y(D.results || []);
      } catch (D) {
        console.error("Failed to fetch orders:", D);
      } finally {
        w(!1);
      }
    })();
  }, [l]);
  const _ = Tn(() => {
    if (!h)
      return {
        data: {
          labels: [],
          datasets: [
            {
              data: [],
              backgroundColor: ["#10100F", "#C9C2C2", "#FFD700"],
              hoverBackgroundColor: ["#10100F", "#C9C2C2", "#FFD700"]
            }
          ]
        },
        percentageChanges: []
      };
    const P = Object.values(h), D = P.reduce((te, ae) => te + (ae.invested || 0), 0), N = P.reduce(
      (te, ae) => {
        const ne = ae.name || "Other";
        return te[ne] = (te[ne] || 0) + (ae.invested || 0), te;
      },
      {}
    ), z = Object.keys(N), G = Object.values(N), Y = G.map(
      (te) => D ? Number((te / D * 100).toFixed(1)) : 0
    );
    return {
      data: {
        labels: z,
        datasets: [
          {
            data: Y,
            backgroundColor: ["#10100F", "#C9C2C2", "#FFD700"],
            hoverBackgroundColor: ["#10100F", "#C9C2C2", "#FFD700"]
          }
        ]
      },
      percentageChanges: G.map(() => 0)
      // We don't have historical data yet
    };
  }, [h]), S = {
    labels: [
      "Sep",
      "Oct",
      "Nov",
      "Dec",
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep"
    ],
    datasets: [
      {
        label: e("dashboard.campaignOne"),
        data: [],
        // 100, 220, 180, 200, 280, 350, 370, 320, 270, 160, 100, 140, 300
        borderColor: "#6E6E6E",
        backgroundColor: "#1B59F8",
        gradientStops: {
          start: "rgba(255, 215, 0, 1)",
          middle: "rgba(255, 215, 0, 1)",
          end: "rgba(255, 215, 0, 0)"
        },
        fill: !0,
        order: 2
      },
      {
        label: e("dashboard.campaignTwo"),
        data: [],
        // 50, 100, 80, 180, 220, 280, 300, 240, 220, 180, 160, 140, 200
        borderColor: "#FF7D00",
        backgroundColor: "#11A2B6",
        gradientStops: {
          start: "rgba(255, 125, 0, 1)",
          middle: "rgba(255, 125, 0, 0.1)",
          end: "rgba(255, 125, 0, 0)"
        },
        fill: !0,
        order: 1
      }
    ]
  }, C = {
    responsive: !0,
    plugins: {
      legend: {
        display: !0,
        position: "bottom",
        align: "start",
        labels: {
          usePointStyle: !0,
          pointStyle: "rectRounded",
          padding: 20,
          font: {
            size: 12
          },
          boxWidth: 16,
          boxHeight: 16
        }
      },
      title: {
        display: !1
      }
    },
    scales: {
      y: {
        beginAtZero: !0,
        grid: {
          color: "rgba(0, 0, 0, 0.1)"
        }
      },
      x: {
        grid: {
          display: !1
        }
      }
    },
    elements: {
      line: {
        tension: 0.4
      },
      point: {
        radius: 0
      }
    }
  }, E = [
    { value: "all", label: e("common:investments.allInvestments") },
    { value: "investmentA", label: e("common:investments.investmentA") },
    { value: "investmentB", label: e("common:investments.investmentB") }
  ], O = [
    {
      title: e("dashboard.investedAmount"),
      value: hs(
        Object.values(h || {}).reduce(
          (P, D) => P + (D.invested || 0),
          0
        ),
        {
          currency: "EUR",
          notation: "compact",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }
      ),
      icon: "user",
      linkText: e("common:common.seeMore"),
      description: e("dashboard.investedAmountDescription"),
      link: "/projects"
    },
    {
      title: e("dashboard.receivedRevenues"),
      value: hs(0, {
        currency: "EUR",
        notation: "compact",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }),
      icon: "check",
      linkText: e("common:common.seeMore"),
      description: e("dashboard.receivedRevenuesDescription"),
      link: "/projects"
    },
    {
      title: e("dashboard.averageYield"),
      value: Ao(0, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
        thousandsSeparator: " "
      }) + "%",
      icon: "wallet",
      linkText: e("common:common.seeMore"),
      description: e("dashboard.averageYieldDescription"),
      link: "/projects"
    }
  ];
  return /* @__PURE__ */ v.jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ v.jsx(yv, { title: e("dashboard.dashboardTitle") }),
    ((k = m == null ? void 0 : m.dashboardInfo) == null ? void 0 : k.topbanner_content) && m.dashboardInfo.topbanner_content.content && ((A = m.dashboardInfo.topbanner_content.icon) == null ? void 0 : A.value) && /* @__PURE__ */ v.jsx(
      Yg,
      {
        text: /* @__PURE__ */ v.jsx(
          "div",
          {
            dangerouslySetInnerHTML: {
              __html: m.dashboardInfo.topbanner_content.content
            }
          }
        ),
        color: m.dashboardInfo.topbanner_content.color || "#f3f4f6",
        icon: m.dashboardInfo.topbanner_content.icon.value,
        route: m.dashboardInfo.topbanner_content.route
      }
    ),
    d ? /* @__PURE__ */ v.jsx("div", { className: "text-red-500", children: d }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx("div", { className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6", children: O.map((P, D) => /* @__PURE__ */ v.jsx(L7, { ...P }, D)) }),
      /* @__PURE__ */ v.jsxs("div", { className: "grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6", children: [
        /* @__PURE__ */ v.jsx("div", { className: "lg:col-span-2 flex flex-col order-2 md:order-1 h-full", children: /* @__PURE__ */ v.jsx(
          D8e,
          {
            title: e("dashboard.receivedRevenues"),
            mainValue: 150042,
            changeValue: 3.5,
            isPositiveChange: !0,
            startDate: t,
            endDate: n,
            onStartDateChange: r,
            onEndDateChange: a,
            selectedFilter: [s],
            filterOptions: E,
            onFilterChange: (P) => i(P[0]),
            chartData: S,
            chartOptions: C,
            renderEmptyState: () => /* @__PURE__ */ v.jsx(
              dh,
              {
                icon: "coins",
                title: e("dashboard.noRevenuesTitle"),
                description: e("dashboard.noRevenuesDescription"),
                primaryAction: {
                  label: e("dashboard.projectInvestment"),
                  onClick: () => o("/marketplace"),
                  icon: "plus"
                }
              }
            )
          }
        ) }),
        /* @__PURE__ */ v.jsx("div", { className: "flex flex-col order-1 md:order-2 h-full", children: /* @__PURE__ */ v.jsx(
          I8e,
          {
            data: _.data,
            percentageChanges: _.percentageChanges
          }
        ) })
      ] }),
      /* @__PURE__ */ v.jsx("div", { className: "grid grid-cols-1 gap-6", children: /* @__PURE__ */ v.jsx(
        N8e,
        {
          loading: x,
          data: g,
          onSeeAll: () => o("/investissements")
        }
      ) })
    ] })
  ] });
}, nJe = ({
  isOpen: e,
  onClose: t,
  projectId: r
}) => {
  const { t: n } = _t(["management"]), a = sn(), s = B.object({
    year: B.coerce.number().min(2e3).max(2100),
    month: B.coerce.number().min(1).max(12),
    amount: B.coerce.number().min(0),
    fees: B.coerce.number().min(0),
    parts: B.coerce.number().min(0)
  }), i = [
    {
      title: "",
      fields: [
        {
          name: "year",
          label: n("management.year"),
          type: "number",
          required: !0,
          labelProps: { position: "top" },
          layout: { className: "col-span-6" }
        },
        {
          name: "month",
          label: n("management.month"),
          type: "number",
          required: !0,
          labelProps: { position: "top" },
          layout: { className: "col-span-6" },
          inputProps: { min: 1, max: 12 }
        },
        {
          name: "amount",
          label: n("management.amount"),
          type: "number",
          required: !0,
          labelProps: { position: "top" },
          layout: { className: "col-span-12" },
          inputProps: { step: 0.01 }
        },
        {
          name: "fees",
          label: n("management.fees"),
          type: "number",
          required: !0,
          labelProps: { position: "top" },
          layout: { className: "col-span-6" },
          inputProps: { step: 0.01 }
        },
        {
          name: "shares",
          label: n("management.parts"),
          type: "number",
          required: !0,
          labelProps: { position: "top" },
          layout: { className: "col-span-6" }
        }
      ]
    }
  ], o = async (l) => {
    try {
      return await a.projectsApi.payout({
        id: r,
        payoutRequest: {
          ...l,
          project: r
        }
      }), t(), !0;
    } catch {
      return !1;
    }
  };
  return /* @__PURE__ */ v.jsx(
    Fh,
    {
      isOpen: e,
      onClose: t,
      title: n("management.payoutDetails"),
      size: "lg",
      children: /* @__PURE__ */ v.jsx(
        Xk,
        {
          sections: i,
          validationSchema: s,
          onSubmit: o,
          onCancel: t,
          defaultValues: {
            year: (/* @__PURE__ */ new Date()).getFullYear(),
            month: (/* @__PURE__ */ new Date()).getMonth() + 1,
            amount: 0,
            fees: 0,
            shares: 0
          },
          layout: { type: "grid" },
          formLayout: "single-page"
        }
      )
    }
  );
}, aJe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PayoutModal: nJe
}, Symbol.toStringTag, { value: "Module" })), stt = (e) => {
  const [t, r] = Me(), n = sn(), a = Ft(
    async (s) => {
      const l = (Array.isArray(s) ? s : [s]).filter((c) => c !== void 0).filter((c) => !(t != null && t[c]));
      if (l.length !== 0)
        try {
          const c = await Promise.all(
            l.map((u) => n.projectsApi.projectStats({ id: u }))
          );
          r((u) => ({
            ...u,
            ...Object.fromEntries(l.map((d, f) => [d, c[f]]))
          }));
        } catch (c) {
          console.error("Error fetching project stats:", c);
        }
    },
    [n]
  );
  return wt(() => {
    e && !(t != null && t[e]) && a(e);
  }, [e, a, t]), { statsMap: t, fetchStats: a };
}, sJe = ({
  columns: e = 3,
  gap: t = 32
}) => {
  const r = tr(null);
  return wt(() => {
    const n = r.current;
    if (!n) return;
    const a = new ResizeObserver(() => {
      const s = Array.from(n.children), i = n.offsetWidth, o = (i - (e - 1) * t) / e, l = Array(e).fill(0);
      let c = 0;
      s.forEach((u) => {
        const d = parseInt(u.dataset.columnSpan || "1", 10);
        if (d === e) {
          c = Math.max(...l), u.style.position = "absolute", u.style.left = "0", u.style.top = `${c}px`, u.style.width = `${i}px`;
          const h = c + u.offsetHeight + t;
          l.fill(h);
        } else {
          let f = 0, h = 1 / 0;
          for (let g = 0; g <= e - d; g++) {
            const y = Math.max(...l.slice(g, g + d));
            y < h && (h = y, f = g);
          }
          const p = f * (o + t);
          c = h, u.style.position = "absolute", u.style.left = `${p}px`, u.style.top = `${c}px`, u.style.width = `${o * d + (d - 1) * t}px`;
          const m = c + u.offsetHeight + t;
          for (let g = 0; g < d; g++)
            l[f + g] = m;
        }
      }), n.style.height = `${Math.max(...l) - t}px`;
    });
    return a.observe(n), () => a.disconnect();
  }, [e, t]), r;
};
function iJe(e) {
  wt(() => {
    const t = document.querySelector('[data-theme-preview="true"]');
    if (t)
      return t.classList.toggle("dark", e.mode === "dark"), t.setAttribute("data-mode", e.mode), eF(e.tokens, e.mode, '[data-theme-preview="true"]'), () => {
        t.classList.remove("dark"), t.removeAttribute("data-mode");
      };
  }, [e, e.mode]);
}
function oJe() {
  const { theme: e } = Wi(), t = e.components.Button, r = Object.keys(t.sizes || {}), n = Object.keys(t.variants || {}), a = Object.keys(e.tokens.colors.semantic[e.mode]).filter(
    (i) => i !== "background" && i !== "foreground" && i !== "border" && i !== "surface" && i !== "text"
  ), s = [
    {
      title: "Variants",
      items: n.map((i) => /* @__PURE__ */ v.jsx(qe, { variant: i, children: i.charAt(0).toUpperCase() + i.slice(1) }, i))
    },
    {
      title: "Colors",
      items: a.map((i) => /* @__PURE__ */ v.jsx(qe, { color: i, children: i.charAt(0).toUpperCase() + i.slice(1) }, i))
    },
    {
      title: "Sizes",
      items: r.map((i) => /* @__PURE__ */ v.jsx(qe, { size: i, children: i.toUpperCase() }, i))
    },
    {
      title: "States",
      items: [
        /* @__PURE__ */ v.jsx(qe, { isLoading: !0, children: "Loading" }, "loading"),
        /* @__PURE__ */ v.jsx(qe, { isActive: !0, children: "Active" }, "active"),
        /* @__PURE__ */ v.jsx(qe, { isDisabled: !0, children: "Disabled" }, "disabled"),
        /* @__PURE__ */ v.jsx(qe, { fullWidth: !0, children: "Full Width" }, "fullWidth")
      ]
    },
    {
      title: "With Icons",
      items: [
        /* @__PURE__ */ v.jsx(qe, { icon: "plus", iconPosition: "left", children: "Left Icon" }, "left"),
        /* @__PURE__ */ v.jsx(qe, { icon: "arrow-right", iconPosition: "right", children: "Right Icon" }, "right"),
        /* @__PURE__ */ v.jsx(qe, { icon: "settings", "aria-label": "Settings" }, "only")
      ]
    }
  ];
  return /* @__PURE__ */ v.jsx("div", { className: "space-y-6", children: s.map(({ title: i, items: o }) => /* @__PURE__ */ v.jsxs("div", { className: "space-y-2", children: [
    /* @__PURE__ */ v.jsx("h3", { className: "text-md font-medium", children: i }),
    /* @__PURE__ */ v.jsx("div", { className: "flex flex-wrap items-center gap-2", children: o })
  ] }, i)) });
}
const lJe = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "info",
  "gray"
], cJe = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900];
function uJe({ theme: e }) {
  const t = e.tokens.colors.base, r = e.tokens.colors.semantic[e.mode], n = (a) => {
    var i;
    const s = t[a];
    return (i = s == null ? void 0 : s.DEFAULT) != null && i.value ? /* @__PURE__ */ v.jsx("div", { className: "w-full sm:w-1/2 lg:w-1/3 p-2", children: /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col bg-surface border border-border rounded-lg overflow-hidden", children: [
      /* @__PURE__ */ v.jsxs("div", { className: "flex items-center p-2 border-b border-border", children: [
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "w-8 h-8 flex-shrink-0 rounded-md shadow-sm mr-2",
            style: { backgroundColor: s.DEFAULT.value }
          }
        ),
        /* @__PURE__ */ v.jsx("span", { className: "text-sm font-medium capitalize", children: a })
      ] }),
      /* @__PURE__ */ v.jsx("div", { className: "grid grid-cols-5", children: cJe.map((o) => /* @__PURE__ */ v.jsx(
        "div",
        {
          className: "relative aspect-square group",
          style: { backgroundColor: s[o].value },
          children: /* @__PURE__ */ v.jsx("div", { className: "absolute inset-0 opacity-0 group-hover:opacity-100 flex items-center justify-center bg-black/50 text-white text-xs font-medium transition-opacity", children: o })
        },
        o
      )) })
    ] }) }, a) : null;
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "space-y-4", children: [
    /* @__PURE__ */ v.jsx("div", { className: "flex flex-wrap -m-2", children: lJe.map(n) }),
    /* @__PURE__ */ v.jsx("div", { className: "grid grid-cols-2 gap-4", children: Object.entries(r).map(([a, s]) => /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ v.jsx(
        "div",
        {
          className: "w-8 h-8 flex-shrink-0 rounded-md shadow-sm",
          style: { backgroundColor: s.value }
        }
      ),
      /* @__PURE__ */ v.jsx("span", { className: "text-sm font-medium capitalize", children: a })
    ] }, a)) })
  ] });
}
const dJe = [
  { key: "xxs", class: "text-xxs" },
  { key: "xs", class: "text-xs" },
  { key: "sm", class: "text-sm" },
  { key: "base", class: "text-base" },
  { key: "lg", class: "text-lg" },
  { key: "xl", class: "text-xl" },
  { key: "2xl", class: "text-2xl" },
  { key: "3xl", class: "text-3xl" },
  { key: "4xl", class: "text-4xl" },
  { key: "5xl", class: "text-5xl" }
];
function fJe({ theme: e }) {
  const t = e.tokens.typography.fontFamily.sans.value;
  return /* @__PURE__ */ v.jsx("div", { className: "space-y-2", children: /* @__PURE__ */ v.jsx("div", { className: "space-y-1.5", children: dJe.map(({ key: r, class: n }) => /* @__PURE__ */ v.jsx("div", { className: "flex items-center gap-4", children: /* @__PURE__ */ v.jsx(
    "p",
    {
      className: `${n} truncate text-ellipsis`,
      style: { fontFamily: t },
      children: `Font size : ${r}`
    }
  ) }, r)) }) });
}
function hJe() {
  var a;
  const { theme: e } = Wi(), t = e.components.Icon, r = Object.keys(((a = t == null ? void 0 : t.baseStyle) == null ? void 0 : a.sizes) ?? {}), n = Object.keys(e.tokens.colors.semantic[e.mode]).filter(
    (s) => Z3(s)
  );
  return /* @__PURE__ */ v.jsxs("div", { className: "space-y-8", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "space-y-4", children: [
      /* @__PURE__ */ v.jsx("h3", { className: "text-sm font-medium", children: "Sizes" }),
      /* @__PURE__ */ v.jsx("div", { className: "flex flex-wrap items-center gap-6", children: r.map((s) => /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center", children: [
        /* @__PURE__ */ v.jsx(dt, { name: "settings", size: s, className: "mb-1" }),
        /* @__PURE__ */ v.jsx("span", { className: "text-xs text-gray-500", children: s })
      ] }, s)) })
    ] }),
    /* @__PURE__ */ v.jsxs("div", { className: "space-y-4", children: [
      /* @__PURE__ */ v.jsx("h3", { className: "text-sm font-medium", children: "Colors" }),
      /* @__PURE__ */ v.jsx("div", { className: "flex flex-wrap items-center gap-6", children: n.map((s) => /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col items-center", children: [
        /* @__PURE__ */ v.jsx(dt, { name: "check", color: s, size: "lg", className: "mb-1" }),
        /* @__PURE__ */ v.jsx("span", { className: "text-xs text-gray-500", children: s })
      ] }, s)) })
    ] })
  ] });
}
function pJe() {
  const e = [
    {
      title: "Sizes",
      items: ["small", "medium", "large"].map((t) => /* @__PURE__ */ v.jsx(
        ar,
        {
          size: t,
          placeholder: `${t} input`,
          className: "w-48"
        },
        t
      ))
    },
    {
      title: "States",
      items: [
        /* @__PURE__ */ v.jsx(ar, { placeholder: "Default", className: "w-48" }, "default"),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            disabled: !0,
            placeholder: "Disabled",
            className: "w-48"
          },
          "disabled"
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            error: "Error message",
            placeholder: "Error",
            className: "w-48"
          },
          "error"
        ),
        /* @__PURE__ */ v.jsx(ar, { placeholder: "Success", className: "w-48" }, "success")
      ]
    },
    {
      title: "With Icons",
      items: [
        /* @__PURE__ */ v.jsx(
          ar,
          {
            icon: "search",
            iconPosition: "left",
            placeholder: "Search...",
            className: "w-48"
          },
          "left"
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            icon: "calendar",
            iconPosition: "right",
            placeholder: "Pick a date",
            className: "w-48"
          },
          "right"
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            icon: "mail",
            placeholder: "Email",
            className: "w-48"
          },
          "both"
        )
      ]
    },
    {
      title: "Common Use Cases",
      items: [
        /* @__PURE__ */ v.jsx(
          ar,
          {
            type: "password",
            placeholder: "Enter password",
            icon: "eye",
            iconPosition: "right",
            className: "w-48"
          },
          "password"
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            type: "search",
            placeholder: "Search...",
            icon: "search",
            iconPosition: "left",
            className: "w-48"
          },
          "search"
        ),
        /* @__PURE__ */ v.jsx(
          ar,
          {
            type: "number",
            placeholder: "Enter amount",
            icon: "dollar",
            iconPosition: "left",
            className: "w-48"
          },
          "number"
        )
      ]
    }
  ];
  return /* @__PURE__ */ v.jsx("div", { className: "space-y-6", children: e.map(({ title: t, items: r }) => /* @__PURE__ */ v.jsxs("div", { className: "space-y-2", children: [
    /* @__PURE__ */ v.jsx("h3", { className: "text-md font-medium", children: t }),
    /* @__PURE__ */ v.jsx("div", { className: "flex flex-wrap gap-4", children: r })
  ] }, t)) });
}
const dl = [
  { value: "1", label: "Option 1" },
  { value: "2", label: "Option 2" },
  { value: "3", label: "Option 3" },
  { value: "4", label: "Option 4" }
], mJe = [
  {
    label: "Group 1",
    options: [
      { value: "g1-1", label: "Group 1 - Option 1" },
      { value: "g1-2", label: "Group 1 - Option 2" }
    ]
  },
  {
    label: "Group 2",
    options: [
      { value: "g2-1", label: "Group 2 - Option 1" },
      { value: "g2-2", label: "Group 2 - Option 2" }
    ]
  }
];
function gJe() {
  const e = [
    {
      title: "Basic Variants",
      items: ["outline", "filled"].map((t) => /* @__PURE__ */ v.jsx(
        ss,
        {
          variant: t,
          options: dl,
          placeholder: `${t} select`
        },
        t
      ))
    },
    {
      title: "Sizes",
      items: ["sm", "md", "lg"].map((t) => /* @__PURE__ */ v.jsx(
        ss,
        {
          size: t,
          options: dl,
          placeholder: `${t} select`
        },
        t
      ))
    },
    {
      title: "States",
      items: [
        /* @__PURE__ */ v.jsx(ss, { options: dl, placeholder: "Default" }, "default"),
        /* @__PURE__ */ v.jsx(
          ss,
          {
            options: dl,
            isDisabled: !0,
            placeholder: "Disabled"
          },
          "disabled"
        ),
        /* @__PURE__ */ v.jsx(
          ss,
          {
            options: dl,
            error: "Error message",
            placeholder: "Error"
          },
          "error"
        ),
        /* @__PURE__ */ v.jsx(
          ss,
          {
            options: dl,
            isLoading: !0,
            placeholder: "Loading"
          },
          "loading"
        )
      ]
    },
    {
      title: "Features",
      items: [
        /* @__PURE__ */ v.jsx(
          ss,
          {
            options: dl,
            isSearchable: !0,
            placeholder: "Searchable"
          },
          "searchable"
        ),
        /* @__PURE__ */ v.jsx(
          ss,
          {
            options: dl,
            isClearable: !0,
            placeholder: "Clearable"
          },
          "clearable"
        ),
        /* @__PURE__ */ v.jsx(
          ss,
          {
            options: dl,
            isMulti: !0,
            placeholder: "Multi-select"
          },
          "multi"
        ),
        /* @__PURE__ */ v.jsx(
          ss,
          {
            options: mJe,
            placeholder: "Grouped options"
          },
          "grouped"
        )
      ]
    }
  ];
  return /* @__PURE__ */ v.jsx("div", { className: "space-y-6", children: e.map(({ title: t, items: r }) => /* @__PURE__ */ v.jsxs("div", { className: "space-y-2", children: [
    /* @__PURE__ */ v.jsx("h3", { className: "text-md font-medium", children: t }),
    /* @__PURE__ */ v.jsx("div", { className: "flex flex-wrap items-start gap-2", children: r })
  ] }, t)) });
}
const vJe = [
  {
    id: 1,
    name: "John Doe",
    email: "john@example.com",
    role: "Admin",
    status: "Active",
    lastActive: "2 hours ago"
  },
  {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    role: "User",
    status: "Inactive",
    lastActive: "1 day ago"
  },
  {
    id: 3,
    name: "Bob Johnson",
    email: "bob@example.com",
    role: "Editor",
    status: "Active",
    lastActive: "5 minutes ago"
  }
], yJe = [
  { id: "name", label: "Name", sortable: !0 },
  { id: "email", label: "Email", sortable: !0 },
  {
    id: "role",
    label: "Role",
    render: (e) => /* @__PURE__ */ v.jsx(an, { color: e.role === "Admin" ? "primary" : "secondary", size: "sm", children: e.role })
  },
  {
    id: "status",
    label: "Status",
    render: (e) => /* @__PURE__ */ v.jsx(an, { color: e.status === "Active" ? "success" : "warning", size: "sm", children: e.status })
  },
  {
    id: "lastActive",
    label: "Last Active",
    sortable: !0
  }
];
function bJe() {
  const [e, t] = Me("name"), [r, n] = Me(
    _n.ASC
  ), [a, s] = Me(/* @__PURE__ */ new Set()), [i, o] = Me(1), l = (d) => {
    d === e ? n(
      r === _n.ASC ? _n.DESC : _n.ASC
    ) : (t(d), n(_n.ASC));
  }, c = (d) => {
    s(d);
  }, u = (d) => /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ v.jsx(
      qe,
      {
        variant: "ghost",
        size: "sm",
        icon: "edit",
        color: "primary",
        onClick: (f) => f.stopPropagation()
      }
    ),
    /* @__PURE__ */ v.jsx(
      qe,
      {
        variant: "ghost",
        size: "sm",
        icon: "trash",
        color: "danger",
        onClick: (f) => f.stopPropagation()
      }
    )
  ] });
  return /* @__PURE__ */ v.jsx(
    xx,
    {
      data: vJe,
      columns: yJe,
      sortColumn: e,
      sortDirection: r,
      onSort: (d, f) => l(d),
      showCheckboxes: !0,
      onSelectionChange: () => c,
      onRowClick: (d) => {
      },
      actions: u,
      pagination: {
        currentPage: i,
        totalPages: 10,
        pageSize: 10,
        totalItems: 100,
        onPageChange: o,
        onPageSizeChange: (d) => {
        }
      },
      variant: "bordered",
      size: "md",
      color: "primary"
    }
  );
}
function wJe() {
  var s;
  const { theme: e } = Wi(), t = e.components.Tooltip, r = Object.keys(t.variants || {}), n = Object.keys(
    ((s = t == null ? void 0 : t.baseStyle) == null ? void 0 : s.placements) ?? {}
  ), a = [
    {
      title: "Variants",
      items: r.map((i) => /* @__PURE__ */ v.jsx(
        ni,
        {
          content: `${i} variant tooltip`,
          variant: i,
          children: /* @__PURE__ */ v.jsx(qe, { variant: "outline", size: "sm", children: i.charAt(0).toUpperCase() + i.slice(1) })
        },
        i
      ))
    },
    {
      title: "Placements",
      items: n.map((i) => /* @__PURE__ */ v.jsx(
        ni,
        {
          content: `${i} placement tooltip`,
          placement: i,
          children: /* @__PURE__ */ v.jsx(qe, { variant: "outline", size: "sm", children: i.charAt(0).toUpperCase() + i.slice(1) })
        },
        i
      ))
    },
    {
      title: "States",
      items: [
        /* @__PURE__ */ v.jsx(ni, { content: "Default tooltip", children: /* @__PURE__ */ v.jsx(qe, { variant: "outline", size: "sm", children: "Default" }) }, "default"),
        /* @__PURE__ */ v.jsx(ni, { content: "Delayed tooltip", delay: 500, children: /* @__PURE__ */ v.jsx(qe, { variant: "outline", size: "sm", children: "Delayed" }) }, "delayed"),
        /* @__PURE__ */ v.jsx(ni, { content: "Disabled tooltip", disabled: !0, children: /* @__PURE__ */ v.jsx(qe, { variant: "outline", size: "sm", children: "Disabled" }) }, "disabled")
      ]
    },
    {
      title: "Content Types",
      items: [
        /* @__PURE__ */ v.jsx(ni, { content: "Simple text tooltip", children: /* @__PURE__ */ v.jsx(qe, { variant: "outline", size: "sm", children: "Text" }) }, "text"),
        /* @__PURE__ */ v.jsx(
          ni,
          {
            content: /* @__PURE__ */ v.jsxs("div", { className: "space-y-1", children: [
              /* @__PURE__ */ v.jsx("p", { className: "font-semibold", children: "Rich Content" }),
              /* @__PURE__ */ v.jsx("p", { className: "text-xs", children: "With multiple lines" })
            ] }),
            children: /* @__PURE__ */ v.jsx(qe, { variant: "outline", size: "sm", children: "Rich Content" })
          },
          "rich"
        ),
        /* @__PURE__ */ v.jsx(
          ni,
          {
            content: /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ v.jsx(dt, { name: "info", size: "sm" }),
              /* @__PURE__ */ v.jsx("span", { children: "Tooltip with icon" })
            ] }),
            children: /* @__PURE__ */ v.jsx(qe, { variant: "outline", size: "sm", children: "With Icon" })
          },
          "withIcon"
        )
      ]
    }
  ];
  return /* @__PURE__ */ v.jsx("div", { className: "space-y-6", children: a.map(({ title: i, items: o }) => /* @__PURE__ */ v.jsxs("div", { className: "space-y-2", children: [
    /* @__PURE__ */ v.jsx("h3", { className: "text-sm font-medium", children: i }),
    /* @__PURE__ */ v.jsx("div", { className: "flex flex-wrap items-center gap-4", children: o })
  ] }, i)) });
}
function xJe() {
  var i;
  const { theme: e } = Wi(), t = e.components.Tag, r = Object.keys(((i = t == null ? void 0 : t.baseStyle) == null ? void 0 : i.sizes) ?? {}), n = Object.keys(t.variants || {}), a = Object.keys(e.tokens.colors.semantic[e.mode]).filter(
    Z3
  ), s = [
    {
      title: "Variants",
      items: n.map((o) => /* @__PURE__ */ v.jsx(an, { variant: o, children: o }, o))
    },
    {
      title: "Colors",
      items: a.map((o) => /* @__PURE__ */ v.jsx(an, { color: o, children: o }, o))
    },
    {
      title: "Sizes",
      items: r.map((o) => /* @__PURE__ */ v.jsx(an, { size: o, children: o }, o))
    },
    {
      title: "States",
      items: [
        /* @__PURE__ */ v.jsx(an, { icon: /* @__PURE__ */ v.jsx(dt, { name: "check", size: "sm" }), children: "With Icon" }, "with-icon"),
        /* @__PURE__ */ v.jsx(an, { onRemove: () => {
        }, children: "Removable" }, "removable")
      ]
    }
  ];
  return /* @__PURE__ */ v.jsx("div", { className: "space-y-4", children: s.map(({ title: o, items: l }) => /* @__PURE__ */ v.jsxs("div", { className: "space-y-2", children: [
    /* @__PURE__ */ v.jsx("h3", { className: "text-sm font-medium", children: o }),
    /* @__PURE__ */ v.jsx("div", { className: "flex flex-wrap gap-2", children: l })
  ] }, o)) });
}
function _Je({ title: e, children: t }) {
  return /* @__PURE__ */ v.jsx(
    hr,
    {
      variant: "outlined",
      className: "bg-surface border-border transition-colors duration-200",
      header: e,
      children: /* @__PURE__ */ v.jsx("div", { className: "flex flex-wrap items-center gap-2", children: t })
    }
  );
}
function itt({ theme: e }) {
  const t = sJe({ columns: 4, gap: 16 });
  iJe(e);
  const r = [
    {
      title: "Colors",
      component: /* @__PURE__ */ v.jsx(uJe, { theme: e }),
      columnSpan: 2
    },
    {
      title: "Typography",
      component: /* @__PURE__ */ v.jsx(fJe, { theme: e }),
      columnSpan: 2
    },
    {
      title: "Buttons",
      component: /* @__PURE__ */ v.jsx(oJe, {}),
      columnSpan: 2
    },
    {
      title: "Icons",
      component: /* @__PURE__ */ v.jsx(hJe, {}),
      columnSpan: 2
    },
    {
      title: "Table",
      component: /* @__PURE__ */ v.jsx(bJe, {}),
      columnSpan: 4
    },
    {
      title: "Tags",
      component: /* @__PURE__ */ v.jsx(xJe, {}),
      columnSpan: 2
    },
    {
      title: "Tooltips",
      component: /* @__PURE__ */ v.jsx(wJe, {}),
      columnSpan: 2
    },
    {
      title: "Inputs",
      component: /* @__PURE__ */ v.jsx(pJe, {}),
      columnSpan: 2
    },
    {
      title: "Select",
      component: /* @__PURE__ */ v.jsx(gJe, {}),
      columnSpan: 2
    }
  ];
  return /* @__PURE__ */ v.jsx(
    "div",
    {
      ref: t,
      className: "relative isolate",
      "data-theme-preview": "true",
      "data-mode": e.mode,
      children: r.map(({ title: n, component: a, columnSpan: s }) => /* @__PURE__ */ v.jsx("div", { "data-column-span": s, className: "w-full", children: /* @__PURE__ */ v.jsx(_Je, { title: n, children: a }) }, n))
    }
  );
}
const ott = {
  sections: [
    // {
    //   title: "Logos",
    //   fields: [
    //     {
    //       name: "logos.clientLogo.src",
    //       label: "Client Logo",
    //       type: "file",
    //       layout: { className: "col-span-6" },
    //       required: true,
    //       // helperText: "Recommended: SVG or PNG with transparent background",
    //     },
    //     {
    //       name: "logos.clientLogo.darkModeSrc",
    //       label: "Client Logo (Dark Mode)",
    //       type: "file",
    //       layout: { className: "col-span-6" },
    //       // helperText: "Optional: Different logo for dark mode",
    //     },
    //   ],
    // },
    {
      title: "Base Colors",
      fields: [
        {
          name: "colors.primary",
          label: "Primary Colors",
          type: "color",
          layout: { className: "col-span-6" },
          required: !0,
          colorProps: {
            showFormatToggle: !1,
            showShades: !0,
            showInput: !0
          }
        },
        {
          name: "colors.secondary",
          label: "Secondary Colors",
          type: "color",
          layout: { className: "col-span-6" },
          required: !0,
          colorProps: {
            showFormatToggle: !1,
            showShades: !0,
            showInput: !0
          }
        }
      ]
    },
    {
      title: "Light Mode Colors",
      fields: [
        {
          name: "colors.light.background",
          label: "Background",
          type: "color",
          layout: { className: "col-span-3" },
          required: !0
        },
        {
          name: "colors.light.surface",
          label: "Surface",
          type: "color",
          layout: { className: "col-span-3" },
          required: !0
        },
        {
          name: "colors.light.border",
          label: "Border",
          type: "color",
          layout: { className: "col-span-3" },
          required: !0
        },
        {
          name: "colors.light.text",
          label: "Text",
          type: "color",
          layout: { className: "col-span-3" },
          required: !0
        }
      ]
    },
    {
      title: "Dark Mode Colors",
      fields: [
        {
          name: "colors.dark.background",
          label: "Background",
          type: "color",
          layout: { className: "col-span-3" },
          required: !0
        },
        {
          name: "colors.dark.surface",
          label: "Surface",
          type: "color",
          layout: { className: "col-span-3" },
          required: !0
        },
        {
          name: "colors.dark.border",
          label: "Border",
          type: "color",
          layout: { className: "col-span-3" },
          required: !0
        },
        {
          name: "colors.dark.text",
          label: "Text",
          type: "color",
          layout: { className: "col-span-3" },
          required: !0
        }
      ]
    },
    {
      title: "Typography",
      fields: [
        {
          name: "typography.fontFamily.sans",
          label: "Font Family",
          type: "text",
          layout: { className: "col-span-12" },
          placeholder: "Inter, system-ui, sans-serif",
          required: !0
        }
      ]
    }
  ],
  validationSchema: B.object({
    colors: B.object({
      primary: B.string().min(1, "Primary color is required"),
      secondary: B.string().min(1, "Secondary color is required"),
      light: B.object({
        background: B.string().min(1, "Background color is required"),
        surface: B.string().min(1, "Surface color is required"),
        border: B.string().min(1, "Border color is required"),
        text: B.string().min(1, "Text color is required")
      }),
      dark: B.object({
        background: B.string().min(1, "Background color is required"),
        surface: B.string().min(1, "Surface color is required"),
        border: B.string().min(1, "Border color is required"),
        text: B.string().min(1, "Text color is required")
      })
    }),
    typography: B.object({
      fontFamily: B.object({
        sans: B.string().min(1, "Main font family is required")
      })
    })
  }),
  layout: {
    type: "grid",
    className: "grid-cols-12 gap-6"
  },
  formLayout: "single-page"
};
export {
  qq as $,
  uG as A,
  qe as B,
  f3 as C,
  h3 as D,
  ed as E,
  Lq as F,
  p3 as G,
  _1 as H,
  om as I,
  jq as J,
  Fq as K,
  Ds as L,
  Fh as M,
  Bq as N,
  m3 as O,
  Uq as P,
  Vq as Q,
  $q as R,
  ss as S,
  Hq as T,
  Wq as U,
  g3 as V,
  Ns as W,
  zq as X,
  Kq as Y,
  v3 as Z,
  jn as _,
  Da as a,
  DZe as a$,
  Gq as a0,
  Yq as a1,
  Xq as a2,
  Qq as a3,
  Jq as a4,
  y3 as a5,
  Zt as a6,
  Zq as a7,
  eG as a8,
  tG as a9,
  lZe as aA,
  cZe as aB,
  uZe as aC,
  dZe as aD,
  fZe as aE,
  hZe as aF,
  pZe as aG,
  $a as aH,
  mZe as aI,
  gZe as aJ,
  vZe as aK,
  yZe as aL,
  bZe as aM,
  wZe as aN,
  xZe as aO,
  _Ze as aP,
  SZe as aQ,
  EZe as aR,
  TZe as aS,
  CZe as aT,
  kZe as aU,
  OZe as aV,
  AZe as aW,
  PZe as aX,
  RZe as aY,
  Uv as aZ,
  IZe as a_,
  rG as aa,
  nG as ab,
  aG as ac,
  sG as ad,
  iG as ae,
  oG as af,
  lG as ag,
  eE as ah,
  b3 as ai,
  KJe as aj,
  eo as ak,
  qJe as al,
  GJe as am,
  YJe as an,
  XJe as ao,
  QJe as ap,
  JJe as aq,
  ZJe as ar,
  eZe as as,
  tZe as at,
  rZe as au,
  nZe as av,
  aZe as aw,
  sZe as ax,
  iZe as ay,
  oZe as az,
  sn as b,
  M7 as b$,
  NZe as b0,
  MZe as b1,
  LZe as b2,
  jZe as b3,
  FZe as b4,
  BZe as b5,
  UZe as b6,
  VZe as b7,
  $Ze as b8,
  HZe as b9,
  yet as bA,
  Met as bB,
  Mo as bC,
  Let as bD,
  Bet as bE,
  dT as bF,
  x$ as bG,
  zFe as bH,
  GFe as bI,
  z8 as bJ,
  Vet as bK,
  As as bL,
  N2 as bM,
  HFe as bN,
  s$e as bO,
  o$e as bP,
  l$e as bQ,
  c$e as bR,
  u$e as bS,
  d$e as bT,
  f$e as bU,
  Uet as bV,
  si as bW,
  $et as bX,
  Zn as bY,
  T8e as bZ,
  Het as b_,
  WZe as ba,
  zZe as bb,
  KZe as bc,
  qZe as bd,
  GZe as be,
  YZe as bf,
  XZe as bg,
  QZe as bh,
  JZe as bi,
  zt as bj,
  ZZe as bk,
  eet as bl,
  tet as bm,
  zc as bn,
  met as bo,
  get as bp,
  vet as bq,
  o$ as br,
  qT as bs,
  TFe as bt,
  IFe as bu,
  RFe as bv,
  WJe as bw,
  ui as bx,
  Th as by,
  bQ as bz,
  dn as c,
  MGe as c$,
  O8e as c0,
  A8e as c1,
  Mb as c2,
  N7 as c3,
  KT as c4,
  DA as c5,
  IJ as c6,
  P8e as c7,
  Wet as c8,
  R8e as c9,
  $Qe as cA,
  yz as cB,
  Zk as cC,
  HQe as cD,
  ttt as cE,
  nO as cF,
  stt as cG,
  HGe as cH,
  zQe as cI,
  WQe as cJ,
  bz as cK,
  Wx as cL,
  VGe as cM,
  $Ge as cN,
  zGe as cO,
  KQe as cP,
  QQe as cQ,
  DGe as cR,
  YQe as cS,
  GQe as cT,
  LGe as cU,
  sf as cV,
  FGe as cW,
  BGe as cX,
  UGe as cY,
  wW as cZ,
  NGe as c_,
  zet as ca,
  I8e as cb,
  Ket as cc,
  D8e as cd,
  N8e as ce,
  qet as cf,
  L7 as cg,
  j8e as ch,
  ntt as ci,
  att as cj,
  nJe as ck,
  qQe as cl,
  xW as cm,
  Lb as cn,
  Rc as co,
  xet as cp,
  IA as cq,
  Pw as cr,
  _W as cs,
  xXe as ct,
  EXe as cu,
  ett as cv,
  CXe as cw,
  kXe as cx,
  UQe as cy,
  VQe as cz,
  Xn as d,
  pFe as d$,
  t1 as d0,
  AGe as d1,
  PGe as d2,
  RGe as d3,
  Zet as d4,
  rtt as d5,
  tJe as d6,
  rJe as d7,
  yv as d8,
  bW as d9,
  Pet as dA,
  la as dB,
  Jk as dC,
  mFe as dD,
  oFe as dE,
  Ret as dF,
  vFe as dG,
  dZ as dH,
  Iet as dI,
  t1e as dJ,
  sV as dK,
  uFe as dL,
  sZ as dM,
  _l as dN,
  qB as dO,
  Qk as dP,
  Det as dQ,
  $F as dR,
  oT as dS,
  a$ as dT,
  xx as dU,
  an as dV,
  lZ as dW,
  ZX as dX,
  fet as dY,
  ni as dZ,
  Yg as d_,
  JQe as da,
  MA as db,
  vMe as dc,
  _et as dd,
  Eet as de,
  hr as df,
  Z3e as dg,
  Oet as dh,
  ZT as di,
  Zxe as dj,
  Ine as dk,
  FF as dl,
  gMe as dm,
  dh as dn,
  Xk as dp,
  fFe as dq,
  hFe as dr,
  Aet as ds,
  Ea as dt,
  cZ as du,
  Uo as dv,
  uL as dw,
  dt as dx,
  fi as dy,
  ar as dz,
  On as e,
  WX as e$,
  Xg as e0,
  Net as e1,
  pet as e2,
  tQ as e3,
  JT as e4,
  BF as e5,
  DJ as e6,
  rO as e7,
  sJe as e8,
  eQ as e9,
  Oj as eA,
  yX as eB,
  bX as eC,
  wX as eD,
  xX as eE,
  _X as eF,
  SX as eG,
  EX as eH,
  TX as eI,
  CX as eJ,
  kX as eK,
  OX as eL,
  AX as eM,
  PX as eN,
  RX as eO,
  IX as eP,
  DX as eQ,
  NX as eR,
  MX as eS,
  LX as eT,
  jX as eU,
  FX as eV,
  BX as eW,
  UX as eX,
  VX as eY,
  $X as eZ,
  HX as e_,
  Wa as ea,
  HT as eb,
  fl as ec,
  $r as ed,
  hs as ee,
  eh as ef,
  pE as eg,
  AJ as eh,
  bet as ei,
  wet as ej,
  M8e as ek,
  Get as el,
  lm as em,
  het as en,
  Yet as eo,
  Xet as ep,
  Qet as eq,
  Ao as er,
  Mm as es,
  N1 as et,
  aet as eu,
  set as ev,
  J3 as ew,
  lt as ex,
  Jet as ey,
  L8e as ez,
  w3 as f,
  zX as f0,
  KX as f1,
  GX as f2,
  iJe as f3,
  qX as f4,
  Wi as f5,
  xFe as f6,
  oJe as f7,
  uJe as f8,
  fJe as f9,
  hJe as fa,
  pJe as fb,
  gJe as fc,
  bJe as fd,
  wJe as fe,
  xJe as ff,
  _Je as fg,
  itt as fh,
  Q3 as fi,
  WT as fj,
  net as fk,
  tF as fl,
  det as fm,
  ott as fn,
  Z3 as fo,
  iet as fp,
  eF as fq,
  oet as fr,
  cet as fs,
  YX as ft,
  vy as fu,
  XX as fv,
  uet as fw,
  QX as fx,
  zp as fy,
  TA as fz,
  zJe as g,
  d3 as h,
  ho as i,
  v as j,
  Tq as k,
  Cq as l,
  Ln as m,
  kq as n,
  Oq as o,
  Aq as p,
  Pq as q,
  Rq as r,
  Iq as s,
  Nr as t,
  _t as u,
  Dq as v,
  Nq as w,
  ns as x,
  po as y,
  Mq as z
};
//# sourceMappingURL=index-Dl7NFc20.mjs.map
